
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6lxfX", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ee80462815e973$export$2e2bcd8739ae039);

var $h8sKa = parcelRequire("h8sKa");
class $49ee80462815e973$var$Toast {
    static instance = null;
    toasts = [];
    options;
    hasAboveToast = false;
    toastGap = 16 // toast 之间的间距
    ;
    baseTopOffset = 20 // 第一个 toast 距离顶部的距离
    ;
    constructor(){
        // 单例模式
        if ($49ee80462815e973$var$Toast.instance) return $49ee80462815e973$var$Toast.instance;
        this.options = {
            color: 'primary',
            stacking: true,
            hidden: false,
            autohide: true,
            width: '450px',
            position: 'top-right',
            delay: 3000
        };
        $49ee80462815e973$var$Toast.instance = this;
    }
    // changeOptions(custom) {
    //   this.options = custom
    // }
    /** 更新所有 toast 的位置 */ updateToastsPosition() {
        let currentTop = this.baseTopOffset;
        // 从最新的 toast 开始(数组末尾),最新的在最上面
        for(let i = this.toasts.length - 1; i >= 0; i--){
            const toast = this.toasts[i];
            if (toast && toast.parentElement) {
                toast.style.setProperty('top', `${currentTop}px`, 'important');
                toast.style.transition = 'top 0.3s ease, opacity 0.3s ease';
                const toastHeight = toast.getBoundingClientRect().height || toast.offsetHeight || 60;
                currentTop += toastHeight + this.toastGap;
            }
        }
    }
    /** Adds a new alert to the DOM and toasts
   * @returns index of this newly created alert in toasts array
   */ makeNew(textColor = 'white', isAbove = false, currentCallback) {
        if (isAbove) {
            this.flush(false);
            this.hasAboveToast = true;
        } else if (this.hasAboveToast) return undefined;
        // 移除原来的 flush() 调用,允许多个 toast 共存
        let a = document.createElement('div');
        a.innerHTML = `<div class="toast-body max-w-[700px]">-</div>`;
        const uuid = Math.random().toString(36).substring(2, 6);
        const toastClass = `toast-${uuid}`;
        a.classList.add('toast', 'fade', 'position-fixed', 'left-0', 'right-0', 'mx-auto', toastClass);
        const zIndex = isAbove ? 10000 : 9999;
        // 重要：使用 !important 覆盖 mdb 的默认样式，并设置初始位置
        a.style.cssText = `z-index:${zIndex};max-width:max-content;--mdb-toast-max-width:inherit;top:${this.baseTopOffset}px !important;`;
        if (textColor) a.classList.add(textColor);
        if (document.querySelector(`.${toastClass}`)) return;
        document.body.appendChild(a);
        if (isAbove) a.setAttribute('data-above', 'true');
        if (currentCallback) {
            a.setAttribute('data-has-callback', 'true');
            a._callback = currentCallback;
        }
        let index = this.toasts.push(a);
        return index - 1;
    }
    hasToast() {
        // 检查是否有非 above 的 toast
        return this.toasts.some((toast)=>!toast.hasAttribute('data-above'));
    }
    executeCallback(callback) {
        if (typeof callback === 'function') try {
            callback();
        } catch (e) {
            console.error('Error executing toast callback:', e);
        }
    }
    // yellow/orange alert
    toast(type = 'warning', text, title = false, customOptions) {
        if (!text) return;
        const isAbove = customOptions?.above === true;
        if (this.hasAboveToast && !isAbove) return;
        // 检查是否已存在相同内容的 toast
        const existingToast = this.toasts.find((toast)=>{
            const toastBodyText = toast.querySelector('.toast-body-text');
            return toastBodyText && toastBodyText.innerHTML === text;
        });
        if (existingToast) return;
        // if there is called on mobile, just show alert
        if ((0, $h8sKa.isMobile)()) {
            alert(text);
            if (customOptions?.callback) this.executeCallback(customOptions.callback);
            return;
        }
        const dashboardEl = document.querySelector('.dashboard-body');
        const isDashboardHidden = dashboardEl?.classList.contains('d-none');
        if ((0, $h8sKa.isInDashboard) && isDashboardHidden) dashboardEl.classList.remove('d-none');
        const colors = {
            warning: 'toast-warning',
            info: 'toast-info',
            success: 'toast-success',
            danger: 'toast-danger'
        };
        const currentCallback = customOptions?.callback;
        let toastIndex = this.makeNew(colors[type], isAbove, currentCallback);
        if (toastIndex === undefined) return;
        // 直接使用索引获取刚创建的 toast 元素
        const currentToast = this.toasts[toastIndex];
        if (!currentToast) {
            console.error("Toast \u521B\u5EFA\u5931\u8D25");
            return;
        }
        let options = {
            color: 'warning',
            stacking: false,
            hidden: false,
            autohide: true,
            width: '450px',
            position: 'center',
            delay: 3000,
            closeable: false,
            ...customOptions
        };
        options.autohide = customOptions?.closeable ? false : customOptions?.autohide ?? true;
        const closeBtn = `<button type="button" style="width: 1rem; height: 1rem;border: none; background: none; padding: 0; cursor: pointer; width: 16px; height: 16px;" data-mdb-dismiss="toast" aria-label="Close">
      <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8.25" fill="#DF9C5E"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.95113 5.95064C6.18544 5.71632 6.56534 5.71632 6.79966 5.95064L9.00039 8.15139L11.2011 5.95064C11.4354 5.71632 11.8153 5.71632 12.0497 5.95064C12.284 6.18495 12.284 6.56485 12.0497 6.79917L9.84892 8.99992L12.0497 11.2007C12.284 11.435 12.284 11.8149 12.0497 12.0492C11.8153 12.2835 11.4354 12.2835 11.2011 12.0492L9.00039 9.84845L6.79966 12.0492C6.56534 12.2835 6.18544 12.2835 5.95113 12.0492C5.71681 11.8149 5.71681 11.435 5.95113 11.2007L8.15187 8.99992L5.95113 6.79917C5.71681 6.56485 5.71681 6.18495 5.95113 5.95064Z" fill="white"/>
      </svg>
    </button>`;
        const toastBody = currentToast.querySelector('.toast-body');
        if (toastBody) {
            toastBody.innerHTML = `<div class="toast-body-text" style="word-break: break-all;">${text}</div>`;
            toastBody.style.display = 'flex';
            toastBody.style.gap = '1.25rem';
        }
        if (options.closeable) toastBody.insertAdjacentHTML('beforeend', closeBtn);
        let alertInstance = new mdb.Toast(currentToast, options);
        if (alertInstance._element && alertInstance._element.innerText !== '-') alertInstance.show();
        const self = this;
        const isAboveToast = currentToast.hasAttribute('data-above');
        // 监听 toast 显示完成事件，更新位置
        currentToast.addEventListener('shown.mdb.toast', function onShown() {
            self.updateToastsPosition();
            currentToast.removeEventListener('shown.mdb.toast', onShown);
        });
        // 备用：延迟更新位置
        setTimeout(()=>self.updateToastsPosition(), 300);
        currentToast.addEventListener('hidden.mdb.toast', function() {
            if (isAboveToast) self.hasAboveToast = false;
            const index = self.toasts.indexOf(currentToast);
            if (index > -1) self.toasts.splice(index, 1);
            if (this._callback) self.executeCallback(this._callback);
            this.remove();
            self.updateToastsPosition();
        });
    }
    /** Wipe all toasts from DOM */ flush() {
        this.toasts.forEach((a)=>a.remove());
        this.toasts = [];
    }
}
var $49ee80462815e973$export$2e2bcd8739ae039 = $49ee80462815e973$var$Toast;

});
parcelRegister("h8sKa", function(module, exports) {

$parcel$export(module.exports, "isLocal", () => $c7997aef068a9f19$export$6dd1bbd39f571125);
$parcel$export(module.exports, "DEV_BASE_URL", () => $c7997aef068a9f19$export$f058dbf75c3bc647);
$parcel$export(module.exports, "isInDashboard", () => $c7997aef068a9f19$export$cb41d1d96eabd074);
$parcel$export(module.exports, "isModelKey", () => $c7997aef068a9f19$export$8eca2ce8e17b5056);
$parcel$export(module.exports, "request", () => $c7997aef068a9f19$export$b5fe3f66a567bec0);
$parcel$export(module.exports, "escapeHtml", () => $c7997aef068a9f19$export$4cf11838cdc2a8a8);
$parcel$export(module.exports, "toUTCTime", () => $c7997aef068a9f19$export$1b019691228bd2a2);
$parcel$export(module.exports, "formatDateTime", () => $c7997aef068a9f19$export$8b492ed8828f789c);
$parcel$export(module.exports, "isMobile", () => $c7997aef068a9f19$export$d0a8044dce8ff2fc);
$parcel$export(module.exports, "formatEmailDisplay", () => $c7997aef068a9f19$export$802dbf9949647319);
$parcel$export(module.exports, "isEmail", () => $c7997aef068a9f19$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isDomain", () => $c7997aef068a9f19$export$2cc4bb09fa7f684c);
$parcel$export(module.exports, "queryAWSAccessHeader", () => $c7997aef068a9f19$export$f0532b9b9fe08dbb);
$parcel$export(module.exports, "queryDownloadURL", () => $c7997aef068a9f19$export$42c5d995c0d20318);
$parcel$export(module.exports, "parseShareLink", () => $c7997aef068a9f19$export$2084cf0695b133b2);
$parcel$export(module.exports, "checkModelKey", () => $c7997aef068a9f19$export$286fe9840ee0efe6);
$parcel$export(module.exports, "checkAccountActive", () => $c7997aef068a9f19$export$7955eb9b212742dc);
$parcel$export(module.exports, "toDataURL", () => $c7997aef068a9f19$export$723e4939e5a27c8);
$parcel$export(module.exports, "userInfoInterval", () => $c7997aef068a9f19$export$f4ccd9db52550610);
$parcel$export(module.exports, "adaptDevice", () => $c7997aef068a9f19$export$2e3430448f68059);
$parcel$export(module.exports, "checkCustomerAccess", () => $c7997aef068a9f19$export$81c8ec47628fc670);
$parcel$export(module.exports, "downloadFile", () => $c7997aef068a9f19$export$bb3b75778e3e272);
$parcel$export(module.exports, "createAndClickAnchor", () => $c7997aef068a9f19$export$1d9cf75e773fdfe9);
$parcel$export(module.exports, "getRootFontSize", () => $c7997aef068a9f19$export$ef86e9b1c847b692);
$parcel$export(module.exports, "getUserColor", () => $c7997aef068a9f19$export$6c21663cd469638f);
$parcel$export(module.exports, "getUserName", () => $c7997aef068a9f19$export$c1fb9bac27b52cdd);
$parcel$export(module.exports, "sleep", () => $c7997aef068a9f19$export$e772c8ff12451969);
// import qrcodeImg from '../assets/home/qrcode-full.png'
// import './log-envent.js'

var $6lxfX = parcelRequire("6lxfX");

var $gngdn = parcelRequire("gngdn");

var $gogTx = parcelRequire("gogTx");

var $lHTSI = parcelRequire("lHTSI");

var $3CfG2 = parcelRequire("3CfG2");

var $iS8eH = parcelRequire("iS8eH");

var $364nM = parcelRequire("364nM");

var $i0TKe = parcelRequire("i0TKe");

var $graZq = parcelRequire("graZq");
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($gogTx))));
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($lHTSI))));
const $c7997aef068a9f19$var$t = (0, $iS8eH.default).global.t;
const $c7997aef068a9f19$export$6dd1bbd39f571125 = location.hostname.includes('localhost') || location.hostname.includes('192.168');
const $c7997aef068a9f19$export$f058dbf75c3bc647 = $c7997aef068a9f19$export$6dd1bbd39f571125 ? "https://api.scanat.app/" : '/';
console.log = function() {};
const $c7997aef068a9f19$var$baseRequest = async (url, data)=>{
    return await fetch(`${$c7997aef068a9f19$export$f058dbf75c3bc647}${url}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data ? JSON.stringify(data) : null
    });
};
const $c7997aef068a9f19$export$cb41d1d96eabd074 = (0, $3CfG2.DASHBOARD_LIST).some((path)=>location.pathname.includes(path));
const $c7997aef068a9f19$var$isScanatWebOrIDPages = [
    ...(0, $3CfG2.DASHBOARD_LIST),
    'models.html',
    'landing.html',
    'login.html',
    'register.html',
    'reset-password.html'
].some((path)=>location.pathname.includes(path));
const $c7997aef068a9f19$var$isInWhiteList = (0, $3CfG2.WHITE_LIST).includes(location.pathname) || location.pathname.startsWith('/articles/');
const $c7997aef068a9f19$var$redirect = (modelKey = '')=>{
    localStorage.removeItem((0, $3CfG2.STORAGE_KEY).LOGIN_TIME);
    if ($c7997aef068a9f19$var$isInWhiteList) return;
    if (modelKey) {
        window.location.href = '/login.html';
        sessionStorage.setItem('SCANAT_SHARE_LINK', location.href);
    }
    window.location.href = '/login.html';
};
const $c7997aef068a9f19$var$showHttpStatus = async (response, url = '', options = {})=>{
    let res = {
        code: 0,
        message: ''
    };
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) res = await response.clone().json();
    const status = (0, $3CfG2.HTTP_STATUS).find((status)=>status.code === response.status);
    const errStatus = (0, $iS8eH.getApiErrorCodes)(url).find((status)=>response.status === 200 && res?.code === status.code);
    if (status) {
        if (location.pathname.includes('models.html')) return true;
        else {
            if (url.includes('portal/cards') && status.code === 500) return;
            new (0, $6lxfX.default)().toast('warning', $c7997aef068a9f19$var$t(status.message) || res?.message, false, {
                delay: 5000,
                callback: ()=>{
                    const redirectUrl = sessionStorage.getItem((0, $3CfG2.STORAGE_KEY).REDIRECT_URL);
                    if (redirectUrl) {
                        window.location.href = redirectUrl;
                        sessionStorage.removeItem((0, $3CfG2.STORAGE_KEY).REDIRECT_URL);
                    }
                }
            });
            return {
                handled: true,
                shouldRetry: false
            };
        }
    }
    if (response.status === 200 && res?.code === 873 && !location.href.includes('modelId') && !$c7997aef068a9f19$export$8eca2ce8e17b5056()) {
        if (location.pathname.includes('models.html')) window.dispatchEvent(new CustomEvent('scanat:model-deleted', {
            detail: {
                type: url.includes('models/list') ? 'access' : 'operation'
            }
        }));
    }
    if ($c7997aef068a9f19$var$isScanatWebOrIDPages) {
        if (errStatus) {
            if (errStatus.noToast) return {
                handled: false,
                shouldRetry: false
            };
            if (url.includes('portal/cards') && errStatus.code === 500) return {
                handled: true,
                shouldRetry: false
            };
            if (url.includes('portal/customer/domain') && options.method === 'PUT' && errStatus.code === 781) {
                new (0, $6lxfX.default)().toast('warning', $c7997aef068a9f19$var$t('error.comInfoDomain'));
                return {
                    handled: true,
                    shouldRetry: false
                };
            }
            if (errStatus.code === 866 && url.includes('folders/refresh')) {
                new (0, $6lxfX.default)().toast('danger', $c7997aef068a9f19$var$t(errStatus.message));
                return {
                    handled: false,
                    shouldRetry: false
                };
            }
            new (0, $6lxfX.default)().toast('danger', $c7997aef068a9f19$var$t(errStatus.message));
            return {
                handled: true,
                shouldRetry: false
            };
        }
    }
    const isCode401 = response.status === 401 || res?.code === 401;
    const isLogin = Boolean(localStorage.getItem((0, $3CfG2.STORAGE_KEY).LOGIN_TIME));
    const isModelShared = $c7997aef068a9f19$export$8eca2ce8e17b5056();
    const isHomeAuthed = isCode401 && $c7997aef068a9f19$var$isInWhiteList && isLogin;
    const isOtherAuthed = isCode401 && !$c7997aef068a9f19$var$isInWhiteList;
    const refreshToken = localStorage.getItem('SCANAT_REFRESH_TOKEN');
    if (isCode401) {
        const tokenRes = await $c7997aef068a9f19$var$baseRequest('auth/refresh_token', {
            refreshToken: refreshToken,
            isFromPortal: true
        });
        const curTokenRes = await tokenRes.json();
        const isTokenUpdated = tokenRes.status === 200 && curTokenRes?.code === 200;
        if (isTokenUpdated) {
            localStorage.setItem('SCANAT_TOKEN', curTokenRes.data.access_token);
            localStorage.setItem('SCANAT_REFRESH_TOKEN', curTokenRes.data.refresh_token);
            // 已刷新 token，交由上层重新发起原请求
            return {
                handled: true,
                shouldRetry: true
            };
        }
        // 401: Unauthorized
        if (isHomeAuthed || isOtherAuthed) {
            const msg = tokenRes.status !== 200 || curTokenRes?.code !== 200 ? "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u4E0A\u306E\u7406\u7531\u3067\u3001Scanat Web\u3067\u306F\u8907\u6570\u7AEF\u672B\u304B\u3089\u306E\u540C\u6642\u30ED\u30B0\u30A4\u30F3\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u81EA\u52D5\u7684\u306B\u30ED\u30B0\u30A2\u30A6\u30C8\u3055\u308C\u307E\u3057\u305F\u3002\u518D\u5EA6\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002" : "\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F\u3002\u518D\u5EA6\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002";
            let isValid = isModelShared;
            if (isValid) {
                if ((0, $3CfG2.VALID_URL).find((path)=>url.includes(path))) return {
                    handled: false,
                    shouldRetry: false
                };
            }
            if (!isValid) {
                if (tokenRes.status === 400 || curTokenRes?.code === 400) {
                    $c7997aef068a9f19$var$redirect();
                    return {
                        handled: true,
                        shouldRetry: false
                    };
                }
                new (0, $6lxfX.default)().toast('warning', $c7997aef068a9f19$var$t('error.overDue'), false, {
                    callback: ()=>{
                        $c7997aef068a9f19$var$redirect();
                    }
                });
                throw new Error('Unauthorized');
            }
            return {
                handled: true,
                shouldRetry: false
            };
        }
    }
    return {
        handled: false,
        shouldRetry: false
    };
};
const $c7997aef068a9f19$export$b5fe3f66a567bec0 = (url, data = {}, isNeedToken = true, method = 'POST', isNeedResponse = false, customHeaders = {
    'Content-Type': 'application/json'
})=>{
    const existingPromise = (0, $364nM.addRequest)(url, method, data);
    if (existingPromise) return existingPromise;
    const controller = AbortController ? new AbortController() : null;
    const promise = (async ()=>{
        // check network status
        if (!navigator.onLine) {
            const pinia = (0, $i0TKe.getActivePinia)();
            if (!pinia || !(0, $graZq.useUploadStore)(pinia).isUploading) new (0, $6lxfX.default)().toast('warning', $c7997aef068a9f19$var$t('error.checkNetWork'), false, {
                delay: 5000
            });
            (0, $364nM.removeRequest)(url, method, data);
            throw new Error('No network connection');
        }
        const createOptions = ()=>{
            const headers = {
                ...customHeaders
            };
            if (isNeedToken) {
                const token = localStorage.getItem('SCANAT_TOKEN');
                if (token) headers['Authorization'] = `Bearer ${token}`;
            }
            const options = {
                method: method,
                headers: headers,
                mode: 'cors'
            };
            if (controller) options.signal = controller.signal;
            if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
                if (data instanceof FormData) {
                    options.body = data;
                    delete options.headers['Content-Type'];
                } else if (data) options.body = JSON.stringify(data);
            }
            return options;
        };
        const buildUrl = ()=>{
            if (url.startsWith('http') || url.startsWith('https')) return url;
            if (method === 'GET' && data) return `${$c7997aef068a9f19$export$f058dbf75c3bc647}${url}?${new URLSearchParams(data).toString()}`;
            return `${$c7997aef068a9f19$export$f058dbf75c3bc647}${url}`;
        };
        const timeoutKey = Object.keys((0, $3CfG2.MAX_REQ_TIMEOUTS)).find((key)=>url.includes(key)) || 'default';
        let hasRetried = false;
        const performFetch = async (isRetry = false)=>{
            const fetchUrl = buildUrl();
            const options = createOptions();
            const timeout = setTimeout(()=>controller?.abort('timeout'), (0, $3CfG2.MAX_REQ_TIMEOUTS)[timeoutKey]);
            try {
                const response = await fetch(fetchUrl, options);
                clearTimeout(timeout);
                const statusResult = await $c7997aef068a9f19$var$showHttpStatus(response, url, options);
                if (statusResult.shouldRetry && !hasRetried) {
                    hasRetried = true;
                    return await performFetch(true);
                }
                if (statusResult.handled) return;
                if (isNeedResponse) return response;
                const res = await response.json();
                return res;
            } catch (err) {
                clearTimeout(timeout);
                if (err.name === 'AbortError' || controller?.signal?.aborted) {
                    if (controller?.signal?.reason === 'timeout') new (0, $6lxfX.default)().toast('warning', $c7997aef068a9f19$var$t('error.timeOut'), false, {
                        delay: 5000
                    });
                    else console.log('request cancelled:', url);
                    throw new Error(controller?.signal?.reason || 'cancelled');
                }
                if ((0, $364nM.isPageUnloading)()) throw new Error('cancelled');
                throw err;
            } finally{
                (0, $364nM.removeRequest)(url, method, data);
            }
        };
        return await performFetch();
    })();
    if (navigator.onLine) (0, $364nM.saveRequest)(url, method, data, promise, controller);
    return promise;
};
function $c7997aef068a9f19$export$4cf11838cdc2a8a8(str) {
    return String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
const $c7997aef068a9f19$export$1b019691228bd2a2 = (time, format)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(time).utc().format(format);
};
const $c7997aef068a9f19$export$b96ad347bdf3bd16 = (time, currentFormat = 'YYYY-MM-DD HH:mm:ss', targetFormat = 'YYYY-MM-DD HH:mm')=>{
    if (!time) return '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))((0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).utc(time, currentFormat)).tz((0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).tz.guess()).format(targetFormat);
};
const $c7997aef068a9f19$export$8b492ed8828f789c = (dateTime, template = 'YYYY-MM-DD HH:mm')=>{
    if (!dateTime) return "\u2014";
    return (0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).utc(dateTime).local().format(template);
};
// Format money: 1000000 => 1,000,000
const $c7997aef068a9f19$export$a17b3c2052469c69 = (money)=>{
    if (!money) return 0;
    return "\uFFE5" + money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
const $c7997aef068a9f19$export$d0a8044dce8ff2fc = ()=>window.innerWidth < 768;
const $c7997aef068a9f19$export$802dbf9949647319 = (email)=>{
    //  add new line every 26 characters
    const characters = (email || '').split('');
    for(let i = 26; i < characters.length; i += 26)characters[i] = characters[i] + '\n';
    return characters.join('');
};
const $c7997aef068a9f19$var$disablePaginationItem = (className)=>{
    const el = document.querySelector(`.${className}`);
    el.firstChild.setAttribute('disabled', '');
    el.classList.add('opacity-40');
    el.firstChild.style.pointerEvents = 'none';
};
const $c7997aef068a9f19$export$36b0e3c07b34faee = (data, newData, loadList)=>{
    const { total: total, pages: pages } = data;
    // generate pagination
    const paginationEl = document.querySelector('.pagination');
    const totalEl = document.querySelector('.pagination-total');
    totalEl.textContent = `\u{7DCF}\u{8A08} ${total} \u{4EF6}`;
    if (pages >= 1) {
        paginationEl.innerHTML = '<li class="page-item page-first"><a class="page-link" href="#">\u6700\u521D\u306E\u30DA\u30FC\u30B8</a></li><li class="page-item page-divider" style="color:#00365b33">|</li><li class="page-item page-prev"><a class="page-link" href="#">\u524D\u3078</a></li>';
        for(let i = 1; i <= pages; i++){
            const liEl = document.createElement('li');
            liEl.classList.add('page-item', 'page-number');
            if (i === Number(newData.page)) liEl.classList.add('active');
            // add gap
            if (i !== pages) liEl.style.marginRight = '0.5rem';
            liEl.style.backgroundColor = '#0068B014';
            const aEl = document.createElement('a');
            aEl.classList.add('page-link');
            aEl.style.color = '#0068B099';
            aEl.href = '#';
            aEl.textContent = i;
            liEl.appendChild(aEl);
            paginationEl.appendChild(liEl);
        }
        paginationEl.innerHTML += '<li class="page-item page-next"><a class="page-link" href="#">\u6B21\u3078</a></li><li class="page-item page-divider" style="color:#00365b33">|</li><li class="page-item page-last"><a class="page-link" href="#">\u6700\u7D42\u30DA\u30FC\u30B8</a></li>';
        if (pages === 1) {
            const classes = [
                'page-prev',
                'page-next',
                'page-first',
                'page-last'
            ];
            classes.forEach((className)=>{
                $c7997aef068a9f19$var$disablePaginationItem(className);
            });
        }
        // only show 5 pages mostly
        // format page item to 1,2,...,length-1,length
        if (pages > 5) {
            const cursor = Number(newData.page);
            let validPages = [
                cursor,
                cursor + 1,
                cursor + 2,
                cursor + 3,
                cursor + 4,
                cursor + 5
            ];
            let centerPage = cursor + 4;
            if (cursor > pages - 5) {
                validPages = [
                    pages - 5,
                    pages - 4,
                    pages - 3,
                    pages - 2,
                    pages - 1,
                    pages
                ];
                centerPage = pages - 6;
            }
            const pageItems = document.querySelectorAll('.page-number');
            const pageItemsArr = Array.from(pageItems);
            pageItemsArr.forEach((item, index)=>{
                if (!validPages.includes(index + 1)) item.style.display = 'none';
                if (index === centerPage) {
                    item.querySelector('a').textContent = "\u2026";
                    item.querySelector('a').style.paddingLeft = '9px';
                    item.querySelector('a').style.paddingRight = '9px';
                    item.firstChild.setAttribute('disabled', '');
                    item.firstChild.style.pointerEvents = 'none';
                }
            });
        }
        if (newData.page === 1) {
            $c7997aef068a9f19$var$disablePaginationItem('page-prev');
            $c7997aef068a9f19$var$disablePaginationItem('page-first');
        }
        if (newData.page === pages) {
            $c7997aef068a9f19$var$disablePaginationItem('page-next');
            $c7997aef068a9f19$var$disablePaginationItem('page-last');
        }
        paginationEl.onclick = (e)=>{
            e.preventDefault();
            if (e.target.tagName === 'A') {
                const classes = e.target.parentElement.classList;
                let currentPage = Number(e.target.textContent);
                if (classes.contains('page-first')) currentPage = 1;
                if (classes.contains('page-prev')) {
                    currentPage = newData.page;
                    currentPage--;
                    if (currentPage < 1) currentPage = 1;
                }
                if (classes.contains('page-next')) {
                    currentPage = newData.page;
                    currentPage++;
                    if (currentPage > pages) currentPage = pages;
                }
                if (classes.contains('page-last')) currentPage = pages;
                loadList({
                    ...newData,
                    page: currentPage
                });
            }
        };
        const jumpPageEl = document.querySelector('.pagination-jump');
        if (jumpPageEl) {
            jumpPageEl.value = newData.page;
            jumpPageEl.onchange = (e)=>{
                let jumpPage = e.target.value;
                if (jumpPage > pages) jumpPage = pages;
                if (jumpPage < 1) jumpPage = 1;
                loadList({
                    ...newData,
                    page: jumpPage
                });
            };
        }
    }
};
const $c7997aef068a9f19$export$619e376a425cb759 = (s)=>/\s/g.test(s);
const $c7997aef068a9f19$export$7fbbfbca30081d0 = (email)=>/^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}$/.test(email);
const $c7997aef068a9f19$export$2cc4bb09fa7f684c = (domain)=>/^(?:(?:[a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+)(?:\.[a-zA-Z]{2,})+$/.test(domain);
const $c7997aef068a9f19$export$f0532b9b9fe08dbb = (method, param, json)=>{
    const payload = {
        method: method,
        host: 'https://image.scanat.app',
        path: '/prod/image',
        payload: json
    };
    if (param) payload.path = payload.path + '?' + 'key' + '=' + param;
    return $c7997aef068a9f19$export$b5fe3f66a567bec0('aws/access/header', payload);
};
const $c7997aef068a9f19$export$42c5d995c0d20318 = (queryString, key)=>{
    const host = 'https://image.scanat.app';
    let path = '/prod/image';
    path = path + '?' + 'key' + '=' + key + '&' + queryString;
    return host + path;
};
const $c7997aef068a9f19$export$8eca2ce8e17b5056 = ()=>{
    const { type: type, modelKey: modelKey = false } = $c7997aef068a9f19$export$2084cf0695b133b2() || {};
    return modelKey;
};
const $c7997aef068a9f19$export$2084cf0695b133b2 = ()=>{
    const params = new URLSearchParams(location.search);
    const modelKey = params.get('modelKey');
    if (modelKey && /.{8}-.{4}-.{4}-.{4}-.{12}/.test(modelKey)) return {
        type: 'new',
        modelKey: modelKey
    };
    const searchValue = location.search.split('?');
    // model key is 36 characters,like 0049a868-31bc-44cd-923b-2e820920050b
    // get model key from search value use regex
    // ignore other search value like &cn&autoload
    const oldFormatKey = searchValue.find((value)=>value.match(/.{8}-.{4}-.{4}-.{4}-.{12}/));
    if (oldFormatKey && location.pathname.includes('models.html')) return {
        type: 'old',
        modelKey: oldFormatKey
    };
    return null;
};
const $c7997aef068a9f19$export$286fe9840ee0efe6 = async (isNeedToken = true)=>{
    const modelKey = $c7997aef068a9f19$export$8eca2ce8e17b5056();
    if (!modelKey) return true;
    const token = localStorage.getItem('SCANAT_TOKEN');
    const res = await $c7997aef068a9f19$export$b5fe3f66a567bec0(`webModels/share/authorization?key=${modelKey}`, null, isNeedToken, 'GET');
    const isValid = res && res.code === 200 && res.data;
    if (res.code === 401 && token) {
        localStorage.removeItem('SCANAT_TOKEN');
        return $c7997aef068a9f19$export$286fe9840ee0efe6(false);
    }
    if (!isValid && !localStorage.getItem('SCANAT_TOKEN')) {
        sessionStorage.setItem('SCANAT_SHARE_LINK', location.href);
        $c7997aef068a9f19$var$redirect(modelKey);
    }
    return isValid;
};
const $c7997aef068a9f19$export$7955eb9b212742dc = async ()=>{
    try {
        const authRes = await $c7997aef068a9f19$export$b5fe3f66a567bec0('auth/currentUserInfo', null, true, 'POST');
        if (authRes?.code === 200) {
            const userInfo = authRes.data;
            if ([
                0,
                6
            ].includes(userInfo?.userStatus)) {
                new (0, $6lxfX.default)().toast('warning', $c7997aef068a9f19$var$t('error.accountDisable'), false, {
                    above: true,
                    callback: ()=>{
                        localStorage.removeItem('SCANAT_TOKEN');
                        localStorage.removeItem('SCANAT_REFRESH_TOKEN');
                        window.location.href = '/login.html';
                    }
                });
                throw new Error('accountDisable');
            }
            sessionStorage.setItem('SCANAT_USER_INFO', JSON.stringify(authRes.data));
            return {
                isActive: [
                    1
                ].includes(userInfo?.userStatus),
                isNoPortalAdmin: ![
                    1,
                    2,
                    3
                ].includes(userInfo?.isPortalAdmin),
                isWebpermission: userInfo?.webPermission === 1,
                userInfo: {
                    ...authRes.data
                }
            };
        }
        return {
            isActive: false,
            isNoPortalAdmin: false,
            isWebpermission: false,
            userInfo: {}
        };
    } catch (error) {
        console.log(error, 'error');
        if (error.message.includes('cancelled')) return {
            isCancelled: true
        };
        if (error.message.includes('accountDisable')) throw new Error('accountDisable');
        return {
            isActive: null,
            isNoPortalAdmin: false,
            isWebpermission: false,
            userInfo: {}
        };
    }
};
const $c7997aef068a9f19$export$723e4939e5a27c8 = (url)=>fetch(url).then((response)=>response.blob()).then((blob)=>new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        }));
const $c7997aef068a9f19$var$showNoPermissionModal = ()=>{
    const noPermissionModalEl = document.querySelector('#noPermissionModal');
    if (noPermissionModalEl) new mdb.Modal(noPermissionModalEl).show();
};
const $c7997aef068a9f19$export$f4ccd9db52550610 = ()=>{
    // set timer to get user info every 1 minute
    setInterval(async ()=>{
        await $c7997aef068a9f19$export$b5fe3f66a567bec0('auth/currentUserInfo');
    }, 30000);
};
const $c7997aef068a9f19$export$2e3430448f68059 = ({ systemSource: systemSource, device: device } = {})=>{
    if (device) {
        if (systemSource === 3) return device.replace(/[^a-zA-Z].*$/, '') || '-';
        let name = '';
        let version = '';
        if (/Edg\//i.test(device)) {
            name = 'Microsoft Edge';
            const match = device.match(/Edg\/([\d.]+)/);
            version = match ? match[1] : '';
        } else if (/Firefox\//i.test(device)) {
            name = 'Firefox';
            const match = device.match(/Firefox\/([\d.]+)/);
            version = match ? match[1] : '';
        } else if (/OPR\//i.test(device)) {
            name = 'Opera';
            const match = device.match(/OPR\/([\d.]+)/);
            version = match ? match[1] : '';
        } else if (/Chrome\//i.test(device)) {
            name = 'Chrome';
            const match = device.match(/Chrome\/([\d.]+)/);
            version = match ? match[1] : '';
        } else if (/Safari\//i.test(device) && !/Chrome|Edg/i.test(device)) {
            name = 'Safari';
            const match = device.match(/Version\/([\d.]+)/);
            version = match ? match[1] : '';
        } else if (/MSIE|Trident/i.test(device)) {
            name = 'Internet Explorer';
            const msieMatch = device.match(/MSIE ([\d.]+)/);
            if (msieMatch) version = msieMatch[1];
            else {
                const rvMatch = device.match(/rv:([\d.]+)/);
                version = rvMatch ? rvMatch[1] : '';
            }
        }
        if (name) return name;
        return device;
    }
    return '-';
};
const $c7997aef068a9f19$export$a55dc7d9a051abe5 = (size, shouldFormat = false)=>{
    if (!size) return size;
    let num = '';
    let unit = '';
    const units = [
        'KB',
        'M',
        'G'
    ];
    units.forEach((loopUnit)=>{
        if (size.includes(loopUnit)) {
            num = size.split(loopUnit)[0];
            if (shouldFormat && num) num = num.replace(/,/g, '');
            unit = loopUnit;
        }
    });
    const formattedNum = shouldFormat ? Math.round(Number(num)).toLocaleString('en-US') : Math.round(Number(num));
    return formattedNum + unit;
};
const $c7997aef068a9f19$export$df9534246a7f765a = (size)=>{
    if (!size) return size;
    if (size < 1024) return `${size}B`;
    if (size < 1048576) return `${(size / 1024).toFixed(2)} KB`;
    if (size < 1073741824) return `${(size / 1048576).toFixed(2)} MB`;
    return `${(size / 1073741824).toFixed(2)} GB`;
};
/**
 * 检查用户是否可以访问服务
 * @param {Object} customerRes - 客户信息
 * @param {planData} planData - 套餐信息
 * @returns {Promise<Object>} { canAccess, message } - 是否可访问及提示消息
 */ const $c7997aef068a9f19$export$81c8ec47628fc670 = async ()=>{
    const linkEle = `<span style="cursor: pointer" href="javascript:;" onclick="window.open('/admin.html#/payment', '_blank')">${$c7997aef068a9f19$var$t('order.purchaseNow')} <i class='fs-6 iconfont icon-icon_universe_circle_right'></i></span>`;
    const result = await $c7997aef068a9f19$export$7955eb9b212742dc();
    if (result.isCancelled) return {
        canAccess: true,
        message: null
    };
    if (result.isActive === null) return {
        canAccess: false,
        message: null
    };
    const { isActive: isActive, isWebpermission: isWebpermission, userInfo: userInfo = {}, userInfo: { useSeat: useSeat = 0 } = {} } = result;
    const { customerPlan: customerPlan } = userInfo;
    const customers = JSON.parse(sessionStorage.getItem('customer') || '{}');
    if (isActive === false) return {
        canAccess: false,
        message: $c7997aef068a9f19$var$t('error.accountDisable')
    };
    // 检查客户ID是否存在
    if (!userInfo?.customerId) return {
        canAccess: false,
        message: `${$c7997aef068a9f19$var$t('error.noPlan')} ${linkEle}`,
        closeable: true
    };
    if (userInfo.isPortalAdmin === 4) return {
        canAccess: false,
        message: `${$c7997aef068a9f19$var$t('error.noRight')}`
    };
    const isAdmin = [
        1,
        2,
        3
    ].includes(userInfo.isPortalAdmin);
    const { status: status = 0, goodsName: goodsName, startTime: startTime, endTime: endTime, goods: goods } = customerPlan || {};
    const isContainerScanatWeb = isWebpermission || [
        1,
        2
    ].includes(goods?.supportPlatform);
    const planEndTime = $c7997aef068a9f19$export$8b492ed8828f789c(endTime, 'YYYY.MM.DD');
    const planStartTime = $c7997aef068a9f19$export$8b492ed8828f789c(startTime, 'YYYY.MM.DD');
    const messageMap = {
        // 管理员消息映射
        admin: {
            0: {
                canAccess: false,
                message: `${$c7997aef068a9f19$var$t('error.noPlan')} ${linkEle}`,
                closeable: true
            },
            3: {
                canAccess: false,
                message: `${$c7997aef068a9f19$var$t('error.overDate', {
                    plan: goodsName,
                    date: planEndTime
                })}${linkEle}`,
                closeable: true
            },
            1: {
                true: {
                    canAccess: false,
                    message: `${$c7997aef068a9f19$var$t('error.unactive', {
                        plan: goodsName,
                        date: planStartTime
                    })}`
                },
                false: {
                    canAccess: false,
                    message: `${$c7997aef068a9f19$var$t('error.noService')}`
                }
            },
            2: {
                true: {
                    1: {
                        canAccess: true,
                        message: null
                    },
                    0: {
                        canAccess: false,
                        message: `${$c7997aef068a9f19$var$t('error.noRight')}`
                    }
                },
                false: {
                    canAccess: false,
                    message: `${$c7997aef068a9f19$var$t('error.noService')}`,
                    callback: $c7997aef068a9f19$var$showNoPermissionModal
                }
            }
        },
        // 普通用户消息映射
        user: {
            0: {
                canAccess: false,
                message: `${$c7997aef068a9f19$var$t('error.noService')}`
            },
            3: {
                canAccess: false,
                message: `${$c7997aef068a9f19$var$t('error.noService')}`
            },
            1: {
                true: {
                    canAccess: false,
                    message: `${$c7997aef068a9f19$var$t('error.unactive', {
                        plan: goodsName,
                        date: planStartTime
                    })}`
                },
                false: {
                    canAccess: false,
                    message: `${$c7997aef068a9f19$var$t('error.noService')}`
                }
            },
            2: {
                true: {
                    1: {
                        canAccess: true,
                        message: null
                    },
                    0: {
                        canAccess: false,
                        message: `${$c7997aef068a9f19$var$t('error.noRight')}`
                    }
                },
                false: {
                    canAccess: false,
                    message: `${$c7997aef068a9f19$var$t('error.noService')}`
                }
            }
        }
    };
    // 获取用户类型
    const userType = isAdmin ? 'admin' : 'user';
    if (status === 2) {
        if (isContainerScanatWeb) return messageMap[userType][status][isContainerScanatWeb][useSeat];
        else return messageMap[userType][status][isContainerScanatWeb];
    }
    if (status === 1) return messageMap[userType][status][isContainerScanatWeb];
    // 处理其他status情况
    return messageMap[userType][status] || {
        canAccess: true,
        message: null
    };
};
// 下载文件通用方法
const $c7997aef068a9f19$export$bb3b75778e3e272 = async (url, data, type, filename)=>{
    try {
        const res = await $c7997aef068a9f19$export$b5fe3f66a567bec0(url, data, true, 'GET', true);
        const result = await res.blob();
        const blob = new Blob([
            result
        ], {
            type: type
        });
        if (window.navigator.msSaveBlob) navigator.msSaveBlob(blob, filename);
        else {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            setTimeout(()=>{
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
            }, 100);
        }
        return true;
    } catch (error) {
        console.error('Download failed:', error);
        return false;
    }
};
const $c7997aef068a9f19$export$1d9cf75e773fdfe9 = (url, target, fileName)=>{
    if (!url) {
        console.error('URL cannot be empty');
        return;
    }
    const link = document.createElement('a');
    link.href = url;
    if (fileName) link.download = fileName;
    if (target) link.target = target;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $c7997aef068a9f19$export$ef86e9b1c847b692 = ()=>{
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return rootFontSize || 16;
};
const $c7997aef068a9f19$var$palette = [
    {
        start: [
            124,
            178,
            210
        ],
        end: [
            174,
            228,
            255
        ]
    },
    {
        start: [
            110,
            119,
            203
        ],
        end: [
            160,
            169,
            253
        ]
    },
    {
        start: [
            180,
            110,
            203
        ],
        end: [
            230,
            160,
            253
        ]
    },
    {
        start: [
            99,
            172,
            138
        ],
        end: [
            149,
            222,
            188
        ]
    },
    {
        start: [
            194,
            165,
            61
        ],
        end: [
            244,
            215,
            111
        ]
    },
    {
        start: [
            203,
            136,
            110
        ],
        end: [
            253,
            186,
            160
        ]
    },
    {
        start: [
            203,
            136,
            110
        ],
        end: [
            253,
            186,
            160
        ]
    },
    {
        start: [
            110,
            203,
            200
        ],
        end: [
            160,
            253,
            250
        ]
    },
    {
        start: [
            194,
            132,
            56
        ],
        end: [
            244,
            182,
            106
        ]
    },
    {
        start: [
            203,
            110,
            161
        ],
        end: [
            253,
            160,
            211
        ]
    },
    {
        start: [
            125,
            79,
            44
        ],
        end: [
            175,
            129,
            94
        ]
    },
    {
        start: [
            202,
            61,
            64
        ],
        end: [
            252,
            111,
            114
        ]
    },
    {
        start: [
            110,
            73,
            162
        ],
        end: [
            160,
            123,
            212
        ]
    },
    {
        start: [
            133,
            161,
            97
        ],
        end: [
            183,
            211,
            147
        ]
    },
    {
        start: [
            76,
            194,
            114
        ],
        end: [
            126,
            244,
            164
        ]
    },
    {
        start: [
            49,
            106,
            213
        ],
        end: [
            99,
            156,
            255
        ]
    }
];
const $c7997aef068a9f19$var$hashString = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        hash = value.charCodeAt(i) + ((hash << 5) - hash);
        hash |= 0;
    }
    return Math.abs(hash);
};
const $c7997aef068a9f19$var$clamp = (value)=>Math.max(0, Math.min(255, value));
const $c7997aef068a9f19$var$adjustRgb = (rgb, delta)=>rgb.map((channel)=>$c7997aef068a9f19$var$clamp(channel + delta));
const $c7997aef068a9f19$var$toRgbString = (rgb)=>`rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`;
const $c7997aef068a9f19$export$6c21663cd469638f = (item = {})=>{
    if (!item.surname || !item.name) return '#7cb2d2';
    const [localPart = 'user', domainPart = 'scanat.com'] = item.email?.trim?.().toLowerCase().split('@');
    const localHash = $c7997aef068a9f19$var$hashString(localPart);
    const domainHash = $c7997aef068a9f19$var$hashString(domainPart);
    const mixedHash = $c7997aef068a9f19$var$hashString(`${localPart}|${domainPart}`);
    const base = $c7997aef068a9f19$var$palette[mixedHash % $c7997aef068a9f19$var$palette.length];
    const startAdjust = localHash % 24 - 12;
    const endAdjust = domainHash % 24 - 12;
    const reverse = mixedHash % 2 === 0;
    const startColor = $c7997aef068a9f19$var$toRgbString($c7997aef068a9f19$var$adjustRgb(base.start, startAdjust));
    const endColor = $c7997aef068a9f19$var$toRgbString($c7997aef068a9f19$var$adjustRgb(base.end, endAdjust));
    return reverse ? `linear-gradient(135deg, ${endColor} 0%, ${startColor} 100%)` : `linear-gradient(135deg, ${startColor} 0%, ${endColor} 100%)`;
};
const $c7997aef068a9f19$export$c1fb9bac27b52cdd = (item = {}, isFull = false)=>{
    if (!item.surname || !item.name) return isFull ? $c7997aef068a9f19$var$t('common.unNamed') : '';
    if (isFull) return `${item.surname} ${item.name}`;
    return /^[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\uFF65-\uFF9F]+$/u.test(item.surname) ? item.surname : `${item.surname[0]}${item.name[0]}`;
};
const $c7997aef068a9f19$export$e772c8ff12451969 = (ms = 0)=>new Promise((resolve)=>setTimeout(resolve, ms));

});
parcelRegister("gngdn", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("gogTx", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var r = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), r.call(this, t);
        };
        var o = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s;
            if (0 === u) return this.utc(f);
            var r = this.clone();
            if (f) return r.$offset = u, r.$u = !1, r;
            var o = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            return (r = this.local().add(u + o, t)).$offset = u, r.$x.$localOffset = o, r;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});

parcelRegister("lHTSI", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("3CfG2", function(module, exports) {

$parcel$export(module.exports, "PLANS", () => $2a2114dd8f608217$export$f7b784bedcf32cb3);
$parcel$export(module.exports, "HTTP_STATUS", () => $2a2114dd8f608217$export$3362bec89bce10fd);
$parcel$export(module.exports, "WHITE_LIST", () => $2a2114dd8f608217$export$d32e4a604598a94);
$parcel$export(module.exports, "DASHBOARD_LIST", () => $2a2114dd8f608217$export$bcef4acfbdf52805);
$parcel$export(module.exports, "MAX_REQ_TIMEOUTS", () => $2a2114dd8f608217$export$a4a53f110e4880cb);
$parcel$export(module.exports, "VALID_URL", () => $2a2114dd8f608217$export$f5d001f706d7ed36);
$parcel$export(module.exports, "STORAGE_KEY", () => $2a2114dd8f608217$export$86880b4b2e1a2384);
const $2a2114dd8f608217$export$f7b784bedcf32cb3 = {
    1: {
        name: "A \u500B\u4EBA",
        pretaxAmount: "\xa5120,000",
        tax: "\xa512,000",
        totalAmount: "\xa5132,000",
        desc: "Plan A \u500B\u4EBA\uFF08\u5E74\u9593\uFF09"
    },
    2: {
        name: "B \u30D9\u30FC\u30B7\u30C3\u30AF",
        pretaxAmount: "\xa5600,000",
        tax: "\xa560,000",
        totalAmount: "\xa5660,000",
        desc: "Plan B \u30D9\u30FC\u30B7\u30C3\u30AF"
    },
    3: {
        name: "C \u30D3\u30B8\u30CD\u30B9",
        pretaxAmount: "\xa53,600,000",
        tax: "\xa5360,000",
        totalAmount: "\xa53,960,000",
        desc: "Plan C \u30D3\u30B8\u30CD\u30B9"
    },
    4: {
        name: "D \u30A8\u30F3\u30BF\u30FC\u30D7\u30E9\u30A4\u30BA",
        pretaxAmount: "\xa55,000,000",
        tax: "\xa5500,000",
        totalAmount: "\xa55,500,000",
        desc: "Plan D \u30A8\u30F3\u30BF\u30FC\u30D7\u30E9\u30A4\u30BA"
    },
    5: {
        name: "A \u500B\u4EBA",
        pretaxAmount: "\xa512,000",
        tax: "\xa51,200",
        totalAmount: "\xa513,200",
        desc: "Plan A \u500B\u4EBA\uFF08\u6708\u9593\uFF09"
    }
};
const $2a2114dd8f608217$export$3362bec89bce10fd = [
    {
        code: 403,
        message: 'error.code.403'
    },
    {
        code: 404,
        message: 'error.code.404'
    },
    {
        code: 500,
        message: 'error.code.500'
    },
    {
        code: 502,
        message: 'error.code.502'
    },
    {
        code: 504,
        message: 'error.code.502'
    }
];
const $2a2114dd8f608217$export$d32e4a604598a94 = [
    '/',
    '/404.html',
    '/fee-plans.html',
    '/login.html',
    '/introduction.html',
    '/show-case.html',
    '/news.html',
    '/report.html',
    '/reset-password.html',
    '/not-found.html'
];
const $2a2114dd8f608217$export$bcef4acfbdf52805 = [
    '/logs.html',
    '/dashboard.html',
    '/enterprise.html',
    '/orders.html',
    '/devices.html',
    '/invitation.html',
    '/payment.html',
    '/admin.html'
];
const $2a2114dd8f608217$export$a4a53f110e4880cb = {
    // max request timeout is 90s
    default: 90000,
    'auth/login': 10000,
    'webModels/list': 60000,
    'webModels/spaces': 60000,
    'portal/user/list': 60000
};
const $2a2114dd8f608217$export$f5d001f706d7ed36 = [
    'webModels/share/authorization',
    'webModels/share/link/check',
    'webModels/share/link/legacy',
    'webModels/share/link/checkPassword',
    'webModels/share/authorization'
];
const $2a2114dd8f608217$var$PREFIX = 'SCANAT_';
const $2a2114dd8f608217$export$86880b4b2e1a2384 = {
    LOGIN_TIME: $2a2114dd8f608217$var$PREFIX + 'LOGIN_TIME',
    REDIRECT_URL: $2a2114dd8f608217$var$PREFIX + 'REDIRECT_URL'
};

});

parcelRegister("iS8eH", function(module, exports) {

$parcel$export(module.exports, "getApiErrorCodes", () => $dbd3a8a849db0724$export$d8e5fd5946392295);
$parcel$export(module.exports, "getLanguage", () => $dbd3a8a849db0724$export$64783e31db14f0ba);
$parcel$export(module.exports, "getElementPlusLocale", () => $dbd3a8a849db0724$export$c6a53bf8b0105e5d);
$parcel$export(module.exports, "default", () => $dbd3a8a849db0724$export$2e2bcd8739ae039);

var $jFUWD = parcelRequire("jFUWD");

var $eZeDV = parcelRequire("eZeDV");

var $ggNjQ = parcelRequire("ggNjQ");

var $cV7oD = parcelRequire("cV7oD");

var $5sJrY = parcelRequire("5sJrY");

var $e5b9N = parcelRequire("e5b9N");

var $ccPRA = parcelRequire("ccPRA");

var $35QKu = parcelRequire("35QKu");

var $fwauw = parcelRequire("fwauw");
const $dbd3a8a849db0724$export$defe85febe8b728c = {
    en: {
        ...(0, $ggNjQ.default)
    },
    zh: {
        ...(0, $cV7oD.default)
    },
    ja: {
        ...(0, $5sJrY.default)
    }
};
const $dbd3a8a849db0724$var$DEFAULT_NO_TOAST_CODES = [
    200,
    401,
    405,
    499,
    501,
    713,
    719,
    740,
    807,
    810,
    873,
    900,
    901,
    902,
    903,
    904,
    20000,
    20001
];
const $dbd3a8a849db0724$var$TOAST_OVERRIDE_RULES = [
    {
        pattern: /^webModels\/upload$/,
        codes: [
            403
        ],
        needToast: true
    },
    {
        pattern: /^webModels\/\d+$/,
        codes: [
            866
        ],
        needToast: false
    }
];
function $dbd3a8a849db0724$export$d8e5fd5946392295(url = '') {
    return (0, $e5b9N.default).map((item)=>{
        const rule = $dbd3a8a849db0724$var$TOAST_OVERRIDE_RULES.find((rule)=>rule.codes.includes(item.code));
        if (rule) {
            const matched = rule.pattern.test(url);
            return {
                ...item,
                noToast: matched ? !rule.needToast : rule.needToast
            };
        }
        return $dbd3a8a849db0724$var$DEFAULT_NO_TOAST_CODES.includes(item.code) ? {
            ...item,
            noToast: true
        } : item;
    });
}
function $dbd3a8a849db0724$export$64783e31db14f0ba() {
    const chooseLanguage = (0, (/*@__PURE__*/$parcel$interopDefault($eZeDV))).get('language');
    if (chooseLanguage) return chooseLanguage;
    // if has not choose language
    return 'ja';
}
function $dbd3a8a849db0724$export$c6a53bf8b0105e5d(locale) {
    const elementLocales = {
        'en': (0, $ccPRA.default),
        'zh': (0, $35QKu.default),
        'ja': (0, $fwauw.default)
    };
    const lang = locale || $dbd3a8a849db0724$export$64783e31db14f0ba();
    return elementLocales[lang] || (0, $ccPRA.default); // 默认为英文
}
const $dbd3a8a849db0724$var$i18n = (0, $jFUWD.createI18n)({
    legacy: false,
    globalInjection: true,
    locale: $dbd3a8a849db0724$export$64783e31db14f0ba(),
    fallbackLocale: 'ja',
    messages: $dbd3a8a849db0724$export$defe85febe8b728c
});
function $dbd3a8a849db0724$export$1856dfc3a920d947(locale = $dbd3a8a849db0724$export$64783e31db14f0ba()) {
    $dbd3a8a849db0724$var$i18n.global.locale.value = locale;
    (0, (/*@__PURE__*/$parcel$interopDefault($eZeDV))).set('language', locale);
    const elements = document.querySelectorAll('[data-lang-key]');
    const updates = [];
    elements.forEach((element)=>{
        const attr = Array.from(element.attributes).filter((attr)=>!attr.name.startsWith('data-lang')).map((attr)=>[
                attr.name,
                attr.value.replace(/\$lang\((.*?)\)/g, (match, key)=>{
                    return $dbd3a8a849db0724$var$i18n.global.t(key || match);
                })
            ]);
        const key = element.getAttribute('data-lang-key');
        try {
            const translatedText = key.replace(/\$lang\((.*?)\)/g, (match, _key)=>{
                return $dbd3a8a849db0724$var$i18n.global.t(_key || match);
            });
            updates.push({
                element: element,
                text: translatedText,
                ...Object.fromEntries(attr),
                isInput: element.tagName === 'INPUT'
            });
        } catch (error) {
            console.warn(`Translation key not found: ${key}`, error);
        }
    });
    if (updates.length > 0) requestAnimationFrame(()=>{
        updates.forEach(({ element: element, text: text, isInput: isInput, ...attr })=>{
            if (!isInput) element.textContent = text;
            Object.entries(attr).forEach(([name, value])=>{
                element.setAttribute(name, value);
            });
        });
    });
}
var $dbd3a8a849db0724$export$2e2bcd8739ae039 = $dbd3a8a849db0724$var$i18n;

});
parcelRegister("jFUWD", function(module, exports) {

$parcel$export(module.exports, "useI18n", () => $409cbe3732db83c2$export$3f3caade1c12f8c9);
$parcel$export(module.exports, "createI18n", () => $409cbe3732db83c2$export$920091e3d72d80ee);
/*!
  * vue-i18n v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $9QywT = parcelRequire("9QywT");

var $f97E4 = parcelRequire("f97E4");
var $7yiTB = parcelRequire("7yiTB");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $iM5gW = parcelRequire("iM5gW");
/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */ const $409cbe3732db83c2$export$a4ad2735b021c132 = '9.14.5';
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $409cbe3732db83c2$var$initFeatureFlags() {
    if (typeof __VUE_I18N_FULL_INSTALL__ !== 'boolean') (0, $9QywT.getGlobalThis)().__VUE_I18N_FULL_INSTALL__ = true;
    if (typeof __VUE_I18N_LEGACY_API__ !== 'boolean') (0, $9QywT.getGlobalThis)().__VUE_I18N_LEGACY_API__ = true;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== 'boolean') (0, $9QywT.getGlobalThis)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== 'boolean') (0, $9QywT.getGlobalThis)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') (0, $9QywT.getGlobalThis)().__INTLIFY_PROD_DEVTOOLS__ = false;
}
const $409cbe3732db83c2$var$code$1 = (0, $f97E4.CoreWarnCodes).__EXTEND_POINT__;
const $409cbe3732db83c2$var$inc$1 = (0, $9QywT.incrementer)($409cbe3732db83c2$var$code$1);
const $409cbe3732db83c2$var$I18nWarnCodes = {
    FALLBACK_TO_ROOT: $409cbe3732db83c2$var$code$1,
    NOT_SUPPORTED_PRESERVE: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_FORMATTER: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_PRESERVE_DIRECTIVE: $409cbe3732db83c2$var$inc$1(),
    NOT_SUPPORTED_GET_CHOICE_INDEX: $409cbe3732db83c2$var$inc$1(),
    COMPONENT_NAME_LEGACY_COMPATIBLE: $409cbe3732db83c2$var$inc$1(),
    NOT_FOUND_PARENT_SCOPE: $409cbe3732db83c2$var$inc$1(),
    IGNORE_OBJ_FLATTEN: $409cbe3732db83c2$var$inc$1(),
    NOTICE_DROP_ALLOW_COMPOSITION: $409cbe3732db83c2$var$inc$1(),
    NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: $409cbe3732db83c2$var$inc$1() // 18
};
const $409cbe3732db83c2$var$warnMessages = {
    [$409cbe3732db83c2$var$I18nWarnCodes.FALLBACK_TO_ROOT]: `Fall back to {type} '{key}' with root locale.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE]: `Not supported 'preserve'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER]: `Not supported 'formatter'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: `Not supported 'preserveDirectiveContent'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX]: `Not supported 'getChoiceIndex'.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE]: `Component name legacy compatible: '{name}' -> 'i18n'`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: `Not found parent scope. use the global scope.`,
    [$409cbe3732db83c2$var$I18nWarnCodes.IGNORE_OBJ_FLATTEN]: `Ignore object flatten: '{key}' key has an string value`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_ALLOW_COMPOSITION]: `'allowComposition' option will be dropped in the next major version. For more information, please see \u{1F449} https://tinyurl.com/2p97mcze`,
    [$409cbe3732db83c2$var$I18nWarnCodes.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: `'translateExistCompatible' option will be dropped in the next major version.`
};
function $409cbe3732db83c2$var$getWarnMessage(code, ...args) {
    return (0, $9QywT.format)($409cbe3732db83c2$var$warnMessages[code], ...args);
}
const $409cbe3732db83c2$var$code = (0, $f97E4.CoreErrorCodes).__EXTEND_POINT__;
const $409cbe3732db83c2$var$inc = (0, $9QywT.incrementer)($409cbe3732db83c2$var$code);
const $409cbe3732db83c2$var$I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: $409cbe3732db83c2$var$code,
    // legacy module errors
    INVALID_ARGUMENT: $409cbe3732db83c2$var$inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: $409cbe3732db83c2$var$inc(),
    NOT_INSTALLED: $409cbe3732db83c2$var$inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: $409cbe3732db83c2$var$inc(),
    // directive module errors
    REQUIRED_VALUE: $409cbe3732db83c2$var$inc(),
    INVALID_VALUE: $409cbe3732db83c2$var$inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: $409cbe3732db83c2$var$inc(),
    NOT_INSTALLED_WITH_PROVIDE: $409cbe3732db83c2$var$inc(),
    // unexpected error
    UNEXPECTED_ERROR: $409cbe3732db83c2$var$inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: $409cbe3732db83c2$var$inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: $409cbe3732db83c2$var$inc(),
    // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
    MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: $409cbe3732db83c2$var$inc(),
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: $409cbe3732db83c2$var$inc(),
    // for enhancement
    __EXTEND_POINT__: $409cbe3732db83c2$var$inc() // 38
};
function $409cbe3732db83c2$var$createI18nError(code, ...args) {
    return (0, $7yiTB.createCompileError)(code, null, undefined);
}
const $409cbe3732db83c2$var$errorMessages = {
    [$409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: 'Unexpected return type in composer',
    [$409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT]: 'Invalid argument',
    [$409cbe3732db83c2$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: 'Must be called at the top of a `setup` function',
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED]: 'Need to install with `app.use` function',
    [$409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR]: 'Unexpected error',
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE]: 'Not available in legacy mode',
    [$409cbe3732db83c2$var$I18nErrorCodes.REQUIRED_VALUE]: `Required in value: {0}`,
    [$409cbe3732db83c2$var$I18nErrorCodes.INVALID_VALUE]: `Invalid value`,
    [$409cbe3732db83c2$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: `Cannot setup vue-devtools plugin`,
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE]: 'Need to install with `provide` function',
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: 'Not compatible legacy VueI18n.',
    [$409cbe3732db83c2$var$I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY]: 'vue-i18n-bridge support Vue 2.x only',
    [$409cbe3732db83c2$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define \u2018i18n\u2019 option or custom block in Composition API with using local scope in Legacy API mode",
    [$409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: 'Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly'
};
const $409cbe3732db83c2$var$TranslateVNodeSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)('__translateVNode');
const $409cbe3732db83c2$var$DatetimePartsSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)('__datetimeParts');
const $409cbe3732db83c2$var$NumberPartsSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)('__numberParts');
const $409cbe3732db83c2$var$EnableEmitter = /* #__PURE__*/ (0, $9QywT.makeSymbol)('__enableEmitter');
const $409cbe3732db83c2$var$DisableEmitter = /* #__PURE__*/ (0, $9QywT.makeSymbol)('__disableEmitter');
const $409cbe3732db83c2$var$SetPluralRulesSymbol = (0, $9QywT.makeSymbol)('__setPluralRules');
(0, $9QywT.makeSymbol)('__intlifyMeta');
const $409cbe3732db83c2$var$InejctWithOptionSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)('__injectWithOption');
const $409cbe3732db83c2$var$DisposeSymbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)('__dispose');
const $409cbe3732db83c2$var$__VUE_I18N_BRIDGE__ = '__VUE_I18N_BRIDGE__';
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Transform flat json in obj to normal json in obj
 */ function $409cbe3732db83c2$var$handleFlatJson(obj) {
    // check obj
    if (!(0, $9QywT.isObject)(obj)) return obj;
    if ((0, $f97E4.isMessageAST)(obj)) return obj;
    for(const key in obj){
        // check key
        if (!(0, $9QywT.hasOwn)(obj, key)) continue;
        // handle for normal json
        if (!key.includes('.')) // recursive process value if value is also a object
        {
            if ((0, $9QywT.isObject)(obj[key])) $409cbe3732db83c2$var$handleFlatJson(obj[key]);
        } else {
            // go to the last object
            const subKeys = key.split('.');
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            let hasStringValue = false;
            for(let i = 0; i < lastIndex; i++){
                if (subKeys[i] === '__proto__') throw new Error(`unsafe key: ${subKeys[i]}`);
                if (!(subKeys[i] in currentObj)) currentObj[subKeys[i]] = (0, $9QywT.create)();
                if (!(0, $9QywT.isObject)(currentObj[subKeys[i]])) {
                    hasStringValue = true;
                    break;
                }
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            if (!hasStringValue) {
                if (!(0, $f97E4.isMessageAST)(currentObj)) {
                    currentObj[subKeys[lastIndex]] = obj[key];
                    delete obj[key];
                } else /**
                     * NOTE:
                     * if the last object is a message AST and subKeys[lastIndex] has message AST prop key, ignore to copy and key deletion
                     */ if (!(0, $f97E4.AST_NODE_PROPS_KEYS).includes(subKeys[lastIndex])) delete obj[key];
            }
            // recursive process value if value is also a object
            if (!(0, $f97E4.isMessageAST)(currentObj)) {
                const target = currentObj[subKeys[lastIndex]];
                if ((0, $9QywT.isObject)(target)) $409cbe3732db83c2$var$handleFlatJson(target);
            }
        }
    }
    return obj;
}
function $409cbe3732db83c2$var$getLocaleMessages(locale, options) {
    const { messages: messages, __i18n: __i18n, messageResolver: messageResolver, flatJson: flatJson } = options;
    // prettier-ignore
    const ret = (0, $9QywT.isPlainObject)(messages) ? messages : (0, $9QywT.isArray)(__i18n) ? (0, $9QywT.create)() : {
        [locale]: (0, $9QywT.create)()
    };
    // merge locale messages of i18n custom block
    if ((0, $9QywT.isArray)(__i18n)) __i18n.forEach((custom)=>{
        if ('locale' in custom && 'resource' in custom) {
            const { locale: locale, resource: resource } = custom;
            if (locale) {
                ret[locale] = ret[locale] || (0, $9QywT.create)();
                (0, $9QywT.deepCopy)(resource, ret[locale]);
            } else (0, $9QywT.deepCopy)(resource, ret);
        } else (0, $9QywT.isString)(custom) && (0, $9QywT.deepCopy)(JSON.parse(custom), ret);
    });
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for(const key in ret)if ((0, $9QywT.hasOwn)(ret, key)) $409cbe3732db83c2$var$handleFlatJson(ret[key]);
    }
    return ret;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getComponentOptions(instance) {
    return instance.type;
}
function $409cbe3732db83c2$var$adjustI18nResources(gl, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    let messages = (0, $9QywT.isObject)(options.messages) ? options.messages : (0, $9QywT.create)();
    if ('__i18nGlobal' in componentOptions) messages = $409cbe3732db83c2$var$getLocaleMessages(gl.locale.value, {
        messages: messages,
        __i18n: componentOptions.__i18nGlobal
    });
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) locales.forEach((locale)=>{
        gl.mergeLocaleMessage(locale, messages[locale]);
    });
    // merge datetime formats
    if ((0, $9QywT.isObject)(options.datetimeFormats)) {
        const locales = Object.keys(options.datetimeFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
    }
    // merge number formats
    if ((0, $9QywT.isObject)(options.numberFormats)) {
        const locales = Object.keys(options.numberFormats);
        if (locales.length) locales.forEach((locale)=>{
            gl.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
    }
}
function $409cbe3732db83c2$var$createTextNode(key) {
    return (0, $TusQn.createVNode)((0, $TusQn.Text), null, key, 0);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ // extend VNode interface
const $409cbe3732db83c2$var$DEVTOOLS_META = '__INTLIFY_META__';
const $409cbe3732db83c2$var$NOOP_RETURN_ARRAY = ()=>[];
const $409cbe3732db83c2$var$NOOP_RETURN_FALSE = ()=>false;
let $409cbe3732db83c2$var$composerID = 0;
function $409cbe3732db83c2$var$defineCoreMissingHandler(missing) {
    return (ctx, locale, key, type)=>{
        return missing(locale, key, (0, $TusQn.getCurrentInstance)() || undefined, type);
    };
}
// for Intlify DevTools
/* #__NO_SIDE_EFFECTS__ */ const $409cbe3732db83c2$var$getMetaInfo = ()=>{
    const instance = (0, $TusQn.getCurrentInstance)();
    let meta = null; // eslint-disable-line @typescript-eslint/no-explicit-any
    return instance && (meta = $409cbe3732db83c2$var$getComponentOptions(instance)[$409cbe3732db83c2$var$DEVTOOLS_META]) ? {
        [$409cbe3732db83c2$var$DEVTOOLS_META]: meta
    } // eslint-disable-line @typescript-eslint/no-explicit-any
     : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$var$createComposer(options = {}, VueI18nLegacy) {
    const { __root: __root, __injectWithOption: __injectWithOption } = options;
    const _isGlobal = __root === undefined;
    const flatJson = options.flatJson;
    const _ref = (0, $9QywT.inBrowser) ? (0, $01W3b.ref) : (0, $01W3b.shallowRef);
    const translateExistCompatible = !!options.translateExistCompatible;
    let _inheritLocale = (0, $9QywT.isBoolean)(options.inheritLocale) ? options.inheritLocale : true;
    const _locale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.locale.value : (0, $9QywT.isString)(options.locale) ? options.locale : (0, $f97E4.DEFAULT_LOCALE));
    const _fallbackLocale = _ref(// prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : (0, $9QywT.isString)(options.fallbackLocale) || (0, $9QywT.isArray)(options.fallbackLocale) || (0, $9QywT.isPlainObject)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = _ref($409cbe3732db83c2$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = _ref((0, $9QywT.isPlainObject)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = _ref((0, $9QywT.isPlainObject)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root ? __root.missingWarn : (0, $9QywT.isBoolean)(options.missingWarn) || (0, $9QywT.isRegExp)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    let _fallbackWarn = __root ? __root.fallbackWarn : (0, $9QywT.isBoolean)(options.fallbackWarn) || (0, $9QywT.isRegExp)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    let _fallbackRoot = __root ? __root.fallbackRoot : (0, $9QywT.isBoolean)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = (0, $9QywT.isFunction)(options.missing) ? options.missing : null;
    let _runtimeMissing = (0, $9QywT.isFunction)(options.missing) ? $409cbe3732db83c2$var$defineCoreMissingHandler(options.missing) : null;
    // postTranslation handler
    let _postTranslation = (0, $9QywT.isFunction)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    let _warnHtmlMessage = __root ? __root.warnHtmlMessage : (0, $9QywT.isBoolean)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root ? __root.modifiers : (0, $9QywT.isPlainObject)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    let _pluralRules = options.pluralRules || __root && __root.pluralRules;
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    const getCoreContext = ()=>{
        _isGlobal && (0, $f97E4.setFallbackContext)(null);
        const ctxOptions = {
            version: $409cbe3732db83c2$export$a4ad2735b021c132,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            messageCompiler: options.messageCompiler,
            __meta: {
                framework: 'vue'
            }
        };
        ctxOptions.datetimeFormats = _datetimeFormats.value;
        ctxOptions.numberFormats = _numberFormats.value;
        ctxOptions.__datetimeFormatters = (0, $9QywT.isPlainObject)(_context) ? _context.__datetimeFormatters : undefined;
        ctxOptions.__numberFormatters = (0, $9QywT.isPlainObject)(_context) ? _context.__numberFormatters : undefined;
        const ctx = (0, $f97E4.createCoreContext)(ctxOptions);
        _isGlobal && (0, $f97E4.setFallbackContext)(ctx);
        return ctx;
    };
    _context = getCoreContext();
    (0, $f97E4.updateFallbackLocale)(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $01W3b.computed)({
        get: ()=>_locale.value,
        set: (val1)=>{
            _locale.value = val1;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $01W3b.computed)({
        get: ()=>_fallbackLocale.value,
        set: (val1)=>{
            _fallbackLocale.value = val1;
            _context.fallbackLocale = _fallbackLocale.value;
            (0, $f97E4.updateFallbackLocale)(_context, _locale.value, val1);
        }
    });
    // messages
    const messages = (0, $01W3b.computed)(()=>_messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ (0, $01W3b.computed)(()=>_datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ (0, $01W3b.computed)(()=>_numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return (0, $9QywT.isFunction)(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler1) {
        _postTranslation = handler1;
        _context.postTranslation = handler1;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler1) {
        if (handler1 !== null) _runtimeMissing = $409cbe3732db83c2$var$defineCoreMissingHandler(handler1);
        _missing = handler1;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        return type !== 'translate' || !arg.resolvedMessage;
    }
    const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition)=>{
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        try {
            if (__INTLIFY_PROD_DEVTOOLS__) (0, $f97E4.setAdditionalMeta)($409cbe3732db83c2$var$getMetaInfo());
            if (!_isGlobal) _context.fallbackContext = __root ? (0, $f97E4.getFallbackContext)() : undefined;
            ret = fn(_context);
        } finally{
            if (__INTLIFY_PROD_DEVTOOLS__) (0, $f97E4.setAdditionalMeta)(null);
            if (!_isGlobal) _context.fallbackContext = undefined;
        }
        if (warnType !== 'translate exists' && // for not `te` (e.g `t`)
        (0, $9QywT.isNumber)(ret) && ret === (0, $f97E4.NOT_REOSLVED) || warnType === 'translate exists' && !ret // for `te`
        ) {
            const [key, arg2] = argumentParser();
            return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
        } else if (successCondition(ret)) return ret;
        else /* istanbul ignore next */ throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    };
    // t
    function t(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.translate), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseTranslateArgs)(...args), 'translate', (root)=>Reflect.apply(root.t, root, [
                ...args
            ]), (key)=>key, (val1)=>(0, $9QywT.isString)(val1));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !(0, $9QywT.isObject)(arg3)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
        return t(...[
            arg1,
            arg2,
            (0, $9QywT.assign)({
                resolvedMessage: true
            }, arg3 || {})
        ]);
    }
    // d
    function d(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.datetime), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseDateTimeArgs)(...args), 'datetime format', (root)=>Reflect.apply(root.d, root, [
                ...args
            ]), ()=>(0, $f97E4.MISSING_RESOLVE_VALUE), (val1)=>(0, $9QywT.isString)(val1));
    }
    // n
    function n(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.number), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseNumberArgs)(...args), 'number format', (root)=>Reflect.apply(root.n, root, [
                ...args
            ]), ()=>(0, $f97E4.MISSING_RESOLVE_VALUE), (val1)=>(0, $9QywT.isString)(val1));
    }
    // for custom processor
    function normalize(values) {
        return values.map((val1)=>(0, $9QywT.isString)(val1) || (0, $9QywT.isNumber)(val1) || (0, $9QywT.isBoolean)(val1) ? $409cbe3732db83c2$var$createTextNode(String(val1)) : val1);
    }
    const interpolate = (val1)=>val1;
    const processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: 'vnode'
    };
    // translateVNode, using for `i18n-t` component
    function translateVNode(...args) {
        return wrapWithDeps((context)=>{
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply((0, $f97E4.translate), null, [
                    _context,
                    ...args
                ]);
            } finally{
                _context.processor = null;
            }
            return ret;
        }, ()=>(0, $f97E4.parseTranslateArgs)(...args), 'translate', // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$TranslateVNodeSymbol](...args), (key)=>[
                $409cbe3732db83c2$var$createTextNode(key)
            ], (val1)=>(0, $9QywT.isArray)(val1));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.number), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseNumberArgs)(...args), 'number format', // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$NumberPartsSymbol](...args), $409cbe3732db83c2$var$NOOP_RETURN_ARRAY, (val1)=>(0, $9QywT.isString)(val1) || (0, $9QywT.isArray)(val1));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $f97E4.datetime), null, [
                context,
                ...args
            ]), ()=>(0, $f97E4.parseDateTimeArgs)(...args), 'datetime format', // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$409cbe3732db83c2$var$DatetimePartsSymbol](...args), $409cbe3732db83c2$var$NOOP_RETURN_ARRAY, (val1)=>(0, $9QywT.isString)(val1) || (0, $9QywT.isArray)(val1));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        return wrapWithDeps(()=>{
            if (!key) return false;
            const targetLocale = (0, $9QywT.isString)(locale) ? locale : _locale.value;
            const message = getLocaleMessage(targetLocale);
            const resolved = _context.messageResolver(message, key);
            return !translateExistCompatible ? (0, $f97E4.isMessageAST)(resolved) || (0, $f97E4.isMessageFunction)(resolved) || (0, $9QywT.isString)(resolved) : resolved != null;
        }, ()=>[
                key
            ], 'translate exists', (root)=>{
            return Reflect.apply(root.te, root, [
                key,
                locale
            ]);
        }, $409cbe3732db83c2$var$NOOP_RETURN_FALSE, (val1)=>(0, $9QywT.isBoolean)(val1));
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = (0, $f97E4.fallbackWithLocaleChain)(_context, _fallbackLocale.value, _locale.value);
        for(let i = 0; i < locales.length; i++){
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null ? messages : __root ? __root.tm(key) || {} : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return _messages.value[locale] || {};
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        if (flatJson) {
            const _message = {
                [locale]: message
            };
            for(const key in _message)if ((0, $9QywT.hasOwn)(_message, key)) $409cbe3732db83c2$var$handleFlatJson(_message[key]);
            message = _message[locale];
        }
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        const _message = {
            [locale]: message
        };
        if (flatJson) {
            for(const key in _message)if ((0, $9QywT.hasOwn)(_message, key)) $409cbe3732db83c2$var$handleFlatJson(_message[key]);
        }
        message = _message[locale];
        (0, $9QywT.deepCopy)(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $f97E4.clearDateTimeFormat)(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = (0, $9QywT.assign)(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $f97E4.clearDateTimeFormat)(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        (0, $f97E4.clearNumberFormat)(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = (0, $9QywT.assign)(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        (0, $f97E4.clearNumberFormat)(_context, locale, format);
    }
    // for debug
    $409cbe3732db83c2$var$composerID++;
    // watch root locale & fallbackLocale
    if (__root && (0, $9QywT.inBrowser)) {
        (0, $01W3b.watch)(__root.locale, (val1)=>{
            if (_inheritLocale) {
                _locale.value = val1;
                _context.locale = val1;
                (0, $f97E4.updateFallbackLocale)(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0, $01W3b.watch)(__root.fallbackLocale, (val1)=>{
            if (_inheritLocale) {
                _fallbackLocale.value = val1;
                _context.fallbackLocale = val1;
                (0, $f97E4.updateFallbackLocale)(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: $409cbe3732db83c2$var$composerID,
        locale: locale,
        fallbackLocale: fallbackLocale,
        get inheritLocale () {
            return _inheritLocale;
        },
        set inheritLocale (val){
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                (0, $f97E4.updateFallbackLocale)(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales () {
            return Object.keys(_messages.value).sort();
        },
        messages: messages,
        get modifiers () {
            return _modifiers;
        },
        get pluralRules () {
            return _pluralRules || {};
        },
        get isGlobal () {
            return _isGlobal;
        },
        get missingWarn () {
            return _missingWarn;
        },
        set missingWarn (val){
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn () {
            return _fallbackWarn;
        },
        set fallbackWarn (val){
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot () {
            return _fallbackRoot;
        },
        set fallbackRoot (val){
            _fallbackRoot = val;
        },
        get fallbackFormat () {
            return _fallbackFormat;
        },
        set fallbackFormat (val){
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage () {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _escapeParameter;
        },
        set escapeParameter (val){
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t: t,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        [$409cbe3732db83c2$var$SetPluralRulesSymbol]: setPluralRules
    };
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[$409cbe3732db83c2$var$InejctWithOptionSymbol] = __injectWithOption;
    composer[$409cbe3732db83c2$var$TranslateVNodeSymbol] = translateVNode;
    composer[$409cbe3732db83c2$var$DatetimePartsSymbol] = datetimeParts;
    composer[$409cbe3732db83c2$var$NumberPartsSymbol] = numberParts;
    var emitter;
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */ function $409cbe3732db83c2$var$convertComposerOptions(options) {
    const locale = (0, $9QywT.isString)(options.locale) ? options.locale : (0, $f97E4.DEFAULT_LOCALE);
    const fallbackLocale = (0, $9QywT.isString)(options.fallbackLocale) || (0, $9QywT.isArray)(options.fallbackLocale) || (0, $9QywT.isPlainObject)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    const missing = (0, $9QywT.isFunction)(options.missing) ? options.missing : undefined;
    const missingWarn = (0, $9QywT.isBoolean)(options.silentTranslationWarn) || (0, $9QywT.isRegExp)(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.silentFallbackWarn) || (0, $9QywT.isRegExp)(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
    const fallbackRoot = (0, $9QywT.isBoolean)(options.fallbackRoot) ? options.fallbackRoot : true;
    const fallbackFormat = !!options.formatFallbackMessages;
    const modifiers = (0, $9QywT.isPlainObject)(options.modifiers) ? options.modifiers : {};
    const pluralizationRules = options.pluralizationRules;
    const postTranslation = (0, $9QywT.isFunction)(options.postTranslation) ? options.postTranslation : undefined;
    const warnHtmlMessage = (0, $9QywT.isString)(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== 'off' : true;
    const escapeParameter = !!options.escapeParameterHtml;
    const inheritLocale = (0, $9QywT.isBoolean)(options.sync) ? options.sync : true;
    let messages = options.messages;
    if ((0, $9QywT.isPlainObject)(options.sharedMessages)) {
        const sharedMessages = options.sharedMessages;
        const locales = Object.keys(sharedMessages);
        messages = locales.reduce((messages, locale)=>{
            const message = messages[locale] || (messages[locale] = {});
            (0, $9QywT.assign)(message, sharedMessages[locale]);
            return messages;
        }, messages || {});
    }
    const { __i18n: __i18n, __root: __root, __injectWithOption: __injectWithOption } = options;
    const datetimeFormats = options.datetimeFormats;
    const numberFormats = options.numberFormats;
    const flatJson = options.flatJson;
    const translateExistCompatible = options.translateExistCompatible;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        translateExistCompatible: translateExistCompatible,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$var$createVueI18n(options = {}, VueI18nLegacy) {
    {
        const composer = $409cbe3732db83c2$var$createComposer($409cbe3732db83c2$var$convertComposerOptions(options));
        const { __extender: __extender } = options;
        // defines VueI18n
        const vueI18n = {
            // id
            id: composer.id,
            // locale
            get locale () {
                return composer.locale.value;
            },
            set locale (val){
                composer.locale.value = val;
            },
            // fallbackLocale
            get fallbackLocale () {
                return composer.fallbackLocale.value;
            },
            set fallbackLocale (val){
                composer.fallbackLocale.value = val;
            },
            // messages
            get messages () {
                return composer.messages.value;
            },
            // datetimeFormats
            get datetimeFormats () {
                return composer.datetimeFormats.value;
            },
            // numberFormats
            get numberFormats () {
                return composer.numberFormats.value;
            },
            // availableLocales
            get availableLocales () {
                return composer.availableLocales;
            },
            // formatter
            get formatter () {
                // dummy
                return {
                    interpolate () {
                        return [];
                    }
                };
            },
            set formatter (val){},
            // missing
            get missing () {
                return composer.getMissingHandler();
            },
            set missing (handler){
                composer.setMissingHandler(handler);
            },
            // silentTranslationWarn
            get silentTranslationWarn () {
                return (0, $9QywT.isBoolean)(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
            },
            set silentTranslationWarn (val){
                composer.missingWarn = (0, $9QywT.isBoolean)(val) ? !val : val;
            },
            // silentFallbackWarn
            get silentFallbackWarn () {
                return (0, $9QywT.isBoolean)(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
            },
            set silentFallbackWarn (val){
                composer.fallbackWarn = (0, $9QywT.isBoolean)(val) ? !val : val;
            },
            // modifiers
            get modifiers () {
                return composer.modifiers;
            },
            // formatFallbackMessages
            get formatFallbackMessages () {
                return composer.fallbackFormat;
            },
            set formatFallbackMessages (val){
                composer.fallbackFormat = val;
            },
            // postTranslation
            get postTranslation () {
                return composer.getPostTranslationHandler();
            },
            set postTranslation (handler){
                composer.setPostTranslationHandler(handler);
            },
            // sync
            get sync () {
                return composer.inheritLocale;
            },
            set sync (val){
                composer.inheritLocale = val;
            },
            // warnInHtmlMessage
            get warnHtmlInMessage () {
                return composer.warnHtmlMessage ? 'warn' : 'off';
            },
            set warnHtmlInMessage (val){
                composer.warnHtmlMessage = val !== 'off';
            },
            // escapeParameterHtml
            get escapeParameterHtml () {
                return composer.escapeParameter;
            },
            set escapeParameterHtml (val){
                composer.escapeParameter = val;
            },
            // preserveDirectiveContent
            get preserveDirectiveContent () {
                return true;
            },
            set preserveDirectiveContent (val){},
            // pluralizationRules
            get pluralizationRules () {
                return composer.pluralRules || {};
            },
            // for internal
            __composer: composer,
            // t
            t (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {};
                let list = null;
                let named = null;
                if (!(0, $9QywT.isString)(arg1)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $9QywT.isString)(arg2)) options.locale = arg2;
                else if ((0, $9QywT.isArray)(arg2)) list = arg2;
                else if ((0, $9QywT.isPlainObject)(arg2)) named = arg2;
                if ((0, $9QywT.isArray)(arg3)) list = arg3;
                else if ((0, $9QywT.isPlainObject)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            rt (...args) {
                return Reflect.apply(composer.rt, composer, [
                    ...args
                ]);
            },
            // tc
            tc (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {
                    plural: 1
                };
                let list = null;
                let named = null;
                if (!(0, $9QywT.isString)(arg1)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $9QywT.isString)(arg2)) options.locale = arg2;
                else if ((0, $9QywT.isNumber)(arg2)) options.plural = arg2;
                else if ((0, $9QywT.isArray)(arg2)) list = arg2;
                else if ((0, $9QywT.isPlainObject)(arg2)) named = arg2;
                if ((0, $9QywT.isString)(arg3)) options.locale = arg3;
                else if ((0, $9QywT.isArray)(arg3)) list = arg3;
                else if ((0, $9QywT.isPlainObject)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            // te
            te (key, locale) {
                return composer.te(key, locale);
            },
            // tm
            tm (key) {
                return composer.tm(key);
            },
            // getLocaleMessage
            getLocaleMessage (locale) {
                return composer.getLocaleMessage(locale);
            },
            // setLocaleMessage
            setLocaleMessage (locale, message) {
                composer.setLocaleMessage(locale, message);
            },
            // mergeLocaleMessage
            mergeLocaleMessage (locale, message) {
                composer.mergeLocaleMessage(locale, message);
            },
            // d
            d (...args) {
                return Reflect.apply(composer.d, composer, [
                    ...args
                ]);
            },
            // getDateTimeFormat
            getDateTimeFormat (locale) {
                return composer.getDateTimeFormat(locale);
            },
            // setDateTimeFormat
            setDateTimeFormat (locale, format) {
                composer.setDateTimeFormat(locale, format);
            },
            // mergeDateTimeFormat
            mergeDateTimeFormat (locale, format) {
                composer.mergeDateTimeFormat(locale, format);
            },
            // n
            n (...args) {
                return Reflect.apply(composer.n, composer, [
                    ...args
                ]);
            },
            // getNumberFormat
            getNumberFormat (locale) {
                return composer.getNumberFormat(locale);
            },
            // setNumberFormat
            setNumberFormat (locale, format) {
                composer.setNumberFormat(locale, format);
            },
            // mergeNumberFormat
            mergeNumberFormat (locale, format) {
                composer.mergeNumberFormat(locale, format);
            },
            // getChoiceIndex
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            getChoiceIndex (choice, choicesLength) {
                return -1;
            }
        };
        vueI18n.__extender = __extender;
        var emitter;
        return vueI18n;
    }
}
/* eslint-enable @typescript-eslint/no-explicit-any */ const $409cbe3732db83c2$var$baseFormatProps = {
    tag: {
        type: [
            String,
            Object
        ]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val1 /* ComponentI18nScope */ )=>val1 === 'parent' || val1 === 'global',
        default: 'parent' /* ComponentI18nScope */ 
    },
    i18n: {
        type: Object
    }
};
function $409cbe3732db83c2$var$getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots: slots }, keys) {
    if (keys.length === 1 && keys[0] === 'default') {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current)=>{
            return [
                ...slot,
                // prettier-ignore
                ...current.type === (0, $TusQn.Fragment) ? current.children : [
                    current
                ]
            ];
        }, []);
    } else // named slots
    return keys.reduce((arg, key)=>{
        const slot = slots[key];
        if (slot) arg[key] = slot();
        return arg;
    }, (0, $9QywT.create)());
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getFragmentableTag(tag) {
    return 0, $TusQn.Fragment;
}
const $409cbe3732db83c2$var$TranslationImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: 'i18n-t',
    props: (0, $9QywT.assign)({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [
                Number,
                String
            ],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: (val1)=>(0, $9QywT.isNumber)(val1) || !isNaN(val1)
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const { slots: slots, attrs: attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return ()=>{
            const keys = Object.keys(slots).filter((key)=>key !== '_');
            const options = (0, $9QywT.create)();
            if (props.locale) options.locale = props.locale;
            if (props.plural !== undefined) options.plural = (0, $9QywT.isString)(props.plural) ? +props.plural : props.plural;
            const arg = $409cbe3732db83c2$var$getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[$409cbe3732db83c2$var$TranslateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = (0, $9QywT.assign)((0, $9QywT.create)(), attrs);
            const tag = (0, $9QywT.isString)(props.tag) || (0, $9QywT.isObject)(props.tag) ? props.tag : $409cbe3732db83c2$var$getFragmentableTag();
            return (0, $TusQn.h)(tag, assignedAttrs, children);
        };
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n keypath="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$b63289fbda65eed1 = $409cbe3732db83c2$var$TranslationImpl;
const $409cbe3732db83c2$export$1d08de71ac06ffd6 = $409cbe3732db83c2$export$b63289fbda65eed1;
function $409cbe3732db83c2$var$isVNode(target) {
    return (0, $9QywT.isArray)(target) && !(0, $9QywT.isString)(target[0]);
}
function $409cbe3732db83c2$var$renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots: slots, attrs: attrs } = context;
    return ()=>{
        const options = {
            part: true
        };
        let overrides = (0, $9QywT.create)();
        if (props.locale) options.locale = props.locale;
        if ((0, $9QywT.isString)(props.format)) options.key = props.format;
        else if ((0, $9QywT.isObject)(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((0, $9QywT.isString)(props.format.key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            options.key = props.format.key;
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop)=>{
                return slotKeys.includes(prop) ? (0, $9QywT.assign)((0, $9QywT.create)(), options, {
                    [prop]: props.format[prop]
                }) // eslint-disable-line @typescript-eslint/no-explicit-any
                 : options;
            }, (0, $9QywT.create)());
        }
        const parts = partFormatter(...[
            props.value,
            options,
            overrides
        ]);
        let children = [
            options.key
        ];
        if ((0, $9QywT.isArray)(parts)) children = parts.map((part, index)=>{
            const slot = slots[part.type];
            const node = slot ? slot({
                [part.type]: part.value,
                index: index,
                parts: parts
            }) : [
                part.value
            ];
            if ($409cbe3732db83c2$var$isVNode(node)) node[0].key = `${part.type}-${index}`;
            return node;
        });
        else if ((0, $9QywT.isString)(parts)) children = [
            parts
        ];
        const assignedAttrs = (0, $9QywT.assign)((0, $9QywT.create)(), attrs);
        const tag = (0, $9QywT.isString)(props.tag) || (0, $9QywT.isObject)(props.tag) ? props.tag : $409cbe3732db83c2$var$getFragmentableTag();
        return (0, $TusQn.h)(tag, assignedAttrs, children);
    };
}
const $409cbe3732db83c2$var$NumberFormatImpl = /*#__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: 'i18n-n',
    props: (0, $9QywT.assign)({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $409cbe3732db83c2$var$renderFormatter(props, context, (0, $f97E4.NUMBER_FORMAT_OPTIONS_KEYS), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$409cbe3732db83c2$var$NumberPartsSymbol](...args));
    }
});
/**
 * export the public type for h/tsx inference
 * also to avoid inline import() in generated d.ts files
 */ /**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$27bce688931fdfcc = $409cbe3732db83c2$var$NumberFormatImpl;
const $409cbe3732db83c2$export$4665d24327644133 = $409cbe3732db83c2$export$27bce688931fdfcc;
const $409cbe3732db83c2$var$DatetimeFormatImpl = /* #__PURE__*/ (0, $TusQn.defineComponent)({
    /* eslint-disable */ name: 'i18n-d',
    props: (0, $9QywT.assign)({
        value: {
            type: [
                Number,
                Date
            ],
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $409cbe3732db83c2$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $409cbe3732db83c2$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return $409cbe3732db83c2$var$renderFormatter(props, context, (0, $f97E4.DATETIME_FORMAT_OPTIONS_KEYS), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$409cbe3732db83c2$var$DatetimePartsSymbol](...args));
    }
});
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */ const $409cbe3732db83c2$export$64ca50867510e64e = $409cbe3732db83c2$var$DatetimeFormatImpl;
const $409cbe3732db83c2$export$c741260b89dcb234 = $409cbe3732db83c2$export$64ca50867510e64e;
function $409cbe3732db83c2$var$getComposer$2(i18n, instance) {
    const i18nInternal = i18n;
    if (i18n.mode === 'composition') return i18nInternal.__getInstance(instance) || i18n.global;
    else {
        const vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
    }
}
function $409cbe3732db83c2$export$8a5a05546006d0b5(i18n) {
    const _process = (binding)=>{
        const { instance: instance, modifiers: modifiers, value: value } = binding;
        /* istanbul ignore if */ if (!instance || !instance.$) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const composer = $409cbe3732db83c2$var$getComposer$2(i18n, instance.$);
        const parsedValue = $409cbe3732db83c2$var$parseValue(value);
        return [
            Reflect.apply(composer.t, composer, [
                ...$409cbe3732db83c2$var$makeParams(parsedValue)
            ]),
            composer
        ];
    };
    const register = (el, binding)=>{
        const [textContent, composer] = _process(binding);
        if ((0, $9QywT.inBrowser) && i18n.global === composer) // global scope only
        el.__i18nWatcher = (0, $01W3b.watch)(composer.locale, ()=>{
            binding.instance && binding.instance.$forceUpdate();
        });
        el.__composer = composer;
        el.textContent = textContent;
    };
    const unregister = (el)=>{
        if ((0, $9QywT.inBrowser) && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    const update = (el, { value: value })=>{
        if (el.__composer) {
            const composer = el.__composer;
            const parsedValue = $409cbe3732db83c2$var$parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, [
                ...$409cbe3732db83c2$var$makeParams(parsedValue)
            ]);
        }
    };
    const getSSRProps = (binding)=>{
        const [textContent] = _process(binding);
        return {
            textContent: textContent
        };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps: getSSRProps
    };
}
function $409cbe3732db83c2$var$parseValue(value) {
    if ((0, $9QywT.isString)(value)) return {
        path: value
    };
    else if ((0, $9QywT.isPlainObject)(value)) {
        if (!('path' in value)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.REQUIRED_VALUE, 'path');
        return value;
    } else throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.INVALID_VALUE);
}
function $409cbe3732db83c2$var$makeParams(value) {
    const { path: path, locale: locale, args: args, choice: choice, plural: plural } = value;
    const options = {};
    const named = args || {};
    if ((0, $9QywT.isString)(locale)) options.locale = locale;
    if ((0, $9QywT.isNumber)(choice)) options.plural = choice;
    if ((0, $9QywT.isNumber)(plural)) options.plural = plural;
    return [
        path,
        named,
        options
    ];
}
function $409cbe3732db83c2$var$apply(app, i18n, ...options) {
    const pluginOptions = (0, $9QywT.isPlainObject)(options[0]) ? options[0] : {};
    const useI18nComponentName = !!pluginOptions.useI18nComponentName;
    const globalInstall = (0, $9QywT.isBoolean)(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
    if (globalInstall) {
        [
            !useI18nComponentName ? $409cbe3732db83c2$export$b63289fbda65eed1.name : 'i18n',
            'I18nT'
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$b63289fbda65eed1));
        [
            $409cbe3732db83c2$export$27bce688931fdfcc.name,
            'I18nN'
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$27bce688931fdfcc));
        [
            $409cbe3732db83c2$export$64ca50867510e64e.name,
            'I18nD'
        ].forEach((name)=>app.component(name, $409cbe3732db83c2$export$64ca50867510e64e));
    }
    app.directive('t', $409cbe3732db83c2$export$8a5a05546006d0b5(i18n));
}
const $409cbe3732db83c2$var$VueDevToolsLabels = {
    ["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ]: 'Vue I18n devtools',
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: 'I18n Resources',
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: 'Vue I18n'
};
const $409cbe3732db83c2$var$VueDevToolsPlaceholders = {
    ["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]: 'Search for scopes ...'
};
const $409cbe3732db83c2$var$VueDevToolsTimelineColors = {
    ["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]: 0xffcd19
};
const $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES = 'vue-i18n: composer properties';
let $409cbe3732db83c2$var$devtoolsApi;
async function $409cbe3732db83c2$var$enableDevTools(app, i18n) {
    return new Promise((resolve, reject)=>{
        try {
            (0, $iM5gW.setupDevtoolsPlugin)({
                id: "vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ,
                label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-devtools-plugin-vue-i18n" /* VueDevToolsIDs.PLUGIN */ ],
                packageName: 'vue-i18n',
                homepage: 'https://vue-i18n.intlify.dev',
                logo: 'https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png',
                componentStateTypes: [
                    $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES
                ],
                app: app // eslint-disable-line @typescript-eslint/no-explicit-any
            }, (api)=>{
                $409cbe3732db83c2$var$devtoolsApi = api;
                api.on.visitComponentTree(({ componentInstance: componentInstance, treeNode: treeNode })=>{
                    $409cbe3732db83c2$var$updateComponentTreeTags(componentInstance, treeNode, i18n);
                });
                api.on.inspectComponent(({ componentInstance: componentInstance, instanceData: instanceData })=>{
                    if (componentInstance.vnode.el && componentInstance.vnode.el.__VUE_I18N__ && instanceData) {
                        if (i18n.mode === 'legacy') // ignore global scope on legacy mode
                        {
                            if (componentInstance.vnode.el.__VUE_I18N__ !== i18n.global.__composer) $409cbe3732db83c2$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                        } else $409cbe3732db83c2$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                    }
                });
                api.addInspector({
                    id: "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ,
                    label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ],
                    icon: 'language',
                    treeFilterPlaceholder: $409cbe3732db83c2$var$VueDevToolsPlaceholders["vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ]
                });
                api.on.getInspectorTree((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $409cbe3732db83c2$var$registerScope(payload, i18n);
                });
                const roots = new Map();
                api.on.getInspectorState(async (payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) {
                        api.unhighlightElement();
                        $409cbe3732db83c2$var$inspectScope(payload, i18n);
                        if (payload.nodeId === 'global') {
                            if (!roots.has(payload.app)) {
                                const [root] = await api.getComponentInstances(payload.app);
                                roots.set(payload.app, root);
                            }
                            api.highlightElement(roots.get(payload.app));
                        } else {
                            const instance = $409cbe3732db83c2$var$getComponentInstance(payload.nodeId, i18n);
                            instance && api.highlightElement(instance);
                        }
                    }
                });
                api.on.editInspectorState((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* VueDevToolsIDs.CUSTOM_INSPECTOR */ ) $409cbe3732db83c2$var$editScope(payload, i18n);
                });
                api.addTimelineLayer({
                    id: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
                    label: $409cbe3732db83c2$var$VueDevToolsLabels["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ],
                    color: $409cbe3732db83c2$var$VueDevToolsTimelineColors["vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ]
                });
                resolve(true);
            });
        } catch (e) {
            console.error(e);
            reject(false);
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getI18nScopeLable(instance) {
    return instance.type.name || instance.type.displayName || instance.type.__file || 'Anonymous';
}
function $409cbe3732db83c2$var$updateComponentTreeTags(instance, treeNode, i18n) {
    // prettier-ignore
    const global = i18n.mode === 'composition' ? i18n.global : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) // add custom tags local scope only
    {
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            const tag = {
                label: `i18n (${$409cbe3732db83c2$var$getI18nScopeLable(instance)} Scope)`,
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function $409cbe3732db83c2$var$inspectComposer(instanceData, composer) {
    const type = $409cbe3732db83c2$var$VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type: type,
        key: 'locale',
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type: type,
        key: 'availableLocales',
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type: type,
        key: 'fallbackLocale',
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type: type,
        key: 'inheritLocale',
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type: type,
        key: 'messages',
        editable: false,
        value: $409cbe3732db83c2$var$getLocaleMessageValue(composer.messages.value)
    });
    instanceData.state.push({
        type: type,
        key: 'datetimeFormats',
        editable: false,
        value: composer.datetimeFormats.value
    });
    instanceData.state.push({
        type: type,
        key: 'numberFormats',
        editable: false,
        value: composer.numberFormats.value
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getLocaleMessageValue(messages) {
    const value = {};
    Object.keys(messages).forEach((key)=>{
        const v = messages[key];
        if ((0, $9QywT.isFunction)(v) && 'source' in v) value[key] = $409cbe3732db83c2$var$getMessageFunctionDetails(v);
        else if ((0, $f97E4.isMessageAST)(v) && v.loc && v.loc.source) value[key] = v.loc.source;
        else if ((0, $9QywT.isObject)(v)) value[key] = $409cbe3732db83c2$var$getLocaleMessageValue(v);
        else value[key] = v;
    });
    return value;
}
const $409cbe3732db83c2$var$ESC = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '&': '&amp;'
};
function $409cbe3732db83c2$var$escape(s) {
    return s.replace(/[<>"&]/g, $409cbe3732db83c2$var$escapeChar);
}
function $409cbe3732db83c2$var$escapeChar(a) {
    return $409cbe3732db83c2$var$ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getMessageFunctionDetails(func) {
    const argString = func.source ? `("${$409cbe3732db83c2$var$escape(func.source)}")` : `(?)`;
    return {
        _custom: {
            type: 'function',
            display: `<span>\u{192}</span> ${argString}`
        }
    };
}
function $409cbe3732db83c2$var$registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: 'global',
        label: 'Global Scope'
    });
    // prettier-ignore
    const global = i18n.mode === 'composition' ? i18n.global : i18n.global.__composer;
    for (const [keyInstance, instance] of i18n.__instances){
        // prettier-ignore
        const composer = i18n.mode === 'composition' ? instance : instance.__composer;
        if (global === composer) continue;
        payload.rootNodes.push({
            id: composer.id.toString(),
            label: `${$409cbe3732db83c2$var$getI18nScopeLable(keyInstance)} Scope`
        });
    }
}
function $409cbe3732db83c2$var$getComponentInstance(nodeId, i18n) {
    let instance = null;
    if (nodeId !== 'global') {
        for (const [component, composer] of i18n.__instances.entries())if (composer.id.toString() === nodeId) {
            instance = component;
            break;
        }
    }
    return instance;
}
function $409cbe3732db83c2$var$getComposer$1(nodeId, i18n) {
    if (nodeId === 'global') return i18n.mode === 'composition' ? i18n.global : i18n.global.__composer;
    else {
        const instance = Array.from(i18n.__instances.values()).find((item)=>item.id.toString() === nodeId);
        if (instance) return i18n.mode === 'composition' ? instance : instance.__composer;
        else return null;
    }
}
function $409cbe3732db83c2$var$inspectScope(payload, i18n) {
    const composer = $409cbe3732db83c2$var$getComposer$1(payload.nodeId, i18n);
    if (composer) // TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload.state = $409cbe3732db83c2$var$makeScopeInspectState(composer);
    return null;
}
function $409cbe3732db83c2$var$makeScopeInspectState(composer) {
    const state = {};
    const localeType = 'Locale related info';
    const localeStates = [
        {
            type: localeType,
            key: 'locale',
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: 'fallbackLocale',
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: 'availableLocales',
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: 'inheritLocale',
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    const localeMessagesType = 'Locale messages info';
    const localeMessagesStates = [
        {
            type: localeMessagesType,
            key: 'messages',
            editable: false,
            value: $409cbe3732db83c2$var$getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        const datetimeFormatsType = 'Datetime formats info';
        const datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: 'datetimeFormats',
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        const numberFormatsType = 'Datetime formats info';
        const numberFormatsStates = [
            {
                type: numberFormatsType,
                key: 'numberFormats',
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function $409cbe3732db83c2$var$addTimelineEvent(event, payload) {
    if ($409cbe3732db83c2$var$devtoolsApi) {
        let groupId;
        if (payload && 'groupId' in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        $409cbe3732db83c2$var$devtoolsApi.addTimelineEvent({
            layerId: "vue-i18n-timeline" /* VueDevToolsIDs.TIMELINE */ ,
            event: {
                title: event,
                groupId: groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === "compile-error" /* VueDevToolsTimelineEvents.COMPILE_ERROR */  ? 'error' : event === "fallback" /* VueDevToolsTimelineEvents.FALBACK */  || event === "missing" /* VueDevToolsTimelineEvents.MISSING */  ? 'warning' : 'default'
            }
        });
    }
}
function $409cbe3732db83c2$var$editScope(payload, i18n) {
    const composer = $409cbe3732db83c2$var$getComposer$1(payload.nodeId, i18n);
    if (composer) {
        const [field] = payload.path;
        if (field === 'locale' && (0, $9QywT.isString)(payload.state.value)) composer.locale.value = payload.state.value;
        else if (field === 'fallbackLocale' && ((0, $9QywT.isString)(payload.state.value) || (0, $9QywT.isArray)(payload.state.value) || (0, $9QywT.isObject)(payload.state.value))) composer.fallbackLocale.value = payload.state.value;
        else if (field === 'inheritLocale' && (0, $9QywT.isBoolean)(payload.state.value)) composer.inheritLocale = payload.state.value;
    }
}
/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */ function $409cbe3732db83c2$var$defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate () {
            const instance = (0, $TusQn.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const options = this.$options;
            if (options.i18n) {
                const optionsI18n = options.i18n;
                if (options.__i18n) optionsI18n.__i18n = options.__i18n;
                optionsI18n.__root = composer;
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $409cbe3732db83c2$var$mergeToGlobal(vuei18n, optionsI18n);
                else {
                    optionsI18n.__injectWithOption = true;
                    optionsI18n.__extender = i18n.__vueI18nExtend;
                    // atttach local VueI18n instance
                    this.$i18n = $409cbe3732db83c2$var$createVueI18n(optionsI18n);
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else if (options.__i18n) {
                if (this === this.$root) // merge option and gttach global
                this.$i18n = $409cbe3732db83c2$var$mergeToGlobal(vuei18n, options);
                else {
                    // atttach local VueI18n instance
                    this.$i18n = $409cbe3732db83c2$var$createVueI18n({
                        __i18n: options.__i18n,
                        __injectWithOption: true,
                        __extender: i18n.__vueI18nExtend,
                        __root: composer
                    });
                    // extend VueI18n instance
                    const _vueI18n = this.$i18n;
                    if (_vueI18n.__extender) _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
                }
            } else // attach global VueI18n instance
            this.$i18n = vuei18n;
            if (options.__i18nGlobal) $409cbe3732db83c2$var$adjustI18nResources(composer, options, options);
            // defines vue-i18n legacy APIs
            this.$t = (...args)=>this.$i18n.t(...args);
            this.$rt = (...args)=>this.$i18n.rt(...args);
            this.$tc = (...args)=>this.$i18n.tc(...args);
            this.$te = (key, locale)=>this.$i18n.te(key, locale);
            this.$d = (...args)=>this.$i18n.d(...args);
            this.$n = (...args)=>this.$i18n.n(...args);
            this.$tm = (key)=>this.$i18n.tm(key);
            i18n.__setInstance(instance, this.$i18n);
        },
        mounted () {
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$i18n) {
                const _vueI18n = this.$i18n;
                this.$el.__VUE_I18N__ = _vueI18n.__composer;
                const emitter = this.__v_emitter = (0, $9QywT.createEmitter)();
                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                emitter.on('*', $409cbe3732db83c2$var$addTimelineEvent);
            }
        },
        unmounted () {
            const instance = (0, $TusQn.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const _vueI18n = this.$i18n;
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$el.__VUE_I18N__) {
                if (this.__v_emitter) {
                    this.__v_emitter.off('*', $409cbe3732db83c2$var$addTimelineEvent);
                    delete this.__v_emitter;
                }
                if (this.$i18n) {
                    _vueI18n.__disableEmitter && _vueI18n.__disableEmitter();
                    delete this.$el.__VUE_I18N__;
                }
            }
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            if (_vueI18n.__disposer) {
                _vueI18n.__disposer();
                delete _vueI18n.__disposer;
                delete _vueI18n.__extender;
            }
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function $409cbe3732db83c2$var$mergeToGlobal(g, options) {
    g.locale = options.locale || g.locale;
    g.fallbackLocale = options.fallbackLocale || g.fallbackLocale;
    g.missing = options.missing || g.missing;
    g.silentTranslationWarn = options.silentTranslationWarn || g.silentFallbackWarn;
    g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn;
    g.formatFallbackMessages = options.formatFallbackMessages || g.formatFallbackMessages;
    g.postTranslation = options.postTranslation || g.postTranslation;
    g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage;
    g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml;
    g.sync = options.sync || g.sync;
    g.__composer[$409cbe3732db83c2$var$SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
    const messages = $409cbe3732db83c2$var$getLocaleMessages(g.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach((locale)=>g.mergeLocaleMessage(locale, messages[locale]));
    if (options.datetimeFormats) Object.keys(options.datetimeFormats).forEach((locale)=>g.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
    if (options.numberFormats) Object.keys(options.numberFormats).forEach((locale)=>g.mergeNumberFormat(locale, options.numberFormats[locale]));
    return g;
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */ const $409cbe3732db83c2$export$b19990ca6e622dd2 = /* #__PURE__*/ (0, $9QywT.makeSymbol)('global-vue-i18n');
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$export$920091e3d72d80ee(options = {}, VueI18nLegacy) {
    // prettier-ignore
    const __legacyMode = __VUE_I18N_LEGACY_API__ && (0, $9QywT.isBoolean)(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
    // prettier-ignore
    const __globalInjection = (0, $9QywT.isBoolean)(options.globalInjection) ? options.globalInjection : true;
    // prettier-ignore
    const __allowComposition = __VUE_I18N_LEGACY_API__ && __legacyMode ? !!options.allowComposition : true;
    const __instances = new Map();
    const [globalScope, __global] = $409cbe3732db83c2$var$createGlobal(options, __legacyMode);
    const symbol = /* #__PURE__*/ (0, $9QywT.makeSymbol)('');
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    {
        const i18n = {
            // mode
            get mode () {
                return __VUE_I18N_LEGACY_API__ && __legacyMode ? 'legacy' : 'composition';
            },
            // allowComposition
            get allowComposition () {
                return __allowComposition;
            },
            // install plugin
            async install (app, ...options) {
                if (__VUE_PROD_DEVTOOLS__ && true) app.__VUE_I18N__ = i18n;
                // setup global provider
                app.__VUE_I18N_SYMBOL__ = symbol;
                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                // set composer & vuei18n extend hook options from plugin options
                if ((0, $9QywT.isPlainObject)(options[0])) {
                    const opts = options[0];
                    i18n.__composerExtend = opts.__composerExtend;
                    i18n.__vueI18nExtend = opts.__vueI18nExtend;
                }
                // global method and properties injection for Composition API
                let globalReleaseHandler = null;
                if (!__legacyMode && __globalInjection) globalReleaseHandler = $409cbe3732db83c2$var$injectGlobalFields(app, i18n.global);
                // install built-in components and directive
                if (__VUE_I18N_FULL_INSTALL__) $409cbe3732db83c2$var$apply(app, i18n, ...options);
                // setup mixin for Legacy API
                if (__VUE_I18N_LEGACY_API__ && __legacyMode) app.mixin($409cbe3732db83c2$var$defineMixin(__global, __global.__composer, i18n));
                // release global scope
                const unmountApp = app.unmount;
                app.unmount = ()=>{
                    globalReleaseHandler && globalReleaseHandler();
                    i18n.dispose();
                    unmountApp();
                };
                // setup vue-devtools plugin
                if (__VUE_PROD_DEVTOOLS__ && true) {
                    const ret = await $409cbe3732db83c2$var$enableDevTools(app, i18n);
                    if (!ret) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
                    const emitter = (0, $9QywT.createEmitter)();
                    if (__legacyMode) {
                        const _vueI18n = __global;
                        _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                    } else {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const _composer = __global;
                        _composer[$409cbe3732db83c2$var$EnableEmitter] && _composer[$409cbe3732db83c2$var$EnableEmitter](emitter);
                    }
                    emitter.on('*', $409cbe3732db83c2$var$addTimelineEvent);
                }
            },
            // global accessor
            get global () {
                return __global;
            },
            dispose () {
                globalScope.stop();
            },
            __instances: // @internal
            __instances,
            __getInstance: // @internal
            __getInstance,
            __setInstance: // @internal
            __setInstance,
            __deleteInstance: // @internal
            __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $409cbe3732db83c2$export$3f3caade1c12f8c9(options = {}) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (instance == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED);
    const i18n = $409cbe3732db83c2$var$getI18nInstance(instance);
    const gl = $409cbe3732db83c2$var$getGlobalComposer(i18n);
    const componentOptions = $409cbe3732db83c2$var$getComponentOptions(instance);
    const scope = $409cbe3732db83c2$var$getScope(options, componentOptions);
    if (__VUE_I18N_LEGACY_API__) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {
        if (i18n.mode === 'legacy' && !options.__useComponent) {
            if (!i18n.allowComposition) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
            return $409cbe3732db83c2$var$useI18nForLegacy(instance, scope, gl, options);
        }
    }
    if (scope === 'global') {
        $409cbe3732db83c2$var$adjustI18nResources(gl, options, componentOptions);
        return gl;
    }
    if (scope === 'parent') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = $409cbe3732db83c2$var$getComposer(i18n, instance, options.__useComponent);
        if (composer == null) composer = gl;
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = (0, $9QywT.assign)({}, options);
        if ('__i18n' in componentOptions) composerOptions.__i18n = componentOptions.__i18n;
        if (gl) composerOptions.__root = gl;
        composer = $409cbe3732db83c2$var$createComposer(composerOptions);
        if (i18nInternal.__composerExtend) composer[$409cbe3732db83c2$var$DisposeSymbol] = i18nInternal.__composerExtend(composer);
        $409cbe3732db83c2$var$setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
/**
 * Cast to VueI18n legacy compatible type
 *
 * @remarks
 * This API is provided only with [vue-i18n-bridge](https://vue-i18n.intlify.dev/guide/migration/ways.html#what-is-vue-i18n-bridge).
 *
 * The purpose of this function is to convert an {@link I18n} instance created with {@link createI18n | createI18n(legacy: true)} into a `vue-i18n@v8.x` compatible instance of `new VueI18n` in a TypeScript environment.
 *
 * @param i18n - An instance of {@link I18n}
 * @returns A i18n instance which is casted to {@link VueI18n} type
 *
 * @VueI18nTip
 * :new: provided by **vue-i18n-bridge only**
 *
 * @VueI18nGeneral
 */ /* #__NO_SIDE_EFFECTS__ */ const $409cbe3732db83c2$export$ec8a89fa64fbfb0 = (i18n)=>{
    if (!($409cbe3732db83c2$var$__VUE_I18N_BRIDGE__ in i18n)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N);
    return i18n;
};
function $409cbe3732db83c2$var$createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const scope = (0, $01W3b.effectScope)();
    {
        const obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(()=>$409cbe3732db83c2$var$createVueI18n(options)) : scope.run(()=>$409cbe3732db83c2$var$createComposer(options));
        if (obj == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        return [
            scope,
            obj
        ];
    }
}
function $409cbe3732db83c2$var$getI18nInstance(instance) {
    {
        const i18n = (0, $TusQn.inject)(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : $409cbe3732db83c2$export$b19990ca6e622dd2);
        /* istanbul ignore if */ if (!i18n) throw $409cbe3732db83c2$var$createI18nError(!instance.isCE ? $409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR : $409cbe3732db83c2$var$I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $409cbe3732db83c2$var$getScope(options, componentOptions) {
    // prettier-ignore
    return (0, $9QywT.isEmptyObject)(options) ? '__i18n' in componentOptions ? 'local' : 'global' : !options.useScope ? 'local' : options.useScope;
}
function $409cbe3732db83c2$var$getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === 'composition' ? i18n.global : i18n.global.__composer;
}
function $409cbe3732db83c2$var$getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = $409cbe3732db83c2$var$getParentComponentInstance(target, useComponent);
    while(current != null){
        const i18nInternal = i18n;
        if (i18n.mode === 'composition') composer = i18nInternal.__getInstance(current);
        else if (__VUE_I18N_LEGACY_API__) {
            const vueI18n = i18nInternal.__getInstance(current);
            if (vueI18n != null) {
                composer = vueI18n.__composer;
                if (useComponent && composer && !composer[$409cbe3732db83c2$var$InejctWithOptionSymbol] // eslint-disable-line @typescript-eslint/no-explicit-any
                ) composer = null;
            }
        }
        if (composer != null) break;
        if (root === current) break;
        current = current.parent;
    }
    return composer;
}
function $409cbe3732db83c2$var$getParentComponentInstance(target, useComponent = false) {
    if (target == null) return null;
    // if `useComponent: true` will be specified, we get lexical scope owner instance for use-case slots
    return !useComponent ? target.parent : target.vnode.ctx || target.parent; // eslint-disable-line @typescript-eslint/no-explicit-any
}
function $409cbe3732db83c2$var$setupLifeCycle(i18n, target, composer) {
    let emitter = null;
    (0, $TusQn.onMounted)(()=>{
        // inject composer instance to DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = (0, $9QywT.createEmitter)();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _composer = composer;
            _composer[$409cbe3732db83c2$var$EnableEmitter] && _composer[$409cbe3732db83c2$var$EnableEmitter](emitter);
            emitter.on('*', $409cbe3732db83c2$var$addTimelineEvent);
        }
    }, target);
    (0, $TusQn.onUnmounted)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _composer = composer;
        // remove composer instance from DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el && target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off('*', $409cbe3732db83c2$var$addTimelineEvent);
            _composer[$409cbe3732db83c2$var$DisableEmitter] && _composer[$409cbe3732db83c2$var$DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
        // dispose extended resources
        const dispose = _composer[$409cbe3732db83c2$var$DisposeSymbol];
        if (dispose) {
            dispose();
            delete _composer[$409cbe3732db83c2$var$DisposeSymbol];
        }
    }, target);
}
function $409cbe3732db83c2$var$useI18nForLegacy(instance, scope, root, options = {} // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const isLocalScope = scope === 'local';
    const _composer = (0, $01W3b.shallowRef)(null);
    if (isLocalScope && instance.proxy && !(instance.proxy.$options.i18n || instance.proxy.$options.__i18n)) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
    const _inheritLocale = (0, $9QywT.isBoolean)(options.inheritLocale) ? options.inheritLocale : !(0, $9QywT.isString)(options.locale);
    const _locale = (0, $01W3b.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.locale.value : (0, $9QywT.isString)(options.locale) ? options.locale : (0, $f97E4.DEFAULT_LOCALE));
    const _fallbackLocale = (0, $01W3b.ref)(// prettier-ignore
    !isLocalScope || _inheritLocale ? root.fallbackLocale.value : (0, $9QywT.isString)(options.fallbackLocale) || (0, $9QywT.isArray)(options.fallbackLocale) || (0, $9QywT.isPlainObject)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = (0, $01W3b.ref)($409cbe3732db83c2$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = (0, $01W3b.ref)((0, $9QywT.isPlainObject)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = (0, $01W3b.ref)((0, $9QywT.isPlainObject)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _missingWarn = isLocalScope ? root.missingWarn : (0, $9QywT.isBoolean)(options.missingWarn) || (0, $9QywT.isRegExp)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    const _fallbackWarn = isLocalScope ? root.fallbackWarn : (0, $9QywT.isBoolean)(options.fallbackWarn) || (0, $9QywT.isRegExp)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    const _fallbackRoot = isLocalScope ? root.fallbackRoot : (0, $9QywT.isBoolean)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    const _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    const _missing = (0, $9QywT.isFunction)(options.missing) ? options.missing : null;
    // postTranslation handler
    const _postTranslation = (0, $9QywT.isFunction)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    const _warnHtmlMessage = isLocalScope ? root.warnHtmlMessage : (0, $9QywT.isBoolean)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const _escapeParameter = !!options.escapeParameter;
    // prettier-ignore
    const _modifiers = isLocalScope ? root.modifiers : (0, $9QywT.isPlainObject)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    const _pluralRules = options.pluralRules || isLocalScope && root.pluralRules;
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $01W3b.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.locale.value : _locale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.locale.value = val1;
            _locale.value = val1;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $01W3b.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.fallbackLocale.value : _fallbackLocale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.fallbackLocale.value = val1;
            _fallbackLocale.value = val1;
        }
    });
    // messages
    const messages = (0, $01W3b.computed)(()=>{
        if (_composer.value) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _composer.value.messages.value;
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _messages.value;
    });
    const datetimeFormats = (0, $01W3b.computed)(()=>_datetimeFormats.value);
    const numberFormats = (0, $01W3b.computed)(()=>_numberFormats.value);
    function getPostTranslationHandler() {
        return _composer.value ? _composer.value.getPostTranslationHandler() : _postTranslation;
    }
    function setPostTranslationHandler(handler1) {
        if (_composer.value) _composer.value.setPostTranslationHandler(handler1);
    }
    function getMissingHandler() {
        return _composer.value ? _composer.value.getMissingHandler() : _missing;
    }
    function setMissingHandler(handler1) {
        if (_composer.value) _composer.value.setMissingHandler(handler1);
    }
    function warpWithDeps(fn) {
        trackReactivityValues();
        return fn();
    }
    function t(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.t, null, [
                ...args
            ])) : warpWithDeps(()=>'');
    }
    function rt(...args) {
        return _composer.value ? Reflect.apply(_composer.value.rt, null, [
            ...args
        ]) : '';
    }
    function d(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.d, null, [
                ...args
            ])) : warpWithDeps(()=>'');
    }
    function n(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.n, null, [
                ...args
            ])) : warpWithDeps(()=>'');
    }
    function tm(key) {
        return _composer.value ? _composer.value.tm(key) : {};
    }
    function te(key, locale) {
        return _composer.value ? _composer.value.te(key, locale) : false;
    }
    function getLocaleMessage(locale) {
        return _composer.value ? _composer.value.getLocaleMessage(locale) : {};
    }
    function setLocaleMessage(locale, message) {
        if (_composer.value) {
            _composer.value.setLocaleMessage(locale, message);
            _messages.value[locale] = message;
        }
    }
    function mergeLocaleMessage(locale, message) {
        if (_composer.value) _composer.value.mergeLocaleMessage(locale, message);
    }
    function getDateTimeFormat(locale) {
        return _composer.value ? _composer.value.getDateTimeFormat(locale) : {};
    }
    function setDateTimeFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setDateTimeFormat(locale, format);
            _datetimeFormats.value[locale] = format;
        }
    }
    function mergeDateTimeFormat(locale, format) {
        if (_composer.value) _composer.value.mergeDateTimeFormat(locale, format);
    }
    function getNumberFormat(locale) {
        return _composer.value ? _composer.value.getNumberFormat(locale) : {};
    }
    function setNumberFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setNumberFormat(locale, format);
            _numberFormats.value[locale] = format;
        }
    }
    function mergeNumberFormat(locale, format) {
        if (_composer.value) _composer.value.mergeNumberFormat(locale, format);
    }
    const wrapper = {
        get id () {
            return _composer.value ? _composer.value.id : -1;
        },
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        get inheritLocale () {
            return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
        },
        set inheritLocale (val){
            if (_composer.value) _composer.value.inheritLocale = val;
        },
        get availableLocales () {
            return _composer.value ? _composer.value.availableLocales : Object.keys(_messages.value);
        },
        get modifiers () {
            return _composer.value ? _composer.value.modifiers : _modifiers;
        },
        get pluralRules () {
            return _composer.value ? _composer.value.pluralRules : _pluralRules;
        },
        get isGlobal () {
            return _composer.value ? _composer.value.isGlobal : false;
        },
        get missingWarn () {
            return _composer.value ? _composer.value.missingWarn : _missingWarn;
        },
        set missingWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackWarn () {
            return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
        },
        set fallbackWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackRoot () {
            return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
        },
        set fallbackRoot (val){
            if (_composer.value) _composer.value.fallbackRoot = val;
        },
        get fallbackFormat () {
            return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
        },
        set fallbackFormat (val){
            if (_composer.value) _composer.value.fallbackFormat = val;
        },
        get warnHtmlMessage () {
            return _composer.value ? _composer.value.warnHtmlMessage : _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            if (_composer.value) _composer.value.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _composer.value ? _composer.value.escapeParameter : _escapeParameter;
        },
        set escapeParameter (val){
            if (_composer.value) _composer.value.escapeParameter = val;
        },
        t: t,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        rt: rt,
        d: d,
        n: n,
        tm: tm,
        te: te,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getDateTimeFormat: getDateTimeFormat,
        setDateTimeFormat: setDateTimeFormat,
        mergeDateTimeFormat: mergeDateTimeFormat,
        getNumberFormat: getNumberFormat,
        setNumberFormat: setNumberFormat,
        mergeNumberFormat: mergeNumberFormat
    };
    function sync(composer) {
        composer.locale.value = _locale.value;
        composer.fallbackLocale.value = _fallbackLocale.value;
        Object.keys(_messages.value).forEach((locale)=>{
            composer.mergeLocaleMessage(locale, _messages.value[locale]);
        });
        Object.keys(_datetimeFormats.value).forEach((locale)=>{
            composer.mergeDateTimeFormat(locale, _datetimeFormats.value[locale]);
        });
        Object.keys(_numberFormats.value).forEach((locale)=>{
            composer.mergeNumberFormat(locale, _numberFormats.value[locale]);
        });
        composer.escapeParameter = _escapeParameter;
        composer.fallbackFormat = _fallbackFormat;
        composer.fallbackRoot = _fallbackRoot;
        composer.fallbackWarn = _fallbackWarn;
        composer.missingWarn = _missingWarn;
        composer.warnHtmlMessage = _warnHtmlMessage;
    }
    (0, $TusQn.onBeforeMount)(()=>{
        if (instance.proxy == null || instance.proxy.$i18n == null) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const composer = _composer.value = instance.proxy.$i18n.__composer;
        if (scope === 'global') {
            _locale.value = composer.locale.value;
            _fallbackLocale.value = composer.fallbackLocale.value;
            _messages.value = composer.messages.value;
            _datetimeFormats.value = composer.datetimeFormats.value;
            _numberFormats.value = composer.numberFormats.value;
        } else if (isLocalScope) sync(composer);
    });
    return wrapper;
}
const $409cbe3732db83c2$var$globalExportProps = [
    'locale',
    'fallbackLocale',
    'availableLocales'
];
const $409cbe3732db83c2$var$globalExportMethods = [
    't',
    'rt',
    'd',
    'n',
    'tm',
    'te'
];
function $409cbe3732db83c2$var$injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    $409cbe3732db83c2$var$globalExportProps.forEach((prop)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const wrap = (0, $01W3b.isRef)(desc.value) // check computed props
         ? {
            get () {
                return desc.value.value;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set (val1) {
                desc.value.value = val1;
            }
        } : {
            get () {
                return desc.get && desc.get();
            }
        };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    $409cbe3732db83c2$var$globalExportMethods.forEach((method)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) throw $409cbe3732db83c2$var$createI18nError($409cbe3732db83c2$var$I18nErrorCodes.UNEXPECTED_ERROR);
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
    const dispose = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete app.config.globalProperties.$i18n;
        $409cbe3732db83c2$var$globalExportMethods.forEach((method)=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            delete app.config.globalProperties[`$${method}`];
        });
    };
    return dispose;
}
$409cbe3732db83c2$var$initFeatureFlags();
// register message compiler at vue-i18n
if (__INTLIFY_JIT_COMPILATION__) (0, $f97E4.registerMessageCompiler)((0, $f97E4.compile));
else (0, $f97E4.registerMessageCompiler)((0, $f97E4.compileToFunction));
// register message resolver at vue-i18n
(0, $f97E4.registerMessageResolver)((0, $f97E4.resolveValue));
// register fallback locale at vue-i18n
(0, $f97E4.registerLocaleFallbacker)((0, $f97E4.fallbackWithLocaleChain));
// NOTE: experimental !!
if (__INTLIFY_PROD_DEVTOOLS__) {
    const target = (0, $9QywT.getGlobalThis)();
    target.__INTLIFY__ = true;
    (0, $f97E4.setDevToolsHook)(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}

});
parcelRegister("9QywT", function(module, exports) {

$parcel$export(module.exports, "warn", () => $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "inBrowser", () => $fbd1e3bc010bc8c2$export$620a268685f0ac45);
$parcel$export(module.exports, "format", () => $fbd1e3bc010bc8c2$export$d9468344d3651243);
$parcel$export(module.exports, "isObject", () => $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "makeSymbol", () => $fbd1e3bc010bc8c2$export$cd133c5e04906ece);
$parcel$export(module.exports, "generateFormatCacheKey", () => $fbd1e3bc010bc8c2$export$5024ef1f92c9a364);
$parcel$export(module.exports, "isNumber", () => $fbd1e3bc010bc8c2$export$7e4aa119212bc614);
$parcel$export(module.exports, "isDate", () => $fbd1e3bc010bc8c2$export$871608497c498473);
$parcel$export(module.exports, "isRegExp", () => $fbd1e3bc010bc8c2$export$49841c62b9eff15);
$parcel$export(module.exports, "isEmptyObject", () => $fbd1e3bc010bc8c2$export$83b788b1a3698c03);
$parcel$export(module.exports, "isPlainObject", () => $fbd1e3bc010bc8c2$export$53b83ca8eaab0383);
$parcel$export(module.exports, "assign", () => $fbd1e3bc010bc8c2$export$e6e34fd1f2686227);
$parcel$export(module.exports, "create", () => $fbd1e3bc010bc8c2$export$185802fd694ee1f5);
$parcel$export(module.exports, "getGlobalThis", () => $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "escapeHtml", () => $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8);
$parcel$export(module.exports, "sanitizeTranslatedHtml", () => $fbd1e3bc010bc8c2$export$d27e3ef8781285da);
$parcel$export(module.exports, "hasOwn", () => $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $fbd1e3bc010bc8c2$export$43bee75e5e14138e);
$parcel$export(module.exports, "isFunction", () => $fbd1e3bc010bc8c2$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $fbd1e3bc010bc8c2$export$844ec244b1367d54);
$parcel$export(module.exports, "isBoolean", () => $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isPromise", () => $fbd1e3bc010bc8c2$export$4369c812aac99591);
$parcel$export(module.exports, "toDisplayString", () => $fbd1e3bc010bc8c2$export$b5b1545233b45293);
$parcel$export(module.exports, "join", () => $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd);
$parcel$export(module.exports, "incrementer", () => $fbd1e3bc010bc8c2$export$47db5deb603dfca1);
$parcel$export(module.exports, "createEmitter", () => $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1);
$parcel$export(module.exports, "deepCopy", () => $fbd1e3bc010bc8c2$export$6c40052bed430212);
/*!
  * shared v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ function $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d(msg, err) {
    if (typeof console !== 'undefined') {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */ if (err) console.warn(err.stack);
    }
}
const $fbd1e3bc010bc8c2$var$hasWarned = {};
function $fbd1e3bc010bc8c2$export$5b28268982f175ba(msg) {
    if (!$fbd1e3bc010bc8c2$var$hasWarned[msg]) {
        $fbd1e3bc010bc8c2$var$hasWarned[msg] = true;
        $fbd1e3bc010bc8c2$export$c106dd0671a0fc2d(msg);
    }
}
/**
 * Original Utilities
 * written by kazuya kawaguchi
 */ const $fbd1e3bc010bc8c2$export$620a268685f0ac45 = typeof window !== 'undefined';
let $fbd1e3bc010bc8c2$export$bf7f2fce5c1cf636;
let $fbd1e3bc010bc8c2$export$83602b44513dc228;
var $fbd1e3bc010bc8c2$var$tag, $fbd1e3bc010bc8c2$var$name, $fbd1e3bc010bc8c2$var$startTag, $fbd1e3bc010bc8c2$var$endTag;
const $fbd1e3bc010bc8c2$var$RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */ function $fbd1e3bc010bc8c2$export$d9468344d3651243(message, ...args) {
    if (args.length === 1 && $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(args[0])) args = args[0];
    if (!args || !args.hasOwnProperty) args = {};
    return message.replace($fbd1e3bc010bc8c2$var$RE_ARGS, (match, identifier)=>{
        return args.hasOwnProperty(identifier) ? args[identifier] : '';
    });
}
const $fbd1e3bc010bc8c2$export$cd133c5e04906ece = (name, shareable = false)=>!shareable ? Symbol(name) : Symbol.for(name);
const $fbd1e3bc010bc8c2$export$5024ef1f92c9a364 = (locale, key, source)=>$fbd1e3bc010bc8c2$export$d704025436eaed65({
        l: locale,
        k: key,
        s: source
    });
const $fbd1e3bc010bc8c2$export$d704025436eaed65 = (json)=>JSON.stringify(json).replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029').replace(/\u0027/g, '\\u0027');
const $fbd1e3bc010bc8c2$export$7e4aa119212bc614 = (val)=>typeof val === 'number' && isFinite(val);
const $fbd1e3bc010bc8c2$export$871608497c498473 = (val)=>$fbd1e3bc010bc8c2$export$1dccc787cc36538b(val) === '[object Date]';
const $fbd1e3bc010bc8c2$export$49841c62b9eff15 = (val)=>$fbd1e3bc010bc8c2$export$1dccc787cc36538b(val) === '[object RegExp]';
const $fbd1e3bc010bc8c2$export$83b788b1a3698c03 = (val)=>$fbd1e3bc010bc8c2$export$53b83ca8eaab0383(val) && Object.keys(val).length === 0;
const $fbd1e3bc010bc8c2$export$e6e34fd1f2686227 = Object.assign;
const $fbd1e3bc010bc8c2$var$_create = Object.create;
const $fbd1e3bc010bc8c2$export$185802fd694ee1f5 = (obj = null)=>$fbd1e3bc010bc8c2$var$_create(obj);
let $fbd1e3bc010bc8c2$var$_globalThis;
const $fbd1e3bc010bc8c2$export$ff5f2eeb11fc7e14 = ()=>{
    // prettier-ignore
    return $fbd1e3bc010bc8c2$var$_globalThis || ($fbd1e3bc010bc8c2$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : $fbd1e3bc010bc8c2$export$185802fd694ee1f5());
};
function $fbd1e3bc010bc8c2$export$4cf11838cdc2a8a8(rawText) {
    return rawText.replace(/&/g, '&amp;') // escape `&` first to avoid double escaping
    .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace(/\//g, '&#x2F;') // escape `/` to prevent closing tags or JavaScript URLs
    .replace(/=/g, '&#x3D;'); // escape `=` to prevent attribute injection
}
function $fbd1e3bc010bc8c2$var$escapeAttributeValue(value) {
    return value.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, '&amp;') // escape unescaped `&`
    .replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $fbd1e3bc010bc8c2$export$d27e3ef8781285da(html) {
    // Escape dangerous characters in attribute values
    // Process attributes with double quotes
    html = html.replace(/(\w+)\s*=\s*"([^"]*)"/g, (_, attrName, attrValue)=>`${attrName}="${$fbd1e3bc010bc8c2$var$escapeAttributeValue(attrValue)}"`);
    // Process attributes with single quotes
    html = html.replace(/(\w+)\s*=\s*'([^']*)'/g, (_, attrName, attrValue)=>`${attrName}='${$fbd1e3bc010bc8c2$var$escapeAttributeValue(attrValue)}'`);
    // Detect and neutralize event handler attributes
    const eventHandlerPattern = /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi;
    if (eventHandlerPattern.test(html)) // Neutralize event handler attributes by escaping 'on'
    html = html.replace(/(\s+)(on)(\w+\s*=)/gi, '$1&#111;n$3');
    // Disable javascript: URLs in various contexts
    const javascriptUrlPattern = [
        // In href, src, action, formaction attributes
        /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
        // In style attributes within url()
        /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
    ];
    javascriptUrlPattern.forEach((pattern)=>{
        html = html.replace(pattern, '$1javascript&#58;');
    });
    return html;
}
const $fbd1e3bc010bc8c2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $fbd1e3bc010bc8c2$export$b5a638e9b3fff9f3(obj, key) {
    return $fbd1e3bc010bc8c2$var$hasOwnProperty.call(obj, key);
}
/* eslint-enable */ /**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */ const $fbd1e3bc010bc8c2$export$43bee75e5e14138e = Array.isArray;
const $fbd1e3bc010bc8c2$export$f6e2535fb5126e54 = (val)=>typeof val === 'function';
const $fbd1e3bc010bc8c2$export$844ec244b1367d54 = (val)=>typeof val === 'string';
const $fbd1e3bc010bc8c2$export$f9ce7b637dfbe238 = (val)=>typeof val === 'boolean';
const $fbd1e3bc010bc8c2$export$a244864fd9645c7f = (val)=>typeof val === 'symbol';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === 'object';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fbd1e3bc010bc8c2$export$4369c812aac99591 = (val)=>{
    return $fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val) && $fbd1e3bc010bc8c2$export$f6e2535fb5126e54(val.then) && $fbd1e3bc010bc8c2$export$f6e2535fb5126e54(val.catch);
};
const $fbd1e3bc010bc8c2$export$830c053460e5ddf6 = Object.prototype.toString;
const $fbd1e3bc010bc8c2$export$1dccc787cc36538b = (value)=>$fbd1e3bc010bc8c2$export$830c053460e5ddf6.call(value);
const $fbd1e3bc010bc8c2$export$53b83ca8eaab0383 = (val)=>{
    if (!$fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val)) return false;
    const proto = Object.getPrototypeOf(val);
    return proto === null || proto.constructor === Object;
};
// for converting list and named values to displayed strings.
const $fbd1e3bc010bc8c2$export$b5b1545233b45293 = (val)=>{
    return val == null ? '' : $fbd1e3bc010bc8c2$export$43bee75e5e14138e(val) || $fbd1e3bc010bc8c2$export$53b83ca8eaab0383(val) && val.toString === $fbd1e3bc010bc8c2$export$830c053460e5ddf6 ? JSON.stringify(val, null, 2) : String(val);
};
function $fbd1e3bc010bc8c2$export$f7e2c8231c57a8bd(items, separator = '') {
    return items.reduce((str, item, index)=>index === 0 ? str + item : str + separator + item, '');
}
const $fbd1e3bc010bc8c2$var$RANGE = 2;
function $fbd1e3bc010bc8c2$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(let j = i - $fbd1e3bc010bc8c2$var$RANGE; j <= i + $fbd1e3bc010bc8c2$var$RANGE || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${' '.repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + ' '.repeat(pad) + '^'.repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + '^'.repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}
function $fbd1e3bc010bc8c2$export$47db5deb603dfca1(code) {
    let current = code;
    return ()=>++current;
}
/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */ /**
 * Create a event emitter
 *
 * @returns An event emitter
 */ function $fbd1e3bc010bc8c2$export$6f5e8f34570e3ad1() {
    const events = new Map();
    const emitter = {
        events: events,
        on (event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) events.set(event, [
                handler
            ]);
        },
        off (event, handler) {
            const handlers = events.get(event);
            if (handlers) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit (event, payload) {
            (events.get(event) || []).slice().map((handler)=>handler(payload));
            (events.get('*') || []).slice().map((handler)=>handler(event, payload));
        }
    };
    return emitter;
}
const $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray = (val)=>!$fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(val) || $fbd1e3bc010bc8c2$export$43bee75e5e14138e(val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $fbd1e3bc010bc8c2$export$6c40052bed430212(src, des) {
    // src and des should both be objects, and none of them can be a array
    if ($fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(src) || $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(des)) throw new Error('Invalid value');
    const stack = [
        {
            src: src,
            des: des
        }
    ];
    while(stack.length){
        const { src: src, des: des } = stack.pop();
        // using `Object.keys` which skips prototype properties
        Object.keys(src).forEach((key)=>{
            if (key === '__proto__') return;
            // if src[key] is an object/array, set des[key]
            // to empty object/array to prevent setting by reference
            if ($fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(src[key]) && !$fbd1e3bc010bc8c2$export$a6cdc56e425d0d0a(des[key])) des[key] = Array.isArray(src[key]) ? [] : $fbd1e3bc010bc8c2$export$185802fd694ee1f5();
            if ($fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(des[key]) || $fbd1e3bc010bc8c2$var$isNotObjectOrIsArray(src[key])) // replace with src[key] when:
            // src[key] or des[key] is not an object, or
            // src[key] or des[key] is an array
            des[key] = src[key];
            else // src[key] and des[key] are both objects, merge them
            stack.push({
                src: src[key],
                des: des[key]
            });
        });
    }
}

});

parcelRegister("f97E4", function(module, exports) {

$parcel$export(module.exports, "isMessageAST", () => $a739018d680a1535$export$9ba95744594b90e0);
$parcel$export(module.exports, "AST_NODE_PROPS_KEYS", () => $a739018d680a1535$export$cc9169d6f60edf74);
$parcel$export(module.exports, "resolveValue", () => $a739018d680a1535$export$d812c8e1906863d0);
$parcel$export(module.exports, "setDevToolsHook", () => $a739018d680a1535$export$c893d6c8966908b9);
$parcel$export(module.exports, "CoreWarnCodes", () => $a739018d680a1535$export$b6a676a18b27d4c8);
$parcel$export(module.exports, "CoreErrorCodes", () => $a739018d680a1535$export$1d4dfd6045c40277);
$parcel$export(module.exports, "fallbackWithLocaleChain", () => $a739018d680a1535$export$71df9db82dc445);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $a739018d680a1535$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "NOT_REOSLVED", () => $a739018d680a1535$export$b7f13a18d1d0f835);
$parcel$export(module.exports, "MISSING_RESOLVE_VALUE", () => $a739018d680a1535$export$a04371e9dbb3870b);
$parcel$export(module.exports, "registerMessageCompiler", () => $a739018d680a1535$export$6ee2fbe83628b40b);
$parcel$export(module.exports, "registerMessageResolver", () => $a739018d680a1535$export$45dacdc710815463);
$parcel$export(module.exports, "registerLocaleFallbacker", () => $a739018d680a1535$export$fd8ec9dd8067edec);
$parcel$export(module.exports, "setAdditionalMeta", () => $a739018d680a1535$export$605703447dca72aa);
$parcel$export(module.exports, "setFallbackContext", () => $a739018d680a1535$export$e16aca6786e72a5e);
$parcel$export(module.exports, "getFallbackContext", () => $a739018d680a1535$export$3adddc434faa9e35);
$parcel$export(module.exports, "createCoreContext", () => $a739018d680a1535$export$3599d465b05a74a5);
$parcel$export(module.exports, "updateFallbackLocale", () => $a739018d680a1535$export$c743ad8a3cc01530);
$parcel$export(module.exports, "compileToFunction", () => $a739018d680a1535$export$1ea8807c727891fc);
$parcel$export(module.exports, "compile", () => $a739018d680a1535$export$ef7acd7185315e22);
$parcel$export(module.exports, "isMessageFunction", () => $a739018d680a1535$export$92c0a039cf358271);
$parcel$export(module.exports, "translate", () => $a739018d680a1535$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "parseTranslateArgs", () => $a739018d680a1535$export$8d9616744e22681a);
$parcel$export(module.exports, "datetime", () => $a739018d680a1535$export$7ba4466dbd0f07e1);
$parcel$export(module.exports, "parseDateTimeArgs", () => $a739018d680a1535$export$165524b21a0d6b5e);
$parcel$export(module.exports, "DATETIME_FORMAT_OPTIONS_KEYS", () => $a739018d680a1535$export$c77049eaf05b1508);
$parcel$export(module.exports, "clearDateTimeFormat", () => $a739018d680a1535$export$5bc4fc7cf15d6ccd);
$parcel$export(module.exports, "number", () => $a739018d680a1535$export$98e628dec113755e);
$parcel$export(module.exports, "parseNumberArgs", () => $a739018d680a1535$export$d0e2eec8b686cf72);
$parcel$export(module.exports, "NUMBER_FORMAT_OPTIONS_KEYS", () => $a739018d680a1535$export$c39a7c3789c46ed6);
$parcel$export(module.exports, "clearNumberFormat", () => $a739018d680a1535$export$6a8717b3043a4f23);
$parcel$export(module.exports, "createCompileError", () => (parcelRequire("7yiTB")).createCompileError);
/*!
  * core-base v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $9QywT = parcelRequire("9QywT");

var $7yiTB = parcelRequire("7yiTB");
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $a739018d680a1535$var$initFeatureFlags() {
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== 'boolean') (0, $9QywT.getGlobalThis)().__INTLIFY_PROD_DEVTOOLS__ = false;
    if (typeof __INTLIFY_JIT_COMPILATION__ !== 'boolean') (0, $9QywT.getGlobalThis)().__INTLIFY_JIT_COMPILATION__ = false;
    if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== 'boolean') (0, $9QywT.getGlobalThis)().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
}
function $a739018d680a1535$export$9ba95744594b90e0(val) {
    return (0, $9QywT.isObject)(val) && $a739018d680a1535$var$resolveType(val) === 0 && ((0, $9QywT.hasOwn)(val, 'b') || (0, $9QywT.hasOwn)(val, 'body'));
}
const $a739018d680a1535$var$PROPS_BODY = [
    'b',
    'body'
];
function $a739018d680a1535$var$resolveBody(node) {
    return $a739018d680a1535$var$resolveProps(node, $a739018d680a1535$var$PROPS_BODY);
}
const $a739018d680a1535$var$PROPS_CASES = [
    'c',
    'cases'
];
function $a739018d680a1535$var$resolveCases(node) {
    return $a739018d680a1535$var$resolveProps(node, $a739018d680a1535$var$PROPS_CASES, []);
}
const $a739018d680a1535$var$PROPS_STATIC = [
    's',
    'static'
];
function $a739018d680a1535$var$resolveStatic(node) {
    return $a739018d680a1535$var$resolveProps(node, $a739018d680a1535$var$PROPS_STATIC);
}
const $a739018d680a1535$var$PROPS_ITEMS = [
    'i',
    'items'
];
function $a739018d680a1535$var$resolveItems(node) {
    return $a739018d680a1535$var$resolveProps(node, $a739018d680a1535$var$PROPS_ITEMS, []);
}
const $a739018d680a1535$var$PROPS_TYPE = [
    't',
    'type'
];
function $a739018d680a1535$var$resolveType(node) {
    return $a739018d680a1535$var$resolveProps(node, $a739018d680a1535$var$PROPS_TYPE);
}
const $a739018d680a1535$var$PROPS_VALUE = [
    'v',
    'value'
];
function $a739018d680a1535$var$resolveValue$1(node, type) {
    const resolved = $a739018d680a1535$var$resolveProps(node, $a739018d680a1535$var$PROPS_VALUE);
    if (resolved != null) return resolved;
    else throw $a739018d680a1535$var$createUnhandleNodeError(type);
}
const $a739018d680a1535$var$PROPS_MODIFIER = [
    'm',
    'modifier'
];
function $a739018d680a1535$var$resolveLinkedModifier(node) {
    return $a739018d680a1535$var$resolveProps(node, $a739018d680a1535$var$PROPS_MODIFIER);
}
const $a739018d680a1535$var$PROPS_KEY = [
    'k',
    'key'
];
function $a739018d680a1535$var$resolveLinkedKey(node) {
    const resolved = $a739018d680a1535$var$resolveProps(node, $a739018d680a1535$var$PROPS_KEY);
    if (resolved) return resolved;
    else throw $a739018d680a1535$var$createUnhandleNodeError(6 /* NodeTypes.Linked */ );
}
function $a739018d680a1535$var$resolveProps(node, props, defaultValue) {
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((0, $9QywT.hasOwn)(node, prop) && node[prop] != null) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return node[prop];
    }
    return defaultValue;
}
const $a739018d680a1535$export$cc9169d6f60edf74 = [
    ...$a739018d680a1535$var$PROPS_BODY,
    ...$a739018d680a1535$var$PROPS_CASES,
    ...$a739018d680a1535$var$PROPS_STATIC,
    ...$a739018d680a1535$var$PROPS_ITEMS,
    ...$a739018d680a1535$var$PROPS_KEY,
    ...$a739018d680a1535$var$PROPS_MODIFIER,
    ...$a739018d680a1535$var$PROPS_VALUE,
    ...$a739018d680a1535$var$PROPS_TYPE
];
function $a739018d680a1535$var$createUnhandleNodeError(type) {
    return new Error(`unhandled node type: ${type}`);
}
const $a739018d680a1535$var$pathStateMachine = [];
$a739018d680a1535$var$pathStateMachine[0 /* States.BEFORE_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        0 /* States.BEFORE_PATH */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[1 /* States.IN_PATH */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[2 /* States.BEFORE_IDENT */ ] = {
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        2 /* States.BEFORE_IDENT */ 
    ],
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[3 /* States.IN_IDENT */ ] = {
    ["i" /* PathCharTypes.IDENT */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["0" /* PathCharTypes.ZERO */ ]: [
        3 /* States.IN_IDENT */ ,
        0 /* Actions.APPEND */ 
    ],
    ["w" /* PathCharTypes.WORKSPACE */ ]: [
        1 /* States.IN_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["." /* PathCharTypes.DOT */ ]: [
        2 /* States.BEFORE_IDENT */ ,
        1 /* Actions.PUSH */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        1 /* Actions.PUSH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: [
        7 /* States.AFTER_PATH */ ,
        1 /* Actions.PUSH */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[4 /* States.IN_SUB_PATH */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ["\"" /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ],
    ["[" /* PathCharTypes.LEFT_BRACKET */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        2 /* Actions.INC_SUB_PATH_DEPTH */ 
    ],
    ["]" /* PathCharTypes.RIGHT_BRACKET */ ]: [
        1 /* States.IN_PATH */ ,
        3 /* Actions.PUSH_SUB_PATH */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[5 /* States.IN_SINGLE_QUOTE */ ] = {
    ["'" /* PathCharTypes.SINGLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        5 /* States.IN_SINGLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
$a739018d680a1535$var$pathStateMachine[6 /* States.IN_DOUBLE_QUOTE */ ] = {
    ["\"" /* PathCharTypes.DOUBLE_QUOTE */ ]: [
        4 /* States.IN_SUB_PATH */ ,
        0 /* Actions.APPEND */ 
    ],
    ["o" /* PathCharTypes.END_OF_FAIL */ ]: 8 /* States.ERROR */ ,
    ["l" /* PathCharTypes.ELSE */ ]: [
        6 /* States.IN_DOUBLE_QUOTE */ ,
        0 /* Actions.APPEND */ 
    ]
};
/**
 * Check if an expression is a literal value.
 */ const $a739018d680a1535$var$literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $a739018d680a1535$var$isLiteral(exp) {
    return $a739018d680a1535$var$literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */ function $a739018d680a1535$var$stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */ function $a739018d680a1535$var$getPathCharType(ch) {
    if (ch === undefined || ch === null) return "o" /* PathCharTypes.END_OF_FAIL */ ;
    const code = ch.charCodeAt(0);
    switch(code){
        case 0x5b:
        case 0x5d:
        case 0x2e:
        case 0x22:
        case 0x27:
            return ch;
        case 0x5f:
        case 0x24:
        case 0x2d:
            return "i" /* PathCharTypes.IDENT */ ;
        case 0x09:
        case 0x0a:
        case 0x0d:
        case 0xa0:
        case 0xfeff:
        case 0x2028:
        case 0x2029:
            return "w" /* PathCharTypes.WORKSPACE */ ;
    }
    return "i" /* PathCharTypes.IDENT */ ;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */ function $a739018d680a1535$var$formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === '0' && isNaN(parseInt(path))) return false;
    return $a739018d680a1535$var$isLiteral(trimmed) ? $a739018d680a1535$var$stripQuotes(trimmed) : "*" /* PathCharTypes.ASTARISK */  + trimmed;
}
/**
 * Parse a string path into an array of segments
 */ function $a739018d680a1535$export$98e6a39c04603d36(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* States.BEFORE_PATH */ ;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* Actions.APPEND */ ] = ()=>{
        if (key === undefined) key = newChar;
        else key += newChar;
    };
    actions[1 /* Actions.PUSH */ ] = ()=>{
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* Actions.INC_SUB_PATH_DEPTH */ ] = ()=>{
        actions[0 /* Actions.APPEND */ ]();
        subPathDepth++;
    };
    actions[3 /* Actions.PUSH_SUB_PATH */ ] = ()=>{
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* States.IN_SUB_PATH */ ;
            actions[0 /* Actions.APPEND */ ]();
        } else {
            subPathDepth = 0;
            if (key === undefined) return false;
            key = $a739018d680a1535$var$formatSubPath(key);
            if (key === false) return false;
            else actions[1 /* Actions.PUSH */ ]();
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if (mode === 5 /* States.IN_SINGLE_QUOTE */  && nextChar === "'" /* PathCharTypes.SINGLE_QUOTE */  || mode === 6 /* States.IN_DOUBLE_QUOTE */  && nextChar === "\"" /* PathCharTypes.DOUBLE_QUOTE */ ) {
            index++;
            newChar = '\\' + nextChar;
            actions[0 /* Actions.APPEND */ ]();
            return true;
        }
    }
    while(mode !== null){
        index++;
        c = path[index];
        if (c === '\\' && maybeUnescapeQuote()) continue;
        type = $a739018d680a1535$var$getPathCharType(c);
        typeMap = $a739018d680a1535$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* PathCharTypes.ELSE */ ] || 8 /* States.ERROR */ ;
        // check parse error
        if (transition === 8 /* States.ERROR */ ) return;
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) return;
            }
        }
        // check parse finish
        if (mode === 7 /* States.AFTER_PATH */ ) return keys;
    }
}
// path token cache
const $a739018d680a1535$var$cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$b365de4c3506886c(obj, path) {
    return (0, $9QywT.isObject)(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$d812c8e1906863d0(obj, path) {
    // check object
    if (!(0, $9QywT.isObject)(obj)) return null;
    // parse path
    let hit = $a739018d680a1535$var$cache.get(path);
    if (!hit) {
        hit = $a739018d680a1535$export$98e6a39c04603d36(path);
        if (hit) $a739018d680a1535$var$cache.set(path, hit);
    }
    // check hit
    if (!hit) return null;
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while(i < len){
        const key = hit[i];
        /**
         * NOTE:
         * if `key` is intlify message format AST node key and `last` is intlify message format AST, skip it.
         * because the AST node is not a key-value structure.
         */ if ($a739018d680a1535$export$cc9169d6f60edf74.includes(key) && $a739018d680a1535$export$9ba95744594b90e0(last)) return null;
        const val = last[key];
        if (val === undefined) return null;
        if ((0, $9QywT.isFunction)(last)) return null;
        last = val;
        i++;
    }
    return last;
}
const $a739018d680a1535$var$DEFAULT_MODIFIER = (str)=>str;
const $a739018d680a1535$var$DEFAULT_MESSAGE = (ctx)=>''; // eslint-disable-line
const $a739018d680a1535$export$12b53af6b8529bfc = 'text';
const $a739018d680a1535$var$DEFAULT_NORMALIZE = (values)=>values.length === 0 ? '' : (0, $9QywT.join)(values);
const $a739018d680a1535$var$DEFAULT_INTERPOLATE = (0, $9QywT.toDisplayString);
function $a739018d680a1535$var$pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) // prettier-ignore
    return choice ? choice > 1 ? 1 : 0 : 1;
    return choice ? Math.min(choice, 2) : 0;
}
function $a739018d680a1535$var$getPluralIndex(options) {
    // prettier-ignore
    const index = (0, $9QywT.isNumber)(options.pluralIndex) ? options.pluralIndex : -1;
    // prettier-ignore
    return options.named && ((0, $9QywT.isNumber)(options.named.count) || (0, $9QywT.isNumber)(options.named.n)) ? (0, $9QywT.isNumber)(options.named.count) ? options.named.count : (0, $9QywT.isNumber)(options.named.n) ? options.named.n : index : index;
}
function $a739018d680a1535$var$normalizeNamed(pluralIndex, props) {
    if (!props.count) props.count = pluralIndex;
    if (!props.n) props.n = pluralIndex;
}
function $a739018d680a1535$export$70de3b14beda2f5e(options = {}) {
    const locale = options.locale;
    const pluralIndex = $a739018d680a1535$var$getPluralIndex(options);
    const pluralRule = (0, $9QywT.isObject)(options.pluralRules) && (0, $9QywT.isString)(locale) && (0, $9QywT.isFunction)(options.pluralRules[locale]) ? options.pluralRules[locale] : $a739018d680a1535$var$pluralDefault;
    const orgPluralRule = (0, $9QywT.isObject)(options.pluralRules) && (0, $9QywT.isString)(locale) && (0, $9QywT.isFunction)(options.pluralRules[locale]) ? $a739018d680a1535$var$pluralDefault : undefined;
    const plural = (messages)=>{
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index)=>_list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || (0, $9QywT.create)();
    (0, $9QywT.isNumber)(options.pluralIndex) && $a739018d680a1535$var$normalizeNamed(pluralIndex, _named);
    const named = (key)=>_named[key];
    function message(key) {
        // prettier-ignore
        const msg = (0, $9QywT.isFunction)(options.messages) ? options.messages(key) : (0, $9QywT.isObject)(options.messages) ? options.messages[key] : false;
        return !msg ? options.parent ? options.parent.message(key) // resolve from parent messages
         : $a739018d680a1535$var$DEFAULT_MESSAGE : msg;
    }
    const _modifier = (name)=>options.modifiers ? options.modifiers[name] : $a739018d680a1535$var$DEFAULT_MODIFIER;
    const normalize = (0, $9QywT.isPlainObject)(options.processor) && (0, $9QywT.isFunction)(options.processor.normalize) ? options.processor.normalize : $a739018d680a1535$var$DEFAULT_NORMALIZE;
    const interpolate = (0, $9QywT.isPlainObject)(options.processor) && (0, $9QywT.isFunction)(options.processor.interpolate) ? options.processor.interpolate : $a739018d680a1535$var$DEFAULT_INTERPOLATE;
    const type = (0, $9QywT.isPlainObject)(options.processor) && (0, $9QywT.isString)(options.processor.type) ? options.processor.type : $a739018d680a1535$export$12b53af6b8529bfc;
    const linked = (key, ...args)=>{
        const [arg1, arg2] = args;
        let type = 'text';
        let modifier = '';
        if (args.length === 1) {
            if ((0, $9QywT.isObject)(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            } else if ((0, $9QywT.isString)(arg1)) modifier = arg1 || modifier;
        } else if (args.length === 2) {
            if ((0, $9QywT.isString)(arg1)) modifier = arg1 || modifier;
            if ((0, $9QywT.isString)(arg2)) type = arg2 || type;
        }
        const ret = message(key)(ctx);
        const msg = // The message in vnode resolved with linked are returned as an array by processor.nomalize
        type === 'vnode' && (0, $9QywT.isArray)(ret) && modifier ? ret[0] : ret;
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* HelperNameMap.LIST */ ]: list,
        ["named" /* HelperNameMap.NAMED */ ]: named,
        ["plural" /* HelperNameMap.PLURAL */ ]: plural,
        ["linked" /* HelperNameMap.LINKED */ ]: linked,
        ["message" /* HelperNameMap.MESSAGE */ ]: message,
        ["type" /* HelperNameMap.TYPE */ ]: type,
        ["interpolate" /* HelperNameMap.INTERPOLATE */ ]: interpolate,
        ["normalize" /* HelperNameMap.NORMALIZE */ ]: normalize,
        ["values" /* HelperNameMap.VALUES */ ]: (0, $9QywT.assign)((0, $9QywT.create)(), _list, _named)
    };
    return ctx;
}
let $a739018d680a1535$var$devtools = null;
function $a739018d680a1535$export$c893d6c8966908b9(hook) {
    $a739018d680a1535$var$devtools = hook;
}
function $a739018d680a1535$export$8bd08e70642dc6f4() {
    return $a739018d680a1535$var$devtools;
}
function $a739018d680a1535$export$725afc6a300324a0(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    $a739018d680a1535$var$devtools && $a739018d680a1535$var$devtools.emit("i18n:init" /* IntlifyDevToolsHooks.I18nInit */ , {
        timestamp: Date.now(),
        i18n: i18n,
        version: version,
        meta: meta
    });
}
const $a739018d680a1535$export$190d71a47ff3f767 = /* #__PURE__*/ $a739018d680a1535$var$createDevToolsHook("function:translate" /* IntlifyDevToolsHooks.FunctionTranslate */ );
function $a739018d680a1535$var$createDevToolsHook(hook) {
    return (payloads)=>$a739018d680a1535$var$devtools && $a739018d680a1535$var$devtools.emit(hook, payloads);
}
const $a739018d680a1535$var$code$1 = (0, $7yiTB.CompileWarnCodes).__EXTEND_POINT__;
const $a739018d680a1535$var$inc$1 = (0, $9QywT.incrementer)($a739018d680a1535$var$code$1);
const $a739018d680a1535$export$b6a676a18b27d4c8 = {
    NOT_FOUND_KEY: $a739018d680a1535$var$code$1,
    FALLBACK_TO_TRANSLATE: $a739018d680a1535$var$inc$1(),
    CANNOT_FORMAT_NUMBER: $a739018d680a1535$var$inc$1(),
    FALLBACK_TO_NUMBER_FORMAT: $a739018d680a1535$var$inc$1(),
    CANNOT_FORMAT_DATE: $a739018d680a1535$var$inc$1(),
    FALLBACK_TO_DATE_FORMAT: $a739018d680a1535$var$inc$1(),
    EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: $a739018d680a1535$var$inc$1(),
    __EXTEND_POINT__: $a739018d680a1535$var$inc$1() // 9
};
/** @internal */ const $a739018d680a1535$var$warnMessages = {
    [$a739018d680a1535$export$b6a676a18b27d4c8.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`,
    [$a739018d680a1535$export$b6a676a18b27d4c8.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: `This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.`
};
function $a739018d680a1535$export$ae7a7631f2b2bb7(code, ...args) {
    return (0, $9QywT.format)($a739018d680a1535$var$warnMessages[code], ...args);
}
const $a739018d680a1535$var$code = (0, $7yiTB.CompileErrorCodes).__EXTEND_POINT__;
const $a739018d680a1535$var$inc = (0, $9QywT.incrementer)($a739018d680a1535$var$code);
const $a739018d680a1535$export$1d4dfd6045c40277 = {
    INVALID_ARGUMENT: $a739018d680a1535$var$code,
    INVALID_DATE_ARGUMENT: $a739018d680a1535$var$inc(),
    INVALID_ISO_DATE_ARGUMENT: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_NON_STRING_MESSAGE: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_PROMISE_VALUE: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: $a739018d680a1535$var$inc(),
    NOT_SUPPORT_LOCALE_TYPE: $a739018d680a1535$var$inc(),
    __EXTEND_POINT__: $a739018d680a1535$var$inc() // 24
};
function $a739018d680a1535$export$3d702f7ac45b0a6b(code) {
    return (0, $7yiTB.createCompileError)(code, null, undefined);
}
/** @internal */ const $a739018d680a1535$var$errorMessages = {
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT]: 'Invalid arguments',
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
    [$a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT]: 'The argument provided is not a valid ISO date string',
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE]: 'Not support non-string message',
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: 'cannot support promise value',
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: 'cannot support async function',
    [$a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE]: 'cannot support locale type'
};
/** @internal */ function $a739018d680a1535$export$180605366c04f0cd(context, options) {
    return options.locale != null ? $a739018d680a1535$export$df9bcabe7f932e01(options.locale) : $a739018d680a1535$export$df9bcabe7f932e01(context.locale);
}
let $a739018d680a1535$var$_resolveLocale;
/** @internal */ function $a739018d680a1535$export$df9bcabe7f932e01(locale) {
    if ((0, $9QywT.isString)(locale)) return locale;
    else {
        if ((0, $9QywT.isFunction)(locale)) {
            if (locale.resolvedOnce && $a739018d680a1535$var$_resolveLocale != null) return $a739018d680a1535$var$_resolveLocale;
            else if (locale.constructor.name === 'Function') {
                const resolve = locale();
                if ((0, $9QywT.isPromise)(resolve)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
                return $a739018d680a1535$var$_resolveLocale = resolve;
            } else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
        } else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_LOCALE_TYPE);
    }
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$e3330076537ef9d1(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return [
        ...new Set([
            start,
            ...(0, $9QywT.isArray)(fallback) ? fallback : (0, $9QywT.isObject)(fallback) ? Object.keys(fallback) : (0, $9QywT.isString)(fallback) ? [
                fallback
            ] : [
                start
            ]
        ])
    ];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$71df9db82dc445(ctx, fallback, start) {
    const startLocale = (0, $9QywT.isString)(start) ? start : $a739018d680a1535$export$1af4c7e47ad72f44;
    const context = ctx;
    if (!context.__localeChainCache) context.__localeChainCache = new Map();
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [
            start
        ];
        // while any intervening block found
        while((0, $9QywT.isArray)(block))block = $a739018d680a1535$var$appendBlockToChain(chain, block, fallback);
        // prettier-ignore
        // last block defined by default
        const defaults = (0, $9QywT.isArray)(fallback) || !(0, $9QywT.isPlainObject)(fallback) ? fallback : fallback['default'] ? fallback['default'] : null;
        // convert defaults to array
        block = (0, $9QywT.isString)(defaults) ? [
            defaults
        ] : defaults;
        if ((0, $9QywT.isArray)(block)) $a739018d680a1535$var$appendBlockToChain(chain, block, false);
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function $a739018d680a1535$var$appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for(let i = 0; i < block.length && (0, $9QywT.isBoolean)(follow); i++){
        const locale = block[i];
        if ((0, $9QywT.isString)(locale)) follow = $a739018d680a1535$var$appendLocaleToChain(chain, block[i], blocks);
    }
    return follow;
}
function $a739018d680a1535$var$appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split('-');
    do {
        const target = tokens.join('-');
        follow = $a739018d680a1535$var$appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    }while (tokens.length && follow === true);
    return follow;
}
function $a739018d680a1535$var$appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== '!';
            const locale = target.replace(/!/g, '');
            chain.push(locale);
            if (((0, $9QywT.isArray)(blocks) || (0, $9QywT.isPlainObject)(blocks)) && blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            follow = blocks[locale];
        }
    }
    return follow;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Intlify core-base version
 * @internal
 */ const $a739018d680a1535$export$a4ad2735b021c132 = '9.14.5';
const $a739018d680a1535$export$b7f13a18d1d0f835 = -1;
const $a739018d680a1535$export$1af4c7e47ad72f44 = 'en-US';
const $a739018d680a1535$export$a04371e9dbb3870b = '';
const $a739018d680a1535$var$capitalize = (str)=>`${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function $a739018d680a1535$var$getDefaultLinkedModifiers() {
    return {
        upper: (val, type)=>{
            // prettier-ignore
            return type === 'text' && (0, $9QywT.isString)(val) ? val.toUpperCase() : type === 'vnode' && (0, $9QywT.isObject)(val) && '__v_isVNode' in val ? val.children.toUpperCase() : val;
        },
        lower: (val, type)=>{
            // prettier-ignore
            return type === 'text' && (0, $9QywT.isString)(val) ? val.toLowerCase() : type === 'vnode' && (0, $9QywT.isObject)(val) && '__v_isVNode' in val ? val.children.toLowerCase() : val;
        },
        capitalize: (val, type)=>{
            // prettier-ignore
            return type === 'text' && (0, $9QywT.isString)(val) ? $a739018d680a1535$var$capitalize(val) : type === 'vnode' && (0, $9QywT.isObject)(val) && '__v_isVNode' in val ? $a739018d680a1535$var$capitalize(val.children) : val;
        }
    };
}
let $a739018d680a1535$var$_compiler;
function $a739018d680a1535$export$6ee2fbe83628b40b(compiler) {
    $a739018d680a1535$var$_compiler = compiler;
}
let $a739018d680a1535$var$_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$45dacdc710815463(resolver) {
    $a739018d680a1535$var$_resolver = resolver;
}
let $a739018d680a1535$var$_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */ function $a739018d680a1535$export$fd8ec9dd8067edec(fallbacker) {
    $a739018d680a1535$var$_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let $a739018d680a1535$var$_additionalMeta = null;
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$605703447dca72aa = (meta)=>{
    $a739018d680a1535$var$_additionalMeta = meta;
};
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$817795a14e5c6622 = ()=>$a739018d680a1535$var$_additionalMeta;
let $a739018d680a1535$var$_fallbackContext = null;
const $a739018d680a1535$export$e16aca6786e72a5e = (context)=>{
    $a739018d680a1535$var$_fallbackContext = context;
};
const $a739018d680a1535$export$3adddc434faa9e35 = ()=>$a739018d680a1535$var$_fallbackContext;
// ID for CoreContext
let $a739018d680a1535$var$_cid = 0;
function $a739018d680a1535$export$3599d465b05a74a5(options = {}) {
    // setup options
    const onWarn = (0, $9QywT.isFunction)(options.onWarn) ? options.onWarn : (0, $9QywT.warn);
    const version = (0, $9QywT.isString)(options.version) ? options.version : $a739018d680a1535$export$a4ad2735b021c132;
    const locale = (0, $9QywT.isString)(options.locale) || (0, $9QywT.isFunction)(options.locale) ? options.locale : $a739018d680a1535$export$1af4c7e47ad72f44;
    const _locale = (0, $9QywT.isFunction)(locale) ? $a739018d680a1535$export$1af4c7e47ad72f44 : locale;
    const fallbackLocale = (0, $9QywT.isArray)(options.fallbackLocale) || (0, $9QywT.isPlainObject)(options.fallbackLocale) || (0, $9QywT.isString)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale;
    const messages = (0, $9QywT.isPlainObject)(options.messages) ? options.messages : $a739018d680a1535$var$createResources(_locale);
    const datetimeFormats = (0, $9QywT.isPlainObject)(options.datetimeFormats) ? options.datetimeFormats : $a739018d680a1535$var$createResources(_locale);
    const numberFormats = (0, $9QywT.isPlainObject)(options.numberFormats) ? options.numberFormats : $a739018d680a1535$var$createResources(_locale);
    const modifiers = (0, $9QywT.assign)((0, $9QywT.create)(), options.modifiers, $a739018d680a1535$var$getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || (0, $9QywT.create)();
    const missing = (0, $9QywT.isFunction)(options.missing) ? options.missing : null;
    const missingWarn = (0, $9QywT.isBoolean)(options.missingWarn) || (0, $9QywT.isRegExp)(options.missingWarn) ? options.missingWarn : true;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.fallbackWarn) || (0, $9QywT.isRegExp)(options.fallbackWarn) ? options.fallbackWarn : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = (0, $9QywT.isFunction)(options.postTranslation) ? options.postTranslation : null;
    const processor = (0, $9QywT.isPlainObject)(options.processor) ? options.processor : null;
    const warnHtmlMessage = (0, $9QywT.isBoolean)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = (0, $9QywT.isFunction)(options.messageCompiler) ? options.messageCompiler : $a739018d680a1535$var$_compiler;
    const messageResolver = (0, $9QywT.isFunction)(options.messageResolver) ? options.messageResolver : $a739018d680a1535$var$_resolver || $a739018d680a1535$export$b365de4c3506886c;
    const localeFallbacker = (0, $9QywT.isFunction)(options.localeFallbacker) ? options.localeFallbacker : $a739018d680a1535$var$_fallbacker || $a739018d680a1535$export$e3330076537ef9d1;
    const fallbackContext = (0, $9QywT.isObject)(options.fallbackContext) ? options.fallbackContext : undefined;
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = (0, $9QywT.isObject)(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : new Map();
    const __numberFormatters = (0, $9QywT.isObject)(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : new Map();
    const __meta = (0, $9QywT.isObject)(internalOptions.__meta) ? internalOptions.__meta : {};
    $a739018d680a1535$var$_cid++;
    const context = {
        version: version,
        cid: $a739018d680a1535$var$_cid,
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        modifiers: modifiers,
        pluralRules: pluralRules,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackFormat: fallbackFormat,
        unresolving: unresolving,
        postTranslation: postTranslation,
        processor: processor,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageCompiler: messageCompiler,
        messageResolver: messageResolver,
        localeFallbacker: localeFallbacker,
        fallbackContext: fallbackContext,
        onWarn: onWarn,
        __meta: __meta
    };
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) $a739018d680a1535$export$725afc6a300324a0(context, version, __meta);
    return context;
}
const $a739018d680a1535$var$createResources = (locale)=>({
        [locale]: (0, $9QywT.create)()
    });
/** @internal */ function $a739018d680a1535$export$d9435df38da77a63(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */ function $a739018d680a1535$export$e419d347a4a2eb71(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */ function $a739018d680a1535$export$bc779048ece0c567(context, key, locale, missingWarn, type) {
    const { missing: missing, onWarn: onWarn } = context;
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return (0, $9QywT.isString)(ret) ? ret : key;
    } else return key;
}
/** @internal */ function $a739018d680a1535$export$c743ad8a3cc01530(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/** @internal */ function $a739018d680a1535$export$59f8e8904fd79a18(locale, compareLocale) {
    if (locale === compareLocale) return false;
    return locale.split('-')[0] === compareLocale.split('-')[0];
}
/** @internal */ function $a739018d680a1535$export$d783301aca6271c3(targetLocale, locales) {
    const index = locales.indexOf(targetLocale);
    if (index === -1) return false;
    for(let i = index + 1; i < locales.length; i++){
        if ($a739018d680a1535$export$59f8e8904fd79a18(targetLocale, locales[i])) return true;
    }
    return false;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ function $a739018d680a1535$var$format(ast) {
    const msg = (ctx)=>$a739018d680a1535$var$formatParts(ctx, ast);
    return msg;
}
function $a739018d680a1535$var$formatParts(ctx, ast) {
    const body = $a739018d680a1535$var$resolveBody(ast);
    if (body == null) throw $a739018d680a1535$var$createUnhandleNodeError(0 /* NodeTypes.Resource */ );
    const type = $a739018d680a1535$var$resolveType(body);
    if (type === 1 /* NodeTypes.Plural */ ) {
        const plural = body;
        const cases = $a739018d680a1535$var$resolveCases(plural);
        return ctx.plural(cases.reduce((messages, c)=>[
                ...messages,
                $a739018d680a1535$var$formatMessageParts(ctx, c)
            ], []));
    } else return $a739018d680a1535$var$formatMessageParts(ctx, body);
}
function $a739018d680a1535$var$formatMessageParts(ctx, node) {
    const static_ = $a739018d680a1535$var$resolveStatic(node);
    if (static_ != null) return ctx.type === 'text' ? static_ : ctx.normalize([
        static_
    ]);
    else {
        const messages = $a739018d680a1535$var$resolveItems(node).reduce((acm, c)=>[
                ...acm,
                $a739018d680a1535$var$formatMessagePart(ctx, c)
            ], []);
        return ctx.normalize(messages);
    }
}
function $a739018d680a1535$var$formatMessagePart(ctx, node) {
    const type = $a739018d680a1535$var$resolveType(node);
    switch(type){
        case 3 /* NodeTypes.Text */ :
            return $a739018d680a1535$var$resolveValue$1(node, type);
        case 9 /* NodeTypes.Literal */ :
            return $a739018d680a1535$var$resolveValue$1(node, type);
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                if ((0, $9QywT.hasOwn)(named, 'k') && named.k) return ctx.interpolate(ctx.named(named.k));
                if ((0, $9QywT.hasOwn)(named, 'key') && named.key) return ctx.interpolate(ctx.named(named.key));
                throw $a739018d680a1535$var$createUnhandleNodeError(type);
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                if ((0, $9QywT.hasOwn)(list, 'i') && (0, $9QywT.isNumber)(list.i)) return ctx.interpolate(ctx.list(list.i));
                if ((0, $9QywT.hasOwn)(list, 'index') && (0, $9QywT.isNumber)(list.index)) return ctx.interpolate(ctx.list(list.index));
                throw $a739018d680a1535$var$createUnhandleNodeError(type);
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                const modifier = $a739018d680a1535$var$resolveLinkedModifier(linked);
                const key = $a739018d680a1535$var$resolveLinkedKey(linked);
                return ctx.linked($a739018d680a1535$var$formatMessagePart(ctx, key), modifier ? $a739018d680a1535$var$formatMessagePart(ctx, modifier) : undefined, ctx.type);
            }
        case 7 /* NodeTypes.LinkedKey */ :
            return $a739018d680a1535$var$resolveValue$1(node, type);
        case 8 /* NodeTypes.LinkedModifier */ :
            return $a739018d680a1535$var$resolveValue$1(node, type);
        default:
            throw new Error(`unhandled node on format message part: ${type}`);
    }
}
const $a739018d680a1535$var$WARN_MESSAGE = `Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`;
function $a739018d680a1535$var$checkHtmlMessage(source, warnHtmlMessage) {
    if (warnHtmlMessage && (0, $7yiTB.detectHtmlTag)(source)) (0, $9QywT.warn)((0, $9QywT.format)($a739018d680a1535$var$WARN_MESSAGE, {
        source: source
    }));
}
const $a739018d680a1535$var$defaultOnCacheKey = (message)=>message;
let $a739018d680a1535$var$compileCache = (0, $9QywT.create)();
function $a739018d680a1535$var$onCompileWarn(_warn) {
    if (_warn.code === (0, $7yiTB.CompileWarnCodes).USE_MODULO_SYNTAX) (0, $9QywT.warn)(`The use of named interpolation with modulo syntax is deprecated. ` + `It will be removed in v10.\n` + `reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format \n` + `(message compiler warning message: ${_warn.message})`);
}
function $a739018d680a1535$export$2683c80ae3fe544() {
    $a739018d680a1535$var$compileCache = (0, $9QywT.create)();
}
function $a739018d680a1535$var$baseCompile(message, options = {}) {
    // error detecting on compile
    let detectError = false;
    const onError = options.onError || (0, $7yiTB.defaultOnError);
    options.onError = (err)=>{
        detectError = true;
        onError(err);
    };
    // compile with mesasge-compiler
    return {
        ...(0, $7yiTB.baseCompile)(message, options),
        detectError: detectError
    };
}
/* #__NO_SIDE_EFFECTS__ */ const $a739018d680a1535$export$1ea8807c727891fc = (message, context)=>{
    if (!(0, $9QywT.isString)(message)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.NOT_SUPPORT_NON_STRING_MESSAGE);
    {
        // check HTML message
        const warnHtmlMessage = (0, $9QywT.isBoolean)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        // check caches
        const onCacheKey = context.onCacheKey || $a739018d680a1535$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $a739018d680a1535$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile
        const { code: code, detectError: detectError } = $a739018d680a1535$var$baseCompile(message, context);
        // evaluate function
        const msg = new Function(`return ${code}`)();
        // if occurred compile error, don't cache
        return !detectError ? $a739018d680a1535$var$compileCache[cacheKey] = msg : msg;
    }
};
function $a739018d680a1535$export$ef7acd7185315e22(message, context) {
    if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && (0, $9QywT.isString)(message)) {
        // check HTML message
        const warnHtmlMessage = (0, $9QywT.isBoolean)(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
        // check caches
        const onCacheKey = context.onCacheKey || $a739018d680a1535$var$defaultOnCacheKey;
        const cacheKey = onCacheKey(message);
        const cached = $a739018d680a1535$var$compileCache[cacheKey];
        if (cached) return cached;
        // compile with JIT mode
        const { ast: ast, detectError: detectError } = $a739018d680a1535$var$baseCompile(message, {
            ...context,
            location: false,
            jit: true
        });
        // compose message function from AST
        const msg = $a739018d680a1535$var$format(ast);
        // if occurred compile error, don't cache
        return !detectError ? $a739018d680a1535$var$compileCache[cacheKey] = msg : msg;
    } else {
        // AST case (passed from bundler)
        const cacheKey = message.cacheKey;
        if (cacheKey) {
            const cached = $a739018d680a1535$var$compileCache[cacheKey];
            if (cached) return cached;
            // compose message function from message (AST)
            return $a739018d680a1535$var$compileCache[cacheKey] = $a739018d680a1535$var$format(message);
        } else return $a739018d680a1535$var$format(message);
    }
}
const $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION = ()=>'';
const $a739018d680a1535$export$92c0a039cf358271 = (val)=>(0, $9QywT.isFunction)(val);
// implementation of `translate` function
function $a739018d680a1535$export$d73ee8ef04f5226a(context, ...args) {
    const { fallbackFormat: fallbackFormat, postTranslation: postTranslation, unresolving: unresolving, messageCompiler: messageCompiler, fallbackLocale: fallbackLocale, messages: messages } = context;
    const [key, options] = $a739018d680a1535$export$8d9616744e22681a(...args);
    const missingWarn = (0, $9QywT.isBoolean)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const escapeParameter = (0, $9QywT.isBoolean)(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = (0, $9QywT.isString)(options.default) || (0, $9QywT.isBoolean)(options.default) // default by function option
     ? !(0, $9QywT.isBoolean)(options.default) ? options.default : !messageCompiler ? ()=>key : key : fallbackFormat // default by `fallbackFormat` option
     ? !messageCompiler ? ()=>key : key : '';
    const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== '';
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    // escape params
    escapeParameter && $a739018d680a1535$var$escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage ? $a739018d680a1535$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
        key,
        locale,
        messages[locale] || (0, $9QywT.create)()
    ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage && !((0, $9QywT.isString)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage && (!((0, $9QywT.isString)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format)) || !(0, $9QywT.isString)(targetLocale))) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    // setup compile error detecting
    let occurred = false;
    const onError = ()=>{
        occurred = true;
    };
    // compile message format
    const msg = !$a739018d680a1535$export$92c0a039cf358271(format) ? $a739018d680a1535$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) : format;
    // if occurred compile error, return the message format
    if (occurred) return format;
    // evaluate message with context
    const ctxOptions = $a739018d680a1535$var$getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = $a739018d680a1535$export$70de3b14beda2f5e(ctxOptions);
    const messaged = $a739018d680a1535$var$evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    let ret = postTranslation ? postTranslation(messaged, key) : messaged;
    // apply HTML sanitization for security
    if (escapeParameter && (0, $9QywT.isString)(ret)) ret = (0, $9QywT.sanitizeTranslatedHtml)(ret);
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: (0, $9QywT.isString)(key) ? key : $a739018d680a1535$export$92c0a039cf358271(format) ? format.key : '',
            locale: targetLocale || ($a739018d680a1535$export$92c0a039cf358271(format) ? format.locale : ''),
            format: (0, $9QywT.isString)(format) ? format : $a739018d680a1535$export$92c0a039cf358271(format) ? format.source : '',
            message: ret
        };
        payloads.meta = (0, $9QywT.assign)({}, context.__meta, $a739018d680a1535$export$817795a14e5c6622() || {});
        $a739018d680a1535$export$190d71a47ff3f767(payloads);
    }
    return ret;
}
function $a739018d680a1535$var$escapeParams(options) {
    if ((0, $9QywT.isArray)(options.list)) options.list = options.list.map((item)=>(0, $9QywT.isString)(item) ? (0, $9QywT.escapeHtml)(item) : item);
    else if ((0, $9QywT.isObject)(options.named)) Object.keys(options.named).forEach((key)=>{
        if ((0, $9QywT.isString)(options.named[key])) options.named[key] = (0, $9QywT.escapeHtml)(options.named[key]);
    });
}
function $a739018d680a1535$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages: messages, onWarn: onWarn, messageResolver: resolveValue, localeFallbacker: localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = (0, $9QywT.create)();
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'translate';
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        message = messages[targetLocale] || (0, $9QywT.create)();
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if ((format = resolveValue(message, key)) === null) // if null, resolve with object key path
        format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        if ((0, $9QywT.isString)(format) || $a739018d680a1535$export$9ba95744594b90e0(format) || $a739018d680a1535$export$92c0a039cf358271(format)) break;
        if (!$a739018d680a1535$export$d783301aca6271c3(targetLocale, locales)) {
            const missingRet = $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type);
            if (missingRet !== key) format = missingRet;
        }
        from = to;
    }
    return [
        format,
        targetLocale,
        message
    ];
}
function $a739018d680a1535$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, onError) {
    const { messageCompiler: messageCompiler, warnHtmlMessage: warnHtmlMessage } = context;
    if ($a739018d680a1535$export$92c0a039cf358271(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = ()=>format;
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const msg = messageCompiler(format, $a739018d680a1535$var$getCompileContext(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, onError));
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function $a739018d680a1535$var$evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const messaged = msg(msgCtx);
    return messaged;
}
/** @internal */ function $a739018d680a1535$export$8d9616744e22681a(...args) {
    const [arg1, arg2, arg3] = args;
    const options = (0, $9QywT.create)();
    if (!(0, $9QywT.isString)(arg1) && !(0, $9QywT.isNumber)(arg1) && !$a739018d680a1535$export$92c0a039cf358271(arg1) && !$a739018d680a1535$export$9ba95744594b90e0(arg1)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    // prettier-ignore
    const key = (0, $9QywT.isNumber)(arg1) ? String(arg1) : $a739018d680a1535$export$92c0a039cf358271(arg1) ? arg1 : arg1;
    if ((0, $9QywT.isNumber)(arg2)) options.plural = arg2;
    else if ((0, $9QywT.isString)(arg2)) options.default = arg2;
    else if ((0, $9QywT.isPlainObject)(arg2) && !(0, $9QywT.isEmptyObject)(arg2)) options.named = arg2;
    else if ((0, $9QywT.isArray)(arg2)) options.list = arg2;
    if ((0, $9QywT.isNumber)(arg3)) options.plural = arg3;
    else if ((0, $9QywT.isString)(arg3)) options.default = arg3;
    else if ((0, $9QywT.isPlainObject)(arg3)) (0, $9QywT.assign)(options, arg3);
    return [
        key,
        options
    ];
}
function $a739018d680a1535$var$getCompileContext(context, locale, key, source, warnHtmlMessage, onError) {
    return {
        locale: locale,
        key: key,
        warnHtmlMessage: warnHtmlMessage,
        onError: (err)=>{
            onError && onError(err);
            throw err;
        },
        onCacheKey: (source)=>(0, $9QywT.generateFormatCacheKey)(locale, key, source)
    };
}
function $a739018d680a1535$var$getSourceForCodeFrame(source) {
    if ((0, $9QywT.isString)(source)) return source;
    else {
        if (source.loc && source.loc.source) return source.loc.source;
    }
}
function $a739018d680a1535$var$getMessageContextOptions(context, locale, message, options) {
    const { modifiers: modifiers, pluralRules: pluralRules, messageResolver: resolveValue, fallbackLocale: fallbackLocale, fallbackWarn: fallbackWarn, missingWarn: missingWarn, fallbackContext: fallbackContext } = context;
    const resolveMessage = (key)=>{
        let val = resolveValue(message, key);
        // fallback to root context
        if (val == null && fallbackContext) {
            const [, , message] = $a739018d680a1535$var$resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if ((0, $9QywT.isString)(val) || $a739018d680a1535$export$9ba95744594b90e0(val)) {
            let occurred = false;
            const onError = ()=>{
                occurred = true;
            };
            const msg = $a739018d680a1535$var$compileMessageFormat(context, key, locale, val, key, onError);
            return !occurred ? msg : $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION;
        } else if ($a739018d680a1535$export$92c0a039cf358271(val)) return val;
        else // TODO: should be implemented warning message
        return $a739018d680a1535$var$NOOP_MESSAGE_FUNCTION;
    };
    const ctxOptions = {
        locale: locale,
        modifiers: modifiers,
        pluralRules: pluralRules,
        messages: resolveMessage
    };
    if (context.processor) ctxOptions.processor = context.processor;
    if (options.list) ctxOptions.list = options.list;
    if (options.named) ctxOptions.named = options.named;
    if ((0, $9QywT.isNumber)(options.plural)) ctxOptions.pluralIndex = options.plural;
    return ctxOptions;
}
const $a739018d680a1535$var$intlDefined = typeof Intl !== 'undefined';
const $a739018d680a1535$var$Availabilities = {
    dateTimeFormat: $a739018d680a1535$var$intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
    numberFormat: $a739018d680a1535$var$intlDefined && typeof Intl.NumberFormat !== 'undefined'
};
// implementation of `datetime` function
function $a739018d680a1535$export$7ba4466dbd0f07e1(context, ...args) {
    const { datetimeFormats: datetimeFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __datetimeFormatters: __datetimeFormatters } = context;
    const [key, value, options, overrides] = $a739018d680a1535$export$165524b21a0d6b5e(...args);
    const missingWarn = (0, $9QywT.isBoolean)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $9QywT.isString)(key) || key === '') return new Intl.DateTimeFormat(locale, overrides).format(value);
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'datetime format';
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        datetimeFormat = datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if ((0, $9QywT.isPlainObject)(format)) break;
        $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $9QywT.isPlainObject)(format) || !(0, $9QywT.isString)(targetLocale)) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $9QywT.isEmptyObject)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, (0, $9QywT.assign)({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $a739018d680a1535$export$c77049eaf05b1508 = [
    'localeMatcher',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'formatMatcher',
    'hour12',
    'timeZone',
    'dateStyle',
    'timeStyle',
    'calendar',
    'dayPeriod',
    'numberingSystem',
    'hourCycle',
    'fractionalSecondDigits'
];
/** @internal */ function $a739018d680a1535$export$165524b21a0d6b5e(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = (0, $9QywT.create)();
    let overrides = (0, $9QywT.create)();
    let value;
    if ((0, $9QywT.isString)(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3] ? matches[3].trim().startsWith('T') ? `${matches[1].trim()}${matches[3].trim()}` : `${matches[1].trim()}T${matches[3].trim()}` : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        } catch (e) {
            throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        }
    } else if ((0, $9QywT.isDate)(arg1)) {
        if (isNaN(arg1.getTime())) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT);
        value = arg1;
    } else if ((0, $9QywT.isNumber)(arg1)) value = arg1;
    else throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    if ((0, $9QywT.isString)(arg2)) options.key = arg2;
    else if ((0, $9QywT.isPlainObject)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($a739018d680a1535$export$c77049eaf05b1508.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $9QywT.isString)(arg3)) options.locale = arg3;
    else if ((0, $9QywT.isPlainObject)(arg3)) overrides = arg3;
    if ((0, $9QywT.isPlainObject)(arg4)) overrides = arg4;
    return [
        options.key || '',
        value,
        options,
        overrides
    ];
}
/** @internal */ function $a739018d680a1535$export$5bc4fc7cf15d6ccd(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) continue;
        context.__datetimeFormatters.delete(id);
    }
}
// implementation of `number` function
function $a739018d680a1535$export$98e628dec113755e(context, ...args) {
    const { numberFormats: numberFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __numberFormatters: __numberFormatters } = context;
    const [key, value, options, overrides] = $a739018d680a1535$export$d0e2eec8b686cf72(...args);
    const missingWarn = (0, $9QywT.isBoolean)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $9QywT.isBoolean)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = $a739018d680a1535$export$180605366c04f0cd(context, options);
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $9QywT.isString)(key) || key === '') return new Intl.NumberFormat(locale, overrides).format(value);
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = 'number format';
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        numberFormat = numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if ((0, $9QywT.isPlainObject)(format)) break;
        $a739018d680a1535$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $9QywT.isPlainObject)(format) || !(0, $9QywT.isString)(targetLocale)) return unresolving ? $a739018d680a1535$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $9QywT.isEmptyObject)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, (0, $9QywT.assign)({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $a739018d680a1535$export$c39a7c3789c46ed6 = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'currencySign',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    'compactDisplay',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'roundingMode',
    'roundingPriority',
    'roundingIncrement',
    'trailingZeroDisplay'
];
/** @internal */ function $a739018d680a1535$export$d0e2eec8b686cf72(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = (0, $9QywT.create)();
    let overrides = (0, $9QywT.create)();
    if (!(0, $9QywT.isNumber)(arg1)) throw $a739018d680a1535$export$3d702f7ac45b0a6b($a739018d680a1535$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    const value = arg1;
    if ((0, $9QywT.isString)(arg2)) options.key = arg2;
    else if ((0, $9QywT.isPlainObject)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($a739018d680a1535$export$c39a7c3789c46ed6.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $9QywT.isString)(arg3)) options.locale = arg3;
    else if ((0, $9QywT.isPlainObject)(arg3)) overrides = arg3;
    if ((0, $9QywT.isPlainObject)(arg4)) overrides = arg4;
    return [
        options.key || '',
        value,
        options,
        overrides
    ];
}
/** @internal */ function $a739018d680a1535$export$6a8717b3043a4f23(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) continue;
        context.__numberFormatters.delete(id);
    }
}
$a739018d680a1535$var$initFeatureFlags();

});
parcelRegister("7yiTB", function(module, exports) {

$parcel$export(module.exports, "CompileWarnCodes", () => $b46efaa99568cb1e$export$21499b937901db8a);
$parcel$export(module.exports, "CompileErrorCodes", () => $b46efaa99568cb1e$export$77436aae039469c4);
$parcel$export(module.exports, "createCompileError", () => $b46efaa99568cb1e$export$21efa8bb37d5fecb);
$parcel$export(module.exports, "defaultOnError", () => $b46efaa99568cb1e$export$ad0eb2c702f03471);
$parcel$export(module.exports, "detectHtmlTag", () => $b46efaa99568cb1e$export$6de85467cbd6ae39);
$parcel$export(module.exports, "baseCompile", () => $b46efaa99568cb1e$export$3243579822c486a0);
/*!
  * message-compiler v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $9QywT = parcelRequire("9QywT");
const $b46efaa99568cb1e$export$7119efed969a17d8 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $b46efaa99568cb1e$export$edb4795983846c10(line, column, offset) {
    return {
        line: line,
        column: column,
        offset: offset
    };
}
function $b46efaa99568cb1e$export$90c043f1c57770b8(start, end, source) {
    const loc = {
        start: start,
        end: end
    };
    if (source != null) loc.source = source;
    return loc;
}
const $b46efaa99568cb1e$export$21499b937901db8a = {
    USE_MODULO_SYNTAX: 1,
    __EXTEND_POINT__: 2
};
/** @internal */ const $b46efaa99568cb1e$export$a9ce0120dbc716f9 = {
    [$b46efaa99568cb1e$export$21499b937901db8a.USE_MODULO_SYNTAX]: `Use modulo before '{{0}}'.`
};
function $b46efaa99568cb1e$export$b5ca1ea40a366b08(code, loc, ...args) {
    const msg = code;
    const message = {
        message: String(msg),
        code: code
    };
    if (loc) message.location = loc;
    return message;
}
const $b46efaa99568cb1e$export$77436aae039469c4 = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // generator error codes
    UNHANDLED_CODEGEN_NODE_TYPE: 15,
    // minifier error codes
    UNHANDLED_MINIFIER_NODE_TYPE: 16,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 17
};
/** @internal */ const $b46efaa99568cb1e$export$d8bd0967cb58683 = {
    // tokenizer error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [$b46efaa99568cb1e$export$77436aae039469c4.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [$b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [$b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`,
    // generator error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_CODEGEN_NODE_TYPE]: `unhandled codegen node type: '{0}'`,
    // minimizer error messages
    [$b46efaa99568cb1e$export$77436aae039469c4.UNHANDLED_MINIFIER_NODE_TYPE]: `unhandled mimifier node type: '{0}'`
};
function $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, options = {}) {
    const { domain: domain, messages: messages, args: args } = options;
    const msg = code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) error.location = loc;
    error.domain = domain;
    return error;
}
/** @internal */ function $b46efaa99568cb1e$export$ad0eb2c702f03471(error) {
    throw error;
}
// eslint-disable-next-line no-useless-escape
const $b46efaa99568cb1e$var$RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const $b46efaa99568cb1e$export$6de85467cbd6ae39 = (source)=>$b46efaa99568cb1e$var$RE_HTML_TAG.test(source);
const $b46efaa99568cb1e$var$CHAR_SP = ' ';
const $b46efaa99568cb1e$var$CHAR_CR = '\r';
const $b46efaa99568cb1e$var$CHAR_LF = '\n';
const $b46efaa99568cb1e$var$CHAR_LS = String.fromCharCode(0x2028);
const $b46efaa99568cb1e$var$CHAR_PS = String.fromCharCode(0x2029);
function $b46efaa99568cb1e$var$createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_CR && _buf[index + 1] === $b46efaa99568cb1e$var$CHAR_LF;
    const isLF = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_LF;
    const isPS = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_PS;
    const isLS = (index)=>_buf[index] === $b46efaa99568cb1e$var$CHAR_LS;
    const isLineEnd = (index)=>isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = ()=>_index;
    const line = ()=>_line;
    const column = ()=>_column;
    const peekOffset = ()=>_peekOffset;
    const charAt = (offset)=>isCRLF(offset) || isPS(offset) || isLS(offset) ? $b46efaa99568cb1e$var$CHAR_LF : _buf[offset];
    const currentChar = ()=>charAt(_index);
    const currentPeek = ()=>charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) _index++;
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) _peekOffset++;
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while(target !== _index)next();
        _peekOffset = 0;
    }
    return {
        index: index,
        line: line,
        column: column,
        peekOffset: peekOffset,
        charAt: charAt,
        currentChar: currentChar,
        currentPeek: currentPeek,
        next: next,
        peek: peek,
        reset: reset,
        resetPeek: resetPeek,
        skipToPeek: skipToPeek
    };
}
const $b46efaa99568cb1e$var$EOF = undefined;
const $b46efaa99568cb1e$var$DOT = '.';
const $b46efaa99568cb1e$var$LITERAL_DELIMITER = "'";
const $b46efaa99568cb1e$var$ERROR_DOMAIN$3 = 'tokenizer';
function $b46efaa99568cb1e$var$createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = $b46efaa99568cb1e$var$createScanner(source);
    const currentOffset = ()=>_scnr.index();
    const currentPosition = ()=>$b46efaa99568cb1e$export$edb4795983846c10(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 14 /* TokenTypes.EOF */ ,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* TokenTypes.EOF */ ,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ''
    };
    const context = ()=>_context;
    const { onError: onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(ctx.startLoc, pos) : null;
            const err = $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, {
                domain: $b46efaa99568cb1e$var$ERROR_DOMAIN$3,
                args: args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = {
            type: type
        };
        if (location) token.loc = $b46efaa99568cb1e$export$90c043f1c57770b8(context.startLoc, context.endLoc);
        if (value != null) token.value = value;
        return token;
    }
    const getEndToken = (context)=>getToken(context, 14 /* TokenTypes.EOF */ );
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        } else {
            emitError($b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return '';
        }
    }
    function peekSpaces(scnr) {
        let buf = '';
        while(scnr.currentPeek() === $b46efaa99568cb1e$var$CHAR_SP || scnr.currentPeek() === $b46efaa99568cb1e$var$CHAR_LF){
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === $b46efaa99568cb1e$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc === 95 // _
        ;
    }
    function isNumberStart(ch) {
        if (ch === $b46efaa99568cb1e$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === '-' ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* TokenTypes.BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === $b46efaa99568cb1e$var$LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 8 /* TokenTypes.LinkedAlias */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* TokenChars.LinkedDot */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 9 /* TokenTypes.LinkedDot */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType: currentType } = context;
        if (!(currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 12 /* TokenTypes.LinkedModifier */ )) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* TokenChars.LinkedDelimiter */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 10 /* TokenTypes.LinkedDelimiter */ ) return false;
        const fn = ()=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return isIdentifierStart(scnr.peek());
            else if (ch === "@" /* TokenChars.LinkedAlias */  || ch === "%" /* TokenChars.Modulo */  || ch === "|" /* TokenChars.Pipe */  || ch === ":" /* TokenChars.LinkedDelimiter */  || ch === "." /* TokenChars.LinkedDot */  || ch === $b46efaa99568cb1e$var$CHAR_SP || !ch) return false;
            else if (ch === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.peek();
                return fn();
            } else // other characters
            return isTextStart(scnr, false);
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* TokenChars.Pipe */ ;
        scnr.resetPeek();
        return ret;
    }
    function detectModuloStart(scnr) {
        const spaces = peekSpaces(scnr);
        const ret = scnr.currentPeek() === "%" /* TokenChars.Modulo */  && scnr.peek() === "{" /* TokenChars.BraceLeft */ ;
        scnr.resetPeek();
        return {
            isModulo: ret,
            hasSpace: spaces.length > 0
        };
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = '', detectModulo = false)=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* TokenChars.BraceLeft */ ) return prev === "%" /* TokenChars.Modulo */  ? false : hasSpace;
            else if (ch === "@" /* TokenChars.LinkedAlias */  || !ch) return prev === "%" /* TokenChars.Modulo */  ? true : hasSpace;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                scnr.peek();
                return fn(hasSpace, "%" /* TokenChars.Modulo */ , true);
            } else if (ch === "|" /* TokenChars.Pipe */ ) return prev === "%" /* TokenChars.Modulo */  || detectModulo ? true : !(prev === $b46efaa99568cb1e$var$CHAR_SP || prev === $b46efaa99568cb1e$var$CHAR_LF);
            else if (ch === $b46efaa99568cb1e$var$CHAR_SP) {
                scnr.peek();
                return fn(true, $b46efaa99568cb1e$var$CHAR_SP, detectModulo);
            } else if (ch === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.peek();
                return fn(true, $b46efaa99568cb1e$var$CHAR_LF, detectModulo);
            } else return true;
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === $b46efaa99568cb1e$var$EOF) return $b46efaa99568cb1e$var$EOF;
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function isIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 // $
        ;
    }
    function takeIdentifierChar(scnr) {
        return takeChar(scnr, isIdentifier);
    }
    function isNamedIdentifier(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc >= 48 && cc <= 57 || // 0-9
        cc === 95 || // _
        cc === 36 || // $
        cc === 45 // -
        ;
    }
    function takeNamedIdentifierChar(scnr) {
        return takeChar(scnr, isNamedIdentifier);
    }
    function isDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function takeDigit(scnr) {
        return takeChar(scnr, isDigit);
    }
    function isHexDigit(ch) {
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57 || // 0-9
        cc >= 65 && cc <= 70 || // A-F
        cc >= 97 && cc <= 102; // a-f
    }
    function takeHexDigit(scnr) {
        return takeChar(scnr, isHexDigit);
    }
    function getDigits(scnr) {
        let ch = '';
        let num = '';
        while(ch = takeDigit(scnr))num += ch;
        return num;
    }
    function readModulo(scnr) {
        skipSpaces(scnr);
        const ch = scnr.currentChar();
        if (ch !== "%" /* TokenChars.Modulo */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
        scnr.next();
        return "%" /* TokenChars.Modulo */ ;
    }
    function readText(scnr) {
        let buf = '';
        // eslint-disable-next-line no-constant-condition
        while(true){
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "}" /* TokenChars.BraceRight */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || !ch) break;
            else if (ch === "%" /* TokenChars.Modulo */ ) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else break;
            } else if (ch === $b46efaa99568cb1e$var$CHAR_SP || ch === $b46efaa99568cb1e$var$CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else if (isPluralStart(scnr)) break;
                else {
                    buf += ch;
                    scnr.next();
                }
            } else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let name = '';
        while(ch = takeNamedIdentifierChar(scnr))name += ch;
        if (scnr.currentChar() === $b46efaa99568cb1e$var$EOF) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = '';
        if (scnr.currentChar() === '-') {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        } else value += getDigits(scnr);
        if (scnr.currentChar() === $b46efaa99568cb1e$var$EOF) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return value;
    }
    function isLiteral(ch) {
        return ch !== $b46efaa99568cb1e$var$LITERAL_DELIMITER && ch !== $b46efaa99568cb1e$var$CHAR_LF;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        let ch = '';
        let literal = '';
        while(ch = takeChar(scnr, isLiteral))if (ch === '\\') literal += readEscapeSequence(scnr);
        else literal += ch;
        const current = scnr.currentChar();
        if (current === $b46efaa99568cb1e$var$CHAR_LF || current === $b46efaa99568cb1e$var$EOF) {
            emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === $b46efaa99568cb1e$var$CHAR_LF) {
                scnr.next();
                // eslint-disable-next-line no-useless-escape
                eat(scnr, `\'`);
            }
            return literal;
        }
        // eslint-disable-next-line no-useless-escape
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch(ch){
            case '\\':
            case `\'`:
                scnr.next();
                return `\\${ch}`;
            case 'u':
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case 'U':
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError($b46efaa99568cb1e$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return '';
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = '';
        for(let i = 0; i < digits; i++){
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function isInvalidIdentifier(ch) {
        return ch !== "{" /* TokenChars.BraceLeft */  && ch !== "}" /* TokenChars.BraceRight */  && ch !== $b46efaa99568cb1e$var$CHAR_SP && ch !== $b46efaa99568cb1e$var$CHAR_LF;
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = '';
        let identifiers = '';
        while(ch = takeChar(scnr, isInvalidIdentifier))identifiers += ch;
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = '';
        let name = '';
        while(ch = takeIdentifierChar(scnr))name += ch;
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (buf)=>{
            const ch = scnr.currentChar();
            if (ch === "{" /* TokenChars.BraceLeft */  || ch === "%" /* TokenChars.Modulo */  || ch === "@" /* TokenChars.LinkedAlias */  || ch === "|" /* TokenChars.Pipe */  || ch === "(" /* TokenChars.ParenLeft */  || ch === ")" /* TokenChars.ParenRight */  || !ch) return buf;
            else if (ch === $b46efaa99568cb1e$var$CHAR_SP) return buf;
            else if (ch === $b46efaa99568cb1e$var$CHAR_LF || ch === $b46efaa99568cb1e$var$DOT) {
                buf += ch;
                scnr.next();
                return fn(buf);
            } else {
                buf += ch;
                scnr.next();
                return fn(buf);
            }
        };
        return fn('');
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* TokenChars.Pipe */ );
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                if (context.braceNest >= 1) emitError($b46efaa99568cb1e$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 2 /* TokenTypes.BraceLeft */ , "{" /* TokenChars.BraceLeft */ );
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* TokenChars.BraceRight */ :
                if (context.braceNest > 0 && context.currentType === 2 /* TokenTypes.BraceLeft */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.EMPTY_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) context.inLinked = false;
                return token;
            case "@" /* TokenChars.LinkedAlias */ :
                if (context.braceNest > 0) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                {
                    let validNamedIdentifier = true;
                    let validListIdentifier = true;
                    let validLiteral = true;
                    if (isPluralStart(scnr)) {
                        if (context.braceNest > 0) emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    if (context.braceNest > 0 && (context.currentType === 5 /* TokenTypes.Named */  || context.currentType === 6 /* TokenTypes.List */  || context.currentType === 7 /* TokenTypes.Literal */ )) {
                        emitError($b46efaa99568cb1e$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                        context.braceNest = 0;
                        return readToken(scnr, context);
                    }
                    if (validNamedIdentifier = isNamedIdentifierStart(scnr, context)) {
                        token = getToken(context, 5 /* TokenTypes.Named */ , readNamedIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validListIdentifier = isListIdentifierStart(scnr, context)) {
                        token = getToken(context, 6 /* TokenTypes.List */ , readListIdentifier(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (validLiteral = isLiteralStart(scnr, context)) {
                        token = getToken(context, 7 /* TokenTypes.Literal */ , readLiteral(scnr));
                        skipSpaces(scnr);
                        return token;
                    }
                    if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                        // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                        token = getToken(context, 13 /* TokenTypes.InvalidPlace */ , readInvalidIdentifier(scnr));
                        emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                        skipSpaces(scnr);
                        return token;
                    }
                    break;
                }
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType: currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 8 /* TokenTypes.LinkedAlias */  || currentType === 9 /* TokenTypes.LinkedDot */  || currentType === 12 /* TokenTypes.LinkedModifier */  || currentType === 10 /* TokenTypes.LinkedDelimiter */ ) && (ch === $b46efaa99568cb1e$var$CHAR_LF || ch === $b46efaa99568cb1e$var$CHAR_SP)) emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
        switch(ch){
            case "@" /* TokenChars.LinkedAlias */ :
                scnr.next();
                token = getToken(context, 8 /* TokenTypes.LinkedAlias */ , "@" /* TokenChars.LinkedAlias */ );
                context.inLinked = true;
                return token;
            case "." /* TokenChars.LinkedDot */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* TokenTypes.LinkedDot */ , "." /* TokenChars.LinkedDot */ );
            case ":" /* TokenChars.LinkedDelimiter */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* TokenTypes.LinkedDelimiter */ , ":" /* TokenChars.LinkedDelimiter */ );
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) || isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* TokenTypes.LinkedModifier */ , readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* TokenChars.BraceLeft */ ) // scan the placeholder
                    return readTokenInPlaceholder(scnr, context) || token;
                    else return getToken(context, 11 /* TokenTypes.LinkedKey */ , readLinkedRefer(scnr));
                }
                if (currentType === 8 /* TokenTypes.LinkedAlias */ ) emitError($b46efaa99568cb1e$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = {
            type: 14 /* TokenTypes.EOF */ 
        };
        if (context.braceNest > 0) return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        if (context.inLinked) return readTokenInLinked(scnr, context) || getEndToken(context);
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* TokenChars.BraceLeft */ :
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* TokenChars.BraceRight */ :
                emitError($b46efaa99568cb1e$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* TokenTypes.BraceRight */ , "}" /* TokenChars.BraceRight */ );
            case "@" /* TokenChars.LinkedAlias */ :
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                {
                    if (isPluralStart(scnr)) {
                        token = getToken(context, 1 /* TokenTypes.Pipe */ , readPlural(scnr));
                        // reset
                        context.braceNest = 0;
                        context.inLinked = false;
                        return token;
                    }
                    const { isModulo: isModulo, hasSpace: hasSpace } = detectModuloStart(scnr);
                    if (isModulo) return hasSpace ? getToken(context, 0 /* TokenTypes.Text */ , readText(scnr)) : getToken(context, 4 /* TokenTypes.Modulo */ , readModulo(scnr));
                    if (isTextStart(scnr)) return getToken(context, 0 /* TokenTypes.Text */ , readText(scnr));
                    break;
                }
        }
        return token;
    }
    function nextToken() {
        const { currentType: currentType, offset: offset, startLoc: startLoc, endLoc: endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === $b46efaa99568cb1e$var$EOF) return getToken(_context, 14 /* TokenTypes.EOF */ );
        return readToken(_scnr, _context);
    }
    return {
        nextToken: nextToken,
        currentOffset: currentOffset,
        currentPosition: currentPosition,
        context: context
    };
}
const $b46efaa99568cb1e$export$9838302824baa7fa = 'parser';
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const $b46efaa99568cb1e$var$KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function $b46efaa99568cb1e$var$fromEscapeSequence(match, codePoint4, codePoint6) {
    switch(match){
        case `\\\\`:
            return `\\`;
        // eslint-disable-next-line no-useless-escape
        case `\\\'`:
            // eslint-disable-next-line no-useless-escape
            return `\'`;
        default:
            {
                const codePoint = parseInt(codePoint4 || codePoint6, 16);
                if (codePoint <= 0xd7ff || codePoint >= 0xe000) return String.fromCodePoint(codePoint);
                // invalid ...
                // Replace them with U+FFFD REPLACEMENT CHARACTER.
                return "\uFFFD";
            }
    }
}
function $b46efaa99568cb1e$export$88a1156fad04455f(options = {}) {
    const location = options.location !== false;
    const { onError: onError, onWarn: onWarn } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(start, end) : null;
            const err = $b46efaa99568cb1e$export$21efa8bb37d5fecb(code, loc, {
                domain: $b46efaa99568cb1e$export$9838302824baa7fa,
                args: args
            });
            onError(err);
        }
    }
    function emitWarn(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onWarn) {
            const loc = location ? $b46efaa99568cb1e$export$90c043f1c57770b8(start, end) : null;
            onWarn($b46efaa99568cb1e$export$b5ca1ea40a366b08(code, loc, args));
        }
    }
    function startNode(type, offset, loc) {
        const node = {
            type: type
        };
        if (location) {
            node.start = offset;
            node.end = offset;
            node.loc = {
                start: loc,
                end: loc
            };
        }
        return node;
    }
    function endNode(node, offset, pos, type) {
        if (type) node.type = type;
        if (location) {
            node.end = offset;
            if (node.loc) node.loc.end = pos;
        }
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* NodeTypes.Text */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* NodeTypes.List */ , offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key, modulo) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* NodeTypes.Named */ , offset, loc);
        node.key = key;
        if (modulo === true) node.modulo = true;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* NodeTypes.Literal */ , offset, loc);
        node.value = value.replace($b46efaa99568cb1e$var$KNOWN_ESCAPES, $b46efaa99568cb1e$var$fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* NodeTypes.LinkedModifier */ , offset, loc);
        if (token.type !== 12 /* TokenTypes.LinkedModifier */ ) {
            // empty modifier
            emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = '';
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node: node
            };
        }
        // check token
        if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
        node.value = token.value || '';
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* NodeTypes.LinkedKey */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* NodeTypes.Linked */ , context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 9 /* TokenTypes.LinkedDot */ ) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* TokenTypes.LinkedDelimiter */ ) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* TokenTypes.BraceLeft */ ) token = tokenizer.nextToken();
        switch(token.type){
            case 11 /* TokenTypes.LinkedKey */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseLinkedKey(tokenizer, token.value || '');
                break;
            case 5 /* TokenTypes.Named */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseNamed(tokenizer, token.value || '');
                break;
            case 6 /* TokenTypes.List */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseList(tokenizer, token.value || '');
                break;
            case 7 /* TokenTypes.Literal */ :
                if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                linkedNode.key = parseLiteral(tokenizer, token.value || '');
                break;
            default:
                {
                    // empty key
                    emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                    const nextContext = tokenizer.context();
                    const emptyLinkedKeyNode = startNode(7 /* NodeTypes.LinkedKey */ , nextContext.offset, nextContext.startLoc);
                    emptyLinkedKeyNode.value = '';
                    endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                    linkedNode.key = emptyLinkedKeyNode;
                    endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                    return {
                        nextConsumeToken: token,
                        node: linkedNode
                    };
                }
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? tokenizer.currentOffset() : context.offset;
        const startLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.endLoc : context.startLoc;
        const node = startNode(2 /* NodeTypes.Message */ , startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        let modulo = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch(token.type){
                case 0 /* TokenTypes.Text */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseText(tokenizer, token.value || ''));
                    break;
                case 6 /* TokenTypes.List */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseList(tokenizer, token.value || ''));
                    break;
                case 4 /* TokenTypes.Modulo */ :
                    modulo = true;
                    break;
                case 5 /* TokenTypes.Named */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseNamed(tokenizer, token.value || '', !!modulo));
                    if (modulo) {
                        emitWarn(tokenizer, $b46efaa99568cb1e$export$21499b937901db8a.USE_MODULO_SYNTAX, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                        modulo = null;
                    }
                    break;
                case 7 /* TokenTypes.Literal */ :
                    if (token.value == null) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $b46efaa99568cb1e$var$getTokenCaption(token));
                    node.items.push(parseLiteral(tokenizer, token.value || ''));
                    break;
                case 8 /* TokenTypes.LinkedAlias */ :
                    {
                        const parsed = parseLinked(tokenizer);
                        node.items.push(parsed.node);
                        nextToken = parsed.nextConsumeToken || null;
                        break;
                    }
            }
        }while (context.currentType !== 14 /* TokenTypes.EOF */  && context.currentType !== 1 /* TokenTypes.Pipe */ );
        // adjust message node loc
        const endOffset = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastOffset : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* TokenTypes.Pipe */  ? context.lastEndLoc : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* NodeTypes.Plural */ , offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) hasEmptyMessage = msg.items.length === 0;
            node.cases.push(msg);
        }while (context.currentType !== 14 /* TokenTypes.EOF */ );
        if (hasEmptyMessage) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset: offset, startLoc: startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* TokenTypes.EOF */ ) return msgNode;
        else return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
    function parse(source) {
        const tokenizer = $b46efaa99568cb1e$var$createTokenizer(source, (0, $9QywT.assign)({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* NodeTypes.Resource */ , context.offset, context.startLoc);
        if (location && node.loc) node.loc.source = source;
        node.body = parseResource(tokenizer);
        if (options.onCacheKey) node.cacheKey = options.onCacheKey(source);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* TokenTypes.EOF */ ) emitError(tokenizer, $b46efaa99568cb1e$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || '');
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return {
        parse: parse
    };
}
function $b46efaa99568cb1e$var$getTokenCaption(token) {
    if (token.type === 14 /* TokenTypes.EOF */ ) return 'EOF';
    const name = (token.value || '').replace(/\r?\n/gu, '\\n');
    return name.length > 10 ? name.slice(0, 9) + "\u2026" : name;
}
function $b46efaa99568cb1e$var$createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast: ast,
        helpers: new Set()
    };
    const context = ()=>_context;
    const helper = (name)=>{
        _context.helpers.add(name);
        return name;
    };
    return {
        context: context,
        helper: helper
    };
}
function $b46efaa99568cb1e$var$traverseNodes(nodes, transformer) {
    for(let i = 0; i < nodes.length; i++)$b46efaa99568cb1e$var$traverseNode(nodes[i], transformer);
}
function $b46efaa99568cb1e$var$traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch(node.type){
        case 1 /* NodeTypes.Plural */ :
            $b46efaa99568cb1e$var$traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* HelperNameMap.PLURAL */ );
            break;
        case 2 /* NodeTypes.Message */ :
            $b46efaa99568cb1e$var$traverseNodes(node.items, transformer);
            break;
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $b46efaa99568cb1e$var$traverseNode(linked.key, transformer);
                transformer.helper("linked" /* HelperNameMap.LINKED */ );
                transformer.helper("type" /* HelperNameMap.TYPE */ );
                break;
            }
        case 5 /* NodeTypes.List */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("list" /* HelperNameMap.LIST */ );
            break;
        case 4 /* NodeTypes.Named */ :
            transformer.helper("interpolate" /* HelperNameMap.INTERPOLATE */ );
            transformer.helper("named" /* HelperNameMap.NAMED */ );
            break;
    }
// TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function $b46efaa99568cb1e$var$transform(ast, options = {} // eslint-disable-line
) {
    const transformer = $b46efaa99568cb1e$var$createTransformer(ast);
    transformer.helper("normalize" /* HelperNameMap.NORMALIZE */ );
    // traverse
    ast.body && $b46efaa99568cb1e$var$traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}
function $b46efaa99568cb1e$var$optimize(ast) {
    const body = ast.body;
    if (body.type === 2 /* NodeTypes.Message */ ) $b46efaa99568cb1e$var$optimizeMessageNode(body);
    else body.cases.forEach((c)=>$b46efaa99568cb1e$var$optimizeMessageNode(c));
    return ast;
}
function $b46efaa99568cb1e$var$optimizeMessageNode(message) {
    if (message.items.length === 1) {
        const item = message.items[0];
        if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) {
            message.static = item.value;
            delete item.value; // optimization for size
        }
    } else {
        const values = [];
        for(let i = 0; i < message.items.length; i++){
            const item = message.items[i];
            if (!(item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ )) break;
            if (item.value == null) break;
            values.push(item.value);
        }
        if (values.length === message.items.length) {
            message.static = (0, $9QywT.join)(values);
            for(let i = 0; i < message.items.length; i++){
                const item = message.items[i];
                if (item.type === 3 /* NodeTypes.Text */  || item.type === 9 /* NodeTypes.Literal */ ) delete item.value; // optimization for size
            }
        }
    }
}
const $b46efaa99568cb1e$var$ERROR_DOMAIN$1 = 'minifier';
/* eslint-disable @typescript-eslint/no-explicit-any */ function $b46efaa99568cb1e$var$minify(node) {
    node.t = node.type;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            {
                const resource = node;
                $b46efaa99568cb1e$var$minify(resource.body);
                resource.b = resource.body;
                delete resource.body;
                break;
            }
        case 1 /* NodeTypes.Plural */ :
            {
                const plural = node;
                const cases = plural.cases;
                for(let i = 0; i < cases.length; i++)$b46efaa99568cb1e$var$minify(cases[i]);
                plural.c = cases;
                delete plural.cases;
                break;
            }
        case 2 /* NodeTypes.Message */ :
            {
                const message = node;
                const items = message.items;
                for(let i = 0; i < items.length; i++)$b46efaa99568cb1e$var$minify(items[i]);
                message.i = items;
                delete message.items;
                if (message.static) {
                    message.s = message.static;
                    delete message.static;
                }
                break;
            }
        case 3 /* NodeTypes.Text */ :
        case 9 /* NodeTypes.Literal */ :
        case 8 /* NodeTypes.LinkedModifier */ :
        case 7 /* NodeTypes.LinkedKey */ :
            {
                const valueNode = node;
                if (valueNode.value) {
                    valueNode.v = valueNode.value;
                    delete valueNode.value;
                }
                break;
            }
        case 6 /* NodeTypes.Linked */ :
            {
                const linked = node;
                $b46efaa99568cb1e$var$minify(linked.key);
                linked.k = linked.key;
                delete linked.key;
                if (linked.modifier) {
                    $b46efaa99568cb1e$var$minify(linked.modifier);
                    linked.m = linked.modifier;
                    delete linked.modifier;
                }
                break;
            }
        case 5 /* NodeTypes.List */ :
            {
                const list = node;
                list.i = list.index;
                delete list.index;
                break;
            }
        case 4 /* NodeTypes.Named */ :
            {
                const named = node;
                named.k = named.key;
                delete named.key;
                break;
            }
        default:
    }
    delete node.type;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ // eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference types="source-map-js" />
const $b46efaa99568cb1e$var$ERROR_DOMAIN = 'parser';
function $b46efaa99568cb1e$var$createCodeGenerator(ast, options) {
    const { sourceMap: sourceMap, filename: filename, breakLineCode: breakLineCode, needIndent: _needIndent } = options;
    const location = options.location !== false;
    const _context = {
        filename: filename,
        code: '',
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode: breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    if (location && ast.loc) _context.source = ast.loc.source;
    const context = ()=>_context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : '';
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key)=>`_${key}`;
    const needIndent = ()=>_context.needIndent;
    return {
        context: context,
        push: push,
        indent: indent,
        deindent: deindent,
        newline: newline,
        helper: helper,
        needIndent: needIndent
    };
}
function $b46efaa99568cb1e$var$generateLinkedNode(generator, node) {
    const { helper: helper } = generator;
    generator.push(`${helper("linked" /* HelperNameMap.LINKED */ )}(`);
    $b46efaa99568cb1e$var$generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        $b46efaa99568cb1e$var$generateNode(generator, node.modifier);
        generator.push(`, _type`);
    } else generator.push(`, undefined, _type`);
    generator.push(`)`);
}
function $b46efaa99568cb1e$var$generateMessageNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    generator.push(`${helper("normalize" /* HelperNameMap.NORMALIZE */ )}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for(let i = 0; i < length; i++){
        $b46efaa99568cb1e$var$generateNode(generator, node.items[i]);
        if (i === length - 1) break;
        generator.push(', ');
    }
    generator.deindent(needIndent());
    generator.push('])');
}
function $b46efaa99568cb1e$var$generatePluralNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* HelperNameMap.PLURAL */ )}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for(let i = 0; i < length; i++){
            $b46efaa99568cb1e$var$generateNode(generator, node.cases[i]);
            if (i === length - 1) break;
            generator.push(', ');
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function $b46efaa99568cb1e$var$generateResource(generator, node) {
    if (node.body) $b46efaa99568cb1e$var$generateNode(generator, node.body);
    else generator.push('null');
}
function $b46efaa99568cb1e$var$generateNode(generator, node) {
    const { helper: helper } = generator;
    switch(node.type){
        case 0 /* NodeTypes.Resource */ :
            $b46efaa99568cb1e$var$generateResource(generator, node);
            break;
        case 1 /* NodeTypes.Plural */ :
            $b46efaa99568cb1e$var$generatePluralNode(generator, node);
            break;
        case 2 /* NodeTypes.Message */ :
            $b46efaa99568cb1e$var$generateMessageNode(generator, node);
            break;
        case 6 /* NodeTypes.Linked */ :
            $b46efaa99568cb1e$var$generateLinkedNode(generator, node);
            break;
        case 8 /* NodeTypes.LinkedModifier */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* NodeTypes.LinkedKey */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* NodeTypes.List */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("list" /* HelperNameMap.LIST */ )}(${node.index}))`, node);
            break;
        case 4 /* NodeTypes.Named */ :
            generator.push(`${helper("interpolate" /* HelperNameMap.INTERPOLATE */ )}(${helper("named" /* HelperNameMap.NAMED */ )}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* NodeTypes.Literal */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* NodeTypes.Text */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
    }
}
// generate code from AST
const $b46efaa99568cb1e$var$generate = (ast, options = {} // eslint-disable-line
)=>{
    const mode = (0, $9QywT.isString)(options.mode) ? options.mode : 'normal';
    const filename = (0, $9QywT.isString)(options.filename) ? options.filename : 'message.intl';
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === 'arrow' ? ';' : '\n';
    const needIndent = options.needIndent ? options.needIndent : mode !== 'arrow';
    const helpers = ast.helpers || [];
    const generator = $b46efaa99568cb1e$var$createCodeGenerator(ast, {
        mode: mode,
        filename: filename,
        sourceMap: sourceMap,
        breakLineCode: breakLineCode,
        needIndent: needIndent
    });
    generator.push(mode === 'normal' ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${(0, $9QywT.join)(helpers.map((s)=>`${s}: _${s}`), ', ')} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    $b46efaa99568cb1e$var$generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    delete ast.helpers;
    const { code: code, map: map } = generator.context();
    return {
        ast: ast,
        code: code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};
function $b46efaa99568cb1e$export$3243579822c486a0(source, options = {}) {
    const assignedOptions = (0, $9QywT.assign)({}, options);
    const jit = !!assignedOptions.jit;
    const enalbeMinify = !!assignedOptions.minify;
    const enambeOptimize = assignedOptions.optimize == null ? true : assignedOptions.optimize;
    // parse source codes
    const parser = $b46efaa99568cb1e$export$88a1156fad04455f(assignedOptions);
    const ast = parser.parse(source);
    if (!jit) {
        // transform ASTs
        $b46efaa99568cb1e$var$transform(ast, assignedOptions);
        // generate javascript codes
        return $b46efaa99568cb1e$var$generate(ast, assignedOptions);
    } else {
        // optimize ASTs
        enambeOptimize && $b46efaa99568cb1e$var$optimize(ast);
        // minimize ASTs
        enalbeMinify && $b46efaa99568cb1e$var$minify(ast);
        // In JIT mode, no ast transform, no code generation.
        return {
            ast: ast,
            code: ''
        };
    }
}

});


parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "cloneVNode", () => (parcelRequire("TusQn")).cloneVNode);
$parcel$export(module.exports, "Comment", () => (parcelRequire("TusQn")).Comment);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createSlots", () => (parcelRequire("TusQn")).createSlots);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("TusQn")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("TusQn")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isVNode", () => (parcelRequire("TusQn")).isVNode);
$parcel$export(module.exports, "KeepAlive", () => (parcelRequire("TusQn")).KeepAlive);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8XWQX")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8XWQX")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDirective", () => (parcelRequire("TusQn")).resolveDirective);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "toHandlerKey", () => (parcelRequire("8XWQX")).toHandlerKey);
$parcel$export(module.exports, "toHandlers", () => (parcelRequire("TusQn")).toHandlers);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useAttrs", () => (parcelRequire("TusQn")).useAttrs);
$parcel$export(module.exports, "useSlots", () => (parcelRequire("TusQn")).useSlots);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "render", () => (parcelRequire("eeJ70")).render);
$parcel$export(module.exports, "Transition", () => (parcelRequire("eeJ70")).Transition);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("eeJ70")).TransitionGroup);
$parcel$export(module.exports, "useCssVars", () => (parcelRequire("eeJ70")).useCssVars);
$parcel$export(module.exports, "vModelCheckbox", () => (parcelRequire("eeJ70")).vModelCheckbox);
$parcel$export(module.exports, "vModelDynamic", () => (parcelRequire("eeJ70")).vModelDynamic);
$parcel$export(module.exports, "vModelRadio", () => (parcelRequire("eeJ70")).vModelRadio);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "vShow", () => (parcelRequire("eeJ70")).vShow);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("eeJ70")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "triggerRef", () => (parcelRequire("01W3b")).triggerRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8XWQX")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8XWQX")).toDisplayString);
/**
* vue v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8XWQX");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $0a6cc4ba868319ae$export$4d299b491347818a);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "cloneVNode", () => $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "isVNode", () => $0a6cc4ba868319ae$export$3868d13f8734ae81);
$parcel$export(module.exports, "KeepAlive", () => $0a6cc4ba868319ae$export$70eb8a58709972df);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "resolveDirective", () => $0a6cc4ba868319ae$export$a1989e995cd481be);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createSlots", () => $0a6cc4ba868319ae$export$85738f8fcd0a5430);
$parcel$export(module.exports, "renderSlot", () => $0a6cc4ba868319ae$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "toHandlers", () => $0a6cc4ba868319ae$export$2fb94ff667a6a1a);
$parcel$export(module.exports, "useSlots", () => $0a6cc4ba868319ae$export$9203a8e84125433c);
$parcel$export(module.exports, "useAttrs", () => $0a6cc4ba868319ae$export$75e29435042cd2ea);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "hasInjectionContext", () => $0a6cc4ba868319ae$export$caf6761f24fc571a);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "guardReactiveProps", () => $0a6cc4ba868319ae$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $0a6cc4ba868319ae$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8XWQX")).camelize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8XWQX")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8XWQX")).normalizeStyle);
$parcel$export(module.exports, "toHandlerKey", () => (parcelRequire("8XWQX")).toHandlerKey);
/**
* @vue/runtime-core v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8XWQX = parcelRequire("8XWQX");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
let $0a6cc4ba868319ae$var$isWarning = false;
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    if ($0a6cc4ba868319ae$var$isWarning) return;
    $0a6cc4ba868319ae$var$isWarning = true;
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
    $0a6cc4ba868319ae$var$isWarning = false;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8XWQX.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8XWQX.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8XWQX.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8XWQX.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8XWQX.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $8XWQX.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = -1;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0a6cc4ba868319ae$var$getId(job);
        const lastJob = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0a6cc4ba868319ae$var$getId(lastJob)) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$currentFlushPromise) $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8XWQX.isArray)(cb)) {
        if ($0a6cc4ba868319ae$var$activePostFlushCbs && cb.id === -1) $0a6cc4ba868319ae$var$activePostFlushCbs.splice($0a6cc4ba868319ae$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$flushIndex + 1) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            const cb = $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    const check = (0, $8XWQX.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0a6cc4ba868319ae$var$flushIndex = -1;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(()=>{
            $0a6cc4ba868319ae$var$isHmrUpdating = true;
            instance.parent.update();
            $0a6cc4ba868319ae$var$isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        $0a6cc4ba868319ae$var$hmrDirtyComponents.clear();
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8XWQX.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8XWQX.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getComponentPublicInstance($0a6cc4ba868319ae$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8XWQX.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8XWQX.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $01W3b.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
const $0a6cc4ba868319ae$var$TeleportEndKey = Symbol("_vte");
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8XWQX.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $0a6cc4ba868319ae$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $0a6cc4ba868319ae$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $0a6cc4ba868319ae$var$updateCssVars(n2, true);
            }
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props)) {
                n2.el.__isMounted = false;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    mountToTarget();
                    delete n2.el.__isMounted;
                }, parentSuspense);
            } else mountToTarget();
        } else {
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props) && n1.el.__isMounted === false) {
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    $0a6cc4ba868319ae$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0a6cc4ba868319ae$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0a6cc4ba868319ae$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const $0a6cc4ba868319ae$var$leaveCbKey = Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $0a6cc4ba868319ae$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $0a6cc4ba868319ae$var$findNonCommentChild(children);
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getInnerChild$1(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            let enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0a6cc4ba868319ae$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(innerChild, oldInnerChild) && $0a6cc4ba868319ae$var$recursiveGetSubtree(instance).type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                let leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0a6cc4ba868319ae$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8XWQX.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getInnerChild$1(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        if ($0a6cc4ba868319ae$var$isTeleport(vnode.type) && vnode.children) return $0a6cc4ba868319ae$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8XWQX.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8XWQX.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8XWQX.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0a6cc4ba868319ae$export$f680877a34711e37() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $0a6cc4ba868319ae$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0a6cc4ba868319ae$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0a6cc4ba868319ae$export$83a5dbc1f35517ca(key) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const r = (0, $01W3b.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $8XWQX.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8XWQX.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8XWQX.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8XWQX.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $01W3b.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $8XWQX.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, $8XWQX.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, $8XWQX.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $8XWQX.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8XWQX.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $8XWQX.isArray)(existing) && (0, $8XWQX.remove)(existing, refValue);
                    else {
                        if (!(0, $8XWQX.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $0a6cc4ba868319ae$var$hasLoggedMismatchError = false;
const $0a6cc4ba868319ae$var$logMismatchError = ()=>{
    if ($0a6cc4ba868319ae$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0a6cc4ba868319ae$var$hasLoggedMismatchError = true;
};
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8XWQX.def)(node, "__vnode", vnode, true);
            (0, $8XWQX.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8XWQX.isOn)(key) && !(0, $8XWQX.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $01W3b.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0a6cc4ba868319ae$var$normalizeVNode(children[i + 1]).type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$0a6cc4ba868319ae$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $0a6cc4ba868319ae$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0a6cc4ba868319ae$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0a6cc4ba868319ae$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $8XWQX.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8XWQX.isString)(clientValue) ? clientValue : (0, $8XWQX.stringifyStyle)((0, $8XWQX.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $8XWQX.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8XWQX.isBooleanAttr)(key) || (0, $8XWQX.isKnownHtmlAttr)(key))) {
        if ((0, $8XWQX.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8XWQX.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8XWQX.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0a6cc4ba868319ae$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $8XWQX.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $8XWQX.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $0a6cc4ba868319ae$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0a6cc4ba868319ae$var$allowMismatchAttr = "data-allow-mismatch";
const $0a6cc4ba868319ae$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0a6cc4ba868319ae$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0a6cc4ba868319ae$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($0a6cc4ba868319ae$var$MismatchTypeString[allowedType]);
    }
}
const $0a6cc4ba868319ae$var$requestIdleCallback = (0, $8XWQX.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0a6cc4ba868319ae$var$cancelIdleCallback = (0, $8XWQX.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0a6cc4ba868319ae$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0a6cc4ba868319ae$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0a6cc4ba868319ae$var$cancelIdleCallback(id);
    };
function $0a6cc4ba868319ae$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0a6cc4ba868319ae$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($0a6cc4ba868319ae$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0a6cc4ba868319ae$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0a6cc4ba868319ae$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $8XWQX.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0a6cc4ba868319ae$var$forEachElement(node, cb) {
    if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0a6cc4ba868319ae$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8XWQX.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$0a6cc4ba868319ae$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8XWQX.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0a6cc4ba868319ae$var$invalidateMount(instance2.m);
            $0a6cc4ba868319ae$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8XWQX.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0a6cc4ba868319ae$var$isSuspense(instance.subTree.type)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
            }
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            if (vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8XWQX.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8XWQX.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8XWQX.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8XWQX.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>{
        if (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8XWQX.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8XWQX.camelize)(name) || selfName === (0, $8XWQX.capitalize)((0, $8XWQX.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8XWQX.camelize)(name)] || registry[(0, $8XWQX.capitalize)((0, $8XWQX.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $8XWQX.isArray)(source);
    if (sourceIsArray || (0, $8XWQX.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $01W3b.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $01W3b.isShallow)(source);
            isReadonlySource = (0, $01W3b.isReadonly)(source);
            source = (0, $01W3b.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $01W3b.toReadonly)((0, $01W3b.toReactive)(source[i])) : (0, $01W3b.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8XWQX.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8XWQX.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.ce || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, null, [
            $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $8XWQX.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8XWQX.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getComponentPublicInstance(i);
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8XWQX.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8XWQX.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8XWQX.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $8XWQX.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8XWQX.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8XWQX.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $8XWQX.hasOwn)(normalizedProps, key) || (0, $8XWQX.hasOwn)(ctx, key) || (0, $8XWQX.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8XWQX.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8XWQX.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8XWQX.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8XWQX.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8XWQX.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8XWQX.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8XWQX.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext("useSlots").slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext("useAttrs").attrs;
}
function $0a6cc4ba868319ae$var$getContext(calledFunctionName) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8XWQX.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8XWQX.isArray)(opt) || (0, $8XWQX.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8XWQX.isArray)(a) && (0, $8XWQX.isArray)(b)) return a.concat(b);
    return (0, $8XWQX.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8XWQX.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8XWQX.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8XWQX.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8XWQX.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8XWQX.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8XWQX.NOOP);
        const set = !(0, $8XWQX.isFunction)(opt) && (0, $8XWQX.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8XWQX.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8XWQX.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8XWQX.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8XWQX.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8XWQX.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8XWQX.NOOP)) {
    if ((0, $8XWQX.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8XWQX.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8XWQX.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8XWQX.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8XWQX.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8XWQX.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8XWQX.isObject)(raw)) {
        if ((0, $8XWQX.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8XWQX.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8XWQX.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8XWQX.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8XWQX.extend)((0, $8XWQX.isFunction)(to) ? to.call(this, this) : to, (0, $8XWQX.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8XWQX.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8XWQX.isArray)(to) && (0, $8XWQX.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8XWQX.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8XWQX.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8XWQX.isFunction)(rootComponent)) rootComponent = (0, $8XWQX.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8XWQX.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8XWQX.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8XWQX.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0a6cc4ba868319ae$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if (!$0a6cc4ba868319ae$var$currentInstance) ;
    else {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        let provides = $0a6cc4ba868319ae$var$currentApp ? $0a6cc4ba868319ae$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8XWQX.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$export$f13e630aa3915748() || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8XWQX.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8XWQX.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8XWQX.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8XWQX.hyphenate)(key)) === key || !(0, $8XWQX.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8XWQX.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8XWQX.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8XWQX.hasOwn)(options, camelKey = (0, $8XWQX.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8XWQX.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8XWQX.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8XWQX.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8XWQX.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8XWQX.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0a6cc4ba868319ae$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8XWQX.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8XWQX.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8XWQX.isObject)(comp)) cache.set(comp, (0, $8XWQX.EMPTY_ARR));
        return 0, $8XWQX.EMPTY_ARR;
    }
    if ((0, $8XWQX.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8XWQX.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8XWQX.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8XWQX.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8XWQX.isArray)(opt) || (0, $8XWQX.isFunction)(opt) ? {
                type: opt
            } : (0, $8XWQX.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $8XWQX.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $8XWQX.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $8XWQX.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $8XWQX.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8XWQX.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8XWQX.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $8XWQX.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8XWQX.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8XWQX.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8XWQX.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8XWQX.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8XWQX.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8XWQX.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key === "_" || key === "__" || key === "_ctx" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8XWQX.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8XWQX.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$0a6cc4ba868319ae$var$isInternalKey(key)) slots[key] = children[key];
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const cacheIndexes = children.__;
        if (cacheIndexes) (0, $8XWQX.def)(slots, "__", cacheIndexes, true);
        const type = children._;
        if (type) {
            $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $8XWQX.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8XWQX.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(`<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8XWQX.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8XWQX.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8XWQX.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8XWQX.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8XWQX.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $0a6cc4ba868319ae$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8XWQX.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8XWQX.def)(el, "__vnode", vnode, true);
            (0, $8XWQX.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $0a6cc4ba868319ae$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8XWQX.EMPTY_OBJ);
        const newProps = n2.props || (0, $8XWQX.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8XWQX.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8XWQX.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $8XWQX.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8XWQX.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && // @ts-expect-error _def is private
                    root.ce._def.shadowRoot !== false) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8XWQX.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8XWQX.EMPTY_ARR);
        c2 = c2 || (0, $8XWQX.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8XWQX.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, fallback to el placeholder for unresolved async component
                anchorVNode.el || anchorVNode.placeholder : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $01W3b.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a, parent: parent, slots: { __: slotCacheKeys } } = instance;
        $0a6cc4ba868319ae$var$invalidateMount(m);
        $0a6cc4ba868319ae$var$invalidateMount(a);
        if (bum) (0, $8XWQX.invokeArrayFns)(bum);
        if (parent && (0, $8XWQX.isArray)(slotCacheKeys)) slotCacheKeys.forEach((v1)=>{
            parent.renderCache[v1] = void 0;
        });
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0a6cc4ba868319ae$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs();
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8XWQX.isArray)(ch1) && (0, $8XWQX.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) c2.el = c1.el;
        if (c2.type === $0a6cc4ba868319ae$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0a6cc4ba868319ae$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, options = (0, $8XWQX.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $8XWQX.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $8XWQX.NOOP);
            watchStopHandle.resume = (0, $8XWQX.NOOP);
            watchStopHandle.pause = (0, $8XWQX.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0a6cc4ba868319ae$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $01W3b.watch)(source, cb, baseWatchOptions);
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8XWQX.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8XWQX.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8XWQX.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8XWQX.camelize)(name);
    const hyphenatedName = (0, $8XWQX.hyphenate)(name);
    const modifiers = $0a6cc4ba868319ae$var$getModelModifiers(props, camelizedName);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $8XWQX.EMPTY_OBJ);
        let prevEmittedValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $8XWQX.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $8XWQX.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $8XWQX.EMPTY_OBJ) && (0, $8XWQX.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $8XWQX.hasChanged)(value, emittedValue) && (0, $8XWQX.hasChanged)(value, prevSetValue) && !(0, $8XWQX.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $8XWQX.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0a6cc4ba868319ae$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $8XWQX.camelize)(modelName)}Modifiers`] || props[`${(0, $8XWQX.hyphenate)(modelName)}Modifiers`];
};
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8XWQX.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0a6cc4ba868319ae$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $8XWQX.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $8XWQX.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8XWQX.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8XWQX.toHandlerKey)((0, $8XWQX.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8XWQX.toHandlerKey)((0, $8XWQX.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8XWQX.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8XWQX.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8XWQX.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8XWQX.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8XWQX.extend)(normalized, raw);
    if ((0, $8XWQX.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8XWQX.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8XWQX.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8XWQX.hasOwn)(options, (0, $8XWQX.hyphenate)(key)) || (0, $8XWQX.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8XWQX.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(root, vnode.transition);
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8XWQX.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8XWQX.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8XWQX.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8XWQX.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8XWQX.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8XWQX.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8XWQX.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
    if (value < 0 && $0a6cc4ba868319ae$var$currentBlock && inVOnce) $0a6cc4ba868319ae$var$currentBlock.hasOnce = true;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8XWQX.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8XWQX.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8XWQX.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8XWQX.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8XWQX.isString)(klass)) props.class = (0, $8XWQX.normalizeClass)(klass);
        if ((0, $8XWQX.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8XWQX.isArray)(style)) style = (0, $8XWQX.extend)({}, style);
            props.style = (0, $8XWQX.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8XWQX.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8XWQX.isObject)(type) ? 4 : (0, $8XWQX.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8XWQX.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8XWQX.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $0a6cc4ba868319ae$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8XWQX.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8XWQX.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8XWQX.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8XWQX.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8XWQX.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8XWQX.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8XWQX.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8XWQX.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8XWQX.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8XWQX.EMPTY_OBJ),
        data: (0, $8XWQX.EMPTY_OBJ),
        props: (0, $8XWQX.EMPTY_OBJ),
        attrs: (0, $8XWQX.EMPTY_OBJ),
        slots: (0, $8XWQX.EMPTY_OBJ),
        refs: (0, $8XWQX.EMPTY_OBJ),
        setupState: (0, $8XWQX.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8XWQX.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8XWQX.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $01W3b.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $8XWQX.isPromise)(setupResult);
        (0, $01W3b.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0a6cc4ba868319ae$var$isAsyncWrapper(instance)) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8XWQX.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8XWQX.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8XWQX.extend)((0, $8XWQX.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8XWQX.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])(\w)/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8XWQX.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8XWQX.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $8XWQX.isObject)(propsOrChildren) && !(0, $8XWQX.isArray)(propsOrChildren)) {
            if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8XWQX.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8XWQX.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8XWQX.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8XWQX.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8XWQX.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8XWQX.isArray)(opts) && opts.includes(key) || (0, $8XWQX.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8XWQX.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.5.18";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8XWQX.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode,
    getComponentPublicInstance: $0a6cc4ba868319ae$var$getComponentPublicInstance,
    ensureValidVNode: $0a6cc4ba868319ae$var$ensureValidVNode,
    pushWarningContext: $0a6cc4ba868319ae$var$pushWarningContext,
    popWarningContext: $0a6cc4ba868319ae$var$popWarningContext
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $005d1fb7704e278c$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $005d1fb7704e278c$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $005d1fb7704e278c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "toReadonly", () => $005d1fb7704e278c$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "shallowReadonly", () => $005d1fb7704e278c$export$7c4b5f2b50f09f6b);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "triggerRef", () => $005d1fb7704e278c$export$f402f86588575ccc);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "toValue", () => $005d1fb7704e278c$export$30bdcc2218aa9458);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $005d1fb7704e278c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $005d1fb7704e278c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $lL4wb = parcelRequire("lL4wb");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $005d1fb7704e278c$var$activeEffectScope;
            $005d1fb7704e278c$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            $005d1fb7704e278c$var$activeEffectScope = this.prevScope;
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeSub;
const $005d1fb7704e278c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $005d1fb7704e278c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($005d1fb7704e278c$var$activeEffectScope && $005d1fb7704e278c$var$activeEffectScope.active) $005d1fb7704e278c$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($005d1fb7704e278c$var$pausedQueueEffects.has(this)) {
                $005d1fb7704e278c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $005d1fb7704e278c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $005d1fb7704e278c$var$cleanupEffect(this);
        $005d1fb7704e278c$var$prepareDeps(this);
        const prevEffect = $005d1fb7704e278c$var$activeSub;
        const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        $005d1fb7704e278c$var$activeSub = this;
        $005d1fb7704e278c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$cleanupDeps(this);
            $005d1fb7704e278c$var$activeSub = prevEffect;
            $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$005d1fb7704e278c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $005d1fb7704e278c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $005d1fb7704e278c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($005d1fb7704e278c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $005d1fb7704e278c$var$isDirty(this);
    }
}
let $005d1fb7704e278c$var$batchDepth = 0;
let $005d1fb7704e278c$var$batchedSub;
let $005d1fb7704e278c$var$batchedComputed;
function $005d1fb7704e278c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = sub;
        return;
    }
    sub.next = $005d1fb7704e278c$var$batchedSub;
    $005d1fb7704e278c$var$batchedSub = sub;
}
function $005d1fb7704e278c$var$startBatch() {
    $005d1fb7704e278c$var$batchDepth++;
}
function $005d1fb7704e278c$var$endBatch() {
    if (--$005d1fb7704e278c$var$batchDepth > 0) return;
    if ($005d1fb7704e278c$var$batchedComputed) {
        let e = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($005d1fb7704e278c$var$batchedSub){
        let e = $005d1fb7704e278c$var$batchedSub;
        $005d1fb7704e278c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $005d1fb7704e278c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $005d1fb7704e278c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $005d1fb7704e278c$var$removeSub(link);
            $005d1fb7704e278c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $005d1fb7704e278c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($005d1fb7704e278c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $005d1fb7704e278c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $005d1fb7704e278c$var$globalVersion) return;
    computed.globalVersion = $005d1fb7704e278c$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$005d1fb7704e278c$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $005d1fb7704e278c$var$activeSub;
    const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
    $005d1fb7704e278c$var$activeSub = computed;
    $005d1fb7704e278c$var$shouldTrack = true;
    try {
        $005d1fb7704e278c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $lL4wb.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $005d1fb7704e278c$var$activeSub = prevSub;
        $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
        $005d1fb7704e278c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $005d1fb7704e278c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $005d1fb7704e278c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) (0, $lL4wb.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeSub instanceof $005d1fb7704e278c$export$28352bb4dd362521) $005d1fb7704e278c$var$activeSub.cleanup = fn;
}
function $005d1fb7704e278c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $005d1fb7704e278c$var$activeSub;
        $005d1fb7704e278c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $005d1fb7704e278c$var$activeSub = prevSub;
        }
    }
}
let $005d1fb7704e278c$var$globalVersion = 0;
class $005d1fb7704e278c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $005d1fb7704e278c$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$005d1fb7704e278c$var$activeSub || !$005d1fb7704e278c$var$shouldTrack || $005d1fb7704e278c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $005d1fb7704e278c$var$activeSub) {
            link = this.activeLink = new $005d1fb7704e278c$var$Link($005d1fb7704e278c$var$activeSub, this);
            if (!$005d1fb7704e278c$var$activeSub.deps) $005d1fb7704e278c$var$activeSub.deps = $005d1fb7704e278c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
            }
            $005d1fb7704e278c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
                if ($005d1fb7704e278c$var$activeSub.deps === link) $005d1fb7704e278c$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $005d1fb7704e278c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $005d1fb7704e278c$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $005d1fb7704e278c$var$endBatch();
        }
    }
}
function $005d1fb7704e278c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = Symbol("");
const $005d1fb7704e278c$export$49093fa1cddcb78d = Symbol("");
const $005d1fb7704e278c$export$4f926f0baab682cd = Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeSub) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $005d1fb7704e278c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) {
        $005d1fb7704e278c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $005d1fb7704e278c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $lL4wb.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $lL4wb.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $005d1fb7704e278c$export$4f926f0baab682cd || !(0, $lL4wb.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($005d1fb7704e278c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $lL4wb.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $lL4wb.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $lL4wb.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $005d1fb7704e278c$var$endBatch();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $005d1fb7704e278c$export$1544eab4943788e4(array) {
    const raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $005d1fb7704e278c$export$6b2a7d5132615086(raw, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return $005d1fb7704e278c$export$7f3fe6025abfa26e(array) ? raw : raw.map($005d1fb7704e278c$export$45c769cf449a508c);
}
function $005d1fb7704e278c$export$5eb48af14254449e(arr) {
    $005d1fb7704e278c$export$6b2a7d5132615086(arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(arr), "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return arr;
}
const $005d1fb7704e278c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $005d1fb7704e278c$var$iterator(this, Symbol.iterator, $005d1fb7704e278c$export$45c769cf449a508c);
    },
    concat (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $lL4wb.isArray)(x) ? $005d1fb7704e278c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $005d1fb7704e278c$var$iterator(this, "entries", (value)=>{
            value[1] = $005d1fb7704e278c$export$45c769cf449a508c(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "filter", fn, thisArg, (v)=>v.map($005d1fb7704e278c$export$45c769cf449a508c), arguments);
    },
    find (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "find", fn, thisArg, $005d1fb7704e278c$export$45c769cf449a508c, arguments);
    },
    findIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLast", fn, thisArg, $005d1fb7704e278c$export$45c769cf449a508c, arguments);
    },
    findLastIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $005d1fb7704e278c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $005d1fb7704e278c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $005d1fb7704e278c$var$iterator(this, "values", $005d1fb7704e278c$export$45c769cf449a508c);
    }
};
function $005d1fb7704e278c$var$iterator(self, method, wrapValue) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $005d1fb7704e278c$var$arrayProto = Array.prototype;
function $005d1fb7704e278c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $005d1fb7704e278c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $005d1fb7704e278c$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $005d1fb7704e278c$var$reduce(self, method, fn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $005d1fb7704e278c$export$45c769cf449a508c(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $005d1fb7704e278c$var$searchProxy(self, method, args) {
    const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(self);
    $005d1fb7704e278c$export$6b2a7d5132615086(arr, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $005d1fb7704e278c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $005d1fb7704e278c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $005d1fb7704e278c$var$noTracking(self, method, args = []) {
    $005d1fb7704e278c$export$938a971395fef855();
    $005d1fb7704e278c$var$startBatch();
    const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $005d1fb7704e278c$var$endBatch();
    $005d1fb7704e278c$export$c39176b1babaa8b8();
    return res;
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $lL4wb.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $lL4wb.isSymbol)));
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $lL4wb.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $lL4wb.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $005d1fb7704e278c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $lL4wb.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $lL4wb.isIntegerKey)(key) ? res : res.value;
        if ((0, $lL4wb.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $lL4wb.isArray)(target) && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, $lL4wb.isArray)(target) && (0, $lL4wb.isIntegerKey)(key) ? Number(key) < target.length : (0, $lL4wb.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $lL4wb.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $lL4wb.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $lL4wb.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $lL4wb.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $lL4wb.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $005d1fb7704e278c$var$toShallow : isReadonly2 ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
        !isReadonly2 && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$export$49093fa1cddcb78d : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $lL4wb.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $lL4wb.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $lL4wb.extend)(instrumentations, readonly ? {
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const proto = $005d1fb7704e278c$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $lL4wb.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $005d1fb7704e278c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $lL4wb.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $lL4wb.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $lL4wb.toRawType)(value));
}
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $lL4wb.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(value)) return $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $lL4wb.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $lL4wb.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$export$45c769cf449a508c = (value)=>(0, $lL4wb.isObject)(value) ? $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$export$4a78e7a2a4fb689f = (value)=>(0, $lL4wb.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $005d1fb7704e278c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $005d1fb7704e278c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $005d1fb7704e278c$export$7f3fe6025abfa26e(newValue) || $005d1fb7704e278c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $005d1fb7704e278c$export$ab18938b9fc5f28e(newValue);
        if ((0, $lL4wb.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $005d1fb7704e278c$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $lL4wb.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $005d1fb7704e278c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $lL4wb.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive($005d1fb7704e278c$export$ab18938b9fc5f28e(this._object), this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $lL4wb.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $lL4wb.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $005d1fb7704e278c$export$4f9f5282de18fc69(val) ? val : new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $005d1fb7704e278c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $005d1fb7704e278c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $005d1fb7704e278c$var$activeSub !== this) {
            $005d1fb7704e278c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $005d1fb7704e278c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $lL4wb.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $005d1fb7704e278c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE = {};
const $005d1fb7704e278c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$activeWatcher = void 0;
function $005d1fb7704e278c$export$2532f7acfca7c82d() {
    return $005d1fb7704e278c$var$activeWatcher;
}
function $005d1fb7704e278c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $005d1fb7704e278c$var$activeWatcher) {
    if (owner) {
        let cleanups = $005d1fb7704e278c$var$cleanupMap.get(owner);
        if (!cleanups) $005d1fb7704e278c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $005d1fb7704e278c$export$3db5d71bdb2d5499(source, cb, options = (0, $lL4wb.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $005d1fb7704e278c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($005d1fb7704e278c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $005d1fb7704e278c$export$df3f009e3d155b20(source2, 1);
        return $005d1fb7704e278c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $005d1fb7704e278c$export$7f3fe6025abfa26e(source);
    } else if ($005d1fb7704e278c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $lL4wb.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$005d1fb7704e278c$export$352205f445242f02(s) || $005d1fb7704e278c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($005d1fb7704e278c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($005d1fb7704e278c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $lL4wb.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $lL4wb.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $005d1fb7704e278c$var$activeWatcher;
            $005d1fb7704e278c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $005d1fb7704e278c$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $lL4wb.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$005d1fb7704e278c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $005d1fb7704e278c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $lL4wb.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($005d1fb7704e278c$var$INITIAL_WATCHER_VALUE) : $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $lL4wb.hasChanged)(v, oldValue[i])) : (0, $lL4wb.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $005d1fb7704e278c$var$activeWatcher;
                $005d1fb7704e278c$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $005d1fb7704e278c$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$005d1fb7704e278c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $005d1fb7704e278c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $005d1fb7704e278c$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $005d1fb7704e278c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $lL4wb.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(value)) $005d1fb7704e278c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $lL4wb.isArray)(value)) for(let i = 0; i < value.length; i++)$005d1fb7704e278c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $lL4wb.isSet)(value) || (0, $lL4wb.isMap)(value)) value.forEach((v)=>{
        $005d1fb7704e278c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $lL4wb.isPlainObject)(value)) {
        for(const key in value)$005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("lL4wb", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $fd717df9cc568609$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $fd717df9cc568609$export$cf583d23ab39677c);
$parcel$export(module.exports, "NOOP", () => $fd717df9cc568609$export$5702a91a6f42969f);
$parcel$export(module.exports, "extend", () => $fd717df9cc568609$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $fd717df9cc568609$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $fd717df9cc568609$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $fd717df9cc568609$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $fd717df9cc568609$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $fd717df9cc568609$export$6750766a7c7ec627);
$parcel$export(module.exports, "isFunction", () => $fd717df9cc568609$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isSymbol", () => $fd717df9cc568609$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $fd717df9cc568609$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "toRawType", () => $fd717df9cc568609$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $fd717df9cc568609$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $fd717df9cc568609$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "hasChanged", () => $fd717df9cc568609$export$f619eb8b89076d23);
$parcel$export(module.exports, "def", () => $fd717df9cc568609$export$8afb76124cf08683);
/**
* @vue/shared v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $fd717df9cc568609$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $fd717df9cc568609$export$cf583d23ab39677c = {};
const $fd717df9cc568609$export$6bd8558f433f1cc1 = [];
const $fd717df9cc568609$export$5702a91a6f42969f = ()=>{};
const $fd717df9cc568609$export$c01351c0af048e39 = ()=>false;
const $fd717df9cc568609$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $fd717df9cc568609$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $fd717df9cc568609$export$8b58be045bf06082 = Object.assign;
const $fd717df9cc568609$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $fd717df9cc568609$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $fd717df9cc568609$export$b5a638e9b3fff9f3 = (val, key)=>$fd717df9cc568609$var$hasOwnProperty.call(val, key);
const $fd717df9cc568609$export$43bee75e5e14138e = Array.isArray;
const $fd717df9cc568609$export$5c90113a285f2241 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Map]";
const $fd717df9cc568609$export$6750766a7c7ec627 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Set]";
const $fd717df9cc568609$export$871608497c498473 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Date]";
const $fd717df9cc568609$export$49841c62b9eff15 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object RegExp]";
const $fd717df9cc568609$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $fd717df9cc568609$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $fd717df9cc568609$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $fd717df9cc568609$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $fd717df9cc568609$export$4369c812aac99591 = (val)=>{
    return ($fd717df9cc568609$export$a6cdc56e425d0d0a(val) || $fd717df9cc568609$export$f6e2535fb5126e54(val)) && $fd717df9cc568609$export$f6e2535fb5126e54(val.then) && $fd717df9cc568609$export$f6e2535fb5126e54(val.catch);
};
const $fd717df9cc568609$export$830c053460e5ddf6 = Object.prototype.toString;
const $fd717df9cc568609$export$1dccc787cc36538b = (value)=>$fd717df9cc568609$export$830c053460e5ddf6.call(value);
const $fd717df9cc568609$export$5ad0a3c360b8fbb5 = (value)=>{
    return $fd717df9cc568609$export$1dccc787cc36538b(value).slice(8, -1);
};
const $fd717df9cc568609$export$53b83ca8eaab0383 = (val)=>$fd717df9cc568609$export$1dccc787cc36538b(val) === "[object Object]";
const $fd717df9cc568609$export$e2a2b93446ec9fe = (key)=>$fd717df9cc568609$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $fd717df9cc568609$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $fd717df9cc568609$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $fd717df9cc568609$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $fd717df9cc568609$var$camelizeRE = /-(\w)/g;
const $fd717df9cc568609$export$161d051f5dd25de7 = $fd717df9cc568609$var$cacheStringFunction((str)=>{
    return str.replace($fd717df9cc568609$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $fd717df9cc568609$var$hyphenateRE = /\B([A-Z])/g;
const $fd717df9cc568609$export$6e6a0a3676c4b8bb = $fd717df9cc568609$var$cacheStringFunction((str)=>str.replace($fd717df9cc568609$var$hyphenateRE, "-$1").toLowerCase());
const $fd717df9cc568609$export$9a00dee1beb8f576 = $fd717df9cc568609$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $fd717df9cc568609$export$8c022799eeaaefcd = $fd717df9cc568609$var$cacheStringFunction((str)=>{
    const s = str ? `on${$fd717df9cc568609$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $fd717df9cc568609$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $fd717df9cc568609$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $fd717df9cc568609$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $fd717df9cc568609$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $fd717df9cc568609$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $fd717df9cc568609$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $fd717df9cc568609$var$_globalThis;
const $fd717df9cc568609$export$ff5f2eeb11fc7e14 = ()=>{
    return $fd717df9cc568609$var$_globalThis || ($fd717df9cc568609$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $fd717df9cc568609$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $fd717df9cc568609$export$53d5e12f9a1d3cde(name) {
    return $fd717df9cc568609$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $fd717df9cc568609$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $fd717df9cc568609$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $fd717df9cc568609$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $fd717df9cc568609$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $fd717df9cc568609$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $fd717df9cc568609$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $fd717df9cc568609$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $fd717df9cc568609$export$f73b8c13b7f97ebf = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$GLOBALS_ALLOWED);
const $fd717df9cc568609$export$d6571a1911e4f27e = $fd717df9cc568609$export$f73b8c13b7f97ebf;
const $fd717df9cc568609$var$range = 2;
function $fd717df9cc568609$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $fd717df9cc568609$var$range; j <= i + $fd717df9cc568609$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $fd717df9cc568609$export$8756898546458274(value) {
    if ($fd717df9cc568609$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $fd717df9cc568609$export$844ec244b1367d54(item) ? $fd717df9cc568609$export$76a205ce979d066a(item) : $fd717df9cc568609$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($fd717df9cc568609$export$844ec244b1367d54(value) || $fd717df9cc568609$export$a6cdc56e425d0d0a(value)) return value;
}
const $fd717df9cc568609$var$listDelimiterRE = /;(?![^(]*\))/g;
const $fd717df9cc568609$var$propertyDelimiterRE = /:([^]+)/;
const $fd717df9cc568609$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $fd717df9cc568609$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($fd717df9cc568609$var$styleCommentRE, "").split($fd717df9cc568609$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($fd717df9cc568609$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $fd717df9cc568609$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($fd717df9cc568609$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($fd717df9cc568609$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $fd717df9cc568609$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $fd717df9cc568609$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($fd717df9cc568609$export$844ec244b1367d54(value)) res = value;
    else if ($fd717df9cc568609$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $fd717df9cc568609$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($fd717df9cc568609$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $fd717df9cc568609$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$fd717df9cc568609$export$844ec244b1367d54(klass)) props.class = $fd717df9cc568609$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $fd717df9cc568609$export$8756898546458274(style);
    return props;
}
const $fd717df9cc568609$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $fd717df9cc568609$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $fd717df9cc568609$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $fd717df9cc568609$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $fd717df9cc568609$export$1ccf854a0984f890 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$HTML_TAGS);
const $fd717df9cc568609$export$6328ce7565ea1049 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$SVG_TAGS);
const $fd717df9cc568609$export$4a46ca4c5be17b20 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$MATH_TAGS);
const $fd717df9cc568609$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$VOID_TAGS);
const $fd717df9cc568609$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $fd717df9cc568609$export$d186f5eb2e810715 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$specialBooleanAttrs);
const $fd717df9cc568609$export$f763ba3b84e9cd8c = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8($fd717df9cc568609$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $fd717df9cc568609$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $fd717df9cc568609$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $fd717df9cc568609$var$attrValidationCache = {};
function $fd717df9cc568609$export$d55ef77660f30d12(name) {
    if ($fd717df9cc568609$var$attrValidationCache.hasOwnProperty(name)) return $fd717df9cc568609$var$attrValidationCache[name];
    const isUnsafe = $fd717df9cc568609$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $fd717df9cc568609$var$attrValidationCache[name] = !isUnsafe;
}
const $fd717df9cc568609$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $fd717df9cc568609$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $fd717df9cc568609$export$80da416f43933831 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $fd717df9cc568609$export$fc0748a8e0014066 = /* @__PURE__ */ $fd717df9cc568609$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $fd717df9cc568609$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $fd717df9cc568609$var$escapeRE = /["'&<>]/;
function $fd717df9cc568609$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $fd717df9cc568609$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $fd717df9cc568609$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $fd717df9cc568609$export$7b105034a53bde5f(src) {
    return src.replace($fd717df9cc568609$var$commentStripRE, "");
}
const $fd717df9cc568609$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $fd717df9cc568609$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($fd717df9cc568609$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $fd717df9cc568609$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $fd717df9cc568609$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $fd717df9cc568609$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $fd717df9cc568609$export$871608497c498473(a);
    let bValidType = $fd717df9cc568609$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $fd717df9cc568609$export$a244864fd9645c7f(a);
    bValidType = $fd717df9cc568609$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $fd717df9cc568609$export$43bee75e5e14138e(a);
    bValidType = $fd717df9cc568609$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $fd717df9cc568609$var$looseCompareArrays(a, b) : false;
    aValidType = $fd717df9cc568609$export$a6cdc56e425d0d0a(a);
    bValidType = $fd717df9cc568609$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$fd717df9cc568609$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $fd717df9cc568609$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$fd717df9cc568609$export$ae8015769846262c(item, val));
}
const $fd717df9cc568609$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $fd717df9cc568609$export$b5b1545233b45293 = (val)=>{
    return $fd717df9cc568609$export$844ec244b1367d54(val) ? val : val == null ? "" : $fd717df9cc568609$export$43bee75e5e14138e(val) || $fd717df9cc568609$export$a6cdc56e425d0d0a(val) && (val.toString === $fd717df9cc568609$export$830c053460e5ddf6 || !$fd717df9cc568609$export$f6e2535fb5126e54(val.toString)) ? $fd717df9cc568609$var$isRef(val) ? $fd717df9cc568609$export$b5b1545233b45293(val.value) : JSON.stringify(val, $fd717df9cc568609$var$replacer, 2) : String(val);
};
const $fd717df9cc568609$var$replacer = (_key, val)=>{
    if ($fd717df9cc568609$var$isRef(val)) return $fd717df9cc568609$var$replacer(_key, val.value);
    else if ($fd717df9cc568609$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$fd717df9cc568609$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($fd717df9cc568609$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$fd717df9cc568609$var$stringifySymbol(v))
    };
    else if ($fd717df9cc568609$export$a244864fd9645c7f(val)) return $fd717df9cc568609$var$stringifySymbol(val);
    else if ($fd717df9cc568609$export$a6cdc56e425d0d0a(val) && !$fd717df9cc568609$export$43bee75e5e14138e(val) && !$fd717df9cc568609$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $fd717df9cc568609$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $fd717df9cc568609$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $fd717df9cc568609$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});


parcelRegister("8XWQX", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $68717c6dc3e7acb0$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $68717c6dc3e7acb0$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $68717c6dc3e7acb0$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $68717c6dc3e7acb0$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $68717c6dc3e7acb0$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $68717c6dc3e7acb0$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $68717c6dc3e7acb0$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $68717c6dc3e7acb0$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $68717c6dc3e7acb0$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $68717c6dc3e7acb0$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $68717c6dc3e7acb0$export$43bee75e5e14138e);
$parcel$export(module.exports, "isRegExp", () => $68717c6dc3e7acb0$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $68717c6dc3e7acb0$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $68717c6dc3e7acb0$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $68717c6dc3e7acb0$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $68717c6dc3e7acb0$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $68717c6dc3e7acb0$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $68717c6dc3e7acb0$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isReservedProp", () => $68717c6dc3e7acb0$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $68717c6dc3e7acb0$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $68717c6dc3e7acb0$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $68717c6dc3e7acb0$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $68717c6dc3e7acb0$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $68717c6dc3e7acb0$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $68717c6dc3e7acb0$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $68717c6dc3e7acb0$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $68717c6dc3e7acb0$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $68717c6dc3e7acb0$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $68717c6dc3e7acb0$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $68717c6dc3e7acb0$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $68717c6dc3e7acb0$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $68717c6dc3e7acb0$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $68717c6dc3e7acb0$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $68717c6dc3e7acb0$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $68717c6dc3e7acb0$export$601abcd8103db5e4);
$parcel$export(module.exports, "isBooleanAttr", () => $68717c6dc3e7acb0$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $68717c6dc3e7acb0$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $68717c6dc3e7acb0$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $68717c6dc3e7acb0$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $68717c6dc3e7acb0$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $68717c6dc3e7acb0$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "toDisplayString", () => $68717c6dc3e7acb0$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $68717c6dc3e7acb0$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $68717c6dc3e7acb0$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $68717c6dc3e7acb0$export$cf583d23ab39677c = {};
const $68717c6dc3e7acb0$export$6bd8558f433f1cc1 = [];
const $68717c6dc3e7acb0$export$5702a91a6f42969f = ()=>{};
const $68717c6dc3e7acb0$export$c01351c0af048e39 = ()=>false;
const $68717c6dc3e7acb0$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $68717c6dc3e7acb0$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $68717c6dc3e7acb0$export$8b58be045bf06082 = Object.assign;
const $68717c6dc3e7acb0$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $68717c6dc3e7acb0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $68717c6dc3e7acb0$export$b5a638e9b3fff9f3 = (val, key)=>$68717c6dc3e7acb0$var$hasOwnProperty.call(val, key);
const $68717c6dc3e7acb0$export$43bee75e5e14138e = Array.isArray;
const $68717c6dc3e7acb0$export$5c90113a285f2241 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Map]";
const $68717c6dc3e7acb0$export$6750766a7c7ec627 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Set]";
const $68717c6dc3e7acb0$export$871608497c498473 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Date]";
const $68717c6dc3e7acb0$export$49841c62b9eff15 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object RegExp]";
const $68717c6dc3e7acb0$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $68717c6dc3e7acb0$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $68717c6dc3e7acb0$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $68717c6dc3e7acb0$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $68717c6dc3e7acb0$export$4369c812aac99591 = (val)=>{
    return ($68717c6dc3e7acb0$export$a6cdc56e425d0d0a(val) || $68717c6dc3e7acb0$export$f6e2535fb5126e54(val)) && $68717c6dc3e7acb0$export$f6e2535fb5126e54(val.then) && $68717c6dc3e7acb0$export$f6e2535fb5126e54(val.catch);
};
const $68717c6dc3e7acb0$export$830c053460e5ddf6 = Object.prototype.toString;
const $68717c6dc3e7acb0$export$1dccc787cc36538b = (value)=>$68717c6dc3e7acb0$export$830c053460e5ddf6.call(value);
const $68717c6dc3e7acb0$export$5ad0a3c360b8fbb5 = (value)=>{
    return $68717c6dc3e7acb0$export$1dccc787cc36538b(value).slice(8, -1);
};
const $68717c6dc3e7acb0$export$53b83ca8eaab0383 = (val)=>$68717c6dc3e7acb0$export$1dccc787cc36538b(val) === "[object Object]";
const $68717c6dc3e7acb0$export$e2a2b93446ec9fe = (key)=>$68717c6dc3e7acb0$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $68717c6dc3e7acb0$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $68717c6dc3e7acb0$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $68717c6dc3e7acb0$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $68717c6dc3e7acb0$var$camelizeRE = /-(\w)/g;
const $68717c6dc3e7acb0$export$161d051f5dd25de7 = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>{
    return str.replace($68717c6dc3e7acb0$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $68717c6dc3e7acb0$var$hyphenateRE = /\B([A-Z])/g;
const $68717c6dc3e7acb0$export$6e6a0a3676c4b8bb = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>str.replace($68717c6dc3e7acb0$var$hyphenateRE, "-$1").toLowerCase());
const $68717c6dc3e7acb0$export$9a00dee1beb8f576 = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $68717c6dc3e7acb0$export$8c022799eeaaefcd = $68717c6dc3e7acb0$var$cacheStringFunction((str)=>{
    const s = str ? `on${$68717c6dc3e7acb0$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $68717c6dc3e7acb0$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $68717c6dc3e7acb0$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $68717c6dc3e7acb0$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $68717c6dc3e7acb0$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $68717c6dc3e7acb0$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $68717c6dc3e7acb0$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $68717c6dc3e7acb0$var$_globalThis;
const $68717c6dc3e7acb0$export$ff5f2eeb11fc7e14 = ()=>{
    return $68717c6dc3e7acb0$var$_globalThis || ($68717c6dc3e7acb0$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $68717c6dc3e7acb0$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $68717c6dc3e7acb0$export$53d5e12f9a1d3cde(name) {
    return $68717c6dc3e7acb0$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $68717c6dc3e7acb0$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $68717c6dc3e7acb0$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $68717c6dc3e7acb0$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $68717c6dc3e7acb0$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $68717c6dc3e7acb0$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $68717c6dc3e7acb0$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $68717c6dc3e7acb0$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $68717c6dc3e7acb0$export$f73b8c13b7f97ebf = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$GLOBALS_ALLOWED);
const $68717c6dc3e7acb0$export$d6571a1911e4f27e = $68717c6dc3e7acb0$export$f73b8c13b7f97ebf;
const $68717c6dc3e7acb0$var$range = 2;
function $68717c6dc3e7acb0$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $68717c6dc3e7acb0$var$range; j <= i + $68717c6dc3e7acb0$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $68717c6dc3e7acb0$export$8756898546458274(value) {
    if ($68717c6dc3e7acb0$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $68717c6dc3e7acb0$export$844ec244b1367d54(item) ? $68717c6dc3e7acb0$export$76a205ce979d066a(item) : $68717c6dc3e7acb0$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($68717c6dc3e7acb0$export$844ec244b1367d54(value) || $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(value)) return value;
}
const $68717c6dc3e7acb0$var$listDelimiterRE = /;(?![^(]*\))/g;
const $68717c6dc3e7acb0$var$propertyDelimiterRE = /:([^]+)/;
const $68717c6dc3e7acb0$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $68717c6dc3e7acb0$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($68717c6dc3e7acb0$var$styleCommentRE, "").split($68717c6dc3e7acb0$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($68717c6dc3e7acb0$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $68717c6dc3e7acb0$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($68717c6dc3e7acb0$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($68717c6dc3e7acb0$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $68717c6dc3e7acb0$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $68717c6dc3e7acb0$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($68717c6dc3e7acb0$export$844ec244b1367d54(value)) res = value;
    else if ($68717c6dc3e7acb0$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $68717c6dc3e7acb0$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($68717c6dc3e7acb0$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $68717c6dc3e7acb0$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$68717c6dc3e7acb0$export$844ec244b1367d54(klass)) props.class = $68717c6dc3e7acb0$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $68717c6dc3e7acb0$export$8756898546458274(style);
    return props;
}
const $68717c6dc3e7acb0$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $68717c6dc3e7acb0$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $68717c6dc3e7acb0$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $68717c6dc3e7acb0$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $68717c6dc3e7acb0$export$1ccf854a0984f890 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$HTML_TAGS);
const $68717c6dc3e7acb0$export$6328ce7565ea1049 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$SVG_TAGS);
const $68717c6dc3e7acb0$export$4a46ca4c5be17b20 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$MATH_TAGS);
const $68717c6dc3e7acb0$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$VOID_TAGS);
const $68717c6dc3e7acb0$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $68717c6dc3e7acb0$export$d186f5eb2e810715 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$specialBooleanAttrs);
const $68717c6dc3e7acb0$export$f763ba3b84e9cd8c = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8($68717c6dc3e7acb0$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $68717c6dc3e7acb0$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $68717c6dc3e7acb0$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $68717c6dc3e7acb0$var$attrValidationCache = {};
function $68717c6dc3e7acb0$export$d55ef77660f30d12(name) {
    if ($68717c6dc3e7acb0$var$attrValidationCache.hasOwnProperty(name)) return $68717c6dc3e7acb0$var$attrValidationCache[name];
    const isUnsafe = $68717c6dc3e7acb0$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $68717c6dc3e7acb0$var$attrValidationCache[name] = !isUnsafe;
}
const $68717c6dc3e7acb0$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $68717c6dc3e7acb0$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $68717c6dc3e7acb0$export$80da416f43933831 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $68717c6dc3e7acb0$export$fc0748a8e0014066 = /* @__PURE__ */ $68717c6dc3e7acb0$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $68717c6dc3e7acb0$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $68717c6dc3e7acb0$var$escapeRE = /["'&<>]/;
function $68717c6dc3e7acb0$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $68717c6dc3e7acb0$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $68717c6dc3e7acb0$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $68717c6dc3e7acb0$export$7b105034a53bde5f(src) {
    return src.replace($68717c6dc3e7acb0$var$commentStripRE, "");
}
const $68717c6dc3e7acb0$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $68717c6dc3e7acb0$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($68717c6dc3e7acb0$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $68717c6dc3e7acb0$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $68717c6dc3e7acb0$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $68717c6dc3e7acb0$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $68717c6dc3e7acb0$export$871608497c498473(a);
    let bValidType = $68717c6dc3e7acb0$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $68717c6dc3e7acb0$export$a244864fd9645c7f(a);
    bValidType = $68717c6dc3e7acb0$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $68717c6dc3e7acb0$export$43bee75e5e14138e(a);
    bValidType = $68717c6dc3e7acb0$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $68717c6dc3e7acb0$var$looseCompareArrays(a, b) : false;
    aValidType = $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(a);
    bValidType = $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$68717c6dc3e7acb0$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $68717c6dc3e7acb0$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$68717c6dc3e7acb0$export$ae8015769846262c(item, val));
}
const $68717c6dc3e7acb0$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $68717c6dc3e7acb0$export$b5b1545233b45293 = (val)=>{
    return $68717c6dc3e7acb0$export$844ec244b1367d54(val) ? val : val == null ? "" : $68717c6dc3e7acb0$export$43bee75e5e14138e(val) || $68717c6dc3e7acb0$export$a6cdc56e425d0d0a(val) && (val.toString === $68717c6dc3e7acb0$export$830c053460e5ddf6 || !$68717c6dc3e7acb0$export$f6e2535fb5126e54(val.toString)) ? $68717c6dc3e7acb0$var$isRef(val) ? $68717c6dc3e7acb0$export$b5b1545233b45293(val.value) : JSON.stringify(val, $68717c6dc3e7acb0$var$replacer, 2) : String(val);
};
const $68717c6dc3e7acb0$var$replacer = (_key, val)=>{
    if ($68717c6dc3e7acb0$var$isRef(val)) return $68717c6dc3e7acb0$var$replacer(_key, val.value);
    else if ($68717c6dc3e7acb0$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$68717c6dc3e7acb0$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($68717c6dc3e7acb0$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$68717c6dc3e7acb0$var$stringifySymbol(v))
    };
    else if ($68717c6dc3e7acb0$export$a244864fd9645c7f(val)) return $68717c6dc3e7acb0$var$stringifySymbol(val);
    else if ($68717c6dc3e7acb0$export$a6cdc56e425d0d0a(val) && !$68717c6dc3e7acb0$export$43bee75e5e14138e(val) && !$68717c6dc3e7acb0$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $68717c6dc3e7acb0$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $68717c6dc3e7acb0$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $68717c6dc3e7acb0$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});


parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8XWQX")).camelize);
$parcel$export(module.exports, "cloneVNode", () => (parcelRequire("TusQn")).cloneVNode);
$parcel$export(module.exports, "Comment", () => (parcelRequire("TusQn")).Comment);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createSlots", () => (parcelRequire("TusQn")).createSlots);
$parcel$export(module.exports, "createStaticVNode", () => (parcelRequire("TusQn")).createStaticVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "customRef", () => (parcelRequire("01W3b")).customRef);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("TusQn")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("TusQn")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("01W3b")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "isVNode", () => (parcelRequire("TusQn")).isVNode);
$parcel$export(module.exports, "KeepAlive", () => (parcelRequire("TusQn")).KeepAlive);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8XWQX")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8XWQX")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("TusQn")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "renderSlot", () => (parcelRequire("TusQn")).renderSlot);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDirective", () => (parcelRequire("TusQn")).resolveDirective);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("01W3b")).shallowReactive);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "toHandlerKey", () => (parcelRequire("8XWQX")).toHandlerKey);
$parcel$export(module.exports, "toHandlers", () => (parcelRequire("TusQn")).toHandlers);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useAttrs", () => (parcelRequire("TusQn")).useAttrs);
$parcel$export(module.exports, "useSlots", () => (parcelRequire("TusQn")).useSlots);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("01W3b")).shallowReadonly);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "triggerRef", () => (parcelRequire("01W3b")).triggerRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8XWQX")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8XWQX")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "useCssVars", () => $a5d55dc64ccb07cf$export$ef28b76f07940108);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "render", () => $a5d55dc64ccb07cf$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $a5d55dc64ccb07cf$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelRadio", () => $a5d55dc64ccb07cf$export$b4356c59b38b7aa9);
$parcel$export(module.exports, "vModelDynamic", () => $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
/**
* @vue/runtime-dom v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
var $01W3b = parcelRequire("01W3b");
var $01W3b = parcelRequire("01W3b");parcelRequire("8XWQX");

var $4YcVI = parcelRequire("4YcVI");
let $a5d55dc64ccb07cf$var$policy = void 0;
const $a5d55dc64ccb07cf$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($a5d55dc64ccb07cf$var$tt) try {
    $a5d55dc64ccb07cf$var$policy = /* @__PURE__ */ $a5d55dc64ccb07cf$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $a5d55dc64ccb07cf$var$unsafeToTrustedHTML = $a5d55dc64ccb07cf$var$policy ? (val)=>$a5d55dc64ccb07cf$var$policy.createHTML(val) : (val)=>val;
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : is ? $a5d55dc64ccb07cf$var$doc.createElement(tag, {
            is: is
        }) : $a5d55dc64ccb07cf$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = Symbol("_vtc");
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = /* @__PURE__ */ (0, $4YcVI.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $a5d55dc64ccb07cf$var$TransitionPropsValidators;
    return t;
};
const $a5d55dc64ccb07cf$export$be58926105124dd4 = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate$1((props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots));
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $4YcVI.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $4YcVI.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $4YcVI.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $a5d55dc64ccb07cf$var$forceReflow();
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
                $a5d55dc64ccb07cf$var$forceReflow();
            }
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $4YcVI.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $4YcVI.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow() {
    return document.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $a5d55dc64ccb07cf$var$setVarsOnNode(instance.ce, vars);
        else $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        (0, $TusQn.queuePostFlushCb)(setVars);
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(setVars, (0, $4YcVI.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $4YcVI.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $4YcVI.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $4YcVI.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $4YcVI.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $4YcVI.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8XWQX.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $4YcVI.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $4YcVI.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $4YcVI.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $4YcVI.isSymbol)(value) ? String(value) : value);
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $4YcVI.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $4YcVI.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $4YcVI.isFunction)(value) || (0, $4YcVI.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $4YcVI.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $4YcVI.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$var$patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $4YcVI.isOn)(key)) {
        if (!(0, $4YcVI.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $4YcVI.isString)(nextValue))) $a5d55dc64ccb07cf$var$patchDOMProp(el, (0, $4YcVI.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $4YcVI.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $4YcVI.isString)(value)) return false;
    return key in el;
}
const $a5d55dc64ccb07cf$var$REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    const Comp = (0, $TusQn.defineComponent)(options, extraOptions);
    if ((0, $4YcVI.isPlainObject)(Comp)) (0, $4YcVI.extend)(Comp, extraOptions);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, $a5d55dc64ccb07cf$export$35800275c0037383);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $a5d55dc64ccb07cf$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $a5d55dc64ccb07cf$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $4YcVI.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $4YcVI.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $4YcVI.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>{
            def.configureApp = this._def.configureApp;
            resolve(this._def = def, true);
        });
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $4YcVI.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $01W3b.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $4YcVI.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $4YcVI.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $a5d55dc64ccb07cf$var$REMOVAL;
        const camelKey = (0, $4YcVI.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $4YcVI.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === $a5d55dc64ccb07cf$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                ob && ob.disconnect();
                if (val === true) this.setAttribute((0, $4YcVI.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $4YcVI.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $4YcVI.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $4YcVI.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $4YcVI.isPlainObject)(args[0]) ? (0, $4YcVI.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $4YcVI.hyphenate)(event) !== event) dispatch((0, $4YcVI.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $a5d55dc64ccb07cf$export$da5acfe93a94e37d(caller) {
    const instance = (0, $TusQn.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $TusQn.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $TusQn.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $a5d55dc64ccb07cf$export$64d45095031fa749() {
    const el = $a5d55dc64ccb07cf$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $4YcVI.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $4YcVI.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $4YcVI.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $4YcVI.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
});
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $4YcVI.isArray)(fn) ? (value)=>(0, $4YcVI.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = Symbol("_assign");
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $4YcVI.looseToNumber)(domValue);
            el[$a5d55dc64ccb07cf$var$assignKey](domValue);
        });
        if (trim) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $4YcVI.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $4YcVI.isArray)(modelValue)) {
                const index = (0, $4YcVI.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $4YcVI.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $4YcVI.isArray)(value)) checked = (0, $4YcVI.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $4YcVI.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $4YcVI.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $4YcVI.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $4YcVI.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $4YcVI.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $4YcVI.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $4YcVI.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $4YcVI.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $4YcVI.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $4YcVI.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $4YcVI.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $4YcVI.isArray)(value)) {
            if (vnode.props && (0, $4YcVI.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $4YcVI.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $4YcVI.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $4YcVI.extend)({
    patchProp: $a5d55dc64ccb07cf$var$patchProp
}, $a5d55dc64ccb07cf$var$nodeOps);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $4YcVI.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $4YcVI.isHTMLTag)(tag) || (0, $4YcVI.isSVGTag)(tag) || (0, $4YcVI.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $4YcVI.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});
parcelRegister("4YcVI", function(module, exports) {

$parcel$export(module.exports, "EMPTY_OBJ", () => $39e6cba439e3586f$export$cf583d23ab39677c);
$parcel$export(module.exports, "NOOP", () => $39e6cba439e3586f$export$5702a91a6f42969f);
$parcel$export(module.exports, "isOn", () => $39e6cba439e3586f$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $39e6cba439e3586f$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $39e6cba439e3586f$export$8b58be045bf06082);
$parcel$export(module.exports, "hasOwn", () => $39e6cba439e3586f$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $39e6cba439e3586f$export$43bee75e5e14138e);
$parcel$export(module.exports, "isSet", () => $39e6cba439e3586f$export$6750766a7c7ec627);
$parcel$export(module.exports, "isFunction", () => $39e6cba439e3586f$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $39e6cba439e3586f$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $39e6cba439e3586f$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $39e6cba439e3586f$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPlainObject", () => $39e6cba439e3586f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "camelize", () => $39e6cba439e3586f$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $39e6cba439e3586f$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $39e6cba439e3586f$export$9a00dee1beb8f576);
$parcel$export(module.exports, "invokeArrayFns", () => $39e6cba439e3586f$export$39951422d618a9d3);
$parcel$export(module.exports, "looseToNumber", () => $39e6cba439e3586f$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $39e6cba439e3586f$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "isHTMLTag", () => $39e6cba439e3586f$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $39e6cba439e3586f$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $39e6cba439e3586f$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $39e6cba439e3586f$export$d186f5eb2e810715);
$parcel$export(module.exports, "includeBooleanAttr", () => $39e6cba439e3586f$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "looseEqual", () => $39e6cba439e3586f$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $39e6cba439e3586f$export$42912a80cedb8bd4);
$parcel$export(module.exports, "normalizeCssVarValue", () => $39e6cba439e3586f$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.18
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function $39e6cba439e3586f$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $39e6cba439e3586f$export$cf583d23ab39677c = {};
const $39e6cba439e3586f$export$6bd8558f433f1cc1 = [];
const $39e6cba439e3586f$export$5702a91a6f42969f = ()=>{};
const $39e6cba439e3586f$export$c01351c0af048e39 = ()=>false;
const $39e6cba439e3586f$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $39e6cba439e3586f$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $39e6cba439e3586f$export$8b58be045bf06082 = Object.assign;
const $39e6cba439e3586f$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $39e6cba439e3586f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $39e6cba439e3586f$export$b5a638e9b3fff9f3 = (val, key)=>$39e6cba439e3586f$var$hasOwnProperty.call(val, key);
const $39e6cba439e3586f$export$43bee75e5e14138e = Array.isArray;
const $39e6cba439e3586f$export$5c90113a285f2241 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Map]";
const $39e6cba439e3586f$export$6750766a7c7ec627 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Set]";
const $39e6cba439e3586f$export$871608497c498473 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Date]";
const $39e6cba439e3586f$export$49841c62b9eff15 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object RegExp]";
const $39e6cba439e3586f$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $39e6cba439e3586f$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $39e6cba439e3586f$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $39e6cba439e3586f$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $39e6cba439e3586f$export$4369c812aac99591 = (val)=>{
    return ($39e6cba439e3586f$export$a6cdc56e425d0d0a(val) || $39e6cba439e3586f$export$f6e2535fb5126e54(val)) && $39e6cba439e3586f$export$f6e2535fb5126e54(val.then) && $39e6cba439e3586f$export$f6e2535fb5126e54(val.catch);
};
const $39e6cba439e3586f$export$830c053460e5ddf6 = Object.prototype.toString;
const $39e6cba439e3586f$export$1dccc787cc36538b = (value)=>$39e6cba439e3586f$export$830c053460e5ddf6.call(value);
const $39e6cba439e3586f$export$5ad0a3c360b8fbb5 = (value)=>{
    return $39e6cba439e3586f$export$1dccc787cc36538b(value).slice(8, -1);
};
const $39e6cba439e3586f$export$53b83ca8eaab0383 = (val)=>$39e6cba439e3586f$export$1dccc787cc36538b(val) === "[object Object]";
const $39e6cba439e3586f$export$e2a2b93446ec9fe = (key)=>$39e6cba439e3586f$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $39e6cba439e3586f$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $39e6cba439e3586f$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $39e6cba439e3586f$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $39e6cba439e3586f$var$camelizeRE = /-(\w)/g;
const $39e6cba439e3586f$export$161d051f5dd25de7 = $39e6cba439e3586f$var$cacheStringFunction((str)=>{
    return str.replace($39e6cba439e3586f$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $39e6cba439e3586f$var$hyphenateRE = /\B([A-Z])/g;
const $39e6cba439e3586f$export$6e6a0a3676c4b8bb = $39e6cba439e3586f$var$cacheStringFunction((str)=>str.replace($39e6cba439e3586f$var$hyphenateRE, "-$1").toLowerCase());
const $39e6cba439e3586f$export$9a00dee1beb8f576 = $39e6cba439e3586f$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $39e6cba439e3586f$export$8c022799eeaaefcd = $39e6cba439e3586f$var$cacheStringFunction((str)=>{
    const s = str ? `on${$39e6cba439e3586f$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $39e6cba439e3586f$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $39e6cba439e3586f$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $39e6cba439e3586f$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $39e6cba439e3586f$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $39e6cba439e3586f$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $39e6cba439e3586f$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $39e6cba439e3586f$var$_globalThis;
const $39e6cba439e3586f$export$ff5f2eeb11fc7e14 = ()=>{
    return $39e6cba439e3586f$var$_globalThis || ($39e6cba439e3586f$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $39e6cba439e3586f$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $39e6cba439e3586f$export$53d5e12f9a1d3cde(name) {
    return $39e6cba439e3586f$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $39e6cba439e3586f$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $39e6cba439e3586f$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $39e6cba439e3586f$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $39e6cba439e3586f$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $39e6cba439e3586f$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $39e6cba439e3586f$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $39e6cba439e3586f$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $39e6cba439e3586f$export$f73b8c13b7f97ebf = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$GLOBALS_ALLOWED);
const $39e6cba439e3586f$export$d6571a1911e4f27e = $39e6cba439e3586f$export$f73b8c13b7f97ebf;
const $39e6cba439e3586f$var$range = 2;
function $39e6cba439e3586f$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $39e6cba439e3586f$var$range; j <= i + $39e6cba439e3586f$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $39e6cba439e3586f$export$8756898546458274(value) {
    if ($39e6cba439e3586f$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $39e6cba439e3586f$export$844ec244b1367d54(item) ? $39e6cba439e3586f$export$76a205ce979d066a(item) : $39e6cba439e3586f$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($39e6cba439e3586f$export$844ec244b1367d54(value) || $39e6cba439e3586f$export$a6cdc56e425d0d0a(value)) return value;
}
const $39e6cba439e3586f$var$listDelimiterRE = /;(?![^(]*\))/g;
const $39e6cba439e3586f$var$propertyDelimiterRE = /:([^]+)/;
const $39e6cba439e3586f$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $39e6cba439e3586f$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($39e6cba439e3586f$var$styleCommentRE, "").split($39e6cba439e3586f$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($39e6cba439e3586f$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $39e6cba439e3586f$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($39e6cba439e3586f$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($39e6cba439e3586f$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $39e6cba439e3586f$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $39e6cba439e3586f$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($39e6cba439e3586f$export$844ec244b1367d54(value)) res = value;
    else if ($39e6cba439e3586f$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $39e6cba439e3586f$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($39e6cba439e3586f$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $39e6cba439e3586f$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$39e6cba439e3586f$export$844ec244b1367d54(klass)) props.class = $39e6cba439e3586f$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $39e6cba439e3586f$export$8756898546458274(style);
    return props;
}
const $39e6cba439e3586f$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $39e6cba439e3586f$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $39e6cba439e3586f$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $39e6cba439e3586f$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $39e6cba439e3586f$export$1ccf854a0984f890 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$HTML_TAGS);
const $39e6cba439e3586f$export$6328ce7565ea1049 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$SVG_TAGS);
const $39e6cba439e3586f$export$4a46ca4c5be17b20 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$MATH_TAGS);
const $39e6cba439e3586f$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$VOID_TAGS);
const $39e6cba439e3586f$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $39e6cba439e3586f$export$d186f5eb2e810715 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$specialBooleanAttrs);
const $39e6cba439e3586f$export$f763ba3b84e9cd8c = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8($39e6cba439e3586f$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $39e6cba439e3586f$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $39e6cba439e3586f$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $39e6cba439e3586f$var$attrValidationCache = {};
function $39e6cba439e3586f$export$d55ef77660f30d12(name) {
    if ($39e6cba439e3586f$var$attrValidationCache.hasOwnProperty(name)) return $39e6cba439e3586f$var$attrValidationCache[name];
    const isUnsafe = $39e6cba439e3586f$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $39e6cba439e3586f$var$attrValidationCache[name] = !isUnsafe;
}
const $39e6cba439e3586f$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $39e6cba439e3586f$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $39e6cba439e3586f$export$80da416f43933831 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $39e6cba439e3586f$export$fc0748a8e0014066 = /* @__PURE__ */ $39e6cba439e3586f$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $39e6cba439e3586f$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $39e6cba439e3586f$var$escapeRE = /["'&<>]/;
function $39e6cba439e3586f$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $39e6cba439e3586f$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $39e6cba439e3586f$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $39e6cba439e3586f$export$7b105034a53bde5f(src) {
    return src.replace($39e6cba439e3586f$var$commentStripRE, "");
}
const $39e6cba439e3586f$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $39e6cba439e3586f$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($39e6cba439e3586f$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $39e6cba439e3586f$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $39e6cba439e3586f$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $39e6cba439e3586f$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $39e6cba439e3586f$export$871608497c498473(a);
    let bValidType = $39e6cba439e3586f$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $39e6cba439e3586f$export$a244864fd9645c7f(a);
    bValidType = $39e6cba439e3586f$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $39e6cba439e3586f$export$43bee75e5e14138e(a);
    bValidType = $39e6cba439e3586f$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $39e6cba439e3586f$var$looseCompareArrays(a, b) : false;
    aValidType = $39e6cba439e3586f$export$a6cdc56e425d0d0a(a);
    bValidType = $39e6cba439e3586f$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$39e6cba439e3586f$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $39e6cba439e3586f$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$39e6cba439e3586f$export$ae8015769846262c(item, val));
}
const $39e6cba439e3586f$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $39e6cba439e3586f$export$b5b1545233b45293 = (val)=>{
    return $39e6cba439e3586f$export$844ec244b1367d54(val) ? val : val == null ? "" : $39e6cba439e3586f$export$43bee75e5e14138e(val) || $39e6cba439e3586f$export$a6cdc56e425d0d0a(val) && (val.toString === $39e6cba439e3586f$export$830c053460e5ddf6 || !$39e6cba439e3586f$export$f6e2535fb5126e54(val.toString)) ? $39e6cba439e3586f$var$isRef(val) ? $39e6cba439e3586f$export$b5b1545233b45293(val.value) : JSON.stringify(val, $39e6cba439e3586f$var$replacer, 2) : String(val);
};
const $39e6cba439e3586f$var$replacer = (_key, val)=>{
    if ($39e6cba439e3586f$var$isRef(val)) return $39e6cba439e3586f$var$replacer(_key, val.value);
    else if ($39e6cba439e3586f$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$39e6cba439e3586f$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($39e6cba439e3586f$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$39e6cba439e3586f$var$stringifySymbol(v))
    };
    else if ($39e6cba439e3586f$export$a244864fd9645c7f(val)) return $39e6cba439e3586f$var$stringifySymbol(val);
    else if ($39e6cba439e3586f$export$a6cdc56e425d0d0a(val) && !$39e6cba439e3586f$export$43bee75e5e14138e(val) && !$39e6cba439e3586f$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $39e6cba439e3586f$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $39e6cba439e3586f$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $39e6cba439e3586f$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("iM5gW", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $dab0cca5d4246c24$export$63b9a9bba9f20f3e);

var $6K6yo = parcelRequire("6K6yo");

var $7oT4w = parcelRequire("7oT4w");

var $k08Bt = parcelRequire("k08Bt");



function $dab0cca5d4246c24$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $6K6yo.getTarget)();
    const hook = (0, $6K6yo.getDevtoolsGlobalHook)();
    const enableProxy = (0, $6K6yo.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $7oT4w.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $k08Bt.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("6K6yo", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $4e8c1f6679972f34$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $4e8c1f6679972f34$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $4e8c1f6679972f34$export$bc32a04c49ed7464);
function $4e8c1f6679972f34$export$5a2d366b2d9f38f6() {
    return $4e8c1f6679972f34$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $4e8c1f6679972f34$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $4e8c1f6679972f34$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("7oT4w", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $56357e6fc7d4b9fa$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $56357e6fc7d4b9fa$export$a0897f44accbe922);
const $56357e6fc7d4b9fa$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $56357e6fc7d4b9fa$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("k08Bt", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $e8fa7b331d4b64b4$export$5728f3776e9b2ac1);

var $7oT4w = parcelRequire("7oT4w");

var $26JMq = parcelRequire("26JMq");
class $e8fa7b331d4b64b4$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $26JMq.now)();
            }
        };
        if (hook) hook.on((0, $7oT4w.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("26JMq", function(module, exports) {

$parcel$export(module.exports, "now", () => $188fa7419712e350$export$461939dd4422153);
let $188fa7419712e350$var$supported;
let $188fa7419712e350$var$perf;
function $188fa7419712e350$export$70d26280bc1ca547() {
    var _a;
    if ($188fa7419712e350$var$supported !== undefined) return $188fa7419712e350$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $188fa7419712e350$var$supported = true;
        $188fa7419712e350$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $188fa7419712e350$var$supported = true;
        $188fa7419712e350$var$perf = globalThis.perf_hooks.performance;
    } else $188fa7419712e350$var$supported = false;
    return $188fa7419712e350$var$supported;
}
function $188fa7419712e350$export$461939dd4422153() {
    return $188fa7419712e350$export$70d26280bc1ca547() ? $188fa7419712e350$var$perf.now() : Date.now();
}

});




parcelRegister("eZeDV", function(module, exports) {
/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader = false;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function init(converter) {
        function api(key, value, attributes) {
            var result;
            if (typeof document === 'undefined') return;
            // Write
            if (arguments.length > 1) {
                attributes = extend({
                    path: '/'
                }, api.defaults, attributes);
                if (typeof attributes.expires === 'number') {
                    var expires = new Date();
                    expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
                    attributes.expires = expires;
                }
                // We're using "expires" because "max-age" is not supported by IE
                attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
                try {
                    result = JSON.stringify(value);
                    if (/^[\{\[]/.test(result)) value = result;
                } catch (e) {}
                if (!converter.write) value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                else value = converter.write(value, key);
                key = encodeURIComponent(String(key));
                key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                key = key.replace(/[\(\)]/g, escape);
                var stringifiedAttributes = '';
                for(var attributeName in attributes){
                    if (!attributes[attributeName]) continue;
                    stringifiedAttributes += '; ' + attributeName;
                    if (attributes[attributeName] === true) continue;
                    stringifiedAttributes += '=' + attributes[attributeName];
                }
                return document.cookie = key + '=' + value + stringifiedAttributes;
            }
            // Read
            if (!key) result = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling "get()"
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var rdecode = /(%[0-9A-Z]{2})+/g;
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!this.json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = parts[0].replace(rdecode, decodeURIComponent);
                    cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
                    if (this.json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    if (key === name) {
                        result = cookie;
                        break;
                    }
                    if (!key) result[name] = cookie;
                } catch (e) {}
            }
            return result;
        }
        api.set = api;
        api.get = function(key) {
            return api.call(api, key);
        };
        api.getJSON = function() {
            return api.apply({
                json: true
            }, [].slice.call(arguments));
        };
        api.defaults = {};
        api.remove = function(key, attributes) {
            api(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("ggNjQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd8465ba247bf189$export$2e2bcd8739ae039);
var $bd8465ba247bf189$export$2e2bcd8739ae039 = {
    logs: {
        export: {
            btn: 'Export',
            text: 'operation log'
        },
        overtimeError: 'Logs older than one year are not available for viewing. Please select a different time period.',
        operateSystem: {
            value3: 'Scanat App',
            value4: 'Scanat Web',
            value1: 'ID Management'
        },
        operatePage: {
            login: 'Login/Registration',
            personal_setting: 'Personal Settings',
            local_model: 'Local Models',
            in_box: 'Inbox',
            cloud_model: 'Cloud Models',
            sample_model: 'Sample List',
            main_list: 'Main List',
            member_manage: 'ID Management',
            company_info: 'Company Information',
            order_manage: 'Order History',
            SharedSpace: 'Shared Space',
            TeamsSpace: 'Team Space',
            team_space: 'Team Space',
            personal_space: 'Personal Space',
            model_link: 'Model link',
            invite_link: 'Invitation link'
        },
        operateType: {
            login: 'Login',
            register: 'Register',
            cancellation: 'Delete Account',
            deleteModel: 'Delete Model',
            addModel: 'Create New Model',
            viewModel: 'View Model',
            viewSampleModel: 'View Model',
            editModel: 'Edit Model',
            editModelInfo: 'Edit Model',
            editModelAvatar: 'Edit Model',
            editModelName: 'Edit Model',
            shareModel: 'Send Model',
            copyModelShareLink: 'Send Model',
            moveModel: 'Move Model',
            uploadModel: 'Upload Model',
            exportModel: 'Export Model',
            copyModel: 'Copy Model',
            applyCad: 'Request CAD Drawing',
            addFolder: 'Create New Folder',
            editFolder: 'Edit Folder',
            deleteFolder: 'Delete Folder',
            moveFolder: 'Move Folder',
            downloadModel: 'Download Model',
            buyAccountPlan: 'Purchase Plan',
            inviteMember: 'Add New Member',
            addEnableMember: 'Add New Member',
            addDisableMember: 'Add New Member',
            enableMember: 'Edit Member',
            disableMember: 'Edit Member',
            setMemberAdmin: 'Edit Member',
            unsetMemberAdmin: 'Edit Member',
            editMemberName: 'Edit Member',
            editCustomerInfo: 'Edit Information',
            downloadInvoices: 'Download transaction documents',
            addId: 'Add Member ID',
            switchCard: 'Change Payment Credit Card',
            batchAdd: 'Add in Bulk',
            batchDelete: 'Delete in Bulk',
            activeMember: 'Activate Member ID',
            deleteMember: 'Delete Member ID',
            payOrder: 'Order Payment',
            cancelOrder: 'Order Cancellation',
            PermissionChange: 'Permission Change',
            URLreset: 'URL Reset',
            FolderSharing: 'Folder Sharing',
            expandOrder: 'Expansion of ID count',
            changeCard: 'Change Payment Credit Card',
            batchAddMembers: 'Add in Bulk',
            batchDeleteMembers: 'Delete in Bulk',
            exportMember: 'Export',
            buyOrder: 'Purchase Plan',
            addMember: 'Add New Member',
            editCustomer: 'Edit Information',
            planCancelApplication: 'Cancel subscription',
            editLink: 'Edit Link',
            moveModelHome: 'Move Model',
            moveFolderHome: 'Move Folder',
            copyLink: 'Send Model',
            changeLink: 'Edit Link',
            changeLinkPassword: 'Edit Link',
            resetPassword: 'Password Reset',
            addMemberNew: 'Add New Member',
            editMemberStatus: 'Edit Member',
            editMemberNew: 'Edit Member',
            enable: 'Enable Member',
            disable: 'Disable Member',
            changeSeat: 'Changed ID consumption setting',
            changeRole: 'Edit Role ',
            uploadFile: 'Import Model File',
            manageCollaborator: 'Manage collaborators',
            moveFolderToFolder: 'Move Folder',
            moveFolderToRoot: 'Move Folder',
            moveModelToFolder: 'Move Model',
            moveModelToRoot: 'Move Model',
            addCollaborator: 'Manage collaborators',
            deleteCollaborator: 'Manage collaborators',
            updateCollaborator: 'Manage collaborators',
            inviteCollaborator: 'Add collaborators',
            resentInvite: 'Add collaborators',
            resentInviteWithDate: 'Add collaborators',
            acceptInvite: 'Accept invitation',
            viewFolder: 'Open the folder',
            uploadToFolder: 'Upload Model',
            uploadToRoot: 'Upload Model',
            importFileToRoot: 'Import Model File',
            importFileToFolder: 'Import Model File'
        },
        detail: {
            register: 'Created account',
            login: 'Logged into the system',
            cancellation: 'Deleted account',
            deleteModel: 'Deleted model "{detail0}"',
            addModel: 'Scanned model "{detail0}" with "{detail1}"',
            viewModel: 'Viewed model "{detail0}"',
            editModelInfo: 'Updated model "{detail0}" information to "Model name: {detail1}\uFF1BPostal Code: {detail2}\uFF1BAddress: {detail3}\uFF1BBuilding name: {detail4}"',
            editModelAvatar: 'Changed cover image for model "{detail0}"',
            editModel: 'Performed "{detail1}" operation on model "{detail0}"',
            moveModel: 'Moved model "{detail0}" to folder "{detail1}"',
            uploadModel: 'Uploaded model "{detail0}" to cloud',
            exportModel: 'Exported data for model "{detail0}"',
            copyModel: 'Copied model "{detail0}" as "{detail1}"',
            applyCad: 'Requested CAD drawing for model "{detail0}"',
            addFolder: 'Created new folder "{detail0}"',
            editFolder: 'Renamed folder "{detail0}" to "{detail1}"',
            deleteFolder: 'Deleted folder "{detail0}"',
            moveFolder: 'Moved folder "{detail0}" to folder "{detail1}"',
            downloadModel: 'Downloaded model "{detail0}"',
            viewSampleModel: 'Viewed "sample model"',
            editModelName: 'Renamed model "{detail0}" to "{detail1}"',
            buyAccountPlan: 'Purchased "{detail0}". ID Limit: {detail1} user(s), Total price (incl. tax): {detail2}JPY, Payment method: "{detail3}"',
            addEnableMember: 'Added member "{detail0}", status: "Active"',
            addDisableMember: 'Added member "{detail0}", status: "Disabled"',
            inviteMember: 'Added member "{detail0}", currently awaiting invitation approval',
            enableMember: 'Set member "{detail0}" status to "Active"',
            disableMember: 'Set member "{detail0}" status to "Disabled"',
            setMemberAdmin: 'Granted administrator rights for member "{detail0}"',
            unsetMemberAdmin: 'Removed administrator rights for member "{detail0}"',
            editMemberName: 'Renamed member "{detail0}" to "{detail1}"',
            editCustomerInfo: 'Edited company information to "Postal Code: {detail0}, Prefecture: {detail1}, City: {detail2}, Address: {detail3}, Responsible Person: {detail4} {detail5}, Phone Number: {detail6}, Industry: {detail7}, Number of Employees: {detail8}, Primary Business: {detail9}"',
            downloadInvoices: 'Downloaded invoice for order "{detail0}" to local storage',
            moveModelHome: 'Moved model "{detail0}" to "Home"',
            moveFolderHome: 'Moved folder "{detail0}" to "Home"',
            expandOrder: '[Expansion of ID count] Order has been submitted. Order details: "Order Number: {detail0}; Plan: {detail1}; Order Type: ID Addition; Subscription: {detail2}; Additional IDs: {detail3}; Start Date: {detail4}; Amount: {detail5}; Tax: {detail6}; Total Payment Amount: {detail7}"',
            buyOrder: '[Purchase Plan] Order has been submitted. Order details: "Order Number: {detail0}; Plan: {detail1}; Order Type: Purchase; Subscription: {detail2}; IDs:{detail3};Amount: {detail4}; Tax: {detail5}; Total Payment Amount: {detail6}"',
            changeCard: 'Changed the payment credit card to {detail0}.',
            addMember: 'Added member {detail0}. Status: {detail1}.',
            batchAddMembers: 'Bulk added {detail0} members.',
            batchDeleteMembers: 'Bulk deleted {detail0} members.',
            exportMember: 'Exported the member list.',
            activeMember: 'Activated member [{detail0}].',
            deleteMember: 'Deleted member [{detail0}].',
            editCustomer: 'Edited company information to "Company Name: {detail0}; Contact Person: {detail1} {detail2} {detail3}; Postal Code: {detail4}; Address: {detail5}; Industry: {detail6}; Number of Employees: {detail7}; Capital: {detail8}; Main Business: {detail9}"',
            payOrder: 'Payment for order [{detail0}] has been completed. Payment method: {detail1}.',
            cancelOrder: 'Order [{detail0}] has been cancelled.',
            SendModelViewable: 'Send the model "{detail0}" with user "{detail1}". Access permission is "Viewable".',
            CopiedModelPrivateLink: 'Copied the "Private Link" of the model "{detail0}".',
            AddedModelMember: 'Added member "{detail1}" to the model "{detail0}" with "Viewable" permissions.',
            UpdatedModelMember: 'Updated member "{detail1}" in the model "{detail0}" to have "Editable" permissions.',
            RemovedModelViewable: 'Removed "Viewable" permissions for member "{detail1}" in the model "{detail0}".',
            ResetModelPrivateLink: 'Reset the "Private Link" of the model "{detail0}".',
            SharedFolder: 'Shared the folder "{detail0}" with user "{detail1}". ',
            CopiedFolderPublicLink: 'Copied the "Public Link" for the folder "{detail0}".',
            ResetModelPublicLink: 'Reset the "Public Link" for the model "{detail0}".',
            SendModelEditable: 'Send the model "{detail0}" to user "{detail1}". Access permission is "Editable".',
            RenamedFolder: 'The folder "{detail0}" has been renamed to "{detail1}" with the description: "{detail2}".',
            SharedFolderViewable: 'Shared the folder "{detail0}" with user "{detail1}". Access permission is "Viewable".',
            CopiedFolderPrivateLink: 'Copied the "Private link" for the folder "{detail0}".',
            AddedFolderMember: 'Added member "{detail1}" to the folder "{detail0}" with "Viewable" permissions.',
            UpdatedFolderMember: 'Updated member "{detail1}" in the folder "{detail0}" to have "Editable" permissions.',
            RemovedFolderViewable: 'Removed "Viewable" permissions for member "{detail1}" in the folder "{detail0}".',
            ResetFolderPublicLink: 'Reset the "Public Link" for the folder "{detail0}".',
            addModel1: 'Layout Scan',
            addModel2: 'Normal Scan',
            editModel1: 'Trim',
            editModel2: 'Align',
            editModel3: 'Transform',
            buyAccountPlan2: 'Invoice',
            buyAccountPlan1: 'Credit Card',
            editCustomerSex0: 'Male',
            editCustomerSex1: 'Female',
            editCustomerInfo1: 'Construction',
            editCustomerInfo2: 'Manufacturing',
            editCustomerInfo3: 'Real Estate and Goods Rental and Leasing',
            editCustomerInfo4: 'Information and Communications',
            editCustomerInfo5: 'Electricity, Gas, Heat Supply and Water',
            editCustomerInfo6: 'Transport and Postal Services',
            editCustomerInfo7: 'Information Services',
            editCustomerInfo8: 'Scientific Research, Professional and Technical Services',
            editCustomerInfo9: 'Wholesale and Retail Trade',
            editCustomerInfo10: 'Research Industry',
            editCustomerInfo0: '-',
            editCustomerInfoStaff1: '1~50',
            editCustomerInfoStaff2: '51~100',
            editCustomerInfoStaff3: 'More than 100',
            editCustomerInfoStaff0: '-',
            editCustomer1: 'Construction',
            editCustomer2: 'Manufacturing',
            editCustomer3: 'Real Estate and Goods Rental and Leasing',
            editCustomer4: 'Information and Communications',
            editCustomer5: 'Electricity, Gas, Heat Supply and Water',
            editCustomer6: 'Transport and Postal Services',
            editCustomer7: 'Information Services',
            editCustomer8: 'Scientific Research, Professional and Technical Services',
            editCustomer9: 'Wholesale and Retail Trade',
            editCustomer10: 'Research Industry',
            editCustomer0: '-',
            editCustomerStaff1: '1~50',
            editCustomerStaff2: '51~100',
            editCustomerStaff3: 'More than 100',
            editCustomerStaff0: '-',
            payOrder1: 'Credit card',
            payOrder2: 'Invoice',
            addMember0: 'Not Active',
            addMember1: 'Activated',
            period1: 'Annual Billing',
            period2: 'Monthly Billing',
            planCancelApplication: 'Submitted a subscription cancellation request.',
            shareModel: 'Send model "{detail0}" to user "{detail1}"',
            copyModelShareLink: 'Copied shared link for model "{detail0}"',
            changeLinkPassword: 'Changed the password for the password-protected link of model  "{detail0}".',
            ResetModelLink: 'Reset the "{detail1}" of the model "{detail0}".',
            ResetFolderLink: 'Reset \'{detail1}\' of folder "{detail0}".',
            resetPassword: 'The password has been reset.',
            copyLink1: 'Private Link',
            copyLink2: 'Password-protected Link',
            copyLink3: 'Public Link',
            changeLink1: 'Private Link',
            changeLink2: 'Password-protected Link',
            changeLink3: 'Public Link',
            copyLink: 'Copied the "{detail1}" of the model "{detail0}".',
            changeLink: 'Changed sharing link permissions for model  "{detail0}" to  "{detail1}".',
            editMemberStatus: 'Update member "{detail0}" status to "{detail1}" .',
            addMemberNew: 'New member "{detail0}" has been added. Role: "{detail1}"; ID consumption setting: "{detail2}"; Status:  "In Use".',
            editMemberNew: 'Member "{detail0}" has been updated: Name to "{detail1}", Role to "{detail2}", and ID consumption setting to "{detail3}".',
            enable: 'Member "{detail0}" has been enabled.',
            disable: 'Member "{detail0}" has been disabled.',
            changeSeat: 'Update the ID consumption setting of member "{detail0}" to "{detail1}".',
            changeRole: 'Update the role of member "{detail0}" to "{detail1}".',
            role1: 'Super administrator',
            role3: 'Administrator',
            role0: 'Scanat User',
            role4: 'Viewer',
            changeSeat1: 'ON',
            changeSeat0: 'OFF',
            uploadFile: 'The model "{detail0}" has been imported. The file type is {detail1}.',
            uploadToFolder: 'Uploaded model "{detail0}" to folder "{detail2}" of "{detail1}".',
            uploadToRoot: 'Uploaded model "{detail0}" to {detail1}\'s "Home".',
            moveFolderToFolder: 'Moved folder "{detail0}" to {detail1}\'s folder "{detail2}".',
            moveFolderToRoot: 'Moved folder "{detail0}" to {detail1}\'s "Home".',
            moveModelToFolder: 'Moved model "{detail0}" to {detail1}\'s folder "{detail2}".',
            moveModelToRoot: 'Moved model "{detail0}" to {detail1}\'s "Home".',
            addCollaborator: 'Set "{detail2}" as the collaborator on {detail0} "{detail1}" with the permission of "{detail3}".',
            deleteCollaborator: 'Deleted the collaborator "{detail2}" from {detail0} "{detail1}".',
            updateCollaborator: 'Set permission of collaborator "{detail2}" on {detail0} "{detail1}" to "{detail3}".',
            space0: 'Personal Space',
            space1: 'Team Space',
            fileType0: 'Model',
            fileType1: 'Folder',
            collaboratorPermission0: 'View only',
            collaboratorPermission1: 'Editable',
            collaboratorPermission2: 'Manageable',
            importFile: 'The model \\"{detail0}\\" has been imported. The file type is {detail1}.',
            inviteCollaborator: 'Invitation sent to "{detail0}" with {detail1} permission. Expires in {detail2} days.',
            resentInvite: 'Invitation resent to "{detail0}".',
            resentInviteWithDate: 'Invitation resent to "{detail0}". Expires in {detail1} days.',
            acceptInvite: 'Collaborator invitation accepted.',
            viewFolder: 'Folder "{detail0}" has been opened.',
            importFileToRoot: 'Import model \\"{detail0}\\" to the root of {detail1}. The file type is {detail2}.',
            importFileToFolder: 'Import model \\"{detail0}\\" to folder \\"{detail2}\\" in {detail1}. The file type is {detail3}.'
        }
    },
    common: {
        close: 'Close',
        got: 'Close',
        title: {
            email: 'Email'
        },
        cancel: 'Cancel',
        share: 'Share',
        settings: 'Settings',
        save: 'Save',
        yes: 'Yes',
        no: 'No',
        done: 'Done',
        name: 'Name',
        loading: 'Loading',
        back: 'Back',
        deleteConfirm: 'Are you sure you want to delete?',
        delete: 'Delete',
        rename: 'Rename',
        empty: 'No data',
        inputhint: 'Please input',
        pre: 'Previous',
        next: 'Next',
        beginning: 'First page',
        last: 'Last page',
        forwardPage: 'Jump to X page',
        summary: 'Total {n} items',
        ok: 'OK',
        select: 'Select',
        confirm: 'Confirm',
        selectAll: 'Select all',
        all: 'All',
        minimize: 'Minimize',
        submit: 'Submit',
        action: 'Action',
        active: 'Activate',
        edit: 'Edit',
        more: 'More',
        batch: 'Batch operation',
        MultiDelete: 'Batch deletion',
        export: 'Export',
        setDefault: 'Set as default',
        create: 'Add new',
        fillin: 'Go fill in',
        reset: 'Reset',
        other: 'Other',
        input: 'Please enter',
        selectHint: 'Please select',
        uploadFile: 'Upload file',
        uploadForm: 'Upload the spreadsheet',
        steps: 'Steps of operation',
        import: 'Confirm import',
        download: 'Download',
        note: 'Remark',
        normalTip: 'Reminder',
        clear: 'Clear',
        remove: 'Deletion',
        move: 'Move',
        scanatId: 'Scanat ID',
        startTime: 'Start time',
        endTime: 'End time',
        page: {
            go: 'Go to Page {detail0}',
            total: 'Total {detail0} items',
            first: 'First Page',
            previous: 'Previous',
            next: 'Next',
            last: 'Last Page',
            perPage: 'per page'
        }
    },
    mesh: {
        export: 'Export Model Data',
        download: 'Download Data',
        all: 'All Data',
        tip: 'Compress and Export All Data of the Model',
        default: 'Mesh',
        pointCloud: 'Point Cloud',
        processing: 'Processing',
        gltf: 'For Android',
        obj: 'Widely Used',
        stl: 'For 3D Printers'
    },
    week: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
    },
    month: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
    },
    login: {
        passwordWrong: 'Please verify your password.',
        accountUndefined: 'Username does not exist.',
        verifiWrong: 'The verification code is incorrect',
        verifiExpired: 'The verification code has expired.',
        loginVerifiSent: 'The verification code has been sent to your email.',
        verifiSend: 'Resend Code',
        login: 'Login',
        register: 'Register',
        back: 'Click here to login',
        guideRegister: 'Click here to register',
        newAccount: 'Register',
        email: 'Email',
        password: 'Password',
        forgetPassword: 'Forgot password?',
        emailError: 'Invalid email address format.',
        passwordTip: 'Password must be between 10 and 50 characters long and includes at least one half-width letter and one half-width number.',
        emailNone: 'This email is not registered.',
        accountError: 'The E-mail or password is not correct.',
        resetPasswordSent: 'An email has been sent to reset your password.',
        verifiSent: 'Verification code has been sent to your email.',
        passwordConfirm: 'Set Password',
        send: 'Send',
        sent: 'Verification code has been sent.',
        verify: 'Verification Code',
        inputVerify: 'Please enter the 6-digit verification code sent to your email.',
        resetPassword: 'Reset Password',
        noEmpty: 'Please fill in all required fields.',
        verifyFormat: 'The verification code must be 6 digits long.',
        verifyNumber: 'The verification code must be a 6-digit number.',
        checkPassword: 'Please verify your password',
        resetPasswordSuccess: 'Password reset successfully.',
        existUser: 'This user already exists.',
        loginSuccess: 'Logged in successfully.',
        registerSuccess: 'Registration completed successfully.',
        logout: 'Log out',
        terms: 'I agree to <link>Scanat Terms of Use</link>.',
        termsError: 'Please read the Scanat Terms of Use and check the box to indicate your agreement before submitting your registration.',
        alert: {
            title: 'Reminder',
            info: 'We have sent you an email with a link to complete your password reset.'
        },
        invalid: {
            info: 'This password reset link has expired.',
            tip: 'Please request a new password reset link.'
        },
        noExist: {
            info: 'The link does not exist.',
            tip: 'Please check if the link is correct.'
        },
        go: 'Go',
        forgetPasswordToast: 'Too many requests. Please try again in 1 minute.',
        introduction: 'Digitize Space, Create Future',
        verifyText: 'Verification Code'
    },
    error: {
        connectionOut: 'The connection has timed out. Please check your network connection or try again later.',
        server: 'The server is either overloaded or undergoing maintenance. Please try again later.',
        connectionCheck: 'Please check your network connection.',
        contactManage: 'Access denied. Please contact your administrator.',
        noPlan: 'Service unavailable. No subscription plan purchased.',
        overDate: 'Your company\'s {plan} subscription expired on {date}. Service unavailable.',
        unactive: 'Your company\'s {plan} subscription will activate on {date}. Please access after activation.',
        needLevelUp: 'Your company has not purchased this service yet. ',
        noService: 'Access denied. Your company hasn\'t purchased this service',
        emptyName: 'First name or last name cannot be empty.',
        unsaveEdit: 'Please save the edited content first.',
        overSeat: 'The user limit has been reached. You cannot add more members. Please remove some members or expand the ID count.',
        noSelectMember: 'Please check the members to be removed below.',
        bestPlan: 'The current package is the highest version and cannot be upgraded.',
        noPermission: 'No permission.',
        comInfoAction: 'Complete the company information',
        comInfoModal: 'Your company information is not yet complete. Please fill in the company information.',
        comInfoBuy: 'Please complete the company information first, and then proceed with the purchase.',
        comInfoHome: 'Note: Due to incomplete company information, some features may be affected.',
        usedAccount: 'This account is already associated with another company and cannot be added. Please re-enter the information.',
        wrongEmail: 'Please provide a valid postal code.',
        unsavePage: 'Please save the content on this page before proceeding.',
        repetitiveMail: 'Duplicate email addresses have been found in the table. Please review the entries and upload again.',
        otherMember: 'The email address {email} is already associated with an existing account. Please check and upload again.',
        wrongFormat: 'The email address format for {email} is incorrect. Please correct it and upload again.',
        creditExpired: 'The credit card you are using has expired. Please verify the expiration date or use an alternate card.',
        agreement: 'Please check the box to confirm your agreement to the Purchase Agreements.',
        payFailed: 'Payment failed. Please verify your credit card information.',
        noAccess: 'Unable to access this page.',
        overSeatActivation: 'The user limit has been reached.  New members cannot be activated. Please remove some members or expand the ID count.',
        emailEmpty: 'Row {n}: Email address is required. Please complete and upload again.',
        nameExceed: 'Row {n}: First or last name exceeds maximum length (10 characters). Please correct and try again.',
        importExceed: 'You can import a maximum of 100 members at once. Please remove some members from the file and try uploading again.',
        existCompany: 'This account has already been added to the company.',
        invalidAccount: 'This account is invalid. Please contact your administrator.',
        creditDisable: 'Your credit card could not be used. Please verify the details and enter  again.',
        accountDisable: 'This account has been disabled and cannot be accessed.',
        noSeat: 'The "ID Consumption" setting is turned off for this account, so app access is unavailable. ',
        noRight: 'Your account does not have permission to access this service.',
        code: {
            '403': 'Access Denied',
            '404': 'Page Not Found',
            '500': 'Server is overloaded and under maintenance. Please try again later.',
            '502': 'Server is busy. Please try again later.',
            '504': 'Server is busy. Please try again later.'
        },
        oneDevice: 'For security reasons, simultaneous login from multiple devices is not allowed on Scanat Web. Your account has been automatically logged out. Please log in again.',
        overDue: 'Your session has expired. Please log in again.',
        checkNetWork: 'Please check your network connection.',
        timeOut: 'The connection timed out. Please check your network connection or try again later.',
        noCompanyInfo: 'The company information has not been completed. You can purchase a plan only after completing the company information in the "Company Information" menu bar.',
        comInfoDomain: 'Please complete the company information before adding a domain.',
        accountNoAccess: 'This account has been disabled and cannot be logged into.',
        existName: 'This name already exists. Please input a different name.',
        nameTooLong: 'Please enter the model name of 20 characters or less, then upload again.',
        noModel: 'No model data found.'
    },
    complete: {
        save: 'Save completed.',
        export: 'Export completed.',
        setManagement: 'The administrator setup has been successfully completed.',
        cancelSetManag: 'The administrator removal has been successfully completed.',
        card: 'A credit card has been added.',
        cardUpdate: 'The credit card has been updated.',
        cardDeleted: 'The credit card has been removed.',
        importMember: 'Imported successfully',
        invoiceDown: 'The receipt has been successfully downloaded.',
        diagramDown: 'The drawing has been successfully downloaded.',
        invoiceSent: 'The invoice has been successfully sent.',
        bought: 'Thank you! Your purchase was successful.',
        add: 'Added successfully',
        change: 'Updated successfully',
        delete: 'Deleted successfully',
        replace: 'Updated successfully'
    },
    landing: {
        select: 'Please select the system you need to access:\nPlease Select Service',
        idManage: 'ID Management',
        scanatWeb: 'Scanat Web',
        pwChange: 'Change Password',
        logout: 'Log Out',
        tipId: "\xb7 Manage Your Account\n  (Update status, change administrative permissions, and more.)\n\xb7 Purchase Plan\n\xb7 Download invoices and receipts",
        tipScanat: "\xb7 Company and individual cloud data management (including features like creating personal folders)\n\xb7 Operate models and edit measurement data via PC browser\n\xb7 Real-time collaboration on models and measurement data with Internal users",
        alertNoPlan: 'Scanat Web is an optional feature available for Enterprise Plans (Plan B and above). You can view and operate models scanned in web browsers, as well as create model links for sharing with non-Scanat users. For further details, please reach out through our <link>contact form</link> or contact your sales representative.',
        invalidAccount: 'Scanat Web is unavailable now since your account has expired.',
        unnamed: 'Unnamed'
    },
    file: {
        allFile: 'All Files',
        sample: 'Sample Model',
        modelAmount: 'Models',
        newFolder: 'New Folder',
        fileName: 'File Name',
        owner: 'Owner',
        time: 'Uploaded',
        createTime: 'Created',
        scanner: 'Author',
        scanTime: 'Date taken',
        editor: 'Last modified by',
        updateTime: 'Last modified',
        folder: 'Folder',
        fileAmount: '{n} Files',
        createString: 'Created at {time}',
        uploadString: 'Uploaded at {time}',
        updateString: 'Updated at {time}',
        editorString: 'Last modified by {ID} at {time}',
        filter: 'Filter',
        sort: 'Sort',
        restore: 'Restore to Default',
        all: 'All',
        filterStatus: 'Model Status',
        filterCad: 'CAD Requested',
        filterMark: 'Pin Status',
        filterMarked: 'Pinned',
        fiterOwner: 'Owner',
        filterSelfOwner: 'Me',
        filterShared: 'Shared with me',
        updateNewest: 'Updated (Newest first)',
        createNewest: 'Uploaded/Created (Newest first)',
        searchHint: 'Input keyword',
        pagePre: 'Previous',
        pageNext: 'Next',
        pageFirst: 'First',
        pageLast: 'Last',
        operate: 'Operate',
        share: 'Share',
        selectAll: 'Select all',
        rename: 'Rename',
        moveTo: 'Move to',
        tipSample: 'No model data has been uploaded. Please upload models using the mobile application or start by opening the sample model to try out the features.',
        btnSample: 'Explore with Sample Model',
        noFile: 'No files in the current folder.',
        noResult: 'No results found. Please try changing the keyword, checking the input, or adjusting the filters.',
        noSearchResult: ' Please try different keywords, check for typos, or adjust filters.',
        editFolder: 'Edit the folder',
        folderName: 'Folder Name',
        folderNameHint: 'Please input the folder name.',
        folderDesc: 'Remarks',
        folderDescHint: 'If there are any remarks, please enter them.',
        folderDescLimit: "\u540C\u4E0A",
        editModel: 'Model Rename',
        modelName: 'Model Name',
        modelNameHint: 'Please input the model name.',
        dataSize: 'Data Size',
        shareString: 'Shared by {ID} at {time}',
        id: {
            log: 'User operation log',
            logCompany: '{company} Operation Log',
            Invoice: "Invoice{\u8BA2\u5355\u53F7}",
            MemberList: "{\u4F1A\u793E\u540D}Member List{YYYYMMDD}",
            PlanOrderList: 'Plan Order List{YYYYMMDD}',
            CADOrderList: 'CAD Order List{YYYYMMDD}',
            CustomerInformationList: 'Customer Information List{YYYYMMDD}',
            AccountList: 'Account List{YYYYMMDD}',
            UserBatchImportTemplate: 'User Batch Import Template',
            transactionFiles: 'Transaction Documents{number}',
            memberList: 'Member List{YYYYMMDD}',
            planOrderList: 'Plan Order List{YYYYMMDD}',
            cadOrderList: 'CAD Order List{YYYYMMDD}',
            customerInformationList: 'Customer Information List{YYYYMMDD}',
            companyMemberList: '{company}Member List{YYYYMMDD}',
            accountList: 'Account List{YYYYMMDD}',
            userBatchImportTemplate: 'User Batch Import Template',
            invoice: 'Invoice {number}'
        },
        noResultTitle: 'No results found.',
        code: {
            get: 'Get Embed Code',
            mode: 'Loading Method',
            manual: 'Manual Load',
            auto: 'Auto Load',
            copy: 'Copy Embed Code',
            language: 'Display Language',
            copySuccess: 'Code copied'
        },
        delete: {
            title: 'Are you sure you want to delete this model?',
            prompt: 'After deletion, members who have permission for the models will no longer be able to access them.',
            noAuth: 'Some files cannot be deleted due to insufficient permissions. Please reselect.'
        },
        deleteFolder: {
            title: 'Are you sure you want to delete this folder?',
            prompt: 'After deletion, you and other members will no longer be able to access the models within the selected folder.'
        },
        mark: {
            cancledToast: 'Not pinned',
            markedToast: 'Pinned'
        },
        copy: 'copy',
        import: {
            button: 'Import model',
            title: 'Import model',
            tip1: 'Select a 3D file or drop it here to import.',
            tip2: 'Supported formats',
            tip3: 'Max size: 500MB. If textures are included, please compress them into a ZIP file before importing.',
            select: 'Select the file',
            reSelect: 'Reselect the file',
            release: 'Drop file to import',
            refresh: 'Import in progress.Do not reload or close the page. Interrupting the process will cause the import to fail.',
            fail: 'Unable to import. Please try again.',
            prompt: 'Import is in progress. Reloading the page will prevent the import from completing. Are you sure?',
            error: {
                checkNet: 'Import failed. Please check your network and try again.',
                parsingFailed: 'Could not parse the model. Please check the file and try again.',
                system: 'An error occurred during processing. Please wait a moment and try again.',
                invalidFile: 'No valid model data found in the ZIP file. Please check the file and try again.'
            }
        },
        itemsPerPage: 'Items per page',
        teamSpace: 'Team Space',
        mySpace: 'Personal Space',
        folderEmptyDesc: 'No remarks.',
        sortBy: {
            updateTimeDescending: 'Last modified (Newest first)',
            updateTimeAscending: 'Last modified (Oldest first)',
            createTimeDescending: 'Uploaded/Created (Newest first)',
            createTimeAscending: 'Uploaded/Created (Oldest first)',
            firstletterDescending: 'A to Z',
            sizeDesc: 'Size (Descending)',
            sizeAsc: 'Size (Ascending)'
        },
        creator: 'Creator',
        createOrUploadTime: 'Upload date',
        noFound: {
            text: 'No folder named "{0}" was found. Please try a different keyword.'
        },
        move: {
            noAuth: 'Some files cannot be moved due to insufficient permissions. Please reselect.'
        },
        modelNum: '{n} model(s)'
    },
    filemodal: {
        deletAll: 'Are you sure you want to delete?',
        selectMove: 'Move To',
        move: 'Move Here',
        noData: 'No data',
        share: 'Share Model Link',
        copyLink: 'Copy',
        copySuccess: 'Link copied successfully',
        shareTip: '1. Users with Scanat Web permissions: Can view and edit the model; changes will be synced to the source shared model in real time.\\n\n2. Users without Scanat Web permissions: Can view and edit the model, but any changes will not be applied or saved to the source shared model.',
        moveSuccess: 'Moved successfully',
        folderSuccess: 'Folder created successfully',
        changeSuccess: 'Modified successfully',
        noSpecialSymbol: 'Special characters are not allowed.',
        sharePromptOld: '1.Users with ScanatWeb permissions: Can view and edit the model simultaneously.\n2.Users without ScanatWeb permissions: Can view the model, but simultaneous editing is not supported.',
        moveFolderTitle: 'Move the folder.',
        moveModelTitle: 'Move the model',
        moveFileTitle: 'Move the file.',
        moveFileDesc: 'The moved file will follow the permission settings of the destination folder. Additionally, current collaborators may lose access to the file.',
        moveFolderDesc: 'The moved folder will follow the permission settings of the destination folder. Additionally, current collaborators may lose access to the folder.',
        moveModelDesc: 'The moved model will follow the permission settings of the destination folder. Additionally, current collaborators may lose access to the model.',
        deleteComfirm: 'Cannot be restored after deletion. Do you want to delete it?',
        cannotEdit: 'Unable to edit because the file has been deleted.',
        cannotAccess: 'Unable to access.The file has been deleted.'
    },
    language: {
        ja: "\u65E5\u672C\u8A9E",
        en: 'English',
        cn: "\u7B80\u4F53\u4E2D\u6587"
    },
    profile: {
        basic: 'Basic information',
        account: 'Account',
        name: 'Name',
        company: 'Affiliated company',
        superManage: 'Super administrator',
        manage: 'Administrator',
        member: 'Standard member',
        deregisterAccount: 'Account deletion',
        deregisterTip: '1.Please note that your personal information and history cannot be restored.\\n\n2.All model records and transaction history will be permanently deleted and cannot be recovered.\\n\n3.If you are the super administrator and there are still active accounts within the team that have not been deleted, you will not be able to log out.',
        deregisterWarningCo: 'Deleting the account will permanently remove all model records associated with the company, and these cannot be restored.',
        deregisterWarningUser: 'Deleting the account will permanently remove all of your model records, and these cannot be restored.',
        deregisterConfirm: 'Confirmation of Account Deletion',
        deregisterfail1: 'In your team, there are still',
        deregisterfail2: 'active accounts ',
        deregisterfail3: 'in use. Please visit the team management page to remove the members, and then proceed with the account cancellation.',
        deregisterComplete: 'The account deletion has been successfully completed.',
        continue: 'Proceed with account deletion',
        manageAccount: 'Manage Account'
    },
    company: {
        setting: 'Company infomation',
        basic: 'Basic Infomation',
        expand: 'Additional Infomation',
        name: 'Company Name',
        owner: 'Person in Charge',
        ownerLastname: 'Last Name',
        ownerName: 'First Name',
        zipcode: 'Postal Code',
        addressProvince: 'State/Province',
        addressCity: 'City/Ward/Town/Village',
        addressDistrict: 'District/Block/House no.',
        industry: 'Type of Industry',
        industryArchi: 'Construction',
        industryManu: 'Manufacturing',
        industryEstate: 'Real Estate and Goods Rental and Leasing',
        industryTel: 'Information and Communications',
        industryElectric: 'Electricity, Gas, Heat Supply and Water',
        industryTrans: 'Transport and Postal Services',
        industryInfo: 'Information Services',
        industryStudy: 'Scientific Research, Professional and Technical Services',
        industryRetail: 'Wholesale and Retail Trade',
        industryResearch: 'Research Industry',
        scale: 'Number of Employees',
        scaleSmall: 'Below 50',
        scaleMedium: '50-100',
        scaleLarge: 'More than 100',
        service: 'Main Business',
        inputCorrectPhone: 'Please enter a valid phone number.',
        inputNumber: 'Please enter a numeric value.',
        domainManage: 'Domain Management',
        domainList: 'Domain List',
        domainDesc: '*Scanat Web allows you to embed model detail pages on external sites. You can add third-party domain names here, and the embedding code will only work on the domains you\'ve registered. You can add a maximum of 10 domains.',
        domain: 'Domain',
        addDomain: 'Add Domain',
        editDomain: 'Edit Domain',
        deleteDomain: 'Delete Domain',
        inputDomain: 'Please enter a domain name',
        domainError: 'Please enter a valid domain name',
        deleteDomainTip: 'Are you sure you want to delete this domain? Once deleted, the model embedding code will no longer work on this domain.',
        nameInput: 'Please enter company name',
        ownerSexual: 'Gender',
        ownerMale: 'Male',
        ownerFemale: 'Female',
        numberInput: 'Please enter phone number',
        zipcodeInput: 'Please enter postal code',
        address: 'Address',
        addressDetails: 'Building/Room',
        industrySelect: 'Please select type of industry',
        scaleSelect: 'Please select number of employees',
        capital: 'Capital',
        capitalInput: 'Please enter capital',
        capitalUnit: 'JPY',
        serviceInput: 'Please enter main business',
        domainIframeError: 'The content cannot be displayed because this domain is not authorized.',
        ownerNameTitle: 'Name',
        ownerGenderTitle: 'Gender',
        ownerPhoneTitle: 'Phone',
        DomainExsit: 'The domain you entered is already in use. Please enter a different domain name.'
    },
    card: {
        manage: 'Manage credit card',
        number: 'Card number',
        dueDate: 'Expiration date',
        status: 'Status',
        owner: 'Cardholder name',
        statusNormal: 'Active',
        statusExpired: 'Expired',
        default: 'Default credit card',
        setDefault: 'Set as default',
        create: 'Add new card',
        inputNumber: 'Please enter your credit card number.',
        validity: 'Expiration date',
        inputMonth: 'Please enter the month',
        inputYear: 'Please enter the 2-digit year',
        securityCode: 'Security code',
        inputSecurityCode: 'Please enter  security code',
        inputOwner: 'Please enter the name of the cardholder.',
        errorNumber: 'Please enter the 16-digit card number.',
        errorMonth: 'Please select and enter a month from January to December',
        errorYear: 'Please enter valid expiration year.',
        errorSecurity: 'Please enter the 3-digit security code.',
        errorOwner: 'Please enter the name of the cardholder.',
        errorExpired: 'This credit card has expired. Please verify the expiration date or use an alternate card.',
        delete: 'Remove credit card information',
        deleteConfirm: 'Are you sure you wish to remove the credit card ending in {number}?',
        deleteComplete: 'The credit card information has been successfully removed.',
        defaultComplete: 'Set as default successfully.',
        emptyTitle: 'No credit card information added currently.',
        emptyDesc: 'Please click the button below to add your credit card information.',
        bind: 'Current payment',
        inputMonthYear: 'MM/YY',
        error: {
            InvalidNumber: 'Your card number is invalid.',
            tooShortNumber: 'Your card number is incomplete.',
            invalidDate: "Your card\u2019s expiration year is invalid.",
            incompleteDate: "Your card\u2019s expiration date is incomplete.",
            expiredDate: "Your card\u2019s expiration year is in the past.",
            invalidSecurityCode: "Your card\u2019s security code is incomplete."
        }
    },
    home: {
        title: 'Home',
        modelAmount: 'Number of models',
        memberAmount: 'Number of members ',
        orderAmount: 'Number of orders',
        quick: 'Shortcut link',
        completeInfo: 'Complete the company information',
        team: 'Create  team',
        cowork: 'Model collaboration',
        order: 'View order details',
        read: 'Recommended reading for beginners',
        back: 'Return to the homepage'
    },
    plan: {
        a: 'Plan A - Starter',
        b: 'Plan B - Basic',
        c: 'Plan C - Business',
        d: 'Plan D - Enterprise',
        selectPlan: 'Select a subscription plan',
        id: 'Number of User IDs',
        app: 'App version',
        appWeb: 'App version + Web version',
        price: 'Starting from {price} JPY',
        none: 'There are no available plans currently.',
        now: 'Current plan',
        statusActive: 'Subscribed',
        statusUnactive: 'Awaiting activation',
        end: 'Expired',
        planDetail: 'More details',
        idMoreThan: 'or more',
        bApp: 'Plan B - Basic (App only)',
        bAll: 'Plan B - Basic (Web + App)',
        aYearText: 'Save 24,000 yen annually vs. monthly payments',
        unSelected: 'No plan selected.'
    },
    order: {
        list: 'Order History',
        plan: 'Plan Order',
        cad: 'CAD Order',
        statusUnpay: 'Unpaid',
        trial: 'Available for early trial',
        statusPaid: 'Paid',
        statusCancel: 'Cancelled',
        statusComplete: 'Process completed',
        statusProcessing: 'In progress',
        searchHint: 'Enter order number/plan name to search',
        number: 'Order number',
        name: 'Plan name',
        payMethod: 'Subscription',
        payMonth: 'Monthly Billing',
        payYear: 'Annual Billing',
        switchPayMethod: 'Switch subscription method',
        switchPay: 'Switch subscription method',
        switchMonthTip: 'Are you sure you want to change the subscription for Plan A to monthly billing?',
        switchYearTip: 'Are you sure you want to change the subscription for Plan A to annual billing?',
        currentPeriod: 'Current plan expiration date',
        nextPeriod: 'Next plan expiration date',
        periord: 'Expiration date',
        selectSeat: 'Select the number of IDs',
        seat: 'Number of IDs',
        seatAdded: 'New available IDs',
        seatAddSum: 'Number of new available IDs',
        seatAddTime: 'Date of ID expansion',
        selectTime: 'Please select a date',
        seatPeople: '{n}',
        seatUnactive: '{n} IDs are pending activation',
        seatTip: 'The number of IDs selected here will be the total number of IDs available for the entire team to use the service. For example, if you select 10, the total number of IDs available for the team will be 10.',
        packageCount: 'Package Count',
        packageCountTip: 'Select the number of packages to purchase',
        additionalIdCount: 'Additional ID Count',
        additionalIdCountTip: 'Additional IDs purchased beyond the base package ID count',
        totalIdCount: 'Total {count} IDs',
        packageBaseIdCount: 'Selected package includes {count} IDs',
        seatOver: 'The member count has exceeded the limit',
        seatOverTip: 'Your current team has {n} members. Please purchase a plan with {n} or more IDs, or remove some members from the management page before making the purchase again.',
        memberUsed: 'Number of IDs in use',
        deleteMemble: 'Remove team member',
        cancelTip: 'Canceled on {date}',
        expandSeat: 'Expansion of ID count',
        purchase: 'Purchase a plan',
        purchaseNow: 'Purchase now',
        levelUp: 'Upgrade',
        renewal: 'Renewal',
        buy: 'Purchase',
        changeTime: 'Change the service usage period',
        olderTime: 'Current usage period',
        newTime: 'Updated usage period',
        startTime: 'Service start date',
        endTime: 'Service end date',
        updateTime: 'Upgrade date',
        contactService: 'Contact customer service',
        changeCard: 'Update billing credit card',
        SelectCard: 'Please select the billing credit card',
        cancel: 'Cancel subscription',
        cancelTip1: 'If you cancel the subscription, the plan will end on {date}, and it will no longer renew automatically. After this date, all members will lose access to the system. Are you sure you wish to proceed with the cancellation?',
        cancelTip2: 'Canceling the subscription will disable automatic renewal. As a result, all members will lose access to the system. Are you sure you wish to proceed with the cancellation?',
        revokeCancellation: 'Cancel subscription cancellation',
        revokeTip: 'Do you want to cancel the subscription cancellation? If you undo it, you can cancel again later.',
        noPlan: 'There are no available plans at this time.',
        newPlan: 'Updated plan',
        learn: 'Plan details',
        learnMore: 'View plan details',
        confirmOrder: 'Review the order',
        orderInfo: 'Order information',
        planStart: 'Plan start date',
        planStartInstant: 'Once the payment has been completed',
        item: 'Item',
        itemName: 'Item name',
        modelName: 'Model name',
        diagramType: 'Drawing type',
        category: 'Category',
        totalItem: 'Quantity',
        unitPriceYen: 'Unit price',
        totalSumYen: 'Total price',
        unitPrice: 'Unit price',
        totalSum: 'Total price',
        unusedSum: 'Unused package balance',
        quickSum: 'Total',
        tax: 'Tax (10%)',
        payableSum: 'Payment amount',
        payableSumUnit: 'Payment amount (JPY)',
        submit: 'Submit',
        confirmSubmit: 'Confirm and submit the order',
        createUser: 'Creator',
        createTime: 'Creation time',
        paidTime: 'Payment time',
        giveTime: 'Delivery time',
        paidStatus: 'Payment status',
        cadStatus: 'CAD creation status',
        orderSum: 'Order amount',
        status: 'Payment status',
        leftTime: 'Remaining payment period',
        switchTipYear: 'The payment will switch to an annual plan starting on {date}.',
        switchTipMonth: 'The payment will switch to a monthly plan starting on {date}.',
        autoFail: 'The automatic payment failed.',
        cardFailTip: 'The credit card payment has failed. A retry will be attempted tomorrow. Please update your payment information at your earliest convenience.',
        toSwitch: 'Proceed to update',
        details: 'Order details',
        type: 'Order type',
        sumTip: "Total amount = Plan unit price \xd7 Additional users \xd7 Remaining days / {n} days",
        unusedTip: "Unused amount (original plan) = Old plan unit price \xd7 Original number of users \xd7 Unused days / {n} days",
        priceTip: "Time-based rate conversion: Unit price = Original plan unit price \xd7 Remaining usage days / {n} days",
        oldPlan: 'Original plan',
        unusedTime: 'Remaining usage days',
        actionDetail: 'Details',
        checkDetail: 'Review the details',
        actionPay: 'Proceed to payment',
        actionCancel: 'Cancel the order',
        cancelConfirm: 'Are you certain you wish to cancel the order?',
        actionInvoice: 'Download transaction documents',
        actionDiagram: 'Download drawing',
        submitOrder: 'Submit the order',
        payOrder: 'Pay for the order',
        completeOrder: 'Order completed',
        applican: 'Applicant',
        appliTime: 'Application date and time',
        checkCancel: 'Review the cancellation reason',
        cancelTime: 'Cancellation time',
        cancelReason: 'Cancellation reason',
        useTip: 'Available immediately after successful payment',
        unpaidTip: 'You have an unpaid plan order. Please complete the payment or contact your service provider.',
        leftDay: 'days',
        leftHr: 'hours',
        leftMin: 'minutes',
        leftSec: 'seconds',
        expireTip: 'The order will be automatically canceled if payment is not received by the deadline.',
        purchaseSuccess: 'Thank you! Your purchase was successful.',
        existPlantip: 'You have already purchased the {plan} plan and cannot purchase a new plan. Please cancel your current order and purchase a new plan.',
        unactivePlantip: 'You have already purchased the {plan} plan. Your subscription starts on {date}.',
        currentSeat: 'Current Number of IDs',
        seatExpandExceed: 'Your current plan allows up to {max-seat} seats. You have {exist-seat} seats and can add {left-seat} more. Please adjust the quantity and try again.',
        checkCurrentPlan: 'View current plan',
        noPlanError: 'You currently do not have an active subscription plan. Expansion of ID count is not available. Please contact your Account Manager to cancel your pending order and repurchase a plan.',
        planType: 'Order plan',
        itemList: 'Order List',
        system: 'System',
        selectNumber: 'Select Quantity',
        numberOfPlan: 'Plan Quantity',
        numberOfID: 'Additional IDs',
        numberTip1: 'Total:{detail0}IDs',
        numberTip2: 'Selected Plan includes {detail0}IDs',
        card: {
            '3DsTip': '3D Secure authentication is required for credit card automatic payment. The system has sent an authentication email, so please check your email and complete the authentication.'
        },
        complete: 'Complete'
    },
    cad: {
        statusProcessing: 'CAD drawing in progress',
        statusComplete: 'CAD drawing completed',
        submit: 'Submit the application',
        completeTime: 'Approximately 2 to 4 days',
        create: 'CAD drawing',
        delivery: 'Submit drawings',
        model: 'Model',
        innerWall: 'Interior wall thickness',
        outerWall: 'Exterior wall thickness',
        deliveryFormat: 'Delivery format',
        usage: 'Building Categories',
        type: 'Type of Drawings',
        attachment: 'Existing Drawings',
        application: 'Request for CAD drawing',
        usageResidential: 'Residential',
        usageOffice: 'Office',
        usageShop: 'Shop and Institution',
        usageOthers: 'Other',
        fileCad: 'CAD File',
        filePdf: 'PDF File',
        diagramFloorplan: 'Floor Plan',
        diagramCeiling: 'Ceiling Plan',
        diagramElevation: 'Elevation',
        tipProcessing: 'The drawings are currently being created. We kindly ask for your patience.'
    },
    pay: {
        payment: 'Payment method',
        detailCard: 'Payment information - Credit card',
        detailInvoice: 'Payment information - Invoice',
        orderPay: 'Order payment',
        selectMethod: 'Select payment method',
        creditcard: 'Credit card',
        invoice: 'Invoice',
        invoiceSendTip: 'The invoice will be sent to {mail}. Please make the payment to the following account:',
        invoiceResendTip: 'The invoice has been sent to {mail}. Please make the payment to the following account:',
        bank: 'Financial Institution',
        banCode: 'Financial Institution Code',
        bankName: 'Branch Name',
        bankNumber: 'Branch Number',
        accountType: 'Account Type',
        accountOwner: 'Account Holder',
        accountNumber: 'Account Number',
        sendInvoice: 'Send Invoice',
        noInvoice: 'The invoice has not been received?',
        resendInvoice: 'Resend Invoice',
        InvoiceSent: 'Invoice sent successfully',
        toPay: 'Proceed to payment',
        agreement: 'Agree to the Purchase Agreement',
        payLoading: 'Please wait while we process your payment...',
        payJump: 'Payment is being processed. Redirecting to order page...',
        unlimited: 'Unlimited',
        alert: 'This order requires payment by bank transfer. Please check your inbox.If you haven\'t received the email regarding the transfer, or if you have any other questions, please contact the service provider.'
    },
    team: {
        member: 'Member management',
        status: 'Status',
        statusActive: 'In use',
        statusUnactive: 'Not activated',
        addMember: 'Add member',
        deleteMember: 'Remove member',
        deleteMemberTip: 'If you remove the member, they will no longer have access to your company. However, any models uploaded to the cloud will remain retained. Are you sure you wish to proceed with this action?',
        addMultiMember: 'Batch Add Members',
        memberFormDownload: 'Click to download the "User Batch Import Template"',
        addMultiMemberTip: '1. Download the "User Batch Import Template."\\n\n2. Open the template, enter or paste the corresponding field information using plain text or numbers.\\n\n3. Click the "Upload File" button, select the completed file, and then click the "Confirm Import" button at the bottom right corner.\\n\nNote: You can import a maximum of 100 records at once. If the file uploaded exceeds 100 records, none of the data will be imported.',
        errorNoFile: 'Please upload the file',
        usedSeat: 'Active ID',
        model: 'Total number of models',
        cloudModel: 'Number of cloud models',
        name: 'Name',
        inputLastname: 'Please enter last name',
        inputname: 'Please enter first name',
        mail: 'Email',
        mailAddress: 'Email address',
        inputEmail: 'Enter the email address',
        emptyEmail: 'Please provide your email address!',
        errorEmail: 'The email address format you entered is incorrect. Please review it and try again.',
        activeAccount: 'Activate Account',
        activeAccountTip: 'An activation email will be sent to this member. Would you like to confirm the account activation?',
        lastLogin: 'Last login time',
        editMember: 'Edit member',
        deleteMultiMember: 'Batch Remove Members',
        deleteMultiMemberTip: 'If you remove selected members, they will no longer have access to your company. However, any models uploaded to the cloud will remain retained. Are you sure you wish to proceed with this action?',
        contactPhone: 'Contact Support: ',
        contactEmail: 'Email Support:',
        cannotRemoveAdminOrSelf: 'Cannot remove super administrator or yourself',
        removeSuccess: 'Member(s) removed successfully',
        statusDisabled: 'Disable',
        role: {
            owner: 'Owner',
            superManger: 'Super administrator',
            manager: 'Administrator',
            ScanatUser: 'Scanat User',
            viewUser: 'Viewer',
            name: 'Role',
            updateSuccess: 'Role Updated Successfully',
            noRole: 'No Role'
        },
        operate: {
            enable: 'Enable',
            disable: 'Disable'
        },
        prompt: {
            buyScanatWeb: 'Scanat Web Service Purchased'
        },
        add: {
            chooseRole: 'Select Role',
            manageSeat: 'ID Consumption',
            seatTip1: 'No ID consumption when turned off.',
            seatTip2: 'One ID will be consumed when turned on.'
        },
        enable: {
            noRight: 'You do not have permission to enable this account',
            tip: 'Once enabled, this account can be used normally. Are you sure you want to enable it?',
            success: 'Enabled successfully',
            noPlan: 'The company is not subscribed. Account cannot be enabled.'
        },
        disable: {
            noRight: 'You do not have permission to disable this account',
            tip: 'Once disabled, this account will be unusable. The account data will not be deleted, and it can be re-enabled later. Do you confirm disabling the account?',
            success: 'Disabled successfully'
        },
        statusDisabledTxt: 'Disabled',
        seatTip: 'Scanat service becomes available after an ID is consumed.',
        delete: {
            noRight: 'You do not have permission to delete this account.'
        },
        seat: {
            total: 'Contract ID',
            manageSeat: 'ID Consumption',
            onSuccess: 'ID consumed successfully',
            noSeat: 'No IDs available. Operation failed.',
            offSuccess: 'ID released successfully'
        }
    },
    survey: {
        title: 'Plan Unsubscription Customer Survey',
        desc: 'Thank you for using Scanat.\n If you wish to cancel your subscription, please fill out the required fields in the form below and submit it.\n After receiving the form, our representative will contact you by phone or email on our business days.',
        questionReason: 'Reason for your unsubscription (Multiple Choice)',
        reason1: 'Low measurement accuracy',
        reason2: 'Difficult scanning or operation methods',
        reason3: 'Low usage frequency',
        reason4: 'Insufficient functionality',
        reason5: 'High cost',
        reason6: 'Inadequate support system',
        questionApp: 'Which other scanning systems have you used? (Select all that apply)',
        app1: '3D Scanner',
        app2: 'Canvas',
        app3: 'Metascan',
        app4: 'Modelar',
        app5: 'Matterport',
        app6: 'OpalUI',
        app7: 'Polycam',
        app9: 'Scaniverse',
        app10: 'Sitescope',
        questionRecommend: '3. How likely would you be to suggest Scanat to friends needing 3D scanning services?',
        descRecommend: '*On a scale of 0-10, where 0 means "extremely unlikely" and 10 means "extremely likely"',
        questionOther: 'Feedback or suggestions',
        descOther: 'If you have any requests regarding Scanat, or suggestions for additional features or improvements, please feel free to let us know. (Free comment field)',
        submit: 'Submit',
        error: 'Please answer this question.',
        complete: 'Submitted successfully',
        thanks: 'Thank you for your valuable time. nat will process your application as soon as possible!',
        profileTitle: 'Your Profile (All items are required)',
        questionReasonDesc: 'Please select all applicable items.',
        reason7: 'Due to departmental or personnel changes',
        reason8: 'Switched to another company\'s product',
        contactTip: 'If you have any questions, please contact us below.',
        contact: "\u3010Contact\u3011\n- Tel\uFF1A050-1780-7133\n- E-mail\uFF1Acs{'@'}natincs.com",
        profileOwnerHint: 'Example:Yamada Taro',
        profilePhoneHint: 'Example:05017807133',
        profileMailHint: 'Example:scanat{\'@\'}natincs.com',
        profileOwnerEmpty: 'Please enter the main person in charge',
        profilePhoneEmpty: 'Please enter the phone number',
        profileMailEmpty: 'Please enter the email address',
        profilePhoneError: 'Please enter a valid phone number',
        profileMailError: 'Please enter a valid email address',
        reasonOtherEmpty: 'Content cannot be empty. Please enter details.',
        reasonEmpty: 'Please select the reason for unsubscription',
        waiting: 'Waiting for processing...',
        submited: 'Your unsubscription request has been submitted. Please wait patiently. \n- Contact phone: 050-1780-7133\n- Contact Email: cs{\'@\'}natincs.com',
        submitedOther: '{id} has submitted an unsubscription request. Please wait patiently.\n- Contact Phone: 050-1780-7133\n- Contact Email: cs{\'@\'}natincs.com'
    },
    log: {
        title: 'Operation log',
        searchHint: 'Input the account to search',
        remark: "\u203BOperation logs from the past year are available for viewing.",
        account: 'Account',
        time: 'Operation time',
        system: 'Associated system',
        page: 'Operation Page',
        action: 'Action',
        detail: 'Details',
        ip: 'IP address',
        device: 'Device',
        overtimeError: 'Logs older than one year are not available for viewing. Please select a different time period.',
        noUserError: 'Account not found.'
    },
    share: {
        people_amount: '{n}',
        accountShare: 'Share via Account',
        linkShare: 'Share via Link',
        searchHint: 'Enter Contact Account to Search',
        searchEmpty: 'No matching contacts found. \nPlease try a different keyword.',
        limits: 'Permissions',
        read: 'View only',
        edit: 'Editable',
        manage: 'Manageable',
        resetLink: 'Reset Link',
        overwritePw: 'Overwrite existing password',
        unSaveTip: 'Please save or cancel your password first',
        title: {
            privateLink: 'Private Link',
            encryptedLink: 'Password-Protected link',
            publicLink: 'Public link',
            changeLinkPassword: 'Change Link Password'
        },
        desc: {
            privateLink: "\u30FBAccessible only to team members",
            encryptedLink: "\u30FBAnyone with the password can access",
            publicLink: "\u30FBAnyone can access"
        },
        hint: {
            changeLinkPassword: 'Please enter 4-20 numbers or letters.'
        },
        toast: {
            changeModeSuccess: 'Permissions set successfully.',
            noPermission: 'Modifications are restricted to the model owner and administrators.',
            save: 'Please save or cancel your password first.',
            noPermissionNew: 'You need edit or manage permissions for the model.'
        },
        alert: {
            title: {
                changeToPublic: 'Note'
            },
            info: {
                changeToPublic: 'Once enabled, anyone on the internet with the link can access the model.'
            }
        },
        copy: 'Model link copied. Share it with others to provide access to the model.',
        link1: '{detail0}',
        link2: 'Scanat model link:{detail0}\npassword: {detail1}',
        privateLink: {
            linkFail: 'The link is no longer valid.',
            tip: 'The current login account is "{id}". You can contact "{admin_id}" to obtain a new link',
            contactManage: 'Access denied. Please contact your administrator.',
            limitPermission: 'The currently logged-in account "{id}" is not authorized to access this model.'
        },
        encryptedLink: {
            needPassword: 'Access to this model requires a password.',
            errorPassword: 'Please enter the correct password.',
            go: 'Go',
            placeholder: 'Please enter the password.'
        },
        copyLink: 'Copy Link',
        modelNotFound: 'The model of "{modelName}" has been deleted.',
        link: {
            noModel: 'Model not found.',
            noModelTip: 'Please verify the link.'
        }
    },
    import: {
        model: 'Import model',
        fail: 'Import failed!',
        reimport: 'Reimport model',
        importGuide: 'Select a 3D file or drop it here to import.',
        importFormat: 'Supported formats: OBJ / GLTF / GLB / DRC / STL / PLY / DAE / FBX / SKP / USDZ / DXF / ZIP\nIf textures are included, please compress them into a ZIP file before importing.',
        releaseMouse: 'Drop file to import',
        localFile: 'Select the file',
        reSelect: 'Reselect the file',
        wrongFormat: 'The selected file format is not supported. Please choose a different file.',
        fileSizeLimit: 'File size exceeds the limit.'
    },
    period: {
        lastWeek: 'Last 7 days',
        lastMonth: 'Last 30 days',
        lastYear: 'Last 1 year'
    },
    menu: {
        company: 'Company infomation',
        log: 'Operation log',
        order: 'Order History',
        team: 'ID Management'
    },
    title: {
        team: 'ID Management',
        company: 'Company infomation',
        order: 'Order History',
        log: 'Operation log',
        buy: 'Purchase',
        pay: 'Order Payment',
        paySuccess: 'Payment Successful',
        orderInfo: 'Order Details',
        land: 'Service Selection',
        link: {
            useless: 'Expired Link',
            notExist: 'Link Not Found'
        }
    },
    SUCCESS: 'Success',
    VALIDATE_FAILED: 'Parameter validation failed.',
    UNAUTHORIZED: 'You have not registered yet or your login session has expired.',
    INVALID_PASSWORD: 'The E-mail or password is not correct.',
    UNAVAILABLE: 'Your account must be activated by our sales team after completing the corporate contract process. Please contact to  for inquiries.',
    FORBIDDEN: 'You do not have the required permissions.',
    POSTCODE_NOT_EXIST: 'Postal code does not exist.',
    NOT_REGISTERED: 'This email is not registered.',
    VERIFICATION_CODE_ERROR: 'The verification code is incorrect.',
    VERIFICATION_CODE_EXPIRE: 'The verification code has expired.',
    USER_NOT_EXIST: 'User does not exist.',
    CRM_ACCOUNT_NOT_EXIST: 'Account does not exist. Please contact customer service for assistance.',
    USER_EXIST: 'User already exists.',
    CONFIRM_PASSWORD: 'Passwords do not match.',
    FILE_UPLOAD_KEY_GET_FAIL: 'Failed to get key.',
    MODEL_NOT_BELONG: 'This model does not belong to you.',
    FAILED: 'Failed',
    REQUEST_FREQUENTLY: 'You are performing actions too frequently. Please try again later.',
    FILE_SHARE_ERROR_DEL: 'Failed to send the file because it has been deleted.',
    FILE_SHARE_ERROR_UNAUTHORIZED: 'You are not authorized to perform this action.',
    FILE_SHARE_ERROR_EMAIL_NOT_EXISTS: 'User ID does not exist.',
    FILE_SHARE_ERROR_UNKNOWN: 'Unknown error.',
    FILE_SHARE_ERROR_REPEAT_SHARING: 'Model has already been sent to this user.',
    FILE_SHARE_ERROR_SELF: 'You cannot send a copy to yourself.',
    FILE_SHARE_UPDATE_FAIL: 'Update failed. The shared file cannot be found.',
    FILE_DOWNLOAD_ERROR_DEL: 'The file has already been deleted and cannot be downloaded.',
    FILE_SHARE_DEL_FAIL: 'Inbox is emtpy and cannot be deleted.',
    FILE_SHARE_DEL_FAIL_NO_AUTHORITY: 'Cannot delete the copy of the model.',
    CREDIT_CARD_PAY_ERROR: 'Failed to restore subscription',
    CREDIT_CARD_PAY_FAIL_BY_ERROR_FILE_KEY: 'Card payment failed. Reason: no data found.',
    PERMITS_CONVERT_FAIL: 'Failed to restore subscription',
    PERMITS_CONVERT_FAIL_USER_NULL: 'Failed to restore subscription',
    APP_TRANSLATION_INVALID: 'User does not exist',
    APP_TRANSLATION_HISTORY_GET_FAIL: 'Failed to retrieve subscription data',
    APP_TRANSLATION_STATUS_GET_FAIL: 'Failed to retrieve subscription data',
    FILE_UPLOAD_FILE_PATH_EMP_ERROR: 'Update failed: Please enter file path.',
    FILE_UPLOAD_FILE_DB_FAIL_ERROR: 'Update failed: model record error.',
    APP_TOKEN_GET_FAIL: 'Failed to retrieve parameters.',
    APP_IP_ADDRESS_NOT_ALLOW: 'The IP address cannot be accessed.',
    CONTACT_ALREADY_EXIST: 'The contact already exists. Please do not add it again.',
    ACCOUNT_PLAN_NOT_EXIST: 'Plan not yet purchased.',
    ACCOUNT_PLAN_TYPE_ERROR: 'Please verify the plan type.',
    ACCOUNT_PLAN_DOWNGRADE: 'It is not allowed to downgrade a plan.',
    ACCOUNT_PLAN_PREPAY_MONTH_ERROR: 'Please verify the plan information.',
    ACCOUNT_PLAN_PREPAY_MONTH_NOT_OVER: 'Plan changes are not allowed until the end of the prepayment period.',
    CUSTOMER_FINCODE_CUSTOMER_ID_NOT_EXIST: 'User\'s Fincode ID not found.',
    FINCODE_PLAN_ID_NOT_EXIST: 'Fincode ID does not exist.',
    CUSTOMER_NAME_DUPLICATE: 'The username already exists. Please verify.',
    CUSTOMER_NAME_BLANK_NOT_ALLOW: 'Please input username.',
    ACCOUNT_NOT_EXIST: 'User ID does not exist.',
    CUSTOMER_NOT_EXIST: 'User does not exist.',
    FINCODE_CARD_ID_BLANK_NOT_ALLOW: 'Please input Fincode ID.',
    CUSTOMER_NOT_BOUND_TO_ACCOUNT_PLAN: 'The user is not associated with any plans.',
    CUSTOMER_ACCOUNT_PLAN_NOT_IN_EFFECT: 'Payment request has been sent. Please wait while the transaction is being processed and confirmed.',
    ACCOUNT_IN_USE_HAS_REACHED_MAX: 'The number of available IDs has reached the limit.',
    ACCOUNT_IN_USE_AND_ADD_ACCOUNT_EXCEED_MAX: 'The total number of IDs newly added and in use, has reached the limit of the plan.',
    ACCOUNT_EMAIL_NOT_ALLOW_DUPLICATES: 'This email is already taken.',
    ACCOUNT_EMAIL_ALREADY_EXISTS: 'Email already exists.',
    ACCOUNT_LIST_CANNOT_BE_EMPTY: 'Account list cannot be empty.',
    FREEE_TOKEN_GET_ERROR: 'An authentication error occured with Freee.',
    FREEE_API_REQUEST_ERROR: 'An error occurred while sending a request to Freee\'s API.',
    FREEE_INVOICE_LIST_ERROR: 'An error occurred while sending a request to Freee\'s API to retrieve the invoice list.',
    FREEE_INVOICE_DETAIL_ERROR: 'An error occurred while sending a request to Freee\'s API to retrieve invoice details.',
    FREEE_ADD_INVOICE_ERROR: 'An error occurred while sending a request to Freee\'s API to add an invoice.',
    FREEE_ADD_PARTNER_ERROR: 'An error occurred while sending a request to Freee\'s API to add a customer.',
    FREEE_UPDATE_PARTNER_ERROR: 'An error occurred while sending a request to Freee\'s API to update a customer.',
    FREEE_PARTNER_DETAIL_ERROR: 'An error occurred while sending a request to Freee\'s API to retrieve customer information.',
    FREEE_PARTNER_LIST_ERROR: 'An error occurred while sending a request to Freee\'s API to retrieve the customer list.',
    ACCOUNT_PLAN_ORDER_NOT_EXISTS: 'Customer\'s contracted plan information does not exist.',
    CUSTOMER_ALREADY_ADDED: 'Customer information already exists.',
    ORDER_NOT_EXIST: 'Order does not exist.',
    ORDER_STATUS_ERROR: 'Orders status error.',
    ORDER_PAYMENT_METHOD_NOT_ALLOW: 'Payment method for this order is not supported.',
    FINCODE_CUSTOMER_CARD_NOT_FOUND: 'Fincode card does not exist.',
    FREEE_PARTNER_NOT_FOUND: 'Freee customer information not found.',
    CUSTOMER_ALREADY_BOUND_PLAN: 'Payment request has been sent. Please do not send it again.',
    MY_USER_PHONE_NUMBER_ALREADY_EXISTS: 'User phone number already exists.',
    MY_USER_EMAIL_ALREADY_EXISTS: 'User email already exists.',
    ROLE_NAME_DUPLICATE: 'Role name already exists.',
    THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DISABLED: 'The role is currently assigned to users and cannot be disabled. ',
    THERE_ARE_USERS_BOUND_TO_THIS_ROLE_CANNOT_UPDATE_ITS_DEPT: 'The role is currently assigned to users and cannot be edited. ',
    THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DELETED: 'The role is currently assigned to users and cannot be deleted. ',
    ADD_DEPT_NOT_ALLOWED_UNDER_HEADQUARTERS: 'Adding sub-departments under the headquarters is not allowed.',
    AGENCY_DEPT_MUST_SET_POSTAL_CODE_AND_ADDRESS_INFORMATION: 'Please enter postal code and address of agency.',
    MOST_FIVE_DEPT_LEVELS: 'Departments are limited to a maximum of 5 levels. Adding more levels is not allowed',
    DEPT_NAME_ALREADY_EXISTS: 'Department name already exists.',
    THE_DEPT_HAS_SUB_DEPT: 'This department has sub-departments and cannot be deleted.',
    THERE_ARE_USERS_IN_THIS_DEPT: 'This department has associated users and cannot be deleted.',
    THERE_ARE_ROLES_BOUND_TO_THIS_DEPT: 'This department has associated roles and cannot be deleted.',
    THERE_ARE_ACCOUNT_PLAN_BOUND_TO_THIS_DEPT: 'This department owns account plans and cannot be deleted.',
    CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_ADD: 'The customer name already exists and cannot be added.',
    THE_DEPT_BOUND_TO_THE_CUSTOMER_DOES_NOT_EXISTS: 'The department associated to the customer does not exist.',
    CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_UPDATE: 'The customer name already exists and cannot be modified.',
    THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ACTIVATE_THE_ACCOUNT: 'Account cannot be activated because the customer has no linked account plan.',
    THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ACTIVATE_THE_ACCOUNT: 'Account cannot be activated because the customer\'s plan package has not taken effect yet.',
    THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_BE_ACTIVATED: 'The number of activated accounts has reached the plan ID limit, no more accounts can be activated.',
    THE_NEW_CUSTOMER_IS_NOT_BOUND_TO_ANY_ACCOUNT_PLAN_THE_ACTIVATED_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: 'The customer has no linked account plan, activated accounts cannot be transferred to this customer.',
    THE_ACCOUNT_PLAN_FOR_NEW_CUSTOMER_HAS_NOT_TAKEN_EFFECT_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: 'The customer\'s account plan has not yet taken effect, activated accounts cannot be transferred to this customer.',
    THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: 'The customer has no linked account plan, cannot add an activated account.',
    THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: 'The customer\'s account plan has not yet taken effect, cannot add an activated account.',
    THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_ADD_ACTIVATED_ACCOUNT: 'The number of activated accounts has reached the plan ID limit, cannot add an activated account.',
    THE_USER_OF_THE_AGENT_STORE_DOES_NOT_HAVE_PERMISSION_TO_VIEW_THE_CAD_ORDER_LIST: 'Agent users do not have permission to view the CAD order list.',
    CAD_ORDER_HAS_BEEN_COMPLETED_NOT_ALLOW_TO_UPLOAD_FILES: 'The order is complete. No files can be uploaded anymore.',
    CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_AGENT_STORE: 'This role belongs to the headquarters and cannot be linked to menus that are only accessible by agents.',
    CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_HEAD_OFFICE: 'This role belongs to agents and cannot be linked to menus that are only accessible by the headquarters.',
    THE_ACCOUNT_PLAN_IS_CURRENTLY_IN_USE_BY_A_CUSTOMER_AND_CANNOT_BE_DELETED: 'It it not allowed to delete this plan because it is being used by a customer.',
    THE_DEPT_WHERE_THE_EQUIPMENT_BELONGS_CANNOT_BE_A_AGENCY_STORE: 'The owning department of the device cannot be an agent.',
    CUSTOMER_IS_CURRENTLY_USING_THIS_EQUIPMENT_CANNOT_BE_DELETED: 'Cannot delete the device because it is currently in use by a customer.',
    THE_STANDARD_QUOTATION_EQUIPMENT_FOR_ACCOUNT_PLAN_WITH_NORMAL_STATUS_IS_THE_CURRENT_EQUIPMENT_CANNOT_BE_DELETED: 'The current device is the standard equipment for an active account plan and cannot be deleted.',
    ADDING_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: 'Failed to add new customer. The customer name already exists in the database.',
    ADDING_IS_NOT_ALLOWED_THIRD_PARTY_CUSTOMER_NAME_ALREADY_EXISTS: 'Failed to add. The third-party customer name already exists.',
    UPDATE_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: 'Failed to update. The customer name already exists in the database.',
    THE_CUSTOMER_HAS_AN_RESOLVED_ACCOUNT_PLAN_ORDER_CANNOT_MODIFY_ITS_DEPT: 'The department cannot be changed because the customer has an active plan order.',
    THE_CUSTOMER_HAS_AN_RESOLVED_EQUIPMENT_ORDER_CANNOT_MODIFY_ITS_DEPT: 'The department cannot be changed because the customer has an active device order.',
    CUSTOMER_INFO_NOT_ADDED: 'Company infomation has not been filled in. You will be able to purchase a plan after fiiling in the company information.',
    FREEE_PARTNER_NOT_EXIST: 'Customer information does not exist in Freee, please check if the accound ID has been entered correctly.',
    INVITATION_NOT_EXIST: 'Invitation does not exist.',
    INVITATION_STATUS_ERROR: 'Invitation status error.',
    INVITATION_STATUS_INVALID: 'The invitation has been revoked. Please contact the inviting administrator to resend the invitation.',
    INVITATION_STATUS_EXPIRED: 'The invitation has expired. Please contact the inviting administrator to resend the invitation.',
    INVITATION_CHECK_CODE_WRONG: 'The verification code is incorrect.',
    CUSTOMER_ACCOUNT_PLAN_IN_EFFECT: 'This account is already subscribed. Please verify if you are sending the invitation to the correct account.',
    CUSTOMER_NOT_ALLOW_CHANGE: 'Change of customer is not allowed.',
    USER_STATUS_UNAVAILABLE: 'A paid subscription is required to use Scanat. Please purchase a plan on Scanat website before logging in.',
    USER_STATUS_AVAILABLE: 'Logged in successfully.',
    USER_STATUS_ACCOUNT_EXPIRED: 'Account expired. Please renew your plan.',
    USER_STATUS_LOGOUT: 'The specified account does not exist. Please verify the account information and try again',
    USER_STATUS_ACTIVE: 'Logged in successfully.',
    USER_STATUS_TO_BE_EFFECTIVE: 'Your account has not been activated yet. Please contact your company administrator %@ for assistance.',
    USER_STATUS_DEACTIVATE: 'Your account has been disabled by the administrator. Please contact your company administrator %@ for assistance.',
    USER_STATUS_PRE_DEACTIVATE: 'Logged in successfully.',
    USER_STATUS_PRE_ABNORMALITY: 'Login failed. There is an issue with your account.',
    AGENT_NOT_EXIST: 'Agent does not exist.',
    AGENT_NAME_DUPLICATE: 'Agent name already exists.',
    REQUEST_BOOK_NOT_EXIST: 'Invoice does not exist.',
    FILE_CREATE_FAIL: 'Failed to create file.',
    SALES_DATE_EMPTY: 'Please enter the transaction date.',
    EXTEND_PLAN_CONFIG_ERROR: 'Extra ID plan is not set. Please contact your administrator for assistance.',
    CAN_NOT_FIND_WEB_MODEL_KEY: 'Model does not exist.',
    CAN_NOT_FIND_WEB_MODEL_FOLDER: 'Folder does not exist.',
    FOLDER_CANT_MOVE_INTO_SUB_FOLDER: 'Failed to move the folder. A folder cannot be moved into a subfolder.',
    FOLDER_CONTAIN_SUB_FOLDER: 'Failed to move the folder. The selected folder contains subfolders and cannot be moved to another folder.',
    WEB_MODEL_ALREADY_IN_FOLDER: 'Failed to move. The item already exists in the folder.',
    FOLDER_NAME_SAME: 'A folder with the same name already exists. Please rename it before saving.',
    EMAIL_CODE_REQUIRED: 'We have added authentication to enhance security. To use this feature, please update your app to the latest version (v1.8.2 or above).',
    FILE_SHARE_FAIL: 'Failed to send: {}',
    NOT_HAS_WEB_PERMISSION: 'Access denied because you have not purchased this service.',
    MODEL_OUTLINE_NOT_EXIST: 'Line Diagram does not exist.',
    WEB_MODEL_NO_AUTH: 'Insufficient permissions.',
    SEAT_NUM_TOO_SMALL: 'The number of IDs is below the minimum limit.',
    SEAT_NUM_TOO_BIG: 'The number of IDs exceeds the maximum limit.',
    SEAT_NUM_LESS_THAN_USED: 'Insufficient number of IDs.',
    CUSTOMER_PLAN_NOT_CANCELED: 'The customer has no cancelled plans.',
    CUSTOMER_PLAN_EXIST: 'The customer has already purchased a plan.',
    CUSTOMER_PLAN_ALREADY_CANCELED: 'The customer\'s plan has been cancelled.',
    CUSTOMER_PLAN_NOT_A: 'The customer is not subscribed to Plan A.',
    CUSTOMER_PLAN_PERIOD_ERROR: 'This subscription method is not supported.',
    START_TIME_ILLEGAL: 'Incorrect start time.',
    STRIPE_ONE_TIME_PRICE_NOT_FOUND: 'The plan does not exist.',
    CUSTOMER_PLAN_EXPAND_NOT_FOUND_ITEM: 'The plan does not exist.',
    ORDER_NOT_BELONG: 'This order does not belong to your company.',
    WEB_PERMISSION_NOT_ALLOW_INACTIVE: 'Insufficient permissions.',
    CUSTOMER_HAS_ACCOUNT_IN_USE: 'Your company currently has accounts in use.',
    CAD_PLAN_GOODS_NOT_EXIST: 'Unable to find this CAD product.',
    CAD_ORDER_NOT_EXIST: 'This CAD order does not exist.',
    CAD_ORDER_STATUS_ERROR: 'This CAD order status is incorrect.',
    CAD_ORDER_FILE_TOO_MANY: 'This CAD order file size exceeds the maximum limit.',
    ACCOUNT_PLAN_PERIOD_NOT_ALLOW: 'This subscription method is not supported.',
    CUSTOMER_PLAN_END_TIME_BEFORE_NOW: 'The plan has not expired yet.',
    EXPAND_SEAT_NOT_ZERO: 'The number of IDs must be at least 1.',
    EXPAND_A_NOT_ALLOW: 'Adding IDs is not supported on Plan A.',
    ACCOUNT_PLAN_GOODS_NOT_EXIST: 'The plan does not exist.',
    CAD_PLAN_GOODS_IS_USED: 'The CAD plan is in use.',
    DOMAIN_ALREADY_EXIST: 'This domain is already registered.',
    LOCATION_WITH_SNAPSHOT: 'This capture point is already associated with a highlight.',
    LOCATION_NOT_FOUNT: 'The capture point does not exist.',
    FLOOR_NOT_EXIST: 'The floor does not exist.',
    AUTO_ALIGN_FAIL: 'Automatic orientation correction failed.',
    CAN_NOT_CHANGE_MEMBER_ROLE: 'Unable to change member roles.',
    CAN_NOT_USE_SEAT: 'You do not have permission to toggle ID consumption.',
    APPLICATION_NOT_EXIST: 'The unsubscribe request does not exist.',
    PROCESSING_RESULT_NOT_EXIST: 'The result of the unsubscribe request does not exist.',
    PLAN_CANCEL_APPLICATION_REASON_NOT_EXIST: 'The reason for the unsubscribe request does not exist.',
    PLAN_CANCEL_APPLICATION_OTHER_REASON_NULL: 'The Other reason is required for unsubscribe.',
    PLAN_CANCEL_APPLICATION_EMAIL_ERROR: 'The email address entered for the unsubscribe request does not match the current account.',
    PLAN_CANCEL_APPLICATION_EXIST: 'An unsubscribe request already exists.',
    ACCOUNT_CAN_NOT_USE: 'Your account is unavailable.',
    ACCOUNT_NO_SEAT: 'The "ID Consumption" setting is turned off for this account, so app access is unavailable. ',
    CAN_NOT_EDIT_MEMBER: 'Unable to edit members. ',
    MODEL_IS_NOT_EXIST: 'The model does not exist.',
    SHARE_LINK_NOT_EXIST: 'The shared link does not exist.',
    NOT_CUSTOMER_MEMBER: 'Not a member of this company.',
    SHARE_LINK_PASSWORD_ERROR: 'The password you entered for the shared link is incorrect.',
    STRIPE_PAYMENT_METHOD_NOT_ALLOW: 'Stripe payments are not supported.',
    NOT_ADMIN_FORBIDDEN: 'Not an administrator.',
    NOT_ACTIVE_FORBIDDEN: 'Account is not activated.',
    toast: {
        noMovePermission: 'You do not have permission to move to the destination folder. Please select another destination.',
        exist: 'Already exists in the destination.',
        cannotMove: 'Cannot move to this folder or its subfolders.',
        depth: {
            exceed: 'Folder hierarchy limit reached. Please select another folder.'
        }
    },
    map: {
        gpsEnabledModelCount: '{n} models with GPS positioning',
        emptyFolderNoGpsModel: 'No models with GPS positioning in this folder.',
        searchNoResult: 'No results found. Please try changing the keyword, checking the input, or adjusting the filters.'
    },
    maps: {
        hover: {
            showAllModels: 'Show all models',
            zoomIn: 'Zoom in',
            zoomOut: 'Zoom out'
        }
    },
    collaborator: {
        set: 'Manage collaborators',
        add: 'Add collaborators',
        search: {
            email: 'Enter the member\'s email'
        },
        online: 'Online',
        owner: 'Owner (Company)',
        title: 'collaborator'
    },
    fileModal: {
        cannotOperate: 'Actions are disabled. The file has been deleted.'
    },
    collaboratorlist: {
        set: 'Collaborator List'
    },
    member: {
        searchHint: 'Enter an account to search',
        searchEmpty: 'No results found. Please search with another keyword.',
        addMember: 'Add collaborators',
        owner: 'Owner',
        admin: 'Super Administrator',
        outsider: 'External Member'
    },
    ACCOUNT_EMAIL_CAN_NOT_CREATE_CUSTOMER: 'This email is already registered. Please use a different email to create a company.',
    COOPERATOR_PERMISSION_DENIED: 'No collaboration permissions.',
    TEAM_SPACE_FOLDER_CREATE_NO_ADMIN: 'Only members with administrative privileges can create folders in the team space.',
    NOT_A_FOLDER: 'Not a folder.',
    FOLDER_SPACE_MISMATCH: 'No folder space found.',
    FOLDER_DEPTH_EXCEEDED: 'Folder hierarchy limit reached. Please select another folder.',
    SPACE_FOLDER_CONTAIN_SUB_FOLDER: 'Cannot move to this folder or its subfolders.',
    SPACE_FILE_ALREADY_IN_FOLDER: 'Already exists in the destination.',
    CAN_NOT_FIND_SPACE_FILE: 'Unable to access.The file has been deleted.',
    SPACE_FILE_PATH_NULL: 'File path is empty.',
    COOPERATOR_ALREADY_EXISTS: 'Already in the collaborator list. Addition failed.',
    INVITE_KEY_NOT_EXIST: 'The invitation link does not exist.',
    INVITE_EMAIL_ERROR: 'The invitation email address is invalid.',
    INVITE_STATUS_ERROR: 'Invitation status error.',
    INVITE_STATUS_EXPIRED: 'The invitation has expired.',
    INVITE_CUSTOMER_PLAN_NOT_EXIST: 'Unable to access the page because the inviter has not purchased a subscription.'
};

});

parcelRegister("cV7oD", function(module, exports) {

$parcel$export(module.exports, "default", () => $96808bade28d3563$export$2e2bcd8739ae039);
var $96808bade28d3563$export$2e2bcd8739ae039 = {
    logs: {
        export: {
            btn: "\u5BFC\u51FA",
            text: "\u64CD\u4F5C\u65E5\u5FD7"
        },
        overtimeError: "\u6240\u67E5\u8BE2\u7684\u65E5\u5FD7\u65F6\u95F4\u5DF2\u7ECF\u8D85\u8FC7\u4E00\u5E74\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u65F6\u95F4",
        operateSystem: {
            value3: 'Scanat App',
            value4: 'Scanat Web',
            value1: "ID\u7BA1\u7406\u7CFB\u7EDF"
        },
        operatePage: {
            login: "\u767B\u5F55\u6CE8\u518C",
            personal_setting: "\u4E2A\u4EBA\u8BBE\u7F6E",
            local_model: "\u672C\u5730\u6A21\u578B",
            in_box: "\u6536\u4EF6\u7BB1",
            cloud_model: "\u4E91\u7AEF\u6A21\u578B",
            sample_model: "\u6837\u672C\u5217\u8868",
            main_list: "\u4E3B\u5217\u8868",
            member_manage: "\u56E2\u961F\u7BA1\u7406",
            company_info: "\u516C\u53F8\u4FE1\u606F",
            order_manage: "\u8BA2\u5355\u7BA1\u7406",
            SharedSpace: "\u5171\u4EAB\u7A7A\u95F4",
            TeamsSpace: "\u56E2\u961F\u7A7A\u95F4",
            team_space: "\u56E2\u961F\u7A7A\u95F4",
            personal_space: "\u4E2A\u4EBA\u7A7A\u95F4",
            model_link: "\u6A21\u578B\u94FE\u63A5",
            invite_link: "\u9080\u8BF7\u94FE\u63A5"
        },
        operateType: {
            login: "\u767B\u5F55",
            register: "\u6CE8\u518C",
            cancellation: "\u6CE8\u9500",
            deleteModel: "\u5220\u9664\u6A21\u578B",
            addModel: "\u65B0\u5EFA\u6A21\u578B",
            viewModel: "\u67E5\u770B\u6A21\u578B",
            viewSampleModel: "\u67E5\u770B\u6A21\u578B",
            editModel: "\u4FEE\u6539\u6A21\u578B",
            editModelInfo: "\u4FEE\u6539\u6A21\u578B",
            editModelAvatar: "\u4FEE\u6539\u6A21\u578B",
            editModelName: "\u4FEE\u6539\u6A21\u578B",
            shareModel: "\u5206\u4EAB\u6A21\u578B",
            copyModelShareLink: "\u5206\u4EAB\u6A21\u578B",
            moveModel: "\u79FB\u52A8\u6A21\u578B",
            uploadModel: "\u4E0A\u4F20\u6A21\u578B",
            exportModel: "\u5BFC\u51FA\u6A21\u578B",
            copyModel: "\u590D\u5236\u6A21\u578B",
            applyCad: "\u7533\u8BF7CAD",
            addFolder: "\u65B0\u5EFA\u6587\u4EF6\u5939",
            editFolder: "\u4FEE\u6539\u6587\u4EF6\u5939",
            deleteFolder: "\u5220\u9664\u6587\u4EF6\u5939",
            moveFolder: "\u79FB\u52A8\u6587\u4EF6\u5939",
            downloadModel: "\u4E0B\u8F7D\u6A21\u578B",
            buyAccountPlan: "\u8D2D\u4E70\u5957\u9910",
            inviteMember: "\u65B0\u589E\u6210\u5458",
            addEnableMember: "\u65B0\u589E\u6210\u5458",
            addDisableMember: "\u65B0\u589E\u6210\u5458",
            enableMember: "\u4FEE\u6539\u6210\u5458",
            disableMember: "\u4FEE\u6539\u6210\u5458",
            setMemberAdmin: "\u4FEE\u6539\u6210\u5458",
            unsetMemberAdmin: "\u4FEE\u6539\u6210\u5458",
            editMemberName: "\u4FEE\u6539\u6210\u5458",
            editCustomerInfo: "\u4FEE\u6539\u4FE1\u606F",
            downloadInvoices: "\u4E0B\u8F7D\u53D1\u7968",
            addId: "\u5E2D\u4F4D\u6269\u5BB9",
            switchCard: "\u66F4\u6362\u6263\u8D39\u4FE1\u7528\u5361",
            batchAdd: "\u6279\u91CF\u65B0\u589E",
            batchDelete: "\u6279\u91CF\u79FB\u9664",
            activeMember: "\u6FC0\u6D3B\u6210\u5458",
            deleteMember: "\u79FB\u9664\u6210\u5458",
            payOrder: "\u652F\u4ED8\u8BA2\u5355",
            cancelOrder: "\u53D6\u6D88\u8BA2\u5355",
            PermissionChange: "\u4FEE\u6539\u6743\u9650",
            URLreset: "\u91CD\u7F6E\u94FE\u63A5",
            FolderSharing: "\u5206\u4EAB\u6587\u4EF6\u5939",
            expandOrder: "\u5E2D\u4F4D\u6269\u5BB9",
            changeCard: "\u66F4\u6362\u6263\u8D39\u4FE1\u7528\u5361",
            batchAddMembers: "\u6279\u91CF\u65B0\u589E",
            batchDeleteMembers: "\u6279\u91CF\u79FB\u9664",
            exportMember: "\u5BFC\u51FA",
            buyOrder: "\u8D2D\u4E70\u5957\u9910",
            addMember: "\u65B0\u589E\u6210\u5458",
            editCustomer: "\u4FEE\u6539\u4FE1\u606F",
            applyToCancle: "\u7533\u8BF7\u53D6\u6D88\u8BA2\u9605",
            planCancelApplication: "\u7533\u8BF7\u53D6\u6D88\u8BA2\u9605",
            editLink: "\u4FEE\u6539\u94FE\u63A5",
            moveModelHome: "\u79FB\u52A8\u6A21\u578B",
            moveFolderHome: "\u79FB\u52A8\u6587\u4EF6\u5939",
            copyLink: "\u5206\u4EAB\u6A21\u578B",
            changeLink: "\u4FEE\u6539\u94FE\u63A5",
            changeLinkPassword: "\u4FEE\u6539\u94FE\u63A5",
            resetPassword: "\u91CD\u7F6E\u5BC6\u7801",
            addMemberNew: "\u65B0\u589E\u6210\u5458",
            editMemberStatus: "\u4FEE\u6539\u6210\u5458",
            editMemberNew: "\u4FEE\u6539\u6210\u5458",
            enable: "\u542F\u7528\u6210\u5458",
            disable: "\u7981\u7528\u6210\u5458",
            changeSeat: "\u4FEE\u6539\u5E2D\u4F4D",
            changeRole: "\u4FEE\u6539\u89D2\u8272",
            uploadFile: "\u5BFC\u5165\u6A21\u578B\u6587\u4EF6",
            manageCollaborator: "\u8BBE\u7F6E\u534F\u4F5C\u8005",
            moveFolderToFolder: "\u79FB\u52A8\u6587\u4EF6\u5939",
            moveFolderToRoot: "\u79FB\u52A8\u6587\u4EF6\u5939",
            moveModelToFolder: "\u79FB\u52A8\u6A21\u578B",
            moveModelToRoot: "\u79FB\u52A8\u6A21\u578B",
            addCollaborator: "\u8BBE\u7F6E\u534F\u4F5C\u8005",
            deleteCollaborator: "\u8BBE\u7F6E\u534F\u4F5C\u8005",
            updateCollaborator: "\u8BBE\u7F6E\u534F\u4F5C\u8005",
            inviteCollaborator: "\u9080\u8BF7\u534F\u4F5C\u8005",
            resentInvite: "\u9080\u8BF7\u534F\u4F5C\u8005",
            resentInviteWithDate: "\u9080\u8BF7\u534F\u4F5C\u8005",
            acceptInvite: "\u63A5\u53D7\u9080\u8BF7",
            viewFolder: "\u67E5\u770B\u6587\u4EF6\u5939",
            uploadToFolder: "\u4E0A\u4F20\u6A21\u578B",
            uploadToRoot: "\u4E0A\u4F20\u6A21\u578B",
            importFileToRoot: "\u5BFC\u5165\u6A21\u578B\u6587\u4EF6",
            importFileToFolder: "\u5BFC\u5165\u6A21\u578B\u6587\u4EF6"
        },
        detail: {
            register: "\u6CE8\u518C\u4E86\u65B0\u8D26\u53F7",
            login: "\u767B\u5F55\u4E86\u7CFB\u7EDF",
            cancellation: "\u6CE8\u9500\u4E86\u8D26\u53F7",
            deleteModel: "\u5220\u9664\u4E86\u6A21\u578B\u3010{detail0}\u3011",
            addModel: "\u626B\u63CF\u4E86\u6A21\u578B\u3010{detail0}\u3011\uFF0C\u626B\u63CF\u65B9\u5F0F\u4E3A\u3010{detail1}\u3011",
            viewModel: "\u67E5\u770B\u4E86\u6A21\u578B\u3010{detail0}\u3011",
            editModelInfo: "\u4FEE\u6539\u4E86\u6A21\u578B\u3010{detail0}\u3011\u4FE1\u606F\u4E3A\u3010\u6A21\u578B\u540D\u79F0\uFF1A{detail1}\uFF1B\u90AE\u7F16\uFF1A{detail2}\uFF1B\u5730\u5740\uFF1A{detail3}\uFF1B\u5EFA\u7B51\u540D\u79F0\uFF1A{detail4}\u3011",
            editModelAvatar: "\u4FEE\u6539\u4E86\u6A21\u578B\u3010{detail0}\u3011\u7684\u5C01\u9762\u56FE",
            editModel: "\u5BF9\u6A21\u578B\u3010{detail0}\u3011\u8FDB\u884C\u4E86\u3010{detail1}\u3011\u64CD\u4F5C",
            moveModel: "\u79FB\u52A8\u6A21\u578B\u3010{detail0}\u3011\u81F3\u6587\u4EF6\u5939\u3010{detail1}\u3011",
            uploadModel: "\u4E0A\u4F20\u6A21\u578B\u3010{detail0}\u3011\u81F3\u4E91\u7AEF",
            exportModel: "\u5BFC\u51FA\u6A21\u578B\u3010{detail0}\u3011\u7684\u6570\u636E",
            copyModel: "\u590D\u5236\u4E86\u6A21\u578B\u3010{detail0}\u3011\u4E3A\u3010{detail1}\u3011",
            applyCad: "\u63D0\u4EA4\u4E86\u6A21\u578B\u3010{detail0}\u3011\u7684 CAD\u7533\u8BF7",
            addFolder: "\u65B0\u5EFA\u4E86\u6587\u4EF6\u5939\u3010{detail0}\u3011",
            editFolder: "\u4FEE\u6539\u4E86\u6587\u4EF6\u5939\u3010{detail0}\u3011\u540D\u79F0\u4E3A\u3010{detail1}\u3011",
            deleteFolder: "\u5220\u9664\u4E86\u6587\u4EF6\u5939\u3010{detail0}\u3011",
            moveFolder: "\u79FB\u52A8\u6587\u4EF6\u5939\u3010{detail0}\u3011\u81F3\u6587\u4EF6\u5939\u3010{detail1}\u3011",
            downloadModel: "\u4E0B\u8F7D\u4E86\u6A21\u578B\u3010{detail0}\u3011",
            viewSampleModel: "\u67E5\u770B\u4E86\u6A21\u578B\u3010\u6837\u672C\u6A21\u578B\u3011",
            editModelName: "\u4FEE\u6539\u4E86\u6A21\u578B\u3010{detail0}\u3011\u540D\u79F0\u4E3A\u3010{detail1}\u3011",
            buyAccountPlan: "\u8D2D\u4E70\u4E86\u3010{detail0}\u3011\uFF0C\u542B{detail1}\u4E2A\u5E2D\u4F4D\uFF0C\u7A0E\u540E\u91D1\u989D{detail2}\u65E5\u5143\uFF0C\u4ED8\u6B3E\u65B9\u5F0F\u4E3A\u3010{detail3}\u3011",
            addEnableMember: "\u65B0\u589E\u6210\u5458\u3010{detail0}\u3011\uFF0C\u72B6\u6001\u4E3A\u3010\u53EF\u7528\u3011",
            addDisableMember: "\u65B0\u589E\u6210\u5458\u3010{detail0}\u3011\uFF0C\u72B6\u6001\u4E3A\u3010\u4E0D\u53EF\u7528\u3011",
            inviteMember: "\u65B0\u589E\u6210\u5458\u3010{detail0}\u3011\uFF0C\u7B49\u5F85\u5BF9\u65B9\u63A5\u53D7\u9080\u8BF7",
            enableMember: "\u8BBE\u7F6E\u6210\u5458\u3010{detail0}\u3011\u72B6\u6001\u4E3A\u3010\u53EF\u7528\u3011",
            disableMember: "\u8BBE\u7F6E\u6210\u5458\u3010{detail0}\u3011\u72B6\u6001\u4E3A\u3010\u4E0D\u53EF\u7528\u3011",
            setMemberAdmin: "\u8BBE\u7F6E\u6210\u5458\u3010{detail0}\u3011\u4E3A\u7BA1\u7406\u5458",
            unsetMemberAdmin: "\u53D6\u6D88\u8BBE\u7F6E\u6210\u5458\u3010{detail0}\u3011\u4E3A\u7BA1\u7406\u5458",
            editMemberName: "\u4FEE\u6539\u6210\u5458\u3010{detail0}\u3011\u540D\u79F0\u4E3A\u3010{detail1}\u3011",
            editCustomerInfo: "\u4FEE\u6539\u4E86\u516C\u53F8\u4FE1\u606F\u4E3A\u3010\u90AE\u653F\u7F16\u7801\uFF1A{detail0}\uFF1B\u90FD\u9053\u5E9C\u53BF\uFF1A{detail1}\uFF1B\u76F4\u8F96\u5E02\uFF1A{detail2}\uFF1B\u5730\u533A\u540D\u79F0\uFF1A{detail3}\uFF1B\u8D1F\u8D23\u4EBA\u59D3\uFF1A{detail4}\uFF1B\u8D1F\u8D23\u4EBA\u540D\uFF1A{detail5}\uFF1B\u7535\u8BDD\u53F7\u7801\uFF1A{detail6}\uFF1B\u6240\u5C5E\u884C\u4E1A\uFF1A{detail7}\uFF1B\u5458\u5DE5\u4EBA\u6570\uFF1A{detail8}\uFF1B\u4E3B\u8425\u4E1A\u52A1\uFF1A{detail9}\u3011",
            downloadInvoices: "\u4E0B\u8F7D\u4E86\u8BA2\u5355\u3010{detail0}\u3011\u7684\u53D1\u7968\u81F3\u672C\u5730",
            moveModelHome: "\u79FB\u52A8\u6A21\u578B\u3010{detail0}\u3011\u81F3\u3010\u4E3B\u76EE\u5F55\u3011",
            moveFolderHome: "\u79FB\u52A8\u6587\u4EF6\u5939\u3010{detail0}\u3011\u81F3\u3010\u4E3B\u76EE\u5F55\u3011",
            expandOrder: "\u63D0\u4EA4\u4E86\u3010\u5E2D\u4F4D\u6269\u5BB9\u3011\u8BA2\u5355\uFF0C\u8BA2\u5355\u4FE1\u606F\uFF1A\u3010\u8BA2\u5355\u53F7\uFF1A{detail0}\uFF1B\u5957\u9910\uFF1A{detail1}\uFF1B\u8BA2\u5355\u7C7B\u578B\uFF1A\u6269\u5BB9\uFF1B\u8BA2\u8D2D\u65B9\u5F0F\uFF1A{detail2}\uFF1B\u65B0\u589E\u5E2D\u4F4D\u6570\uFF1A{detail3}\uFF1B\u5E2D\u4F4D\u52A0\u5165\u65F6\u95F4\uFF1A{detail4}\uFF1B\u603B\u91D1\u989D\uFF1A{detail5}\uFF1B\u7A0E\u8D39\uFF1A{detail6}\uFF1B\u5E94\u4ED8\u91D1\u989D\uFF1A{detail7}\u3011",
            buyOrder: "\u63D0\u4EA4\u4E86\u3010\u8D2D\u4E70\u5957\u9910\u3011\u8BA2\u5355\uFF0C\u8BA2\u5355\u4FE1\u606F\uFF1A\u3010\u8BA2\u5355\u53F7\uFF1A{detail0}\uFF1B\u5957\u9910\uFF1A{detail1}\uFF1B\u8BA2\u5355\u7C7B\u578B\uFF1A\u8D2D\u4E70\uFF1B\u8BA2\u8D2D\u65B9\u5F0F\uFF1A{detail2}\uFF1B\u5E2D\u4F4D\u6570\uFF1A{detail3};  \u603B\u91D1\u989D\uFF1A{detail4}\uFF1B\u7A0E\u8D39\uFF1A{detail5}\uFF1B\u5E94\u4ED8\u91D1\u989D\uFF1A{detail6}\u3011",
            changeCard: "\u66F4\u6362\u4E86\u6263\u8D39\u4FE1\u7528\u5361\u4E3A{detail0}",
            addMember: "\u65B0\u589E\u6210\u5458\u3010{detail0}\u3011\uFF0C\u72B6\u6001\u4E3A\u3010{detail1}\u3011",
            batchAddMembers: "\u6279\u91CF\u65B0\u589E\u4E86{detail0}\u4F4D\u6210\u5458",
            batchDeleteMembers: "\u6279\u91CF\u79FB\u9664\u4E86{detail0}\u4F4D\u6210\u5458",
            exportMember: "\u5BFC\u51FA\u4E86\u6210\u5458\u5217\u8868",
            activeMember: "\u6FC0\u6D3B\u4E86\u6210\u5458\u3010{detail0}\u3011",
            deleteMember: "\u79FB\u9664\u4E86\u6210\u5458\u3010{detail0}\u3011",
            editCustomer: "\u4FEE\u6539\u4E86\u516C\u53F8\u4FE1\u606F\u4E3A\u3010\u516C\u53F8\u540D\u79F0\uFF1A{detail0}\uFF0C\u4E3B\u62C5\u5F53\u8005\uFF1A{detail1}\uFF0C{detail2}\uFF0C{detail3}\uFF1B\u90AE\u7F16\uFF1A{detail4}\uFF1B\u5730\u5740\uFF1A{detail5}\uFF1B\u884C\u4E1A\u5206\u7C7B\uFF1A{detail6}\uFF1B\u5458\u5DE5\u89C4\u6A21\uFF1A{detail7}\uFF1B\u6CE8\u518C\u8D44\u672C\uFF1A{detail8}\uFF1B\u4E3B\u8425\u4E1A\u52A1\uFF1A{detail9}\u3011",
            payOrder: "\u652F\u4ED8\u4E86\u8BA2\u5355\u3010{detail0}\u3011\uFF0C\u652F\u4ED8\u65B9\u5F0F\u4E3A\u3010{detail1}\u3011",
            cancelOrder: "\u53D6\u6D88\u4E86\u8BA2\u5355\u3010{detail0}\u3011",
            SendModelViewable: "\u5206\u4EAB\u6A21\u578B\u3010{detail0}\u3011\u7ED9\u7528\u6237\u3010{detail1}\u3011\uFF0C\u8BBF\u95EE\u6743\u9650\u4E3A\u3010\u53EF\u67E5\u770B\u3011",
            CopiedModelPrivateLink: "\u590D\u5236\u4E86\u6A21\u578B\u3010{detail0}\u3011\u7684\u3010\u79C1\u5BC6\u94FE\u63A5\u3011",
            AddedModelMember: "\u9488\u5BF9\u6A21\u578B\u3010{detail0}\u3011\uFF0C\u6DFB\u52A0\u6210\u5458\u3010{detail1}\u3011\u4E3A\u3010\u53EF\u67E5\u770B\u3011\u6743\u9650",
            UpdatedModelMember: "\u9488\u5BF9\u6A21\u578B\u3010{detail0}\u3011\uFF0C\u4FEE\u6539\u6210\u5458\u3010{detail1}\u3011\u4E3A\u3010\u53EF\u7F16\u8F91\u3011\u6743\u9650",
            RemovedModelViewable: "\u9488\u5BF9\u6A21\u578B\u3010{detail0}\u3011\uFF0C\u5220\u9664\u6210\u5458\u3010{detail1}\u3011\u7684\u3010\u53EF\u67E5\u770B\u3011\u6743\u9650",
            ResetModelPrivateLink: "\u91CD\u7F6E\u4E86\u6A21\u578B\u3010{detail0}\u3011\u7684\u3010\u79C1\u5BC6\u94FE\u63A5\u3011",
            SharedFolder: "\u5206\u4EAB\u6587\u4EF6\u5939\u3010{detail0}\u3011\u7ED9\u7528\u6237\u3010{detail1}\u3011",
            CopiedFolderPublicLink: "\u590D\u5236\u4E86\u6587\u4EF6\u5939\u3010{detail0}\u3011\u7684\u3010\u516C\u5F00\u94FE\u63A5\u3011",
            ResetModelPublicLink: "\u91CD\u7F6E\u4E86\u6A21\u578B\u3010{detail0}\u3011\u7684\u3010\u516C\u5F00\u94FE\u63A5\u3011",
            SendModelEditable: "\u5206\u4EAB\u6A21\u578B\u3010{detail0}\u3011\u7ED9\u7528\u6237\u3010{detail1}\u3011\uFF0C\u6743\u9650\u4E3A\u3010\u53EF\u7F16\u8F91\u3011",
            RenamedFolder: "\u4FEE\u6539\u4E86\u6587\u4EF6\u5939\u3010{detail0}\u3011\u4E3A\u3010\u6587\u4EF6\u5939\u540D\u79F0\uFF1A{detail1}\uFF1B\u7B80\u4ECB\uFF1A{detail2}\u3011",
            SharedFolderViewable: "\u5206\u4EAB\u6587\u4EF6\u5939\u3010{detail0}\u3011\u7ED9\u7528\u6237\u3010{detail1}\u3011\uFF0C\u6743\u9650\u4E3A\u3010\u53EF\u67E5\u770B\u3011",
            CopiedFolderPrivateLink: "\u590D\u5236\u4E86\u6587\u4EF6\u5939\u3010{detail0}\u3011\u7684\u3010\u79C1\u5BC6\u94FE\u63A5\u3011",
            AddedFolderMember: "\u9488\u5BF9\u6587\u4EF6\u5939\u3010{detail0}\u3011\uFF0C\u6DFB\u52A0\u6210\u5458\u3010{detail1}\u3011\u4E3A\u3010\u53EF\u67E5\u770B\u3011\u6743\u9650",
            UpdatedFolderMember: "\u9488\u5BF9\u6587\u4EF6\u5939\u3010{detail0}\u3011\uFF0C\u4FEE\u6539\u6210\u5458\u3010{detail1}\u3011\u4E3A\u3010\u53EF\u7F16\u8F91\u3011\u6743\u9650",
            RemovedFolderViewable: "\u9488\u5BF9\u6587\u4EF6\u5939\u3010{detail0}\u3011\uFF0C\u5220\u9664\u6210\u5458\u3010{detail1}\u3011\u7684\u3010\u53EF\u67E5\u770B\u3011\u6743\u9650",
            ResetFolderPublicLink: "\u91CD\u7F6E\u4E86\u6587\u4EF6\u5939\u3010{detail0}\u3011\u7684\u3010\u516C\u5F00\u94FE\u63A5\u3011",
            addModel1: "\u7B80\u6613\u626B\u63CF",
            addModel2: "\u8BE6\u7EC6\u626B\u63CF",
            editModel1: "\u5207\u5272",
            editModel2: "\u5BF9\u9F50",
            editModel3: "\u53D8\u5F62",
            buyAccountPlan2: "\u8BF7\u6C42\u4E66",
            buyAccountPlan1: "\u4FE1\u7528\u5361",
            editCustomerSex0: "\u7537",
            editCustomerSex1: "\u5973",
            editCustomerInfo1: "\u5EFA\u7B51\u4E1A",
            editCustomerInfo2: "\u5236\u9020\u4E1A",
            editCustomerInfo3: "\u623F\u5730\u4EA7\u4E1A\u30FB\u7269\u54C1\u79DF\u8D41\u4E1A",
            editCustomerInfo4: "\u4FE1\u606F\u901A\u4FE1\u4E1A",
            editCustomerInfo5: "\u7535\u529B\u30FB\u71C3\u6C14\u30FB\u70ED\u529B\u30FB\u81EA\u6765\u6C34\u4E1A",
            editCustomerInfo6: "\u8FD0\u8F93\u4E1A\u30FB\u90AE\u653F\u4E1A",
            editCustomerInfo7: "\u4FE1\u606F\u5904\u7406\u670D\u52A1\u4E1A",
            editCustomerInfo8: "\u5B66\u672F\u7814\u7A76\u30FB\u4E13\u4E1A\u30FB\u6280\u672F\u670D\u52A1\u4E1A",
            editCustomerInfo9: "\u6279\u53D1\u4E1A\u30FB\u96F6\u552E\u4E1A",
            editCustomerInfo10: "\u8C03\u7814\u4E1A",
            editCustomerInfo0: '-',
            editCustomerInfoStaff1: '1~50',
            editCustomerInfoStaff2: '51~100',
            editCustomerInfoStaff3: "100\u4EBA\u4EE5\u4E0A",
            editCustomerInfoStaff0: '-',
            editCustomer1: "\u5EFA\u7B51\u4E1A",
            editCustomer2: "\u5236\u9020\u4E1A",
            editCustomer3: "\u623F\u5730\u4EA7\u4E1A\u30FB\u7269\u54C1\u79DF\u8D41\u4E1A",
            editCustomer4: "\u4FE1\u606F\u901A\u4FE1\u4E1A",
            editCustomer5: "\u7535\u529B\u30FB\u71C3\u6C14\u30FB\u70ED\u529B\u30FB\u81EA\u6765\u6C34\u4E1A",
            editCustomer6: "\u8FD0\u8F93\u4E1A\u30FB\u90AE\u653F\u4E1A",
            editCustomer7: "\u4FE1\u606F\u5904\u7406\u670D\u52A1\u4E1A",
            editCustomer8: "\u5B66\u672F\u7814\u7A76\u30FB\u4E13\u4E1A\u30FB\u6280\u672F\u670D\u52A1\u4E1A",
            editCustomer9: "\u6279\u53D1\u4E1A\u30FB\u96F6\u552E\u4E1A",
            editCustomer10: "\u8C03\u7814\u4E1A",
            editCustomer0: '-',
            editCustomerStaff1: '1~50',
            editCustomerStaff2: '51~100',
            editCustomerStaff3: "100\u4EBA\u4EE5\u4E0A",
            editCustomerStaff0: '-',
            payOrder1: "\u4FE1\u7528\u5361",
            payOrder2: "\u8BF7\u6C42\u4E66",
            addMember0: "\u672A\u6FC0\u6D3B",
            addMember1: "\u4F7F\u7528\u4E2D",
            period1: "\u5E74\u4ED8",
            period2: "\u6708\u4ED8",
            applyToCancle: "\u63D0\u4EA4\u4E86\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7",
            planCancelApplication: "\u63D0\u4EA4\u4E86\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7",
            shareModel: "\u5206\u4EAB\u6A21\u578B\u3010{detail0}\u3011\u7ED9\u7528\u6237\u3010{detail1}\u3011",
            copyModelShareLink: "\u590D\u5236\u4E86\u6A21\u578B\u3010{detail0}\u3011\u7684\u5206\u4EAB\u94FE\u63A5",
            changeLinkPassword: "\u4FEE\u6539\u4E86\u6A21\u578B\u3010{detail0}\u3011\u52A0\u5BC6\u94FE\u63A5\u7684\u5BC6\u7801",
            ResetModelLink: "\u91CD\u7F6E\u4E86\u6A21\u578B\u3010{detail0}\u3011\u7684\u3010{detail1}\u3011",
            ResetFolderLink: "\u91CD\u7F6E\u4E86\u6587\u4EF6\u5939\u3010{detail0}\u3011\u7684\u3010{detail1}\u3011",
            resetPassword: "\u91CD\u7F6E\u4E86\u5BC6\u7801",
            copyLink1: "\u79C1\u5BC6\u94FE\u63A5",
            copyLink2: "\u52A0\u5BC6\u94FE\u63A5",
            copyLink3: "\u516C\u5F00\u94FE\u63A5",
            changeLink1: "\u79C1\u5BC6\u94FE\u63A5",
            changeLink2: "\u52A0\u5BC6\u94FE\u63A5",
            changeLink3: "\u516C\u5F00\u94FE\u63A5",
            copyLink: "\u590D\u5236\u4E86\u6A21\u578B\u3010{detail0}\u3011\u7684\u3010{detail1}\u3011",
            changeLink: "\u4FEE\u6539\u4E86\u6A21\u578B\u3010{detail0}\u3011\u7684\u5206\u4EAB\u94FE\u63A5\u6743\u9650\u4E3A\u3010{detail1}\u3011",
            editMemberStatus: "\u4FEE\u6539\u6210\u5458\u3010{detail0}\u3011\u72B6\u6001\u4E3A\u3010{detail1}\u3011",
            addMemberNew: "\u65B0\u589E\u6210\u5458\u3010{detail0}\u3011\uFF0C\u89D2\u8272\u4E3A\u3010{detail1}\u3011\uFF0C\u5E2D\u4F4D\u72B6\u6001\u3010{detail2}\u3011\uFF0C\u72B6\u6001\u4E3A\u3010\u4F7F\u7528\u4E2D\u3011",
            editMemberNew: "\u4FEE\u6539\u6210\u5458\u3010{detail0}\u3011\u7684\u540D\u79F0\u4E3A\u3010{detail1}\u3011\uFF0C\u89D2\u8272\u4E3A\u3010{detail2}\u3011\uFF0C\u5E2D\u4F4D\u72B6\u6001\u4E3A\u3010{detail3}\u3011",
            enable: "\u542F\u7528\u6210\u5458\u3010{detail0}\u3011",
            disable: "\u7981\u7528\u6210\u5458\u3010{detail0}\u3011",
            changeSeat: "\u4FEE\u6539\u6210\u5458\u3010{detail0}\u3011\u7684\u5E2D\u4F4D\u72B6\u6001\u4E3A\u3010{detail1}\u3011",
            changeRole: "\u4FEE\u6539\u6210\u5458\u3010{detail0}\u3011\u7684\u89D2\u8272\u4E3A\u3010{detail1}\u3011",
            role1: "\u8D85\u7EA7\u7BA1\u7406\u5458",
            role3: "\u7BA1\u7406\u5458",
            role0: "Scanat\u7528\u6237",
            role4: "\u6D4F\u89C8\u7528\u6237",
            changeSeat1: "\u5F00\u542F",
            changeSeat0: "\u5173\u95ED",
            uploadFile: "\u5BFC\u5165\u4E86\u6A21\u578B\u3010{detail0}\u3011\uFF0C\u5BFC\u5165\u6587\u4EF6\u7C7B\u578B\u4E3A{detail1}",
            uploadToFolder: "\u4E0A\u4F20\u6A21\u578B\u3010{detail0}\u3011\u81F3{detail1}\u7684\u6587\u4EF6\u5939\u3010{detail2}\u3011",
            uploadToRoot: "\u4E0A\u4F20\u6A21\u578B\u3010{detail0}\u3011\u81F3{detail1}\u7684\u3010\u4E3B\u76EE\u5F55\u3011",
            moveFolderToFolder: "\u79FB\u52A8\u6587\u4EF6\u5939\u3010{detail0}\u3011\u81F3{detail1}\u7684\u6587\u4EF6\u5939\u3010{detail2}\u3011",
            moveFolderToRoot: "\u79FB\u52A8\u6587\u4EF6\u5939\u3010{detail0}\u3011\u81F3{detail1}\u7684\u3010\u4E3B\u76EE\u5F55\u3011",
            moveModelToFolder: "\u79FB\u52A8\u6A21\u578B\u3010{detail0}\u3011\u81F3{detail1}\u7684\u6587\u4EF6\u5939\u3010{detail2}\u3011",
            moveModelToRoot: "\u79FB\u52A8\u6A21\u578B\u3010{detail0}\u3011\u81F3{detail1}\u7684\u3010\u4E3B\u76EE\u5F55\u3011",
            addCollaborator: "\u5728{detail0}\u3010{detail1}\u3011\u4E2D\u6DFB\u52A0\u4E86\u534F\u4F5C\u8005\u3010{detail2}\u3011\uFF0C\u6743\u9650\u4E3A\u3010{detail3}\u3011",
            deleteCollaborator: "\u5728{detail0}\u3010{detail1}\u3011\u4E2D\u5220\u9664\u4E86\u534F\u4F5C\u8005\u3010{detail2}\u3011",
            updateCollaborator: "\u4FEE\u6539\u4E86{detail0}\u3010{detail1}\u3011\u4E2D\u534F\u4F5C\u8005\u3010{detail2}\u3011\u7684\u6743\u9650\u4E3A\u3010{detail3}\u3011",
            space0: "\u4E2A\u4EBA\u7A7A\u95F4",
            space1: "\u56E2\u961F\u7A7A\u95F4",
            collaboratorPermission0: "\u4EC5\u67E5\u770B",
            collaboratorPermission1: "\u53EF\u7F16\u8F91",
            collaboratorPermission2: "\u53EF\u7BA1\u7406",
            fileType0: "\u6A21\u578B",
            fileType1: "\u6587\u4EF6\u5939",
            importFile: "\u5BFC\u5165\u4E86\u6A21\u578B\u3010{detail0}\u3011\uFF0C\u4E0A\u4F20\u5BFC\u5165\u6587\u4EF6\u7C7B\u578B\u4E3A{detail1}",
            inviteCollaborator: "\u9080\u8BF7\u4E86\u3010{detail0}\u3011\uFF0C\u6743\u9650\u4E3A\u3010{detail1}\u3011\uFF0C\u6709\u6548\u671F\u4E3A\u3010{detail2}\u5929\u3011",
            resentInvite: "\u5411\u3010{detail0}\u3011\u91CD\u65B0\u53D1\u9001\u4E86\u534F\u4F5C\u8005\u9080\u8BF7",
            resentInviteWithDate: "\u5411\u3010{detail0}\u3011\u91CD\u65B0\u53D1\u9001\u4E86\u534F\u4F5C\u8005\u9080\u8BF7\uFF0C\u5E76\u8BBE\u7F6E\u6709\u6548\u671F\u4E3A\u3010{detail1}\u5929\u3011",
            acceptInvite: "\u63A5\u53D7\u4E86\u534F\u4F5C\u8005\u9080\u8BF7",
            viewFolder: "\u67E5\u770B\u4E86\u6587\u4EF6\u5939\u3010{detail0}\u3011",
            importFileToRoot: "\u5BFC\u5165\u6A21\u578B\u3010{detail0}\u3011\u81F3{detail1}\u7684\u3010\u4E3B\u76EE\u5F55\u3011\uFF0C\u5BFC\u5165\u6587\u4EF6\u7C7B\u578B\u4E3A{detail2}",
            importFileToFolder: "\u5BFC\u5165\u6A21\u578B\u3010{detail0}\u3011\u81F3{detail1}\u7684\u6587\u4EF6\u5939\u3010{detail2}\u3011\uFF0C\u5BFC\u5165\u6587\u4EF6\u7C7B\u578B\u4E3A{detail3}"
        }
    },
    common: {
        close: "\u5173\u95ED",
        got: "\u6211\u77E5\u9053\u4E86",
        title: {
            email: "\u90AE\u7BB1"
        },
        cancel: "\u53D6\u6D88",
        share: "\u5206\u4EAB",
        settings: "\u8BBE\u7F6E",
        save: "\u4FDD\u5B58",
        yes: "\u662F",
        no: "\u65E0",
        done: "\u5DF2\u5B8C\u6210/\u5B8C\u6210",
        name: "\u540D\u79F0",
        loading: "\u52A0\u8F7D\u4E2D",
        back: "\u8FD4\u56DE",
        deleteConfirm: "\u8981\u5220\u9664\u5417\uFF1F",
        delete: "\u5220\u9664",
        rename: "\u66F4\u6539\u540D\u79F0",
        empty: "\u6CA1\u6709\u53EF\u7528\u6570\u636E",
        inputhint: "\u8BF7\u8F93\u5165",
        pre: "\u4E0A\u4E00\u4E2A",
        next: "\u4E0B\u4E00\u4E2A",
        beginning: "\u7B2C\u4E00\u9875",
        last: "\u6700\u540E\u4E00\u9875",
        forwardPage: "\u8DF3\u8F6C",
        summary: "\u5171{n}\u6761",
        ok: "\u786E\u5B9A",
        select: "\u9009\u62E9",
        confirm: "\u786E\u8BA4",
        selectAll: "\u5168\u9009",
        all: "\u5168\u90E8",
        minimize: "\u6700\u5C0F\u5316",
        submit: "\u63D0\u4EA4",
        deregister: "\u6CE8\u9500",
        action: "\u64CD\u4F5C",
        active: "\u6FC0\u6D3B",
        edit: "\u7F16\u8F91",
        more: "\u66F4\u591A",
        batch: "\u6279\u91CF\u64CD\u4F5C",
        MultiDelete: "\u6279\u91CF\u79FB\u9664",
        export: "\u5BFC\u51FA",
        setDefault: "\u8BBE\u4E3A\u9ED8\u8BA4",
        create: "\u65B0\u589E",
        fillin: "\u53BB\u586B\u5199",
        reset: "\u91CD\u7F6E",
        other: "\u5176\u4ED6",
        input: "\u8BF7\u8F93\u5165",
        selectHint: "\u8BF7\u9009\u62E9",
        uploadFile: "\u4E0A\u4F20\u6587\u4EF6",
        uploadForm: "\u4E0A\u4F20\u8868\u683C",
        steps: "\u64CD\u4F5C\u6B65\u9AA4",
        import: "\u786E\u8BA4\u5BFC\u5165",
        download: "\u4E0B\u8F7D",
        note: "\u5907\u6CE8",
        normalTip: "\u6E29\u99A8\u63D0\u793A",
        clear: "\u6E05\u7A7A",
        member: "\u6210\u5458",
        memberPermission: "\u6210\u5458\u4E0E\u6743\u9650",
        move: "\u79FB\u52A8",
        remove: "\u79FB\u9664",
        scanatId: 'Scanat ID',
        startTime: "\u5F00\u59CB\u65F6\u95F4",
        endTime: "\u7ED3\u675F\u65F6\u95F4",
        page: {
            total: "\u603B\u8BA1 {detail0} \u6761",
            first: "\u9996\u9875",
            previous: "\u4E0A\u4E00\u9875",
            next: "\u4E0B\u4E00\u9875",
            last: "\u672B\u9875",
            go: "\u524D\u5F80\u7B2C{detail0}\u9875",
            perPage: "\u6761/\u9875"
        }
    },
    mesh: {
        export: "\u5BFC\u51FA\u6A21\u578B\u6570\u636E",
        download: "\u6570\u636E\u4E0B\u8F7D",
        all: "\u6240\u6709\u6570\u636E",
        tip: "\u6253\u5305\u5E76\u5BFC\u51FA\u6A21\u578B\u6240\u6709\u6570\u636E",
        default: "\u7F51\u683C",
        pointCloud: "\u70B9\u4E91",
        processing: "\u6B63\u5728\u5904\u7406",
        gltf: "\u7528\u4E8E\u5B89\u5353",
        obj: "\u5E94\u7528\u5E7F\u6CDB",
        stl: "\u7528\u4E8E3D\u6253\u5370\u673A"
    },
    week: {
        mon: "\u4E00",
        tue: "\u4E8C",
        wed: "\u4E09",
        thu: "\u56DB",
        fri: "\u4E94",
        sat: "\u516D",
        sun: "\u65E5"
    },
    month: {
        jan: "1\u6708",
        feb: "2\u6708",
        mar: "3\u6708",
        apr: "4\u6708",
        may: "5\u6708",
        jun: "6\u6708",
        jul: "7\u6708",
        aug: "8\u6708",
        sep: "9\u6708",
        oct: "10\u6708",
        nov: "11\u6708",
        dec: "12\u6708"
    },
    login: {
        passwordWrong: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u5BC6\u7801",
        accountUndefined: "\u7528\u6237\u540D\u4E0D\u5B58\u5728",
        verifiWrong: "\u9A8C\u8BC1\u7801\u4E0D\u6B63\u786E",
        verifiExpired: "\u9A8C\u8BC1\u7801\u5DF2\u8FC7\u671F",
        loginVerifiSent: "\u767B\u5F55\u9A8C\u8BC1\u7801\u5DF2\u53D1\u9001\u5230\u60A8\u7684\u7535\u5B50\u90AE\u7BB1",
        verifiSend: "\u91CD\u65B0\u53D1\u9001\u9A8C\u8BC1\u7801",
        login: "\u767B\u5F55",
        register: "\u6CE8\u518C",
        back: "\u56DE\u5230\u767B\u5F55\u9875\u9762",
        guideRegister: "\u70B9\u51FB\u8FD9\u91CC\u6CE8\u518C\u65B0\u8D26\u6237",
        newAccount: "\u65B0\u7528\u6237\u6CE8\u518C",
        email: "\u7535\u5B50\u90AE\u7BB1\u5730\u5740",
        password: "\u5BC6\u7801",
        forgetPassword: "\u5FD8\u8BB0\u5BC6\u7801\uFF1F",
        emailError: "\u7535\u5B50\u90AE\u7BB1\u683C\u5F0F\u4E0D\u6B63\u786E",
        passwordTip: "\u5BC6\u7801\u5FC5\u987B\u572810\u523050\u4E2A\u5B57\u7B26\u4E4B\u95F4\uFF0C\u4E14\u81F3\u5C11\u5305\u542B\u4E00\u4E2A\u534A\u89D2\u82F1\u6587\u5B57\u6BCD\u548C\u4E00\u4E2A\u6570\u5B57\u5B57\u7B26\u3002",
        emailNone: "\u8BE5\u7535\u5B50\u90AE\u7BB1\u5730\u5740\u672A\u6CE8\u518C",
        accountError: "\u7528\u6237\u540D\u6216\u5BC6\u7801\u4E0D\u6B63\u786E\u3002",
        resetPasswordSent: "\u5DF2\u53D1\u9001\u7535\u5B50\u90AE\u4EF6\u91CD\u7F6E\u60A8\u7684\u5BC6\u7801\u3002",
        verifiSent: "\u9A8C\u8BC1\u7801\u5DF2\u53D1\u9001\u5230\u60A8\u7684\u7535\u5B50\u90AE\u7BB1",
        passwordConfirm: "\u786E\u8BA4\u5BC6\u7801",
        send: "\u53D1\u9001",
        sent: "\u5DF2\u53D1\u9001\u9A8C\u8BC1\u7801",
        verify: "\u9A8C\u8BC1\u7801",
        inputVerify: "\u8F93\u5165\u60A8\u7535\u5B50\u90AE\u4EF6\u4E2D\u6536\u5230\u7684 6 \u4F4D\u9A8C\u8BC1\u7801",
        resetPassword: "\u91CD\u7F6E\u5BC6\u7801",
        noEmpty: "\u4E0D\u5141\u8BB8\u51FA\u73B0\u7A7A\u5143\u7D20\n\uFF08\u6CE8\uFF1A\u5FC5\u586B\u9879\u6CA1\u586B\u70B9\u63D0\u4EA4\uFF0C\u51FA\u73B0\u4E86\u8BE5\u63D0\u793A\uFF09",
        verifyFormat: "\u9A8C\u8BC1\u7801\u5FC5\u987B\u4E3A 6 \u4F4D\u6570",
        verifyNumber: "\u9A8C\u8BC1\u7801\u4E3A6\u4F4D\u6570\u7EAF\u6570\u5B57",
        checkPassword: "\u8BF7\u68C0\u67E5\u60A8\u7684\u5BC6\u7801",
        resetPasswordSuccess: "\u5BC6\u7801\u5DF2\u91CD\u7F6E\u6210\u529F",
        existUser: "\u8BE5\u7528\u6237\u5DF2\u5B58\u5728",
        loginSuccess: "\u5DF2\u6210\u529F\u767B\u5F55",
        registerSuccess: "\u5DF2\u6210\u529F\u6CE8\u518C",
        logout: "\u767B\u51FA",
        terms: "\u6211\u540C\u610F <link>Scanat \u4F7F\u7528\u6761\u6B3E</link>",
        termsError: "\u8BF7\u9605\u8BFB\u5E76\u52FE\u9009\u4F7F\u7528\u6761\u6B3E\u540E\uFF0C\u518D\u63D0\u4EA4\u6CE8\u518C",
        alert: {
            title: "\u63D0\u793A",
            info: "\u6211\u4EEC\u5DF2\u7ECF\u5411\u60A8\u53D1\u9001\u4E86\u4E00\u5C01\u7535\u5B50\u90AE\u4EF6\uFF0C\u5176\u4E2D\u5305\u542B\u7528\u4E8E\u5B8C\u6210\u91CD\u7F6E\u5BC6\u7801\u7684\u94FE\u63A5"
        },
        invalid: {
            info: "\u8BE5\u91CD\u7F6E\u5BC6\u7801\u94FE\u63A5\u5DF2\u5931\u6548",
            tip: "\u8BF7\u91CD\u65B0\u83B7\u53D6\u91CD\u7F6E\u5BC6\u7801\u94FE\u63A5"
        },
        noExist: {
            info: "\u94FE\u63A5\u4E0D\u5B58\u5728",
            tip: "\u8BF7\u68C0\u67E5\u94FE\u63A5\u662F\u5426\u6B63\u786E"
        },
        go: "\u524D\u5F80",
        forgetPasswordToast: "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF71\u5206\u949F\u540E\u518D\u8BD5",
        introduction: "\u6570\u5B57\u5316\u7A7A\u95F4\uFF0C\u521B\u9020\u672A\u6765",
        verifyText: "\u9A8C\u8BC1\u7801"
    },
    error: {
        connectionOut: "\u8FDE\u63A5\u8D85\u65F6\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC\u8FDE\u63A5\u6216\u7A0D\u540E\u518D\u8BD5\u3002",
        server: "\u670D\u52A1\u5668\u8FC7\u8F7D\u6B63\u5728\u7EF4\u62A4\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002",
        connectionCheck: "\u8BF7\u68C0\u67E5\u7F51\u7EDC\u8FDE\u63A5",
        contactManage: "\u6CA1\u6709\u8BBF\u95EE\u6743\u9650\uFF0C\u8BF7\u8054\u7CFB\u60A8\u7684\u7BA1\u7406\u5458",
        noPlan: "\u6682\u672A\u8D2D\u4E70\u5957\u9910\uFF0C\u65E0\u6CD5\u4F7F\u7528\u8BE5\u670D\u52A1\u3002",
        overDate: "\u60A8\u4F01\u4E1A\u7684\u5957\u9910{plan}\u5DF2\u4E8E{date}\u8FC7\u671F\uFF0C\u65E0\u6CD5\u4F7F\u7528\u8BE5\u670D\u52A1\u3002",
        unactive: "\u60A8\u4F01\u4E1A\u7684\u5957\u9910{plan}\u5C06\u4E8E{date}\u751F\u6548\uFF0C\u8BF7\u5728\u5957\u9910\u751F\u6548\u540E\u8BBF\u95EE\u3002",
        needLevelUp: "\u60A8\u7684\u4F01\u4E1A\u6682\u672A\u8D2D\u4E70\u8BE5\u670D\u52A1",
        noService: "\u60A8\u7684\u4F01\u4E1A\u6682\u672A\u8D2D\u4E70\u8BE5\u670D\u52A1\uFF0C\u65E0\u6CD5\u8BBF\u95EE",
        emptyName: "\u59D3\u6216\u540D\u4E0D\u80FD\u4E3A\u7A7A",
        unsaveEdit: "\u8BF7\u5148\u4FDD\u5B58\u7F16\u8F91\u7684\u5185\u5BB9",
        overSeat: "\u5E2D\u4F4D\u6570\u5DF2\u8FBE\u4E0A\u9650\uFF0C\u65E0\u6CD5\u6DFB\u52A0\u6210\u5458\u3002\u8BF7\u5148\u79FB\u9664\u90E8\u5206\u6210\u5458\uFF0C\u6216\u8FDB\u884C\u5E2D\u4F4D\u6269\u5BB9",
        noSelectMember: "\u8BF7\u5148\u5728\u4E0B\u65B9\u52FE\u9009\u9700\u8981\u79FB\u9664\u7684\u6210\u5458",
        bestPlan: "\u5F53\u524D\u5957\u9910\u4E3A\u6700\u9AD8\u7248\u672C\uFF0C\u65E0\u6CD5\u5347\u7EA7",
        noPermission: "\u6682\u65E0\u6743\u9650",
        comInfoAction: "\u5B8C\u5584\u4F01\u4E1A\u4FE1\u606F",
        comInfoModal: "\u60A8\u597D\uFF0C\u60A8\u7684\u4F01\u4E1A\u4FE1\u606F\u5C1A\u672A\u5B8C\u5584\uFF0C\u8BF7\u586B\u5199\u4F01\u4E1A\u4FE1\u606F",
        comInfoBuy: "\u8BF7\u5148\u5B8C\u5584\u4F01\u4E1A\u4FE1\u606F\uFF0C\u518D\u8FDB\u884C\u8D2D\u4E70\u3002",
        comInfoHome: "\u6E29\u99A8\u63D0\u793A\uFF1A\u4F01\u4E1A\u4FE1\u606F\u672A\u5B8C\u5584\uFF0C\u5C06\u5F71\u54CD\u529F\u80FD\u4F7F\u7528",
        usedAccount: "\u8BE5\u8D26\u53F7\u5DF2\u5C5E\u4E8E\u5176\u4ED6\u4F1A\u793E\uFF0C\u65E0\u6CD5\u6DFB\u52A0\uFF0C\u8BF7\u91CD\u65B0\u586B\u5199",
        wrongEmail: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u90AE\u7F16",
        unsavePage: "\u8BF7\u5148\u4FDD\u5B58\u5F53\u524D\u9875\u9762\u7684\u5185\u5BB9",
        repetitiveMail: "\u8868\u683C\u4E2D\u5B58\u5728\u91CD\u590D\u7684\u90AE\u7BB1\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u65B0\u4E0A\u4F20",
        otherMember: "\u90AE\u7BB1{email}\u4E3A\u5DF2\u6709\u8D26\u53F7\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u65B0\u4E0A\u4F20",
        wrongFormat: "\u90AE\u7BB1{email}\u683C\u5F0F\u6709\u8BEF\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u65B0\u4E0A\u4F20",
        creditExpired: "\u60A8\u7684\u4FE1\u7528\u5361\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u68C0\u67E5\u6709\u6548\u671F\u6216\u66F4\u6362\u5361\u7247",
        agreement: "\u8BF7\u52FE\u9009\u540C\u610F\u300A\u8D2D\u4E70\u534F\u8BAE\u300B",
        payFailed: "\u652F\u4ED8\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u4FE1\u7528\u5361\u662F\u5426\u53EF\u6B63\u5E38\u4F7F\u7528",
        noAccess: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8BBF\u95EE",
        emailEmpty: "\u7B2C{n}\u884C\u90AE\u7BB1\u672A\u586B\u5199\uFF0C\u8BF7\u586B\u5199\u540E\u91CD\u65B0\u4E0A\u4F20",
        nameExceed: "\u7B2C{n}\u884C\u7684\u59D3\u6216\u540D\u4E0D\u80FD\u8D85\u8FC710\u4E2A\u5B57\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u65B0\u4E0A\u4F20",
        overSeatActivation: "\u5E2D\u4F4D\u6570\u5DF2\u8FBE\u4E0A\u9650\uFF0C\u65E0\u6CD5\u6FC0\u6D3B\u6210\u5458\u3002\u8BF7\u5148\u79FB\u9664\u90E8\u5206\u6210\u5458\uFF0C\u6216\u8FDB\u884C\u5E2D\u4F4D\u6269\u5BB9",
        importExceed: "\u5BFC\u5165\u6210\u5458\u6570\u91CF\u4E0D\u80FD\u5927\u4E8E100\uFF0C\u8BF7\u5728\u8868\u683C\u4E2D\u5220\u9664\u90E8\u5206\u6210\u5458\u540E\u91CD\u65B0\u4E0A\u4F20",
        existCompany: "\u8BE5\u8D26\u53F7\u5DF2\u5728\u5F53\u524D\u4F1A\u793E\uFF0C\u65E0\u9700\u91CD\u590D\u6DFB\u52A0",
        invalidAccount: "\u8D26\u53F7\u65E0\u6548\uFF0C\u8BF7\u8054\u7CFB\u60A8\u7684\u7BA1\u7406\u5458",
        creditDisable: "\u4FE1\u7528\u5361\u4E0D\u53EF\u7528\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u65B0\u586B\u5199",
        code: {
            '403': "\u60A8\u7684\u8BBF\u95EE\u88AB\u62D2\u7EDD",
            '404': "\u9875\u9762\u4E0D\u5B58\u5728",
            '500': "\u670D\u52A1\u5668\u8FC7\u8F7D\uFF0C\u6B63\u5728\u7EF4\u62A4\u4E2D\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
            '502': "\u670D\u52A1\u5668\u7E41\u5FD9\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5",
            '504': "\u670D\u52A1\u5668\u7E41\u5FD9\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5"
        },
        accountDisable: "\u8D26\u53F7\u5DF2\u88AB\u7981\u7528\uFF0C\u65E0\u6CD5\u8BBF\u95EE",
        noSeat: "\u8D26\u53F7\u672A\u5F00\u901A\u5E2D\u4F4D\uFF0C\u65E0\u6CD5\u4F7F\u7528app",
        noRight: "\u60A8\u7684\u8D26\u53F7\u65E0\u6743\u9650\u8BBF\u95EE\u8BE5\u670D\u52A1\u3002",
        oneDevice: "\u51FA\u4E8E\u5B89\u5168\u8003\u8651\uFF0CScanat Web\u4E0D\u5141\u8BB8\u5728\u591A\u53F0\u8BBE\u5907\u4E0A\u540C\u65F6\u767B\u5F55\u3002\u60A8\u7684\u5E10\u6237\u5DF2\u88AB\u81EA\u52A8\u767B\u51FA\u3002\u8BF7\u91CD\u65B0\u767B\u5F55\u3002",
        overDue: "\u4F1A\u8BDD\u5DF2\u8FC7\u671F\u3002\u8BF7\u91CD\u65B0\u767B\u5F55\u3002",
        checkNetWork: "\u8BF7\u68C0\u67E5\u60A8\u7684\u7F51\u7EDC\u8FDE\u63A5\u3002",
        timeOut: "\u8FDE\u63A5\u8D85\u65F6\u3002\u8BF7\u68C0\u67E5\u60A8\u7684\u7F51\u7EDC\u8FDE\u63A5\u6216\u7A0D\u540E\u91CD\u8BD5\u3002",
        noCompanyInfo: "\u60A8\u7684\u4F01\u4E1A\u4FE1\u606F\u5C1A\u672A\u586B\u5199\u3002\u5728\u201C\u4F01\u4E1A\u4FE1\u606F\u201D\u83DC\u5355\u680F\u4E2D\u5B8C\u6210\u4F01\u4E1A\u4FE1\u606F\u7684\u586B\u5199\u540E\uFF0C\u624D\u53EF\u8D2D\u4E70\u5957\u9910\u3002",
        comInfoDomain: "\u8BF7\u5148\u5B8C\u5584\u4F01\u4E1A\u4FE1\u606F\uFF0C\u518D\u6DFB\u52A0\u57DF\u540D",
        accountNoAccess: "\u8D26\u53F7\u5DF2\u88AB\u7981\u7528\uFF0C\u65E0\u6CD5\u767B\u5F55",
        existName: "\u540D\u79F0\u5DF2\u5B58\u5728\uFF0C\u8BF7\u91CD\u65B0\u586B\u5199",
        nameTooLong: "\u6A21\u578B\u540D\u79F0\u4E0D\u53EF\u8D85\u8FC720\u4E2A\u5B57\u7B26\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u65B0\u4E0A\u4F20",
        noModel: "\u6682\u65E0\u6A21\u578B\u6570\u636E"
    },
    complete: {
        save: "\u4FDD\u5B58\u6210\u529F",
        export: "\u5BFC\u51FA\u6210\u529F",
        setManagement: "\u8BBE\u7F6E\u7BA1\u7406\u5458\u6210\u529F",
        cancelSetManag: "\u53D6\u6D88\u7BA1\u7406\u5458\u6210\u529F",
        card: "\u4FE1\u7528\u5361\u5DF2\u6DFB\u52A0",
        cardUpdate: "\u4FE1\u7528\u5361\u5DF2\u66F4\u65B0",
        cardDeleted: "\u4FE1\u7528\u5361\u5DF2\u5220\u9664",
        importMember: "\u5BFC\u5165\u6210\u529F",
        invoiceDown: "\u4E0B\u8F7D\u53D1\u7968\u6210\u529F",
        diagramDown: "\u4E0B\u8F7D\u56FE\u7EB8\u6210\u529F",
        invoiceSent: "\u8BF7\u6C42\u4E66\u53D1\u9001\u6210\u529F",
        bought: "\u606D\u559C\u4F60\uFF0C\u8D2D\u4E70\u6210\u529F",
        add: "\u6DFB\u52A0\u6210\u529F",
        change: "\u4FEE\u6539\u6210\u529F",
        delete: "\u5DF2\u5220\u9664",
        replace: "\u66F4\u6362\u6210\u529F"
    },
    landing: {
        select: "\u8BF7\u9009\u62E9\u8981\u8BBF\u95EE\u7684\u7CFB\u7EDF",
        idManage: "ID\u7BA1\u7406\u7CFB\u7EDF",
        scanatWeb: 'Scanat Web',
        pwChange: "\u4FEE\u6539\u5BC6\u7801",
        logout: "\u9000\u51FA\u767B\u5F55",
        tipId: "\xb7 \u8D26\u6237\u7BA1\u7406\n  (\u5982\u66F4\u65B0\u72B6\u6001\u3001\u5207\u6362\u7BA1\u7406\u6743\u9650\u7B49\uFF09\n\xb7 \u8D2D\u4E70\u8BA1\u5212\n\xb7 \u4E0B\u8F7D\u53D1\u7968\u548C\u6536\u636E",
        tipScanat: "\xb7 \u5168\u516C\u53F8\u548C\u4E2A\u4EBA\u4E91\u6570\u636E\u7BA1\u7406\uFF08\u5982\u521B\u5EFA\u4E2A\u4EBA\u6587\u4EF6\u5939\uFF09\n\xb7 \u901A\u8FC7 PC \u6D4F\u89C8\u5668\u8FDB\u884C\u6A21\u578B\u64CD\u4F5C\u548C\u6D4B\u91CF\u6570\u636E\u7F16\u8F91\n\xb7 \u4E0E\u5185\u90E8\u7528\u6237\u540C\u65F6\u67E5\u770B\u6A21\u578B\u548C\u7F16\u8F91\u6D4B\u91CF\u6570\u636E",
        alertNoPlan: "Scanat Web \u662F\u4F01\u4E1A\u8BA1\u5212\uFF08B \u8BA1\u5212\u53CA\u4EE5\u4E0A\uFF09\u7684\u53EF\u9009\u529F\u80FD\u3002\u8FD9\u662F\u4E00\u9879\u65B9\u4FBF\u7684\u529F\u80FD\uFF0C\u5141\u8BB8\u5728\u6D4F\u89C8\u5668\u4E2D\u67E5\u770B\u548C\u64CD\u4F5C\u4F7F\u7528\u5E94\u7528\u7A0B\u5E8F\u626B\u63CF\u7684\u6A21\u578B\uFF0C\u5E76\u521B\u5EFA\u6A21\u578B\u94FE\u63A5\u4E0E\u975E Scanat \u7528\u6237\u5171\u4EAB\u3002\n\n\u5982\u9700\u4E86\u89E3\u66F4\u591A\u4FE1\u606F\uFF0C\u8BF7\u4F7F\u7528<link>\u8054\u7CFB\u8868\u683C</link>\u6216\u8054\u7CFB\u60A8\u7684\u9500\u552E\u4EE3\u8868\u3002",
        invalidAccount: "\u60A8\u7684\u8D26\u53F7\u5DF2\u5931\u6548\uFF0C\u65E0\u6CD5\u8BBF\u95EEScanat Web\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458",
        unnamed: "\u672A\u547D\u540D"
    },
    file: {
        allFile: "\u5168\u90E8\u6587\u4EF6",
        sample: "\u6837\u4F8B\u6A21\u578B",
        modelAmount: "\u6A21\u578B\u6570\u91CF",
        newFolder: "\u65B0\u5EFA\u6587\u4EF6\u5939",
        fileName: "\u540D\u79F0",
        owner: "\u6240\u6709\u8005",
        time: "\u4E0A\u4F20\u65F6\u95F4",
        createTime: "\u521B\u5EFA\u65F6\u95F4",
        scanner: "\u62CD\u6444\u8005",
        scanTime: "\u62CD\u6444\u65F6\u95F4",
        editor: "\u6700\u540E\u7F16\u8F91\u8005",
        updateTime: "\u66F4\u65B0\u65F6\u95F4",
        folder: "\u6587\u4EF6\u5939",
        fileAmount: "{n} \u4E2A\u6587\u4EF6",
        createString: "{time} \u521B\u5EFA",
        uploadString: "{time} \u4E0A\u4F20",
        updateString: "{time} \u66F4\u65B0",
        editorString: "{ID} \u4E8E {time} \u66F4\u65B0",
        filter: "\u7B5B\u9009",
        sort: "\u6392\u5E8F",
        restore: "\u6062\u590D\u9ED8\u8BA4",
        all: "\u5168\u90E8",
        filterStatus: "\u6A21\u578B\u72B6\u6001",
        filterCad: "\u5DF2\u7533\u8BF7CAD",
        filterMark: "\u6807\u8BB0\u72B6\u6001",
        filterMarked: "\u5DF2\u6807\u8BB0",
        fiterOwner: "\u6240\u6709\u8005",
        filterSelfOwner: "\u81EA\u5DF1\u6240\u6709",
        filterShared: "\u4ED6\u4EBA\u5206\u4EAB",
        updateNewest: "\u6700\u8FD1\u66F4\u65B0",
        createNewest: "\u6700\u8FD1\u4E0A\u4F20/\u521B\u5EFA",
        searchHint: "\u8F93\u5165\u5173\u952E\u5B57",
        pagePre: "\u4E0A\u4E00\u9875",
        pageNext: "\u4E0B\u4E00\u9875",
        pageFirst: "\u7B2C\u4E00\u9875",
        pageLast: "\u6700\u540E\u4E00\u9875",
        operate: "\u64CD\u4F5C",
        share: "\u5206\u4EAB",
        selectAll: "\u5168\u9009",
        rename: "\u4FEE\u6539\u540D\u79F0",
        moveTo: "\u79FB\u5165\u6587\u4EF6\u5939",
        tipSample: "\u5F53\u524D\u65E0\u4EFB\u4F55\u6A21\u578B\u6570\u636E\uFF0C\u8BF7\u4ECEApp\u7AEF\u4E0A\u4F20\u6A21\u578B\u81F3\u6D4F\u89C8\u5668\uFF0C\u6216\u70B9\u51FB\u4E0B\u65B9\u6309\u94AE\u4F53\u9A8C\u793A\u4F8B\u6A21\u578B\u3002",
        btnSample: "\u4F53\u9A8C\u793A\u4F8B\u6A21\u578B",
        noFile: "\u5F53\u524D\u6587\u4EF6\u5939\u4E2D\u6CA1\u6709\u6587\u4EF6",
        noResult: "\u6CA1\u6709\u7B26\u5408\u60A8\u641C\u7D22\u6761\u4EF6\u7684\u7ED3\u679C\u3002 \u8BF7\u66F4\u6539\u641C\u7D22\u6761\u4EF6\u3002",
        noSearchResult: "\u5EFA\u8BAE\u5C1D\u8BD5\u66F4\u6539\u5173\u952E\u5B57\u3001\u68C0\u67E5\u8F93\u5165\u9519\u8BEF\u6216\u8C03\u6574\u7B5B\u9009\u5668\u3002",
        shareSpace: "\u5171\u4EAB\u7A7A\u95F4",
        teamSpace: "\u56E2\u961F\u7A7A\u95F4",
        editFolder: "\u7F16\u8F91\u6587\u4EF6\u5939",
        folderName: "\u6587\u4EF6\u5939\u540D\u79F0",
        folderNameHint: "\u8BF7\u586B\u5199\u6587\u4EF6\u5939\u540D\u79F0",
        folderDesc: "\u6587\u4EF6\u5939\u7B80\u4ECB",
        folderDescHint: "\u8BF7\u586B\u5199\u7B80\u4ECB",
        folderDescLimit: "\u8BF7\u8F93\u5165100\u5B57\u4EE5\u5185\u7684\u7B80\u4ECB",
        editModel: "\u7F16\u8F91\u6A21\u578B\u540D\u79F0",
        modelName: "\u6A21\u578B\u540D\u79F0",
        modelNameHint: "\u8BF7\u586B\u5199\u6A21\u578B\u540D\u79F0",
        dataSize: "\u6A21\u578B\u5927\u5C0F",
        shareString: "{ID} \u4E8E {time} \u5206\u4EAB",
        id: {
            log: "\u5BA2\u6237\u64CD\u4F5C\u65E5\u5FD7",
            logCompany: "{company}\u64CD\u4F5C\u65E5\u5FD7",
            Invoice: "\u53D1\u7968{\u8BA2\u5355\u53F7}",
            MemberList: "{\u4F1A\u793E\u540D}\u6210\u5458\u5217\u8868{YYYYMMDD}",
            PlanOrderList: "\u5957\u9910\u8BA2\u5355\u5217\u8868{YYYYMMDD}",
            CADOrderList: "CAD\u8BA2\u5355\u5217\u8868{YYYYMMDD}",
            CustomerInformationList: "\u5BA2\u6237\u4FE1\u606F\u5217\u8868{YYYYMMDD}",
            AccountList: "\u8D26\u53F7\u5217\u8868{YYYYMMDD}",
            UserBatchImportTemplate: "\u6279\u91CF\u5BFC\u5165\u6210\u5458\u6A21\u677F",
            transactionFiles: "\u51ED\u8BC1\u6587\u4EF6{number}",
            memberList: "\u6210\u5458\u5217\u8868{YYYYMMDD}",
            planOrderList: "\u5957\u9910\u8BA2\u5355\u5217\u8868{YYYYMMDD}",
            cadOrderList: "CAD\u8BA2\u5355\u5217\u8868{YYYYMMDD}",
            customerInformationList: "\u5BA2\u6237\u4FE1\u606F\u5217\u8868{YYYYMMDD}",
            companyMemberList: "{company}\u6210\u5458\u5217\u8868{YYYYMMDD}",
            accountList: "\u8D26\u53F7\u5217\u8868{YYYYMMDD}",
            userBatchImportTemplate: "\u6279\u91CF\u5BFC\u5165\u6210\u5458\u6A21\u677F",
            invoice: "\u8BF7\u6C42\u4E66{number}"
        },
        noResultTitle: "\u672A\u627E\u5230\u7ED3\u679C",
        code: {
            get: "\u83B7\u53D6\u5D4C\u5165\u4EE3\u7801",
            mode: "\u52A0\u8F7D\u65B9\u5F0F",
            manual: "\u624B\u52A8\u52A0\u8F7D",
            auto: "\u81EA\u52A8\u52A0\u8F7D",
            copy: "\u590D\u5236\u5D4C\u5165\u4EE3\u7801",
            language: "\u663E\u793A\u8BED\u8A00",
            copySuccess: "\u4EE3\u7801\u5DF2\u590D\u5236"
        },
        delete: {
            title: "\u786E\u5B9A\u8981\u5220\u9664\u6B64\u6A21\u578B\u5417\uFF1F",
            prompt: "\u5220\u9664\u540E\uFF0C\u62E5\u6709\u6A21\u578B\u6743\u9650\u7684\u6210\u5458\u5C06\u65E0\u6CD5\u518D\u8BBF\u95EE\u8FD9\u4E9B\u6A21\u578B\u3002",
            noAuth: "\u90E8\u5206\u6587\u4EF6\u65E0\u5220\u9664\u6743\u9650\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9"
        },
        deleteFolder: {
            title: "\u786E\u5B9A\u8981\u5220\u9664\u6B64\u6587\u4EF6\u5939\u5417\uFF1F",
            prompt: "\u5220\u9664\u540E\uFF0C\u60A8\u548C\u5176\u4ED6\u6210\u5458\u5C06\u65E0\u6CD5\u8BBF\u95EE\u6240\u9009\u6587\u4EF6\u5939\u5185\u7684\u6A21\u578B\u3002"
        },
        mark: {
            cancledToast: "\u672A\u6807\u8BB0",
            markedToast: "\u5DF2\u6807\u8BB0"
        },
        copy: "\u590D\u5236",
        import: {
            button: "\u5BFC\u5165\u6A21\u578B",
            title: "\u5BFC\u5165\u6A21\u578B",
            tip1: "\u9009\u62E9\u6216\u62D6\u62FD\u5355\u4E2A3D\u6587\u4EF6\u5BFC\u5165",
            tip2: "\u652F\u6301\u683C\u5F0F",
            tip3: "\u6700\u5927\u652F\u6301500M\u3002\u5982\u679C\u60A8\u7684\u6587\u4EF6\u5305\u542B\u7D20\u6750\u56FE\u7247\uFF0C\u8BF7\u538B\u7F29\u4E3Azip\u518D\u5BFC\u5165",
            select: "\u9009\u62E9\u6587\u4EF6",
            reSelect: "\u91CD\u65B0\u9009\u62E9\u6587\u4EF6",
            release: "\u91CA\u653E\u9F20\u6807\uFF0C\u6DFB\u52A0\u6587\u4EF6",
            refresh: "\u6587\u4EF6\u6B63\u5728\u5BFC\u5165\u4E2D\uFF0C\u8BF7\u52FF\u5237\u65B0\u6216\u5173\u95ED\u9875\u9762\uFF0C\u5426\u5219\u5BFC\u5165\u5C06\u5931\u8D25",
            fail: "\u5BFC\u5165\u5931\u8D25\uFF01\u8BF7\u91CD\u65B0\u5BFC\u5165\u6A21\u578B",
            prompt: "\u6587\u4EF6\u6B63\u5728\u5BFC\u5165\u4E2D\uFF0C\u5237\u65B0\u540E\u5BFC\u5165\u5C06\u5931\u8D25\uFF0C\u786E\u8BA4\u5237\u65B0\u5417\uFF1F",
            error: {
                checkNet: "\u5BFC\u5165\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC\u540E\u91CD\u8BD5",
                parsingFailed: "\u6A21\u578B\u89E3\u6790\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u65B0\u5BFC\u5165",
                system: "\u7CFB\u7EDF\u5904\u7406\u5F02\u5E38\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
                invalidFile: "\u672A\u5728\u538B\u7F29\u5305\u4E2D\u8BC6\u522B\u5230\u6709\u6548\u7684\u6A21\u578B\u6587\u4EF6\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u65B0\u5BFC\u5165"
            }
        },
        itemsPerPage: "\u6BCF\u9875\u6570\u91CF",
        mySpace: "\u4E2A\u4EBA\u7A7A\u95F4",
        folderEmptyDesc: "\u6682\u672A\u586B\u5199\u7B80\u4ECB",
        sortBy: {
            updateTimeDescending: "\u66F4\u65B0\u65F6\u95F4\uFF08\u8FD1\u2192\u8FDC\uFF09",
            updateTimeAscending: "\u66F4\u65B0\u65F6\u95F4\uFF08\u8FDC\u2192\u8FD1\uFF09",
            createTimeDescending: "\u4E0A\u4F20/\u521B\u5EFA\u65F6\u95F4\uFF08\u8FD1\u2192\u8FDC\uFF09",
            createTimeAscending: "\u4E0A\u4F20/\u521B\u5EFA\u65F6\u95F4\uFF08\u8FDC\u2192\u8FD1\uFF09",
            firstletterDescending: "\u540D\u79F0\u9996\u5B57\u6BCD\uFF08A\u2192Z\uFF09",
            sizeDesc: "\u6A21\u578B\u5927\u5C0F\uFF08\u5927->\u5C0F\uFF09",
            sizeAsc: "\u6A21\u578B\u5927\u5C0F\uFF08\u5C0F->\u5927\uFF09"
        },
        creator: "\u4E0A\u4F20/\u521B\u5EFA\u8005",
        createOrUploadTime: "\u4E0A\u4F20/\u521B\u5EFA\u65F6\u95F4",
        noFound: {
            text: "\u672A\u627E\u5230\u540D\u79F0\u542B\u6709{0}\u7684\u6587\u4EF6\u5939\uFF0C\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u5173\u952E\u8BCD"
        },
        move: {
            noAuth: "\u90E8\u5206\u6587\u4EF6\u65E0\u79FB\u52A8\u6743\u9650\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9"
        },
        modelNum: "{n}\u4E2A\u6A21\u578B"
    },
    filemodal: {
        deletAll: "\u786E\u8BA4\u5220\u9664\u5417\uFF1F",
        selectMove: "\u9009\u62E9\u79FB\u52A8\u4F4D\u7F6E",
        move: "\u79FB\u52A8\u5230\u6B64",
        noData: "\u5F53\u524D\u65E0\u6570\u636E",
        share: "\u5206\u4EAB\u6A21\u578B\u94FE\u63A5",
        copyLink: "\u590D\u5236\u94FE\u63A5",
        copySuccess: "\u94FE\u63A5\u590D\u5236\u6210\u529F\uFF01",
        shareTip: "1. \u62E5\u6709Scanat Web\u6743\u9650\u7684\u7528\u6237\uFF1A\u53EF\u4EE5\u67E5\u770B\u548C\u7F16\u8F91\u6A21\u578B\u3002\u6240\u505A\u7684\u66F4\u6539\u5C06\u5B9E\u65F6\u540C\u6B65\u5230\u539F\u59CB\u5171\u4EAB\u6A21\u578B\u4E2D\u3002\\n\n2. \u6CA1\u6709Scanat Web\u6743\u9650\u7684\u7528\u6237\uFF1A\u53EF\u4EE5\u67E5\u770B\u548C\u7F16\u8F91\u6A21\u578B\uFF0C\u4F46\u6240\u505A\u7684\u66F4\u6539\u4E0D\u4F1A\u5E94\u7528\u6216\u4FDD\u5B58\u5230\u539F\u59CB\u7684\u5171\u4EAB\u6A21\u578B\u4E2D\u3002",
        moveSuccess: "\u79FB\u52A8\u6210\u529F\uFF01",
        folderSuccess: "\u6587\u4EF6\u5939\u521B\u5EFA\u6210\u529F\uFF01",
        changeSuccess: "\u5DF2\u53D8\u66F4",
        noSpecialSymbol: "\u4E0D\u5141\u8BB8\u4F7F\u7528\u7279\u6B8A\u7B26\u53F7",
        deleteComfirm: "\u786E\u8BA4\u5220\u9664\u5417\uFF1F\u5220\u9664\u540E\u5C06\u65E0\u6CD5\u6062\u590D",
        cannotEdit: "\u8BE5\u6587\u4EF6\u5DF2\u88AB\u5220\u9664\uFF0C\u65E0\u6CD5\u7F16\u8F91",
        resetLink: "\u786E\u5B9A\u91CD\u7F6E\u94FE\u63A5\u5417\uFF1F\u91CD\u7F6E\u540E\uFF0C\u4E4B\u524D\u7684\u94FE\u63A5\u5C06\u65E0\u6CD5\u8BBF\u95EE\u3002",
        moveFileTitle: "\u79FB\u52A8\u6587\u4EF6",
        moveFileDesc: "\u79FB\u52A8\u540E\uFF0C\u6240\u9009\u6587\u4EF6\u5C06\u7EE7\u627F\u76EE\u6807\u6587\u4EF6\u5939\u7684\u534F\u4F5C\u8005\u4E0E\u6743\u9650\u8BBE\u7F6E\uFF0C\u539F\u534F\u4F5C\u8005\u53EF\u80FD\u65E0\u6CD5\u8BBF\u95EE\u3002",
        moveFolderTitle: "\u79FB\u52A8\u6587\u4EF6\u5939",
        moveFolderDesc: "\u79FB\u52A8\u540E\uFF0C\u5F53\u524D\u6587\u4EF6\u5939\u5C06\u7EE7\u627F\u76EE\u6807\u6587\u4EF6\u5939\u7684\u534F\u4F5C\u8005\u4E0E\u6743\u9650\u8BBE\u7F6E\uFF0C\u539F\u534F\u4F5C\u8005\u53EF\u80FD\u65E0\u6CD5\u8BBF\u95EE\u3002",
        moveModelTitle: "\u79FB\u52A8\u6A21\u578B",
        moveModelDesc: "\u79FB\u52A8\u540E\uFF0C\u5F53\u524D\u6A21\u578B\u5C06\u7EE7\u627F\u76EE\u6807\u6587\u4EF6\u5939\u7684\u534F\u4F5C\u8005\u4E0E\u6743\u9650\u8BBE\u7F6E\uFF0C\u539F\u534F\u4F5C\u8005\u53EF\u80FD\u65E0\u6CD5\u8BBF\u95EE\u3002",
        sharePromptOld: "1.\u62E5\u6709ScanatWeb\u6743\u9650\u7684\u7528\u6237\uFF1A\u53EF\u540C\u65F6\u67E5\u770B\u548C\u7F16\u8F91\u6A21\u578B\u3002\n2.\u6CA1\u6709ScanatWeb\u6743\u9650\u7684\u7528\u6237\uFF1A\u53EF\u4EE5\u67E5\u770B\u6A21\u578B\uFF0C\u4F46\u65E0\u6CD5\u540C\u65F6\u8FDB\u884C\u7F16\u8F91\u3002",
        cannotAccess: "\u8BE5\u6587\u4EF6\u5DF2\u88AB\u5220\u9664\uFF0C\u65E0\u6CD5\u8BBF\u95EE"
    },
    language: {
        ja: "\u65E5\u672C\u8A9E",
        en: 'English',
        cn: "\u7B80\u4F53\u4E2D\u6587"
    },
    profile: {
        basic: "\u57FA\u672C\u4FE1\u606F",
        account: "\u8D26\u53F7",
        name: "\u59D3\u540D",
        company: "\u6240\u5C5E\u4F1A\u793E",
        superManage: "\u8D85\u7EA7\u7BA1\u7406\u5458",
        manage: "\u7BA1\u7406\u5458",
        member: "\u666E\u901A\u6210\u5458",
        deregisterAccount: "\u6CE8\u9500\u8D26\u53F7",
        deregisterTip: "1. \u60A8\u7684\u5168\u90E8\u4E2A\u4EBA\u4FE1\u606F\u4E0E\u5386\u53F2\u4FE1\u606F\u5C06\u65E0\u6CD5\u627E\u56DE\u3002\\n\n2. \u60A8\u7684\u6240\u6709\u6A21\u578B\u8BB0\u5F55\u3001\u4EA4\u6613\u8BB0\u5F55\u7B49\u5C06\u88AB\u5168\u90E8\u5220\u9664\u4E14\u65E0\u6CD5\u6062\u590D\u3002\\n\n3. \u82E5\u60A8\u662F\u8D85\u7EA7\u7BA1\u7406\u5458\uFF0C\u4E14\u56E2\u961F\u4E2D\u4ECD\u6709\u8D26\u6237\u672A\u79FB\u9664\uFF0C\u5219\u65E0\u6CD5\u6CE8\u9500\u3002",
        deregisterWarningCo: "\u6CE8\u9500\u540E\u5C06\u5220\u9664\u4F01\u4E1A\u7684\u6240\u6709\u6A21\u578B\u8BB0\u5F55\u4E14\u65E0\u6CD5\u627E\u56DE\uFF0C",
        deregisterWarningUser: "\u6CE8\u9500\u540E\u5C06\u5220\u9664\u60A8\u7684\u6240\u6709\u6A21\u578B\u8BB0\u5F55\u4E14\u65E0\u6CD5\u627E\u56DE\uFF0C",
        deregisterConfirm: "\u786E\u5B9A\u6CE8\u9500\u5417\uFF1F",
        deregisterfail1: "\u60A8\u597D\uFF0C\u60A8\u7684\u56E2\u961F\u4E2D\u4ECD\u6709",
        deregisterfail2: "\u8D26\u53F7",
        deregisterfail3: "\u5728\u4F7F\u7528\uFF0C\u8BF7\u81F3\u56E2\u961F\u7BA1\u7406\u9875\u9762\uFF0C\u5C06\u6210\u5458\u79FB\u9664\u540E\u518D\u6CE8\u9500\u3002",
        deregisterComplete: "\u60A8\u5DF2\u5B8C\u6210\u6CE8\u9500",
        continue: "\u7EE7\u7EED\u6CE8\u9500",
        manageAccount: "\u53BB\u7BA1\u7406\u8D26\u53F7"
    },
    company: {
        setting: "\u516C\u53F8\u4FE1\u606F",
        basic: "\u57FA\u672C\u4FE1\u606F",
        expand: "\u6269\u5C55\u4FE1\u606F",
        name: "\u516C\u53F8\u540D\u79F0",
        nameInput: "\u8BF7\u586B\u5199\u516C\u53F8\u540D\u79F0",
        owner: "\u516C\u53F8\u8D1F\u8D23\u4EBA",
        ownerLastname: "\u59D3",
        ownerName: "\u540D",
        ownerSexual: "\u8BF7\u9009\u62E9\u6027\u522B",
        ownerMale: "\u7537",
        ownerFemale: "\u5973",
        numberInput: "\u8BF7\u586B\u5199\u7535\u8BDD\u53F7\u7801",
        zipcode: "\u90AE\u7F16",
        zipcodeInput: "\u8BF7\u586B\u5199\u90AE\u7F16",
        address: "\u5730\u5740",
        addressProvince: "\u5DDE/\u7701",
        addressCity: "\u5E02/\u9547/\u6751",
        addressDistrict: "\u5730\u533A\u540D\u79F0",
        addressDetails: "\u8BE6\u7EC6\u5730\u5740",
        industry: "\u884C\u4E1A\u5206\u7C7B",
        industrySelect: "\u8BF7\u9009\u62E9\u884C\u4E1A\u5206\u7C7B",
        industryArchi: "\u5EFA\u7B51\u4E1A",
        industryManu: "\u5236\u9020\u4E1A",
        industryEstate: "\u623F\u5730\u4EA7\xb7\u5546\u54C1\u79DF\u8D41",
        industryTel: "\u4FE1\u606F\u548C\u901A\u4FE1\u4E1A",
        industryElectric: "\u4F9B\u7535\xb7\u4F9B\u6C14\xb7\u4F9B\u70ED\u548C\u4F9B\u6C34",
        industryTrans: "\u4EA4\u901A\u8FD0\u8F93 \xb7 \u90AE\u653F\u670D\u52A1",
        industryInfo: "\u4FE1\u606F\u5904\u7406\u670D\u52A1",
        industryStudy: "\u5B66\u672F\u3001\u7814\u7A76\u3001\u4E13\u4E1A\u548C\u6280\u672F\u670D\u52A1",
        industryRetail: "\u6279\u53D1\u548C\u96F6\u552E\u4E1A",
        industryResearch: "\u7814\u7A76\u884C\u4E1A",
        scale: "\u5458\u5DE5\u89C4\u6A21",
        scaleSmall: '0-50',
        scaleMedium: '50-100',
        scaleLarge: "100\u4EBA\u4EE5\u4E0A",
        scaleSelect: "\u8BF7\u9009\u62E9\u5458\u5DE5\u89C4\u6A21",
        capital: "\u6CE8\u518C\u8D44\u672C",
        capitalInput: "\u8BF7\u586B\u5199\u6CE8\u518C\u8D44\u672C",
        capitalUnit: "\u65E5\u5143",
        service: "\u4E3B\u8425\u4E1A\u52A1",
        serviceInput: "\u8BF7\u586B\u5199\u4E3B\u8425\u4E1A\u52A1",
        domain: "\u57DF\u540D",
        domainDesc: "*ScanatWeb\u5141\u8BB8\u60A8\u5C06\u6A21\u578B\u8BE6\u60C5\u9875\u9762\u5D4C\u5165\u81F3\u7B2C\u4E09\u65B9\u5E73\u53F0\u3002\u60A8\u53EF\u4EE5\u5728\u6B64\u6DFB\u52A0\u7B2C\u4E09\u65B9\u5E73\u53F0\u7684\u57DF\u540D\uFF0C\u6A21\u578B\u5D4C\u5165\u4EE3\u7801\u5C06\u53EA\u5728\u60A8\u8BBE\u7F6E\u7684\u57DF\u540D\u4E0A\u751F\u6548\u3002\u60A8\u6700\u591A\u53EF\u6DFB\u52A010\u4E2A\u57DF\u540D\u3002",
        inputDomain: "\u8BF7\u8F93\u5165\u57DF\u540D",
        domainError: "\u8BF7\u8F93\u5165\u6709\u6548\u57DF\u540D",
        domainManage: "\u57DF\u540D\u7BA1\u7406",
        domainList: "\u57DF\u540D\u5217\u8868",
        addDomain: "\u65B0\u589E\u57DF\u540D",
        editDomain: "\u7F16\u8F91\u57DF\u540D",
        deleteDomain: "\u5220\u9664\u57DF\u540D",
        deleteDomainTip: "\u786E\u8BA4\u5220\u9664\u57DF\u540D\u5417\uFF1F\u5220\u9664\u540E\u6A21\u578B\u5D4C\u5165\u4EE3\u7801\u5C06\u65E0\u6CD5\u5728\u8BE5\u57DF\u540D\u8BBF\u95EE\u3002",
        inputCorrectPhone: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u7535\u8BDD\u53F7\u7801",
        inputNumber: "\u8BF7\u8F93\u5165\u6570\u5B57",
        domainIframeError: "\u6B64\u57DF\u540D\u672A\u88AB\u6388\u6743\uFF0C\u65E0\u6CD5\u5C55\u793A",
        ownerNameTitle: "\u59D3\u540D",
        ownerGenderTitle: "\u6027\u522B",
        ownerPhoneTitle: "\u7535\u8BDD",
        DomainExsit: "\u57DF\u540D\u5DF2\u5B58\u5728\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165"
    },
    card: {
        manage: "\u4FE1\u7528\u5361\u7BA1\u7406",
        number: "\u5361\u53F7",
        dueDate: "\u5230\u671F\u65F6\u95F4",
        status: "\u72B6\u6001",
        owner: "\u6301\u5361\u4EBA",
        statusNormal: "\u6B63\u5E38",
        statusExpired: "\u5DF2\u8FC7\u671F",
        default: "\u9ED8\u8BA4\u4FE1\u7528\u5361",
        setDefault: "\u8BBE\u4E3A\u9ED8\u8BA4",
        create: "\u65B0\u589E\u4FE1\u7528\u5361",
        inputNumber: "\u8BF7\u586B\u5199\u5361\u53F7",
        validity: "\u6709\u6548\u671F\u9650",
        inputMonth: "\u8BF7\u586B\u5199\u6708\u4EFD",
        inputYear: "\u8BF7\u586B\u5199\u4E24\u4F4D\u6570\u5E74\u4EFD",
        securityCode: "\u5B89\u5168\u7801",
        inputSecurityCode: "\u8BF7\u586B\u5199\u5B89\u5168\u7801",
        inputOwner: "\u8BF7\u586B\u5199\u6301\u5361\u4EBA\u59D3\u540D",
        errorNumber: "\u8BF7\u586B\u519916\u4F4D\u6574\u6570",
        errorMonth: "\u8BF7\u586B\u519901\uFF5E12\u6708\u4EFD",
        errorYear: "\u8BF7\u586B\u5199\u6709\u6548\u5E74\u4EFD",
        errorSecurity: "\u8BF7\u586B\u51993\u4F4D\u5B89\u5168\u7801",
        errorOwner: "\u8BF7\u586B\u5199\u6301\u5361\u4EBA",
        errorExpired: "\u60A8\u7684\u4FE1\u7528\u5361\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u68C0\u67E5\u6709\u6548\u671F\u6216\u66F4\u6362\u5361\u7247",
        delete: "\u5220\u9664\u4FE1\u7528\u5361",
        deleteConfirm: "\u786E\u8BA4\u5220\u9664\u5C3E\u53F7{number}\u7684\u4FE1\u7528\u5361\u5417\uFF1F",
        deleteComplete: "\u4FE1\u7528\u5361\u5DF2\u5220\u9664",
        defaultComplete: "\u8BBE\u4E3A\u9ED8\u8BA4\u6210\u529F",
        emptyTitle: "\u5F53\u524D\u672A\u6DFB\u52A0\u4FE1\u7528\u5361\u4FE1\u606F",
        emptyDesc: "\u8BF7\u70B9\u51FB\u4E0B\u65B9\u6DFB\u52A0\u6309\u7EBD\u6DFB\u52A0\u4FE1\u7528\u5361",
        bind: "\u5F53\u524D\u6263\u8D39\u4FE1\u7528\u5361",
        inputMonthYear: "\u6708/\u5E74",
        error: {
            InvalidNumber: "\u60A8\u7684\u5361\u53F7\u65E0\u6548",
            tooShortNumber: "\u60A8\u7684\u94F6\u884C\u5361\u5361\u53F7\u4E0D\u5B8C\u6574\u3002",
            invalidDate: "\u60A8\u94F6\u884C\u5361\u7684\u5230\u671F\u5E74\u4EFD\u65E0\u6548\u3002",
            incompleteDate: "\u60A8\u94F6\u884C\u5361\u7684\u6709\u6548\u671F\u4E0D\u5B8C\u6574\u3002",
            expiredDate: "\u60A8\u94F6\u884C\u5361\u7684\u5230\u671F\u5E74\u4EFD\u662F\u8FC7\u53BB\u7684\u5E74\u4EFD\u3002",
            invalidSecurityCode: "\u60A8\u94F6\u884C\u5361\u7684\u5B89\u5168\u7801\u4E0D\u5B8C\u6574\u3002"
        }
    },
    home: {
        title: "\u9996\u9875",
        modelAmount: "\u603B\u6A21\u578B\u6570\uFF08\u4E2A\uFF09",
        memberAmount: "\u6210\u5458\u6570\uFF08\u4E2A\uFF09",
        orderAmount: "\u4EA7\u751F\u8BA2\u5355\uFF08\u4E2A\uFF09",
        quick: "\u5FEB\u6377\u5165\u53E3",
        completeInfo: "\u5B8C\u5584\u4F01\u4E1A\u4FE1\u606F",
        team: "\u7EC4\u5EFA\u56E2\u961F",
        cowork: "\u6A21\u578B\u534F\u4F5C",
        order: "\u67E5\u770B\u8BA2\u5355",
        read: "\u5165\u95E8\u5FC5\u8BFB",
        back: "\u8FD4\u56DE\u4E3B\u9875"
    },
    plan: {
        a: "Plan A \u4F53\u9A8C\u5957\u9910",
        b: "Plan B \u57FA\u7840\u5957\u9910",
        c: "Plan C \u5546\u52A1\u5957\u9910",
        d: "Plan D - \u4F01\u4E1A\u5957\u9910",
        selectPlan: "\u9009\u62E9\u5957\u9910\u8BA1\u5212",
        id: "ID\u6570",
        app: "\u5E94\u7528\u7248",
        appWeb: "\u5E94\u7528+\u7F51\u9875\u7248",
        price: "{price}\u5186\u8D77",
        none: "\u5F53\u524D\u65E0\u5957\u9910",
        now: "\u5F53\u524D\u5957\u9910",
        statusActive: "\u8BA2\u9605\u4E2D",
        statusUnactive: "\u5F85\u751F\u6548",
        end: "\u5DF2\u7ED3\u675F",
        planDetail: "\u5957\u9910\u8BE6\u60C5",
        idMoreThan: "\u4EBA\u8D77",
        bApp: "Plan B \u57FA\u7840\u5957\u9910\uFF08\u5E94\u7528\u7248\uFF09",
        bAll: "Plan B \u57FA\u7840\u5957\u9910\uFF08\u5E94\u7528\u7248+Web\u7248\uFF09",
        aYearText: "\u4E0E\u6708\u4ED8\u76F8\u6BD4\u4F18\u60E024,000\u65E5\u5143",
        unSelected: "\u672A\u9009\u62E9\u4EFB\u4F55\u5957\u9910"
    },
    order: {
        list: "\u8BA2\u5355\u8BB0\u5F55",
        plan: "\u5957\u9910\u8BA2\u5355",
        cad: "CAD\u8BA2\u5355",
        statusUnpay: "\u672A\u652F\u4ED8",
        trial: "\u53EF\u63D0\u524D\u8BD5\u7528",
        statusPaid: "\u5DF2\u652F\u4ED8",
        statusCancel: "\u5DF2\u53D6\u6D88",
        statusComplete: "\u5DF2\u5B8C\u6210",
        statusProcessing: "\u8FDB\u884C\u4E2D",
        searchHint: "\u8F93\u5165\u8BA2\u5355\u53F7/\u5957\u9910\u540D\u641C\u7D22",
        number: "\u8BA2\u5355\u53F7",
        name: "\u5957\u9910\u540D",
        payMethod: "\u8BA2\u9605\u65B9\u5F0F",
        payMonth: "\u6708\u4ED8",
        payYear: "\u5E74\u4ED8",
        switchPayMethod: "\u5207\u6362\u8BA2\u9605\u65B9\u5F0F",
        switchPay: "\u5207\u6362\u8BA2\u9605\u65B9\u5F0F",
        switchMonthTip: "\u786E\u8BA4\u5C06\u5F53\u524DA\u5957\u9910\u7684\u8BA2\u9605\u65B9\u5F0F\u4FEE\u6539\u4E3A\u3010\u6708\u4ED8\u3011\u5417\uFF1F",
        switchYearTip: "\u786E\u8BA4\u5C06\u5F53\u524DA\u5957\u9910\u7684\u8BA2\u9605\u65B9\u5F0F\u4FEE\u6539\u4E3A\u3010\u5E74\u4ED8\u3011\u5417\uFF1F",
        currentPeriod: "\u5F53\u524D\u5957\u9910\u5468\u671F",
        nextPeriod: "\u4E0B\u4E00\u5957\u9910\u5468\u671F",
        periord: "\u670D\u52A1\u65F6\u95F4",
        selectSeat: "\u9009\u62E9\u5E2D\u4F4D\u6570",
        seat: "\u5E2D\u4F4D\u6570",
        seatAdded: "\u65B0\u589E\u5E2D\u4F4D",
        seatAddSum: "\u65B0\u589E\u5E2D\u4F4D\u6570",
        seatAddTime: "\u5E2D\u4F4D\u52A0\u5165\u65F6\u95F4",
        selectTime: "\u8BF7\u9009\u62E9\u65F6\u95F4",
        seatPeople: "{n}\u4EBA",
        seatUnactive: "{n}\u4E2A\u5E2D\u4F4D\u5F85\u751F\u6548",
        seatTip: "\u6B64\u5904\u60A8\u6240\u9009\u62E9\u7684\u5E2D\u4F4D\u6570\u91CF\u4E3A\u8BE5\u56E2\u961F\u53EF\u7528\u5E2D\u4F4D\u603B\u6570\uFF0C\u5982\u60A8\u9009\u62E9 10\uFF0C \u5219\u56E2\u961F\u53EF\u7528\u5E2D\u4F4D\u603B\u6570\u4E3A10\u3002",
        packageCount: "\u5957\u9910\u6570",
        packageCountTip: "\u9009\u62E9\u8D2D\u4E70\u7684\u5957\u9910\u6570\u91CF",
        additionalIdCount: "\u8FFD\u52A0ID\u6570",
        additionalIdCountTip: "\u5728\u5957\u9910\u57FA\u7840ID\u6570\u4E4B\u5916\u989D\u5916\u8D2D\u4E70\u7684ID\u6570\u91CF",
        totalIdCount: "\u5408\u8BA1{count}\u4E2AID",
        packageBaseIdCount: "\u6240\u9009\u5957\u9910\u5305\u542B{count}\u4E2AID",
        seatOver: "\u6210\u5458\u8D85\u989D\u63D0\u9192",
        seatOverTip: "\u60A8\u597D\uFF0C\u60A8\u5F53\u524D\u56E2\u961F\u6709{n}\u4F4D\u6210\u5458\uFF0C\u8BF7\u786E\u4FDD\u60A8\u7684\u8D2D\u4E70\u5E2D\u4F4D\u6570\u5927\u4E8E{n}\uFF0C\u6216\u81F3\u56E2\u961F\u7BA1\u7406\u9875\u9762\u79FB\u9664\u90E8\u5206\u6210\u5458\u540E\u518D\u6765\u8D2D\u4E70\u3002",
        memberUsed: "\u4F7F\u7528\u4E2D\u7684\u6210\u5458",
        deleteMemble: "\u53BB\u79FB\u9664\u6210\u5458",
        cancelTip: "{date}\u53D6\u6D88",
        expandSeat: "\u5E2D\u4F4D\u6269\u5BB9",
        purchase: "\u8D2D\u4E70\u5957\u9910",
        purchaseNow: "\u7ACB\u5373\u8D2D\u4E70",
        levelUp: "\u5347\u7EA7\u7248\u672C",
        renewal: "\u7EED\u8D39",
        buy: "\u8D2D\u4E70",
        changeTime: "\u4FEE\u6539\u670D\u52A1\u65F6\u95F4",
        olderTime: "\u539F\u670D\u52A1\u65F6\u95F4",
        newTime: "\u65B0\u670D\u52A1\u65F6\u95F4",
        startTime: "\u5F00\u59CB\u65F6\u95F4",
        endTime: "\u7ED3\u675F\u65F6\u95F4",
        updateTime: "\u5347\u7EA7\u65F6\u95F4",
        contactService: "\u8054\u7CFB\u5BA2\u670D",
        changeCard: "\u66F4\u6539\u6263\u8D39\u4FE1\u7528\u5361",
        SelectCard: "\u8BF7\u9009\u62E9\u6263\u8D39\u4FE1\u7528\u5361",
        cancel: "\u7533\u8BF7\u53D6\u6D88\u8BA2\u9605",
        cancelTip1: "\u53D6\u6D88\u8BA2\u9605\u540E\uFF0C\u5957\u9910\u5728{date}\u5230\u671F\u540E\u5C06\u4E0D\u518D\u7EED\u8D39\uFF0C\u5C4A\u65F6\u8BE5\u4F1A\u793E\u4E0B\u6240\u6709\u6210\u5458\u5C06\u65E0\u6CD5\u4F7F\u7528\u7CFB\u7EDF\uFF0C\u786E\u5B9A\u53D6\u6D88\u5417\uFF1F",
        cancelTip2: "\u53D6\u6D88\u8BA2\u9605\u540E\uFF0C\u5C06\u4E0D\u518D\u5C1D\u8BD5\u81EA\u52A8\u6263\u8D39\uFF0C\u8BE5\u4F1A\u793E\u4E0B\u6240\u6709\u6210\u5458\u5C06\u65E0\u6CD5\u4F7F\u7528\u7CFB\u7EDF\uFF0C\u786E\u5B9A\u5417\uFF1F",
        revokeCancellation: "\u64A4\u56DE\u53D6\u6D88\u8BA2\u9605",
        revokeTip: "\u786E\u8BA4\u64A4\u56DE\u53D6\u6D88\u8BA2\u9605\u64CD\u4F5C\u5417\uFF1F\u64A4\u56DE\u540E\u60A8\u53EF\u4EE5\u91CD\u65B0\u53D6\u6D88\u8BA2\u9605",
        noPlan: "\u5F53\u524D\u65E0\u53EF\u7528\u5957\u9910",
        newPlan: "\u53D8\u66F4\u540E\u5957\u9910",
        learn: "\u4E86\u89E3\u5957\u9910",
        learnMore: "\u67E5\u770B\u5957\u9910\u8BE6\u60C5",
        confirmOrder: "\u786E\u8BA4\u8BA2\u5355",
        orderInfo: "\u8BA2\u5355\u4FE1\u606F",
        planStart: "\u5957\u9910\u5F00\u59CB\u65F6\u95F4",
        planStartInstant: "\u4ED8\u6B3E\u5B8C\u6210\u540E\u5373\u53EF\u4F7F\u7528",
        item: "\u5546\u54C1",
        itemName: "\u5546\u54C1\u540D\u79F0",
        modelName: "\u6A21\u578B\u540D\u79F0",
        diagramType: "\u56FE\u7EB8\u7C7B\u578B",
        category: "\u7C7B\u522B",
        totalItem: "\u6570\u91CF",
        unitPriceYen: "\u5355\u4EF7",
        totalSumYen: "\u603B\u91D1\u989D",
        unitPrice: "\u5355\u4EF7",
        totalSum: "\u603B\u91D1\u989D",
        unusedSum: "\u539F\u5957\u9910\u672A\u4F7F\u7528\u91D1\u989D",
        quickSum: "\u5C0F\u8BA1",
        tax: "\u7A0E\u8D39\uFF0810%\uFF09",
        payableSum: "\u5E94\u4ED8\u91D1\u989D",
        payableSumUnit: "\u5E94\u4ED8\u91D1\u989D\uFF08\u65E5\u5143\uFF09",
        submit: "\u63D0\u4EA4\u8BA2\u5355",
        confirmSubmit: "\u786E\u8BA4\u5E76\u63D0\u4EA4\u8BA2\u5355",
        createUser: "\u521B\u5EFA\u4EBA",
        createTime: "\u521B\u5EFA\u65F6\u95F4",
        paidTime: "\u4ED8\u6B3E\u65F6\u95F4",
        giveTime: "\u4EA4\u4ED8\u65F6\u95F4",
        paidStatus: "\u4ED8\u6B3E\u72B6\u6001",
        cadStatus: "CAD\u5236\u4F5C\u72B6\u6001",
        orderSum: "\u8BA2\u5355\u91D1\u989D",
        status: "\u72B6\u6001",
        leftTime: "\u5269\u4F59\u652F\u4ED8\u65F6\u95F4",
        switchTipYear: "\u5C06\u4E8E{date}\u5207\u6362\u4E3A\u5E74\u4ED8",
        switchTipMonth: "\u5C06\u4E8E{date}\u5207\u6362\u4E3A\u6708\u4ED8",
        autoFail: "\u81EA\u52A8\u6263\u8D39\u5931\u8D25",
        cardFailTip: "\u4FE1\u7528\u5361\u6263\u8D39\u5931\u8D25\uFF0C\u660E\u65E5\u5C06\u91CD\u8BD5\uFF0C\u8BF7\u5C3D\u5FEB\u66F4\u6362\u60A8\u7684\u6263\u8D39\u4FE1\u7528\u5361\u3002",
        toSwitch: "\u53BB\u66F4\u6362",
        details: "\u8BA2\u5355\u8BE6\u60C5",
        type: "\u8BA2\u5355\u7C7B\u578B",
        sumTip: "\u603B\u91D1\u989D=\u5957\u9910\u5355\u4EF7*\u65B0\u589E\u5E2D\u4F4D\u6570*\u5269\u4F59\u5929\u6570/{n}\u5929",
        unusedTip: "\u539F\u5957\u9910\u672A\u4F7F\u7528\u91D1\u989D=\u65E7\u5957\u9910\u5355\u4EF7*\u539F\u5E2D\u4F4D\u6570*\u672A\u4F7F\u7528\u5929\u6570/{n}\u5929",
        priceTip: "\u6309\u65F6\u957F\u6298\u7B97\u540E\u5355\u4EF7\uFF0C\u5355\u4EF7=\u5957\u9910\u539F\u5355\u4EF7*\u5269\u4F59\u4F7F\u7528\u5929\u6570/{n}\u5929",
        oldPlan: "\u539F\u5957\u9910",
        unusedTime: "\u672A\u4F7F\u7528\u5929\u6570",
        actionDetail: "\u8BE6\u60C5",
        checkDetail: "\u67E5\u770B\u8BE6\u60C5",
        actionPay: "\u53BB\u652F\u4ED8",
        actionCancel: "\u53D6\u6D88\u8BA2\u5355",
        cancelConfirm: "\u786E\u8BA4\u53D6\u6D88\u8BA2\u5355\u5417\uFF1F",
        actionInvoice: "\u4E0B\u8F7D\u51ED\u8BC1",
        actionDiagram: "\u4E0B\u8F7D\u56FE\u7EB8",
        submitOrder: "\u63D0\u4EA4\u8BA2\u5355",
        payOrder: "\u652F\u4ED8\u8BA2\u5355",
        completeOrder: "\u8BA2\u5355\u5B8C\u6210",
        applican: "\u7533\u8BF7\u4EBA",
        appliTime: "\u7533\u8BF7\u65F6\u95F4",
        checkCancel: "\u67E5\u770B\u53D6\u6D88\u539F\u56E0",
        cancelTime: "\u53D6\u6D88\u65F6\u95F4",
        cancelReason: "\u53D6\u6D88\u539F\u56E0",
        useTip: "\u4ED8\u6B3E\u6210\u529F\u5373\u53EF\u4F7F\u7528",
        unpaidTip: "\u60A8\u6709\u4E00\u7B14\u5957\u9910\u8BA2\u5355\u4ECD\u672A\u652F\u4ED8\uFF0C\u8BF7\u652F\u4ED8\u6216\u54A8\u8BE2\u670D\u52A1\u5546",
        existPlantip: "\u60A8\u5DF2\u8D2D\u4E70\u5957\u9910{plan}\uFF0C\u65E0\u6CD5\u8D2D\u4E70\u65B0\u7684\u5957\u9910\u3002",
        unactivePlantip: "\u60A8\u5DF2\u8D2D\u4E70\u5957\u9910{plan}\uFF0C\u8FD8\u672A\u5230\u751F\u6548\u65F6\u95F4\uFF0C\u5957\u9910\u7684\u751F\u6548\u65F6\u95F4\u4E3A{date}\u3002",
        checkCurrentPlan: "\u67E5\u770B\u5F53\u524D\u5957\u9910",
        leftDay: "\u5929",
        leftHr: "\u5C0F\u65F6",
        leftMin: "\u5206\u949F",
        leftSec: "\u79D2",
        expireTip: "\u8D85\u8FC7\u8BE5\u65F6\u95F4\u672A\u652F\u4ED8\uFF0C\u8BA2\u5355\u5C06\u4F1A\u88AB\u81EA\u52A8\u53D6\u6D88",
        purchaseSuccess: "\u606D\u559C\u4F60\uFF0C\u8D2D\u4E70\u6210\u529F",
        currentSeat: "\u5F53\u524D\u5E2D\u4F4D\u6570",
        seatExpandExceed: "\u5F53\u524D\u5957\u9910\u6700\u591A\u53EF\u8D2D\u4E70{max-seat}\u4E2A\u5E2D\u4F4D\uFF0C\u60A8\u5F53\u524D\u5DF2\u8D2D\u4E70{exist-seat}\u4E2A\u5E2D\u4F4D\uFF0C\u6700\u591A\u53EF\u6269\u5BB9{left-seat}\u4E2A\u5E2D\u4F4D\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u65B0\u63D0\u4EA4\u3002",
        noPlanError: "\u5F53\u524D\u65E0\u8BA2\u9605\u4E2D\u7684\u5957\u9910\uFF0C\u4E0D\u5141\u8BB8\u8FDB\u884C\u6269\u5BB9\u64CD\u4F5C\u3002\u8BF7\u8054\u7CFB\u5BA2\u6237\u7ECF\u7406\u53D6\u6D88\u8BA2\u5355\u540E\u91CD\u65B0\u8D2D\u4E70\u5957\u9910\u3002",
        planType: "\u8BA2\u8D2D\u5957\u9910",
        overTime: "\u5DF2\u8D85\u8FC7\u652F\u4ED8\u671F\u9650",
        itemList: "\u5546\u54C1\u6E05\u5355",
        system: "\u7CFB\u7EDF",
        selectNumber: "\u9009\u62E9\u6570\u91CF",
        numberOfPlan: "\u5957\u9910\u6570",
        numberOfID: "\u8FFD\u52A0ID\u6570",
        numberTip1: "\u5408\u8BA1{detail0}\u4E2AID",
        numberTip2: "\u6240\u9009\u5957\u9910\u5305\u542B{detail0}\u4E2AID",
        card: {
            '3DsTip': "\u4FE1\u7528\u5361\u81EA\u52A8\u6263\u8D39\u9700\u89813Ds\u8BA4\u8BC1\uFF0C\u7CFB\u7EDF\u5DF2\u53D1\u9001\u8BA4\u8BC1\u90AE\u4EF6\uFF0C\u8BF7\u68C0\u67E5\u60A8\u7684\u90AE\u4EF6\u5E76\u5B8C\u6210\u8BA4\u8BC1\u3002"
        },
        complete: "\u5B8C\u6210\u7533\u8BF7"
    },
    cad: {
        statusProcessing: "CAD\u7ED8\u5236\u4E2D",
        statusComplete: "CAD\u7ED8\u5236\u5B8C\u6210",
        submit: "\u63D0\u4EA4\u7533\u8BF7",
        completeTime: "\u7EA62\uFF5E4\u5929",
        create: "CAD\u7ED8\u5236",
        delivery: "\u4EA4\u4ED8\u56FE\u7EB8",
        model: "\u6A21\u578B",
        innerWall: "\u5185\u58C1\u539A\u5EA6",
        outerWall: "\u5916\u58C1\u539A\u5EA6",
        deliveryFormat: "\u56FE\u7EB8\u4EA4\u4ED8\u683C\u5F0F",
        usage: "\u5EFA\u7B51\u7C7B\u578B",
        type: "\u56FE\u7EB8\u7C7B\u578B",
        attachment: "\u73B0\u6709\u56FE\u7EB8",
        application: "CAD\u5236\u56FE\u7533\u8BF7",
        usageResidential: "\u4F4F\u5B85",
        usageOffice: "\u529E\u516C\u5BA4",
        usageShop: "\u5546\u5E97\u548C\u673A\u6784",
        usageOthers: "\u5176\u4ED6",
        fileCad: "CAD\u6587\u4EF6",
        filePdf: "PDF\u6587\u4EF6",
        diagramFloorplan: "\u5E73\u9762\u56FE",
        diagramCeiling: "\u5929\u82B1\u677F\u56FE",
        diagramElevation: "\u7ACB\u9762\u56FE",
        tipProcessing: "\u56FE\u7EB8\u7ED8\u5236\u4E2D\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u2026"
    },
    pay: {
        payment: "\u652F\u4ED8\u65B9\u5F0F",
        detailCard: "\u652F\u4ED8\u8BE6\u60C5-\u4FE1\u7528\u5361",
        detailInvoice: "\u652F\u4ED8\u8BE6\u60C5-\u8BF7\u6C42\u4E66",
        orderPay: "\u8BA2\u5355\u652F\u4ED8",
        selectMethod: "\u9009\u62E9\u652F\u4ED8\u65B9\u5F0F",
        creditcard: "\u4FE1\u7528\u5361",
        invoice: "\u8BF7\u6C42\u4E66",
        invoiceSendTip: "\u8BF7\u6C42\u4E66\u5C06\u4F1A\u53D1\u9001\u81F3\u60A8\u7684\u90AE\u7BB1{mail}\uFF0C\u8BF7\u5C06\u8D44\u91D1\u8F6C\u5165\u4EE5\u4E0B\u8D26\u6237\uFF1A",
        invoiceResendTip: "\u8BF7\u6C42\u4E66\u5DF2\u53D1\u9001\u81F3\u60A8\u7684\u90AE\u7BB1{mail}\uFF0C\u8BF7\u5C06\u8D44\u91D1\u8F6C\u5165\u4EE5\u4E0B\u8D26\u6237\uFF1A",
        bank: "\u94F6\u884C",
        banCode: "\u94F6\u884C\u7F16\u53F7",
        bankName: "\u652F\u884C\u540D\u79F0",
        bankNumber: "\u652F\u884C\u7F16\u53F7",
        accountType: "\u8D26\u6237\u7C7B\u578B",
        accountOwner: "\u8D26\u6237\u6301\u6709\u4EBA",
        accountNumber: "\u8D26\u6237\u53F7\u7801",
        sendInvoice: "\u53D1\u9001\u8BF7\u6C42\u4E66",
        noInvoice: "\u6CA1\u6536\u5230\u8BF7\u6C42\u4E66\uFF1F",
        resendInvoice: "\u518D\u6B21\u53D1\u9001\u8BF7\u6C42\u4E66",
        InvoiceSent: "\u8BF7\u6C42\u4E66\u53D1\u9001\u6210\u529F",
        toPay: "\u524D\u5F80\u652F\u4ED8",
        agreement: "\u540C\u610F\u300A\u8D2D\u4E70\u534F\u8BAE\u300B",
        payLoading: "\u6B63\u5728\u652F\u4ED8\uFF0C\u8BF7\u7A0D\u5019...",
        payJump: "\u652F\u4ED8\u5904\u7406\u4E2D\uFF0C\u5373\u5C06\u8DF3\u8F6C\u81F3\u8BA2\u5355\u9875",
        unlimited: "\u65E0\u9650\u5236",
        alert: "\u8BE5\u8BA2\u5355\u9700\u8981\u60A8\u7EBF\u4E0B\u8F6C\u8D26\uFF0C\u8BF7\u68C0\u67E5\u60A8\u7684\u5386\u53F2\u90AE\u4EF6\u3002\u82E5\u672A\u6536\u5230\u8F6C\u8D26\u4FE1\u606F\u6216\u6709\u5176\u4ED6\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u60A8\u7684\u5BA2\u6237\u7ECF\u7406\u3002"
    },
    team: {
        member: "\u6210\u5458\u7BA1\u7406",
        status: "\u72B6\u6001",
        statusActive: "\u4F7F\u7528\u4E2D",
        statusUnactive: "\u672A\u6FC0\u6D3B",
        addMember: "\u6DFB\u52A0\u6210\u5458",
        deleteMember: "\u79FB\u9664\u6210\u5458",
        deleteMemberTip: "\u79FB\u9664\u6210\u5458\u540E\uFF0C\u8BE5\u6210\u5458\u5C06\u65E0\u6CD5\u8BBF\u95EE\u60A8\u7684\u4F1A\u793E\uFF0C\u8BE5\u6210\u5458\u5DF2\u4E0A\u4F20\u81F3\u4E91\u7AEF\u7684\u6A21\u578B\u5C06\u4E0D\u4F1A\u4E22\u5931\u3002\u786E\u5B9A\u79FB\u9664\u5417\uFF1F",
        addMultiMember: "\u6279\u91CF\u6DFB\u52A0\u6210\u5458",
        memberFormDownload: "\u70B9\u51FB\u4E0B\u8F7D\u300C\u7528\u6237\u6279\u91CF\u5BFC\u5165\u6A21\u7248\u8868\u683C\u300D",
        addMultiMemberTip: "1. \u4E0B\u8F7D\u300C\u7528\u6237\u6279\u91CF\u5BFC\u5165\u6A21\u7248\u8868\u683C\u300D\uFF1B\\n\n2. \u6253\u5F00\u6A21\u677F\uFF0C\u8BF7\u4F7F\u7528\u7EAF\u6587\u672C\u6216\u6570\u5B57\u5C06\u5BF9\u5E94\u5B57\u6BB5\u4FE1\u606F\u8F93\u5165\u6216\u7C98\u8D34\u8FDB\u672C\u8868\uFF1B\\n\n3. \u70B9\u51FB\u300C\u4E0A\u4F20\u8868\u683C\u300D\u6309\u94AE\uFF0C\u9009\u62E9\u521A\u521A\u5B8C\u6210\u7684\u7528\u6237\u4FE1\u606F\u8868\u683C\u5E76\u4E0A\u4F20\u540E\uFF0C\u70B9\u51FB\u53F3\u4E0B\u65B9\u3010\u786E\u8BA4\u5BFC\u5165\u3011\u6309\u94AE\u5373\u53EF\u3002\\n\n\u6CE8\uFF1A\u6700\u591A\u5141\u8BB8\u5BFC\u5165100\u6761\u6570\u636E\uFF0C\u82E5\u8868\u683C\u6570\u636E\u8D85\u8FC7100\u6761\uFF0C\u6240\u6709\u6570\u636E\u5747\u65E0\u6CD5\u88AB\u5BFC\u5165",
        errorNoFile: "\u8BF7\u4E0A\u4F20\u6587\u4EF6",
        usedSeat: "\u5DF2\u7528\u5E2D\u4F4D",
        seat: {
            total: "\u603B\u5E2D\u4F4D",
            noSeat: "\u65E0\u5269\u4F59\u53EF\u7528\u5E2D\u4F4D\uFF0C\u65E0\u6CD5\u64CD\u4F5C",
            manageSeat: "\u5E2D\u4F4D\u5206\u914D",
            onSuccess: "\u5206\u914D\u5E2D\u4F4D\u6210\u529F",
            offSuccess: "\u5173\u95ED\u5E2D\u4F4D\u6210\u529F"
        },
        model: "\u603B\u6A21\u578B\u6570",
        cloudModel: "\u4E91\u7AEF\u6A21\u578B\u6570",
        name: "\u59D3\u540D",
        inputLastname: "\u8BF7\u8F93\u5165\u59D3",
        inputname: "\u8BF7\u8F93\u5165\u540D",
        mail: "\u90AE\u7BB1",
        mailAddress: "\u90AE\u7BB1\u5730\u5740",
        inputEmail: "\u8BF7\u586B\u5199\u90AE\u7BB1\u5730\u5740",
        emptyEmail: "\u8BF7\u586B\u5199\u90AE\u7BB1\uFF01",
        errorEmail: "\u90AE\u7BB1\u683C\u5F0F\u6709\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u540E\u91CD\u65B0\u586B\u5199",
        activeAccount: "\u6FC0\u6D3B\u8D26\u53F7",
        activeAccountTip: "\u8BE5\u6210\u5458\u5C06\u6536\u5230\u6FC0\u6D3B\u90AE\u4EF6\uFF0C\u786E\u8BA4\u6FC0\u6D3B\u5417\uFF1F",
        lastLogin: "\u6700\u8FD1\u767B\u5F55\u65F6\u95F4",
        deleteMultiMember: "\u6279\u91CF\u79FB\u9664\u6210\u5458",
        deleteMultiMemberTip: "\u79FB\u9664\u6210\u5458\u540E\uFF0C\u6240\u9009\u6210\u5458\u5C06\u65E0\u6CD5\u8BBF\u95EE\u60A8\u7684\u4F1A\u793E\uFF0C\u6210\u5458\u5DF2\u4E0A\u4F20\u81F3\u4E91\u7AEF\u7684\u6A21\u578B\u5C06\u4E0D\u4F1A\u4E22\u5931\u3002\u786E\u5B9A\u79FB\u9664\u5417\uFF1F",
        editMember: "\u7F16\u8F91\u6210\u5458",
        contactPhone: "\u5BA2\u670D\u8054\u7CFB\u65B9\u5F0F\uFF1A",
        contactEmail: "\u5BA2\u670D\u90AE\u7BB1\uFF1A",
        cannotRemoveAdminOrSelf: "\u65E0\u6CD5\u79FB\u9664\u8D85\u7EA7\u7BA1\u7406\u5458\u6216\u81EA\u5DF1",
        removeSuccess: "\u6210\u5458\u79FB\u9664\u6210\u529F",
        statusDisabled: "\u505C\u7528\u4E2D",
        role: {
            owner: "\u6240\u6709\u8005",
            superManger: "\u8D85\u7EA7\u7BA1\u7406\u5458",
            manager: "\u7BA1\u7406\u5458",
            ScanatUser: "Scanat\u7528\u6237",
            viewUser: "\u6D4F\u89C8\u7528\u6237",
            name: "\u89D2\u8272",
            updateSuccess: "\u4FEE\u6539\u89D2\u8272\u6210\u529F",
            noRole: "\u65E0\u89D2\u8272"
        },
        operate: {
            enable: "\u542F\u7528",
            disable: "\u7981\u7528"
        },
        prompt: {
            buyScanatWeb: "\u5DF2\u8D2D\u4E70Scanat web\u670D\u52A1"
        },
        add: {
            chooseRole: "\u8BF7\u9009\u62E9\u89D2\u8272",
            manageSeat: "\u5E2D\u4F4D\u5206\u914D",
            seatTip1: "\u5173\u95ED\u540E\u8BE5\u8D26\u53F7\u5C06\u4E0D\u5360\u7528\u5E2D\u4F4D",
            seatTip2: "\u5F00\u542F\u540E\u8BE5\u8D26\u53F7\u5C06\u5360\u75281\u4E2A\u5E2D\u4F4D"
        },
        enable: {
            noRight: "\u65E0\u542F\u7528\u8BE5\u8D26\u53F7\u7684\u6743\u9650",
            tip: "\u542F\u7528\u540E\uFF0C\u8BE5\u8D26\u53F7\u53EF\u4EE5\u6B63\u5E38\u4F7F\u7528\uFF0C\u786E\u5B9A\u542F\u7528\u5417\uFF1F",
            success: "\u542F\u7528\u6210\u529F",
            noPlan: "\u516C\u53F8\u4E0D\u5728\u8BA2\u9605\u4E2D\uFF0C\u65E0\u6CD5\u542F\u7528\u8D26\u53F7"
        },
        disable: {
            noRight: "\u65E0\u7981\u7528\u8BE5\u8D26\u53F7\u7684\u6743\u9650",
            tip: "\u7981\u7528\u540E\uFF0C\u8BE5\u8D26\u53F7\u5C06\u65E0\u6CD5\u4F7F\u7528\uFF0C\u7CFB\u7EDF\u4E0D\u4F1A\u5220\u9664\u8D26\u53F7\u7684\u6570\u636E\uFF0C\u7981\u7528\u540E\u53EF\u518D\u6B21\u542F\u7528\uFF0C\u786E\u8BA4\u7981\u7528\u5417\uFF1F",
            success: "\u7981\u7528\u6210\u529F"
        },
        statusDisabledTxt: "\u5DF2\u7981\u7528",
        seatTip: "\u5206\u914D\u5E2D\u4F4D\u540E\uFF0C\u53EF\u4F7F\u7528Scanat\u670D\u52A1",
        delete: {
            noRight: "\u65E0\u5220\u9664\u8BE5\u8D26\u53F7\u7684\u6743\u9650"
        }
    },
    survey: {
        title: "Scanat \u89E3\u7EA6\u7533\u8BF7",
        desc: "\u611F\u8C22\u60A8\u4E00\u76F4\u4EE5\u6765\u5BF9 Scanat \u7684\u4F7F\u7528\u4E0E\u652F\u6301\u3002\n\u5982\u60A8\u5E0C\u671B\u7533\u8BF7\u89E3\u7EA6\uFF0C\u8BF7\u586B\u5199\u4EE5\u4E0B\u8868\u683C\u4E2D\u7684\u5FC5\u8981\u4E8B\u9879\u540E\u63D0\u4EA4\u3002\n\u6211\u4EEC\u5C06\u5728\u6536\u5230\u8868\u683C\u540E\u7684\u5DE5\u4F5C\u65E5\uFF0C\u7531\u8D1F\u8D23\u4EBA\u901A\u8FC7\u7535\u8BDD\u6216\u7535\u5B50\u90AE\u4EF6\u4E0E\u60A8\u8054\u7CFB\u3002",
        questionReason: "\u89E3\u7EA6\u539F\u56E0\uFF08\u53EF\u591A\u9009\uFF09",
        reason1: "\u6D4B\u91CF\u7CBE\u5EA6\u4F4E",
        reason2: "\u62CD\u6444\u6216\u64CD\u4F5C\u65B9\u6CD5\u56F0\u96BE",
        reason3: "\u4F7F\u7528\u9891\u7387\u4F4E",
        reason4: "\u529F\u80FD\u4E0D\u8DB3",
        reason5: "\u8D39\u7528\u9AD8",
        reason6: "\u652F\u6301\u4F53\u7CFB\u4E0D\u5B8C\u5584",
        questionApp: "2. \u60A8\u8FD8\u7528\u8FC7\u54EA\u4E9B\u626B\u63CF\u7CFB\u7EDF\uFF1F\uFF08\u591A\u9009\uFF09",
        app1: '3D Scanner',
        app2: 'Canvas',
        app3: 'Metascan',
        app4: 'Modelar',
        app5: 'Matterport',
        app6: 'OpalUI',
        app7: 'Polycam',
        app9: 'Scaniverse',
        app10: 'Sitescope',
        questionRecommend: "3. \u60A8\u6709\u591A\u5927\u610F\u613F\u5C06Scanat\u63A8\u8350\u7ED9\u9700\u89813D\u626B\u63CF\u7684\u670B\u53CB\uFF1F",
        descRecommend: "* 0\uFF5E10\u4EE3\u8868\u60A8\u5411\u670B\u53CB\u63A8\u8350Scanat\u7684\u610F\u613F\u7A0B\u5EA6\uFF0C0\u4EE3\u8868\u300C\u975E\u5E38\u4E0D\u613F\u610F\u300D\uFF0C10\u4EE3\u8868\u300C\u975E\u5E38\u613F\u610F\u300D",
        questionOther: "\u610F\u89C1\u6216\u5EFA\u8BAE",
        descOther: "\u5982\u679C\u60A8\u5BF9 Scanat \u6709\u4EFB\u4F55\u9700\u6C42\uFF0C\u6216\u5E0C\u671B\u6DFB\u52A0\u7684\u529F\u80FD\u3001\u5E0C\u671B\u6539\u8FDB\u7684\u5730\u65B9\uFF0C\u6B22\u8FCE\u586B\u5199\u3002\uFF08\u81EA\u7531\u586B\u5199\u680F\uFF09",
        submit: "\u63D0\u4EA4\u7533\u8BF7",
        error: "\u8BF7\u586B\u5199\u8BE5\u95EE\u9898",
        complete: "\u7533\u8BF7\u63D0\u4EA4\u6210\u529F",
        thanks: "\u611F\u8C22\u60A8\u7684\u5B9D\u8D35\u65F6\u95F4\uFF0Cnat\u5C06\u5C3D\u5FEB\u5904\u7406\u60A8\u7684\u7533\u8BF7\uFF01",
        profileTitle: "\u60A8\u7684\u8BE6\u7EC6\u4FE1\u606F\uFF08\u6240\u6709\u5B57\u6BB5\u5FC5\u586B\uFF09",
        profileOwnerHint: "\u4F8B\uFF1A\u5C71\u7530\u592A\u90CE",
        profilePhoneHint: "\u4F8B\uFF1A05017807133",
        profileMailHint: "\u4F8B\uFF1Ascanat{'@'}natincs.com",
        profileOwnerEmpty: "\u8BF7\u8F93\u5165\u4E3B\u62C5\u5F53\u8005",
        profilePhoneEmpty: "\u8BF7\u8F93\u5165\u7535\u8BDD",
        profileMailEmpty: "\u8BF7\u8F93\u5165\u90AE\u7BB1",
        profilePhoneError: "\u8BF7\u8F93\u5165\u6709\u6548\u7684\u7535\u8BDD",
        profileMailError: "\u8BF7\u8F93\u5165\u6709\u6548\u7684\u90AE\u7BB1",
        reasonOtherEmpty: "\u5185\u5BB9\u4E0D\u80FD\u4E3A\u7A7A\uFF0C\u8BF7\u8F93\u5165\u5177\u4F53\u5185\u5BB9",
        reasonEmpty: "\u8BF7\u9009\u62E9\u89E3\u7EA6\u7406\u7531",
        questionReasonDesc: "\u8BF7\u52FE\u9009\u6240\u6709\u9002\u7528\u7684\u9009\u9879",
        reason7: "\u90E8\u95E8\u6216\u8D1F\u8D23\u4EBA\u53D8\u66F4",
        reason8: "\u66F4\u6362\u4E3A\u5176\u4ED6\u516C\u53F8\u4EA7\u54C1",
        contactTip: "\u5982\u6709\u7591\u95EE\uFF0C\u8BF7\u901A\u8FC7\u4E0B\u65B9\u65B9\u5F0F\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002",
        contact: "\u3010\u8054\u7CFB\u65B9\u5F0F\u3011\n- \u8054\u7CFB\u7535\u8BDD\uFF1A050-1780-7133\n- \u8054\u7CFB\u90AE\u7BB1\uFF1Acs{'@'}natincs.com",
        waiting: "\u7B49\u5F85\u5904\u7406\u4E2D...",
        submited: "\u60A8\u5DF2\u63D0\u4EA4\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\n- \u8054\u7CFB\u7535\u8BDD\uFF1A050-1780-7133\n- \u8054\u7CFB\u90AE\u7BB1\uFF1Acs{'@'}natincs.com",
        submitedOther: "{id}\u5DF2\u63D0\u4EA4\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\n- \u8054\u7CFB\u7535\u8BDD\uFF1A050-1780-7133\n- \u8054\u7CFB\u90AE\u7BB1\uFF1Acs{'@'}natincs.com"
    },
    log: {
        title: "\u64CD\u4F5C\u65E5\u5FD7",
        searchHint: "\u8F93\u5165\u8D26\u53F7\u641C\u7D22",
        remark: "\u203B \u53EF\u67E5\u770B1\u5E74\u5185\u64CD\u4F5C\u65E5\u5FD7",
        account: "\u64CD\u4F5C\u8D26\u53F7",
        time: "\u64CD\u4F5C\u65F6\u95F4",
        system: "\u6240\u5C5E\u7CFB\u7EDF",
        page: "\u64CD\u4F5C\u9875\u9762",
        action: "\u4E8B\u4EF6\u540D\u79F0",
        detail: "\u8BE6\u60C5",
        ip: "IP\u5730\u5740",
        device: "\u64CD\u4F5C\u8BBE\u5907",
        overtimeError: "\u6240\u67E5\u8BE2\u7684\u65E5\u5FD7\u65F6\u95F4\u5DF2\u7ECF\u8D85\u8FC7\u4E00\u5E74\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u65F6\u95F4",
        noUserError: "\u672A\u627E\u5230\u8BE5\u8D26\u53F7"
    },
    toast: {
        noMovePermission: "\u6CA1\u6709\u76EE\u6807\u6587\u4EF6\u5939\u7684\u79FB\u52A8\u6743\u9650\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9",
        levelExceed: "\u90E8\u5206\u6587\u4EF6\u5939\u79FB\u52A8\u540E\u8D85\u8FC72\u7EA7\u5C42\u7EA7\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9",
        exist: "\u5DF2\u7ECF\u5B58\u5728\u4E8E\u8BE5\u6587\u4EF6\u5939\u4E2D",
        cannotMove: "\u4E0D\u53EF\u79FB\u52A8\u81F3\u5F53\u524D\u6587\u4EF6\u5939\u6216\u5B50\u6587\u4EF6\u5939\u4E2D",
        depth: {
            exceed: "\u79FB\u52A8\u540E\u8D85\u8FC710\u7EA7\u5C42\u7EA7\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9"
        }
    },
    share: {
        accountShare: "\u901A\u8FC7\u8D26\u53F7\u5206\u4EAB",
        linkShare: "\u901A\u8FC7\u94FE\u63A5\u5206\u4EAB",
        searchHint: "\u8F93\u5165\u8054\u7CFB\u4EBA\u8D26\u53F7\u641C\u7D22",
        searchEmpty: "\u672A\u627E\u5230\u7B26\u5408\u7684\u8054\u7CFB\u4EBA\u3002\n\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u5173\u952E\u8BCD\u641C\u7D22\u3002",
        limits: "\u6743\u9650",
        people_amount: "{n}\u4EBA",
        read: "\u4EC5\u67E5\u770B",
        edit: "\u53EF\u7F16\u8F91",
        manage: "\u53EF\u7BA1\u7406",
        resetLink: "\u91CD\u7F6E\u94FE\u63A5",
        overwritePw: "\u8986\u76D6\u73B0\u6709\u5BC6\u7801",
        unSaveTip: "\u8BF7\u5148\u53D6\u6D88\u6216\u4FDD\u5B58\u5BC6\u7801",
        title: {
            privateLink: "\u79C1\u5BC6\u94FE\u63A5",
            encryptedLink: "\u52A0\u5BC6\u94FE\u63A5",
            publicLink: "\u516C\u5F00\u94FE\u63A5",
            changeLinkPassword: "\u4FEE\u6539\u94FE\u63A5\u5BC6\u7801"
        },
        desc: {
            privateLink: "- \u4EC5\u56E2\u961F\u5185\u6210\u5458\u53EF\u8BBF\u95EE",
            encryptedLink: "- \u83B7\u5F97\u5BC6\u7801\u7684\u4EBA\u53EF\u8BBF\u95EE",
            publicLink: "- \u6240\u6709\u4EBA\u5747\u53EF\u8BBF\u95EE"
        },
        hint: {
            changeLinkPassword: "\u8BF7\u8F93\u5165\u957F\u5EA64\uFF5E20\u7684\u6570\u5B57\u6216\u5B57\u6BCD"
        },
        toast: {
            changeModeSuccess: "\u6743\u9650\u8BBE\u7F6E\u6210\u529F",
            noPermission: "\u4EC5\u6A21\u578B\u6240\u6709\u8005\u4E0E\u7BA1\u7406\u5458\u53EF\u4FEE\u6539",
            save: "\u8BF7\u5148\u53D6\u6D88\u6216\u4FDD\u5B58\u5BC6\u7801",
            noPermissionNew: "\u9700\u8981\u8BE5\u6A21\u578B\u7684\u53EF\u7F16\u8F91\u6216\u53EF\u7BA1\u7406\u6743\u9650"
        },
        alert: {
            title: {
                changeToPublic: "\u63D0\u793A"
            },
            info: {
                changeToPublic: "\u8BE5\u529F\u80FD\u5F00\u542F\u540E\uFF0C\u4E92\u8054\u7F51\u4E0A\u83B7\u5F97\u94FE\u63A5\u7684\u4EBA\u90FD\u80FD\u591F\u8BBF\u95EE\u6A21\u578B"
            }
        },
        copy: "\u5DF2\u590D\u5236\u94FE\u63A5\uFF0C\u5C06\u5176\u7C98\u8D34\u5230\u6D4F\u89C8\u5668\u4E2D\u5373\u53EF\u4E0E\u4ED6\u4EBA\u5206\u4EAB\u3002",
        link1: '{detail0}',
        link2: "Scanat\u6A21\u578B\u94FE\u63A5\uFF1A{detail0}\n\u5BC6\u7801\uFF1A{detail1}",
        copyLink: "\u590D\u5236\u94FE\u63A5",
        modelNotFound: "\u6A21\u578B\u300C{modelName}\u300D\u5DF2\u88AB\u5220\u9664",
        link: {
            noModel: "\u6A21\u578B\u4E0D\u5B58\u5728",
            noModelTip: "\u8BF7\u68C0\u67E5\u94FE\u63A5\u662F\u5426\u6B63\u786E"
        },
        privateLink: {
            linkFail: "\u94FE\u63A5\u5DF2\u5931\u6548",
            tip: "\u5F53\u524D\u767B\u5F55\u8D26\u53F7 {id}\uFF0C\u60A8\u53EF\u4EE5\u8054\u7CFB {admin_id} \u83B7\u53D6\u65B0\u7684\u94FE\u63A5",
            contactManage: "\u6CA1\u6709\u8BBF\u95EE\u6743\u9650\uFF0C\u8BF7\u8054\u7CFB\u60A8\u7684\u7BA1\u7406\u5458",
            limitPermission: "\u5F53\u524D\u767B\u5F55\u8D26\u53F7\u4E3A{id},\u6CA1\u6709\u6743\u9650\u8BBF\u95EE\u6A21\u578B"
        },
        encryptedLink: {
            needPassword: "\u8BBF\u95EE\u8BE5\u6A21\u578B\u9700\u8981\u5BC6\u7801",
            errorPassword: "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u5BC6\u7801",
            go: "\u524D\u5F80",
            placeholder: "\u8BF7\u8F93\u5165\u5BC6\u7801"
        }
    },
    member: {
        searchHint: "\u8F93\u5165\u6210\u5458\u8D26\u53F7\u641C\u7D22",
        searchEmpty: "\u672A\u627E\u5230\u7B26\u5408\u7684\u6210\u5458\uFF0C\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u5173\u952E\u8BCD\u641C\u7D22",
        addMember: "\u6DFB\u52A0\u6210\u5458",
        owner: "\u6240\u6709\u8005",
        admin: "\u8D85\u7EA7\u7BA1\u7406\u5458",
        outsider: "\u5916\u90E8\u4EBA\u5458"
    },
    import: {
        model: "\u5BFC\u5165\u6A21\u578B",
        fail: "\u5BFC\u5165\u5931\u8D25\uFF01",
        reimport: "\u91CD\u65B0\u5BFC\u5165\u6A21\u578B",
        importGuide: "\u9009\u62E9\u6216\u62D6\u62FD\u5355\u4E2A3D\u6587\u4EF6\u5BFC\u5165",
        importFormat: "\u652F\u6301\u683C\u5F0F\uFF1AOBJ/GLTF/GLB/DRC/STL/PLY/DAE/FBX/SKP/USDZ/DXF/ZIP\n\u5982\u679C\u60A8\u7684\u6587\u4EF6\u5305\u542B\u7D20\u6750\u56FE\u7247\uFF0C\u8BF7\u538B\u7F29\u4E3AZIP\u5BFC\u5165",
        releaseMouse: "\u91CA\u653E\u9F20\u6807\uFF0C\u6DFB\u52A0\u6587\u4EF6",
        localFile: "\u9009\u62E9\u6587\u4EF6",
        reSelect: "\u91CD\u65B0\u9009\u62E9\u6587\u4EF6",
        wrongFormat: "\u60A8\u9009\u62E9\u7684\u6587\u4EF6\u683C\u5F0F\u4E0D\u652F\u6301\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9",
        fileSizeLimit: "\u6587\u4EF6\u5927\u5C0F\u8D85\u8FC7\u9650\u5236\uFF0C\u8BF7\u91CD\u65B0\u5BFC\u5165"
    },
    period: {
        lastWeek: "\u8FD11\u5468",
        lastMonth: "\u8FD11\u4E2A\u6708",
        lastYear: "\u8FD11\u5E74"
    },
    menu: {
        company: "\u516C\u53F8\u4FE1\u606F",
        log: "\u64CD\u4F5C\u65E5\u5FD7",
        order: "\u8BA2\u5355\u8BB0\u5F55",
        team: "\u56E2\u961F\u7BA1\u7406"
    },
    title: {
        team: "\u56E2\u961F\u7BA1\u7406",
        company: "\u516C\u53F8\u4FE1\u606F",
        order: "\u8BA2\u5355\u8BB0\u5F55",
        log: "\u64CD\u4F5C\u65E5\u5FD7",
        buy: "\u8D2D\u4E70\u5546\u54C1",
        pay: "\u652F\u4ED8\u8BA2\u5355",
        paySuccess: "\u652F\u4ED8\u6210\u529F",
        orderInfo: "\u8BA2\u5355\u8BE6\u60C5",
        land: "\u9009\u62E9\u60A8\u8981\u4F7F\u7528\u7684\u670D\u52A1",
        link: {
            useless: "\u94FE\u63A5\u5931\u6548",
            notExist: "\u94FE\u63A5\u4E0D\u5B58\u5728"
        }
    },
    SUCCESS: "\u64CD\u4F5C\u5B8C\u6BD5",
    VALIDATE_FAILED: "\u53C2\u6570\u9A8C\u8BC1\u5931\u8D25\u3002",
    UNAUTHORIZED: "\u5C1A\u672A\u6CE8\u518C\u6216\u4EE4\u724C\u5DF2\u8FC7\u671F\u3002",
    INVALID_PASSWORD: "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF\u3002",
    UNAVAILABLE: "\u6CE8\u518C\u540E\u8D26\u6237\u9700\u8981\u5728\u6CD5\u4EBA\u5408\u540C\u7B7E\u8BA2\u540E\u7531\u9500\u552E\u4EE3\u8868\u8FDB\u884C\u6FC0\u6D3B\u3002\u5982\u679C\u60A8\u6709\u610F\u613F\uFF0C\u8BF7\u8054\u7CFB",
    FORBIDDEN: "\u672A\u6388\u4E88\u5FC5\u8981\u7684\u6743\u9650\u3002",
    POSTCODE_NOT_EXIST: "\u90AE\u653F\u7F16\u7801\u4E0D\u5B58\u5728\u3002",
    NOT_REGISTERED: "\u6B64\u90AE\u7BB1\u5730\u5740\u672A\u6CE8\u518C\u3002",
    VERIFICATION_CODE_ERROR: "\u9A8C\u8BC1\u7801\u4E0D\u6B63\u786E\u3002",
    VERIFICATION_CODE_EXPIRE: "\u9A8C\u8BC1\u7801\u5DF2\u8FC7\u671F\u3002",
    USER_NOT_EXIST: "\u6B64\u7528\u6237\u4E0D\u5B58\u5728\u3002",
    CRM_ACCOUNT_NOT_EXIST: "\u8D26\u6237\u4E0D\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D\u3002",
    USER_EXIST: "\u6B64\u7528\u6237\u5DF2\u5B58\u5728\u3002",
    CONFIRM_PASSWORD: "\u8F93\u5165\u7684\u5BC6\u7801\u4E0D\u5339\u914D\u3002",
    FILE_UPLOAD_KEY_GET_FAIL: "\u65E0\u6CD5\u83B7\u53D6\u5BC6\u94A5\u3002",
    MODEL_NOT_BELONG: "\u8BE5\u6A21\u578B\u4E0D\u5C5E\u4E8E\u60A8\u3002",
    FAILED: "\u64CD\u4F5C\u5931\u8D25",
    REQUEST_FREQUENTLY: "\u64CD\u4F5C\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u3002",
    FILE_SHARE_ERROR_DEL: "\u7531\u4E8E\u6587\u4EF6\u5DF2\u88AB\u5220\u9664\uFF0C\u5171\u4EAB\u5931\u8D25",
    FILE_SHARE_ERROR_UNAUTHORIZED: "\u6CA1\u6709\u6743\u9650\u8FDB\u884C\u6B64\u64CD\u4F5C",
    FILE_SHARE_ERROR_EMAIL_NOT_EXISTS: "\u7528\u6237ID\u4E0D\u5B58\u5728",
    FILE_SHARE_ERROR_UNKNOWN: "\u672A\u77E5\u9519\u8BEF",
    FILE_SHARE_ERROR_REPEAT_SHARING: "\u6A21\u578B\u5DF2\u88AB\u53D1\u9001\u7ED9\u8BE5\u7528\u6237",
    FILE_SHARE_ERROR_SELF: "\u65E0\u6CD5\u5C06\u6A21\u578B\u53D1\u9001\u7ED9\u81EA\u5DF1",
    FILE_SHARE_UPDATE_FAIL: "\u66F4\u65B0\u5931\u8D25\u3002\u627E\u4E0D\u5230\u5171\u4EAB\u7684\u6587\u4EF6",
    FILE_DOWNLOAD_ERROR_DEL: "\u7531\u4E8E\u6587\u4EF6\u5DF2\u88AB\u5220\u9664\uFF0C\u65E0\u6CD5\u4E0B\u8F7D",
    FILE_SHARE_DEL_FAIL: "\u7531\u4E8E\u6CA1\u6709\u5171\u4EAB\u7684\u6A21\u578B\uFF0C\u65E0\u6CD5\u5220\u9664",
    FILE_SHARE_DEL_FAIL_NO_AUTHORITY: "\u65E0\u6CD5\u5220\u9664\u5171\u4EAB\u7684\u6A21\u578B",
    CREDIT_CARD_PAY_ERROR: "\u8BA2\u9605\u6062\u590D\u5931\u8D25",
    CREDIT_CARD_PAY_FAIL_BY_ERROR_FILE_KEY: "\u5361\u652F\u4ED8\u5931\u8D25\uFF0C\u539F\u56E0\uFF1A\u6570\u636E\u4E0D\u5B58\u5728\uFF01",
    PERMITS_CONVERT_FAIL: "\u8BA2\u9605\u6062\u590D\u5931\u8D25",
    PERMITS_CONVERT_FAIL_USER_NULL: "\u8BA2\u9605\u6062\u590D\u5931\u8D25",
    APP_TRANSLATION_INVALID: "\u7528\u6237\u4E0D\u5B58\u5728",
    APP_TRANSLATION_HISTORY_GET_FAIL: "\u83B7\u53D6\u8BA2\u9605\u6570\u636E\u5931\u8D25",
    APP_TRANSLATION_STATUS_GET_FAIL: "\u83B7\u53D6\u8BA2\u9605\u6570\u636E\u5931\u8D25",
    FILE_UPLOAD_FILE_PATH_EMP_ERROR: "\u65E0\u6CD5\u66F4\u65B0\uFF1A\u8BF7\u8F93\u5165\u6587\u4EF6\u8DEF\u5F84\u3002",
    FILE_UPLOAD_FILE_DB_FAIL_ERROR: "\u65E0\u6CD5\u66F4\u65B0\uFF1A\u6A21\u578B\u8BB0\u5F55\u51FA\u73B0\u9519\u8BEF\u3002",
    APP_TOKEN_GET_FAIL: "\u83B7\u53D6\u53C2\u6570\u5931\u8D25",
    APP_IP_ADDRESS_NOT_ALLOW: "\u8BE5IP\u5730\u5740\u65E0\u6CD5\u88AB\u8BBF\u95EE",
    CONTACT_ALREADY_EXIST: "\u8054\u7CFB\u4EBA\u5DF2\u5B58\u5728\uFF0C\u8BF7\u4E0D\u8981\u91CD\u590D\u6DFB\u52A0\u3002",
    ACCOUNT_PLAN_NOT_EXIST: "\u5C1A\u672A\u8D2D\u4E70\u5957\u9910\u8BA1\u5212",
    ACCOUNT_PLAN_TYPE_ERROR: "\u5957\u9910\u7C7B\u578B\u4FE1\u606F\u6709\u8BEF",
    ACCOUNT_PLAN_DOWNGRADE: "\u4E0D\u80FD\u5C06\u5957\u9910\u964D\u7EA7",
    ACCOUNT_PLAN_PREPAY_MONTH_ERROR: "\u5957\u9910\u4FE1\u606F\u6709\u8BEF",
    ACCOUNT_PLAN_PREPAY_MONTH_NOT_OVER: "\u5728\u9884\u4ED8\u6B3E\u671F\u95F4\u7ED3\u675F\u4E4B\u524D\uFF0C\u65E0\u6CD5\u66F4\u6539\u5957\u9910",
    CUSTOMER_FINCODE_CUSTOMER_ID_NOT_EXIST: "\u627E\u4E0D\u5230\u7528\u6237\u7684FincodeID",
    FINCODE_PLAN_ID_NOT_EXIST: "FincodeID\u4E0D\u5B58\u5728",
    CUSTOMER_NAME_DUPLICATE: "\u7528\u6237\u540D\u5DF2\u5B58\u5728\uFF0C\u8BF7\u4E0D\u8981\u91CD\u590D\u6DFB\u52A0",
    CUSTOMER_NAME_BLANK_NOT_ALLOW: "\u7528\u6237\u540D\u4E0D\u80FD\u4E3A\u7A7A",
    ACCOUNT_NOT_EXIST: "\u7528\u6237ID\u4E0D\u5B58\u5728",
    CUSTOMER_NOT_EXIST: "\u7528\u6237\u4E0D\u5B58\u5728",
    FINCODE_CARD_ID_BLANK_NOT_ALLOW: "FincodeID\u4E0D\u80FD\u4E3A\u7A7A",
    CUSTOMER_NOT_BOUND_TO_ACCOUNT_PLAN: "\u7528\u6237\u672A\u4E0E\u4EFB\u4F55\u5957\u9910\u8BA1\u5212\u5173\u8054",
    CUSTOMER_ACCOUNT_PLAN_NOT_IN_EFFECT: "\u4ED8\u6B3E\u8BF7\u6C42\u5DF2\u53D1\u9001\uFF0C\u6B63\u5728\u786E\u8BA4\u6263\u6B3E\u7ED3\u679C\uFF0C\u8BF7\u7A0D\u7B49\uFF01",
    ACCOUNT_IN_USE_HAS_REACHED_MAX: "\u53EF\u7528\u7684ID\u6570\u91CF\u5DF2\u8FBE\u5230\u4E0A\u9650",
    ACCOUNT_IN_USE_AND_ADD_ACCOUNT_EXCEED_MAX: "\u65B0\u589E\u7684ID\u6570\u4E0E\u5F53\u524D\u4F7F\u7528\u7684ID\u6570\u603B\u548C\u5DF2\u8D85\u8FC7\u5957\u9910\u7684ID\u6570\u91CF\u4E0A\u9650",
    ACCOUNT_EMAIL_NOT_ALLOW_DUPLICATES: "\u8D26\u6237\u7684\u90AE\u7BB1\u5730\u5740\u4E0D\u80FD\u91CD\u590D\u6CE8\u518C",
    ACCOUNT_EMAIL_ALREADY_EXISTS: "\u90AE\u7BB1\u5730\u5740\u5DF2\u5B58\u5728",
    ACCOUNT_LIST_CANNOT_BE_EMPTY: "\u8D26\u6237\u96C6\u5408\u4E0D\u80FD\u4E3A\u7A7A",
    FREEE_TOKEN_GET_ERROR: "\u53D1\u751F\u4E86Freee\u7684\u8BA4\u8BC1\u9519\u8BEF",
    FREEE_API_REQUEST_ERROR: "\u5411Freee\u7684API\u53D1\u9001\u8BF7\u6C42\u65F6\u53D1\u751F\u4E86\u9519\u8BEF",
    FREEE_INVOICE_LIST_ERROR: "\u5411Freee\u7684API\u53D1\u9001\u8BF7\u6C42\u83B7\u53D6\u53D1\u7968\u5217\u8868\u65F6\u53D1\u751F\u4E86\u9519\u8BEF",
    FREEE_INVOICE_DETAIL_ERROR: "\u5411Freee\u7684API\u53D1\u9001\u8BF7\u6C42\u83B7\u53D6\u53D1\u7968\u8BE6\u60C5\u65F6\u53D1\u751F\u4E86\u9519\u8BEF",
    FREEE_ADD_INVOICE_ERROR: "\u5411Freee\u7684API\u53D1\u9001\u8BF7\u6C42\u6DFB\u52A0\u53D1\u7968\u65F6\u53D1\u751F\u4E86\u9519\u8BEF",
    FREEE_ADD_PARTNER_ERROR: "\u5411Freee\u7684API\u53D1\u9001\u8BF7\u6C42\u6DFB\u52A0\u5BA2\u6237\u65F6\u53D1\u751F\u4E86\u9519\u8BEF",
    FREEE_UPDATE_PARTNER_ERROR: "\u5411Freee\u7684API\u53D1\u9001\u8BF7\u6C42\u66F4\u65B0\u5BA2\u6237\u65F6\u53D1\u751F\u4E86\u9519\u8BEF",
    FREEE_PARTNER_DETAIL_ERROR: "\u5411Freee\u7684API\u53D1\u9001\u8BF7\u6C42\u83B7\u53D6\u5BA2\u6237\u4FE1\u606F\u65F6\u53D1\u751F\u4E86\u9519\u8BEF",
    FREEE_PARTNER_LIST_ERROR: "\u5411Freee\u7684API\u53D1\u9001\u8BF7\u6C42\u83B7\u53D6\u5BA2\u6237\u5217\u8868\u65F6\u53D1\u751F\u4E86\u9519\u8BEF",
    ACCOUNT_PLAN_ORDER_NOT_EXISTS: "\u5BA2\u6237\u7684\u5408\u540C\u5957\u9910\u4FE1\u606F\u4E0D\u5B58\u5728",
    CUSTOMER_ALREADY_ADDED: "\u5BA2\u6237\u4FE1\u606F\u5DF2\u5B58\u5728",
    ORDER_NOT_EXIST: "\u8BA2\u5355\u4E0D\u5B58\u5728",
    ORDER_STATUS_ERROR: "\u8BA2\u5355\u72B6\u6001\u9519\u8BEF",
    ORDER_PAYMENT_METHOD_NOT_ALLOW: "\u8BA2\u5355\u652F\u4ED8\u65B9\u5F0F\u4E0D\u652F\u6301",
    FINCODE_CUSTOMER_CARD_NOT_FOUND: "Fincode\u5361\u4E0D\u5B58\u5728",
    FREEE_PARTNER_NOT_FOUND: "Freee\u5BA2\u6237\u4FE1\u606F\u6CA1\u6709\u627E\u5230",
    CUSTOMER_ALREADY_BOUND_PLAN: "\u5DF2\u53D1\u9001\u4ED8\u6B3E\u8BF7\u6C42\uFF0C\u8BF7\u52FF\u91CD\u590D\u53D1\u9001",
    MY_USER_PHONE_NUMBER_ALREADY_EXISTS: "\u7528\u6237\u624B\u673A\u53F7\u7801\u5DF2\u5B58\u5728",
    MY_USER_EMAIL_ALREADY_EXISTS: "\u7528\u6237\u90AE\u7BB1\u5DF2\u5B58\u5728",
    ROLE_NAME_DUPLICATE: "\u89D2\u8272\u540D\u79F0\u4E0D\u80FD\u91CD\u590D",
    THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DISABLED: "\u6709\u7528\u6237\u7ED1\u5B9A\u8BE5\u89D2\u8272\uFF0C\u4E0D\u80FD\u7981\u7528",
    THERE_ARE_USERS_BOUND_TO_THIS_ROLE_CANNOT_UPDATE_ITS_DEPT: "\u6709\u7528\u6237\u7ED1\u5B9A\u8BE5\u89D2\u8272\uFF0C\u4E0D\u80FD\u4FEE\u6539\u5176\u90E8\u95E8",
    THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DELETED: "\u6709\u7528\u6237\u7ED1\u5B9A\u8BE5\u89D2\u8272\uFF0C\u4E0D\u80FD\u5220\u9664",
    ADD_DEPT_NOT_ALLOWED_UNDER_HEADQUARTERS: "\u603B\u90E8\u4E0B\u4E0D\u5141\u8BB8\u6DFB\u52A0\u90E8\u95E8",
    AGENCY_DEPT_MUST_SET_POSTAL_CODE_AND_ADDRESS_INFORMATION: "\u4EE3\u7406\u5E97\u90E8\u95E8\u5FC5\u987B\u8BBE\u7F6E\u90AE\u7F16\u548C\u5730\u5740\u4FE1\u606F",
    MOST_FIVE_DEPT_LEVELS: "\u90E8\u95E8\u6700\u591A\u4E94\u7EA7\uFF0C\u4E0D\u5141\u8BB8\u6DFB\u52A0\u90E8\u95E8",
    DEPT_NAME_ALREADY_EXISTS: "\u90E8\u95E8\u540D\u79F0\u5DF2\u5B58\u5728",
    THE_DEPT_HAS_SUB_DEPT: "\u8BE5\u90E8\u95E8\u5B58\u5728\u4E0B\u7EA7\u90E8\u95E8\uFF0C\u4E0D\u5141\u8BB8\u5220\u9664",
    THERE_ARE_USERS_IN_THIS_DEPT: "\u8BE5\u90E8\u95E8\u5B58\u5728\u7528\u6237\uFF0C\u4E0D\u5141\u8BB8\u5220\u9664",
    THERE_ARE_ROLES_BOUND_TO_THIS_DEPT: "\u6709\u89D2\u8272\u7ED1\u5B9A\u8BE5\u90E8\u95E8\uFF0C\u4E0D\u5141\u8BB8\u5220\u9664",
    THERE_ARE_ACCOUNT_PLAN_BOUND_TO_THIS_DEPT: "\u8BE5\u90E8\u95E8\u4E0B\u5B58\u5728\u8D26\u53F7\u5957\u9910\uFF0C\u4E0D\u5141\u8BB8\u5220\u9664",
    CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_ADD: "\u5BA2\u6237\u540D\u79F0\u5DF2\u5B58\u5728\uFF0C\u4E0D\u80FD\u65B0\u589E",
    THE_DEPT_BOUND_TO_THE_CUSTOMER_DOES_NOT_EXISTS: "\u5BA2\u6237\u6240\u7ED1\u5B9A\u7684\u90E8\u95E8\u4E0D\u5B58\u5728",
    CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_UPDATE: "\u5BA2\u6237\u540D\u79F0\u5DF2\u5B58\u5728\uFF0C\u4E0D\u80FD\u4FEE\u6539",
    THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ACTIVATE_THE_ACCOUNT: "\u8BE5\u5BA2\u6237\u672A\u7ED1\u5B9A\u8D26\u53F7\u5957\u9910\uFF0C\u4E0D\u80FD\u6FC0\u6D3B\u8D26\u53F7",
    THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ACTIVATE_THE_ACCOUNT: "\u8BE5\u5BA2\u6237\u7684\u8D26\u53F7\u5957\u9910\u672A\u751F\u6548\uFF0C\u4E0D\u80FD\u6FC0\u6D3B\u8D26\u53F7",
    THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_BE_ACTIVATED: "\u5DF2\u6FC0\u6D3B\u7684\u8D26\u53F7\u6570\u5DF2\u8FBE\u5230\u5957\u9910id\u6570\u91CF\u4E0A\u9650\uFF0C\u4E0D\u80FD\u518D\u6FC0\u6D3B\u8D26\u53F7",
    THE_NEW_CUSTOMER_IS_NOT_BOUND_TO_ANY_ACCOUNT_PLAN_THE_ACTIVATED_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: "\u65B0\u5BA2\u6237\u672A\u7ED1\u5B9A\u4EFB\u4F55\u8D26\u53F7\u5957\u9910\uFF0C\u5DF2\u6FC0\u6D3B\u7684\u8D26\u53F7\u4E0D\u80FD\u6539\u5230\u8BE5\u5BA2\u6237\u540D\u4E0B",
    THE_ACCOUNT_PLAN_FOR_NEW_CUSTOMER_HAS_NOT_TAKEN_EFFECT_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: "\u65B0\u5BA2\u6237\u7684\u8D26\u53F7\u5957\u9910\u672A\u751F\u6548\uFF0C\u5DF2\u6FC0\u6D3B\u7684\u8D26\u53F7\u4E0D\u80FD\u6539\u5230\u8BE5\u5BA2\u6237\u540D\u4E0B",
    THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: "\u8BE5\u5BA2\u6237\u672A\u7ED1\u5B9A\u8D26\u53F7\u5957\u9910\uFF0C\u4E0D\u80FD\u8FFD\u52A0\u6FC0\u6D3B\u72B6\u6001\u7684\u8D26\u53F7",
    THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: "\u8BE5\u5BA2\u6237\u7684\u8D26\u53F7\u5957\u9910\u672A\u751F\u6548\uFF0C\u4E0D\u80FD\u8FFD\u52A0\u6FC0\u6D3B\u72B6\u6001\u7684\u8D26\u53F7",
    THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_ADD_ACTIVATED_ACCOUNT: "\u5DF2\u6FC0\u6D3B\u7684\u8D26\u53F7\u6570\u5DF2\u8FBE\u5230\u5957\u9910id\u6570\u91CF\u4E0A\u9650\uFF0C\u4E0D\u80FD\u8FFD\u52A0\u6FC0\u6D3B\u72B6\u6001\u7684\u8D26\u53F7",
    THE_USER_OF_THE_AGENT_STORE_DOES_NOT_HAVE_PERMISSION_TO_VIEW_THE_CAD_ORDER_LIST: "\u4EE3\u7406\u5E97\u7684\u7528\u6237\u6CA1\u6709\u6743\u9650\u67E5\u770BCAD\u8BA2\u5355\u5217\u8868",
    CAD_ORDER_HAS_BEEN_COMPLETED_NOT_ALLOW_TO_UPLOAD_FILES: "\u8BA2\u5355\u5DF2\u5B8C\u7ED3\uFF0C\u4E0D\u80FD\u518D\u4E0A\u4F20\u6587\u4EF6",
    CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_AGENT_STORE: "\u8BE5\u89D2\u8272\u5C5E\u4E8E\u672C\u90E8\uFF0C\u4E0D\u80FD\u7ED1\u5B9A\u53EA\u5141\u8BB8\u4EE3\u7406\u5E97\u8BBF\u95EE\u624D\u80FD\u8BBF\u95EE\u7684\u83DC\u5355",
    CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_HEAD_OFFICE: "\u8BE5\u89D2\u8272\u5C5E\u4E8E\u4EE3\u7406\u5E97\uFF0C\u4E0D\u80FD\u7ED1\u5B9A\u53EA\u5141\u8BB8\u672C\u90E8\u8BBF\u95EE\u624D\u80FD\u8BBF\u95EE\u7684\u83DC\u5355",
    THE_ACCOUNT_PLAN_IS_CURRENTLY_IN_USE_BY_A_CUSTOMER_AND_CANNOT_BE_DELETED: "\u8BE5\u5957\u9910\u6709\u5BA2\u6237\u6B63\u5728\u4F7F\u7528\uFF0C\u4E0D\u5141\u8BB8\u5220\u9664",
    THE_DEPT_WHERE_THE_EQUIPMENT_BELONGS_CANNOT_BE_A_AGENCY_STORE: "\u8BBE\u5907\u7684\u5F52\u5C5E\u90E8\u95E8\u4E0D\u80FD\u4E3A\u4EE3\u7406\u5E97",
    CUSTOMER_IS_CURRENTLY_USING_THIS_EQUIPMENT_CANNOT_BE_DELETED: "\u6709\u5BA2\u6237\u6B63\u5728\u4F7F\u7528\u8BE5\u8BBE\u5907\uFF0C\u4E0D\u80FD\u5220\u9664",
    THE_STANDARD_QUOTATION_EQUIPMENT_FOR_ACCOUNT_PLAN_WITH_NORMAL_STATUS_IS_THE_CURRENT_EQUIPMENT_CANNOT_BE_DELETED: "\u6709\u6B63\u5E38\u72B6\u6001\u7684\u8D26\u53F7\u5957\u9910\u7684\u6807\u51C6\u62A5\u4EF7\u8BBE\u5907\u662F\u5F53\u524D\u8BBE\u5907\uFF0C\u4E0D\u80FD\u5220\u9664",
    ADDING_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: "\u4E0D\u5141\u8BB8\u65B0\u589E\u5BA2\u6237\uFF0C\u5BA2\u6237\u540D\u79F0DB\u4E2D\u5DF2\u5B58\u5728",
    ADDING_IS_NOT_ALLOWED_THIRD_PARTY_CUSTOMER_NAME_ALREADY_EXISTS: "\u4E0D\u5141\u8BB8\u65B0\u589E\uFF0C\u7B2C\u4E09\u65B9\u5BA2\u6237\u540D\u79F0\u5DF2\u5B58\u5728",
    UPDATE_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: "\u4E0D\u5141\u8BB8\u66F4\u65B0\u5BA2\u6237\u540D\u79F0\uFF0C\u5BA2\u6237\u540D\u79F0DB\u4E2D\u5DF2\u5B58\u5728",
    THE_CUSTOMER_HAS_AN_RESOLVED_ACCOUNT_PLAN_ORDER_CANNOT_MODIFY_ITS_DEPT: "\u5BA2\u6237\u6709\u672A\u89E3\u7EA6\u7684\u5957\u9910\u8BA2\u5355\uFF0C\u4E0D\u80FD\u4FEE\u6539\u5176\u6240\u5C5E\u90E8\u95E8",
    THE_CUSTOMER_HAS_AN_RESOLVED_EQUIPMENT_ORDER_CANNOT_MODIFY_ITS_DEPT: "\u5BA2\u6237\u6709\u672A\u89E3\u7EA6\u7684\u8BBE\u5907\u8BA2\u5355\uFF0C\u4E0D\u80FD\u4FEE\u6539\u5176\u6240\u5C5E\u90E8\u95E8",
    CUSTOMER_INFO_NOT_ADDED: "\u60A8\u8FD8\u6CA1\u6709\u6DFB\u52A0\u5BA2\u6237\u4FE1\u606F",
    FREEE_PARTNER_NOT_EXIST: "Freee\u4E2D\u7684\u5BA2\u6237\u4FE1\u606F\u4E0D\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u786E\u8BA4",
    INVITATION_NOT_EXIST: "\u9080\u8BF7\u4E0D\u5B58\u5728",
    INVITATION_STATUS_ERROR: "\u9080\u8BF7\u72B6\u6001\u9519\u8BEF",
    INVITATION_STATUS_INVALID: "\u9080\u8BF7\u5DF2\u7ECF\u88AB\u64A4\u9500\uFF0C\u8BF7\u8054\u7CFB\u9080\u8BF7\u5BA2\u6237\u7BA1\u7406\u5458\u91CD\u65B0\u53D1\u9001\u9080\u8BF7",
    INVITATION_STATUS_EXPIRED: "\u9080\u8BF7\u5DF2\u7ECF\u8FC7\u671F\uFF0C\u8BF7\u8054\u7CFB\u9080\u8BF7\u5BA2\u6237\u7BA1\u7406\u5458\u91CD\u65B0\u53D1\u9001\u9080\u8BF7",
    INVITATION_CHECK_CODE_WRONG: "\u9080\u8BF7\u7684\u9A8C\u8BC1\u7801\u9519\u8BEF",
    CUSTOMER_ACCOUNT_PLAN_IN_EFFECT: "\u8BE5\u8D26\u6237\u5DF2\u7ECF\u662F\u4ED8\u8D39\u7528\u6237\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u5BF9\u9519\u8BEF\u7684\u8D26\u6237\u53D1\u51FA\u4E86\u9080\u8BF7",
    CUSTOMER_NOT_ALLOW_CHANGE: "\u7528\u6237\u6240\u5C5E\u7684\u5BA2\u6237\u4E0D\u5141\u8BB8\u4FEE\u6539\u3002",
    USER_STATUS_UNAVAILABLE: "\u60A8\u7684\u8D26\u53F7\u5C1A\u672A\u8D2D\u4E70\u5957\u9910\uFF0C\u8BF7\u53BB\u8D2D\u4E70",
    USER_STATUS_AVAILABLE: "\u767B\u5F55\u6210\u529F",
    USER_STATUS_ACCOUNT_EXPIRED: "\u60A8\u7684\u5E10\u53F7\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u7EED\u8D39",
    USER_STATUS_LOGOUT: "\u5BF9\u5E94\u8D26\u53F7\u4E0D\u5B58\u5728",
    USER_STATUS_ACTIVE: "\u767B\u5F55\u6210\u529F",
    USER_STATUS_TO_BE_EFFECTIVE: "\u60A8\u7684\u5E10\u53F7\u5C1A\u672A\u751F\u6548\uFF0C\u8BF7\u8054\u7CFB\u8D35\u516C\u53F8\u7684\u7BA1\u7406\u5458%@\u5904\u7406",
    USER_STATUS_DEACTIVATE: "\u60A8\u7684\u8D26\u53F7\u5DF2\u88AB\u7BA1\u7406\u5458\u505C\u7528\uFF0C\u8BF7\u8054\u7CFB\u8D35\u516C\u53F8\u7684\u7BA1\u7406\u5458%@\u5904\u7406",
    USER_STATUS_PRE_DEACTIVATE: "\u767B\u5F55\u6210\u529F",
    USER_STATUS_PRE_ABNORMALITY: "\u8D26\u53F7\u5F02\u5E38\uFF0C\u65E0\u6CD5\u767B\u5F55",
    AGENT_NOT_EXIST: "\u4EE3\u7406\u5E97\u4E0D\u5B58\u5728",
    AGENT_NAME_DUPLICATE: "\u4EE3\u7406\u5E97\u540D\u91CD\u590D",
    REQUEST_BOOK_NOT_EXIST: "\u8BF7\u6C42\u4E66\u4E0D\u5B58\u5728",
    FILE_CREATE_FAIL: "\u521B\u5EFA\u6587\u4EF6\u5931\u8D25",
    SALES_DATE_EMPTY: "\u8BF7\u8F93\u5165\u4EA4\u6613\u65E5\u671F",
    EXTEND_PLAN_CONFIG_ERROR: "\u62D3\u5C55\u5957\u9910\u672A\u914D\u7F6E\uFF0C\u8BF7\u8054\u7CFB\u5F00\u53D1\u4EBA\u5458",
    CAN_NOT_FIND_WEB_MODEL_KEY: "\u6A21\u578B\u4E0D\u5B58\u5728",
    CAN_NOT_FIND_WEB_MODEL_FOLDER: "\u6587\u4EF6\u5939\u4E0D\u5B58\u5728",
    FOLDER_CANT_MOVE_INTO_SUB_FOLDER: "\u79FB\u52A8\u5931\u8D25\uFF0C\u6587\u4EF6\u5939\u4E0D\u80FD\u88AB\u79FB\u52A8\u81F3\u4E8C\u7EA7\u6587\u4EF6\u5939",
    FOLDER_CONTAIN_SUB_FOLDER: "\u79FB\u52A8\u5931\u8D25\uFF0C\u6240\u9009\u6587\u4EF6\u5939\u4E2D\u5305\u542B\u4E8C\u7EA7\u6587\u4EF6\u5939\uFF0C\u65E0\u6CD5\u88AB\u79FB\u52A8\u81F3\u5176\u4ED6\u6587\u4EF6\u5939",
    WEB_MODEL_ALREADY_IN_FOLDER: "\u79FB\u52A8\u5931\u8D25\uFF0C\u6587\u4EF6\u5DF2\u5B58\u5728\u4E8E\u8BE5\u6587\u4EF6\u5939\u4E2D",
    FOLDER_NAME_SAME: "\u5F53\u524D\u5B58\u5728\u540C\u540D\u6587\u4EF6\u5939\uFF0C\u8BF7\u4FEE\u6539\u540D\u79F0\u540E\u518D\u4FDD\u5B58",
    EMAIL_CODE_REQUIRED: "\u4E3A\u63D0\u9AD8\u5B89\u5168\u6027\uFF0C\u65B0\u589E\u4E86\u8BA4\u8BC1\u4EE3\u7801\u529F\u80FD\u3002\u8981\u4F7F\u7528\u6B64\u529F\u80FD\uFF0C\u8BF7\u5C06\u5E94\u7528\u7A0B\u5E8F\u66F4\u65B0\u5230\u6700\u65B0\u7248\u672C\uFF08v1.8.2\u6216\u4EE5\u4E0A\uFF09\u3002",
    FILE_SHARE_FAIL: "\u53D1\u9001\u5931\u8D25\uFF1A{}",
    NOT_HAS_WEB_PERMISSION: "\u60A8\u7684\u4F01\u4E1A\u6682\u672A\u8D2D\u4E70\u8BE5\u670D\u52A1\uFF0C\u65E0\u6CD5\u8BBF\u95EE",
    MODEL_OUTLINE_NOT_EXIST: "\u6A21\u578B\u8F6E\u5ED3\u56FE\u4E0D\u5B58\u5728",
    WEB_MODEL_NO_AUTH: "\u6743\u9650\u4E0D\u8DB3",
    SEAT_NUM_TOO_SMALL: "\u5E2D\u4F4D\u6570\u5C0F\u4E8E\u6700\u5C0F\u9650\u5236",
    SEAT_NUM_TOO_BIG: "\u5E2D\u4F4D\u6570\u5927\u4E8E\u6700\u5927\u9650\u5236",
    SEAT_NUM_LESS_THAN_USED: "\u5E2D\u4F4D\u4E0D\u8DB3",
    CUSTOMER_PLAN_NOT_CANCELED: "\u5BA2\u6237\u6CA1\u6709\u5DF2\u53D6\u6D88\u7684\u5957\u9910",
    CUSTOMER_PLAN_EXIST: "\u5BA2\u6237\u5DF2\u7ECF\u8D2D\u4E70\u5957\u9910",
    CUSTOMER_PLAN_ALREADY_CANCELED: "\u5BA2\u6237\u5957\u9910\u5DF2\u53D6\u6D88",
    CUSTOMER_PLAN_NOT_A: "\u5BA2\u6237\u4E0D\u662F\u5957\u9910A",
    CUSTOMER_PLAN_PERIOD_ERROR: "\u4E0D\u652F\u6301\u7684\u4ED8\u6B3E\u5468\u671F",
    START_TIME_ILLEGAL: "\u5F00\u59CB\u65F6\u95F4\u9519\u8BEF",
    STRIPE_ONE_TIME_PRICE_NOT_FOUND: "\u5957\u9910\u5546\u54C1\u4E0D\u5B58\u5728",
    CUSTOMER_PLAN_EXPAND_NOT_FOUND_ITEM: "\u5957\u9910\u5546\u54C1\u4E0D\u5B58\u5728",
    ORDER_NOT_BELONG: "\u8BA2\u5355\u4E0D\u5C5E\u4E8E\u5F53\u524D\u4F1A\u793E",
    WEB_PERMISSION_NOT_ALLOW_INACTIVE: "\u6743\u9650\u4E0D\u8DB3",
    CUSTOMER_HAS_ACCOUNT_IN_USE: "\u4F1A\u793E\u5B58\u5728\u8D26\u53F7\u5728\u4F7F\u7528",
    CAD_PLAN_GOODS_NOT_EXIST: "\u6CA1\u6709\u627E\u5230CAD\u5546\u54C1",
    CAD_ORDER_NOT_EXIST: "CAD\u8BA2\u5355\u4E0D\u5B58\u5728",
    CAD_ORDER_STATUS_ERROR: "CAD\u8BA2\u5355\u72B6\u6001\u9519\u8BEF",
    CAD_ORDER_FILE_TOO_MANY: "CAD\u8BA2\u5355\u6587\u4EF6\u5927\u5C0F\u8D85\u51FA\u4E0A\u9650",
    ACCOUNT_PLAN_PERIOD_NOT_ALLOW: "\u4E0D\u652F\u6301\u7684\u4ED8\u6B3E\u5468\u671F",
    CUSTOMER_PLAN_END_TIME_BEFORE_NOW: "\u5957\u9910\u8FD8\u672A\u5230\u671F",
    EXPAND_SEAT_NOT_ZERO: "\u6269\u5BB9\u5E2D\u4F4D\u4E0D\u80FD\u4E3A0",
    EXPAND_A_NOT_ALLOW: "\u5957\u9910A\u4E0D\u5141\u8BB8\u6269\u5BB9",
    ACCOUNT_PLAN_GOODS_NOT_EXIST: "\u5957\u9910\u5546\u54C1\u4E0D\u5B58\u5728",
    CAD_PLAN_GOODS_IS_USED: "CAD\u5957\u9910\u5728\u4F7F\u7528\u4E2D",
    DOMAIN_ALREADY_EXIST: "\u57DF\u540D\u5DF2\u7ECF\u5B58\u5728",
    LOCATION_WITH_SNAPSHOT: "\u7AD9\u70B9\u5DF2\u7ECF\u548C\u6F2B\u6E38\u70B9\u5173\u8054\u4E86",
    LOCATION_NOT_FOUNT: "\u7AD9\u70B9\u4E0D\u5B58\u5728",
    FLOOR_NOT_EXIST: "\u697C\u5C42\u4E0D\u5B58\u5728",
    AUTO_ALIGN_FAIL: "\u81EA\u52A8\u5BF9\u9F50\u5931\u8D25",
    CAN_NOT_CHANGE_MEMBER_ROLE: "\u4E0D\u80FD\u4FEE\u6539\u6210\u5458\u89D2\u8272",
    CAN_NOT_USE_SEAT: "\u6CA1\u6709\u6743\u9650\u4FEE\u6539\u5E2D\u4F4D\u5F00\u5173",
    APPLICATION_NOT_EXIST: "\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7\u4E0D\u5B58\u5728",
    PROCESSING_RESULT_NOT_EXIST: "\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7\u5904\u7406\u7ED3\u679C\u4E0D\u5B58\u5728",
    PLAN_CANCEL_APPLICATION_REASON_NOT_EXIST: "\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7\u7406\u7531\u4E0D\u5B58\u5728",
    PLAN_CANCEL_APPLICATION_OTHER_REASON_NULL: "\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7\uFF0C\u5176\u4ED6\u7406\u7531\u4E0D\u80FD\u4E3A\u7A7A",
    PLAN_CANCEL_APPLICATION_EMAIL_ERROR: "\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7\uFF0C\u4E0D\u662F\u5F53\u524D\u8D26\u53F7\u7684\u90AE\u7BB1",
    PLAN_CANCEL_APPLICATION_EXIST: "\u53D6\u6D88\u8BA2\u9605\u7533\u8BF7\u5DF2\u5B58\u5728",
    ACCOUNT_CAN_NOT_USE: "\u60A8\u7684\u8D26\u6237\u4E0D\u53EF\u7528",
    ACCOUNT_NOT_BUY_PLAN: "\u60A8\u5C1A\u672A\u8D2D\u4E70Scanat\u670D\u52A1\uFF0C\u8BF7\u81F3\u7535\u8111\u7AEF\u8BBF\u95EEhttps://scanat.app/fee-plans.html \u8D2D\u4E70\u5957\u9910\u540E\u518D\u6B21\u767B\u5F55",
    CUSTOMER_NOT_BUY_PLAN: "\u60A8\u7684\u4F1A\u793E\u5C1A\u672A\u8D2D\u4E70Scanat\u670D\u52A1\uFF0C\u6682\u65E0\u6CD5\u767B\u5F55",
    ACCOUNT_PLAN_EXPIRED: "\u60A8\u7684\u5957\u9910 {} \u5DF2\u4E8E {} \u8FC7\u671F\uFF0C\u8BF7\u81F3\u7535\u8111\u7AEF\u8BBF\u95EEhttps://scanat.app/fee-plans.html \u8D2D\u4E70\u5957\u9910\u540E\u518D\u6B21\u767B\u5F55",
    CUSTOMER_PLAN_EXPIRED: "\u60A8\u7684\u4F1A\u793E\u8D2D\u4E70\u7684\u5957\u9910 {} \u5DF2\u4E8E {} \u8FC7\u671F\uFF0C\u6682\u65E0\u6CD5\u767B\u5F55",
    ACCOUNT_PLAN_TOBE_EFFECTIVE: "\u60A8\u7684\u670D\u52A1\u5C06\u4E8E {} \u751F\u6548\uFF0C\u8BF7\u5728\u5957\u9910\u751F\u6548\u540E\u767B\u5F55\u4F7F\u7528",
    ACCOUNT_NO_SEAT: "\u8D26\u53F7\u672A\u5F00\u901A\u5E2D\u4F4D\uFF0C\u65E0\u6CD5\u4F7F\u7528app",
    CAN_NOT_EDIT_MEMBER: "\u4E0D\u80FD\u7F16\u8F91\u6210\u5458",
    MODEL_IS_NOT_EXIST: "\u6A21\u578B\u4E0D\u5B58\u5728",
    SHARE_LINK_NOT_EXIST: "\u5206\u4EAB\u94FE\u63A5\u4E0D\u5B58\u5728",
    NOT_CUSTOMER_MEMBER: "\u4E0D\u662F\u4F1A\u793E\u6210\u5458",
    SHARE_LINK_PASSWORD_ERROR: "\u5206\u4EAB\u94FE\u63A5\u5BC6\u7801\u9519\u8BEF",
    STRIPE_PAYMENT_METHOD_NOT_ALLOW: "stripe\u652F\u4ED8\u65B9\u5F0F\u4E0D\u5141\u8BB8",
    NOT_ADMIN_FORBIDDEN: "\u4E0D\u662F\u7BA1\u7406\u5458",
    NOT_ACTIVE_FORBIDDEN: "\u8D26\u53F7\u672A\u6FC0\u6D3B",
    map: {
        gpsEnabledModelCount: "\u6709GPS\u5B9A\u4F4D\u7684\u6A21\u578B\u6570\uFF1A{n}",
        emptyFolderNoGpsModel: "\u5F53\u524D\u6587\u4EF6\u5939\u5185\u6CA1\u6709\u4EFB\u4F55\u6709GPS\u5B9A\u4F4D\u7684\u6A21\u578B\u3002",
        searchNoResult: "\u672A\u627E\u5230\u7ED3\u679C\u3002\u5EFA\u8BAE\u5C1D\u8BD5\u66F4\u6539\u5173\u952E\u5B57\u3001\u68C0\u67E5\u8F93\u5165\u9519\u8BEF\u6216\u8C03\u6574\u7B5B\u9009\u5668\u3002"
    },
    maps: {
        hover: {
            showAllModels: "\u663E\u793A\u5168\u90E8\u6A21\u578B",
            zoomIn: "\u653E\u5927",
            zoomOut: "\u7F29\u5C0F"
        }
    },
    collaborator: {
        set: "\u8BBE\u7F6E\u534F\u4F5C\u8005",
        add: "\u6DFB\u52A0\u534F\u4F5C\u8005",
        search: {
            email: "\u8F93\u5165\u56E2\u961F\u6210\u5458\u90AE\u7BB1\u641C\u7D22"
        },
        online: "\u5F53\u524D\u5728\u7EBF",
        owner: "\u516C\u53F8\u6240\u6709\u8005",
        title: "\u534F\u4F5C\u8005"
    },
    fileModal: {
        cannotOperate: "\u8BE5\u6587\u4EF6\u5DF2\u88AB\u5220\u9664\uFF0C\u65E0\u6CD5\u64CD\u4F5C"
    },
    collaboratorlist: {
        set: "\u534F\u4F5C\u8005\u5217\u8868"
    },
    ACCOUNT_EMAIL_CAN_NOT_CREATE_CUSTOMER: "\u90AE\u7BB1\u5DF2\u6CE8\u518C\u8D26\u53F7\uFF0C\u65E0\u6CD5\u521B\u5EFA\u516C\u53F8\uFF0C\u8BF7\u66F4\u6362\u90AE\u7BB1",
    COOPERATOR_PERMISSION_DENIED: "\u6CA1\u6709\u534F\u4F5C\u8005\u6743\u9650",
    TEAM_SPACE_FOLDER_CREATE_NO_ADMIN: "\u975E\u7BA1\u7406\u5458\u4E0D\u80FD\u521B\u5EFA\u56E2\u961F\u7A7A\u95F4\u6587\u4EF6\u5939",
    NOT_A_FOLDER: "\u4E0D\u662F\u4E00\u4E2A\u6587\u4EF6\u5939",
    FOLDER_SPACE_MISMATCH: "\u627E\u4E0D\u5230\u6587\u4EF6\u5939\u7A7A\u95F4",
    FOLDER_DEPTH_EXCEEDED: "\u79FB\u52A8\u540E\u8D85\u8FC710\u7EA7\u5C42\u7EA7\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9",
    SPACE_FOLDER_CONTAIN_SUB_FOLDER: "\u4E0D\u53EF\u79FB\u52A8\u81F3\u5F53\u524D\u6587\u4EF6\u5939\u6216\u5B50\u6587\u4EF6\u5939\u4E2D",
    SPACE_FILE_ALREADY_IN_FOLDER: "\u5DF2\u7ECF\u5B58\u5728\u4E8E\u8BE5\u6587\u4EF6\u5939\u4E2D",
    CAN_NOT_FIND_SPACE_FILE: "\u8BE5\u6587\u4EF6\u5DF2\u88AB\u5220\u9664\uFF0C\u65E0\u6CD5\u8BBF\u95EE",
    SPACE_FILE_PATH_NULL: "\u6587\u4EF6\u8DEF\u5F84\u4E3A\u7A7A",
    COOPERATOR_ALREADY_EXISTS: "\u534F\u4F5C\u8005\u5DF2\u7ECF\u5728\u5217\u8868\u4E2D\uFF0C\u65E0\u6CD5\u6DFB\u52A0",
    INVITE_KEY_NOT_EXIST: "\u9080\u8BF7\u94FE\u63A5\u4E0D\u5B58\u5728",
    INVITE_EMAIL_ERROR: "\u9080\u8BF7\u90AE\u7BB1\u4E0D\u6B63\u786E",
    INVITE_STATUS_ERROR: "\u9080\u8BF7\u72B6\u6001\u9519\u8BEF",
    INVITE_STATUS_EXPIRED: "\u9080\u8BF7\u5DF2\u8FC7\u671F",
    INVITE_CUSTOMER_PLAN_NOT_EXIST: "\u9080\u8BF7\u65B9\u7684\u4F1A\u793E\u6CA1\u6709\u8D2D\u4E70\u8BA2\u9605"
};

});

parcelRegister("5sJrY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa2d2c0c6a5685e$export$2e2bcd8739ae039);
var $3fa2d2c0c6a5685e$export$2e2bcd8739ae039 = {
    common: {
        close: "\u9589\u3058\u308B",
        got: "\u9589\u3058\u308B",
        title: {
            email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9"
        },
        cancel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
        clear: "\u30AF\u30EA\u30A2",
        share: "\u5171\u6709",
        member: "\u30E1\u30F3\u30D0\u30FC",
        settings: "\u8A2D\u5B9A",
        save: "\u4FDD\u5B58",
        yes: "\u306F\u3044",
        no: "\u3044\u3044\u3048",
        done: "\u5B8C\u4E86",
        name: "\u540D\u524D",
        loading: "\u8AAD\u307F\u8FBC\u307F\u4E2D",
        back: "\u623B\u308B",
        deleteConfirm: "\u524A\u9664\u3057\u307E\u3059\u304B?",
        delete: "\u524A\u9664",
        rename: "\u540D\u524D\u3092\u5909\u66F4",
        empty: "\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
        inputhint: "\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        pre: "\u524D\u3078",
        next: "\u6B21\u3078",
        beginning: "\u6700\u5F8C\u3078",
        last: "\u6700\u5F8C\u3078",
        forwardPage: " \u30DA\u30FC\u30B8\u76EE\u3078",
        summary: "{n}\u4EF6",
        ok: "\u78BA\u5B9A",
        select: "\u9078\u629E",
        confirm: "\u78BA\u8A8D",
        selectAll: "\u3059\u3079\u3066\u9078\u629E",
        all: "\u3059\u3079\u3066",
        minimize: "\u6700\u5C0F\u5316",
        submit: "\u5909\u66F4",
        action: "\u30A2\u30AF\u30B7\u30E7\u30F3",
        active: "\u6709\u52B9\u5316",
        edit: "\u7DE8\u96C6",
        move: "\u79FB\u52D5",
        remove: "\u524A\u9664",
        more: "\u3055\u3089\u306B\u8868\u793A",
        batch: "\u4E00\u62EC\u51E6\u7406",
        MultiDelete: "\u4E00\u62EC\u524A\u9664",
        export: "\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
        setDefault: "\u30C7\u30D5\u30A9\u30EB\u30C8\u3068\u3057\u3066\u8A2D\u5B9A",
        create: "\u65B0\u898F\u8FFD\u52A0",
        fillin: "\u5165\u529B\u306B\u9032\u3080",
        reset: "\u30EA\u30BB\u30C3\u30C8",
        other: "\u305D\u306E\u4ED6",
        input: "\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        selectHint: "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
        uploadFile: "\u30D5\u30A1\u30A4\u30EB\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
        uploadForm: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
        steps: "\u64CD\u4F5C\u624B\u9806",
        import: "\u30A4\u30F3\u30DD\u30FC\u30C8\u78BA\u8A8D",
        download: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
        note: "\u5099\u8003",
        normalTip: "\u3054\u6CE8\u610F",
        scanatId: 'Scanat ID',
        startTime: "\u958B\u59CB\u65E5",
        endTime: "\u7D42\u4E86\u65E5",
        memberPermission: "\u30E1\u30F3\u30D0\u30FC\u53CA\u3073\u6A29\u9650",
        page: {
            total: "\u7DCF\u8A08{detail0}\u4EF6",
            first: "\u6700\u521D\u306E\u30DA\u30FC\u30B8",
            previous: "\u524D\u3078",
            next: "\u6B21\u3078",
            last: "\u6700\u7D42\u30DA\u30FC\u30B8",
            go: "{detail0}\u30DA\u30FC\u30B8\u76EE\u3078",
            perPage: "\u4EF6/\u30DA\u30FC\u30B8"
        }
    },
    mesh: {
        export: "\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
        download: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
        all: "\u5168\u30C7\u30FC\u30BF",
        tip: "\u30E2\u30C7\u30EB\u306E\u3059\u3079\u3066\u306E\u30C7\u30FC\u30BF\u3092\u5727\u7E2E\u3057\u3066\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u3059\u308B",
        default: "\u30E1\u30C3\u30B7\u30E5\u30C7\u30FC\u30BF",
        pointCloud: "\u70B9\u7FA4\u30C7\u30FC\u30BF",
        processing: "\u51E6\u7406\u4E2D",
        gltf: "Android\u7528",
        obj: "\u5FDC\u7528\u7BC4\u56F2\u304C\u5E83\u3044",
        stl: "3D\u30D7\u30EA\u30F3\u30BF\u30FC\u7528"
    },
    week: {
        mon: "\u6708",
        tue: "\u706B",
        wed: "\u6C34",
        thu: "\u6728",
        fri: "\u91D1",
        sat: "\u571F",
        sun: "\u65E5"
    },
    month: {
        jan: "1\u6708",
        feb: "2\u6708",
        mar: "3\u6708",
        apr: "4\u6708",
        may: "5\u6708",
        jun: "6\u6708",
        jul: "7\u6708",
        aug: "8\u6708",
        sep: "9\u6708",
        oct: "10\u6708",
        nov: "11\u6708",
        dec: "12\u6708"
    },
    login: {
        passwordWrong: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        accountUndefined: "\u30E6\u30FC\u30B6\u30FC\u540D\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
        verifiWrong: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
        verifiExpired: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002",
        loginVerifiSent: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u30E1\u30FC\u30EB\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002",
        verifiSend: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u518D\u5EA6\u9001\u4FE1",
        login: "\u30ED\u30B0\u30A4\u30F3",
        register: "\u767B\u9332 ",
        back: "\u30ED\u30B0\u30A4\u30F3\u306F\u3053\u3061\u3089",
        guideRegister: "\u65B0\u898F\u30A2\u30AB\u30A6\u30F3\u30C8\u767B\u9332\u306F\u3053\u3061\u3089",
        newAccount: "\u65B0\u898F\u30A2\u30AB\u30A6\u30F3\u30C8\u767B\u9332 ",
        email: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        password: "\u30D1\u30B9\u30EF\u30FC\u30C9",
        forgetPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306E\u65B9",
        emailError: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
        passwordTip: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306F10\u6587\u5B57\u4EE5\u4E0A50\u6587\u5B57\u4EE5\u4E0B\u3067\u3001\u534A\u89D2\u82F1\u5B57\u3068\u6570\u5B57\u3092\u305D\u308C\u305E\u308C1\u6587\u5B57\u4EE5\u4E0A\u542B\u3081\u3066\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        emailNone: "\u3053\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
        accountError: "\u30E6\u30FC\u30B6\u30FC\u540D\u3068\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        resetPasswordSent: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u518D\u8A2D\u5B9A\u3059\u308B\u305F\u3081\u306E\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002",
        verifiSent: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u30E1\u30FC\u30EB\u306B\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002",
        passwordConfirm: "\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u78BA\u8A8D",
        send: "\u9001\u4FE1 ",
        sent: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002",
        verify: "\u8A8D\u8A3C\u30B3\u30FC\u30C9",
        inputVerify: "\u30E1\u30FC\u30EB\u306B\u5C4A\u3044\u305F6\u6841\u306E\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        resetPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
        noEmpty: "\u3059\u3079\u3066\u306E\u5FC5\u9808\u9805\u76EE\u306B\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        verifyFormat: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306F6\u6841\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        verifyNumber: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306F6\u6841\u306E\u6570\u5B57\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        checkPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044",
        resetPasswordSuccess: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u518D\u8A2D\u5B9A\u3057\u307E\u3057\u305F\u3002",
        existUser: "\u3053\u306E\u30E6\u30FC\u30B6\u30FC\u306F\u65E2\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
        loginSuccess: "\u30ED\u30B0\u30A4\u30F3\u3057\u307E\u3057\u305F\u3002",
        registerSuccess: "\u767B\u9332\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002",
        logout: "\u30ED\u30B0\u30A2\u30A6\u30C8",
        terms: "<link>Scanat\u306E\u5229\u7528\u898F\u7D04</link> \u306B\u540C\u610F\u3057\u307E\u3059",
        termsError: "\u5229\u7528\u898F\u7D04\u306E\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u306E\u3046\u3048\u3001\u540C\u610F\u3044\u305F\u3060\u3051\u308B\u5834\u5408\u306E\u307F\u30C1\u30A7\u30C3\u30AF\u3057\u3066\u767B\u9332\u3092\u9032\u3081\u3066\u304F\u3060\u3055\u3044\u3002",
        alert: {
            title: "\u3054\u6CE8\u610F",
            info: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8\u7528\u306E\u30EA\u30F3\u30AF\u3092\u8A18\u8F09\u3057\u305F\u30E1\u30FC\u30EB\u3092\u304A\u9001\u308A\u3057\u307E\u3057\u305F\u3002"
        },
        invalid: {
            info: "\u3053\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8\u7528\u30EA\u30F3\u30AF\u306F\u7121\u52B9\u3067\u3059\u3002",
            tip: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8\u7528\u306E\u30EA\u30F3\u30AF\u3092\u3001\u3082\u3046\u4E00\u5EA6\u53D6\u5F97\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        },
        noExist: {
            info: "\u30EA\u30F3\u30AF\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
            tip: "\u30EA\u30F3\u30AF\u304C\u6B63\u3057\u3044\u304B\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"
        },
        go: "\u6B21\u3078",
        forgetPasswordToast: "\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u96C6\u4E2D\u3057\u3066\u3044\u307E\u3059\u30021\u5206\u5F8C\u306B\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
        introduction: "\u7A7A\u9593\u3092\u30C7\u30B8\u30BF\u30EB\u5316\u3059\u308B\u3001\u672A\u6765\u3092\u5275\u9020\u3059\u308B",
        verifyText: "\u8A8D\u8A3C\u30B3\u30FC\u30C9"
    },
    error: {
        connectionOut: "\u63A5\u7D9A\u304C\u30BF\u30A4\u30E0\u30A2\u30A6\u30C8\u3057\u307E\u3057\u305F\u3002\\n\n\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u63A5\u7D9A\u3092\u78BA\u8A8D\u3059\u308B\u304B\u3001\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        server: "\u30B5\u30FC\u30D0\u30FC\u304C\u904E\u8CA0\u8377\u72B6\u614B\u304B\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        connectionCheck: "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        invalidAccount: "\u8A72\u5F53\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u52B9\u3067\u3059\u3002\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
        contactManage: "\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
        noPlan: "\u30D7\u30E9\u30F3\u3092\u5951\u7D04\u3057\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u3053\u306E\u30B5\u30FC\u30D3\u30B9\u306F\u3054\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
        overDate: "\u3054\u5951\u7D04\u30D7\u30E9\u30F3{plan}\u306F{date}\u306B\u671F\u9650\u5207\u308C\u3068\u306A\u3063\u305F\u305F\u3081\u3001\u3053\u306E\u30B5\u30FC\u30D3\u30B9\u3092\u4F7F\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002",
        unactive: "\u3054\u5951\u7D04\u30D7\u30E9\u30F3{plan}\u306F{date}\u304B\u3089\u6709\u52B9\u306B\u306A\u308A\u307E\u3059\u3002\u30D7\u30E9\u30F3\u958B\u59CB\u5F8C\u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        needLevelUp: "\u5FA1\u793E\u306F\u73FE\u5728\u3001\u3053\u306E\u30B5\u30FC\u30D3\u30B9\u3092\u5229\u7528\u3059\u308B\u30D7\u30E9\u30F3\u306B\u3054\u52A0\u5165\u3044\u305F\u3060\u3044\u3066\u304A\u308A\u307E\u305B\u3093\u3002",
        noService: "\u5FA1\u793E\u306F\u73FE\u5728\u3001\u3053\u306E\u30B5\u30FC\u30D3\u30B9\u3092\u8CFC\u5165\u3055\u308C\u3066\u304A\u308A\u307E\u305B\u3093\u3002\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093\u3002",
        emptyName: "\u59D3\u307E\u305F\u306F\u540D\u306F\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        unsaveEdit: "\u7DE8\u96C6\u4E2D\u306E\u5185\u5BB9\u3092\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        overSeat: "ID\u6570\u306E\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F\u306E\u3067\u3001\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002\u4E00\u90E8\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3059\u308B\u304B\u3001ID\u6570\u306E\u8FFD\u52A0\u3092\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002",
        overSeatActivation: "ID\u6570\u306E\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F\u306E\u3067\u3001\u30E1\u30F3\u30D0\u30FC\u3092\u6709\u52B9\u5316\u3067\u304D\u307E\u305B\u3093\u3002\u4E00\u90E8\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3059\u308B\u304B\u3001ID\u6570\u306E\u8FFD\u52A0\u3092\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002",
        noSelectMember: "\u524A\u9664\u5BFE\u8C61\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u4E0B\u8A18\u304B\u3089\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        bestPlan: "\u73FE\u5728\u3054\u5951\u7D04\u4E2D\u306E\u30D7\u30E9\u30F3\u306F\u6700\u4E0A\u4F4D\u7248\u306E\u305F\u3081\u3001\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3067\u304D\u307E\u305B\u3093\u3002",
        noPermission: "\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
        emailEmpty: "{n}\u884C\u76EE\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u672A\u5165\u529B\u3067\u3059\u3002\u5165\u529B\u5F8C\u306B\u518D\u5EA6\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        nameExceed: "{n}\u884C\u76EE\u306E\u59D3\u307E\u305F\u306F\u540D\u306F10\u6587\u5B57\u3092\u8D85\u3048\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u4FEE\u6B63\u5F8C\u306B\u518D\u5EA6\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        importExceed: "\u4E00\u5EA6\u306B\u30A4\u30F3\u30DD\u30FC\u30C8\u3067\u304D\u308B\u30E1\u30F3\u30D0\u30FC\u306F100\u540D\u307E\u3067\u3067\u3059\u3002\u30D5\u30A1\u30A4\u30EB\u5185\u306E\u4E00\u90E8\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3057\u3066\u304B\u3089\u518D\u5EA6\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        comInfoAction: "\u4F1A\u793E\u60C5\u5831\u306E\u5165\u529B",
        comInfoModal: "\u4F1A\u793E\u60C5\u5831\u304C\u672A\u5B8C\u6210\u3067\u3059\u3002\u4F1A\u793E\u60C5\u5831\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        comInfoBuy: "\u4F1A\u793E\u60C5\u5831\u3092\u5148\u306B\u5165\u529B\u3057\u3066\u304B\u3089\u3001\u8CFC\u5165\u624B\u7D9A\u304D\u3092\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002",
        comInfoHome: "\u3054\u6CE8\u610F\uFF1A\u4F1A\u793E\u60C5\u5831\u304C\u672A\u5B8C\u6210\u306E\u5834\u5408\u3001\u4E00\u90E8\u306E\u6A5F\u80FD\u304C\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u306A\u3044\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
        usedAccount: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u3059\u3067\u306B\u4ED6\u306E\u4F1A\u793E\u306B\u767B\u9332\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002\u518D\u5EA6\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002",
        existCompany: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u65E2\u306B\u4F1A\u793E\u306B\u8FFD\u52A0\u6E08\u307F\u3067\u3059\u3002\u91CD\u8907\u3057\u3066\u8FFD\u52A0\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
        wrongEmail: "\u6B63\u3057\u3044\u90F5\u4FBF\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        unsavePage: "\u73FE\u5728\u306E\u30DA\u30FC\u30B8\u5185\u5BB9\u3092\u5148\u306B\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044",
        repetitiveMail: "\u8868\u306E\u4E2D\u306B\u91CD\u8907\u3059\u308B\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u3042\u308A\u307E\u3059\u3002\u78BA\u8A8D\u3057\u3066\u518D\u5EA6\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        otherMember: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9 {email}\u306F\u3059\u3067\u306B\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u518D\u5EA6\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        wrongFormat: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9 {email} \u306E\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002\u4FEE\u6B63\u3057\u3066\u518D\u5EA6\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        creditExpired: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002\u6709\u52B9\u671F\u9650\u3092\u3054\u78BA\u8A8D\u3044\u305F\u3060\u304F\u304B\u3001\u5225\u306E\u30AB\u30FC\u30C9\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044",
        agreement: "\u5229\u7528\u898F\u7D04\u306B\u540C\u610F\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        creditDisable: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u304C\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u518D\u5EA6\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002",
        payFailed: "\u652F\u6255\u3044\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u304C\u6B63\u5E38\u306B\u4F7F\u7528\u3067\u304D\u308B\u304B\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
        noAccess: "\u3053\u306E\u30DA\u30FC\u30B8\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093\u3002",
        code: {
            '403': "\u30A2\u30AF\u30BB\u30B9\u304C\u62D2\u5426\u3055\u308C\u307E\u3057\u305F",
            '404': "\u30DA\u30FC\u30B8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093",
            '500': "\u30B5\u30FC\u30D0\u30FC\u304C\u904E\u8CA0\u8377\u72B6\u614B\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            '502': "\u30B5\u30FC\u30D0\u30FC\u304C\u6DF7\u96D1\u3057\u3066\u3044\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            '504': "\u30B5\u30FC\u30D0\u30FC\u304C\u6DF7\u96D1\u3057\u3066\u3044\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        },
        oneDevice: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u4E0A\u306E\u7406\u7531\u3067\u3001Scanat Web\u3067\u306F\u8907\u6570\u7AEF\u672B\u304B\u3089\u306E\u540C\u6642\u30ED\u30B0\u30A4\u30F3\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u81EA\u52D5\u7684\u306B\u30ED\u30B0\u30A2\u30A6\u30C8\u3055\u308C\u307E\u3057\u305F\u3002\u518D\u5EA6\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        overDue: "\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F\u3002\u518D\u5EA6\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        checkNetWork: "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        timeOut: "\u63A5\u7D9A\u304C\u30BF\u30A4\u30E0\u30A2\u30A6\u30C8\u3057\u307E\u3057\u305F\u3002\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u63A5\u7D9A\u3092\u78BA\u8A8D\u3059\u308B\u304B\u3001\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u518D\u8A66\u884C\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        noCompanyInfo: "\u4F01\u696D\u60C5\u5831\u304C\u307E\u3060\u5165\u529B\u3057\u3066\u306A\u3044\u3067\u3059\u3002\u4F01\u696D\u60C5\u5831\u30E1\u30CB\u30E5\u30FC\u30D0\u30FC\u3067\u4F01\u696D\u60C5\u5831\u3092\u5B8C\u5168\u306B\u5165\u529B\u3057\u305F\u5F8C\u306B\u3001\u30D7\u30E9\u30F3\u306E\u8CFC\u5165\u304C\u53EF\u80FD\u3067\u3059\u3002",
        accountDisable: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u52B9\u5316\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093\u3002",
        noSeat: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u300CScanat\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u300D\u306E\u8A2D\u5B9A\u304C\u30AA\u30D5\u306E\u305F\u3081\u3001\u30A2\u30D7\u30EA\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002",
        noRight: "\u8A72\u5F53\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u306F\u3001\u3053\u306E\u30B5\u30FC\u30D3\u30B9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
        comInfoDomain: "\u4F1A\u793E\u60C5\u5831\u3092\u5165\u529B\u3057\u3066\u304B\u3089\u3001\u30C9\u30E1\u30A4\u30F3\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        accountNoAccess: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u7121\u52B9\u5316\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u30ED\u30B0\u30A4\u30F3\u3067\u304D\u307E\u305B\u3093\u3002",
        existName: "\u3053\u306E\u540D\u524D\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059\u3002\u5225\u306E\u540D\u524D\u306B\u5909\u66F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        nameTooLong: "\u30E2\u30C7\u30EB\u540D\u309220\u6587\u5B57\u4EE5\u5185\u3067\u5165\u529B\u3057\u3066\u304B\u3089\u518D\u5EA6\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        noModel: "\u30E2\u30C7\u30EB\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093\u3002"
    },
    complete: {
        save: "\u4FDD\u5B58\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        export: "\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        replace: "\u66F4\u65B0\u3057\u307E\u3057\u305F",
        setManagement: "\u7BA1\u7406\u8005\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        cancelSetManag: "\u7BA1\u7406\u8005\u306E\u89E3\u9664\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        card: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u304C\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F",
        cardUpdate: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F",
        cardDeleted: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F",
        importMember: "\u53D6\u308A\u8FBC\u307F\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        invoiceDown: "\u9818\u53CE\u66F8\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        diagramDown: "\u56F3\u9762\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        invoiceSent: "\u8ACB\u6C42\u66F8\u306E\u9001\u4FE1\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        add: "\u8FFD\u52A0\u3057\u307E\u3057\u305F",
        change: "\u7DE8\u96C6\u3057\u307E\u3057\u305F",
        delete: "\u524A\u9664\u3057\u307E\u3057\u305F",
        bought: "\u304A\u7533\u3057\u8FBC\u307F\u3044\u305F\u3060\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002"
    },
    landing: {
        select: "\u5229\u7528\u3059\u308B\u30B5\u30FC\u30D3\u30B9\u3092\u9078\u629E",
        idManage: "ID\u7BA1\u7406",
        scanatWeb: 'Scanat Web',
        pwChange: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u66F4\u65B0",
        logout: "\u30ED\u30B0\u30A2\u30A6\u30C8",
        tipId: "\xb7 \u30A2\u30AB\u30A6\u30F3\u30C8\u7BA1\u7406\n\uFF08\u30B9\u30C6\u30FC\u30BF\u30B9\u306E\u66F4\u65B0\u30FB\u7BA1\u7406\u6A29\u9650\u306E\u5207\u308A\u66FF\u3048\u7B49\uFF09\n\xb7 \u30D7\u30E9\u30F3\u306E\u8CFC\u5165\n\xb7 \u8ACB\u6C42\u66F8\u3068\u9818\u53CE\u66F8\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
        tipScanat: "\xb7 \u5168\u793E\u3068\u500B\u4EBA\u306E\u30AF\u30E9\u30A6\u30C9\u30C7\u30FC\u30BF\u7BA1\u7406\n\uFF08\u500B\u4EBA\u30D5\u30A9\u30EB\u30C0\u306E\u4F5C\u6210\u7B49\uFF09\n\xb7 PC\u30D6\u30E9\u30A6\u30B6\u3067\u306E\u30E2\u30C7\u30EB\u64CD\u4F5C\u3068\u8A08\u6E2C\u30C7\u30FC\u30BF\u7DE8\u96C6\n\xb7 \u793E\u5185\u30E6\u30FC\u30B6\u3068\u540C\u6642\u306B\u30E2\u30C7\u30EB\u306E\u95B2\u89A7\u3068\u8A08\u6E2C\u30C7\u30FC\u30BF\u7DE8\u96C6",
        alertNoPlan: "Scanat Web\u306F\u6CD5\u4EBA\u30D7\u30E9\u30F3\uFF08Plan B\u4EE5\u4E0A\uFF09\u306E\u30AA\u30D7\u30B7\u30E7\u30F3\u6A5F\u80FD\u3067\u3059\u3002 \u30A2\u30D7\u30EA\u3067\u30B9\u30AD\u30E3\u30F3\u3057\u305F\u30E2\u30C7\u30EB\u3092\u30D6\u30E9\u30A6\u30B6\u4E0A\u3067\u95B2\u89A7\u30FB\u64CD\u4F5C\u3067\u304D\u3001\u30E2\u30C7\u30EB\u30EA\u30F3\u30AF\u3092\u4F5C\u6210\u3057\u3066Scanat\u30E6\u30FC\u30B6\u4EE5\u5916\u306B\u3082\u5171\u6709\u3067\u304D\u308B\u4FBF\u5229\u306A\u6A5F\u80FD\u3067\u3059\u3002\n\n\u8A73\u7D30\u306F<link>\u304A\u554F\u3044\u5408\u308F\u305B\u30D5\u30A9\u30FC\u30E0</link>\u3001\u307E\u305F\u306F\u55B6\u696D\u62C5\u5F53\u307E\u3067\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
        invalidAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u52B9\u306E\u305F\u3081\u3001Scanat Web\u3092\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
        unnamed: "\u540D\u524D\u7A7A\u767D"
    },
    file: {
        allFile: "\u30DB\u30FC\u30E0\u30EA\u30B9\u30C8",
        sample: "\u30B5\u30F3\u30D7\u30EB\u30E2\u30C7\u30EB",
        modelAmount: "\u30E2\u30C7\u30EB\u6570",
        newFolder: "\u65B0\u898F\u30D5\u30A9\u30EB\u30C0",
        fileName: "\u30D5\u30A1\u30A4\u30EB\u540D\n",
        owner: "\u6240\u6709\u8005",
        time: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u65E5\u6642",
        createTime: "\u4F5C\u6210\u65E5\u6642",
        scanner: "\u64AE\u5F71\u8005",
        scanTime: "\u64AE\u5F71\u65E5\u6642",
        editor: "\u6700\u7D42\u66F4\u65B0\u8005",
        updateTime: "\u66F4\u65B0\u65E5\u6642",
        dataSize: "\u30C7\u30FC\u30BF\u5BB9\u91CF",
        folder: "\u30D5\u30A9\u30EB\u30C0",
        fileAmount: "{n} \u9805\u76EE\u306E\u30E2\u30C7\u30EB",
        shareString: "{ID} \u3088\u308A {time} \u306B\u5171\u6709",
        createString: "{time} \u306B\u4F5C\u6210\n",
        uploadString: "{time} \u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
        updateString: "{time} \u306B\u66F4\u65B0",
        editorString: "{ID} \u3088\u308A{time} \u306B\u66F4\u65B0",
        filter: "\u7D5E\u308A\u8FBC\u307F",
        sort: "\u4E26\u3079\u66FF\u3048",
        restore: "\u30EA\u30BB\u30C3\u30C8",
        all: "\u3059\u3079\u3066",
        filterStatus: "\u30E2\u30C7\u30EB\u72B6\u614B",
        filterCad: "CAD\u56F3\u9762\u4F9D\u983C\u6E08\u307F",
        filterMark: "\u30D4\u30F3\u306E\u72B6\u614B",
        filterMarked: "\u30D4\u30F3\u3042\u308A",
        fiterOwner: "\u6240\u6709\u8005",
        filterSelfOwner: "\u81EA\u5206",
        filterShared: "\u5171\u6709\u3055\u308C\u305F\u3082\u306E",
        updateNewest: "\u66F4\u65B0\u306E\u65B0\u3057\u3044\u9806",
        createNewest: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9/\u4F5C\u6210\u306E\u65B0\u3057\u3044\u9806",
        searchHint: "\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u5165\u529B",
        pagePre: "\u524D\u3078",
        pageNext: "\u6B21\u3078",
        pageFirst: "\u6700\u521D\u3078",
        pageLast: "\u6700\u5F8C\u3078",
        operate: "\u64CD\u4F5C",
        share: "\u5171\u6709",
        selectAll: "\u3059\u3079\u3066\u9078\u629E",
        rename: "\u540D\u524D\u306E\u5909\u66F4",
        moveTo: "\u30D5\u30A9\u30EB\u30C0\u306B\u79FB\u52D5",
        tipSample: "\u307E\u3060\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30E2\u30C7\u30EB\u30C7\u30FC\u30BF\u306F\u3042\u308A\u307E\u305B\u3093\u3002Scanat\u30A2\u30D7\u30EA\u304B\u3089\u30E2\u30C7\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3059\u308B\u304B\u3001\u30B5\u30F3\u30D7\u30EB\u30E2\u30C7\u30EB\u3092\u958B\u304D\u3001\u5B9F\u969B\u306E\u64CD\u4F5C\u611F\u3092\u304A\u78BA\u304B\u3081\u304F\u3060\u3055\u3044\u3002",
        btnSample: "\u30B5\u30F3\u30D7\u30EB\u30E2\u30C7\u30EB\u3092\u958B\u304F",
        noFile: "\u3053\u306E\u30D5\u30A9\u30EB\u30C0\u306B\u306F\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
        noResult: "\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3059\u308B\u304B\u3001\u5165\u529B\u5185\u5BB9\u3092\u78BA\u8A8D\u3059\u308B\u304B\u3001\u30D5\u30A3\u30EB\u30BF\u30FC\u8A2D\u5B9A\u3092\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        noResultTitle: "\u4F55\u3082\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
        noSearchResult: "\u30AD\u30FC\u30EF\u30FC\u30C9\u306E\u5909\u66F4\u3001\u5165\u529B\u30DF\u30B9\u306E\u30C1\u30A7\u30C3\u30AF\u3001\u307E\u305F\u306F\u30D5\u30A3\u30EB\u30BF\u30FC\u306E\u8ABF\u6574\u3092\u8A66\u3057\u3066\u307F\u308B\u3053\u3068\u3092\u304A\u3059\u3059\u3081\u3057\u307E\u3059\u3002",
        id: {
            log: "\u9867\u5BA2\u64CD\u4F5C\u30ED\u30B0",
            logCompany: "{company}\u64CD\u4F5C\u30ED\u30B0",
            transactionFiles: "\u8A3C\u6191\u66F8\u985E{number}",
            memberList: "\u30E1\u30F3\u30D0\u30FC\u30EA\u30B9\u30C8{YYYYMMDD}",
            planOrderList: "\u30D7\u30E9\u30F3\u6CE8\u6587\u30EA\u30B9\u30C8{YYYYMMDD}",
            cadOrderList: "CAD\u6CE8\u6587\u30EA\u30B9\u30C8{YYYYMMDD}",
            customerInformationList: "\u9867\u5BA2\u60C5\u5831\u30EA\u30B9\u30C8{YYYYMMDD}",
            companyMemberList: "{company}\u30E1\u30F3\u30D0\u30FC\u30EA\u30B9\u30C8{YYYYMMDD}",
            accountList: "\u30A2\u30AB\u30A6\u30F3\u30C8\u30EA\u30B9\u30C8{YYYYMMDD}",
            userBatchImportTemplate: "\u30E6\u30FC\u30B6\u30FC\u4E00\u62EC\u30A4\u30F3\u30DD\u30FC\u30C8\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8",
            invoice: "\u8ACB\u6C42\u66F8{number}"
        },
        code: {
            get: "\u57CB\u3081\u8FBC\u307F\u30B3\u30FC\u30C9\u3092\u53D6\u5F97",
            mode: "\u8AAD\u307F\u8FBC\u307F\u65B9\u6CD5",
            manual: "\u624B\u52D5\u8AAD\u307F\u8FBC\u307F",
            auto: "\u81EA\u52D5\u8AAD\u307F\u8FBC\u307F",
            copy: "\u57CB\u3081\u8FBC\u307F\u30B3\u30FC\u30C9\u3092\u30B3\u30D4\u30FC",
            language: "\u8868\u793A\u8A00\u8A9E",
            copySuccess: "\u30B3\u30FC\u30C9\u304C\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002"
        },
        delete: {
            title: "\u3053\u306E\u30E2\u30C7\u30EB\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F",
            prompt: "\u524A\u9664\u5F8C\u3001\u30E2\u30C7\u30EB\u306E\u6A29\u9650\u3092\u6301\u3063\u3066\u3044\u308B\u30E1\u30F3\u30D0\u30FC\u306F\u3001\u3053\u308C\u3089\u306E\u30E2\u30C7\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
            noAuth: "\u524A\u9664\u6A29\u9650\u304C\u306A\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u542B\u307F\u307E\u3059\u3002\u9078\u629E\u3057\u76F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        },
        deleteFolder: {
            title: "\u3053\u306E\u30D5\u30A9\u30EB\u30C0\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F",
            prompt: "\u524A\u9664\u5F8C\u306F\u3001\u3042\u306A\u305F\u3068\u4ED6\u306E\u30E1\u30F3\u30D0\u30FC\u306F\u9078\u629E\u3057\u305F\u30D5\u30A9\u30EB\u30C0\u5185\u306E\u30E2\u30C7\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002"
        },
        mark: {
            cancledToast: "\u30D4\u30F3\u306A\u3057",
            markedToast: "\u30D4\u30F3\u3042\u308A"
        },
        copy: "\u30B3\u30D4\u30FC",
        import: {
            button: "\u30E2\u30C7\u30EB\u30A4\u30F3\u30DD\u30FC\u30C8",
            title: "\u30E2\u30C7\u30EB\u30A4\u30F3\u30DD\u30FC\u30C8",
            tip1: "3D\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u307E\u305F\u306F\u3053\u3053\u306B\u30C9\u30ED\u30C3\u30D7\u3057\u3066\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            tip2: "\u5BFE\u5FDC\u5F62\u5F0F",
            tip3: "\u6700\u5927500MB\u307E\u3067\u3001\u30C6\u30AF\u30B9\u30C1\u30E3\u3092\u542B\u3080\u5834\u5408\u306F\u3001ZIP\u5F62\u5F0F\u3067\u5727\u7E2E\u306E\u4E0A\u3001\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            select: "\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E",
            reSelect: "\u30D5\u30A1\u30A4\u30EB\u3092\u518D\u9078\u629E",
            release: "\u30C9\u30ED\u30C3\u30D7\u3057\u3066\u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8",
            refresh: "\u30A4\u30F3\u30DD\u30FC\u30C8\u4E2D\u3067\u3059\u3002\u30DA\u30FC\u30B8\u3092\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u305F\u308A\u9589\u3058\u305F\u308A\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002\u4E2D\u65AD\u3059\u308B\u3068\u30A4\u30F3\u30DD\u30FC\u30C8\u304C\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
            fail: "\u30A4\u30F3\u30DD\u30FC\u30C8\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u518D\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            prompt: "\u30A4\u30F3\u30DD\u30FC\u30C8\u4E2D\u3067\u3059\u3002\u30DA\u30FC\u30B8\u3092\u518D\u8AAD\u307F\u8FBC\u307F\u3059\u308B\u3068\u30A4\u30F3\u30DD\u30FC\u30C8\u304C\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u304C\u3001\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
            error: {
                checkNet: "\u30A4\u30F3\u30DD\u30FC\u30C8\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u78BA\u8A8D\u3057\u3066\u304B\u3089\u518D\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                parsingFailed: "\u30E2\u30C7\u30EB\u306E\u89E3\u6790\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30D5\u30A1\u30A4\u30EB\u3092\u78BA\u8A8D\u3057\u3066\u304B\u3089\u518D\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                system: "\u51E6\u7406\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u66AB\u304F\u3057\u3066\u304B\u3089\u518D\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
                invalidFile: "ZIP\u30D5\u30A1\u30A4\u30EB\u5185\u306B\u6709\u52B9\u306A\u30E2\u30C7\u30EB\u30C7\u30FC\u30BF\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30D5\u30A1\u30A4\u30EB\u3092\u78BA\u8A8D\u3057\u3066\u304B\u3089\u518D\u5EA6\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
            }
        },
        itemsPerPage: "\u8868\u793A\u4EF6\u6570",
        teamSpace: "\u30C1\u30FC\u30E0\u30B9\u30DA\u30FC\u30B9",
        mySpace: "\u500B\u4EBA\u30B9\u30DA\u30FC\u30B9",
        editFolder: "\u30D5\u30A9\u30EB\u30C0\u3092\u7DE8\u96C6",
        folderName: "\u30D5\u30A9\u30EB\u30C0\u540D",
        folderNameHint: "\u30D5\u30A9\u30EB\u30C0\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        folderDesc: "\u5099\u8003",
        folderDescHint: "\u5099\u8003\u304C\u3042\u308C\u3070\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        folderEmptyDesc: "\u5099\u8003\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
        editModel: "\u30E2\u30C7\u30EB\u540D\u3092\u5909\u66F4",
        modelName: "\u30E2\u30C7\u30EB\u540D",
        modelNameHint: "\u30E2\u30C7\u30EB\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        sortBy: {
            updateTimeDescending: "\u66F4\u65B0\u65E5\u6642\uFF08\u964D\u9806\uFF09",
            updateTimeAscending: "\u66F4\u65B0\u65E5\u6642\uFF08\u6607\u9806\uFF09",
            createTimeDescending: "\u4F5C\u6210\u65E5\u6642\uFF08\u964D\u9806\uFF09",
            createTimeAscending: "\u4F5C\u6210\u65E5\u6642\uFF08\u6607\u9806\uFF09",
            firstletterDescending: "\u540D\u524D\uFF08A \u2192 Z\uFF09",
            sizeDesc: "\u30B5\u30A4\u30BA\uFF08\u964D\u9806\uFF09",
            sizeAsc: "\u30B5\u30A4\u30BA\uFF08\u6607\u9806\uFF09"
        },
        creator: "\u4F5C\u6210\u8005",
        createOrUploadTime: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u65E5",
        noFound: {
            text: "\u300C{0}\u300D\u306E\u30D5\u30A9\u30EB\u30C0\u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u5225\u306E\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        },
        move: {
            noAuth: "\u79FB\u52D5\u6A29\u9650\u304C\u306A\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u542B\u307F\u307E\u3059\u3002\u9078\u629E\u3057\u76F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        },
        modelNum: "{n} \u4EF6\u306E\u30E2\u30C7\u30EB"
    },
    filemodal: {
        deletAll: "\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F\n",
        selectMove: "\u79FB\u52D5\u5148\u3092\u9078\u629E",
        move: "\u78BA\u8A8D",
        noData: "\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
        share: "Web\u7528\u30EA\u30F3\u30AF\u306E\u5171\u6709",
        copyLink: "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
        copySuccess: "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002",
        shareTip: "1. Scanat Web\u306E\u6A29\u9650\u304C\u3042\u308B\u30E6\u30FC\u30B6\uFF1A\u30E2\u30C7\u30EB\u3092\u95B2\u89A7\u304A\u3088\u3073\u7DE8\u96C6\u3067\u304D\u307E\u3059\u3002\u5909\u66F4\u306F\u5171\u6709\u5143\u30E2\u30C7\u30EB\u306B\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u3067\u540C\u671F\u3055\u308C\u307E\u3059\u3002\\n\n2. Scanat Web\u306E\u6A29\u9650\u304C\u306A\u3044\u30E6\u30FC\u30B6\uFF1A\u30E2\u30C7\u30EB\u3092\u95B2\u89A7\u304A\u3088\u3073\u7DE8\u96C6\u3067\u304D\u307E\u3059\u304C\u3001\u5909\u66F4\u306F\u5171\u6709\u5143\u30E2\u30C7\u30EB\u306B\u306F\u9069\u7528\u307E\u305F\u306F\u4FDD\u5B58\u3055\u308C\u307E\u305B\u3093\u3002",
        moveSuccess: "\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002",
        folderSuccess: "\u30D5\u30A9\u30EB\u30C0\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002",
        changeSuccess: "\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
        noSpecialSymbol: "\u7279\u6B8A\u6587\u5B57\u306F\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u3002",
        resetLink: "\u30EA\u30F3\u30AF\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3059\u304B\uFF1F \u30EA\u30BB\u30C3\u30C8\u3059\u308B\u3068\u3001\u73FE\u5728\u306E\u30EA\u30F3\u30AF\u306F\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
        moveFileTitle: "\u30D5\u30A1\u30A4\u30EB\u3092\u79FB\u52D5",
        moveFolderTitle: "\u30D5\u30A9\u30EB\u30C0\u3092\u79FB\u52D5",
        moveModelTitle: "\u30E2\u30C7\u30EB\u3092\u79FB\u52D5",
        sharePromptOld: " 1. ScanatWeb\u6A29\u9650\u3092\u304A\u6301\u3061\u306E\u65B9\uFF1A\u540C\u6642\u306B\u30E2\u30C7\u30EB\u306E\u95B2\u89A7\u3068\u7DE8\u96C6\u304C\u53EF\u80FD\n 2. ScanatWeb\u6A29\u9650\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u65B9\uFF1A\u30E2\u30C7\u30EB\u306E\u95B2\u89A7\u306F\u53EF\u80FD\u3060\u304C\u3001\u540C\u6642\u7DE8\u96C6\u306F\u4E0D\u53EF ",
        moveFileDesc: "\u79FB\u52D5\u3055\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u306F\u5B9B\u5148\u30D5\u30A9\u30EB\u30C0\u306E\u6A29\u9650\u8A2D\u5B9A\u306B\u5F93\u3044\u307E\u3059\u3002\u307E\u305F\u73FE\u5728\u306E\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u304C\u30D5\u30A1\u30A4\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002",
        moveFolderDesc: "\u79FB\u52D5\u3055\u308C\u305F\u30D5\u30A9\u30EB\u30C0\u306F\u5B9B\u5148\u30D5\u30A9\u30EB\u30C0\u306E\u6A29\u9650\u8A2D\u5B9A\u306B\u5F93\u3044\u307E\u3059\u3002\u307E\u305F\u73FE\u5728\u306E\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u304C\u30D5\u30A9\u30EB\u30C0\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002",
        moveModelDesc: "\u79FB\u52D5\u3055\u308C\u305F\u30E2\u30C7\u30EB\u306F\u5B9B\u5148\u30D5\u30A9\u30EB\u30C0\u306E\u6A29\u9650\u8A2D\u5B9A\u306B\u5F93\u3044\u307E\u3059\u3002\u307E\u305F\u73FE\u5728\u306E\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u304C\u30E2\u30C7\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u306A\u304F\u306A\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002",
        deleteComfirm: "\u524A\u9664\u5F8C\u306F\u5FA9\u5143\u3067\u304D\u307E\u305B\u3093\u3002\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F",
        cannotEdit: "\u3053\u306E\u30D5\u30A1\u30A4\u30EB\u306F\u524A\u9664\u6E08\u307F\u306E\u305F\u3081\u3001\u7DE8\u96C6\u3067\u304D\u307E\u305B\u3093\u3002",
        cannotAccess: "\u3053\u306E\u30D5\u30A1\u30A4\u30EB\u306F\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093\u3002"
    },
    toast: {
        noMovePermission: "\u5B9B\u5148\u30D5\u30A9\u30EB\u30C0\u3078\u306E\u79FB\u52D5\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u4ED6\u306E\u5B9B\u5148\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        exist: "\u65E2\u306B\u5B9B\u5148\u306B\u5B58\u5728\u3057\u307E\u3059\u3002",
        cannotMove: "\u3053\u306E\u30D5\u30A9\u30EB\u30C0\u3084\u30B5\u30D6\u30D5\u30A9\u30EB\u30C0\u3078\u306E\u79FB\u52D5\u304C\u3067\u304D\u307E\u305B\u3093\u3002",
        depth: {
            exceed: "\u30D5\u30A9\u30EB\u30C0\u968E\u5C64\u306E\u4E0A\u9650\u3092\u8D85\u3048\u3066\u3044\u307E\u3059\u3002\u5225\u306E\u30D5\u30A9\u30EB\u30C0\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        }
    },
    share: {
        accountShare: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3067\u5171\u6709",
        linkShare: "\u30EA\u30F3\u30AF\u3067\u5171\u6709",
        searchHint: "\u9023\u7D61\u5148\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5165\u529B\u3057\u3066\u691C\u7D22",
        searchEmpty: "\u8A72\u5F53\u3059\u308B\u9023\u7D61\u5148\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\n\u4ED6\u306E\u30AD\u30FC\u30EF\u30FC\u30C9\u3067\u691C\u7D22\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        people_amount: "{n}\u4EBA",
        read: "\u95B2\u89A7\u306E\u307F",
        edit: "\u7DE8\u96C6\u53EF\u80FD",
        manage: "\u7BA1\u7406\u53EF\u80FD",
        resetLink: "\u30EA\u30F3\u30AF\u3092\u30EA\u30BB\u30C3\u30C8",
        overwritePw: "\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u4E0A\u66F8\u304D",
        limits: "\u6A29\u9650",
        unSaveTip: "\u5148\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u4FDD\u5B58\u307E\u305F\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u3066\u304F\u3060\u3055\u3044",
        title: {
            privateLink: "\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30EA\u30F3\u30AF",
            encryptedLink: "\u30D1\u30B9\u30EF\u30FC\u30C9\u4ED8\u304D\u30EA\u30F3\u30AF",
            publicLink: "\u516C\u958B\u30EA\u30F3\u30AF",
            changeLinkPassword: "\u30EA\u30F3\u30AF\u30D1\u30B9\u30EF\u30FC\u30C9\u306E\u5909\u66F4"
        },
        desc: {
            privateLink: "\u30FB\u30C1\u30FC\u30E0\u30E1\u30F3\u30D0\u30FC\u306E\u307F\u30A2\u30AF\u30BB\u30B9\u53EF\u80FD",
            encryptedLink: "\u30FB\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u77E5\u3063\u3066\u3044\u308B\u4EBA\u304C\u30A2\u30AF\u30BB\u30B9\u53EF\u80FD",
            publicLink: "\u30FB\u8AB0\u3067\u3082\u30A2\u30AF\u30BB\u30B9\u53EF\u80FD"
        },
        hint: {
            changeLinkPassword: "4\u301C20\u6587\u5B57\u306E\u6570\u5B57\u307E\u305F\u306F\u30A2\u30EB\u30D5\u30A1\u30D9\u30C3\u30C8\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        },
        toast: {
            changeModeSuccess: "\u6A29\u9650\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002",
            noPermission: "\u30E2\u30C7\u30EB\u306E\u6240\u6709\u8005\u3068\u7BA1\u7406\u8005\u306E\u307F\u5909\u66F4\u53EF\u80FD\u3067\u3059\u3002",
            save: "\u5148\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u4FDD\u5B58\u307E\u305F\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            noPermissionNew: "\u30E2\u30C7\u30EB\u306E\u7DE8\u96C6\u6A29\u9650\u3001\u53C8\u306F\u7BA1\u7406\u6A29\u9650\u304C\u5FC5\u8981\u3067\u3059\u3002"
        },
        alert: {
            title: {
                changeToPublic: "\u3054\u6CE8\u610F"
            },
            info: {
                changeToPublic: "\u3053\u306E\u6A5F\u80FD\u3092\u6709\u52B9\u306B\u3059\u308B\u3068\u3001\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u4E0A\u3067\u30EA\u30F3\u30AF\u3092\u77E5\u3063\u3066\u3044\u308B\u4EBA\u306A\u3089\u8AB0\u3067\u3082\u30E2\u30C7\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u3059\u3002"
            }
        },
        copy: "Web\u7528\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002\u5165\u529B\u30DC\u30C3\u30AF\u30B9\u306B\u8CBC\u308A\u4ED8\u3051\u3066\u4ED6\u306E\u4EBA\u306B\u5171\u6709\u3067\u304D\u307E\u3059\u3002",
        link1: '{detail0}',
        link2: "Scanat\u306E\u30E2\u30C7\u30EB\u30EA\u30F3\u30AF\uFF1A{detail0}\n\u30D1\u30B9\u30EF\u30FC\u30C9\uFF1A{detail1}",
        copyLink: "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
        modelNotFound: "\u30E2\u30C7\u30EB\u300C{modelName}\u300D\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
        link: {
            noModel: "\u30E2\u30C7\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
            noModelTip: "\u30EA\u30F3\u30AF\u304C\u6B63\u3057\u3044\u304B\u3001\u518D\u5EA6\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"
        },
        privateLink: {
            linkFail: "\u30EA\u30F3\u30AF\u304C\u7121\u52B9\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
            tip: "\u73FE\u5728\u30ED\u30B0\u30A4\u30F3\u4E2D\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F \u300C{id}\u300D\u3067\u3059\u3002\u65B0\u3057\u3044\u30EA\u30F3\u30AF\u3092\u53D6\u5F97\u3059\u308B\u306B\u306F\u300C{admin_id}\u300D \u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
            contactManage: "\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
            limitPermission: "\u73FE\u5728\u30ED\u30B0\u30A4\u30F3\u4E2D\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F \u300C{id}\u300D\u3067\u3001\u30E2\u30C7\u30EB\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002"
        },
        encryptedLink: {
            needPassword: "\u3053\u306E\u30E2\u30C7\u30EB\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u306B\u306F\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u5FC5\u8981\u3067\u3059\u3002",
            errorPassword: "\u6B63\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
            go: "\u6B21\u3078",
            placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        }
    },
    member: {
        searchHint: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5165\u529B\u3057\u3066\u691C\u7D22",
        searchEmpty: "\u8A72\u5F53\u30E1\u30F3\u30D0\u30FC\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u5225\u306E\u30AD\u30FC\u30EF\u30FC\u30C9\u3067\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        addMember: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0",
        owner: "\u6240\u6709\u8005",
        admin: "\u30B9\u30FC\u30D1\u30FC\u7BA1\u7406\u8005",
        outsider: "\u793E\u5916\u30E1\u30F3\u30D0\u30FC"
    },
    import: {
        model: "\u30E2\u30C7\u30EB\u30A4\u30F3\u30DD\u30FC\u30C8",
        fail: "\u30A4\u30F3\u30DD\u30FC\u30C8\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
        reimport: "\u30E2\u30C7\u30EB\u3092\u518D\u30A4\u30F3\u30DD\u30FC\u30C8",
        importGuide: "3D\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u307E\u305F\u306F\u3053\u3053\u306B\u30C9\u30ED\u30C3\u30D7\u3057\u3066\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        importFormat: "\u5BFE\u5FDC\u5F62\u5F0F\uFF1AOBJ/GLTF/GLB/DRC/STL/PLY/DAE/FBX/SKP/USDZ/DXF/ZIP\n\u30C6\u30AF\u30B9\u30C1\u30E3\u3092\u542B\u3080\u5834\u5408\u306F\u3001ZIP\u5F62\u5F0F\u3067\u5727\u7E2E\u306E\u4E0A\u3001\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        releaseMouse: "\u30C9\u30ED\u30C3\u30D7\u3057\u3066\u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8",
        localFile: "\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E",
        reSelect: "\u30D5\u30A1\u30A4\u30EB\u3092\u518D\u9078\u629E",
        wrongFormat: "\u9078\u629E\u3055\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u306F\u5BFE\u5FDC\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u5225\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        fileSizeLimit: "\u30D5\u30A1\u30A4\u30EB\u30B5\u30A4\u30BA\u304C\u4E0A\u9650\u3092\u8D85\u3048\u3066\u3044\u307E\u3059\u3002"
    },
    language: {
        ja: "\u65E5\u672C\u8A9E",
        en: 'English',
        cn: "\u7B80\u4F53\u4E2D\u6587"
    },
    profile: {
        basic: "\u57FA\u672C\u60C5\u5831",
        account: "\u30A2\u30AB\u30A6\u30F3\u30C8",
        name: "\u6C0F\u540D",
        company: "\u6240\u5C5E\u4F1A\u793E",
        superManage: "\u30B9\u30FC\u30D1\u30FC\u7BA1\u7406\u8005",
        manage: "\u7BA1\u7406\u8005",
        member: "\u901A\u5E38\u30E1\u30F3\u30D0\u30FC",
        deregisterAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664",
        deregisterTip: "1.\u3042\u306A\u305F\u306E\u500B\u4EBA\u60C5\u5831\u3084\u5C65\u6B74\u306F\u5FA9\u5143\u3067\u304D\u307E\u305B\u3093\u3002\\n\n2. \u3059\u3079\u3066\u306E\u30E2\u30C7\u30EB\u8A18\u9332\u3084\u53D6\u5F15\u8A18\u9332\u306F\u524A\u9664\u3055\u308C\u3001\u5FA9\u5143\u3067\u304D\u307E\u305B\u3093\u3002\\n\n3. \u3042\u306A\u305F\u304C\u30B9\u30FC\u30D1\u30FC\u7BA1\u7406\u8005\u3067\u3001\u307E\u3060\u524A\u9664\u3055\u308C\u3066\u3044\u306A\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u30C1\u30FC\u30E0\u306B\u5B58\u5728\u3059\u308B\u5834\u5408\u3001\u30ED\u30B0\u30A2\u30A6\u30C8\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
        deregisterWarningCo: "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u3059\u308B\u3068\u3001\u4F01\u696D\u306E\u3059\u3079\u3066\u306E\u30E2\u30C7\u30EB\u8A18\u9332\u304C\u524A\u9664\u3055\u308C\u3001\u5FA9\u5143\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
        deregisterWarningUser: "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u3059\u308B\u3068\u3001\u3042\u306A\u305F\u306E\u3059\u3079\u3066\u306E\u30E2\u30C7\u30EB\u8A18\u9332\u304C\u524A\u9664\u3055\u308C\u3001\u5FA9\u5143\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
        deregisterConfirm: "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u306E\u78BA\u8A8D",
        deregisterfail1: "\u30C1\u30FC\u30E0\u306B\u306F\u307E\u3060",
        deregisterfail2: "\u30A2\u30AB\u30A6\u30F3\u30C8",
        deregisterfail3: "\u304C\u4F7F\u7528\u3057\u3066\u307E\u3059\u3002\u62DB\u5F85\u72B6\u306E\u7BA1\u7406\u30DA\u30FC\u30B8\u306B\u79FB\u52D5\u3057\u3066\u3001\u8A72\u5F53\u3059\u308B\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3057\u3066\u304B\u3089\u518D\u5EA6\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        deregisterComplete: "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        continue: "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u3092\u7D9A\u3051\u308B",
        manageAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u7BA1\u7406\u3059\u308B"
    },
    company: {
        setting: "\u4F1A\u793E\u60C5\u5831",
        basic: "\u57FA\u672C\u60C5\u5831",
        expand: "\u62E1\u5F35\u60C5\u5831",
        name: "\u4F1A\u793E\u540D",
        nameInput: "\u4F1A\u793E\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        owner: "\u4E3B\u62C5\u5F53\u8005",
        ownerNameTitle: "\u6C0F\u540D",
        ownerGenderTitle: "\u6027\u5225",
        ownerPhoneTitle: "\u96FB\u8A71\u756A\u53F7",
        ownerLastname: "\u59D3",
        ownerName: "\u540D",
        ownerSexual: "\u6027\u5225",
        ownerMale: "\u7537",
        ownerFemale: "\u5973",
        numberInput: "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        zipcode: "\u90F5\u4FBF\u756A\u53F7",
        zipcodeInput: "\u90F5\u4FBF\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        address: "\u4F4F\u6240",
        addressProvince: "\u90FD\u9053\u5E9C\u770C",
        addressCity: "\u5E02\u533A\u753A\u6751",
        addressDistrict: "\u753A\u540D\u756A\u5730",
        addressDetails: "\u305D\u308C\u4EE5\u964D\u306E\u4F4F\u6240",
        industry: "\u6240\u5C5E\u696D\u7A2E",
        industrySelect: "\u6240\u5C5E\u696D\u7A2E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
        industryArchi: "\u5EFA\u8A2D\u696D",
        industryManu: "\u88FD\u9020\u696D",
        industryEstate: "\u4E0D\u52D5\u7523\u696D\uFF0C\u7269\u54C1\u8CC3\u8CB8\u696D",
        industryTel: "\u60C5\u5831\u901A\u4FE1\u696D",
        industryElectric: "\u96FB\u6C17\u30FB\u30AC\u30B9\u30FB\u71B1\u4F9B\u7D66\u30FB\u6C34\u9053\u696D",
        industryTrans: "\u904B\u8F38\u696D\uFF0C\u90F5\u4FBF\u696D",
        industryInfo: "\u60C5\u5831\u51E6\u7406\u30B5\u30FC\u30D3\u30B9\u696D",
        industryStudy: "\u5B66\u8853\u7814\u7A76\uFF0C\u5C02\u9580\u30FB\u6280\u8853\u30B5\u30FC\u30D3\u30B9\u696D",
        industryRetail: "\u5378\u58F2\u696D\uFF0C\u5C0F\u58F2\u696D",
        industryResearch: "\u30EA\u30B5\u30FC\u30C1\u696D",
        scale: "\u5F93\u696D\u54E1\u6570",
        scaleSmall: "50\u540D\u4EE5\u4E0B",
        scaleMedium: "50-100\u540D",
        scaleLarge: "100\u540D\u4EE5\u4E0A",
        scaleSelect: "\u5F93\u696D\u54E1\u6570\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
        capital: "\u8CC7\u672C\u91D1",
        capitalInput: "\u8CC7\u672C\u91D1\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        capitalUnit: "\u5186",
        service: "\u4E8B\u696D\u5185\u5BB9",
        serviceInput: "\u4E8B\u696D\u5185\u5BB9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        domainManage: "\u30C9\u30E1\u30A4\u30F3\u7BA1\u7406",
        domainList: "\u30C9\u30E1\u30A4\u30F3\u4E00\u89A7",
        domainDesc: "Scanat Web\u3067\u306F\u3001\u30E2\u30C7\u30EB\u8A73\u7D30\u753B\u9762\u3092\u5916\u90E8\u30B5\u30A4\u30C8\u306B\u57CB\u3081\u8FBC\u3080\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3053\u3053\u3067\u5916\u90E8\u30B5\u30A4\u30C8\u306E\u30C9\u30E1\u30A4\u30F3\u3092\u8FFD\u52A0\u3059\u308B\u3068\u3001\u57CB\u3081\u8FBC\u307F\u30B3\u30FC\u30C9\u306F\u767B\u9332\u3057\u305F\u30C9\u30E1\u30A4\u30F3\u3067\u306E\u307F\u6709\u52B9\u306B\u306A\u308A\u307E\u3059\u3002\u6700\u592710\u500B\u306E\u30C9\u30E1\u30A4\u30F3\u3092\u767B\u9332\u3067\u304D\u307E\u3059\u3002",
        domain: "\u30C9\u30E1\u30A4\u30F3",
        addDomain: "\u30C9\u30E1\u30A4\u30F3\u306E\u8FFD\u52A0",
        editDomain: "\u30C9\u30E1\u30A4\u30F3\u306E\u7DE8\u96C6",
        deleteDomain: "\u30C9\u30E1\u30A4\u30F3\u306E\u524A\u9664",
        inputDomain: "\u30C9\u30E1\u30A4\u30F3\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        domainError: "\u6709\u52B9\u306A\u30C9\u30E1\u30A4\u30F3\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        deleteDomainTip: "\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F\u524A\u9664\u3059\u308B\u3068\u3001\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u3067\u30E2\u30C7\u30EB\u57CB\u3081\u8FBC\u307F\u30B3\u30FC\u30C9\u304C\u4F7F\u7528\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
        inputCorrectPhone: "\u6709\u52B9\u306A\u96FB\u8A71\u756A\u53F7\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044",
        inputNumber: "\u6570\u5024\u3092\u3054\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        domainIframeError: "\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u306F\u8A8D\u53EF\u3055\u308C\u3066\u3044\u306A\u3044\u306E\u3067\u3001\u8868\u793A\u3067\u304D\u307E\u305B\u3093\u3002",
        DomainExsit: "\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u306F\u65E2\u306B\u4F7F\u308F\u308C\u3066\u3044\u308B\u306E\u3067\u3001\u5225\u306E\u30C9\u30E1\u30A4\u30F3\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    },
    card: {
        manage: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u7BA1\u7406",
        number: "\u30AB\u30FC\u30C9\u756A\u53F7",
        dueDate: "\u671F\u9650\u6E80\u4E86\u65E5",
        status: "\u72B6\u614B",
        owner: "\u30AB\u30FC\u30C9\u540D\u7FA9\u4EBA",
        statusNormal: "\u5229\u7528\u53EF\u80FD",
        statusExpired: "\u671F\u9650\u5207\u308C",
        default: "\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9",
        bind: "\u6C7A\u6E08\u7528\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9",
        setDefault: "\u30C7\u30D5\u30A9\u30EB\u30C8\u3068\u3057\u3066\u8A2D\u5B9A",
        create: "\u65B0\u3057\u3044\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3092\u767B\u9332",
        inputNumber: "\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        validity: "\u6709\u52B9\u671F\u9650",
        inputMonth: "\u6708\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        inputYear: "2\u6841\u306E\u5E74\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        securityCode: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9",
        inputSecurityCode: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        inputOwner: "\u30AB\u30FC\u30C9\u540D\u7FA9\u4EBA\u306E\u540D\u524D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        errorNumber: "16\u6841\u306E\u6574\u6570\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        errorMonth: "1\u6708\u304B\u308912\u6708\u306E\u4E2D\u304B\u3089\u9078\u3093\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        errorYear: "\u6709\u52B9\u306A\u5E74\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        errorSecurity: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        errorOwner: "\u30AB\u30FC\u30C9\u540D\u7FA9\u4EBA\u3092\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044",
        errorExpired: "\u3053\u306E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002\u671F\u9650\u3092\u78BA\u8A8D\u3059\u308B\u304B\u3001\u65B0\u3057\u3044\u30AB\u30FC\u30C9\u306B\u5207\u308A\u66FF\u3048\u3066\u304F\u3060\u3055\u3044",
        delete: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u60C5\u5831\u3092\u524A\u9664",
        deleteConfirm: "\u672B\u5C3E\u304C{number}\u306E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3092\u672C\u5F53\u306B\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
        deleteComplete: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u60C5\u5831\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F",
        defaultComplete: "\u30C7\u30D5\u30A9\u30EB\u30C8\u3068\u3057\u3066\u8A2D\u5B9A\u3055\u308C\u307E\u3057\u305F",
        emptyTitle: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u60C5\u5831\u304C\u672A\u767B\u9332\u3067\u3059",
        emptyDesc: "\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3092\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044",
        inputMonthYear: 'MM/YY',
        error: {
            InvalidNumber: "\u5165\u529B\u3055\u308C\u305F\u30AB\u30FC\u30C9\u756A\u53F7\u304C\u7121\u52B9\u3067\u3059\u3002",
            tooShortNumber: "\u5165\u529B\u3055\u308C\u305F\u30AB\u30FC\u30C9\u756A\u53F7\u306B\u4E0D\u5099\u304C\u3042\u308A\u307E\u3059\u3002",
            invalidDate: "\u5165\u529B\u3055\u308C\u305F\u30AB\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u306F\u7121\u52B9\u3067\u3059\u3002",
            incompleteDate: "\u5165\u529B\u3055\u308C\u305F\u30AB\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u306B\u4E0D\u5099\u304C\u3042\u308A\u307E\u3059\u3002",
            expiredDate: "\u5165\u529B\u3055\u308C\u305F\u30AB\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u306F\u904E\u53BB\u306E\u65E5\u4ED8\u3067\u3059\u3002",
            invalidSecurityCode: "\u5165\u529B\u3055\u308C\u305F\u30AB\u30FC\u30C9\u306E\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9\u306B\u4E0D\u5099\u304C\u3042\u308A\u307E\u3059\u3002"
        }
    },
    home: {
        title: "\u30DB\u30FC\u30E0",
        modelAmount: "\u30E2\u30C7\u30EB\u306E\u7DCF\u6570\uFF08\u500B\uFF09",
        memberAmount: "\u30E1\u30F3\u30D0\u30FC\u306E\u6570\uFF08\u540D\uFF09",
        orderAmount: "\u751F\u6210\u3055\u308C\u305F\u6CE8\u6587\u6570\uFF08\u4EF6\uFF09",
        quick: "\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u30EA\u30F3\u30AF",
        completeInfo: "\u4F1A\u793E\u60C5\u5831\u306E\u66F4\u65B0",
        team: "\u30C1\u30FC\u30E0\u3092\u69CB\u7BC9",
        cowork: "\u30E2\u30C7\u30EB\u30B3\u30E9\u30DC\u30EC\u30FC\u30B7\u30E7\u30F3",
        order: "\u6CE8\u6587\u5C65\u6B74\u3092\u78BA\u8A8D\u3059\u308B",
        read: "\u521D\u5FC3\u8005\u5FC5\u8AAD",
        back: "\u30DB\u30FC\u30E0\u753B\u9762\u306B\u623B\u308B"
    },
    plan: {
        a: "Plan A \u30B9\u30BF\u30FC\u30BF\u30FC",
        b: "Plan B \u30D9\u30FC\u30B7\u30C3\u30AF",
        bApp: "Plan B \u30D9\u30FC\u30B7\u30C3\u30AF\uFF08\u30A2\u30D7\u30EA\u7248\uFF09",
        bAll: "Plan B \u30D9\u30FC\u30B7\u30C3\u30AF\uFF08\u30A2\u30D7\u30EA\u7248 + Web\u7248\uFF09",
        c: "Plan C \u30D3\u30B8\u30CD\u30B9",
        selectPlan: "\u30D7\u30E9\u30F3\u306E\u9078\u629E",
        planDetail: "\u30D7\u30E9\u30F3\u8A73\u7D30",
        id: "\u3054\u5229\u7528\u53EF\u80FD\u306AID\u6570",
        idMoreThan: "\u4EE5\u4E0A",
        app: "\u30A2\u30D7\u30EA\u7248",
        appWeb: "\u30A2\u30D7\u30EA\u7248 + Web\u7248",
        price: "{price}\u5186\uFF5E",
        none: "\u73FE\u5728\u3054\u5951\u7D04\u4E2D\u306E\u30D7\u30E9\u30F3\u306F\u3042\u308A\u307E\u305B\u3093",
        now: "\u73FE\u5728\u3054\u5951\u7D04\u4E2D\u306E\u30D7\u30E9\u30F3",
        statusActive: "\u5951\u7D04\u4E2D",
        statusUnactive: "\u958B\u59CB\u524D",
        end: "\u7D42\u4E86",
        aYearText: "\u6708\u6255\u3044\u3068\u6BD4\u8F03\u3057\u3066 24,000 \u5186\u304A\u5F97",
        unSelected: "\u9078\u629E\u4E2D\u306E\u30D7\u30E9\u30F3\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
    },
    order: {
        list: "\u53D6\u5F15\u5C65\u6B74",
        plan: "\u30D7\u30E9\u30F3\u6CE8\u6587",
        cad: "CAD\u6CE8\u6587",
        statusUnpay: "\u304A\u652F\u6255\u3044\u5F85\u3061",
        trial: "\u5148\u884C\u30C8\u30E9\u30A4\u30A2\u30EB\u53EF\u80FD",
        statusPaid: "\u304A\u652F\u6255\u3044\u6E08\u307F",
        statusCancel: "\u30AD\u30E3\u30F3\u30BB\u30EB\u6E08\u307F",
        statusComplete: "\u51E6\u7406\u6E08\u307F",
        statusProcessing: "\u51E6\u7406\u4E2D",
        searchHint: "\u7BA1\u7406\u756A\u53F7/\u30D7\u30E9\u30F3\u540D\u3092\u5165\u529B\u3057\u3066\u691C\u7D22",
        number: "\u7BA1\u7406\u756A\u53F7",
        name: "\u30D7\u30E9\u30F3\u540D",
        payMethod: "\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u5F62\u5F0F",
        payMonth: "\u6708\u6255\u3044",
        payYear: "\u5E74\u6255\u3044",
        switchPayMethod: "\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u5F62\u5F0F\u306E\u5909\u66F4",
        switchPay: "\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u5F62\u5F0F\u306E\u5909\u66F4",
        switchMonthTip: "\u30D7\u30E9\u30F3A\u306E\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u5F62\u5F0F\u3092\u3010\u6708\u6255\u3044\u3011\u306B\u5909\u66F4\u3057\u307E\u3059\u304B\uFF1F",
        switchYearTip: "\u30D7\u30E9\u30F3A\u306E\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u5F62\u5F0F\u3092\u3010\u5E74\u6255\u3044\u3011\u306B\u5909\u66F4\u3057\u307E\u3059\u304B\uFF1F",
        currentPeriod: "\u73FE\u5728\u30D7\u30E9\u30F3\u306E\u6709\u52B9\u671F\u9650",
        nextPeriod: "\u6B21\u56DE\u30D7\u30E9\u30F3\u306E\u6709\u52B9\u671F\u9650",
        currentSeat: "\u73FE\u5728\u3054\u5951\u7D04\u4E2D\u306EID\u6570",
        periord: "\u3054\u5951\u7D04\u671F\u9593",
        selectSeat: "\u3054\u5229\u7528\u5E0C\u671B\u306EID\u6570",
        seat: "\u3054\u5951\u7D04ID\u6570",
        seatAdded: "\u65B0\u898F\u3067\u3054\u5229\u7528\u53EF\u80FD\u306AID",
        seatAddSum: "\u8FFD\u52A0\u5E0C\u671B\u306E\u65B0\u898FID\u6570",
        seatAddTime: "\u3054\u5229\u7528\u958B\u59CB\u65E5",
        selectTime: "\u65E5\u4ED8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
        seatPeople: "{n}\u4EBA",
        seatUnactive: "{n}\u500B\u306EID\u304C\u6709\u52B9\u5316\u5F85\u3061",
        seatTip: "\u3053\u3053\u3067\u9078\u629E\u3057\u305FID\u6570\u306F\u3001\u30C1\u30FC\u30E0\u3067\u5229\u7528\u53EF\u80FD\u306AID\u306E\u5408\u8A08\u3068\u306A\u308A\u307E\u3059\u3002\uFF08\u4F8B\uFF1A10\u3092\u9078\u629E\u3057\u305F\u5834\u5408\u3001\u30C1\u30FC\u30E0\u5168\u4F53\u3067\u5229\u7528\u53EF\u80FD\u306AID\u6570\u306F10\u3068\u306A\u308A\u307E\u3059\uFF09",
        packageCount: "\u30D1\u30C3\u30B1\u30FC\u30B8\u6570",
        packageCountTip: "\u8CFC\u5165\u3059\u308B\u30D1\u30C3\u30B1\u30FC\u30B8\u6570\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
        additionalIdCount: "\u8FFD\u52A0ID\u6570",
        additionalIdCountTip: "\u30D1\u30C3\u30B1\u30FC\u30B8\u306E\u57FA\u672CID\u6570\u306B\u52A0\u3048\u3066\u8FFD\u52A0\u8CFC\u5165\u3059\u308BID\u6570",
        totalIdCount: "\u5408\u8A08{count}\u500B\u306EID",
        packageBaseIdCount: "\u9078\u629E\u3057\u305F\u30D1\u30C3\u30B1\u30FC\u30B8\u306B\u306F{count}\u500B\u306EID\u304C\u542B\u307E\u308C\u3066\u3044\u307E\u3059",
        seatOver: "\u30E1\u30F3\u30D0\u30FC\u6570\u304C\u4E0A\u9650\u3092\u8D85\u3048\u307E\u3057\u305F",
        seatOverTip: "\u73FE\u5728\u30C1\u30FC\u30E0\u306E\u30E1\u30F3\u30D0\u30FC\u306F{n}\u4EBA\u3067\u3059\u3002{n}ID\u4EE5\u4E0A\u306E\u30D7\u30E9\u30F3\u3092\u3054\u5951\u7D04\u3044\u305F\u3060\u304F\u304B\u3001\u7BA1\u7406\u753B\u9762\u3067\u4E00\u90E8\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3057\u3066\u304B\u3089\u3054\u5951\u7D04\u304F\u3060\u3055\u3044\u3002",
        memberUsed: "\u73FE\u5728\u5229\u7528\u4E2D\u306EID\u6570",
        deleteMemble: "\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3059\u308B",
        cancelTip: "{date}\u30AD\u30E3\u30F3\u30BB\u30EB",
        expandSeat: "ID\u6570\u8FFD\u52A0",
        purchase: "\u30D7\u30E9\u30F3\u3092\u7533\u3057\u8FBC\u3080",
        purchaseNow: "\u4ECA\u3059\u3050\u5951\u7D04",
        levelUp: "\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9",
        renewal: "\u5951\u7D04\u66F4\u65B0",
        buy: "\u65B0\u898F\u5951\u7D04",
        changeTime: "\u5229\u7528\u671F\u9593\u3092\u5909\u66F4",
        olderTime: "\u73FE\u5728\u306E\u5229\u7528\u671F\u9593",
        newTime: "\u66F4\u65B0\u5F8C\u306E\u5229\u7528\u671F\u9593",
        startTime: "\u5229\u7528\u958B\u59CB\u65E5",
        endTime: "\u5229\u7528\u7D42\u4E86\u65E5",
        updateTime: "\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u65E5",
        contactService: "\u30B5\u30DD\u30FC\u30C8\u30FB\u554F\u3044\u5408\u308F\u305B",
        changeCard: "\u304A\u652F\u6255\u3044\u306E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3092\u5909\u66F4",
        SelectCard: "\u304A\u652F\u6255\u3044\u306E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
        cancel: "\u30D7\u30E9\u30F3\u89E3\u7D04\u7533\u8ACB",
        cancelTip1: "\u30D7\u30E9\u30F3\u3092\u89E3\u7D04\u3059\u308B\u3068\u3001\u30D7\u30E9\u30F3\u306F{date}\u306B\u7D42\u4E86\u3057\u3001\u305D\u308C\u4EE5\u964D\u306F\u81EA\u52D5\u66F4\u65B0\u3055\u308C\u307E\u305B\u3093\u3002\u305D\u306E\u969B\u3001\u30E1\u30F3\u30D0\u30FC\u5168\u54E1\u304C\u30B7\u30B9\u30C6\u30E0\u3092\u5229\u7528\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u672C\u5F53\u306B\u89E3\u7D04\u3057\u3066\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
        cancelTip2: "\u30D7\u30E9\u30F3\u3092\u89E3\u7D04\u3059\u308B\u3068\u3001\u5951\u7D04\u306E\u81EA\u52D5\u66F4\u65B0\u304C\u505C\u6B62\u3055\u308C\u307E\u3059\u3002\u5951\u7D04\u7D42\u4E86\u5F8C\u3001\u30E1\u30F3\u30D0\u30FC\u5168\u54E1\u304C\u30B7\u30B9\u30C6\u30E0\u3092\u5229\u7528\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u672C\u5F53\u306B\u89E3\u7D04\u3057\u3066\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
        revokeCancellation: "\u89E3\u7D04\u3092\u53D6\u308A\u6D88\u3059",
        revokeTip: "\u89E3\u7D04\u3092\u53D6\u308A\u6D88\u3057\u307E\u3059\u304B\uFF1F\u53D6\u308A\u6D88\u3057\u305F\u5834\u5408\u3001\u518D\u5EA6\u89E3\u7D04\u304C\u53EF\u80FD\u3067\u3059\u3002",
        seatExpandExceed: "\u73FE\u5728\u3054\u5951\u7D04\u4E2D\u306E\u30D7\u30E9\u30F3\u3067\u306E\u4E0A\u9650\u306F{max-seat}ID\u3067\u3059\u3002\u65E2\u306B{exist-seat}\u5E2D\u3092\u5229\u7528\u4E2D\u306E\u305F\u3081\u3001\u8FFD\u52A0\u3067\u304D\u308B\u306E\u306F{left-seat}ID\u307E\u3067\u3067\u3059\u3002ID\u6570\u3092\u8ABF\u6574\u3057\u3066\u518D\u5EA6\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        unpaidTip: "\u73FE\u5728\u3001\u304A\u652F\u6255\u3044\u5F85\u3061\u306E\u3054\u6CE8\u6587\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u304A\u652F\u6255\u3044\u624B\u7D9A\u304D\u3078\u304A\u9032\u307F\u3044\u305F\u3060\u304F\u304B\u3001\u30B5\u30FC\u30D3\u30B9\u63D0\u4F9B\u5074\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002",
        noPlanError: "\u73FE\u5728\u3001\u3054\u5951\u7D04\u306E\u30D7\u30E9\u30F3\u304C\u306A\u3044\u305F\u3081\u3001\u65B0\u898FID\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002\u30B5\u30FC\u30D3\u30B9\u63D0\u4F9B\u5074\u306B\u3054\u9023\u7D61\u3044\u305F\u3060\u304D\u3001\u4E00\u5EA6\u3054\u6CE8\u6587\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u3066\u304B\u3089\u6539\u3081\u3066\u30D7\u30E9\u30F3\u3092\u3054\u8CFC\u5165\u304F\u3060\u3055\u3044\u3002",
        existPlantip: "{plan}\u30D7\u30E9\u30F3\u3092\u3059\u3067\u306B\u3054\u5951\u7D04\u4E2D\u306E\u305F\u3081\u3001\u65B0\u898F\u30D7\u30E9\u30F3\u3092\u3054\u5951\u7D04\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002",
        unactivePlantip: "{plan}\u30D7\u30E9\u30F3\u3092\u3054\u5951\u7D04\u6E08\u307F\u3067\u3059\u3002\u30B5\u30FC\u30D3\u30B9\u958B\u59CB\u65E5{date}\u304B\u3089\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u306E\u3067\u3001\u4ECA\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002",
        noPlan: "\u73FE\u5728\u5229\u7528\u53EF\u80FD\u306A\u30D7\u30E9\u30F3\u306F\u3042\u308A\u307E\u305B\u3093",
        newPlan: "\u5909\u66F4\u5F8C\u306E\u30D7\u30E9\u30F3",
        learn: "\u30D7\u30E9\u30F3\u306E\u8A73\u7D30",
        learnMore: "\u30D7\u30E9\u30F3\u306E\u8A73\u7D30\u3092\u78BA\u8A8D",
        checkCurrentPlan: "\u73FE\u5728\u3054\u5951\u7D04\u4E2D\u306E\u30D7\u30E9\u30F3\u3092\u78BA\u8A8D",
        confirmOrder: "\u30D7\u30E9\u30F3\u3092\u9078\u629E\u3057\u3066\u7533\u3057\u8FBC\u3080",
        orderInfo: "\u304A\u7533\u3057\u8FBC\u307F\u5185\u5BB9",
        planStart: "\u3054\u5229\u7528\u958B\u59CB\u65E5",
        planStartInstant: "\u304A\u652F\u6255\u3044\u304C\u5B8C\u4E86\u6B21\u7B2C",
        item: "\u6CE8\u6587\u5185\u5BB9",
        itemName: "\u5546\u54C1\u540D",
        modelName: "\u30E2\u30C7\u30EB\u540D",
        diagramType: "\u56F3\u9762\u7A2E\u5225",
        category: "\u7A2E\u5225",
        totalItem: "\u6570\u91CF",
        unitPriceYen: "\u5358\u4FA1",
        totalSumYen: "\u5C0F\u8A08",
        unitPrice: "\u5358\u4FA1",
        totalSum: "\u5C0F\u8A08",
        unusedSum: "\u672A\u4F7F\u7528\u306E\u30D1\u30C3\u30B1\u30FC\u30B8\u6B8B\u9AD8",
        quickSum: "\u5408\u8A08",
        tax: "\u6D88\u8CBB\u7A0E\uFF0810%\uFF09",
        payableSum: "\u304A\u652F\u6255\u3044\u91D1\u984D",
        payableSumUnit: "\u304A\u652F\u6255\u3044\u91D1\u984D\uFF08\u5186\uFF09",
        submit: "\u3053\u306E\u5185\u5BB9\u3067\u7533\u3057\u8FBC\u3080",
        confirmSubmit: "\u3053\u306E\u5185\u5BB9\u3067\u7533\u3057\u8FBC\u3080",
        createUser: "\u64CD\u4F5CID",
        createTime: "\u64CD\u4F5C\u65E5\u6642",
        paidTime: "\u304A\u652F\u6255\u3044\u65E5\u6642",
        giveTime: "\u7D0D\u54C1\u65E5\u6642",
        paidStatus: "\u304A\u652F\u6255\u3044\u72B6\u6CC1",
        cadStatus: "CAD\u4F5C\u6210\u72B6\u6CC1",
        orderSum: "\u652F\u6255\u91D1\u984D",
        status: "\u304A\u652F\u6255\u3044\u72B6\u6CC1",
        leftTime: "\u652F\u6255\u671F\u9650\u307E\u3067\u3042\u3068",
        leftDay: "\u65E5",
        leftHr: "\u6642\u9593",
        leftMin: "\u5206",
        leftSec: "\u79D2",
        expireTip: "\u3054\u6CE8\u610F\uFF1A\u652F\u6255\u671F\u9650\u307E\u3067\u306B\u304A\u652F\u6255\u3044\u3055\u308C\u306A\u304B\u3063\u305F\u5834\u5408\u3001\u304A\u7533\u3057\u8FBC\u307F\u306F\u81EA\u52D5\u7684\u306B\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3059\u3002",
        purchaseSuccess: "\u304A\u7533\u3057\u8FBC\u307F\u3044\u305F\u3060\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002",
        switchTipYear: "{date} \u306B\u5E74\u984D\u5951\u7D04\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059",
        switchTipMonth: "{date} \u306B\u6708\u984D\u5951\u7D04\u306B\u5207\u308A\u66FF\u308F\u308A\u307E\u3059",
        autoFail: "\u81EA\u52D5\u5F15\u304D\u843D\u3068\u3057\u306B\u5931\u6557\u3057\u307E\u3057\u305F",
        cardFailTip: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3067\u306E\u5F15\u304D\u843D\u3068\u3057\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u660E\u65E5\u518D\u5EA6\u304A\u624B\u7D9A\u304D\u3092\u884C\u3044\u307E\u3059\u306E\u3067\u3001\u5FC5\u8981\u306B\u5FDC\u3058\u3066\u652F\u6255\u30AB\u30FC\u30C9\u306E\u5909\u66F4\u3092\u3054\u691C\u8A0E\u304F\u3060\u3055\u3044\u3002",
        toSwitch: "\u5909\u66F4\u3078\u9032\u3080",
        details: "\u3054\u6CE8\u6587\u8A73\u7D30",
        type: "\u7A2E\u5225",
        planType: "\u9078\u629E\u4E2D\u306E\u30D7\u30E9\u30F3",
        sumTip: "\u7DCF\u91D1\u984D=\u30D7\u30E9\u30F3\u5358\u4FA1\xd7\u8FFD\u52A0ID\u6570\xd7\u6B8B\u308A\u65E5\u6570/{n}\u65E5",
        unusedTip: "\u672A\u4F7F\u7528\u91D1\u984D\uFF08\u5143\u306E\u30D7\u30E9\u30F3\uFF09\uFF1D\u65E7\u30D7\u30E9\u30F3\u5358\u4FA1\xd7\u5143\u306EID\u6570\xd7\u672A\u4F7F\u7528\u65E5\u6570/{n}\u65E5",
        priceTip: "\u6642\u9593\u306B\u5FDC\u3058\u305F\u5358\u4FA1\u63DB\u7B97\u3001\u5358\u4FA1\uFF1D\u30D7\u30E9\u30F3\u306E\u5143\u5358\u4FA1\xd7\u6B8B\u308A\u5229\u7528\u65E5\u6570/{n}\u65E5",
        oldPlan: "\u5143\u306E\u30D7\u30E9\u30F3",
        unusedTime: "\u672A\u4F7F\u7528\u65E5\u6570",
        actionDetail: "\u8A73\u7D30",
        checkDetail: "\u8A73\u7D30\u3092\u78BA\u8A8D",
        actionPay: "\u304A\u652F\u6255\u3044\u3078\u9032\u3080",
        actionCancel: "\u304A\u7533\u8FBC\u307F\u3092\u30AD\u30E3\u30F3\u30BB\u30EB",
        cancelConfirm: "\u304A\u7533\u8FBC\u307F\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
        actionInvoice: "\u8ACB\u6C42\u66F8 \u30FB \u7D0D\u54C1\u66F8 \u30FB \u9818\u53CE\u66F8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
        actionDiagram: "\u56F3\u9762\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
        submitOrder: "\u3053\u306E\u5185\u5BB9\u3067\u7533\u3057\u8FBC\u3080",
        payOrder: "\u304A\u652F\u6255\u3044\u65B9\u6CD5\u3092\u9078\u629E",
        completeOrder: "\u3054\u5951\u7D04\u5B8C\u4E86",
        applican: "\u7533\u8ACB\u8005",
        appliTime: "\u7533\u8ACB\u65E5\u6642",
        checkCancel: "\u30AD\u30E3\u30F3\u30BB\u30EB\u7406\u7531\u3092\u78BA\u8A8D",
        cancelTime: "\u30AD\u30E3\u30F3\u30BB\u30EB\u6642\u9593",
        cancelReason: "\u30AD\u30E3\u30F3\u30BB\u30EB\u7406\u7531",
        useTip: "\u304A\u652F\u6255\u3044\u5B8C\u4E86\u3068\u540C\u6642\u306B\u5229\u7528\u958B\u59CB",
        itemList: "\u6CE8\u6587\u4E00\u89A7",
        system: "\u30B7\u30B9\u30C6\u30E0",
        selectNumber: "\u6570\u91CF\u306E\u9078\u629E",
        numberOfPlan: "\u30D7\u30E9\u30F3\u6570",
        numberOfID: "\u8FFD\u52A0ID\u6570",
        numberTip1: "ID\u6570\u5408\u8A08\uFF1A{detail0}",
        numberTip2: "\u9078\u629E\u3055\u308C\u305F\u30D7\u30E9\u30F3\u306EID\u6570\uFF1A{detail0}",
        card: {
            '3DsTip': "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u81EA\u52D5\u5F15\u304D\u843D\u3068\u3057\u306B\u306F\u30013D\u30BB\u30AD\u30E5\u30A2\u8A8D\u8A3C\u304C\u5FC5\u8981\u3067\u3059\u3002\u30B7\u30B9\u30C6\u30E0\u3088\u308A\u8A8D\u8A3C\u30E1\u30FC\u30EB\u3092\u9001\u4FE1\u3044\u305F\u3057\u307E\u3057\u305F\u306E\u3067\u3001\u30E1\u30FC\u30EB\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u8A8D\u8A3C\u3092\u5B8C\u4E86\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        },
        complete: "\u304A\u7533\u3057\u8FBC\u307F\u3092\u5B8C\u4E86\u3059\u308B"
    },
    cad: {
        statusProcessing: "CAD\u4F5C\u56F3\u4E2D",
        statusComplete: "CAD\u4F5C\u56F3\u5B8C\u4E86",
        submit: "\u7533\u8ACB\u3092\u63D0\u51FA\u3059\u308B",
        completeTime: "\u7D042\u301C4\u65E5",
        create: "CAD\u56F3\u9762\u4F5C\u6210",
        delivery: "\u56F3\u9762\u306E\u4EA4\u4ED8",
        model: "\u30E2\u30C7\u30EB",
        innerWall: "\u5185\u58C1\u306E\u539A\u3055",
        outerWall: "\u5916\u58C1\u306E\u539A\u3055",
        deliveryFormat: "\u56F3\u9762\u306E\u7D0D\u54C1\u5F62\u5F0F",
        usage: "\u5EFA\u7269\u7A2E\u5225",
        type: "\u56F3\u9762\u306E\u7A2E\u985E",
        attachment: "\u65E2\u5B58\u56F3\u9762\u30C6\u3099\u30FC\u30BF",
        application: "CAD\u56F3\u9762\u4F5C\u6210\u4F9D\u983C",
        usageResidential: "\u4F4F\u5B85",
        usageOffice: "\u30AA\u30D5\u30A3\u30B9",
        usageShop: "\u5E97\u8217\u30FB\u65BD\u8A2D",
        usageOthers: "\u305D\u306E\u4ED6",
        fileCad: "CAD\u30D5\u30A1\u30A4\u30EB",
        filePdf: "PDF\u30D5\u30A1\u30A4\u30EB",
        diagramFloorplan: "\u5E73\u9762\u56F3",
        diagramCeiling: "\u5929\u4E95\u4F0F\u56F3",
        diagramElevation: "\u7ACB\u9762\u56F3",
        tipProcessing: "\u73FE\u5728\u3001\u56F3\u9762\u3092\u4F5C\u6210\u3057\u3066\u304A\u308A\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002"
    },
    pay: {
        payment: "\u304A\u652F\u6255\u3044\u65B9\u6CD5",
        detailCard: "\u304A\u652F\u6255\u3044\u60C5\u5831 - \u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9",
        detailInvoice: "\u304A\u652F\u6255\u3044\u60C5\u5831 - \u8ACB\u6C42\u66F8",
        orderPay: "\u304A\u652F\u6255\u3044\u65B9\u6CD5\u3092\u9078\u629E",
        unlimited: "\u7121\u5236\u9650",
        selectMethod: "\u304A\u652F\u6255\u3044\u65B9\u6CD5",
        creditcard: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9",
        invoice: "\u8ACB\u6C42\u66F8",
        invoiceSendTip: "\u8ACB\u6C42\u66F8\u304C{mail}\u306B\u9001\u4FE1\u3055\u308C\u307E\u3059\u306E\u3067\u3001\u4E0B\u8A18\u306E\u53E3\u5EA7\u306B\u304A\u632F\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002",
        invoiceResendTip: "\u8ACB\u6C42\u66F8\u304C{mail}\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u4E0B\u8A18\u306E\u53E3\u5EA7\u306B\u304A\u632F\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002",
        bank: "\u91D1\u878D\u6A5F\u95A2",
        banCode: "\u91D1\u878D\u6A5F\u95A2\u30B3\u30FC\u30C9",
        bankName: "\u652F\u5E97\u540D",
        bankNumber: "\u652F\u5E97\u756A\u53F7",
        accountType: "\u53E3\u5EA7\u7A2E\u5225",
        accountOwner: "\u53E3\u5EA7\u540D\u7FA9",
        accountNumber: "\u53E3\u5EA7\u756A\u53F7",
        sendInvoice: "\u8ACB\u6C42\u66F8\u3092\u9001\u4FE1",
        noInvoice: "\u8ACB\u6C42\u66F8\u304C\u5C4A\u304B\u306A\u3044\u5834\u5408\u306F\u3053\u3061\u3089",
        resendInvoice: "\u8ACB\u6C42\u66F8\u3092\u518D\u9001\u4FE1\u3057\u307E\u3059",
        InvoiceSent: "\u8ACB\u6C42\u66F8\u306E\u9001\u4FE1\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
        toPay: "\u304A\u652F\u6255\u3044\u3078\u9032\u3080",
        payLoading: "\u304A\u652F\u6255\u3044\u51E6\u7406\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002",
        payJump: "\u304A\u652F\u6255\u3044\u51E6\u7406\u4E2D\u3067\u3059\u3002\u307E\u3082\u306A\u304F\u6CE8\u6587\u753B\u9762\u306B\u79FB\u52D5\u3057\u307E\u3059\u3002",
        agreement: "\u5229\u7528\u898F\u7D04\u306B\u540C\u610F\u3059\u308B",
        alert: "\u3053\u306E\u3054\u6CE8\u6587\u306F\u9280\u884C\u632F\u8FBC\u3067\u306E\u304A\u652F\u6255\u3044\u304C\u5FC5\u8981\u3067\u3059\u3002\u53D7\u4FE1\u30C8\u30EC\u30A4\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u3082\u3057\u632F\u8FBC\u306B\u95A2\u3059\u308B\u30E1\u30FC\u30EB\u304C\u5C4A\u3044\u3066\u3044\u306A\u3044\u5834\u5408\u3084\u3001\u4ED6\u306B\u3054\u4E0D\u660E\u306A\u70B9\u304C\u3054\u3056\u3044\u307E\u3057\u305F\u3089\u3001\u30B5\u30FC\u30D3\u30B9\u63D0\u4F9B\u5074\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002"
    },
    team: {
        member: "\u30E1\u30F3\u30D0\u30FC\u7BA1\u7406",
        status: "\u5229\u7528\u72B6\u6CC1",
        statusActive: "\u5229\u7528\u4E2D",
        statusUnactive: "\u6709\u52B9\u5316\u5F85\u3061",
        addMember: "\u30E1\u30F3\u30D0\u30FC\u767B\u9332",
        deleteMember: "\u30E1\u30F3\u30D0\u30FC\u524A\u9664",
        deleteMultiMember: "\u30E1\u30F3\u30D0\u30FC\u4E00\u62EC\u524A\u9664",
        deleteMultiMemberTip: "\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u9078\u629E\u3055\u308C\u305F\u30E1\u30F3\u30D0\u30FC\u306F\u8CB4\u793E\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u304C\u3001\u30AF\u30E9\u30A6\u30C9\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30E2\u30C7\u30EB\u306F\u4FDD\u6301\u3055\u308C\u307E\u3059\u3002\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3057\u3087\u3046\u304B\uFF1F",
        editMember: "\u30E1\u30F3\u30D0\u30FC\u7DE8\u96C6",
        deleteMemberTip: "\u30E1\u30F3\u30D0\u30FC\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u305D\u306E\u30E1\u30F3\u30D0\u30FC\u306F\u8CB4\u793E\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u304C\u3001\u30AF\u30E9\u30A6\u30C9\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30E2\u30C7\u30EB\u306F\u4FDD\u6301\u3055\u308C\u307E\u3059\u3002\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3057\u3087\u3046\u304B\uFF1F",
        addMultiMember: "\u30E1\u30F3\u30D0\u30FC\u4E00\u62EC\u767B\u9332",
        memberFormDownload: "\u300C\u30E1\u30F3\u30D0\u30FC\u4E00\u62EC\u767B\u9332\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u300D\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
        addMultiMemberTip: "1.\u300C\u30E1\u30F3\u30D0\u30FC\u4E00\u62EC\u767B\u9332\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u300D\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u307E\u3059\uFF1B\\n\n2.\u30D5\u30A1\u30A4\u30EB\u3092\u958B\u304D\u3001\u60C5\u5831\u3092\u30C6\u30AD\u30B9\u30C8\u3084\u6570\u5B57\u3067\u5165\u529B\u3059\u308B\u304B\u3001\u8CBC\u308A\u4ED8\u3051\u3066\u304F\u3060\u3055\u3044\uFF1B\\n\n3. \u300C\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3001\u5148\u307B\u3069\u4F5C\u6210\u3057\u305F\u30E1\u30F3\u30D0\u30FC\u60C5\u5831\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3057\u3066\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u5F8C\u3001\u53F3\u4E0B\u306E\u300C\u30A4\u30F3\u30DD\u30FC\u30C8\u78BA\u8A8D\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\\n\n\u203B\u4E00\u5EA6\u306B\u30A4\u30F3\u30DD\u30FC\u30C8\u3067\u304D\u308B\u30C7\u30FC\u30BF\u306F100\u4EF6\u307E\u3067\u3067\u3059\u3002\u30C7\u30FC\u30BF\u304C100\u4EF6\u3092\u8D85\u3048\u308B\u5834\u5408\u3001\u3059\u3079\u3066\u306E\u30C7\u30FC\u30BF\u304C\u30A4\u30F3\u30DD\u30FC\u30C8\u3055\u308C\u307E\u305B\u3093\u3002",
        errorNoFile: "\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044",
        usedSeat: "\u5229\u7528\u4E2DID",
        model: "\u5168\u30E2\u30C7\u30EB\u6570",
        cloudModel: "\u30AF\u30E9\u30A6\u30C9\u4E0A\u306E\u30E2\u30C7\u30EB\u6570",
        name: "\u6C0F\u540D",
        inputLastname: "\u59D3\u3092\u5165\u529B",
        inputname: "\u540D\u3092\u5165\u529B",
        mail: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        mailAddress: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
        inputEmail: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
        emptyEmail: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        errorEmail: "\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306E\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
        activeAccount: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6709\u52B9\u5316",
        activeAccountTip: "\u3053\u306E\u30E1\u30F3\u30D0\u30FC\u306B\u306F\u30A2\u30AF\u30C6\u30A3\u30D9\u30FC\u30B7\u30E7\u30F3\u30E1\u30FC\u30EB\u304C\u5C4A\u304D\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6709\u52B9\u5316\u3057\u307E\u3059\u304B\uFF1F",
        lastLogin: "\u6700\u5F8C\u306E\u30ED\u30B0\u30A4\u30F3\u65E5\u6642",
        contactPhone: "\u304A\u5BA2\u69D8\u30B5\u30DD\u30FC\u30C8\uFF1A",
        contactEmail: "\u304A\u554F\u3044\u5408\u308F\u305B\u30E1\u30FC\u30EB\uFF1A",
        statusDisabled: "\u505C\u6B62\u4E2D",
        role: {
            owner: "\u6240\u6709\u8005",
            superManger: "\u30B9\u30FC\u30D1\u30FC\u7BA1\u7406\u8005",
            manager: "\u7BA1\u7406\u8005",
            ScanatUser: "Scanat\u30E6\u30FC\u30B6\u30FC",
            viewUser: "\u95B2\u89A7\u30E6\u30FC\u30B6\u30FC",
            name: "\u6A29\u9650\u8A2D\u5B9A",
            updateSuccess: "\u6A29\u9650\u8A2D\u5B9A\u304C\u5909\u66F4\u3055\u308C\u307E\u3057\u305F",
            noRole: "\u6A29\u9650\u8A2D\u5B9A\u306A\u3057"
        },
        operate: {
            enable: "\u6709\u52B9\u5316",
            disable: "\u7121\u52B9\u5316"
        },
        prompt: {
            buyScanatWeb: "Scanat Web\u30B5\u30FC\u30D3\u30B9\u3054\u8CFC\u5165\u6E08\u307F"
        },
        add: {
            chooseRole: "\u6A29\u9650\u8A2D\u5B9A\u9078\u629E",
            manageSeat: "Scanat\u30B5\u30FC\u30D3\u30B9\u5229\u7528",
            seatTip1: "OFF\u306B\u3059\u308B\u3068\u3001\u30E1\u30F3\u30D0\u30FC\u767B\u9332\u3057\u3066\u3082ID\u6570\u306F\u6D88\u8CBB\u3055\u308C\u307E\u305B\u3093\u3002",
            seatTip2: "ON\u306B\u3059\u308B\u3068\u3001ID\u6570\u3092\u4E00\u3064\u6D88\u8CBB\u3057\u307E\u3059\u3002"
        },
        enable: {
            noRight: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6709\u52B9\u5316\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093",
            tip: "\u6709\u52B9\u5316\u3059\u308B\u3068\u3001\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u901A\u5E38\u901A\u308A\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002\u6709\u52B9\u5316\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
            success: "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u6709\u52B9\u5316\u3055\u308C\u307E\u3057\u305F",
            noPlan: "\u8CB4\u793E\u304C\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u306E\u5BFE\u8C61\u5916\u3068\u306A\u308B\u305F\u3081\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6709\u52B9\u5316\u3067\u304D\u307E\u305B\u3093\u3002"
        },
        disable: {
            noRight: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u7121\u52B9\u5316\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093",
            tip: "\u7121\u52B9\u5316\u3059\u308B\u3068\u3001\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u306A\u304F\u306A\u308A\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u30C7\u30FC\u30BF\u306F\u524A\u9664\u3055\u308C\u305A\u3001\u5F8C\u3067\u518D\u5EA6\u6709\u52B9\u5316\u3067\u304D\u307E\u3059\u3002\u7121\u52B9\u5316\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F",
            success: "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u52B9\u5316\u3055\u308C\u307E\u3057\u305F"
        },
        statusDisabledTxt: "\u7121\u52B9\u5316\u6E08\u307F",
        seatTip: "ON\u306B\u3059\u308B\u3068\u3001Scanat\u30B5\u30FC\u30D3\u30B9\u306E\u5229\u7528\u304C\u53EF\u80FD",
        delete: {
            noRight: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093"
        },
        seat: {
            total: "\u5951\u7D04\u4E2DID",
            manageSeat: "Scanat\u30B5\u30FC\u30D3\u30B9\u5229\u7528",
            onSuccess: "Scanat \u30B5\u30FC\u30D3\u30B9\u5229\u7528\u8A2D\u5B9A\u304C\u30AA\u30F3\u306B\u306A\u308A\u307E\u3057\u305F",
            noSeat: "\u5229\u7528\u53EF\u80FD\u306AID\u6570\u304C\u6B8B\u3063\u3066\u3044\u306A\u3044\u305F\u3081\u3001Scanat \u30B5\u30FC\u30D3\u30B9\u5229\u7528\u8A2D\u5B9A\u3092\u30AA\u30F3\u306B\u3067\u304D\u307E\u305B\u3093",
            offSuccess: "Scanat \u30B5\u30FC\u30D3\u30B9\u5229\u7528\u8A2D\u5B9A\u304C\u30AA\u30D5\u306B\u306A\u308A\u307E\u3057\u305F"
        }
    },
    survey: {
        title: "Scanat \u89E3\u7D04\u7533\u8ACB\u30D5\u30A9\u30FC\u30E0",
        desc: "\u5E73\u7D20\u3088\u308AScanat\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u304D\u307E\u3057\u3066\u3001\u8AA0\u306B\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002\n\u89E3\u7D04\u3092\u3054\u5E0C\u671B\u306E\u304A\u5BA2\u69D8\u306F\u3001\u4E0B\u8A18\u306E\u30D5\u30A9\u30FC\u30E0\u306B\u5FC5\u8981\u4E8B\u9805\u3092\u3054\u5165\u529B\u306E\u3046\u3048\u3001\u3054\u9001\u4FE1\u304F\u3060\u3055\u3044\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u7533\u3057\u4E0A\u3052\u307E\u3059\u3002\n\u30D5\u30A9\u30FC\u30E0\u306E\u53D7\u9818\u5F8C\u3001\u5F0A\u793E\u55B6\u696D\u65E5\u306B\u62C5\u5F53\u8005\u3088\u308A\u304A\u96FB\u8A71\u307E\u305F\u306F\u30E1\u30FC\u30EB\u306B\u3066\u6298\u308A\u8FD4\u3057\u3054\u9023\u7D61\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002",
        questionReason: "\u89E3\u7D04\u7406\u7531\uFF08\u8907\u6570\u9078\u629E\u53EF\uFF09",
        reason1: "\u8A08\u6E2C\u7CBE\u5EA6\u304C\u4F4E\u3044",
        reason2: "\u64AE\u5F71\u30FB\u64CD\u4F5C\u65B9\u6CD5\u304C\u96E3\u3057\u3044",
        reason3: "\u4F7F\u7528\u983B\u5EA6\u304C\u5C11\u306A\u3044",
        reason4: "\u6A5F\u80FD\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u308B",
        reason5: "\u8CBB\u7528\u304C\u9AD8\u3044",
        reason6: "\u30B5\u30DD\u30FC\u30C8\u4F53\u5236\u304C\u4E0D\u5341\u5206",
        questionApp: "2.\u3053\u308C\u307E\u3067\u306B\u5229\u7528\u3057\u305F\u30B9\u30AD\u30E3\u30F3\u30B7\u30B9\u30C6\u30E0\u304C\u3042\u308C\u3070\u6559\u3048\u3066\u304F\u3060\u3055\u3044\u3002\uFF08\u8907\u6570\u9078\u629E\u53EF\uFF09",
        app1: '3D Scanner',
        app2: 'Canvas',
        app3: 'Metascan',
        app4: 'Modelar',
        app5: 'Matterport',
        app6: 'OpalUI',
        app7: 'Polycam',
        app9: 'Scaniverse',
        app10: 'Sitescope',
        questionRecommend: "3.3D\u30B9\u30AD\u30E3\u30F3\u304C\u5FC5\u8981\u306A\u53CB\u4EBA\u306B\u3001Scanat\u3092\u3069\u308C\u307B\u3069\u304A\u3059\u3059\u3081\u3057\u305F\u3044\u3067\u3059\u304B\uFF1F",
        descRecommend: "* 0\u301C10\u306F\u3001\u3042\u306A\u305F\u304C\u53CB\u4EBA\u306BScanat\u3092\u63A8\u85A6\u3059\u308B\u610F\u6B32\u306E\u7A0B\u5EA6\u3092\u793A\u3057\u307E\u3059\u30020\u306F\u300C\u5168\u304F\u63A8\u85A6\u3057\u305F\u304F\u306A\u3044\u300D\u300110\u306F\u300C\u975E\u5E38\u306B\u63A8\u85A6\u3057\u305F\u3044\u300D\u3067\u3059\u3002",
        questionOther: "\u3054\u610F\u898B\u30FB\u3054\u8981\u671B",
        descOther: "Scanat\u306B\u5BFE\u3057\u3066\u3001\u3054\u8981\u671B\u3084\u8FFD\u52A0\u3057\u3066\u307B\u3057\u3044\u6A5F\u80FD\u30FB\u6539\u5584\u3057\u3066\u307B\u3057\u3044\u70B9\u306A\u3069\u304C\u3054\u3056\u3044\u307E\u3057\u305F\u3089\u3001\u305C\u3072\u3054\u8A18\u5165\u304F\u3060\u3055\u3044\u3002\uFF08\u81EA\u7531\u8A18\u8FF0\u6B04\uFF09",
        submit: "\u9001\u4FE1",
        error: "\u3053\u3061\u3089\u306E\u8CEA\u554F\u3092\u3054\u8A18\u5165\u3057\u3066\u304F\u3060\u3055\u3044",
        complete: "\u9001\u4FE1\u3057\u307E\u3057\u305F",
        thanks: "\u8CB4\u91CD\u306A\u304A\u6642\u9593\u3092\u9802\u304D\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002nat\u306B\u3066\u304A\u7533\u3057\u8FBC\u307F\u3092\u901F\u3084\u304B\u306B\u3054\u5BFE\u5FDC\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002",
        profileTitle: "\u3054\u5165\u529B\u5185\u5BB9\uFF08\u5168\u9805\u76EE\u5FC5\u9808\uFF09",
        profileOwnerHint: "\u4F8B\uFF1A\u5C71\u7530\u592A\u90CE",
        profilePhoneHint: "\u4F8B\uFF1A05017807133",
        profileMailHint: "\u4F8B\uFF1Ascanat{'@'}natincs.com",
        questionReasonDesc: "\u8A72\u5F53\u3059\u308B\u9805\u76EE\u3092\u3059\u3079\u3066\u3054\u9078\u629E\u304F\u3060\u3055\u3044\u3002",
        reason7: "\u90E8\u7F72\u3084\u62C5\u5F53\u8005\u306E\u5909\u66F4\u306B\u3088\u308B",
        reason8: "\u4ED6\u793E\u88FD\u54C1\u3078\u306E\u4E57\u308A\u63DB\u3048",
        contactTip: "\u5185\u5BB9\u306B\u3054\u4E0D\u660E\u70B9\u304C\u3042\u308B\u5834\u5408\u306F\u3001\u4E0B\u8A18\u307E\u3067\u304A\u6C17\u8EFD\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
        contact: "\u3010\u304A\u554F\u3044\u5408\u308F\u305B\u7A93\u53E3\u3011\n- \u96FB\u8A71\u756A\u53F7\uFF1A050-1780-7133\n- \u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF1Acs{'@'}natincs.com",
        profileOwnerEmpty: "\u4E3B\u62C5\u5F53\u8005\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        profilePhoneEmpty: "\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        profileMailEmpty: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        profilePhoneError: "\u6709\u52B9\u306A\u96FB\u8A71\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        profileMailError: "\u6709\u52B9\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        reasonOtherEmpty: "\u5FC5\u9808\u9805\u76EE\u3067\u3059\u3002\u5185\u5BB9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
        reasonEmpty: "\u89E3\u7D04\u7406\u7531\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
        waiting: "\u51E6\u7406\u4E2D\u3067\u3059\u3002\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002",
        submited: "\u89E3\u7D04\u7533\u8ACB\u30D5\u30A9\u30FC\u30E0\u304C\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002\n- \u96FB\u8A71\u756A\u53F7\uFF1A050-1780-7133\n- \u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF1Acs{'@'}natincs.com ",
        submitedOther: "{id}\u306F\u89E3\u7D04\u7533\u8ACB\u30D5\u30A9\u30FC\u30E0\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002\n- \u96FB\u8A71\u756A\u53F7\uFF1A050-1780-7133\n- \u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF1Acs{'@'}natincs.com"
    },
    log: {
        title: "\u64CD\u4F5C\u30ED\u30B0",
        searchHint: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5165\u529B\u3057\u3066\u691C\u7D22",
        remark: "\u203B\u904E\u53BB1\u5E74\u9593\u306E\u64CD\u4F5C\u30ED\u30B0\u3092\u78BA\u8A8D\u53EF\u80FD",
        account: "\u30A2\u30AB\u30A6\u30F3\u30C8",
        time: "\u64CD\u4F5C\u6642\u9593",
        system: "\u6240\u5C5E\u30B7\u30B9\u30C6\u30E0",
        page: "\u64CD\u4F5C\u753B\u9762",
        action: "\u30A2\u30AF\u30B7\u30E7\u30F3",
        detail: "\u8A73\u7D30",
        ip: "IP\u30A2\u30C9\u30EC\u30B9",
        device: "\u30C7\u30D0\u30A4\u30B9",
        overtimeError: "1\u5E74\u4EE5\u4E0A\u524D\u306E\u30ED\u30B0\u306F\u78BA\u8A8D\u3067\u304D\u307E\u305B\u3093\u3001\u5225\u306E\u671F\u9593\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
        noUserError: "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002"
    },
    logs: {
        operateSystem: {
            value3: 'Scanat App',
            value4: 'Scanat Web',
            value1: "ID\u7BA1\u7406"
        },
        operatePage: {
            login: "\u30ED\u30B0\u30A4\u30F3\uFF0F\u65B0\u898F\u767B\u9332",
            personal_setting: "\u500B\u4EBA\u8A2D\u5B9A",
            local_model: "\u30ED\u30FC\u30AB\u30EB\u30E2\u30C7\u30EB",
            in_box: "\u53D7\u4FE1\u7BB1",
            cloud_model: "\u30AF\u30E9\u30A6\u30C9\u30E2\u30C7\u30EB",
            sample_model: "\u30B5\u30F3\u30D7\u30EB\u30EA\u30B9\u30C8",
            main_list: "\u30E1\u30A4\u30F3\u30EA\u30B9\u30C8",
            member_manage: "ID\u7BA1\u7406",
            company_info: "\u4F1A\u793E\u60C5\u5831",
            order_manage: "\u6CE8\u6587\u5C65\u6B74",
            SharedSpace: "\u5171\u6709\u7A7A\u9593",
            TeamsSpace: "\u30C1\u30FC\u30E0\u7A7A\u9593",
            team_space: "\u30C1\u30FC\u30E0\u30B9\u30DA\u30FC\u30B9",
            personal_space: "\u500B\u4EBA\u30B9\u30DA\u30FC\u30B9",
            model_link: "\u30E2\u30C7\u30EB\u30EA\u30F3\u30AF",
            invite_link: "\u62DB\u5F85\u30EA\u30F3\u30AF"
        },
        operateType: {
            login: "\u30ED\u30B0\u30A4\u30F3",
            register: "\u65B0\u898F\u767B\u9332",
            cancellation: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664",
            deleteModel: "\u30E2\u30C7\u30EB\u3092\u524A\u9664",
            addModel: "\u30E2\u30C7\u30EB\u3092\u65B0\u898F\u4F5C\u6210",
            viewModel: "\u30E2\u30C7\u30EB\u3092\u95B2\u89A7",
            viewSampleModel: "\u30E2\u30C7\u30EB\u3092\u95B2\u89A7",
            editModel: "\u30E2\u30C7\u30EB\u3092\u5909\u66F4",
            editModelInfo: "\u30E2\u30C7\u30EB\u3092\u5909\u66F4",
            editModelAvatar: "\u30E2\u30C7\u30EB\u3092\u5909\u66F4",
            editModelName: "\u30E2\u30C7\u30EB\u3092\u5909\u66F4",
            shareModel: "\u30E2\u30C7\u30EB\u3092\u8EE2\u9001",
            copyModelShareLink: "\u30E2\u30C7\u30EB\u3092\u8EE2\u9001",
            moveModel: "\u30E2\u30C7\u30EB\u3092\u79FB\u52D5",
            uploadModel: "\u30E2\u30C7\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
            exportModel: "\u30E2\u30C7\u30EB\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
            copyModel: "\u30E2\u30C7\u30EB\u3092\u8907\u88FD",
            applyCad: "CAD\u56F3\u9762\u4F5C\u6210\u4F9D\u983C",
            addFolder: "\u30D5\u30A9\u30EB\u30C0\u65B0\u898F\u4F5C\u6210",
            editFolder: "\u30D5\u30A9\u30EB\u30C0\u3092\u5909\u66F4",
            deleteFolder: "\u30D5\u30A9\u30EB\u30C0\u3092\u524A\u9664",
            moveFolder: "\u30D5\u30A9\u30EB\u30C0\u3092\u79FB\u52D5",
            downloadModel: "\u30E2\u30C7\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
            buyAccountPlan: "\u30D7\u30E9\u30F3\u3092\u8CFC\u5165",
            inviteMember: "\u30E1\u30F3\u30D0\u30FC\u3092\u767B\u9332",
            addEnableMember: "\u30E1\u30F3\u30D0\u30FC\u3092\u767B\u9332",
            addMember: "\u30E1\u30F3\u30D0\u30FC\u3092\u767B\u9332",
            addDisableMember: "\u30E1\u30F3\u30D0\u30FC\u3092\u767B\u9332",
            enableMember: "\u30E1\u30F3\u30D0\u30FC\u3092\u767B\u9332",
            disableMember: "\u30E1\u30F3\u30D0\u30FC\u3092\u5909\u66F4",
            setMemberAdmin: "\u30E1\u30F3\u30D0\u30FC\u3092\u5909\u66F4",
            unsetMemberAdmin: "\u30E1\u30F3\u30D0\u30FC\u3092\u5909\u66F4",
            editMemberName: "\u30E1\u30F3\u30D0\u30FC\u3092\u5909\u66F4",
            editCustomerInfo: "\u60C5\u5831\u3092\u5909\u66F4",
            editCustomer: "\u60C5\u5831\u3092\u5909\u66F4",
            downloadInvoices: "\u8ACB\u6C42\u66F8 \u30FB \u7D0D\u54C1\u66F8 \u30FB \u9818\u53CE\u66F8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
            expandOrder: "ID\u6570\u8FFD\u52A0",
            changeCard: "\u652F\u6255\u3044\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u306E\u5909\u66F4",
            batchAddMembers: "\u4E00\u62EC\u767B\u9332",
            batchDeleteMembers: "\u4E00\u62EC\u524A\u9664",
            activeMember: "\u30E1\u30F3\u30D0\u30FCID\u3092\u6709\u52B9\u5316",
            deleteMember: "\u30E1\u30F3\u30D0\u30FCID\u3092\u524A\u9664",
            payOrder: "\u6CE8\u6587\u306E\u652F\u6255\u3044",
            cancelOrder: "\u6CE8\u6587\u306E\u30AD\u30E3\u30F3\u30BB\u30EB",
            exportMember: "\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
            buyOrder: "\u30D7\u30E9\u30F3\u3092\u8CFC\u5165",
            URLreset: "URL\u3092\u30EA\u30BB\u30C3\u30C8",
            FolderSharing: "\u30D5\u30A9\u30EB\u30C0\u3092\u5171\u6709",
            planCancelApplication: "\u30D7\u30E9\u30F3\u89E3\u7D04\u7533\u8ACB",
            editLink: "\u30EA\u30F3\u30AF\u5909\u66F4",
            PermissionChange: "\u6A29\u9650\u3092\u5909\u66F4",
            moveModelHome: "\u30E2\u30C7\u30EB\u3092\u79FB\u52D5",
            moveFolderHome: "\u30D5\u30A9\u30EB\u30C0\u3092\u79FB\u52D5",
            copyLink: "\u30E2\u30C7\u30EB\u3092\u8EE2\u9001",
            changeLink: "\u30EA\u30F3\u30AF\u3092\u5909\u66F4",
            changeLinkPassword: "\u30EA\u30F3\u30AF\u3092\u5909\u66F4",
            resetPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8",
            addMemberNew: "\u30E1\u30F3\u30D0\u30FC\u3092\u767B\u9332",
            editMemberStatus: "\u30E1\u30F3\u30D0\u30FC\u3092\u5909\u66F4",
            editMemberNew: "\u30E1\u30F3\u30D0\u30FC\u3092\u5909\u66F4",
            enable: "\u30E1\u30F3\u30D0\u30FC\u3092\u6709\u52B9\u5316",
            disable: "\u30E1\u30F3\u30D0\u30FC\u3092\u7121\u52B9\u5316",
            changeSeat: "Scanat\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u3092\u5909\u66F4",
            changeRole: "\u6A29\u9650\u8A2D\u5B9A\u3092\u5909\u66F4",
            uploadFile: "\u30E2\u30C7\u30EB\u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8",
            manageCollaborator: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u7BA1\u7406",
            moveFolderToFolder: "\u30D5\u30A9\u30EB\u30C0\u3092\u79FB\u52D5",
            moveFolderToRoot: "\u30D5\u30A9\u30EB\u30C0\u3092\u79FB\u52D5",
            moveModelToFolder: "\u30E2\u30C7\u30EB\u3092\u79FB\u52D5",
            moveModelToRoot: "\u30E2\u30C7\u30EB\u3092\u79FB\u52D5",
            addCollaborator: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u7BA1\u7406",
            deleteCollaborator: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u7BA1\u7406",
            updateCollaborator: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u7BA1\u7406",
            inviteCollaborator: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0",
            resentInvite: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0",
            resentInviteWithDate: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0",
            acceptInvite: "\u62DB\u5F85\u3092\u627F\u8AFE",
            viewFolder: "\u30D5\u30A9\u30EB\u30C0\u3092\u958B\u304F",
            uploadToFolder: "\u30E2\u30C7\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
            uploadToRoot: "\u30E2\u30C7\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
            importFileToRoot: "\u30E2\u30C7\u30EB\u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8",
            importFileToFolder: "\u30E2\u30C7\u30EB\u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8"
        },
        detail: {
            register: "\u65B0\u898F\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002",
            login: "\u30B7\u30B9\u30C6\u30E0\u306B\u30ED\u30B0\u30A4\u30F3\u3057\u307E\u3057\u305F\u3002",
            cancellation: "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u307E\u3057\u305F\u3002",
            deleteModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u524A\u9664\u3057\u307E\u3057\u305F\u3002",
            addModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u300C{detail1}\u300D\u3067\u30B9\u30AD\u30E3\u30F3\u3057\u307E\u3057\u305F\u3002",
            viewModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002",
            editModelInfo: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u60C5\u5831\u3092\u300C\u30E2\u30C7\u30EB\u540D\uFF1A{detail1}\uFF1B\u90F5\u4FBF\u756A\u53F7\uFF1A{detail2}\uFF1B\u4F4F\u6240\uFF1A{detail3}\uFF1B\u5EFA\u7269\u540D\uFF1A{detail4}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            editModelAvatar: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u30AB\u30D0\u30FC\u753B\u50CF\u3092\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            editModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306B\u300C{detail1}\u300D\u64CD\u4F5C\u3092\u884C\u3044\u307E\u3057\u305F\u3002",
            moveModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u30D5\u30A9\u30EB\u30C0\u300C{detail1}\u300D\u306B\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002",
            uploadModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u30AF\u30E9\u30A6\u30C9\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002",
            exportModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u30C7\u30FC\u30BF\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u3057\u307E\u3057\u305F\u3002",
            copyModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u300C{detail1}\u300D\u3068\u3057\u3066\u8907\u88FD\u3057\u307E\u3057\u305F\u3002",
            applyCad: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306ECAD\u56F3\u9762\u4F5C\u6210\u3092\u4F9D\u983C\u3057\u307E\u3057\u305F\u3002",
            addFolder: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u3092\u65B0\u898F\u4F5C\u6210\u3057\u307E\u3057\u305F\u3002",
            editFolder: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u306E\u540D\u79F0\u3092\u300C{detail1}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            deleteFolder: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u3092\u524A\u9664\u3057\u307E\u3057\u305F\u3002",
            moveFolder: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u3092\u30D5\u30A9\u30EB\u30C0\u300C{detail1}\u300D\u306B\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002",
            downloadModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002",
            viewSampleModel: "\u30E2\u30C7\u30EB\u300C\u30B5\u30F3\u30D7\u30EB\u30E2\u30C7\u30EB\u300D\u3092\u78BA\u8A8D\u3057\u307E\u3057\u305F\u3002",
            editModelName: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u540D\u79F0\u3092\u300C{detail1}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            buyAccountPlan: "\u300C{detail0}\u300D\u3092\u8CFC\u5165\u3057\u307E\u3057\u305F\u3002ID\u4E0A\u9650\u306F{detail1}\u3067\u3001\u91D1\u984D\u306F\u7A0E\u8FBC{detail2}\u5186\u3001\u652F\u6255\u3044\u65B9\u6CD5\u306F\u300C{detail3}\u300D\u3067\u3059\u3002",
            addEnableMember: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002\u72B6\u614B\u306F\u300C\u6709\u52B9\u300D\u3067\u3059\u3002",
            addDisableMember: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002\u72B6\u614B\u306F\u300C\u4F7F\u7528\u4E0D\u53EF\u300D\u3067\u3059\u3002",
            inviteMember: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002\u4ECA\u306F\u76F8\u624B\u306E\u627F\u8AFE\u5F85\u3061\u72B6\u614B\u3067\u3059\u3002",
            enableMember: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u306E\u72B6\u614B\u3092\u300C\u6709\u52B9\u300D\u306B\u8A2D\u5B9A\u3057\u307E\u3057\u305F\u3002",
            disableMember: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u306E\u72B6\u614B\u3092\u300C\u4F7F\u7528\u4E0D\u53EF\u300D\u306B\u8A2D\u5B9A\u3057\u307E\u3057\u305F\u3002",
            setMemberAdmin: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u7BA1\u7406\u8005\u306B\u8A2D\u5B9A\u3057\u307E\u3057\u305F\u3002",
            unsetMemberAdmin: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u306E\u7BA1\u7406\u8005\u6A29\u9650\u3092\u89E3\u9664\u3057\u307E\u3057\u305F\u3002",
            editMemberName: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u306E\u540D\u524D\u3092\u300C{detail1}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            editCustomerInfo: "\u4F1A\u793E\u60C5\u5831\u3092\u300C\u90F5\u4FBF\u756A\u53F7\uFF1A{detail0}\u3001\u90FD\u9053\u5E9C\u770C\uFF1A{detail1}\u3001\u5E02\u6751\u753A\uFF1A{detail2}\u3001\u4F4F\u6240\uFF1A{detail3}\u3001\u8CAC\u4EFB\u8005\u59D3\uFF1A{detail4}\u3001\u8CAC\u4EFB\u8005\u540D\uFF1A{detail5}\u3001\u96FB\u8A71\u756A\u53F7\uFF1A{detail6}\u3001\u696D\u7A2E\uFF1A{detail7}\u3001\u5F93\u696D\u54E1\u6570\uFF1A{detail8}\u3001\u4E3B\u8981\u696D\u52D9\uFF1A{detail9}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            downloadInvoices: "\u6CE8\u6587\u300C{detail0}\u300D\u306E\u8ACB\u6C42\u66F8\u3092\u30ED\u30FC\u30AB\u30EB\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002",
            moveModelHome: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u300C\u30DB\u30FC\u30E0\u300D\u306B\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002",
            moveFolderHome: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u3092\u300C\u30DB\u30FC\u30E0\u300D\u306B\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002",
            expandOrder: "\u300CID\u6570\u8FFD\u52A0\u300D\u6CE8\u6587\u3092\u63D0\u51FA\u3057\u307E\u3057\u305F\u3002\u6CE8\u6587\u60C5\u5831\uFF1A\u300C\u6CE8\u6587\u756A\u53F7\uFF1A{detail0}\uFF1B\u30D7\u30E9\u30F3\uFF1A{detail1}\uFF1B\u6CE8\u6587\u30BF\u30A4\u30D7\uFF1AID\u8FFD\u52A0\uFF1B\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u5F62\u5F0F\uFF1A{detail2}\uFF1B\u8FFD\u52A0ID\u6570\uFF1A{detail3}\uFF1B\u958B\u59CB\u65E5\uFF1A{detail4}\uFF1B\u91D1\u984D\uFF1A{detail5}\uFF1B\u7A0E\u91D1\uFF1A{detail6}\uFF1B\u652F\u6255\u91D1\u984D\uFF1A{detail7}\u300D",
            buyOrder: "\u300C\u30D7\u30E9\u30F3\u8CFC\u5165\u300D\u6CE8\u6587\u3092\u63D0\u51FA\u3057\u307E\u3057\u305F\u3002\u6CE8\u6587\u60C5\u5831\uFF1A\u300C\u6CE8\u6587\u756A\u53F7\uFF1A{detail0}\uFF1B\u30D7\u30E9\u30F3\uFF1A{detail1}\uFF1B\u6CE8\u6587\u30BF\u30A4\u30D7\uFF1A\u8CFC\u5165\uFF1B\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u5F62\u5F0F\uFF1A{detail2}\uFF1BID\u6570\uFF1A{detail3};  \u91D1\u984D\uFF1A{detail4}\uFF1B\u7A0E\u91D1\uFF1A{detail5}\uFF1B\u652F\u6255\u91D1\u984D\uFF1A{detail6}\u300D",
            changeCard: "\u652F\u6255\u3044\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3092{detail0}\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            addMember: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002\u72B6\u614B\u306F\u300C{detail1}\u300D\u3067\u3059\u3002",
            batchAddMembers: "{detail0}\u4EBA\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u4E00\u62EC\u3067\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002",
            batchDeleteMembers: "{detail0}\u4EBA\u306E\u30E1\u30F3\u30D0\u30FC\u3092\u4E00\u62EC\u3067\u524A\u9664\u3057\u307E\u3057\u305F\u3002",
            exportMember: "\u30E1\u30F3\u30D0\u30FC\u30EA\u30B9\u30C8\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u3057\u307E\u3057\u305F\u3002",
            activeMember: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u6709\u52B9\u5316\u3057\u307E\u3057\u305F\u3002",
            deleteMember: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u524A\u9664\u3057\u307E\u3057\u305F\u3002",
            editCustomer: "\u4F1A\u793E\u60C5\u5831\u3092\u300C\u4F1A\u793E\u540D\uFF1A{detail0}\u3001\u62C5\u5F53\u8005\uFF1A{detail1}\u3001{detail2}\u3001{detail3}\uFF1B\u90F5\u4FBF\u756A\u53F7\uFF1A{detail4}\uFF1B\u4F4F\u6240\uFF1A{detail5}\uFF1B\u696D\u7A2E\uFF1A{detail6}\uFF1B\u5F93\u696D\u54E1\u6570\uFF1A{detail7}\uFF1B\u8CC7\u672C\u91D1\uFF1A{detail8}\uFF1B\u4E3B\u8981\u696D\u52D9\uFF1A{detail9}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            payOrder: "\u6CE8\u6587\u300C{detail0}\u300D\u306E\u652F\u6255\u3044\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u652F\u6255\u3044\u65B9\u6CD5\u306F\u300C{detail1}\u300D\u3067\u3059\u3002",
            cancelOrder: "\u6CE8\u6587\u300C{detail0}\u300D\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F\u3002",
            SendModelViewable: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u30E6\u30FC\u30B6\u30FC\u300C{detail1}\u300D\u306B\u8EE2\u9001\u3057\u307E\u3057\u305F\u3002\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306F\u300C\u95B2\u89A7\u53EF\u80FD\u300D\u3067\u3059\u3002",
            CopiedModelPrivateLink: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u300C\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30EA\u30F3\u30AF\u300D\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002",
            AddedModelMember: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306B\u30E1\u30F3\u30D0\u30FC\u300C{detail1}\u300D\u3092\u300C\u95B2\u89A7\u53EF\u80FD\u300D\u6A29\u9650\u3067\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002",
            UpdatedModelMember: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u30E1\u30F3\u30D0\u30FC\u300C{detail1}\u300D\u306E\u6A29\u9650\u3092\u300C\u7DE8\u96C6\u53EF\u80FD\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            RemovedModelViewable: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u304B\u3089\u30E1\u30F3\u30D0\u30FC\u300C{detail1}\u300D\u306E\u300C\u95B2\u89A7\u53EF\u80FD\u300D\u6A29\u9650\u3092\u524A\u9664\u3057\u307E\u3057\u305F\u3002",
            ResetModelPrivateLink: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u300C\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30EA\u30F3\u30AF\u300D\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3057\u305F\u3002",
            SharedFolder: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u3092\u30E6\u30FC\u30B6\u30FC\u300C{detail1}\u300D\u306B\u5171\u6709\u3057\u307E\u3057\u305F\u3002",
            CopiedFolderPublicLink: "\u30D5\u30A9\u30EB\u30C0\u30FC\u300C{detail0}\u300D\u306E\u300C\u516C\u958B\u30EA\u30F3\u30AF\u300D\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002",
            ResetModelPublicLink: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u300C\u516C\u958B\u30EA\u30F3\u30AF\u300D\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3057\u305F\u3002",
            SendModelEditable: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u30E6\u30FC\u30B6\u30FC\u300C{detail1}\u300D\u306B\u8EE2\u9001\u3057\u307E\u3057\u305F\u3002\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306F\u300C\u7DE8\u96C6\u53EF\u80FD\u300D\u3067\u3059\u3002",
            RenamedFolder: "\u30D5\u30A9\u30EB\u30C0\u30FC\u300C{detail0}\u300D\u3092\u300C\u30D5\u30A9\u30EB\u30C0\u30FC\u540D\uFF1A{detail1}\uFF1B\u6982\u8981\uFF1A{detail2}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            SharedFolderViewable: "\u30D5\u30A9\u30EB\u30C0\u30FC\u300C{detail0}\u300D\u3092\u30E6\u30FC\u30B6\u30FC\u300C{detail1}\u300D\u306B\u5171\u6709\u3057\u307E\u3057\u305F\u3002\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306F\u300C\u95B2\u89A7\u53EF\u80FD\u300D\u3067\u3059\u3002",
            CopiedFolderPrivateLink: "\u30D5\u30A9\u30EB\u30C0\u30FC\u300C{detail0}\u300D\u306E\u300C\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30EA\u30F3\u30AF\u300D\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002",
            AddedFolderMember: "\u30D5\u30A9\u30EB\u30C0\u30FC\u300C{detail0}\u300D\u306B\u30E1\u30F3\u30D0\u30FC\u300C{detail1}\u300D\u3092\u300C\u95B2\u89A7\u53EF\u80FD\u300D\u6A29\u9650\u3067\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002",
            UpdatedFolderMember: "\u30D5\u30A9\u30EB\u30C0\u30FC\u300C{detail0}\u300D\u306E\u30E1\u30F3\u30D0\u30FC\u300C{detail1}\u300D\u306E\u6A29\u9650\u3092\u300C\u7DE8\u96C6\u53EF\u80FD\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            RemovedFolderViewable: "\u30D5\u30A9\u30EB\u30C0\u30FC\u300C{detail0}\u300D\u304B\u3089\u30E1\u30F3\u30D0\u30FC\u300C{detail1}\u300D\u306E\u300C\u95B2\u89A7\u53EF\u80FD\u300D\u6A29\u9650\u3092\u524A\u9664\u3057\u307E\u3057\u305F\u3002",
            ResetFolderPublicLink: "\u30D5\u30A9\u30EB\u30C0\u30FC\u300C{detail0}\u300D\u306E\u300C\u516C\u958B\u30EA\u30F3\u30AF\u300D\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3057\u305F\u3002",
            addModel1: "\u9593\u53D6\u308A\u30B9\u30AD\u30E3\u30F3",
            addModel2: "\u30CE\u30FC\u30DE\u30EB\u308A\u30B9\u30AD\u30E3\u30F3",
            editModel1: "\u5207\u308A\u53D6\u308A",
            editModel2: "\u4F4D\u7F6E\u3092\u5408\u308F\u305B\u308B",
            editModel3: "\u5909\u5F62",
            buyAccountPlan2: "\u8ACB\u6C42\u66F8",
            buyAccountPlan1: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9",
            editCustomerSex0: "\u7537",
            editCustomerSex1: "\u5973",
            editCustomerInfo1: "\u5EFA\u8A2D\u696D",
            editCustomerInfo2: "\u88FD\u9020\u696D",
            editCustomerInfo3: "\u4E0D\u52D5\u7523\u696D\u30FB\u7269\u54C1\u8CC3\u8CB8\u696D",
            editCustomerInfo4: "\u60C5\u5831\u901A\u4FE1\u696D",
            editCustomerInfo5: "\u96FB\u6C17\u30FB\u30AC\u30B9\u30FB\u71B1\u4F9B\u7D66\u30FB\u6C34\u9053\u696D",
            editCustomerInfo6: "\u904B\u8F38\u696D\u30FB\u90F5\u4FBF\u696D",
            editCustomerInfo7: "\u60C5\u5831\u51E6\u7406\u30B5\u30FC\u30D3\u30B9\u696D",
            editCustomerInfo8: "\u5B66\u8853\u7814\u7A76\u30FB\u5C02\u9580\u30FB\u6280\u8853\u30B5\u30FC\u30D3\u30B9\u696D",
            editCustomerInfo9: "\u5378\u58F2\u696D\u30FB\u5C0F\u58F2\u696D",
            editCustomerInfo10: "\u30EA\u30B5\u30FC\u30C1\u696D",
            editCustomerInfo0: '-',
            editCustomerInfoStaff1: '1~50',
            editCustomerInfoStaff2: '51~100',
            editCustomerInfoStaff3: "100\u540D\u4EE5\u4E0A",
            editCustomerInfoStaff0: '-',
            editCustomer1: "\u5EFA\u8A2D\u696D",
            editCustomer2: "\u88FD\u9020\u696D",
            editCustomer3: "\u4E0D\u52D5\u7523\u696D\u30FB\u7269\u54C1\u8CC3\u8CB8\u696D",
            editCustomer4: "\u60C5\u5831\u901A\u4FE1\u696D",
            editCustomer5: "\u96FB\u6C17\u30FB\u30AC\u30B9\u30FB\u71B1\u4F9B\u7D66\u30FB\u6C34\u9053\u696D",
            editCustomer6: "\u904B\u8F38\u696D\u30FB\u90F5\u4FBF\u696D",
            editCustomer7: "\u60C5\u5831\u51E6\u7406\u30B5\u30FC\u30D3\u30B9\u696D",
            editCustomer8: "\u5B66\u8853\u7814\u7A76\u30FB\u5C02\u9580\u30FB\u6280\u8853\u30B5\u30FC\u30D3\u30B9\u696D",
            editCustomer9: "\u5378\u58F2\u696D\u30FB\u5C0F\u58F2\u696D",
            editCustomer10: "\u30EA\u30B5\u30FC\u30C1\u696D",
            editCustomer0: '-',
            editCustomerStaff1: '1~50',
            editCustomerStaff2: '51~100',
            editCustomerStaff3: "100\u540D\u4EE5\u4E0A",
            editCustomerStaff0: '-',
            payOrder1: "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9",
            payOrder2: "\u8ACB\u6C42\u66F8",
            addMember0: "\u6709\u52B9\u5316\u5F85\u3061",
            addMember1: "\u5229\u7528\u4E2D",
            period1: "\u5E74\u6255\u3044",
            period2: "\u6708\u6255\u3044",
            planCancelApplication: "\u30D7\u30E9\u30F3\u89E3\u7D04\u7533\u8ACB\u3092\u63D0\u51FA\u3057\u307E\u3057\u305F\u3002",
            shareModel: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u30E6\u30FC\u30B6\u30FC\u300C{detail1}\u300D\u306B\u8EE2\u9001\u3057\u307E\u3057\u305F\u3002",
            copyModelShareLink: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u5171\u6709\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002",
            changeLinkPassword: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u4ED8\u304D\u30EA\u30F3\u30AF\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            ResetModelLink: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u300C{detail1}\u300D\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3057\u305F\u3002",
            ResetFolderLink: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u306E\u300C{detail1}\u300D\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3057\u305F\u3002",
            resetPassword: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u307E\u3057\u305F\u3002",
            copyLink1: "\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30EA\u30F3\u30AF",
            copyLink2: "\u30D1\u30B9\u30EF\u30FC\u30C9\u4ED8\u304D\u30EA\u30F3\u30AF",
            copyLink3: "\u516C\u958B\u30EA\u30F3\u30AF",
            changeLink1: "\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30EA\u30F3\u30AF",
            changeLink2: "\u30D1\u30B9\u30EF\u30FC\u30C9\u4ED8\u304D\u30EA\u30F3\u30AF",
            changeLink3: "\u516C\u958B\u30EA\u30F3\u30AF",
            copyLink: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u300C{detail1}\u300D\u3092\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002",
            changeLink: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u306E\u5171\u6709\u30EA\u30F3\u30AF\u6A29\u9650\u3092\u300C{detail1}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            editMemberStatus: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u306E\u72B6\u614B\u3092\u300C{detail1}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            addMemberNew: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002\u6A29\u9650\u8A2D\u5B9A\uFF1A\u300C{detail1}\u300D\uFF1BScanat \u30B5\u30FC\u30D3\u30B9\u5229\u7528\u8A2D\u5B9A\uFF1A\u300C{detail2}\u300D\uFF1B\u30B9\u30C6\u30FC\u30BF\u30B9\uFF1A\u300C\u5229\u7528\u4E2D\u300D",
            editMemberNew: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u306E\u540D\u524D\u3092\u300C{detail1}\u300D\u306B\u3001\u6A29\u9650\u8A2D\u5B9A\u3092\u300C{detail2}\u300D\u306B\u3001Scanat \u30B5\u30FC\u30D3\u30B9\u5229\u7528\u8A2D\u5B9A\u3092\u300C{detail3}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            enable: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u6709\u52B9\u5316\u3057\u307E\u3057\u305F\u3002",
            disable: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u3092\u7121\u52B9\u5316\u3057\u307E\u3057\u305F\u3002",
            changeSeat: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u306EScanat \u30B5\u30FC\u30D3\u30B9\u5229\u7528\u8A2D\u5B9A\u3092\u300C{detail1}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            changeRole: "\u30E1\u30F3\u30D0\u30FC\u300C{detail0}\u300D\u306E\u6A29\u9650\u8A2D\u5B9A\u3092\u300C{detail1}\u300D\u306B\u5909\u66F4\u3057\u307E\u3057\u305F\u3002",
            role1: "\u30B9\u30FC\u30D1\u30FC\u7BA1\u7406\u8005",
            role3: "\u7BA1\u7406\u8005",
            role0: "Scanat\u30E6\u30FC\u30B6\u30FC",
            role4: "\u95B2\u89A7\u30E6\u30FC\u30B6\u30FC",
            changeSeat1: "\u30AA\u30F3",
            changeSeat0: "\u30AA\u30D5",
            uploadFile: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3057\u305F\u3002\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u306F{detail1}\u3067\u3059\u3002",
            uploadToFolder: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092{detail1}\u306E\u30D5\u30A9\u30EB\u30C0\u300C{detail2}\u300D\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002",
            uploadToRoot: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092{detail1}\u306E\u300C\u30DB\u30FC\u30E0\u300D\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002",
            moveFolderToFolder: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u3092{detail1}\u306E\u30D5\u30A9\u30EB\u30C0\u300C{detail2}\u300D\u306B\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002",
            moveFolderToRoot: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u3092{detail1}\u306E\u300C\u30DB\u30FC\u30E0\u300D\u306B\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002",
            moveModelToFolder: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092{detail1}\u306E\u30D5\u30A9\u30EB\u30C0\u300C{detail2}\u300D\u306B\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002",
            moveModelToRoot: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092{detail1}\u306E\u300C\u30DB\u30FC\u30E0\u300D\u306B\u79FB\u52D5\u3057\u307E\u3057\u305F\u3002",
            addCollaborator: "\u300C{detail2}\u300D\u3092{detail0}\u300C{detail1}\u300D\u306E\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3001\u6A29\u9650\u3092\u300C{detail3}\u300D\u306B\u8A2D\u5B9A\u3057\u307E\u3057\u305F\u3002",
            deleteCollaborator: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u300C{detail2}\u300D\u3092{detail0}\u300C{detail1}\u300D\u304B\u3089\u524A\u9664\u3057\u307E\u3057\u305F\u3002",
            updateCollaborator: "{detail0}\u300C{detail1}\u300D\u306E\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u300C{detail2}\u300D\u306E\u6A29\u9650\u3092\u300C{detail3}\u300D\u306B\u8A2D\u5B9A\u3057\u307E\u3057\u305F\u3002",
            space0: "\u500B\u4EBA\u30B9\u30DA\u30FC\u30B9",
            space1: "\u30C1\u30FC\u30E0\u30B9\u30DA\u30FC\u30B9",
            fileType0: "\u30E2\u30C7\u30EB",
            fileType1: "\u30D5\u30A9\u30EB\u30C0",
            collaboratorPermission0: "\u95B2\u89A7\u306E\u307F",
            collaboratorPermission1: "\u7DE8\u96C6\u53EF\u80FD",
            collaboratorPermission2: "\u7BA1\u7406\u53EF\u80FD",
            importFile: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3057\u305F\u3002\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u306F{detail1}\u3067\u3059\u3002",
            inviteCollaborator: "\u300C{detail0}\u300D\u306B\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u306E\u62DB\u5F85\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002\u6A29\u9650\u306F{detail1}\u3001\u6709\u52B9\u671F\u9650\u306F{detail2}\u65E5\u3067\u3059\u3002",
            resentInvite: "\u300C{detail0}\u300D\u306B\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u306E\u62DB\u5F85\u3092\u518D\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002",
            resentInviteWithDate: "\u300C{detail0}\u300D\u306B\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u306E\u62DB\u5F85\u3092\u518D\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002\u6709\u52B9\u671F\u9650\u306F{detail1}\u65E5\u3067\u3059\u3002",
            acceptInvite: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u306E\u62DB\u5F85\u3092\u627F\u8AFE\u3057\u307E\u3057\u305F\u3002",
            viewFolder: "\u30D5\u30A9\u30EB\u30C0\u300C{detail0}\u300D\u3092\u958B\u304D\u307E\u3057\u305F\u3002",
            importFileToRoot: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092{detail1}\u306E\u30EB\u30FC\u30C8\u30C7\u30A3\u30EC\u30AF\u30C8\u30EA\u306B\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u306F{detail2}\u3067\u3059\u3002",
            importFileToFolder: "\u30E2\u30C7\u30EB\u300C{detail0}\u300D\u3092{detail1}\u306E\u30D5\u30A9\u30EB\u30C0\u300C{detail2}\u300D\u306B\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002\u30D5\u30A1\u30A4\u30EB\u5F62\u5F0F\u306F{detail3}\u3067\u3059\u3002"
        }
    },
    period: {
        lastWeek: "\u904E\u53BB1\u9031\u9593",
        lastMonth: "\u904E\u53BB1\u304B\u6708",
        lastYear: "\u904E\u53BB1\u5E74"
    },
    menu: {
        company: "\u4F1A\u793E\u60C5\u5831",
        log: "\u64CD\u4F5C\u30ED\u30B0",
        order: "\u6CE8\u6587\u5C65\u6B74",
        team: "ID\u7BA1\u7406"
    },
    title: {
        team: "ID\u7BA1\u7406",
        company: "\u4F1A\u793E\u60C5\u5831",
        order: "\u6CE8\u6587\u5C65\u6B74",
        log: "\u64CD\u4F5C\u30ED\u30B0",
        buy: "\u5546\u54C1\u8CFC\u5165",
        pay: "\u6CE8\u6587\u306E\u304A\u652F\u6255\u3044",
        paySuccess: "\u304A\u652F\u6255\u3044\u5B8C\u4E86",
        orderInfo: "\u3054\u6CE8\u6587\u306E\u8A73\u7D30",
        land: "\u5229\u7528\u30B5\u30FC\u30D3\u30B9\u9078\u629E",
        link: {
            useless: "\u30EA\u30F3\u30AF\u304C\u7121\u52B9\u3067\u3059",
            notExist: "\u30EA\u30F3\u30AF\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093"
        }
    },
    SUCCESS: "\u64CD\u4F5C\u5B8C\u4E86",
    VALIDATE_FAILED: "\u30D1\u30E9\u30E1\u30FC\u30BF\u691C\u8A3C\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    UNAUTHORIZED: "\u307E\u3060\u767B\u9332\u3055\u308C\u3066\u3044\u306A\u3044\u304B\u3001\u30ED\u30B0\u30A4\u30F3\u30BB\u30C3\u30B7\u30E7\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u307E\u3057\u305F\u3002",
    INVALID_PASSWORD: "\u30E6\u30FC\u30B6\u30FC\u540D\u3068\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    UNAVAILABLE: "\u767B\u9332\u3055\u308C\u305F\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u306F\u6CD5\u4EBA\u5951\u7D04\u5F8C\u306B\u55B6\u696D\u62C5\u5F53\u8005\u306B\u3088\u308B\u30A2\u30AF\u30C6\u30A3\u30D9\u30FC\u30B7\u30E7\u30F3\u304C\u5FC5\u8981\u3067\u3059\u3002\u3054\u691C\u8A0E\u3044\u305F\u3060\u3051\u308B\u65B9\u306F\u306B\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002",
    FORBIDDEN: "\u5FC5\u8981\u306A\u6A29\u9650\u304C\u4ED8\u4E0E\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    POSTCODE_NOT_EXIST: "\u90F5\u4FBF\u756A\u53F7\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    NOT_REGISTERED: "\u3053\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    VERIFICATION_CODE_ERROR: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    VERIFICATION_CODE_EXPIRE: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002",
    USER_NOT_EXIST: "\u3053\u306E\u30E6\u30FC\u30B6\u30FC\u306F\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    CRM_ACCOUNT_NOT_EXIST: "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30FC\u30D3\u30B9\u306B\u9023\u7D61\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    USER_EXIST: "\u3053\u306E\u30E6\u30FC\u30B6\u30FC\u306F\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    CONFIRM_PASSWORD: "\u5165\u529B\u3055\u308C\u305F\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002",
    FILE_UPLOAD_KEY_GET_FAIL: "\u30AD\u30FC\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3002",
    MODEL_NOT_BELONG: "\u3053\u306E\u30E2\u30C7\u30EB\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u6240\u6709\u3057\u3066\u3044\u307E\u3059\u3002",
    FAILED: "\u64CD\u4F5C\u5931\u6557",
    REQUEST_FREQUENTLY: "\u64CD\u4F5C\u304C\u983B\u7E41\u3059\u304E\u307E\u3059\u3002\u3057\u3070\u3089\u304F\u6642\u9593\u3092\u304A\u3044\u3066\u304B\u3089\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    FILE_SHARE_ERROR_DEL: "\u8EE2\u9001\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u30D5\u30A1\u30A4\u30EB\u304C\u3059\u3067\u306B\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
    FILE_SHARE_ERROR_UNAUTHORIZED: "\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    FILE_SHARE_ERROR_EMAIL_NOT_EXISTS: "\u30E6\u30FC\u30B6\u30FCID\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    FILE_SHARE_ERROR_UNKNOWN: "\u672A\u77E5\u306E\u30A8\u30E9\u30FC",
    FILE_SHARE_ERROR_REPEAT_SHARING: "\u30E2\u30C7\u30EB\u306F\u3059\u3067\u306B\u3053\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u8EE2\u9001\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
    FILE_SHARE_ERROR_SELF: "\u81EA\u5206\u306B\u8EE2\u9001\u3067\u304D\u307E\u305B\u3093\u3002",
    FILE_SHARE_UPDATE_FAIL: "\u66F4\u65B0\u5931\u6557\u3002\u8EE2\u9001\u3055\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    FILE_DOWNLOAD_ERROR_DEL: "\u30D5\u30A1\u30A4\u30EB\u304C\u3059\u3067\u306B\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u305F\u3081\u3001\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u307E\u305B\u3093\u3002",
    FILE_SHARE_DEL_FAIL: "\u8EE2\u9001\u3055\u308C\u305F\u30E2\u30C7\u30EB\u304C\u306A\u3044\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    FILE_SHARE_DEL_FAIL_NO_AUTHORITY: "\u8EE2\u9001\u3055\u308C\u305F\u30E2\u30C7\u30EB\u306F\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    CREDIT_CARD_PAY_ERROR: "\u8CFC\u8AAD\u306E\u5FA9\u5143\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    CREDIT_CARD_PAY_FAIL_BY_ERROR_FILE_KEY: "\u30AB\u30FC\u30C9\u652F\u6255\u3044\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u539F\u56E0\uFF1A\u30C7\u30FC\u30BF\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    PERMITS_CONVERT_FAIL: "\u8CFC\u8AAD\u306E\u5FA9\u5143\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    PERMITS_CONVERT_FAIL_USER_NULL: "\u8CFC\u8AAD\u306E\u5FA9\u5143\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    APP_TRANSLATION_INVALID: "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093",
    APP_TRANSLATION_HISTORY_GET_FAIL: "\u8CFC\u8AAD\u30C7\u30FC\u30BF\u306E\u53D6\u5F97\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    APP_TRANSLATION_STATUS_GET_FAIL: "\u8CFC\u8AAD\u30C7\u30FC\u30BF\u306E\u53D6\u5F97\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    FILE_UPLOAD_FILE_PATH_EMP_ERROR: "\u66F4\u65B0\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A\u30D5\u30A1\u30A4\u30EB\u30D1\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
    FILE_UPLOAD_FILE_DB_FAIL_ERROR: "\u66F4\u65B0\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A\u30E2\u30C7\u30EB\u8A18\u9332\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    APP_TOKEN_GET_FAIL: "\u30D1\u30E9\u30E1\u30FC\u30BF\u30FC\u306E\u53D6\u5F97\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    APP_IP_ADDRESS_NOT_ALLOW: "IP\u30A2\u30C9\u30EC\u30B9\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093\u3002",
    CONTACT_ALREADY_EXIST: "\u9023\u7D61\u5148\u304C\u65E2\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    ACCOUNT_PLAN_NOT_EXIST: "\u30D7\u30E9\u30F3\u3092\u8CFC\u5165\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
    ACCOUNT_PLAN_TYPE_ERROR: "\u30D7\u30E9\u30F3\u306E\u30BF\u30A4\u30D7\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    ACCOUNT_PLAN_DOWNGRADE: "\u73FE\u5728\u306E\u30D7\u30E9\u30F3\u3088\u308A\u4F4E\u3044\u30D7\u30E9\u30F3\u3078\u306E\u5909\u66F4\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    ACCOUNT_PLAN_PREPAY_MONTH_ERROR: "\u30D7\u30E9\u30F3\u306E\u60C5\u5831\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    ACCOUNT_PLAN_PREPAY_MONTH_NOT_OVER: "\u524D\u6255\u3044\u671F\u9593\u304C\u7D42\u4E86\u3059\u308B\u307E\u3067\u3001\u30D7\u30E9\u30F3\u3092\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3002",
    CUSTOMER_FINCODE_CUSTOMER_ID_NOT_EXIST: "\u30E6\u30FC\u30B6\u30FC\u306EFincode ID\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    FINCODE_PLAN_ID_NOT_EXIST: "Fincode ID\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    CUSTOMER_NAME_DUPLICATE: "\u30E6\u30FC\u30B6\u30FC\u540D\u306F\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002\u518D\u5EA6\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    CUSTOMER_NAME_BLANK_NOT_ALLOW: "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    ACCOUNT_NOT_EXIST: "\u30E6\u30FC\u30B6\u30FCID\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    CUSTOMER_NOT_EXIST: "\u30E6\u30FC\u30B6\u30FC\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    FINCODE_CARD_ID_BLANK_NOT_ALLOW: "Fincode ID\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    CUSTOMER_NOT_BOUND_TO_ACCOUNT_PLAN: "\u30E6\u30FC\u30B6\u30FC\u306F\u30D7\u30E9\u30F3\u3068\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    CUSTOMER_ACCOUNT_PLAN_NOT_IN_EFFECT: "\u304A\u652F\u6255\u3044\u30EA\u30AF\u30A8\u30B9\u30C8\u306F\u9001\u4FE1\u6E08\u307F\u3067\u3001\u6C7A\u6E08\u7D50\u679C\u3092\u78BA\u8A8D\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002",
    ACCOUNT_IN_USE_HAS_REACHED_MAX: "\u5229\u7528\u53EF\u80FD\u306EID\u6570\u306F\u4E0A\u9650\u306B\u306A\u30EA\u307E\u3057\u305F\u3002",
    ACCOUNT_IN_USE_AND_ADD_ACCOUNT_EXCEED_MAX: "\u8FFD\u52A0\u3055\u308C\u305FID\u6570\u3068\u73FE\u5728\u5229\u7528\u4E2D\u306EID\u6570\u306E\u5408\u8A08\u304C\u3001\u30D7\u30E9\u30F3\u306EID\u6570\u4E0A\u9650\u3092\u8D85\u3048\u3066\u3044\u307E\u3059\u3002",
    ACCOUNT_EMAIL_NOT_ALLOW_DUPLICATES: "\u3053\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u3059\u3067\u306B\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
    ACCOUNT_EMAIL_ALREADY_EXISTS: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u65E2\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    ACCOUNT_LIST_CANNOT_BE_EMPTY: "\u30A2\u30AB\u30A6\u30F3\u30C8\u30EA\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    FREEE_TOKEN_GET_ERROR: "Freee\u306E\u8A8D\u8A3C\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
    FREEE_API_REQUEST_ERROR: "Freee\u306EAPI\u306B\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3068\u304D\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    FREEE_INVOICE_LIST_ERROR: "Freee\u306EAPI\u306B\u8ACB\u6C42\u66F8\u30EA\u30B9\u30C8\u306E\u53D6\u5F97\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3068\u304D\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    FREEE_INVOICE_DETAIL_ERROR: "Freee\u306EAPI\u306B\u8ACB\u6C42\u66F8\u8A73\u7D30\u306E\u53D6\u5F97\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3068\u304D\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    FREEE_ADD_INVOICE_ERROR: "Freee\u306EAPI\u306B\u8ACB\u6C42\u66F8\u306E\u8FFD\u52A0\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3068\u304D\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    FREEE_ADD_PARTNER_ERROR: "Freee\u306EAPI\u306B\u9867\u5BA2\u306E\u8FFD\u52A0\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3068\u304D\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    FREEE_UPDATE_PARTNER_ERROR: "Freee\u306EAPI\u306B\u9867\u5BA2\u306E\u66F4\u65B0\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3068\u304D\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    FREEE_PARTNER_DETAIL_ERROR: "Freee\u306EAPI\u306B\u9867\u5BA2\u60C5\u5831\u306E\u53D6\u5F97\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3068\u304D\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    FREEE_PARTNER_LIST_ERROR: "Freee\u306EAPI\u306B\u9867\u5BA2\u30EA\u30B9\u30C8\u306E\u53D6\u5F97\u3092\u30EA\u30AF\u30A8\u30B9\u30C8\u3059\u308B\u3068\u304D\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002",
    ACCOUNT_PLAN_ORDER_NOT_EXISTS: "\u9867\u5BA2\u306E\u5951\u7D04\u30D7\u30E9\u30F3\u60C5\u5831\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    CUSTOMER_ALREADY_ADDED: "\u9867\u5BA2\u60C5\u5831\u306F\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    ORDER_NOT_EXIST: "\u6CE8\u6587\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    ORDER_STATUS_ERROR: "\u6CE8\u6587\u30B9\u30C6\u30FC\u30BF\u30B9\u30A8\u30E9\u30FC",
    ORDER_PAYMENT_METHOD_NOT_ALLOW: "\u652F\u6255\u3044\u65B9\u6CD5\u304C\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    FINCODE_CUSTOMER_CARD_NOT_FOUND: "Fincode\u30AB\u30FC\u30C9\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    FREEE_PARTNER_NOT_FOUND: "Freee\u9867\u5BA2\u60C5\u5831\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    CUSTOMER_ALREADY_BOUND_PLAN: "\u652F\u6255\u4F9D\u983C\u304C\u3059\u3067\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u91CD\u8907\u3057\u3066\u9001\u4FE1\u3057\u306A\u3044\u304F\u3060\u3055\u3044\u3002",
    MY_USER_PHONE_NUMBER_ALREADY_EXISTS: "\u96FB\u8A71\u756A\u53F7\u306F\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    MY_USER_EMAIL_ALREADY_EXISTS: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    ROLE_NAME_DUPLICATE: "\u30ED\u30FC\u30EB\u540D\u306F\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DISABLED: "\u3053\u306E\u30ED\u30FC\u30EB\u306F\u73FE\u5728\u30E6\u30FC\u30B6\u30FC\u306B\u5272\u308A\u5F53\u3066\u3089\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u7121\u52B9\u5316\u3067\u304D\u307E\u305B\u3093\u3002",
    THERE_ARE_USERS_BOUND_TO_THIS_ROLE_CANNOT_UPDATE_ITS_DEPT: "\u3053\u306E\u30ED\u30FC\u30EB\u306F\u73FE\u5728\u30E6\u30FC\u30B6\u30FC\u306B\u5272\u308A\u5F53\u3066\u3089\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u7DE8\u96C6\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DELETED: "\u3053\u306E\u30ED\u30FC\u30EB\u306F\u73FE\u5728\u30E6\u30FC\u30B6\u30FC\u306B\u5272\u308A\u5F53\u3066\u3089\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    ADD_DEPT_NOT_ALLOWED_UNDER_HEADQUARTERS: "\u672C\u90E8\u306B\u4E0B\u4F4D\u90E8\u9580\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    AGENCY_DEPT_MUST_SET_POSTAL_CODE_AND_ADDRESS_INFORMATION: "\u4EE3\u7406\u5E97\u306E\u90F5\u4FBF\u756A\u53F7\u3068\u4F4F\u6240\u60C5\u5831\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    MOST_FIVE_DEPT_LEVELS: "\u90E8\u9580\u306E\u968E\u5C64\u306F\u6700\u59275\u968E\u5C64\u307E\u3067\u3068\u5236\u9650\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u3053\u308C\u4EE5\u4E0A\u968E\u5C64\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    DEPT_NAME_ALREADY_EXISTS: "\u90E8\u9580\u540D\u306F\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    THE_DEPT_HAS_SUB_DEPT: "\u3053\u306E\u90E8\u9580\u306B\u306F\u4E0B\u4F4D\u90E8\u9580\u304C\u5B58\u5728\u3059\u308B\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    THERE_ARE_USERS_IN_THIS_DEPT: "\u3053\u306E\u90E8\u9580\u306B\u306F\u30E6\u30FC\u30B6\u30FC\u304C\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    THERE_ARE_ROLES_BOUND_TO_THIS_DEPT: "\u3053\u306E\u90E8\u9580\u306B\u306F\u30ED\u30FC\u30EB\u304C\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    THERE_ARE_ACCOUNT_PLAN_BOUND_TO_THIS_DEPT: "\u3053\u306E\u90E8\u9580\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u30D7\u30E9\u30F3\u3092\u4FDD\u6709\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_ADD: "\u9867\u5BA2\u540D\u306F\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u65B0\u898F\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_DEPT_BOUND_TO_THE_CUSTOMER_DOES_NOT_EXISTS: "\u9867\u5BA2\u304C\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u90E8\u9580\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_UPDATE: "\u9867\u5BA2\u540D\u306F\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u308B\u305F\u3081\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ACTIVATE_THE_ACCOUNT: "\u3053\u306E\u9867\u5BA2\u306B\u306F\u30D7\u30E9\u30F3\u304C\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6709\u52B9\u5316\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ACTIVATE_THE_ACCOUNT: "\u3053\u306E\u9867\u5BA2\u306E\u30D7\u30E9\u30F3\u306F\u307E\u3060\u6709\u52B9\u5316\u3055\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6709\u52B9\u5316\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_BE_ACTIVATED: "\u6709\u52B9\u306A\u30A2\u30AB\u30A6\u30F3\u30C8\u6570\u304C\u4E0A\u9650\u306B\u9054\u3057\u305F\u305F\u3081\u3001\u3053\u308C\u4EE5\u4E0A\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u6709\u52B9\u5316\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_NEW_CUSTOMER_IS_NOT_BOUND_TO_ANY_ACCOUNT_PLAN_THE_ACTIVATED_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: "\u3053\u306E\u9867\u5BA2\u306B\u306F\u95A2\u9023\u3064\u3051\u3089\u308C\u305F\u30D7\u30E9\u30F3\u304C\u306A\u3044\u305F\u3081\u3001\u6709\u52B9\u306A\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u79FB\u7BA1\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_ACCOUNT_PLAN_FOR_NEW_CUSTOMER_HAS_NOT_TAKEN_EFFECT_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER: "\u3053\u306E\u9867\u5BA2\u306E\u30D7\u30E9\u30F3\u306F\u307E\u3060\u6709\u52B9\u5316\u3055\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u6709\u52B9\u306A\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u79FB\u7BA1\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: "\u3053\u306E\u9867\u5BA2\u306B\u306F\u30D7\u30E9\u30F3\u304C\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u6709\u52B9\u306A\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ADD_ACTIVATE_ACCOUNT: "\u3053\u306E\u9867\u5BA2\u306E\u30D7\u30E9\u30F3\u306F\u307E\u3060\u6709\u52B9\u5316\u3055\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u6709\u52B9\u306A\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_ADD_ACTIVATED_ACCOUNT: "\u6709\u52B9\u306A\u30A2\u30AB\u30A6\u30F3\u30C8\u6570\u304C\u3059\u3067\u306B\u30D7\u30E9\u30F3ID\u306E\u4E0A\u9650\u306B\u9054\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u6709\u52B9\u306A\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_USER_OF_THE_AGENT_STORE_DOES_NOT_HAVE_PERMISSION_TO_VIEW_THE_CAD_ORDER_LIST: "\u4EE3\u7406\u5E97\u30E6\u30FC\u30B6\u30FC\u306B\u306FCAD\u6CE8\u6587\u30EA\u30B9\u30C8\u3092\u8868\u793A\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    CAD_ORDER_HAS_BEEN_COMPLETED_NOT_ALLOW_TO_UPLOAD_FILES: "\u6CE8\u6587\u306F\u3059\u3067\u306B\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002\u30D5\u30A1\u30A4\u30EB\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_AGENT_STORE: "\u3053\u306E\u30ED\u30FC\u30EB\u306F\u672C\u90E8\u306B\u6240\u5C5E\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u4EE3\u7406\u5E97\u306E\u307F\u304C\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u30E1\u30CB\u30E5\u30FC\u306B\u306F\u95A2\u9023\u4ED8\u3051\u3089\u308C\u307E\u305B\u3093\u3002",
    CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_HEAD_OFFICE: "\u3053\u306E\u30ED\u30FC\u30EB\u306F\u4EE3\u7406\u5E97\u306B\u6240\u5C5E\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u672C\u90E8\u306E\u307F\u304C\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u30E1\u30CB\u30E5\u30FC\u306B\u306F\u95A2\u9023\u3064\u3051\u3089\u308C\u307E\u305B\u3093\u3002",
    THE_ACCOUNT_PLAN_IS_CURRENTLY_IN_USE_BY_A_CUSTOMER_AND_CANNOT_BE_DELETED: "\u3053\u306E\u30D7\u30E9\u30F3\u306F\u73FE\u5728\u9867\u5BA2\u306B\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_DEPT_WHERE_THE_EQUIPMENT_BELONGS_CANNOT_BE_A_AGENCY_STORE: "\u30C7\u30D0\u30A4\u30B9\u306E\u6240\u5C5E\u90E8\u9580\u306B\u4EE3\u7406\u5E97\u3092\u6307\u5B9A\u3067\u304D\u307E\u305B\u3093\u3002",
    CUSTOMER_IS_CURRENTLY_USING_THIS_EQUIPMENT_CANNOT_BE_DELETED: "\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306F\u73FE\u5728\u9867\u5BA2\u304C\u4F7F\u7528\u4E2D\u306E\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_STANDARD_QUOTATION_EQUIPMENT_FOR_ACCOUNT_PLAN_WITH_NORMAL_STATUS_IS_THE_CURRENT_EQUIPMENT_CANNOT_BE_DELETED: "\u73FE\u5728\u306E\u30C7\u30D0\u30A4\u30B9\u304C\u6709\u52B9\u306A\u30A2\u30AB\u30A6\u30F3\u30C8\u30D7\u30E9\u30F3\u306E\u6A19\u6E96\u898B\u7A4D\u3082\u308A\u30C7\u30D0\u30A4\u30B9\u3068\u3057\u3066\u4F7F\u7528\u3055\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3002",
    ADDING_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: "\u9867\u5BA2\u540D\u306F\u3059\u3067\u306B\u306B\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u306B\u5B58\u5728\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u65B0\u898F\u9867\u5BA2\u3068\u3057\u3066\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    ADDING_IS_NOT_ALLOWED_THIRD_PARTY_CUSTOMER_NAME_ALREADY_EXISTS: "\u9867\u5BA2\u540D\u306F\u65E2\u306B\u5B58\u5728\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u65B0\u898F\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    UPDATE_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS: "\u9867\u5BA2\u540D\u306F\u3059\u3067\u306B\u306B\u30C7\u30FC\u30BF\u30D9\u30FC\u30B9\u306B\u5B58\u5728\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_CUSTOMER_HAS_AN_RESOLVED_ACCOUNT_PLAN_ORDER_CANNOT_MODIFY_ITS_DEPT: "\u8A72\u5F53\u306E\u9867\u5BA2\u306F\u89E3\u7D04\u3055\u308C\u3066\u3044\u306A\u3044\u5951\u7D04\u6CE8\u6587\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u6240\u5C5E\u90E8\u7F72\u3092\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3002",
    THE_CUSTOMER_HAS_AN_RESOLVED_EQUIPMENT_ORDER_CANNOT_MODIFY_ITS_DEPT: "\u8A72\u5F53\u306E\u9867\u5BA2\u306F\u89E3\u7D04\u3055\u308C\u3066\u3044\u306A\u3044\u30C7\u30D0\u30A4\u30B9\u306E\u6CE8\u6587\u304C\u3042\u308A\u307E\u3059\u306E\u3067\u3001\u6240\u5C5E\u90E8\u7F72\u3092\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3002",
    CUSTOMER_INFO_NOT_ADDED: "\u4F01\u696D\u60C5\u5831\u304C\u5165\u529B\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u4F01\u696D\u60C5\u5831\u30E1\u30CB\u30E5\u30FC\u30D0\u30FC\u3067\u4F01\u696D\u60C5\u5831\u3092\u5165\u529B\u3057\u305F\u5F8C\u3001\u30D7\u30E9\u30F3\u306E\u8CFC\u5165\u304C\u53EF\u80FD\u306B\u306A\u308A\u307E\u3059\u3002",
    FREEE_PARTNER_NOT_EXIST: "Freee\u3067\u8A72\u5F53\u3059\u308B\u60C5\u5831\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8ID\u304C\u6B63\u3057\u304F\u5165\u529B\u3055\u308C\u3066\u3044\u308B\u304B\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    INVITATION_NOT_EXIST: "\u62DB\u5F85\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    INVITATION_STATUS_ERROR: "\u62DB\u5F85\u30B9\u30C6\u30FC\u30BF\u30B9\u30A8\u30E9\u30FC",
    INVITATION_STATUS_INVALID: "\u62DB\u5F85\u304C\u53D6\u308A\u6D88\u3055\u308C\u307E\u3057\u305F\u3002\u62DB\u5F85\u5143\u306E\u7BA1\u7406\u8005\u306B\u9023\u7D61\u3057\u3066\u3001\u62DB\u5F85\u3092\u518D\u9001\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    INVITATION_STATUS_EXPIRED: "\u62DB\u5F85\u304C\u671F\u9650\u5207\u308C\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u62DB\u5F85\u5143\u306E\u7BA1\u7406\u8005\u306B\u9023\u7D61\u3057\u3066\u3001\u62DB\u5F85\u3092\u518D\u9001\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    INVITATION_CHECK_CODE_WRONG: "\u5165\u529B\u3055\u308C\u305F\u8A8D\u8A3C\u30B3\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    CUSTOMER_ACCOUNT_PLAN_IN_EFFECT: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u3059\u3067\u306B\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u62DB\u5F85\u5148\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u6B63\u3057\u3044\u304B\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    CUSTOMER_NOT_ALLOW_CHANGE: "\u9867\u5BA2\u3092\u5909\u66F4\u3067\u304D\u307E\u305B\u3093\u3002",
    USER_STATUS_UNAVAILABLE: "Scanat\u306E\u3054\u5229\u7528\u306B\u306F\u6709\u6599\u5951\u7D04\u304C\u5FC5\u8981\u3067\u3059\u3002Scanat\u306E\u88FD\u54C1\u30B5\u30A4\u30C8\u3067\u30D7\u30E9\u30F3\u3092\u8CFC\u5165\u3057\u3066\u304B\u3089\u3001\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    USER_STATUS_AVAILABLE: "\u30ED\u30B0\u30A4\u30F3\u3057\u307E\u3057\u305F\u3002",
    USER_STATUS_ACCOUNT_EXPIRED: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u671F\u9650\u5207\u308C\u306B\u306A\u308A\u307E\u3057\u305F\u3002\u30D7\u30E9\u30F3\u3092\u66F4\u65B0\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    USER_STATUS_LOGOUT: "\u8A72\u5F53\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u60C5\u5831\u3092\u78BA\u8A8D\u3057\u3066\u3001\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    USER_STATUS_ACTIVE: "\u30ED\u30B0\u30A4\u30F3\u3057\u307E\u3057\u305F\u3002",
    USER_STATUS_TO_BE_EFFECTIVE: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u307E\u3060\u6709\u52B9\u5316\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u8CB4\u793E\u306E\u7BA1\u7406\u8005%@\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
    USER_STATUS_DEACTIVATE: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u7BA1\u7406\u8005\u306B\u3088\u3063\u3066\u7121\u52B9\u5316\u3055\u308C\u3066\u3044\u307E\u3059\u3002\u8CB4\u793E\u306E\u7BA1\u7406\u8005%@\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
    USER_STATUS_PRE_DEACTIVATE: "\u30ED\u30B0\u30A4\u30F3\u3057\u307E\u3057\u305F\u3002",
    USER_STATUS_PRE_ABNORMALITY: "\u30A2\u30AB\u30A6\u30F3\u30C8\u306B\u554F\u984C\u304C\u767A\u751F\u3057\u3066\u3044\u308B\u305F\u3081\u3001\u73FE\u5728\u30ED\u30B0\u30A4\u30F3\u3067\u304D\u307E\u305B\u3093\u3002",
    AGENT_NOT_EXIST: "\u4EE3\u7406\u5E97\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    AGENT_NAME_DUPLICATE: "\u4EE3\u7406\u5E97\u540D\u304C\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    REQUEST_BOOK_NOT_EXIST: "\u8ACB\u6C42\u66F8\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    FILE_CREATE_FAIL: "\u30D5\u30A1\u30A4\u30EB\u4F5C\u6210\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    SALES_DATE_EMPTY: "\u53D6\u5F15\u65E5\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    EXTEND_PLAN_CONFIG_ERROR: "ID\u8FFD\u52A0\u30D7\u30E9\u30F3\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u7BA1\u7406\u8005\u306B\u304A\u554F\u3044\u5408\u308F\u305B\u304F\u3060\u3055\u3044\u3002",
    CAN_NOT_FIND_WEB_MODEL_KEY: "\u30E2\u30C7\u30EB\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    CAN_NOT_FIND_WEB_MODEL_FOLDER: "\u30D5\u30A9\u30EB\u30C0\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    FOLDER_CANT_MOVE_INTO_SUB_FOLDER: "\u30D5\u30A9\u30EB\u30C0\u79FB\u52D5\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u30D5\u30A9\u30EB\u30C0\u306F\u30B5\u30D6\u30D5\u30A9\u30EB\u30C0\u307E\u3067\u306B\u79FB\u52D5\u3067\u304D\u307E\u305B\u3093\u3002",
    FOLDER_CONTAIN_SUB_FOLDER: "\u30D5\u30A9\u30EB\u30C0\u79FB\u52D5\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u6307\u5B9A\u3055\u308C\u305F\u30D5\u30A9\u30EB\u30C0\u306F\u30B5\u30D6\u30D5\u30A9\u30EB\u30C0\u3092\u542B\u3081\u3066\u3044\u305F\u306E\u3067\u79FB\u52D5\u3067\u304D\u307E\u305B\u3093\u3002",
    WEB_MODEL_ALREADY_IN_FOLDER: "\u79FB\u52D5\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002\u3053\u306E\u30C7\u30FC\u30BF\u306F\u3059\u3067\u306B\u30D5\u30A9\u30EB\u30C0\u306B\u5B58\u5728\u3057\u307E\u3059\u3002",
    FOLDER_NAME_SAME: "\u540C\u3058\u540D\u524D\u306E\u30D5\u30A9\u30EB\u30C0\u304C\u3059\u3067\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002\u540D\u524D\u3092\u5909\u66F4\u3057\u3066\u304B\u3089\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    EMAIL_CODE_REQUIRED: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u5411\u4E0A\u306E\u305F\u3081\u3001\u8A8D\u8A3C\u30B3\u30FC\u30C9\u6A5F\u80FD\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002\u3053\u306E\u6A5F\u80FD\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u304F\u306B\u306F\u3001\u30A2\u30D7\u30EA\u3092\u6700\u65B0\u30D0\u30FC\u30B8\u30E7\u30F3\uFF08v1.8.2\u4EE5\u4E0A\uFF09\u306B\u30A2\u30C3\u30D7\u30C7\u30FC\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    FILE_SHARE_FAIL: "\u8EE2\u9001\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A{}",
    NOT_HAS_WEB_PERMISSION: "\u672C\u30B5\u30FC\u30D3\u30B9\u3092\u3054\u8CFC\u5165\u3044\u305F\u3060\u3044\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093\u3002",
    MODEL_OUTLINE_NOT_EXIST: "\u30E2\u30C7\u30EB\u306E\u4E0B\u56F3\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    WEB_MODEL_NO_AUTH: "\u6A29\u9650\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059\u3002",
    SEAT_NUM_TOO_SMALL: "ID\u6570\u304C\u6700\u5C0F\u5236\u9650\u3092\u4E0B\u56DE\u3063\u3066\u3044\u307E\u3059\u3002",
    SEAT_NUM_TOO_BIG: "ID\u6570\u304C\u6700\u5927\u5236\u9650\u3092\u8D85\u3048\u3066\u3044\u307E\u3059\u3002",
    SEAT_NUM_LESS_THAN_USED: "ID\u6570\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059\u3002",
    CUSTOMER_PLAN_NOT_CANCELED: "\u304A\u5BA2\u69D8\u306B\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u6E08\u307F\u306E\u30D7\u30E9\u30F3\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002",
    CUSTOMER_PLAN_EXIST: "\u304A\u5BA2\u69D8\u306F\u65E2\u306B\u30D7\u30E9\u30F3\u3092\u3054\u8CFC\u5165\u6E08\u307F\u3067\u3059\u3002",
    CUSTOMER_PLAN_ALREADY_CANCELED: "\u304A\u5BA2\u69D8\u306E\u30D7\u30E9\u30F3\u306F\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F\u3002",
    CUSTOMER_PLAN_NOT_A: "\u304A\u5BA2\u69D8\u306F\u30D7\u30E9\u30F3A\u306E\u5951\u7D04\u8005\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    CUSTOMER_PLAN_PERIOD_ERROR: "\u3053\u306E\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u5F62\u5F0F\u306B\u306F\u5BFE\u5FDC\u3057\u3066\u304A\u308A\u307E\u305B\u3093\u3002",
    START_TIME_ILLEGAL: "\u958B\u59CB\u6642\u9593\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    STRIPE_ONE_TIME_PRICE_NOT_FOUND: "\u8A72\u5F53\u30D7\u30E9\u30F3\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    CUSTOMER_PLAN_EXPAND_NOT_FOUND_ITEM: "\u8A72\u5F53\u30D7\u30E9\u30F3\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    ORDER_NOT_BELONG: "\u3053\u306E\u6CE8\u6587\u306F\u3001\u304A\u5BA2\u69D8\u306E\u4F1A\u793E\u306B\u5C5E\u3059\u308B\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    WEB_PERMISSION_NOT_ALLOW_INACTIVE: "\u6A29\u9650\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059\u3002",
    CUSTOMER_HAS_ACCOUNT_IN_USE: "\u8CB4\u793E\u306B\u306F\u73FE\u5728\u3001\u5229\u7528\u4E2D\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u3042\u308A\u307E\u3059\u3002",
    CAD_PLAN_GOODS_NOT_EXIST: "\u3053\u306ECAD\u5546\u54C1\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    CAD_ORDER_NOT_EXIST: "\u8A72\u5F53\u3059\u308BCAD\u6CE8\u6587\u306F\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    CAD_ORDER_STATUS_ERROR: "\u8A72\u5F53\u3059\u308BCAD\u6CE8\u6587\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u306F\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    CAD_ORDER_FILE_TOO_MANY: "\u8A72\u5F53\u3059\u308BCAD\u6CE8\u6587\u306E\u30D5\u30A1\u30A4\u30EB\u30B5\u30A4\u30BA\u304C\u4E0A\u9650\u3092\u8D85\u3048\u3066\u3044\u307E\u3059\u3002",
    ACCOUNT_PLAN_PERIOD_NOT_ALLOW: "\u3053\u306E\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u5F62\u5F0F\u306B\u306F\u5BFE\u5FDC\u3057\u3066\u304A\u308A\u307E\u305B\u3093\u3002",
    CUSTOMER_PLAN_END_TIME_BEFORE_NOW: "\u30D7\u30E9\u30F3\u306E\u6709\u52B9\u671F\u9650\u304C\u307E\u3060\u5207\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    EXPAND_SEAT_NOT_ZERO: "\u8FFD\u52A0ID\u6570\u306F1\u4EE5\u4E0A\u306B\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    EXPAND_A_NOT_ALLOW: "\u30D7\u30E9\u30F3A\u3067\u306FID\u6570\u306E\u8FFD\u52A0\u304C\u3067\u304D\u307E\u305B\u3093\u3002",
    ACCOUNT_PLAN_GOODS_NOT_EXIST: "\u8A72\u5F53\u30D7\u30E9\u30F3\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    CAD_PLAN_GOODS_IS_USED: "\u3053\u306ECAD\u30D7\u30E9\u30F3\u306F\u3054\u5229\u7528\u4E2D\u3067\u3059\u3002",
    DOMAIN_ALREADY_EXIST: "\u3053\u306E\u30C9\u30E1\u30A4\u30F3\u306F\u65E2\u306B\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u3059\u3002",
    LOCATION_WITH_SNAPSHOT: "\u3053\u306E\u64AE\u5F71\u30B9\u30DD\u30C3\u30C8\u306F\u65E2\u306B\u30CF\u30A4\u30E9\u30A4\u30C8\u3068\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u307E\u3059\u3002",
    LOCATION_NOT_FOUNT: "\u3053\u306E\u64AE\u5F71\u30B9\u30DD\u30C3\u30C8\u306F\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    FLOOR_NOT_EXIST: "\u30D5\u30ED\u30A2\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    AUTO_ALIGN_FAIL: "\u81EA\u52D5\u56DE\u8EE2\u4FEE\u6B63\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    CAN_NOT_CHANGE_MEMBER_ROLE: "\u30E1\u30F3\u30D0\u30FC\u306E\u6A29\u9650\u8A2D\u5B9A\u3092\u5909\u66F4\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    CAN_NOT_USE_SEAT: "\u300CScanat\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u300D\u306E\u30AA\u30F3/\u30AA\u30D5\u3092\u5207\u308A\u66FF\u3048\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    APPLICATION_NOT_EXIST: "\u89E3\u7D04\u7533\u8ACB\u306F\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    PROCESSING_RESULT_NOT_EXIST: "\u89E3\u7D04\u7533\u8ACB\u306E\u51E6\u7406\u7D50\u679C\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    PLAN_CANCEL_APPLICATION_REASON_NOT_EXIST: "\u89E3\u7D04\u7533\u8ACB\u306E\u7406\u7531\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    PLAN_CANCEL_APPLICATION_OTHER_REASON_NULL: "\u89E3\u7D04\u7533\u8ACB\u3067\u306F\u3001\u300C\u305D\u306E\u4ED6\u300D\u306E\u7406\u7531\u306F\u5FC5\u9808\u9805\u76EE\u3067\u3059\u3002",
    PLAN_CANCEL_APPLICATION_EMAIL_ERROR: "\u89E3\u7D04\u7533\u8ACB\u306B\u5165\u529B\u3055\u308C\u305F\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u304C\u3001\u73FE\u5728\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3068\u4E00\u81F4\u3057\u307E\u305B\u3093\u3002",
    PLAN_CANCEL_APPLICATION_EXIST: "\u89E3\u7D04\u7533\u8ACB\u306F\u65E2\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002",
    ACCOUNT_CAN_NOT_USE: "\u304A\u5BA2\u69D8\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002",
    ACCOUNT_NOT_BUY_PLAN: "Scanat\u30B5\u30FC\u30D3\u30B9\u306F\u307E\u3060\u3054\u8CFC\u5165\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002{} \u306B\u30A2\u30AF\u30BB\u30B9\u3057\u3001\u30D7\u30E9\u30F3\u3092\u3054\u8CFC\u5165\u5F8C\u3001\u518D\u5EA6\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    CUSTOMER_NOT_BUY_PLAN: "\u5FA1\u793E\u306FScanat\u30B5\u30FC\u30D3\u30B9\u3092\u3054\u8CFC\u5165\u3055\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u73FE\u5728\u30ED\u30B0\u30A4\u30F3\u3067\u304D\u307E\u305B\u3093\u3002",
    ACCOUNT_NO_SEAT: "\u3053\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u300CScanat\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u300D\u306E\u8A2D\u5B9A\u304C\u30AA\u30D5\u306E\u305F\u3081\u3001\u30A2\u30D7\u30EA\u3092\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002",
    CAN_NOT_EDIT_MEMBER: "\u30E1\u30F3\u30D0\u30FC\u306E\u7DE8\u96C6\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    MODEL_IS_NOT_EXIST: "\u30E2\u30C7\u30EB\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    SHARE_LINK_NOT_EXIST: "\u5171\u6709\u30EA\u30F3\u30AF\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    NOT_CUSTOMER_MEMBER: "\u3053\u306E\u4F1A\u793E\u306E\u30E1\u30F3\u30D0\u30FC\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    SHARE_LINK_PASSWORD_ERROR: "\u5165\u529B\u3055\u308C\u305F\u5171\u6709\u30EA\u30F3\u30AF\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    STRIPE_PAYMENT_METHOD_NOT_ALLOW: "Stripe\u6C7A\u6E08\u306B\u306F\u5BFE\u5FDC\u3057\u3066\u3044\u307E\u305B\u3093\u3002",
    NOT_ADMIN_FORBIDDEN: "\u7BA1\u7406\u8005\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    NOT_ACTIVE_FORBIDDEN: "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u6709\u52B9\u5316\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    map: {
        gpsEnabledModelCount: "GPS\u4ED8\u4E0E\u306E\u30E2\u30C7\u30EB\u6570\uFF1A{n}",
        emptyFolderNoGpsModel: "\u3053\u306E\u30D5\u30A9\u30EB\u30C0\u306B\u306FGPS\u4ED8\u4E0E\u306E\u30E2\u30C7\u30EB\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
        searchNoResult: "\u7D50\u679C\u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u5909\u66F4\u3057\u305F\u308A\u3001\u8AA4\u5B57\u30FB\u8131\u5B57\u304C\u306A\u3044\u304B\u78BA\u8A8D\u3057\u305F\u308A\u3059\u308B\u304B\u3001\u53C8\u306F\u7D5E\u308A\u8FBC\u307F\u6A5F\u80FD\u3092\u8A66\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
    },
    maps: {
        hover: {
            showAllModels: "\u5168\u30E2\u30C7\u30EB\u3092\u8868\u793A",
            zoomIn: "\u62E1\u5927",
            zoomOut: "\u7E2E\u5C0F"
        }
    },
    collaborator: {
        set: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u7BA1\u7406",
        add: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0",
        search: {
            email: "\u30E1\u30F3\u30D0\u30FC\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u691C\u7D22"
        },
        online: "\u30AA\u30F3\u30E9\u30A4\u30F3",
        owner: "\u6240\u6709\u8005\uFF08\u4F1A\u793E\uFF09",
        title: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC"
    },
    fileModal: {
        cannotOperate: "\u3053\u306E\u30D5\u30A1\u30A4\u30EB\u306F\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002\u64CD\u4F5C\u3067\u304D\u307E\u305B\u3093\u3002"
    },
    collaboratorlist: {
        set: "\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u30EA\u30B9\u30C8"
    },
    ACCOUNT_EMAIL_CAN_NOT_CREATE_CUSTOMER: "\u3053\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u65E2\u306B\u767B\u9332\u6E08\u307F\u306E\u305F\u3081\u3001\u4F1A\u793E\u3092\u4F5C\u6210\u3067\u304D\u307E\u305B\u3093\u3002\u5225\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u3054\u4F7F\u7528\u304F\u3060\u3055\u3044\u3002",
    COOPERATOR_PERMISSION_DENIED: "\u5354\u50CD\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093\u3002",
    TEAM_SPACE_FOLDER_CREATE_NO_ADMIN: "\u7BA1\u7406\u5C64\u30E1\u30F3\u30D0\u30FC\u4EE5\u5916\u306F\u30C1\u30FC\u30E0\u30B9\u30DA\u30FC\u30B9\u306E\u30D5\u30A9\u30EB\u30C0\u3092\u4F5C\u6210\u3067\u304D\u307E\u305B\u3093\u3002",
    NOT_A_FOLDER: "\u30D5\u30A9\u30EB\u30C0\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    FOLDER_SPACE_MISMATCH: "\u30D5\u30A9\u30EB\u30C0\u306E\u30B9\u30DA\u30FC\u30B9\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002",
    FOLDER_DEPTH_EXCEEDED: "\u30D5\u30A9\u30EB\u30C0\u968E\u5C64\u306E\u4E0A\u9650\u3092\u8D85\u3048\u3066\u3044\u307E\u3059\u3002\u5225\u306E\u30D5\u30A9\u30EB\u30C0\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    SPACE_FOLDER_CONTAIN_SUB_FOLDER: "\u3053\u306E\u30D5\u30A9\u30EB\u30C0\u3084\u30B5\u30D6\u30D5\u30A9\u30EB\u30C0\u3078\u306E\u79FB\u52D5\u304C\u3067\u304D\u307E\u305B\u3093\u3002",
    SPACE_FILE_ALREADY_IN_FOLDER: "\u65E2\u306B\u5B9B\u5148\u306B\u5B58\u5728\u3057\u307E\u3059\u3002",
    CAN_NOT_FIND_SPACE_FILE: "\u3053\u306E\u30D5\u30A1\u30A4\u30EB\u306F\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093\u3002",
    SPACE_FILE_PATH_NULL: "\u30D5\u30A1\u30A4\u30EB\u30D1\u30B9\u304C\u7A7A\u3067\u3059\u3002",
    COOPERATOR_ALREADY_EXISTS: "\u65E2\u306B\u5354\u50CD\u30E1\u30F3\u30D0\u30FC\u30EA\u30B9\u30C8\u306B\u5B58\u5728\u3057\u307E\u3059\u3002\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093\u3002",
    INVITE_KEY_NOT_EXIST: "\u62DB\u5F85\u30EA\u30F3\u30AF\u304C\u5B58\u5728\u3057\u307E\u305B\u3093\u3002",
    INVITE_EMAIL_ERROR: "\u62DB\u5F85\u30E1\u30FC\u30EB\u306E\u30A2\u30C9\u30EC\u30B9\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002",
    INVITE_STATUS_ERROR: "\u62DB\u5F85\u30B9\u30C6\u30FC\u30BF\u30B9\u30A8\u30E9\u30FC\u3067\u3059\u3002",
    INVITE_STATUS_EXPIRED: "\u62DB\u5F85\u306E\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059\u3002",
    INVITE_CUSTOMER_PLAN_NOT_EXIST: "\u62DB\u5F85\u5074\u304C\u30B5\u30D6\u30B9\u30AF\u30EA\u30D7\u30B7\u30E7\u30F3\u306E\u8CFC\u5165\u3092\u3055\u308C\u3066\u3044\u306A\u3044\u305F\u3081\u3001\u30DA\u30FC\u30B8\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093\u3002"
};

});

parcelRegister("e5b9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $a40a2fdaf713e441$export$2e2bcd8739ae039);
var $a40a2fdaf713e441$export$2e2bcd8739ae039 = [
    {
        code: 200,
        message: 'SUCCESS'
    },
    {
        code: 400,
        message: 'VALIDATE_FAILED'
    },
    {
        code: 401,
        message: 'UNAUTHORIZED'
    },
    {
        code: 411,
        message: 'INVALID_PASSWORD'
    },
    {
        code: 421,
        message: 'UNAVAILABLE'
    },
    {
        code: 403,
        message: 'FORBIDDEN'
    },
    {
        code: 404,
        message: 'POSTCODE_NOT_EXIST'
    },
    {
        code: 405,
        message: 'NOT_REGISTERED'
    },
    {
        code: 406,
        message: 'VERIFICATION_CODE_ERROR'
    },
    {
        code: 416,
        message: 'VERIFICATION_CODE_EXPIRE'
    },
    {
        code: 407,
        message: 'USER_NOT_EXIST'
    },
    {
        code: 417,
        message: 'CRM_ACCOUNT_NOT_EXIST'
    },
    {
        code: 408,
        message: 'USER_EXIST'
    },
    {
        code: 409,
        message: 'CONFIRM_PASSWORD'
    },
    {
        code: 410,
        message: 'FILE_UPLOAD_KEY_GET_FAIL'
    },
    {
        code: 499,
        message: 'MODEL_NOT_BELONG'
    },
    {
        code: 500,
        message: 'FAILED'
    },
    {
        code: 501,
        message: 'REQUEST_FREQUENTLY'
    },
    {
        code: 601,
        message: 'FILE_SHARE_ERROR_DEL'
    },
    {
        code: 602,
        message: 'FILE_SHARE_ERROR_UNAUTHORIZED'
    },
    {
        code: 603,
        message: 'FILE_SHARE_ERROR_EMAIL_NOT_EXISTS'
    },
    {
        code: 604,
        message: 'FILE_SHARE_ERROR_UNKNOWN'
    },
    {
        code: 605,
        message: 'FILE_SHARE_ERROR_REPEAT_SHARING'
    },
    {
        code: 606,
        message: 'FILE_SHARE_ERROR_SELF'
    },
    {
        code: 607,
        message: 'FILE_SHARE_UPDATE_FAIL'
    },
    {
        code: 608,
        message: 'FILE_DOWNLOAD_ERROR_DEL'
    },
    {
        code: 609,
        message: 'FILE_SHARE_DEL_FAIL'
    },
    {
        code: 610,
        message: 'FILE_SHARE_DEL_FAIL_NO_AUTHORITY'
    },
    {
        code: 611,
        message: 'CREDIT_CARD_PAY_ERROR'
    },
    {
        code: 612,
        message: 'CREDIT_CARD_PAY_FAIL_BY_ERROR_FILE_KEY'
    },
    {
        code: 613,
        message: 'PERMITS_CONVERT_FAIL'
    },
    {
        code: 614,
        message: 'PERMITS_CONVERT_FAIL_USER_NULL'
    },
    {
        code: 615,
        message: 'APP_TRANSLATION_INVALID'
    },
    {
        code: 616,
        message: 'APP_TRANSLATION_HISTORY_GET_FAIL'
    },
    {
        code: 617,
        message: 'APP_TRANSLATION_STATUS_GET_FAIL'
    },
    {
        code: 618,
        message: 'FILE_UPLOAD_FILE_PATH_EMP_ERROR'
    },
    {
        code: 619,
        message: 'FILE_UPLOAD_FILE_DB_FAIL_ERROR'
    },
    {
        code: 701,
        message: 'APP_TOKEN_GET_FAIL'
    },
    {
        code: 702,
        message: 'APP_IP_ADDRESS_NOT_ALLOW'
    },
    {
        code: 703,
        message: 'CONTACT_ALREADY_EXIST'
    },
    {
        code: 704,
        message: 'ACCOUNT_PLAN_NOT_EXIST'
    },
    {
        code: 705,
        message: 'ACCOUNT_PLAN_TYPE_ERROR'
    },
    {
        code: 706,
        message: 'ACCOUNT_PLAN_DOWNGRADE'
    },
    {
        code: 707,
        message: 'ACCOUNT_PLAN_PREPAY_MONTH_ERROR'
    },
    {
        code: 708,
        message: 'ACCOUNT_PLAN_PREPAY_MONTH_NOT_OVER'
    },
    {
        code: 709,
        message: 'CUSTOMER_FINCODE_CUSTOMER_ID_NOT_EXIST'
    },
    {
        code: 710,
        message: 'FINCODE_PLAN_ID_NOT_EXIST'
    },
    {
        code: 711,
        message: 'CUSTOMER_NAME_DUPLICATE'
    },
    {
        code: 712,
        message: 'CUSTOMER_NAME_BLANK_NOT_ALLOW'
    },
    {
        code: 713,
        message: 'ACCOUNT_NOT_EXIST'
    },
    {
        code: 714,
        message: 'CUSTOMER_NOT_EXIST'
    },
    {
        code: 715,
        message: 'FINCODE_CARD_ID_BLANK_NOT_ALLOW'
    },
    {
        code: 716,
        message: 'CUSTOMER_NOT_BOUND_TO_ACCOUNT_PLAN'
    },
    {
        code: 717,
        message: 'CUSTOMER_ACCOUNT_PLAN_NOT_IN_EFFECT'
    },
    {
        code: 718,
        message: 'ACCOUNT_IN_USE_HAS_REACHED_MAX'
    },
    {
        code: 719,
        message: 'ACCOUNT_IN_USE_AND_ADD_ACCOUNT_EXCEED_MAX'
    },
    {
        code: 720,
        message: 'ACCOUNT_EMAIL_NOT_ALLOW_DUPLICATES'
    },
    {
        code: 721,
        message: 'ACCOUNT_EMAIL_ALREADY_EXISTS'
    },
    {
        code: 722,
        message: 'ACCOUNT_LIST_CANNOT_BE_EMPTY'
    },
    {
        code: 723,
        message: 'FREEE_TOKEN_GET_ERROR'
    },
    {
        code: 724,
        message: 'FREEE_API_REQUEST_ERROR'
    },
    {
        code: 725,
        message: 'FREEE_INVOICE_LIST_ERROR'
    },
    {
        code: 726,
        message: 'FREEE_INVOICE_DETAIL_ERROR'
    },
    {
        code: 728,
        message: 'FREEE_ADD_INVOICE_ERROR'
    },
    {
        code: 729,
        message: 'FREEE_ADD_PARTNER_ERROR'
    },
    {
        code: 730,
        message: 'FREEE_UPDATE_PARTNER_ERROR'
    },
    {
        code: 731,
        message: 'FREEE_PARTNER_DETAIL_ERROR'
    },
    {
        code: 732,
        message: 'FREEE_PARTNER_LIST_ERROR'
    },
    {
        code: 733,
        message: 'ACCOUNT_PLAN_ORDER_NOT_EXISTS'
    },
    {
        code: 734,
        message: 'CUSTOMER_ALREADY_ADDED'
    },
    {
        code: 735,
        message: 'ORDER_NOT_EXIST'
    },
    {
        code: 736,
        message: 'ORDER_STATUS_ERROR'
    },
    {
        code: 737,
        message: 'ORDER_PAYMENT_METHOD_NOT_ALLOW'
    },
    {
        code: 738,
        message: 'FINCODE_CUSTOMER_CARD_NOT_FOUND'
    },
    {
        code: 739,
        message: 'FREEE_PARTNER_NOT_FOUND'
    },
    {
        code: 740,
        message: 'CUSTOMER_ALREADY_BOUND_PLAN'
    },
    {
        code: 741,
        message: 'MY_USER_PHONE_NUMBER_ALREADY_EXISTS'
    },
    {
        code: 742,
        message: 'MY_USER_EMAIL_ALREADY_EXISTS'
    },
    {
        code: 743,
        message: 'ROLE_NAME_DUPLICATE'
    },
    {
        code: 744,
        message: 'THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DISABLED'
    },
    {
        code: 745,
        message: 'THERE_ARE_USERS_BOUND_TO_THIS_ROLE_CANNOT_UPDATE_ITS_DEPT'
    },
    {
        code: 746,
        message: 'THE_ROLE_IS_BOUND_USER_AND_CAN_NOT_BE_DELETED'
    },
    {
        code: 747,
        message: 'ADD_DEPT_NOT_ALLOWED_UNDER_HEADQUARTERS'
    },
    {
        code: 748,
        message: 'AGENCY_DEPT_MUST_SET_POSTAL_CODE_AND_ADDRESS_INFORMATION'
    },
    {
        code: 749,
        message: 'MOST_FIVE_DEPT_LEVELS'
    },
    {
        code: 750,
        message: 'DEPT_NAME_ALREADY_EXISTS'
    },
    {
        code: 751,
        message: 'THE_DEPT_HAS_SUB_DEPT'
    },
    {
        code: 752,
        message: 'THERE_ARE_USERS_IN_THIS_DEPT'
    },
    {
        code: 753,
        message: 'THERE_ARE_ROLES_BOUND_TO_THIS_DEPT'
    },
    {
        code: 754,
        message: 'THERE_ARE_ACCOUNT_PLAN_BOUND_TO_THIS_DEPT'
    },
    {
        code: 755,
        message: 'CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_ADD'
    },
    {
        code: 756,
        message: 'THE_DEPT_BOUND_TO_THE_CUSTOMER_DOES_NOT_EXISTS'
    },
    {
        code: 759,
        message: 'CUSTOMER_NAME_ALREADY_EXISTS_CANNOT_UPDATE'
    },
    {
        code: 760,
        message: 'THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ACTIVATE_THE_ACCOUNT'
    },
    {
        code: 761,
        message: 'THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ACTIVATE_THE_ACCOUNT'
    },
    {
        code: 762,
        message: 'THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_BE_ACTIVATED'
    },
    {
        code: 763,
        message: 'THE_NEW_CUSTOMER_IS_NOT_BOUND_TO_ANY_ACCOUNT_PLAN_THE_ACTIVATED_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER'
    },
    {
        code: 764,
        message: 'THE_ACCOUNT_PLAN_FOR_NEW_CUSTOMER_HAS_NOT_TAKEN_EFFECT_ACCOUNT_CANNOT_BE_CHANGED_TO_THE_CUSTOMER'
    },
    {
        code: 765,
        message: 'THE_CUSTOMER_NOT_BOUND_TO_AN_ACCOUNT_PLAN_AND_CANNOT_ADD_ACTIVATE_ACCOUNT'
    },
    {
        code: 766,
        message: 'THE_CUSTOMER_ACCOUNT_PLAN_IS_NOT_EFFECTIVE_AND_CANNOT_ADD_ACTIVATE_ACCOUNT'
    },
    {
        code: 767,
        message: 'THE_NUMBER_OF_ACTIVATED_ACCOUNTS_HAS_REACHED_THE_MAXIMUM_NUMBER_ACCOUNT_PLAN_IDS_AND_CANNOT_ADD_ACTIVATED_ACCOUNT'
    },
    {
        code: 768,
        message: 'THE_USER_OF_THE_AGENT_STORE_DOES_NOT_HAVE_PERMISSION_TO_VIEW_THE_CAD_ORDER_LIST'
    },
    {
        code: 769,
        message: 'CAD_ORDER_HAS_BEEN_COMPLETED_NOT_ALLOW_TO_UPLOAD_FILES'
    },
    {
        code: 770,
        message: 'CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_AGENT_STORE'
    },
    {
        code: 771,
        message: 'CANNOT_BE_BOUND_TO_THE_MENU_THAT_CAN_ONLY_BE_ACCESSED_BY_THE_HEAD_OFFICE'
    },
    {
        code: 772,
        message: 'THE_ACCOUNT_PLAN_IS_CURRENTLY_IN_USE_BY_A_CUSTOMER_AND_CANNOT_BE_DELETED'
    },
    {
        code: 773,
        message: 'THE_DEPT_WHERE_THE_EQUIPMENT_BELONGS_CANNOT_BE_A_AGENCY_STORE'
    },
    {
        code: 774,
        message: 'CUSTOMER_IS_CURRENTLY_USING_THIS_EQUIPMENT_CANNOT_BE_DELETED'
    },
    {
        code: 775,
        message: 'THE_STANDARD_QUOTATION_EQUIPMENT_FOR_ACCOUNT_PLAN_WITH_NORMAL_STATUS_IS_THE_CURRENT_EQUIPMENT_CANNOT_BE_DELETED'
    },
    {
        code: 776,
        message: 'ADDING_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS'
    },
    {
        code: 777,
        message: 'ADDING_IS_NOT_ALLOWED_THIRD_PARTY_CUSTOMER_NAME_ALREADY_EXISTS'
    },
    {
        code: 778,
        message: 'UPDATE_CUSTOMER_IS_NOT_ALLOWED_DB_CUSTOMER_NAME_ALREADY_EXISTS'
    },
    {
        code: 779,
        message: 'THE_CUSTOMER_HAS_AN_RESOLVED_ACCOUNT_PLAN_ORDER_CANNOT_MODIFY_ITS_DEPT'
    },
    {
        code: 780,
        message: 'THE_CUSTOMER_HAS_AN_RESOLVED_EQUIPMENT_ORDER_CANNOT_MODIFY_ITS_DEPT'
    },
    {
        code: 781,
        message: 'CUSTOMER_INFO_NOT_ADDED'
    },
    {
        code: 782,
        message: 'FREEE_PARTNER_NOT_EXIST'
    },
    {
        code: 783,
        message: 'INVITATION_NOT_EXIST'
    },
    {
        code: 784,
        message: 'INVITATION_STATUS_ERROR'
    },
    {
        code: 785,
        message: 'INVITATION_STATUS_INVALID'
    },
    {
        code: 786,
        message: 'INVITATION_STATUS_EXPIRED'
    },
    {
        code: 787,
        message: 'INVITATION_CHECK_CODE_WRONG'
    },
    {
        code: 788,
        message: 'CUSTOMER_ACCOUNT_PLAN_IN_EFFECT'
    },
    {
        code: 789,
        message: 'CUSTOMER_NOT_ALLOW_CHANGE'
    },
    {
        code: 790,
        message: 'ACCOUNT_EMAIL_OVER_LENGTH'
    },
    {
        code: 791,
        message: 'USER_STATUS_UNAVAILABLE'
    },
    {
        code: 792,
        message: 'USER_STATUS_AVAILABLE'
    },
    {
        code: 793,
        message: 'USER_STATUS_ACCOUNT_EXPIRED'
    },
    {
        code: 794,
        message: 'USER_STATUS_LOGOUT'
    },
    {
        code: 795,
        message: 'USER_STATUS_ACTIVE'
    },
    {
        code: 796,
        message: 'USER_STATUS_TO_BE_EFFECTIVE'
    },
    {
        code: 797,
        message: 'USER_STATUS_DEACTIVATE'
    },
    {
        code: 798,
        message: 'USER_STATUS_PRE_DEACTIVATE'
    },
    {
        code: 799,
        message: 'USER_STATUS_PRE_ABNORMALITY'
    },
    {
        code: 800,
        message: 'AGENT_NOT_EXIST'
    },
    {
        code: 801,
        message: 'AGENT_NAME_DUPLICATE'
    },
    {
        code: 802,
        message: 'REQUEST_BOOK_NOT_EXIST'
    },
    {
        code: 803,
        message: 'FILE_CREATE_FAIL'
    },
    {
        code: 804,
        message: 'SALES_DATE_EMPTY'
    },
    {
        code: 805,
        message: 'EXTEND_PLAN_CONFIG_ERROR'
    },
    {
        code: 806,
        message: 'CAN_NOT_FIND_WEB_MODEL_KEY'
    },
    {
        code: 807,
        message: 'CAN_NOT_FIND_WEB_MODEL_FOLDER'
    },
    {
        code: 808,
        message: 'FOLDER_CANT_MOVE_INTO_SUB_FOLDER'
    },
    {
        code: 808,
        message: 'FOLDER_CONTAIN_SUB_FOLDER'
    },
    {
        code: 809,
        message: 'WEB_MODEL_ALREADY_IN_FOLDER'
    },
    {
        code: 810,
        message: 'FOLDER_NAME_SAME'
    },
    {
        code: 811,
        message: 'MODEL_OUTLINE_NOT_EXIST'
    },
    {
        code: 812,
        message: 'WEB_MODEL_NO_AUTH'
    },
    {
        code: 814,
        message: 'SEAT_NUM_TOO_SMALL'
    },
    {
        code: 815,
        message: 'SEAT_NUM_TOO_BIG'
    },
    {
        code: 816,
        message: 'SEAT_NUM_LESS_THAN_USED'
    },
    {
        code: 819,
        message: 'CUSTOMER_PLAN_NOT_CANCELED'
    },
    {
        code: 820,
        message: 'CUSTOMER_PLAN_EXIST'
    },
    {
        code: 821,
        message: 'CUSTOMER_PLAN_ALREADY_CANCELED'
    },
    {
        code: 824,
        message: 'CUSTOMER_PLAN_NOT_A'
    },
    {
        code: 826,
        message: 'CUSTOMER_PLAN_PERIOD_ERROR'
    },
    {
        code: 827,
        message: 'START_TIME_ILLEGAL'
    },
    {
        code: 828,
        message: 'STRIPE_ONE_TIME_PRICE_NOT_FOUND'
    },
    {
        code: 829,
        message: 'CUSTOMER_PLAN_EXPAND_NOT_FOUND_ITEM'
    },
    {
        code: 830,
        message: 'ORDER_NOT_BELONG'
    },
    {
        code: 831,
        message: 'WEB_PERMISSION_NOT_ALLOW_INACTIVE'
    },
    {
        code: 832,
        message: 'CUSTOMER_HAS_ACCOUNT_IN_USE'
    },
    {
        code: 833,
        message: 'CAD_PLAN_GOODS_NOT_EXIST'
    },
    {
        code: 834,
        message: 'CAD_ORDER_NOT_EXIST'
    },
    {
        code: 835,
        message: 'CAD_ORDER_STATUS_ERROR'
    },
    {
        code: 836,
        message: 'CAD_ORDER_FILE_TOO_MANY'
    },
    {
        code: 837,
        message: 'ACCOUNT_PLAN_PERIOD_NOT_ALLOW'
    },
    {
        code: 839,
        message: 'CUSTOMER_PLAN_END_TIME_BEFORE_NOW'
    },
    {
        code: 840,
        message: 'EXPAND_SEAT_NOT_ZERO'
    },
    {
        code: 841,
        message: 'EXPAND_A_NOT_ALLOW'
    },
    {
        code: 842,
        message: 'ACCOUNT_PLAN_GOODS_NOT_EXIST'
    },
    {
        code: 843,
        message: 'CAD_PLAN_GOODS_IS_USED'
    },
    {
        code: 844,
        message: 'DOMAIN_ALREADY_EXIST'
    },
    {
        code: 845,
        message: 'LOCATION_WITH_SNAPSHOT'
    },
    {
        code: 846,
        message: 'LOCATION_NOT_FOUNT'
    },
    {
        code: 847,
        message: 'FLOOR_NOT_EXIST'
    },
    {
        code: 848,
        message: 'AUTO_ALIGN_FAIL'
    },
    {
        code: 849,
        message: 'CAN_NOT_CHANGE_MEMBER_ROLE'
    },
    {
        code: 850,
        message: 'CAN_NOT_USE_SEAT'
    },
    {
        code: 851,
        message: 'APPLICATION_NOT_EXIST'
    },
    {
        code: 852,
        message: 'PROCESSING_RESULT_NOT_EXIST'
    },
    {
        code: 853,
        message: 'PLAN_CANCEL_APPLICATION_REASON_NOT_EXIST'
    },
    {
        code: 854,
        message: 'PLAN_CANCEL_APPLICATION_OTHER_REASON_NULL'
    },
    {
        code: 855,
        message: 'PLAN_CANCEL_APPLICATION_EMAIL_ERROR'
    },
    {
        code: 856,
        message: 'PLAN_CANCEL_APPLICATION_EXIST'
    },
    {
        code: 857,
        message: 'ACCOUNT_CAN_NOT_USE'
    },
    {
        code: 858,
        message: 'ACCOUNT_NOT_BUY_PLAN'
    },
    {
        code: 859,
        message: 'CUSTOMER_NOT_BUY_PLAN'
    },
    {
        code: 860,
        message: 'ACCOUNT_PLAN_EXPIRED'
    },
    {
        code: 861,
        message: 'CUSTOMER_PLAN_EXPIRED'
    },
    {
        code: 862,
        message: 'ACCOUNT_PLAN_TOBE_EFFECTIVE'
    },
    {
        code: 863,
        message: 'ACCOUNT_NO_SEAT'
    },
    {
        code: 864,
        message: 'CAN_NOT_EDIT_MEMBER'
    },
    {
        code: 865,
        message: 'ACCOUNT_EMAIL_CAN_NOT_CREATE_CUSTOMER'
    },
    {
        code: 866,
        message: 'COOPERATOR_PERMISSION_DENIED'
    },
    {
        code: 867,
        message: 'TEAM_SPACE_FOLDER_CREATE_NO_ADMIN'
    },
    {
        code: 868,
        message: 'NOT_A_FOLDER'
    },
    {
        code: 869,
        message: 'FOLDER_SPACE_MISMATCH'
    },
    {
        code: 870,
        message: 'FOLDER_DEPTH_EXCEEDED'
    },
    {
        code: 871,
        message: 'SPACE_FOLDER_CONTAIN_SUB_FOLDER'
    },
    {
        code: 872,
        message: 'SPACE_FILE_ALREADY_IN_FOLDER'
    },
    {
        code: 873,
        message: 'CAN_NOT_FIND_SPACE_FILE'
    },
    {
        code: 874,
        message: 'SPACE_FILE_PATH_NULL'
    },
    {
        code: 875,
        message: 'COOPERATOR_ALREADY_EXISTS'
    },
    {
        code: 876,
        message: 'INVITE_KEY_NOT_EXIST'
    },
    {
        code: 877,
        message: 'INVITE_EMAIL_ERROR'
    },
    {
        code: 878,
        message: 'INVITE_STATUS_ERROR'
    },
    {
        code: 879,
        message: 'INVITE_STATUS_EXPIRED'
    },
    {
        code: 880,
        message: 'INVITE_CUSTOMER_PLAN_NOT_EXIST'
    },
    {
        code: 900,
        message: 'NOT_HAS_WEB_PERMISSION'
    },
    {
        code: 901,
        message: 'MODEL_IS_NOT_EXIST'
    },
    {
        code: 902,
        message: 'SHARE_LINK_NOT_EXIST'
    },
    {
        code: 903,
        message: 'NOT_CUSTOMER_MEMBER'
    },
    {
        code: 904,
        message: 'SHARE_LINK_PASSWORD_ERROR'
    },
    {
        code: 905,
        message: 'STRIPE_PAYMENT_METHOD_NOT_ALLOW'
    },
    {
        code: 20000,
        message: 'EMAIL_CODE_REQUIRED'
    },
    {
        code: 20001,
        message: 'NOT_ADMIN_FORBIDDEN'
    },
    {
        code: 20002,
        message: 'NOT_ACTIVE_FORBIDDEN'
    },
    {
        code: 20003,
        message: 'PAYMENT_REQUIRE_ACTION'
    }
];

});

parcelRegister("ccPRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5756e295443ad392$export$2e2bcd8739ae039);
//#region ../../packages/locale/lang/en.ts
var $5756e295443ad392$export$2e2bcd8739ae039 = {
    name: "en",
    el: {
        breadcrumb: {
            label: "Breadcrumb"
        },
        colorpicker: {
            confirm: "OK",
            clear: "Clear",
            defaultLabel: "color picker",
            description: "current color is {color}. press enter to select a new color.",
            alphaLabel: "pick alpha value",
            alphaDescription: "alpha {alpha}, current color is {color}",
            hueLabel: "pick hue value",
            hueDescription: "hue {hue}, current color is {color}",
            svLabel: "pick saturation and brightness value",
            svDescription: "saturation {saturation}, brightness {brightness}, current color is {color}",
            predefineDescription: "select {value} as the color"
        },
        datepicker: {
            now: "Now",
            today: "Today",
            cancel: "Cancel",
            clear: "Clear",
            confirm: "OK",
            dateTablePrompt: "Use the arrow keys and enter to select the day of the month",
            monthTablePrompt: "Use the arrow keys and enter to select the month",
            yearTablePrompt: "Use the arrow keys and enter to select the year",
            selectedDate: "Selected date",
            selectDate: "Select date",
            selectTime: "Select time",
            startDate: "Start Date",
            startTime: "Start Time",
            endDate: "End Date",
            endTime: "End Time",
            prevYear: "Previous Year",
            nextYear: "Next Year",
            prevMonth: "Previous Month",
            nextMonth: "Next Month",
            year: "",
            month1: "January",
            month2: "February",
            month3: "March",
            month4: "April",
            month5: "May",
            month6: "June",
            month7: "July",
            month8: "August",
            month9: "September",
            month10: "October",
            month11: "November",
            month12: "December",
            weeks: {
                sun: "Sun",
                mon: "Mon",
                tue: "Tue",
                wed: "Wed",
                thu: "Thu",
                fri: "Fri",
                sat: "Sat"
            },
            weeksFull: {
                sun: "Sunday",
                mon: "Monday",
                tue: "Tuesday",
                wed: "Wednesday",
                thu: "Thursday",
                fri: "Friday",
                sat: "Saturday"
            },
            months: {
                jan: "Jan",
                feb: "Feb",
                mar: "Mar",
                apr: "Apr",
                may: "May",
                jun: "Jun",
                jul: "Jul",
                aug: "Aug",
                sep: "Sep",
                oct: "Oct",
                nov: "Nov",
                dec: "Dec"
            }
        },
        inputNumber: {
            decrease: "decrease number",
            increase: "increase number"
        },
        select: {
            loading: "Loading",
            noMatch: "No matching data",
            noData: "No data",
            placeholder: "Select"
        },
        mention: {
            loading: "Loading"
        },
        dropdown: {
            toggleDropdown: "Toggle Dropdown"
        },
        cascader: {
            noMatch: "No matching data",
            loading: "Loading",
            placeholder: "Select",
            noData: "No data"
        },
        pagination: {
            goto: "Go to",
            pagesize: "/page",
            total: "Total {total}",
            pageClassifier: "",
            page: "Page",
            prev: "Go to previous page",
            next: "Go to next page",
            currentPage: "page {pager}",
            prevPages: "Previous {pager} pages",
            nextPages: "Next {pager} pages",
            deprecationWarning: "Deprecated usages detected, please refer to the el-pagination documentation for more details"
        },
        dialog: {
            close: "Close this dialog"
        },
        drawer: {
            close: "Close this dialog"
        },
        messagebox: {
            title: "Message",
            confirm: "OK",
            cancel: "Cancel",
            error: "Illegal input",
            close: "Close this dialog"
        },
        upload: {
            deleteTip: "press delete to remove",
            delete: "Delete",
            preview: "Preview",
            continue: "Continue"
        },
        slider: {
            defaultLabel: "slider between {min} and {max}",
            defaultRangeStartLabel: "pick start value",
            defaultRangeEndLabel: "pick end value"
        },
        table: {
            emptyText: "No Data",
            confirmFilter: "Confirm",
            resetFilter: "Reset",
            clearFilter: "All",
            sumText: "Sum",
            selectAllLabel: "Select all rows",
            selectRowLabel: "Select this row",
            expandRowLabel: "Expand this row",
            collapseRowLabel: "Collapse this row",
            sortLabel: "Sort by {column}",
            filterLabel: "Filter by {column}"
        },
        tag: {
            close: "Close this tag"
        },
        tour: {
            next: "Next",
            previous: "Previous",
            finish: "Finish",
            close: "Close this dialog"
        },
        tree: {
            emptyText: "No Data"
        },
        transfer: {
            noMatch: "No matching data",
            noData: "No data",
            titles: [
                "List 1",
                "List 2"
            ],
            filterPlaceholder: "Enter keyword",
            noCheckedFormat: "{total} items",
            hasCheckedFormat: "{checked}/{total} checked"
        },
        image: {
            error: "FAILED"
        },
        pageHeader: {
            title: "Back"
        },
        popconfirm: {
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        },
        carousel: {
            leftArrow: "Carousel arrow left",
            rightArrow: "Carousel arrow right",
            indicator: "Carousel switch to index {index}"
        },
        inputOTP: {
            groupLabel: "OTP Input",
            defaultLabel: "Please enter OTP character {index}"
        }
    }
};

});

parcelRegister("35QKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a70d875f044eb055$export$2e2bcd8739ae039);
//#region ../../packages/locale/lang/zh-cn.ts
var $a70d875f044eb055$export$2e2bcd8739ae039 = {
    name: "zh-cn",
    el: {
        breadcrumb: {
            label: "\u9762\u5305\u5C51"
        },
        colorpicker: {
            confirm: "\u786E\u5B9A",
            clear: "\u6E05\u7A7A",
            defaultLabel: "\u989C\u8272\u9009\u62E9\u5668",
            description: "\u5F53\u524D\u989C\u8272 {color}\uFF0C\u6309 Enter \u952E\u9009\u62E9\u65B0\u989C\u8272",
            alphaLabel: "\u9009\u62E9\u900F\u660E\u5EA6\u7684\u503C",
            alphaDescription: "\u900F\u660E\u5EA6 {alpha}, \u5F53\u524D\u989C\u8272 {color}",
            hueLabel: "\u9009\u62E9\u8272\u76F8\u503C",
            hueDescription: "\u8272\u76F8 {hue}, \u5F53\u524D\u989C\u8272 {color}",
            svLabel: "\u9009\u62E9\u9971\u548C\u5EA6\u4E0E\u660E\u5EA6\u7684\u503C",
            svDescription: "\u9971\u548C\u5EA6 {saturation}, \u660E\u5EA6 {brightness}, \u5F53\u524D\u989C\u8272 {color}",
            predefineDescription: "\u9009\u62E9 {value} \u4F5C\u4E3A\u989C\u8272"
        },
        datepicker: {
            now: "\u6B64\u523B",
            today: "\u4ECA\u5929",
            cancel: "\u53D6\u6D88",
            clear: "\u6E05\u7A7A",
            confirm: "\u786E\u5B9A",
            dateTablePrompt: "\u4F7F\u7528\u65B9\u5411\u952E\u4E0E Enter \u952E\u53EF\u9009\u62E9\u65E5\u671F",
            monthTablePrompt: "\u4F7F\u7528\u65B9\u5411\u952E\u4E0E Enter \u952E\u53EF\u9009\u62E9\u6708\u4EFD",
            yearTablePrompt: "\u4F7F\u7528\u65B9\u5411\u952E\u4E0E Enter \u952E\u53EF\u9009\u62E9\u5E74\u4EFD",
            selectedDate: "\u5DF2\u9009\u65E5\u671F",
            selectDate: "\u9009\u62E9\u65E5\u671F",
            selectTime: "\u9009\u62E9\u65F6\u95F4",
            startDate: "\u5F00\u59CB\u65E5\u671F",
            startTime: "\u5F00\u59CB\u65F6\u95F4",
            endDate: "\u7ED3\u675F\u65E5\u671F",
            endTime: "\u7ED3\u675F\u65F6\u95F4",
            prevYear: "\u524D\u4E00\u5E74",
            nextYear: "\u540E\u4E00\u5E74",
            prevMonth: "\u4E0A\u4E2A\u6708",
            nextMonth: "\u4E0B\u4E2A\u6708",
            year: "\u5E74",
            month1: "1 \u6708",
            month2: "2 \u6708",
            month3: "3 \u6708",
            month4: "4 \u6708",
            month5: "5 \u6708",
            month6: "6 \u6708",
            month7: "7 \u6708",
            month8: "8 \u6708",
            month9: "9 \u6708",
            month10: "10 \u6708",
            month11: "11 \u6708",
            month12: "12 \u6708",
            weeks: {
                sun: "\u65E5",
                mon: "\u4E00",
                tue: "\u4E8C",
                wed: "\u4E09",
                thu: "\u56DB",
                fri: "\u4E94",
                sat: "\u516D"
            },
            weeksFull: {
                sun: "\u661F\u671F\u65E5",
                mon: "\u661F\u671F\u4E00",
                tue: "\u661F\u671F\u4E8C",
                wed: "\u661F\u671F\u4E09",
                thu: "\u661F\u671F\u56DB",
                fri: "\u661F\u671F\u4E94",
                sat: "\u661F\u671F\u516D"
            },
            months: {
                jan: "\u4E00\u6708",
                feb: "\u4E8C\u6708",
                mar: "\u4E09\u6708",
                apr: "\u56DB\u6708",
                may: "\u4E94\u6708",
                jun: "\u516D\u6708",
                jul: "\u4E03\u6708",
                aug: "\u516B\u6708",
                sep: "\u4E5D\u6708",
                oct: "\u5341\u6708",
                nov: "\u5341\u4E00\u6708",
                dec: "\u5341\u4E8C\u6708"
            }
        },
        inputNumber: {
            decrease: "\u51CF\u5C11\u6570\u503C",
            increase: "\u589E\u52A0\u6570\u503C"
        },
        select: {
            loading: "\u52A0\u8F7D\u4E2D",
            noMatch: "\u65E0\u5339\u914D\u6570\u636E",
            noData: "\u65E0\u6570\u636E",
            placeholder: "\u8BF7\u9009\u62E9"
        },
        mention: {
            loading: "\u52A0\u8F7D\u4E2D"
        },
        dropdown: {
            toggleDropdown: "\u5207\u6362\u4E0B\u62C9\u9009\u9879"
        },
        cascader: {
            noMatch: "\u65E0\u5339\u914D\u6570\u636E",
            loading: "\u52A0\u8F7D\u4E2D",
            placeholder: "\u8BF7\u9009\u62E9",
            noData: "\u6682\u65E0\u6570\u636E"
        },
        pagination: {
            goto: "\u524D\u5F80",
            pagesize: "\u6761/\u9875",
            total: "\u5171 {total} \u6761",
            pageClassifier: "\u9875",
            page: "\u9875",
            prev: "\u4E0A\u4E00\u9875",
            next: "\u4E0B\u4E00\u9875",
            currentPage: "\u7B2C {pager} \u9875",
            prevPages: "\u5411\u524D {pager} \u9875",
            nextPages: "\u5411\u540E {pager} \u9875",
            deprecationWarning: "\u4F60\u4F7F\u7528\u4E86\u4E00\u4E9B\u5DF2\u88AB\u5E9F\u5F03\u7684\u7528\u6CD5\uFF0C\u8BF7\u53C2\u8003 el-pagination \u7684\u5B98\u65B9\u6587\u6863"
        },
        dialog: {
            close: "\u5173\u95ED\u6B64\u5BF9\u8BDD\u6846"
        },
        drawer: {
            close: "\u5173\u95ED\u6B64\u5BF9\u8BDD\u6846"
        },
        messagebox: {
            title: "\u63D0\u793A",
            confirm: "\u786E\u5B9A",
            cancel: "\u53D6\u6D88",
            error: "\u8F93\u5165\u7684\u6570\u636E\u4E0D\u5408\u6CD5!",
            close: "\u5173\u95ED\u6B64\u5BF9\u8BDD\u6846"
        },
        upload: {
            deleteTip: "\u6309 Delete \u952E\u53EF\u5220\u9664",
            delete: "\u5220\u9664",
            preview: "\u67E5\u770B\u56FE\u7247",
            continue: "\u7EE7\u7EED\u4E0A\u4F20"
        },
        slider: {
            defaultLabel: "\u6ED1\u5757\u4ECB\u4E8E {min} \u81F3 {max}",
            defaultRangeStartLabel: "\u9009\u62E9\u8D77\u59CB\u503C",
            defaultRangeEndLabel: "\u9009\u62E9\u7ED3\u675F\u503C"
        },
        table: {
            emptyText: "\u6682\u65E0\u6570\u636E",
            confirmFilter: "\u7B5B\u9009",
            resetFilter: "\u91CD\u7F6E",
            clearFilter: "\u5168\u90E8",
            sumText: "\u5408\u8BA1",
            selectAllLabel: "\u9009\u62E9\u6240\u6709\u884C",
            selectRowLabel: "\u9009\u62E9\u5F53\u524D\u884C",
            expandRowLabel: "\u5C55\u5F00\u5F53\u524D\u884C",
            collapseRowLabel: "\u6536\u8D77\u5F53\u524D\u884C",
            sortLabel: "\u6309 {column} \u6392\u5E8F",
            filterLabel: "\u6309 {column} \u8FC7\u6EE4"
        },
        tag: {
            close: "\u5173\u95ED\u6B64\u6807\u7B7E"
        },
        tour: {
            next: "\u4E0B\u4E00\u6B65",
            previous: "\u4E0A\u4E00\u6B65",
            finish: "\u7ED3\u675F\u5BFC\u89C8",
            close: "\u5173\u95ED\u6B64\u5BF9\u8BDD\u6846"
        },
        tree: {
            emptyText: "\u6682\u65E0\u6570\u636E"
        },
        transfer: {
            noMatch: "\u65E0\u5339\u914D\u6570\u636E",
            noData: "\u65E0\u6570\u636E",
            titles: [
                "\u5217\u8868 1",
                "\u5217\u8868 2"
            ],
            filterPlaceholder: "\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9",
            noCheckedFormat: "\u5171 {total} \u9879",
            hasCheckedFormat: "\u5DF2\u9009 {checked}/{total} \u9879"
        },
        image: {
            error: "\u52A0\u8F7D\u5931\u8D25"
        },
        pageHeader: {
            title: "\u8FD4\u56DE"
        },
        popconfirm: {
            confirmButtonText: "\u786E\u5B9A",
            cancelButtonText: "\u53D6\u6D88"
        },
        carousel: {
            leftArrow: "\u4E0A\u4E00\u5F20\u5E7B\u706F\u7247",
            rightArrow: "\u4E0B\u4E00\u5F20\u5E7B\u706F\u7247",
            indicator: "\u5E7B\u706F\u7247\u5207\u6362\u81F3\u7D22\u5F15 {index}"
        },
        inputOTP: {
            groupLabel: "\u4E00\u6B21\u6027\u5BC6\u7801\u8F93\u5165\u6846",
            defaultLabel: "\u8BF7\u8F93\u5165\u7B2C {index} \u4F4D OTP \u5B57\u7B26"
        }
    }
};

});

parcelRegister("fwauw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e078e19640e39ab$export$2e2bcd8739ae039);
//#region ../../packages/locale/lang/ja.ts
var $4e078e19640e39ab$export$2e2bcd8739ae039 = {
    name: "ja",
    el: {
        breadcrumb: {
            label: "Breadcrumb"
        },
        colorpicker: {
            confirm: "OK",
            clear: "\u30AF\u30EA\u30A2",
            defaultLabel: "color picker",
            description: "current color is {color}. press enter to select a new color.",
            alphaLabel: "pick alpha value",
            alphaDescription: "alpha {alpha}, current color is {color}",
            hueLabel: "pick hue value",
            hueDescription: "hue {hue}, current color is {color}",
            svLabel: "pick saturation and brightness value",
            svDescription: "saturation {saturation}, brightness {brightness}, current color is {color}",
            predefineDescription: "select {value} as the color"
        },
        datepicker: {
            now: "\u73FE\u5728",
            today: "\u4ECA\u65E5",
            cancel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
            clear: "\u30AF\u30EA\u30A2",
            confirm: "OK",
            dateTablePrompt: "Use the arrow keys and enter to select the day of the month",
            monthTablePrompt: "Use the arrow keys and enter to select the month",
            yearTablePrompt: "Use the arrow keys and enter to select the year",
            selectedDate: "Selected date",
            selectDate: "\u65E5\u4ED8\u3092\u9078\u629E",
            selectTime: "\u6642\u9593\u3092\u9078\u629E",
            startDate: "\u958B\u59CB\u65E5",
            startTime: "\u958B\u59CB\u6642\u9593",
            endDate: "\u7D42\u4E86\u65E5",
            endTime: "\u7D42\u4E86\u6642\u9593",
            prevYear: "\u524D\u5E74",
            nextYear: "\u7FCC\u5E74",
            prevMonth: "\u524D\u6708",
            nextMonth: "\u7FCC\u6708",
            year: "\u5E74",
            month1: "1\u6708",
            month2: "2\u6708",
            month3: "3\u6708",
            month4: "4\u6708",
            month5: "5\u6708",
            month6: "6\u6708",
            month7: "7\u6708",
            month8: "8\u6708",
            month9: "9\u6708",
            month10: "10\u6708",
            month11: "11\u6708",
            month12: "12\u6708",
            weeks: {
                sun: "\u65E5",
                mon: "\u6708",
                tue: "\u706B",
                wed: "\u6C34",
                thu: "\u6728",
                fri: "\u91D1",
                sat: "\u571F"
            },
            weeksFull: {
                sun: "Sunday",
                mon: "Monday",
                tue: "Tuesday",
                wed: "Wednesday",
                thu: "Thursday",
                fri: "Friday",
                sat: "Saturday"
            },
            months: {
                jan: "1\u6708",
                feb: "2\u6708",
                mar: "3\u6708",
                apr: "4\u6708",
                may: "5\u6708",
                jun: "6\u6708",
                jul: "7\u6708",
                aug: "8\u6708",
                sep: "9\u6708",
                oct: "10\u6708",
                nov: "11\u6708",
                dec: "12\u6708"
            }
        },
        inputNumber: {
            decrease: "decrease number",
            increase: "increase number"
        },
        select: {
            loading: "\u30ED\u30FC\u30C9\u4E2D",
            noMatch: "\u30C7\u30FC\u30BF\u306A\u3057",
            noData: "\u30C7\u30FC\u30BF\u306A\u3057",
            placeholder: "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"
        },
        mention: {
            loading: "\u30ED\u30FC\u30C9\u4E2D"
        },
        dropdown: {
            toggleDropdown: "Toggle Dropdown"
        },
        cascader: {
            noMatch: "\u30C7\u30FC\u30BF\u306A\u3057",
            loading: "\u30ED\u30FC\u30C9\u4E2D",
            placeholder: "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
            noData: "\u30C7\u30FC\u30BF\u306A\u3057"
        },
        pagination: {
            goto: "",
            pagesize: "\u4EF6/\u30DA\u30FC\u30B8",
            total: "\u7DCF\u8A08 {total} \u4EF6",
            pageClassifier: "\u30DA\u30FC\u30B8\u76EE\u3078",
            page: "Page",
            prev: "Go to previous page",
            next: "Go to next page",
            currentPage: "page {pager}",
            prevPages: "Previous {pager} pages",
            nextPages: "Next {pager} pages",
            deprecationWarning: "Deprecated usages detected, please refer to the el-pagination documentation for more details"
        },
        dialog: {
            close: "Close this dialog"
        },
        drawer: {
            close: "Close this dialog"
        },
        messagebox: {
            title: "\u30E1\u30C3\u30BB\u30FC\u30B8",
            confirm: "OK",
            cancel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
            error: "\u6B63\u3057\u304F\u306A\u3044\u5165\u529B",
            close: "Close this dialog"
        },
        upload: {
            deleteTip: "Del\u30AD\u30FC\u3092\u62BC\u3057\u3066\u524A\u9664\u3059\u308B",
            delete: "\u524A\u9664\u3059\u308B",
            preview: "\u30D7\u30EC\u30D3\u30E5\u30FC",
            continue: "\u7D9A\u884C\u3059\u308B"
        },
        slider: {
            defaultLabel: "slider between {min} and {max}",
            defaultRangeStartLabel: "pick start value",
            defaultRangeEndLabel: "pick end value"
        },
        table: {
            emptyText: "\u30C7\u30FC\u30BF\u306A\u3057",
            confirmFilter: "\u78BA\u8A8D",
            resetFilter: "\u521D\u671F\u5316",
            clearFilter: "\u3059\u3079\u3066",
            sumText: "\u5408\u8A08",
            selectAllLabel: "Select all rows",
            selectRowLabel: "Select this row",
            expandRowLabel: "Expand this row",
            collapseRowLabel: "Collapse this row",
            sortLabel: "Sort by {column}",
            filterLabel: "Filter by {column}"
        },
        tag: {
            close: "Close this tag"
        },
        tour: {
            next: "\u6B21\u3078",
            previous: "\u524D\u3078",
            finish: "\u30C4\u30A2\u30FC\u7D42\u4E86",
            close: "Close this dialog"
        },
        tree: {
            emptyText: "\u30C7\u30FC\u30BF\u306A\u3057"
        },
        transfer: {
            noMatch: "\u30C7\u30FC\u30BF\u306A\u3057",
            noData: "\u30C7\u30FC\u30BF\u306A\u3057",
            titles: [
                "\u30EA\u30B9\u30C8 1",
                "\u30EA\u30B9\u30C8 2"
            ],
            filterPlaceholder: "\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u5165\u529B",
            noCheckedFormat: "\u7DCF\u8A08 {total} \u4EF6",
            hasCheckedFormat: "{checked}/{total} \u3092\u9078\u629E\u3057\u305F"
        },
        image: {
            error: "\u5931\u6557"
        },
        pageHeader: {
            title: "\u623B\u308B"
        },
        popconfirm: {
            confirmButtonText: "\u306F\u3044",
            cancelButtonText: "\u3044\u3044\u3048"
        },
        carousel: {
            leftArrow: "Carousel arrow left",
            rightArrow: "Carousel arrow right",
            indicator: "Carousel switch to index {index}"
        },
        inputOTP: {
            groupLabel: "OTP Input",
            defaultLabel: "Please enter OTP character {index}"
        }
    }
};

});


parcelRegister("364nM", function(module, exports) {

$parcel$export(module.exports, "addRequest", () => $241554e6188443b3$export$cd5552281a6383e6);
$parcel$export(module.exports, "saveRequest", () => $241554e6188443b3$export$5d9ef4022e2e669c);
$parcel$export(module.exports, "removeRequest", () => $241554e6188443b3$export$84351156c9426589);
$parcel$export(module.exports, "isPageUnloading", () => $241554e6188443b3$export$806b710b4d1b901c);
$parcel$export(module.exports, "setWhiteList", () => $241554e6188443b3$export$92e6864fead80df5);
/**
 用于管理请求，避免重复请求
 */ const $241554e6188443b3$var$pendingRequests = new Map();
// 白名单配置
let $241554e6188443b3$var$whiteList = [];
/**
 * 生成请求的唯一标识
 * @param {string} url - 请求URL
 * @param {string} method - 请求方法
 * @param {Object|FormData} data - 请求数据
 * @returns {string} - 请求的唯一标识
 */ const $241554e6188443b3$var$generateRequestKey = (url, method, data)=>{
    // 对于FormData，我们不包含数据部分，因为它不能被序列化
    const dataStr = data instanceof FormData ? 'FormData' : JSON.stringify(data || {});
    return `${method}:${url}:${dataStr}`;
};
/**
 * 检查请求是否在白名单中
 * @param {string} url - 请求URL
 * @returns {boolean} - 是否在白名单中
 */ const $241554e6188443b3$var$isInWhiteList = (url)=>{
    return $241554e6188443b3$var$whiteList.some((pattern)=>{
        if (typeof pattern === 'string') return url.includes(pattern);
        else if (pattern instanceof RegExp) return pattern.test(url);
        return false;
    });
};
/**
 * 如果存在重复请求，则返回现有请求的Promise。
 * @param {string} url - 请求URL
 * @param {string} method - 请求方法
 * @param {Object|FormData} data - 请求数据
 * @returns {Promise|null} - 如果有重复请求，返回它的Promise；否则返回null
 */ const $241554e6188443b3$export$cd5552281a6383e6 = (url, method, data)=>{
    if ($241554e6188443b3$var$isInWhiteList(url)) return null;
    const key = $241554e6188443b3$var$generateRequestKey(url, method, data);
    if ($241554e6188443b3$var$pendingRequests.has(key)) return $241554e6188443b3$var$pendingRequests.get(key).promise;
    return null;
};
/**
 * 存储新请求
 * @param {string} url
 * @param {string} method
 * @param {Object} data
 * @param {Promise} promise
 * @param {AbortController} controller
 */ const $241554e6188443b3$export$5d9ef4022e2e669c = (url, method, data, promise, controller)=>{
    if ($241554e6188443b3$var$isInWhiteList(url)) return;
    const key = $241554e6188443b3$var$generateRequestKey(url, method, data);
    $241554e6188443b3$var$pendingRequests.set(key, {
        promise: promise,
        controller: controller
    });
};
/**
 * 移除请求
 * @param {string} url - 请求URL
 * @param {string} method - 请求方法
 * @param {Object|FormData} data - 请求数据
 */ const $241554e6188443b3$export$84351156c9426589 = (url, method, data)=>{
    const key = $241554e6188443b3$var$generateRequestKey(url, method, data);
    if ($241554e6188443b3$var$pendingRequests.has(key)) $241554e6188443b3$var$pendingRequests.delete(key);
};
/**
 * 清空所有请求
 */ const $241554e6188443b3$export$c5e3fe7cd84d327a = ()=>{
    $241554e6188443b3$var$pendingRequests.forEach((req)=>{
        req.controller?.abort('cancelled');
    });
    $241554e6188443b3$var$pendingRequests.clear();
};
let $241554e6188443b3$var$isUnloading = false;
const $241554e6188443b3$var$markUnloading = ()=>{
    $241554e6188443b3$var$isUnloading = true;
    $241554e6188443b3$export$c5e3fe7cd84d327a();
};
window.addEventListener('beforeunload', $241554e6188443b3$var$markUnloading);
window.addEventListener('pagehide', $241554e6188443b3$var$markUnloading);
window.addEventListener('pageshow', ()=>{
    $241554e6188443b3$var$isUnloading = false;
});
const $241554e6188443b3$export$806b710b4d1b901c = ()=>$241554e6188443b3$var$isUnloading;
/**
 * 设置白名单
 * @param {Array<string|RegExp>} list - 白名单列表，可以是字符串或正则表达式
 */ const $241554e6188443b3$export$92e6864fead80df5 = (list)=>{
    $241554e6188443b3$var$whiteList = Array.isArray(list) ? list : [];
};
/**
 * 添加白名单项
 * @param {string|RegExp} item - 白名单项，可以是字符串或正则表达式
 */ const $241554e6188443b3$export$172e83d5b08751ab = (item)=>{
    if (!$241554e6188443b3$var$whiteList.includes(item)) $241554e6188443b3$var$whiteList.push(item);
};
/**
 * 移除白名单项
 * @param {string|RegExp} item - 要移除的白名单项
 */ const $241554e6188443b3$export$68726549a12d8de = (item)=>{
    const index = $241554e6188443b3$var$whiteList.findIndex((i)=>i === item);
    if (index !== -1) $241554e6188443b3$var$whiteList.splice(index, 1);
};
/**
 * 获取当前白名单
 * @returns {Array<string|RegExp>} - 当前白名单
 */ const $241554e6188443b3$export$8c172f92a8a485c3 = ()=>{
    return [
        ...$241554e6188443b3$var$whiteList
    ];
};
/**
 * 获取当前活跃请求数量
 * @returns {number} - 活跃请求数量
 */ const $241554e6188443b3$export$9e24718f863fc116 = ()=>{
    return $241554e6188443b3$var$pendingRequests.size;
};

});

parcelRegister("i0TKe", function(module, exports) {

$parcel$export(module.exports, "getActivePinia", () => $52e3354521f75c8c$export$d0cc41ca14a2d060);
$parcel$export(module.exports, "createPinia", () => $52e3354521f75c8c$export$4b9f6a0748623d44);
$parcel$export(module.exports, "defineStore", () => $52e3354521f75c8c$export$5061c4f75bbcb4a);
$parcel$export(module.exports, "storeToRefs", () => $52e3354521f75c8c$export$586af8bd019552de);
/*!
 * pinia v3.0.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

var $70eLC = parcelRequire("70eLC");
const $52e3354521f75c8c$var$IS_CLIENT = typeof window !== 'undefined';
/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */ let $52e3354521f75c8c$var$activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */ // @ts-expect-error: cannot constrain the type of the return
const $52e3354521f75c8c$export$89ffb8149ccd46af = (pinia)=>$52e3354521f75c8c$var$activePinia = pinia;
/**
 * Get the currently active pinia if there is any.
 */ const $52e3354521f75c8c$export$d0cc41ca14a2d060 = ()=>(0, $TusQn.hasInjectionContext)() && (0, $TusQn.inject)($52e3354521f75c8c$var$piniaSymbol) || $52e3354521f75c8c$var$activePinia;
const $52e3354521f75c8c$var$piniaSymbol = /* istanbul ignore next */ Symbol();
function $52e3354521f75c8c$var$isPlainObject(// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return o && typeof o === 'object' && Object.prototype.toString.call(o) === '[object Object]' && typeof o.toJSON !== 'function';
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */ var $52e3354521f75c8c$export$d97371ba8df8c539;
(function(MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */ MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */ MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */ MutationType["patchFunction"] = "patch function";
// maybe reset? for $state = {} and $reset
})($52e3354521f75c8c$export$d97371ba8df8c539 || ($52e3354521f75c8c$export$d97371ba8df8c539 = {}));
/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */ // The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const $52e3354521f75c8c$var$_global = /*#__PURE__*/ (()=>typeof window === 'object' && window.window === window ? window : typeof self === 'object' && self.self === self ? self : typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global ? $parcel$global : typeof globalThis === 'object' ? globalThis : {
        HTMLElement: null
    })();
function $52e3354521f75c8c$var$bom(blob, { autoBom: autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
        String.fromCharCode(0xfeff),
        blob
    ], {
        type: blob.type
    });
    return blob;
}
function $52e3354521f75c8c$var$download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = function() {
        $52e3354521f75c8c$var$saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function() {
        console.error('could not download file');
    };
    xhr.send();
}
function $52e3354521f75c8c$var$corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open('HEAD', url, false);
    try {
        xhr.send();
    } catch (e) {}
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function $52e3354521f75c8c$var$click(node) {
    try {
        node.dispatchEvent(new MouseEvent('click'));
    } catch (e) {
        const evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
            detail: 0,
            screenX: 80,
            screenY: 20,
            clientX: 80,
            clientY: 20,
            ctrlKey: false,
            altKey: false,
            shiftKey: false,
            metaKey: false,
            button: 0,
            relatedTarget: null
        });
        node.dispatchEvent(evt);
    }
}
const $52e3354521f75c8c$var$_navigator = typeof navigator === 'object' ? navigator : {
    userAgent: ''
};
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const $52e3354521f75c8c$var$isMacOSWebView = /*#__PURE__*/ (()=>/Macintosh/.test($52e3354521f75c8c$var$_navigator.userAgent) && /AppleWebKit/.test($52e3354521f75c8c$var$_navigator.userAgent) && !/Safari/.test($52e3354521f75c8c$var$_navigator.userAgent))();
const $52e3354521f75c8c$var$saveAs = !$52e3354521f75c8c$var$IS_CLIENT ? ()=>{} // noop
 : typeof HTMLAnchorElement !== 'undefined' && 'download' in HTMLAnchorElement.prototype && !$52e3354521f75c8c$var$isMacOSWebView ? $52e3354521f75c8c$var$downloadSaveAs : 'msSaveOrOpenBlob' in $52e3354521f75c8c$var$_navigator ? $52e3354521f75c8c$var$msSaveAs : $52e3354521f75c8c$var$fileSaverSaveAs;
function $52e3354521f75c8c$var$downloadSaveAs(blob, name = 'download', opts) {
    const a = document.createElement('a');
    a.download = name;
    a.rel = 'noopener'; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === 'string') {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if ($52e3354521f75c8c$var$corsEnabled(a.href)) $52e3354521f75c8c$var$download(blob, name, opts);
            else {
                a.target = '_blank';
                $52e3354521f75c8c$var$click(a);
            }
        } else $52e3354521f75c8c$var$click(a);
    } else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function() {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function() {
            $52e3354521f75c8c$var$click(a);
        }, 0);
    }
}
function $52e3354521f75c8c$var$msSaveAs(blob, name = 'download', opts) {
    if (typeof blob === 'string') {
        if ($52e3354521f75c8c$var$corsEnabled(blob)) $52e3354521f75c8c$var$download(blob, name, opts);
        else {
            const a = document.createElement('a');
            a.href = blob;
            a.target = '_blank';
            setTimeout(function() {
                $52e3354521f75c8c$var$click(a);
            });
        }
    } else // @ts-ignore: works on windows
    navigator.msSaveOrOpenBlob($52e3354521f75c8c$var$bom(blob, opts), name);
}
function $52e3354521f75c8c$var$fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open('', '_blank');
    if (popup) popup.document.title = popup.document.body.innerText = 'downloading...';
    if (typeof blob === 'string') return $52e3354521f75c8c$var$download(blob, name, opts);
    const force = blob.type === 'application/octet-stream';
    const isSafari = /constructor/i.test(String($52e3354521f75c8c$var$_global.HTMLElement)) || 'safari' in $52e3354521f75c8c$var$_global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || force && isSafari || $52e3354521f75c8c$var$isMacOSWebView) && typeof FileReader !== 'undefined') {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function() {
            let url = reader.result;
            if (typeof url !== 'string') {
                popup = null;
                throw new Error('Wrong reader.result type');
            }
            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
            if (popup) popup.location.href = url;
            else location.assign(url);
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    } else {
        const url = URL.createObjectURL(blob);
        if (popup) popup.location.assign(url);
        else location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}
/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */ function $52e3354521f75c8c$var$toastMessage(message, type) {
    const piniaMessage = "\uD83C\uDF4D " + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === 'function') // No longer available :(
    __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    else if (type === 'error') console.error(piniaMessage);
    else if (type === 'warn') console.warn(piniaMessage);
    else console.log(piniaMessage);
}
function $52e3354521f75c8c$var$isPinia(o) {
    return '_a' in o && 'install' in o;
}
/**
 * This file contain devtools actions, they are not Pinia actions.
 */ // ---
function $52e3354521f75c8c$var$checkClipboardAccess() {
    if (!('clipboard' in navigator)) {
        $52e3354521f75c8c$var$toastMessage(`Your browser doesn't support the Clipboard API`, 'error');
        return true;
    }
}
function $52e3354521f75c8c$var$checkNotFocusedError(error) {
    if (error instanceof Error && error.message.toLowerCase().includes('document is not focused')) {
        $52e3354521f75c8c$var$toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', 'warn');
        return true;
    }
    return false;
}
async function $52e3354521f75c8c$var$actionGlobalCopyState(pinia) {
    if ($52e3354521f75c8c$var$checkClipboardAccess()) return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        $52e3354521f75c8c$var$toastMessage('Global state copied to clipboard.');
    } catch (error) {
        if ($52e3354521f75c8c$var$checkNotFocusedError(error)) return;
        $52e3354521f75c8c$var$toastMessage(`Failed to serialize the state. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function $52e3354521f75c8c$var$actionGlobalPasteState(pinia) {
    if ($52e3354521f75c8c$var$checkClipboardAccess()) return;
    try {
        $52e3354521f75c8c$var$loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
        $52e3354521f75c8c$var$toastMessage('Global state pasted from clipboard.');
    } catch (error) {
        if ($52e3354521f75c8c$var$checkNotFocusedError(error)) return;
        $52e3354521f75c8c$var$toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function $52e3354521f75c8c$var$actionGlobalSaveState(pinia) {
    try {
        $52e3354521f75c8c$var$saveAs(new Blob([
            JSON.stringify(pinia.state.value)
        ], {
            type: 'text/plain;charset=utf-8'
        }), 'pinia-state.json');
    } catch (error) {
        $52e3354521f75c8c$var$toastMessage(`Failed to export the state as JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
let $52e3354521f75c8c$var$fileInput;
function $52e3354521f75c8c$var$getFileOpener() {
    if (!$52e3354521f75c8c$var$fileInput) {
        $52e3354521f75c8c$var$fileInput = document.createElement('input');
        $52e3354521f75c8c$var$fileInput.type = 'file';
        $52e3354521f75c8c$var$fileInput.accept = '.json';
    }
    function openFile() {
        return new Promise((resolve, reject)=>{
            $52e3354521f75c8c$var$fileInput.onchange = async ()=>{
                const files = $52e3354521f75c8c$var$fileInput.files;
                if (!files) return resolve(null);
                const file = files.item(0);
                if (!file) return resolve(null);
                return resolve({
                    text: await file.text(),
                    file: file
                });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            $52e3354521f75c8c$var$fileInput.oncancel = ()=>resolve(null);
            $52e3354521f75c8c$var$fileInput.onerror = reject;
            $52e3354521f75c8c$var$fileInput.click();
        });
    }
    return openFile;
}
async function $52e3354521f75c8c$var$actionGlobalOpenStateFile(pinia) {
    try {
        const open1 = $52e3354521f75c8c$var$getFileOpener();
        const result = await open1();
        if (!result) return;
        const { text: text, file: file } = result;
        $52e3354521f75c8c$var$loadStoresState(pinia, JSON.parse(text));
        $52e3354521f75c8c$var$toastMessage(`Global state imported from "${file.name}".`);
    } catch (error) {
        $52e3354521f75c8c$var$toastMessage(`Failed to import the state from JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
function $52e3354521f75c8c$var$loadStoresState(pinia, state) {
    for(const key in state){
        const storeState = pinia.state.value[key];
        // store is already instantiated, patch it
        if (storeState) Object.assign(storeState, state[key]);
        else // store is not instantiated, set the initial state
        pinia.state.value[key] = state[key];
    }
}
function $52e3354521f75c8c$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
const $52e3354521f75c8c$var$PINIA_ROOT_LABEL = "\uD83C\uDF4D Pinia (root)";
const $52e3354521f75c8c$var$PINIA_ROOT_ID = '_root';
function $52e3354521f75c8c$var$formatStoreForInspectorTree(store) {
    return $52e3354521f75c8c$var$isPinia(store) ? {
        id: $52e3354521f75c8c$var$PINIA_ROOT_ID,
        label: $52e3354521f75c8c$var$PINIA_ROOT_LABEL
    } : {
        id: store.$id,
        label: store.$id
    };
}
function $52e3354521f75c8c$var$formatStoreForInspectorState(store) {
    if ($52e3354521f75c8c$var$isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId)=>({
                    editable: true,
                    key: storeId,
                    value: store.state.value[storeId]
                })),
            getters: storeNames.filter((id)=>storeMap.get(id)._getters).map((id)=>{
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key)=>{
                        getters[key] = store[key];
                        return getters;
                    }, {})
                };
            })
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key)=>({
                editable: true,
                key: key,
                value: store.$state[key]
            }))
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) state.getters = store._getters.map((getterName)=>({
            editable: false,
            key: getterName,
            value: store[getterName]
        }));
    if (store._customProperties.size) state.customProperties = Array.from(store._customProperties).map((key)=>({
            editable: true,
            key: key,
            value: store[key]
        }));
    return state;
}
function $52e3354521f75c8c$var$formatEventData(events) {
    if (!events) return {};
    if (Array.isArray(events)) // TODO: handle add and delete for arrays and objects
    return events.reduce((data, event)=>{
        data.keys.push(event.key);
        data.operations.push(event.type);
        data.oldValue[event.key] = event.oldValue;
        data.newValue[event.key] = event.newValue;
        return data;
    }, {
        oldValue: {},
        keys: [],
        operations: [],
        newValue: {}
    });
    else return {
        operation: $52e3354521f75c8c$var$formatDisplay(events.type),
        key: $52e3354521f75c8c$var$formatDisplay(events.key),
        oldValue: events.oldValue,
        newValue: events.newValue
    };
}
function $52e3354521f75c8c$var$formatMutationType(type) {
    switch(type){
        case $52e3354521f75c8c$export$d97371ba8df8c539.direct:
            return 'mutation';
        case $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction:
            return '$patch';
        case $52e3354521f75c8c$export$d97371ba8df8c539.patchObject:
            return '$patch';
        default:
            return 'unknown';
    }
}
// timeline can be paused when directly changing the state
let $52e3354521f75c8c$var$isTimelineActive = true;
const $52e3354521f75c8c$var$componentStateTypes = [];
const $52e3354521f75c8c$var$MUTATIONS_LAYER_ID = 'pinia:mutations';
const $52e3354521f75c8c$var$INSPECTOR_ID = 'pinia';
const { assign: $52e3354521f75c8c$var$assign$1 } = Object;
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */ const $52e3354521f75c8c$var$getStoreType = (id)=>"\uD83C\uDF4D " + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */ function $52e3354521f75c8c$var$registerPiniaDevtools(app, pinia) {
    (0, $70eLC.setupDevToolsPlugin)({
        id: 'dev.esm.pinia',
        label: "Pinia \uD83C\uDF4D",
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: $52e3354521f75c8c$var$componentStateTypes,
        app: app
    }, (api)=>{
        if (typeof api.now !== 'function') $52e3354521f75c8c$var$toastMessage('You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        api.addTimelineLayer({
            id: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
            label: `Pinia \u{1F34D}`,
            color: 0xe5df88
        });
        api.addInspector({
            id: $52e3354521f75c8c$var$INSPECTOR_ID,
            label: "Pinia \uD83C\uDF4D",
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
                {
                    icon: 'content_copy',
                    action: ()=>{
                        $52e3354521f75c8c$var$actionGlobalCopyState(pinia);
                    },
                    tooltip: 'Serialize and copy the state'
                },
                {
                    icon: 'content_paste',
                    action: async ()=>{
                        await $52e3354521f75c8c$var$actionGlobalPasteState(pinia);
                        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
                        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                    },
                    tooltip: 'Replace the state with the content of your clipboard'
                },
                {
                    icon: 'save',
                    action: ()=>{
                        $52e3354521f75c8c$var$actionGlobalSaveState(pinia);
                    },
                    tooltip: 'Save the state as a JSON file'
                },
                {
                    icon: 'folder_open',
                    action: async ()=>{
                        await $52e3354521f75c8c$var$actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
                        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                    },
                    tooltip: 'Import the state from a JSON file'
                }
            ],
            nodeActions: [
                {
                    icon: 'restore',
                    tooltip: 'Reset the state (with "$reset")',
                    action: (nodeId)=>{
                        const store = pinia._s.get(nodeId);
                        if (!store) $52e3354521f75c8c$var$toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, 'warn');
                        else if (typeof store.$reset !== 'function') $52e3354521f75c8c$var$toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, 'warn');
                        else {
                            store.$reset();
                            $52e3354521f75c8c$var$toastMessage(`Store "${nodeId}" reset.`);
                        }
                    }
                }
            ]
        });
        api.on.inspectComponent((payload)=>{
            const proxy = payload.componentInstance && payload.componentInstance.proxy;
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store)=>{
                    payload.instanceData.state.push({
                        type: $52e3354521f75c8c$var$getStoreType(store.$id),
                        key: 'state',
                        editable: true,
                        value: store._isOptionsAPI ? {
                            _custom: {
                                value: (0, $01W3b.toRaw)(store.$state),
                                actions: [
                                    {
                                        icon: 'restore',
                                        tooltip: 'Reset the state of this store',
                                        action: ()=>store.$reset()
                                    }
                                ]
                            }
                        } : Object.keys(store.$state).reduce((state, key)=>{
                            state[key] = store.$state[key];
                            return state;
                        }, {})
                    });
                    if (store._getters && store._getters.length) payload.instanceData.state.push({
                        type: $52e3354521f75c8c$var$getStoreType(store.$id),
                        key: 'getters',
                        editable: false,
                        value: store._getters.reduce((getters, key)=>{
                            try {
                                getters[key] = store[key];
                            } catch (error) {
                                // @ts-expect-error: we just want to show it in devtools
                                getters[key] = error;
                            }
                            return getters;
                        }, {})
                    });
                });
            }
        });
        api.on.getInspectorTree((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                let stores = [
                    pinia
                ];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter ? stores.filter((store)=>'$id' in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : $52e3354521f75c8c$var$PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map($52e3354521f75c8c$var$formatStoreForInspectorTree);
            }
        });
        // Expose pinia instance as $pinia to window
        globalThis.$pinia = pinia;
        api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $52e3354521f75c8c$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) // this could be the selected store restored for a different project
                // so it's better not to say anything here
                return;
                if (inspectedStore) {
                    // Expose selected store as $store to window
                    if (payload.nodeId !== $52e3354521f75c8c$var$PINIA_ROOT_ID) globalThis.$store = (0, $01W3b.toRaw)(inspectedStore);
                    payload.state = $52e3354521f75c8c$var$formatStoreForInspectorState(inspectedStore);
                }
            }
        });
        api.on.editInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $52e3354521f75c8c$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) return $52e3354521f75c8c$var$toastMessage(`store "${payload.nodeId}" not found`, 'error');
                const { path: path } = payload;
                if (!$52e3354521f75c8c$var$isPinia(inspectedStore)) // access only the state
                {
                    if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) path.unshift('$state');
                } else // Root access, we can omit the `.value` because the devtools API does it for us
                path.unshift('state');
                $52e3354521f75c8c$var$isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                $52e3354521f75c8c$var$isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload)=>{
            if (payload.type.startsWith("\uD83C\uDF4D")) {
                const storeId = payload.type.replace(/^🍍\s*/, '');
                const store = pinia._s.get(storeId);
                if (!store) return $52e3354521f75c8c$var$toastMessage(`store "${storeId}" not found`, 'error');
                const { path: path } = payload;
                if (path[0] !== 'state') return $52e3354521f75c8c$var$toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = '$state';
                $52e3354521f75c8c$var$isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                $52e3354521f75c8c$var$isTimelineActive = true;
            }
        });
    });
}
function $52e3354521f75c8c$var$addStoreToDevtools(app, store) {
    if (!$52e3354521f75c8c$var$componentStateTypes.includes($52e3354521f75c8c$var$getStoreType(store.$id))) $52e3354521f75c8c$var$componentStateTypes.push($52e3354521f75c8c$var$getStoreType(store.$id));
    (0, $70eLC.setupDevToolsPlugin)({
        id: 'dev.esm.pinia',
        label: "Pinia \uD83C\uDF4D",
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: $52e3354521f75c8c$var$componentStateTypes,
        app: app,
        settings: {
            logStoreChanges: {
                label: 'Notify about new/deleted stores',
                type: 'boolean',
                defaultValue: true
            }
        }
    }, (api)=>{
        // gracefully handle errors
        const now = typeof api.now === 'function' ? api.now.bind(api) : Date.now;
        store.$onAction(({ after: after, onError: onError, name: name, args: args })=>{
            const groupId = $52e3354521f75c8c$var$runningActionId++;
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDEEB " + name,
                    subtitle: 'start',
                    data: {
                        store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                        action: $52e3354521f75c8c$var$formatDisplay(name),
                        args: args
                    },
                    groupId: groupId
                }
            });
            after((result)=>{
                $52e3354521f75c8c$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "\uD83D\uDEEC " + name,
                        subtitle: 'end',
                        data: {
                            store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                            action: $52e3354521f75c8c$var$formatDisplay(name),
                            args: args,
                            result: result
                        },
                        groupId: groupId
                    }
                });
            });
            onError((error)=>{
                $52e3354521f75c8c$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: 'error',
                        title: "\uD83D\uDCA5 " + name,
                        subtitle: 'end',
                        data: {
                            store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                            action: $52e3354521f75c8c$var$formatDisplay(name),
                            args: args,
                            error: error
                        },
                        groupId: groupId
                    }
                });
            });
        }, true);
        store._customProperties.forEach((name)=>{
            (0, $01W3b.watch)(()=>(0, $01W3b.unref)(store[name]), (newValue, oldValue)=>{
                api.notifyComponentUpdate();
                api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                if ($52e3354521f75c8c$var$isTimelineActive) api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: 'Change',
                        subtitle: name,
                        data: {
                            newValue: newValue,
                            oldValue: oldValue
                        },
                        groupId: $52e3354521f75c8c$var$activeAction
                    }
                });
            }, {
                deep: true
            });
        });
        store.$subscribe(({ events: events, type: type }, state)=>{
            api.notifyComponentUpdate();
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
            if (!$52e3354521f75c8c$var$isTimelineActive) return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: $52e3354521f75c8c$var$formatMutationType(type),
                data: $52e3354521f75c8c$var$assign$1({
                    store: $52e3354521f75c8c$var$formatDisplay(store.$id)
                }, $52e3354521f75c8c$var$formatEventData(events)),
                groupId: $52e3354521f75c8c$var$activeAction
            };
            if (type === $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction) eventData.subtitle = "\u2935\uFE0F";
            else if (type === $52e3354521f75c8c$export$d97371ba8df8c539.patchObject) eventData.subtitle = "\uD83E\uDDE9";
            else if (events && !Array.isArray(events)) eventData.subtitle = events.type;
            if (events) eventData.data['rawEvent(s)'] = {
                _custom: {
                    display: 'DebuggerEvent',
                    type: 'object',
                    tooltip: 'raw DebuggerEvent[]',
                    value: events
                }
            };
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: eventData
            });
        }, {
            detached: true,
            flush: 'sync'
        });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = (0, $01W3b.markRaw)((newStore)=>{
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDD25 " + store.$id,
                    subtitle: 'HMR update',
                    data: {
                        store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                        info: $52e3354521f75c8c$var$formatDisplay(`HMR update`)
                    }
                }
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
        });
        const { $dispose: $dispose } = store;
        store.$dispose = ()=>{
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
            api.getSettings().logStoreChanges && $52e3354521f75c8c$var$toastMessage(`Disposed "${store.$id}" store \u{1F5D1}`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
        api.getSettings().logStoreChanges && $52e3354521f75c8c$var$toastMessage(`"${store.$id}" store installed \u{1F195}`);
    });
}
let $52e3354521f75c8c$var$runningActionId = 0;
let $52e3354521f75c8c$var$activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */ function $52e3354521f75c8c$var$patchActionForGrouping(store, actionNames, wrapWithProxy) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName)=>{
        // use toRaw to avoid tracking #541
        storeActions[actionName] = (0, $01W3b.toRaw)(store)[actionName];
        return storeActions;
    }, {});
    for(const actionName in actions)store[actionName] = function() {
        // the running action id is incremented in a before action hook
        const _actionId = $52e3354521f75c8c$var$runningActionId;
        const trackedStore = wrapWithProxy ? new Proxy(store, {
            get (...args) {
                $52e3354521f75c8c$var$activeAction = _actionId;
                return Reflect.get(...args);
            },
            set (...args) {
                $52e3354521f75c8c$var$activeAction = _actionId;
                return Reflect.set(...args);
            }
        }) : store;
        // For Setup Stores we need https://github.com/tc39/proposal-async-context
        $52e3354521f75c8c$var$activeAction = _actionId;
        const retValue = actions[actionName].apply(trackedStore, arguments);
        // this is safer as async actions in Setup Stores would associate mutations done outside of the action
        $52e3354521f75c8c$var$activeAction = undefined;
        return retValue;
    };
}
/**
 * pinia.use(devtoolsPlugin)
 */ function $52e3354521f75c8c$var$devtoolsPlugin({ app: app, store: store, options: options }) {
    // HMR module
    if (store.$id.startsWith('__hot:')) return;
    // detect option api vs setup api
    store._isOptionsAPI = !!options.state;
    // Do not overwrite actions mocked by @pinia/testing (#2298)
    if (!store._p._testing) {
        $52e3354521f75c8c$var$patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
        // Upgrade the HMR to also update the new actions
        const originalHotUpdate = store._hotUpdate;
        (0, $01W3b.toRaw)(store)._hotUpdate = function(newStore) {
            originalHotUpdate.apply(this, arguments);
            $52e3354521f75c8c$var$patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
        };
    }
    $52e3354521f75c8c$var$addStoreToDevtools(app, // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}
/**
 * Creates a Pinia instance to be used by the application
 */ function $52e3354521f75c8c$export$4b9f6a0748623d44() {
    const scope = (0, $01W3b.effectScope)(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(()=>(0, $01W3b.ref)({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = (0, $01W3b.markRaw)({
        install (app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
            pinia._a = app;
            app.provide($52e3354521f75c8c$var$piniaSymbol, pinia);
            app.config.globalProperties.$pinia = pinia;
            /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) $52e3354521f75c8c$var$registerPiniaDevtools(app, pinia);
            toBeInstalled.forEach((plugin)=>_p.push(plugin));
            toBeInstalled = [];
        },
        use (plugin) {
            if (!this._a) toBeInstalled.push(plugin);
            else _p.push(plugin);
            return this;
        },
        _p: _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state: state
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT && typeof Proxy !== 'undefined') pinia.use($52e3354521f75c8c$var$devtoolsPlugin);
    return pinia;
}
/**
 * Dispose a Pinia instance by stopping its effectScope and removing the state, plugins and stores. This is mostly
 * useful in tests, with both a testing pinia or a regular pinia and in applications that use multiple pinia instances.
 * Once disposed, the pinia instance cannot be used anymore.
 *
 * @param pinia - pinia instance
 */ function $52e3354521f75c8c$export$75b0179c67a9344e(pinia) {
    pinia._e.stop();
    pinia._s.clear();
    pinia._p.splice(0);
    pinia.state.value = {};
    // @ts-expect-error: non valid
    pinia._a = null;
}
/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */ const $52e3354521f75c8c$var$isUseStore = (fn)=>{
    return typeof fn === 'function' && typeof fn.$id === 'string';
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */ function $52e3354521f75c8c$var$patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in oldState){
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) continue;
        const targetValue = newState[key];
        if ($52e3354521f75c8c$var$isPlainObject(targetValue) && $52e3354521f75c8c$var$isPlainObject(subPatch) && !(0, $01W3b.isRef)(subPatch) && !(0, $01W3b.isReactive)(subPatch)) newState[key] = $52e3354521f75c8c$var$patchObject(targetValue, subPatch);
        else // objects are either a bit more complex (e.g. refs) or primitives, so we
        // just set the whole thing
        newState[key] = subPatch;
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */ function $52e3354521f75c8c$export$d3530ca2abd36d5e(initialUseStore, hot) {
    var newModule;
    return ()=>{};
}
const $52e3354521f75c8c$var$noop = ()=>{};
function $52e3354521f75c8c$var$addSubscription(subscriptions, callback, detached, onCleanup = $52e3354521f75c8c$var$noop) {
    subscriptions.add(callback);
    const removeSubscription = ()=>{
        const isDel = subscriptions.delete(callback);
        isDel && onCleanup();
    };
    if (!detached && (0, $01W3b.getCurrentScope)()) (0, $01W3b.onScopeDispose)(removeSubscription);
    return removeSubscription;
}
function $52e3354521f75c8c$var$triggerSubscriptions(subscriptions, ...args) {
    subscriptions.forEach((callback)=>{
        callback(...args);
    });
}
const $52e3354521f75c8c$var$fallbackRunWithContext = (fn)=>fn();
/**
 * Marks a function as an action for `$onAction`
 * @internal
 */ const $52e3354521f75c8c$var$ACTION_MARKER = Symbol();
/**
 * Action name symbol. Allows to add a name to an action after defining it
 * @internal
 */ const $52e3354521f75c8c$var$ACTION_NAME = Symbol();
function $52e3354521f75c8c$var$mergeReactiveObjects(target, patchToApply) {
    // Handle Map instances
    if (target instanceof Map && patchToApply instanceof Map) patchToApply.forEach((value, key)=>target.set(key, value));
    else if (target instanceof Set && patchToApply instanceof Set) // Handle Set instances
    patchToApply.forEach(target.add, target);
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in patchToApply){
        if (!patchToApply.hasOwnProperty(key)) continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if ($52e3354521f75c8c$var$isPlainObject(targetValue) && $52e3354521f75c8c$var$isPlainObject(subPatch) && target.hasOwnProperty(key) && !(0, $01W3b.isRef)(subPatch) && !(0, $01W3b.isReactive)(subPatch)) // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
        // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
        // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
        target[key] = $52e3354521f75c8c$var$mergeReactiveObjects(targetValue, subPatch);
        else // @ts-expect-error: subPatch is a valid value
        target[key] = subPatch;
    }
    return target;
}
const $52e3354521f75c8c$var$skipHydrateSymbol = /* istanbul ignore next */ Symbol();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */ function $52e3354521f75c8c$export$dbb88672ab248e88(obj) {
    return Object.defineProperty(obj, $52e3354521f75c8c$var$skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */ function $52e3354521f75c8c$export$bdc3d2e33d3136e5(obj) {
    return !$52e3354521f75c8c$var$isPlainObject(obj) || !Object.prototype.hasOwnProperty.call(obj, $52e3354521f75c8c$var$skipHydrateSymbol);
}
const { assign: $52e3354521f75c8c$var$assign } = Object;
function $52e3354521f75c8c$var$isComputed(o) {
    return !!((0, $01W3b.isRef)(o) && o.effect);
}
function $52e3354521f75c8c$var$createOptionsStore(id, options, pinia, hot) {
    const { state: state, actions: actions, getters: getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && true) /* istanbul ignore if */ pinia.state.value[id] = state ? state() : {};
        // avoid creating a state in pinia.state.value
        const localState = (0, $01W3b.toRefs)(pinia.state.value[id]);
        return $52e3354521f75c8c$var$assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name)=>{
            computedGetters[name] = (0, $01W3b.markRaw)((0, $01W3b.computed)(()=>{
                $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = $52e3354521f75c8c$var$createSetupStore(id, setup, options, pinia, hot, true);
    return store;
}
function $52e3354521f75c8c$var$createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = $52e3354521f75c8c$var$assign({
        actions: {}
    }, options);
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true
    };
    var event;
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = new Set();
    let actionSubscriptions = new Set();
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && true) /* istanbul ignore if */ pinia.state.value[$id] = {};
    const hotState = (0, $01W3b.ref)({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        if (typeof partialStateOrMutator === 'function') {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction,
                storeId: $id,
                events: debuggerEvents
            };
        } else {
            $52e3354521f75c8c$var$mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: $52e3354521f75c8c$export$d97371ba8df8c539.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents
            };
        }
        const myListenerId = activeListener = Symbol();
        (0, $TusQn.nextTick)().then(()=>{
            if (activeListener === myListenerId) isListening = true;
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        $52e3354521f75c8c$var$triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore ? function $reset() {
        const { state: state } = options;
        const newState = state ? state() : {};
        // we use a patch to group all changes into one single subscription
        this.$patch(($state)=>{
            // @ts-expect-error: FIXME: shouldn't error?
            $52e3354521f75c8c$var$assign($state, newState);
        });
    } : $52e3354521f75c8c$var$noop;
    function $dispose() {
        scope.stop();
        subscriptions.clear();
        actionSubscriptions.clear();
        pinia._s.delete($id);
    }
    /**
     * Helper that wraps function so it can be tracked with $onAction
     * @param fn - action to wrap
     * @param name - name of the action
     */ const action = (fn, name = '')=>{
        if ($52e3354521f75c8c$var$ACTION_MARKER in fn) {
            fn[$52e3354521f75c8c$var$ACTION_NAME] = name;
            return fn;
        }
        const wrappedAction = function() {
            $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
            const args = Array.from(arguments);
            const afterCallbackSet = new Set();
            const onErrorCallbackSet = new Set();
            function after(callback) {
                afterCallbackSet.add(callback);
            }
            function onError(callback) {
                onErrorCallbackSet.add(callback);
            }
            // @ts-expect-error
            $52e3354521f75c8c$var$triggerSubscriptions(actionSubscriptions, {
                args: args,
                name: wrappedAction[$52e3354521f75c8c$var$ACTION_NAME],
                store: store,
                after: after,
                onError: onError
            });
            let ret;
            try {
                ret = fn.apply(this && this.$id === $id ? this : store, args);
            // handle sync errors
            } catch (error) {
                $52e3354521f75c8c$var$triggerSubscriptions(onErrorCallbackSet, error);
                throw error;
            }
            if (ret instanceof Promise) return ret.then((value)=>{
                $52e3354521f75c8c$var$triggerSubscriptions(afterCallbackSet, value);
                return value;
            }).catch((error)=>{
                $52e3354521f75c8c$var$triggerSubscriptions(onErrorCallbackSet, error);
                return Promise.reject(error);
            });
            // trigger after callbacks
            $52e3354521f75c8c$var$triggerSubscriptions(afterCallbackSet, ret);
            return ret;
        };
        wrappedAction[$52e3354521f75c8c$var$ACTION_MARKER] = true;
        wrappedAction[$52e3354521f75c8c$var$ACTION_NAME] = name; // will be set later
        // @ts-expect-error: we are intentionally limiting the returned type to just Fn
        // because all the added properties are internals that are exposed through `$onAction()` only
        return wrappedAction;
    };
    const _hmrPayload = /*#__PURE__*/ (0, $01W3b.markRaw)({
        actions: {},
        getters: {},
        state: [],
        hotState: hotState
    });
    const partialStore = {
        _p: pinia,
        $id: // _s: scope,
        $id,
        $onAction: $52e3354521f75c8c$var$addSubscription.bind(null, actionSubscriptions),
        $patch: $patch,
        $reset: $reset,
        $subscribe (callback, options = {}) {
            const removeSubscription = $52e3354521f75c8c$var$addSubscription(subscriptions, callback, options.detached, ()=>stopWatcher());
            const stopWatcher = scope.run(()=>(0, $01W3b.watch)(()=>pinia.state.value[$id], (state)=>{
                    if (options.flush === 'sync' ? isSyncListening : isListening) callback({
                        storeId: $id,
                        type: $52e3354521f75c8c$export$d97371ba8df8c539.direct,
                        events: debuggerEvents
                    }, state);
                }, $52e3354521f75c8c$var$assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose: $dispose
    };
    const store = (0, $01W3b.reactive)(typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT ? $52e3354521f75c8c$var$assign({
        _hmrPayload: _hmrPayload,
        _customProperties: (0, $01W3b.markRaw)(new Set())
    }, partialStore) : partialStore);
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    const runWithContext = pinia._a && pinia._a.runWithContext || $52e3354521f75c8c$var$fallbackRunWithContext;
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = runWithContext(()=>pinia._e.run(()=>(scope = (0, $01W3b.effectScope)()).run(()=>setup({
                    action: action
                }))));
    // overwrite existing actions to support $onAction
    for(const key in setupStore){
        const prop = setupStore[key];
        if ((0, $01W3b.isRef)(prop) && !$52e3354521f75c8c$var$isComputed(prop) || (0, $01W3b.isReactive)(prop)) {
            if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && $52e3354521f75c8c$export$bdc3d2e33d3136e5(prop)) {
                    if ((0, $01W3b.isRef)(prop)) prop.value = initialState[key];
                    else // probably a reactive object, lets recursively assign
                    // @ts-expect-error: prop is unknown
                    $52e3354521f75c8c$var$mergeReactiveObjects(prop, initialState[key]);
                }
                // transfer the ref to the pinia state to keep everything in sync
                pinia.state.value[$id][key] = prop;
            }
        } else if (typeof prop === 'function') {
            const actionValue = action(prop, key);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            // @ts-expect-error
            setupStore[key] = actionValue;
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */ $52e3354521f75c8c$var$assign(store, setupStore);
    // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
    // Make `storeToRefs()` work with `reactive()` #799
    $52e3354521f75c8c$var$assign((0, $01W3b.toRaw)(store), setupStore);
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, '$state', {
        get: ()=>(0, pinia.state.value[$id]),
        set: (state)=>{
            $patch(($state)=>{
                // @ts-expect-error: FIXME: shouldn't error?
                $52e3354521f75c8c$var$assign($state, state);
            });
        }
    });
    var newStore, stateKey, stateKey1, key, key1;
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false
        };
        [
            '_p',
            '_hmrPayload',
            '_getters',
            '_customProperties'
        ].forEach((p)=>{
            Object.defineProperty(store, p, $52e3354521f75c8c$var$assign({
                value: store[p]
            }, nonEnumerable));
        });
    }
    // apply all plugins
    pinia._p.forEach((extender)=>{
        /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) {
            const extensions = scope.run(()=>extender({
                    store: store,
                    app: pinia._a,
                    pinia: pinia,
                    options: optionsForPlugin
                }));
            Object.keys(extensions || {}).forEach((key)=>store._customProperties.add(key));
            $52e3354521f75c8c$var$assign(store, extensions);
        } else $52e3354521f75c8c$var$assign(store, scope.run(()=>extender({
                store: store,
                app: pinia._a,
                pinia: pinia,
                options: optionsForPlugin
            })));
    });
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState && isOptionsStore && options.hydrate) options.hydrate(store.$state, initialState);
    isListening = true;
    isSyncListening = true;
    return store;
}
// allows unused stores to be tree shaken
/*! #__NO_SIDE_EFFECTS__ */ function $52e3354521f75c8c$export$5061c4f75bbcb4a(// TODO: add proper types from above
id, setup, setupOptions) {
    let options;
    const isSetupStore = typeof setup === 'function';
    // the option store setup will contain the actual options in this case
    options = isSetupStore ? setupOptions : setup;
    function useStore(pinia, hot) {
        const hasContext = (0, $TusQn.hasInjectionContext)();
        pinia = pinia || (hasContext ? (0, $TusQn.inject)($52e3354521f75c8c$var$piniaSymbol, null) : null);
        if (pinia) $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
        pinia = $52e3354521f75c8c$var$activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) $52e3354521f75c8c$var$createSetupStore(id, setup, options, pinia);
            else $52e3354521f75c8c$var$createOptionsStore(id, options, pinia);
        }
        const store = pinia._s.get(id);
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}
let $52e3354521f75c8c$var$mapStoreSuffix = 'Store';
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */ function $52e3354521f75c8c$export$3c0d0850ffd38177(suffix // could be 'Store' but that would be annoying for JS
) {
    $52e3354521f75c8c$var$mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */ function $52e3354521f75c8c$export$4701f243feba9f88(...stores) {
    return stores.reduce((reduced, useStore)=>{
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + $52e3354521f75c8c$var$mapStoreSuffix] = function() {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$a337c713bdba072(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = function() {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[key];
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function() {
            const store = useStore(this.$pinia);
            const storeKey = keysOrMapper[key];
            // for some reason TS is unable to infer the type of storeKey to be a
            // function
            return typeof storeKey === 'function' ? storeKey.call(this, store) : store[storeKey];
        };
        return reduced;
    }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */ const $52e3354521f75c8c$export$74d9085e6d5a97cb = $52e3354521f75c8c$export$a337c713bdba072;
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$1d73b9b98821f6dc(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[key](...args);
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[keysOrMapper[key]](...args);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$c069310e76f1a3e7(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[key];
            },
            set (value) {
                return useStore(this.$pinia)[key] = value;
            }
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[keysOrMapper[key]];
            },
            set (value) {
                return useStore(this.$pinia)[keysOrMapper[key]] = value;
            }
        };
        return reduced;
    }, {});
}
/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */ function $52e3354521f75c8c$export$586af8bd019552de(store) {
    const rawStore = (0, $01W3b.toRaw)(store);
    const refs = {};
    for(const key in rawStore){
        const value = rawStore[key];
        // There is no native method to check for a computed
        // https://github.com/vuejs/core/pull/4165
        if (value.effect) // @ts-expect-error: too hard to type correctly
        refs[key] = // ...
        (0, $01W3b.computed)({
            get: ()=>store[key],
            set (value) {
                store[key] = value;
            }
        });
        else if ((0, $01W3b.isRef)(value) || (0, $01W3b.isReactive)(value)) // @ts-expect-error: the key is state or getter
        refs[key] = // ---
        (0, $01W3b.toRef)(store, key);
    }
    return refs;
}

});
parcelRegister("70eLC", function(module, exports) {

$parcel$export(module.exports, "setupDevToolsPlugin", () => $5193fce5c5df8bb9$export$1f0daed17c8e64f);

var $i0cUC = parcelRequire("i0cUC");

var $dj5lJ = parcelRequire("dj5lJ");

var $ptPDd = parcelRequire("ptPDd");

var $enkGC = parcelRequire("enkGC");
var $5193fce5c5df8bb9$var$__create = Object.create;
var $5193fce5c5df8bb9$var$__defProp = Object.defineProperty;
var $5193fce5c5df8bb9$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $5193fce5c5df8bb9$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $5193fce5c5df8bb9$var$__getProtoOf = Object.getPrototypeOf;
var $5193fce5c5df8bb9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5193fce5c5df8bb9$var$__esm = (fn, res)=>function __init() {
        return fn && (res = (0, fn[$5193fce5c5df8bb9$var$__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
var $5193fce5c5df8bb9$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$5193fce5c5df8bb9$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $5193fce5c5df8bb9$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $5193fce5c5df8bb9$var$__getOwnPropNames(from))if (!$5193fce5c5df8bb9$var$__hasOwnProp.call(to, key) && key !== except) $5193fce5c5df8bb9$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $5193fce5c5df8bb9$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $5193fce5c5df8bb9$var$__toESM = (mod, isNodeMode, target22)=>(target22 = mod != null ? $5193fce5c5df8bb9$var$__create($5193fce5c5df8bb9$var$__getProtoOf(mod)) : {}, $5193fce5c5df8bb9$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $5193fce5c5df8bb9$var$__defProp(target22, "default", {
        value: mod,
        enumerable: true
    }) : target22, mod));
// ../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js
var $5193fce5c5df8bb9$var$init_esm_shims = $5193fce5c5df8bb9$var$__esm({
    "../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js" () {
        "use strict";
    }
});
// ../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js
var $5193fce5c5df8bb9$var$require_speakingurl = $5193fce5c5df8bb9$var$__commonJS({
    "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js" (exports, module) {
        "use strict";
        $5193fce5c5df8bb9$var$init_esm_shims();
        (function(root) {
            "use strict";
            var charMap = {
                // latin
                "\xC0": "A",
                "\xC1": "A",
                "\xC2": "A",
                "\xC3": "A",
                "\xC4": "Ae",
                "\xC5": "A",
                "\xC6": "AE",
                "\xC7": "C",
                "\xC8": "E",
                "\xC9": "E",
                "\xCA": "E",
                "\xCB": "E",
                "\xCC": "I",
                "\xCD": "I",
                "\xCE": "I",
                "\xCF": "I",
                "\xD0": "D",
                "\xD1": "N",
                "\xD2": "O",
                "\xD3": "O",
                "\xD4": "O",
                "\xD5": "O",
                "\xD6": "Oe",
                "\u0150": "O",
                "\xD8": "O",
                "\xD9": "U",
                "\xDA": "U",
                "\xDB": "U",
                "\xDC": "Ue",
                "\u0170": "U",
                "\xDD": "Y",
                "\xDE": "TH",
                "\xDF": "ss",
                "\xE0": "a",
                "\xE1": "a",
                "\xE2": "a",
                "\xE3": "a",
                "\xE4": "ae",
                "\xE5": "a",
                "\xE6": "ae",
                "\xE7": "c",
                "\xE8": "e",
                "\xE9": "e",
                "\xEA": "e",
                "\xEB": "e",
                "\xEC": "i",
                "\xED": "i",
                "\xEE": "i",
                "\xEF": "i",
                "\xF0": "d",
                "\xF1": "n",
                "\xF2": "o",
                "\xF3": "o",
                "\xF4": "o",
                "\xF5": "o",
                "\xF6": "oe",
                "\u0151": "o",
                "\xF8": "o",
                "\xF9": "u",
                "\xFA": "u",
                "\xFB": "u",
                "\xFC": "ue",
                "\u0171": "u",
                "\xFD": "y",
                "\xFE": "th",
                "\xFF": "y",
                "\u1E9E": "SS",
                // language specific
                // Arabic
                "\u0627": "a",
                "\u0623": "a",
                "\u0625": "i",
                "\u0622": "aa",
                "\u0624": "u",
                "\u0626": "e",
                "\u0621": "a",
                "\u0628": "b",
                "\u062A": "t",
                "\u062B": "th",
                "\u062C": "j",
                "\u062D": "h",
                "\u062E": "kh",
                "\u062F": "d",
                "\u0630": "th",
                "\u0631": "r",
                "\u0632": "z",
                "\u0633": "s",
                "\u0634": "sh",
                "\u0635": "s",
                "\u0636": "dh",
                "\u0637": "t",
                "\u0638": "z",
                "\u0639": "a",
                "\u063A": "gh",
                "\u0641": "f",
                "\u0642": "q",
                "\u0643": "k",
                "\u0644": "l",
                "\u0645": "m",
                "\u0646": "n",
                "\u0647": "h",
                "\u0648": "w",
                "\u064A": "y",
                "\u0649": "a",
                "\u0629": "h",
                "\uFEFB": "la",
                "\uFEF7": "laa",
                "\uFEF9": "lai",
                "\uFEF5": "laa",
                // Persian additional characters than Arabic
                "\u06AF": "g",
                "\u0686": "ch",
                "\u067E": "p",
                "\u0698": "zh",
                "\u06A9": "k",
                "\u06CC": "y",
                // Arabic diactrics
                "\u064E": "a",
                "\u064B": "an",
                "\u0650": "e",
                "\u064D": "en",
                "\u064F": "u",
                "\u064C": "on",
                "\u0652": "",
                // Arabic numbers
                "\u0660": "0",
                "\u0661": "1",
                "\u0662": "2",
                "\u0663": "3",
                "\u0664": "4",
                "\u0665": "5",
                "\u0666": "6",
                "\u0667": "7",
                "\u0668": "8",
                "\u0669": "9",
                // Persian numbers
                "\u06F0": "0",
                "\u06F1": "1",
                "\u06F2": "2",
                "\u06F3": "3",
                "\u06F4": "4",
                "\u06F5": "5",
                "\u06F6": "6",
                "\u06F7": "7",
                "\u06F8": "8",
                "\u06F9": "9",
                // Burmese consonants
                "\u1000": "k",
                "\u1001": "kh",
                "\u1002": "g",
                "\u1003": "ga",
                "\u1004": "ng",
                "\u1005": "s",
                "\u1006": "sa",
                "\u1007": "z",
                "\u1005\u103B": "za",
                "\u100A": "ny",
                "\u100B": "t",
                "\u100C": "ta",
                "\u100D": "d",
                "\u100E": "da",
                "\u100F": "na",
                "\u1010": "t",
                "\u1011": "ta",
                "\u1012": "d",
                "\u1013": "da",
                "\u1014": "n",
                "\u1015": "p",
                "\u1016": "pa",
                "\u1017": "b",
                "\u1018": "ba",
                "\u1019": "m",
                "\u101A": "y",
                "\u101B": "ya",
                "\u101C": "l",
                "\u101D": "w",
                "\u101E": "th",
                "\u101F": "h",
                "\u1020": "la",
                "\u1021": "a",
                // consonant character combos
                "\u103C": "y",
                "\u103B": "ya",
                "\u103D": "w",
                "\u103C\u103D": "yw",
                "\u103B\u103D": "ywa",
                "\u103E": "h",
                // independent vowels
                "\u1027": "e",
                "\u104F": "-e",
                "\u1023": "i",
                "\u1024": "-i",
                "\u1009": "u",
                "\u1026": "-u",
                "\u1029": "aw",
                "\u101E\u103C\u1031\u102C": "aw",
                "\u102A": "aw",
                // numbers
                "\u1040": "0",
                "\u1041": "1",
                "\u1042": "2",
                "\u1043": "3",
                "\u1044": "4",
                "\u1045": "5",
                "\u1046": "6",
                "\u1047": "7",
                "\u1048": "8",
                "\u1049": "9",
                // virama and tone marks which are silent in transliteration
                "\u1039": "",
                "\u1037": "",
                "\u1038": "",
                // Czech
                "\u010D": "c",
                "\u010F": "d",
                "\u011B": "e",
                "\u0148": "n",
                "\u0159": "r",
                "\u0161": "s",
                "\u0165": "t",
                "\u016F": "u",
                "\u017E": "z",
                "\u010C": "C",
                "\u010E": "D",
                "\u011A": "E",
                "\u0147": "N",
                "\u0158": "R",
                "\u0160": "S",
                "\u0164": "T",
                "\u016E": "U",
                "\u017D": "Z",
                // Dhivehi
                "\u0780": "h",
                "\u0781": "sh",
                "\u0782": "n",
                "\u0783": "r",
                "\u0784": "b",
                "\u0785": "lh",
                "\u0786": "k",
                "\u0787": "a",
                "\u0788": "v",
                "\u0789": "m",
                "\u078A": "f",
                "\u078B": "dh",
                "\u078C": "th",
                "\u078D": "l",
                "\u078E": "g",
                "\u078F": "gn",
                "\u0790": "s",
                "\u0791": "d",
                "\u0792": "z",
                "\u0793": "t",
                "\u0794": "y",
                "\u0795": "p",
                "\u0796": "j",
                "\u0797": "ch",
                "\u0798": "tt",
                "\u0799": "hh",
                "\u079A": "kh",
                "\u079B": "th",
                "\u079C": "z",
                "\u079D": "sh",
                "\u079E": "s",
                "\u079F": "d",
                "\u07A0": "t",
                "\u07A1": "z",
                "\u07A2": "a",
                "\u07A3": "gh",
                "\u07A4": "q",
                "\u07A5": "w",
                "\u07A6": "a",
                "\u07A7": "aa",
                "\u07A8": "i",
                "\u07A9": "ee",
                "\u07AA": "u",
                "\u07AB": "oo",
                "\u07AC": "e",
                "\u07AD": "ey",
                "\u07AE": "o",
                "\u07AF": "oa",
                "\u07B0": "",
                // Georgian https://en.wikipedia.org/wiki/Romanization_of_Georgian
                // National system (2002)
                "\u10D0": "a",
                "\u10D1": "b",
                "\u10D2": "g",
                "\u10D3": "d",
                "\u10D4": "e",
                "\u10D5": "v",
                "\u10D6": "z",
                "\u10D7": "t",
                "\u10D8": "i",
                "\u10D9": "k",
                "\u10DA": "l",
                "\u10DB": "m",
                "\u10DC": "n",
                "\u10DD": "o",
                "\u10DE": "p",
                "\u10DF": "zh",
                "\u10E0": "r",
                "\u10E1": "s",
                "\u10E2": "t",
                "\u10E3": "u",
                "\u10E4": "p",
                "\u10E5": "k",
                "\u10E6": "gh",
                "\u10E7": "q",
                "\u10E8": "sh",
                "\u10E9": "ch",
                "\u10EA": "ts",
                "\u10EB": "dz",
                "\u10EC": "ts",
                "\u10ED": "ch",
                "\u10EE": "kh",
                "\u10EF": "j",
                "\u10F0": "h",
                // Greek
                "\u03B1": "a",
                "\u03B2": "v",
                "\u03B3": "g",
                "\u03B4": "d",
                "\u03B5": "e",
                "\u03B6": "z",
                "\u03B7": "i",
                "\u03B8": "th",
                "\u03B9": "i",
                "\u03BA": "k",
                "\u03BB": "l",
                "\u03BC": "m",
                "\u03BD": "n",
                "\u03BE": "ks",
                "\u03BF": "o",
                "\u03C0": "p",
                "\u03C1": "r",
                "\u03C3": "s",
                "\u03C4": "t",
                "\u03C5": "y",
                "\u03C6": "f",
                "\u03C7": "x",
                "\u03C8": "ps",
                "\u03C9": "o",
                "\u03AC": "a",
                "\u03AD": "e",
                "\u03AF": "i",
                "\u03CC": "o",
                "\u03CD": "y",
                "\u03AE": "i",
                "\u03CE": "o",
                "\u03C2": "s",
                "\u03CA": "i",
                "\u03B0": "y",
                "\u03CB": "y",
                "\u0390": "i",
                "\u0391": "A",
                "\u0392": "B",
                "\u0393": "G",
                "\u0394": "D",
                "\u0395": "E",
                "\u0396": "Z",
                "\u0397": "I",
                "\u0398": "TH",
                "\u0399": "I",
                "\u039A": "K",
                "\u039B": "L",
                "\u039C": "M",
                "\u039D": "N",
                "\u039E": "KS",
                "\u039F": "O",
                "\u03A0": "P",
                "\u03A1": "R",
                "\u03A3": "S",
                "\u03A4": "T",
                "\u03A5": "Y",
                "\u03A6": "F",
                "\u03A7": "X",
                "\u03A8": "PS",
                "\u03A9": "O",
                "\u0386": "A",
                "\u0388": "E",
                "\u038A": "I",
                "\u038C": "O",
                "\u038E": "Y",
                "\u0389": "I",
                "\u038F": "O",
                "\u03AA": "I",
                "\u03AB": "Y",
                // Latvian
                "\u0101": "a",
                // 'č': 'c', // duplicate
                "\u0113": "e",
                "\u0123": "g",
                "\u012B": "i",
                "\u0137": "k",
                "\u013C": "l",
                "\u0146": "n",
                // 'š': 's', // duplicate
                "\u016B": "u",
                // 'ž': 'z', // duplicate
                "\u0100": "A",
                // 'Č': 'C', // duplicate
                "\u0112": "E",
                "\u0122": "G",
                "\u012A": "I",
                "\u0136": "k",
                "\u013B": "L",
                "\u0145": "N",
                // 'Š': 'S', // duplicate
                "\u016A": "U",
                // 'Ž': 'Z', // duplicate
                // Macedonian
                "\u040C": "Kj",
                "\u045C": "kj",
                "\u0409": "Lj",
                "\u0459": "lj",
                "\u040A": "Nj",
                "\u045A": "nj",
                "\u0422\u0441": "Ts",
                "\u0442\u0441": "ts",
                // Polish
                "\u0105": "a",
                "\u0107": "c",
                "\u0119": "e",
                "\u0142": "l",
                "\u0144": "n",
                // 'ó': 'o', // duplicate
                "\u015B": "s",
                "\u017A": "z",
                "\u017C": "z",
                "\u0104": "A",
                "\u0106": "C",
                "\u0118": "E",
                "\u0141": "L",
                "\u0143": "N",
                "\u015A": "S",
                "\u0179": "Z",
                "\u017B": "Z",
                // Ukranian
                "\u0404": "Ye",
                "\u0406": "I",
                "\u0407": "Yi",
                "\u0490": "G",
                "\u0454": "ye",
                "\u0456": "i",
                "\u0457": "yi",
                "\u0491": "g",
                // Romanian
                "\u0103": "a",
                "\u0102": "A",
                "\u0219": "s",
                "\u0218": "S",
                // 'ş': 's', // duplicate
                // 'Ş': 'S', // duplicate
                "\u021B": "t",
                "\u021A": "T",
                "\u0163": "t",
                "\u0162": "T",
                // Russian https://en.wikipedia.org/wiki/Romanization_of_Russian
                // ICAO
                "\u0430": "a",
                "\u0431": "b",
                "\u0432": "v",
                "\u0433": "g",
                "\u0434": "d",
                "\u0435": "e",
                "\u0451": "yo",
                "\u0436": "zh",
                "\u0437": "z",
                "\u0438": "i",
                "\u0439": "i",
                "\u043A": "k",
                "\u043B": "l",
                "\u043C": "m",
                "\u043D": "n",
                "\u043E": "o",
                "\u043F": "p",
                "\u0440": "r",
                "\u0441": "s",
                "\u0442": "t",
                "\u0443": "u",
                "\u0444": "f",
                "\u0445": "kh",
                "\u0446": "c",
                "\u0447": "ch",
                "\u0448": "sh",
                "\u0449": "sh",
                "\u044A": "",
                "\u044B": "y",
                "\u044C": "",
                "\u044D": "e",
                "\u044E": "yu",
                "\u044F": "ya",
                "\u0410": "A",
                "\u0411": "B",
                "\u0412": "V",
                "\u0413": "G",
                "\u0414": "D",
                "\u0415": "E",
                "\u0401": "Yo",
                "\u0416": "Zh",
                "\u0417": "Z",
                "\u0418": "I",
                "\u0419": "I",
                "\u041A": "K",
                "\u041B": "L",
                "\u041C": "M",
                "\u041D": "N",
                "\u041E": "O",
                "\u041F": "P",
                "\u0420": "R",
                "\u0421": "S",
                "\u0422": "T",
                "\u0423": "U",
                "\u0424": "F",
                "\u0425": "Kh",
                "\u0426": "C",
                "\u0427": "Ch",
                "\u0428": "Sh",
                "\u0429": "Sh",
                "\u042A": "",
                "\u042B": "Y",
                "\u042C": "",
                "\u042D": "E",
                "\u042E": "Yu",
                "\u042F": "Ya",
                // Serbian
                "\u0452": "dj",
                "\u0458": "j",
                // 'љ': 'lj',  // duplicate
                // 'њ': 'nj', // duplicate
                "\u045B": "c",
                "\u045F": "dz",
                "\u0402": "Dj",
                "\u0408": "j",
                // 'Љ': 'Lj', // duplicate
                // 'Њ': 'Nj', // duplicate
                "\u040B": "C",
                "\u040F": "Dz",
                // Slovak
                "\u013E": "l",
                "\u013A": "l",
                "\u0155": "r",
                "\u013D": "L",
                "\u0139": "L",
                "\u0154": "R",
                // Turkish
                "\u015F": "s",
                "\u015E": "S",
                "\u0131": "i",
                "\u0130": "I",
                // 'ç': 'c', // duplicate
                // 'Ç': 'C', // duplicate
                // 'ü': 'u', // duplicate, see langCharMap
                // 'Ü': 'U', // duplicate, see langCharMap
                // 'ö': 'o', // duplicate, see langCharMap
                // 'Ö': 'O', // duplicate, see langCharMap
                "\u011F": "g",
                "\u011E": "G",
                // Vietnamese
                "\u1EA3": "a",
                "\u1EA2": "A",
                "\u1EB3": "a",
                "\u1EB2": "A",
                "\u1EA9": "a",
                "\u1EA8": "A",
                "\u0111": "d",
                "\u0110": "D",
                "\u1EB9": "e",
                "\u1EB8": "E",
                "\u1EBD": "e",
                "\u1EBC": "E",
                "\u1EBB": "e",
                "\u1EBA": "E",
                "\u1EBF": "e",
                "\u1EBE": "E",
                "\u1EC1": "e",
                "\u1EC0": "E",
                "\u1EC7": "e",
                "\u1EC6": "E",
                "\u1EC5": "e",
                "\u1EC4": "E",
                "\u1EC3": "e",
                "\u1EC2": "E",
                "\u1ECF": "o",
                "\u1ECD": "o",
                "\u1ECC": "o",
                "\u1ED1": "o",
                "\u1ED0": "O",
                "\u1ED3": "o",
                "\u1ED2": "O",
                "\u1ED5": "o",
                "\u1ED4": "O",
                "\u1ED9": "o",
                "\u1ED8": "O",
                "\u1ED7": "o",
                "\u1ED6": "O",
                "\u01A1": "o",
                "\u01A0": "O",
                "\u1EDB": "o",
                "\u1EDA": "O",
                "\u1EDD": "o",
                "\u1EDC": "O",
                "\u1EE3": "o",
                "\u1EE2": "O",
                "\u1EE1": "o",
                "\u1EE0": "O",
                "\u1EDE": "o",
                "\u1EDF": "o",
                "\u1ECB": "i",
                "\u1ECA": "I",
                "\u0129": "i",
                "\u0128": "I",
                "\u1EC9": "i",
                "\u1EC8": "i",
                "\u1EE7": "u",
                "\u1EE6": "U",
                "\u1EE5": "u",
                "\u1EE4": "U",
                "\u0169": "u",
                "\u0168": "U",
                "\u01B0": "u",
                "\u01AF": "U",
                "\u1EE9": "u",
                "\u1EE8": "U",
                "\u1EEB": "u",
                "\u1EEA": "U",
                "\u1EF1": "u",
                "\u1EF0": "U",
                "\u1EEF": "u",
                "\u1EEE": "U",
                "\u1EED": "u",
                "\u1EEC": "\u01B0",
                "\u1EF7": "y",
                "\u1EF6": "y",
                "\u1EF3": "y",
                "\u1EF2": "Y",
                "\u1EF5": "y",
                "\u1EF4": "Y",
                "\u1EF9": "y",
                "\u1EF8": "Y",
                "\u1EA1": "a",
                "\u1EA0": "A",
                "\u1EA5": "a",
                "\u1EA4": "A",
                "\u1EA7": "a",
                "\u1EA6": "A",
                "\u1EAD": "a",
                "\u1EAC": "A",
                "\u1EAB": "a",
                "\u1EAA": "A",
                // 'ă': 'a', // duplicate
                // 'Ă': 'A', // duplicate
                "\u1EAF": "a",
                "\u1EAE": "A",
                "\u1EB1": "a",
                "\u1EB0": "A",
                "\u1EB7": "a",
                "\u1EB6": "A",
                "\u1EB5": "a",
                "\u1EB4": "A",
                "\u24EA": "0",
                "\u2460": "1",
                "\u2461": "2",
                "\u2462": "3",
                "\u2463": "4",
                "\u2464": "5",
                "\u2465": "6",
                "\u2466": "7",
                "\u2467": "8",
                "\u2468": "9",
                "\u2469": "10",
                "\u246A": "11",
                "\u246B": "12",
                "\u246C": "13",
                "\u246D": "14",
                "\u246E": "15",
                "\u246F": "16",
                "\u2470": "17",
                "\u2471": "18",
                "\u2472": "18",
                "\u2473": "18",
                "\u24F5": "1",
                "\u24F6": "2",
                "\u24F7": "3",
                "\u24F8": "4",
                "\u24F9": "5",
                "\u24FA": "6",
                "\u24FB": "7",
                "\u24FC": "8",
                "\u24FD": "9",
                "\u24FE": "10",
                "\u24FF": "0",
                "\u24EB": "11",
                "\u24EC": "12",
                "\u24ED": "13",
                "\u24EE": "14",
                "\u24EF": "15",
                "\u24F0": "16",
                "\u24F1": "17",
                "\u24F2": "18",
                "\u24F3": "19",
                "\u24F4": "20",
                "\u24B6": "A",
                "\u24B7": "B",
                "\u24B8": "C",
                "\u24B9": "D",
                "\u24BA": "E",
                "\u24BB": "F",
                "\u24BC": "G",
                "\u24BD": "H",
                "\u24BE": "I",
                "\u24BF": "J",
                "\u24C0": "K",
                "\u24C1": "L",
                "\u24C2": "M",
                "\u24C3": "N",
                "\u24C4": "O",
                "\u24C5": "P",
                "\u24C6": "Q",
                "\u24C7": "R",
                "\u24C8": "S",
                "\u24C9": "T",
                "\u24CA": "U",
                "\u24CB": "V",
                "\u24CC": "W",
                "\u24CD": "X",
                "\u24CE": "Y",
                "\u24CF": "Z",
                "\u24D0": "a",
                "\u24D1": "b",
                "\u24D2": "c",
                "\u24D3": "d",
                "\u24D4": "e",
                "\u24D5": "f",
                "\u24D6": "g",
                "\u24D7": "h",
                "\u24D8": "i",
                "\u24D9": "j",
                "\u24DA": "k",
                "\u24DB": "l",
                "\u24DC": "m",
                "\u24DD": "n",
                "\u24DE": "o",
                "\u24DF": "p",
                "\u24E0": "q",
                "\u24E1": "r",
                "\u24E2": "s",
                "\u24E3": "t",
                "\u24E4": "u",
                "\u24E6": "v",
                "\u24E5": "w",
                "\u24E7": "x",
                "\u24E8": "y",
                "\u24E9": "z",
                // symbols
                "\u201C": '"',
                "\u201D": '"',
                "\u2018": "'",
                "\u2019": "'",
                "\u2202": "d",
                "\u0192": "f",
                "\u2122": "(TM)",
                "\xA9": "(C)",
                "\u0153": "oe",
                "\u0152": "OE",
                "\xAE": "(R)",
                "\u2020": "+",
                "\u2120": "(SM)",
                "\u2026": "...",
                "\u02DA": "o",
                "\xBA": "o",
                "\xAA": "a",
                "\u2022": "*",
                "\u104A": ",",
                "\u104B": ".",
                // currency
                "$": "USD",
                "\u20AC": "EUR",
                "\u20A2": "BRN",
                "\u20A3": "FRF",
                "\xA3": "GBP",
                "\u20A4": "ITL",
                "\u20A6": "NGN",
                "\u20A7": "ESP",
                "\u20A9": "KRW",
                "\u20AA": "ILS",
                "\u20AB": "VND",
                "\u20AD": "LAK",
                "\u20AE": "MNT",
                "\u20AF": "GRD",
                "\u20B1": "ARS",
                "\u20B2": "PYG",
                "\u20B3": "ARA",
                "\u20B4": "UAH",
                "\u20B5": "GHS",
                "\xA2": "cent",
                "\xA5": "CNY",
                "\u5143": "CNY",
                "\u5186": "YEN",
                "\uFDFC": "IRR",
                "\u20A0": "EWE",
                "\u0E3F": "THB",
                "\u20A8": "INR",
                "\u20B9": "INR",
                "\u20B0": "PF",
                "\u20BA": "TRY",
                "\u060B": "AFN",
                "\u20BC": "AZN",
                "\u043B\u0432": "BGN",
                "\u17DB": "KHR",
                "\u20A1": "CRC",
                "\u20B8": "KZT",
                "\u0434\u0435\u043D": "MKD",
                "z\u0142": "PLN",
                "\u20BD": "RUB",
                "\u20BE": "GEL"
            };
            var lookAheadCharArray = [
                // burmese
                "\u103A",
                // Dhivehi
                "\u07B0"
            ];
            var diatricMap = {
                // Burmese
                // dependent vowels
                "\u102C": "a",
                "\u102B": "a",
                "\u1031": "e",
                "\u1032": "e",
                "\u102D": "i",
                "\u102E": "i",
                "\u102D\u102F": "o",
                "\u102F": "u",
                "\u1030": "u",
                "\u1031\u102B\u1004\u103A": "aung",
                "\u1031\u102C": "aw",
                "\u1031\u102C\u103A": "aw",
                "\u1031\u102B": "aw",
                "\u1031\u102B\u103A": "aw",
                "\u103A": "\u103A",
                // this is special case but the character will be converted to latin in the code
                "\u1000\u103A": "et",
                "\u102D\u102F\u1000\u103A": "aik",
                "\u1031\u102C\u1000\u103A": "auk",
                "\u1004\u103A": "in",
                "\u102D\u102F\u1004\u103A": "aing",
                "\u1031\u102C\u1004\u103A": "aung",
                "\u1005\u103A": "it",
                "\u100A\u103A": "i",
                "\u1010\u103A": "at",
                "\u102D\u1010\u103A": "eik",
                "\u102F\u1010\u103A": "ok",
                "\u103D\u1010\u103A": "ut",
                "\u1031\u1010\u103A": "it",
                "\u1012\u103A": "d",
                "\u102D\u102F\u1012\u103A": "ok",
                "\u102F\u1012\u103A": "ait",
                "\u1014\u103A": "an",
                "\u102C\u1014\u103A": "an",
                "\u102D\u1014\u103A": "ein",
                "\u102F\u1014\u103A": "on",
                "\u103D\u1014\u103A": "un",
                "\u1015\u103A": "at",
                "\u102D\u1015\u103A": "eik",
                "\u102F\u1015\u103A": "ok",
                "\u103D\u1015\u103A": "ut",
                "\u1014\u103A\u102F\u1015\u103A": "nub",
                "\u1019\u103A": "an",
                "\u102D\u1019\u103A": "ein",
                "\u102F\u1019\u103A": "on",
                "\u103D\u1019\u103A": "un",
                "\u101A\u103A": "e",
                "\u102D\u102F\u101C\u103A": "ol",
                "\u1009\u103A": "in",
                "\u1036": "an",
                "\u102D\u1036": "ein",
                "\u102F\u1036": "on",
                // Dhivehi
                "\u07A6\u0787\u07B0": "ah",
                "\u07A6\u0781\u07B0": "ah"
            };
            var langCharMap = {
                "en": {},
                // default language
                "az": {
                    // Azerbaijani
                    "\xE7": "c",
                    "\u0259": "e",
                    "\u011F": "g",
                    "\u0131": "i",
                    "\xF6": "o",
                    "\u015F": "s",
                    "\xFC": "u",
                    "\xC7": "C",
                    "\u018F": "E",
                    "\u011E": "G",
                    "\u0130": "I",
                    "\xD6": "O",
                    "\u015E": "S",
                    "\xDC": "U"
                },
                "cs": {
                    // Czech
                    "\u010D": "c",
                    "\u010F": "d",
                    "\u011B": "e",
                    "\u0148": "n",
                    "\u0159": "r",
                    "\u0161": "s",
                    "\u0165": "t",
                    "\u016F": "u",
                    "\u017E": "z",
                    "\u010C": "C",
                    "\u010E": "D",
                    "\u011A": "E",
                    "\u0147": "N",
                    "\u0158": "R",
                    "\u0160": "S",
                    "\u0164": "T",
                    "\u016E": "U",
                    "\u017D": "Z"
                },
                "fi": {
                    // Finnish
                    // 'å': 'a', duplicate see charMap/latin
                    // 'Å': 'A', duplicate see charMap/latin
                    "\xE4": "a",
                    // ok
                    "\xC4": "A",
                    // ok
                    "\xF6": "o",
                    // ok
                    "\xD6": "O"
                },
                "hu": {
                    // Hungarian
                    "\xE4": "a",
                    // ok
                    "\xC4": "A",
                    // ok
                    // 'á': 'a', duplicate see charMap/latin
                    // 'Á': 'A', duplicate see charMap/latin
                    "\xF6": "o",
                    // ok
                    "\xD6": "O",
                    // ok
                    // 'ő': 'o', duplicate see charMap/latin
                    // 'Ő': 'O', duplicate see charMap/latin
                    "\xFC": "u",
                    "\xDC": "U",
                    "\u0171": "u",
                    "\u0170": "U"
                },
                "lt": {
                    // Lithuanian
                    "\u0105": "a",
                    "\u010D": "c",
                    "\u0119": "e",
                    "\u0117": "e",
                    "\u012F": "i",
                    "\u0161": "s",
                    "\u0173": "u",
                    "\u016B": "u",
                    "\u017E": "z",
                    "\u0104": "A",
                    "\u010C": "C",
                    "\u0118": "E",
                    "\u0116": "E",
                    "\u012E": "I",
                    "\u0160": "S",
                    "\u0172": "U",
                    "\u016A": "U"
                },
                "lv": {
                    // Latvian
                    "\u0101": "a",
                    "\u010D": "c",
                    "\u0113": "e",
                    "\u0123": "g",
                    "\u012B": "i",
                    "\u0137": "k",
                    "\u013C": "l",
                    "\u0146": "n",
                    "\u0161": "s",
                    "\u016B": "u",
                    "\u017E": "z",
                    "\u0100": "A",
                    "\u010C": "C",
                    "\u0112": "E",
                    "\u0122": "G",
                    "\u012A": "i",
                    "\u0136": "k",
                    "\u013B": "L",
                    "\u0145": "N",
                    "\u0160": "S",
                    "\u016A": "u",
                    "\u017D": "Z"
                },
                "pl": {
                    // Polish
                    "\u0105": "a",
                    "\u0107": "c",
                    "\u0119": "e",
                    "\u0142": "l",
                    "\u0144": "n",
                    "\xF3": "o",
                    "\u015B": "s",
                    "\u017A": "z",
                    "\u017C": "z",
                    "\u0104": "A",
                    "\u0106": "C",
                    "\u0118": "e",
                    "\u0141": "L",
                    "\u0143": "N",
                    "\xD3": "O",
                    "\u015A": "S",
                    "\u0179": "Z",
                    "\u017B": "Z"
                },
                "sv": {
                    // Swedish
                    // 'å': 'a', duplicate see charMap/latin
                    // 'Å': 'A', duplicate see charMap/latin
                    "\xE4": "a",
                    // ok
                    "\xC4": "A",
                    // ok
                    "\xF6": "o",
                    // ok
                    "\xD6": "O"
                },
                "sk": {
                    // Slovak
                    "\xE4": "a",
                    "\xC4": "A"
                },
                "sr": {
                    // Serbian
                    "\u0459": "lj",
                    "\u045A": "nj",
                    "\u0409": "Lj",
                    "\u040A": "Nj",
                    "\u0111": "dj",
                    "\u0110": "Dj"
                },
                "tr": {
                    // Turkish
                    "\xDC": "U",
                    "\xD6": "O",
                    "\xFC": "u",
                    "\xF6": "o"
                }
            };
            var symbolMap = {
                "ar": {
                    "\u2206": "delta",
                    "\u221E": "la-nihaya",
                    "\u2665": "hob",
                    "&": "wa",
                    "|": "aw",
                    "<": "aqal-men",
                    ">": "akbar-men",
                    "\u2211": "majmou",
                    "\xA4": "omla"
                },
                "az": {},
                "ca": {
                    "\u2206": "delta",
                    "\u221E": "infinit",
                    "\u2665": "amor",
                    "&": "i",
                    "|": "o",
                    "<": "menys que",
                    ">": "mes que",
                    "\u2211": "suma dels",
                    "\xA4": "moneda"
                },
                "cs": {
                    "\u2206": "delta",
                    "\u221E": "nekonecno",
                    "\u2665": "laska",
                    "&": "a",
                    "|": "nebo",
                    "<": "mensi nez",
                    ">": "vetsi nez",
                    "\u2211": "soucet",
                    "\xA4": "mena"
                },
                "de": {
                    "\u2206": "delta",
                    "\u221E": "unendlich",
                    "\u2665": "Liebe",
                    "&": "und",
                    "|": "oder",
                    "<": "kleiner als",
                    ">": "groesser als",
                    "\u2211": "Summe von",
                    "\xA4": "Waehrung"
                },
                "dv": {
                    "\u2206": "delta",
                    "\u221E": "kolunulaa",
                    "\u2665": "loabi",
                    "&": "aai",
                    "|": "noonee",
                    "<": "ah vure kuda",
                    ">": "ah vure bodu",
                    "\u2211": "jumula",
                    "\xA4": "faisaa"
                },
                "en": {
                    "\u2206": "delta",
                    "\u221E": "infinity",
                    "\u2665": "love",
                    "&": "and",
                    "|": "or",
                    "<": "less than",
                    ">": "greater than",
                    "\u2211": "sum",
                    "\xA4": "currency"
                },
                "es": {
                    "\u2206": "delta",
                    "\u221E": "infinito",
                    "\u2665": "amor",
                    "&": "y",
                    "|": "u",
                    "<": "menos que",
                    ">": "mas que",
                    "\u2211": "suma de los",
                    "\xA4": "moneda"
                },
                "fa": {
                    "\u2206": "delta",
                    "\u221E": "bi-nahayat",
                    "\u2665": "eshgh",
                    "&": "va",
                    "|": "ya",
                    "<": "kamtar-az",
                    ">": "bishtar-az",
                    "\u2211": "majmooe",
                    "\xA4": "vahed"
                },
                "fi": {
                    "\u2206": "delta",
                    "\u221E": "aarettomyys",
                    "\u2665": "rakkaus",
                    "&": "ja",
                    "|": "tai",
                    "<": "pienempi kuin",
                    ">": "suurempi kuin",
                    "\u2211": "summa",
                    "\xA4": "valuutta"
                },
                "fr": {
                    "\u2206": "delta",
                    "\u221E": "infiniment",
                    "\u2665": "Amour",
                    "&": "et",
                    "|": "ou",
                    "<": "moins que",
                    ">": "superieure a",
                    "\u2211": "somme des",
                    "\xA4": "monnaie"
                },
                "ge": {
                    "\u2206": "delta",
                    "\u221E": "usasruloba",
                    "\u2665": "siqvaruli",
                    "&": "da",
                    "|": "an",
                    "<": "naklebi",
                    ">": "meti",
                    "\u2211": "jami",
                    "\xA4": "valuta"
                },
                "gr": {},
                "hu": {
                    "\u2206": "delta",
                    "\u221E": "vegtelen",
                    "\u2665": "szerelem",
                    "&": "es",
                    "|": "vagy",
                    "<": "kisebb mint",
                    ">": "nagyobb mint",
                    "\u2211": "szumma",
                    "\xA4": "penznem"
                },
                "it": {
                    "\u2206": "delta",
                    "\u221E": "infinito",
                    "\u2665": "amore",
                    "&": "e",
                    "|": "o",
                    "<": "minore di",
                    ">": "maggiore di",
                    "\u2211": "somma",
                    "\xA4": "moneta"
                },
                "lt": {
                    "\u2206": "delta",
                    "\u221E": "begalybe",
                    "\u2665": "meile",
                    "&": "ir",
                    "|": "ar",
                    "<": "maziau nei",
                    ">": "daugiau nei",
                    "\u2211": "suma",
                    "\xA4": "valiuta"
                },
                "lv": {
                    "\u2206": "delta",
                    "\u221E": "bezgaliba",
                    "\u2665": "milestiba",
                    "&": "un",
                    "|": "vai",
                    "<": "mazak neka",
                    ">": "lielaks neka",
                    "\u2211": "summa",
                    "\xA4": "valuta"
                },
                "my": {
                    "\u2206": "kwahkhyaet",
                    "\u221E": "asaonasme",
                    "\u2665": "akhyait",
                    "&": "nhin",
                    "|": "tho",
                    "<": "ngethaw",
                    ">": "kyithaw",
                    "\u2211": "paungld",
                    "\xA4": "ngwekye"
                },
                "mk": {},
                "nl": {
                    "\u2206": "delta",
                    "\u221E": "oneindig",
                    "\u2665": "liefde",
                    "&": "en",
                    "|": "of",
                    "<": "kleiner dan",
                    ">": "groter dan",
                    "\u2211": "som",
                    "\xA4": "valuta"
                },
                "pl": {
                    "\u2206": "delta",
                    "\u221E": "nieskonczonosc",
                    "\u2665": "milosc",
                    "&": "i",
                    "|": "lub",
                    "<": "mniejsze niz",
                    ">": "wieksze niz",
                    "\u2211": "suma",
                    "\xA4": "waluta"
                },
                "pt": {
                    "\u2206": "delta",
                    "\u221E": "infinito",
                    "\u2665": "amor",
                    "&": "e",
                    "|": "ou",
                    "<": "menor que",
                    ">": "maior que",
                    "\u2211": "soma",
                    "\xA4": "moeda"
                },
                "ro": {
                    "\u2206": "delta",
                    "\u221E": "infinit",
                    "\u2665": "dragoste",
                    "&": "si",
                    "|": "sau",
                    "<": "mai mic ca",
                    ">": "mai mare ca",
                    "\u2211": "suma",
                    "\xA4": "valuta"
                },
                "ru": {
                    "\u2206": "delta",
                    "\u221E": "beskonechno",
                    "\u2665": "lubov",
                    "&": "i",
                    "|": "ili",
                    "<": "menshe",
                    ">": "bolshe",
                    "\u2211": "summa",
                    "\xA4": "valjuta"
                },
                "sk": {
                    "\u2206": "delta",
                    "\u221E": "nekonecno",
                    "\u2665": "laska",
                    "&": "a",
                    "|": "alebo",
                    "<": "menej ako",
                    ">": "viac ako",
                    "\u2211": "sucet",
                    "\xA4": "mena"
                },
                "sr": {},
                "tr": {
                    "\u2206": "delta",
                    "\u221E": "sonsuzluk",
                    "\u2665": "ask",
                    "&": "ve",
                    "|": "veya",
                    "<": "kucuktur",
                    ">": "buyuktur",
                    "\u2211": "toplam",
                    "\xA4": "para birimi"
                },
                "uk": {
                    "\u2206": "delta",
                    "\u221E": "bezkinechnist",
                    "\u2665": "lubov",
                    "&": "i",
                    "|": "abo",
                    "<": "menshe",
                    ">": "bilshe",
                    "\u2211": "suma",
                    "\xA4": "valjuta"
                },
                "vn": {
                    "\u2206": "delta",
                    "\u221E": "vo cuc",
                    "\u2665": "yeu",
                    "&": "va",
                    "|": "hoac",
                    "<": "nho hon",
                    ">": "lon hon",
                    "\u2211": "tong",
                    "\xA4": "tien te"
                }
            };
            var uricChars = [
                ";",
                "?",
                ":",
                "@",
                "&",
                "=",
                "+",
                "$",
                ",",
                "/"
            ].join("");
            var uricNoSlashChars = [
                ";",
                "?",
                ":",
                "@",
                "&",
                "=",
                "+",
                "$",
                ","
            ].join("");
            var markChars = [
                ".",
                "!",
                "~",
                "*",
                "'",
                "(",
                ")"
            ].join("");
            var getSlug = function getSlug2(input, opts) {
                var separator = "-";
                var result = "";
                var diatricString = "";
                var convertSymbols = true;
                var customReplacements = {};
                var maintainCase;
                var titleCase;
                var truncate;
                var uricFlag;
                var uricNoSlashFlag;
                var markFlag;
                var symbol;
                var langChar;
                var lucky;
                var i;
                var ch;
                var l;
                var lastCharWasSymbol;
                var lastCharWasDiatric;
                var allowedChars = "";
                if (typeof input !== "string") return "";
                if (typeof opts === "string") separator = opts;
                symbol = symbolMap.en;
                langChar = langCharMap.en;
                if (typeof opts === "object") {
                    maintainCase = opts.maintainCase || false;
                    customReplacements = opts.custom && typeof opts.custom === "object" ? opts.custom : customReplacements;
                    truncate = +opts.truncate > 1 && opts.truncate || false;
                    uricFlag = opts.uric || false;
                    uricNoSlashFlag = opts.uricNoSlash || false;
                    markFlag = opts.mark || false;
                    convertSymbols = opts.symbols === false || opts.lang === false ? false : true;
                    separator = opts.separator || separator;
                    if (uricFlag) allowedChars += uricChars;
                    if (uricNoSlashFlag) allowedChars += uricNoSlashChars;
                    if (markFlag) allowedChars += markChars;
                    symbol = opts.lang && symbolMap[opts.lang] && convertSymbols ? symbolMap[opts.lang] : convertSymbols ? symbolMap.en : {};
                    langChar = opts.lang && langCharMap[opts.lang] ? langCharMap[opts.lang] : opts.lang === false || opts.lang === true ? {} : langCharMap.en;
                    if (opts.titleCase && typeof opts.titleCase.length === "number" && Array.prototype.toString.call(opts.titleCase)) {
                        opts.titleCase.forEach(function(v) {
                            customReplacements[v + ""] = v + "";
                        });
                        titleCase = true;
                    } else titleCase = !!opts.titleCase;
                    if (opts.custom && typeof opts.custom.length === "number" && Array.prototype.toString.call(opts.custom)) opts.custom.forEach(function(v) {
                        customReplacements[v + ""] = v + "";
                    });
                    Object.keys(customReplacements).forEach(function(v) {
                        var r;
                        if (v.length > 1) r = new RegExp("\\b" + escapeChars(v) + "\\b", "gi");
                        else r = new RegExp(escapeChars(v), "gi");
                        input = input.replace(r, customReplacements[v]);
                    });
                    for(ch in customReplacements)allowedChars += ch;
                }
                allowedChars += separator;
                allowedChars = escapeChars(allowedChars);
                input = input.replace(/(^\s+|\s+$)/g, "");
                lastCharWasSymbol = false;
                lastCharWasDiatric = false;
                for(i = 0, l = input.length; i < l; i++){
                    ch = input[i];
                    if (isReplacedCustomChar(ch, customReplacements)) lastCharWasSymbol = false;
                    else if (langChar[ch]) {
                        ch = lastCharWasSymbol && langChar[ch].match(/[A-Za-z0-9]/) ? " " + langChar[ch] : langChar[ch];
                        lastCharWasSymbol = false;
                    } else if (ch in charMap) {
                        if (i + 1 < l && lookAheadCharArray.indexOf(input[i + 1]) >= 0) {
                            diatricString += ch;
                            ch = "";
                        } else if (lastCharWasDiatric === true) {
                            ch = diatricMap[diatricString] + charMap[ch];
                            diatricString = "";
                        } else ch = lastCharWasSymbol && charMap[ch].match(/[A-Za-z0-9]/) ? " " + charMap[ch] : charMap[ch];
                        lastCharWasSymbol = false;
                        lastCharWasDiatric = false;
                    } else if (ch in diatricMap) {
                        diatricString += ch;
                        ch = "";
                        if (i === l - 1) ch = diatricMap[diatricString];
                        lastCharWasDiatric = true;
                    } else if (// process symbol chars
                    symbol[ch] && !(uricFlag && uricChars.indexOf(ch) !== -1) && !(uricNoSlashFlag && uricNoSlashChars.indexOf(ch) !== -1)) {
                        ch = lastCharWasSymbol || result.substr(-1).match(/[A-Za-z0-9]/) ? separator + symbol[ch] : symbol[ch];
                        ch += input[i + 1] !== void 0 && input[i + 1].match(/[A-Za-z0-9]/) ? separator : "";
                        lastCharWasSymbol = true;
                    } else {
                        if (lastCharWasDiatric === true) {
                            ch = diatricMap[diatricString] + ch;
                            diatricString = "";
                            lastCharWasDiatric = false;
                        } else if (lastCharWasSymbol && (/[A-Za-z0-9]/.test(ch) || result.substr(-1).match(/A-Za-z0-9]/))) ch = " " + ch;
                        lastCharWasSymbol = false;
                    }
                    result += ch.replace(new RegExp("[^\\w\\s" + allowedChars + "_-]", "g"), separator);
                }
                if (titleCase) result = result.replace(/(\w)(\S*)/g, function(_, i2, r) {
                    var j = i2.toUpperCase() + (r !== null ? r : "");
                    return Object.keys(customReplacements).indexOf(j.toLowerCase()) < 0 ? j : j.toLowerCase();
                });
                result = result.replace(/\s+/g, separator).replace(new RegExp("\\" + separator + "+", "g"), separator).replace(new RegExp("(^\\" + separator + "+|\\" + separator + "+$)", "g"), "");
                if (truncate && result.length > truncate) {
                    lucky = result.charAt(truncate) === separator;
                    result = result.slice(0, truncate);
                    if (!lucky) result = result.slice(0, result.lastIndexOf(separator));
                }
                if (!maintainCase && !titleCase) result = result.toLowerCase();
                return result;
            };
            var createSlug = function createSlug2(opts) {
                return function getSlugWithConfig(input) {
                    return getSlug(input, opts);
                };
            };
            var escapeChars = function escapeChars2(input) {
                return input.replace(/[-\\^$*+?.()|[\]{}\/]/g, "\\$&");
            };
            var isReplacedCustomChar = function(ch, customReplacements) {
                for(var c in customReplacements){
                    if (customReplacements[c] === ch) return true;
                }
            };
            if (typeof module !== "undefined" && module.exports) {
                module.exports = getSlug;
                module.exports.createSlug = createSlug;
            } else if (typeof define !== "undefined" && define.amd) define([], function() {
                return getSlug;
            });
            else try {
                if (root.getSlug || root.createSlug) throw "speakingurl: globals exists /(getSlug|createSlug)/";
                else {
                    root.getSlug = getSlug;
                    root.createSlug = createSlug;
                }
            } catch (e) {}
        })(exports);
    }
});
// ../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js
var $5193fce5c5df8bb9$var$require_speakingurl2 = $5193fce5c5df8bb9$var$__commonJS({
    "../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/index.js" (exports, module) {
        "use strict";
        $5193fce5c5df8bb9$var$init_esm_shims();
        module.exports = $5193fce5c5df8bb9$var$require_speakingurl();
    }
});
// src/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/compat/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$onLegacyDevToolsPluginApiAvailable(cb) {
    if ((0, $i0cUC.target).__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__) {
        cb();
        return;
    }
    Object.defineProperty((0, $i0cUC.target), "__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__", {
        set (value) {
            if (value) cb();
        },
        configurable: true
    });
}
// src/ctx/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/api.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component-highlighter/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/bounding-rect.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/utils/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$getComponentTypeName(options) {
    var _a25;
    const name = options.name || options._componentTag || options.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || options.__name;
    if (name === "index" && ((_a25 = options.__file) == null ? void 0 : _a25.endsWith("index.vue"))) return "";
    return name;
}
function $5193fce5c5df8bb9$var$getComponentFileName(options) {
    const file = options.__file;
    if (file) return (0, $i0cUC.classify)((0, $i0cUC.basename)(file, ".vue"));
}
function $5193fce5c5df8bb9$var$getComponentName(options) {
    const name = options.displayName || options.name || options._componentTag;
    if (name) return name;
    return $5193fce5c5df8bb9$var$getComponentFileName(options);
}
function $5193fce5c5df8bb9$var$saveComponentGussedName(instance, name) {
    instance.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = name;
    return name;
}
function $5193fce5c5df8bb9$var$getAppRecord(instance) {
    if (instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__) return instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    else if (instance.root) return instance.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
}
async function $5193fce5c5df8bb9$var$getComponentId(options) {
    const { app: app, uid: uid, instance: instance } = options;
    try {
        if (instance.__VUE_DEVTOOLS_NEXT_UID__) return instance.__VUE_DEVTOOLS_NEXT_UID__;
        const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app);
        if (!appRecord) return null;
        const isRoot = appRecord.rootInstance === instance;
        return `${appRecord.id}:${isRoot ? "root" : uid}`;
    } catch (e) {}
}
function $5193fce5c5df8bb9$var$isFragment(instance) {
    var _a25, _b25;
    const subTreeType = (_a25 = instance.subTree) == null ? void 0 : _a25.type;
    const appRecord = $5193fce5c5df8bb9$var$getAppRecord(instance);
    if (appRecord) return ((_b25 = appRecord == null ? void 0 : appRecord.types) == null ? void 0 : _b25.Fragment) === subTreeType;
    return false;
}
function $5193fce5c5df8bb9$var$isBeingDestroyed(instance) {
    return instance._isBeingDestroyed || instance.isUnmounted;
}
function $5193fce5c5df8bb9$var$getInstanceName(instance) {
    var _a25, _b25, _c;
    const name = $5193fce5c5df8bb9$var$getComponentTypeName((instance == null ? void 0 : instance.type) || {});
    if (name) return name;
    if ((instance == null ? void 0 : instance.root) === instance) return "Root";
    for(const key in (_b25 = (_a25 = instance.parent) == null ? void 0 : _a25.type) == null ? void 0 : _b25.components){
        if (instance.parent.type.components[key] === (instance == null ? void 0 : instance.type)) return $5193fce5c5df8bb9$var$saveComponentGussedName(instance, key);
    }
    for(const key in (_c = instance.appContext) == null ? void 0 : _c.components){
        if (instance.appContext.components[key] === (instance == null ? void 0 : instance.type)) return $5193fce5c5df8bb9$var$saveComponentGussedName(instance, key);
    }
    const fileName = $5193fce5c5df8bb9$var$getComponentFileName((instance == null ? void 0 : instance.type) || {});
    if (fileName) return fileName;
    return "Anonymous Component";
}
function $5193fce5c5df8bb9$var$getUniqueComponentId(instance) {
    var _a25, _b25, _c;
    const appId = (_c = (_b25 = (_a25 = instance == null ? void 0 : instance.appContext) == null ? void 0 : _a25.app) == null ? void 0 : _b25.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__) != null ? _c : 0;
    const instanceId = instance === (instance == null ? void 0 : instance.root) ? "root" : instance.uid;
    return `${appId}:${instanceId}`;
}
function $5193fce5c5df8bb9$var$getRenderKey(value) {
    if (value == null) return "";
    if (typeof value === "number") return value;
    else if (typeof value === "string") return `'${value}'`;
    else if (Array.isArray(value)) return "Array";
    else return "Object";
}
function $5193fce5c5df8bb9$var$returnError(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
function $5193fce5c5df8bb9$var$getComponentInstance(appRecord, instanceId) {
    instanceId = instanceId || `${appRecord.id}:root`;
    const instance = appRecord.instanceMap.get(instanceId);
    return instance || appRecord.instanceMap.get(":root");
}
function $5193fce5c5df8bb9$var$ensurePropertyExists(obj, key, skipObjCheck = false) {
    return skipObjCheck ? key in obj : typeof obj === "object" && obj !== null ? key in obj : false;
}
// src/core/component/state/bounding-rect.ts
function $5193fce5c5df8bb9$var$createRect() {
    const rect = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        get width () {
            return rect.right - rect.left;
        },
        get height () {
            return rect.bottom - rect.top;
        }
    };
    return rect;
}
var $5193fce5c5df8bb9$var$range;
function $5193fce5c5df8bb9$var$getTextRect(node) {
    if (!$5193fce5c5df8bb9$var$range) $5193fce5c5df8bb9$var$range = document.createRange();
    $5193fce5c5df8bb9$var$range.selectNode(node);
    return $5193fce5c5df8bb9$var$range.getBoundingClientRect();
}
function $5193fce5c5df8bb9$var$getFragmentRect(vnode) {
    const rect = $5193fce5c5df8bb9$var$createRect();
    if (!vnode.children) return rect;
    for(let i = 0, l = vnode.children.length; i < l; i++){
        const childVnode = vnode.children[i];
        let childRect;
        if (childVnode.component) childRect = $5193fce5c5df8bb9$var$getComponentBoundingRect(childVnode.component);
        else if (childVnode.el) {
            const el = childVnode.el;
            if (el.nodeType === 1 || el.getBoundingClientRect) childRect = el.getBoundingClientRect();
            else if (el.nodeType === 3 && el.data.trim()) childRect = $5193fce5c5df8bb9$var$getTextRect(el);
        }
        if (childRect) $5193fce5c5df8bb9$var$mergeRects(rect, childRect);
    }
    return rect;
}
function $5193fce5c5df8bb9$var$mergeRects(a, b) {
    if (!a.top || b.top < a.top) a.top = b.top;
    if (!a.bottom || b.bottom > a.bottom) a.bottom = b.bottom;
    if (!a.left || b.left < a.left) a.left = b.left;
    if (!a.right || b.right > a.right) a.right = b.right;
    return a;
}
var $5193fce5c5df8bb9$var$DEFAULT_RECT = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
};
function $5193fce5c5df8bb9$var$getComponentBoundingRect(instance) {
    const el = instance.subTree.el;
    if (typeof window === "undefined") return $5193fce5c5df8bb9$var$DEFAULT_RECT;
    if ($5193fce5c5df8bb9$var$isFragment(instance)) return $5193fce5c5df8bb9$var$getFragmentRect(instance.subTree);
    else if ((el == null ? void 0 : el.nodeType) === 1) return el == null ? void 0 : el.getBoundingClientRect();
    else if (instance.subTree.component) return $5193fce5c5df8bb9$var$getComponentBoundingRect(instance.subTree.component);
    else return $5193fce5c5df8bb9$var$DEFAULT_RECT;
}
// src/core/component/tree/el.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(instance) {
    if ($5193fce5c5df8bb9$var$isFragment(instance)) return $5193fce5c5df8bb9$var$getFragmentRootElements(instance.subTree);
    if (!instance.subTree) return [];
    return [
        instance.subTree.el
    ];
}
function $5193fce5c5df8bb9$var$getFragmentRootElements(vnode) {
    if (!vnode.children) return [];
    const list = [];
    vnode.children.forEach((childVnode)=>{
        if (childVnode.component) list.push(...$5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(childVnode.component));
        else if (childVnode == null ? void 0 : childVnode.el) list.push(childVnode.el);
    });
    return list;
}
// src/core/component-highlighter/index.ts
var $5193fce5c5df8bb9$var$CONTAINER_ELEMENT_ID = "__vue-devtools-component-inspector__";
var $5193fce5c5df8bb9$var$CARD_ELEMENT_ID = "__vue-devtools-component-inspector__card__";
var $5193fce5c5df8bb9$var$COMPONENT_NAME_ELEMENT_ID = "__vue-devtools-component-inspector__name__";
var $5193fce5c5df8bb9$var$INDICATOR_ELEMENT_ID = "__vue-devtools-component-inspector__indicator__";
var $5193fce5c5df8bb9$var$containerStyles = {
    display: "block",
    zIndex: 2147483640,
    position: "fixed",
    backgroundColor: "#42b88325",
    border: "1px solid #42b88350",
    borderRadius: "5px",
    transition: "all 0.1s ease-in",
    pointerEvents: "none"
};
var $5193fce5c5df8bb9$var$cardStyles = {
    fontFamily: "Arial, Helvetica, sans-serif",
    padding: "5px 8px",
    borderRadius: "4px",
    textAlign: "left",
    position: "absolute",
    left: 0,
    color: "#e9e9e9",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    backgroundColor: "#42b883",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
};
var $5193fce5c5df8bb9$var$indicatorStyles = {
    display: "inline-block",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    opacity: 0.7
};
function $5193fce5c5df8bb9$var$getContainerElement() {
    return document.getElementById($5193fce5c5df8bb9$var$CONTAINER_ELEMENT_ID);
}
function $5193fce5c5df8bb9$var$getCardElement() {
    return document.getElementById($5193fce5c5df8bb9$var$CARD_ELEMENT_ID);
}
function $5193fce5c5df8bb9$var$getIndicatorElement() {
    return document.getElementById($5193fce5c5df8bb9$var$INDICATOR_ELEMENT_ID);
}
function $5193fce5c5df8bb9$var$getNameElement() {
    return document.getElementById($5193fce5c5df8bb9$var$COMPONENT_NAME_ELEMENT_ID);
}
function $5193fce5c5df8bb9$var$getStyles(bounds) {
    return {
        left: `${Math.round(bounds.left * 100) / 100}px`,
        top: `${Math.round(bounds.top * 100) / 100}px`,
        width: `${Math.round(bounds.width * 100) / 100}px`,
        height: `${Math.round(bounds.height * 100) / 100}px`
    };
}
function $5193fce5c5df8bb9$var$create(options) {
    var _a25;
    const containerEl = document.createElement("div");
    containerEl.id = (_a25 = options.elementId) != null ? _a25 : $5193fce5c5df8bb9$var$CONTAINER_ELEMENT_ID;
    Object.assign(containerEl.style, {
        ...$5193fce5c5df8bb9$var$containerStyles,
        ...$5193fce5c5df8bb9$var$getStyles(options.bounds),
        ...options.style
    });
    const cardEl = document.createElement("span");
    cardEl.id = $5193fce5c5df8bb9$var$CARD_ELEMENT_ID;
    Object.assign(cardEl.style, {
        ...$5193fce5c5df8bb9$var$cardStyles,
        top: options.bounds.top < 35 ? 0 : "-35px"
    });
    const nameEl = document.createElement("span");
    nameEl.id = $5193fce5c5df8bb9$var$COMPONENT_NAME_ELEMENT_ID;
    nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
    const indicatorEl = document.createElement("i");
    indicatorEl.id = $5193fce5c5df8bb9$var$INDICATOR_ELEMENT_ID;
    indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    Object.assign(indicatorEl.style, $5193fce5c5df8bb9$var$indicatorStyles);
    cardEl.appendChild(nameEl);
    cardEl.appendChild(indicatorEl);
    containerEl.appendChild(cardEl);
    document.body.appendChild(containerEl);
    return containerEl;
}
function $5193fce5c5df8bb9$var$update(options) {
    const containerEl = $5193fce5c5df8bb9$var$getContainerElement();
    const cardEl = $5193fce5c5df8bb9$var$getCardElement();
    const nameEl = $5193fce5c5df8bb9$var$getNameElement();
    const indicatorEl = $5193fce5c5df8bb9$var$getIndicatorElement();
    if (containerEl) {
        Object.assign(containerEl.style, {
            ...$5193fce5c5df8bb9$var$containerStyles,
            ...$5193fce5c5df8bb9$var$getStyles(options.bounds)
        });
        Object.assign(cardEl.style, {
            top: options.bounds.top < 35 ? 0 : "-35px"
        });
        nameEl.innerHTML = `&lt;${options.name}&gt;&nbsp;&nbsp;`;
        indicatorEl.innerHTML = `${Math.round(options.bounds.width * 100) / 100} x ${Math.round(options.bounds.height * 100) / 100}`;
    }
}
function $5193fce5c5df8bb9$var$highlight(instance) {
    const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
    if (!bounds.width && !bounds.height) return;
    const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
    const container = $5193fce5c5df8bb9$var$getContainerElement();
    container ? $5193fce5c5df8bb9$var$update({
        bounds: bounds,
        name: name
    }) : $5193fce5c5df8bb9$var$create({
        bounds: bounds,
        name: name
    });
}
function $5193fce5c5df8bb9$var$unhighlight() {
    const el = $5193fce5c5df8bb9$var$getContainerElement();
    if (el) el.style.display = "none";
}
var $5193fce5c5df8bb9$var$inspectInstance = null;
function $5193fce5c5df8bb9$var$inspectFn(e) {
    const target22 = e.target;
    if (target22) {
        const instance = target22.__vueParentComponent;
        if (instance) {
            $5193fce5c5df8bb9$var$inspectInstance = instance;
            const el = instance.vnode.el;
            if (el) {
                const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
                const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
                const container = $5193fce5c5df8bb9$var$getContainerElement();
                container ? $5193fce5c5df8bb9$var$update({
                    bounds: bounds,
                    name: name
                }) : $5193fce5c5df8bb9$var$create({
                    bounds: bounds,
                    name: name
                });
            }
        }
    }
}
function $5193fce5c5df8bb9$var$selectComponentFn(e, cb) {
    e.preventDefault();
    e.stopPropagation();
    if ($5193fce5c5df8bb9$var$inspectInstance) {
        const uniqueComponentId = $5193fce5c5df8bb9$var$getUniqueComponentId($5193fce5c5df8bb9$var$inspectInstance);
        cb(uniqueComponentId);
    }
}
var $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn = null;
function $5193fce5c5df8bb9$var$cancelInspectComponentHighLighter() {
    $5193fce5c5df8bb9$var$unhighlight();
    window.removeEventListener("mouseover", $5193fce5c5df8bb9$var$inspectFn);
    window.removeEventListener("click", $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn, true);
    $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn = null;
}
function $5193fce5c5df8bb9$var$inspectComponentHighLighter() {
    window.addEventListener("mouseover", $5193fce5c5df8bb9$var$inspectFn);
    return new Promise((resolve)=>{
        function onSelect(e) {
            e.preventDefault();
            e.stopPropagation();
            $5193fce5c5df8bb9$var$selectComponentFn(e, (id)=>{
                window.removeEventListener("click", onSelect, true);
                $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn = null;
                window.removeEventListener("mouseover", $5193fce5c5df8bb9$var$inspectFn);
                const el = $5193fce5c5df8bb9$var$getContainerElement();
                if (el) el.style.display = "none";
                resolve(JSON.stringify({
                    id: id
                }));
            });
        }
        $5193fce5c5df8bb9$var$inspectComponentHighLighterSelectFn = onSelect;
        window.addEventListener("click", onSelect, true);
    });
}
function $5193fce5c5df8bb9$var$scrollToComponent(options) {
    const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, options.id);
    if (instance) {
        const [el] = $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(instance);
        if (typeof el.scrollIntoView === "function") el.scrollIntoView({
            behavior: "smooth"
        });
        else {
            const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
            const scrollTarget = document.createElement("div");
            const styles = {
                ...$5193fce5c5df8bb9$var$getStyles(bounds),
                position: "absolute"
            };
            Object.assign(scrollTarget.style, styles);
            document.body.appendChild(scrollTarget);
            scrollTarget.scrollIntoView({
                behavior: "smooth"
            });
            setTimeout(()=>{
                document.body.removeChild(scrollTarget);
            }, 2e3);
        }
        setTimeout(()=>{
            const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
            if (bounds.width || bounds.height) {
                const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
                const el2 = $5193fce5c5df8bb9$var$getContainerElement();
                el2 ? $5193fce5c5df8bb9$var$update({
                    ...options,
                    name: name,
                    bounds: bounds
                }) : $5193fce5c5df8bb9$var$create({
                    ...options,
                    name: name,
                    bounds: bounds
                });
                setTimeout(()=>{
                    if (el2) el2.style.display = "none";
                }, 1500);
            }
        }, 1200);
    }
}
// src/core/component-inspector/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$_a, $5193fce5c5df8bb9$var$_b;
($5193fce5c5df8bb9$var$_b = ($5193fce5c5df8bb9$var$_a = (0, $i0cUC.target)).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) != null ? $5193fce5c5df8bb9$var$_b : $5193fce5c5df8bb9$var$_a.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = true;
function $5193fce5c5df8bb9$export$56455f68fb6e3b63(enabled) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = enabled;
}
function $5193fce5c5df8bb9$var$waitForInspectorInit(cb) {
    let total = 0;
    const timer = setInterval(()=>{
        if ((0, $i0cUC.target).__VUE_INSPECTOR__) {
            clearInterval(timer);
            total += 30;
            cb();
        }
        if (total >= /* 5s */ 5e3) clearInterval(timer);
    }, 30);
}
function $5193fce5c5df8bb9$var$setupInspector() {
    const inspector = (0, $i0cUC.target).__VUE_INSPECTOR__;
    const _openInEditor = inspector.openInEditor;
    inspector.openInEditor = async (...params)=>{
        inspector.disable();
        _openInEditor(...params);
    };
}
function $5193fce5c5df8bb9$var$getComponentInspector() {
    return new Promise((resolve)=>{
        function setup() {
            $5193fce5c5df8bb9$var$setupInspector();
            resolve((0, $i0cUC.target).__VUE_INSPECTOR__);
        }
        if (!(0, $i0cUC.target).__VUE_INSPECTOR__) $5193fce5c5df8bb9$var$waitForInspectorInit(()=>{
            setup();
        });
        else setup();
    });
}
// src/core/component/state/editor.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/shared/stub-vue.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$isReadonly(value) {
    return !!(value && value["__v_isReadonly" /* IS_READONLY */ ]);
}
function $5193fce5c5df8bb9$var$isReactive(value) {
    if ($5193fce5c5df8bb9$var$isReadonly(value)) return $5193fce5c5df8bb9$var$isReactive(value["__v_raw" /* RAW */ ]);
    return !!(value && value["__v_isReactive" /* IS_REACTIVE */ ]);
}
function $5193fce5c5df8bb9$var$isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function $5193fce5c5df8bb9$var$toRaw(observed) {
    const raw = observed && observed["__v_raw" /* RAW */ ];
    return raw ? $5193fce5c5df8bb9$var$toRaw(raw) : observed;
}
var $5193fce5c5df8bb9$var$Fragment = Symbol.for("v-fgt");
// src/core/component/state/editor.ts
var $5193fce5c5df8bb9$var$StateEditor = class {
    constructor(){
        this.refEditor = new $5193fce5c5df8bb9$var$RefStateEditor();
    }
    set(object, path, value, cb) {
        const sections = Array.isArray(path) ? path : path.split(".");
        const markRef = false;
        while(sections.length > 1){
            const section = sections.shift();
            if (object instanceof Map) object = object.get(section);
            else if (object instanceof Set) object = Array.from(object.values())[section];
            else object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        const field = sections[0];
        const item = this.refEditor.get(object)[field];
        if (cb) cb(object, field, value);
        else {
            if (this.refEditor.isRef(item)) this.refEditor.set(item, value);
            else if (markRef) object[field] = value;
            else object[field] = value;
        }
    }
    get(object, path) {
        const sections = Array.isArray(path) ? path : path.split(".");
        for(let i = 0; i < sections.length; i++){
            if (object instanceof Map) object = object.get(sections[i]);
            else object = object[sections[i]];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
            if (!object) return void 0;
        }
        return object;
    }
    has(object, path, parent = false) {
        if (typeof object === "undefined") return false;
        const sections = Array.isArray(path) ? path.slice() : path.split(".");
        const size = !parent ? 1 : 2;
        while(object && sections.length > size){
            const section = sections.shift();
            object = object[section];
            if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
        }
        return object != null && Object.prototype.hasOwnProperty.call(object, sections[0]);
    }
    createDefaultSetCallback(state) {
        return (object, field, value)=>{
            if (state.remove || state.newKey) {
                if (Array.isArray(object)) object.splice(field, 1);
                else if ($5193fce5c5df8bb9$var$toRaw(object) instanceof Map) object.delete(field);
                else if ($5193fce5c5df8bb9$var$toRaw(object) instanceof Set) object.delete(Array.from(object.values())[field]);
                else Reflect.deleteProperty(object, field);
            }
            if (!state.remove) {
                const target22 = object[state.newKey || field];
                if (this.refEditor.isRef(target22)) this.refEditor.set(target22, value);
                else if ($5193fce5c5df8bb9$var$toRaw(object) instanceof Map) object.set(state.newKey || field, value);
                else if ($5193fce5c5df8bb9$var$toRaw(object) instanceof Set) object.add(value);
                else object[state.newKey || field] = value;
            }
        };
    }
};
var $5193fce5c5df8bb9$var$RefStateEditor = class {
    set(ref, value) {
        if ($5193fce5c5df8bb9$var$isRef(ref)) ref.value = value;
        else {
            if (ref instanceof Set && Array.isArray(value)) {
                ref.clear();
                value.forEach((v)=>ref.add(v));
                return;
            }
            const currentKeys = Object.keys(value);
            if (ref instanceof Map) {
                const previousKeysSet2 = new Set(ref.keys());
                currentKeys.forEach((key)=>{
                    ref.set(key, Reflect.get(value, key));
                    previousKeysSet2.delete(key);
                });
                previousKeysSet2.forEach((key)=>ref.delete(key));
                return;
            }
            const previousKeysSet = new Set(Object.keys(ref));
            currentKeys.forEach((key)=>{
                Reflect.set(ref, key, Reflect.get(value, key));
                previousKeysSet.delete(key);
            });
            previousKeysSet.forEach((key)=>Reflect.deleteProperty(ref, key));
        }
    }
    get(ref) {
        return $5193fce5c5df8bb9$var$isRef(ref) ? ref.value : ref;
    }
    isRef(ref) {
        return $5193fce5c5df8bb9$var$isRef(ref) || $5193fce5c5df8bb9$var$isReactive(ref);
    }
};
async function $5193fce5c5df8bb9$var$editComponentState(payload, stateEditor2) {
    const { path: path, nodeId: nodeId, state: state, type: type } = payload;
    const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, nodeId);
    if (!instance) return;
    const targetPath = path.slice();
    let target22;
    if (Object.keys(instance.props).includes(path[0])) target22 = instance.props;
    else if (instance.devtoolsRawSetupState && Object.keys(instance.devtoolsRawSetupState).includes(path[0])) target22 = instance.devtoolsRawSetupState;
    else if (instance.data && Object.keys(instance.data).includes(path[0])) target22 = instance.data;
    else target22 = instance.proxy;
    if (target22 && targetPath) {
        state.type === "object" && type;
        stateEditor2.set(target22, targetPath, state.value, stateEditor2.createDefaultSetCallback(state));
    }
}
var $5193fce5c5df8bb9$var$stateEditor = new $5193fce5c5df8bb9$var$StateEditor();
async function $5193fce5c5df8bb9$var$editState(payload) {
    $5193fce5c5df8bb9$var$editComponentState(payload, $5193fce5c5df8bb9$var$stateEditor);
}
// src/core/open-in-editor/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/state.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/timeline/storage.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$TIMELINE_LAYERS_STATE_STORAGE_ID = "__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__";
function $5193fce5c5df8bb9$var$addTimelineLayersStateToStorage(state) {
    if (!(0, $i0cUC.isBrowser) || typeof localStorage === "undefined" || localStorage === null) return;
    localStorage.setItem($5193fce5c5df8bb9$var$TIMELINE_LAYERS_STATE_STORAGE_ID, JSON.stringify(state));
}
function $5193fce5c5df8bb9$var$getTimelineLayersStateFromStorage() {
    if (typeof window === "undefined" || !(0, $i0cUC.isBrowser) || typeof localStorage === "undefined" || localStorage === null) return {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
    const state = typeof localStorage.getItem !== "undefined" ? localStorage.getItem($5193fce5c5df8bb9$var$TIMELINE_LAYERS_STATE_STORAGE_ID) : null;
    return state ? JSON.parse(state) : {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
}
// src/ctx/hook.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/inspector.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/timeline.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$_a2, $5193fce5c5df8bb9$var$_b2;
($5193fce5c5df8bb9$var$_b2 = ($5193fce5c5df8bb9$var$_a2 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) != null ? $5193fce5c5df8bb9$var$_b2 : $5193fce5c5df8bb9$var$_a2.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = [];
var $5193fce5c5df8bb9$var$devtoolsTimelineLayers = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
    get (target22, prop, receiver) {
        return Reflect.get(target22, prop, receiver);
    }
});
function $5193fce5c5df8bb9$var$addTimelineLayer(options, descriptor) {
    $5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState[descriptor.id] = false;
    $5193fce5c5df8bb9$var$devtoolsTimelineLayers.push({
        ...options,
        descriptorId: descriptor.id,
        appRecord: $5193fce5c5df8bb9$var$getAppRecord(descriptor.app)
    });
}
function $5193fce5c5df8bb9$export$736910b7e8839d93(state) {
    const updatedState = {
        ...$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState,
        ...state
    };
    $5193fce5c5df8bb9$var$addTimelineLayersStateToStorage(updatedState);
    $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
        timelineLayersState: updatedState
    });
}
// src/ctx/inspector.ts
var $5193fce5c5df8bb9$var$_a3, $5193fce5c5df8bb9$var$_b3;
($5193fce5c5df8bb9$var$_b3 = ($5193fce5c5df8bb9$var$_a3 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_INSPECTOR__) != null ? $5193fce5c5df8bb9$var$_b3 : $5193fce5c5df8bb9$var$_a3.__VUE_DEVTOOLS_KIT_INSPECTOR__ = [];
var $5193fce5c5df8bb9$export$996e3c8abad0143f = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_INSPECTOR__, {
    get (target22, prop, receiver) {
        return Reflect.get(target22, prop, receiver);
    }
});
var $5193fce5c5df8bb9$export$17f8005932e80cc0 = (0, $dj5lJ.debounce)(()=>{
    $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("sendInspectorToClient" /* SEND_INSPECTOR_TO_CLIENT */ , $5193fce5c5df8bb9$export$2844c7432ba9d166());
});
function $5193fce5c5df8bb9$export$e863e3b6c2ff029b(inspector, descriptor) {
    var _a25, _b25;
    $5193fce5c5df8bb9$export$996e3c8abad0143f.push({
        options: inspector,
        descriptor: descriptor,
        treeFilterPlaceholder: (_a25 = inspector.treeFilterPlaceholder) != null ? _a25 : "Search tree...",
        stateFilterPlaceholder: (_b25 = inspector.stateFilterPlaceholder) != null ? _b25 : "Search state...",
        treeFilter: "",
        selectedNodeId: "",
        appRecord: $5193fce5c5df8bb9$var$getAppRecord(descriptor.app)
    });
    $5193fce5c5df8bb9$export$17f8005932e80cc0();
}
function $5193fce5c5df8bb9$export$2844c7432ba9d166() {
    return $5193fce5c5df8bb9$export$996e3c8abad0143f.filter((inspector)=>inspector.descriptor.app === $5193fce5c5df8bb9$export$162128841a7f2877.value.app).filter((inspector)=>inspector.descriptor.id !== "components").map((inspector)=>{
        var _a25;
        const descriptor = inspector.descriptor;
        const options = inspector.options;
        return {
            id: options.id,
            label: options.label,
            logo: descriptor.logo,
            icon: `custom-ic-baseline-${(_a25 = options == null ? void 0 : options.icon) == null ? void 0 : _a25.replace(/_/g, "-")}`,
            packageName: descriptor.packageName,
            homepage: descriptor.homepage,
            pluginId: descriptor.id
        };
    });
}
function $5193fce5c5df8bb9$export$5042bdc6f02e4304(id) {
    const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(id, $5193fce5c5df8bb9$export$162128841a7f2877.value.app);
    if (!inspector) return;
    const descriptor = inspector.descriptor;
    const options = inspector.options;
    const timelineLayers = $5193fce5c5df8bb9$var$devtoolsTimelineLayers.filter((layer)=>layer.descriptorId === descriptor.id).map((item)=>({
            id: item.id,
            label: item.label,
            color: item.color
        }));
    return {
        id: options.id,
        label: options.label,
        logo: descriptor.logo,
        packageName: descriptor.packageName,
        homepage: descriptor.homepage,
        timelineLayers: timelineLayers,
        treeFilterPlaceholder: inspector.treeFilterPlaceholder,
        stateFilterPlaceholder: inspector.stateFilterPlaceholder
    };
}
function $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(id, app) {
    return $5193fce5c5df8bb9$export$996e3c8abad0143f.find((inspector)=>inspector.options.id === id && (app ? inspector.descriptor.app === app : true));
}
function $5193fce5c5df8bb9$export$54eb86d2eca92815(id) {
    const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(id);
    return inspector == null ? void 0 : inspector.options.actions;
}
function $5193fce5c5df8bb9$export$eebdca42b352a0b2(id) {
    const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(id);
    return inspector == null ? void 0 : inspector.options.nodeActions;
}
// src/ctx/hook.ts
var $5193fce5c5df8bb9$export$3936435a794cb908 = /* @__PURE__ */ ((DevToolsV6PluginAPIHookKeys2)=>{
    DevToolsV6PluginAPIHookKeys2["VISIT_COMPONENT_TREE"] = "visitComponentTree";
    DevToolsV6PluginAPIHookKeys2["INSPECT_COMPONENT"] = "inspectComponent";
    DevToolsV6PluginAPIHookKeys2["EDIT_COMPONENT_STATE"] = "editComponentState";
    DevToolsV6PluginAPIHookKeys2["GET_INSPECTOR_TREE"] = "getInspectorTree";
    DevToolsV6PluginAPIHookKeys2["GET_INSPECTOR_STATE"] = "getInspectorState";
    DevToolsV6PluginAPIHookKeys2["EDIT_INSPECTOR_STATE"] = "editInspectorState";
    DevToolsV6PluginAPIHookKeys2["INSPECT_TIMELINE_EVENT"] = "inspectTimelineEvent";
    DevToolsV6PluginAPIHookKeys2["TIMELINE_CLEARED"] = "timelineCleared";
    DevToolsV6PluginAPIHookKeys2["SET_PLUGIN_SETTINGS"] = "setPluginSettings";
    return DevToolsV6PluginAPIHookKeys2;
})($5193fce5c5df8bb9$export$3936435a794cb908 || {});
var $5193fce5c5df8bb9$export$4c35c03df042a977 = /* @__PURE__ */ ((DevToolsContextHookKeys2)=>{
    DevToolsContextHookKeys2["ADD_INSPECTOR"] = "addInspector";
    DevToolsContextHookKeys2["SEND_INSPECTOR_TREE"] = "sendInspectorTree";
    DevToolsContextHookKeys2["SEND_INSPECTOR_STATE"] = "sendInspectorState";
    DevToolsContextHookKeys2["CUSTOM_INSPECTOR_SELECT_NODE"] = "customInspectorSelectNode";
    DevToolsContextHookKeys2["TIMELINE_LAYER_ADDED"] = "timelineLayerAdded";
    DevToolsContextHookKeys2["TIMELINE_EVENT_ADDED"] = "timelineEventAdded";
    DevToolsContextHookKeys2["GET_COMPONENT_INSTANCES"] = "getComponentInstances";
    DevToolsContextHookKeys2["GET_COMPONENT_BOUNDS"] = "getComponentBounds";
    DevToolsContextHookKeys2["GET_COMPONENT_NAME"] = "getComponentName";
    DevToolsContextHookKeys2["COMPONENT_HIGHLIGHT"] = "componentHighlight";
    DevToolsContextHookKeys2["COMPONENT_UNHIGHLIGHT"] = "componentUnhighlight";
    return DevToolsContextHookKeys2;
})($5193fce5c5df8bb9$export$4c35c03df042a977 || {});
var $5193fce5c5df8bb9$export$12aa7e661bddec80 = /* @__PURE__ */ ((DevToolsMessagingHookKeys2)=>{
    DevToolsMessagingHookKeys2["SEND_INSPECTOR_TREE_TO_CLIENT"] = "sendInspectorTreeToClient";
    DevToolsMessagingHookKeys2["SEND_INSPECTOR_STATE_TO_CLIENT"] = "sendInspectorStateToClient";
    DevToolsMessagingHookKeys2["SEND_TIMELINE_EVENT_TO_CLIENT"] = "sendTimelineEventToClient";
    DevToolsMessagingHookKeys2["SEND_INSPECTOR_TO_CLIENT"] = "sendInspectorToClient";
    DevToolsMessagingHookKeys2["SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT"] = "sendActiveAppUpdatedToClient";
    DevToolsMessagingHookKeys2["DEVTOOLS_STATE_UPDATED"] = "devtoolsStateUpdated";
    DevToolsMessagingHookKeys2["DEVTOOLS_CONNECTED_UPDATED"] = "devtoolsConnectedUpdated";
    DevToolsMessagingHookKeys2["ROUTER_INFO_UPDATED"] = "routerInfoUpdated";
    return DevToolsMessagingHookKeys2;
})($5193fce5c5df8bb9$export$12aa7e661bddec80 || {});
function $5193fce5c5df8bb9$export$73be3ac6032ad9bb() {
    const hooks2 = (0, $ptPDd.createHooks)();
    hooks2.hook("addInspector" /* ADD_INSPECTOR */ , ({ inspector: inspector, plugin: plugin })=>{
        $5193fce5c5df8bb9$export$e863e3b6c2ff029b(inspector, plugin.descriptor);
    });
    const debounceSendInspectorTree = (0, $dj5lJ.debounce)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        var _a25;
        if (!inspectorId || !((_a25 = plugin == null ? void 0 : plugin.descriptor) == null ? void 0 : _a25.app) || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            filter: (inspector == null ? void 0 : inspector.treeFilter) || "",
            rootNodes: []
        };
        await new Promise((resolve)=>{
            hooks2.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload)));
                resolve();
            }, "getInspectorTree" /* GET_INSPECTOR_TREE */ );
        });
        hooks2.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    rootNodes: _payload.rootNodes
                })));
        }, "sendInspectorTreeToClient" /* SEND_INSPECTOR_TREE_TO_CLIENT */ );
    }, 120);
    hooks2.hook("sendInspectorTree" /* SEND_INSPECTOR_TREE */ , debounceSendInspectorTree);
    const debounceSendInspectorState = (0, $dj5lJ.debounce)(async ({ inspectorId: inspectorId, plugin: plugin })=>{
        var _a25;
        if (!inspectorId || !((_a25 = plugin == null ? void 0 : plugin.descriptor) == null ? void 0 : _a25.app) || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        const _payload = {
            app: plugin.descriptor.app,
            inspectorId: inspectorId,
            nodeId: (inspector == null ? void 0 : inspector.selectedNodeId) || "",
            state: null
        };
        const ctx = {
            currentTab: `custom-inspector:${inspectorId}`
        };
        if (_payload.nodeId) await new Promise((resolve)=>{
            hooks2.callHookWith(async (callbacks)=>{
                await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                resolve();
            }, "getInspectorState" /* GET_INSPECTOR_STATE */ );
        });
        hooks2.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb({
                    inspectorId: inspectorId,
                    nodeId: _payload.nodeId,
                    state: _payload.state
                })));
        }, "sendInspectorStateToClient" /* SEND_INSPECTOR_STATE_TO_CLIENT */ );
    }, 120);
    hooks2.hook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , debounceSendInspectorState);
    hooks2.hook("customInspectorSelectNode" /* CUSTOM_INSPECTOR_SELECT_NODE */ , ({ inspectorId: inspectorId, nodeId: nodeId, plugin: plugin })=>{
        const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        if (!inspector) return;
        inspector.selectedNodeId = nodeId;
    });
    hooks2.hook("timelineLayerAdded" /* TIMELINE_LAYER_ADDED */ , ({ options: options, plugin: plugin })=>{
        $5193fce5c5df8bb9$var$addTimelineLayer(options, plugin.descriptor);
    });
    hooks2.hook("timelineEventAdded" /* TIMELINE_EVENT_ADDED */ , ({ options: options, plugin: plugin })=>{
        var _a25;
        const internalLayerIds = [
            "performance",
            "component-event",
            "keyboard",
            "mouse"
        ];
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled || !((_a25 = $5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState) == null ? void 0 : _a25[plugin.descriptor.id]) && !internalLayerIds.includes(options.layerId)) return;
        hooks2.callHookWith(async (callbacks)=>{
            await Promise.all(callbacks.map((cb)=>cb(options)));
        }, "sendTimelineEventToClient" /* SEND_TIMELINE_EVENT_TO_CLIENT */ );
    });
    hooks2.hook("getComponentInstances" /* GET_COMPONENT_INSTANCES */ , async ({ app: app })=>{
        const appRecord = app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
        if (!appRecord) return null;
        const appId = appRecord.id.toString();
        const instances = [
            ...appRecord.instanceMap
        ].filter(([key])=>key.split(":")[0] === appId).map(([, instance])=>instance);
        return instances;
    });
    hooks2.hook("getComponentBounds" /* GET_COMPONENT_BOUNDS */ , async ({ instance: instance })=>{
        const bounds = $5193fce5c5df8bb9$var$getComponentBoundingRect(instance);
        return bounds;
    });
    hooks2.hook("getComponentName" /* GET_COMPONENT_NAME */ , ({ instance: instance })=>{
        const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
        return name;
    });
    hooks2.hook("componentHighlight" /* COMPONENT_HIGHLIGHT */ , ({ uid: uid })=>{
        const instance = $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap.get(uid);
        if (instance) $5193fce5c5df8bb9$var$highlight(instance);
    });
    hooks2.hook("componentUnhighlight" /* COMPONENT_UNHIGHLIGHT */ , ()=>{
        $5193fce5c5df8bb9$var$unhighlight();
    });
    return hooks2;
}
// src/ctx/state.ts
var $5193fce5c5df8bb9$var$_a4, $5193fce5c5df8bb9$var$_b4;
($5193fce5c5df8bb9$var$_b4 = ($5193fce5c5df8bb9$var$_a4 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_APP_RECORDS__) != null ? $5193fce5c5df8bb9$var$_b4 : $5193fce5c5df8bb9$var$_a4.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = [];
var $5193fce5c5df8bb9$var$_a5, $5193fce5c5df8bb9$var$_b5;
($5193fce5c5df8bb9$var$_b5 = ($5193fce5c5df8bb9$var$_a5 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) != null ? $5193fce5c5df8bb9$var$_b5 : $5193fce5c5df8bb9$var$_a5.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {};
var $5193fce5c5df8bb9$var$_a6, $5193fce5c5df8bb9$var$_b6;
($5193fce5c5df8bb9$var$_b6 = ($5193fce5c5df8bb9$var$_a6 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) != null ? $5193fce5c5df8bb9$var$_b6 : $5193fce5c5df8bb9$var$_a6.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = "";
var $5193fce5c5df8bb9$var$_a7, $5193fce5c5df8bb9$var$_b7;
($5193fce5c5df8bb9$var$_b7 = ($5193fce5c5df8bb9$var$_a7 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) != null ? $5193fce5c5df8bb9$var$_b7 : $5193fce5c5df8bb9$var$_a7.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = [];
var $5193fce5c5df8bb9$var$_a8, $5193fce5c5df8bb9$var$_b8;
($5193fce5c5df8bb9$var$_b8 = ($5193fce5c5df8bb9$var$_a8 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) != null ? $5193fce5c5df8bb9$var$_b8 : $5193fce5c5df8bb9$var$_a8.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = [];
var $5193fce5c5df8bb9$var$STATE_KEY = "__VUE_DEVTOOLS_KIT_GLOBAL_STATE__";
function $5193fce5c5df8bb9$var$initStateFactory() {
    return {
        connected: false,
        clientConnected: false,
        vitePluginDetected: true,
        appRecords: [],
        activeAppRecordId: "",
        tabs: [],
        commands: [],
        highPerfModeEnabled: true,
        devtoolsClientDetected: {},
        perfUniqueGroupId: 0,
        timelineLayersState: $5193fce5c5df8bb9$var$getTimelineLayersStateFromStorage()
    };
}
var $5193fce5c5df8bb9$var$_a9, $5193fce5c5df8bb9$var$_b9;
($5193fce5c5df8bb9$var$_b9 = ($5193fce5c5df8bb9$var$_a9 = (0, $i0cUC.target))[$5193fce5c5df8bb9$var$STATE_KEY]) != null ? $5193fce5c5df8bb9$var$_b9 : $5193fce5c5df8bb9$var$_a9[$5193fce5c5df8bb9$var$STATE_KEY] = $5193fce5c5df8bb9$var$initStateFactory();
var $5193fce5c5df8bb9$export$ff4fc651602b9735 = (0, $dj5lJ.debounce)((state)=>{
    $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("devtoolsStateUpdated" /* DEVTOOLS_STATE_UPDATED */ , {
        state: state
    });
});
var $5193fce5c5df8bb9$export$ce292af96ab94f7c = (0, $dj5lJ.debounce)((state, oldState)=>{
    $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("devtoolsConnectedUpdated" /* DEVTOOLS_CONNECTED_UPDATED */ , {
        state: state,
        oldState: oldState
    });
});
var $5193fce5c5df8bb9$export$d3c0473489b1d63b = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__;
        return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__[prop];
    }
});
var $5193fce5c5df8bb9$export$c1761479e1420543 = (app)=>{
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = [
        ...(0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__,
        app
    ];
};
var $5193fce5c5df8bb9$export$4d20c72f1da170ba = (app)=>{
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = $5193fce5c5df8bb9$export$d3c0473489b1d63b.value.filter((record)=>record.app !== app);
};
var $5193fce5c5df8bb9$export$162128841a7f2877 = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
    get (_target, prop, receiver) {
        if (prop === "value") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__;
        else if (prop === "id") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__;
        return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[prop];
    }
});
function $5193fce5c5df8bb9$var$updateAllStates() {
    $5193fce5c5df8bb9$export$ff4fc651602b9735({
        ...(0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY],
        appRecords: $5193fce5c5df8bb9$export$d3c0473489b1d63b.value,
        activeAppRecordId: $5193fce5c5df8bb9$export$162128841a7f2877.id,
        tabs: (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
        commands: (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
    });
}
function $5193fce5c5df8bb9$export$1574774def61bdf9(app) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = app;
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$1a7804ab8d8511d1(id) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = id;
    $5193fce5c5df8bb9$var$updateAllStates();
}
var $5193fce5c5df8bb9$export$a67dd585df937baa = new Proxy((0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY], {
    get (target22, property) {
        if (property === "appRecords") return $5193fce5c5df8bb9$export$d3c0473489b1d63b;
        else if (property === "activeAppRecordId") return $5193fce5c5df8bb9$export$162128841a7f2877.id;
        else if (property === "tabs") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
        else if (property === "commands") return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
        return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY][property];
    },
    deleteProperty (target22, property) {
        delete target22[property];
        return true;
    },
    set (target22, property, value) {
        const oldState = {
            ...(0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY]
        };
        target22[property] = value;
        (0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY][property] = value;
        return true;
    }
});
function $5193fce5c5df8bb9$export$ed70a0f71250535e() {
    Object.assign((0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY], $5193fce5c5df8bb9$var$initStateFactory());
}
function $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2(state) {
    const oldState = {
        ...(0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY],
        appRecords: $5193fce5c5df8bb9$export$d3c0473489b1d63b.value,
        activeAppRecordId: $5193fce5c5df8bb9$export$162128841a7f2877.id
    };
    if (oldState.connected !== state.connected && state.connected || oldState.clientConnected !== state.clientConnected && state.clientConnected) $5193fce5c5df8bb9$export$ce292af96ab94f7c((0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY], oldState);
    Object.assign((0, $i0cUC.target)[$5193fce5c5df8bb9$var$STATE_KEY], state);
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$814e9e34f2c01770(fn) {
    return new Promise((resolve)=>{
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.connected) {
            fn();
            resolve();
        }
        $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.hook("devtoolsConnectedUpdated" /* DEVTOOLS_CONNECTED_UPDATED */ , ({ state: state })=>{
            if (state.connected) {
                fn();
                resolve();
            }
        });
    });
}
var $5193fce5c5df8bb9$var$resolveIcon = (icon)=>{
    if (!icon) return;
    if (icon.startsWith("baseline-")) return `custom-ic-${icon}`;
    if (icon.startsWith("i-") || (0, $i0cUC.isUrlString)(icon)) return icon;
    return `custom-ic-baseline-${icon}`;
};
function $5193fce5c5df8bb9$export$9ce008646970742b(tab) {
    const tabs = (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
    if (tabs.some((t)=>t.name === tab.name)) return;
    tabs.push({
        ...tab,
        icon: $5193fce5c5df8bb9$var$resolveIcon(tab.icon)
    });
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$faa8225e4ad5293(action) {
    const commands = (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    if (commands.some((t)=>t.id === action.id)) return;
    commands.push({
        ...action,
        icon: $5193fce5c5df8bb9$var$resolveIcon(action.icon),
        children: action.children ? action.children.map((child)=>({
                ...child,
                icon: $5193fce5c5df8bb9$var$resolveIcon(child.icon)
            })) : void 0
    });
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$8791c0d68ff21044(actionId) {
    const commands = (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    const index = commands.findIndex((t)=>t.id === actionId);
    if (index === -1) return;
    commands.splice(index, 1);
    $5193fce5c5df8bb9$var$updateAllStates();
}
function $5193fce5c5df8bb9$export$b2de3679515b1d6b(state) {
    $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
        clientConnected: state
    });
}
// src/core/open-in-editor/index.ts
function $5193fce5c5df8bb9$export$d4398ad178564033(url) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ = url;
}
function $5193fce5c5df8bb9$var$openInEditor(options = {}) {
    var _a25, _b25, _c;
    const { file: file, host: host, baseUrl: baseUrl = window.location.origin, line: line = 0, column: column = 0 } = options;
    if (file) {
        if (host === "chrome-extension") {
            const fileName = file.replace(/\\/g, "\\\\");
            const _baseUrl = (_b25 = (_a25 = window.VUE_DEVTOOLS_CONFIG) == null ? void 0 : _a25.openInEditorHost) != null ? _b25 : "/";
            fetch(`${_baseUrl}__open-in-editor?file=${encodeURI(file)}`).then((response)=>{
                if (!response.ok) {
                    const msg = `Opening component ${fileName} failed`;
                    console.log(`%c${msg}`, "color:red");
                }
            });
        } else if ($5193fce5c5df8bb9$export$a67dd585df937baa.vitePluginDetected) {
            const _baseUrl = (_c = (0, $i0cUC.target).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) != null ? _c : baseUrl;
            (0, $i0cUC.target).__VUE_INSPECTOR__.openInEditor(_baseUrl, file, line, column);
        }
    }
}
// src/core/plugin/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/api/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/api/v6/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/plugin/plugin-settings.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/plugin.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$_a10, $5193fce5c5df8bb9$var$_b10;
($5193fce5c5df8bb9$var$_b10 = ($5193fce5c5df8bb9$var$_a10 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) != null ? $5193fce5c5df8bb9$var$_b10 : $5193fce5c5df8bb9$var$_a10.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = [];
var $5193fce5c5df8bb9$export$df02dcb86618c10f = new Proxy((0, $i0cUC.target).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
    get (target22, prop, receiver) {
        return Reflect.get(target22, prop, receiver);
    }
});
function $5193fce5c5df8bb9$export$5158df7771943590(pluginDescriptor, setupFn) {
    $5193fce5c5df8bb9$export$df02dcb86618c10f.push([
        pluginDescriptor,
        setupFn
    ]);
}
// src/core/plugin/plugin-settings.ts
function $5193fce5c5df8bb9$var$_getSettings(settings) {
    const _settings = {};
    Object.keys(settings).forEach((key)=>{
        _settings[key] = settings[key].defaultValue;
    });
    return _settings;
}
function $5193fce5c5df8bb9$var$getPluginLocalKey(pluginId) {
    return `__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__${pluginId}__`;
}
function $5193fce5c5df8bb9$var$getPluginSettingsOptions(pluginId) {
    var _a25, _b25, _c;
    const item = (_b25 = (_a25 = $5193fce5c5df8bb9$export$df02dcb86618c10f.find((item2)=>{
        var _a26;
        return item2[0].id === pluginId && !!((_a26 = item2[0]) == null ? void 0 : _a26.settings);
    })) == null ? void 0 : _a25[0]) != null ? _b25 : null;
    return (_c = item == null ? void 0 : item.settings) != null ? _c : null;
}
function $5193fce5c5df8bb9$var$getPluginSettings(pluginId, fallbackValue) {
    var _a25, _b25, _c;
    const localKey = $5193fce5c5df8bb9$var$getPluginLocalKey(pluginId);
    if (localKey) {
        const localSettings = localStorage.getItem(localKey);
        if (localSettings) return JSON.parse(localSettings);
    }
    if (pluginId) {
        const item = (_b25 = (_a25 = $5193fce5c5df8bb9$export$df02dcb86618c10f.find((item2)=>item2[0].id === pluginId)) == null ? void 0 : _a25[0]) != null ? _b25 : null;
        return $5193fce5c5df8bb9$var$_getSettings((_c = item == null ? void 0 : item.settings) != null ? _c : {});
    }
    return $5193fce5c5df8bb9$var$_getSettings(fallbackValue);
}
function $5193fce5c5df8bb9$var$initPluginSettings(pluginId, settings) {
    const localKey = $5193fce5c5df8bb9$var$getPluginLocalKey(pluginId);
    const localSettings = localStorage.getItem(localKey);
    if (!localSettings) localStorage.setItem(localKey, JSON.stringify($5193fce5c5df8bb9$var$_getSettings(settings)));
}
function $5193fce5c5df8bb9$var$setPluginSettings(pluginId, key, value) {
    const localKey = $5193fce5c5df8bb9$var$getPluginLocalKey(pluginId);
    const localSettings = localStorage.getItem(localKey);
    const parsedLocalSettings = JSON.parse(localSettings || "{}");
    const updated = {
        ...parsedLocalSettings,
        [key]: value
    };
    localStorage.setItem(localKey, JSON.stringify(updated));
    $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
        callbacks.forEach((cb)=>cb({
                pluginId: pluginId,
                key: key,
                oldValue: parsedLocalSettings[key],
                newValue: value,
                settings: updated
            }));
    }, "setPluginSettings" /* SET_PLUGIN_SETTINGS */ );
}
// src/hook/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/app.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/command.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/component.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/hook.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/inspector.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/plugin.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/router.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/tab.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/types/timeline.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/hook/index.ts
var $5193fce5c5df8bb9$var$_a11, $5193fce5c5df8bb9$var$_b11;
var $5193fce5c5df8bb9$var$devtoolsHooks = ($5193fce5c5df8bb9$var$_b11 = ($5193fce5c5df8bb9$var$_a11 = (0, $i0cUC.target)).__VUE_DEVTOOLS_HOOK) != null ? $5193fce5c5df8bb9$var$_b11 : $5193fce5c5df8bb9$var$_a11.__VUE_DEVTOOLS_HOOK = (0, $ptPDd.createHooks)();
var $5193fce5c5df8bb9$var$on = {
    vueAppInit (fn) {
        $5193fce5c5df8bb9$var$devtoolsHooks.hook("app:init" /* APP_INIT */ , fn);
    },
    vueAppUnmount (fn) {
        $5193fce5c5df8bb9$var$devtoolsHooks.hook("app:unmount" /* APP_UNMOUNT */ , fn);
    },
    vueAppConnected (fn) {
        $5193fce5c5df8bb9$var$devtoolsHooks.hook("app:connected" /* APP_CONNECTED */ , fn);
    },
    componentAdded (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("component:added" /* COMPONENT_ADDED */ , fn);
    },
    componentEmit (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("component:emit" /* COMPONENT_EMIT */ , fn);
    },
    componentUpdated (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("component:updated" /* COMPONENT_UPDATED */ , fn);
    },
    componentRemoved (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("component:removed" /* COMPONENT_REMOVED */ , fn);
    },
    setupDevtoolsPlugin (fn) {
        $5193fce5c5df8bb9$var$devtoolsHooks.hook("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , fn);
    },
    perfStart (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("perf:start" /* PERFORMANCE_START */ , fn);
    },
    perfEnd (fn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.hook("perf:end" /* PERFORMANCE_END */ , fn);
    }
};
function $5193fce5c5df8bb9$var$createDevToolsHook() {
    return {
        id: "vue-devtools-next",
        devtoolsVersion: "7.0",
        enabled: false,
        appRecords: [],
        apps: [],
        events: /* @__PURE__ */ new Map(),
        on (event, fn) {
            var _a25;
            if (!this.events.has(event)) this.events.set(event, []);
            (_a25 = this.events.get(event)) == null || _a25.push(fn);
            return ()=>this.off(event, fn);
        },
        once (event, fn) {
            const onceFn = (...args)=>{
                this.off(event, onceFn);
                fn(...args);
            };
            this.on(event, onceFn);
            return [
                event,
                onceFn
            ];
        },
        off (event, fn) {
            if (this.events.has(event)) {
                const eventCallbacks = this.events.get(event);
                const index = eventCallbacks.indexOf(fn);
                if (index !== -1) eventCallbacks.splice(index, 1);
            }
        },
        emit (event, ...payload) {
            if (this.events.has(event)) this.events.get(event).forEach((fn)=>fn(...payload));
        }
    };
}
function $5193fce5c5df8bb9$var$subscribeDevToolsHook(hook2) {
    hook2.on("app:init" /* APP_INIT */ , (app, version, types)=>{
        var _a25, _b25, _c;
        if ((_c = (_b25 = (_a25 = app == null ? void 0 : app._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("app:init" /* APP_INIT */ , app, version, types);
    });
    hook2.on("app:unmount" /* APP_UNMOUNT */ , (app)=>{
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("app:unmount" /* APP_UNMOUNT */ , app);
    });
    hook2.on("component:added" /* COMPONENT_ADDED */ , async (app, uid, parentUid, component)=>{
        var _a25, _b25, _c;
        if (((_c = (_b25 = (_a25 = app == null ? void 0 : app._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        if (!app || typeof uid !== "number" && !uid || !component) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:added" /* COMPONENT_ADDED */ , app, uid, parentUid, component);
    });
    hook2.on("component:updated" /* COMPONENT_UPDATED */ , (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:updated" /* COMPONENT_UPDATED */ , app, uid, parentUid, component);
    });
    hook2.on("component:removed" /* COMPONENT_REMOVED */ , async (app, uid, parentUid, component)=>{
        if (!app || typeof uid !== "number" && !uid || !component || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:removed" /* COMPONENT_REMOVED */ , app, uid, parentUid, component);
    });
    hook2.on("component:emit" /* COMPONENT_EMIT */ , async (app, instance, event, params)=>{
        if (!app || !instance || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:emit" /* COMPONENT_EMIT */ , app, instance, event, params);
    });
    hook2.on("perf:start" /* PERFORMANCE_START */ , (app, uid, vm, type, time)=>{
        if (!app || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("perf:start" /* PERFORMANCE_START */ , app, uid, vm, type, time);
    });
    hook2.on("perf:end" /* PERFORMANCE_END */ , (app, uid, vm, type, time)=>{
        if (!app || $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("perf:end" /* PERFORMANCE_END */ , app, uid, vm, type, time);
    });
    hook2.on("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , (pluginDescriptor, setupFn, options)=>{
        if ((options == null ? void 0 : options.target) === "legacy") return;
        $5193fce5c5df8bb9$var$devtoolsHooks.callHook("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , pluginDescriptor, setupFn);
    });
}
var $5193fce5c5df8bb9$var$hook = {
    on: $5193fce5c5df8bb9$var$on,
    setupDevToolsPlugin (pluginDescriptor, setupFn) {
        return $5193fce5c5df8bb9$var$devtoolsHooks.callHook("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , pluginDescriptor, setupFn);
    }
};
// src/api/v6/index.ts
var $5193fce5c5df8bb9$var$DevToolsV6PluginAPI = class {
    constructor({ plugin: plugin, ctx: ctx }){
        this.hooks = ctx.hooks;
        this.plugin = plugin;
    }
    get on() {
        return {
            // component inspector
            visitComponentTree: (handler)=>{
                this.hooks.hook("visitComponentTree" /* VISIT_COMPONENT_TREE */ , handler);
            },
            inspectComponent: (handler)=>{
                this.hooks.hook("inspectComponent" /* INSPECT_COMPONENT */ , handler);
            },
            editComponentState: (handler)=>{
                this.hooks.hook("editComponentState" /* EDIT_COMPONENT_STATE */ , handler);
            },
            // custom inspector
            getInspectorTree: (handler)=>{
                this.hooks.hook("getInspectorTree" /* GET_INSPECTOR_TREE */ , handler);
            },
            getInspectorState: (handler)=>{
                this.hooks.hook("getInspectorState" /* GET_INSPECTOR_STATE */ , handler);
            },
            editInspectorState: (handler)=>{
                this.hooks.hook("editInspectorState" /* EDIT_INSPECTOR_STATE */ , handler);
            },
            // timeline
            inspectTimelineEvent: (handler)=>{
                this.hooks.hook("inspectTimelineEvent" /* INSPECT_TIMELINE_EVENT */ , handler);
            },
            timelineCleared: (handler)=>{
                this.hooks.hook("timelineCleared" /* TIMELINE_CLEARED */ , handler);
            },
            // settings
            setPluginSettings: (handler)=>{
                this.hooks.hook("setPluginSettings" /* SET_PLUGIN_SETTINGS */ , handler);
            }
        };
    }
    // component inspector
    notifyComponentUpdate(instance) {
        var _a25;
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        const inspector = $5193fce5c5df8bb9$export$2844c7432ba9d166().find((i)=>i.packageName === this.plugin.descriptor.packageName);
        if (inspector == null ? void 0 : inspector.id) {
            if (instance) {
                const args = [
                    instance.appContext.app,
                    instance.uid,
                    (_a25 = instance.parent) == null ? void 0 : _a25.uid,
                    instance
                ];
                $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:updated" /* COMPONENT_UPDATED */ , ...args);
            } else $5193fce5c5df8bb9$var$devtoolsHooks.callHook("component:updated" /* COMPONENT_UPDATED */ );
            this.hooks.callHook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , {
                inspectorId: inspector.id,
                plugin: this.plugin
            });
        }
    }
    // custom inspector
    addInspector(options) {
        this.hooks.callHook("addInspector" /* ADD_INSPECTOR */ , {
            inspector: options,
            plugin: this.plugin
        });
        if (this.plugin.descriptor.settings) $5193fce5c5df8bb9$var$initPluginSettings(options.id, this.plugin.descriptor.settings);
    }
    sendInspectorTree(inspectorId) {
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook("sendInspectorTree" /* SEND_INSPECTOR_TREE */ , {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    sendInspectorState(inspectorId) {
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , {
            inspectorId: inspectorId,
            plugin: this.plugin
        });
    }
    selectInspectorNode(inspectorId, nodeId) {
        this.hooks.callHook("customInspectorSelectNode" /* CUSTOM_INSPECTOR_SELECT_NODE */ , {
            inspectorId: inspectorId,
            nodeId: nodeId,
            plugin: this.plugin
        });
    }
    visitComponentTree(payload) {
        return this.hooks.callHook("visitComponentTree" /* VISIT_COMPONENT_TREE */ , payload);
    }
    // timeline
    now() {
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return 0;
        return Date.now();
    }
    addTimelineLayer(options) {
        this.hooks.callHook("timelineLayerAdded" /* TIMELINE_LAYER_ADDED */ , {
            options: options,
            plugin: this.plugin
        });
    }
    addTimelineEvent(options) {
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        this.hooks.callHook("timelineEventAdded" /* TIMELINE_EVENT_ADDED */ , {
            options: options,
            plugin: this.plugin
        });
    }
    // settings
    getSettings(pluginId) {
        return $5193fce5c5df8bb9$var$getPluginSettings(pluginId != null ? pluginId : this.plugin.descriptor.id, this.plugin.descriptor.settings);
    }
    // utilities
    getComponentInstances(app) {
        return this.hooks.callHook("getComponentInstances" /* GET_COMPONENT_INSTANCES */ , {
            app: app
        });
    }
    getComponentBounds(instance) {
        return this.hooks.callHook("getComponentBounds" /* GET_COMPONENT_BOUNDS */ , {
            instance: instance
        });
    }
    getComponentName(instance) {
        return this.hooks.callHook("getComponentName" /* GET_COMPONENT_NAME */ , {
            instance: instance
        });
    }
    highlightElement(instance) {
        const uid = instance.__VUE_DEVTOOLS_NEXT_UID__;
        return this.hooks.callHook("componentHighlight" /* COMPONENT_HIGHLIGHT */ , {
            uid: uid
        });
    }
    unhighlightElement() {
        return this.hooks.callHook("componentUnhighlight" /* COMPONENT_UNHIGHLIGHT */ );
    }
};
// src/api/index.ts
var $5193fce5c5df8bb9$var$DevToolsPluginAPI = $5193fce5c5df8bb9$var$DevToolsV6PluginAPI;
// src/core/plugin/components.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/process.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/constants.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$vueBuiltins = /* @__PURE__ */ new Set([
    "nextTick",
    "defineComponent",
    "defineAsyncComponent",
    "defineCustomElement",
    "ref",
    "computed",
    "reactive",
    "readonly",
    "watchEffect",
    "watchPostEffect",
    "watchSyncEffect",
    "watch",
    "isRef",
    "unref",
    "toRef",
    "toRefs",
    "isProxy",
    "isReactive",
    "isReadonly",
    "shallowRef",
    "triggerRef",
    "customRef",
    "shallowReactive",
    "shallowReadonly",
    "toRaw",
    "markRaw",
    "effectScope",
    "getCurrentScope",
    "onScopeDispose",
    "onMounted",
    "onUpdated",
    "onUnmounted",
    "onBeforeMount",
    "onBeforeUpdate",
    "onBeforeUnmount",
    "onErrorCaptured",
    "onRenderTracked",
    "onRenderTriggered",
    "onActivated",
    "onDeactivated",
    "onServerPrefetch",
    "provide",
    "inject",
    "h",
    "mergeProps",
    "cloneVNode",
    "isVNode",
    "resolveComponent",
    "resolveDirective",
    "withDirectives",
    "withModifiers"
]);
var $5193fce5c5df8bb9$var$symbolRE = /^\[native Symbol Symbol\((.*)\)\]$/;
var $5193fce5c5df8bb9$var$rawTypeRE = /^\[object (\w+)\]$/;
var $5193fce5c5df8bb9$var$specialTypeRE = /^\[native (\w+) (.*?)(<>(([\s\S])*))?\]$/;
var $5193fce5c5df8bb9$var$fnTypeRE = /^(?:function|class) (\w+)/;
var $5193fce5c5df8bb9$var$MAX_STRING_SIZE = 1e4;
var $5193fce5c5df8bb9$var$MAX_ARRAY_SIZE = 5e3;
var $5193fce5c5df8bb9$export$6db089fe7b26f5b6 = "__vue_devtool_undefined__";
var $5193fce5c5df8bb9$export$b4bf424ed968e242 = "__vue_devtool_infinity__";
var $5193fce5c5df8bb9$export$95cb88e357cbada8 = "__vue_devtool_negative_infinity__";
var $5193fce5c5df8bb9$export$d7ae0f70ebb9e144 = "__vue_devtool_nan__";
var $5193fce5c5df8bb9$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
// src/core/component/state/util.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/is.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$isVueInstance(value) {
    if (!$5193fce5c5df8bb9$var$ensurePropertyExists(value, "_")) return false;
    if (!$5193fce5c5df8bb9$export$53b83ca8eaab0383(value._)) return false;
    return Object.keys(value._).includes("vnode");
}
function $5193fce5c5df8bb9$export$53b83ca8eaab0383(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
function $5193fce5c5df8bb9$var$isPrimitive(data) {
    if (data == null) return true;
    const type = typeof data;
    return type === "string" || type === "number" || type === "boolean";
}
function $5193fce5c5df8bb9$var$isRef2(raw) {
    return !!raw.__v_isRef;
}
function $5193fce5c5df8bb9$var$isComputed(raw) {
    return $5193fce5c5df8bb9$var$isRef2(raw) && !!raw.effect;
}
function $5193fce5c5df8bb9$var$isReactive2(raw) {
    return !!raw.__v_isReactive;
}
function $5193fce5c5df8bb9$var$isReadOnly(raw) {
    return !!raw.__v_isReadonly;
}
// src/core/component/state/util.ts
var $5193fce5c5df8bb9$var$tokenMap = {
    [$5193fce5c5df8bb9$export$6db089fe7b26f5b6]: "undefined",
    [$5193fce5c5df8bb9$export$d7ae0f70ebb9e144]: "NaN",
    [$5193fce5c5df8bb9$export$b4bf424ed968e242]: "Infinity",
    [$5193fce5c5df8bb9$export$95cb88e357cbada8]: "-Infinity"
};
var $5193fce5c5df8bb9$var$reversedTokenMap = Object.entries($5193fce5c5df8bb9$var$tokenMap).reduce((acc, [key, value])=>{
    acc[value] = key;
    return acc;
}, {});
function $5193fce5c5df8bb9$var$internalStateTokenToString(value) {
    if (value === null) return "null";
    return typeof value === "string" && $5193fce5c5df8bb9$var$tokenMap[value] || false;
}
function $5193fce5c5df8bb9$var$replaceTokenToString(value) {
    const replaceRegex = new RegExp(`"(${Object.keys($5193fce5c5df8bb9$var$tokenMap).join("|")})"`, "g");
    return value.replace(replaceRegex, (_, g1)=>$5193fce5c5df8bb9$var$tokenMap[g1]);
}
function $5193fce5c5df8bb9$var$replaceStringToToken(value) {
    const literalValue = $5193fce5c5df8bb9$var$reversedTokenMap[value.trim()];
    if (literalValue) return `"${literalValue}"`;
    const replaceRegex = new RegExp(`:\\s*(${Object.keys($5193fce5c5df8bb9$var$reversedTokenMap).join("|")})`, "g");
    return value.replace(replaceRegex, (_, g1)=>`:"${$5193fce5c5df8bb9$var$reversedTokenMap[g1]}"`);
}
function $5193fce5c5df8bb9$var$getPropType(type) {
    if (Array.isArray(type)) return type.map((t)=>$5193fce5c5df8bb9$var$getPropType(t)).join(" or ");
    if (type == null) return "null";
    const match = type.toString().match($5193fce5c5df8bb9$var$fnTypeRE);
    return typeof type === "function" ? match && match[1] || "any" : "any";
}
function $5193fce5c5df8bb9$var$sanitize(data) {
    if (!$5193fce5c5df8bb9$var$isPrimitive(data) && !Array.isArray(data) && !$5193fce5c5df8bb9$export$53b83ca8eaab0383(data)) return Object.prototype.toString.call(data);
    else return data;
}
function $5193fce5c5df8bb9$var$getSetupStateType(raw) {
    try {
        return {
            ref: $5193fce5c5df8bb9$var$isRef2(raw),
            computed: $5193fce5c5df8bb9$var$isComputed(raw),
            reactive: $5193fce5c5df8bb9$var$isReactive2(raw),
            readonly: $5193fce5c5df8bb9$var$isReadOnly(raw)
        };
    } catch (e) {
        return {
            ref: false,
            computed: false,
            reactive: false,
            readonly: false
        };
    }
}
function $5193fce5c5df8bb9$var$toRaw2(value) {
    if (value == null ? void 0 : value.__v_raw) return value.__v_raw;
    return value;
}
function $5193fce5c5df8bb9$export$4e7f196112fea3c5(s) {
    return s.replace(/[<>"&]/g, (s2)=>{
        return $5193fce5c5df8bb9$var$ESC[s2] || s2;
    });
}
// src/core/component/state/process.ts
function $5193fce5c5df8bb9$var$mergeOptions(to, from, instance) {
    if (typeof from === "function") from = from.options;
    if (!from) return to;
    const { mixins: mixins, extends: extendsOptions } = from;
    extendsOptions && $5193fce5c5df8bb9$var$mergeOptions(to, extendsOptions, instance);
    mixins && mixins.forEach((m)=>$5193fce5c5df8bb9$var$mergeOptions(to, m, instance));
    for (const key of [
        "computed",
        "inject"
    ])if (Object.prototype.hasOwnProperty.call(from, key)) {
        if (!to[key]) to[key] = from[key];
        else Object.assign(to[key], from[key]);
    }
    return to;
}
function $5193fce5c5df8bb9$var$resolveMergedOptions(instance) {
    const raw = instance == null ? void 0 : instance.type;
    if (!raw) return {};
    const { mixins: mixins, extends: extendsOptions } = raw;
    const globalMixins = instance.appContext.mixins;
    if (!globalMixins.length && !mixins && !extendsOptions) return raw;
    const options = {};
    globalMixins.forEach((m)=>$5193fce5c5df8bb9$var$mergeOptions(options, m, instance));
    $5193fce5c5df8bb9$var$mergeOptions(options, raw, instance);
    return options;
}
function $5193fce5c5df8bb9$var$processProps(instance) {
    var _a25;
    const props = [];
    const propDefinitions = (_a25 = instance == null ? void 0 : instance.type) == null ? void 0 : _a25.props;
    for(const key in instance == null ? void 0 : instance.props){
        const propDefinition = propDefinitions ? propDefinitions[key] : null;
        const camelizeKey = (0, $i0cUC.camelize)(key);
        props.push({
            type: "props",
            key: camelizeKey,
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.props[key]),
            editable: true,
            meta: propDefinition ? {
                type: propDefinition.type ? $5193fce5c5df8bb9$var$getPropType(propDefinition.type) : "any",
                required: !!propDefinition.required,
                ...propDefinition.default ? {
                    default: propDefinition.default.toString()
                } : {}
            } : {
                type: "invalid"
            }
        });
    }
    return props;
}
function $5193fce5c5df8bb9$var$processState(instance) {
    const type = instance.type;
    const props = type == null ? void 0 : type.props;
    const getters = type.vuex && type.vuex.getters;
    const computedDefs = type.computed;
    const data = {
        ...instance.data,
        ...instance.renderContext
    };
    return Object.keys(data).filter((key)=>!(props && key in props) && !(getters && key in getters) && !(computedDefs && key in computedDefs)).map((key)=>({
            key: key,
            type: "data",
            value: $5193fce5c5df8bb9$var$returnError(()=>data[key]),
            editable: true
        }));
}
function $5193fce5c5df8bb9$var$getStateTypeAndName(info) {
    const stateType = info.computed ? "computed" : info.ref ? "ref" : info.reactive ? "reactive" : null;
    const stateTypeName = stateType ? `${stateType.charAt(0).toUpperCase()}${stateType.slice(1)}` : null;
    return {
        stateType: stateType,
        stateTypeName: stateTypeName
    };
}
function $5193fce5c5df8bb9$var$processSetupState(instance) {
    const raw = instance.devtoolsRawSetupState || {};
    return Object.keys(instance.setupState).filter((key)=>!$5193fce5c5df8bb9$var$vueBuiltins.has(key) && key.split(/(?=[A-Z])/)[0] !== "use").map((key)=>{
        var _a25, _b25, _c, _d;
        const value = $5193fce5c5df8bb9$var$returnError(()=>$5193fce5c5df8bb9$var$toRaw2(instance.setupState[key]));
        const accessError = value instanceof Error;
        const rawData = raw[key];
        let result;
        let isOtherType = accessError || typeof value === "function" || $5193fce5c5df8bb9$var$ensurePropertyExists(value, "render") && typeof value.render === "function" || $5193fce5c5df8bb9$var$ensurePropertyExists(value, "__asyncLoader") && typeof value.__asyncLoader === "function" || typeof value === "object" && value && ("setup" in value || "props" in value) || /^v[A-Z]/.test(key);
        if (rawData && !accessError) {
            const info = $5193fce5c5df8bb9$var$getSetupStateType(rawData);
            const { stateType: stateType, stateTypeName: stateTypeName } = $5193fce5c5df8bb9$var$getStateTypeAndName(info);
            const isState = info.ref || info.computed || info.reactive;
            const raw2 = $5193fce5c5df8bb9$var$ensurePropertyExists(rawData, "effect") ? ((_b25 = (_a25 = rawData.effect) == null ? void 0 : _a25.raw) == null ? void 0 : _b25.toString()) || ((_d = (_c = rawData.effect) == null ? void 0 : _c.fn) == null ? void 0 : _d.toString()) : null;
            if (stateType) isOtherType = false;
            result = {
                ...stateType ? {
                    stateType: stateType,
                    stateTypeName: stateTypeName
                } : {},
                ...raw2 ? {
                    raw: raw2
                } : {},
                editable: isState && !info.readonly
            };
        }
        const type = isOtherType ? "setup (other)" : "setup";
        return {
            key: key,
            value: value,
            type: type,
            // @ts-expect-error ignore
            ...result
        };
    });
}
function $5193fce5c5df8bb9$var$processComputed(instance, mergedType) {
    const type = mergedType;
    const computed = [];
    const defs = type.computed || {};
    for(const key in defs){
        const def = defs[key];
        const type2 = typeof def === "function" && def.vuex ? "vuex bindings" : "computed";
        computed.push({
            type: type2,
            key: key,
            value: $5193fce5c5df8bb9$var$returnError(()=>{
                var _a25;
                return (_a25 = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a25[key];
            }),
            editable: typeof def.set === "function"
        });
    }
    return computed;
}
function $5193fce5c5df8bb9$var$processAttrs(instance) {
    return Object.keys(instance.attrs).map((key)=>({
            type: "attrs",
            key: key,
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.attrs[key])
        }));
}
function $5193fce5c5df8bb9$var$processProvide(instance) {
    return Reflect.ownKeys(instance.provides).map((key)=>({
            type: "provided",
            key: key.toString(),
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.provides[key])
        }));
}
function $5193fce5c5df8bb9$var$processInject(instance, mergedType) {
    if (!(mergedType == null ? void 0 : mergedType.inject)) return [];
    let keys = [];
    let defaultValue;
    if (Array.isArray(mergedType.inject)) keys = mergedType.inject.map((key)=>({
            key: key,
            originalKey: key
        }));
    else keys = Reflect.ownKeys(mergedType.inject).map((key)=>{
        const value = mergedType.inject[key];
        let originalKey;
        if (typeof value === "string" || typeof value === "symbol") originalKey = value;
        else {
            originalKey = value.from;
            defaultValue = value.default;
        }
        return {
            key: key,
            originalKey: originalKey
        };
    });
    return keys.map(({ key: key, originalKey: originalKey })=>({
            type: "injected",
            key: originalKey && key !== originalKey ? `${originalKey.toString()} \u279E ${key.toString()}` : key.toString(),
            // eslint-disable-next-line no-prototype-builtins
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.ctx.hasOwnProperty(key) ? instance.ctx[key] : instance.provides.hasOwnProperty(originalKey) ? instance.provides[originalKey] : defaultValue)
        }));
}
function $5193fce5c5df8bb9$var$processRefs(instance) {
    return Object.keys(instance.refs).map((key)=>({
            type: "template refs",
            key: key,
            value: $5193fce5c5df8bb9$var$returnError(()=>instance.refs[key])
        }));
}
function $5193fce5c5df8bb9$var$processEventListeners(instance) {
    var _a25, _b25;
    const emitsDefinition = instance.type.emits;
    const declaredEmits = Array.isArray(emitsDefinition) ? emitsDefinition : Object.keys(emitsDefinition != null ? emitsDefinition : {});
    const keys = Object.keys((_b25 = (_a25 = instance == null ? void 0 : instance.vnode) == null ? void 0 : _a25.props) != null ? _b25 : {});
    const result = [];
    for (const key of keys){
        const [prefix, ...eventNameParts] = key.split(/(?=[A-Z])/);
        if (prefix === "on") {
            const eventName = eventNameParts.join("-").toLowerCase();
            const isDeclared = declaredEmits.includes(eventName);
            result.push({
                type: "event listeners",
                key: eventName,
                value: {
                    _custom: {
                        displayText: isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared",
                        key: isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared",
                        value: isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared",
                        tooltipText: !isDeclared ? `The event <code>${eventName}</code> is not declared in the <code>emits</code> option. It will leak into the component's attributes (<code>$attrs</code>).` : null
                    }
                }
            });
        }
    }
    return result;
}
function $5193fce5c5df8bb9$var$processInstanceState(instance) {
    const mergedType = $5193fce5c5df8bb9$var$resolveMergedOptions(instance);
    return $5193fce5c5df8bb9$var$processProps(instance).concat($5193fce5c5df8bb9$var$processState(instance), $5193fce5c5df8bb9$var$processSetupState(instance), $5193fce5c5df8bb9$var$processComputed(instance, mergedType), $5193fce5c5df8bb9$var$processAttrs(instance), $5193fce5c5df8bb9$var$processProvide(instance), $5193fce5c5df8bb9$var$processInject(instance, mergedType), $5193fce5c5df8bb9$var$processRefs(instance), $5193fce5c5df8bb9$var$processEventListeners(instance));
}
// src/core/component/state/index.ts
function $5193fce5c5df8bb9$var$getInstanceState(params) {
    var _a25;
    const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, params.instanceId);
    const id = $5193fce5c5df8bb9$var$getUniqueComponentId(instance);
    const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
    const file = (_a25 = instance == null ? void 0 : instance.type) == null ? void 0 : _a25.__file;
    const state = $5193fce5c5df8bb9$var$processInstanceState(instance);
    return {
        id: id,
        name: name,
        file: file,
        state: state,
        instance: instance
    };
}
// src/core/component/tree/walker.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/tree/filter.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$ComponentFilter = class {
    constructor(filter){
        this.filter = filter || "";
    }
    /**
   * Check if an instance is qualified.
   *
   * @param {Vue|Vnode} instance
   * @return {boolean}
   */ isQualified(instance) {
        const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
        return (0, $i0cUC.classify)(name).toLowerCase().includes(this.filter) || (0, $i0cUC.kebabize)(name).toLowerCase().includes(this.filter);
    }
};
function $5193fce5c5df8bb9$var$createComponentFilter(filterText) {
    return new $5193fce5c5df8bb9$var$ComponentFilter(filterText);
}
// src/core/component/tree/walker.ts
var $5193fce5c5df8bb9$var$ComponentWalker = class {
    constructor(options){
        // Dedupe instances (Some instances may be both on a component and on a child abstract/functional component)
        this.captureIds = /* @__PURE__ */ new Map();
        const { filterText: filterText = "", maxDepth: maxDepth, recursively: recursively, api: api } = options;
        this.componentFilter = $5193fce5c5df8bb9$var$createComponentFilter(filterText);
        this.maxDepth = maxDepth;
        this.recursively = recursively;
        this.api = api;
    }
    getComponentTree(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        return this.findQualifiedChildren(instance, 0);
    }
    getComponentParents(instance) {
        this.captureIds = /* @__PURE__ */ new Map();
        const parents = [];
        this.captureId(instance);
        let parent = instance;
        while(parent = parent.parent){
            this.captureId(parent);
            parents.push(parent);
        }
        return parents;
    }
    captureId(instance) {
        if (!instance) return null;
        const id = instance.__VUE_DEVTOOLS_NEXT_UID__ != null ? instance.__VUE_DEVTOOLS_NEXT_UID__ : $5193fce5c5df8bb9$var$getUniqueComponentId(instance);
        instance.__VUE_DEVTOOLS_NEXT_UID__ = id;
        if (this.captureIds.has(id)) return null;
        else this.captureIds.set(id, void 0);
        this.mark(instance);
        return id;
    }
    /**
   * Capture the meta information of an instance. (recursive)
   *
   * @param {Vue} instance
   * @return {object}
   */ async capture(instance, depth) {
        var _a25;
        if (!instance) return null;
        const id = this.captureId(instance);
        const name = $5193fce5c5df8bb9$var$getInstanceName(instance);
        const children = this.getInternalInstanceChildren(instance.subTree).filter((child)=>!$5193fce5c5df8bb9$var$isBeingDestroyed(child));
        const parents = this.getComponentParents(instance) || [];
        const inactive = !!instance.isDeactivated || parents.some((parent)=>parent.isDeactivated);
        const treeNode = {
            uid: instance.uid,
            id: id,
            name: name,
            renderKey: $5193fce5c5df8bb9$var$getRenderKey(instance.vnode ? instance.vnode.key : null),
            inactive: inactive,
            children: [],
            isFragment: $5193fce5c5df8bb9$var$isFragment(instance),
            tags: typeof instance.type !== "function" ? [] : [
                {
                    label: "functional",
                    textColor: 5592405,
                    backgroundColor: 15658734
                }
            ],
            autoOpen: this.recursively,
            file: instance.type.__file || ""
        };
        if (depth < this.maxDepth || instance.type.__isKeepAlive || parents.some((parent)=>parent.type.__isKeepAlive)) treeNode.children = await Promise.all(children.map((child)=>this.capture(child, depth + 1)).filter(Boolean));
        if (this.isKeepAlive(instance)) {
            const cachedComponents = this.getKeepAliveCachedInstances(instance);
            const childrenIds = children.map((child)=>child.__VUE_DEVTOOLS_NEXT_UID__);
            for (const cachedChild of cachedComponents)if (!childrenIds.includes(cachedChild.__VUE_DEVTOOLS_NEXT_UID__)) {
                const node = await this.capture({
                    ...cachedChild,
                    isDeactivated: true
                }, depth + 1);
                if (node) treeNode.children.push(node);
            }
        }
        const rootElements = $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(instance);
        const firstElement = rootElements[0];
        if (firstElement == null ? void 0 : firstElement.parentElement) {
            const parentInstance = instance.parent;
            const parentRootElements = parentInstance ? $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(parentInstance) : [];
            let el = firstElement;
            const indexList = [];
            do {
                indexList.push(Array.from(el.parentElement.childNodes).indexOf(el));
                el = el.parentElement;
            }while (el.parentElement && parentRootElements.length && !parentRootElements.includes(el));
            treeNode.domOrder = indexList.reverse();
        } else treeNode.domOrder = [
            -1
        ];
        if ((_a25 = instance.suspense) == null ? void 0 : _a25.suspenseKey) {
            treeNode.tags.push({
                label: instance.suspense.suspenseKey,
                backgroundColor: 14979812,
                textColor: 16777215
            });
            this.mark(instance, true);
        }
        this.api.visitComponentTree({
            treeNode: treeNode,
            componentInstance: instance,
            app: instance.appContext.app,
            filter: this.componentFilter.filter
        });
        return treeNode;
    }
    /**
   * Find qualified children from a single instance.
   * If the instance itself is qualified, just return itself.
   * This is ok because [].concat works in both cases.
   *
   * @param {Vue|Vnode} instance
   * @return {Vue|Array}
   */ async findQualifiedChildren(instance, depth) {
        var _a25;
        if (this.componentFilter.isQualified(instance) && !((_a25 = instance.type.devtools) == null ? void 0 : _a25.hide)) return [
            await this.capture(instance, depth)
        ];
        else if (instance.subTree) {
            const list = this.isKeepAlive(instance) ? this.getKeepAliveCachedInstances(instance) : this.getInternalInstanceChildren(instance.subTree);
            return this.findQualifiedChildrenFromList(list, depth);
        } else return [];
    }
    /**
   * Iterate through an array of instances and flatten it into
   * an array of qualified instances. This is a depth-first
   * traversal - e.g. if an instance is not matched, we will
   * recursively go deeper until a qualified child is found.
   *
   * @param {Array} instances
   * @return {Array}
   */ async findQualifiedChildrenFromList(instances, depth) {
        instances = instances.filter((child)=>{
            var _a25;
            return !$5193fce5c5df8bb9$var$isBeingDestroyed(child) && !((_a25 = child.type.devtools) == null ? void 0 : _a25.hide);
        });
        if (!this.componentFilter.filter) return Promise.all(instances.map((child)=>this.capture(child, depth)));
        else return Array.prototype.concat.apply([], await Promise.all(instances.map((i)=>this.findQualifiedChildren(i, depth))));
    }
    /**
   * Get children from a component instance.
   */ getInternalInstanceChildren(subTree, suspense = null) {
        const list = [];
        if (subTree) {
            if (subTree.component) !suspense ? list.push(subTree.component) : list.push({
                ...subTree.component,
                suspense: suspense
            });
            else if (subTree.suspense) {
                const suspenseKey = !subTree.suspense.isInFallback ? "suspense default" : "suspense fallback";
                list.push(...this.getInternalInstanceChildren(subTree.suspense.activeBranch, {
                    ...subTree.suspense,
                    suspenseKey: suspenseKey
                }));
            } else if (Array.isArray(subTree.children)) subTree.children.forEach((childSubTree)=>{
                if (childSubTree.component) !suspense ? list.push(childSubTree.component) : list.push({
                    ...childSubTree.component,
                    suspense: suspense
                });
                else list.push(...this.getInternalInstanceChildren(childSubTree, suspense));
            });
        }
        return list.filter((child)=>{
            var _a25;
            return !$5193fce5c5df8bb9$var$isBeingDestroyed(child) && !((_a25 = child.type.devtools) == null ? void 0 : _a25.hide);
        });
    }
    /**
   * Mark an instance as captured and store it in the instance map.
   *
   * @param {Vue} instance
   */ mark(instance, force = false) {
        const instanceMap = $5193fce5c5df8bb9$var$getAppRecord(instance).instanceMap;
        if (force || !instanceMap.has(instance.__VUE_DEVTOOLS_NEXT_UID__)) {
            instanceMap.set(instance.__VUE_DEVTOOLS_NEXT_UID__, instance);
            $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap = instanceMap;
        }
    }
    isKeepAlive(instance) {
        return instance.type.__isKeepAlive && instance.__v_cache;
    }
    getKeepAliveCachedInstances(instance) {
        return Array.from(instance.__v_cache.values()).map((vnode)=>vnode.component).filter(Boolean);
    }
};
// src/core/timeline/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/timeline/perf.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$markEndQueue = /* @__PURE__ */ new Map();
var $5193fce5c5df8bb9$var$PERFORMANCE_EVENT_LAYER_ID = "performance";
async function $5193fce5c5df8bb9$var$performanceMarkStart(api, app, uid, vm, type, time) {
    const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $5193fce5c5df8bb9$var$getInstanceName(vm) || "Unknown Component";
    const groupId = $5193fce5c5df8bb9$export$a67dd585df937baa.perfUniqueGroupId++;
    const groupKey = `${uid}-${type}`;
    appRecord.perfGroupIds.set(groupKey, {
        groupId: groupId,
        time: time
    });
    await api.addTimelineEvent({
        layerId: $5193fce5c5df8bb9$var$PERFORMANCE_EVENT_LAYER_ID,
        event: {
            time: Date.now(),
            data: {
                component: componentName,
                type: type,
                measure: "start"
            },
            title: componentName,
            subtitle: type,
            groupId: groupId
        }
    });
    if ($5193fce5c5df8bb9$var$markEndQueue.has(groupKey)) {
        const { app: app2, uid: uid2, instance: instance, type: type2, time: time2 } = $5193fce5c5df8bb9$var$markEndQueue.get(groupKey);
        $5193fce5c5df8bb9$var$markEndQueue.delete(groupKey);
        await $5193fce5c5df8bb9$var$performanceMarkEnd(api, app2, uid2, instance, type2, time2);
    }
}
function $5193fce5c5df8bb9$var$performanceMarkEnd(api, app, uid, vm, type, time) {
    const appRecord = $5193fce5c5df8bb9$var$getAppRecord(app);
    if (!appRecord) return;
    const componentName = $5193fce5c5df8bb9$var$getInstanceName(vm) || "Unknown Component";
    const groupKey = `${uid}-${type}`;
    const groupInfo = appRecord.perfGroupIds.get(groupKey);
    if (groupInfo) {
        const groupId = groupInfo.groupId;
        const startTime = groupInfo.time;
        const duration = time - startTime;
        api.addTimelineEvent({
            layerId: $5193fce5c5df8bb9$var$PERFORMANCE_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: componentName,
                    type: type,
                    measure: "end",
                    duration: {
                        _custom: {
                            type: "Duration",
                            value: duration,
                            display: `${duration} ms`
                        }
                    }
                },
                title: componentName,
                subtitle: type,
                groupId: groupId
            }
        });
    } else $5193fce5c5df8bb9$var$markEndQueue.set(groupKey, {
        app: app,
        uid: uid,
        instance: vm,
        type: type,
        time: time
    });
}
// src/core/timeline/index.ts
var $5193fce5c5df8bb9$var$COMPONENT_EVENT_LAYER_ID = "component-event";
function $5193fce5c5df8bb9$var$setupBuiltinTimelineLayers(api) {
    if (!(0, $i0cUC.isBrowser)) return;
    api.addTimelineLayer({
        id: "mouse",
        label: "Mouse",
        color: 10768815
    });
    [
        "mousedown",
        "mouseup",
        "click",
        "dblclick"
    ].forEach((eventType)=>{
        if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.mouseEventEnabled) return;
        window.addEventListener(eventType, async (event)=>{
            await api.addTimelineEvent({
                layerId: "mouse",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        x: event.clientX,
                        y: event.clientY
                    },
                    title: eventType
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: "keyboard",
        label: "Keyboard",
        color: 8475055
    });
    [
        "keyup",
        "keydown",
        "keypress"
    ].forEach((eventType)=>{
        window.addEventListener(eventType, async (event)=>{
            if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.keyboardEventEnabled) return;
            await api.addTimelineEvent({
                layerId: "keyboard",
                event: {
                    time: Date.now(),
                    data: {
                        type: eventType,
                        key: event.key,
                        ctrlKey: event.ctrlKey,
                        shiftKey: event.shiftKey,
                        altKey: event.altKey,
                        metaKey: event.metaKey
                    },
                    title: event.key
                }
            });
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: $5193fce5c5df8bb9$var$COMPONENT_EVENT_LAYER_ID,
        label: "Component events",
        color: 5226637
    });
    $5193fce5c5df8bb9$var$hook.on.componentEmit(async (app, instance, event, params)=>{
        if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.componentEventEnabled) return;
        const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app);
        if (!appRecord) return;
        const componentId = `${appRecord.id}:${instance.uid}`;
        const componentName = $5193fce5c5df8bb9$var$getInstanceName(instance) || "Unknown Component";
        api.addTimelineEvent({
            layerId: $5193fce5c5df8bb9$var$COMPONENT_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: {
                        _custom: {
                            type: "component-definition",
                            display: componentName
                        }
                    },
                    event: event,
                    params: params
                },
                title: event,
                subtitle: `by ${componentName}`,
                meta: {
                    componentId: componentId
                }
            }
        });
    });
    api.addTimelineLayer({
        id: "performance",
        label: $5193fce5c5df8bb9$var$PERFORMANCE_EVENT_LAYER_ID,
        color: 4307050
    });
    $5193fce5c5df8bb9$var$hook.on.perfStart((app, uid, vm, type, time)=>{
        if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $5193fce5c5df8bb9$var$performanceMarkStart(api, app, uid, vm, type, time);
    });
    $5193fce5c5df8bb9$var$hook.on.perfEnd((app, uid, vm, type, time)=>{
        if (!$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.recordingState || !$5193fce5c5df8bb9$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $5193fce5c5df8bb9$var$performanceMarkEnd(api, app, uid, vm, type, time);
    });
}
// src/core/vm/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$MAX_$VM = 10;
var $5193fce5c5df8bb9$var$$vmQueue = [];
function $5193fce5c5df8bb9$var$exposeInstanceToWindow(componentInstance) {
    if (typeof window === "undefined") return;
    const win = window;
    if (!componentInstance) return;
    win.$vm = componentInstance;
    if ($5193fce5c5df8bb9$var$$vmQueue[0] !== componentInstance) {
        if ($5193fce5c5df8bb9$var$$vmQueue.length >= $5193fce5c5df8bb9$var$MAX_$VM) $5193fce5c5df8bb9$var$$vmQueue.pop();
        for(let i = $5193fce5c5df8bb9$var$$vmQueue.length; i > 0; i--)win[`$vm${i}`] = $5193fce5c5df8bb9$var$$vmQueue[i] = $5193fce5c5df8bb9$var$$vmQueue[i - 1];
        win.$vm0 = $5193fce5c5df8bb9$var$$vmQueue[0] = componentInstance;
    }
}
// src/core/plugin/components.ts
var $5193fce5c5df8bb9$var$INSPECTOR_ID = "components";
function $5193fce5c5df8bb9$export$7e5554ded389d004(app) {
    const descriptor = {
        id: $5193fce5c5df8bb9$var$INSPECTOR_ID,
        label: "Components",
        app: app
    };
    const setupFn = (api)=>{
        api.addInspector({
            id: $5193fce5c5df8bb9$var$INSPECTOR_ID,
            label: "Components",
            treeFilterPlaceholder: "Search components"
        });
        $5193fce5c5df8bb9$var$setupBuiltinTimelineLayers(api);
        api.on.getInspectorTree(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $5193fce5c5df8bb9$var$INSPECTOR_ID) {
                const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, payload.instanceId);
                if (instance) {
                    const walker2 = new $5193fce5c5df8bb9$var$ComponentWalker({
                        filterText: payload.filter,
                        // @TODO: should make this configurable?
                        maxDepth: 100,
                        recursively: false,
                        api: api
                    });
                    payload.rootNodes = await walker2.getComponentTree(instance);
                }
            }
        });
        api.on.getInspectorState(async (payload)=>{
            var _a25;
            if (payload.app === app && payload.inspectorId === $5193fce5c5df8bb9$var$INSPECTOR_ID) {
                const result = $5193fce5c5df8bb9$var$getInstanceState({
                    instanceId: payload.nodeId
                });
                const componentInstance = result.instance;
                const app2 = (_a25 = result.instance) == null ? void 0 : _a25.appContext.app;
                const _payload = {
                    componentInstance: componentInstance,
                    app: app2,
                    instanceData: result
                };
                $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHookWith((callbacks)=>{
                    callbacks.forEach((cb)=>cb(_payload));
                }, "inspectComponent" /* INSPECT_COMPONENT */ );
                payload.state = result;
                $5193fce5c5df8bb9$var$exposeInstanceToWindow(componentInstance);
            }
        });
        api.on.editInspectorState(async (payload)=>{
            if (payload.app === app && payload.inspectorId === $5193fce5c5df8bb9$var$INSPECTOR_ID) {
                $5193fce5c5df8bb9$var$editState(payload);
                await api.sendInspectorState("components");
            }
        });
        const debounceSendInspectorTree = (0, $dj5lJ.debounce)(()=>{
            api.sendInspectorTree($5193fce5c5df8bb9$var$INSPECTOR_ID);
        }, 120);
        const debounceSendInspectorState = (0, $dj5lJ.debounce)(()=>{
            api.sendInspectorState($5193fce5c5df8bb9$var$INSPECTOR_ID);
        }, 120);
        const componentAddedCleanup = $5193fce5c5df8bb9$var$hook.on.componentAdded(async (app2, uid, parentUid, component)=>{
            var _a25, _b25, _c;
            if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
            if ((_c = (_b25 = (_a25 = app2 == null ? void 0 : app2._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
            if (!app2 || typeof uid !== "number" && !uid || !component) return;
            const id = await $5193fce5c5df8bb9$var$getComponentId({
                app: app2,
                uid: uid,
                instance: component
            });
            const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app2);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!(appRecord == null ? void 0 : appRecord.instanceMap.has(id))) {
                    appRecord == null || appRecord.instanceMap.set(id, component);
                    if ($5193fce5c5df8bb9$export$162128841a7f2877.value.id === (appRecord == null ? void 0 : appRecord.id)) $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
        });
        const componentUpdatedCleanup = $5193fce5c5df8bb9$var$hook.on.componentUpdated(async (app2, uid, parentUid, component)=>{
            var _a25, _b25, _c;
            if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
            if ((_c = (_b25 = (_a25 = app2 == null ? void 0 : app2._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
            if (!app2 || typeof uid !== "number" && !uid || !component) return;
            const id = await $5193fce5c5df8bb9$var$getComponentId({
                app: app2,
                uid: uid,
                instance: component
            });
            const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app2);
            if (component) {
                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (!(appRecord == null ? void 0 : appRecord.instanceMap.has(id))) {
                    appRecord == null || appRecord.instanceMap.set(id, component);
                    if ($5193fce5c5df8bb9$export$162128841a7f2877.value.id === (appRecord == null ? void 0 : appRecord.id)) $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                }
            }
            if (!appRecord) return;
            debounceSendInspectorTree();
            debounceSendInspectorState();
        });
        const componentRemovedCleanup = $5193fce5c5df8bb9$var$hook.on.componentRemoved(async (app2, uid, parentUid, component)=>{
            var _a25, _b25, _c;
            if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
            if ((_c = (_b25 = (_a25 = app2 == null ? void 0 : app2._instance) == null ? void 0 : _a25.type) == null ? void 0 : _b25.devtools) == null ? void 0 : _c.hide) return;
            if (!app2 || typeof uid !== "number" && !uid || !component) return;
            const appRecord = await $5193fce5c5df8bb9$var$getAppRecord(app2);
            if (!appRecord) return;
            const id = await $5193fce5c5df8bb9$var$getComponentId({
                app: app2,
                uid: uid,
                instance: component
            });
            appRecord == null || appRecord.instanceMap.delete(id);
            if ($5193fce5c5df8bb9$export$162128841a7f2877.value.id === (appRecord == null ? void 0 : appRecord.id)) $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
            debounceSendInspectorTree();
        });
    };
    return [
        descriptor,
        setupFn
    ];
}
// src/core/plugin/index.ts
var $5193fce5c5df8bb9$var$_a12, $5193fce5c5df8bb9$var$_b12;
($5193fce5c5df8bb9$var$_b12 = ($5193fce5c5df8bb9$var$_a12 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) != null ? $5193fce5c5df8bb9$var$_b12 : $5193fce5c5df8bb9$var$_a12.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = /* @__PURE__ */ new Set();
function $5193fce5c5df8bb9$export$1f0daed17c8e64f(pluginDescriptor, setupFn) {
    return $5193fce5c5df8bb9$var$hook.setupDevToolsPlugin(pluginDescriptor, setupFn);
}
function $5193fce5c5df8bb9$export$873c261f47a243e7(plugin, app) {
    const [pluginDescriptor, setupFn] = plugin;
    if (pluginDescriptor.app !== app) return;
    const api = new $5193fce5c5df8bb9$var$DevToolsPluginAPI({
        plugin: {
            setupFn: setupFn,
            descriptor: pluginDescriptor
        },
        ctx: $5193fce5c5df8bb9$export$4f1904c03898171b
    });
    if (pluginDescriptor.packageName === "vuex") api.on.editInspectorState((payload)=>{
        api.sendInspectorState(payload.inspectorId);
    });
    setupFn(api);
}
function $5193fce5c5df8bb9$export$7f52963080ec618f(app) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.delete(app);
}
function $5193fce5c5df8bb9$export$c357c87447719db2(app, options) {
    if ((0, $i0cUC.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(app)) return;
    if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled && !(options == null ? void 0 : options.inspectingComponent)) return;
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(app);
    $5193fce5c5df8bb9$export$df02dcb86618c10f.forEach((plugin)=>{
        $5193fce5c5df8bb9$export$873c261f47a243e7(plugin, app);
    });
}
// src/core/router/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/ctx/router.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$export$57206cad6442cbbb = "__VUE_DEVTOOLS_ROUTER__";
var $5193fce5c5df8bb9$export$bcb936c2c1e0b8ba = "__VUE_DEVTOOLS_ROUTER_INFO__";
var $5193fce5c5df8bb9$var$_a13, $5193fce5c5df8bb9$var$_b13;
($5193fce5c5df8bb9$var$_b13 = ($5193fce5c5df8bb9$var$_a13 = (0, $i0cUC.target))[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba]) != null ? $5193fce5c5df8bb9$var$_b13 : $5193fce5c5df8bb9$var$_a13[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba] = {
    currentRoute: null,
    routes: []
};
var $5193fce5c5df8bb9$var$_a14, $5193fce5c5df8bb9$var$_b14;
($5193fce5c5df8bb9$var$_b14 = ($5193fce5c5df8bb9$var$_a14 = (0, $i0cUC.target))[$5193fce5c5df8bb9$export$57206cad6442cbbb]) != null ? $5193fce5c5df8bb9$var$_b14 : $5193fce5c5df8bb9$var$_a14[$5193fce5c5df8bb9$export$57206cad6442cbbb] = {};
var $5193fce5c5df8bb9$export$10a28a01c0e59bea = new Proxy((0, $i0cUC.target)[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba], {
    get (target22, property) {
        return (0, $i0cUC.target)[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba][property];
    }
});
var $5193fce5c5df8bb9$export$73b6e4968c970971 = new Proxy((0, $i0cUC.target)[$5193fce5c5df8bb9$export$57206cad6442cbbb], {
    get (target22, property) {
        if (property === "value") return (0, $i0cUC.target)[$5193fce5c5df8bb9$export$57206cad6442cbbb];
    }
});
// src/core/router/index.ts
function $5193fce5c5df8bb9$var$getRoutes(router) {
    const routesMap = /* @__PURE__ */ new Map();
    return ((router == null ? void 0 : router.getRoutes()) || []).filter((i)=>!routesMap.has(i.path) && routesMap.set(i.path, 1));
}
function $5193fce5c5df8bb9$var$filterRoutes(routes) {
    return routes.map((item)=>{
        let { path: path, name: name, children: children, meta: meta } = item;
        if (children == null ? void 0 : children.length) children = $5193fce5c5df8bb9$var$filterRoutes(children);
        return {
            path: path,
            name: name,
            children: children,
            meta: meta
        };
    });
}
function $5193fce5c5df8bb9$var$filterCurrentRoute(route) {
    if (route) {
        const { fullPath: fullPath, hash: hash, href: href, path: path, name: name, matched: matched, params: params, query: query } = route;
        return {
            fullPath: fullPath,
            hash: hash,
            href: href,
            path: path,
            name: name,
            params: params,
            query: query,
            matched: $5193fce5c5df8bb9$var$filterRoutes(matched)
        };
    }
    return route;
}
function $5193fce5c5df8bb9$var$normalizeRouterInfo(appRecord, activeAppRecord2) {
    function init() {
        var _a25;
        const router = (_a25 = appRecord.app) == null ? void 0 : _a25.config.globalProperties.$router;
        const currentRoute = $5193fce5c5df8bb9$var$filterCurrentRoute(router == null ? void 0 : router.currentRoute.value);
        const routes = $5193fce5c5df8bb9$var$filterRoutes($5193fce5c5df8bb9$var$getRoutes(router));
        const c = console.warn;
        console.warn = ()=>{};
        (0, $i0cUC.target)[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba] = {
            currentRoute: currentRoute ? (0, $i0cUC.deepClone)(currentRoute) : {},
            routes: (0, $i0cUC.deepClone)(routes)
        };
        (0, $i0cUC.target)[$5193fce5c5df8bb9$export$57206cad6442cbbb] = router;
        console.warn = c;
    }
    init();
    $5193fce5c5df8bb9$var$hook.on.componentUpdated((0, $dj5lJ.debounce)(()=>{
        var _a25;
        if (((_a25 = activeAppRecord2.value) == null ? void 0 : _a25.app) !== appRecord.app) return;
        init();
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled) return;
        $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("routerInfoUpdated" /* ROUTER_INFO_UPDATED */ , {
            state: (0, $i0cUC.target)[$5193fce5c5df8bb9$export$bcb936c2c1e0b8ba]
        });
    }, 200));
}
// src/ctx/api.ts
function $5193fce5c5df8bb9$export$bb51459158adb36b(hooks2) {
    return {
        // get inspector tree
        async getInspectorTree (payload) {
            const _payload = {
                ...payload,
                app: $5193fce5c5df8bb9$export$162128841a7f2877.value.app,
                rootNodes: []
            };
            await new Promise((resolve)=>{
                hooks2.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload)));
                    resolve();
                }, "getInspectorTree" /* GET_INSPECTOR_TREE */ );
            });
            return _payload.rootNodes;
        },
        // get inspector state
        async getInspectorState (payload) {
            const _payload = {
                ...payload,
                app: $5193fce5c5df8bb9$export$162128841a7f2877.value.app,
                state: null
            };
            const ctx = {
                currentTab: `custom-inspector:${payload.inspectorId}`
            };
            await new Promise((resolve)=>{
                hooks2.callHookWith(async (callbacks)=>{
                    await Promise.all(callbacks.map((cb)=>cb(_payload, ctx)));
                    resolve();
                }, "getInspectorState" /* GET_INSPECTOR_STATE */ );
            });
            return _payload.state;
        },
        // edit inspector state
        editInspectorState (payload) {
            const stateEditor2 = new $5193fce5c5df8bb9$var$StateEditor();
            const _payload = {
                ...payload,
                app: $5193fce5c5df8bb9$export$162128841a7f2877.value.app,
                set: (obj, path = payload.path, value = payload.state.value, cb)=>{
                    stateEditor2.set(obj, path, value, cb || stateEditor2.createDefaultSetCallback(payload.state));
                }
            };
            hooks2.callHookWith((callbacks)=>{
                callbacks.forEach((cb)=>cb(_payload));
            }, "editInspectorState" /* EDIT_INSPECTOR_STATE */ );
        },
        // send inspector state
        sendInspectorState (inspectorId) {
            const inspector = $5193fce5c5df8bb9$export$aa4140d0f5ce4bbe(inspectorId);
            hooks2.callHook("sendInspectorState" /* SEND_INSPECTOR_STATE */ , {
                inspectorId: inspectorId,
                plugin: {
                    descriptor: inspector.descriptor,
                    setupFn: ()=>({})
                }
            });
        },
        // inspect component inspector
        inspectComponentInspector () {
            return $5193fce5c5df8bb9$var$inspectComponentHighLighter();
        },
        // cancel inspect component inspector
        cancelInspectComponentInspector () {
            return $5193fce5c5df8bb9$var$cancelInspectComponentHighLighter();
        },
        // get component render code
        getComponentRenderCode (id) {
            const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, id);
            if (instance) return !(typeof (instance == null ? void 0 : instance.type) === "function") ? instance.render.toString() : instance.type.toString();
        },
        // scroll to component
        scrollToComponent (id) {
            return $5193fce5c5df8bb9$var$scrollToComponent({
                id: id
            });
        },
        openInEditor: // open in editor
        $5193fce5c5df8bb9$var$openInEditor,
        // get vue inspector
        getVueInspector: $5193fce5c5df8bb9$var$getComponentInspector,
        // toggle app
        toggleApp (id, options) {
            const appRecord = $5193fce5c5df8bb9$export$d3c0473489b1d63b.value.find((record)=>record.id === id);
            if (appRecord) {
                $5193fce5c5df8bb9$export$1a7804ab8d8511d1(id);
                $5193fce5c5df8bb9$export$1574774def61bdf9(appRecord);
                $5193fce5c5df8bb9$var$normalizeRouterInfo(appRecord, $5193fce5c5df8bb9$export$162128841a7f2877);
                $5193fce5c5df8bb9$export$17f8005932e80cc0();
                $5193fce5c5df8bb9$export$c357c87447719db2(appRecord.app, options);
            }
        },
        // inspect dom
        inspectDOM (instanceId) {
            const instance = $5193fce5c5df8bb9$var$getComponentInstance($5193fce5c5df8bb9$export$162128841a7f2877.value, instanceId);
            if (instance) {
                const [el] = $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(instance);
                if (el) (0, $i0cUC.target).__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = el;
            }
        },
        updatePluginSettings (pluginId, key, value) {
            $5193fce5c5df8bb9$var$setPluginSettings(pluginId, key, value);
        },
        getPluginSettings (pluginId) {
            return {
                options: $5193fce5c5df8bb9$var$getPluginSettingsOptions(pluginId),
                values: $5193fce5c5df8bb9$var$getPluginSettings(pluginId)
            };
        }
    };
}
// src/ctx/env.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$_a15, $5193fce5c5df8bb9$var$_b15;
($5193fce5c5df8bb9$var$_b15 = ($5193fce5c5df8bb9$var$_a15 = (0, $i0cUC.target)).__VUE_DEVTOOLS_ENV__) != null ? $5193fce5c5df8bb9$var$_b15 : $5193fce5c5df8bb9$var$_a15.__VUE_DEVTOOLS_ENV__ = {
    vitePluginDetected: false
};
function $5193fce5c5df8bb9$export$6fcf3c68ecb51939() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_ENV__;
}
function $5193fce5c5df8bb9$export$b209b470d7c4ea55(env) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_ENV__ = {
        ...(0, $i0cUC.target).__VUE_DEVTOOLS_ENV__,
        ...env
    };
}
// src/ctx/index.ts
var $5193fce5c5df8bb9$var$hooks = $5193fce5c5df8bb9$export$73be3ac6032ad9bb();
var $5193fce5c5df8bb9$var$_a16, $5193fce5c5df8bb9$var$_b16;
($5193fce5c5df8bb9$var$_b16 = ($5193fce5c5df8bb9$var$_a16 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_CONTEXT__) != null ? $5193fce5c5df8bb9$var$_b16 : $5193fce5c5df8bb9$var$_a16.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
    hooks: $5193fce5c5df8bb9$var$hooks,
    get state () {
        return {
            ...$5193fce5c5df8bb9$export$a67dd585df937baa,
            activeAppRecordId: $5193fce5c5df8bb9$export$162128841a7f2877.id,
            activeAppRecord: $5193fce5c5df8bb9$export$162128841a7f2877.value,
            appRecords: $5193fce5c5df8bb9$export$d3c0473489b1d63b.value
        };
    },
    api: $5193fce5c5df8bb9$export$bb51459158adb36b($5193fce5c5df8bb9$var$hooks)
};
var $5193fce5c5df8bb9$export$4f1904c03898171b = (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_CONTEXT__;
// src/core/app/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$import_speakingurl = $5193fce5c5df8bb9$var$__toESM($5193fce5c5df8bb9$var$require_speakingurl2(), 1);
var $5193fce5c5df8bb9$var$_a17, $5193fce5c5df8bb9$var$_b17;
var $5193fce5c5df8bb9$var$appRecordInfo = ($5193fce5c5df8bb9$var$_b17 = ($5193fce5c5df8bb9$var$_a17 = (0, $i0cUC.target)).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) != null ? $5193fce5c5df8bb9$var$_b17 : $5193fce5c5df8bb9$var$_a17.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = {
    id: 0,
    appIds: /* @__PURE__ */ new Set()
};
function $5193fce5c5df8bb9$var$getAppRecordName(app, fallbackName) {
    var _a25;
    return ((_a25 = app == null ? void 0 : app._component) == null ? void 0 : _a25.name) || `App ${fallbackName}`;
}
function $5193fce5c5df8bb9$var$getAppRootInstance(app) {
    var _a25, _b25, _c, _d;
    if (app._instance) return app._instance;
    else if ((_b25 = (_a25 = app._container) == null ? void 0 : _a25._vnode) == null ? void 0 : _b25.component) return (_d = (_c = app._container) == null ? void 0 : _c._vnode) == null ? void 0 : _d.component;
}
function $5193fce5c5df8bb9$var$removeAppRecordId(app) {
    const id = app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    if (id != null) {
        $5193fce5c5df8bb9$var$appRecordInfo.appIds.delete(id);
        $5193fce5c5df8bb9$var$appRecordInfo.id--;
    }
}
function $5193fce5c5df8bb9$var$getAppRecordId(app, defaultId) {
    if (app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ != null) return app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    let id = defaultId != null ? defaultId : ($5193fce5c5df8bb9$var$appRecordInfo.id++).toString();
    if (defaultId && $5193fce5c5df8bb9$var$appRecordInfo.appIds.has(id)) {
        let count = 1;
        while($5193fce5c5df8bb9$var$appRecordInfo.appIds.has(`${defaultId}_${count}`))count++;
        id = `${defaultId}_${count}`;
    }
    $5193fce5c5df8bb9$var$appRecordInfo.appIds.add(id);
    app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ = id;
    return id;
}
function $5193fce5c5df8bb9$var$createAppRecord(app, types) {
    var _a25, _b25;
    const rootInstance = $5193fce5c5df8bb9$var$getAppRootInstance(app);
    if (rootInstance) {
        $5193fce5c5df8bb9$var$appRecordInfo.id++;
        const name = $5193fce5c5df8bb9$var$getAppRecordName(app, $5193fce5c5df8bb9$var$appRecordInfo.id.toString());
        const id = $5193fce5c5df8bb9$var$getAppRecordId(app, (0, $5193fce5c5df8bb9$var$import_speakingurl.default)(name));
        const [el] = $5193fce5c5df8bb9$var$getRootElementsFromComponentInstance(rootInstance);
        const record = {
            id: id,
            name: name,
            types: types,
            instanceMap: /* @__PURE__ */ new Map(),
            perfGroupIds: /* @__PURE__ */ new Map(),
            rootInstance: rootInstance,
            iframe: (0, $i0cUC.isBrowser) && document !== (el == null ? void 0 : el.ownerDocument) ? (_b25 = (_a25 = el == null ? void 0 : el.ownerDocument) == null ? void 0 : _a25.location) == null ? void 0 : _b25.pathname : void 0
        };
        app.__VUE_DEVTOOLS_NEXT_APP_RECORD__ = record;
        const rootId = `${record.id}:root`;
        record.instanceMap.set(rootId, record.rootInstance);
        record.rootInstance.__VUE_DEVTOOLS_NEXT_UID__ = rootId;
        return record;
    } else return {};
}
// src/core/iframe/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$detectIframeApp(target22, inIframe = false) {
    if (inIframe) {
        let sendEventToParent2 = function(cb) {
            try {
                const hook3 = window.parent.__VUE_DEVTOOLS_GLOBAL_HOOK__;
                if (hook3) cb(hook3);
            } catch (e) {}
        };
        var sendEventToParent = sendEventToParent2;
        const hook2 = {
            id: "vue-devtools-next",
            devtoolsVersion: "7.0",
            on: (event, cb)=>{
                sendEventToParent2((hook3)=>{
                    hook3.on(event, cb);
                });
            },
            once: (event, cb)=>{
                sendEventToParent2((hook3)=>{
                    hook3.once(event, cb);
                });
            },
            off: (event, cb)=>{
                sendEventToParent2((hook3)=>{
                    hook3.off(event, cb);
                });
            },
            emit: (event, ...payload)=>{
                sendEventToParent2((hook3)=>{
                    hook3.emit(event, ...payload);
                });
            }
        };
        Object.defineProperty(target22, "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
            get () {
                return hook2;
            },
            configurable: true
        });
    }
    function injectVueHookToIframe(iframe) {
        if (iframe.__vdevtools__injected) return;
        try {
            iframe.__vdevtools__injected = true;
            const inject = ()=>{
                try {
                    iframe.contentWindow.__VUE_DEVTOOLS_IFRAME__ = iframe;
                    const script = iframe.contentDocument.createElement("script");
                    script.textContent = `;(${$5193fce5c5df8bb9$var$detectIframeApp.toString()})(window, true)`;
                    iframe.contentDocument.documentElement.appendChild(script);
                    script.parentNode.removeChild(script);
                } catch (e) {}
            };
            inject();
            iframe.addEventListener("load", ()=>inject());
        } catch (e) {}
    }
    function injectVueHookToIframes() {
        if (typeof window === "undefined") return;
        const iframes = Array.from(document.querySelectorAll("iframe:not([data-vue-devtools-ignore])"));
        for (const iframe of iframes)injectVueHookToIframe(iframe);
    }
    injectVueHookToIframes();
    let iframeAppChecks = 0;
    const iframeAppCheckTimer = setInterval(()=>{
        injectVueHookToIframes();
        iframeAppChecks++;
        if (iframeAppChecks >= 5) clearInterval(iframeAppCheckTimer);
    }, 1e3);
}
// src/core/index.ts
function $5193fce5c5df8bb9$export$93f430585c3f6d11() {
    var _a25;
    $5193fce5c5df8bb9$var$detectIframeApp((0, $i0cUC.target));
    $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
        vitePluginDetected: $5193fce5c5df8bb9$export$6fcf3c68ecb51939().vitePluginDetected
    });
    const isDevToolsNext = ((_a25 = (0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__) == null ? void 0 : _a25.id) === "vue-devtools-next";
    if ((0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__ && isDevToolsNext) return;
    const _devtoolsHook = $5193fce5c5df8bb9$var$createDevToolsHook();
    if ((0, $i0cUC.target).__VUE_DEVTOOLS_HOOK_REPLAY__) try {
        (0, $i0cUC.target).__VUE_DEVTOOLS_HOOK_REPLAY__.forEach((cb)=>cb(_devtoolsHook));
        (0, $i0cUC.target).__VUE_DEVTOOLS_HOOK_REPLAY__ = [];
    } catch (e) {
        console.error("[vue-devtools] Error during hook replay", e);
    }
    _devtoolsHook.once("init", (Vue)=>{
        (0, $i0cUC.target).__VUE_DEVTOOLS_VUE2_APP_DETECTED__ = true;
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
        console.log("%cVue DevTools v7 detected in your Vue2 project. v7 only supports Vue3 and will not work.", "font-bold: 500; font-size: 14px;");
        const legacyChromeUrl = "https://chromewebstore.google.com/detail/vuejs-devtools/iaajmlceplecbljialhhkmedjlpdblhp";
        const legacyFirefoxUrl = "https://addons.mozilla.org/firefox/addon/vue-js-devtools-v6-legacy";
        console.log(`%cThe legacy version of chrome extension that supports both Vue 2 and Vue 3 has been moved to %c ${legacyChromeUrl}`, "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log(`%cThe legacy version of firefox extension that supports both Vue 2 and Vue 3 has been moved to %c ${legacyFirefoxUrl}`, "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log("%cPlease install and enable only the legacy version for your Vue2 app.", "font-bold: 500; font-size: 14px;");
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
    });
    $5193fce5c5df8bb9$var$hook.on.setupDevtoolsPlugin((pluginDescriptor, setupFn)=>{
        var _a26;
        $5193fce5c5df8bb9$export$5158df7771943590(pluginDescriptor, setupFn);
        const { app: app } = (_a26 = $5193fce5c5df8bb9$export$162128841a7f2877) != null ? _a26 : {};
        if (pluginDescriptor.settings) $5193fce5c5df8bb9$var$initPluginSettings(pluginDescriptor.id, pluginDescriptor.settings);
        if (!app) return;
        $5193fce5c5df8bb9$export$873c261f47a243e7([
            pluginDescriptor,
            setupFn
        ], app);
    });
    $5193fce5c5df8bb9$var$onLegacyDevToolsPluginApiAvailable(()=>{
        const normalizedPluginBuffer = $5193fce5c5df8bb9$export$df02dcb86618c10f.filter(([item])=>item.id !== "components");
        normalizedPluginBuffer.forEach(([pluginDescriptor, setupFn])=>{
            _devtoolsHook.emit("devtools-plugin:setup" /* SETUP_DEVTOOLS_PLUGIN */ , pluginDescriptor, setupFn, {
                target: "legacy"
            });
        });
    });
    $5193fce5c5df8bb9$var$hook.on.vueAppInit(async (app, version, types)=>{
        const appRecord = $5193fce5c5df8bb9$var$createAppRecord(app, types);
        const normalizedAppRecord = {
            ...appRecord,
            app: app,
            version: version
        };
        $5193fce5c5df8bb9$export$c1761479e1420543(normalizedAppRecord);
        if ($5193fce5c5df8bb9$export$d3c0473489b1d63b.value.length === 1) {
            $5193fce5c5df8bb9$export$1574774def61bdf9(normalizedAppRecord);
            $5193fce5c5df8bb9$export$1a7804ab8d8511d1(normalizedAppRecord.id);
            $5193fce5c5df8bb9$var$normalizeRouterInfo(normalizedAppRecord, $5193fce5c5df8bb9$export$162128841a7f2877);
            $5193fce5c5df8bb9$export$c357c87447719db2(normalizedAppRecord.app);
        }
        $5193fce5c5df8bb9$export$1f0daed17c8e64f(...$5193fce5c5df8bb9$export$7e5554ded389d004(normalizedAppRecord.app));
        $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
            connected: true
        });
        _devtoolsHook.apps.push(app);
    });
    $5193fce5c5df8bb9$var$hook.on.vueAppUnmount(async (app)=>{
        const activeRecords = $5193fce5c5df8bb9$export$d3c0473489b1d63b.value.filter((appRecord)=>appRecord.app !== app);
        if (activeRecords.length === 0) $5193fce5c5df8bb9$export$ee22a7aaf6b41ce2({
            connected: false
        });
        $5193fce5c5df8bb9$export$4d20c72f1da170ba(app);
        $5193fce5c5df8bb9$var$removeAppRecordId(app);
        if ($5193fce5c5df8bb9$export$162128841a7f2877.value.app === app) {
            $5193fce5c5df8bb9$export$1574774def61bdf9(activeRecords[0]);
            $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.callHook("sendActiveAppUpdatedToClient" /* SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT */ );
        }
        (0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.splice((0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.indexOf(app), 1);
        $5193fce5c5df8bb9$export$7f52963080ec618f(app);
    });
    $5193fce5c5df8bb9$var$subscribeDevToolsHook(_devtoolsHook);
    if (!(0, $i0cUC.target).__VUE_DEVTOOLS_GLOBAL_HOOK__) Object.defineProperty((0, $i0cUC.target), "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
        get () {
            return _devtoolsHook;
        },
        configurable: true
    });
    else if (!(0, $i0cUC.isNuxtApp)) Object.assign(__VUE_DEVTOOLS_GLOBAL_HOOK__, _devtoolsHook);
}
function $5193fce5c5df8bb9$export$cb42e76452729606(fn) {
    return new Promise((resolve)=>{
        if ($5193fce5c5df8bb9$export$a67dd585df937baa.connected && $5193fce5c5df8bb9$export$a67dd585df937baa.clientConnected) {
            fn();
            resolve();
            return;
        }
        $5193fce5c5df8bb9$export$4f1904c03898171b.hooks.hook("devtoolsConnectedUpdated" /* DEVTOOLS_CONNECTED_UPDATED */ , ({ state: state })=>{
            if (state.connected && state.clientConnected) {
                fn();
                resolve();
            }
        });
    });
}
// src/core/high-perf-mode/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$export$6f15da7a796da26a(state) {
    $5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled = state != null ? state : !$5193fce5c5df8bb9$export$a67dd585df937baa.highPerfModeEnabled;
    if (!state && $5193fce5c5df8bb9$export$162128841a7f2877.value) $5193fce5c5df8bb9$export$c357c87447719db2($5193fce5c5df8bb9$export$162128841a7f2877.value.app);
}
// src/core/component/state/format.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/reviver.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$reviveSet(val) {
    const result = /* @__PURE__ */ new Set();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const value = list[i];
        result.add($5193fce5c5df8bb9$var$revive(value));
    }
    return result;
}
function $5193fce5c5df8bb9$var$reviveMap(val) {
    const result = /* @__PURE__ */ new Map();
    const list = val._custom.value;
    for(let i = 0; i < list.length; i++){
        const { key: key, value: value } = list[i];
        result.set(key, $5193fce5c5df8bb9$var$revive(value));
    }
    return result;
}
function $5193fce5c5df8bb9$var$revive(val) {
    if (val === $5193fce5c5df8bb9$export$6db089fe7b26f5b6) return void 0;
    else if (val === $5193fce5c5df8bb9$export$b4bf424ed968e242) return Number.POSITIVE_INFINITY;
    else if (val === $5193fce5c5df8bb9$export$95cb88e357cbada8) return Number.NEGATIVE_INFINITY;
    else if (val === $5193fce5c5df8bb9$export$d7ae0f70ebb9e144) return Number.NaN;
    else if (val && val._custom) {
        const { _custom: custom } = val;
        if (custom.type === "component") return $5193fce5c5df8bb9$export$162128841a7f2877.value.instanceMap.get(custom.id);
        else if (custom.type === "map") return $5193fce5c5df8bb9$var$reviveMap(val);
        else if (custom.type === "set") return $5193fce5c5df8bb9$var$reviveSet(val);
        else if (custom.type === "bigint") return BigInt(custom.value);
        else return $5193fce5c5df8bb9$var$revive(custom.value);
    } else if ($5193fce5c5df8bb9$var$symbolRE.test(val)) {
        const [, string] = $5193fce5c5df8bb9$var$symbolRE.exec(val);
        return Symbol.for(string);
    } else if ($5193fce5c5df8bb9$var$specialTypeRE.test(val)) {
        const [, type, string, , details] = $5193fce5c5df8bb9$var$specialTypeRE.exec(val);
        const result = new (0, $i0cUC.target)[type](string);
        if (type === "Error" && details) result.stack = details;
        return result;
    } else return val;
}
function $5193fce5c5df8bb9$var$reviver(key, value) {
    return $5193fce5c5df8bb9$var$revive(value);
}
// src/core/component/state/format.ts
function $5193fce5c5df8bb9$export$a2acd0fde5480ad5(value, raw = true) {
    const type = typeof value;
    if (value == null || value === $5193fce5c5df8bb9$export$6db089fe7b26f5b6 || value === "undefined") return "null";
    else if (type === "boolean" || type === "number" || value === $5193fce5c5df8bb9$export$b4bf424ed968e242 || value === $5193fce5c5df8bb9$export$95cb88e357cbada8 || value === $5193fce5c5df8bb9$export$d7ae0f70ebb9e144) return "literal";
    else if (value == null ? void 0 : value._custom) {
        if (raw || value._custom.display != null || value._custom.displayText != null) return "custom";
        else return $5193fce5c5df8bb9$export$a2acd0fde5480ad5(value._custom.value);
    } else if (typeof value === "string") {
        const typeMatch = $5193fce5c5df8bb9$var$specialTypeRE.exec(value);
        if (typeMatch) {
            const [, type2] = typeMatch;
            return `native ${type2}`;
        } else return "string";
    } else if (Array.isArray(value) || (value == null ? void 0 : value._isArray)) return "array";
    else if ($5193fce5c5df8bb9$export$53b83ca8eaab0383(value)) return "plain-object";
    else return "unknown";
}
function $5193fce5c5df8bb9$export$6c635c17a78ff695(value, quotes = false, options) {
    var _a25, _b25, _c;
    const { customClass: customClass } = options != null ? options : {};
    let result;
    const type = $5193fce5c5df8bb9$export$a2acd0fde5480ad5(value, false);
    if (type !== "custom" && (value == null ? void 0 : value._custom)) value = value._custom.value;
    if (result = $5193fce5c5df8bb9$var$internalStateTokenToString(value)) return result;
    else if (type === "custom") {
        const nestedName = ((_a25 = value._custom.value) == null ? void 0 : _a25._custom) && $5193fce5c5df8bb9$export$6c635c17a78ff695(value._custom.value, quotes, options);
        return nestedName || value._custom.displayText || value._custom.display;
    } else if (type === "array") return `Array[${value.length}]`;
    else if (type === "plain-object") return `Object${Object.keys(value).length ? "" : " (empty)"}`;
    else if (type == null ? void 0 : type.includes("native")) return $5193fce5c5df8bb9$export$4e7f196112fea3c5((_b25 = $5193fce5c5df8bb9$var$specialTypeRE.exec(value)) == null ? void 0 : _b25[2]);
    else if (typeof value === "string") {
        const typeMatch = value.match($5193fce5c5df8bb9$var$rawTypeRE);
        if (typeMatch) value = $5193fce5c5df8bb9$var$escapeString(typeMatch[1]);
        else if (quotes) value = `<span>"</span>${(customClass == null ? void 0 : customClass.string) ? `<span class=${customClass.string}>${$5193fce5c5df8bb9$var$escapeString(value)}</span>` : $5193fce5c5df8bb9$var$escapeString(value)}<span>"</span>`;
        else value = (customClass == null ? void 0 : customClass.string) ? `<span class="${(_c = customClass == null ? void 0 : customClass.string) != null ? _c : ""}">${$5193fce5c5df8bb9$var$escapeString(value)}</span>` : $5193fce5c5df8bb9$var$escapeString(value);
    }
    return value;
}
function $5193fce5c5df8bb9$var$escapeString(value) {
    return $5193fce5c5df8bb9$export$4e7f196112fea3c5(value).replace(/ /g, "&nbsp;").replace(/\n/g, "<span>\\n</span>");
}
function $5193fce5c5df8bb9$export$d049e3525cb8af5d(value) {
    var _a25, _b25, _c;
    let customType;
    const isCustom = $5193fce5c5df8bb9$export$a2acd0fde5480ad5(value) === "custom";
    let inherit = {};
    if (isCustom) {
        const data = value;
        const customValue = (_a25 = data._custom) == null ? void 0 : _a25.value;
        const currentCustomType = (_b25 = data._custom) == null ? void 0 : _b25.type;
        const nestedCustom = typeof customValue === "object" && customValue !== null && "_custom" in customValue ? $5193fce5c5df8bb9$export$d049e3525cb8af5d(customValue) : {
            inherit: void 0,
            value: void 0,
            customType: void 0
        };
        inherit = nestedCustom.inherit || ((_c = data._custom) == null ? void 0 : _c.fields) || {};
        value = nestedCustom.value || customValue;
        customType = nestedCustom.customType || currentCustomType;
    }
    if (value && value._isArray) value = value.items;
    return {
        value: value,
        inherit: inherit,
        customType: customType
    };
}
function $5193fce5c5df8bb9$export$b0067b146e5937f7(value, customType) {
    if (customType === "bigint") return value;
    if (customType === "date") return value;
    return $5193fce5c5df8bb9$var$replaceTokenToString(JSON.stringify(value));
}
function $5193fce5c5df8bb9$export$d61dc8d725d3735e(value, customType) {
    if (customType === "bigint") return BigInt(value);
    if (customType === "date") return new Date(value);
    return JSON.parse($5193fce5c5df8bb9$var$replaceStringToToken(value), $5193fce5c5df8bb9$var$reviver);
}
// src/core/devtools-client/detected.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$export$2fce292577290205(params) {
    $5193fce5c5df8bb9$export$a67dd585df937baa.devtoolsClientDetected = {
        ...$5193fce5c5df8bb9$export$a67dd585df937baa.devtoolsClientDetected,
        ...params
    };
    const devtoolsClientVisible = Object.values($5193fce5c5df8bb9$export$a67dd585df937baa.devtoolsClientDetected).some(Boolean);
    $5193fce5c5df8bb9$export$6f15da7a796da26a(!devtoolsClientVisible);
}
var $5193fce5c5df8bb9$var$_a18, $5193fce5c5df8bb9$var$_b18;
($5193fce5c5df8bb9$var$_b18 = ($5193fce5c5df8bb9$var$_a18 = (0, $i0cUC.target)).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) != null ? $5193fce5c5df8bb9$var$_b18 : $5193fce5c5df8bb9$var$_a18.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = $5193fce5c5df8bb9$export$2fce292577290205;
// src/messaging/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/broadcast-channel/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/index.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/class-registry.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/registry.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/double-indexed-kv.js
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$DoubleIndexedKV = class {
    constructor(){
        this.keyToValue = /* @__PURE__ */ new Map();
        this.valueToKey = /* @__PURE__ */ new Map();
    }
    set(key, value) {
        this.keyToValue.set(key, value);
        this.valueToKey.set(value, key);
    }
    getByKey(key) {
        return this.keyToValue.get(key);
    }
    getByValue(value) {
        return this.valueToKey.get(value);
    }
    clear() {
        this.keyToValue.clear();
        this.valueToKey.clear();
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/registry.js
var $5193fce5c5df8bb9$var$Registry = class {
    constructor(generateIdentifier){
        this.generateIdentifier = generateIdentifier;
        this.kv = new $5193fce5c5df8bb9$var$DoubleIndexedKV();
    }
    register(value, identifier) {
        if (this.kv.getByValue(value)) return;
        if (!identifier) identifier = this.generateIdentifier(value);
        this.kv.set(identifier, value);
    }
    clear() {
        this.kv.clear();
    }
    getIdentifier(value) {
        return this.kv.getByValue(value);
    }
    getValue(identifier) {
        return this.kv.getByKey(identifier);
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/class-registry.js
var $5193fce5c5df8bb9$var$ClassRegistry = class extends $5193fce5c5df8bb9$var$Registry {
    constructor(){
        super((c)=>c.name);
        this.classToAllowedProps = /* @__PURE__ */ new Map();
    }
    register(value, options) {
        if (typeof options === "object") {
            if (options.allowProps) this.classToAllowedProps.set(value, options.allowProps);
            super.register(value, options.identifier);
        } else super.register(value, options);
    }
    getAllowedProps(value) {
        return this.classToAllowedProps.get(value);
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/custom-transformer-registry.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/util.js
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$valuesOfObj(record) {
    if ("values" in Object) return Object.values(record);
    const values = [];
    for(const key in record)if (record.hasOwnProperty(key)) values.push(record[key]);
    return values;
}
function $5193fce5c5df8bb9$var$find(record, predicate) {
    const values = $5193fce5c5df8bb9$var$valuesOfObj(record);
    if ("find" in values) return values.find(predicate);
    const valuesNotNever = values;
    for(let i = 0; i < valuesNotNever.length; i++){
        const value = valuesNotNever[i];
        if (predicate(value)) return value;
    }
    return void 0;
}
function $5193fce5c5df8bb9$var$forEach(record, run) {
    Object.entries(record).forEach(([key, value])=>run(value, key));
}
function $5193fce5c5df8bb9$var$includes(arr, value) {
    return arr.indexOf(value) !== -1;
}
function $5193fce5c5df8bb9$var$findArr(record, predicate) {
    for(let i = 0; i < record.length; i++){
        const value = record[i];
        if (predicate(value)) return value;
    }
    return void 0;
}
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/custom-transformer-registry.js
var $5193fce5c5df8bb9$var$CustomTransformerRegistry = class {
    constructor(){
        this.transfomers = {};
    }
    register(transformer) {
        this.transfomers[transformer.name] = transformer;
    }
    findApplicable(v) {
        return $5193fce5c5df8bb9$var$find(this.transfomers, (transformer)=>transformer.isApplicable(v));
    }
    findByName(name) {
        return this.transfomers[name];
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/plainer.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/is.js
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$getType = (payload)=>Object.prototype.toString.call(payload).slice(8, -1);
var $5193fce5c5df8bb9$var$isUndefined = (payload)=>typeof payload === "undefined";
var $5193fce5c5df8bb9$var$isNull = (payload)=>payload === null;
var $5193fce5c5df8bb9$var$isPlainObject2 = (payload)=>{
    if (typeof payload !== "object" || payload === null) return false;
    if (payload === Object.prototype) return false;
    if (Object.getPrototypeOf(payload) === null) return true;
    return Object.getPrototypeOf(payload) === Object.prototype;
};
var $5193fce5c5df8bb9$var$isEmptyObject = (payload)=>$5193fce5c5df8bb9$var$isPlainObject2(payload) && Object.keys(payload).length === 0;
var $5193fce5c5df8bb9$var$isArray = (payload)=>Array.isArray(payload);
var $5193fce5c5df8bb9$var$isString = (payload)=>typeof payload === "string";
var $5193fce5c5df8bb9$var$isNumber = (payload)=>typeof payload === "number" && !isNaN(payload);
var $5193fce5c5df8bb9$var$isBoolean = (payload)=>typeof payload === "boolean";
var $5193fce5c5df8bb9$var$isRegExp = (payload)=>payload instanceof RegExp;
var $5193fce5c5df8bb9$var$isMap = (payload)=>payload instanceof Map;
var $5193fce5c5df8bb9$var$isSet = (payload)=>payload instanceof Set;
var $5193fce5c5df8bb9$var$isSymbol = (payload)=>$5193fce5c5df8bb9$var$getType(payload) === "Symbol";
var $5193fce5c5df8bb9$var$isDate = (payload)=>payload instanceof Date && !isNaN(payload.valueOf());
var $5193fce5c5df8bb9$var$isError = (payload)=>payload instanceof Error;
var $5193fce5c5df8bb9$var$isNaNValue = (payload)=>typeof payload === "number" && isNaN(payload);
var $5193fce5c5df8bb9$var$isPrimitive2 = (payload)=>$5193fce5c5df8bb9$var$isBoolean(payload) || $5193fce5c5df8bb9$var$isNull(payload) || $5193fce5c5df8bb9$var$isUndefined(payload) || $5193fce5c5df8bb9$var$isNumber(payload) || $5193fce5c5df8bb9$var$isString(payload) || $5193fce5c5df8bb9$var$isSymbol(payload);
var $5193fce5c5df8bb9$var$isBigint = (payload)=>typeof payload === "bigint";
var $5193fce5c5df8bb9$var$isInfinite = (payload)=>payload === Infinity || payload === -Infinity;
var $5193fce5c5df8bb9$var$isTypedArray = (payload)=>ArrayBuffer.isView(payload) && !(payload instanceof DataView);
var $5193fce5c5df8bb9$var$isURL = (payload)=>payload instanceof URL;
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/pathstringifier.js
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$escapeKey = (key)=>key.replace(/\./g, "\\.");
var $5193fce5c5df8bb9$var$stringifyPath = (path)=>path.map(String).map($5193fce5c5df8bb9$var$escapeKey).join(".");
var $5193fce5c5df8bb9$var$parsePath = (string)=>{
    const result = [];
    let segment = "";
    for(let i = 0; i < string.length; i++){
        let char = string.charAt(i);
        const isEscapedDot = char === "\\" && string.charAt(i + 1) === ".";
        if (isEscapedDot) {
            segment += ".";
            i++;
            continue;
        }
        const isEndOfSegment = char === ".";
        if (isEndOfSegment) {
            result.push(segment);
            segment = "";
            continue;
        }
        segment += char;
    }
    const lastSegment = segment;
    result.push(lastSegment);
    return result;
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/transformer.js
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$simpleTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $5193fce5c5df8bb9$var$simpleRules = [
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isUndefined, "undefined", ()=>null, ()=>void 0),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isBigint, "bigint", (v)=>v.toString(), (v)=>{
        if (typeof BigInt !== "undefined") return BigInt(v);
        console.error("Please add a BigInt polyfill.");
        return v;
    }),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isDate, "Date", (v)=>v.toISOString(), (v)=>new Date(v)),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isError, "Error", (v, superJson)=>{
        const baseError = {
            name: v.name,
            message: v.message
        };
        superJson.allowedErrorProps.forEach((prop)=>{
            baseError[prop] = v[prop];
        });
        return baseError;
    }, (v, superJson)=>{
        const e = new Error(v.message);
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach((prop)=>{
            e[prop] = v[prop];
        });
        return e;
    }),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isRegExp, "regexp", (v)=>"" + v, (regex)=>{
        const body = regex.slice(1, regex.lastIndexOf("/"));
        const flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
    }),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isSet, "set", // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    (v)=>[
            ...v.values()
        ], (v)=>new Set(v)),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isMap, "map", (v)=>[
            ...v.entries()
        ], (v)=>new Map(v)),
    $5193fce5c5df8bb9$var$simpleTransformation((v)=>$5193fce5c5df8bb9$var$isNaNValue(v) || $5193fce5c5df8bb9$var$isInfinite(v), "number", (v)=>{
        if ($5193fce5c5df8bb9$var$isNaNValue(v)) return "NaN";
        if (v > 0) return "Infinity";
        else return "-Infinity";
    }, Number),
    $5193fce5c5df8bb9$var$simpleTransformation((v)=>v === 0 && 1 / v === -Infinity, "number", ()=>{
        return "-0";
    }, Number),
    $5193fce5c5df8bb9$var$simpleTransformation($5193fce5c5df8bb9$var$isURL, "URL", (v)=>v.toString(), (v)=>new URL(v))
];
function $5193fce5c5df8bb9$var$compositeTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $5193fce5c5df8bb9$var$symbolRule = $5193fce5c5df8bb9$var$compositeTransformation((s, superJson)=>{
    if ($5193fce5c5df8bb9$var$isSymbol(s)) {
        const isRegistered = !!superJson.symbolRegistry.getIdentifier(s);
        return isRegistered;
    }
    return false;
}, (s, superJson)=>{
    const identifier = superJson.symbolRegistry.getIdentifier(s);
    return [
        "symbol",
        identifier
    ];
}, (v)=>v.description, (_, a, superJson)=>{
    const value = superJson.symbolRegistry.getValue(a[1]);
    if (!value) throw new Error("Trying to deserialize unknown symbol");
    return value;
});
var $5193fce5c5df8bb9$var$constructorToName = [
    Int8Array,
    Uint8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    Uint8ClampedArray
].reduce((obj, ctor)=>{
    obj[ctor.name] = ctor;
    return obj;
}, {});
var $5193fce5c5df8bb9$var$typedArrayRule = $5193fce5c5df8bb9$var$compositeTransformation($5193fce5c5df8bb9$var$isTypedArray, (v)=>[
        "typed-array",
        v.constructor.name
    ], (v)=>[
        ...v
    ], (v, a)=>{
    const ctor = $5193fce5c5df8bb9$var$constructorToName[a[1]];
    if (!ctor) throw new Error("Trying to deserialize unknown typed array");
    return new ctor(v);
});
function $5193fce5c5df8bb9$var$isInstanceOfRegisteredClass(potentialClass, superJson) {
    if (potentialClass == null ? void 0 : potentialClass.constructor) {
        const isRegistered = !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
        return isRegistered;
    }
    return false;
}
var $5193fce5c5df8bb9$var$classRule = $5193fce5c5df8bb9$var$compositeTransformation($5193fce5c5df8bb9$var$isInstanceOfRegisteredClass, (clazz, superJson)=>{
    const identifier = superJson.classRegistry.getIdentifier(clazz.constructor);
    return [
        "class",
        identifier
    ];
}, (clazz, superJson)=>{
    const allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
    if (!allowedProps) return {
        ...clazz
    };
    const result = {};
    allowedProps.forEach((prop)=>{
        result[prop] = clazz[prop];
    });
    return result;
}, (v, a, superJson)=>{
    const clazz = superJson.classRegistry.getValue(a[1]);
    if (!clazz) throw new Error(`Trying to deserialize unknown class '${a[1]}' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564`);
    return Object.assign(Object.create(clazz.prototype), v);
});
var $5193fce5c5df8bb9$var$customRule = $5193fce5c5df8bb9$var$compositeTransformation((value, superJson)=>{
    return !!superJson.customTransformerRegistry.findApplicable(value);
}, (value, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findApplicable(value);
    return [
        "custom",
        transformer.name
    ];
}, (value, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findApplicable(value);
    return transformer.serialize(value);
}, (v, a, superJson)=>{
    const transformer = superJson.customTransformerRegistry.findByName(a[1]);
    if (!transformer) throw new Error("Trying to deserialize unknown custom value");
    return transformer.deserialize(v);
});
var $5193fce5c5df8bb9$var$compositeRules = [
    $5193fce5c5df8bb9$var$classRule,
    $5193fce5c5df8bb9$var$symbolRule,
    $5193fce5c5df8bb9$var$customRule,
    $5193fce5c5df8bb9$var$typedArrayRule
];
var $5193fce5c5df8bb9$var$transformValue = (value, superJson)=>{
    const applicableCompositeRule = $5193fce5c5df8bb9$var$findArr($5193fce5c5df8bb9$var$compositeRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableCompositeRule) return {
        value: applicableCompositeRule.transform(value, superJson),
        type: applicableCompositeRule.annotation(value, superJson)
    };
    const applicableSimpleRule = $5193fce5c5df8bb9$var$findArr($5193fce5c5df8bb9$var$simpleRules, (rule)=>rule.isApplicable(value, superJson));
    if (applicableSimpleRule) return {
        value: applicableSimpleRule.transform(value, superJson),
        type: applicableSimpleRule.annotation
    };
    return void 0;
};
var $5193fce5c5df8bb9$var$simpleRulesByAnnotation = {};
$5193fce5c5df8bb9$var$simpleRules.forEach((rule)=>{
    $5193fce5c5df8bb9$var$simpleRulesByAnnotation[rule.annotation] = rule;
});
var $5193fce5c5df8bb9$var$untransformValue = (json, type, superJson)=>{
    if ($5193fce5c5df8bb9$var$isArray(type)) switch(type[0]){
        case "symbol":
            return $5193fce5c5df8bb9$var$symbolRule.untransform(json, type, superJson);
        case "class":
            return $5193fce5c5df8bb9$var$classRule.untransform(json, type, superJson);
        case "custom":
            return $5193fce5c5df8bb9$var$customRule.untransform(json, type, superJson);
        case "typed-array":
            return $5193fce5c5df8bb9$var$typedArrayRule.untransform(json, type, superJson);
        default:
            throw new Error("Unknown transformation: " + type);
    }
    else {
        const transformation = $5193fce5c5df8bb9$var$simpleRulesByAnnotation[type];
        if (!transformation) throw new Error("Unknown transformation: " + type);
        return transformation.untransform(json, superJson);
    }
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/accessDeep.js
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$getNthKey = (value, n)=>{
    if (n > value.size) throw new Error("index out of bounds");
    const keys = value.keys();
    while(n > 0){
        keys.next();
        n--;
    }
    return keys.next().value;
};
function $5193fce5c5df8bb9$var$validatePath(path) {
    if ($5193fce5c5df8bb9$var$includes(path, "__proto__")) throw new Error("__proto__ is not allowed as a property");
    if ($5193fce5c5df8bb9$var$includes(path, "prototype")) throw new Error("prototype is not allowed as a property");
    if ($5193fce5c5df8bb9$var$includes(path, "constructor")) throw new Error("constructor is not allowed as a property");
}
var $5193fce5c5df8bb9$var$getDeep = (object, path)=>{
    $5193fce5c5df8bb9$var$validatePath(path);
    for(let i = 0; i < path.length; i++){
        const key = path[i];
        if ($5193fce5c5df8bb9$var$isSet(object)) object = $5193fce5c5df8bb9$var$getNthKey(object, +key);
        else if ($5193fce5c5df8bb9$var$isMap(object)) {
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $5193fce5c5df8bb9$var$getNthKey(object, row);
            switch(type){
                case "key":
                    object = keyOfRow;
                    break;
                case "value":
                    object = object.get(keyOfRow);
                    break;
            }
        } else object = object[key];
    }
    return object;
};
var $5193fce5c5df8bb9$var$setDeep = (object, path, mapper)=>{
    $5193fce5c5df8bb9$var$validatePath(path);
    if (path.length === 0) return mapper(object);
    let parent = object;
    for(let i = 0; i < path.length - 1; i++){
        const key = path[i];
        if ($5193fce5c5df8bb9$var$isArray(parent)) {
            const index = +key;
            parent = parent[index];
        } else if ($5193fce5c5df8bb9$var$isPlainObject2(parent)) parent = parent[key];
        else if ($5193fce5c5df8bb9$var$isSet(parent)) {
            const row = +key;
            parent = $5193fce5c5df8bb9$var$getNthKey(parent, row);
        } else if ($5193fce5c5df8bb9$var$isMap(parent)) {
            const isEnd = i === path.length - 2;
            if (isEnd) break;
            const row = +key;
            const type = +path[++i] === 0 ? "key" : "value";
            const keyOfRow = $5193fce5c5df8bb9$var$getNthKey(parent, row);
            switch(type){
                case "key":
                    parent = keyOfRow;
                    break;
                case "value":
                    parent = parent.get(keyOfRow);
                    break;
            }
        }
    }
    const lastKey = path[path.length - 1];
    if ($5193fce5c5df8bb9$var$isArray(parent)) parent[+lastKey] = mapper(parent[+lastKey]);
    else if ($5193fce5c5df8bb9$var$isPlainObject2(parent)) parent[lastKey] = mapper(parent[lastKey]);
    if ($5193fce5c5df8bb9$var$isSet(parent)) {
        const oldValue = $5193fce5c5df8bb9$var$getNthKey(parent, +lastKey);
        const newValue = mapper(oldValue);
        if (oldValue !== newValue) {
            parent.delete(oldValue);
            parent.add(newValue);
        }
    }
    if ($5193fce5c5df8bb9$var$isMap(parent)) {
        const row = +path[path.length - 2];
        const keyToRow = $5193fce5c5df8bb9$var$getNthKey(parent, row);
        const type = +lastKey === 0 ? "key" : "value";
        switch(type){
            case "key":
                {
                    const newKey = mapper(keyToRow);
                    parent.set(newKey, parent.get(keyToRow));
                    if (newKey !== keyToRow) parent.delete(keyToRow);
                    break;
                }
            case "value":
                parent.set(keyToRow, mapper(parent.get(keyToRow)));
                break;
        }
    }
    return object;
};
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/plainer.js
function $5193fce5c5df8bb9$var$traverse(tree, walker2, origin = []) {
    if (!tree) return;
    if (!$5193fce5c5df8bb9$var$isArray(tree)) {
        $5193fce5c5df8bb9$var$forEach(tree, (subtree, key)=>$5193fce5c5df8bb9$var$traverse(subtree, walker2, [
                ...origin,
                ...$5193fce5c5df8bb9$var$parsePath(key)
            ]));
        return;
    }
    const [nodeValue, children] = tree;
    if (children) $5193fce5c5df8bb9$var$forEach(children, (child, key)=>{
        $5193fce5c5df8bb9$var$traverse(child, walker2, [
            ...origin,
            ...$5193fce5c5df8bb9$var$parsePath(key)
        ]);
    });
    walker2(nodeValue, origin);
}
function $5193fce5c5df8bb9$var$applyValueAnnotations(plain, annotations, superJson) {
    $5193fce5c5df8bb9$var$traverse(annotations, (type, path)=>{
        plain = $5193fce5c5df8bb9$var$setDeep(plain, path, (v)=>$5193fce5c5df8bb9$var$untransformValue(v, type, superJson));
    });
    return plain;
}
function $5193fce5c5df8bb9$var$applyReferentialEqualityAnnotations(plain, annotations) {
    function apply(identicalPaths, path) {
        const object = $5193fce5c5df8bb9$var$getDeep(plain, $5193fce5c5df8bb9$var$parsePath(path));
        identicalPaths.map($5193fce5c5df8bb9$var$parsePath).forEach((identicalObjectPath)=>{
            plain = $5193fce5c5df8bb9$var$setDeep(plain, identicalObjectPath, ()=>object);
        });
    }
    if ($5193fce5c5df8bb9$var$isArray(annotations)) {
        const [root, other] = annotations;
        root.forEach((identicalPath)=>{
            plain = $5193fce5c5df8bb9$var$setDeep(plain, $5193fce5c5df8bb9$var$parsePath(identicalPath), ()=>plain);
        });
        if (other) $5193fce5c5df8bb9$var$forEach(other, apply);
    } else $5193fce5c5df8bb9$var$forEach(annotations, apply);
    return plain;
}
var $5193fce5c5df8bb9$var$isDeep = (object, superJson)=>$5193fce5c5df8bb9$var$isPlainObject2(object) || $5193fce5c5df8bb9$var$isArray(object) || $5193fce5c5df8bb9$var$isMap(object) || $5193fce5c5df8bb9$var$isSet(object) || $5193fce5c5df8bb9$var$isInstanceOfRegisteredClass(object, superJson);
function $5193fce5c5df8bb9$var$addIdentity(object, path, identities) {
    const existingSet = identities.get(object);
    if (existingSet) existingSet.push(path);
    else identities.set(object, [
        path
    ]);
}
function $5193fce5c5df8bb9$var$generateReferentialEqualityAnnotations(identitites, dedupe) {
    const result = {};
    let rootEqualityPaths = void 0;
    identitites.forEach((paths)=>{
        if (paths.length <= 1) return;
        if (!dedupe) paths = paths.map((path)=>path.map(String)).sort((a, b)=>a.length - b.length);
        const [representativePath, ...identicalPaths] = paths;
        if (representativePath.length === 0) rootEqualityPaths = identicalPaths.map($5193fce5c5df8bb9$var$stringifyPath);
        else result[$5193fce5c5df8bb9$var$stringifyPath(representativePath)] = identicalPaths.map($5193fce5c5df8bb9$var$stringifyPath);
    });
    if (rootEqualityPaths) {
        if ($5193fce5c5df8bb9$var$isEmptyObject(result)) return [
            rootEqualityPaths
        ];
        else return [
            rootEqualityPaths,
            result
        ];
    } else return $5193fce5c5df8bb9$var$isEmptyObject(result) ? void 0 : result;
}
var $5193fce5c5df8bb9$var$walker = (object, identities, superJson, dedupe, path = [], objectsInThisPath = [], seenObjects = /* @__PURE__ */ new Map())=>{
    var _a25;
    const primitive = $5193fce5c5df8bb9$var$isPrimitive2(object);
    if (!primitive) {
        $5193fce5c5df8bb9$var$addIdentity(object, path, identities);
        const seen = seenObjects.get(object);
        if (seen) return dedupe ? {
            transformedValue: null
        } : seen;
    }
    if (!$5193fce5c5df8bb9$var$isDeep(object, superJson)) {
        const transformed2 = $5193fce5c5df8bb9$var$transformValue(object, superJson);
        const result2 = transformed2 ? {
            transformedValue: transformed2.value,
            annotations: [
                transformed2.type
            ]
        } : {
            transformedValue: object
        };
        if (!primitive) seenObjects.set(object, result2);
        return result2;
    }
    if ($5193fce5c5df8bb9$var$includes(objectsInThisPath, object)) return {
        transformedValue: null
    };
    const transformationResult = $5193fce5c5df8bb9$var$transformValue(object, superJson);
    const transformed = (_a25 = transformationResult == null ? void 0 : transformationResult.value) != null ? _a25 : object;
    const transformedValue = $5193fce5c5df8bb9$var$isArray(transformed) ? [] : {};
    const innerAnnotations = {};
    $5193fce5c5df8bb9$var$forEach(transformed, (value, index)=>{
        if (index === "__proto__" || index === "constructor" || index === "prototype") throw new Error(`Detected property ${index}. This is a prototype pollution risk, please remove it from your object.`);
        const recursiveResult = $5193fce5c5df8bb9$var$walker(value, identities, superJson, dedupe, [
            ...path,
            index
        ], [
            ...objectsInThisPath,
            object
        ], seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if ($5193fce5c5df8bb9$var$isArray(recursiveResult.annotations)) innerAnnotations[index] = recursiveResult.annotations;
        else if ($5193fce5c5df8bb9$var$isPlainObject2(recursiveResult.annotations)) $5193fce5c5df8bb9$var$forEach(recursiveResult.annotations, (tree, key)=>{
            innerAnnotations[$5193fce5c5df8bb9$var$escapeKey(index) + "." + key] = tree;
        });
    });
    const result = $5193fce5c5df8bb9$var$isEmptyObject(innerAnnotations) ? {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type
        ] : void 0
    } : {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type,
            innerAnnotations
        ] : innerAnnotations
    };
    if (!primitive) seenObjects.set(object, result);
    return result;
};
// ../../node_modules/.pnpm/copy-anything@3.0.5/node_modules/copy-anything/dist/index.js
$5193fce5c5df8bb9$var$init_esm_shims();
// ../../node_modules/.pnpm/is-what@4.1.16/node_modules/is-what/dist/index.js
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$getType2(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
function $5193fce5c5df8bb9$var$isArray2(payload) {
    return $5193fce5c5df8bb9$var$getType2(payload) === "Array";
}
function $5193fce5c5df8bb9$var$isPlainObject3(payload) {
    if ($5193fce5c5df8bb9$var$getType2(payload) !== "Object") return false;
    const prototype = Object.getPrototypeOf(payload);
    return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function $5193fce5c5df8bb9$var$isNull2(payload) {
    return $5193fce5c5df8bb9$var$getType2(payload) === "Null";
}
function $5193fce5c5df8bb9$var$isOneOf(a, b, c, d, e) {
    return (value)=>a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
}
function $5193fce5c5df8bb9$var$isUndefined2(payload) {
    return $5193fce5c5df8bb9$var$getType2(payload) === "Undefined";
}
var $5193fce5c5df8bb9$var$isNullOrUndefined = $5193fce5c5df8bb9$var$isOneOf($5193fce5c5df8bb9$var$isNull2, $5193fce5c5df8bb9$var$isUndefined2);
// ../../node_modules/.pnpm/copy-anything@3.0.5/node_modules/copy-anything/dist/index.js
function $5193fce5c5df8bb9$var$assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
    const propType = ({}).propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (includeNonenumerable && propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function $5193fce5c5df8bb9$var$copy(target22, options = {}) {
    if ($5193fce5c5df8bb9$var$isArray2(target22)) return target22.map((item)=>$5193fce5c5df8bb9$var$copy(item, options));
    if (!$5193fce5c5df8bb9$var$isPlainObject3(target22)) return target22;
    const props = Object.getOwnPropertyNames(target22);
    const symbols = Object.getOwnPropertySymbols(target22);
    return [
        ...props,
        ...symbols
    ].reduce((carry, key)=>{
        if ($5193fce5c5df8bb9$var$isArray2(options.props) && !options.props.includes(key)) return carry;
        const val = target22[key];
        const newVal = $5193fce5c5df8bb9$var$copy(val, options);
        $5193fce5c5df8bb9$var$assignProp(carry, key, newVal, target22, options.nonenumerable);
        return carry;
    }, {});
}
// ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/index.js
var $5193fce5c5df8bb9$var$SuperJSON = class {
    /**
   * @param dedupeReferentialEqualities  If true, SuperJSON will make sure only one instance of referentially equal objects are serialized and the rest are replaced with `null`.
   */ constructor({ dedupe: dedupe = false } = {}){
        this.classRegistry = new $5193fce5c5df8bb9$var$ClassRegistry();
        this.symbolRegistry = new $5193fce5c5df8bb9$var$Registry((s)=>{
            var _a25;
            return (_a25 = s.description) != null ? _a25 : "";
        });
        this.customTransformerRegistry = new $5193fce5c5df8bb9$var$CustomTransformerRegistry();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
    }
    serialize(object) {
        const identities = /* @__PURE__ */ new Map();
        const output = $5193fce5c5df8bb9$var$walker(object, identities, this, this.dedupe);
        const res = {
            json: output.transformedValue
        };
        if (output.annotations) res.meta = {
            ...res.meta,
            values: output.annotations
        };
        const equalityAnnotations = $5193fce5c5df8bb9$var$generateReferentialEqualityAnnotations(identities, this.dedupe);
        if (equalityAnnotations) res.meta = {
            ...res.meta,
            referentialEqualities: equalityAnnotations
        };
        return res;
    }
    deserialize(payload) {
        const { json: json, meta: meta } = payload;
        let result = $5193fce5c5df8bb9$var$copy(json);
        if (meta == null ? void 0 : meta.values) result = $5193fce5c5df8bb9$var$applyValueAnnotations(result, meta.values, this);
        if (meta == null ? void 0 : meta.referentialEqualities) result = $5193fce5c5df8bb9$var$applyReferentialEqualityAnnotations(result, meta.referentialEqualities);
        return result;
    }
    stringify(object) {
        return JSON.stringify(this.serialize(object));
    }
    parse(string) {
        return this.deserialize(JSON.parse(string));
    }
    registerClass(v, options) {
        this.classRegistry.register(v, options);
    }
    registerSymbol(v, identifier) {
        this.symbolRegistry.register(v, identifier);
    }
    registerCustom(transformer, name) {
        this.customTransformerRegistry.register({
            name: name,
            ...transformer
        });
    }
    allowErrorProps(...props) {
        this.allowedErrorProps.push(...props);
    }
};
$5193fce5c5df8bb9$var$SuperJSON.defaultInstance = new $5193fce5c5df8bb9$var$SuperJSON();
$5193fce5c5df8bb9$var$SuperJSON.serialize = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.serialize.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.deserialize = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.deserialize.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.stringify = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.stringify.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.parse = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.parse.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.registerClass = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.registerClass.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.registerSymbol = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.registerSymbol.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.registerCustom = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.registerCustom.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
$5193fce5c5df8bb9$var$SuperJSON.allowErrorProps = $5193fce5c5df8bb9$var$SuperJSON.defaultInstance.allowErrorProps.bind($5193fce5c5df8bb9$var$SuperJSON.defaultInstance);
var $5193fce5c5df8bb9$var$serialize = $5193fce5c5df8bb9$var$SuperJSON.serialize;
var $5193fce5c5df8bb9$var$deserialize = $5193fce5c5df8bb9$var$SuperJSON.deserialize;
var $5193fce5c5df8bb9$var$stringify = $5193fce5c5df8bb9$var$SuperJSON.stringify;
var $5193fce5c5df8bb9$var$parse = $5193fce5c5df8bb9$var$SuperJSON.parse;
var $5193fce5c5df8bb9$var$registerClass = $5193fce5c5df8bb9$var$SuperJSON.registerClass;
var $5193fce5c5df8bb9$var$registerCustom = $5193fce5c5df8bb9$var$SuperJSON.registerCustom;
var $5193fce5c5df8bb9$var$registerSymbol = $5193fce5c5df8bb9$var$SuperJSON.registerSymbol;
var $5193fce5c5df8bb9$var$allowErrorProps = $5193fce5c5df8bb9$var$SuperJSON.allowErrorProps;
// src/messaging/presets/broadcast-channel/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY = "__devtools-kit-broadcast-messaging-event-key__";
// src/messaging/presets/broadcast-channel/index.ts
var $5193fce5c5df8bb9$var$BROADCAST_CHANNEL_NAME = "__devtools-kit:broadcast-channel__";
function $5193fce5c5df8bb9$var$createBroadcastChannel() {
    const channel = new BroadcastChannel($5193fce5c5df8bb9$var$BROADCAST_CHANNEL_NAME);
    return {
        post: (data)=>{
            channel.postMessage($5193fce5c5df8bb9$var$SuperJSON.stringify({
                event: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY,
                data: data
            }));
        },
        on: (handler)=>{
            channel.onmessage = (event)=>{
                const parsed = $5193fce5c5df8bb9$var$SuperJSON.parse(event.data);
                if (parsed.event === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY) handler(parsed.data);
            };
        }
    };
}
// src/messaging/presets/electron/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/electron/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/electron/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__ELECTRON_CLIENT_CONTEXT__ = "electron:client-context";
var $5193fce5c5df8bb9$var$__ELECTRON_RPOXY_CONTEXT__ = "electron:proxy-context";
var $5193fce5c5df8bb9$var$__ELECTRON_SERVER_CONTEXT__ = "electron:server-context";
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__ = {
    // client
    CLIENT_TO_PROXY: "client->proxy",
    // on: proxy->client
    // proxy
    PROXY_TO_CLIENT: "proxy->client",
    // on: server->proxy
    PROXY_TO_SERVER: "proxy->server",
    // on: client->proxy
    // server
    SERVER_TO_PROXY: "server->proxy"
};
function $5193fce5c5df8bb9$var$getElectronClientContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_CLIENT_CONTEXT__];
}
function $5193fce5c5df8bb9$export$2837faaf25ee2c9a(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_CLIENT_CONTEXT__] = context;
}
function $5193fce5c5df8bb9$var$getElectronProxyContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_RPOXY_CONTEXT__];
}
function $5193fce5c5df8bb9$export$f4b34d15f9836c97(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_RPOXY_CONTEXT__] = context;
}
function $5193fce5c5df8bb9$var$getElectronServerContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_SERVER_CONTEXT__];
}
function $5193fce5c5df8bb9$export$d8c81043a9a1bbbe(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__ELECTRON_SERVER_CONTEXT__] = context;
}
// src/messaging/presets/electron/client.ts
function $5193fce5c5df8bb9$var$createElectronClientChannel() {
    const socket = $5193fce5c5df8bb9$var$getElectronClientContext();
    return {
        post: (data)=>{
            socket.emit($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, $5193fce5c5df8bb9$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, (e)=>{
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(e));
            });
        }
    };
}
// src/messaging/presets/electron/proxy.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createElectronProxyChannel() {
    const socket = $5193fce5c5df8bb9$var$getElectronProxyContext();
    return {
        post: (data)=>{},
        on: (handler)=>{
            socket.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, (data)=>{
                socket.broadcast.emit($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, data);
            });
            socket.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, (data)=>{
                socket.broadcast.emit($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, data);
            });
        }
    };
}
// src/messaging/presets/electron/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createElectronServerChannel() {
    const socket = $5193fce5c5df8bb9$var$getElectronServerContext();
    return {
        post: (data)=>{
            socket.emit($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, $5193fce5c5df8bb9$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            socket.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, (data)=>{
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(data));
            });
        }
    };
}
// src/messaging/presets/extension/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/extension/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/extension/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__EXTENSION_CLIENT_CONTEXT__ = "electron:client-context";
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__ = {
    // client
    CLIENT_TO_PROXY: "client->proxy",
    // on: proxy->client
    // proxy
    PROXY_TO_CLIENT: "proxy->client",
    // on: server->proxy
    PROXY_TO_SERVER: "proxy->server",
    // on: client->proxy
    // server
    SERVER_TO_PROXY: "server->proxy"
};
function $5193fce5c5df8bb9$export$6c3de6c2be1b2806() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__EXTENSION_CLIENT_CONTEXT__];
}
function $5193fce5c5df8bb9$export$31a9a778785defb(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__EXTENSION_CLIENT_CONTEXT__] = context;
}
// src/messaging/presets/extension/client.ts
function $5193fce5c5df8bb9$var$createExtensionClientChannel() {
    let disconnected = false;
    let port = null;
    let reconnectTimer = null;
    let onMessageHandler = null;
    function connect() {
        try {
            clearTimeout(reconnectTimer);
            port = chrome.runtime.connect({
                name: `${chrome.devtools.inspectedWindow.tabId}`
            });
            $5193fce5c5df8bb9$export$31a9a778785defb(port);
            disconnected = false;
            port == null || port.onMessage.addListener(onMessageHandler);
            port.onDisconnect.addListener(()=>{
                disconnected = true;
                port == null || port.onMessage.removeListener(onMessageHandler);
                reconnectTimer = setTimeout(connect, 1e3);
            });
        } catch (e) {
            disconnected = true;
        }
    }
    connect();
    return {
        post: (data)=>{
            if (disconnected) return;
            port == null || port.postMessage($5193fce5c5df8bb9$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            onMessageHandler = (data)=>{
                if (disconnected) return;
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(data));
            };
            port == null || port.onMessage.addListener(onMessageHandler);
        }
    };
}
// src/messaging/presets/extension/proxy.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createExtensionProxyChannel() {
    const port = chrome.runtime.connect({
        name: "content-script"
    });
    function sendMessageToUserApp(payload) {
        window.postMessage({
            source: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER,
            payload: payload
        }, "*");
    }
    function sendMessageToDevToolsClient(e) {
        if (e.data && e.data.source === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY) try {
            port.postMessage(e.data.payload);
        } catch (e2) {}
    }
    port.onMessage.addListener(sendMessageToUserApp);
    window.addEventListener("message", sendMessageToDevToolsClient);
    port.onDisconnect.addListener(()=>{
        window.removeEventListener("message", sendMessageToDevToolsClient);
        sendMessageToUserApp($5193fce5c5df8bb9$var$SuperJSON.stringify({
            event: "shutdown"
        }));
    });
    sendMessageToUserApp($5193fce5c5df8bb9$var$SuperJSON.stringify({
        event: "init"
    }));
    return {
        post: (data)=>{},
        on: (handler)=>{}
    };
}
// src/messaging/presets/extension/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createExtensionServerChannel() {
    return {
        post: (data)=>{
            window.postMessage({
                source: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY,
                payload: $5193fce5c5df8bb9$var$SuperJSON.stringify(data)
            }, "*");
        },
        on: (handler)=>{
            const listener = (event)=>{
                if (event.data.source === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER && event.data.payload) handler($5193fce5c5df8bb9$var$SuperJSON.parse(event.data.payload));
            };
            window.addEventListener("message", listener);
            return ()=>{
                window.removeEventListener("message", listener);
            };
        }
    };
}
// src/messaging/presets/iframe/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/iframe/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/iframe/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY = "__devtools-kit-iframe-messaging-event-key__";
var $5193fce5c5df8bb9$var$__IFRAME_SERVER_CONTEXT__ = "iframe:server-context";
function $5193fce5c5df8bb9$var$getIframeServerContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__IFRAME_SERVER_CONTEXT__];
}
function $5193fce5c5df8bb9$export$918b6d08f99ca1d5(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__IFRAME_SERVER_CONTEXT__] = context;
}
// src/messaging/presets/iframe/client.ts
function $5193fce5c5df8bb9$var$createIframeClientChannel() {
    if (!(0, $i0cUC.isBrowser)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>window.parent.postMessage($5193fce5c5df8bb9$var$SuperJSON.stringify({
                event: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*"),
        on: (handler)=>window.addEventListener("message", (event)=>{
                try {
                    const parsed = $5193fce5c5df8bb9$var$SuperJSON.parse(event.data);
                    if (event.source === window.parent && parsed.event === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY) handler(parsed.data);
                } catch (e) {}
            })
    };
}
// src/messaging/presets/iframe/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createIframeServerChannel() {
    if (!(0, $i0cUC.isBrowser)) return {
        post: (data)=>{},
        on: (handler)=>{}
    };
    return {
        post: (data)=>{
            var _a25;
            const iframe = $5193fce5c5df8bb9$var$getIframeServerContext();
            (_a25 = iframe == null ? void 0 : iframe.contentWindow) == null || _a25.postMessage($5193fce5c5df8bb9$var$SuperJSON.stringify({
                event: $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*");
        },
        on: (handler)=>{
            window.addEventListener("message", (event)=>{
                const iframe = $5193fce5c5df8bb9$var$getIframeServerContext();
                try {
                    const parsed = $5193fce5c5df8bb9$var$SuperJSON.parse(event.data);
                    if (event.source === (iframe == null ? void 0 : iframe.contentWindow) && parsed.event === $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY) handler(parsed.data);
                } catch (e) {}
            });
        }
    };
}
// src/messaging/presets/vite/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/vite/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/vite/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY = "__devtools-kit-vite-messaging-event-key__";
var $5193fce5c5df8bb9$var$__VITE_CLIENT_CONTEXT__ = "vite:client-context";
var $5193fce5c5df8bb9$var$__VITE_SERVER_CONTEXT__ = "vite:server-context";
function $5193fce5c5df8bb9$var$getViteClientContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__VITE_CLIENT_CONTEXT__];
}
function $5193fce5c5df8bb9$export$8559d72d41937efd(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__VITE_CLIENT_CONTEXT__] = context;
}
function $5193fce5c5df8bb9$var$getViteServerContext() {
    return (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__VITE_SERVER_CONTEXT__];
}
function $5193fce5c5df8bb9$export$4c32fe701137877e(context) {
    (0, $i0cUC.target)[$5193fce5c5df8bb9$var$__VITE_SERVER_CONTEXT__] = context;
}
// src/messaging/presets/vite/client.ts
function $5193fce5c5df8bb9$var$createViteClientChannel() {
    const client = $5193fce5c5df8bb9$var$getViteClientContext();
    return {
        post: (data)=>{
            client == null || client.send($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $5193fce5c5df8bb9$var$SuperJSON.stringify(data));
        },
        on: (handler)=>{
            client == null || client.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(event));
            });
        }
    };
}
// src/messaging/presets/vite/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$createViteServerChannel() {
    var _a25;
    const viteServer = $5193fce5c5df8bb9$var$getViteServerContext();
    const ws = (_a25 = viteServer.hot) != null ? _a25 : viteServer.ws;
    return {
        post: (data)=>ws == null ? void 0 : ws.send($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $5193fce5c5df8bb9$var$SuperJSON.stringify(data)),
        on: (handler)=>ws == null ? void 0 : ws.on($5193fce5c5df8bb9$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, (event)=>{
                handler($5193fce5c5df8bb9$var$SuperJSON.parse(event));
            })
    };
}
// src/messaging/presets/ws/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/ws/client.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/ws/context.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/presets/ws/server.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/messaging/index.ts
var $5193fce5c5df8bb9$var$_a19, $5193fce5c5df8bb9$var$_b19;
($5193fce5c5df8bb9$var$_b19 = ($5193fce5c5df8bb9$var$_a19 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) != null ? $5193fce5c5df8bb9$var$_b19 : $5193fce5c5df8bb9$var$_a19.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = [];
var $5193fce5c5df8bb9$var$_a20, $5193fce5c5df8bb9$var$_b20;
($5193fce5c5df8bb9$var$_b20 = ($5193fce5c5df8bb9$var$_a20 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) != null ? $5193fce5c5df8bb9$var$_b20 : $5193fce5c5df8bb9$var$_a20.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null;
var $5193fce5c5df8bb9$var$_a21, $5193fce5c5df8bb9$var$_b21;
($5193fce5c5df8bb9$var$_b21 = ($5193fce5c5df8bb9$var$_a21 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_RPC_SERVER__) != null ? $5193fce5c5df8bb9$var$_b21 : $5193fce5c5df8bb9$var$_a21.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null;
var $5193fce5c5df8bb9$var$_a22, $5193fce5c5df8bb9$var$_b22;
($5193fce5c5df8bb9$var$_b22 = ($5193fce5c5df8bb9$var$_a22 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) != null ? $5193fce5c5df8bb9$var$_b22 : $5193fce5c5df8bb9$var$_a22.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null;
var $5193fce5c5df8bb9$var$_a23, $5193fce5c5df8bb9$var$_b23;
($5193fce5c5df8bb9$var$_b23 = ($5193fce5c5df8bb9$var$_a23 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) != null ? $5193fce5c5df8bb9$var$_b23 : $5193fce5c5df8bb9$var$_a23.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null;
var $5193fce5c5df8bb9$var$_a24, $5193fce5c5df8bb9$var$_b24;
($5193fce5c5df8bb9$var$_b24 = ($5193fce5c5df8bb9$var$_a24 = (0, $i0cUC.target)).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) != null ? $5193fce5c5df8bb9$var$_b24 : $5193fce5c5df8bb9$var$_a24.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null;
function $5193fce5c5df8bb9$var$setRpcClientToGlobal(rpc) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = rpc;
}
function $5193fce5c5df8bb9$export$7f98be55f66c4a0d(rpc) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_RPC_SERVER__ = rpc;
}
function $5193fce5c5df8bb9$export$9362d59e25b9feb1() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_RPC_CLIENT__;
}
function $5193fce5c5df8bb9$export$380718822fedc343() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_RPC_SERVER__;
}
function $5193fce5c5df8bb9$export$5f8b48d38df9666a(rpc) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = rpc;
}
function $5193fce5c5df8bb9$export$5105f0908e5b2002(rpc) {
    (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = rpc;
}
function $5193fce5c5df8bb9$export$c7310d0d7eeaac08() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__;
}
function $5193fce5c5df8bb9$export$97b242d29756c723() {
    return (0, $i0cUC.target).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__;
}
function $5193fce5c5df8bb9$var$getChannel(preset, host = "client") {
    const channel = {
        iframe: {
            client: $5193fce5c5df8bb9$var$createIframeClientChannel,
            server: $5193fce5c5df8bb9$var$createIframeServerChannel
        }[host],
        electron: {
            client: $5193fce5c5df8bb9$var$createElectronClientChannel,
            proxy: $5193fce5c5df8bb9$var$createElectronProxyChannel,
            server: $5193fce5c5df8bb9$var$createElectronServerChannel
        }[host],
        vite: {
            client: $5193fce5c5df8bb9$var$createViteClientChannel,
            server: $5193fce5c5df8bb9$var$createViteServerChannel
        }[host],
        broadcast: {
            client: $5193fce5c5df8bb9$var$createBroadcastChannel,
            server: $5193fce5c5df8bb9$var$createBroadcastChannel
        }[host],
        extension: {
            client: $5193fce5c5df8bb9$var$createExtensionClientChannel,
            proxy: $5193fce5c5df8bb9$var$createExtensionProxyChannel,
            server: $5193fce5c5df8bb9$var$createExtensionServerChannel
        }[host]
    }[preset];
    return channel();
}
function $5193fce5c5df8bb9$export$9c13c20c639717e6(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $5193fce5c5df8bb9$var$getChannel(preset) : _channel;
    const rpc = (0, $enkGC.createBirpc)(functions, {
        ..._options,
        ...channel,
        timeout: -1
    });
    if (preset === "vite") {
        $5193fce5c5df8bb9$export$5f8b48d38df9666a(rpc);
        return;
    }
    $5193fce5c5df8bb9$var$setRpcClientToGlobal(rpc);
    return rpc;
}
function $5193fce5c5df8bb9$export$fbf8e1689a053c1c(functions, options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $5193fce5c5df8bb9$var$getChannel(preset, "server") : _channel;
    const rpcServer = $5193fce5c5df8bb9$export$380718822fedc343();
    if (!rpcServer) {
        const group = (0, $enkGC.createBirpcGroup)(functions, [
            channel
        ], {
            ..._options,
            timeout: -1
        });
        if (preset === "vite") {
            $5193fce5c5df8bb9$export$5105f0908e5b2002(group);
            return;
        }
        $5193fce5c5df8bb9$export$7f98be55f66c4a0d(group);
    } else rpcServer.updateChannels((channels)=>{
        channels.push(channel);
    });
}
function $5193fce5c5df8bb9$export$490df4aa0eb47722(options = {}) {
    const { channel: _channel, options: _options, preset: preset } = options;
    const channel = preset ? $5193fce5c5df8bb9$var$getChannel(preset, "proxy") : _channel;
    return (0, $enkGC.createBirpc)({}, {
        ..._options,
        ...channel,
        timeout: -1
    });
}
// src/shared/index.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/shared/env.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/shared/time.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/shared/util.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/replacer.ts
$5193fce5c5df8bb9$var$init_esm_shims();
// src/core/component/state/custom.ts
$5193fce5c5df8bb9$var$init_esm_shims();
function $5193fce5c5df8bb9$var$getFunctionDetails(func) {
    let string = "";
    let matches = null;
    try {
        string = Function.prototype.toString.call(func);
        matches = String.prototype.match.call(string, /\([\s\S]*?\)/);
    } catch (e) {}
    const match = matches && matches[0];
    const args = typeof match === "string" ? match : "(?)";
    const name = typeof func.name === "string" ? func.name : "";
    return {
        _custom: {
            type: "function",
            displayText: `<span style="opacity:.8;margin-right:5px;">function</span> <span style="white-space:nowrap;">${$5193fce5c5df8bb9$export$4e7f196112fea3c5(name)}${args}</span>`,
            tooltipText: string.trim() ? `<pre>${string}</pre>` : null
        }
    };
}
function $5193fce5c5df8bb9$var$getBigIntDetails(val) {
    const stringifiedBigInt = BigInt.prototype.toString.call(val);
    return {
        _custom: {
            type: "bigint",
            displayText: `BigInt(${stringifiedBigInt})`,
            value: stringifiedBigInt
        }
    };
}
function $5193fce5c5df8bb9$var$getDateDetails(val) {
    const date = new Date(val.getTime());
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return {
        _custom: {
            type: "date",
            displayText: Date.prototype.toString.call(val),
            value: date.toISOString().slice(0, -1)
        }
    };
}
function $5193fce5c5df8bb9$var$getMapDetails(val) {
    const list = Object.fromEntries(val);
    return {
        _custom: {
            type: "map",
            displayText: "Map",
            value: list,
            readOnly: true,
            fields: {
                abstract: true
            }
        }
    };
}
function $5193fce5c5df8bb9$var$getSetDetails(val) {
    const list = Array.from(val);
    return {
        _custom: {
            type: "set",
            displayText: `Set[${list.length}]`,
            value: list,
            readOnly: true
        }
    };
}
function $5193fce5c5df8bb9$var$getCaughtGetters(store) {
    const getters = {};
    const origGetters = store.getters || {};
    const keys = Object.keys(origGetters);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        Object.defineProperty(getters, key, {
            enumerable: true,
            get: ()=>{
                try {
                    return origGetters[key];
                } catch (e) {
                    return e;
                }
            }
        });
    }
    return getters;
}
function $5193fce5c5df8bb9$var$reduceStateList(list) {
    if (!list.length) return void 0;
    return list.reduce((map, item)=>{
        const key = item.type || "data";
        const obj = map[key] = map[key] || {};
        obj[item.key] = item.value;
        return map;
    }, {});
}
function $5193fce5c5df8bb9$var$namedNodeMapToObject(map) {
    const result = {};
    const l = map.length;
    for(let i = 0; i < l; i++){
        const node = map.item(i);
        result[node.name] = node.value;
    }
    return result;
}
function $5193fce5c5df8bb9$var$getStoreDetails(store) {
    return {
        _custom: {
            type: "store",
            displayText: "Store",
            value: {
                state: store.state,
                getters: $5193fce5c5df8bb9$var$getCaughtGetters(store)
            },
            fields: {
                abstract: true
            }
        }
    };
}
function $5193fce5c5df8bb9$var$getRouterDetails(router) {
    return {
        _custom: {
            type: "router",
            displayText: "VueRouter",
            value: {
                options: router.options,
                currentRoute: router.currentRoute
            },
            fields: {
                abstract: true
            }
        }
    };
}
function $5193fce5c5df8bb9$var$getInstanceDetails(instance) {
    if (instance._) instance = instance._;
    const state = $5193fce5c5df8bb9$var$processInstanceState(instance);
    return {
        _custom: {
            type: "component",
            id: instance.__VUE_DEVTOOLS_NEXT_UID__,
            displayText: $5193fce5c5df8bb9$var$getInstanceName(instance),
            tooltipText: "Component instance",
            value: $5193fce5c5df8bb9$var$reduceStateList(state),
            fields: {
                abstract: true
            }
        }
    };
}
function $5193fce5c5df8bb9$var$getComponentDefinitionDetails(definition) {
    let display = $5193fce5c5df8bb9$var$getComponentName(definition);
    if (display) {
        if (definition.name && definition.__file) display += ` <span>(${definition.__file})</span>`;
    } else display = "<i>Unknown Component</i>";
    return {
        _custom: {
            type: "component-definition",
            displayText: display,
            tooltipText: "Component definition",
            ...definition.__file ? {
                file: definition.__file
            } : {}
        }
    };
}
function $5193fce5c5df8bb9$var$getHTMLElementDetails(value) {
    try {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="opacity-30">&lt;</span><span class="text-blue-500">${value.tagName.toLowerCase()}</span><span class="opacity-30">&gt;</span>`,
                value: $5193fce5c5df8bb9$var$namedNodeMapToObject(value.attributes)
            }
        };
    } catch (e) {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: `<span class="text-blue-500">${String(value)}</span>`
            }
        };
    }
}
function $5193fce5c5df8bb9$var$tryGetRefValue(ref) {
    if ($5193fce5c5df8bb9$var$ensurePropertyExists(ref, "_value", true)) return ref._value;
    if ($5193fce5c5df8bb9$var$ensurePropertyExists(ref, "value", true)) return ref.value;
}
function $5193fce5c5df8bb9$var$getObjectDetails(object) {
    var _a25, _b25, _c, _d;
    const info = $5193fce5c5df8bb9$var$getSetupStateType(object);
    const isState = info.ref || info.computed || info.reactive;
    if (isState) {
        const stateTypeName = info.computed ? "Computed" : info.ref ? "Ref" : info.reactive ? "Reactive" : null;
        const value = $5193fce5c5df8bb9$var$toRaw2(info.reactive ? object : $5193fce5c5df8bb9$var$tryGetRefValue(object));
        const raw = $5193fce5c5df8bb9$var$ensurePropertyExists(object, "effect") ? ((_b25 = (_a25 = object.effect) == null ? void 0 : _a25.raw) == null ? void 0 : _b25.toString()) || ((_d = (_c = object.effect) == null ? void 0 : _c.fn) == null ? void 0 : _d.toString()) : null;
        return {
            _custom: {
                type: stateTypeName == null ? void 0 : stateTypeName.toLowerCase(),
                stateTypeName: stateTypeName,
                value: value,
                ...raw ? {
                    tooltipText: `<span class="font-mono">${raw}</span>`
                } : {}
            }
        };
    }
    if ($5193fce5c5df8bb9$var$ensurePropertyExists(object, "__asyncLoader") && typeof object.__asyncLoader === "function") return {
        _custom: {
            type: "component-definition",
            display: "Async component definition"
        }
    };
}
// src/core/component/state/replacer.ts
function $5193fce5c5df8bb9$var$stringifyReplacer(key, _value, depth, seenInstance) {
    var _a25;
    if (key === "compilerOptions") return;
    const val = this[key];
    const type = typeof val;
    if (Array.isArray(val)) {
        const l = val.length;
        if (l > $5193fce5c5df8bb9$var$MAX_ARRAY_SIZE) return {
            _isArray: true,
            length: l,
            items: val.slice(0, $5193fce5c5df8bb9$var$MAX_ARRAY_SIZE)
        };
        return val;
    } else if (typeof val === "string") {
        if (val.length > $5193fce5c5df8bb9$var$MAX_STRING_SIZE) return `${val.substring(0, $5193fce5c5df8bb9$var$MAX_STRING_SIZE)}... (${val.length} total length)`;
        else return val;
    } else if (type === "undefined") return $5193fce5c5df8bb9$export$6db089fe7b26f5b6;
    else if (val === Number.POSITIVE_INFINITY) return $5193fce5c5df8bb9$export$b4bf424ed968e242;
    else if (val === Number.NEGATIVE_INFINITY) return $5193fce5c5df8bb9$export$95cb88e357cbada8;
    else if (typeof val === "function") return $5193fce5c5df8bb9$var$getFunctionDetails(val);
    else if (type === "symbol") return `[native Symbol ${Symbol.prototype.toString.call(val)}]`;
    else if (typeof val === "bigint") return $5193fce5c5df8bb9$var$getBigIntDetails(val);
    else if (val !== null && typeof val === "object") {
        const proto = Object.prototype.toString.call(val);
        if (proto === "[object Map]") return $5193fce5c5df8bb9$var$getMapDetails(val);
        else if (proto === "[object Set]") return $5193fce5c5df8bb9$var$getSetDetails(val);
        else if (proto === "[object RegExp]") return `[native RegExp ${RegExp.prototype.toString.call(val)}]`;
        else if (proto === "[object Date]") return $5193fce5c5df8bb9$var$getDateDetails(val);
        else if (proto === "[object Error]") return `[native Error ${val.message}<>${val.stack}]`;
        else if ($5193fce5c5df8bb9$var$ensurePropertyExists(val, "state", true) && $5193fce5c5df8bb9$var$ensurePropertyExists(val, "_vm", true)) return $5193fce5c5df8bb9$var$getStoreDetails(val);
        else if (val.constructor && val.constructor.name === "VueRouter") return $5193fce5c5df8bb9$var$getRouterDetails(val);
        else if ($5193fce5c5df8bb9$var$isVueInstance(val)) {
            const componentVal = $5193fce5c5df8bb9$var$getInstanceDetails(val);
            const parentInstanceDepth = seenInstance == null ? void 0 : seenInstance.get(val);
            if (parentInstanceDepth && parentInstanceDepth < depth) return `[[CircularRef]] <${componentVal._custom.displayText}>`;
            seenInstance == null || seenInstance.set(val, depth);
            return componentVal;
        } else if ($5193fce5c5df8bb9$var$ensurePropertyExists(val, "render", true) && typeof val.render === "function") return $5193fce5c5df8bb9$var$getComponentDefinitionDetails(val);
        else if (val.constructor && val.constructor.name === "VNode") return `[native VNode <${val.tag}>]`;
        else if (typeof HTMLElement !== "undefined" && val instanceof HTMLElement) return $5193fce5c5df8bb9$var$getHTMLElementDetails(val);
        else if (((_a25 = val.constructor) == null ? void 0 : _a25.name) === "Store" && "_wrappedGetters" in val) return "[object Store]";
        else if ($5193fce5c5df8bb9$var$ensurePropertyExists(val, "currentRoute", true)) return "[object Router]";
        const customDetails = $5193fce5c5df8bb9$var$getObjectDetails(val);
        if (customDetails != null) return customDetails;
    } else if (Number.isNaN(val)) return $5193fce5c5df8bb9$export$d7ae0f70ebb9e144;
    return $5193fce5c5df8bb9$var$sanitize(val);
}
// src/shared/transfer.ts
$5193fce5c5df8bb9$var$init_esm_shims();
var $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE = 2097152;
function $5193fce5c5df8bb9$var$isObject(_data, proto) {
    return proto === "[object Object]";
}
function $5193fce5c5df8bb9$var$isArray3(_data, proto) {
    return proto === "[object Array]";
}
function $5193fce5c5df8bb9$var$isVueReactiveLinkNode(node) {
    var _a25;
    const constructorName = (_a25 = node == null ? void 0 : node.constructor) == null ? void 0 : _a25.name;
    return constructorName === "Dep" && "activeLink" in node || constructorName === "Link" && "dep" in node;
}
function $5193fce5c5df8bb9$var$encode(data, replacer, list, seen, depth = 0, seenVueInstance = /* @__PURE__ */ new Map()) {
    let stored;
    let key;
    let value;
    let i;
    let l;
    const seenIndex = seen.get(data);
    if (seenIndex != null) return seenIndex;
    const index = list.length;
    const proto = Object.prototype.toString.call(data);
    if ($5193fce5c5df8bb9$var$isObject(data, proto)) {
        if ($5193fce5c5df8bb9$var$isVueReactiveLinkNode(data)) return index;
        stored = {};
        seen.set(data, index);
        list.push(stored);
        const keys = Object.keys(data);
        for(i = 0, l = keys.length; i < l; i++){
            key = keys[i];
            if (key === "compilerOptions") return index;
            value = data[key];
            const isVm = value != null && $5193fce5c5df8bb9$var$isObject(value, Object.prototype.toString.call(data)) && $5193fce5c5df8bb9$var$isVueInstance(value);
            try {
                if (replacer) value = replacer.call(data, key, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[key] = $5193fce5c5df8bb9$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
            if (isVm) seenVueInstance.delete(value);
        }
    } else if ($5193fce5c5df8bb9$var$isArray3(data, proto)) {
        stored = [];
        seen.set(data, index);
        list.push(stored);
        for(i = 0, l = data.length; i < l; i++){
            try {
                value = data[i];
                if (replacer) value = replacer.call(data, i, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[i] = $5193fce5c5df8bb9$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
        }
    } else list.push(data);
    return index;
}
function $5193fce5c5df8bb9$var$decode(list, reviver2 = null) {
    let i = list.length;
    let j, k, data, key, value, proto;
    while(i--){
        data = list[i];
        proto = Object.prototype.toString.call(data);
        if (proto === "[object Object]") {
            const keys = Object.keys(data);
            for(j = 0, k = keys.length; j < k; j++){
                key = keys[j];
                value = list[data[key]];
                if (reviver2) value = reviver2.call(data, key, value);
                data[key] = value;
            }
        } else if (proto === "[object Array]") for(j = 0, k = data.length; j < k; j++){
            value = list[data[j]];
            if (reviver2) value = reviver2.call(data, j, value);
            data[j] = value;
        }
    }
}
function $5193fce5c5df8bb9$var$stringifyCircularAutoChunks(data, replacer = null, space = null) {
    let result;
    try {
        result = arguments.length === 1 ? JSON.stringify(data) : JSON.stringify(data, (k, v)=>{
            var _a25;
            return (_a25 = replacer == null ? void 0 : replacer(k, v)) == null ? void 0 : _a25.call(this);
        }, space);
    } catch (e) {
        result = $5193fce5c5df8bb9$var$stringifyStrictCircularAutoChunks(data, replacer, space);
    }
    if (result.length > $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE) {
        const chunkCount = Math.ceil(result.length / $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE);
        const chunks = [];
        for(let i = 0; i < chunkCount; i++)chunks.push(result.slice(i * $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE, (i + 1) * $5193fce5c5df8bb9$var$MAX_SERIALIZED_SIZE));
        return chunks;
    }
    return result;
}
function $5193fce5c5df8bb9$var$stringifyStrictCircularAutoChunks(data, replacer = null, space = null) {
    const list = [];
    $5193fce5c5df8bb9$var$encode(data, replacer, list, /* @__PURE__ */ new Map());
    return space ? ` ${JSON.stringify(list, null, space)}` : ` ${JSON.stringify(list)}`;
}
function $5193fce5c5df8bb9$var$parseCircularAutoChunks(data, reviver2 = null) {
    if (Array.isArray(data)) data = data.join("");
    const hasCircular = /^\s/.test(data);
    if (!hasCircular) return arguments.length === 1 ? JSON.parse(data) : JSON.parse(data, reviver2);
    else {
        const list = JSON.parse(data);
        $5193fce5c5df8bb9$var$decode(list, reviver2);
        return list[0];
    }
}
// src/shared/util.ts
function $5193fce5c5df8bb9$export$fac44ee5b035f737(data) {
    return $5193fce5c5df8bb9$var$stringifyCircularAutoChunks(data, $5193fce5c5df8bb9$var$stringifyReplacer);
}
function $5193fce5c5df8bb9$export$98e6a39c04603d36(data, revive2 = false) {
    if (data == void 0) return {};
    return revive2 ? $5193fce5c5df8bb9$var$parseCircularAutoChunks(data, $5193fce5c5df8bb9$var$reviver) : $5193fce5c5df8bb9$var$parseCircularAutoChunks(data);
}
// src/index.ts
var $5193fce5c5df8bb9$export$6922d3b3a607469e = {
    hook: $5193fce5c5df8bb9$var$hook,
    init: ()=>{
        $5193fce5c5df8bb9$export$93f430585c3f6d11();
    },
    get ctx () {
        return $5193fce5c5df8bb9$export$4f1904c03898171b;
    },
    get api () {
        return $5193fce5c5df8bb9$export$4f1904c03898171b.api;
    }
};

});
parcelRegister("i0cUC", function(module, exports) {

$parcel$export(module.exports, "isBrowser", () => $d1b23e2c2244874a$export$4e09c449d6c407f7);
$parcel$export(module.exports, "target", () => $d1b23e2c2244874a$export$44271b4f0c6a3563);
$parcel$export(module.exports, "isNuxtApp", () => $d1b23e2c2244874a$export$e34a31924fd64105);
$parcel$export(module.exports, "classify", () => $d1b23e2c2244874a$export$b04d9b8d414ba5e8);
$parcel$export(module.exports, "camelize", () => $d1b23e2c2244874a$export$161d051f5dd25de7);
$parcel$export(module.exports, "kebabize", () => $d1b23e2c2244874a$export$3b2e9c066cbbdd4c);
$parcel$export(module.exports, "basename", () => $d1b23e2c2244874a$export$9bf319d8f74f51d1);
$parcel$export(module.exports, "isUrlString", () => $d1b23e2c2244874a$export$8092cb61b2731942);
$parcel$export(module.exports, "deepClone", () => $d1b23e2c2244874a$export$b7d58db314e0ac27);

var $6ZWSX = parcelRequire("6ZWSX");
var $d1b23e2c2244874a$require$Buffer = $6ZWSX.Buffer;
var $d1b23e2c2244874a$var$__create = Object.create;
var $d1b23e2c2244874a$var$__defProp = Object.defineProperty;
var $d1b23e2c2244874a$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d1b23e2c2244874a$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $d1b23e2c2244874a$var$__getProtoOf = Object.getPrototypeOf;
var $d1b23e2c2244874a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d1b23e2c2244874a$var$__esm = (fn, res)=>function __init() {
        return fn && (res = (0, fn[$d1b23e2c2244874a$var$__getOwnPropNames(fn)[0]])(fn = 0)), res;
    };
var $d1b23e2c2244874a$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$d1b23e2c2244874a$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $d1b23e2c2244874a$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $d1b23e2c2244874a$var$__getOwnPropNames(from))if (!$d1b23e2c2244874a$var$__hasOwnProp.call(to, key) && key !== except) $d1b23e2c2244874a$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $d1b23e2c2244874a$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $d1b23e2c2244874a$var$__toESM = (mod, isNodeMode, target2)=>(target2 = mod != null ? $d1b23e2c2244874a$var$__create($d1b23e2c2244874a$var$__getProtoOf(mod)) : {}, $d1b23e2c2244874a$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $d1b23e2c2244874a$var$__defProp(target2, "default", {
        value: mod,
        enumerable: true
    }) : target2, mod));
// ../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js
var $d1b23e2c2244874a$var$init_esm_shims = $d1b23e2c2244874a$var$__esm({
    "../../node_modules/.pnpm/tsup@8.4.0_@microsoft+api-extractor@7.51.1_@types+node@22.13.14__jiti@2.4.2_postcss@8.5_96eb05a9d65343021e53791dd83f3773/node_modules/tsup/assets/esm_shims.js" () {
        "use strict";
    }
});
// ../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js
var $d1b23e2c2244874a$var$require_rfdc = $d1b23e2c2244874a$var$__commonJS({
    "../../node_modules/.pnpm/rfdc@1.4.1/node_modules/rfdc/index.js" (exports, module) {
        "use strict";
        $d1b23e2c2244874a$var$init_esm_shims();
        module.exports = rfdc2;
        function copyBuffer(cur) {
            if (cur instanceof $d1b23e2c2244874a$require$Buffer) return $d1b23e2c2244874a$require$Buffer.from(cur);
            return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length);
        }
        function rfdc2(opts) {
            opts = opts || {};
            if (opts.circles) return rfdcCircles(opts);
            const constructorHandlers = /* @__PURE__ */ new Map();
            constructorHandlers.set(Date, (o)=>new Date(o));
            constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
            constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
            if (opts.constructorHandlers) for (const handler2 of opts.constructorHandlers)constructorHandlers.set(handler2[0], handler2[1]);
            let handler = null;
            return opts.proto ? cloneProto : clone;
            function cloneArray(a, fn) {
                const keys = Object.keys(a);
                const a2 = new Array(keys.length);
                for(let i = 0; i < keys.length; i++){
                    const k = keys[i];
                    const cur = a[k];
                    if (typeof cur !== "object" || cur === null) a2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                    else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                    else a2[k] = fn(cur);
                }
                return a2;
            }
            function clone(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, clone);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
                const o2 = {};
                for(const k in o){
                    if (Object.hasOwnProperty.call(o, k) === false) continue;
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else o2[k] = clone(cur);
                }
                return o2;
            }
            function cloneProto(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, cloneProto);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
                const o2 = {};
                for(const k in o){
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else o2[k] = cloneProto(cur);
                }
                return o2;
            }
        }
        function rfdcCircles(opts) {
            const refs = [];
            const refsNew = [];
            const constructorHandlers = /* @__PURE__ */ new Map();
            constructorHandlers.set(Date, (o)=>new Date(o));
            constructorHandlers.set(Map, (o, fn)=>new Map(cloneArray(Array.from(o), fn)));
            constructorHandlers.set(Set, (o, fn)=>new Set(cloneArray(Array.from(o), fn)));
            if (opts.constructorHandlers) for (const handler2 of opts.constructorHandlers)constructorHandlers.set(handler2[0], handler2[1]);
            let handler = null;
            return opts.proto ? cloneProto : clone;
            function cloneArray(a, fn) {
                const keys = Object.keys(a);
                const a2 = new Array(keys.length);
                for(let i = 0; i < keys.length; i++){
                    const k = keys[i];
                    const cur = a[k];
                    if (typeof cur !== "object" || cur === null) a2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) a2[k] = handler(cur, fn);
                    else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                    else {
                        const index = refs.indexOf(cur);
                        if (index !== -1) a2[k] = refsNew[index];
                        else a2[k] = fn(cur);
                    }
                }
                return a2;
            }
            function clone(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, clone);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, clone);
                const o2 = {};
                refs.push(o);
                refsNew.push(o2);
                for(const k in o){
                    if (Object.hasOwnProperty.call(o, k) === false) continue;
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, clone);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else {
                        const i = refs.indexOf(cur);
                        if (i !== -1) o2[k] = refsNew[i];
                        else o2[k] = clone(cur);
                    }
                }
                refs.pop();
                refsNew.pop();
                return o2;
            }
            function cloneProto(o) {
                if (typeof o !== "object" || o === null) return o;
                if (Array.isArray(o)) return cloneArray(o, cloneProto);
                if (o.constructor !== Object && (handler = constructorHandlers.get(o.constructor))) return handler(o, cloneProto);
                const o2 = {};
                refs.push(o);
                refsNew.push(o2);
                for(const k in o){
                    const cur = o[k];
                    if (typeof cur !== "object" || cur === null) o2[k] = cur;
                    else if (cur.constructor !== Object && (handler = constructorHandlers.get(cur.constructor))) o2[k] = handler(cur, cloneProto);
                    else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                    else {
                        const i = refs.indexOf(cur);
                        if (i !== -1) o2[k] = refsNew[i];
                        else o2[k] = cloneProto(cur);
                    }
                }
                refs.pop();
                refsNew.pop();
                return o2;
            }
        }
    }
});
// src/index.ts
$d1b23e2c2244874a$var$init_esm_shims();
// src/constants.ts
$d1b23e2c2244874a$var$init_esm_shims();
var $d1b23e2c2244874a$export$a13f7f627010bccd = "__vue-devtools-view-mode__";
var $d1b23e2c2244874a$export$cb85e77fef76bd8b = "__vue-devtools-vite-plugin-detected__";
var $d1b23e2c2244874a$export$45e7092a470efb27 = "__vue-devtools-vite-plugin-client-url__";
var $d1b23e2c2244874a$export$a7ca7371bc63510e = "__vue-devtools-broadcast-channel__";
// src/env.ts
$d1b23e2c2244874a$var$init_esm_shims();
var $d1b23e2c2244874a$export$4e09c449d6c407f7 = typeof navigator !== "undefined";
var $d1b23e2c2244874a$export$44271b4f0c6a3563 = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : {};
var $d1b23e2c2244874a$export$2a47bd138bf4827c = typeof $d1b23e2c2244874a$export$44271b4f0c6a3563.chrome !== "undefined" && !!$d1b23e2c2244874a$export$44271b4f0c6a3563.chrome.devtools;
var $d1b23e2c2244874a$export$9f140ed41af5108c = $d1b23e2c2244874a$export$4e09c449d6c407f7 && $d1b23e2c2244874a$export$44271b4f0c6a3563.self !== $d1b23e2c2244874a$export$44271b4f0c6a3563.top;
var $d1b23e2c2244874a$var$_a;
var $d1b23e2c2244874a$export$6272d088ce0bd5ee = typeof navigator !== "undefined" && (($d1b23e2c2244874a$var$_a = navigator.userAgent) == null ? void 0 : $d1b23e2c2244874a$var$_a.toLowerCase().includes("electron"));
var $d1b23e2c2244874a$export$e34a31924fd64105 = typeof window !== "undefined" && !!window.__NUXT__;
var $d1b23e2c2244874a$export$cd24a69e3c9a51c8 = !$d1b23e2c2244874a$export$9f140ed41af5108c && !$d1b23e2c2244874a$export$2a47bd138bf4827c && !$d1b23e2c2244874a$export$6272d088ce0bd5ee;
// src/general.ts
$d1b23e2c2244874a$var$init_esm_shims();
var $d1b23e2c2244874a$var$import_rfdc = $d1b23e2c2244874a$var$__toESM($d1b23e2c2244874a$var$require_rfdc(), 1);
function $d1b23e2c2244874a$export$5702a91a6f42969f() {}
var $d1b23e2c2244874a$export$e90fb89750dba83f = (str)=>`${+str}` === str;
var $d1b23e2c2244874a$export$6159e43e50a41987 = ()=>(navigator == null ? void 0 : navigator.platform) ? navigator == null ? void 0 : navigator.platform.toLowerCase().includes("mac") : /Macintosh/.test(navigator.userAgent);
var $d1b23e2c2244874a$var$classifyRE = /(?:^|[-_/])(\w)/g;
var $d1b23e2c2244874a$var$camelizeRE = /-(\w)/g;
var $d1b23e2c2244874a$var$kebabizeRE = /([a-z0-9])([A-Z])/g;
function $d1b23e2c2244874a$var$toUpper(_, c) {
    return c ? c.toUpperCase() : "";
}
function $d1b23e2c2244874a$export$b04d9b8d414ba5e8(str) {
    return str && `${str}`.replace($d1b23e2c2244874a$var$classifyRE, $d1b23e2c2244874a$var$toUpper);
}
function $d1b23e2c2244874a$export$161d051f5dd25de7(str) {
    return str && str.replace($d1b23e2c2244874a$var$camelizeRE, $d1b23e2c2244874a$var$toUpper);
}
function $d1b23e2c2244874a$export$3b2e9c066cbbdd4c(str) {
    return str && str.replace($d1b23e2c2244874a$var$kebabizeRE, (_, lowerCaseCharacter, upperCaseLetter)=>{
        return `${lowerCaseCharacter}-${upperCaseLetter}`;
    }).toLowerCase();
}
function $d1b23e2c2244874a$export$9bf319d8f74f51d1(filename, ext) {
    let normalizedFilename = filename.replace(/^[a-z]:/i, "").replace(/\\/g, "/");
    if (normalizedFilename.endsWith(`index${ext}`)) normalizedFilename = normalizedFilename.replace(`/index${ext}`, ext);
    const lastSlashIndex = normalizedFilename.lastIndexOf("/");
    const baseNameWithExt = normalizedFilename.substring(lastSlashIndex + 1);
    if (ext) {
        const extIndex = baseNameWithExt.lastIndexOf(ext);
        return baseNameWithExt.substring(0, extIndex);
    }
    return "";
}
function $d1b23e2c2244874a$export$584200199479c807(state) {
    return state && state.slice().sort((a, b)=>{
        if (a.key < b.key) return -1;
        if (a.key > b.key) return 1;
        return 0;
    });
}
var $d1b23e2c2244874a$var$HTTP_URL_RE = /^https?:\/\//;
function $d1b23e2c2244874a$export$8092cb61b2731942(str) {
    return str.startsWith("/") || $d1b23e2c2244874a$var$HTTP_URL_RE.test(str);
}
var $d1b23e2c2244874a$export$b7d58db314e0ac27 = (0, $d1b23e2c2244874a$var$import_rfdc.default)({
    circles: true
});
function $d1b23e2c2244874a$export$e700e91d2b9349e8() {
    return Math.random().toString(36).slice(2);
}
function $d1b23e2c2244874a$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && !Array.isArray(value) && value !== null;
}
function $d1b23e2c2244874a$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $d1b23e2c2244874a$export$6750766a7c7ec627(value) {
    return value instanceof Set;
}
function $d1b23e2c2244874a$export$5c90113a285f2241(value) {
    return value instanceof Map;
}

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("dj5lJ", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $6e9f4183630d4f60$export$61fc7d43ac8f84b0);
const $6e9f4183630d4f60$var$DEBOUNCE_DEFAULTS = {
    trailing: true
};
function $6e9f4183630d4f60$export$61fc7d43ac8f84b0(fn, wait = 25, options = {}) {
    options = {
        ...$6e9f4183630d4f60$var$DEBOUNCE_DEFAULTS,
        ...options
    };
    if (!Number.isFinite(wait)) throw new TypeError("Expected `wait` to be a finite number");
    let leadingValue;
    let timeout;
    let resolveList = [];
    let currentPromise;
    let trailingArgs;
    const applyFn = (_this, args)=>{
        currentPromise = $6e9f4183630d4f60$var$_applyPromised(fn, _this, args);
        currentPromise.finally(()=>{
            currentPromise = null;
            if (options.trailing && trailingArgs && !timeout) {
                const promise = applyFn(_this, trailingArgs);
                trailingArgs = null;
                return promise;
            }
        });
        return currentPromise;
    };
    return function(...args) {
        if (currentPromise) {
            if (options.trailing) trailingArgs = args;
            return currentPromise;
        }
        return new Promise((resolve)=>{
            const shouldCallNow = !timeout && options.leading;
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                timeout = null;
                const promise = options.leading ? leadingValue : applyFn(this, args);
                for (const _resolve of resolveList)_resolve(promise);
                resolveList = [];
            }, wait);
            if (shouldCallNow) {
                leadingValue = applyFn(this, args);
                resolve(leadingValue);
            } else resolveList.push(resolve);
        });
    };
}
async function $6e9f4183630d4f60$var$_applyPromised(fn, _this, args) {
    return await fn.apply(_this, args);
}

});

parcelRegister("ptPDd", function(module, exports) {

$parcel$export(module.exports, "createHooks", () => $aad1b324593e83d0$export$39c6a2b4dbabca5d);
function $aad1b324593e83d0$export$9089e2fc8ae509cd(configHooks, hooks = {}, parentName) {
    for(const key in configHooks){
        const subHook = configHooks[key];
        const name = parentName ? `${parentName}:${key}` : key;
        if (typeof subHook === "object" && subHook !== null) $aad1b324593e83d0$export$9089e2fc8ae509cd(subHook, hooks, name);
        else if (typeof subHook === "function") hooks[name] = subHook;
    }
    return hooks;
}
function $aad1b324593e83d0$export$3de1ffbf114b9f2d(...hooks) {
    const finalHooks = {};
    for (const hook of hooks){
        const flatenHook = $aad1b324593e83d0$export$9089e2fc8ae509cd(hook);
        for(const key in flatenHook)if (finalHooks[key]) finalHooks[key].push(flatenHook[key]);
        else finalHooks[key] = [
            flatenHook[key]
        ];
    }
    for(const key in finalHooks)if (finalHooks[key].length > 1) {
        const array = finalHooks[key];
        finalHooks[key] = (...arguments_)=>$aad1b324593e83d0$export$6c2c9a00e27c07e8(array, (function_)=>function_(...arguments_));
    } else finalHooks[key] = finalHooks[key][0];
    return finalHooks;
}
function $aad1b324593e83d0$export$6c2c9a00e27c07e8(tasks, function_) {
    return tasks.reduce((promise, task)=>promise.then(()=>function_(task)), Promise.resolve());
}
const $aad1b324593e83d0$var$defaultTask = {
    run: (function_)=>function_()
};
const $aad1b324593e83d0$var$_createTask = ()=>$aad1b324593e83d0$var$defaultTask;
const $aad1b324593e83d0$var$createTask = typeof console.createTask !== "undefined" ? console.createTask : $aad1b324593e83d0$var$_createTask;
function $aad1b324593e83d0$var$serialTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $aad1b324593e83d0$var$createTask(name);
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>task.run(()=>hookFunction(...args))), Promise.resolve());
}
function $aad1b324593e83d0$var$parallelTaskCaller(hooks, args) {
    const name = args.shift();
    const task = $aad1b324593e83d0$var$createTask(name);
    return Promise.all(hooks.map((hook)=>task.run(()=>hook(...args))));
}
function $aad1b324593e83d0$export$e1dd809e3137c513(hooks, arguments_) {
    return hooks.reduce((promise, hookFunction)=>promise.then(()=>hookFunction(...arguments_ || [])), Promise.resolve());
}
function $aad1b324593e83d0$export$23b1f1c6efb4a44a(hooks, args) {
    return Promise.all(hooks.map((hook)=>hook(...args || [])));
}
function $aad1b324593e83d0$var$callEachWith(callbacks, arg0) {
    for (const callback of [
        ...callbacks
    ])callback(arg0);
}
class $aad1b324593e83d0$export$f26845e0fc859724 {
    constructor(){
        this._hooks = {};
        this._before = void 0;
        this._after = void 0;
        this._deprecatedMessages = void 0;
        this._deprecatedHooks = {};
        this.hook = this.hook.bind(this);
        this.callHook = this.callHook.bind(this);
        this.callHookWith = this.callHookWith.bind(this);
    }
    hook(name, function_, options = {}) {
        if (!name || typeof function_ !== "function") return ()=>{};
        const originalName = name;
        let dep;
        while(this._deprecatedHooks[name]){
            dep = this._deprecatedHooks[name];
            name = dep.to;
        }
        if (dep && !options.allowDeprecated) {
            let message = dep.message;
            if (!message) message = `${originalName} hook has been deprecated` + (dep.to ? `, please use ${dep.to}` : "");
            if (!this._deprecatedMessages) this._deprecatedMessages = /* @__PURE__ */ new Set();
            if (!this._deprecatedMessages.has(message)) {
                console.warn(message);
                this._deprecatedMessages.add(message);
            }
        }
        if (!function_.name) try {
            Object.defineProperty(function_, "name", {
                get: ()=>"_" + name.replace(/\W+/g, "_") + "_hook_cb",
                configurable: true
            });
        } catch  {}
        this._hooks[name] = this._hooks[name] || [];
        this._hooks[name].push(function_);
        return ()=>{
            if (function_) {
                this.removeHook(name, function_);
                function_ = void 0;
            }
        };
    }
    hookOnce(name, function_) {
        let _unreg;
        let _function = (...arguments_)=>{
            if (typeof _unreg === "function") _unreg();
            _unreg = void 0;
            _function = void 0;
            return function_(...arguments_);
        };
        _unreg = this.hook(name, _function);
        return _unreg;
    }
    removeHook(name, function_) {
        if (this._hooks[name]) {
            const index = this._hooks[name].indexOf(function_);
            if (index !== -1) this._hooks[name].splice(index, 1);
            if (this._hooks[name].length === 0) delete this._hooks[name];
        }
    }
    deprecateHook(name, deprecated) {
        this._deprecatedHooks[name] = typeof deprecated === "string" ? {
            to: deprecated
        } : deprecated;
        const _hooks = this._hooks[name] || [];
        delete this._hooks[name];
        for (const hook of _hooks)this.hook(name, hook);
    }
    deprecateHooks(deprecatedHooks) {
        Object.assign(this._deprecatedHooks, deprecatedHooks);
        for(const name in deprecatedHooks)this.deprecateHook(name, deprecatedHooks[name]);
    }
    addHooks(configHooks) {
        const hooks = $aad1b324593e83d0$export$9089e2fc8ae509cd(configHooks);
        const removeFns = Object.keys(hooks).map((key)=>this.hook(key, hooks[key]));
        return ()=>{
            for (const unreg of removeFns.splice(0, removeFns.length))unreg();
        };
    }
    removeHooks(configHooks) {
        const hooks = $aad1b324593e83d0$export$9089e2fc8ae509cd(configHooks);
        for(const key in hooks)this.removeHook(key, hooks[key]);
    }
    removeAllHooks() {
        for(const key in this._hooks)delete this._hooks[key];
    }
    callHook(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($aad1b324593e83d0$var$serialTaskCaller, name, ...arguments_);
    }
    callHookParallel(name, ...arguments_) {
        arguments_.unshift(name);
        return this.callHookWith($aad1b324593e83d0$var$parallelTaskCaller, name, ...arguments_);
    }
    callHookWith(caller, name, ...arguments_) {
        const event = this._before || this._after ? {
            name: name,
            args: arguments_,
            context: {}
        } : void 0;
        if (this._before) $aad1b324593e83d0$var$callEachWith(this._before, event);
        const result = caller(name in this._hooks ? [
            ...this._hooks[name]
        ] : [], arguments_);
        if (result instanceof Promise) return result.finally(()=>{
            if (this._after && event) $aad1b324593e83d0$var$callEachWith(this._after, event);
        });
        if (this._after && event) $aad1b324593e83d0$var$callEachWith(this._after, event);
        return result;
    }
    beforeEach(function_) {
        this._before = this._before || [];
        this._before.push(function_);
        return ()=>{
            if (this._before !== void 0) {
                const index = this._before.indexOf(function_);
                if (index !== -1) this._before.splice(index, 1);
            }
        };
    }
    afterEach(function_) {
        this._after = this._after || [];
        this._after.push(function_);
        return ()=>{
            if (this._after !== void 0) {
                const index = this._after.indexOf(function_);
                if (index !== -1) this._after.splice(index, 1);
            }
        };
    }
}
function $aad1b324593e83d0$export$39c6a2b4dbabca5d() {
    return new $aad1b324593e83d0$export$f26845e0fc859724();
}
const $aad1b324593e83d0$var$isBrowser = typeof window !== "undefined";
function $aad1b324593e83d0$export$acfdf6f45fa21f5e(hooks, _options = {}) {
    const options = {
        inspect: $aad1b324593e83d0$var$isBrowser,
        group: $aad1b324593e83d0$var$isBrowser,
        filter: ()=>true,
        ..._options
    };
    const _filter = options.filter;
    const filter = typeof _filter === "string" ? (name)=>name.startsWith(_filter) : _filter;
    const _tag = options.tag ? `[${options.tag}] ` : "";
    const logPrefix = (event)=>_tag + event.name + "".padEnd(event._id, "\0");
    const _idCtr = {};
    const unsubscribeBefore = hooks.beforeEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        _idCtr[event.name] = _idCtr[event.name] || 0;
        event._id = _idCtr[event.name]++;
        console.time(logPrefix(event));
    });
    const unsubscribeAfter = hooks.afterEach((event)=>{
        if (filter !== void 0 && !filter(event.name)) return;
        if (options.group) console.groupCollapsed(event.name);
        if (options.inspect) console.timeLog(logPrefix(event), event.args);
        else console.timeEnd(logPrefix(event));
        if (options.group) console.groupEnd();
        _idCtr[event.name]--;
    });
    return {
        /** Stop debugging and remove listeners */ close: ()=>{
            unsubscribeBefore();
            unsubscribeAfter();
        }
    };
}

});

parcelRegister("enkGC", function(module, exports) {

$parcel$export(module.exports, "createBirpc", () => $baa9e15afeaf047c$export$8de909a09ac6851a);
$parcel$export(module.exports, "createBirpcGroup", () => $baa9e15afeaf047c$export$ec516731f3c62ae5);
const $baa9e15afeaf047c$var$TYPE_REQUEST = "q";
const $baa9e15afeaf047c$var$TYPE_RESPONSE = "s";
const $baa9e15afeaf047c$export$7bd623b29ec8e1eb = 6e4;
function $baa9e15afeaf047c$var$defaultSerialize(i) {
    return i;
}
const $baa9e15afeaf047c$var$defaultDeserialize = $baa9e15afeaf047c$var$defaultSerialize;
const { clearTimeout: $baa9e15afeaf047c$var$clearTimeout, setTimeout: $baa9e15afeaf047c$var$setTimeout } = globalThis;
const $baa9e15afeaf047c$var$random = Math.random.bind(Math);
function $baa9e15afeaf047c$export$8de909a09ac6851a($functions, options) {
    const { post: post, on: on, off: off = ()=>{}, eventNames: eventNames = [], serialize: serialize = $baa9e15afeaf047c$var$defaultSerialize, deserialize: deserialize = $baa9e15afeaf047c$var$defaultDeserialize, resolver: resolver, bind: bind = "rpc", timeout: timeout = $baa9e15afeaf047c$export$7bd623b29ec8e1eb } = options;
    let $closed = false;
    const _rpcPromiseMap = /* @__PURE__ */ new Map();
    let _promiseInit;
    let rpc;
    async function _call(method, args, event, optional) {
        if ($closed) throw new Error(`[birpc] rpc is closed, cannot call "${method}"`);
        const req = {
            m: method,
            a: args,
            t: $baa9e15afeaf047c$var$TYPE_REQUEST
        };
        if (optional) req.o = true;
        const send = async (_req)=>post(serialize(_req));
        if (event) {
            await send(req);
            return;
        }
        if (_promiseInit) try {
            await _promiseInit;
        } finally{
            _promiseInit = void 0;
        }
        let { promise: promise, resolve: resolve, reject: reject } = $baa9e15afeaf047c$var$createPromiseWithResolvers();
        const id = $baa9e15afeaf047c$var$nanoid();
        req.i = id;
        let timeoutId;
        async function handler(newReq = req) {
            if (timeout >= 0) {
                timeoutId = $baa9e15afeaf047c$var$setTimeout(()=>{
                    try {
                        const handleResult = options.onTimeoutError?.call(rpc, method, args);
                        if (handleResult !== true) throw new Error(`[birpc] timeout on calling "${method}"`);
                    } catch (e) {
                        reject(e);
                    }
                    _rpcPromiseMap.delete(id);
                }, timeout);
                if (typeof timeoutId === "object") timeoutId = timeoutId.unref?.();
            }
            _rpcPromiseMap.set(id, {
                resolve: resolve,
                reject: reject,
                timeoutId: timeoutId,
                method: method
            });
            await send(newReq);
            return promise;
        }
        try {
            if (options.onRequest) await options.onRequest.call(rpc, req, handler, resolve);
            else await handler();
        } catch (e) {
            if (options.onGeneralError?.call(rpc, e) !== true) throw e;
            return;
        } finally{
            $baa9e15afeaf047c$var$clearTimeout(timeoutId);
            _rpcPromiseMap.delete(id);
        }
        return promise;
    }
    const $call = (method, ...args)=>_call(method, args, false);
    const $callOptional = (method, ...args)=>_call(method, args, false, true);
    const $callEvent = (method, ...args)=>_call(method, args, true);
    const $callRaw = (options2)=>_call(options2.method, options2.args, options2.event, options2.optional);
    const builtinMethods = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent,
        $callRaw: $callRaw,
        $rejectPendingCalls: $rejectPendingCalls,
        get $closed () {
            return $closed;
        },
        get $meta () {
            return options.meta;
        },
        $close: $close,
        $functions: $functions
    };
    rpc = new Proxy({}, {
        get (_, method) {
            if (Object.prototype.hasOwnProperty.call(builtinMethods, method)) return builtinMethods[method];
            if (method === "then" && !eventNames.includes("then") && !("then" in $functions)) return void 0;
            const sendEvent = (...args)=>_call(method, args, true);
            if (eventNames.includes(method)) {
                sendEvent.asEvent = sendEvent;
                return sendEvent;
            }
            const sendCall = (...args)=>_call(method, args, false);
            sendCall.asEvent = sendEvent;
            return sendCall;
        }
    });
    function $close(customError) {
        $closed = true;
        _rpcPromiseMap.forEach(({ reject: reject, method: method })=>{
            const error = new Error(`[birpc] rpc is closed, cannot call "${method}"`);
            if (customError) {
                customError.cause ??= error;
                return reject(customError);
            }
            reject(error);
        });
        _rpcPromiseMap.clear();
        off(onMessage);
    }
    function $rejectPendingCalls(handler) {
        const entries = Array.from(_rpcPromiseMap.values());
        const handlerResults = entries.map(({ method: method, reject: reject })=>{
            if (!handler) return reject(new Error(`[birpc]: rejected pending call "${method}".`));
            return handler({
                method: method,
                reject: reject
            });
        });
        _rpcPromiseMap.clear();
        return handlerResults;
    }
    async function onMessage(data, ...extra) {
        let msg;
        try {
            msg = deserialize(data);
        } catch (e) {
            if (options.onGeneralError?.call(rpc, e) !== true) throw e;
            return;
        }
        if (msg.t === $baa9e15afeaf047c$var$TYPE_REQUEST) {
            const { m: method, a: args, o: optional } = msg;
            let result, error;
            let fn = await (resolver ? resolver.call(rpc, method, $functions[method]) : $functions[method]);
            if (optional) fn ||= ()=>void 0;
            if (!fn) error = new Error(`[birpc] function "${method}" not found`);
            else try {
                result = await fn.apply(bind === "rpc" ? rpc : $functions, args);
            } catch (e) {
                error = e;
            }
            if (msg.i) {
                if (error && options.onError) options.onError.call(rpc, error, method, args);
                if (error && options.onFunctionError) {
                    if (options.onFunctionError.call(rpc, error, method, args) === true) return;
                }
                if (!error) try {
                    await post(serialize({
                        t: $baa9e15afeaf047c$var$TYPE_RESPONSE,
                        i: msg.i,
                        r: result
                    }), ...extra);
                    return;
                } catch (e) {
                    error = e;
                    if (options.onGeneralError?.call(rpc, e, method, args) !== true) throw e;
                }
                try {
                    await post(serialize({
                        t: $baa9e15afeaf047c$var$TYPE_RESPONSE,
                        i: msg.i,
                        e: error
                    }), ...extra);
                } catch (e) {
                    if (options.onGeneralError?.call(rpc, e, method, args) !== true) throw e;
                }
            }
        } else {
            const { i: ack, r: result, e: error } = msg;
            const promise = _rpcPromiseMap.get(ack);
            if (promise) {
                $baa9e15afeaf047c$var$clearTimeout(promise.timeoutId);
                if (error) promise.reject(error);
                else promise.resolve(result);
            }
            _rpcPromiseMap.delete(ack);
        }
    }
    _promiseInit = on(onMessage);
    return rpc;
}
const $baa9e15afeaf047c$var$cacheMap = /* @__PURE__ */ new WeakMap();
function $baa9e15afeaf047c$export$c26b4cbcfe84a428(items, fn) {
    return items.map((i)=>{
        let r = $baa9e15afeaf047c$var$cacheMap.get(i);
        if (!r) {
            r = fn(i);
            $baa9e15afeaf047c$var$cacheMap.set(i, r);
        }
        return r;
    });
}
function $baa9e15afeaf047c$export$ec516731f3c62ae5(functions, channels, options = {}) {
    const getChannels = ()=>typeof channels === "function" ? channels() : channels;
    const getClients = (channels2 = getChannels())=>$baa9e15afeaf047c$export$c26b4cbcfe84a428(channels2, (s)=>$baa9e15afeaf047c$export$8de909a09ac6851a(functions, {
                ...options,
                ...s
            }));
    function _boardcast(method, args, event, optional) {
        const clients = getClients();
        return Promise.all(clients.map((c)=>c.$callRaw({
                method: method,
                args: args,
                event: event,
                optional: optional
            })));
    }
    function $call(method, ...args) {
        return _boardcast(method, args, false);
    }
    function $callOptional(method, ...args) {
        return _boardcast(method, args, false, true);
    }
    function $callEvent(method, ...args) {
        return _boardcast(method, args, true);
    }
    const broadcastBuiltin = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent
    };
    const broadcastProxy = new Proxy({}, {
        get (_, method) {
            if (Object.prototype.hasOwnProperty.call(broadcastBuiltin, method)) return broadcastBuiltin[method];
            const client = getClients();
            const callbacks = client.map((c)=>c[method]);
            const sendCall = (...args)=>{
                return Promise.all(callbacks.map((i)=>i(...args)));
            };
            sendCall.asEvent = async (...args)=>{
                await Promise.all(callbacks.map((i)=>i.asEvent(...args)));
            };
            return sendCall;
        }
    });
    function updateChannels(fn) {
        const channels2 = getChannels();
        fn?.(channels2);
        return getClients(channels2);
    }
    getClients();
    return {
        get clients () {
            return getClients();
        },
        functions: functions,
        updateChannels: updateChannels,
        broadcast: broadcastProxy,
        /**
     * @deprecated use `broadcast`
     */ // @ts-expect-error deprecated
        boardcast: broadcastProxy
    };
}
function $baa9e15afeaf047c$var$createPromiseWithResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
const $baa9e15afeaf047c$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
function $baa9e15afeaf047c$var$nanoid(size = 21) {
    let id = "";
    let i = size;
    while(i--)id += $baa9e15afeaf047c$var$urlAlphabet[$baa9e15afeaf047c$var$random() * 64 | 0];
    return id;
}

});



parcelRegister("graZq", function(module, exports) {

$parcel$export(module.exports, "useUploadStore", () => $bf77b14802833572$export$cca0db9d1e15c2d0);

var $i0TKe = parcelRequire("i0TKe");

var $cUvMp = parcelRequire("cUvMp");

var $lUp03 = parcelRequire("lUp03");

var $iS8eH = parcelRequire("iS8eH");

var $6zjtX = parcelRequire("6zjtX");

var $8I7XG = parcelRequire("8I7XG");

var $6PUuc = parcelRequire("6PUuc");

var $gByFP = parcelRequire("gByFP");

var $h8sKa = parcelRequire("h8sKa");
const $bf77b14802833572$var$t = (0, $iS8eH.default).global.t;
let $bf77b14802833572$var$_uploadInput = null;
let $bf77b14802833572$var$_cancelAdd = null;
const $bf77b14802833572$export$cca0db9d1e15c2d0 = (0, $i0TKe.defineStore)('upload', {
    state: ()=>({
            isAdding: false,
            activeFile: null,
            addingFiles: [],
            uploadingFiles: [],
            latestTime: 0
        }),
    getters: {
        currentAddingFiles: (state)=>{
            return state.activeFile ? [
                state.activeFile
            ] : state.addingFiles;
        },
        currentUploadingFiles: (state)=>{
            const commonStore = (0, $6zjtX.useCommonStore)();
            return state.uploadingFiles.filter((item)=>item.folderId == commonStore.folderId && item.space == commonStore.space);
        },
        isUploading: (state)=>{
            return state.uploadingFiles.filter((item)=>[
                    'analyzing',
                    'uploading'
                ].includes(item.status)).length > 0;
        }
    },
    actions: {
        setIsAdding (isAdding = false) {
            if (isAdding !== this.isAdding) {
                this.isAdding = isAdding;
                if (isAdding) $bf77b14802833572$var$_uploadInput.setAttribute('disabled', 'disabled');
                else $bf77b14802833572$var$_uploadInput.removeAttribute('disabled');
            }
        },
        init (id = 'models_upload', needReset = false) {
            (0, $gByFP.default).init();
            if ($bf77b14802833572$var$_uploadInput) {
                if (!needReset) return;
                this.clear();
            }
            if (id && !$bf77b14802833572$var$_uploadInput) {
                $bf77b14802833572$var$_uploadInput = document.createElement('input');
                $bf77b14802833572$var$_uploadInput.setAttribute('type', 'file');
                $bf77b14802833572$var$_uploadInput.setAttribute('id', id);
                $bf77b14802833572$var$_uploadInput.setAttribute('accept', [
                    'zip',
                    ...(0, $gByFP.FILE_TYPES)
                ].map((ext)=>`.${ext}`).join(','));
                $bf77b14802833572$var$_uploadInput.setAttribute('style', 'position: absolute; width: 0; height: 0; opacity: 0; top: 0; left: 0; user-select: none; pointer-events: none;');
                $bf77b14802833572$var$_uploadInput.addEventListener('change', this.addFileByInput);
                document.body.appendChild($bf77b14802833572$var$_uploadInput);
            }
        },
        clear () {
            this.isAdding = false;
            this.activeFile = null;
            this.addingFiles = [];
            this.uploadingFiles = [];
            if ($bf77b14802833572$var$_uploadInput) {
                $bf77b14802833572$var$_uploadInput.removeEventListener('change', this.addFileByInput);
                $bf77b14802833572$var$_uploadInput.remove();
                $bf77b14802833572$var$_uploadInput = null;
            }
            (0, $gByFP.default).clear();
        },
        clearAddCancel () {
            if ($bf77b14802833572$var$_cancelAdd) {
                $bf77b14802833572$var$_cancelAdd();
                $bf77b14802833572$var$_cancelAdd = null;
            }
        },
        clearAddingFiles () {
            this.addingFiles = [];
            this.clearAddCancel();
            this.setIsAdding(false);
            if ($bf77b14802833572$var$_uploadInput) $bf77b14802833572$var$_uploadInput.value = '';
            (0, $8I7XG.useListStore)().handleTooltips();
        },
        clearAll () {
            this.clearAddingFiles();
            this.activeFile = null;
        },
        openUploadPicker () {
            if (!$bf77b14802833572$var$_uploadInput) this.init();
            if ($bf77b14802833572$var$_uploadInput.showPicker) $bf77b14802833572$var$_uploadInput.showPicker();
            else $bf77b14802833572$var$_uploadInput.click();
        },
        async checkFileType (file) {
            const suffix = file.name.split('.').pop()?.toLowerCase();
            if (suffix === 'zip' && [
                'application/zip',
                'application/x-zip',
                'application/x-zip-compressed'
            ].includes(file.type)) {
                const zip = await (0, $lUp03.loadAsync)(file);
                const keys = Object.keys(zip.files);
                const supportFiles = [];
                let type = '';
                let modelFile = null;
                let mtlFile = null;
                for(let i = 0; i < keys.length; i++){
                    const key = keys[i];
                    const zipFile = zip.files[key];
                    const zipType = key?.toLowerCase() || '';
                    if (zipFile && !zipType.startsWith('__macosx')) {
                        const modelType = (0, $gByFP.FILE_TYPES).find((type)=>zipType.endsWith(`.${type}`));
                        if (modelType) {
                            const f = await zipFile.async('blob');
                            type = modelType;
                            modelFile = f;
                        } else if (zipType.endsWith('.mtl')) {
                            const f = await zipFile.async('blob');
                            mtlFile = f;
                        } else if ((0, $gByFP.SUPPORT_TYPES).findIndex((type)=>zipType.endsWith(`.${type}`)) > -1) {
                            const f = await zipFile.async('blob');
                            supportFiles.push({
                                name: zipFile.name,
                                file: f
                            });
                        }
                    }
                }
                return {
                    type: type,
                    modelFile: modelFile,
                    mtlFile: mtlFile,
                    supportFiles: supportFiles,
                    isZip: true
                };
            }
            return (0, $gByFP.FILE_TYPES).includes(suffix) ? {
                type: suffix,
                modelFile: file
            } : {
                type: '',
                modelFile: null
            };
        },
        async generateFileKey () {
            try {
                const fileKey = Math.random().toString(36).substring(2, 6);
                const res = await fetch(`${(0, $h8sKa.DEV_BASE_URL)}webModels/share/status`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem('SCANAT_TOKEN')
                    },
                    body: JSON.stringify({
                        fileKey: fileKey
                    })
                });
                const result = await res?.json();
                if (result?.code === 806) return fileKey;
                else return this.generateFileKey();
            } catch  {
                return this.generateFileKey();
            }
        },
        async _addFile (file, info = {}) {
            if (!this.isAdding) try {
                if (file) {
                    this.setIsAdding(true);
                    const commonStore = (0, $6zjtX.useCommonStore)();
                    const listStore = (0, $8I7XG.useListStore)();
                    if (file.size > 524288000) (0, $cUvMp.ElMessage)({
                        message: $bf77b14802833572$var$t('import.fileSizeLimit'),
                        type: 'warning'
                    });
                    else {
                        const { type: type, modelFile: modelFile, mtlFile: mtlFile, supportFiles: supportFiles, isZip: isZip } = await this.checkFileType(file);
                        if (info.cancelled) return;
                        if (type) {
                            const name = file.name.trim().slice(0, -(isZip ? 4 : type.length + 1));
                            if (name.length <= 20) {
                                if (this.activeFile) this.activeFile = {
                                    ...this.activeFile,
                                    name: name,
                                    type: type,
                                    file: file,
                                    modelFile: modelFile,
                                    mtlFile: mtlFile,
                                    supportFiles: supportFiles,
                                    isZip: isZip
                                };
                                else if (this.addingFiles.length === 1) // TODO vicky: 后续支持添加多个文件直接用下个分支
                                this.addingFiles[0] = {
                                    ...this.addingFiles[0],
                                    name: name,
                                    type: type,
                                    file: file,
                                    modelFile: modelFile,
                                    mtlFile: mtlFile,
                                    supportFiles: supportFiles,
                                    isZip: isZip
                                };
                                else {
                                    const info = {
                                        name: name,
                                        type: type,
                                        file: file,
                                        modelFile: modelFile,
                                        mtlFile: mtlFile,
                                        supportFiles: supportFiles,
                                        isZip: isZip,
                                        folderId: commonStore.folderId,
                                        space: commonStore.space,
                                        fileKey: await this.generateFileKey()
                                    };
                                    if (info.cancelled) return;
                                    this.addingFiles = [
                                        info
                                    ];
                                }
                                listStore.handleTooltips();
                            } else (0, $cUvMp.ElMessage)({
                                message: $bf77b14802833572$var$t('error.nameTooLong'),
                                type: 'warning'
                            });
                        } else (0, $cUvMp.ElMessage)({
                            message: $bf77b14802833572$var$t(isZip ? 'file.import.error.invalidFile' : 'import.wrongFormat'),
                            type: 'warning'
                        });
                    }
                    if ($bf77b14802833572$var$_uploadInput) $bf77b14802833572$var$_uploadInput.value = '';
                }
            } finally{
                this.setIsAdding(false);
            }
        },
        addFile (file) {
            if (!this.isAdding) {
                const info = {
                    cancelled: false
                };
                this._addFile(file, info);
                return ()=>{
                    info.cancelled = true;
                };
            }
        },
        addFileByInput () {
            if ($bf77b14802833572$var$_uploadInput) {
                const file = $bf77b14802833572$var$_uploadInput.files[0];
                this.addFileByDrop(file);
            }
        },
        addFileByDrop (file) {
            const cancelAdd = this.addFile(file);
            if (cancelAdd) {
                this.clearAddCancel();
                $bf77b14802833572$var$_cancelAdd = cancelAdd;
            }
        },
        appendAddingFiles () {
            if (this.activeFile) this.updateUploadingFile(this.activeFile, {
                ...this.activeFile,
                status: 'waiting',
                percent: 0
            });
            else this.uploadingFiles.push(...this.addingFiles);
            (0, $gByFP.default).appendQueue([
                ...this.currentAddingFiles
            ]);
            this.clearAll();
        },
        restartUploadingFile (file) {
            this.activeFile = file;
            (0, $6PUuc.useModalStore)().openModal('uploadInfo', {
                title: $bf77b14802833572$var$t('import.model')
            });
        },
        updateUploadingFile (info, data = {}) {
            const index = this.uploadingFiles.findIndex((item)=>item.fileKey === info.fileKey);
            if (index > -1) {
                const newInfo = {
                    ...this.uploadingFiles[index],
                    ...data
                };
                this.uploadingFiles[index] = newInfo;
                if (data.status === 'success') {
                    this.latestTime = Date.now();
                    const index = this.uploadingFiles.findIndex((item)=>item.fileKey === info.fileKey);
                    if (index > -1) this.uploadingFiles.splice(index, 1);
                }
            }
        }
    }
});

});
parcelRegister("cUvMp", function(module, exports) {

$parcel$export(module.exports, "ElMessage", () => $ecc822d6a35a1fd5$export$c50a58f7520ff7d2);

var $9U8vi = parcelRequire("9U8vi");


var $1bFPP = parcelRequire("1bFPP");
//#region ../../packages/components/message/index.ts
const $ecc822d6a35a1fd5$export$c50a58f7520ff7d2 = (0, $9U8vi.withInstallFunction)((0, $1bFPP.default), "$message");

});
parcelRegister("9U8vi", function(module, exports) {

$parcel$export(module.exports, "withInstall", () => $eb54a91488d21ec2$export$ffdb00514a54d83d);
$parcel$export(module.exports, "withInstallFunction", () => $eb54a91488d21ec2$export$31562801bbd00b3f);
$parcel$export(module.exports, "withInstallDirective", () => $eb54a91488d21ec2$export$71116210d1f960ed);
$parcel$export(module.exports, "withNoopInstall", () => $eb54a91488d21ec2$export$649091e5662200a);

var $8POXm = parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");

var $fpLZH = parcelRequire("fpLZH");
//#region ../../packages/utils/vue/install.ts
const $eb54a91488d21ec2$export$c769fc94c323e6ab = (target)=>{
    const _p = target.props;
    const props = (0, $8POXm.isArray)(_p) ? (0, $fpLZH.fromPairs)(_p.map((key)=>[
            key,
            {}
        ])) : _p;
    target.setPropsDefaults = (defaults)=>{
        if (!props) return;
        for (const [key, value] of Object.entries(defaults)){
            const prop = props[key];
            if (!(0, $8POXm.hasOwn)(props, key)) continue;
            if ((0, $fpLZH.isPlainObject)(prop)) {
                props[key] = {
                    ...prop,
                    default: value
                };
                continue;
            }
            props[key] = {
                type: prop,
                default: value
            };
        }
        target.props = props;
    };
};
const $eb54a91488d21ec2$export$ffdb00514a54d83d = (main, extra)=>{
    main.install = (app)=>{
        for (const comp of [
            main,
            ...Object.values(extra ?? {})
        ])app.component(comp.name, comp);
    };
    if (extra) for (const [key, comp] of Object.entries(extra))main[key] = comp;
    $eb54a91488d21ec2$export$c769fc94c323e6ab(main);
    return main;
};
const $eb54a91488d21ec2$export$31562801bbd00b3f = (fn, name)=>{
    fn.install = (app)=>{
        fn._context = app._context;
        app.config.globalProperties[name] = fn;
    };
    return fn;
};
const $eb54a91488d21ec2$export$71116210d1f960ed = (directive, name)=>{
    directive.install = (app)=>{
        app.directive(name, directive);
    };
    return directive;
};
const $eb54a91488d21ec2$export$649091e5662200a = (component)=>{
    component.install = (0, $8POXm.NOOP);
    $eb54a91488d21ec2$export$c769fc94c323e6ab(component);
    return component;
};

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isDate", () => $66ea9d0aaa418c4d$export$871608497c498473);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
/**
* @vue/shared v3.5.35
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-\w/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $66ea9d0aaa418c4d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$export$fc0748a8e0014066 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
const $66ea9d0aaa418c4d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $66ea9d0aaa418c4d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($66ea9d0aaa418c4d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? $66ea9d0aaa418c4d$var$isRef(val) ? $66ea9d0aaa418c4d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if ($66ea9d0aaa418c4d$var$isRef(val)) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});

parcelRegister("fpLZH", function(module, exports) {

module.exports = (parcelRequire("f1q41"));

});
parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});



parcelRegister("1bFPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5903c5ae90c405cc$export$2e2bcd8739ae039);
parcelRequire("cB44k");
var $aPZNl = parcelRequire("aPZNl");

var $7eXmP = parcelRequire("7eXmP");
var $8POXm = parcelRequire("8POXm");
var $8POXm = parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");

var $2YSiN = parcelRequire("2YSiN");

var $9OIed = parcelRequire("9OIed");

var $6sMT7 = parcelRequire("6sMT7");

var $8N8IR = parcelRequire("8N8IR");

var $bhgOI = parcelRequire("bhgOI");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
//#region ../../packages/components/message/src/method.ts
let $5903c5ae90c405cc$var$seed = 1;
const $5903c5ae90c405cc$var$normalizeAppendTo = (normalized)=>{
    if (!normalized.appendTo) normalized.appendTo = document.body;
    else if ((0, $8POXm.isString)(normalized.appendTo)) {
        let appendTo = document.querySelector(normalized.appendTo);
        if (!(0, $7eXmP.isElement)(appendTo)) {
            (0, $2YSiN.debugWarn)("ElMessage", "the appendTo option is not an HTMLElement. Falling back to document.body.");
            appendTo = document.body;
        }
        normalized.appendTo = appendTo;
    }
};
const $5903c5ae90c405cc$var$normalizePlacement = (normalized)=>{
    if (!normalized.placement && (0, $8POXm.isString)((0, $9OIed.messageConfig).placement) && (0, $9OIed.messageConfig).placement) normalized.placement = (0, $9OIed.messageConfig).placement;
    if (!normalized.placement) normalized.placement = "top";
    if (!(0, $6sMT7.messagePlacement).includes(normalized.placement)) {
        (0, $2YSiN.debugWarn)("ElMessage", `Invalid placement: ${normalized.placement}. Falling back to 'top'.`);
        normalized.placement = "top";
    }
};
const $5903c5ae90c405cc$var$normalizeOptions = (params)=>{
    const options = !params || (0, $8POXm.isString)(params) || (0, $TusQn.isVNode)(params) || (0, $8POXm.isFunction)(params) ? {
        message: params
    } : params;
    const normalized = {
        ...(0, $6sMT7.messageDefaults),
        ...options
    };
    $5903c5ae90c405cc$var$normalizeAppendTo(normalized);
    $5903c5ae90c405cc$var$normalizePlacement(normalized);
    if ((0, $7eXmP.isBoolean)((0, $9OIed.messageConfig).grouping) && !normalized.grouping) normalized.grouping = (0, $9OIed.messageConfig).grouping;
    if ((0, $7eXmP.isNumber)((0, $9OIed.messageConfig).duration) && normalized.duration === 3e3) normalized.duration = (0, $9OIed.messageConfig).duration;
    if ((0, $7eXmP.isNumber)((0, $9OIed.messageConfig).offset) && normalized.offset === 16) normalized.offset = (0, $9OIed.messageConfig).offset;
    if ((0, $7eXmP.isBoolean)((0, $9OIed.messageConfig).showClose) && !normalized.showClose) normalized.showClose = (0, $9OIed.messageConfig).showClose;
    if ((0, $7eXmP.isBoolean)((0, $9OIed.messageConfig).plain) && !normalized.plain) normalized.plain = (0, $9OIed.messageConfig).plain;
    return normalized;
};
const $5903c5ae90c405cc$var$closeMessage = (instance)=>{
    const instances = (0, $8N8IR.placementInstances)[instance.props.placement || "top"];
    const idx = instances.indexOf(instance);
    if (idx === -1) return;
    instances.splice(idx, 1);
    const { handler: handler } = instance;
    handler.close();
};
const $5903c5ae90c405cc$var$createMessage = ({ appendTo: appendTo, ...options }, context)=>{
    const id = `message_${$5903c5ae90c405cc$var$seed++}`;
    const userOnClose = options.onClose;
    const container = document.createElement("div");
    const props = {
        ...options,
        id: id,
        onClose: ()=>{
            userOnClose?.();
            $5903c5ae90c405cc$var$closeMessage(instance);
        },
        onDestroy: ()=>{
            (0, $eeJ70.render)(null, container);
        }
    };
    const vnode = (0, $TusQn.createVNode)((0, $bhgOI.default), props, (0, $8POXm.isFunction)(props.message) || (0, $TusQn.isVNode)(props.message) ? {
        default: (0, $8POXm.isFunction)(props.message) ? props.message : ()=>props.message
    } : null);
    vnode.appContext = context || $5903c5ae90c405cc$export$2e2bcd8739ae039._context;
    (0, $eeJ70.render)(vnode, container);
    appendTo.appendChild(container.firstElementChild);
    const vm = vnode.component;
    const instance = {
        id: id,
        vnode: vnode,
        vm: vm,
        handler: {
            close: ()=>{
                vm.exposed.close();
            }
        },
        props: vnode.component.props
    };
    return instance;
};
const $5903c5ae90c405cc$export$2e2bcd8739ae039 = (options = {}, context)=>{
    if (!(0, $aPZNl.isClient)) return {
        close: ()=>void 0
    };
    const normalized = $5903c5ae90c405cc$var$normalizeOptions(options);
    const instances = (0, $8N8IR.getOrCreatePlacementInstances)(normalized.placement || "top");
    if (normalized.grouping && instances.length) {
        const instance = instances.find(({ vnode: vm })=>vm.props?.message === normalized.message);
        if (instance) {
            instance.props.repeatNum += 1;
            instance.props.type = normalized.type;
            return instance.handler;
        }
    }
    if ((0, $7eXmP.isNumber)((0, $9OIed.messageConfig).max) && instances.length >= (0, $9OIed.messageConfig).max) return {
        close: ()=>void 0
    };
    const instance = $5903c5ae90c405cc$var$createMessage(normalized, context);
    instances.push(instance);
    return instance.handler;
};
(0, $6sMT7.messageTypes).forEach((type)=>{
    $5903c5ae90c405cc$export$2e2bcd8739ae039[type] = (options = {}, appContext)=>{
        return $5903c5ae90c405cc$export$2e2bcd8739ae039({
            ...$5903c5ae90c405cc$var$normalizeOptions(options),
            type: type
        }, appContext);
    };
});
function $5903c5ae90c405cc$export$c1c4edbd62f57e70(type) {
    for(const placement in 0, $8N8IR.placementInstances)if ((0, $8POXm.hasOwn)((0, $8N8IR.placementInstances), placement)) {
        const instances = [
            ...(0, $8N8IR.placementInstances)[placement]
        ];
        for (const instance of instances)if (!type || type === instance.props.type) instance.handler.close();
    }
}
function $5903c5ae90c405cc$export$69ce00c806b543c3(placement) {
    if (!(0, $8N8IR.placementInstances)[placement]) return;
    [
        ...(0, $8N8IR.placementInstances)[placement]
    ].forEach((instance)=>instance.handler.close());
}
$5903c5ae90c405cc$export$2e2bcd8739ae039.closeAll = $5903c5ae90c405cc$export$c1c4edbd62f57e70;
$5903c5ae90c405cc$export$2e2bcd8739ae039.closeAllByPlacement = $5903c5ae90c405cc$export$69ce00c806b543c3;
$5903c5ae90c405cc$export$2e2bcd8739ae039._context = null;

});
parcelRegister("cB44k", function(module, exports) {

$parcel$export(module.exports, "isFirefox", () => $650f605a759b1717$export$b7d78993b74f766d);
$parcel$export(module.exports, "isAndroid", () => $650f605a759b1717$export$a11b0059900ceec8);
$parcel$export(module.exports, "isClient", () => (parcelRequire("aPZNl")).isClient);

var $aPZNl = parcelRequire("aPZNl");
//#region ../../packages/utils/browser.ts
const $650f605a759b1717$export$b7d78993b74f766d = ()=>(0, $aPZNl.isClient) && /firefox/i.test(window.navigator.userAgent);
const $650f605a759b1717$export$a11b0059900ceec8 = ()=>(0, $aPZNl.isClient) && /android/i.test(window.navigator.userAgent);

});
parcelRegister("aPZNl", function(module, exports) {

$parcel$export(module.exports, "computedEager", () => $7e3e99f445db3d3b$export$c92323792c35f5f1);
$parcel$export(module.exports, "computedWithControl", () => $7e3e99f445db3d3b$export$220dfb31330e2956);
$parcel$export(module.exports, "tryOnScopeDispose", () => $7e3e99f445db3d3b$export$c3d49ae4e58d3d9d);
$parcel$export(module.exports, "createEventHook", () => $7e3e99f445db3d3b$export$c8b3b0996d763ee);
$parcel$export(module.exports, "injectLocal", () => $7e3e99f445db3d3b$export$89897216f9bf9933);
$parcel$export(module.exports, "provideLocal", () => $7e3e99f445db3d3b$export$a797c3886d31ed0);
$parcel$export(module.exports, "createRef", () => $7e3e99f445db3d3b$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "isClient", () => $7e3e99f445db3d3b$export$7383f122bf48ec30);
$parcel$export(module.exports, "isWorker", () => $7e3e99f445db3d3b$export$3c901a5f01941a06);
$parcel$export(module.exports, "isDef", () => $7e3e99f445db3d3b$export$7b816c9b8ecf71b4);
$parcel$export(module.exports, "notNullish", () => $7e3e99f445db3d3b$export$aedb69ff3e31596c);
$parcel$export(module.exports, "isObject", () => $7e3e99f445db3d3b$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "timestamp", () => $7e3e99f445db3d3b$export$fc00ee57782020aa);
$parcel$export(module.exports, "clamp", () => $7e3e99f445db3d3b$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "noop", () => $7e3e99f445db3d3b$export$8793edee2d425525);
$parcel$export(module.exports, "hasOwn", () => $7e3e99f445db3d3b$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isIOS", () => $7e3e99f445db3d3b$export$fedb369cb70207f1);
$parcel$export(module.exports, "toRef", () => $7e3e99f445db3d3b$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "createFilterWrapper", () => $7e3e99f445db3d3b$export$a1f1cf91007f23bf);
$parcel$export(module.exports, "bypassFilter", () => $7e3e99f445db3d3b$export$8cc0e33a27868391);
$parcel$export(module.exports, "debounceFilter", () => $7e3e99f445db3d3b$export$fca2c450ae03b38e);
$parcel$export(module.exports, "throttleFilter", () => $7e3e99f445db3d3b$export$cd62e9dbf204fd92);
$parcel$export(module.exports, "pausableFilter", () => $7e3e99f445db3d3b$export$8d46ce8e0ead9c2b);
$parcel$export(module.exports, "promiseTimeout", () => $7e3e99f445db3d3b$export$69e8b3daf72c74b7);
$parcel$export(module.exports, "identity", () => $7e3e99f445db3d3b$export$f0954fd7d5368655);
$parcel$export(module.exports, "createSingletonPromise", () => $7e3e99f445db3d3b$export$7a0c7c93e8e22bce);
$parcel$export(module.exports, "containsProp", () => $7e3e99f445db3d3b$export$d138bf93e1dfa23f);
$parcel$export(module.exports, "increaseWithUnit", () => $7e3e99f445db3d3b$export$f5c97f6a04b90212);
$parcel$export(module.exports, "pxValue", () => $7e3e99f445db3d3b$export$e3ee541f3ff8ee70);
$parcel$export(module.exports, "objectPick", () => $7e3e99f445db3d3b$export$5f2d71bd504be1ec);
$parcel$export(module.exports, "objectOmit", () => $7e3e99f445db3d3b$export$3320623908f24e40);
$parcel$export(module.exports, "objectEntries", () => $7e3e99f445db3d3b$export$6a29ade99f81ec8a);
$parcel$export(module.exports, "toArray", () => $7e3e99f445db3d3b$export$45b10814cc054894);
$parcel$export(module.exports, "camelize", () => $7e3e99f445db3d3b$export$161d051f5dd25de7);
$parcel$export(module.exports, "makeDestructurable", () => $7e3e99f445db3d3b$export$d50fdd10db75504e);
$parcel$export(module.exports, "reactiveComputed", () => $7e3e99f445db3d3b$export$35298289c11958e1);
$parcel$export(module.exports, "useDebounceFn", () => $7e3e99f445db3d3b$export$ddf8f1aa96b8ea88);
$parcel$export(module.exports, "refDebounced", () => $7e3e99f445db3d3b$export$8c510297518aecb4);
$parcel$export(module.exports, "useThrottleFn", () => $7e3e99f445db3d3b$export$8ed85856108010bc);
$parcel$export(module.exports, "watchWithFilter", () => $7e3e99f445db3d3b$export$3955c00bb6715986);
$parcel$export(module.exports, "watchPausable", () => $7e3e99f445db3d3b$export$88467b54a7b59d4);
$parcel$export(module.exports, "syncRef", () => $7e3e99f445db3d3b$export$d43743c1df800be0);
$parcel$export(module.exports, "toRefs", () => $7e3e99f445db3d3b$export$2e9533675e5e70e0);
$parcel$export(module.exports, "tryOnMounted", () => $7e3e99f445db3d3b$export$cf1be5b643f0827);
$parcel$export(module.exports, "tryOnUnmounted", () => $7e3e99f445db3d3b$export$9fa6e59ca833c930);
$parcel$export(module.exports, "until", () => $7e3e99f445db3d3b$export$a40009bd2c363351);
$parcel$export(module.exports, "useIntervalFn", () => $7e3e99f445db3d3b$export$35ee30a05e4f2223);
$parcel$export(module.exports, "useTimeoutFn", () => $7e3e99f445db3d3b$export$14705c14c13d528a);
$parcel$export(module.exports, "watchIgnorable", () => $7e3e99f445db3d3b$export$3a6f8a7df9ef7264);
$parcel$export(module.exports, "watchImmediate", () => $7e3e99f445db3d3b$export$d9aec7ec4e8a1634);
$parcel$export(module.exports, "watchOnce", () => $7e3e99f445db3d3b$export$95d4a8ca30b80ae0);
$parcel$export(module.exports, "whenever", () => $7e3e99f445db3d3b$export$909eba9696cc3445);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
//#region computedEager/index.ts
/**
*
* @deprecated This function will be removed in future version.
*
* Note: If you are using Vue 3.4+, you can straight use computed instead.
* Because in Vue 3.4+, if computed new value does not change,
* computed, effect, watch, watchEffect, render dependencies will not be triggered.
* refer: https://github.com/vuejs/core/pull/5912
*
* @param fn effect function
* @param options WatchOptionsBase
* @returns readonly shallowRef
*/ function $7e3e99f445db3d3b$export$c92323792c35f5f1(fn, options) {
    var _options$flush;
    const result = (0, $01W3b.shallowRef)();
    (0, $TusQn.watchEffect)(()=>{
        result.value = fn();
    }, {
        ...options,
        flush: (_options$flush = options === null || options === void 0 ? void 0 : options.flush) !== null && _options$flush !== void 0 ? _options$flush : "sync"
    });
    return (0, $01W3b.readonly)(result);
}
/** @deprecated use `computedEager` instead */ const $7e3e99f445db3d3b$export$ed24b95ee94e63cc = $7e3e99f445db3d3b$export$c92323792c35f5f1;
//#endregion
//#region computedWithControl/index.ts
/**
* Explicitly define the deps of computed.
*
* @param source
* @param fn
*/ function $7e3e99f445db3d3b$export$220dfb31330e2956(source, fn, options = {}) {
    let v = void 0;
    let track;
    let trigger;
    let dirty = true;
    const update = ()=>{
        dirty = true;
        trigger();
    };
    (0, $01W3b.watch)(source, update, {
        flush: "sync",
        ...options
    });
    const get = typeof fn === "function" ? fn : fn.get;
    const set = typeof fn === "function" ? void 0 : fn.set;
    const result = (0, $01W3b.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                if (dirty) {
                    v = get(v);
                    dirty = false;
                }
                track();
                return v;
            },
            set (v) {
                set === null || set === void 0 || set(v);
            }
        };
    });
    result.trigger = update;
    return result;
}
/** @deprecated use `computedWithControl` instead */ const $7e3e99f445db3d3b$export$dbcb108a1500a704 = $7e3e99f445db3d3b$export$220dfb31330e2956;
//#endregion
//#region createDisposableDirective/index.ts
/**
* Utility for authoring disposable directives. Reactive effects created within `mounted` directive hook will be tracked and automatically disposed when directive is unmounted.
*
* @see https://vueuse.org/createDisposableDirective
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$f563fa6b47d21a6b(origin = {}) {
    function isFunc(fn) {
        return typeof fn === "function";
    }
    const normalisedOrigin = isFunc(origin) ? {
        mounted: origin,
        updated: origin
    } : origin;
    const { mounted: mounted, unmounted: unmounted } = normalisedOrigin;
    if (!isFunc(mounted)) return origin;
    const scopeWeakMap = /* @__PURE__ */ new WeakMap();
    return {
        ...normalisedOrigin,
        mounted (el, binding, vNode, prevNode) {
            var _scopeWeakMap$get;
            const scope = (_scopeWeakMap$get = scopeWeakMap.get(el)) !== null && _scopeWeakMap$get !== void 0 ? _scopeWeakMap$get : (0, $01W3b.effectScope)();
            scopeWeakMap.set(el, scope);
            scope.run(()=>{
                mounted === null || mounted === void 0 || mounted(el, binding, vNode, prevNode);
            });
        },
        unmounted (el, binding, vNode, prevNode) {
            var _scopeWeakMap$get2;
            (_scopeWeakMap$get2 = scopeWeakMap.get(el)) === null || _scopeWeakMap$get2 === void 0 || _scopeWeakMap$get2.stop();
            scopeWeakMap.delete(el);
            if (isFunc(unmounted)) unmounted(el, binding, vNode, prevNode);
        }
    };
}
//#endregion
//#region tryOnScopeDispose/index.ts
/**
* Call onScopeDispose() if it's inside an effect scope lifecycle, if not, do nothing
*
* @param fn
*/ function $7e3e99f445db3d3b$export$c3d49ae4e58d3d9d(fn, failSilently) {
    if ((0, $01W3b.getCurrentScope)()) {
        (0, $01W3b.onScopeDispose)(fn, failSilently);
        return true;
    }
    return false;
}
//#endregion
//#region createEventHook/index.ts
/**
* Utility for creating event hooks
*
* @see https://vueuse.org/createEventHook
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$c8b3b0996d763ee() {
    const fns = /* @__PURE__ */ new Set();
    const off = (fn)=>{
        fns.delete(fn);
    };
    const clear = ()=>{
        fns.clear();
    };
    const on = (fn)=>{
        fns.add(fn);
        const offFn = ()=>off(fn);
        $7e3e99f445db3d3b$export$c3d49ae4e58d3d9d(offFn);
        return {
            off: offFn
        };
    };
    const trigger = (...args)=>{
        return Promise.all(Array.from(fns).map((fn)=>fn(...args)));
    };
    return {
        on: on,
        off: off,
        trigger: trigger,
        clear: clear
    };
}
//#endregion
//#region createGlobalState/index.ts
/**
* Keep states in the global scope to be reusable across Vue instances.
*
* @see https://vueuse.org/createGlobalState
* @param stateFactory A factory function to create the state
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$aa9aac23b3959ee1(stateFactory) {
    let initialized = false;
    let state;
    const scope = (0, $01W3b.effectScope)(true);
    return (...args)=>{
        if (!initialized) {
            state = scope.run(()=>stateFactory(...args));
            initialized = true;
        }
        return state;
    };
}
//#endregion
//#region provideLocal/map.ts
const $7e3e99f445db3d3b$var$localProvidedStateMap = /* @__PURE__ */ new WeakMap();
//#endregion
//#region injectLocal/index.ts
/**
* On the basis of `inject`, it is allowed to directly call inject to obtain the value after call provide in the same component.
*
* @example
* ```ts
* injectLocal('MyInjectionKey', 1)
* const injectedValue = injectLocal('MyInjectionKey') // injectedValue === 1
* ```
*
* @__NO_SIDE_EFFECTS__
*/ const $7e3e99f445db3d3b$export$89897216f9bf9933 = (...args)=>{
    var _getCurrentInstance;
    const key = args[0];
    const instance = (_getCurrentInstance = (0, $TusQn.getCurrentInstance)()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy;
    const owner = instance !== null && instance !== void 0 ? instance : (0, $01W3b.getCurrentScope)();
    if (owner == null && !(0, $TusQn.hasInjectionContext)()) throw new Error("injectLocal must be called in setup");
    if (owner && $7e3e99f445db3d3b$var$localProvidedStateMap.has(owner) && key in $7e3e99f445db3d3b$var$localProvidedStateMap.get(owner)) return $7e3e99f445db3d3b$var$localProvidedStateMap.get(owner)[key];
    return (0, $TusQn.inject)(...args);
};
//#endregion
//#region provideLocal/index.ts
/**
* On the basis of `provide`, it is allowed to directly call inject to obtain the value after call provide in the same component.
*
* @example
* ```ts
* provideLocal('MyInjectionKey', 1)
* const injectedValue = injectLocal('MyInjectionKey') // injectedValue === 1
* ```
*/ function $7e3e99f445db3d3b$export$a797c3886d31ed0(key, value) {
    var _getCurrentInstance;
    const instance = (_getCurrentInstance = (0, $TusQn.getCurrentInstance)()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy;
    const owner = instance !== null && instance !== void 0 ? instance : (0, $01W3b.getCurrentScope)();
    if (owner == null) throw new Error("provideLocal must be called in setup");
    if (!$7e3e99f445db3d3b$var$localProvidedStateMap.has(owner)) $7e3e99f445db3d3b$var$localProvidedStateMap.set(owner, Object.create(null));
    const localProvidedState = $7e3e99f445db3d3b$var$localProvidedStateMap.get(owner);
    localProvidedState[key] = value;
    return (0, $TusQn.provide)(key, value);
}
//#endregion
//#region createInjectionState/index.ts
function $7e3e99f445db3d3b$export$91b9c7550061230e(composable, options) {
    const key = (options === null || options === void 0 ? void 0 : options.injectionKey) || Symbol(composable.name || "InjectionState");
    const defaultValue = options === null || options === void 0 ? void 0 : options.defaultValue;
    const useProvidingState = (...args)=>{
        const state = composable(...args);
        $7e3e99f445db3d3b$export$a797c3886d31ed0(key, state);
        return state;
    };
    const useInjectedState = ()=>$7e3e99f445db3d3b$export$89897216f9bf9933(key, defaultValue);
    return [
        useProvidingState,
        useInjectedState
    ];
}
//#endregion
//#region createRef/index.ts
/**
* Returns a `deepRef` or `shallowRef` depending on the `deep` param.
*
* @example createRef(1) // ShallowRef<number>
* @example createRef(1, false) // ShallowRef<number>
* @example createRef(1, true) // Ref<number>
* @example createRef("string") // ShallowRef<string>
* @example createRef<"A"|"B">("A", true) // Ref<"A"|"B">
*
* @param value
* @param deep
* @returns the `deepRef` or `shallowRef`
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$7d1e3a5e95ceca43(value, deep) {
    if (deep === true) return (0, $01W3b.ref)(value);
    else return (0, $01W3b.shallowRef)(value);
}
//#endregion
//#region utils/is.ts
const $7e3e99f445db3d3b$export$7383f122bf48ec30 = typeof window !== "undefined" && typeof document !== "undefined";
const $7e3e99f445db3d3b$export$3c901a5f01941a06 = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const $7e3e99f445db3d3b$export$7b816c9b8ecf71b4 = (val)=>typeof val !== "undefined";
const $7e3e99f445db3d3b$export$aedb69ff3e31596c = (val)=>val != null;
const $7e3e99f445db3d3b$export$a7a9523472993e97 = (condition, ...infos)=>{
    if (!condition) console.warn(...infos);
};
const $7e3e99f445db3d3b$var$toString = Object.prototype.toString;
const $7e3e99f445db3d3b$export$a6cdc56e425d0d0a = (val)=>$7e3e99f445db3d3b$var$toString.call(val) === "[object Object]";
const $7e3e99f445db3d3b$export$461939dd4422153 = ()=>Date.now();
const $7e3e99f445db3d3b$export$fc00ee57782020aa = ()=>+Date.now();
const $7e3e99f445db3d3b$export$7d15b64cf5a3a4c4 = (n, min, max)=>Math.min(max, Math.max(min, n));
const $7e3e99f445db3d3b$export$8793edee2d425525 = ()=>{};
const $7e3e99f445db3d3b$export$bb0a9c36cf454ea0 = (min, max)=>{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
const $7e3e99f445db3d3b$export$b5a638e9b3fff9f3 = (val, key)=>Object.hasOwn(val, key);
const $7e3e99f445db3d3b$export$fedb369cb70207f1 = /* @__PURE__ */ $7e3e99f445db3d3b$var$getIsIOS();
function $7e3e99f445db3d3b$var$getIsIOS() {
    var _window, _window2, _window3;
    return $7e3e99f445db3d3b$export$7383f122bf48ec30 && !!((_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.navigator) === null || _window2 === void 0 ? void 0 : _window2.maxTouchPoints) > 2 && /iPad|Macintosh/.test((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.navigator.userAgent));
}
//#endregion
//#region toRef/index.ts
function $7e3e99f445db3d3b$export$1f60508e4f47b4b7(...args) {
    if (args.length !== 1) return (0, $01W3b.toRef)(...args);
    const r = args[0];
    return typeof r === "function" ? (0, $01W3b.readonly)((0, $01W3b.customRef)(()=>({
            get: r,
            set: $7e3e99f445db3d3b$export$8793edee2d425525
        }))) : (0, $01W3b.ref)(r);
}
//#endregion
//#region utils/filters.ts
/**
* @internal
*/ function $7e3e99f445db3d3b$export$a1f1cf91007f23bf(filter, fn) {
    function wrapper(...args) {
        return new Promise((resolve, reject)=>{
            Promise.resolve(filter(()=>fn.apply(this, args), {
                fn: fn,
                thisArg: this,
                args: args
            })).then(resolve).catch(reject);
        });
    }
    return wrapper;
}
const $7e3e99f445db3d3b$export$8cc0e33a27868391 = (invoke)=>{
    return invoke();
};
/**
* Create an EventFilter that debounce the events
*/ function $7e3e99f445db3d3b$export$fca2c450ae03b38e(ms, options = {}) {
    let timer;
    let maxTimer;
    let lastRejector = $7e3e99f445db3d3b$export$8793edee2d425525;
    const _clearTimeout = (timer)=>{
        clearTimeout(timer);
        lastRejector();
        lastRejector = $7e3e99f445db3d3b$export$8793edee2d425525;
    };
    let lastInvoker;
    const filter = (invoke)=>{
        const duration = (0, $01W3b.toValue)(ms);
        const maxDuration = (0, $01W3b.toValue)(options.maxWait);
        if (timer) _clearTimeout(timer);
        if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
            if (maxTimer) {
                _clearTimeout(maxTimer);
                maxTimer = void 0;
            }
            return Promise.resolve(invoke());
        }
        return new Promise((resolve, reject)=>{
            lastRejector = options.rejectOnCancel ? reject : resolve;
            lastInvoker = invoke;
            if (maxDuration && !maxTimer) maxTimer = setTimeout(()=>{
                if (timer) _clearTimeout(timer);
                maxTimer = void 0;
                resolve(lastInvoker());
            }, maxDuration);
            timer = setTimeout(()=>{
                if (maxTimer) _clearTimeout(maxTimer);
                maxTimer = void 0;
                resolve(invoke());
            }, duration);
        });
    };
    return filter;
}
function $7e3e99f445db3d3b$export$cd62e9dbf204fd92(...args) {
    let lastExec = 0;
    let timer;
    let isLeading = true;
    let lastRejector = $7e3e99f445db3d3b$export$8793edee2d425525;
    let lastValue;
    let ms;
    let trailing;
    let leading;
    let rejectOnCancel;
    if (!(0, $01W3b.isRef)(args[0]) && typeof args[0] === "object") ({ delay: ms, trailing: trailing = true, leading: leading = true, rejectOnCancel: rejectOnCancel = false } = args[0]);
    else [ms, trailing = true, leading = true, rejectOnCancel = false] = args;
    const clear = ()=>{
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
            lastRejector();
            lastRejector = $7e3e99f445db3d3b$export$8793edee2d425525;
        }
    };
    const filter = (_invoke)=>{
        const duration = (0, $01W3b.toValue)(ms);
        const elapsed = Date.now() - lastExec;
        const invoke = ()=>{
            return lastValue = _invoke();
        };
        clear();
        if (duration <= 0) {
            lastExec = Date.now();
            return invoke();
        }
        if (elapsed > duration) {
            lastExec = Date.now();
            if (leading || !isLeading) invoke();
        } else if (trailing) lastValue = new Promise((resolve, reject)=>{
            lastRejector = rejectOnCancel ? reject : resolve;
            timer = setTimeout(()=>{
                lastExec = Date.now();
                isLeading = true;
                resolve(invoke());
                clear();
            }, Math.max(0, duration - elapsed));
        });
        if (!leading && !timer) timer = setTimeout(()=>isLeading = true, duration);
        isLeading = false;
        return lastValue;
    };
    return filter;
}
/**
* EventFilter that gives extra controls to pause and resume the filter
*
* @param extendFilter  Extra filter to apply when the PausableFilter is active, default to none
* @param options Options to configure the filter
*/ function $7e3e99f445db3d3b$export$8d46ce8e0ead9c2b(extendFilter = $7e3e99f445db3d3b$export$8cc0e33a27868391, options = {}) {
    const { initialState: initialState = "active" } = options;
    const isActive = $7e3e99f445db3d3b$export$1f60508e4f47b4b7(initialState === "active");
    function pause() {
        isActive.value = false;
    }
    function resume() {
        isActive.value = true;
    }
    const eventFilter = (...args)=>{
        if (isActive.value) extendFilter(...args);
    };
    return {
        isActive: (0, $01W3b.shallowReadonly)(isActive),
        pause: pause,
        resume: resume,
        eventFilter: eventFilter
    };
}
//#endregion
//#region utils/general.ts
function $7e3e99f445db3d3b$export$69e8b3daf72c74b7(ms, throwOnTimeout = false, reason = "Timeout") {
    return new Promise((resolve, reject)=>{
        if (throwOnTimeout) setTimeout(reject, ms, reason);
        else setTimeout(resolve, ms);
    });
}
function $7e3e99f445db3d3b$export$f0954fd7d5368655(arg) {
    return arg;
}
/**
* Create singleton promise function
*
* @example
* ```
* const promise = createSingletonPromise(async () => { ... })
*
* await promise()
* await promise() // all of them will be bind to a single promise instance
* await promise() // and be resolved together
* ```
*/ function $7e3e99f445db3d3b$export$7a0c7c93e8e22bce(fn) {
    let _promise;
    function wrapper() {
        if (!_promise) _promise = fn();
        return _promise;
    }
    wrapper.reset = async ()=>{
        const _prev = _promise;
        _promise = void 0;
        if (_prev) await _prev;
    };
    return wrapper;
}
function $7e3e99f445db3d3b$export$468cda29b159ee5d(fn) {
    return fn();
}
function $7e3e99f445db3d3b$export$d138bf93e1dfa23f(obj, ...props) {
    return props.some((k)=>k in obj);
}
function $7e3e99f445db3d3b$export$f5c97f6a04b90212(target, delta) {
    var _target$match;
    if (typeof target === "number") return target + delta;
    const value = ((_target$match = target.match(/^-?\d+\.?\d*/)) === null || _target$match === void 0 ? void 0 : _target$match[0]) || "";
    const unit = target.slice(value.length);
    const result = Number.parseFloat(value) + delta;
    if (Number.isNaN(result)) return target;
    return result + unit;
}
/**
* Get a px value for SSR use, do not rely on this method outside of SSR as REM unit is assumed at 16px, which might not be the case on the client
*/ function $7e3e99f445db3d3b$export$e3ee541f3ff8ee70(px) {
    return px.endsWith("rem") ? Number.parseFloat(px) * 16 : Number.parseFloat(px);
}
/**
* Create a new subset object by giving keys
*/ function $7e3e99f445db3d3b$export$5f2d71bd504be1ec(obj, keys, omitUndefined = false) {
    return keys.reduce((n, k)=>{
        if (k in obj) {
            if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
        }
        return n;
    }, {});
}
/**
* Create a new subset object by omit giving keys
*/ function $7e3e99f445db3d3b$export$3320623908f24e40(obj, keys, omitUndefined = false) {
    return Object.fromEntries(Object.entries(obj).filter(([key, value])=>{
        return (!omitUndefined || value !== void 0) && !keys.includes(key);
    }));
}
function $7e3e99f445db3d3b$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $7e3e99f445db3d3b$export$45b10814cc054894(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
//#endregion
//#region utils/port.ts
function $7e3e99f445db3d3b$var$cacheStringFunction(fn) {
    const cache = Object.create(null);
    return (str)=>{
        return cache[str] || (cache[str] = fn(str));
    };
}
const $7e3e99f445db3d3b$var$hyphenateRE = /\B([A-Z])/g;
const $7e3e99f445db3d3b$export$6e6a0a3676c4b8bb = $7e3e99f445db3d3b$var$cacheStringFunction((str)=>str.replace($7e3e99f445db3d3b$var$hyphenateRE, "-$1").toLowerCase());
const $7e3e99f445db3d3b$var$camelizeRE = /-(\w)/g;
const $7e3e99f445db3d3b$export$161d051f5dd25de7 = $7e3e99f445db3d3b$var$cacheStringFunction((str)=>{
    return str.replace($7e3e99f445db3d3b$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
//#endregion
//#region utils/vue.ts
function $7e3e99f445db3d3b$export$5c967efe8efb656c(target) {
    return target || (0, $TusQn.getCurrentInstance)();
}
//#endregion
//#region createSharedComposable/index.ts
/**
* Make a composable function usable with multiple Vue instances.
*
* @see https://vueuse.org/createSharedComposable
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$9e8d4b001a1bb310(composable) {
    if (!$7e3e99f445db3d3b$export$7383f122bf48ec30) return composable;
    let subscribers = 0;
    let state;
    let scope;
    const dispose = ()=>{
        subscribers -= 1;
        if (scope && subscribers <= 0) {
            scope.stop();
            state = void 0;
            scope = void 0;
        }
    };
    return (...args)=>{
        subscribers += 1;
        if (!scope) {
            scope = (0, $01W3b.effectScope)(true);
            state = scope.run(()=>composable(...args));
        }
        $7e3e99f445db3d3b$export$c3d49ae4e58d3d9d(dispose);
        return state;
    };
}
//#endregion
//#region extendRef/index.ts
function $7e3e99f445db3d3b$export$ecda8b07a1b5deab(ref, extend, { enumerable: enumerable = false, unwrap: unwrap = true } = {}) {
    for (const [key, value] of Object.entries(extend)){
        if (key === "value") continue;
        if ((0, $01W3b.isRef)(value) && unwrap) Object.defineProperty(ref, key, {
            get () {
                return value.value;
            },
            set (v) {
                value.value = v;
            },
            enumerable: enumerable
        });
        else Object.defineProperty(ref, key, {
            value: value,
            enumerable: enumerable
        });
    }
    return ref;
}
//#endregion
//#region get/index.ts
function $7e3e99f445db3d3b$export$3988ae62b71be9a3(obj, key) {
    if (key == null) return (0, $01W3b.unref)(obj);
    return (0, $01W3b.unref)(obj)[key];
}
//#endregion
//#region isDefined/index.ts
function $7e3e99f445db3d3b$export$4e62c701997796c1(v) {
    return (0, $01W3b.unref)(v) != null;
}
//#endregion
//#region makeDestructurable/index.ts
/* @__NO_SIDE_EFFECTS__ */ function $7e3e99f445db3d3b$export$d50fdd10db75504e(obj, arr) {
    if (typeof Symbol !== "undefined") {
        const clone = {
            ...obj
        };
        Object.defineProperty(clone, Symbol.iterator, {
            enumerable: false,
            value () {
                let index = 0;
                return {
                    next: ()=>({
                            value: arr[index++],
                            done: index > arr.length
                        })
                };
            }
        });
        return clone;
    } else return Object.assign([
        ...arr
    ], obj);
}
//#endregion
//#region reactify/index.ts
/**
* Converts plain function into a reactive function.
* The converted function accepts refs as it's arguments
* and returns a ComputedRef, with proper typing.
*
* @param fn - Source function
* @param options - Options
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$70ffb7a4a03c02ad(fn, options) {
    const unrefFn = (options === null || options === void 0 ? void 0 : options.computedGetter) === false ? (0, $01W3b.unref) : (0, $01W3b.toValue);
    return function(...args) {
        return (0, $01W3b.computed)(()=>fn.apply(this, args.map((i)=>unrefFn(i))));
    };
}
/** @deprecated use `reactify` instead */ const $7e3e99f445db3d3b$export$4ba03523724ba2d7 = $7e3e99f445db3d3b$export$70ffb7a4a03c02ad;
//#endregion
//#region reactifyObject/index.ts
/**
* Apply `reactify` to an object
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$1ff2e29423610e60(obj, optionsOrKeys = {}) {
    let keys = [];
    let options;
    if (Array.isArray(optionsOrKeys)) keys = optionsOrKeys;
    else {
        options = optionsOrKeys;
        const { includeOwnProperties: includeOwnProperties = true } = optionsOrKeys;
        keys.push(...Object.keys(obj));
        if (includeOwnProperties) keys.push(...Object.getOwnPropertyNames(obj));
    }
    return Object.fromEntries(keys.map((key)=>{
        const value = obj[key];
        return [
            key,
            typeof value === "function" ? $7e3e99f445db3d3b$export$70ffb7a4a03c02ad(value.bind(obj), options) : value
        ];
    }));
}
//#endregion
//#region toReactive/index.ts
/**
* Converts ref to reactive.
*
* @see https://vueuse.org/toReactive
* @param objectRef A ref of object
*/ function $7e3e99f445db3d3b$export$45c769cf449a508c(objectRef) {
    if (!(0, $01W3b.isRef)(objectRef)) return (0, $01W3b.reactive)(objectRef);
    return (0, $01W3b.reactive)(new Proxy({}, {
        get (_, p, receiver) {
            return (0, $01W3b.unref)(Reflect.get(objectRef.value, p, receiver));
        },
        set (_, p, value) {
            if ((0, $01W3b.isRef)(objectRef.value[p]) && !(0, $01W3b.isRef)(value)) objectRef.value[p].value = value;
            else objectRef.value[p] = value;
            return true;
        },
        deleteProperty (_, p) {
            return Reflect.deleteProperty(objectRef.value, p);
        },
        has (_, p) {
            return Reflect.has(objectRef.value, p);
        },
        ownKeys () {
            return Object.keys(objectRef.value);
        },
        getOwnPropertyDescriptor () {
            return {
                enumerable: true,
                configurable: true
            };
        }
    }));
}
//#endregion
//#region reactiveComputed/index.ts
/**
* Computed reactive object.
*/ function $7e3e99f445db3d3b$export$35298289c11958e1(fn) {
    return $7e3e99f445db3d3b$export$45c769cf449a508c((0, $01W3b.computed)(fn));
}
//#endregion
//#region reactiveOmit/index.ts
/**
* Reactively omit fields from a reactive object
*
* @see https://vueuse.org/reactiveOmit
*/ function $7e3e99f445db3d3b$export$797deb43a681bdd1(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $7e3e99f445db3d3b$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter(([k, v])=>!predicate((0, $01W3b.toValue)(v), k))) : Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter((e)=>!flatKeys.includes(e[0]))));
}
//#endregion
//#region reactivePick/index.ts
/**
* Reactively pick fields from a reactive object
*
* @see https://vueuse.org/reactivePick
*/ function $7e3e99f445db3d3b$export$afd74972d99a820f(obj, ...keys) {
    const flatKeys = keys.flat();
    const predicate = flatKeys[0];
    return $7e3e99f445db3d3b$export$35298289c11958e1(()=>typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $01W3b.toRefs)(obj)).filter(([k, v])=>predicate((0, $01W3b.toValue)(v), k))) : Object.fromEntries(flatKeys.map((k)=>[
                k,
                $7e3e99f445db3d3b$export$1f60508e4f47b4b7(obj, k)
            ])));
}
//#endregion
//#region refAutoReset/index.ts
/**
* Create a ref which will be reset to the default value after some time.
*
* @see https://vueuse.org/refAutoReset
* @param defaultValue The value which will be set.
* @param afterMs      A zero-or-greater delay in milliseconds.
*/ function $7e3e99f445db3d3b$export$3e2185a13d625d13(defaultValue, afterMs = 1e4) {
    return (0, $01W3b.customRef)((track, trigger)=>{
        let value = (0, $01W3b.toValue)(defaultValue);
        let timer;
        const resetAfter = ()=>setTimeout(()=>{
                value = (0, $01W3b.toValue)(defaultValue);
                trigger();
            }, (0, $01W3b.toValue)(afterMs));
        $7e3e99f445db3d3b$export$c3d49ae4e58d3d9d(()=>{
            clearTimeout(timer);
        });
        return {
            get () {
                track();
                return value;
            },
            set (newValue) {
                value = newValue;
                trigger();
                clearTimeout(timer);
                timer = resetAfter();
            }
        };
    });
}
/** @deprecated use `refAutoReset` instead */ const $7e3e99f445db3d3b$export$c1f1e286df6cc58f = $7e3e99f445db3d3b$export$3e2185a13d625d13;
//#endregion
//#region useDebounceFn/index.ts
/**
* Debounce execution of a function.
*
* @see https://vueuse.org/useDebounceFn
* @param  fn          A function to be executed after delay milliseconds debounced.
* @param  ms          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
* @param  options     Options
*
* @return A new, debounce, function.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$ddf8f1aa96b8ea88(fn, ms = 200, options = {}) {
    return $7e3e99f445db3d3b$export$a1f1cf91007f23bf($7e3e99f445db3d3b$export$fca2c450ae03b38e(ms, options), fn);
}
//#endregion
//#region refDebounced/index.ts
/**
* Debounce updates of a ref.
*
* @return A new debounced ref.
*/ function $7e3e99f445db3d3b$export$8c510297518aecb4(value, ms = 200, options = {}) {
    const debounced = (0, $01W3b.ref)((0, $01W3b.toValue)(value));
    const updater = $7e3e99f445db3d3b$export$ddf8f1aa96b8ea88(()=>{
        debounced.value = value.value;
    }, ms, options);
    (0, $01W3b.watch)(value, ()=>updater());
    return (0, $01W3b.shallowReadonly)(debounced);
}
/** @deprecated use `refDebounced` instead */ const $7e3e99f445db3d3b$export$179967fbe3ecb41a = $7e3e99f445db3d3b$export$8c510297518aecb4;
/** @deprecated use `refDebounced` instead */ const $7e3e99f445db3d3b$export$21805fee57372823 = $7e3e99f445db3d3b$export$8c510297518aecb4;
//#endregion
//#region refDefault/index.ts
/**
* Apply default value to a ref.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$52a73c0b6dcfe111(source, defaultValue) {
    return (0, $01W3b.computed)({
        get () {
            var _source$value;
            return (_source$value = source.value) !== null && _source$value !== void 0 ? _source$value : defaultValue;
        },
        set (value) {
            source.value = value;
        }
    });
}
//#endregion
//#region refManualReset/index.ts
/**
* Create a ref with manual reset functionality.
*
* @see https://vueuse.org/refManualReset
* @param defaultValue The value which will be set.
*/ function $7e3e99f445db3d3b$export$586a74df7e50dd40(defaultValue) {
    let value = (0, $01W3b.toValue)(defaultValue);
    let trigger;
    const reset = ()=>{
        value = (0, $01W3b.toValue)(defaultValue);
        trigger();
    };
    const refValue = (0, $01W3b.customRef)((track, _trigger)=>{
        trigger = _trigger;
        return {
            get () {
                track();
                return value;
            },
            set (newValue) {
                value = newValue;
                trigger();
            }
        };
    });
    refValue.reset = reset;
    return refValue;
}
//#endregion
//#region useThrottleFn/index.ts
/**
* Throttle execution of a function. Especially useful for rate limiting
* execution of handlers on events like resize and scroll.
*
* @param   fn             A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
*                                    to `callback` when the throttled-function is executed.
* @param   ms             A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
*                                    (default value: 200)
*
* @param [trailing] if true, call fn again after the time is up (default value: false)
*
* @param [leading] if true, call fn on the leading edge of the ms timeout (default value: true)
*
* @param [rejectOnCancel] if true, reject the last call if it's been cancel (default value: false)
*
* @return  A new, throttled, function.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$8ed85856108010bc(fn, ms = 200, trailing = false, leading = true, rejectOnCancel = false) {
    return $7e3e99f445db3d3b$export$a1f1cf91007f23bf($7e3e99f445db3d3b$export$cd62e9dbf204fd92(ms, trailing, leading, rejectOnCancel), fn);
}
//#endregion
//#region refThrottled/index.ts
/**
* Throttle execution of a function. Especially useful for rate limiting
* execution of handlers on events like resize and scroll.
*
* @param value Ref value to be watched with throttle effect
* @param  delay  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
* @param trailing if true, update the value again after the delay time is up
* @param leading if true, update the value on the leading edge of the ms timeout
*/ function $7e3e99f445db3d3b$export$4d1d638ad6b48495(value, delay = 200, trailing = true, leading = true) {
    if (delay <= 0) return value;
    const throttled = (0, $01W3b.ref)((0, $01W3b.toValue)(value));
    const updater = $7e3e99f445db3d3b$export$8ed85856108010bc(()=>{
        throttled.value = value.value;
    }, delay, trailing, leading);
    (0, $01W3b.watch)(value, ()=>updater());
    return throttled;
}
/** @deprecated use `refThrottled` instead */ const $7e3e99f445db3d3b$export$2e155d06d2d78112 = $7e3e99f445db3d3b$export$4d1d638ad6b48495;
/** @deprecated use `refThrottled` instead */ const $7e3e99f445db3d3b$export$8b7b9481d6186f21 = $7e3e99f445db3d3b$export$4d1d638ad6b48495;
//#endregion
//#region refWithControl/index.ts
/**
* Fine-grained controls over ref and its reactivity.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$4b7f2010e13474b2(initial, options = {}) {
    let source = initial;
    let track;
    let trigger;
    const ref = (0, $01W3b.customRef)((_track, _trigger)=>{
        track = _track;
        trigger = _trigger;
        return {
            get () {
                return get();
            },
            set (v) {
                set(v);
            }
        };
    });
    function get(tracking = true) {
        if (tracking) track();
        return source;
    }
    function set(value, triggering = true) {
        var _options$onBeforeChan, _options$onChanged;
        if (value === source) return;
        const old = source;
        if (((_options$onBeforeChan = options.onBeforeChange) === null || _options$onBeforeChan === void 0 ? void 0 : _options$onBeforeChan.call(options, value, old)) === false) return;
        source = value;
        (_options$onChanged = options.onChanged) === null || _options$onChanged === void 0 || _options$onChanged.call(options, value, old);
        if (triggering) trigger();
    }
    /**
	* Get the value without tracked in the reactivity system
	*/ const untrackedGet = ()=>get(false);
    /**
	* Set the value without triggering the reactivity system
	*/ const silentSet = (v)=>set(v, false);
    /**
	* Get the value without tracked in the reactivity system.
	*
	* Alias for `untrackedGet()`
	*/ const peek = ()=>get(false);
    /**
	* Set the value without triggering the reactivity system
	*
	* Alias for `silentSet(v)`
	*/ const lay = (v)=>set(v, false);
    return $7e3e99f445db3d3b$export$ecda8b07a1b5deab(ref, {
        get: get,
        set: set,
        untrackedGet: untrackedGet,
        silentSet: silentSet,
        peek: peek,
        lay: lay
    }, {
        enumerable: true
    });
}
/** @deprecated use `refWithControl` instead */ const $7e3e99f445db3d3b$export$6b6db3af7a80e2d2 = $7e3e99f445db3d3b$export$4b7f2010e13474b2;
//#endregion
//#region set/index.ts
/**
*  Shorthand for `ref.value = x`
*/ function $7e3e99f445db3d3b$export$adaa4cf7ef1b65be(...args) {
    if (args.length === 2) {
        const [ref, value] = args;
        ref.value = value;
    }
    if (args.length === 3) {
        const [target, key, value] = args;
        target[key] = value;
    }
}
//#endregion
//#region watchWithFilter/index.ts
function $7e3e99f445db3d3b$export$3955c00bb6715986(source, cb, options = {}) {
    const { eventFilter: eventFilter = $7e3e99f445db3d3b$export$8cc0e33a27868391, ...watchOptions } = options;
    return (0, $01W3b.watch)(source, $7e3e99f445db3d3b$export$a1f1cf91007f23bf(eventFilter, cb), watchOptions);
}
//#endregion
//#region watchPausable/index.ts
/** @deprecated Use Vue's built-in `watch` instead. This function will be removed in future version. */ function $7e3e99f445db3d3b$export$88467b54a7b59d4(source, cb, options = {}) {
    const { eventFilter: filter, initialState: initialState = "active", ...watchOptions } = options;
    const { eventFilter: eventFilter, pause: pause, resume: resume, isActive: isActive } = $7e3e99f445db3d3b$export$8d46ce8e0ead9c2b(filter, {
        initialState: initialState
    });
    return {
        stop: $7e3e99f445db3d3b$export$3955c00bb6715986(source, cb, {
            ...watchOptions,
            eventFilter: eventFilter
        }),
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
/** @deprecated Use Vue's built-in `watch` instead. This function will be removed in future version. */ const $7e3e99f445db3d3b$export$37fdf671f882195e = $7e3e99f445db3d3b$export$88467b54a7b59d4;
//#endregion
//#region syncRef/index.ts
/**
* Two-way refs synchronization.
* From the set theory perspective to restrict the option's type
* Check in the following order:
* 1. L = R
* 2. L ∩ R ≠ ∅
* 3. L ⊆ R
* 4. L ∩ R = ∅
*/ function $7e3e99f445db3d3b$export$d43743c1df800be0(left, right, ...[options]) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true, direction: direction = "both", transform: transform = {} } = options || {};
    const watchers = [];
    const transformLTR = "ltr" in transform && transform.ltr || ((v)=>v);
    const transformRTL = "rtl" in transform && transform.rtl || ((v)=>v);
    if (direction === "both" || direction === "ltr") watchers.push($7e3e99f445db3d3b$export$88467b54a7b59d4(left, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        right.value = transformLTR(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    if (direction === "both" || direction === "rtl") watchers.push($7e3e99f445db3d3b$export$88467b54a7b59d4(right, (newValue)=>{
        watchers.forEach((w)=>w.pause());
        left.value = transformRTL(newValue);
        watchers.forEach((w)=>w.resume());
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    const stop = ()=>{
        watchers.forEach((w)=>w.stop());
    };
    return stop;
}
//#endregion
//#region syncRefs/index.ts
/**
* Keep target ref(s) in sync with the source ref
*
* @param source source ref
* @param targets
*/ function $7e3e99f445db3d3b$export$16a582ae8a437df6(source, targets, options = {}) {
    const { flush: flush = "sync", deep: deep = false, immediate: immediate = true } = options;
    const targetsArray = $7e3e99f445db3d3b$export$45b10814cc054894(targets);
    return (0, $01W3b.watch)(source, (newValue)=>targetsArray.forEach((target)=>target.value = newValue), {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
}
//#endregion
//#region toRefs/index.ts
/**
* Extended `toRefs` that also accepts refs of an object.
*
* @see https://vueuse.org/toRefs
* @param objectRef A ref or normal object or array.
* @param options Options
*/ function $7e3e99f445db3d3b$export$2e9533675e5e70e0(objectRef, options = {}) {
    if (!(0, $01W3b.isRef)(objectRef)) return (0, $01W3b.toRefs)(objectRef);
    const result = Array.isArray(objectRef.value) ? Array.from({
        length: objectRef.value.length
    }) : {};
    for(const key in objectRef.value)result[key] = (0, $01W3b.customRef)(()=>({
            get () {
                return objectRef.value[key];
            },
            set (v) {
                var _toValue;
                if ((_toValue = (0, $01W3b.toValue)(options.replaceRef)) !== null && _toValue !== void 0 ? _toValue : true) {
                    if (Array.isArray(objectRef.value)) {
                        const copy = [
                            ...objectRef.value
                        ];
                        copy[key] = v;
                        objectRef.value = copy;
                    } else {
                        const newObject = {
                            ...objectRef.value,
                            [key]: v
                        };
                        Object.setPrototypeOf(newObject, Object.getPrototypeOf(objectRef.value));
                        objectRef.value = newObject;
                    }
                } else objectRef.value[key] = v;
            }
        }));
    return result;
}
//#endregion
//#region tryOnBeforeMount/index.ts
/**
* Call onBeforeMount() if it's inside a component lifecycle, if not, just call the function
*
* @param fn
* @param sync if set to false, it will run in the nextTick() of Vue
* @param target
*/ function $7e3e99f445db3d3b$export$25180f6b7105226e(fn, sync = true, target) {
    if ($7e3e99f445db3d3b$export$5c967efe8efb656c(target)) (0, $TusQn.onBeforeMount)(fn, target);
    else if (sync) fn();
    else (0, $TusQn.nextTick)(fn);
}
//#endregion
//#region tryOnBeforeUnmount/index.ts
/**
* Call onBeforeUnmount() if it's inside a component lifecycle, if not, do nothing
*
* @param fn
* @param target
*/ function $7e3e99f445db3d3b$export$7b037ce8d7969c15(fn, target) {
    if ($7e3e99f445db3d3b$export$5c967efe8efb656c(target)) (0, $TusQn.onBeforeUnmount)(fn, target);
}
//#endregion
//#region tryOnMounted/index.ts
/**
* Call onMounted() if it's inside a component lifecycle, if not, just call the function
*
* @param fn
* @param sync if set to false, it will run in the nextTick() of Vue
* @param target
*/ function $7e3e99f445db3d3b$export$cf1be5b643f0827(fn, sync = true, target) {
    if ($7e3e99f445db3d3b$export$5c967efe8efb656c(target)) (0, $TusQn.onMounted)(fn, target);
    else if (sync) fn();
    else (0, $TusQn.nextTick)(fn);
}
//#endregion
//#region tryOnUnmounted/index.ts
/**
* Call onUnmounted() if it's inside a component lifecycle, if not, do nothing
*
* @param fn
* @param target
*/ function $7e3e99f445db3d3b$export$9fa6e59ca833c930(fn, target) {
    if ($7e3e99f445db3d3b$export$5c967efe8efb656c(target)) (0, $TusQn.onUnmounted)(fn, target);
}
//#endregion
//#region until/index.ts
function $7e3e99f445db3d3b$var$createUntil(r, isNot = false) {
    function toMatch(condition, { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = {}) {
        let stop = null;
        const promises = [
            new Promise((resolve)=>{
                stop = (0, $01W3b.watch)(r, (v)=>{
                    if (condition(v) !== isNot) {
                        if (stop) stop();
                        else (0, $TusQn.nextTick)(()=>stop === null || stop === void 0 ? void 0 : stop());
                        resolve(v);
                    }
                }, {
                    flush: flush,
                    deep: deep,
                    immediate: true
                });
            })
        ];
        if (timeout != null) promises.push($7e3e99f445db3d3b$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>(0, $01W3b.toValue)(r)).finally(()=>stop === null || stop === void 0 ? void 0 : stop()));
        return Promise.race(promises);
    }
    function toBe(value, options) {
        if (!(0, $01W3b.isRef)(value)) return toMatch((v)=>v === value, options);
        const { flush: flush = "sync", deep: deep = false, timeout: timeout, throwOnTimeout: throwOnTimeout } = options !== null && options !== void 0 ? options : {};
        let stop = null;
        const promises = [
            new Promise((resolve)=>{
                stop = (0, $01W3b.watch)([
                    r,
                    value
                ], ([v1, v2])=>{
                    if (isNot !== (v1 === v2)) {
                        if (stop) stop();
                        else (0, $TusQn.nextTick)(()=>stop === null || stop === void 0 ? void 0 : stop());
                        resolve(v1);
                    }
                }, {
                    flush: flush,
                    deep: deep,
                    immediate: true
                });
            })
        ];
        if (timeout != null) promises.push($7e3e99f445db3d3b$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(()=>(0, $01W3b.toValue)(r)).finally(()=>{
            stop === null || stop === void 0 || stop();
            return (0, $01W3b.toValue)(r);
        }));
        return Promise.race(promises);
    }
    function toBeTruthy(options) {
        return toMatch((v)=>Boolean(v), options);
    }
    function toBeNull(options) {
        return toBe(null, options);
    }
    function toBeUndefined(options) {
        return toBe(void 0, options);
    }
    function toBeNaN(options) {
        return toMatch(Number.isNaN, options);
    }
    function toContains(value, options) {
        return toMatch((v)=>{
            const array = Array.from(v);
            return array.includes(value) || array.includes((0, $01W3b.toValue)(value));
        }, options);
    }
    function changed(options) {
        return changedTimes(1, options);
    }
    function changedTimes(n = 1, options) {
        let count = -1;
        return toMatch(()=>{
            count += 1;
            return count >= n;
        }, options);
    }
    if (Array.isArray((0, $01W3b.toValue)(r))) return {
        toMatch: toMatch,
        toContains: toContains,
        changed: changed,
        changedTimes: changedTimes,
        get not () {
            return $7e3e99f445db3d3b$var$createUntil(r, !isNot);
        }
    };
    else return {
        toMatch: toMatch,
        toBe: toBe,
        toBeTruthy: toBeTruthy,
        toBeNull: toBeNull,
        toBeNaN: toBeNaN,
        toBeUndefined: toBeUndefined,
        changed: changed,
        changedTimes: changedTimes,
        get not () {
            return $7e3e99f445db3d3b$var$createUntil(r, !isNot);
        }
    };
}
function $7e3e99f445db3d3b$export$a40009bd2c363351(r) {
    return $7e3e99f445db3d3b$var$createUntil(r);
}
//#endregion
//#region useArrayDifference/index.ts
function $7e3e99f445db3d3b$var$defaultComparator(value, othVal) {
    return value === othVal;
}
/**
* Reactive get array difference of two array
* @see https://vueuse.org/useArrayDifference
* @returns - the difference of two array
* @param args
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$34602ebc410e389c(...args) {
    var _args$, _args$2;
    const list = args[0];
    const values = args[1];
    let compareFn = (_args$ = args[2]) !== null && _args$ !== void 0 ? _args$ : $7e3e99f445db3d3b$var$defaultComparator;
    const { symmetric: symmetric = false } = (_args$2 = args[3]) !== null && _args$2 !== void 0 ? _args$2 : {};
    if (typeof compareFn === "string") {
        const key = compareFn;
        compareFn = (value, othVal)=>value[key] === othVal[key];
    }
    const diff1 = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).filter((x)=>(0, $01W3b.toValue)(values).findIndex((y)=>compareFn(x, y)) === -1));
    if (symmetric) {
        const diff2 = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(values).filter((x)=>(0, $01W3b.toValue)(list).findIndex((y)=>compareFn(x, y)) === -1));
        return (0, $01W3b.computed)(()=>symmetric ? [
                ...(0, $01W3b.toValue)(diff1),
                ...(0, $01W3b.toValue)(diff2)
            ] : (0, $01W3b.toValue)(diff1));
    } else return diff1;
}
//#endregion
//#region useArrayEvery/index.ts
/**
* Reactive `Array.every`
*
* @see https://vueuse.org/useArrayEvery
* @param list - the array was called upon.
* @param fn - a function to test each element.
*
* @returns **true** if the `fn` function returns a **truthy** value for every element from the array. Otherwise, **false**.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$1e5a400faddb345f(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).every((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)));
}
//#endregion
//#region useArrayFilter/index.ts
/**
* Reactive `Array.filter`
*
* @see https://vueuse.org/useArrayFilter
* @param list - the array was called upon.
* @param fn - a function that is called for every element of the given `list`. Each time `fn` executes, the returned value is added to the new array.
*
* @returns a shallow copy of a portion of the given array, filtered down to just the elements from the given array that pass the test implemented by the provided function. If no elements pass the test, an empty array will be returned.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$d62e4083f0a2d244(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).map((i)=>(0, $01W3b.toValue)(i)).filter(fn));
}
//#endregion
//#region useArrayFind/index.ts
/**
* Reactive `Array.find`
*
* @see https://vueuse.org/useArrayFind
* @param list - the array was called upon.
* @param fn - a function to test each element.
*
* @returns the first element in the array that satisfies the provided testing function. Otherwise, undefined is returned.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$ace4ef07c63f605e(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)((0, $01W3b.toValue)(list).find((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array))));
}
//#endregion
//#region useArrayFindIndex/index.ts
/**
* Reactive `Array.findIndex`
*
* @see https://vueuse.org/useArrayFindIndex
* @param list - the array was called upon.
* @param fn - a function to test each element.
*
* @returns the index of the first element in the array that passes the test. Otherwise, "-1".
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$3ec066cdb63e2970(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).findIndex((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)));
}
//#endregion
//#region useArrayFindLast/index.ts
function $7e3e99f445db3d3b$var$findLast(arr, cb) {
    let index = arr.length;
    while(index-- > 0)if (cb(arr[index], index, arr)) return arr[index];
}
/**
* Reactive `Array.findLast`
*
* @see https://vueuse.org/useArrayFindLast
* @param list - the array was called upon.
* @param fn - a function to test each element.
*
* @returns the last element in the array that satisfies the provided testing function. Otherwise, undefined is returned.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$b59cd47693a134f7(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(!Array.prototype.findLast ? $7e3e99f445db3d3b$var$findLast((0, $01W3b.toValue)(list), (element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)) : (0, $01W3b.toValue)(list).findLast((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array))));
}
//#endregion
//#region useArrayIncludes/index.ts
function $7e3e99f445db3d3b$var$isArrayIncludesOptions(obj) {
    return $7e3e99f445db3d3b$export$a6cdc56e425d0d0a(obj) && $7e3e99f445db3d3b$export$d138bf93e1dfa23f(obj, "formIndex", "comparator");
}
/**
* Reactive `Array.includes`
*
* @see https://vueuse.org/useArrayIncludes
*
* @returns true if the `value` is found in the array. Otherwise, false.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$34f006a38543d952(...args) {
    var _comparator;
    const list = args[0];
    const value = args[1];
    let comparator = args[2];
    let formIndex = 0;
    if ($7e3e99f445db3d3b$var$isArrayIncludesOptions(comparator)) {
        var _comparator$fromIndex;
        formIndex = (_comparator$fromIndex = comparator.fromIndex) !== null && _comparator$fromIndex !== void 0 ? _comparator$fromIndex : 0;
        comparator = comparator.comparator;
    }
    if (typeof comparator === "string") {
        const key = comparator;
        comparator = (element, value)=>element[key] === (0, $01W3b.toValue)(value);
    }
    comparator = (_comparator = comparator) !== null && _comparator !== void 0 ? _comparator : (element, value)=>element === (0, $01W3b.toValue)(value);
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).slice(formIndex).some((element, index, array)=>comparator((0, $01W3b.toValue)(element), (0, $01W3b.toValue)(value), index, (0, $01W3b.toValue)(array))));
}
//#endregion
//#region useArrayJoin/index.ts
/**
* Reactive `Array.join`
*
* @see https://vueuse.org/useArrayJoin
* @param list - the array was called upon.
* @param separator - a string to separate each pair of adjacent elements of the array. If omitted, the array elements are separated with a comma (",").
*
* @returns a string with all array elements joined. If arr.length is 0, the empty string is returned.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$4a02928bbff39848(list, separator) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).map((i)=>(0, $01W3b.toValue)(i)).join((0, $01W3b.toValue)(separator)));
}
//#endregion
//#region useArrayMap/index.ts
/**
* Reactive `Array.map`
*
* @see https://vueuse.org/useArrayMap
* @param list - the array was called upon.
* @param fn - a function that is called for every element of the given `list`. Each time `fn` executes, the returned value is added to the new array.
*
* @returns a new array with each element being the result of the callback function.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$8cc4758f083c4ffe(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).map((i)=>(0, $01W3b.toValue)(i)).map(fn));
}
//#endregion
//#region useArrayReduce/index.ts
/**
* Reactive `Array.reduce`
*
* @see https://vueuse.org/useArrayReduce
* @param list - the array was called upon.
* @param reducer - a "reducer" function.
* @param args
*
* @returns the value that results from running the "reducer" callback function to completion over the entire array.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$2a4c0ee40e3400de(list, reducer, ...args) {
    const reduceCallback = (sum, value, index)=>reducer((0, $01W3b.toValue)(sum), (0, $01W3b.toValue)(value), index);
    return (0, $01W3b.computed)(()=>{
        const resolved = (0, $01W3b.toValue)(list);
        return args.length ? resolved.reduce(reduceCallback, typeof args[0] === "function" ? (0, $01W3b.toValue)(args[0]()) : (0, $01W3b.toValue)(args[0])) : resolved.reduce(reduceCallback);
    });
}
//#endregion
//#region useArraySome/index.ts
/**
* Reactive `Array.some`
*
* @see https://vueuse.org/useArraySome
* @param list - the array was called upon.
* @param fn - a function to test each element.
*
* @returns **true** if the `fn` function returns a **truthy** value for any element from the array. Otherwise, **false**.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$53834b0e1a20e7a3(list, fn) {
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(list).some((element, index, array)=>fn((0, $01W3b.toValue)(element), index, array)));
}
//#endregion
//#region useArrayUnique/index.ts
function $7e3e99f445db3d3b$var$uniq(array) {
    return Array.from(new Set(array));
}
function $7e3e99f445db3d3b$var$uniqueElementsBy(array, fn) {
    return array.reduce((acc, v)=>{
        if (!acc.some((x)=>fn(v, x, array))) acc.push(v);
        return acc;
    }, []);
}
/**
* reactive unique array
* @see https://vueuse.org/useArrayUnique
* @param list - the array was called upon.
* @param compareFn
* @returns A computed ref that returns a unique array of items.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$1b97ec936c2f7d03(list, compareFn) {
    return (0, $01W3b.computed)(()=>{
        const resolvedList = (0, $01W3b.toValue)(list).map((element)=>(0, $01W3b.toValue)(element));
        return compareFn ? $7e3e99f445db3d3b$var$uniqueElementsBy(resolvedList, compareFn) : $7e3e99f445db3d3b$var$uniq(resolvedList);
    });
}
//#endregion
//#region useCounter/index.ts
/**
* Basic counter with utility functions.
*
* @see https://vueuse.org/useCounter
* @param [initialValue]
* @param options
*/ function $7e3e99f445db3d3b$export$70c4067197c60e2d(initialValue = 0, options = {}) {
    let _initialValue = (0, $01W3b.unref)(initialValue);
    const count = (0, $01W3b.shallowRef)(initialValue);
    const { max: max = Number.POSITIVE_INFINITY, min: min = Number.NEGATIVE_INFINITY } = options;
    const inc = (delta = 1)=>count.value = Math.max(Math.min(max, count.value + delta), min);
    const dec = (delta = 1)=>count.value = Math.min(Math.max(min, count.value - delta), max);
    const get = ()=>count.value;
    const set = (val)=>count.value = Math.max(min, Math.min(max, val));
    const reset = (val = _initialValue)=>{
        _initialValue = val;
        return set(val);
    };
    return {
        count: (0, $01W3b.shallowReadonly)(count),
        inc: inc,
        dec: dec,
        get: get,
        set: set,
        reset: reset
    };
}
//#endregion
//#region useDateFormat/index.ts
const $7e3e99f445db3d3b$var$REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[T\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/i;
const $7e3e99f445db3d3b$var$REGEX_FORMAT = /[YMDHhms]o|\[([^\]]+)\]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|z{1,4}|SSS/g;
function $7e3e99f445db3d3b$var$defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
    let m = hours < 12 ? "AM" : "PM";
    if (hasPeriod) m = m.split("").reduce((acc, curr)=>acc += `${curr}.`, "");
    return isLowercase ? m.toLowerCase() : m;
}
function $7e3e99f445db3d3b$var$formatOrdinal(num) {
    const suffixes = [
        "th",
        "st",
        "nd",
        "rd"
    ];
    const v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}
function $7e3e99f445db3d3b$export$3ae94a2503e890a1(date, formatStr, options = {}) {
    var _options$customMeridi;
    const years = date.getFullYear();
    const month = date.getMonth();
    const days = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const milliseconds = date.getMilliseconds();
    const day = date.getDay();
    const meridiem = (_options$customMeridi = options.customMeridiem) !== null && _options$customMeridi !== void 0 ? _options$customMeridi : $7e3e99f445db3d3b$var$defaultMeridiem;
    const stripTimeZone = (dateString)=>{
        var _dateString$split$;
        return (_dateString$split$ = dateString.split(" ")[1]) !== null && _dateString$split$ !== void 0 ? _dateString$split$ : "";
    };
    const matches = {
        Yo: ()=>$7e3e99f445db3d3b$var$formatOrdinal(years),
        YY: ()=>String(years).slice(-2),
        YYYY: ()=>years,
        M: ()=>month + 1,
        Mo: ()=>$7e3e99f445db3d3b$var$formatOrdinal(month + 1),
        MM: ()=>`${month + 1}`.padStart(2, "0"),
        MMM: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                month: "short"
            }),
        MMMM: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                month: "long"
            }),
        D: ()=>String(days),
        Do: ()=>$7e3e99f445db3d3b$var$formatOrdinal(days),
        DD: ()=>`${days}`.padStart(2, "0"),
        H: ()=>String(hours),
        Ho: ()=>$7e3e99f445db3d3b$var$formatOrdinal(hours),
        HH: ()=>`${hours}`.padStart(2, "0"),
        h: ()=>`${hours % 12 || 12}`.padStart(1, "0"),
        ho: ()=>$7e3e99f445db3d3b$var$formatOrdinal(hours % 12 || 12),
        hh: ()=>`${hours % 12 || 12}`.padStart(2, "0"),
        m: ()=>String(minutes),
        mo: ()=>$7e3e99f445db3d3b$var$formatOrdinal(minutes),
        mm: ()=>`${minutes}`.padStart(2, "0"),
        s: ()=>String(seconds),
        so: ()=>$7e3e99f445db3d3b$var$formatOrdinal(seconds),
        ss: ()=>`${seconds}`.padStart(2, "0"),
        SSS: ()=>`${milliseconds}`.padStart(3, "0"),
        d: ()=>day,
        dd: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                weekday: "narrow"
            }),
        ddd: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                weekday: "short"
            }),
        dddd: ()=>date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                weekday: "long"
            }),
        A: ()=>meridiem(hours, minutes),
        AA: ()=>meridiem(hours, minutes, false, true),
        a: ()=>meridiem(hours, minutes, true),
        aa: ()=>meridiem(hours, minutes, true, true),
        z: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "shortOffset"
            })),
        zz: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "shortOffset"
            })),
        zzz: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "shortOffset"
            })),
        zzzz: ()=>stripTimeZone(date.toLocaleDateString((0, $01W3b.toValue)(options.locales), {
                timeZoneName: "longOffset"
            }))
    };
    return formatStr.replace($7e3e99f445db3d3b$var$REGEX_FORMAT, (match, $1)=>{
        var _ref, _matches$match;
        return (_ref = $1 !== null && $1 !== void 0 ? $1 : (_matches$match = matches[match]) === null || _matches$match === void 0 ? void 0 : _matches$match.call(matches)) !== null && _ref !== void 0 ? _ref : match;
    });
}
function $7e3e99f445db3d3b$export$fcc71269590ba0a8(date) {
    if (date === null) return /* @__PURE__ */ new Date(NaN);
    if (date === void 0) return /* @__PURE__ */ new Date();
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        const d = date.match($7e3e99f445db3d3b$var$REGEX_PARSE);
        if (d) {
            const m = d[2] - 1 || 0;
            const ms = (d[7] || "0").substring(0, 3);
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date);
}
/**
* Get the formatted date according to the string of tokens passed in.
*
* @see https://vueuse.org/useDateFormat
* @param date - The date to format, can either be a `Date` object, a timestamp, or a string
* @param formatStr - The combination of tokens to format the date
* @param options - UseDateFormatOptions
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$6d181172004bc6fc(date, formatStr = "HH:mm:ss", options = {}) {
    return (0, $01W3b.computed)(()=>$7e3e99f445db3d3b$export$3ae94a2503e890a1($7e3e99f445db3d3b$export$fcc71269590ba0a8((0, $01W3b.toValue)(date)), (0, $01W3b.toValue)(formatStr), options));
}
//#endregion
//#region useIntervalFn/index.ts
/**
* Wrapper for `setInterval` with controls
*
* @see https://vueuse.org/useIntervalFn
* @param cb
* @param interval
* @param options
*/ function $7e3e99f445db3d3b$export$35ee30a05e4f2223(cb, interval = 1e3, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    let timer = null;
    const isActive = (0, $01W3b.shallowRef)(false);
    function clean() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function pause() {
        isActive.value = false;
        clean();
    }
    function resume() {
        const intervalValue = (0, $01W3b.toValue)(interval);
        if (intervalValue <= 0) return;
        isActive.value = true;
        if (immediateCallback) cb();
        clean();
        if (isActive.value) timer = setInterval(cb, intervalValue);
    }
    if (immediate && $7e3e99f445db3d3b$export$7383f122bf48ec30) resume();
    if ((0, $01W3b.isRef)(interval) || typeof interval === "function") $7e3e99f445db3d3b$export$c3d49ae4e58d3d9d((0, $01W3b.watch)(interval, ()=>{
        if (isActive.value && $7e3e99f445db3d3b$export$7383f122bf48ec30) resume();
    }));
    $7e3e99f445db3d3b$export$c3d49ae4e58d3d9d(pause);
    return {
        isActive: (0, $01W3b.shallowReadonly)(isActive),
        pause: pause,
        resume: resume
    };
}
//#endregion
//#region useInterval/index.ts
function $7e3e99f445db3d3b$export$f4b266cd2aae9cb1(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, immediate: immediate = true, callback: callback } = options;
    const counter = (0, $01W3b.shallowRef)(0);
    const update = ()=>counter.value += 1;
    const reset = ()=>{
        counter.value = 0;
    };
    const controls = $7e3e99f445db3d3b$export$35ee30a05e4f2223(callback ? ()=>{
        update();
        callback(counter.value);
    } : update, interval, {
        immediate: immediate
    });
    if (exposeControls) return {
        counter: (0, $01W3b.shallowReadonly)(counter),
        reset: reset,
        ...controls
    };
    else return (0, $01W3b.shallowReadonly)(counter);
}
//#endregion
//#region useLastChanged/index.ts
function $7e3e99f445db3d3b$export$de385d6f89d6db3c(source, options = {}) {
    var _options$initialValue;
    const ms = (0, $01W3b.shallowRef)((_options$initialValue = options.initialValue) !== null && _options$initialValue !== void 0 ? _options$initialValue : null);
    (0, $01W3b.watch)(source, ()=>ms.value = $7e3e99f445db3d3b$export$fc00ee57782020aa(), options);
    return (0, $01W3b.shallowReadonly)(ms);
}
//#endregion
//#region useTimeoutFn/index.ts
/**
* Wrapper for `setTimeout` with controls.
*
* @param cb
* @param interval
* @param options
*/ function $7e3e99f445db3d3b$export$14705c14c13d528a(cb, interval, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    const isPending = (0, $01W3b.shallowRef)(false);
    let timer;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
        }
    }
    function stop() {
        isPending.value = false;
        clear();
    }
    function start(...args) {
        if (immediateCallback) cb();
        clear();
        isPending.value = true;
        timer = setTimeout(()=>{
            isPending.value = false;
            timer = void 0;
            cb(...args);
        }, (0, $01W3b.toValue)(interval));
    }
    if (immediate) {
        isPending.value = true;
        if ($7e3e99f445db3d3b$export$7383f122bf48ec30) start();
    }
    $7e3e99f445db3d3b$export$c3d49ae4e58d3d9d(stop);
    return {
        isPending: (0, $01W3b.shallowReadonly)(isPending),
        start: start,
        stop: stop
    };
}
//#endregion
//#region useTimeout/index.ts
function $7e3e99f445db3d3b$export$d8e6abf214c9ec0f(interval = 1e3, options = {}) {
    const { controls: exposeControls = false, callback: callback } = options;
    const controls = $7e3e99f445db3d3b$export$14705c14c13d528a(callback !== null && callback !== void 0 ? callback : $7e3e99f445db3d3b$export$8793edee2d425525, interval, options);
    const ready = (0, $01W3b.computed)(()=>!controls.isPending.value);
    if (exposeControls) return {
        ready: ready,
        ...controls
    };
    else return ready;
}
//#endregion
//#region useToNumber/index.ts
/**
* Reactively convert a string ref to number.
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$1ee6bb1f922f50b3(value, options = {}) {
    const { method: method = "parseFloat", radix: radix, nanToZero: nanToZero } = options;
    return (0, $01W3b.computed)(()=>{
        let resolved = (0, $01W3b.toValue)(value);
        if (typeof method === "function") resolved = method(resolved);
        else if (typeof resolved === "string") resolved = Number[method](resolved, radix);
        if (nanToZero && Number.isNaN(resolved)) resolved = 0;
        return resolved;
    });
}
//#endregion
//#region useToString/index.ts
/**
* Reactively convert a ref to string.
*
* @see https://vueuse.org/useToString
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$8906942fea47e698(value) {
    return (0, $01W3b.computed)(()=>`${(0, $01W3b.toValue)(value)}`);
}
//#endregion
//#region useToggle/index.ts
/**
* A boolean ref with a toggler
*
* @see https://vueuse.org/useToggle
* @param [initialValue]
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $7e3e99f445db3d3b$export$cbe85ee05b554577(initialValue = false, options = {}) {
    const { truthyValue: truthyValue = true, falsyValue: falsyValue = false } = options;
    const valueIsRef = (0, $01W3b.isRef)(initialValue);
    const _value = (0, $01W3b.shallowRef)(initialValue);
    function toggle(value) {
        if (arguments.length) {
            _value.value = value;
            return _value.value;
        } else {
            const truthy = (0, $01W3b.toValue)(truthyValue);
            _value.value = _value.value === truthy ? (0, $01W3b.toValue)(falsyValue) : truthy;
            return _value.value;
        }
    }
    if (valueIsRef) return toggle;
    else return [
        _value,
        toggle
    ];
}
//#endregion
//#region watchArray/index.ts
/**
* Watch for an array with additions and removals.
*
* @see https://vueuse.org/watchArray
*/ function $7e3e99f445db3d3b$export$8ebd2befe4deaa6b(source, cb, options) {
    let oldList = (options === null || options === void 0 ? void 0 : options.immediate) ? [] : [
        ...typeof source === "function" ? source() : Array.isArray(source) ? source : (0, $01W3b.toValue)(source)
    ];
    return (0, $01W3b.watch)(source, (newList, _, onCleanup)=>{
        const oldListRemains = Array.from({
            length: oldList.length
        });
        const added = [];
        for (const obj of newList){
            let found = false;
            for(let i = 0; i < oldList.length; i++)if (!oldListRemains[i] && obj === oldList[i]) {
                oldListRemains[i] = true;
                found = true;
                break;
            }
            if (!found) added.push(obj);
        }
        const removed = oldList.filter((_, i)=>!oldListRemains[i]);
        cb(newList, oldList, added, removed, onCleanup);
        oldList = [
            ...newList
        ];
    }, options);
}
//#endregion
//#region watchAtMost/index.ts
function $7e3e99f445db3d3b$export$a121c3bc1a97f0b4(source, cb, options) {
    const { count: count, ...watchOptions } = options;
    const current = (0, $01W3b.shallowRef)(0);
    const { stop: stop, resume: resume, pause: pause } = $7e3e99f445db3d3b$export$3955c00bb6715986(source, (...args)=>{
        current.value += 1;
        if (current.value >= (0, $01W3b.toValue)(count)) (0, $TusQn.nextTick)(()=>stop());
        cb(...args);
    }, watchOptions);
    return {
        count: current,
        stop: stop,
        resume: resume,
        pause: pause
    };
}
//#endregion
//#region watchDebounced/index.ts
function $7e3e99f445db3d3b$export$e5ecd9a9bc034e48(source, cb, options = {}) {
    const { debounce: debounce = 0, maxWait: maxWait, ...watchOptions } = options;
    return $7e3e99f445db3d3b$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $7e3e99f445db3d3b$export$fca2c450ae03b38e(debounce, {
            maxWait: maxWait
        })
    });
}
/** @deprecated use `watchDebounced` instead */ const $7e3e99f445db3d3b$export$578b5d9cbe132cee = $7e3e99f445db3d3b$export$e5ecd9a9bc034e48;
//#endregion
//#region watchDeep/index.ts
/**
* Shorthand for watching value with {deep: true}
*
* @see https://vueuse.org/watchDeep
*/ function $7e3e99f445db3d3b$export$79f242cf85fb93a(source, cb, options) {
    return (0, $01W3b.watch)(source, cb, {
        ...options,
        deep: true
    });
}
//#endregion
//#region watchIgnorable/index.ts
function $7e3e99f445db3d3b$export$3a6f8a7df9ef7264(source, cb, options = {}) {
    const { eventFilter: eventFilter = $7e3e99f445db3d3b$export$8cc0e33a27868391, ...watchOptions } = options;
    const filteredCb = $7e3e99f445db3d3b$export$a1f1cf91007f23bf(eventFilter, cb);
    let ignoreUpdates;
    let ignorePrevAsyncUpdates;
    let stop;
    if (watchOptions.flush === "sync") {
        let ignore = false;
        ignorePrevAsyncUpdates = ()=>{};
        ignoreUpdates = (updater)=>{
            ignore = true;
            updater();
            ignore = false;
        };
        stop = (0, $01W3b.watch)(source, (...args)=>{
            if (!ignore) filteredCb(...args);
        }, watchOptions);
    } else {
        const disposables = [];
        let ignoreCounter = 0;
        let syncCounter = 0;
        ignorePrevAsyncUpdates = ()=>{
            ignoreCounter = syncCounter;
        };
        disposables.push((0, $01W3b.watch)(source, ()=>{
            syncCounter++;
        }, {
            ...watchOptions,
            flush: "sync"
        }));
        ignoreUpdates = (updater)=>{
            const syncCounterPrev = syncCounter;
            updater();
            ignoreCounter += syncCounter - syncCounterPrev;
        };
        disposables.push((0, $01W3b.watch)(source, (...args)=>{
            const ignore = ignoreCounter > 0 && ignoreCounter === syncCounter;
            ignoreCounter = 0;
            syncCounter = 0;
            if (ignore) return;
            filteredCb(...args);
        }, watchOptions));
        stop = ()=>{
            disposables.forEach((fn)=>fn());
        };
    }
    return {
        stop: stop,
        ignoreUpdates: ignoreUpdates,
        ignorePrevAsyncUpdates: ignorePrevAsyncUpdates
    };
}
/** @deprecated use `watchIgnorable` instead */ const $7e3e99f445db3d3b$export$63ac06655f58d92a = $7e3e99f445db3d3b$export$3a6f8a7df9ef7264;
//#endregion
//#region watchImmediate/index.ts
/**
* Shorthand for watching value with {immediate: true}
*
* @see https://vueuse.org/watchImmediate
*/ function $7e3e99f445db3d3b$export$d9aec7ec4e8a1634(source, cb, options) {
    return (0, $01W3b.watch)(source, cb, {
        ...options,
        immediate: true
    });
}
//#endregion
//#region watchOnce/index.ts
/**
* Shorthand for watching value with { once: true }
*
* @see https://vueuse.org/watchOnce
*/ function $7e3e99f445db3d3b$export$95d4a8ca30b80ae0(source, cb, options) {
    return (0, $01W3b.watch)(source, cb, {
        ...options,
        once: true
    });
}
//#endregion
//#region watchThrottled/index.ts
function $7e3e99f445db3d3b$export$f16f4c6ea5ba8b0d(source, cb, options = {}) {
    const { throttle: throttle = 0, trailing: trailing = true, leading: leading = true, ...watchOptions } = options;
    return $7e3e99f445db3d3b$export$3955c00bb6715986(source, cb, {
        ...watchOptions,
        eventFilter: $7e3e99f445db3d3b$export$cd62e9dbf204fd92(throttle, trailing, leading)
    });
}
/** @deprecated use `watchThrottled` instead */ const $7e3e99f445db3d3b$export$2768dce732d5eb3 = $7e3e99f445db3d3b$export$f16f4c6ea5ba8b0d;
//#endregion
//#region watchTriggerable/index.ts
function $7e3e99f445db3d3b$export$b75c094d1092c205(source, cb, options = {}) {
    let cleanupFn;
    function onEffect() {
        if (!cleanupFn) return;
        const fn = cleanupFn;
        cleanupFn = void 0;
        fn();
    }
    /** Register the function `cleanupFn` */ function onCleanup(callback) {
        cleanupFn = callback;
    }
    const _cb = (value, oldValue)=>{
        onEffect();
        return cb(value, oldValue, onCleanup);
    };
    const res = $7e3e99f445db3d3b$export$3a6f8a7df9ef7264(source, _cb, options);
    const { ignoreUpdates: ignoreUpdates } = res;
    const trigger = ()=>{
        let res;
        ignoreUpdates(()=>{
            res = _cb($7e3e99f445db3d3b$var$getWatchSources(source), $7e3e99f445db3d3b$var$getOldValue(source));
        });
        return res;
    };
    return {
        ...res,
        trigger: trigger
    };
}
function $7e3e99f445db3d3b$var$getWatchSources(sources) {
    if ((0, $01W3b.isReactive)(sources)) return sources;
    if (Array.isArray(sources)) return sources.map((item)=>(0, $01W3b.toValue)(item));
    return (0, $01W3b.toValue)(sources);
}
function $7e3e99f445db3d3b$var$getOldValue(source) {
    return Array.isArray(source) ? source.map(()=>void 0) : void 0;
}
//#endregion
//#region whenever/index.ts
function $7e3e99f445db3d3b$export$909eba9696cc3445(source, cb, options) {
    const stop = (0, $01W3b.watch)(source, (v, ov, onInvalidate)=>{
        if (v) {
            if (options === null || options === void 0 ? void 0 : options.once) (0, $TusQn.nextTick)(()=>stop());
            cb(v, ov, onInvalidate);
        }
    }, {
        ...options,
        once: false
    });
    return stop;
}

});


parcelRegister("7eXmP", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $6b6c33093439d235$export$fce6876652108ab);
$parcel$export(module.exports, "isBoolean", () => $6b6c33093439d235$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isNumber", () => $6b6c33093439d235$export$7e4aa119212bc614);
$parcel$export(module.exports, "isEmpty", () => $6b6c33093439d235$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "isElement", () => $6b6c33093439d235$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isPropAbsent", () => $6b6c33093439d235$export$5fa05d6447c72b52);
$parcel$export(module.exports, "isStringNumber", () => $6b6c33093439d235$export$c28be6c4c9d8f124);
$parcel$export(module.exports, "isWindow", () => $6b6c33093439d235$export$5a096129d439f843);
$parcel$export(module.exports, "isArray", () => (parcelRequire("8POXm")).isArray);
$parcel$export(module.exports, "isObject", () => (parcelRequire("8POXm")).isObject);
$parcel$export(module.exports, "isString", () => (parcelRequire("8POXm")).isString);

var $8POXm = parcelRequire("8POXm");

var $fpLZH = parcelRequire("fpLZH");
//#region ../../packages/utils/types.ts
const $6b6c33093439d235$export$fce6876652108ab = (val)=>val === void 0;
const $6b6c33093439d235$export$f9ce7b637dfbe238 = (val)=>typeof val === "boolean";
const $6b6c33093439d235$export$7e4aa119212bc614 = (val)=>typeof val === "number";
const $6b6c33093439d235$export$dd1bc94b04021eeb = (val)=>!val && val !== 0 || (0, $8POXm.isArray)(val) && val.length === 0 || (0, $8POXm.isObject)(val) && !Object.keys(val).length;
const $6b6c33093439d235$export$45a5e7f76e0caa8d = (e)=>{
    if (typeof Element === "undefined") return false;
    return e instanceof Element;
};
const $6b6c33093439d235$export$5fa05d6447c72b52 = (prop)=>(0, $fpLZH.isNil)(prop);
const $6b6c33093439d235$export$c28be6c4c9d8f124 = (val)=>{
    if (!(0, $8POXm.isString)(val)) return false;
    return !Number.isNaN(Number(val));
};
const $6b6c33093439d235$export$5a096129d439f843 = (val)=>val === window;

});

parcelRegister("2YSiN", function(module, exports) {

$parcel$export(module.exports, "throwError", () => $8602d89b9aa961fe$export$8bf7aba4a9e09055);
$parcel$export(module.exports, "debugWarn", () => $8602d89b9aa961fe$export$e14ef1f20abddcb5);
parcelRequire("7eXmP");
var $8POXm = parcelRequire("8POXm");
//#region ../../packages/utils/error.ts
var $8602d89b9aa961fe$var$ElementPlusError = class extends Error {
    constructor(m){
        super(m);
        this.name = "ElementPlusError";
    }
};
function $8602d89b9aa961fe$export$8bf7aba4a9e09055(scope, m) {
    throw new $8602d89b9aa961fe$var$ElementPlusError(`[${scope}] ${m}`);
}
function $8602d89b9aa961fe$export$e14ef1f20abddcb5(scope, message) {
    {
        const error = (0, $8POXm.isString)(scope) ? new $8602d89b9aa961fe$var$ElementPlusError(`[${scope}] ${message}`) : scope;
        console.warn(error);
    }
}

});

parcelRegister("9OIed", function(module, exports) {

$parcel$export(module.exports, "messageConfig", () => $672825d0cdb5bbf6$export$a5d677d602114dbf);
$parcel$export(module.exports, "default", () => $672825d0cdb5bbf6$export$2e2bcd8739ae039);

var $7h4nQ = parcelRequire("7h4nQ");

var $7EkzJ = parcelRequire("7EkzJ");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
//#region ../../packages/components/config-provider/src/config-provider.ts
const $672825d0cdb5bbf6$export$a5d677d602114dbf = {
    placement: "top"
};
const $672825d0cdb5bbf6$export$2e2bcd8739ae039 = (0, $TusQn.defineComponent)({
    name: "ElConfigProvider",
    props: (0, $7EkzJ.configProviderProps),
    setup (props, { slots: slots }) {
        const config = (0, $7h4nQ.provideGlobalConfig)(props);
        (0, $01W3b.watch)(()=>props.message, (val)=>{
            Object.assign($672825d0cdb5bbf6$export$a5d677d602114dbf, config?.value?.message ?? {}, val ?? {});
        }, {
            immediate: true,
            deep: true
        });
        return ()=>(0, $TusQn.renderSlot)(slots, "default", {
                config: config?.value
            });
    }
});

});
parcelRegister("7h4nQ", function(module, exports) {

$parcel$export(module.exports, "useGlobalConfig", () => $e79d671b5ee1cf98$export$29031ce8b4e54e85);
$parcel$export(module.exports, "useGlobalComponentSettings", () => $e79d671b5ee1cf98$export$3d55d05a7201392d);
$parcel$export(module.exports, "provideGlobalConfig", () => $e79d671b5ee1cf98$export$6e56961ebe309ef0);

var $bgAd2 = parcelRequire("bgAd2");

var $2YSiN = parcelRequire("2YSiN");

var $95iHl = parcelRequire("95iHl");

var $87qdP = parcelRequire("87qdP");

var $gxje9 = parcelRequire("gxje9");

var $jcDdb = parcelRequire("jcDdb");

var $jGvau = parcelRequire("jGvau");

var $1I4Iv = parcelRequire("1I4Iv");

var $fpLZH = parcelRequire("fpLZH");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
//#region ../../packages/components/config-provider/src/hooks/use-global-config.ts
const $e79d671b5ee1cf98$var$globalConfig = (0, $01W3b.ref)();
function $e79d671b5ee1cf98$export$29031ce8b4e54e85(key, defaultValue) {
    const config = (0, $TusQn.getCurrentInstance)() ? (0, $TusQn.inject)((0, $1I4Iv.configProviderContextKey), $e79d671b5ee1cf98$var$globalConfig) : $e79d671b5ee1cf98$var$globalConfig;
    if (key) return (0, $01W3b.computed)(()=>config.value?.[key] ?? defaultValue);
    else return config;
}
function $e79d671b5ee1cf98$export$3d55d05a7201392d(block, sizeFallback) {
    const config = $e79d671b5ee1cf98$export$29031ce8b4e54e85();
    const ns = (0, $87qdP.useNamespace)(block, (0, $01W3b.computed)(()=>config.value?.namespace || "el"));
    const locale = (0, $95iHl.useLocale)((0, $01W3b.computed)(()=>config.value?.locale));
    const zIndex = (0, $gxje9.useZIndex)((0, $01W3b.computed)(()=>{
        const zIndex = config.value?.zIndex;
        return (0, $fpLZH.isNil)(zIndex) || Number.isNaN(zIndex) ? (0, $gxje9.defaultInitialZIndex) : zIndex;
    }));
    const size = (0, $01W3b.computed)(()=>(0, $01W3b.unref)(sizeFallback) || config.value?.size || "");
    $e79d671b5ee1cf98$export$6e56961ebe309ef0((0, $01W3b.computed)(()=>(0, $01W3b.unref)(config) || {}));
    return {
        ns: ns,
        locale: locale,
        zIndex: zIndex,
        size: size
    };
}
const $e79d671b5ee1cf98$export$6e56961ebe309ef0 = (config, app, global = false)=>{
    const inSetup = !!(0, $TusQn.getCurrentInstance)();
    const oldConfig = inSetup ? $e79d671b5ee1cf98$export$29031ce8b4e54e85() : void 0;
    const provideFn = app?.provide ?? (inSetup ? (0, $TusQn.provide) : void 0);
    if (!provideFn) {
        (0, $2YSiN.debugWarn)("provideGlobalConfig", "provideGlobalConfig() can only be used inside setup().");
        return;
    }
    const context = (0, $01W3b.computed)(()=>{
        const cfg = (0, $01W3b.unref)(config);
        if (!oldConfig?.value) return cfg;
        return $e79d671b5ee1cf98$var$mergeConfig(oldConfig.value, cfg);
    });
    provideFn((0, $1I4Iv.configProviderContextKey), context);
    provideFn((0, $95iHl.localeContextKey), (0, $01W3b.computed)(()=>context.value.locale));
    provideFn((0, $87qdP.namespaceContextKey), (0, $01W3b.computed)(()=>context.value.namespace));
    provideFn((0, $gxje9.zIndexContextKey), (0, $01W3b.computed)(()=>context.value.zIndex));
    provideFn((0, $jcDdb.SIZE_INJECTION_KEY), {
        size: (0, $01W3b.computed)(()=>context.value.size || "")
    });
    provideFn((0, $jGvau.emptyValuesContextKey), (0, $01W3b.computed)(()=>({
            emptyValues: context.value.emptyValues,
            valueOnClear: context.value.valueOnClear
        })));
    if (global || !$e79d671b5ee1cf98$var$globalConfig.value) $e79d671b5ee1cf98$var$globalConfig.value = context.value;
    return context;
};
const $e79d671b5ee1cf98$var$mergeConfig = (a, b)=>{
    const keys = [
        ...new Set([
            ...(0, $bgAd2.keysOf)(a),
            ...(0, $bgAd2.keysOf)(b)
        ])
    ];
    const obj = {};
    for (const key of keys)obj[key] = b[key] !== void 0 ? b[key] : a[key];
    return obj;
};

});
parcelRegister("bgAd2", function(module, exports) {

$parcel$export(module.exports, "keysOf", () => $3c842aa19f87933a$export$c869321ab9f63b9e);
$parcel$export(module.exports, "entriesOf", () => $3c842aa19f87933a$export$372f9544b7df828f);
$parcel$export(module.exports, "getProp", () => $3c842aa19f87933a$export$88c9ddb45cea7241);

var $8POXm = parcelRequire("8POXm");

var $fpLZH = parcelRequire("fpLZH");
//#region ../../packages/utils/objects.ts
const $3c842aa19f87933a$export$c869321ab9f63b9e = (arr)=>Object.keys(arr);
const $3c842aa19f87933a$export$372f9544b7df828f = (arr)=>Object.entries(arr);
const $3c842aa19f87933a$export$88c9ddb45cea7241 = (obj, path, defaultValue)=>{
    return {
        get value () {
            return (0, $fpLZH.get)(obj, path, defaultValue);
        },
        set value (val){
            (0, $fpLZH.set)(obj, path, val);
        }
    };
};

});

parcelRegister("95iHl", function(module, exports) {

$parcel$export(module.exports, "localeContextKey", () => $cfaa9f0471e1ef92$export$ca3ec22a3b669d1a);
$parcel$export(module.exports, "useLocale", () => $cfaa9f0471e1ef92$export$43bb16f9c6d9e3f7);

var $ccPRA = parcelRequire("ccPRA");

var $fpLZH = parcelRequire("fpLZH");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
//#region ../../packages/hooks/use-locale/index.ts
const $cfaa9f0471e1ef92$export$2f72ff0a25f57d90 = (locale)=>(path, option)=>$cfaa9f0471e1ef92$export$d73ee8ef04f5226a(path, option, (0, $01W3b.unref)(locale));
const $cfaa9f0471e1ef92$export$d73ee8ef04f5226a = (path, option, locale)=>(0, $fpLZH.get)(locale, path, path).replace(/\{(\w+)\}/g, (_, key)=>`${option?.[key] ?? `{${key}}`}`);
const $cfaa9f0471e1ef92$export$1696ecedf3924c95 = (locale)=>{
    return {
        lang: (0, $01W3b.computed)(()=>(0, $01W3b.unref)(locale).name),
        locale: (0, $01W3b.isRef)(locale) ? locale : (0, $01W3b.ref)(locale),
        t: $cfaa9f0471e1ef92$export$2f72ff0a25f57d90(locale)
    };
};
const $cfaa9f0471e1ef92$export$ca3ec22a3b669d1a = Symbol("localeContextKey");
const $cfaa9f0471e1ef92$export$43bb16f9c6d9e3f7 = (localeOverrides)=>{
    const locale = localeOverrides || (0, $TusQn.inject)($cfaa9f0471e1ef92$export$ca3ec22a3b669d1a, (0, $01W3b.ref)());
    return $cfaa9f0471e1ef92$export$1696ecedf3924c95((0, $01W3b.computed)(()=>locale.value || (0, $ccPRA.default)));
};

});

parcelRegister("87qdP", function(module, exports) {

$parcel$export(module.exports, "namespaceContextKey", () => $858fb23754fc011f$export$c9bc548e59064c70);
$parcel$export(module.exports, "useGetDerivedNamespace", () => $858fb23754fc011f$export$936215971a6b2a43);
$parcel$export(module.exports, "useNamespace", () => $858fb23754fc011f$export$36865cb38f168067);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
//#region ../../packages/hooks/use-namespace/index.ts
const $858fb23754fc011f$export$4ba431a01d85bff = "el";
const $858fb23754fc011f$var$statePrefix = "is-";
const $858fb23754fc011f$var$_bem = (namespace, block, blockSuffix, element, modifier)=>{
    let cls = `${namespace}-${block}`;
    if (blockSuffix) cls += `-${blockSuffix}`;
    if (element) cls += `__${element}`;
    if (modifier) cls += `--${modifier}`;
    return cls;
};
const $858fb23754fc011f$export$c9bc548e59064c70 = Symbol("namespaceContextKey");
const $858fb23754fc011f$export$936215971a6b2a43 = (namespaceOverrides)=>{
    const derivedNamespace = namespaceOverrides || ((0, $TusQn.getCurrentInstance)() ? (0, $TusQn.inject)($858fb23754fc011f$export$c9bc548e59064c70, (0, $01W3b.ref)("el")) : (0, $01W3b.ref)("el"));
    return (0, $01W3b.computed)(()=>{
        return (0, $01W3b.unref)(derivedNamespace) || "el";
    });
};
const $858fb23754fc011f$export$36865cb38f168067 = (block, namespaceOverrides)=>{
    const namespace = $858fb23754fc011f$export$936215971a6b2a43(namespaceOverrides);
    const b = (blockSuffix = "")=>$858fb23754fc011f$var$_bem(namespace.value, block, blockSuffix, "", "");
    const e = (element)=>element ? $858fb23754fc011f$var$_bem(namespace.value, block, "", element, "") : "";
    const m = (modifier)=>modifier ? $858fb23754fc011f$var$_bem(namespace.value, block, "", "", modifier) : "";
    const be = (blockSuffix, element)=>blockSuffix && element ? $858fb23754fc011f$var$_bem(namespace.value, block, blockSuffix, element, "") : "";
    const em = (element, modifier)=>element && modifier ? $858fb23754fc011f$var$_bem(namespace.value, block, "", element, modifier) : "";
    const bm = (blockSuffix, modifier)=>blockSuffix && modifier ? $858fb23754fc011f$var$_bem(namespace.value, block, blockSuffix, "", modifier) : "";
    const bem = (blockSuffix, element, modifier)=>blockSuffix && element && modifier ? $858fb23754fc011f$var$_bem(namespace.value, block, blockSuffix, element, modifier) : "";
    const is = (name, ...args)=>{
        const state = args.length >= 1 ? args[0] : true;
        return name && state ? `${$858fb23754fc011f$var$statePrefix}${name}` : "";
    };
    const cssVar = (object)=>{
        const styles = {};
        for(const key in object)if (object[key]) styles[`--${namespace.value}-${key}`] = object[key];
        return styles;
    };
    const cssVarBlock = (object)=>{
        const styles = {};
        for(const key in object)if (object[key]) styles[`--${namespace.value}-${block}-${key}`] = object[key];
        return styles;
    };
    const cssVarName = (name)=>`--${namespace.value}-${name}`;
    const cssVarBlockName = (name)=>`--${namespace.value}-${block}-${name}`;
    return {
        namespace: namespace,
        b: b,
        e: e,
        m: m,
        be: be,
        em: em,
        bm: bm,
        bem: bem,
        is: is,
        cssVar: cssVar,
        cssVarName: cssVarName,
        cssVarBlock: cssVarBlock,
        cssVarBlockName: cssVarBlockName
    };
};

});

parcelRegister("gxje9", function(module, exports) {

$parcel$export(module.exports, "defaultInitialZIndex", () => $bfd7ccb305cd5102$export$3a43ce769297a0f4);
$parcel$export(module.exports, "zIndexContextKey", () => $bfd7ccb305cd5102$export$ffc717f4c7294626);
$parcel$export(module.exports, "useZIndex", () => $bfd7ccb305cd5102$export$3e7906d4075187a4);
parcelRequire("cB44k");
var $aPZNl = parcelRequire("aPZNl");

var $7eXmP = parcelRequire("7eXmP");

var $2YSiN = parcelRequire("2YSiN");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
//#region ../../packages/hooks/use-z-index/index.ts
const $bfd7ccb305cd5102$var$initial = {
    current: 0
};
const $bfd7ccb305cd5102$var$zIndex = (0, $01W3b.ref)(0);
const $bfd7ccb305cd5102$export$3a43ce769297a0f4 = 2e3;
const $bfd7ccb305cd5102$export$a56f372ca687380a = Symbol("elZIndexContextKey");
const $bfd7ccb305cd5102$export$ffc717f4c7294626 = Symbol("zIndexContextKey");
const $bfd7ccb305cd5102$export$3e7906d4075187a4 = (zIndexOverrides)=>{
    const increasingInjection = (0, $TusQn.getCurrentInstance)() ? (0, $TusQn.inject)($bfd7ccb305cd5102$export$a56f372ca687380a, $bfd7ccb305cd5102$var$initial) : $bfd7ccb305cd5102$var$initial;
    const zIndexInjection = zIndexOverrides || ((0, $TusQn.getCurrentInstance)() ? (0, $TusQn.inject)($bfd7ccb305cd5102$export$ffc717f4c7294626, void 0) : void 0);
    const initialZIndex = (0, $01W3b.computed)(()=>{
        const zIndexFromInjection = (0, $01W3b.unref)(zIndexInjection);
        return (0, $7eXmP.isNumber)(zIndexFromInjection) ? zIndexFromInjection : $bfd7ccb305cd5102$export$3a43ce769297a0f4;
    });
    const currentZIndex = (0, $01W3b.computed)(()=>initialZIndex.value + $bfd7ccb305cd5102$var$zIndex.value);
    const nextZIndex = ()=>{
        increasingInjection.current++;
        $bfd7ccb305cd5102$var$zIndex.value = increasingInjection.current;
        return currentZIndex.value;
    };
    if (!(0, $aPZNl.isClient) && !(0, $TusQn.inject)($bfd7ccb305cd5102$export$a56f372ca687380a)) (0, $2YSiN.debugWarn)("ZIndexInjection", `Looks like you are using server rendering, you must provide a z-index provider to ensure the hydration process to be succeed
usage: app.provide(ZINDEX_INJECTION_KEY, { current: 0 })`);
    return {
        initialZIndex: initialZIndex,
        currentZIndex: currentZIndex,
        nextZIndex: nextZIndex
    };
};

});

parcelRegister("jcDdb", function(module, exports) {

$parcel$export(module.exports, "useSizeProp", () => $fa1920fd2f80c9d0$export$fc4ced8fdf5eeb81);
$parcel$export(module.exports, "SIZE_INJECTION_KEY", () => $fa1920fd2f80c9d0$export$5fbe9e1d2345bf40);
$parcel$export(module.exports, "useGlobalSize", () => $fa1920fd2f80c9d0$export$805b8bb2224f6c97);

var $01xaH = parcelRequire("01xaH");

var $1RPMp = parcelRequire("1RPMp");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
//#region ../../packages/hooks/use-size/index.ts
const $fa1920fd2f80c9d0$export$fc4ced8fdf5eeb81 = (0, $1RPMp.buildProp)({
    type: String,
    values: (0, $01xaH.componentSizes),
    required: false
});
const $fa1920fd2f80c9d0$export$4c350e33e62f18da = {
    size: $fa1920fd2f80c9d0$export$fc4ced8fdf5eeb81
};
const $fa1920fd2f80c9d0$export$5fbe9e1d2345bf40 = Symbol("size");
const $fa1920fd2f80c9d0$export$805b8bb2224f6c97 = ()=>{
    const injectedSize = (0, $TusQn.inject)($fa1920fd2f80c9d0$export$5fbe9e1d2345bf40, {});
    return (0, $01W3b.computed)(()=>{
        return (0, $01W3b.unref)(injectedSize.size) || "";
    });
};

});
parcelRegister("01xaH", function(module, exports) {

$parcel$export(module.exports, "componentSizes", () => $0a25c979b2cec3dc$export$7892c2bcdb6f4218);
//#region ../../packages/constants/size.ts
const $0a25c979b2cec3dc$export$7892c2bcdb6f4218 = [
    "",
    "default",
    "small",
    "large"
];
const $0a25c979b2cec3dc$export$b18d1037fc50d09b = {
    large: 40,
    default: 32,
    small: 24
};

});

parcelRegister("1RPMp", function(module, exports) {

$parcel$export(module.exports, "definePropType", () => $1bdb06a81ff88ef8$export$fc8f78ef673a4b01);
$parcel$export(module.exports, "buildProp", () => $1bdb06a81ff88ef8$export$ff441cf2113a23d9);
$parcel$export(module.exports, "buildProps", () => $1bdb06a81ff88ef8$export$bc4cd0273bb05e1b);
parcelRequire("7eXmP");
var $8POXm = parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");

var $fpLZH = parcelRequire("fpLZH");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
//#region ../../packages/utils/vue/props/runtime.ts
const $1bdb06a81ff88ef8$export$3ad1385c8afba548 = "__epPropKey";
const $1bdb06a81ff88ef8$export$fc8f78ef673a4b01 = (val)=>val;
const $1bdb06a81ff88ef8$export$6095b66581952c52 = (val)=>(0, $8POXm.isObject)(val) && !!val["__epPropKey"];
/**
* @description Build prop. It can better optimize prop types
* @description 生成 prop，能更好地优化类型
* @example
// limited options
// the type will be PropType<'light' | 'dark'>
buildProp({
type: String,
values: ['light', 'dark'],
} as const)
* @example
// limited options and other types
// the type will be PropType<'small' | 'large' | number>
buildProp({
type: [String, Number],
values: ['small', 'large'],
validator: (val: unknown): val is number => typeof val === 'number',
} as const)
@link see more: https://github.com/element-plus/element-plus/pull/3341
*/ const $1bdb06a81ff88ef8$export$ff441cf2113a23d9 = (prop, key)=>{
    if (!(0, $8POXm.isObject)(prop) || $1bdb06a81ff88ef8$export$6095b66581952c52(prop)) return prop;
    const { values: values, required: required, default: defaultValue, type: type, validator: validator } = prop;
    const epProp = {
        type: type,
        required: !!required,
        validator: values || validator ? (val)=>{
            let valid = false;
            let allowedValues = [];
            if (values) {
                allowedValues = Array.from(values);
                if ((0, $8POXm.hasOwn)(prop, "default")) allowedValues.push(defaultValue);
                valid ||= allowedValues.includes(val);
            }
            if (validator) valid ||= validator(val);
            if (!valid && allowedValues.length > 0) {
                const allowValuesText = [
                    ...new Set(allowedValues)
                ].map((value)=>JSON.stringify(value)).join(", ");
                (0, $TusQn.warn)(`Invalid prop: validation failed${key ? ` for prop "${key}"` : ""}. Expected one of [${allowValuesText}], got value ${JSON.stringify(val)}.`);
            }
            return valid;
        } : void 0,
        [$1bdb06a81ff88ef8$export$3ad1385c8afba548]: true
    };
    if ((0, $8POXm.hasOwn)(prop, "default")) epProp.default = defaultValue;
    return epProp;
};
const $1bdb06a81ff88ef8$export$bc4cd0273bb05e1b = (props)=>(0, $fpLZH.fromPairs)(Object.entries(props).map(([key, option])=>[
            key,
            $1bdb06a81ff88ef8$export$ff441cf2113a23d9(option, key)
        ]));

});


parcelRegister("jGvau", function(module, exports) {

$parcel$export(module.exports, "emptyValuesContextKey", () => $d4450a1688797a4e$export$427905894e54f735);
$parcel$export(module.exports, "useEmptyValuesProps", () => $d4450a1688797a4e$export$110c1d125a0e4483);
$parcel$export(module.exports, "useEmptyValues", () => $d4450a1688797a4e$export$c01bb921e04e6f86);
parcelRequire("7eXmP");
var $8POXm = parcelRequire("8POXm");
var $8POXm = parcelRequire("8POXm");

var $2YSiN = parcelRequire("2YSiN");

var $1RPMp = parcelRequire("1RPMp");

var $fpLZH = parcelRequire("fpLZH");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
//#region ../../packages/hooks/use-empty-values/index.ts
const $d4450a1688797a4e$export$427905894e54f735 = Symbol("emptyValuesContextKey");
const $d4450a1688797a4e$export$1c5a554c78c0cd12 = "use-empty-values";
const $d4450a1688797a4e$export$4cdf908a0b365f28 = [
    "",
    void 0,
    null
];
const $d4450a1688797a4e$export$2816f29bd2a36905 = void 0;
/**
* @deprecated Removed after 3.0.0, Use `UseEmptyValuesProps` instead.
*/ const $d4450a1688797a4e$export$110c1d125a0e4483 = (0, $1RPMp.buildProps)({
    /**
	* @description empty values supported by the component
	*/ emptyValues: Array,
    /**
	* @description return value when cleared, if you want to set `undefined`, use `() => undefined`
	*/ valueOnClear: {
        type: (0, $1RPMp.definePropType)([
            String,
            Number,
            Boolean,
            Function
        ]),
        default: void 0,
        validator: (val)=>{
            val = (0, $8POXm.isFunction)(val) ? val() : val;
            if ((0, $8POXm.isArray)(val)) return val.every((item)=>!item);
            return !val;
        }
    }
});
const $d4450a1688797a4e$export$c01bb921e04e6f86 = (props, defaultValue)=>{
    const config = (0, $TusQn.getCurrentInstance)() ? (0, $TusQn.inject)($d4450a1688797a4e$export$427905894e54f735, (0, $01W3b.ref)({})) : (0, $01W3b.ref)({});
    const emptyValues = (0, $01W3b.computed)(()=>props.emptyValues || config.value.emptyValues || $d4450a1688797a4e$export$4cdf908a0b365f28);
    const valueOnClear = (0, $01W3b.computed)(()=>{
        if ((0, $8POXm.isFunction)(props.valueOnClear)) return props.valueOnClear();
        else if (props.valueOnClear !== void 0) return props.valueOnClear;
        else if ((0, $8POXm.isFunction)(config.value.valueOnClear)) return config.value.valueOnClear();
        else if (config.value.valueOnClear !== void 0) return config.value.valueOnClear;
        return defaultValue !== void 0 ? defaultValue : void 0;
    });
    const isEmptyValue = (value)=>{
        let result = true;
        if ((0, $8POXm.isArray)(value)) result = emptyValues.value.some((emptyValue)=>{
            return (0, $fpLZH.isEqual)(value, emptyValue);
        });
        else result = emptyValues.value.includes(value);
        return result;
    };
    if (!isEmptyValue(valueOnClear.value)) (0, $2YSiN.debugWarn)($d4450a1688797a4e$export$1c5a554c78c0cd12, "value-on-clear should be a value of empty-values");
    return {
        emptyValues: emptyValues,
        valueOnClear: valueOnClear,
        isEmptyValue: isEmptyValue
    };
};

});

parcelRegister("1I4Iv", function(module, exports) {

$parcel$export(module.exports, "configProviderContextKey", () => $63bfc52b474a8437$export$296118318bd24b4d);
//#region ../../packages/components/config-provider/src/constants.ts
const $63bfc52b474a8437$export$296118318bd24b4d = Symbol();

});


parcelRegister("7EkzJ", function(module, exports) {

$parcel$export(module.exports, "configProviderProps", () => $47cc068b76fcc45f$export$2590bbb255115843);

var $1RPMp = parcelRequire("1RPMp");

var $jcDdb = parcelRequire("jcDdb");

var $jGvau = parcelRequire("jGvau");
//#region ../../packages/components/config-provider/src/config-provider-props.ts
const $47cc068b76fcc45f$export$2590bbb255115843 = (0, $1RPMp.buildProps)({
    /**
	* @description Controlling if the users want a11y features
	*/ a11y: {
        type: Boolean,
        default: true
    },
    /**
	* @description Locale Object
	*/ locale: {
        type: (0, $1RPMp.definePropType)(Object)
    },
    /**
	* @description global component size
	*/ size: (0, $jcDdb.useSizeProp),
    /**
	* @description button related configuration, [see the following table](https://element-plus.org/en-US/component/config-provider.html#button-attribute)
	*/ button: {
        type: (0, $1RPMp.definePropType)(Object)
    },
    /**
	* @description card related configuration, [see the following table](https://element-plus.org/en-US/component/config-provider.html#card-attribute)
	*/ card: {
        type: (0, $1RPMp.definePropType)(Object)
    },
    /**
	* @description dialog related configuration, [see the following table](https://element-plus.org/en-US/component/config-provider.html#dialog-attribute)
	*/ dialog: {
        type: (0, $1RPMp.definePropType)(Object)
    },
    /**
	* @description link related configuration, [see the following table](https://element-plus.org/en-US/component/config-provider.html#link-attribute)
	*/ link: {
        type: (0, $1RPMp.definePropType)(Object)
    },
    /**
	* @description features at experimental stage to be added, all features are default to be set to false, [see the following table](https://element-plus.org/en-US/component/config-provider.html#experimental-features)                                                                            | ^[object]
	*/ experimentalFeatures: {
        type: (0, $1RPMp.definePropType)(Object)
    },
    /**
	* @description Controls if we should handle keyboard navigation
	*/ keyboardNavigation: {
        type: Boolean,
        default: true
    },
    /**
	* @description message related configuration, [see the following table](https://element-plus.org/en-US/component/config-provider.html#message-attribute)
	*/ message: {
        type: (0, $1RPMp.definePropType)(Object)
    },
    /**
	* @description global Initial zIndex
	*/ zIndex: Number,
    /**
	* @description global component className prefix (cooperated with [$namespace](https://github.com/element-plus/element-plus/blob/dev/packages/theme-chalk/src/mixins/config.scss#L1)) | ^[string]
	*/ namespace: {
        type: String,
        default: "el"
    },
    /**
	* @description table related configuration, [see the following table](https://element-plus.org/en-US/component/config-provider.html#table-attribute)
	*/ table: {
        type: (0, $1RPMp.definePropType)(Object)
    },
    ...(0, $jGvau.useEmptyValuesProps)
});

});


parcelRegister("6sMT7", function(module, exports) {

$parcel$export(module.exports, "messageTypes", () => $051fe6bc5e0372c0$export$e4d84787c2301878);
$parcel$export(module.exports, "messagePlacement", () => $051fe6bc5e0372c0$export$227ac5f96213db2f);
$parcel$export(module.exports, "messageDefaults", () => $051fe6bc5e0372c0$export$f4f9596e3027fa97);
$parcel$export(module.exports, "messageProps", () => $051fe6bc5e0372c0$export$2f8223e438c8a191);
$parcel$export(module.exports, "messageEmits", () => $051fe6bc5e0372c0$export$53642747df780119);
parcelRequire("cB44k");
var $aPZNl = parcelRequire("aPZNl");

var $1RPMp = parcelRequire("1RPMp");

var $4yuAl = parcelRequire("4yuAl");

var $eCh8z = parcelRequire("eCh8z");
//#region ../../packages/components/message/src/message.ts
const $051fe6bc5e0372c0$export$e4d84787c2301878 = [
    "primary",
    "success",
    "info",
    "warning",
    "error"
];
const $051fe6bc5e0372c0$export$227ac5f96213db2f = [
    "top",
    "top-left",
    "top-right",
    "bottom",
    "bottom-left",
    "bottom-right"
];
const $051fe6bc5e0372c0$export$80b5f6d280be3329 = "top";
const $051fe6bc5e0372c0$export$f4f9596e3027fa97 = (0, $eCh8z.mutable)({
    customClass: "",
    dangerouslyUseHTMLString: false,
    duration: 3e3,
    icon: void 0,
    id: "",
    message: "",
    onClose: void 0,
    showClose: false,
    type: "info",
    plain: false,
    offset: 16,
    placement: void 0,
    zIndex: 0,
    grouping: false,
    repeatNum: 1,
    appendTo: (0, $aPZNl.isClient) ? document.body : void 0
});
/**
* @deprecated Removed after 3.0.0, Use `MessageProps` instead.
*/ const $051fe6bc5e0372c0$export$2f8223e438c8a191 = (0, $1RPMp.buildProps)({
    /**
	* @description custom class name for Message
	*/ customClass: {
        type: String,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.customClass
    },
    /**
	* @description whether `message` is treated as HTML string
	*/ dangerouslyUseHTMLString: {
        type: Boolean,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.dangerouslyUseHTMLString
    },
    /**
	* @description display duration, millisecond. If set to 0, it will not turn off automatically
	*/ duration: {
        type: Number,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.duration
    },
    /**
	* @description custom icon component, overrides `type`
	*/ icon: {
        type: (0, $4yuAl.iconPropType),
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.icon
    },
    /**
	* @description message dom id
	*/ id: {
        type: String,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.id
    },
    /**
	* @description message text
	*/ message: {
        type: (0, $1RPMp.definePropType)([
            String,
            Object,
            Function
        ]),
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.message
    },
    /**
	* @description callback function when closed with the message instance as the parameter
	*/ onClose: {
        type: (0, $1RPMp.definePropType)(Function),
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.onClose
    },
    /**
	* @description whether to show a close button
	*/ showClose: {
        type: Boolean,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.showClose
    },
    /**
	* @description message type
	*/ type: {
        type: String,
        values: $051fe6bc5e0372c0$export$e4d84787c2301878,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.type
    },
    /**
	* @description whether message is plain
	*/ plain: {
        type: Boolean,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.plain
    },
    /**
	* @description set the distance to the top of viewport
	*/ offset: {
        type: Number,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.offset
    },
    /**
	* @description message placement position
	*/ placement: {
        type: String,
        values: $051fe6bc5e0372c0$export$227ac5f96213db2f,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.placement
    },
    /**
	* @description message element zIndex value
	*/ zIndex: {
        type: Number,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.zIndex
    },
    /**
	* @description merge messages with the same content, type of VNode message is not supported
	*/ grouping: {
        type: Boolean,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.grouping
    },
    /**
	* @description The number of repetitions, similar to badge, is used as the initial number when used with `grouping`
	*/ repeatNum: {
        type: Number,
        default: $051fe6bc5e0372c0$export$f4f9596e3027fa97.repeatNum
    }
});
const $051fe6bc5e0372c0$export$53642747df780119 = {
    destroy: ()=>true
};

});
parcelRegister("4yuAl", function(module, exports) {

$parcel$export(module.exports, "iconPropType", () => $2a60f8387f7494ca$export$e25a4cae8eaea84f);
$parcel$export(module.exports, "CloseComponents", () => $2a60f8387f7494ca$export$33aa54d1819f0ce1);
$parcel$export(module.exports, "TypeComponents", () => $2a60f8387f7494ca$export$567a0e264f4a56eb);
$parcel$export(module.exports, "TypeComponentsMap", () => $2a60f8387f7494ca$export$f40aecfc952cc83d);
$parcel$export(module.exports, "ValidateComponentsMap", () => $2a60f8387f7494ca$export$805fb1f445a00233);

var $1RPMp = parcelRequire("1RPMp");

var $4Miza = parcelRequire("4Miza");
//#region ../../packages/utils/vue/icon.ts
const $2a60f8387f7494ca$export$e25a4cae8eaea84f = (0, $1RPMp.definePropType)([
    String,
    Object,
    Function
]);
const $2a60f8387f7494ca$export$33aa54d1819f0ce1 = {
    Close: $4Miza.Close
};
const $2a60f8387f7494ca$export$567a0e264f4a56eb = {
    Close: $4Miza.Close,
    SuccessFilled: $4Miza.SuccessFilled,
    InfoFilled: $4Miza.InfoFilled,
    WarningFilled: $4Miza.WarningFilled,
    CircleCloseFilled: $4Miza.CircleCloseFilled
};
const $2a60f8387f7494ca$export$f40aecfc952cc83d = {
    primary: (0, $4Miza.InfoFilled),
    success: (0, $4Miza.SuccessFilled),
    warning: (0, $4Miza.WarningFilled),
    error: (0, $4Miza.CircleCloseFilled),
    info: (0, $4Miza.InfoFilled)
};
const $2a60f8387f7494ca$export$805fb1f445a00233 = {
    validating: (0, $4Miza.Loading),
    success: (0, $4Miza.CircleCheck),
    error: (0, $4Miza.CircleClose)
};

});
parcelRegister("4Miza", function(module, exports) {

$parcel$export(module.exports, "ArrowDown", () => $37aa0bf70ef60230$export$1fa5a43af950a186);
$parcel$export(module.exports, "ArrowLeft", () => $37aa0bf70ef60230$export$e4c291d45fea4cd0);
$parcel$export(module.exports, "ArrowRight", () => $37aa0bf70ef60230$export$acad20503ad73ac1);
$parcel$export(module.exports, "ArrowUp", () => $37aa0bf70ef60230$export$2624c5890f1bbcf7);
$parcel$export(module.exports, "Back", () => $37aa0bf70ef60230$export$25e48ac541203d4a);
$parcel$export(module.exports, "Calendar", () => $37aa0bf70ef60230$export$e1aef45b828286de);
$parcel$export(module.exports, "CaretRight", () => $37aa0bf70ef60230$export$98ac0f496a0846de);
$parcel$export(module.exports, "CaretTop", () => $37aa0bf70ef60230$export$ee4a489416b22c29);
$parcel$export(module.exports, "Check", () => $37aa0bf70ef60230$export$60bffc6e2a50e7f9);
$parcel$export(module.exports, "CircleCheckFilled", () => $37aa0bf70ef60230$export$8d9ef6d183a38e6f);
$parcel$export(module.exports, "CircleCheck", () => $37aa0bf70ef60230$export$e98f1a5f8b66cf2);
$parcel$export(module.exports, "CircleCloseFilled", () => $37aa0bf70ef60230$export$eb5e919574e4808f);
$parcel$export(module.exports, "CircleClose", () => $37aa0bf70ef60230$export$abaca3c8ef8f75e4);
$parcel$export(module.exports, "Clock", () => $37aa0bf70ef60230$export$9735c82c4bae3302);
$parcel$export(module.exports, "Close", () => $37aa0bf70ef60230$export$f39c2d165cd861fe);
$parcel$export(module.exports, "DArrowLeft", () => $37aa0bf70ef60230$export$bc181e1009fb1f20);
$parcel$export(module.exports, "DArrowRight", () => $37aa0bf70ef60230$export$f6d4240c6dee439b);
$parcel$export(module.exports, "Delete", () => $37aa0bf70ef60230$export$bfadae053a633538);
$parcel$export(module.exports, "Document", () => $37aa0bf70ef60230$export$b34a105447964f9f);
$parcel$export(module.exports, "FullScreen", () => $37aa0bf70ef60230$export$f885b95b3f0be76d);
$parcel$export(module.exports, "Hide", () => $37aa0bf70ef60230$export$bed28288a051538);
$parcel$export(module.exports, "InfoFilled", () => $37aa0bf70ef60230$export$d2505fbd697b65ef);
$parcel$export(module.exports, "Loading", () => $37aa0bf70ef60230$export$669f6ea7d267feaf);
$parcel$export(module.exports, "Minus", () => $37aa0bf70ef60230$export$da45d96ed490d127);
$parcel$export(module.exports, "MoreFilled", () => $37aa0bf70ef60230$export$53e4dbce1155d264);
$parcel$export(module.exports, "More", () => $37aa0bf70ef60230$export$d440bfe209149ca5);
$parcel$export(module.exports, "PictureFilled", () => $37aa0bf70ef60230$export$399c7bf2478a7c6);
$parcel$export(module.exports, "Plus", () => $37aa0bf70ef60230$export$2d9ac7aa84f97a08);
$parcel$export(module.exports, "QuestionFilled", () => $37aa0bf70ef60230$export$506e04add06ac68b);
$parcel$export(module.exports, "RefreshLeft", () => $37aa0bf70ef60230$export$508e83cbbc160028);
$parcel$export(module.exports, "RefreshRight", () => $37aa0bf70ef60230$export$f036638f43d00a3c);
$parcel$export(module.exports, "ScaleToOriginal", () => $37aa0bf70ef60230$export$ea550ac48bb84963);
$parcel$export(module.exports, "Search", () => $37aa0bf70ef60230$export$4b85d3515bd863a5);
$parcel$export(module.exports, "SortDown", () => $37aa0bf70ef60230$export$7289022845b706f2);
$parcel$export(module.exports, "SortUp", () => $37aa0bf70ef60230$export$610129a4e97e5826);
$parcel$export(module.exports, "StarFilled", () => $37aa0bf70ef60230$export$5c83eb0ad220f681);
$parcel$export(module.exports, "Star", () => $37aa0bf70ef60230$export$1644ba17714857f1);
$parcel$export(module.exports, "SuccessFilled", () => $37aa0bf70ef60230$export$11c077e7878a3c8c);
$parcel$export(module.exports, "View", () => $37aa0bf70ef60230$export$27a5bd065ad55220);
$parcel$export(module.exports, "WarningFilled", () => $37aa0bf70ef60230$export$73296e0703a210f);
$parcel$export(module.exports, "ZoomIn", () => $37aa0bf70ef60230$export$d13069184bfa0730);
$parcel$export(module.exports, "ZoomOut", () => $37aa0bf70ef60230$export$adc4acb67269225);
/*! Element Plus Icons Vue v2.3.2 */ // src/components/add-location.vue
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $37aa0bf70ef60230$var$_sfc_main = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "AddLocation",
    __name: "add-location",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 384h96a32 32 0 1 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96v-96a32 32 0 0 1 64 0z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6710f3610f757456 = $37aa0bf70ef60230$var$_sfc_main;
var $37aa0bf70ef60230$var$_sfc_main2 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Aim",
    __name: "aim",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 96a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V128a32 32 0 0 1 32-32m0 576a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V704a32 32 0 0 1 32-32M96 512a32 32 0 0 1 32-32h192a32 32 0 0 1 0 64H128a32 32 0 0 1-32-32m576 0a32 32 0 0 1 32-32h192a32 32 0 1 1 0 64H704a32 32 0 0 1-32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$9dc667c60e2def33 = $37aa0bf70ef60230$var$_sfc_main2;
var $37aa0bf70ef60230$var$_sfc_main3 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "AlarmClock",
    __name: "alarm-clock",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 832a320 320 0 1 0 0-640 320 320 0 0 0 0 640m0 64a384 384 0 1 1 0-768 384 384 0 0 1 0 768"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m292.288 824.576 55.424 32-48 83.136a32 32 0 1 1-55.424-32zm439.424 0-55.424 32 48 83.136a32 32 0 1 0 55.424-32zM512 512h160a32 32 0 1 1 0 64H480a32 32 0 0 1-32-32V320a32 32 0 0 1 64 0zM90.496 312.256A160 160 0 0 1 312.32 90.496l-46.848 46.848a96 96 0 0 0-128 128L90.56 312.256zm835.264 0A160 160 0 0 0 704 90.496l46.848 46.848a96 96 0 0 1 128 128z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ac2f3eaef45cb222 = $37aa0bf70ef60230$var$_sfc_main3;
var $37aa0bf70ef60230$var$_sfc_main4 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Apple",
    __name: "apple",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M599.872 203.776a189.4 189.4 0 0 1 64.384-4.672l2.624.128c31.168 1.024 51.2 4.096 79.488 16.32 37.632 16.128 74.496 45.056 111.488 89.344 96.384 115.264 82.752 372.8-34.752 521.728-7.68 9.728-32 41.6-30.72 39.936a427 427 0 0 1-30.08 35.776c-31.232 32.576-65.28 49.216-110.08 50.048-31.36.64-53.568-5.312-84.288-18.752l-6.528-2.88c-20.992-9.216-30.592-11.904-47.296-11.904-18.112 0-28.608 2.88-51.136 12.672l-6.464 2.816c-28.416 12.224-48.32 18.048-76.16 19.2-74.112 2.752-116.928-38.08-180.672-132.16-96.64-142.08-132.608-349.312-55.04-486.4 46.272-81.92 129.92-133.632 220.672-135.04 32.832-.576 60.288 6.848 99.648 22.72 27.136 10.88 34.752 13.76 37.376 14.272 16.256-20.16 27.776-36.992 34.56-50.24 13.568-26.304 27.2-59.968 40.704-100.8a32 32 0 1 1 60.8 20.224c-12.608 37.888-25.408 70.4-38.528 97.664m-51.52 78.08c-14.528 17.792-31.808 37.376-51.904 58.816a32 32 0 1 1-46.72-43.776l12.288-13.248c-28.032-11.2-61.248-26.688-95.68-26.112-70.4 1.088-135.296 41.6-171.648 105.792C121.6 492.608 176 684.16 247.296 788.992c34.816 51.328 76.352 108.992 130.944 106.944 52.48-2.112 72.32-34.688 135.872-34.688s81.28 34.688 136.96 33.536c56.448-1.088 75.776-39.04 126.848-103.872 107.904-136.768 107.904-362.752 35.776-449.088-72.192-86.272-124.672-84.096-151.68-85.12-41.472-4.288-81.6 12.544-113.664 25.152"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e3fccb5d29105673 = $37aa0bf70ef60230$var$_sfc_main4;
var $37aa0bf70ef60230$var$_sfc_main5 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ArrowDownBold",
    __name: "arrow-down-bold",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2fbb36af09846aa0 = $37aa0bf70ef60230$var$_sfc_main5;
var $37aa0bf70ef60230$var$_sfc_main6 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ArrowDown",
    __name: "arrow-down",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M831.872 340.864 512 652.672 192.128 340.864a30.59 30.59 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.59 30.59 0 0 0-42.752 0z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1fa5a43af950a186 = $37aa0bf70ef60230$var$_sfc_main6;
var $37aa0bf70ef60230$var$_sfc_main7 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ArrowLeftBold",
    __name: "arrow-left-bold",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M685.248 104.704a64 64 0 0 1 0 90.496L368.448 512l316.8 316.8a64 64 0 0 1-90.496 90.496L232.704 557.248a64 64 0 0 1 0-90.496l362.048-362.048a64 64 0 0 1 90.496 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ea9a5c7ec18f8eaf = $37aa0bf70ef60230$var$_sfc_main7;
var $37aa0bf70ef60230$var$_sfc_main8 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ArrowLeft",
    __name: "arrow-left",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.59 30.59 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.59 30.59 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e4c291d45fea4cd0 = $37aa0bf70ef60230$var$_sfc_main8;
var $37aa0bf70ef60230$var$_sfc_main9 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ArrowRightBold",
    __name: "arrow-right-bold",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M338.752 104.704a64 64 0 0 0 0 90.496l316.8 316.8-316.8 316.8a64 64 0 0 0 90.496 90.496l362.048-362.048a64 64 0 0 0 0-90.496L429.248 104.704a64 64 0 0 0-90.496 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d6d021d74f4bac76 = $37aa0bf70ef60230$var$_sfc_main9;
var $37aa0bf70ef60230$var$_sfc_main10 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ArrowRight",
    __name: "arrow-right",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M340.864 149.312a30.59 30.59 0 0 0 0 42.752L652.736 512 340.864 831.872a30.59 30.59 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$acad20503ad73ac1 = $37aa0bf70ef60230$var$_sfc_main10;
var $37aa0bf70ef60230$var$_sfc_main11 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ArrowUpBold",
    __name: "arrow-up-bold",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M104.704 685.248a64 64 0 0 0 90.496 0l316.8-316.8 316.8 316.8a64 64 0 0 0 90.496-90.496L557.248 232.704a64 64 0 0 0-90.496 0L104.704 594.752a64 64 0 0 0 0 90.496"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$928b9ecbfcbe86f4 = $37aa0bf70ef60230$var$_sfc_main11;
var $37aa0bf70ef60230$var$_sfc_main12 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ArrowUp",
    __name: "arrow-up",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m488.832 344.32-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872 319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2624c5890f1bbcf7 = $37aa0bf70ef60230$var$_sfc_main12;
var $37aa0bf70ef60230$var$_sfc_main13 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Avatar",
    __name: "avatar",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M628.736 528.896A416 416 0 0 1 928 928H96a415.87 415.87 0 0 1 299.264-399.104L512 704zM720 304a208 208 0 1 1-416 0 208 208 0 0 1 416 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e2255cf6045e8d47 = $37aa0bf70ef60230$var$_sfc_main13;
var $37aa0bf70ef60230$var$_sfc_main14 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Back",
    __name: "back",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$25e48ac541203d4a = $37aa0bf70ef60230$var$_sfc_main14;
var $37aa0bf70ef60230$var$_sfc_main15 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Baseball",
    __name: "baseball",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M195.2 828.8a448 448 0 1 1 633.6-633.6 448 448 0 0 1-633.6 633.6m45.248-45.248a384 384 0 1 0 543.104-543.104 384 384 0 0 0-543.104 543.104"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M497.472 96.896c22.784 4.672 44.416 9.472 64.896 14.528a256.128 256.128 0 0 0 350.208 350.208c5.056 20.48 9.856 42.112 14.528 64.896A320.128 320.128 0 0 1 497.472 96.896M108.48 491.904a320.128 320.128 0 0 1 423.616 423.68c-23.04-3.648-44.992-7.424-65.728-11.52a256.128 256.128 0 0 0-346.496-346.432 1737 1737 0 0 1-11.392-65.728"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4b80782cff9f4cc3 = $37aa0bf70ef60230$var$_sfc_main15;
var $37aa0bf70ef60230$var$_sfc_main16 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Basketball",
    __name: "basketball",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M778.752 788.224a382.46 382.46 0 0 0 116.032-245.632 256.51 256.51 0 0 0-241.728-13.952 762.9 762.9 0 0 1 125.696 259.584m-55.04 44.224a699.65 699.65 0 0 0-125.056-269.632 256.13 256.13 0 0 0-56.064 331.968 382.7 382.7 0 0 0 181.12-62.336m-254.08 61.248A320.13 320.13 0 0 1 557.76 513.6a716 716 0 0 0-48.192-48.128 320.13 320.13 0 0 1-379.264 88.384 382.4 382.4 0 0 0 110.144 229.696 382.4 382.4 0 0 0 229.184 110.08zM129.28 481.088a256.13 256.13 0 0 0 331.072-56.448 699.65 699.65 0 0 0-268.8-124.352 382.66 382.66 0 0 0-62.272 180.8m106.56-235.84a762.9 762.9 0 0 1 258.688 125.056 256.51 256.51 0 0 0-13.44-241.088A382.46 382.46 0 0 0 235.84 245.248m318.08-114.944c40.576 89.536 37.76 193.92-8.448 281.344a780 780 0 0 1 66.176 66.112 320.83 320.83 0 0 1 282.112-8.128 382.4 382.4 0 0 0-110.144-229.12 382.4 382.4 0 0 0-229.632-110.208zM828.8 828.8a448 448 0 1 1-633.6-633.6 448 448 0 0 1 633.6 633.6"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6dddbaab7b8f4743 = $37aa0bf70ef60230$var$_sfc_main16;
var $37aa0bf70ef60230$var$_sfc_main17 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "BellFilled",
    __name: "bell-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M640 832a128 128 0 0 1-256 0zm192-64H134.4a38.4 38.4 0 0 1 0-76.8H192V448c0-154.88 110.08-284.16 256.32-313.6a64 64 0 1 1 127.36 0A320.13 320.13 0 0 1 832 448v243.2h57.6a38.4 38.4 0 0 1 0 76.8z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c514625610ab1ff1 = $37aa0bf70ef60230$var$_sfc_main17;
var $37aa0bf70ef60230$var$_sfc_main18 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Bell",
    __name: "bell",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a64 64 0 0 1 64 64v64H448v-64a64 64 0 0 1 64-64"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 768h512V448a256 256 0 1 0-512 0zm256-640a320 320 0 0 1 320 320v384H192V448a320 320 0 0 1 320-320"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M96 768h832q32 0 32 32t-32 32H96q-32 0-32-32t32-32m352 128h128a64 64 0 0 1-128 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$84dc348f90a995ec = $37aa0bf70ef60230$var$_sfc_main18;
var $37aa0bf70ef60230$var$_sfc_main19 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Bicycle",
    __name: "bicycle",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 832a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M288 672h320q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M768 832a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 192a32 32 0 0 1 0-64h160a32 32 0 0 1 31.04 24.256l96 384a32 32 0 0 1-62.08 15.488L615.04 192zM96 384a32 32 0 0 1 0-64h128a32 32 0 0 1 30.336 21.888l64 192a32 32 0 1 1-60.672 20.224L200.96 384z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m373.376 599.808-42.752-47.616 320-288 42.752 47.616z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6345cd76256e2015 = $37aa0bf70ef60230$var$_sfc_main19;
var $37aa0bf70ef60230$var$_sfc_main20 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "BottomLeft",
    __name: "bottom-left",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 768h416a32 32 0 1 1 0 64H224a32 32 0 0 1-32-32V352a32 32 0 0 1 64 0z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M246.656 822.656a32 32 0 0 1-45.312-45.312l544-544a32 32 0 0 1 45.312 45.312z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$dc509f97132dd4b2 = $37aa0bf70ef60230$var$_sfc_main20;
var $37aa0bf70ef60230$var$_sfc_main21 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "BottomRight",
    __name: "bottom-right",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M352 768a32 32 0 1 0 0 64h448a32 32 0 0 0 32-32V352a32 32 0 0 0-64 0v416z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M777.344 822.656a32 32 0 0 0 45.312-45.312l-544-544a32 32 0 0 0-45.312 45.312z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7b07ea303eba8491 = $37aa0bf70ef60230$var$_sfc_main21;
var $37aa0bf70ef60230$var$_sfc_main22 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Bottom",
    __name: "bottom",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 805.888V168a32 32 0 1 0-64 0v637.888L246.656 557.952a30.72 30.72 0 0 0-45.312 0 35.52 35.52 0 0 0 0 48.064l288 306.048a30.72 30.72 0 0 0 45.312 0l288-306.048a35.52 35.52 0 0 0 0-48 30.72 30.72 0 0 0-45.312 0L544 805.824z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$254d4c7b77d00ced = $37aa0bf70ef60230$var$_sfc_main22;
var $37aa0bf70ef60230$var$_sfc_main23 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Bowl",
    __name: "bowl",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M714.432 704a351.74 351.74 0 0 0 148.16-256H161.408a351.74 351.74 0 0 0 148.16 256zM288 766.592A415.68 415.68 0 0 1 96 416a32 32 0 0 1 32-32h768a32 32 0 0 1 32 32 415.68 415.68 0 0 1-192 350.592V832a64 64 0 0 1-64 64H352a64 64 0 0 1-64-64zM493.248 320h-90.496l254.4-254.4a32 32 0 1 1 45.248 45.248zm187.328 0h-128l269.696-155.712a32 32 0 0 1 32 55.424zM352 768v64h320v-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$422170d64fde2a30 = $37aa0bf70ef60230$var$_sfc_main23;
var $37aa0bf70ef60230$var$_sfc_main24 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Box",
    __name: "box",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M317.056 128 128 344.064V896h768V344.064L706.944 128zm-14.528-64h418.944a32 32 0 0 1 24.064 10.88l206.528 236.096A32 32 0 0 1 960 332.032V928a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V332.032a32 32 0 0 1 7.936-21.12L278.4 75.008A32 32 0 0 1 302.528 64"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M64 320h896v64H64z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M448 327.872V640h128V327.872L526.08 128h-28.16zM448 64h128l64 256v352a32 32 0 0 1-32 32H416a32 32 0 0 1-32-32V320z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e71c4d32a2263218 = $37aa0bf70ef60230$var$_sfc_main24;
var $37aa0bf70ef60230$var$_sfc_main25 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Briefcase",
    __name: "briefcase",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M320 320V128h384v192h192v192H128V320zM128 576h768v320H128zm256-256h256.064V192H384z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e7d61f8a47ad0cdc = $37aa0bf70ef60230$var$_sfc_main25;
var $37aa0bf70ef60230$var$_sfc_main26 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "BrushFilled",
    __name: "brush-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M608 704v160a96 96 0 0 1-192 0V704h-96a128 128 0 0 1-128-128h640a128 128 0 0 1-128 128zM192 512V128.064h640V512z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$bfebe877b3b31e97 = $37aa0bf70ef60230$var$_sfc_main26;
var $37aa0bf70ef60230$var$_sfc_main27 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Brush",
    __name: "brush",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M896 448H128v192a64 64 0 0 0 64 64h192v192h256V704h192a64 64 0 0 0 64-64zm-770.752-64c0-47.552 5.248-90.24 15.552-128 14.72-54.016 42.496-107.392 83.2-160h417.28l-15.36 70.336L736 96h211.2c-24.832 42.88-41.92 96.256-51.2 160a664 664 0 0 0-6.144 128H960v256a128 128 0 0 1-128 128H704v160a32 32 0 0 1-32 32H352a32 32 0 0 1-32-32V768H192A128 128 0 0 1 64 640V384zm64 0h636.544c-2.048-45.824.256-91.584 6.848-137.216 4.48-30.848 10.688-59.776 18.688-86.784h-96.64l-221.12 141.248L561.92 160H256.512c-25.856 37.888-43.776 75.456-53.952 112.832-8.768 32.064-13.248 69.12-13.312 111.168"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$59bc2e3533b384a0 = $37aa0bf70ef60230$var$_sfc_main27;
var $37aa0bf70ef60230$var$_sfc_main28 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Burger",
    __name: "burger",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 512a32 32 0 0 0-32 32v64a32 32 0 0 0 30.08 32H864a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32zm736-58.56A96 96 0 0 1 960 544v64a96 96 0 0 1-51.968 85.312L855.36 833.6a96 96 0 0 1-89.856 62.272H258.496A96 96 0 0 1 168.64 833.6l-52.608-140.224A96 96 0 0 1 64 608v-64a96 96 0 0 1 64-90.56V448a384 384 0 1 1 768 5.44M832 448a320 320 0 0 0-640 0zM512 704H188.352l40.192 107.136a32 32 0 0 0 29.952 20.736h507.008a32 32 0 0 0 29.952-20.736L835.648 704z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$3990fdb7137d85ae = $37aa0bf70ef60230$var$_sfc_main28;
var $37aa0bf70ef60230$var$_sfc_main29 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Calendar",
    __name: "calendar",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 384v512h768V192H768v32a32 32 0 1 1-64 0v-32H320v32a32 32 0 0 1-64 0v-32H128v128h768v64zm192-256h384V96a32 32 0 1 1 64 0v32h160a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h160V96a32 32 0 0 1 64 0zm-32 384h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m192-192h64a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m192-192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64m0 192h64a32 32 0 1 1 0 64h-64a32 32 0 1 1 0-64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e1aef45b828286de = $37aa0bf70ef60230$var$_sfc_main29;
var $37aa0bf70ef60230$var$_sfc_main30 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CameraFilled",
    __name: "camera-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 224a64 64 0 0 0-64 64v512a64 64 0 0 0 64 64h704a64 64 0 0 0 64-64V288a64 64 0 0 0-64-64H748.416l-46.464-92.672A64 64 0 0 0 644.736 96H379.328a64 64 0 0 0-57.216 35.392L275.776 224zm352 435.2a115.2 115.2 0 1 0 0-230.4 115.2 115.2 0 0 0 0 230.4m0 140.8a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c2507c153af8e6f0 = $37aa0bf70ef60230$var$_sfc_main30;
var $37aa0bf70ef60230$var$_sfc_main31 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Camera",
    __name: "camera",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M896 256H128v576h768zm-199.424-64-32.064-64h-304.96l-32 64zM96 192h160l46.336-92.608A64 64 0 0 1 359.552 64h304.96a64 64 0 0 1 57.216 35.328L768.192 192H928a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32m416 512a160 160 0 1 0 0-320 160 160 0 0 0 0 320m0 64a224 224 0 1 1 0-448 224 224 0 0 1 0 448"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$79f141de891a5fed = $37aa0bf70ef60230$var$_sfc_main31;
var $37aa0bf70ef60230$var$_sfc_main32 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CaretBottom",
    __name: "caret-bottom",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m192 384 320 384 320-384z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$3a92bef021d782db = $37aa0bf70ef60230$var$_sfc_main32;
var $37aa0bf70ef60230$var$_sfc_main33 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CaretLeft",
    __name: "caret-left",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M672 192 288 511.936 672 832z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$9de62fa342934f27 = $37aa0bf70ef60230$var$_sfc_main33;
var $37aa0bf70ef60230$var$_sfc_main34 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CaretRight",
    __name: "caret-right",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 192v640l384-320.064z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$98ac0f496a0846de = $37aa0bf70ef60230$var$_sfc_main34;
var $37aa0bf70ef60230$var$_sfc_main35 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CaretTop",
    __name: "caret-top",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 320 192 704h639.936z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ee4a489416b22c29 = $37aa0bf70ef60230$var$_sfc_main35;
var $37aa0bf70ef60230$var$_sfc_main36 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Cellphone",
    __name: "cellphone",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 128a64 64 0 0 0-64 64v640a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm0-64h512a128 128 0 0 1 128 128v640a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V192A128 128 0 0 1 256 64m128 128h256a32 32 0 1 1 0 64H384a32 32 0 0 1 0-64m128 640a64 64 0 1 1 0-128 64 64 0 0 1 0 128"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e4b1186e21bebc66 = $37aa0bf70ef60230$var$_sfc_main36;
var $37aa0bf70ef60230$var$_sfc_main37 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ChatDotRound",
    __name: "chat-dot-round",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m174.72 855.68 135.296-45.12 23.68 11.84C388.096 849.536 448.576 864 512 864c211.84 0 384-166.784 384-352S723.84 160 512 160 128 326.784 128 512c0 69.12 24.96 139.264 70.848 199.232l22.08 28.8-46.272 115.584zm-45.248 82.56A32 32 0 0 1 89.6 896l58.368-145.92C94.72 680.32 64 596.864 64 512 64 299.904 256 96 512 96s448 203.904 448 416-192 416-448 416a461.06 461.06 0 0 1-206.912-48.384l-175.616 58.56z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 563.2a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m192 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m-384 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$766e4b9d221bd0cd = $37aa0bf70ef60230$var$_sfc_main37;
var $37aa0bf70ef60230$var$_sfc_main38 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ChatDotSquare",
    __name: "chat-dot-square",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64v570.88zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 499.2a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m192 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4m-384 0a51.2 51.2 0 1 1 0-102.4 51.2 51.2 0 0 1 0 102.4"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4373f0c7c7ee0076 = $37aa0bf70ef60230$var$_sfc_main38;
var $37aa0bf70ef60230$var$_sfc_main39 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ChatLineRound",
    __name: "chat-line-round",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m174.72 855.68 135.296-45.12 23.68 11.84C388.096 849.536 448.576 864 512 864c211.84 0 384-166.784 384-352S723.84 160 512 160 128 326.784 128 512c0 69.12 24.96 139.264 70.848 199.232l22.08 28.8-46.272 115.584zm-45.248 82.56A32 32 0 0 1 89.6 896l58.368-145.92C94.72 680.32 64 596.864 64 512 64 299.904 256 96 512 96s448 203.904 448 416-192 416-448 416a461.06 461.06 0 0 1-206.912-48.384l-175.616 58.56z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M352 576h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m32-192h256q32 0 32 32t-32 32H384q-32 0-32-32t32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$afe780e84d36175b = $37aa0bf70ef60230$var$_sfc_main39;
var $37aa0bf70ef60230$var$_sfc_main40 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ChatLineSquare",
    __name: "chat-line-square",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 826.88 273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M352 512h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m0-192h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e34997c6974ad44e = $37aa0bf70ef60230$var$_sfc_main40;
var $37aa0bf70ef60230$var$_sfc_main41 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ChatRound",
    __name: "chat-round",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m174.72 855.68 130.048-43.392 23.424 11.392C382.4 849.984 444.352 864 512 864c223.744 0 384-159.872 384-352 0-192.832-159.104-352-384-352S128 319.168 128 512a341.12 341.12 0 0 0 69.248 204.288l21.632 28.8-44.16 110.528zm-45.248 82.56A32 32 0 0 1 89.6 896l56.512-141.248A405.12 405.12 0 0 1 64 512C64 299.904 235.648 96 512 96s448 203.904 448 416-173.44 416-448 416c-79.68 0-150.848-17.152-211.712-46.72l-170.88 56.96z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a9b52e2af04693b0 = $37aa0bf70ef60230$var$_sfc_main41;
var $37aa0bf70ef60230$var$_sfc_main42 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ChatSquare",
    __name: "chat-square",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64v570.88zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$689e7c193d06e0b0 = $37aa0bf70ef60230$var$_sfc_main42;
var $37aa0bf70ef60230$var$_sfc_main43 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Check",
    __name: "check",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M406.656 706.944 195.84 496.256a32 32 0 1 0-45.248 45.248l256 256 512-512a32 32 0 0 0-45.248-45.248L406.592 706.944z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$60bffc6e2a50e7f9 = $37aa0bf70ef60230$var$_sfc_main43;
var $37aa0bf70ef60230$var$_sfc_main44 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Checked",
    __name: "checked",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 192h160v736H160V192h160.064v64H704zM311.616 537.28l-45.312 45.248L447.36 763.52l316.8-316.8-45.312-45.184L447.36 673.024zM384 192V96h256v96z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8c8ee9238b7b0c2a = $37aa0bf70ef60230$var$_sfc_main44;
var $37aa0bf70ef60230$var$_sfc_main45 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Cherry",
    __name: "cherry",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M261.056 449.6c13.824-69.696 34.88-128.96 63.36-177.728 23.744-40.832 61.12-88.64 112.256-143.872H320a32 32 0 0 1 0-64h384a32 32 0 1 1 0 64H554.752c14.912 39.168 41.344 86.592 79.552 141.76 47.36 68.48 84.8 106.752 106.304 114.304a224 224 0 1 1-84.992 14.784c-22.656-22.912-47.04-53.76-73.92-92.608-38.848-56.128-67.008-105.792-84.352-149.312-55.296 58.24-94.528 107.52-117.76 147.2-23.168 39.744-41.088 88.768-53.568 147.072a224.064 224.064 0 1 1-64.96-1.6M288 832a160 160 0 1 0 0-320 160 160 0 0 0 0 320m448-64a160 160 0 1 0 0-320 160 160 0 0 0 0 320"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e0c62b5cdc73b9f = $37aa0bf70ef60230$var$_sfc_main45;
var $37aa0bf70ef60230$var$_sfc_main46 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Chicken",
    __name: "chicken",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M349.952 716.992 478.72 588.16a106.7 106.7 0 0 1-26.176-19.072 106.7 106.7 0 0 1-19.072-26.176L304.704 671.744c.768 3.072 1.472 6.144 2.048 9.216l2.048 31.936 31.872 1.984c3.136.64 6.208 1.28 9.28 2.112m57.344 33.152a128 128 0 1 1-216.32 114.432l-1.92-32-32-1.92a128 128 0 1 1 114.432-216.32L416.64 469.248c-2.432-101.44 58.112-239.104 149.056-330.048 107.328-107.328 231.296-85.504 316.8 0 85.44 85.44 107.328 209.408 0 316.8-91.008 90.88-228.672 151.424-330.112 149.056L407.296 750.08zm90.496-226.304c49.536 49.536 233.344-7.04 339.392-113.088 78.208-78.208 63.232-163.072 0-226.304-63.168-63.232-148.032-78.208-226.24 0C504.896 290.496 448.32 474.368 497.792 523.84M244.864 708.928a64 64 0 1 0-59.84 59.84l56.32-3.52zm8.064 127.68a64 64 0 1 0 59.84-59.84l-56.32 3.52z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$902c63284deb2691 = $37aa0bf70ef60230$var$_sfc_main46;
var $37aa0bf70ef60230$var$_sfc_main47 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ChromeFilled",
    __name: "chrome-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M938.67 512.01c0-44.59-6.82-87.6-19.54-128H682.67a212.37 212.37 0 0 1 42.67 128c.06 38.71-10.45 76.7-30.42 109.87l-182.91 316.8c235.65-.01 426.66-191.02 426.66-426.67"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M576.79 401.63a127.9 127.9 0 0 0-63.56-17.6c-22.36-.22-44.39 5.43-63.89 16.38s-35.79 26.82-47.25 46.02a128 128 0 0 0-2.16 127.44l1.24 2.13a127.9 127.9 0 0 0 46.36 46.61 127.9 127.9 0 0 0 63.38 17.44c22.29.2 44.24-5.43 63.68-16.33a127.94 127.94 0 0 0 47.16-45.79v-.01l1.11-1.92a127.98 127.98 0 0 0 .29-127.46 127.96 127.96 0 0 0-46.36-46.91"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M394.45 333.96A213.34 213.34 0 0 1 512 298.67h369.58A426.5 426.5 0 0 0 512 85.34a425.6 425.6 0 0 0-171.74 35.98 425.6 425.6 0 0 0-142.62 102.22l118.14 204.63a213.4 213.4 0 0 1 78.67-94.21m117.56 604.72H512zm-97.25-236.73a213.3 213.3 0 0 1-89.54-86.81L142.48 298.6c-36.35 62.81-57.13 135.68-57.13 213.42 0 203.81 142.93 374.22 333.95 416.55h.04l118.19-204.71a213.3 213.3 0 0 1-122.77-21.91"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c66129126a13710e = $37aa0bf70ef60230$var$_sfc_main47;
var $37aa0bf70ef60230$var$_sfc_main48 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CircleCheckFilled",
    __name: "circle-check-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.27 38.27 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8d9ef6d183a38e6f = $37aa0bf70ef60230$var$_sfc_main48;
var $37aa0bf70ef60230$var$_sfc_main49 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CircleCheck",
    __name: "circle-check",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M745.344 361.344a32 32 0 0 1 45.312 45.312l-288 288a32 32 0 0 1-45.312 0l-160-160a32 32 0 1 1 45.312-45.312L480 626.752z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e98f1a5f8b66cf2 = $37aa0bf70ef60230$var$_sfc_main49;
var $37aa0bf70ef60230$var$_sfc_main50 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CircleCloseFilled",
    __name: "circle-close-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$eb5e919574e4808f = $37aa0bf70ef60230$var$_sfc_main50;
var $37aa0bf70ef60230$var$_sfc_main51 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CircleClose",
    __name: "circle-close",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$abaca3c8ef8f75e4 = $37aa0bf70ef60230$var$_sfc_main51;
var $37aa0bf70ef60230$var$_sfc_main52 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CirclePlusFilled",
    __name: "circle-plus-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-38.4 409.6H326.4a38.4 38.4 0 1 0 0 76.8h147.2v147.2a38.4 38.4 0 0 0 76.8 0V550.4h147.2a38.4 38.4 0 0 0 0-76.8H550.4V326.4a38.4 38.4 0 1 0-76.8 0z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$5b29149862cef40d = $37aa0bf70ef60230$var$_sfc_main52;
var $37aa0bf70ef60230$var$_sfc_main53 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CirclePlus",
    __name: "circle-plus",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M352 480h320a32 32 0 1 1 0 64H352a32 32 0 0 1 0-64"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 672V352a32 32 0 1 1 64 0v320a32 32 0 0 1-64 0"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$61983de76e45a87b = $37aa0bf70ef60230$var$_sfc_main53;
var $37aa0bf70ef60230$var$_sfc_main54 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Clock",
    __name: "clock",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 256a32 32 0 0 1 32 32v256a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 512h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$9735c82c4bae3302 = $37aa0bf70ef60230$var$_sfc_main54;
var $37aa0bf70ef60230$var$_sfc_main55 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CloseBold",
    __name: "close-bold",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a0319d8dde5c7de5 = $37aa0bf70ef60230$var$_sfc_main55;
var $37aa0bf70ef60230$var$_sfc_main56 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Close",
    __name: "close",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$f39c2d165cd861fe = $37aa0bf70ef60230$var$_sfc_main56;
var $37aa0bf70ef60230$var$_sfc_main57 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Cloudy",
    __name: "cloudy",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M598.4 831.872H328.192a256 256 0 0 1-34.496-510.528A352 352 0 1 1 598.4 831.872m-271.36-64h272.256a288 288 0 1 0-248.512-417.664L335.04 381.44l-34.816 3.584a192 192 0 0 0 26.88 382.848z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1642f9917782fae3 = $37aa0bf70ef60230$var$_sfc_main57;
var $37aa0bf70ef60230$var$_sfc_main58 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CoffeeCup",
    __name: "coffee-cup",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M768 192a192 192 0 1 1-8 383.808A256.13 256.13 0 0 1 512 768H320A256 256 0 0 1 64 512V160a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 64v256a128 128 0 1 0 0-256M96 832h640a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64m32-640v320a192 192 0 0 0 192 192h192a192 192 0 0 0 192-192V192z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$61d3208fd994d96c = $37aa0bf70ef60230$var$_sfc_main58;
var $37aa0bf70ef60230$var$_sfc_main59 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Coffee",
    __name: "coffee",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M822.592 192h14.272a32 32 0 0 1 31.616 26.752l21.312 128A32 32 0 0 1 858.24 384h-49.344l-39.04 546.304A32 32 0 0 1 737.92 960H285.824a32 32 0 0 1-32-29.696L214.912 384H165.76a32 32 0 0 1-31.552-37.248l21.312-128A32 32 0 0 1 187.136 192h14.016l-6.72-93.696A32 32 0 0 1 226.368 64h571.008a32 32 0 0 1 31.936 34.304zm-64.128 0 4.544-64H260.736l4.544 64zm-548.16 128H820.48l-10.688-64H214.208l-10.688 64zm68.736 64 36.544 512H708.16l36.544-512z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d350a92ac3718aff = $37aa0bf70ef60230$var$_sfc_main59;
var $37aa0bf70ef60230$var$_sfc_main60 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Coin",
    __name: "coin",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m161.92 580.736 29.888 58.88C171.328 659.776 160 681.728 160 704c0 82.304 155.328 160 352 160s352-77.696 352-160c0-22.272-11.392-44.16-31.808-64.32l30.464-58.432C903.936 615.808 928 657.664 928 704c0 129.728-188.544 224-416 224S96 833.728 96 704c0-46.592 24.32-88.576 65.92-123.264"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m161.92 388.736 29.888 58.88C171.328 467.84 160 489.792 160 512c0 82.304 155.328 160 352 160s352-77.696 352-160c0-22.272-11.392-44.16-31.808-64.32l30.464-58.432C903.936 423.808 928 465.664 928 512c0 129.728-188.544 224-416 224S96 641.728 96 512c0-46.592 24.32-88.576 65.92-123.264"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 544c-227.456 0-416-94.272-416-224S284.544 96 512 96s416 94.272 416 224-188.544 224-416 224m0-64c196.672 0 352-77.696 352-160S708.672 160 512 160s-352 77.696-352 160 155.328 160 352 160"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$19600bc7e7f23c95 = $37aa0bf70ef60230$var$_sfc_main60;
var $37aa0bf70ef60230$var$_sfc_main61 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ColdDrink",
    __name: "cold-drink",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M768 64a192 192 0 1 1-69.952 370.88L480 725.376V896h96a32 32 0 1 1 0 64H320a32 32 0 1 1 0-64h96V725.376L76.8 273.536a64 64 0 0 1-12.8-38.4v-10.688a32 32 0 0 1 32-32h71.808l-65.536-83.84a32 32 0 0 1 50.432-39.424l96.256 123.264h337.728A192.06 192.06 0 0 1 768 64M656.896 192.448H800a32 32 0 0 1 32 32v10.624a64 64 0 0 1-12.8 38.4l-80.448 107.2a128 128 0 1 0-81.92-188.16v-.064zm-357.888 64 129.472 165.76a32 32 0 0 1-50.432 39.36l-160.256-205.12H144l304 404.928 304-404.928z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$3cb219c423e77ed0 = $37aa0bf70ef60230$var$_sfc_main61;
var $37aa0bf70ef60230$var$_sfc_main62 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CollectionTag",
    __name: "collection-tag",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 128v698.88l196.032-156.864a96 96 0 0 1 119.936 0L768 826.816V128zm-32-64h576a32 32 0 0 1 32 32v797.44a32 32 0 0 1-51.968 24.96L531.968 720a32 32 0 0 0-39.936 0L243.968 918.4A32 32 0 0 1 192 893.44V96a32 32 0 0 1 32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$aab8049ea533c19 = $37aa0bf70ef60230$var$_sfc_main62;
var $37aa0bf70ef60230$var$_sfc_main63 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Collection",
    __name: "collection",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 736h640V128H256a64 64 0 0 0-64 64zm64-672h608a32 32 0 0 1 32 32v672a32 32 0 0 1-32 32H160l-32 57.536V192A128 128 0 0 1 256 64"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M240 800a48 48 0 1 0 0 96h592v-96zm0-64h656v160a64 64 0 0 1-64 64H240a112 112 0 0 1 0-224m144-608v250.88l96-76.8 96 76.8V128zm-64-64h320v381.44a32 32 0 0 1-51.968 24.96L480 384l-108.032 86.4A32 32 0 0 1 320 445.44z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$fb8073518f34e6ec = $37aa0bf70ef60230$var$_sfc_main63;
var $37aa0bf70ef60230$var$_sfc_main64 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Comment",
    __name: "comment",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M736 504a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112m-224 0a56 56 0 1 1 0-112 56 56 0 0 1 0 112M128 128v640h192v160l224-160h352V128z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4d299b491347818a = $37aa0bf70ef60230$var$_sfc_main64;
var $37aa0bf70ef60230$var$_sfc_main65 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Compass",
    __name: "compass",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M725.888 315.008C676.48 428.672 624 513.28 568.576 568.64c-55.424 55.424-139.968 107.904-253.568 157.312a12.8 12.8 0 0 1-16.896-16.832c49.536-113.728 102.016-198.272 157.312-253.632 55.36-55.296 139.904-107.776 253.632-157.312a12.8 12.8 0 0 1 16.832 16.832"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$87ae43576cc53e22 = $37aa0bf70ef60230$var$_sfc_main65;
var $37aa0bf70ef60230$var$_sfc_main66 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Connection",
    __name: "connection",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M640 384v64H448a128 128 0 0 0-128 128v128a128 128 0 0 0 128 128h320a128 128 0 0 0 128-128V576a128 128 0 0 0-64-110.848V394.88c74.56 26.368 128 97.472 128 181.056v128a192 192 0 0 1-192 192H448a192 192 0 0 1-192-192V576a192 192 0 0 1 192-192z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 640v-64h192a128 128 0 0 0 128-128V320a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v128a128 128 0 0 0 64 110.848v70.272A192.06 192.06 0 0 1 64 448V320a192 192 0 0 1 192-192h320a192 192 0 0 1 192 192v128a192 192 0 0 1-192 192z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$98b66c25bb38499d = $37aa0bf70ef60230$var$_sfc_main66;
var $37aa0bf70ef60230$var$_sfc_main67 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Coordinate",
    __name: "coordinate",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 512h64v320h-64z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 896h640a64 64 0 0 0-64-64H256a64 64 0 0 0-64 64m64-128h512a128 128 0 0 1 128 128v64H128v-64a128 128 0 0 1 128-128m256-256a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7faa80054108057 = $37aa0bf70ef60230$var$_sfc_main67;
var $37aa0bf70ef60230$var$_sfc_main68 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CopyDocument",
    __name: "copy-document",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M768 832a128 128 0 0 1-128 128H192A128 128 0 0 1 64 832V384a128 128 0 0 1 128-128v64a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 128a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V192a64 64 0 0 0-64-64zm0-64h448a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H384a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c8231c61904977e8 = $37aa0bf70ef60230$var$_sfc_main68;
var $37aa0bf70ef60230$var$_sfc_main69 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Cpu",
    __name: "cpu",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M320 256a64 64 0 0 0-64 64v384a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V320a64 64 0 0 0-64-64zm0-64h384a128 128 0 0 1 128 128v384a128 128 0 0 1-128 128H320a128 128 0 0 1-128-128V320a128 128 0 0 1 128-128"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m160 0a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m-320 0a32 32 0 0 1 32 32v128h-64V96a32 32 0 0 1 32-32m160 896a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32m160 0a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32m-320 0a32 32 0 0 1-32-32V800h64v128a32 32 0 0 1-32 32M64 512a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m0-160a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m0 320a32 32 0 0 1 32-32h128v64H96a32 32 0 0 1-32-32m896-160a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32m0-160a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32m0 320a32 32 0 0 1-32 32H800v-64h128a32 32 0 0 1 32 32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1df9025937e8ffa7 = $37aa0bf70ef60230$var$_sfc_main69;
var $37aa0bf70ef60230$var$_sfc_main70 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "CreditCard",
    __name: "credit-card",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M896 324.096c0-42.368-2.496-55.296-9.536-68.48a52.35 52.35 0 0 0-22.144-22.08c-13.12-7.04-26.048-9.536-68.416-9.536H228.096c-42.368 0-55.296 2.496-68.48 9.536a52.35 52.35 0 0 0-22.08 22.144c-7.04 13.12-9.536 26.048-9.536 68.416v375.808c0 42.368 2.496 55.296 9.536 68.48a52.35 52.35 0 0 0 22.144 22.08c13.12 7.04 26.048 9.536 68.416 9.536h567.808c42.368 0 55.296-2.496 68.48-9.536a52.35 52.35 0 0 0 22.08-22.144c7.04-13.12 9.536-26.048 9.536-68.416zm64 0v375.808c0 57.088-5.952 77.76-17.088 98.56-11.136 20.928-27.52 37.312-48.384 48.448S852.928 864 795.968 864H228.032c-57.088 0-77.76-5.952-98.56-17.088a116.3 116.3 0 0 1-48.448-48.384c-11.136-20.864-17.088-41.6-17.088-98.56V324.032c0-57.088 5.952-77.76 17.088-98.56 11.136-20.928 27.52-37.312 48.384-48.448s41.6-17.088 98.56-17.088H795.84c57.088 0 77.76 5.952 98.56 17.088 20.928 11.136 37.312 27.52 48.448 48.384s17.088 41.6 17.088 98.56z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M64 320h896v64H64zm0 128h896v64H64zm128 192h256v64H192z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$769b6865db9774d4 = $37aa0bf70ef60230$var$_sfc_main70;
var $37aa0bf70ef60230$var$_sfc_main71 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Crop",
    __name: "crop",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 768h672a32 32 0 1 1 0 64H224a32 32 0 0 1-32-32V96a32 32 0 0 1 64 0z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M832 224v704a32 32 0 1 1-64 0V256H96a32 32 0 0 1 0-64h704a32 32 0 0 1 32 32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8e58b6dc125f7f1b = $37aa0bf70ef60230$var$_sfc_main71;
var $37aa0bf70ef60230$var$_sfc_main72 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DArrowLeft",
    __name: "d-arrow-left",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M529.408 149.376a29.12 29.12 0 0 1 41.728 0 30.59 30.59 0 0 1 0 42.688L259.264 511.936l311.872 319.936a30.59 30.59 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L197.76 534.272a32 32 0 0 1 0-44.672zm256 0a29.12 29.12 0 0 1 41.728 0 30.59 30.59 0 0 1 0 42.688L515.264 511.936l311.872 319.936a30.59 30.59 0 0 1-.512 43.264 29.12 29.12 0 0 1-41.216-.512L453.76 534.272a32 32 0 0 1 0-44.672z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$bc181e1009fb1f20 = $37aa0bf70ef60230$var$_sfc_main72;
var $37aa0bf70ef60230$var$_sfc_main73 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DArrowRight",
    __name: "d-arrow-right",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M452.864 149.312a29.12 29.12 0 0 1 41.728.064L826.24 489.664a32 32 0 0 1 0 44.672L494.592 874.624a29.12 29.12 0 0 1-41.728 0 30.59 30.59 0 0 1 0-42.752L764.736 512 452.864 192a30.59 30.59 0 0 1 0-42.688m-256 0a29.12 29.12 0 0 1 41.728.064L570.24 489.664a32 32 0 0 1 0 44.672L238.592 874.624a29.12 29.12 0 0 1-41.728 0 30.59 30.59 0 0 1 0-42.752L508.736 512 196.864 192a30.59 30.59 0 0 1 0-42.688"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$f6d4240c6dee439b = $37aa0bf70ef60230$var$_sfc_main73;
var $37aa0bf70ef60230$var$_sfc_main74 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DCaret",
    __name: "d-caret",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m512 128 288 320H224zM224 576h576L512 896z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$b0d73bc0a71f4efd = $37aa0bf70ef60230$var$_sfc_main74;
var $37aa0bf70ef60230$var$_sfc_main75 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DataAnalysis",
    __name: "data-analysis",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m665.216 768 110.848 192h-73.856L591.36 768H433.024L322.176 960H248.32l110.848-192H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32zM832 192H192v512h640zM352 448a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0v-64a32 32 0 0 1 32-32m160-64a32 32 0 0 1 32 32v128a32 32 0 0 1-64 0V416a32 32 0 0 1 32-32m160-64a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V352a32 32 0 0 1 32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$63b083d9da4579d = $37aa0bf70ef60230$var$_sfc_main75;
var $37aa0bf70ef60230$var$_sfc_main76 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DataBoard",
    __name: "data-board",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M32 128h960v64H32z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 192v512h640V192zm-64-64h768v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M322.176 960H248.32l144.64-250.56 55.424 32zm453.888 0h-73.856L576 741.44l55.424-32z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8f03e8a8ef20bb12 = $37aa0bf70ef60230$var$_sfc_main76;
var $37aa0bf70ef60230$var$_sfc_main77 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DataLine",
    __name: "data-line",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M359.168 768H160a32 32 0 0 1-32-32V192H64a32 32 0 0 1 0-64h896a32 32 0 1 1 0 64h-64v544a32 32 0 0 1-32 32H665.216l110.848 192h-73.856L591.36 768H433.024L322.176 960H248.32zM832 192H192v512h640zM342.656 534.656a32 32 0 1 1-45.312-45.312L444.992 341.76l125.44 94.08L679.04 300.032a32 32 0 1 1 49.92 39.936L581.632 524.224 451.008 426.24 342.656 534.592z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1856efadb92fecd6 = $37aa0bf70ef60230$var$_sfc_main77;
var $37aa0bf70ef60230$var$_sfc_main78 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DeleteFilled",
    __name: "delete-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M352 192V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64H96a32 32 0 0 1 0-64zm64 0h192v-64H416zM192 960a32 32 0 0 1-32-32V256h704v672a32 32 0 0 1-32 32zm224-192a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32m192 0a32 32 0 0 0 32-32V416a32 32 0 0 0-64 0v320a32 32 0 0 0 32 32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ef5ba407dcc31020 = $37aa0bf70ef60230$var$_sfc_main78;
var $37aa0bf70ef60230$var$_sfc_main79 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DeleteLocation",
    __name: "delete-location",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 384h256q32 0 32 32t-32 32H384q-32 0-32-32t32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d99811ad28f6b3ed = $37aa0bf70ef60230$var$_sfc_main79;
var $37aa0bf70ef60230$var$_sfc_main80 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Delete",
    __name: "delete",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 256H96a32 32 0 0 1 0-64h256V95.936a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V192h256a32 32 0 1 1 0 64h-64v672a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32zm448-64v-64H416v64zM224 896h576V256H224zm192-128a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32m192 0a32 32 0 0 1-32-32V416a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$bfadae053a633538 = $37aa0bf70ef60230$var$_sfc_main80;
var $37aa0bf70ef60230$var$_sfc_main81 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Dessert",
    __name: "dessert",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 416v-48a144 144 0 0 1 168.64-141.888 224.128 224.128 0 0 1 430.72 0A144 144 0 0 1 896 368v48a384 384 0 0 1-352 382.72V896h-64v-97.28A384 384 0 0 1 128 416m287.104-32.064h193.792a143.81 143.81 0 0 1 58.88-132.736 160.064 160.064 0 0 0-311.552 0 143.81 143.81 0 0 1 58.88 132.8zm-72.896 0a72 72 0 1 0-140.48 0zm339.584 0h140.416a72 72 0 1 0-140.48 0zM512 736a320 320 0 0 0 318.4-288.064H193.6A320 320 0 0 0 512 736M384 896.064h256a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ff1577357a617830 = $37aa0bf70ef60230$var$_sfc_main81;
var $37aa0bf70ef60230$var$_sfc_main82 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Discount",
    __name: "discount",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M224 704h576V318.336L552.512 115.84a64 64 0 0 0-81.024 0L224 318.336zm0 64v128h576V768zM593.024 66.304l259.2 212.096A32 32 0 0 1 864 303.168V928a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V303.168a32 32 0 0 1 11.712-24.768l259.2-212.096a128 128 0 0 1 162.112 0"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$5f0fddd75cd8dcd7 = $37aa0bf70ef60230$var$_sfc_main82;
var $37aa0bf70ef60230$var$_sfc_main83 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DishDot",
    __name: "dish-dot",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m384.064 274.56.064-50.688A128 128 0 0 1 512.128 96c70.528 0 127.68 57.152 127.68 127.68v50.752A448.19 448.19 0 0 1 955.392 768H68.544A448.19 448.19 0 0 1 384 274.56zM96 832h832a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64m32-128h768a384 384 0 1 0-768 0m447.808-448v-32.32a63.68 63.68 0 0 0-63.68-63.68 64 64 0 0 0-64 63.936V256z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$65dc54a0eb8df4e = $37aa0bf70ef60230$var$_sfc_main83;
var $37aa0bf70ef60230$var$_sfc_main84 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Dish",
    __name: "dish",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 257.152V192h-96a32 32 0 0 1 0-64h256a32 32 0 1 1 0 64h-96v65.152A448 448 0 0 1 955.52 768H68.48A448 448 0 0 1 480 257.152M128 704h768a384 384 0 1 0-768 0M96 832h832a32 32 0 1 1 0 64H96a32 32 0 1 1 0-64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4a56531d79e9bee6 = $37aa0bf70ef60230$var$_sfc_main84;
var $37aa0bf70ef60230$var$_sfc_main85 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DocumentAdd",
    __name: "document-add",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M832 384H576V128H192v768h640zm-26.496-64L640 154.496V320zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m320 512V448h64v128h128v64H544v128h-64V640H352v-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a6784a536d3eaef4 = $37aa0bf70ef60230$var$_sfc_main85;
var $37aa0bf70ef60230$var$_sfc_main86 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DocumentChecked",
    __name: "document-checked",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M805.504 320 640 154.496V320zM832 384H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m318.4 582.144 180.992-180.992L704.64 510.4 478.4 736.64 320 578.304l45.248-45.312z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$479d1f1599370326 = $37aa0bf70ef60230$var$_sfc_main86;
var $37aa0bf70ef60230$var$_sfc_main87 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DocumentCopy",
    __name: "document-copy",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 320v576h576V320zm-32-64h640a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32M960 96v704a32 32 0 0 1-32 32h-96v-64h64V128H384v64h-64V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32M256 672h320v64H256zm0-192h320v64H256z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$723e76cecf9e3942 = $37aa0bf70ef60230$var$_sfc_main87;
var $37aa0bf70ef60230$var$_sfc_main88 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DocumentDelete",
    __name: "document-delete",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M805.504 320 640 154.496V320zM832 384H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m308.992 546.304-90.496-90.624 45.248-45.248 90.56 90.496 90.496-90.432 45.248 45.248-90.496 90.56 90.496 90.496-45.248 45.248-90.496-90.496-90.56 90.496-45.248-45.248z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1dfe5cdddc8af56d = $37aa0bf70ef60230$var$_sfc_main88;
var $37aa0bf70ef60230$var$_sfc_main89 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "DocumentRemove",
    __name: "document-remove",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M805.504 320 640 154.496V320zM832 384H576V128H192v768h640zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m192 512h320v64H352z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$206a9f328a38d7ae = $37aa0bf70ef60230$var$_sfc_main89;
var $37aa0bf70ef60230$var$_sfc_main90 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Document",
    __name: "document",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M832 384H576V128H192v768h640zm-26.496-64L640 154.496V320zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m160 448h384v64H320zm0-192h160v64H320zm0 384h384v64H320z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$b34a105447964f9f = $37aa0bf70ef60230$var$_sfc_main90;
var $37aa0bf70ef60230$var$_sfc_main91 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Download",
    __name: "download",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m384-253.696 236.288-236.352 45.248 45.248L508.8 704 192 387.2l45.248-45.248L480 584.704V128h64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a7aaed3e118dd255 = $37aa0bf70ef60230$var$_sfc_main91;
var $37aa0bf70ef60230$var$_sfc_main92 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Drizzling",
    __name: "drizzling",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m739.328 291.328-35.2-6.592-12.8-33.408a192.064 192.064 0 0 0-365.952 23.232l-9.92 40.896-41.472 7.04a176.32 176.32 0 0 0-146.24 173.568c0 97.28 78.72 175.936 175.808 175.936h400a192 192 0 0 0 35.776-380.672M959.552 480a256 256 0 0 1-256 256h-400A239.81 239.81 0 0 1 63.744 496.192a240.32 240.32 0 0 1 199.488-236.8 256.128 256.128 0 0 1 487.872-30.976A256.064 256.064 0 0 1 959.552 480M288 800h64v64h-64zm192 0h64v64h-64zm-96 96h64v64h-64zm192 0h64v64h-64zm96-96h64v64h-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$3d388186242aeaf = $37aa0bf70ef60230$var$_sfc_main92;
var $37aa0bf70ef60230$var$_sfc_main93 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "EditPen",
    __name: "edit-pen",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696zM455.04 229.248l193.92 112 56.704-98.112-193.984-112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336zm384 254.272v-64h448v64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$5a017da3e5366b1e = $37aa0bf70ef60230$var$_sfc_main93;
var $37aa0bf70ef60230$var$_sfc_main94 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Edit",
    __name: "edit",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M832 512a32 32 0 1 1 64 0v352a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h352a32 32 0 0 1 0 64H192v640h640z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m469.952 554.24 52.8-7.552L847.104 222.4a32 32 0 1 0-45.248-45.248L477.44 501.44l-7.552 52.8zm422.4-422.4a96 96 0 0 1 0 135.808l-331.84 331.84a32 32 0 0 1-18.112 9.088L436.8 623.68a32 32 0 0 1-36.224-36.224l15.104-105.6a32 32 0 0 1 9.024-18.112l331.904-331.84a96 96 0 0 1 135.744 0z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6ed0965c9443aaa6 = $37aa0bf70ef60230$var$_sfc_main94;
var $37aa0bf70ef60230$var$_sfc_main95 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ElemeFilled",
    __name: "eleme-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M176 64h672c61.824 0 112 50.176 112 112v672a112 112 0 0 1-112 112H176A112 112 0 0 1 64 848V176c0-61.824 50.176-112 112-112m150.528 173.568c-152.896 99.968-196.544 304.064-97.408 456.96a330.69 330.69 0 0 0 456.96 96.64c9.216-5.888 17.6-11.776 25.152-18.56a18.24 18.24 0 0 0 4.224-24.32L700.352 724.8a47.55 47.55 0 0 0-65.536-14.272A234.56 234.56 0 0 1 310.592 641.6C240 533.248 271.104 387.968 379.456 316.48a234.3 234.3 0 0 1 276.352 15.168c1.664.832 2.56 2.56 3.392 4.224 5.888 8.384 3.328 19.328-5.12 25.216L456.832 489.6a47.55 47.55 0 0 0-14.336 65.472l16 24.384c5.888 8.384 16.768 10.88 25.216 5.056l308.224-199.936a19.584 19.584 0 0 0 6.72-23.488v-.896c-4.992-9.216-10.048-17.6-15.104-26.88-99.968-151.168-304.064-194.88-456.96-95.744zM786.88 504.704l-62.208 40.32c-8.32 5.888-10.88 16.768-4.992 25.216L760 632.32c5.888 8.448 16.768 11.008 25.152 5.12l31.104-20.16a55.36 55.36 0 0 0 16-76.48l-20.224-31.04a19.52 19.52 0 0 0-25.152-5.12z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d743f90dbbebae5 = $37aa0bf70ef60230$var$_sfc_main95;
var $37aa0bf70ef60230$var$_sfc_main96 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Eleme",
    __name: "eleme",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M300.032 188.8c174.72-113.28 408-63.36 522.24 109.44 5.76 10.56 11.52 20.16 17.28 30.72v.96a22.4 22.4 0 0 1-7.68 26.88l-352.32 228.48c-9.6 6.72-22.08 3.84-28.8-5.76l-18.24-27.84a54.336 54.336 0 0 1 16.32-74.88l225.6-146.88c9.6-6.72 12.48-19.2 5.76-28.8-.96-1.92-1.92-3.84-3.84-4.8a267.84 267.84 0 0 0-315.84-17.28c-123.84 81.6-159.36 247.68-78.72 371.52a268.096 268.096 0 0 0 370.56 78.72 54.336 54.336 0 0 1 74.88 16.32l17.28 26.88c5.76 9.6 3.84 21.12-4.8 27.84-8.64 7.68-18.24 14.4-28.8 21.12a377.92 377.92 0 0 1-522.24-110.4c-113.28-174.72-63.36-408 111.36-522.24m526.08 305.28a22.336 22.336 0 0 1 28.8 5.76l23.04 35.52a63.23 63.23 0 0 1-18.24 87.36l-35.52 23.04c-9.6 6.72-22.08 3.84-28.8-5.76l-46.08-71.04c-6.72-9.6-3.84-22.08 5.76-28.8z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$664fa00d3d7c36fb = $37aa0bf70ef60230$var$_sfc_main96;
var $37aa0bf70ef60230$var$_sfc_main97 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ElementPlus",
    __name: "element-plus",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M839.7 734.7c0 33.3-17.9 41-17.9 41S519.7 949.8 499.2 960c-10.2 5.1-20.5 5.1-30.7 0 0 0-314.9-184.3-325.1-192-5.1-5.1-10.2-12.8-12.8-20.5V368.6c0-17.9 20.5-28.2 20.5-28.2L466 158.6q19.2-7.65 38.4 0s279 161.3 309.8 179.2c17.9 7.7 28.2 25.6 25.6 46.1-.1-5-.1 317.5-.1 350.8M714.2 371.2c-64-35.8-217.6-125.4-217.6-125.4-7.7-5.1-20.5-5.1-30.7 0L217.6 389.1s-17.9 10.2-17.9 23v297c0 5.1 5.1 12.8 7.7 17.9 7.7 5.1 256 148.5 256 148.5 7.7 5.1 17.9 5.1 25.6 0 15.4-7.7 250.9-145.9 250.9-145.9s12.8-5.1 12.8-30.7v-74.2l-276.5 169v-64c0-17.9 7.7-30.7 20.5-46.1L745 535c5.1-7.7 10.2-20.5 10.2-30.7v-66.6l-279 169v-69.1c0-15.4 5.1-30.7 17.9-38.4zM919 135.7c0-5.1-5.1-7.7-7.7-7.7h-58.9V66.6c0-5.1-5.1-5.1-10.2-5.1l-30.7 5.1c-5.1 0-5.1 2.6-5.1 5.1V128h-56.3c-5.1 0-5.1 5.1-7.7 5.1v38.4h69.1v64c0 5.1 5.1 5.1 10.2 5.1l30.7-5.1c5.1 0 5.1-2.6 5.1-5.1v-56.3h64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d5f1d7786a96a28b = $37aa0bf70ef60230$var$_sfc_main97;
var $37aa0bf70ef60230$var$_sfc_main98 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Expand",
    __name: "expand",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 192h768v128H128zm0 256h512v128H128zm0 256h768v128H128zm576-352 192 160-192 128z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$49bd1dfb0ad29c40 = $37aa0bf70ef60230$var$_sfc_main98;
var $37aa0bf70ef60230$var$_sfc_main99 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Failed",
    __name: "failed",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m557.248 608 135.744-135.744-45.248-45.248-135.68 135.744-135.808-135.68-45.248 45.184L466.752 608l-135.68 135.68 45.184 45.312L512 653.248l135.744 135.744 45.248-45.248L557.312 608zM704 192h160v736H160V192h160v64h384zm-320 0V96h256v96z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$91ae1e982b7b05d4 = $37aa0bf70ef60230$var$_sfc_main99;
var $37aa0bf70ef60230$var$_sfc_main100 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Female",
    __name: "female",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 640a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 640q32 0 32 32v256q0 32-32 32t-32-32V672q0-32 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M352 800h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$95aa991f674bcf6e = $37aa0bf70ef60230$var$_sfc_main100;
var $37aa0bf70ef60230$var$_sfc_main101 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Files",
    __name: "files",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 384v448h768V384zm-32-64h832a32 32 0 0 1 32 32v512a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32m64-128h704v64H160zm96-128h512v64H256z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$9330ab61a7e5c11b = $37aa0bf70ef60230$var$_sfc_main101;
var $37aa0bf70ef60230$var$_sfc_main102 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Film",
    __name: "film",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 160v704h704V160zm-32-64h768a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M320 288V128h64v352h256V128h64v160h160v64H704v128h160v64H704v128h160v64H704v160h-64V544H384v352h-64V736H128v-64h192V544H128v-64h192V352H128v-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d5ceef4e30af8800 = $37aa0bf70ef60230$var$_sfc_main102;
var $37aa0bf70ef60230$var$_sfc_main103 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Filter",
    __name: "filter",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 523.392V928a32 32 0 0 0 46.336 28.608l192-96A32 32 0 0 0 640 832V523.392l280.768-343.104a32 32 0 1 0-49.536-40.576l-288 352A32 32 0 0 0 576 512v300.224l-128 64V512a32 32 0 0 0-7.232-20.288L195.52 192H704a32 32 0 1 0 0-64H128a32 32 0 0 0-24.768 52.288z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ec91da630f36d5ea = $37aa0bf70ef60230$var$_sfc_main103;
var $37aa0bf70ef60230$var$_sfc_main104 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Finished",
    __name: "finished",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M280.768 753.728 691.456 167.04a32 32 0 1 1 52.416 36.672L314.24 817.472a32 32 0 0 1-45.44 7.296l-230.4-172.8a32 32 0 0 1 38.4-51.2zM736 448a32 32 0 1 1 0-64h192a32 32 0 1 1 0 64zM608 640a32 32 0 0 1 0-64h319.936a32 32 0 1 1 0 64zM480 832a32 32 0 1 1 0-64h447.936a32 32 0 1 1 0 64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c5d72bc034a5be08 = $37aa0bf70ef60230$var$_sfc_main104;
var $37aa0bf70ef60230$var$_sfc_main105 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "FirstAidKit",
    __name: "first-aid-kit",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 256a64 64 0 0 0-64 64v448a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V320a64 64 0 0 0-64-64zm0-64h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 512h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96v-96a32 32 0 0 1 64 0zM352 128v64h320v-64zm-32-64h384a32 32 0 0 1 32 32v128a32 32 0 0 1-32 32H320a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8362e3218b03f95a = $37aa0bf70ef60230$var$_sfc_main105;
var $37aa0bf70ef60230$var$_sfc_main106 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Flag",
    __name: "flag",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M288 128h608L736 384l160 256H288v320h-96V64h96z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$48ea269755562084 = $37aa0bf70ef60230$var$_sfc_main106;
var $37aa0bf70ef60230$var$_sfc_main107 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Fold",
    __name: "fold",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M896 192H128v128h768zm0 256H384v128h512zm0 256H128v128h768zM320 384 128 512l192 128z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$71b56ab8b1d5480d = $37aa0bf70ef60230$var$_sfc_main107;
var $37aa0bf70ef60230$var$_sfc_main108 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "FolderAdd",
    __name: "folder-add",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m384 416V416h64v128h128v64H544v128h-64V608H352v-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a8ad20d6e96ec931 = $37aa0bf70ef60230$var$_sfc_main108;
var $37aa0bf70ef60230$var$_sfc_main109 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "FolderChecked",
    __name: "folder-checked",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m414.08 502.144 180.992-180.992L736.32 494.4 510.08 720.64l-158.4-158.336 45.248-45.312z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6b5dd1d5fba28a5 = $37aa0bf70ef60230$var$_sfc_main109;
var $37aa0bf70ef60230$var$_sfc_main110 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "FolderDelete",
    __name: "folder-delete",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m370.752 448-90.496-90.496 45.248-45.248L512 530.752l90.496-90.496 45.248 45.248L557.248 576l90.496 90.496-45.248 45.248L512 621.248l-90.496 90.496-45.248-45.248z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a83fb399a1a6967f = $37aa0bf70ef60230$var$_sfc_main110;
var $37aa0bf70ef60230$var$_sfc_main111 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "FolderOpened",
    __name: "folder-opened",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M878.08 448H241.92l-96 384h636.16zM832 384v-64H485.76L357.504 192H128v448l57.92-231.744A32 32 0 0 1 216.96 384zm-24.96 512H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h287.872l128.384 128H864a32 32 0 0 1 32 32v96h23.04a32 32 0 0 1 31.04 39.744l-112 448A32 32 0 0 1 807.04 896"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4c8f3be37e22e091 = $37aa0bf70ef60230$var$_sfc_main111;
var $37aa0bf70ef60230$var$_sfc_main112 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "FolderRemove",
    __name: "folder-remove",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32m256 416h320v64H352z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e279dda20e3691bb = $37aa0bf70ef60230$var$_sfc_main112;
var $37aa0bf70ef60230$var$_sfc_main113 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Folder",
    __name: "folder",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 192v640h768V320H485.76L357.504 192zm-32-64h287.872l128.384 128H928a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$80729fed35a16515 = $37aa0bf70ef60230$var$_sfc_main113;
var $37aa0bf70ef60230$var$_sfc_main114 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Food",
    __name: "food",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 352.576V352a288 288 0 0 1 491.072-204.224 192 192 0 0 1 274.24 204.48 64 64 0 0 1 57.216 74.24C921.6 600.512 850.048 710.656 736 756.992V800a96 96 0 0 1-96 96H384a96 96 0 0 1-96-96v-43.008c-114.048-46.336-185.6-156.48-214.528-330.496A64 64 0 0 1 128 352.64zm64-.576h64a160 160 0 0 1 320 0h64a224 224 0 0 0-448 0m128 0h192a96 96 0 0 0-192 0m439.424 0h68.544A128.256 128.256 0 0 0 704 192c-15.36 0-29.952 2.688-43.52 7.616 11.328 18.176 20.672 37.76 27.84 58.304A64.128 64.128 0 0 1 759.424 352M672 768H352v32a32 32 0 0 0 32 32h256a32 32 0 0 0 32-32zm-342.528-64h365.056c101.504-32.64 165.76-124.928 192.896-288H136.576c27.136 163.072 91.392 255.36 192.896 288"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$160f9e0323fbc7fd = $37aa0bf70ef60230$var$_sfc_main114;
var $37aa0bf70ef60230$var$_sfc_main115 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Football",
    __name: "football",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896m0-64a384 384 0 1 0 0-768 384 384 0 0 0 0 768"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M186.816 268.288c16-16.384 31.616-31.744 46.976-46.08 17.472 30.656 39.808 58.112 65.984 81.28l-32.512 56.448a386 386 0 0 1-80.448-91.648m653.696-5.312a385.9 385.9 0 0 1-83.776 96.96l-32.512-56.384a322.9 322.9 0 0 0 68.48-85.76c15.552 14.08 31.488 29.12 47.808 45.184M465.984 445.248l11.136-63.104a323.6 323.6 0 0 0 69.76 0l11.136 63.104a388 388 0 0 1-92.032 0m-62.72-12.8A381.8 381.8 0 0 1 320 396.544l32-55.424a320 320 0 0 0 62.464 27.712l-11.2 63.488zm300.8-35.84a381.8 381.8 0 0 1-83.328 35.84l-11.2-63.552A320 320 0 0 0 672 341.184l32 55.424zm-520.768 364.8a385.9 385.9 0 0 1 83.968-97.28l32.512 56.32c-26.88 23.936-49.856 52.352-67.52 84.032-16-13.44-32.32-27.712-48.96-43.072m657.536.128a1443 1443 0 0 1-49.024 43.072 321.4 321.4 0 0 0-67.584-84.16l32.512-56.32c33.216 27.456 61.696 60.352 84.096 97.408M465.92 578.752a388 388 0 0 1 92.032 0l-11.136 63.104a323.6 323.6 0 0 0-69.76 0zm-62.72 12.8 11.2 63.552a320 320 0 0 0-62.464 27.712L320 627.392a381.8 381.8 0 0 1 83.264-35.84zm300.8 35.84-32 55.424a318.3 318.3 0 0 0-62.528-27.712l11.2-63.488c29.44 8.64 57.28 20.736 83.264 35.776z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7e4beb3c7865065d = $37aa0bf70ef60230$var$_sfc_main115;
var $37aa0bf70ef60230$var$_sfc_main116 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ForkSpoon",
    __name: "fork-spoon",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 410.304V96a32 32 0 0 1 64 0v314.304a96 96 0 0 0 64-90.56V96a32 32 0 0 1 64 0v223.744a160 160 0 0 1-128 156.8V928a32 32 0 1 1-64 0V476.544a160 160 0 0 1-128-156.8V96a32 32 0 0 1 64 0v223.744a96 96 0 0 0 64 90.56M672 572.48C581.184 552.128 512 446.848 512 320c0-141.44 85.952-256 192-256s192 114.56 192 256c0 126.848-69.184 232.128-160 252.48V928a32 32 0 1 1-64 0zM704 512c66.048 0 128-82.56 128-192s-61.952-192-128-192-128 82.56-128 192 61.952 192 128 192"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e12b1598f90221e7 = $37aa0bf70ef60230$var$_sfc_main116;
var $37aa0bf70ef60230$var$_sfc_main117 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Fries",
    __name: "fries",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M608 224v-64a32 32 0 0 0-64 0v336h26.88A64 64 0 0 0 608 484.096zm101.12 160A64 64 0 0 0 672 395.904V384h64V224a32 32 0 1 0-64 0v160zm74.88 0a92.928 92.928 0 0 1 91.328 110.08l-60.672 323.584A96 96 0 0 1 720.32 896H303.68a96 96 0 0 1-94.336-78.336L148.672 494.08A92.928 92.928 0 0 1 240 384h-16V224a96 96 0 0 1 188.608-25.28A95.74 95.74 0 0 1 480 197.44V160a96 96 0 0 1 188.608-25.28A96 96 0 0 1 800 224v160zM670.784 512a128 128 0 0 1-99.904 48H453.12a128 128 0 0 1-99.84-48H352v-1.536a128 128 0 0 1-9.984-14.976L314.88 448H240a28.928 28.928 0 0 0-28.48 34.304L241.088 640h541.824l29.568-157.696A28.928 28.928 0 0 0 784 448h-74.88l-27.136 47.488A132 132 0 0 1 672 510.464V512zM480 288a32 32 0 0 0-64 0v196.096A64 64 0 0 0 453.12 496H480zm-128 96V224a32 32 0 0 0-64 0v160zh-37.12A64 64 0 0 1 352 395.904zm-98.88 320 19.072 101.888A32 32 0 0 0 303.68 832h416.64a32 32 0 0 0 31.488-26.112L770.88 704z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$3c6300d31f5e7512 = $37aa0bf70ef60230$var$_sfc_main117;
var $37aa0bf70ef60230$var$_sfc_main118 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "FullScreen",
    __name: "full-screen",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m160 96.064 192 .192a32 32 0 0 1 0 64l-192-.192V352a32 32 0 0 1-64 0V96h64zm0 831.872V928H96V672a32 32 0 1 1 64 0v191.936l192-.192a32 32 0 1 1 0 64zM864 96.064V96h64v256a32 32 0 1 1-64 0V160.064l-192 .192a32 32 0 1 1 0-64zm0 831.872-192-.192a32 32 0 0 1 0-64l192 .192V672a32 32 0 1 1 64 0v256h-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$f885b95b3f0be76d = $37aa0bf70ef60230$var$_sfc_main118;
var $37aa0bf70ef60230$var$_sfc_main119 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "GobletFull",
    __name: "goblet-full",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 320h512c0-78.592-12.608-142.4-36.928-192h-434.24C269.504 192.384 256 256.256 256 320m503.936 64H264.064a256.128 256.128 0 0 0 495.872 0M544 638.4V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.4A320 320 0 0 1 192 320c0-85.632 21.312-170.944 64-256h512c42.688 64.32 64 149.632 64 256a320 320 0 0 1-288 318.4"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a47ea2fef79799f6 = $37aa0bf70ef60230$var$_sfc_main119;
var $37aa0bf70ef60230$var$_sfc_main120 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "GobletSquareFull",
    __name: "goblet-square-full",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 270.912c10.048 6.72 22.464 14.912 28.992 18.624a220.16 220.16 0 0 0 114.752 30.72c30.592 0 49.408-9.472 91.072-41.152l.64-.448c52.928-40.32 82.368-55.04 132.288-54.656 55.552.448 99.584 20.8 142.72 57.408l1.536 1.28V128H256zm.96 76.288C266.368 482.176 346.88 575.872 512 576c157.44.064 237.952-85.056 253.248-209.984a952 952 0 0 1-40.192-35.712c-32.704-27.776-63.36-41.92-101.888-42.24-31.552-.256-50.624 9.28-93.12 41.6l-.576.448c-52.096 39.616-81.024 54.208-129.792 54.208-54.784 0-100.48-13.376-142.784-37.056zM480 638.848C250.624 623.424 192 442.496 192 319.68V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v224c0 122.816-58.624 303.68-288 318.912V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6defda64da2015cb = $37aa0bf70ef60230$var$_sfc_main120;
var $37aa0bf70ef60230$var$_sfc_main121 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "GobletSquare",
    __name: "goblet-square",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 638.912V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.848C250.624 623.424 192 442.496 192 319.68V96a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v224c0 122.816-58.624 303.68-288 318.912M256 319.68c0 149.568 80 256.192 256 256.256C688.128 576 768 469.568 768 320V128H256z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$bf629ef10a3f2d4e = $37aa0bf70ef60230$var$_sfc_main121;
var $37aa0bf70ef60230$var$_sfc_main122 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Goblet",
    __name: "goblet",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 638.4V896h96a32 32 0 1 1 0 64H384a32 32 0 1 1 0-64h96V638.4A320 320 0 0 1 192 320c0-85.632 21.312-170.944 64-256h512c42.688 64.32 64 149.632 64 256a320 320 0 0 1-288 318.4M256 320a256 256 0 1 0 512 0c0-78.592-12.608-142.4-36.928-192h-434.24C269.504 192.384 256 256.256 256 320"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$20f8a214ba85188c = $37aa0bf70ef60230$var$_sfc_main122;
var $37aa0bf70ef60230$var$_sfc_main123 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "GoldMedal",
    __name: "gold-medal",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m772.13 452.84 53.86-351.81c1.32-10.01-1.17-18.68-7.49-26.02S804.35 64 795.01 64H228.99v-.01h-.06c-9.33 0-17.15 3.67-23.49 11.01s-8.83 16.01-7.49 26.02l53.87 351.89C213.54 505.73 193.59 568.09 192 640c2 90.67 33.17 166.17 93.5 226.5S421.33 957.99 512 960c90.67-2 166.17-33.17 226.5-93.5 60.33-60.34 91.49-135.83 93.5-226.5-1.59-71.94-21.56-134.32-59.87-187.16M640.01 128h117.02l-39.01 254.02c-20.75-10.64-40.74-19.73-59.94-27.28-5.92-3-11.95-5.8-18.08-8.41V128zM576 128v198.76c-13.18-2.58-26.74-4.43-40.67-5.55-8.07-.8-15.85-1.2-23.33-1.2-10.54 0-21.09.66-31.64 1.96a360 360 0 0 0-32.36 4.79V128zm-192 0h.04v218.3c-6.22 2.66-12.34 5.5-18.36 8.56-19.13 7.54-39.02 16.6-59.66 27.16L267.01 128zm308.99 692.99c-48 48-108.33 73-180.99 75.01-72.66-2.01-132.99-27.01-180.99-75.01S258.01 712.66 256 640c2.01-72.66 27.01-132.99 75.01-180.99 19.67-19.67 41.41-35.47 65.22-47.41 38.33-15.04 71.15-23.92 98.44-26.65 5.07-.41 10.2-.7 15.39-.88.63-.01 1.28-.03 1.91-.03.66 0 1.35.03 2.02.04 5.11.17 10.15.46 15.13.86 27.4 2.71 60.37 11.65 98.91 26.79 23.71 11.93 45.36 27.69 64.96 47.29 48 48 73 108.33 75.01 180.99-2.01 72.65-27.01 132.98-75.01 180.98"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 480H416v64h64v192h-64v64h192v-64h-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8a0b6a6ecd48b8ae = $37aa0bf70ef60230$var$_sfc_main123;
var $37aa0bf70ef60230$var$_sfc_main124 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "GoodsFilled",
    __name: "goods-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 352h640l64 544H128zm128 224h64V448h-64zm320 0h64V448h-64zM384 288h-64a192 192 0 1 1 384 0h-64a128 128 0 1 0-256 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$34c94a3c78f58a22 = $37aa0bf70ef60230$var$_sfc_main124;
var $37aa0bf70ef60230$var$_sfc_main125 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Goods",
    __name: "goods",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M320 288v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4h131.072a32 32 0 0 1 31.808 28.8l57.6 576a32 32 0 0 1-31.808 35.2H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320zm64 0h256v-22.336C640 189.248 582.272 128 512 128s-128 61.248-128 137.664v22.4zm-64 64H217.92l-51.2 512h690.56l-51.264-512H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$20c26229f13b559b = $37aa0bf70ef60230$var$_sfc_main125;
var $37aa0bf70ef60230$var$_sfc_main126 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Grape",
    __name: "grape",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 195.2a160 160 0 0 1 96 60.8 160 160 0 1 1 146.24 254.976 160 160 0 0 1-128 224 160 160 0 1 1-292.48 0 160 160 0 0 1-128-224A160 160 0 1 1 384 256a160 160 0 0 1 96-60.8V128h-64a32 32 0 0 1 0-64h192a32 32 0 0 1 0 64h-64zM512 448a96 96 0 1 0 0-192 96 96 0 0 0 0 192m-256 0a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128 224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128 224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128-224a96 96 0 1 0 0-192 96 96 0 0 0 0 192m128-224a96 96 0 1 0 0-192 96 96 0 0 0 0 192"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4e38012a866f8d08 = $37aa0bf70ef60230$var$_sfc_main126;
var $37aa0bf70ef60230$var$_sfc_main127 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Grid",
    __name: "grid",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M640 384v256H384V384zm64 0h192v256H704zm-64 512H384V704h256zm64 0V704h192v192zm-64-768v192H384V128zm64 0h192v192H704zM320 384v256H128V384zm0 512H128V704h192zm0-768v192H128V128z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ef2184bd89960b14 = $37aa0bf70ef60230$var$_sfc_main127;
var $37aa0bf70ef60230$var$_sfc_main128 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Guide",
    __name: "guide",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M640 608h-64V416h64zm0 160v160a32 32 0 0 1-32 32H416a32 32 0 0 1-32-32V768h64v128h128V768zM384 608V416h64v192zm256-352h-64V128H448v128h-64V96a32 32 0 0 1 32-32h192a32 32 0 0 1 32 32z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m220.8 256-71.232 80 71.168 80H768V256zm-14.4-64H800a32 32 0 0 1 32 32v224a32 32 0 0 1-32 32H206.4a32 32 0 0 1-23.936-10.752l-99.584-112a32 32 0 0 1 0-42.496l99.584-112A32 32 0 0 1 206.4 192m678.784 496-71.104 80H266.816V608h547.2zm-56.768-144H234.88a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32h593.6a32 32 0 0 0 23.936-10.752l99.584-112a32 32 0 0 0 0-42.496l-99.584-112A32 32 0 0 0 828.48 544z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$dd9cef36367ff841 = $37aa0bf70ef60230$var$_sfc_main128;
var $37aa0bf70ef60230$var$_sfc_main129 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Handbag",
    __name: "handbag",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M887.01 264.99c-6-5.99-13.67-8.99-23.01-8.99H704c-1.34-54.68-20.01-100.01-56-136s-81.32-54.66-136-56c-54.68 1.34-100.01 20.01-136 56s-54.66 81.32-56 136H160c-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.67-8.99 23.01v640c0 9.35 2.99 17.02 8.99 23.01S150.66 960 160 960h704c9.35 0 17.02-2.99 23.01-8.99S896 937.34 896 928V288c0-9.35-2.99-17.02-8.99-23.01M421.5 165.5c24.32-24.34 54.49-36.84 90.5-37.5 35.99.68 66.16 13.18 90.5 37.5s36.84 54.49 37.5 90.5H384c.68-35.99 13.18-66.16 37.5-90.5M832 896H192V320h128v128h64V320h256v128h64V320h128z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$578aef0462d0c0a0 = $37aa0bf70ef60230$var$_sfc_main129;
var $37aa0bf70ef60230$var$_sfc_main130 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Headset",
    __name: "headset",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M896 529.152V512a384 384 0 1 0-768 0v17.152A128 128 0 0 1 320 640v128a128 128 0 1 1-256 0V512a448 448 0 1 1 896 0v256a128 128 0 1 1-256 0V640a128 128 0 0 1 192-110.848M896 640a64 64 0 0 0-128 0v128a64 64 0 0 0 128 0zm-768 0v128a64 64 0 0 0 128 0V640a64 64 0 1 0-128 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2d2afa4e2c836258 = $37aa0bf70ef60230$var$_sfc_main130;
var $37aa0bf70ef60230$var$_sfc_main131 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "HelpFilled",
    __name: "help-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M926.784 480H701.312A192.51 192.51 0 0 0 544 322.688V97.216A416.064 416.064 0 0 1 926.784 480m0 64A416.064 416.064 0 0 1 544 926.784V701.312A192.51 192.51 0 0 0 701.312 544zM97.28 544h225.472A192.51 192.51 0 0 0 480 701.312v225.472A416.064 416.064 0 0 1 97.216 544zm0-64A416.064 416.064 0 0 1 480 97.216v225.472A192.51 192.51 0 0 0 322.688 480H97.216z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1666f0a103b0fba = $37aa0bf70ef60230$var$_sfc_main131;
var $37aa0bf70ef60230$var$_sfc_main132 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Help",
    __name: "help",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m759.936 805.248-90.944-91.008A254.9 254.9 0 0 1 512 768a254.9 254.9 0 0 1-156.992-53.76l-90.944 91.008A382.46 382.46 0 0 0 512 896c94.528 0 181.12-34.176 247.936-90.752m45.312-45.312A382.46 382.46 0 0 0 896 512c0-94.528-34.176-181.12-90.752-247.936l-91.008 90.944C747.904 398.4 768 452.864 768 512s-20.096 113.6-53.76 156.992zm-45.312-541.184A382.46 382.46 0 0 0 512 128c-94.528 0-181.12 34.176-247.936 90.752l90.944 91.008A254.9 254.9 0 0 1 512 256c59.136 0 113.6 20.096 156.992 53.76zm-541.184 45.312A382.46 382.46 0 0 0 128 512c0 94.528 34.176 181.12 90.752 247.936l91.008-90.944A254.9 254.9 0 0 1 256 512c0-59.136 20.096-113.6 53.76-156.992zm417.28 394.496a194.6 194.6 0 0 0 22.528-22.528C686.912 602.56 704 559.232 704 512a191.23 191.23 0 0 0-67.968-146.56A191.3 191.3 0 0 0 512 320a191.23 191.23 0 0 0-146.56 67.968C337.088 421.44 320 464.768 320 512a191.23 191.23 0 0 0 67.968 146.56C421.44 686.912 464.768 704 512 704c47.296 0 90.56-17.088 124.032-45.44M512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1be7516c0280bee8 = $37aa0bf70ef60230$var$_sfc_main132;
var $37aa0bf70ef60230$var$_sfc_main133 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Hide",
    __name: "hide",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M876.8 156.8c0-9.6-3.2-16-9.6-22.4s-12.8-9.6-22.4-9.6-16 3.2-22.4 9.6L736 220.8c-64-32-137.6-51.2-224-60.8-160 16-288 73.6-377.6 176S0 496 0 512s48 73.6 134.4 176c22.4 25.6 44.8 48 73.6 67.2l-86.4 89.6c-6.4 6.4-9.6 12.8-9.6 22.4s3.2 16 9.6 22.4 12.8 9.6 22.4 9.6 16-3.2 22.4-9.6l704-710.4c3.2-6.4 6.4-12.8 6.4-22.4m-646.4 528Q115.2 579.2 76.8 512q43.2-72 153.6-172.8C304 272 400 230.4 512 224c64 3.2 124.8 19.2 176 44.8l-54.4 54.4C598.4 300.8 560 288 512 288c-64 0-115.2 22.4-160 64s-64 96-64 160c0 48 12.8 89.6 35.2 124.8L256 707.2c-9.6-6.4-19.2-16-25.6-22.4m140.8-96Q352 555.2 352 512c0-44.8 16-83.2 48-112s67.2-48 112-48c28.8 0 54.4 6.4 73.6 19.2zM889.599 336c-12.8-16-28.8-28.8-41.6-41.6l-48 48c73.6 67.2 124.8 124.8 150.4 169.6q-43.2 72-153.6 172.8c-73.6 67.2-172.8 108.8-284.8 115.2-51.2-3.2-99.2-12.8-140.8-28.8l-48 48c57.6 22.4 118.4 38.4 188.8 44.8 160-16 288-73.6 377.6-176S1024 528 1024 512s-48.001-73.6-134.401-176"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M511.998 672c-12.8 0-25.6-3.2-38.4-6.4l-51.2 51.2c28.8 12.8 57.6 19.2 89.6 19.2 64 0 115.2-22.4 160-64 41.6-41.6 64-96 64-160 0-32-6.4-64-19.2-89.6l-51.2 51.2c3.2 12.8 6.4 25.6 6.4 38.4 0 44.8-16 83.2-48 112s-67.2 48-112 48"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$bed28288a051538 = $37aa0bf70ef60230$var$_sfc_main133;
var $37aa0bf70ef60230$var$_sfc_main134 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Histogram",
    __name: "histogram",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M416 896V128h192v768zm-288 0V448h192v448zm576 0V320h192v576z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8166dc6475613235 = $37aa0bf70ef60230$var$_sfc_main134;
var $37aa0bf70ef60230$var$_sfc_main135 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "HomeFilled",
    __name: "home-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 128 128 447.936V896h255.936V640H640v256h255.936V447.936z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c3378819f5c9f403 = $37aa0bf70ef60230$var$_sfc_main135;
var $37aa0bf70ef60230$var$_sfc_main136 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "HotWater",
    __name: "hot-water",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M273.067 477.867h477.866V409.6H273.067zm0 68.266v51.2A187.733 187.733 0 0 0 460.8 785.067h102.4a187.733 187.733 0 0 0 187.733-187.734v-51.2zm-34.134-204.8h546.134a34.133 34.133 0 0 1 34.133 34.134v221.866a256 256 0 0 1-256 256H460.8a256 256 0 0 1-256-256V375.467a34.133 34.133 0 0 1 34.133-34.134M512 34.133a34.133 34.133 0 0 1 34.133 34.134v170.666a34.133 34.133 0 0 1-68.266 0V68.267A34.133 34.133 0 0 1 512 34.133M375.467 102.4a34.133 34.133 0 0 1 34.133 34.133v102.4a34.133 34.133 0 0 1-68.267 0v-102.4a34.133 34.133 0 0 1 34.134-34.133m273.066 0a34.133 34.133 0 0 1 34.134 34.133v102.4a34.133 34.133 0 1 1-68.267 0v-102.4a34.133 34.133 0 0 1 34.133-34.133M170.667 921.668h682.666a34.133 34.133 0 1 1 0 68.267H170.667a34.133 34.133 0 1 1 0-68.267"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8043212fda8a4210 = $37aa0bf70ef60230$var$_sfc_main136;
var $37aa0bf70ef60230$var$_sfc_main137 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "House",
    __name: "house",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 413.952V896h640V413.952L512 147.328zM139.52 374.4l352-293.312a32 32 0 0 1 40.96 0l352 293.312A32 32 0 0 1 896 398.976V928a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V398.976a32 32 0 0 1 11.52-24.576"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1027d4534a5ce60b = $37aa0bf70ef60230$var$_sfc_main137;
var $37aa0bf70ef60230$var$_sfc_main138 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "IceCreamRound",
    __name: "ice-cream-round",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m308.352 489.344 226.304 226.304a32 32 0 0 0 45.248 0L783.552 512A192 192 0 1 0 512 240.448L308.352 444.16a32 32 0 0 0 0 45.248zm135.744 226.304L308.352 851.392a96 96 0 0 1-135.744-135.744l135.744-135.744-45.248-45.248a96 96 0 0 1 0-135.808L466.752 195.2A256 256 0 0 1 828.8 557.248L625.152 760.96a96 96 0 0 1-135.808 0l-45.248-45.248zM398.848 670.4 353.6 625.152 217.856 760.896a32 32 0 0 0 45.248 45.248zm248.96-384.64a32 32 0 0 1 0 45.248L466.624 512a32 32 0 1 1-45.184-45.248l180.992-181.056a32 32 0 0 1 45.248 0zm90.496 90.496a32 32 0 0 1 0 45.248L557.248 602.496A32 32 0 1 1 512 557.248l180.992-180.992a32 32 0 0 1 45.312 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7d5d2fd7872e8c95 = $37aa0bf70ef60230$var$_sfc_main138;
var $37aa0bf70ef60230$var$_sfc_main139 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "IceCreamSquare",
    __name: "ice-cream-square",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M416 640h256a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32H352a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32zm192 64v160a96 96 0 0 1-192 0V704h-64a96 96 0 0 1-96-96V160a96 96 0 0 1 96-96h320a96 96 0 0 1 96 96v448a96 96 0 0 1-96 96zm-64 0h-64v160a32 32 0 1 0 64 0z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$cf8f8c8c61ab36bf = $37aa0bf70ef60230$var$_sfc_main139;
var $37aa0bf70ef60230$var$_sfc_main140 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "IceCream",
    __name: "ice-cream",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128.64 448a208 208 0 0 1 193.536-191.552 224 224 0 0 1 445.248 15.488A208.13 208.13 0 0 1 894.784 448H896L548.8 983.68a32 32 0 0 1-53.248.704L128 448zm64.256 0h286.208a144 144 0 0 0-286.208 0m351.36 0h286.272a144 144 0 0 0-286.272 0m-294.848 64 271.808 396.608L778.24 512zM511.68 352.64a207.87 207.87 0 0 1 189.184-96.192 160 160 0 0 0-314.752 5.632c52.608 12.992 97.28 46.08 125.568 90.56"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$3e98347679d84c37 = $37aa0bf70ef60230$var$_sfc_main140;
var $37aa0bf70ef60230$var$_sfc_main141 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "IceDrink",
    __name: "ice-drink",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 448v128h239.68l16.064-128zm-64 0H256.256l16.064 128H448zm64-255.36V384h247.744A256.13 256.13 0 0 0 512 192.64m-64 8.064A256.45 256.45 0 0 0 264.256 384H448zm64-72.064A320.13 320.13 0 0 1 825.472 384H896a32 32 0 1 1 0 64h-64v1.92l-56.96 454.016A64 64 0 0 1 711.552 960H312.448a64 64 0 0 1-63.488-56.064L192 449.92V448h-64a32 32 0 0 1 0-64h70.528A320.38 320.38 0 0 1 448 135.04V96a96 96 0 0 1 96-96h128a32 32 0 1 1 0 64H544a32 32 0 0 0-32 32zM743.68 640H280.32l32.128 256h399.104z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$556974b45abb19eb = $37aa0bf70ef60230$var$_sfc_main141;
var $37aa0bf70ef60230$var$_sfc_main142 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "IceTea",
    __name: "ice-tea",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M197.696 259.648a320.128 320.128 0 0 1 628.608 0A96 96 0 0 1 896 352v64a96 96 0 0 1-71.616 92.864l-49.408 395.072A64 64 0 0 1 711.488 960H312.512a64 64 0 0 1-63.488-56.064l-49.408-395.072A96 96 0 0 1 128 416v-64a96 96 0 0 1 69.696-92.352M264.064 256h495.872a256.128 256.128 0 0 0-495.872 0m495.424 256H264.512l48 384h398.976zM224 448h576a32 32 0 0 0 32-32v-64a32 32 0 0 0-32-32H224a32 32 0 0 0-32 32v64a32 32 0 0 0 32 32m160 192h64v64h-64zm192 64h64v64h-64zm-128 64h64v64h-64zm64-192h64v64h-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7285b9473ca84e05 = $37aa0bf70ef60230$var$_sfc_main142;
var $37aa0bf70ef60230$var$_sfc_main143 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "InfoFilled",
    __name: "info-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896.064A448 448 0 0 1 512 64m67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344M590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.99 12.99 0 0 1-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296-44.096 0-108.992 44.736-148.48 101.504 0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 0 1 7.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04 67.84 0 107.904-43.648 147.456-100.416z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d2505fbd697b65ef = $37aa0bf70ef60230$var$_sfc_main143;
var $37aa0bf70ef60230$var$_sfc_main144 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Iphone",
    __name: "iphone",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M224 768v96.064a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64V768zm0-64h576V160a64 64 0 0 0-64-64H288a64 64 0 0 0-64 64zm32 288a96 96 0 0 1-96-96V128a96 96 0 0 1 96-96h512a96 96 0 0 1 96 96v768a96 96 0 0 1-96 96zm304-144a48 48 0 1 1-96 0 48 48 0 0 1 96 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e11ad930d3bd3fc2 = $37aa0bf70ef60230$var$_sfc_main144;
var $37aa0bf70ef60230$var$_sfc_main145 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Key",
    __name: "key",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M448 456.064V96a32 32 0 0 1 32-32.064L672 64a32 32 0 0 1 0 64H512v128h160a32 32 0 0 1 0 64H512v128a256 256 0 1 1-64 8.064M512 896a192 192 0 1 0 0-384 192 192 0 0 0 0 384"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$cd0f44441c3b7719 = $37aa0bf70ef60230$var$_sfc_main145;
var $37aa0bf70ef60230$var$_sfc_main146 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "KnifeFork",
    __name: "knife-fork",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 410.56V96a32 32 0 0 1 64 0v314.56A96 96 0 0 0 384 320V96a32 32 0 0 1 64 0v224a160 160 0 0 1-128 156.8V928a32 32 0 1 1-64 0V476.8A160 160 0 0 1 128 320V96a32 32 0 0 1 64 0v224a96 96 0 0 0 64 90.56m384-250.24V544h126.72c-3.328-78.72-12.928-147.968-28.608-207.744-14.336-54.528-46.848-113.344-98.112-175.872zM640 608v320a32 32 0 1 1-64 0V64h64c85.312 89.472 138.688 174.848 160 256s32 177.152 32 288z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4357dc9ed615037b = $37aa0bf70ef60230$var$_sfc_main146;
var $37aa0bf70ef60230$var$_sfc_main147 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Lightning",
    __name: "lightning",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M288 671.36v64.128A239.81 239.81 0 0 1 63.744 496.192a240.32 240.32 0 0 1 199.488-236.8 256.128 256.128 0 0 1 487.872-30.976A256.064 256.064 0 0 1 736 734.016v-64.768a192 192 0 0 0 3.328-377.92l-35.2-6.592-12.8-33.408a192.064 192.064 0 0 0-365.952 23.232l-9.92 40.896-41.472 7.04a176.32 176.32 0 0 0-146.24 173.568c0 91.968 70.464 167.36 160.256 175.232z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M416 736a32 32 0 0 1-27.776-47.872l128-224a32 32 0 1 1 55.552 31.744L471.168 672H608a32 32 0 0 1 27.776 47.872l-128 224a32 32 0 1 1-55.68-31.744L552.96 736z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$71809dd4a5478fb0 = $37aa0bf70ef60230$var$_sfc_main147;
var $37aa0bf70ef60230$var$_sfc_main148 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Link",
    __name: "link",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a6c7ac8248d6e38a = $37aa0bf70ef60230$var$_sfc_main148;
var $37aa0bf70ef60230$var$_sfc_main149 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "List",
    __name: "list",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 192h160v736H160V192h160v64h384zM288 512h448v-64H288zm0 256h448v-64H288zm96-576V96h256v96z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$54c2e3dc7acea9f5 = $37aa0bf70ef60230$var$_sfc_main149;
var $37aa0bf70ef60230$var$_sfc_main150 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Loading",
    __name: "loading",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248m452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248M828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$669f6ea7d267feaf = $37aa0bf70ef60230$var$_sfc_main150;
var $37aa0bf70ef60230$var$_sfc_main151 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "LocationFilled",
    __name: "location-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 928c23.936 0 117.504-68.352 192.064-153.152C803.456 661.888 864 535.808 864 416c0-189.632-155.84-320-352-320S160 226.368 160 416c0 120.32 60.544 246.4 159.936 359.232C394.432 859.84 488 928 512 928m0-435.2a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 140.8a204.8 204.8 0 1 1 0-409.6 204.8 204.8 0 0 1 0 409.6"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c873a3379640320 = $37aa0bf70ef60230$var$_sfc_main151;
var $37aa0bf70ef60230$var$_sfc_main152 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "LocationInformation",
    __name: "location-information",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M288 896h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192m0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$165c136fa652c3f8 = $37aa0bf70ef60230$var$_sfc_main152;
var $37aa0bf70ef60230$var$_sfc_main153 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Location",
    __name: "location",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 512a96 96 0 1 0 0-192 96 96 0 0 0 0 192m0 64a160 160 0 1 1 0-320 160 160 0 0 1 0 320"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$18a2be9195644f38 = $37aa0bf70ef60230$var$_sfc_main153;
var $37aa0bf70ef60230$var$_sfc_main154 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Lock",
    __name: "lock",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M224 448a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V480a32 32 0 0 0-32-32zm0-64h576a96 96 0 0 1 96 96v384a96 96 0 0 1-96 96H224a96 96 0 0 1-96-96V480a96 96 0 0 1 96-96"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 544a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V576a32 32 0 0 1 32-32m192-160v-64a192 192 0 1 0-384 0v64zM512 64a256 256 0 0 1 256 256v128H256V320A256 256 0 0 1 512 64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$5b9db7ce80343746 = $37aa0bf70ef60230$var$_sfc_main154;
var $37aa0bf70ef60230$var$_sfc_main155 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Lollipop",
    __name: "lollipop",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M513.28 448a64 64 0 1 1 76.544 49.728A96 96 0 0 0 768 448h64a160 160 0 0 1-320 0zm-126.976-29.696a256 256 0 1 0 43.52-180.48A256 256 0 0 1 832 448h-64a192 192 0 0 0-381.696-29.696m105.664 249.472L285.696 874.048a96 96 0 0 1-135.68-135.744l206.208-206.272a320 320 0 1 1 135.744 135.744m-54.464-36.032a322 322 0 0 1-45.248-45.248L195.2 783.552a32 32 0 1 0 45.248 45.248l197.056-197.12z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$debf6b7fbebe490e = $37aa0bf70ef60230$var$_sfc_main155;
var $37aa0bf70ef60230$var$_sfc_main156 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "MagicStick",
    __name: "magic-stick",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64h64v192h-64zm0 576h64v192h-64zM160 480v-64h192v64zm576 0v-64h192v64zM249.856 199.04l45.248-45.184L430.848 289.6 385.6 334.848 249.856 199.104zM657.152 606.4l45.248-45.248 135.744 135.744-45.248 45.248zM114.048 923.2 68.8 877.952l316.8-316.8 45.248 45.248zM702.4 334.848 657.152 289.6l135.744-135.744 45.248 45.248z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$b3536bd01f6e269a = $37aa0bf70ef60230$var$_sfc_main156;
var $37aa0bf70ef60230$var$_sfc_main157 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Magnet",
    __name: "magnet",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M832 320V192H704v320a192 192 0 1 1-384 0V192H192v128h128v64H192v128a320 320 0 0 0 640 0V384H704v-64zM640 512V128h256v384a384 384 0 1 1-768 0V128h256v384a128 128 0 1 0 256 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$910423bbbae07cdf = $37aa0bf70ef60230$var$_sfc_main157;
var $37aa0bf70ef60230$var$_sfc_main158 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Male",
    __name: "male",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M399.5 849.5a225 225 0 1 0 0-450 225 225 0 0 0 0 450m0 56.25a281.25 281.25 0 1 1 0-562.5 281.25 281.25 0 0 1 0 562.5m253.125-787.5h225q28.125 0 28.125 28.125T877.625 174.5h-225q-28.125 0-28.125-28.125t28.125-28.125"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M877.625 118.25q28.125 0 28.125 28.125v225q0 28.125-28.125 28.125T849.5 371.375v-225q0-28.125 28.125-28.125"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M604.813 458.9 565.1 419.131l292.613-292.668 39.825 39.824z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8c8eae0bed52e0ea = $37aa0bf70ef60230$var$_sfc_main158;
var $37aa0bf70ef60230$var$_sfc_main159 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Management",
    __name: "management",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M576 128v288l96-96 96 96V128h128v768H320V128zm-448 0h128v768H128z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$cbb26d9fbbee6ab2 = $37aa0bf70ef60230$var$_sfc_main159;
var $37aa0bf70ef60230$var$_sfc_main160 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "MapLocation",
    __name: "map-location",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M800 416a288 288 0 1 0-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416M512 960C277.312 746.688 160 565.312 160 416a352 352 0 0 1 704 0c0 149.312-117.312 330.688-352 544"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256m345.6 192L960 960H672v-64H352v64H64l102.4-256zm-68.928 0H235.328l-76.8 192h706.944z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$919cd7230f55bee7 = $37aa0bf70ef60230$var$_sfc_main160;
var $37aa0bf70ef60230$var$_sfc_main161 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Medal",
    __name: "medal",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M576 128H448v200a286.7 286.7 0 0 1 64-8c19.52 0 40.832 2.688 64 8zm64 0v219.648c24.448 9.088 50.56 20.416 78.4 33.92L757.44 128zm-256 0H266.624l39.04 253.568c27.84-13.504 53.888-24.832 78.336-33.92zM229.312 64h565.376a32 32 0 0 1 31.616 36.864L768 480c-113.792-64-199.104-96-256-96s-142.208 32-256 96l-58.304-379.136A32 32 0 0 1 229.312 64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$f75a880bcbff3a85 = $37aa0bf70ef60230$var$_sfc_main161;
var $37aa0bf70ef60230$var$_sfc_main162 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Memo",
    __name: "memo",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 320h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M887.01 72.99C881.01 67 873.34 64 864 64H160c-9.35 0-17.02 3-23.01 8.99C131 78.99 128 86.66 128 96v832c0 9.35 2.99 17.02 8.99 23.01S150.66 960 160 960h704c9.35 0 17.02-2.99 23.01-8.99S896 937.34 896 928V96c0-9.35-3-17.02-8.99-23.01M192 896V128h96v768zm640 0H352V128h480z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 512h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32m0 192h192c21.33 0 32-10.67 32-32s-10.67-32-32-32H480c-21.33 0-32 10.67-32 32s10.67 32 32 32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7897aa7841a5380c = $37aa0bf70ef60230$var$_sfc_main162;
var $37aa0bf70ef60230$var$_sfc_main163 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Menu",
    __name: "menu",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 448a32 32 0 0 1-32-32V160.064a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32V416a32 32 0 0 1-32 32zm448 0a32 32 0 0 1-32-32V160.064a32 32 0 0 1 32-32h255.936a32 32 0 0 1 32 32V416a32 32 0 0 1-32 32zM160 896a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h256a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zm448 0a32 32 0 0 1-32-32V608a32 32 0 0 1 32-32h255.936a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d9b273488cd8ce6f = $37aa0bf70ef60230$var$_sfc_main163;
var $37aa0bf70ef60230$var$_sfc_main164 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "MessageBox",
    __name: "message-box",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M288 384h448v64H288zm96-128h256v64H384zM131.456 512H384v128h256V512h252.544L721.856 192H302.144zM896 576H704v128H320V576H128v256h768zM275.776 128h472.448a32 32 0 0 1 28.608 17.664l179.84 359.552A32 32 0 0 1 960 519.552V864a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V519.552a32 32 0 0 1 3.392-14.336l179.776-359.552A32 32 0 0 1 275.776 128"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$52499e2c5ea4b095 = $37aa0bf70ef60230$var$_sfc_main164;
var $37aa0bf70ef60230$var$_sfc_main165 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Message",
    __name: "message",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 224v512a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V224zm0-64h768a64 64 0 0 1 64 64v512a128 128 0 0 1-128 128H192A128 128 0 0 1 64 736V224a64 64 0 0 1 64-64"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M904 224 656.512 506.88a192 192 0 0 1-289.024 0L120 224zm-698.944 0 210.56 240.704a128 128 0 0 0 192.704 0L818.944 224z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$f69c19e57285b83a = $37aa0bf70ef60230$var$_sfc_main165;
var $37aa0bf70ef60230$var$_sfc_main166 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Mic",
    __name: "mic",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 704h160a64 64 0 0 0 64-64v-32h-96a32 32 0 0 1 0-64h96v-96h-96a32 32 0 0 1 0-64h96v-96h-96a32 32 0 0 1 0-64h96v-32a64 64 0 0 0-64-64H384a64 64 0 0 0-64 64v32h96a32 32 0 0 1 0 64h-96v96h96a32 32 0 0 1 0 64h-96v96h96a32 32 0 0 1 0 64h-96v32a64 64 0 0 0 64 64zm64 64v128h192a32 32 0 1 1 0 64H288a32 32 0 1 1 0-64h192V768h-96a128 128 0 0 1-128-128V192A128 128 0 0 1 384 64h256a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$29d522803b02ca3a = $37aa0bf70ef60230$var$_sfc_main166;
var $37aa0bf70ef60230$var$_sfc_main167 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Microphone",
    __name: "microphone",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 128a128 128 0 0 0-128 128v256a128 128 0 1 0 256 0V256a128 128 0 0 0-128-128m0-64a192 192 0 0 1 192 192v256a192 192 0 1 1-384 0V256A192 192 0 0 1 512 64m-32 832v-64a288 288 0 0 1-288-288v-32a32 32 0 0 1 64 0v32a224 224 0 0 0 224 224h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$df91f3efeb156795 = $37aa0bf70ef60230$var$_sfc_main167;
var $37aa0bf70ef60230$var$_sfc_main168 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "MilkTea",
    __name: "milk-tea",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M416 128V96a96 96 0 0 1 96-96h128a32 32 0 1 1 0 64H512a32 32 0 0 0-32 32v32h320a96 96 0 0 1 11.712 191.296l-39.68 581.056A64 64 0 0 1 708.224 960H315.776a64 64 0 0 1-63.872-59.648l-39.616-581.056A96 96 0 0 1 224 128zM276.48 320l39.296 576h392.448l4.8-70.784a224.064 224.064 0 0 1 30.016-439.808L747.52 320zM224 256h576a32 32 0 1 0 0-64H224a32 32 0 0 0 0 64m493.44 503.872 21.12-309.12a160 160 0 0 0-21.12 309.12"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$89f66d34e05b1171 = $37aa0bf70ef60230$var$_sfc_main168;
var $37aa0bf70ef60230$var$_sfc_main169 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Minus",
    __name: "minus",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 544h768a32 32 0 1 0 0-64H128a32 32 0 0 0 0 64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$da45d96ed490d127 = $37aa0bf70ef60230$var$_sfc_main169;
var $37aa0bf70ef60230$var$_sfc_main170 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Money",
    __name: "money",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 640v192h640V384H768v-64h150.976c14.272 0 19.456 1.472 24.64 4.288a29.06 29.06 0 0 1 12.16 12.096c2.752 5.184 4.224 10.368 4.224 24.64v493.952c0 14.272-1.472 19.456-4.288 24.64a29.06 29.06 0 0 1-12.096 12.16c-5.184 2.752-10.368 4.224-24.64 4.224H233.024c-14.272 0-19.456-1.472-24.64-4.288a29.06 29.06 0 0 1-12.16-12.096c-2.688-5.184-4.224-10.368-4.224-24.576V640z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M768 192H128v448h640zm64-22.976v493.952c0 14.272-1.472 19.456-4.288 24.64a29.06 29.06 0 0 1-12.096 12.16c-5.184 2.752-10.368 4.224-24.64 4.224H105.024c-14.272 0-19.456-1.472-24.64-4.288a29.06 29.06 0 0 1-12.16-12.096C65.536 682.432 64 677.248 64 663.04V169.024c0-14.272 1.472-19.456 4.288-24.64a29.06 29.06 0 0 1 12.096-12.16C85.568 129.536 90.752 128 104.96 128h685.952c14.272 0 19.456 1.472 24.64 4.288a29.06 29.06 0 0 1 12.16 12.096c2.752 5.184 4.224 10.368 4.224 24.64z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M448 576a160 160 0 1 1 0-320 160 160 0 0 1 0 320m0-64a96 96 0 1 0 0-192 96 96 0 0 0 0 192"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d26bcf891bc220f6 = $37aa0bf70ef60230$var$_sfc_main170;
var $37aa0bf70ef60230$var$_sfc_main171 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Monitor",
    __name: "monitor",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 768v128h192a32 32 0 1 1 0 64H288a32 32 0 1 1 0-64h192V768H192A128 128 0 0 1 64 640V256a128 128 0 0 1 128-128h640a128 128 0 0 1 128 128v384a128 128 0 0 1-128 128zM192 192a64 64 0 0 0-64 64v384a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$3de16b9a4e4a99f4 = $37aa0bf70ef60230$var$_sfc_main171;
var $37aa0bf70ef60230$var$_sfc_main172 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "MoonNight",
    __name: "moon-night",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 512a448 448 0 0 1 215.872-383.296A384 384 0 0 0 213.76 640h188.8A448.3 448.3 0 0 1 384 512M171.136 704a448 448 0 0 1 636.992-575.296A384 384 0 0 0 499.328 704h-328.32z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M32 640h960q32 0 32 32t-32 32H32q-32 0-32-32t32-32m128 128h384a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m160 127.68 224 .256a32 32 0 0 1 32 32V928a32 32 0 0 1-32 32l-224-.384a32 32 0 0 1-32-32v-.064a32 32 0 0 1 32-32z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c03de3443cb26e1 = $37aa0bf70ef60230$var$_sfc_main172;
var $37aa0bf70ef60230$var$_sfc_main173 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Moon",
    __name: "moon",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M240.448 240.448a384 384 0 1 0 559.424 525.696 448 448 0 0 1-542.016-542.08 391 391 0 0 0-17.408 16.384m181.056 362.048a384 384 0 0 0 525.632 16.384A448 448 0 1 1 405.056 76.8a384 384 0 0 0 16.448 525.696"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ab2e8fc3a68054ee = $37aa0bf70ef60230$var$_sfc_main173;
var $37aa0bf70ef60230$var$_sfc_main174 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "MoreFilled",
    __name: "more-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M176 416a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224m336 0a112 112 0 1 1 0 224 112 112 0 0 1 0-224"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$53e4dbce1155d264 = $37aa0bf70ef60230$var$_sfc_main174;
var $37aa0bf70ef60230$var$_sfc_main175 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "More",
    __name: "more",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M176 416a112 112 0 1 0 0 224 112 112 0 0 0 0-224m0 64a48 48 0 1 1 0 96 48 48 0 0 1 0-96m336-64a112 112 0 1 1 0 224 112 112 0 0 1 0-224m0 64a48 48 0 1 0 0 96 48 48 0 0 0 0-96m336-64a112 112 0 1 1 0 224 112 112 0 0 1 0-224m0 64a48 48 0 1 0 0 96 48 48 0 0 0 0-96"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d440bfe209149ca5 = $37aa0bf70ef60230$var$_sfc_main175;
var $37aa0bf70ef60230$var$_sfc_main176 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "MostlyCloudy",
    __name: "mostly-cloudy",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M737.216 357.952 704 349.824l-11.776-32a192.064 192.064 0 0 0-367.424 23.04l-8.96 39.04-39.04 8.96A192.064 192.064 0 0 0 320 768h368a207.81 207.81 0 0 0 207.808-208 208.32 208.32 0 0 0-158.592-202.048m15.168-62.208A272.32 272.32 0 0 1 959.744 560a271.81 271.81 0 0 1-271.552 272H320a256 256 0 0 1-57.536-505.536 256.128 256.128 0 0 1 489.92-30.72"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$bff4dd01af0fb097 = $37aa0bf70ef60230$var$_sfc_main176;
var $37aa0bf70ef60230$var$_sfc_main177 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Mouse",
    __name: "mouse",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M438.144 256c-68.352 0-92.736 4.672-117.76 18.112q-30.144 16.128-46.272 46.272C260.672 345.408 256 369.792 256 438.144v275.712c0 68.352 4.672 92.736 18.112 117.76q16.128 30.144 46.272 46.272C345.408 891.328 369.792 896 438.144 896h147.712c68.352 0 92.736-4.672 117.76-18.112q30.144-16.128 46.272-46.272C763.328 806.592 768 782.208 768 713.856V438.144c0-68.352-4.672-92.736-18.112-117.76a110.46 110.46 0 0 0-46.272-46.272C678.592 260.672 654.208 256 585.856 256zm0-64h147.712c85.568 0 116.608 8.96 147.904 25.6 31.36 16.768 55.872 41.344 72.576 72.64C823.104 321.536 832 352.576 832 438.08v275.84c0 85.504-8.96 116.544-25.6 147.84a174.46 174.46 0 0 1-72.64 72.576C702.464 951.104 671.424 960 585.92 960H438.08c-85.504 0-116.544-8.96-147.84-25.6a174.46 174.46 0 0 1-72.64-72.704c-16.768-31.296-25.664-62.336-25.664-147.84v-275.84c0-85.504 8.96-116.544 25.6-147.84a174.46 174.46 0 0 1 72.768-72.576c31.232-16.704 62.272-25.6 147.776-25.6z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 320q32 0 32 32v128q0 32-32 32t-32-32V352q0-32 32-32m32-96a32 32 0 0 1-64 0v-64a32 32 0 0 0-32-32h-96a32 32 0 0 1 0-64h96a96 96 0 0 1 96 96z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7caecd373b84cec3 = $37aa0bf70ef60230$var$_sfc_main177;
var $37aa0bf70ef60230$var$_sfc_main178 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Mug",
    __name: "mug",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M736 800V160H160v640a64 64 0 0 0 64 64h448a64 64 0 0 0 64-64m64-544h63.552a96 96 0 0 1 96 96v224a96 96 0 0 1-96 96H800v128a128 128 0 0 1-128 128H224A128 128 0 0 1 96 800V128a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 64v288h63.552a32 32 0 0 0 32-32V352a32 32 0 0 0-32-32z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ffd1adf89252c96b = $37aa0bf70ef60230$var$_sfc_main178;
var $37aa0bf70ef60230$var$_sfc_main179 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "MuteNotification",
    __name: "mute-notification",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m241.216 832 63.616-64H768V448c0-42.368-10.24-82.304-28.48-117.504l46.912-47.232C815.36 331.392 832 387.84 832 448v320h96a32 32 0 1 1 0 64zm-90.24 0H96a32 32 0 1 1 0-64h96V448a320.13 320.13 0 0 1 256-313.6V128a64 64 0 1 1 128 0v6.4a319.55 319.55 0 0 1 171.648 97.088l-45.184 45.44A256 256 0 0 0 256 448v278.336L151.04 832zM448 896h128a64 64 0 0 1-128 0"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M150.72 859.072a32 32 0 0 1-45.44-45.056l704-708.544a32 32 0 0 1 45.44 45.056z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$cb63dd3f92c2873f = $37aa0bf70ef60230$var$_sfc_main179;
var $37aa0bf70ef60230$var$_sfc_main180 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Mute",
    __name: "mute",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m412.16 592.128-45.44 45.44A191.23 191.23 0 0 1 320 512V256a192 192 0 1 1 384 0v44.352l-64 64V256a128 128 0 1 0-256 0v256c0 30.336 10.56 58.24 28.16 80.128m51.968 38.592A128 128 0 0 0 640 512v-57.152l64-64V512a192 192 0 0 1-287.68 166.528zM314.88 779.968l46.144-46.08A223 223 0 0 0 480 768h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64h64v-64c-61.44 0-118.4-19.2-165.12-52.032M266.752 737.6A286.98 286.98 0 0 1 192 544v-32a32 32 0 0 1 64 0v32c0 56.832 21.184 108.8 56.064 148.288z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M150.72 859.072a32 32 0 0 1-45.44-45.056l704-708.544a32 32 0 0 1 45.44 45.056z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1243038cbae7dd2b = $37aa0bf70ef60230$var$_sfc_main180;
var $37aa0bf70ef60230$var$_sfc_main181 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "NoSmoking",
    __name: "no-smoking",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M440.256 576H256v128h56.256l-64 64H224a32 32 0 0 1-32-32V544a32 32 0 0 1 32-32h280.256zm143.488 128H704V583.744L775.744 512H928a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H519.744zM768 576v128h128V576zm-29.696-207.552 45.248 45.248-497.856 497.856-45.248-45.248zM256 64h64v320h-64zM128 192h64v192h-64zM64 512h64v256H64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c55348c395070dd0 = $37aa0bf70ef60230$var$_sfc_main181;
var $37aa0bf70ef60230$var$_sfc_main182 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Notebook",
    __name: "notebook",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 128v768h640V128zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M672 128h64v768h-64zM96 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32m0 192h128q32 0 32 32t-32 32H96q-32 0-32-32t32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$9d9b3a199c5437eb = $37aa0bf70ef60230$var$_sfc_main182;
var $37aa0bf70ef60230$var$_sfc_main183 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Notification",
    __name: "notification",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 128v64H256a64 64 0 0 0-64 64v512a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V512h64v256a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V256a128 128 0 0 1 128-128z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M768 384a128 128 0 1 0 0-256 128 128 0 0 0 0 256m0 64a192 192 0 1 1 0-384 192 192 0 0 1 0 384"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$14834abbfce3b8cd = $37aa0bf70ef60230$var$_sfc_main183;
var $37aa0bf70ef60230$var$_sfc_main184 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Odometer",
    __name: "odometer",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 512a320 320 0 1 1 640 0 32 32 0 1 1-64 0 256 256 0 1 0-512 0 32 32 0 0 1-64 0"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M570.432 627.84A96 96 0 1 1 509.568 608l60.992-187.776A32 32 0 1 1 631.424 440l-60.992 187.776zM502.08 734.464a32 32 0 1 0 19.84-60.928 32 32 0 0 0-19.84 60.928"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c6c5382a7d099975 = $37aa0bf70ef60230$var$_sfc_main184;
var $37aa0bf70ef60230$var$_sfc_main185 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "OfficeBuilding",
    __name: "office-building",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 128v704h384V128zm-32-64h448a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 256h256v64H256zm0 192h256v64H256zm0 192h256v64H256zm384-128h128v64H640zm0 128h128v64H640zM64 832h896v64H64z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M640 384v448h192V384zm-32-64h256a32 32 0 0 1 32 32v512a32 32 0 0 1-32 32H608a32 32 0 0 1-32-32V352a32 32 0 0 1 32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a8de711f30b8b9b8 = $37aa0bf70ef60230$var$_sfc_main185;
var $37aa0bf70ef60230$var$_sfc_main186 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Open",
    __name: "open",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M329.956 257.138a254.862 254.862 0 0 0 0 509.724h364.088a254.862 254.862 0 0 0 0-509.724zm0-72.818h364.088a327.68 327.68 0 1 1 0 655.36H329.956a327.68 327.68 0 1 1 0-655.36"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M694.044 621.227a109.227 109.227 0 1 0 0-218.454 109.227 109.227 0 0 0 0 218.454m0 72.817a182.044 182.044 0 1 1 0-364.088 182.044 182.044 0 0 1 0 364.088"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$779aeef03935e9f3 = $37aa0bf70ef60230$var$_sfc_main186;
var $37aa0bf70ef60230$var$_sfc_main187 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Operation",
    __name: "operation",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M389.44 768a96.064 96.064 0 0 1 181.12 0H896v64H570.56a96.064 96.064 0 0 1-181.12 0H128v-64zm192-288a96.064 96.064 0 0 1 181.12 0H896v64H762.56a96.064 96.064 0 0 1-181.12 0H128v-64zm-320-288a96.064 96.064 0 0 1 181.12 0H896v64H442.56a96.064 96.064 0 0 1-181.12 0H128v-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ab5aad00225c5662 = $37aa0bf70ef60230$var$_sfc_main187;
var $37aa0bf70ef60230$var$_sfc_main188 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Opportunity",
    __name: "opportunity",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 960v-64h192.064v64zm448-544a350.66 350.66 0 0 1-128.32 271.424C665.344 719.04 640 763.776 640 813.504V832H320v-14.336c0-48-19.392-95.36-57.216-124.992a351.55 351.55 0 0 1-128.448-344.256c25.344-136.448 133.888-248.128 269.76-276.48A352.384 352.384 0 0 1 832 416m-544 32c0-132.288 75.904-224 192-224v-64c-154.432 0-256 122.752-256 288z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$3fe8175078dc4e4f = $37aa0bf70ef60230$var$_sfc_main188;
var $37aa0bf70ef60230$var$_sfc_main189 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Orange",
    __name: "orange",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 894.72a382.34 382.34 0 0 0 215.936-89.472L577.024 622.272c-10.24 6.016-21.248 10.688-33.024 13.696v258.688zm261.248-134.784A382.34 382.34 0 0 0 894.656 544H635.968c-3.008 11.776-7.68 22.848-13.696 33.024zM894.656 480a382.34 382.34 0 0 0-89.408-215.936L622.272 446.976c6.016 10.24 10.688 21.248 13.696 33.024zm-134.72-261.248A382.34 382.34 0 0 0 544 129.344v258.688c11.776 3.008 22.848 7.68 33.024 13.696zM480 129.344a382.34 382.34 0 0 0-215.936 89.408l182.912 182.976c10.24-6.016 21.248-10.688 33.024-13.696zm-261.248 134.72A382.34 382.34 0 0 0 129.344 480h258.688c3.008-11.776 7.68-22.848 13.696-33.024zM129.344 544a382.34 382.34 0 0 0 89.408 215.936l182.976-182.912A127.2 127.2 0 0 1 388.032 544zm134.72 261.248A382.34 382.34 0 0 0 480 894.656V635.968a127.2 127.2 0 0 1-33.024-13.696zM512 960a448 448 0 1 1 0-896 448 448 0 0 1 0 896m0-384a64 64 0 1 0 0-128 64 64 0 0 0 0 128"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a8e2843f0fe527f4 = $37aa0bf70ef60230$var$_sfc_main189;
var $37aa0bf70ef60230$var$_sfc_main190 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Paperclip",
    __name: "paperclip",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M602.496 240.448A192 192 0 1 1 874.048 512l-316.8 316.8A256 256 0 0 1 195.2 466.752L602.496 59.456l45.248 45.248L240.448 512A192 192 0 0 0 512 783.552l316.8-316.8a128 128 0 1 0-181.056-181.056L353.6 579.904a32 32 0 1 0 45.248 45.248l294.144-294.144 45.312 45.248L444.096 670.4a96 96 0 1 1-135.744-135.744z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$83b4e98970744671 = $37aa0bf70ef60230$var$_sfc_main190;
var $37aa0bf70ef60230$var$_sfc_main191 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "PartlyCloudy",
    __name: "partly-cloudy",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M598.4 895.872H328.192a256 256 0 0 1-34.496-510.528A352 352 0 1 1 598.4 895.872m-271.36-64h272.256a288 288 0 1 0-248.512-417.664L335.04 445.44l-34.816 3.584a192 192 0 0 0 26.88 382.848z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M139.84 501.888a256 256 0 1 1 417.856-277.12c-17.728 2.176-38.208 8.448-61.504 18.816A192 192 0 1 0 189.12 460.48a6004 6004 0 0 0-49.28 41.408"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$916e1129960876bf = $37aa0bf70ef60230$var$_sfc_main191;
var $37aa0bf70ef60230$var$_sfc_main192 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Pear",
    __name: "pear",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M542.336 258.816a443 443 0 0 0-9.024 25.088 32 32 0 1 1-60.8-20.032l1.088-3.328a162.69 162.69 0 0 0-122.048 131.392l-17.088 102.72-20.736 15.36C256.192 552.704 224 610.88 224 672c0 120.576 126.4 224 288 224s288-103.424 288-224c0-61.12-32.192-119.296-89.728-161.92l-20.736-15.424-17.088-102.72a162.69 162.69 0 0 0-130.112-133.12m-40.128-66.56c7.936-15.552 16.576-30.08 25.92-43.776 23.296-33.92 49.408-59.776 78.528-77.12a32 32 0 1 1 32.704 55.04c-20.544 12.224-40.064 31.552-58.432 58.304a317 317 0 0 0-9.792 15.104 226.69 226.69 0 0 1 164.48 181.568l12.8 77.248C819.456 511.36 864 587.392 864 672c0 159.04-157.568 288-352 288S160 831.04 160 672c0-84.608 44.608-160.64 115.584-213.376l12.8-77.248a226.624 226.624 0 0 1 213.76-189.184z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e80ca3cf16f79f38 = $37aa0bf70ef60230$var$_sfc_main192;
var $37aa0bf70ef60230$var$_sfc_main193 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "PhoneFilled",
    __name: "phone-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M199.232 125.568 90.624 379.008a32 32 0 0 0 6.784 35.2l512.384 512.384a32 32 0 0 0 35.2 6.784l253.44-108.608a32 32 0 0 0 10.048-52.032L769.6 633.92a32 32 0 0 0-36.928-5.952l-130.176 65.088-271.488-271.552 65.024-130.176a32 32 0 0 0-5.952-36.928L251.2 115.52a32 32 0 0 0-51.968 10.048"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2de862feea185790 = $37aa0bf70ef60230$var$_sfc_main193;
var $37aa0bf70ef60230$var$_sfc_main194 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Phone",
    __name: "phone",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M79.36 432.256 591.744 944.64a32 32 0 0 0 35.2 6.784l253.44-108.544a32 32 0 0 0 9.984-52.032l-153.856-153.92a32 32 0 0 0-36.928-6.016l-69.888 34.944L358.08 394.24l35.008-69.888a32 32 0 0 0-5.952-36.928L233.152 133.568a32 32 0 0 0-52.032 10.048L72.512 397.056a32 32 0 0 0 6.784 35.2zm60.48-29.952 81.536-190.08L325.568 316.48l-24.64 49.216-20.608 41.216 32.576 32.64 271.552 271.552 32.64 32.64 41.216-20.672 49.28-24.576 104.192 104.128-190.08 81.472zM512 320v-64a256 256 0 0 1 256 256h-64a192 192 0 0 0-192-192m0-192V64a448 448 0 0 1 448 448h-64a384 384 0 0 0-384-384"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2de540f0cd7c073a = $37aa0bf70ef60230$var$_sfc_main194;
var $37aa0bf70ef60230$var$_sfc_main195 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "PictureFilled",
    __name: "picture-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M96 896a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32h832a32 32 0 0 1 32 32v704a32 32 0 0 1-32 32zm315.52-228.48-68.928-68.928a32 32 0 0 0-45.248 0L128 768.064h778.688l-242.112-290.56a32 32 0 0 0-49.216 0L458.752 665.408a32 32 0 0 1-47.232 2.112M256 384a96 96 0 1 0 192.064-.064A96 96 0 0 0 256 384"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$399c7bf2478a7c6 = $37aa0bf70ef60230$var$_sfc_main195;
var $37aa0bf70ef60230$var$_sfc_main196 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "PictureRounded",
    __name: "picture-rounded",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768m0-64a448 448 0 1 1 0 896 448 448 0 0 1 0-896"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M640 288q64 0 64 64t-64 64-64-64 64-64M214.656 790.656l-45.312-45.312 185.664-185.6a96 96 0 0 1 123.712-10.24l138.24 98.688a32 32 0 0 0 39.872-2.176L906.688 422.4l42.624 47.744L699.52 693.696a96 96 0 0 1-119.808 6.592l-138.24-98.752a32 32 0 0 0-41.152 3.456l-185.664 185.6z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ebc307b11894495d = $37aa0bf70ef60230$var$_sfc_main196;
var $37aa0bf70ef60230$var$_sfc_main197 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Picture",
    __name: "picture",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 160v704h704V160zm-32-64h768a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H128a32 32 0 0 1-32-32V128a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 288q64 0 64 64t-64 64-64-64 64-64M185.408 876.992l-50.816-38.912L350.72 556.032a96 96 0 0 1 134.592-17.856l1.856 1.472 122.88 99.136a32 32 0 0 0 44.992-4.864l216-269.888 49.92 39.936-215.808 269.824-.256.32a96 96 0 0 1-135.04 14.464l-122.88-99.072-.64-.512a32 32 0 0 0-44.8 5.952z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$f0d5dc2ce3e4cb5f = $37aa0bf70ef60230$var$_sfc_main197;
var $37aa0bf70ef60230$var$_sfc_main198 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "PieChart",
    __name: "pie-chart",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M448 68.48v64.832A384.128 384.128 0 0 0 512 896a384.13 384.13 0 0 0 378.688-320h64.768A448.128 448.128 0 0 1 64 512 448.13 448.13 0 0 1 448 68.48"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M576 97.28V448h350.72A384.064 384.064 0 0 0 576 97.28M512 64V33.152A448 448 0 0 1 990.848 512H512z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$b99d3348f709c998 = $37aa0bf70ef60230$var$_sfc_main198;
var $37aa0bf70ef60230$var$_sfc_main199 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Place",
    __name: "place",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 512a32 32 0 0 1 32 32v256a32 32 0 1 1-64 0V544a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 649.088v64.96C269.76 732.352 192 771.904 192 800c0 37.696 139.904 96 320 96s320-58.304 320-96c0-28.16-77.76-67.648-192-85.952v-64.96C789.12 671.04 896 730.368 896 800c0 88.32-171.904 160-384 160s-384-71.68-384-160c0-69.696 106.88-128.96 256-150.912"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2f77e7adfbeab348 = $37aa0bf70ef60230$var$_sfc_main199;
var $37aa0bf70ef60230$var$_sfc_main200 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Platform",
    __name: "platform",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M448 832v-64h128v64h192v64H256v-64zM128 704V128h768v576z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2dffd0b5373a4389 = $37aa0bf70ef60230$var$_sfc_main200;
var $37aa0bf70ef60230$var$_sfc_main201 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Plus",
    __name: "plus",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 480V128a32 32 0 0 1 64 0v352h352a32 32 0 1 1 0 64H544v352a32 32 0 1 1-64 0V544H128a32 32 0 0 1 0-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2d9ac7aa84f97a08 = $37aa0bf70ef60230$var$_sfc_main201;
var $37aa0bf70ef60230$var$_sfc_main202 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Pointer",
    __name: "pointer",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M511.552 128c-35.584 0-64.384 28.8-64.384 64.448v516.48L274.048 570.88a94.27 94.27 0 0 0-112.896-3.456 44.416 44.416 0 0 0-8.96 62.208L332.8 870.4A64 64 0 0 0 384 896h512V575.232a64 64 0 0 0-45.632-61.312l-205.952-61.76A96 96 0 0 1 576 360.192V192.448C576 156.8 547.2 128 511.552 128M359.04 556.8l24.128 19.2V192.448a128.448 128.448 0 1 1 256.832 0v167.744a32 32 0 0 0 22.784 30.656l206.016 61.76A128 128 0 0 1 960 575.232V896a64 64 0 0 1-64 64H384a128 128 0 0 1-102.4-51.2L101.056 668.032A108.416 108.416 0 0 1 128 512.512a158.27 158.27 0 0 1 185.984 8.32z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$b56007f12edf0c17 = $37aa0bf70ef60230$var$_sfc_main202;
var $37aa0bf70ef60230$var$_sfc_main203 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Position",
    __name: "position",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m249.6 417.088 319.744 43.072 39.168 310.272L845.12 178.88zm-129.024 47.168a32 32 0 0 1-7.68-61.44l777.792-311.04a32 32 0 0 1 41.6 41.6l-310.336 775.68a32 32 0 0 1-61.44-7.808L512 516.992z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$13807d9ee5a34a42 = $37aa0bf70ef60230$var$_sfc_main203;
var $37aa0bf70ef60230$var$_sfc_main204 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Postcard",
    __name: "postcard",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 224a32 32 0 0 0-32 32v512a32 32 0 0 0 32 32h704a32 32 0 0 0 32-32V256a32 32 0 0 0-32-32zm0-64h704a96 96 0 0 1 96 96v512a96 96 0 0 1-96 96H160a96 96 0 0 1-96-96V256a96 96 0 0 1 96-96"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 320a64 64 0 1 1 0 128 64 64 0 0 1 0-128M288 448h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32m0 128h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8e3ca95a02132541 = $37aa0bf70ef60230$var$_sfc_main204;
var $37aa0bf70ef60230$var$_sfc_main205 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Pouring",
    __name: "pouring",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m739.328 291.328-35.2-6.592-12.8-33.408a192.064 192.064 0 0 0-365.952 23.232l-9.92 40.896-41.472 7.04a176.32 176.32 0 0 0-146.24 173.568c0 97.28 78.72 175.936 175.808 175.936h400a192 192 0 0 0 35.776-380.672M959.552 480a256 256 0 0 1-256 256h-400A239.81 239.81 0 0 1 63.744 496.192a240.32 240.32 0 0 1 199.488-236.8 256.128 256.128 0 0 1 487.872-30.976A256.064 256.064 0 0 1 959.552 480M224 800a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32m192 0a32 32 0 0 1 32 32v96a32 32 0 1 1-64 0v-96a32 32 0 0 1 32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2dab1f487a009c6a = $37aa0bf70ef60230$var$_sfc_main205;
var $37aa0bf70ef60230$var$_sfc_main206 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Present",
    __name: "present",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 896V640H192v-64h288V320H192v576zm64 0h288V320H544v256h288v64H544zM128 256h768v672a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M96 256h832q32 0 32 32t-32 32H96q-32 0-32-32t32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M416 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M608 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1e32f3df6c8d60db = $37aa0bf70ef60230$var$_sfc_main206;
var $37aa0bf70ef60230$var$_sfc_main207 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "PriceTag",
    __name: "price-tag",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M224 318.336V896h576V318.336L552.512 115.84a64 64 0 0 0-81.024 0zM593.024 66.304l259.2 212.096A32 32 0 0 1 864 303.168V928a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V303.168a32 32 0 0 1 11.712-24.768l259.2-212.096a128 128 0 0 1 162.112 0"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 448a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e3515f09c6268e0d = $37aa0bf70ef60230$var$_sfc_main207;
var $37aa0bf70ef60230$var$_sfc_main208 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Printer",
    __name: "printer",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 768H105.024c-14.272 0-19.456-1.472-24.64-4.288a29.06 29.06 0 0 1-12.16-12.096C65.536 746.432 64 741.248 64 727.04V379.072c0-42.816 4.48-58.304 12.8-73.984 8.384-15.616 20.672-27.904 36.288-36.288 15.68-8.32 31.168-12.8 73.984-12.8H256V64h512v192h68.928c42.816 0 58.304 4.48 73.984 12.8 15.616 8.384 27.904 20.672 36.288 36.288 8.32 15.68 12.8 31.168 12.8 73.984v347.904c0 14.272-1.472 19.456-4.288 24.64a29.06 29.06 0 0 1-12.096 12.16c-5.184 2.752-10.368 4.224-24.64 4.224H768v192H256zm64-192v320h384V576zm-64 128V512h512v192h128V379.072c0-29.376-1.408-36.48-5.248-43.776a23.3 23.3 0 0 0-10.048-10.048c-7.232-3.84-14.4-5.248-43.776-5.248H187.072c-29.376 0-36.48 1.408-43.776 5.248a23.3 23.3 0 0 0-10.048 10.048c-3.84 7.232-5.248 14.4-5.248 43.776V704zm64-448h384V128H320zm-64 128h64v64h-64zm128 0h64v64h-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ff97ddd7b62e4930 = $37aa0bf70ef60230$var$_sfc_main208;
var $37aa0bf70ef60230$var$_sfc_main209 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Promotion",
    __name: "promotion",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m64 448 832-320-128 704-446.08-243.328L832 192 242.816 545.472zm256 512V657.024L512 768z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2b8020cba8e4d3e3 = $37aa0bf70ef60230$var$_sfc_main209;
var $37aa0bf70ef60230$var$_sfc_main210 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "QuartzWatch",
    __name: "quartz-watch",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M422.02 602.01v-.03c-6.68-5.99-14.35-8.83-23.01-8.51q-13.005.48-22.5 10.02c-6.33 6.36-9.5 13.7-9.5 22.02s3 15.82 8.99 22.5c8.68 8.68 19.02 11.35 31.01 8s19.49-10.85 22.5-22.5.51-22.15-7.49-31.49zM384 512c0-9.35-3-17.02-8.99-23.01-6-5.99-13.66-8.99-23.01-8.99s-17.02 3-23.01 8.99c-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.66 8.99 23.01 8.99s17.02-3 23.01-8.99c5.99-6 8.99-13.67 8.99-23.01m6.53-82.49c11.65 3.01 22.15.51 31.49-7.49h.04c5.99-6.68 8.83-14.34 8.51-23.01s-3.66-16.16-10.02-22.5c-6.36-6.33-13.7-9.5-22.02-9.5s-15.82 3-22.5 8.99c-8.68 8.69-11.35 19.02-8 31.01q5.025 17.985 22.5 22.5m242.94 0q17.505-4.545 22.02-22.02c3.01-11.65.51-22.15-7.49-31.49h.01c-6.68-5.99-14.18-8.99-22.5-8.99s-15.66 3.16-22.02 9.5q-9.54 9.51-10.02 22.5c-.32 8.66 2.52 16.33 8.51 23.01 9.32 8.02 19.82 10.52 31.49 7.49M512 640c-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.67 8.99 23.01 8.99 9.35 0 17.02-3 23.01-8.99 5.99-6 8.99-13.66 8.99-23.01s-3-17.02-8.99-23.01c-6-5.99-13.66-8.99-23.01-8.99m183.01-151.01c-6-5.99-13.66-8.99-23.01-8.99s-17.02 3-23.01 8.99c-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.66 8.99 23.01 8.99s17.02-3 23.01-8.99c5.99-6 8.99-13.67 8.99-23.01 0-9.35-3-17.02-8.99-23.01"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M832 512c-2-90.67-33.17-166.17-93.5-226.5-20.43-20.42-42.6-37.49-66.5-51.23V64H352v170.26c-23.9 13.74-46.07 30.81-66.5 51.24-60.33 60.33-91.49 135.83-93.5 226.5 2 90.67 33.17 166.17 93.5 226.5 20.43 20.43 42.6 37.5 66.5 51.24V960h320V789.74c23.9-13.74 46.07-30.81 66.5-51.24 60.33-60.34 91.49-135.83 93.5-226.5M416 128h192v78.69c-29.85-9.03-61.85-13.93-96-14.69-34.15.75-66.15 5.65-96 14.68zm192 768H416v-78.68c29.85 9.03 61.85 13.93 96 14.68 34.15-.75 66.15-5.65 96-14.68zm-96-128c-72.66-2.01-132.99-27.01-180.99-75.01S258.01 584.66 256 512c2.01-72.66 27.01-132.99 75.01-180.99S439.34 258.01 512 256c72.66 2.01 132.99 27.01 180.99 75.01S765.99 439.34 768 512c-2.01 72.66-27.01 132.99-75.01 180.99S584.66 765.99 512 768"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 320c-9.35 0-17.02 3-23.01 8.99-5.99 6-8.99 13.66-8.99 23.01s3 17.02 8.99 23.01c6 5.99 13.67 8.99 23.01 8.99 9.35 0 17.02-3 23.01-8.99 5.99-6 8.99-13.66 8.99-23.01s-3-17.02-8.99-23.01c-6-5.99-13.66-8.99-23.01-8.99m112.99 273.5c-8.66-.32-16.33 2.52-23.01 8.51-7.98 9.32-10.48 19.82-7.49 31.49s10.49 19.17 22.5 22.5 22.35.66 31.01-8v.04c5.99-6.68 8.99-14.18 8.99-22.5s-3.16-15.66-9.5-22.02-13.84-9.7-22.5-10.02"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$154e11a078ce31b1 = $37aa0bf70ef60230$var$_sfc_main210;
var $37aa0bf70ef60230$var$_sfc_main211 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "QuestionFilled",
    __name: "question-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m23.744 191.488c-52.096 0-92.928 14.784-123.2 44.352-30.976 29.568-45.76 70.4-45.76 122.496h80.256c0-29.568 5.632-52.8 17.6-68.992 13.376-19.712 35.2-28.864 66.176-28.864 23.936 0 42.944 6.336 56.32 19.712 12.672 13.376 19.712 31.68 19.712 54.912 0 17.6-6.336 34.496-19.008 49.984l-8.448 9.856c-45.76 40.832-73.216 70.4-82.368 89.408-9.856 19.008-14.08 42.24-14.08 68.992v9.856h80.96v-9.856c0-16.896 3.52-31.68 10.56-45.76 6.336-12.672 15.488-24.64 28.16-35.2 33.792-29.568 54.208-48.576 60.544-55.616 16.896-22.528 26.048-51.392 26.048-86.592q0-64.416-42.24-101.376c-28.16-25.344-65.472-37.312-111.232-37.312m-12.672 406.208a54.27 54.27 0 0 0-38.72 14.784 49.4 49.4 0 0 0-15.488 38.016c0 15.488 4.928 28.16 15.488 38.016A54.85 54.85 0 0 0 523.072 768c15.488 0 28.16-4.928 38.72-14.784a51.52 51.52 0 0 0 16.192-38.72 51.97 51.97 0 0 0-15.488-38.016 55.94 55.94 0 0 0-39.424-14.784"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$506e04add06ac68b = $37aa0bf70ef60230$var$_sfc_main211;
var $37aa0bf70ef60230$var$_sfc_main212 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Rank",
    __name: "rank",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m186.496 544 41.408 41.344a32 32 0 1 1-45.248 45.312l-96-96a32 32 0 0 1 0-45.312l96-96a32 32 0 1 1 45.248 45.312L186.496 480h290.816V186.432l-41.472 41.472a32 32 0 1 1-45.248-45.184l96-96.128a32 32 0 0 1 45.312 0l96 96.064a32 32 0 0 1-45.248 45.184l-41.344-41.28V480H832l-41.344-41.344a32 32 0 0 1 45.248-45.312l96 96a32 32 0 0 1 0 45.312l-96 96a32 32 0 0 1-45.248-45.312L832 544H541.312v293.44l41.344-41.28a32 32 0 1 1 45.248 45.248l-96 96a32 32 0 0 1-45.312 0l-96-96a32 32 0 1 1 45.312-45.248l41.408 41.408V544z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c36edca8f8f0427a = $37aa0bf70ef60230$var$_sfc_main212;
var $37aa0bf70ef60230$var$_sfc_main213 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ReadingLamp",
    __name: "reading-lamp",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M352 896h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m-44.672-768-99.52 448h608.384l-99.52-448zm-25.6-64h460.608a32 32 0 0 1 31.232 25.088l113.792 512A32 32 0 0 1 856.128 640H167.872a32 32 0 0 1-31.232-38.912l113.792-512A32 32 0 0 1 281.664 64z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M672 576q32 0 32 32v128q0 32-32 32t-32-32V608q0-32 32-32m-192-.064h64V960h-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$cd1d22c36a1f2df8 = $37aa0bf70ef60230$var$_sfc_main213;
var $37aa0bf70ef60230$var$_sfc_main214 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Reading",
    __name: "reading",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m512 863.36 384-54.848v-638.72L525.568 222.72a96 96 0 0 1-27.136 0L128 169.792v638.72zM137.024 106.432l370.432 52.928a32 32 0 0 0 9.088 0l370.432-52.928A64 64 0 0 1 960 169.792v638.72a64 64 0 0 1-54.976 63.36l-388.48 55.488a32 32 0 0 1-9.088 0l-388.48-55.488A64 64 0 0 1 64 808.512v-638.72a64 64 0 0 1 73.024-63.36"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 192h64v704h-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$db3ca10f31d94bff = $37aa0bf70ef60230$var$_sfc_main214;
var $37aa0bf70ef60230$var$_sfc_main215 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "RefreshLeft",
    __name: "refresh-left",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M289.088 296.704h92.992a32 32 0 0 1 0 64H232.96a32 32 0 0 1-32-32V179.712a32 32 0 0 1 64 0v50.56a384 384 0 0 1 643.84 282.88 384 384 0 0 1-383.936 384 384 384 0 0 1-384-384h64a320 320 0 1 0 640 0 320 320 0 0 0-555.712-216.448z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$508e83cbbc160028 = $37aa0bf70ef60230$var$_sfc_main215;
var $37aa0bf70ef60230$var$_sfc_main216 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "RefreshRight",
    __name: "refresh-right",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M784.512 230.272v-50.56a32 32 0 1 1 64 0v149.056a32 32 0 0 1-32 32H667.52a32 32 0 1 1 0-64h92.992A320 320 0 1 0 524.8 833.152a320 320 0 0 0 320-320h64a384 384 0 0 1-384 384 384 384 0 0 1-384-384 384 384 0 0 1 643.712-282.88"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$f036638f43d00a3c = $37aa0bf70ef60230$var$_sfc_main216;
var $37aa0bf70ef60230$var$_sfc_main217 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Refresh",
    __name: "refresh",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M771.776 794.88A384 384 0 0 1 128 512h64a320 320 0 0 0 555.712 216.448H654.72a32 32 0 1 1 0-64h149.056a32 32 0 0 1 32 32v148.928a32 32 0 1 1-64 0v-50.56zM276.288 295.616h92.992a32 32 0 0 1 0 64H220.16a32 32 0 0 1-32-32V178.56a32 32 0 0 1 64 0v50.56A384 384 0 0 1 896.128 512h-64a320 320 0 0 0-555.776-216.384z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$f93ec6528f706bfe = $37aa0bf70ef60230$var$_sfc_main217;
var $37aa0bf70ef60230$var$_sfc_main218 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Refrigerator",
    __name: "refrigerator",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 448h512V160a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32zm0 64v352a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V512zm32-448h448a96 96 0 0 1 96 96v704a96 96 0 0 1-96 96H288a96 96 0 0 1-96-96V160a96 96 0 0 1 96-96m32 224h64v96h-64zm0 288h64v96h-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8e377804f23c0758 = $37aa0bf70ef60230$var$_sfc_main218;
var $37aa0bf70ef60230$var$_sfc_main219 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "RemoveFilled",
    __name: "remove-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896M288 512a38.4 38.4 0 0 0 38.4 38.4h371.2a38.4 38.4 0 0 0 0-76.8H326.4A38.4 38.4 0 0 0 288 512"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d3f9a00c6f34ae91 = $37aa0bf70ef60230$var$_sfc_main219;
var $37aa0bf70ef60230$var$_sfc_main220 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Remove",
    __name: "remove",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M352 480h320a32 32 0 1 1 0 64H352a32 32 0 0 1 0-64"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6072865765515195 = $37aa0bf70ef60230$var$_sfc_main220;
var $37aa0bf70ef60230$var$_sfc_main221 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Right",
    __name: "right",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M754.752 480H160a32 32 0 1 0 0 64h594.752L521.344 777.344a32 32 0 0 0 45.312 45.312l288-288a32 32 0 0 0 0-45.312l-288-288a32 32 0 1 0-45.312 45.312z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$19db0165690c701a = $37aa0bf70ef60230$var$_sfc_main221;
var $37aa0bf70ef60230$var$_sfc_main222 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ScaleToOriginal",
    __name: "scale-to-original",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M813.176 180.706a60.235 60.235 0 0 1 60.236 60.235v481.883a60.235 60.235 0 0 1-60.236 60.235H210.824a60.235 60.235 0 0 1-60.236-60.235V240.94a60.235 60.235 0 0 1 60.236-60.235h602.352zm0-60.235H210.824A120.47 120.47 0 0 0 90.353 240.94v481.883a120.47 120.47 0 0 0 120.47 120.47h602.353a120.47 120.47 0 0 0 120.471-120.47V240.94a120.47 120.47 0 0 0-120.47-120.47zm-120.47 180.705a30.12 30.12 0 0 0-30.118 30.118v301.177a30.118 30.118 0 0 0 60.236 0V331.294a30.12 30.12 0 0 0-30.118-30.118m-361.412 0a30.12 30.12 0 0 0-30.118 30.118v301.177a30.118 30.118 0 1 0 60.236 0V331.294a30.12 30.12 0 0 0-30.118-30.118M512 361.412a30.12 30.12 0 0 0-30.118 30.117v30.118a30.118 30.118 0 0 0 60.236 0V391.53A30.12 30.12 0 0 0 512 361.412M512 512a30.12 30.12 0 0 0-30.118 30.118v30.117a30.118 30.118 0 0 0 60.236 0v-30.117A30.12 30.12 0 0 0 512 512"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ea550ac48bb84963 = $37aa0bf70ef60230$var$_sfc_main222;
var $37aa0bf70ef60230$var$_sfc_main223 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "School",
    __name: "school",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M224 128v704h576V128zm-32-64h640a32 32 0 0 1 32 32v768a32 32 0 0 1-32 32H192a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M64 832h896v64H64zm256-640h128v96H320z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 832h256v-64a128 128 0 1 0-256 0zm128-256a192 192 0 0 1 192 192v128H320V768a192 192 0 0 1 192-192M320 384h128v96H320zm256-192h128v96H576zm0 192h128v96H576z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6a7037f95d336c89 = $37aa0bf70ef60230$var$_sfc_main223;
var $37aa0bf70ef60230$var$_sfc_main224 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Scissor",
    __name: "scissor",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m512.064 578.368-106.88 152.768a160 160 0 1 1-23.36-78.208L472.96 522.56 196.864 128.256a32 32 0 1 1 52.48-36.736l393.024 561.344a160 160 0 1 1-23.36 78.208l-106.88-152.704zm54.4-189.248 208.384-297.6a32 32 0 0 1 52.48 36.736l-221.76 316.672-39.04-55.808zm-376.32 425.856a96 96 0 1 0 110.144-157.248 96 96 0 0 0-110.08 157.248zm643.84 0a96 96 0 1 0-110.08-157.248 96 96 0 0 0 110.08 157.248"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$333aff27de68d687 = $37aa0bf70ef60230$var$_sfc_main224;
var $37aa0bf70ef60230$var$_sfc_main225 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Search",
    __name: "search",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4b85d3515bd863a5 = $37aa0bf70ef60230$var$_sfc_main225;
var $37aa0bf70ef60230$var$_sfc_main226 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Select",
    __name: "select",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M77.248 415.04a64 64 0 0 1 90.496 0l226.304 226.304L846.528 188.8a64 64 0 1 1 90.56 90.496l-543.04 543.04-316.8-316.8a64 64 0 0 1 0-90.496"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ef9b1a59e592288f = $37aa0bf70ef60230$var$_sfc_main226;
var $37aa0bf70ef60230$var$_sfc_main227 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Sell",
    __name: "sell",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 288h131.072a32 32 0 0 1 31.808 28.8L886.4 512h-64.384l-16-160H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0v-96H217.92l-51.2 512H512v64H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4zm-64 0v-22.336C640 189.248 582.272 128 512 128s-128 61.248-128 137.664v22.4h256zm201.408 483.84L768 698.496V928a32 32 0 1 1-64 0V698.496l-73.344 73.344a32 32 0 1 1-45.248-45.248l128-128a32 32 0 0 1 45.248 0l128 128a32 32 0 1 1-45.248 45.248"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7f377ffdc4bc2316 = $37aa0bf70ef60230$var$_sfc_main227;
var $37aa0bf70ef60230$var$_sfc_main228 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "SemiSelect",
    __name: "semi-select",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 448h768q64 0 64 64t-64 64H128q-64 0-64-64t64-64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c2d0dd76d405538a = $37aa0bf70ef60230$var$_sfc_main228;
var $37aa0bf70ef60230$var$_sfc_main229 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Service",
    __name: "service",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M864 409.6a192 192 0 0 1-37.888 349.44A256.064 256.064 0 0 1 576 960h-96a32 32 0 1 1 0-64h96a192.06 192.06 0 0 0 181.12-128H736a32 32 0 0 1-32-32V416a32 32 0 0 1 32-32h32c10.368 0 20.544.832 30.528 2.432a288 288 0 0 0-573.056 0A193 193 0 0 1 256 384h32a32 32 0 0 1 32 32v320a32 32 0 0 1-32 32h-32a192 192 0 0 1-96-358.4 352 352 0 0 1 704 0M256 448a128 128 0 1 0 0 256zm640 128a128 128 0 0 0-128-128v256a128 128 0 0 0 128-128"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8b2af884909d32a5 = $37aa0bf70ef60230$var$_sfc_main229;
var $37aa0bf70ef60230$var$_sfc_main230 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "SetUp",
    __name: "set-up",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M224 160a64 64 0 0 0-64 64v576a64 64 0 0 0 64 64h576a64 64 0 0 0 64-64V224a64 64 0 0 0-64-64zm0-64h576a128 128 0 0 1 128 128v576a128 128 0 0 1-128 128H224A128 128 0 0 1 96 800V224A128 128 0 0 1 224 96"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 320h256q32 0 32 32t-32 32H480q-32 0-32-32t32-32m160 416a64 64 0 1 0 0-128 64 64 0 0 0 0 128m0 64a128 128 0 1 1 0-256 128 128 0 0 1 0 256"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M288 640h256q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$294bc1fa66ad6b28 = $37aa0bf70ef60230$var$_sfc_main230;
var $37aa0bf70ef60230$var$_sfc_main231 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Setting",
    __name: "setting",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M600.704 64a32 32 0 0 1 30.464 22.208l35.2 109.376c14.784 7.232 28.928 15.36 42.432 24.512l112.384-24.192a32 32 0 0 1 34.432 15.36L944.32 364.8a32 32 0 0 1-4.032 37.504l-77.12 85.12a357 357 0 0 1 0 49.024l77.12 85.248a32 32 0 0 1 4.032 37.504l-88.704 153.6a32 32 0 0 1-34.432 15.296L708.8 803.904c-13.44 9.088-27.648 17.28-42.368 24.512l-35.264 109.376A32 32 0 0 1 600.704 960H423.296a32 32 0 0 1-30.464-22.208L357.696 828.48a352 352 0 0 1-42.56-24.64l-112.32 24.256a32 32 0 0 1-34.432-15.36L79.68 659.2a32 32 0 0 1 4.032-37.504l77.12-85.248a357 357 0 0 1 0-48.896l-77.12-85.248A32 32 0 0 1 79.68 364.8l88.704-153.6a32 32 0 0 1 34.432-15.296l112.32 24.256c13.568-9.152 27.776-17.408 42.56-24.64l35.2-109.312A32 32 0 0 1 423.232 64H600.64zm-23.424 64H446.72l-36.352 113.088-24.512 11.968a294 294 0 0 0-34.816 20.096l-22.656 15.36-116.224-25.088-65.28 113.152 79.68 88.192-1.92 27.136a293 293 0 0 0 0 40.192l1.92 27.136-79.808 88.192 65.344 113.152 116.224-25.024 22.656 15.296a294 294 0 0 0 34.816 20.096l24.512 11.968L446.72 896h130.688l36.48-113.152 24.448-11.904a288 288 0 0 0 34.752-20.096l22.592-15.296 116.288 25.024 65.28-113.152-79.744-88.192 1.92-27.136a293 293 0 0 0 0-40.256l-1.92-27.136 79.808-88.128-65.344-113.152-116.288 24.96-22.592-15.232a288 288 0 0 0-34.752-20.096l-24.448-11.904L577.344 128zM512 320a192 192 0 1 1 0 384 192 192 0 0 1 0-384m0 64a128 128 0 1 0 0 256 128 128 0 0 0 0-256"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$805dc0bee9369f09 = $37aa0bf70ef60230$var$_sfc_main231;
var $37aa0bf70ef60230$var$_sfc_main232 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Share",
    __name: "share",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m679.872 348.8-301.76 188.608a127.8 127.8 0 0 1 5.12 52.16l279.936 104.96a128 128 0 1 1-22.464 59.904l-279.872-104.96a128 128 0 1 1-16.64-166.272l301.696-188.608a128 128 0 1 1 33.92 54.272z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c9915453de10000b = $37aa0bf70ef60230$var$_sfc_main232;
var $37aa0bf70ef60230$var$_sfc_main233 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Ship",
    __name: "ship",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 386.88V448h405.568a32 32 0 0 1 30.72 40.768l-76.48 267.968A192 192 0 0 1 687.168 896H336.832a192 192 0 0 1-184.64-139.264L75.648 488.768A32 32 0 0 1 106.368 448H448V117.888a32 32 0 0 1 47.36-28.096l13.888 7.616L512 96v2.88l231.68 126.4a32 32 0 0 1-2.048 57.216zm0-70.272 144.768-65.792L512 171.84zM512 512H148.864l18.24 64H856.96l18.24-64zM185.408 640l28.352 99.2A128 128 0 0 0 336.832 832h350.336a128 128 0 0 0 123.072-92.8l28.352-99.2z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7930c61d9b464618 = $37aa0bf70ef60230$var$_sfc_main233;
var $37aa0bf70ef60230$var$_sfc_main234 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Shop",
    __name: "shop",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 704h64v192H256V704h64v64h384zm188.544-152.192C894.528 559.616 896 567.616 896 576a96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0 96 96 0 1 1-192 0c0-8.384 1.408-16.384 3.392-24.192L192 128h640z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$aa82d568fb2f38da = $37aa0bf70ef60230$var$_sfc_main234;
var $37aa0bf70ef60230$var$_sfc_main235 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ShoppingBag",
    __name: "shopping-bag",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 320v96a32 32 0 0 1-32 32h-32V320H384v128h-32a32 32 0 0 1-32-32v-96H192v576h640V320zm-384-64a192 192 0 1 1 384 0h160a32 32 0 0 1 32 32v640a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32zm64 0h256a128 128 0 1 0-256 0"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 704h640v64H192z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$acda254a1ccd05c3 = $37aa0bf70ef60230$var$_sfc_main235;
var $37aa0bf70ef60230$var$_sfc_main236 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ShoppingCartFull",
    __name: "shopping-cart-full",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M432 928a48 48 0 1 1 0-96 48 48 0 0 1 0 96m320 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96M96 128a32 32 0 0 1 0-64h160a32 32 0 0 1 31.36 25.728L320.64 256H928a32 32 0 0 1 31.296 38.72l-96 448A32 32 0 0 1 832 768H384a32 32 0 0 1-31.36-25.728L229.76 128zm314.24 576h395.904l82.304-384H333.44z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M699.648 256 608 145.984 516.352 256zm-140.8-151.04a64 64 0 0 1 98.304 0L836.352 320H379.648z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6c4e55ac8e5f0524 = $37aa0bf70ef60230$var$_sfc_main236;
var $37aa0bf70ef60230$var$_sfc_main237 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ShoppingCart",
    __name: "shopping-cart",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M432 928a48 48 0 1 1 0-96 48 48 0 0 1 0 96m320 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96M96 128a32 32 0 0 1 0-64h160a32 32 0 0 1 31.36 25.728L320.64 256H928a32 32 0 0 1 31.296 38.72l-96 448A32 32 0 0 1 832 768H384a32 32 0 0 1-31.36-25.728L229.76 128zm314.24 576h395.904l82.304-384H333.44z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$b09d44dc9283a8f5 = $37aa0bf70ef60230$var$_sfc_main237;
var $37aa0bf70ef60230$var$_sfc_main238 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ShoppingTrolley",
    __name: "shopping-trolley",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M368 833c-13.3 0-24.5 4.5-33.5 13.5S321 866.7 321 880s4.5 24.5 13.5 33.5 20.2 13.8 33.5 14.5c13.3-.7 24.5-5.5 33.5-14.5S415 893.3 415 880s-4.5-24.5-13.5-33.5S381.3 833 368 833m439-193c7.4 0 13.8-2.2 19.5-6.5S836 623.3 838 616l112-448c2-10-.2-19.2-6.5-27.5S929 128 919 128H96c-9.3 0-17 3-23 9s-9 13.7-9 23 3 17 9 23 13.7 9 23 9h96v576h672c9.3 0 17-3 23-9s9-13.7 9-23-3-17-9-23-13.7-9-23-9H256v-64zM256 192h622l-96 384H256zm432 641c-13.3 0-24.5 4.5-33.5 13.5S641 866.7 641 880s4.5 24.5 13.5 33.5 20.2 13.8 33.5 14.5c13.3-.7 24.5-5.5 33.5-14.5S735 893.3 735 880s-4.5-24.5-13.5-33.5S701.3 833 688 833"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$bd223116fa4ade9f = $37aa0bf70ef60230$var$_sfc_main238;
var $37aa0bf70ef60230$var$_sfc_main239 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Smoking",
    __name: "smoking",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 576v128h640V576zm-32-64h704a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H224a32 32 0 0 1-32-32V544a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 576h64v128h-64zM256 64h64v320h-64zM128 192h64v192h-64zM64 512h64v256H64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$f456cf8572a068cb = $37aa0bf70ef60230$var$_sfc_main239;
var $37aa0bf70ef60230$var$_sfc_main240 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Soccer",
    __name: "soccer",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M418.496 871.04 152.256 604.8c-16.512 94.016-2.368 178.624 42.944 224 44.928 44.928 129.344 58.752 223.296 42.24m72.32-18.176a573.06 573.06 0 0 0 224.832-137.216 573.1 573.1 0 0 0 137.216-224.832L533.888 171.84a578.56 578.56 0 0 0-227.52 138.496A567.7 567.7 0 0 0 170.432 532.48zM871.04 418.496c16.512-93.952 2.688-178.368-42.24-223.296-44.544-44.544-128.704-58.048-222.592-41.536zM149.952 874.048c-112.96-112.96-88.832-408.96 111.168-608.96C461.056 65.152 760.96 36.928 874.048 149.952c113.024 113.024 86.784 411.008-113.152 610.944s-497.92 226.112-610.944 113.152m452.544-497.792 22.656-22.656a32 32 0 0 1 45.248 45.248l-22.656 22.656 45.248 45.248A32 32 0 1 1 647.744 512l-45.248-45.248L557.248 512l45.248 45.248a32 32 0 1 1-45.248 45.248L512 557.248l-45.248 45.248L512 647.744a32 32 0 1 1-45.248 45.248l-45.248-45.248-22.656 22.656a32 32 0 1 1-45.248-45.248l22.656-22.656-45.248-45.248A32 32 0 1 1 376.256 512l45.248 45.248L466.752 512l-45.248-45.248a32 32 0 1 1 45.248-45.248L512 466.752l45.248-45.248L512 376.256a32 32 0 0 1 45.248-45.248z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$94517f2240d79aef = $37aa0bf70ef60230$var$_sfc_main240;
var $37aa0bf70ef60230$var$_sfc_main241 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "SoldOut",
    __name: "sold-out",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 288h131.072a32 32 0 0 1 31.808 28.8L886.4 512h-64.384l-16-160H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0v-96H217.92l-51.2 512H512v64H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4zm-64 0v-22.336C640 189.248 582.272 128 512 128s-128 61.248-128 137.664v22.4h256zm201.408 476.16a32 32 0 1 1 45.248 45.184l-128 128a32 32 0 0 1-45.248 0l-128-128a32 32 0 1 1 45.248-45.248L704 837.504V608a32 32 0 1 1 64 0v229.504l73.408-73.408z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$55aa795759f227b9 = $37aa0bf70ef60230$var$_sfc_main241;
var $37aa0bf70ef60230$var$_sfc_main242 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "SortDown",
    __name: "sort-down",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M576 96v709.568L333.312 562.816A32 32 0 1 0 288 608l297.408 297.344A32 32 0 0 0 640 882.688V96a32 32 0 0 0-64 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$7289022845b706f2 = $37aa0bf70ef60230$var$_sfc_main242;
var $37aa0bf70ef60230$var$_sfc_main243 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "SortUp",
    __name: "sort-up",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 141.248V928a32 32 0 1 0 64 0V218.56l242.688 242.688A32 32 0 1 0 736 416L438.592 118.656A32 32 0 0 0 384 141.248"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$610129a4e97e5826 = $37aa0bf70ef60230$var$_sfc_main243;
var $37aa0bf70ef60230$var$_sfc_main244 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Sort",
    __name: "sort",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 96a32 32 0 0 1 64 0v786.752a32 32 0 0 1-54.592 22.656L95.936 608a32 32 0 0 1 0-45.312h.128a32 32 0 0 1 45.184 0L384 805.632zm192 45.248a32 32 0 0 1 54.592-22.592L928.064 416a32 32 0 0 1 0 45.312h-.128a32 32 0 0 1-45.184 0L640 218.496V928a32 32 0 1 1-64 0z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d43f91ac58cde147 = $37aa0bf70ef60230$var$_sfc_main244;
var $37aa0bf70ef60230$var$_sfc_main245 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Stamp",
    __name: "stamp",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M624 475.968V640h144a128 128 0 0 1 128 128H128a128 128 0 0 1 128-128h144V475.968a192 192 0 1 1 224 0M128 896v-64h768v64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8897676213252052 = $37aa0bf70ef60230$var$_sfc_main245;
var $37aa0bf70ef60230$var$_sfc_main246 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "StarFilled",
    __name: "star-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M313.6 924.48a70.4 70.4 0 0 1-74.152-5.365 70.4 70.4 0 0 1-27.992-68.875l37.888-220.928L88.96 472.96a70.4 70.4 0 0 1 3.788-104.225A70.4 70.4 0 0 1 128 352.896l221.76-32.256 99.2-200.96a70.4 70.4 0 0 1 100.246-28.595 70.4 70.4 0 0 1 25.962 28.595l99.2 200.96 221.824 32.256a70.4 70.4 0 0 1 39.04 120.064L774.72 629.376l37.888 220.928a70.4 70.4 0 0 1-102.144 74.24L512 820.096l-198.4 104.32z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$5c83eb0ad220f681 = $37aa0bf70ef60230$var$_sfc_main246;
var $37aa0bf70ef60230$var$_sfc_main247 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Star",
    __name: "star",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m512 747.84 228.16 119.936a6.4 6.4 0 0 0 9.28-6.72l-43.52-254.08 184.512-179.904a6.4 6.4 0 0 0-3.52-10.88l-255.104-37.12L517.76 147.904a6.4 6.4 0 0 0-11.52 0L392.192 379.072l-255.104 37.12a6.4 6.4 0 0 0-3.52 10.88L318.08 606.976l-43.584 254.08a6.4 6.4 0 0 0 9.28 6.72zM313.6 924.48a70.4 70.4 0 0 1-102.144-74.24l37.888-220.928L88.96 472.96A70.4 70.4 0 0 1 128 352.896l221.76-32.256 99.2-200.96a70.4 70.4 0 0 1 126.208 0l99.2 200.96 221.824 32.256a70.4 70.4 0 0 1 39.04 120.064L774.72 629.376l37.888 220.928a70.4 70.4 0 0 1-102.144 74.24L512 820.096l-198.4 104.32z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1644ba17714857f1 = $37aa0bf70ef60230$var$_sfc_main247;
var $37aa0bf70ef60230$var$_sfc_main248 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Stopwatch",
    __name: "stopwatch",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M672 234.88c-39.168 174.464-80 298.624-122.688 372.48-64 110.848-202.624 30.848-138.624-80C453.376 453.44 540.48 355.968 672 234.816z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e16de4ea1abb52c8 = $37aa0bf70ef60230$var$_sfc_main248;
var $37aa0bf70ef60230$var$_sfc_main249 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "SuccessFilled",
    __name: "success-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.27 38.27 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$11c077e7878a3c8c = $37aa0bf70ef60230$var$_sfc_main249;
var $37aa0bf70ef60230$var$_sfc_main250 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Sugar",
    __name: "sugar",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m801.728 349.184 4.48 4.48a128 128 0 0 1 0 180.992L534.656 806.144a128 128 0 0 1-181.056 0l-4.48-4.48-19.392 109.696a64 64 0 0 1-108.288 34.176L78.464 802.56a64 64 0 0 1 34.176-108.288l109.76-19.328-4.544-4.544a128 128 0 0 1 0-181.056l271.488-271.488a128 128 0 0 1 181.056 0l4.48 4.48 19.392-109.504a64 64 0 0 1 108.352-34.048l142.592 143.04a64 64 0 0 1-34.24 108.16zm-548.8 198.72h447.168v2.24l60.8-60.8a63.8 63.8 0 0 0 18.752-44.416h-426.88l-89.664 89.728a64 64 0 0 0-10.24 13.248zm0 64q4.128 7.104 10.176 13.248l135.744 135.744a64 64 0 0 0 90.496 0L638.4 611.904zm490.048-230.976L625.152 263.104a64 64 0 0 0-90.496 0L416.768 380.928zM123.712 757.312l142.976 142.976 24.32-137.6a25.6 25.6 0 0 0-29.696-29.632zm633.6-633.344-24.32 137.472a25.6 25.6 0 0 0 29.632 29.632l137.28-24.064-142.656-143.04z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$cfeb173db0b5a0a7 = $37aa0bf70ef60230$var$_sfc_main250;
var $37aa0bf70ef60230$var$_sfc_main251 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "SuitcaseLine",
    __name: "suitcase-line",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M922.5 229.5c-24.32-24.34-54.49-36.84-90.5-37.5H704v-64c-.68-17.98-7.02-32.98-19.01-44.99S658.01 64.66 640 64H384c-17.98.68-32.98 7.02-44.99 19.01S320.66 110 320 128v64H192c-35.99.68-66.16 13.18-90.5 37.5S64.66 283.99 64 320v448c.68 35.99 13.18 66.16 37.5 90.5s54.49 36.84 90.5 37.5h640c35.99-.68 66.16-13.18 90.5-37.5s36.84-54.49 37.5-90.5V320c-.68-35.99-13.18-66.16-37.5-90.5M384 128h256v64H384zM256 832h-64c-17.98-.68-32.98-7.02-44.99-19.01S128.66 786.01 128 768V448h128zm448 0H320V448h384zm192-64c-.68 17.98-7.02 32.98-19.01 44.99S850.01 831.34 832 832h-64V448h128zm0-384H128v-64c.69-17.98 7.02-32.98 19.01-44.99S173.99 256.66 192 256h640c17.98.69 32.98 7.02 44.99 19.01S895.34 301.99 896 320z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$802a895f6af33550 = $37aa0bf70ef60230$var$_sfc_main251;
var $37aa0bf70ef60230$var$_sfc_main252 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Suitcase",
    __name: "suitcase",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 384h768v-64a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64zm0 64v320a64 64 0 0 0 64 64h640a64 64 0 0 0 64-64V448zm64-256h640a128 128 0 0 1 128 128v448a128 128 0 0 1-128 128H192A128 128 0 0 1 64 768V320a128 128 0 0 1 128-128"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M384 128v64h256v-64zm0-64h256a64 64 0 0 1 64 64v64a64 64 0 0 1-64 64H384a64 64 0 0 1-64-64v-64a64 64 0 0 1 64-64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$90b57c730448f610 = $37aa0bf70ef60230$var$_sfc_main252;
var $37aa0bf70ef60230$var$_sfc_main253 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Sunny",
    __name: "sunny",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 704a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m0-704a32 32 0 0 1 32 32v64a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 768a32 32 0 0 1 32 32v64a32 32 0 1 1-64 0v-64a32 32 0 0 1 32-32M195.2 195.2a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 1 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248m543.104 543.104a32 32 0 0 1 45.248 0l45.248 45.248a32 32 0 0 1-45.248 45.248l-45.248-45.248a32 32 0 0 1 0-45.248M64 512a32 32 0 0 1 32-32h64a32 32 0 0 1 0 64H96a32 32 0 0 1-32-32m768 0a32 32 0 0 1 32-32h64a32 32 0 1 1 0 64h-64a32 32 0 0 1-32-32M195.2 828.8a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248L240.448 828.8a32 32 0 0 1-45.248 0m543.104-543.104a32 32 0 0 1 0-45.248l45.248-45.248a32 32 0 0 1 45.248 45.248l-45.248 45.248a32 32 0 0 1-45.248 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$811be11460bfa9e7 = $37aa0bf70ef60230$var$_sfc_main253;
var $37aa0bf70ef60230$var$_sfc_main254 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Sunrise",
    __name: "sunrise",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M32 768h960a32 32 0 1 1 0 64H32a32 32 0 1 1 0-64m129.408-96a352 352 0 0 1 701.184 0h-64.32a288 288 0 0 0-572.544 0zM512 128a32 32 0 0 1 32 32v96a32 32 0 0 1-64 0v-96a32 32 0 0 1 32-32m407.296 168.704a32 32 0 0 1 0 45.248l-67.84 67.84a32 32 0 1 1-45.248-45.248l67.84-67.84a32 32 0 0 1 45.248 0m-814.592 0a32 32 0 0 1 45.248 0l67.84 67.84a32 32 0 1 1-45.248 45.248l-67.84-67.84a32 32 0 0 1 0-45.248"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$bf182411798a7d0d = $37aa0bf70ef60230$var$_sfc_main254;
var $37aa0bf70ef60230$var$_sfc_main255 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Sunset",
    __name: "sunset",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M82.56 640a448 448 0 1 1 858.88 0h-67.2a384 384 0 1 0-724.288 0zM32 704h960q32 0 32 32t-32 32H32q-32 0-32-32t32-32m256 128h448q32 0 32 32t-32 32H288q-32 0-32-32t32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c13a2587b9dce428 = $37aa0bf70ef60230$var$_sfc_main255;
var $37aa0bf70ef60230$var$_sfc_main256 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "SwitchButton",
    __name: "switch-button",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M352 159.872V230.4a352 352 0 1 0 320 0v-70.528A416.128 416.128 0 0 1 512 960a416 416 0 0 1-160-800.128"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64q32 0 32 32v320q0 32-32 32t-32-32V96q0-32 32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$72111f742dee7cb8 = $37aa0bf70ef60230$var$_sfc_main256;
var $37aa0bf70ef60230$var$_sfc_main257 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "SwitchFilled",
    __name: "switch-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M247.47 358.4v.04c.07 19.17 7.72 37.53 21.27 51.09s31.92 21.2 51.09 21.27c39.86 0 72.41-32.6 72.41-72.4s-32.6-72.36-72.41-72.36-72.36 32.55-72.36 72.36"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M492.38 128H324.7c-52.16 0-102.19 20.73-139.08 57.61a196.66 196.66 0 0 0-57.61 139.08V698.7c-.01 25.84 5.08 51.42 14.96 75.29s24.36 45.56 42.63 63.83 39.95 32.76 63.82 42.65a196.7 196.7 0 0 0 75.28 14.98h167.68c3.03 0 5.46-2.43 5.46-5.42V133.42c.6-2.99-1.83-5.42-5.46-5.42m-56.11 705.88H324.7c-17.76.13-35.36-3.33-51.75-10.18s-31.22-16.94-43.61-29.67c-25.3-25.35-39.81-59.1-39.81-95.32V324.69c-.13-17.75 3.33-35.35 10.17-51.74a131.7 131.7 0 0 1 29.64-43.62c25.39-25.3 59.14-39.81 95.36-39.81h111.57zm402.12-647.67a196.66 196.66 0 0 0-139.08-57.61H580.48c-3.03 0-4.82 2.43-4.82 4.82v757.16c-.6 2.99 1.79 5.42 5.42 5.42h118.23a196.7 196.7 0 0 0 139.08-57.61A196.66 196.66 0 0 0 896 699.31V325.29a196.7 196.7 0 0 0-57.61-139.08m-111.3 441.92c-42.83 0-77.82-34.99-77.82-77.82s34.98-77.82 77.82-77.82c42.83 0 77.82 34.99 77.82 77.82s-34.99 77.82-77.82 77.82"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$5a22ab0dc9c088b8 = $37aa0bf70ef60230$var$_sfc_main257;
var $37aa0bf70ef60230$var$_sfc_main258 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Switch",
    __name: "switch",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M118.656 438.656a32 32 0 0 1 0-45.248L416 96l4.48-3.776A32 32 0 0 1 461.248 96l3.712 4.48a32.064 32.064 0 0 1-3.712 40.832L218.56 384H928a32 32 0 1 1 0 64H141.248a32 32 0 0 1-22.592-9.344M64 608a32 32 0 0 1 32-32h786.752a32 32 0 0 1 22.656 54.592L608 928l-4.48 3.776a32.064 32.064 0 0 1-40.832-49.024L805.632 640H96a32 32 0 0 1-32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$b5d5cf8927ab7262 = $37aa0bf70ef60230$var$_sfc_main258;
var $37aa0bf70ef60230$var$_sfc_main259 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "TakeawayBox",
    __name: "takeaway-box",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M832 384H192v448h640zM96 320h832V128H96zm800 64v480a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V384H64a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h896a32 32 0 0 1 32 32v256a32 32 0 0 1-32 32zM416 512h192a32 32 0 0 1 0 64H416a32 32 0 0 1 0-64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$8123ffdb4b1dc068 = $37aa0bf70ef60230$var$_sfc_main259;
var $37aa0bf70ef60230$var$_sfc_main260 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Ticket",
    __name: "ticket",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M640 832H64V640a128 128 0 1 0 0-256V192h576v160h64V192h256v192a128 128 0 1 0 0 256v192H704V672h-64zm0-416v192h64V416z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$ed207b05bbcf0a37 = $37aa0bf70ef60230$var$_sfc_main260;
var $37aa0bf70ef60230$var$_sfc_main261 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Tickets",
    __name: "tickets",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M192 128v768h640V128zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m160 448h384v64H320zm0-192h192v64H320zm0 384h384v64H320z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c75ecad2a9923481 = $37aa0bf70ef60230$var$_sfc_main261;
var $37aa0bf70ef60230$var$_sfc_main262 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Timer",
    __name: "timer",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 896a320 320 0 1 0 0-640 320 320 0 0 0 0 640m0 64a384 384 0 1 1 0-768 384 384 0 0 1 0 768"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 320a32 32 0 0 1 32 32l-.512 224a32 32 0 1 1-64 0L480 352a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M448 576a64 64 0 1 0 128 0 64 64 0 1 0-128 0m96-448v128h-64V128h-96a32 32 0 0 1 0-64h256a32 32 0 1 1 0 64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c57e9b2d8b9e4de = $37aa0bf70ef60230$var$_sfc_main262;
var $37aa0bf70ef60230$var$_sfc_main263 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ToiletPaper",
    __name: "toilet-paper",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M595.2 128H320a192 192 0 0 0-192 192v576h384V352c0-90.496 32.448-171.2 83.2-224M736 64c123.712 0 224 128.96 224 288S859.712 640 736 640H576v320H64V320A256 256 0 0 1 320 64zM576 352v224h160c84.352 0 160-97.28 160-224s-75.648-224-160-224-160 97.28-160 224"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M736 448c-35.328 0-64-43.008-64-96s28.672-96 64-96 64 43.008 64 96-28.672 96-64 96"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$93e9571cb71342e7 = $37aa0bf70ef60230$var$_sfc_main263;
var $37aa0bf70ef60230$var$_sfc_main264 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Tools",
    __name: "tools",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M764.416 254.72a351.7 351.7 0 0 1 86.336 149.184H960v192.064H850.752a351.7 351.7 0 0 1-86.336 149.312l54.72 94.72-166.272 96-54.592-94.72a352.64 352.64 0 0 1-172.48 0L371.136 936l-166.272-96 54.72-94.72a351.7 351.7 0 0 1-86.336-149.312H64v-192h109.248a351.7 351.7 0 0 1 86.336-149.312L204.8 160l166.208-96h.192l54.656 94.592a352.64 352.64 0 0 1 172.48 0L652.8 64h.128L819.2 160l-54.72 94.72zM704 499.968a192 192 0 1 0-384 0 192 192 0 0 0 384 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$390d11d353c16e49 = $37aa0bf70ef60230$var$_sfc_main264;
var $37aa0bf70ef60230$var$_sfc_main265 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "TopLeft",
    __name: "top-left",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M256 256h416a32 32 0 1 0 0-64H224a32 32 0 0 0-32 32v448a32 32 0 0 0 64 0z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M246.656 201.344a32 32 0 0 0-45.312 45.312l544 544a32 32 0 0 0 45.312-45.312z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$5234821464421cc8 = $37aa0bf70ef60230$var$_sfc_main265;
var $37aa0bf70ef60230$var$_sfc_main266 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "TopRight",
    __name: "top-right",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M768 256H353.6a32 32 0 1 1 0-64H800a32 32 0 0 1 32 32v448a32 32 0 0 1-64 0z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M777.344 201.344a32 32 0 0 1 45.312 45.312l-544 544a32 32 0 0 1-45.312-45.312z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6d2b4f20362e6b19 = $37aa0bf70ef60230$var$_sfc_main266;
var $37aa0bf70ef60230$var$_sfc_main267 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Top",
    __name: "top",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M572.235 205.282v600.365a30.118 30.118 0 1 1-60.235 0V205.282L292.382 438.633a28.913 28.913 0 0 1-42.646 0 33.43 33.43 0 0 1 0-45.236l271.058-288.045a28.913 28.913 0 0 1 42.647 0L834.5 393.397a33.43 33.43 0 0 1 0 45.176 28.913 28.913 0 0 1-42.647 0l-219.618-233.23z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$b5738e83c092973d = $37aa0bf70ef60230$var$_sfc_main267;
var $37aa0bf70ef60230$var$_sfc_main268 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "TrendCharts",
    __name: "trend-charts",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 896V128h768v768zm291.712-327.296 128 102.4 180.16-201.792-47.744-42.624-139.84 156.608-128-102.4-180.16 201.792 47.744 42.624zM816 352a48 48 0 1 0-96 0 48 48 0 0 0 96 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2e64f038594ace80 = $37aa0bf70ef60230$var$_sfc_main268;
var $37aa0bf70ef60230$var$_sfc_main269 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "TrophyBase",
    __name: "trophy-base",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M918.4 201.6c-6.4-6.4-12.8-9.6-22.4-9.6H768V96c0-9.6-3.2-16-9.6-22.4S745.6 64 736 64H288c-9.6 0-16 3.2-22.4 9.6S256 86.4 256 96v96H128c-9.6 0-16 3.2-22.4 9.6S96 217.6 96 224c3.2 108.8 25.6 185.6 64 224 34.4 34.4 77.56 55.65 127.65 61.99 10.91 20.44 24.78 39.25 41.95 56.41 40.86 40.86 91 65.47 150.4 71.9V768h-96c-9.6 0-16 3.2-22.4 9.6S352 790.4 352 800s3.2 16 9.6 22.4 12.8 9.6 22.4 9.6h256c9.6 0 16-3.2 22.4-9.6s9.6-12.8 9.6-22.4-3.2-16-9.6-22.4-12.8-9.6-22.4-9.6h-96V637.26c59.4-7.71 109.54-30.01 150.4-70.86 17.2-17.2 31.51-36.06 42.81-56.55 48.93-6.51 90.02-27.7 126.79-61.85 38.4-38.4 60.8-112 64-224 0-6.4-3.2-16-9.6-22.4M256 438.4c-19.2-6.4-35.2-19.2-51.2-35.2-22.4-22.4-35.2-70.4-41.6-147.2H256zm390.4 80C608 553.6 566.4 576 512 576s-99.2-19.2-134.4-57.6S320 438.4 320 384V128h384v256q0 81.6-57.6 134.4m172.8-115.2c-16 16-32 25.6-51.2 35.2V256h92.8c-6.4 76.8-19.2 124.8-41.6 147.2M768 896H256c-9.6 0-16 3.2-22.4 9.6S224 918.4 224 928s3.2 16 9.6 22.4 12.8 9.6 22.4 9.6h512c9.6 0 16-3.2 22.4-9.6s9.6-12.8 9.6-22.4-3.2-16-9.6-22.4-12.8-9.6-22.4-9.6"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a9fd7566c997b845 = $37aa0bf70ef60230$var$_sfc_main269;
var $37aa0bf70ef60230$var$_sfc_main270 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Trophy",
    __name: "trophy",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 896V702.08A256.26 256.26 0 0 1 264.064 512h-32.64a96 96 0 0 1-91.968-68.416L93.632 290.88a76.8 76.8 0 0 1 73.6-98.88H256V96a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32v96h88.768a76.8 76.8 0 0 1 73.6 98.88L884.48 443.52A96 96 0 0 1 792.576 512h-32.64A256.26 256.26 0 0 1 544 702.08V896h128a32 32 0 1 1 0 64H352a32 32 0 1 1 0-64zm224-448V128H320v320a192 192 0 1 0 384 0m64 0h24.576a32 32 0 0 0 30.656-22.784l45.824-152.768A12.8 12.8 0 0 0 856.768 256H768zm-512 0V256h-88.768a12.8 12.8 0 0 0-12.288 16.448l45.824 152.768A32 32 0 0 0 231.424 448z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c902dcd836bd9c4f = $37aa0bf70ef60230$var$_sfc_main270;
var $37aa0bf70ef60230$var$_sfc_main271 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "TurnOff",
    __name: "turn-off",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M329.956 257.138a254.862 254.862 0 0 0 0 509.724h364.088a254.862 254.862 0 0 0 0-509.724zm0-72.818h364.088a327.68 327.68 0 1 1 0 655.36H329.956a327.68 327.68 0 1 1 0-655.36"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M329.956 621.227a109.227 109.227 0 1 0 0-218.454 109.227 109.227 0 0 0 0 218.454m0 72.817a182.044 182.044 0 1 1 0-364.088 182.044 182.044 0 0 1 0 364.088"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e84fc9e9fd4f8fa0 = $37aa0bf70ef60230$var$_sfc_main271;
var $37aa0bf70ef60230$var$_sfc_main272 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Umbrella",
    __name: "umbrella",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M320 768a32 32 0 1 1 64 0 64 64 0 0 0 128 0V512H64a448 448 0 1 1 896 0H576v256a128 128 0 1 1-256 0m570.688-320a384.128 384.128 0 0 0-757.376 0z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$979074be5b6c6631 = $37aa0bf70ef60230$var$_sfc_main272;
var $37aa0bf70ef60230$var$_sfc_main273 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Unlock",
    __name: "unlock",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M224 448a32 32 0 0 0-32 32v384a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V480a32 32 0 0 0-32-32zm0-64h576a96 96 0 0 1 96 96v384a96 96 0 0 1-96 96H224a96 96 0 0 1-96-96V480a96 96 0 0 1 96-96"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 544a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V576a32 32 0 0 1 32-32m178.304-295.296A192.064 192.064 0 0 0 320 320v64h352l96 38.4V448H256V320a256 256 0 0 1 493.76-95.104z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a818bbe058f189e = $37aa0bf70ef60230$var$_sfc_main273;
var $37aa0bf70ef60230$var$_sfc_main274 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "UploadFilled",
    __name: "upload-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M544 864V672h128L512 480 352 672h128v192H320v-1.6c-5.376.32-10.496 1.6-16 1.6A240 240 0 0 1 64 624c0-123.136 93.12-223.488 212.608-237.248A239.81 239.81 0 0 1 512 192a239.87 239.87 0 0 1 235.456 194.752c119.488 13.76 212.48 114.112 212.48 237.248a240 240 0 0 1-240 240c-5.376 0-10.56-1.28-16-1.6v1.6z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4c2fc06c457dba0f = $37aa0bf70ef60230$var$_sfc_main274;
var $37aa0bf70ef60230$var$_sfc_main275 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Upload",
    __name: "upload",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 832h704a32 32 0 1 1 0 64H160a32 32 0 1 1 0-64m384-578.304V704h-64V247.296L237.248 490.048 192 444.8 508.8 128l316.8 316.8-45.312 45.248z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c58532f0fb5faa97 = $37aa0bf70ef60230$var$_sfc_main275;
var $37aa0bf70ef60230$var$_sfc_main276 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "UserFilled",
    __name: "user-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M288 320a224 224 0 1 0 448 0 224 224 0 1 0-448 0m544 608H160a32 32 0 0 1-32-32v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 0 1-32 32z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$323d2a36c3f59b3b = $37aa0bf70ef60230$var$_sfc_main276;
var $37aa0bf70ef60230$var$_sfc_main277 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "User",
    __name: "user",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 512a192 192 0 1 0 0-384 192 192 0 0 0 0 384m0 64a256 256 0 1 1 0-512 256 256 0 0 1 0 512m320 320v-96a96 96 0 0 0-96-96H288a96 96 0 0 0-96 96v96a32 32 0 1 1-64 0v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 1 1-64 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1f44aaf2ec115b54 = $37aa0bf70ef60230$var$_sfc_main277;
var $37aa0bf70ef60230$var$_sfc_main278 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Van",
    __name: "van",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128.896 736H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h576a32 32 0 0 1 32 32v96h164.544a32 32 0 0 1 31.616 27.136l54.144 352A32 32 0 0 1 922.688 736h-91.52a144 144 0 1 1-286.272 0H415.104a144 144 0 1 1-286.272 0zm23.36-64a143.872 143.872 0 0 1 239.488 0H568.32c17.088-25.6 42.24-45.376 71.744-55.808V256H128v416zm655.488 0h77.632l-19.648-128H704v64.896A144 144 0 0 1 807.744 672m48.128-192-14.72-96H704v96zM688 832a80 80 0 1 0 0-160 80 80 0 0 0 0 160m-416 0a80 80 0 1 0 0-160 80 80 0 0 0 0 160"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$e5b8aa0d2c53c2ea = $37aa0bf70ef60230$var$_sfc_main278;
var $37aa0bf70ef60230$var$_sfc_main279 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "VideoCameraFilled",
    __name: "video-camera-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m768 576 192-64v320l-192-64v96a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V480a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zM192 768v64h384v-64zm192-480a160 160 0 0 1 320 0 160 160 0 0 1-320 0m64 0a96 96 0 1 0 192.064-.064A96 96 0 0 0 448 288m-320 32a128 128 0 1 1 256.064.064A128 128 0 0 1 128 320m64 0a64 64 0 1 0 128 0 64 64 0 0 0-128 0"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$a5bed8cf2ad1e613 = $37aa0bf70ef60230$var$_sfc_main279;
var $37aa0bf70ef60230$var$_sfc_main280 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "VideoCamera",
    __name: "video-camera",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 768V256H128v512zm64-416 192-96v512l-192-96v128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V224a32 32 0 0 1 32-32h640a32 32 0 0 1 32 32zm0 71.552v176.896l128 64V359.552zM192 320h192v64H192z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$af6fbc3d5e506b68 = $37aa0bf70ef60230$var$_sfc_main280;
var $37aa0bf70ef60230$var$_sfc_main281 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "VideoPause",
    __name: "video-pause",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-96-544q32 0 32 32v256q0 32-32 32t-32-32V384q0-32 32-32m192 0q32 0 32 32v256q0 32-32 32t-32-32V384q0-32 32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$6ad4e028d371f955 = $37aa0bf70ef60230$var$_sfc_main281;
var $37aa0bf70ef60230$var$_sfc_main282 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "VideoPlay",
    __name: "video-play",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m-48-247.616L668.608 512 464 375.616zm10.624-342.656 249.472 166.336a48 48 0 0 1 0 79.872L474.624 718.272A48 48 0 0 1 400 678.336V345.6a48 48 0 0 1 74.624-39.936z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$cc3a325749da3826 = $37aa0bf70ef60230$var$_sfc_main282;
var $37aa0bf70ef60230$var$_sfc_main283 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "View",
    __name: "view",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352m0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288m0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448m0 64a160.19 160.19 0 0 0-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$27a5bd065ad55220 = $37aa0bf70ef60230$var$_sfc_main283;
var $37aa0bf70ef60230$var$_sfc_main284 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "WalletFilled",
    __name: "wallet-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M688 512a112 112 0 1 0 0 224h208v160H128V352h768v160zm32 160h-32a48 48 0 0 1 0-96h32a48 48 0 0 1 0 96m-80-544 128 160H384z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$35d893ff0fcfd4fb = $37aa0bf70ef60230$var$_sfc_main284;
var $37aa0bf70ef60230$var$_sfc_main285 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Wallet",
    __name: "wallet",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M640 288h-64V128H128v704h384v32a32 32 0 0 0 32 32H96a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32h512a32 32 0 0 1 32 32z"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M128 320v512h768V320zm-32-64h832a32 32 0 0 1 32 32v576a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V288a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M704 640a64 64 0 1 1 0-128 64 64 0 0 1 0 128"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$bcca3ea514774656 = $37aa0bf70ef60230$var$_sfc_main285;
var $37aa0bf70ef60230$var$_sfc_main286 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "WarnTriangleFilled",
    __name: "warn-triangle-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                "xml:space": "preserve",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M928.99 755.83 574.6 203.25c-12.89-20.16-36.76-32.58-62.6-32.58s-49.71 12.43-62.6 32.58L95.01 755.83c-12.91 20.12-12.9 44.91.01 65.03 12.92 20.12 36.78 32.51 62.59 32.49h708.78c25.82.01 49.68-12.37 62.59-32.49s12.92-44.91.01-65.03M554.67 768h-85.33v-85.33h85.33zm0-426.67v298.66h-85.33V341.32z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$165d2e18178e1ec2 = $37aa0bf70ef60230$var$_sfc_main286;
var $37aa0bf70ef60230$var$_sfc_main287 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "WarningFilled",
    __name: "warning-filled",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 192a58.43 58.43 0 0 0-58.24 63.744l23.36 256.384a35.072 35.072 0 0 0 69.76 0l23.296-256.384A58.43 58.43 0 0 0 512 256m0 512a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$73296e0703a210f = $37aa0bf70ef60230$var$_sfc_main287;
var $37aa0bf70ef60230$var$_sfc_main288 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Warning",
    __name: "warning",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 832a384 384 0 0 0 0-768 384 384 0 0 0 0 768m48-176a48 48 0 1 1-96 0 48 48 0 0 1 96 0m-48-464a32 32 0 0 1 32 32v288a32 32 0 0 1-64 0V288a32 32 0 0 1 32-32"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$c688898c4e3580ee = $37aa0bf70ef60230$var$_sfc_main288;
var $37aa0bf70ef60230$var$_sfc_main289 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Watch",
    __name: "watch",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M512 768a256 256 0 1 0 0-512 256 256 0 0 0 0 512m0 64a320 320 0 1 1 0-640 320 320 0 0 1 0 640"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 352a32 32 0 0 1 32 32v160a32 32 0 0 1-64 0V384a32 32 0 0 1 32-32"
                }),
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M480 512h128q32 0 32 32t-32 32H480q-32 0-32-32t32-32m128-256V128H416v128h-64V64h320v192zM416 768v128h192V768h64v192H352V768z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$4c68f1a79f88778c = $37aa0bf70ef60230$var$_sfc_main289;
var $37aa0bf70ef60230$var$_sfc_main290 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "Watermelon",
    __name: "watermelon",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m683.072 600.32-43.648 162.816-61.824-16.512 53.248-198.528L576 493.248l-158.4 158.4-45.248-45.248 158.4-158.4-55.616-55.616-198.528 53.248-16.512-61.824 162.816-43.648L282.752 200A384 384 0 0 0 824 741.248zm231.552 141.056a448 448 0 1 1-632-632z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$1dcf734be4e793d = $37aa0bf70ef60230$var$_sfc_main290;
var $37aa0bf70ef60230$var$_sfc_main291 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "WindPower",
    __name: "wind-power",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "M160 64q32 0 32 32v832q0 32-32 32t-32-32V96q0-32 32-32m416 354.624 128-11.584V168.96l-128-11.52v261.12zm-64 5.824V151.552L320 134.08V160h-64V64l616.704 56.064A96 96 0 0 1 960 215.68v144.64a96 96 0 0 1-87.296 95.616L256 512V224h64v217.92zm256-23.232 98.88-8.96A32 32 0 0 0 896 360.32V215.68a32 32 0 0 0-29.12-31.872l-98.88-8.96z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$2f350d3ae555ca0 = $37aa0bf70ef60230$var$_sfc_main291;
var $37aa0bf70ef60230$var$_sfc_main292 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ZoomIn",
    __name: "zoom-in",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704m-32-384v-96a32 32 0 0 1 64 0v96h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64z"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$d13069184bfa0730 = $37aa0bf70ef60230$var$_sfc_main292;
var $37aa0bf70ef60230$var$_sfc_main293 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ZoomOut",
    __name: "zoom-out",
    setup (__props) {
        return (_ctx, _cache)=>((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 1024 1024"
            }, [
                (0, $TusQn.createElementVNode)("path", {
                    fill: "currentColor",
                    d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704M352 448h256a32 32 0 0 1 0 64H352a32 32 0 0 1 0-64"
                })
            ]));
    }
}), $37aa0bf70ef60230$export$adc4acb67269225 = $37aa0bf70ef60230$var$_sfc_main293;

});


parcelRegister("eCh8z", function(module, exports) {

$parcel$export(module.exports, "mutable", () => $2e94afbf11d36b99$export$9cc7a411a0b9bd72);
//#region ../../packages/utils/typescript.ts
const $2e94afbf11d36b99$export$9cc7a411a0b9bd72 = (val)=>val;

});


parcelRegister("8N8IR", function(module, exports) {

$parcel$export(module.exports, "placementInstances", () => $cefe16de9eeb0033$export$ea27e76ebd7dd348);
$parcel$export(module.exports, "getOrCreatePlacementInstances", () => $cefe16de9eeb0033$export$d4f221520c08c1f);
$parcel$export(module.exports, "getLastOffset", () => $cefe16de9eeb0033$export$f2c4188d5649f22a);
$parcel$export(module.exports, "getOffsetOrSpace", () => $cefe16de9eeb0033$export$d8d3f95808bbba50);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
//#region ../../packages/components/message/src/instance.ts
const $cefe16de9eeb0033$export$ea27e76ebd7dd348 = (0, $01W3b.shallowReactive)({});
const $cefe16de9eeb0033$export$d4f221520c08c1f = (placement)=>{
    if (!$cefe16de9eeb0033$export$ea27e76ebd7dd348[placement]) $cefe16de9eeb0033$export$ea27e76ebd7dd348[placement] = (0, $01W3b.shallowReactive)([]);
    return $cefe16de9eeb0033$export$ea27e76ebd7dd348[placement];
};
const $cefe16de9eeb0033$export$8bedcca5bbd73999 = (id, placement)=>{
    const instances = $cefe16de9eeb0033$export$ea27e76ebd7dd348[placement] || [];
    const idx = instances.findIndex((instance)=>instance.id === id);
    const current = instances[idx];
    let prev;
    if (idx > 0) prev = instances[idx - 1];
    return {
        current: current,
        prev: prev
    };
};
const $cefe16de9eeb0033$export$f2c4188d5649f22a = (id, placement)=>{
    const { prev: prev } = $cefe16de9eeb0033$export$8bedcca5bbd73999(id, placement);
    if (!prev) return 0;
    return prev.vm.exposed.bottom.value;
};
const $cefe16de9eeb0033$export$d8d3f95808bbba50 = (id, offset, placement)=>{
    return ($cefe16de9eeb0033$export$ea27e76ebd7dd348[placement] || []).findIndex((instance)=>instance.id === id) > 0 ? 16 : offset;
};

});

parcelRegister("bhgOI", function(module, exports) {

$parcel$export(module.exports, "default", () => $344008a3b76214e9$export$2e2bcd8739ae039);

var $emqm7 = parcelRequire("emqm7");
//#region ../../packages/components/message/src/message.vue
var $344008a3b76214e9$export$2e2bcd8739ae039 = (0, $emqm7.default);

});
parcelRegister("emqm7", function(module, exports) {

$parcel$export(module.exports, "default", () => $739b82ded8dc3ac6$export$2e2bcd8739ae039);

var $9aJbI = parcelRequire("9aJbI");

var $6R4Ru = parcelRequire("6R4Ru");

var $4yuAl = parcelRequire("4yuAl");

var $byrrq = parcelRequire("byrrq");

var $771R0 = parcelRequire("771R0");

var $7h4nQ = parcelRequire("7h4nQ");

var $6sMT7 = parcelRequire("6sMT7");

var $8N8IR = parcelRequire("8N8IR");

var $buPHZ = parcelRequire("buPHZ");
var $aPZNl = parcelRequire("aPZNl");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
var $eeJ70 = parcelRequire("eeJ70");
//#region ../../packages/components/message/src/message.vue?vue&type=script&setup=true&lang.ts
const $739b82ded8dc3ac6$var$_hoisted_1 = [
    "id"
];
const $739b82ded8dc3ac6$var$_hoisted_2 = [
    "innerHTML"
];
var $739b82ded8dc3ac6$export$2e2bcd8739ae039 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ElMessage",
    __name: "message",
    props: (0, $6sMT7.messageProps),
    emits: (0, $6sMT7.messageEmits),
    setup (__props, { expose: __expose, emit: __emit }) {
        const { Close: Close } = (0, $4yuAl.TypeComponents);
        const props = __props;
        const emit = __emit;
        const isStartTransition = (0, $01W3b.ref)(false);
        const { ns: ns, zIndex: zIndex } = (0, $7h4nQ.useGlobalComponentSettings)("message");
        const { currentZIndex: currentZIndex, nextZIndex: nextZIndex } = zIndex;
        const messageRef = (0, $01W3b.ref)();
        const visible = (0, $01W3b.ref)(false);
        const height = (0, $01W3b.ref)(0);
        let stopTimer = void 0;
        const badgeType = (0, $01W3b.computed)(()=>props.type ? props.type === "error" ? "danger" : props.type : "info");
        const typeClass = (0, $01W3b.computed)(()=>{
            const type = props.type;
            return {
                [ns.bm("icon", type)]: type && (0, $4yuAl.TypeComponentsMap)[type]
            };
        });
        const iconComponent = (0, $01W3b.computed)(()=>props.icon || (0, $4yuAl.TypeComponentsMap)[props.type] || "");
        const placement = (0, $01W3b.computed)(()=>props.placement || "top");
        const lastOffset = (0, $01W3b.computed)(()=>(0, $8N8IR.getLastOffset)(props.id, placement.value));
        const offset = (0, $01W3b.computed)(()=>{
            return Math.max((0, $8N8IR.getOffsetOrSpace)(props.id, props.offset, placement.value) + lastOffset.value, props.offset);
        });
        const bottom = (0, $01W3b.computed)(()=>height.value + offset.value);
        const horizontalClass = (0, $01W3b.computed)(()=>{
            if (placement.value.includes("left")) return ns.is("left");
            if (placement.value.includes("right")) return ns.is("right");
            return ns.is("center");
        });
        const verticalProperty = (0, $01W3b.computed)(()=>placement.value.startsWith("top") ? "top" : "bottom");
        const customStyle = (0, $01W3b.computed)(()=>({
                [verticalProperty.value]: `${offset.value}px`,
                zIndex: currentZIndex.value
            }));
        function startTimer() {
            if (props.duration === 0) return;
            ({ stop: stopTimer } = (0, $aPZNl.useTimeoutFn)(()=>{
                close();
            }, props.duration));
        }
        function clearTimer() {
            stopTimer?.();
        }
        function close() {
            visible.value = false;
            (0, $TusQn.nextTick)(()=>{
                if (!isStartTransition.value) {
                    props.onClose?.();
                    emit("destroy");
                }
            });
        }
        function keydown(event) {
            if ((0, $6R4Ru.getEventCode)(event) === (0, $9aJbI.EVENT_CODE).esc) close();
        }
        (0, $TusQn.onMounted)(()=>{
            startTimer();
            nextZIndex();
            visible.value = true;
        });
        (0, $01W3b.watch)(()=>props.repeatNum, ()=>{
            clearTimer();
            startTimer();
        });
        (0, $buPHZ.useEventListener)(document, "keydown", keydown);
        (0, $buPHZ.useResizeObserver)(messageRef, ()=>{
            height.value = messageRef.value.getBoundingClientRect().height;
        });
        __expose({
            visible: visible,
            bottom: bottom,
            close: close
        });
        return (_ctx, _cache)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $eeJ70.Transition), {
                name: (0, $01W3b.unref)(ns).b("fade"),
                onBeforeEnter: _cache[0] || (_cache[0] = ($event)=>isStartTransition.value = true),
                onBeforeLeave: __props.onClose,
                onAfterLeave: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("destroy")),
                persisted: ""
            }, {
                default: (0, $TusQn.withCtx)(()=>[
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                            id: __props.id,
                            ref_key: "messageRef",
                            ref: messageRef,
                            class: (0, $8XWQX.normalizeClass)([
                                (0, $01W3b.unref)(ns).b(),
                                {
                                    [(0, $01W3b.unref)(ns).m(__props.type)]: __props.type
                                },
                                (0, $01W3b.unref)(ns).is("closable", __props.showClose),
                                (0, $01W3b.unref)(ns).is("plain", __props.plain),
                                (0, $01W3b.unref)(ns).is("bottom", verticalProperty.value === "bottom"),
                                horizontalClass.value,
                                __props.customClass
                            ]),
                            style: (0, $8XWQX.normalizeStyle)(customStyle.value),
                            role: "alert",
                            onMouseenter: clearTimer,
                            onMouseleave: startTimer
                        }, [
                            __props.repeatNum > 1 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)((0, $771R0.ElBadge)), {
                                key: 0,
                                value: __props.repeatNum,
                                type: badgeType.value,
                                class: (0, $8XWQX.normalizeClass)((0, $01W3b.unref)(ns).e("badge"))
                            }, null, 8, [
                                "value",
                                "type",
                                "class"
                            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                            iconComponent.value ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)((0, $byrrq.ElIcon)), {
                                key: 1,
                                class: (0, $8XWQX.normalizeClass)([
                                    (0, $01W3b.unref)(ns).e("icon"),
                                    typeClass.value
                                ])
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $TusQn.resolveDynamicComponent)(iconComponent.value)))
                                    ]),
                                _: 1
                            }, 8, [
                                "class"
                            ])) : (0, $TusQn.createCommentVNode)("v-if", true),
                            !__props.dangerouslyUseHTMLString || _ctx.$slots.default ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("p", {
                                key: 2,
                                class: (0, $8XWQX.normalizeClass)((0, $01W3b.unref)(ns).e("content"))
                            }, [
                                (0, $TusQn.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(__props.message), 1)
                                    ])
                            ], 2)) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), {
                                key: 3
                            }, [
                                (0, $TusQn.createCommentVNode)(" Caution here, message could've been compromised, never use user's input as message "),
                                (0, $TusQn.createElementVNode)("p", {
                                    class: (0, $8XWQX.normalizeClass)((0, $01W3b.unref)(ns).e("content")),
                                    innerHTML: __props.message
                                }, null, 10, $739b82ded8dc3ac6$var$_hoisted_2)
                            ], 2112)),
                            __props.showClose ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)((0, $01W3b.unref)((0, $byrrq.ElIcon)), {
                                key: 4,
                                class: (0, $8XWQX.normalizeClass)((0, $01W3b.unref)(ns).e("closeBtn")),
                                onClick: (0, $eeJ70.withModifiers)(close, [
                                    "stop"
                                ])
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createVNode)((0, $01W3b.unref)(Close))
                                    ]),
                                _: 1
                            }, 8, [
                                "class"
                            ])) : (0, $TusQn.createCommentVNode)("v-if", true)
                        ], 46, $739b82ded8dc3ac6$var$_hoisted_1), [
                            [
                                (0, $eeJ70.vShow),
                                visible.value
                            ]
                        ])
                    ]),
                _: 3
            }, 8, [
                "name",
                "onBeforeLeave"
            ]);
        };
    }
});

});
parcelRegister("9aJbI", function(module, exports) {

$parcel$export(module.exports, "EVENT_CODE", () => $8ab220f56e1a2b84$export$6c25223a39177dc8);
//#region ../../packages/constants/aria.ts
const $8ab220f56e1a2b84$export$6c25223a39177dc8 = {
    tab: "Tab",
    enter: "Enter",
    space: "Space",
    left: "ArrowLeft",
    up: "ArrowUp",
    right: "ArrowRight",
    down: "ArrowDown",
    esc: "Escape",
    delete: "Delete",
    backspace: "Backspace",
    numpadEnter: "NumpadEnter",
    pageUp: "PageUp",
    pageDown: "PageDown",
    home: "Home",
    end: "End"
};

});

parcelRegister("6R4Ru", function(module, exports) {

$parcel$export(module.exports, "composeEventHandlers", () => $e5297966c94edaa8$export$b9ecd428b558ff10);
$parcel$export(module.exports, "whenMouse", () => $e5297966c94edaa8$export$aca25bab92135cb5);
$parcel$export(module.exports, "getEventCode", () => $e5297966c94edaa8$export$3b02bc22c26b91a5);
$parcel$export(module.exports, "getEventKey", () => $e5297966c94edaa8$export$f7a7490116b79d4d);

var $9aJbI = parcelRequire("9aJbI");

var $cB44k = parcelRequire("cB44k");
//#region ../../packages/utils/dom/event.ts
const $e5297966c94edaa8$export$b9ecd428b558ff10 = (theirsHandler, oursHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {})=>{
    const handleEvent = (event)=>{
        const shouldPrevent = theirsHandler?.(event);
        if (checkForDefaultPrevented === false || !shouldPrevent) return oursHandler?.(event);
    };
    return handleEvent;
};
const $e5297966c94edaa8$export$aca25bab92135cb5 = (handler)=>{
    return (e)=>e.pointerType === "mouse" ? handler(e) : void 0;
};
const $e5297966c94edaa8$export$3b02bc22c26b91a5 = (event)=>{
    if (event.code && event.code !== "Unidentified") return event.code;
    const key = $e5297966c94edaa8$export$f7a7490116b79d4d(event);
    if (key) {
        if (Object.values((0, $9aJbI.EVENT_CODE)).includes(key)) return key;
        switch(key){
            case " ":
                return (0, $9aJbI.EVENT_CODE).space;
            default:
                return "";
        }
    }
    return "";
};
const $e5297966c94edaa8$export$f7a7490116b79d4d = (event)=>{
    let key = event.key && event.key !== "Unidentified" ? event.key : "";
    if (!key && event.type === "keyup" && (0, $cB44k.isAndroid)()) {
        const target = event.target;
        key = target.value.charAt(target.selectionStart - 1);
    }
    return key;
};

});

parcelRegister("byrrq", function(module, exports) {

$parcel$export(module.exports, "ElIcon", () => $be7b47ccf8e00fff$export$81e7691deec47e36);

var $9U8vi = parcelRequire("9U8vi");


var $5Z25c = parcelRequire("5Z25c");
//#region ../../packages/components/icon/index.ts
const $be7b47ccf8e00fff$export$81e7691deec47e36 = (0, $9U8vi.withInstall)((0, $5Z25c.default));

});
parcelRegister("5Z25c", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cc8c04e42081508$export$2e2bcd8739ae039);

var $geiL8 = parcelRequire("geiL8");
//#region ../../packages/components/icon/src/icon.vue
var $3cc8c04e42081508$export$2e2bcd8739ae039 = (0, $geiL8.default);

});
parcelRegister("geiL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $424af20399f3cf54$export$2e2bcd8739ae039);

var $7Jzoa = parcelRequire("7Jzoa");

var $87qdP = parcelRequire("87qdP");

var $gb4QN = parcelRequire("gb4QN");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
//#region ../../packages/components/icon/src/icon.vue?vue&type=script&setup=true&lang.ts
var $424af20399f3cf54$export$2e2bcd8739ae039 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ElIcon",
    inheritAttrs: false,
    __name: "icon",
    props: (0, $gb4QN.iconProps),
    setup (__props) {
        const props = __props;
        const ns = (0, $87qdP.useNamespace)("icon");
        const style = (0, $01W3b.computed)(()=>{
            const { size: size, color: color } = props;
            const fontSize = (0, $7Jzoa.addUnit)(size);
            if (!fontSize && !color) return {};
            return {
                fontSize: fontSize,
                "--color": color
            };
        });
        return (_ctx, _cache)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("i", (0, $TusQn.mergeProps)({
                class: (0, $01W3b.unref)(ns).b(),
                style: style.value
            }, _ctx.$attrs), [
                (0, $TusQn.renderSlot)(_ctx.$slots, "default")
            ], 16);
        };
    }
});

});
parcelRegister("7Jzoa", function(module, exports) {

$parcel$export(module.exports, "hasClass", () => $044f91e9b802e3f1$export$4ea3d958472af68f);
$parcel$export(module.exports, "addClass", () => $044f91e9b802e3f1$export$d2cf6cd1dc7067d3);
$parcel$export(module.exports, "removeClass", () => $044f91e9b802e3f1$export$c2255604a80b4506);
$parcel$export(module.exports, "getStyle", () => $044f91e9b802e3f1$export$3d2f074408bd1b82);
$parcel$export(module.exports, "setStyle", () => $044f91e9b802e3f1$export$37a5fde709c1db82);
$parcel$export(module.exports, "addUnit", () => $044f91e9b802e3f1$export$fe6185f3b4cd56fc);

var $28mtQ = parcelRequire("28mtQ");
parcelRequire("cB44k");
var $aPZNl = parcelRequire("aPZNl");

var $7eXmP = parcelRequire("7eXmP");
var $8POXm = parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");

var $bgAd2 = parcelRequire("bgAd2");

var $2YSiN = parcelRequire("2YSiN");
//#region ../../packages/utils/dom/style.ts
const $044f91e9b802e3f1$var$SCOPE = "utils/dom/style";
const $044f91e9b802e3f1$export$34c6c037e7b246b8 = (cls = "")=>cls.split(" ").filter((item)=>!!item.trim());
const $044f91e9b802e3f1$export$4ea3d958472af68f = (el, cls)=>{
    if (!el || !cls) return false;
    if (cls.includes(" ")) throw new Error("className should not contain space.");
    return el.classList.contains(cls);
};
const $044f91e9b802e3f1$export$d2cf6cd1dc7067d3 = (el, cls)=>{
    if (!el || !cls.trim()) return;
    el.classList.add(...$044f91e9b802e3f1$export$34c6c037e7b246b8(cls));
};
const $044f91e9b802e3f1$export$c2255604a80b4506 = (el, cls)=>{
    if (!el || !cls.trim()) return;
    el.classList.remove(...$044f91e9b802e3f1$export$34c6c037e7b246b8(cls));
};
const $044f91e9b802e3f1$export$3d2f074408bd1b82 = (element, styleName)=>{
    if (!(0, $aPZNl.isClient) || !element || !styleName || (0, $28mtQ.isShadowRoot)(element)) return "";
    let key = (0, $8POXm.camelize)(styleName);
    if (key === "float") key = "cssFloat";
    try {
        const style = element.style[key];
        if (style) return style;
        const computed = document.defaultView?.getComputedStyle(element, "");
        return computed ? computed[key] : "";
    } catch  {
        return element.style[key];
    }
};
const $044f91e9b802e3f1$export$37a5fde709c1db82 = (element, styleName, value)=>{
    if (!element || !styleName) return;
    if ((0, $8POXm.isObject)(styleName)) (0, $bgAd2.entriesOf)(styleName).forEach(([prop, value])=>$044f91e9b802e3f1$export$37a5fde709c1db82(element, prop, value));
    else {
        const key = (0, $8POXm.camelize)(styleName);
        element.style[key] = value;
    }
};
const $044f91e9b802e3f1$export$afe978aceb0adefd = (element, style)=>{
    if (!element || !style) return;
    if ((0, $8POXm.isObject)(style)) (0, $bgAd2.keysOf)(style).forEach((prop)=>$044f91e9b802e3f1$export$afe978aceb0adefd(element, prop));
    else $044f91e9b802e3f1$export$37a5fde709c1db82(element, style, "");
};
function $044f91e9b802e3f1$export$fe6185f3b4cd56fc(value, defaultUnit = "px") {
    if (!value && value !== 0) return "";
    if ((0, $7eXmP.isNumber)(value) || (0, $7eXmP.isStringNumber)(value)) return `${value}${defaultUnit}`;
    else if ((0, $8POXm.isString)(value)) return value;
    (0, $2YSiN.debugWarn)($044f91e9b802e3f1$var$SCOPE, "binding value must be a string or number");
}

});
parcelRegister("28mtQ", function(module, exports) {

$parcel$export(module.exports, "isShadowRoot", () => $3d1093ce5cfcb43c$export$af51f0f06c0f328a);
$parcel$export(module.exports, "obtainAllFocusableElements", () => $3d1093ce5cfcb43c$export$d435bc8975acb6ee);
$parcel$export(module.exports, "isFocusable", () => $3d1093ce5cfcb43c$export$4c063cf1350e6fed);
$parcel$export(module.exports, "triggerEvent", () => $3d1093ce5cfcb43c$export$bf5e5f0a0e9ca89d);
$parcel$export(module.exports, "isLeaf", () => $3d1093ce5cfcb43c$export$e132ced8f644a612);
$parcel$export(module.exports, "getSibling", () => $3d1093ce5cfcb43c$export$9de01e0b147309f0);
$parcel$export(module.exports, "focusElement", () => $3d1093ce5cfcb43c$export$5fed9cc43865dc7e);
$parcel$export(module.exports, "focusNode", () => $3d1093ce5cfcb43c$export$ce681353c988ed89);
//#region ../../packages/utils/dom/aria.ts
const $3d1093ce5cfcb43c$var$FOCUSABLE_ELEMENT_SELECTORS = `a[href],button:not([disabled]),button:not([hidden]),:not([tabindex="-1"]),input:not([disabled]),input:not([type="hidden"]),select:not([disabled]),textarea:not([disabled])`;
const $3d1093ce5cfcb43c$export$af51f0f06c0f328a = (e)=>{
    if (typeof ShadowRoot === "undefined") return false;
    return e instanceof ShadowRoot;
};
const $3d1093ce5cfcb43c$var$isHTMLElement = (e)=>{
    if (typeof Element === "undefined") return false;
    return e instanceof Element;
};
/**
* Determine if the testing element is visible on screen no matter if its on the viewport or not
*/ const $3d1093ce5cfcb43c$export$795910f5f15a9633 = (element)=>{
    return getComputedStyle(element).position === "fixed" ? false : element.offsetParent !== null;
};
const $3d1093ce5cfcb43c$export$d435bc8975acb6ee = (element)=>{
    return Array.from(element.querySelectorAll($3d1093ce5cfcb43c$var$FOCUSABLE_ELEMENT_SELECTORS)).filter((item)=>$3d1093ce5cfcb43c$export$4c063cf1350e6fed(item) && $3d1093ce5cfcb43c$export$795910f5f15a9633(item));
};
/**
* @desc Determine if target element is focusable
* @param element {HTMLElement}
* @returns {Boolean} true if it is focusable
*/ const $3d1093ce5cfcb43c$export$4c063cf1350e6fed = (element)=>{
    if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute("tabIndex") !== null) return true;
    if (element.tabIndex < 0 || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true") return false;
    switch(element.nodeName){
        case "A":
            return !!element.href && element.rel !== "ignore";
        case "INPUT":
            return !(element.type === "hidden" || element.type === "file");
        case "BUTTON":
        case "SELECT":
        case "TEXTAREA":
            return true;
        default:
            return false;
    }
};
/**
* Trigger an event
* mouseenter, mouseleave, mouseover, keyup, change, click, etc.
* @param  {HTMLElement} elm
* @param  {String} name
* @param  {*} opts
*/ const $3d1093ce5cfcb43c$export$bf5e5f0a0e9ca89d = function(elm, name, ...opts) {
    let eventName;
    if (name.includes("mouse") || name.includes("click")) eventName = "MouseEvents";
    else if (name.includes("key")) eventName = "KeyboardEvent";
    else eventName = "HTMLEvents";
    const evt = document.createEvent(eventName);
    evt.initEvent(name, ...opts);
    elm.dispatchEvent(evt);
    return elm;
};
const $3d1093ce5cfcb43c$export$e132ced8f644a612 = (el)=>!el.getAttribute("aria-owns");
const $3d1093ce5cfcb43c$export$9de01e0b147309f0 = (el, distance, elClass)=>{
    const { parentNode: parentNode } = el;
    if (!parentNode) return null;
    const siblings = parentNode.querySelectorAll(elClass);
    return siblings[Array.prototype.indexOf.call(siblings, el) + distance] || null;
};
const $3d1093ce5cfcb43c$export$5fed9cc43865dc7e = (el, options)=>{
    if (!el || !el.focus) return;
    let cleanup = false;
    if ($3d1093ce5cfcb43c$var$isHTMLElement(el) && !$3d1093ce5cfcb43c$export$4c063cf1350e6fed(el) && !el.getAttribute("tabindex")) {
        el.setAttribute("tabindex", "-1");
        cleanup = true;
    }
    el.focus(options);
    if ($3d1093ce5cfcb43c$var$isHTMLElement(el) && cleanup) el.removeAttribute("tabindex");
};
const $3d1093ce5cfcb43c$export$ce681353c988ed89 = (el)=>{
    if (!el) return;
    $3d1093ce5cfcb43c$export$5fed9cc43865dc7e(el);
    !$3d1093ce5cfcb43c$export$e132ced8f644a612(el) && el.click();
};

});


parcelRegister("gb4QN", function(module, exports) {

$parcel$export(module.exports, "iconProps", () => $9077819d175a9acf$export$98fdc91c71468bd5);

var $1RPMp = parcelRequire("1RPMp");
//#region ../../packages/components/icon/src/icon.ts
/**
* @deprecated Removed after 3.0.0, Use `IconProps` instead.
*/ const $9077819d175a9acf$export$98fdc91c71468bd5 = (0, $1RPMp.buildProps)({
    /**
	* @description SVG icon size, size x size
	*/ size: {
        type: (0, $1RPMp.definePropType)([
            Number,
            String
        ])
    },
    /**
	* @description SVG tag's fill attribute
	*/ color: {
        type: String
    }
});

});




parcelRegister("771R0", function(module, exports) {

$parcel$export(module.exports, "ElBadge", () => $ce9555681ed14e3d$export$b9c73464a1107642);

var $9U8vi = parcelRequire("9U8vi");


var $4h1fH = parcelRequire("4h1fH");
//#region ../../packages/components/badge/index.ts
const $ce9555681ed14e3d$export$b9c73464a1107642 = (0, $9U8vi.withInstall)((0, $4h1fH.default));

});
parcelRegister("4h1fH", function(module, exports) {

$parcel$export(module.exports, "default", () => $acfd4142508109cf$export$2e2bcd8739ae039);

var $37LKW = parcelRequire("37LKW");
//#region ../../packages/components/badge/src/badge.vue
var $acfd4142508109cf$export$2e2bcd8739ae039 = (0, $37LKW.default);

});
parcelRegister("37LKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38d8909fe76cedc$export$2e2bcd8739ae039);

var $7eXmP = parcelRequire("7eXmP");

var $7Jzoa = parcelRequire("7Jzoa");

var $87qdP = parcelRequire("87qdP");

var $d46yv = parcelRequire("d46yv");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8XWQX = parcelRequire("8XWQX");
var $eeJ70 = parcelRequire("eeJ70");
//#region ../../packages/components/badge/src/badge.vue?vue&type=script&setup=true&lang.ts
var $a38d8909fe76cedc$export$2e2bcd8739ae039 = /* @__PURE__ */ (0, $TusQn.defineComponent)({
    name: "ElBadge",
    __name: "badge",
    props: (0, $d46yv.badgeProps),
    setup (__props, { expose: __expose }) {
        const props = __props;
        const ns = (0, $87qdP.useNamespace)("badge");
        const content = (0, $01W3b.computed)(()=>{
            if (props.isDot) return "";
            if ((0, $7eXmP.isNumber)(props.value) && (0, $7eXmP.isNumber)(props.max)) return props.max < props.value ? `${props.max}+` : `${props.value}`;
            return `${props.value}`;
        });
        const style = (0, $01W3b.computed)(()=>{
            return [
                {
                    backgroundColor: props.color,
                    marginRight: (0, $7Jzoa.addUnit)(-props.offset[0]),
                    marginTop: (0, $7Jzoa.addUnit)(props.offset[1])
                },
                props.badgeStyle ?? {}
            ];
        });
        __expose({
            content: /** @description badge content */ content
        });
        return (_ctx, _cache)=>{
            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                class: (0, $8XWQX.normalizeClass)((0, $01W3b.unref)(ns).b())
            }, [
                (0, $TusQn.renderSlot)(_ctx.$slots, "default"),
                (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
                    name: `${(0, $01W3b.unref)(ns).namespace.value}-zoom-in-center`
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            !__props.hidden && (content.value || __props.isDot || _ctx.$slots.content) ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("sup", {
                                key: 0,
                                class: (0, $8XWQX.normalizeClass)([
                                    (0, $01W3b.unref)(ns).e("content"),
                                    (0, $01W3b.unref)(ns).em("content", __props.type),
                                    (0, $01W3b.unref)(ns).is("fixed", !!_ctx.$slots.default),
                                    (0, $01W3b.unref)(ns).is("dot", __props.isDot),
                                    (0, $01W3b.unref)(ns).is("hide-zero", !__props.showZero && __props.value === 0),
                                    __props.badgeClass
                                ]),
                                style: (0, $8XWQX.normalizeStyle)(style.value)
                            }, [
                                (0, $TusQn.renderSlot)(_ctx.$slots, "content", {
                                    value: content.value
                                }, ()=>[
                                        (0, $TusQn.createTextVNode)((0, $8XWQX.toDisplayString)(content.value), 1)
                                    ])
                            ], 6)) : (0, $TusQn.createCommentVNode)("v-if", true)
                        ]),
                    _: 3
                }, 8, [
                    "name"
                ])
            ], 2);
        };
    }
});

});
parcelRegister("d46yv", function(module, exports) {

$parcel$export(module.exports, "badgeProps", () => $04af084d7765a0bd$export$d2daba5b3d3f9248);

var $1RPMp = parcelRequire("1RPMp");
//#region ../../packages/components/badge/src/badge.ts
/**
* @deprecated Removed after 3.0.0, Use `BadgeProps` instead.
*/ const $04af084d7765a0bd$export$d2daba5b3d3f9248 = (0, $1RPMp.buildProps)({
    /**
	* @description display value.
	*/ value: {
        type: [
            String,
            Number
        ],
        default: ""
    },
    /**
	* @description maximum value, shows `{max}+` when exceeded. Only works if value is a number.
	*/ max: {
        type: Number,
        default: 99
    },
    /**
	* @description if a little dot is displayed.
	*/ isDot: Boolean,
    /**
	* @description hidden badge.
	*/ hidden: Boolean,
    /**
	* @description badge type.
	*/ type: {
        type: String,
        values: [
            "primary",
            "success",
            "warning",
            "info",
            "danger"
        ],
        default: "danger"
    },
    /**
	* @description whether to show badge when value is zero.
	*/ showZero: {
        type: Boolean,
        default: true
    },
    /**
	* @description customize dot background color
	*/ color: String,
    /**
	* @description CSS style of badge
	*/ badgeStyle: {
        type: (0, $1RPMp.definePropType)([
            String,
            Object,
            Array,
            Boolean
        ]),
        default: void 0
    },
    /**
	* @description set offset of the badge
	*/ offset: {
        type: (0, $1RPMp.definePropType)(Array),
        default: ()=>[
                0,
                0
            ]
    },
    /**
	* @description custom class name of badge
	*/ badgeClass: {
        type: String
    }
});

});




parcelRegister("buPHZ", function(module, exports) {
$parcel$export(module.exports, "bypassFilter", () => (parcelRequire("aPZNl")).bypassFilter);
$parcel$export(module.exports, "camelize", () => (parcelRequire("aPZNl")).camelize);
$parcel$export(module.exports, "clamp", () => (parcelRequire("aPZNl")).clamp);
$parcel$export(module.exports, "computedEager", () => (parcelRequire("aPZNl")).computedEager);
$parcel$export(module.exports, "computedWithControl", () => (parcelRequire("aPZNl")).computedWithControl);
$parcel$export(module.exports, "containsProp", () => (parcelRequire("aPZNl")).containsProp);
$parcel$export(module.exports, "createEventHook", () => (parcelRequire("aPZNl")).createEventHook);
$parcel$export(module.exports, "createFilterWrapper", () => (parcelRequire("aPZNl")).createFilterWrapper);
$parcel$export(module.exports, "createRef", () => (parcelRequire("aPZNl")).createRef);
$parcel$export(module.exports, "createSingletonPromise", () => (parcelRequire("aPZNl")).createSingletonPromise);
$parcel$export(module.exports, "debounceFilter", () => (parcelRequire("aPZNl")).debounceFilter);
$parcel$export(module.exports, "hasOwn", () => (parcelRequire("aPZNl")).hasOwn);
$parcel$export(module.exports, "identity", () => (parcelRequire("aPZNl")).identity);
$parcel$export(module.exports, "increaseWithUnit", () => (parcelRequire("aPZNl")).increaseWithUnit);
$parcel$export(module.exports, "injectLocal", () => (parcelRequire("aPZNl")).injectLocal);
$parcel$export(module.exports, "isClient", () => (parcelRequire("aPZNl")).isClient);
$parcel$export(module.exports, "isDef", () => (parcelRequire("aPZNl")).isDef);
$parcel$export(module.exports, "isIOS", () => (parcelRequire("aPZNl")).isIOS);
$parcel$export(module.exports, "isObject", () => (parcelRequire("aPZNl")).isObject);
$parcel$export(module.exports, "isWorker", () => (parcelRequire("aPZNl")).isWorker);
$parcel$export(module.exports, "makeDestructurable", () => (parcelRequire("aPZNl")).makeDestructurable);
$parcel$export(module.exports, "noop", () => (parcelRequire("aPZNl")).noop);
$parcel$export(module.exports, "notNullish", () => (parcelRequire("aPZNl")).notNullish);
$parcel$export(module.exports, "objectEntries", () => (parcelRequire("aPZNl")).objectEntries);
$parcel$export(module.exports, "objectOmit", () => (parcelRequire("aPZNl")).objectOmit);
$parcel$export(module.exports, "objectPick", () => (parcelRequire("aPZNl")).objectPick);
$parcel$export(module.exports, "pausableFilter", () => (parcelRequire("aPZNl")).pausableFilter);
$parcel$export(module.exports, "promiseTimeout", () => (parcelRequire("aPZNl")).promiseTimeout);
$parcel$export(module.exports, "provideLocal", () => (parcelRequire("aPZNl")).provideLocal);
$parcel$export(module.exports, "pxValue", () => (parcelRequire("aPZNl")).pxValue);
$parcel$export(module.exports, "reactiveComputed", () => (parcelRequire("aPZNl")).reactiveComputed);
$parcel$export(module.exports, "refDebounced", () => (parcelRequire("aPZNl")).refDebounced);
$parcel$export(module.exports, "syncRef", () => (parcelRequire("aPZNl")).syncRef);
$parcel$export(module.exports, "throttleFilter", () => (parcelRequire("aPZNl")).throttleFilter);
$parcel$export(module.exports, "timestamp", () => (parcelRequire("aPZNl")).timestamp);
$parcel$export(module.exports, "toArray", () => (parcelRequire("aPZNl")).toArray);
$parcel$export(module.exports, "toRef", () => (parcelRequire("aPZNl")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("aPZNl")).toRefs);
$parcel$export(module.exports, "tryOnMounted", () => (parcelRequire("aPZNl")).tryOnMounted);
$parcel$export(module.exports, "tryOnScopeDispose", () => (parcelRequire("aPZNl")).tryOnScopeDispose);
$parcel$export(module.exports, "tryOnUnmounted", () => (parcelRequire("aPZNl")).tryOnUnmounted);
$parcel$export(module.exports, "until", () => (parcelRequire("aPZNl")).until);
$parcel$export(module.exports, "useDebounceFn", () => (parcelRequire("aPZNl")).useDebounceFn);
$parcel$export(module.exports, "useIntervalFn", () => (parcelRequire("aPZNl")).useIntervalFn);
$parcel$export(module.exports, "useThrottleFn", () => (parcelRequire("aPZNl")).useThrottleFn);
$parcel$export(module.exports, "useTimeoutFn", () => (parcelRequire("aPZNl")).useTimeoutFn);
$parcel$export(module.exports, "watchIgnorable", () => (parcelRequire("aPZNl")).watchIgnorable);
$parcel$export(module.exports, "watchImmediate", () => (parcelRequire("aPZNl")).watchImmediate);
$parcel$export(module.exports, "watchOnce", () => (parcelRequire("aPZNl")).watchOnce);
$parcel$export(module.exports, "watchPausable", () => (parcelRequire("aPZNl")).watchPausable);
$parcel$export(module.exports, "watchWithFilter", () => (parcelRequire("aPZNl")).watchWithFilter);
$parcel$export(module.exports, "whenever", () => (parcelRequire("aPZNl")).whenever);

$parcel$export(module.exports, "unrefElement", () => $85ea9b47855776cf$export$c61124d3cf5adbae);
$parcel$export(module.exports, "useEventListener", () => $85ea9b47855776cf$export$7080b3e976bc91ab);
$parcel$export(module.exports, "onClickOutside", () => $85ea9b47855776cf$export$806d9a98fb0e6fd0);
$parcel$export(module.exports, "useMutationObserver", () => $85ea9b47855776cf$export$8ecdcf3bb089e9cd);
$parcel$export(module.exports, "useActiveElement", () => $85ea9b47855776cf$export$4e1875a4b2b1434f);
$parcel$export(module.exports, "useCssVar", () => $85ea9b47855776cf$export$811e58a9be6ff112);
$parcel$export(module.exports, "useDocumentVisibility", () => $85ea9b47855776cf$export$87a87a3d299ece7c);
$parcel$export(module.exports, "useResizeObserver", () => $85ea9b47855776cf$export$683480f191c0e3ea);
$parcel$export(module.exports, "useElementBounding", () => $85ea9b47855776cf$export$f623e6fca765c371);
$parcel$export(module.exports, "useElementSize", () => $85ea9b47855776cf$export$2b86bedf890eab8);
$parcel$export(module.exports, "useIntersectionObserver", () => $85ea9b47855776cf$export$a7395f9832c00176);
$parcel$export(module.exports, "useVModel", () => $85ea9b47855776cf$export$42662bab1b538e5);
$parcel$export(module.exports, "useWindowFocus", () => $85ea9b47855776cf$export$e838b63e89f8751e);
$parcel$export(module.exports, "useWindowSize", () => $85ea9b47855776cf$export$42c02f33970a2afa);

var $aPZNl = parcelRequire("aPZNl");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
//#region computedAsync/index.ts
function $85ea9b47855776cf$export$b28622284d5efdc3(evaluationCallback, initialState, optionsOrRef) {
    var _globalThis$reportErr;
    let options;
    if ((0, $01W3b.isRef)(optionsOrRef)) options = {
        evaluating: optionsOrRef
    };
    else options = optionsOrRef || {};
    const { lazy: lazy = false, flush: flush = "sync", evaluating: evaluating, shallow: shallow = true, onError: onError = (_globalThis$reportErr = globalThis.reportError) !== null && _globalThis$reportErr !== void 0 ? _globalThis$reportErr : (0, $aPZNl.noop) } = options;
    const started = (0, $01W3b.shallowRef)(!lazy);
    const current = shallow ? (0, $01W3b.shallowRef)(initialState) : (0, $01W3b.ref)(initialState);
    let counter = 0;
    (0, $TusQn.watchEffect)(async (onInvalidate)=>{
        if (!started.value) return;
        counter++;
        const counterAtBeginning = counter;
        let hasFinished = false;
        if (evaluating) Promise.resolve().then(()=>{
            evaluating.value = true;
        });
        try {
            const result = await evaluationCallback((cancelCallback)=>{
                onInvalidate(()=>{
                    if (evaluating) evaluating.value = false;
                    if (!hasFinished) cancelCallback();
                });
            });
            if (counterAtBeginning === counter) current.value = result;
        } catch (e) {
            onError(e);
        } finally{
            if (evaluating && counterAtBeginning === counter) evaluating.value = false;
            hasFinished = true;
        }
    }, {
        flush: flush
    });
    if (lazy) return (0, $01W3b.computed)(()=>{
        started.value = true;
        return current.value;
    });
    else return current;
}
/** @deprecated use `computedAsync` instead */ const $85ea9b47855776cf$export$dcbb7025f4e5281b = $85ea9b47855776cf$export$b28622284d5efdc3;
//#endregion
//#region computedInject/index.ts
function $85ea9b47855776cf$export$dc0885167ecf1257(key, options, defaultSource, treatDefaultAsFactory) {
    let source = (0, $TusQn.inject)(key);
    if (defaultSource) source = (0, $TusQn.inject)(key, defaultSource);
    if (treatDefaultAsFactory) source = (0, $TusQn.inject)(key, defaultSource, treatDefaultAsFactory);
    if (typeof options === "function") return (0, $01W3b.computed)((oldValue)=>options(source, oldValue));
    else return (0, $01W3b.computed)({
        get: (oldValue)=>options.get(source, oldValue),
        set: options.set
    });
}
//#endregion
//#region createReusableTemplate/index.ts
/**
* This function creates `define` and `reuse` components in pair,
* It also allow to pass a generic to bind with type.
*
* @see https://vueuse.org/createReusableTemplate
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$7ef9f841998c60db(options = {}) {
    const { inheritAttrs: inheritAttrs = true, name: name = "ReusableTemplate" } = options;
    const render = (0, $01W3b.shallowRef)();
    const define = (0, $TusQn.defineComponent)({
        name: `${name}.define`,
        setup (_, { slots: slots }) {
            return ()=>{
                render.value = slots.default;
            };
        }
    });
    const reuse = (0, $TusQn.defineComponent)({
        inheritAttrs: inheritAttrs,
        name: `${name}.reuse`,
        props: options.props,
        setup (props, { attrs: attrs, slots: slots }) {
            return ()=>{
                var _render$value;
                if (!render.value && true) throw new Error("[VueUse] Failed to find the definition of reusable template");
                const vnode = (_render$value = render.value) === null || _render$value === void 0 ? void 0 : _render$value.call(render, {
                    ...options.props == null ? $85ea9b47855776cf$var$keysToCamelKebabCase(attrs) : props,
                    $slots: slots
                });
                return inheritAttrs && (vnode === null || vnode === void 0 ? void 0 : vnode.length) === 1 ? vnode[0] : vnode;
            };
        }
    });
    return (0, $aPZNl.makeDestructurable)({
        define: define,
        reuse: reuse
    }, [
        define,
        reuse
    ]);
}
function $85ea9b47855776cf$var$keysToCamelKebabCase(obj) {
    const newObj = {};
    for(const key in obj)newObj[(0, $aPZNl.camelize)(key)] = obj[key];
    return newObj;
}
//#endregion
//#region createTemplatePromise/index.ts
/**
* Creates a template promise component.
*
* @see https://vueuse.org/createTemplatePromise
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$cf238338337c58d1(options = {}) {
    let index = 0;
    const instances = (0, $01W3b.ref)([]);
    function create(...args) {
        const props = (0, $01W3b.shallowReactive)({
            key: index++,
            args: args,
            promise: void 0,
            resolve: ()=>{},
            reject: ()=>{},
            isResolving: false,
            options: options
        });
        instances.value.push(props);
        props.promise = new Promise((_resolve, _reject)=>{
            props.resolve = (v)=>{
                props.isResolving = true;
                return _resolve(v);
            };
            props.reject = _reject;
        }).finally(()=>{
            props.promise = void 0;
            const index = instances.value.indexOf(props);
            if (index !== -1) instances.value.splice(index, 1);
        });
        return props.promise;
    }
    function start(...args) {
        if (options.singleton && instances.value.length > 0) return instances.value[0].promise;
        return create(...args);
    }
    const component = (0, $TusQn.defineComponent)((_, { slots: slots })=>{
        const renderList = ()=>instances.value.map((props)=>{
                var _slots$default;
                return (0, $TusQn.h)((0, $TusQn.Fragment), {
                    key: props.key
                }, (_slots$default = slots.default) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots, props));
            });
        if (options.transition) return ()=>(0, $TusQn.h)((0, $eeJ70.TransitionGroup), options.transition, renderList);
        return renderList;
    });
    component.start = start;
    return component;
}
//#endregion
//#region createUnrefFn/index.ts
/**
* Make a plain function accepting ref and raw values as arguments.
* Returns the same value the unconverted function returns, with proper typing.
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$4ebd6dd2d9c62e4b(fn) {
    return function(...args) {
        return fn.apply(this, args.map((i)=>(0, $01W3b.toValue)(i)));
    };
}
//#endregion
//#region _configurable.ts
const $85ea9b47855776cf$export$16f8ba610718ae4a = (0, $aPZNl.isClient) ? window : void 0;
const $85ea9b47855776cf$export$37990bd438d16af3 = (0, $aPZNl.isClient) ? window.document : void 0;
const $85ea9b47855776cf$export$eade61489f57e3fc = (0, $aPZNl.isClient) ? window.navigator : void 0;
const $85ea9b47855776cf$export$66494ae16bad8985 = (0, $aPZNl.isClient) ? window.location : void 0;
//#endregion
//#region unrefElement/index.ts
/**
* Get the dom element of a ref of element or Vue component instance
*
* @param elRef
*/ function $85ea9b47855776cf$export$c61124d3cf5adbae(elRef) {
    var _$el;
    const plain = (0, $01W3b.toValue)(elRef);
    return (_$el = plain === null || plain === void 0 ? void 0 : plain.$el) !== null && _$el !== void 0 ? _$el : plain;
}
//#endregion
//#region useEventListener/index.ts
function $85ea9b47855776cf$export$7080b3e976bc91ab(...args) {
    const register = (el, event, listener, options)=>{
        el.addEventListener(event, listener, options);
        return ()=>el.removeEventListener(event, listener, options);
    };
    const firstParamTargets = (0, $01W3b.computed)(()=>{
        const test = (0, $aPZNl.toArray)((0, $01W3b.toValue)(args[0])).filter((e)=>e != null);
        return test.every((e)=>typeof e !== "string") ? test : void 0;
    });
    return (0, $aPZNl.watchImmediate)(()=>{
        var _firstParamTargets$va, _firstParamTargets$va2;
        return [
            (_firstParamTargets$va = (_firstParamTargets$va2 = firstParamTargets.value) === null || _firstParamTargets$va2 === void 0 ? void 0 : _firstParamTargets$va2.map((e)=>$85ea9b47855776cf$export$c61124d3cf5adbae(e))) !== null && _firstParamTargets$va !== void 0 ? _firstParamTargets$va : [
                $85ea9b47855776cf$export$16f8ba610718ae4a
            ].filter((e)=>e != null),
            (0, $aPZNl.toArray)((0, $01W3b.toValue)(firstParamTargets.value ? args[1] : args[0])),
            (0, $aPZNl.toArray)((0, $01W3b.unref)(firstParamTargets.value ? args[2] : args[1])),
            (0, $01W3b.toValue)(firstParamTargets.value ? args[3] : args[2])
        ];
    }, ([raw_targets, raw_events, raw_listeners, raw_options], _, onCleanup)=>{
        if (!(raw_targets === null || raw_targets === void 0 ? void 0 : raw_targets.length) || !(raw_events === null || raw_events === void 0 ? void 0 : raw_events.length) || !(raw_listeners === null || raw_listeners === void 0 ? void 0 : raw_listeners.length)) return;
        const optionsClone = (0, $aPZNl.isObject)(raw_options) ? {
            ...raw_options
        } : raw_options;
        const cleanups = raw_targets.flatMap((el)=>raw_events.flatMap((event)=>raw_listeners.map((listener)=>register(el, event, listener, optionsClone))));
        onCleanup(()=>{
            cleanups.forEach((fn)=>fn());
        });
    }, {
        flush: "post"
    });
}
//#endregion
//#region onClickOutside/index.ts
let $85ea9b47855776cf$var$_iOSWorkaround = false;
function $85ea9b47855776cf$export$806d9a98fb0e6fd0(target, handler, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, ignore: ignore = [], capture: capture = true, detectIframe: detectIframe = false, controls: controls = false } = options;
    if (!window1) return controls ? {
        stop: (0, $aPZNl.noop),
        cancel: (0, $aPZNl.noop),
        trigger: (0, $aPZNl.noop)
    } : (0, $aPZNl.noop);
    if ((0, $aPZNl.isIOS) && !$85ea9b47855776cf$var$_iOSWorkaround) {
        $85ea9b47855776cf$var$_iOSWorkaround = true;
        const listenerOptions = {
            passive: true
        };
        Array.from(window1.document.body.children).forEach((el)=>el.addEventListener("click", (0, $aPZNl.noop), listenerOptions));
        window1.document.documentElement.addEventListener("click", (0, $aPZNl.noop), listenerOptions);
    }
    let shouldListen = true;
    const shouldIgnore = (event)=>{
        return (0, $01W3b.toValue)(ignore).some((target)=>{
            if (typeof target === "string") return Array.from(window1.document.querySelectorAll(target)).some((el)=>el === event.target || event.composedPath().includes(el));
            else {
                const el = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
                return el && (event.target === el || event.composedPath().includes(el));
            }
        });
    };
    /**
	* Determines if the given target has multiple root elements.
	* Referenced from: https://github.com/vuejs/test-utils/blob/ccb460be55f9f6be05ab708500a41ec8adf6f4bc/src/vue-wrapper.ts#L21
	*/ function hasMultipleRoots(target) {
        const vm = (0, $01W3b.toValue)(target);
        return vm && vm.$.subTree.shapeFlag === 16;
    }
    function checkMultipleRoots(target, event) {
        const vm = (0, $01W3b.toValue)(target);
        const children = vm.$.subTree && vm.$.subTree.children;
        if (children == null || !Array.isArray(children)) return false;
        return children.some((child)=>child.el === event.target || event.composedPath().includes(child.el));
    }
    const listener = (event)=>{
        const el = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
        if (event.target == null) return;
        if (!(el instanceof Element) && hasMultipleRoots(target) && checkMultipleRoots(target, event)) return;
        if (!el || el === event.target || event.composedPath().includes(el)) return;
        if ("detail" in event && event.detail === 0) shouldListen = !shouldIgnore(event);
        if (!shouldListen) {
            shouldListen = true;
            return;
        }
        handler(event);
    };
    let isProcessingClick = false;
    const cleanup = [
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "click", (event)=>{
            if (!isProcessingClick) {
                isProcessingClick = true;
                setTimeout(()=>{
                    isProcessingClick = false;
                }, 0);
                listener(event);
            }
        }, {
            passive: true,
            capture: capture
        }),
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "pointerdown", (e)=>{
            const el = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
            shouldListen = !shouldIgnore(e) && !!(el && !e.composedPath().includes(el));
        }, {
            passive: true
        }),
        detectIframe && $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "blur", (event)=>{
            setTimeout(()=>{
                const el = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
                let activeEl = window1.document.activeElement;
                while(activeEl === null || activeEl === void 0 ? void 0 : activeEl.shadowRoot)activeEl = activeEl.shadowRoot.activeElement;
                if ((activeEl === null || activeEl === void 0 ? void 0 : activeEl.tagName) === "IFRAME" && !(el === null || el === void 0 ? void 0 : el.contains(window1.document.activeElement))) handler(event);
            }, 0);
        }, {
            passive: true
        })
    ].filter(Boolean);
    const stop = ()=>cleanup.forEach((fn)=>fn());
    if (controls) return {
        stop: stop,
        cancel: ()=>{
            shouldListen = false;
        },
        trigger: (event)=>{
            shouldListen = true;
            listener(event);
            shouldListen = false;
        }
    };
    return stop;
}
//#endregion
//#region useMounted/index.ts
/**
* Mounted state in ref.
*
* @see https://vueuse.org/useMounted
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$bce3bfec9f56c837() {
    const isMounted = (0, $01W3b.shallowRef)(false);
    const instance = (0, $TusQn.getCurrentInstance)();
    if (instance) (0, $TusQn.onMounted)(()=>{
        isMounted.value = true;
    }, instance);
    return isMounted;
}
//#endregion
//#region useSupported/index.ts
/* @__NO_SIDE_EFFECTS__ */ function $85ea9b47855776cf$export$85904d4478b9c8a4(callback) {
    const isMounted = $85ea9b47855776cf$export$bce3bfec9f56c837();
    return (0, $01W3b.computed)(()=>{
        isMounted.value;
        return Boolean(callback());
    });
}
//#endregion
//#region useMutationObserver/index.ts
/**
* Watch for changes being made to the DOM tree.
*
* @see https://vueuse.org/useMutationObserver
* @see https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver MutationObserver MDN
* @param target
* @param callback
* @param options
*/ function $85ea9b47855776cf$export$8ecdcf3bb089e9cd(target, callback, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, ...mutationOptions } = options;
    let observer;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && "MutationObserver" in window1);
    const cleanup = ()=>{
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    const stopWatch = (0, $01W3b.watch)((0, $01W3b.computed)(()=>{
        const items = (0, $aPZNl.toArray)((0, $01W3b.toValue)(target)).map($85ea9b47855776cf$export$c61124d3cf5adbae).filter((0, $aPZNl.notNullish));
        return new Set(items);
    }), (newTargets)=>{
        cleanup();
        if (isSupported.value && newTargets.size) {
            observer = new MutationObserver(callback);
            newTargets.forEach((el)=>observer.observe(el, mutationOptions));
        }
    }, {
        immediate: true,
        flush: "post"
    });
    const takeRecords = ()=>{
        return observer === null || observer === void 0 ? void 0 : observer.takeRecords();
    };
    const stop = ()=>{
        stopWatch();
        cleanup();
    };
    (0, $aPZNl.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        stop: stop,
        takeRecords: takeRecords
    };
}
//#endregion
//#region onElementRemoval/index.ts
/**
* Fires when the element or any element containing it is removed.
*
* @param target
* @param callback
* @param options
*/ function $85ea9b47855776cf$export$23b05fde944e9922(target, callback, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, document: document1 = window1 === null || window1 === void 0 ? void 0 : window1.document, flush: flush = "sync" } = options;
    if (!window1 || !document1) return 0, $aPZNl.noop;
    let stopFn;
    const cleanupAndUpdate = (fn)=>{
        stopFn === null || stopFn === void 0 || stopFn();
        stopFn = fn;
    };
    const stopWatch = (0, $TusQn.watchEffect)(()=>{
        const el = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
        if (el) {
            const { stop: stop } = $85ea9b47855776cf$export$8ecdcf3bb089e9cd(document1, (mutationsList)=>{
                if (mutationsList.map((mutation)=>[
                        ...mutation.removedNodes
                    ]).flat().some((node)=>node === el || node.contains(el))) callback(mutationsList);
            }, {
                window: window1,
                childList: true,
                subtree: true
            });
            cleanupAndUpdate(stop);
        }
    }, {
        flush: flush
    });
    const stopHandle = ()=>{
        stopWatch();
        cleanupAndUpdate();
    };
    (0, $aPZNl.tryOnScopeDispose)(stopHandle);
    return stopHandle;
}
//#endregion
//#region onKeyStroke/index.ts
function $85ea9b47855776cf$var$createKeyPredicate(keyFilter) {
    if (typeof keyFilter === "function") return keyFilter;
    else if (typeof keyFilter === "string") return (event)=>event.key === keyFilter;
    else if (Array.isArray(keyFilter)) return (event)=>keyFilter.includes(event.key);
    return ()=>true;
}
function $85ea9b47855776cf$export$70ca9878161d161b(...args) {
    let key;
    let handler;
    let options = {};
    if (args.length === 3) {
        key = args[0];
        handler = args[1];
        options = args[2];
    } else if (args.length === 2) {
        if (typeof args[1] === "object") {
            key = true;
            handler = args[0];
            options = args[1];
        } else {
            key = args[0];
            handler = args[1];
        }
    } else {
        key = true;
        handler = args[0];
    }
    const { target: target = $85ea9b47855776cf$export$16f8ba610718ae4a, eventName: eventName = "keydown", passive: passive = false, dedupe: dedupe = false } = options;
    const predicate = $85ea9b47855776cf$var$createKeyPredicate(key);
    const listener = (e)=>{
        if (e.repeat && (0, $01W3b.toValue)(dedupe)) return;
        if (predicate(e)) handler(e);
    };
    return $85ea9b47855776cf$export$7080b3e976bc91ab(target, eventName, listener, passive);
}
/**
* Listen to the keydown event of the given key.
*
* @see https://vueuse.org/onKeyStroke
* @param key
* @param handler
* @param options
*/ function $85ea9b47855776cf$export$de8e1b1372cdb41b(key, handler, options = {}) {
    return $85ea9b47855776cf$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keydown"
    });
}
/**
* Listen to the keypress event of the given key.
*
* @see https://vueuse.org/onKeyStroke
* @param key
* @param handler
* @param options
*/ function $85ea9b47855776cf$export$33ead148203888dd(key, handler, options = {}) {
    return $85ea9b47855776cf$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keypress"
    });
}
/**
* Listen to the keyup event of the given key.
*
* @see https://vueuse.org/onKeyStroke
* @param key
* @param handler
* @param options
*/ function $85ea9b47855776cf$export$f144bbb6e186b14b(key, handler, options = {}) {
    return $85ea9b47855776cf$export$70ca9878161d161b(key, handler, {
        ...options,
        eventName: "keyup"
    });
}
//#endregion
//#region onLongPress/index.ts
const $85ea9b47855776cf$var$DEFAULT_DELAY = 500;
const $85ea9b47855776cf$var$DEFAULT_THRESHOLD = 10;
function $85ea9b47855776cf$export$d0dd9c8bca391fcb(target, handler, options) {
    var _options$modifiers10, _options$modifiers11;
    const elementRef = (0, $01W3b.computed)(()=>$85ea9b47855776cf$export$c61124d3cf5adbae(target));
    let timeout;
    let posStart;
    let startTimestamp;
    let hasLongPressed = false;
    function clear() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = void 0;
        }
        posStart = void 0;
        startTimestamp = void 0;
        hasLongPressed = false;
    }
    function getDelay(ev) {
        const delay = options === null || options === void 0 ? void 0 : options.delay;
        if (typeof delay === "function") return delay(ev);
        return delay !== null && delay !== void 0 ? delay : $85ea9b47855776cf$var$DEFAULT_DELAY;
    }
    function onRelease(ev) {
        var _options$modifiers, _options$modifiers2, _options$modifiers3;
        const [_startTimestamp, _posStart, _hasLongPressed] = [
            startTimestamp,
            posStart,
            hasLongPressed
        ];
        clear();
        if (!(options === null || options === void 0 ? void 0 : options.onMouseUp) || !_posStart || !_startTimestamp) return;
        if ((options === null || options === void 0 || (_options$modifiers = options.modifiers) === null || _options$modifiers === void 0 ? void 0 : _options$modifiers.self) && ev.target !== elementRef.value) return;
        if (options === null || options === void 0 || (_options$modifiers2 = options.modifiers) === null || _options$modifiers2 === void 0 ? void 0 : _options$modifiers2.prevent) ev.preventDefault();
        if (options === null || options === void 0 || (_options$modifiers3 = options.modifiers) === null || _options$modifiers3 === void 0 ? void 0 : _options$modifiers3.stop) ev.stopPropagation();
        const dx = ev.x - _posStart.x;
        const dy = ev.y - _posStart.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        options.onMouseUp(ev.timeStamp - _startTimestamp, distance, _hasLongPressed, ev);
    }
    function onDown(ev) {
        var _options$modifiers4, _options$modifiers5, _options$modifiers6;
        if ((options === null || options === void 0 || (_options$modifiers4 = options.modifiers) === null || _options$modifiers4 === void 0 ? void 0 : _options$modifiers4.self) && ev.target !== elementRef.value) return;
        clear();
        if (options === null || options === void 0 || (_options$modifiers5 = options.modifiers) === null || _options$modifiers5 === void 0 ? void 0 : _options$modifiers5.prevent) ev.preventDefault();
        if (options === null || options === void 0 || (_options$modifiers6 = options.modifiers) === null || _options$modifiers6 === void 0 ? void 0 : _options$modifiers6.stop) ev.stopPropagation();
        posStart = {
            x: ev.x,
            y: ev.y
        };
        startTimestamp = ev.timeStamp;
        timeout = setTimeout(()=>{
            hasLongPressed = true;
            handler(ev);
        }, getDelay(ev));
    }
    function onMove(ev) {
        var _options$modifiers7, _options$modifiers8, _options$modifiers9, _options$distanceThre;
        if ((options === null || options === void 0 || (_options$modifiers7 = options.modifiers) === null || _options$modifiers7 === void 0 ? void 0 : _options$modifiers7.self) && ev.target !== elementRef.value) return;
        if (!posStart || (options === null || options === void 0 ? void 0 : options.distanceThreshold) === false) return;
        if (options === null || options === void 0 || (_options$modifiers8 = options.modifiers) === null || _options$modifiers8 === void 0 ? void 0 : _options$modifiers8.prevent) ev.preventDefault();
        if (options === null || options === void 0 || (_options$modifiers9 = options.modifiers) === null || _options$modifiers9 === void 0 ? void 0 : _options$modifiers9.stop) ev.stopPropagation();
        const dx = ev.x - posStart.x;
        const dy = ev.y - posStart.y;
        if (Math.sqrt(dx * dx + dy * dy) >= ((_options$distanceThre = options === null || options === void 0 ? void 0 : options.distanceThreshold) !== null && _options$distanceThre !== void 0 ? _options$distanceThre : $85ea9b47855776cf$var$DEFAULT_THRESHOLD)) clear();
    }
    const listenerOptions = {
        capture: options === null || options === void 0 || (_options$modifiers10 = options.modifiers) === null || _options$modifiers10 === void 0 ? void 0 : _options$modifiers10.capture,
        once: options === null || options === void 0 || (_options$modifiers11 = options.modifiers) === null || _options$modifiers11 === void 0 ? void 0 : _options$modifiers11.once
    };
    const cleanup = [
        $85ea9b47855776cf$export$7080b3e976bc91ab(elementRef, "pointerdown", onDown, listenerOptions),
        $85ea9b47855776cf$export$7080b3e976bc91ab(elementRef, "pointermove", onMove, listenerOptions),
        $85ea9b47855776cf$export$7080b3e976bc91ab(elementRef, [
            "pointerup",
            "pointerleave"
        ], onRelease, listenerOptions)
    ];
    const stop = ()=>cleanup.forEach((fn)=>fn());
    return stop;
}
//#endregion
//#region onStartTyping/index.ts
function $85ea9b47855776cf$var$isFocusedElementEditable() {
    const { activeElement: activeElement, body: body } = document;
    if (!activeElement) return false;
    if (activeElement === body) return false;
    switch(activeElement.tagName){
        case "INPUT":
        case "TEXTAREA":
            return true;
    }
    return activeElement.hasAttribute("contenteditable");
}
function $85ea9b47855776cf$var$isTypedCharValid({ keyCode: keyCode, metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey }) {
    if (metaKey || ctrlKey || altKey) return false;
    if (keyCode >= 48 && keyCode <= 57 || keyCode >= 96 && keyCode <= 105) return true;
    if (keyCode >= 65 && keyCode <= 90) return true;
    return false;
}
/**
* Fires when users start typing on non-editable elements.
*
* @see https://vueuse.org/onStartTyping
* @param callback
* @param options
*/ function $85ea9b47855776cf$export$cd54fc233e2f4a5d(callback, options = {}) {
    const { document: document1 = $85ea9b47855776cf$export$37990bd438d16af3 } = options;
    const keydown = (event)=>{
        if (!$85ea9b47855776cf$var$isFocusedElementEditable() && $85ea9b47855776cf$var$isTypedCharValid(event)) callback(event);
    };
    if (document1) $85ea9b47855776cf$export$7080b3e976bc91ab(document1, "keydown", keydown, {
        passive: true
    });
}
//#endregion
//#region templateRef/index.ts
/**
* @deprecated Use Vue's built-in `useTemplateRef` instead.
*
* Shorthand for binding ref to template element.
*
* @see https://vueuse.org/templateRef
* @param key
* @param initialValue
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$fc38e812d383221(key, initialValue = null) {
    const instance = (0, $TusQn.getCurrentInstance)();
    let _trigger = ()=>{};
    const element = (0, $01W3b.customRef)((track, trigger)=>{
        _trigger = trigger;
        return {
            get () {
                var _instance$proxy$$refs, _instance$proxy;
                track();
                return (_instance$proxy$$refs = instance === null || instance === void 0 || (_instance$proxy = instance.proxy) === null || _instance$proxy === void 0 ? void 0 : _instance$proxy.$refs[key]) !== null && _instance$proxy$$refs !== void 0 ? _instance$proxy$$refs : initialValue;
            },
            set () {}
        };
    });
    (0, $aPZNl.tryOnMounted)(_trigger);
    (0, $TusQn.onUpdated)(_trigger);
    return element;
}
//#endregion
//#region useActiveElement/index.ts
/**
* Reactive `document.activeElement`
*
* @see https://vueuse.org/useActiveElement
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$4e1875a4b2b1434f(options = {}) {
    var _options$document;
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, deep: deep = true, triggerOnRemoval: triggerOnRemoval = false } = options;
    const document1 = (_options$document = options.document) !== null && _options$document !== void 0 ? _options$document : window1 === null || window1 === void 0 ? void 0 : window1.document;
    const getDeepActiveElement = ()=>{
        let element = document1 === null || document1 === void 0 ? void 0 : document1.activeElement;
        if (deep) {
            var _element$shadowRoot;
            while(element === null || element === void 0 ? void 0 : element.shadowRoot)element = element === null || element === void 0 || (_element$shadowRoot = element.shadowRoot) === null || _element$shadowRoot === void 0 ? void 0 : _element$shadowRoot.activeElement;
        }
        return element;
    };
    const activeElement = (0, $01W3b.shallowRef)();
    const trigger = ()=>{
        activeElement.value = getDeepActiveElement();
    };
    if (window1) {
        const listenerOptions = {
            capture: true,
            passive: true
        };
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "blur", (event)=>{
            if (event.relatedTarget !== null) return;
            trigger();
        }, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "focus", trigger, listenerOptions);
    }
    if (triggerOnRemoval) $85ea9b47855776cf$export$23b05fde944e9922(activeElement, trigger, {
        document: document1
    });
    trigger();
    return activeElement;
}
//#endregion
//#region useRafFn/index.ts
/**
* Call function on every `requestAnimationFrame`. With controls of pausing and resuming.
*
* @see https://vueuse.org/useRafFn
* @param fn
* @param options
*/ function $85ea9b47855776cf$export$13251e0fc79284e(fn, options = {}) {
    const { immediate: immediate = true, fpsLimit: fpsLimit = null, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, once: once = false } = options;
    const isActive = (0, $01W3b.shallowRef)(false);
    const intervalLimit = (0, $01W3b.computed)(()=>{
        const limit = (0, $01W3b.toValue)(fpsLimit);
        return limit ? 1e3 / limit : null;
    });
    let previousFrameTimestamp = 0;
    let rafId = null;
    function loop(timestamp) {
        if (!isActive.value || !window1) return;
        if (!previousFrameTimestamp) previousFrameTimestamp = timestamp;
        const delta = timestamp - previousFrameTimestamp;
        if (intervalLimit.value && delta < intervalLimit.value) {
            rafId = window1.requestAnimationFrame(loop);
            return;
        }
        previousFrameTimestamp = timestamp;
        fn({
            delta: delta,
            timestamp: timestamp
        });
        if (once) {
            isActive.value = false;
            rafId = null;
            return;
        }
        rafId = window1.requestAnimationFrame(loop);
    }
    function resume() {
        if (!isActive.value && window1) {
            isActive.value = true;
            previousFrameTimestamp = 0;
            rafId = window1.requestAnimationFrame(loop);
        }
    }
    function pause() {
        isActive.value = false;
        if (rafId != null && window1) {
            window1.cancelAnimationFrame(rafId);
            rafId = null;
        }
    }
    if (immediate) resume();
    (0, $aPZNl.tryOnScopeDispose)(pause);
    return {
        isActive: (0, $01W3b.shallowReadonly)(isActive),
        pause: pause,
        resume: resume
    };
}
//#endregion
//#region useAnimate/index.ts
/**
* Reactive Web Animations API
*
* @see https://vueuse.org/useAnimate
* @param target
* @param keyframes
* @param options
*/ function $85ea9b47855776cf$export$9f387b98a73b1511(target, keyframes, options) {
    let config;
    let animateOptions;
    if ((0, $aPZNl.isObject)(options)) {
        config = options;
        animateOptions = (0, $aPZNl.objectOmit)(options, [
            "window",
            "immediate",
            "commitStyles",
            "persist",
            "onReady",
            "onError"
        ]);
    } else {
        config = {
            duration: options
        };
        animateOptions = options;
    }
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, immediate: immediate = true, commitStyles: commitStyles, persist: persist, playbackRate: _playbackRate = 1, onReady: onReady, onError: onError = (e)=>{
        console.error(e);
    } } = config;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && HTMLElement && "animate" in HTMLElement.prototype);
    const animate = (0, $01W3b.shallowRef)(void 0);
    const store = (0, $01W3b.shallowReactive)({
        startTime: null,
        currentTime: null,
        timeline: null,
        playbackRate: _playbackRate,
        pending: false,
        playState: immediate ? "idle" : "paused",
        replaceState: "active"
    });
    const pending = (0, $01W3b.computed)(()=>store.pending);
    const playState = (0, $01W3b.computed)(()=>store.playState);
    const replaceState = (0, $01W3b.computed)(()=>store.replaceState);
    const startTime = (0, $01W3b.computed)({
        get () {
            return store.startTime;
        },
        set (value) {
            store.startTime = value;
            if (animate.value) animate.value.startTime = value;
        }
    });
    const currentTime = (0, $01W3b.computed)({
        get () {
            return store.currentTime;
        },
        set (value) {
            store.currentTime = value;
            if (animate.value) {
                animate.value.currentTime = value;
                syncResume();
            }
        }
    });
    const timeline = (0, $01W3b.computed)({
        get () {
            return store.timeline;
        },
        set (value) {
            store.timeline = value;
            if (animate.value) animate.value.timeline = value;
        }
    });
    const playbackRate = (0, $01W3b.computed)({
        get () {
            return store.playbackRate;
        },
        set (value) {
            store.playbackRate = value;
            if (animate.value) animate.value.playbackRate = value;
        }
    });
    const play = ()=>{
        if (animate.value) try {
            animate.value.play();
            syncResume();
        } catch (e) {
            syncPause();
            onError(e);
        }
        else update();
    };
    const pause = ()=>{
        try {
            var _animate$value;
            (_animate$value = animate.value) === null || _animate$value === void 0 || _animate$value.pause();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    const reverse = ()=>{
        if (!animate.value) update();
        try {
            var _animate$value2;
            (_animate$value2 = animate.value) === null || _animate$value2 === void 0 || _animate$value2.reverse();
            syncResume();
        } catch (e) {
            syncPause();
            onError(e);
        }
    };
    const finish = ()=>{
        try {
            var _animate$value3;
            (_animate$value3 = animate.value) === null || _animate$value3 === void 0 || _animate$value3.finish();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    const cancel = ()=>{
        try {
            var _animate$value4;
            (_animate$value4 = animate.value) === null || _animate$value4 === void 0 || _animate$value4.cancel();
            syncPause();
        } catch (e) {
            onError(e);
        }
    };
    (0, $01W3b.watch)(()=>$85ea9b47855776cf$export$c61124d3cf5adbae(target), (el)=>{
        if (el) update(true);
        else animate.value = void 0;
    });
    (0, $01W3b.watch)(()=>keyframes, (value)=>{
        if (animate.value) {
            update();
            const targetEl = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
            if (targetEl) animate.value.effect = new KeyframeEffect(targetEl, (0, $01W3b.toValue)(value), animateOptions);
        }
    }, {
        deep: true
    });
    (0, $aPZNl.tryOnMounted)(()=>update(true), false);
    (0, $aPZNl.tryOnScopeDispose)(cancel);
    function update(init) {
        const el = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
        if (!isSupported.value || !el) return;
        if (!animate.value) animate.value = el.animate((0, $01W3b.toValue)(keyframes), animateOptions);
        if (persist) animate.value.persist();
        if (_playbackRate !== 1) animate.value.playbackRate = _playbackRate;
        if (init && !immediate) animate.value.pause();
        else syncResume();
        onReady === null || onReady === void 0 || onReady(animate.value);
    }
    const listenerOptions = {
        passive: true
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab(animate, [
        "cancel",
        "finish",
        "remove"
    ], syncPause, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(animate, "finish", ()=>{
        var _animate$value5;
        if (commitStyles) (_animate$value5 = animate.value) === null || _animate$value5 === void 0 || _animate$value5.commitStyles();
    }, listenerOptions);
    const { resume: resumeRef, pause: pauseRef } = $85ea9b47855776cf$export$13251e0fc79284e(()=>{
        if (!animate.value) return;
        store.pending = animate.value.pending;
        store.playState = animate.value.playState;
        store.replaceState = animate.value.replaceState;
        store.startTime = animate.value.startTime;
        store.currentTime = animate.value.currentTime;
        store.timeline = animate.value.timeline;
        store.playbackRate = animate.value.playbackRate;
    }, {
        immediate: false
    });
    function syncResume() {
        if (isSupported.value) resumeRef();
    }
    function syncPause() {
        if (isSupported.value && window1) window1.requestAnimationFrame(pauseRef);
    }
    return {
        isSupported: isSupported,
        animate: animate,
        play: play,
        pause: pause,
        reverse: reverse,
        finish: finish,
        cancel: cancel,
        pending: pending,
        playState: playState,
        replaceState: replaceState,
        startTime: startTime,
        currentTime: currentTime,
        timeline: timeline,
        playbackRate: playbackRate
    };
}
//#endregion
//#region useAsyncQueue/index.ts
/**
* Asynchronous queue task controller.
*
* @see https://vueuse.org/useAsyncQueue
* @param tasks
* @param options
*/ function $85ea9b47855776cf$export$15048550d0df8459(tasks, options) {
    const { interrupt: interrupt = true, onError: onError = (0, $aPZNl.noop), onFinished: onFinished = (0, $aPZNl.noop), signal: signal } = options || {};
    const promiseState = {
        aborted: "aborted",
        fulfilled: "fulfilled",
        pending: "pending",
        rejected: "rejected"
    };
    const result = (0, $01W3b.reactive)(Array.from(Array.from({
        length: tasks.length
    }), ()=>({
            state: promiseState.pending,
            data: null
        })));
    const activeIndex = (0, $01W3b.shallowRef)(-1);
    if (!tasks || tasks.length === 0) {
        onFinished();
        return {
            activeIndex: activeIndex,
            result: result
        };
    }
    function updateResult(state, res) {
        activeIndex.value++;
        result[activeIndex.value].data = res;
        result[activeIndex.value].state = state;
    }
    tasks.reduce((prev, curr)=>{
        return prev.then((prevRes)=>{
            var _result$activeIndex$v;
            if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, /* @__PURE__ */ new Error("aborted"));
                return;
            }
            if (((_result$activeIndex$v = result[activeIndex.value]) === null || _result$activeIndex$v === void 0 ? void 0 : _result$activeIndex$v.state) === promiseState.rejected && interrupt) {
                onFinished();
                return;
            }
            const done = curr(prevRes).then((currentRes)=>{
                updateResult(promiseState.fulfilled, currentRes);
                if (activeIndex.value === tasks.length - 1) onFinished();
                return currentRes;
            });
            if (!signal) return done;
            return Promise.race([
                done,
                $85ea9b47855776cf$var$whenAborted(signal)
            ]);
        }).catch((e)=>{
            if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                updateResult(promiseState.aborted, e);
                return e;
            }
            updateResult(promiseState.rejected, e);
            onError();
            if (activeIndex.value === tasks.length - 1) onFinished();
            return e;
        });
    }, Promise.resolve());
    return {
        activeIndex: activeIndex,
        result: result
    };
}
function $85ea9b47855776cf$var$whenAborted(signal) {
    return new Promise((resolve, reject)=>{
        const error = /* @__PURE__ */ new Error("aborted");
        if (signal.aborted) reject(error);
        else signal.addEventListener("abort", ()=>reject(error), {
            once: true
        });
    });
}
//#endregion
//#region useAsyncState/index.ts
/**
* Reactive async state. Will not block your setup function and will trigger changes once
* the promise is ready.
*
* @see https://vueuse.org/useAsyncState
* @param promise         The promise / async function to be resolved
* @param initialState    The initial state, used until the first evaluation finishes
* @param options
*/ function $85ea9b47855776cf$export$d94717ae0e8aa8b(promise, initialState, options) {
    var _globalThis$reportErr;
    const { immediate: immediate = true, delay: delay = 0, onError: onError = (_globalThis$reportErr = globalThis.reportError) !== null && _globalThis$reportErr !== void 0 ? _globalThis$reportErr : (0, $aPZNl.noop), onSuccess: onSuccess = (0, $aPZNl.noop), resetOnExecute: resetOnExecute = true, shallow: shallow = true, throwError: throwError } = options !== null && options !== void 0 ? options : {};
    const state = shallow ? (0, $01W3b.shallowRef)(initialState) : (0, $01W3b.ref)(initialState);
    const isReady = (0, $01W3b.shallowRef)(false);
    const isLoading = (0, $01W3b.shallowRef)(false);
    const error = (0, $01W3b.shallowRef)(void 0);
    let executionsCount = 0;
    async function execute(delay = 0, ...args) {
        const executionId = executionsCount += 1;
        if (resetOnExecute) state.value = (0, $01W3b.toValue)(initialState);
        error.value = void 0;
        isReady.value = false;
        isLoading.value = true;
        if (delay > 0) await (0, $aPZNl.promiseTimeout)(delay);
        const _promise = typeof promise === "function" ? promise(...args) : promise;
        try {
            const data = await _promise;
            if (executionId === executionsCount) {
                state.value = data;
                isReady.value = true;
            }
            onSuccess(data);
            return data;
        } catch (e) {
            if (executionId === executionsCount) error.value = e;
            onError(e);
            if (throwError) throw e;
        } finally{
            if (executionId === executionsCount) isLoading.value = false;
        }
    }
    if (immediate) execute(delay);
    const shell = {
        state: state,
        isReady: isReady,
        isLoading: isLoading,
        error: error,
        execute: execute,
        executeImmediate: (...args)=>execute(0, ...args)
    };
    function waitUntilIsLoaded() {
        return new Promise((resolve, reject)=>{
            (0, $aPZNl.until)(isLoading).toBe(false).then(()=>resolve(shell)).catch(reject);
        });
    }
    return {
        ...shell,
        then (onFulfilled, onRejected) {
            return waitUntilIsLoaded().then(onFulfilled, onRejected);
        }
    };
}
//#endregion
//#region useBase64/serialization.ts
const $85ea9b47855776cf$var$defaults = {
    array: (v)=>JSON.stringify(v),
    object: (v)=>JSON.stringify(v),
    set: (v)=>JSON.stringify(Array.from(v)),
    map: (v)=>JSON.stringify(Object.fromEntries(v)),
    null: ()=>""
};
function $85ea9b47855776cf$var$getDefaultSerialization(target) {
    if (!target) return $85ea9b47855776cf$var$defaults.null;
    if (target instanceof Map) return $85ea9b47855776cf$var$defaults.map;
    else if (target instanceof Set) return $85ea9b47855776cf$var$defaults.set;
    else if (Array.isArray(target)) return $85ea9b47855776cf$var$defaults.array;
    else return $85ea9b47855776cf$var$defaults.object;
}
//#endregion
//#region useBase64/index.ts
function $85ea9b47855776cf$export$a1fce3538bfe26db(target, options) {
    const base64 = (0, $01W3b.shallowRef)("");
    const promise = (0, $01W3b.shallowRef)();
    function execute() {
        if (!(0, $aPZNl.isClient)) return;
        promise.value = new Promise((resolve, reject)=>{
            try {
                const _target = (0, $01W3b.toValue)(target);
                if (_target == null) resolve("");
                else if (typeof _target === "string") resolve($85ea9b47855776cf$var$blobToBase64(new Blob([
                    _target
                ], {
                    type: "text/plain"
                })));
                else if (_target instanceof Blob) resolve($85ea9b47855776cf$var$blobToBase64(_target));
                else if (_target instanceof ArrayBuffer) resolve(window.btoa(String.fromCharCode(...new Uint8Array(_target))));
                else if (_target instanceof HTMLCanvasElement) resolve(_target.toDataURL(options === null || options === void 0 ? void 0 : options.type, options === null || options === void 0 ? void 0 : options.quality));
                else if (_target instanceof HTMLImageElement) {
                    const img = _target.cloneNode(false);
                    img.crossOrigin = "Anonymous";
                    $85ea9b47855776cf$var$imgLoaded(img).then(()=>{
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        resolve(canvas.toDataURL(options === null || options === void 0 ? void 0 : options.type, options === null || options === void 0 ? void 0 : options.quality));
                    }).catch(reject);
                } else if (typeof _target === "object") {
                    const serialized = ((options === null || options === void 0 ? void 0 : options.serializer) || $85ea9b47855776cf$var$getDefaultSerialization(_target))(_target);
                    return resolve($85ea9b47855776cf$var$blobToBase64(new Blob([
                        serialized
                    ], {
                        type: "application/json"
                    })));
                } else reject(/* @__PURE__ */ new Error("target is unsupported types"));
            } catch (error) {
                reject(error);
            }
        });
        promise.value.then((res)=>{
            base64.value = (options === null || options === void 0 ? void 0 : options.dataUrl) === false ? res.replace(/^data:.*?;base64,/, "") : res;
        });
        return promise.value;
    }
    if ((0, $01W3b.isRef)(target) || typeof target === "function") (0, $01W3b.watch)(target, execute, {
        immediate: true
    });
    else execute();
    return {
        base64: base64,
        promise: promise,
        execute: execute
    };
}
function $85ea9b47855776cf$var$imgLoaded(img) {
    return new Promise((resolve, reject)=>{
        if (!img.complete) {
            img.onload = ()=>{
                resolve();
            };
            img.onerror = reject;
        } else resolve();
    });
}
function $85ea9b47855776cf$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const fr = new FileReader();
        fr.onload = (e)=>{
            resolve(e.target.result);
        };
        fr.onerror = reject;
        fr.readAsDataURL(blob);
    });
}
//#endregion
//#region useBattery/index.ts
/**
* Reactive Battery Status API.
*
* @see https://vueuse.org/useBattery
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$2a2cdda660e4b159(options = {}) {
    const { navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc } = options;
    const events = [
        "chargingchange",
        "chargingtimechange",
        "dischargingtimechange",
        "levelchange"
    ];
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "getBattery" in navigator1 && typeof navigator1.getBattery === "function");
    const charging = (0, $01W3b.shallowRef)(false);
    const chargingTime = (0, $01W3b.shallowRef)(0);
    const dischargingTime = (0, $01W3b.shallowRef)(0);
    const level = (0, $01W3b.shallowRef)(1);
    let battery;
    function updateBatteryInfo() {
        charging.value = this.charging;
        chargingTime.value = this.chargingTime || 0;
        dischargingTime.value = this.dischargingTime || 0;
        level.value = this.level;
    }
    if (isSupported.value) navigator1.getBattery().then((_battery)=>{
        battery = _battery;
        updateBatteryInfo.call(battery);
        $85ea9b47855776cf$export$7080b3e976bc91ab(battery, events, updateBatteryInfo, {
            passive: true
        });
    });
    return {
        isSupported: isSupported,
        charging: charging,
        chargingTime: chargingTime,
        dischargingTime: dischargingTime,
        level: level
    };
}
//#endregion
//#region useBluetooth/index.ts
/* @__NO_SIDE_EFFECTS__ */ function $85ea9b47855776cf$export$4fa034be92e08f89(options) {
    let { acceptAllDevices: acceptAllDevices = false } = options || {};
    const { filters: filters, optionalServices: optionalServices, navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc } = options || {};
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "bluetooth" in navigator1);
    const device = (0, $01W3b.shallowRef)();
    const error = (0, $01W3b.shallowRef)(null);
    (0, $01W3b.watch)(device, ()=>{
        connectToBluetoothGATTServer();
    });
    async function requestDevice() {
        if (!isSupported.value) return;
        error.value = null;
        if (filters && filters.length > 0) acceptAllDevices = false;
        try {
            device.value = await (navigator1 === null || navigator1 === void 0 ? void 0 : navigator1.bluetooth.requestDevice({
                acceptAllDevices: acceptAllDevices,
                filters: filters,
                optionalServices: optionalServices
            }));
        } catch (err) {
            error.value = err;
        }
    }
    const server = (0, $01W3b.shallowRef)();
    const isConnected = (0, $01W3b.shallowRef)(false);
    function reset() {
        isConnected.value = false;
        device.value = void 0;
        server.value = void 0;
    }
    async function connectToBluetoothGATTServer() {
        error.value = null;
        if (device.value && device.value.gatt) {
            $85ea9b47855776cf$export$7080b3e976bc91ab(device, "gattserverdisconnected", reset, {
                passive: true
            });
            try {
                server.value = await device.value.gatt.connect();
                isConnected.value = server.value.connected;
            } catch (err) {
                error.value = err;
            }
        }
    }
    (0, $aPZNl.tryOnMounted)(()=>{
        var _device$value$gatt;
        if (device.value) (_device$value$gatt = device.value.gatt) === null || _device$value$gatt === void 0 || _device$value$gatt.connect();
    });
    (0, $aPZNl.tryOnScopeDispose)(()=>{
        var _device$value$gatt2;
        if (device.value) (_device$value$gatt2 = device.value.gatt) === null || _device$value$gatt2 === void 0 || _device$value$gatt2.disconnect();
    });
    return {
        isSupported: isSupported,
        isConnected: (0, $01W3b.shallowReadonly)(isConnected),
        device: device,
        requestDevice: requestDevice,
        server: server,
        error: error
    };
}
//#endregion
//#region useSSRWidth/index.ts
const $85ea9b47855776cf$var$ssrWidthSymbol = Symbol("vueuse-ssr-width");
/* @__NO_SIDE_EFFECTS__ */ function $85ea9b47855776cf$export$cafdc23c22f6a4c3() {
    const ssrWidth = (0, $TusQn.hasInjectionContext)() ? (0, $aPZNl.injectLocal)($85ea9b47855776cf$var$ssrWidthSymbol, null) : null;
    return typeof ssrWidth === "number" ? ssrWidth : void 0;
}
function $85ea9b47855776cf$export$bd980f40a4d4aa5(width, app) {
    if (app !== void 0) app.provide($85ea9b47855776cf$var$ssrWidthSymbol, width);
    else (0, $aPZNl.provideLocal)($85ea9b47855776cf$var$ssrWidthSymbol, width);
}
//#endregion
//#region useMediaQuery/index.ts
/**
* Reactive Media Query.
*
* @see https://vueuse.org/useMediaQuery
* @param query
* @param options
*/ function $85ea9b47855776cf$export$32d5543ab307c01(query, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, ssrWidth: ssrWidth = /* @__PURE__ */ $85ea9b47855776cf$export$cafdc23c22f6a4c3() } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && "matchMedia" in window1 && typeof window1.matchMedia === "function");
    const ssrSupport = (0, $01W3b.shallowRef)(typeof ssrWidth === "number");
    const mediaQuery = (0, $01W3b.shallowRef)();
    const matches = (0, $01W3b.shallowRef)(false);
    const handler = (event)=>{
        matches.value = event.matches;
    };
    (0, $TusQn.watchEffect)(()=>{
        if (ssrSupport.value) {
            ssrSupport.value = !isSupported.value;
            matches.value = (0, $01W3b.toValue)(query).split(",").some((queryString)=>{
                const not = queryString.includes("not all");
                const minWidth = queryString.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
                const maxWidth = queryString.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
                let res = Boolean(minWidth || maxWidth);
                if (minWidth && res) res = ssrWidth >= (0, $aPZNl.pxValue)(minWidth[1]);
                if (maxWidth && res) res = ssrWidth <= (0, $aPZNl.pxValue)(maxWidth[1]);
                return not ? !res : res;
            });
            return;
        }
        if (!isSupported.value) return;
        mediaQuery.value = window1.matchMedia((0, $01W3b.toValue)(query));
        matches.value = mediaQuery.value.matches;
    });
    $85ea9b47855776cf$export$7080b3e976bc91ab(mediaQuery, "change", handler, {
        passive: true
    });
    return (0, $01W3b.computed)(()=>matches.value);
}
//#endregion
//#region useBreakpoints/breakpoints.ts
/**
* Breakpoints from Tailwind V2
*
* @see https://tailwindcss.com/docs/breakpoints
*/ const $85ea9b47855776cf$export$1e7f3da0afb51c4 = {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
};
/**
* Breakpoints from Bootstrap V5
*
* @see https://getbootstrap.com/docs/5.0/layout/breakpoints
*/ const $85ea9b47855776cf$export$ab05426c509559f5 = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};
/**
* Breakpoints from Vuetify V2
*
* @see https://v2.vuetifyjs.com/en/features/breakpoints/
*/ const $85ea9b47855776cf$export$59a8910ce37234c0 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1264,
    xl: 1904
};
/**
* Breakpoints from Vuetify V3
*
* @see https://vuetifyjs.com/en/styles/float/#overview
*/ const $85ea9b47855776cf$export$f7fcbbae4606fa86 = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
    xxl: 2560
};
/**
* Alias to `breakpointsVuetifyV2`
*
* @deprecated explictly use `breakpointsVuetifyV2` or `breakpointsVuetifyV3` instead
*/ const $85ea9b47855776cf$export$e826524d50707be3 = $85ea9b47855776cf$export$59a8910ce37234c0;
/**
* Breakpoints from Ant Design
*
* @see https://ant.design/components/layout/#breakpoint-width
*/ const $85ea9b47855776cf$export$913d30ac358ba918 = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600
};
/**
* Breakpoints from Quasar V2
*
* @see https://quasar.dev/style/breakpoints
*/ const $85ea9b47855776cf$export$6ed1cd5183566ff7 = {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
};
/**
* Sematic Breakpoints
*/ const $85ea9b47855776cf$export$b4376e330fd9cda3 = {
    mobileS: 320,
    mobileM: 375,
    mobileL: 425,
    tablet: 768,
    laptop: 1024,
    laptopL: 1440,
    desktop4K: 2560
};
/**
* Breakpoints from Master CSS
*
* @see https://docs.master.co/css/breakpoints
*/ const $85ea9b47855776cf$export$dba9946743c0ab98 = {
    "3xs": 360,
    "2xs": 480,
    "xs": 600,
    "sm": 768,
    "md": 1024,
    "lg": 1280,
    "xl": 1440,
    "2xl": 1600,
    "3xl": 1920,
    "4xl": 2560
};
/**
* Breakpoints from PrimeFlex
*
* @see https://primeflex.org/installation
*/ const $85ea9b47855776cf$export$71df204985f11b6 = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
/**
* Breakpoints from ElementUI/ElementPlus
*
* @see https://element.eleme.io/#/en-US/component/layout
* @see https://element-plus.org/en-US/component/layout.html
*/ const $85ea9b47855776cf$export$8cbac7b6592328df = {
    xs: 0,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1920
};
//#endregion
//#region useBreakpoints/index.ts
/**
* Reactively viewport breakpoints
*
* @see https://vueuse.org/useBreakpoints
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$e818ed21e924bde4(breakpoints, options = {}) {
    function getValue(k, delta) {
        let v = (0, $01W3b.toValue)(breakpoints[(0, $01W3b.toValue)(k)]);
        if (delta != null) v = (0, $aPZNl.increaseWithUnit)(v, delta);
        if (typeof v === "number") v = `${v}px`;
        return v;
    }
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, strategy: strategy = "min-width", ssrWidth: ssrWidth = /* @__PURE__ */ $85ea9b47855776cf$export$cafdc23c22f6a4c3() } = options;
    const ssrSupport = typeof ssrWidth === "number";
    const mounted = ssrSupport ? (0, $01W3b.shallowRef)(false) : {
        value: true
    };
    if (ssrSupport) (0, $aPZNl.tryOnMounted)(()=>mounted.value = !!window1);
    function match(query, size) {
        if (!mounted.value && ssrSupport) return query === "min" ? ssrWidth >= (0, $aPZNl.pxValue)(size) : ssrWidth <= (0, $aPZNl.pxValue)(size);
        if (!window1) return false;
        return window1.matchMedia(`(${query}-width: ${size})`).matches;
    }
    const greaterOrEqual = (k)=>{
        return $85ea9b47855776cf$export$32d5543ab307c01(()=>`(min-width: ${getValue(k)})`, options);
    };
    const smallerOrEqual = (k)=>{
        return $85ea9b47855776cf$export$32d5543ab307c01(()=>`(max-width: ${getValue(k)})`, options);
    };
    const shortcutMethods = Object.keys(breakpoints).reduce((shortcuts, k)=>{
        Object.defineProperty(shortcuts, k, {
            get: ()=>strategy === "min-width" ? greaterOrEqual(k) : smallerOrEqual(k),
            enumerable: true,
            configurable: true
        });
        return shortcuts;
    }, {});
    function current() {
        const points = Object.keys(breakpoints).map((k)=>[
                k,
                shortcutMethods[k],
                (0, $aPZNl.pxValue)(getValue(k))
            ]).sort((a, b)=>a[2] - b[2]);
        return (0, $01W3b.computed)(()=>points.filter(([, v])=>v.value).map(([k])=>k));
    }
    return Object.assign(shortcutMethods, {
        greaterOrEqual: greaterOrEqual,
        smallerOrEqual: smallerOrEqual,
        greater (k) {
            return $85ea9b47855776cf$export$32d5543ab307c01(()=>`(min-width: ${getValue(k, .1)})`, options);
        },
        smaller (k) {
            return $85ea9b47855776cf$export$32d5543ab307c01(()=>`(max-width: ${getValue(k, -0.1)})`, options);
        },
        between (a, b) {
            return $85ea9b47855776cf$export$32d5543ab307c01(()=>`(min-width: ${getValue(a)}) and (max-width: ${getValue(b, -0.1)})`, options);
        },
        isGreater (k) {
            return match("min", getValue(k, .1));
        },
        isGreaterOrEqual (k) {
            return match("min", getValue(k));
        },
        isSmaller (k) {
            return match("max", getValue(k, -0.1));
        },
        isSmallerOrEqual (k) {
            return match("max", getValue(k));
        },
        isInBetween (a, b) {
            return match("min", getValue(a)) && match("max", getValue(b, -0.1));
        },
        current: current,
        active () {
            const bps = current();
            return (0, $01W3b.computed)(()=>bps.value.length === 0 ? "" : bps.value.at(strategy === "min-width" ? -1 : 0));
        }
    });
}
//#endregion
//#region useBroadcastChannel/index.ts
/**
* Reactive BroadcastChannel
*
* @see https://vueuse.org/useBroadcastChannel
* @see https://developer.mozilla.org/en-US/docs/Web/API/BroadcastChannel
* @param options
*
*/ function $85ea9b47855776cf$export$e38c76da774a8077(options) {
    const { name: name, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && "BroadcastChannel" in window1);
    const isClosed = (0, $01W3b.shallowRef)(false);
    const channel = (0, $01W3b.shallowRef)();
    const data = (0, $01W3b.shallowRef)();
    const error = (0, $01W3b.shallowRef)(null);
    const post = (data)=>{
        if (channel.value) channel.value.postMessage(data);
    };
    const close = ()=>{
        if (channel.value) channel.value.close();
        isClosed.value = true;
    };
    if (isSupported.value) (0, $aPZNl.tryOnMounted)(()=>{
        error.value = null;
        channel.value = new BroadcastChannel(name);
        const listenerOptions = {
            passive: true
        };
        $85ea9b47855776cf$export$7080b3e976bc91ab(channel, "message", (e)=>{
            data.value = e.data;
        }, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(channel, "messageerror", (e)=>{
            error.value = e;
        }, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(channel, "close", ()=>{
            isClosed.value = true;
        }, listenerOptions);
    });
    (0, $aPZNl.tryOnScopeDispose)(()=>{
        close();
    });
    return {
        isSupported: isSupported,
        channel: channel,
        data: data,
        post: post,
        close: close,
        error: error,
        isClosed: isClosed
    };
}
//#endregion
//#region useBrowserLocation/index.ts
const $85ea9b47855776cf$var$WRITABLE_PROPERTIES = [
    "hash",
    "host",
    "hostname",
    "href",
    "pathname",
    "port",
    "protocol",
    "search"
];
/**
* Reactive browser location.
*
* @see https://vueuse.org/useBrowserLocation
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$29c60f5332583(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const refs = Object.fromEntries($85ea9b47855776cf$var$WRITABLE_PROPERTIES.map((key)=>[
            key,
            (0, $01W3b.ref)()
        ]));
    for (const [key, ref] of (0, $aPZNl.objectEntries)(refs))(0, $01W3b.watch)(ref, (value)=>{
        if (!(window1 === null || window1 === void 0 ? void 0 : window1.location) || window1.location[key] === value) return;
        window1.location[key] = value;
    });
    const buildState = (trigger)=>{
        var _window$location;
        const { state: state, length: length } = (window1 === null || window1 === void 0 ? void 0 : window1.history) || {};
        const { origin: origin } = (window1 === null || window1 === void 0 ? void 0 : window1.location) || {};
        for (const key of $85ea9b47855776cf$var$WRITABLE_PROPERTIES)refs[key].value = window1 === null || window1 === void 0 || (_window$location = window1.location) === null || _window$location === void 0 ? void 0 : _window$location[key];
        return (0, $01W3b.reactive)({
            trigger: trigger,
            state: state,
            length: length,
            origin: origin,
            ...refs
        });
    };
    const state = (0, $01W3b.ref)(buildState("load"));
    if (window1) {
        const listenerOptions = {
            passive: true
        };
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "popstate", ()=>state.value = buildState("popstate"), listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "hashchange", ()=>state.value = buildState("hashchange"), listenerOptions);
    }
    return state;
}
//#endregion
//#region useCached/index.ts
function $85ea9b47855776cf$export$738959f2b29daa01(refValue, comparator = (newSourceValue, cachedValue)=>newSourceValue === cachedValue, options) {
    const { deepRefs: deepRefs = true, ...watchOptions } = options || {};
    const cachedValue = (0, $aPZNl.createRef)(refValue.value, deepRefs);
    (0, $01W3b.watch)(()=>refValue.value, (value)=>{
        if (!comparator(value, cachedValue.value)) cachedValue.value = value;
    }, watchOptions);
    return cachedValue;
}
//#endregion
//#region usePermission/index.ts
/**
* Reactive Permissions API.
*
* @see https://vueuse.org/usePermission
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$d7376454a3cf5ab4(permissionDesc, options = {}) {
    const { controls: controls = false, navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "permissions" in navigator1);
    const permissionStatus = (0, $01W3b.shallowRef)();
    const desc = typeof permissionDesc === "string" ? {
        name: permissionDesc
    } : permissionDesc;
    const state = (0, $01W3b.shallowRef)();
    const update = ()=>{
        var _permissionStatus$val, _permissionStatus$val2;
        state.value = (_permissionStatus$val = (_permissionStatus$val2 = permissionStatus.value) === null || _permissionStatus$val2 === void 0 ? void 0 : _permissionStatus$val2.state) !== null && _permissionStatus$val !== void 0 ? _permissionStatus$val : "prompt";
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab(permissionStatus, "change", update, {
        passive: true
    });
    const query = (0, $aPZNl.createSingletonPromise)(async ()=>{
        if (!isSupported.value) return;
        if (!permissionStatus.value) try {
            permissionStatus.value = await navigator1.permissions.query(desc);
        } catch (_unused) {
            permissionStatus.value = void 0;
        } finally{
            update();
        }
        if (controls) return (0, $01W3b.toRaw)(permissionStatus.value);
    });
    query();
    if (controls) return {
        state: state,
        isSupported: isSupported,
        query: query
    };
    else return state;
}
//#endregion
//#region useClipboard/index.ts
function $85ea9b47855776cf$export$2314ca2a3e892862(options = {}) {
    const { navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc, read: read = false, source: source, copiedDuring: copiedDuring = 1500, legacy: legacy = false } = options;
    const isClipboardApiSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "clipboard" in navigator1);
    const permissionRead = $85ea9b47855776cf$export$d7376454a3cf5ab4("clipboard-read");
    const permissionWrite = $85ea9b47855776cf$export$d7376454a3cf5ab4("clipboard-write");
    const isSupported = (0, $01W3b.computed)(()=>isClipboardApiSupported.value || legacy);
    const text = (0, $01W3b.shallowRef)("");
    const copied = (0, $01W3b.shallowRef)(false);
    const copyPending = (0, $01W3b.shallowRef)(false);
    const timeout = (0, $aPZNl.useTimeoutFn)(()=>copied.value = false, copiedDuring, {
        immediate: false
    });
    let lastLegacyId = 0;
    async function updateText() {
        let useLegacy = !(isClipboardApiSupported.value && isAllowed(permissionRead.value));
        if (!useLegacy) try {
            text.value = await navigator1.clipboard.readText();
        } catch (_unused) {
            useLegacy = true;
        }
        if (useLegacy) text.value = legacyRead();
    }
    if (isSupported.value && read) $85ea9b47855776cf$export$7080b3e976bc91ab([
        "copy",
        "cut"
    ], updateText, {
        passive: true
    });
    async function copy(value) {
        const resolvedValue = value !== null && value !== void 0 ? value : (0, $01W3b.toValue)(source);
        if (isSupported.value && resolvedValue != null) {
            copyPending.value = true;
            let useLegacy = !(isClipboardApiSupported.value && isAllowed(permissionWrite.value));
            if (!useLegacy) try {
                const clipboardItem = createClipboardItem(resolvedValue);
                await navigator1.clipboard.write([
                    clipboardItem
                ]);
            } catch (_unused2) {
                useLegacy = true;
            }
            if (useLegacy) {
                if (typeof resolvedValue === "string") {
                    text.value = resolvedValue;
                    legacyCopy(resolvedValue);
                } else {
                    const currentId = ++lastLegacyId;
                    const resolvedText = await resolvedValue();
                    if (resolvedText != null && currentId === lastLegacyId) {
                        text.value = resolvedText;
                        legacyCopy(resolvedText);
                    }
                }
            }
            copied.value = true;
            timeout.start();
            copyPending.value = false;
        }
    }
    function createClipboardItem(value) {
        if (typeof value === "string") {
            text.value = value;
            return new ClipboardItem({
                "text/plain": value
            });
        } else return new ClipboardItem({
            "text/plain": value().then((resolvedText = "")=>{
                text.value = resolvedText;
                return new Blob([
                    resolvedText
                ], {
                    type: "text/plain"
                });
            })
        });
    }
    function legacyCopy(value) {
        const ta = document.createElement("textarea");
        ta.value = value;
        ta.style.position = "absolute";
        ta.style.opacity = "0";
        ta.setAttribute("readonly", "");
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
    }
    function legacyRead() {
        var _document$getSelectio, _document, _document$getSelectio2;
        return (_document$getSelectio = (_document = document) === null || _document === void 0 || (_document$getSelectio2 = _document.getSelection) === null || _document$getSelectio2 === void 0 || (_document$getSelectio2 = _document$getSelectio2.call(_document)) === null || _document$getSelectio2 === void 0 ? void 0 : _document$getSelectio2.toString()) !== null && _document$getSelectio !== void 0 ? _document$getSelectio : "";
    }
    function isAllowed(status) {
        return status === "granted" || status === "prompt";
    }
    return {
        copyPending: (0, $01W3b.shallowReadonly)(copyPending),
        isSupported: isSupported,
        text: (0, $01W3b.shallowReadonly)(text),
        copied: (0, $01W3b.shallowReadonly)(copied),
        copy: copy
    };
}
//#endregion
//#region useClipboardItems/index.ts
function $85ea9b47855776cf$export$ada6005637a1689d(options = {}) {
    const { navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc, read: read = false, source: source, copiedDuring: copiedDuring = 1500 } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "clipboard" in navigator1);
    const content = (0, $01W3b.shallowRef)([]);
    const copied = (0, $01W3b.shallowRef)(false);
    const timeout = (0, $aPZNl.useTimeoutFn)(()=>copied.value = false, copiedDuring, {
        immediate: false
    });
    function updateContent() {
        if (isSupported.value) navigator1.clipboard.read().then((items)=>{
            content.value = items;
        });
    }
    if (isSupported.value && read) $85ea9b47855776cf$export$7080b3e976bc91ab([
        "copy",
        "cut"
    ], updateContent, {
        passive: true
    });
    async function copy(value = (0, $01W3b.toValue)(source)) {
        if (isSupported.value && value != null) {
            await navigator1.clipboard.write(value);
            content.value = value;
            copied.value = true;
            timeout.start();
        }
    }
    return {
        isSupported: isSupported,
        content: (0, $01W3b.shallowReadonly)(content),
        copied: (0, $01W3b.shallowReadonly)(copied),
        copy: copy,
        read: updateContent
    };
}
//#endregion
//#region useCloned/index.ts
function $85ea9b47855776cf$export$9e72043f8ff3a3df(source) {
    return JSON.parse(JSON.stringify(source));
}
function $85ea9b47855776cf$export$1d793528ac2b824a(source, options = {}) {
    const cloned = (0, $01W3b.ref)({});
    const isModified = (0, $01W3b.shallowRef)(false);
    let _lastSync = false;
    const { manual: manual, clone: clone = $85ea9b47855776cf$export$9e72043f8ff3a3df, deep: deep = true, immediate: immediate = true } = options;
    (0, $01W3b.watch)(cloned, ()=>{
        if (_lastSync) {
            _lastSync = false;
            return;
        }
        isModified.value = true;
    }, {
        deep: true,
        flush: "sync"
    });
    function sync() {
        _lastSync = true;
        isModified.value = false;
        cloned.value = clone((0, $01W3b.toValue)(source));
    }
    if (!manual && ((0, $01W3b.isRef)(source) || typeof source === "function")) (0, $01W3b.watch)(source, sync, {
        ...options,
        deep: deep,
        immediate: immediate
    });
    else sync();
    return {
        cloned: cloned,
        isModified: isModified,
        sync: sync
    };
}
//#endregion
//#region ssr-handlers.ts
const $85ea9b47855776cf$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
const $85ea9b47855776cf$var$globalKey = "__vueuse_ssr_handlers__";
const $85ea9b47855776cf$var$handlers = /* @__PURE__ */ $85ea9b47855776cf$var$getHandlers();
function $85ea9b47855776cf$var$getHandlers() {
    if (!($85ea9b47855776cf$var$globalKey in $85ea9b47855776cf$var$_global)) $85ea9b47855776cf$var$_global[$85ea9b47855776cf$var$globalKey] = $85ea9b47855776cf$var$_global[$85ea9b47855776cf$var$globalKey] || {};
    return $85ea9b47855776cf$var$_global[$85ea9b47855776cf$var$globalKey];
}
function $85ea9b47855776cf$export$b0cf1ae5a98eb83b(key, fallback) {
    return $85ea9b47855776cf$var$handlers[key] || fallback;
}
function $85ea9b47855776cf$export$4094cfc0512bc950(key, fn) {
    $85ea9b47855776cf$var$handlers[key] = fn;
}
//#endregion
//#region usePreferredDark/index.ts
/**
* Reactive dark theme preference.
*
* @see https://vueuse.org/usePreferredDark
* @param [options]
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$a9fe667866660cd5(options) {
    return $85ea9b47855776cf$export$32d5543ab307c01("(prefers-color-scheme: dark)", options);
}
//#endregion
//#region useStorage/guess.ts
function $85ea9b47855776cf$var$guessSerializerType(rawInit) {
    return rawInit == null ? "any" : rawInit instanceof Set ? "set" : rawInit instanceof Map ? "map" : rawInit instanceof Date ? "date" : typeof rawInit === "boolean" ? "boolean" : typeof rawInit === "string" ? "string" : typeof rawInit === "object" ? "object" : !Number.isNaN(rawInit) ? "number" : "any";
}
//#endregion
//#region useStorage/index.ts
const $85ea9b47855776cf$export$8111877b006f9b0b = {
    boolean: {
        read: (v)=>v === "true",
        write: (v)=>String(v)
    },
    object: {
        read: (v)=>JSON.parse(v),
        write: (v)=>JSON.stringify(v)
    },
    number: {
        read: (v)=>Number.parseFloat(v),
        write: (v)=>String(v)
    },
    any: {
        read: (v)=>v,
        write: (v)=>String(v)
    },
    string: {
        read: (v)=>v,
        write: (v)=>String(v)
    },
    map: {
        read: (v)=>new Map(JSON.parse(v)),
        write: (v)=>JSON.stringify(Array.from(v.entries()))
    },
    set: {
        read: (v)=>new Set(JSON.parse(v)),
        write: (v)=>JSON.stringify(Array.from(v))
    },
    date: {
        read: (v)=>new Date(v),
        write: (v)=>v.toISOString()
    }
};
const $85ea9b47855776cf$export$5962b94d93010632 = "vueuse-storage";
/**
* Reactive LocalStorage/SessionStorage.
*
* @see https://vueuse.org/useStorage
*/ function $85ea9b47855776cf$export$95809329f49ea9f9(key, defaults, storage, options = {}) {
    var _options$serializer;
    const { flush: flush = "pre", deep: deep = true, listenToStorageChanges: listenToStorageChanges = true, writeDefaults: writeDefaults = true, mergeDefaults: mergeDefaults = false, shallow: shallow, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, eventFilter: eventFilter, onError: onError = (e)=>{
        console.error(e);
    }, initOnMounted: initOnMounted } = options;
    const data = (shallow ? (0, $01W3b.shallowRef) : (0, $01W3b.ref))(typeof defaults === "function" ? defaults() : defaults);
    const keyComputed = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(key));
    if (!storage) try {
        storage = $85ea9b47855776cf$export$b0cf1ae5a98eb83b("getDefaultStorage", ()=>$85ea9b47855776cf$export$16f8ba610718ae4a === null || $85ea9b47855776cf$export$16f8ba610718ae4a === void 0 ? void 0 : $85ea9b47855776cf$export$16f8ba610718ae4a.localStorage)();
    } catch (e) {
        onError(e);
    }
    if (!storage) return data;
    const rawInit = (0, $01W3b.toValue)(defaults);
    const type = $85ea9b47855776cf$var$guessSerializerType(rawInit);
    const serializer = (_options$serializer = options.serializer) !== null && _options$serializer !== void 0 ? _options$serializer : $85ea9b47855776cf$export$8111877b006f9b0b[type];
    const { pause: pauseWatch, resume: resumeWatch } = (0, $aPZNl.watchPausable)(data, (newValue)=>write(newValue), {
        flush: flush,
        deep: deep,
        eventFilter: eventFilter
    });
    (0, $01W3b.watch)(keyComputed, ()=>update(), {
        flush: flush
    });
    let firstMounted = false;
    const onStorageEvent = (ev)=>{
        if (initOnMounted && !firstMounted) return;
        update(ev);
    };
    const onStorageCustomEvent = (ev)=>{
        if (initOnMounted && !firstMounted) return;
        updateFromCustomEvent(ev);
    };
    /**
	* The custom event is needed for same-document syncing when using custom
	* storage backends, but it doesn't work across different documents.
	*
	* TODO: Consider implementing a BroadcastChannel-based solution that fixes this.
	*/ if (window1 && listenToStorageChanges) {
        if (storage instanceof Storage) $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "storage", onStorageEvent, {
            passive: true
        });
        else $85ea9b47855776cf$export$7080b3e976bc91ab(window1, $85ea9b47855776cf$export$5962b94d93010632, onStorageCustomEvent);
    }
    if (initOnMounted) (0, $aPZNl.tryOnMounted)(()=>{
        firstMounted = true;
        update();
    });
    else update();
    function dispatchWriteEvent(oldValue, newValue) {
        if (window1) {
            const payload = {
                key: keyComputed.value,
                oldValue: oldValue,
                newValue: newValue,
                storageArea: storage
            };
            window1.dispatchEvent(storage instanceof Storage ? new StorageEvent("storage", payload) : new CustomEvent($85ea9b47855776cf$export$5962b94d93010632, {
                detail: payload
            }));
        }
    }
    function write(v) {
        try {
            const oldValue = storage.getItem(keyComputed.value);
            if (v == null) {
                dispatchWriteEvent(oldValue, null);
                storage.removeItem(keyComputed.value);
            } else {
                const serialized = serializer.write(v);
                if (oldValue !== serialized) {
                    storage.setItem(keyComputed.value, serialized);
                    dispatchWriteEvent(oldValue, serialized);
                }
            }
        } catch (e) {
            onError(e);
        }
    }
    function read(event) {
        const rawValue = event ? event.newValue : storage.getItem(keyComputed.value);
        if (rawValue == null) {
            if (writeDefaults && rawInit != null) storage.setItem(keyComputed.value, serializer.write(rawInit));
            return rawInit;
        } else if (!event && mergeDefaults) {
            const value = serializer.read(rawValue);
            if (typeof mergeDefaults === "function") return mergeDefaults(value, rawInit);
            else if (type === "object" && !Array.isArray(value)) return {
                ...rawInit,
                ...value
            };
            return value;
        } else if (typeof rawValue !== "string") return rawValue;
        else return serializer.read(rawValue);
    }
    function update(event) {
        if (event && event.storageArea !== storage) return;
        if (event && event.key == null) {
            data.value = rawInit;
            return;
        }
        if (event && event.key !== keyComputed.value) return;
        pauseWatch();
        try {
            const serializedData = serializer.write(data.value);
            if (event === void 0 || (event === null || event === void 0 ? void 0 : event.newValue) !== serializedData) data.value = read(event);
        } catch (e) {
            onError(e);
        } finally{
            if (event) (0, $TusQn.nextTick)(resumeWatch);
            else resumeWatch();
        }
    }
    function updateFromCustomEvent(event) {
        update(event.detail);
    }
    return data;
}
//#endregion
//#region useColorMode/index.ts
const $85ea9b47855776cf$var$CSS_DISABLE_TRANS = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
/**
* Reactive color mode with auto data persistence.
*
* @see https://vueuse.org/useColorMode
* @param options
*/ function $85ea9b47855776cf$export$20f3076712c8dfa(options = {}) {
    const { selector: selector = "html", attribute: attribute = "class", initialValue: initialValue = "auto", window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, storage: storage, storageKey: storageKey = "vueuse-color-scheme", listenToStorageChanges: listenToStorageChanges = true, storageRef: storageRef, emitAuto: emitAuto, disableTransition: disableTransition = true } = options;
    const modes = {
        auto: "",
        light: "light",
        dark: "dark",
        ...options.modes || {}
    };
    const preferredDark = $85ea9b47855776cf$export$a9fe667866660cd5({
        window: window1
    });
    const system = (0, $01W3b.computed)(()=>preferredDark.value ? "dark" : "light");
    const store = storageRef || (storageKey == null ? (0, $aPZNl.toRef)(initialValue) : $85ea9b47855776cf$export$95809329f49ea9f9(storageKey, initialValue, storage, {
        window: window1,
        listenToStorageChanges: listenToStorageChanges
    }));
    const state = (0, $01W3b.computed)(()=>store.value === "auto" ? system.value : store.value);
    const updateHTMLAttrs = $85ea9b47855776cf$export$b0cf1ae5a98eb83b("updateHTMLAttrs", (selector, attribute, value)=>{
        const el = typeof selector === "string" ? window1 === null || window1 === void 0 ? void 0 : window1.document.querySelector(selector) : $85ea9b47855776cf$export$c61124d3cf5adbae(selector);
        if (!el) return;
        const classesToAdd = /* @__PURE__ */ new Set();
        const classesToRemove = /* @__PURE__ */ new Set();
        let attributeToChange = null;
        if (attribute === "class") {
            const current = value.split(/\s/g);
            Object.values(modes).flatMap((i)=>(i || "").split(/\s/g)).filter(Boolean).forEach((v)=>{
                if (current.includes(v)) classesToAdd.add(v);
                else classesToRemove.add(v);
            });
        } else attributeToChange = {
            key: attribute,
            value: value
        };
        if (classesToAdd.size === 0 && classesToRemove.size === 0 && attributeToChange === null) return;
        let style;
        if (disableTransition) {
            style = window1.document.createElement("style");
            style.appendChild(document.createTextNode($85ea9b47855776cf$var$CSS_DISABLE_TRANS));
            window1.document.head.appendChild(style);
        }
        for (const c of classesToAdd)el.classList.add(c);
        for (const c of classesToRemove)el.classList.remove(c);
        if (attributeToChange) el.setAttribute(attributeToChange.key, attributeToChange.value);
        if (disableTransition) {
            window1.getComputedStyle(style).opacity;
            document.head.removeChild(style);
        }
    });
    function defaultOnChanged(mode) {
        var _modes$mode;
        updateHTMLAttrs(selector, attribute, (_modes$mode = modes[mode]) !== null && _modes$mode !== void 0 ? _modes$mode : mode);
    }
    function onChanged(mode) {
        if (options.onChanged) options.onChanged(mode, defaultOnChanged);
        else defaultOnChanged(mode);
    }
    (0, $01W3b.watch)(state, onChanged, {
        flush: "post",
        immediate: true
    });
    (0, $aPZNl.tryOnMounted)(()=>onChanged(state.value));
    const auto = (0, $01W3b.computed)({
        get () {
            return emitAuto ? store.value : state.value;
        },
        set (v) {
            store.value = v;
        }
    });
    return Object.assign(auto, {
        store: store,
        system: system,
        state: state
    });
}
//#endregion
//#region useConfirmDialog/index.ts
/**
* Hooks for creating confirm dialogs. Useful for modal windows, popups and logins.
*
* @see https://vueuse.org/useConfirmDialog/
* @param revealed `boolean` `ref` that handles a modal window
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$93c95fc6177ab5cd(revealed = (0, $01W3b.shallowRef)(false)) {
    const confirmHook = (0, $aPZNl.createEventHook)();
    const cancelHook = (0, $aPZNl.createEventHook)();
    const revealHook = (0, $aPZNl.createEventHook)();
    let _resolve = (0, $aPZNl.noop);
    const reveal = (data)=>{
        revealHook.trigger(data);
        revealed.value = true;
        return new Promise((resolve)=>{
            _resolve = resolve;
        });
    };
    const confirm = (data)=>{
        revealed.value = false;
        confirmHook.trigger(data);
        _resolve({
            data: data,
            isCanceled: false
        });
    };
    const cancel = (data)=>{
        revealed.value = false;
        cancelHook.trigger(data);
        _resolve({
            data: data,
            isCanceled: true
        });
    };
    return {
        isRevealed: (0, $01W3b.computed)(()=>revealed.value),
        reveal: reveal,
        confirm: confirm,
        cancel: cancel,
        onReveal: revealHook.on,
        onConfirm: confirmHook.on,
        onCancel: cancelHook.on
    };
}
//#endregion
//#region useCountdown/index.ts
function $85ea9b47855776cf$var$getDefaultScheduler$8(options) {
    if ("interval" in options || "immediate" in options) {
        const { interval: interval = 1e3, immediate: immediate = false } = options;
        return (cb)=>(0, $aPZNl.useIntervalFn)(cb, interval, {
                immediate: immediate
            });
    }
    return (cb)=>(0, $aPZNl.useIntervalFn)(cb, 1e3, {
            immediate: false
        });
}
/**
* Reactive countdown timer in seconds.
*
* @param initialCountdown
* @param options
*
* @see https://vueuse.org/useCountdown
*/ function $85ea9b47855776cf$export$8103f7eb37e19f7b(initialCountdown, options = {}) {
    const remaining = (0, $01W3b.shallowRef)((0, $01W3b.toValue)(initialCountdown));
    const { scheduler: scheduler = $85ea9b47855776cf$var$getDefaultScheduler$8(options), onTick: onTick, onComplete: onComplete } = options;
    const controls = scheduler(()=>{
        const value = remaining.value - 1;
        remaining.value = value < 0 ? 0 : value;
        onTick === null || onTick === void 0 || onTick();
        if (remaining.value <= 0) {
            controls.pause();
            onComplete === null || onComplete === void 0 || onComplete();
        }
    });
    const reset = (countdown)=>{
        var _toValue;
        remaining.value = (_toValue = (0, $01W3b.toValue)(countdown)) !== null && _toValue !== void 0 ? _toValue : (0, $01W3b.toValue)(initialCountdown);
    };
    const stop = ()=>{
        controls.pause();
        reset();
    };
    const resume = ()=>{
        if (!controls.isActive.value) {
            if (remaining.value > 0) controls.resume();
        }
    };
    const start = (countdown)=>{
        reset(countdown);
        controls.resume();
    };
    return {
        remaining: remaining,
        reset: reset,
        stop: stop,
        start: start,
        pause: controls.pause,
        resume: resume,
        isActive: controls.isActive
    };
}
//#endregion
//#region useCssSupports/index.ts
function $85ea9b47855776cf$export$c47f322ff6a4dadb(...args) {
    let options = {};
    if (typeof (0, $01W3b.toValue)(args.at(-1)) === "object") options = args.pop();
    const [prop, value] = args;
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, ssrValue: ssrValue = false } = options;
    const isMounted = $85ea9b47855776cf$export$bce3bfec9f56c837();
    return {
        isSupported: (0, $01W3b.computed)(()=>{
            if (!(0, $aPZNl.isClient) || !isMounted.value) return ssrValue;
            return args.length === 2 ? window1 === null || window1 === void 0 ? void 0 : window1.CSS.supports((0, $01W3b.toValue)(prop), (0, $01W3b.toValue)(value)) : window1 === null || window1 === void 0 ? void 0 : window1.CSS.supports((0, $01W3b.toValue)(prop));
        })
    };
}
//#endregion
//#region useCssVar/index.ts
/**
* Manipulate CSS variables.
*
* @see https://vueuse.org/useCssVar
* @param prop
* @param target
* @param options
*/ function $85ea9b47855776cf$export$811e58a9be6ff112(prop, target, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, initialValue: initialValue, observe: observe = false } = options;
    const variable = (0, $01W3b.shallowRef)(initialValue);
    const elRef = (0, $01W3b.computed)(()=>{
        var _window$document;
        return $85ea9b47855776cf$export$c61124d3cf5adbae(target) || (window1 === null || window1 === void 0 || (_window$document = window1.document) === null || _window$document === void 0 ? void 0 : _window$document.documentElement);
    });
    function updateCssVar() {
        const key = (0, $01W3b.toValue)(prop);
        const el = (0, $01W3b.toValue)(elRef);
        if (el && window1 && key) {
            var _window$getComputedSt;
            variable.value = ((_window$getComputedSt = window1.getComputedStyle(el).getPropertyValue(key)) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.trim()) || variable.value || initialValue;
        }
    }
    if (observe) $85ea9b47855776cf$export$8ecdcf3bb089e9cd(elRef, updateCssVar, {
        attributeFilter: [
            "style",
            "class"
        ],
        window: window1
    });
    (0, $01W3b.watch)([
        elRef,
        ()=>(0, $01W3b.toValue)(prop)
    ], (_, old)=>{
        if (old[0] && old[1]) old[0].style.removeProperty(old[1]);
        updateCssVar();
    }, {
        immediate: true
    });
    (0, $01W3b.watch)([
        variable,
        elRef
    ], ([val, el])=>{
        const raw_prop = (0, $01W3b.toValue)(prop);
        if ((el === null || el === void 0 ? void 0 : el.style) && raw_prop) {
            if (val == null) el.style.removeProperty(raw_prop);
            else el.style.setProperty(raw_prop, val);
        }
    }, {
        immediate: true
    });
    return variable;
}
//#endregion
//#region useCurrentElement/index.ts
function $85ea9b47855776cf$export$8d937a32bc2b31dd(rootComponent) {
    const vm = (0, $TusQn.getCurrentInstance)();
    const currentElement = (0, $aPZNl.computedWithControl)(()=>null, ()=>rootComponent ? $85ea9b47855776cf$export$c61124d3cf5adbae(rootComponent) : vm.proxy.$el);
    (0, $TusQn.onUpdated)(currentElement.trigger);
    (0, $TusQn.onMounted)(currentElement.trigger);
    return currentElement;
}
//#endregion
//#region useCycleList/index.ts
/**
* Cycle through a list of items
*
* @see https://vueuse.org/useCycleList
*/ function $85ea9b47855776cf$export$a43ea948f6bdcecc(list, options) {
    const state = (0, $01W3b.shallowRef)(getInitialValue());
    const listRef = (0, $aPZNl.toRef)(list);
    const index = (0, $01W3b.computed)({
        get () {
            var _options$fallbackInde;
            const targetList = listRef.value;
            let index = (options === null || options === void 0 ? void 0 : options.getIndexOf) ? options.getIndexOf(state.value, targetList) : targetList.indexOf(state.value);
            if (index < 0) index = (_options$fallbackInde = options === null || options === void 0 ? void 0 : options.fallbackIndex) !== null && _options$fallbackInde !== void 0 ? _options$fallbackInde : 0;
            return index;
        },
        set (v) {
            set(v);
        }
    });
    function set(i) {
        const targetList = listRef.value;
        const length = targetList.length;
        const value = targetList[(i % length + length) % length];
        state.value = value;
        return value;
    }
    function shift(delta = 1) {
        return set(index.value + delta);
    }
    function next(n = 1) {
        return shift(n);
    }
    function prev(n = 1) {
        return shift(-n);
    }
    function getInitialValue() {
        var _toValue, _options$initialValue;
        return (_toValue = (0, $01W3b.toValue)((_options$initialValue = options === null || options === void 0 ? void 0 : options.initialValue) !== null && _options$initialValue !== void 0 ? _options$initialValue : (0, $01W3b.toValue)(list)[0])) !== null && _toValue !== void 0 ? _toValue : void 0;
    }
    (0, $01W3b.watch)(listRef, ()=>set(index.value));
    return {
        state: state,
        index: index,
        next: next,
        prev: prev,
        go: set
    };
}
//#endregion
//#region useDark/index.ts
/**
* Reactive dark mode with auto data persistence.
*
* @see https://vueuse.org/useDark
* @param options
*/ function $85ea9b47855776cf$export$b067746439a7c60(options = {}) {
    const { valueDark: valueDark = "dark", valueLight: valueLight = "" } = options;
    const mode = $85ea9b47855776cf$export$20f3076712c8dfa({
        ...options,
        onChanged: (mode, defaultHandler)=>{
            var _options$onChanged;
            if (options.onChanged) (_options$onChanged = options.onChanged) === null || _options$onChanged === void 0 || _options$onChanged.call(options, mode === "dark", defaultHandler, mode);
            else defaultHandler(mode);
        },
        modes: {
            dark: valueDark,
            light: valueLight
        }
    });
    const system = (0, $01W3b.computed)(()=>mode.system.value);
    return (0, $01W3b.computed)({
        get () {
            return mode.value === "dark";
        },
        set (v) {
            const modeVal = v ? "dark" : "light";
            if (system.value === modeVal) mode.value = "auto";
            else mode.value = modeVal;
        }
    });
}
//#endregion
//#region useManualRefHistory/index.ts
function $85ea9b47855776cf$var$fnBypass(v) {
    return v;
}
function $85ea9b47855776cf$var$fnSetSource(source, value) {
    return source.value = value;
}
function $85ea9b47855776cf$var$defaultDump(clone) {
    return clone ? typeof clone === "function" ? clone : $85ea9b47855776cf$export$9e72043f8ff3a3df : $85ea9b47855776cf$var$fnBypass;
}
function $85ea9b47855776cf$var$defaultParse(clone) {
    return clone ? typeof clone === "function" ? clone : $85ea9b47855776cf$export$9e72043f8ff3a3df : $85ea9b47855776cf$var$fnBypass;
}
/**
* Track the change history of a ref, also provides undo and redo functionality.
*
* @see https://vueuse.org/useManualRefHistory
* @param source
* @param options
*/ function $85ea9b47855776cf$export$614531ad6f0c8fd(source, options = {}) {
    const { clone: clone = false, dump: dump = $85ea9b47855776cf$var$defaultDump(clone), parse: parse = $85ea9b47855776cf$var$defaultParse(clone), setSource: setSource = $85ea9b47855776cf$var$fnSetSource } = options;
    function _createHistoryRecord() {
        return (0, $01W3b.markRaw)({
            snapshot: dump(source.value),
            timestamp: (0, $aPZNl.timestamp)()
        });
    }
    const last = (0, $01W3b.ref)(_createHistoryRecord());
    const undoStack = (0, $01W3b.ref)([]);
    const redoStack = (0, $01W3b.ref)([]);
    const _setSource = (record)=>{
        setSource(source, parse(record.snapshot));
        last.value = record;
    };
    const commit = ()=>{
        undoStack.value.unshift(last.value);
        last.value = _createHistoryRecord();
        if (options.capacity && undoStack.value.length > options.capacity) undoStack.value.splice(options.capacity, Number.POSITIVE_INFINITY);
        if (redoStack.value.length) redoStack.value.splice(0, redoStack.value.length);
    };
    const clear = ()=>{
        undoStack.value.splice(0, undoStack.value.length);
        redoStack.value.splice(0, redoStack.value.length);
    };
    const undo = ()=>{
        const state = undoStack.value.shift();
        if (state) {
            redoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    const redo = ()=>{
        const state = redoStack.value.shift();
        if (state) {
            undoStack.value.unshift(last.value);
            _setSource(state);
        }
    };
    const reset = ()=>{
        _setSource(last.value);
    };
    return {
        source: source,
        undoStack: undoStack,
        redoStack: redoStack,
        last: last,
        history: (0, $01W3b.computed)(()=>[
                last.value,
                ...undoStack.value
            ]),
        canUndo: (0, $01W3b.computed)(()=>undoStack.value.length > 0),
        canRedo: (0, $01W3b.computed)(()=>redoStack.value.length > 0),
        clear: clear,
        commit: commit,
        reset: reset,
        undo: undo,
        redo: redo
    };
}
//#endregion
//#region useRefHistory/index.ts
/**
* Track the change history of a ref, also provides undo and redo functionality.
*
* @see https://vueuse.org/useRefHistory
* @param source
* @param options
*/ function $85ea9b47855776cf$export$de889b39e422efc4(source, options = {}) {
    const { deep: deep = false, flush: flush = "pre", eventFilter: eventFilter, shouldCommit: shouldCommit = ()=>true } = options;
    const { eventFilter: composedFilter, pause: pause, resume: resumeTracking, isActive: isTracking } = (0, $aPZNl.pausableFilter)(eventFilter);
    let lastRawValue = source.value;
    const { ignoreUpdates: ignoreUpdates, ignorePrevAsyncUpdates: ignorePrevAsyncUpdates, stop: stop } = (0, $aPZNl.watchIgnorable)(source, commit, {
        deep: deep,
        flush: flush,
        eventFilter: composedFilter
    });
    function setSource(source, value) {
        ignorePrevAsyncUpdates();
        ignoreUpdates(()=>{
            source.value = value;
            lastRawValue = value;
        });
    }
    const manualHistory = $85ea9b47855776cf$export$614531ad6f0c8fd(source, {
        ...options,
        clone: options.clone || deep,
        setSource: setSource
    });
    const { clear: clear, commit: manualCommit } = manualHistory;
    function commit() {
        ignorePrevAsyncUpdates();
        if (!shouldCommit(lastRawValue, source.value)) return;
        lastRawValue = source.value;
        manualCommit();
    }
    function resume(commitNow) {
        resumeTracking();
        if (commitNow) commit();
    }
    function batch(fn) {
        let canceled = false;
        const cancel = ()=>canceled = true;
        ignoreUpdates(()=>{
            fn(cancel);
        });
        if (!canceled) commit();
    }
    function dispose() {
        stop();
        clear();
    }
    return {
        ...manualHistory,
        isTracking: isTracking,
        pause: pause,
        resume: resume,
        commit: commit,
        batch: batch,
        dispose: dispose
    };
}
//#endregion
//#region useDebouncedRefHistory/index.ts
/**
* Shorthand for [useRefHistory](https://vueuse.org/useRefHistory) with debounce filter.
*
* @see https://vueuse.org/useDebouncedRefHistory
* @param source
* @param options
*/ function $85ea9b47855776cf$export$3b9372c83f595b14(source, options = {}) {
    const filter = options.debounce ? (0, $aPZNl.debounceFilter)(options.debounce) : void 0;
    return {
        ...$85ea9b47855776cf$export$de889b39e422efc4(source, {
            ...options,
            eventFilter: filter
        })
    };
}
//#endregion
//#region useDeviceMotion/index.ts
/**
* Reactive DeviceMotionEvent.
*
* @see https://vueuse.org/useDeviceMotion
* @param options
*/ function $85ea9b47855776cf$export$45ef0ca3d803202d(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, requestPermissions: requestPermissions = false, eventFilter: eventFilter = (0, $aPZNl.bypassFilter) } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>typeof DeviceMotionEvent !== "undefined");
    const requirePermissions = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>isSupported.value && "requestPermission" in DeviceMotionEvent && typeof DeviceMotionEvent.requestPermission === "function");
    const permissionGranted = (0, $01W3b.shallowRef)(false);
    const acceleration = (0, $01W3b.ref)({
        x: null,
        y: null,
        z: null
    });
    const rotationRate = (0, $01W3b.ref)({
        alpha: null,
        beta: null,
        gamma: null
    });
    const interval = (0, $01W3b.shallowRef)(0);
    const accelerationIncludingGravity = (0, $01W3b.ref)({
        x: null,
        y: null,
        z: null
    });
    function init() {
        if (window1) $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "devicemotion", (0, $aPZNl.createFilterWrapper)(eventFilter, (event)=>{
            var _event$acceleration, _event$acceleration2, _event$acceleration3, _event$accelerationIn, _event$accelerationIn2, _event$accelerationIn3, _event$rotationRate, _event$rotationRate2, _event$rotationRate3;
            acceleration.value = {
                x: ((_event$acceleration = event.acceleration) === null || _event$acceleration === void 0 ? void 0 : _event$acceleration.x) || null,
                y: ((_event$acceleration2 = event.acceleration) === null || _event$acceleration2 === void 0 ? void 0 : _event$acceleration2.y) || null,
                z: ((_event$acceleration3 = event.acceleration) === null || _event$acceleration3 === void 0 ? void 0 : _event$acceleration3.z) || null
            };
            accelerationIncludingGravity.value = {
                x: ((_event$accelerationIn = event.accelerationIncludingGravity) === null || _event$accelerationIn === void 0 ? void 0 : _event$accelerationIn.x) || null,
                y: ((_event$accelerationIn2 = event.accelerationIncludingGravity) === null || _event$accelerationIn2 === void 0 ? void 0 : _event$accelerationIn2.y) || null,
                z: ((_event$accelerationIn3 = event.accelerationIncludingGravity) === null || _event$accelerationIn3 === void 0 ? void 0 : _event$accelerationIn3.z) || null
            };
            rotationRate.value = {
                alpha: ((_event$rotationRate = event.rotationRate) === null || _event$rotationRate === void 0 ? void 0 : _event$rotationRate.alpha) || null,
                beta: ((_event$rotationRate2 = event.rotationRate) === null || _event$rotationRate2 === void 0 ? void 0 : _event$rotationRate2.beta) || null,
                gamma: ((_event$rotationRate3 = event.rotationRate) === null || _event$rotationRate3 === void 0 ? void 0 : _event$rotationRate3.gamma) || null
            };
            interval.value = event.interval;
        }), {
            passive: true
        });
    }
    const ensurePermissions = async ()=>{
        if (!requirePermissions.value) permissionGranted.value = true;
        if (permissionGranted.value) return;
        if (requirePermissions.value) {
            const requestPermission = DeviceMotionEvent.requestPermission;
            try {
                if (await requestPermission() === "granted") {
                    permissionGranted.value = true;
                    init();
                }
            } catch (error) {
                console.error(error);
            }
        }
    };
    if (isSupported.value) {
        if (requestPermissions && requirePermissions.value) ensurePermissions().then(()=>init());
        else init();
    }
    return {
        acceleration: acceleration,
        accelerationIncludingGravity: accelerationIncludingGravity,
        rotationRate: rotationRate,
        interval: interval,
        isSupported: isSupported,
        requirePermissions: requirePermissions,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted
    };
}
//#endregion
//#region useDeviceOrientation/index.ts
/**
* Reactive DeviceOrientationEvent.
*
* @see https://vueuse.org/useDeviceOrientation
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$9bafe4f626b63a33(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && "DeviceOrientationEvent" in window1);
    const isAbsolute = (0, $01W3b.shallowRef)(false);
    const alpha = (0, $01W3b.shallowRef)(null);
    const beta = (0, $01W3b.shallowRef)(null);
    const gamma = (0, $01W3b.shallowRef)(null);
    if (window1 && isSupported.value) $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "deviceorientation", (event)=>{
        isAbsolute.value = event.absolute;
        alpha.value = event.alpha;
        beta.value = event.beta;
        gamma.value = event.gamma;
    }, {
        passive: true
    });
    return {
        isSupported: isSupported,
        isAbsolute: isAbsolute,
        alpha: alpha,
        beta: beta,
        gamma: gamma
    };
}
//#endregion
//#region useDevicePixelRatio/index.ts
/**
* Reactively track `window.devicePixelRatio`.
*
* @see https://vueuse.org/useDevicePixelRatio
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$9619f0fa9e7879c6(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const pixelRatio = (0, $01W3b.shallowRef)(1);
    const query = $85ea9b47855776cf$export$32d5543ab307c01(()=>`(resolution: ${pixelRatio.value}dppx)`, options);
    let stop = (0, $aPZNl.noop);
    if (window1) stop = (0, $aPZNl.watchImmediate)(query, ()=>pixelRatio.value = window1.devicePixelRatio);
    return {
        pixelRatio: (0, $01W3b.shallowReadonly)(pixelRatio),
        stop: stop
    };
}
//#endregion
//#region useDevicesList/index.ts
/**
* Reactive `enumerateDevices` listing available input/output devices
*
* @see https://vueuse.org/useDevicesList
* @param options
*/ function $85ea9b47855776cf$export$c860eb59c2f56cac(options = {}) {
    const { navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc, requestPermissions: requestPermissions = false, constraints: constraints = {
        audio: true,
        video: true
    }, onUpdated: onUpdated } = options;
    const devices = (0, $01W3b.shallowRef)([]);
    const videoInputs = (0, $01W3b.computed)(()=>devices.value.filter((i)=>i.kind === "videoinput"));
    const audioInputs = (0, $01W3b.computed)(()=>devices.value.filter((i)=>i.kind === "audioinput"));
    const audioOutputs = (0, $01W3b.computed)(()=>devices.value.filter((i)=>i.kind === "audiooutput"));
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && navigator1.mediaDevices && navigator1.mediaDevices.enumerateDevices);
    const permissionGranted = (0, $01W3b.shallowRef)(false);
    let stream;
    async function update() {
        if (!isSupported.value) return;
        devices.value = await navigator1.mediaDevices.enumerateDevices();
        onUpdated === null || onUpdated === void 0 || onUpdated(devices.value);
        if (stream) {
            stream.getTracks().forEach((t)=>t.stop());
            stream = null;
        }
    }
    async function ensurePermissions() {
        const deviceName = constraints.video ? "camera" : "microphone";
        if (!isSupported.value) return false;
        if (permissionGranted.value) return true;
        const { state: state, query: query } = $85ea9b47855776cf$export$d7376454a3cf5ab4(deviceName, {
            controls: true
        });
        await query();
        if (state.value !== "granted") {
            let granted = true;
            try {
                const allDevices = await navigator1.mediaDevices.enumerateDevices();
                const hasCamera = allDevices.some((device)=>device.kind === "videoinput");
                const hasMicrophone = allDevices.some((device)=>device.kind === "audioinput" || device.kind === "audiooutput");
                constraints.video = hasCamera ? constraints.video : false;
                constraints.audio = hasMicrophone ? constraints.audio : false;
                stream = await navigator1.mediaDevices.getUserMedia(constraints);
            } catch (_unused) {
                stream = null;
                granted = false;
            }
            update();
            permissionGranted.value = granted;
        } else permissionGranted.value = true;
        return permissionGranted.value;
    }
    if (isSupported.value) {
        if (requestPermissions) ensurePermissions();
        $85ea9b47855776cf$export$7080b3e976bc91ab(navigator1.mediaDevices, "devicechange", update, {
            passive: true
        });
        update();
    }
    return {
        devices: devices,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        videoInputs: videoInputs,
        audioInputs: audioInputs,
        audioOutputs: audioOutputs,
        isSupported: isSupported
    };
}
//#endregion
//#region useDisplayMedia/index.ts
/**
* Reactive `mediaDevices.getDisplayMedia` streaming
*
* @see https://vueuse.org/useDisplayMedia
* @param options
*/ function $85ea9b47855776cf$export$f2d17e22a8e6ddfc(options = {}) {
    var _options$enabled;
    const enabled = (0, $01W3b.shallowRef)((_options$enabled = options.enabled) !== null && _options$enabled !== void 0 ? _options$enabled : false);
    const video = options.video;
    const audio = options.audio;
    const { navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>{
        var _navigator$mediaDevic;
        return navigator1 === null || navigator1 === void 0 || (_navigator$mediaDevic = navigator1.mediaDevices) === null || _navigator$mediaDevic === void 0 ? void 0 : _navigator$mediaDevic.getDisplayMedia;
    });
    const constraint = {
        audio: audio,
        video: video
    };
    const stream = (0, $01W3b.shallowRef)();
    async function _start() {
        var _stream$value;
        if (!isSupported.value || stream.value) return;
        stream.value = await navigator1.mediaDevices.getDisplayMedia(constraint);
        (_stream$value = stream.value) === null || _stream$value === void 0 || _stream$value.getTracks().forEach((t)=>$85ea9b47855776cf$export$7080b3e976bc91ab(t, "ended", stop, {
                passive: true
            }));
        return stream.value;
    }
    async function _stop() {
        var _stream$value2;
        (_stream$value2 = stream.value) === null || _stream$value2 === void 0 || _stream$value2.getTracks().forEach((t)=>t.stop());
        stream.value = void 0;
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    async function start() {
        await _start();
        if (stream.value) enabled.value = true;
        return stream.value;
    }
    (0, $01W3b.watch)(enabled, (v)=>{
        if (v) _start();
        else _stop();
    }, {
        immediate: true
    });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        enabled: enabled
    };
}
//#endregion
//#region useDocumentVisibility/index.ts
/**
* Reactively track `document.visibilityState`.
*
* @see https://vueuse.org/useDocumentVisibility
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$87a87a3d299ece7c(options = {}) {
    const { document: document1 = $85ea9b47855776cf$export$37990bd438d16af3 } = options;
    if (!document1) return (0, $01W3b.shallowRef)("visible");
    const visibility = (0, $01W3b.shallowRef)(document1.visibilityState);
    $85ea9b47855776cf$export$7080b3e976bc91ab(document1, "visibilitychange", ()=>{
        visibility.value = document1.visibilityState;
    }, {
        passive: true
    });
    return visibility;
}
//#endregion
//#region useDraggable/index.ts
const $85ea9b47855776cf$var$defaultScrollConfig = {
    speed: 2,
    margin: 30,
    direction: "both"
};
function $85ea9b47855776cf$var$clampContainerScroll(container) {
    if (container.scrollLeft > container.scrollWidth - container.clientWidth) container.scrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
    if (container.scrollTop > container.scrollHeight - container.clientHeight) container.scrollTop = Math.max(0, container.scrollHeight - container.clientHeight);
}
/**
* Make elements draggable.
*
* @see https://vueuse.org/useDraggable
* @param target
* @param options
*/ function $85ea9b47855776cf$export$df30c81f5aa01ff7(target, options = {}) {
    var _toValue, _toValue2, _toValue3, _scrollConfig$directi;
    const { pointerTypes: pointerTypes, preventDefault: preventDefault, stopPropagation: stopPropagation, exact: exact, onMove: onMove, onEnd: onEnd, onStart: onStart, initialValue: initialValue, axis: axis = "both", draggingElement: draggingElement = $85ea9b47855776cf$export$16f8ba610718ae4a, containerElement: containerElement, handle: draggingHandle = target, buttons: buttons = [
        0
    ], restrictInView: restrictInView, autoScroll: autoScroll = false } = options;
    const position = (0, $01W3b.ref)((_toValue = (0, $01W3b.toValue)(initialValue)) !== null && _toValue !== void 0 ? _toValue : {
        x: 0,
        y: 0
    });
    const pressedDelta = (0, $01W3b.ref)();
    const filterEvent = (e)=>{
        if (pointerTypes) return pointerTypes.includes(e.pointerType);
        return true;
    };
    const handleEvent = (e)=>{
        if ((0, $01W3b.toValue)(preventDefault)) e.preventDefault();
        if ((0, $01W3b.toValue)(stopPropagation)) e.stopPropagation();
    };
    const scrollConfig = (0, $01W3b.toValue)(autoScroll);
    const scrollSettings = typeof scrollConfig === "object" ? {
        speed: (_toValue2 = (0, $01W3b.toValue)(scrollConfig.speed)) !== null && _toValue2 !== void 0 ? _toValue2 : $85ea9b47855776cf$var$defaultScrollConfig.speed,
        margin: (_toValue3 = (0, $01W3b.toValue)(scrollConfig.margin)) !== null && _toValue3 !== void 0 ? _toValue3 : $85ea9b47855776cf$var$defaultScrollConfig.margin,
        direction: (_scrollConfig$directi = scrollConfig.direction) !== null && _scrollConfig$directi !== void 0 ? _scrollConfig$directi : $85ea9b47855776cf$var$defaultScrollConfig.direction
    } : $85ea9b47855776cf$var$defaultScrollConfig;
    const getScrollAxisValues = (value)=>typeof value === "number" ? [
            value,
            value
        ] : [
            value.x,
            value.y
        ];
    const handleAutoScroll = (container, targetRect, position)=>{
        const { clientWidth: clientWidth, clientHeight: clientHeight, scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, scrollHeight: scrollHeight } = container;
        const [marginX, marginY] = getScrollAxisValues(scrollSettings.margin);
        const [speedX, speedY] = getScrollAxisValues(scrollSettings.speed);
        let deltaX = 0;
        let deltaY = 0;
        if (scrollSettings.direction === "x" || scrollSettings.direction === "both") {
            if (position.x < marginX && scrollLeft > 0) deltaX = -speedX;
            else if (position.x + targetRect.width > clientWidth - marginX && scrollLeft < scrollWidth - clientWidth) deltaX = speedX;
        }
        if (scrollSettings.direction === "y" || scrollSettings.direction === "both") {
            if (position.y < marginY && scrollTop > 0) deltaY = -speedY;
            else if (position.y + targetRect.height > clientHeight - marginY && scrollTop < scrollHeight - clientHeight) deltaY = speedY;
        }
        if (deltaX || deltaY) container.scrollBy({
            left: deltaX,
            top: deltaY,
            behavior: "auto"
        });
    };
    let autoScrollInterval = null;
    const startAutoScroll = ()=>{
        const container = (0, $01W3b.toValue)(containerElement);
        if (container && !autoScrollInterval) autoScrollInterval = setInterval(()=>{
            const targetRect = (0, $01W3b.toValue)(target).getBoundingClientRect();
            const { x: x, y: y } = position.value;
            const relativePosition = {
                x: x - container.scrollLeft,
                y: y - container.scrollTop
            };
            if (relativePosition.x >= 0 && relativePosition.y >= 0) {
                handleAutoScroll(container, targetRect, relativePosition);
                relativePosition.x += container.scrollLeft;
                relativePosition.y += container.scrollTop;
                position.value = relativePosition;
            }
        }, 1e3 / 60);
    };
    const stopAutoScroll = ()=>{
        if (autoScrollInterval) {
            clearInterval(autoScrollInterval);
            autoScrollInterval = null;
        }
    };
    const isPointerNearEdge = (pointer, container, margin, targetRect)=>{
        const [marginX, marginY] = typeof margin === "number" ? [
            margin,
            margin
        ] : [
            margin.x,
            margin.y
        ];
        const { clientWidth: clientWidth, clientHeight: clientHeight } = container;
        return pointer.x < marginX || pointer.x + targetRect.width > clientWidth - marginX || pointer.y < marginY || pointer.y + targetRect.height > clientHeight - marginY;
    };
    const checkAutoScroll = ()=>{
        if ((0, $01W3b.toValue)(options.disabled) || !pressedDelta.value) return;
        const container = (0, $01W3b.toValue)(containerElement);
        if (!container) return;
        const targetRect = (0, $01W3b.toValue)(target).getBoundingClientRect();
        const { x: x, y: y } = position.value;
        if (isPointerNearEdge({
            x: x - container.scrollLeft,
            y: y - container.scrollTop
        }, container, scrollSettings.margin, targetRect)) startAutoScroll();
        else stopAutoScroll();
    };
    if ((0, $01W3b.toValue)(autoScroll)) (0, $01W3b.watch)(position, checkAutoScroll);
    const start = (e)=>{
        var _container$getBoundin;
        if (!(0, $01W3b.toValue)(buttons).includes(e.button)) return;
        if ((0, $01W3b.toValue)(options.disabled) || !filterEvent(e)) return;
        if ((0, $01W3b.toValue)(exact) && e.target !== (0, $01W3b.toValue)(target)) return;
        const container = (0, $01W3b.toValue)(containerElement);
        const containerRect = container === null || container === void 0 || (_container$getBoundin = container.getBoundingClientRect) === null || _container$getBoundin === void 0 ? void 0 : _container$getBoundin.call(container);
        const targetRect = (0, $01W3b.toValue)(target).getBoundingClientRect();
        const pos = {
            x: e.clientX - (container ? targetRect.left - containerRect.left + (autoScroll ? 0 : container.scrollLeft) : targetRect.left),
            y: e.clientY - (container ? targetRect.top - containerRect.top + (autoScroll ? 0 : container.scrollTop) : targetRect.top)
        };
        if ((onStart === null || onStart === void 0 ? void 0 : onStart(pos, e)) === false) return;
        pressedDelta.value = pos;
        handleEvent(e);
    };
    const move = (e)=>{
        if ((0, $01W3b.toValue)(options.disabled) || !filterEvent(e)) return;
        if (!pressedDelta.value) return;
        const container = (0, $01W3b.toValue)(containerElement);
        if (container instanceof HTMLElement) $85ea9b47855776cf$var$clampContainerScroll(container);
        const targetRect = (0, $01W3b.toValue)(target).getBoundingClientRect();
        let { x: x, y: y } = position.value;
        if (axis === "x" || axis === "both") {
            x = e.clientX - pressedDelta.value.x;
            if (container) x = Math.min(Math.max(0, x), container.scrollWidth - targetRect.width);
        }
        if (axis === "y" || axis === "both") {
            y = e.clientY - pressedDelta.value.y;
            if (container) y = Math.min(Math.max(0, y), container.scrollHeight - targetRect.height);
        }
        if ((0, $01W3b.toValue)(autoScroll) && container) {
            if (autoScrollInterval === null) handleAutoScroll(container, targetRect, {
                x: x,
                y: y
            });
            x += container.scrollLeft;
            y += container.scrollTop;
        }
        if (container && (restrictInView || autoScroll)) {
            if (axis !== "y") {
                const relativeX = x - container.scrollLeft;
                if (relativeX < 0) x = container.scrollLeft;
                else if (relativeX > container.clientWidth - targetRect.width) x = container.clientWidth - targetRect.width + container.scrollLeft;
            }
            if (axis !== "x") {
                const relativeY = y - container.scrollTop;
                if (relativeY < 0) y = container.scrollTop;
                else if (relativeY > container.clientHeight - targetRect.height) y = container.clientHeight - targetRect.height + container.scrollTop;
            }
        }
        position.value = {
            x: x,
            y: y
        };
        onMove === null || onMove === void 0 || onMove(position.value, e);
        handleEvent(e);
    };
    const end = (e)=>{
        if ((0, $01W3b.toValue)(options.disabled) || !filterEvent(e)) return;
        if (!pressedDelta.value) return;
        pressedDelta.value = void 0;
        if (autoScroll) stopAutoScroll();
        onEnd === null || onEnd === void 0 || onEnd(position.value, e);
        handleEvent(e);
    };
    if (0, $aPZNl.isClient) {
        const config = ()=>{
            var _options$capture;
            return {
                capture: (_options$capture = options.capture) !== null && _options$capture !== void 0 ? _options$capture : true,
                passive: !(0, $01W3b.toValue)(preventDefault)
            };
        };
        $85ea9b47855776cf$export$7080b3e976bc91ab(draggingHandle, "pointerdown", start, config);
        $85ea9b47855776cf$export$7080b3e976bc91ab(draggingElement, "pointermove", move, config);
        $85ea9b47855776cf$export$7080b3e976bc91ab(draggingElement, "pointerup", end, config);
    }
    return {
        ...(0, $aPZNl.toRefs)(position),
        position: position,
        isDragging: (0, $01W3b.computed)(()=>!!pressedDelta.value),
        style: (0, $01W3b.computed)(()=>`
      left: ${position.value.x}px;
      top: ${position.value.y}px;
      ${autoScroll ? "text-wrap: nowrap;" : ""}
    `)
    };
}
//#endregion
//#region useDropZone/index.ts
function $85ea9b47855776cf$export$ff33ba24b8f2a683(target, options = {}) {
    const isOverDropZone = (0, $01W3b.shallowRef)(false);
    const files = (0, $01W3b.shallowRef)(null);
    let counter = 0;
    let isValid = true;
    if (0, $aPZNl.isClient) {
        var _options$multiple, _options$preventDefau;
        const _options = typeof options === "function" ? {
            onDrop: options
        } : options;
        const multiple = (_options$multiple = _options.multiple) !== null && _options$multiple !== void 0 ? _options$multiple : true;
        const preventDefaultForUnhandled = (_options$preventDefau = _options.preventDefaultForUnhandled) !== null && _options$preventDefau !== void 0 ? _options$preventDefau : false;
        const getFiles = (event)=>{
            var _event$dataTransfer$f, _event$dataTransfer;
            const list = Array.from((_event$dataTransfer$f = (_event$dataTransfer = event.dataTransfer) === null || _event$dataTransfer === void 0 ? void 0 : _event$dataTransfer.files) !== null && _event$dataTransfer$f !== void 0 ? _event$dataTransfer$f : []);
            return list.length === 0 ? null : multiple ? list : [
                list[0]
            ];
        };
        const checkDataTypes = (types)=>{
            const dataTypes = (0, $01W3b.unref)(_options.dataTypes);
            if (typeof dataTypes === "function") return dataTypes(types);
            if (!(dataTypes === null || dataTypes === void 0 ? void 0 : dataTypes.length)) return true;
            if (types.length === 0) return false;
            return types.every((type)=>dataTypes.some((allowedType)=>type.includes(allowedType)));
        };
        const checkValidity = (items)=>{
            if (_options.checkValidity) return _options.checkValidity(items);
            const dataTypesValid = checkDataTypes(Array.from(items !== null && items !== void 0 ? items : []).map((item)=>item.type));
            const multipleFilesValid = multiple || items.length <= 1;
            return dataTypesValid && multipleFilesValid;
        };
        const isSafari = ()=>/^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !("chrome" in window);
        const handleDragEvent = (event, eventType)=>{
            var _event$dataTransfer2, _ref;
            const dataTransferItemList = (_event$dataTransfer2 = event.dataTransfer) === null || _event$dataTransfer2 === void 0 ? void 0 : _event$dataTransfer2.items;
            isValid = (_ref = dataTransferItemList && checkValidity(dataTransferItemList)) !== null && _ref !== void 0 ? _ref : false;
            if (preventDefaultForUnhandled) event.preventDefault();
            if (!isSafari() && !isValid) {
                if (event.dataTransfer) event.dataTransfer.dropEffect = "none";
                return;
            }
            event.preventDefault();
            if (event.dataTransfer) event.dataTransfer.dropEffect = "copy";
            const currentFiles = getFiles(event);
            switch(eventType){
                case "enter":
                    var _options$onEnter;
                    counter += 1;
                    isOverDropZone.value = true;
                    (_options$onEnter = _options.onEnter) === null || _options$onEnter === void 0 || _options$onEnter.call(_options, null, event);
                    break;
                case "over":
                    var _options$onOver;
                    (_options$onOver = _options.onOver) === null || _options$onOver === void 0 || _options$onOver.call(_options, null, event);
                    break;
                case "leave":
                    var _options$onLeave;
                    counter -= 1;
                    if (counter === 0) isOverDropZone.value = false;
                    (_options$onLeave = _options.onLeave) === null || _options$onLeave === void 0 || _options$onLeave.call(_options, null, event);
                    break;
                case "drop":
                    counter = 0;
                    isOverDropZone.value = false;
                    if (isValid) {
                        var _options$onDrop;
                        files.value = currentFiles;
                        (_options$onDrop = _options.onDrop) === null || _options$onDrop === void 0 || _options$onDrop.call(_options, currentFiles, event);
                    }
                    break;
            }
        };
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "dragenter", (event)=>handleDragEvent(event, "enter"));
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "dragover", (event)=>handleDragEvent(event, "over"));
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "dragleave", (event)=>handleDragEvent(event, "leave"));
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "drop", (event)=>handleDragEvent(event, "drop"));
    }
    return {
        files: files,
        isOverDropZone: isOverDropZone
    };
}
//#endregion
//#region useResizeObserver/index.ts
/**
* Reports changes to the dimensions of an Element's content or the border-box
*
* @see https://vueuse.org/useResizeObserver
* @param target
* @param callback
* @param options
*/ function $85ea9b47855776cf$export$683480f191c0e3ea(target, callback, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, ...observerOptions } = options;
    let observer;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && "ResizeObserver" in window1);
    const cleanup = ()=>{
        if (observer) {
            observer.disconnect();
            observer = void 0;
        }
    };
    const stopWatch = (0, $01W3b.watch)((0, $01W3b.computed)(()=>{
        const _targets = (0, $01W3b.toValue)(target);
        return Array.isArray(_targets) ? _targets.map((el)=>$85ea9b47855776cf$export$c61124d3cf5adbae(el)) : [
            $85ea9b47855776cf$export$c61124d3cf5adbae(_targets)
        ];
    }), (els)=>{
        cleanup();
        if (isSupported.value && window1) {
            observer = new ResizeObserver(callback);
            for (const _el of els)if (_el) observer.observe(_el, observerOptions);
        }
    }, {
        immediate: true,
        flush: "post"
    });
    const stop = ()=>{
        cleanup();
        stopWatch();
    };
    (0, $aPZNl.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        stop: stop
    };
}
//#endregion
//#region useElementBounding/index.ts
/**
* Reactive bounding box of an HTML element.
*
* @see https://vueuse.org/useElementBounding
* @param target
*/ function $85ea9b47855776cf$export$f623e6fca765c371(target, options = {}) {
    const { reset: reset = true, windowResize: windowResize = true, windowScroll: windowScroll = true, immediate: immediate = true, updateTiming: updateTiming = "sync" } = options;
    const height = (0, $01W3b.shallowRef)(0);
    const bottom = (0, $01W3b.shallowRef)(0);
    const left = (0, $01W3b.shallowRef)(0);
    const right = (0, $01W3b.shallowRef)(0);
    const top = (0, $01W3b.shallowRef)(0);
    const width = (0, $01W3b.shallowRef)(0);
    const x = (0, $01W3b.shallowRef)(0);
    const y = (0, $01W3b.shallowRef)(0);
    function recalculate() {
        const el = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
        if (!el) {
            if (reset) {
                height.value = 0;
                bottom.value = 0;
                left.value = 0;
                right.value = 0;
                top.value = 0;
                width.value = 0;
                x.value = 0;
                y.value = 0;
            }
            return;
        }
        const rect = el.getBoundingClientRect();
        height.value = rect.height;
        bottom.value = rect.bottom;
        left.value = rect.left;
        right.value = rect.right;
        top.value = rect.top;
        width.value = rect.width;
        x.value = rect.x;
        y.value = rect.y;
    }
    function update() {
        if (updateTiming === "sync") recalculate();
        else if (updateTiming === "next-frame") requestAnimationFrame(()=>recalculate());
    }
    $85ea9b47855776cf$export$683480f191c0e3ea(target, update);
    (0, $01W3b.watch)(()=>$85ea9b47855776cf$export$c61124d3cf5adbae(target), (ele)=>!ele && update());
    $85ea9b47855776cf$export$8ecdcf3bb089e9cd(target, update, {
        attributeFilter: [
            "style",
            "class"
        ]
    });
    if (windowScroll) $85ea9b47855776cf$export$7080b3e976bc91ab("scroll", update, {
        capture: true,
        passive: true
    });
    if (windowResize) $85ea9b47855776cf$export$7080b3e976bc91ab("resize", update, {
        passive: true
    });
    (0, $aPZNl.tryOnMounted)(()=>{
        if (immediate) update();
    });
    return {
        height: height,
        bottom: bottom,
        left: left,
        right: right,
        top: top,
        width: width,
        x: x,
        y: y,
        update: update
    };
}
//#endregion
//#region useElementByPoint/index.ts
function $85ea9b47855776cf$var$getDefaultScheduler$7(options) {
    if ("interval" in options || "immediate" in options) {
        const { interval: interval = "requestAnimationFrame", immediate: immediate = true } = options;
        return interval === "requestAnimationFrame" ? (cb)=>$85ea9b47855776cf$export$13251e0fc79284e(cb, {
                immediate: immediate
            }) : (cb)=>(0, $aPZNl.useIntervalFn)(cb, interval, {
                immediate: immediate
            });
    }
    return $85ea9b47855776cf$export$13251e0fc79284e;
}
/**
* Reactive element by point.
*
* @see https://vueuse.org/useElementByPoint
* @param options - UseElementByPointOptions
*/ function $85ea9b47855776cf$export$f6b6f8dd6f68aad2(options) {
    const { x: x, y: y, document: document1 = $85ea9b47855776cf$export$37990bd438d16af3, multiple: multiple, scheduler: scheduler = $85ea9b47855776cf$var$getDefaultScheduler$7(options) } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>{
        if ((0, $01W3b.toValue)(multiple)) return document1 && "elementsFromPoint" in document1;
        return document1 && "elementFromPoint" in document1;
    });
    const element = (0, $01W3b.shallowRef)(null);
    return {
        isSupported: isSupported,
        element: element,
        ...scheduler(()=>{
            var _document$elementsFro, _document$elementFrom;
            element.value = (0, $01W3b.toValue)(multiple) ? (_document$elementsFro = document1 === null || document1 === void 0 ? void 0 : document1.elementsFromPoint((0, $01W3b.toValue)(x), (0, $01W3b.toValue)(y))) !== null && _document$elementsFro !== void 0 ? _document$elementsFro : [] : (_document$elementFrom = document1 === null || document1 === void 0 ? void 0 : document1.elementFromPoint((0, $01W3b.toValue)(x), (0, $01W3b.toValue)(y))) !== null && _document$elementFrom !== void 0 ? _document$elementFrom : null;
        })
    };
}
//#endregion
//#region useElementHover/index.ts
function $85ea9b47855776cf$export$6e95f3a294e6b04d(el, options = {}) {
    const { delayEnter: delayEnter = 0, delayLeave: delayLeave = 0, triggerOnRemoval: triggerOnRemoval = false, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const isHovered = (0, $01W3b.shallowRef)(false);
    let timer;
    const toggle = (entering)=>{
        const delay = entering ? delayEnter : delayLeave;
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
        }
        if (delay) timer = setTimeout(()=>isHovered.value = entering, delay);
        else isHovered.value = entering;
    };
    if (!window1) return isHovered;
    $85ea9b47855776cf$export$7080b3e976bc91ab(el, "mouseenter", ()=>toggle(true), {
        passive: true
    });
    $85ea9b47855776cf$export$7080b3e976bc91ab(el, "mouseleave", ()=>toggle(false), {
        passive: true
    });
    if (triggerOnRemoval) $85ea9b47855776cf$export$23b05fde944e9922((0, $01W3b.computed)(()=>$85ea9b47855776cf$export$c61124d3cf5adbae(el)), ()=>toggle(false));
    return isHovered;
}
//#endregion
//#region useElementSize/index.ts
/**
* Reactive size of an HTML element.
*
* @see https://vueuse.org/useElementSize
*/ function $85ea9b47855776cf$export$2b86bedf890eab8(target, initialSize = {
    width: 0,
    height: 0
}, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, box: box = "content-box" } = options;
    const isSVG = (0, $01W3b.computed)(()=>{
        var _unrefElement;
        return (_unrefElement = $85ea9b47855776cf$export$c61124d3cf5adbae(target)) === null || _unrefElement === void 0 || (_unrefElement = _unrefElement.namespaceURI) === null || _unrefElement === void 0 ? void 0 : _unrefElement.includes("svg");
    });
    const width = (0, $01W3b.shallowRef)(initialSize.width);
    const height = (0, $01W3b.shallowRef)(initialSize.height);
    const { stop: stop1 } = $85ea9b47855776cf$export$683480f191c0e3ea(target, ([entry])=>{
        const boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
        if (window1 && isSVG.value) {
            const $elem = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
            if ($elem) {
                const rect = $elem.getBoundingClientRect();
                width.value = rect.width;
                height.value = rect.height;
            }
        } else if (boxSize) {
            const formatBoxSize = (0, $aPZNl.toArray)(boxSize);
            width.value = formatBoxSize.reduce((acc, { inlineSize: inlineSize })=>acc + inlineSize, 0);
            height.value = formatBoxSize.reduce((acc, { blockSize: blockSize })=>acc + blockSize, 0);
        } else {
            width.value = entry.contentRect.width;
            height.value = entry.contentRect.height;
        }
    }, options);
    (0, $aPZNl.tryOnMounted)(()=>{
        const ele = $85ea9b47855776cf$export$c61124d3cf5adbae(target);
        if (ele) {
            width.value = "offsetWidth" in ele ? ele.offsetWidth : initialSize.width;
            height.value = "offsetHeight" in ele ? ele.offsetHeight : initialSize.height;
        }
    });
    const stop2 = (0, $01W3b.watch)(()=>$85ea9b47855776cf$export$c61124d3cf5adbae(target), (ele)=>{
        width.value = ele ? initialSize.width : 0;
        height.value = ele ? initialSize.height : 0;
    });
    function stop() {
        stop1();
        stop2();
    }
    return {
        width: width,
        height: height,
        stop: stop
    };
}
//#endregion
//#region useIntersectionObserver/index.ts
/**
* Detects changes to a target element's visibility.
*
* @see https://vueuse.org/useIntersectionObserver
* @param target
* @param callback
* @param options
*/ function $85ea9b47855776cf$export$a7395f9832c00176(target, callback, options = {}) {
    const { root: root, rootMargin: rootMargin, threshold: threshold = 0, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, immediate: immediate = true } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && "IntersectionObserver" in window1);
    const targets = (0, $01W3b.computed)(()=>{
        return (0, $aPZNl.toArray)((0, $01W3b.toValue)(target)).map($85ea9b47855776cf$export$c61124d3cf5adbae).filter((0, $aPZNl.notNullish));
    });
    let cleanup = (0, $aPZNl.noop);
    const isActive = (0, $01W3b.shallowRef)(immediate);
    const stopWatch = isSupported.value ? (0, $01W3b.watch)(()=>[
            targets.value,
            $85ea9b47855776cf$export$c61124d3cf5adbae(root),
            (0, $01W3b.toValue)(rootMargin),
            isActive.value
        ], ([targets, root, rootMargin])=>{
        cleanup();
        if (!isActive.value) return;
        if (!targets.length) return;
        const observer = new IntersectionObserver(callback, {
            root: $85ea9b47855776cf$export$c61124d3cf5adbae(root),
            rootMargin: rootMargin,
            threshold: threshold
        });
        targets.forEach((el)=>el && observer.observe(el));
        cleanup = ()=>{
            observer.disconnect();
            cleanup = (0, $aPZNl.noop);
        };
    }, {
        immediate: immediate,
        flush: "post"
    }) : (0, $aPZNl.noop);
    const stop = ()=>{
        cleanup();
        stopWatch();
        isActive.value = false;
    };
    (0, $aPZNl.tryOnScopeDispose)(stop);
    return {
        isSupported: isSupported,
        isActive: isActive,
        pause () {
            cleanup();
            isActive.value = false;
        },
        resume () {
            isActive.value = true;
        },
        stop: stop
    };
}
//#endregion
//#region useElementVisibility/index.ts
function $85ea9b47855776cf$export$6aadc312a449609d(element, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, scrollTarget: scrollTarget, threshold: threshold = 0, rootMargin: rootMargin, once: once = false, initialValue: initialValue = false } = options;
    const isVisible = (0, $01W3b.shallowRef)(initialValue);
    const observerController = $85ea9b47855776cf$export$a7395f9832c00176(element, (intersectionObserverEntries)=>{
        let isIntersecting = isVisible.value;
        let latestTime = 0;
        for (const entry of intersectionObserverEntries)if (entry.time >= latestTime) {
            latestTime = entry.time;
            isIntersecting = entry.isIntersecting;
        }
        isVisible.value = isIntersecting;
        if (once) (0, $aPZNl.watchOnce)(isVisible, ()=>{
            observerController.stop();
        });
    }, {
        root: scrollTarget,
        window: window1,
        threshold: threshold,
        rootMargin: rootMargin
    });
    return options.controls ? {
        ...observerController,
        isVisible: isVisible
    } : isVisible;
}
//#endregion
//#region useEventBus/internal.ts
/* #__PURE__ */ const $85ea9b47855776cf$var$events = /* @__PURE__ */ new Map();
//#endregion
//#region useEventBus/index.ts
/* @__NO_SIDE_EFFECTS__ */ function $85ea9b47855776cf$export$965c4f095bc7d646(key) {
    const scope = (0, $01W3b.getCurrentScope)();
    function on(listener) {
        var _scope$cleanups;
        const listeners = $85ea9b47855776cf$var$events.get(key) || /* @__PURE__ */ new Set();
        listeners.add(listener);
        $85ea9b47855776cf$var$events.set(key, listeners);
        const _off = ()=>off(listener);
        scope === null || scope === void 0 || (_scope$cleanups = scope.cleanups) === null || _scope$cleanups === void 0 || _scope$cleanups.push(_off);
        return _off;
    }
    function once(listener) {
        function _listener(...args) {
            off(_listener);
            listener(...args);
        }
        return on(_listener);
    }
    function off(listener) {
        const listeners = $85ea9b47855776cf$var$events.get(key);
        if (!listeners) return;
        listeners.delete(listener);
        if (!listeners.size) reset();
    }
    function reset() {
        $85ea9b47855776cf$var$events.delete(key);
    }
    function emit(event, payload) {
        var _events$get;
        (_events$get = $85ea9b47855776cf$var$events.get(key)) === null || _events$get === void 0 || _events$get.forEach((v)=>v(event, payload));
    }
    return {
        on: on,
        once: once,
        off: off,
        emit: emit,
        reset: reset
    };
}
//#endregion
//#region useEventSource/index.ts
function $85ea9b47855776cf$var$resolveNestedOptions$1(options) {
    if (options === true) return {};
    return options;
}
/**
* Reactive wrapper for EventSource.
*
* @see https://vueuse.org/useEventSource
* @see https://developer.mozilla.org/en-US/docs/Web/API/EventSource/EventSource EventSource
* @param url
* @param events
* @param options
*/ function $85ea9b47855776cf$export$1492e5081ec8f8b5(url, events = [], options = {}) {
    const event = (0, $01W3b.shallowRef)(null);
    const data = (0, $01W3b.shallowRef)(null);
    const status = (0, $01W3b.shallowRef)("CONNECTING");
    const eventSource = (0, $01W3b.shallowRef)(null);
    const error = (0, $01W3b.shallowRef)(null);
    const urlRef = (0, $aPZNl.toRef)(url);
    const lastEventId = (0, $01W3b.shallowRef)(null);
    let explicitlyClosed = false;
    let retried = 0;
    const { withCredentials: withCredentials = false, immediate: immediate = true, autoConnect: autoConnect = true, autoReconnect: autoReconnect, serializer: serializer = {
        read: (v)=>v
    } } = options;
    const close = ()=>{
        if ((0, $aPZNl.isClient) && eventSource.value) {
            eventSource.value.close();
            eventSource.value = null;
            status.value = "CLOSED";
            explicitlyClosed = true;
        }
    };
    const _init = ()=>{
        if (explicitlyClosed || typeof urlRef.value === "undefined") return;
        const es = new EventSource(urlRef.value, {
            withCredentials: withCredentials
        });
        status.value = "CONNECTING";
        eventSource.value = es;
        es.onopen = ()=>{
            status.value = "OPEN";
            error.value = null;
        };
        es.onerror = (e)=>{
            status.value = "CLOSED";
            error.value = e;
            if (es.readyState === 2 && !explicitlyClosed && autoReconnect) {
                es.close();
                const { retries: retries = -1, delay: delay = 1e3, onFailed: onFailed } = $85ea9b47855776cf$var$resolveNestedOptions$1(autoReconnect);
                retried += 1;
                if (typeof retries === "number" && (retries < 0 || retried < retries)) setTimeout(_init, delay);
                else if (typeof retries === "function" && retries()) setTimeout(_init, delay);
                else onFailed === null || onFailed === void 0 || onFailed();
            }
        };
        es.onmessage = (e)=>{
            var _serializer$read;
            event.value = null;
            data.value = (_serializer$read = serializer.read(e.data)) !== null && _serializer$read !== void 0 ? _serializer$read : null;
            lastEventId.value = e.lastEventId;
        };
        for (const event_name of events)$85ea9b47855776cf$export$7080b3e976bc91ab(es, event_name, (e)=>{
            var _serializer$read2, _e$lastEventId;
            event.value = event_name;
            data.value = (_serializer$read2 = serializer.read(e.data)) !== null && _serializer$read2 !== void 0 ? _serializer$read2 : null;
            lastEventId.value = (_e$lastEventId = e.lastEventId) !== null && _e$lastEventId !== void 0 ? _e$lastEventId : null;
        }, {
            passive: true
        });
    };
    const open = ()=>{
        if (!(0, $aPZNl.isClient)) return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate) open();
    if (autoConnect) (0, $01W3b.watch)(urlRef, open);
    (0, $aPZNl.tryOnScopeDispose)(close);
    return {
        eventSource: eventSource,
        event: event,
        data: data,
        status: status,
        error: error,
        open: open,
        close: close,
        lastEventId: lastEventId
    };
}
//#endregion
//#region useEyeDropper/index.ts
/**
* Reactive [EyeDropper API](https://developer.mozilla.org/en-US/docs/Web/API/EyeDropper_API)
*
* @see https://vueuse.org/useEyeDropper
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$b649d244384df275(options = {}) {
    const { initialValue: initialValue = "" } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>typeof window !== "undefined" && "EyeDropper" in window);
    const sRGBHex = (0, $01W3b.shallowRef)(initialValue);
    async function open(openOptions) {
        if (!isSupported.value) return;
        const result = await new window.EyeDropper().open(openOptions);
        sRGBHex.value = result.sRGBHex;
        return result;
    }
    return {
        isSupported: isSupported,
        sRGBHex: sRGBHex,
        open: open
    };
}
//#endregion
//#region useFavicon/index.ts
function $85ea9b47855776cf$export$1252d0179ae6292b(newIcon = null, options = {}) {
    const { baseUrl: baseUrl = "", rel: rel = "icon", document: document1 = $85ea9b47855776cf$export$37990bd438d16af3 } = options;
    const favicon = (0, $aPZNl.toRef)(newIcon);
    const applyIcon = (icon)=>{
        const elements = document1 === null || document1 === void 0 ? void 0 : document1.head.querySelectorAll(`link[rel*="${rel}"]`);
        if (!elements || elements.length === 0) {
            const link = document1 === null || document1 === void 0 ? void 0 : document1.createElement("link");
            if (link) {
                link.rel = rel;
                link.href = `${baseUrl}${icon}`;
                link.type = `image/${icon.split(".").pop()}`;
                document1 === null || document1 === void 0 || document1.head.append(link);
            }
            return;
        }
        elements === null || elements === void 0 || elements.forEach((el)=>el.href = `${baseUrl}${icon}`);
    };
    (0, $01W3b.watch)(favicon, (i, o)=>{
        if (typeof i === "string" && i !== o) applyIcon(i);
    }, {
        immediate: true
    });
    return favicon;
}
//#endregion
//#region useFetch/index.ts
const $85ea9b47855776cf$var$payloadMapping = {
    json: "application/json",
    text: "text/plain"
};
/**
* !!!IMPORTANT!!!
*
* If you update the UseFetchOptions interface, be sure to update this object
* to include the new options
*/ function $85ea9b47855776cf$var$isFetchOptions(obj) {
    return obj && (0, $aPZNl.containsProp)(obj, "immediate", "refetch", "initialData", "timeout", "beforeFetch", "afterFetch", "onFetchError", "fetch", "updateDataOnError");
}
const $85ea9b47855776cf$var$reAbsolute = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i;
function $85ea9b47855776cf$var$isAbsoluteURL(url) {
    return $85ea9b47855776cf$var$reAbsolute.test(url);
}
function $85ea9b47855776cf$var$headersToObject(headers) {
    if (typeof Headers !== "undefined" && headers instanceof Headers) return Object.fromEntries(headers.entries());
    return headers;
}
function $85ea9b47855776cf$var$combineCallbacks(combination, ...callbacks) {
    if (combination === "overwrite") return async (ctx)=>{
        let callback;
        for(let i = callbacks.length - 1; i >= 0; i--)if (callbacks[i] != null) {
            callback = callbacks[i];
            break;
        }
        if (callback) return {
            ...ctx,
            ...await callback(ctx)
        };
        return ctx;
    };
    else return async (ctx)=>{
        for (const callback of callbacks)if (callback) ctx = {
            ...ctx,
            ...await callback(ctx)
        };
        return ctx;
    };
}
function $85ea9b47855776cf$export$3d173a42d8c9a48a(config = {}) {
    const _combination = config.combination || "chain";
    const _options = config.options || {};
    const _fetchOptions = config.fetchOptions || {};
    function useFactoryFetch(url, ...args) {
        const computedUrl = (0, $01W3b.computed)(()=>{
            const baseUrl = (0, $01W3b.toValue)(config.baseUrl);
            const targetUrl = (0, $01W3b.toValue)(url);
            return baseUrl && !$85ea9b47855776cf$var$isAbsoluteURL(targetUrl) ? $85ea9b47855776cf$var$joinPaths(baseUrl, targetUrl) : targetUrl;
        });
        let options = _options;
        let fetchOptions = _fetchOptions;
        if (args.length > 0) {
            if ($85ea9b47855776cf$var$isFetchOptions(args[0])) options = {
                ...options,
                ...args[0],
                beforeFetch: $85ea9b47855776cf$var$combineCallbacks(_combination, _options.beforeFetch, args[0].beforeFetch),
                afterFetch: $85ea9b47855776cf$var$combineCallbacks(_combination, _options.afterFetch, args[0].afterFetch),
                onFetchError: $85ea9b47855776cf$var$combineCallbacks(_combination, _options.onFetchError, args[0].onFetchError)
            };
            else fetchOptions = {
                ...fetchOptions,
                ...args[0],
                headers: {
                    ...$85ea9b47855776cf$var$headersToObject(fetchOptions.headers) || {},
                    ...$85ea9b47855776cf$var$headersToObject(args[0].headers) || {}
                }
            };
        }
        if (args.length > 1 && $85ea9b47855776cf$var$isFetchOptions(args[1])) options = {
            ...options,
            ...args[1],
            beforeFetch: $85ea9b47855776cf$var$combineCallbacks(_combination, _options.beforeFetch, args[1].beforeFetch),
            afterFetch: $85ea9b47855776cf$var$combineCallbacks(_combination, _options.afterFetch, args[1].afterFetch),
            onFetchError: $85ea9b47855776cf$var$combineCallbacks(_combination, _options.onFetchError, args[1].onFetchError)
        };
        return $85ea9b47855776cf$export$d852f5f778460fa4(computedUrl, fetchOptions, options);
    }
    return useFactoryFetch;
}
function $85ea9b47855776cf$export$d852f5f778460fa4(url, ...args) {
    var _defaultWindow$fetch, _globalThis;
    const supportsAbort = typeof AbortController === "function";
    let fetchOptions = {};
    let options = {
        immediate: true,
        refetch: false,
        timeout: 0,
        updateDataOnError: false
    };
    const config = {
        method: "GET",
        type: "text",
        payload: void 0
    };
    if (args.length > 0) {
        if ($85ea9b47855776cf$var$isFetchOptions(args[0])) options = {
            ...options,
            ...args[0]
        };
        else fetchOptions = args[0];
    }
    if (args.length > 1) {
        if ($85ea9b47855776cf$var$isFetchOptions(args[1])) options = {
            ...options,
            ...args[1]
        };
    }
    const { fetch: fetch = (_defaultWindow$fetch = $85ea9b47855776cf$export$16f8ba610718ae4a === null || $85ea9b47855776cf$export$16f8ba610718ae4a === void 0 ? void 0 : $85ea9b47855776cf$export$16f8ba610718ae4a.fetch) !== null && _defaultWindow$fetch !== void 0 ? _defaultWindow$fetch : (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.fetch, initialData: initialData, timeout: timeout } = options;
    const responseEvent = (0, $aPZNl.createEventHook)();
    const errorEvent = (0, $aPZNl.createEventHook)();
    const finallyEvent = (0, $aPZNl.createEventHook)();
    const isFinished = (0, $01W3b.shallowRef)(false);
    const isFetching = (0, $01W3b.shallowRef)(false);
    const aborted = (0, $01W3b.shallowRef)(false);
    const statusCode = (0, $01W3b.shallowRef)(null);
    const response = (0, $01W3b.shallowRef)(null);
    const error = (0, $01W3b.shallowRef)(null);
    const data = (0, $01W3b.shallowRef)(initialData || null);
    const canAbort = (0, $01W3b.computed)(()=>supportsAbort && isFetching.value);
    let controller;
    let timer;
    const abort = (reason)=>{
        if (supportsAbort) {
            controller === null || controller === void 0 || controller.abort(reason);
            controller = new AbortController();
            controller.signal.onabort = ()=>aborted.value = true;
            fetchOptions = {
                ...fetchOptions,
                signal: controller.signal
            };
        }
    };
    const loading = (isLoading)=>{
        isFetching.value = isLoading;
        isFinished.value = !isLoading;
    };
    if (timeout) timer = (0, $aPZNl.useTimeoutFn)(abort, timeout, {
        immediate: false
    });
    let executeCounter = 0;
    const execute = async (throwOnFailed = false)=>{
        var _context$options;
        abort();
        loading(true);
        error.value = null;
        statusCode.value = null;
        aborted.value = false;
        executeCounter += 1;
        const currentExecuteCounter = executeCounter;
        const defaultFetchOptions = {
            method: config.method,
            headers: {}
        };
        const payload = (0, $01W3b.toValue)(config.payload);
        if (payload) {
            var _payloadMapping$confi;
            const headers = $85ea9b47855776cf$var$headersToObject(defaultFetchOptions.headers);
            const proto = Object.getPrototypeOf(payload);
            if (!config.payloadType && payload && (proto === Object.prototype || Array.isArray(proto)) && !(payload instanceof FormData)) config.payloadType = "json";
            if (config.payloadType) headers["Content-Type"] = (_payloadMapping$confi = $85ea9b47855776cf$var$payloadMapping[config.payloadType]) !== null && _payloadMapping$confi !== void 0 ? _payloadMapping$confi : config.payloadType;
            defaultFetchOptions.body = config.payloadType === "json" ? JSON.stringify(payload) : payload;
        }
        let isCanceled = false;
        const context = {
            url: (0, $01W3b.toValue)(url),
            options: {
                ...defaultFetchOptions,
                ...fetchOptions
            },
            cancel: ()=>{
                isCanceled = true;
            }
        };
        if (options.beforeFetch) Object.assign(context, await options.beforeFetch(context));
        if (isCanceled || !fetch) {
            loading(false);
            return Promise.resolve(null);
        }
        let responseData = null;
        if (timer) timer.start();
        return fetch(context.url, {
            ...defaultFetchOptions,
            ...context.options,
            headers: {
                ...$85ea9b47855776cf$var$headersToObject(defaultFetchOptions.headers),
                ...$85ea9b47855776cf$var$headersToObject((_context$options = context.options) === null || _context$options === void 0 ? void 0 : _context$options.headers)
            }
        }).then(async (fetchResponse)=>{
            response.value = fetchResponse;
            statusCode.value = fetchResponse.status;
            responseData = await fetchResponse.clone()[config.type]();
            if (!fetchResponse.ok) {
                data.value = initialData || null;
                throw new Error(fetchResponse.statusText);
            }
            if (options.afterFetch) ({ data: responseData } = await options.afterFetch({
                data: responseData,
                response: fetchResponse,
                context: context,
                execute: execute
            }));
            data.value = responseData;
            responseEvent.trigger(fetchResponse);
            return fetchResponse;
        }).catch(async (fetchError)=>{
            let errorData = fetchError.message || fetchError.name;
            if (options.onFetchError) ({ error: errorData, data: responseData } = await options.onFetchError({
                data: responseData,
                error: fetchError,
                response: response.value,
                context: context,
                execute: execute
            }));
            error.value = errorData;
            if (options.updateDataOnError) data.value = responseData;
            errorEvent.trigger(fetchError);
            if (throwOnFailed) throw fetchError;
            return null;
        }).finally(()=>{
            if (currentExecuteCounter === executeCounter) loading(false);
            if (timer) timer.stop();
            finallyEvent.trigger(null);
        });
    };
    const refetch = (0, $aPZNl.toRef)(options.refetch);
    (0, $01W3b.watch)([
        refetch,
        (0, $aPZNl.toRef)(url)
    ], ([refetch])=>refetch && execute(), {
        deep: true
    });
    const shell = {
        isFinished: (0, $01W3b.shallowReadonly)(isFinished),
        isFetching: (0, $01W3b.shallowReadonly)(isFetching),
        statusCode: statusCode,
        response: response,
        error: error,
        data: data,
        canAbort: canAbort,
        aborted: aborted,
        abort: abort,
        execute: execute,
        onFetchResponse: responseEvent.on,
        onFetchError: errorEvent.on,
        onFetchFinally: finallyEvent.on,
        get: setMethod("GET"),
        put: setMethod("PUT"),
        post: setMethod("POST"),
        delete: setMethod("DELETE"),
        patch: setMethod("PATCH"),
        head: setMethod("HEAD"),
        options: setMethod("OPTIONS"),
        json: setType("json"),
        text: setType("text"),
        blob: setType("blob"),
        arrayBuffer: setType("arrayBuffer"),
        formData: setType("formData")
    };
    function setMethod(method) {
        return (payload, payloadType)=>{
            if (!isFetching.value) {
                config.method = method;
                config.payload = payload;
                config.payloadType = payloadType;
                if ((0, $01W3b.isRef)(config.payload)) (0, $01W3b.watch)([
                    refetch,
                    (0, $aPZNl.toRef)(config.payload)
                ], ([refetch])=>refetch && execute(), {
                    deep: true
                });
                return {
                    ...shell,
                    then (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    }
                };
            }
        };
    }
    function waitUntilFinished() {
        return new Promise((resolve, reject)=>{
            (0, $aPZNl.until)(isFinished).toBe(true).then(()=>resolve(shell)).catch(reject);
        });
    }
    function setType(type) {
        return ()=>{
            if (!isFetching.value) {
                config.type = type;
                return {
                    ...shell,
                    then (onFulfilled, onRejected) {
                        return waitUntilFinished().then(onFulfilled, onRejected);
                    }
                };
            }
        };
    }
    if (options.immediate) Promise.resolve().then(()=>execute());
    return {
        ...shell,
        then (onFulfilled, onRejected) {
            return waitUntilFinished().then(onFulfilled, onRejected);
        }
    };
}
function $85ea9b47855776cf$var$joinPaths(start, end) {
    if (!start.endsWith("/") && !end.startsWith("/")) return `${start}/${end}`;
    if (start.endsWith("/") && end.startsWith("/")) return `${start.slice(0, -1)}${end}`;
    return `${start}${end}`;
}
//#endregion
//#region useFileDialog/index.ts
const $85ea9b47855776cf$var$DEFAULT_OPTIONS = {
    multiple: true,
    accept: "*",
    reset: false,
    directory: false
};
function $85ea9b47855776cf$var$prepareInitialFiles(files) {
    if (!files) return null;
    if (files instanceof FileList) return files;
    const dt = new DataTransfer();
    for (const file of files)dt.items.add(file);
    return dt.files;
}
/**
* Open file dialog with ease.
*
* @see https://vueuse.org/useFileDialog
* @param options
*/ function $85ea9b47855776cf$export$46ab9fa3f3719597(options = {}) {
    const { document: document1 = $85ea9b47855776cf$export$37990bd438d16af3 } = options;
    const files = (0, $01W3b.ref)($85ea9b47855776cf$var$prepareInitialFiles(options.initialFiles));
    const { on: onChange, trigger: changeTrigger } = (0, $aPZNl.createEventHook)();
    const { on: onCancel, trigger: cancelTrigger } = (0, $aPZNl.createEventHook)();
    const inputRef = (0, $01W3b.computed)(()=>{
        var _unrefElement;
        const input = (_unrefElement = $85ea9b47855776cf$export$c61124d3cf5adbae(options.input)) !== null && _unrefElement !== void 0 ? _unrefElement : document1 ? document1.createElement("input") : void 0;
        if (input) {
            input.type = "file";
            input.onchange = (event)=>{
                files.value = event.target.files;
                changeTrigger(files.value);
            };
            input.oncancel = ()=>{
                cancelTrigger();
            };
        }
        return input;
    });
    const reset = ()=>{
        files.value = null;
        if (inputRef.value && inputRef.value.value) {
            inputRef.value.value = "";
            changeTrigger(null);
        }
    };
    const applyOptions = (options)=>{
        const el = inputRef.value;
        if (!el) return;
        el.multiple = (0, $01W3b.toValue)(options.multiple);
        el.accept = (0, $01W3b.toValue)(options.accept);
        el.webkitdirectory = (0, $01W3b.toValue)(options.directory);
        if ((0, $aPZNl.hasOwn)(options, "capture")) el.capture = (0, $01W3b.toValue)(options.capture);
    };
    const open = (localOptions)=>{
        const el = inputRef.value;
        if (!el) return;
        const mergedOptions = {
            ...$85ea9b47855776cf$var$DEFAULT_OPTIONS,
            ...options,
            ...localOptions
        };
        applyOptions(mergedOptions);
        if ((0, $01W3b.toValue)(mergedOptions.reset)) reset();
        el.click();
    };
    (0, $TusQn.watchEffect)(()=>{
        applyOptions(options);
    });
    return {
        files: (0, $01W3b.readonly)(files),
        open: open,
        reset: reset,
        onCancel: onCancel,
        onChange: onChange
    };
}
//#endregion
//#region useFileSystemAccess/index.ts
function $85ea9b47855776cf$export$2af170812ec5e71(options = {}) {
    const { window: _window = $85ea9b47855776cf$export$16f8ba610718ae4a, dataType: dataType = "Text" } = options;
    const window1 = _window;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && "showSaveFilePicker" in window1 && "showOpenFilePicker" in window1);
    const fileHandle = (0, $01W3b.shallowRef)();
    const data = (0, $01W3b.shallowRef)();
    const file = (0, $01W3b.shallowRef)();
    const fileName = (0, $01W3b.computed)(()=>{
        var _file$value$name, _file$value;
        return (_file$value$name = (_file$value = file.value) === null || _file$value === void 0 ? void 0 : _file$value.name) !== null && _file$value$name !== void 0 ? _file$value$name : "";
    });
    const fileMIME = (0, $01W3b.computed)(()=>{
        var _file$value$type, _file$value2;
        return (_file$value$type = (_file$value2 = file.value) === null || _file$value2 === void 0 ? void 0 : _file$value2.type) !== null && _file$value$type !== void 0 ? _file$value$type : "";
    });
    const fileSize = (0, $01W3b.computed)(()=>{
        var _file$value$size, _file$value3;
        return (_file$value$size = (_file$value3 = file.value) === null || _file$value3 === void 0 ? void 0 : _file$value3.size) !== null && _file$value$size !== void 0 ? _file$value$size : 0;
    });
    const fileLastModified = (0, $01W3b.computed)(()=>{
        var _file$value$lastModif, _file$value4;
        return (_file$value$lastModif = (_file$value4 = file.value) === null || _file$value4 === void 0 ? void 0 : _file$value4.lastModified) !== null && _file$value$lastModif !== void 0 ? _file$value$lastModif : 0;
    });
    async function open(_options = {}) {
        if (!isSupported.value) return;
        const [handle] = await window1.showOpenFilePicker({
            ...(0, $01W3b.toValue)(options),
            ..._options
        });
        fileHandle.value = handle;
        await updateData();
    }
    async function create(_options = {}) {
        if (!isSupported.value) return;
        fileHandle.value = await window1.showSaveFilePicker({
            ...options,
            ..._options
        });
        data.value = void 0;
        await updateData();
    }
    async function save(_options = {}) {
        if (!isSupported.value) return;
        if (!fileHandle.value) return saveAs(_options);
        if (data.value) {
            const writableStream = await fileHandle.value.createWritable();
            await writableStream.write(data.value);
            await writableStream.close();
        }
        await updateFile();
    }
    async function saveAs(_options = {}) {
        if (!isSupported.value) return;
        fileHandle.value = await window1.showSaveFilePicker({
            ...options,
            ..._options
        });
        if (data.value) {
            const writableStream = await fileHandle.value.createWritable();
            await writableStream.write(data.value);
            await writableStream.close();
        }
        await updateFile();
    }
    async function updateFile() {
        var _fileHandle$value;
        file.value = await ((_fileHandle$value = fileHandle.value) === null || _fileHandle$value === void 0 ? void 0 : _fileHandle$value.getFile());
    }
    async function updateData() {
        var _file$value5, _file$value6;
        await updateFile();
        const type = (0, $01W3b.toValue)(dataType);
        if (type === "Text") data.value = await ((_file$value5 = file.value) === null || _file$value5 === void 0 ? void 0 : _file$value5.text());
        else if (type === "ArrayBuffer") data.value = await ((_file$value6 = file.value) === null || _file$value6 === void 0 ? void 0 : _file$value6.arrayBuffer());
        else if (type === "Blob") data.value = file.value;
    }
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(dataType), updateData);
    return {
        isSupported: isSupported,
        data: data,
        file: file,
        fileName: fileName,
        fileMIME: fileMIME,
        fileSize: fileSize,
        fileLastModified: fileLastModified,
        open: open,
        create: create,
        save: save,
        saveAs: saveAs,
        updateData: updateData
    };
}
//#endregion
//#region useFocus/index.ts
/**
* Track or set the focus state of a DOM element.
*
* @see https://vueuse.org/useFocus
* @param target The target element for the focus and blur events.
* @param options
*/ function $85ea9b47855776cf$export$f8168d8dd8fd66e6(target, options = {}) {
    const { initialValue: initialValue = false, focusVisible: focusVisible = false, preventScroll: preventScroll = false } = options;
    const innerFocused = (0, $01W3b.shallowRef)(false);
    const targetElement = (0, $01W3b.computed)(()=>$85ea9b47855776cf$export$c61124d3cf5adbae(target));
    const listenerOptions = {
        passive: true
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab(targetElement, "focus", (event)=>{
        var _matches, _ref;
        if (!focusVisible || ((_matches = (_ref = event.target).matches) === null || _matches === void 0 ? void 0 : _matches.call(_ref, ":focus-visible"))) innerFocused.value = true;
    }, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(targetElement, "blur", ()=>innerFocused.value = false, listenerOptions);
    const focused = (0, $01W3b.computed)({
        get: ()=>innerFocused.value,
        set (value) {
            var _targetElement$value, _targetElement$value2;
            if (!value && innerFocused.value) (_targetElement$value = targetElement.value) === null || _targetElement$value === void 0 || _targetElement$value.blur();
            else if (value && !innerFocused.value) (_targetElement$value2 = targetElement.value) === null || _targetElement$value2 === void 0 || _targetElement$value2.focus({
                preventScroll: preventScroll
            });
        }
    });
    (0, $01W3b.watch)(targetElement, ()=>{
        focused.value = initialValue;
    }, {
        immediate: true,
        flush: "post"
    });
    return {
        focused: focused
    };
}
//#endregion
//#region useFocusWithin/index.ts
const $85ea9b47855776cf$var$EVENT_FOCUS_IN = "focusin";
const $85ea9b47855776cf$var$EVENT_FOCUS_OUT = "focusout";
const $85ea9b47855776cf$var$PSEUDO_CLASS_FOCUS_WITHIN = ":focus-within";
/**
* Track if focus is contained within the target element
*
* @see https://vueuse.org/useFocusWithin
* @param target The target element to track
* @param options Focus within options
*/ function $85ea9b47855776cf$export$420e68273165f4ec(target, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const targetElement = (0, $01W3b.computed)(()=>$85ea9b47855776cf$export$c61124d3cf5adbae(target));
    const _focused = (0, $01W3b.shallowRef)(false);
    const focused = (0, $01W3b.computed)(()=>_focused.value);
    const activeElement = $85ea9b47855776cf$export$4e1875a4b2b1434f(options);
    if (!window1 || !activeElement.value) return {
        focused: focused
    };
    const listenerOptions = {
        passive: true
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab(targetElement, $85ea9b47855776cf$var$EVENT_FOCUS_IN, ()=>_focused.value = true, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(targetElement, $85ea9b47855776cf$var$EVENT_FOCUS_OUT, ()=>{
        var _targetElement$value$, _targetElement$value, _targetElement$value$2;
        return _focused.value = (_targetElement$value$ = (_targetElement$value = targetElement.value) === null || _targetElement$value === void 0 || (_targetElement$value$2 = _targetElement$value.matches) === null || _targetElement$value$2 === void 0 ? void 0 : _targetElement$value$2.call(_targetElement$value, $85ea9b47855776cf$var$PSEUDO_CLASS_FOCUS_WITHIN)) !== null && _targetElement$value$ !== void 0 ? _targetElement$value$ : false;
    }, listenerOptions);
    return {
        focused: focused
    };
}
//#endregion
//#region useFps/index.ts
/* @__NO_SIDE_EFFECTS__ */ function $85ea9b47855776cf$export$ab5229fe4b5ea5d0(options) {
    var _options$every;
    const fps = (0, $01W3b.shallowRef)(0);
    if (typeof performance === "undefined") return fps;
    const every = (_options$every = options === null || options === void 0 ? void 0 : options.every) !== null && _options$every !== void 0 ? _options$every : 10;
    let last = performance.now();
    let ticks = 0;
    $85ea9b47855776cf$export$13251e0fc79284e(()=>{
        ticks += 1;
        if (ticks >= every) {
            const now = performance.now();
            const diff = now - last;
            fps.value = Math.round(1e3 / (diff / ticks));
            last = now;
            ticks = 0;
        }
    });
    return fps;
}
//#endregion
//#region useFullscreen/index.ts
const $85ea9b47855776cf$var$eventHandlers = [
    "fullscreenchange",
    "webkitfullscreenchange",
    "webkitendfullscreen",
    "mozfullscreenchange",
    "MSFullscreenChange"
];
/**
* Reactive Fullscreen API.
*
* @see https://vueuse.org/useFullscreen
* @param target
* @param options
*/ function $85ea9b47855776cf$export$873ff9d3a24fe223(target, options = {}) {
    const { document: document1 = $85ea9b47855776cf$export$37990bd438d16af3, autoExit: autoExit = false } = options;
    const targetRef = (0, $01W3b.computed)(()=>{
        var _unrefElement;
        return (_unrefElement = $85ea9b47855776cf$export$c61124d3cf5adbae(target)) !== null && _unrefElement !== void 0 ? _unrefElement : document1 === null || document1 === void 0 ? void 0 : document1.documentElement;
    });
    const isFullscreen = (0, $01W3b.shallowRef)(false);
    const requestMethod = (0, $01W3b.computed)(()=>{
        return [
            "requestFullscreen",
            "webkitRequestFullscreen",
            "webkitEnterFullscreen",
            "webkitEnterFullScreen",
            "webkitRequestFullScreen",
            "mozRequestFullScreen",
            "msRequestFullscreen"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const exitMethod = (0, $01W3b.computed)(()=>{
        return [
            "exitFullscreen",
            "webkitExitFullscreen",
            "webkitExitFullScreen",
            "webkitCancelFullScreen",
            "mozCancelFullScreen",
            "msExitFullscreen"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const fullscreenEnabled = (0, $01W3b.computed)(()=>{
        return [
            "fullScreen",
            "webkitIsFullScreen",
            "webkitDisplayingFullscreen",
            "mozFullScreen",
            "msFullscreenElement"
        ].find((m)=>document1 && m in document1 || targetRef.value && m in targetRef.value);
    });
    const fullscreenElementMethod = [
        "fullscreenElement",
        "webkitFullscreenElement",
        "mozFullScreenElement",
        "msFullscreenElement"
    ].find((m)=>document1 && m in document1);
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>targetRef.value && document1 && requestMethod.value !== void 0 && exitMethod.value !== void 0 && fullscreenEnabled.value !== void 0);
    const isCurrentElementFullScreen = ()=>{
        if (fullscreenElementMethod) return (document1 === null || document1 === void 0 ? void 0 : document1[fullscreenElementMethod]) === targetRef.value;
        return false;
    };
    const isElementFullScreen = ()=>{
        if (fullscreenEnabled.value) {
            if (document1 && document1[fullscreenEnabled.value] != null) return document1[fullscreenEnabled.value];
            else {
                const target = targetRef.value;
                if ((target === null || target === void 0 ? void 0 : target[fullscreenEnabled.value]) != null) return Boolean(target[fullscreenEnabled.value]);
            }
        }
        return false;
    };
    async function exit() {
        if (!isSupported.value || !isFullscreen.value) return;
        if (exitMethod.value) {
            if ((document1 === null || document1 === void 0 ? void 0 : document1[exitMethod.value]) != null) await document1[exitMethod.value]();
            else {
                const target = targetRef.value;
                if ((target === null || target === void 0 ? void 0 : target[exitMethod.value]) != null) await target[exitMethod.value]();
            }
        }
        isFullscreen.value = false;
    }
    async function enter() {
        if (!isSupported.value || isFullscreen.value) return;
        if (isElementFullScreen()) await exit();
        const target = targetRef.value;
        if (requestMethod.value && (target === null || target === void 0 ? void 0 : target[requestMethod.value]) != null) {
            await target[requestMethod.value]();
            isFullscreen.value = true;
        }
    }
    async function toggle() {
        await (isFullscreen.value ? exit() : enter());
    }
    const handlerCallback = ()=>{
        const isElementFullScreenValue = isElementFullScreen();
        if (!isElementFullScreenValue || isElementFullScreenValue && isCurrentElementFullScreen()) isFullscreen.value = isElementFullScreenValue;
    };
    const listenerOptions = {
        capture: false,
        passive: true
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab(document1, $85ea9b47855776cf$var$eventHandlers, handlerCallback, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(()=>$85ea9b47855776cf$export$c61124d3cf5adbae(targetRef), $85ea9b47855776cf$var$eventHandlers, handlerCallback, listenerOptions);
    (0, $aPZNl.tryOnMounted)(handlerCallback, false);
    if (autoExit) (0, $aPZNl.tryOnScopeDispose)(exit);
    return {
        isSupported: isSupported,
        isFullscreen: isFullscreen,
        enter: enter,
        exit: exit,
        toggle: toggle
    };
}
//#endregion
//#region useGamepad/index.ts
/**
* Maps a standard standard gamepad to an Xbox 360 Controller.
*/ function $85ea9b47855776cf$export$9688e62b453d9aed(gamepad) {
    return (0, $01W3b.computed)(()=>{
        if (gamepad.value) return {
            buttons: {
                a: gamepad.value.buttons[0],
                b: gamepad.value.buttons[1],
                x: gamepad.value.buttons[2],
                y: gamepad.value.buttons[3]
            },
            bumper: {
                left: gamepad.value.buttons[4],
                right: gamepad.value.buttons[5]
            },
            triggers: {
                left: gamepad.value.buttons[6],
                right: gamepad.value.buttons[7]
            },
            stick: {
                left: {
                    horizontal: gamepad.value.axes[0],
                    vertical: gamepad.value.axes[1],
                    button: gamepad.value.buttons[10]
                },
                right: {
                    horizontal: gamepad.value.axes[2],
                    vertical: gamepad.value.axes[3],
                    button: gamepad.value.buttons[11]
                }
            },
            dpad: {
                up: gamepad.value.buttons[12],
                down: gamepad.value.buttons[13],
                left: gamepad.value.buttons[14],
                right: gamepad.value.buttons[15]
            },
            back: gamepad.value.buttons[8],
            start: gamepad.value.buttons[9]
        };
        return null;
    });
}
/* @__NO_SIDE_EFFECTS__ */ function $85ea9b47855776cf$export$467a9d70edd1fd69(options = {}) {
    const { navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "getGamepads" in navigator1);
    const gamepads = (0, $01W3b.ref)([]);
    const onConnectedHook = (0, $aPZNl.createEventHook)();
    const onDisconnectedHook = (0, $aPZNl.createEventHook)();
    const stateFromGamepad = (gamepad)=>{
        const hapticActuators = [];
        const vibrationActuator = "vibrationActuator" in gamepad ? gamepad.vibrationActuator : null;
        if (vibrationActuator) hapticActuators.push(vibrationActuator);
        if (gamepad.hapticActuators) hapticActuators.push(...gamepad.hapticActuators);
        return {
            id: gamepad.id,
            index: gamepad.index,
            connected: gamepad.connected,
            mapping: gamepad.mapping,
            timestamp: gamepad.timestamp,
            vibrationActuator: gamepad.vibrationActuator,
            hapticActuators: hapticActuators,
            axes: gamepad.axes.map((axes)=>axes),
            buttons: gamepad.buttons.map((button)=>({
                    pressed: button.pressed,
                    touched: button.touched,
                    value: button.value
                }))
        };
    };
    const updateGamepadState = ()=>{
        const _gamepads = (navigator1 === null || navigator1 === void 0 ? void 0 : navigator1.getGamepads()) || [];
        for (const gamepad of _gamepads)if (gamepad && gamepads.value[gamepad.index]) gamepads.value[gamepad.index] = stateFromGamepad(gamepad);
    };
    const { isActive: isActive, pause: pause, resume: resume } = $85ea9b47855776cf$export$13251e0fc79284e(updateGamepadState);
    const onGamepadConnected = (gamepad)=>{
        if (!gamepads.value.some(({ index: index })=>index === gamepad.index)) {
            gamepads.value.push(stateFromGamepad(gamepad));
            onConnectedHook.trigger(gamepad.index);
        }
        resume();
    };
    const onGamepadDisconnected = (gamepad)=>{
        gamepads.value = gamepads.value.filter((x)=>x.index !== gamepad.index);
        onDisconnectedHook.trigger(gamepad.index);
    };
    const listenerOptions = {
        passive: true
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab("gamepadconnected", (e)=>onGamepadConnected(e.gamepad), listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab("gamepaddisconnected", (e)=>onGamepadDisconnected(e.gamepad), listenerOptions);
    (0, $aPZNl.tryOnMounted)(()=>{
        const _gamepads = (navigator1 === null || navigator1 === void 0 ? void 0 : navigator1.getGamepads()) || [];
        for (const gamepad of _gamepads)if (gamepad && gamepads.value[gamepad.index]) onGamepadConnected(gamepad);
    });
    pause();
    return {
        isSupported: isSupported,
        onConnected: onConnectedHook.on,
        onDisconnected: onDisconnectedHook.on,
        gamepads: gamepads,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
//#endregion
//#region useGeolocation/index.ts
/**
* Reactive Geolocation API.
*
* @see https://vueuse.org/useGeolocation
* @param options
*/ function $85ea9b47855776cf$export$8c959c84e890409a(options = {}) {
    const { enableHighAccuracy: enableHighAccuracy = true, maximumAge: maximumAge = 3e4, timeout: timeout = 27e3, navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc, immediate: immediate = true } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "geolocation" in navigator1);
    const locatedAt = (0, $01W3b.shallowRef)(null);
    const error = (0, $01W3b.shallowRef)(null);
    const coords = (0, $01W3b.shallowRef)({
        accuracy: 0,
        latitude: Number.POSITIVE_INFINITY,
        longitude: Number.POSITIVE_INFINITY,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        speed: null
    });
    function updatePosition(position) {
        locatedAt.value = position.timestamp;
        coords.value = position.coords;
        error.value = null;
    }
    let watcher;
    function resume() {
        if (isSupported.value) watcher = navigator1.geolocation.watchPosition(updatePosition, (err)=>error.value = err, {
            enableHighAccuracy: enableHighAccuracy,
            maximumAge: maximumAge,
            timeout: timeout
        });
    }
    if (immediate) resume();
    function pause() {
        if (watcher && navigator1) navigator1.geolocation.clearWatch(watcher);
    }
    (0, $aPZNl.tryOnScopeDispose)(()=>{
        pause();
    });
    return {
        isSupported: isSupported,
        coords: coords,
        locatedAt: locatedAt,
        error: error,
        resume: resume,
        pause: pause
    };
}
//#endregion
//#region useIdle/index.ts
const $85ea9b47855776cf$var$defaultEvents$1 = [
    "mousemove",
    "mousedown",
    "resize",
    "keydown",
    "touchstart",
    "wheel"
];
const $85ea9b47855776cf$var$oneMinute = 6e4;
/**
* Tracks whether the user is being inactive.
*
* @see https://vueuse.org/useIdle
* @param timeout default to 1 minute
* @param options IdleOptions
*/ function $85ea9b47855776cf$export$4fed27c116de10cb(timeout = $85ea9b47855776cf$var$oneMinute, options = {}) {
    const { initialState: initialState = false, listenForVisibilityChange: listenForVisibilityChange = true, events: events = $85ea9b47855776cf$var$defaultEvents$1, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, eventFilter: eventFilter = (0, $aPZNl.throttleFilter)(50) } = options;
    const idle = (0, $01W3b.shallowRef)(initialState);
    const lastActive = (0, $01W3b.shallowRef)((0, $aPZNl.timestamp)());
    const isPending = (0, $01W3b.shallowRef)(false);
    let timer;
    const reset = ()=>{
        idle.value = false;
        clearTimeout(timer);
        timer = setTimeout(()=>idle.value = true, timeout);
    };
    const onEvent = (0, $aPZNl.createFilterWrapper)(eventFilter, ()=>{
        lastActive.value = (0, $aPZNl.timestamp)();
        reset();
    });
    if (window1) {
        const document1 = window1.document;
        const listenerOptions = {
            passive: true
        };
        for (const event of events)$85ea9b47855776cf$export$7080b3e976bc91ab(window1, event, ()=>{
            if (!isPending.value) return;
            onEvent();
        }, listenerOptions);
        if (listenForVisibilityChange) $85ea9b47855776cf$export$7080b3e976bc91ab(document1, "visibilitychange", ()=>{
            if (document1.hidden || !isPending.value) return;
            onEvent();
        }, listenerOptions);
        start();
    }
    function start() {
        if (isPending.value) return;
        isPending.value = true;
        if (!initialState) reset();
    }
    function stop() {
        idle.value = initialState;
        clearTimeout(timer);
        isPending.value = false;
    }
    return {
        idle: idle,
        lastActive: lastActive,
        reset: reset,
        stop: stop,
        start: start,
        isPending: (0, $01W3b.shallowReadonly)(isPending)
    };
}
//#endregion
//#region useImage/index.ts
async function $85ea9b47855776cf$var$loadImage(options) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        const { src: src, srcset: srcset, sizes: sizes, class: clazz, loading: loading, crossorigin: crossorigin, referrerPolicy: referrerPolicy, width: width, height: height, decoding: decoding, fetchPriority: fetchPriority, ismap: ismap, usemap: usemap } = options;
        img.src = src;
        if (srcset != null) img.srcset = srcset;
        if (sizes != null) img.sizes = sizes;
        if (clazz != null) img.className = clazz;
        if (loading != null) img.loading = loading;
        if (crossorigin != null) img.crossOrigin = crossorigin;
        if (referrerPolicy != null) img.referrerPolicy = referrerPolicy;
        if (width != null) img.width = width;
        if (height != null) img.height = height;
        if (decoding != null) img.decoding = decoding;
        if (fetchPriority != null) img.fetchPriority = fetchPriority;
        if (ismap != null) img.isMap = ismap;
        if (usemap != null) img.useMap = usemap;
        img.onload = ()=>resolve(img);
        img.onerror = reject;
    });
}
/**
* Reactive load an image in the browser, you can wait the result to display it or show a fallback.
*
* @see https://vueuse.org/useImage
* @param options Image attributes, as used in the <img> tag
* @param asyncStateOptions
*/ function $85ea9b47855776cf$export$e4da99f09da8b739(options, asyncStateOptions = {}) {
    const state = $85ea9b47855776cf$export$d94717ae0e8aa8b(()=>$85ea9b47855776cf$var$loadImage((0, $01W3b.toValue)(options)), void 0, {
        resetOnExecute: true,
        ...asyncStateOptions
    });
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(options), ()=>state.execute(asyncStateOptions.delay), {
        deep: true
    });
    return state;
}
//#endregion
//#region _resolve-element.ts
/**
* Resolves an element from a given element, window, or document.
*
* @internal
*/ function $85ea9b47855776cf$var$resolveElement(el) {
    if (typeof Window !== "undefined" && el instanceof Window) return el.document.documentElement;
    if (typeof Document !== "undefined" && el instanceof Document) return el.documentElement;
    return el;
}
//#endregion
//#region useScroll/index.ts
/**
* We have to check if the scroll amount is close enough to some threshold in order to
* more accurately calculate arrivedState. This is because scrollTop/scrollLeft are non-rounded
* numbers, while scrollHeight/scrollWidth and clientHeight/clientWidth are rounded.
* https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#determine_if_an_element_has_been_totally_scrolled
*/ const $85ea9b47855776cf$var$ARRIVED_STATE_THRESHOLD_PIXELS = 1;
/**
* Reactive scroll.
*
* @see https://vueuse.org/useScroll
* @param element
* @param options
*/ function $85ea9b47855776cf$export$d928051c8cd740b(element, options = {}) {
    const { throttle: throttle = 0, idle: idle = 200, onStop: onStop = (0, $aPZNl.noop), onScroll: onScroll = (0, $aPZNl.noop), offset: offset = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    }, observe: _observe = {
        mutation: false
    }, eventListenerOptions: eventListenerOptions = {
        capture: false,
        passive: true
    }, behavior: behavior = "auto", window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, onError: onError = (e)=>{
        console.error(e);
    } } = options;
    const observe = typeof _observe === "boolean" ? {
        mutation: _observe
    } : _observe;
    const internalX = (0, $01W3b.shallowRef)(0);
    const internalY = (0, $01W3b.shallowRef)(0);
    const x = (0, $01W3b.computed)({
        get () {
            return internalX.value;
        },
        set (x) {
            scrollTo(x, void 0);
        }
    });
    const y = (0, $01W3b.computed)({
        get () {
            return internalY.value;
        },
        set (y) {
            scrollTo(void 0, y);
        }
    });
    function scrollTo(_x, _y) {
        var _ref, _toValue, _toValue2, _document;
        if (!window1) return;
        const _element = (0, $01W3b.toValue)(element);
        if (!_element) return;
        (_ref = _element instanceof Document ? window1.document.body : _element) === null || _ref === void 0 || _ref.scrollTo({
            top: (_toValue = (0, $01W3b.toValue)(_y)) !== null && _toValue !== void 0 ? _toValue : y.value,
            left: (_toValue2 = (0, $01W3b.toValue)(_x)) !== null && _toValue2 !== void 0 ? _toValue2 : x.value,
            behavior: (0, $01W3b.toValue)(behavior)
        });
        const scrollContainer = (_element === null || _element === void 0 || (_document = _element.document) === null || _document === void 0 ? void 0 : _document.documentElement) || (_element === null || _element === void 0 ? void 0 : _element.documentElement) || _element;
        if (x != null) internalX.value = scrollContainer.scrollLeft;
        if (y != null) internalY.value = scrollContainer.scrollTop;
    }
    const isScrolling = (0, $01W3b.shallowRef)(false);
    const arrivedState = (0, $01W3b.reactive)({
        left: true,
        right: false,
        top: true,
        bottom: false
    });
    const directions = (0, $01W3b.reactive)({
        left: false,
        right: false,
        top: false,
        bottom: false
    });
    const onScrollEnd = (e)=>{
        if (!isScrolling.value) return;
        isScrolling.value = false;
        directions.left = false;
        directions.right = false;
        directions.top = false;
        directions.bottom = false;
        onStop(e);
    };
    const onScrollEndDebounced = (0, $aPZNl.useDebounceFn)(onScrollEnd, throttle + idle);
    const setArrivedState = (target)=>{
        var _document2;
        if (!window1) return;
        const el = (target === null || target === void 0 || (_document2 = target.document) === null || _document2 === void 0 ? void 0 : _document2.documentElement) || (target === null || target === void 0 ? void 0 : target.documentElement) || $85ea9b47855776cf$export$c61124d3cf5adbae(target);
        const { display: display, flexDirection: flexDirection, direction: direction } = window1.getComputedStyle(el);
        const directionMultipler = direction === "rtl" ? -1 : 1;
        const scrollLeft = el.scrollLeft;
        directions.left = scrollLeft < internalX.value;
        directions.right = scrollLeft > internalX.value;
        const left = Math.abs(scrollLeft * directionMultipler) <= (offset.left || 0);
        const right = Math.abs(scrollLeft * directionMultipler) + el.clientWidth >= el.scrollWidth - (offset.right || 0) - $85ea9b47855776cf$var$ARRIVED_STATE_THRESHOLD_PIXELS;
        if (display === "flex" && flexDirection === "row-reverse") {
            arrivedState.left = right;
            arrivedState.right = left;
        } else {
            arrivedState.left = left;
            arrivedState.right = right;
        }
        internalX.value = scrollLeft;
        let scrollTop = el.scrollTop;
        if (target === window1.document && !scrollTop) scrollTop = window1.document.body.scrollTop;
        directions.top = scrollTop < internalY.value;
        directions.bottom = scrollTop > internalY.value;
        const top = Math.abs(scrollTop) <= (offset.top || 0);
        const bottom = Math.abs(scrollTop) + el.clientHeight >= el.scrollHeight - (offset.bottom || 0) - $85ea9b47855776cf$var$ARRIVED_STATE_THRESHOLD_PIXELS;
        /**
		* reverse columns and rows behave exactly the other way around,
		* bottom is treated as top and top is treated as the negative version of bottom
		*/ if (display === "flex" && flexDirection === "column-reverse") {
            arrivedState.top = bottom;
            arrivedState.bottom = top;
        } else {
            arrivedState.top = top;
            arrivedState.bottom = bottom;
        }
        internalY.value = scrollTop;
    };
    const onScrollHandler = (e)=>{
        var _documentElement;
        if (!window1) return;
        setArrivedState((_documentElement = e.target.documentElement) !== null && _documentElement !== void 0 ? _documentElement : e.target);
        isScrolling.value = true;
        onScrollEndDebounced(e);
        onScroll(e);
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab(element, "scroll", throttle ? (0, $aPZNl.useThrottleFn)(onScrollHandler, throttle, true, false) : onScrollHandler, eventListenerOptions);
    (0, $aPZNl.tryOnMounted)(()=>{
        try {
            const _element = (0, $01W3b.toValue)(element);
            if (!_element) return;
            setArrivedState(_element);
        } catch (e) {
            onError(e);
        }
    });
    if ((observe === null || observe === void 0 ? void 0 : observe.mutation) && element != null && element !== window1 && element !== document) $85ea9b47855776cf$export$8ecdcf3bb089e9cd(element, ()=>{
        const _element = (0, $01W3b.toValue)(element);
        if (!_element) return;
        setArrivedState(_element);
    }, {
        attributes: true,
        childList: true,
        subtree: true
    });
    $85ea9b47855776cf$export$7080b3e976bc91ab(element, "scrollend", onScrollEnd, eventListenerOptions);
    return {
        x: x,
        y: y,
        isScrolling: isScrolling,
        arrivedState: arrivedState,
        directions: directions,
        measure () {
            const _element = (0, $01W3b.toValue)(element);
            if (window1 && _element) setArrivedState(_element);
        }
    };
}
//#endregion
//#region useInfiniteScroll/index.ts
/**
* Reactive infinite scroll.
*
* @see https://vueuse.org/useInfiniteScroll
*/ function $85ea9b47855776cf$export$a973cef5093a8d22(element, onLoadMore, options = {}) {
    var _options$distance;
    const { direction: direction = "bottom", interval: interval = 100, canLoadMore: canLoadMore = ()=>true } = options;
    const state = (0, $01W3b.reactive)($85ea9b47855776cf$export$d928051c8cd740b(element, {
        ...options,
        offset: {
            [direction]: (_options$distance = options.distance) !== null && _options$distance !== void 0 ? _options$distance : 0,
            ...options.offset
        }
    }));
    const promise = (0, $01W3b.shallowRef)();
    const isLoading = (0, $01W3b.computed)(()=>!!promise.value);
    const observedElement = (0, $01W3b.computed)(()=>{
        return $85ea9b47855776cf$var$resolveElement((0, $01W3b.toValue)(element));
    });
    const isElementVisible = $85ea9b47855776cf$export$6aadc312a449609d(observedElement);
    const canLoad = (0, $01W3b.computed)(()=>{
        if (!observedElement.value) return false;
        return canLoadMore(observedElement.value);
    });
    function checkAndLoad() {
        state.measure();
        if (!observedElement.value || !isElementVisible.value || !canLoad.value || promise.value) return;
        const { scrollHeight: scrollHeight, clientHeight: clientHeight, scrollWidth: scrollWidth, clientWidth: clientWidth } = observedElement.value;
        const isNarrower = direction === "bottom" || direction === "top" ? scrollHeight <= clientHeight : scrollWidth <= clientWidth;
        if (state.arrivedState[direction] || isNarrower) promise.value = Promise.all([
            onLoadMore(state),
            new Promise((resolve)=>setTimeout(resolve, interval))
        ]).finally(()=>{
            promise.value = null;
            (0, $TusQn.nextTick)(()=>checkAndLoad());
        });
    }
    (0, $aPZNl.tryOnUnmounted)((0, $01W3b.watch)(()=>[
            state.arrivedState[direction],
            isElementVisible.value,
            canLoad.value
        ], checkAndLoad, {
        immediate: true,
        flush: "post"
    }));
    return {
        isLoading: isLoading,
        reset () {
            (0, $TusQn.nextTick)(()=>checkAndLoad());
        }
    };
}
//#endregion
//#region useKeyModifier/index.ts
const $85ea9b47855776cf$var$defaultEvents = [
    "mousedown",
    "mouseup",
    "keydown",
    "keyup"
];
/* @__NO_SIDE_EFFECTS__ */ function $85ea9b47855776cf$export$2056835662f651c4(modifier, options = {}) {
    const { events: events = $85ea9b47855776cf$var$defaultEvents, document: document1 = $85ea9b47855776cf$export$37990bd438d16af3, initial: initial = null } = options;
    const state = (0, $01W3b.shallowRef)(initial);
    if (document1) events.forEach((listenerEvent)=>{
        $85ea9b47855776cf$export$7080b3e976bc91ab(document1, listenerEvent, (evt)=>{
            if (typeof evt.getModifierState === "function") state.value = evt.getModifierState(modifier);
        }, {
            passive: true
        });
    });
    return state;
}
//#endregion
//#region useLocalStorage/index.ts
/**
* Reactive LocalStorage.
*
* @see https://vueuse.org/useLocalStorage
* @param key
* @param initialValue
* @param options
*/ function $85ea9b47855776cf$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    return $85ea9b47855776cf$export$95809329f49ea9f9(key, initialValue, window1 === null || window1 === void 0 ? void 0 : window1.localStorage, options);
}
//#endregion
//#region useMagicKeys/aliasMap.ts
const $85ea9b47855776cf$export$73a678c1574e03a3 = {
    ctrl: "control",
    command: "meta",
    cmd: "meta",
    option: "alt",
    up: "arrowup",
    down: "arrowdown",
    left: "arrowleft",
    right: "arrowright"
};
//#endregion
//#region useMagicKeys/index.ts
/**
* Reactive keys pressed state, with magical keys combination support.
*
* @see https://vueuse.org/useMagicKeys
*/ function $85ea9b47855776cf$export$8805bf46e5b1d2e5(options = {}) {
    const { reactive: useReactive = false, target: target = $85ea9b47855776cf$export$16f8ba610718ae4a, aliasMap: aliasMap = $85ea9b47855776cf$export$73a678c1574e03a3, passive: passive = true, onEventFired: onEventFired = (0, $aPZNl.noop) } = options;
    const current = (0, $01W3b.reactive)(/* @__PURE__ */ new Set());
    const obj = {
        toJSON () {
            return {};
        },
        current: current
    };
    const refs = useReactive ? (0, $01W3b.reactive)(obj) : obj;
    const metaDeps = /* @__PURE__ */ new Set();
    const depsMap = new Map([
        [
            "Meta",
            metaDeps
        ],
        [
            "Shift",
            /* @__PURE__ */ new Set()
        ],
        [
            "Alt",
            /* @__PURE__ */ new Set()
        ]
    ]);
    const usedKeys = /* @__PURE__ */ new Set();
    function setRefs(key, value) {
        if (key in refs) {
            if (useReactive) refs[key] = value;
            else refs[key].value = value;
        }
    }
    function reset() {
        current.clear();
        for (const key of usedKeys)setRefs(key, false);
    }
    function updateDeps(value, e, keys) {
        if (!value || typeof e.getModifierState !== "function") return;
        for (const [modifier, depsSet] of depsMap)if (e.getModifierState(modifier)) {
            keys.forEach((key)=>depsSet.add(key));
            break;
        }
    }
    function clearDeps(value, key) {
        if (value) return;
        const depsMapKey = `${key[0].toUpperCase()}${key.slice(1)}`;
        const deps = depsMap.get(depsMapKey);
        if (![
            "shift",
            "alt"
        ].includes(key) || !deps) return;
        const depsArray = Array.from(deps);
        const depsIndex = depsArray.indexOf(key);
        depsArray.forEach((key, index)=>{
            if (index >= depsIndex) {
                current.delete(key);
                setRefs(key, false);
            }
        });
        deps.clear();
    }
    function updateRefs(e, value) {
        var _e$key, _e$code;
        const key = (_e$key = e.key) === null || _e$key === void 0 ? void 0 : _e$key.toLowerCase();
        const values = [
            (_e$code = e.code) === null || _e$code === void 0 ? void 0 : _e$code.toLowerCase(),
            key
        ].filter(Boolean);
        if (!key) return;
        if (key) {
            if (value) current.add(key);
            else current.delete(key);
        }
        for (const key of values){
            usedKeys.add(key);
            setRefs(key, value);
        }
        updateDeps(value, e, [
            ...current,
            ...values
        ]);
        clearDeps(value, key);
        if (key === "meta" && !value) {
            metaDeps.forEach((key)=>{
                current.delete(key);
                setRefs(key, false);
            });
            metaDeps.clear();
        }
    }
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "keydown", (e)=>{
        updateRefs(e, true);
        return onEventFired(e);
    }, {
        passive: passive
    });
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "keyup", (e)=>{
        updateRefs(e, false);
        return onEventFired(e);
    }, {
        passive: passive
    });
    $85ea9b47855776cf$export$7080b3e976bc91ab("blur", reset, {
        passive: passive
    });
    $85ea9b47855776cf$export$7080b3e976bc91ab("focus", reset, {
        passive: passive
    });
    const proxy = new Proxy(refs, {
        get (target, prop, rec) {
            if (typeof prop !== "string") return Reflect.get(target, prop, rec);
            prop = prop.toLowerCase();
            if (prop in aliasMap) prop = aliasMap[prop];
            if (!(prop in refs)) {
                if (/[+_-]/.test(prop)) {
                    const keys = prop.split(/[+_-]/g).map((i)=>i.trim());
                    refs[prop] = (0, $01W3b.computed)(()=>keys.map((key)=>(0, $01W3b.toValue)(proxy[key])).every(Boolean));
                } else refs[prop] = (0, $01W3b.shallowRef)(false);
            }
            const r = Reflect.get(target, prop, rec);
            return useReactive ? (0, $01W3b.toValue)(r) : r;
        }
    });
    return proxy;
}
//#endregion
//#region useMediaControls/index.ts
/**
* Automatically check if the ref exists and if it does run the cb fn
*/ function $85ea9b47855776cf$var$usingElRef(source, cb) {
    if ((0, $01W3b.toValue)(source)) cb((0, $01W3b.toValue)(source));
}
/**
* Converts a TimeRange object to an array
*/ function $85ea9b47855776cf$var$timeRangeToArray(timeRanges) {
    let ranges = [];
    for(let i = 0; i < timeRanges.length; ++i)ranges = [
        ...ranges,
        [
            timeRanges.start(i),
            timeRanges.end(i)
        ]
    ];
    return ranges;
}
/**
* Converts a TextTrackList object to an array of `UseMediaTextTrack`
*/ function $85ea9b47855776cf$var$tracksToArray(tracks) {
    return Array.from(tracks).map(({ label: label, kind: kind, language: language, mode: mode, activeCues: activeCues, cues: cues, inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType }, id)=>({
            id: id,
            label: label,
            kind: kind,
            language: language,
            mode: mode,
            activeCues: activeCues,
            cues: cues,
            inBandMetadataTrackDispatchType: inBandMetadataTrackDispatchType
        }));
}
const $85ea9b47855776cf$var$defaultOptions = {
    src: "",
    tracks: []
};
function $85ea9b47855776cf$export$4401816799be37c8(target, options = {}) {
    target = (0, $aPZNl.toRef)(target);
    options = {
        ...$85ea9b47855776cf$var$defaultOptions,
        ...options
    };
    const { document: document1 = $85ea9b47855776cf$export$37990bd438d16af3 } = options;
    const listenerOptions = {
        passive: true
    };
    const currentTime = (0, $01W3b.shallowRef)(0);
    const duration = (0, $01W3b.shallowRef)(0);
    const seeking = (0, $01W3b.shallowRef)(false);
    const volume = (0, $01W3b.shallowRef)(1);
    const waiting = (0, $01W3b.shallowRef)(false);
    const ended = (0, $01W3b.shallowRef)(false);
    const playing = (0, $01W3b.shallowRef)(false);
    const rate = (0, $01W3b.shallowRef)(1);
    const stalled = (0, $01W3b.shallowRef)(false);
    const buffered = (0, $01W3b.shallowRef)([]);
    const tracks = (0, $01W3b.shallowRef)([]);
    const selectedTrack = (0, $01W3b.shallowRef)(-1);
    const isPictureInPicture = (0, $01W3b.shallowRef)(false);
    const muted = (0, $01W3b.shallowRef)(false);
    const supportsPictureInPicture = Boolean(document1 && "pictureInPictureEnabled" in document1);
    const sourceErrorEvent = (0, $aPZNl.createEventHook)();
    const playbackErrorEvent = (0, $aPZNl.createEventHook)();
    /**
	* Disables the specified track. If no track is specified then
	* all tracks will be disabled
	*
	* @param track The id of the track to disable
	*/ const disableTrack = (track)=>{
        $85ea9b47855776cf$var$usingElRef(target, (el)=>{
            if (track) {
                const id = typeof track === "number" ? track : track.id;
                el.textTracks[id].mode = "disabled";
            } else for(let i = 0; i < el.textTracks.length; ++i)el.textTracks[i].mode = "disabled";
            selectedTrack.value = -1;
        });
    };
    /**
	* Enables the specified track and disables the
	* other tracks unless otherwise specified
	*
	* @param track The track of the id of the track to enable
	* @param disableTracks Disable all other tracks
	*/ const enableTrack = (track, disableTracks = true)=>{
        $85ea9b47855776cf$var$usingElRef(target, (el)=>{
            const id = typeof track === "number" ? track : track.id;
            if (disableTracks) disableTrack();
            el.textTracks[id].mode = "showing";
            selectedTrack.value = id;
        });
    };
    /**
	* Toggle picture in picture mode for the player.
	*/ const togglePictureInPicture = ()=>{
        return new Promise((resolve, reject)=>{
            $85ea9b47855776cf$var$usingElRef(target, async (el)=>{
                if (supportsPictureInPicture) {
                    if (!isPictureInPicture.value) el.requestPictureInPicture().then(resolve).catch(reject);
                    else document1.exitPictureInPicture().then(resolve).catch(reject);
                }
            });
        });
    };
    /**
	* This will automatically inject sources to the media element. The sources will be
	* appended as children to the media element as `<source>` elements.
	*/ (0, $TusQn.watchEffect)(()=>{
        if (!document1) return;
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        const src = (0, $01W3b.toValue)(options.src);
        let sources = [];
        if (!src) return;
        if (typeof src === "string") sources = [
            {
                src: src
            }
        ];
        else if (Array.isArray(src)) sources = src;
        else if ((0, $aPZNl.isObject)(src)) sources = [
            src
        ];
        el.querySelectorAll("source").forEach((e)=>{
            e.remove();
        });
        sources.forEach(({ src: src, type: type, media: media })=>{
            const source = document1.createElement("source");
            source.setAttribute("src", src);
            source.setAttribute("type", type || "");
            source.setAttribute("media", media || "");
            $85ea9b47855776cf$export$7080b3e976bc91ab(source, "error", sourceErrorEvent.trigger, listenerOptions);
            el.appendChild(source);
        });
        el.load();
    });
    /**
	* Apply composable state to the element, also when element is changed
	*/ (0, $01W3b.watch)([
        target,
        volume
    ], ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        el.volume = volume.value;
    });
    (0, $01W3b.watch)([
        target,
        muted
    ], ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        el.muted = muted.value;
    });
    (0, $01W3b.watch)([
        target,
        rate
    ], ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        el.playbackRate = rate.value;
    });
    /**
	* Load Tracks
	*/ (0, $TusQn.watchEffect)(()=>{
        if (!document1) return;
        const textTracks = (0, $01W3b.toValue)(options.tracks);
        const el = (0, $01W3b.toValue)(target);
        if (!textTracks || !textTracks.length || !el) return;
        /**
		* The MediaAPI provides an API for adding text tracks, but they don't currently
		* have an API for removing text tracks, so instead we will just create and remove
		* the tracks manually using the HTML api.
		*/ el.querySelectorAll("track").forEach((e)=>e.remove());
        textTracks.forEach(({ default: isDefault, kind: kind, label: label, src: src, srcLang: srcLang }, i)=>{
            const track = document1.createElement("track");
            track.default = isDefault || false;
            track.kind = kind;
            track.label = label;
            track.src = src;
            track.srclang = srcLang;
            if (track.default) selectedTrack.value = i;
            el.appendChild(track);
        });
    });
    /**
	* This will allow us to update the current time from the timeupdate event
	* without setting the medias current position, but if the user changes the
	* current time via the ref, then the media will seek.
	*
	* If we did not use an ignorable watch, then the current time update from
	* the timeupdate event would cause the media to stutter.
	*/ const { ignoreUpdates: ignoreCurrentTimeUpdates } = (0, $aPZNl.watchIgnorable)(currentTime, (time)=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        el.currentTime = time;
    });
    /**
	* Using an ignorable watch so we can control the play state using a ref and not
	* a function
	*/ const { ignoreUpdates: ignorePlayingUpdates } = (0, $aPZNl.watchIgnorable)(playing, (isPlaying)=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        if (isPlaying) el.play().catch((e)=>{
            playbackErrorEvent.trigger(e);
            throw e;
        });
        else el.pause();
    });
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "timeupdate", ()=>ignoreCurrentTimeUpdates(()=>currentTime.value = (0, $01W3b.toValue)(target).currentTime), listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "durationchange", ()=>duration.value = (0, $01W3b.toValue)(target).duration, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "progress", ()=>buffered.value = $85ea9b47855776cf$var$timeRangeToArray((0, $01W3b.toValue)(target).buffered), listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "seeking", ()=>seeking.value = true, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "seeked", ()=>seeking.value = false, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, [
        "waiting",
        "loadstart"
    ], ()=>{
        waiting.value = true;
        ignorePlayingUpdates(()=>playing.value = false);
    }, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "loadeddata", ()=>waiting.value = false, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "playing", ()=>{
        waiting.value = false;
        ended.value = false;
        ignorePlayingUpdates(()=>playing.value = true);
    }, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "ratechange", ()=>rate.value = (0, $01W3b.toValue)(target).playbackRate, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "stalled", ()=>stalled.value = true, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "ended", ()=>ended.value = true, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "pause", ()=>ignorePlayingUpdates(()=>playing.value = false), listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "play", ()=>ignorePlayingUpdates(()=>playing.value = true), listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "enterpictureinpicture", ()=>isPictureInPicture.value = true, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "leavepictureinpicture", ()=>isPictureInPicture.value = false, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "volumechange", ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        volume.value = el.volume;
        muted.value = el.muted;
    }, listenerOptions);
    /**
	* The following listeners need to listen to a nested
	* object on the target, so we will have to use a nested
	* watch and manually remove the listeners
	*/ const listeners = [];
    const stop = (0, $01W3b.watch)([
        target
    ], ()=>{
        const el = (0, $01W3b.toValue)(target);
        if (!el) return;
        stop();
        listeners[0] = $85ea9b47855776cf$export$7080b3e976bc91ab(el.textTracks, "addtrack", ()=>tracks.value = $85ea9b47855776cf$var$tracksToArray(el.textTracks), listenerOptions);
        listeners[1] = $85ea9b47855776cf$export$7080b3e976bc91ab(el.textTracks, "removetrack", ()=>tracks.value = $85ea9b47855776cf$var$tracksToArray(el.textTracks), listenerOptions);
        listeners[2] = $85ea9b47855776cf$export$7080b3e976bc91ab(el.textTracks, "change", ()=>tracks.value = $85ea9b47855776cf$var$tracksToArray(el.textTracks), listenerOptions);
    });
    (0, $aPZNl.tryOnScopeDispose)(()=>listeners.forEach((listener)=>listener()));
    return {
        currentTime: currentTime,
        duration: duration,
        waiting: waiting,
        seeking: seeking,
        ended: ended,
        stalled: stalled,
        buffered: buffered,
        playing: playing,
        rate: rate,
        volume: volume,
        muted: muted,
        tracks: tracks,
        selectedTrack: selectedTrack,
        enableTrack: enableTrack,
        disableTrack: disableTrack,
        supportsPictureInPicture: supportsPictureInPicture,
        togglePictureInPicture: togglePictureInPicture,
        isPictureInPicture: isPictureInPicture,
        onSourceError: sourceErrorEvent.on,
        onPlaybackError: playbackErrorEvent.on
    };
}
//#endregion
//#region useMemoize/index.ts
/**
* Reactive function result cache based on arguments
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$7403ef0fca9c6367(resolver, options) {
    const initCache = ()=>{
        if (options === null || options === void 0 ? void 0 : options.cache) return (0, $01W3b.shallowReactive)(options.cache);
        return (0, $01W3b.shallowReactive)(/* @__PURE__ */ new Map());
    };
    const cache = initCache();
    /**
	* Generate key from args
	*/ const generateKey = (...args)=>(options === null || options === void 0 ? void 0 : options.getKey) ? options.getKey(...args) : JSON.stringify(args);
    /**
	* Load data and save in cache
	*/ const _loadData = (key, ...args)=>{
        cache.set(key, resolver(...args));
        return cache.get(key);
    };
    const loadData = (...args)=>_loadData(generateKey(...args), ...args);
    /**
	* Delete key from cache
	*/ const deleteData = (...args)=>{
        cache.delete(generateKey(...args));
    };
    /**
	* Clear cached data
	*/ const clearData = ()=>{
        cache.clear();
    };
    const memoized = (...args)=>{
        const key = generateKey(...args);
        if (cache.has(key)) return cache.get(key);
        return _loadData(key, ...args);
    };
    memoized.load = loadData;
    memoized.delete = deleteData;
    memoized.clear = clearData;
    memoized.generateKey = generateKey;
    memoized.cache = cache;
    return memoized;
}
//#endregion
//#region useMemory/index.ts
function $85ea9b47855776cf$var$getDefaultScheduler$6(options) {
    if ("interval" in options || "immediate" in options || "immediateCallback" in options) {
        const { interval: interval = 1e3, immediate: immediate, immediateCallback: immediateCallback } = options;
        return (cb)=>(0, $aPZNl.useIntervalFn)(cb, interval, {
                immediate: immediate,
                immediateCallback: immediateCallback
            });
    }
    return 0, $aPZNl.useIntervalFn;
}
/**
* Reactive Memory Info.
*
* @see https://vueuse.org/useMemory
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$b1c8a28243292cb9(options = {}) {
    const memory = (0, $01W3b.shallowRef)();
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>typeof performance !== "undefined" && "memory" in performance);
    if (isSupported.value) {
        const { scheduler: scheduler = $85ea9b47855776cf$var$getDefaultScheduler$6 } = options;
        scheduler(()=>{
            memory.value = performance.memory;
        });
    }
    return {
        isSupported: isSupported,
        memory: memory
    };
}
//#endregion
//#region useMouse/index.ts
const $85ea9b47855776cf$var$UseMouseBuiltinExtractors = {
    page: (event)=>[
            event.pageX,
            event.pageY
        ],
    client: (event)=>[
            event.clientX,
            event.clientY
        ],
    screen: (event)=>[
            event.screenX,
            event.screenY
        ],
    movement: (event)=>event instanceof MouseEvent ? [
            event.movementX,
            event.movementY
        ] : null
};
/**
* Reactive mouse position.
*
* @see https://vueuse.org/useMouse
* @param options
*/ function $85ea9b47855776cf$export$70811b4970b0f258(options = {}) {
    const { type: type = "page", touch: touch = true, resetOnTouchEnds: resetOnTouchEnds = false, initialValue: initialValue = {
        x: 0,
        y: 0
    }, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, target: target = window1, scroll: scroll = true, eventFilter: eventFilter } = options;
    let _prevMouseEvent = null;
    let _prevScrollX = 0;
    let _prevScrollY = 0;
    const x = (0, $01W3b.shallowRef)(initialValue.x);
    const y = (0, $01W3b.shallowRef)(initialValue.y);
    const sourceType = (0, $01W3b.shallowRef)(null);
    const extractor = typeof type === "function" ? type : $85ea9b47855776cf$var$UseMouseBuiltinExtractors[type];
    const mouseHandler = (event)=>{
        const result = extractor(event);
        _prevMouseEvent = event;
        if (result) {
            [x.value, y.value] = result;
            sourceType.value = "mouse";
        }
        if (window1) {
            _prevScrollX = window1.scrollX;
            _prevScrollY = window1.scrollY;
        }
    };
    const touchHandler = (event)=>{
        if (event.touches.length > 0) {
            const result = extractor(event.touches[0]);
            if (result) {
                [x.value, y.value] = result;
                sourceType.value = "touch";
            }
        }
    };
    const scrollHandler = ()=>{
        if (!_prevMouseEvent || !window1) return;
        const pos = extractor(_prevMouseEvent);
        if (_prevMouseEvent instanceof MouseEvent && pos) {
            x.value = pos[0] + window1.scrollX - _prevScrollX;
            y.value = pos[1] + window1.scrollY - _prevScrollY;
        }
    };
    const reset = ()=>{
        x.value = initialValue.x;
        y.value = initialValue.y;
    };
    const mouseHandlerWrapper = eventFilter ? (event)=>eventFilter(()=>mouseHandler(event), {}) : (event)=>mouseHandler(event);
    const touchHandlerWrapper = eventFilter ? (event)=>eventFilter(()=>touchHandler(event), {}) : (event)=>touchHandler(event);
    const scrollHandlerWrapper = eventFilter ? ()=>eventFilter(()=>scrollHandler(), {}) : ()=>scrollHandler();
    if (target) {
        const listenerOptions = {
            passive: true
        };
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, [
            "mousemove",
            "dragover"
        ], mouseHandlerWrapper, listenerOptions);
        if (touch && type !== "movement") {
            $85ea9b47855776cf$export$7080b3e976bc91ab(target, [
                "touchstart",
                "touchmove"
            ], touchHandlerWrapper, listenerOptions);
            if (resetOnTouchEnds) $85ea9b47855776cf$export$7080b3e976bc91ab(target, "touchend", reset, listenerOptions);
        }
        if (scroll && type === "page") $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "scroll", scrollHandlerWrapper, listenerOptions);
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType
    };
}
//#endregion
//#region useMouseInElement/index.ts
/**
* Reactive mouse position related to an element.
*
* @see https://vueuse.org/useMouseInElement
* @param target
* @param options
*/ function $85ea9b47855776cf$export$74acb291b8ceb4b8(target, options = {}) {
    const { windowResize: windowResize = true, windowScroll: windowScroll = true, handleOutside: handleOutside = true, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const type = options.type || "page";
    const { x: x, y: y, sourceType: sourceType } = $85ea9b47855776cf$export$70811b4970b0f258(options);
    const targetRef = (0, $01W3b.shallowRef)(target !== null && target !== void 0 ? target : window1 === null || window1 === void 0 ? void 0 : window1.document.body);
    const elementX = (0, $01W3b.shallowRef)(0);
    const elementY = (0, $01W3b.shallowRef)(0);
    const elementPositionX = (0, $01W3b.shallowRef)(0);
    const elementPositionY = (0, $01W3b.shallowRef)(0);
    const elementHeight = (0, $01W3b.shallowRef)(0);
    const elementWidth = (0, $01W3b.shallowRef)(0);
    const isOutside = (0, $01W3b.shallowRef)(true);
    function update() {
        if (!window1) return;
        const el = $85ea9b47855776cf$export$c61124d3cf5adbae(targetRef);
        if (!el || !(el instanceof Element)) return;
        for (const rect of el.getClientRects()){
            const { left: left, top: top, width: width, height: height } = rect;
            elementPositionX.value = left + (type === "page" ? window1.pageXOffset : 0);
            elementPositionY.value = top + (type === "page" ? window1.pageYOffset : 0);
            elementHeight.value = height;
            elementWidth.value = width;
            const elX = x.value - elementPositionX.value;
            const elY = y.value - elementPositionY.value;
            isOutside.value = width === 0 || height === 0 || elX < 0 || elY < 0 || elX > width || elY > height;
            if (handleOutside || !isOutside.value) {
                elementX.value = elX;
                elementY.value = elY;
            }
            if (!isOutside.value) break;
        }
    }
    const stopFnList = [];
    function stop() {
        stopFnList.forEach((fn)=>fn());
        stopFnList.length = 0;
    }
    (0, $aPZNl.tryOnMounted)(()=>{
        update();
    });
    if (window1) {
        const { stop: stopResizeObserver } = $85ea9b47855776cf$export$683480f191c0e3ea(targetRef, update);
        const { stop: stopMutationObserver } = $85ea9b47855776cf$export$8ecdcf3bb089e9cd(targetRef, update, {
            attributeFilter: [
                "style",
                "class"
            ]
        });
        const stopWatch = (0, $01W3b.watch)([
            targetRef,
            x,
            y
        ], update);
        stopFnList.push(stopResizeObserver, stopMutationObserver, stopWatch);
        $85ea9b47855776cf$export$7080b3e976bc91ab(document, "mouseleave", ()=>isOutside.value = true, {
            passive: true
        });
        if (windowScroll) stopFnList.push($85ea9b47855776cf$export$7080b3e976bc91ab("scroll", update, {
            capture: true,
            passive: true
        }));
        if (windowResize) stopFnList.push($85ea9b47855776cf$export$7080b3e976bc91ab("resize", update, {
            passive: true
        }));
    }
    return {
        x: x,
        y: y,
        sourceType: sourceType,
        elementX: elementX,
        elementY: elementY,
        elementPositionX: elementPositionX,
        elementPositionY: elementPositionY,
        elementHeight: elementHeight,
        elementWidth: elementWidth,
        isOutside: isOutside,
        stop: stop
    };
}
//#endregion
//#region useMousePressed/index.ts
/**
* Reactive mouse pressing state.
*
* @see https://vueuse.org/useMousePressed
* @param options
*/ function $85ea9b47855776cf$export$5d7a2a40c559277c(options = {}) {
    const { touch: touch = true, drag: drag = true, capture: capture = false, initialValue: initialValue = false, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const pressed = (0, $01W3b.shallowRef)(initialValue);
    const sourceType = (0, $01W3b.shallowRef)(null);
    if (!window1) return {
        pressed: pressed,
        sourceType: sourceType
    };
    const onPressed = (srcType)=>(event)=>{
            var _options$onPressed;
            pressed.value = true;
            sourceType.value = srcType;
            (_options$onPressed = options.onPressed) === null || _options$onPressed === void 0 || _options$onPressed.call(options, event);
        };
    const onReleased = (event)=>{
        var _options$onReleased;
        pressed.value = false;
        sourceType.value = null;
        (_options$onReleased = options.onReleased) === null || _options$onReleased === void 0 || _options$onReleased.call(options, event);
    };
    const target = (0, $01W3b.computed)(()=>$85ea9b47855776cf$export$c61124d3cf5adbae(options.target) || window1);
    const listenerOptions = {
        passive: true,
        capture: capture
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab(target, "mousedown", onPressed("mouse"), listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "mouseleave", onReleased, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "mouseup", onReleased, listenerOptions);
    if (drag) {
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "dragstart", onPressed("mouse"), listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "drop", onReleased, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "dragend", onReleased, listenerOptions);
    }
    if (touch) {
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "touchstart", onPressed("touch"), listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "touchend", onReleased, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "touchcancel", onReleased, listenerOptions);
    }
    return {
        pressed: pressed,
        sourceType: sourceType
    };
}
//#endregion
//#region useNavigatorLanguage/index.ts
/**
*
* Reactive useNavigatorLanguage
*
* Detects the currently selected user language and returns a reactive language
* @see https://vueuse.org/useNavigatorLanguage
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$64fd3a716d6bb70f(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const navigator1 = window1 === null || window1 === void 0 ? void 0 : window1.navigator;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "language" in navigator1);
    const language = (0, $01W3b.shallowRef)(navigator1 === null || navigator1 === void 0 ? void 0 : navigator1.language);
    $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "languagechange", ()=>{
        if (navigator1) language.value = navigator1.language;
    }, {
        passive: true
    });
    return {
        isSupported: isSupported,
        language: language
    };
}
//#endregion
//#region useNetwork/index.ts
/**
* Reactive Network status.
*
* @see https://vueuse.org/useNetwork
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$553aaf59afc1a2d8(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const navigator1 = window1 === null || window1 === void 0 ? void 0 : window1.navigator;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "connection" in navigator1);
    const isOnline = (0, $01W3b.shallowRef)(true);
    const saveData = (0, $01W3b.shallowRef)(false);
    const offlineAt = (0, $01W3b.shallowRef)(void 0);
    const onlineAt = (0, $01W3b.shallowRef)(void 0);
    const downlink = (0, $01W3b.shallowRef)(void 0);
    const downlinkMax = (0, $01W3b.shallowRef)(void 0);
    const rtt = (0, $01W3b.shallowRef)(void 0);
    const effectiveType = (0, $01W3b.shallowRef)(void 0);
    const type = (0, $01W3b.shallowRef)("unknown");
    const connection = isSupported.value && navigator1.connection;
    function updateNetworkInformation() {
        if (!navigator1) return;
        isOnline.value = navigator1.onLine;
        offlineAt.value = isOnline.value ? void 0 : Date.now();
        onlineAt.value = isOnline.value ? Date.now() : void 0;
        if (connection) {
            downlink.value = connection.downlink;
            downlinkMax.value = connection.downlinkMax;
            effectiveType.value = connection.effectiveType;
            rtt.value = connection.rtt;
            saveData.value = connection.saveData;
            type.value = connection.type;
        }
    }
    const listenerOptions = {
        passive: true
    };
    if (window1) {
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "offline", ()=>{
            isOnline.value = false;
            offlineAt.value = Date.now();
        }, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "online", ()=>{
            isOnline.value = true;
            onlineAt.value = Date.now();
        }, listenerOptions);
    }
    if (connection) $85ea9b47855776cf$export$7080b3e976bc91ab(connection, "change", updateNetworkInformation, listenerOptions);
    updateNetworkInformation();
    return {
        isSupported: isSupported,
        isOnline: (0, $01W3b.shallowReadonly)(isOnline),
        saveData: (0, $01W3b.shallowReadonly)(saveData),
        offlineAt: (0, $01W3b.shallowReadonly)(offlineAt),
        onlineAt: (0, $01W3b.shallowReadonly)(onlineAt),
        downlink: (0, $01W3b.shallowReadonly)(downlink),
        downlinkMax: (0, $01W3b.shallowReadonly)(downlinkMax),
        effectiveType: (0, $01W3b.shallowReadonly)(effectiveType),
        rtt: (0, $01W3b.shallowReadonly)(rtt),
        type: (0, $01W3b.shallowReadonly)(type)
    };
}
//#endregion
//#region useNow/index.ts
function $85ea9b47855776cf$var$getDefaultScheduler$5(options) {
    if ("interval" in options || "immediate" in options) {
        const { interval: interval = "requestAnimationFrame", immediate: immediate = true } = options;
        return interval === "requestAnimationFrame" ? (fn)=>$85ea9b47855776cf$export$13251e0fc79284e(fn, {
                immediate: immediate
            }) : (fn)=>(0, $aPZNl.useIntervalFn)(fn, interval, options);
    }
    return $85ea9b47855776cf$export$13251e0fc79284e;
}
/**
* Reactive current Date instance.
*
* @see https://vueuse.org/useNow
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$3a404aece3dff2fa(options = {}) {
    const { controls: exposeControls = false, scheduler: scheduler = $85ea9b47855776cf$var$getDefaultScheduler$5(options) } = options;
    const now = (0, $01W3b.shallowRef)(/* @__PURE__ */ new Date());
    const update = ()=>now.value = /* @__PURE__ */ new Date();
    const controls = scheduler(update);
    if (exposeControls) return {
        now: now,
        ...controls
    };
    else return now;
}
//#endregion
//#region useObjectUrl/index.ts
/**
* Reactive URL representing an object.
*
* @see https://vueuse.org/useObjectUrl
* @param object
*/ function $85ea9b47855776cf$export$533619a63360a89b(object) {
    const url = (0, $01W3b.shallowRef)();
    const release = ()=>{
        if (url.value) URL.revokeObjectURL(url.value);
        url.value = void 0;
    };
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(object), (newObject)=>{
        release();
        if (newObject) url.value = URL.createObjectURL(newObject);
    }, {
        immediate: true
    });
    (0, $aPZNl.tryOnScopeDispose)(release);
    return (0, $01W3b.shallowReadonly)(url);
}
//#endregion
//#region ../math/useClamp/index.ts
/**
* Reactively clamp a value between two other values.
*
* @see https://vueuse.org/useClamp
* @param value number
* @param min
* @param max
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$var$useClamp(value, min, max) {
    if (typeof value === "function" || (0, $01W3b.isReadonly)(value)) return (0, $01W3b.computed)(()=>(0, $aPZNl.clamp)((0, $01W3b.toValue)(value), (0, $01W3b.toValue)(min), (0, $01W3b.toValue)(max)));
    const _value = (0, $01W3b.ref)(value);
    return (0, $01W3b.computed)({
        get () {
            return _value.value = (0, $aPZNl.clamp)(_value.value, (0, $01W3b.toValue)(min), (0, $01W3b.toValue)(max));
        },
        set (value) {
            _value.value = (0, $aPZNl.clamp)(value, (0, $01W3b.toValue)(min), (0, $01W3b.toValue)(max));
        }
    });
}
//#endregion
//#region useOffsetPagination/index.ts
function $85ea9b47855776cf$export$dca1841098f618ea(options) {
    const { total: total = Number.POSITIVE_INFINITY, pageSize: pageSize = 10, page: page = 1, onPageChange: onPageChange = (0, $aPZNl.noop), onPageSizeChange: onPageSizeChange = (0, $aPZNl.noop), onPageCountChange: onPageCountChange = (0, $aPZNl.noop) } = options;
    const currentPageSize = $85ea9b47855776cf$var$useClamp(pageSize, 1, Number.POSITIVE_INFINITY);
    const pageCount = (0, $01W3b.computed)(()=>Math.max(1, Math.ceil((0, $01W3b.toValue)(total) / (0, $01W3b.toValue)(currentPageSize))));
    const currentPage = $85ea9b47855776cf$var$useClamp(page, 1, pageCount);
    const isFirstPage = (0, $01W3b.computed)(()=>currentPage.value === 1);
    const isLastPage = (0, $01W3b.computed)(()=>currentPage.value === pageCount.value);
    if ((0, $01W3b.isRef)(page)) (0, $aPZNl.syncRef)(page, currentPage, {
        direction: (0, $01W3b.isReadonly)(page) ? "ltr" : "both"
    });
    if ((0, $01W3b.isRef)(pageSize)) (0, $aPZNl.syncRef)(pageSize, currentPageSize, {
        direction: (0, $01W3b.isReadonly)(pageSize) ? "ltr" : "both"
    });
    function prev() {
        currentPage.value--;
    }
    function next() {
        currentPage.value++;
    }
    const returnValue = {
        currentPage: currentPage,
        currentPageSize: currentPageSize,
        pageCount: pageCount,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage,
        prev: prev,
        next: next
    };
    (0, $01W3b.watch)(currentPage, ()=>{
        onPageChange((0, $01W3b.reactive)(returnValue));
    });
    (0, $01W3b.watch)(currentPageSize, ()=>{
        onPageSizeChange((0, $01W3b.reactive)(returnValue));
    });
    (0, $01W3b.watch)(pageCount, ()=>{
        onPageCountChange((0, $01W3b.reactive)(returnValue));
    });
    return returnValue;
}
//#endregion
//#region useOnline/index.ts
/**
* Reactive online state.
*
* @see https://vueuse.org/useOnline
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$6feb6ada280bcdab(options = {}) {
    const { isOnline: isOnline } = $85ea9b47855776cf$export$553aaf59afc1a2d8(options);
    return isOnline;
}
//#endregion
//#region usePageLeave/index.ts
/**
* Reactive state to show whether mouse leaves the page.
*
* @see https://vueuse.org/usePageLeave
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$6bd1f37e929013e5(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const isLeft = (0, $01W3b.shallowRef)(false);
    const handler = (event)=>{
        if (!window1) return;
        event = event || window1.event;
        isLeft.value = !(event.relatedTarget || event.toElement);
    };
    if (window1) {
        const listenerOptions = {
            passive: true
        };
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "mouseout", handler, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1.document, "mouseleave", handler, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(window1.document, "mouseenter", handler, listenerOptions);
    }
    return isLeft;
}
//#endregion
//#region useScreenOrientation/index.ts
/**
* Reactive screen orientation
*
* @see https://vueuse.org/useScreenOrientation
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$588695585364abce(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && "screen" in window1 && "orientation" in window1.screen);
    const screenOrientation = isSupported.value ? window1.screen.orientation : {};
    const orientation = (0, $01W3b.shallowRef)(screenOrientation.type);
    const angle = (0, $01W3b.shallowRef)(screenOrientation.angle || 0);
    if (isSupported.value) $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "orientationchange", ()=>{
        orientation.value = screenOrientation.type;
        angle.value = screenOrientation.angle;
    }, {
        passive: true
    });
    const lockOrientation = (type)=>{
        if (isSupported.value && typeof screenOrientation.lock === "function") return screenOrientation.lock(type);
        return Promise.reject(/* @__PURE__ */ new Error("Not supported"));
    };
    const unlockOrientation = ()=>{
        if (isSupported.value && typeof screenOrientation.unlock === "function") screenOrientation.unlock();
    };
    return {
        isSupported: isSupported,
        orientation: orientation,
        angle: angle,
        lockOrientation: lockOrientation,
        unlockOrientation: unlockOrientation
    };
}
//#endregion
//#region useParallax/index.ts
/**
* Create parallax effect easily. It uses `useDeviceOrientation` and fallback to `useMouse`
* if orientation is not supported.
*
* @param target
* @param options
*/ function $85ea9b47855776cf$export$78dabaa73e04c89f(target, options = {}) {
    const { deviceOrientationTiltAdjust: deviceOrientationTiltAdjust = (i)=>i, deviceOrientationRollAdjust: deviceOrientationRollAdjust = (i)=>i, mouseTiltAdjust: mouseTiltAdjust = (i)=>i, mouseRollAdjust: mouseRollAdjust = (i)=>i, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const orientation = (0, $01W3b.reactive)($85ea9b47855776cf$export$9bafe4f626b63a33({
        window: window1
    }));
    const screenOrientation = (0, $01W3b.reactive)($85ea9b47855776cf$export$588695585364abce({
        window: window1
    }));
    const { elementX: x, elementY: y, elementWidth: width, elementHeight: height } = $85ea9b47855776cf$export$74acb291b8ceb4b8(target, {
        handleOutside: false,
        window: window1
    });
    const source = (0, $01W3b.computed)(()=>{
        if (orientation.isSupported && (orientation.alpha != null && orientation.alpha !== 0 || orientation.gamma != null && orientation.gamma !== 0)) return "deviceOrientation";
        return "mouse";
    });
    return {
        roll: (0, $01W3b.computed)(()=>{
            if (source.value === "deviceOrientation") {
                let value;
                switch(screenOrientation.orientation){
                    case "landscape-primary":
                        value = orientation.gamma / 90;
                        break;
                    case "landscape-secondary":
                        value = -orientation.gamma / 90;
                        break;
                    case "portrait-primary":
                        value = -orientation.beta / 90;
                        break;
                    case "portrait-secondary":
                        value = orientation.beta / 90;
                        break;
                    default:
                        value = -orientation.beta / 90;
                }
                return deviceOrientationRollAdjust(value);
            } else return mouseRollAdjust(-(y.value - height.value / 2) / height.value);
        }),
        tilt: (0, $01W3b.computed)(()=>{
            if (source.value === "deviceOrientation") {
                let value;
                switch(screenOrientation.orientation){
                    case "landscape-primary":
                        value = orientation.beta / 90;
                        break;
                    case "landscape-secondary":
                        value = -orientation.beta / 90;
                        break;
                    case "portrait-primary":
                        value = orientation.gamma / 90;
                        break;
                    case "portrait-secondary":
                        value = -orientation.gamma / 90;
                        break;
                    default:
                        value = orientation.gamma / 90;
                }
                return deviceOrientationTiltAdjust(value);
            } else return mouseTiltAdjust((x.value - width.value / 2) / width.value);
        }),
        source: source
    };
}
//#endregion
//#region useParentElement/index.ts
function $85ea9b47855776cf$export$868ba98d0a4efc6f(element = $85ea9b47855776cf$export$8d937a32bc2b31dd()) {
    const parentElement = (0, $01W3b.shallowRef)();
    const update = ()=>{
        const el = $85ea9b47855776cf$export$c61124d3cf5adbae(element);
        if (el) parentElement.value = el.parentElement;
    };
    (0, $aPZNl.tryOnMounted)(update);
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(element), update);
    return parentElement;
}
//#endregion
//#region usePerformanceObserver/index.ts
/**
* Observe performance metrics.
*
* @see https://vueuse.org/usePerformanceObserver
* @param options
*/ function $85ea9b47855776cf$export$d3d061a08d0fe848(options, callback) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, immediate: immediate = true, ...performanceOptions } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>window1 && "PerformanceObserver" in window1);
    let observer;
    const stop = ()=>{
        observer === null || observer === void 0 || observer.disconnect();
    };
    const start = ()=>{
        if (isSupported.value) {
            stop();
            observer = new PerformanceObserver(callback);
            observer.observe(performanceOptions);
        }
    };
    (0, $aPZNl.tryOnScopeDispose)(stop);
    if (immediate) start();
    return {
        isSupported: isSupported,
        start: start,
        stop: stop
    };
}
//#endregion
//#region usePointer/index.ts
const $85ea9b47855776cf$var$defaultState = /* #__PURE__ */ {
    x: 0,
    y: 0,
    pointerId: 0,
    pressure: 0,
    tiltX: 0,
    tiltY: 0,
    width: 0,
    height: 0,
    twist: 0,
    pointerType: null
};
const $85ea9b47855776cf$var$keys = /* @__PURE__ */ Object.keys($85ea9b47855776cf$var$defaultState);
/**
* Reactive pointer state.
*
* @see https://vueuse.org/usePointer
* @param options
*/ function $85ea9b47855776cf$export$a6d851f32526772(options = {}) {
    const { target: target = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const isInside = (0, $01W3b.shallowRef)(false);
    const state = (0, $01W3b.shallowRef)(options.initialValue || {});
    Object.assign(state.value, $85ea9b47855776cf$var$defaultState, state.value);
    const handler = (event)=>{
        isInside.value = true;
        if (options.pointerTypes && !options.pointerTypes.includes(event.pointerType)) return;
        state.value = (0, $aPZNl.objectPick)(event, $85ea9b47855776cf$var$keys, false);
    };
    if (target) {
        const listenerOptions = {
            passive: true
        };
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, [
            "pointerdown",
            "pointermove",
            "pointerup"
        ], handler, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "pointerleave", ()=>isInside.value = false, listenerOptions);
    }
    return {
        ...(0, $aPZNl.toRefs)(state),
        isInside: isInside
    };
}
//#endregion
//#region usePointerLock/index.ts
/**
* Reactive pointer lock.
*
* @see https://vueuse.org/usePointerLock
* @param target
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$fc4b89f039a97947(target, options = {}) {
    const { document: document1 = $85ea9b47855776cf$export$37990bd438d16af3 } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>document1 && "pointerLockElement" in document1);
    const element = (0, $01W3b.shallowRef)();
    const triggerElement = (0, $01W3b.shallowRef)();
    let targetElement;
    if (isSupported.value) {
        const listenerOptions = {
            passive: true
        };
        $85ea9b47855776cf$export$7080b3e976bc91ab(document1, "pointerlockchange", ()=>{
            var _pointerLockElement;
            const currentElement = (_pointerLockElement = document1.pointerLockElement) !== null && _pointerLockElement !== void 0 ? _pointerLockElement : element.value;
            if (targetElement && currentElement === targetElement) {
                element.value = document1.pointerLockElement;
                if (!element.value) targetElement = triggerElement.value = null;
            }
        }, listenerOptions);
        $85ea9b47855776cf$export$7080b3e976bc91ab(document1, "pointerlockerror", ()=>{
            var _pointerLockElement2;
            const currentElement = (_pointerLockElement2 = document1.pointerLockElement) !== null && _pointerLockElement2 !== void 0 ? _pointerLockElement2 : element.value;
            if (targetElement && currentElement === targetElement) {
                const action = document1.pointerLockElement ? "release" : "acquire";
                throw new Error(`Failed to ${action} pointer lock.`);
            }
        }, listenerOptions);
    }
    async function lock(e) {
        var _unrefElement;
        if (!isSupported.value) throw new Error("Pointer Lock API is not supported by your browser.");
        triggerElement.value = e instanceof Event ? e.currentTarget : null;
        targetElement = e instanceof Event ? (_unrefElement = $85ea9b47855776cf$export$c61124d3cf5adbae(target)) !== null && _unrefElement !== void 0 ? _unrefElement : triggerElement.value : $85ea9b47855776cf$export$c61124d3cf5adbae(e);
        if (!targetElement) throw new Error("Target element undefined.");
        targetElement.requestPointerLock();
        return await (0, $aPZNl.until)(element).toBe(targetElement);
    }
    async function unlock() {
        if (!element.value) return false;
        document1.exitPointerLock();
        await (0, $aPZNl.until)(element).toBeNull();
        return true;
    }
    return {
        isSupported: isSupported,
        element: element,
        triggerElement: triggerElement,
        lock: lock,
        unlock: unlock
    };
}
//#endregion
//#region usePointerSwipe/index.ts
/**
* Reactive swipe detection based on PointerEvents.
*
* @see https://vueuse.org/usePointerSwipe
* @param target
* @param options
*/ function $85ea9b47855776cf$export$abaee32ee49963c1(target, options = {}) {
    const targetRef = (0, $aPZNl.toRef)(target);
    const { threshold: threshold = 50, onSwipe: onSwipe, onSwipeEnd: onSwipeEnd, onSwipeStart: onSwipeStart, disableTextSelect: disableTextSelect = false } = options;
    const posStart = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const updatePosStart = (x, y)=>{
        posStart.x = x;
        posStart.y = y;
    };
    const posEnd = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const updatePosEnd = (x, y)=>{
        posEnd.x = x;
        posEnd.y = y;
    };
    const distanceX = (0, $01W3b.computed)(()=>posStart.x - posEnd.x);
    const distanceY = (0, $01W3b.computed)(()=>posStart.y - posEnd.y);
    const { max: max, abs: abs } = Math;
    const isThresholdExceeded = (0, $01W3b.computed)(()=>max(abs(distanceX.value), abs(distanceY.value)) >= threshold);
    const isSwiping = (0, $01W3b.shallowRef)(false);
    const isPointerDown = (0, $01W3b.shallowRef)(false);
    const direction = (0, $01W3b.computed)(()=>{
        if (!isThresholdExceeded.value) return "none";
        if (abs(distanceX.value) > abs(distanceY.value)) return distanceX.value > 0 ? "left" : "right";
        else return distanceY.value > 0 ? "up" : "down";
    });
    const eventIsAllowed = (e)=>{
        var _ref, _options$pointerTypes, _options$pointerTypes2;
        const isReleasingButton = e.buttons === 0;
        const isPrimaryButton = e.buttons === 1;
        return (_ref = (_options$pointerTypes = (_options$pointerTypes2 = options.pointerTypes) === null || _options$pointerTypes2 === void 0 ? void 0 : _options$pointerTypes2.includes(e.pointerType)) !== null && _options$pointerTypes !== void 0 ? _options$pointerTypes : isReleasingButton || isPrimaryButton) !== null && _ref !== void 0 ? _ref : true;
    };
    const listenerOptions = {
        passive: true
    };
    const stops = [
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "pointerdown", (e)=>{
            if (!eventIsAllowed(e)) return;
            isPointerDown.value = true;
            const eventTarget = e.target;
            eventTarget === null || eventTarget === void 0 || eventTarget.setPointerCapture(e.pointerId);
            const { clientX: x, clientY: y } = e;
            updatePosStart(x, y);
            updatePosEnd(x, y);
            onSwipeStart === null || onSwipeStart === void 0 || onSwipeStart(e);
        }, listenerOptions),
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "pointermove", (e)=>{
            if (!eventIsAllowed(e)) return;
            if (!isPointerDown.value) return;
            const { clientX: x, clientY: y } = e;
            updatePosEnd(x, y);
            if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
            if (isSwiping.value) onSwipe === null || onSwipe === void 0 || onSwipe(e);
        }, listenerOptions),
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "pointerup", (e)=>{
            if (!eventIsAllowed(e)) return;
            if (isSwiping.value) onSwipeEnd === null || onSwipeEnd === void 0 || onSwipeEnd(e, direction.value);
            isPointerDown.value = false;
            isSwiping.value = false;
        }, listenerOptions)
    ];
    (0, $aPZNl.tryOnMounted)(()=>{
        var _targetRef$value;
        (_targetRef$value = targetRef.value) === null || _targetRef$value === void 0 || (_targetRef$value = _targetRef$value.style) === null || _targetRef$value === void 0 || _targetRef$value.setProperty("touch-action", "pan-y");
        if (disableTextSelect) {
            var _targetRef$value2, _targetRef$value3, _targetRef$value4;
            (_targetRef$value2 = targetRef.value) === null || _targetRef$value2 === void 0 || (_targetRef$value2 = _targetRef$value2.style) === null || _targetRef$value2 === void 0 || _targetRef$value2.setProperty("-webkit-user-select", "none");
            (_targetRef$value3 = targetRef.value) === null || _targetRef$value3 === void 0 || (_targetRef$value3 = _targetRef$value3.style) === null || _targetRef$value3 === void 0 || _targetRef$value3.setProperty("-ms-user-select", "none");
            (_targetRef$value4 = targetRef.value) === null || _targetRef$value4 === void 0 || (_targetRef$value4 = _targetRef$value4.style) === null || _targetRef$value4 === void 0 || _targetRef$value4.setProperty("user-select", "none");
        }
    });
    const stop = ()=>stops.forEach((s)=>s());
    return {
        isSwiping: (0, $01W3b.shallowReadonly)(isSwiping),
        direction: (0, $01W3b.shallowReadonly)(direction),
        posStart: (0, $01W3b.readonly)(posStart),
        posEnd: (0, $01W3b.readonly)(posEnd),
        distanceX: distanceX,
        distanceY: distanceY,
        stop: stop
    };
}
//#endregion
//#region usePreferredColorScheme/index.ts
/**
* Reactive prefers-color-scheme media query.
*
* @see https://vueuse.org/usePreferredColorScheme
* @param [options]
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$7c3b8f854ca5e941(options) {
    const isLight = $85ea9b47855776cf$export$32d5543ab307c01("(prefers-color-scheme: light)", options);
    const isDark = $85ea9b47855776cf$export$32d5543ab307c01("(prefers-color-scheme: dark)", options);
    return (0, $01W3b.computed)(()=>{
        if (isDark.value) return "dark";
        if (isLight.value) return "light";
        return "no-preference";
    });
}
//#endregion
//#region usePreferredContrast/index.ts
/**
* Reactive prefers-contrast media query.
*
* @see https://vueuse.org/usePreferredContrast
* @param [options]
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$14fe172294a7a184(options) {
    const isMore = $85ea9b47855776cf$export$32d5543ab307c01("(prefers-contrast: more)", options);
    const isLess = $85ea9b47855776cf$export$32d5543ab307c01("(prefers-contrast: less)", options);
    const isCustom = $85ea9b47855776cf$export$32d5543ab307c01("(prefers-contrast: custom)", options);
    return (0, $01W3b.computed)(()=>{
        if (isMore.value) return "more";
        if (isLess.value) return "less";
        if (isCustom.value) return "custom";
        return "no-preference";
    });
}
//#endregion
//#region usePreferredLanguages/index.ts
/**
* Reactive Navigator Languages.
*
* @see https://vueuse.org/usePreferredLanguages
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$408b11bf0000ced3(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $01W3b.shallowRef)([
        "en"
    ]);
    const navigator1 = window1.navigator;
    const value = (0, $01W3b.shallowRef)(navigator1.languages);
    $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "languagechange", ()=>{
        value.value = navigator1.languages;
    }, {
        passive: true
    });
    return value;
}
//#endregion
//#region usePreferredReducedMotion/index.ts
/**
* Reactive prefers-reduced-motion media query.
*
* @see https://vueuse.org/usePreferredReducedMotion
* @param [options]
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$66a8176c0ff6800c(options) {
    const isReduced = $85ea9b47855776cf$export$32d5543ab307c01("(prefers-reduced-motion: reduce)", options);
    return (0, $01W3b.computed)(()=>{
        if (isReduced.value) return "reduce";
        return "no-preference";
    });
}
//#endregion
//#region usePreferredReducedTransparency/index.ts
/**
* Reactive prefers-reduced-transparency media query.
*
* @see https://vueuse.org/usePreferredReducedTransparency
* @param [options]
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$d9ef768c38bc7027(options) {
    const isReduced = $85ea9b47855776cf$export$32d5543ab307c01("(prefers-reduced-transparency: reduce)", options);
    return (0, $01W3b.computed)(()=>{
        if (isReduced.value) return "reduce";
        return "no-preference";
    });
}
//#endregion
//#region usePrevious/index.ts
function $85ea9b47855776cf$export$5cae361ad82dce8b(value, initialValue) {
    const previous = (0, $01W3b.shallowRef)(initialValue);
    (0, $01W3b.watch)((0, $aPZNl.toRef)(value), (_, oldValue)=>{
        previous.value = oldValue;
    }, {
        flush: "sync"
    });
    return (0, $01W3b.readonly)(previous);
}
//#endregion
//#region useScreenSafeArea/index.ts
const $85ea9b47855776cf$var$topVarName = "--vueuse-safe-area-top";
const $85ea9b47855776cf$var$rightVarName = "--vueuse-safe-area-right";
const $85ea9b47855776cf$var$bottomVarName = "--vueuse-safe-area-bottom";
const $85ea9b47855776cf$var$leftVarName = "--vueuse-safe-area-left";
/**
* Reactive `env(safe-area-inset-*)`
*
* @see https://vueuse.org/useScreenSafeArea
*/ function $85ea9b47855776cf$export$40dfca171e090791() {
    const top = (0, $01W3b.shallowRef)("");
    const right = (0, $01W3b.shallowRef)("");
    const bottom = (0, $01W3b.shallowRef)("");
    const left = (0, $01W3b.shallowRef)("");
    if (0, $aPZNl.isClient) {
        const topCssVar = $85ea9b47855776cf$export$811e58a9be6ff112($85ea9b47855776cf$var$topVarName);
        const rightCssVar = $85ea9b47855776cf$export$811e58a9be6ff112($85ea9b47855776cf$var$rightVarName);
        const bottomCssVar = $85ea9b47855776cf$export$811e58a9be6ff112($85ea9b47855776cf$var$bottomVarName);
        const leftCssVar = $85ea9b47855776cf$export$811e58a9be6ff112($85ea9b47855776cf$var$leftVarName);
        topCssVar.value = "env(safe-area-inset-top, 0px)";
        rightCssVar.value = "env(safe-area-inset-right, 0px)";
        bottomCssVar.value = "env(safe-area-inset-bottom, 0px)";
        leftCssVar.value = "env(safe-area-inset-left, 0px)";
        (0, $aPZNl.tryOnMounted)(update);
        $85ea9b47855776cf$export$7080b3e976bc91ab("resize", (0, $aPZNl.useDebounceFn)(update), {
            passive: true
        });
    }
    function update() {
        top.value = $85ea9b47855776cf$var$getValue($85ea9b47855776cf$var$topVarName);
        right.value = $85ea9b47855776cf$var$getValue($85ea9b47855776cf$var$rightVarName);
        bottom.value = $85ea9b47855776cf$var$getValue($85ea9b47855776cf$var$bottomVarName);
        left.value = $85ea9b47855776cf$var$getValue($85ea9b47855776cf$var$leftVarName);
    }
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        update: update
    };
}
function $85ea9b47855776cf$var$getValue(position) {
    return getComputedStyle(document.documentElement).getPropertyValue(position);
}
//#endregion
//#region useScriptTag/index.ts
/**
* Async script tag loading.
*
* @see https://vueuse.org/useScriptTag
* @param src
* @param onLoaded
* @param options
*/ function $85ea9b47855776cf$export$eac342b7cdc4d8de(src, onLoaded = (0, $aPZNl.noop), options = {}) {
    const { immediate: immediate = true, manual: manual = false, type: type = "text/javascript", async: async = true, crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, noModule: noModule, defer: defer, document: document1 = $85ea9b47855776cf$export$37990bd438d16af3, attrs: attrs = {}, nonce: nonce } = options;
    const scriptTag = (0, $01W3b.shallowRef)(null);
    let _promise = null;
    /**
	* Load the script specified via `src`.
	*
	* @param waitForScriptLoad Whether if the Promise should resolve once the "load" event is emitted by the <script> attribute, or right after appending it to the DOM.
	* @returns Promise<HTMLScriptElement>
	*/ const loadScript = (waitForScriptLoad)=>new Promise((resolve, reject)=>{
            const resolveWithElement = (el)=>{
                scriptTag.value = el;
                resolve(el);
                return el;
            };
            if (!document1) {
                resolve(false);
                return;
            }
            let shouldAppend = false;
            let el = document1.querySelector(`script[src="${(0, $01W3b.toValue)(src)}"]`);
            if (!el) {
                el = document1.createElement("script");
                el.type = type;
                el.async = async;
                el.src = (0, $01W3b.toValue)(src);
                if (defer) el.defer = defer;
                if (crossOrigin) el.crossOrigin = crossOrigin;
                if (noModule) el.noModule = noModule;
                if (referrerPolicy) el.referrerPolicy = referrerPolicy;
                if (nonce) el.nonce = nonce;
                Object.entries(attrs).forEach(([name, value])=>el === null || el === void 0 ? void 0 : el.setAttribute(name, value));
                shouldAppend = true;
            } else if (el.hasAttribute("data-loaded")) resolveWithElement(el);
            const listenerOptions = {
                passive: true
            };
            $85ea9b47855776cf$export$7080b3e976bc91ab(el, "error", (event)=>reject(event), listenerOptions);
            $85ea9b47855776cf$export$7080b3e976bc91ab(el, "abort", (event)=>reject(event), listenerOptions);
            $85ea9b47855776cf$export$7080b3e976bc91ab(el, "load", ()=>{
                el.setAttribute("data-loaded", "true");
                onLoaded(el);
                resolveWithElement(el);
            }, listenerOptions);
            if (shouldAppend) el = document1.head.appendChild(el);
            if (!waitForScriptLoad) resolveWithElement(el);
        });
    /**
	* Exposed singleton wrapper for `loadScript`, avoiding calling it twice.
	*
	* @param waitForScriptLoad Whether if the Promise should resolve once the "load" event is emitted by the <script> attribute, or right after appending it to the DOM.
	* @returns Promise<HTMLScriptElement>
	*/ const load = (waitForScriptLoad = true)=>{
        if (!_promise) _promise = loadScript(waitForScriptLoad);
        return _promise;
    };
    /**
	* Unload the script specified by `src`.
	*/ const unload = ()=>{
        if (!document1) return;
        _promise = null;
        if (scriptTag.value) scriptTag.value = null;
        const el = document1.querySelector(`script[src="${(0, $01W3b.toValue)(src)}"]`);
        if (el) document1.head.removeChild(el);
    };
    if (immediate && !manual) (0, $aPZNl.tryOnMounted)(load);
    if (!manual) (0, $aPZNl.tryOnUnmounted)(unload);
    return {
        scriptTag: scriptTag,
        load: load,
        unload: unload
    };
}
//#endregion
//#region useScrollLock/index.ts
function $85ea9b47855776cf$var$checkOverflowScroll(ele) {
    const style = window.getComputedStyle(ele);
    if (style.overflowX === "scroll" || style.overflowY === "scroll" || style.overflowX === "auto" && ele.clientWidth < ele.scrollWidth || style.overflowY === "auto" && ele.clientHeight < ele.scrollHeight) return true;
    else {
        const parent = ele.parentNode;
        if (!parent || parent.tagName === "BODY") return false;
        return $85ea9b47855776cf$var$checkOverflowScroll(parent);
    }
}
function $85ea9b47855776cf$var$preventDefault(rawEvent) {
    const e = rawEvent || window.event;
    const _target = e.target;
    if ($85ea9b47855776cf$var$checkOverflowScroll(_target)) return false;
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
}
const $85ea9b47855776cf$var$elInitialOverflow = /* @__PURE__ */ new WeakMap();
/**
* Lock scrolling of the element.
*
* @see https://vueuse.org/useScrollLock
* @param element
*/ function $85ea9b47855776cf$export$e47ba1b900da5d3b(element, initialState = false) {
    const isLocked = (0, $01W3b.shallowRef)(initialState);
    let stopTouchMoveListener = null;
    let initialOverflow = "";
    (0, $01W3b.watch)((0, $aPZNl.toRef)(element), (el)=>{
        const target = $85ea9b47855776cf$var$resolveElement((0, $01W3b.toValue)(el));
        if (target) {
            const ele = target;
            if (!$85ea9b47855776cf$var$elInitialOverflow.get(ele)) $85ea9b47855776cf$var$elInitialOverflow.set(ele, ele.style.overflow);
            if (ele.style.overflow !== "hidden") initialOverflow = ele.style.overflow;
            if (ele.style.overflow === "hidden") return isLocked.value = true;
            if (isLocked.value) return ele.style.overflow = "hidden";
        }
    }, {
        immediate: true
    });
    const lock = ()=>{
        const el = $85ea9b47855776cf$var$resolveElement((0, $01W3b.toValue)(element));
        if (!el || isLocked.value) return;
        if (0, $aPZNl.isIOS) stopTouchMoveListener = $85ea9b47855776cf$export$7080b3e976bc91ab(el, "touchmove", (e)=>{
            $85ea9b47855776cf$var$preventDefault(e);
        }, {
            passive: false
        });
        el.style.overflow = "hidden";
        isLocked.value = true;
    };
    const unlock = ()=>{
        const el = $85ea9b47855776cf$var$resolveElement((0, $01W3b.toValue)(element));
        if (!el || !isLocked.value) return;
        if (0, $aPZNl.isIOS) stopTouchMoveListener === null || stopTouchMoveListener === void 0 || stopTouchMoveListener();
        el.style.overflow = initialOverflow;
        $85ea9b47855776cf$var$elInitialOverflow.delete(el);
        isLocked.value = false;
    };
    (0, $aPZNl.tryOnScopeDispose)(unlock);
    return (0, $01W3b.computed)({
        get () {
            return isLocked.value;
        },
        set (v) {
            if (v) lock();
            else unlock();
        }
    });
}
//#endregion
//#region useSessionStorage/index.ts
/**
* Reactive SessionStorage.
*
* @see https://vueuse.org/useSessionStorage
* @param key
* @param initialValue
* @param options
*/ function $85ea9b47855776cf$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    return $85ea9b47855776cf$export$95809329f49ea9f9(key, initialValue, window1 === null || window1 === void 0 ? void 0 : window1.sessionStorage, options);
}
//#endregion
//#region useShare/index.ts
/**
* Reactive Web Share API.
*
* @see https://vueuse.org/useShare
* @param shareOptions
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$96a35531d1008427(shareOptions = {}, options = {}) {
    const { navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc } = options;
    const _navigator = navigator1;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>_navigator && "canShare" in _navigator);
    const share = async (overrideOptions = {})=>{
        if (isSupported.value) {
            const data = {
                ...(0, $01W3b.toValue)(shareOptions),
                ...(0, $01W3b.toValue)(overrideOptions)
            };
            let granted = false;
            if (_navigator.canShare) granted = _navigator.canShare(data);
            if (granted) return _navigator.share(data);
        }
    };
    return {
        isSupported: isSupported,
        share: share
    };
}
//#endregion
//#region useSorted/index.ts
const $85ea9b47855776cf$var$defaultSortFn = (source, compareFn)=>source.sort(compareFn);
const $85ea9b47855776cf$var$defaultCompare = (a, b)=>a - b;
function $85ea9b47855776cf$export$a4fc6b60896f06a0(...args) {
    const [source] = args;
    let compareFn = $85ea9b47855776cf$var$defaultCompare;
    let options = {};
    if (args.length === 2) {
        if (typeof args[1] === "object") {
            var _options$compareFn;
            options = args[1];
            compareFn = (_options$compareFn = options.compareFn) !== null && _options$compareFn !== void 0 ? _options$compareFn : $85ea9b47855776cf$var$defaultCompare;
        } else {
            var _args$;
            compareFn = (_args$ = args[1]) !== null && _args$ !== void 0 ? _args$ : $85ea9b47855776cf$var$defaultCompare;
        }
    } else if (args.length > 2) {
        var _args$2, _args$3;
        compareFn = (_args$2 = args[1]) !== null && _args$2 !== void 0 ? _args$2 : $85ea9b47855776cf$var$defaultCompare;
        options = (_args$3 = args[2]) !== null && _args$3 !== void 0 ? _args$3 : {};
    }
    const { dirty: dirty = false, sortFn: sortFn = $85ea9b47855776cf$var$defaultSortFn } = options;
    if (!dirty) return (0, $01W3b.computed)(()=>sortFn([
            ...(0, $01W3b.toValue)(source)
        ], compareFn));
    (0, $TusQn.watchEffect)(()=>{
        const result = sortFn((0, $01W3b.toValue)(source), compareFn);
        if ((0, $01W3b.isRef)(source)) source.value = result;
        else source.splice(0, source.length, ...result);
    });
    return source;
}
//#endregion
//#region useSpeechRecognition/index.ts
/**
* Reactive SpeechRecognition.
*
* @see https://vueuse.org/useSpeechRecognition
* @see https://developer.mozilla.org/en-US/docs/Web/API/SpeechRecognition SpeechRecognition
* @param options
*/ function $85ea9b47855776cf$export$b2a8ce41ccd863a1(options = {}) {
    const { interimResults: interimResults = true, continuous: continuous = true, maxAlternatives: maxAlternatives = 1, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const lang = (0, $aPZNl.toRef)(options.lang || "en-US");
    const isListening = (0, $01W3b.shallowRef)(false);
    const isFinal = (0, $01W3b.shallowRef)(false);
    const result = (0, $01W3b.shallowRef)("");
    const error = (0, $01W3b.shallowRef)(void 0);
    let recognition;
    const start = ()=>{
        isListening.value = true;
    };
    const stop = ()=>{
        isListening.value = false;
    };
    const toggle = (value = !isListening.value)=>{
        if (value) start();
        else stop();
    };
    const SpeechRecognition = window1 && (window1.SpeechRecognition || window1.webkitSpeechRecognition);
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>SpeechRecognition);
    if (isSupported.value) {
        recognition = new SpeechRecognition();
        recognition.continuous = continuous;
        recognition.interimResults = interimResults;
        recognition.lang = (0, $01W3b.toValue)(lang);
        recognition.maxAlternatives = maxAlternatives;
        recognition.onstart = ()=>{
            isListening.value = true;
            isFinal.value = false;
        };
        (0, $01W3b.watch)(lang, (lang)=>{
            if (recognition && !isListening.value) recognition.lang = lang;
        });
        recognition.onresult = (event)=>{
            const currentResult = event.results[event.resultIndex];
            const { transcript: transcript } = currentResult[0];
            isFinal.value = currentResult.isFinal;
            result.value = transcript;
            error.value = void 0;
        };
        recognition.onerror = (event)=>{
            error.value = event;
        };
        recognition.onend = ()=>{
            isListening.value = false;
            recognition.lang = (0, $01W3b.toValue)(lang);
        };
        (0, $01W3b.watch)(isListening, (newValue, oldValue)=>{
            if (newValue === oldValue) return;
            try {
                if (newValue) recognition.start();
                else recognition.stop();
            } catch (err) {
                error.value = err;
            }
        });
    }
    (0, $aPZNl.tryOnScopeDispose)(()=>{
        stop();
    });
    return {
        isSupported: isSupported,
        isListening: isListening,
        isFinal: isFinal,
        recognition: recognition,
        result: result,
        error: error,
        toggle: toggle,
        start: start,
        stop: stop
    };
}
//#endregion
//#region useSpeechSynthesis/index.ts
/**
* Reactive SpeechSynthesis.
*
* @see https://vueuse.org/useSpeechSynthesis
* @see https://developer.mozilla.org/en-US/docs/Web/API/SpeechSynthesis SpeechSynthesis
*/ function $85ea9b47855776cf$export$44e311196d9d3623(text, options = {}) {
    const { pitch: pitch = 1, rate: rate = 1, volume: volume = 1, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, onBoundary: onBoundary } = options;
    const synth = window1 && window1.speechSynthesis;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>synth);
    const isPlaying = (0, $01W3b.shallowRef)(false);
    const status = (0, $01W3b.shallowRef)("init");
    const spokenText = (0, $aPZNl.toRef)(text || "");
    const lang = (0, $aPZNl.toRef)(options.lang || "en-US");
    const error = (0, $01W3b.shallowRef)(void 0);
    const toggle = (value = !isPlaying.value)=>{
        isPlaying.value = value;
    };
    const bindEventsForUtterance = (utterance)=>{
        utterance.lang = (0, $01W3b.toValue)(lang);
        utterance.voice = (0, $01W3b.toValue)(options.voice) || null;
        utterance.pitch = (0, $01W3b.toValue)(pitch);
        utterance.rate = (0, $01W3b.toValue)(rate);
        utterance.volume = (0, $01W3b.toValue)(volume);
        utterance.onstart = ()=>{
            isPlaying.value = true;
            status.value = "play";
        };
        utterance.onpause = ()=>{
            isPlaying.value = false;
            status.value = "pause";
        };
        utterance.onresume = ()=>{
            isPlaying.value = true;
            status.value = "play";
        };
        utterance.onend = ()=>{
            isPlaying.value = false;
            status.value = "end";
        };
        utterance.onerror = (event)=>{
            error.value = event;
        };
        utterance.onboundary = (event)=>{
            onBoundary === null || onBoundary === void 0 || onBoundary(event);
        };
    };
    const utterance = (0, $01W3b.computed)(()=>{
        isPlaying.value = false;
        status.value = "init";
        const newUtterance = new SpeechSynthesisUtterance(spokenText.value);
        bindEventsForUtterance(newUtterance);
        return newUtterance;
    });
    const speak = ()=>{
        synth.cancel();
        if (utterance) synth.speak(utterance.value);
    };
    const stop = ()=>{
        synth.cancel();
        isPlaying.value = false;
    };
    if (isSupported.value) {
        bindEventsForUtterance(utterance.value);
        (0, $01W3b.watch)(lang, (lang)=>{
            if (utterance.value && !isPlaying.value) utterance.value.lang = lang;
        });
        if (options.voice) (0, $01W3b.watch)(options.voice, ()=>{
            synth.cancel();
        });
        (0, $01W3b.watch)(isPlaying, ()=>{
            if (isPlaying.value) synth.resume();
            else synth.pause();
        });
    }
    (0, $aPZNl.tryOnScopeDispose)(()=>{
        isPlaying.value = false;
    });
    return {
        isSupported: isSupported,
        isPlaying: isPlaying,
        status: status,
        utterance: utterance,
        error: error,
        stop: stop,
        toggle: toggle,
        speak: speak
    };
}
//#endregion
//#region useStepper/index.ts
/* @__NO_SIDE_EFFECTS__ */ function $85ea9b47855776cf$export$9378619b14945e16(steps, initialStep) {
    const stepsRef = (0, $01W3b.ref)(steps);
    const stepNames = (0, $01W3b.computed)(()=>Array.isArray(stepsRef.value) ? stepsRef.value : Object.keys(stepsRef.value));
    const index = (0, $01W3b.ref)(stepNames.value.indexOf(initialStep !== null && initialStep !== void 0 ? initialStep : stepNames.value[0]));
    const current = (0, $01W3b.computed)(()=>at(index.value));
    const isFirst = (0, $01W3b.computed)(()=>index.value === 0);
    const isLast = (0, $01W3b.computed)(()=>index.value === stepNames.value.length - 1);
    const next = (0, $01W3b.computed)(()=>stepNames.value[index.value + 1]);
    const previous = (0, $01W3b.computed)(()=>stepNames.value[index.value - 1]);
    function at(index) {
        if (Array.isArray(stepsRef.value)) return stepsRef.value[index];
        return stepsRef.value[stepNames.value[index]];
    }
    function get(step) {
        if (!stepNames.value.includes(step)) return;
        return at(stepNames.value.indexOf(step));
    }
    function goTo(step) {
        if (stepNames.value.includes(step)) index.value = stepNames.value.indexOf(step);
    }
    function goToNext() {
        if (isLast.value) return;
        index.value++;
    }
    function goToPrevious() {
        if (isFirst.value) return;
        index.value--;
    }
    function goBackTo(step) {
        if (isAfter(step)) goTo(step);
    }
    function isNext(step) {
        return stepNames.value.indexOf(step) === index.value + 1;
    }
    function isPrevious(step) {
        return stepNames.value.indexOf(step) === index.value - 1;
    }
    function isCurrent(step) {
        return stepNames.value.indexOf(step) === index.value;
    }
    function isBefore(step) {
        return index.value < stepNames.value.indexOf(step);
    }
    function isAfter(step) {
        return index.value > stepNames.value.indexOf(step);
    }
    return {
        steps: stepsRef,
        stepNames: stepNames,
        index: index,
        current: current,
        next: next,
        previous: previous,
        isFirst: isFirst,
        isLast: isLast,
        at: at,
        get: get,
        goTo: goTo,
        goToNext: goToNext,
        goToPrevious: goToPrevious,
        goBackTo: goBackTo,
        isNext: isNext,
        isPrevious: isPrevious,
        isCurrent: isCurrent,
        isBefore: isBefore,
        isAfter: isAfter
    };
}
//#endregion
//#region useStorageAsync/index.ts
/**
* Reactive Storage with async support.
*
* @see https://vueuse.org/useStorageAsync
* @param key
* @param initialValue
* @param storage
* @param options
*/ function $85ea9b47855776cf$export$dd72d4318fe38e17(key, initialValue, storage, options = {}) {
    var _options$serializer;
    const { flush: flush = "pre", deep: deep = true, listenToStorageChanges: listenToStorageChanges = true, writeDefaults: writeDefaults = true, mergeDefaults: mergeDefaults = false, shallow: shallow, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, eventFilter: eventFilter, onError: onError = (e)=>{
        console.error(e);
    }, onReady: onReady } = options;
    const rawInit = (0, $01W3b.toValue)(initialValue);
    const type = $85ea9b47855776cf$var$guessSerializerType(rawInit);
    const data = (shallow ? (0, $01W3b.shallowRef) : (0, $01W3b.ref))((0, $01W3b.toValue)(initialValue));
    const serializer = (_options$serializer = options.serializer) !== null && _options$serializer !== void 0 ? _options$serializer : $85ea9b47855776cf$export$8111877b006f9b0b[type];
    if (!storage) try {
        storage = $85ea9b47855776cf$export$b0cf1ae5a98eb83b("getDefaultStorageAsync", ()=>$85ea9b47855776cf$export$16f8ba610718ae4a === null || $85ea9b47855776cf$export$16f8ba610718ae4a === void 0 ? void 0 : $85ea9b47855776cf$export$16f8ba610718ae4a.localStorage)();
    } catch (e) {
        onError(e);
    }
    async function read(event) {
        if (!storage || event && event.key !== key) return;
        try {
            const rawValue = event ? event.newValue : await storage.getItem(key);
            if (rawValue == null) {
                data.value = rawInit;
                if (writeDefaults && rawInit !== null) await storage.setItem(key, await serializer.write(rawInit));
            } else if (mergeDefaults) {
                const value = await serializer.read(rawValue);
                if (typeof mergeDefaults === "function") data.value = mergeDefaults(value, rawInit);
                else if (type === "object" && !Array.isArray(value)) data.value = {
                    ...rawInit,
                    ...value
                };
                else data.value = value;
            } else data.value = await serializer.read(rawValue);
        } catch (e) {
            onError(e);
        }
    }
    const promise = new Promise((resolve)=>{
        read().then(()=>{
            onReady === null || onReady === void 0 || onReady(data.value);
            resolve(data);
        });
    });
    if (window1 && listenToStorageChanges) $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "storage", (e)=>Promise.resolve().then(()=>read(e)), {
        passive: true
    });
    if (storage) (0, $aPZNl.watchWithFilter)(data, async ()=>{
        try {
            if (data.value == null) await storage.removeItem(key);
            else await storage.setItem(key, await serializer.write(data.value));
        } catch (e) {
            onError(e);
        }
    }, {
        flush: flush,
        deep: deep,
        eventFilter: eventFilter
    });
    Object.assign(data, {
        then: promise.then.bind(promise),
        catch: promise.catch.bind(promise)
    });
    return data;
}
//#endregion
//#region useStyleTag/index.ts
let $85ea9b47855776cf$var$_id = 0;
/**
* Inject <style> element in head.
*
* Overload: Omitted id
*
* @see https://vueuse.org/useStyleTag
* @param css
* @param options
*/ function $85ea9b47855776cf$export$c100116e6aa85030(css, options = {}) {
    const isLoaded = (0, $01W3b.shallowRef)(false);
    const { document: document1 = $85ea9b47855776cf$export$37990bd438d16af3, immediate: immediate = true, manual: manual = false, id: id = `vueuse_styletag_${++$85ea9b47855776cf$var$_id}` } = options;
    const cssRef = (0, $01W3b.shallowRef)(css);
    let stop = ()=>{};
    const load = ()=>{
        if (!document1) return;
        const el = document1.getElementById(id) || document1.createElement("style");
        if (!el.isConnected) {
            el.id = id;
            if (options.nonce) el.nonce = options.nonce;
            if (options.media) el.media = options.media;
            document1.head.appendChild(el);
        }
        if (isLoaded.value) return;
        stop = (0, $01W3b.watch)(cssRef, (value)=>{
            el.textContent = value;
        }, {
            immediate: true
        });
        isLoaded.value = true;
    };
    const unload = ()=>{
        if (!document1 || !isLoaded.value) return;
        stop();
        document1.head.removeChild(document1.getElementById(id));
        isLoaded.value = false;
    };
    if (immediate && !manual) (0, $aPZNl.tryOnMounted)(load);
    if (!manual) (0, $aPZNl.tryOnScopeDispose)(unload);
    return {
        id: id,
        css: cssRef,
        unload: unload,
        load: load,
        isLoaded: (0, $01W3b.shallowReadonly)(isLoaded)
    };
}
//#endregion
//#region useSwipe/index.ts
/**
* Reactive swipe detection.
*
* @see https://vueuse.org/useSwipe
* @param target
* @param options
*/ function $85ea9b47855776cf$export$b57f07e22c950716(target, options = {}) {
    const { threshold: threshold = 50, onSwipe: onSwipe, onSwipeEnd: onSwipeEnd, onSwipeStart: onSwipeStart, passive: passive = true } = options;
    const coordsStart = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const coordsEnd = (0, $01W3b.reactive)({
        x: 0,
        y: 0
    });
    const diffX = (0, $01W3b.computed)(()=>coordsStart.x - coordsEnd.x);
    const diffY = (0, $01W3b.computed)(()=>coordsStart.y - coordsEnd.y);
    const { max: max, abs: abs } = Math;
    const isThresholdExceeded = (0, $01W3b.computed)(()=>max(abs(diffX.value), abs(diffY.value)) >= threshold);
    const isSwiping = (0, $01W3b.shallowRef)(false);
    const direction = (0, $01W3b.computed)(()=>{
        if (!isThresholdExceeded.value) return "none";
        if (abs(diffX.value) > abs(diffY.value)) return diffX.value > 0 ? "left" : "right";
        else return diffY.value > 0 ? "up" : "down";
    });
    const getTouchEventCoords = (e)=>[
            e.touches[0].clientX,
            e.touches[0].clientY
        ];
    const updateCoordsStart = (x, y)=>{
        coordsStart.x = x;
        coordsStart.y = y;
    };
    const updateCoordsEnd = (x, y)=>{
        coordsEnd.x = x;
        coordsEnd.y = y;
    };
    const listenerOptions = {
        passive: passive,
        capture: !passive
    };
    const onTouchEnd = (e)=>{
        if (isSwiping.value) onSwipeEnd === null || onSwipeEnd === void 0 || onSwipeEnd(e, direction.value);
        isSwiping.value = false;
    };
    const stops = [
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "touchstart", (e)=>{
            if (e.touches.length !== 1) return;
            const [x, y] = getTouchEventCoords(e);
            updateCoordsStart(x, y);
            updateCoordsEnd(x, y);
            onSwipeStart === null || onSwipeStart === void 0 || onSwipeStart(e);
        }, listenerOptions),
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, "touchmove", (e)=>{
            if (e.touches.length !== 1) return;
            const [x, y] = getTouchEventCoords(e);
            updateCoordsEnd(x, y);
            if (listenerOptions.capture && !listenerOptions.passive && Math.abs(diffX.value) > Math.abs(diffY.value)) e.preventDefault();
            if (!isSwiping.value && isThresholdExceeded.value) isSwiping.value = true;
            if (isSwiping.value) onSwipe === null || onSwipe === void 0 || onSwipe(e);
        }, listenerOptions),
        $85ea9b47855776cf$export$7080b3e976bc91ab(target, [
            "touchend",
            "touchcancel"
        ], onTouchEnd, listenerOptions)
    ];
    const stop = ()=>stops.forEach((s)=>s());
    return {
        isSwiping: isSwiping,
        direction: direction,
        coordsStart: coordsStart,
        coordsEnd: coordsEnd,
        lengthX: diffX,
        lengthY: diffY,
        stop: stop
    };
}
//#endregion
//#region useTemplateRefsList/index.ts
/* @__NO_SIDE_EFFECTS__ */ function $85ea9b47855776cf$export$253c1ef7895b3fea() {
    const refs = (0, $01W3b.ref)([]);
    refs.value.set = (el)=>{
        if (el) refs.value.push(el);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        refs.value.length = 0;
    });
    return refs;
}
//#endregion
//#region useTextDirection/index.ts
/**
* Reactive dir of the element's text.
*
* @see https://vueuse.org/useTextDirection
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$cf24a79f32f45545(options = {}) {
    const { document: document1 = $85ea9b47855776cf$export$37990bd438d16af3, selector: selector = "html", observe: observe = false, initialValue: initialValue = "ltr" } = options;
    function getValue() {
        var _ref, _document$querySelect;
        return (_ref = document1 === null || document1 === void 0 || (_document$querySelect = document1.querySelector(selector)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute("dir")) !== null && _ref !== void 0 ? _ref : initialValue;
    }
    const dir = (0, $01W3b.shallowRef)(getValue());
    (0, $aPZNl.tryOnMounted)(()=>dir.value = getValue());
    if (observe && document1) $85ea9b47855776cf$export$8ecdcf3bb089e9cd(document1.querySelector(selector), ()=>dir.value = getValue(), {
        attributes: true
    });
    return (0, $01W3b.computed)({
        get () {
            return dir.value;
        },
        set (v) {
            var _document$querySelect2, _document$querySelect3;
            dir.value = v;
            if (!document1) return;
            if (dir.value) (_document$querySelect2 = document1.querySelector(selector)) === null || _document$querySelect2 === void 0 || _document$querySelect2.setAttribute("dir", dir.value);
            else (_document$querySelect3 = document1.querySelector(selector)) === null || _document$querySelect3 === void 0 || _document$querySelect3.removeAttribute("dir");
        }
    });
}
//#endregion
//#region useTextSelection/index.ts
function $85ea9b47855776cf$var$getRangesFromSelection(selection) {
    var _selection$rangeCount;
    const rangeCount = (_selection$rangeCount = selection.rangeCount) !== null && _selection$rangeCount !== void 0 ? _selection$rangeCount : 0;
    return Array.from({
        length: rangeCount
    }, (_, i)=>selection.getRangeAt(i));
}
/**
* Reactively track user text selection based on [`Window.getSelection`](https://developer.mozilla.org/en-US/docs/Web/API/Window/getSelection).
*
* @see https://vueuse.org/useTextSelection
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$9c9cf404b65a1c0a(options = {}) {
    var _window$getSelection;
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const selection = (0, $01W3b.shallowRef)((_window$getSelection = window1 === null || window1 === void 0 ? void 0 : window1.getSelection()) !== null && _window$getSelection !== void 0 ? _window$getSelection : null);
    const text = (0, $01W3b.computed)(()=>{
        var _selection$value$toSt, _selection$value;
        return (_selection$value$toSt = (_selection$value = selection.value) === null || _selection$value === void 0 ? void 0 : _selection$value.toString()) !== null && _selection$value$toSt !== void 0 ? _selection$value$toSt : "";
    });
    const ranges = (0, $01W3b.computed)(()=>selection.value ? $85ea9b47855776cf$var$getRangesFromSelection(selection.value) : []);
    const rects = (0, $01W3b.computed)(()=>ranges.value.map((range)=>range.getBoundingClientRect()));
    function onSelectionChange() {
        selection.value = null;
        if (window1) selection.value = window1.getSelection();
    }
    if (window1) $85ea9b47855776cf$export$7080b3e976bc91ab(window1.document, "selectionchange", onSelectionChange, {
        passive: true
    });
    return {
        text: text,
        rects: rects,
        ranges: ranges,
        selection: selection
    };
}
//#endregion
//#region useTextareaAutosize/index.ts
/**
* Call window.requestAnimationFrame(), if not available, just call the function
*
* @param window
* @param fn
*/ function $85ea9b47855776cf$var$tryRequestAnimationFrame(window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, fn) {
    if (window1 && typeof window1.requestAnimationFrame === "function") window1.requestAnimationFrame(fn);
    else fn();
}
function $85ea9b47855776cf$export$2e9ef3b733cccd07(options = {}) {
    var _options$input, _options$styleProp;
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const textarea = (0, $aPZNl.toRef)(options === null || options === void 0 ? void 0 : options.element);
    const input = (0, $aPZNl.toRef)((_options$input = options === null || options === void 0 ? void 0 : options.input) !== null && _options$input !== void 0 ? _options$input : "");
    const styleProp = (_options$styleProp = options === null || options === void 0 ? void 0 : options.styleProp) !== null && _options$styleProp !== void 0 ? _options$styleProp : "height";
    const textareaScrollHeight = (0, $01W3b.shallowRef)(1);
    const textareaOldWidth = (0, $01W3b.shallowRef)(0);
    function triggerResize() {
        var _textarea$value;
        if (!textarea.value) return;
        let height = "";
        const maxHeight = options === null || options === void 0 ? void 0 : options.maxHeight;
        textarea.value.style[styleProp] = "1px";
        textareaScrollHeight.value = (_textarea$value = textarea.value) === null || _textarea$value === void 0 ? void 0 : _textarea$value.scrollHeight;
        const _styleTarget = (0, $01W3b.toValue)(options === null || options === void 0 ? void 0 : options.styleTarget);
        const styleHeight = maxHeight != null ? `${Math.min(textareaScrollHeight.value, maxHeight)}px` : `${textareaScrollHeight.value}px`;
        if (_styleTarget) _styleTarget.style[styleProp] = styleHeight;
        else height = styleHeight;
        textarea.value.style[styleProp] = height;
    }
    (0, $01W3b.watch)([
        input,
        textarea
    ], ()=>(0, $TusQn.nextTick)(triggerResize), {
        immediate: true
    });
    (0, $01W3b.watch)(textareaScrollHeight, ()=>{
        var _options$onResize;
        return options === null || options === void 0 || (_options$onResize = options.onResize) === null || _options$onResize === void 0 ? void 0 : _options$onResize.call(options);
    });
    $85ea9b47855776cf$export$683480f191c0e3ea(textarea, ([{ contentRect: contentRect }])=>{
        if (textareaOldWidth.value === contentRect.width) return;
        $85ea9b47855776cf$var$tryRequestAnimationFrame(window1, ()=>{
            textareaOldWidth.value = contentRect.width;
            triggerResize();
        });
    });
    if (options === null || options === void 0 ? void 0 : options.watch) (0, $01W3b.watch)(options.watch, triggerResize, {
        immediate: true,
        deep: true
    });
    return {
        textarea: textarea,
        input: input,
        triggerResize: triggerResize
    };
}
//#endregion
//#region useThrottledRefHistory/index.ts
/**
* Shorthand for [useRefHistory](https://vueuse.org/useRefHistory) with throttled filter.
*
* @see https://vueuse.org/useThrottledRefHistory
* @param source
* @param options
*/ function $85ea9b47855776cf$export$55673c2843562e1(source, options = {}) {
    const { throttle: throttle = 200, trailing: trailing = true } = options;
    const filter = (0, $aPZNl.throttleFilter)(throttle, trailing);
    return {
        ...$85ea9b47855776cf$export$de889b39e422efc4(source, {
            ...options,
            eventFilter: filter
        })
    };
}
//#endregion
//#region useTimeAgo/index.ts
const $85ea9b47855776cf$var$DEFAULT_UNITS = [
    {
        max: 6e4,
        value: 1e3,
        name: "second"
    },
    {
        max: 276e4,
        value: 6e4,
        name: "minute"
    },
    {
        max: 72e6,
        value: 36e5,
        name: "hour"
    },
    {
        max: 5184e5,
        value: 864e5,
        name: "day"
    },
    {
        max: 24192e5,
        value: 6048e5,
        name: "week"
    },
    {
        max: 28512e6,
        value: 2592e6,
        name: "month"
    },
    {
        max: Number.POSITIVE_INFINITY,
        value: 31536e6,
        name: "year"
    }
];
const $85ea9b47855776cf$var$DEFAULT_MESSAGES = {
    justNow: "just now",
    past: (n)=>/\d/.test(n) ? `${n} ago` : n,
    future: (n)=>/\d/.test(n) ? `in ${n}` : n,
    month: (n, past)=>n === 1 ? past ? "last month" : "next month" : `${n} month${n > 1 ? "s" : ""}`,
    year: (n, past)=>n === 1 ? past ? "last year" : "next year" : `${n} year${n > 1 ? "s" : ""}`,
    day: (n, past)=>n === 1 ? past ? "yesterday" : "tomorrow" : `${n} day${n > 1 ? "s" : ""}`,
    week: (n, past)=>n === 1 ? past ? "last week" : "next week" : `${n} week${n > 1 ? "s" : ""}`,
    hour: (n)=>`${n} hour${n > 1 ? "s" : ""}`,
    minute: (n)=>`${n} minute${n > 1 ? "s" : ""}`,
    second: (n)=>`${n} second${n > 1 ? "s" : ""}`,
    invalid: ""
};
function $85ea9b47855776cf$var$DEFAULT_FORMATTER(date) {
    return date.toISOString().slice(0, 10);
}
function $85ea9b47855776cf$var$getDefaultScheduler$4(options) {
    if ("updateInterval" in options) {
        const { updateInterval: updateInterval = 3e4 } = options;
        return (cb)=>(0, $aPZNl.useIntervalFn)(cb, updateInterval);
    }
    return (cb)=>(0, $aPZNl.useIntervalFn)(cb, 3e4);
}
/**
* Reactive time ago formatter.
*
* @see https://vueuse.org/useTimeAgo
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$1deeb1050525eb40(time, options = {}) {
    const { controls: exposeControls = false, scheduler: scheduler = $85ea9b47855776cf$var$getDefaultScheduler$4(options) } = options;
    const { now: now, ...controls } = $85ea9b47855776cf$export$3a404aece3dff2fa({
        scheduler: scheduler,
        controls: true
    });
    const timeAgo = (0, $01W3b.computed)(()=>$85ea9b47855776cf$export$78ae3e68d8c394bc(new Date((0, $01W3b.toValue)(time)), options, (0, $01W3b.toValue)(now)));
    if (exposeControls) return {
        timeAgo: timeAgo,
        ...controls
    };
    else return timeAgo;
}
function $85ea9b47855776cf$export$78ae3e68d8c394bc(from, options = {}, now = Date.now()) {
    const { max: max, messages: messages = $85ea9b47855776cf$var$DEFAULT_MESSAGES, fullDateFormatter: fullDateFormatter = $85ea9b47855776cf$var$DEFAULT_FORMATTER, units: units = $85ea9b47855776cf$var$DEFAULT_UNITS, showSecond: showSecond = false, rounding: rounding = "round" } = options;
    const roundFn = typeof rounding === "number" ? (n)=>+n.toFixed(rounding) : Math[rounding];
    const diff = +now - +from;
    const absDiff = Math.abs(diff);
    function getValue(diff, unit) {
        return roundFn(Math.abs(diff) / unit.value);
    }
    function format(diff, unit) {
        const val = getValue(diff, unit);
        const past = diff > 0;
        const str = applyFormat(unit.name, val, past);
        return applyFormat(past ? "past" : "future", str, past);
    }
    function applyFormat(name, val, isPast) {
        const formatter = messages[name];
        if (typeof formatter === "function") return formatter(val, isPast);
        return formatter.replace("{0}", val.toString());
    }
    if (absDiff < 6e4 && !showSecond) return messages.justNow;
    if (typeof max === "number" && absDiff > max) return fullDateFormatter(new Date(from));
    if (typeof max === "string") {
        var _units$find;
        const unitMax = (_units$find = units.find((i)=>i.name === max)) === null || _units$find === void 0 ? void 0 : _units$find.max;
        if (unitMax && absDiff > unitMax) return fullDateFormatter(new Date(from));
    }
    for (const [idx, unit] of units.entries()){
        if (getValue(diff, unit) <= 0 && units[idx - 1]) return format(diff, units[idx - 1]);
        if (absDiff < unit.max) return format(diff, unit);
    }
    return messages.invalid;
}
//#endregion
//#region useTimeAgoIntl/index.ts
const $85ea9b47855776cf$var$UNITS = [
    {
        name: "year",
        ms: 31536e6
    },
    {
        name: "month",
        ms: 2592e6
    },
    {
        name: "week",
        ms: 6048e5
    },
    {
        name: "day",
        ms: 864e5
    },
    {
        name: "hour",
        ms: 36e5
    },
    {
        name: "minute",
        ms: 6e4
    },
    {
        name: "second",
        ms: 1e3
    }
];
function $85ea9b47855776cf$var$getDefaultScheduler$3(options) {
    if ("updateInterval" in options) {
        const { updateInterval: updateInterval = 3e4 } = options;
        return (cb)=>(0, $aPZNl.useIntervalFn)(cb, updateInterval);
    }
    return (cb)=>(0, $aPZNl.useIntervalFn)(cb, 3e4);
}
function $85ea9b47855776cf$export$333176621e1d393f(time, options = {}) {
    const { controls: exposeControls = false, scheduler: scheduler = $85ea9b47855776cf$var$getDefaultScheduler$3(options) } = options;
    const { now: now, ...controls } = $85ea9b47855776cf$export$3a404aece3dff2fa({
        scheduler: scheduler,
        controls: true
    });
    const result = (0, $01W3b.computed)(()=>$85ea9b47855776cf$var$getTimeAgoIntlResult(new Date((0, $01W3b.toValue)(time)), options, (0, $01W3b.toValue)(now)));
    const parts = (0, $01W3b.computed)(()=>result.value.parts);
    const timeAgoIntl = (0, $01W3b.computed)(()=>$85ea9b47855776cf$export$69785b872cce0fc0(parts.value, {
            ...options,
            locale: result.value.resolvedLocale
        }));
    return exposeControls ? {
        timeAgoIntl: timeAgoIntl,
        parts: parts,
        ...controls
    } : timeAgoIntl;
}
/**
* Non-reactive version of useTimeAgoIntl
*/ function $85ea9b47855776cf$export$b320aa1f4c8f6bb1(from, options = {}, now = Date.now()) {
    const { parts: parts, resolvedLocale: resolvedLocale } = $85ea9b47855776cf$var$getTimeAgoIntlResult(from, options, now);
    return $85ea9b47855776cf$export$69785b872cce0fc0(parts, {
        ...options,
        locale: resolvedLocale
    });
}
/**
* Get parts from `Intl.RelativeTimeFormat.formatToParts`.
*/ function $85ea9b47855776cf$var$getTimeAgoIntlResult(from, options = {}, now = Date.now()) {
    var _options$units;
    const { locale: locale, relativeTimeFormatOptions: relativeTimeFormatOptions = {
        numeric: "auto"
    } } = options;
    const rtf = new Intl.RelativeTimeFormat(locale, relativeTimeFormatOptions);
    const { locale: resolvedLocale } = rtf.resolvedOptions();
    const diff = +from - +now;
    const absDiff = Math.abs(diff);
    const units = (_options$units = options.units) !== null && _options$units !== void 0 ? _options$units : $85ea9b47855776cf$var$UNITS;
    for (const { name: name, ms: ms } of units)if (absDiff >= ms) return {
        resolvedLocale: resolvedLocale,
        parts: rtf.formatToParts(Math.round(diff / ms), name)
    };
    return {
        resolvedLocale: resolvedLocale,
        parts: rtf.formatToParts(0, units[units.length - 1].name)
    };
}
/**
* Format parts into a string
*/ function $85ea9b47855776cf$export$69785b872cce0fc0(parts, options = {}) {
    const { insertSpace: insertSpace = true, joinParts: joinParts, locale: locale } = options;
    if (typeof joinParts === "function") return joinParts(parts, locale);
    if (!insertSpace) return parts.map((part)=>part.value).join("");
    return parts.map((part)=>part.value.trim()).join(" ");
}
//#endregion
//#region useTimeoutPoll/index.ts
function $85ea9b47855776cf$export$ce370d3d38ed4da0(fn, interval, options = {}) {
    const { immediate: immediate = true, immediateCallback: immediateCallback = false } = options;
    const { start: start } = (0, $aPZNl.useTimeoutFn)(loop, interval, {
        immediate: immediate
    });
    const isActive = (0, $01W3b.shallowRef)(false);
    async function loop() {
        if (!isActive.value) return;
        await fn();
        start();
    }
    function resume() {
        if (!isActive.value) {
            isActive.value = true;
            if (immediateCallback) fn();
            start();
        }
    }
    function pause() {
        isActive.value = false;
    }
    if (immediate && (0, $aPZNl.isClient)) resume();
    (0, $aPZNl.tryOnScopeDispose)(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
//#endregion
//#region useTimestamp/index.ts
function $85ea9b47855776cf$var$getDefaultScheduler$2(options) {
    if ("interval" in options || "immediate" in options) {
        const { interval: interval = "requestAnimationFrame", immediate: immediate = true } = options;
        return interval === "requestAnimationFrame" ? (cb)=>$85ea9b47855776cf$export$13251e0fc79284e(cb, {
                immediate: immediate
            }) : (cb)=>(0, $aPZNl.useIntervalFn)(cb, interval, {
                immediate: immediate
            });
    }
    return $85ea9b47855776cf$export$13251e0fc79284e;
}
function $85ea9b47855776cf$export$c4f6efe9f19a3a66(options = {}) {
    const { controls: exposeControls = false, offset: offset = 0, scheduler: scheduler = $85ea9b47855776cf$var$getDefaultScheduler$2(options), callback: callback } = options;
    const ts = (0, $01W3b.shallowRef)((0, $aPZNl.timestamp)() + offset);
    const update = ()=>ts.value = (0, $aPZNl.timestamp)() + offset;
    const controls = scheduler(callback ? ()=>{
        update();
        callback(ts.value);
    } : update);
    if (exposeControls) return {
        timestamp: ts,
        ...controls
    };
    else return ts;
}
//#endregion
//#region useTitle/index.ts
function $85ea9b47855776cf$export$bc98e171e8c82a3d(newTitle = null, options = {}) {
    var _document$title, _ref;
    const { document: document1 = $85ea9b47855776cf$export$37990bd438d16af3, restoreOnUnmount: restoreOnUnmount = (t)=>t } = options;
    const originalTitle = (_document$title = document1 === null || document1 === void 0 ? void 0 : document1.title) !== null && _document$title !== void 0 ? _document$title : "";
    const title = (0, $aPZNl.toRef)((_ref = newTitle !== null && newTitle !== void 0 ? newTitle : document1 === null || document1 === void 0 ? void 0 : document1.title) !== null && _ref !== void 0 ? _ref : null);
    const isReadonly = !!(newTitle && typeof newTitle === "function");
    function format(t) {
        if (!("titleTemplate" in options)) return t;
        const template = options.titleTemplate || "%s";
        return typeof template === "function" ? template(t) : (0, $01W3b.toValue)(template).replace(/%s/g, t);
    }
    (0, $01W3b.watch)(title, (newValue, oldValue)=>{
        if (newValue !== oldValue && document1) document1.title = format(newValue !== null && newValue !== void 0 ? newValue : "");
    }, {
        immediate: true
    });
    if (options.observe && !options.titleTemplate && document1 && !isReadonly) {
        var _document$head;
        $85ea9b47855776cf$export$8ecdcf3bb089e9cd((_document$head = document1.head) === null || _document$head === void 0 ? void 0 : _document$head.querySelector("title"), ()=>{
            if (document1 && document1.title !== title.value) title.value = format(document1.title);
        }, {
            childList: true
        });
    }
    (0, $aPZNl.tryOnScopeDispose)(()=>{
        if (restoreOnUnmount) {
            const restoredTitle = restoreOnUnmount(originalTitle, title.value || "");
            if (restoredTitle != null && document1) document1.title = restoredTitle;
        }
    });
    return title;
}
/**
* Common transitions
*
* @see https://easings.net
*/ const $85ea9b47855776cf$export$a1745a8bb687f918 = /* @__PURE__ */ Object.assign({}, {
    linear: (0, $aPZNl.identity)
}, {
    easeInSine: [
        .12,
        0,
        .39,
        0
    ],
    easeOutSine: [
        .61,
        1,
        .88,
        1
    ],
    easeInOutSine: [
        .37,
        0,
        .63,
        1
    ],
    easeInQuad: [
        .11,
        0,
        .5,
        0
    ],
    easeOutQuad: [
        .5,
        1,
        .89,
        1
    ],
    easeInOutQuad: [
        .45,
        0,
        .55,
        1
    ],
    easeInCubic: [
        .32,
        0,
        .67,
        0
    ],
    easeOutCubic: [
        .33,
        1,
        .68,
        1
    ],
    easeInOutCubic: [
        .65,
        0,
        .35,
        1
    ],
    easeInQuart: [
        .5,
        0,
        .75,
        0
    ],
    easeOutQuart: [
        .25,
        1,
        .5,
        1
    ],
    easeInOutQuart: [
        .76,
        0,
        .24,
        1
    ],
    easeInQuint: [
        .64,
        0,
        .78,
        0
    ],
    easeOutQuint: [
        .22,
        1,
        .36,
        1
    ],
    easeInOutQuint: [
        .83,
        0,
        .17,
        1
    ],
    easeInExpo: [
        .7,
        0,
        .84,
        0
    ],
    easeOutExpo: [
        .16,
        1,
        .3,
        1
    ],
    easeInOutExpo: [
        .87,
        0,
        .13,
        1
    ],
    easeInCirc: [
        .55,
        0,
        1,
        .45
    ],
    easeOutCirc: [
        0,
        .55,
        .45,
        1
    ],
    easeInOutCirc: [
        .85,
        0,
        .15,
        1
    ],
    easeInBack: [
        .36,
        0,
        .66,
        -0.56
    ],
    easeOutBack: [
        .34,
        1.56,
        .64,
        1
    ],
    easeInOutBack: [
        .68,
        -0.6,
        .32,
        1.6
    ]
});
/**
* Create an easing function from cubic bezier points.
*/ function $85ea9b47855776cf$var$createEasingFunction([p0, p1, p2, p3]) {
    const a = (a1, a2)=>1 - 3 * a2 + 3 * a1;
    const b = (a1, a2)=>3 * a2 - 6 * a1;
    const c = (a1)=>3 * a1;
    const calcBezier = (t, a1, a2)=>((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
    const getSlope = (t, a1, a2)=>3 * a(a1, a2) * t * t + 2 * b(a1, a2) * t + c(a1);
    const getTforX = (x)=>{
        let aGuessT = x;
        for(let i = 0; i < 4; ++i){
            const currentSlope = getSlope(aGuessT, p0, p2);
            if (currentSlope === 0) return aGuessT;
            const currentX = calcBezier(aGuessT, p0, p2) - x;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    return (x)=>p0 === p1 && p2 === p3 ? x : calcBezier(getTforX(x), p1, p3);
}
function $85ea9b47855776cf$var$lerp(a, b, alpha) {
    return a + alpha * (b - a);
}
function $85ea9b47855776cf$var$defaultInterpolation(a, b, t) {
    const aVal = (0, $01W3b.toValue)(a);
    const bVal = (0, $01W3b.toValue)(b);
    if (typeof aVal === "number" && typeof bVal === "number") return $85ea9b47855776cf$var$lerp(aVal, bVal, t);
    if (Array.isArray(aVal) && Array.isArray(bVal)) return aVal.map((v, i)=>$85ea9b47855776cf$var$lerp(v, (0, $01W3b.toValue)(bVal[i]), t));
    throw new TypeError("Unknown transition type, specify an interpolation function.");
}
function $85ea9b47855776cf$var$normalizeEasing(easing) {
    var _toValue;
    return typeof easing === "function" ? easing : (_toValue = (0, $01W3b.toValue)(easing)) !== null && _toValue !== void 0 ? _toValue : (0, $aPZNl.identity);
}
/**
* Transition from one value to another.
*
* @param source
* @param from
* @param to
* @param options
*/ function $85ea9b47855776cf$export$66bb15e2994e6a26(source, from, to, options = {}) {
    var _toValue2;
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    const fromVal = (0, $01W3b.toValue)(from);
    const toVal = (0, $01W3b.toValue)(to);
    const duration = (_toValue2 = (0, $01W3b.toValue)(options.duration)) !== null && _toValue2 !== void 0 ? _toValue2 : 1e3;
    const startedAt = Date.now();
    const endAt = Date.now() + duration;
    const interpolation = typeof options.interpolation === "function" ? options.interpolation : $85ea9b47855776cf$var$defaultInterpolation;
    const trans = typeof options.easing !== "undefined" ? $85ea9b47855776cf$var$normalizeEasing(options.easing) : $85ea9b47855776cf$var$normalizeEasing(options.transition);
    const ease = typeof trans === "function" ? trans : $85ea9b47855776cf$var$createEasingFunction(trans);
    return new Promise((resolve)=>{
        source.value = fromVal;
        const tick = ()=>{
            var _options$abort;
            if ((_options$abort = options.abort) === null || _options$abort === void 0 ? void 0 : _options$abort.call(options)) {
                resolve();
                return;
            }
            const now = Date.now();
            source.value = interpolation(fromVal, toVal, ease((now - startedAt) / duration));
            if (now < endAt) window1 === null || window1 === void 0 || window1.requestAnimationFrame(tick);
            else {
                source.value = toVal;
                resolve();
            }
        };
        tick();
    });
}
/**
* Transition from one value to another.
* @deprecated The `executeTransition` function is deprecated, use `transition` instead.
*
* @param source
* @param from
* @param to
* @param options
*/ function $85ea9b47855776cf$export$b82f7b6c1e4d2890(source, from, to, options = {}) {
    return $85ea9b47855776cf$export$66bb15e2994e6a26(source, from, to, options);
}
/**
* Follow value with a transition.
*
* @see https://vueuse.org/useTransition
* @param source
* @param options
*/ function $85ea9b47855776cf$export$7b286972b8d8ccbf(source, options = {}) {
    let currentId = 0;
    const sourceVal = ()=>{
        const v = (0, $01W3b.toValue)(source);
        return typeof options.interpolation === "undefined" && Array.isArray(v) ? v.map((0, $01W3b.toValue)) : v;
    };
    const outputRef = (0, $01W3b.shallowRef)(sourceVal());
    (0, $01W3b.watch)(sourceVal, async (to)=>{
        var _options$onStarted, _options$onFinished;
        if ((0, $01W3b.toValue)(options.disabled)) return;
        const id = ++currentId;
        if (options.delay) await (0, $aPZNl.promiseTimeout)((0, $01W3b.toValue)(options.delay));
        if (id !== currentId) return;
        (_options$onStarted = options.onStarted) === null || _options$onStarted === void 0 || _options$onStarted.call(options);
        await $85ea9b47855776cf$export$66bb15e2994e6a26(outputRef, outputRef.value, to, {
            ...options,
            abort: ()=>{
                var _options$abort2;
                return id !== currentId || ((_options$abort2 = options.abort) === null || _options$abort2 === void 0 ? void 0 : _options$abort2.call(options));
            }
        });
        (_options$onFinished = options.onFinished) === null || _options$onFinished === void 0 || _options$onFinished.call(options);
    }, {
        deep: true
    });
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(options.disabled), (disabled)=>{
        if (disabled) {
            currentId++;
            outputRef.value = sourceVal();
        }
    });
    (0, $aPZNl.tryOnScopeDispose)(()=>{
        currentId++;
    });
    return (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(options.disabled) ? sourceVal() : outputRef.value);
}
//#endregion
//#region useUrlSearchParams/index.ts
/**
* Reactive URLSearchParams
*
* @see https://vueuse.org/useUrlSearchParams
* @param mode
* @param options
*/ function $85ea9b47855776cf$export$a64580081d23e3b8(mode = "history", options = {}) {
    const { initialValue: initialValue = {}, removeNullishValues: removeNullishValues = true, removeFalsyValues: removeFalsyValues = false, write: enableWrite = true, writeMode: writeMode = "replace", window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, stringify: stringify = (params)=>params.toString() } = options;
    if (!window1) return (0, $01W3b.reactive)(initialValue);
    const state = (0, $01W3b.reactive)({});
    function getRawParams() {
        if (mode === "history") return window1.location.search || "";
        else if (mode === "hash") {
            const hash = window1.location.hash || "";
            const index = hash.indexOf("?");
            return index > 0 ? hash.slice(index) : "";
        } else return (window1.location.hash || "").replace(/^#/, "");
    }
    function constructQuery(params) {
        const stringified = stringify(params);
        if (mode === "history") return `${stringified ? `?${stringified}` : ""}${window1.location.hash || ""}`;
        if (mode === "hash-params") return `${window1.location.search || ""}${stringified ? `#${stringified}` : ""}`;
        const hash = window1.location.hash || "#";
        const index = hash.indexOf("?");
        if (index > 0) return `${window1.location.search || ""}${hash.slice(0, index)}${stringified ? `?${stringified}` : ""}`;
        return `${window1.location.search || ""}${hash}${stringified ? `?${stringified}` : ""}`;
    }
    function read() {
        return new URLSearchParams(getRawParams());
    }
    function updateState(params) {
        const unusedKeys = new Set(Object.keys(state));
        for (const key of params.keys()){
            const paramsForKey = params.getAll(key);
            state[key] = paramsForKey.length > 1 ? paramsForKey : params.get(key) || "";
            unusedKeys.delete(key);
        }
        Array.from(unusedKeys).forEach((key)=>delete state[key]);
    }
    const { pause: pause, resume: resume } = (0, $aPZNl.watchPausable)(state, ()=>{
        const params = new URLSearchParams("");
        Object.keys(state).forEach((key)=>{
            const mapEntry = state[key];
            if (Array.isArray(mapEntry)) mapEntry.forEach((value)=>params.append(key, value));
            else if (removeNullishValues && mapEntry == null) params.delete(key);
            else if (removeFalsyValues && !mapEntry) params.delete(key);
            else params.set(key, mapEntry);
        });
        write(params, false);
    }, {
        deep: true
    });
    function write(params, shouldUpdate, shouldWriteHistory = true) {
        pause();
        if (shouldUpdate) updateState(params);
        if (writeMode === "replace") window1.history.replaceState(window1.history.state, window1.document.title, window1.location.pathname + constructQuery(params));
        else if (shouldWriteHistory) window1.history.pushState(window1.history.state, window1.document.title, window1.location.pathname + constructQuery(params));
        (0, $TusQn.nextTick)(()=>resume());
    }
    function onChanged() {
        if (!enableWrite) return;
        write(read(), true, false);
    }
    const listenerOptions = {
        passive: true
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "popstate", onChanged, listenerOptions);
    if (mode !== "history") $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "hashchange", onChanged, listenerOptions);
    const initial = read();
    if (initial.keys().next().value) updateState(initial);
    else Object.assign(state, initialValue);
    return state;
}
//#endregion
//#region useUserMedia/index.ts
/**
* Reactive `mediaDevices.getUserMedia` streaming
*
* @see https://vueuse.org/useUserMedia
* @param options
*/ function $85ea9b47855776cf$export$a16ee9849ed85b4e(options = {}) {
    var _options$enabled, _options$autoSwitch;
    const enabled = (0, $01W3b.shallowRef)((_options$enabled = options.enabled) !== null && _options$enabled !== void 0 ? _options$enabled : false);
    const autoSwitch = (0, $01W3b.shallowRef)((_options$autoSwitch = options.autoSwitch) !== null && _options$autoSwitch !== void 0 ? _options$autoSwitch : true);
    const constraints = (0, $01W3b.ref)(options.constraints);
    const { navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc } = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>{
        var _navigator$mediaDevic;
        return navigator1 === null || navigator1 === void 0 || (_navigator$mediaDevic = navigator1.mediaDevices) === null || _navigator$mediaDevic === void 0 ? void 0 : _navigator$mediaDevic.getUserMedia;
    });
    const stream = (0, $01W3b.shallowRef)();
    function getDeviceOptions(type) {
        switch(type){
            case "video":
                if (constraints.value) return constraints.value.video || false;
                break;
            case "audio":
                if (constraints.value) return constraints.value.audio || false;
                break;
        }
    }
    async function _start() {
        if (!isSupported.value || stream.value) return;
        stream.value = await navigator1.mediaDevices.getUserMedia({
            video: getDeviceOptions("video"),
            audio: getDeviceOptions("audio")
        });
        return stream.value;
    }
    function _stop() {
        var _stream$value;
        (_stream$value = stream.value) === null || _stream$value === void 0 || _stream$value.getTracks().forEach((t)=>t.stop());
        stream.value = void 0;
    }
    function stop() {
        _stop();
        enabled.value = false;
    }
    async function start() {
        await _start();
        if (stream.value) enabled.value = true;
        return stream.value;
    }
    async function restart() {
        _stop();
        return await start();
    }
    (0, $01W3b.watch)(enabled, (v)=>{
        if (v) _start();
        else _stop();
    }, {
        immediate: true
    });
    (0, $01W3b.watch)(constraints, ()=>{
        if (autoSwitch.value && stream.value) restart();
    }, {
        immediate: true,
        deep: true
    });
    (0, $aPZNl.tryOnScopeDispose)(()=>{
        stop();
    });
    return {
        isSupported: isSupported,
        stream: stream,
        start: start,
        stop: stop,
        restart: restart,
        constraints: constraints,
        enabled: enabled,
        autoSwitch: autoSwitch
    };
}
//#endregion
//#region useVModel/index.ts
/**
* Shorthand for v-model binding, props + emit -> ref
*
* @see https://vueuse.org/useVModel
* @param props
* @param key (default 'modelValue')
* @param emit
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$42662bab1b538e5(props, key, emit, options = {}) {
    var _vm$$emit, _vm$proxy;
    const { clone: clone = false, passive: passive = false, eventName: eventName, deep: deep = false, defaultValue: defaultValue, shouldEmit: shouldEmit } = options;
    const vm = (0, $TusQn.getCurrentInstance)();
    const _emit = emit || (vm === null || vm === void 0 ? void 0 : vm.emit) || (vm === null || vm === void 0 || (_vm$$emit = vm.$emit) === null || _vm$$emit === void 0 ? void 0 : _vm$$emit.bind(vm)) || (vm === null || vm === void 0 || (_vm$proxy = vm.proxy) === null || _vm$proxy === void 0 || (_vm$proxy = _vm$proxy.$emit) === null || _vm$proxy === void 0 ? void 0 : _vm$proxy.bind(vm === null || vm === void 0 ? void 0 : vm.proxy));
    let event = eventName;
    if (!key) key = "modelValue";
    event = event || `update:${key.toString()}`;
    const cloneFn = (val)=>!clone ? val : typeof clone === "function" ? clone(val) : $85ea9b47855776cf$export$9e72043f8ff3a3df(val);
    const getValue = ()=>(0, $aPZNl.isDef)(props[key]) ? cloneFn(props[key]) : defaultValue;
    const triggerEmit = (value)=>{
        if (shouldEmit) {
            if (shouldEmit(value)) _emit(event, value);
        } else _emit(event, value);
    };
    if (passive) {
        const proxy = (0, $01W3b.ref)(getValue());
        let isUpdating = false;
        (0, $01W3b.watch)(()=>props[key], (v)=>{
            if (!isUpdating) {
                isUpdating = true;
                proxy.value = cloneFn(v);
                (0, $TusQn.nextTick)(()=>isUpdating = false);
            }
        });
        (0, $01W3b.watch)(proxy, (v)=>{
            if (!isUpdating && (v !== props[key] || deep)) triggerEmit(v);
        }, {
            deep: deep
        });
        return proxy;
    } else return (0, $01W3b.computed)({
        get () {
            return getValue();
        },
        set (value) {
            triggerEmit(value);
        }
    });
}
//#endregion
//#region useVModels/index.ts
/**
* Shorthand for props v-model binding. Think like `toRefs(props)` but changes will also emit out.
*
* @see https://vueuse.org/useVModels
* @param props
* @param emit
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$b020cc6dc10339b9(props, emit, options = {}) {
    const ret = {};
    for(const key in props)ret[key] = $85ea9b47855776cf$export$42662bab1b538e5(props, key, emit, options);
    return ret;
}
//#endregion
//#region useVibrate/index.ts
function $85ea9b47855776cf$var$getDefaultScheduler$1(options = {
    interval: 0
}) {
    const { interval: interval } = options;
    if (interval === 0) return;
    return (fn)=>(0, $aPZNl.useIntervalFn)(fn, interval, {
            immediate: false,
            immediateCallback: false
        });
}
/**
* Reactive vibrate
*
* @see https://vueuse.org/useVibrate
* @see https://developer.mozilla.org/en-US/docs/Web/API/Vibration_API
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$165ce7a5158a386d(options) {
    const { pattern: pattern = [], scheduler: scheduler = $85ea9b47855776cf$var$getDefaultScheduler$1(options), navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc } = options || {};
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>typeof navigator1 !== "undefined" && "vibrate" in navigator1);
    const patternRef = (0, $aPZNl.toRef)(pattern);
    const vibrate = (pattern = patternRef.value)=>{
        if (isSupported.value) navigator1.vibrate(pattern);
    };
    const intervalControls = scheduler === null || scheduler === void 0 ? void 0 : scheduler(vibrate);
    const stop = ()=>{
        if (isSupported.value) navigator1.vibrate(0);
        intervalControls === null || intervalControls === void 0 || intervalControls.pause();
    };
    return {
        isSupported: isSupported,
        pattern: pattern,
        intervalControls: intervalControls,
        vibrate: vibrate,
        stop: stop
    };
}
//#endregion
//#region useVirtualList/index.ts
/**
* Please consider using [`vue-virtual-scroller`](https://github.com/Akryum/vue-virtual-scroller) if you are looking for more features.
*/ function $85ea9b47855776cf$export$e0cfc61c348fbd34(list, options) {
    const { containerStyle: containerStyle, wrapperProps: wrapperProps, scrollTo: scrollTo, calculateRange: calculateRange, currentList: currentList, containerRef: containerRef } = "itemHeight" in options ? $85ea9b47855776cf$var$useVerticalVirtualList(options, list) : $85ea9b47855776cf$var$useHorizontalVirtualList(options, list);
    return {
        list: currentList,
        scrollTo: scrollTo,
        containerProps: {
            ref: containerRef,
            onScroll: ()=>{
                calculateRange();
            },
            style: containerStyle
        },
        wrapperProps: wrapperProps
    };
}
function $85ea9b47855776cf$var$useVirtualListResources(list) {
    const containerRef = (0, $01W3b.shallowRef)(null);
    const size = $85ea9b47855776cf$export$2b86bedf890eab8(containerRef);
    const currentList = (0, $01W3b.ref)([]);
    const source = (0, $01W3b.shallowRef)(list);
    return {
        state: (0, $01W3b.ref)({
            start: 0,
            end: 10
        }),
        source: source,
        currentList: currentList,
        size: size,
        containerRef: containerRef
    };
}
function $85ea9b47855776cf$var$createGetViewCapacity(state, source, itemSize) {
    return (containerSize)=>{
        if (typeof itemSize === "number") return Math.ceil(containerSize / itemSize);
        const { start: start = 0 } = state.value;
        let sum = 0;
        let capacity = 0;
        for(let i = start; i < source.value.length; i++){
            const size = itemSize(i);
            sum += size;
            capacity = i;
            if (sum > containerSize) break;
        }
        return capacity - start;
    };
}
function $85ea9b47855776cf$var$createGetOffset(source, itemSize) {
    return (scrollDirection)=>{
        if (typeof itemSize === "number") return Math.floor(scrollDirection / itemSize) + 1;
        let sum = 0;
        let offset = 0;
        for(let i = 0; i < source.value.length; i++){
            const size = itemSize(i);
            sum += size;
            if (sum >= scrollDirection) {
                offset = i;
                break;
            }
        }
        return offset + 1;
    };
}
function $85ea9b47855776cf$var$createCalculateRange(type, overscan, getOffset, getViewCapacity, { containerRef: containerRef, state: state, currentList: currentList, source: source }) {
    return ()=>{
        const element = containerRef.value;
        if (element) {
            const offset = getOffset(type === "vertical" ? element.scrollTop : element.scrollLeft);
            const viewCapacity = getViewCapacity(type === "vertical" ? element.clientHeight : element.clientWidth);
            const from = offset - overscan;
            const to = offset + viewCapacity + overscan;
            state.value = {
                start: from < 0 ? 0 : from,
                end: to > source.value.length ? source.value.length : to
            };
            currentList.value = source.value.slice(state.value.start, state.value.end).map((ele, index)=>({
                    data: ele,
                    index: index + state.value.start
                }));
        }
    };
}
function $85ea9b47855776cf$var$createGetDistance(itemSize, source) {
    return (index)=>{
        if (typeof itemSize === "number") return index * itemSize;
        return source.value.slice(0, index).reduce((sum, _, i)=>sum + itemSize(i), 0);
    };
}
function $85ea9b47855776cf$var$useWatchForSizes(size, listRef, containerRef, calculateRange) {
    (0, $01W3b.watch)([
        size.width,
        size.height,
        listRef,
        containerRef
    ], ()=>{
        calculateRange();
    });
}
function $85ea9b47855776cf$var$createComputedTotalSize(itemSize, source) {
    return (0, $01W3b.computed)(()=>{
        if (typeof itemSize === "number") return source.value.length * itemSize;
        return source.value.reduce((sum, _, index)=>sum + itemSize(index), 0);
    });
}
const $85ea9b47855776cf$var$scrollToDictionaryForElementScrollKey = {
    horizontal: "scrollLeft",
    vertical: "scrollTop"
};
function $85ea9b47855776cf$var$createScrollTo(type, calculateRange, getDistance, containerRef) {
    return (index)=>{
        if (containerRef.value) {
            containerRef.value[$85ea9b47855776cf$var$scrollToDictionaryForElementScrollKey[type]] = getDistance(index);
            calculateRange();
        }
    };
}
function $85ea9b47855776cf$var$useHorizontalVirtualList(options, list) {
    const resources = $85ea9b47855776cf$var$useVirtualListResources(list);
    const { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef } = resources;
    const containerStyle = {
        overflowX: "auto"
    };
    const { itemWidth: itemWidth, overscan: overscan = 5 } = options;
    const getViewCapacity = $85ea9b47855776cf$var$createGetViewCapacity(state, source, itemWidth);
    const calculateRange = $85ea9b47855776cf$var$createCalculateRange("horizontal", overscan, $85ea9b47855776cf$var$createGetOffset(source, itemWidth), getViewCapacity, resources);
    const getDistanceLeft = $85ea9b47855776cf$var$createGetDistance(itemWidth, source);
    const offsetLeft = (0, $01W3b.computed)(()=>getDistanceLeft(state.value.start));
    const totalWidth = $85ea9b47855776cf$var$createComputedTotalSize(itemWidth, source);
    $85ea9b47855776cf$var$useWatchForSizes(size, source, containerRef, calculateRange);
    return {
        scrollTo: $85ea9b47855776cf$var$createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef),
        calculateRange: calculateRange,
        wrapperProps: (0, $01W3b.computed)(()=>{
            return {
                style: {
                    height: "100%",
                    width: `${totalWidth.value - offsetLeft.value}px`,
                    marginLeft: `${offsetLeft.value}px`,
                    display: "flex"
                }
            };
        }),
        containerStyle: containerStyle,
        currentList: currentList,
        containerRef: containerRef
    };
}
function $85ea9b47855776cf$var$useVerticalVirtualList(options, list) {
    const resources = $85ea9b47855776cf$var$useVirtualListResources(list);
    const { state: state, source: source, currentList: currentList, size: size, containerRef: containerRef } = resources;
    const containerStyle = {
        overflowY: "auto"
    };
    const { itemHeight: itemHeight, overscan: overscan = 5 } = options;
    const getViewCapacity = $85ea9b47855776cf$var$createGetViewCapacity(state, source, itemHeight);
    const calculateRange = $85ea9b47855776cf$var$createCalculateRange("vertical", overscan, $85ea9b47855776cf$var$createGetOffset(source, itemHeight), getViewCapacity, resources);
    const getDistanceTop = $85ea9b47855776cf$var$createGetDistance(itemHeight, source);
    const offsetTop = (0, $01W3b.computed)(()=>getDistanceTop(state.value.start));
    const totalHeight = $85ea9b47855776cf$var$createComputedTotalSize(itemHeight, source);
    $85ea9b47855776cf$var$useWatchForSizes(size, source, containerRef, calculateRange);
    return {
        calculateRange: calculateRange,
        scrollTo: $85ea9b47855776cf$var$createScrollTo("vertical", calculateRange, getDistanceTop, containerRef),
        containerStyle: containerStyle,
        wrapperProps: (0, $01W3b.computed)(()=>{
            return {
                style: {
                    width: "100%",
                    height: `${totalHeight.value - offsetTop.value}px`,
                    marginTop: `${offsetTop.value}px`
                }
            };
        }),
        currentList: currentList,
        containerRef: containerRef
    };
}
//#endregion
//#region useWakeLock/index.ts
/**
* Reactive Screen Wake Lock API.
*
* @see https://vueuse.org/useWakeLock
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$73321d658b51e565(options = {}) {
    const { navigator: navigator1 = $85ea9b47855776cf$export$eade61489f57e3fc, document: document1 = $85ea9b47855776cf$export$37990bd438d16af3 } = options;
    const requestedType = (0, $01W3b.shallowRef)(false);
    const sentinel = (0, $01W3b.shallowRef)(null);
    const documentVisibility = $85ea9b47855776cf$export$87a87a3d299ece7c({
        document: document1
    });
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>navigator1 && "wakeLock" in navigator1);
    const isActive = (0, $01W3b.computed)(()=>!!sentinel.value && documentVisibility.value === "visible");
    if (isSupported.value) {
        $85ea9b47855776cf$export$7080b3e976bc91ab(sentinel, "release", ()=>{
            var _sentinel$value$type, _sentinel$value;
            requestedType.value = (_sentinel$value$type = (_sentinel$value = sentinel.value) === null || _sentinel$value === void 0 ? void 0 : _sentinel$value.type) !== null && _sentinel$value$type !== void 0 ? _sentinel$value$type : false;
        }, {
            passive: true
        });
        (0, $aPZNl.whenever)(()=>documentVisibility.value === "visible" && (document1 === null || document1 === void 0 ? void 0 : document1.visibilityState) === "visible" && requestedType.value, (type)=>{
            requestedType.value = false;
            forceRequest(type);
        });
    }
    async function forceRequest(type) {
        var _sentinel$value2;
        await ((_sentinel$value2 = sentinel.value) === null || _sentinel$value2 === void 0 ? void 0 : _sentinel$value2.release());
        sentinel.value = isSupported.value ? await navigator1.wakeLock.request(type) : null;
    }
    async function request(type) {
        if (documentVisibility.value === "visible") await forceRequest(type);
        else requestedType.value = type;
    }
    async function release() {
        requestedType.value = false;
        const s = sentinel.value;
        sentinel.value = null;
        await (s === null || s === void 0 ? void 0 : s.release());
    }
    (0, $aPZNl.tryOnScopeDispose)(()=>{
        release();
    });
    return {
        sentinel: sentinel,
        isSupported: isSupported,
        isActive: isActive,
        request: request,
        forceRequest: forceRequest,
        release: release
    };
}
//#endregion
//#region useWebNotification/index.ts
/**
* Reactive useWebNotification
*
* @see https://vueuse.org/useWebNotification
* @see https://developer.mozilla.org/en-US/docs/Web/API/notification
*/ function $85ea9b47855776cf$export$522fa265139e12a1(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, requestPermissions: _requestForPermissions = true } = options;
    const defaultWebNotificationOptions = options;
    const isSupported = /* @__PURE__ */ $85ea9b47855776cf$export$85904d4478b9c8a4(()=>{
        if (!window1 || !("Notification" in window1)) return false;
        if (Notification.permission === "granted") return true;
        try {
            const notification = new Notification("");
            notification.onshow = ()=>{
                notification.close();
            };
        } catch (e) {
            if (e.name === "TypeError") return false;
        }
        return true;
    });
    const permissionGranted = (0, $01W3b.shallowRef)(isSupported.value && "permission" in Notification && Notification.permission === "granted");
    const notification = (0, $01W3b.shallowRef)(null);
    const ensurePermissions = async ()=>{
        if (!isSupported.value) return;
        if (!permissionGranted.value && Notification.permission !== "denied") {
            if (await Notification.requestPermission() === "granted") permissionGranted.value = true;
        }
        return permissionGranted.value;
    };
    const { on: onClick, trigger: clickTrigger } = (0, $aPZNl.createEventHook)();
    const { on: onShow, trigger: showTrigger } = (0, $aPZNl.createEventHook)();
    const { on: onError, trigger: errorTrigger } = (0, $aPZNl.createEventHook)();
    const { on: onClose, trigger: closeTrigger } = (0, $aPZNl.createEventHook)();
    const show = async (overrides)=>{
        if (!isSupported.value || !permissionGranted.value) return;
        const options = Object.assign({}, defaultWebNotificationOptions, overrides);
        notification.value = new Notification(options.title || "", options);
        notification.value.onclick = clickTrigger;
        notification.value.onshow = showTrigger;
        notification.value.onerror = errorTrigger;
        notification.value.onclose = closeTrigger;
        return notification.value;
    };
    const close = ()=>{
        if (notification.value) notification.value.close();
        notification.value = null;
    };
    if (_requestForPermissions) (0, $aPZNl.tryOnMounted)(ensurePermissions);
    (0, $aPZNl.tryOnScopeDispose)(close);
    if (isSupported.value && window1) {
        const document1 = window1.document;
        $85ea9b47855776cf$export$7080b3e976bc91ab(document1, "visibilitychange", (e)=>{
            e.preventDefault();
            if (document1.visibilityState === "visible") close();
        });
    }
    return {
        isSupported: isSupported,
        notification: notification,
        ensurePermissions: ensurePermissions,
        permissionGranted: permissionGranted,
        show: show,
        close: close,
        onClick: onClick,
        onShow: onShow,
        onError: onError,
        onClose: onClose
    };
}
//#endregion
//#region useWebSocket/index.ts
const $85ea9b47855776cf$var$DEFAULT_PING_MESSAGE = "ping";
function $85ea9b47855776cf$var$resolveNestedOptions(options) {
    if (options === true) return {};
    return options;
}
function $85ea9b47855776cf$var$getDefaultScheduler(options) {
    if ("interval" in options) {
        const { interval: interval = 1e3 } = options;
        return (cb)=>(0, $aPZNl.useIntervalFn)(cb, interval, {
                immediate: false
            });
    }
    return (cb)=>(0, $aPZNl.useIntervalFn)(cb, 1e3, {
            immediate: false
        });
}
/**
* Reactive WebSocket client.
*
* @see https://vueuse.org/useWebSocket
* @param url
*/ function $85ea9b47855776cf$export$ef4944d05bd3db0(url, options = {}) {
    const { onConnected: onConnected, onDisconnected: onDisconnected, onError: onError, onMessage: onMessage, immediate: immediate = true, autoConnect: autoConnect = true, autoClose: autoClose = true, protocols: protocols = [] } = options;
    const data = (0, $01W3b.shallowRef)(null);
    const status = (0, $01W3b.shallowRef)("CLOSED");
    const wsRef = (0, $01W3b.shallowRef)();
    const urlRef = (0, $aPZNl.toRef)(url);
    let heartbeatPause;
    let heartbeatResume;
    let explicitlyClosed = false;
    let retried = 0;
    let bufferedData = [];
    let retryTimeout;
    let pongTimeoutWait;
    const _sendBuffer = ()=>{
        if (bufferedData.length && wsRef.value && status.value === "OPEN") {
            for (const buffer of bufferedData)wsRef.value.send(buffer);
            bufferedData = [];
        }
    };
    const resetRetry = ()=>{
        if (retryTimeout != null) {
            clearTimeout(retryTimeout);
            retryTimeout = void 0;
        }
    };
    const resetHeartbeat = ()=>{
        clearTimeout(pongTimeoutWait);
        pongTimeoutWait = void 0;
    };
    const close = (code = 1e3, reason)=>{
        resetRetry();
        if (!(0, $aPZNl.isClient) && !(0, $aPZNl.isWorker) || !wsRef.value) return;
        explicitlyClosed = true;
        resetHeartbeat();
        heartbeatPause === null || heartbeatPause === void 0 || heartbeatPause();
        wsRef.value.close(code, reason);
        wsRef.value = void 0;
    };
    const send = (data, useBuffer = true)=>{
        if (!wsRef.value || status.value !== "OPEN") {
            if (useBuffer) bufferedData.push(data);
            return false;
        }
        _sendBuffer();
        wsRef.value.send(data);
        return true;
    };
    const _init = ()=>{
        if (explicitlyClosed || typeof urlRef.value === "undefined") return;
        const ws = new WebSocket(urlRef.value, protocols);
        wsRef.value = ws;
        status.value = "CONNECTING";
        ws.onopen = ()=>{
            if (wsRef.value !== ws) return;
            status.value = "OPEN";
            retried = 0;
            onConnected === null || onConnected === void 0 || onConnected(ws);
            heartbeatResume === null || heartbeatResume === void 0 || heartbeatResume();
            _sendBuffer();
        };
        ws.onclose = (ev)=>{
            if (wsRef.value === ws) status.value = "CLOSED";
            resetHeartbeat();
            heartbeatPause === null || heartbeatPause === void 0 || heartbeatPause();
            onDisconnected === null || onDisconnected === void 0 || onDisconnected(ws, ev);
            if (!explicitlyClosed && options.autoReconnect && (wsRef.value == null || ws === wsRef.value)) {
                const { retries: retries = -1, delay: delay = 1e3, onFailed: onFailed } = $85ea9b47855776cf$var$resolveNestedOptions(options.autoReconnect);
                if ((typeof retries === "function" ? retries : ()=>typeof retries === "number" && (retries < 0 || retried < retries))(retried)) {
                    retried += 1;
                    const delayTime = typeof delay === "function" ? delay(retried) : delay;
                    retryTimeout = setTimeout(_init, delayTime);
                } else onFailed === null || onFailed === void 0 || onFailed();
            }
        };
        ws.onerror = (e)=>{
            onError === null || onError === void 0 || onError(ws, e);
        };
        ws.onmessage = (e)=>{
            if (options.heartbeat) {
                resetHeartbeat();
                const { message: message = $85ea9b47855776cf$var$DEFAULT_PING_MESSAGE, responseMessage: responseMessage = message } = $85ea9b47855776cf$var$resolveNestedOptions(options.heartbeat);
                if (e.data === (0, $01W3b.toValue)(responseMessage)) return;
            }
            data.value = e.data;
            onMessage === null || onMessage === void 0 || onMessage(ws, e);
        };
    };
    if (options.heartbeat) {
        const { message: message = $85ea9b47855776cf$var$DEFAULT_PING_MESSAGE, scheduler: scheduler = $85ea9b47855776cf$var$getDefaultScheduler($85ea9b47855776cf$var$resolveNestedOptions(options.heartbeat)), pongTimeout: pongTimeout = 1e3 } = $85ea9b47855776cf$var$resolveNestedOptions(options.heartbeat);
        const { pause: pause, resume: resume } = scheduler(()=>{
            send((0, $01W3b.toValue)(message), false);
            if (pongTimeoutWait != null) return;
            pongTimeoutWait = setTimeout(()=>{
                close();
                explicitlyClosed = false;
            }, pongTimeout);
        });
        heartbeatPause = pause;
        heartbeatResume = resume;
    }
    if (autoClose) {
        if (0, $aPZNl.isClient) $85ea9b47855776cf$export$7080b3e976bc91ab("beforeunload", ()=>close(), {
            passive: true
        });
        (0, $aPZNl.tryOnScopeDispose)(close);
    }
    const open = ()=>{
        if (!(0, $aPZNl.isClient) && !(0, $aPZNl.isWorker)) return;
        close();
        explicitlyClosed = false;
        retried = 0;
        _init();
    };
    if (immediate) open();
    if (autoConnect) (0, $01W3b.watch)(urlRef, open);
    return {
        data: data,
        status: status,
        close: close,
        send: send,
        open: open,
        ws: wsRef
    };
}
//#endregion
//#region useWebWorker/index.ts
function $85ea9b47855776cf$export$44bc62d25eb3a976(arg0, workerOptions, options) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options !== null && options !== void 0 ? options : {};
    const data = (0, $01W3b.shallowRef)(null);
    const worker = (0, $01W3b.shallowRef)();
    const post = (...args)=>{
        if (!worker.value) return;
        worker.value.postMessage(...args);
    };
    const terminate = function terminate() {
        if (!worker.value) return;
        worker.value.terminate();
    };
    if (window1) {
        if (typeof arg0 === "string") worker.value = new Worker(arg0, workerOptions);
        else if (typeof arg0 === "function") worker.value = arg0();
        else worker.value = arg0;
        worker.value.onmessage = (e)=>{
            data.value = e.data;
        };
        (0, $aPZNl.tryOnScopeDispose)(()=>{
            if (worker.value) worker.value.terminate();
        });
    }
    return {
        data: data,
        post: post,
        terminate: terminate,
        worker: worker
    };
}
//#endregion
//#region useWebWorkerFn/lib/depsParser.ts
/**
*
* Concatenates the dependencies into a comma separated string.
* this string will then be passed as an argument to the "importScripts" function
*
* @param deps array of string
* @param localDeps array of function
* @returns a string composed by the concatenation of the array
* elements "deps" and "importScripts".
*
* @example
* depsParser(['demo1', 'demo2']) // return importScripts('demo1', 'demo2')
*/ function $85ea9b47855776cf$var$depsParser(deps, localDeps) {
    if (deps.length === 0 && localDeps.length === 0) return "";
    const depsString = deps.map((dep)=>`'${dep}'`).toString();
    const depsFunctionString = localDeps.filter((dep)=>typeof dep === "function").map((fn)=>{
        const str = fn.toString();
        if (str.trim().startsWith("function")) return str;
        else return `const ${fn.name} = ${str}`;
    }).join(";");
    const importString = `importScripts(${depsString});`;
    return `${depsString.trim() === "" ? "" : importString} ${depsFunctionString}`;
}
//#endregion
//#region useWebWorkerFn/lib/jobRunner.ts
/**
* This function accepts as a parameter a function "userFunc"
* And as a result returns an anonymous function.
* This anonymous function, accepts as arguments,
* the parameters to pass to the function "useArgs" and returns a Promise
* This function can be used as a wrapper, only inside a Worker
* because it depends by "postMessage".
*
* @param userFunc {Function} fn the function to run with web worker
*
* @returns returns a function that accepts the parameters
* to be passed to the "userFunc" function
*/ function $85ea9b47855776cf$var$jobRunner(userFunc) {
    return (e)=>{
        const userFuncArgs = e.data[0];
        return Promise.resolve(userFunc.apply(void 0, userFuncArgs)).then((result)=>{
            postMessage([
                "SUCCESS",
                result
            ]);
        }).catch((error)=>{
            postMessage([
                "ERROR",
                error
            ]);
        });
    };
}
//#endregion
//#region useWebWorkerFn/lib/createWorkerBlobUrl.ts
/**
* Converts the "fn" function into the syntax needed to be executed within a web worker
*
* @param fn the function to run with web worker
* @param deps array of strings, imported into the worker through "importScripts"
* @param localDeps array of function, local dependencies
*
* @returns a blob url, containing the code of "fn" as a string
*
* @example
* createWorkerBlobUrl((a,b) => a+b, [])
* // return "onmessage=return Promise.resolve((a,b) => a + b)
* .then(postMessage(['SUCCESS', result]))
* .catch(postMessage(['ERROR', error])"
*/ function $85ea9b47855776cf$var$createWorkerBlobUrl(fn, deps, localDeps) {
    const blobCode = `${$85ea9b47855776cf$var$depsParser(deps, localDeps)}; onmessage=(${$85ea9b47855776cf$var$jobRunner})(${fn})`;
    const blob = new Blob([
        blobCode
    ], {
        type: "text/javascript"
    });
    return URL.createObjectURL(blob);
}
//#endregion
//#region useWebWorkerFn/index.ts
/**
* Run expensive function without blocking the UI, using a simple syntax that makes use of Promise.
*
* @see https://vueuse.org/useWebWorkerFn
* @param fn
* @param options
*/ function $85ea9b47855776cf$export$33b1fcfcd57b961(fn, options = {}) {
    const { dependencies: dependencies = [], localDependencies: localDependencies = [], timeout: timeout, window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    let worker;
    const workerStatus = (0, $01W3b.shallowRef)("PENDING");
    const promise = (0, $01W3b.shallowRef)({});
    const timeoutId = (0, $01W3b.shallowRef)();
    const workerTerminate = (status = "PENDING")=>{
        if (worker && worker._url && window1) {
            worker.terminate();
            URL.revokeObjectURL(worker._url);
            promise.value = {};
            worker = void 0;
            window1.clearTimeout(timeoutId.value);
            workerStatus.value = status;
        }
    };
    workerTerminate();
    (0, $aPZNl.tryOnScopeDispose)(workerTerminate);
    const generateWorker = ()=>{
        const blobUrl = $85ea9b47855776cf$var$createWorkerBlobUrl(fn, dependencies, localDependencies);
        const newWorker = new Worker(blobUrl);
        newWorker._url = blobUrl;
        newWorker.onmessage = (e)=>{
            const { resolve: resolve = ()=>{}, reject: reject = ()=>{} } = promise.value;
            const [status, result] = e.data;
            switch(status){
                case "SUCCESS":
                    resolve(result);
                    workerTerminate(status);
                    break;
                default:
                    reject(result);
                    workerTerminate("ERROR");
                    break;
            }
        };
        newWorker.onerror = (e)=>{
            const { reject: reject = ()=>{} } = promise.value;
            e.preventDefault();
            reject(e);
            workerTerminate("ERROR");
        };
        if (timeout) timeoutId.value = setTimeout(workerTerminate, timeout, "TIMEOUT_EXPIRED");
        return newWorker;
    };
    const callWorker = (...fnArgs)=>new Promise((resolve, reject)=>{
            promise.value = {
                resolve: resolve,
                reject: reject
            };
            worker === null || worker === void 0 || worker.postMessage([
                [
                    ...fnArgs
                ]
            ]);
            workerStatus.value = "RUNNING";
        });
    const workerFn = (...fnArgs)=>{
        if (workerStatus.value === "RUNNING") {
            console.error("[useWebWorkerFn] You can only run one instance of the worker at a time.");
            return Promise.reject();
        }
        worker = generateWorker();
        return callWorker(...fnArgs);
    };
    return {
        workerFn: workerFn,
        workerStatus: workerStatus,
        workerTerminate: workerTerminate
    };
}
//#endregion
//#region useWindowFocus/index.ts
/**
* Reactively track window focus with `window.onfocus` and `window.onblur`.
*
* @see https://vueuse.org/useWindowFocus
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$e838b63e89f8751e(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a } = options;
    if (!window1) return (0, $01W3b.shallowRef)(false);
    const focused = (0, $01W3b.shallowRef)(window1.document.hasFocus());
    const listenerOptions = {
        passive: true
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "blur", ()=>{
        focused.value = false;
    }, listenerOptions);
    $85ea9b47855776cf$export$7080b3e976bc91ab(window1, "focus", ()=>{
        focused.value = true;
    }, listenerOptions);
    return focused;
}
//#endregion
//#region useWindowScroll/index.ts
/**
* Reactive window scroll.
*
* @see https://vueuse.org/useWindowScroll
* @param options
*/ function $85ea9b47855776cf$export$c510e5ca8a22f2a1(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, ...rest } = options;
    return $85ea9b47855776cf$export$d928051c8cd740b(window1, rest);
}
//#endregion
//#region useWindowSize/index.ts
/**
* Reactive window size.
*
* @see https://vueuse.org/useWindowSize
* @param options
*
* @__NO_SIDE_EFFECTS__
*/ function $85ea9b47855776cf$export$42c02f33970a2afa(options = {}) {
    const { window: window1 = $85ea9b47855776cf$export$16f8ba610718ae4a, initialWidth: initialWidth = Number.POSITIVE_INFINITY, initialHeight: initialHeight = Number.POSITIVE_INFINITY, listenOrientation: listenOrientation = true, includeScrollbar: includeScrollbar = true, type: type = "inner" } = options;
    const width = (0, $01W3b.shallowRef)(initialWidth);
    const height = (0, $01W3b.shallowRef)(initialHeight);
    const update = ()=>{
        if (window1) {
            if (type === "outer") {
                width.value = window1.outerWidth;
                height.value = window1.outerHeight;
            } else if (type === "visual" && window1.visualViewport) {
                const { width: visualViewportWidth, height: visualViewportHeight, scale: scale } = window1.visualViewport;
                width.value = Math.round(visualViewportWidth * scale);
                height.value = Math.round(visualViewportHeight * scale);
            } else if (includeScrollbar) {
                width.value = window1.innerWidth;
                height.value = window1.innerHeight;
            } else {
                width.value = window1.document.documentElement.clientWidth;
                height.value = window1.document.documentElement.clientHeight;
            }
        }
    };
    update();
    (0, $aPZNl.tryOnMounted)(update);
    const listenerOptions = {
        passive: true
    };
    $85ea9b47855776cf$export$7080b3e976bc91ab("resize", update, listenerOptions);
    if (window1 && type === "visual" && window1.visualViewport) $85ea9b47855776cf$export$7080b3e976bc91ab(window1.visualViewport, "resize", update, listenerOptions);
    if (listenOrientation) (0, $01W3b.watch)($85ea9b47855776cf$export$32d5543ab307c01("(orientation: portrait)"), ()=>update());
    return {
        width: width,
        height: height
    };
}

});





parcelRegister("lUp03", function(module, exports) {
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $6ZWSX = parcelRequire("6ZWSX");
var $ff323866fb43afa6$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");
!function(e) {
    module.exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $ff323866fb43afa6$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($ff323866fb43afa6$require$Buffer.from && $ff323866fb43afa6$require$Buffer.from !== Uint8Array.from) return $ff323866fb43afa6$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $ff323866fb43afa6$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($ff323866fb43afa6$require$Buffer.alloc) return $ff323866fb43afa6$require$Buffer.alloc(e);
                        var t = new $ff323866fb43afa6$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $ff323866fb43afa6$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $ff323866fb43afa6$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $ff323866fb43afa6$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $hPtJY.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("6zjtX", function(module, exports) {

$parcel$export(module.exports, "useCommonStore", () => $4c851fb55265682b$export$abc224086152f714);

var $i0TKe = parcelRequire("i0TKe");

var $j2lJZ = parcelRequire("j2lJZ");
const $4c851fb55265682b$export$abc224086152f714 = (0, $i0TKe.defineStore)('common', {
    state: ()=>({
            folderId: '',
            space: '',
            userInfo: {}
        }),
    actions: {
        init () {
            this.userInfo = JSON.parse(sessionStorage.getItem('SCANAT_USER_INFO')) ?? {};
        },
        setFolderId (folderId) {
            this.folderId = (0, $j2lJZ.apiParentIdOf)(folderId) || '0';
        },
        setSpace (space) {
            this.space = space;
        }
    }
});

});
parcelRegister("j2lJZ", function(module, exports) {

$parcel$export(module.exports, "PERSONAL_ROOT_ID", () => $ddbf117b5bbd0237$export$eacd29cf0034a277);
$parcel$export(module.exports, "TEAM_ROOT_ID", () => $ddbf117b5bbd0237$export$2e99ffd4630f2b47);
$parcel$export(module.exports, "SAMPLE_ROOT_ID", () => $ddbf117b5bbd0237$export$21a9c047a6a86777);
$parcel$export(module.exports, "rootFolderIdOf", () => $ddbf117b5bbd0237$export$d272400a1c36e538);
$parcel$export(module.exports, "isSpaceRootFolderId", () => $ddbf117b5bbd0237$export$3443c01481639bbd);
$parcel$export(module.exports, "spaceOfRootFolderId", () => $ddbf117b5bbd0237$export$c4f18cddb744f393);
$parcel$export(module.exports, "apiParentIdOf", () => $ddbf117b5bbd0237$export$68945212e4117c8a);
$parcel$export(module.exports, "normalizeFolders", () => $ddbf117b5bbd0237$export$708a949fe776caf7);
$parcel$export(module.exports, "cloneFolderTree", () => $ddbf117b5bbd0237$export$64f3ec90105a8e1b);
$parcel$export(module.exports, "findFolderById", () => $ddbf117b5bbd0237$export$c082e5337b142686);
$parcel$export(module.exports, "findFolderParent", () => $ddbf117b5bbd0237$export$820665972310b71f);
$parcel$export(module.exports, "createRootFolder", () => $ddbf117b5bbd0237$export$e1ada826a928cb52);
$parcel$export(module.exports, "parseUrlFolderState", () => $ddbf117b5bbd0237$export$740faeebd589392e);
$parcel$export(module.exports, "resolveRequestFolderState", () => $ddbf117b5bbd0237$export$9f4acd03e2807387);
const $ddbf117b5bbd0237$export$eacd29cf0034a277 = 'personal';
const $ddbf117b5bbd0237$export$2e99ffd4630f2b47 = 'team';
const $ddbf117b5bbd0237$export$21a9c047a6a86777 = 'sample';
const $ddbf117b5bbd0237$export$d272400a1c36e538 = (space)=>{
    if (space === 1) return $ddbf117b5bbd0237$export$2e99ffd4630f2b47;
    if (space === 0) return $ddbf117b5bbd0237$export$eacd29cf0034a277;
    return null;
};
const $ddbf117b5bbd0237$export$3443c01481639bbd = (id)=>[
        $ddbf117b5bbd0237$export$eacd29cf0034a277,
        $ddbf117b5bbd0237$export$2e99ffd4630f2b47
    ].includes(String(id));
const $ddbf117b5bbd0237$export$c4f18cddb744f393 = (id)=>{
    if (String(id) === $ddbf117b5bbd0237$export$2e99ffd4630f2b47) return 1;
    if (String(id) === $ddbf117b5bbd0237$export$eacd29cf0034a277) return 0;
    return null;
};
const $ddbf117b5bbd0237$export$68945212e4117c8a = (id)=>$ddbf117b5bbd0237$export$3443c01481639bbd(id) ? 0 : id;
const $ddbf117b5bbd0237$export$708a949fe776caf7 = (list, space = null, depth = 1)=>(list || []).map((item)=>({
            ...item,
            space: item.space ?? space,
            depth: item.depth ?? depth,
            folderName: item.folderName,
            children: $ddbf117b5bbd0237$export$708a949fe776caf7(item.children || [], item.space ?? space, (item.depth ?? depth) + 1),
            childrenLoaded: !!item.childrenLoaded || Array.isArray(item.children),
            hasSubFolder: !!item.hasSubFolder || !!(item.children && item.children.length)
        }));
const $ddbf117b5bbd0237$export$64f3ec90105a8e1b = (list)=>(list || []).map((item)=>({
            ...item,
            hasSubFolder: !!item.hasSubFolder || !!(item.children && item.children.length),
            children: $ddbf117b5bbd0237$export$64f3ec90105a8e1b(item.children || [])
        }));
const $ddbf117b5bbd0237$export$c082e5337b142686 = (items, folderId)=>{
    for (const item of items || []){
        if (String(item.id) === String(folderId)) return item;
        const child = $ddbf117b5bbd0237$export$c082e5337b142686(item.children, folderId);
        if (child) return child;
    }
    return null;
};
const $ddbf117b5bbd0237$export$820665972310b71f = (items, folderId, parent = null)=>{
    for (const item of items || []){
        if (String(item.id) === String(folderId)) return parent;
        const found = $ddbf117b5bbd0237$export$820665972310b71f(item.children, folderId, item);
        if (found) return found;
    }
    return null;
};
const $ddbf117b5bbd0237$export$caaa409357ebd755 = (node, ids = [])=>{
    if (!node) return ids;
    ids.push(node.id);
    (node.children || []).forEach((child)=>$ddbf117b5bbd0237$export$caaa409357ebd755(child, ids));
    return ids;
};
const $ddbf117b5bbd0237$export$e1ada826a928cb52 = (space, children = [], labels = {})=>({
        id: $ddbf117b5bbd0237$export$d272400a1c36e538(space),
        space: space,
        folderName: space === 1 ? labels.team : labels.personal,
        children: children,
        childrenLoaded: true,
        hasSubFolder: children.length > 0,
        isRoot: true
    });
const $ddbf117b5bbd0237$export$740faeebd589392e = (search)=>{
    const params = new URLSearchParams(search);
    let folderId = params.get('folderId');
    const space = params.get('space');
    const parsedSpace = space === '0' || space === '1' ? Number(space) : null;
    if (folderId === '0' && parsedSpace === 0) folderId = $ddbf117b5bbd0237$export$eacd29cf0034a277;
    else if (folderId === '1' && parsedSpace === 1) folderId = $ddbf117b5bbd0237$export$2e99ffd4630f2b47;
    return {
        folderId: folderId,
        space: parsedSpace,
        isSample: folderId === $ddbf117b5bbd0237$export$21a9c047a6a86777
    };
};
const $ddbf117b5bbd0237$export$9f4acd03e2807387 = ({ currentFolderId: currentFolderId, currentFolderSpace: currentFolderSpace, urlFolderId: urlFolderId, urlSpace: urlSpace, options: options = {} })=>{
    let parentId = currentFolderId;
    let space = currentFolderSpace;
    const lastUrlFolderId = urlFolderId?.split(',').slice(-1)[0];
    if (lastUrlFolderId) parentId = lastUrlFolderId;
    if (options?.parentId !== undefined && options?.parentId !== null) parentId = options.parentId;
    if (parentId === $ddbf117b5bbd0237$export$21a9c047a6a86777) space = null;
    else {
        const rootSpace = $ddbf117b5bbd0237$export$c4f18cddb744f393(parentId);
        if (options?.space !== undefined) space = options.space;
        else if (rootSpace !== null) space = rootSpace;
        else if (urlSpace !== null) space = urlSpace;
    }
    return {
        displayFolderId: parentId,
        parentId: $ddbf117b5bbd0237$export$68945212e4117c8a(parentId),
        space: space
    };
};

});


parcelRegister("8I7XG", function(module, exports) {

$parcel$export(module.exports, "useListStore", () => $65789bd26f6a1839$export$7dd7d634a4ef95ac);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

var $i0TKe = parcelRequire("i0TKe");
const $65789bd26f6a1839$export$7dd7d634a4ef95ac = (0, $i0TKe.defineStore)('list', {
    state: ()=>({
            modelList: []
        }),
    actions: {
        handleTooltips () {
            (0, $TusQn.nextTick)(()=>{
                const tooltips = document.querySelectorAll('[data-mdb-tooltip-init]');
                tooltips.forEach((tooltip)=>{
                    let isTextTruncated = false;
                    const el = tooltip.firstElementChild;
                    const text = (el?.textContent || '').trim();
                    if (text) {
                        const range = document.createRange();
                        range.selectNodeContents(el);
                        const textWidth = range.getBoundingClientRect().width;
                        const boxWidth = tooltip.getBoundingClientRect().width;
                        isTextTruncated = textWidth > boxWidth;
                    }
                    if (!isTextTruncated) isTextTruncated = Math.max(tooltip.offsetWidth, tooltip.scrollWidth) > tooltip.clientWidth;
                    const tooltipInstance = mdb.Tooltip.getInstance(tooltip);
                    if (!isTextTruncated) {
                        tooltipInstance?.dispose();
                        tooltip.removeAttribute('title');
                        tooltip.removeAttribute('data-mdb-original-title');
                    } else if (!tooltipInstance) {
                        tooltip.setAttribute('title', tooltip.innerText);
                        new mdb.Tooltip(tooltip);
                    }
                });
            });
        }
    }
});

});

parcelRegister("6PUuc", function(module, exports) {

$parcel$export(module.exports, "useModalStore", () => $4fa3526f8081501f$export$cad361735e98db2a);

var $i0TKe = parcelRequire("i0TKe");
const $4fa3526f8081501f$export$cad361735e98db2a = (0, $i0TKe.defineStore)('modal', {
    state: ()=>({
            confirmInfo: {},
            uploadInfo: {}
        }),
    actions: {
        openModal (key = '', info = {}) {
            if (this[key]) this[key] = {
                visible: true,
                ...info
            };
        },
        closeModal (key = '') {
            if (this[key]) {
                this[key].onCancel?.();
                this[key] = {};
            }
        },
        async confirmModal (key = 'confirmInfo', params) {
            const onConfirm = this[key]?.onConfirm;
            if (onConfirm) try {
                const ignoreClose = await onConfirm(params);
                if (!ignoreClose) this.closeModal(key);
            } catch (error) {
                console.error(error);
            }
            else this.closeModal(key);
        }
    }
});

});

parcelRegister("gByFP", function(module, exports) {

$parcel$export(module.exports, "FILE_TYPES", () => $c16aff875b1b182a$export$feb1a34a99be61f9);
$parcel$export(module.exports, "SUPPORT_TYPES", () => $c16aff875b1b182a$export$d317bbb14816da6b);
$parcel$export(module.exports, "default", () => $c16aff875b1b182a$export$2e2bcd8739ae039);

var $5702Z = parcelRequire("5702Z");

var $cUvMp = parcelRequire("cUvMp");
parcelRequire("ilpIi");
var $9HrqM = parcelRequire("9HrqM");

var $kp7Te = parcelRequire("kp7Te");

var $dBwuy = parcelRequire("dBwuy");

var $ebHgd = parcelRequire("ebHgd");

var $3Jkin = parcelRequire("3Jkin");

var $f55LV = parcelRequire("f55LV");

var $4xroJ = parcelRequire("4xroJ");

var $hYjPp = parcelRequire("hYjPp");

var $90G9q = parcelRequire("90G9q");

var $h8sKa = parcelRequire("h8sKa");

var $iS8eH = parcelRequire("iS8eH");

var $lUp03 = parcelRequire("lUp03");
parcelRequire("fmRoT");
var $7we3r = parcelRequire("7we3r");

var $graZq = parcelRequire("graZq");
const $c16aff875b1b182a$export$feb1a34a99be61f9 = [
    'obj',
    'gltf',
    'glb',
    'fbx',
    'stl',
    'las',
    'xyz',
    'ply',
    'pcd',
    'e57',
    'ifc',
    'skp',
    'blend',
    'stp',
    'step',
    '3dm'
];
const $c16aff875b1b182a$export$d317bbb14816da6b = [
    'jpg',
    'png',
    'jpeg',
    'gif',
    'bmp',
    'webp',
    'tga',
    'tiff',
    'tif',
    'dds',
    'hdr',
    'exr',
    'bin',
    'sldprt',
    'sldasm',
    'xml',
    'prj',
    'csv',
    'json'
];
const $c16aff875b1b182a$export$c8de4b939e782b44 = 0.5;
const $c16aff875b1b182a$export$75c2114d2764d628 = 0.1;
const $c16aff875b1b182a$var$t = (0, $iS8eH.default).global.t;

class $c16aff875b1b182a$var$UploadFile {
    unsubscriber = null;
    queue = null;
    file = null;
    modelFile = null;
    mtlFile = null;
    serverFile = null;
    supportFiles = [];
    jpgMap = {};
    folderId = 0;
    space = null;
    name = '';
    type = '';
    isZip = false;
    isOriginal = false;
    fileKey = '';
    uploadKey = '';
    transformId = '';
    _status = 'waiting';
    get id() {
        return this.fileKey;
    }
    get isCloud() {
        return !this.isOriginal && [
            'las',
            'xyz',
            'ply',
            'pcd',
            'e57'
        ].includes(this.type);
    }
    get key() {
        const type = this.type === 'step' ? 'stp' : this.type;
        if (this.isCloud) return type ? `upload_cloud_${type}` : 'upload_cloud';
        if (this.serverType) return `upload_${this.serverType}_${type}`;
        return `upload_${type}`;
    }
    get mineType() {
        if (this.type === 'skp') return 'application/x-koan';
        return '';
    }
    get serverType() {
        if ([
            'skp',
            'blend',
            'stp',
            'step'
        ].includes(this.type)) return 'glb';
        return '';
    }
    get status() {
        return this._status;
    }
    set status(status = '') {
        const uploadStore = (0, $graZq.useUploadStore)();
        this._status = status;
        uploadStore.updateUploadingFile(this, {
            status: this._status
        });
    }
    constructor(queue, props = {}){
        this.queue = queue;
        this.file = props.file;
        this.modelFile = props.modelFile;
        this.mtlFile = props.mtlFile;
        this.supportFiles = props.supportFiles || [];
        this.folderId = props.folderId;
        this.space = props.space;
        this.name = props.name;
        this.type = props.type;
        this.isZip = !!props.isZip;
        this.fileKey = props.fileKey;
    }
    async getSize(file, zip) {
        let size = 0;
        if (this.isCloud) {
            if (!zip) zip = await (0, (/*@__PURE__*/$parcel$interopDefault($lUp03))).loadAsync(file);
            zip.forEach((_, f)=>{
                if (!f.dir) {
                    const s = f._data?.uncompressedSize || 0;
                    size += s;
                }
            });
            return size;
        }
        if (this.serverFile) size += this.serverFile.size;
        else if (this.modelFile) size += this.modelFile.size;
        for(let i = 0; i < this.supportFiles.length; i++){
            const f = this.supportFiles[i];
            if (f.file) size += f.file.size;
        }
        return size;
    }
    handleProgress(progress = {}, start = 0, ratio = 1) {
        const uploadStore = (0, $graZq.useUploadStore)();
        const { loaded: loaded = 0, total: total = 1 } = progress;
        uploadStore.updateUploadingFile(this, {
            percent: start + loaded / total * ratio
        });
    }
    handleError(msg = '') {
        if (this.checkActive()) {
            if (!navigator.onLine) (0, $cUvMp.ElMessage)({
                message: $c16aff875b1b182a$var$t('file.import.error.checkNet'),
                type: 'error'
            });
            else {
                const controller = new AbortController();
                const timer = setTimeout(()=>controller.abort(), 3000);
                fetch('https://scanat.app', {
                    mode: 'no-cors',
                    signal: controller.signal
                }).then(()=>{
                    if (msg) (0, $cUvMp.ElMessage)({
                        message: msg,
                        type: 'error'
                    });
                }).catch(()=>{
                    (0, $cUvMp.ElMessage)({
                        message: $c16aff875b1b182a$var$t('file.import.error.checkNet'),
                        type: 'error'
                    });
                }).finally(()=>clearTimeout(timer));
            }
        }
        this.status = 'error';
        this.queue?.queueOut(this);
        this.clearImages();
    }
    handleSuccess() {
        this.status = 'success';
        this.queue?.queueOut(this);
        this.clearImages();
    }
    handleSubscribe(transformId = '') {
        const uploadStore = (0, $graZq.useUploadStore)();
        uploadStore.updateUploadingFile(this, {
            transformId: transformId
        });
        this.transformId = transformId;
    }
    handleUnsubscribe() {
        const uploadStore = (0, $graZq.useUploadStore)();
        uploadStore.updateUploadingFile(this, {
            transformId: ''
        });
        this.transformId = '';
        this.unsubscriber?.();
        this.unsubscriber = null;
    }
    createImages() {
        this.clearImages();
        for(let i = 0; i < this.supportFiles.length; i++){
            const { name: name, file: file } = this.supportFiles[i];
            this.jpgMap[name] = URL.createObjectURL(file);
        }
    }
    clearImages() {
        const jpgKeys = Object.keys(this.jpgMap);
        if (jpgKeys.length > 0) {
            jpgKeys.forEach((key)=>URL.revokeObjectURL(this.jpgMap[key]));
            this.jpgMap = {};
        }
    }
    checkActive() {
        const active = this.queue?.uploadingFiles?.includes(this);
        if (!active && this.unsubscriber) this.handleUnsubscribe();
        return active;
    }
    async checkMTL() {
        if (this.mtlFile && this.checkActive()) {
            const mtlUrl = URL.createObjectURL(this.mtlFile);
            return new Promise((resolve)=>{
                new (0, $ebHgd.MTLLoader)().load(mtlUrl, async (materials)=>{
                    try {
                        await materials?.preload?.();
                        URL.revokeObjectURL(mtlUrl);
                        resolve(materials);
                    } catch  {
                        URL.revokeObjectURL(mtlUrl);
                        resolve(false);
                    }
                }, undefined, ()=>{
                    URL.revokeObjectURL(mtlUrl);
                    resolve(false);
                }, this.jpgMap);
            });
        }
        return false;
    }
    start() {
        this.analyze();
    }
    async analyze() {
        this.status = 'analyzing';
        this.handleProgress();
        if (this.modelFile && this.checkActive()) {
            if (this.isCloud) this.queue?.appendConvert(this);
            else {
                let loader, url;
                this.createImages();
                switch(this.type){
                    case 'obj':
                        if (this.mtlFile) {
                            const materials = await this.checkMTL();
                            if (materials) loader = new (0, $3Jkin.OBJLoader)().setMaterials(materials);
                        } else loader = new (0, $3Jkin.OBJLoader)();
                        break;
                    case 'gltf':
                    case 'glb':
                        loader = new (0, $f55LV.GLTFLoader)().setMeshoptDecoder((0, $kp7Te.MeshoptDecoder));
                        break;
                    case 'fbx':
                        loader = new (0, $4xroJ.FBXLoader)();
                        break;
                    case 'stl':
                        loader = new (0, $hYjPp.STLLoader)();
                        break;
                    case '3dm':
                        loader = new (0, $90G9q.Rhino3dmLoader)();
                        loader.setLibraryPath((0, $h8sKa.isLocal) ? 'https://localhost:5173/webModel/jsm/rhino3dm/' : '/webModel/jsm/rhino3dm/');
                        break;
                }
                if (this.checkActive()) {
                    if (loader) try {
                        url = URL.createObjectURL(this.modelFile);
                        loader.load(url, (o)=>{
                            if (url) URL.revokeObjectURL(url);
                            if (o?.children?.length || o?.scene?.children?.length || o?.attributes?.position?.count) {
                                this.upload();
                                this.clearImages();
                            } else this.handleError($c16aff875b1b182a$var$t('file.import.error.parsingFailed'));
                        }, (p)=>{
                            this.handleProgress(p, 0, $c16aff875b1b182a$export$c8de4b939e782b44);
                        }, ()=>{
                            if (url) URL.revokeObjectURL(url);
                            this.handleError($c16aff875b1b182a$var$t('file.import.error.parsingFailed'));
                        }, this.jpgMap);
                    } catch  {
                        if (url) URL.revokeObjectURL(url);
                        this.handleError($c16aff875b1b182a$var$t('file.import.error.parsingFailed'));
                    } finally{
                        loader = null;
                    }
                    else if (this.type === 'ifc') try {
                        loader = new (0, $5702Z.IfcAPI)();
                        await loader.Init((path, prefix)=>{
                            if (path?.includes('web-ifc.wasm')) return new URL((parcelRequire("boMKk"))).toString();
                            return `${prefix}${path}`;
                        });
                        this.handleProgress({
                            loaded: 0.5,
                            total: 1
                        }, 0, $c16aff875b1b182a$export$c8de4b939e782b44);
                        await (0, $h8sKa.sleep)(100);
                        const modelData = await this.modelFile.arrayBuffer();
                        this.handleProgress({
                            loaded: 1,
                            total: 1
                        }, 0, $c16aff875b1b182a$export$c8de4b939e782b44);
                        const modelId = loader.OpenModel(new Uint8Array(modelData));
                        if (modelId === -1) this.handleError($c16aff875b1b182a$var$t('file.import.error.parsingFailed'));
                        else {
                            this.upload();
                            this.clearImages();
                        }
                        loader.Dispose();
                    } catch (err) {
                        this.handleError($c16aff875b1b182a$var$t('file.import.error.parsingFailed'));
                    } finally{
                        loader = null;
                    }
                    else if (this.serverType) {
                        await this.loadFromServer();
                        if (this.serverFile) {
                            this.upload();
                            this.clearImages();
                        } else this.handleError();
                    } else this.handleError($c16aff875b1b182a$var$t('file.import.error.parsingFailed'));
                }
            }
        } else this.handleError($c16aff875b1b182a$var$t('file.import.error.parsingFailed'));
    }
    async transform(key, callback) {
        try {
            const convertRes = await (0, $h8sKa.request)(`webModels/convert?key=${key}`, {}, true);
            const transformId = convertRes?.data?.id;
            if (convertRes?.code === 200 && transformId !== undefined) {
                this.handleSubscribe(transformId);
                return new Promise(async (resolve)=>{
                    const userInfo = JSON.parse(sessionStorage.getItem('SCANAT_USER_INFO')) ?? {};
                    const userId = userInfo?.id;
                    if (userId) try {
                        const taskDoc = (0, $9HrqM.doc)((0, $dBwuy.db), 'modelConvert', `${userId}`, 'tasks', `${transformId}`);
                        await (0, $9HrqM.setDoc)(taskDoc, {
                            visitor: userId
                        }, {
                            merge: true
                        });
                        this.unsubscriber?.();
                        this.unsubscriber = (0, $9HrqM.onSnapshot)(taskDoc, async (doc)=>{
                            const { status: status = '', url: url = '' } = doc.data() || {};
                            switch(status){
                                case 'success':
                                    (0, $9HrqM.deleteDoc)(taskDoc);
                                    if (url) {
                                        const res = await fetch(url);
                                        const contentLength = res?.headers?.get('content-length');
                                        if (contentLength && res.status === 200 && res.ok) resolve({
                                            status: 'success',
                                            contentLength: contentLength,
                                            res: res
                                        });
                                        else resolve({
                                            status: 'error'
                                        });
                                    } else resolve({
                                        status: 'error'
                                    });
                                    break;
                                case 'fail':
                                    (0, $9HrqM.deleteDoc)(taskDoc);
                                    resolve({
                                        status: 'error'
                                    });
                                    break;
                                case 'processing':
                                    callback?.({
                                        loaded: 0.2,
                                        total: 1
                                    });
                                    break;
                            }
                        });
                    } catch (err) {
                        console.error(err);
                        resolve({
                            status: 'error'
                        });
                    }
                    else {
                        console.error('user not found');
                        resolve({
                            status: 'error'
                        });
                    }
                });
            } else return {
                status: 'error'
            };
        } catch (err) {
            console.error(err);
            return {
                status: 'error'
            };
        }
    }
    async download(key = '', callback) {
        try {
            if (!key || !this.checkActive()) return null;
            const { status: status, contentLength: contentLength, res: downloadRes } = await this.transform(key, callback);
            if (status === 'success') {
                const total = parseInt(contentLength, 10);
                let loaded = 0;
                const res = new Response(new ReadableStream({
                    start (controller) {
                        const reader = downloadRes.body?.getReader();
                        async function push() {
                            const { done: done, value: value } = await reader?.read();
                            if (done) {
                                controller.close();
                                return;
                            }
                            loaded += value.byteLength;
                            controller.enqueue(value);
                            callback?.({
                                loaded: (total + loaded) / 2,
                                total: total
                            });
                            push();
                        }
                        push();
                    }
                }));
                const blob = await res.blob();
                blob.name = `${this.name}.${this.serverType || this.type}`;
                return blob;
            }
            return null;
        } catch  {
            return null;
        } finally{
            this.handleUnsubscribe();
        }
    }
    async loadFromServer(file, fileType) {
        try {
            const zipPercent = $c16aff875b1b182a$export$c8de4b939e782b44 / 4;
            const uploadPercent = $c16aff875b1b182a$export$c8de4b939e782b44 / 2;
            this.serverFile = null;
            if (!this.checkActive()) return;
            if (!file) file = this.modelFile;
            if (!fileType) fileType = this.type === 'step' ? 'stp' : this.type;
            const transformRes = await (0, $h8sKa.request)('webModels/uploadTransform', {
                fileType: fileType,
                timestamp: Date.now()
            }, true, 'GET');
            if (transformRes?.code === 200 && transformRes?.data) {
                const uploadRes = await (0, $7we3r.default)({
                    url: transformRes.data.url,
                    method: 'PUT',
                    data: file,
                    headers: {
                        'Content-type': 'application/octet-stream'
                    },
                    onUploadProgress: (p)=>{
                        this.handleProgress(p, zipPercent, uploadPercent);
                    }
                });
                if (uploadRes?.status === 200) {
                    const ratio = $c16aff875b1b182a$export$c8de4b939e782b44 - zipPercent - uploadPercent;
                    this.serverFile = await this.download(transformRes.data.key, ({ total: total, loaded: loaded })=>{
                        this.handleProgress({
                            loaded: loaded,
                            total: total
                        }, zipPercent + uploadPercent, ratio);
                    });
                    if (!this.serverFile) {
                        this.handleError($c16aff875b1b182a$var$t('file.import.error.system'));
                        return;
                    }
                }
            }
        } catch  {
            this.handleError($c16aff875b1b182a$var$t('file.import.error.system'));
        }
    }
    async originalUpload() {
        this.isOriginal = true;
        this.upload();
    }
    async upload(file) {
        try {
            if (!this.checkActive()) return;
            this.status = 'uploading';
            let isServer = false;
            if (!file) {
                if (this.serverFile) {
                    file = this.serverFile;
                    isServer = true;
                } else file = this.file;
            }
            let zip;
            if (this.isCloud) {
                if (this.supportFiles.length > 0) zip = await (0, (/*@__PURE__*/$parcel$interopDefault($lUp03))).loadAsync(file);
            } else if (!this.isZip || isServer) {
                zip = new (0, (/*@__PURE__*/$parcel$interopDefault($lUp03)))();
                const folder = zip.folder(this.key);
                folder.file(file.name, file);
            }
            if (zip) {
                this.supportFiles.forEach((item)=>{
                    zip.file(`${this.key}/${item.name}`, item.file);
                });
                file = await zip.generateAsync({
                    type: 'blob',
                    compression: 'DEFLATE',
                    compressionOptions: {
                        level: 3
                    }
                }, (info)=>{
                    this.handleProgress({
                        loaded: info?.percent || 0,
                        total: 100
                    }, $c16aff875b1b182a$export$c8de4b939e782b44, $c16aff875b1b182a$export$75c2114d2764d628);
                });
            }
            if (!this.uploadKey) {
                const res = await (0, $h8sKa.request)('webModels/requestFileKey', {}, true, 'GET');
                if (res.code === 200 && res.data) this.uploadKey = res.data;
            }
            if (this.uploadKey) {
                const res = await (0, $h8sKa.request)('webModels/uploadModel', {
                    fileKey: this.uploadKey,
                    timestamp: Date.now()
                }, true, 'GET');
                if (res.code === 200 && res.data?.url) {
                    const uploadRes = await (0, $7we3r.default)({
                        url: res.data.url,
                        method: 'PUT',
                        data: file,
                        headers: {
                            'Content-Type': 'application/zip'
                        },
                        onUploadProgress: (p)=>{
                            this.handleProgress(p, $c16aff875b1b182a$export$c8de4b939e782b44 + $c16aff875b1b182a$export$75c2114d2764d628, 1 - $c16aff875b1b182a$export$c8de4b939e782b44 - $c16aff875b1b182a$export$75c2114d2764d628);
                        }
                    });
                    if (uploadRes?.status === 200) {
                        const size = await this.getSize(file, zip);
                        await this.addModel(size);
                        return;
                    }
                }
            }
            this.handleError($c16aff875b1b182a$var$t('file.import.error.system'));
        } catch (err) {
            console.error(err);
            this.handleError($c16aff875b1b182a$var$t('file.import.error.system'));
        }
    }
    async addModel(size) {
        try {
            const res = await (0, $h8sKa.request)(`webModels/spaces/${this.space}/importModel`, {
                fileKey: this.uploadKey,
                fileName: this.name,
                fileSize: size,
                modelType: this.isCloud ? 'cloud' : this.serverType || this.type,
                originType: this.isZip ? 'zip' : this.type,
                parentId: this.folderId == 0 ? null : this.folderId
            }, true, 'PUT');
            if (res?.code === 200) this.handleSuccess();
            else this.handleError($c16aff875b1b182a$var$t('file.import.error.system'));
        } catch  {
            this.handleError($c16aff875b1b182a$var$t('file.import.error.system'));
        }
    }
}

class $c16aff875b1b182a$var$UploadQueue {
    worker = null;
    MAX_UPLOADING_COUNT = 3;
    queueFiles = [];
    uploadingFiles = [];
    canConvert = false;
    convertFiles = [];
    convertingFile = null;
    init() {
        this.worker = new Worker((parcelRequire("hBtug")));
        this.worker.postMessage({
            type: 'init'
        });
        this.worker.onmessage = this.handleConvert.bind(this);
    }
    clear() {
        this.queueFiles = [];
        this.uploadingFiles = [];
        this.canConvert = false;
        this.convertFiles = [];
        this.convertingFile = null;
        if (this.worker) {
            this.worker.terminate();
            this.worker = null;
        }
    }
    appendQueue(files = [], lazyStart = false) {
        this.queueFiles.push(...files.map((f)=>f instanceof $c16aff875b1b182a$var$UploadFile ? f : new $c16aff875b1b182a$var$UploadFile(this, f)));
        if (lazyStart) setTimeout(()=>this.startQueue(), 500);
        else this.startQueue();
    }
    queueOut(file) {
        this.queueFiles = this.queueFiles.filter((f)=>f !== file);
        this.uploadingFiles = this.uploadingFiles.filter((f)=>f !== file);
        this.startQueue();
    }
    startQueue() {
        const count = this.MAX_UPLOADING_COUNT - this.uploadingFiles.length;
        const files = this.queueFiles.splice(0, count);
        this.uploadingFiles.push(...files);
        files.forEach((f)=>f.start());
    }
    appendConvert(file) {
        if (this.convertFiles.includes(file)) return;
        this.convertFiles.push(file);
        this.startConvert();
    }
    endConvert() {
        if (this.convertingFile) {
            this.convertFiles = this.convertFiles.filter((f)=>f !== this.convertingFile);
            this.convertingFile = null;
            this.startConvert();
        }
    }
    startConvert() {
        if (!this.convertingFile && this.canConvert) {
            this.convertingFile = this.convertFiles.shift();
            if (this.convertingFile) {
                this.worker.postMessage({
                    type: 'key',
                    key: this.convertingFile.key,
                    fileType: this.convertingFile.type?.toLowerCase()
                });
                const reader = new FileReader();
                reader.onload = (e)=>{
                    const data = new Uint8Array(e.target.result);
                    this.worker.postMessage(data.buffer, [
                        data.buffer
                    ]);
                };
                reader.onerror = ()=>{
                    this.convertingFile?.handleError?.($c16aff875b1b182a$var$t('file.import.error.parsingFailed'));
                    this.endConvert();
                };
                reader.readAsArrayBuffer(this.convertingFile.modelFile);
            }
        }
    }
    handleConvert(event) {
        const data = event.data;
        if (data instanceof ArrayBuffer) {
            this.convertingFile?.upload?.(new Blob([
                data
            ], {
                type: 'application/zip'
            }));
            this.endConvert();
        } else {
            const { type: type } = data || {};
            switch(type){
                case 'progress':
                    const p = data?.progress <= 1 ? data.progress : 1;
                    if (data?.progressType === 'zip') this.convertingFile?.handleProgress?.({
                        total: 1,
                        loaded: p
                    }, $c16aff875b1b182a$export$c8de4b939e782b44, $c16aff875b1b182a$export$75c2114d2764d628);
                    else this.convertingFile?.handleProgress?.({
                        total: 1,
                        loaded: p
                    }, 0, $c16aff875b1b182a$export$c8de4b939e782b44);
                    break;
                case 'no-need-convert':
                    this.convertingFile?.originalUpload?.();
                    this.endConvert();
                    break;
                case 'error':
                    this.convertingFile?.handleError?.($c16aff875b1b182a$var$t('file.import.error.parsingFailed'));
                    this.endConvert();
                    break;
                case 'initialized':
                    this.canConvert = true;
                    this.startConvert();
                    break;
            }
        }
    }
}
var $c16aff875b1b182a$export$2e2bcd8739ae039 = new $c16aff875b1b182a$var$UploadQueue();

});
parcelRegister("5702Z", function(module, exports) {

$parcel$export(module.exports, "IfcAPI", () => $3b8da494b8e92f36$export$851bf40c76520248);
var $3b8da494b8e92f36$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $3b8da494b8e92f36$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$3b8da494b8e92f36$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
// dist/web-ifc-mt.js
var $3b8da494b8e92f36$var$require_web_ifc_mt = $3b8da494b8e92f36$var$__commonJS({
    "dist/web-ifc-mt.js" (exports, module) {
        "use strict";
        var WebIFCWasm2 = (()=>{
            var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;
            return function(moduleArg = {}) {
                function GROWABLE_HEAP_I8() {
                    if (wasmMemory.buffer != HEAP8.buffer) updateMemoryViews();
                    return HEAP8;
                }
                function GROWABLE_HEAP_U8() {
                    if (wasmMemory.buffer != HEAP8.buffer) updateMemoryViews();
                    return HEAPU8;
                }
                function GROWABLE_HEAP_I16() {
                    if (wasmMemory.buffer != HEAP8.buffer) updateMemoryViews();
                    return HEAP16;
                }
                function GROWABLE_HEAP_U16() {
                    if (wasmMemory.buffer != HEAP8.buffer) updateMemoryViews();
                    return HEAPU16;
                }
                function GROWABLE_HEAP_I32() {
                    if (wasmMemory.buffer != HEAP8.buffer) updateMemoryViews();
                    return HEAP32;
                }
                function GROWABLE_HEAP_U32() {
                    if (wasmMemory.buffer != HEAP8.buffer) updateMemoryViews();
                    return HEAPU32;
                }
                function GROWABLE_HEAP_F32() {
                    if (wasmMemory.buffer != HEAP8.buffer) updateMemoryViews();
                    return HEAPF32;
                }
                function GROWABLE_HEAP_F64() {
                    if (wasmMemory.buffer != HEAP8.buffer) updateMemoryViews();
                    return HEAPF64;
                }
                var Module = moduleArg;
                var readyPromiseResolve, readyPromiseReject;
                Module["ready"] = new Promise((resolve, reject)=>{
                    readyPromiseResolve = resolve;
                    readyPromiseReject = reject;
                });
                var moduleOverrides = Object.assign({}, Module);
                var arguments_ = [];
                var thisProgram = "./this.program";
                var quit_ = (status, toThrow)=>{
                    throw toThrow;
                };
                var ENVIRONMENT_IS_WEB = typeof window == "object";
                var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
                var ENVIRONMENT_IS_NODE = false;
                var ENVIRONMENT_IS_PTHREAD = Module["ENVIRONMENT_IS_PTHREAD"] || false;
                var scriptDirectory = "";
                function locateFile(path) {
                    if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
                    return scriptDirectory + path;
                }
                var read_, readAsync, readBinary, setWindowTitle;
                if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
                    if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
                    else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
                    if (_scriptDir) scriptDirectory = _scriptDir;
                    if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
                    else scriptDirectory = "";
                    read_ = (url)=>{
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, false);
                        xhr.send(null);
                        return xhr.responseText;
                    };
                    if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, false);
                        xhr.responseType = "arraybuffer";
                        xhr.send(null);
                        return new Uint8Array(xhr.response);
                    };
                    readAsync = (url, onload, onerror)=>{
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, true);
                        xhr.responseType = "arraybuffer";
                        xhr.onload = ()=>{
                            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                                onload(xhr.response);
                                return;
                            }
                            onerror();
                        };
                        xhr.onerror = onerror;
                        xhr.send(null);
                    };
                    setWindowTitle = (title)=>document.title = title;
                }
                var out = Module["print"] || console.log.bind(console);
                var err = Module["printErr"] || console.error.bind(console);
                Object.assign(Module, moduleOverrides);
                moduleOverrides = null;
                if (Module["arguments"]) arguments_ = Module["arguments"];
                if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
                if (Module["quit"]) quit_ = Module["quit"];
                var wasmBinary;
                if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
                var noExitRuntime = Module["noExitRuntime"] || true;
                if (typeof WebAssembly != "object") abort("no native wasm support detected");
                var wasmMemory;
                var wasmExports;
                var wasmModule;
                var ABORT = false;
                var EXITSTATUS;
                function assert(condition, text) {
                    if (!condition) abort(text);
                }
                var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
                function updateMemoryViews() {
                    var b = wasmMemory.buffer;
                    Module["HEAP8"] = HEAP8 = new Int8Array(b);
                    Module["HEAP16"] = HEAP16 = new Int16Array(b);
                    Module["HEAP32"] = HEAP32 = new Int32Array(b);
                    Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
                    Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
                    Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
                    Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
                    Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
                }
                var INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
                assert(INITIAL_MEMORY >= 5242880, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + INITIAL_MEMORY + "! (STACK_SIZE=5242880)");
                if (ENVIRONMENT_IS_PTHREAD) wasmMemory = Module["wasmMemory"];
                else if (Module["wasmMemory"]) wasmMemory = Module["wasmMemory"];
                else {
                    wasmMemory = new WebAssembly.Memory({
                        "initial": INITIAL_MEMORY / 65536,
                        "maximum": 65536,
                        "shared": true
                    });
                    if (!(wasmMemory.buffer instanceof SharedArrayBuffer)) {
                        err("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag");
                        if (ENVIRONMENT_IS_NODE) err("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)");
                        throw Error("bad memory");
                    }
                }
                updateMemoryViews();
                INITIAL_MEMORY = wasmMemory.buffer.byteLength;
                var wasmTable;
                var __ATPRERUN__ = [];
                var __ATINIT__ = [];
                var __ATPOSTRUN__ = [];
                var runtimeInitialized = false;
                var runtimeKeepaliveCounter = 0;
                function keepRuntimeAlive() {
                    return noExitRuntime || runtimeKeepaliveCounter > 0;
                }
                function preRun() {
                    if (Module["preRun"]) {
                        if (typeof Module["preRun"] == "function") Module["preRun"] = [
                            Module["preRun"]
                        ];
                        while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
                    }
                    callRuntimeCallbacks(__ATPRERUN__);
                }
                function initRuntime() {
                    runtimeInitialized = true;
                    if (ENVIRONMENT_IS_PTHREAD) return;
                    if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
                    FS.ignorePermissions = false;
                    TTY.init();
                    callRuntimeCallbacks(__ATINIT__);
                }
                function postRun() {
                    if (ENVIRONMENT_IS_PTHREAD) return;
                    if (Module["postRun"]) {
                        if (typeof Module["postRun"] == "function") Module["postRun"] = [
                            Module["postRun"]
                        ];
                        while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
                    }
                    callRuntimeCallbacks(__ATPOSTRUN__);
                }
                function addOnPreRun(cb) {
                    __ATPRERUN__.unshift(cb);
                }
                function addOnInit(cb) {
                    __ATINIT__.unshift(cb);
                }
                function addOnPostRun(cb) {
                    __ATPOSTRUN__.unshift(cb);
                }
                var runDependencies = 0;
                var runDependencyWatcher = null;
                var dependenciesFulfilled = null;
                function getUniqueRunDependency(id) {
                    return id;
                }
                function addRunDependency(id) {
                    runDependencies++;
                    if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
                }
                function removeRunDependency(id) {
                    runDependencies--;
                    if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
                    if (runDependencies == 0) {
                        if (runDependencyWatcher !== null) {
                            clearInterval(runDependencyWatcher);
                            runDependencyWatcher = null;
                        }
                        if (dependenciesFulfilled) {
                            var callback = dependenciesFulfilled;
                            dependenciesFulfilled = null;
                            callback();
                        }
                    }
                }
                function abort(what) {
                    if (Module["onAbort"]) Module["onAbort"](what);
                    what = "Aborted(" + what + ")";
                    err(what);
                    ABORT = true;
                    EXITSTATUS = 1;
                    what += ". Build with -sASSERTIONS for more info.";
                    var e = new WebAssembly.RuntimeError(what);
                    readyPromiseReject(e);
                    throw e;
                }
                var dataURIPrefix = "data:application/octet-stream;base64,";
                function isDataURI(filename) {
                    return filename.startsWith(dataURIPrefix);
                }
                var wasmBinaryFile;
                wasmBinaryFile = "web-ifc-mt.wasm";
                if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
                function getBinarySync(file) {
                    if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
                    if (readBinary) return readBinary(file);
                    throw "both async and sync fetching of the wasm failed";
                }
                function getBinaryPromise(binaryFile) {
                    if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
                        if (typeof fetch == "function") return fetch(binaryFile, {
                            credentials: "same-origin"
                        }).then((response)=>{
                            if (!response["ok"]) throw "failed to load wasm binary file at '" + binaryFile + "'";
                            return response["arrayBuffer"]();
                        }).catch(()=>getBinarySync(binaryFile));
                    }
                    return Promise.resolve().then(()=>getBinarySync(binaryFile));
                }
                function instantiateArrayBuffer(binaryFile, imports, receiver) {
                    return getBinaryPromise(binaryFile).then((binary)=>WebAssembly.instantiate(binary, imports)).then((instance)=>instance).then(receiver, (reason)=>{
                        err("failed to asynchronously prepare wasm: " + reason);
                        abort(reason);
                    });
                }
                function instantiateAsync(binary, binaryFile, imports, callback) {
                    if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") return fetch(binaryFile, {
                        credentials: "same-origin"
                    }).then((response)=>{
                        var result = WebAssembly.instantiateStreaming(response, imports);
                        return result.then(callback, function(reason) {
                            err("wasm streaming compile failed: " + reason);
                            err("falling back to ArrayBuffer instantiation");
                            return instantiateArrayBuffer(binaryFile, imports, callback);
                        });
                    });
                    return instantiateArrayBuffer(binaryFile, imports, callback);
                }
                function createWasm() {
                    var info = {
                        "a": wasmImports
                    };
                    function receiveInstance(instance, module2) {
                        var exports2 = instance.exports;
                        exports2 = applySignatureConversions(exports2);
                        wasmExports = exports2;
                        registerTLSInit(wasmExports["oa"]);
                        wasmTable = wasmExports["na"];
                        addOnInit(wasmExports["ja"]);
                        wasmModule = module2;
                        removeRunDependency("wasm-instantiate");
                        return exports2;
                    }
                    addRunDependency("wasm-instantiate");
                    function receiveInstantiationResult(result) {
                        receiveInstance(result["instance"], result["module"]);
                    }
                    if (Module["instantiateWasm"]) try {
                        return Module["instantiateWasm"](info, receiveInstance);
                    } catch (e) {
                        err("Module.instantiateWasm callback failed with error: " + e);
                        readyPromiseReject(e);
                    }
                    instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
                    return {};
                }
                var tempDouble;
                var tempI64;
                function ExitStatus(status) {
                    this.name = "ExitStatus";
                    this.message = `Program terminated with exit(${status})`;
                    this.status = status;
                }
                var terminateWorker = function(worker) {
                    worker.terminate();
                    worker.onmessage = (e)=>{};
                };
                function killThread(pthread_ptr) {
                    var worker = PThread.pthreads[pthread_ptr];
                    delete PThread.pthreads[pthread_ptr];
                    terminateWorker(worker);
                    __emscripten_thread_free_data(pthread_ptr);
                    PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1);
                    worker.pthread_ptr = 0;
                }
                function cancelThread(pthread_ptr) {
                    var worker = PThread.pthreads[pthread_ptr];
                    worker.postMessage({
                        "cmd": "cancel"
                    });
                }
                function cleanupThread(pthread_ptr) {
                    var worker = PThread.pthreads[pthread_ptr];
                    assert(worker);
                    PThread.returnWorkerToPool(worker);
                }
                function spawnThread(threadParams) {
                    var worker = PThread.getNewWorker();
                    if (!worker) return 6;
                    PThread.runningWorkers.push(worker);
                    PThread.pthreads[threadParams.pthread_ptr] = worker;
                    worker.pthread_ptr = threadParams.pthread_ptr;
                    var msg = {
                        "cmd": "run",
                        "start_routine": threadParams.startRoutine,
                        "arg": threadParams.arg,
                        "pthread_ptr": threadParams.pthread_ptr
                    };
                    worker.postMessage(msg, threadParams.transferList);
                    return 0;
                }
                var PATH = {
                    isAbs: (path)=>path.charAt(0) === "/",
                    splitPath: (filename)=>{
                        var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                        return splitPathRe.exec(filename).slice(1);
                    },
                    normalizeArray: (parts, allowAboveRoot)=>{
                        var up = 0;
                        for(var i = parts.length - 1; i >= 0; i--){
                            var last = parts[i];
                            if (last === ".") parts.splice(i, 1);
                            else if (last === "..") {
                                parts.splice(i, 1);
                                up++;
                            } else if (up) {
                                parts.splice(i, 1);
                                up--;
                            }
                        }
                        if (allowAboveRoot) for(; up; up--)parts.unshift("..");
                        return parts;
                    },
                    normalize: (path)=>{
                        var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
                        path = PATH.normalizeArray(path.split("/").filter((p)=>!!p), !isAbsolute).join("/");
                        if (!path && !isAbsolute) path = ".";
                        if (path && trailingSlash) path += "/";
                        return (isAbsolute ? "/" : "") + path;
                    },
                    dirname: (path)=>{
                        var result = PATH.splitPath(path), root = result[0], dir = result[1];
                        if (!root && !dir) return ".";
                        if (dir) dir = dir.substr(0, dir.length - 1);
                        return root + dir;
                    },
                    basename: (path)=>{
                        if (path === "/") return "/";
                        path = PATH.normalize(path);
                        path = path.replace(/\/$/, "");
                        var lastSlash = path.lastIndexOf("/");
                        if (lastSlash === -1) return path;
                        return path.substr(lastSlash + 1);
                    },
                    join: function() {
                        var paths = Array.prototype.slice.call(arguments);
                        return PATH.normalize(paths.join("/"));
                    },
                    join2: (l, r)=>PATH.normalize(l + "/" + r)
                };
                var initRandomFill = ()=>{
                    if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") return (view)=>(view.set(crypto.getRandomValues(new Uint8Array(view.byteLength))), view);
                    else abort("initRandomDevice");
                };
                var randomFill = (view)=>(randomFill = initRandomFill())(view);
                var PATH_FS = {
                    resolve: function() {
                        var resolvedPath = "", resolvedAbsolute = false;
                        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
                            var path = i >= 0 ? arguments[i] : FS.cwd();
                            if (typeof path != "string") throw new TypeError("Arguments to path.resolve must be strings");
                            else if (!path) return "";
                            resolvedPath = path + "/" + resolvedPath;
                            resolvedAbsolute = PATH.isAbs(path);
                        }
                        resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
                        return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
                    },
                    relative: (from, to)=>{
                        from = PATH_FS.resolve(from).substr(1);
                        to = PATH_FS.resolve(to).substr(1);
                        function trim(arr) {
                            var start = 0;
                            for(; start < arr.length; start++){
                                if (arr[start] !== "") break;
                            }
                            var end = arr.length - 1;
                            for(; end >= 0; end--){
                                if (arr[end] !== "") break;
                            }
                            if (start > end) return [];
                            return arr.slice(start, end - start + 1);
                        }
                        var fromParts = trim(from.split("/"));
                        var toParts = trim(to.split("/"));
                        var length = Math.min(fromParts.length, toParts.length);
                        var samePartsLength = length;
                        for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
                            samePartsLength = i;
                            break;
                        }
                        var outputParts = [];
                        for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
                        outputParts = outputParts.concat(toParts.slice(samePartsLength));
                        return outputParts.join("/");
                    }
                };
                var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;
                var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead)=>{
                    idx >>>= 0;
                    var endIdx = idx + maxBytesToRead;
                    var endPtr = idx;
                    while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
                    if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) return UTF8Decoder.decode(heapOrArray.buffer instanceof SharedArrayBuffer ? heapOrArray.slice(idx, endPtr) : heapOrArray.subarray(idx, endPtr));
                    var str = "";
                    while(idx < endPtr){
                        var u0 = heapOrArray[idx++];
                        if (!(u0 & 128)) {
                            str += String.fromCharCode(u0);
                            continue;
                        }
                        var u1 = heapOrArray[idx++] & 63;
                        if ((u0 & 224) == 192) {
                            str += String.fromCharCode((u0 & 31) << 6 | u1);
                            continue;
                        }
                        var u2 = heapOrArray[idx++] & 63;
                        if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                        else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
                        if (u0 < 65536) str += String.fromCharCode(u0);
                        else {
                            var ch = u0 - 65536;
                            str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                        }
                    }
                    return str;
                };
                var FS_stdin_getChar_buffer = [];
                var lengthBytesUTF8 = (str)=>{
                    var len = 0;
                    for(var i = 0; i < str.length; ++i){
                        var c = str.charCodeAt(i);
                        if (c <= 127) len++;
                        else if (c <= 2047) len += 2;
                        else if (c >= 55296 && c <= 57343) {
                            len += 4;
                            ++i;
                        } else len += 3;
                    }
                    return len;
                };
                var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite)=>{
                    outIdx >>>= 0;
                    if (!(maxBytesToWrite > 0)) return 0;
                    var startIdx = outIdx;
                    var endIdx = outIdx + maxBytesToWrite - 1;
                    for(var i = 0; i < str.length; ++i){
                        var u = str.charCodeAt(i);
                        if (u >= 55296 && u <= 57343) {
                            var u1 = str.charCodeAt(++i);
                            u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                        }
                        if (u <= 127) {
                            if (outIdx >= endIdx) break;
                            heap[outIdx++ >>> 0] = u;
                        } else if (u <= 2047) {
                            if (outIdx + 1 >= endIdx) break;
                            heap[outIdx++ >>> 0] = 192 | u >> 6;
                            heap[outIdx++ >>> 0] = 128 | u & 63;
                        } else if (u <= 65535) {
                            if (outIdx + 2 >= endIdx) break;
                            heap[outIdx++ >>> 0] = 224 | u >> 12;
                            heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
                            heap[outIdx++ >>> 0] = 128 | u & 63;
                        } else {
                            if (outIdx + 3 >= endIdx) break;
                            heap[outIdx++ >>> 0] = 240 | u >> 18;
                            heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
                            heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
                            heap[outIdx++ >>> 0] = 128 | u & 63;
                        }
                    }
                    heap[outIdx >>> 0] = 0;
                    return outIdx - startIdx;
                };
                function intArrayFromString(stringy, dontAddNull, length) {
                    var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
                    var u8array = new Array(len);
                    var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
                    if (dontAddNull) u8array.length = numBytesWritten;
                    return u8array;
                }
                var FS_stdin_getChar = ()=>{
                    if (!FS_stdin_getChar_buffer.length) {
                        var result = null;
                        if (typeof window != "undefined" && typeof window.prompt == "function") {
                            result = window.prompt("Input: ");
                            if (result !== null) result += "\n";
                        } else if (typeof readline == "function") {
                            result = readline();
                            if (result !== null) result += "\n";
                        }
                        if (!result) return null;
                        FS_stdin_getChar_buffer = intArrayFromString(result, true);
                    }
                    return FS_stdin_getChar_buffer.shift();
                };
                var TTY = {
                    ttys: [],
                    init: function() {},
                    shutdown: function() {},
                    register: function(dev, ops) {
                        TTY.ttys[dev] = {
                            input: [],
                            output: [],
                            ops: ops
                        };
                        FS.registerDevice(dev, TTY.stream_ops);
                    },
                    stream_ops: {
                        open: function(stream) {
                            var tty = TTY.ttys[stream.node.rdev];
                            if (!tty) throw new FS.ErrnoError(43);
                            stream.tty = tty;
                            stream.seekable = false;
                        },
                        close: function(stream) {
                            stream.tty.ops.fsync(stream.tty);
                        },
                        fsync: function(stream) {
                            stream.tty.ops.fsync(stream.tty);
                        },
                        read: function(stream, buffer, offset, length, pos) {
                            if (!stream.tty || !stream.tty.ops.get_char) throw new FS.ErrnoError(60);
                            var bytesRead = 0;
                            for(var i = 0; i < length; i++){
                                var result;
                                try {
                                    result = stream.tty.ops.get_char(stream.tty);
                                } catch (e) {
                                    throw new FS.ErrnoError(29);
                                }
                                if (result === void 0 && bytesRead === 0) throw new FS.ErrnoError(6);
                                if (result === null || result === void 0) break;
                                bytesRead++;
                                buffer[offset + i] = result;
                            }
                            if (bytesRead) stream.node.timestamp = Date.now();
                            return bytesRead;
                        },
                        write: function(stream, buffer, offset, length, pos) {
                            if (!stream.tty || !stream.tty.ops.put_char) throw new FS.ErrnoError(60);
                            try {
                                for(var i = 0; i < length; i++)stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                            } catch (e) {
                                throw new FS.ErrnoError(29);
                            }
                            if (length) stream.node.timestamp = Date.now();
                            return i;
                        }
                    },
                    default_tty_ops: {
                        get_char: function(tty) {
                            return FS_stdin_getChar();
                        },
                        put_char: function(tty, val) {
                            if (val === null || val === 10) {
                                out(UTF8ArrayToString(tty.output, 0));
                                tty.output = [];
                            } else if (val != 0) tty.output.push(val);
                        },
                        fsync: function(tty) {
                            if (tty.output && tty.output.length > 0) {
                                out(UTF8ArrayToString(tty.output, 0));
                                tty.output = [];
                            }
                        },
                        ioctl_tcgets: function(tty) {
                            return {
                                c_iflag: 25856,
                                c_oflag: 5,
                                c_cflag: 191,
                                c_lflag: 35387,
                                c_cc: [
                                    3,
                                    28,
                                    127,
                                    21,
                                    4,
                                    0,
                                    1,
                                    0,
                                    17,
                                    19,
                                    26,
                                    0,
                                    18,
                                    15,
                                    23,
                                    22,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            };
                        },
                        ioctl_tcsets: function(tty, optional_actions, data) {
                            return 0;
                        },
                        ioctl_tiocgwinsz: function(tty) {
                            return [
                                24,
                                80
                            ];
                        }
                    },
                    default_tty1_ops: {
                        put_char: function(tty, val) {
                            if (val === null || val === 10) {
                                err(UTF8ArrayToString(tty.output, 0));
                                tty.output = [];
                            } else if (val != 0) tty.output.push(val);
                        },
                        fsync: function(tty) {
                            if (tty.output && tty.output.length > 0) {
                                err(UTF8ArrayToString(tty.output, 0));
                                tty.output = [];
                            }
                        }
                    }
                };
                var mmapAlloc = (size)=>{
                    abort();
                };
                var MEMFS = {
                    ops_table: null,
                    mount (mount) {
                        return MEMFS.createNode(null, "/", 16895, 0);
                    },
                    createNode (parent, name, mode, dev) {
                        if (FS.isBlkdev(mode) || FS.isFIFO(mode)) throw new FS.ErrnoError(63);
                        if (!MEMFS.ops_table) MEMFS.ops_table = {
                            dir: {
                                node: {
                                    getattr: MEMFS.node_ops.getattr,
                                    setattr: MEMFS.node_ops.setattr,
                                    lookup: MEMFS.node_ops.lookup,
                                    mknod: MEMFS.node_ops.mknod,
                                    rename: MEMFS.node_ops.rename,
                                    unlink: MEMFS.node_ops.unlink,
                                    rmdir: MEMFS.node_ops.rmdir,
                                    readdir: MEMFS.node_ops.readdir,
                                    symlink: MEMFS.node_ops.symlink
                                },
                                stream: {
                                    llseek: MEMFS.stream_ops.llseek
                                }
                            },
                            file: {
                                node: {
                                    getattr: MEMFS.node_ops.getattr,
                                    setattr: MEMFS.node_ops.setattr
                                },
                                stream: {
                                    llseek: MEMFS.stream_ops.llseek,
                                    read: MEMFS.stream_ops.read,
                                    write: MEMFS.stream_ops.write,
                                    allocate: MEMFS.stream_ops.allocate,
                                    mmap: MEMFS.stream_ops.mmap,
                                    msync: MEMFS.stream_ops.msync
                                }
                            },
                            link: {
                                node: {
                                    getattr: MEMFS.node_ops.getattr,
                                    setattr: MEMFS.node_ops.setattr,
                                    readlink: MEMFS.node_ops.readlink
                                },
                                stream: {}
                            },
                            chrdev: {
                                node: {
                                    getattr: MEMFS.node_ops.getattr,
                                    setattr: MEMFS.node_ops.setattr
                                },
                                stream: FS.chrdev_stream_ops
                            }
                        };
                        var node = FS.createNode(parent, name, mode, dev);
                        if (FS.isDir(node.mode)) {
                            node.node_ops = MEMFS.ops_table.dir.node;
                            node.stream_ops = MEMFS.ops_table.dir.stream;
                            node.contents = {};
                        } else if (FS.isFile(node.mode)) {
                            node.node_ops = MEMFS.ops_table.file.node;
                            node.stream_ops = MEMFS.ops_table.file.stream;
                            node.usedBytes = 0;
                            node.contents = null;
                        } else if (FS.isLink(node.mode)) {
                            node.node_ops = MEMFS.ops_table.link.node;
                            node.stream_ops = MEMFS.ops_table.link.stream;
                        } else if (FS.isChrdev(node.mode)) {
                            node.node_ops = MEMFS.ops_table.chrdev.node;
                            node.stream_ops = MEMFS.ops_table.chrdev.stream;
                        }
                        node.timestamp = Date.now();
                        if (parent) {
                            parent.contents[name] = node;
                            parent.timestamp = node.timestamp;
                        }
                        return node;
                    },
                    getFileDataAsTypedArray (node) {
                        if (!node.contents) return new Uint8Array(0);
                        if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
                        return new Uint8Array(node.contents);
                    },
                    expandFileStorage (node, newCapacity) {
                        var prevCapacity = node.contents ? node.contents.length : 0;
                        if (prevCapacity >= newCapacity) return;
                        var CAPACITY_DOUBLING_MAX = 1048576;
                        newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
                        if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
                        var oldContents = node.contents;
                        node.contents = new Uint8Array(newCapacity);
                        if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
                    },
                    resizeFileStorage (node, newSize) {
                        if (node.usedBytes == newSize) return;
                        if (newSize == 0) {
                            node.contents = null;
                            node.usedBytes = 0;
                        } else {
                            var oldContents = node.contents;
                            node.contents = new Uint8Array(newSize);
                            if (oldContents) node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
                            node.usedBytes = newSize;
                        }
                    },
                    node_ops: {
                        getattr (node) {
                            var attr = {};
                            attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
                            attr.ino = node.id;
                            attr.mode = node.mode;
                            attr.nlink = 1;
                            attr.uid = 0;
                            attr.gid = 0;
                            attr.rdev = node.rdev;
                            if (FS.isDir(node.mode)) attr.size = 4096;
                            else if (FS.isFile(node.mode)) attr.size = node.usedBytes;
                            else if (FS.isLink(node.mode)) attr.size = node.link.length;
                            else attr.size = 0;
                            attr.atime = new Date(node.timestamp);
                            attr.mtime = new Date(node.timestamp);
                            attr.ctime = new Date(node.timestamp);
                            attr.blksize = 4096;
                            attr.blocks = Math.ceil(attr.size / attr.blksize);
                            return attr;
                        },
                        setattr (node, attr) {
                            if (attr.mode !== void 0) node.mode = attr.mode;
                            if (attr.timestamp !== void 0) node.timestamp = attr.timestamp;
                            if (attr.size !== void 0) MEMFS.resizeFileStorage(node, attr.size);
                        },
                        lookup (parent, name) {
                            throw FS.genericErrors[44];
                        },
                        mknod (parent, name, mode, dev) {
                            return MEMFS.createNode(parent, name, mode, dev);
                        },
                        rename (old_node, new_dir, new_name) {
                            if (FS.isDir(old_node.mode)) {
                                var new_node;
                                try {
                                    new_node = FS.lookupNode(new_dir, new_name);
                                } catch (e) {}
                                if (new_node) {
                                    for(var i in new_node.contents)throw new FS.ErrnoError(55);
                                }
                            }
                            delete old_node.parent.contents[old_node.name];
                            old_node.parent.timestamp = Date.now();
                            old_node.name = new_name;
                            new_dir.contents[new_name] = old_node;
                            new_dir.timestamp = old_node.parent.timestamp;
                            old_node.parent = new_dir;
                        },
                        unlink (parent, name) {
                            delete parent.contents[name];
                            parent.timestamp = Date.now();
                        },
                        rmdir (parent, name) {
                            var node = FS.lookupNode(parent, name);
                            for(var i in node.contents)throw new FS.ErrnoError(55);
                            delete parent.contents[name];
                            parent.timestamp = Date.now();
                        },
                        readdir (node) {
                            var entries = [
                                ".",
                                ".."
                            ];
                            for(var key in node.contents){
                                if (!node.contents.hasOwnProperty(key)) continue;
                                entries.push(key);
                            }
                            return entries;
                        },
                        symlink (parent, newname, oldpath) {
                            var node = MEMFS.createNode(parent, newname, 41471, 0);
                            node.link = oldpath;
                            return node;
                        },
                        readlink (node) {
                            if (!FS.isLink(node.mode)) throw new FS.ErrnoError(28);
                            return node.link;
                        }
                    },
                    stream_ops: {
                        read (stream, buffer, offset, length, position) {
                            var contents = stream.node.contents;
                            if (position >= stream.node.usedBytes) return 0;
                            var size = Math.min(stream.node.usedBytes - position, length);
                            if (size > 8 && contents.subarray) buffer.set(contents.subarray(position, position + size), offset);
                            else for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                            return size;
                        },
                        write (stream, buffer, offset, length, position, canOwn) {
                            if (buffer.buffer === GROWABLE_HEAP_I8().buffer) canOwn = false;
                            if (!length) return 0;
                            var node = stream.node;
                            node.timestamp = Date.now();
                            if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                                if (canOwn) {
                                    node.contents = buffer.subarray(offset, offset + length);
                                    node.usedBytes = length;
                                    return length;
                                } else if (node.usedBytes === 0 && position === 0) {
                                    node.contents = buffer.slice(offset, offset + length);
                                    node.usedBytes = length;
                                    return length;
                                } else if (position + length <= node.usedBytes) {
                                    node.contents.set(buffer.subarray(offset, offset + length), position);
                                    return length;
                                }
                            }
                            MEMFS.expandFileStorage(node, position + length);
                            if (node.contents.subarray && buffer.subarray) node.contents.set(buffer.subarray(offset, offset + length), position);
                            else for(var i = 0; i < length; i++)node.contents[position + i] = buffer[offset + i];
                            node.usedBytes = Math.max(node.usedBytes, position + length);
                            return length;
                        },
                        llseek (stream, offset, whence) {
                            var position = offset;
                            if (whence === 1) position += stream.position;
                            else if (whence === 2) {
                                if (FS.isFile(stream.node.mode)) position += stream.node.usedBytes;
                            }
                            if (position < 0) throw new FS.ErrnoError(28);
                            return position;
                        },
                        allocate (stream, offset, length) {
                            MEMFS.expandFileStorage(stream.node, offset + length);
                            stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
                        },
                        mmap (stream, length, position, prot, flags) {
                            if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                            var ptr;
                            var allocated;
                            var contents = stream.node.contents;
                            if (!(flags & 2) && contents.buffer === GROWABLE_HEAP_I8().buffer) {
                                allocated = false;
                                ptr = contents.byteOffset;
                            } else {
                                if (position > 0 || position + length < contents.length) {
                                    if (contents.subarray) contents = contents.subarray(position, position + length);
                                    else contents = Array.prototype.slice.call(contents, position, position + length);
                                }
                                allocated = true;
                                ptr = mmapAlloc(length);
                                if (!ptr) throw new FS.ErrnoError(48);
                                GROWABLE_HEAP_I8().set(contents, ptr >>> 0);
                            }
                            return {
                                ptr: ptr,
                                allocated: allocated
                            };
                        },
                        msync (stream, buffer, offset, length, mmapFlags) {
                            MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
                            return 0;
                        }
                    }
                };
                var asyncLoad = (url, onload, onerror, noRunDep)=>{
                    var dep = !noRunDep ? getUniqueRunDependency(`al ${url}`) : "";
                    readAsync(url, (arrayBuffer)=>{
                        assert(arrayBuffer, `Loading data file "${url}" failed (no arrayBuffer).`);
                        onload(new Uint8Array(arrayBuffer));
                        if (dep) removeRunDependency(dep);
                    }, (event)=>{
                        if (onerror) onerror();
                        else throw `Loading data file "${url}" failed.`;
                    });
                    if (dep) addRunDependency(dep);
                };
                var preloadPlugins = Module["preloadPlugins"] || [];
                function FS_handledByPreloadPlugin(byteArray, fullname, finish, onerror) {
                    if (typeof Browser != "undefined") Browser.init();
                    var handled = false;
                    preloadPlugins.forEach(function(plugin) {
                        if (handled) return;
                        if (plugin["canHandle"](fullname)) {
                            plugin["handle"](byteArray, fullname, finish, onerror);
                            handled = true;
                        }
                    });
                    return handled;
                }
                function FS_createPreloadedFile(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) {
                    var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
                    var dep = getUniqueRunDependency(`cp ${fullname}`);
                    function processData(byteArray) {
                        function finish(byteArray2) {
                            if (preFinish) preFinish();
                            if (!dontCreateFile) FS.createDataFile(parent, name, byteArray2, canRead, canWrite, canOwn);
                            if (onload) onload();
                            removeRunDependency(dep);
                        }
                        if (FS_handledByPreloadPlugin(byteArray, fullname, finish, ()=>{
                            if (onerror) onerror();
                            removeRunDependency(dep);
                        })) return;
                        finish(byteArray);
                    }
                    addRunDependency(dep);
                    if (typeof url == "string") asyncLoad(url, (byteArray)=>processData(byteArray), onerror);
                    else processData(url);
                }
                function FS_modeStringToFlags(str) {
                    var flagModes = {
                        "r": 0,
                        "r+": 2,
                        "w": 577,
                        "w+": 578,
                        "a": 1089,
                        "a+": 1090
                    };
                    var flags = flagModes[str];
                    if (typeof flags == "undefined") throw new Error(`Unknown file open mode: ${str}`);
                    return flags;
                }
                function FS_getMode(canRead, canWrite) {
                    var mode = 0;
                    if (canRead) mode |= 365;
                    if (canWrite) mode |= 146;
                    return mode;
                }
                var FS = {
                    root: null,
                    mounts: [],
                    devices: {},
                    streams: [],
                    nextInode: 1,
                    nameTable: null,
                    currentPath: "/",
                    initialized: false,
                    ignorePermissions: true,
                    ErrnoError: null,
                    genericErrors: {},
                    filesystems: null,
                    syncFSRequests: 0,
                    lookupPath: (path, opts = {})=>{
                        path = PATH_FS.resolve(path);
                        if (!path) return {
                            path: "",
                            node: null
                        };
                        var defaults = {
                            follow_mount: true,
                            recurse_count: 0
                        };
                        opts = Object.assign(defaults, opts);
                        if (opts.recurse_count > 8) throw new FS.ErrnoError(32);
                        var parts = path.split("/").filter((p)=>!!p);
                        var current = FS.root;
                        var current_path = "/";
                        for(var i = 0; i < parts.length; i++){
                            var islast = i === parts.length - 1;
                            if (islast && opts.parent) break;
                            current = FS.lookupNode(current, parts[i]);
                            current_path = PATH.join2(current_path, parts[i]);
                            if (FS.isMountpoint(current)) {
                                if (!islast || islast && opts.follow_mount) current = current.mounted.root;
                            }
                            if (!islast || opts.follow) {
                                var count = 0;
                                while(FS.isLink(current.mode)){
                                    var link = FS.readlink(current_path);
                                    current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                                    var lookup = FS.lookupPath(current_path, {
                                        recurse_count: opts.recurse_count + 1
                                    });
                                    current = lookup.node;
                                    if (count++ > 40) throw new FS.ErrnoError(32);
                                }
                            }
                        }
                        return {
                            path: current_path,
                            node: current
                        };
                    },
                    getPath: (node)=>{
                        var path;
                        while(true){
                            if (FS.isRoot(node)) {
                                var mount = node.mount.mountpoint;
                                if (!path) return mount;
                                return mount[mount.length - 1] !== "/" ? `${mount}/${path}` : mount + path;
                            }
                            path = path ? `${node.name}/${path}` : node.name;
                            node = node.parent;
                        }
                    },
                    hashName: (parentid, name)=>{
                        var hash = 0;
                        for(var i = 0; i < name.length; i++)hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
                        return (parentid + hash >>> 0) % FS.nameTable.length;
                    },
                    hashAddNode: (node)=>{
                        var hash = FS.hashName(node.parent.id, node.name);
                        node.name_next = FS.nameTable[hash];
                        FS.nameTable[hash] = node;
                    },
                    hashRemoveNode: (node)=>{
                        var hash = FS.hashName(node.parent.id, node.name);
                        if (FS.nameTable[hash] === node) FS.nameTable[hash] = node.name_next;
                        else {
                            var current = FS.nameTable[hash];
                            while(current){
                                if (current.name_next === node) {
                                    current.name_next = node.name_next;
                                    break;
                                }
                                current = current.name_next;
                            }
                        }
                    },
                    lookupNode: (parent, name)=>{
                        var errCode = FS.mayLookup(parent);
                        if (errCode) throw new FS.ErrnoError(errCode, parent);
                        var hash = FS.hashName(parent.id, name);
                        for(var node = FS.nameTable[hash]; node; node = node.name_next){
                            var nodeName = node.name;
                            if (node.parent.id === parent.id && nodeName === name) return node;
                        }
                        return FS.lookup(parent, name);
                    },
                    createNode: (parent, name, mode, rdev)=>{
                        var node = new FS.FSNode(parent, name, mode, rdev);
                        FS.hashAddNode(node);
                        return node;
                    },
                    destroyNode: (node)=>{
                        FS.hashRemoveNode(node);
                    },
                    isRoot: (node)=>node === node.parent,
                    isMountpoint: (node)=>!!node.mounted,
                    isFile: (mode)=>(mode & 61440) === 32768,
                    isDir: (mode)=>(mode & 61440) === 16384,
                    isLink: (mode)=>(mode & 61440) === 40960,
                    isChrdev: (mode)=>(mode & 61440) === 8192,
                    isBlkdev: (mode)=>(mode & 61440) === 24576,
                    isFIFO: (mode)=>(mode & 61440) === 4096,
                    isSocket: (mode)=>(mode & 49152) === 49152,
                    flagsToPermissionString: (flag)=>{
                        var perms = [
                            "r",
                            "w",
                            "rw"
                        ][flag & 3];
                        if (flag & 512) perms += "w";
                        return perms;
                    },
                    nodePermissions: (node, perms)=>{
                        if (FS.ignorePermissions) return 0;
                        if (perms.includes("r") && !(node.mode & 292)) return 2;
                        else if (perms.includes("w") && !(node.mode & 146)) return 2;
                        else if (perms.includes("x") && !(node.mode & 73)) return 2;
                        return 0;
                    },
                    mayLookup: (dir)=>{
                        var errCode = FS.nodePermissions(dir, "x");
                        if (errCode) return errCode;
                        if (!dir.node_ops.lookup) return 2;
                        return 0;
                    },
                    mayCreate: (dir, name)=>{
                        try {
                            var node = FS.lookupNode(dir, name);
                            return 20;
                        } catch (e) {}
                        return FS.nodePermissions(dir, "wx");
                    },
                    mayDelete: (dir, name, isdir)=>{
                        var node;
                        try {
                            node = FS.lookupNode(dir, name);
                        } catch (e) {
                            return e.errno;
                        }
                        var errCode = FS.nodePermissions(dir, "wx");
                        if (errCode) return errCode;
                        if (isdir) {
                            if (!FS.isDir(node.mode)) return 54;
                            if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) return 10;
                        } else {
                            if (FS.isDir(node.mode)) return 31;
                        }
                        return 0;
                    },
                    mayOpen: (node, flags)=>{
                        if (!node) return 44;
                        if (FS.isLink(node.mode)) return 32;
                        else if (FS.isDir(node.mode)) {
                            if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) return 31;
                        }
                        return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
                    },
                    MAX_OPEN_FDS: 4096,
                    nextfd: ()=>{
                        for(var fd = 0; fd <= FS.MAX_OPEN_FDS; fd++){
                            if (!FS.streams[fd]) return fd;
                        }
                        throw new FS.ErrnoError(33);
                    },
                    getStreamChecked: (fd)=>{
                        var stream = FS.getStream(fd);
                        if (!stream) throw new FS.ErrnoError(8);
                        return stream;
                    },
                    getStream: (fd)=>FS.streams[fd],
                    createStream: (stream, fd = -1)=>{
                        if (!FS.FSStream) {
                            FS.FSStream = function() {
                                this.shared = {};
                            };
                            FS.FSStream.prototype = {};
                            Object.defineProperties(FS.FSStream.prototype, {
                                object: {
                                    get () {
                                        return this.node;
                                    },
                                    set (val) {
                                        this.node = val;
                                    }
                                },
                                isRead: {
                                    get () {
                                        return (this.flags & 2097155) !== 1;
                                    }
                                },
                                isWrite: {
                                    get () {
                                        return (this.flags & 2097155) !== 0;
                                    }
                                },
                                isAppend: {
                                    get () {
                                        return this.flags & 1024;
                                    }
                                },
                                flags: {
                                    get () {
                                        return this.shared.flags;
                                    },
                                    set (val) {
                                        this.shared.flags = val;
                                    }
                                },
                                position: {
                                    get () {
                                        return this.shared.position;
                                    },
                                    set (val) {
                                        this.shared.position = val;
                                    }
                                }
                            });
                        }
                        stream = Object.assign(new FS.FSStream(), stream);
                        if (fd == -1) fd = FS.nextfd();
                        stream.fd = fd;
                        FS.streams[fd] = stream;
                        return stream;
                    },
                    closeStream: (fd)=>{
                        FS.streams[fd] = null;
                    },
                    chrdev_stream_ops: {
                        open: (stream)=>{
                            var device = FS.getDevice(stream.node.rdev);
                            stream.stream_ops = device.stream_ops;
                            if (stream.stream_ops.open) stream.stream_ops.open(stream);
                        },
                        llseek: ()=>{
                            throw new FS.ErrnoError(70);
                        }
                    },
                    major: (dev)=>dev >> 8,
                    minor: (dev)=>dev & 255,
                    makedev: (ma, mi)=>ma << 8 | mi,
                    registerDevice: (dev, ops)=>{
                        FS.devices[dev] = {
                            stream_ops: ops
                        };
                    },
                    getDevice: (dev)=>FS.devices[dev],
                    getMounts: (mount)=>{
                        var mounts = [];
                        var check = [
                            mount
                        ];
                        while(check.length){
                            var m = check.pop();
                            mounts.push(m);
                            check.push.apply(check, m.mounts);
                        }
                        return mounts;
                    },
                    syncfs: (populate, callback)=>{
                        if (typeof populate == "function") {
                            callback = populate;
                            populate = false;
                        }
                        FS.syncFSRequests++;
                        if (FS.syncFSRequests > 1) err(`warning: ${FS.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
                        var mounts = FS.getMounts(FS.root.mount);
                        var completed = 0;
                        function doCallback(errCode) {
                            FS.syncFSRequests--;
                            return callback(errCode);
                        }
                        function done(errCode) {
                            if (errCode) {
                                if (!done.errored) {
                                    done.errored = true;
                                    return doCallback(errCode);
                                }
                                return;
                            }
                            if (++completed >= mounts.length) doCallback(null);
                        }
                        mounts.forEach((mount)=>{
                            if (!mount.type.syncfs) return done(null);
                            mount.type.syncfs(mount, populate, done);
                        });
                    },
                    mount: (type, opts, mountpoint)=>{
                        var root = mountpoint === "/";
                        var pseudo = !mountpoint;
                        var node;
                        if (root && FS.root) throw new FS.ErrnoError(10);
                        else if (!root && !pseudo) {
                            var lookup = FS.lookupPath(mountpoint, {
                                follow_mount: false
                            });
                            mountpoint = lookup.path;
                            node = lookup.node;
                            if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                            if (!FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                        }
                        var mount = {
                            type: type,
                            opts: opts,
                            mountpoint: mountpoint,
                            mounts: []
                        };
                        var mountRoot = type.mount(mount);
                        mountRoot.mount = mount;
                        mount.root = mountRoot;
                        if (root) FS.root = mountRoot;
                        else if (node) {
                            node.mounted = mount;
                            if (node.mount) node.mount.mounts.push(mount);
                        }
                        return mountRoot;
                    },
                    unmount: (mountpoint)=>{
                        var lookup = FS.lookupPath(mountpoint, {
                            follow_mount: false
                        });
                        if (!FS.isMountpoint(lookup.node)) throw new FS.ErrnoError(28);
                        var node = lookup.node;
                        var mount = node.mounted;
                        var mounts = FS.getMounts(mount);
                        Object.keys(FS.nameTable).forEach((hash)=>{
                            var current = FS.nameTable[hash];
                            while(current){
                                var next = current.name_next;
                                if (mounts.includes(current.mount)) FS.destroyNode(current);
                                current = next;
                            }
                        });
                        node.mounted = null;
                        var idx = node.mount.mounts.indexOf(mount);
                        node.mount.mounts.splice(idx, 1);
                    },
                    lookup: (parent, name)=>parent.node_ops.lookup(parent, name),
                    mknod: (path, mode, dev)=>{
                        var lookup = FS.lookupPath(path, {
                            parent: true
                        });
                        var parent = lookup.node;
                        var name = PATH.basename(path);
                        if (!name || name === "." || name === "..") throw new FS.ErrnoError(28);
                        var errCode = FS.mayCreate(parent, name);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!parent.node_ops.mknod) throw new FS.ErrnoError(63);
                        return parent.node_ops.mknod(parent, name, mode, dev);
                    },
                    create: (path, mode)=>{
                        mode = mode !== void 0 ? mode : 438;
                        mode &= 4095;
                        mode |= 32768;
                        return FS.mknod(path, mode, 0);
                    },
                    mkdir: (path, mode)=>{
                        mode = mode !== void 0 ? mode : 511;
                        mode &= 1023;
                        mode |= 16384;
                        return FS.mknod(path, mode, 0);
                    },
                    mkdirTree: (path, mode)=>{
                        var dirs = path.split("/");
                        var d = "";
                        for(var i = 0; i < dirs.length; ++i){
                            if (!dirs[i]) continue;
                            d += "/" + dirs[i];
                            try {
                                FS.mkdir(d, mode);
                            } catch (e) {
                                if (e.errno != 20) throw e;
                            }
                        }
                    },
                    mkdev: (path, mode, dev)=>{
                        if (typeof dev == "undefined") {
                            dev = mode;
                            mode = 438;
                        }
                        mode |= 8192;
                        return FS.mknod(path, mode, dev);
                    },
                    symlink: (oldpath, newpath)=>{
                        if (!PATH_FS.resolve(oldpath)) throw new FS.ErrnoError(44);
                        var lookup = FS.lookupPath(newpath, {
                            parent: true
                        });
                        var parent = lookup.node;
                        if (!parent) throw new FS.ErrnoError(44);
                        var newname = PATH.basename(newpath);
                        var errCode = FS.mayCreate(parent, newname);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!parent.node_ops.symlink) throw new FS.ErrnoError(63);
                        return parent.node_ops.symlink(parent, newname, oldpath);
                    },
                    rename: (old_path, new_path)=>{
                        var old_dirname = PATH.dirname(old_path);
                        var new_dirname = PATH.dirname(new_path);
                        var old_name = PATH.basename(old_path);
                        var new_name = PATH.basename(new_path);
                        var lookup, old_dir, new_dir;
                        lookup = FS.lookupPath(old_path, {
                            parent: true
                        });
                        old_dir = lookup.node;
                        lookup = FS.lookupPath(new_path, {
                            parent: true
                        });
                        new_dir = lookup.node;
                        if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
                        if (old_dir.mount !== new_dir.mount) throw new FS.ErrnoError(75);
                        var old_node = FS.lookupNode(old_dir, old_name);
                        var relative = PATH_FS.relative(old_path, new_dirname);
                        if (relative.charAt(0) !== ".") throw new FS.ErrnoError(28);
                        relative = PATH_FS.relative(new_path, old_dirname);
                        if (relative.charAt(0) !== ".") throw new FS.ErrnoError(55);
                        var new_node;
                        try {
                            new_node = FS.lookupNode(new_dir, new_name);
                        } catch (e) {}
                        if (old_node === new_node) return;
                        var isdir = FS.isDir(old_node.mode);
                        var errCode = FS.mayDelete(old_dir, old_name, isdir);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!old_dir.node_ops.rename) throw new FS.ErrnoError(63);
                        if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) throw new FS.ErrnoError(10);
                        if (new_dir !== old_dir) {
                            errCode = FS.nodePermissions(old_dir, "w");
                            if (errCode) throw new FS.ErrnoError(errCode);
                        }
                        FS.hashRemoveNode(old_node);
                        try {
                            old_dir.node_ops.rename(old_node, new_dir, new_name);
                        } catch (e) {
                            throw e;
                        } finally{
                            FS.hashAddNode(old_node);
                        }
                    },
                    rmdir: (path)=>{
                        var lookup = FS.lookupPath(path, {
                            parent: true
                        });
                        var parent = lookup.node;
                        var name = PATH.basename(path);
                        var node = FS.lookupNode(parent, name);
                        var errCode = FS.mayDelete(parent, name, true);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!parent.node_ops.rmdir) throw new FS.ErrnoError(63);
                        if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                        parent.node_ops.rmdir(parent, name);
                        FS.destroyNode(node);
                    },
                    readdir: (path)=>{
                        var lookup = FS.lookupPath(path, {
                            follow: true
                        });
                        var node = lookup.node;
                        if (!node.node_ops.readdir) throw new FS.ErrnoError(54);
                        return node.node_ops.readdir(node);
                    },
                    unlink: (path)=>{
                        var lookup = FS.lookupPath(path, {
                            parent: true
                        });
                        var parent = lookup.node;
                        if (!parent) throw new FS.ErrnoError(44);
                        var name = PATH.basename(path);
                        var node = FS.lookupNode(parent, name);
                        var errCode = FS.mayDelete(parent, name, false);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!parent.node_ops.unlink) throw new FS.ErrnoError(63);
                        if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                        parent.node_ops.unlink(parent, name);
                        FS.destroyNode(node);
                    },
                    readlink: (path)=>{
                        var lookup = FS.lookupPath(path);
                        var link = lookup.node;
                        if (!link) throw new FS.ErrnoError(44);
                        if (!link.node_ops.readlink) throw new FS.ErrnoError(28);
                        return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
                    },
                    stat: (path, dontFollow)=>{
                        var lookup = FS.lookupPath(path, {
                            follow: !dontFollow
                        });
                        var node = lookup.node;
                        if (!node) throw new FS.ErrnoError(44);
                        if (!node.node_ops.getattr) throw new FS.ErrnoError(63);
                        return node.node_ops.getattr(node);
                    },
                    lstat: (path)=>FS.stat(path, true),
                    chmod: (path, mode, dontFollow)=>{
                        var node;
                        if (typeof path == "string") {
                            var lookup = FS.lookupPath(path, {
                                follow: !dontFollow
                            });
                            node = lookup.node;
                        } else node = path;
                        if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                        node.node_ops.setattr(node, {
                            mode: mode & 4095 | node.mode & -4096,
                            timestamp: Date.now()
                        });
                    },
                    lchmod: (path, mode)=>{
                        FS.chmod(path, mode, true);
                    },
                    fchmod: (fd, mode)=>{
                        var stream = FS.getStreamChecked(fd);
                        FS.chmod(stream.node, mode);
                    },
                    chown: (path, uid, gid, dontFollow)=>{
                        var node;
                        if (typeof path == "string") {
                            var lookup = FS.lookupPath(path, {
                                follow: !dontFollow
                            });
                            node = lookup.node;
                        } else node = path;
                        if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                        node.node_ops.setattr(node, {
                            timestamp: Date.now()
                        });
                    },
                    lchown: (path, uid, gid)=>{
                        FS.chown(path, uid, gid, true);
                    },
                    fchown: (fd, uid, gid)=>{
                        var stream = FS.getStreamChecked(fd);
                        FS.chown(stream.node, uid, gid);
                    },
                    truncate: (path, len)=>{
                        if (len < 0) throw new FS.ErrnoError(28);
                        var node;
                        if (typeof path == "string") {
                            var lookup = FS.lookupPath(path, {
                                follow: true
                            });
                            node = lookup.node;
                        } else node = path;
                        if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                        if (FS.isDir(node.mode)) throw new FS.ErrnoError(31);
                        if (!FS.isFile(node.mode)) throw new FS.ErrnoError(28);
                        var errCode = FS.nodePermissions(node, "w");
                        if (errCode) throw new FS.ErrnoError(errCode);
                        node.node_ops.setattr(node, {
                            size: len,
                            timestamp: Date.now()
                        });
                    },
                    ftruncate: (fd, len)=>{
                        var stream = FS.getStreamChecked(fd);
                        if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(28);
                        FS.truncate(stream.node, len);
                    },
                    utime: (path, atime, mtime)=>{
                        var lookup = FS.lookupPath(path, {
                            follow: true
                        });
                        var node = lookup.node;
                        node.node_ops.setattr(node, {
                            timestamp: Math.max(atime, mtime)
                        });
                    },
                    open: (path, flags, mode)=>{
                        if (path === "") throw new FS.ErrnoError(44);
                        flags = typeof flags == "string" ? FS_modeStringToFlags(flags) : flags;
                        mode = typeof mode == "undefined" ? 438 : mode;
                        if (flags & 64) mode = mode & 4095 | 32768;
                        else mode = 0;
                        var node;
                        if (typeof path == "object") node = path;
                        else {
                            path = PATH.normalize(path);
                            try {
                                var lookup = FS.lookupPath(path, {
                                    follow: !(flags & 131072)
                                });
                                node = lookup.node;
                            } catch (e) {}
                        }
                        var created = false;
                        if (flags & 64) {
                            if (node) {
                                if (flags & 128) throw new FS.ErrnoError(20);
                            } else {
                                node = FS.mknod(path, mode, 0);
                                created = true;
                            }
                        }
                        if (!node) throw new FS.ErrnoError(44);
                        if (FS.isChrdev(node.mode)) flags &= -513;
                        if (flags & 65536 && !FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                        if (!created) {
                            var errCode = FS.mayOpen(node, flags);
                            if (errCode) throw new FS.ErrnoError(errCode);
                        }
                        if (flags & 512 && !created) FS.truncate(node, 0);
                        flags &= -131713;
                        var stream = FS.createStream({
                            node: node,
                            path: FS.getPath(node),
                            flags: flags,
                            seekable: true,
                            position: 0,
                            stream_ops: node.stream_ops,
                            ungotten: [],
                            error: false
                        });
                        if (stream.stream_ops.open) stream.stream_ops.open(stream);
                        if (Module["logReadFiles"] && !(flags & 1)) {
                            if (!FS.readFiles) FS.readFiles = {};
                            if (!(path in FS.readFiles)) FS.readFiles[path] = 1;
                        }
                        return stream;
                    },
                    close: (stream)=>{
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if (stream.getdents) stream.getdents = null;
                        try {
                            if (stream.stream_ops.close) stream.stream_ops.close(stream);
                        } catch (e) {
                            throw e;
                        } finally{
                            FS.closeStream(stream.fd);
                        }
                        stream.fd = null;
                    },
                    isClosed: (stream)=>stream.fd === null,
                    llseek: (stream, offset, whence)=>{
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if (!stream.seekable || !stream.stream_ops.llseek) throw new FS.ErrnoError(70);
                        if (whence != 0 && whence != 1 && whence != 2) throw new FS.ErrnoError(28);
                        stream.position = stream.stream_ops.llseek(stream, offset, whence);
                        stream.ungotten = [];
                        return stream.position;
                    },
                    read: (stream, buffer, offset, length, position)=>{
                        if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(8);
                        if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                        if (!stream.stream_ops.read) throw new FS.ErrnoError(28);
                        var seeking = typeof position != "undefined";
                        if (!seeking) position = stream.position;
                        else if (!stream.seekable) throw new FS.ErrnoError(70);
                        var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
                        if (!seeking) stream.position += bytesRead;
                        return bytesRead;
                    },
                    write: (stream, buffer, offset, length, position, canOwn)=>{
                        if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                        if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                        if (!stream.stream_ops.write) throw new FS.ErrnoError(28);
                        if (stream.seekable && stream.flags & 1024) FS.llseek(stream, 0, 2);
                        var seeking = typeof position != "undefined";
                        if (!seeking) position = stream.position;
                        else if (!stream.seekable) throw new FS.ErrnoError(70);
                        var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
                        if (!seeking) stream.position += bytesWritten;
                        return bytesWritten;
                    },
                    allocate: (stream, offset, length)=>{
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if (offset < 0 || length <= 0) throw new FS.ErrnoError(28);
                        if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                        if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) throw new FS.ErrnoError(43);
                        if (!stream.stream_ops.allocate) throw new FS.ErrnoError(138);
                        stream.stream_ops.allocate(stream, offset, length);
                    },
                    mmap: (stream, length, position, prot, flags)=>{
                        if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) throw new FS.ErrnoError(2);
                        if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(2);
                        if (!stream.stream_ops.mmap) throw new FS.ErrnoError(43);
                        return stream.stream_ops.mmap(stream, length, position, prot, flags);
                    },
                    msync: (stream, buffer, offset, length, mmapFlags)=>{
                        if (!stream.stream_ops.msync) return 0;
                        return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
                    },
                    munmap: (stream)=>0,
                    ioctl: (stream, cmd, arg)=>{
                        if (!stream.stream_ops.ioctl) throw new FS.ErrnoError(59);
                        return stream.stream_ops.ioctl(stream, cmd, arg);
                    },
                    readFile: (path, opts = {})=>{
                        opts.flags = opts.flags || 0;
                        opts.encoding = opts.encoding || "binary";
                        if (opts.encoding !== "utf8" && opts.encoding !== "binary") throw new Error(`Invalid encoding type "${opts.encoding}"`);
                        var ret;
                        var stream = FS.open(path, opts.flags);
                        var stat = FS.stat(path);
                        var length = stat.size;
                        var buf = new Uint8Array(length);
                        FS.read(stream, buf, 0, length, 0);
                        if (opts.encoding === "utf8") ret = UTF8ArrayToString(buf, 0);
                        else if (opts.encoding === "binary") ret = buf;
                        FS.close(stream);
                        return ret;
                    },
                    writeFile: (path, data, opts = {})=>{
                        opts.flags = opts.flags || 577;
                        var stream = FS.open(path, opts.flags, opts.mode);
                        if (typeof data == "string") {
                            var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
                            var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
                            FS.write(stream, buf, 0, actualNumBytes, void 0, opts.canOwn);
                        } else if (ArrayBuffer.isView(data)) FS.write(stream, data, 0, data.byteLength, void 0, opts.canOwn);
                        else throw new Error("Unsupported data type");
                        FS.close(stream);
                    },
                    cwd: ()=>FS.currentPath,
                    chdir: (path)=>{
                        var lookup = FS.lookupPath(path, {
                            follow: true
                        });
                        if (lookup.node === null) throw new FS.ErrnoError(44);
                        if (!FS.isDir(lookup.node.mode)) throw new FS.ErrnoError(54);
                        var errCode = FS.nodePermissions(lookup.node, "x");
                        if (errCode) throw new FS.ErrnoError(errCode);
                        FS.currentPath = lookup.path;
                    },
                    createDefaultDirectories: ()=>{
                        FS.mkdir("/tmp");
                        FS.mkdir("/home");
                        FS.mkdir("/home/web_user");
                    },
                    createDefaultDevices: ()=>{
                        FS.mkdir("/dev");
                        FS.registerDevice(FS.makedev(1, 3), {
                            read: ()=>0,
                            write: (stream, buffer, offset, length, pos)=>length
                        });
                        FS.mkdev("/dev/null", FS.makedev(1, 3));
                        TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
                        TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
                        FS.mkdev("/dev/tty", FS.makedev(5, 0));
                        FS.mkdev("/dev/tty1", FS.makedev(6, 0));
                        var randomBuffer = new Uint8Array(1024), randomLeft = 0;
                        var randomByte = ()=>{
                            if (randomLeft === 0) randomLeft = randomFill(randomBuffer).byteLength;
                            return randomBuffer[--randomLeft];
                        };
                        FS.createDevice("/dev", "random", randomByte);
                        FS.createDevice("/dev", "urandom", randomByte);
                        FS.mkdir("/dev/shm");
                        FS.mkdir("/dev/shm/tmp");
                    },
                    createSpecialDirectories: ()=>{
                        FS.mkdir("/proc");
                        var proc_self = FS.mkdir("/proc/self");
                        FS.mkdir("/proc/self/fd");
                        FS.mount({
                            mount: ()=>{
                                var node = FS.createNode(proc_self, "fd", 16895, 73);
                                node.node_ops = {
                                    lookup: (parent, name)=>{
                                        var fd = +name;
                                        var stream = FS.getStreamChecked(fd);
                                        var ret = {
                                            parent: null,
                                            mount: {
                                                mountpoint: "fake"
                                            },
                                            node_ops: {
                                                readlink: ()=>stream.path
                                            }
                                        };
                                        ret.parent = ret;
                                        return ret;
                                    }
                                };
                                return node;
                            }
                        }, {}, "/proc/self/fd");
                    },
                    createStandardStreams: ()=>{
                        if (Module["stdin"]) FS.createDevice("/dev", "stdin", Module["stdin"]);
                        else FS.symlink("/dev/tty", "/dev/stdin");
                        if (Module["stdout"]) FS.createDevice("/dev", "stdout", null, Module["stdout"]);
                        else FS.symlink("/dev/tty", "/dev/stdout");
                        if (Module["stderr"]) FS.createDevice("/dev", "stderr", null, Module["stderr"]);
                        else FS.symlink("/dev/tty1", "/dev/stderr");
                        var stdin = FS.open("/dev/stdin", 0);
                        var stdout = FS.open("/dev/stdout", 1);
                        var stderr = FS.open("/dev/stderr", 1);
                    },
                    ensureErrnoError: ()=>{
                        if (FS.ErrnoError) return;
                        FS.ErrnoError = function ErrnoError(errno, node) {
                            this.name = "ErrnoError";
                            this.node = node;
                            this.setErrno = function(errno2) {
                                this.errno = errno2;
                            };
                            this.setErrno(errno);
                            this.message = "FS error";
                        };
                        FS.ErrnoError.prototype = new Error();
                        FS.ErrnoError.prototype.constructor = FS.ErrnoError;
                        [
                            44
                        ].forEach((code)=>{
                            FS.genericErrors[code] = new FS.ErrnoError(code);
                            FS.genericErrors[code].stack = "<generic error, no stack>";
                        });
                    },
                    staticInit: ()=>{
                        FS.ensureErrnoError();
                        FS.nameTable = new Array(4096);
                        FS.mount(MEMFS, {}, "/");
                        FS.createDefaultDirectories();
                        FS.createDefaultDevices();
                        FS.createSpecialDirectories();
                        FS.filesystems = {
                            "MEMFS": MEMFS
                        };
                    },
                    init: (input, output, error)=>{
                        FS.init.initialized = true;
                        FS.ensureErrnoError();
                        Module["stdin"] = input || Module["stdin"];
                        Module["stdout"] = output || Module["stdout"];
                        Module["stderr"] = error || Module["stderr"];
                        FS.createStandardStreams();
                    },
                    quit: ()=>{
                        FS.init.initialized = false;
                        for(var i = 0; i < FS.streams.length; i++){
                            var stream = FS.streams[i];
                            if (!stream) continue;
                            FS.close(stream);
                        }
                    },
                    findObject: (path, dontResolveLastLink)=>{
                        var ret = FS.analyzePath(path, dontResolveLastLink);
                        if (!ret.exists) return null;
                        return ret.object;
                    },
                    analyzePath: (path, dontResolveLastLink)=>{
                        try {
                            var lookup = FS.lookupPath(path, {
                                follow: !dontResolveLastLink
                            });
                            path = lookup.path;
                        } catch (e) {}
                        var ret = {
                            isRoot: false,
                            exists: false,
                            error: 0,
                            name: null,
                            path: null,
                            object: null,
                            parentExists: false,
                            parentPath: null,
                            parentObject: null
                        };
                        try {
                            var lookup = FS.lookupPath(path, {
                                parent: true
                            });
                            ret.parentExists = true;
                            ret.parentPath = lookup.path;
                            ret.parentObject = lookup.node;
                            ret.name = PATH.basename(path);
                            lookup = FS.lookupPath(path, {
                                follow: !dontResolveLastLink
                            });
                            ret.exists = true;
                            ret.path = lookup.path;
                            ret.object = lookup.node;
                            ret.name = lookup.node.name;
                            ret.isRoot = lookup.path === "/";
                        } catch (e) {
                            ret.error = e.errno;
                        }
                        return ret;
                    },
                    createPath: (parent, path, canRead, canWrite)=>{
                        parent = typeof parent == "string" ? parent : FS.getPath(parent);
                        var parts = path.split("/").reverse();
                        while(parts.length){
                            var part = parts.pop();
                            if (!part) continue;
                            var current = PATH.join2(parent, part);
                            try {
                                FS.mkdir(current);
                            } catch (e) {}
                            parent = current;
                        }
                        return current;
                    },
                    createFile: (parent, name, properties, canRead, canWrite)=>{
                        var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                        var mode = FS_getMode(canRead, canWrite);
                        return FS.create(path, mode);
                    },
                    createDataFile: (parent, name, data, canRead, canWrite, canOwn)=>{
                        var path = name;
                        if (parent) {
                            parent = typeof parent == "string" ? parent : FS.getPath(parent);
                            path = name ? PATH.join2(parent, name) : parent;
                        }
                        var mode = FS_getMode(canRead, canWrite);
                        var node = FS.create(path, mode);
                        if (data) {
                            if (typeof data == "string") {
                                var arr = new Array(data.length);
                                for(var i = 0, len = data.length; i < len; ++i)arr[i] = data.charCodeAt(i);
                                data = arr;
                            }
                            FS.chmod(node, mode | 146);
                            var stream = FS.open(node, 577);
                            FS.write(stream, data, 0, data.length, 0, canOwn);
                            FS.close(stream);
                            FS.chmod(node, mode);
                        }
                        return node;
                    },
                    createDevice: (parent, name, input, output)=>{
                        var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                        var mode = FS_getMode(!!input, !!output);
                        if (!FS.createDevice.major) FS.createDevice.major = 64;
                        var dev = FS.makedev(FS.createDevice.major++, 0);
                        FS.registerDevice(dev, {
                            open: (stream)=>{
                                stream.seekable = false;
                            },
                            close: (stream)=>{
                                if (output && output.buffer && output.buffer.length) output(10);
                            },
                            read: (stream, buffer, offset, length, pos)=>{
                                var bytesRead = 0;
                                for(var i = 0; i < length; i++){
                                    var result;
                                    try {
                                        result = input();
                                    } catch (e) {
                                        throw new FS.ErrnoError(29);
                                    }
                                    if (result === void 0 && bytesRead === 0) throw new FS.ErrnoError(6);
                                    if (result === null || result === void 0) break;
                                    bytesRead++;
                                    buffer[offset + i] = result;
                                }
                                if (bytesRead) stream.node.timestamp = Date.now();
                                return bytesRead;
                            },
                            write: (stream, buffer, offset, length, pos)=>{
                                for(var i = 0; i < length; i++)try {
                                    output(buffer[offset + i]);
                                } catch (e) {
                                    throw new FS.ErrnoError(29);
                                }
                                if (length) stream.node.timestamp = Date.now();
                                return i;
                            }
                        });
                        return FS.mkdev(path, mode, dev);
                    },
                    forceLoadFile: (obj)=>{
                        if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
                        if (typeof XMLHttpRequest != "undefined") throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                        else if (read_) try {
                            obj.contents = intArrayFromString(read_(obj.url), true);
                            obj.usedBytes = obj.contents.length;
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        else throw new Error("Cannot load without read() or XMLHttpRequest.");
                    },
                    createLazyFile: (parent, name, url, canRead, canWrite)=>{
                        function LazyUint8Array() {
                            this.lengthKnown = false;
                            this.chunks = [];
                        }
                        LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
                            if (idx > this.length - 1 || idx < 0) return void 0;
                            var chunkOffset = idx % this.chunkSize;
                            var chunkNum = idx / this.chunkSize | 0;
                            return this.getter(chunkNum)[chunkOffset];
                        };
                        LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
                            this.getter = getter;
                        };
                        LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
                            var xhr = new XMLHttpRequest();
                            xhr.open("HEAD", url, false);
                            xhr.send(null);
                            if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                            var datalength = Number(xhr.getResponseHeader("Content-length"));
                            var header;
                            var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                            var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
                            var chunkSize = 1048576;
                            if (!hasByteServing) chunkSize = datalength;
                            var doXHR = (from, to)=>{
                                if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                                if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                                var xhr2 = new XMLHttpRequest();
                                xhr2.open("GET", url, false);
                                if (datalength !== chunkSize) xhr2.setRequestHeader("Range", "bytes=" + from + "-" + to);
                                xhr2.responseType = "arraybuffer";
                                if (xhr2.overrideMimeType) xhr2.overrideMimeType("text/plain; charset=x-user-defined");
                                xhr2.send(null);
                                if (!(xhr2.status >= 200 && xhr2.status < 300 || xhr2.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr2.status);
                                if (xhr2.response !== void 0) return new Uint8Array(xhr2.response || []);
                                return intArrayFromString(xhr2.responseText || "", true);
                            };
                            var lazyArray2 = this;
                            lazyArray2.setDataGetter((chunkNum)=>{
                                var start = chunkNum * chunkSize;
                                var end = (chunkNum + 1) * chunkSize - 1;
                                end = Math.min(end, datalength - 1);
                                if (typeof lazyArray2.chunks[chunkNum] == "undefined") lazyArray2.chunks[chunkNum] = doXHR(start, end);
                                if (typeof lazyArray2.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                                return lazyArray2.chunks[chunkNum];
                            });
                            if (usesGzip || !datalength) {
                                chunkSize = datalength = 1;
                                datalength = this.getter(0).length;
                                chunkSize = datalength;
                                out("LazyFiles on gzip forces download of the whole file when length is accessed");
                            }
                            this._length = datalength;
                            this._chunkSize = chunkSize;
                            this.lengthKnown = true;
                        };
                        if (typeof XMLHttpRequest != "undefined") {
                            if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                            var lazyArray = new LazyUint8Array();
                            Object.defineProperties(lazyArray, {
                                length: {
                                    get: function() {
                                        if (!this.lengthKnown) this.cacheLength();
                                        return this._length;
                                    }
                                },
                                chunkSize: {
                                    get: function() {
                                        if (!this.lengthKnown) this.cacheLength();
                                        return this._chunkSize;
                                    }
                                }
                            });
                            var properties = {
                                isDevice: false,
                                contents: lazyArray
                            };
                        } else var properties = {
                            isDevice: false,
                            url: url
                        };
                        var node = FS.createFile(parent, name, properties, canRead, canWrite);
                        if (properties.contents) node.contents = properties.contents;
                        else if (properties.url) {
                            node.contents = null;
                            node.url = properties.url;
                        }
                        Object.defineProperties(node, {
                            usedBytes: {
                                get: function() {
                                    return this.contents.length;
                                }
                            }
                        });
                        var stream_ops = {};
                        var keys = Object.keys(node.stream_ops);
                        keys.forEach((key)=>{
                            var fn = node.stream_ops[key];
                            stream_ops[key] = function forceLoadLazyFile() {
                                FS.forceLoadFile(node);
                                return fn.apply(null, arguments);
                            };
                        });
                        function writeChunks(stream, buffer, offset, length, position) {
                            var contents = stream.node.contents;
                            if (position >= contents.length) return 0;
                            var size = Math.min(contents.length - position, length);
                            if (contents.slice) for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                            else for(var i = 0; i < size; i++)buffer[offset + i] = contents.get(position + i);
                            return size;
                        }
                        stream_ops.read = (stream, buffer, offset, length, position)=>{
                            FS.forceLoadFile(node);
                            return writeChunks(stream, buffer, offset, length, position);
                        };
                        stream_ops.mmap = (stream, length, position, prot, flags)=>{
                            FS.forceLoadFile(node);
                            var ptr = mmapAlloc(length);
                            if (!ptr) throw new FS.ErrnoError(48);
                            writeChunks(stream, GROWABLE_HEAP_I8(), ptr, length, position);
                            return {
                                ptr: ptr,
                                allocated: true
                            };
                        };
                        node.stream_ops = stream_ops;
                        return node;
                    }
                };
                var UTF8ToString = (ptr, maxBytesToRead)=>{
                    ptr >>>= 0;
                    return ptr ? UTF8ArrayToString(GROWABLE_HEAP_U8(), ptr, maxBytesToRead) : "";
                };
                var SYSCALLS = {
                    DEFAULT_POLLMASK: 5,
                    calculateAt: function(dirfd, path, allowEmpty) {
                        if (PATH.isAbs(path)) return path;
                        var dir;
                        if (dirfd === -100) dir = FS.cwd();
                        else {
                            var dirstream = SYSCALLS.getStreamFromFD(dirfd);
                            dir = dirstream.path;
                        }
                        if (path.length == 0) {
                            if (!allowEmpty) throw new FS.ErrnoError(44);
                            return dir;
                        }
                        return PATH.join2(dir, path);
                    },
                    doStat: function(func, path, buf) {
                        try {
                            var stat = func(path);
                        } catch (e) {
                            if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) return -54;
                            throw e;
                        }
                        GROWABLE_HEAP_I32()[buf >>> 2] = stat.dev;
                        GROWABLE_HEAP_I32()[buf + 4 >>> 2] = stat.mode;
                        GROWABLE_HEAP_U32()[buf + 8 >>> 2] = stat.nlink;
                        GROWABLE_HEAP_I32()[buf + 12 >>> 2] = stat.uid;
                        GROWABLE_HEAP_I32()[buf + 16 >>> 2] = stat.gid;
                        GROWABLE_HEAP_I32()[buf + 20 >>> 2] = stat.rdev;
                        tempI64 = [
                            stat.size >>> 0,
                            (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], GROWABLE_HEAP_I32()[buf + 24 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 28 >>> 2] = tempI64[1];
                        GROWABLE_HEAP_I32()[buf + 32 >>> 2] = 4096;
                        GROWABLE_HEAP_I32()[buf + 36 >>> 2] = stat.blocks;
                        var atime = stat.atime.getTime();
                        var mtime = stat.mtime.getTime();
                        var ctime = stat.ctime.getTime();
                        tempI64 = [
                            Math.floor(atime / 1e3) >>> 0,
                            (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], GROWABLE_HEAP_I32()[buf + 40 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 44 >>> 2] = tempI64[1];
                        GROWABLE_HEAP_U32()[buf + 48 >>> 2] = atime % 1e3 * 1e3;
                        tempI64 = [
                            Math.floor(mtime / 1e3) >>> 0,
                            (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], GROWABLE_HEAP_I32()[buf + 56 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 60 >>> 2] = tempI64[1];
                        GROWABLE_HEAP_U32()[buf + 64 >>> 2] = mtime % 1e3 * 1e3;
                        tempI64 = [
                            Math.floor(ctime / 1e3) >>> 0,
                            (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], GROWABLE_HEAP_I32()[buf + 72 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 76 >>> 2] = tempI64[1];
                        GROWABLE_HEAP_U32()[buf + 80 >>> 2] = ctime % 1e3 * 1e3;
                        tempI64 = [
                            stat.ino >>> 0,
                            (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], GROWABLE_HEAP_I32()[buf + 88 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 92 >>> 2] = tempI64[1];
                        return 0;
                    },
                    doMsync: function(addr, stream, len, flags, offset) {
                        if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                        if (flags & 2) return 0;
                        var buffer = GROWABLE_HEAP_U8().slice(addr, addr + len);
                        FS.msync(stream, buffer, offset, len, flags);
                    },
                    varargs: void 0,
                    get () {
                        SYSCALLS.varargs += 4;
                        var ret = GROWABLE_HEAP_I32()[SYSCALLS.varargs - 4 >>> 2];
                        return ret;
                    },
                    getStr (ptr) {
                        var ret = UTF8ToString(ptr);
                        return ret;
                    },
                    getStreamFromFD: function(fd) {
                        var stream = FS.getStreamChecked(fd);
                        return stream;
                    }
                };
                function _proc_exit(code) {
                    if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(1, 1, code);
                    EXITSTATUS = code;
                    if (!keepRuntimeAlive()) {
                        PThread.terminateAllThreads();
                        if (Module["onExit"]) Module["onExit"](code);
                        ABORT = true;
                    }
                    quit_(code, new ExitStatus(code));
                }
                var exitJS = (status, implicit)=>{
                    EXITSTATUS = status;
                    if (ENVIRONMENT_IS_PTHREAD) {
                        exitOnMainThread(status);
                        throw "unwind";
                    }
                    _proc_exit(status);
                };
                var _exit = exitJS;
                var handleException = (e)=>{
                    if (e instanceof ExitStatus || e == "unwind") return EXITSTATUS;
                    quit_(1, e);
                };
                var PThread = {
                    unusedWorkers: [],
                    runningWorkers: [],
                    tlsInitFunctions: [],
                    pthreads: {},
                    init: function() {
                        if (ENVIRONMENT_IS_PTHREAD) PThread.initWorker();
                        else PThread.initMainThread();
                    },
                    initMainThread: function() {
                        var pthreadPoolSize = navigator.hardwareConcurrency;
                        while(pthreadPoolSize--)PThread.allocateUnusedWorker();
                        addOnPreRun(()=>{
                            addRunDependency("loading-workers");
                            PThread.loadWasmModuleToAllWorkers(()=>removeRunDependency("loading-workers"));
                        });
                    },
                    initWorker: function() {
                        noExitRuntime = false;
                    },
                    setExitStatus: function(status) {
                        EXITSTATUS = status;
                    },
                    terminateAllThreads__deps: [
                        "$terminateWorker"
                    ],
                    terminateAllThreads: function() {
                        for (var worker of PThread.runningWorkers)terminateWorker(worker);
                        for (var worker of PThread.unusedWorkers)terminateWorker(worker);
                        PThread.unusedWorkers = [];
                        PThread.runningWorkers = [];
                        PThread.pthreads = [];
                    },
                    returnWorkerToPool: function(worker) {
                        var pthread_ptr = worker.pthread_ptr;
                        delete PThread.pthreads[pthread_ptr];
                        PThread.unusedWorkers.push(worker);
                        PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1);
                        worker.pthread_ptr = 0;
                        __emscripten_thread_free_data(pthread_ptr);
                    },
                    receiveObjectTransfer: function(data) {},
                    threadInitTLS: function() {
                        PThread.tlsInitFunctions.forEach((f)=>f());
                    },
                    loadWasmModuleToWorker: (worker)=>new Promise((onFinishedLoading)=>{
                            worker.onmessage = (e)=>{
                                var d = e["data"];
                                var cmd = d["cmd"];
                                if (d["targetThread"] && d["targetThread"] != _pthread_self()) {
                                    var targetWorker = PThread.pthreads[d.targetThread];
                                    if (targetWorker) targetWorker.postMessage(d, d["transferList"]);
                                    else err('Internal error! Worker sent a message "' + cmd + '" to target pthread ' + d["targetThread"] + ", but that thread no longer exists!");
                                    return;
                                }
                                if (cmd === "checkMailbox") checkMailbox();
                                else if (cmd === "spawnThread") spawnThread(d);
                                else if (cmd === "cleanupThread") cleanupThread(d["thread"]);
                                else if (cmd === "killThread") killThread(d["thread"]);
                                else if (cmd === "cancelThread") cancelThread(d["thread"]);
                                else if (cmd === "loaded") {
                                    worker.loaded = true;
                                    onFinishedLoading(worker);
                                } else if (cmd === "alert") alert("Thread " + d["threadId"] + ": " + d["text"]);
                                else if (d.target === "setimmediate") worker.postMessage(d);
                                else if (cmd === "callHandler") Module[d["handler"]](...d["args"]);
                                else if (cmd) err("worker sent an unknown command " + cmd);
                            };
                            worker.onerror = (e)=>{
                                var message = "worker sent an error!";
                                err(message + " " + e.filename + ":" + e.lineno + ": " + e.message);
                                throw e;
                            };
                            var handlers = [];
                            var knownHandlers = [
                                "onExit",
                                "onAbort",
                                "print",
                                "printErr"
                            ];
                            for (var handler of knownHandlers)if (Module.hasOwnProperty(handler)) handlers.push(handler);
                            worker.postMessage({
                                "cmd": "load",
                                "handlers": handlers,
                                "urlOrBlob": Module["mainScriptUrlOrBlob"] || _scriptDir,
                                "wasmMemory": wasmMemory,
                                "wasmModule": wasmModule
                            });
                        }),
                    loadWasmModuleToAllWorkers: function(onMaybeReady) {
                        if (ENVIRONMENT_IS_PTHREAD) return onMaybeReady();
                        let pthreadPoolReady = Promise.all(PThread.unusedWorkers.map(PThread.loadWasmModuleToWorker));
                        pthreadPoolReady.then(onMaybeReady);
                    },
                    allocateUnusedWorker: function() {
                        var worker;
                        var pthreadMainJs = locateFile("web-ifc-mt.worker.js");
                        worker = new Worker(pthreadMainJs);
                        PThread.unusedWorkers.push(worker);
                    },
                    getNewWorker: function() {
                        if (PThread.unusedWorkers.length == 0) {
                            PThread.allocateUnusedWorker();
                            PThread.loadWasmModuleToWorker(PThread.unusedWorkers[0]);
                        }
                        return PThread.unusedWorkers.pop();
                    }
                };
                Module["PThread"] = PThread;
                var callRuntimeCallbacks = (callbacks)=>{
                    while(callbacks.length > 0)callbacks.shift()(Module);
                };
                function establishStackSpace() {
                    var pthread_ptr = _pthread_self();
                    var stackHigh = GROWABLE_HEAP_I32()[pthread_ptr + 52 >>> 2];
                    var stackSize = GROWABLE_HEAP_I32()[pthread_ptr + 56 >>> 2];
                    var stackLow = stackHigh - stackSize;
                    _emscripten_stack_set_limits(stackHigh, stackLow);
                    stackRestore(stackHigh);
                }
                Module["establishStackSpace"] = establishStackSpace;
                function exitOnMainThread(returnCode) {
                    if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(2, 0, returnCode);
                    _exit(returnCode);
                }
                var wasmTableMirror = [];
                var getWasmTableEntry = (funcPtr)=>{
                    var func = wasmTableMirror[funcPtr];
                    if (!func) {
                        if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
                        wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
                    }
                    return func;
                };
                function invokeEntryPoint(ptr, arg) {
                    var result = getWasmTableEntry(ptr)(arg);
                    function finish(result2) {
                        if (keepRuntimeAlive()) PThread.setExitStatus(result2);
                        else __emscripten_thread_exit(result2);
                    }
                    finish(result);
                }
                Module["invokeEntryPoint"] = invokeEntryPoint;
                function registerTLSInit(tlsInitFunc) {
                    PThread.tlsInitFunctions.push(tlsInitFunc);
                }
                function ExceptionInfo(excPtr) {
                    this.excPtr = excPtr;
                    this.ptr = excPtr - 24;
                    this.set_type = function(type) {
                        GROWABLE_HEAP_U32()[this.ptr + 4 >>> 2] = type;
                    };
                    this.get_type = function() {
                        return GROWABLE_HEAP_U32()[this.ptr + 4 >>> 2];
                    };
                    this.set_destructor = function(destructor) {
                        GROWABLE_HEAP_U32()[this.ptr + 8 >>> 2] = destructor;
                    };
                    this.get_destructor = function() {
                        return GROWABLE_HEAP_U32()[this.ptr + 8 >>> 2];
                    };
                    this.set_caught = function(caught) {
                        caught = caught ? 1 : 0;
                        GROWABLE_HEAP_I8()[this.ptr + 12 >>> 0] = caught;
                    };
                    this.get_caught = function() {
                        return GROWABLE_HEAP_I8()[this.ptr + 12 >>> 0] != 0;
                    };
                    this.set_rethrown = function(rethrown) {
                        rethrown = rethrown ? 1 : 0;
                        GROWABLE_HEAP_I8()[this.ptr + 13 >>> 0] = rethrown;
                    };
                    this.get_rethrown = function() {
                        return GROWABLE_HEAP_I8()[this.ptr + 13 >>> 0] != 0;
                    };
                    this.init = function(type, destructor) {
                        this.set_adjusted_ptr(0);
                        this.set_type(type);
                        this.set_destructor(destructor);
                    };
                    this.set_adjusted_ptr = function(adjustedPtr) {
                        GROWABLE_HEAP_U32()[this.ptr + 16 >>> 2] = adjustedPtr;
                    };
                    this.get_adjusted_ptr = function() {
                        return GROWABLE_HEAP_U32()[this.ptr + 16 >>> 2];
                    };
                    this.get_exception_ptr = function() {
                        var isPointer = ___cxa_is_pointer_type(this.get_type());
                        if (isPointer) return GROWABLE_HEAP_U32()[this.excPtr >>> 2];
                        var adjusted = this.get_adjusted_ptr();
                        if (adjusted !== 0) return adjusted;
                        return this.excPtr;
                    };
                }
                var exceptionLast = 0;
                var uncaughtExceptionCount = 0;
                function convertI32PairToI53Checked(lo, hi) {
                    return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
                }
                function ___cxa_throw(ptr, type, destructor) {
                    ptr >>>= 0;
                    type >>>= 0;
                    destructor >>>= 0;
                    var info = new ExceptionInfo(ptr);
                    info.init(type, destructor);
                    exceptionLast = ptr;
                    uncaughtExceptionCount++;
                    throw exceptionLast;
                }
                function ___emscripten_init_main_thread_js(tb) {
                    tb >>>= 0;
                    __emscripten_thread_init(tb, !ENVIRONMENT_IS_WORKER, 1, !ENVIRONMENT_IS_WEB, 5242880, false);
                    PThread.threadInitTLS();
                }
                function ___emscripten_thread_cleanup(thread) {
                    thread >>>= 0;
                    if (!ENVIRONMENT_IS_PTHREAD) cleanupThread(thread);
                    else postMessage({
                        "cmd": "cleanupThread",
                        "thread": thread
                    });
                }
                var tupleRegistrations = {};
                function runDestructors(destructors) {
                    while(destructors.length){
                        var ptr = destructors.pop();
                        var del = destructors.pop();
                        del(ptr);
                    }
                }
                function simpleReadValueFromPointer(pointer) {
                    return this["fromWireType"](GROWABLE_HEAP_I32()[pointer >>> 2]);
                }
                var awaitingDependencies = {};
                var registeredTypes = {};
                var typeDependencies = {};
                var InternalError = void 0;
                function throwInternalError(message) {
                    throw new InternalError(message);
                }
                function whenDependentTypesAreResolved(myTypes, dependentTypes, getTypeConverters) {
                    myTypes.forEach(function(type) {
                        typeDependencies[type] = dependentTypes;
                    });
                    function onComplete(typeConverters2) {
                        var myTypeConverters = getTypeConverters(typeConverters2);
                        if (myTypeConverters.length !== myTypes.length) throwInternalError("Mismatched type converter count");
                        for(var i = 0; i < myTypes.length; ++i)registerType(myTypes[i], myTypeConverters[i]);
                    }
                    var typeConverters = new Array(dependentTypes.length);
                    var unregisteredTypes = [];
                    var registered = 0;
                    dependentTypes.forEach((dt, i)=>{
                        if (registeredTypes.hasOwnProperty(dt)) typeConverters[i] = registeredTypes[dt];
                        else {
                            unregisteredTypes.push(dt);
                            if (!awaitingDependencies.hasOwnProperty(dt)) awaitingDependencies[dt] = [];
                            awaitingDependencies[dt].push(()=>{
                                typeConverters[i] = registeredTypes[dt];
                                ++registered;
                                if (registered === unregisteredTypes.length) onComplete(typeConverters);
                            });
                        }
                    });
                    if (0 === unregisteredTypes.length) onComplete(typeConverters);
                }
                function __embind_finalize_value_array(rawTupleType) {
                    rawTupleType >>>= 0;
                    var reg = tupleRegistrations[rawTupleType];
                    delete tupleRegistrations[rawTupleType];
                    var elements = reg.elements;
                    var elementsLength = elements.length;
                    var elementTypes = elements.map(function(elt) {
                        return elt.getterReturnType;
                    }).concat(elements.map(function(elt) {
                        return elt.setterArgumentType;
                    }));
                    var rawConstructor = reg.rawConstructor;
                    var rawDestructor = reg.rawDestructor;
                    whenDependentTypesAreResolved([
                        rawTupleType
                    ], elementTypes, function(elementTypes2) {
                        elements.forEach((elt, i)=>{
                            var getterReturnType = elementTypes2[i];
                            var getter = elt.getter;
                            var getterContext = elt.getterContext;
                            var setterArgumentType = elementTypes2[i + elementsLength];
                            var setter = elt.setter;
                            var setterContext = elt.setterContext;
                            elt.read = (ptr)=>getterReturnType["fromWireType"](getter(getterContext, ptr));
                            elt.write = (ptr, o)=>{
                                var destructors = [];
                                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                                runDestructors(destructors);
                            };
                        });
                        return [
                            {
                                name: reg.name,
                                "fromWireType": function(ptr) {
                                    var rv = new Array(elementsLength);
                                    for(var i = 0; i < elementsLength; ++i)rv[i] = elements[i].read(ptr);
                                    rawDestructor(ptr);
                                    return rv;
                                },
                                "toWireType": function(destructors, o) {
                                    if (elementsLength !== o.length) throw new TypeError(`Incorrect number of tuple elements for ${reg.name}: expected=${elementsLength}, actual=${o.length}`);
                                    var ptr = rawConstructor();
                                    for(var i = 0; i < elementsLength; ++i)elements[i].write(ptr, o[i]);
                                    if (destructors !== null) destructors.push(rawDestructor, ptr);
                                    return ptr;
                                },
                                "argPackAdvance": 8,
                                "readValueFromPointer": simpleReadValueFromPointer,
                                destructorFunction: rawDestructor
                            }
                        ];
                    });
                }
                var structRegistrations = {};
                var __embind_finalize_value_object = function(structType) {
                    structType >>>= 0;
                    var reg = structRegistrations[structType];
                    delete structRegistrations[structType];
                    var rawConstructor = reg.rawConstructor;
                    var rawDestructor = reg.rawDestructor;
                    var fieldRecords = reg.fields;
                    var fieldTypes = fieldRecords.map((field)=>field.getterReturnType).concat(fieldRecords.map((field)=>field.setterArgumentType));
                    whenDependentTypesAreResolved([
                        structType
                    ], fieldTypes, (fieldTypes2)=>{
                        var fields = {};
                        fieldRecords.forEach((field, i)=>{
                            var fieldName = field.fieldName;
                            var getterReturnType = fieldTypes2[i];
                            var getter = field.getter;
                            var getterContext = field.getterContext;
                            var setterArgumentType = fieldTypes2[i + fieldRecords.length];
                            var setter = field.setter;
                            var setterContext = field.setterContext;
                            fields[fieldName] = {
                                read: (ptr)=>getterReturnType["fromWireType"](getter(getterContext, ptr)),
                                write: (ptr, o)=>{
                                    var destructors = [];
                                    setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                                    runDestructors(destructors);
                                }
                            };
                        });
                        return [
                            {
                                name: reg.name,
                                "fromWireType": function(ptr) {
                                    var rv = {};
                                    for(var i in fields)rv[i] = fields[i].read(ptr);
                                    rawDestructor(ptr);
                                    return rv;
                                },
                                "toWireType": function(destructors, o) {
                                    for(var fieldName in fields){
                                        if (!(fieldName in o)) throw new TypeError(`Missing field: "${fieldName}"`);
                                    }
                                    var ptr = rawConstructor();
                                    for(fieldName in fields)fields[fieldName].write(ptr, o[fieldName]);
                                    if (destructors !== null) destructors.push(rawDestructor, ptr);
                                    return ptr;
                                },
                                "argPackAdvance": 8,
                                "readValueFromPointer": simpleReadValueFromPointer,
                                destructorFunction: rawDestructor
                            }
                        ];
                    });
                };
                function __embind_register_bigint(primitiveType, name, size, minRange, maxRange) {
                    primitiveType >>>= 0;
                    name >>>= 0;
                    size >>>= 0;
                }
                function getShiftFromSize(size) {
                    switch(size){
                        case 1:
                            return 0;
                        case 2:
                            return 1;
                        case 4:
                            return 2;
                        case 8:
                            return 3;
                        default:
                            throw new TypeError(`Unknown type size: ${size}`);
                    }
                }
                function embind_init_charCodes() {
                    var codes = new Array(256);
                    for(var i = 0; i < 256; ++i)codes[i] = String.fromCharCode(i);
                    embind_charCodes = codes;
                }
                var embind_charCodes = void 0;
                function readLatin1String(ptr) {
                    var ret = "";
                    var c = ptr;
                    while(GROWABLE_HEAP_U8()[c >>> 0])ret += embind_charCodes[GROWABLE_HEAP_U8()[c++ >>> 0]];
                    return ret;
                }
                var BindingError = void 0;
                function throwBindingError(message) {
                    throw new BindingError(message);
                }
                function sharedRegisterType(rawType, registeredInstance, options = {}) {
                    var name = registeredInstance.name;
                    if (!rawType) throwBindingError(`type "${name}" must have a positive integer typeid pointer`);
                    if (registeredTypes.hasOwnProperty(rawType)) {
                        if (options.ignoreDuplicateRegistrations) return;
                        else throwBindingError(`Cannot register type '${name}' twice`);
                    }
                    registeredTypes[rawType] = registeredInstance;
                    delete typeDependencies[rawType];
                    if (awaitingDependencies.hasOwnProperty(rawType)) {
                        var callbacks = awaitingDependencies[rawType];
                        delete awaitingDependencies[rawType];
                        callbacks.forEach((cb)=>cb());
                    }
                }
                function registerType(rawType, registeredInstance, options = {}) {
                    if (!("argPackAdvance" in registeredInstance)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
                    return sharedRegisterType(rawType, registeredInstance, options);
                }
                function __embind_register_bool(rawType, name, size, trueValue, falseValue) {
                    rawType >>>= 0;
                    name >>>= 0;
                    size >>>= 0;
                    var shift = getShiftFromSize(size);
                    name = readLatin1String(name);
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(wt) {
                            return !!wt;
                        },
                        "toWireType": function(destructors, o) {
                            return o ? trueValue : falseValue;
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": function(pointer) {
                            var heap;
                            if (size === 1) heap = GROWABLE_HEAP_I8();
                            else if (size === 2) heap = GROWABLE_HEAP_I16();
                            else if (size === 4) heap = GROWABLE_HEAP_I32();
                            else throw new TypeError("Unknown boolean type size: " + name);
                            return this["fromWireType"](heap[pointer >>> shift]);
                        },
                        destructorFunction: null
                    });
                }
                function ClassHandle_isAliasOf(other) {
                    if (!(this instanceof ClassHandle)) return false;
                    if (!(other instanceof ClassHandle)) return false;
                    var leftClass = this.$$.ptrType.registeredClass;
                    var left = this.$$.ptr;
                    var rightClass = other.$$.ptrType.registeredClass;
                    var right = other.$$.ptr;
                    while(leftClass.baseClass){
                        left = leftClass.upcast(left);
                        leftClass = leftClass.baseClass;
                    }
                    while(rightClass.baseClass){
                        right = rightClass.upcast(right);
                        rightClass = rightClass.baseClass;
                    }
                    return leftClass === rightClass && left === right;
                }
                function shallowCopyInternalPointer(o) {
                    return {
                        count: o.count,
                        deleteScheduled: o.deleteScheduled,
                        preservePointerOnDelete: o.preservePointerOnDelete,
                        ptr: o.ptr,
                        ptrType: o.ptrType,
                        smartPtr: o.smartPtr,
                        smartPtrType: o.smartPtrType
                    };
                }
                function throwInstanceAlreadyDeleted(obj) {
                    function getInstanceTypeName(handle) {
                        return handle.$$.ptrType.registeredClass.name;
                    }
                    throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
                }
                var finalizationRegistry = false;
                function detachFinalizer(handle) {}
                function runDestructor($$) {
                    if ($$.smartPtr) $$.smartPtrType.rawDestructor($$.smartPtr);
                    else $$.ptrType.registeredClass.rawDestructor($$.ptr);
                }
                function releaseClassHandle($$) {
                    $$.count.value -= 1;
                    var toDelete = 0 === $$.count.value;
                    if (toDelete) runDestructor($$);
                }
                function downcastPointer(ptr, ptrClass, desiredClass) {
                    if (ptrClass === desiredClass) return ptr;
                    if (void 0 === desiredClass.baseClass) return null;
                    var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);
                    if (rv === null) return null;
                    return desiredClass.downcast(rv);
                }
                var registeredPointers = {};
                function getInheritedInstanceCount() {
                    return Object.keys(registeredInstances).length;
                }
                function getLiveInheritedInstances() {
                    var rv = [];
                    for(var k in registeredInstances)if (registeredInstances.hasOwnProperty(k)) rv.push(registeredInstances[k]);
                    return rv;
                }
                var deletionQueue = [];
                function flushPendingDeletes() {
                    while(deletionQueue.length){
                        var obj = deletionQueue.pop();
                        obj.$$.deleteScheduled = false;
                        obj["delete"]();
                    }
                }
                var delayFunction = void 0;
                function setDelayFunction(fn) {
                    delayFunction = fn;
                    if (deletionQueue.length && delayFunction) delayFunction(flushPendingDeletes);
                }
                function init_embind() {
                    Module["getInheritedInstanceCount"] = getInheritedInstanceCount;
                    Module["getLiveInheritedInstances"] = getLiveInheritedInstances;
                    Module["flushPendingDeletes"] = flushPendingDeletes;
                    Module["setDelayFunction"] = setDelayFunction;
                }
                var registeredInstances = {};
                function getBasestPointer(class_, ptr) {
                    if (ptr === void 0) throwBindingError("ptr should not be undefined");
                    while(class_.baseClass){
                        ptr = class_.upcast(ptr);
                        class_ = class_.baseClass;
                    }
                    return ptr;
                }
                function getInheritedInstance(class_, ptr) {
                    ptr = getBasestPointer(class_, ptr);
                    return registeredInstances[ptr];
                }
                function makeClassHandle(prototype, record) {
                    if (!record.ptrType || !record.ptr) throwInternalError("makeClassHandle requires ptr and ptrType");
                    var hasSmartPtrType = !!record.smartPtrType;
                    var hasSmartPtr = !!record.smartPtr;
                    if (hasSmartPtrType !== hasSmartPtr) throwInternalError("Both smartPtrType and smartPtr must be specified");
                    record.count = {
                        value: 1
                    };
                    return attachFinalizer(Object.create(prototype, {
                        $$: {
                            value: record
                        }
                    }));
                }
                function RegisteredPointer_fromWireType(ptr) {
                    var rawPointer = this.getPointee(ptr);
                    if (!rawPointer) {
                        this.destructor(ptr);
                        return null;
                    }
                    var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);
                    if (void 0 !== registeredInstance) {
                        if (0 === registeredInstance.$$.count.value) {
                            registeredInstance.$$.ptr = rawPointer;
                            registeredInstance.$$.smartPtr = ptr;
                            return registeredInstance["clone"]();
                        } else {
                            var rv = registeredInstance["clone"]();
                            this.destructor(ptr);
                            return rv;
                        }
                    }
                    function makeDefaultHandle() {
                        if (this.isSmartPointer) return makeClassHandle(this.registeredClass.instancePrototype, {
                            ptrType: this.pointeeType,
                            ptr: rawPointer,
                            smartPtrType: this,
                            smartPtr: ptr
                        });
                        else return makeClassHandle(this.registeredClass.instancePrototype, {
                            ptrType: this,
                            ptr: ptr
                        });
                    }
                    var actualType = this.registeredClass.getActualType(rawPointer);
                    var registeredPointerRecord = registeredPointers[actualType];
                    if (!registeredPointerRecord) return makeDefaultHandle.call(this);
                    var toType;
                    if (this.isConst) toType = registeredPointerRecord.constPointerType;
                    else toType = registeredPointerRecord.pointerType;
                    var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
                    if (dp === null) return makeDefaultHandle.call(this);
                    if (this.isSmartPointer) return makeClassHandle(toType.registeredClass.instancePrototype, {
                        ptrType: toType,
                        ptr: dp,
                        smartPtrType: this,
                        smartPtr: ptr
                    });
                    else return makeClassHandle(toType.registeredClass.instancePrototype, {
                        ptrType: toType,
                        ptr: dp
                    });
                }
                var attachFinalizer = function(handle) {
                    if ("undefined" === typeof FinalizationRegistry) {
                        attachFinalizer = (handle2)=>handle2;
                        return handle;
                    }
                    finalizationRegistry = new FinalizationRegistry((info)=>{
                        releaseClassHandle(info.$$);
                    });
                    attachFinalizer = (handle2)=>{
                        var $$ = handle2.$$;
                        var hasSmartPtr = !!$$.smartPtr;
                        if (hasSmartPtr) {
                            var info = {
                                $$: $$
                            };
                            finalizationRegistry.register(handle2, info, handle2);
                        }
                        return handle2;
                    };
                    detachFinalizer = (handle2)=>finalizationRegistry.unregister(handle2);
                    return attachFinalizer(handle);
                };
                function ClassHandle_clone() {
                    if (!this.$$.ptr) throwInstanceAlreadyDeleted(this);
                    if (this.$$.preservePointerOnDelete) {
                        this.$$.count.value += 1;
                        return this;
                    } else {
                        var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), {
                            $$: {
                                value: shallowCopyInternalPointer(this.$$)
                            }
                        }));
                        clone.$$.count.value += 1;
                        clone.$$.deleteScheduled = false;
                        return clone;
                    }
                }
                function ClassHandle_delete() {
                    if (!this.$$.ptr) throwInstanceAlreadyDeleted(this);
                    if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) throwBindingError("Object already scheduled for deletion");
                    detachFinalizer(this);
                    releaseClassHandle(this.$$);
                    if (!this.$$.preservePointerOnDelete) {
                        this.$$.smartPtr = void 0;
                        this.$$.ptr = void 0;
                    }
                }
                function ClassHandle_isDeleted() {
                    return !this.$$.ptr;
                }
                function ClassHandle_deleteLater() {
                    if (!this.$$.ptr) throwInstanceAlreadyDeleted(this);
                    if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) throwBindingError("Object already scheduled for deletion");
                    deletionQueue.push(this);
                    if (deletionQueue.length === 1 && delayFunction) delayFunction(flushPendingDeletes);
                    this.$$.deleteScheduled = true;
                    return this;
                }
                function init_ClassHandle() {
                    ClassHandle.prototype["isAliasOf"] = ClassHandle_isAliasOf;
                    ClassHandle.prototype["clone"] = ClassHandle_clone;
                    ClassHandle.prototype["delete"] = ClassHandle_delete;
                    ClassHandle.prototype["isDeleted"] = ClassHandle_isDeleted;
                    ClassHandle.prototype["deleteLater"] = ClassHandle_deleteLater;
                }
                function ClassHandle() {}
                var char_0 = 48;
                var char_9 = 57;
                function makeLegalFunctionName(name) {
                    if (void 0 === name) return "_unknown";
                    name = name.replace(/[^a-zA-Z0-9_]/g, "$");
                    var f = name.charCodeAt(0);
                    if (f >= char_0 && f <= char_9) return `_${name}`;
                    return name;
                }
                function createNamedFunction(name, body) {
                    name = makeLegalFunctionName(name);
                    return ({
                        [name]: function() {
                            return body.apply(this, arguments);
                        }
                    })[name];
                }
                function ensureOverloadTable(proto, methodName, humanName) {
                    if (void 0 === proto[methodName].overloadTable) {
                        var prevFunc = proto[methodName];
                        proto[methodName] = function() {
                            if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) throwBindingError(`Function '${humanName}' called with an invalid number of arguments (${arguments.length}) - expects one of (${proto[methodName].overloadTable})!`);
                            return proto[methodName].overloadTable[arguments.length].apply(this, arguments);
                        };
                        proto[methodName].overloadTable = [];
                        proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
                    }
                }
                function exposePublicSymbol(name, value, numArguments) {
                    if (Module.hasOwnProperty(name)) {
                        if (void 0 === numArguments || void 0 !== Module[name].overloadTable && void 0 !== Module[name].overloadTable[numArguments]) throwBindingError(`Cannot register public name '${name}' twice`);
                        ensureOverloadTable(Module, name, name);
                        if (Module.hasOwnProperty(numArguments)) throwBindingError(`Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`);
                        Module[name].overloadTable[numArguments] = value;
                    } else {
                        Module[name] = value;
                        if (void 0 !== numArguments) Module[name].numArguments = numArguments;
                    }
                }
                function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
                    this.name = name;
                    this.constructor = constructor;
                    this.instancePrototype = instancePrototype;
                    this.rawDestructor = rawDestructor;
                    this.baseClass = baseClass;
                    this.getActualType = getActualType;
                    this.upcast = upcast;
                    this.downcast = downcast;
                    this.pureVirtualFunctions = [];
                }
                function upcastPointer(ptr, ptrClass, desiredClass) {
                    while(ptrClass !== desiredClass){
                        if (!ptrClass.upcast) throwBindingError(`Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`);
                        ptr = ptrClass.upcast(ptr);
                        ptrClass = ptrClass.baseClass;
                    }
                    return ptr;
                }
                function constNoSmartPtrRawPointerToWireType(destructors, handle) {
                    if (handle === null) {
                        if (this.isReference) throwBindingError(`null is not a valid ${this.name}`);
                        return 0;
                    }
                    if (!handle.$$) throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
                    if (!handle.$$.ptr) throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
                    var handleClass = handle.$$.ptrType.registeredClass;
                    var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
                    return ptr;
                }
                function genericPointerToWireType(destructors, handle) {
                    var ptr;
                    if (handle === null) {
                        if (this.isReference) throwBindingError(`null is not a valid ${this.name}`);
                        if (this.isSmartPointer) {
                            ptr = this.rawConstructor();
                            if (destructors !== null) destructors.push(this.rawDestructor, ptr);
                            return ptr;
                        } else return 0;
                    }
                    if (!handle.$$) throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
                    if (!handle.$$.ptr) throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
                    if (!this.isConst && handle.$$.ptrType.isConst) throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
                    var handleClass = handle.$$.ptrType.registeredClass;
                    ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
                    if (this.isSmartPointer) {
                        if (void 0 === handle.$$.smartPtr) throwBindingError("Passing raw pointer to smart pointer is illegal");
                        switch(this.sharingPolicy){
                            case 0:
                                if (handle.$$.smartPtrType === this) ptr = handle.$$.smartPtr;
                                else throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
                                break;
                            case 1:
                                ptr = handle.$$.smartPtr;
                                break;
                            case 2:
                                if (handle.$$.smartPtrType === this) ptr = handle.$$.smartPtr;
                                else {
                                    var clonedHandle = handle["clone"]();
                                    ptr = this.rawShare(ptr, Emval.toHandle(function() {
                                        clonedHandle["delete"]();
                                    }));
                                    if (destructors !== null) destructors.push(this.rawDestructor, ptr);
                                }
                                break;
                            default:
                                throwBindingError("Unsupporting sharing policy");
                        }
                    }
                    return ptr;
                }
                function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
                    if (handle === null) {
                        if (this.isReference) throwBindingError(`null is not a valid ${this.name}`);
                        return 0;
                    }
                    if (!handle.$$) throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
                    if (!handle.$$.ptr) throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
                    if (handle.$$.ptrType.isConst) throwBindingError(`Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`);
                    var handleClass = handle.$$.ptrType.registeredClass;
                    var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
                    return ptr;
                }
                function RegisteredPointer_getPointee(ptr) {
                    if (this.rawGetPointee) ptr = this.rawGetPointee(ptr);
                    return ptr;
                }
                function RegisteredPointer_destructor(ptr) {
                    if (this.rawDestructor) this.rawDestructor(ptr);
                }
                function RegisteredPointer_deleteObject(handle) {
                    if (handle !== null) handle["delete"]();
                }
                function init_RegisteredPointer() {
                    RegisteredPointer.prototype.getPointee = RegisteredPointer_getPointee;
                    RegisteredPointer.prototype.destructor = RegisteredPointer_destructor;
                    RegisteredPointer.prototype["argPackAdvance"] = 8;
                    RegisteredPointer.prototype["readValueFromPointer"] = simpleReadValueFromPointer;
                    RegisteredPointer.prototype["deleteObject"] = RegisteredPointer_deleteObject;
                    RegisteredPointer.prototype["fromWireType"] = RegisteredPointer_fromWireType;
                }
                function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
                    this.name = name;
                    this.registeredClass = registeredClass;
                    this.isReference = isReference;
                    this.isConst = isConst;
                    this.isSmartPointer = isSmartPointer;
                    this.pointeeType = pointeeType;
                    this.sharingPolicy = sharingPolicy;
                    this.rawGetPointee = rawGetPointee;
                    this.rawConstructor = rawConstructor;
                    this.rawShare = rawShare;
                    this.rawDestructor = rawDestructor;
                    if (!isSmartPointer && registeredClass.baseClass === void 0) {
                        if (isConst) {
                            this["toWireType"] = constNoSmartPtrRawPointerToWireType;
                            this.destructorFunction = null;
                        } else {
                            this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
                            this.destructorFunction = null;
                        }
                    } else this["toWireType"] = genericPointerToWireType;
                }
                function replacePublicSymbol(name, value, numArguments) {
                    if (!Module.hasOwnProperty(name)) throwInternalError("Replacing nonexistant public symbol");
                    if (void 0 !== Module[name].overloadTable && void 0 !== numArguments) Module[name].overloadTable[numArguments] = value;
                    else {
                        Module[name] = value;
                        Module[name].argCount = numArguments;
                    }
                }
                var dynCallLegacy = (sig, ptr, args)=>{
                    var f = Module["dynCall_" + sig];
                    return args && args.length ? f.apply(null, [
                        ptr
                    ].concat(args)) : f.call(null, ptr);
                };
                var dynCall = (sig, ptr, args)=>{
                    if (sig.includes("j")) return dynCallLegacy(sig, ptr, args);
                    var rtn = getWasmTableEntry(ptr).apply(null, args);
                    return rtn;
                };
                var getDynCaller = (sig, ptr)=>{
                    var argCache = [];
                    return function() {
                        argCache.length = 0;
                        Object.assign(argCache, arguments);
                        return dynCall(sig, ptr, argCache);
                    };
                };
                function embind__requireFunction(signature, rawFunction) {
                    signature = readLatin1String(signature);
                    function makeDynCaller() {
                        if (signature.includes("j")) return getDynCaller(signature, rawFunction);
                        return getWasmTableEntry(rawFunction);
                    }
                    var fp = makeDynCaller();
                    if (typeof fp != "function") throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`);
                    return fp;
                }
                function extendError(baseErrorType, errorName) {
                    var errorClass = createNamedFunction(errorName, function(message) {
                        this.name = errorName;
                        this.message = message;
                        var stack = new Error(message).stack;
                        if (stack !== void 0) this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "");
                    });
                    errorClass.prototype = Object.create(baseErrorType.prototype);
                    errorClass.prototype.constructor = errorClass;
                    errorClass.prototype.toString = function() {
                        if (this.message === void 0) return this.name;
                        else return `${this.name}: ${this.message}`;
                    };
                    return errorClass;
                }
                var UnboundTypeError = void 0;
                function getTypeName(type) {
                    var ptr = ___getTypeName(type);
                    var rv = readLatin1String(ptr);
                    _free(ptr);
                    return rv;
                }
                function throwUnboundTypeError(message, types) {
                    var unboundTypes = [];
                    var seen = {};
                    function visit(type) {
                        if (seen[type]) return;
                        if (registeredTypes[type]) return;
                        if (typeDependencies[type]) {
                            typeDependencies[type].forEach(visit);
                            return;
                        }
                        unboundTypes.push(type);
                        seen[type] = true;
                    }
                    types.forEach(visit);
                    throw new UnboundTypeError(`${message}: ` + unboundTypes.map(getTypeName).join([
                        ", "
                    ]));
                }
                function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
                    rawType >>>= 0;
                    rawPointerType >>>= 0;
                    rawConstPointerType >>>= 0;
                    baseClassRawType >>>= 0;
                    getActualTypeSignature >>>= 0;
                    getActualType >>>= 0;
                    upcastSignature >>>= 0;
                    upcast >>>= 0;
                    downcastSignature >>>= 0;
                    downcast >>>= 0;
                    name >>>= 0;
                    destructorSignature >>>= 0;
                    rawDestructor >>>= 0;
                    name = readLatin1String(name);
                    getActualType = embind__requireFunction(getActualTypeSignature, getActualType);
                    if (upcast) upcast = embind__requireFunction(upcastSignature, upcast);
                    if (downcast) downcast = embind__requireFunction(downcastSignature, downcast);
                    rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
                    var legalFunctionName = makeLegalFunctionName(name);
                    exposePublicSymbol(legalFunctionName, function() {
                        throwUnboundTypeError(`Cannot construct ${name} due to unbound types`, [
                            baseClassRawType
                        ]);
                    });
                    whenDependentTypesAreResolved([
                        rawType,
                        rawPointerType,
                        rawConstPointerType
                    ], baseClassRawType ? [
                        baseClassRawType
                    ] : [], function(base) {
                        base = base[0];
                        var baseClass;
                        var basePrototype;
                        if (baseClassRawType) {
                            baseClass = base.registeredClass;
                            basePrototype = baseClass.instancePrototype;
                        } else basePrototype = ClassHandle.prototype;
                        var constructor = createNamedFunction(legalFunctionName, function() {
                            if (Object.getPrototypeOf(this) !== instancePrototype) throw new BindingError("Use 'new' to construct " + name);
                            if (void 0 === registeredClass.constructor_body) throw new BindingError(name + " has no accessible constructor");
                            var body = registeredClass.constructor_body[arguments.length];
                            if (void 0 === body) throw new BindingError(`Tried to invoke ctor of ${name} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`);
                            return body.apply(this, arguments);
                        });
                        var instancePrototype = Object.create(basePrototype, {
                            constructor: {
                                value: constructor
                            }
                        });
                        constructor.prototype = instancePrototype;
                        var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
                        if (registeredClass.baseClass) {
                            if (registeredClass.baseClass.__derivedClasses === void 0) registeredClass.baseClass.__derivedClasses = [];
                            registeredClass.baseClass.__derivedClasses.push(registeredClass);
                        }
                        var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
                        var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
                        var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
                        registeredPointers[rawType] = {
                            pointerType: pointerConverter,
                            constPointerType: constPointerConverter
                        };
                        replacePublicSymbol(legalFunctionName, constructor);
                        return [
                            referenceConverter,
                            pointerConverter,
                            constPointerConverter
                        ];
                    });
                }
                function heap32VectorToArray(count, firstElement) {
                    var array = [];
                    for(var i = 0; i < count; i++)array.push(GROWABLE_HEAP_U32()[firstElement + i * 4 >>> 2]);
                    return array;
                }
                function newFunc(constructor, argumentList) {
                    if (!(constructor instanceof Function)) throw new TypeError(`new_ called with constructor type ${typeof constructor} which is not a function`);
                    var dummy = createNamedFunction(constructor.name || "unknownFunctionName", function() {});
                    dummy.prototype = constructor.prototype;
                    var obj = new dummy();
                    var r = constructor.apply(obj, argumentList);
                    return r instanceof Object ? r : obj;
                }
                function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc, isAsync) {
                    var argCount = argTypes.length;
                    if (argCount < 2) throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
                    var isClassMethodFunc = argTypes[1] !== null && classType !== null;
                    var needsDestructorStack = false;
                    for(var i = 1; i < argTypes.length; ++i)if (argTypes[i] !== null && argTypes[i].destructorFunction === void 0) {
                        needsDestructorStack = true;
                        break;
                    }
                    var returns = argTypes[0].name !== "void";
                    var argsList = "";
                    var argsListWired = "";
                    for(var i = 0; i < argCount - 2; ++i){
                        argsList += (i !== 0 ? ", " : "") + "arg" + i;
                        argsListWired += (i !== 0 ? ", " : "") + "arg" + i + "Wired";
                    }
                    var invokerFnBody = `
        return function ${makeLegalFunctionName(humanName)}(${argsList}) {
        if (arguments.length !== ${argCount - 2}) {
          throwBindingError('function ${humanName} called with ${arguments.length} arguments, expected ${argCount - 2} args!');
        }`;
                    if (needsDestructorStack) invokerFnBody += "var destructors = [];\n";
                    var dtorStack = needsDestructorStack ? "destructors" : "null";
                    var args1 = [
                        "throwBindingError",
                        "invoker",
                        "fn",
                        "runDestructors",
                        "retType",
                        "classParam"
                    ];
                    var args2 = [
                        throwBindingError,
                        cppInvokerFunc,
                        cppTargetFunc,
                        runDestructors,
                        argTypes[0],
                        argTypes[1]
                    ];
                    if (isClassMethodFunc) invokerFnBody += "var thisWired = classParam.toWireType(" + dtorStack + ", this);\n";
                    for(var i = 0; i < argCount - 2; ++i){
                        invokerFnBody += "var arg" + i + "Wired = argType" + i + ".toWireType(" + dtorStack + ", arg" + i + "); // " + argTypes[i + 2].name + "\n";
                        args1.push("argType" + i);
                        args2.push(argTypes[i + 2]);
                    }
                    if (isClassMethodFunc) argsListWired = "thisWired" + (argsListWired.length > 0 ? ", " : "") + argsListWired;
                    invokerFnBody += (returns || isAsync ? "var rv = " : "") + "invoker(fn" + (argsListWired.length > 0 ? ", " : "") + argsListWired + ");\n";
                    if (needsDestructorStack) invokerFnBody += "runDestructors(destructors);\n";
                    else for(var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i){
                        var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";
                        if (argTypes[i].destructorFunction !== null) {
                            invokerFnBody += paramName + "_dtor(" + paramName + "); // " + argTypes[i].name + "\n";
                            args1.push(paramName + "_dtor");
                            args2.push(argTypes[i].destructorFunction);
                        }
                    }
                    if (returns) invokerFnBody += "var ret = retType.fromWireType(rv);\nreturn ret;\n";
                    invokerFnBody += "}\n";
                    args1.push(invokerFnBody);
                    return newFunc(Function, args1).apply(null, args2);
                }
                function __embind_register_class_constructor(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
                    rawClassType >>>= 0;
                    rawArgTypesAddr >>>= 0;
                    invokerSignature >>>= 0;
                    invoker >>>= 0;
                    rawConstructor >>>= 0;
                    var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                    invoker = embind__requireFunction(invokerSignature, invoker);
                    whenDependentTypesAreResolved([], [
                        rawClassType
                    ], function(classType) {
                        classType = classType[0];
                        var humanName = `constructor ${classType.name}`;
                        if (void 0 === classType.registeredClass.constructor_body) classType.registeredClass.constructor_body = [];
                        if (void 0 !== classType.registeredClass.constructor_body[argCount - 1]) throw new BindingError(`Cannot register multiple constructors with identical number of parameters (${argCount - 1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                        classType.registeredClass.constructor_body[argCount - 1] = ()=>{
                            throwUnboundTypeError(`Cannot construct ${classType.name} due to unbound types`, rawArgTypes);
                        };
                        whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
                            argTypes.splice(1, 0, null);
                            classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
                            return [];
                        });
                        return [];
                    });
                }
                function __embind_register_class_function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual, isAsync) {
                    rawClassType >>>= 0;
                    methodName >>>= 0;
                    rawArgTypesAddr >>>= 0;
                    invokerSignature >>>= 0;
                    rawInvoker >>>= 0;
                    context >>>= 0;
                    var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                    methodName = readLatin1String(methodName);
                    rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
                    whenDependentTypesAreResolved([], [
                        rawClassType
                    ], function(classType) {
                        classType = classType[0];
                        var humanName = `${classType.name}.${methodName}`;
                        if (methodName.startsWith("@@")) methodName = Symbol[methodName.substring(2)];
                        if (isPureVirtual) classType.registeredClass.pureVirtualFunctions.push(methodName);
                        function unboundTypesHandler() {
                            throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`, rawArgTypes);
                        }
                        var proto = classType.registeredClass.instancePrototype;
                        var method = proto[methodName];
                        if (void 0 === method || void 0 === method.overloadTable && method.className !== classType.name && method.argCount === argCount - 2) {
                            unboundTypesHandler.argCount = argCount - 2;
                            unboundTypesHandler.className = classType.name;
                            proto[methodName] = unboundTypesHandler;
                        } else {
                            ensureOverloadTable(proto, methodName, humanName);
                            proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
                        }
                        whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
                            var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context, isAsync);
                            if (void 0 === proto[methodName].overloadTable) {
                                memberFunction.argCount = argCount - 2;
                                proto[methodName] = memberFunction;
                            } else proto[methodName].overloadTable[argCount - 2] = memberFunction;
                            return [];
                        });
                        return [];
                    });
                }
                function handleAllocatorInit() {
                    Object.assign(HandleAllocator.prototype, {
                        get (id) {
                            return this.allocated[id];
                        },
                        has (id) {
                            return this.allocated[id] !== void 0;
                        },
                        allocate (handle) {
                            var id = this.freelist.pop() || this.allocated.length;
                            this.allocated[id] = handle;
                            return id;
                        },
                        free (id) {
                            this.allocated[id] = void 0;
                            this.freelist.push(id);
                        }
                    });
                }
                function HandleAllocator() {
                    this.allocated = [
                        void 0
                    ];
                    this.freelist = [];
                }
                var emval_handles = new HandleAllocator();
                function __emval_decref(handle) {
                    handle >>>= 0;
                    if (handle >= emval_handles.reserved && 0 === --emval_handles.get(handle).refcount) emval_handles.free(handle);
                }
                function count_emval_handles() {
                    var count = 0;
                    for(var i = emval_handles.reserved; i < emval_handles.allocated.length; ++i)if (emval_handles.allocated[i] !== void 0) ++count;
                    return count;
                }
                function init_emval() {
                    emval_handles.allocated.push({
                        value: void 0
                    }, {
                        value: null
                    }, {
                        value: true
                    }, {
                        value: false
                    });
                    emval_handles.reserved = emval_handles.allocated.length;
                    Module["count_emval_handles"] = count_emval_handles;
                }
                var Emval = {
                    toValue: (handle)=>{
                        if (!handle) throwBindingError("Cannot use deleted val. handle = " + handle);
                        return emval_handles.get(handle).value;
                    },
                    toHandle: (value)=>{
                        switch(value){
                            case void 0:
                                return 1;
                            case null:
                                return 2;
                            case true:
                                return 3;
                            case false:
                                return 4;
                            default:
                                return emval_handles.allocate({
                                    refcount: 1,
                                    value: value
                                });
                        }
                    }
                };
                function __embind_register_emval(rawType, name) {
                    rawType >>>= 0;
                    name >>>= 0;
                    name = readLatin1String(name);
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(handle) {
                            var rv = Emval.toValue(handle);
                            __emval_decref(handle);
                            return rv;
                        },
                        "toWireType": function(destructors, value) {
                            return Emval.toHandle(value);
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": simpleReadValueFromPointer,
                        destructorFunction: null
                    });
                }
                function embindRepr(v) {
                    if (v === null) return "null";
                    var t = typeof v;
                    if (t === "object" || t === "array" || t === "function") return v.toString();
                    else return "" + v;
                }
                function floatReadValueFromPointer(name, shift) {
                    switch(shift){
                        case 2:
                            return function(pointer) {
                                return this["fromWireType"](GROWABLE_HEAP_F32()[pointer >>> 2]);
                            };
                        case 3:
                            return function(pointer) {
                                return this["fromWireType"](GROWABLE_HEAP_F64()[pointer >>> 3]);
                            };
                        default:
                            throw new TypeError("Unknown float type: " + name);
                    }
                }
                function __embind_register_float(rawType, name, size) {
                    rawType >>>= 0;
                    name >>>= 0;
                    size >>>= 0;
                    var shift = getShiftFromSize(size);
                    name = readLatin1String(name);
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(value) {
                            return value;
                        },
                        "toWireType": function(destructors, value) {
                            return value;
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": floatReadValueFromPointer(name, shift),
                        destructorFunction: null
                    });
                }
                function __embind_register_function(name, argCount, rawArgTypesAddr, signature, rawInvoker, fn, isAsync) {
                    name >>>= 0;
                    rawArgTypesAddr >>>= 0;
                    signature >>>= 0;
                    rawInvoker >>>= 0;
                    fn >>>= 0;
                    var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                    name = readLatin1String(name);
                    rawInvoker = embind__requireFunction(signature, rawInvoker);
                    exposePublicSymbol(name, function() {
                        throwUnboundTypeError(`Cannot call ${name} due to unbound types`, argTypes);
                    }, argCount - 1);
                    whenDependentTypesAreResolved([], argTypes, function(argTypes2) {
                        var invokerArgsArray = [
                            argTypes2[0],
                            null
                        ].concat(argTypes2.slice(1));
                        replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn, isAsync), argCount - 1);
                        return [];
                    });
                }
                function integerReadValueFromPointer(name, shift, signed) {
                    switch(shift){
                        case 0:
                            return signed ? function readS8FromPointer(pointer) {
                                return GROWABLE_HEAP_I8()[pointer >>> 0];
                            } : function readU8FromPointer(pointer) {
                                return GROWABLE_HEAP_U8()[pointer >>> 0];
                            };
                        case 1:
                            return signed ? function readS16FromPointer(pointer) {
                                return GROWABLE_HEAP_I16()[pointer >>> 1];
                            } : function readU16FromPointer(pointer) {
                                return GROWABLE_HEAP_U16()[pointer >>> 1];
                            };
                        case 2:
                            return signed ? function readS32FromPointer(pointer) {
                                return GROWABLE_HEAP_I32()[pointer >>> 2];
                            } : function readU32FromPointer(pointer) {
                                return GROWABLE_HEAP_U32()[pointer >>> 2];
                            };
                        default:
                            throw new TypeError("Unknown integer type: " + name);
                    }
                }
                function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
                    primitiveType >>>= 0;
                    name >>>= 0;
                    size >>>= 0;
                    name = readLatin1String(name);
                    if (maxRange === -1) maxRange = 4294967295;
                    var shift = getShiftFromSize(size);
                    var fromWireType = (value)=>value;
                    if (minRange === 0) {
                        var bitshift = 32 - 8 * size;
                        fromWireType = (value)=>value << bitshift >>> bitshift;
                    }
                    var isUnsignedType = name.includes("unsigned");
                    var checkAssertions = (value, toTypeName)=>{};
                    var toWireType;
                    if (isUnsignedType) toWireType = function(destructors, value) {
                        checkAssertions(value, this.name);
                        return value >>> 0;
                    };
                    else toWireType = function(destructors, value) {
                        checkAssertions(value, this.name);
                        return value;
                    };
                    registerType(primitiveType, {
                        name: name,
                        "fromWireType": fromWireType,
                        "toWireType": toWireType,
                        "argPackAdvance": 8,
                        "readValueFromPointer": integerReadValueFromPointer(name, shift, minRange !== 0),
                        destructorFunction: null
                    });
                }
                function __embind_register_memory_view(rawType, dataTypeIndex, name) {
                    rawType >>>= 0;
                    name >>>= 0;
                    var typeMapping = [
                        Int8Array,
                        Uint8Array,
                        Int16Array,
                        Uint16Array,
                        Int32Array,
                        Uint32Array,
                        Float32Array,
                        Float64Array
                    ];
                    var TA = typeMapping[dataTypeIndex];
                    function decodeMemoryView(handle) {
                        handle = handle >> 2;
                        var heap = GROWABLE_HEAP_U32();
                        var size = heap[handle >>> 0];
                        var data = heap[handle + 1 >>> 0];
                        return new TA(heap.buffer, data, size);
                    }
                    name = readLatin1String(name);
                    registerType(rawType, {
                        name: name,
                        "fromWireType": decodeMemoryView,
                        "argPackAdvance": 8,
                        "readValueFromPointer": decodeMemoryView
                    }, {
                        ignoreDuplicateRegistrations: true
                    });
                }
                var stringToUTF8 = (str, outPtr, maxBytesToWrite)=>stringToUTF8Array(str, GROWABLE_HEAP_U8(), outPtr, maxBytesToWrite);
                function __embind_register_std_string(rawType, name) {
                    rawType >>>= 0;
                    name >>>= 0;
                    name = readLatin1String(name);
                    var stdStringIsUTF8 = name === "std::string";
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(value) {
                            var length = GROWABLE_HEAP_U32()[value >>> 2];
                            var payload = value + 4;
                            var str;
                            if (stdStringIsUTF8) {
                                var decodeStartPtr = payload;
                                for(var i = 0; i <= length; ++i){
                                    var currentBytePtr = payload + i;
                                    if (i == length || GROWABLE_HEAP_U8()[currentBytePtr >>> 0] == 0) {
                                        var maxRead = currentBytePtr - decodeStartPtr;
                                        var stringSegment = UTF8ToString(decodeStartPtr, maxRead);
                                        if (str === void 0) str = stringSegment;
                                        else {
                                            str += String.fromCharCode(0);
                                            str += stringSegment;
                                        }
                                        decodeStartPtr = currentBytePtr + 1;
                                    }
                                }
                            } else {
                                var a = new Array(length);
                                for(var i = 0; i < length; ++i)a[i] = String.fromCharCode(GROWABLE_HEAP_U8()[payload + i >>> 0]);
                                str = a.join("");
                            }
                            _free(value);
                            return str;
                        },
                        "toWireType": function(destructors, value) {
                            if (value instanceof ArrayBuffer) value = new Uint8Array(value);
                            var length;
                            var valueIsOfTypeString = typeof value == "string";
                            if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) throwBindingError("Cannot pass non-string to std::string");
                            if (stdStringIsUTF8 && valueIsOfTypeString) length = lengthBytesUTF8(value);
                            else length = value.length;
                            var base = _malloc(4 + length + 1);
                            var ptr = base + 4;
                            GROWABLE_HEAP_U32()[base >>> 2] = length;
                            if (stdStringIsUTF8 && valueIsOfTypeString) stringToUTF8(value, ptr, length + 1);
                            else {
                                if (valueIsOfTypeString) for(var i = 0; i < length; ++i){
                                    var charCode = value.charCodeAt(i);
                                    if (charCode > 255) {
                                        _free(ptr);
                                        throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                                    }
                                    GROWABLE_HEAP_U8()[ptr + i >>> 0] = charCode;
                                }
                                else for(var i = 0; i < length; ++i)GROWABLE_HEAP_U8()[ptr + i >>> 0] = value[i];
                            }
                            if (destructors !== null) destructors.push(_free, base);
                            return base;
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": simpleReadValueFromPointer,
                        destructorFunction: function(ptr) {
                            _free(ptr);
                        }
                    });
                }
                var UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0;
                var UTF16ToString = (ptr, maxBytesToRead)=>{
                    var endPtr = ptr;
                    var idx = endPtr >> 1;
                    var maxIdx = idx + maxBytesToRead / 2;
                    while(!(idx >= maxIdx) && GROWABLE_HEAP_U16()[idx >>> 0])++idx;
                    endPtr = idx << 1;
                    if (endPtr - ptr > 32 && UTF16Decoder) return UTF16Decoder.decode(GROWABLE_HEAP_U8().slice(ptr, endPtr));
                    var str = "";
                    for(var i = 0; !(i >= maxBytesToRead / 2); ++i){
                        var codeUnit = GROWABLE_HEAP_I16()[ptr + i * 2 >>> 1];
                        if (codeUnit == 0) break;
                        str += String.fromCharCode(codeUnit);
                    }
                    return str;
                };
                var stringToUTF16 = (str, outPtr, maxBytesToWrite)=>{
                    if (maxBytesToWrite === void 0) maxBytesToWrite = 2147483647;
                    if (maxBytesToWrite < 2) return 0;
                    maxBytesToWrite -= 2;
                    var startPtr = outPtr;
                    var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
                    for(var i = 0; i < numCharsToWrite; ++i){
                        var codeUnit = str.charCodeAt(i);
                        GROWABLE_HEAP_I16()[outPtr >>> 1] = codeUnit;
                        outPtr += 2;
                    }
                    GROWABLE_HEAP_I16()[outPtr >>> 1] = 0;
                    return outPtr - startPtr;
                };
                var lengthBytesUTF16 = (str)=>str.length * 2;
                var UTF32ToString = (ptr, maxBytesToRead)=>{
                    var i = 0;
                    var str = "";
                    while(!(i >= maxBytesToRead / 4)){
                        var utf32 = GROWABLE_HEAP_I32()[ptr + i * 4 >>> 2];
                        if (utf32 == 0) break;
                        ++i;
                        if (utf32 >= 65536) {
                            var ch = utf32 - 65536;
                            str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                        } else str += String.fromCharCode(utf32);
                    }
                    return str;
                };
                var stringToUTF32 = (str, outPtr, maxBytesToWrite)=>{
                    outPtr >>>= 0;
                    if (maxBytesToWrite === void 0) maxBytesToWrite = 2147483647;
                    if (maxBytesToWrite < 4) return 0;
                    var startPtr = outPtr;
                    var endPtr = startPtr + maxBytesToWrite - 4;
                    for(var i = 0; i < str.length; ++i){
                        var codeUnit = str.charCodeAt(i);
                        if (codeUnit >= 55296 && codeUnit <= 57343) {
                            var trailSurrogate = str.charCodeAt(++i);
                            codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023;
                        }
                        GROWABLE_HEAP_I32()[outPtr >>> 2] = codeUnit;
                        outPtr += 4;
                        if (outPtr + 4 > endPtr) break;
                    }
                    GROWABLE_HEAP_I32()[outPtr >>> 2] = 0;
                    return outPtr - startPtr;
                };
                var lengthBytesUTF32 = (str)=>{
                    var len = 0;
                    for(var i = 0; i < str.length; ++i){
                        var codeUnit = str.charCodeAt(i);
                        if (codeUnit >= 55296 && codeUnit <= 57343) ++i;
                        len += 4;
                    }
                    return len;
                };
                var __embind_register_std_wstring = function(rawType, charSize, name) {
                    rawType >>>= 0;
                    charSize >>>= 0;
                    name >>>= 0;
                    name = readLatin1String(name);
                    var decodeString, encodeString, getHeap, lengthBytesUTF, shift;
                    if (charSize === 2) {
                        decodeString = UTF16ToString;
                        encodeString = stringToUTF16;
                        lengthBytesUTF = lengthBytesUTF16;
                        getHeap = ()=>GROWABLE_HEAP_U16();
                        shift = 1;
                    } else if (charSize === 4) {
                        decodeString = UTF32ToString;
                        encodeString = stringToUTF32;
                        lengthBytesUTF = lengthBytesUTF32;
                        getHeap = ()=>GROWABLE_HEAP_U32();
                        shift = 2;
                    }
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(value) {
                            var length = GROWABLE_HEAP_U32()[value >>> 2];
                            var HEAP = getHeap();
                            var str;
                            var decodeStartPtr = value + 4;
                            for(var i = 0; i <= length; ++i){
                                var currentBytePtr = value + 4 + i * charSize;
                                if (i == length || HEAP[currentBytePtr >>> shift] == 0) {
                                    var maxReadBytes = currentBytePtr - decodeStartPtr;
                                    var stringSegment = decodeString(decodeStartPtr, maxReadBytes);
                                    if (str === void 0) str = stringSegment;
                                    else {
                                        str += String.fromCharCode(0);
                                        str += stringSegment;
                                    }
                                    decodeStartPtr = currentBytePtr + charSize;
                                }
                            }
                            _free(value);
                            return str;
                        },
                        "toWireType": function(destructors, value) {
                            if (!(typeof value == "string")) throwBindingError(`Cannot pass non-string to C++ string type ${name}`);
                            var length = lengthBytesUTF(value);
                            var ptr = _malloc(4 + length + charSize);
                            GROWABLE_HEAP_U32()[ptr >>> 2] = length >> shift;
                            encodeString(value, ptr + 4, length + charSize);
                            if (destructors !== null) destructors.push(_free, ptr);
                            return ptr;
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": simpleReadValueFromPointer,
                        destructorFunction: function(ptr) {
                            _free(ptr);
                        }
                    });
                };
                function __embind_register_value_array(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
                    rawType >>>= 0;
                    name >>>= 0;
                    constructorSignature >>>= 0;
                    rawConstructor >>>= 0;
                    destructorSignature >>>= 0;
                    rawDestructor >>>= 0;
                    tupleRegistrations[rawType] = {
                        name: readLatin1String(name),
                        rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
                        rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
                        elements: []
                    };
                }
                function __embind_register_value_array_element(rawTupleType, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
                    rawTupleType >>>= 0;
                    getterReturnType >>>= 0;
                    getterSignature >>>= 0;
                    getter >>>= 0;
                    getterContext >>>= 0;
                    setterArgumentType >>>= 0;
                    setterSignature >>>= 0;
                    setter >>>= 0;
                    setterContext >>>= 0;
                    tupleRegistrations[rawTupleType].elements.push({
                        getterReturnType: getterReturnType,
                        getter: embind__requireFunction(getterSignature, getter),
                        getterContext: getterContext,
                        setterArgumentType: setterArgumentType,
                        setter: embind__requireFunction(setterSignature, setter),
                        setterContext: setterContext
                    });
                }
                function __embind_register_value_object(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
                    rawType >>>= 0;
                    name >>>= 0;
                    constructorSignature >>>= 0;
                    rawConstructor >>>= 0;
                    destructorSignature >>>= 0;
                    rawDestructor >>>= 0;
                    structRegistrations[rawType] = {
                        name: readLatin1String(name),
                        rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
                        rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
                        fields: []
                    };
                }
                function __embind_register_value_object_field(structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
                    structType >>>= 0;
                    fieldName >>>= 0;
                    getterReturnType >>>= 0;
                    getterSignature >>>= 0;
                    getter >>>= 0;
                    getterContext >>>= 0;
                    setterArgumentType >>>= 0;
                    setterSignature >>>= 0;
                    setter >>>= 0;
                    setterContext >>>= 0;
                    structRegistrations[structType].fields.push({
                        fieldName: readLatin1String(fieldName),
                        getterReturnType: getterReturnType,
                        getter: embind__requireFunction(getterSignature, getter),
                        getterContext: getterContext,
                        setterArgumentType: setterArgumentType,
                        setter: embind__requireFunction(setterSignature, setter),
                        setterContext: setterContext
                    });
                }
                function __embind_register_void(rawType, name) {
                    rawType >>>= 0;
                    name >>>= 0;
                    name = readLatin1String(name);
                    registerType(rawType, {
                        isVoid: true,
                        name: name,
                        "argPackAdvance": 0,
                        "fromWireType": function() {
                            return void 0;
                        },
                        "toWireType": function(destructors, o) {
                            return void 0;
                        }
                    });
                }
                var nowIsMonotonic = true;
                var __emscripten_get_now_is_monotonic = ()=>nowIsMonotonic;
                var maybeExit = ()=>{
                    if (!keepRuntimeAlive()) try {
                        if (ENVIRONMENT_IS_PTHREAD) __emscripten_thread_exit(EXITSTATUS);
                        else _exit(EXITSTATUS);
                    } catch (e) {
                        handleException(e);
                    }
                };
                var callUserCallback = (func)=>{
                    if (ABORT) return;
                    try {
                        func();
                        maybeExit();
                    } catch (e) {
                        handleException(e);
                    }
                };
                function __emscripten_thread_mailbox_await(pthread_ptr) {
                    pthread_ptr >>>= 0;
                    if (typeof Atomics.waitAsync === "function") {
                        var wait = Atomics.waitAsync(GROWABLE_HEAP_I32(), pthread_ptr >> 2, pthread_ptr);
                        wait.value.then(checkMailbox);
                        var waitingAsync = pthread_ptr + 128;
                        Atomics.store(GROWABLE_HEAP_I32(), waitingAsync >> 2, 1);
                    }
                }
                Module["__emscripten_thread_mailbox_await"] = __emscripten_thread_mailbox_await;
                var checkMailbox = function() {
                    var pthread_ptr = _pthread_self();
                    if (pthread_ptr) {
                        __emscripten_thread_mailbox_await(pthread_ptr);
                        callUserCallback(()=>__emscripten_check_mailbox());
                    }
                };
                Module["checkMailbox"] = checkMailbox;
                var __emscripten_notify_mailbox_postmessage = function(targetThreadId, currThreadId, mainThreadId) {
                    targetThreadId >>>= 0;
                    currThreadId >>>= 0;
                    mainThreadId >>>= 0;
                    if (targetThreadId == currThreadId) setTimeout(()=>checkMailbox());
                    else if (ENVIRONMENT_IS_PTHREAD) postMessage({
                        "targetThread": targetThreadId,
                        "cmd": "checkMailbox"
                    });
                    else {
                        var worker = PThread.pthreads[targetThreadId];
                        if (!worker) return;
                        worker.postMessage({
                            "cmd": "checkMailbox"
                        });
                    }
                };
                function __emscripten_set_offscreencanvas_size(target, width, height) {
                    target >>>= 0;
                    return -1;
                }
                function __emscripten_thread_set_strongref(thread) {
                    thread >>>= 0;
                }
                function requireRegisteredType(rawType, humanName) {
                    var impl = registeredTypes[rawType];
                    if (void 0 === impl) throwBindingError(humanName + " has unknown type " + getTypeName(rawType));
                    return impl;
                }
                function __emval_as(handle, returnType, destructorsRef) {
                    handle >>>= 0;
                    returnType >>>= 0;
                    destructorsRef >>>= 0;
                    handle = Emval.toValue(handle);
                    returnType = requireRegisteredType(returnType, "emval::as");
                    var destructors = [];
                    var rd = Emval.toHandle(destructors);
                    GROWABLE_HEAP_U32()[destructorsRef >>> 2] = rd;
                    return returnType["toWireType"](destructors, handle);
                }
                function emval_lookupTypes(argCount, argTypes) {
                    var a = new Array(argCount);
                    for(var i = 0; i < argCount; ++i)a[i] = requireRegisteredType(GROWABLE_HEAP_U32()[argTypes + i * 4 >>> 2], "parameter " + i);
                    return a;
                }
                function __emval_call(handle, argCount, argTypes, argv) {
                    handle >>>= 0;
                    argTypes >>>= 0;
                    argv >>>= 0;
                    handle = Emval.toValue(handle);
                    var types = emval_lookupTypes(argCount, argTypes);
                    var args = new Array(argCount);
                    for(var i = 0; i < argCount; ++i){
                        var type = types[i];
                        args[i] = type["readValueFromPointer"](argv);
                        argv += type["argPackAdvance"];
                    }
                    var rv = handle.apply(void 0, args);
                    return Emval.toHandle(rv);
                }
                var emval_symbols = {};
                function getStringOrSymbol(address) {
                    var symbol = emval_symbols[address];
                    if (symbol === void 0) return readLatin1String(address);
                    return symbol;
                }
                function emval_get_global() {
                    if (typeof globalThis == "object") return globalThis;
                    return /* @__PURE__ */ (function() {
                        return Function;
                    })()("return this")();
                }
                function __emval_get_global(name) {
                    name >>>= 0;
                    if (name === 0) return Emval.toHandle(emval_get_global());
                    else {
                        name = getStringOrSymbol(name);
                        return Emval.toHandle(emval_get_global()[name]);
                    }
                }
                function __emval_get_property(handle, key) {
                    handle >>>= 0;
                    key >>>= 0;
                    handle = Emval.toValue(handle);
                    key = Emval.toValue(key);
                    return Emval.toHandle(handle[key]);
                }
                function __emval_incref(handle) {
                    handle >>>= 0;
                    if (handle > 4) emval_handles.get(handle).refcount += 1;
                }
                function __emval_instanceof(object, constructor) {
                    object >>>= 0;
                    constructor >>>= 0;
                    object = Emval.toValue(object);
                    constructor = Emval.toValue(constructor);
                    return object instanceof constructor;
                }
                function __emval_is_number(handle) {
                    handle >>>= 0;
                    handle = Emval.toValue(handle);
                    return typeof handle == "number";
                }
                function __emval_is_string(handle) {
                    handle >>>= 0;
                    handle = Emval.toValue(handle);
                    return typeof handle == "string";
                }
                function __emval_new_array() {
                    return Emval.toHandle([]);
                }
                function __emval_new_cstring(v) {
                    v >>>= 0;
                    return Emval.toHandle(getStringOrSymbol(v));
                }
                function __emval_new_object() {
                    return Emval.toHandle({});
                }
                function __emval_run_destructors(handle) {
                    handle >>>= 0;
                    var destructors = Emval.toValue(handle);
                    runDestructors(destructors);
                    __emval_decref(handle);
                }
                function __emval_set_property(handle, key, value) {
                    handle >>>= 0;
                    key >>>= 0;
                    value >>>= 0;
                    handle = Emval.toValue(handle);
                    key = Emval.toValue(key);
                    value = Emval.toValue(value);
                    handle[key] = value;
                }
                function __emval_take_value(type, arg) {
                    type >>>= 0;
                    arg >>>= 0;
                    type = requireRegisteredType(type, "_emval_take_value");
                    var v = type["readValueFromPointer"](arg);
                    return Emval.toHandle(v);
                }
                function __gmtime_js(time_low, time_high, tmPtr) {
                    var time = convertI32PairToI53Checked(time_low, time_high);
                    tmPtr >>>= 0;
                    var date = new Date(time * 1e3);
                    GROWABLE_HEAP_I32()[tmPtr >>> 2] = date.getUTCSeconds();
                    GROWABLE_HEAP_I32()[tmPtr + 4 >>> 2] = date.getUTCMinutes();
                    GROWABLE_HEAP_I32()[tmPtr + 8 >>> 2] = date.getUTCHours();
                    GROWABLE_HEAP_I32()[tmPtr + 12 >>> 2] = date.getUTCDate();
                    GROWABLE_HEAP_I32()[tmPtr + 16 >>> 2] = date.getUTCMonth();
                    GROWABLE_HEAP_I32()[tmPtr + 20 >>> 2] = date.getUTCFullYear() - 1900;
                    GROWABLE_HEAP_I32()[tmPtr + 24 >>> 2] = date.getUTCDay();
                    var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
                    var yday = (date.getTime() - start) / 86400000 | 0;
                    GROWABLE_HEAP_I32()[tmPtr + 28 >>> 2] = yday;
                }
                var isLeapYear = (year)=>year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
                var MONTH_DAYS_LEAP_CUMULATIVE = [
                    0,
                    31,
                    60,
                    91,
                    121,
                    152,
                    182,
                    213,
                    244,
                    274,
                    305,
                    335
                ];
                var MONTH_DAYS_REGULAR_CUMULATIVE = [
                    0,
                    31,
                    59,
                    90,
                    120,
                    151,
                    181,
                    212,
                    243,
                    273,
                    304,
                    334
                ];
                var ydayFromDate = (date)=>{
                    var leap = isLeapYear(date.getFullYear());
                    var monthDaysCumulative = leap ? MONTH_DAYS_LEAP_CUMULATIVE : MONTH_DAYS_REGULAR_CUMULATIVE;
                    var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
                    return yday;
                };
                function __localtime_js(time_low, time_high, tmPtr) {
                    var time = convertI32PairToI53Checked(time_low, time_high);
                    tmPtr >>>= 0;
                    var date = new Date(time * 1e3);
                    GROWABLE_HEAP_I32()[tmPtr >>> 2] = date.getSeconds();
                    GROWABLE_HEAP_I32()[tmPtr + 4 >>> 2] = date.getMinutes();
                    GROWABLE_HEAP_I32()[tmPtr + 8 >>> 2] = date.getHours();
                    GROWABLE_HEAP_I32()[tmPtr + 12 >>> 2] = date.getDate();
                    GROWABLE_HEAP_I32()[tmPtr + 16 >>> 2] = date.getMonth();
                    GROWABLE_HEAP_I32()[tmPtr + 20 >>> 2] = date.getFullYear() - 1900;
                    GROWABLE_HEAP_I32()[tmPtr + 24 >>> 2] = date.getDay();
                    var yday = ydayFromDate(date) | 0;
                    GROWABLE_HEAP_I32()[tmPtr + 28 >>> 2] = yday;
                    GROWABLE_HEAP_I32()[tmPtr + 36 >>> 2] = -(date.getTimezoneOffset() * 60);
                    var start = new Date(date.getFullYear(), 0, 1);
                    var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
                    var winterOffset = start.getTimezoneOffset();
                    var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
                    GROWABLE_HEAP_I32()[tmPtr + 32 >>> 2] = dst;
                }
                var stringToNewUTF8 = (str)=>{
                    var size = lengthBytesUTF8(str) + 1;
                    var ret = _malloc(size);
                    if (ret) stringToUTF8(str, ret, size);
                    return ret;
                };
                function __tzset_js(timezone, daylight, tzname) {
                    timezone >>>= 0;
                    daylight >>>= 0;
                    tzname >>>= 0;
                    var currentYear = /* @__PURE__ */ new Date().getFullYear();
                    var winter = new Date(currentYear, 0, 1);
                    var summer = new Date(currentYear, 6, 1);
                    var winterOffset = winter.getTimezoneOffset();
                    var summerOffset = summer.getTimezoneOffset();
                    var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
                    GROWABLE_HEAP_U32()[timezone >>> 2] = stdTimezoneOffset * 60;
                    GROWABLE_HEAP_I32()[daylight >>> 2] = Number(winterOffset != summerOffset);
                    function extractZone(date) {
                        var match = date.toTimeString().match(/\(([A-Za-z ]+)\)$/);
                        return match ? match[1] : "GMT";
                    }
                    var winterName = extractZone(winter);
                    var summerName = extractZone(summer);
                    var winterNamePtr = stringToNewUTF8(winterName);
                    var summerNamePtr = stringToNewUTF8(summerName);
                    if (summerOffset < winterOffset) {
                        GROWABLE_HEAP_U32()[tzname >>> 2] = winterNamePtr;
                        GROWABLE_HEAP_U32()[tzname + 4 >>> 2] = summerNamePtr;
                    } else {
                        GROWABLE_HEAP_U32()[tzname >>> 2] = summerNamePtr;
                        GROWABLE_HEAP_U32()[tzname + 4 >>> 2] = winterNamePtr;
                    }
                }
                var _abort = ()=>{
                    abort("");
                };
                var warnOnce = (text)=>{
                    if (!warnOnce.shown) warnOnce.shown = {};
                    if (!warnOnce.shown[text]) {
                        warnOnce.shown[text] = 1;
                        err(text);
                    }
                };
                function _emscripten_check_blocking_allowed() {}
                function _emscripten_date_now() {
                    return Date.now();
                }
                var runtimeKeepalivePush = ()=>{
                    runtimeKeepaliveCounter += 1;
                };
                var _emscripten_exit_with_live_runtime = ()=>{
                    runtimeKeepalivePush();
                    throw "unwind";
                };
                var _emscripten_get_now;
                _emscripten_get_now = ()=>performance.timeOrigin + performance.now();
                var withStackSave = (f)=>{
                    var stack = stackSave();
                    var ret = f();
                    stackRestore(stack);
                    return ret;
                };
                var proxyToMainThread = function(index, sync) {
                    var numCallArgs = arguments.length - 2;
                    var outerArgs = arguments;
                    return withStackSave(()=>{
                        var serializedNumCallArgs = numCallArgs;
                        var args = stackAlloc(serializedNumCallArgs * 8);
                        var b = args >> 3;
                        for(var i = 0; i < numCallArgs; i++){
                            var arg = outerArgs[2 + i];
                            GROWABLE_HEAP_F64()[b + i >>> 0] = arg;
                        }
                        return __emscripten_run_in_main_runtime_thread_js(index, serializedNumCallArgs, args, sync);
                    });
                };
                var emscripten_receive_on_main_thread_js_callArgs = [];
                function _emscripten_receive_on_main_thread_js(index, callingThread, numCallArgs, args) {
                    callingThread >>>= 0;
                    args >>>= 0;
                    PThread.currentProxiedOperationCallerThread = callingThread;
                    emscripten_receive_on_main_thread_js_callArgs.length = numCallArgs;
                    var b = args >> 3;
                    for(var i = 0; i < numCallArgs; i++)emscripten_receive_on_main_thread_js_callArgs[i] = GROWABLE_HEAP_F64()[b + i >>> 0];
                    var func = proxiedFunctionTable[index];
                    return func.apply(null, emscripten_receive_on_main_thread_js_callArgs);
                }
                var getHeapMax = ()=>4294901760;
                var growMemory = (size)=>{
                    var b = wasmMemory.buffer;
                    var pages = size - b.byteLength + 65535 >>> 16;
                    try {
                        wasmMemory.grow(pages);
                        updateMemoryViews();
                        return 1;
                    } catch (e) {}
                };
                function _emscripten_resize_heap(requestedSize) {
                    requestedSize >>>= 0;
                    var oldSize = GROWABLE_HEAP_U8().length;
                    if (requestedSize <= oldSize) return false;
                    var maxHeapSize = getHeapMax();
                    if (requestedSize > maxHeapSize) return false;
                    var alignUp = (x, multiple)=>x + (multiple - x % multiple) % multiple;
                    for(var cutDown = 1; cutDown <= 4; cutDown *= 2){
                        var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
                        overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
                        var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
                        var replacement = growMemory(newSize);
                        if (replacement) return true;
                    }
                    return false;
                }
                var ENV = {};
                var getExecutableName = ()=>thisProgram || "./this.program";
                var getEnvStrings = ()=>{
                    if (!getEnvStrings.strings) {
                        var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
                        var env = {
                            "USER": "web_user",
                            "LOGNAME": "web_user",
                            "PATH": "/",
                            "PWD": "/",
                            "HOME": "/home/web_user",
                            "LANG": lang,
                            "_": getExecutableName()
                        };
                        for(var x in ENV)if (ENV[x] === void 0) delete env[x];
                        else env[x] = ENV[x];
                        var strings = [];
                        for(var x in env)strings.push(`${x}=${env[x]}`);
                        getEnvStrings.strings = strings;
                    }
                    return getEnvStrings.strings;
                };
                var stringToAscii = (str, buffer)=>{
                    for(var i = 0; i < str.length; ++i)GROWABLE_HEAP_I8()[buffer++ >>> 0] = str.charCodeAt(i);
                    GROWABLE_HEAP_I8()[buffer >>> 0] = 0;
                };
                function _environ_get(__environ, environ_buf) {
                    if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(3, 1, __environ, environ_buf);
                    __environ >>>= 0;
                    environ_buf >>>= 0;
                    var bufSize = 0;
                    getEnvStrings().forEach(function(string, i) {
                        var ptr = environ_buf + bufSize;
                        GROWABLE_HEAP_U32()[__environ + i * 4 >>> 2] = ptr;
                        stringToAscii(string, ptr);
                        bufSize += string.length + 1;
                    });
                    return 0;
                }
                function _environ_sizes_get(penviron_count, penviron_buf_size) {
                    if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(4, 1, penviron_count, penviron_buf_size);
                    penviron_count >>>= 0;
                    penviron_buf_size >>>= 0;
                    var strings = getEnvStrings();
                    GROWABLE_HEAP_U32()[penviron_count >>> 2] = strings.length;
                    var bufSize = 0;
                    strings.forEach(function(string) {
                        bufSize += string.length + 1;
                    });
                    GROWABLE_HEAP_U32()[penviron_buf_size >>> 2] = bufSize;
                    return 0;
                }
                function _fd_close(fd) {
                    if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(5, 1, fd);
                    try {
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        FS.close(stream);
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                function _fd_fdstat_get(fd, pbuf) {
                    if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(6, 1, fd, pbuf);
                    pbuf >>>= 0;
                    try {
                        var rightsBase = 0;
                        var rightsInheriting = 0;
                        var flags = 0;
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        var type = stream.tty ? 2 : FS.isDir(stream.mode) ? 3 : FS.isLink(stream.mode) ? 7 : 4;
                        GROWABLE_HEAP_I8()[pbuf >>> 0] = type;
                        GROWABLE_HEAP_I16()[pbuf + 2 >>> 1] = flags;
                        tempI64 = [
                            rightsBase >>> 0,
                            (tempDouble = rightsBase, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], GROWABLE_HEAP_I32()[pbuf + 8 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[pbuf + 12 >>> 2] = tempI64[1];
                        tempI64 = [
                            rightsInheriting >>> 0,
                            (tempDouble = rightsInheriting, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], GROWABLE_HEAP_I32()[pbuf + 16 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[pbuf + 20 >>> 2] = tempI64[1];
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                var doReadv = (stream, iov, iovcnt, offset)=>{
                    var ret = 0;
                    for(var i = 0; i < iovcnt; i++){
                        var ptr = GROWABLE_HEAP_U32()[iov >>> 2];
                        var len = GROWABLE_HEAP_U32()[iov + 4 >>> 2];
                        iov += 8;
                        var curr = FS.read(stream, GROWABLE_HEAP_I8(), ptr, len, offset);
                        if (curr < 0) return -1;
                        ret += curr;
                        if (curr < len) break;
                        if (typeof offset !== "undefined") offset += curr;
                    }
                    return ret;
                };
                function _fd_read(fd, iov, iovcnt, pnum) {
                    if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(7, 1, fd, iov, iovcnt, pnum);
                    iov >>>= 0;
                    iovcnt >>>= 0;
                    pnum >>>= 0;
                    try {
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        var num = doReadv(stream, iov, iovcnt);
                        GROWABLE_HEAP_U32()[pnum >>> 2] = num;
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
                    if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(8, 1, fd, offset_low, offset_high, whence, newOffset);
                    var offset = convertI32PairToI53Checked(offset_low, offset_high);
                    newOffset >>>= 0;
                    try {
                        if (isNaN(offset)) return 61;
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        FS.llseek(stream, offset, whence);
                        tempI64 = [
                            stream.position >>> 0,
                            (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], GROWABLE_HEAP_I32()[newOffset >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[newOffset + 4 >>> 2] = tempI64[1];
                        if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                var doWritev = (stream, iov, iovcnt, offset)=>{
                    var ret = 0;
                    for(var i = 0; i < iovcnt; i++){
                        var ptr = GROWABLE_HEAP_U32()[iov >>> 2];
                        var len = GROWABLE_HEAP_U32()[iov + 4 >>> 2];
                        iov += 8;
                        var curr = FS.write(stream, GROWABLE_HEAP_I8(), ptr, len, offset);
                        if (curr < 0) return -1;
                        ret += curr;
                        if (typeof offset !== "undefined") offset += curr;
                    }
                    return ret;
                };
                function _fd_write(fd, iov, iovcnt, pnum) {
                    if (ENVIRONMENT_IS_PTHREAD) return proxyToMainThread(9, 1, fd, iov, iovcnt, pnum);
                    iov >>>= 0;
                    iovcnt >>>= 0;
                    pnum >>>= 0;
                    try {
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        var num = doWritev(stream, iov, iovcnt);
                        GROWABLE_HEAP_U32()[pnum >>> 2] = num;
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                function _getentropy(buffer, size) {
                    buffer >>>= 0;
                    size >>>= 0;
                    randomFill(GROWABLE_HEAP_U8().subarray(buffer >>> 0, buffer + size >>> 0));
                    return 0;
                }
                var arraySum = (array, index)=>{
                    var sum = 0;
                    for(var i = 0; i <= index; sum += array[i++]);
                    return sum;
                };
                var MONTH_DAYS_LEAP = [
                    31,
                    29,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ];
                var MONTH_DAYS_REGULAR = [
                    31,
                    28,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ];
                var addDays = (date, days)=>{
                    var newDate = new Date(date.getTime());
                    while(days > 0){
                        var leap = isLeapYear(newDate.getFullYear());
                        var currentMonth = newDate.getMonth();
                        var daysInCurrentMonth = (leap ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[currentMonth];
                        if (days > daysInCurrentMonth - newDate.getDate()) {
                            days -= daysInCurrentMonth - newDate.getDate() + 1;
                            newDate.setDate(1);
                            if (currentMonth < 11) newDate.setMonth(currentMonth + 1);
                            else {
                                newDate.setMonth(0);
                                newDate.setFullYear(newDate.getFullYear() + 1);
                            }
                        } else {
                            newDate.setDate(newDate.getDate() + days);
                            return newDate;
                        }
                    }
                    return newDate;
                };
                var writeArrayToMemory = (array, buffer)=>{
                    GROWABLE_HEAP_I8().set(array, buffer >>> 0);
                };
                function _strftime(s, maxsize, format, tm) {
                    s >>>= 0;
                    maxsize >>>= 0;
                    format >>>= 0;
                    tm >>>= 0;
                    var tm_zone = GROWABLE_HEAP_I32()[tm + 40 >>> 2];
                    var date = {
                        tm_sec: GROWABLE_HEAP_I32()[tm >>> 2],
                        tm_min: GROWABLE_HEAP_I32()[tm + 4 >>> 2],
                        tm_hour: GROWABLE_HEAP_I32()[tm + 8 >>> 2],
                        tm_mday: GROWABLE_HEAP_I32()[tm + 12 >>> 2],
                        tm_mon: GROWABLE_HEAP_I32()[tm + 16 >>> 2],
                        tm_year: GROWABLE_HEAP_I32()[tm + 20 >>> 2],
                        tm_wday: GROWABLE_HEAP_I32()[tm + 24 >>> 2],
                        tm_yday: GROWABLE_HEAP_I32()[tm + 28 >>> 2],
                        tm_isdst: GROWABLE_HEAP_I32()[tm + 32 >>> 2],
                        tm_gmtoff: GROWABLE_HEAP_I32()[tm + 36 >>> 2],
                        tm_zone: tm_zone ? UTF8ToString(tm_zone) : ""
                    };
                    var pattern = UTF8ToString(format);
                    var EXPANSION_RULES_1 = {
                        "%c": "%a %b %d %H:%M:%S %Y",
                        "%D": "%m/%d/%y",
                        "%F": "%Y-%m-%d",
                        "%h": "%b",
                        "%r": "%I:%M:%S %p",
                        "%R": "%H:%M",
                        "%T": "%H:%M:%S",
                        "%x": "%m/%d/%y",
                        "%X": "%H:%M:%S",
                        "%Ec": "%c",
                        "%EC": "%C",
                        "%Ex": "%m/%d/%y",
                        "%EX": "%H:%M:%S",
                        "%Ey": "%y",
                        "%EY": "%Y",
                        "%Od": "%d",
                        "%Oe": "%e",
                        "%OH": "%H",
                        "%OI": "%I",
                        "%Om": "%m",
                        "%OM": "%M",
                        "%OS": "%S",
                        "%Ou": "%u",
                        "%OU": "%U",
                        "%OV": "%V",
                        "%Ow": "%w",
                        "%OW": "%W",
                        "%Oy": "%y"
                    };
                    for(var rule in EXPANSION_RULES_1)pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
                    var WEEKDAYS = [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ];
                    var MONTHS = [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ];
                    function leadingSomething(value, digits, character) {
                        var str = typeof value == "number" ? value.toString() : value || "";
                        while(str.length < digits)str = character[0] + str;
                        return str;
                    }
                    function leadingNulls(value, digits) {
                        return leadingSomething(value, digits, "0");
                    }
                    function compareByDay(date1, date2) {
                        function sgn(value) {
                            return value < 0 ? -1 : value > 0 ? 1 : 0;
                        }
                        var compare;
                        if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
                            if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) compare = sgn(date1.getDate() - date2.getDate());
                        }
                        return compare;
                    }
                    function getFirstWeekStartDate(janFourth) {
                        switch(janFourth.getDay()){
                            case 0:
                                return new Date(janFourth.getFullYear() - 1, 11, 29);
                            case 1:
                                return janFourth;
                            case 2:
                                return new Date(janFourth.getFullYear(), 0, 3);
                            case 3:
                                return new Date(janFourth.getFullYear(), 0, 2);
                            case 4:
                                return new Date(janFourth.getFullYear(), 0, 1);
                            case 5:
                                return new Date(janFourth.getFullYear() - 1, 11, 31);
                            case 6:
                                return new Date(janFourth.getFullYear() - 1, 11, 30);
                        }
                    }
                    function getWeekBasedYear(date2) {
                        var thisDate = addDays(new Date(date2.tm_year + 1900, 0, 1), date2.tm_yday);
                        var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
                        var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
                        var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
                        var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
                        if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
                            if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) return thisDate.getFullYear() + 1;
                            return thisDate.getFullYear();
                        }
                        return thisDate.getFullYear() - 1;
                    }
                    var EXPANSION_RULES_2 = {
                        "%a": (date2)=>WEEKDAYS[date2.tm_wday].substring(0, 3),
                        "%A": (date2)=>WEEKDAYS[date2.tm_wday],
                        "%b": (date2)=>MONTHS[date2.tm_mon].substring(0, 3),
                        "%B": (date2)=>MONTHS[date2.tm_mon],
                        "%C": (date2)=>{
                            var year = date2.tm_year + 1900;
                            return leadingNulls(year / 100 | 0, 2);
                        },
                        "%d": (date2)=>leadingNulls(date2.tm_mday, 2),
                        "%e": (date2)=>leadingSomething(date2.tm_mday, 2, " "),
                        "%g": (date2)=>getWeekBasedYear(date2).toString().substring(2),
                        "%G": (date2)=>getWeekBasedYear(date2),
                        "%H": (date2)=>leadingNulls(date2.tm_hour, 2),
                        "%I": (date2)=>{
                            var twelveHour = date2.tm_hour;
                            if (twelveHour == 0) twelveHour = 12;
                            else if (twelveHour > 12) twelveHour -= 12;
                            return leadingNulls(twelveHour, 2);
                        },
                        "%j": (date2)=>leadingNulls(date2.tm_mday + arraySum(isLeapYear(date2.tm_year + 1900) ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR, date2.tm_mon - 1), 3),
                        "%m": (date2)=>leadingNulls(date2.tm_mon + 1, 2),
                        "%M": (date2)=>leadingNulls(date2.tm_min, 2),
                        "%n": ()=>"\n",
                        "%p": (date2)=>{
                            if (date2.tm_hour >= 0 && date2.tm_hour < 12) return "AM";
                            return "PM";
                        },
                        "%S": (date2)=>leadingNulls(date2.tm_sec, 2),
                        "%t": ()=>"	",
                        "%u": (date2)=>date2.tm_wday || 7,
                        "%U": (date2)=>{
                            var days = date2.tm_yday + 7 - date2.tm_wday;
                            return leadingNulls(Math.floor(days / 7), 2);
                        },
                        "%V": (date2)=>{
                            var val = Math.floor((date2.tm_yday + 7 - (date2.tm_wday + 6) % 7) / 7);
                            if ((date2.tm_wday + 371 - date2.tm_yday - 2) % 7 <= 2) val++;
                            if (!val) {
                                val = 52;
                                var dec31 = (date2.tm_wday + 7 - date2.tm_yday - 1) % 7;
                                if (dec31 == 4 || dec31 == 5 && isLeapYear(date2.tm_year % 400 - 1)) val++;
                            } else if (val == 53) {
                                var jan1 = (date2.tm_wday + 371 - date2.tm_yday) % 7;
                                if (jan1 != 4 && (jan1 != 3 || !isLeapYear(date2.tm_year))) val = 1;
                            }
                            return leadingNulls(val, 2);
                        },
                        "%w": (date2)=>date2.tm_wday,
                        "%W": (date2)=>{
                            var days = date2.tm_yday + 7 - (date2.tm_wday + 6) % 7;
                            return leadingNulls(Math.floor(days / 7), 2);
                        },
                        "%y": (date2)=>(date2.tm_year + 1900).toString().substring(2),
                        "%Y": (date2)=>date2.tm_year + 1900,
                        "%z": (date2)=>{
                            var off = date2.tm_gmtoff;
                            var ahead = off >= 0;
                            off = Math.abs(off) / 60;
                            off = off / 60 * 100 + off % 60;
                            return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
                        },
                        "%Z": (date2)=>date2.tm_zone,
                        "%%": ()=>"%"
                    };
                    pattern = pattern.replace(/%%/g, "\0\0");
                    for(var rule in EXPANSION_RULES_2)if (pattern.includes(rule)) pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
                    pattern = pattern.replace(/\0\0/g, "%");
                    var bytes = intArrayFromString(pattern, false);
                    if (bytes.length > maxsize) return 0;
                    writeArrayToMemory(bytes, s);
                    return bytes.length - 1;
                }
                function _strftime_l(s, maxsize, format, tm, loc) {
                    s >>>= 0;
                    maxsize >>>= 0;
                    format >>>= 0;
                    tm >>>= 0;
                    loc >>>= 0;
                    return _strftime(s, maxsize, format, tm);
                }
                PThread.init();
                var FSNode = function(parent, name, mode, rdev) {
                    if (!parent) parent = this;
                    this.parent = parent;
                    this.mount = parent.mount;
                    this.mounted = null;
                    this.id = FS.nextInode++;
                    this.name = name;
                    this.mode = mode;
                    this.node_ops = {};
                    this.stream_ops = {};
                    this.rdev = rdev;
                };
                var readMode = 365;
                var writeMode = 146;
                Object.defineProperties(FSNode.prototype, {
                    read: {
                        get: function() {
                            return (this.mode & readMode) === readMode;
                        },
                        set: function(val) {
                            val ? this.mode |= readMode : this.mode &= ~readMode;
                        }
                    },
                    write: {
                        get: function() {
                            return (this.mode & writeMode) === writeMode;
                        },
                        set: function(val) {
                            val ? this.mode |= writeMode : this.mode &= ~writeMode;
                        }
                    },
                    isFolder: {
                        get: function() {
                            return FS.isDir(this.mode);
                        }
                    },
                    isDevice: {
                        get: function() {
                            return FS.isChrdev(this.mode);
                        }
                    }
                });
                FS.FSNode = FSNode;
                FS.createPreloadedFile = FS_createPreloadedFile;
                FS.staticInit();
                InternalError = Module["InternalError"] = class InternalError extends Error {
                    constructor(message){
                        super(message);
                        this.name = "InternalError";
                    }
                };
                embind_init_charCodes();
                BindingError = Module["BindingError"] = class BindingError extends Error {
                    constructor(message){
                        super(message);
                        this.name = "BindingError";
                    }
                };
                init_ClassHandle();
                init_embind();
                init_RegisteredPointer();
                UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
                handleAllocatorInit();
                init_emval();
                var proxiedFunctionTable = [
                    null,
                    _proc_exit,
                    exitOnMainThread,
                    _environ_get,
                    _environ_sizes_get,
                    _fd_close,
                    _fd_fdstat_get,
                    _fd_read,
                    _fd_seek,
                    _fd_write
                ];
                var wasmImports = {
                    g: ___cxa_throw,
                    _: ___emscripten_init_main_thread_js,
                    B: ___emscripten_thread_cleanup,
                    ha: __embind_finalize_value_array,
                    q: __embind_finalize_value_object,
                    L: __embind_register_bigint,
                    fa: __embind_register_bool,
                    j: __embind_register_class,
                    i: __embind_register_class_constructor,
                    c: __embind_register_class_function,
                    ea: __embind_register_emval,
                    D: __embind_register_float,
                    d: __embind_register_function,
                    t: __embind_register_integer,
                    n: __embind_register_memory_view,
                    E: __embind_register_std_string,
                    y: __embind_register_std_wstring,
                    ia: __embind_register_value_array,
                    o: __embind_register_value_array_element,
                    r: __embind_register_value_object,
                    e: __embind_register_value_object_field,
                    ga: __embind_register_void,
                    V: __emscripten_get_now_is_monotonic,
                    T: __emscripten_notify_mailbox_postmessage,
                    Y: __emscripten_set_offscreencanvas_size,
                    Z: __emscripten_thread_mailbox_await,
                    da: __emscripten_thread_set_strongref,
                    m: __emval_as,
                    x: __emval_call,
                    b: __emval_decref,
                    A: __emval_get_global,
                    k: __emval_get_property,
                    s: __emval_incref,
                    H: __emval_instanceof,
                    z: __emval_is_number,
                    G: __emval_is_string,
                    F: __emval_new_array,
                    h: __emval_new_cstring,
                    u: __emval_new_object,
                    l: __emval_run_destructors,
                    p: __emval_set_property,
                    f: __emval_take_value,
                    J: __gmtime_js,
                    K: __localtime_js,
                    S: __tzset_js,
                    w: _abort,
                    C: _emscripten_check_blocking_allowed,
                    W: _emscripten_date_now,
                    ca: _emscripten_exit_with_live_runtime,
                    v: _emscripten_get_now,
                    X: _emscripten_receive_on_main_thread_js,
                    R: _emscripten_resize_heap,
                    aa: _environ_get,
                    ba: _environ_sizes_get,
                    M: _exit,
                    P: _fd_close,
                    $: _fd_fdstat_get,
                    Q: _fd_read,
                    I: _fd_seek,
                    U: _fd_write,
                    N: _getentropy,
                    a: wasmMemory || Module["wasmMemory"],
                    O: _strftime_l
                };
                var asm = createWasm();
                var ___wasm_call_ctors = ()=>(___wasm_call_ctors = wasmExports["ja"])();
                var _free = (a0)=>(_free = wasmExports["ka"])(a0);
                var _malloc = (a0)=>(_malloc = wasmExports["la"])(a0);
                var _pthread_self = Module["_pthread_self"] = ()=>(_pthread_self = Module["_pthread_self"] = wasmExports["ma"])();
                var __emscripten_tls_init = Module["__emscripten_tls_init"] = ()=>(__emscripten_tls_init = Module["__emscripten_tls_init"] = wasmExports["oa"])();
                var ___getTypeName = (a0)=>(___getTypeName = wasmExports["pa"])(a0);
                var __embind_initialize_bindings = Module["__embind_initialize_bindings"] = ()=>(__embind_initialize_bindings = Module["__embind_initialize_bindings"] = wasmExports["qa"])();
                var ___errno_location = ()=>(___errno_location = wasmExports["__errno_location"])();
                var __emscripten_thread_init = Module["__emscripten_thread_init"] = (a0, a1, a2, a3, a4, a5)=>(__emscripten_thread_init = Module["__emscripten_thread_init"] = wasmExports["ra"])(a0, a1, a2, a3, a4, a5);
                var __emscripten_thread_crashed = Module["__emscripten_thread_crashed"] = ()=>(__emscripten_thread_crashed = Module["__emscripten_thread_crashed"] = wasmExports["sa"])();
                var _emscripten_main_thread_process_queued_calls = ()=>(_emscripten_main_thread_process_queued_calls = wasmExports["emscripten_main_thread_process_queued_calls"])();
                var _emscripten_main_runtime_thread_id = ()=>(_emscripten_main_runtime_thread_id = wasmExports["emscripten_main_runtime_thread_id"])();
                var __emscripten_run_in_main_runtime_thread_js = (a0, a1, a2, a3)=>(__emscripten_run_in_main_runtime_thread_js = wasmExports["ta"])(a0, a1, a2, a3);
                var _emscripten_dispatch_to_thread_ = (a0, a1, a2, a3, a4)=>(_emscripten_dispatch_to_thread_ = wasmExports["emscripten_dispatch_to_thread_"])(a0, a1, a2, a3, a4);
                var __emscripten_thread_free_data = (a0)=>(__emscripten_thread_free_data = wasmExports["ua"])(a0);
                var __emscripten_thread_exit = Module["__emscripten_thread_exit"] = (a0)=>(__emscripten_thread_exit = Module["__emscripten_thread_exit"] = wasmExports["va"])(a0);
                var __emscripten_check_mailbox = Module["__emscripten_check_mailbox"] = ()=>(__emscripten_check_mailbox = Module["__emscripten_check_mailbox"] = wasmExports["wa"])();
                var _emscripten_stack_set_limits = (a0, a1)=>(_emscripten_stack_set_limits = wasmExports["xa"])(a0, a1);
                var stackSave = ()=>(stackSave = wasmExports["ya"])();
                var stackRestore = (a0)=>(stackRestore = wasmExports["za"])(a0);
                var stackAlloc = (a0)=>(stackAlloc = wasmExports["Aa"])(a0);
                var ___cxa_increment_exception_refcount = (a0)=>(___cxa_increment_exception_refcount = wasmExports["__cxa_increment_exception_refcount"])(a0);
                var ___cxa_is_pointer_type = (a0)=>(___cxa_is_pointer_type = wasmExports["Ba"])(a0);
                var dynCall_jiji = Module["dynCall_jiji"] = (a0, a1, a2, a3, a4)=>(dynCall_jiji = Module["dynCall_jiji"] = wasmExports["Ca"])(a0, a1, a2, a3, a4);
                var dynCall_viijii = Module["dynCall_viijii"] = (a0, a1, a2, a3, a4, a5, a6)=>(dynCall_viijii = Module["dynCall_viijii"] = wasmExports["Da"])(a0, a1, a2, a3, a4, a5, a6);
                var dynCall_iiiiij = Module["dynCall_iiiiij"] = (a0, a1, a2, a3, a4, a5, a6)=>(dynCall_iiiiij = Module["dynCall_iiiiij"] = wasmExports["Ea"])(a0, a1, a2, a3, a4, a5, a6);
                var dynCall_iiiiijj = Module["dynCall_iiiiijj"] = (a0, a1, a2, a3, a4, a5, a6, a7, a8)=>(dynCall_iiiiijj = Module["dynCall_iiiiijj"] = wasmExports["Fa"])(a0, a1, a2, a3, a4, a5, a6, a7, a8);
                var dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9)=>(dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = wasmExports["Ga"])(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
                function applySignatureConversions(exports2) {
                    exports2 = Object.assign({}, exports2);
                    var makeWrapper_pp = (f)=>(a0)=>f(a0) >>> 0;
                    var makeWrapper_p = (f)=>()=>f() >>> 0;
                    exports2["malloc"] = makeWrapper_pp(exports2["malloc"]);
                    exports2["pthread_self"] = makeWrapper_p(exports2["pthread_self"]);
                    exports2["__getTypeName"] = makeWrapper_pp(exports2["__getTypeName"]);
                    exports2["__errno_location"] = makeWrapper_p(exports2["__errno_location"]);
                    exports2["stackSave"] = makeWrapper_p(exports2["stackSave"]);
                    exports2["stackAlloc"] = makeWrapper_pp(exports2["stackAlloc"]);
                    return exports2;
                }
                Module["keepRuntimeAlive"] = keepRuntimeAlive;
                Module["wasmMemory"] = wasmMemory;
                Module["ExitStatus"] = ExitStatus;
                Module["PThread"] = PThread;
                var calledRun;
                dependenciesFulfilled = function runCaller() {
                    if (!calledRun) run();
                    if (!calledRun) dependenciesFulfilled = runCaller;
                };
                function run() {
                    if (runDependencies > 0) return;
                    if (ENVIRONMENT_IS_PTHREAD) {
                        readyPromiseResolve(Module);
                        initRuntime();
                        startWorker(Module);
                        return;
                    }
                    preRun();
                    if (runDependencies > 0) return;
                    function doRun() {
                        if (calledRun) return;
                        calledRun = true;
                        Module["calledRun"] = true;
                        if (ABORT) return;
                        initRuntime();
                        readyPromiseResolve(Module);
                        if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                        postRun();
                    }
                    if (Module["setStatus"]) {
                        Module["setStatus"]("Running...");
                        setTimeout(function() {
                            setTimeout(function() {
                                Module["setStatus"]("");
                            }, 1);
                            doRun();
                        }, 1);
                    } else doRun();
                }
                if (Module["preInit"]) {
                    if (typeof Module["preInit"] == "function") Module["preInit"] = [
                        Module["preInit"]
                    ];
                    while(Module["preInit"].length > 0)Module["preInit"].pop()();
                }
                run();
                return moduleArg.ready;
            };
        })();
        if (typeof exports === "object" && typeof module === "object") module.exports = WebIFCWasm2;
        else if (typeof define === "function" && define["amd"]) define([], ()=>WebIFCWasm2);
    }
});
// dist/web-ifc.js
var $3b8da494b8e92f36$var$require_web_ifc = $3b8da494b8e92f36$var$__commonJS({
    "dist/web-ifc.js" (exports, module) {
        "use strict";
        var WebIFCWasm2 = (()=>{
            var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;
            return function(moduleArg = {}) {
                var Module = moduleArg;
                var readyPromiseResolve, readyPromiseReject;
                Module["ready"] = new Promise((resolve, reject)=>{
                    readyPromiseResolve = resolve;
                    readyPromiseReject = reject;
                });
                var moduleOverrides = Object.assign({}, Module);
                var arguments_ = [];
                var thisProgram = "./this.program";
                var quit_ = (status, toThrow)=>{
                    throw toThrow;
                };
                var ENVIRONMENT_IS_WEB = true;
                var ENVIRONMENT_IS_WORKER = false;
                var scriptDirectory = "";
                function locateFile(path) {
                    if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
                    return scriptDirectory + path;
                }
                var read_, readAsync, readBinary, setWindowTitle;
                if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
                    if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
                    else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
                    if (_scriptDir) scriptDirectory = _scriptDir;
                    if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
                    else scriptDirectory = "";
                    read_ = (url)=>{
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, false);
                        xhr.send(null);
                        return xhr.responseText;
                    };
                    if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, false);
                        xhr.responseType = "arraybuffer";
                        xhr.send(null);
                        return new Uint8Array(xhr.response);
                    };
                    readAsync = (url, onload, onerror)=>{
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, true);
                        xhr.responseType = "arraybuffer";
                        xhr.onload = ()=>{
                            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                                onload(xhr.response);
                                return;
                            }
                            onerror();
                        };
                        xhr.onerror = onerror;
                        xhr.send(null);
                    };
                    setWindowTitle = (title)=>document.title = title;
                }
                var out = Module["print"] || console.log.bind(console);
                var err = Module["printErr"] || console.error.bind(console);
                Object.assign(Module, moduleOverrides);
                moduleOverrides = null;
                if (Module["arguments"]) arguments_ = Module["arguments"];
                if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
                if (Module["quit"]) quit_ = Module["quit"];
                var wasmBinary;
                if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
                var noExitRuntime = Module["noExitRuntime"] || true;
                if (typeof WebAssembly != "object") abort("no native wasm support detected");
                var wasmMemory;
                var wasmExports;
                var ABORT = false;
                var EXITSTATUS;
                function assert(condition, text) {
                    if (!condition) abort(text);
                }
                var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
                function updateMemoryViews() {
                    var b = wasmMemory.buffer;
                    Module["HEAP8"] = HEAP8 = new Int8Array(b);
                    Module["HEAP16"] = HEAP16 = new Int16Array(b);
                    Module["HEAP32"] = HEAP32 = new Int32Array(b);
                    Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
                    Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
                    Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
                    Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
                    Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
                }
                var wasmTable;
                var __ATPRERUN__ = [];
                var __ATINIT__ = [];
                var __ATPOSTRUN__ = [];
                var runtimeInitialized = false;
                function preRun() {
                    if (Module["preRun"]) {
                        if (typeof Module["preRun"] == "function") Module["preRun"] = [
                            Module["preRun"]
                        ];
                        while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
                    }
                    callRuntimeCallbacks(__ATPRERUN__);
                }
                function initRuntime() {
                    runtimeInitialized = true;
                    if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
                    FS.ignorePermissions = false;
                    TTY.init();
                    callRuntimeCallbacks(__ATINIT__);
                }
                function postRun() {
                    if (Module["postRun"]) {
                        if (typeof Module["postRun"] == "function") Module["postRun"] = [
                            Module["postRun"]
                        ];
                        while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
                    }
                    callRuntimeCallbacks(__ATPOSTRUN__);
                }
                function addOnPreRun(cb) {
                    __ATPRERUN__.unshift(cb);
                }
                function addOnInit(cb) {
                    __ATINIT__.unshift(cb);
                }
                function addOnPostRun(cb) {
                    __ATPOSTRUN__.unshift(cb);
                }
                var runDependencies = 0;
                var runDependencyWatcher = null;
                var dependenciesFulfilled = null;
                function getUniqueRunDependency(id) {
                    return id;
                }
                function addRunDependency(id) {
                    runDependencies++;
                    if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
                }
                function removeRunDependency(id) {
                    runDependencies--;
                    if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
                    if (runDependencies == 0) {
                        if (runDependencyWatcher !== null) {
                            clearInterval(runDependencyWatcher);
                            runDependencyWatcher = null;
                        }
                        if (dependenciesFulfilled) {
                            var callback = dependenciesFulfilled;
                            dependenciesFulfilled = null;
                            callback();
                        }
                    }
                }
                function abort(what) {
                    if (Module["onAbort"]) Module["onAbort"](what);
                    what = "Aborted(" + what + ")";
                    err(what);
                    ABORT = true;
                    EXITSTATUS = 1;
                    what += ". Build with -sASSERTIONS for more info.";
                    var e = new WebAssembly.RuntimeError(what);
                    readyPromiseReject(e);
                    throw e;
                }
                var dataURIPrefix = "data:application/octet-stream;base64,";
                function isDataURI(filename) {
                    return filename.startsWith(dataURIPrefix);
                }
                var wasmBinaryFile;
                wasmBinaryFile = "web-ifc.wasm";
                if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
                function getBinarySync(file) {
                    if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
                    if (readBinary) return readBinary(file);
                    throw "both async and sync fetching of the wasm failed";
                }
                function getBinaryPromise(binaryFile) {
                    if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
                        if (typeof fetch == "function") return fetch(binaryFile, {
                            credentials: "same-origin"
                        }).then((response)=>{
                            if (!response["ok"]) throw "failed to load wasm binary file at '" + binaryFile + "'";
                            return response["arrayBuffer"]();
                        }).catch(()=>getBinarySync(binaryFile));
                    }
                    return Promise.resolve().then(()=>getBinarySync(binaryFile));
                }
                function instantiateArrayBuffer(binaryFile, imports, receiver) {
                    return getBinaryPromise(binaryFile).then((binary)=>WebAssembly.instantiate(binary, imports)).then((instance)=>instance).then(receiver, (reason)=>{
                        err("failed to asynchronously prepare wasm: " + reason);
                        abort(reason);
                    });
                }
                function instantiateAsync(binary, binaryFile, imports, callback) {
                    if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") return fetch(binaryFile, {
                        credentials: "same-origin"
                    }).then((response)=>{
                        var result = WebAssembly.instantiateStreaming(response, imports);
                        return result.then(callback, function(reason) {
                            err("wasm streaming compile failed: " + reason);
                            err("falling back to ArrayBuffer instantiation");
                            return instantiateArrayBuffer(binaryFile, imports, callback);
                        });
                    });
                    return instantiateArrayBuffer(binaryFile, imports, callback);
                }
                function createWasm() {
                    var info = {
                        "a": wasmImports
                    };
                    function receiveInstance(instance, module2) {
                        var exports2 = instance.exports;
                        exports2 = applySignatureConversions(exports2);
                        wasmExports = exports2;
                        wasmMemory = wasmExports["_"];
                        updateMemoryViews();
                        wasmTable = wasmExports["ca"];
                        addOnInit(wasmExports["$"]);
                        removeRunDependency("wasm-instantiate");
                        return exports2;
                    }
                    addRunDependency("wasm-instantiate");
                    function receiveInstantiationResult(result) {
                        receiveInstance(result["instance"]);
                    }
                    if (Module["instantiateWasm"]) try {
                        return Module["instantiateWasm"](info, receiveInstance);
                    } catch (e) {
                        err("Module.instantiateWasm callback failed with error: " + e);
                        readyPromiseReject(e);
                    }
                    instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
                    return {};
                }
                var tempDouble;
                var tempI64;
                var callRuntimeCallbacks = (callbacks)=>{
                    while(callbacks.length > 0)callbacks.shift()(Module);
                };
                function ExceptionInfo(excPtr) {
                    this.excPtr = excPtr;
                    this.ptr = excPtr - 24;
                    this.set_type = function(type) {
                        HEAPU32[this.ptr + 4 >>> 2] = type;
                    };
                    this.get_type = function() {
                        return HEAPU32[this.ptr + 4 >>> 2];
                    };
                    this.set_destructor = function(destructor) {
                        HEAPU32[this.ptr + 8 >>> 2] = destructor;
                    };
                    this.get_destructor = function() {
                        return HEAPU32[this.ptr + 8 >>> 2];
                    };
                    this.set_caught = function(caught) {
                        caught = caught ? 1 : 0;
                        HEAP8[this.ptr + 12 >>> 0] = caught;
                    };
                    this.get_caught = function() {
                        return HEAP8[this.ptr + 12 >>> 0] != 0;
                    };
                    this.set_rethrown = function(rethrown) {
                        rethrown = rethrown ? 1 : 0;
                        HEAP8[this.ptr + 13 >>> 0] = rethrown;
                    };
                    this.get_rethrown = function() {
                        return HEAP8[this.ptr + 13 >>> 0] != 0;
                    };
                    this.init = function(type, destructor) {
                        this.set_adjusted_ptr(0);
                        this.set_type(type);
                        this.set_destructor(destructor);
                    };
                    this.set_adjusted_ptr = function(adjustedPtr) {
                        HEAPU32[this.ptr + 16 >>> 2] = adjustedPtr;
                    };
                    this.get_adjusted_ptr = function() {
                        return HEAPU32[this.ptr + 16 >>> 2];
                    };
                    this.get_exception_ptr = function() {
                        var isPointer = ___cxa_is_pointer_type(this.get_type());
                        if (isPointer) return HEAPU32[this.excPtr >>> 2];
                        var adjusted = this.get_adjusted_ptr();
                        if (adjusted !== 0) return adjusted;
                        return this.excPtr;
                    };
                }
                var exceptionLast = 0;
                var uncaughtExceptionCount = 0;
                function convertI32PairToI53Checked(lo, hi) {
                    return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
                }
                function ___cxa_throw(ptr, type, destructor) {
                    ptr >>>= 0;
                    type >>>= 0;
                    destructor >>>= 0;
                    var info = new ExceptionInfo(ptr);
                    info.init(type, destructor);
                    exceptionLast = ptr;
                    uncaughtExceptionCount++;
                    throw exceptionLast;
                }
                var tupleRegistrations = {};
                function runDestructors(destructors) {
                    while(destructors.length){
                        var ptr = destructors.pop();
                        var del = destructors.pop();
                        del(ptr);
                    }
                }
                function simpleReadValueFromPointer(pointer) {
                    return this["fromWireType"](HEAP32[pointer >>> 2]);
                }
                var awaitingDependencies = {};
                var registeredTypes = {};
                var typeDependencies = {};
                var InternalError = void 0;
                function throwInternalError(message) {
                    throw new InternalError(message);
                }
                function whenDependentTypesAreResolved(myTypes, dependentTypes, getTypeConverters) {
                    myTypes.forEach(function(type) {
                        typeDependencies[type] = dependentTypes;
                    });
                    function onComplete(typeConverters2) {
                        var myTypeConverters = getTypeConverters(typeConverters2);
                        if (myTypeConverters.length !== myTypes.length) throwInternalError("Mismatched type converter count");
                        for(var i = 0; i < myTypes.length; ++i)registerType(myTypes[i], myTypeConverters[i]);
                    }
                    var typeConverters = new Array(dependentTypes.length);
                    var unregisteredTypes = [];
                    var registered = 0;
                    dependentTypes.forEach((dt, i)=>{
                        if (registeredTypes.hasOwnProperty(dt)) typeConverters[i] = registeredTypes[dt];
                        else {
                            unregisteredTypes.push(dt);
                            if (!awaitingDependencies.hasOwnProperty(dt)) awaitingDependencies[dt] = [];
                            awaitingDependencies[dt].push(()=>{
                                typeConverters[i] = registeredTypes[dt];
                                ++registered;
                                if (registered === unregisteredTypes.length) onComplete(typeConverters);
                            });
                        }
                    });
                    if (0 === unregisteredTypes.length) onComplete(typeConverters);
                }
                function __embind_finalize_value_array(rawTupleType) {
                    rawTupleType >>>= 0;
                    var reg = tupleRegistrations[rawTupleType];
                    delete tupleRegistrations[rawTupleType];
                    var elements = reg.elements;
                    var elementsLength = elements.length;
                    var elementTypes = elements.map(function(elt) {
                        return elt.getterReturnType;
                    }).concat(elements.map(function(elt) {
                        return elt.setterArgumentType;
                    }));
                    var rawConstructor = reg.rawConstructor;
                    var rawDestructor = reg.rawDestructor;
                    whenDependentTypesAreResolved([
                        rawTupleType
                    ], elementTypes, function(elementTypes2) {
                        elements.forEach((elt, i)=>{
                            var getterReturnType = elementTypes2[i];
                            var getter = elt.getter;
                            var getterContext = elt.getterContext;
                            var setterArgumentType = elementTypes2[i + elementsLength];
                            var setter = elt.setter;
                            var setterContext = elt.setterContext;
                            elt.read = (ptr)=>getterReturnType["fromWireType"](getter(getterContext, ptr));
                            elt.write = (ptr, o)=>{
                                var destructors = [];
                                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                                runDestructors(destructors);
                            };
                        });
                        return [
                            {
                                name: reg.name,
                                "fromWireType": function(ptr) {
                                    var rv = new Array(elementsLength);
                                    for(var i = 0; i < elementsLength; ++i)rv[i] = elements[i].read(ptr);
                                    rawDestructor(ptr);
                                    return rv;
                                },
                                "toWireType": function(destructors, o) {
                                    if (elementsLength !== o.length) throw new TypeError(`Incorrect number of tuple elements for ${reg.name}: expected=${elementsLength}, actual=${o.length}`);
                                    var ptr = rawConstructor();
                                    for(var i = 0; i < elementsLength; ++i)elements[i].write(ptr, o[i]);
                                    if (destructors !== null) destructors.push(rawDestructor, ptr);
                                    return ptr;
                                },
                                "argPackAdvance": 8,
                                "readValueFromPointer": simpleReadValueFromPointer,
                                destructorFunction: rawDestructor
                            }
                        ];
                    });
                }
                var structRegistrations = {};
                var __embind_finalize_value_object = function(structType) {
                    structType >>>= 0;
                    var reg = structRegistrations[structType];
                    delete structRegistrations[structType];
                    var rawConstructor = reg.rawConstructor;
                    var rawDestructor = reg.rawDestructor;
                    var fieldRecords = reg.fields;
                    var fieldTypes = fieldRecords.map((field)=>field.getterReturnType).concat(fieldRecords.map((field)=>field.setterArgumentType));
                    whenDependentTypesAreResolved([
                        structType
                    ], fieldTypes, (fieldTypes2)=>{
                        var fields = {};
                        fieldRecords.forEach((field, i)=>{
                            var fieldName = field.fieldName;
                            var getterReturnType = fieldTypes2[i];
                            var getter = field.getter;
                            var getterContext = field.getterContext;
                            var setterArgumentType = fieldTypes2[i + fieldRecords.length];
                            var setter = field.setter;
                            var setterContext = field.setterContext;
                            fields[fieldName] = {
                                read: (ptr)=>getterReturnType["fromWireType"](getter(getterContext, ptr)),
                                write: (ptr, o)=>{
                                    var destructors = [];
                                    setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                                    runDestructors(destructors);
                                }
                            };
                        });
                        return [
                            {
                                name: reg.name,
                                "fromWireType": function(ptr) {
                                    var rv = {};
                                    for(var i in fields)rv[i] = fields[i].read(ptr);
                                    rawDestructor(ptr);
                                    return rv;
                                },
                                "toWireType": function(destructors, o) {
                                    for(var fieldName in fields){
                                        if (!(fieldName in o)) throw new TypeError(`Missing field: "${fieldName}"`);
                                    }
                                    var ptr = rawConstructor();
                                    for(fieldName in fields)fields[fieldName].write(ptr, o[fieldName]);
                                    if (destructors !== null) destructors.push(rawDestructor, ptr);
                                    return ptr;
                                },
                                "argPackAdvance": 8,
                                "readValueFromPointer": simpleReadValueFromPointer,
                                destructorFunction: rawDestructor
                            }
                        ];
                    });
                };
                function __embind_register_bigint(primitiveType, name, size, minRange, maxRange) {
                    primitiveType >>>= 0;
                    name >>>= 0;
                    size >>>= 0;
                }
                function getShiftFromSize(size) {
                    switch(size){
                        case 1:
                            return 0;
                        case 2:
                            return 1;
                        case 4:
                            return 2;
                        case 8:
                            return 3;
                        default:
                            throw new TypeError(`Unknown type size: ${size}`);
                    }
                }
                function embind_init_charCodes() {
                    var codes = new Array(256);
                    for(var i = 0; i < 256; ++i)codes[i] = String.fromCharCode(i);
                    embind_charCodes = codes;
                }
                var embind_charCodes = void 0;
                function readLatin1String(ptr) {
                    var ret = "";
                    var c = ptr;
                    while(HEAPU8[c >>> 0])ret += embind_charCodes[HEAPU8[c++ >>> 0]];
                    return ret;
                }
                var BindingError = void 0;
                function throwBindingError(message) {
                    throw new BindingError(message);
                }
                function sharedRegisterType(rawType, registeredInstance, options = {}) {
                    var name = registeredInstance.name;
                    if (!rawType) throwBindingError(`type "${name}" must have a positive integer typeid pointer`);
                    if (registeredTypes.hasOwnProperty(rawType)) {
                        if (options.ignoreDuplicateRegistrations) return;
                        else throwBindingError(`Cannot register type '${name}' twice`);
                    }
                    registeredTypes[rawType] = registeredInstance;
                    delete typeDependencies[rawType];
                    if (awaitingDependencies.hasOwnProperty(rawType)) {
                        var callbacks = awaitingDependencies[rawType];
                        delete awaitingDependencies[rawType];
                        callbacks.forEach((cb)=>cb());
                    }
                }
                function registerType(rawType, registeredInstance, options = {}) {
                    if (!("argPackAdvance" in registeredInstance)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
                    return sharedRegisterType(rawType, registeredInstance, options);
                }
                function __embind_register_bool(rawType, name, size, trueValue, falseValue) {
                    rawType >>>= 0;
                    name >>>= 0;
                    size >>>= 0;
                    var shift = getShiftFromSize(size);
                    name = readLatin1String(name);
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(wt) {
                            return !!wt;
                        },
                        "toWireType": function(destructors, o) {
                            return o ? trueValue : falseValue;
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": function(pointer) {
                            var heap;
                            if (size === 1) heap = HEAP8;
                            else if (size === 2) heap = HEAP16;
                            else if (size === 4) heap = HEAP32;
                            else throw new TypeError("Unknown boolean type size: " + name);
                            return this["fromWireType"](heap[pointer >>> shift]);
                        },
                        destructorFunction: null
                    });
                }
                function ClassHandle_isAliasOf(other) {
                    if (!(this instanceof ClassHandle)) return false;
                    if (!(other instanceof ClassHandle)) return false;
                    var leftClass = this.$$.ptrType.registeredClass;
                    var left = this.$$.ptr;
                    var rightClass = other.$$.ptrType.registeredClass;
                    var right = other.$$.ptr;
                    while(leftClass.baseClass){
                        left = leftClass.upcast(left);
                        leftClass = leftClass.baseClass;
                    }
                    while(rightClass.baseClass){
                        right = rightClass.upcast(right);
                        rightClass = rightClass.baseClass;
                    }
                    return leftClass === rightClass && left === right;
                }
                function shallowCopyInternalPointer(o) {
                    return {
                        count: o.count,
                        deleteScheduled: o.deleteScheduled,
                        preservePointerOnDelete: o.preservePointerOnDelete,
                        ptr: o.ptr,
                        ptrType: o.ptrType,
                        smartPtr: o.smartPtr,
                        smartPtrType: o.smartPtrType
                    };
                }
                function throwInstanceAlreadyDeleted(obj) {
                    function getInstanceTypeName(handle) {
                        return handle.$$.ptrType.registeredClass.name;
                    }
                    throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
                }
                var finalizationRegistry = false;
                function detachFinalizer(handle) {}
                function runDestructor($$) {
                    if ($$.smartPtr) $$.smartPtrType.rawDestructor($$.smartPtr);
                    else $$.ptrType.registeredClass.rawDestructor($$.ptr);
                }
                function releaseClassHandle($$) {
                    $$.count.value -= 1;
                    var toDelete = 0 === $$.count.value;
                    if (toDelete) runDestructor($$);
                }
                function downcastPointer(ptr, ptrClass, desiredClass) {
                    if (ptrClass === desiredClass) return ptr;
                    if (void 0 === desiredClass.baseClass) return null;
                    var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);
                    if (rv === null) return null;
                    return desiredClass.downcast(rv);
                }
                var registeredPointers = {};
                function getInheritedInstanceCount() {
                    return Object.keys(registeredInstances).length;
                }
                function getLiveInheritedInstances() {
                    var rv = [];
                    for(var k in registeredInstances)if (registeredInstances.hasOwnProperty(k)) rv.push(registeredInstances[k]);
                    return rv;
                }
                var deletionQueue = [];
                function flushPendingDeletes() {
                    while(deletionQueue.length){
                        var obj = deletionQueue.pop();
                        obj.$$.deleteScheduled = false;
                        obj["delete"]();
                    }
                }
                var delayFunction = void 0;
                function setDelayFunction(fn) {
                    delayFunction = fn;
                    if (deletionQueue.length && delayFunction) delayFunction(flushPendingDeletes);
                }
                function init_embind() {
                    Module["getInheritedInstanceCount"] = getInheritedInstanceCount;
                    Module["getLiveInheritedInstances"] = getLiveInheritedInstances;
                    Module["flushPendingDeletes"] = flushPendingDeletes;
                    Module["setDelayFunction"] = setDelayFunction;
                }
                var registeredInstances = {};
                function getBasestPointer(class_, ptr) {
                    if (ptr === void 0) throwBindingError("ptr should not be undefined");
                    while(class_.baseClass){
                        ptr = class_.upcast(ptr);
                        class_ = class_.baseClass;
                    }
                    return ptr;
                }
                function getInheritedInstance(class_, ptr) {
                    ptr = getBasestPointer(class_, ptr);
                    return registeredInstances[ptr];
                }
                function makeClassHandle(prototype, record) {
                    if (!record.ptrType || !record.ptr) throwInternalError("makeClassHandle requires ptr and ptrType");
                    var hasSmartPtrType = !!record.smartPtrType;
                    var hasSmartPtr = !!record.smartPtr;
                    if (hasSmartPtrType !== hasSmartPtr) throwInternalError("Both smartPtrType and smartPtr must be specified");
                    record.count = {
                        value: 1
                    };
                    return attachFinalizer(Object.create(prototype, {
                        $$: {
                            value: record
                        }
                    }));
                }
                function RegisteredPointer_fromWireType(ptr) {
                    var rawPointer = this.getPointee(ptr);
                    if (!rawPointer) {
                        this.destructor(ptr);
                        return null;
                    }
                    var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);
                    if (void 0 !== registeredInstance) {
                        if (0 === registeredInstance.$$.count.value) {
                            registeredInstance.$$.ptr = rawPointer;
                            registeredInstance.$$.smartPtr = ptr;
                            return registeredInstance["clone"]();
                        } else {
                            var rv = registeredInstance["clone"]();
                            this.destructor(ptr);
                            return rv;
                        }
                    }
                    function makeDefaultHandle() {
                        if (this.isSmartPointer) return makeClassHandle(this.registeredClass.instancePrototype, {
                            ptrType: this.pointeeType,
                            ptr: rawPointer,
                            smartPtrType: this,
                            smartPtr: ptr
                        });
                        else return makeClassHandle(this.registeredClass.instancePrototype, {
                            ptrType: this,
                            ptr: ptr
                        });
                    }
                    var actualType = this.registeredClass.getActualType(rawPointer);
                    var registeredPointerRecord = registeredPointers[actualType];
                    if (!registeredPointerRecord) return makeDefaultHandle.call(this);
                    var toType;
                    if (this.isConst) toType = registeredPointerRecord.constPointerType;
                    else toType = registeredPointerRecord.pointerType;
                    var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);
                    if (dp === null) return makeDefaultHandle.call(this);
                    if (this.isSmartPointer) return makeClassHandle(toType.registeredClass.instancePrototype, {
                        ptrType: toType,
                        ptr: dp,
                        smartPtrType: this,
                        smartPtr: ptr
                    });
                    else return makeClassHandle(toType.registeredClass.instancePrototype, {
                        ptrType: toType,
                        ptr: dp
                    });
                }
                var attachFinalizer = function(handle) {
                    if ("undefined" === typeof FinalizationRegistry) {
                        attachFinalizer = (handle2)=>handle2;
                        return handle;
                    }
                    finalizationRegistry = new FinalizationRegistry((info)=>{
                        releaseClassHandle(info.$$);
                    });
                    attachFinalizer = (handle2)=>{
                        var $$ = handle2.$$;
                        var hasSmartPtr = !!$$.smartPtr;
                        if (hasSmartPtr) {
                            var info = {
                                $$: $$
                            };
                            finalizationRegistry.register(handle2, info, handle2);
                        }
                        return handle2;
                    };
                    detachFinalizer = (handle2)=>finalizationRegistry.unregister(handle2);
                    return attachFinalizer(handle);
                };
                function ClassHandle_clone() {
                    if (!this.$$.ptr) throwInstanceAlreadyDeleted(this);
                    if (this.$$.preservePointerOnDelete) {
                        this.$$.count.value += 1;
                        return this;
                    } else {
                        var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), {
                            $$: {
                                value: shallowCopyInternalPointer(this.$$)
                            }
                        }));
                        clone.$$.count.value += 1;
                        clone.$$.deleteScheduled = false;
                        return clone;
                    }
                }
                function ClassHandle_delete() {
                    if (!this.$$.ptr) throwInstanceAlreadyDeleted(this);
                    if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) throwBindingError("Object already scheduled for deletion");
                    detachFinalizer(this);
                    releaseClassHandle(this.$$);
                    if (!this.$$.preservePointerOnDelete) {
                        this.$$.smartPtr = void 0;
                        this.$$.ptr = void 0;
                    }
                }
                function ClassHandle_isDeleted() {
                    return !this.$$.ptr;
                }
                function ClassHandle_deleteLater() {
                    if (!this.$$.ptr) throwInstanceAlreadyDeleted(this);
                    if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) throwBindingError("Object already scheduled for deletion");
                    deletionQueue.push(this);
                    if (deletionQueue.length === 1 && delayFunction) delayFunction(flushPendingDeletes);
                    this.$$.deleteScheduled = true;
                    return this;
                }
                function init_ClassHandle() {
                    ClassHandle.prototype["isAliasOf"] = ClassHandle_isAliasOf;
                    ClassHandle.prototype["clone"] = ClassHandle_clone;
                    ClassHandle.prototype["delete"] = ClassHandle_delete;
                    ClassHandle.prototype["isDeleted"] = ClassHandle_isDeleted;
                    ClassHandle.prototype["deleteLater"] = ClassHandle_deleteLater;
                }
                function ClassHandle() {}
                var char_0 = 48;
                var char_9 = 57;
                function makeLegalFunctionName(name) {
                    if (void 0 === name) return "_unknown";
                    name = name.replace(/[^a-zA-Z0-9_]/g, "$");
                    var f = name.charCodeAt(0);
                    if (f >= char_0 && f <= char_9) return `_${name}`;
                    return name;
                }
                function createNamedFunction(name, body) {
                    name = makeLegalFunctionName(name);
                    return ({
                        [name]: function() {
                            return body.apply(this, arguments);
                        }
                    })[name];
                }
                function ensureOverloadTable(proto, methodName, humanName) {
                    if (void 0 === proto[methodName].overloadTable) {
                        var prevFunc = proto[methodName];
                        proto[methodName] = function() {
                            if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) throwBindingError(`Function '${humanName}' called with an invalid number of arguments (${arguments.length}) - expects one of (${proto[methodName].overloadTable})!`);
                            return proto[methodName].overloadTable[arguments.length].apply(this, arguments);
                        };
                        proto[methodName].overloadTable = [];
                        proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
                    }
                }
                function exposePublicSymbol(name, value, numArguments) {
                    if (Module.hasOwnProperty(name)) {
                        if (void 0 === numArguments || void 0 !== Module[name].overloadTable && void 0 !== Module[name].overloadTable[numArguments]) throwBindingError(`Cannot register public name '${name}' twice`);
                        ensureOverloadTable(Module, name, name);
                        if (Module.hasOwnProperty(numArguments)) throwBindingError(`Cannot register multiple overloads of a function with the same number of arguments (${numArguments})!`);
                        Module[name].overloadTable[numArguments] = value;
                    } else {
                        Module[name] = value;
                        if (void 0 !== numArguments) Module[name].numArguments = numArguments;
                    }
                }
                function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
                    this.name = name;
                    this.constructor = constructor;
                    this.instancePrototype = instancePrototype;
                    this.rawDestructor = rawDestructor;
                    this.baseClass = baseClass;
                    this.getActualType = getActualType;
                    this.upcast = upcast;
                    this.downcast = downcast;
                    this.pureVirtualFunctions = [];
                }
                function upcastPointer(ptr, ptrClass, desiredClass) {
                    while(ptrClass !== desiredClass){
                        if (!ptrClass.upcast) throwBindingError(`Expected null or instance of ${desiredClass.name}, got an instance of ${ptrClass.name}`);
                        ptr = ptrClass.upcast(ptr);
                        ptrClass = ptrClass.baseClass;
                    }
                    return ptr;
                }
                function constNoSmartPtrRawPointerToWireType(destructors, handle) {
                    if (handle === null) {
                        if (this.isReference) throwBindingError(`null is not a valid ${this.name}`);
                        return 0;
                    }
                    if (!handle.$$) throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
                    if (!handle.$$.ptr) throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
                    var handleClass = handle.$$.ptrType.registeredClass;
                    var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
                    return ptr;
                }
                function genericPointerToWireType(destructors, handle) {
                    var ptr;
                    if (handle === null) {
                        if (this.isReference) throwBindingError(`null is not a valid ${this.name}`);
                        if (this.isSmartPointer) {
                            ptr = this.rawConstructor();
                            if (destructors !== null) destructors.push(this.rawDestructor, ptr);
                            return ptr;
                        } else return 0;
                    }
                    if (!handle.$$) throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
                    if (!handle.$$.ptr) throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
                    if (!this.isConst && handle.$$.ptrType.isConst) throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
                    var handleClass = handle.$$.ptrType.registeredClass;
                    ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
                    if (this.isSmartPointer) {
                        if (void 0 === handle.$$.smartPtr) throwBindingError("Passing raw pointer to smart pointer is illegal");
                        switch(this.sharingPolicy){
                            case 0:
                                if (handle.$$.smartPtrType === this) ptr = handle.$$.smartPtr;
                                else throwBindingError(`Cannot convert argument of type ${handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name} to parameter type ${this.name}`);
                                break;
                            case 1:
                                ptr = handle.$$.smartPtr;
                                break;
                            case 2:
                                if (handle.$$.smartPtrType === this) ptr = handle.$$.smartPtr;
                                else {
                                    var clonedHandle = handle["clone"]();
                                    ptr = this.rawShare(ptr, Emval.toHandle(function() {
                                        clonedHandle["delete"]();
                                    }));
                                    if (destructors !== null) destructors.push(this.rawDestructor, ptr);
                                }
                                break;
                            default:
                                throwBindingError("Unsupporting sharing policy");
                        }
                    }
                    return ptr;
                }
                function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
                    if (handle === null) {
                        if (this.isReference) throwBindingError(`null is not a valid ${this.name}`);
                        return 0;
                    }
                    if (!handle.$$) throwBindingError(`Cannot pass "${embindRepr(handle)}" as a ${this.name}`);
                    if (!handle.$$.ptr) throwBindingError(`Cannot pass deleted object as a pointer of type ${this.name}`);
                    if (handle.$$.ptrType.isConst) throwBindingError(`Cannot convert argument of type ${handle.$$.ptrType.name} to parameter type ${this.name}`);
                    var handleClass = handle.$$.ptrType.registeredClass;
                    var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
                    return ptr;
                }
                function RegisteredPointer_getPointee(ptr) {
                    if (this.rawGetPointee) ptr = this.rawGetPointee(ptr);
                    return ptr;
                }
                function RegisteredPointer_destructor(ptr) {
                    if (this.rawDestructor) this.rawDestructor(ptr);
                }
                function RegisteredPointer_deleteObject(handle) {
                    if (handle !== null) handle["delete"]();
                }
                function init_RegisteredPointer() {
                    RegisteredPointer.prototype.getPointee = RegisteredPointer_getPointee;
                    RegisteredPointer.prototype.destructor = RegisteredPointer_destructor;
                    RegisteredPointer.prototype["argPackAdvance"] = 8;
                    RegisteredPointer.prototype["readValueFromPointer"] = simpleReadValueFromPointer;
                    RegisteredPointer.prototype["deleteObject"] = RegisteredPointer_deleteObject;
                    RegisteredPointer.prototype["fromWireType"] = RegisteredPointer_fromWireType;
                }
                function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
                    this.name = name;
                    this.registeredClass = registeredClass;
                    this.isReference = isReference;
                    this.isConst = isConst;
                    this.isSmartPointer = isSmartPointer;
                    this.pointeeType = pointeeType;
                    this.sharingPolicy = sharingPolicy;
                    this.rawGetPointee = rawGetPointee;
                    this.rawConstructor = rawConstructor;
                    this.rawShare = rawShare;
                    this.rawDestructor = rawDestructor;
                    if (!isSmartPointer && registeredClass.baseClass === void 0) {
                        if (isConst) {
                            this["toWireType"] = constNoSmartPtrRawPointerToWireType;
                            this.destructorFunction = null;
                        } else {
                            this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
                            this.destructorFunction = null;
                        }
                    } else this["toWireType"] = genericPointerToWireType;
                }
                function replacePublicSymbol(name, value, numArguments) {
                    if (!Module.hasOwnProperty(name)) throwInternalError("Replacing nonexistant public symbol");
                    if (void 0 !== Module[name].overloadTable && void 0 !== numArguments) Module[name].overloadTable[numArguments] = value;
                    else {
                        Module[name] = value;
                        Module[name].argCount = numArguments;
                    }
                }
                var dynCallLegacy = (sig, ptr, args)=>{
                    var f = Module["dynCall_" + sig];
                    return args && args.length ? f.apply(null, [
                        ptr
                    ].concat(args)) : f.call(null, ptr);
                };
                var wasmTableMirror = [];
                var getWasmTableEntry = (funcPtr)=>{
                    var func = wasmTableMirror[funcPtr];
                    if (!func) {
                        if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
                        wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
                    }
                    return func;
                };
                var dynCall = (sig, ptr, args)=>{
                    if (sig.includes("j")) return dynCallLegacy(sig, ptr, args);
                    var rtn = getWasmTableEntry(ptr).apply(null, args);
                    return rtn;
                };
                var getDynCaller = (sig, ptr)=>{
                    var argCache = [];
                    return function() {
                        argCache.length = 0;
                        Object.assign(argCache, arguments);
                        return dynCall(sig, ptr, argCache);
                    };
                };
                function embind__requireFunction(signature, rawFunction) {
                    signature = readLatin1String(signature);
                    function makeDynCaller() {
                        if (signature.includes("j")) return getDynCaller(signature, rawFunction);
                        return getWasmTableEntry(rawFunction);
                    }
                    var fp = makeDynCaller();
                    if (typeof fp != "function") throwBindingError(`unknown function pointer with signature ${signature}: ${rawFunction}`);
                    return fp;
                }
                function extendError(baseErrorType, errorName) {
                    var errorClass = createNamedFunction(errorName, function(message) {
                        this.name = errorName;
                        this.message = message;
                        var stack = new Error(message).stack;
                        if (stack !== void 0) this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "");
                    });
                    errorClass.prototype = Object.create(baseErrorType.prototype);
                    errorClass.prototype.constructor = errorClass;
                    errorClass.prototype.toString = function() {
                        if (this.message === void 0) return this.name;
                        else return `${this.name}: ${this.message}`;
                    };
                    return errorClass;
                }
                var UnboundTypeError = void 0;
                function getTypeName(type) {
                    var ptr = ___getTypeName(type);
                    var rv = readLatin1String(ptr);
                    _free(ptr);
                    return rv;
                }
                function throwUnboundTypeError(message, types) {
                    var unboundTypes = [];
                    var seen = {};
                    function visit(type) {
                        if (seen[type]) return;
                        if (registeredTypes[type]) return;
                        if (typeDependencies[type]) {
                            typeDependencies[type].forEach(visit);
                            return;
                        }
                        unboundTypes.push(type);
                        seen[type] = true;
                    }
                    types.forEach(visit);
                    throw new UnboundTypeError(`${message}: ` + unboundTypes.map(getTypeName).join([
                        ", "
                    ]));
                }
                function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
                    rawType >>>= 0;
                    rawPointerType >>>= 0;
                    rawConstPointerType >>>= 0;
                    baseClassRawType >>>= 0;
                    getActualTypeSignature >>>= 0;
                    getActualType >>>= 0;
                    upcastSignature >>>= 0;
                    upcast >>>= 0;
                    downcastSignature >>>= 0;
                    downcast >>>= 0;
                    name >>>= 0;
                    destructorSignature >>>= 0;
                    rawDestructor >>>= 0;
                    name = readLatin1String(name);
                    getActualType = embind__requireFunction(getActualTypeSignature, getActualType);
                    if (upcast) upcast = embind__requireFunction(upcastSignature, upcast);
                    if (downcast) downcast = embind__requireFunction(downcastSignature, downcast);
                    rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
                    var legalFunctionName = makeLegalFunctionName(name);
                    exposePublicSymbol(legalFunctionName, function() {
                        throwUnboundTypeError(`Cannot construct ${name} due to unbound types`, [
                            baseClassRawType
                        ]);
                    });
                    whenDependentTypesAreResolved([
                        rawType,
                        rawPointerType,
                        rawConstPointerType
                    ], baseClassRawType ? [
                        baseClassRawType
                    ] : [], function(base) {
                        base = base[0];
                        var baseClass;
                        var basePrototype;
                        if (baseClassRawType) {
                            baseClass = base.registeredClass;
                            basePrototype = baseClass.instancePrototype;
                        } else basePrototype = ClassHandle.prototype;
                        var constructor = createNamedFunction(legalFunctionName, function() {
                            if (Object.getPrototypeOf(this) !== instancePrototype) throw new BindingError("Use 'new' to construct " + name);
                            if (void 0 === registeredClass.constructor_body) throw new BindingError(name + " has no accessible constructor");
                            var body = registeredClass.constructor_body[arguments.length];
                            if (void 0 === body) throw new BindingError(`Tried to invoke ctor of ${name} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(registeredClass.constructor_body).toString()}) parameters instead!`);
                            return body.apply(this, arguments);
                        });
                        var instancePrototype = Object.create(basePrototype, {
                            constructor: {
                                value: constructor
                            }
                        });
                        constructor.prototype = instancePrototype;
                        var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
                        if (registeredClass.baseClass) {
                            if (registeredClass.baseClass.__derivedClasses === void 0) registeredClass.baseClass.__derivedClasses = [];
                            registeredClass.baseClass.__derivedClasses.push(registeredClass);
                        }
                        var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
                        var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
                        var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
                        registeredPointers[rawType] = {
                            pointerType: pointerConverter,
                            constPointerType: constPointerConverter
                        };
                        replacePublicSymbol(legalFunctionName, constructor);
                        return [
                            referenceConverter,
                            pointerConverter,
                            constPointerConverter
                        ];
                    });
                }
                function heap32VectorToArray(count, firstElement) {
                    var array = [];
                    for(var i = 0; i < count; i++)array.push(HEAPU32[firstElement + i * 4 >>> 2]);
                    return array;
                }
                function newFunc(constructor, argumentList) {
                    if (!(constructor instanceof Function)) throw new TypeError(`new_ called with constructor type ${typeof constructor} which is not a function`);
                    var dummy = createNamedFunction(constructor.name || "unknownFunctionName", function() {});
                    dummy.prototype = constructor.prototype;
                    var obj = new dummy();
                    var r = constructor.apply(obj, argumentList);
                    return r instanceof Object ? r : obj;
                }
                function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc, isAsync) {
                    var argCount = argTypes.length;
                    if (argCount < 2) throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
                    var isClassMethodFunc = argTypes[1] !== null && classType !== null;
                    var needsDestructorStack = false;
                    for(var i = 1; i < argTypes.length; ++i)if (argTypes[i] !== null && argTypes[i].destructorFunction === void 0) {
                        needsDestructorStack = true;
                        break;
                    }
                    var returns = argTypes[0].name !== "void";
                    var argsList = "";
                    var argsListWired = "";
                    for(var i = 0; i < argCount - 2; ++i){
                        argsList += (i !== 0 ? ", " : "") + "arg" + i;
                        argsListWired += (i !== 0 ? ", " : "") + "arg" + i + "Wired";
                    }
                    var invokerFnBody = `
        return function ${makeLegalFunctionName(humanName)}(${argsList}) {
        if (arguments.length !== ${argCount - 2}) {
          throwBindingError('function ${humanName} called with ${arguments.length} arguments, expected ${argCount - 2} args!');
        }`;
                    if (needsDestructorStack) invokerFnBody += "var destructors = [];\n";
                    var dtorStack = needsDestructorStack ? "destructors" : "null";
                    var args1 = [
                        "throwBindingError",
                        "invoker",
                        "fn",
                        "runDestructors",
                        "retType",
                        "classParam"
                    ];
                    var args2 = [
                        throwBindingError,
                        cppInvokerFunc,
                        cppTargetFunc,
                        runDestructors,
                        argTypes[0],
                        argTypes[1]
                    ];
                    if (isClassMethodFunc) invokerFnBody += "var thisWired = classParam.toWireType(" + dtorStack + ", this);\n";
                    for(var i = 0; i < argCount - 2; ++i){
                        invokerFnBody += "var arg" + i + "Wired = argType" + i + ".toWireType(" + dtorStack + ", arg" + i + "); // " + argTypes[i + 2].name + "\n";
                        args1.push("argType" + i);
                        args2.push(argTypes[i + 2]);
                    }
                    if (isClassMethodFunc) argsListWired = "thisWired" + (argsListWired.length > 0 ? ", " : "") + argsListWired;
                    invokerFnBody += (returns || isAsync ? "var rv = " : "") + "invoker(fn" + (argsListWired.length > 0 ? ", " : "") + argsListWired + ");\n";
                    if (needsDestructorStack) invokerFnBody += "runDestructors(destructors);\n";
                    else for(var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i){
                        var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";
                        if (argTypes[i].destructorFunction !== null) {
                            invokerFnBody += paramName + "_dtor(" + paramName + "); // " + argTypes[i].name + "\n";
                            args1.push(paramName + "_dtor");
                            args2.push(argTypes[i].destructorFunction);
                        }
                    }
                    if (returns) invokerFnBody += "var ret = retType.fromWireType(rv);\nreturn ret;\n";
                    invokerFnBody += "}\n";
                    args1.push(invokerFnBody);
                    return newFunc(Function, args1).apply(null, args2);
                }
                function __embind_register_class_constructor(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
                    rawClassType >>>= 0;
                    rawArgTypesAddr >>>= 0;
                    invokerSignature >>>= 0;
                    invoker >>>= 0;
                    rawConstructor >>>= 0;
                    var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                    invoker = embind__requireFunction(invokerSignature, invoker);
                    whenDependentTypesAreResolved([], [
                        rawClassType
                    ], function(classType) {
                        classType = classType[0];
                        var humanName = `constructor ${classType.name}`;
                        if (void 0 === classType.registeredClass.constructor_body) classType.registeredClass.constructor_body = [];
                        if (void 0 !== classType.registeredClass.constructor_body[argCount - 1]) throw new BindingError(`Cannot register multiple constructors with identical number of parameters (${argCount - 1}) for class '${classType.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                        classType.registeredClass.constructor_body[argCount - 1] = ()=>{
                            throwUnboundTypeError(`Cannot construct ${classType.name} due to unbound types`, rawArgTypes);
                        };
                        whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
                            argTypes.splice(1, 0, null);
                            classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
                            return [];
                        });
                        return [];
                    });
                }
                function __embind_register_class_function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual, isAsync) {
                    rawClassType >>>= 0;
                    methodName >>>= 0;
                    rawArgTypesAddr >>>= 0;
                    invokerSignature >>>= 0;
                    rawInvoker >>>= 0;
                    context >>>= 0;
                    var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                    methodName = readLatin1String(methodName);
                    rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
                    whenDependentTypesAreResolved([], [
                        rawClassType
                    ], function(classType) {
                        classType = classType[0];
                        var humanName = `${classType.name}.${methodName}`;
                        if (methodName.startsWith("@@")) methodName = Symbol[methodName.substring(2)];
                        if (isPureVirtual) classType.registeredClass.pureVirtualFunctions.push(methodName);
                        function unboundTypesHandler() {
                            throwUnboundTypeError(`Cannot call ${humanName} due to unbound types`, rawArgTypes);
                        }
                        var proto = classType.registeredClass.instancePrototype;
                        var method = proto[methodName];
                        if (void 0 === method || void 0 === method.overloadTable && method.className !== classType.name && method.argCount === argCount - 2) {
                            unboundTypesHandler.argCount = argCount - 2;
                            unboundTypesHandler.className = classType.name;
                            proto[methodName] = unboundTypesHandler;
                        } else {
                            ensureOverloadTable(proto, methodName, humanName);
                            proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
                        }
                        whenDependentTypesAreResolved([], rawArgTypes, function(argTypes) {
                            var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context, isAsync);
                            if (void 0 === proto[methodName].overloadTable) {
                                memberFunction.argCount = argCount - 2;
                                proto[methodName] = memberFunction;
                            } else proto[methodName].overloadTable[argCount - 2] = memberFunction;
                            return [];
                        });
                        return [];
                    });
                }
                function handleAllocatorInit() {
                    Object.assign(HandleAllocator.prototype, {
                        get (id) {
                            return this.allocated[id];
                        },
                        has (id) {
                            return this.allocated[id] !== void 0;
                        },
                        allocate (handle) {
                            var id = this.freelist.pop() || this.allocated.length;
                            this.allocated[id] = handle;
                            return id;
                        },
                        free (id) {
                            this.allocated[id] = void 0;
                            this.freelist.push(id);
                        }
                    });
                }
                function HandleAllocator() {
                    this.allocated = [
                        void 0
                    ];
                    this.freelist = [];
                }
                var emval_handles = new HandleAllocator();
                function __emval_decref(handle) {
                    handle >>>= 0;
                    if (handle >= emval_handles.reserved && 0 === --emval_handles.get(handle).refcount) emval_handles.free(handle);
                }
                function count_emval_handles() {
                    var count = 0;
                    for(var i = emval_handles.reserved; i < emval_handles.allocated.length; ++i)if (emval_handles.allocated[i] !== void 0) ++count;
                    return count;
                }
                function init_emval() {
                    emval_handles.allocated.push({
                        value: void 0
                    }, {
                        value: null
                    }, {
                        value: true
                    }, {
                        value: false
                    });
                    emval_handles.reserved = emval_handles.allocated.length;
                    Module["count_emval_handles"] = count_emval_handles;
                }
                var Emval = {
                    toValue: (handle)=>{
                        if (!handle) throwBindingError("Cannot use deleted val. handle = " + handle);
                        return emval_handles.get(handle).value;
                    },
                    toHandle: (value)=>{
                        switch(value){
                            case void 0:
                                return 1;
                            case null:
                                return 2;
                            case true:
                                return 3;
                            case false:
                                return 4;
                            default:
                                return emval_handles.allocate({
                                    refcount: 1,
                                    value: value
                                });
                        }
                    }
                };
                function __embind_register_emval(rawType, name) {
                    rawType >>>= 0;
                    name >>>= 0;
                    name = readLatin1String(name);
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(handle) {
                            var rv = Emval.toValue(handle);
                            __emval_decref(handle);
                            return rv;
                        },
                        "toWireType": function(destructors, value) {
                            return Emval.toHandle(value);
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": simpleReadValueFromPointer,
                        destructorFunction: null
                    });
                }
                function embindRepr(v) {
                    if (v === null) return "null";
                    var t = typeof v;
                    if (t === "object" || t === "array" || t === "function") return v.toString();
                    else return "" + v;
                }
                function floatReadValueFromPointer(name, shift) {
                    switch(shift){
                        case 2:
                            return function(pointer) {
                                return this["fromWireType"](HEAPF32[pointer >>> 2]);
                            };
                        case 3:
                            return function(pointer) {
                                return this["fromWireType"](HEAPF64[pointer >>> 3]);
                            };
                        default:
                            throw new TypeError("Unknown float type: " + name);
                    }
                }
                function __embind_register_float(rawType, name, size) {
                    rawType >>>= 0;
                    name >>>= 0;
                    size >>>= 0;
                    var shift = getShiftFromSize(size);
                    name = readLatin1String(name);
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(value) {
                            return value;
                        },
                        "toWireType": function(destructors, value) {
                            return value;
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": floatReadValueFromPointer(name, shift),
                        destructorFunction: null
                    });
                }
                function __embind_register_function(name, argCount, rawArgTypesAddr, signature, rawInvoker, fn, isAsync) {
                    name >>>= 0;
                    rawArgTypesAddr >>>= 0;
                    signature >>>= 0;
                    rawInvoker >>>= 0;
                    fn >>>= 0;
                    var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
                    name = readLatin1String(name);
                    rawInvoker = embind__requireFunction(signature, rawInvoker);
                    exposePublicSymbol(name, function() {
                        throwUnboundTypeError(`Cannot call ${name} due to unbound types`, argTypes);
                    }, argCount - 1);
                    whenDependentTypesAreResolved([], argTypes, function(argTypes2) {
                        var invokerArgsArray = [
                            argTypes2[0],
                            null
                        ].concat(argTypes2.slice(1));
                        replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn, isAsync), argCount - 1);
                        return [];
                    });
                }
                function integerReadValueFromPointer(name, shift, signed) {
                    switch(shift){
                        case 0:
                            return signed ? function readS8FromPointer(pointer) {
                                return HEAP8[pointer >>> 0];
                            } : function readU8FromPointer(pointer) {
                                return HEAPU8[pointer >>> 0];
                            };
                        case 1:
                            return signed ? function readS16FromPointer(pointer) {
                                return HEAP16[pointer >>> 1];
                            } : function readU16FromPointer(pointer) {
                                return HEAPU16[pointer >>> 1];
                            };
                        case 2:
                            return signed ? function readS32FromPointer(pointer) {
                                return HEAP32[pointer >>> 2];
                            } : function readU32FromPointer(pointer) {
                                return HEAPU32[pointer >>> 2];
                            };
                        default:
                            throw new TypeError("Unknown integer type: " + name);
                    }
                }
                function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
                    primitiveType >>>= 0;
                    name >>>= 0;
                    size >>>= 0;
                    name = readLatin1String(name);
                    if (maxRange === -1) maxRange = 4294967295;
                    var shift = getShiftFromSize(size);
                    var fromWireType = (value)=>value;
                    if (minRange === 0) {
                        var bitshift = 32 - 8 * size;
                        fromWireType = (value)=>value << bitshift >>> bitshift;
                    }
                    var isUnsignedType = name.includes("unsigned");
                    var checkAssertions = (value, toTypeName)=>{};
                    var toWireType;
                    if (isUnsignedType) toWireType = function(destructors, value) {
                        checkAssertions(value, this.name);
                        return value >>> 0;
                    };
                    else toWireType = function(destructors, value) {
                        checkAssertions(value, this.name);
                        return value;
                    };
                    registerType(primitiveType, {
                        name: name,
                        "fromWireType": fromWireType,
                        "toWireType": toWireType,
                        "argPackAdvance": 8,
                        "readValueFromPointer": integerReadValueFromPointer(name, shift, minRange !== 0),
                        destructorFunction: null
                    });
                }
                function __embind_register_memory_view(rawType, dataTypeIndex, name) {
                    rawType >>>= 0;
                    name >>>= 0;
                    var typeMapping = [
                        Int8Array,
                        Uint8Array,
                        Int16Array,
                        Uint16Array,
                        Int32Array,
                        Uint32Array,
                        Float32Array,
                        Float64Array
                    ];
                    var TA = typeMapping[dataTypeIndex];
                    function decodeMemoryView(handle) {
                        handle = handle >> 2;
                        var heap = HEAPU32;
                        var size = heap[handle >>> 0];
                        var data = heap[handle + 1 >>> 0];
                        return new TA(heap.buffer, data, size);
                    }
                    name = readLatin1String(name);
                    registerType(rawType, {
                        name: name,
                        "fromWireType": decodeMemoryView,
                        "argPackAdvance": 8,
                        "readValueFromPointer": decodeMemoryView
                    }, {
                        ignoreDuplicateRegistrations: true
                    });
                }
                var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite)=>{
                    outIdx >>>= 0;
                    if (!(maxBytesToWrite > 0)) return 0;
                    var startIdx = outIdx;
                    var endIdx = outIdx + maxBytesToWrite - 1;
                    for(var i = 0; i < str.length; ++i){
                        var u = str.charCodeAt(i);
                        if (u >= 55296 && u <= 57343) {
                            var u1 = str.charCodeAt(++i);
                            u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                        }
                        if (u <= 127) {
                            if (outIdx >= endIdx) break;
                            heap[outIdx++ >>> 0] = u;
                        } else if (u <= 2047) {
                            if (outIdx + 1 >= endIdx) break;
                            heap[outIdx++ >>> 0] = 192 | u >> 6;
                            heap[outIdx++ >>> 0] = 128 | u & 63;
                        } else if (u <= 65535) {
                            if (outIdx + 2 >= endIdx) break;
                            heap[outIdx++ >>> 0] = 224 | u >> 12;
                            heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
                            heap[outIdx++ >>> 0] = 128 | u & 63;
                        } else {
                            if (outIdx + 3 >= endIdx) break;
                            heap[outIdx++ >>> 0] = 240 | u >> 18;
                            heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
                            heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
                            heap[outIdx++ >>> 0] = 128 | u & 63;
                        }
                    }
                    heap[outIdx >>> 0] = 0;
                    return outIdx - startIdx;
                };
                var stringToUTF8 = (str, outPtr, maxBytesToWrite)=>stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
                var lengthBytesUTF8 = (str)=>{
                    var len = 0;
                    for(var i = 0; i < str.length; ++i){
                        var c = str.charCodeAt(i);
                        if (c <= 127) len++;
                        else if (c <= 2047) len += 2;
                        else if (c >= 55296 && c <= 57343) {
                            len += 4;
                            ++i;
                        } else len += 3;
                    }
                    return len;
                };
                var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;
                var UTF8ArrayToString = (heapOrArray, idx, maxBytesToRead)=>{
                    idx >>>= 0;
                    var endIdx = idx + maxBytesToRead;
                    var endPtr = idx;
                    while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
                    if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
                    var str = "";
                    while(idx < endPtr){
                        var u0 = heapOrArray[idx++];
                        if (!(u0 & 128)) {
                            str += String.fromCharCode(u0);
                            continue;
                        }
                        var u1 = heapOrArray[idx++] & 63;
                        if ((u0 & 224) == 192) {
                            str += String.fromCharCode((u0 & 31) << 6 | u1);
                            continue;
                        }
                        var u2 = heapOrArray[idx++] & 63;
                        if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                        else u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
                        if (u0 < 65536) str += String.fromCharCode(u0);
                        else {
                            var ch = u0 - 65536;
                            str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                        }
                    }
                    return str;
                };
                var UTF8ToString = (ptr, maxBytesToRead)=>{
                    ptr >>>= 0;
                    return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
                };
                function __embind_register_std_string(rawType, name) {
                    rawType >>>= 0;
                    name >>>= 0;
                    name = readLatin1String(name);
                    var stdStringIsUTF8 = name === "std::string";
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(value) {
                            var length = HEAPU32[value >>> 2];
                            var payload = value + 4;
                            var str;
                            if (stdStringIsUTF8) {
                                var decodeStartPtr = payload;
                                for(var i = 0; i <= length; ++i){
                                    var currentBytePtr = payload + i;
                                    if (i == length || HEAPU8[currentBytePtr >>> 0] == 0) {
                                        var maxRead = currentBytePtr - decodeStartPtr;
                                        var stringSegment = UTF8ToString(decodeStartPtr, maxRead);
                                        if (str === void 0) str = stringSegment;
                                        else {
                                            str += String.fromCharCode(0);
                                            str += stringSegment;
                                        }
                                        decodeStartPtr = currentBytePtr + 1;
                                    }
                                }
                            } else {
                                var a = new Array(length);
                                for(var i = 0; i < length; ++i)a[i] = String.fromCharCode(HEAPU8[payload + i >>> 0]);
                                str = a.join("");
                            }
                            _free(value);
                            return str;
                        },
                        "toWireType": function(destructors, value) {
                            if (value instanceof ArrayBuffer) value = new Uint8Array(value);
                            var length;
                            var valueIsOfTypeString = typeof value == "string";
                            if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) throwBindingError("Cannot pass non-string to std::string");
                            if (stdStringIsUTF8 && valueIsOfTypeString) length = lengthBytesUTF8(value);
                            else length = value.length;
                            var base = _malloc(4 + length + 1);
                            var ptr = base + 4;
                            HEAPU32[base >>> 2] = length;
                            if (stdStringIsUTF8 && valueIsOfTypeString) stringToUTF8(value, ptr, length + 1);
                            else {
                                if (valueIsOfTypeString) for(var i = 0; i < length; ++i){
                                    var charCode = value.charCodeAt(i);
                                    if (charCode > 255) {
                                        _free(ptr);
                                        throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                                    }
                                    HEAPU8[ptr + i >>> 0] = charCode;
                                }
                                else for(var i = 0; i < length; ++i)HEAPU8[ptr + i >>> 0] = value[i];
                            }
                            if (destructors !== null) destructors.push(_free, base);
                            return base;
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": simpleReadValueFromPointer,
                        destructorFunction: function(ptr) {
                            _free(ptr);
                        }
                    });
                }
                var UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0;
                var UTF16ToString = (ptr, maxBytesToRead)=>{
                    var endPtr = ptr;
                    var idx = endPtr >> 1;
                    var maxIdx = idx + maxBytesToRead / 2;
                    while(!(idx >= maxIdx) && HEAPU16[idx >>> 0])++idx;
                    endPtr = idx << 1;
                    if (endPtr - ptr > 32 && UTF16Decoder) return UTF16Decoder.decode(HEAPU8.subarray(ptr >>> 0, endPtr >>> 0));
                    var str = "";
                    for(var i = 0; !(i >= maxBytesToRead / 2); ++i){
                        var codeUnit = HEAP16[ptr + i * 2 >>> 1];
                        if (codeUnit == 0) break;
                        str += String.fromCharCode(codeUnit);
                    }
                    return str;
                };
                var stringToUTF16 = (str, outPtr, maxBytesToWrite)=>{
                    if (maxBytesToWrite === void 0) maxBytesToWrite = 2147483647;
                    if (maxBytesToWrite < 2) return 0;
                    maxBytesToWrite -= 2;
                    var startPtr = outPtr;
                    var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
                    for(var i = 0; i < numCharsToWrite; ++i){
                        var codeUnit = str.charCodeAt(i);
                        HEAP16[outPtr >>> 1] = codeUnit;
                        outPtr += 2;
                    }
                    HEAP16[outPtr >>> 1] = 0;
                    return outPtr - startPtr;
                };
                var lengthBytesUTF16 = (str)=>str.length * 2;
                var UTF32ToString = (ptr, maxBytesToRead)=>{
                    var i = 0;
                    var str = "";
                    while(!(i >= maxBytesToRead / 4)){
                        var utf32 = HEAP32[ptr + i * 4 >>> 2];
                        if (utf32 == 0) break;
                        ++i;
                        if (utf32 >= 65536) {
                            var ch = utf32 - 65536;
                            str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                        } else str += String.fromCharCode(utf32);
                    }
                    return str;
                };
                var stringToUTF32 = (str, outPtr, maxBytesToWrite)=>{
                    outPtr >>>= 0;
                    if (maxBytesToWrite === void 0) maxBytesToWrite = 2147483647;
                    if (maxBytesToWrite < 4) return 0;
                    var startPtr = outPtr;
                    var endPtr = startPtr + maxBytesToWrite - 4;
                    for(var i = 0; i < str.length; ++i){
                        var codeUnit = str.charCodeAt(i);
                        if (codeUnit >= 55296 && codeUnit <= 57343) {
                            var trailSurrogate = str.charCodeAt(++i);
                            codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023;
                        }
                        HEAP32[outPtr >>> 2] = codeUnit;
                        outPtr += 4;
                        if (outPtr + 4 > endPtr) break;
                    }
                    HEAP32[outPtr >>> 2] = 0;
                    return outPtr - startPtr;
                };
                var lengthBytesUTF32 = (str)=>{
                    var len = 0;
                    for(var i = 0; i < str.length; ++i){
                        var codeUnit = str.charCodeAt(i);
                        if (codeUnit >= 55296 && codeUnit <= 57343) ++i;
                        len += 4;
                    }
                    return len;
                };
                var __embind_register_std_wstring = function(rawType, charSize, name) {
                    rawType >>>= 0;
                    charSize >>>= 0;
                    name >>>= 0;
                    name = readLatin1String(name);
                    var decodeString, encodeString, getHeap, lengthBytesUTF, shift;
                    if (charSize === 2) {
                        decodeString = UTF16ToString;
                        encodeString = stringToUTF16;
                        lengthBytesUTF = lengthBytesUTF16;
                        getHeap = ()=>HEAPU16;
                        shift = 1;
                    } else if (charSize === 4) {
                        decodeString = UTF32ToString;
                        encodeString = stringToUTF32;
                        lengthBytesUTF = lengthBytesUTF32;
                        getHeap = ()=>HEAPU32;
                        shift = 2;
                    }
                    registerType(rawType, {
                        name: name,
                        "fromWireType": function(value) {
                            var length = HEAPU32[value >>> 2];
                            var HEAP = getHeap();
                            var str;
                            var decodeStartPtr = value + 4;
                            for(var i = 0; i <= length; ++i){
                                var currentBytePtr = value + 4 + i * charSize;
                                if (i == length || HEAP[currentBytePtr >>> shift] == 0) {
                                    var maxReadBytes = currentBytePtr - decodeStartPtr;
                                    var stringSegment = decodeString(decodeStartPtr, maxReadBytes);
                                    if (str === void 0) str = stringSegment;
                                    else {
                                        str += String.fromCharCode(0);
                                        str += stringSegment;
                                    }
                                    decodeStartPtr = currentBytePtr + charSize;
                                }
                            }
                            _free(value);
                            return str;
                        },
                        "toWireType": function(destructors, value) {
                            if (!(typeof value == "string")) throwBindingError(`Cannot pass non-string to C++ string type ${name}`);
                            var length = lengthBytesUTF(value);
                            var ptr = _malloc(4 + length + charSize);
                            HEAPU32[ptr >>> 2] = length >> shift;
                            encodeString(value, ptr + 4, length + charSize);
                            if (destructors !== null) destructors.push(_free, ptr);
                            return ptr;
                        },
                        "argPackAdvance": 8,
                        "readValueFromPointer": simpleReadValueFromPointer,
                        destructorFunction: function(ptr) {
                            _free(ptr);
                        }
                    });
                };
                function __embind_register_value_array(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
                    rawType >>>= 0;
                    name >>>= 0;
                    constructorSignature >>>= 0;
                    rawConstructor >>>= 0;
                    destructorSignature >>>= 0;
                    rawDestructor >>>= 0;
                    tupleRegistrations[rawType] = {
                        name: readLatin1String(name),
                        rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
                        rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
                        elements: []
                    };
                }
                function __embind_register_value_array_element(rawTupleType, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
                    rawTupleType >>>= 0;
                    getterReturnType >>>= 0;
                    getterSignature >>>= 0;
                    getter >>>= 0;
                    getterContext >>>= 0;
                    setterArgumentType >>>= 0;
                    setterSignature >>>= 0;
                    setter >>>= 0;
                    setterContext >>>= 0;
                    tupleRegistrations[rawTupleType].elements.push({
                        getterReturnType: getterReturnType,
                        getter: embind__requireFunction(getterSignature, getter),
                        getterContext: getterContext,
                        setterArgumentType: setterArgumentType,
                        setter: embind__requireFunction(setterSignature, setter),
                        setterContext: setterContext
                    });
                }
                function __embind_register_value_object(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
                    rawType >>>= 0;
                    name >>>= 0;
                    constructorSignature >>>= 0;
                    rawConstructor >>>= 0;
                    destructorSignature >>>= 0;
                    rawDestructor >>>= 0;
                    structRegistrations[rawType] = {
                        name: readLatin1String(name),
                        rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
                        rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
                        fields: []
                    };
                }
                function __embind_register_value_object_field(structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
                    structType >>>= 0;
                    fieldName >>>= 0;
                    getterReturnType >>>= 0;
                    getterSignature >>>= 0;
                    getter >>>= 0;
                    getterContext >>>= 0;
                    setterArgumentType >>>= 0;
                    setterSignature >>>= 0;
                    setter >>>= 0;
                    setterContext >>>= 0;
                    structRegistrations[structType].fields.push({
                        fieldName: readLatin1String(fieldName),
                        getterReturnType: getterReturnType,
                        getter: embind__requireFunction(getterSignature, getter),
                        getterContext: getterContext,
                        setterArgumentType: setterArgumentType,
                        setter: embind__requireFunction(setterSignature, setter),
                        setterContext: setterContext
                    });
                }
                function __embind_register_void(rawType, name) {
                    rawType >>>= 0;
                    name >>>= 0;
                    name = readLatin1String(name);
                    registerType(rawType, {
                        isVoid: true,
                        name: name,
                        "argPackAdvance": 0,
                        "fromWireType": function() {
                            return void 0;
                        },
                        "toWireType": function(destructors, o) {
                            return void 0;
                        }
                    });
                }
                var nowIsMonotonic = true;
                var __emscripten_get_now_is_monotonic = ()=>nowIsMonotonic;
                function requireRegisteredType(rawType, humanName) {
                    var impl = registeredTypes[rawType];
                    if (void 0 === impl) throwBindingError(humanName + " has unknown type " + getTypeName(rawType));
                    return impl;
                }
                function __emval_as(handle, returnType, destructorsRef) {
                    handle >>>= 0;
                    returnType >>>= 0;
                    destructorsRef >>>= 0;
                    handle = Emval.toValue(handle);
                    returnType = requireRegisteredType(returnType, "emval::as");
                    var destructors = [];
                    var rd = Emval.toHandle(destructors);
                    HEAPU32[destructorsRef >>> 2] = rd;
                    return returnType["toWireType"](destructors, handle);
                }
                function emval_lookupTypes(argCount, argTypes) {
                    var a = new Array(argCount);
                    for(var i = 0; i < argCount; ++i)a[i] = requireRegisteredType(HEAPU32[argTypes + i * 4 >>> 2], "parameter " + i);
                    return a;
                }
                function __emval_call(handle, argCount, argTypes, argv) {
                    handle >>>= 0;
                    argTypes >>>= 0;
                    argv >>>= 0;
                    handle = Emval.toValue(handle);
                    var types = emval_lookupTypes(argCount, argTypes);
                    var args = new Array(argCount);
                    for(var i = 0; i < argCount; ++i){
                        var type = types[i];
                        args[i] = type["readValueFromPointer"](argv);
                        argv += type["argPackAdvance"];
                    }
                    var rv = handle.apply(void 0, args);
                    return Emval.toHandle(rv);
                }
                var emval_symbols = {};
                function getStringOrSymbol(address) {
                    var symbol = emval_symbols[address];
                    if (symbol === void 0) return readLatin1String(address);
                    return symbol;
                }
                function emval_get_global() {
                    if (typeof globalThis == "object") return globalThis;
                    return /* @__PURE__ */ (function() {
                        return Function;
                    })()("return this")();
                }
                function __emval_get_global(name) {
                    name >>>= 0;
                    if (name === 0) return Emval.toHandle(emval_get_global());
                    else {
                        name = getStringOrSymbol(name);
                        return Emval.toHandle(emval_get_global()[name]);
                    }
                }
                function __emval_get_property(handle, key) {
                    handle >>>= 0;
                    key >>>= 0;
                    handle = Emval.toValue(handle);
                    key = Emval.toValue(key);
                    return Emval.toHandle(handle[key]);
                }
                function __emval_incref(handle) {
                    handle >>>= 0;
                    if (handle > 4) emval_handles.get(handle).refcount += 1;
                }
                function __emval_instanceof(object, constructor) {
                    object >>>= 0;
                    constructor >>>= 0;
                    object = Emval.toValue(object);
                    constructor = Emval.toValue(constructor);
                    return object instanceof constructor;
                }
                function __emval_is_number(handle) {
                    handle >>>= 0;
                    handle = Emval.toValue(handle);
                    return typeof handle == "number";
                }
                function __emval_is_string(handle) {
                    handle >>>= 0;
                    handle = Emval.toValue(handle);
                    return typeof handle == "string";
                }
                function __emval_new_array() {
                    return Emval.toHandle([]);
                }
                function __emval_new_cstring(v) {
                    v >>>= 0;
                    return Emval.toHandle(getStringOrSymbol(v));
                }
                function __emval_new_object() {
                    return Emval.toHandle({});
                }
                function __emval_run_destructors(handle) {
                    handle >>>= 0;
                    var destructors = Emval.toValue(handle);
                    runDestructors(destructors);
                    __emval_decref(handle);
                }
                function __emval_set_property(handle, key, value) {
                    handle >>>= 0;
                    key >>>= 0;
                    value >>>= 0;
                    handle = Emval.toValue(handle);
                    key = Emval.toValue(key);
                    value = Emval.toValue(value);
                    handle[key] = value;
                }
                function __emval_take_value(type, arg) {
                    type >>>= 0;
                    arg >>>= 0;
                    type = requireRegisteredType(type, "_emval_take_value");
                    var v = type["readValueFromPointer"](arg);
                    return Emval.toHandle(v);
                }
                function __gmtime_js(time_low, time_high, tmPtr) {
                    var time = convertI32PairToI53Checked(time_low, time_high);
                    tmPtr >>>= 0;
                    var date = new Date(time * 1e3);
                    HEAP32[tmPtr >>> 2] = date.getUTCSeconds();
                    HEAP32[tmPtr + 4 >>> 2] = date.getUTCMinutes();
                    HEAP32[tmPtr + 8 >>> 2] = date.getUTCHours();
                    HEAP32[tmPtr + 12 >>> 2] = date.getUTCDate();
                    HEAP32[tmPtr + 16 >>> 2] = date.getUTCMonth();
                    HEAP32[tmPtr + 20 >>> 2] = date.getUTCFullYear() - 1900;
                    HEAP32[tmPtr + 24 >>> 2] = date.getUTCDay();
                    var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
                    var yday = (date.getTime() - start) / 86400000 | 0;
                    HEAP32[tmPtr + 28 >>> 2] = yday;
                }
                var isLeapYear = (year)=>year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
                var MONTH_DAYS_LEAP_CUMULATIVE = [
                    0,
                    31,
                    60,
                    91,
                    121,
                    152,
                    182,
                    213,
                    244,
                    274,
                    305,
                    335
                ];
                var MONTH_DAYS_REGULAR_CUMULATIVE = [
                    0,
                    31,
                    59,
                    90,
                    120,
                    151,
                    181,
                    212,
                    243,
                    273,
                    304,
                    334
                ];
                var ydayFromDate = (date)=>{
                    var leap = isLeapYear(date.getFullYear());
                    var monthDaysCumulative = leap ? MONTH_DAYS_LEAP_CUMULATIVE : MONTH_DAYS_REGULAR_CUMULATIVE;
                    var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
                    return yday;
                };
                function __localtime_js(time_low, time_high, tmPtr) {
                    var time = convertI32PairToI53Checked(time_low, time_high);
                    tmPtr >>>= 0;
                    var date = new Date(time * 1e3);
                    HEAP32[tmPtr >>> 2] = date.getSeconds();
                    HEAP32[tmPtr + 4 >>> 2] = date.getMinutes();
                    HEAP32[tmPtr + 8 >>> 2] = date.getHours();
                    HEAP32[tmPtr + 12 >>> 2] = date.getDate();
                    HEAP32[tmPtr + 16 >>> 2] = date.getMonth();
                    HEAP32[tmPtr + 20 >>> 2] = date.getFullYear() - 1900;
                    HEAP32[tmPtr + 24 >>> 2] = date.getDay();
                    var yday = ydayFromDate(date) | 0;
                    HEAP32[tmPtr + 28 >>> 2] = yday;
                    HEAP32[tmPtr + 36 >>> 2] = -(date.getTimezoneOffset() * 60);
                    var start = new Date(date.getFullYear(), 0, 1);
                    var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
                    var winterOffset = start.getTimezoneOffset();
                    var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
                    HEAP32[tmPtr + 32 >>> 2] = dst;
                }
                var stringToNewUTF8 = (str)=>{
                    var size = lengthBytesUTF8(str) + 1;
                    var ret = _malloc(size);
                    if (ret) stringToUTF8(str, ret, size);
                    return ret;
                };
                function __tzset_js(timezone, daylight, tzname) {
                    timezone >>>= 0;
                    daylight >>>= 0;
                    tzname >>>= 0;
                    var currentYear = /* @__PURE__ */ new Date().getFullYear();
                    var winter = new Date(currentYear, 0, 1);
                    var summer = new Date(currentYear, 6, 1);
                    var winterOffset = winter.getTimezoneOffset();
                    var summerOffset = summer.getTimezoneOffset();
                    var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
                    HEAPU32[timezone >>> 2] = stdTimezoneOffset * 60;
                    HEAP32[daylight >>> 2] = Number(winterOffset != summerOffset);
                    function extractZone(date) {
                        var match = date.toTimeString().match(/\(([A-Za-z ]+)\)$/);
                        return match ? match[1] : "GMT";
                    }
                    var winterName = extractZone(winter);
                    var summerName = extractZone(summer);
                    var winterNamePtr = stringToNewUTF8(winterName);
                    var summerNamePtr = stringToNewUTF8(summerName);
                    if (summerOffset < winterOffset) {
                        HEAPU32[tzname >>> 2] = winterNamePtr;
                        HEAPU32[tzname + 4 >>> 2] = summerNamePtr;
                    } else {
                        HEAPU32[tzname >>> 2] = summerNamePtr;
                        HEAPU32[tzname + 4 >>> 2] = winterNamePtr;
                    }
                }
                var _abort = ()=>{
                    abort("");
                };
                function _emscripten_date_now() {
                    return Date.now();
                }
                var _emscripten_get_now;
                _emscripten_get_now = ()=>performance.now();
                function _emscripten_memcpy_big(dest, src, num) {
                    dest >>>= 0;
                    src >>>= 0;
                    num >>>= 0;
                    return HEAPU8.copyWithin(dest >>> 0, src >>> 0, src + num >>> 0);
                }
                var getHeapMax = ()=>4294901760;
                var growMemory = (size)=>{
                    var b = wasmMemory.buffer;
                    var pages = size - b.byteLength + 65535 >>> 16;
                    try {
                        wasmMemory.grow(pages);
                        updateMemoryViews();
                        return 1;
                    } catch (e) {}
                };
                function _emscripten_resize_heap(requestedSize) {
                    requestedSize >>>= 0;
                    var oldSize = HEAPU8.length;
                    var maxHeapSize = getHeapMax();
                    if (requestedSize > maxHeapSize) return false;
                    var alignUp = (x, multiple)=>x + (multiple - x % multiple) % multiple;
                    for(var cutDown = 1; cutDown <= 4; cutDown *= 2){
                        var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
                        overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
                        var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
                        var replacement = growMemory(newSize);
                        if (replacement) return true;
                    }
                    return false;
                }
                var ENV = {};
                var getExecutableName = ()=>thisProgram || "./this.program";
                var getEnvStrings = ()=>{
                    if (!getEnvStrings.strings) {
                        var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
                        var env = {
                            "USER": "web_user",
                            "LOGNAME": "web_user",
                            "PATH": "/",
                            "PWD": "/",
                            "HOME": "/home/web_user",
                            "LANG": lang,
                            "_": getExecutableName()
                        };
                        for(var x in ENV)if (ENV[x] === void 0) delete env[x];
                        else env[x] = ENV[x];
                        var strings = [];
                        for(var x in env)strings.push(`${x}=${env[x]}`);
                        getEnvStrings.strings = strings;
                    }
                    return getEnvStrings.strings;
                };
                var stringToAscii = (str, buffer)=>{
                    for(var i = 0; i < str.length; ++i)HEAP8[buffer++ >>> 0] = str.charCodeAt(i);
                    HEAP8[buffer >>> 0] = 0;
                };
                var PATH = {
                    isAbs: (path)=>path.charAt(0) === "/",
                    splitPath: (filename)=>{
                        var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                        return splitPathRe.exec(filename).slice(1);
                    },
                    normalizeArray: (parts, allowAboveRoot)=>{
                        var up = 0;
                        for(var i = parts.length - 1; i >= 0; i--){
                            var last = parts[i];
                            if (last === ".") parts.splice(i, 1);
                            else if (last === "..") {
                                parts.splice(i, 1);
                                up++;
                            } else if (up) {
                                parts.splice(i, 1);
                                up--;
                            }
                        }
                        if (allowAboveRoot) for(; up; up--)parts.unshift("..");
                        return parts;
                    },
                    normalize: (path)=>{
                        var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
                        path = PATH.normalizeArray(path.split("/").filter((p)=>!!p), !isAbsolute).join("/");
                        if (!path && !isAbsolute) path = ".";
                        if (path && trailingSlash) path += "/";
                        return (isAbsolute ? "/" : "") + path;
                    },
                    dirname: (path)=>{
                        var result = PATH.splitPath(path), root = result[0], dir = result[1];
                        if (!root && !dir) return ".";
                        if (dir) dir = dir.substr(0, dir.length - 1);
                        return root + dir;
                    },
                    basename: (path)=>{
                        if (path === "/") return "/";
                        path = PATH.normalize(path);
                        path = path.replace(/\/$/, "");
                        var lastSlash = path.lastIndexOf("/");
                        if (lastSlash === -1) return path;
                        return path.substr(lastSlash + 1);
                    },
                    join: function() {
                        var paths = Array.prototype.slice.call(arguments);
                        return PATH.normalize(paths.join("/"));
                    },
                    join2: (l, r)=>PATH.normalize(l + "/" + r)
                };
                var initRandomFill = ()=>{
                    if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") return (view)=>crypto.getRandomValues(view);
                    else abort("initRandomDevice");
                };
                var randomFill = (view)=>(randomFill = initRandomFill())(view);
                var PATH_FS = {
                    resolve: function() {
                        var resolvedPath = "", resolvedAbsolute = false;
                        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
                            var path = i >= 0 ? arguments[i] : FS.cwd();
                            if (typeof path != "string") throw new TypeError("Arguments to path.resolve must be strings");
                            else if (!path) return "";
                            resolvedPath = path + "/" + resolvedPath;
                            resolvedAbsolute = PATH.isAbs(path);
                        }
                        resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
                        return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
                    },
                    relative: (from, to)=>{
                        from = PATH_FS.resolve(from).substr(1);
                        to = PATH_FS.resolve(to).substr(1);
                        function trim(arr) {
                            var start = 0;
                            for(; start < arr.length; start++){
                                if (arr[start] !== "") break;
                            }
                            var end = arr.length - 1;
                            for(; end >= 0; end--){
                                if (arr[end] !== "") break;
                            }
                            if (start > end) return [];
                            return arr.slice(start, end - start + 1);
                        }
                        var fromParts = trim(from.split("/"));
                        var toParts = trim(to.split("/"));
                        var length = Math.min(fromParts.length, toParts.length);
                        var samePartsLength = length;
                        for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
                            samePartsLength = i;
                            break;
                        }
                        var outputParts = [];
                        for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
                        outputParts = outputParts.concat(toParts.slice(samePartsLength));
                        return outputParts.join("/");
                    }
                };
                var FS_stdin_getChar_buffer = [];
                function intArrayFromString(stringy, dontAddNull, length) {
                    var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
                    var u8array = new Array(len);
                    var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
                    if (dontAddNull) u8array.length = numBytesWritten;
                    return u8array;
                }
                var FS_stdin_getChar = ()=>{
                    if (!FS_stdin_getChar_buffer.length) {
                        var result = null;
                        if (typeof window != "undefined" && typeof window.prompt == "function") {
                            result = window.prompt("Input: ");
                            if (result !== null) result += "\n";
                        } else if (typeof readline == "function") {
                            result = readline();
                            if (result !== null) result += "\n";
                        }
                        if (!result) return null;
                        FS_stdin_getChar_buffer = intArrayFromString(result, true);
                    }
                    return FS_stdin_getChar_buffer.shift();
                };
                var TTY = {
                    ttys: [],
                    init: function() {},
                    shutdown: function() {},
                    register: function(dev, ops) {
                        TTY.ttys[dev] = {
                            input: [],
                            output: [],
                            ops: ops
                        };
                        FS.registerDevice(dev, TTY.stream_ops);
                    },
                    stream_ops: {
                        open: function(stream) {
                            var tty = TTY.ttys[stream.node.rdev];
                            if (!tty) throw new FS.ErrnoError(43);
                            stream.tty = tty;
                            stream.seekable = false;
                        },
                        close: function(stream) {
                            stream.tty.ops.fsync(stream.tty);
                        },
                        fsync: function(stream) {
                            stream.tty.ops.fsync(stream.tty);
                        },
                        read: function(stream, buffer, offset, length, pos) {
                            if (!stream.tty || !stream.tty.ops.get_char) throw new FS.ErrnoError(60);
                            var bytesRead = 0;
                            for(var i = 0; i < length; i++){
                                var result;
                                try {
                                    result = stream.tty.ops.get_char(stream.tty);
                                } catch (e) {
                                    throw new FS.ErrnoError(29);
                                }
                                if (result === void 0 && bytesRead === 0) throw new FS.ErrnoError(6);
                                if (result === null || result === void 0) break;
                                bytesRead++;
                                buffer[offset + i] = result;
                            }
                            if (bytesRead) stream.node.timestamp = Date.now();
                            return bytesRead;
                        },
                        write: function(stream, buffer, offset, length, pos) {
                            if (!stream.tty || !stream.tty.ops.put_char) throw new FS.ErrnoError(60);
                            try {
                                for(var i = 0; i < length; i++)stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                            } catch (e) {
                                throw new FS.ErrnoError(29);
                            }
                            if (length) stream.node.timestamp = Date.now();
                            return i;
                        }
                    },
                    default_tty_ops: {
                        get_char: function(tty) {
                            return FS_stdin_getChar();
                        },
                        put_char: function(tty, val) {
                            if (val === null || val === 10) {
                                out(UTF8ArrayToString(tty.output, 0));
                                tty.output = [];
                            } else if (val != 0) tty.output.push(val);
                        },
                        fsync: function(tty) {
                            if (tty.output && tty.output.length > 0) {
                                out(UTF8ArrayToString(tty.output, 0));
                                tty.output = [];
                            }
                        },
                        ioctl_tcgets: function(tty) {
                            return {
                                c_iflag: 25856,
                                c_oflag: 5,
                                c_cflag: 191,
                                c_lflag: 35387,
                                c_cc: [
                                    3,
                                    28,
                                    127,
                                    21,
                                    4,
                                    0,
                                    1,
                                    0,
                                    17,
                                    19,
                                    26,
                                    0,
                                    18,
                                    15,
                                    23,
                                    22,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0
                                ]
                            };
                        },
                        ioctl_tcsets: function(tty, optional_actions, data) {
                            return 0;
                        },
                        ioctl_tiocgwinsz: function(tty) {
                            return [
                                24,
                                80
                            ];
                        }
                    },
                    default_tty1_ops: {
                        put_char: function(tty, val) {
                            if (val === null || val === 10) {
                                err(UTF8ArrayToString(tty.output, 0));
                                tty.output = [];
                            } else if (val != 0) tty.output.push(val);
                        },
                        fsync: function(tty) {
                            if (tty.output && tty.output.length > 0) {
                                err(UTF8ArrayToString(tty.output, 0));
                                tty.output = [];
                            }
                        }
                    }
                };
                var mmapAlloc = (size)=>{
                    abort();
                };
                var MEMFS = {
                    ops_table: null,
                    mount (mount) {
                        return MEMFS.createNode(null, "/", 16895, 0);
                    },
                    createNode (parent, name, mode, dev) {
                        if (FS.isBlkdev(mode) || FS.isFIFO(mode)) throw new FS.ErrnoError(63);
                        if (!MEMFS.ops_table) MEMFS.ops_table = {
                            dir: {
                                node: {
                                    getattr: MEMFS.node_ops.getattr,
                                    setattr: MEMFS.node_ops.setattr,
                                    lookup: MEMFS.node_ops.lookup,
                                    mknod: MEMFS.node_ops.mknod,
                                    rename: MEMFS.node_ops.rename,
                                    unlink: MEMFS.node_ops.unlink,
                                    rmdir: MEMFS.node_ops.rmdir,
                                    readdir: MEMFS.node_ops.readdir,
                                    symlink: MEMFS.node_ops.symlink
                                },
                                stream: {
                                    llseek: MEMFS.stream_ops.llseek
                                }
                            },
                            file: {
                                node: {
                                    getattr: MEMFS.node_ops.getattr,
                                    setattr: MEMFS.node_ops.setattr
                                },
                                stream: {
                                    llseek: MEMFS.stream_ops.llseek,
                                    read: MEMFS.stream_ops.read,
                                    write: MEMFS.stream_ops.write,
                                    allocate: MEMFS.stream_ops.allocate,
                                    mmap: MEMFS.stream_ops.mmap,
                                    msync: MEMFS.stream_ops.msync
                                }
                            },
                            link: {
                                node: {
                                    getattr: MEMFS.node_ops.getattr,
                                    setattr: MEMFS.node_ops.setattr,
                                    readlink: MEMFS.node_ops.readlink
                                },
                                stream: {}
                            },
                            chrdev: {
                                node: {
                                    getattr: MEMFS.node_ops.getattr,
                                    setattr: MEMFS.node_ops.setattr
                                },
                                stream: FS.chrdev_stream_ops
                            }
                        };
                        var node = FS.createNode(parent, name, mode, dev);
                        if (FS.isDir(node.mode)) {
                            node.node_ops = MEMFS.ops_table.dir.node;
                            node.stream_ops = MEMFS.ops_table.dir.stream;
                            node.contents = {};
                        } else if (FS.isFile(node.mode)) {
                            node.node_ops = MEMFS.ops_table.file.node;
                            node.stream_ops = MEMFS.ops_table.file.stream;
                            node.usedBytes = 0;
                            node.contents = null;
                        } else if (FS.isLink(node.mode)) {
                            node.node_ops = MEMFS.ops_table.link.node;
                            node.stream_ops = MEMFS.ops_table.link.stream;
                        } else if (FS.isChrdev(node.mode)) {
                            node.node_ops = MEMFS.ops_table.chrdev.node;
                            node.stream_ops = MEMFS.ops_table.chrdev.stream;
                        }
                        node.timestamp = Date.now();
                        if (parent) {
                            parent.contents[name] = node;
                            parent.timestamp = node.timestamp;
                        }
                        return node;
                    },
                    getFileDataAsTypedArray (node) {
                        if (!node.contents) return new Uint8Array(0);
                        if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
                        return new Uint8Array(node.contents);
                    },
                    expandFileStorage (node, newCapacity) {
                        var prevCapacity = node.contents ? node.contents.length : 0;
                        if (prevCapacity >= newCapacity) return;
                        var CAPACITY_DOUBLING_MAX = 1048576;
                        newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
                        if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
                        var oldContents = node.contents;
                        node.contents = new Uint8Array(newCapacity);
                        if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
                    },
                    resizeFileStorage (node, newSize) {
                        if (node.usedBytes == newSize) return;
                        if (newSize == 0) {
                            node.contents = null;
                            node.usedBytes = 0;
                        } else {
                            var oldContents = node.contents;
                            node.contents = new Uint8Array(newSize);
                            if (oldContents) node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
                            node.usedBytes = newSize;
                        }
                    },
                    node_ops: {
                        getattr (node) {
                            var attr = {};
                            attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
                            attr.ino = node.id;
                            attr.mode = node.mode;
                            attr.nlink = 1;
                            attr.uid = 0;
                            attr.gid = 0;
                            attr.rdev = node.rdev;
                            if (FS.isDir(node.mode)) attr.size = 4096;
                            else if (FS.isFile(node.mode)) attr.size = node.usedBytes;
                            else if (FS.isLink(node.mode)) attr.size = node.link.length;
                            else attr.size = 0;
                            attr.atime = new Date(node.timestamp);
                            attr.mtime = new Date(node.timestamp);
                            attr.ctime = new Date(node.timestamp);
                            attr.blksize = 4096;
                            attr.blocks = Math.ceil(attr.size / attr.blksize);
                            return attr;
                        },
                        setattr (node, attr) {
                            if (attr.mode !== void 0) node.mode = attr.mode;
                            if (attr.timestamp !== void 0) node.timestamp = attr.timestamp;
                            if (attr.size !== void 0) MEMFS.resizeFileStorage(node, attr.size);
                        },
                        lookup (parent, name) {
                            throw FS.genericErrors[44];
                        },
                        mknod (parent, name, mode, dev) {
                            return MEMFS.createNode(parent, name, mode, dev);
                        },
                        rename (old_node, new_dir, new_name) {
                            if (FS.isDir(old_node.mode)) {
                                var new_node;
                                try {
                                    new_node = FS.lookupNode(new_dir, new_name);
                                } catch (e) {}
                                if (new_node) {
                                    for(var i in new_node.contents)throw new FS.ErrnoError(55);
                                }
                            }
                            delete old_node.parent.contents[old_node.name];
                            old_node.parent.timestamp = Date.now();
                            old_node.name = new_name;
                            new_dir.contents[new_name] = old_node;
                            new_dir.timestamp = old_node.parent.timestamp;
                            old_node.parent = new_dir;
                        },
                        unlink (parent, name) {
                            delete parent.contents[name];
                            parent.timestamp = Date.now();
                        },
                        rmdir (parent, name) {
                            var node = FS.lookupNode(parent, name);
                            for(var i in node.contents)throw new FS.ErrnoError(55);
                            delete parent.contents[name];
                            parent.timestamp = Date.now();
                        },
                        readdir (node) {
                            var entries = [
                                ".",
                                ".."
                            ];
                            for(var key in node.contents){
                                if (!node.contents.hasOwnProperty(key)) continue;
                                entries.push(key);
                            }
                            return entries;
                        },
                        symlink (parent, newname, oldpath) {
                            var node = MEMFS.createNode(parent, newname, 41471, 0);
                            node.link = oldpath;
                            return node;
                        },
                        readlink (node) {
                            if (!FS.isLink(node.mode)) throw new FS.ErrnoError(28);
                            return node.link;
                        }
                    },
                    stream_ops: {
                        read (stream, buffer, offset, length, position) {
                            var contents = stream.node.contents;
                            if (position >= stream.node.usedBytes) return 0;
                            var size = Math.min(stream.node.usedBytes - position, length);
                            if (size > 8 && contents.subarray) buffer.set(contents.subarray(position, position + size), offset);
                            else for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                            return size;
                        },
                        write (stream, buffer, offset, length, position, canOwn) {
                            if (buffer.buffer === HEAP8.buffer) canOwn = false;
                            if (!length) return 0;
                            var node = stream.node;
                            node.timestamp = Date.now();
                            if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                                if (canOwn) {
                                    node.contents = buffer.subarray(offset, offset + length);
                                    node.usedBytes = length;
                                    return length;
                                } else if (node.usedBytes === 0 && position === 0) {
                                    node.contents = buffer.slice(offset, offset + length);
                                    node.usedBytes = length;
                                    return length;
                                } else if (position + length <= node.usedBytes) {
                                    node.contents.set(buffer.subarray(offset, offset + length), position);
                                    return length;
                                }
                            }
                            MEMFS.expandFileStorage(node, position + length);
                            if (node.contents.subarray && buffer.subarray) node.contents.set(buffer.subarray(offset, offset + length), position);
                            else for(var i = 0; i < length; i++)node.contents[position + i] = buffer[offset + i];
                            node.usedBytes = Math.max(node.usedBytes, position + length);
                            return length;
                        },
                        llseek (stream, offset, whence) {
                            var position = offset;
                            if (whence === 1) position += stream.position;
                            else if (whence === 2) {
                                if (FS.isFile(stream.node.mode)) position += stream.node.usedBytes;
                            }
                            if (position < 0) throw new FS.ErrnoError(28);
                            return position;
                        },
                        allocate (stream, offset, length) {
                            MEMFS.expandFileStorage(stream.node, offset + length);
                            stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
                        },
                        mmap (stream, length, position, prot, flags) {
                            if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                            var ptr;
                            var allocated;
                            var contents = stream.node.contents;
                            if (!(flags & 2) && contents.buffer === HEAP8.buffer) {
                                allocated = false;
                                ptr = contents.byteOffset;
                            } else {
                                if (position > 0 || position + length < contents.length) {
                                    if (contents.subarray) contents = contents.subarray(position, position + length);
                                    else contents = Array.prototype.slice.call(contents, position, position + length);
                                }
                                allocated = true;
                                ptr = mmapAlloc(length);
                                if (!ptr) throw new FS.ErrnoError(48);
                                HEAP8.set(contents, ptr >>> 0);
                            }
                            return {
                                ptr: ptr,
                                allocated: allocated
                            };
                        },
                        msync (stream, buffer, offset, length, mmapFlags) {
                            MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
                            return 0;
                        }
                    }
                };
                var asyncLoad = (url, onload, onerror, noRunDep)=>{
                    var dep = !noRunDep ? getUniqueRunDependency(`al ${url}`) : "";
                    readAsync(url, (arrayBuffer)=>{
                        assert(arrayBuffer, `Loading data file "${url}" failed (no arrayBuffer).`);
                        onload(new Uint8Array(arrayBuffer));
                        if (dep) removeRunDependency(dep);
                    }, (event)=>{
                        if (onerror) onerror();
                        else throw `Loading data file "${url}" failed.`;
                    });
                    if (dep) addRunDependency(dep);
                };
                var preloadPlugins = Module["preloadPlugins"] || [];
                function FS_handledByPreloadPlugin(byteArray, fullname, finish, onerror) {
                    if (typeof Browser != "undefined") Browser.init();
                    var handled = false;
                    preloadPlugins.forEach(function(plugin) {
                        if (handled) return;
                        if (plugin["canHandle"](fullname)) {
                            plugin["handle"](byteArray, fullname, finish, onerror);
                            handled = true;
                        }
                    });
                    return handled;
                }
                function FS_createPreloadedFile(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) {
                    var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
                    var dep = getUniqueRunDependency(`cp ${fullname}`);
                    function processData(byteArray) {
                        function finish(byteArray2) {
                            if (preFinish) preFinish();
                            if (!dontCreateFile) FS.createDataFile(parent, name, byteArray2, canRead, canWrite, canOwn);
                            if (onload) onload();
                            removeRunDependency(dep);
                        }
                        if (FS_handledByPreloadPlugin(byteArray, fullname, finish, ()=>{
                            if (onerror) onerror();
                            removeRunDependency(dep);
                        })) return;
                        finish(byteArray);
                    }
                    addRunDependency(dep);
                    if (typeof url == "string") asyncLoad(url, (byteArray)=>processData(byteArray), onerror);
                    else processData(url);
                }
                function FS_modeStringToFlags(str) {
                    var flagModes = {
                        "r": 0,
                        "r+": 2,
                        "w": 577,
                        "w+": 578,
                        "a": 1089,
                        "a+": 1090
                    };
                    var flags = flagModes[str];
                    if (typeof flags == "undefined") throw new Error(`Unknown file open mode: ${str}`);
                    return flags;
                }
                function FS_getMode(canRead, canWrite) {
                    var mode = 0;
                    if (canRead) mode |= 365;
                    if (canWrite) mode |= 146;
                    return mode;
                }
                var FS = {
                    root: null,
                    mounts: [],
                    devices: {},
                    streams: [],
                    nextInode: 1,
                    nameTable: null,
                    currentPath: "/",
                    initialized: false,
                    ignorePermissions: true,
                    ErrnoError: null,
                    genericErrors: {},
                    filesystems: null,
                    syncFSRequests: 0,
                    lookupPath: (path, opts = {})=>{
                        path = PATH_FS.resolve(path);
                        if (!path) return {
                            path: "",
                            node: null
                        };
                        var defaults = {
                            follow_mount: true,
                            recurse_count: 0
                        };
                        opts = Object.assign(defaults, opts);
                        if (opts.recurse_count > 8) throw new FS.ErrnoError(32);
                        var parts = path.split("/").filter((p)=>!!p);
                        var current = FS.root;
                        var current_path = "/";
                        for(var i = 0; i < parts.length; i++){
                            var islast = i === parts.length - 1;
                            if (islast && opts.parent) break;
                            current = FS.lookupNode(current, parts[i]);
                            current_path = PATH.join2(current_path, parts[i]);
                            if (FS.isMountpoint(current)) {
                                if (!islast || islast && opts.follow_mount) current = current.mounted.root;
                            }
                            if (!islast || opts.follow) {
                                var count = 0;
                                while(FS.isLink(current.mode)){
                                    var link = FS.readlink(current_path);
                                    current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                                    var lookup = FS.lookupPath(current_path, {
                                        recurse_count: opts.recurse_count + 1
                                    });
                                    current = lookup.node;
                                    if (count++ > 40) throw new FS.ErrnoError(32);
                                }
                            }
                        }
                        return {
                            path: current_path,
                            node: current
                        };
                    },
                    getPath: (node)=>{
                        var path;
                        while(true){
                            if (FS.isRoot(node)) {
                                var mount = node.mount.mountpoint;
                                if (!path) return mount;
                                return mount[mount.length - 1] !== "/" ? `${mount}/${path}` : mount + path;
                            }
                            path = path ? `${node.name}/${path}` : node.name;
                            node = node.parent;
                        }
                    },
                    hashName: (parentid, name)=>{
                        var hash = 0;
                        for(var i = 0; i < name.length; i++)hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
                        return (parentid + hash >>> 0) % FS.nameTable.length;
                    },
                    hashAddNode: (node)=>{
                        var hash = FS.hashName(node.parent.id, node.name);
                        node.name_next = FS.nameTable[hash];
                        FS.nameTable[hash] = node;
                    },
                    hashRemoveNode: (node)=>{
                        var hash = FS.hashName(node.parent.id, node.name);
                        if (FS.nameTable[hash] === node) FS.nameTable[hash] = node.name_next;
                        else {
                            var current = FS.nameTable[hash];
                            while(current){
                                if (current.name_next === node) {
                                    current.name_next = node.name_next;
                                    break;
                                }
                                current = current.name_next;
                            }
                        }
                    },
                    lookupNode: (parent, name)=>{
                        var errCode = FS.mayLookup(parent);
                        if (errCode) throw new FS.ErrnoError(errCode, parent);
                        var hash = FS.hashName(parent.id, name);
                        for(var node = FS.nameTable[hash]; node; node = node.name_next){
                            var nodeName = node.name;
                            if (node.parent.id === parent.id && nodeName === name) return node;
                        }
                        return FS.lookup(parent, name);
                    },
                    createNode: (parent, name, mode, rdev)=>{
                        var node = new FS.FSNode(parent, name, mode, rdev);
                        FS.hashAddNode(node);
                        return node;
                    },
                    destroyNode: (node)=>{
                        FS.hashRemoveNode(node);
                    },
                    isRoot: (node)=>node === node.parent,
                    isMountpoint: (node)=>!!node.mounted,
                    isFile: (mode)=>(mode & 61440) === 32768,
                    isDir: (mode)=>(mode & 61440) === 16384,
                    isLink: (mode)=>(mode & 61440) === 40960,
                    isChrdev: (mode)=>(mode & 61440) === 8192,
                    isBlkdev: (mode)=>(mode & 61440) === 24576,
                    isFIFO: (mode)=>(mode & 61440) === 4096,
                    isSocket: (mode)=>(mode & 49152) === 49152,
                    flagsToPermissionString: (flag)=>{
                        var perms = [
                            "r",
                            "w",
                            "rw"
                        ][flag & 3];
                        if (flag & 512) perms += "w";
                        return perms;
                    },
                    nodePermissions: (node, perms)=>{
                        if (FS.ignorePermissions) return 0;
                        if (perms.includes("r") && !(node.mode & 292)) return 2;
                        else if (perms.includes("w") && !(node.mode & 146)) return 2;
                        else if (perms.includes("x") && !(node.mode & 73)) return 2;
                        return 0;
                    },
                    mayLookup: (dir)=>{
                        var errCode = FS.nodePermissions(dir, "x");
                        if (errCode) return errCode;
                        if (!dir.node_ops.lookup) return 2;
                        return 0;
                    },
                    mayCreate: (dir, name)=>{
                        try {
                            var node = FS.lookupNode(dir, name);
                            return 20;
                        } catch (e) {}
                        return FS.nodePermissions(dir, "wx");
                    },
                    mayDelete: (dir, name, isdir)=>{
                        var node;
                        try {
                            node = FS.lookupNode(dir, name);
                        } catch (e) {
                            return e.errno;
                        }
                        var errCode = FS.nodePermissions(dir, "wx");
                        if (errCode) return errCode;
                        if (isdir) {
                            if (!FS.isDir(node.mode)) return 54;
                            if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) return 10;
                        } else {
                            if (FS.isDir(node.mode)) return 31;
                        }
                        return 0;
                    },
                    mayOpen: (node, flags)=>{
                        if (!node) return 44;
                        if (FS.isLink(node.mode)) return 32;
                        else if (FS.isDir(node.mode)) {
                            if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) return 31;
                        }
                        return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
                    },
                    MAX_OPEN_FDS: 4096,
                    nextfd: ()=>{
                        for(var fd = 0; fd <= FS.MAX_OPEN_FDS; fd++){
                            if (!FS.streams[fd]) return fd;
                        }
                        throw new FS.ErrnoError(33);
                    },
                    getStreamChecked: (fd)=>{
                        var stream = FS.getStream(fd);
                        if (!stream) throw new FS.ErrnoError(8);
                        return stream;
                    },
                    getStream: (fd)=>FS.streams[fd],
                    createStream: (stream, fd = -1)=>{
                        if (!FS.FSStream) {
                            FS.FSStream = function() {
                                this.shared = {};
                            };
                            FS.FSStream.prototype = {};
                            Object.defineProperties(FS.FSStream.prototype, {
                                object: {
                                    get () {
                                        return this.node;
                                    },
                                    set (val) {
                                        this.node = val;
                                    }
                                },
                                isRead: {
                                    get () {
                                        return (this.flags & 2097155) !== 1;
                                    }
                                },
                                isWrite: {
                                    get () {
                                        return (this.flags & 2097155) !== 0;
                                    }
                                },
                                isAppend: {
                                    get () {
                                        return this.flags & 1024;
                                    }
                                },
                                flags: {
                                    get () {
                                        return this.shared.flags;
                                    },
                                    set (val) {
                                        this.shared.flags = val;
                                    }
                                },
                                position: {
                                    get () {
                                        return this.shared.position;
                                    },
                                    set (val) {
                                        this.shared.position = val;
                                    }
                                }
                            });
                        }
                        stream = Object.assign(new FS.FSStream(), stream);
                        if (fd == -1) fd = FS.nextfd();
                        stream.fd = fd;
                        FS.streams[fd] = stream;
                        return stream;
                    },
                    closeStream: (fd)=>{
                        FS.streams[fd] = null;
                    },
                    chrdev_stream_ops: {
                        open: (stream)=>{
                            var device = FS.getDevice(stream.node.rdev);
                            stream.stream_ops = device.stream_ops;
                            if (stream.stream_ops.open) stream.stream_ops.open(stream);
                        },
                        llseek: ()=>{
                            throw new FS.ErrnoError(70);
                        }
                    },
                    major: (dev)=>dev >> 8,
                    minor: (dev)=>dev & 255,
                    makedev: (ma, mi)=>ma << 8 | mi,
                    registerDevice: (dev, ops)=>{
                        FS.devices[dev] = {
                            stream_ops: ops
                        };
                    },
                    getDevice: (dev)=>FS.devices[dev],
                    getMounts: (mount)=>{
                        var mounts = [];
                        var check = [
                            mount
                        ];
                        while(check.length){
                            var m = check.pop();
                            mounts.push(m);
                            check.push.apply(check, m.mounts);
                        }
                        return mounts;
                    },
                    syncfs: (populate, callback)=>{
                        if (typeof populate == "function") {
                            callback = populate;
                            populate = false;
                        }
                        FS.syncFSRequests++;
                        if (FS.syncFSRequests > 1) err(`warning: ${FS.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
                        var mounts = FS.getMounts(FS.root.mount);
                        var completed = 0;
                        function doCallback(errCode) {
                            FS.syncFSRequests--;
                            return callback(errCode);
                        }
                        function done(errCode) {
                            if (errCode) {
                                if (!done.errored) {
                                    done.errored = true;
                                    return doCallback(errCode);
                                }
                                return;
                            }
                            if (++completed >= mounts.length) doCallback(null);
                        }
                        mounts.forEach((mount)=>{
                            if (!mount.type.syncfs) return done(null);
                            mount.type.syncfs(mount, populate, done);
                        });
                    },
                    mount: (type, opts, mountpoint)=>{
                        var root = mountpoint === "/";
                        var pseudo = !mountpoint;
                        var node;
                        if (root && FS.root) throw new FS.ErrnoError(10);
                        else if (!root && !pseudo) {
                            var lookup = FS.lookupPath(mountpoint, {
                                follow_mount: false
                            });
                            mountpoint = lookup.path;
                            node = lookup.node;
                            if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                            if (!FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                        }
                        var mount = {
                            type: type,
                            opts: opts,
                            mountpoint: mountpoint,
                            mounts: []
                        };
                        var mountRoot = type.mount(mount);
                        mountRoot.mount = mount;
                        mount.root = mountRoot;
                        if (root) FS.root = mountRoot;
                        else if (node) {
                            node.mounted = mount;
                            if (node.mount) node.mount.mounts.push(mount);
                        }
                        return mountRoot;
                    },
                    unmount: (mountpoint)=>{
                        var lookup = FS.lookupPath(mountpoint, {
                            follow_mount: false
                        });
                        if (!FS.isMountpoint(lookup.node)) throw new FS.ErrnoError(28);
                        var node = lookup.node;
                        var mount = node.mounted;
                        var mounts = FS.getMounts(mount);
                        Object.keys(FS.nameTable).forEach((hash)=>{
                            var current = FS.nameTable[hash];
                            while(current){
                                var next = current.name_next;
                                if (mounts.includes(current.mount)) FS.destroyNode(current);
                                current = next;
                            }
                        });
                        node.mounted = null;
                        var idx = node.mount.mounts.indexOf(mount);
                        node.mount.mounts.splice(idx, 1);
                    },
                    lookup: (parent, name)=>parent.node_ops.lookup(parent, name),
                    mknod: (path, mode, dev)=>{
                        var lookup = FS.lookupPath(path, {
                            parent: true
                        });
                        var parent = lookup.node;
                        var name = PATH.basename(path);
                        if (!name || name === "." || name === "..") throw new FS.ErrnoError(28);
                        var errCode = FS.mayCreate(parent, name);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!parent.node_ops.mknod) throw new FS.ErrnoError(63);
                        return parent.node_ops.mknod(parent, name, mode, dev);
                    },
                    create: (path, mode)=>{
                        mode = mode !== void 0 ? mode : 438;
                        mode &= 4095;
                        mode |= 32768;
                        return FS.mknod(path, mode, 0);
                    },
                    mkdir: (path, mode)=>{
                        mode = mode !== void 0 ? mode : 511;
                        mode &= 1023;
                        mode |= 16384;
                        return FS.mknod(path, mode, 0);
                    },
                    mkdirTree: (path, mode)=>{
                        var dirs = path.split("/");
                        var d = "";
                        for(var i = 0; i < dirs.length; ++i){
                            if (!dirs[i]) continue;
                            d += "/" + dirs[i];
                            try {
                                FS.mkdir(d, mode);
                            } catch (e) {
                                if (e.errno != 20) throw e;
                            }
                        }
                    },
                    mkdev: (path, mode, dev)=>{
                        if (typeof dev == "undefined") {
                            dev = mode;
                            mode = 438;
                        }
                        mode |= 8192;
                        return FS.mknod(path, mode, dev);
                    },
                    symlink: (oldpath, newpath)=>{
                        if (!PATH_FS.resolve(oldpath)) throw new FS.ErrnoError(44);
                        var lookup = FS.lookupPath(newpath, {
                            parent: true
                        });
                        var parent = lookup.node;
                        if (!parent) throw new FS.ErrnoError(44);
                        var newname = PATH.basename(newpath);
                        var errCode = FS.mayCreate(parent, newname);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!parent.node_ops.symlink) throw new FS.ErrnoError(63);
                        return parent.node_ops.symlink(parent, newname, oldpath);
                    },
                    rename: (old_path, new_path)=>{
                        var old_dirname = PATH.dirname(old_path);
                        var new_dirname = PATH.dirname(new_path);
                        var old_name = PATH.basename(old_path);
                        var new_name = PATH.basename(new_path);
                        var lookup, old_dir, new_dir;
                        lookup = FS.lookupPath(old_path, {
                            parent: true
                        });
                        old_dir = lookup.node;
                        lookup = FS.lookupPath(new_path, {
                            parent: true
                        });
                        new_dir = lookup.node;
                        if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
                        if (old_dir.mount !== new_dir.mount) throw new FS.ErrnoError(75);
                        var old_node = FS.lookupNode(old_dir, old_name);
                        var relative = PATH_FS.relative(old_path, new_dirname);
                        if (relative.charAt(0) !== ".") throw new FS.ErrnoError(28);
                        relative = PATH_FS.relative(new_path, old_dirname);
                        if (relative.charAt(0) !== ".") throw new FS.ErrnoError(55);
                        var new_node;
                        try {
                            new_node = FS.lookupNode(new_dir, new_name);
                        } catch (e) {}
                        if (old_node === new_node) return;
                        var isdir = FS.isDir(old_node.mode);
                        var errCode = FS.mayDelete(old_dir, old_name, isdir);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!old_dir.node_ops.rename) throw new FS.ErrnoError(63);
                        if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) throw new FS.ErrnoError(10);
                        if (new_dir !== old_dir) {
                            errCode = FS.nodePermissions(old_dir, "w");
                            if (errCode) throw new FS.ErrnoError(errCode);
                        }
                        FS.hashRemoveNode(old_node);
                        try {
                            old_dir.node_ops.rename(old_node, new_dir, new_name);
                        } catch (e) {
                            throw e;
                        } finally{
                            FS.hashAddNode(old_node);
                        }
                    },
                    rmdir: (path)=>{
                        var lookup = FS.lookupPath(path, {
                            parent: true
                        });
                        var parent = lookup.node;
                        var name = PATH.basename(path);
                        var node = FS.lookupNode(parent, name);
                        var errCode = FS.mayDelete(parent, name, true);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!parent.node_ops.rmdir) throw new FS.ErrnoError(63);
                        if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                        parent.node_ops.rmdir(parent, name);
                        FS.destroyNode(node);
                    },
                    readdir: (path)=>{
                        var lookup = FS.lookupPath(path, {
                            follow: true
                        });
                        var node = lookup.node;
                        if (!node.node_ops.readdir) throw new FS.ErrnoError(54);
                        return node.node_ops.readdir(node);
                    },
                    unlink: (path)=>{
                        var lookup = FS.lookupPath(path, {
                            parent: true
                        });
                        var parent = lookup.node;
                        if (!parent) throw new FS.ErrnoError(44);
                        var name = PATH.basename(path);
                        var node = FS.lookupNode(parent, name);
                        var errCode = FS.mayDelete(parent, name, false);
                        if (errCode) throw new FS.ErrnoError(errCode);
                        if (!parent.node_ops.unlink) throw new FS.ErrnoError(63);
                        if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                        parent.node_ops.unlink(parent, name);
                        FS.destroyNode(node);
                    },
                    readlink: (path)=>{
                        var lookup = FS.lookupPath(path);
                        var link = lookup.node;
                        if (!link) throw new FS.ErrnoError(44);
                        if (!link.node_ops.readlink) throw new FS.ErrnoError(28);
                        return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
                    },
                    stat: (path, dontFollow)=>{
                        var lookup = FS.lookupPath(path, {
                            follow: !dontFollow
                        });
                        var node = lookup.node;
                        if (!node) throw new FS.ErrnoError(44);
                        if (!node.node_ops.getattr) throw new FS.ErrnoError(63);
                        return node.node_ops.getattr(node);
                    },
                    lstat: (path)=>FS.stat(path, true),
                    chmod: (path, mode, dontFollow)=>{
                        var node;
                        if (typeof path == "string") {
                            var lookup = FS.lookupPath(path, {
                                follow: !dontFollow
                            });
                            node = lookup.node;
                        } else node = path;
                        if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                        node.node_ops.setattr(node, {
                            mode: mode & 4095 | node.mode & -4096,
                            timestamp: Date.now()
                        });
                    },
                    lchmod: (path, mode)=>{
                        FS.chmod(path, mode, true);
                    },
                    fchmod: (fd, mode)=>{
                        var stream = FS.getStreamChecked(fd);
                        FS.chmod(stream.node, mode);
                    },
                    chown: (path, uid, gid, dontFollow)=>{
                        var node;
                        if (typeof path == "string") {
                            var lookup = FS.lookupPath(path, {
                                follow: !dontFollow
                            });
                            node = lookup.node;
                        } else node = path;
                        if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                        node.node_ops.setattr(node, {
                            timestamp: Date.now()
                        });
                    },
                    lchown: (path, uid, gid)=>{
                        FS.chown(path, uid, gid, true);
                    },
                    fchown: (fd, uid, gid)=>{
                        var stream = FS.getStreamChecked(fd);
                        FS.chown(stream.node, uid, gid);
                    },
                    truncate: (path, len)=>{
                        if (len < 0) throw new FS.ErrnoError(28);
                        var node;
                        if (typeof path == "string") {
                            var lookup = FS.lookupPath(path, {
                                follow: true
                            });
                            node = lookup.node;
                        } else node = path;
                        if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                        if (FS.isDir(node.mode)) throw new FS.ErrnoError(31);
                        if (!FS.isFile(node.mode)) throw new FS.ErrnoError(28);
                        var errCode = FS.nodePermissions(node, "w");
                        if (errCode) throw new FS.ErrnoError(errCode);
                        node.node_ops.setattr(node, {
                            size: len,
                            timestamp: Date.now()
                        });
                    },
                    ftruncate: (fd, len)=>{
                        var stream = FS.getStreamChecked(fd);
                        if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(28);
                        FS.truncate(stream.node, len);
                    },
                    utime: (path, atime, mtime)=>{
                        var lookup = FS.lookupPath(path, {
                            follow: true
                        });
                        var node = lookup.node;
                        node.node_ops.setattr(node, {
                            timestamp: Math.max(atime, mtime)
                        });
                    },
                    open: (path, flags, mode)=>{
                        if (path === "") throw new FS.ErrnoError(44);
                        flags = typeof flags == "string" ? FS_modeStringToFlags(flags) : flags;
                        mode = typeof mode == "undefined" ? 438 : mode;
                        if (flags & 64) mode = mode & 4095 | 32768;
                        else mode = 0;
                        var node;
                        if (typeof path == "object") node = path;
                        else {
                            path = PATH.normalize(path);
                            try {
                                var lookup = FS.lookupPath(path, {
                                    follow: !(flags & 131072)
                                });
                                node = lookup.node;
                            } catch (e) {}
                        }
                        var created = false;
                        if (flags & 64) {
                            if (node) {
                                if (flags & 128) throw new FS.ErrnoError(20);
                            } else {
                                node = FS.mknod(path, mode, 0);
                                created = true;
                            }
                        }
                        if (!node) throw new FS.ErrnoError(44);
                        if (FS.isChrdev(node.mode)) flags &= -513;
                        if (flags & 65536 && !FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                        if (!created) {
                            var errCode = FS.mayOpen(node, flags);
                            if (errCode) throw new FS.ErrnoError(errCode);
                        }
                        if (flags & 512 && !created) FS.truncate(node, 0);
                        flags &= -131713;
                        var stream = FS.createStream({
                            node: node,
                            path: FS.getPath(node),
                            flags: flags,
                            seekable: true,
                            position: 0,
                            stream_ops: node.stream_ops,
                            ungotten: [],
                            error: false
                        });
                        if (stream.stream_ops.open) stream.stream_ops.open(stream);
                        if (Module["logReadFiles"] && !(flags & 1)) {
                            if (!FS.readFiles) FS.readFiles = {};
                            if (!(path in FS.readFiles)) FS.readFiles[path] = 1;
                        }
                        return stream;
                    },
                    close: (stream)=>{
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if (stream.getdents) stream.getdents = null;
                        try {
                            if (stream.stream_ops.close) stream.stream_ops.close(stream);
                        } catch (e) {
                            throw e;
                        } finally{
                            FS.closeStream(stream.fd);
                        }
                        stream.fd = null;
                    },
                    isClosed: (stream)=>stream.fd === null,
                    llseek: (stream, offset, whence)=>{
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if (!stream.seekable || !stream.stream_ops.llseek) throw new FS.ErrnoError(70);
                        if (whence != 0 && whence != 1 && whence != 2) throw new FS.ErrnoError(28);
                        stream.position = stream.stream_ops.llseek(stream, offset, whence);
                        stream.ungotten = [];
                        return stream.position;
                    },
                    read: (stream, buffer, offset, length, position)=>{
                        if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(8);
                        if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                        if (!stream.stream_ops.read) throw new FS.ErrnoError(28);
                        var seeking = typeof position != "undefined";
                        if (!seeking) position = stream.position;
                        else if (!stream.seekable) throw new FS.ErrnoError(70);
                        var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
                        if (!seeking) stream.position += bytesRead;
                        return bytesRead;
                    },
                    write: (stream, buffer, offset, length, position, canOwn)=>{
                        if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                        if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                        if (!stream.stream_ops.write) throw new FS.ErrnoError(28);
                        if (stream.seekable && stream.flags & 1024) FS.llseek(stream, 0, 2);
                        var seeking = typeof position != "undefined";
                        if (!seeking) position = stream.position;
                        else if (!stream.seekable) throw new FS.ErrnoError(70);
                        var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
                        if (!seeking) stream.position += bytesWritten;
                        return bytesWritten;
                    },
                    allocate: (stream, offset, length)=>{
                        if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                        if (offset < 0 || length <= 0) throw new FS.ErrnoError(28);
                        if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                        if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) throw new FS.ErrnoError(43);
                        if (!stream.stream_ops.allocate) throw new FS.ErrnoError(138);
                        stream.stream_ops.allocate(stream, offset, length);
                    },
                    mmap: (stream, length, position, prot, flags)=>{
                        if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) throw new FS.ErrnoError(2);
                        if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(2);
                        if (!stream.stream_ops.mmap) throw new FS.ErrnoError(43);
                        return stream.stream_ops.mmap(stream, length, position, prot, flags);
                    },
                    msync: (stream, buffer, offset, length, mmapFlags)=>{
                        if (!stream.stream_ops.msync) return 0;
                        return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
                    },
                    munmap: (stream)=>0,
                    ioctl: (stream, cmd, arg)=>{
                        if (!stream.stream_ops.ioctl) throw new FS.ErrnoError(59);
                        return stream.stream_ops.ioctl(stream, cmd, arg);
                    },
                    readFile: (path, opts = {})=>{
                        opts.flags = opts.flags || 0;
                        opts.encoding = opts.encoding || "binary";
                        if (opts.encoding !== "utf8" && opts.encoding !== "binary") throw new Error(`Invalid encoding type "${opts.encoding}"`);
                        var ret;
                        var stream = FS.open(path, opts.flags);
                        var stat = FS.stat(path);
                        var length = stat.size;
                        var buf = new Uint8Array(length);
                        FS.read(stream, buf, 0, length, 0);
                        if (opts.encoding === "utf8") ret = UTF8ArrayToString(buf, 0);
                        else if (opts.encoding === "binary") ret = buf;
                        FS.close(stream);
                        return ret;
                    },
                    writeFile: (path, data, opts = {})=>{
                        opts.flags = opts.flags || 577;
                        var stream = FS.open(path, opts.flags, opts.mode);
                        if (typeof data == "string") {
                            var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
                            var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
                            FS.write(stream, buf, 0, actualNumBytes, void 0, opts.canOwn);
                        } else if (ArrayBuffer.isView(data)) FS.write(stream, data, 0, data.byteLength, void 0, opts.canOwn);
                        else throw new Error("Unsupported data type");
                        FS.close(stream);
                    },
                    cwd: ()=>FS.currentPath,
                    chdir: (path)=>{
                        var lookup = FS.lookupPath(path, {
                            follow: true
                        });
                        if (lookup.node === null) throw new FS.ErrnoError(44);
                        if (!FS.isDir(lookup.node.mode)) throw new FS.ErrnoError(54);
                        var errCode = FS.nodePermissions(lookup.node, "x");
                        if (errCode) throw new FS.ErrnoError(errCode);
                        FS.currentPath = lookup.path;
                    },
                    createDefaultDirectories: ()=>{
                        FS.mkdir("/tmp");
                        FS.mkdir("/home");
                        FS.mkdir("/home/web_user");
                    },
                    createDefaultDevices: ()=>{
                        FS.mkdir("/dev");
                        FS.registerDevice(FS.makedev(1, 3), {
                            read: ()=>0,
                            write: (stream, buffer, offset, length, pos)=>length
                        });
                        FS.mkdev("/dev/null", FS.makedev(1, 3));
                        TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
                        TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
                        FS.mkdev("/dev/tty", FS.makedev(5, 0));
                        FS.mkdev("/dev/tty1", FS.makedev(6, 0));
                        var randomBuffer = new Uint8Array(1024), randomLeft = 0;
                        var randomByte = ()=>{
                            if (randomLeft === 0) randomLeft = randomFill(randomBuffer).byteLength;
                            return randomBuffer[--randomLeft];
                        };
                        FS.createDevice("/dev", "random", randomByte);
                        FS.createDevice("/dev", "urandom", randomByte);
                        FS.mkdir("/dev/shm");
                        FS.mkdir("/dev/shm/tmp");
                    },
                    createSpecialDirectories: ()=>{
                        FS.mkdir("/proc");
                        var proc_self = FS.mkdir("/proc/self");
                        FS.mkdir("/proc/self/fd");
                        FS.mount({
                            mount: ()=>{
                                var node = FS.createNode(proc_self, "fd", 16895, 73);
                                node.node_ops = {
                                    lookup: (parent, name)=>{
                                        var fd = +name;
                                        var stream = FS.getStreamChecked(fd);
                                        var ret = {
                                            parent: null,
                                            mount: {
                                                mountpoint: "fake"
                                            },
                                            node_ops: {
                                                readlink: ()=>stream.path
                                            }
                                        };
                                        ret.parent = ret;
                                        return ret;
                                    }
                                };
                                return node;
                            }
                        }, {}, "/proc/self/fd");
                    },
                    createStandardStreams: ()=>{
                        if (Module["stdin"]) FS.createDevice("/dev", "stdin", Module["stdin"]);
                        else FS.symlink("/dev/tty", "/dev/stdin");
                        if (Module["stdout"]) FS.createDevice("/dev", "stdout", null, Module["stdout"]);
                        else FS.symlink("/dev/tty", "/dev/stdout");
                        if (Module["stderr"]) FS.createDevice("/dev", "stderr", null, Module["stderr"]);
                        else FS.symlink("/dev/tty1", "/dev/stderr");
                        var stdin = FS.open("/dev/stdin", 0);
                        var stdout = FS.open("/dev/stdout", 1);
                        var stderr = FS.open("/dev/stderr", 1);
                    },
                    ensureErrnoError: ()=>{
                        if (FS.ErrnoError) return;
                        FS.ErrnoError = function ErrnoError(errno, node) {
                            this.name = "ErrnoError";
                            this.node = node;
                            this.setErrno = function(errno2) {
                                this.errno = errno2;
                            };
                            this.setErrno(errno);
                            this.message = "FS error";
                        };
                        FS.ErrnoError.prototype = new Error();
                        FS.ErrnoError.prototype.constructor = FS.ErrnoError;
                        [
                            44
                        ].forEach((code)=>{
                            FS.genericErrors[code] = new FS.ErrnoError(code);
                            FS.genericErrors[code].stack = "<generic error, no stack>";
                        });
                    },
                    staticInit: ()=>{
                        FS.ensureErrnoError();
                        FS.nameTable = new Array(4096);
                        FS.mount(MEMFS, {}, "/");
                        FS.createDefaultDirectories();
                        FS.createDefaultDevices();
                        FS.createSpecialDirectories();
                        FS.filesystems = {
                            "MEMFS": MEMFS
                        };
                    },
                    init: (input, output, error)=>{
                        FS.init.initialized = true;
                        FS.ensureErrnoError();
                        Module["stdin"] = input || Module["stdin"];
                        Module["stdout"] = output || Module["stdout"];
                        Module["stderr"] = error || Module["stderr"];
                        FS.createStandardStreams();
                    },
                    quit: ()=>{
                        FS.init.initialized = false;
                        for(var i = 0; i < FS.streams.length; i++){
                            var stream = FS.streams[i];
                            if (!stream) continue;
                            FS.close(stream);
                        }
                    },
                    findObject: (path, dontResolveLastLink)=>{
                        var ret = FS.analyzePath(path, dontResolveLastLink);
                        if (!ret.exists) return null;
                        return ret.object;
                    },
                    analyzePath: (path, dontResolveLastLink)=>{
                        try {
                            var lookup = FS.lookupPath(path, {
                                follow: !dontResolveLastLink
                            });
                            path = lookup.path;
                        } catch (e) {}
                        var ret = {
                            isRoot: false,
                            exists: false,
                            error: 0,
                            name: null,
                            path: null,
                            object: null,
                            parentExists: false,
                            parentPath: null,
                            parentObject: null
                        };
                        try {
                            var lookup = FS.lookupPath(path, {
                                parent: true
                            });
                            ret.parentExists = true;
                            ret.parentPath = lookup.path;
                            ret.parentObject = lookup.node;
                            ret.name = PATH.basename(path);
                            lookup = FS.lookupPath(path, {
                                follow: !dontResolveLastLink
                            });
                            ret.exists = true;
                            ret.path = lookup.path;
                            ret.object = lookup.node;
                            ret.name = lookup.node.name;
                            ret.isRoot = lookup.path === "/";
                        } catch (e) {
                            ret.error = e.errno;
                        }
                        return ret;
                    },
                    createPath: (parent, path, canRead, canWrite)=>{
                        parent = typeof parent == "string" ? parent : FS.getPath(parent);
                        var parts = path.split("/").reverse();
                        while(parts.length){
                            var part = parts.pop();
                            if (!part) continue;
                            var current = PATH.join2(parent, part);
                            try {
                                FS.mkdir(current);
                            } catch (e) {}
                            parent = current;
                        }
                        return current;
                    },
                    createFile: (parent, name, properties, canRead, canWrite)=>{
                        var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                        var mode = FS_getMode(canRead, canWrite);
                        return FS.create(path, mode);
                    },
                    createDataFile: (parent, name, data, canRead, canWrite, canOwn)=>{
                        var path = name;
                        if (parent) {
                            parent = typeof parent == "string" ? parent : FS.getPath(parent);
                            path = name ? PATH.join2(parent, name) : parent;
                        }
                        var mode = FS_getMode(canRead, canWrite);
                        var node = FS.create(path, mode);
                        if (data) {
                            if (typeof data == "string") {
                                var arr = new Array(data.length);
                                for(var i = 0, len = data.length; i < len; ++i)arr[i] = data.charCodeAt(i);
                                data = arr;
                            }
                            FS.chmod(node, mode | 146);
                            var stream = FS.open(node, 577);
                            FS.write(stream, data, 0, data.length, 0, canOwn);
                            FS.close(stream);
                            FS.chmod(node, mode);
                        }
                        return node;
                    },
                    createDevice: (parent, name, input, output)=>{
                        var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                        var mode = FS_getMode(!!input, !!output);
                        if (!FS.createDevice.major) FS.createDevice.major = 64;
                        var dev = FS.makedev(FS.createDevice.major++, 0);
                        FS.registerDevice(dev, {
                            open: (stream)=>{
                                stream.seekable = false;
                            },
                            close: (stream)=>{
                                if (output && output.buffer && output.buffer.length) output(10);
                            },
                            read: (stream, buffer, offset, length, pos)=>{
                                var bytesRead = 0;
                                for(var i = 0; i < length; i++){
                                    var result;
                                    try {
                                        result = input();
                                    } catch (e) {
                                        throw new FS.ErrnoError(29);
                                    }
                                    if (result === void 0 && bytesRead === 0) throw new FS.ErrnoError(6);
                                    if (result === null || result === void 0) break;
                                    bytesRead++;
                                    buffer[offset + i] = result;
                                }
                                if (bytesRead) stream.node.timestamp = Date.now();
                                return bytesRead;
                            },
                            write: (stream, buffer, offset, length, pos)=>{
                                for(var i = 0; i < length; i++)try {
                                    output(buffer[offset + i]);
                                } catch (e) {
                                    throw new FS.ErrnoError(29);
                                }
                                if (length) stream.node.timestamp = Date.now();
                                return i;
                            }
                        });
                        return FS.mkdev(path, mode, dev);
                    },
                    forceLoadFile: (obj)=>{
                        if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
                        if (typeof XMLHttpRequest != "undefined") throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                        else if (read_) try {
                            obj.contents = intArrayFromString(read_(obj.url), true);
                            obj.usedBytes = obj.contents.length;
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        else throw new Error("Cannot load without read() or XMLHttpRequest.");
                    },
                    createLazyFile: (parent, name, url, canRead, canWrite)=>{
                        function LazyUint8Array() {
                            this.lengthKnown = false;
                            this.chunks = [];
                        }
                        LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
                            if (idx > this.length - 1 || idx < 0) return void 0;
                            var chunkOffset = idx % this.chunkSize;
                            var chunkNum = idx / this.chunkSize | 0;
                            return this.getter(chunkNum)[chunkOffset];
                        };
                        LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
                            this.getter = getter;
                        };
                        LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
                            var xhr = new XMLHttpRequest();
                            xhr.open("HEAD", url, false);
                            xhr.send(null);
                            if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                            var datalength = Number(xhr.getResponseHeader("Content-length"));
                            var header;
                            var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                            var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
                            var chunkSize = 1048576;
                            if (!hasByteServing) chunkSize = datalength;
                            var doXHR = (from, to)=>{
                                if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                                if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                                var xhr2 = new XMLHttpRequest();
                                xhr2.open("GET", url, false);
                                if (datalength !== chunkSize) xhr2.setRequestHeader("Range", "bytes=" + from + "-" + to);
                                xhr2.responseType = "arraybuffer";
                                if (xhr2.overrideMimeType) xhr2.overrideMimeType("text/plain; charset=x-user-defined");
                                xhr2.send(null);
                                if (!(xhr2.status >= 200 && xhr2.status < 300 || xhr2.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr2.status);
                                if (xhr2.response !== void 0) return new Uint8Array(xhr2.response || []);
                                return intArrayFromString(xhr2.responseText || "", true);
                            };
                            var lazyArray2 = this;
                            lazyArray2.setDataGetter((chunkNum)=>{
                                var start = chunkNum * chunkSize;
                                var end = (chunkNum + 1) * chunkSize - 1;
                                end = Math.min(end, datalength - 1);
                                if (typeof lazyArray2.chunks[chunkNum] == "undefined") lazyArray2.chunks[chunkNum] = doXHR(start, end);
                                if (typeof lazyArray2.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                                return lazyArray2.chunks[chunkNum];
                            });
                            if (usesGzip || !datalength) {
                                chunkSize = datalength = 1;
                                datalength = this.getter(0).length;
                                chunkSize = datalength;
                                out("LazyFiles on gzip forces download of the whole file when length is accessed");
                            }
                            this._length = datalength;
                            this._chunkSize = chunkSize;
                            this.lengthKnown = true;
                        };
                        if (typeof XMLHttpRequest != "undefined") {
                            if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                            var lazyArray = new LazyUint8Array();
                            Object.defineProperties(lazyArray, {
                                length: {
                                    get: function() {
                                        if (!this.lengthKnown) this.cacheLength();
                                        return this._length;
                                    }
                                },
                                chunkSize: {
                                    get: function() {
                                        if (!this.lengthKnown) this.cacheLength();
                                        return this._chunkSize;
                                    }
                                }
                            });
                            var properties = {
                                isDevice: false,
                                contents: lazyArray
                            };
                        } else var properties = {
                            isDevice: false,
                            url: url
                        };
                        var node = FS.createFile(parent, name, properties, canRead, canWrite);
                        if (properties.contents) node.contents = properties.contents;
                        else if (properties.url) {
                            node.contents = null;
                            node.url = properties.url;
                        }
                        Object.defineProperties(node, {
                            usedBytes: {
                                get: function() {
                                    return this.contents.length;
                                }
                            }
                        });
                        var stream_ops = {};
                        var keys = Object.keys(node.stream_ops);
                        keys.forEach((key)=>{
                            var fn = node.stream_ops[key];
                            stream_ops[key] = function forceLoadLazyFile() {
                                FS.forceLoadFile(node);
                                return fn.apply(null, arguments);
                            };
                        });
                        function writeChunks(stream, buffer, offset, length, position) {
                            var contents = stream.node.contents;
                            if (position >= contents.length) return 0;
                            var size = Math.min(contents.length - position, length);
                            if (contents.slice) for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                            else for(var i = 0; i < size; i++)buffer[offset + i] = contents.get(position + i);
                            return size;
                        }
                        stream_ops.read = (stream, buffer, offset, length, position)=>{
                            FS.forceLoadFile(node);
                            return writeChunks(stream, buffer, offset, length, position);
                        };
                        stream_ops.mmap = (stream, length, position, prot, flags)=>{
                            FS.forceLoadFile(node);
                            var ptr = mmapAlloc(length);
                            if (!ptr) throw new FS.ErrnoError(48);
                            writeChunks(stream, HEAP8, ptr, length, position);
                            return {
                                ptr: ptr,
                                allocated: true
                            };
                        };
                        node.stream_ops = stream_ops;
                        return node;
                    }
                };
                var SYSCALLS = {
                    DEFAULT_POLLMASK: 5,
                    calculateAt: function(dirfd, path, allowEmpty) {
                        if (PATH.isAbs(path)) return path;
                        var dir;
                        if (dirfd === -100) dir = FS.cwd();
                        else {
                            var dirstream = SYSCALLS.getStreamFromFD(dirfd);
                            dir = dirstream.path;
                        }
                        if (path.length == 0) {
                            if (!allowEmpty) throw new FS.ErrnoError(44);
                            return dir;
                        }
                        return PATH.join2(dir, path);
                    },
                    doStat: function(func, path, buf) {
                        try {
                            var stat = func(path);
                        } catch (e) {
                            if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) return -54;
                            throw e;
                        }
                        HEAP32[buf >>> 2] = stat.dev;
                        HEAP32[buf + 4 >>> 2] = stat.mode;
                        HEAPU32[buf + 8 >>> 2] = stat.nlink;
                        HEAP32[buf + 12 >>> 2] = stat.uid;
                        HEAP32[buf + 16 >>> 2] = stat.gid;
                        HEAP32[buf + 20 >>> 2] = stat.rdev;
                        tempI64 = [
                            stat.size >>> 0,
                            (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], HEAP32[buf + 24 >>> 2] = tempI64[0], HEAP32[buf + 28 >>> 2] = tempI64[1];
                        HEAP32[buf + 32 >>> 2] = 4096;
                        HEAP32[buf + 36 >>> 2] = stat.blocks;
                        var atime = stat.atime.getTime();
                        var mtime = stat.mtime.getTime();
                        var ctime = stat.ctime.getTime();
                        tempI64 = [
                            Math.floor(atime / 1e3) >>> 0,
                            (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], HEAP32[buf + 40 >>> 2] = tempI64[0], HEAP32[buf + 44 >>> 2] = tempI64[1];
                        HEAPU32[buf + 48 >>> 2] = atime % 1e3 * 1e3;
                        tempI64 = [
                            Math.floor(mtime / 1e3) >>> 0,
                            (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], HEAP32[buf + 56 >>> 2] = tempI64[0], HEAP32[buf + 60 >>> 2] = tempI64[1];
                        HEAPU32[buf + 64 >>> 2] = mtime % 1e3 * 1e3;
                        tempI64 = [
                            Math.floor(ctime / 1e3) >>> 0,
                            (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], HEAP32[buf + 72 >>> 2] = tempI64[0], HEAP32[buf + 76 >>> 2] = tempI64[1];
                        HEAPU32[buf + 80 >>> 2] = ctime % 1e3 * 1e3;
                        tempI64 = [
                            stat.ino >>> 0,
                            (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], HEAP32[buf + 88 >>> 2] = tempI64[0], HEAP32[buf + 92 >>> 2] = tempI64[1];
                        return 0;
                    },
                    doMsync: function(addr, stream, len, flags, offset) {
                        if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                        if (flags & 2) return 0;
                        var buffer = HEAPU8.slice(addr, addr + len);
                        FS.msync(stream, buffer, offset, len, flags);
                    },
                    varargs: void 0,
                    get () {
                        SYSCALLS.varargs += 4;
                        var ret = HEAP32[SYSCALLS.varargs - 4 >>> 2];
                        return ret;
                    },
                    getStr (ptr) {
                        var ret = UTF8ToString(ptr);
                        return ret;
                    },
                    getStreamFromFD: function(fd) {
                        var stream = FS.getStreamChecked(fd);
                        return stream;
                    }
                };
                function _environ_get(__environ, environ_buf) {
                    __environ >>>= 0;
                    environ_buf >>>= 0;
                    var bufSize = 0;
                    getEnvStrings().forEach(function(string, i) {
                        var ptr = environ_buf + bufSize;
                        HEAPU32[__environ + i * 4 >>> 2] = ptr;
                        stringToAscii(string, ptr);
                        bufSize += string.length + 1;
                    });
                    return 0;
                }
                function _environ_sizes_get(penviron_count, penviron_buf_size) {
                    penviron_count >>>= 0;
                    penviron_buf_size >>>= 0;
                    var strings = getEnvStrings();
                    HEAPU32[penviron_count >>> 2] = strings.length;
                    var bufSize = 0;
                    strings.forEach(function(string) {
                        bufSize += string.length + 1;
                    });
                    HEAPU32[penviron_buf_size >>> 2] = bufSize;
                    return 0;
                }
                function _fd_close(fd) {
                    try {
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        FS.close(stream);
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                function _fd_fdstat_get(fd, pbuf) {
                    pbuf >>>= 0;
                    try {
                        var rightsBase = 0;
                        var rightsInheriting = 0;
                        var flags = 0;
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        var type = stream.tty ? 2 : FS.isDir(stream.mode) ? 3 : FS.isLink(stream.mode) ? 7 : 4;
                        HEAP8[pbuf >>> 0] = type;
                        HEAP16[pbuf + 2 >>> 1] = flags;
                        tempI64 = [
                            rightsBase >>> 0,
                            (tempDouble = rightsBase, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], HEAP32[pbuf + 8 >>> 2] = tempI64[0], HEAP32[pbuf + 12 >>> 2] = tempI64[1];
                        tempI64 = [
                            rightsInheriting >>> 0,
                            (tempDouble = rightsInheriting, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], HEAP32[pbuf + 16 >>> 2] = tempI64[0], HEAP32[pbuf + 20 >>> 2] = tempI64[1];
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                var doReadv = (stream, iov, iovcnt, offset)=>{
                    var ret = 0;
                    for(var i = 0; i < iovcnt; i++){
                        var ptr = HEAPU32[iov >>> 2];
                        var len = HEAPU32[iov + 4 >>> 2];
                        iov += 8;
                        var curr = FS.read(stream, HEAP8, ptr, len, offset);
                        if (curr < 0) return -1;
                        ret += curr;
                        if (curr < len) break;
                        if (typeof offset !== "undefined") offset += curr;
                    }
                    return ret;
                };
                function _fd_read(fd, iov, iovcnt, pnum) {
                    iov >>>= 0;
                    iovcnt >>>= 0;
                    pnum >>>= 0;
                    try {
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        var num = doReadv(stream, iov, iovcnt);
                        HEAPU32[pnum >>> 2] = num;
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
                    var offset = convertI32PairToI53Checked(offset_low, offset_high);
                    newOffset >>>= 0;
                    try {
                        if (isNaN(offset)) return 61;
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        FS.llseek(stream, offset, whence);
                        tempI64 = [
                            stream.position >>> 0,
                            (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? +Math.floor(tempDouble / 4294967296) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                        ], HEAP32[newOffset >>> 2] = tempI64[0], HEAP32[newOffset + 4 >>> 2] = tempI64[1];
                        if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                var doWritev = (stream, iov, iovcnt, offset)=>{
                    var ret = 0;
                    for(var i = 0; i < iovcnt; i++){
                        var ptr = HEAPU32[iov >>> 2];
                        var len = HEAPU32[iov + 4 >>> 2];
                        iov += 8;
                        var curr = FS.write(stream, HEAP8, ptr, len, offset);
                        if (curr < 0) return -1;
                        ret += curr;
                        if (typeof offset !== "undefined") offset += curr;
                    }
                    return ret;
                };
                function _fd_write(fd, iov, iovcnt, pnum) {
                    iov >>>= 0;
                    iovcnt >>>= 0;
                    pnum >>>= 0;
                    try {
                        var stream = SYSCALLS.getStreamFromFD(fd);
                        var num = doWritev(stream, iov, iovcnt);
                        HEAPU32[pnum >>> 2] = num;
                        return 0;
                    } catch (e) {
                        if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                        return e.errno;
                    }
                }
                function _getentropy(buffer, size) {
                    buffer >>>= 0;
                    size >>>= 0;
                    randomFill(HEAPU8.subarray(buffer >>> 0, buffer + size >>> 0));
                    return 0;
                }
                var arraySum = (array, index)=>{
                    var sum = 0;
                    for(var i = 0; i <= index; sum += array[i++]);
                    return sum;
                };
                var MONTH_DAYS_LEAP = [
                    31,
                    29,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ];
                var MONTH_DAYS_REGULAR = [
                    31,
                    28,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ];
                var addDays = (date, days)=>{
                    var newDate = new Date(date.getTime());
                    while(days > 0){
                        var leap = isLeapYear(newDate.getFullYear());
                        var currentMonth = newDate.getMonth();
                        var daysInCurrentMonth = (leap ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR)[currentMonth];
                        if (days > daysInCurrentMonth - newDate.getDate()) {
                            days -= daysInCurrentMonth - newDate.getDate() + 1;
                            newDate.setDate(1);
                            if (currentMonth < 11) newDate.setMonth(currentMonth + 1);
                            else {
                                newDate.setMonth(0);
                                newDate.setFullYear(newDate.getFullYear() + 1);
                            }
                        } else {
                            newDate.setDate(newDate.getDate() + days);
                            return newDate;
                        }
                    }
                    return newDate;
                };
                var writeArrayToMemory = (array, buffer)=>{
                    HEAP8.set(array, buffer >>> 0);
                };
                function _strftime(s, maxsize, format, tm) {
                    s >>>= 0;
                    maxsize >>>= 0;
                    format >>>= 0;
                    tm >>>= 0;
                    var tm_zone = HEAP32[tm + 40 >>> 2];
                    var date = {
                        tm_sec: HEAP32[tm >>> 2],
                        tm_min: HEAP32[tm + 4 >>> 2],
                        tm_hour: HEAP32[tm + 8 >>> 2],
                        tm_mday: HEAP32[tm + 12 >>> 2],
                        tm_mon: HEAP32[tm + 16 >>> 2],
                        tm_year: HEAP32[tm + 20 >>> 2],
                        tm_wday: HEAP32[tm + 24 >>> 2],
                        tm_yday: HEAP32[tm + 28 >>> 2],
                        tm_isdst: HEAP32[tm + 32 >>> 2],
                        tm_gmtoff: HEAP32[tm + 36 >>> 2],
                        tm_zone: tm_zone ? UTF8ToString(tm_zone) : ""
                    };
                    var pattern = UTF8ToString(format);
                    var EXPANSION_RULES_1 = {
                        "%c": "%a %b %d %H:%M:%S %Y",
                        "%D": "%m/%d/%y",
                        "%F": "%Y-%m-%d",
                        "%h": "%b",
                        "%r": "%I:%M:%S %p",
                        "%R": "%H:%M",
                        "%T": "%H:%M:%S",
                        "%x": "%m/%d/%y",
                        "%X": "%H:%M:%S",
                        "%Ec": "%c",
                        "%EC": "%C",
                        "%Ex": "%m/%d/%y",
                        "%EX": "%H:%M:%S",
                        "%Ey": "%y",
                        "%EY": "%Y",
                        "%Od": "%d",
                        "%Oe": "%e",
                        "%OH": "%H",
                        "%OI": "%I",
                        "%Om": "%m",
                        "%OM": "%M",
                        "%OS": "%S",
                        "%Ou": "%u",
                        "%OU": "%U",
                        "%OV": "%V",
                        "%Ow": "%w",
                        "%OW": "%W",
                        "%Oy": "%y"
                    };
                    for(var rule in EXPANSION_RULES_1)pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
                    var WEEKDAYS = [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ];
                    var MONTHS = [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ];
                    function leadingSomething(value, digits, character) {
                        var str = typeof value == "number" ? value.toString() : value || "";
                        while(str.length < digits)str = character[0] + str;
                        return str;
                    }
                    function leadingNulls(value, digits) {
                        return leadingSomething(value, digits, "0");
                    }
                    function compareByDay(date1, date2) {
                        function sgn(value) {
                            return value < 0 ? -1 : value > 0 ? 1 : 0;
                        }
                        var compare;
                        if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
                            if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) compare = sgn(date1.getDate() - date2.getDate());
                        }
                        return compare;
                    }
                    function getFirstWeekStartDate(janFourth) {
                        switch(janFourth.getDay()){
                            case 0:
                                return new Date(janFourth.getFullYear() - 1, 11, 29);
                            case 1:
                                return janFourth;
                            case 2:
                                return new Date(janFourth.getFullYear(), 0, 3);
                            case 3:
                                return new Date(janFourth.getFullYear(), 0, 2);
                            case 4:
                                return new Date(janFourth.getFullYear(), 0, 1);
                            case 5:
                                return new Date(janFourth.getFullYear() - 1, 11, 31);
                            case 6:
                                return new Date(janFourth.getFullYear() - 1, 11, 30);
                        }
                    }
                    function getWeekBasedYear(date2) {
                        var thisDate = addDays(new Date(date2.tm_year + 1900, 0, 1), date2.tm_yday);
                        var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
                        var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
                        var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
                        var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
                        if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
                            if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) return thisDate.getFullYear() + 1;
                            return thisDate.getFullYear();
                        }
                        return thisDate.getFullYear() - 1;
                    }
                    var EXPANSION_RULES_2 = {
                        "%a": (date2)=>WEEKDAYS[date2.tm_wday].substring(0, 3),
                        "%A": (date2)=>WEEKDAYS[date2.tm_wday],
                        "%b": (date2)=>MONTHS[date2.tm_mon].substring(0, 3),
                        "%B": (date2)=>MONTHS[date2.tm_mon],
                        "%C": (date2)=>{
                            var year = date2.tm_year + 1900;
                            return leadingNulls(year / 100 | 0, 2);
                        },
                        "%d": (date2)=>leadingNulls(date2.tm_mday, 2),
                        "%e": (date2)=>leadingSomething(date2.tm_mday, 2, " "),
                        "%g": (date2)=>getWeekBasedYear(date2).toString().substring(2),
                        "%G": (date2)=>getWeekBasedYear(date2),
                        "%H": (date2)=>leadingNulls(date2.tm_hour, 2),
                        "%I": (date2)=>{
                            var twelveHour = date2.tm_hour;
                            if (twelveHour == 0) twelveHour = 12;
                            else if (twelveHour > 12) twelveHour -= 12;
                            return leadingNulls(twelveHour, 2);
                        },
                        "%j": (date2)=>leadingNulls(date2.tm_mday + arraySum(isLeapYear(date2.tm_year + 1900) ? MONTH_DAYS_LEAP : MONTH_DAYS_REGULAR, date2.tm_mon - 1), 3),
                        "%m": (date2)=>leadingNulls(date2.tm_mon + 1, 2),
                        "%M": (date2)=>leadingNulls(date2.tm_min, 2),
                        "%n": ()=>"\n",
                        "%p": (date2)=>{
                            if (date2.tm_hour >= 0 && date2.tm_hour < 12) return "AM";
                            return "PM";
                        },
                        "%S": (date2)=>leadingNulls(date2.tm_sec, 2),
                        "%t": ()=>"	",
                        "%u": (date2)=>date2.tm_wday || 7,
                        "%U": (date2)=>{
                            var days = date2.tm_yday + 7 - date2.tm_wday;
                            return leadingNulls(Math.floor(days / 7), 2);
                        },
                        "%V": (date2)=>{
                            var val = Math.floor((date2.tm_yday + 7 - (date2.tm_wday + 6) % 7) / 7);
                            if ((date2.tm_wday + 371 - date2.tm_yday - 2) % 7 <= 2) val++;
                            if (!val) {
                                val = 52;
                                var dec31 = (date2.tm_wday + 7 - date2.tm_yday - 1) % 7;
                                if (dec31 == 4 || dec31 == 5 && isLeapYear(date2.tm_year % 400 - 1)) val++;
                            } else if (val == 53) {
                                var jan1 = (date2.tm_wday + 371 - date2.tm_yday) % 7;
                                if (jan1 != 4 && (jan1 != 3 || !isLeapYear(date2.tm_year))) val = 1;
                            }
                            return leadingNulls(val, 2);
                        },
                        "%w": (date2)=>date2.tm_wday,
                        "%W": (date2)=>{
                            var days = date2.tm_yday + 7 - (date2.tm_wday + 6) % 7;
                            return leadingNulls(Math.floor(days / 7), 2);
                        },
                        "%y": (date2)=>(date2.tm_year + 1900).toString().substring(2),
                        "%Y": (date2)=>date2.tm_year + 1900,
                        "%z": (date2)=>{
                            var off = date2.tm_gmtoff;
                            var ahead = off >= 0;
                            off = Math.abs(off) / 60;
                            off = off / 60 * 100 + off % 60;
                            return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
                        },
                        "%Z": (date2)=>date2.tm_zone,
                        "%%": ()=>"%"
                    };
                    pattern = pattern.replace(/%%/g, "\0\0");
                    for(var rule in EXPANSION_RULES_2)if (pattern.includes(rule)) pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
                    pattern = pattern.replace(/\0\0/g, "%");
                    var bytes = intArrayFromString(pattern, false);
                    if (bytes.length > maxsize) return 0;
                    writeArrayToMemory(bytes, s);
                    return bytes.length - 1;
                }
                function _strftime_l(s, maxsize, format, tm, loc) {
                    s >>>= 0;
                    maxsize >>>= 0;
                    format >>>= 0;
                    tm >>>= 0;
                    loc >>>= 0;
                    return _strftime(s, maxsize, format, tm);
                }
                InternalError = Module["InternalError"] = class InternalError extends Error {
                    constructor(message){
                        super(message);
                        this.name = "InternalError";
                    }
                };
                embind_init_charCodes();
                BindingError = Module["BindingError"] = class BindingError extends Error {
                    constructor(message){
                        super(message);
                        this.name = "BindingError";
                    }
                };
                init_ClassHandle();
                init_embind();
                init_RegisteredPointer();
                UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
                handleAllocatorInit();
                init_emval();
                var FSNode = function(parent, name, mode, rdev) {
                    if (!parent) parent = this;
                    this.parent = parent;
                    this.mount = parent.mount;
                    this.mounted = null;
                    this.id = FS.nextInode++;
                    this.name = name;
                    this.mode = mode;
                    this.node_ops = {};
                    this.stream_ops = {};
                    this.rdev = rdev;
                };
                var readMode = 365;
                var writeMode = 146;
                Object.defineProperties(FSNode.prototype, {
                    read: {
                        get: function() {
                            return (this.mode & readMode) === readMode;
                        },
                        set: function(val) {
                            val ? this.mode |= readMode : this.mode &= ~readMode;
                        }
                    },
                    write: {
                        get: function() {
                            return (this.mode & writeMode) === writeMode;
                        },
                        set: function(val) {
                            val ? this.mode |= writeMode : this.mode &= ~writeMode;
                        }
                    },
                    isFolder: {
                        get: function() {
                            return FS.isDir(this.mode);
                        }
                    },
                    isDevice: {
                        get: function() {
                            return FS.isChrdev(this.mode);
                        }
                    }
                });
                FS.FSNode = FSNode;
                FS.createPreloadedFile = FS_createPreloadedFile;
                FS.staticInit();
                var wasmImports = {
                    f: ___cxa_throw,
                    Y: __embind_finalize_value_array,
                    p: __embind_finalize_value_object,
                    H: __embind_register_bigint,
                    W: __embind_register_bool,
                    i: __embind_register_class,
                    h: __embind_register_class_constructor,
                    b: __embind_register_class_function,
                    V: __embind_register_emval,
                    z: __embind_register_float,
                    c: __embind_register_function,
                    s: __embind_register_integer,
                    m: __embind_register_memory_view,
                    A: __embind_register_std_string,
                    w: __embind_register_std_wstring,
                    Z: __embind_register_value_array,
                    n: __embind_register_value_array_element,
                    q: __embind_register_value_object,
                    d: __embind_register_value_object_field,
                    X: __embind_register_void,
                    P: __emscripten_get_now_is_monotonic,
                    l: __emval_as,
                    v: __emval_call,
                    a: __emval_decref,
                    y: __emval_get_global,
                    j: __emval_get_property,
                    r: __emval_incref,
                    D: __emval_instanceof,
                    x: __emval_is_number,
                    C: __emval_is_string,
                    B: __emval_new_array,
                    g: __emval_new_cstring,
                    t: __emval_new_object,
                    k: __emval_run_destructors,
                    o: __emval_set_property,
                    e: __emval_take_value,
                    F: __gmtime_js,
                    G: __localtime_js,
                    N: __tzset_js,
                    u: _abort,
                    Q: _emscripten_date_now,
                    U: _emscripten_memcpy_big,
                    M: _emscripten_resize_heap,
                    S: _environ_get,
                    T: _environ_sizes_get,
                    K: _fd_close,
                    R: _fd_fdstat_get,
                    L: _fd_read,
                    E: _fd_seek,
                    O: _fd_write,
                    I: _getentropy,
                    J: _strftime_l
                };
                var asm = createWasm();
                var ___wasm_call_ctors = ()=>(___wasm_call_ctors = wasmExports["$"])();
                var _free = (a0)=>(_free = wasmExports["aa"])(a0);
                var _malloc = (a0)=>(_malloc = wasmExports["ba"])(a0);
                var ___getTypeName = (a0)=>(___getTypeName = wasmExports["da"])(a0);
                var __embind_initialize_bindings = Module["__embind_initialize_bindings"] = ()=>(__embind_initialize_bindings = Module["__embind_initialize_bindings"] = wasmExports["ea"])();
                var ___errno_location = ()=>(___errno_location = wasmExports["__errno_location"])();
                var ___cxa_increment_exception_refcount = (a0)=>(___cxa_increment_exception_refcount = wasmExports["__cxa_increment_exception_refcount"])(a0);
                var ___cxa_is_pointer_type = (a0)=>(___cxa_is_pointer_type = wasmExports["fa"])(a0);
                var dynCall_jiji = Module["dynCall_jiji"] = (a0, a1, a2, a3, a4)=>(dynCall_jiji = Module["dynCall_jiji"] = wasmExports["ga"])(a0, a1, a2, a3, a4);
                var dynCall_viijii = Module["dynCall_viijii"] = (a0, a1, a2, a3, a4, a5, a6)=>(dynCall_viijii = Module["dynCall_viijii"] = wasmExports["ha"])(a0, a1, a2, a3, a4, a5, a6);
                var dynCall_iiiiij = Module["dynCall_iiiiij"] = (a0, a1, a2, a3, a4, a5, a6)=>(dynCall_iiiiij = Module["dynCall_iiiiij"] = wasmExports["ia"])(a0, a1, a2, a3, a4, a5, a6);
                var dynCall_iiiiijj = Module["dynCall_iiiiijj"] = (a0, a1, a2, a3, a4, a5, a6, a7, a8)=>(dynCall_iiiiijj = Module["dynCall_iiiiijj"] = wasmExports["ja"])(a0, a1, a2, a3, a4, a5, a6, a7, a8);
                var dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9)=>(dynCall_iiiiiijj = Module["dynCall_iiiiiijj"] = wasmExports["ka"])(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
                function applySignatureConversions(exports2) {
                    exports2 = Object.assign({}, exports2);
                    var makeWrapper_pp = (f)=>(a0)=>f(a0) >>> 0;
                    var makeWrapper_p = (f)=>()=>f() >>> 0;
                    exports2["malloc"] = makeWrapper_pp(exports2["malloc"]);
                    exports2["__getTypeName"] = makeWrapper_pp(exports2["__getTypeName"]);
                    exports2["__errno_location"] = makeWrapper_p(exports2["__errno_location"]);
                    exports2["stackSave"] = makeWrapper_p(exports2["stackSave"]);
                    exports2["stackAlloc"] = makeWrapper_pp(exports2["stackAlloc"]);
                    return exports2;
                }
                var calledRun;
                dependenciesFulfilled = function runCaller() {
                    if (!calledRun) run();
                    if (!calledRun) dependenciesFulfilled = runCaller;
                };
                function run() {
                    if (runDependencies > 0) return;
                    preRun();
                    if (runDependencies > 0) return;
                    function doRun() {
                        if (calledRun) return;
                        calledRun = true;
                        Module["calledRun"] = true;
                        if (ABORT) return;
                        initRuntime();
                        readyPromiseResolve(Module);
                        if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                        postRun();
                    }
                    if (Module["setStatus"]) {
                        Module["setStatus"]("Running...");
                        setTimeout(function() {
                            setTimeout(function() {
                                Module["setStatus"]("");
                            }, 1);
                            doRun();
                        }, 1);
                    } else doRun();
                }
                if (Module["preInit"]) {
                    if (typeof Module["preInit"] == "function") Module["preInit"] = [
                        Module["preInit"]
                    ];
                    while(Module["preInit"].length > 0)Module["preInit"].pop()();
                }
                run();
                return moduleArg.ready;
            };
        })();
        if (typeof exports === "object" && typeof module === "object") module.exports = WebIFCWasm2;
        else if (typeof define === "function" && define["amd"]) define([], ()=>WebIFCWasm2);
    }
});
// dist/ifc-schema.ts
var $3b8da494b8e92f36$export$9be4fc8b4df03494 = 2149462589;
var $3b8da494b8e92f36$export$25da0834f0fe8381 = 1805707277;
var $3b8da494b8e92f36$export$b351cb3900482c09 = 950732822;
var $3b8da494b8e92f36$export$bd133ea5f34ea500 = 4075327185;
var $3b8da494b8e92f36$export$a28e777adc863a9c = 1209108979;
var $3b8da494b8e92f36$export$595be83aed3574c2 = 3457685358;
var $3b8da494b8e92f36$export$609fe2ac166b9d33 = 4157543285;
var $3b8da494b8e92f36$export$3f77e3ee5b80b904 = 2798247006;
var $3b8da494b8e92f36$export$aa785ee641c5a60 = 1790229001;
var $3b8da494b8e92f36$export$29ab5759b462d9ba = 525895558;
var $3b8da494b8e92f36$export$5fadc755628e6c94 = 1774176899;
var $3b8da494b8e92f36$export$c8c2575022fdd0c7 = 1275358634;
var $3b8da494b8e92f36$export$97b0993a31b60a9a = 2541165894;
var $3b8da494b8e92f36$export$9be5b280fc4f39c5 = 3701338814;
var $3b8da494b8e92f36$export$4e3204057f9a77f6 = 2195413836;
var $3b8da494b8e92f36$export$5d73a2a8668758eb = 937566702;
var $3b8da494b8e92f36$export$867f90ce0e107952 = 1683019596;
var $3b8da494b8e92f36$export$ac0bd00559531f44 = 2314439260;
var $3b8da494b8e92f36$export$2af46588094a0b8c = 1500781891;
var $3b8da494b8e92f36$export$52990bf33542b7b9 = 3683503648;
var $3b8da494b8e92f36$export$ab0d814f7a583288 = 4065007721;
var $3b8da494b8e92f36$export$9e289eb0d30be70b = 1718600412;
var $3b8da494b8e92f36$export$54636c09adeef529 = 51269191;
var $3b8da494b8e92f36$export$96f21ffcc8edf8e7 = 2593997549;
var $3b8da494b8e92f36$export$47b777dc7f0906ad = 3458127941;
var $3b8da494b8e92f36$export$85ff8dc335ef66a5 = 3345633955;
var $3b8da494b8e92f36$export$7a3d2d6c9b283f9a = 1278329552;
var $3b8da494b8e92f36$export$3f090b537990bddb = 2591213694;
var $3b8da494b8e92f36$export$283673331de46adb = 2726807636;
var $3b8da494b8e92f36$export$3f3920510a1fd6e8 = 743184107;
var $3b8da494b8e92f36$export$15cb62bd5588b93a = 2016195849;
var $3b8da494b8e92f36$export$e17e98f491a61ae1 = 857959152;
var $3b8da494b8e92f36$export$bcbc4415b4d8f50a = 2281867870;
var $3b8da494b8e92f36$export$f254493ff9fe5b0f = 2645777649;
var $3b8da494b8e92f36$export$ab657c3e59b181f9 = 232962298;
var $3b8da494b8e92f36$export$377d6b28593981bf = 296282323;
var $3b8da494b8e92f36$export$88a9c2ff32d12a60 = 603696268;
var $3b8da494b8e92f36$export$9fcf1895d7dd1b30 = 3490877962;
var $3b8da494b8e92f36$export$a62796ae9901bd4f = 1460886941;
var $3b8da494b8e92f36$export$d74edf1cd3c6f7f2 = 2801250643;
var $3b8da494b8e92f36$export$1f44ed9b84de118a = 58845555;
var $3b8da494b8e92f36$export$43e511e39ec9293a = 361837227;
var $3b8da494b8e92f36$export$5bd9025d0db5daef = 2757832317;
var $3b8da494b8e92f36$export$1e4377caac10a898 = 3477203348;
var $3b8da494b8e92f36$export$6dee35e628e1a7b5 = 993287707;
var $3b8da494b8e92f36$export$2d8c48dbc0103786 = 846465480;
var $3b8da494b8e92f36$export$16a9e6464b93c869 = 3471399674;
var $3b8da494b8e92f36$export$1be59ce426ba974c = 408310005;
var $3b8da494b8e92f36$export$ba33028e4b603d89 = 2190458107;
var $3b8da494b8e92f36$export$82de3c9092a72762 = 3467162246;
var $3b8da494b8e92f36$export$269ff0eb6c4928d4 = 2766185779;
var $3b8da494b8e92f36$export$7232b1a3d29710c7 = 3211557302;
var $3b8da494b8e92f36$export$939b039427879826 = 1755127002;
var $3b8da494b8e92f36$export$e30e73d0c2c8421b = 2133746277;
var $3b8da494b8e92f36$export$dac1de8ef0193f39 = 200335297;
var $3b8da494b8e92f36$export$cbdb73f5af2e0f69 = 96294661;
var $3b8da494b8e92f36$export$a1437333d6791ff5 = 3972513137;
var $3b8da494b8e92f36$export$867dbf69bb2471b8 = 3665567075;
var $3b8da494b8e92f36$export$d2fe22619afae4f0 = 2169031380;
var $3b8da494b8e92f36$export$ea8df15a5b8c9a5 = 1364037233;
var $3b8da494b8e92f36$export$d514a77dd77bff7 = 1245737093;
var $3b8da494b8e92f36$export$2a0ed13d0e90c19a = 3054510233;
var $3b8da494b8e92f36$export$7b08b803f14ae007 = 2815919920;
var $3b8da494b8e92f36$export$8100c055aa68865f = 4042175685;
var $3b8da494b8e92f36$export$85ab6b4ac23fd839 = 2642773653;
var $3b8da494b8e92f36$export$8149b8a16a07a398 = 2260317790;
var $3b8da494b8e92f36$export$3d0dbf8aa0b178a2 = 929793134;
var $3b8da494b8e92f36$export$290d4c0285ad77cb = 2395907400;
var $3b8da494b8e92f36$export$65a10d1876a3619a = 2095195183;
var $3b8da494b8e92f36$export$6925700041a94e89 = 765770214;
var $3b8da494b8e92f36$export$f55e2f5693021465 = 2615040989;
var $3b8da494b8e92f36$export$a0c0bc07513eab23 = 3114022597;
var $3b8da494b8e92f36$export$96f8439ffe92b77b = 1648970520;
var $3b8da494b8e92f36$export$88064d60baba7183 = 3177669450;
var $3b8da494b8e92f36$export$3ab157df675489fb = 1753493141;
var $3b8da494b8e92f36$export$6e76af2d697d0c1a = 1052454078;
var $3b8da494b8e92f36$export$6a4aed160d569213 = 2173214787;
var $3b8da494b8e92f36$export$8ec264b6801dbb88 = 3341486342;
var $3b8da494b8e92f36$export$8ca4caddf8f50516 = 102610177;
var $3b8da494b8e92f36$export$9ab762fbe4dc30f = 3531705166;
var $3b8da494b8e92f36$export$785d24646dfb2ad5 = 3124614049;
var $3b8da494b8e92f36$export$43640c9aa832423c = 4017473158;
var $3b8da494b8e92f36$export$570d2bafabb7811d = 1477762836;
var $3b8da494b8e92f36$export$5b2c3ed463fec8c9 = 2486716878;
var $3b8da494b8e92f36$export$d30172e6bbdcb382 = 286949696;
var $3b8da494b8e92f36$export$b81c1702eb4666c0 = 151039812;
var $3b8da494b8e92f36$export$d71cae810dd3b400 = 2755797622;
var $3b8da494b8e92f36$export$401faaf2ac2ef3ce = 2095003142;
var $3b8da494b8e92f36$export$3c666c140b752c9b = 503418787;
var $3b8da494b8e92f36$export$c69159b0cc9fe67c = 3086160713;
var $3b8da494b8e92f36$export$9741250d7ff6a677 = 1307019551;
var $3b8da494b8e92f36$export$cebb2df221bf6656 = 2128979029;
var $3b8da494b8e92f36$export$68dadc2c35d2224f = 191860431;
var $3b8da494b8e92f36$export$9c08b66352ec00bd = 1243674935;
var $3b8da494b8e92f36$export$a25c5ed25eda93ff = 3258342251;
var $3b8da494b8e92f36$export$d3daf1d75f3c7375 = 2054016361;
var $3b8da494b8e92f36$export$71c2752790538657 = 3192672207;
var $3b8da494b8e92f36$export$4d04be9e1bfaad65 = 3686016028;
var $3b8da494b8e92f36$export$80c31b8fdf7cf141 = 3809634241;
var $3b8da494b8e92f36$export$642bd0afe0e5e7e1 = 1939436016;
var $3b8da494b8e92f36$export$f6bfa38124957f7b = 2679005408;
var $3b8da494b8e92f36$export$e76e89b4b50d9071 = 3358199106;
var $3b8da494b8e92f36$export$3bbc3e3fb49b3fcb = 983778844;
var $3b8da494b8e92f36$export$af17755d3b6141ee = 2589826445;
var $3b8da494b8e92f36$export$b42969202203fb4a = 1158859006;
var $3b8da494b8e92f36$export$2393e663a3fbd438 = 3113092358;
var $3b8da494b8e92f36$export$4902c5e80eba64d5 = 3064340077;
var $3b8da494b8e92f36$export$9a9b8bc60fbcbf70 = 3044325142;
var $3b8da494b8e92f36$export$a4b124fdb7e28dd4 = 1361398929;
var $3b8da494b8e92f36$export$c30d6c8b7e93407 = 2590844177;
var $3b8da494b8e92f36$export$a9bd17591ef400b7 = 2715512545;
var $3b8da494b8e92f36$export$466086c12fbe0636 = 1102727119;
var $3b8da494b8e92f36$export$404aafc1f49e5600 = 2078135608;
var $3b8da494b8e92f36$export$e14143426b372ca8 = 2506197118;
var $3b8da494b8e92f36$export$78a0ae5a4c035bc3 = 2951915441;
var $3b8da494b8e92f36$export$39ea62a148f7a8bc = 3790457270;
var $3b8da494b8e92f36$export$b23063b898cdf65 = 2093906313;
var $3b8da494b8e92f36$export$74a46cedf8715d03 = 3818826038;
var $3b8da494b8e92f36$export$6fb9bda01cf9a16b = 1827137117;
var $3b8da494b8e92f36$export$ca0a65e9f9f021b9 = 69416015;
var $3b8da494b8e92f36$export$9a93db2d678c9f6b = 524656162;
var $3b8da494b8e92f36$export$9160990506cd70fb = 4134073009;
var $3b8da494b8e92f36$export$563e544f3e5955af = 1514641115;
var $3b8da494b8e92f36$export$c108f0b29fe65f49 = 300323983;
var $3b8da494b8e92f36$export$55e61e244712eb62 = 86635668;
var $3b8da494b8e92f36$export$61b437177179e88 = 94842927;
var $3b8da494b8e92f36$export$4bce54e9e43bd7e6 = 1778710042;
var $3b8da494b8e92f36$export$be3c063267f9ec1f = 3238673880;
var $3b8da494b8e92f36$export$a78a0d0f47f4f274 = 3812528620;
var $3b8da494b8e92f36$export$879ec093d877facc = 2991860651;
var $3b8da494b8e92f36$export$be55df53e7a4683b = 1867003952;
var $3b8da494b8e92f36$export$196662710a8f67be = 2735952531;
var $3b8da494b8e92f36$export$5d5268bedd0ac035 = 2650437152;
var $3b8da494b8e92f36$export$73fe37ba4ce02b70 = 632304761;
var $3b8da494b8e92f36$export$7986b4edb0bc5f16 = 360377573;
var $3b8da494b8e92f36$export$d5941839b793e74d = 4182062534;
var $3b8da494b8e92f36$export$b7bf655d2c31d0da = 3699917729;
var $3b8da494b8e92f36$export$ba9b533eb93c61e6 = 1971632696;
var $3b8da494b8e92f36$export$c6db94a21532bc0 = 2680139844;
var $3b8da494b8e92f36$export$fc44e3e1a7a655b8 = 24726584;
var $3b8da494b8e92f36$export$8b38478acd341f50 = 3693000487;
var $3b8da494b8e92f36$export$85aee7ae7c03d05a = 3460952963;
var $3b8da494b8e92f36$export$e3e5acb3f314f36e = 3999819293;
var $3b8da494b8e92f36$export$c9e95b59bddb461b = 3314249567;
var $3b8da494b8e92f36$export$621164991f057b60 = 4196446775;
var $3b8da494b8e92f36$export$15d220a8d3840c2b = 325726236;
var $3b8da494b8e92f36$export$148542c71c2cd1c6 = 3425753595;
var $3b8da494b8e92f36$export$882807e675fb9068 = 991950508;
var $3b8da494b8e92f36$export$aea7c0bc4ec470d9 = 3798194928;
var $3b8da494b8e92f36$export$58e8ff1cdcf5d006 = 3290496277;
var $3b8da494b8e92f36$export$fa079470b767c651 = 1383356374;
var $3b8da494b8e92f36$export$bc6fb4287404ee80 = 2182337498;
var $3b8da494b8e92f36$export$cf79a786a1f31c67 = 234836483;
var $3b8da494b8e92f36$export$baebabf49e14381f = 2078563270;
var $3b8da494b8e92f36$export$fd80d94bec4f0a5b = 1638804497;
var $3b8da494b8e92f36$export$b9eca9ef3b8d6669 = 1154579445;
var $3b8da494b8e92f36$export$9c2743d05a45981d = 2696325953;
var $3b8da494b8e92f36$export$590a133adb265ce2 = 2713699986;
var $3b8da494b8e92f36$export$8ecb1acc5cef3623 = 2142170206;
var $3b8da494b8e92f36$export$510370982f2cd70b = 3376911765;
var $3b8da494b8e92f36$export$d913f9a28f897cb4 = 1077100507;
var $3b8da494b8e92f36$export$689c1ff4f7778216 = 3071239417;
var $3b8da494b8e92f36$export$a71ce1f807a99ffa = 479945903;
var $3b8da494b8e92f36$export$df9b2345d13dc8f2 = 3426335179;
var $3b8da494b8e92f36$export$7758680385d7f5d0 = 1502416096;
var $3b8da494b8e92f36$export$ac3368af3a97899c = 2940368186;
var $3b8da494b8e92f36$export$1571a6a1a0ef60d5 = 3203706013;
var $3b8da494b8e92f36$export$4e0003e3499b7937 = 3862327254;
var $3b8da494b8e92f36$export$3e99d4f5fb74344a = 1876633798;
var $3b8da494b8e92f36$export$13e708936da24a68 = 963979645;
var $3b8da494b8e92f36$export$621ee50854ea2931 = 644574406;
var $3b8da494b8e92f36$export$658f97b35e3ab77a = 3649138523;
var $3b8da494b8e92f36$export$c8107dc828f27d75 = 1662888072;
var $3b8da494b8e92f36$export$e09bab7a22edd350 = 317615605;
var $3b8da494b8e92f36$export$b885f77cbc299c4 = 1545765605;
var $3b8da494b8e92f36$export$32d390b4d2721141 = 4266260250;
var $3b8da494b8e92f36$export$65425f7fe03c67e3 = 3956297820;
var $3b8da494b8e92f36$export$63c3891ef0655b46 = 1530820697;
var $3b8da494b8e92f36$export$5c7124f036f5261b = 840318589;
var $3b8da494b8e92f36$export$77890d3c0e815d73 = 1953115116;
var $3b8da494b8e92f36$export$a319cba82d87c3cb = 618700268;
var $3b8da494b8e92f36$export$36865c33f6b928df = 2281632017;
var $3b8da494b8e92f36$export$a6d7d4ab29f210d8 = 3663046924;
var $3b8da494b8e92f36$export$930ecb71bb54f6b9 = 42703149;
var $3b8da494b8e92f36$export$4aad03902b9ab9b7 = 1894708472;
var $3b8da494b8e92f36$export$bf8da5dfd8f2bbd7 = 3599934289;
var $3b8da494b8e92f36$export$5988cb69223093bd = 33720170;
var $3b8da494b8e92f36$export$71a20a295551861d = 1027922057;
var $3b8da494b8e92f36$export$ae61b17b9a1def4f = 544395925;
var $3b8da494b8e92f36$export$21377908e11164b8 = 3649235739;
var $3b8da494b8e92f36$export$222e5cfe959e7091 = 550521510;
var $3b8da494b8e92f36$export$cbecbfc736c5fee6 = 146592293;
var $3b8da494b8e92f36$export$79a1ba43c7a549ce = 3818125796;
var $3b8da494b8e92f36$export$2594575309e586b5 = 4021432810;
var $3b8da494b8e92f36$export$6d6a87bbda8f8f8f = 1891881377;
var $3b8da494b8e92f36$export$3d4b06c2ec93a11c = 3992365140;
var $3b8da494b8e92f36$export$bde4b2f022aa3cc3 = 1763565496;
var $3b8da494b8e92f36$export$8f9be165ecf1e4df = 1946335990;
var $3b8da494b8e92f36$export$ae5ea07bb40f05a4 = 514975943;
var $3b8da494b8e92f36$export$d9ea6d65e35c77e6 = 506776471;
var $3b8da494b8e92f36$export$1b9d9b67f9494a = 710110818;
var $3b8da494b8e92f36$export$8ec901ef3dd34dee = 1950438474;
var $3b8da494b8e92f36$export$b27765c1626bd4e5 = 976884017;
var $3b8da494b8e92f36$export$9586a13e6aa3297b = 525669439;
var $3b8da494b8e92f36$export$30c0a743764a442d = 1770583370;
var $3b8da494b8e92f36$export$f3c5edda9fcffe08 = 2176059722;
var $3b8da494b8e92f36$export$bc2d1907fc896c9e = 679976338;
var $3b8da494b8e92f36$export$20d4cd77bb23839a = 3948183225;
var $3b8da494b8e92f36$export$fc1d66d7d457d0bd = 2568555532;
var $3b8da494b8e92f36$export$14f69d2c614ba0a3 = 2898700619;
var $3b8da494b8e92f36$export$3120d79bc0036ae8 = 1594536857;
var $3b8da494b8e92f36$export$27c232e08a5c1615 = 4230923436;
var $3b8da494b8e92f36$export$2430d0e5fe5a448e = 4228831410;
var $3b8da494b8e92f36$export$21e17a46032a87f8 = 1310830890;
var $3b8da494b8e92f36$export$c8c6cd13ee455751 = 24185140;
var $3b8da494b8e92f36$export$7ac92bdfbda997a6 = 4234616927;
var $3b8da494b8e92f36$export$261b3d86b8abacc9 = 1306400036;
var $3b8da494b8e92f36$export$6348979270e0ef76 = 4189326743;
var $3b8da494b8e92f36$export$fd146d5f53fefc87 = 2000195564;
var $3b8da494b8e92f36$export$9c60c9750bd86c93 = 3497074424;
var $3b8da494b8e92f36$export$a118d3359be4f9d8 = 1626504194;
var $3b8da494b8e92f36$export$a39811f2fb3014d9 = 3651464721;
var $3b8da494b8e92f36$export$df1aea6f3c3fdd3 = 1229763772;
var $3b8da494b8e92f36$export$e925431939456153 = 3665877780;
var $3b8da494b8e92f36$export$eae2f9556d21859d = 782932809;
var $3b8da494b8e92f36$export$889cc41214b5970c = 2735484536;
var $3b8da494b8e92f36$export$406ae3ea561cdfed = 1356537516;
var $3b8da494b8e92f36$export$25fbf7852b3a8a34 = 1290935644;
var $3b8da494b8e92f36$export$e545ccdc4ae42e81 = 1862484736;
var $3b8da494b8e92f36$export$c33f71f232dbf671 = 1441486842;
var $3b8da494b8e92f36$export$4f578206c5065f1f = 1033248425;
var $3b8da494b8e92f36$export$1721bccc01fce10a = 3381221214;
var $3b8da494b8e92f36$export$7ff49950c8e89377 = 2485787929;
var $3b8da494b8e92f36$export$ff5167510e50ee26 = 590820931;
var $3b8da494b8e92f36$export$1e82cbdcd9fe6ab9 = 3465909080;
var $3b8da494b8e92f36$export$6eda1fffe4033879 = 593015953;
var $3b8da494b8e92f36$export$702326c0288a963 = 4212018352;
var $3b8da494b8e92f36$export$aa97e6334e80a8ca = 3425423356;
var $3b8da494b8e92f36$export$301a7e858fe85036 = 823603102;
var $3b8da494b8e92f36$export$b2d243272d4e7e07 = 2165702409;
var $3b8da494b8e92f36$export$c2cca572ace0bab5 = 182550632;
var $3b8da494b8e92f36$export$ee5fe2a61985b27e = 388784114;
var $3b8da494b8e92f36$export$e2b249d4f45002ea = 536804194;
var $3b8da494b8e92f36$export$fa5b448c5eddeb03 = 3752311538;
var $3b8da494b8e92f36$export$2431f6624361f2ff = 1175146630;
var $3b8da494b8e92f36$export$e6abbc136a759ca9 = 1010789467;
var $3b8da494b8e92f36$export$9a0fe36b94f2528a = 222769930;
var $3b8da494b8e92f36$export$fd0b1b6c7ac86314 = 1794013214;
var $3b8da494b8e92f36$export$f192946650c793a8 = 2691318326;
var $3b8da494b8e92f36$export$6d2edf02bc3e05a2 = 4105526436;
var $3b8da494b8e92f36$export$c81b40a3be0ef8e7 = 917726184;
var $3b8da494b8e92f36$export$56da2f0cc849825c = 3633395639;
var $3b8da494b8e92f36$export$ec77e2918707a8a3 = 2879124712;
var $3b8da494b8e92f36$export$1bed1511641669cd = 25142252;
var $3b8da494b8e92f36$export$256a7ae6f2f20b7a = 3087945054;
var $3b8da494b8e92f36$export$6228cf2343baa399 = 4288193352;
var $3b8da494b8e92f36$export$104c0856e18167ed = 630975310;
var $3b8da494b8e92f36$export$bd8a03a55659160d = 4086658281;
var $3b8da494b8e92f36$export$4d5258657f2d3858 = 2295281155;
var $3b8da494b8e92f36$export$3c336c07a4f995a3 = 182646315;
var $3b8da494b8e92f36$export$6f871c8fa333e822 = 1426591983;
var $3b8da494b8e92f36$export$97f16789cdafafab = 819412036;
var $3b8da494b8e92f36$export$60cebc3132db61fc = 3415622556;
var $3b8da494b8e92f36$export$29c53ca64f3f47eb = 1003880860;
var $3b8da494b8e92f36$export$2a7fd01d7f217eea = 402227799;
var $3b8da494b8e92f36$export$f7b92a5686344918 = 264262732;
var $3b8da494b8e92f36$export$17b013543c080bda = 3310460725;
var $3b8da494b8e92f36$export$f8e3926daf5ae150 = 862014818;
var $3b8da494b8e92f36$export$965414a7c9f66c8e = 1904799276;
var $3b8da494b8e92f36$export$cdadba6e2525ae05 = 1360408905;
var $3b8da494b8e92f36$export$a71590cc0b132e81 = 3518393246;
var $3b8da494b8e92f36$export$9acab8bc6a12023d = 342316401;
var $3b8da494b8e92f36$export$78b19c4a252f3d7b = 562808652;
var $3b8da494b8e92f36$export$2f2a04037296b593 = 4074379575;
var $3b8da494b8e92f36$export$9af0ffdfaf8deb4b = 3640358203;
var $3b8da494b8e92f36$export$c1ab2755a348af2 = 4136498852;
var $3b8da494b8e92f36$export$f532c17f39683164 = 2272882330;
var $3b8da494b8e92f36$export$d80c5d49d2a19bfd = 3571504051;
var $3b8da494b8e92f36$export$668639329cae33ad = 3221913625;
var $3b8da494b8e92f36$export$8d5af027eaba9fc4 = 639361253;
var $3b8da494b8e92f36$export$8a82842e122232c = 3902619387;
var $3b8da494b8e92f36$export$7cb946b2ac41961c = 4217484030;
var $3b8da494b8e92f36$export$cd3804f140d65bc7 = 1051757585;
var $3b8da494b8e92f36$export$133c65ddb4b70017 = 3758799889;
var $3b8da494b8e92f36$export$e44afe3a7829791a = 635142910;
var $3b8da494b8e92f36$export$ab163798e2f775ed = 2938176219;
var $3b8da494b8e92f36$export$306fdfb2e1082660 = 32344328;
var $3b8da494b8e92f36$export$d912e9b49c740c82 = 2906023776;
var $3b8da494b8e92f36$export$ab6c764fe9bef52d = 277319702;
var $3b8da494b8e92f36$export$6c7de868663152ee = 2056796094;
var $3b8da494b8e92f36$export$e01e5cce8a3c1b24 = 177149247;
var $3b8da494b8e92f36$export$9deafe265cc260c9 = 1634111441;
var $3b8da494b8e92f36$export$df5d90a458391b35 = 486154966;
var $3b8da494b8e92f36$export$b6a8842980c23f65 = 4237592921;
var $3b8da494b8e92f36$export$7f972ab55f8adda0 = 4156078855;
var $3b8da494b8e92f36$export$41a1521485ab6317 = 4207607924;
var $3b8da494b8e92f36$export$9c3f5e24bcf64017 = 4292641817;
var $3b8da494b8e92f36$export$34d108d80727bc18 = 3179687236;
var $3b8da494b8e92f36$export$7ddb90dede515c81 = 3026737570;
var $3b8da494b8e92f36$export$4f4bf8c551fb73d5 = 3825984169;
var $3b8da494b8e92f36$export$5229b0f0c9a5bb88 = 812556717;
var $3b8da494b8e92f36$export$4c61bb3d56ddc107 = 1162798199;
var $3b8da494b8e92f36$export$57379c20a5f35b14 = 385403989;
var $3b8da494b8e92f36$export$39c19636f9173ccb = 1404847402;
var $3b8da494b8e92f36$export$273c14799d1e65d2 = 1999602285;
var $3b8da494b8e92f36$export$1dd798d580992210 = 3420628829;
var $3b8da494b8e92f36$export$f765133cc69cf269 = 3027962421;
var $3b8da494b8e92f36$export$53f51e3ca061719d = 3127900445;
var $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc = 1329646415;
var $3b8da494b8e92f36$export$bb3a10186aad9336 = 3053780830;
var $3b8da494b8e92f36$export$4adb715104a5828e = 2572171363;
var $3b8da494b8e92f36$export$d119e59d83beec72 = 1232101972;
var $3b8da494b8e92f36$export$eb15acbbc0d2cf08 = 90941305;
var $3b8da494b8e92f36$export$3feb97dc469b4d81 = 655969474;
var $3b8da494b8e92f36$export$9e9165f95050e15e = 738039164;
var $3b8da494b8e92f36$export$40058285857aae13 = 1156407060;
var $3b8da494b8e92f36$export$3b8d48227d708608 = 3612865200;
var $3b8da494b8e92f36$export$4df0321cc3536447 = 310824031;
var $3b8da494b8e92f36$export$6618e2639e992b4 = 3694346114;
var $3b8da494b8e92f36$export$3051e38f53a4ea7f = 144952367;
var $3b8da494b8e92f36$export$909c399c43b4565a = 2474470126;
var $3b8da494b8e92f36$export$540eb1154ef9932a = 1911478936;
var $3b8da494b8e92f36$export$85feca2a73d2d8f = 1437502449;
var $3b8da494b8e92f36$export$9b1fd3cec62df66d = 629592764;
var $3b8da494b8e92f36$export$f570b472a926491d = 76236018;
var $3b8da494b8e92f36$export$f77c50967a5433ae = 2176052936;
var $3b8da494b8e92f36$export$30cd12a6f9c4e81e = 4175244083;
var $3b8da494b8e92f36$export$23b97179eafd208b = 2068733104;
var $3b8da494b8e92f36$export$e74173267223d777 = 3319311131;
var $3b8da494b8e92f36$export$aef8a18f5e93c475 = 2188021234;
var $3b8da494b8e92f36$export$1d58c6b4a0c04096 = 1209101575;
var $3b8da494b8e92f36$export$4d77b1c4ed455124 = 484807127;
var $3b8da494b8e92f36$export$1590d3bdbcc096f = 3747195512;
var $3b8da494b8e92f36$export$7b69c20feaae0df5 = 2814081492;
var $3b8da494b8e92f36$export$62cf11b69e1e5438 = 2417008758;
var $3b8da494b8e92f36$export$22f423f0e05cb34b = 3242481149;
var $3b8da494b8e92f36$export$34a6baef290b91cd = 3205830791;
var $3b8da494b8e92f36$export$b200d13e7dff4623 = 400855858;
var $3b8da494b8e92f36$export$1c2f4ad96fea6d36 = 905975707;
var $3b8da494b8e92f36$export$19789af29bafa1b = 1677625105;
var $3b8da494b8e92f36$export$ab271d772829021c = 3296154744;
var $3b8da494b8e92f36$export$20641696240c6d20 = 2674252688;
var $3b8da494b8e92f36$export$8ebc99c73ee268ae = 2188180465;
var $3b8da494b8e92f36$export$2db5c9c97dd86736 = 1177604601;
var $3b8da494b8e92f36$export$356a8f063280f1fb = 39481116;
var $3b8da494b8e92f36$export$a8fb7937a6f31dcd = 1136057603;
var $3b8da494b8e92f36$export$8c7b4fc0454a715b = 2461110595;
var $3b8da494b8e92f36$export$5462a079c779a428 = 1532957894;
var $3b8da494b8e92f36$export$8e15250779a21ef = 4088093105;
var $3b8da494b8e92f36$export$ccb52ac6dd143ac7 = 4009809668;
var $3b8da494b8e92f36$export$9322f31e6030ab4a = 926996030;
var $3b8da494b8e92f36$export$fec6e80290b1bed0 = 2391383451;
var $3b8da494b8e92f36$export$4c91930f06c612f3 = 2415094496;
var $3b8da494b8e92f36$export$292060b67a56230e = 3081323446;
var $3b8da494b8e92f36$export$a023a3a19ecc9fa8 = 413509423;
var $3b8da494b8e92f36$export$dbd31b812d2eaf57 = 3101698114;
var $3b8da494b8e92f36$export$9a501468338c7167 = 3657597509;
var $3b8da494b8e92f36$export$e85d2db4954b8de1 = 2757150158;
var $3b8da494b8e92f36$export$7274fd8538766ba9 = 1004757350;
var $3b8da494b8e92f36$export$b31d2e8d2292dbf5 = 338393293;
var $3b8da494b8e92f36$export$2c822598b9767f32 = 1072016465;
var $3b8da494b8e92f36$export$d4787b648eef7e28 = 4074543187;
var $3b8da494b8e92f36$export$922fa769a539de57 = 2157484638;
var $3b8da494b8e92f36$export$ef31ba14dea6d94d = 2781568857;
var $3b8da494b8e92f36$export$c746bc8f9f204d89 = 2310774935;
var $3b8da494b8e92f36$export$52cd7ae850170c1c = 964333572;
var $3b8da494b8e92f36$export$7be85d9a50dbe60c = 683857671;
var $3b8da494b8e92f36$export$789f22e7812b8923 = 1469900589;
var $3b8da494b8e92f36$export$cf616a1a67553ce5 = 2839578677;
var $3b8da494b8e92f36$export$45d766a52c6751e8 = 1158309216;
var $3b8da494b8e92f36$export$14c6ae98e9d52fcb = 3079942009;
var $3b8da494b8e92f36$export$e31f8d74b6c6a890 = 1114901282;
var $3b8da494b8e92f36$export$85f2457f407ffd38 = 3113134337;
var $3b8da494b8e92f36$export$bcb97b473c8cf78d = 3946677679;
var $3b8da494b8e92f36$export$569b2f842286694a = 2571569899;
var $3b8da494b8e92f36$export$e640d953799bf92a = 3493046030;
var $3b8da494b8e92f36$export$eef1bb90f7dbe007 = 1509553395;
var $3b8da494b8e92f36$export$5efb46f971d100c = 1893162501;
var $3b8da494b8e92f36$export$6e8c566b0d60ea1b = 2853485674;
var $3b8da494b8e92f36$export$d14ef3fe75da3f4 = 4148101412;
var $3b8da494b8e92f36$export$1ff9841360300191 = 132023988;
var $3b8da494b8e92f36$export$1388d94b5491cc07 = 2397081782;
var $3b8da494b8e92f36$export$e95d4dc7a2f8cef = 2323601079;
var $3b8da494b8e92f36$export$a633a7857c4afb8b = 1213902940;
var $3b8da494b8e92f36$export$b545dd0102a18723 = 1525564444;
var $3b8da494b8e92f36$export$140202a799be714a = 4105962743;
var $3b8da494b8e92f36$export$d615d46de51ad773 = 2185764099;
var $3b8da494b8e92f36$export$c894d0a8a6cbf76f = 15328376;
var $3b8da494b8e92f36$export$825f7cab9140cf42 = 3875453745;
var $3b8da494b8e92f36$export$2b01c18e55370ff = 3893394355;
var $3b8da494b8e92f36$export$afecab087ae8f2 = 2197970202;
var $3b8da494b8e92f36$export$c954e3b540b1cc1d = 167062518;
var $3b8da494b8e92f36$export$14920f38b00f3073 = 2887950389;
var $3b8da494b8e92f36$export$e7d9f6ef76ebe73f = 2603310189;
var $3b8da494b8e92f36$export$45f4c4bef325c6de = 1635779807;
var $3b8da494b8e92f36$export$2ecfbeca9fa8edbd = 2916149573;
var $3b8da494b8e92f36$export$8bcad0fd81ccef4e = 1935646853;
var $3b8da494b8e92f36$export$be55db5658261c24 = 2387106220;
var $3b8da494b8e92f36$export$b09c679f1085725a = 3206491090;
var $3b8da494b8e92f36$export$c71362c4ed185b32 = 699246055;
var $3b8da494b8e92f36$export$5b70e847d8154d66 = 4095615324;
var $3b8da494b8e92f36$export$c40954ae09567ff2 = 603775116;
var $3b8da494b8e92f36$export$7c3b7ecc8dd17171 = 4015995234;
var $3b8da494b8e92f36$export$b1ab780de012c3ba = 2481509218;
var $3b8da494b8e92f36$export$7b95f940068bb1c3 = 463610769;
var $3b8da494b8e92f36$export$8ab37c04c221437e = 710998568;
var $3b8da494b8e92f36$export$cc78bfb1fd84dc0c = 1412071761;
var $3b8da494b8e92f36$export$6dac613d32d3427f = 3663146110;
var $3b8da494b8e92f36$export$fe015439a6fa96b6 = 3243963512;
var $3b8da494b8e92f36$export$5478cb2985eabb5a = 816062949;
var $3b8da494b8e92f36$export$96504c3b59e8a728 = 1521410863;
var $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9 = 3523091289;
var $3b8da494b8e92f36$export$bb6d5e50e6dcbd85 = 427948657;
var $3b8da494b8e92f36$export$dfec9be971c6e8a5 = 307848117;
var $3b8da494b8e92f36$export$f650b9b610878411 = 1462361463;
var $3b8da494b8e92f36$export$4ea4a40a0b69b18b = 2565941209;
var $3b8da494b8e92f36$export$d68e05a23c1f8359 = 1027710054;
var $3b8da494b8e92f36$export$23fb84fb575e1cb4 = 3521284610;
var $3b8da494b8e92f36$export$67177aa5e10d7edd = 492091185;
var $3b8da494b8e92f36$export$4f9b13f55d01f662 = 653396225;
var $3b8da494b8e92f36$export$c81d279acf1b12b4 = 569719735;
var $3b8da494b8e92f36$export$f27d665fae434b5e = 3967405729;
var $3b8da494b8e92f36$export$3a90cd7486e7bfc7 = 1682466193;
var $3b8da494b8e92f36$export$bbeb77fbb7735b23 = 428585644;
var $3b8da494b8e92f36$export$e759ffb34c88cdbb = 2294589976;
var $3b8da494b8e92f36$export$a15ad7bc84af942e = 178912537;
var $3b8da494b8e92f36$export$61d02055f294889e = 4095422895;
var $3b8da494b8e92f36$export$cc878395e6134df2 = 2652556860;
var $3b8da494b8e92f36$export$f03ac9a18a5a000 = 2804161546;
var $3b8da494b8e92f36$export$599b343cb1d64b49 = 4024345920;
var $3b8da494b8e92f36$export$4bb861b4bba551ce = 2629017746;
var $3b8da494b8e92f36$export$8c2a8073f4f77e7e = 1815067380;
var $3b8da494b8e92f36$export$ae975bd6a53dc3da = 3419103109;
var $3b8da494b8e92f36$export$3d378e730e40374 = 2574617495;
var $3b8da494b8e92f36$export$e5527fc80680ccac = 2059837836;
var $3b8da494b8e92f36$export$d0a6287d5fe2b0d0 = 1675464909;
var $3b8da494b8e92f36$export$24551edc0d1c7c9e = 574549367;
var $3b8da494b8e92f36$export$55b4788f85a51e1a = 3406155212;
var $3b8da494b8e92f36$export$b05d4b54ea7217ba = 3698973494;
var $3b8da494b8e92f36$export$60411d6f391d4743 = 3736923433;
var $3b8da494b8e92f36$export$70128586019a4a85 = 901063453;
var $3b8da494b8e92f36$export$9462ca86e16364d3 = 1096409881;
var $3b8da494b8e92f36$export$995f2435226e1b6a = 1042787934;
var $3b8da494b8e92f36$export$acffd400493c189c = 1608871552;
var $3b8da494b8e92f36$export$13de02c11c361011 = 2943643501;
var $3b8da494b8e92f36$export$3eb2ff47f0213310 = 2090586900;
var $3b8da494b8e92f36$export$2abd1abb4fbec99a = 1482703590;
var $3b8da494b8e92f36$export$c262d6aa9cc45c1e = 3778827333;
var $3b8da494b8e92f36$export$6ff606ccfc58f5bb = 2998442950;
var $3b8da494b8e92f36$export$e2f0b7f5e626526f = 853536259;
var $3b8da494b8e92f36$export$ac428444f42ac73b = 3404854881;
var $3b8da494b8e92f36$export$9da0ae2bdea157b5 = 3079605661;
var $3b8da494b8e92f36$export$b1bef060ce5931d8 = 2852063980;
var $3b8da494b8e92f36$export$bf1ff376c816a889 = 3708119e3;
var $3b8da494b8e92f36$export$a568399b60500b43 = 1585845231;
var $3b8da494b8e92f36$export$12c8486b22f747b4 = 2133299955;
var $3b8da494b8e92f36$export$7c4f7aaa3a160deb = 1437953363;
var $3b8da494b8e92f36$export$5c5bfbea1f9750f0 = 3570813810;
var $3b8da494b8e92f36$export$dc995d42867b8d56 = 1437805879;
var $3b8da494b8e92f36$export$971eec9c9d45cdbc = 297599258;
var $3b8da494b8e92f36$export$1c250d1efa52f027 = 211053100;
var $3b8da494b8e92f36$export$c792ec963053411b = 2713554722;
var $3b8da494b8e92f36$export$447b3f598cf8325d = 3285139300;
var $3b8da494b8e92f36$export$c259b6fe2d03e118 = 1236880293;
var $3b8da494b8e92f36$export$a14a34c7c94d4c15 = 1199560280;
var $3b8da494b8e92f36$export$eb38190c7ccf4599 = 3611470254;
var $3b8da494b8e92f36$export$25d64be31bf108b = 2771591690;
var $3b8da494b8e92f36$export$cfb1203a57a5f31c = 1549132990;
var $3b8da494b8e92f36$export$95952426b5ed4c8d = 2043862942;
var $3b8da494b8e92f36$export$ebcd8907887dc222 = 2934153892;
var $3b8da494b8e92f36$export$aaf8576a4abe9819 = 609421318;
var $3b8da494b8e92f36$export$f8bd1434641262e3 = 3478079324;
var $3b8da494b8e92f36$export$da63624fcec21f0e = 1054537805;
var $3b8da494b8e92f36$export$6bf787c6cb4ec4c9 = 2439245199;
var $3b8da494b8e92f36$export$a21e5fbbc72b6ce5 = 2433181523;
var $3b8da494b8e92f36$export$815e5f848af6bac = 3915482550;
var $3b8da494b8e92f36$export$4896f9f5272f8bda = 986844984;
var $3b8da494b8e92f36$export$3ba9c26e1e245f60 = 3843373140;
var $3b8da494b8e92f36$export$377158268bac142a = 677532197;
var $3b8da494b8e92f36$export$8071277a37ba0309 = 1507914824;
var $3b8da494b8e92f36$export$cb4089fd00927e5e = 552965576;
var $3b8da494b8e92f36$export$ce700270dbd3f574 = 164193824;
var $3b8da494b8e92f36$export$90624260d4eb2c6c = 2235152071;
var $3b8da494b8e92f36$export$36935a2a2087e3a2 = 1847252529;
var $3b8da494b8e92f36$export$54b851f34521942c = 760658860;
var $3b8da494b8e92f36$export$9c8e8646198c2dbd = 3057273783;
var $3b8da494b8e92f36$export$99f65669fcd3b135 = 4294318154;
var $3b8da494b8e92f36$export$951f4c5b515d70d2 = 1466758467;
var $3b8da494b8e92f36$export$ecb047565e884e65 = 1785450214;
var $3b8da494b8e92f36$export$7630445096f3e0e = 775493141;
var $3b8da494b8e92f36$export$66b56d86c1fdc999 = 979691226;
var $3b8da494b8e92f36$export$8388c401d8add90d = 3700593921;
var $3b8da494b8e92f36$export$c65910fd24111dc1 = 1062813311;
var $3b8da494b8e92f36$export$7a104ba75cbe7e45 = 1052013943;
var $3b8da494b8e92f36$export$1a9d91cc7daf74f7 = 578613899;
var $3b8da494b8e92f36$export$7a3c6c08717af1a3 = 2454782716;
var $3b8da494b8e92f36$export$4f2487ede48f0d2a = 753842376;
var $3b8da494b8e92f36$export$972dd4e9463306ac = 3001207471;
var $3b8da494b8e92f36$export$547e4d098b2f0ae5 = 2874132201;
var $3b8da494b8e92f36$export$d6aa0703d849041b = 3304561284;
var $3b8da494b8e92f36$export$61bc9e508bdccd25 = 3512223829;
var $3b8da494b8e92f36$export$dafc07efbc1adbdf = 2391406946;
var $3b8da494b8e92f36$export$7f68f805d71a6e66 = 3313531582;
var $3b8da494b8e92f36$export$ff63d71e09d6a536 = 2347447852;
var $3b8da494b8e92f36$export$2be614ca8afd913d = 3824725483;
var $3b8da494b8e92f36$export$1a86b8c219c2e539 = 2515109513;
var $3b8da494b8e92f36$export$46f01ebf0887dc1d = 4252922144;
var $3b8da494b8e92f36$export$866ac0b0ad7986cb = 331165859;
var $3b8da494b8e92f36$export$609a47466db8ab45 = 1529196076;
var $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb = 1783015770;
var $3b8da494b8e92f36$export$defa1f0c8fe66659 = 1376911519;
var $3b8da494b8e92f36$export$3607ac6f8790d3a8 = 2016517767;
var $3b8da494b8e92f36$export$ddf825439bd50398 = 2320036040;
var $3b8da494b8e92f36$export$287844283129ec9a = 3027567501;
var $3b8da494b8e92f36$export$17a178252d8924e1 = 3055160366;
var $3b8da494b8e92f36$export$322ff56c5dcb27d9 = 3283111854;
var $3b8da494b8e92f36$export$13db912ddb7b3508 = 3024970846;
var $3b8da494b8e92f36$export$805f2f490dd0ca23 = 2262370178;
var $3b8da494b8e92f36$export$91c283c4fd8a20a6 = 3171933400;
var $3b8da494b8e92f36$export$da9bcacbb199e2e1 = 1687234759;
var $3b8da494b8e92f36$export$be1b4f4b5c27785f = 1073191201;
var $3b8da494b8e92f36$export$ef3c534479771485 = 900683007;
var $3b8da494b8e92f36$export$f80c44f6cd8e5df8 = 3508470533;
var $3b8da494b8e92f36$export$b227591106b6c07d = 2223149337;
var $3b8da494b8e92f36$export$91ba6cfefaa29b48 = 707683696;
var $3b8da494b8e92f36$export$5d7451154b719cfd = 987401354;
var $3b8da494b8e92f36$export$22cffa5d6d01d817 = 3132237377;
var $3b8da494b8e92f36$export$eb2d882d03a89f21 = 4037862832;
var $3b8da494b8e92f36$export$f2a6887988b8cf66 = 4278956645;
var $3b8da494b8e92f36$export$eb7f84f0caa28271 = 2058353004;
var $3b8da494b8e92f36$export$8fc952379a94dea3 = 4222183408;
var $3b8da494b8e92f36$export$c16cb005304b9a6 = 1810631287;
var $3b8da494b8e92f36$export$d0de9dff026d95f4 = 346874300;
var $3b8da494b8e92f36$export$52e474d7ed246098 = 1658829314;
var $3b8da494b8e92f36$export$26adc90518fc7f55 = 857184966;
var $3b8da494b8e92f36$export$96fd1f1884f8293c = 1634875225;
var $3b8da494b8e92f36$export$6f58b73dd87cfe79 = 712377611;
var $3b8da494b8e92f36$export$6d06d206fd28315e = 1217240411;
var $3b8da494b8e92f36$export$32bafd879e2dddb5 = 1365060375;
var $3b8da494b8e92f36$export$62566c9f1588e72d = 1534661035;
var $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8 = 3277789161;
var $3b8da494b8e92f36$export$e9c2f02afad5f070 = 663422040;
var $3b8da494b8e92f36$export$b194eecedbff75e1 = 855621170;
var $3b8da494b8e92f36$export$f2f8891345874b6a = 2030761528;
var $3b8da494b8e92f36$export$878c9eeddcfc1c9d = 3760055223;
var $3b8da494b8e92f36$export$bf3c7060c2d74dc3 = 869906466;
var $3b8da494b8e92f36$export$9c705f1ac76b11cc = 395920057;
var $3b8da494b8e92f36$export$a0685d525ffdd769 = 3041715199;
var $3b8da494b8e92f36$export$8d770ff3102f12cf = 3040386961;
var $3b8da494b8e92f36$export$dc7924847d53fe73 = 1945004755;
var $3b8da494b8e92f36$export$77bcfd1ca2caf9f1 = 2063403501;
var $3b8da494b8e92f36$export$22c217a29e76d93f = 1599208980;
var $3b8da494b8e92f36$export$1618f1a56215844f = 2635815018;
var $3b8da494b8e92f36$export$2f56044b25111c07 = 1335981549;
var $3b8da494b8e92f36$export$76ac35741e93e1e3 = 4147604152;
var $3b8da494b8e92f36$export$56e4e9cc3d4027a8 = 3961806047;
var $3b8da494b8e92f36$export$661f52213c124a05 = 3495092785;
var $3b8da494b8e92f36$export$500d8b4c01275b03 = 1973544240;
var $3b8da494b8e92f36$export$fea663b35a9b2fd5 = 2954562838;
var $3b8da494b8e92f36$export$5e23f47185550854 = 335055490;
var $3b8da494b8e92f36$export$75992b31f8a355d1 = 488727124;
var $3b8da494b8e92f36$export$9c528b0c14978ab5 = 1060000209;
var $3b8da494b8e92f36$export$94821cd5f6936a22 = 3898045240;
var $3b8da494b8e92f36$export$362a10b06c97d57d = 1163958913;
var $3b8da494b8e92f36$export$e6a1bbf1fc25125c = 2188551683;
var $3b8da494b8e92f36$export$2af5a79c3477a52b = 2816379211;
var $3b8da494b8e92f36$export$ac6bae5e4212d704 = 3850581409;
var $3b8da494b8e92f36$export$6b2435252ee80cc6 = 843113511;
var $3b8da494b8e92f36$export$6a5c99508008e1cf = 2301859152;
var $3b8da494b8e92f36$export$184537a450d4eb23 = 2611217952;
var $3b8da494b8e92f36$export$39652294cc94ec4d = 2951183804;
var $3b8da494b8e92f36$export$ac39f9e9a6506c31 = 1285652485;
var $3b8da494b8e92f36$export$632f59f9073fd206 = 3293546465;
var $3b8da494b8e92f36$export$c3fd351b02fc878e = 395041908;
var $3b8da494b8e92f36$export$87e5f03e9b7321b2 = 1909888760;
var $3b8da494b8e92f36$export$5f91686e3f0ec9c1 = 1095909175;
var $3b8da494b8e92f36$export$e889106cbea0f06d = 2979338954;
var $3b8da494b8e92f36$export$be6eacb56fb6c8fb = 52481810;
var $3b8da494b8e92f36$export$a86d393485a380dd = 3299480353;
var $3b8da494b8e92f36$export$14196a6ce01ebc90 = 231477066;
var $3b8da494b8e92f36$export$e6f3e3864604f581 = 1916977116;
var $3b8da494b8e92f36$export$526a609d02735d86 = 819618141;
var $3b8da494b8e92f36$export$4ff88438ab997405 = 1967976161;
var $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a = 3460190687;
var $3b8da494b8e92f36$export$ae18b145d18a65a0 = 2470393545;
var $3b8da494b8e92f36$export$86ca3b73bd675762 = 1871374353;
var $3b8da494b8e92f36$export$3430f4fb0b506a96 = 3352864051;
var $3b8da494b8e92f36$export$9fdf36e3167f42db = 1411407467;
var $3b8da494b8e92f36$export$b4911fd9d99601eb = 3821786052;
var $3b8da494b8e92f36$export$b19edc019cfe9de6 = 1213861670;
var $3b8da494b8e92f36$export$6ca3bf98d9446928 = 1033361043;
var $3b8da494b8e92f36$export$a95166503d2b6ffb = 3342526732;
var $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4 = 4218914973;
var $3b8da494b8e92f36$export$aa19b9c6daf8f2b7 = 1028945134;
var $3b8da494b8e92f36$export$9166b29db0b1767c = 1133259667;
var $3b8da494b8e92f36$export$723497d1e8551beb = 1898987631;
var $3b8da494b8e92f36$export$4a8581b8026ec1de = 2769231204;
var $3b8da494b8e92f36$export$c49899a0f28a82a4 = 728799441;
var $3b8da494b8e92f36$export$b06bf88c31950afb = 1911125066;
var $3b8da494b8e92f36$export$5c2a810c48b7d687 = 1600972822;
var $3b8da494b8e92f36$export$b671f8cba3531a5b = 3593883385;
var $3b8da494b8e92f36$export$89669bf1e21c3a8c = 1620046519;
var $3b8da494b8e92f36$export$e3363943d93a5893 = 1692211062;
var $3b8da494b8e92f36$export$5d02e5cc9d3a330c = 1637806684;
var $3b8da494b8e92f36$export$5c4875c794e07e3c = 5716631;
var $3b8da494b8e92f36$export$9f161186acea64da = 2254336722;
var $3b8da494b8e92f36$export$bcd0a4268fe14e8d = 2315554128;
var $3b8da494b8e92f36$export$588bb20bb44157c = 148013059;
var $3b8da494b8e92f36$export$c928377fd4feb321 = 1975003073;
var $3b8da494b8e92f36$export$88c23504cdda26e = 2986769608;
var $3b8da494b8e92f36$export$b39a8ba0405bb6d5 = 1235345126;
var $3b8da494b8e92f36$export$c216fdf93111d89f = 734778138;
var $3b8da494b8e92f36$export$42d84e5964307874 = 2082059205;
var $3b8da494b8e92f36$export$17e11e354f64283f = 3987759626;
var $3b8da494b8e92f36$export$512d0c7c106ecc18 = 1621171031;
var $3b8da494b8e92f36$export$b02d58a89e6b5ff7 = 1252848954;
var $3b8da494b8e92f36$export$f4c53f192a3ea7a1 = 1721250024;
var $3b8da494b8e92f36$export$ee7aa2a71993541a = 1807405624;
var $3b8da494b8e92f36$export$1c90015ebcc206f4 = 2445595289;
var $3b8da494b8e92f36$export$d63f485dcf694e96 = 214636428;
var $3b8da494b8e92f36$export$1b3d019a5ff7e4c0 = 4243806635;
var $3b8da494b8e92f36$export$39176bacc0129384 = 1179482911;
var $3b8da494b8e92f36$export$708a87c69a745de7 = 682877961;
var $3b8da494b8e92f36$export$9ff11c1c025aada8 = 1039846685;
var $3b8da494b8e92f36$export$61500658d92a6fec = 3112655638;
var $3b8da494b8e92f36$export$70869bbe5fdba7cc = 3812236995;
var $3b8da494b8e92f36$export$cd44f8494212d99d = 652456506;
var $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c = 1305183839;
var $3b8da494b8e92f36$export$9e9518e51f5a696e = 3856911033;
var $3b8da494b8e92f36$export$a709f37d4ebaba50 = 2533589738;
var $3b8da494b8e92f36$export$f24dfb731091175 = 4097777520;
var $3b8da494b8e92f36$export$60907473f1c7f6ac = 4105383287;
var $3b8da494b8e92f36$export$1525fe60aac5b17a = 3517283431;
var $3b8da494b8e92f36$export$cf2424288308e0b2 = 1768891740;
var $3b8da494b8e92f36$export$c384581c6776ce3d = 2863920197;
var $3b8da494b8e92f36$export$cff3fa05b2018b59 = 160246688;
var $3b8da494b8e92f36$export$2fef8d3cb4859750 = 2324767716;
var $3b8da494b8e92f36$export$ae2d3615237f1a = 2893384427;
var $3b8da494b8e92f36$export$19fc29e00d5d6f73 = 3248260540;
var $3b8da494b8e92f36$export$34f76b58e0e9c3d2 = 2250791053;
var $3b8da494b8e92f36$export$5fc87efa73b68291 = 1842657554;
var $3b8da494b8e92f36$export$fd69280ac5175edc = 3651124850;
var $3b8da494b8e92f36$export$5271976935958385 = 3642467123;
var $3b8da494b8e92f36$export$c88ac1f006bdeee2 = 2904328755;
var $3b8da494b8e92f36$export$6e44935b7739e0ff = 2744685151;
var $3b8da494b8e92f36$export$a71149a81d77ee49 = 3740093272;
var $3b8da494b8e92f36$export$c2678de8aed1a067 = 3724593414;
var $3b8da494b8e92f36$export$57538b274174efc0 = 4017108033;
var $3b8da494b8e92f36$export$19fbfd0ac4f95693 = 4231323485;
var $3b8da494b8e92f36$export$b4ba1bc8e1985ce0 = 804291784;
var $3b8da494b8e92f36$export$7182a3bf21e44226 = 3327091369;
var $3b8da494b8e92f36$export$509cf312676aed46 = 2382730787;
var $3b8da494b8e92f36$export$c370851a9414f0eb = 2837617999;
var $3b8da494b8e92f36$export$e4d201a36f1cfffd = 3425660407;
var $3b8da494b8e92f36$export$b1c9dabc9c7433dc = 3588315303;
var $3b8da494b8e92f36$export$4690a2f5205975d8 = 4143007308;
var $3b8da494b8e92f36$export$1661c90a4afb2a0e = 1916936684;
var $3b8da494b8e92f36$export$7d9c8b1bb730aae6 = 977012517;
var $3b8da494b8e92f36$export$850457d55019fbac = 3181161470;
var $3b8da494b8e92f36$export$fa6e0ae210f3bc46 = 2108223431;
var $3b8da494b8e92f36$export$55aca517d8ba50ae = 377706215;
var $3b8da494b8e92f36$export$8273fbcc9f6a7487 = 2506943328;
var $3b8da494b8e92f36$export$4653376215ef59b8 = 1161773419;
var $3b8da494b8e92f36$export$4a801cfaa3c0d3b5 = 1051575348;
var $3b8da494b8e92f36$export$a72c82f60145e8d0 = 3827777499;
var $3b8da494b8e92f36$export$54e62b6aab985cac = 4288270099;
var $3b8da494b8e92f36$export$6738e6f00a5ca09 = 2391368822;
var $3b8da494b8e92f36$export$38d6e43c3cb2511b = 1806887404;
var $3b8da494b8e92f36$export$c628708806673682 = 1251058090;
var $3b8da494b8e92f36$export$f43ad39311bcb56 = 2706460486;
var $3b8da494b8e92f36$export$d112ffc231f4837b = 3009204131;
var $3b8da494b8e92f36$export$199e9b07f076c19c = 200128114;
var $3b8da494b8e92f36$export$1d7ec19524492a0a = 814719939;
var $3b8da494b8e92f36$export$694b1dc00358431a = 263784265;
var $3b8da494b8e92f36$export$2572b77a3589fc3e = 3009222698;
var $3b8da494b8e92f36$export$ce5af253d449f14 = 2297155007;
var $3b8da494b8e92f36$export$560300bd08cc9a49 = 1339347760;
var $3b8da494b8e92f36$export$8f4beacebcde9bad = 1834744321;
var $3b8da494b8e92f36$export$98508108126f81e2 = 1482959167;
var $3b8da494b8e92f36$export$25b07a829bbe1df6 = 3815607619;
var $3b8da494b8e92f36$export$41fabaf132913619 = 3198132628;
var $3b8da494b8e92f36$export$7e49ca761835aea4 = 3907093117;
var $3b8da494b8e92f36$export$b471058a8e9e1bfd = 1287392070;
var $3b8da494b8e92f36$export$39f93a81a1d0de6f = 2143335405;
var $3b8da494b8e92f36$export$4a5f0a051095a87e = 2827207264;
var $3b8da494b8e92f36$export$f1c98ef26339ddd7 = 2489546625;
var $3b8da494b8e92f36$export$c119463806d89254 = 647756555;
var $3b8da494b8e92f36$export$fbb5bbebdcabe72a = 3737207727;
var $3b8da494b8e92f36$export$24a3bc8472005843 = 807026263;
var $3b8da494b8e92f36$export$4b03dc5d4218e051 = 3390157468;
var $3b8da494b8e92f36$export$8f0a8783fda72466 = 3174744832;
var $3b8da494b8e92f36$export$f37c9444cc9075c7 = 3272907226;
var $3b8da494b8e92f36$export$d2225c8afda26732 = 1962604670;
var $3b8da494b8e92f36$export$4fb40b28127d10c5 = 2107101300;
var $3b8da494b8e92f36$export$ada38802d9d4b96f = 1704287377;
var $3b8da494b8e92f36$export$50d67ce214025f0d = 2590856083;
var $3b8da494b8e92f36$export$724079d67d908529 = 1623761950;
var $3b8da494b8e92f36$export$eabd83e99ab5035a = 4123344466;
var $3b8da494b8e92f36$export$eeda05de3055b9ad = 1758889154;
var $3b8da494b8e92f36$export$5bea4c09e53ad038 = 360485395;
var $3b8da494b8e92f36$export$751ee52b2566888a = 3849074793;
var $3b8da494b8e92f36$export$a1410ea7301e19b2 = 3256556792;
var $3b8da494b8e92f36$export$7f49599a30af57cd = 681481545;
var $3b8da494b8e92f36$export$91c73aab9ceca7a4 = 1457835157;
var $3b8da494b8e92f36$export$8a56abe08ce17f22 = 3295246426;
var $3b8da494b8e92f36$export$cec8b10dd1fabd5d = 1916426348;
var $3b8da494b8e92f36$export$86236e7471cd08b7 = 1419761937;
var $3b8da494b8e92f36$export$bd39418d01d3093c = 3895139033;
var $3b8da494b8e92f36$export$573337cb0f58bf7b = 3293443760;
var $3b8da494b8e92f36$export$2ba349e11c58c1d1 = 2559216714;
var $3b8da494b8e92f36$export$ec4770aab56c805f = 2510884976;
var $3b8da494b8e92f36$export$7952e91536a239e7 = 3732776249;
var $3b8da494b8e92f36$export$68729a9d4641d5fa = 300633059;
var $3b8da494b8e92f36$export$9bf9b7d525eb98c7 = 2937912522;
var $3b8da494b8e92f36$export$9c2be460fff60f00 = 3124254112;
var $3b8da494b8e92f36$export$7bcfd353a35a91d8 = 1950629157;
var $3b8da494b8e92f36$export$70a5078283e32f9 = 4031249490;
var $3b8da494b8e92f36$export$cddab537799fe2fd = 1260505505;
var $3b8da494b8e92f36$export$a340b94c3a9627f5 = 3649129432;
var $3b8da494b8e92f36$export$aba424e86850f717 = 1334484129;
var $3b8da494b8e92f36$export$9f98ad7f69b4 = 3207858831;
var $3b8da494b8e92f36$export$f8669d468384f20f = 1674181508;
var $3b8da494b8e92f36$export$d4f0edab93018f7f = 2296667514;
var $3b8da494b8e92f36$export$8b6f0b216dad9fa1 = 2097647324;
var $3b8da494b8e92f36$export$dbe999d9768fb4f6 = 3473067441;
var $3b8da494b8e92f36$export$8e2240bc69b3bc6b = 1580310250;
var $3b8da494b8e92f36$export$723dea784c83594a = 4124788165;
var $3b8da494b8e92f36$export$c551472fc9de690a = 2809605785;
var $3b8da494b8e92f36$export$58866381b884e0eb = 2028607225;
var $3b8da494b8e92f36$export$52fe4a955de5eb0a = 4070609034;
var $3b8da494b8e92f36$export$76257ab7fe716a7f = 2218152070;
var $3b8da494b8e92f36$export$fa5640b666a3c31a = 3979015343;
var $3b8da494b8e92f36$export$3cb9409cf76f9ab = 3689010777;
var $3b8da494b8e92f36$export$526ec6349313a6f6 = 530289379;
var $3b8da494b8e92f36$export$3a817c6a27a024f5 = 3136571912;
var $3b8da494b8e92f36$export$f105b5cea245e10f = 3544373492;
var $3b8da494b8e92f36$export$2a2b17b32d1a9938 = 451544542;
var $3b8da494b8e92f36$export$32533591b24299cf = 3893378262;
var $3b8da494b8e92f36$export$c3dee48e256db302 = 2706606064;
var $3b8da494b8e92f36$export$f1de0c39f08c8646 = 3626867408;
var $3b8da494b8e92f36$export$36783435db2b01a1 = 4158566097;
var $3b8da494b8e92f36$export$a60bd1ba1e8134ca = 1856042241;
var $3b8da494b8e92f36$export$5591fe75469fbc36 = 2914609552;
var $3b8da494b8e92f36$export$27e14a4f50e6a1ce = 1401173127;
var $3b8da494b8e92f36$export$a712aed3e137585e = 3451746338;
var $3b8da494b8e92f36$export$c331bec3b085e9a1 = 366585022;
var $3b8da494b8e92f36$export$2bafde249aab99b4 = 4122056220;
var $3b8da494b8e92f36$export$f0bc40d4cf9f4c13 = 1058617721;
var $3b8da494b8e92f36$export$8d69d79340327b03 = 1245217292;
var $3b8da494b8e92f36$export$d35785e0f77dbe69 = 750771296;
var $3b8da494b8e92f36$export$9ec66581628a6b51 = 202636808;
var $3b8da494b8e92f36$export$948a40ccb5d8f52c = 2051452291;
var $3b8da494b8e92f36$export$b1832f175144bc77 = 3268803585;
var $3b8da494b8e92f36$export$4ebf013b2eb5605 = 4189434867;
var $3b8da494b8e92f36$export$9cb68f339a367600 = 279856033;
var $3b8da494b8e92f36$export$51e6468498cab028 = 3940055652;
var $3b8da494b8e92f36$export$813f9cf6a2209fec = 781010003;
var $3b8da494b8e92f36$export$bc9bd707c4403985 = 4186316022;
var $3b8da494b8e92f36$export$d4b22dc6a2f55e73 = 693640335;
var $3b8da494b8e92f36$export$2e330e8e36019063 = 2551354335;
var $3b8da494b8e92f36$export$20528f2adfe8dc9c = 2802773753;
var $3b8da494b8e92f36$export$9572797f2851b0 = 886880790;
var $3b8da494b8e92f36$export$b933598a67b23044 = 3242617779;
var $3b8da494b8e92f36$export$edd14ec048dfff5c = 3678494232;
var $3b8da494b8e92f36$export$976ca854e309f825 = 504942748;
var $3b8da494b8e92f36$export$1fe9178d23052979 = 1638771189;
var $3b8da494b8e92f36$export$7d39bda8b7b90f7 = 3912681535;
var $3b8da494b8e92f36$export$cf68aeaedc9f5bf1 = 2127690289;
var $3b8da494b8e92f36$export$94d1e1fe7b940759 = 3190031847;
var $3b8da494b8e92f36$export$2b794d8b645d7087 = 4201705270;
var $3b8da494b8e92f36$export$1804860af295bb6c = 3945020480;
var $3b8da494b8e92f36$export$4a59ec454710396a = 1204542856;
var $3b8da494b8e92f36$export$a636087bbbf1a084 = 826625072;
var $3b8da494b8e92f36$export$5a451f1021e76496 = 2851387026;
var $3b8da494b8e92f36$export$90569318bbf3a5cb = 2655215786;
var $3b8da494b8e92f36$export$3fd59b6be292fb81 = 3840914261;
var $3b8da494b8e92f36$export$8bef70def9fcccef = 982818633;
var $3b8da494b8e92f36$export$8f026b620b6b36d2 = 2728634034;
var $3b8da494b8e92f36$export$89d3022d89ef3649 = 919958153;
var $3b8da494b8e92f36$export$c7eeffff290e6124 = 4095574036;
var $3b8da494b8e92f36$export$b56f06451667ac1c = 1327628568;
var $3b8da494b8e92f36$export$87c3ff288d974d02 = 1865459582;
var $3b8da494b8e92f36$export$5c698c7bb50b493 = 205026976;
var $3b8da494b8e92f36$export$85c864d0fb1c21 = 3372526763;
var $3b8da494b8e92f36$export$422809562a8398de = 2857406711;
var $3b8da494b8e92f36$export$a48481dfef95f4a2 = 4278684876;
var $3b8da494b8e92f36$export$95d386c017712592 = 1307041759;
var $3b8da494b8e92f36$export$d6a5461e4c9c5de9 = 2495723537;
var $3b8da494b8e92f36$export$d988060319005ccc = 1683148259;
var $3b8da494b8e92f36$export$bb5ce9eb5b74ac1 = 3939117080;
var $3b8da494b8e92f36$export$20b2a1f4dec0721b = 3454111270;
var $3b8da494b8e92f36$export$d414ecd4014891b0 = 2798486643;
var $3b8da494b8e92f36$export$2c0c343d0211b12a = 2770003689;
var $3b8da494b8e92f36$export$ecd13d53d7a4573e = 3219374653;
var $3b8da494b8e92f36$export$11ccca7a6068fc2c = 1451395588;
var $3b8da494b8e92f36$export$1392625c61300e87 = 4194566429;
var $3b8da494b8e92f36$export$7bec46e80091ced6 = 103090709;
var $3b8da494b8e92f36$export$91748340fd72a888 = 4208778838;
var $3b8da494b8e92f36$export$22d84e75fa702951 = 2945172077;
var $3b8da494b8e92f36$export$32b9b3ebd4722148 = 220341763;
var $3b8da494b8e92f36$export$a8dfee375f66477 = 603570806;
var $3b8da494b8e92f36$export$f68e11d990d9b413 = 3566463478;
var $3b8da494b8e92f36$export$cb9cf4371be8f15d = 3505215534;
var $3b8da494b8e92f36$export$1d01e90a5e4dec43 = 3388369263;
var $3b8da494b8e92f36$export$aa818ced04ed1ad6 = 3888040117;
var $3b8da494b8e92f36$export$212932c39cad14c1 = 1425443689;
var $3b8da494b8e92f36$export$6c79cacc663fc254 = 1281925730;
var $3b8da494b8e92f36$export$78c21ee34d1c97a2 = 572779678;
var $3b8da494b8e92f36$export$4f772a6ff028612d = 1484403080;
var $3b8da494b8e92f36$export$20db6cfb2db45f44 = 987898635;
var $3b8da494b8e92f36$export$6f6e43cda6d00167 = 1268542332;
var $3b8da494b8e92f36$export$5c5e42d238f720e8 = 4238390223;
var $3b8da494b8e92f36$export$fb207e5dcb39ff56 = 3455213021;
var $3b8da494b8e92f36$export$9aea5e4278bdf41 = 315944413;
var $3b8da494b8e92f36$export$5de1881e0274940 = 4203026998;
var $3b8da494b8e92f36$export$521bada8515ab976 = 374418227;
var $3b8da494b8e92f36$export$5549d05fc93b536b = 2047409740;
var $3b8da494b8e92f36$export$e537328a93948147 = 477187591;
var $3b8da494b8e92f36$export$4b188b7ebea22345 = 80994333;
var $3b8da494b8e92f36$export$6cce02eb19410fd6 = 2835456948;
var $3b8da494b8e92f36$export$60c94e2d2eb3ae2d = 2777663545;
var $3b8da494b8e92f36$export$f1c306d0c6bd87c1 = 339256511;
var $3b8da494b8e92f36$export$ae9001e98ea773dd = 1883228015;
var $3b8da494b8e92f36$export$804200e8992a9b20 = 1472233963;
var $3b8da494b8e92f36$export$2c91bae7185bb7c5 = 4006246654;
var $3b8da494b8e92f36$export$2a79ce8e6dde1605 = 445594917;
var $3b8da494b8e92f36$export$b6cea144bed9ade0 = 3073041342;
var $3b8da494b8e92f36$export$d1d6e43b67173127 = 526551008;
var $3b8da494b8e92f36$export$3d28a3f3def06976 = 1714330368;
var $3b8da494b8e92f36$export$a6127017c8832457 = 2963535650;
var $3b8da494b8e92f36$export$ef6ede6699415aa4 = 32440307;
var $3b8da494b8e92f36$export$a344fd0eadbfecfd = 4054601972;
var $3b8da494b8e92f36$export$d5bdd4bede6134ba = 606661476;
var $3b8da494b8e92f36$export$57bc436ff3f2a5b4 = 693772133;
var $3b8da494b8e92f36$export$7a8fab203344ee59 = 2827736869;
var $3b8da494b8e92f36$export$5f769669c17cd7be = 2601014836;
var $3b8da494b8e92f36$export$a7c9a308bd61791e = 2147822146;
var $3b8da494b8e92f36$export$5655bbb83559ae0a = 2506170314;
var $3b8da494b8e92f36$export$27d54c1ce100f08f = 194851669;
var $3b8da494b8e92f36$export$c9619b4f25a6fec9 = 4133800736;
var $3b8da494b8e92f36$export$d919945f72bbea0b = 2485617015;
var $3b8da494b8e92f36$export$8176d17ddc845867 = 2205249479;
var $3b8da494b8e92f36$export$509dfb8dfad057e9 = 1383045692;
var $3b8da494b8e92f36$export$64fbfc27b4cec02a = 1416205885;
var $3b8da494b8e92f36$export$843f1ace19c7b757 = 3331915920;
var $3b8da494b8e92f36$export$6b6b5ff5fe5ba252 = 3486308946;
var $3b8da494b8e92f36$export$88babb7bc763dabe = 3749851601;
var $3b8da494b8e92f36$export$86be59b19ba0bac8 = 59481748;
var $3b8da494b8e92f36$export$929165ba65228ecd = 1123145078;
var $3b8da494b8e92f36$export$6659a6bebb9ff076 = 2898889636;
var $3b8da494b8e92f36$export$ebd3184cd8b065fd = 2713105998;
var $3b8da494b8e92f36$export$36a18b804a497897 = 2581212453;
var $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b = 4182860854;
var $3b8da494b8e92f36$export$a93e600de3d261bf = 2736907675;
var $3b8da494b8e92f36$export$51d4dba1ae2d8f1b = 2740243338;
var $3b8da494b8e92f36$export$307e928f69359e15 = 3125803723;
var $3b8da494b8e92f36$export$ad8e83777baa8a31 = 4261334040;
var $3b8da494b8e92f36$export$3812c41bd5a38c31 = 1302238472;
var $3b8da494b8e92f36$export$68ad2a8fa72d7d5d = 2265737646;
var $3b8da494b8e92f36$export$6b50b93a9a443e09 = 669184980;
var $3b8da494b8e92f36$export$1da0b60eaa4646c7 = 3288037868;
var $3b8da494b8e92f36$export$3e010693b51db065 = 2543172580;
var $3b8da494b8e92f36$export$e8d5f91a47737ca2 = 1299126871;
var $3b8da494b8e92f36$export$b5f25ff49e2cce09 = 512836454;
var $3b8da494b8e92f36$export$519ba6d3fd8728d1 = 336235671;
var $3b8da494b8e92f36$export$e209a4a7e118ebd5 = 2759199220;
var $3b8da494b8e92f36$export$aa7ed498f6d760b8 = 1417489154;
var $3b8da494b8e92f36$export$5046f8ea20f33c53 = 427810014;
var $3b8da494b8e92f36$export$fe64d2939a7bcd9f = 2347495698;
var $3b8da494b8e92f36$export$9418e91392f50813 = 1628702193;
var $3b8da494b8e92f36$export$1ed081495b7a3a30 = 1345879162;
var $3b8da494b8e92f36$export$6a6339501d69dda6 = 2715220739;
var $3b8da494b8e92f36$export$fd5f089562b081f9 = 3124975700;
var $3b8da494b8e92f36$export$baa116807524c06e = 4282788508;
var $3b8da494b8e92f36$export$bbe7a575e2c472c = 3028897424;
var $3b8da494b8e92f36$export$24e4f709acf9819a = 3071757647;
var $3b8da494b8e92f36$export$e7d69479b3ed50b5 = 230924584;
var $3b8da494b8e92f36$export$2ef492eaafc1544a = 1260650574;
var $3b8da494b8e92f36$export$db3cb7c28fcdcb12 = 2247615214;
var $3b8da494b8e92f36$export$102bd971c14ba988 = 1878645084;
var $3b8da494b8e92f36$export$aea7582eed012cfd = 2513912981;
var $3b8da494b8e92f36$export$a88a630c8a34962c = 2233826070;
var $3b8da494b8e92f36$export$6757c80a00accad7 = 3653947884;
var $3b8da494b8e92f36$export$41a1f0e241a2a28b = 3843319758;
var $3b8da494b8e92f36$export$34a05c9e12c53c23 = 1190533807;
var $3b8da494b8e92f36$export$a413c76fb80f2f8f = 1597423693;
var $3b8da494b8e92f36$export$3787e1faec59f84d = 1973038258;
var $3b8da494b8e92f36$export$17bdef5f951eb73a = 2473145415;
var $3b8da494b8e92f36$export$ceebe0114638d080 = 2668620305;
var $3b8da494b8e92f36$export$1256946afdc9c505 = 1595516126;
var $3b8da494b8e92f36$export$e6b8d999588bbfb0 = 390701378;
var $3b8da494b8e92f36$export$73f1ed87b1382872 = 1202362311;
var $3b8da494b8e92f36$export$ac74d5ae1cf456e2 = 2485662743;
var $3b8da494b8e92f36$export$1fe9373d30daf09d = 723233188;
var $3b8da494b8e92f36$export$7bbc953ffa23813a = 2609359061;
var $3b8da494b8e92f36$export$f0268edfa147e5dc = 4124623270;
var $3b8da494b8e92f36$export$6647f951c3b0d1f4 = 2411513650;
var $3b8da494b8e92f36$export$9de8356191dd818 = 1509187699;
var $3b8da494b8e92f36$export$bb7bafb36fa737d0 = 2778083089;
var $3b8da494b8e92f36$export$6c8179c0d6d08ecd = 478536968;
var $3b8da494b8e92f36$export$b58a07450f76f5f4 = 3765753017;
var $3b8da494b8e92f36$export$3535b249460c70df = 3413951693;
var $3b8da494b8e92f36$export$9d1f507a1764cea9 = 3615266464;
var $3b8da494b8e92f36$export$18fc149087e3c79f = 110355661;
var $3b8da494b8e92f36$export$9f8310d680636df4 = 3650150729;
var $3b8da494b8e92f36$export$de24c94bb0d02a47 = 3357820518;
var $3b8da494b8e92f36$export$2d97768d0015dccc = 941946838;
var $3b8da494b8e92f36$export$b40b280750874c4 = 2752243245;
var $3b8da494b8e92f36$export$421fb9d9a3f56509 = 4166981789;
var $3b8da494b8e92f36$export$c97535012f6ac326 = 1680319473;
var $3b8da494b8e92f36$export$2ee49241e76b8d88 = 871118103;
var $3b8da494b8e92f36$export$6d55f5b363d70c84 = 673634403;
var $3b8da494b8e92f36$export$e8b651e9570a42fe = 179317114;
var $3b8da494b8e92f36$export$3285d659f1d95448 = 433424934;
var $3b8da494b8e92f36$export$42292ad7a949ca7e = 2559016684;
var $3b8da494b8e92f36$export$d18f4beaf4701e94 = 759155922;
var $3b8da494b8e92f36$export$e569b2ccaf52a8fd = 2775532180;
var $3b8da494b8e92f36$export$1dcd1852764e4fb7 = 2924175390;
var $3b8da494b8e92f36$export$8923f08b310dd8eb = 1423911732;
var $3b8da494b8e92f36$export$f9263ceb04bc6af7 = 4022376103;
var $3b8da494b8e92f36$export$f181705801de6aa3 = 2067069095;
var $3b8da494b8e92f36$export$53e8d872a4770e53 = 1663979128;
var $3b8da494b8e92f36$export$48039412bed87667 = 2004835150;
var $3b8da494b8e92f36$export$d3d6625d33fe749f = 597895409;
var $3b8da494b8e92f36$export$8334e069ea620bb8 = 3021840470;
var $3b8da494b8e92f36$export$52eaa2d341700ec1 = 2519244187;
var $3b8da494b8e92f36$export$81a199afe8025f54 = 2529465313;
var $3b8da494b8e92f36$export$3d22c077bdb90a75 = 1029017970;
var $3b8da494b8e92f36$export$dd210e591847e415 = 2665983363;
var $3b8da494b8e92f36$export$3204ea49f2718d42 = 2833995503;
var $3b8da494b8e92f36$export$933e35db50e6a51e = 219451334;
var $3b8da494b8e92f36$export$4fe467dabb00dda9 = 1430189142;
var $3b8da494b8e92f36$export$95d5078ec273e20a = 2022407955;
var $3b8da494b8e92f36$export$f6578324c1ae7b2d = 2347385850;
var $3b8da494b8e92f36$export$c75f1a12de9d86b8 = 1008929658;
var $3b8da494b8e92f36$export$34302876ddf37791 = 2624227202;
var $3b8da494b8e92f36$export$f91087a08c2974c5 = 3422422726;
var $3b8da494b8e92f36$export$a205ad382a675d9 = 1520743889;
var $3b8da494b8e92f36$export$7d2f047f3374cd6d = 4266656042;
var $3b8da494b8e92f36$export$91b809c3774b52ca = 2604431987;
var $3b8da494b8e92f36$export$8799bf99f01d0b68 = 125510826;
var $3b8da494b8e92f36$export$117debe45e2ae49d = 1402838566;
var $3b8da494b8e92f36$export$9fb6085672705774 = 3741457305;
var $3b8da494b8e92f36$export$28f95f3a6633e96f = 3905492369;
var $3b8da494b8e92f36$export$b1f1e3ede519ae5d = 2445078500;
var $3b8da494b8e92f36$export$fc934d2c514a6d85 = 812098782;
var $3b8da494b8e92f36$export$af00f3f0f2c6d769 = 178086475;
var $3b8da494b8e92f36$export$70c90f142bc37811 = 3590301190;
var $3b8da494b8e92f36$export$c78a940a5c4e916a = 4142052618;
var $3b8da494b8e92f36$export$a321d78f5cb9ca4f = 2453401579;
var $3b8da494b8e92f36$export$b1afc9e5bea6b0b5 = 3448662350;
var $3b8da494b8e92f36$export$3a196dd363119ece = 1446786286;
var $3b8da494b8e92f36$export$ac5310f0d6f3db5c = 803998398;
var $3b8da494b8e92f36$export$d6b8bce4708b1831 = 3857492461;
var $3b8da494b8e92f36$export$868aba9d7912640 = 738692330;
var $3b8da494b8e92f36$export$b4e4bbdecfda501 = 4219587988;
var $3b8da494b8e92f36$export$5a54e2173db7aff1 = 3008276851;
var $3b8da494b8e92f36$export$720f149ff6c3542a = 803316827;
var $3b8da494b8e92f36$export$3534ea9b1da643f3 = 1809719519;
var $3b8da494b8e92f36$export$6c1d729adeeaed4a = 2556980723;
var $3b8da494b8e92f36$export$94fa95b743687d37 = 1860660968;
var $3b8da494b8e92f36$export$7beb7cab9d3e2b14 = 476780140;
var $3b8da494b8e92f36$export$4b2fd6d0e55ecfa0 = 3900360178;
var $3b8da494b8e92f36$export$bb01581d91f365d6 = 4170525392;
var $3b8da494b8e92f36$export$5dc53366ca618592 = 3732053477;
var $3b8da494b8e92f36$export$ee0d746d8ff1888 = 1694125774;
var $3b8da494b8e92f36$export$c979e6e85019e6b8 = 2273265877;
var $3b8da494b8e92f36$export$1a193eff9b81238c = 3632507154;
var $3b8da494b8e92f36$export$4c036fdbe809739e = 3800577675;
var $3b8da494b8e92f36$export$bc84a57a2afc707f = 2889183280;
var $3b8da494b8e92f36$export$4d644d65c6f10de9 = 3050246964;
var $3b8da494b8e92f36$export$415e991945a654ac = 45288368;
var $3b8da494b8e92f36$export$6ef8b10b979d6ed7 = 1981873012;
var $3b8da494b8e92f36$export$873d7c14f646e598 = 370225590;
var $3b8da494b8e92f36$export$a749204998f5a3c = 1485152156;
var $3b8da494b8e92f36$export$ea419368a3085d41 = 2542286263;
var $3b8da494b8e92f36$export$856784adecc150fd = 776857604;
var $3b8da494b8e92f36$export$72ed75e7fb4d773c = 647927063;
var $3b8da494b8e92f36$export$3c5dfd8f9406db1 = 3150382593;
var $3b8da494b8e92f36$export$cdda591705a51882 = 616511568;
var $3b8da494b8e92f36$export$7d329955417ee03b = 2705031697;
var $3b8da494b8e92f36$export$40359089e4e5f50d = 1310608509;
var $3b8da494b8e92f36$export$17c544e73ae3a145 = 3798115385;
var $3b8da494b8e92f36$export$4236824d5abac42e = 2297822566;
var $3b8da494b8e92f36$export$16bf2d4e6d976d3f = 3612888222;
var $3b8da494b8e92f36$export$5f6c4319f2d45df8 = 962685235;
var $3b8da494b8e92f36$export$2cb306ee14038b5b = 2442683028;
var $3b8da494b8e92f36$export$82c094da49d2ff47 = 1065908215;
var $3b8da494b8e92f36$export$39a9378576bb57be = 891718957;
var $3b8da494b8e92f36$export$5993765fc33cd311 = 1907098498;
var $3b8da494b8e92f36$export$51b6b07df735d683 = 3304826586;
var $3b8da494b8e92f36$export$c780a52ecdcabf01 = 2799835756;
var $3b8da494b8e92f36$export$6aa049ff08a0c4f1 = 180925521;
var $3b8da494b8e92f36$export$5f0eb5061797e589 = 1735638870;
var $3b8da494b8e92f36$export$d82e092cbe83635 = 1377556343;
var $3b8da494b8e92f36$export$5a4c73a4f8aa5d8e = 581633288;
var $3b8da494b8e92f36$export$8d9cc5ad564ee144 = 1718945513;
var $3b8da494b8e92f36$export$c86c1f40af604403 = 3101149627;
var $3b8da494b8e92f36$export$662956efd4bfbec8 = 3317419933;
var $3b8da494b8e92f36$export$616208c6ed2a0bc3 = 1210645708;
var $3b8da494b8e92f36$export$925b578047892bce = 2552916305;
var $3b8da494b8e92f36$export$cc681b8347ae2d28 = 1742049831;
var $3b8da494b8e92f36$export$f9f8eae306150574 = 280115917;
var $3b8da494b8e92f36$export$785d406623be72b4 = 1484833681;
var $3b8da494b8e92f36$export$d8e08722b3a63093 = 1640371178;
var $3b8da494b8e92f36$export$a22358e886367f19 = 2636378356;
var $3b8da494b8e92f36$export$56d725cc20359b33 = 1983826977;
var $3b8da494b8e92f36$export$6f91f48d17dc7f0c = 1447204868;
var $3b8da494b8e92f36$export$1d51c48a0d338c7d = 912023232;
var $3b8da494b8e92f36$export$a6d7a4aa050bf0af = 531007025;
var $3b8da494b8e92f36$export$ee8bfae354e48d7a = 985171141;
var $3b8da494b8e92f36$export$5ae10812dce15666 = 1290481447;
var $3b8da494b8e92f36$export$b54830ac8ad9727a = 626085974;
var $3b8da494b8e92f36$export$a208be2840956e7f = 1351298697;
var $3b8da494b8e92f36$export$c548b4b271e262e6 = 846575682;
var $3b8da494b8e92f36$export$9b0f4a78b27610b2 = 1607154358;
var $3b8da494b8e92f36$export$a47851a048855495 = 3303107099;
var $3b8da494b8e92f36$export$922b2a5ffa4eee3e = 1300840506;
var $3b8da494b8e92f36$export$e8d16de4476cf00b = 3049322572;
var $3b8da494b8e92f36$export$b718d0ddc70e8826 = 3958052878;
var $3b8da494b8e92f36$export$feba35570752eed7 = 2830218821;
var $3b8da494b8e92f36$export$6b91369e24532c08 = 3408363356;
var $3b8da494b8e92f36$export$2488f86e43e28df = 2525727697;
var $3b8da494b8e92f36$export$cc4382b670d6cb85 = 2162789131;
var $3b8da494b8e92f36$export$5b040d73f338adc4 = 2273995522;
var $3b8da494b8e92f36$export$15997dea423f274a = 3692461612;
var $3b8da494b8e92f36$export$982f17a83654a1a9 = 4240577450;
var $3b8da494b8e92f36$export$2e35095825dbcf3c = 3982875396;
var $3b8da494b8e92f36$export$858f8a041fd3a224 = 867548509;
var $3b8da494b8e92f36$export$8ada78967ce0de43 = 4165799628;
var $3b8da494b8e92f36$export$2f757802d81974e2 = 2042790032;
var $3b8da494b8e92f36$export$342dff6367faf07 = 448429030;
var $3b8da494b8e92f36$export$561c2ab2304850ba = 2341007311;
var $3b8da494b8e92f36$export$811553376c3d20a1 = 3679540991;
var $3b8da494b8e92f36$export$fdb8da78dfd217b = 1660063152;
var $3b8da494b8e92f36$export$1d819f3892ceee28 = 3008791417;
var $3b8da494b8e92f36$export$ae8b05aa6e0aacb = 3377609919;
var $3b8da494b8e92f36$export$2ddea3c8ef71f411 = 1076942058;
var $3b8da494b8e92f36$export$878d964deb1331d5 = 1222501353;
var $3b8da494b8e92f36$export$f4438fbaac045e16 = 1580146022;
var $3b8da494b8e92f36$export$7e9b46959f13f9f9 = 2692823254;
var $3b8da494b8e92f36$export$b383f456d1eb5728 = 825690147;
var $3b8da494b8e92f36$export$e5dbe5700ecba735 = 2405470396;
var $3b8da494b8e92f36$export$ccca2dba73dadeee = 3252649465;
var $3b8da494b8e92f36$export$678778899caae9fb = 931644368;
var $3b8da494b8e92f36$export$d48394905ba00253 = 2093928680;
var $3b8da494b8e92f36$export$c69ac01f7bf51b3 = 2044713172;
var $3b8da494b8e92f36$export$a1c63a5e92dd2589 = 3710013099;
var $3b8da494b8e92f36$export$7fc4348977f8efbe = 148025276;
var $3b8da494b8e92f36$export$d3bab060ba7bb28e = 3896028662;
var $3b8da494b8e92f36$export$58f9c0981808b34a = 2598011224;
var $3b8da494b8e92f36$export$925767a3ae3a4925 = 2802850158;
var $3b8da494b8e92f36$export$fd22cc0d8a9221ad = 3958567839;
var $3b8da494b8e92f36$export$e44d5de26af5ea64 = 2267347899;
var $3b8da494b8e92f36$export$d5d8ad3a011628f1 = 2095639259;
var $3b8da494b8e92f36$export$37d3d6bd5c8ccc64 = 2417041796;
var $3b8da494b8e92f36$export$6206aa3d0f21f45b = 3119450353;
var $3b8da494b8e92f36$export$c9ca953ef790beab = 1304840413;
var $3b8da494b8e92f36$export$8fee3bf866f8cce8 = 2022622350;
var $3b8da494b8e92f36$export$e24694355c430317 = 1775413392;
var $3b8da494b8e92f36$export$676596d7c04e166c = 3213052703;
var $3b8da494b8e92f36$export$dd39b62503026d92 = 990879717;
var $3b8da494b8e92f36$export$5cd60fa6a78c0173 = 3727388367;
var $3b8da494b8e92f36$export$852f8a6b6383ece8 = 3355820592;
var $3b8da494b8e92f36$export$21edf23fe590ab33 = 2226359599;
var $3b8da494b8e92f36$export$633cca251a505d1c = 2483315170;
var $3b8da494b8e92f36$export$c819a2c53c7debd3 = 101040310;
var $3b8da494b8e92f36$export$ffa0fdddece68333 = 2077209135;
var $3b8da494b8e92f36$export$6c64a4f6b6ac2c27 = 1207048766;
var $3b8da494b8e92f36$export$f7ea933b5cc28fe9 = 1411181986;
var $3b8da494b8e92f36$export$484015ec0cfcf638 = 4251960020;
var $3b8da494b8e92f36$export$3f47c3818454d080 = 1227763645;
var $3b8da494b8e92f36$export$fd56761a594c90b1 = 2251480897;
var $3b8da494b8e92f36$export$16a79191283c73fb = 3701648758;
var $3b8da494b8e92f36$export$a745bf458fbeee83 = 1918398963;
var $3b8da494b8e92f36$export$2a6665453c658732 = 2706619895;
var $3b8da494b8e92f36$export$6bb698fabb80bc4f = 3368373690;
var $3b8da494b8e92f36$export$86d3411164b0d7ca = 677618848;
var $3b8da494b8e92f36$export$335d88569fe87f23 = 4256014907;
var $3b8da494b8e92f36$export$d394212ace624aa4 = 2597039031;
var $3b8da494b8e92f36$export$d8f086a59e04ee25 = 3265635763;
var $3b8da494b8e92f36$export$ef24113ba020ce8b = 2199411900;
var $3b8da494b8e92f36$export$33d702d835661133 = 1303795690;
var $3b8da494b8e92f36$export$271c16e7766bc70a = 3303938423;
var $3b8da494b8e92f36$export$dc9e27d0030a4e65 = 248100487;
var $3b8da494b8e92f36$export$574ce7177061cd49 = 1847130766;
var $3b8da494b8e92f36$export$f73761c75017e522 = 1838606355;
var $3b8da494b8e92f36$export$6fc652c3309b2805 = 30780891;
var $3b8da494b8e92f36$export$8e87328dda511499 = 1566485204;
var $3b8da494b8e92f36$export$730dc93cbeee78d = 4162380809;
var $3b8da494b8e92f36$export$96fe74a17c6cc802 = 3452421091;
var $3b8da494b8e92f36$export$87ba372ae8130125 = 2655187982;
var $3b8da494b8e92f36$export$dfd7fcb4b870ec5c = 3020489413;
var $3b8da494b8e92f36$export$81e1b971a1c4ebdc = 852622518;
var $3b8da494b8e92f36$export$5ea64628e783fcd7 = 3548104201;
var $3b8da494b8e92f36$export$ea241fcbff64ea22 = 3207319532;
var $3b8da494b8e92f36$export$599e2cc9684286ad = 1040185647;
var $3b8da494b8e92f36$export$133f46f5e03827d2 = 2242383968;
var $3b8da494b8e92f36$export$452a97d064c41087 = 3200245327;
var $3b8da494b8e92f36$export$ac02302577b36171 = 1648886627;
var $3b8da494b8e92f36$export$4c93c766e0e36aab = 3796139169;
var $3b8da494b8e92f36$export$623f6287e006c7a4 = 770865208;
var $3b8da494b8e92f36$export$18cb417b645b7410 = 1154170062;
var $3b8da494b8e92f36$export$754bbb5e0a086428 = 1376555844;
var $3b8da494b8e92f36$export$7830682e416a9613 = 2949456006;
var $3b8da494b8e92f36$export$a8162083776a1967 = 1045800335;
var $3b8da494b8e92f36$export$df2de258a2e9ad6e = 1765591967;
var $3b8da494b8e92f36$export$1831bebef003f99c = 1072939445;
var $3b8da494b8e92f36$export$a111f4db685f7a59 = 3510044353;
var $3b8da494b8e92f36$export$3ed3034f18cddaaf = 2367409068;
var $3b8da494b8e92f36$export$f9ded52c4b70f4f5 = 1105321065;
var $3b8da494b8e92f36$export$fba1c7dc4402a4b3 = 539742890;
var $3b8da494b8e92f36$export$61dc578b5cbce35b = 602808272;
var $3b8da494b8e92f36$export$52ac7bd280cbd04f = 1065062679;
var $3b8da494b8e92f36$export$cd24e82549f8104a = 347226245;
var $3b8da494b8e92f36$export$d9a4f267e9f6318f = 613356794;
var $3b8da494b8e92f36$export$da5288cf4b26555 = 1658513725;
var $3b8da494b8e92f36$export$12f953fa3de3799d = 1959218052;
var $3b8da494b8e92f36$export$dc861dfbf2baaa1a = 2732653382;
var $3b8da494b8e92f36$export$f4030cb204e0fdd0 = 4257277454;
var $3b8da494b8e92f36$export$a8e470c98a867218 = 2614616156;
var $3b8da494b8e92f36$export$882088260ccc7b4e = 2859738748;
var $3b8da494b8e92f36$export$6ce0be1835c9ab1b = 3264961684;
var $3b8da494b8e92f36$export$f36161e505db02b5 = 3639012971;
var $3b8da494b8e92f36$export$b4aba58d960d51f2 = 938368621;
var $3b8da494b8e92f36$export$348fb08c3ac89e16 = 1098599126;
var $3b8da494b8e92f36$export$4a58eef3e39e7dc9 = 1767535486;
var $3b8da494b8e92f36$export$4414ee8d28b3907a = 747523909;
var $3b8da494b8e92f36$export$ffe31dc9f08ace1d = 622194075;
var $3b8da494b8e92f36$export$cfb27e5500a39320 = 2069777674;
var $3b8da494b8e92f36$export$229e73e933804e50 = 1387855156;
var $3b8da494b8e92f36$export$a34702b337593132 = 3367102660;
var $3b8da494b8e92f36$export$a08930e72563c535 = 1560379544;
var $3b8da494b8e92f36$export$5609a6d9599ac69a = 4037036970;
var $3b8da494b8e92f36$export$cea9d94742f0d4d6 = 3869604511;
var $3b8da494b8e92f36$export$5c6a7bd9ef3bd95c = 390851274;
var $3b8da494b8e92f36$export$bbecaa296832f2e5 = 2080292479;
var $3b8da494b8e92f36$export$bb754af29f96df84 = 130549933;
var $3b8da494b8e92f36$export$2bc1977a2b3383fc = 1110488051;
var $3b8da494b8e92f36$export$85628107d33cb852 = 411424972;
var $3b8da494b8e92f36$export$2d0d3edb1689a375 = 639542469;
var $3b8da494b8e92f36$export$ca3c586c641ca9ba = 618182010;
var $3b8da494b8e92f36$export$97bd4cd6a4e84bf7 = 3630933823;
var $3b8da494b8e92f36$export$b29a12041c9b9847 = 599546466;
var $3b8da494b8e92f36$export$4b79612785fd8d50 = 1390159747;
var $3b8da494b8e92f36$export$4506ff5c4f61e02a = 1109904537;
var $3b8da494b8e92f36$export$94890c79f4cae6d6 = class {
    constructor(value, schema = 2, tapeItem){
        this.value = value;
        this.type = 5;
        if (tapeItem && tapeItem?.type === 2) return $3b8da494b8e92f36$var$TypeInitialiser(schema, tapeItem);
    }
};
var $3b8da494b8e92f36$export$2e483f5afea275bb = class {
    constructor(v, type){
        this.type = 4;
        if (type) this.type = type;
        this.value = v;
    }
    get internalValue() {
        return this._internalValue;
    }
    get value() {
        return this._representationValue;
    }
    set value(v) {
        this._representationValue = (this._internalValue = v) === null ? v : parseFloat(v);
    }
};
var $3b8da494b8e92f36$export$965c6ce6d3869a7a = /* @__PURE__ */ ((logical2)=>{
    logical2[logical2["FALSE"] = 0] = "FALSE";
    logical2[logical2["TRUE"] = 1] = "TRUE";
    logical2[logical2["UNKNOWN"] = 2] = "UNKNOWN";
    return logical2;
})($3b8da494b8e92f36$export$965c6ce6d3869a7a || {});
var $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 = class {
    constructor(expressID = -1){
        this.expressID = expressID;
        this.type = 0;
    }
};
var $3b8da494b8e92f36$export$6c6c405ef9389ced = [];
var $3b8da494b8e92f36$export$1ae3922015fd7522 = {};
var $3b8da494b8e92f36$export$6fc5084ea038b400 = {};
var $3b8da494b8e92f36$export$cab133dc4b2240f9 = {};
var $3b8da494b8e92f36$export$4085d3c0722bed8d = {};
var $3b8da494b8e92f36$export$9d063d2e6222d3e2 = {};
var $3b8da494b8e92f36$export$a6870f5c6ab054f9 = [];
function $3b8da494b8e92f36$var$TypeInitialiser(schema, tapeItem) {
    if (Array.isArray(tapeItem)) tapeItem.map((p)=>$3b8da494b8e92f36$var$TypeInitialiser(schema, p));
    if (tapeItem.typecode) return $3b8da494b8e92f36$export$9d063d2e6222d3e2[schema][tapeItem.typecode](tapeItem.value);
    return tapeItem.value;
}
function $3b8da494b8e92f36$var$Labelise(tapeItem) {
    if ((tapeItem ?? void 0) === void 0 || tapeItem instanceof $3b8da494b8e92f36$export$94890c79f4cae6d6 || tapeItem instanceof $3b8da494b8e92f36$export$2e483f5afea275bb || tapeItem.label) return tapeItem;
    if (Array.isArray(tapeItem)) return tapeItem.map((p)=>$3b8da494b8e92f36$var$Labelise(p));
    const _valueName = tapeItem.type === 4 ? "internalValue" : "value";
    return {
        [_valueName]: tapeItem[_valueName],
        valueType: tapeItem.type,
        type: 2,
        label: tapeItem.name
    };
}
var $3b8da494b8e92f36$export$e49b768f28ad1b60 = /* @__PURE__ */ ((Schemas2)=>{
    Schemas2["IFC2X3"] = "IFC2X3";
    Schemas2["IFC4"] = "IFC4";
    Schemas2["IFC4X3"] = "IFC4X3";
    return Schemas2;
})($3b8da494b8e92f36$export$e49b768f28ad1b60 || {});
$3b8da494b8e92f36$export$a6870f5c6ab054f9[1] = [
    "IFC2X3",
    "IFC2X_FINAL"
];
$3b8da494b8e92f36$export$6c6c405ef9389ced[1] = {
    3630933823: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcActorRole(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    618182010: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAddress(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    639542469: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApplication(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    411424972: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAppliedValue((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    1110488051: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAppliedValueRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    130549933: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApproval((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    2080292479: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApprovalActorRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    390851274: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApprovalPropertyRelationship(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    3869604511: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApprovalRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    4037036970: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1560379544: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryEdgeCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfLinearSubgradeReactionMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfLinearSubgradeReactionMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfLinearSubgradeReactionMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfRotationalSubgradeReactionMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfRotationalSubgradeReactionMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfRotationalSubgradeReactionMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    3367102660: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryFaceCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfSubgradeReactionMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfSubgradeReactionMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfSubgradeReactionMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1387855156: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryNodeCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearStiffnessMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearStiffnessMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearStiffnessMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRotationalStiffnessMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRotationalStiffnessMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRotationalStiffnessMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    2069777674: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryNodeConditionWarping((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearStiffnessMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearStiffnessMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearStiffnessMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRotationalStiffnessMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRotationalStiffnessMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRotationalStiffnessMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWarpingMomentMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    622194075: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCalendarDate(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDayInMonthNumber((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMonthInYearNumber((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcYearNumber((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    747523909: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassification(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1767535486: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationItem(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1098599126: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationItemRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    938368621: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationNotation(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3639012971: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationNotationFacet(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3264961684: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcColourSpecification((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2859738748: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionGeometry(),
    2614616156: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionPointGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    4257277454: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionPortGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    2732653382: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionSurfaceGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    1959218052: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstraint(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1658513725: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstraintAggregationRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[4]),
    613356794: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstraintClassificationRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    347226245: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstraintRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1065062679: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCoordinatedUniversalTimeOffset(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHourInDay((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMinuteInHour((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]),
    602808272: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCostValue((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    539742890: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurrencyRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4])),
    1105321065: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveStyleFont((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2367409068: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveStyleFontAndScaling((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3510044353: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveStyleFontPattern(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1072939445: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDateAndTime(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    1765591967: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDerivedUnit(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1045800335: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDerivedUnitElement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 10)),
    2949456006: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionalExponents(new $3b8da494b8e92f36$export$2e483f5afea275bb((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 10)),
    1376555844: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDocumentElectronicFormat((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1154170062: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDocumentInformation(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 1, v[11]), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 1, v[12]), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value, 1, v[13]), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value, 1, v[14]), v[15], v[16]),
    770865208: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDocumentInformationRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3796139169: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingCalloutRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    1648886627: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEnvironmentalImpactValue((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3200245327: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternalReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2242383968: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternallyDefinedHatchStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1040185647: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternallyDefinedSurfaceStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3207319532: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternallyDefinedSymbol((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3548104201: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternallyDefinedTextFont((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    852622518: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGridAxis((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3020489413: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIrregularTimeSeriesValue(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(1, p) : null) || []),
    2655187982: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLibraryInformation(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3452421091: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLibraryReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    4162380809: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightDistributionData(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure(p.value) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLuminousIntensityDistributionMeasure(p.value) : null) || []),
    1566485204: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightIntensityDistribution(v[0], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    30780891: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLocalTime(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHourInDay((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMinuteInHour((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSecondInMinute((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDaylightSavingHour((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1838606355: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterial(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1847130766: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialClassificationRelationship(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    248100487: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialLayer((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLogical((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3303938423: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialLayerSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1303795690: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialLayerSetUsage(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1], v[2], new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2199411900: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialList(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3265635763: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    2597039031: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMeasureWithUnit($3b8da494b8e92f36$var$TypeInitialiser(1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    4256014907: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalMaterialProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDynamicViscosityMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfElasticityMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfElasticityMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalExpansionCoefficientMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    677618848: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalSteelMaterialProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDynamicViscosityMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfElasticityMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfElasticityMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalExpansionCoefficientMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPressureMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPressureMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfElasticityMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPressureMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3368373690: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMetric(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9])),
    2706619895: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMonetaryUnit(v[0]),
    1918398963: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNamedUnit(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]),
    3701648758: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcObjectPlacement(),
    2251480897: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcObjective(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    1227763645: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOpticalMaterialProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    4251960020: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOrganization((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1411181986: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOrganizationRelationship(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1207048766: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOwnerHistory(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), v[2], v[3], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeStamp((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeStamp((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2077209135: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPerson((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel(p.value) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    101040310: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPersonAndOrganization(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2483315170: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPhysicalQuantity(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2226359599: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPhysicalSimpleQuantity(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    3355820592: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPostalAddress(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    3727388367: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedItem(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    990879717: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedSymbol(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3213052703: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedTerminatorSymbol(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1775413392: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedTextFont(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2022622350: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentationLayerAssignment(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1304840413: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentationLayerWithStyle(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3119450353: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentationStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2417041796: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentationStyleAssignment(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2095639259: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProductRepresentation((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2267347899: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProductsOfCombustionProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpecificHeatCapacityMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3958567839: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2802850158: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProfileProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    2598011224: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProperty(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3896028662: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyConstraintRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    148025276: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyDependencyRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3710013099: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyEnumeration(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    2044713172: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityArea(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2093928680: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityCount(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCountMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    931644368: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityLength(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3252649465: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityTime(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2405470396: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityVolume(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVolumeMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    825690147: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityWeight(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2692823254: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReferencesValueDocument(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1580146022: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcementBarProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCountMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    1222501353: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelaxation(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1076942058: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3377609919: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRepresentationContext((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3008791417: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRepresentationItem(),
    1660063152: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRepresentationMap(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    3679540991: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRibPlateProfileProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6]),
    2341007311: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRoot(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    448429030: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSIUnit(v[0], v[1], v[2]),
    2042790032: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionProperties(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    4165799628: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionReinforcementProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    867548509: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcShapeAspect(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4])),
    3982875396: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcShapeModel(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    4240577450: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcShapeRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3692461612: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSimpleProperty(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2273995522: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralConnectionCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2162789131: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoad((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2525727697: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadStatic((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3408363356: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadTemperature((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2830218821: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStyleModel(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3958052878: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStyledItem((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3049322572: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStyledRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1300840506: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3303107099: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleLighting(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    1607154358: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleRefraction((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    846575682: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleShading(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    1351298697: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleWithTextures(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    626085974: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceTexture((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    1290481447: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSymbolStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), $3b8da494b8e92f36$var$TypeInitialiser(1, v[1])),
    985171141: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTable((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    531007025: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTableRow(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(1, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value),
    912023232: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTelecomAddress(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel(p.value) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1447204868: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    1983826977: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyleFontModel(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextFontName(p.value) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFontStyle((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFontVariant((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFontWeight((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), $3b8da494b8e92f36$var$TypeInitialiser(1, v[5])),
    2636378356: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyleForDefinedFont(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    1640371178: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyleTextModel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextAlignment((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextDecoration((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextTransformation((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[6])),
    1484833681: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyleWithBoxCharacteristics((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[4])),
    280115917: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextureCoordinate(),
    1742049831: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextureCoordinateGenerator(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(1, p) : null) || []),
    2552916305: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextureMap(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1210645708: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextureVertex(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue(p.value) : null) || []),
    3317419933: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalMaterialProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpecificHeatCapacityMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalConductivityMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3101149627: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeSeries(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    1718945513: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeSeriesReferenceRelationship(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    581633288: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeSeriesValue(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(1, p) : null) || []),
    1377556343: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTopologicalRepresentationItem(),
    1735638870: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTopologyRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    180925521: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcUnitAssignment(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2799835756: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVertex(),
    3304826586: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVertexBasedTextureMap(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1907098498: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVertexPoint(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    891718957: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVirtualGridIntersection(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure(p.value) : null) || []),
    1065908215: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWaterProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIonConcentrationMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIonConcentrationMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIonConcentrationMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPHMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2442683028: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationOccurrence((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    962685235: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationSurfaceOccurrence((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3612888222: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationSymbolOccurrence((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2297822566: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationTextOccurrence((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3798115385: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcArbitraryClosedProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    1310608509: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcArbitraryOpenProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    2705031697: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcArbitraryProfileDefWithVoids(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    616511568: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBlobTexture((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value),
    3150382593: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCenterLineProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    647927063: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    776857604: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcColourRgb((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2542286263: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcComplexProperty(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1485152156: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompositeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    370225590: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectedFaceSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1981873012: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionCurveGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    45288368: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionPointEccentricity(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3050246964: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcContextDependentUnit(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1], new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2889183280: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConversionBasedUnit(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1], new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    3800577675: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    3632507154: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDerivedProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2273265877: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCalloutRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    1694125774: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionPair((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    3732053477: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDocumentReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    4170525392: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingPreDefinedTextFont(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3900360178: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEdge(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    476780140: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEdgeCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value),
    1860660968: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExtendedMaterialProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2556980723: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFace(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1809719519: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFaceBound(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value),
    803316827: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFaceOuterBound(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value),
    3008276851: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFaceSurface(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value),
    4219587988: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFailureConnectionCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    738692330: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFillAreaStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3857492461: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFuelProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHeatingValueMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHeatingValueMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    803998398: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeneralMaterialProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMolecularWeightMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassDensityMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1446786286: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeneralProfileProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassPerLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    3448662350: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricRepresentationContext((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCount((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 4), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    2453401579: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricRepresentationItem(),
    4142052618: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricRepresentationSubContext((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3590301190: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    178086475: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGridPlacement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    812098782: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHalfSpaceSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value),
    2445078500: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHygroscopicMaterialProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIsothermalMoistureCapacityMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVaporPermeabilityMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMoistureDiffusivityMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3905492369: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcImageTexture((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3741457305: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIrregularTimeSeries(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1402838566: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSource((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    125510826: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourceAmbient((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2604431987: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourceDirectional((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4])),
    4266656042: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourceGoniometric((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLuminousFluxMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9])),
    1520743889: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourcePositional((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3422422726: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourceSpot((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositivePlaneAngleMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositivePlaneAngleMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    2624227202: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLocalPlacement((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    1008929658: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLoop(),
    2347385850: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMappedItem(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    2022407955: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialDefinitionRepresentation((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    1430189142: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalConcreteMaterialProperties(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDynamicViscosityMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfElasticityMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfElasticityMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalExpansionCoefficientMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPressureMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    219451334: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcObjectDefinition(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2833995503: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOneDirectionRepeatFactor(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    2665983363: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOpenShell(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1029017970: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOrientedEdge(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value),
    2529465313: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterizedProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    2519244187: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPath(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3021840470: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPhysicalComplexQuantity(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    597895409: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPixelTexture((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcInteger((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcInteger((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcInteger((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? Number(p.value) : null) || []),
    2004835150: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlacement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    1663979128: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlanarExtent(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2067069095: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPoint(),
    4022376103: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPointOnCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1423911732: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPointOnSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2924175390: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPolyLoop(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2775532180: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPolygonalBoundedHalfSpace(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    759155922: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedColour(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2559016684: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedCurveFont(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    433424934: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedDimensionSymbol(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    179317114: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedPointMarkerSymbol(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    673634403: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProductDefinitionShape((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    871118103: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyBoundedValue(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4])),
    1680319473: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyDefinition(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    4166981789: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyEnumeratedValue(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(1, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    2752243245: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyListValue(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(1, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    941946838: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyReferenceValue(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    3357820518: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertySetDefinition(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3650150729: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertySingleValue(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    110355661: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyTableValue(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(1, p) : null) || [], v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(1, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    3615266464: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRectangleProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3413951693: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRegularTimeSeries(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3765753017: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcementDefinitionProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    478536968: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelationship(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2778083089: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRoundedRectangleProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    1509187699: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionedSpine(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2411513650: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcServiceLifeFactor(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[5]), $3b8da494b8e92f36$var$TypeInitialiser(1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[7])),
    4124623270: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcShellBasedSurfaceModel(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2609359061: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSlippageConnectionCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    723233188: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSolidModel(),
    2485662743: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSoundProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoolean((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1202362311: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSoundValue(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFrequencyMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[6])),
    390701378: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpaceThermalLoadProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPowerMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPowerMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), v[13]),
    1595516126: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadLinearForce((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearMomentMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearMomentMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearMomentMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    2668620305: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadPlanarForce((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlanarForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlanarForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlanarForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2473145415: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadSingleDisplacement((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1973038258: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadSingleDisplacementDistortion((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurvatureMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1597423693: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadSingleForce((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTorqueMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTorqueMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTorqueMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1190533807: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadSingleForceWarping((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTorqueMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTorqueMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTorqueMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWarpingMomentMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3843319758: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralProfileProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassPerLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMomentOfInertiaMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMomentOfInertiaMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMomentOfInertiaMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMomentOfInertiaMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWarpingConstantMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value), (v[19] ?? void 0) === void 0 || v[19] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[19] ?? void 0) === void 0 || v[19] === "" ? null : v[19].value), (v[20] ?? void 0) === void 0 || v[20] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[20] ?? void 0) === void 0 || v[20] === "" ? null : v[20].value), (v[21] ?? void 0) === void 0 || v[21] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[21] ?? void 0) === void 0 || v[21] === "" ? null : v[21].value), (v[22] ?? void 0) === void 0 || v[22] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[22] ?? void 0) === void 0 || v[22] === "" ? null : v[22].value)),
    3653947884: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralSteelProfileProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassPerLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMomentOfInertiaMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMomentOfInertiaMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMomentOfInertiaMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMomentOfInertiaMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWarpingConstantMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value), (v[19] ?? void 0) === void 0 || v[19] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[19] ?? void 0) === void 0 || v[19] === "" ? null : v[19].value), (v[20] ?? void 0) === void 0 || v[20] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure((v[20] ?? void 0) === void 0 || v[20] === "" ? null : v[20].value), (v[21] ?? void 0) === void 0 || v[21] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[21] ?? void 0) === void 0 || v[21] === "" ? null : v[21].value), (v[22] ?? void 0) === void 0 || v[22] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[22] ?? void 0) === void 0 || v[22] === "" ? null : v[22].value), (v[23] ?? void 0) === void 0 || v[23] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[23] ?? void 0) === void 0 || v[23] === "" ? null : v[23].value), (v[24] ?? void 0) === void 0 || v[24] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[24] ?? void 0) === void 0 || v[24] === "" ? null : v[24].value), (v[25] ?? void 0) === void 0 || v[25] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[25] ?? void 0) === void 0 || v[25] === "" ? null : v[25].value), (v[26] ?? void 0) === void 0 || v[26] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[26] ?? void 0) === void 0 || v[26] === "" ? null : v[26].value)),
    2233826070: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSubedge(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    2513912981: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurface(),
    1878645084: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleRendering(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[7]), v[8]),
    2247615214: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    1260650574: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSweptDiskSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    230924584: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSweptSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    3071757647: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    3028897424: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTerminatorSymbol((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    4282788508: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextLiteral(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentableText((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), v[2]),
    3124975700: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextLiteralWithExtent(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentableText((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), v[2], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoxAlignment((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2715220739: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTrapeziumProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1345879162: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTwoDirectionRepeatFactor(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    1628702193: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTypeObject(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2347495698: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTypeProduct(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    427810014: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcUShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    1417489154: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVector(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2759199220: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVertexLoop(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    336235671: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWindowLiningProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 1, v[12])),
    512836454: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWindowPanelProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8])),
    1299126871: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWindowStyle(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, (v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value),
    2543172580: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcZShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3288037868: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationCurveOccurrence((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    669184980: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationFillArea(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2265737646: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationFillAreaOccurrence((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), v[4]),
    1302238472: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    4261334040: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAxis1Placement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    3125803723: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAxis2Placement2D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    2740243338: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAxis2Placement3D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    2736907675: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBooleanResult(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    4182860854: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundedSurface(),
    2581212453: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundingBox(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2713105998: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoxedHalfSpace(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    2898889636: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1123145078: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianPoint(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure(p.value) : null) || []),
    59481748: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 4)),
    3749851601: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator2D((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 4)),
    3486308946: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator2DnonUniform((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 4), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 4)),
    3331915920: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator3D((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 4), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4])),
    1416205885: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator3DnonUniform((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 4), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 4), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 4)),
    1383045692: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCircleProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2205249479: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClosedShell(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2485617015: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompositeCurveSegment(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    4133800736: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCraneRailAShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value)),
    194851669: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCraneRailFShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    2506170314: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCsgPrimitive3D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    2147822146: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCsgSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    2601014836: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurve(),
    2827736869: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveBoundedPlane(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    693772133: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDefinedSymbol(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    606661476: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCurve((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    4054601972: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCurveTerminator((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), v[4]),
    32440307: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDirection(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? Number(p.value) : null) || []),
    2963535650: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDoorLiningProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value, 1, v[14])),
    1714330368: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDoorPanelProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8])),
    526551008: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDoorStyle(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, (v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value),
    3073041342: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingCallout(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    445594917: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingPreDefinedColour(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    4006246654: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingPreDefinedCurveFont(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1472233963: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEdgeLoop(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1883228015: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementQuantity(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    339256511: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2777663545: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementarySurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    2835456948: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEllipseProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    80994333: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEnergyProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    477187591: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExtrudedAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2047409740: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFaceBasedSurfaceModel(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    374418227: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFillAreaStyleHatching(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    4203026998: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFillAreaStyleTileSymbolWithStyle(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    315944413: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFillAreaStyleTiles(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3455213021: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFluidFlowProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value, 1, v[13]), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value, 1, v[14]), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(1, v[15]), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearVelocityMeasure((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPressureMeasure((v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value)),
    4238390223: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFurnishingElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1268542332: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFurnitureType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    987898635: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricCurveSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1484403080: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    572779678: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    1281925730: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLine(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1])),
    1425443689: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcManifoldSolidBrep(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    3888040117: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcObject(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3388369263: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOffsetCurve2D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value),
    3505215534: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOffsetCurve3D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 1, v[3])),
    3566463478: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPermeableCoveringProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8])),
    603570806: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlanarBox(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    220341763: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlane(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    2945172077: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProcess(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    4208778838: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProduct(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    103090709: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProject(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8])),
    4194566429: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProjectionCurve((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1451395588: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertySet(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3219374653: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProxy(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2770003689: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRectangleHollowProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2798486643: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRectangularPyramid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3454111270: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRectangularTrimmedSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value),
    3939117080: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssigns(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5]),
    1683148259: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToActor(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    2495723537: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToControl(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    1307041759: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToGroup(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    4278684876: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToProcess(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    2857406711: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToProduct(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    3372526763: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToProjectOrder(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    205026976: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToResource(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    1865459582: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociates(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1327628568: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesAppliedValue(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    4095574036: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesApproval(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    919958153: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesClassification(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    2728634034: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesConstraint(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    982818633: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesDocument(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    3840914261: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesLibrary(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    2655215786: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesMaterial(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    2851387026: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesProfileProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    826625072: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnects(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1204542856: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsElements(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    3945020480: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsPathElements(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? Number(p.value) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? Number(p.value) : null) || [], v[9], v[10]),
    4201705270: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsPortToElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    3190031847: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsPorts(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    2127690289: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsStructuralActivity(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    3912681535: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsStructuralElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    1638771189: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsStructuralMember(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9])),
    504942748: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsWithEccentricity(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10])),
    3678494232: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsWithRealizingElements(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3242617779: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelContainedInSpatialStructure(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    886880790: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelCoversBldgElements(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2802773753: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelCoversSpaces(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2551354335: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelDecomposes(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    693640335: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelDefines(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    4186316022: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelDefinesByProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    781010003: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelDefinesByType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    3940055652: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelFillsElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    279856033: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelFlowControlElements(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    4189434867: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelInteractionRequirements(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCountMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8])),
    3268803585: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelNests(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2051452291: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelOccupiesSpaces(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    202636808: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelOverridesProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    750771296: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelProjectsElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    1245217292: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelReferencedInSpatialStructure(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    1058617721: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelSchedulesCostItems(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    4122056220: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelSequence(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]),
    366585022: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelServicesBuildings(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3451746338: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelSpaceBoundary(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7], v[8]),
    1401173127: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelVoidsElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    2914609552: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcResource(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1856042241: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRevolvedAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    4158566097: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRightCircularCone(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3626867408: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRightCircularCylinder(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2706606064: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpatialStructureElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3893378262: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpatialStructureElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    451544542: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSphere(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3544373492: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralActivity(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8]),
    3136571912: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralItem(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    530289379: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralMember(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    3689010777: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralReaction(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8]),
    3979015343: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralSurfaceMember(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2218152070: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralSurfaceMemberVarying(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure(p.value) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10])),
    4070609034: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuredDimensionCallout(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2028607225: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceCurveSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    2809605785: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceOfLinearExtrusion(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    4124788165: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceOfRevolution(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    1580310250: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSystemFurnitureElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3473067441: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTask(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 10)),
    2097647324: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTransportElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2296667514: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcActor(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5])),
    1674181508: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotation(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    3207858831: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAsymmetricIShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    1334484129: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBlock(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3649129432: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBooleanClippingResult(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2])),
    1260505505: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundedCurve(),
    4031249490: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuilding(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 1, v[11])),
    1950629157: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3124254112: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingStorey(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    2937912522: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCircleHollowProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 1, v[2]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    300633059: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcColumnType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3732776249: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompositeCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value),
    2510884976: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConic(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    2559216714: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstructionResource(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8])),
    3293443760: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcControl(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3895139033: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCostItem(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1419761937: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCostSchedule(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), v[12]),
    1916426348: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCoveringType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3295246426: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCrewResource(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8])),
    1457835157: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurtainWallType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    681481545: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCurveDirectedCallout(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3256556792: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3849074793: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionFlowElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    360485395: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricalBaseProperties(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricVoltageMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFrequencyMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricCurrentMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricCurrentMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPowerMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPowerMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value, 10)),
    1758889154: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4123344466: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementAssembly(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    1623761950: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementComponent(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2590856083: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementComponentType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1704287377: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEllipse(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2107101300: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEnergyConversionDeviceType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1962604670: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEquipmentElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3272907226: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEquipmentStandard(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3174744832: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEvaporativeCoolerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3390157468: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEvaporatorType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    807026263: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFacetedBrep(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0])),
    3737207727: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFacetedBrepWithVoids(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    647756555: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFastener(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2489546625: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFastenerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2827207264: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFeatureElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2143335405: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFeatureElementAddition(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1287392070: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFeatureElementSubtraction(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3907093117: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowControllerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3198132628: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowFittingType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3815607619: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowMeterType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1482959167: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowMovingDeviceType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1834744321: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowSegmentType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1339347760: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowStorageDeviceType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2297155007: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowTerminalType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3009222698: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowTreatmentDeviceType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    263784265: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFurnishingElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    814719939: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFurnitureStandard(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    200128114: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGasTerminalType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3009204131: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGrid(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2706460486: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGroup(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1251058090: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHeatExchangerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1806887404: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHumidifierType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2391368822: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcInventory(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10])),
    4288270099: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcJunctionBoxType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3827777499: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLaborResource(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    1051575348: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLampType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1161773419: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightFixtureType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2506943328: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearDimension(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    377706215: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalFastener(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    2108223431: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalFastenerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3181161470: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMemberType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    977012517: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMotorConnectionType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1916936684: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMove(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 10), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 1, v[11]), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText(p.value) : null) || []),
    4143007308: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOccupant(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), v[6]),
    3588315303: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOpeningElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3425660407: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOrderAction(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 10), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    2837617999: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOutletType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2382730787: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPerformanceHistory(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3327091369: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPermit(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    804291784: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPipeFittingType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4231323485: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPipeSegmentType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4017108033: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlateType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3724593414: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPolyline(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3740093272: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPort(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    2744685151: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProcedure(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2904328755: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProjectOrder(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3642467123: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProjectOrderRecord(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[6]),
    3651124850: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProjectionElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1842657554: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProtectiveDeviceType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2250791053: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPumpType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3248260540: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRadiusDimension(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2893384427: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRailingType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2324767716: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRampFlightType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    160246688: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAggregates(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 1, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2863920197: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsTasks(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    1768891740: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSanitaryTerminalType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3517283431: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcScheduleTimeControl(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 1, v[11]), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 1, v[12]), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : (v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value, (v[19] ?? void 0) === void 0 || v[19] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[19] ?? void 0) === void 0 || v[19] === "" ? null : v[19].value, 1, v[19]), (v[20] ?? void 0) === void 0 || v[20] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[20] ?? void 0) === void 0 || v[20] === "" ? null : v[20].value), (v[21] ?? void 0) === void 0 || v[21] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[21] ?? void 0) === void 0 || v[21] === "" ? null : v[21].value), (v[22] ?? void 0) === void 0 || v[22] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure((v[22] ?? void 0) === void 0 || v[22] === "" ? null : v[22].value)),
    4105383287: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcServiceLife(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    4097777520: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSite(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompoundPlaneAngleMeasure(v[9].map((x)=>x.value)), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompoundPlaneAngleMeasure(v[10].map((x)=>x.value)), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value, 1, v[13])),
    2533589738: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSlabType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3856911033: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpace(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    1305183839: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpaceHeaterType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    652456506: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpaceProgram(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    3812236995: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpaceType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3112655638: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStackTerminalType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1039846685: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStairFlightType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    682877961: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralAction(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10])),
    1179482911: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralConnection(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    4243806635: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralCurveConnection(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    214636428: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralCurveMember(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7]),
    2445595289: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralCurveMemberVarying(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7]),
    1807405624: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLinearAction(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), v[11]),
    1721250024: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLinearActionVarying(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), v[11], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 1, v[12]), v[13]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1252848954: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadGroup(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], v[6], v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    1621171031: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPlanarAction(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), v[11]),
    3987759626: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPlanarActionVarying(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), v[11], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 1, v[12]), v[13]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    2082059205: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPointAction(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10])),
    734778138: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPointConnection(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    1235345126: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPointReaction(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), v[8]),
    2986769608: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralResultGroup(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value),
    1975003073: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralSurfaceConnection(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    148013059: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSubContractResource(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    2315554128: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSwitchingDeviceType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2254336722: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSystem(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    5716631: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTankType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1637806684: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeSeriesSchedule(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[6], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7])),
    1692211062: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTransformerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1620046519: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTransportElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCountMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    3593883385: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTrimmedCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, v[4]),
    1600972822: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTubeBundleType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1911125066: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcUnitaryEquipmentType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    728799441: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcValveType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2769231204: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVirtualElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1898987631: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWallType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1133259667: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWasteTerminalType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1028945134: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWorkControl(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 1, v[11]), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 1, v[12]), v[13], (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value)),
    4218914973: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWorkPlan(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 1, v[11]), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 1, v[12]), v[13], (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value)),
    3342526732: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWorkSchedule(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 1, v[11]), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 1, v[12]), v[13], (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value)),
    1033361043: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcZone(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1213861670: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.Ifc2DCompositeCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value),
    3821786052: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcActionRequest(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    1411407467: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAirTerminalBoxType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3352864051: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAirTerminalType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1871374353: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAirToAirHeatRecoveryType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2470393545: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAngularDimension(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3460190687: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAsset(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 1, v[7]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 1, v[9]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 1, v[10]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 1, v[11]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 1, v[12]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value, 1, v[13])),
    1967976161: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBSplineCurve(new $3b8da494b8e92f36$export$2e483f5afea275bb((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 10), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value),
    819618141: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBeamType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1916977116: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBezierCurve(new $3b8da494b8e92f36$export$2e483f5afea275bb((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 10), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value),
    231477066: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoilerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3299480353: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    52481810: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementComponent(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2979338954: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementPart(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1095909175: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementProxy(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1909888760: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementProxyType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    395041908: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCableCarrierFittingType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3293546465: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCableCarrierSegmentType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1285652485: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCableSegmentType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2951183804: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcChillerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2611217952: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCircle(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 1, v[0]), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2301859152: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCoilType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    843113511: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcColumn(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3850581409: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompressorType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2816379211: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCondenserType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2188551683: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCondition(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1163958913: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConditionCriterion(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6])),
    3898045240: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstructionEquipmentResource(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8])),
    1060000209: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstructionMaterialResource(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRatioMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    488727124: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstructionProductResource(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 1, v[8])),
    335055490: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCooledBeamType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2954562838: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCoolingTowerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1973544240: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCovering(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3495092785: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurtainWall(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3961806047: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDamperType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4147604152: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDiameterDimension(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    1335981549: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDiscreteAccessory(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2635815018: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDiscreteAccessoryType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1599208980: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionChamberElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2063403501: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionControlElementType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1945004755: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3040386961: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionFlowElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3041715199: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionPort(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), v[7]),
    395920057: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDoor(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    869906466: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDuctFittingType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3760055223: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDuctSegmentType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2030761528: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDuctSilencerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    855621170: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEdgeFeature(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    663422040: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricApplianceType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3277789161: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricFlowStorageDeviceType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1534661035: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricGeneratorType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1365060375: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricHeaterType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1217240411: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricMotorType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    712377611: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricTimeControlType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1634875225: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricalCircuit(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    857184966: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricalElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1658829314: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEnergyConversionDevice(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    346874300: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFanType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1810631287: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFilterType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4222183408: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFireSuppressionTerminalType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2058353004: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowController(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4278956645: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowFitting(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4037862832: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowInstrumentType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3132237377: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowMovingDevice(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    987401354: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowSegment(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    707683696: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowStorageDevice(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2223149337: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowTerminal(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3508470533: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowTreatmentDevice(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    900683007: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFooting(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1073191201: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMember(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1687234759: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPile(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    3171933400: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlate(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2262370178: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRailing(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3024970846: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRamp(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3283111854: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRampFlight(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3055160366: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRationalBezierCurve(new $3b8da494b8e92f36$export$2e483f5afea275bb((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 10), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? Number(p.value) : null) || []),
    3027567501: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcingElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2320036040: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcingMesh(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value)),
    2016517767: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRoof(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1376911519: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRoundedEdgeFeature(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    1783015770: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSensorType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1529196076: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSlab(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    331165859: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStair(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4252922144: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStairFlight(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 10), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$2e483f5afea275bb((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 10), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    2515109513: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralAnalysisModel(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || []),
    3824725483: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTendon(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPressureMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value)),
    2347447852: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTendonAnchor(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3313531582: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVibrationIsolatorType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2391406946: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWall(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3512223829: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWallStandardCase(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3304561284: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWindow(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    2874132201: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcActuatorType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3001207471: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAlarmType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    753842376: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBeam(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2454782716: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcChamferEdgeFeature(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    578613899: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcControllerType(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 1, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1052013943: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionChamberElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1062813311: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionControlElement(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3700593921: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricDistributionPoint(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    979691226: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcingBar(new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 1, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 1, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 1, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), v[12], v[13])
};
$3b8da494b8e92f36$export$6fc5084ea038b400[1] = {
    618182010: [
        $3b8da494b8e92f36$export$1d51c48a0d338c7d,
        $3b8da494b8e92f36$export$852f8a6b6383ece8
    ],
    411424972: [
        $3b8da494b8e92f36$export$ac02302577b36171,
        $3b8da494b8e92f36$export$61dc578b5cbce35b
    ],
    4037036970: [
        $3b8da494b8e92f36$export$cfb27e5500a39320,
        $3b8da494b8e92f36$export$229e73e933804e50,
        $3b8da494b8e92f36$export$a34702b337593132,
        $3b8da494b8e92f36$export$a08930e72563c535
    ],
    1387855156: [
        $3b8da494b8e92f36$export$cfb27e5500a39320
    ],
    3264961684: [
        $3b8da494b8e92f36$export$856784adecc150fd
    ],
    2859738748: [
        $3b8da494b8e92f36$export$6ef8b10b979d6ed7,
        $3b8da494b8e92f36$export$dc861dfbf2baaa1a,
        $3b8da494b8e92f36$export$f4030cb204e0fdd0,
        $3b8da494b8e92f36$export$415e991945a654ac,
        $3b8da494b8e92f36$export$a8e470c98a867218
    ],
    2614616156: [
        $3b8da494b8e92f36$export$415e991945a654ac
    ],
    1959218052: [
        $3b8da494b8e92f36$export$fd56761a594c90b1,
        $3b8da494b8e92f36$export$6bb698fabb80bc4f
    ],
    3796139169: [
        $3b8da494b8e92f36$export$ee0d746d8ff1888,
        $3b8da494b8e92f36$export$c979e6e85019e6b8
    ],
    3200245327: [
        $3b8da494b8e92f36$export$5dc53366ca618592,
        $3b8da494b8e92f36$export$72ed75e7fb4d773c,
        $3b8da494b8e92f36$export$96fe74a17c6cc802,
        $3b8da494b8e92f36$export$5ea64628e783fcd7,
        $3b8da494b8e92f36$export$ea241fcbff64ea22,
        $3b8da494b8e92f36$export$599e2cc9684286ad,
        $3b8da494b8e92f36$export$133f46f5e03827d2
    ],
    3265635763: [
        $3b8da494b8e92f36$export$b1f1e3ede519ae5d,
        $3b8da494b8e92f36$export$ac5310f0d6f3db5c,
        $3b8da494b8e92f36$export$d6b8bce4708b1831,
        $3b8da494b8e92f36$export$94fa95b743687d37,
        $3b8da494b8e92f36$export$82c094da49d2ff47,
        $3b8da494b8e92f36$export$662956efd4bfbec8,
        $3b8da494b8e92f36$export$e44d5de26af5ea64,
        $3b8da494b8e92f36$export$3f47c3818454d080,
        $3b8da494b8e92f36$export$4fe467dabb00dda9,
        $3b8da494b8e92f36$export$86d3411164b0d7ca,
        $3b8da494b8e92f36$export$335d88569fe87f23
    ],
    4256014907: [
        $3b8da494b8e92f36$export$4fe467dabb00dda9,
        $3b8da494b8e92f36$export$86d3411164b0d7ca
    ],
    1918398963: [
        $3b8da494b8e92f36$export$bc84a57a2afc707f,
        $3b8da494b8e92f36$export$4d644d65c6f10de9,
        $3b8da494b8e92f36$export$342dff6367faf07
    ],
    3701648758: [
        $3b8da494b8e92f36$export$34302876ddf37791,
        $3b8da494b8e92f36$export$af00f3f0f2c6d769
    ],
    2483315170: [
        $3b8da494b8e92f36$export$8334e069ea620bb8,
        $3b8da494b8e92f36$export$b383f456d1eb5728,
        $3b8da494b8e92f36$export$e5dbe5700ecba735,
        $3b8da494b8e92f36$export$ccca2dba73dadeee,
        $3b8da494b8e92f36$export$678778899caae9fb,
        $3b8da494b8e92f36$export$d48394905ba00253,
        $3b8da494b8e92f36$export$c69ac01f7bf51b3,
        $3b8da494b8e92f36$export$21edf23fe590ab33
    ],
    2226359599: [
        $3b8da494b8e92f36$export$b383f456d1eb5728,
        $3b8da494b8e92f36$export$e5dbe5700ecba735,
        $3b8da494b8e92f36$export$ccca2dba73dadeee,
        $3b8da494b8e92f36$export$678778899caae9fb,
        $3b8da494b8e92f36$export$d48394905ba00253,
        $3b8da494b8e92f36$export$c69ac01f7bf51b3
    ],
    3727388367: [
        $3b8da494b8e92f36$export$2c91bae7185bb7c5,
        $3b8da494b8e92f36$export$42292ad7a949ca7e,
        $3b8da494b8e92f36$export$2a79ce8e6dde1605,
        $3b8da494b8e92f36$export$d18f4beaf4701e94,
        $3b8da494b8e92f36$export$bb01581d91f365d6,
        $3b8da494b8e92f36$export$56d725cc20359b33,
        $3b8da494b8e92f36$export$e24694355c430317,
        $3b8da494b8e92f36$export$e8b651e9570a42fe,
        $3b8da494b8e92f36$export$3285d659f1d95448,
        $3b8da494b8e92f36$export$676596d7c04e166c,
        $3b8da494b8e92f36$export$dd39b62503026d92
    ],
    990879717: [
        $3b8da494b8e92f36$export$e8b651e9570a42fe,
        $3b8da494b8e92f36$export$3285d659f1d95448,
        $3b8da494b8e92f36$export$676596d7c04e166c
    ],
    1775413392: [
        $3b8da494b8e92f36$export$bb01581d91f365d6,
        $3b8da494b8e92f36$export$56d725cc20359b33
    ],
    2022622350: [
        $3b8da494b8e92f36$export$c9ca953ef790beab
    ],
    3119450353: [
        $3b8da494b8e92f36$export$868aba9d7912640,
        $3b8da494b8e92f36$export$4c036fdbe809739e,
        $3b8da494b8e92f36$export$6f91f48d17dc7f0c,
        $3b8da494b8e92f36$export$5ae10812dce15666,
        $3b8da494b8e92f36$export$922b2a5ffa4eee3e
    ],
    2095639259: [
        $3b8da494b8e92f36$export$6d55f5b363d70c84,
        $3b8da494b8e92f36$export$95d5078ec273e20a
    ],
    3958567839: [
        $3b8da494b8e92f36$export$78c21ee34d1c97a2,
        $3b8da494b8e92f36$export$9f98ad7f69b4,
        $3b8da494b8e92f36$export$4f772a6ff028612d,
        $3b8da494b8e92f36$export$6cce02eb19410fd6,
        $3b8da494b8e92f36$export$27d54c1ce100f08f,
        $3b8da494b8e92f36$export$c9619b4f25a6fec9,
        $3b8da494b8e92f36$export$9bf9b7d525eb98c7,
        $3b8da494b8e92f36$export$509dfb8dfad057e9,
        $3b8da494b8e92f36$export$6659a6bebb9ff076,
        $3b8da494b8e92f36$export$3e010693b51db065,
        $3b8da494b8e92f36$export$5046f8ea20f33c53,
        $3b8da494b8e92f36$export$6a6339501d69dda6,
        $3b8da494b8e92f36$export$24e4f709acf9819a,
        $3b8da494b8e92f36$export$2c0c343d0211b12a,
        $3b8da494b8e92f36$export$bb7bafb36fa737d0,
        $3b8da494b8e92f36$export$9d1f507a1764cea9,
        $3b8da494b8e92f36$export$81a199afe8025f54,
        $3b8da494b8e92f36$export$1a193eff9b81238c,
        $3b8da494b8e92f36$export$a749204998f5a3c,
        $3b8da494b8e92f36$export$3c5dfd8f9406db1,
        $3b8da494b8e92f36$export$40359089e4e5f50d,
        $3b8da494b8e92f36$export$7d329955417ee03b,
        $3b8da494b8e92f36$export$17c544e73ae3a145
    ],
    2802850158: [
        $3b8da494b8e92f36$export$6757c80a00accad7,
        $3b8da494b8e92f36$export$41a1f0e241a2a28b,
        $3b8da494b8e92f36$export$3a196dd363119ece,
        $3b8da494b8e92f36$export$811553376c3d20a1
    ],
    2598011224: [
        $3b8da494b8e92f36$export$ea419368a3085d41,
        $3b8da494b8e92f36$export$18fc149087e3c79f,
        $3b8da494b8e92f36$export$9f8310d680636df4,
        $3b8da494b8e92f36$export$2d97768d0015dccc,
        $3b8da494b8e92f36$export$b40b280750874c4,
        $3b8da494b8e92f36$export$421fb9d9a3f56509,
        $3b8da494b8e92f36$export$2ee49241e76b8d88,
        $3b8da494b8e92f36$export$15997dea423f274a
    ],
    1076942058: [
        $3b8da494b8e92f36$export$e8d16de4476cf00b,
        $3b8da494b8e92f36$export$feba35570752eed7,
        $3b8da494b8e92f36$export$5f0eb5061797e589,
        $3b8da494b8e92f36$export$982f17a83654a1a9,
        $3b8da494b8e92f36$export$2e35095825dbcf3c
    ],
    3377609919: [
        $3b8da494b8e92f36$export$c78a940a5c4e916a,
        $3b8da494b8e92f36$export$b1afc9e5bea6b0b5
    ],
    3008791417: [
        $3b8da494b8e92f36$export$f6578324c1ae7b2d,
        $3b8da494b8e92f36$export$9aea5e4278bdf41,
        $3b8da494b8e92f36$export$5de1881e0274940,
        $3b8da494b8e92f36$export$521bada8515ab976,
        $3b8da494b8e92f36$export$5549d05fc93b536b,
        $3b8da494b8e92f36$export$76ac35741e93e1e3,
        $3b8da494b8e92f36$export$ae18b145d18a65a0,
        $3b8da494b8e92f36$export$19fc29e00d5d6f73,
        $3b8da494b8e92f36$export$8273fbcc9f6a7487,
        $3b8da494b8e92f36$export$7f49599a30af57cd,
        $3b8da494b8e92f36$export$52fe4a955de5eb0a,
        $3b8da494b8e92f36$export$b6cea144bed9ade0,
        $3b8da494b8e92f36$export$ef6ede6699415aa4,
        $3b8da494b8e92f36$export$57bc436ff3f2a5b4,
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f,
        $3b8da494b8e92f36$export$ec4770aab56c805f,
        $3b8da494b8e92f36$export$17a178252d8924e1,
        $3b8da494b8e92f36$export$e6f3e3864604f581,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$b19edc019cfe9de6,
        $3b8da494b8e92f36$export$7952e91536a239e7,
        $3b8da494b8e92f36$export$cddab537799fe2fd,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43,
        $3b8da494b8e92f36$export$6c79cacc663fc254,
        $3b8da494b8e92f36$export$5f769669c17cd7be,
        $3b8da494b8e92f36$export$aba424e86850f717,
        $3b8da494b8e92f36$export$2a2b17b32d1a9938,
        $3b8da494b8e92f36$export$f1de0c39f08c8646,
        $3b8da494b8e92f36$export$36783435db2b01a1,
        $3b8da494b8e92f36$export$d414ecd4014891b0,
        $3b8da494b8e92f36$export$5655bbb83559ae0a,
        $3b8da494b8e92f36$export$d919945f72bbea0b,
        $3b8da494b8e92f36$export$64fbfc27b4cec02a,
        $3b8da494b8e92f36$export$843f1ace19c7b757,
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252,
        $3b8da494b8e92f36$export$88babb7bc763dabe,
        $3b8da494b8e92f36$export$86be59b19ba0bac8,
        $3b8da494b8e92f36$export$36a18b804a497897,
        $3b8da494b8e92f36$export$a340b94c3a9627f5,
        $3b8da494b8e92f36$export$a93e600de3d261bf,
        $3b8da494b8e92f36$export$3812c41bd5a38c31,
        $3b8da494b8e92f36$export$6b50b93a9a443e09,
        $3b8da494b8e92f36$export$aa7ed498f6d760b8,
        $3b8da494b8e92f36$export$fd5f089562b081f9,
        $3b8da494b8e92f36$export$baa116807524c06e,
        $3b8da494b8e92f36$export$32b9b3ebd4722148,
        $3b8da494b8e92f36$export$60c94e2d2eb3ae2d,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$7a8fab203344ee59,
        $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b,
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a,
        $3b8da494b8e92f36$export$e7d69479b3ed50b5,
        $3b8da494b8e92f36$export$aea7582eed012cfd,
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$212932c39cad14c1,
        $3b8da494b8e92f36$export$a7c9a308bd61791e,
        $3b8da494b8e92f36$export$2ef492eaafc1544a,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$db3cb7c28fcdcb12,
        $3b8da494b8e92f36$export$1fe9373d30daf09d,
        $3b8da494b8e92f36$export$f0268edfa147e5dc,
        $3b8da494b8e92f36$export$9de8356191dd818,
        $3b8da494b8e92f36$export$929165ba65228ecd,
        $3b8da494b8e92f36$export$8923f08b310dd8eb,
        $3b8da494b8e92f36$export$f9263ceb04bc6af7,
        $3b8da494b8e92f36$export$f181705801de6aa3,
        $3b8da494b8e92f36$export$a8dfee375f66477,
        $3b8da494b8e92f36$export$53e8d872a4770e53,
        $3b8da494b8e92f36$export$51d4dba1ae2d8f1b,
        $3b8da494b8e92f36$export$307e928f69359e15,
        $3b8da494b8e92f36$export$ad8e83777baa8a31,
        $3b8da494b8e92f36$export$48039412bed87667,
        $3b8da494b8e92f36$export$1ed081495b7a3a30,
        $3b8da494b8e92f36$export$3204ea49f2718d42,
        $3b8da494b8e92f36$export$f91087a08c2974c5,
        $3b8da494b8e92f36$export$a205ad382a675d9,
        $3b8da494b8e92f36$export$7d2f047f3374cd6d,
        $3b8da494b8e92f36$export$91b809c3774b52ca,
        $3b8da494b8e92f36$export$8799bf99f01d0b68,
        $3b8da494b8e92f36$export$117debe45e2ae49d,
        $3b8da494b8e92f36$export$ebd3184cd8b065fd,
        $3b8da494b8e92f36$export$e569b2ccaf52a8fd,
        $3b8da494b8e92f36$export$fc934d2c514a6d85,
        $3b8da494b8e92f36$export$20db6cfb2db45f44,
        $3b8da494b8e92f36$export$70c90f142bc37811,
        $3b8da494b8e92f36$export$a321d78f5cb9ca4f,
        $3b8da494b8e92f36$export$52eaa2d341700ec1,
        $3b8da494b8e92f36$export$804200e8992a9b20,
        $3b8da494b8e92f36$export$e209a4a7e118ebd5,
        $3b8da494b8e92f36$export$1dcd1852764e4fb7,
        $3b8da494b8e92f36$export$c75f1a12de9d86b8,
        $3b8da494b8e92f36$export$720f149ff6c3542a,
        $3b8da494b8e92f36$export$3534ea9b1da643f3,
        $3b8da494b8e92f36$export$5a54e2173db7aff1,
        $3b8da494b8e92f36$export$6c1d729adeeaed4a,
        $3b8da494b8e92f36$export$a88a630c8a34962c,
        $3b8da494b8e92f36$export$3d22c077bdb90a75,
        $3b8da494b8e92f36$export$7beb7cab9d3e2b14,
        $3b8da494b8e92f36$export$4b2fd6d0e55ecfa0,
        $3b8da494b8e92f36$export$8176d17ddc845867,
        $3b8da494b8e92f36$export$dd210e591847e415,
        $3b8da494b8e92f36$export$873d7c14f646e598,
        $3b8da494b8e92f36$export$5993765fc33cd311,
        $3b8da494b8e92f36$export$c780a52ecdcabf01,
        $3b8da494b8e92f36$export$d82e092cbe83635,
        $3b8da494b8e92f36$export$68ad2a8fa72d7d5d,
        $3b8da494b8e92f36$export$1392625c61300e87,
        $3b8da494b8e92f36$export$d5bdd4bede6134ba,
        $3b8da494b8e92f36$export$1da0b60eaa4646c7,
        $3b8da494b8e92f36$export$4236824d5abac42e,
        $3b8da494b8e92f36$export$a344fd0eadbfecfd,
        $3b8da494b8e92f36$export$bbe7a575e2c472c,
        $3b8da494b8e92f36$export$16bf2d4e6d976d3f,
        $3b8da494b8e92f36$export$5f6c4319f2d45df8,
        $3b8da494b8e92f36$export$2cb306ee14038b5b,
        $3b8da494b8e92f36$export$b718d0ddc70e8826
    ],
    2341007311: [
        $3b8da494b8e92f36$export$813f9cf6a2209fec,
        $3b8da494b8e92f36$export$9ec66581628a6b51,
        $3b8da494b8e92f36$export$bc9bd707c4403985,
        $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
        $3b8da494b8e92f36$export$cff3fa05b2018b59,
        $3b8da494b8e92f36$export$b1832f175144bc77,
        $3b8da494b8e92f36$export$2e330e8e36019063,
        $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
        $3b8da494b8e92f36$export$a712aed3e137585e,
        $3b8da494b8e92f36$export$c331bec3b085e9a1,
        $3b8da494b8e92f36$export$2bafde249aab99b4,
        $3b8da494b8e92f36$export$8d69d79340327b03,
        $3b8da494b8e92f36$export$d35785e0f77dbe69,
        $3b8da494b8e92f36$export$4ebf013b2eb5605,
        $3b8da494b8e92f36$export$9cb68f339a367600,
        $3b8da494b8e92f36$export$51e6468498cab028,
        $3b8da494b8e92f36$export$20528f2adfe8dc9c,
        $3b8da494b8e92f36$export$9572797f2851b0,
        $3b8da494b8e92f36$export$b933598a67b23044,
        $3b8da494b8e92f36$export$976ca854e309f825,
        $3b8da494b8e92f36$export$1fe9178d23052979,
        $3b8da494b8e92f36$export$7d39bda8b7b90f7,
        $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
        $3b8da494b8e92f36$export$94d1e1fe7b940759,
        $3b8da494b8e92f36$export$2b794d8b645d7087,
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c,
        $3b8da494b8e92f36$export$4a59ec454710396a,
        $3b8da494b8e92f36$export$a636087bbbf1a084,
        $3b8da494b8e92f36$export$5a451f1021e76496,
        $3b8da494b8e92f36$export$90569318bbf3a5cb,
        $3b8da494b8e92f36$export$3fd59b6be292fb81,
        $3b8da494b8e92f36$export$8bef70def9fcccef,
        $3b8da494b8e92f36$export$8f026b620b6b36d2,
        $3b8da494b8e92f36$export$89d3022d89ef3649,
        $3b8da494b8e92f36$export$c7eeffff290e6124,
        $3b8da494b8e92f36$export$b56f06451667ac1c,
        $3b8da494b8e92f36$export$87c3ff288d974d02,
        $3b8da494b8e92f36$export$5c698c7bb50b493,
        $3b8da494b8e92f36$export$422809562a8398de,
        $3b8da494b8e92f36$export$a48481dfef95f4a2,
        $3b8da494b8e92f36$export$95d386c017712592,
        $3b8da494b8e92f36$export$c384581c6776ce3d,
        $3b8da494b8e92f36$export$f0bc40d4cf9f4c13,
        $3b8da494b8e92f36$export$85c864d0fb1c21,
        $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
        $3b8da494b8e92f36$export$948a40ccb5d8f52c,
        $3b8da494b8e92f36$export$d988060319005ccc,
        $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
        $3b8da494b8e92f36$export$6c8179c0d6d08ecd,
        $3b8da494b8e92f36$export$11ccca7a6068fc2c,
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$fb207e5dcb39ff56,
        $3b8da494b8e92f36$export$5bea4c09e53ad038,
        $3b8da494b8e92f36$export$4b188b7ebea22345,
        $3b8da494b8e92f36$export$ae9001e98ea773dd,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$e6b8d999588bbfb0,
        $3b8da494b8e92f36$export$73f1ed87b1382872,
        $3b8da494b8e92f36$export$ac74d5ae1cf456e2,
        $3b8da494b8e92f36$export$6647f951c3b0d1f4,
        $3b8da494b8e92f36$export$b58a07450f76f5f4,
        $3b8da494b8e92f36$export$de24c94bb0d02a47,
        $3b8da494b8e92f36$export$c97535012f6ac326,
        $3b8da494b8e92f36$export$e6a1bbf1fc25125c,
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$96fd1f1884f8293c,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09,
        $3b8da494b8e92f36$export$f43ad39311bcb56,
        $3b8da494b8e92f36$export$362a10b06c97d57d,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$5d02e5cc9d3a330c,
        $3b8da494b8e92f36$export$cd44f8494212d99d,
        $3b8da494b8e92f36$export$60907473f1c7f6ac,
        $3b8da494b8e92f36$export$1525fe60aac5b17a,
        $3b8da494b8e92f36$export$5271976935958385,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$1d7ec19524492a0a,
        $3b8da494b8e92f36$export$f37c9444cc9075c7,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c,
        $3b8da494b8e92f36$export$573337cb0f58bf7b,
        $3b8da494b8e92f36$export$4690a2f5205975d8,
        $3b8da494b8e92f36$export$d4f0edab93018f7f,
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1,
        $3b8da494b8e92f36$export$5591fe75469fbc36,
        $3b8da494b8e92f36$export$7bec46e80091ced6,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$26adc90518fc7f55,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$8388c401d8add90d,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$be6eacb56fb6c8fb,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$7a3c6c08717af1a3,
        $3b8da494b8e92f36$export$defa1f0c8fe66659,
        $3b8da494b8e92f36$export$b194eecedbff75e1,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$d2225c8afda26732,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$17e11e354f64283f,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$f4c53f192a3ea7a1,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$ecd13d53d7a4573e,
        $3b8da494b8e92f36$export$91748340fd72a888,
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$e4d201a36f1cfffd,
        $3b8da494b8e92f36$export$1661c90a4afb2a0e,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6,
        $3b8da494b8e92f36$export$22d84e75fa702951,
        $3b8da494b8e92f36$export$aa818ced04ed1ad6,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$32bafd879e2dddb5,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$199e9b07f076c19c,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$d1d6e43b67173127,
        $3b8da494b8e92f36$export$e8d5f91a47737ca2,
        $3b8da494b8e92f36$export$fe64d2939a7bcd9f,
        $3b8da494b8e92f36$export$9418e91392f50813,
        $3b8da494b8e92f36$export$933e35db50e6a51e
    ],
    3982875396: [
        $3b8da494b8e92f36$export$5f0eb5061797e589,
        $3b8da494b8e92f36$export$982f17a83654a1a9
    ],
    3692461612: [
        $3b8da494b8e92f36$export$18fc149087e3c79f,
        $3b8da494b8e92f36$export$9f8310d680636df4,
        $3b8da494b8e92f36$export$2d97768d0015dccc,
        $3b8da494b8e92f36$export$b40b280750874c4,
        $3b8da494b8e92f36$export$421fb9d9a3f56509,
        $3b8da494b8e92f36$export$2ee49241e76b8d88
    ],
    2273995522: [
        $3b8da494b8e92f36$export$7bbc953ffa23813a,
        $3b8da494b8e92f36$export$b4e4bbdecfda501
    ],
    2162789131: [
        $3b8da494b8e92f36$export$34a05c9e12c53c23,
        $3b8da494b8e92f36$export$a413c76fb80f2f8f,
        $3b8da494b8e92f36$export$3787e1faec59f84d,
        $3b8da494b8e92f36$export$17bdef5f951eb73a,
        $3b8da494b8e92f36$export$ceebe0114638d080,
        $3b8da494b8e92f36$export$1256946afdc9c505,
        $3b8da494b8e92f36$export$6b91369e24532c08,
        $3b8da494b8e92f36$export$2488f86e43e28df
    ],
    2525727697: [
        $3b8da494b8e92f36$export$34a05c9e12c53c23,
        $3b8da494b8e92f36$export$a413c76fb80f2f8f,
        $3b8da494b8e92f36$export$3787e1faec59f84d,
        $3b8da494b8e92f36$export$17bdef5f951eb73a,
        $3b8da494b8e92f36$export$ceebe0114638d080,
        $3b8da494b8e92f36$export$1256946afdc9c505,
        $3b8da494b8e92f36$export$6b91369e24532c08
    ],
    2830218821: [
        $3b8da494b8e92f36$export$e8d16de4476cf00b
    ],
    3958052878: [
        $3b8da494b8e92f36$export$68ad2a8fa72d7d5d,
        $3b8da494b8e92f36$export$1392625c61300e87,
        $3b8da494b8e92f36$export$d5bdd4bede6134ba,
        $3b8da494b8e92f36$export$1da0b60eaa4646c7,
        $3b8da494b8e92f36$export$4236824d5abac42e,
        $3b8da494b8e92f36$export$a344fd0eadbfecfd,
        $3b8da494b8e92f36$export$bbe7a575e2c472c,
        $3b8da494b8e92f36$export$16bf2d4e6d976d3f,
        $3b8da494b8e92f36$export$5f6c4319f2d45df8,
        $3b8da494b8e92f36$export$2cb306ee14038b5b
    ],
    846575682: [
        $3b8da494b8e92f36$export$102bd971c14ba988
    ],
    626085974: [
        $3b8da494b8e92f36$export$d3d6625d33fe749f,
        $3b8da494b8e92f36$export$28f95f3a6633e96f,
        $3b8da494b8e92f36$export$cdda591705a51882
    ],
    280115917: [
        $3b8da494b8e92f36$export$925b578047892bce,
        $3b8da494b8e92f36$export$cc681b8347ae2d28
    ],
    3101149627: [
        $3b8da494b8e92f36$export$3535b249460c70df,
        $3b8da494b8e92f36$export$9fb6085672705774
    ],
    1377556343: [
        $3b8da494b8e92f36$export$52eaa2d341700ec1,
        $3b8da494b8e92f36$export$804200e8992a9b20,
        $3b8da494b8e92f36$export$e209a4a7e118ebd5,
        $3b8da494b8e92f36$export$1dcd1852764e4fb7,
        $3b8da494b8e92f36$export$c75f1a12de9d86b8,
        $3b8da494b8e92f36$export$720f149ff6c3542a,
        $3b8da494b8e92f36$export$3534ea9b1da643f3,
        $3b8da494b8e92f36$export$5a54e2173db7aff1,
        $3b8da494b8e92f36$export$6c1d729adeeaed4a,
        $3b8da494b8e92f36$export$a88a630c8a34962c,
        $3b8da494b8e92f36$export$3d22c077bdb90a75,
        $3b8da494b8e92f36$export$7beb7cab9d3e2b14,
        $3b8da494b8e92f36$export$4b2fd6d0e55ecfa0,
        $3b8da494b8e92f36$export$8176d17ddc845867,
        $3b8da494b8e92f36$export$dd210e591847e415,
        $3b8da494b8e92f36$export$873d7c14f646e598,
        $3b8da494b8e92f36$export$5993765fc33cd311,
        $3b8da494b8e92f36$export$c780a52ecdcabf01
    ],
    2799835756: [
        $3b8da494b8e92f36$export$5993765fc33cd311
    ],
    2442683028: [
        $3b8da494b8e92f36$export$68ad2a8fa72d7d5d,
        $3b8da494b8e92f36$export$1392625c61300e87,
        $3b8da494b8e92f36$export$d5bdd4bede6134ba,
        $3b8da494b8e92f36$export$1da0b60eaa4646c7,
        $3b8da494b8e92f36$export$4236824d5abac42e,
        $3b8da494b8e92f36$export$a344fd0eadbfecfd,
        $3b8da494b8e92f36$export$bbe7a575e2c472c,
        $3b8da494b8e92f36$export$16bf2d4e6d976d3f,
        $3b8da494b8e92f36$export$5f6c4319f2d45df8
    ],
    3612888222: [
        $3b8da494b8e92f36$export$a344fd0eadbfecfd,
        $3b8da494b8e92f36$export$bbe7a575e2c472c
    ],
    3798115385: [
        $3b8da494b8e92f36$export$7d329955417ee03b
    ],
    1310608509: [
        $3b8da494b8e92f36$export$3c5dfd8f9406db1
    ],
    370225590: [
        $3b8da494b8e92f36$export$8176d17ddc845867,
        $3b8da494b8e92f36$export$dd210e591847e415
    ],
    3900360178: [
        $3b8da494b8e92f36$export$a88a630c8a34962c,
        $3b8da494b8e92f36$export$3d22c077bdb90a75,
        $3b8da494b8e92f36$export$7beb7cab9d3e2b14
    ],
    2556980723: [
        $3b8da494b8e92f36$export$5a54e2173db7aff1
    ],
    1809719519: [
        $3b8da494b8e92f36$export$720f149ff6c3542a
    ],
    1446786286: [
        $3b8da494b8e92f36$export$6757c80a00accad7,
        $3b8da494b8e92f36$export$41a1f0e241a2a28b
    ],
    3448662350: [
        $3b8da494b8e92f36$export$c78a940a5c4e916a
    ],
    2453401579: [
        $3b8da494b8e92f36$export$9aea5e4278bdf41,
        $3b8da494b8e92f36$export$5de1881e0274940,
        $3b8da494b8e92f36$export$521bada8515ab976,
        $3b8da494b8e92f36$export$5549d05fc93b536b,
        $3b8da494b8e92f36$export$76ac35741e93e1e3,
        $3b8da494b8e92f36$export$ae18b145d18a65a0,
        $3b8da494b8e92f36$export$19fc29e00d5d6f73,
        $3b8da494b8e92f36$export$8273fbcc9f6a7487,
        $3b8da494b8e92f36$export$7f49599a30af57cd,
        $3b8da494b8e92f36$export$52fe4a955de5eb0a,
        $3b8da494b8e92f36$export$b6cea144bed9ade0,
        $3b8da494b8e92f36$export$ef6ede6699415aa4,
        $3b8da494b8e92f36$export$57bc436ff3f2a5b4,
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f,
        $3b8da494b8e92f36$export$ec4770aab56c805f,
        $3b8da494b8e92f36$export$17a178252d8924e1,
        $3b8da494b8e92f36$export$e6f3e3864604f581,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$b19edc019cfe9de6,
        $3b8da494b8e92f36$export$7952e91536a239e7,
        $3b8da494b8e92f36$export$cddab537799fe2fd,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43,
        $3b8da494b8e92f36$export$6c79cacc663fc254,
        $3b8da494b8e92f36$export$5f769669c17cd7be,
        $3b8da494b8e92f36$export$aba424e86850f717,
        $3b8da494b8e92f36$export$2a2b17b32d1a9938,
        $3b8da494b8e92f36$export$f1de0c39f08c8646,
        $3b8da494b8e92f36$export$36783435db2b01a1,
        $3b8da494b8e92f36$export$d414ecd4014891b0,
        $3b8da494b8e92f36$export$5655bbb83559ae0a,
        $3b8da494b8e92f36$export$d919945f72bbea0b,
        $3b8da494b8e92f36$export$64fbfc27b4cec02a,
        $3b8da494b8e92f36$export$843f1ace19c7b757,
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252,
        $3b8da494b8e92f36$export$88babb7bc763dabe,
        $3b8da494b8e92f36$export$86be59b19ba0bac8,
        $3b8da494b8e92f36$export$36a18b804a497897,
        $3b8da494b8e92f36$export$a340b94c3a9627f5,
        $3b8da494b8e92f36$export$a93e600de3d261bf,
        $3b8da494b8e92f36$export$3812c41bd5a38c31,
        $3b8da494b8e92f36$export$6b50b93a9a443e09,
        $3b8da494b8e92f36$export$aa7ed498f6d760b8,
        $3b8da494b8e92f36$export$fd5f089562b081f9,
        $3b8da494b8e92f36$export$baa116807524c06e,
        $3b8da494b8e92f36$export$32b9b3ebd4722148,
        $3b8da494b8e92f36$export$60c94e2d2eb3ae2d,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$7a8fab203344ee59,
        $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b,
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a,
        $3b8da494b8e92f36$export$e7d69479b3ed50b5,
        $3b8da494b8e92f36$export$aea7582eed012cfd,
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$212932c39cad14c1,
        $3b8da494b8e92f36$export$a7c9a308bd61791e,
        $3b8da494b8e92f36$export$2ef492eaafc1544a,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$db3cb7c28fcdcb12,
        $3b8da494b8e92f36$export$1fe9373d30daf09d,
        $3b8da494b8e92f36$export$f0268edfa147e5dc,
        $3b8da494b8e92f36$export$9de8356191dd818,
        $3b8da494b8e92f36$export$929165ba65228ecd,
        $3b8da494b8e92f36$export$8923f08b310dd8eb,
        $3b8da494b8e92f36$export$f9263ceb04bc6af7,
        $3b8da494b8e92f36$export$f181705801de6aa3,
        $3b8da494b8e92f36$export$a8dfee375f66477,
        $3b8da494b8e92f36$export$53e8d872a4770e53,
        $3b8da494b8e92f36$export$51d4dba1ae2d8f1b,
        $3b8da494b8e92f36$export$307e928f69359e15,
        $3b8da494b8e92f36$export$ad8e83777baa8a31,
        $3b8da494b8e92f36$export$48039412bed87667,
        $3b8da494b8e92f36$export$1ed081495b7a3a30,
        $3b8da494b8e92f36$export$3204ea49f2718d42,
        $3b8da494b8e92f36$export$f91087a08c2974c5,
        $3b8da494b8e92f36$export$a205ad382a675d9,
        $3b8da494b8e92f36$export$7d2f047f3374cd6d,
        $3b8da494b8e92f36$export$91b809c3774b52ca,
        $3b8da494b8e92f36$export$8799bf99f01d0b68,
        $3b8da494b8e92f36$export$117debe45e2ae49d,
        $3b8da494b8e92f36$export$ebd3184cd8b065fd,
        $3b8da494b8e92f36$export$e569b2ccaf52a8fd,
        $3b8da494b8e92f36$export$fc934d2c514a6d85,
        $3b8da494b8e92f36$export$20db6cfb2db45f44,
        $3b8da494b8e92f36$export$70c90f142bc37811
    ],
    3590301190: [
        $3b8da494b8e92f36$export$20db6cfb2db45f44
    ],
    812098782: [
        $3b8da494b8e92f36$export$ebd3184cd8b065fd,
        $3b8da494b8e92f36$export$e569b2ccaf52a8fd
    ],
    1402838566: [
        $3b8da494b8e92f36$export$f91087a08c2974c5,
        $3b8da494b8e92f36$export$a205ad382a675d9,
        $3b8da494b8e92f36$export$7d2f047f3374cd6d,
        $3b8da494b8e92f36$export$91b809c3774b52ca,
        $3b8da494b8e92f36$export$8799bf99f01d0b68
    ],
    1520743889: [
        $3b8da494b8e92f36$export$f91087a08c2974c5
    ],
    1008929658: [
        $3b8da494b8e92f36$export$804200e8992a9b20,
        $3b8da494b8e92f36$export$e209a4a7e118ebd5,
        $3b8da494b8e92f36$export$1dcd1852764e4fb7
    ],
    219451334: [
        $3b8da494b8e92f36$export$e6a1bbf1fc25125c,
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$96fd1f1884f8293c,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09,
        $3b8da494b8e92f36$export$f43ad39311bcb56,
        $3b8da494b8e92f36$export$362a10b06c97d57d,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$5d02e5cc9d3a330c,
        $3b8da494b8e92f36$export$cd44f8494212d99d,
        $3b8da494b8e92f36$export$60907473f1c7f6ac,
        $3b8da494b8e92f36$export$1525fe60aac5b17a,
        $3b8da494b8e92f36$export$5271976935958385,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$1d7ec19524492a0a,
        $3b8da494b8e92f36$export$f37c9444cc9075c7,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c,
        $3b8da494b8e92f36$export$573337cb0f58bf7b,
        $3b8da494b8e92f36$export$4690a2f5205975d8,
        $3b8da494b8e92f36$export$d4f0edab93018f7f,
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1,
        $3b8da494b8e92f36$export$5591fe75469fbc36,
        $3b8da494b8e92f36$export$7bec46e80091ced6,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$26adc90518fc7f55,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$8388c401d8add90d,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$be6eacb56fb6c8fb,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$7a3c6c08717af1a3,
        $3b8da494b8e92f36$export$defa1f0c8fe66659,
        $3b8da494b8e92f36$export$b194eecedbff75e1,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$d2225c8afda26732,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$17e11e354f64283f,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$f4c53f192a3ea7a1,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$ecd13d53d7a4573e,
        $3b8da494b8e92f36$export$91748340fd72a888,
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$e4d201a36f1cfffd,
        $3b8da494b8e92f36$export$1661c90a4afb2a0e,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6,
        $3b8da494b8e92f36$export$22d84e75fa702951,
        $3b8da494b8e92f36$export$aa818ced04ed1ad6,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$32bafd879e2dddb5,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$199e9b07f076c19c,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$d1d6e43b67173127,
        $3b8da494b8e92f36$export$e8d5f91a47737ca2,
        $3b8da494b8e92f36$export$fe64d2939a7bcd9f,
        $3b8da494b8e92f36$export$9418e91392f50813
    ],
    2833995503: [
        $3b8da494b8e92f36$export$1ed081495b7a3a30
    ],
    2529465313: [
        $3b8da494b8e92f36$export$78c21ee34d1c97a2,
        $3b8da494b8e92f36$export$9f98ad7f69b4,
        $3b8da494b8e92f36$export$4f772a6ff028612d,
        $3b8da494b8e92f36$export$6cce02eb19410fd6,
        $3b8da494b8e92f36$export$27d54c1ce100f08f,
        $3b8da494b8e92f36$export$c9619b4f25a6fec9,
        $3b8da494b8e92f36$export$9bf9b7d525eb98c7,
        $3b8da494b8e92f36$export$509dfb8dfad057e9,
        $3b8da494b8e92f36$export$6659a6bebb9ff076,
        $3b8da494b8e92f36$export$3e010693b51db065,
        $3b8da494b8e92f36$export$5046f8ea20f33c53,
        $3b8da494b8e92f36$export$6a6339501d69dda6,
        $3b8da494b8e92f36$export$24e4f709acf9819a,
        $3b8da494b8e92f36$export$2c0c343d0211b12a,
        $3b8da494b8e92f36$export$bb7bafb36fa737d0,
        $3b8da494b8e92f36$export$9d1f507a1764cea9
    ],
    2004835150: [
        $3b8da494b8e92f36$export$51d4dba1ae2d8f1b,
        $3b8da494b8e92f36$export$307e928f69359e15,
        $3b8da494b8e92f36$export$ad8e83777baa8a31
    ],
    1663979128: [
        $3b8da494b8e92f36$export$a8dfee375f66477
    ],
    2067069095: [
        $3b8da494b8e92f36$export$929165ba65228ecd,
        $3b8da494b8e92f36$export$8923f08b310dd8eb,
        $3b8da494b8e92f36$export$f9263ceb04bc6af7
    ],
    759155922: [
        $3b8da494b8e92f36$export$2a79ce8e6dde1605
    ],
    2559016684: [
        $3b8da494b8e92f36$export$2c91bae7185bb7c5
    ],
    1680319473: [
        $3b8da494b8e92f36$export$11ccca7a6068fc2c,
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$fb207e5dcb39ff56,
        $3b8da494b8e92f36$export$5bea4c09e53ad038,
        $3b8da494b8e92f36$export$4b188b7ebea22345,
        $3b8da494b8e92f36$export$ae9001e98ea773dd,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$e6b8d999588bbfb0,
        $3b8da494b8e92f36$export$73f1ed87b1382872,
        $3b8da494b8e92f36$export$ac74d5ae1cf456e2,
        $3b8da494b8e92f36$export$6647f951c3b0d1f4,
        $3b8da494b8e92f36$export$b58a07450f76f5f4,
        $3b8da494b8e92f36$export$de24c94bb0d02a47
    ],
    3357820518: [
        $3b8da494b8e92f36$export$11ccca7a6068fc2c,
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$fb207e5dcb39ff56,
        $3b8da494b8e92f36$export$5bea4c09e53ad038,
        $3b8da494b8e92f36$export$4b188b7ebea22345,
        $3b8da494b8e92f36$export$ae9001e98ea773dd,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$e6b8d999588bbfb0,
        $3b8da494b8e92f36$export$73f1ed87b1382872,
        $3b8da494b8e92f36$export$ac74d5ae1cf456e2,
        $3b8da494b8e92f36$export$6647f951c3b0d1f4,
        $3b8da494b8e92f36$export$b58a07450f76f5f4
    ],
    3615266464: [
        $3b8da494b8e92f36$export$2c0c343d0211b12a,
        $3b8da494b8e92f36$export$bb7bafb36fa737d0
    ],
    478536968: [
        $3b8da494b8e92f36$export$813f9cf6a2209fec,
        $3b8da494b8e92f36$export$9ec66581628a6b51,
        $3b8da494b8e92f36$export$bc9bd707c4403985,
        $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
        $3b8da494b8e92f36$export$cff3fa05b2018b59,
        $3b8da494b8e92f36$export$b1832f175144bc77,
        $3b8da494b8e92f36$export$2e330e8e36019063,
        $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
        $3b8da494b8e92f36$export$a712aed3e137585e,
        $3b8da494b8e92f36$export$c331bec3b085e9a1,
        $3b8da494b8e92f36$export$2bafde249aab99b4,
        $3b8da494b8e92f36$export$8d69d79340327b03,
        $3b8da494b8e92f36$export$d35785e0f77dbe69,
        $3b8da494b8e92f36$export$4ebf013b2eb5605,
        $3b8da494b8e92f36$export$9cb68f339a367600,
        $3b8da494b8e92f36$export$51e6468498cab028,
        $3b8da494b8e92f36$export$20528f2adfe8dc9c,
        $3b8da494b8e92f36$export$9572797f2851b0,
        $3b8da494b8e92f36$export$b933598a67b23044,
        $3b8da494b8e92f36$export$976ca854e309f825,
        $3b8da494b8e92f36$export$1fe9178d23052979,
        $3b8da494b8e92f36$export$7d39bda8b7b90f7,
        $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
        $3b8da494b8e92f36$export$94d1e1fe7b940759,
        $3b8da494b8e92f36$export$2b794d8b645d7087,
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c,
        $3b8da494b8e92f36$export$4a59ec454710396a,
        $3b8da494b8e92f36$export$a636087bbbf1a084,
        $3b8da494b8e92f36$export$5a451f1021e76496,
        $3b8da494b8e92f36$export$90569318bbf3a5cb,
        $3b8da494b8e92f36$export$3fd59b6be292fb81,
        $3b8da494b8e92f36$export$8bef70def9fcccef,
        $3b8da494b8e92f36$export$8f026b620b6b36d2,
        $3b8da494b8e92f36$export$89d3022d89ef3649,
        $3b8da494b8e92f36$export$c7eeffff290e6124,
        $3b8da494b8e92f36$export$b56f06451667ac1c,
        $3b8da494b8e92f36$export$87c3ff288d974d02,
        $3b8da494b8e92f36$export$5c698c7bb50b493,
        $3b8da494b8e92f36$export$422809562a8398de,
        $3b8da494b8e92f36$export$a48481dfef95f4a2,
        $3b8da494b8e92f36$export$95d386c017712592,
        $3b8da494b8e92f36$export$c384581c6776ce3d,
        $3b8da494b8e92f36$export$f0bc40d4cf9f4c13,
        $3b8da494b8e92f36$export$85c864d0fb1c21,
        $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
        $3b8da494b8e92f36$export$948a40ccb5d8f52c,
        $3b8da494b8e92f36$export$d988060319005ccc,
        $3b8da494b8e92f36$export$bb5ce9eb5b74ac1
    ],
    723233188: [
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$212932c39cad14c1,
        $3b8da494b8e92f36$export$a7c9a308bd61791e,
        $3b8da494b8e92f36$export$2ef492eaafc1544a,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$db3cb7c28fcdcb12
    ],
    2473145415: [
        $3b8da494b8e92f36$export$3787e1faec59f84d
    ],
    1597423693: [
        $3b8da494b8e92f36$export$34a05c9e12c53c23
    ],
    3843319758: [
        $3b8da494b8e92f36$export$6757c80a00accad7
    ],
    2513912981: [
        $3b8da494b8e92f36$export$32b9b3ebd4722148,
        $3b8da494b8e92f36$export$60c94e2d2eb3ae2d,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$7a8fab203344ee59,
        $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b,
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a,
        $3b8da494b8e92f36$export$e7d69479b3ed50b5
    ],
    2247615214: [
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$e537328a93948147
    ],
    230924584: [
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a
    ],
    3028897424: [
        $3b8da494b8e92f36$export$a344fd0eadbfecfd
    ],
    4282788508: [
        $3b8da494b8e92f36$export$fd5f089562b081f9
    ],
    1628702193: [
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$32bafd879e2dddb5,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$199e9b07f076c19c,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$d1d6e43b67173127,
        $3b8da494b8e92f36$export$e8d5f91a47737ca2,
        $3b8da494b8e92f36$export$fe64d2939a7bcd9f
    ],
    2347495698: [
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$32bafd879e2dddb5,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$199e9b07f076c19c,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$d1d6e43b67173127,
        $3b8da494b8e92f36$export$e8d5f91a47737ca2
    ],
    3288037868: [
        $3b8da494b8e92f36$export$1392625c61300e87,
        $3b8da494b8e92f36$export$d5bdd4bede6134ba
    ],
    2736907675: [
        $3b8da494b8e92f36$export$a340b94c3a9627f5
    ],
    4182860854: [
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$7a8fab203344ee59
    ],
    59481748: [
        $3b8da494b8e92f36$export$64fbfc27b4cec02a,
        $3b8da494b8e92f36$export$843f1ace19c7b757,
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252,
        $3b8da494b8e92f36$export$88babb7bc763dabe
    ],
    3749851601: [
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252
    ],
    3331915920: [
        $3b8da494b8e92f36$export$64fbfc27b4cec02a
    ],
    1383045692: [
        $3b8da494b8e92f36$export$9bf9b7d525eb98c7
    ],
    2506170314: [
        $3b8da494b8e92f36$export$aba424e86850f717,
        $3b8da494b8e92f36$export$2a2b17b32d1a9938,
        $3b8da494b8e92f36$export$f1de0c39f08c8646,
        $3b8da494b8e92f36$export$36783435db2b01a1,
        $3b8da494b8e92f36$export$d414ecd4014891b0
    ],
    2601014836: [
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f,
        $3b8da494b8e92f36$export$ec4770aab56c805f,
        $3b8da494b8e92f36$export$17a178252d8924e1,
        $3b8da494b8e92f36$export$e6f3e3864604f581,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$b19edc019cfe9de6,
        $3b8da494b8e92f36$export$7952e91536a239e7,
        $3b8da494b8e92f36$export$cddab537799fe2fd,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43,
        $3b8da494b8e92f36$export$6c79cacc663fc254
    ],
    3073041342: [
        $3b8da494b8e92f36$export$76ac35741e93e1e3,
        $3b8da494b8e92f36$export$ae18b145d18a65a0,
        $3b8da494b8e92f36$export$19fc29e00d5d6f73,
        $3b8da494b8e92f36$export$8273fbcc9f6a7487,
        $3b8da494b8e92f36$export$7f49599a30af57cd,
        $3b8da494b8e92f36$export$52fe4a955de5eb0a
    ],
    339256511: [
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$32bafd879e2dddb5,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$199e9b07f076c19c,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8
    ],
    2777663545: [
        $3b8da494b8e92f36$export$32b9b3ebd4722148
    ],
    80994333: [
        $3b8da494b8e92f36$export$5bea4c09e53ad038
    ],
    4238390223: [
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167
    ],
    1484403080: [
        $3b8da494b8e92f36$export$9f98ad7f69b4
    ],
    1425443689: [
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843
    ],
    3888040117: [
        $3b8da494b8e92f36$export$e6a1bbf1fc25125c,
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$96fd1f1884f8293c,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09,
        $3b8da494b8e92f36$export$f43ad39311bcb56,
        $3b8da494b8e92f36$export$362a10b06c97d57d,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$5d02e5cc9d3a330c,
        $3b8da494b8e92f36$export$cd44f8494212d99d,
        $3b8da494b8e92f36$export$60907473f1c7f6ac,
        $3b8da494b8e92f36$export$1525fe60aac5b17a,
        $3b8da494b8e92f36$export$5271976935958385,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$1d7ec19524492a0a,
        $3b8da494b8e92f36$export$f37c9444cc9075c7,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c,
        $3b8da494b8e92f36$export$573337cb0f58bf7b,
        $3b8da494b8e92f36$export$4690a2f5205975d8,
        $3b8da494b8e92f36$export$d4f0edab93018f7f,
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1,
        $3b8da494b8e92f36$export$5591fe75469fbc36,
        $3b8da494b8e92f36$export$7bec46e80091ced6,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$26adc90518fc7f55,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$8388c401d8add90d,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$be6eacb56fb6c8fb,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$7a3c6c08717af1a3,
        $3b8da494b8e92f36$export$defa1f0c8fe66659,
        $3b8da494b8e92f36$export$b194eecedbff75e1,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$d2225c8afda26732,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$17e11e354f64283f,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$f4c53f192a3ea7a1,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$ecd13d53d7a4573e,
        $3b8da494b8e92f36$export$91748340fd72a888,
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$e4d201a36f1cfffd,
        $3b8da494b8e92f36$export$1661c90a4afb2a0e,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6,
        $3b8da494b8e92f36$export$22d84e75fa702951
    ],
    2945172077: [
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$e4d201a36f1cfffd,
        $3b8da494b8e92f36$export$1661c90a4afb2a0e,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6
    ],
    4208778838: [
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$26adc90518fc7f55,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$8388c401d8add90d,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$be6eacb56fb6c8fb,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$7a3c6c08717af1a3,
        $3b8da494b8e92f36$export$defa1f0c8fe66659,
        $3b8da494b8e92f36$export$b194eecedbff75e1,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$d2225c8afda26732,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$17e11e354f64283f,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$f4c53f192a3ea7a1,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$ecd13d53d7a4573e
    ],
    3939117080: [
        $3b8da494b8e92f36$export$5c698c7bb50b493,
        $3b8da494b8e92f36$export$422809562a8398de,
        $3b8da494b8e92f36$export$a48481dfef95f4a2,
        $3b8da494b8e92f36$export$95d386c017712592,
        $3b8da494b8e92f36$export$c384581c6776ce3d,
        $3b8da494b8e92f36$export$f0bc40d4cf9f4c13,
        $3b8da494b8e92f36$export$85c864d0fb1c21,
        $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
        $3b8da494b8e92f36$export$948a40ccb5d8f52c,
        $3b8da494b8e92f36$export$d988060319005ccc
    ],
    1683148259: [
        $3b8da494b8e92f36$export$948a40ccb5d8f52c
    ],
    2495723537: [
        $3b8da494b8e92f36$export$c384581c6776ce3d,
        $3b8da494b8e92f36$export$f0bc40d4cf9f4c13,
        $3b8da494b8e92f36$export$85c864d0fb1c21
    ],
    1865459582: [
        $3b8da494b8e92f36$export$5a451f1021e76496,
        $3b8da494b8e92f36$export$90569318bbf3a5cb,
        $3b8da494b8e92f36$export$3fd59b6be292fb81,
        $3b8da494b8e92f36$export$8bef70def9fcccef,
        $3b8da494b8e92f36$export$8f026b620b6b36d2,
        $3b8da494b8e92f36$export$89d3022d89ef3649,
        $3b8da494b8e92f36$export$c7eeffff290e6124,
        $3b8da494b8e92f36$export$b56f06451667ac1c
    ],
    826625072: [
        $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
        $3b8da494b8e92f36$export$a712aed3e137585e,
        $3b8da494b8e92f36$export$c331bec3b085e9a1,
        $3b8da494b8e92f36$export$2bafde249aab99b4,
        $3b8da494b8e92f36$export$8d69d79340327b03,
        $3b8da494b8e92f36$export$d35785e0f77dbe69,
        $3b8da494b8e92f36$export$4ebf013b2eb5605,
        $3b8da494b8e92f36$export$9cb68f339a367600,
        $3b8da494b8e92f36$export$51e6468498cab028,
        $3b8da494b8e92f36$export$20528f2adfe8dc9c,
        $3b8da494b8e92f36$export$9572797f2851b0,
        $3b8da494b8e92f36$export$b933598a67b23044,
        $3b8da494b8e92f36$export$976ca854e309f825,
        $3b8da494b8e92f36$export$1fe9178d23052979,
        $3b8da494b8e92f36$export$7d39bda8b7b90f7,
        $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
        $3b8da494b8e92f36$export$94d1e1fe7b940759,
        $3b8da494b8e92f36$export$2b794d8b645d7087,
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c,
        $3b8da494b8e92f36$export$4a59ec454710396a
    ],
    1204542856: [
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c
    ],
    1638771189: [
        $3b8da494b8e92f36$export$976ca854e309f825
    ],
    2551354335: [
        $3b8da494b8e92f36$export$cff3fa05b2018b59,
        $3b8da494b8e92f36$export$b1832f175144bc77
    ],
    693640335: [
        $3b8da494b8e92f36$export$813f9cf6a2209fec,
        $3b8da494b8e92f36$export$9ec66581628a6b51,
        $3b8da494b8e92f36$export$bc9bd707c4403985
    ],
    4186316022: [
        $3b8da494b8e92f36$export$9ec66581628a6b51
    ],
    2914609552: [
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1
    ],
    2706606064: [
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9
    ],
    3893378262: [
        $3b8da494b8e92f36$export$70869bbe5fdba7cc
    ],
    3544373492: [
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$17e11e354f64283f,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$f4c53f192a3ea7a1,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab
    ],
    3136571912: [
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6
    ],
    530289379: [
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a
    ],
    3689010777: [
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5
    ],
    3979015343: [
        $3b8da494b8e92f36$export$76257ab7fe716a7f
    ],
    3473067441: [
        $3b8da494b8e92f36$export$e4d201a36f1cfffd,
        $3b8da494b8e92f36$export$1661c90a4afb2a0e
    ],
    2296667514: [
        $3b8da494b8e92f36$export$4690a2f5205975d8
    ],
    1260505505: [
        $3b8da494b8e92f36$export$17a178252d8924e1,
        $3b8da494b8e92f36$export$e6f3e3864604f581,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$b19edc019cfe9de6,
        $3b8da494b8e92f36$export$7952e91536a239e7
    ],
    1950629157: [
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa
    ],
    3732776249: [
        $3b8da494b8e92f36$export$b19edc019cfe9de6
    ],
    2510884976: [
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f
    ],
    2559216714: [
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22
    ],
    3293443760: [
        $3b8da494b8e92f36$export$362a10b06c97d57d,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$5d02e5cc9d3a330c,
        $3b8da494b8e92f36$export$cd44f8494212d99d,
        $3b8da494b8e92f36$export$60907473f1c7f6ac,
        $3b8da494b8e92f36$export$1525fe60aac5b17a,
        $3b8da494b8e92f36$export$5271976935958385,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$1d7ec19524492a0a,
        $3b8da494b8e92f36$export$f37c9444cc9075c7,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c
    ],
    681481545: [
        $3b8da494b8e92f36$export$76ac35741e93e1e3,
        $3b8da494b8e92f36$export$ae18b145d18a65a0,
        $3b8da494b8e92f36$export$19fc29e00d5d6f73,
        $3b8da494b8e92f36$export$8273fbcc9f6a7487
    ],
    3256556792: [
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$32bafd879e2dddb5,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$199e9b07f076c19c,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a
    ],
    3849074793: [
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$32bafd879e2dddb5,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$199e9b07f076c19c,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$4fb40b28127d10c5
    ],
    1758889154: [
        $3b8da494b8e92f36$export$26adc90518fc7f55,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$8388c401d8add90d,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$be6eacb56fb6c8fb,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$7a3c6c08717af1a3,
        $3b8da494b8e92f36$export$defa1f0c8fe66659,
        $3b8da494b8e92f36$export$b194eecedbff75e1,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$d2225c8afda26732,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a
    ],
    1623761950: [
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254
    ],
    2590856083: [
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7
    ],
    2107101300: [
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466
    ],
    647756555: [
        $3b8da494b8e92f36$export$55aca517d8ba50ae
    ],
    2489546625: [
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46
    ],
    2827207264: [
        $3b8da494b8e92f36$export$7a3c6c08717af1a3,
        $3b8da494b8e92f36$export$defa1f0c8fe66659,
        $3b8da494b8e92f36$export$b194eecedbff75e1,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f
    ],
    2143335405: [
        $3b8da494b8e92f36$export$fd69280ac5175edc
    ],
    1287392070: [
        $3b8da494b8e92f36$export$7a3c6c08717af1a3,
        $3b8da494b8e92f36$export$defa1f0c8fe66659,
        $3b8da494b8e92f36$export$b194eecedbff75e1,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc
    ],
    3907093117: [
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6
    ],
    3198132628: [
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac
    ],
    1482959167: [
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2
    ],
    1834744321: [
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693
    ],
    1339347760: [
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c
    ],
    2297155007: [
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$32bafd879e2dddb5,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$199e9b07f076c19c
    ],
    3009222698: [
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a
    ],
    2706460486: [
        $3b8da494b8e92f36$export$e6a1bbf1fc25125c,
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$96fd1f1884f8293c,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09
    ],
    3740093272: [
        $3b8da494b8e92f36$export$a0685d525ffdd769
    ],
    682877961: [
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$17e11e354f64283f,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$f4c53f192a3ea7a1,
        $3b8da494b8e92f36$export$ee7aa2a71993541a
    ],
    1179482911: [
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0
    ],
    214636428: [
        $3b8da494b8e92f36$export$1c90015ebcc206f4
    ],
    1807405624: [
        $3b8da494b8e92f36$export$f4c53f192a3ea7a1
    ],
    1621171031: [
        $3b8da494b8e92f36$export$17e11e354f64283f
    ],
    2254336722: [
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$96fd1f1884f8293c
    ],
    1028945134: [
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4
    ],
    1967976161: [
        $3b8da494b8e92f36$export$17a178252d8924e1,
        $3b8da494b8e92f36$export$e6f3e3864604f581
    ],
    1916977116: [
        $3b8da494b8e92f36$export$17a178252d8924e1
    ],
    3299480353: [
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$be6eacb56fb6c8fb
    ],
    52481810: [
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$e889106cbea0f06d
    ],
    2635815018: [
        $3b8da494b8e92f36$export$7f68f805d71a6e66
    ],
    2063403501: [
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$eb2d882d03a89f21
    ],
    1945004755: [
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$8388c401d8add90d,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf
    ],
    3040386961: [
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$8388c401d8add90d,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$52e474d7ed246098
    ],
    855621170: [
        $3b8da494b8e92f36$export$7a3c6c08717af1a3,
        $3b8da494b8e92f36$export$defa1f0c8fe66659
    ],
    2058353004: [
        $3b8da494b8e92f36$export$8388c401d8add90d
    ],
    3027567501: [
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398
    ],
    2391406946: [
        $3b8da494b8e92f36$export$61bc9e508bdccd25
    ]
};
$3b8da494b8e92f36$export$1ae3922015fd7522[1] = {
    618182010: [
        [
            "OfPerson",
            $3b8da494b8e92f36$export$ffa0fdddece68333,
            7,
            true
        ],
        [
            "OfOrganization",
            $3b8da494b8e92f36$export$484015ec0cfcf638,
            4,
            true
        ]
    ],
    411424972: [
        [
            "ValuesReferenced",
            $3b8da494b8e92f36$export$7e9b46959f13f9f9,
            1,
            true
        ],
        [
            "ValueOfComponents",
            $3b8da494b8e92f36$export$2bc1977a2b3383fc,
            0,
            true
        ],
        [
            "IsComponentIn",
            $3b8da494b8e92f36$export$2bc1977a2b3383fc,
            1,
            true
        ]
    ],
    130549933: [
        [
            "Actors",
            $3b8da494b8e92f36$export$bbecaa296832f2e5,
            1,
            true
        ],
        [
            "IsRelatedWith",
            $3b8da494b8e92f36$export$cea9d94742f0d4d6,
            0,
            true
        ],
        [
            "Relates",
            $3b8da494b8e92f36$export$cea9d94742f0d4d6,
            1,
            true
        ]
    ],
    747523909: [
        [
            "Contains",
            $3b8da494b8e92f36$export$4a58eef3e39e7dc9,
            1,
            true
        ]
    ],
    1767535486: [
        [
            "IsClassifiedItemIn",
            $3b8da494b8e92f36$export$348fb08c3ac89e16,
            1,
            true
        ],
        [
            "IsClassifyingItemIn",
            $3b8da494b8e92f36$export$348fb08c3ac89e16,
            0,
            true
        ]
    ],
    1959218052: [
        [
            "ClassifiedAs",
            $3b8da494b8e92f36$export$d9a4f267e9f6318f,
            0,
            true
        ],
        [
            "RelatesConstraints",
            $3b8da494b8e92f36$export$cd24e82549f8104a,
            2,
            true
        ],
        [
            "IsRelatedWith",
            $3b8da494b8e92f36$export$cd24e82549f8104a,
            3,
            true
        ],
        [
            "PropertiesForConstraint",
            $3b8da494b8e92f36$export$d3bab060ba7bb28e,
            0,
            true
        ],
        [
            "Aggregates",
            $3b8da494b8e92f36$export$da5288cf4b26555,
            2,
            true
        ],
        [
            "IsAggregatedIn",
            $3b8da494b8e92f36$export$da5288cf4b26555,
            3,
            true
        ]
    ],
    602808272: [
        [
            "ValuesReferenced",
            $3b8da494b8e92f36$export$7e9b46959f13f9f9,
            1,
            true
        ],
        [
            "ValueOfComponents",
            $3b8da494b8e92f36$export$2bc1977a2b3383fc,
            0,
            true
        ],
        [
            "IsComponentIn",
            $3b8da494b8e92f36$export$2bc1977a2b3383fc,
            1,
            true
        ]
    ],
    1154170062: [
        [
            "IsPointedTo",
            $3b8da494b8e92f36$export$623f6287e006c7a4,
            1,
            true
        ],
        [
            "IsPointer",
            $3b8da494b8e92f36$export$623f6287e006c7a4,
            0,
            true
        ]
    ],
    1648886627: [
        [
            "ValuesReferenced",
            $3b8da494b8e92f36$export$7e9b46959f13f9f9,
            1,
            true
        ],
        [
            "ValueOfComponents",
            $3b8da494b8e92f36$export$2bc1977a2b3383fc,
            0,
            true
        ],
        [
            "IsComponentIn",
            $3b8da494b8e92f36$export$2bc1977a2b3383fc,
            1,
            true
        ]
    ],
    852622518: [
        [
            "PartOfW",
            $3b8da494b8e92f36$export$d112ffc231f4837b,
            9,
            true
        ],
        [
            "PartOfV",
            $3b8da494b8e92f36$export$d112ffc231f4837b,
            8,
            true
        ],
        [
            "PartOfU",
            $3b8da494b8e92f36$export$d112ffc231f4837b,
            7,
            true
        ],
        [
            "HasIntersections",
            $3b8da494b8e92f36$export$39a9378576bb57be,
            0,
            true
        ]
    ],
    3452421091: [
        [
            "ReferenceIntoLibrary",
            $3b8da494b8e92f36$export$87ba372ae8130125,
            4,
            true
        ]
    ],
    1838606355: [
        [
            "HasRepresentation",
            $3b8da494b8e92f36$export$95d5078ec273e20a,
            3,
            true
        ],
        [
            "ClassifiedAs",
            $3b8da494b8e92f36$export$574ce7177061cd49,
            1,
            true
        ]
    ],
    248100487: [
        [
            "ToMaterialLayerSet",
            $3b8da494b8e92f36$export$271c16e7766bc70a,
            0,
            false
        ]
    ],
    3368373690: [
        [
            "ClassifiedAs",
            $3b8da494b8e92f36$export$d9a4f267e9f6318f,
            0,
            true
        ],
        [
            "RelatesConstraints",
            $3b8da494b8e92f36$export$cd24e82549f8104a,
            2,
            true
        ],
        [
            "IsRelatedWith",
            $3b8da494b8e92f36$export$cd24e82549f8104a,
            3,
            true
        ],
        [
            "PropertiesForConstraint",
            $3b8da494b8e92f36$export$d3bab060ba7bb28e,
            0,
            true
        ],
        [
            "Aggregates",
            $3b8da494b8e92f36$export$da5288cf4b26555,
            2,
            true
        ],
        [
            "IsAggregatedIn",
            $3b8da494b8e92f36$export$da5288cf4b26555,
            3,
            true
        ]
    ],
    3701648758: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$34302876ddf37791,
            0,
            true
        ]
    ],
    2251480897: [
        [
            "ClassifiedAs",
            $3b8da494b8e92f36$export$d9a4f267e9f6318f,
            0,
            true
        ],
        [
            "RelatesConstraints",
            $3b8da494b8e92f36$export$cd24e82549f8104a,
            2,
            true
        ],
        [
            "IsRelatedWith",
            $3b8da494b8e92f36$export$cd24e82549f8104a,
            3,
            true
        ],
        [
            "PropertiesForConstraint",
            $3b8da494b8e92f36$export$d3bab060ba7bb28e,
            0,
            true
        ],
        [
            "Aggregates",
            $3b8da494b8e92f36$export$da5288cf4b26555,
            2,
            true
        ],
        [
            "IsAggregatedIn",
            $3b8da494b8e92f36$export$da5288cf4b26555,
            3,
            true
        ]
    ],
    4251960020: [
        [
            "IsRelatedBy",
            $3b8da494b8e92f36$export$f7ea933b5cc28fe9,
            3,
            true
        ],
        [
            "Relates",
            $3b8da494b8e92f36$export$f7ea933b5cc28fe9,
            2,
            true
        ],
        [
            "Engages",
            $3b8da494b8e92f36$export$c819a2c53c7debd3,
            1,
            true
        ]
    ],
    2077209135: [
        [
            "EngagedIn",
            $3b8da494b8e92f36$export$c819a2c53c7debd3,
            0,
            true
        ]
    ],
    2483315170: [
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2226359599: [
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    3355820592: [
        [
            "OfPerson",
            $3b8da494b8e92f36$export$ffa0fdddece68333,
            7,
            true
        ],
        [
            "OfOrganization",
            $3b8da494b8e92f36$export$484015ec0cfcf638,
            4,
            true
        ]
    ],
    2598011224: [
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            0,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            1,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ]
    ],
    2044713172: [
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2093928680: [
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    931644368: [
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    3252649465: [
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2405470396: [
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    825690147: [
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    1076942058: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ]
    ],
    3377609919: [
        [
            "RepresentationsInContext",
            $3b8da494b8e92f36$export$2ddea3c8ef71f411,
            0,
            true
        ]
    ],
    3008791417: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1660063152: [
        [
            "MapUsage",
            $3b8da494b8e92f36$export$f6578324c1ae7b2d,
            0,
            true
        ]
    ],
    3982875396: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ],
        [
            "OfShapeAspect",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            0,
            true
        ]
    ],
    4240577450: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ],
        [
            "OfShapeAspect",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            0,
            true
        ]
    ],
    3692461612: [
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            0,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            1,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ]
    ],
    2830218821: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ]
    ],
    3958052878: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3049322572: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ]
    ],
    531007025: [
        [
            "OfTable",
            $3b8da494b8e92f36$export$ee8bfae354e48d7a,
            1,
            false
        ]
    ],
    912023232: [
        [
            "OfPerson",
            $3b8da494b8e92f36$export$ffa0fdddece68333,
            7,
            true
        ],
        [
            "OfOrganization",
            $3b8da494b8e92f36$export$484015ec0cfcf638,
            4,
            true
        ]
    ],
    280115917: [
        [
            "AnnotatedSurface",
            $3b8da494b8e92f36$export$3812c41bd5a38c31,
            1,
            true
        ]
    ],
    1742049831: [
        [
            "AnnotatedSurface",
            $3b8da494b8e92f36$export$3812c41bd5a38c31,
            1,
            true
        ]
    ],
    2552916305: [
        [
            "AnnotatedSurface",
            $3b8da494b8e92f36$export$3812c41bd5a38c31,
            1,
            true
        ]
    ],
    3101149627: [
        [
            "DocumentedBy",
            $3b8da494b8e92f36$export$8d9cc5ad564ee144,
            0,
            true
        ]
    ],
    1377556343: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1735638870: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ],
        [
            "OfShapeAspect",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            0,
            true
        ]
    ],
    2799835756: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1907098498: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2442683028: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    962685235: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3612888222: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2297822566: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2542286263: [
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            0,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            1,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ]
    ],
    370225590: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3732053477: [
        [
            "ReferenceToDocument",
            $3b8da494b8e92f36$export$18cb417b645b7410,
            3,
            true
        ]
    ],
    3900360178: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    476780140: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2556980723: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1809719519: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    803316827: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3008276851: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3448662350: [
        [
            "RepresentationsInContext",
            $3b8da494b8e92f36$export$2ddea3c8ef71f411,
            0,
            true
        ],
        [
            "HasSubContexts",
            $3b8da494b8e92f36$export$c78a940a5c4e916a,
            6,
            true
        ]
    ],
    2453401579: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4142052618: [
        [
            "RepresentationsInContext",
            $3b8da494b8e92f36$export$2ddea3c8ef71f411,
            0,
            true
        ],
        [
            "HasSubContexts",
            $3b8da494b8e92f36$export$c78a940a5c4e916a,
            6,
            true
        ]
    ],
    3590301190: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    178086475: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$34302876ddf37791,
            0,
            true
        ]
    ],
    812098782: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3741457305: [
        [
            "DocumentedBy",
            $3b8da494b8e92f36$export$8d9cc5ad564ee144,
            0,
            true
        ]
    ],
    1402838566: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    125510826: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2604431987: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4266656042: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1520743889: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3422422726: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2624227202: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$34302876ddf37791,
            0,
            true
        ]
    ],
    1008929658: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2347385850: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    219451334: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ]
    ],
    2833995503: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2665983363: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1029017970: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2519244187: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3021840470: [
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2004835150: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1663979128: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2067069095: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4022376103: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1423911732: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2924175390: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2775532180: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    673634403: [
        [
            "ShapeOfProduct",
            $3b8da494b8e92f36$export$91748340fd72a888,
            6,
            true
        ],
        [
            "HasShapeAspects",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            4,
            true
        ]
    ],
    871118103: [
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            0,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            1,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ]
    ],
    1680319473: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ]
    ],
    4166981789: [
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            0,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            1,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ]
    ],
    2752243245: [
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            0,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            1,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ]
    ],
    941946838: [
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            0,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            1,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ]
    ],
    3357820518: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    3650150729: [
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            0,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            1,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ]
    ],
    110355661: [
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            0,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            1,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ]
    ],
    3413951693: [
        [
            "DocumentedBy",
            $3b8da494b8e92f36$export$8d9cc5ad564ee144,
            0,
            true
        ]
    ],
    3765753017: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    1509187699: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2411513650: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    4124623270: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    723233188: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2485662743: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    1202362311: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    390701378: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    2233826070: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2513912981: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2247615214: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1260650574: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    230924584: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3028897424: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4282788508: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3124975700: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1345879162: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1628702193: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2347495698: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1417489154: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2759199220: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    336235671: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    512836454: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    1299126871: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3288037868: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    669184980: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2265737646: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1302238472: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4261334040: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3125803723: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2740243338: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2736907675: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4182860854: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2581212453: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2713105998: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1123145078: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    59481748: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3749851601: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3486308946: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3331915920: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1416205885: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2205249479: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2485617015: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "UsingCurves",
            $3b8da494b8e92f36$export$7952e91536a239e7,
            0,
            true
        ]
    ],
    2506170314: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2147822146: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2601014836: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2827736869: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    693772133: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    606661476: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "AnnotatedBySymbols",
            $3b8da494b8e92f36$export$bbe7a575e2c472c,
            3,
            true
        ]
    ],
    4054601972: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    32440307: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2963535650: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    1714330368: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    526551008: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3073041342: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "IsRelatedFromCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            3,
            true
        ],
        [
            "IsRelatedToCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            2,
            true
        ]
    ],
    1472233963: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1883228015: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    339256511: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2777663545: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    80994333: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    477187591: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2047409740: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    374418227: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4203026998: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    315944413: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3455213021: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    4238390223: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1268542332: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    987898635: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1281925730: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1425443689: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3888040117: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ]
    ],
    3388369263: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3505215534: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3566463478: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    603570806: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    220341763: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2945172077: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ]
    ],
    4208778838: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    103090709: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ]
    ],
    4194566429: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1451395588: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    3219374653: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2798486643: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3454111270: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2914609552: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1856042241: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4158566097: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3626867408: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2706606064: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ]
    ],
    3893378262: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    451544542: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3544373492: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            false
        ]
    ],
    3136571912: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ]
    ],
    530289379: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ReferencesElement",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            5,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    3689010777: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            false
        ],
        [
            "Causes",
            $3b8da494b8e92f36$export$708a87c69a745de7,
            10,
            true
        ]
    ],
    3979015343: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ReferencesElement",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            5,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    2218152070: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ReferencesElement",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            5,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    4070609034: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "IsRelatedFromCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            3,
            true
        ],
        [
            "IsRelatedToCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            2,
            true
        ]
    ],
    2028607225: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2809605785: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4124788165: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1580310250: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3473067441: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ]
    ],
    2097647324: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2296667514: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsActingUpon",
            $3b8da494b8e92f36$export$d988060319005ccc,
            6,
            true
        ]
    ],
    1674181508: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    1334484129: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3649129432: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1260505505: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4031249490: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ]
    ],
    1950629157: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3124254112: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ]
    ],
    300633059: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3732776249: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2510884976: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2559216714: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    3293443760: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3895139033: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1419761937: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1916426348: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3295246426: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1457835157: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    681481545: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "IsRelatedFromCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            3,
            true
        ],
        [
            "IsRelatedToCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            2,
            true
        ]
    ],
    3256556792: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3849074793: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    360485395: [
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PropertyDefinitionOf",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ]
    ],
    1758889154: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    4123344466: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    1623761950: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2590856083: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1704287377: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2107101300: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1962604670: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3272907226: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3174744832: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3390157468: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    807026263: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3737207727: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    647756555: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2489546625: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2827207264: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2143335405: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "ProjectsElements",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            5,
            false
        ]
    ],
    1287392070: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ]
    ],
    3907093117: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3198132628: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3815607619: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1482959167: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1834744321: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1339347760: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2297155007: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3009222698: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    263784265: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    814719939: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    200128114: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3009204131: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2706460486: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ]
    ],
    1251058090: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1806887404: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2391368822: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ]
    ],
    4288270099: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3827777499: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1051575348: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1161773419: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2506943328: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "IsRelatedFromCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            3,
            true
        ],
        [
            "IsRelatedToCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            2,
            true
        ]
    ],
    377706215: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2108223431: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3181161470: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    977012517: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1916936684: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ]
    ],
    4143007308: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsActingUpon",
            $3b8da494b8e92f36$export$d988060319005ccc,
            6,
            true
        ]
    ],
    3588315303: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ],
        [
            "HasFillings",
            $3b8da494b8e92f36$export$51e6468498cab028,
            4,
            true
        ]
    ],
    3425660407: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ]
    ],
    2837617999: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2382730787: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3327091369: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    804291784: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    4231323485: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    4017108033: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3724593414: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3740093272: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainedIn",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            4,
            false
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            4,
            true
        ]
    ],
    2744685151: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ]
    ],
    2904328755: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3642467123: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3651124850: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "ProjectsElements",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            5,
            false
        ]
    ],
    1842657554: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2250791053: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3248260540: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "IsRelatedFromCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            3,
            true
        ],
        [
            "IsRelatedToCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            2,
            true
        ]
    ],
    2893384427: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2324767716: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1768891740: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3517283431: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ],
        [
            "ScheduleTimeControlAssigned",
            $3b8da494b8e92f36$export$c384581c6776ce3d,
            7,
            false
        ]
    ],
    4105383287: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    4097777520: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ]
    ],
    2533589738: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3856911033: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$20528f2adfe8dc9c,
            4,
            true
        ],
        [
            "BoundedBy",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            4,
            true
        ]
    ],
    1305183839: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    652456506: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ],
        [
            "HasInteractionReqsFrom",
            $3b8da494b8e92f36$export$4ebf013b2eb5605,
            7,
            true
        ],
        [
            "HasInteractionReqsTo",
            $3b8da494b8e92f36$export$4ebf013b2eb5605,
            8,
            true
        ]
    ],
    3812236995: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3112655638: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1039846685: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    682877961: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            false
        ]
    ],
    1179482911: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    4243806635: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    214636428: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ReferencesElement",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            5,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    2445595289: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ReferencesElement",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            5,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    1807405624: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            false
        ]
    ],
    1721250024: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            false
        ]
    ],
    1252848954: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ],
        [
            "SourceOfResultGroup",
            $3b8da494b8e92f36$export$88c23504cdda26e,
            6,
            true
        ],
        [
            "LoadGroupFor",
            $3b8da494b8e92f36$export$1a86b8c219c2e539,
            7,
            true
        ]
    ],
    1621171031: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            false
        ]
    ],
    3987759626: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            false
        ]
    ],
    2082059205: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            false
        ]
    ],
    734778138: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    1235345126: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            false
        ],
        [
            "Causes",
            $3b8da494b8e92f36$export$708a87c69a745de7,
            10,
            true
        ]
    ],
    2986769608: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ],
        [
            "ResultGroupFor",
            $3b8da494b8e92f36$export$1a86b8c219c2e539,
            8,
            true
        ]
    ],
    1975003073: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    148013059: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    2315554128: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2254336722: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ]
    ],
    5716631: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1637806684: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1692211062: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1620046519: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3593883385: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1600972822: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1911125066: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    728799441: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2769231204: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    1898987631: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1133259667: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1028945134: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    4218914973: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3342526732: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1033361043: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ]
    ],
    1213861670: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3821786052: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1411407467: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3352864051: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1871374353: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2470393545: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "IsRelatedFromCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            3,
            true
        ],
        [
            "IsRelatedToCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            2,
            true
        ]
    ],
    3460190687: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ]
    ],
    1967976161: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    819618141: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1916977116: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    231477066: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3299480353: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    52481810: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2979338954: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    1095909175: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    1909888760: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    395041908: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3293546465: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1285652485: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2951183804: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2611217952: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2301859152: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    843113511: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3850581409: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2816379211: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2188551683: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ]
    ],
    1163958913: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3898045240: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1060000209: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    488727124: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    335055490: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2954562838: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1973544240: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "CoversSpaces",
            $3b8da494b8e92f36$export$20528f2adfe8dc9c,
            5,
            true
        ],
        [
            "Covers",
            $3b8da494b8e92f36$export$9572797f2851b0,
            5,
            true
        ]
    ],
    3495092785: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3961806047: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    4147604152: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "IsRelatedFromCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            3,
            true
        ],
        [
            "IsRelatedToCallout",
            $3b8da494b8e92f36$export$4c93c766e0e36aab,
            2,
            true
        ]
    ],
    1335981549: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2635815018: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1599208980: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2063403501: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1945004755: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3040386961: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3041715199: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainedIn",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            4,
            false
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            4,
            true
        ]
    ],
    395920057: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    869906466: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3760055223: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2030761528: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    855621170: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ]
    ],
    663422040: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3277789161: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1534661035: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1365060375: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1217240411: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    712377611: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1634875225: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ]
    ],
    857184966: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    1658829314: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    346874300: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1810631287: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    4222183408: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2058353004: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4278956645: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4037862832: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3132237377: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    987401354: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    707683696: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2223149337: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3508470533: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    900683007: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    1073191201: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    1687234759: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3171933400: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2262370178: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3024970846: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3283111854: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3055160366: [
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3027567501: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2320036040: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2016517767: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    1376911519: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ]
    ],
    1783015770: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1529196076: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    331165859: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    4252922144: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2515109513: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            false
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ]
    ],
    3824725483: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2347447852: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3313531582: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    2391406946: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3512223829: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    3304561284: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2874132201: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3001207471: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    753842376: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2454782716: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ]
    ],
    578613899: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "ObjectTypeOf",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    1052013943: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1062813311: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    3700593921: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    979691226: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$2e330e8e36019063,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "HasStructuralMember",
            $3b8da494b8e92f36$export$7d39bda8b7b90f7,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ]
};
$3b8da494b8e92f36$export$cab133dc4b2240f9[1] = {
    3630933823: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcActorRole(a[0], a[1], a[2]),
    618182010: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAddress(a[0], a[1], a[2]),
    639542469: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApplication(a[0], a[1], a[2], a[3]),
    411424972: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAppliedValue(a[0], a[1], a[2], a[3], a[4], a[5]),
    1110488051: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAppliedValueRelationship(a[0], a[1], a[2], a[3], a[4]),
    130549933: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApproval(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2080292479: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApprovalActorRelationship(a[0], a[1], a[2]),
    390851274: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApprovalPropertyRelationship(a[0], a[1]),
    3869604511: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcApprovalRelationship(a[0], a[1], a[2], a[3]),
    4037036970: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryCondition(a[0]),
    1560379544: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryEdgeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3367102660: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryFaceCondition(a[0], a[1], a[2], a[3]),
    1387855156: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryNodeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2069777674: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundaryNodeConditionWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    622194075: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCalendarDate(a[0], a[1], a[2]),
    747523909: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassification(a[0], a[1], a[2], a[3]),
    1767535486: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationItem(a[0], a[1], a[2]),
    1098599126: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationItemRelationship(a[0], a[1]),
    938368621: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationNotation(a[0]),
    3639012971: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationNotationFacet(a[0]),
    3264961684: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcColourSpecification(a[0]),
    2859738748: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionGeometry(),
    2614616156: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionPointGeometry(a[0], a[1]),
    4257277454: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionPortGeometry(a[0], a[1], a[2]),
    2732653382: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionSurfaceGeometry(a[0], a[1]),
    1959218052: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1658513725: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstraintAggregationRelationship(a[0], a[1], a[2], a[3], a[4]),
    613356794: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstraintClassificationRelationship(a[0], a[1]),
    347226245: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstraintRelationship(a[0], a[1], a[2], a[3]),
    1065062679: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCoordinatedUniversalTimeOffset(a[0], a[1], a[2]),
    602808272: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCostValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    539742890: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurrencyRelationship(a[0], a[1], a[2], a[3], a[4]),
    1105321065: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveStyleFont(a[0], a[1]),
    2367409068: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveStyleFontAndScaling(a[0], a[1], a[2]),
    3510044353: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveStyleFontPattern(a[0], a[1]),
    1072939445: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDateAndTime(a[0], a[1]),
    1765591967: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDerivedUnit(a[0], a[1], a[2]),
    1045800335: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDerivedUnitElement(a[0], a[1]),
    2949456006: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionalExponents(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1376555844: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDocumentElectronicFormat(a[0], a[1], a[2]),
    1154170062: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDocumentInformation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
    770865208: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDocumentInformationRelationship(a[0], a[1], a[2]),
    3796139169: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingCalloutRelationship(a[0], a[1], a[2], a[3]),
    1648886627: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEnvironmentalImpactValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3200245327: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternalReference(a[0], a[1], a[2]),
    2242383968: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternallyDefinedHatchStyle(a[0], a[1], a[2]),
    1040185647: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternallyDefinedSurfaceStyle(a[0], a[1], a[2]),
    3207319532: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternallyDefinedSymbol(a[0], a[1], a[2]),
    3548104201: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExternallyDefinedTextFont(a[0], a[1], a[2]),
    852622518: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGridAxis(a[0], a[1], a[2]),
    3020489413: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIrregularTimeSeriesValue(a[0], a[1]),
    2655187982: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLibraryInformation(a[0], a[1], a[2], a[3], a[4]),
    3452421091: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLibraryReference(a[0], a[1], a[2]),
    4162380809: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightDistributionData(a[0], a[1], a[2]),
    1566485204: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightIntensityDistribution(a[0], a[1]),
    30780891: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLocalTime(a[0], a[1], a[2], a[3], a[4]),
    1838606355: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterial(a[0]),
    1847130766: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialClassificationRelationship(a[0], a[1]),
    248100487: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialLayer(a[0], a[1], a[2]),
    3303938423: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialLayerSet(a[0], a[1]),
    1303795690: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialLayerSetUsage(a[0], a[1], a[2], a[3]),
    2199411900: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialList(a[0]),
    3265635763: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialProperties(a[0]),
    2597039031: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMeasureWithUnit(a[0], a[1]),
    4256014907: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    677618848: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalSteelMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    3368373690: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMetric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2706619895: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMonetaryUnit(a[0]),
    1918398963: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNamedUnit(a[0], a[1]),
    3701648758: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcObjectPlacement(),
    2251480897: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcObjective(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1227763645: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOpticalMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4251960020: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOrganization(a[0], a[1], a[2], a[3], a[4]),
    1411181986: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOrganizationRelationship(a[0], a[1], a[2], a[3]),
    1207048766: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOwnerHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2077209135: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPerson(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    101040310: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPersonAndOrganization(a[0], a[1], a[2]),
    2483315170: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPhysicalQuantity(a[0], a[1]),
    2226359599: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPhysicalSimpleQuantity(a[0], a[1], a[2]),
    3355820592: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPostalAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3727388367: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedItem(a[0]),
    990879717: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedSymbol(a[0]),
    3213052703: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedTerminatorSymbol(a[0]),
    1775413392: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedTextFont(a[0]),
    2022622350: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentationLayerAssignment(a[0], a[1], a[2], a[3]),
    1304840413: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentationLayerWithStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3119450353: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentationStyle(a[0]),
    2417041796: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentationStyleAssignment(a[0]),
    2095639259: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProductRepresentation(a[0], a[1], a[2]),
    2267347899: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProductsOfCombustionProperties(a[0], a[1], a[2], a[3], a[4]),
    3958567839: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProfileDef(a[0], a[1]),
    2802850158: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProfileProperties(a[0], a[1]),
    2598011224: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProperty(a[0], a[1]),
    3896028662: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyConstraintRelationship(a[0], a[1], a[2], a[3]),
    148025276: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyDependencyRelationship(a[0], a[1], a[2], a[3], a[4]),
    3710013099: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyEnumeration(a[0], a[1], a[2]),
    2044713172: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityArea(a[0], a[1], a[2], a[3]),
    2093928680: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityCount(a[0], a[1], a[2], a[3]),
    931644368: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityLength(a[0], a[1], a[2], a[3]),
    3252649465: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityTime(a[0], a[1], a[2], a[3]),
    2405470396: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityVolume(a[0], a[1], a[2], a[3]),
    825690147: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcQuantityWeight(a[0], a[1], a[2], a[3]),
    2692823254: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReferencesValueDocument(a[0], a[1], a[2], a[3]),
    1580146022: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcementBarProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    1222501353: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelaxation(a[0], a[1]),
    1076942058: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRepresentation(a[0], a[1], a[2], a[3]),
    3377609919: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRepresentationContext(a[0], a[1]),
    3008791417: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRepresentationItem(),
    1660063152: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRepresentationMap(a[0], a[1]),
    3679540991: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRibPlateProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2341007311: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRoot(a[0], a[1], a[2], a[3]),
    448429030: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSIUnit(a[0], a[1], a[2]),
    2042790032: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionProperties(a[0], a[1], a[2]),
    4165799628: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionReinforcementProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    867548509: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcShapeAspect(a[0], a[1], a[2], a[3], a[4]),
    3982875396: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcShapeModel(a[0], a[1], a[2], a[3]),
    4240577450: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcShapeRepresentation(a[0], a[1], a[2], a[3]),
    3692461612: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSimpleProperty(a[0], a[1]),
    2273995522: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralConnectionCondition(a[0]),
    2162789131: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoad(a[0]),
    2525727697: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadStatic(a[0]),
    3408363356: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadTemperature(a[0], a[1], a[2], a[3]),
    2830218821: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStyleModel(a[0], a[1], a[2], a[3]),
    3958052878: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStyledItem(a[0], a[1], a[2]),
    3049322572: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStyledRepresentation(a[0], a[1], a[2], a[3]),
    1300840506: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyle(a[0], a[1], a[2]),
    3303107099: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleLighting(a[0], a[1], a[2], a[3]),
    1607154358: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleRefraction(a[0], a[1]),
    846575682: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleShading(a[0]),
    1351298697: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleWithTextures(a[0]),
    626085974: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceTexture(a[0], a[1], a[2], a[3]),
    1290481447: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSymbolStyle(a[0], a[1]),
    985171141: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTable(a[0], a[1]),
    531007025: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTableRow(a[0], a[1]),
    912023232: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTelecomAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1447204868: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyle(a[0], a[1], a[2], a[3]),
    1983826977: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyleFontModel(a[0], a[1], a[2], a[3], a[4], a[5]),
    2636378356: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyleForDefinedFont(a[0], a[1]),
    1640371178: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyleTextModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1484833681: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextStyleWithBoxCharacteristics(a[0], a[1], a[2], a[3], a[4]),
    280115917: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextureCoordinate(),
    1742049831: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextureCoordinateGenerator(a[0], a[1]),
    2552916305: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextureMap(a[0]),
    1210645708: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextureVertex(a[0]),
    3317419933: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalMaterialProperties(a[0], a[1], a[2], a[3], a[4]),
    3101149627: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1718945513: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeSeriesReferenceRelationship(a[0], a[1]),
    581633288: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeSeriesValue(a[0]),
    1377556343: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTopologicalRepresentationItem(),
    1735638870: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTopologyRepresentation(a[0], a[1], a[2], a[3]),
    180925521: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcUnitAssignment(a[0]),
    2799835756: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVertex(),
    3304826586: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVertexBasedTextureMap(a[0], a[1]),
    1907098498: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVertexPoint(a[0]),
    891718957: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVirtualGridIntersection(a[0], a[1]),
    1065908215: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWaterProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2442683028: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationOccurrence(a[0], a[1], a[2]),
    962685235: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationSurfaceOccurrence(a[0], a[1], a[2]),
    3612888222: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationSymbolOccurrence(a[0], a[1], a[2]),
    2297822566: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationTextOccurrence(a[0], a[1], a[2]),
    3798115385: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcArbitraryClosedProfileDef(a[0], a[1], a[2]),
    1310608509: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcArbitraryOpenProfileDef(a[0], a[1], a[2]),
    2705031697: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcArbitraryProfileDefWithVoids(a[0], a[1], a[2], a[3]),
    616511568: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBlobTexture(a[0], a[1], a[2], a[3], a[4], a[5]),
    3150382593: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCenterLineProfileDef(a[0], a[1], a[2], a[3]),
    647927063: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClassificationReference(a[0], a[1], a[2], a[3]),
    776857604: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcColourRgb(a[0], a[1], a[2], a[3]),
    2542286263: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcComplexProperty(a[0], a[1], a[2], a[3]),
    1485152156: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompositeProfileDef(a[0], a[1], a[2], a[3]),
    370225590: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectedFaceSet(a[0]),
    1981873012: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionCurveGeometry(a[0], a[1]),
    45288368: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConnectionPointEccentricity(a[0], a[1], a[2], a[3], a[4]),
    3050246964: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcContextDependentUnit(a[0], a[1], a[2]),
    2889183280: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConversionBasedUnit(a[0], a[1], a[2], a[3]),
    3800577675: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveStyle(a[0], a[1], a[2], a[3]),
    3632507154: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDerivedProfileDef(a[0], a[1], a[2], a[3], a[4]),
    2273265877: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCalloutRelationship(a[0], a[1], a[2], a[3]),
    1694125774: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionPair(a[0], a[1], a[2], a[3]),
    3732053477: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDocumentReference(a[0], a[1], a[2]),
    4170525392: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingPreDefinedTextFont(a[0]),
    3900360178: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEdge(a[0], a[1]),
    476780140: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEdgeCurve(a[0], a[1], a[2], a[3]),
    1860660968: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExtendedMaterialProperties(a[0], a[1], a[2], a[3]),
    2556980723: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFace(a[0]),
    1809719519: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFaceBound(a[0], a[1]),
    803316827: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFaceOuterBound(a[0], a[1]),
    3008276851: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFaceSurface(a[0], a[1], a[2]),
    4219587988: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFailureConnectionCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    738692330: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFillAreaStyle(a[0], a[1]),
    3857492461: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFuelProperties(a[0], a[1], a[2], a[3], a[4]),
    803998398: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeneralMaterialProperties(a[0], a[1], a[2], a[3]),
    1446786286: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeneralProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3448662350: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricRepresentationContext(a[0], a[1], a[2], a[3], a[4], a[5]),
    2453401579: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricRepresentationItem(),
    4142052618: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricRepresentationSubContext(a[0], a[1], a[2], a[3], a[4], a[5]),
    3590301190: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricSet(a[0]),
    178086475: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGridPlacement(a[0], a[1]),
    812098782: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHalfSpaceSolid(a[0], a[1]),
    2445078500: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHygroscopicMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    3905492369: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcImageTexture(a[0], a[1], a[2], a[3], a[4]),
    3741457305: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIrregularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1402838566: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSource(a[0], a[1], a[2], a[3]),
    125510826: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourceAmbient(a[0], a[1], a[2], a[3]),
    2604431987: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourceDirectional(a[0], a[1], a[2], a[3], a[4]),
    4266656042: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourceGoniometric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1520743889: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourcePositional(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3422422726: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightSourceSpot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    2624227202: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLocalPlacement(a[0], a[1]),
    1008929658: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLoop(),
    2347385850: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMappedItem(a[0], a[1]),
    2022407955: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMaterialDefinitionRepresentation(a[0], a[1], a[2], a[3]),
    1430189142: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalConcreteMaterialProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    219451334: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcObjectDefinition(a[0], a[1], a[2], a[3]),
    2833995503: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOneDirectionRepeatFactor(a[0]),
    2665983363: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOpenShell(a[0]),
    1029017970: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOrientedEdge(a[0], a[1]),
    2529465313: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterizedProfileDef(a[0], a[1], a[2]),
    2519244187: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPath(a[0]),
    3021840470: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPhysicalComplexQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
    597895409: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPixelTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2004835150: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlacement(a[0]),
    1663979128: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlanarExtent(a[0], a[1]),
    2067069095: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPoint(),
    4022376103: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPointOnCurve(a[0], a[1]),
    1423911732: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPointOnSurface(a[0], a[1], a[2]),
    2924175390: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPolyLoop(a[0]),
    2775532180: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPolygonalBoundedHalfSpace(a[0], a[1], a[2], a[3]),
    759155922: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedColour(a[0]),
    2559016684: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedCurveFont(a[0]),
    433424934: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedDimensionSymbol(a[0]),
    179317114: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPreDefinedPointMarkerSymbol(a[0]),
    673634403: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProductDefinitionShape(a[0], a[1], a[2]),
    871118103: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyBoundedValue(a[0], a[1], a[2], a[3], a[4]),
    1680319473: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyDefinition(a[0], a[1], a[2], a[3]),
    4166981789: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyEnumeratedValue(a[0], a[1], a[2], a[3]),
    2752243245: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyListValue(a[0], a[1], a[2], a[3]),
    941946838: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyReferenceValue(a[0], a[1], a[2], a[3]),
    3357820518: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertySetDefinition(a[0], a[1], a[2], a[3]),
    3650150729: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertySingleValue(a[0], a[1], a[2], a[3]),
    110355661: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertyTableValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3615266464: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRectangleProfileDef(a[0], a[1], a[2], a[3], a[4]),
    3413951693: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRegularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3765753017: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcementDefinitionProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    478536968: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelationship(a[0], a[1], a[2], a[3]),
    2778083089: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRoundedRectangleProfileDef(a[0], a[1], a[2], a[3], a[4], a[5]),
    1509187699: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionedSpine(a[0], a[1], a[2]),
    2411513650: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcServiceLifeFactor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4124623270: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcShellBasedSurfaceModel(a[0]),
    2609359061: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSlippageConnectionCondition(a[0], a[1], a[2], a[3]),
    723233188: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSolidModel(),
    2485662743: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSoundProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1202362311: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSoundValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    390701378: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpaceThermalLoadProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    1595516126: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadLinearForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2668620305: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadPlanarForce(a[0], a[1], a[2], a[3]),
    2473145415: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadSingleDisplacement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1973038258: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadSingleDisplacementDistortion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1597423693: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadSingleForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1190533807: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadSingleForceWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3843319758: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22]),
    3653947884: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralSteelProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22], a[23], a[24], a[25], a[26]),
    2233826070: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSubedge(a[0], a[1], a[2]),
    2513912981: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurface(),
    1878645084: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceStyleRendering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2247615214: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSweptAreaSolid(a[0], a[1]),
    1260650574: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSweptDiskSolid(a[0], a[1], a[2], a[3], a[4]),
    230924584: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSweptSurface(a[0], a[1]),
    3071757647: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    3028897424: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTerminatorSymbol(a[0], a[1], a[2], a[3]),
    4282788508: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextLiteral(a[0], a[1], a[2]),
    3124975700: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextLiteralWithExtent(a[0], a[1], a[2], a[3], a[4]),
    2715220739: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTrapeziumProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1345879162: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTwoDirectionRepeatFactor(a[0], a[1]),
    1628702193: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTypeObject(a[0], a[1], a[2], a[3], a[4], a[5]),
    2347495698: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTypeProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    427810014: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcUShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1417489154: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVector(a[0], a[1]),
    2759199220: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVertexLoop(a[0]),
    336235671: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWindowLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    512836454: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWindowPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1299126871: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWindowStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    2543172580: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcZShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3288037868: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationCurveOccurrence(a[0], a[1], a[2]),
    669184980: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationFillArea(a[0], a[1]),
    2265737646: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationFillAreaOccurrence(a[0], a[1], a[2], a[3], a[4]),
    1302238472: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotationSurface(a[0], a[1]),
    4261334040: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAxis1Placement(a[0], a[1]),
    3125803723: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAxis2Placement2D(a[0], a[1]),
    2740243338: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAxis2Placement3D(a[0], a[1], a[2]),
    2736907675: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBooleanResult(a[0], a[1], a[2]),
    4182860854: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundedSurface(),
    2581212453: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundingBox(a[0], a[1], a[2], a[3]),
    2713105998: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoxedHalfSpace(a[0], a[1], a[2]),
    2898889636: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1123145078: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianPoint(a[0]),
    59481748: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator(a[0], a[1], a[2], a[3]),
    3749851601: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator2D(a[0], a[1], a[2], a[3]),
    3486308946: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator2DnonUniform(a[0], a[1], a[2], a[3], a[4]),
    3331915920: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator3D(a[0], a[1], a[2], a[3], a[4]),
    1416205885: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCartesianTransformationOperator3DnonUniform(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1383045692: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCircleProfileDef(a[0], a[1], a[2], a[3]),
    2205249479: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcClosedShell(a[0]),
    2485617015: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompositeCurveSegment(a[0], a[1], a[2]),
    4133800736: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCraneRailAShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
    194851669: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCraneRailFShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    2506170314: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCsgPrimitive3D(a[0]),
    2147822146: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCsgSolid(a[0]),
    2601014836: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurve(),
    2827736869: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurveBoundedPlane(a[0], a[1], a[2]),
    693772133: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDefinedSymbol(a[0], a[1]),
    606661476: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCurve(a[0], a[1], a[2]),
    4054601972: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCurveTerminator(a[0], a[1], a[2], a[3], a[4]),
    32440307: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDirection(a[0]),
    2963535650: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDoorLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
    1714330368: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDoorPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    526551008: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDoorStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    3073041342: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingCallout(a[0]),
    445594917: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingPreDefinedColour(a[0]),
    4006246654: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDraughtingPreDefinedCurveFont(a[0]),
    1472233963: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEdgeLoop(a[0]),
    1883228015: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
    339256511: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2777663545: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementarySurface(a[0]),
    2835456948: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEllipseProfileDef(a[0], a[1], a[2], a[3], a[4]),
    80994333: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEnergyProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    477187591: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcExtrudedAreaSolid(a[0], a[1], a[2], a[3]),
    2047409740: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFaceBasedSurfaceModel(a[0]),
    374418227: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFillAreaStyleHatching(a[0], a[1], a[2], a[3], a[4]),
    4203026998: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFillAreaStyleTileSymbolWithStyle(a[0]),
    315944413: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFillAreaStyleTiles(a[0], a[1], a[2]),
    3455213021: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFluidFlowProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18]),
    4238390223: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFurnishingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1268542332: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFurnitureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    987898635: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGeometricCurveSet(a[0]),
    1484403080: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    572779678: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1281925730: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLine(a[0], a[1]),
    1425443689: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcManifoldSolidBrep(a[0]),
    3888040117: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcObject(a[0], a[1], a[2], a[3], a[4]),
    3388369263: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOffsetCurve2D(a[0], a[1], a[2]),
    3505215534: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOffsetCurve3D(a[0], a[1], a[2], a[3]),
    3566463478: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPermeableCoveringProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    603570806: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlanarBox(a[0], a[1], a[2]),
    220341763: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlane(a[0]),
    2945172077: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProcess(a[0], a[1], a[2], a[3], a[4]),
    4208778838: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    103090709: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProject(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4194566429: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProjectionCurve(a[0], a[1], a[2]),
    1451395588: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPropertySet(a[0], a[1], a[2], a[3], a[4]),
    3219374653: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2770003689: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRectangleHollowProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2798486643: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRectangularPyramid(a[0], a[1], a[2], a[3]),
    3454111270: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRectangularTrimmedSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3939117080: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssigns(a[0], a[1], a[2], a[3], a[4], a[5]),
    1683148259: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToActor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2495723537: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1307041759: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    4278684876: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2857406711: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3372526763: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToProjectOrder(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    205026976: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsToResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1865459582: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociates(a[0], a[1], a[2], a[3], a[4]),
    1327628568: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesAppliedValue(a[0], a[1], a[2], a[3], a[4], a[5]),
    4095574036: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesApproval(a[0], a[1], a[2], a[3], a[4], a[5]),
    919958153: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesClassification(a[0], a[1], a[2], a[3], a[4], a[5]),
    2728634034: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    982818633: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesDocument(a[0], a[1], a[2], a[3], a[4], a[5]),
    3840914261: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesLibrary(a[0], a[1], a[2], a[3], a[4], a[5]),
    2655215786: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesMaterial(a[0], a[1], a[2], a[3], a[4], a[5]),
    2851387026: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssociatesProfileProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    826625072: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnects(a[0], a[1], a[2], a[3]),
    1204542856: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3945020480: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsPathElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4201705270: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsPortToElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    3190031847: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsPorts(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2127690289: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5]),
    3912681535: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsStructuralElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    1638771189: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    504942748: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsWithEccentricity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3678494232: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelConnectsWithRealizingElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3242617779: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelContainedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
    886880790: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelCoversBldgElements(a[0], a[1], a[2], a[3], a[4], a[5]),
    2802773753: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelCoversSpaces(a[0], a[1], a[2], a[3], a[4], a[5]),
    2551354335: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelDecomposes(a[0], a[1], a[2], a[3], a[4], a[5]),
    693640335: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelDefines(a[0], a[1], a[2], a[3], a[4]),
    4186316022: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelDefinesByProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    781010003: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelDefinesByType(a[0], a[1], a[2], a[3], a[4], a[5]),
    3940055652: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelFillsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    279856033: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelFlowControlElements(a[0], a[1], a[2], a[3], a[4], a[5]),
    4189434867: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelInteractionRequirements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3268803585: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelNests(a[0], a[1], a[2], a[3], a[4], a[5]),
    2051452291: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelOccupiesSpaces(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    202636808: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelOverridesProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    750771296: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelProjectsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    1245217292: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelReferencedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
    1058617721: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelSchedulesCostItems(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    4122056220: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelSequence(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    366585022: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelServicesBuildings(a[0], a[1], a[2], a[3], a[4], a[5]),
    3451746338: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelSpaceBoundary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1401173127: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelVoidsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    2914609552: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcResource(a[0], a[1], a[2], a[3], a[4]),
    1856042241: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRevolvedAreaSolid(a[0], a[1], a[2], a[3]),
    4158566097: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRightCircularCone(a[0], a[1], a[2]),
    3626867408: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRightCircularCylinder(a[0], a[1], a[2]),
    2706606064: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3893378262: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpatialStructureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    451544542: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSphere(a[0], a[1]),
    3544373492: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3136571912: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    530289379: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3689010777: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3979015343: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralSurfaceMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2218152070: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralSurfaceMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4070609034: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuredDimensionCallout(a[0]),
    2028607225: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceCurveSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
    2809605785: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceOfLinearExtrusion(a[0], a[1], a[2], a[3]),
    4124788165: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSurfaceOfRevolution(a[0], a[1], a[2]),
    1580310250: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSystemFurnitureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3473067441: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTask(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2097647324: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTransportElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2296667514: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcActor(a[0], a[1], a[2], a[3], a[4], a[5]),
    1674181508: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAnnotation(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3207858831: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAsymmetricIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1334484129: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBlock(a[0], a[1], a[2], a[3]),
    3649129432: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBooleanClippingResult(a[0], a[1], a[2]),
    1260505505: (_)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoundedCurve(),
    4031249490: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuilding(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1950629157: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3124254112: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingStorey(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2937912522: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCircleHollowProfileDef(a[0], a[1], a[2], a[3], a[4]),
    300633059: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcColumnType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3732776249: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompositeCurve(a[0], a[1]),
    2510884976: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConic(a[0]),
    2559216714: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstructionResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3293443760: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcControl(a[0], a[1], a[2], a[3], a[4]),
    3895139033: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCostItem(a[0], a[1], a[2], a[3], a[4]),
    1419761937: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCostSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    1916426348: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCoveringType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3295246426: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCrewResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1457835157: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurtainWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    681481545: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCurveDirectedCallout(a[0]),
    3256556792: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3849074793: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionFlowElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    360485395: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricalBaseProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    1758889154: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4123344466: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementAssembly(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1623761950: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementComponent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2590856083: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElementComponentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1704287377: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEllipse(a[0], a[1], a[2]),
    2107101300: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEnergyConversionDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1962604670: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEquipmentElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3272907226: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEquipmentStandard(a[0], a[1], a[2], a[3], a[4]),
    3174744832: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEvaporativeCoolerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3390157468: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEvaporatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    807026263: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFacetedBrep(a[0]),
    3737207727: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFacetedBrepWithVoids(a[0], a[1]),
    647756555: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2489546625: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2827207264: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFeatureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2143335405: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFeatureElementAddition(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1287392070: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFeatureElementSubtraction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3907093117: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3198132628: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3815607619: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowMeterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1482959167: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowMovingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1834744321: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1339347760: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2297155007: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3009222698: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowTreatmentDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    263784265: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFurnishingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    814719939: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFurnitureStandard(a[0], a[1], a[2], a[3], a[4]),
    200128114: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGasTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3009204131: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGrid(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2706460486: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGroup(a[0], a[1], a[2], a[3], a[4]),
    1251058090: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHeatExchangerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1806887404: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHumidifierType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2391368822: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcInventory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4288270099: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcJunctionBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3827777499: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLaborResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1051575348: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1161773419: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLightFixtureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2506943328: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearDimension(a[0]),
    377706215: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2108223431: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMechanicalFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3181161470: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMemberType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    977012517: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMotorConnectionType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1916936684: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMove(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    4143007308: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOccupant(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3588315303: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOpeningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3425660407: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOrderAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2837617999: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcOutletType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2382730787: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPerformanceHistory(a[0], a[1], a[2], a[3], a[4], a[5]),
    3327091369: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPermit(a[0], a[1], a[2], a[3], a[4], a[5]),
    804291784: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPipeFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4231323485: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPipeSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4017108033: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlateType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3724593414: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPolyline(a[0]),
    3740093272: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2744685151: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProcedure(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2904328755: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProjectOrder(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3642467123: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProjectOrderRecord(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3651124850: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProjectionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1842657554: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcProtectiveDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2250791053: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPumpType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3248260540: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRadiusDimension(a[0]),
    2893384427: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRailingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2324767716: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRampFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    160246688: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAggregates(a[0], a[1], a[2], a[3], a[4], a[5]),
    2863920197: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRelAssignsTasks(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1768891740: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSanitaryTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3517283431: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcScheduleTimeControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22]),
    4105383287: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcServiceLife(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    4097777520: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSite(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    2533589738: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSlabType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3856911033: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpace(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1305183839: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpaceHeaterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    652456506: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpaceProgram(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3812236995: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpaceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3112655638: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStackTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1039846685: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStairFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    682877961: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1179482911: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4243806635: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralCurveConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    214636428: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralCurveMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2445595289: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralCurveMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1807405624: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLinearAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1721250024: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLinearActionVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    1252848954: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralLoadGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1621171031: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPlanarAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    3987759626: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPlanarActionVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    2082059205: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPointAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    734778138: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPointConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1235345126: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralPointReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2986769608: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralResultGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1975003073: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralSurfaceConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    148013059: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSubContractResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2315554128: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSwitchingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2254336722: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSystem(a[0], a[1], a[2], a[3], a[4]),
    5716631: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTankType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1637806684: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeSeriesSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1692211062: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTransformerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1620046519: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTransportElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3593883385: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTrimmedCurve(a[0], a[1], a[2], a[3], a[4]),
    1600972822: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTubeBundleType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1911125066: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcUnitaryEquipmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    728799441: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcValveType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2769231204: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVirtualElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1898987631: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1133259667: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWasteTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1028945134: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWorkControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
    4218914973: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWorkPlan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
    3342526732: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWorkSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
    1033361043: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcZone(a[0], a[1], a[2], a[3], a[4]),
    1213861670: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.Ifc2DCompositeCurve(a[0], a[1]),
    3821786052: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcActionRequest(a[0], a[1], a[2], a[3], a[4], a[5]),
    1411407467: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAirTerminalBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3352864051: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAirTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1871374353: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAirToAirHeatRecoveryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2470393545: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAngularDimension(a[0]),
    3460190687: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAsset(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    1967976161: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBSplineCurve(a[0], a[1], a[2], a[3], a[4]),
    819618141: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1916977116: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBezierCurve(a[0], a[1], a[2], a[3], a[4]),
    231477066: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoilerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3299480353: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    52481810: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementComponent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2979338954: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1095909175: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1909888760: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBuildingElementProxyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    395041908: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCableCarrierFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3293546465: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCableCarrierSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1285652485: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCableSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2951183804: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcChillerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2611217952: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCircle(a[0], a[1]),
    2301859152: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCoilType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    843113511: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcColumn(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3850581409: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompressorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2816379211: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCondenserType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2188551683: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCondition(a[0], a[1], a[2], a[3], a[4]),
    1163958913: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConditionCriterion(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3898045240: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstructionEquipmentResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1060000209: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstructionMaterialResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    488727124: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcConstructionProductResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    335055490: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCooledBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2954562838: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCoolingTowerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1973544240: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCovering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3495092785: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurtainWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3961806047: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDamperType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4147604152: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDiameterDimension(a[0]),
    1335981549: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDiscreteAccessory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2635815018: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDiscreteAccessoryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1599208980: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionChamberElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2063403501: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1945004755: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3040386961: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionFlowElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3041715199: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    395920057: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDoor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    869906466: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDuctFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3760055223: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDuctSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2030761528: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDuctSilencerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    855621170: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEdgeFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    663422040: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3277789161: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1534661035: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricGeneratorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1365060375: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricHeaterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1217240411: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricMotorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    712377611: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricTimeControlType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1634875225: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricalCircuit(a[0], a[1], a[2], a[3], a[4]),
    857184966: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricalElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1658829314: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEnergyConversionDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    346874300: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFanType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1810631287: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFilterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4222183408: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFireSuppressionTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2058353004: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4278956645: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4037862832: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowInstrumentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3132237377: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowMovingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    987401354: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    707683696: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2223149337: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3508470533: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFlowTreatmentDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    900683007: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFooting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1073191201: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1687234759: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPile(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3171933400: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2262370178: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRailing(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3024970846: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3283111854: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRampFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3055160366: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRationalBezierCurve(a[0], a[1], a[2], a[3], a[4], a[5]),
    3027567501: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2320036040: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcingMesh(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
    2016517767: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRoof(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1376911519: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRoundedEdgeFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1783015770: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSensorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1529196076: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSlab(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    331165859: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStair(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4252922144: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStairFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    2515109513: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcStructuralAnalysisModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3824725483: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTendon(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
    2347447852: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTendonAnchor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3313531582: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVibrationIsolatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2391406946: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3512223829: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWallStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3304561284: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWindow(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2874132201: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcActuatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3001207471: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAlarmType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    753842376: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2454782716: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcChamferEdgeFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    578613899: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1052013943: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionChamberElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1062813311: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDistributionControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3700593921: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricDistributionPoint(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    979691226: (a)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReinforcingBar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13])
};
$3b8da494b8e92f36$export$4085d3c0722bed8d[1] = {
    3630933823: (i)=>[
            i.Role,
            i.UserDefinedRole,
            i.Description
        ],
    618182010: (i)=>[
            i.Purpose,
            i.Description,
            i.UserDefinedPurpose
        ],
    639542469: (i)=>[
            i.ApplicationDeveloper,
            i.Version,
            i.ApplicationFullName,
            i.ApplicationIdentifier
        ],
    411424972: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AppliedValue),
            i.UnitBasis,
            $3b8da494b8e92f36$var$Labelise(i.ApplicableDate),
            $3b8da494b8e92f36$var$Labelise(i.FixedUntilDate)
        ],
    1110488051: (i)=>[
            i.ComponentOfTotal,
            i.Components,
            i.ArithmeticOperator,
            i.Name,
            i.Description
        ],
    130549933: (i)=>[
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.ApprovalDateTime),
            i.ApprovalStatus,
            i.ApprovalLevel,
            i.ApprovalQualifier,
            i.Name,
            i.Identifier
        ],
    2080292479: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Actor),
            i.Approval,
            i.Role
        ],
    390851274: (i)=>[
            i.ApprovedProperties,
            i.Approval
        ],
    3869604511: (i)=>[
            i.RelatedApproval,
            i.RelatingApproval,
            i.Description,
            i.Name
        ],
    4037036970: (i)=>[
            i.Name
        ],
    1560379544: (i)=>[
            i.Name,
            i.LinearStiffnessByLengthX,
            i.LinearStiffnessByLengthY,
            i.LinearStiffnessByLengthZ,
            i.RotationalStiffnessByLengthX,
            i.RotationalStiffnessByLengthY,
            i.RotationalStiffnessByLengthZ
        ],
    3367102660: (i)=>[
            i.Name,
            i.LinearStiffnessByAreaX,
            i.LinearStiffnessByAreaY,
            i.LinearStiffnessByAreaZ
        ],
    1387855156: (i)=>[
            i.Name,
            i.LinearStiffnessX,
            i.LinearStiffnessY,
            i.LinearStiffnessZ,
            i.RotationalStiffnessX,
            i.RotationalStiffnessY,
            i.RotationalStiffnessZ
        ],
    2069777674: (i)=>[
            i.Name,
            i.LinearStiffnessX,
            i.LinearStiffnessY,
            i.LinearStiffnessZ,
            i.RotationalStiffnessX,
            i.RotationalStiffnessY,
            i.RotationalStiffnessZ,
            i.WarpingStiffness
        ],
    622194075: (i)=>[
            i.DayComponent,
            i.MonthComponent,
            i.YearComponent
        ],
    747523909: (i)=>[
            i.Source,
            i.Edition,
            i.EditionDate,
            i.Name
        ],
    1767535486: (i)=>[
            i.Notation,
            i.ItemOf,
            i.Title
        ],
    1098599126: (i)=>[
            i.RelatingItem,
            i.RelatedItems
        ],
    938368621: (i)=>[
            i.NotationFacets
        ],
    3639012971: (i)=>[
            i.NotationValue
        ],
    3264961684: (i)=>[
            i.Name
        ],
    2859738748: (_)=>[],
    2614616156: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatedElement)
        ],
    4257277454: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.LocationAtRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.LocationAtRelatedElement),
            i.ProfileOfPort
        ],
    2732653382: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SurfaceOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.SurfaceOnRelatedElement)
        ],
    1959218052: (i)=>[
            i.Name,
            i.Description,
            i.ConstraintGrade,
            i.ConstraintSource,
            $3b8da494b8e92f36$var$Labelise(i.CreatingActor),
            $3b8da494b8e92f36$var$Labelise(i.CreationTime),
            i.UserDefinedGrade
        ],
    1658513725: (i)=>[
            i.Name,
            i.Description,
            i.RelatingConstraint,
            i.RelatedConstraints,
            i.LogicalAggregator
        ],
    613356794: (i)=>[
            i.ClassifiedConstraint,
            $3b8da494b8e92f36$var$Labelise(i.RelatedClassifications)
        ],
    347226245: (i)=>[
            i.Name,
            i.Description,
            i.RelatingConstraint,
            i.RelatedConstraints
        ],
    1065062679: (i)=>[
            i.HourOffset,
            i.MinuteOffset,
            i.Sense
        ],
    602808272: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AppliedValue),
            i.UnitBasis,
            $3b8da494b8e92f36$var$Labelise(i.ApplicableDate),
            $3b8da494b8e92f36$var$Labelise(i.FixedUntilDate),
            i.CostType,
            i.Condition
        ],
    539742890: (i)=>[
            i.RelatingMonetaryUnit,
            i.RelatedMonetaryUnit,
            i.ExchangeRate,
            i.RateDateTime,
            i.RateSource
        ],
    1105321065: (i)=>[
            i.Name,
            i.PatternList
        ],
    2367409068: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.CurveFont),
            i.CurveFontScaling
        ],
    3510044353: (i)=>[
            i.VisibleSegmentLength,
            i.InvisibleSegmentLength
        ],
    1072939445: (i)=>[
            i.DateComponent,
            i.TimeComponent
        ],
    1765591967: (i)=>[
            i.Elements,
            i.UnitType,
            i.UserDefinedType
        ],
    1045800335: (i)=>[
            i.Unit,
            i.Exponent
        ],
    2949456006: (i)=>[
            i.LengthExponent,
            i.MassExponent,
            i.TimeExponent,
            i.ElectricCurrentExponent,
            i.ThermodynamicTemperatureExponent,
            i.AmountOfSubstanceExponent,
            i.LuminousIntensityExponent
        ],
    1376555844: (i)=>[
            i.FileExtension,
            i.MimeContentType,
            i.MimeSubtype
        ],
    1154170062: (i)=>[
            i.DocumentId,
            i.Name,
            i.Description,
            i.DocumentReferences,
            i.Purpose,
            i.IntendedUse,
            i.Scope,
            i.Revision,
            $3b8da494b8e92f36$var$Labelise(i.DocumentOwner),
            $3b8da494b8e92f36$var$Labelise(i.Editors),
            i.CreationTime,
            i.LastRevisionTime,
            i.ElectronicFormat,
            i.ValidFrom,
            i.ValidUntil,
            i.Confidentiality,
            i.Status
        ],
    770865208: (i)=>[
            i.RelatingDocument,
            i.RelatedDocuments,
            i.RelationshipType
        ],
    3796139169: (i)=>[
            i.Name,
            i.Description,
            i.RelatingDraughtingCallout,
            i.RelatedDraughtingCallout
        ],
    1648886627: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AppliedValue),
            i.UnitBasis,
            $3b8da494b8e92f36$var$Labelise(i.ApplicableDate),
            $3b8da494b8e92f36$var$Labelise(i.FixedUntilDate),
            i.ImpactType,
            i.Category,
            i.UserDefinedCategory
        ],
    3200245327: (i)=>[
            i.Location,
            i.ItemReference,
            i.Name
        ],
    2242383968: (i)=>[
            i.Location,
            i.ItemReference,
            i.Name
        ],
    1040185647: (i)=>[
            i.Location,
            i.ItemReference,
            i.Name
        ],
    3207319532: (i)=>[
            i.Location,
            i.ItemReference,
            i.Name
        ],
    3548104201: (i)=>[
            i.Location,
            i.ItemReference,
            i.Name
        ],
    852622518: (i)=>[
            i.AxisTag,
            i.AxisCurve,
            {
                type: 3,
                value: i.SameSense.value
            }
        ],
    3020489413: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.TimeStamp),
            i.ListValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    2655187982: (i)=>[
            i.Name,
            i.Version,
            i.Publisher,
            i.VersionDate,
            i.LibraryReference
        ],
    3452421091: (i)=>[
            i.Location,
            i.ItemReference,
            i.Name
        ],
    4162380809: (i)=>[
            i.MainPlaneAngle,
            i.SecondaryPlaneAngle,
            i.LuminousIntensity
        ],
    1566485204: (i)=>[
            i.LightDistributionCurve,
            i.DistributionData
        ],
    30780891: (i)=>[
            i.HourComponent,
            i.MinuteComponent,
            i.SecondComponent,
            i.Zone,
            i.DaylightSavingOffset
        ],
    1838606355: (i)=>[
            i.Name
        ],
    1847130766: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.MaterialClassifications),
            i.ClassifiedMaterial
        ],
    248100487: (i)=>[
            i.Material,
            i.LayerThickness,
            i.IsVentilated == null ? null : {
                type: 3,
                value: i.IsVentilated.value
            }
        ],
    3303938423: (i)=>[
            i.MaterialLayers,
            i.LayerSetName
        ],
    1303795690: (i)=>[
            i.ForLayerSet,
            i.LayerSetDirection,
            i.DirectionSense,
            i.OffsetFromReferenceLine
        ],
    2199411900: (i)=>[
            i.Materials
        ],
    3265635763: (i)=>[
            i.Material
        ],
    2597039031: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.ValueComponent),
            $3b8da494b8e92f36$var$Labelise(i.UnitComponent)
        ],
    4256014907: (i)=>[
            i.Material,
            i.DynamicViscosity,
            i.YoungModulus,
            i.ShearModulus,
            i.PoissonRatio,
            i.ThermalExpansionCoefficient
        ],
    677618848: (i)=>[
            i.Material,
            i.DynamicViscosity,
            i.YoungModulus,
            i.ShearModulus,
            i.PoissonRatio,
            i.ThermalExpansionCoefficient,
            i.YieldStress,
            i.UltimateStress,
            i.UltimateStrain,
            i.HardeningModule,
            i.ProportionalStress,
            i.PlasticStrain,
            i.Relaxations
        ],
    3368373690: (i)=>[
            i.Name,
            i.Description,
            i.ConstraintGrade,
            i.ConstraintSource,
            $3b8da494b8e92f36$var$Labelise(i.CreatingActor),
            $3b8da494b8e92f36$var$Labelise(i.CreationTime),
            i.UserDefinedGrade,
            i.Benchmark,
            i.ValueSource,
            $3b8da494b8e92f36$var$Labelise(i.DataValue)
        ],
    2706619895: (i)=>[
            i.Currency
        ],
    1918398963: (i)=>[
            i.Dimensions,
            i.UnitType
        ],
    3701648758: (_)=>[],
    2251480897: (i)=>[
            i.Name,
            i.Description,
            i.ConstraintGrade,
            i.ConstraintSource,
            $3b8da494b8e92f36$var$Labelise(i.CreatingActor),
            $3b8da494b8e92f36$var$Labelise(i.CreationTime),
            i.UserDefinedGrade,
            i.BenchmarkValues,
            i.ResultValues,
            i.ObjectiveQualifier,
            i.UserDefinedQualifier
        ],
    1227763645: (i)=>[
            i.Material,
            i.VisibleTransmittance,
            i.SolarTransmittance,
            i.ThermalIrTransmittance,
            i.ThermalIrEmissivityBack,
            i.ThermalIrEmissivityFront,
            i.VisibleReflectanceBack,
            i.VisibleReflectanceFront,
            i.SolarReflectanceFront,
            i.SolarReflectanceBack
        ],
    4251960020: (i)=>[
            i.Id,
            i.Name,
            i.Description,
            i.Roles,
            i.Addresses
        ],
    1411181986: (i)=>[
            i.Name,
            i.Description,
            i.RelatingOrganization,
            i.RelatedOrganizations
        ],
    1207048766: (i)=>[
            i.OwningUser,
            i.OwningApplication,
            i.State,
            i.ChangeAction,
            i.LastModifiedDate,
            i.LastModifyingUser,
            i.LastModifyingApplication,
            i.CreationDate
        ],
    2077209135: (i)=>[
            i.Id,
            i.FamilyName,
            i.GivenName,
            i.MiddleNames,
            i.PrefixTitles,
            i.SuffixTitles,
            i.Roles,
            i.Addresses
        ],
    101040310: (i)=>[
            i.ThePerson,
            i.TheOrganization,
            i.Roles
        ],
    2483315170: (i)=>[
            i.Name,
            i.Description
        ],
    2226359599: (i)=>[
            i.Name,
            i.Description,
            i.Unit
        ],
    3355820592: (i)=>[
            i.Purpose,
            i.Description,
            i.UserDefinedPurpose,
            i.InternalLocation,
            i.AddressLines,
            i.PostalBox,
            i.Town,
            i.Region,
            i.PostalCode,
            i.Country
        ],
    3727388367: (i)=>[
            i.Name
        ],
    990879717: (i)=>[
            i.Name
        ],
    3213052703: (i)=>[
            i.Name
        ],
    1775413392: (i)=>[
            i.Name
        ],
    2022622350: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AssignedItems),
            i.Identifier
        ],
    1304840413: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AssignedItems),
            i.Identifier,
            i.LayerOn,
            i.LayerFrozen,
            i.LayerBlocked,
            $3b8da494b8e92f36$var$Labelise(i.LayerStyles)
        ],
    3119450353: (i)=>[
            i.Name
        ],
    2417041796: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Styles)
        ],
    2095639259: (i)=>[
            i.Name,
            i.Description,
            i.Representations
        ],
    2267347899: (i)=>[
            i.Material,
            i.SpecificHeatCapacity,
            i.N20Content,
            i.COContent,
            i.CO2Content
        ],
    3958567839: (i)=>[
            i.ProfileType,
            i.ProfileName
        ],
    2802850158: (i)=>[
            i.ProfileName,
            i.ProfileDefinition
        ],
    2598011224: (i)=>[
            i.Name,
            i.Description
        ],
    3896028662: (i)=>[
            i.RelatingConstraint,
            i.RelatedProperties,
            i.Name,
            i.Description
        ],
    148025276: (i)=>[
            i.DependingProperty,
            i.DependantProperty,
            i.Name,
            i.Description,
            i.Expression
        ],
    3710013099: (i)=>[
            i.Name,
            i.EnumerationValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    2044713172: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.AreaValue
        ],
    2093928680: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.CountValue
        ],
    931644368: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.LengthValue
        ],
    3252649465: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.TimeValue
        ],
    2405470396: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.VolumeValue
        ],
    825690147: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.WeightValue
        ],
    2692823254: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.ReferencedDocument),
            i.ReferencingValues,
            i.Name,
            i.Description
        ],
    1580146022: (i)=>[
            i.TotalCrossSectionArea,
            i.SteelGrade,
            i.BarSurface,
            i.EffectiveDepth,
            i.NominalBarDiameter,
            i.BarCount
        ],
    1222501353: (i)=>[
            i.RelaxationValue,
            i.InitialStress
        ],
    1076942058: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    3377609919: (i)=>[
            i.ContextIdentifier,
            i.ContextType
        ],
    3008791417: (_)=>[],
    1660063152: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.MappingOrigin),
            i.MappedRepresentation
        ],
    3679540991: (i)=>[
            i.ProfileName,
            i.ProfileDefinition,
            i.Thickness,
            i.RibHeight,
            i.RibWidth,
            i.RibSpacing,
            i.Direction
        ],
    2341007311: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    448429030: (i)=>[
            void 0,
            i.UnitType,
            i.Prefix,
            i.Name
        ],
    2042790032: (i)=>[
            i.SectionType,
            i.StartProfile,
            i.EndProfile
        ],
    4165799628: (i)=>[
            i.LongitudinalStartPosition,
            i.LongitudinalEndPosition,
            i.TransversePosition,
            i.ReinforcementRole,
            i.SectionDefinition,
            i.CrossSectionReinforcementDefinitions
        ],
    867548509: (i)=>[
            i.ShapeRepresentations,
            i.Name,
            i.Description,
            i.ProductDefinitional,
            i.PartOfProductDefinitionShape
        ],
    3982875396: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    4240577450: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    3692461612: (i)=>[
            i.Name,
            i.Description
        ],
    2273995522: (i)=>[
            i.Name
        ],
    2162789131: (i)=>[
            i.Name
        ],
    2525727697: (i)=>[
            i.Name
        ],
    3408363356: (i)=>[
            i.Name,
            i.DeltaT_Constant,
            i.DeltaT_Y,
            i.DeltaT_Z
        ],
    2830218821: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    3958052878: (i)=>[
            i.Item,
            i.Styles,
            i.Name
        ],
    3049322572: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    1300840506: (i)=>[
            i.Name,
            i.Side,
            $3b8da494b8e92f36$var$Labelise(i.Styles)
        ],
    3303107099: (i)=>[
            i.DiffuseTransmissionColour,
            i.DiffuseReflectionColour,
            i.TransmissionColour,
            i.ReflectanceColour
        ],
    1607154358: (i)=>[
            i.RefractionIndex,
            i.DispersionFactor
        ],
    846575682: (i)=>[
            i.SurfaceColour
        ],
    1351298697: (i)=>[
            i.Textures
        ],
    626085974: (i)=>[
            i.RepeatS,
            i.RepeatT,
            i.TextureType,
            i.TextureTransform
        ],
    1290481447: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.StyleOfSymbol)
        ],
    985171141: (i)=>[
            i.Name,
            i.Rows
        ],
    531007025: (i)=>[
            i.RowCells.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.IsHeading
        ],
    912023232: (i)=>[
            i.Purpose,
            i.Description,
            i.UserDefinedPurpose,
            i.TelephoneNumbers,
            i.FacsimileNumbers,
            i.PagerNumber,
            i.ElectronicMailAddresses,
            i.WWWHomePageURL
        ],
    1447204868: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.TextCharacterAppearance),
            $3b8da494b8e92f36$var$Labelise(i.TextStyle),
            $3b8da494b8e92f36$var$Labelise(i.TextFontStyle)
        ],
    1983826977: (i)=>[
            i.Name,
            i.FontFamily,
            i.FontStyle,
            i.FontVariant,
            i.FontWeight,
            $3b8da494b8e92f36$var$Labelise(i.FontSize)
        ],
    2636378356: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Colour),
            $3b8da494b8e92f36$var$Labelise(i.BackgroundColour)
        ],
    1640371178: (i)=>[
            (i.TextIndent ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TextIndent),
            i.TextAlign,
            i.TextDecoration,
            (i.LetterSpacing ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LetterSpacing),
            (i.WordSpacing ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.WordSpacing),
            i.TextTransform,
            (i.LineHeight ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LineHeight)
        ],
    1484833681: (i)=>[
            i.BoxHeight,
            i.BoxWidth,
            i.BoxSlantAngle,
            i.BoxRotateAngle,
            (i.CharacterSpacing ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.CharacterSpacing)
        ],
    280115917: (_)=>[],
    1742049831: (i)=>[
            i.Mode,
            i.Parameter.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    2552916305: (i)=>[
            i.TextureMaps
        ],
    1210645708: (i)=>[
            i.Coordinates
        ],
    3317419933: (i)=>[
            i.Material,
            i.SpecificHeatCapacity,
            i.BoilingPoint,
            i.FreezingPoint,
            i.ThermalConductivity
        ],
    3101149627: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.StartTime),
            $3b8da494b8e92f36$var$Labelise(i.EndTime),
            i.TimeSeriesDataType,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    1718945513: (i)=>[
            i.ReferencedTimeSeries,
            $3b8da494b8e92f36$var$Labelise(i.TimeSeriesReferences)
        ],
    581633288: (i)=>[
            i.ListValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    1377556343: (_)=>[],
    1735638870: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    180925521: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Units)
        ],
    2799835756: (_)=>[],
    3304826586: (i)=>[
            i.TextureVertices,
            i.TexturePoints
        ],
    1907098498: (i)=>[
            i.VertexGeometry
        ],
    891718957: (i)=>[
            i.IntersectingAxes,
            i.OffsetDistances
        ],
    1065908215: (i)=>[
            i.Material,
            i.IsPotable,
            i.Hardness,
            i.AlkalinityConcentration,
            i.AcidityConcentration,
            i.ImpuritiesContent,
            i.PHLevel,
            i.DissolvedSolidsContent
        ],
    2442683028: (i)=>[
            i.Item,
            i.Styles,
            i.Name
        ],
    962685235: (i)=>[
            i.Item,
            i.Styles,
            i.Name
        ],
    3612888222: (i)=>[
            i.Item,
            i.Styles,
            i.Name
        ],
    2297822566: (i)=>[
            i.Item,
            i.Styles,
            i.Name
        ],
    3798115385: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.OuterCurve
        ],
    1310608509: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Curve
        ],
    2705031697: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.OuterCurve,
            i.InnerCurves
        ],
    616511568: (i)=>[
            i.RepeatS,
            i.RepeatT,
            i.TextureType,
            i.TextureTransform,
            i.RasterFormat,
            i.RasterCode
        ],
    3150382593: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Curve,
            i.Thickness
        ],
    647927063: (i)=>[
            i.Location,
            i.ItemReference,
            i.Name,
            i.ReferencedSource
        ],
    776857604: (i)=>[
            i.Name,
            i.Red,
            i.Green,
            i.Blue
        ],
    2542286263: (i)=>[
            i.Name,
            i.Description,
            i.UsageName,
            i.HasProperties
        ],
    1485152156: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Profiles,
            i.Label
        ],
    370225590: (i)=>[
            i.CfsFaces
        ],
    1981873012: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.CurveOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.CurveOnRelatedElement)
        ],
    45288368: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatedElement),
            i.EccentricityInX,
            i.EccentricityInY,
            i.EccentricityInZ
        ],
    3050246964: (i)=>[
            i.Dimensions,
            i.UnitType,
            i.Name
        ],
    2889183280: (i)=>[
            i.Dimensions,
            i.UnitType,
            i.Name,
            i.ConversionFactor
        ],
    3800577675: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.CurveFont),
            (i.CurveWidth ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.CurveWidth),
            $3b8da494b8e92f36$var$Labelise(i.CurveColour)
        ],
    3632507154: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.ParentProfile,
            i.Operator,
            i.Label
        ],
    2273265877: (i)=>[
            i.Name,
            i.Description,
            i.RelatingDraughtingCallout,
            i.RelatedDraughtingCallout
        ],
    1694125774: (i)=>[
            i.Name,
            i.Description,
            i.RelatingDraughtingCallout,
            i.RelatedDraughtingCallout
        ],
    3732053477: (i)=>[
            i.Location,
            i.ItemReference,
            i.Name
        ],
    4170525392: (i)=>[
            i.Name
        ],
    3900360178: (i)=>[
            i.EdgeStart,
            i.EdgeEnd
        ],
    476780140: (i)=>[
            i.EdgeStart,
            i.EdgeEnd,
            i.EdgeGeometry,
            i.SameSense
        ],
    1860660968: (i)=>[
            i.Material,
            i.ExtendedProperties,
            i.Description,
            i.Name
        ],
    2556980723: (i)=>[
            i.Bounds
        ],
    1809719519: (i)=>[
            i.Bound,
            i.Orientation
        ],
    803316827: (i)=>[
            i.Bound,
            i.Orientation
        ],
    3008276851: (i)=>[
            i.Bounds,
            i.FaceSurface,
            i.SameSense
        ],
    4219587988: (i)=>[
            i.Name,
            i.TensionFailureX,
            i.TensionFailureY,
            i.TensionFailureZ,
            i.CompressionFailureX,
            i.CompressionFailureY,
            i.CompressionFailureZ
        ],
    738692330: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.FillStyles)
        ],
    3857492461: (i)=>[
            i.Material,
            i.CombustionTemperature,
            i.CarbonContent,
            i.LowerHeatingValue,
            i.HigherHeatingValue
        ],
    803998398: (i)=>[
            i.Material,
            i.MolecularWeight,
            i.Porosity,
            i.MassDensity
        ],
    1446786286: (i)=>[
            i.ProfileName,
            i.ProfileDefinition,
            i.PhysicalWeight,
            i.Perimeter,
            i.MinimumPlateThickness,
            i.MaximumPlateThickness,
            i.CrossSectionArea
        ],
    3448662350: (i)=>[
            i.ContextIdentifier,
            i.ContextType,
            i.CoordinateSpaceDimension,
            i.Precision,
            $3b8da494b8e92f36$var$Labelise(i.WorldCoordinateSystem),
            i.TrueNorth
        ],
    2453401579: (_)=>[],
    4142052618: (i)=>[
            i.ContextIdentifier,
            i.ContextType,
            void 0,
            void 0,
            void 0,
            void 0,
            i.ParentContext,
            i.TargetScale,
            i.TargetView,
            i.UserDefinedTargetView
        ],
    3590301190: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Elements)
        ],
    178086475: (i)=>[
            i.PlacementLocation,
            i.PlacementRefDirection
        ],
    812098782: (i)=>[
            i.BaseSurface,
            i.AgreementFlag
        ],
    2445078500: (i)=>[
            i.Material,
            i.UpperVaporResistanceFactor,
            i.LowerVaporResistanceFactor,
            i.IsothermalMoistureCapacity,
            i.VaporPermeability,
            i.MoistureDiffusivity
        ],
    3905492369: (i)=>[
            i.RepeatS,
            i.RepeatT,
            i.TextureType,
            i.TextureTransform,
            i.UrlReference
        ],
    3741457305: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.StartTime),
            $3b8da494b8e92f36$var$Labelise(i.EndTime),
            i.TimeSeriesDataType,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            i.Values
        ],
    1402838566: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity
        ],
    125510826: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity
        ],
    2604431987: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Orientation
        ],
    4266656042: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Position,
            i.ColourAppearance,
            i.ColourTemperature,
            i.LuminousFlux,
            i.LightEmissionSource,
            $3b8da494b8e92f36$var$Labelise(i.LightDistributionDataSource)
        ],
    1520743889: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Position,
            i.Radius,
            i.ConstantAttenuation,
            i.DistanceAttenuation,
            i.QuadricAttenuation
        ],
    3422422726: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Position,
            i.Radius,
            i.ConstantAttenuation,
            i.DistanceAttenuation,
            i.QuadricAttenuation,
            i.Orientation,
            i.ConcentrationExponent,
            i.SpreadAngle,
            i.BeamWidthAngle
        ],
    2624227202: (i)=>[
            i.PlacementRelTo,
            $3b8da494b8e92f36$var$Labelise(i.RelativePlacement)
        ],
    1008929658: (_)=>[],
    2347385850: (i)=>[
            i.MappingSource,
            i.MappingTarget
        ],
    2022407955: (i)=>[
            i.Name,
            i.Description,
            i.Representations,
            i.RepresentedMaterial
        ],
    1430189142: (i)=>[
            i.Material,
            i.DynamicViscosity,
            i.YoungModulus,
            i.ShearModulus,
            i.PoissonRatio,
            i.ThermalExpansionCoefficient,
            i.CompressiveStrength,
            i.MaxAggregateSize,
            i.AdmixturesDescription,
            i.Workability,
            i.ProtectivePoreRatio,
            i.WaterImpermeability
        ],
    219451334: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    2833995503: (i)=>[
            i.RepeatFactor
        ],
    2665983363: (i)=>[
            i.CfsFaces
        ],
    1029017970: (i)=>[
            void 0,
            void 0,
            i.EdgeElement,
            i.Orientation
        ],
    2529465313: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position
        ],
    2519244187: (i)=>[
            i.EdgeList
        ],
    3021840470: (i)=>[
            i.Name,
            i.Description,
            i.HasQuantities,
            i.Discrimination,
            i.Quality,
            i.Usage
        ],
    597895409: (i)=>[
            i.RepeatS,
            i.RepeatT,
            i.TextureType,
            i.TextureTransform,
            i.Width,
            i.Height,
            i.ColourComponents,
            i.Pixel
        ],
    2004835150: (i)=>[
            i.Location
        ],
    1663979128: (i)=>[
            i.SizeInX,
            i.SizeInY
        ],
    2067069095: (_)=>[],
    4022376103: (i)=>[
            i.BasisCurve,
            i.PointParameter
        ],
    1423911732: (i)=>[
            i.BasisSurface,
            i.PointParameterU,
            i.PointParameterV
        ],
    2924175390: (i)=>[
            i.Polygon
        ],
    2775532180: (i)=>[
            i.BaseSurface,
            i.AgreementFlag,
            i.Position,
            i.PolygonalBoundary
        ],
    759155922: (i)=>[
            i.Name
        ],
    2559016684: (i)=>[
            i.Name
        ],
    433424934: (i)=>[
            i.Name
        ],
    179317114: (i)=>[
            i.Name
        ],
    673634403: (i)=>[
            i.Name,
            i.Description,
            i.Representations
        ],
    871118103: (i)=>[
            i.Name,
            i.Description,
            (i.UpperBoundValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.UpperBoundValue),
            (i.LowerBoundValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LowerBoundValue),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    1680319473: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    4166981789: (i)=>[
            i.Name,
            i.Description,
            i.EnumerationValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.EnumerationReference
        ],
    2752243245: (i)=>[
            i.Name,
            i.Description,
            i.ListValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    941946838: (i)=>[
            i.Name,
            i.Description,
            i.UsageName,
            $3b8da494b8e92f36$var$Labelise(i.PropertyReference)
        ],
    3357820518: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    3650150729: (i)=>[
            i.Name,
            i.Description,
            (i.NominalValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.NominalValue),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    110355661: (i)=>[
            i.Name,
            i.Description,
            i.DefiningValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.DefinedValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.Expression,
            $3b8da494b8e92f36$var$Labelise(i.DefiningUnit),
            $3b8da494b8e92f36$var$Labelise(i.DefinedUnit)
        ],
    3615266464: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.XDim,
            i.YDim
        ],
    3413951693: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.StartTime),
            $3b8da494b8e92f36$var$Labelise(i.EndTime),
            i.TimeSeriesDataType,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            i.TimeStep,
            i.Values
        ],
    3765753017: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.DefinitionType,
            i.ReinforcementSectionDefinitions
        ],
    478536968: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    2778083089: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.XDim,
            i.YDim,
            i.RoundingRadius
        ],
    1509187699: (i)=>[
            i.SpineCurve,
            i.CrossSections,
            i.CrossSectionPositions
        ],
    2411513650: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.PredefinedType,
            (i.UpperValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.UpperValue),
            $3b8da494b8e92f36$var$Labelise(i.MostUsedValue),
            (i.LowerValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LowerValue)
        ],
    4124623270: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SbsmBoundary)
        ],
    2609359061: (i)=>[
            i.Name,
            i.SlippageX,
            i.SlippageY,
            i.SlippageZ
        ],
    723233188: (_)=>[],
    2485662743: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            {
                type: 3,
                value: i.IsAttenuating.value
            },
            i.SoundScale,
            i.SoundValues
        ],
    1202362311: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.SoundLevelTimeSeries,
            i.Frequency,
            (i.SoundLevelSingleValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.SoundLevelSingleValue)
        ],
    390701378: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableValueRatio,
            i.ThermalLoadSource,
            i.PropertySource,
            i.SourceDescription,
            i.MaximumValue,
            i.MinimumValue,
            i.ThermalLoadTimeSeriesValues,
            i.UserDefinedThermalLoadSource,
            i.UserDefinedPropertySource,
            i.ThermalLoadType
        ],
    1595516126: (i)=>[
            i.Name,
            i.LinearForceX,
            i.LinearForceY,
            i.LinearForceZ,
            i.LinearMomentX,
            i.LinearMomentY,
            i.LinearMomentZ
        ],
    2668620305: (i)=>[
            i.Name,
            i.PlanarForceX,
            i.PlanarForceY,
            i.PlanarForceZ
        ],
    2473145415: (i)=>[
            i.Name,
            i.DisplacementX,
            i.DisplacementY,
            i.DisplacementZ,
            i.RotationalDisplacementRX,
            i.RotationalDisplacementRY,
            i.RotationalDisplacementRZ
        ],
    1973038258: (i)=>[
            i.Name,
            i.DisplacementX,
            i.DisplacementY,
            i.DisplacementZ,
            i.RotationalDisplacementRX,
            i.RotationalDisplacementRY,
            i.RotationalDisplacementRZ,
            i.Distortion
        ],
    1597423693: (i)=>[
            i.Name,
            i.ForceX,
            i.ForceY,
            i.ForceZ,
            i.MomentX,
            i.MomentY,
            i.MomentZ
        ],
    1190533807: (i)=>[
            i.Name,
            i.ForceX,
            i.ForceY,
            i.ForceZ,
            i.MomentX,
            i.MomentY,
            i.MomentZ,
            i.WarpingMoment
        ],
    3843319758: (i)=>[
            i.ProfileName,
            i.ProfileDefinition,
            i.PhysicalWeight,
            i.Perimeter,
            i.MinimumPlateThickness,
            i.MaximumPlateThickness,
            i.CrossSectionArea,
            i.TorsionalConstantX,
            i.MomentOfInertiaYZ,
            i.MomentOfInertiaY,
            i.MomentOfInertiaZ,
            i.WarpingConstant,
            i.ShearCentreZ,
            i.ShearCentreY,
            i.ShearDeformationAreaZ,
            i.ShearDeformationAreaY,
            i.MaximumSectionModulusY,
            i.MinimumSectionModulusY,
            i.MaximumSectionModulusZ,
            i.MinimumSectionModulusZ,
            i.TorsionalSectionModulus,
            i.CentreOfGravityInX,
            i.CentreOfGravityInY
        ],
    3653947884: (i)=>[
            i.ProfileName,
            i.ProfileDefinition,
            i.PhysicalWeight,
            i.Perimeter,
            i.MinimumPlateThickness,
            i.MaximumPlateThickness,
            i.CrossSectionArea,
            i.TorsionalConstantX,
            i.MomentOfInertiaYZ,
            i.MomentOfInertiaY,
            i.MomentOfInertiaZ,
            i.WarpingConstant,
            i.ShearCentreZ,
            i.ShearCentreY,
            i.ShearDeformationAreaZ,
            i.ShearDeformationAreaY,
            i.MaximumSectionModulusY,
            i.MinimumSectionModulusY,
            i.MaximumSectionModulusZ,
            i.MinimumSectionModulusZ,
            i.TorsionalSectionModulus,
            i.CentreOfGravityInX,
            i.CentreOfGravityInY,
            i.ShearAreaZ,
            i.ShearAreaY,
            i.PlasticShapeFactorY,
            i.PlasticShapeFactorZ
        ],
    2233826070: (i)=>[
            i.EdgeStart,
            i.EdgeEnd,
            i.ParentEdge
        ],
    2513912981: (_)=>[],
    1878645084: (i)=>[
            i.SurfaceColour,
            i.Transparency,
            $3b8da494b8e92f36$var$Labelise(i.DiffuseColour),
            $3b8da494b8e92f36$var$Labelise(i.TransmissionColour),
            $3b8da494b8e92f36$var$Labelise(i.DiffuseTransmissionColour),
            $3b8da494b8e92f36$var$Labelise(i.ReflectionColour),
            $3b8da494b8e92f36$var$Labelise(i.SpecularColour),
            (i.SpecularHighlight ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.SpecularHighlight),
            i.ReflectanceMethod
        ],
    2247615214: (i)=>[
            i.SweptArea,
            i.Position
        ],
    1260650574: (i)=>[
            i.Directrix,
            i.Radius,
            i.InnerRadius,
            i.StartParam,
            i.EndParam
        ],
    230924584: (i)=>[
            i.SweptCurve,
            i.Position
        ],
    3071757647: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.FlangeWidth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.FlangeEdgeRadius,
            i.WebEdgeRadius,
            i.WebSlope,
            i.FlangeSlope,
            i.CentreOfGravityInY
        ],
    3028897424: (i)=>[
            i.Item,
            i.Styles,
            i.Name,
            i.AnnotatedCurve
        ],
    4282788508: (i)=>[
            i.Literal,
            $3b8da494b8e92f36$var$Labelise(i.Placement),
            i.Path
        ],
    3124975700: (i)=>[
            i.Literal,
            $3b8da494b8e92f36$var$Labelise(i.Placement),
            i.Path,
            i.Extent,
            i.BoxAlignment
        ],
    2715220739: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.BottomXDim,
            i.TopXDim,
            i.YDim,
            i.TopXOffset
        ],
    1345879162: (i)=>[
            i.RepeatFactor,
            i.SecondRepeatFactor
        ],
    1628702193: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets
        ],
    2347495698: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag
        ],
    427810014: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.FlangeWidth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.EdgeRadius,
            i.FlangeSlope,
            i.CentreOfGravityInX
        ],
    1417489154: (i)=>[
            i.Orientation,
            i.Magnitude
        ],
    2759199220: (i)=>[
            i.LoopVertex
        ],
    336235671: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.LiningDepth,
            i.LiningThickness,
            i.TransomThickness,
            i.MullionThickness,
            i.FirstTransomOffset,
            i.SecondTransomOffset,
            i.FirstMullionOffset,
            i.SecondMullionOffset,
            i.ShapeAspectStyle
        ],
    512836454: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.OperationType,
            i.PanelPosition,
            i.FrameDepth,
            i.FrameThickness,
            i.ShapeAspectStyle
        ],
    1299126871: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ConstructionType,
            i.OperationType,
            i.ParameterTakesPrecedence,
            i.Sizeable
        ],
    2543172580: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.FlangeWidth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.EdgeRadius
        ],
    3288037868: (i)=>[
            i.Item,
            i.Styles,
            i.Name
        ],
    669184980: (i)=>[
            i.OuterBoundary,
            i.InnerBoundaries
        ],
    2265737646: (i)=>[
            i.Item,
            i.Styles,
            i.Name,
            i.FillStyleTarget,
            i.GlobalOrLocal
        ],
    1302238472: (i)=>[
            i.Item,
            i.TextureCoordinates
        ],
    4261334040: (i)=>[
            i.Location,
            i.Axis
        ],
    3125803723: (i)=>[
            i.Location,
            i.RefDirection
        ],
    2740243338: (i)=>[
            i.Location,
            i.Axis,
            i.RefDirection
        ],
    2736907675: (i)=>[
            i.Operator,
            $3b8da494b8e92f36$var$Labelise(i.FirstOperand),
            $3b8da494b8e92f36$var$Labelise(i.SecondOperand)
        ],
    4182860854: (_)=>[],
    2581212453: (i)=>[
            i.Corner,
            i.XDim,
            i.YDim,
            i.ZDim
        ],
    2713105998: (i)=>[
            i.BaseSurface,
            i.AgreementFlag,
            i.Enclosure
        ],
    2898889636: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.Width,
            i.WallThickness,
            i.Girth,
            i.InternalFilletRadius,
            i.CentreOfGravityInX
        ],
    1123145078: (i)=>[
            i.Coordinates
        ],
    59481748: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale
        ],
    3749851601: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale
        ],
    3486308946: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale,
            i.Scale2
        ],
    3331915920: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale,
            i.Axis3
        ],
    1416205885: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale,
            i.Axis3,
            i.Scale2,
            i.Scale3
        ],
    1383045692: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Radius
        ],
    2205249479: (i)=>[
            i.CfsFaces
        ],
    2485617015: (i)=>[
            i.Transition,
            i.SameSense,
            i.ParentCurve
        ],
    4133800736: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.OverallHeight,
            i.BaseWidth2,
            i.Radius,
            i.HeadWidth,
            i.HeadDepth2,
            i.HeadDepth3,
            i.WebThickness,
            i.BaseWidth4,
            i.BaseDepth1,
            i.BaseDepth2,
            i.BaseDepth3,
            i.CentreOfGravityInY
        ],
    194851669: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.OverallHeight,
            i.HeadWidth,
            i.Radius,
            i.HeadDepth2,
            i.HeadDepth3,
            i.WebThickness,
            i.BaseDepth1,
            i.BaseDepth2,
            i.CentreOfGravityInY
        ],
    2506170314: (i)=>[
            i.Position
        ],
    2147822146: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.TreeRootExpression)
        ],
    2601014836: (_)=>[],
    2827736869: (i)=>[
            i.BasisSurface,
            i.OuterBoundary,
            i.InnerBoundaries
        ],
    693772133: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Definition),
            i.Target
        ],
    606661476: (i)=>[
            i.Item,
            i.Styles,
            i.Name
        ],
    4054601972: (i)=>[
            i.Item,
            i.Styles,
            i.Name,
            i.AnnotatedCurve,
            i.Role
        ],
    32440307: (i)=>[
            i.DirectionRatios
        ],
    2963535650: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.LiningDepth,
            i.LiningThickness,
            i.ThresholdDepth,
            i.ThresholdThickness,
            i.TransomThickness,
            i.TransomOffset,
            i.LiningOffset,
            i.ThresholdOffset,
            i.CasingThickness,
            i.CasingDepth,
            i.ShapeAspectStyle
        ],
    1714330368: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.PanelDepth,
            i.PanelOperation,
            i.PanelWidth,
            i.PanelPosition,
            i.ShapeAspectStyle
        ],
    526551008: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.OperationType,
            i.ConstructionType,
            i.ParameterTakesPrecedence,
            i.Sizeable
        ],
    3073041342: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Contents)
        ],
    445594917: (i)=>[
            i.Name
        ],
    4006246654: (i)=>[
            i.Name
        ],
    1472233963: (i)=>[
            i.EdgeList
        ],
    1883228015: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.MethodOfMeasurement,
            i.Quantities
        ],
    339256511: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2777663545: (i)=>[
            i.Position
        ],
    2835456948: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.SemiAxis1,
            i.SemiAxis2
        ],
    80994333: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.EnergySequence,
            i.UserDefinedEnergySequence
        ],
    477187591: (i)=>[
            i.SweptArea,
            i.Position,
            i.ExtrudedDirection,
            i.Depth
        ],
    2047409740: (i)=>[
            i.FbsmFaces
        ],
    374418227: (i)=>[
            i.HatchLineAppearance,
            $3b8da494b8e92f36$var$Labelise(i.StartOfNextHatchLine),
            i.PointOfReferenceHatchLine,
            i.PatternStart,
            i.HatchLineAngle
        ],
    4203026998: (i)=>[
            i.Symbol
        ],
    315944413: (i)=>[
            i.TilingPattern,
            $3b8da494b8e92f36$var$Labelise(i.Tiles),
            i.TilingScale
        ],
    3455213021: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.PropertySource,
            i.FlowConditionTimeSeries,
            i.VelocityTimeSeries,
            i.FlowrateTimeSeries,
            i.Fluid,
            i.PressureTimeSeries,
            i.UserDefinedPropertySource,
            i.TemperatureSingleValue,
            i.WetBulbTemperatureSingleValue,
            i.WetBulbTemperatureTimeSeries,
            i.TemperatureTimeSeries,
            (i.FlowrateSingleValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.FlowrateSingleValue),
            i.FlowConditionSingleValue,
            i.VelocitySingleValue,
            i.PressureSingleValue
        ],
    4238390223: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1268542332: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.AssemblyPlace
        ],
    987898635: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Elements)
        ],
    1484403080: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.OverallWidth,
            i.OverallDepth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius
        ],
    572779678: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.Width,
            i.Thickness,
            i.FilletRadius,
            i.EdgeRadius,
            i.LegSlope,
            i.CentreOfGravityInX,
            i.CentreOfGravityInY
        ],
    1281925730: (i)=>[
            i.Pnt,
            i.Dir
        ],
    1425443689: (i)=>[
            i.Outer
        ],
    3888040117: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    3388369263: (i)=>[
            i.BasisCurve,
            i.Distance,
            i.SelfIntersect
        ],
    3505215534: (i)=>[
            i.BasisCurve,
            i.Distance,
            i.SelfIntersect,
            i.RefDirection
        ],
    3566463478: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.OperationType,
            i.PanelPosition,
            i.FrameDepth,
            i.FrameThickness,
            i.ShapeAspectStyle
        ],
    603570806: (i)=>[
            i.SizeInX,
            i.SizeInY,
            $3b8da494b8e92f36$var$Labelise(i.Placement)
        ],
    220341763: (i)=>[
            i.Position
        ],
    2945172077: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    4208778838: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    103090709: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.Phase,
            i.RepresentationContexts,
            i.UnitsInContext
        ],
    4194566429: (i)=>[
            i.Item,
            i.Styles,
            i.Name
        ],
    1451395588: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.HasProperties
        ],
    3219374653: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.ProxyType,
            i.Tag
        ],
    2770003689: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.XDim,
            i.YDim,
            i.WallThickness,
            i.InnerFilletRadius,
            i.OuterFilletRadius
        ],
    2798486643: (i)=>[
            i.Position,
            i.XLength,
            i.YLength,
            i.Height
        ],
    3454111270: (i)=>[
            i.BasisSurface,
            i.U1,
            i.V1,
            i.U2,
            i.V2,
            i.Usense,
            i.Vsense
        ],
    3939117080: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType
        ],
    1683148259: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingActor,
            i.ActingRole
        ],
    2495723537: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingControl
        ],
    1307041759: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingGroup
        ],
    4278684876: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingProcess,
            i.QuantityInProcess
        ],
    2857406711: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingProduct
        ],
    3372526763: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingControl
        ],
    205026976: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingResource
        ],
    1865459582: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects
        ],
    1327628568: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingAppliedValue
        ],
    4095574036: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingApproval
        ],
    919958153: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            $3b8da494b8e92f36$var$Labelise(i.RelatingClassification)
        ],
    2728634034: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.Intent,
            i.RelatingConstraint
        ],
    982818633: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            $3b8da494b8e92f36$var$Labelise(i.RelatingDocument)
        ],
    3840914261: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            $3b8da494b8e92f36$var$Labelise(i.RelatingLibrary)
        ],
    2655215786: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            $3b8da494b8e92f36$var$Labelise(i.RelatingMaterial)
        ],
    2851387026: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingProfileProperties,
            i.ProfileSectionLocation,
            $3b8da494b8e92f36$var$Labelise(i.ProfileOrientation)
        ],
    826625072: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    1204542856: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ConnectionGeometry,
            i.RelatingElement,
            i.RelatedElement
        ],
    3945020480: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ConnectionGeometry,
            i.RelatingElement,
            i.RelatedElement,
            i.RelatingPriorities,
            i.RelatedPriorities,
            i.RelatedConnectionType,
            i.RelatingConnectionType
        ],
    4201705270: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingPort,
            i.RelatedElement
        ],
    3190031847: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingPort,
            i.RelatedPort,
            i.RealizingElement
        ],
    2127690289: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingElement),
            i.RelatedStructuralActivity
        ],
    3912681535: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingElement,
            i.RelatedStructuralMember
        ],
    1638771189: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingStructuralMember,
            i.RelatedStructuralConnection,
            i.AppliedCondition,
            i.AdditionalConditions,
            i.SupportedLength,
            i.ConditionCoordinateSystem
        ],
    504942748: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingStructuralMember,
            i.RelatedStructuralConnection,
            i.AppliedCondition,
            i.AdditionalConditions,
            i.SupportedLength,
            i.ConditionCoordinateSystem,
            i.ConnectionConstraint
        ],
    3678494232: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ConnectionGeometry,
            i.RelatingElement,
            i.RelatedElement,
            i.RealizingElements,
            i.ConnectionType
        ],
    3242617779: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedElements,
            i.RelatingStructure
        ],
    886880790: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingBuildingElement,
            i.RelatedCoverings
        ],
    2802773753: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedSpace,
            i.RelatedCoverings
        ],
    2551354335: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingObject,
            i.RelatedObjects
        ],
    693640335: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects
        ],
    4186316022: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingPropertyDefinition
        ],
    781010003: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingType
        ],
    3940055652: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingOpeningElement,
            i.RelatedBuildingElement
        ],
    279856033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedControlElements,
            i.RelatingFlowElement
        ],
    4189434867: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.DailyInteraction,
            i.ImportanceRating,
            i.LocationOfInteraction,
            i.RelatedSpaceProgram,
            i.RelatingSpaceProgram
        ],
    3268803585: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingObject,
            i.RelatedObjects
        ],
    2051452291: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingActor,
            i.ActingRole
        ],
    202636808: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingPropertyDefinition,
            i.OverridingProperties
        ],
    750771296: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingElement,
            i.RelatedFeatureElement
        ],
    1245217292: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedElements,
            i.RelatingStructure
        ],
    1058617721: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingControl
        ],
    4122056220: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingProcess,
            i.RelatedProcess,
            i.TimeLag,
            i.SequenceType
        ],
    366585022: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingSystem,
            i.RelatedBuildings
        ],
    3451746338: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingSpace,
            i.RelatedBuildingElement,
            i.ConnectionGeometry,
            i.PhysicalOrVirtualBoundary,
            i.InternalOrExternalBoundary
        ],
    1401173127: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingBuildingElement,
            i.RelatedOpeningElement
        ],
    2914609552: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    1856042241: (i)=>[
            i.SweptArea,
            i.Position,
            i.Axis,
            i.Angle
        ],
    4158566097: (i)=>[
            i.Position,
            i.Height,
            i.BottomRadius
        ],
    3626867408: (i)=>[
            i.Position,
            i.Height,
            i.Radius
        ],
    2706606064: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType
        ],
    3893378262: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    451544542: (i)=>[
            i.Position,
            i.Radius
        ],
    3544373492: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal
        ],
    3136571912: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    530289379: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    3689010777: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal
        ],
    3979015343: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Thickness
        ],
    2218152070: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Thickness,
            i.SubsequentThickness,
            i.VaryingThicknessLocation
        ],
    4070609034: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Contents)
        ],
    2028607225: (i)=>[
            i.SweptArea,
            i.Position,
            i.Directrix,
            i.StartParam,
            i.EndParam,
            i.ReferenceSurface
        ],
    2809605785: (i)=>[
            i.SweptCurve,
            i.Position,
            i.ExtrudedDirection,
            i.Depth
        ],
    4124788165: (i)=>[
            i.SweptCurve,
            i.Position,
            i.AxisPosition
        ],
    1580310250: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3473067441: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.TaskId,
            i.Status,
            i.WorkMethod,
            i.IsMilestone,
            i.Priority
        ],
    2097647324: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2296667514: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.TheActor)
        ],
    1674181508: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    3207858831: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.OverallWidth,
            i.OverallDepth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.TopFlangeWidth,
            i.TopFlangeThickness,
            i.TopFlangeFilletRadius,
            i.CentreOfGravityInY
        ],
    1334484129: (i)=>[
            i.Position,
            i.XLength,
            i.YLength,
            i.ZLength
        ],
    3649129432: (i)=>[
            i.Operator,
            $3b8da494b8e92f36$var$Labelise(i.FirstOperand),
            $3b8da494b8e92f36$var$Labelise(i.SecondOperand)
        ],
    1260505505: (_)=>[],
    4031249490: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.ElevationOfRefHeight,
            i.ElevationOfTerrain,
            i.BuildingAddress
        ],
    1950629157: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3124254112: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.Elevation
        ],
    2937912522: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Radius,
            i.WallThickness
        ],
    300633059: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3732776249: (i)=>[
            i.Segments,
            i.SelfIntersect
        ],
    2510884976: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position)
        ],
    2559216714: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ResourceIdentifier,
            i.ResourceGroup,
            i.ResourceConsumption,
            i.BaseQuantity
        ],
    3293443760: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    3895139033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    1419761937: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.SubmittedBy),
            $3b8da494b8e92f36$var$Labelise(i.PreparedBy),
            $3b8da494b8e92f36$var$Labelise(i.SubmittedOn),
            i.Status,
            $3b8da494b8e92f36$var$Labelise(i.TargetUsers),
            $3b8da494b8e92f36$var$Labelise(i.UpdateDate),
            i.ID,
            i.PredefinedType
        ],
    1916426348: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3295246426: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ResourceIdentifier,
            i.ResourceGroup,
            i.ResourceConsumption,
            i.BaseQuantity
        ],
    1457835157: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    681481545: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Contents)
        ],
    3256556792: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3849074793: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    360485395: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.EnergySequence,
            i.UserDefinedEnergySequence,
            i.ElectricCurrentType,
            i.InputVoltage,
            i.InputFrequency,
            i.FullLoadCurrent,
            i.MinimumCircuitCurrent,
            i.MaximumPowerInput,
            i.RatedPowerInput,
            i.InputPhase
        ],
    1758889154: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    4123344466: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.AssemblyPlace,
            i.PredefinedType
        ],
    1623761950: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2590856083: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1704287377: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.SemiAxis1,
            i.SemiAxis2
        ],
    2107101300: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1962604670: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3272907226: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    3174744832: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3390157468: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    807026263: (i)=>[
            i.Outer
        ],
    3737207727: (i)=>[
            i.Outer,
            i.Voids
        ],
    647756555: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2489546625: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2827207264: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2143335405: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1287392070: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3907093117: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3198132628: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3815607619: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1482959167: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1834744321: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1339347760: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2297155007: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3009222698: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    263784265: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    814719939: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    200128114: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3009204131: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.UAxes,
            i.VAxes,
            i.WAxes
        ],
    2706460486: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    1251058090: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1806887404: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2391368822: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.InventoryType,
            $3b8da494b8e92f36$var$Labelise(i.Jurisdiction),
            i.ResponsiblePersons,
            i.LastUpdateDate,
            i.CurrentValue,
            i.OriginalValue
        ],
    4288270099: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3827777499: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ResourceIdentifier,
            i.ResourceGroup,
            i.ResourceConsumption,
            i.BaseQuantity,
            i.SkillSet
        ],
    1051575348: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1161773419: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2506943328: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Contents)
        ],
    377706215: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.NominalDiameter,
            i.NominalLength
        ],
    2108223431: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3181161470: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    977012517: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1916936684: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.TaskId,
            i.Status,
            i.WorkMethod,
            i.IsMilestone,
            i.Priority,
            i.MoveFrom,
            i.MoveTo,
            i.PunchList
        ],
    4143007308: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.TheActor),
            i.PredefinedType
        ],
    3588315303: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3425660407: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.TaskId,
            i.Status,
            i.WorkMethod,
            i.IsMilestone,
            i.Priority,
            i.ActionID
        ],
    2837617999: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2382730787: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LifeCyclePhase
        ],
    3327091369: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PermitID
        ],
    804291784: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4231323485: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4017108033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3724593414: (i)=>[
            i.Points
        ],
    3740093272: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    2744685151: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ProcedureID,
            i.ProcedureType,
            i.UserDefinedProcedureType
        ],
    2904328755: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ID,
            i.PredefinedType,
            i.Status
        ],
    3642467123: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Records,
            i.PredefinedType
        ],
    3651124850: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1842657554: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2250791053: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3248260540: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Contents)
        ],
    2893384427: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2324767716: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    160246688: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingObject,
            i.RelatedObjects
        ],
    2863920197: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingControl,
            i.TimeForTask
        ],
    1768891740: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3517283431: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.ActualStart),
            $3b8da494b8e92f36$var$Labelise(i.EarlyStart),
            $3b8da494b8e92f36$var$Labelise(i.LateStart),
            $3b8da494b8e92f36$var$Labelise(i.ScheduleStart),
            $3b8da494b8e92f36$var$Labelise(i.ActualFinish),
            $3b8da494b8e92f36$var$Labelise(i.EarlyFinish),
            $3b8da494b8e92f36$var$Labelise(i.LateFinish),
            $3b8da494b8e92f36$var$Labelise(i.ScheduleFinish),
            i.ScheduleDuration,
            i.ActualDuration,
            i.RemainingTime,
            i.FreeFloat,
            i.TotalFloat,
            i.IsCritical,
            $3b8da494b8e92f36$var$Labelise(i.StatusTime),
            i.StartFloat,
            i.FinishFloat,
            i.Completion
        ],
    4105383287: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ServiceLifeType,
            i.ServiceLifeDuration
        ],
    4097777520: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.RefLatitude,
            i.RefLongitude,
            i.RefElevation,
            i.LandTitleNumber,
            i.SiteAddress
        ],
    2533589738: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3856911033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.InteriorOrExteriorSpace,
            i.ElevationWithFlooring
        ],
    1305183839: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    652456506: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.SpaceProgramIdentifier,
            i.MaxRequiredArea,
            i.MinRequiredArea,
            i.RequestedLocation,
            i.StandardRequiredArea
        ],
    3812236995: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3112655638: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1039846685: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    682877961: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad,
            i.CausedBy
        ],
    1179482911: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition
        ],
    4243806635: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition
        ],
    214636428: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType
        ],
    2445595289: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType
        ],
    1807405624: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad,
            i.CausedBy,
            i.ProjectedOrTrue
        ],
    1721250024: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad,
            i.CausedBy,
            i.ProjectedOrTrue,
            i.VaryingAppliedLoadLocation,
            i.SubsequentAppliedLoads
        ],
    1252848954: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.ActionType,
            i.ActionSource,
            i.Coefficient,
            i.Purpose
        ],
    1621171031: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad,
            i.CausedBy,
            i.ProjectedOrTrue
        ],
    3987759626: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad,
            i.CausedBy,
            i.ProjectedOrTrue,
            i.VaryingAppliedLoadLocation,
            i.SubsequentAppliedLoads
        ],
    2082059205: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad,
            i.CausedBy
        ],
    734778138: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition
        ],
    1235345126: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal
        ],
    2986769608: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.TheoryType,
            i.ResultForLoadGroup,
            i.IsLinear
        ],
    1975003073: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition
        ],
    148013059: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ResourceIdentifier,
            i.ResourceGroup,
            i.ResourceConsumption,
            i.BaseQuantity,
            $3b8da494b8e92f36$var$Labelise(i.SubContractor),
            i.JobDescription
        ],
    2315554128: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2254336722: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    5716631: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1637806684: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.ApplicableDates),
            i.TimeSeriesScheduleType,
            i.TimeSeries
        ],
    1692211062: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1620046519: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.OperationType,
            i.CapacityByWeight,
            i.CapacityByNumber
        ],
    3593883385: (i)=>[
            i.BasisCurve,
            $3b8da494b8e92f36$var$Labelise(i.Trim1),
            $3b8da494b8e92f36$var$Labelise(i.Trim2),
            i.SenseAgreement,
            i.MasterRepresentation
        ],
    1600972822: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1911125066: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    728799441: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2769231204: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1898987631: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1133259667: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1028945134: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identifier,
            $3b8da494b8e92f36$var$Labelise(i.CreationDate),
            i.Creators,
            i.Purpose,
            i.Duration,
            i.TotalFloat,
            $3b8da494b8e92f36$var$Labelise(i.StartTime),
            $3b8da494b8e92f36$var$Labelise(i.FinishTime),
            i.WorkControlType,
            i.UserDefinedControlType
        ],
    4218914973: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identifier,
            $3b8da494b8e92f36$var$Labelise(i.CreationDate),
            i.Creators,
            i.Purpose,
            i.Duration,
            i.TotalFloat,
            $3b8da494b8e92f36$var$Labelise(i.StartTime),
            $3b8da494b8e92f36$var$Labelise(i.FinishTime),
            i.WorkControlType,
            i.UserDefinedControlType
        ],
    3342526732: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identifier,
            $3b8da494b8e92f36$var$Labelise(i.CreationDate),
            i.Creators,
            i.Purpose,
            i.Duration,
            i.TotalFloat,
            $3b8da494b8e92f36$var$Labelise(i.StartTime),
            $3b8da494b8e92f36$var$Labelise(i.FinishTime),
            i.WorkControlType,
            i.UserDefinedControlType
        ],
    1033361043: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    1213861670: (i)=>[
            i.Segments,
            i.SelfIntersect
        ],
    3821786052: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.RequestID
        ],
    1411407467: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3352864051: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1871374353: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2470393545: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Contents)
        ],
    3460190687: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.AssetID,
            i.OriginalValue,
            i.CurrentValue,
            i.TotalReplacementCost,
            $3b8da494b8e92f36$var$Labelise(i.Owner),
            $3b8da494b8e92f36$var$Labelise(i.User),
            i.ResponsiblePerson,
            i.IncorporationDate,
            i.DepreciatedValue
        ],
    1967976161: (i)=>[
            i.Degree,
            i.ControlPointsList,
            i.CurveForm,
            i.ClosedCurve,
            i.SelfIntersect
        ],
    819618141: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1916977116: (i)=>[
            i.Degree,
            i.ControlPointsList,
            i.CurveForm,
            i.ClosedCurve,
            i.SelfIntersect
        ],
    231477066: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3299480353: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    52481810: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2979338954: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1095909175: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.CompositionType
        ],
    1909888760: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    395041908: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3293546465: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1285652485: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2951183804: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2611217952: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.Radius
        ],
    2301859152: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    843113511: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3850581409: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2816379211: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2188551683: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    1163958913: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.Criterion),
            $3b8da494b8e92f36$var$Labelise(i.CriterionDateTime)
        ],
    3898045240: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ResourceIdentifier,
            i.ResourceGroup,
            i.ResourceConsumption,
            i.BaseQuantity
        ],
    1060000209: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ResourceIdentifier,
            i.ResourceGroup,
            i.ResourceConsumption,
            i.BaseQuantity,
            $3b8da494b8e92f36$var$Labelise(i.Suppliers),
            i.UsageRatio
        ],
    488727124: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ResourceIdentifier,
            i.ResourceGroup,
            i.ResourceConsumption,
            i.BaseQuantity
        ],
    335055490: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2954562838: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1973544240: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3495092785: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3961806047: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4147604152: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Contents)
        ],
    1335981549: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2635815018: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1599208980: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2063403501: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1945004755: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3040386961: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3041715199: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.FlowDirection
        ],
    395920057: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.OverallHeight,
            i.OverallWidth
        ],
    869906466: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3760055223: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2030761528: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    855621170: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.FeatureLength
        ],
    663422040: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3277789161: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1534661035: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1365060375: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1217240411: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    712377611: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1634875225: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    857184966: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1658829314: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    346874300: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1810631287: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4222183408: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2058353004: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    4278956645: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    4037862832: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3132237377: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    987401354: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    707683696: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2223149337: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3508470533: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    900683007: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1073191201: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1687234759: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType,
            i.ConstructionType
        ],
    3171933400: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2262370178: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3024970846: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.ShapeType
        ],
    3283111854: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3055160366: (i)=>[
            i.Degree,
            i.ControlPointsList,
            i.CurveForm,
            i.ClosedCurve,
            i.SelfIntersect,
            i.WeightsData
        ],
    3027567501: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade
        ],
    2320036040: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.MeshLength,
            i.MeshWidth,
            i.LongitudinalBarNominalDiameter,
            i.TransverseBarNominalDiameter,
            i.LongitudinalBarCrossSectionArea,
            i.TransverseBarCrossSectionArea,
            i.LongitudinalBarSpacing,
            i.TransverseBarSpacing
        ],
    2016517767: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.ShapeType
        ],
    1376911519: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.FeatureLength,
            i.Radius
        ],
    1783015770: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1529196076: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    331165859: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.ShapeType
        ],
    4252922144: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.NumberOfRiser,
            i.NumberOfTreads,
            i.RiserHeight,
            i.TreadLength
        ],
    2515109513: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.OrientationOf2DPlane,
            i.LoadedBy,
            i.HasResults
        ],
    3824725483: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.PredefinedType,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.TensionForce,
            i.PreStress,
            i.FrictionCoefficient,
            i.AnchorageSlip,
            i.MinCurvatureRadius
        ],
    2347447852: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade
        ],
    3313531582: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2391406946: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3512223829: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3304561284: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.OverallHeight,
            i.OverallWidth
        ],
    2874132201: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3001207471: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    753842376: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2454782716: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.FeatureLength,
            i.Width,
            i.Height
        ],
    578613899: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1052013943: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1062813311: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.ControlElementId
        ],
    3700593921: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.DistributionPointFunction,
            i.UserDefinedFunction
        ],
    979691226: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.BarLength,
            i.BarRole,
            i.BarSurface
        ]
};
$3b8da494b8e92f36$export$9d063d2e6222d3e2[1] = {
    3699917729: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAbsorbedDoseMeasure(v),
    4182062534: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAccelerationMeasure(v),
    360377573: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAmountOfSubstanceMeasure(v),
    632304761: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAngularVelocityMeasure(v),
    2650437152: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcAreaMeasure(v),
    2735952531: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoolean(v),
    1867003952: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcBoxAlignment(v),
    2991860651: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcComplexNumber(v.map((x)=>x.value)),
    3812528620: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCompoundPlaneAngleMeasure(v.map((x)=>x.value)),
    3238673880: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcContextDependentMeasure(v),
    1778710042: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCountMeasure(v),
    94842927: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcCurvatureMeasure(v),
    86635668: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDayInMonthNumber(v),
    300323983: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDaylightSavingHour(v),
    1514641115: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDescriptiveMeasure(v),
    4134073009: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDimensionCount(v),
    524656162: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDoseEquivalentMeasure(v),
    69416015: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcDynamicViscosityMeasure(v),
    1827137117: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricCapacitanceMeasure(v),
    3818826038: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricChargeMeasure(v),
    2093906313: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricConductanceMeasure(v),
    3790457270: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricCurrentMeasure(v),
    2951915441: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricResistanceMeasure(v),
    2506197118: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcElectricVoltageMeasure(v),
    2078135608: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcEnergyMeasure(v),
    1102727119: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFontStyle(v),
    2715512545: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFontVariant(v),
    2590844177: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFontWeight(v),
    1361398929: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcForceMeasure(v),
    3044325142: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcFrequencyMeasure(v),
    3064340077: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcGloballyUniqueId(v),
    3113092358: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHeatFluxDensityMeasure(v),
    1158859006: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHeatingValueMeasure(v),
    2589826445: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcHourInDay(v),
    983778844: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIdentifier(v),
    3358199106: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIlluminanceMeasure(v),
    2679005408: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcInductanceMeasure(v),
    1939436016: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcInteger(v),
    3809634241: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIntegerCountRateMeasure(v),
    3686016028: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIonConcentrationMeasure(v),
    3192672207: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcIsothermalMoistureCapacityMeasure(v),
    2054016361: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcKinematicViscosityMeasure(v),
    3258342251: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLabel(v),
    1243674935: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLengthMeasure(v),
    191860431: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearForceMeasure(v),
    2128979029: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearMomentMeasure(v),
    1307019551: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearStiffnessMeasure(v),
    3086160713: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLinearVelocityMeasure(v),
    503418787: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLogical(v),
    2095003142: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLuminousFluxMeasure(v),
    2755797622: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLuminousIntensityDistributionMeasure(v),
    151039812: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcLuminousIntensityMeasure(v),
    286949696: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMagneticFluxDensityMeasure(v),
    2486716878: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMagneticFluxMeasure(v),
    1477762836: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassDensityMeasure(v),
    4017473158: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassFlowRateMeasure(v),
    3124614049: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassMeasure(v),
    3531705166: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMassPerLengthMeasure(v),
    102610177: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMinuteInHour(v),
    3341486342: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfElasticityMeasure(v),
    2173214787: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfLinearSubgradeReactionMeasure(v),
    1052454078: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfRotationalSubgradeReactionMeasure(v),
    1753493141: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcModulusOfSubgradeReactionMeasure(v),
    3177669450: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMoistureDiffusivityMeasure(v),
    1648970520: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMolecularWeightMeasure(v),
    3114022597: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMomentOfInertiaMeasure(v),
    2615040989: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMonetaryMeasure(v),
    765770214: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcMonthInYearNumber(v),
    2095195183: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNormalisedRatioMeasure(v),
    2395907400: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcNumericMeasure(v),
    929793134: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPHMeasure(v),
    2260317790: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcParameterValue(v),
    2642773653: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlanarForceMeasure(v),
    4042175685: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPlaneAngleMeasure(v),
    2815919920: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveLengthMeasure(v),
    3054510233: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositivePlaneAngleMeasure(v),
    1245737093: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPositiveRatioMeasure(v),
    1364037233: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPowerMeasure(v),
    2169031380: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPresentableText(v),
    3665567075: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcPressureMeasure(v),
    3972513137: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRadioActivityMeasure(v),
    96294661: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRatioMeasure(v),
    200335297: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcReal(v),
    2133746277: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRotationalFrequencyMeasure(v),
    1755127002: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRotationalMassMeasure(v),
    3211557302: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcRotationalStiffnessMeasure(v),
    2766185779: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSecondInMinute(v),
    3467162246: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionModulusMeasure(v),
    2190458107: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSectionalAreaIntegralMeasure(v),
    408310005: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcShearModulusMeasure(v),
    3471399674: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSolidAngleMeasure(v),
    846465480: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSoundPowerMeasure(v),
    993287707: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSoundPressureMeasure(v),
    3477203348: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpecificHeatCapacityMeasure(v),
    2757832317: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpecularExponent(v),
    361837227: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcSpecularRoughness(v),
    58845555: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTemperatureGradientMeasure(v),
    2801250643: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcText(v),
    1460886941: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextAlignment(v),
    3490877962: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextDecoration(v),
    603696268: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextFontName(v),
    296282323: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTextTransformation(v),
    232962298: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalAdmittanceMeasure(v),
    2645777649: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalConductivityMeasure(v),
    2281867870: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalExpansionCoefficientMeasure(v),
    857959152: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalResistanceMeasure(v),
    2016195849: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermalTransmittanceMeasure(v),
    743184107: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcThermodynamicTemperatureMeasure(v),
    2726807636: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeMeasure(v),
    2591213694: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTimeStamp(v),
    1278329552: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcTorqueMeasure(v),
    3345633955: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVaporPermeabilityMeasure(v),
    3458127941: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVolumeMeasure(v),
    2593997549: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcVolumetricFlowRateMeasure(v),
    51269191: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWarpingConstantMeasure(v),
    1718600412: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcWarpingMomentMeasure(v),
    4065007721: (v)=>new $3b8da494b8e92f36$export$c9c0ab869345d70a.IfcYearNumber(v)
};
var $3b8da494b8e92f36$export$c9c0ab869345d70a;
((IFC2X32)=>{
    class IfcAbsorbedDoseMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCABSORBEDDOSEMEASURE";
        }
    }
    IFC2X32.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;
    class IfcAccelerationMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCACCELERATIONMEASURE";
        }
    }
    IFC2X32.IfcAccelerationMeasure = IfcAccelerationMeasure;
    class IfcAmountOfSubstanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCAMOUNTOFSUBSTANCEMEASURE";
        }
    }
    IFC2X32.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;
    class IfcAngularVelocityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCANGULARVELOCITYMEASURE";
        }
    }
    IFC2X32.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;
    class IfcAreaMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCAREAMEASURE";
        }
    }
    IFC2X32.IfcAreaMeasure = IfcAreaMeasure;
    class IfcBoolean {
        constructor(v){
            this.type = 3;
            this.name = "IFCBOOLEAN";
            this.value = v;
        }
    }
    IFC2X32.IfcBoolean = IfcBoolean;
    class IfcBoxAlignment {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCBOXALIGNMENT";
        }
    }
    IFC2X32.IfcBoxAlignment = IfcBoxAlignment;
    class IfcComplexNumber {
        constructor(value){
            this.value = value;
            this.type = 4;
        }
    }
    IFC2X32.IfcComplexNumber = IfcComplexNumber;
    class IfcCompoundPlaneAngleMeasure {
        constructor(value){
            this.value = value;
            this.type = 10;
        }
    }
    IFC2X32.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;
    class IfcContextDependentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCCONTEXTDEPENDENTMEASURE";
        }
    }
    IFC2X32.IfcContextDependentMeasure = IfcContextDependentMeasure;
    class IfcCountMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCCOUNTMEASURE";
        }
    }
    IFC2X32.IfcCountMeasure = IfcCountMeasure;
    class IfcCurvatureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCCURVATUREMEASURE";
        }
    }
    IFC2X32.IfcCurvatureMeasure = IfcCurvatureMeasure;
    class IfcDayInMonthNumber extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCDAYINMONTHNUMBER";
        }
    }
    IFC2X32.IfcDayInMonthNumber = IfcDayInMonthNumber;
    class IfcDaylightSavingHour extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCDAYLIGHTSAVINGHOUR";
        }
    }
    IFC2X32.IfcDaylightSavingHour = IfcDaylightSavingHour;
    class IfcDescriptiveMeasure {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCDESCRIPTIVEMEASURE";
        }
    }
    IFC2X32.IfcDescriptiveMeasure = IfcDescriptiveMeasure;
    class IfcDimensionCount extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCDIMENSIONCOUNT";
        }
    }
    IFC2X32.IfcDimensionCount = IfcDimensionCount;
    class IfcDoseEquivalentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCDOSEEQUIVALENTMEASURE";
        }
    }
    IFC2X32.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;
    class IfcDynamicViscosityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCDYNAMICVISCOSITYMEASURE";
        }
    }
    IFC2X32.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;
    class IfcElectricCapacitanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCAPACITANCEMEASURE";
        }
    }
    IFC2X32.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;
    class IfcElectricChargeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCHARGEMEASURE";
        }
    }
    IFC2X32.IfcElectricChargeMeasure = IfcElectricChargeMeasure;
    class IfcElectricConductanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCONDUCTANCEMEASURE";
        }
    }
    IFC2X32.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;
    class IfcElectricCurrentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCURRENTMEASURE";
        }
    }
    IFC2X32.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;
    class IfcElectricResistanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICRESISTANCEMEASURE";
        }
    }
    IFC2X32.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;
    class IfcElectricVoltageMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICVOLTAGEMEASURE";
        }
    }
    IFC2X32.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;
    class IfcEnergyMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCENERGYMEASURE";
        }
    }
    IFC2X32.IfcEnergyMeasure = IfcEnergyMeasure;
    class IfcFontStyle {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCFONTSTYLE";
        }
    }
    IFC2X32.IfcFontStyle = IfcFontStyle;
    class IfcFontVariant {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCFONTVARIANT";
        }
    }
    IFC2X32.IfcFontVariant = IfcFontVariant;
    class IfcFontWeight {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCFONTWEIGHT";
        }
    }
    IFC2X32.IfcFontWeight = IfcFontWeight;
    class IfcForceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCFORCEMEASURE";
        }
    }
    IFC2X32.IfcForceMeasure = IfcForceMeasure;
    class IfcFrequencyMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCFREQUENCYMEASURE";
        }
    }
    IFC2X32.IfcFrequencyMeasure = IfcFrequencyMeasure;
    class IfcGloballyUniqueId {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCGLOBALLYUNIQUEID";
        }
    }
    IFC2X32.IfcGloballyUniqueId = IfcGloballyUniqueId;
    class IfcHeatFluxDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCHEATFLUXDENSITYMEASURE";
        }
    }
    IFC2X32.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;
    class IfcHeatingValueMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCHEATINGVALUEMEASURE";
        }
    }
    IFC2X32.IfcHeatingValueMeasure = IfcHeatingValueMeasure;
    class IfcHourInDay extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCHOURINDAY";
        }
    }
    IFC2X32.IfcHourInDay = IfcHourInDay;
    class IfcIdentifier {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCIDENTIFIER";
        }
    }
    IFC2X32.IfcIdentifier = IfcIdentifier;
    class IfcIlluminanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCILLUMINANCEMEASURE";
        }
    }
    IFC2X32.IfcIlluminanceMeasure = IfcIlluminanceMeasure;
    class IfcInductanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCINDUCTANCEMEASURE";
        }
    }
    IFC2X32.IfcInductanceMeasure = IfcInductanceMeasure;
    class IfcInteger extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCINTEGER";
        }
    }
    IFC2X32.IfcInteger = IfcInteger;
    class IfcIntegerCountRateMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCINTEGERCOUNTRATEMEASURE";
        }
    }
    IFC2X32.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;
    class IfcIonConcentrationMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCIONCONCENTRATIONMEASURE";
        }
    }
    IFC2X32.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;
    class IfcIsothermalMoistureCapacityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCISOTHERMALMOISTURECAPACITYMEASURE";
        }
    }
    IFC2X32.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;
    class IfcKinematicViscosityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCKINEMATICVISCOSITYMEASURE";
        }
    }
    IFC2X32.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;
    class IfcLabel {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCLABEL";
        }
    }
    IFC2X32.IfcLabel = IfcLabel;
    class IfcLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLENGTHMEASURE";
        }
    }
    IFC2X32.IfcLengthMeasure = IfcLengthMeasure;
    class IfcLinearForceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARFORCEMEASURE";
        }
    }
    IFC2X32.IfcLinearForceMeasure = IfcLinearForceMeasure;
    class IfcLinearMomentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARMOMENTMEASURE";
        }
    }
    IFC2X32.IfcLinearMomentMeasure = IfcLinearMomentMeasure;
    class IfcLinearStiffnessMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARSTIFFNESSMEASURE";
        }
    }
    IFC2X32.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;
    class IfcLinearVelocityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARVELOCITYMEASURE";
        }
    }
    IFC2X32.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;
    class IfcLogical {
        constructor(v){
            this.type = 3;
            this.name = "IFCLOGICAL";
            this.value = v;
        }
    }
    IFC2X32.IfcLogical = IfcLogical;
    class IfcLuminousFluxMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLUMINOUSFLUXMEASURE";
        }
    }
    IFC2X32.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;
    class IfcLuminousIntensityDistributionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE";
        }
    }
    IFC2X32.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;
    class IfcLuminousIntensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLUMINOUSINTENSITYMEASURE";
        }
    }
    IFC2X32.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;
    class IfcMagneticFluxDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMAGNETICFLUXDENSITYMEASURE";
        }
    }
    IFC2X32.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;
    class IfcMagneticFluxMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMAGNETICFLUXMEASURE";
        }
    }
    IFC2X32.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;
    class IfcMassDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSDENSITYMEASURE";
        }
    }
    IFC2X32.IfcMassDensityMeasure = IfcMassDensityMeasure;
    class IfcMassFlowRateMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSFLOWRATEMEASURE";
        }
    }
    IFC2X32.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;
    class IfcMassMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSMEASURE";
        }
    }
    IFC2X32.IfcMassMeasure = IfcMassMeasure;
    class IfcMassPerLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSPERLENGTHMEASURE";
        }
    }
    IFC2X32.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;
    class IfcMinuteInHour extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCMINUTEINHOUR";
        }
    }
    IFC2X32.IfcMinuteInHour = IfcMinuteInHour;
    class IfcModulusOfElasticityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFELASTICITYMEASURE";
        }
    }
    IFC2X32.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;
    class IfcModulusOfLinearSubgradeReactionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE";
        }
    }
    IFC2X32.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;
    class IfcModulusOfRotationalSubgradeReactionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE";
        }
    }
    IFC2X32.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;
    class IfcModulusOfSubgradeReactionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFSUBGRADEREACTIONMEASURE";
        }
    }
    IFC2X32.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;
    class IfcMoistureDiffusivityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMOISTUREDIFFUSIVITYMEASURE";
        }
    }
    IFC2X32.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;
    class IfcMolecularWeightMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMOLECULARWEIGHTMEASURE";
        }
    }
    IFC2X32.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;
    class IfcMomentOfInertiaMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMOMENTOFINERTIAMEASURE";
        }
    }
    IFC2X32.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;
    class IfcMonetaryMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMONETARYMEASURE";
        }
    }
    IFC2X32.IfcMonetaryMeasure = IfcMonetaryMeasure;
    class IfcMonthInYearNumber extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCMONTHINYEARNUMBER";
        }
    }
    IFC2X32.IfcMonthInYearNumber = IfcMonthInYearNumber;
    class IfcNormalisedRatioMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCNORMALISEDRATIOMEASURE";
        }
    }
    IFC2X32.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;
    class IfcNumericMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCNUMERICMEASURE";
        }
    }
    IFC2X32.IfcNumericMeasure = IfcNumericMeasure;
    class IfcPHMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPHMEASURE";
        }
    }
    IFC2X32.IfcPHMeasure = IfcPHMeasure;
    class IfcParameterValue extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPARAMETERVALUE";
        }
    }
    IFC2X32.IfcParameterValue = IfcParameterValue;
    class IfcPlanarForceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPLANARFORCEMEASURE";
        }
    }
    IFC2X32.IfcPlanarForceMeasure = IfcPlanarForceMeasure;
    class IfcPlaneAngleMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPLANEANGLEMEASURE";
        }
    }
    IFC2X32.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;
    class IfcPositiveLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOSITIVELENGTHMEASURE";
        }
    }
    IFC2X32.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;
    class IfcPositivePlaneAngleMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOSITIVEPLANEANGLEMEASURE";
        }
    }
    IFC2X32.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;
    class IfcPositiveRatioMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOSITIVERATIOMEASURE";
        }
    }
    IFC2X32.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;
    class IfcPowerMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOWERMEASURE";
        }
    }
    IFC2X32.IfcPowerMeasure = IfcPowerMeasure;
    class IfcPresentableText {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCPRESENTABLETEXT";
        }
    }
    IFC2X32.IfcPresentableText = IfcPresentableText;
    class IfcPressureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPRESSUREMEASURE";
        }
    }
    IFC2X32.IfcPressureMeasure = IfcPressureMeasure;
    class IfcRadioActivityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCRADIOACTIVITYMEASURE";
        }
    }
    IFC2X32.IfcRadioActivityMeasure = IfcRadioActivityMeasure;
    class IfcRatioMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCRATIOMEASURE";
        }
    }
    IFC2X32.IfcRatioMeasure = IfcRatioMeasure;
    class IfcReal extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCREAL";
        }
    }
    IFC2X32.IfcReal = IfcReal;
    class IfcRotationalFrequencyMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCROTATIONALFREQUENCYMEASURE";
        }
    }
    IFC2X32.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;
    class IfcRotationalMassMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCROTATIONALMASSMEASURE";
        }
    }
    IFC2X32.IfcRotationalMassMeasure = IfcRotationalMassMeasure;
    class IfcRotationalStiffnessMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCROTATIONALSTIFFNESSMEASURE";
        }
    }
    IFC2X32.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;
    class IfcSecondInMinute extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSECONDINMINUTE";
        }
    }
    IFC2X32.IfcSecondInMinute = IfcSecondInMinute;
    class IfcSectionModulusMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSECTIONMODULUSMEASURE";
        }
    }
    IFC2X32.IfcSectionModulusMeasure = IfcSectionModulusMeasure;
    class IfcSectionalAreaIntegralMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSECTIONALAREAINTEGRALMEASURE";
        }
    }
    IFC2X32.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;
    class IfcShearModulusMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSHEARMODULUSMEASURE";
        }
    }
    IFC2X32.IfcShearModulusMeasure = IfcShearModulusMeasure;
    class IfcSolidAngleMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOLIDANGLEMEASURE";
        }
    }
    IFC2X32.IfcSolidAngleMeasure = IfcSolidAngleMeasure;
    class IfcSoundPowerMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPOWERMEASURE";
        }
    }
    IFC2X32.IfcSoundPowerMeasure = IfcSoundPowerMeasure;
    class IfcSoundPressureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPRESSUREMEASURE";
        }
    }
    IFC2X32.IfcSoundPressureMeasure = IfcSoundPressureMeasure;
    class IfcSpecificHeatCapacityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSPECIFICHEATCAPACITYMEASURE";
        }
    }
    IFC2X32.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;
    class IfcSpecularExponent extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSPECULAREXPONENT";
        }
    }
    IFC2X32.IfcSpecularExponent = IfcSpecularExponent;
    class IfcSpecularRoughness extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSPECULARROUGHNESS";
        }
    }
    IFC2X32.IfcSpecularRoughness = IfcSpecularRoughness;
    class IfcTemperatureGradientMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTEMPERATUREGRADIENTMEASURE";
        }
    }
    IFC2X32.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;
    class IfcText {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXT";
        }
    }
    IFC2X32.IfcText = IfcText;
    class IfcTextAlignment {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTALIGNMENT";
        }
    }
    IFC2X32.IfcTextAlignment = IfcTextAlignment;
    class IfcTextDecoration {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTDECORATION";
        }
    }
    IFC2X32.IfcTextDecoration = IfcTextDecoration;
    class IfcTextFontName {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTFONTNAME";
        }
    }
    IFC2X32.IfcTextFontName = IfcTextFontName;
    class IfcTextTransformation {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTTRANSFORMATION";
        }
    }
    IFC2X32.IfcTextTransformation = IfcTextTransformation;
    class IfcThermalAdmittanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALADMITTANCEMEASURE";
        }
    }
    IFC2X32.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;
    class IfcThermalConductivityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALCONDUCTIVITYMEASURE";
        }
    }
    IFC2X32.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;
    class IfcThermalExpansionCoefficientMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE";
        }
    }
    IFC2X32.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;
    class IfcThermalResistanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALRESISTANCEMEASURE";
        }
    }
    IFC2X32.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;
    class IfcThermalTransmittanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALTRANSMITTANCEMEASURE";
        }
    }
    IFC2X32.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;
    class IfcThermodynamicTemperatureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMODYNAMICTEMPERATUREMEASURE";
        }
    }
    IFC2X32.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;
    class IfcTimeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTIMEMEASURE";
        }
    }
    IFC2X32.IfcTimeMeasure = IfcTimeMeasure;
    class IfcTimeStamp extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCTIMESTAMP";
        }
    }
    IFC2X32.IfcTimeStamp = IfcTimeStamp;
    class IfcTorqueMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTORQUEMEASURE";
        }
    }
    IFC2X32.IfcTorqueMeasure = IfcTorqueMeasure;
    class IfcVaporPermeabilityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCVAPORPERMEABILITYMEASURE";
        }
    }
    IFC2X32.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;
    class IfcVolumeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCVOLUMEMEASURE";
        }
    }
    IFC2X32.IfcVolumeMeasure = IfcVolumeMeasure;
    class IfcVolumetricFlowRateMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCVOLUMETRICFLOWRATEMEASURE";
        }
    }
    IFC2X32.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;
    class IfcWarpingConstantMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCWARPINGCONSTANTMEASURE";
        }
    }
    IFC2X32.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;
    class IfcWarpingMomentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCWARPINGMOMENTMEASURE";
        }
    }
    IFC2X32.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;
    class IfcYearNumber extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCYEARNUMBER";
        }
    }
    IFC2X32.IfcYearNumber = IfcYearNumber;
    class IfcActionSourceTypeEnum {
        static{
            this.DEAD_LOAD_G = {
                type: 3,
                value: "DEAD_LOAD_G"
            };
        }
        static{
            this.COMPLETION_G1 = {
                type: 3,
                value: "COMPLETION_G1"
            };
        }
        static{
            this.LIVE_LOAD_Q = {
                type: 3,
                value: "LIVE_LOAD_Q"
            };
        }
        static{
            this.SNOW_S = {
                type: 3,
                value: "SNOW_S"
            };
        }
        static{
            this.WIND_W = {
                type: 3,
                value: "WIND_W"
            };
        }
        static{
            this.PRESTRESSING_P = {
                type: 3,
                value: "PRESTRESSING_P"
            };
        }
        static{
            this.SETTLEMENT_U = {
                type: 3,
                value: "SETTLEMENT_U"
            };
        }
        static{
            this.TEMPERATURE_T = {
                type: 3,
                value: "TEMPERATURE_T"
            };
        }
        static{
            this.EARTHQUAKE_E = {
                type: 3,
                value: "EARTHQUAKE_E"
            };
        }
        static{
            this.FIRE = {
                type: 3,
                value: "FIRE"
            };
        }
        static{
            this.IMPULSE = {
                type: 3,
                value: "IMPULSE"
            };
        }
        static{
            this.IMPACT = {
                type: 3,
                value: "IMPACT"
            };
        }
        static{
            this.TRANSPORT = {
                type: 3,
                value: "TRANSPORT"
            };
        }
        static{
            this.ERECTION = {
                type: 3,
                value: "ERECTION"
            };
        }
        static{
            this.PROPPING = {
                type: 3,
                value: "PROPPING"
            };
        }
        static{
            this.SYSTEM_IMPERFECTION = {
                type: 3,
                value: "SYSTEM_IMPERFECTION"
            };
        }
        static{
            this.SHRINKAGE = {
                type: 3,
                value: "SHRINKAGE"
            };
        }
        static{
            this.CREEP = {
                type: 3,
                value: "CREEP"
            };
        }
        static{
            this.LACK_OF_FIT = {
                type: 3,
                value: "LACK_OF_FIT"
            };
        }
        static{
            this.BUOYANCY = {
                type: 3,
                value: "BUOYANCY"
            };
        }
        static{
            this.ICE = {
                type: 3,
                value: "ICE"
            };
        }
        static{
            this.CURRENT = {
                type: 3,
                value: "CURRENT"
            };
        }
        static{
            this.WAVE = {
                type: 3,
                value: "WAVE"
            };
        }
        static{
            this.RAIN = {
                type: 3,
                value: "RAIN"
            };
        }
        static{
            this.BRAKES = {
                type: 3,
                value: "BRAKES"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;
    class IfcActionTypeEnum {
        static{
            this.PERMANENT_G = {
                type: 3,
                value: "PERMANENT_G"
            };
        }
        static{
            this.VARIABLE_Q = {
                type: 3,
                value: "VARIABLE_Q"
            };
        }
        static{
            this.EXTRAORDINARY_A = {
                type: 3,
                value: "EXTRAORDINARY_A"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcActionTypeEnum = IfcActionTypeEnum;
    class IfcActuatorTypeEnum {
        static{
            this.ELECTRICACTUATOR = {
                type: 3,
                value: "ELECTRICACTUATOR"
            };
        }
        static{
            this.HANDOPERATEDACTUATOR = {
                type: 3,
                value: "HANDOPERATEDACTUATOR"
            };
        }
        static{
            this.HYDRAULICACTUATOR = {
                type: 3,
                value: "HYDRAULICACTUATOR"
            };
        }
        static{
            this.PNEUMATICACTUATOR = {
                type: 3,
                value: "PNEUMATICACTUATOR"
            };
        }
        static{
            this.THERMOSTATICACTUATOR = {
                type: 3,
                value: "THERMOSTATICACTUATOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcActuatorTypeEnum = IfcActuatorTypeEnum;
    class IfcAddressTypeEnum {
        static{
            this.OFFICE = {
                type: 3,
                value: "OFFICE"
            };
        }
        static{
            this.SITE = {
                type: 3,
                value: "SITE"
            };
        }
        static{
            this.HOME = {
                type: 3,
                value: "HOME"
            };
        }
        static{
            this.DISTRIBUTIONPOINT = {
                type: 3,
                value: "DISTRIBUTIONPOINT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC2X32.IfcAddressTypeEnum = IfcAddressTypeEnum;
    class IfcAheadOrBehind {
        static{
            this.AHEAD = {
                type: 3,
                value: "AHEAD"
            };
        }
        static{
            this.BEHIND = {
                type: 3,
                value: "BEHIND"
            };
        }
    }
    IFC2X32.IfcAheadOrBehind = IfcAheadOrBehind;
    class IfcAirTerminalBoxTypeEnum {
        static{
            this.CONSTANTFLOW = {
                type: 3,
                value: "CONSTANTFLOW"
            };
        }
        static{
            this.VARIABLEFLOWPRESSUREDEPENDANT = {
                type: 3,
                value: "VARIABLEFLOWPRESSUREDEPENDANT"
            };
        }
        static{
            this.VARIABLEFLOWPRESSUREINDEPENDANT = {
                type: 3,
                value: "VARIABLEFLOWPRESSUREINDEPENDANT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;
    class IfcAirTerminalTypeEnum {
        static{
            this.GRILLE = {
                type: 3,
                value: "GRILLE"
            };
        }
        static{
            this.REGISTER = {
                type: 3,
                value: "REGISTER"
            };
        }
        static{
            this.DIFFUSER = {
                type: 3,
                value: "DIFFUSER"
            };
        }
        static{
            this.EYEBALL = {
                type: 3,
                value: "EYEBALL"
            };
        }
        static{
            this.IRIS = {
                type: 3,
                value: "IRIS"
            };
        }
        static{
            this.LINEARGRILLE = {
                type: 3,
                value: "LINEARGRILLE"
            };
        }
        static{
            this.LINEARDIFFUSER = {
                type: 3,
                value: "LINEARDIFFUSER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;
    class IfcAirToAirHeatRecoveryTypeEnum {
        static{
            this.FIXEDPLATECOUNTERFLOWEXCHANGER = {
                type: 3,
                value: "FIXEDPLATECOUNTERFLOWEXCHANGER"
            };
        }
        static{
            this.FIXEDPLATECROSSFLOWEXCHANGER = {
                type: 3,
                value: "FIXEDPLATECROSSFLOWEXCHANGER"
            };
        }
        static{
            this.FIXEDPLATEPARALLELFLOWEXCHANGER = {
                type: 3,
                value: "FIXEDPLATEPARALLELFLOWEXCHANGER"
            };
        }
        static{
            this.ROTARYWHEEL = {
                type: 3,
                value: "ROTARYWHEEL"
            };
        }
        static{
            this.RUNAROUNDCOILLOOP = {
                type: 3,
                value: "RUNAROUNDCOILLOOP"
            };
        }
        static{
            this.HEATPIPE = {
                type: 3,
                value: "HEATPIPE"
            };
        }
        static{
            this.TWINTOWERENTHALPYRECOVERYLOOPS = {
                type: 3,
                value: "TWINTOWERENTHALPYRECOVERYLOOPS"
            };
        }
        static{
            this.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = {
                type: 3,
                value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS"
            };
        }
        static{
            this.THERMOSIPHONCOILTYPEHEATEXCHANGERS = {
                type: 3,
                value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;
    class IfcAlarmTypeEnum {
        static{
            this.BELL = {
                type: 3,
                value: "BELL"
            };
        }
        static{
            this.BREAKGLASSBUTTON = {
                type: 3,
                value: "BREAKGLASSBUTTON"
            };
        }
        static{
            this.LIGHT = {
                type: 3,
                value: "LIGHT"
            };
        }
        static{
            this.MANUALPULLBOX = {
                type: 3,
                value: "MANUALPULLBOX"
            };
        }
        static{
            this.SIREN = {
                type: 3,
                value: "SIREN"
            };
        }
        static{
            this.WHISTLE = {
                type: 3,
                value: "WHISTLE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcAlarmTypeEnum = IfcAlarmTypeEnum;
    class IfcAnalysisModelTypeEnum {
        static{
            this.IN_PLANE_LOADING_2D = {
                type: 3,
                value: "IN_PLANE_LOADING_2D"
            };
        }
        static{
            this.OUT_PLANE_LOADING_2D = {
                type: 3,
                value: "OUT_PLANE_LOADING_2D"
            };
        }
        static{
            this.LOADING_3D = {
                type: 3,
                value: "LOADING_3D"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;
    class IfcAnalysisTheoryTypeEnum {
        static{
            this.FIRST_ORDER_THEORY = {
                type: 3,
                value: "FIRST_ORDER_THEORY"
            };
        }
        static{
            this.SECOND_ORDER_THEORY = {
                type: 3,
                value: "SECOND_ORDER_THEORY"
            };
        }
        static{
            this.THIRD_ORDER_THEORY = {
                type: 3,
                value: "THIRD_ORDER_THEORY"
            };
        }
        static{
            this.FULL_NONLINEAR_THEORY = {
                type: 3,
                value: "FULL_NONLINEAR_THEORY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;
    class IfcArithmeticOperatorEnum {
        static{
            this.ADD = {
                type: 3,
                value: "ADD"
            };
        }
        static{
            this.DIVIDE = {
                type: 3,
                value: "DIVIDE"
            };
        }
        static{
            this.MULTIPLY = {
                type: 3,
                value: "MULTIPLY"
            };
        }
        static{
            this.SUBTRACT = {
                type: 3,
                value: "SUBTRACT"
            };
        }
    }
    IFC2X32.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;
    class IfcAssemblyPlaceEnum {
        static{
            this.SITE = {
                type: 3,
                value: "SITE"
            };
        }
        static{
            this.FACTORY = {
                type: 3,
                value: "FACTORY"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;
    class IfcBSplineCurveForm {
        static{
            this.POLYLINE_FORM = {
                type: 3,
                value: "POLYLINE_FORM"
            };
        }
        static{
            this.CIRCULAR_ARC = {
                type: 3,
                value: "CIRCULAR_ARC"
            };
        }
        static{
            this.ELLIPTIC_ARC = {
                type: 3,
                value: "ELLIPTIC_ARC"
            };
        }
        static{
            this.PARABOLIC_ARC = {
                type: 3,
                value: "PARABOLIC_ARC"
            };
        }
        static{
            this.HYPERBOLIC_ARC = {
                type: 3,
                value: "HYPERBOLIC_ARC"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC2X32.IfcBSplineCurveForm = IfcBSplineCurveForm;
    class IfcBeamTypeEnum {
        static{
            this.BEAM = {
                type: 3,
                value: "BEAM"
            };
        }
        static{
            this.JOIST = {
                type: 3,
                value: "JOIST"
            };
        }
        static{
            this.LINTEL = {
                type: 3,
                value: "LINTEL"
            };
        }
        static{
            this.T_BEAM = {
                type: 3,
                value: "T_BEAM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcBeamTypeEnum = IfcBeamTypeEnum;
    class IfcBenchmarkEnum {
        static{
            this.GREATERTHAN = {
                type: 3,
                value: "GREATERTHAN"
            };
        }
        static{
            this.GREATERTHANOREQUALTO = {
                type: 3,
                value: "GREATERTHANOREQUALTO"
            };
        }
        static{
            this.LESSTHAN = {
                type: 3,
                value: "LESSTHAN"
            };
        }
        static{
            this.LESSTHANOREQUALTO = {
                type: 3,
                value: "LESSTHANOREQUALTO"
            };
        }
        static{
            this.EQUALTO = {
                type: 3,
                value: "EQUALTO"
            };
        }
        static{
            this.NOTEQUALTO = {
                type: 3,
                value: "NOTEQUALTO"
            };
        }
    }
    IFC2X32.IfcBenchmarkEnum = IfcBenchmarkEnum;
    class IfcBoilerTypeEnum {
        static{
            this.WATER = {
                type: 3,
                value: "WATER"
            };
        }
        static{
            this.STEAM = {
                type: 3,
                value: "STEAM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcBoilerTypeEnum = IfcBoilerTypeEnum;
    class IfcBooleanOperator {
        static{
            this.UNION = {
                type: 3,
                value: "UNION"
            };
        }
        static{
            this.INTERSECTION = {
                type: 3,
                value: "INTERSECTION"
            };
        }
        static{
            this.DIFFERENCE = {
                type: 3,
                value: "DIFFERENCE"
            };
        }
    }
    IFC2X32.IfcBooleanOperator = IfcBooleanOperator;
    class IfcBuildingElementProxyTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;
    class IfcCableCarrierFittingTypeEnum {
        static{
            this.BEND = {
                type: 3,
                value: "BEND"
            };
        }
        static{
            this.CROSS = {
                type: 3,
                value: "CROSS"
            };
        }
        static{
            this.REDUCER = {
                type: 3,
                value: "REDUCER"
            };
        }
        static{
            this.TEE = {
                type: 3,
                value: "TEE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;
    class IfcCableCarrierSegmentTypeEnum {
        static{
            this.CABLELADDERSEGMENT = {
                type: 3,
                value: "CABLELADDERSEGMENT"
            };
        }
        static{
            this.CABLETRAYSEGMENT = {
                type: 3,
                value: "CABLETRAYSEGMENT"
            };
        }
        static{
            this.CABLETRUNKINGSEGMENT = {
                type: 3,
                value: "CABLETRUNKINGSEGMENT"
            };
        }
        static{
            this.CONDUITSEGMENT = {
                type: 3,
                value: "CONDUITSEGMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;
    class IfcCableSegmentTypeEnum {
        static{
            this.CABLESEGMENT = {
                type: 3,
                value: "CABLESEGMENT"
            };
        }
        static{
            this.CONDUCTORSEGMENT = {
                type: 3,
                value: "CONDUCTORSEGMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;
    class IfcChangeActionEnum {
        static{
            this.NOCHANGE = {
                type: 3,
                value: "NOCHANGE"
            };
        }
        static{
            this.MODIFIED = {
                type: 3,
                value: "MODIFIED"
            };
        }
        static{
            this.ADDED = {
                type: 3,
                value: "ADDED"
            };
        }
        static{
            this.DELETED = {
                type: 3,
                value: "DELETED"
            };
        }
        static{
            this.MODIFIEDADDED = {
                type: 3,
                value: "MODIFIEDADDED"
            };
        }
        static{
            this.MODIFIEDDELETED = {
                type: 3,
                value: "MODIFIEDDELETED"
            };
        }
    }
    IFC2X32.IfcChangeActionEnum = IfcChangeActionEnum;
    class IfcChillerTypeEnum {
        static{
            this.AIRCOOLED = {
                type: 3,
                value: "AIRCOOLED"
            };
        }
        static{
            this.WATERCOOLED = {
                type: 3,
                value: "WATERCOOLED"
            };
        }
        static{
            this.HEATRECOVERY = {
                type: 3,
                value: "HEATRECOVERY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcChillerTypeEnum = IfcChillerTypeEnum;
    class IfcCoilTypeEnum {
        static{
            this.DXCOOLINGCOIL = {
                type: 3,
                value: "DXCOOLINGCOIL"
            };
        }
        static{
            this.WATERCOOLINGCOIL = {
                type: 3,
                value: "WATERCOOLINGCOIL"
            };
        }
        static{
            this.STEAMHEATINGCOIL = {
                type: 3,
                value: "STEAMHEATINGCOIL"
            };
        }
        static{
            this.WATERHEATINGCOIL = {
                type: 3,
                value: "WATERHEATINGCOIL"
            };
        }
        static{
            this.ELECTRICHEATINGCOIL = {
                type: 3,
                value: "ELECTRICHEATINGCOIL"
            };
        }
        static{
            this.GASHEATINGCOIL = {
                type: 3,
                value: "GASHEATINGCOIL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCoilTypeEnum = IfcCoilTypeEnum;
    class IfcColumnTypeEnum {
        static{
            this.COLUMN = {
                type: 3,
                value: "COLUMN"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcColumnTypeEnum = IfcColumnTypeEnum;
    class IfcCompressorTypeEnum {
        static{
            this.DYNAMIC = {
                type: 3,
                value: "DYNAMIC"
            };
        }
        static{
            this.RECIPROCATING = {
                type: 3,
                value: "RECIPROCATING"
            };
        }
        static{
            this.ROTARY = {
                type: 3,
                value: "ROTARY"
            };
        }
        static{
            this.SCROLL = {
                type: 3,
                value: "SCROLL"
            };
        }
        static{
            this.TROCHOIDAL = {
                type: 3,
                value: "TROCHOIDAL"
            };
        }
        static{
            this.SINGLESTAGE = {
                type: 3,
                value: "SINGLESTAGE"
            };
        }
        static{
            this.BOOSTER = {
                type: 3,
                value: "BOOSTER"
            };
        }
        static{
            this.OPENTYPE = {
                type: 3,
                value: "OPENTYPE"
            };
        }
        static{
            this.HERMETIC = {
                type: 3,
                value: "HERMETIC"
            };
        }
        static{
            this.SEMIHERMETIC = {
                type: 3,
                value: "SEMIHERMETIC"
            };
        }
        static{
            this.WELDEDSHELLHERMETIC = {
                type: 3,
                value: "WELDEDSHELLHERMETIC"
            };
        }
        static{
            this.ROLLINGPISTON = {
                type: 3,
                value: "ROLLINGPISTON"
            };
        }
        static{
            this.ROTARYVANE = {
                type: 3,
                value: "ROTARYVANE"
            };
        }
        static{
            this.SINGLESCREW = {
                type: 3,
                value: "SINGLESCREW"
            };
        }
        static{
            this.TWINSCREW = {
                type: 3,
                value: "TWINSCREW"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCompressorTypeEnum = IfcCompressorTypeEnum;
    class IfcCondenserTypeEnum {
        static{
            this.WATERCOOLEDSHELLTUBE = {
                type: 3,
                value: "WATERCOOLEDSHELLTUBE"
            };
        }
        static{
            this.WATERCOOLEDSHELLCOIL = {
                type: 3,
                value: "WATERCOOLEDSHELLCOIL"
            };
        }
        static{
            this.WATERCOOLEDTUBEINTUBE = {
                type: 3,
                value: "WATERCOOLEDTUBEINTUBE"
            };
        }
        static{
            this.WATERCOOLEDBRAZEDPLATE = {
                type: 3,
                value: "WATERCOOLEDBRAZEDPLATE"
            };
        }
        static{
            this.AIRCOOLED = {
                type: 3,
                value: "AIRCOOLED"
            };
        }
        static{
            this.EVAPORATIVECOOLED = {
                type: 3,
                value: "EVAPORATIVECOOLED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCondenserTypeEnum = IfcCondenserTypeEnum;
    class IfcConnectionTypeEnum {
        static{
            this.ATPATH = {
                type: 3,
                value: "ATPATH"
            };
        }
        static{
            this.ATSTART = {
                type: 3,
                value: "ATSTART"
            };
        }
        static{
            this.ATEND = {
                type: 3,
                value: "ATEND"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcConnectionTypeEnum = IfcConnectionTypeEnum;
    class IfcConstraintEnum {
        static{
            this.HARD = {
                type: 3,
                value: "HARD"
            };
        }
        static{
            this.SOFT = {
                type: 3,
                value: "SOFT"
            };
        }
        static{
            this.ADVISORY = {
                type: 3,
                value: "ADVISORY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcConstraintEnum = IfcConstraintEnum;
    class IfcControllerTypeEnum {
        static{
            this.FLOATING = {
                type: 3,
                value: "FLOATING"
            };
        }
        static{
            this.PROPORTIONAL = {
                type: 3,
                value: "PROPORTIONAL"
            };
        }
        static{
            this.PROPORTIONALINTEGRAL = {
                type: 3,
                value: "PROPORTIONALINTEGRAL"
            };
        }
        static{
            this.PROPORTIONALINTEGRALDERIVATIVE = {
                type: 3,
                value: "PROPORTIONALINTEGRALDERIVATIVE"
            };
        }
        static{
            this.TIMEDTWOPOSITION = {
                type: 3,
                value: "TIMEDTWOPOSITION"
            };
        }
        static{
            this.TWOPOSITION = {
                type: 3,
                value: "TWOPOSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcControllerTypeEnum = IfcControllerTypeEnum;
    class IfcCooledBeamTypeEnum {
        static{
            this.ACTIVE = {
                type: 3,
                value: "ACTIVE"
            };
        }
        static{
            this.PASSIVE = {
                type: 3,
                value: "PASSIVE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;
    class IfcCoolingTowerTypeEnum {
        static{
            this.NATURALDRAFT = {
                type: 3,
                value: "NATURALDRAFT"
            };
        }
        static{
            this.MECHANICALINDUCEDDRAFT = {
                type: 3,
                value: "MECHANICALINDUCEDDRAFT"
            };
        }
        static{
            this.MECHANICALFORCEDDRAFT = {
                type: 3,
                value: "MECHANICALFORCEDDRAFT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;
    class IfcCostScheduleTypeEnum {
        static{
            this.BUDGET = {
                type: 3,
                value: "BUDGET"
            };
        }
        static{
            this.COSTPLAN = {
                type: 3,
                value: "COSTPLAN"
            };
        }
        static{
            this.ESTIMATE = {
                type: 3,
                value: "ESTIMATE"
            };
        }
        static{
            this.TENDER = {
                type: 3,
                value: "TENDER"
            };
        }
        static{
            this.PRICEDBILLOFQUANTITIES = {
                type: 3,
                value: "PRICEDBILLOFQUANTITIES"
            };
        }
        static{
            this.UNPRICEDBILLOFQUANTITIES = {
                type: 3,
                value: "UNPRICEDBILLOFQUANTITIES"
            };
        }
        static{
            this.SCHEDULEOFRATES = {
                type: 3,
                value: "SCHEDULEOFRATES"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;
    class IfcCoveringTypeEnum {
        static{
            this.CEILING = {
                type: 3,
                value: "CEILING"
            };
        }
        static{
            this.FLOORING = {
                type: 3,
                value: "FLOORING"
            };
        }
        static{
            this.CLADDING = {
                type: 3,
                value: "CLADDING"
            };
        }
        static{
            this.ROOFING = {
                type: 3,
                value: "ROOFING"
            };
        }
        static{
            this.INSULATION = {
                type: 3,
                value: "INSULATION"
            };
        }
        static{
            this.MEMBRANE = {
                type: 3,
                value: "MEMBRANE"
            };
        }
        static{
            this.SLEEVING = {
                type: 3,
                value: "SLEEVING"
            };
        }
        static{
            this.WRAPPING = {
                type: 3,
                value: "WRAPPING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCoveringTypeEnum = IfcCoveringTypeEnum;
    class IfcCurrencyEnum {
        static{
            this.AED = {
                type: 3,
                value: "AED"
            };
        }
        static{
            this.AES = {
                type: 3,
                value: "AES"
            };
        }
        static{
            this.ATS = {
                type: 3,
                value: "ATS"
            };
        }
        static{
            this.AUD = {
                type: 3,
                value: "AUD"
            };
        }
        static{
            this.BBD = {
                type: 3,
                value: "BBD"
            };
        }
        static{
            this.BEG = {
                type: 3,
                value: "BEG"
            };
        }
        static{
            this.BGL = {
                type: 3,
                value: "BGL"
            };
        }
        static{
            this.BHD = {
                type: 3,
                value: "BHD"
            };
        }
        static{
            this.BMD = {
                type: 3,
                value: "BMD"
            };
        }
        static{
            this.BND = {
                type: 3,
                value: "BND"
            };
        }
        static{
            this.BRL = {
                type: 3,
                value: "BRL"
            };
        }
        static{
            this.BSD = {
                type: 3,
                value: "BSD"
            };
        }
        static{
            this.BWP = {
                type: 3,
                value: "BWP"
            };
        }
        static{
            this.BZD = {
                type: 3,
                value: "BZD"
            };
        }
        static{
            this.CAD = {
                type: 3,
                value: "CAD"
            };
        }
        static{
            this.CBD = {
                type: 3,
                value: "CBD"
            };
        }
        static{
            this.CHF = {
                type: 3,
                value: "CHF"
            };
        }
        static{
            this.CLP = {
                type: 3,
                value: "CLP"
            };
        }
        static{
            this.CNY = {
                type: 3,
                value: "CNY"
            };
        }
        static{
            this.CYS = {
                type: 3,
                value: "CYS"
            };
        }
        static{
            this.CZK = {
                type: 3,
                value: "CZK"
            };
        }
        static{
            this.DDP = {
                type: 3,
                value: "DDP"
            };
        }
        static{
            this.DEM = {
                type: 3,
                value: "DEM"
            };
        }
        static{
            this.DKK = {
                type: 3,
                value: "DKK"
            };
        }
        static{
            this.EGL = {
                type: 3,
                value: "EGL"
            };
        }
        static{
            this.EST = {
                type: 3,
                value: "EST"
            };
        }
        static{
            this.EUR = {
                type: 3,
                value: "EUR"
            };
        }
        static{
            this.FAK = {
                type: 3,
                value: "FAK"
            };
        }
        static{
            this.FIM = {
                type: 3,
                value: "FIM"
            };
        }
        static{
            this.FJD = {
                type: 3,
                value: "FJD"
            };
        }
        static{
            this.FKP = {
                type: 3,
                value: "FKP"
            };
        }
        static{
            this.FRF = {
                type: 3,
                value: "FRF"
            };
        }
        static{
            this.GBP = {
                type: 3,
                value: "GBP"
            };
        }
        static{
            this.GIP = {
                type: 3,
                value: "GIP"
            };
        }
        static{
            this.GMD = {
                type: 3,
                value: "GMD"
            };
        }
        static{
            this.GRX = {
                type: 3,
                value: "GRX"
            };
        }
        static{
            this.HKD = {
                type: 3,
                value: "HKD"
            };
        }
        static{
            this.HUF = {
                type: 3,
                value: "HUF"
            };
        }
        static{
            this.ICK = {
                type: 3,
                value: "ICK"
            };
        }
        static{
            this.IDR = {
                type: 3,
                value: "IDR"
            };
        }
        static{
            this.ILS = {
                type: 3,
                value: "ILS"
            };
        }
        static{
            this.INR = {
                type: 3,
                value: "INR"
            };
        }
        static{
            this.IRP = {
                type: 3,
                value: "IRP"
            };
        }
        static{
            this.ITL = {
                type: 3,
                value: "ITL"
            };
        }
        static{
            this.JMD = {
                type: 3,
                value: "JMD"
            };
        }
        static{
            this.JOD = {
                type: 3,
                value: "JOD"
            };
        }
        static{
            this.JPY = {
                type: 3,
                value: "JPY"
            };
        }
        static{
            this.KES = {
                type: 3,
                value: "KES"
            };
        }
        static{
            this.KRW = {
                type: 3,
                value: "KRW"
            };
        }
        static{
            this.KWD = {
                type: 3,
                value: "KWD"
            };
        }
        static{
            this.KYD = {
                type: 3,
                value: "KYD"
            };
        }
        static{
            this.LKR = {
                type: 3,
                value: "LKR"
            };
        }
        static{
            this.LUF = {
                type: 3,
                value: "LUF"
            };
        }
        static{
            this.MTL = {
                type: 3,
                value: "MTL"
            };
        }
        static{
            this.MUR = {
                type: 3,
                value: "MUR"
            };
        }
        static{
            this.MXN = {
                type: 3,
                value: "MXN"
            };
        }
        static{
            this.MYR = {
                type: 3,
                value: "MYR"
            };
        }
        static{
            this.NLG = {
                type: 3,
                value: "NLG"
            };
        }
        static{
            this.NZD = {
                type: 3,
                value: "NZD"
            };
        }
        static{
            this.OMR = {
                type: 3,
                value: "OMR"
            };
        }
        static{
            this.PGK = {
                type: 3,
                value: "PGK"
            };
        }
        static{
            this.PHP = {
                type: 3,
                value: "PHP"
            };
        }
        static{
            this.PKR = {
                type: 3,
                value: "PKR"
            };
        }
        static{
            this.PLN = {
                type: 3,
                value: "PLN"
            };
        }
        static{
            this.PTN = {
                type: 3,
                value: "PTN"
            };
        }
        static{
            this.QAR = {
                type: 3,
                value: "QAR"
            };
        }
        static{
            this.RUR = {
                type: 3,
                value: "RUR"
            };
        }
        static{
            this.SAR = {
                type: 3,
                value: "SAR"
            };
        }
        static{
            this.SCR = {
                type: 3,
                value: "SCR"
            };
        }
        static{
            this.SEK = {
                type: 3,
                value: "SEK"
            };
        }
        static{
            this.SGD = {
                type: 3,
                value: "SGD"
            };
        }
        static{
            this.SKP = {
                type: 3,
                value: "SKP"
            };
        }
        static{
            this.THB = {
                type: 3,
                value: "THB"
            };
        }
        static{
            this.TRL = {
                type: 3,
                value: "TRL"
            };
        }
        static{
            this.TTD = {
                type: 3,
                value: "TTD"
            };
        }
        static{
            this.TWD = {
                type: 3,
                value: "TWD"
            };
        }
        static{
            this.USD = {
                type: 3,
                value: "USD"
            };
        }
        static{
            this.VEB = {
                type: 3,
                value: "VEB"
            };
        }
        static{
            this.VND = {
                type: 3,
                value: "VND"
            };
        }
        static{
            this.XEU = {
                type: 3,
                value: "XEU"
            };
        }
        static{
            this.ZAR = {
                type: 3,
                value: "ZAR"
            };
        }
        static{
            this.ZWD = {
                type: 3,
                value: "ZWD"
            };
        }
        static{
            this.NOK = {
                type: 3,
                value: "NOK"
            };
        }
    }
    IFC2X32.IfcCurrencyEnum = IfcCurrencyEnum;
    class IfcCurtainWallTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;
    class IfcDamperTypeEnum {
        static{
            this.CONTROLDAMPER = {
                type: 3,
                value: "CONTROLDAMPER"
            };
        }
        static{
            this.FIREDAMPER = {
                type: 3,
                value: "FIREDAMPER"
            };
        }
        static{
            this.SMOKEDAMPER = {
                type: 3,
                value: "SMOKEDAMPER"
            };
        }
        static{
            this.FIRESMOKEDAMPER = {
                type: 3,
                value: "FIRESMOKEDAMPER"
            };
        }
        static{
            this.BACKDRAFTDAMPER = {
                type: 3,
                value: "BACKDRAFTDAMPER"
            };
        }
        static{
            this.RELIEFDAMPER = {
                type: 3,
                value: "RELIEFDAMPER"
            };
        }
        static{
            this.BLASTDAMPER = {
                type: 3,
                value: "BLASTDAMPER"
            };
        }
        static{
            this.GRAVITYDAMPER = {
                type: 3,
                value: "GRAVITYDAMPER"
            };
        }
        static{
            this.GRAVITYRELIEFDAMPER = {
                type: 3,
                value: "GRAVITYRELIEFDAMPER"
            };
        }
        static{
            this.BALANCINGDAMPER = {
                type: 3,
                value: "BALANCINGDAMPER"
            };
        }
        static{
            this.FUMEHOODEXHAUST = {
                type: 3,
                value: "FUMEHOODEXHAUST"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDamperTypeEnum = IfcDamperTypeEnum;
    class IfcDataOriginEnum {
        static{
            this.MEASURED = {
                type: 3,
                value: "MEASURED"
            };
        }
        static{
            this.PREDICTED = {
                type: 3,
                value: "PREDICTED"
            };
        }
        static{
            this.SIMULATED = {
                type: 3,
                value: "SIMULATED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDataOriginEnum = IfcDataOriginEnum;
    class IfcDerivedUnitEnum {
        static{
            this.ANGULARVELOCITYUNIT = {
                type: 3,
                value: "ANGULARVELOCITYUNIT"
            };
        }
        static{
            this.COMPOUNDPLANEANGLEUNIT = {
                type: 3,
                value: "COMPOUNDPLANEANGLEUNIT"
            };
        }
        static{
            this.DYNAMICVISCOSITYUNIT = {
                type: 3,
                value: "DYNAMICVISCOSITYUNIT"
            };
        }
        static{
            this.HEATFLUXDENSITYUNIT = {
                type: 3,
                value: "HEATFLUXDENSITYUNIT"
            };
        }
        static{
            this.INTEGERCOUNTRATEUNIT = {
                type: 3,
                value: "INTEGERCOUNTRATEUNIT"
            };
        }
        static{
            this.ISOTHERMALMOISTURECAPACITYUNIT = {
                type: 3,
                value: "ISOTHERMALMOISTURECAPACITYUNIT"
            };
        }
        static{
            this.KINEMATICVISCOSITYUNIT = {
                type: 3,
                value: "KINEMATICVISCOSITYUNIT"
            };
        }
        static{
            this.LINEARVELOCITYUNIT = {
                type: 3,
                value: "LINEARVELOCITYUNIT"
            };
        }
        static{
            this.MASSDENSITYUNIT = {
                type: 3,
                value: "MASSDENSITYUNIT"
            };
        }
        static{
            this.MASSFLOWRATEUNIT = {
                type: 3,
                value: "MASSFLOWRATEUNIT"
            };
        }
        static{
            this.MOISTUREDIFFUSIVITYUNIT = {
                type: 3,
                value: "MOISTUREDIFFUSIVITYUNIT"
            };
        }
        static{
            this.MOLECULARWEIGHTUNIT = {
                type: 3,
                value: "MOLECULARWEIGHTUNIT"
            };
        }
        static{
            this.SPECIFICHEATCAPACITYUNIT = {
                type: 3,
                value: "SPECIFICHEATCAPACITYUNIT"
            };
        }
        static{
            this.THERMALADMITTANCEUNIT = {
                type: 3,
                value: "THERMALADMITTANCEUNIT"
            };
        }
        static{
            this.THERMALCONDUCTANCEUNIT = {
                type: 3,
                value: "THERMALCONDUCTANCEUNIT"
            };
        }
        static{
            this.THERMALRESISTANCEUNIT = {
                type: 3,
                value: "THERMALRESISTANCEUNIT"
            };
        }
        static{
            this.THERMALTRANSMITTANCEUNIT = {
                type: 3,
                value: "THERMALTRANSMITTANCEUNIT"
            };
        }
        static{
            this.VAPORPERMEABILITYUNIT = {
                type: 3,
                value: "VAPORPERMEABILITYUNIT"
            };
        }
        static{
            this.VOLUMETRICFLOWRATEUNIT = {
                type: 3,
                value: "VOLUMETRICFLOWRATEUNIT"
            };
        }
        static{
            this.ROTATIONALFREQUENCYUNIT = {
                type: 3,
                value: "ROTATIONALFREQUENCYUNIT"
            };
        }
        static{
            this.TORQUEUNIT = {
                type: 3,
                value: "TORQUEUNIT"
            };
        }
        static{
            this.MOMENTOFINERTIAUNIT = {
                type: 3,
                value: "MOMENTOFINERTIAUNIT"
            };
        }
        static{
            this.LINEARMOMENTUNIT = {
                type: 3,
                value: "LINEARMOMENTUNIT"
            };
        }
        static{
            this.LINEARFORCEUNIT = {
                type: 3,
                value: "LINEARFORCEUNIT"
            };
        }
        static{
            this.PLANARFORCEUNIT = {
                type: 3,
                value: "PLANARFORCEUNIT"
            };
        }
        static{
            this.MODULUSOFELASTICITYUNIT = {
                type: 3,
                value: "MODULUSOFELASTICITYUNIT"
            };
        }
        static{
            this.SHEARMODULUSUNIT = {
                type: 3,
                value: "SHEARMODULUSUNIT"
            };
        }
        static{
            this.LINEARSTIFFNESSUNIT = {
                type: 3,
                value: "LINEARSTIFFNESSUNIT"
            };
        }
        static{
            this.ROTATIONALSTIFFNESSUNIT = {
                type: 3,
                value: "ROTATIONALSTIFFNESSUNIT"
            };
        }
        static{
            this.MODULUSOFSUBGRADEREACTIONUNIT = {
                type: 3,
                value: "MODULUSOFSUBGRADEREACTIONUNIT"
            };
        }
        static{
            this.ACCELERATIONUNIT = {
                type: 3,
                value: "ACCELERATIONUNIT"
            };
        }
        static{
            this.CURVATUREUNIT = {
                type: 3,
                value: "CURVATUREUNIT"
            };
        }
        static{
            this.HEATINGVALUEUNIT = {
                type: 3,
                value: "HEATINGVALUEUNIT"
            };
        }
        static{
            this.IONCONCENTRATIONUNIT = {
                type: 3,
                value: "IONCONCENTRATIONUNIT"
            };
        }
        static{
            this.LUMINOUSINTENSITYDISTRIBUTIONUNIT = {
                type: 3,
                value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT"
            };
        }
        static{
            this.MASSPERLENGTHUNIT = {
                type: 3,
                value: "MASSPERLENGTHUNIT"
            };
        }
        static{
            this.MODULUSOFLINEARSUBGRADEREACTIONUNIT = {
                type: 3,
                value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT"
            };
        }
        static{
            this.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = {
                type: 3,
                value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT"
            };
        }
        static{
            this.PHUNIT = {
                type: 3,
                value: "PHUNIT"
            };
        }
        static{
            this.ROTATIONALMASSUNIT = {
                type: 3,
                value: "ROTATIONALMASSUNIT"
            };
        }
        static{
            this.SECTIONAREAINTEGRALUNIT = {
                type: 3,
                value: "SECTIONAREAINTEGRALUNIT"
            };
        }
        static{
            this.SECTIONMODULUSUNIT = {
                type: 3,
                value: "SECTIONMODULUSUNIT"
            };
        }
        static{
            this.SOUNDPOWERUNIT = {
                type: 3,
                value: "SOUNDPOWERUNIT"
            };
        }
        static{
            this.SOUNDPRESSUREUNIT = {
                type: 3,
                value: "SOUNDPRESSUREUNIT"
            };
        }
        static{
            this.TEMPERATUREGRADIENTUNIT = {
                type: 3,
                value: "TEMPERATUREGRADIENTUNIT"
            };
        }
        static{
            this.THERMALEXPANSIONCOEFFICIENTUNIT = {
                type: 3,
                value: "THERMALEXPANSIONCOEFFICIENTUNIT"
            };
        }
        static{
            this.WARPINGCONSTANTUNIT = {
                type: 3,
                value: "WARPINGCONSTANTUNIT"
            };
        }
        static{
            this.WARPINGMOMENTUNIT = {
                type: 3,
                value: "WARPINGMOMENTUNIT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC2X32.IfcDerivedUnitEnum = IfcDerivedUnitEnum;
    class IfcDimensionExtentUsage {
        static{
            this.ORIGIN = {
                type: 3,
                value: "ORIGIN"
            };
        }
        static{
            this.TARGET = {
                type: 3,
                value: "TARGET"
            };
        }
    }
    IFC2X32.IfcDimensionExtentUsage = IfcDimensionExtentUsage;
    class IfcDirectionSenseEnum {
        static{
            this.POSITIVE = {
                type: 3,
                value: "POSITIVE"
            };
        }
        static{
            this.NEGATIVE = {
                type: 3,
                value: "NEGATIVE"
            };
        }
    }
    IFC2X32.IfcDirectionSenseEnum = IfcDirectionSenseEnum;
    class IfcDistributionChamberElementTypeEnum {
        static{
            this.FORMEDDUCT = {
                type: 3,
                value: "FORMEDDUCT"
            };
        }
        static{
            this.INSPECTIONCHAMBER = {
                type: 3,
                value: "INSPECTIONCHAMBER"
            };
        }
        static{
            this.INSPECTIONPIT = {
                type: 3,
                value: "INSPECTIONPIT"
            };
        }
        static{
            this.MANHOLE = {
                type: 3,
                value: "MANHOLE"
            };
        }
        static{
            this.METERCHAMBER = {
                type: 3,
                value: "METERCHAMBER"
            };
        }
        static{
            this.SUMP = {
                type: 3,
                value: "SUMP"
            };
        }
        static{
            this.TRENCH = {
                type: 3,
                value: "TRENCH"
            };
        }
        static{
            this.VALVECHAMBER = {
                type: 3,
                value: "VALVECHAMBER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;
    class IfcDocumentConfidentialityEnum {
        static{
            this.PUBLIC = {
                type: 3,
                value: "PUBLIC"
            };
        }
        static{
            this.RESTRICTED = {
                type: 3,
                value: "RESTRICTED"
            };
        }
        static{
            this.CONFIDENTIAL = {
                type: 3,
                value: "CONFIDENTIAL"
            };
        }
        static{
            this.PERSONAL = {
                type: 3,
                value: "PERSONAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;
    class IfcDocumentStatusEnum {
        static{
            this.DRAFT = {
                type: 3,
                value: "DRAFT"
            };
        }
        static{
            this.FINALDRAFT = {
                type: 3,
                value: "FINALDRAFT"
            };
        }
        static{
            this.FINAL = {
                type: 3,
                value: "FINAL"
            };
        }
        static{
            this.REVISION = {
                type: 3,
                value: "REVISION"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDocumentStatusEnum = IfcDocumentStatusEnum;
    class IfcDoorPanelOperationEnum {
        static{
            this.SWINGING = {
                type: 3,
                value: "SWINGING"
            };
        }
        static{
            this.DOUBLE_ACTING = {
                type: 3,
                value: "DOUBLE_ACTING"
            };
        }
        static{
            this.SLIDING = {
                type: 3,
                value: "SLIDING"
            };
        }
        static{
            this.FOLDING = {
                type: 3,
                value: "FOLDING"
            };
        }
        static{
            this.REVOLVING = {
                type: 3,
                value: "REVOLVING"
            };
        }
        static{
            this.ROLLINGUP = {
                type: 3,
                value: "ROLLINGUP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;
    class IfcDoorPanelPositionEnum {
        static{
            this.LEFT = {
                type: 3,
                value: "LEFT"
            };
        }
        static{
            this.MIDDLE = {
                type: 3,
                value: "MIDDLE"
            };
        }
        static{
            this.RIGHT = {
                type: 3,
                value: "RIGHT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;
    class IfcDoorStyleConstructionEnum {
        static{
            this.ALUMINIUM = {
                type: 3,
                value: "ALUMINIUM"
            };
        }
        static{
            this.HIGH_GRADE_STEEL = {
                type: 3,
                value: "HIGH_GRADE_STEEL"
            };
        }
        static{
            this.STEEL = {
                type: 3,
                value: "STEEL"
            };
        }
        static{
            this.WOOD = {
                type: 3,
                value: "WOOD"
            };
        }
        static{
            this.ALUMINIUM_WOOD = {
                type: 3,
                value: "ALUMINIUM_WOOD"
            };
        }
        static{
            this.ALUMINIUM_PLASTIC = {
                type: 3,
                value: "ALUMINIUM_PLASTIC"
            };
        }
        static{
            this.PLASTIC = {
                type: 3,
                value: "PLASTIC"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;
    class IfcDoorStyleOperationEnum {
        static{
            this.SINGLE_SWING_LEFT = {
                type: 3,
                value: "SINGLE_SWING_LEFT"
            };
        }
        static{
            this.SINGLE_SWING_RIGHT = {
                type: 3,
                value: "SINGLE_SWING_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT"
            };
        }
        static{
            this.DOUBLE_SWING_LEFT = {
                type: 3,
                value: "DOUBLE_SWING_LEFT"
            };
        }
        static{
            this.DOUBLE_SWING_RIGHT = {
                type: 3,
                value: "DOUBLE_SWING_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_DOUBLE_SWING = {
                type: 3,
                value: "DOUBLE_DOOR_DOUBLE_SWING"
            };
        }
        static{
            this.SLIDING_TO_LEFT = {
                type: 3,
                value: "SLIDING_TO_LEFT"
            };
        }
        static{
            this.SLIDING_TO_RIGHT = {
                type: 3,
                value: "SLIDING_TO_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_SLIDING = {
                type: 3,
                value: "DOUBLE_DOOR_SLIDING"
            };
        }
        static{
            this.FOLDING_TO_LEFT = {
                type: 3,
                value: "FOLDING_TO_LEFT"
            };
        }
        static{
            this.FOLDING_TO_RIGHT = {
                type: 3,
                value: "FOLDING_TO_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_FOLDING = {
                type: 3,
                value: "DOUBLE_DOOR_FOLDING"
            };
        }
        static{
            this.REVOLVING = {
                type: 3,
                value: "REVOLVING"
            };
        }
        static{
            this.ROLLINGUP = {
                type: 3,
                value: "ROLLINGUP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;
    class IfcDuctFittingTypeEnum {
        static{
            this.BEND = {
                type: 3,
                value: "BEND"
            };
        }
        static{
            this.CONNECTOR = {
                type: 3,
                value: "CONNECTOR"
            };
        }
        static{
            this.ENTRY = {
                type: 3,
                value: "ENTRY"
            };
        }
        static{
            this.EXIT = {
                type: 3,
                value: "EXIT"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.OBSTRUCTION = {
                type: 3,
                value: "OBSTRUCTION"
            };
        }
        static{
            this.TRANSITION = {
                type: 3,
                value: "TRANSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;
    class IfcDuctSegmentTypeEnum {
        static{
            this.RIGIDSEGMENT = {
                type: 3,
                value: "RIGIDSEGMENT"
            };
        }
        static{
            this.FLEXIBLESEGMENT = {
                type: 3,
                value: "FLEXIBLESEGMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;
    class IfcDuctSilencerTypeEnum {
        static{
            this.FLATOVAL = {
                type: 3,
                value: "FLATOVAL"
            };
        }
        static{
            this.RECTANGULAR = {
                type: 3,
                value: "RECTANGULAR"
            };
        }
        static{
            this.ROUND = {
                type: 3,
                value: "ROUND"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;
    class IfcElectricApplianceTypeEnum {
        static{
            this.COMPUTER = {
                type: 3,
                value: "COMPUTER"
            };
        }
        static{
            this.DIRECTWATERHEATER = {
                type: 3,
                value: "DIRECTWATERHEATER"
            };
        }
        static{
            this.DISHWASHER = {
                type: 3,
                value: "DISHWASHER"
            };
        }
        static{
            this.ELECTRICCOOKER = {
                type: 3,
                value: "ELECTRICCOOKER"
            };
        }
        static{
            this.ELECTRICHEATER = {
                type: 3,
                value: "ELECTRICHEATER"
            };
        }
        static{
            this.FACSIMILE = {
                type: 3,
                value: "FACSIMILE"
            };
        }
        static{
            this.FREESTANDINGFAN = {
                type: 3,
                value: "FREESTANDINGFAN"
            };
        }
        static{
            this.FREEZER = {
                type: 3,
                value: "FREEZER"
            };
        }
        static{
            this.FRIDGE_FREEZER = {
                type: 3,
                value: "FRIDGE_FREEZER"
            };
        }
        static{
            this.HANDDRYER = {
                type: 3,
                value: "HANDDRYER"
            };
        }
        static{
            this.INDIRECTWATERHEATER = {
                type: 3,
                value: "INDIRECTWATERHEATER"
            };
        }
        static{
            this.MICROWAVE = {
                type: 3,
                value: "MICROWAVE"
            };
        }
        static{
            this.PHOTOCOPIER = {
                type: 3,
                value: "PHOTOCOPIER"
            };
        }
        static{
            this.PRINTER = {
                type: 3,
                value: "PRINTER"
            };
        }
        static{
            this.REFRIGERATOR = {
                type: 3,
                value: "REFRIGERATOR"
            };
        }
        static{
            this.RADIANTHEATER = {
                type: 3,
                value: "RADIANTHEATER"
            };
        }
        static{
            this.SCANNER = {
                type: 3,
                value: "SCANNER"
            };
        }
        static{
            this.TELEPHONE = {
                type: 3,
                value: "TELEPHONE"
            };
        }
        static{
            this.TUMBLEDRYER = {
                type: 3,
                value: "TUMBLEDRYER"
            };
        }
        static{
            this.TV = {
                type: 3,
                value: "TV"
            };
        }
        static{
            this.VENDINGMACHINE = {
                type: 3,
                value: "VENDINGMACHINE"
            };
        }
        static{
            this.WASHINGMACHINE = {
                type: 3,
                value: "WASHINGMACHINE"
            };
        }
        static{
            this.WATERHEATER = {
                type: 3,
                value: "WATERHEATER"
            };
        }
        static{
            this.WATERCOOLER = {
                type: 3,
                value: "WATERCOOLER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;
    class IfcElectricCurrentEnum {
        static{
            this.ALTERNATING = {
                type: 3,
                value: "ALTERNATING"
            };
        }
        static{
            this.DIRECT = {
                type: 3,
                value: "DIRECT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcElectricCurrentEnum = IfcElectricCurrentEnum;
    class IfcElectricDistributionPointFunctionEnum {
        static{
            this.ALARMPANEL = {
                type: 3,
                value: "ALARMPANEL"
            };
        }
        static{
            this.CONSUMERUNIT = {
                type: 3,
                value: "CONSUMERUNIT"
            };
        }
        static{
            this.CONTROLPANEL = {
                type: 3,
                value: "CONTROLPANEL"
            };
        }
        static{
            this.DISTRIBUTIONBOARD = {
                type: 3,
                value: "DISTRIBUTIONBOARD"
            };
        }
        static{
            this.GASDETECTORPANEL = {
                type: 3,
                value: "GASDETECTORPANEL"
            };
        }
        static{
            this.INDICATORPANEL = {
                type: 3,
                value: "INDICATORPANEL"
            };
        }
        static{
            this.MIMICPANEL = {
                type: 3,
                value: "MIMICPANEL"
            };
        }
        static{
            this.MOTORCONTROLCENTRE = {
                type: 3,
                value: "MOTORCONTROLCENTRE"
            };
        }
        static{
            this.SWITCHBOARD = {
                type: 3,
                value: "SWITCHBOARD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcElectricDistributionPointFunctionEnum = IfcElectricDistributionPointFunctionEnum;
    class IfcElectricFlowStorageDeviceTypeEnum {
        static{
            this.BATTERY = {
                type: 3,
                value: "BATTERY"
            };
        }
        static{
            this.CAPACITORBANK = {
                type: 3,
                value: "CAPACITORBANK"
            };
        }
        static{
            this.HARMONICFILTER = {
                type: 3,
                value: "HARMONICFILTER"
            };
        }
        static{
            this.INDUCTORBANK = {
                type: 3,
                value: "INDUCTORBANK"
            };
        }
        static{
            this.UPS = {
                type: 3,
                value: "UPS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;
    class IfcElectricGeneratorTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;
    class IfcElectricHeaterTypeEnum {
        static{
            this.ELECTRICPOINTHEATER = {
                type: 3,
                value: "ELECTRICPOINTHEATER"
            };
        }
        static{
            this.ELECTRICCABLEHEATER = {
                type: 3,
                value: "ELECTRICCABLEHEATER"
            };
        }
        static{
            this.ELECTRICMATHEATER = {
                type: 3,
                value: "ELECTRICMATHEATER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcElectricHeaterTypeEnum = IfcElectricHeaterTypeEnum;
    class IfcElectricMotorTypeEnum {
        static{
            this.DC = {
                type: 3,
                value: "DC"
            };
        }
        static{
            this.INDUCTION = {
                type: 3,
                value: "INDUCTION"
            };
        }
        static{
            this.POLYPHASE = {
                type: 3,
                value: "POLYPHASE"
            };
        }
        static{
            this.RELUCTANCESYNCHRONOUS = {
                type: 3,
                value: "RELUCTANCESYNCHRONOUS"
            };
        }
        static{
            this.SYNCHRONOUS = {
                type: 3,
                value: "SYNCHRONOUS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;
    class IfcElectricTimeControlTypeEnum {
        static{
            this.TIMECLOCK = {
                type: 3,
                value: "TIMECLOCK"
            };
        }
        static{
            this.TIMEDELAY = {
                type: 3,
                value: "TIMEDELAY"
            };
        }
        static{
            this.RELAY = {
                type: 3,
                value: "RELAY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;
    class IfcElementAssemblyTypeEnum {
        static{
            this.ACCESSORY_ASSEMBLY = {
                type: 3,
                value: "ACCESSORY_ASSEMBLY"
            };
        }
        static{
            this.ARCH = {
                type: 3,
                value: "ARCH"
            };
        }
        static{
            this.BEAM_GRID = {
                type: 3,
                value: "BEAM_GRID"
            };
        }
        static{
            this.BRACED_FRAME = {
                type: 3,
                value: "BRACED_FRAME"
            };
        }
        static{
            this.GIRDER = {
                type: 3,
                value: "GIRDER"
            };
        }
        static{
            this.REINFORCEMENT_UNIT = {
                type: 3,
                value: "REINFORCEMENT_UNIT"
            };
        }
        static{
            this.RIGID_FRAME = {
                type: 3,
                value: "RIGID_FRAME"
            };
        }
        static{
            this.SLAB_FIELD = {
                type: 3,
                value: "SLAB_FIELD"
            };
        }
        static{
            this.TRUSS = {
                type: 3,
                value: "TRUSS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;
    class IfcElementCompositionEnum {
        static{
            this.COMPLEX = {
                type: 3,
                value: "COMPLEX"
            };
        }
        static{
            this.ELEMENT = {
                type: 3,
                value: "ELEMENT"
            };
        }
        static{
            this.PARTIAL = {
                type: 3,
                value: "PARTIAL"
            };
        }
    }
    IFC2X32.IfcElementCompositionEnum = IfcElementCompositionEnum;
    class IfcEnergySequenceEnum {
        static{
            this.PRIMARY = {
                type: 3,
                value: "PRIMARY"
            };
        }
        static{
            this.SECONDARY = {
                type: 3,
                value: "SECONDARY"
            };
        }
        static{
            this.TERTIARY = {
                type: 3,
                value: "TERTIARY"
            };
        }
        static{
            this.AUXILIARY = {
                type: 3,
                value: "AUXILIARY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcEnergySequenceEnum = IfcEnergySequenceEnum;
    class IfcEnvironmentalImpactCategoryEnum {
        static{
            this.COMBINEDVALUE = {
                type: 3,
                value: "COMBINEDVALUE"
            };
        }
        static{
            this.DISPOSAL = {
                type: 3,
                value: "DISPOSAL"
            };
        }
        static{
            this.EXTRACTION = {
                type: 3,
                value: "EXTRACTION"
            };
        }
        static{
            this.INSTALLATION = {
                type: 3,
                value: "INSTALLATION"
            };
        }
        static{
            this.MANUFACTURE = {
                type: 3,
                value: "MANUFACTURE"
            };
        }
        static{
            this.TRANSPORTATION = {
                type: 3,
                value: "TRANSPORTATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcEnvironmentalImpactCategoryEnum = IfcEnvironmentalImpactCategoryEnum;
    class IfcEvaporativeCoolerTypeEnum {
        static{
            this.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVEAIRWASHER = {
                type: 3,
                value: "DIRECTEVAPORATIVEAIRWASHER"
            };
        }
        static{
            this.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = {
                type: 3,
                value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER"
            };
        }
        static{
            this.INDIRECTEVAPORATIVEWETCOIL = {
                type: 3,
                value: "INDIRECTEVAPORATIVEWETCOIL"
            };
        }
        static{
            this.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = {
                type: 3,
                value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER"
            };
        }
        static{
            this.INDIRECTDIRECTCOMBINATION = {
                type: 3,
                value: "INDIRECTDIRECTCOMBINATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;
    class IfcEvaporatorTypeEnum {
        static{
            this.DIRECTEXPANSIONSHELLANDTUBE = {
                type: 3,
                value: "DIRECTEXPANSIONSHELLANDTUBE"
            };
        }
        static{
            this.DIRECTEXPANSIONTUBEINTUBE = {
                type: 3,
                value: "DIRECTEXPANSIONTUBEINTUBE"
            };
        }
        static{
            this.DIRECTEXPANSIONBRAZEDPLATE = {
                type: 3,
                value: "DIRECTEXPANSIONBRAZEDPLATE"
            };
        }
        static{
            this.FLOODEDSHELLANDTUBE = {
                type: 3,
                value: "FLOODEDSHELLANDTUBE"
            };
        }
        static{
            this.SHELLANDCOIL = {
                type: 3,
                value: "SHELLANDCOIL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;
    class IfcFanTypeEnum {
        static{
            this.CENTRIFUGALFORWARDCURVED = {
                type: 3,
                value: "CENTRIFUGALFORWARDCURVED"
            };
        }
        static{
            this.CENTRIFUGALRADIAL = {
                type: 3,
                value: "CENTRIFUGALRADIAL"
            };
        }
        static{
            this.CENTRIFUGALBACKWARDINCLINEDCURVED = {
                type: 3,
                value: "CENTRIFUGALBACKWARDINCLINEDCURVED"
            };
        }
        static{
            this.CENTRIFUGALAIRFOIL = {
                type: 3,
                value: "CENTRIFUGALAIRFOIL"
            };
        }
        static{
            this.TUBEAXIAL = {
                type: 3,
                value: "TUBEAXIAL"
            };
        }
        static{
            this.VANEAXIAL = {
                type: 3,
                value: "VANEAXIAL"
            };
        }
        static{
            this.PROPELLORAXIAL = {
                type: 3,
                value: "PROPELLORAXIAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcFanTypeEnum = IfcFanTypeEnum;
    class IfcFilterTypeEnum {
        static{
            this.AIRPARTICLEFILTER = {
                type: 3,
                value: "AIRPARTICLEFILTER"
            };
        }
        static{
            this.ODORFILTER = {
                type: 3,
                value: "ODORFILTER"
            };
        }
        static{
            this.OILFILTER = {
                type: 3,
                value: "OILFILTER"
            };
        }
        static{
            this.STRAINER = {
                type: 3,
                value: "STRAINER"
            };
        }
        static{
            this.WATERFILTER = {
                type: 3,
                value: "WATERFILTER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcFilterTypeEnum = IfcFilterTypeEnum;
    class IfcFireSuppressionTerminalTypeEnum {
        static{
            this.BREECHINGINLET = {
                type: 3,
                value: "BREECHINGINLET"
            };
        }
        static{
            this.FIREHYDRANT = {
                type: 3,
                value: "FIREHYDRANT"
            };
        }
        static{
            this.HOSEREEL = {
                type: 3,
                value: "HOSEREEL"
            };
        }
        static{
            this.SPRINKLER = {
                type: 3,
                value: "SPRINKLER"
            };
        }
        static{
            this.SPRINKLERDEFLECTOR = {
                type: 3,
                value: "SPRINKLERDEFLECTOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;
    class IfcFlowDirectionEnum {
        static{
            this.SOURCE = {
                type: 3,
                value: "SOURCE"
            };
        }
        static{
            this.SINK = {
                type: 3,
                value: "SINK"
            };
        }
        static{
            this.SOURCEANDSINK = {
                type: 3,
                value: "SOURCEANDSINK"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcFlowDirectionEnum = IfcFlowDirectionEnum;
    class IfcFlowInstrumentTypeEnum {
        static{
            this.PRESSUREGAUGE = {
                type: 3,
                value: "PRESSUREGAUGE"
            };
        }
        static{
            this.THERMOMETER = {
                type: 3,
                value: "THERMOMETER"
            };
        }
        static{
            this.AMMETER = {
                type: 3,
                value: "AMMETER"
            };
        }
        static{
            this.FREQUENCYMETER = {
                type: 3,
                value: "FREQUENCYMETER"
            };
        }
        static{
            this.POWERFACTORMETER = {
                type: 3,
                value: "POWERFACTORMETER"
            };
        }
        static{
            this.PHASEANGLEMETER = {
                type: 3,
                value: "PHASEANGLEMETER"
            };
        }
        static{
            this.VOLTMETER_PEAK = {
                type: 3,
                value: "VOLTMETER_PEAK"
            };
        }
        static{
            this.VOLTMETER_RMS = {
                type: 3,
                value: "VOLTMETER_RMS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;
    class IfcFlowMeterTypeEnum {
        static{
            this.ELECTRICMETER = {
                type: 3,
                value: "ELECTRICMETER"
            };
        }
        static{
            this.ENERGYMETER = {
                type: 3,
                value: "ENERGYMETER"
            };
        }
        static{
            this.FLOWMETER = {
                type: 3,
                value: "FLOWMETER"
            };
        }
        static{
            this.GASMETER = {
                type: 3,
                value: "GASMETER"
            };
        }
        static{
            this.OILMETER = {
                type: 3,
                value: "OILMETER"
            };
        }
        static{
            this.WATERMETER = {
                type: 3,
                value: "WATERMETER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;
    class IfcFootingTypeEnum {
        static{
            this.FOOTING_BEAM = {
                type: 3,
                value: "FOOTING_BEAM"
            };
        }
        static{
            this.PAD_FOOTING = {
                type: 3,
                value: "PAD_FOOTING"
            };
        }
        static{
            this.PILE_CAP = {
                type: 3,
                value: "PILE_CAP"
            };
        }
        static{
            this.STRIP_FOOTING = {
                type: 3,
                value: "STRIP_FOOTING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcFootingTypeEnum = IfcFootingTypeEnum;
    class IfcGasTerminalTypeEnum {
        static{
            this.GASAPPLIANCE = {
                type: 3,
                value: "GASAPPLIANCE"
            };
        }
        static{
            this.GASBOOSTER = {
                type: 3,
                value: "GASBOOSTER"
            };
        }
        static{
            this.GASBURNER = {
                type: 3,
                value: "GASBURNER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcGasTerminalTypeEnum = IfcGasTerminalTypeEnum;
    class IfcGeometricProjectionEnum {
        static{
            this.GRAPH_VIEW = {
                type: 3,
                value: "GRAPH_VIEW"
            };
        }
        static{
            this.SKETCH_VIEW = {
                type: 3,
                value: "SKETCH_VIEW"
            };
        }
        static{
            this.MODEL_VIEW = {
                type: 3,
                value: "MODEL_VIEW"
            };
        }
        static{
            this.PLAN_VIEW = {
                type: 3,
                value: "PLAN_VIEW"
            };
        }
        static{
            this.REFLECTED_PLAN_VIEW = {
                type: 3,
                value: "REFLECTED_PLAN_VIEW"
            };
        }
        static{
            this.SECTION_VIEW = {
                type: 3,
                value: "SECTION_VIEW"
            };
        }
        static{
            this.ELEVATION_VIEW = {
                type: 3,
                value: "ELEVATION_VIEW"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;
    class IfcGlobalOrLocalEnum {
        static{
            this.GLOBAL_COORDS = {
                type: 3,
                value: "GLOBAL_COORDS"
            };
        }
        static{
            this.LOCAL_COORDS = {
                type: 3,
                value: "LOCAL_COORDS"
            };
        }
    }
    IFC2X32.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;
    class IfcHeatExchangerTypeEnum {
        static{
            this.PLATE = {
                type: 3,
                value: "PLATE"
            };
        }
        static{
            this.SHELLANDTUBE = {
                type: 3,
                value: "SHELLANDTUBE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;
    class IfcHumidifierTypeEnum {
        static{
            this.STEAMINJECTION = {
                type: 3,
                value: "STEAMINJECTION"
            };
        }
        static{
            this.ADIABATICAIRWASHER = {
                type: 3,
                value: "ADIABATICAIRWASHER"
            };
        }
        static{
            this.ADIABATICPAN = {
                type: 3,
                value: "ADIABATICPAN"
            };
        }
        static{
            this.ADIABATICWETTEDELEMENT = {
                type: 3,
                value: "ADIABATICWETTEDELEMENT"
            };
        }
        static{
            this.ADIABATICATOMIZING = {
                type: 3,
                value: "ADIABATICATOMIZING"
            };
        }
        static{
            this.ADIABATICULTRASONIC = {
                type: 3,
                value: "ADIABATICULTRASONIC"
            };
        }
        static{
            this.ADIABATICRIGIDMEDIA = {
                type: 3,
                value: "ADIABATICRIGIDMEDIA"
            };
        }
        static{
            this.ADIABATICCOMPRESSEDAIRNOZZLE = {
                type: 3,
                value: "ADIABATICCOMPRESSEDAIRNOZZLE"
            };
        }
        static{
            this.ASSISTEDELECTRIC = {
                type: 3,
                value: "ASSISTEDELECTRIC"
            };
        }
        static{
            this.ASSISTEDNATURALGAS = {
                type: 3,
                value: "ASSISTEDNATURALGAS"
            };
        }
        static{
            this.ASSISTEDPROPANE = {
                type: 3,
                value: "ASSISTEDPROPANE"
            };
        }
        static{
            this.ASSISTEDBUTANE = {
                type: 3,
                value: "ASSISTEDBUTANE"
            };
        }
        static{
            this.ASSISTEDSTEAM = {
                type: 3,
                value: "ASSISTEDSTEAM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;
    class IfcInternalOrExternalEnum {
        static{
            this.INTERNAL = {
                type: 3,
                value: "INTERNAL"
            };
        }
        static{
            this.EXTERNAL = {
                type: 3,
                value: "EXTERNAL"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;
    class IfcInventoryTypeEnum {
        static{
            this.ASSETINVENTORY = {
                type: 3,
                value: "ASSETINVENTORY"
            };
        }
        static{
            this.SPACEINVENTORY = {
                type: 3,
                value: "SPACEINVENTORY"
            };
        }
        static{
            this.FURNITUREINVENTORY = {
                type: 3,
                value: "FURNITUREINVENTORY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcInventoryTypeEnum = IfcInventoryTypeEnum;
    class IfcJunctionBoxTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;
    class IfcLampTypeEnum {
        static{
            this.COMPACTFLUORESCENT = {
                type: 3,
                value: "COMPACTFLUORESCENT"
            };
        }
        static{
            this.FLUORESCENT = {
                type: 3,
                value: "FLUORESCENT"
            };
        }
        static{
            this.HIGHPRESSUREMERCURY = {
                type: 3,
                value: "HIGHPRESSUREMERCURY"
            };
        }
        static{
            this.HIGHPRESSURESODIUM = {
                type: 3,
                value: "HIGHPRESSURESODIUM"
            };
        }
        static{
            this.METALHALIDE = {
                type: 3,
                value: "METALHALIDE"
            };
        }
        static{
            this.TUNGSTENFILAMENT = {
                type: 3,
                value: "TUNGSTENFILAMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcLampTypeEnum = IfcLampTypeEnum;
    class IfcLayerSetDirectionEnum {
        static{
            this.AXIS1 = {
                type: 3,
                value: "AXIS1"
            };
        }
        static{
            this.AXIS2 = {
                type: 3,
                value: "AXIS2"
            };
        }
        static{
            this.AXIS3 = {
                type: 3,
                value: "AXIS3"
            };
        }
    }
    IFC2X32.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;
    class IfcLightDistributionCurveEnum {
        static{
            this.TYPE_A = {
                type: 3,
                value: "TYPE_A"
            };
        }
        static{
            this.TYPE_B = {
                type: 3,
                value: "TYPE_B"
            };
        }
        static{
            this.TYPE_C = {
                type: 3,
                value: "TYPE_C"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;
    class IfcLightEmissionSourceEnum {
        static{
            this.COMPACTFLUORESCENT = {
                type: 3,
                value: "COMPACTFLUORESCENT"
            };
        }
        static{
            this.FLUORESCENT = {
                type: 3,
                value: "FLUORESCENT"
            };
        }
        static{
            this.HIGHPRESSUREMERCURY = {
                type: 3,
                value: "HIGHPRESSUREMERCURY"
            };
        }
        static{
            this.HIGHPRESSURESODIUM = {
                type: 3,
                value: "HIGHPRESSURESODIUM"
            };
        }
        static{
            this.LIGHTEMITTINGDIODE = {
                type: 3,
                value: "LIGHTEMITTINGDIODE"
            };
        }
        static{
            this.LOWPRESSURESODIUM = {
                type: 3,
                value: "LOWPRESSURESODIUM"
            };
        }
        static{
            this.LOWVOLTAGEHALOGEN = {
                type: 3,
                value: "LOWVOLTAGEHALOGEN"
            };
        }
        static{
            this.MAINVOLTAGEHALOGEN = {
                type: 3,
                value: "MAINVOLTAGEHALOGEN"
            };
        }
        static{
            this.METALHALIDE = {
                type: 3,
                value: "METALHALIDE"
            };
        }
        static{
            this.TUNGSTENFILAMENT = {
                type: 3,
                value: "TUNGSTENFILAMENT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;
    class IfcLightFixtureTypeEnum {
        static{
            this.POINTSOURCE = {
                type: 3,
                value: "POINTSOURCE"
            };
        }
        static{
            this.DIRECTIONSOURCE = {
                type: 3,
                value: "DIRECTIONSOURCE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;
    class IfcLoadGroupTypeEnum {
        static{
            this.LOAD_GROUP = {
                type: 3,
                value: "LOAD_GROUP"
            };
        }
        static{
            this.LOAD_CASE = {
                type: 3,
                value: "LOAD_CASE"
            };
        }
        static{
            this.LOAD_COMBINATION_GROUP = {
                type: 3,
                value: "LOAD_COMBINATION_GROUP"
            };
        }
        static{
            this.LOAD_COMBINATION = {
                type: 3,
                value: "LOAD_COMBINATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;
    class IfcLogicalOperatorEnum {
        static{
            this.LOGICALAND = {
                type: 3,
                value: "LOGICALAND"
            };
        }
        static{
            this.LOGICALOR = {
                type: 3,
                value: "LOGICALOR"
            };
        }
    }
    IFC2X32.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;
    class IfcMemberTypeEnum {
        static{
            this.BRACE = {
                type: 3,
                value: "BRACE"
            };
        }
        static{
            this.CHORD = {
                type: 3,
                value: "CHORD"
            };
        }
        static{
            this.COLLAR = {
                type: 3,
                value: "COLLAR"
            };
        }
        static{
            this.MEMBER = {
                type: 3,
                value: "MEMBER"
            };
        }
        static{
            this.MULLION = {
                type: 3,
                value: "MULLION"
            };
        }
        static{
            this.PLATE = {
                type: 3,
                value: "PLATE"
            };
        }
        static{
            this.POST = {
                type: 3,
                value: "POST"
            };
        }
        static{
            this.PURLIN = {
                type: 3,
                value: "PURLIN"
            };
        }
        static{
            this.RAFTER = {
                type: 3,
                value: "RAFTER"
            };
        }
        static{
            this.STRINGER = {
                type: 3,
                value: "STRINGER"
            };
        }
        static{
            this.STRUT = {
                type: 3,
                value: "STRUT"
            };
        }
        static{
            this.STUD = {
                type: 3,
                value: "STUD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcMemberTypeEnum = IfcMemberTypeEnum;
    class IfcMotorConnectionTypeEnum {
        static{
            this.BELTDRIVE = {
                type: 3,
                value: "BELTDRIVE"
            };
        }
        static{
            this.COUPLING = {
                type: 3,
                value: "COUPLING"
            };
        }
        static{
            this.DIRECTDRIVE = {
                type: 3,
                value: "DIRECTDRIVE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;
    class IfcNullStyle {
        static{
            this.NULL = {
                type: 3,
                value: "NULL"
            };
        }
    }
    IFC2X32.IfcNullStyle = IfcNullStyle;
    class IfcObjectTypeEnum {
        static{
            this.PRODUCT = {
                type: 3,
                value: "PRODUCT"
            };
        }
        static{
            this.PROCESS = {
                type: 3,
                value: "PROCESS"
            };
        }
        static{
            this.CONTROL = {
                type: 3,
                value: "CONTROL"
            };
        }
        static{
            this.RESOURCE = {
                type: 3,
                value: "RESOURCE"
            };
        }
        static{
            this.ACTOR = {
                type: 3,
                value: "ACTOR"
            };
        }
        static{
            this.GROUP = {
                type: 3,
                value: "GROUP"
            };
        }
        static{
            this.PROJECT = {
                type: 3,
                value: "PROJECT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcObjectTypeEnum = IfcObjectTypeEnum;
    class IfcObjectiveEnum {
        static{
            this.CODECOMPLIANCE = {
                type: 3,
                value: "CODECOMPLIANCE"
            };
        }
        static{
            this.DESIGNINTENT = {
                type: 3,
                value: "DESIGNINTENT"
            };
        }
        static{
            this.HEALTHANDSAFETY = {
                type: 3,
                value: "HEALTHANDSAFETY"
            };
        }
        static{
            this.REQUIREMENT = {
                type: 3,
                value: "REQUIREMENT"
            };
        }
        static{
            this.SPECIFICATION = {
                type: 3,
                value: "SPECIFICATION"
            };
        }
        static{
            this.TRIGGERCONDITION = {
                type: 3,
                value: "TRIGGERCONDITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcObjectiveEnum = IfcObjectiveEnum;
    class IfcOccupantTypeEnum {
        static{
            this.ASSIGNEE = {
                type: 3,
                value: "ASSIGNEE"
            };
        }
        static{
            this.ASSIGNOR = {
                type: 3,
                value: "ASSIGNOR"
            };
        }
        static{
            this.LESSEE = {
                type: 3,
                value: "LESSEE"
            };
        }
        static{
            this.LESSOR = {
                type: 3,
                value: "LESSOR"
            };
        }
        static{
            this.LETTINGAGENT = {
                type: 3,
                value: "LETTINGAGENT"
            };
        }
        static{
            this.OWNER = {
                type: 3,
                value: "OWNER"
            };
        }
        static{
            this.TENANT = {
                type: 3,
                value: "TENANT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcOccupantTypeEnum = IfcOccupantTypeEnum;
    class IfcOutletTypeEnum {
        static{
            this.AUDIOVISUALOUTLET = {
                type: 3,
                value: "AUDIOVISUALOUTLET"
            };
        }
        static{
            this.COMMUNICATIONSOUTLET = {
                type: 3,
                value: "COMMUNICATIONSOUTLET"
            };
        }
        static{
            this.POWEROUTLET = {
                type: 3,
                value: "POWEROUTLET"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcOutletTypeEnum = IfcOutletTypeEnum;
    class IfcPermeableCoveringOperationEnum {
        static{
            this.GRILL = {
                type: 3,
                value: "GRILL"
            };
        }
        static{
            this.LOUVER = {
                type: 3,
                value: "LOUVER"
            };
        }
        static{
            this.SCREEN = {
                type: 3,
                value: "SCREEN"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;
    class IfcPhysicalOrVirtualEnum {
        static{
            this.PHYSICAL = {
                type: 3,
                value: "PHYSICAL"
            };
        }
        static{
            this.VIRTUAL = {
                type: 3,
                value: "VIRTUAL"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;
    class IfcPileConstructionEnum {
        static{
            this.CAST_IN_PLACE = {
                type: 3,
                value: "CAST_IN_PLACE"
            };
        }
        static{
            this.COMPOSITE = {
                type: 3,
                value: "COMPOSITE"
            };
        }
        static{
            this.PRECAST_CONCRETE = {
                type: 3,
                value: "PRECAST_CONCRETE"
            };
        }
        static{
            this.PREFAB_STEEL = {
                type: 3,
                value: "PREFAB_STEEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcPileConstructionEnum = IfcPileConstructionEnum;
    class IfcPileTypeEnum {
        static{
            this.COHESION = {
                type: 3,
                value: "COHESION"
            };
        }
        static{
            this.FRICTION = {
                type: 3,
                value: "FRICTION"
            };
        }
        static{
            this.SUPPORT = {
                type: 3,
                value: "SUPPORT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcPileTypeEnum = IfcPileTypeEnum;
    class IfcPipeFittingTypeEnum {
        static{
            this.BEND = {
                type: 3,
                value: "BEND"
            };
        }
        static{
            this.CONNECTOR = {
                type: 3,
                value: "CONNECTOR"
            };
        }
        static{
            this.ENTRY = {
                type: 3,
                value: "ENTRY"
            };
        }
        static{
            this.EXIT = {
                type: 3,
                value: "EXIT"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.OBSTRUCTION = {
                type: 3,
                value: "OBSTRUCTION"
            };
        }
        static{
            this.TRANSITION = {
                type: 3,
                value: "TRANSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;
    class IfcPipeSegmentTypeEnum {
        static{
            this.FLEXIBLESEGMENT = {
                type: 3,
                value: "FLEXIBLESEGMENT"
            };
        }
        static{
            this.RIGIDSEGMENT = {
                type: 3,
                value: "RIGIDSEGMENT"
            };
        }
        static{
            this.GUTTER = {
                type: 3,
                value: "GUTTER"
            };
        }
        static{
            this.SPOOL = {
                type: 3,
                value: "SPOOL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;
    class IfcPlateTypeEnum {
        static{
            this.CURTAIN_PANEL = {
                type: 3,
                value: "CURTAIN_PANEL"
            };
        }
        static{
            this.SHEET = {
                type: 3,
                value: "SHEET"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcPlateTypeEnum = IfcPlateTypeEnum;
    class IfcProcedureTypeEnum {
        static{
            this.ADVICE_CAUTION = {
                type: 3,
                value: "ADVICE_CAUTION"
            };
        }
        static{
            this.ADVICE_NOTE = {
                type: 3,
                value: "ADVICE_NOTE"
            };
        }
        static{
            this.ADVICE_WARNING = {
                type: 3,
                value: "ADVICE_WARNING"
            };
        }
        static{
            this.CALIBRATION = {
                type: 3,
                value: "CALIBRATION"
            };
        }
        static{
            this.DIAGNOSTIC = {
                type: 3,
                value: "DIAGNOSTIC"
            };
        }
        static{
            this.SHUTDOWN = {
                type: 3,
                value: "SHUTDOWN"
            };
        }
        static{
            this.STARTUP = {
                type: 3,
                value: "STARTUP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcProcedureTypeEnum = IfcProcedureTypeEnum;
    class IfcProfileTypeEnum {
        static{
            this.CURVE = {
                type: 3,
                value: "CURVE"
            };
        }
        static{
            this.AREA = {
                type: 3,
                value: "AREA"
            };
        }
    }
    IFC2X32.IfcProfileTypeEnum = IfcProfileTypeEnum;
    class IfcProjectOrderRecordTypeEnum {
        static{
            this.CHANGE = {
                type: 3,
                value: "CHANGE"
            };
        }
        static{
            this.MAINTENANCE = {
                type: 3,
                value: "MAINTENANCE"
            };
        }
        static{
            this.MOVE = {
                type: 3,
                value: "MOVE"
            };
        }
        static{
            this.PURCHASE = {
                type: 3,
                value: "PURCHASE"
            };
        }
        static{
            this.WORK = {
                type: 3,
                value: "WORK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcProjectOrderRecordTypeEnum = IfcProjectOrderRecordTypeEnum;
    class IfcProjectOrderTypeEnum {
        static{
            this.CHANGEORDER = {
                type: 3,
                value: "CHANGEORDER"
            };
        }
        static{
            this.MAINTENANCEWORKORDER = {
                type: 3,
                value: "MAINTENANCEWORKORDER"
            };
        }
        static{
            this.MOVEORDER = {
                type: 3,
                value: "MOVEORDER"
            };
        }
        static{
            this.PURCHASEORDER = {
                type: 3,
                value: "PURCHASEORDER"
            };
        }
        static{
            this.WORKORDER = {
                type: 3,
                value: "WORKORDER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;
    class IfcProjectedOrTrueLengthEnum {
        static{
            this.PROJECTED_LENGTH = {
                type: 3,
                value: "PROJECTED_LENGTH"
            };
        }
        static{
            this.TRUE_LENGTH = {
                type: 3,
                value: "TRUE_LENGTH"
            };
        }
    }
    IFC2X32.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;
    class IfcPropertySourceEnum {
        static{
            this.DESIGN = {
                type: 3,
                value: "DESIGN"
            };
        }
        static{
            this.DESIGNMAXIMUM = {
                type: 3,
                value: "DESIGNMAXIMUM"
            };
        }
        static{
            this.DESIGNMINIMUM = {
                type: 3,
                value: "DESIGNMINIMUM"
            };
        }
        static{
            this.SIMULATED = {
                type: 3,
                value: "SIMULATED"
            };
        }
        static{
            this.ASBUILT = {
                type: 3,
                value: "ASBUILT"
            };
        }
        static{
            this.COMMISSIONING = {
                type: 3,
                value: "COMMISSIONING"
            };
        }
        static{
            this.MEASURED = {
                type: 3,
                value: "MEASURED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTKNOWN = {
                type: 3,
                value: "NOTKNOWN"
            };
        }
    }
    IFC2X32.IfcPropertySourceEnum = IfcPropertySourceEnum;
    class IfcProtectiveDeviceTypeEnum {
        static{
            this.FUSEDISCONNECTOR = {
                type: 3,
                value: "FUSEDISCONNECTOR"
            };
        }
        static{
            this.CIRCUITBREAKER = {
                type: 3,
                value: "CIRCUITBREAKER"
            };
        }
        static{
            this.EARTHFAILUREDEVICE = {
                type: 3,
                value: "EARTHFAILUREDEVICE"
            };
        }
        static{
            this.RESIDUALCURRENTCIRCUITBREAKER = {
                type: 3,
                value: "RESIDUALCURRENTCIRCUITBREAKER"
            };
        }
        static{
            this.RESIDUALCURRENTSWITCH = {
                type: 3,
                value: "RESIDUALCURRENTSWITCH"
            };
        }
        static{
            this.VARISTOR = {
                type: 3,
                value: "VARISTOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;
    class IfcPumpTypeEnum {
        static{
            this.CIRCULATOR = {
                type: 3,
                value: "CIRCULATOR"
            };
        }
        static{
            this.ENDSUCTION = {
                type: 3,
                value: "ENDSUCTION"
            };
        }
        static{
            this.SPLITCASE = {
                type: 3,
                value: "SPLITCASE"
            };
        }
        static{
            this.VERTICALINLINE = {
                type: 3,
                value: "VERTICALINLINE"
            };
        }
        static{
            this.VERTICALTURBINE = {
                type: 3,
                value: "VERTICALTURBINE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcPumpTypeEnum = IfcPumpTypeEnum;
    class IfcRailingTypeEnum {
        static{
            this.HANDRAIL = {
                type: 3,
                value: "HANDRAIL"
            };
        }
        static{
            this.GUARDRAIL = {
                type: 3,
                value: "GUARDRAIL"
            };
        }
        static{
            this.BALUSTRADE = {
                type: 3,
                value: "BALUSTRADE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcRailingTypeEnum = IfcRailingTypeEnum;
    class IfcRampFlightTypeEnum {
        static{
            this.STRAIGHT = {
                type: 3,
                value: "STRAIGHT"
            };
        }
        static{
            this.SPIRAL = {
                type: 3,
                value: "SPIRAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;
    class IfcRampTypeEnum {
        static{
            this.STRAIGHT_RUN_RAMP = {
                type: 3,
                value: "STRAIGHT_RUN_RAMP"
            };
        }
        static{
            this.TWO_STRAIGHT_RUN_RAMP = {
                type: 3,
                value: "TWO_STRAIGHT_RUN_RAMP"
            };
        }
        static{
            this.QUARTER_TURN_RAMP = {
                type: 3,
                value: "QUARTER_TURN_RAMP"
            };
        }
        static{
            this.TWO_QUARTER_TURN_RAMP = {
                type: 3,
                value: "TWO_QUARTER_TURN_RAMP"
            };
        }
        static{
            this.HALF_TURN_RAMP = {
                type: 3,
                value: "HALF_TURN_RAMP"
            };
        }
        static{
            this.SPIRAL_RAMP = {
                type: 3,
                value: "SPIRAL_RAMP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcRampTypeEnum = IfcRampTypeEnum;
    class IfcReflectanceMethodEnum {
        static{
            this.BLINN = {
                type: 3,
                value: "BLINN"
            };
        }
        static{
            this.FLAT = {
                type: 3,
                value: "FLAT"
            };
        }
        static{
            this.GLASS = {
                type: 3,
                value: "GLASS"
            };
        }
        static{
            this.MATT = {
                type: 3,
                value: "MATT"
            };
        }
        static{
            this.METAL = {
                type: 3,
                value: "METAL"
            };
        }
        static{
            this.MIRROR = {
                type: 3,
                value: "MIRROR"
            };
        }
        static{
            this.PHONG = {
                type: 3,
                value: "PHONG"
            };
        }
        static{
            this.PLASTIC = {
                type: 3,
                value: "PLASTIC"
            };
        }
        static{
            this.STRAUSS = {
                type: 3,
                value: "STRAUSS"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;
    class IfcReinforcingBarRoleEnum {
        static{
            this.MAIN = {
                type: 3,
                value: "MAIN"
            };
        }
        static{
            this.SHEAR = {
                type: 3,
                value: "SHEAR"
            };
        }
        static{
            this.LIGATURE = {
                type: 3,
                value: "LIGATURE"
            };
        }
        static{
            this.STUD = {
                type: 3,
                value: "STUD"
            };
        }
        static{
            this.PUNCHING = {
                type: 3,
                value: "PUNCHING"
            };
        }
        static{
            this.EDGE = {
                type: 3,
                value: "EDGE"
            };
        }
        static{
            this.RING = {
                type: 3,
                value: "RING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;
    class IfcReinforcingBarSurfaceEnum {
        static{
            this.PLAIN = {
                type: 3,
                value: "PLAIN"
            };
        }
        static{
            this.TEXTURED = {
                type: 3,
                value: "TEXTURED"
            };
        }
    }
    IFC2X32.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;
    class IfcResourceConsumptionEnum {
        static{
            this.CONSUMED = {
                type: 3,
                value: "CONSUMED"
            };
        }
        static{
            this.PARTIALLYCONSUMED = {
                type: 3,
                value: "PARTIALLYCONSUMED"
            };
        }
        static{
            this.NOTCONSUMED = {
                type: 3,
                value: "NOTCONSUMED"
            };
        }
        static{
            this.OCCUPIED = {
                type: 3,
                value: "OCCUPIED"
            };
        }
        static{
            this.PARTIALLYOCCUPIED = {
                type: 3,
                value: "PARTIALLYOCCUPIED"
            };
        }
        static{
            this.NOTOCCUPIED = {
                type: 3,
                value: "NOTOCCUPIED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcResourceConsumptionEnum = IfcResourceConsumptionEnum;
    class IfcRibPlateDirectionEnum {
        static{
            this.DIRECTION_X = {
                type: 3,
                value: "DIRECTION_X"
            };
        }
        static{
            this.DIRECTION_Y = {
                type: 3,
                value: "DIRECTION_Y"
            };
        }
    }
    IFC2X32.IfcRibPlateDirectionEnum = IfcRibPlateDirectionEnum;
    class IfcRoleEnum {
        static{
            this.SUPPLIER = {
                type: 3,
                value: "SUPPLIER"
            };
        }
        static{
            this.MANUFACTURER = {
                type: 3,
                value: "MANUFACTURER"
            };
        }
        static{
            this.CONTRACTOR = {
                type: 3,
                value: "CONTRACTOR"
            };
        }
        static{
            this.SUBCONTRACTOR = {
                type: 3,
                value: "SUBCONTRACTOR"
            };
        }
        static{
            this.ARCHITECT = {
                type: 3,
                value: "ARCHITECT"
            };
        }
        static{
            this.STRUCTURALENGINEER = {
                type: 3,
                value: "STRUCTURALENGINEER"
            };
        }
        static{
            this.COSTENGINEER = {
                type: 3,
                value: "COSTENGINEER"
            };
        }
        static{
            this.CLIENT = {
                type: 3,
                value: "CLIENT"
            };
        }
        static{
            this.BUILDINGOWNER = {
                type: 3,
                value: "BUILDINGOWNER"
            };
        }
        static{
            this.BUILDINGOPERATOR = {
                type: 3,
                value: "BUILDINGOPERATOR"
            };
        }
        static{
            this.MECHANICALENGINEER = {
                type: 3,
                value: "MECHANICALENGINEER"
            };
        }
        static{
            this.ELECTRICALENGINEER = {
                type: 3,
                value: "ELECTRICALENGINEER"
            };
        }
        static{
            this.PROJECTMANAGER = {
                type: 3,
                value: "PROJECTMANAGER"
            };
        }
        static{
            this.FACILITIESMANAGER = {
                type: 3,
                value: "FACILITIESMANAGER"
            };
        }
        static{
            this.CIVILENGINEER = {
                type: 3,
                value: "CIVILENGINEER"
            };
        }
        static{
            this.COMISSIONINGENGINEER = {
                type: 3,
                value: "COMISSIONINGENGINEER"
            };
        }
        static{
            this.ENGINEER = {
                type: 3,
                value: "ENGINEER"
            };
        }
        static{
            this.OWNER = {
                type: 3,
                value: "OWNER"
            };
        }
        static{
            this.CONSULTANT = {
                type: 3,
                value: "CONSULTANT"
            };
        }
        static{
            this.CONSTRUCTIONMANAGER = {
                type: 3,
                value: "CONSTRUCTIONMANAGER"
            };
        }
        static{
            this.FIELDCONSTRUCTIONMANAGER = {
                type: 3,
                value: "FIELDCONSTRUCTIONMANAGER"
            };
        }
        static{
            this.RESELLER = {
                type: 3,
                value: "RESELLER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC2X32.IfcRoleEnum = IfcRoleEnum;
    class IfcRoofTypeEnum {
        static{
            this.FLAT_ROOF = {
                type: 3,
                value: "FLAT_ROOF"
            };
        }
        static{
            this.SHED_ROOF = {
                type: 3,
                value: "SHED_ROOF"
            };
        }
        static{
            this.GABLE_ROOF = {
                type: 3,
                value: "GABLE_ROOF"
            };
        }
        static{
            this.HIP_ROOF = {
                type: 3,
                value: "HIP_ROOF"
            };
        }
        static{
            this.HIPPED_GABLE_ROOF = {
                type: 3,
                value: "HIPPED_GABLE_ROOF"
            };
        }
        static{
            this.GAMBREL_ROOF = {
                type: 3,
                value: "GAMBREL_ROOF"
            };
        }
        static{
            this.MANSARD_ROOF = {
                type: 3,
                value: "MANSARD_ROOF"
            };
        }
        static{
            this.BARREL_ROOF = {
                type: 3,
                value: "BARREL_ROOF"
            };
        }
        static{
            this.RAINBOW_ROOF = {
                type: 3,
                value: "RAINBOW_ROOF"
            };
        }
        static{
            this.BUTTERFLY_ROOF = {
                type: 3,
                value: "BUTTERFLY_ROOF"
            };
        }
        static{
            this.PAVILION_ROOF = {
                type: 3,
                value: "PAVILION_ROOF"
            };
        }
        static{
            this.DOME_ROOF = {
                type: 3,
                value: "DOME_ROOF"
            };
        }
        static{
            this.FREEFORM = {
                type: 3,
                value: "FREEFORM"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcRoofTypeEnum = IfcRoofTypeEnum;
    class IfcSIPrefix {
        static{
            this.EXA = {
                type: 3,
                value: "EXA"
            };
        }
        static{
            this.PETA = {
                type: 3,
                value: "PETA"
            };
        }
        static{
            this.TERA = {
                type: 3,
                value: "TERA"
            };
        }
        static{
            this.GIGA = {
                type: 3,
                value: "GIGA"
            };
        }
        static{
            this.MEGA = {
                type: 3,
                value: "MEGA"
            };
        }
        static{
            this.KILO = {
                type: 3,
                value: "KILO"
            };
        }
        static{
            this.HECTO = {
                type: 3,
                value: "HECTO"
            };
        }
        static{
            this.DECA = {
                type: 3,
                value: "DECA"
            };
        }
        static{
            this.DECI = {
                type: 3,
                value: "DECI"
            };
        }
        static{
            this.CENTI = {
                type: 3,
                value: "CENTI"
            };
        }
        static{
            this.MILLI = {
                type: 3,
                value: "MILLI"
            };
        }
        static{
            this.MICRO = {
                type: 3,
                value: "MICRO"
            };
        }
        static{
            this.NANO = {
                type: 3,
                value: "NANO"
            };
        }
        static{
            this.PICO = {
                type: 3,
                value: "PICO"
            };
        }
        static{
            this.FEMTO = {
                type: 3,
                value: "FEMTO"
            };
        }
        static{
            this.ATTO = {
                type: 3,
                value: "ATTO"
            };
        }
    }
    IFC2X32.IfcSIPrefix = IfcSIPrefix;
    class IfcSIUnitName {
        static{
            this.AMPERE = {
                type: 3,
                value: "AMPERE"
            };
        }
        static{
            this.BECQUEREL = {
                type: 3,
                value: "BECQUEREL"
            };
        }
        static{
            this.CANDELA = {
                type: 3,
                value: "CANDELA"
            };
        }
        static{
            this.COULOMB = {
                type: 3,
                value: "COULOMB"
            };
        }
        static{
            this.CUBIC_METRE = {
                type: 3,
                value: "CUBIC_METRE"
            };
        }
        static{
            this.DEGREE_CELSIUS = {
                type: 3,
                value: "DEGREE_CELSIUS"
            };
        }
        static{
            this.FARAD = {
                type: 3,
                value: "FARAD"
            };
        }
        static{
            this.GRAM = {
                type: 3,
                value: "GRAM"
            };
        }
        static{
            this.GRAY = {
                type: 3,
                value: "GRAY"
            };
        }
        static{
            this.HENRY = {
                type: 3,
                value: "HENRY"
            };
        }
        static{
            this.HERTZ = {
                type: 3,
                value: "HERTZ"
            };
        }
        static{
            this.JOULE = {
                type: 3,
                value: "JOULE"
            };
        }
        static{
            this.KELVIN = {
                type: 3,
                value: "KELVIN"
            };
        }
        static{
            this.LUMEN = {
                type: 3,
                value: "LUMEN"
            };
        }
        static{
            this.LUX = {
                type: 3,
                value: "LUX"
            };
        }
        static{
            this.METRE = {
                type: 3,
                value: "METRE"
            };
        }
        static{
            this.MOLE = {
                type: 3,
                value: "MOLE"
            };
        }
        static{
            this.NEWTON = {
                type: 3,
                value: "NEWTON"
            };
        }
        static{
            this.OHM = {
                type: 3,
                value: "OHM"
            };
        }
        static{
            this.PASCAL = {
                type: 3,
                value: "PASCAL"
            };
        }
        static{
            this.RADIAN = {
                type: 3,
                value: "RADIAN"
            };
        }
        static{
            this.SECOND = {
                type: 3,
                value: "SECOND"
            };
        }
        static{
            this.SIEMENS = {
                type: 3,
                value: "SIEMENS"
            };
        }
        static{
            this.SIEVERT = {
                type: 3,
                value: "SIEVERT"
            };
        }
        static{
            this.SQUARE_METRE = {
                type: 3,
                value: "SQUARE_METRE"
            };
        }
        static{
            this.STERADIAN = {
                type: 3,
                value: "STERADIAN"
            };
        }
        static{
            this.TESLA = {
                type: 3,
                value: "TESLA"
            };
        }
        static{
            this.VOLT = {
                type: 3,
                value: "VOLT"
            };
        }
        static{
            this.WATT = {
                type: 3,
                value: "WATT"
            };
        }
        static{
            this.WEBER = {
                type: 3,
                value: "WEBER"
            };
        }
    }
    IFC2X32.IfcSIUnitName = IfcSIUnitName;
    class IfcSanitaryTerminalTypeEnum {
        static{
            this.BATH = {
                type: 3,
                value: "BATH"
            };
        }
        static{
            this.BIDET = {
                type: 3,
                value: "BIDET"
            };
        }
        static{
            this.CISTERN = {
                type: 3,
                value: "CISTERN"
            };
        }
        static{
            this.SHOWER = {
                type: 3,
                value: "SHOWER"
            };
        }
        static{
            this.SINK = {
                type: 3,
                value: "SINK"
            };
        }
        static{
            this.SANITARYFOUNTAIN = {
                type: 3,
                value: "SANITARYFOUNTAIN"
            };
        }
        static{
            this.TOILETPAN = {
                type: 3,
                value: "TOILETPAN"
            };
        }
        static{
            this.URINAL = {
                type: 3,
                value: "URINAL"
            };
        }
        static{
            this.WASHHANDBASIN = {
                type: 3,
                value: "WASHHANDBASIN"
            };
        }
        static{
            this.WCSEAT = {
                type: 3,
                value: "WCSEAT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;
    class IfcSectionTypeEnum {
        static{
            this.UNIFORM = {
                type: 3,
                value: "UNIFORM"
            };
        }
        static{
            this.TAPERED = {
                type: 3,
                value: "TAPERED"
            };
        }
    }
    IFC2X32.IfcSectionTypeEnum = IfcSectionTypeEnum;
    class IfcSensorTypeEnum {
        static{
            this.CO2SENSOR = {
                type: 3,
                value: "CO2SENSOR"
            };
        }
        static{
            this.FIRESENSOR = {
                type: 3,
                value: "FIRESENSOR"
            };
        }
        static{
            this.FLOWSENSOR = {
                type: 3,
                value: "FLOWSENSOR"
            };
        }
        static{
            this.GASSENSOR = {
                type: 3,
                value: "GASSENSOR"
            };
        }
        static{
            this.HEATSENSOR = {
                type: 3,
                value: "HEATSENSOR"
            };
        }
        static{
            this.HUMIDITYSENSOR = {
                type: 3,
                value: "HUMIDITYSENSOR"
            };
        }
        static{
            this.LIGHTSENSOR = {
                type: 3,
                value: "LIGHTSENSOR"
            };
        }
        static{
            this.MOISTURESENSOR = {
                type: 3,
                value: "MOISTURESENSOR"
            };
        }
        static{
            this.MOVEMENTSENSOR = {
                type: 3,
                value: "MOVEMENTSENSOR"
            };
        }
        static{
            this.PRESSURESENSOR = {
                type: 3,
                value: "PRESSURESENSOR"
            };
        }
        static{
            this.SMOKESENSOR = {
                type: 3,
                value: "SMOKESENSOR"
            };
        }
        static{
            this.SOUNDSENSOR = {
                type: 3,
                value: "SOUNDSENSOR"
            };
        }
        static{
            this.TEMPERATURESENSOR = {
                type: 3,
                value: "TEMPERATURESENSOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcSensorTypeEnum = IfcSensorTypeEnum;
    class IfcSequenceEnum {
        static{
            this.START_START = {
                type: 3,
                value: "START_START"
            };
        }
        static{
            this.START_FINISH = {
                type: 3,
                value: "START_FINISH"
            };
        }
        static{
            this.FINISH_START = {
                type: 3,
                value: "FINISH_START"
            };
        }
        static{
            this.FINISH_FINISH = {
                type: 3,
                value: "FINISH_FINISH"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcSequenceEnum = IfcSequenceEnum;
    class IfcServiceLifeFactorTypeEnum {
        static{
            this.A_QUALITYOFCOMPONENTS = {
                type: 3,
                value: "A_QUALITYOFCOMPONENTS"
            };
        }
        static{
            this.B_DESIGNLEVEL = {
                type: 3,
                value: "B_DESIGNLEVEL"
            };
        }
        static{
            this.C_WORKEXECUTIONLEVEL = {
                type: 3,
                value: "C_WORKEXECUTIONLEVEL"
            };
        }
        static{
            this.D_INDOORENVIRONMENT = {
                type: 3,
                value: "D_INDOORENVIRONMENT"
            };
        }
        static{
            this.E_OUTDOORENVIRONMENT = {
                type: 3,
                value: "E_OUTDOORENVIRONMENT"
            };
        }
        static{
            this.F_INUSECONDITIONS = {
                type: 3,
                value: "F_INUSECONDITIONS"
            };
        }
        static{
            this.G_MAINTENANCELEVEL = {
                type: 3,
                value: "G_MAINTENANCELEVEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcServiceLifeFactorTypeEnum = IfcServiceLifeFactorTypeEnum;
    class IfcServiceLifeTypeEnum {
        static{
            this.ACTUALSERVICELIFE = {
                type: 3,
                value: "ACTUALSERVICELIFE"
            };
        }
        static{
            this.EXPECTEDSERVICELIFE = {
                type: 3,
                value: "EXPECTEDSERVICELIFE"
            };
        }
        static{
            this.OPTIMISTICREFERENCESERVICELIFE = {
                type: 3,
                value: "OPTIMISTICREFERENCESERVICELIFE"
            };
        }
        static{
            this.PESSIMISTICREFERENCESERVICELIFE = {
                type: 3,
                value: "PESSIMISTICREFERENCESERVICELIFE"
            };
        }
        static{
            this.REFERENCESERVICELIFE = {
                type: 3,
                value: "REFERENCESERVICELIFE"
            };
        }
    }
    IFC2X32.IfcServiceLifeTypeEnum = IfcServiceLifeTypeEnum;
    class IfcSlabTypeEnum {
        static{
            this.FLOOR = {
                type: 3,
                value: "FLOOR"
            };
        }
        static{
            this.ROOF = {
                type: 3,
                value: "ROOF"
            };
        }
        static{
            this.LANDING = {
                type: 3,
                value: "LANDING"
            };
        }
        static{
            this.BASESLAB = {
                type: 3,
                value: "BASESLAB"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcSlabTypeEnum = IfcSlabTypeEnum;
    class IfcSoundScaleEnum {
        static{
            this.DBA = {
                type: 3,
                value: "DBA"
            };
        }
        static{
            this.DBB = {
                type: 3,
                value: "DBB"
            };
        }
        static{
            this.DBC = {
                type: 3,
                value: "DBC"
            };
        }
        static{
            this.NC = {
                type: 3,
                value: "NC"
            };
        }
        static{
            this.NR = {
                type: 3,
                value: "NR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcSoundScaleEnum = IfcSoundScaleEnum;
    class IfcSpaceHeaterTypeEnum {
        static{
            this.SECTIONALRADIATOR = {
                type: 3,
                value: "SECTIONALRADIATOR"
            };
        }
        static{
            this.PANELRADIATOR = {
                type: 3,
                value: "PANELRADIATOR"
            };
        }
        static{
            this.TUBULARRADIATOR = {
                type: 3,
                value: "TUBULARRADIATOR"
            };
        }
        static{
            this.CONVECTOR = {
                type: 3,
                value: "CONVECTOR"
            };
        }
        static{
            this.BASEBOARDHEATER = {
                type: 3,
                value: "BASEBOARDHEATER"
            };
        }
        static{
            this.FINNEDTUBEUNIT = {
                type: 3,
                value: "FINNEDTUBEUNIT"
            };
        }
        static{
            this.UNITHEATER = {
                type: 3,
                value: "UNITHEATER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;
    class IfcSpaceTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcSpaceTypeEnum = IfcSpaceTypeEnum;
    class IfcStackTerminalTypeEnum {
        static{
            this.BIRDCAGE = {
                type: 3,
                value: "BIRDCAGE"
            };
        }
        static{
            this.COWL = {
                type: 3,
                value: "COWL"
            };
        }
        static{
            this.RAINWATERHOPPER = {
                type: 3,
                value: "RAINWATERHOPPER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;
    class IfcStairFlightTypeEnum {
        static{
            this.STRAIGHT = {
                type: 3,
                value: "STRAIGHT"
            };
        }
        static{
            this.WINDER = {
                type: 3,
                value: "WINDER"
            };
        }
        static{
            this.SPIRAL = {
                type: 3,
                value: "SPIRAL"
            };
        }
        static{
            this.CURVED = {
                type: 3,
                value: "CURVED"
            };
        }
        static{
            this.FREEFORM = {
                type: 3,
                value: "FREEFORM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;
    class IfcStairTypeEnum {
        static{
            this.STRAIGHT_RUN_STAIR = {
                type: 3,
                value: "STRAIGHT_RUN_STAIR"
            };
        }
        static{
            this.TWO_STRAIGHT_RUN_STAIR = {
                type: 3,
                value: "TWO_STRAIGHT_RUN_STAIR"
            };
        }
        static{
            this.QUARTER_WINDING_STAIR = {
                type: 3,
                value: "QUARTER_WINDING_STAIR"
            };
        }
        static{
            this.QUARTER_TURN_STAIR = {
                type: 3,
                value: "QUARTER_TURN_STAIR"
            };
        }
        static{
            this.HALF_WINDING_STAIR = {
                type: 3,
                value: "HALF_WINDING_STAIR"
            };
        }
        static{
            this.HALF_TURN_STAIR = {
                type: 3,
                value: "HALF_TURN_STAIR"
            };
        }
        static{
            this.TWO_QUARTER_WINDING_STAIR = {
                type: 3,
                value: "TWO_QUARTER_WINDING_STAIR"
            };
        }
        static{
            this.TWO_QUARTER_TURN_STAIR = {
                type: 3,
                value: "TWO_QUARTER_TURN_STAIR"
            };
        }
        static{
            this.THREE_QUARTER_WINDING_STAIR = {
                type: 3,
                value: "THREE_QUARTER_WINDING_STAIR"
            };
        }
        static{
            this.THREE_QUARTER_TURN_STAIR = {
                type: 3,
                value: "THREE_QUARTER_TURN_STAIR"
            };
        }
        static{
            this.SPIRAL_STAIR = {
                type: 3,
                value: "SPIRAL_STAIR"
            };
        }
        static{
            this.DOUBLE_RETURN_STAIR = {
                type: 3,
                value: "DOUBLE_RETURN_STAIR"
            };
        }
        static{
            this.CURVED_RUN_STAIR = {
                type: 3,
                value: "CURVED_RUN_STAIR"
            };
        }
        static{
            this.TWO_CURVED_RUN_STAIR = {
                type: 3,
                value: "TWO_CURVED_RUN_STAIR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcStairTypeEnum = IfcStairTypeEnum;
    class IfcStateEnum {
        static{
            this.READWRITE = {
                type: 3,
                value: "READWRITE"
            };
        }
        static{
            this.READONLY = {
                type: 3,
                value: "READONLY"
            };
        }
        static{
            this.LOCKED = {
                type: 3,
                value: "LOCKED"
            };
        }
        static{
            this.READWRITELOCKED = {
                type: 3,
                value: "READWRITELOCKED"
            };
        }
        static{
            this.READONLYLOCKED = {
                type: 3,
                value: "READONLYLOCKED"
            };
        }
    }
    IFC2X32.IfcStateEnum = IfcStateEnum;
    class IfcStructuralCurveTypeEnum {
        static{
            this.RIGID_JOINED_MEMBER = {
                type: 3,
                value: "RIGID_JOINED_MEMBER"
            };
        }
        static{
            this.PIN_JOINED_MEMBER = {
                type: 3,
                value: "PIN_JOINED_MEMBER"
            };
        }
        static{
            this.CABLE = {
                type: 3,
                value: "CABLE"
            };
        }
        static{
            this.TENSION_MEMBER = {
                type: 3,
                value: "TENSION_MEMBER"
            };
        }
        static{
            this.COMPRESSION_MEMBER = {
                type: 3,
                value: "COMPRESSION_MEMBER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcStructuralCurveTypeEnum = IfcStructuralCurveTypeEnum;
    class IfcStructuralSurfaceTypeEnum {
        static{
            this.BENDING_ELEMENT = {
                type: 3,
                value: "BENDING_ELEMENT"
            };
        }
        static{
            this.MEMBRANE_ELEMENT = {
                type: 3,
                value: "MEMBRANE_ELEMENT"
            };
        }
        static{
            this.SHELL = {
                type: 3,
                value: "SHELL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcStructuralSurfaceTypeEnum = IfcStructuralSurfaceTypeEnum;
    class IfcSurfaceSide {
        static{
            this.POSITIVE = {
                type: 3,
                value: "POSITIVE"
            };
        }
        static{
            this.NEGATIVE = {
                type: 3,
                value: "NEGATIVE"
            };
        }
        static{
            this.BOTH = {
                type: 3,
                value: "BOTH"
            };
        }
    }
    IFC2X32.IfcSurfaceSide = IfcSurfaceSide;
    class IfcSurfaceTextureEnum {
        static{
            this.BUMP = {
                type: 3,
                value: "BUMP"
            };
        }
        static{
            this.OPACITY = {
                type: 3,
                value: "OPACITY"
            };
        }
        static{
            this.REFLECTION = {
                type: 3,
                value: "REFLECTION"
            };
        }
        static{
            this.SELFILLUMINATION = {
                type: 3,
                value: "SELFILLUMINATION"
            };
        }
        static{
            this.SHININESS = {
                type: 3,
                value: "SHININESS"
            };
        }
        static{
            this.SPECULAR = {
                type: 3,
                value: "SPECULAR"
            };
        }
        static{
            this.TEXTURE = {
                type: 3,
                value: "TEXTURE"
            };
        }
        static{
            this.TRANSPARENCYMAP = {
                type: 3,
                value: "TRANSPARENCYMAP"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcSurfaceTextureEnum = IfcSurfaceTextureEnum;
    class IfcSwitchingDeviceTypeEnum {
        static{
            this.CONTACTOR = {
                type: 3,
                value: "CONTACTOR"
            };
        }
        static{
            this.EMERGENCYSTOP = {
                type: 3,
                value: "EMERGENCYSTOP"
            };
        }
        static{
            this.STARTER = {
                type: 3,
                value: "STARTER"
            };
        }
        static{
            this.SWITCHDISCONNECTOR = {
                type: 3,
                value: "SWITCHDISCONNECTOR"
            };
        }
        static{
            this.TOGGLESWITCH = {
                type: 3,
                value: "TOGGLESWITCH"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;
    class IfcTankTypeEnum {
        static{
            this.PREFORMED = {
                type: 3,
                value: "PREFORMED"
            };
        }
        static{
            this.SECTIONAL = {
                type: 3,
                value: "SECTIONAL"
            };
        }
        static{
            this.EXPANSION = {
                type: 3,
                value: "EXPANSION"
            };
        }
        static{
            this.PRESSUREVESSEL = {
                type: 3,
                value: "PRESSUREVESSEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcTankTypeEnum = IfcTankTypeEnum;
    class IfcTendonTypeEnum {
        static{
            this.STRAND = {
                type: 3,
                value: "STRAND"
            };
        }
        static{
            this.WIRE = {
                type: 3,
                value: "WIRE"
            };
        }
        static{
            this.BAR = {
                type: 3,
                value: "BAR"
            };
        }
        static{
            this.COATED = {
                type: 3,
                value: "COATED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcTendonTypeEnum = IfcTendonTypeEnum;
    class IfcTextPath {
        static{
            this.LEFT = {
                type: 3,
                value: "LEFT"
            };
        }
        static{
            this.RIGHT = {
                type: 3,
                value: "RIGHT"
            };
        }
        static{
            this.UP = {
                type: 3,
                value: "UP"
            };
        }
        static{
            this.DOWN = {
                type: 3,
                value: "DOWN"
            };
        }
    }
    IFC2X32.IfcTextPath = IfcTextPath;
    class IfcThermalLoadSourceEnum {
        static{
            this.PEOPLE = {
                type: 3,
                value: "PEOPLE"
            };
        }
        static{
            this.LIGHTING = {
                type: 3,
                value: "LIGHTING"
            };
        }
        static{
            this.EQUIPMENT = {
                type: 3,
                value: "EQUIPMENT"
            };
        }
        static{
            this.VENTILATIONINDOORAIR = {
                type: 3,
                value: "VENTILATIONINDOORAIR"
            };
        }
        static{
            this.VENTILATIONOUTSIDEAIR = {
                type: 3,
                value: "VENTILATIONOUTSIDEAIR"
            };
        }
        static{
            this.RECIRCULATEDAIR = {
                type: 3,
                value: "RECIRCULATEDAIR"
            };
        }
        static{
            this.EXHAUSTAIR = {
                type: 3,
                value: "EXHAUSTAIR"
            };
        }
        static{
            this.AIREXCHANGERATE = {
                type: 3,
                value: "AIREXCHANGERATE"
            };
        }
        static{
            this.DRYBULBTEMPERATURE = {
                type: 3,
                value: "DRYBULBTEMPERATURE"
            };
        }
        static{
            this.RELATIVEHUMIDITY = {
                type: 3,
                value: "RELATIVEHUMIDITY"
            };
        }
        static{
            this.INFILTRATION = {
                type: 3,
                value: "INFILTRATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcThermalLoadSourceEnum = IfcThermalLoadSourceEnum;
    class IfcThermalLoadTypeEnum {
        static{
            this.SENSIBLE = {
                type: 3,
                value: "SENSIBLE"
            };
        }
        static{
            this.LATENT = {
                type: 3,
                value: "LATENT"
            };
        }
        static{
            this.RADIANT = {
                type: 3,
                value: "RADIANT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcThermalLoadTypeEnum = IfcThermalLoadTypeEnum;
    class IfcTimeSeriesDataTypeEnum {
        static{
            this.CONTINUOUS = {
                type: 3,
                value: "CONTINUOUS"
            };
        }
        static{
            this.DISCRETE = {
                type: 3,
                value: "DISCRETE"
            };
        }
        static{
            this.DISCRETEBINARY = {
                type: 3,
                value: "DISCRETEBINARY"
            };
        }
        static{
            this.PIECEWISEBINARY = {
                type: 3,
                value: "PIECEWISEBINARY"
            };
        }
        static{
            this.PIECEWISECONSTANT = {
                type: 3,
                value: "PIECEWISECONSTANT"
            };
        }
        static{
            this.PIECEWISECONTINUOUS = {
                type: 3,
                value: "PIECEWISECONTINUOUS"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;
    class IfcTimeSeriesScheduleTypeEnum {
        static{
            this.ANNUAL = {
                type: 3,
                value: "ANNUAL"
            };
        }
        static{
            this.MONTHLY = {
                type: 3,
                value: "MONTHLY"
            };
        }
        static{
            this.WEEKLY = {
                type: 3,
                value: "WEEKLY"
            };
        }
        static{
            this.DAILY = {
                type: 3,
                value: "DAILY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcTimeSeriesScheduleTypeEnum = IfcTimeSeriesScheduleTypeEnum;
    class IfcTransformerTypeEnum {
        static{
            this.CURRENT = {
                type: 3,
                value: "CURRENT"
            };
        }
        static{
            this.FREQUENCY = {
                type: 3,
                value: "FREQUENCY"
            };
        }
        static{
            this.VOLTAGE = {
                type: 3,
                value: "VOLTAGE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcTransformerTypeEnum = IfcTransformerTypeEnum;
    class IfcTransitionCode {
        static{
            this.DISCONTINUOUS = {
                type: 3,
                value: "DISCONTINUOUS"
            };
        }
        static{
            this.CONTINUOUS = {
                type: 3,
                value: "CONTINUOUS"
            };
        }
        static{
            this.CONTSAMEGRADIENT = {
                type: 3,
                value: "CONTSAMEGRADIENT"
            };
        }
        static{
            this.CONTSAMEGRADIENTSAMECURVATURE = {
                type: 3,
                value: "CONTSAMEGRADIENTSAMECURVATURE"
            };
        }
    }
    IFC2X32.IfcTransitionCode = IfcTransitionCode;
    class IfcTransportElementTypeEnum {
        static{
            this.ELEVATOR = {
                type: 3,
                value: "ELEVATOR"
            };
        }
        static{
            this.ESCALATOR = {
                type: 3,
                value: "ESCALATOR"
            };
        }
        static{
            this.MOVINGWALKWAY = {
                type: 3,
                value: "MOVINGWALKWAY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;
    class IfcTrimmingPreference {
        static{
            this.CARTESIAN = {
                type: 3,
                value: "CARTESIAN"
            };
        }
        static{
            this.PARAMETER = {
                type: 3,
                value: "PARAMETER"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC2X32.IfcTrimmingPreference = IfcTrimmingPreference;
    class IfcTubeBundleTypeEnum {
        static{
            this.FINNED = {
                type: 3,
                value: "FINNED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;
    class IfcUnitEnum {
        static{
            this.ABSORBEDDOSEUNIT = {
                type: 3,
                value: "ABSORBEDDOSEUNIT"
            };
        }
        static{
            this.AMOUNTOFSUBSTANCEUNIT = {
                type: 3,
                value: "AMOUNTOFSUBSTANCEUNIT"
            };
        }
        static{
            this.AREAUNIT = {
                type: 3,
                value: "AREAUNIT"
            };
        }
        static{
            this.DOSEEQUIVALENTUNIT = {
                type: 3,
                value: "DOSEEQUIVALENTUNIT"
            };
        }
        static{
            this.ELECTRICCAPACITANCEUNIT = {
                type: 3,
                value: "ELECTRICCAPACITANCEUNIT"
            };
        }
        static{
            this.ELECTRICCHARGEUNIT = {
                type: 3,
                value: "ELECTRICCHARGEUNIT"
            };
        }
        static{
            this.ELECTRICCONDUCTANCEUNIT = {
                type: 3,
                value: "ELECTRICCONDUCTANCEUNIT"
            };
        }
        static{
            this.ELECTRICCURRENTUNIT = {
                type: 3,
                value: "ELECTRICCURRENTUNIT"
            };
        }
        static{
            this.ELECTRICRESISTANCEUNIT = {
                type: 3,
                value: "ELECTRICRESISTANCEUNIT"
            };
        }
        static{
            this.ELECTRICVOLTAGEUNIT = {
                type: 3,
                value: "ELECTRICVOLTAGEUNIT"
            };
        }
        static{
            this.ENERGYUNIT = {
                type: 3,
                value: "ENERGYUNIT"
            };
        }
        static{
            this.FORCEUNIT = {
                type: 3,
                value: "FORCEUNIT"
            };
        }
        static{
            this.FREQUENCYUNIT = {
                type: 3,
                value: "FREQUENCYUNIT"
            };
        }
        static{
            this.ILLUMINANCEUNIT = {
                type: 3,
                value: "ILLUMINANCEUNIT"
            };
        }
        static{
            this.INDUCTANCEUNIT = {
                type: 3,
                value: "INDUCTANCEUNIT"
            };
        }
        static{
            this.LENGTHUNIT = {
                type: 3,
                value: "LENGTHUNIT"
            };
        }
        static{
            this.LUMINOUSFLUXUNIT = {
                type: 3,
                value: "LUMINOUSFLUXUNIT"
            };
        }
        static{
            this.LUMINOUSINTENSITYUNIT = {
                type: 3,
                value: "LUMINOUSINTENSITYUNIT"
            };
        }
        static{
            this.MAGNETICFLUXDENSITYUNIT = {
                type: 3,
                value: "MAGNETICFLUXDENSITYUNIT"
            };
        }
        static{
            this.MAGNETICFLUXUNIT = {
                type: 3,
                value: "MAGNETICFLUXUNIT"
            };
        }
        static{
            this.MASSUNIT = {
                type: 3,
                value: "MASSUNIT"
            };
        }
        static{
            this.PLANEANGLEUNIT = {
                type: 3,
                value: "PLANEANGLEUNIT"
            };
        }
        static{
            this.POWERUNIT = {
                type: 3,
                value: "POWERUNIT"
            };
        }
        static{
            this.PRESSUREUNIT = {
                type: 3,
                value: "PRESSUREUNIT"
            };
        }
        static{
            this.RADIOACTIVITYUNIT = {
                type: 3,
                value: "RADIOACTIVITYUNIT"
            };
        }
        static{
            this.SOLIDANGLEUNIT = {
                type: 3,
                value: "SOLIDANGLEUNIT"
            };
        }
        static{
            this.THERMODYNAMICTEMPERATUREUNIT = {
                type: 3,
                value: "THERMODYNAMICTEMPERATUREUNIT"
            };
        }
        static{
            this.TIMEUNIT = {
                type: 3,
                value: "TIMEUNIT"
            };
        }
        static{
            this.VOLUMEUNIT = {
                type: 3,
                value: "VOLUMEUNIT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC2X32.IfcUnitEnum = IfcUnitEnum;
    class IfcUnitaryEquipmentTypeEnum {
        static{
            this.AIRHANDLER = {
                type: 3,
                value: "AIRHANDLER"
            };
        }
        static{
            this.AIRCONDITIONINGUNIT = {
                type: 3,
                value: "AIRCONDITIONINGUNIT"
            };
        }
        static{
            this.SPLITSYSTEM = {
                type: 3,
                value: "SPLITSYSTEM"
            };
        }
        static{
            this.ROOFTOPUNIT = {
                type: 3,
                value: "ROOFTOPUNIT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;
    class IfcValveTypeEnum {
        static{
            this.AIRRELEASE = {
                type: 3,
                value: "AIRRELEASE"
            };
        }
        static{
            this.ANTIVACUUM = {
                type: 3,
                value: "ANTIVACUUM"
            };
        }
        static{
            this.CHANGEOVER = {
                type: 3,
                value: "CHANGEOVER"
            };
        }
        static{
            this.CHECK = {
                type: 3,
                value: "CHECK"
            };
        }
        static{
            this.COMMISSIONING = {
                type: 3,
                value: "COMMISSIONING"
            };
        }
        static{
            this.DIVERTING = {
                type: 3,
                value: "DIVERTING"
            };
        }
        static{
            this.DRAWOFFCOCK = {
                type: 3,
                value: "DRAWOFFCOCK"
            };
        }
        static{
            this.DOUBLECHECK = {
                type: 3,
                value: "DOUBLECHECK"
            };
        }
        static{
            this.DOUBLEREGULATING = {
                type: 3,
                value: "DOUBLEREGULATING"
            };
        }
        static{
            this.FAUCET = {
                type: 3,
                value: "FAUCET"
            };
        }
        static{
            this.FLUSHING = {
                type: 3,
                value: "FLUSHING"
            };
        }
        static{
            this.GASCOCK = {
                type: 3,
                value: "GASCOCK"
            };
        }
        static{
            this.GASTAP = {
                type: 3,
                value: "GASTAP"
            };
        }
        static{
            this.ISOLATING = {
                type: 3,
                value: "ISOLATING"
            };
        }
        static{
            this.MIXING = {
                type: 3,
                value: "MIXING"
            };
        }
        static{
            this.PRESSUREREDUCING = {
                type: 3,
                value: "PRESSUREREDUCING"
            };
        }
        static{
            this.PRESSURERELIEF = {
                type: 3,
                value: "PRESSURERELIEF"
            };
        }
        static{
            this.REGULATING = {
                type: 3,
                value: "REGULATING"
            };
        }
        static{
            this.SAFETYCUTOFF = {
                type: 3,
                value: "SAFETYCUTOFF"
            };
        }
        static{
            this.STEAMTRAP = {
                type: 3,
                value: "STEAMTRAP"
            };
        }
        static{
            this.STOPCOCK = {
                type: 3,
                value: "STOPCOCK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcValveTypeEnum = IfcValveTypeEnum;
    class IfcVibrationIsolatorTypeEnum {
        static{
            this.COMPRESSION = {
                type: 3,
                value: "COMPRESSION"
            };
        }
        static{
            this.SPRING = {
                type: 3,
                value: "SPRING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;
    class IfcWallTypeEnum {
        static{
            this.STANDARD = {
                type: 3,
                value: "STANDARD"
            };
        }
        static{
            this.POLYGONAL = {
                type: 3,
                value: "POLYGONAL"
            };
        }
        static{
            this.SHEAR = {
                type: 3,
                value: "SHEAR"
            };
        }
        static{
            this.ELEMENTEDWALL = {
                type: 3,
                value: "ELEMENTEDWALL"
            };
        }
        static{
            this.PLUMBINGWALL = {
                type: 3,
                value: "PLUMBINGWALL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcWallTypeEnum = IfcWallTypeEnum;
    class IfcWasteTerminalTypeEnum {
        static{
            this.FLOORTRAP = {
                type: 3,
                value: "FLOORTRAP"
            };
        }
        static{
            this.FLOORWASTE = {
                type: 3,
                value: "FLOORWASTE"
            };
        }
        static{
            this.GULLYSUMP = {
                type: 3,
                value: "GULLYSUMP"
            };
        }
        static{
            this.GULLYTRAP = {
                type: 3,
                value: "GULLYTRAP"
            };
        }
        static{
            this.GREASEINTERCEPTOR = {
                type: 3,
                value: "GREASEINTERCEPTOR"
            };
        }
        static{
            this.OILINTERCEPTOR = {
                type: 3,
                value: "OILINTERCEPTOR"
            };
        }
        static{
            this.PETROLINTERCEPTOR = {
                type: 3,
                value: "PETROLINTERCEPTOR"
            };
        }
        static{
            this.ROOFDRAIN = {
                type: 3,
                value: "ROOFDRAIN"
            };
        }
        static{
            this.WASTEDISPOSALUNIT = {
                type: 3,
                value: "WASTEDISPOSALUNIT"
            };
        }
        static{
            this.WASTETRAP = {
                type: 3,
                value: "WASTETRAP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;
    class IfcWindowPanelOperationEnum {
        static{
            this.SIDEHUNGRIGHTHAND = {
                type: 3,
                value: "SIDEHUNGRIGHTHAND"
            };
        }
        static{
            this.SIDEHUNGLEFTHAND = {
                type: 3,
                value: "SIDEHUNGLEFTHAND"
            };
        }
        static{
            this.TILTANDTURNRIGHTHAND = {
                type: 3,
                value: "TILTANDTURNRIGHTHAND"
            };
        }
        static{
            this.TILTANDTURNLEFTHAND = {
                type: 3,
                value: "TILTANDTURNLEFTHAND"
            };
        }
        static{
            this.TOPHUNG = {
                type: 3,
                value: "TOPHUNG"
            };
        }
        static{
            this.BOTTOMHUNG = {
                type: 3,
                value: "BOTTOMHUNG"
            };
        }
        static{
            this.PIVOTHORIZONTAL = {
                type: 3,
                value: "PIVOTHORIZONTAL"
            };
        }
        static{
            this.PIVOTVERTICAL = {
                type: 3,
                value: "PIVOTVERTICAL"
            };
        }
        static{
            this.SLIDINGHORIZONTAL = {
                type: 3,
                value: "SLIDINGHORIZONTAL"
            };
        }
        static{
            this.SLIDINGVERTICAL = {
                type: 3,
                value: "SLIDINGVERTICAL"
            };
        }
        static{
            this.REMOVABLECASEMENT = {
                type: 3,
                value: "REMOVABLECASEMENT"
            };
        }
        static{
            this.FIXEDCASEMENT = {
                type: 3,
                value: "FIXEDCASEMENT"
            };
        }
        static{
            this.OTHEROPERATION = {
                type: 3,
                value: "OTHEROPERATION"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;
    class IfcWindowPanelPositionEnum {
        static{
            this.LEFT = {
                type: 3,
                value: "LEFT"
            };
        }
        static{
            this.MIDDLE = {
                type: 3,
                value: "MIDDLE"
            };
        }
        static{
            this.RIGHT = {
                type: 3,
                value: "RIGHT"
            };
        }
        static{
            this.BOTTOM = {
                type: 3,
                value: "BOTTOM"
            };
        }
        static{
            this.TOP = {
                type: 3,
                value: "TOP"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;
    class IfcWindowStyleConstructionEnum {
        static{
            this.ALUMINIUM = {
                type: 3,
                value: "ALUMINIUM"
            };
        }
        static{
            this.HIGH_GRADE_STEEL = {
                type: 3,
                value: "HIGH_GRADE_STEEL"
            };
        }
        static{
            this.STEEL = {
                type: 3,
                value: "STEEL"
            };
        }
        static{
            this.WOOD = {
                type: 3,
                value: "WOOD"
            };
        }
        static{
            this.ALUMINIUM_WOOD = {
                type: 3,
                value: "ALUMINIUM_WOOD"
            };
        }
        static{
            this.PLASTIC = {
                type: 3,
                value: "PLASTIC"
            };
        }
        static{
            this.OTHER_CONSTRUCTION = {
                type: 3,
                value: "OTHER_CONSTRUCTION"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;
    class IfcWindowStyleOperationEnum {
        static{
            this.SINGLE_PANEL = {
                type: 3,
                value: "SINGLE_PANEL"
            };
        }
        static{
            this.DOUBLE_PANEL_VERTICAL = {
                type: 3,
                value: "DOUBLE_PANEL_VERTICAL"
            };
        }
        static{
            this.DOUBLE_PANEL_HORIZONTAL = {
                type: 3,
                value: "DOUBLE_PANEL_HORIZONTAL"
            };
        }
        static{
            this.TRIPLE_PANEL_VERTICAL = {
                type: 3,
                value: "TRIPLE_PANEL_VERTICAL"
            };
        }
        static{
            this.TRIPLE_PANEL_BOTTOM = {
                type: 3,
                value: "TRIPLE_PANEL_BOTTOM"
            };
        }
        static{
            this.TRIPLE_PANEL_TOP = {
                type: 3,
                value: "TRIPLE_PANEL_TOP"
            };
        }
        static{
            this.TRIPLE_PANEL_LEFT = {
                type: 3,
                value: "TRIPLE_PANEL_LEFT"
            };
        }
        static{
            this.TRIPLE_PANEL_RIGHT = {
                type: 3,
                value: "TRIPLE_PANEL_RIGHT"
            };
        }
        static{
            this.TRIPLE_PANEL_HORIZONTAL = {
                type: 3,
                value: "TRIPLE_PANEL_HORIZONTAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;
    class IfcWorkControlTypeEnum {
        static{
            this.ACTUAL = {
                type: 3,
                value: "ACTUAL"
            };
        }
        static{
            this.BASELINE = {
                type: 3,
                value: "BASELINE"
            };
        }
        static{
            this.PLANNED = {
                type: 3,
                value: "PLANNED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC2X32.IfcWorkControlTypeEnum = IfcWorkControlTypeEnum;
    class IfcActorRole extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Role, UserDefinedRole, Description){
            super();
            this.Role = Role;
            this.UserDefinedRole = UserDefinedRole;
            this.Description = Description;
            this.type = 3630933823;
        }
    }
    IFC2X32.IfcActorRole = IfcActorRole;
    class IfcAddress extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Purpose, Description, UserDefinedPurpose){
            super();
            this.Purpose = Purpose;
            this.Description = Description;
            this.UserDefinedPurpose = UserDefinedPurpose;
            this.type = 618182010;
        }
    }
    IFC2X32.IfcAddress = IfcAddress;
    class IfcApplication extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier){
            super();
            this.ApplicationDeveloper = ApplicationDeveloper;
            this.Version = Version;
            this.ApplicationFullName = ApplicationFullName;
            this.ApplicationIdentifier = ApplicationIdentifier;
            this.type = 639542469;
        }
    }
    IFC2X32.IfcApplication = IfcApplication;
    class IfcAppliedValue extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate){
            super();
            this.Name = Name;
            this.Description = Description;
            this.AppliedValue = AppliedValue;
            this.UnitBasis = UnitBasis;
            this.ApplicableDate = ApplicableDate;
            this.FixedUntilDate = FixedUntilDate;
            this.type = 411424972;
        }
    }
    IFC2X32.IfcAppliedValue = IfcAppliedValue;
    class IfcAppliedValueRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ComponentOfTotal, Components, ArithmeticOperator, Name, Description){
            super();
            this.ComponentOfTotal = ComponentOfTotal;
            this.Components = Components;
            this.ArithmeticOperator = ArithmeticOperator;
            this.Name = Name;
            this.Description = Description;
            this.type = 1110488051;
        }
    }
    IFC2X32.IfcAppliedValueRelationship = IfcAppliedValueRelationship;
    class IfcApproval extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Description, ApprovalDateTime, ApprovalStatus, ApprovalLevel, ApprovalQualifier, Name, Identifier){
            super();
            this.Description = Description;
            this.ApprovalDateTime = ApprovalDateTime;
            this.ApprovalStatus = ApprovalStatus;
            this.ApprovalLevel = ApprovalLevel;
            this.ApprovalQualifier = ApprovalQualifier;
            this.Name = Name;
            this.Identifier = Identifier;
            this.type = 130549933;
        }
    }
    IFC2X32.IfcApproval = IfcApproval;
    class IfcApprovalActorRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Actor, Approval, Role){
            super();
            this.Actor = Actor;
            this.Approval = Approval;
            this.Role = Role;
            this.type = 2080292479;
        }
    }
    IFC2X32.IfcApprovalActorRelationship = IfcApprovalActorRelationship;
    class IfcApprovalPropertyRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ApprovedProperties, Approval){
            super();
            this.ApprovedProperties = ApprovedProperties;
            this.Approval = Approval;
            this.type = 390851274;
        }
    }
    IFC2X32.IfcApprovalPropertyRelationship = IfcApprovalPropertyRelationship;
    class IfcApprovalRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RelatedApproval, RelatingApproval, Description, Name){
            super();
            this.RelatedApproval = RelatedApproval;
            this.RelatingApproval = RelatingApproval;
            this.Description = Description;
            this.Name = Name;
            this.type = 3869604511;
        }
    }
    IFC2X32.IfcApprovalRelationship = IfcApprovalRelationship;
    class IfcBoundaryCondition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 4037036970;
        }
    }
    IFC2X32.IfcBoundaryCondition = IfcBoundaryCondition;
    class IfcBoundaryEdgeCondition extends IfcBoundaryCondition {
        constructor(Name, LinearStiffnessByLengthX, LinearStiffnessByLengthY, LinearStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ){
            super(Name);
            this.Name = Name;
            this.LinearStiffnessByLengthX = LinearStiffnessByLengthX;
            this.LinearStiffnessByLengthY = LinearStiffnessByLengthY;
            this.LinearStiffnessByLengthZ = LinearStiffnessByLengthZ;
            this.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
            this.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
            this.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
            this.type = 1560379544;
        }
    }
    IFC2X32.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;
    class IfcBoundaryFaceCondition extends IfcBoundaryCondition {
        constructor(Name, LinearStiffnessByAreaX, LinearStiffnessByAreaY, LinearStiffnessByAreaZ){
            super(Name);
            this.Name = Name;
            this.LinearStiffnessByAreaX = LinearStiffnessByAreaX;
            this.LinearStiffnessByAreaY = LinearStiffnessByAreaY;
            this.LinearStiffnessByAreaZ = LinearStiffnessByAreaZ;
            this.type = 3367102660;
        }
    }
    IFC2X32.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;
    class IfcBoundaryNodeCondition extends IfcBoundaryCondition {
        constructor(Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ){
            super(Name);
            this.Name = Name;
            this.LinearStiffnessX = LinearStiffnessX;
            this.LinearStiffnessY = LinearStiffnessY;
            this.LinearStiffnessZ = LinearStiffnessZ;
            this.RotationalStiffnessX = RotationalStiffnessX;
            this.RotationalStiffnessY = RotationalStiffnessY;
            this.RotationalStiffnessZ = RotationalStiffnessZ;
            this.type = 1387855156;
        }
    }
    IFC2X32.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;
    class IfcBoundaryNodeConditionWarping extends IfcBoundaryNodeCondition {
        constructor(Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness){
            super(Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
            this.Name = Name;
            this.LinearStiffnessX = LinearStiffnessX;
            this.LinearStiffnessY = LinearStiffnessY;
            this.LinearStiffnessZ = LinearStiffnessZ;
            this.RotationalStiffnessX = RotationalStiffnessX;
            this.RotationalStiffnessY = RotationalStiffnessY;
            this.RotationalStiffnessZ = RotationalStiffnessZ;
            this.WarpingStiffness = WarpingStiffness;
            this.type = 2069777674;
        }
    }
    IFC2X32.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;
    class IfcCalendarDate extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(DayComponent, MonthComponent, YearComponent){
            super();
            this.DayComponent = DayComponent;
            this.MonthComponent = MonthComponent;
            this.YearComponent = YearComponent;
            this.type = 622194075;
        }
    }
    IFC2X32.IfcCalendarDate = IfcCalendarDate;
    class IfcClassification extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Source, Edition, EditionDate, Name){
            super();
            this.Source = Source;
            this.Edition = Edition;
            this.EditionDate = EditionDate;
            this.Name = Name;
            this.type = 747523909;
        }
    }
    IFC2X32.IfcClassification = IfcClassification;
    class IfcClassificationItem extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Notation, ItemOf, Title){
            super();
            this.Notation = Notation;
            this.ItemOf = ItemOf;
            this.Title = Title;
            this.type = 1767535486;
        }
    }
    IFC2X32.IfcClassificationItem = IfcClassificationItem;
    class IfcClassificationItemRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RelatingItem, RelatedItems){
            super();
            this.RelatingItem = RelatingItem;
            this.RelatedItems = RelatedItems;
            this.type = 1098599126;
        }
    }
    IFC2X32.IfcClassificationItemRelationship = IfcClassificationItemRelationship;
    class IfcClassificationNotation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(NotationFacets){
            super();
            this.NotationFacets = NotationFacets;
            this.type = 938368621;
        }
    }
    IFC2X32.IfcClassificationNotation = IfcClassificationNotation;
    class IfcClassificationNotationFacet extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(NotationValue){
            super();
            this.NotationValue = NotationValue;
            this.type = 3639012971;
        }
    }
    IFC2X32.IfcClassificationNotationFacet = IfcClassificationNotationFacet;
    class IfcColourSpecification extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 3264961684;
        }
    }
    IFC2X32.IfcColourSpecification = IfcColourSpecification;
    class IfcConnectionGeometry extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 2859738748;
        }
    }
    IFC2X32.IfcConnectionGeometry = IfcConnectionGeometry;
    class IfcConnectionPointGeometry extends IfcConnectionGeometry {
        constructor(PointOnRelatingElement, PointOnRelatedElement){
            super();
            this.PointOnRelatingElement = PointOnRelatingElement;
            this.PointOnRelatedElement = PointOnRelatedElement;
            this.type = 2614616156;
        }
    }
    IFC2X32.IfcConnectionPointGeometry = IfcConnectionPointGeometry;
    class IfcConnectionPortGeometry extends IfcConnectionGeometry {
        constructor(LocationAtRelatingElement, LocationAtRelatedElement, ProfileOfPort){
            super();
            this.LocationAtRelatingElement = LocationAtRelatingElement;
            this.LocationAtRelatedElement = LocationAtRelatedElement;
            this.ProfileOfPort = ProfileOfPort;
            this.type = 4257277454;
        }
    }
    IFC2X32.IfcConnectionPortGeometry = IfcConnectionPortGeometry;
    class IfcConnectionSurfaceGeometry extends IfcConnectionGeometry {
        constructor(SurfaceOnRelatingElement, SurfaceOnRelatedElement){
            super();
            this.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
            this.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
            this.type = 2732653382;
        }
    }
    IFC2X32.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;
    class IfcConstraint extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade){
            super();
            this.Name = Name;
            this.Description = Description;
            this.ConstraintGrade = ConstraintGrade;
            this.ConstraintSource = ConstraintSource;
            this.CreatingActor = CreatingActor;
            this.CreationTime = CreationTime;
            this.UserDefinedGrade = UserDefinedGrade;
            this.type = 1959218052;
        }
    }
    IFC2X32.IfcConstraint = IfcConstraint;
    class IfcConstraintAggregationRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, RelatingConstraint, RelatedConstraints, LogicalAggregator){
            super();
            this.Name = Name;
            this.Description = Description;
            this.RelatingConstraint = RelatingConstraint;
            this.RelatedConstraints = RelatedConstraints;
            this.LogicalAggregator = LogicalAggregator;
            this.type = 1658513725;
        }
    }
    IFC2X32.IfcConstraintAggregationRelationship = IfcConstraintAggregationRelationship;
    class IfcConstraintClassificationRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ClassifiedConstraint, RelatedClassifications){
            super();
            this.ClassifiedConstraint = ClassifiedConstraint;
            this.RelatedClassifications = RelatedClassifications;
            this.type = 613356794;
        }
    }
    IFC2X32.IfcConstraintClassificationRelationship = IfcConstraintClassificationRelationship;
    class IfcConstraintRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, RelatingConstraint, RelatedConstraints){
            super();
            this.Name = Name;
            this.Description = Description;
            this.RelatingConstraint = RelatingConstraint;
            this.RelatedConstraints = RelatedConstraints;
            this.type = 347226245;
        }
    }
    IFC2X32.IfcConstraintRelationship = IfcConstraintRelationship;
    class IfcCoordinatedUniversalTimeOffset extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(HourOffset, MinuteOffset, Sense){
            super();
            this.HourOffset = HourOffset;
            this.MinuteOffset = MinuteOffset;
            this.Sense = Sense;
            this.type = 1065062679;
        }
    }
    IFC2X32.IfcCoordinatedUniversalTimeOffset = IfcCoordinatedUniversalTimeOffset;
    class IfcCostValue extends IfcAppliedValue {
        constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, CostType, Condition){
            super(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate);
            this.Name = Name;
            this.Description = Description;
            this.AppliedValue = AppliedValue;
            this.UnitBasis = UnitBasis;
            this.ApplicableDate = ApplicableDate;
            this.FixedUntilDate = FixedUntilDate;
            this.CostType = CostType;
            this.Condition = Condition;
            this.type = 602808272;
        }
    }
    IFC2X32.IfcCostValue = IfcCostValue;
    class IfcCurrencyRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource){
            super();
            this.RelatingMonetaryUnit = RelatingMonetaryUnit;
            this.RelatedMonetaryUnit = RelatedMonetaryUnit;
            this.ExchangeRate = ExchangeRate;
            this.RateDateTime = RateDateTime;
            this.RateSource = RateSource;
            this.type = 539742890;
        }
    }
    IFC2X32.IfcCurrencyRelationship = IfcCurrencyRelationship;
    class IfcCurveStyleFont extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, PatternList){
            super();
            this.Name = Name;
            this.PatternList = PatternList;
            this.type = 1105321065;
        }
    }
    IFC2X32.IfcCurveStyleFont = IfcCurveStyleFont;
    class IfcCurveStyleFontAndScaling extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, CurveFont, CurveFontScaling){
            super();
            this.Name = Name;
            this.CurveFont = CurveFont;
            this.CurveFontScaling = CurveFontScaling;
            this.type = 2367409068;
        }
    }
    IFC2X32.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;
    class IfcCurveStyleFontPattern extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(VisibleSegmentLength, InvisibleSegmentLength){
            super();
            this.VisibleSegmentLength = VisibleSegmentLength;
            this.InvisibleSegmentLength = InvisibleSegmentLength;
            this.type = 3510044353;
        }
    }
    IFC2X32.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;
    class IfcDateAndTime extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(DateComponent, TimeComponent){
            super();
            this.DateComponent = DateComponent;
            this.TimeComponent = TimeComponent;
            this.type = 1072939445;
        }
    }
    IFC2X32.IfcDateAndTime = IfcDateAndTime;
    class IfcDerivedUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Elements, UnitType, UserDefinedType){
            super();
            this.Elements = Elements;
            this.UnitType = UnitType;
            this.UserDefinedType = UserDefinedType;
            this.type = 1765591967;
        }
    }
    IFC2X32.IfcDerivedUnit = IfcDerivedUnit;
    class IfcDerivedUnitElement extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Unit, Exponent){
            super();
            this.Unit = Unit;
            this.Exponent = Exponent;
            this.type = 1045800335;
        }
    }
    IFC2X32.IfcDerivedUnitElement = IfcDerivedUnitElement;
    class IfcDimensionalExponents extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent){
            super();
            this.LengthExponent = LengthExponent;
            this.MassExponent = MassExponent;
            this.TimeExponent = TimeExponent;
            this.ElectricCurrentExponent = ElectricCurrentExponent;
            this.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
            this.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
            this.LuminousIntensityExponent = LuminousIntensityExponent;
            this.type = 2949456006;
        }
    }
    IFC2X32.IfcDimensionalExponents = IfcDimensionalExponents;
    class IfcDocumentElectronicFormat extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(FileExtension, MimeContentType, MimeSubtype){
            super();
            this.FileExtension = FileExtension;
            this.MimeContentType = MimeContentType;
            this.MimeSubtype = MimeSubtype;
            this.type = 1376555844;
        }
    }
    IFC2X32.IfcDocumentElectronicFormat = IfcDocumentElectronicFormat;
    class IfcDocumentInformation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(DocumentId, Name, Description, DocumentReferences, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status){
            super();
            this.DocumentId = DocumentId;
            this.Name = Name;
            this.Description = Description;
            this.DocumentReferences = DocumentReferences;
            this.Purpose = Purpose;
            this.IntendedUse = IntendedUse;
            this.Scope = Scope;
            this.Revision = Revision;
            this.DocumentOwner = DocumentOwner;
            this.Editors = Editors;
            this.CreationTime = CreationTime;
            this.LastRevisionTime = LastRevisionTime;
            this.ElectronicFormat = ElectronicFormat;
            this.ValidFrom = ValidFrom;
            this.ValidUntil = ValidUntil;
            this.Confidentiality = Confidentiality;
            this.Status = Status;
            this.type = 1154170062;
        }
    }
    IFC2X32.IfcDocumentInformation = IfcDocumentInformation;
    class IfcDocumentInformationRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RelatingDocument, RelatedDocuments, RelationshipType){
            super();
            this.RelatingDocument = RelatingDocument;
            this.RelatedDocuments = RelatedDocuments;
            this.RelationshipType = RelationshipType;
            this.type = 770865208;
        }
    }
    IFC2X32.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;
    class IfcDraughtingCalloutRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout){
            super();
            this.Name = Name;
            this.Description = Description;
            this.RelatingDraughtingCallout = RelatingDraughtingCallout;
            this.RelatedDraughtingCallout = RelatedDraughtingCallout;
            this.type = 3796139169;
        }
    }
    IFC2X32.IfcDraughtingCalloutRelationship = IfcDraughtingCalloutRelationship;
    class IfcEnvironmentalImpactValue extends IfcAppliedValue {
        constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, ImpactType, Category, UserDefinedCategory){
            super(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate);
            this.Name = Name;
            this.Description = Description;
            this.AppliedValue = AppliedValue;
            this.UnitBasis = UnitBasis;
            this.ApplicableDate = ApplicableDate;
            this.FixedUntilDate = FixedUntilDate;
            this.ImpactType = ImpactType;
            this.Category = Category;
            this.UserDefinedCategory = UserDefinedCategory;
            this.type = 1648886627;
        }
    }
    IFC2X32.IfcEnvironmentalImpactValue = IfcEnvironmentalImpactValue;
    class IfcExternalReference extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Location, ItemReference, Name){
            super();
            this.Location = Location;
            this.ItemReference = ItemReference;
            this.Name = Name;
            this.type = 3200245327;
        }
    }
    IFC2X32.IfcExternalReference = IfcExternalReference;
    class IfcExternallyDefinedHatchStyle extends IfcExternalReference {
        constructor(Location, ItemReference, Name){
            super(Location, ItemReference, Name);
            this.Location = Location;
            this.ItemReference = ItemReference;
            this.Name = Name;
            this.type = 2242383968;
        }
    }
    IFC2X32.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;
    class IfcExternallyDefinedSurfaceStyle extends IfcExternalReference {
        constructor(Location, ItemReference, Name){
            super(Location, ItemReference, Name);
            this.Location = Location;
            this.ItemReference = ItemReference;
            this.Name = Name;
            this.type = 1040185647;
        }
    }
    IFC2X32.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;
    class IfcExternallyDefinedSymbol extends IfcExternalReference {
        constructor(Location, ItemReference, Name){
            super(Location, ItemReference, Name);
            this.Location = Location;
            this.ItemReference = ItemReference;
            this.Name = Name;
            this.type = 3207319532;
        }
    }
    IFC2X32.IfcExternallyDefinedSymbol = IfcExternallyDefinedSymbol;
    class IfcExternallyDefinedTextFont extends IfcExternalReference {
        constructor(Location, ItemReference, Name){
            super(Location, ItemReference, Name);
            this.Location = Location;
            this.ItemReference = ItemReference;
            this.Name = Name;
            this.type = 3548104201;
        }
    }
    IFC2X32.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;
    class IfcGridAxis extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(AxisTag, AxisCurve, SameSense){
            super();
            this.AxisTag = AxisTag;
            this.AxisCurve = AxisCurve;
            this.SameSense = SameSense;
            this.type = 852622518;
        }
    }
    IFC2X32.IfcGridAxis = IfcGridAxis;
    class IfcIrregularTimeSeriesValue extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(TimeStamp, ListValues){
            super();
            this.TimeStamp = TimeStamp;
            this.ListValues = ListValues;
            this.type = 3020489413;
        }
    }
    IFC2X32.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;
    class IfcLibraryInformation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Version, Publisher, VersionDate, LibraryReference){
            super();
            this.Name = Name;
            this.Version = Version;
            this.Publisher = Publisher;
            this.VersionDate = VersionDate;
            this.LibraryReference = LibraryReference;
            this.type = 2655187982;
        }
    }
    IFC2X32.IfcLibraryInformation = IfcLibraryInformation;
    class IfcLibraryReference extends IfcExternalReference {
        constructor(Location, ItemReference, Name){
            super(Location, ItemReference, Name);
            this.Location = Location;
            this.ItemReference = ItemReference;
            this.Name = Name;
            this.type = 3452421091;
        }
    }
    IFC2X32.IfcLibraryReference = IfcLibraryReference;
    class IfcLightDistributionData extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity){
            super();
            this.MainPlaneAngle = MainPlaneAngle;
            this.SecondaryPlaneAngle = SecondaryPlaneAngle;
            this.LuminousIntensity = LuminousIntensity;
            this.type = 4162380809;
        }
    }
    IFC2X32.IfcLightDistributionData = IfcLightDistributionData;
    class IfcLightIntensityDistribution extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(LightDistributionCurve, DistributionData){
            super();
            this.LightDistributionCurve = LightDistributionCurve;
            this.DistributionData = DistributionData;
            this.type = 1566485204;
        }
    }
    IFC2X32.IfcLightIntensityDistribution = IfcLightIntensityDistribution;
    class IfcLocalTime extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(HourComponent, MinuteComponent, SecondComponent, Zone, DaylightSavingOffset){
            super();
            this.HourComponent = HourComponent;
            this.MinuteComponent = MinuteComponent;
            this.SecondComponent = SecondComponent;
            this.Zone = Zone;
            this.DaylightSavingOffset = DaylightSavingOffset;
            this.type = 30780891;
        }
    }
    IFC2X32.IfcLocalTime = IfcLocalTime;
    class IfcMaterial extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 1838606355;
        }
    }
    IFC2X32.IfcMaterial = IfcMaterial;
    class IfcMaterialClassificationRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MaterialClassifications, ClassifiedMaterial){
            super();
            this.MaterialClassifications = MaterialClassifications;
            this.ClassifiedMaterial = ClassifiedMaterial;
            this.type = 1847130766;
        }
    }
    IFC2X32.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;
    class IfcMaterialLayer extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Material, LayerThickness, IsVentilated){
            super();
            this.Material = Material;
            this.LayerThickness = LayerThickness;
            this.IsVentilated = IsVentilated;
            this.type = 248100487;
        }
    }
    IFC2X32.IfcMaterialLayer = IfcMaterialLayer;
    class IfcMaterialLayerSet extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MaterialLayers, LayerSetName){
            super();
            this.MaterialLayers = MaterialLayers;
            this.LayerSetName = LayerSetName;
            this.type = 3303938423;
        }
    }
    IFC2X32.IfcMaterialLayerSet = IfcMaterialLayerSet;
    class IfcMaterialLayerSetUsage extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine){
            super();
            this.ForLayerSet = ForLayerSet;
            this.LayerSetDirection = LayerSetDirection;
            this.DirectionSense = DirectionSense;
            this.OffsetFromReferenceLine = OffsetFromReferenceLine;
            this.type = 1303795690;
        }
    }
    IFC2X32.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;
    class IfcMaterialList extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Materials){
            super();
            this.Materials = Materials;
            this.type = 2199411900;
        }
    }
    IFC2X32.IfcMaterialList = IfcMaterialList;
    class IfcMaterialProperties extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Material){
            super();
            this.Material = Material;
            this.type = 3265635763;
        }
    }
    IFC2X32.IfcMaterialProperties = IfcMaterialProperties;
    class IfcMeasureWithUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ValueComponent, UnitComponent){
            super();
            this.ValueComponent = ValueComponent;
            this.UnitComponent = UnitComponent;
            this.type = 2597039031;
        }
    }
    IFC2X32.IfcMeasureWithUnit = IfcMeasureWithUnit;
    class IfcMechanicalMaterialProperties extends IfcMaterialProperties {
        constructor(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient){
            super(Material);
            this.Material = Material;
            this.DynamicViscosity = DynamicViscosity;
            this.YoungModulus = YoungModulus;
            this.ShearModulus = ShearModulus;
            this.PoissonRatio = PoissonRatio;
            this.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
            this.type = 4256014907;
        }
    }
    IFC2X32.IfcMechanicalMaterialProperties = IfcMechanicalMaterialProperties;
    class IfcMechanicalSteelMaterialProperties extends IfcMechanicalMaterialProperties {
        constructor(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient, YieldStress, UltimateStress, UltimateStrain, HardeningModule, ProportionalStress, PlasticStrain, Relaxations){
            super(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient);
            this.Material = Material;
            this.DynamicViscosity = DynamicViscosity;
            this.YoungModulus = YoungModulus;
            this.ShearModulus = ShearModulus;
            this.PoissonRatio = PoissonRatio;
            this.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
            this.YieldStress = YieldStress;
            this.UltimateStress = UltimateStress;
            this.UltimateStrain = UltimateStrain;
            this.HardeningModule = HardeningModule;
            this.ProportionalStress = ProportionalStress;
            this.PlasticStrain = PlasticStrain;
            this.Relaxations = Relaxations;
            this.type = 677618848;
        }
    }
    IFC2X32.IfcMechanicalSteelMaterialProperties = IfcMechanicalSteelMaterialProperties;
    class IfcMetric extends IfcConstraint {
        constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue){
            super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
            this.Name = Name;
            this.Description = Description;
            this.ConstraintGrade = ConstraintGrade;
            this.ConstraintSource = ConstraintSource;
            this.CreatingActor = CreatingActor;
            this.CreationTime = CreationTime;
            this.UserDefinedGrade = UserDefinedGrade;
            this.Benchmark = Benchmark;
            this.ValueSource = ValueSource;
            this.DataValue = DataValue;
            this.type = 3368373690;
        }
    }
    IFC2X32.IfcMetric = IfcMetric;
    class IfcMonetaryUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Currency){
            super();
            this.Currency = Currency;
            this.type = 2706619895;
        }
    }
    IFC2X32.IfcMonetaryUnit = IfcMonetaryUnit;
    class IfcNamedUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Dimensions, UnitType){
            super();
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.type = 1918398963;
        }
    }
    IFC2X32.IfcNamedUnit = IfcNamedUnit;
    class IfcObjectPlacement extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 3701648758;
        }
    }
    IFC2X32.IfcObjectPlacement = IfcObjectPlacement;
    class IfcObjective extends IfcConstraint {
        constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, ResultValues, ObjectiveQualifier, UserDefinedQualifier){
            super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
            this.Name = Name;
            this.Description = Description;
            this.ConstraintGrade = ConstraintGrade;
            this.ConstraintSource = ConstraintSource;
            this.CreatingActor = CreatingActor;
            this.CreationTime = CreationTime;
            this.UserDefinedGrade = UserDefinedGrade;
            this.BenchmarkValues = BenchmarkValues;
            this.ResultValues = ResultValues;
            this.ObjectiveQualifier = ObjectiveQualifier;
            this.UserDefinedQualifier = UserDefinedQualifier;
            this.type = 2251480897;
        }
    }
    IFC2X32.IfcObjective = IfcObjective;
    class IfcOpticalMaterialProperties extends IfcMaterialProperties {
        constructor(Material, VisibleTransmittance, SolarTransmittance, ThermalIrTransmittance, ThermalIrEmissivityBack, ThermalIrEmissivityFront, VisibleReflectanceBack, VisibleReflectanceFront, SolarReflectanceFront, SolarReflectanceBack){
            super(Material);
            this.Material = Material;
            this.VisibleTransmittance = VisibleTransmittance;
            this.SolarTransmittance = SolarTransmittance;
            this.ThermalIrTransmittance = ThermalIrTransmittance;
            this.ThermalIrEmissivityBack = ThermalIrEmissivityBack;
            this.ThermalIrEmissivityFront = ThermalIrEmissivityFront;
            this.VisibleReflectanceBack = VisibleReflectanceBack;
            this.VisibleReflectanceFront = VisibleReflectanceFront;
            this.SolarReflectanceFront = SolarReflectanceFront;
            this.SolarReflectanceBack = SolarReflectanceBack;
            this.type = 1227763645;
        }
    }
    IFC2X32.IfcOpticalMaterialProperties = IfcOpticalMaterialProperties;
    class IfcOrganization extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Id, Name, Description, Roles, Addresses){
            super();
            this.Id = Id;
            this.Name = Name;
            this.Description = Description;
            this.Roles = Roles;
            this.Addresses = Addresses;
            this.type = 4251960020;
        }
    }
    IFC2X32.IfcOrganization = IfcOrganization;
    class IfcOrganizationRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, RelatingOrganization, RelatedOrganizations){
            super();
            this.Name = Name;
            this.Description = Description;
            this.RelatingOrganization = RelatingOrganization;
            this.RelatedOrganizations = RelatedOrganizations;
            this.type = 1411181986;
        }
    }
    IFC2X32.IfcOrganizationRelationship = IfcOrganizationRelationship;
    class IfcOwnerHistory extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate){
            super();
            this.OwningUser = OwningUser;
            this.OwningApplication = OwningApplication;
            this.State = State;
            this.ChangeAction = ChangeAction;
            this.LastModifiedDate = LastModifiedDate;
            this.LastModifyingUser = LastModifyingUser;
            this.LastModifyingApplication = LastModifyingApplication;
            this.CreationDate = CreationDate;
            this.type = 1207048766;
        }
    }
    IFC2X32.IfcOwnerHistory = IfcOwnerHistory;
    class IfcPerson extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Id, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses){
            super();
            this.Id = Id;
            this.FamilyName = FamilyName;
            this.GivenName = GivenName;
            this.MiddleNames = MiddleNames;
            this.PrefixTitles = PrefixTitles;
            this.SuffixTitles = SuffixTitles;
            this.Roles = Roles;
            this.Addresses = Addresses;
            this.type = 2077209135;
        }
    }
    IFC2X32.IfcPerson = IfcPerson;
    class IfcPersonAndOrganization extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ThePerson, TheOrganization, Roles){
            super();
            this.ThePerson = ThePerson;
            this.TheOrganization = TheOrganization;
            this.Roles = Roles;
            this.type = 101040310;
        }
    }
    IFC2X32.IfcPersonAndOrganization = IfcPersonAndOrganization;
    class IfcPhysicalQuantity extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description){
            super();
            this.Name = Name;
            this.Description = Description;
            this.type = 2483315170;
        }
    }
    IFC2X32.IfcPhysicalQuantity = IfcPhysicalQuantity;
    class IfcPhysicalSimpleQuantity extends IfcPhysicalQuantity {
        constructor(Name, Description, Unit){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.type = 2226359599;
        }
    }
    IFC2X32.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;
    class IfcPostalAddress extends IfcAddress {
        constructor(Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country){
            super(Purpose, Description, UserDefinedPurpose);
            this.Purpose = Purpose;
            this.Description = Description;
            this.UserDefinedPurpose = UserDefinedPurpose;
            this.InternalLocation = InternalLocation;
            this.AddressLines = AddressLines;
            this.PostalBox = PostalBox;
            this.Town = Town;
            this.Region = Region;
            this.PostalCode = PostalCode;
            this.Country = Country;
            this.type = 3355820592;
        }
    }
    IFC2X32.IfcPostalAddress = IfcPostalAddress;
    class IfcPreDefinedItem extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 3727388367;
        }
    }
    IFC2X32.IfcPreDefinedItem = IfcPreDefinedItem;
    class IfcPreDefinedSymbol extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 990879717;
        }
    }
    IFC2X32.IfcPreDefinedSymbol = IfcPreDefinedSymbol;
    class IfcPreDefinedTerminatorSymbol extends IfcPreDefinedSymbol {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 3213052703;
        }
    }
    IFC2X32.IfcPreDefinedTerminatorSymbol = IfcPreDefinedTerminatorSymbol;
    class IfcPreDefinedTextFont extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 1775413392;
        }
    }
    IFC2X32.IfcPreDefinedTextFont = IfcPreDefinedTextFont;
    class IfcPresentationLayerAssignment extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, AssignedItems, Identifier){
            super();
            this.Name = Name;
            this.Description = Description;
            this.AssignedItems = AssignedItems;
            this.Identifier = Identifier;
            this.type = 2022622350;
        }
    }
    IFC2X32.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;
    class IfcPresentationLayerWithStyle extends IfcPresentationLayerAssignment {
        constructor(Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles){
            super(Name, Description, AssignedItems, Identifier);
            this.Name = Name;
            this.Description = Description;
            this.AssignedItems = AssignedItems;
            this.Identifier = Identifier;
            this.LayerOn = LayerOn;
            this.LayerFrozen = LayerFrozen;
            this.LayerBlocked = LayerBlocked;
            this.LayerStyles = LayerStyles;
            this.type = 1304840413;
        }
    }
    IFC2X32.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;
    class IfcPresentationStyle extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 3119450353;
        }
    }
    IFC2X32.IfcPresentationStyle = IfcPresentationStyle;
    class IfcPresentationStyleAssignment extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Styles){
            super();
            this.Styles = Styles;
            this.type = 2417041796;
        }
    }
    IFC2X32.IfcPresentationStyleAssignment = IfcPresentationStyleAssignment;
    class IfcProductRepresentation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, Representations){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Representations = Representations;
            this.type = 2095639259;
        }
    }
    IFC2X32.IfcProductRepresentation = IfcProductRepresentation;
    class IfcProductsOfCombustionProperties extends IfcMaterialProperties {
        constructor(Material, SpecificHeatCapacity, N20Content, COContent, CO2Content){
            super(Material);
            this.Material = Material;
            this.SpecificHeatCapacity = SpecificHeatCapacity;
            this.N20Content = N20Content;
            this.COContent = COContent;
            this.CO2Content = CO2Content;
            this.type = 2267347899;
        }
    }
    IFC2X32.IfcProductsOfCombustionProperties = IfcProductsOfCombustionProperties;
    class IfcProfileDef extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ProfileType, ProfileName){
            super();
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.type = 3958567839;
        }
    }
    IFC2X32.IfcProfileDef = IfcProfileDef;
    class IfcProfileProperties extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ProfileName, ProfileDefinition){
            super();
            this.ProfileName = ProfileName;
            this.ProfileDefinition = ProfileDefinition;
            this.type = 2802850158;
        }
    }
    IFC2X32.IfcProfileProperties = IfcProfileProperties;
    class IfcProperty extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description){
            super();
            this.Name = Name;
            this.Description = Description;
            this.type = 2598011224;
        }
    }
    IFC2X32.IfcProperty = IfcProperty;
    class IfcPropertyConstraintRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RelatingConstraint, RelatedProperties, Name, Description){
            super();
            this.RelatingConstraint = RelatingConstraint;
            this.RelatedProperties = RelatedProperties;
            this.Name = Name;
            this.Description = Description;
            this.type = 3896028662;
        }
    }
    IFC2X32.IfcPropertyConstraintRelationship = IfcPropertyConstraintRelationship;
    class IfcPropertyDependencyRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(DependingProperty, DependantProperty, Name, Description, Expression){
            super();
            this.DependingProperty = DependingProperty;
            this.DependantProperty = DependantProperty;
            this.Name = Name;
            this.Description = Description;
            this.Expression = Expression;
            this.type = 148025276;
        }
    }
    IFC2X32.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;
    class IfcPropertyEnumeration extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, EnumerationValues, Unit){
            super();
            this.Name = Name;
            this.EnumerationValues = EnumerationValues;
            this.Unit = Unit;
            this.type = 3710013099;
        }
    }
    IFC2X32.IfcPropertyEnumeration = IfcPropertyEnumeration;
    class IfcQuantityArea extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, AreaValue){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.AreaValue = AreaValue;
            this.type = 2044713172;
        }
    }
    IFC2X32.IfcQuantityArea = IfcQuantityArea;
    class IfcQuantityCount extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, CountValue){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.CountValue = CountValue;
            this.type = 2093928680;
        }
    }
    IFC2X32.IfcQuantityCount = IfcQuantityCount;
    class IfcQuantityLength extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, LengthValue){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.LengthValue = LengthValue;
            this.type = 931644368;
        }
    }
    IFC2X32.IfcQuantityLength = IfcQuantityLength;
    class IfcQuantityTime extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, TimeValue){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.TimeValue = TimeValue;
            this.type = 3252649465;
        }
    }
    IFC2X32.IfcQuantityTime = IfcQuantityTime;
    class IfcQuantityVolume extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, VolumeValue){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.VolumeValue = VolumeValue;
            this.type = 2405470396;
        }
    }
    IFC2X32.IfcQuantityVolume = IfcQuantityVolume;
    class IfcQuantityWeight extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, WeightValue){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.WeightValue = WeightValue;
            this.type = 825690147;
        }
    }
    IFC2X32.IfcQuantityWeight = IfcQuantityWeight;
    class IfcReferencesValueDocument extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ReferencedDocument, ReferencingValues, Name, Description){
            super();
            this.ReferencedDocument = ReferencedDocument;
            this.ReferencingValues = ReferencingValues;
            this.Name = Name;
            this.Description = Description;
            this.type = 2692823254;
        }
    }
    IFC2X32.IfcReferencesValueDocument = IfcReferencesValueDocument;
    class IfcReinforcementBarProperties extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount){
            super();
            this.TotalCrossSectionArea = TotalCrossSectionArea;
            this.SteelGrade = SteelGrade;
            this.BarSurface = BarSurface;
            this.EffectiveDepth = EffectiveDepth;
            this.NominalBarDiameter = NominalBarDiameter;
            this.BarCount = BarCount;
            this.type = 1580146022;
        }
    }
    IFC2X32.IfcReinforcementBarProperties = IfcReinforcementBarProperties;
    class IfcRelaxation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RelaxationValue, InitialStress){
            super();
            this.RelaxationValue = RelaxationValue;
            this.InitialStress = InitialStress;
            this.type = 1222501353;
        }
    }
    IFC2X32.IfcRelaxation = IfcRelaxation;
    class IfcRepresentation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super();
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 1076942058;
        }
    }
    IFC2X32.IfcRepresentation = IfcRepresentation;
    class IfcRepresentationContext extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ContextIdentifier, ContextType){
            super();
            this.ContextIdentifier = ContextIdentifier;
            this.ContextType = ContextType;
            this.type = 3377609919;
        }
    }
    IFC2X32.IfcRepresentationContext = IfcRepresentationContext;
    class IfcRepresentationItem extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 3008791417;
        }
    }
    IFC2X32.IfcRepresentationItem = IfcRepresentationItem;
    class IfcRepresentationMap extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MappingOrigin, MappedRepresentation){
            super();
            this.MappingOrigin = MappingOrigin;
            this.MappedRepresentation = MappedRepresentation;
            this.type = 1660063152;
        }
    }
    IFC2X32.IfcRepresentationMap = IfcRepresentationMap;
    class IfcRibPlateProfileProperties extends IfcProfileProperties {
        constructor(ProfileName, ProfileDefinition, Thickness, RibHeight, RibWidth, RibSpacing, Direction){
            super(ProfileName, ProfileDefinition);
            this.ProfileName = ProfileName;
            this.ProfileDefinition = ProfileDefinition;
            this.Thickness = Thickness;
            this.RibHeight = RibHeight;
            this.RibWidth = RibWidth;
            this.RibSpacing = RibSpacing;
            this.Direction = Direction;
            this.type = 3679540991;
        }
    }
    IFC2X32.IfcRibPlateProfileProperties = IfcRibPlateProfileProperties;
    class IfcRoot extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super();
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 2341007311;
        }
    }
    IFC2X32.IfcRoot = IfcRoot;
    class IfcSIUnit extends IfcNamedUnit {
        constructor(UnitType, Prefix, Name){
            super(new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), UnitType);
            this.UnitType = UnitType;
            this.Prefix = Prefix;
            this.Name = Name;
            this.type = 448429030;
        }
    }
    IFC2X32.IfcSIUnit = IfcSIUnit;
    class IfcSectionProperties extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(SectionType, StartProfile, EndProfile){
            super();
            this.SectionType = SectionType;
            this.StartProfile = StartProfile;
            this.EndProfile = EndProfile;
            this.type = 2042790032;
        }
    }
    IFC2X32.IfcSectionProperties = IfcSectionProperties;
    class IfcSectionReinforcementProperties extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions){
            super();
            this.LongitudinalStartPosition = LongitudinalStartPosition;
            this.LongitudinalEndPosition = LongitudinalEndPosition;
            this.TransversePosition = TransversePosition;
            this.ReinforcementRole = ReinforcementRole;
            this.SectionDefinition = SectionDefinition;
            this.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
            this.type = 4165799628;
        }
    }
    IFC2X32.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;
    class IfcShapeAspect extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape){
            super();
            this.ShapeRepresentations = ShapeRepresentations;
            this.Name = Name;
            this.Description = Description;
            this.ProductDefinitional = ProductDefinitional;
            this.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
            this.type = 867548509;
        }
    }
    IFC2X32.IfcShapeAspect = IfcShapeAspect;
    class IfcShapeModel extends IfcRepresentation {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 3982875396;
        }
    }
    IFC2X32.IfcShapeModel = IfcShapeModel;
    class IfcShapeRepresentation extends IfcShapeModel {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 4240577450;
        }
    }
    IFC2X32.IfcShapeRepresentation = IfcShapeRepresentation;
    class IfcSimpleProperty extends IfcProperty {
        constructor(Name, Description){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.type = 3692461612;
        }
    }
    IFC2X32.IfcSimpleProperty = IfcSimpleProperty;
    class IfcStructuralConnectionCondition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 2273995522;
        }
    }
    IFC2X32.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;
    class IfcStructuralLoad extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 2162789131;
        }
    }
    IFC2X32.IfcStructuralLoad = IfcStructuralLoad;
    class IfcStructuralLoadStatic extends IfcStructuralLoad {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 2525727697;
        }
    }
    IFC2X32.IfcStructuralLoadStatic = IfcStructuralLoadStatic;
    class IfcStructuralLoadTemperature extends IfcStructuralLoadStatic {
        constructor(Name, DeltaT_Constant, DeltaT_Y, DeltaT_Z){
            super(Name);
            this.Name = Name;
            this.DeltaT_Constant = DeltaT_Constant;
            this.DeltaT_Y = DeltaT_Y;
            this.DeltaT_Z = DeltaT_Z;
            this.type = 3408363356;
        }
    }
    IFC2X32.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;
    class IfcStyleModel extends IfcRepresentation {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 2830218821;
        }
    }
    IFC2X32.IfcStyleModel = IfcStyleModel;
    class IfcStyledItem extends IfcRepresentationItem {
        constructor(Item, Styles, Name){
            super();
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 3958052878;
        }
    }
    IFC2X32.IfcStyledItem = IfcStyledItem;
    class IfcStyledRepresentation extends IfcStyleModel {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 3049322572;
        }
    }
    IFC2X32.IfcStyledRepresentation = IfcStyledRepresentation;
    class IfcSurfaceStyle extends IfcPresentationStyle {
        constructor(Name, Side, Styles){
            super(Name);
            this.Name = Name;
            this.Side = Side;
            this.Styles = Styles;
            this.type = 1300840506;
        }
    }
    IFC2X32.IfcSurfaceStyle = IfcSurfaceStyle;
    class IfcSurfaceStyleLighting extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour){
            super();
            this.DiffuseTransmissionColour = DiffuseTransmissionColour;
            this.DiffuseReflectionColour = DiffuseReflectionColour;
            this.TransmissionColour = TransmissionColour;
            this.ReflectanceColour = ReflectanceColour;
            this.type = 3303107099;
        }
    }
    IFC2X32.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;
    class IfcSurfaceStyleRefraction extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RefractionIndex, DispersionFactor){
            super();
            this.RefractionIndex = RefractionIndex;
            this.DispersionFactor = DispersionFactor;
            this.type = 1607154358;
        }
    }
    IFC2X32.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;
    class IfcSurfaceStyleShading extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(SurfaceColour){
            super();
            this.SurfaceColour = SurfaceColour;
            this.type = 846575682;
        }
    }
    IFC2X32.IfcSurfaceStyleShading = IfcSurfaceStyleShading;
    class IfcSurfaceStyleWithTextures extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Textures){
            super();
            this.Textures = Textures;
            this.type = 1351298697;
        }
    }
    IFC2X32.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;
    class IfcSurfaceTexture extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RepeatS, RepeatT, TextureType, TextureTransform){
            super();
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.TextureType = TextureType;
            this.TextureTransform = TextureTransform;
            this.type = 626085974;
        }
    }
    IFC2X32.IfcSurfaceTexture = IfcSurfaceTexture;
    class IfcSymbolStyle extends IfcPresentationStyle {
        constructor(Name, StyleOfSymbol){
            super(Name);
            this.Name = Name;
            this.StyleOfSymbol = StyleOfSymbol;
            this.type = 1290481447;
        }
    }
    IFC2X32.IfcSymbolStyle = IfcSymbolStyle;
    class IfcTable extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Rows){
            super();
            this.Name = Name;
            this.Rows = Rows;
            this.type = 985171141;
        }
    }
    IFC2X32.IfcTable = IfcTable;
    class IfcTableRow extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RowCells, IsHeading){
            super();
            this.RowCells = RowCells;
            this.IsHeading = IsHeading;
            this.type = 531007025;
        }
    }
    IFC2X32.IfcTableRow = IfcTableRow;
    class IfcTelecomAddress extends IfcAddress {
        constructor(Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL){
            super(Purpose, Description, UserDefinedPurpose);
            this.Purpose = Purpose;
            this.Description = Description;
            this.UserDefinedPurpose = UserDefinedPurpose;
            this.TelephoneNumbers = TelephoneNumbers;
            this.FacsimileNumbers = FacsimileNumbers;
            this.PagerNumber = PagerNumber;
            this.ElectronicMailAddresses = ElectronicMailAddresses;
            this.WWWHomePageURL = WWWHomePageURL;
            this.type = 912023232;
        }
    }
    IFC2X32.IfcTelecomAddress = IfcTelecomAddress;
    class IfcTextStyle extends IfcPresentationStyle {
        constructor(Name, TextCharacterAppearance, TextStyle, TextFontStyle){
            super(Name);
            this.Name = Name;
            this.TextCharacterAppearance = TextCharacterAppearance;
            this.TextStyle = TextStyle;
            this.TextFontStyle = TextFontStyle;
            this.type = 1447204868;
        }
    }
    IFC2X32.IfcTextStyle = IfcTextStyle;
    class IfcTextStyleFontModel extends IfcPreDefinedTextFont {
        constructor(Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize){
            super(Name);
            this.Name = Name;
            this.FontFamily = FontFamily;
            this.FontStyle = FontStyle;
            this.FontVariant = FontVariant;
            this.FontWeight = FontWeight;
            this.FontSize = FontSize;
            this.type = 1983826977;
        }
    }
    IFC2X32.IfcTextStyleFontModel = IfcTextStyleFontModel;
    class IfcTextStyleForDefinedFont extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Colour, BackgroundColour){
            super();
            this.Colour = Colour;
            this.BackgroundColour = BackgroundColour;
            this.type = 2636378356;
        }
    }
    IFC2X32.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;
    class IfcTextStyleTextModel extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight){
            super();
            this.TextIndent = TextIndent;
            this.TextAlign = TextAlign;
            this.TextDecoration = TextDecoration;
            this.LetterSpacing = LetterSpacing;
            this.WordSpacing = WordSpacing;
            this.TextTransform = TextTransform;
            this.LineHeight = LineHeight;
            this.type = 1640371178;
        }
    }
    IFC2X32.IfcTextStyleTextModel = IfcTextStyleTextModel;
    class IfcTextStyleWithBoxCharacteristics extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(BoxHeight, BoxWidth, BoxSlantAngle, BoxRotateAngle, CharacterSpacing){
            super();
            this.BoxHeight = BoxHeight;
            this.BoxWidth = BoxWidth;
            this.BoxSlantAngle = BoxSlantAngle;
            this.BoxRotateAngle = BoxRotateAngle;
            this.CharacterSpacing = CharacterSpacing;
            this.type = 1484833681;
        }
    }
    IFC2X32.IfcTextStyleWithBoxCharacteristics = IfcTextStyleWithBoxCharacteristics;
    class IfcTextureCoordinate extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 280115917;
        }
    }
    IFC2X32.IfcTextureCoordinate = IfcTextureCoordinate;
    class IfcTextureCoordinateGenerator extends IfcTextureCoordinate {
        constructor(Mode, Parameter){
            super();
            this.Mode = Mode;
            this.Parameter = Parameter;
            this.type = 1742049831;
        }
    }
    IFC2X32.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;
    class IfcTextureMap extends IfcTextureCoordinate {
        constructor(TextureMaps){
            super();
            this.TextureMaps = TextureMaps;
            this.type = 2552916305;
        }
    }
    IFC2X32.IfcTextureMap = IfcTextureMap;
    class IfcTextureVertex extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Coordinates){
            super();
            this.Coordinates = Coordinates;
            this.type = 1210645708;
        }
    }
    IFC2X32.IfcTextureVertex = IfcTextureVertex;
    class IfcThermalMaterialProperties extends IfcMaterialProperties {
        constructor(Material, SpecificHeatCapacity, BoilingPoint, FreezingPoint, ThermalConductivity){
            super(Material);
            this.Material = Material;
            this.SpecificHeatCapacity = SpecificHeatCapacity;
            this.BoilingPoint = BoilingPoint;
            this.FreezingPoint = FreezingPoint;
            this.ThermalConductivity = ThermalConductivity;
            this.type = 3317419933;
        }
    }
    IFC2X32.IfcThermalMaterialProperties = IfcThermalMaterialProperties;
    class IfcTimeSeries extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit){
            super();
            this.Name = Name;
            this.Description = Description;
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.TimeSeriesDataType = TimeSeriesDataType;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.Unit = Unit;
            this.type = 3101149627;
        }
    }
    IFC2X32.IfcTimeSeries = IfcTimeSeries;
    class IfcTimeSeriesReferenceRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ReferencedTimeSeries, TimeSeriesReferences){
            super();
            this.ReferencedTimeSeries = ReferencedTimeSeries;
            this.TimeSeriesReferences = TimeSeriesReferences;
            this.type = 1718945513;
        }
    }
    IFC2X32.IfcTimeSeriesReferenceRelationship = IfcTimeSeriesReferenceRelationship;
    class IfcTimeSeriesValue extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ListValues){
            super();
            this.ListValues = ListValues;
            this.type = 581633288;
        }
    }
    IFC2X32.IfcTimeSeriesValue = IfcTimeSeriesValue;
    class IfcTopologicalRepresentationItem extends IfcRepresentationItem {
        constructor(){
            super();
            this.type = 1377556343;
        }
    }
    IFC2X32.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;
    class IfcTopologyRepresentation extends IfcShapeModel {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 1735638870;
        }
    }
    IFC2X32.IfcTopologyRepresentation = IfcTopologyRepresentation;
    class IfcUnitAssignment extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Units){
            super();
            this.Units = Units;
            this.type = 180925521;
        }
    }
    IFC2X32.IfcUnitAssignment = IfcUnitAssignment;
    class IfcVertex extends IfcTopologicalRepresentationItem {
        constructor(){
            super();
            this.type = 2799835756;
        }
    }
    IFC2X32.IfcVertex = IfcVertex;
    class IfcVertexBasedTextureMap extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(TextureVertices, TexturePoints){
            super();
            this.TextureVertices = TextureVertices;
            this.TexturePoints = TexturePoints;
            this.type = 3304826586;
        }
    }
    IFC2X32.IfcVertexBasedTextureMap = IfcVertexBasedTextureMap;
    class IfcVertexPoint extends IfcVertex {
        constructor(VertexGeometry){
            super();
            this.VertexGeometry = VertexGeometry;
            this.type = 1907098498;
        }
    }
    IFC2X32.IfcVertexPoint = IfcVertexPoint;
    class IfcVirtualGridIntersection extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(IntersectingAxes, OffsetDistances){
            super();
            this.IntersectingAxes = IntersectingAxes;
            this.OffsetDistances = OffsetDistances;
            this.type = 891718957;
        }
    }
    IFC2X32.IfcVirtualGridIntersection = IfcVirtualGridIntersection;
    class IfcWaterProperties extends IfcMaterialProperties {
        constructor(Material, IsPotable, Hardness, AlkalinityConcentration, AcidityConcentration, ImpuritiesContent, PHLevel, DissolvedSolidsContent){
            super(Material);
            this.Material = Material;
            this.IsPotable = IsPotable;
            this.Hardness = Hardness;
            this.AlkalinityConcentration = AlkalinityConcentration;
            this.AcidityConcentration = AcidityConcentration;
            this.ImpuritiesContent = ImpuritiesContent;
            this.PHLevel = PHLevel;
            this.DissolvedSolidsContent = DissolvedSolidsContent;
            this.type = 1065908215;
        }
    }
    IFC2X32.IfcWaterProperties = IfcWaterProperties;
    class IfcAnnotationOccurrence extends IfcStyledItem {
        constructor(Item, Styles, Name){
            super(Item, Styles, Name);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 2442683028;
        }
    }
    IFC2X32.IfcAnnotationOccurrence = IfcAnnotationOccurrence;
    class IfcAnnotationSurfaceOccurrence extends IfcAnnotationOccurrence {
        constructor(Item, Styles, Name){
            super(Item, Styles, Name);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 962685235;
        }
    }
    IFC2X32.IfcAnnotationSurfaceOccurrence = IfcAnnotationSurfaceOccurrence;
    class IfcAnnotationSymbolOccurrence extends IfcAnnotationOccurrence {
        constructor(Item, Styles, Name){
            super(Item, Styles, Name);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 3612888222;
        }
    }
    IFC2X32.IfcAnnotationSymbolOccurrence = IfcAnnotationSymbolOccurrence;
    class IfcAnnotationTextOccurrence extends IfcAnnotationOccurrence {
        constructor(Item, Styles, Name){
            super(Item, Styles, Name);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 2297822566;
        }
    }
    IFC2X32.IfcAnnotationTextOccurrence = IfcAnnotationTextOccurrence;
    class IfcArbitraryClosedProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, OuterCurve){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.OuterCurve = OuterCurve;
            this.type = 3798115385;
        }
    }
    IFC2X32.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;
    class IfcArbitraryOpenProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, Curve){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Curve = Curve;
            this.type = 1310608509;
        }
    }
    IFC2X32.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;
    class IfcArbitraryProfileDefWithVoids extends IfcArbitraryClosedProfileDef {
        constructor(ProfileType, ProfileName, OuterCurve, InnerCurves){
            super(ProfileType, ProfileName, OuterCurve);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.OuterCurve = OuterCurve;
            this.InnerCurves = InnerCurves;
            this.type = 2705031697;
        }
    }
    IFC2X32.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;
    class IfcBlobTexture extends IfcSurfaceTexture {
        constructor(RepeatS, RepeatT, TextureType, TextureTransform, RasterFormat, RasterCode){
            super(RepeatS, RepeatT, TextureType, TextureTransform);
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.TextureType = TextureType;
            this.TextureTransform = TextureTransform;
            this.RasterFormat = RasterFormat;
            this.RasterCode = RasterCode;
            this.type = 616511568;
        }
    }
    IFC2X32.IfcBlobTexture = IfcBlobTexture;
    class IfcCenterLineProfileDef extends IfcArbitraryOpenProfileDef {
        constructor(ProfileType, ProfileName, Curve, Thickness){
            super(ProfileType, ProfileName, Curve);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Curve = Curve;
            this.Thickness = Thickness;
            this.type = 3150382593;
        }
    }
    IFC2X32.IfcCenterLineProfileDef = IfcCenterLineProfileDef;
    class IfcClassificationReference extends IfcExternalReference {
        constructor(Location, ItemReference, Name, ReferencedSource){
            super(Location, ItemReference, Name);
            this.Location = Location;
            this.ItemReference = ItemReference;
            this.Name = Name;
            this.ReferencedSource = ReferencedSource;
            this.type = 647927063;
        }
    }
    IFC2X32.IfcClassificationReference = IfcClassificationReference;
    class IfcColourRgb extends IfcColourSpecification {
        constructor(Name, Red, Green, Blue){
            super(Name);
            this.Name = Name;
            this.Red = Red;
            this.Green = Green;
            this.Blue = Blue;
            this.type = 776857604;
        }
    }
    IFC2X32.IfcColourRgb = IfcColourRgb;
    class IfcComplexProperty extends IfcProperty {
        constructor(Name, Description, UsageName, HasProperties){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.UsageName = UsageName;
            this.HasProperties = HasProperties;
            this.type = 2542286263;
        }
    }
    IFC2X32.IfcComplexProperty = IfcComplexProperty;
    class IfcCompositeProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, Profiles, Label){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Profiles = Profiles;
            this.Label = Label;
            this.type = 1485152156;
        }
    }
    IFC2X32.IfcCompositeProfileDef = IfcCompositeProfileDef;
    class IfcConnectedFaceSet extends IfcTopologicalRepresentationItem {
        constructor(CfsFaces){
            super();
            this.CfsFaces = CfsFaces;
            this.type = 370225590;
        }
    }
    IFC2X32.IfcConnectedFaceSet = IfcConnectedFaceSet;
    class IfcConnectionCurveGeometry extends IfcConnectionGeometry {
        constructor(CurveOnRelatingElement, CurveOnRelatedElement){
            super();
            this.CurveOnRelatingElement = CurveOnRelatingElement;
            this.CurveOnRelatedElement = CurveOnRelatedElement;
            this.type = 1981873012;
        }
    }
    IFC2X32.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;
    class IfcConnectionPointEccentricity extends IfcConnectionPointGeometry {
        constructor(PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ){
            super(PointOnRelatingElement, PointOnRelatedElement);
            this.PointOnRelatingElement = PointOnRelatingElement;
            this.PointOnRelatedElement = PointOnRelatedElement;
            this.EccentricityInX = EccentricityInX;
            this.EccentricityInY = EccentricityInY;
            this.EccentricityInZ = EccentricityInZ;
            this.type = 45288368;
        }
    }
    IFC2X32.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;
    class IfcContextDependentUnit extends IfcNamedUnit {
        constructor(Dimensions, UnitType, Name){
            super(Dimensions, UnitType);
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.Name = Name;
            this.type = 3050246964;
        }
    }
    IFC2X32.IfcContextDependentUnit = IfcContextDependentUnit;
    class IfcConversionBasedUnit extends IfcNamedUnit {
        constructor(Dimensions, UnitType, Name, ConversionFactor){
            super(Dimensions, UnitType);
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.Name = Name;
            this.ConversionFactor = ConversionFactor;
            this.type = 2889183280;
        }
    }
    IFC2X32.IfcConversionBasedUnit = IfcConversionBasedUnit;
    class IfcCurveStyle extends IfcPresentationStyle {
        constructor(Name, CurveFont, CurveWidth, CurveColour){
            super(Name);
            this.Name = Name;
            this.CurveFont = CurveFont;
            this.CurveWidth = CurveWidth;
            this.CurveColour = CurveColour;
            this.type = 3800577675;
        }
    }
    IFC2X32.IfcCurveStyle = IfcCurveStyle;
    class IfcDerivedProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, ParentProfile, Operator, Label){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.ParentProfile = ParentProfile;
            this.Operator = Operator;
            this.Label = Label;
            this.type = 3632507154;
        }
    }
    IFC2X32.IfcDerivedProfileDef = IfcDerivedProfileDef;
    class IfcDimensionCalloutRelationship extends IfcDraughtingCalloutRelationship {
        constructor(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout){
            super(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout);
            this.Name = Name;
            this.Description = Description;
            this.RelatingDraughtingCallout = RelatingDraughtingCallout;
            this.RelatedDraughtingCallout = RelatedDraughtingCallout;
            this.type = 2273265877;
        }
    }
    IFC2X32.IfcDimensionCalloutRelationship = IfcDimensionCalloutRelationship;
    class IfcDimensionPair extends IfcDraughtingCalloutRelationship {
        constructor(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout){
            super(Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout);
            this.Name = Name;
            this.Description = Description;
            this.RelatingDraughtingCallout = RelatingDraughtingCallout;
            this.RelatedDraughtingCallout = RelatedDraughtingCallout;
            this.type = 1694125774;
        }
    }
    IFC2X32.IfcDimensionPair = IfcDimensionPair;
    class IfcDocumentReference extends IfcExternalReference {
        constructor(Location, ItemReference, Name){
            super(Location, ItemReference, Name);
            this.Location = Location;
            this.ItemReference = ItemReference;
            this.Name = Name;
            this.type = 3732053477;
        }
    }
    IFC2X32.IfcDocumentReference = IfcDocumentReference;
    class IfcDraughtingPreDefinedTextFont extends IfcPreDefinedTextFont {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 4170525392;
        }
    }
    IFC2X32.IfcDraughtingPreDefinedTextFont = IfcDraughtingPreDefinedTextFont;
    class IfcEdge extends IfcTopologicalRepresentationItem {
        constructor(EdgeStart, EdgeEnd){
            super();
            this.EdgeStart = EdgeStart;
            this.EdgeEnd = EdgeEnd;
            this.type = 3900360178;
        }
    }
    IFC2X32.IfcEdge = IfcEdge;
    class IfcEdgeCurve extends IfcEdge {
        constructor(EdgeStart, EdgeEnd, EdgeGeometry, SameSense){
            super(EdgeStart, EdgeEnd);
            this.EdgeStart = EdgeStart;
            this.EdgeEnd = EdgeEnd;
            this.EdgeGeometry = EdgeGeometry;
            this.SameSense = SameSense;
            this.type = 476780140;
        }
    }
    IFC2X32.IfcEdgeCurve = IfcEdgeCurve;
    class IfcExtendedMaterialProperties extends IfcMaterialProperties {
        constructor(Material, ExtendedProperties, Description, Name){
            super(Material);
            this.Material = Material;
            this.ExtendedProperties = ExtendedProperties;
            this.Description = Description;
            this.Name = Name;
            this.type = 1860660968;
        }
    }
    IFC2X32.IfcExtendedMaterialProperties = IfcExtendedMaterialProperties;
    class IfcFace extends IfcTopologicalRepresentationItem {
        constructor(Bounds){
            super();
            this.Bounds = Bounds;
            this.type = 2556980723;
        }
    }
    IFC2X32.IfcFace = IfcFace;
    class IfcFaceBound extends IfcTopologicalRepresentationItem {
        constructor(Bound, Orientation){
            super();
            this.Bound = Bound;
            this.Orientation = Orientation;
            this.type = 1809719519;
        }
    }
    IFC2X32.IfcFaceBound = IfcFaceBound;
    class IfcFaceOuterBound extends IfcFaceBound {
        constructor(Bound, Orientation){
            super(Bound, Orientation);
            this.Bound = Bound;
            this.Orientation = Orientation;
            this.type = 803316827;
        }
    }
    IFC2X32.IfcFaceOuterBound = IfcFaceOuterBound;
    class IfcFaceSurface extends IfcFace {
        constructor(Bounds, FaceSurface, SameSense){
            super(Bounds);
            this.Bounds = Bounds;
            this.FaceSurface = FaceSurface;
            this.SameSense = SameSense;
            this.type = 3008276851;
        }
    }
    IFC2X32.IfcFaceSurface = IfcFaceSurface;
    class IfcFailureConnectionCondition extends IfcStructuralConnectionCondition {
        constructor(Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ){
            super(Name);
            this.Name = Name;
            this.TensionFailureX = TensionFailureX;
            this.TensionFailureY = TensionFailureY;
            this.TensionFailureZ = TensionFailureZ;
            this.CompressionFailureX = CompressionFailureX;
            this.CompressionFailureY = CompressionFailureY;
            this.CompressionFailureZ = CompressionFailureZ;
            this.type = 4219587988;
        }
    }
    IFC2X32.IfcFailureConnectionCondition = IfcFailureConnectionCondition;
    class IfcFillAreaStyle extends IfcPresentationStyle {
        constructor(Name, FillStyles){
            super(Name);
            this.Name = Name;
            this.FillStyles = FillStyles;
            this.type = 738692330;
        }
    }
    IFC2X32.IfcFillAreaStyle = IfcFillAreaStyle;
    class IfcFuelProperties extends IfcMaterialProperties {
        constructor(Material, CombustionTemperature, CarbonContent, LowerHeatingValue, HigherHeatingValue){
            super(Material);
            this.Material = Material;
            this.CombustionTemperature = CombustionTemperature;
            this.CarbonContent = CarbonContent;
            this.LowerHeatingValue = LowerHeatingValue;
            this.HigherHeatingValue = HigherHeatingValue;
            this.type = 3857492461;
        }
    }
    IFC2X32.IfcFuelProperties = IfcFuelProperties;
    class IfcGeneralMaterialProperties extends IfcMaterialProperties {
        constructor(Material, MolecularWeight, Porosity, MassDensity){
            super(Material);
            this.Material = Material;
            this.MolecularWeight = MolecularWeight;
            this.Porosity = Porosity;
            this.MassDensity = MassDensity;
            this.type = 803998398;
        }
    }
    IFC2X32.IfcGeneralMaterialProperties = IfcGeneralMaterialProperties;
    class IfcGeneralProfileProperties extends IfcProfileProperties {
        constructor(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea){
            super(ProfileName, ProfileDefinition);
            this.ProfileName = ProfileName;
            this.ProfileDefinition = ProfileDefinition;
            this.PhysicalWeight = PhysicalWeight;
            this.Perimeter = Perimeter;
            this.MinimumPlateThickness = MinimumPlateThickness;
            this.MaximumPlateThickness = MaximumPlateThickness;
            this.CrossSectionArea = CrossSectionArea;
            this.type = 1446786286;
        }
    }
    IFC2X32.IfcGeneralProfileProperties = IfcGeneralProfileProperties;
    class IfcGeometricRepresentationContext extends IfcRepresentationContext {
        constructor(ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth){
            super(ContextIdentifier, ContextType);
            this.ContextIdentifier = ContextIdentifier;
            this.ContextType = ContextType;
            this.CoordinateSpaceDimension = CoordinateSpaceDimension;
            this.Precision = Precision;
            this.WorldCoordinateSystem = WorldCoordinateSystem;
            this.TrueNorth = TrueNorth;
            this.type = 3448662350;
        }
    }
    IFC2X32.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;
    class IfcGeometricRepresentationItem extends IfcRepresentationItem {
        constructor(){
            super();
            this.type = 2453401579;
        }
    }
    IFC2X32.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;
    class IfcGeometricRepresentationSubContext extends IfcGeometricRepresentationContext {
        constructor(ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView){
            super(ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), null);
            this.ContextIdentifier = ContextIdentifier;
            this.ContextType = ContextType;
            this.ParentContext = ParentContext;
            this.TargetScale = TargetScale;
            this.TargetView = TargetView;
            this.UserDefinedTargetView = UserDefinedTargetView;
            this.type = 4142052618;
        }
    }
    IFC2X32.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;
    class IfcGeometricSet extends IfcGeometricRepresentationItem {
        constructor(Elements){
            super();
            this.Elements = Elements;
            this.type = 3590301190;
        }
    }
    IFC2X32.IfcGeometricSet = IfcGeometricSet;
    class IfcGridPlacement extends IfcObjectPlacement {
        constructor(PlacementLocation, PlacementRefDirection){
            super();
            this.PlacementLocation = PlacementLocation;
            this.PlacementRefDirection = PlacementRefDirection;
            this.type = 178086475;
        }
    }
    IFC2X32.IfcGridPlacement = IfcGridPlacement;
    class IfcHalfSpaceSolid extends IfcGeometricRepresentationItem {
        constructor(BaseSurface, AgreementFlag){
            super();
            this.BaseSurface = BaseSurface;
            this.AgreementFlag = AgreementFlag;
            this.type = 812098782;
        }
    }
    IFC2X32.IfcHalfSpaceSolid = IfcHalfSpaceSolid;
    class IfcHygroscopicMaterialProperties extends IfcMaterialProperties {
        constructor(Material, UpperVaporResistanceFactor, LowerVaporResistanceFactor, IsothermalMoistureCapacity, VaporPermeability, MoistureDiffusivity){
            super(Material);
            this.Material = Material;
            this.UpperVaporResistanceFactor = UpperVaporResistanceFactor;
            this.LowerVaporResistanceFactor = LowerVaporResistanceFactor;
            this.IsothermalMoistureCapacity = IsothermalMoistureCapacity;
            this.VaporPermeability = VaporPermeability;
            this.MoistureDiffusivity = MoistureDiffusivity;
            this.type = 2445078500;
        }
    }
    IFC2X32.IfcHygroscopicMaterialProperties = IfcHygroscopicMaterialProperties;
    class IfcImageTexture extends IfcSurfaceTexture {
        constructor(RepeatS, RepeatT, TextureType, TextureTransform, UrlReference){
            super(RepeatS, RepeatT, TextureType, TextureTransform);
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.TextureType = TextureType;
            this.TextureTransform = TextureTransform;
            this.UrlReference = UrlReference;
            this.type = 3905492369;
        }
    }
    IFC2X32.IfcImageTexture = IfcImageTexture;
    class IfcIrregularTimeSeries extends IfcTimeSeries {
        constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values){
            super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
            this.Name = Name;
            this.Description = Description;
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.TimeSeriesDataType = TimeSeriesDataType;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.Unit = Unit;
            this.Values = Values;
            this.type = 3741457305;
        }
    }
    IFC2X32.IfcIrregularTimeSeries = IfcIrregularTimeSeries;
    class IfcLightSource extends IfcGeometricRepresentationItem {
        constructor(Name, LightColour, AmbientIntensity, Intensity){
            super();
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.type = 1402838566;
        }
    }
    IFC2X32.IfcLightSource = IfcLightSource;
    class IfcLightSourceAmbient extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.type = 125510826;
        }
    }
    IFC2X32.IfcLightSourceAmbient = IfcLightSourceAmbient;
    class IfcLightSourceDirectional extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Orientation){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Orientation = Orientation;
            this.type = 2604431987;
        }
    }
    IFC2X32.IfcLightSourceDirectional = IfcLightSourceDirectional;
    class IfcLightSourceGoniometric extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Position = Position;
            this.ColourAppearance = ColourAppearance;
            this.ColourTemperature = ColourTemperature;
            this.LuminousFlux = LuminousFlux;
            this.LightEmissionSource = LightEmissionSource;
            this.LightDistributionDataSource = LightDistributionDataSource;
            this.type = 4266656042;
        }
    }
    IFC2X32.IfcLightSourceGoniometric = IfcLightSourceGoniometric;
    class IfcLightSourcePositional extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Position = Position;
            this.Radius = Radius;
            this.ConstantAttenuation = ConstantAttenuation;
            this.DistanceAttenuation = DistanceAttenuation;
            this.QuadricAttenuation = QuadricAttenuation;
            this.type = 1520743889;
        }
    }
    IFC2X32.IfcLightSourcePositional = IfcLightSourcePositional;
    class IfcLightSourceSpot extends IfcLightSourcePositional {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle){
            super(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Position = Position;
            this.Radius = Radius;
            this.ConstantAttenuation = ConstantAttenuation;
            this.DistanceAttenuation = DistanceAttenuation;
            this.QuadricAttenuation = QuadricAttenuation;
            this.Orientation = Orientation;
            this.ConcentrationExponent = ConcentrationExponent;
            this.SpreadAngle = SpreadAngle;
            this.BeamWidthAngle = BeamWidthAngle;
            this.type = 3422422726;
        }
    }
    IFC2X32.IfcLightSourceSpot = IfcLightSourceSpot;
    class IfcLocalPlacement extends IfcObjectPlacement {
        constructor(PlacementRelTo, RelativePlacement){
            super();
            this.PlacementRelTo = PlacementRelTo;
            this.RelativePlacement = RelativePlacement;
            this.type = 2624227202;
        }
    }
    IFC2X32.IfcLocalPlacement = IfcLocalPlacement;
    class IfcLoop extends IfcTopologicalRepresentationItem {
        constructor(){
            super();
            this.type = 1008929658;
        }
    }
    IFC2X32.IfcLoop = IfcLoop;
    class IfcMappedItem extends IfcRepresentationItem {
        constructor(MappingSource, MappingTarget){
            super();
            this.MappingSource = MappingSource;
            this.MappingTarget = MappingTarget;
            this.type = 2347385850;
        }
    }
    IFC2X32.IfcMappedItem = IfcMappedItem;
    class IfcMaterialDefinitionRepresentation extends IfcProductRepresentation {
        constructor(Name, Description, Representations, RepresentedMaterial){
            super(Name, Description, Representations);
            this.Name = Name;
            this.Description = Description;
            this.Representations = Representations;
            this.RepresentedMaterial = RepresentedMaterial;
            this.type = 2022407955;
        }
    }
    IFC2X32.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;
    class IfcMechanicalConcreteMaterialProperties extends IfcMechanicalMaterialProperties {
        constructor(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient, CompressiveStrength, MaxAggregateSize, AdmixturesDescription, Workability, ProtectivePoreRatio, WaterImpermeability){
            super(Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient);
            this.Material = Material;
            this.DynamicViscosity = DynamicViscosity;
            this.YoungModulus = YoungModulus;
            this.ShearModulus = ShearModulus;
            this.PoissonRatio = PoissonRatio;
            this.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
            this.CompressiveStrength = CompressiveStrength;
            this.MaxAggregateSize = MaxAggregateSize;
            this.AdmixturesDescription = AdmixturesDescription;
            this.Workability = Workability;
            this.ProtectivePoreRatio = ProtectivePoreRatio;
            this.WaterImpermeability = WaterImpermeability;
            this.type = 1430189142;
        }
    }
    IFC2X32.IfcMechanicalConcreteMaterialProperties = IfcMechanicalConcreteMaterialProperties;
    class IfcObjectDefinition extends IfcRoot {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 219451334;
        }
    }
    IFC2X32.IfcObjectDefinition = IfcObjectDefinition;
    class IfcOneDirectionRepeatFactor extends IfcGeometricRepresentationItem {
        constructor(RepeatFactor){
            super();
            this.RepeatFactor = RepeatFactor;
            this.type = 2833995503;
        }
    }
    IFC2X32.IfcOneDirectionRepeatFactor = IfcOneDirectionRepeatFactor;
    class IfcOpenShell extends IfcConnectedFaceSet {
        constructor(CfsFaces){
            super(CfsFaces);
            this.CfsFaces = CfsFaces;
            this.type = 2665983363;
        }
    }
    IFC2X32.IfcOpenShell = IfcOpenShell;
    class IfcOrientedEdge extends IfcEdge {
        constructor(EdgeElement, Orientation){
            super(new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), new $3b8da494b8e92f36$export$94890c79f4cae6d6(0));
            this.EdgeElement = EdgeElement;
            this.Orientation = Orientation;
            this.type = 1029017970;
        }
    }
    IFC2X32.IfcOrientedEdge = IfcOrientedEdge;
    class IfcParameterizedProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, Position){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.type = 2529465313;
        }
    }
    IFC2X32.IfcParameterizedProfileDef = IfcParameterizedProfileDef;
    class IfcPath extends IfcTopologicalRepresentationItem {
        constructor(EdgeList){
            super();
            this.EdgeList = EdgeList;
            this.type = 2519244187;
        }
    }
    IFC2X32.IfcPath = IfcPath;
    class IfcPhysicalComplexQuantity extends IfcPhysicalQuantity {
        constructor(Name, Description, HasQuantities, Discrimination, Quality, Usage){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.HasQuantities = HasQuantities;
            this.Discrimination = Discrimination;
            this.Quality = Quality;
            this.Usage = Usage;
            this.type = 3021840470;
        }
    }
    IFC2X32.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;
    class IfcPixelTexture extends IfcSurfaceTexture {
        constructor(RepeatS, RepeatT, TextureType, TextureTransform, Width, Height, ColourComponents, Pixel){
            super(RepeatS, RepeatT, TextureType, TextureTransform);
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.TextureType = TextureType;
            this.TextureTransform = TextureTransform;
            this.Width = Width;
            this.Height = Height;
            this.ColourComponents = ColourComponents;
            this.Pixel = Pixel;
            this.type = 597895409;
        }
    }
    IFC2X32.IfcPixelTexture = IfcPixelTexture;
    class IfcPlacement extends IfcGeometricRepresentationItem {
        constructor(Location){
            super();
            this.Location = Location;
            this.type = 2004835150;
        }
    }
    IFC2X32.IfcPlacement = IfcPlacement;
    class IfcPlanarExtent extends IfcGeometricRepresentationItem {
        constructor(SizeInX, SizeInY){
            super();
            this.SizeInX = SizeInX;
            this.SizeInY = SizeInY;
            this.type = 1663979128;
        }
    }
    IFC2X32.IfcPlanarExtent = IfcPlanarExtent;
    class IfcPoint extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 2067069095;
        }
    }
    IFC2X32.IfcPoint = IfcPoint;
    class IfcPointOnCurve extends IfcPoint {
        constructor(BasisCurve, PointParameter){
            super();
            this.BasisCurve = BasisCurve;
            this.PointParameter = PointParameter;
            this.type = 4022376103;
        }
    }
    IFC2X32.IfcPointOnCurve = IfcPointOnCurve;
    class IfcPointOnSurface extends IfcPoint {
        constructor(BasisSurface, PointParameterU, PointParameterV){
            super();
            this.BasisSurface = BasisSurface;
            this.PointParameterU = PointParameterU;
            this.PointParameterV = PointParameterV;
            this.type = 1423911732;
        }
    }
    IFC2X32.IfcPointOnSurface = IfcPointOnSurface;
    class IfcPolyLoop extends IfcLoop {
        constructor(Polygon){
            super();
            this.Polygon = Polygon;
            this.type = 2924175390;
        }
    }
    IFC2X32.IfcPolyLoop = IfcPolyLoop;
    class IfcPolygonalBoundedHalfSpace extends IfcHalfSpaceSolid {
        constructor(BaseSurface, AgreementFlag, Position, PolygonalBoundary){
            super(BaseSurface, AgreementFlag);
            this.BaseSurface = BaseSurface;
            this.AgreementFlag = AgreementFlag;
            this.Position = Position;
            this.PolygonalBoundary = PolygonalBoundary;
            this.type = 2775532180;
        }
    }
    IFC2X32.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;
    class IfcPreDefinedColour extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 759155922;
        }
    }
    IFC2X32.IfcPreDefinedColour = IfcPreDefinedColour;
    class IfcPreDefinedCurveFont extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 2559016684;
        }
    }
    IFC2X32.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;
    class IfcPreDefinedDimensionSymbol extends IfcPreDefinedSymbol {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 433424934;
        }
    }
    IFC2X32.IfcPreDefinedDimensionSymbol = IfcPreDefinedDimensionSymbol;
    class IfcPreDefinedPointMarkerSymbol extends IfcPreDefinedSymbol {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 179317114;
        }
    }
    IFC2X32.IfcPreDefinedPointMarkerSymbol = IfcPreDefinedPointMarkerSymbol;
    class IfcProductDefinitionShape extends IfcProductRepresentation {
        constructor(Name, Description, Representations){
            super(Name, Description, Representations);
            this.Name = Name;
            this.Description = Description;
            this.Representations = Representations;
            this.type = 673634403;
        }
    }
    IFC2X32.IfcProductDefinitionShape = IfcProductDefinitionShape;
    class IfcPropertyBoundedValue extends IfcSimpleProperty {
        constructor(Name, Description, UpperBoundValue, LowerBoundValue, Unit){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.UpperBoundValue = UpperBoundValue;
            this.LowerBoundValue = LowerBoundValue;
            this.Unit = Unit;
            this.type = 871118103;
        }
    }
    IFC2X32.IfcPropertyBoundedValue = IfcPropertyBoundedValue;
    class IfcPropertyDefinition extends IfcRoot {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 1680319473;
        }
    }
    IFC2X32.IfcPropertyDefinition = IfcPropertyDefinition;
    class IfcPropertyEnumeratedValue extends IfcSimpleProperty {
        constructor(Name, Description, EnumerationValues, EnumerationReference){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.EnumerationValues = EnumerationValues;
            this.EnumerationReference = EnumerationReference;
            this.type = 4166981789;
        }
    }
    IFC2X32.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;
    class IfcPropertyListValue extends IfcSimpleProperty {
        constructor(Name, Description, ListValues, Unit){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.ListValues = ListValues;
            this.Unit = Unit;
            this.type = 2752243245;
        }
    }
    IFC2X32.IfcPropertyListValue = IfcPropertyListValue;
    class IfcPropertyReferenceValue extends IfcSimpleProperty {
        constructor(Name, Description, UsageName, PropertyReference){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.UsageName = UsageName;
            this.PropertyReference = PropertyReference;
            this.type = 941946838;
        }
    }
    IFC2X32.IfcPropertyReferenceValue = IfcPropertyReferenceValue;
    class IfcPropertySetDefinition extends IfcPropertyDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 3357820518;
        }
    }
    IFC2X32.IfcPropertySetDefinition = IfcPropertySetDefinition;
    class IfcPropertySingleValue extends IfcSimpleProperty {
        constructor(Name, Description, NominalValue, Unit){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.NominalValue = NominalValue;
            this.Unit = Unit;
            this.type = 3650150729;
        }
    }
    IFC2X32.IfcPropertySingleValue = IfcPropertySingleValue;
    class IfcPropertyTableValue extends IfcSimpleProperty {
        constructor(Name, Description, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.DefiningValues = DefiningValues;
            this.DefinedValues = DefinedValues;
            this.Expression = Expression;
            this.DefiningUnit = DefiningUnit;
            this.DefinedUnit = DefinedUnit;
            this.type = 110355661;
        }
    }
    IFC2X32.IfcPropertyTableValue = IfcPropertyTableValue;
    class IfcRectangleProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, XDim, YDim){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.XDim = XDim;
            this.YDim = YDim;
            this.type = 3615266464;
        }
    }
    IFC2X32.IfcRectangleProfileDef = IfcRectangleProfileDef;
    class IfcRegularTimeSeries extends IfcTimeSeries {
        constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values){
            super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
            this.Name = Name;
            this.Description = Description;
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.TimeSeriesDataType = TimeSeriesDataType;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.Unit = Unit;
            this.TimeStep = TimeStep;
            this.Values = Values;
            this.type = 3413951693;
        }
    }
    IFC2X32.IfcRegularTimeSeries = IfcRegularTimeSeries;
    class IfcReinforcementDefinitionProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.DefinitionType = DefinitionType;
            this.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
            this.type = 3765753017;
        }
    }
    IFC2X32.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;
    class IfcRelationship extends IfcRoot {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 478536968;
        }
    }
    IFC2X32.IfcRelationship = IfcRelationship;
    class IfcRoundedRectangleProfileDef extends IfcRectangleProfileDef {
        constructor(ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius){
            super(ProfileType, ProfileName, Position, XDim, YDim);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.XDim = XDim;
            this.YDim = YDim;
            this.RoundingRadius = RoundingRadius;
            this.type = 2778083089;
        }
    }
    IFC2X32.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;
    class IfcSectionedSpine extends IfcGeometricRepresentationItem {
        constructor(SpineCurve, CrossSections, CrossSectionPositions){
            super();
            this.SpineCurve = SpineCurve;
            this.CrossSections = CrossSections;
            this.CrossSectionPositions = CrossSectionPositions;
            this.type = 1509187699;
        }
    }
    IFC2X32.IfcSectionedSpine = IfcSectionedSpine;
    class IfcServiceLifeFactor extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, PredefinedType, UpperValue, MostUsedValue, LowerValue){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.PredefinedType = PredefinedType;
            this.UpperValue = UpperValue;
            this.MostUsedValue = MostUsedValue;
            this.LowerValue = LowerValue;
            this.type = 2411513650;
        }
    }
    IFC2X32.IfcServiceLifeFactor = IfcServiceLifeFactor;
    class IfcShellBasedSurfaceModel extends IfcGeometricRepresentationItem {
        constructor(SbsmBoundary){
            super();
            this.SbsmBoundary = SbsmBoundary;
            this.type = 4124623270;
        }
    }
    IFC2X32.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;
    class IfcSlippageConnectionCondition extends IfcStructuralConnectionCondition {
        constructor(Name, SlippageX, SlippageY, SlippageZ){
            super(Name);
            this.Name = Name;
            this.SlippageX = SlippageX;
            this.SlippageY = SlippageY;
            this.SlippageZ = SlippageZ;
            this.type = 2609359061;
        }
    }
    IFC2X32.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;
    class IfcSolidModel extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 723233188;
        }
    }
    IFC2X32.IfcSolidModel = IfcSolidModel;
    class IfcSoundProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, IsAttenuating, SoundScale, SoundValues){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.IsAttenuating = IsAttenuating;
            this.SoundScale = SoundScale;
            this.SoundValues = SoundValues;
            this.type = 2485662743;
        }
    }
    IFC2X32.IfcSoundProperties = IfcSoundProperties;
    class IfcSoundValue extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, SoundLevelTimeSeries, Frequency, SoundLevelSingleValue){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.SoundLevelTimeSeries = SoundLevelTimeSeries;
            this.Frequency = Frequency;
            this.SoundLevelSingleValue = SoundLevelSingleValue;
            this.type = 1202362311;
        }
    }
    IFC2X32.IfcSoundValue = IfcSoundValue;
    class IfcSpaceThermalLoadProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableValueRatio, ThermalLoadSource, PropertySource, SourceDescription, MaximumValue, MinimumValue, ThermalLoadTimeSeriesValues, UserDefinedThermalLoadSource, UserDefinedPropertySource, ThermalLoadType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableValueRatio = ApplicableValueRatio;
            this.ThermalLoadSource = ThermalLoadSource;
            this.PropertySource = PropertySource;
            this.SourceDescription = SourceDescription;
            this.MaximumValue = MaximumValue;
            this.MinimumValue = MinimumValue;
            this.ThermalLoadTimeSeriesValues = ThermalLoadTimeSeriesValues;
            this.UserDefinedThermalLoadSource = UserDefinedThermalLoadSource;
            this.UserDefinedPropertySource = UserDefinedPropertySource;
            this.ThermalLoadType = ThermalLoadType;
            this.type = 390701378;
        }
    }
    IFC2X32.IfcSpaceThermalLoadProperties = IfcSpaceThermalLoadProperties;
    class IfcStructuralLoadLinearForce extends IfcStructuralLoadStatic {
        constructor(Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ){
            super(Name);
            this.Name = Name;
            this.LinearForceX = LinearForceX;
            this.LinearForceY = LinearForceY;
            this.LinearForceZ = LinearForceZ;
            this.LinearMomentX = LinearMomentX;
            this.LinearMomentY = LinearMomentY;
            this.LinearMomentZ = LinearMomentZ;
            this.type = 1595516126;
        }
    }
    IFC2X32.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;
    class IfcStructuralLoadPlanarForce extends IfcStructuralLoadStatic {
        constructor(Name, PlanarForceX, PlanarForceY, PlanarForceZ){
            super(Name);
            this.Name = Name;
            this.PlanarForceX = PlanarForceX;
            this.PlanarForceY = PlanarForceY;
            this.PlanarForceZ = PlanarForceZ;
            this.type = 2668620305;
        }
    }
    IFC2X32.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;
    class IfcStructuralLoadSingleDisplacement extends IfcStructuralLoadStatic {
        constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ){
            super(Name);
            this.Name = Name;
            this.DisplacementX = DisplacementX;
            this.DisplacementY = DisplacementY;
            this.DisplacementZ = DisplacementZ;
            this.RotationalDisplacementRX = RotationalDisplacementRX;
            this.RotationalDisplacementRY = RotationalDisplacementRY;
            this.RotationalDisplacementRZ = RotationalDisplacementRZ;
            this.type = 2473145415;
        }
    }
    IFC2X32.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;
    class IfcStructuralLoadSingleDisplacementDistortion extends IfcStructuralLoadSingleDisplacement {
        constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion){
            super(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
            this.Name = Name;
            this.DisplacementX = DisplacementX;
            this.DisplacementY = DisplacementY;
            this.DisplacementZ = DisplacementZ;
            this.RotationalDisplacementRX = RotationalDisplacementRX;
            this.RotationalDisplacementRY = RotationalDisplacementRY;
            this.RotationalDisplacementRZ = RotationalDisplacementRZ;
            this.Distortion = Distortion;
            this.type = 1973038258;
        }
    }
    IFC2X32.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;
    class IfcStructuralLoadSingleForce extends IfcStructuralLoadStatic {
        constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ){
            super(Name);
            this.Name = Name;
            this.ForceX = ForceX;
            this.ForceY = ForceY;
            this.ForceZ = ForceZ;
            this.MomentX = MomentX;
            this.MomentY = MomentY;
            this.MomentZ = MomentZ;
            this.type = 1597423693;
        }
    }
    IFC2X32.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;
    class IfcStructuralLoadSingleForceWarping extends IfcStructuralLoadSingleForce {
        constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment){
            super(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
            this.Name = Name;
            this.ForceX = ForceX;
            this.ForceY = ForceY;
            this.ForceZ = ForceZ;
            this.MomentX = MomentX;
            this.MomentY = MomentY;
            this.MomentZ = MomentZ;
            this.WarpingMoment = WarpingMoment;
            this.type = 1190533807;
        }
    }
    IFC2X32.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;
    class IfcStructuralProfileProperties extends IfcGeneralProfileProperties {
        constructor(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY){
            super(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea);
            this.ProfileName = ProfileName;
            this.ProfileDefinition = ProfileDefinition;
            this.PhysicalWeight = PhysicalWeight;
            this.Perimeter = Perimeter;
            this.MinimumPlateThickness = MinimumPlateThickness;
            this.MaximumPlateThickness = MaximumPlateThickness;
            this.CrossSectionArea = CrossSectionArea;
            this.TorsionalConstantX = TorsionalConstantX;
            this.MomentOfInertiaYZ = MomentOfInertiaYZ;
            this.MomentOfInertiaY = MomentOfInertiaY;
            this.MomentOfInertiaZ = MomentOfInertiaZ;
            this.WarpingConstant = WarpingConstant;
            this.ShearCentreZ = ShearCentreZ;
            this.ShearCentreY = ShearCentreY;
            this.ShearDeformationAreaZ = ShearDeformationAreaZ;
            this.ShearDeformationAreaY = ShearDeformationAreaY;
            this.MaximumSectionModulusY = MaximumSectionModulusY;
            this.MinimumSectionModulusY = MinimumSectionModulusY;
            this.MaximumSectionModulusZ = MaximumSectionModulusZ;
            this.MinimumSectionModulusZ = MinimumSectionModulusZ;
            this.TorsionalSectionModulus = TorsionalSectionModulus;
            this.CentreOfGravityInX = CentreOfGravityInX;
            this.CentreOfGravityInY = CentreOfGravityInY;
            this.type = 3843319758;
        }
    }
    IFC2X32.IfcStructuralProfileProperties = IfcStructuralProfileProperties;
    class IfcStructuralSteelProfileProperties extends IfcStructuralProfileProperties {
        constructor(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY, ShearAreaZ, ShearAreaY, PlasticShapeFactorY, PlasticShapeFactorZ){
            super(ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY);
            this.ProfileName = ProfileName;
            this.ProfileDefinition = ProfileDefinition;
            this.PhysicalWeight = PhysicalWeight;
            this.Perimeter = Perimeter;
            this.MinimumPlateThickness = MinimumPlateThickness;
            this.MaximumPlateThickness = MaximumPlateThickness;
            this.CrossSectionArea = CrossSectionArea;
            this.TorsionalConstantX = TorsionalConstantX;
            this.MomentOfInertiaYZ = MomentOfInertiaYZ;
            this.MomentOfInertiaY = MomentOfInertiaY;
            this.MomentOfInertiaZ = MomentOfInertiaZ;
            this.WarpingConstant = WarpingConstant;
            this.ShearCentreZ = ShearCentreZ;
            this.ShearCentreY = ShearCentreY;
            this.ShearDeformationAreaZ = ShearDeformationAreaZ;
            this.ShearDeformationAreaY = ShearDeformationAreaY;
            this.MaximumSectionModulusY = MaximumSectionModulusY;
            this.MinimumSectionModulusY = MinimumSectionModulusY;
            this.MaximumSectionModulusZ = MaximumSectionModulusZ;
            this.MinimumSectionModulusZ = MinimumSectionModulusZ;
            this.TorsionalSectionModulus = TorsionalSectionModulus;
            this.CentreOfGravityInX = CentreOfGravityInX;
            this.CentreOfGravityInY = CentreOfGravityInY;
            this.ShearAreaZ = ShearAreaZ;
            this.ShearAreaY = ShearAreaY;
            this.PlasticShapeFactorY = PlasticShapeFactorY;
            this.PlasticShapeFactorZ = PlasticShapeFactorZ;
            this.type = 3653947884;
        }
    }
    IFC2X32.IfcStructuralSteelProfileProperties = IfcStructuralSteelProfileProperties;
    class IfcSubedge extends IfcEdge {
        constructor(EdgeStart, EdgeEnd, ParentEdge){
            super(EdgeStart, EdgeEnd);
            this.EdgeStart = EdgeStart;
            this.EdgeEnd = EdgeEnd;
            this.ParentEdge = ParentEdge;
            this.type = 2233826070;
        }
    }
    IFC2X32.IfcSubedge = IfcSubedge;
    class IfcSurface extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 2513912981;
        }
    }
    IFC2X32.IfcSurface = IfcSurface;
    class IfcSurfaceStyleRendering extends IfcSurfaceStyleShading {
        constructor(SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod){
            super(SurfaceColour);
            this.SurfaceColour = SurfaceColour;
            this.Transparency = Transparency;
            this.DiffuseColour = DiffuseColour;
            this.TransmissionColour = TransmissionColour;
            this.DiffuseTransmissionColour = DiffuseTransmissionColour;
            this.ReflectionColour = ReflectionColour;
            this.SpecularColour = SpecularColour;
            this.SpecularHighlight = SpecularHighlight;
            this.ReflectanceMethod = ReflectanceMethod;
            this.type = 1878645084;
        }
    }
    IFC2X32.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;
    class IfcSweptAreaSolid extends IfcSolidModel {
        constructor(SweptArea, Position){
            super();
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.type = 2247615214;
        }
    }
    IFC2X32.IfcSweptAreaSolid = IfcSweptAreaSolid;
    class IfcSweptDiskSolid extends IfcSolidModel {
        constructor(Directrix, Radius, InnerRadius, StartParam, EndParam){
            super();
            this.Directrix = Directrix;
            this.Radius = Radius;
            this.InnerRadius = InnerRadius;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.type = 1260650574;
        }
    }
    IFC2X32.IfcSweptDiskSolid = IfcSweptDiskSolid;
    class IfcSweptSurface extends IfcSurface {
        constructor(SweptCurve, Position){
            super();
            this.SweptCurve = SweptCurve;
            this.Position = Position;
            this.type = 230924584;
        }
    }
    IFC2X32.IfcSweptSurface = IfcSweptSurface;
    class IfcTShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope, CentreOfGravityInY){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.FlangeWidth = FlangeWidth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.FlangeEdgeRadius = FlangeEdgeRadius;
            this.WebEdgeRadius = WebEdgeRadius;
            this.WebSlope = WebSlope;
            this.FlangeSlope = FlangeSlope;
            this.CentreOfGravityInY = CentreOfGravityInY;
            this.type = 3071757647;
        }
    }
    IFC2X32.IfcTShapeProfileDef = IfcTShapeProfileDef;
    class IfcTerminatorSymbol extends IfcAnnotationSymbolOccurrence {
        constructor(Item, Styles, Name, AnnotatedCurve){
            super(Item, Styles, Name);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.AnnotatedCurve = AnnotatedCurve;
            this.type = 3028897424;
        }
    }
    IFC2X32.IfcTerminatorSymbol = IfcTerminatorSymbol;
    class IfcTextLiteral extends IfcGeometricRepresentationItem {
        constructor(Literal, Placement, Path){
            super();
            this.Literal = Literal;
            this.Placement = Placement;
            this.Path = Path;
            this.type = 4282788508;
        }
    }
    IFC2X32.IfcTextLiteral = IfcTextLiteral;
    class IfcTextLiteralWithExtent extends IfcTextLiteral {
        constructor(Literal, Placement, Path, Extent, BoxAlignment){
            super(Literal, Placement, Path);
            this.Literal = Literal;
            this.Placement = Placement;
            this.Path = Path;
            this.Extent = Extent;
            this.BoxAlignment = BoxAlignment;
            this.type = 3124975700;
        }
    }
    IFC2X32.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;
    class IfcTrapeziumProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.BottomXDim = BottomXDim;
            this.TopXDim = TopXDim;
            this.YDim = YDim;
            this.TopXOffset = TopXOffset;
            this.type = 2715220739;
        }
    }
    IFC2X32.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;
    class IfcTwoDirectionRepeatFactor extends IfcOneDirectionRepeatFactor {
        constructor(RepeatFactor, SecondRepeatFactor){
            super(RepeatFactor);
            this.RepeatFactor = RepeatFactor;
            this.SecondRepeatFactor = SecondRepeatFactor;
            this.type = 1345879162;
        }
    }
    IFC2X32.IfcTwoDirectionRepeatFactor = IfcTwoDirectionRepeatFactor;
    class IfcTypeObject extends IfcObjectDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.type = 1628702193;
        }
    }
    IFC2X32.IfcTypeObject = IfcTypeObject;
    class IfcTypeProduct extends IfcTypeObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.type = 2347495698;
        }
    }
    IFC2X32.IfcTypeProduct = IfcTypeProduct;
    class IfcUShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope, CentreOfGravityInX){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.FlangeWidth = FlangeWidth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.EdgeRadius = EdgeRadius;
            this.FlangeSlope = FlangeSlope;
            this.CentreOfGravityInX = CentreOfGravityInX;
            this.type = 427810014;
        }
    }
    IFC2X32.IfcUShapeProfileDef = IfcUShapeProfileDef;
    class IfcVector extends IfcGeometricRepresentationItem {
        constructor(Orientation, Magnitude){
            super();
            this.Orientation = Orientation;
            this.Magnitude = Magnitude;
            this.type = 1417489154;
        }
    }
    IFC2X32.IfcVector = IfcVector;
    class IfcVertexLoop extends IfcLoop {
        constructor(LoopVertex){
            super();
            this.LoopVertex = LoopVertex;
            this.type = 2759199220;
        }
    }
    IFC2X32.IfcVertexLoop = IfcVertexLoop;
    class IfcWindowLiningProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.LiningDepth = LiningDepth;
            this.LiningThickness = LiningThickness;
            this.TransomThickness = TransomThickness;
            this.MullionThickness = MullionThickness;
            this.FirstTransomOffset = FirstTransomOffset;
            this.SecondTransomOffset = SecondTransomOffset;
            this.FirstMullionOffset = FirstMullionOffset;
            this.SecondMullionOffset = SecondMullionOffset;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 336235671;
        }
    }
    IFC2X32.IfcWindowLiningProperties = IfcWindowLiningProperties;
    class IfcWindowPanelProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.OperationType = OperationType;
            this.PanelPosition = PanelPosition;
            this.FrameDepth = FrameDepth;
            this.FrameThickness = FrameThickness;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 512836454;
        }
    }
    IFC2X32.IfcWindowPanelProperties = IfcWindowPanelProperties;
    class IfcWindowStyle extends IfcTypeProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ConstructionType, OperationType, ParameterTakesPrecedence, Sizeable){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ConstructionType = ConstructionType;
            this.OperationType = OperationType;
            this.ParameterTakesPrecedence = ParameterTakesPrecedence;
            this.Sizeable = Sizeable;
            this.type = 1299126871;
        }
    }
    IFC2X32.IfcWindowStyle = IfcWindowStyle;
    class IfcZShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.FlangeWidth = FlangeWidth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.EdgeRadius = EdgeRadius;
            this.type = 2543172580;
        }
    }
    IFC2X32.IfcZShapeProfileDef = IfcZShapeProfileDef;
    class IfcAnnotationCurveOccurrence extends IfcAnnotationOccurrence {
        constructor(Item, Styles, Name){
            super(Item, Styles, Name);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 3288037868;
        }
    }
    IFC2X32.IfcAnnotationCurveOccurrence = IfcAnnotationCurveOccurrence;
    class IfcAnnotationFillArea extends IfcGeometricRepresentationItem {
        constructor(OuterBoundary, InnerBoundaries){
            super();
            this.OuterBoundary = OuterBoundary;
            this.InnerBoundaries = InnerBoundaries;
            this.type = 669184980;
        }
    }
    IFC2X32.IfcAnnotationFillArea = IfcAnnotationFillArea;
    class IfcAnnotationFillAreaOccurrence extends IfcAnnotationOccurrence {
        constructor(Item, Styles, Name, FillStyleTarget, GlobalOrLocal){
            super(Item, Styles, Name);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.FillStyleTarget = FillStyleTarget;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 2265737646;
        }
    }
    IFC2X32.IfcAnnotationFillAreaOccurrence = IfcAnnotationFillAreaOccurrence;
    class IfcAnnotationSurface extends IfcGeometricRepresentationItem {
        constructor(Item, TextureCoordinates){
            super();
            this.Item = Item;
            this.TextureCoordinates = TextureCoordinates;
            this.type = 1302238472;
        }
    }
    IFC2X32.IfcAnnotationSurface = IfcAnnotationSurface;
    class IfcAxis1Placement extends IfcPlacement {
        constructor(Location, Axis){
            super(Location);
            this.Location = Location;
            this.Axis = Axis;
            this.type = 4261334040;
        }
    }
    IFC2X32.IfcAxis1Placement = IfcAxis1Placement;
    class IfcAxis2Placement2D extends IfcPlacement {
        constructor(Location, RefDirection){
            super(Location);
            this.Location = Location;
            this.RefDirection = RefDirection;
            this.type = 3125803723;
        }
    }
    IFC2X32.IfcAxis2Placement2D = IfcAxis2Placement2D;
    class IfcAxis2Placement3D extends IfcPlacement {
        constructor(Location, Axis, RefDirection){
            super(Location);
            this.Location = Location;
            this.Axis = Axis;
            this.RefDirection = RefDirection;
            this.type = 2740243338;
        }
    }
    IFC2X32.IfcAxis2Placement3D = IfcAxis2Placement3D;
    class IfcBooleanResult extends IfcGeometricRepresentationItem {
        constructor(Operator, FirstOperand, SecondOperand){
            super();
            this.Operator = Operator;
            this.FirstOperand = FirstOperand;
            this.SecondOperand = SecondOperand;
            this.type = 2736907675;
        }
    }
    IFC2X32.IfcBooleanResult = IfcBooleanResult;
    class IfcBoundedSurface extends IfcSurface {
        constructor(){
            super();
            this.type = 4182860854;
        }
    }
    IFC2X32.IfcBoundedSurface = IfcBoundedSurface;
    class IfcBoundingBox extends IfcGeometricRepresentationItem {
        constructor(Corner, XDim, YDim, ZDim){
            super();
            this.Corner = Corner;
            this.XDim = XDim;
            this.YDim = YDim;
            this.ZDim = ZDim;
            this.type = 2581212453;
        }
    }
    IFC2X32.IfcBoundingBox = IfcBoundingBox;
    class IfcBoxedHalfSpace extends IfcHalfSpaceSolid {
        constructor(BaseSurface, AgreementFlag, Enclosure){
            super(BaseSurface, AgreementFlag);
            this.BaseSurface = BaseSurface;
            this.AgreementFlag = AgreementFlag;
            this.Enclosure = Enclosure;
            this.type = 2713105998;
        }
    }
    IFC2X32.IfcBoxedHalfSpace = IfcBoxedHalfSpace;
    class IfcCShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius, CentreOfGravityInX){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.Width = Width;
            this.WallThickness = WallThickness;
            this.Girth = Girth;
            this.InternalFilletRadius = InternalFilletRadius;
            this.CentreOfGravityInX = CentreOfGravityInX;
            this.type = 2898889636;
        }
    }
    IFC2X32.IfcCShapeProfileDef = IfcCShapeProfileDef;
    class IfcCartesianPoint extends IfcPoint {
        constructor(Coordinates){
            super();
            this.Coordinates = Coordinates;
            this.type = 1123145078;
        }
    }
    IFC2X32.IfcCartesianPoint = IfcCartesianPoint;
    class IfcCartesianTransformationOperator extends IfcGeometricRepresentationItem {
        constructor(Axis1, Axis2, LocalOrigin, Scale){
            super();
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.type = 59481748;
        }
    }
    IFC2X32.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;
    class IfcCartesianTransformationOperator2D extends IfcCartesianTransformationOperator {
        constructor(Axis1, Axis2, LocalOrigin, Scale){
            super(Axis1, Axis2, LocalOrigin, Scale);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.type = 3749851601;
        }
    }
    IFC2X32.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;
    class IfcCartesianTransformationOperator2DnonUniform extends IfcCartesianTransformationOperator2D {
        constructor(Axis1, Axis2, LocalOrigin, Scale, Scale2){
            super(Axis1, Axis2, LocalOrigin, Scale);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.Scale2 = Scale2;
            this.type = 3486308946;
        }
    }
    IFC2X32.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;
    class IfcCartesianTransformationOperator3D extends IfcCartesianTransformationOperator {
        constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3){
            super(Axis1, Axis2, LocalOrigin, Scale);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.Axis3 = Axis3;
            this.type = 3331915920;
        }
    }
    IFC2X32.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;
    class IfcCartesianTransformationOperator3DnonUniform extends IfcCartesianTransformationOperator3D {
        constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3){
            super(Axis1, Axis2, LocalOrigin, Scale, Axis3);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.Axis3 = Axis3;
            this.Scale2 = Scale2;
            this.Scale3 = Scale3;
            this.type = 1416205885;
        }
    }
    IFC2X32.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;
    class IfcCircleProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Radius){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Radius = Radius;
            this.type = 1383045692;
        }
    }
    IFC2X32.IfcCircleProfileDef = IfcCircleProfileDef;
    class IfcClosedShell extends IfcConnectedFaceSet {
        constructor(CfsFaces){
            super(CfsFaces);
            this.CfsFaces = CfsFaces;
            this.type = 2205249479;
        }
    }
    IFC2X32.IfcClosedShell = IfcClosedShell;
    class IfcCompositeCurveSegment extends IfcGeometricRepresentationItem {
        constructor(Transition, SameSense, ParentCurve){
            super();
            this.Transition = Transition;
            this.SameSense = SameSense;
            this.ParentCurve = ParentCurve;
            this.type = 2485617015;
        }
    }
    IFC2X32.IfcCompositeCurveSegment = IfcCompositeCurveSegment;
    class IfcCraneRailAShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, OverallHeight, BaseWidth2, Radius, HeadWidth, HeadDepth2, HeadDepth3, WebThickness, BaseWidth4, BaseDepth1, BaseDepth2, BaseDepth3, CentreOfGravityInY){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.OverallHeight = OverallHeight;
            this.BaseWidth2 = BaseWidth2;
            this.Radius = Radius;
            this.HeadWidth = HeadWidth;
            this.HeadDepth2 = HeadDepth2;
            this.HeadDepth3 = HeadDepth3;
            this.WebThickness = WebThickness;
            this.BaseWidth4 = BaseWidth4;
            this.BaseDepth1 = BaseDepth1;
            this.BaseDepth2 = BaseDepth2;
            this.BaseDepth3 = BaseDepth3;
            this.CentreOfGravityInY = CentreOfGravityInY;
            this.type = 4133800736;
        }
    }
    IFC2X32.IfcCraneRailAShapeProfileDef = IfcCraneRailAShapeProfileDef;
    class IfcCraneRailFShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, OverallHeight, HeadWidth, Radius, HeadDepth2, HeadDepth3, WebThickness, BaseDepth1, BaseDepth2, CentreOfGravityInY){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.OverallHeight = OverallHeight;
            this.HeadWidth = HeadWidth;
            this.Radius = Radius;
            this.HeadDepth2 = HeadDepth2;
            this.HeadDepth3 = HeadDepth3;
            this.WebThickness = WebThickness;
            this.BaseDepth1 = BaseDepth1;
            this.BaseDepth2 = BaseDepth2;
            this.CentreOfGravityInY = CentreOfGravityInY;
            this.type = 194851669;
        }
    }
    IFC2X32.IfcCraneRailFShapeProfileDef = IfcCraneRailFShapeProfileDef;
    class IfcCsgPrimitive3D extends IfcGeometricRepresentationItem {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2506170314;
        }
    }
    IFC2X32.IfcCsgPrimitive3D = IfcCsgPrimitive3D;
    class IfcCsgSolid extends IfcSolidModel {
        constructor(TreeRootExpression){
            super();
            this.TreeRootExpression = TreeRootExpression;
            this.type = 2147822146;
        }
    }
    IFC2X32.IfcCsgSolid = IfcCsgSolid;
    class IfcCurve extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 2601014836;
        }
    }
    IFC2X32.IfcCurve = IfcCurve;
    class IfcCurveBoundedPlane extends IfcBoundedSurface {
        constructor(BasisSurface, OuterBoundary, InnerBoundaries){
            super();
            this.BasisSurface = BasisSurface;
            this.OuterBoundary = OuterBoundary;
            this.InnerBoundaries = InnerBoundaries;
            this.type = 2827736869;
        }
    }
    IFC2X32.IfcCurveBoundedPlane = IfcCurveBoundedPlane;
    class IfcDefinedSymbol extends IfcGeometricRepresentationItem {
        constructor(Definition, Target){
            super();
            this.Definition = Definition;
            this.Target = Target;
            this.type = 693772133;
        }
    }
    IFC2X32.IfcDefinedSymbol = IfcDefinedSymbol;
    class IfcDimensionCurve extends IfcAnnotationCurveOccurrence {
        constructor(Item, Styles, Name){
            super(Item, Styles, Name);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 606661476;
        }
    }
    IFC2X32.IfcDimensionCurve = IfcDimensionCurve;
    class IfcDimensionCurveTerminator extends IfcTerminatorSymbol {
        constructor(Item, Styles, Name, AnnotatedCurve, Role){
            super(Item, Styles, Name, AnnotatedCurve);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.AnnotatedCurve = AnnotatedCurve;
            this.Role = Role;
            this.type = 4054601972;
        }
    }
    IFC2X32.IfcDimensionCurveTerminator = IfcDimensionCurveTerminator;
    class IfcDirection extends IfcGeometricRepresentationItem {
        constructor(DirectionRatios){
            super();
            this.DirectionRatios = DirectionRatios;
            this.type = 32440307;
        }
    }
    IFC2X32.IfcDirection = IfcDirection;
    class IfcDoorLiningProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.LiningDepth = LiningDepth;
            this.LiningThickness = LiningThickness;
            this.ThresholdDepth = ThresholdDepth;
            this.ThresholdThickness = ThresholdThickness;
            this.TransomThickness = TransomThickness;
            this.TransomOffset = TransomOffset;
            this.LiningOffset = LiningOffset;
            this.ThresholdOffset = ThresholdOffset;
            this.CasingThickness = CasingThickness;
            this.CasingDepth = CasingDepth;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 2963535650;
        }
    }
    IFC2X32.IfcDoorLiningProperties = IfcDoorLiningProperties;
    class IfcDoorPanelProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.PanelDepth = PanelDepth;
            this.PanelOperation = PanelOperation;
            this.PanelWidth = PanelWidth;
            this.PanelPosition = PanelPosition;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 1714330368;
        }
    }
    IFC2X32.IfcDoorPanelProperties = IfcDoorPanelProperties;
    class IfcDoorStyle extends IfcTypeProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, OperationType, ConstructionType, ParameterTakesPrecedence, Sizeable){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.OperationType = OperationType;
            this.ConstructionType = ConstructionType;
            this.ParameterTakesPrecedence = ParameterTakesPrecedence;
            this.Sizeable = Sizeable;
            this.type = 526551008;
        }
    }
    IFC2X32.IfcDoorStyle = IfcDoorStyle;
    class IfcDraughtingCallout extends IfcGeometricRepresentationItem {
        constructor(Contents){
            super();
            this.Contents = Contents;
            this.type = 3073041342;
        }
    }
    IFC2X32.IfcDraughtingCallout = IfcDraughtingCallout;
    class IfcDraughtingPreDefinedColour extends IfcPreDefinedColour {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 445594917;
        }
    }
    IFC2X32.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;
    class IfcDraughtingPreDefinedCurveFont extends IfcPreDefinedCurveFont {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 4006246654;
        }
    }
    IFC2X32.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;
    class IfcEdgeLoop extends IfcLoop {
        constructor(EdgeList){
            super();
            this.EdgeList = EdgeList;
            this.type = 1472233963;
        }
    }
    IFC2X32.IfcEdgeLoop = IfcEdgeLoop;
    class IfcElementQuantity extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.MethodOfMeasurement = MethodOfMeasurement;
            this.Quantities = Quantities;
            this.type = 1883228015;
        }
    }
    IFC2X32.IfcElementQuantity = IfcElementQuantity;
    class IfcElementType extends IfcTypeProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 339256511;
        }
    }
    IFC2X32.IfcElementType = IfcElementType;
    class IfcElementarySurface extends IfcSurface {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2777663545;
        }
    }
    IFC2X32.IfcElementarySurface = IfcElementarySurface;
    class IfcEllipseProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.SemiAxis1 = SemiAxis1;
            this.SemiAxis2 = SemiAxis2;
            this.type = 2835456948;
        }
    }
    IFC2X32.IfcEllipseProfileDef = IfcEllipseProfileDef;
    class IfcEnergyProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.EnergySequence = EnergySequence;
            this.UserDefinedEnergySequence = UserDefinedEnergySequence;
            this.type = 80994333;
        }
    }
    IFC2X32.IfcEnergyProperties = IfcEnergyProperties;
    class IfcExtrudedAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, ExtrudedDirection, Depth){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.ExtrudedDirection = ExtrudedDirection;
            this.Depth = Depth;
            this.type = 477187591;
        }
    }
    IFC2X32.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;
    class IfcFaceBasedSurfaceModel extends IfcGeometricRepresentationItem {
        constructor(FbsmFaces){
            super();
            this.FbsmFaces = FbsmFaces;
            this.type = 2047409740;
        }
    }
    IFC2X32.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;
    class IfcFillAreaStyleHatching extends IfcGeometricRepresentationItem {
        constructor(HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle){
            super();
            this.HatchLineAppearance = HatchLineAppearance;
            this.StartOfNextHatchLine = StartOfNextHatchLine;
            this.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
            this.PatternStart = PatternStart;
            this.HatchLineAngle = HatchLineAngle;
            this.type = 374418227;
        }
    }
    IFC2X32.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;
    class IfcFillAreaStyleTileSymbolWithStyle extends IfcGeometricRepresentationItem {
        constructor(Symbol2){
            super();
            this.Symbol = Symbol2;
            this.type = 4203026998;
        }
    }
    IFC2X32.IfcFillAreaStyleTileSymbolWithStyle = IfcFillAreaStyleTileSymbolWithStyle;
    class IfcFillAreaStyleTiles extends IfcGeometricRepresentationItem {
        constructor(TilingPattern, Tiles, TilingScale){
            super();
            this.TilingPattern = TilingPattern;
            this.Tiles = Tiles;
            this.TilingScale = TilingScale;
            this.type = 315944413;
        }
    }
    IFC2X32.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;
    class IfcFluidFlowProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, PropertySource, FlowConditionTimeSeries, VelocityTimeSeries, FlowrateTimeSeries, Fluid, PressureTimeSeries, UserDefinedPropertySource, TemperatureSingleValue, WetBulbTemperatureSingleValue, WetBulbTemperatureTimeSeries, TemperatureTimeSeries, FlowrateSingleValue, FlowConditionSingleValue, VelocitySingleValue, PressureSingleValue){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.PropertySource = PropertySource;
            this.FlowConditionTimeSeries = FlowConditionTimeSeries;
            this.VelocityTimeSeries = VelocityTimeSeries;
            this.FlowrateTimeSeries = FlowrateTimeSeries;
            this.Fluid = Fluid;
            this.PressureTimeSeries = PressureTimeSeries;
            this.UserDefinedPropertySource = UserDefinedPropertySource;
            this.TemperatureSingleValue = TemperatureSingleValue;
            this.WetBulbTemperatureSingleValue = WetBulbTemperatureSingleValue;
            this.WetBulbTemperatureTimeSeries = WetBulbTemperatureTimeSeries;
            this.TemperatureTimeSeries = TemperatureTimeSeries;
            this.FlowrateSingleValue = FlowrateSingleValue;
            this.FlowConditionSingleValue = FlowConditionSingleValue;
            this.VelocitySingleValue = VelocitySingleValue;
            this.PressureSingleValue = PressureSingleValue;
            this.type = 3455213021;
        }
    }
    IFC2X32.IfcFluidFlowProperties = IfcFluidFlowProperties;
    class IfcFurnishingElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 4238390223;
        }
    }
    IFC2X32.IfcFurnishingElementType = IfcFurnishingElementType;
    class IfcFurnitureType extends IfcFurnishingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.AssemblyPlace = AssemblyPlace;
            this.type = 1268542332;
        }
    }
    IFC2X32.IfcFurnitureType = IfcFurnitureType;
    class IfcGeometricCurveSet extends IfcGeometricSet {
        constructor(Elements){
            super(Elements);
            this.Elements = Elements;
            this.type = 987898635;
        }
    }
    IFC2X32.IfcGeometricCurveSet = IfcGeometricCurveSet;
    class IfcIShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.OverallWidth = OverallWidth;
            this.OverallDepth = OverallDepth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.type = 1484403080;
        }
    }
    IFC2X32.IfcIShapeProfileDef = IfcIShapeProfileDef;
    class IfcLShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope, CentreOfGravityInX, CentreOfGravityInY){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.Width = Width;
            this.Thickness = Thickness;
            this.FilletRadius = FilletRadius;
            this.EdgeRadius = EdgeRadius;
            this.LegSlope = LegSlope;
            this.CentreOfGravityInX = CentreOfGravityInX;
            this.CentreOfGravityInY = CentreOfGravityInY;
            this.type = 572779678;
        }
    }
    IFC2X32.IfcLShapeProfileDef = IfcLShapeProfileDef;
    class IfcLine extends IfcCurve {
        constructor(Pnt, Dir){
            super();
            this.Pnt = Pnt;
            this.Dir = Dir;
            this.type = 1281925730;
        }
    }
    IFC2X32.IfcLine = IfcLine;
    class IfcManifoldSolidBrep extends IfcSolidModel {
        constructor(Outer){
            super();
            this.Outer = Outer;
            this.type = 1425443689;
        }
    }
    IFC2X32.IfcManifoldSolidBrep = IfcManifoldSolidBrep;
    class IfcObject extends IfcObjectDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 3888040117;
        }
    }
    IFC2X32.IfcObject = IfcObject;
    class IfcOffsetCurve2D extends IfcCurve {
        constructor(BasisCurve, Distance, SelfIntersect){
            super();
            this.BasisCurve = BasisCurve;
            this.Distance = Distance;
            this.SelfIntersect = SelfIntersect;
            this.type = 3388369263;
        }
    }
    IFC2X32.IfcOffsetCurve2D = IfcOffsetCurve2D;
    class IfcOffsetCurve3D extends IfcCurve {
        constructor(BasisCurve, Distance, SelfIntersect, RefDirection){
            super();
            this.BasisCurve = BasisCurve;
            this.Distance = Distance;
            this.SelfIntersect = SelfIntersect;
            this.RefDirection = RefDirection;
            this.type = 3505215534;
        }
    }
    IFC2X32.IfcOffsetCurve3D = IfcOffsetCurve3D;
    class IfcPermeableCoveringProperties extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.OperationType = OperationType;
            this.PanelPosition = PanelPosition;
            this.FrameDepth = FrameDepth;
            this.FrameThickness = FrameThickness;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 3566463478;
        }
    }
    IFC2X32.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;
    class IfcPlanarBox extends IfcPlanarExtent {
        constructor(SizeInX, SizeInY, Placement){
            super(SizeInX, SizeInY);
            this.SizeInX = SizeInX;
            this.SizeInY = SizeInY;
            this.Placement = Placement;
            this.type = 603570806;
        }
    }
    IFC2X32.IfcPlanarBox = IfcPlanarBox;
    class IfcPlane extends IfcElementarySurface {
        constructor(Position){
            super(Position);
            this.Position = Position;
            this.type = 220341763;
        }
    }
    IFC2X32.IfcPlane = IfcPlane;
    class IfcProcess extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 2945172077;
        }
    }
    IFC2X32.IfcProcess = IfcProcess;
    class IfcProduct extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 4208778838;
        }
    }
    IFC2X32.IfcProduct = IfcProduct;
    class IfcProject extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.Phase = Phase;
            this.RepresentationContexts = RepresentationContexts;
            this.UnitsInContext = UnitsInContext;
            this.type = 103090709;
        }
    }
    IFC2X32.IfcProject = IfcProject;
    class IfcProjectionCurve extends IfcAnnotationCurveOccurrence {
        constructor(Item, Styles, Name){
            super(Item, Styles, Name);
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 4194566429;
        }
    }
    IFC2X32.IfcProjectionCurve = IfcProjectionCurve;
    class IfcPropertySet extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, HasProperties){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.HasProperties = HasProperties;
            this.type = 1451395588;
        }
    }
    IFC2X32.IfcPropertySet = IfcPropertySet;
    class IfcProxy extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, ProxyType, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.ProxyType = ProxyType;
            this.Tag = Tag;
            this.type = 3219374653;
        }
    }
    IFC2X32.IfcProxy = IfcProxy;
    class IfcRectangleHollowProfileDef extends IfcRectangleProfileDef {
        constructor(ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius){
            super(ProfileType, ProfileName, Position, XDim, YDim);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.XDim = XDim;
            this.YDim = YDim;
            this.WallThickness = WallThickness;
            this.InnerFilletRadius = InnerFilletRadius;
            this.OuterFilletRadius = OuterFilletRadius;
            this.type = 2770003689;
        }
    }
    IFC2X32.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;
    class IfcRectangularPyramid extends IfcCsgPrimitive3D {
        constructor(Position, XLength, YLength, Height){
            super(Position);
            this.Position = Position;
            this.XLength = XLength;
            this.YLength = YLength;
            this.Height = Height;
            this.type = 2798486643;
        }
    }
    IFC2X32.IfcRectangularPyramid = IfcRectangularPyramid;
    class IfcRectangularTrimmedSurface extends IfcBoundedSurface {
        constructor(BasisSurface, U1, V1, U2, V2, Usense, Vsense){
            super();
            this.BasisSurface = BasisSurface;
            this.U1 = U1;
            this.V1 = V1;
            this.U2 = U2;
            this.V2 = V2;
            this.Usense = Usense;
            this.Vsense = Vsense;
            this.type = 3454111270;
        }
    }
    IFC2X32.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;
    class IfcRelAssigns extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.type = 3939117080;
        }
    }
    IFC2X32.IfcRelAssigns = IfcRelAssigns;
    class IfcRelAssignsToActor extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingActor = RelatingActor;
            this.ActingRole = ActingRole;
            this.type = 1683148259;
        }
    }
    IFC2X32.IfcRelAssignsToActor = IfcRelAssignsToActor;
    class IfcRelAssignsToControl extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingControl = RelatingControl;
            this.type = 2495723537;
        }
    }
    IFC2X32.IfcRelAssignsToControl = IfcRelAssignsToControl;
    class IfcRelAssignsToGroup extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingGroup = RelatingGroup;
            this.type = 1307041759;
        }
    }
    IFC2X32.IfcRelAssignsToGroup = IfcRelAssignsToGroup;
    class IfcRelAssignsToProcess extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingProcess = RelatingProcess;
            this.QuantityInProcess = QuantityInProcess;
            this.type = 4278684876;
        }
    }
    IFC2X32.IfcRelAssignsToProcess = IfcRelAssignsToProcess;
    class IfcRelAssignsToProduct extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingProduct = RelatingProduct;
            this.type = 2857406711;
        }
    }
    IFC2X32.IfcRelAssignsToProduct = IfcRelAssignsToProduct;
    class IfcRelAssignsToProjectOrder extends IfcRelAssignsToControl {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingControl = RelatingControl;
            this.type = 3372526763;
        }
    }
    IFC2X32.IfcRelAssignsToProjectOrder = IfcRelAssignsToProjectOrder;
    class IfcRelAssignsToResource extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingResource = RelatingResource;
            this.type = 205026976;
        }
    }
    IFC2X32.IfcRelAssignsToResource = IfcRelAssignsToResource;
    class IfcRelAssociates extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.type = 1865459582;
        }
    }
    IFC2X32.IfcRelAssociates = IfcRelAssociates;
    class IfcRelAssociatesAppliedValue extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingAppliedValue){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingAppliedValue = RelatingAppliedValue;
            this.type = 1327628568;
        }
    }
    IFC2X32.IfcRelAssociatesAppliedValue = IfcRelAssociatesAppliedValue;
    class IfcRelAssociatesApproval extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingApproval = RelatingApproval;
            this.type = 4095574036;
        }
    }
    IFC2X32.IfcRelAssociatesApproval = IfcRelAssociatesApproval;
    class IfcRelAssociatesClassification extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingClassification = RelatingClassification;
            this.type = 919958153;
        }
    }
    IFC2X32.IfcRelAssociatesClassification = IfcRelAssociatesClassification;
    class IfcRelAssociatesConstraint extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.Intent = Intent;
            this.RelatingConstraint = RelatingConstraint;
            this.type = 2728634034;
        }
    }
    IFC2X32.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;
    class IfcRelAssociatesDocument extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingDocument = RelatingDocument;
            this.type = 982818633;
        }
    }
    IFC2X32.IfcRelAssociatesDocument = IfcRelAssociatesDocument;
    class IfcRelAssociatesLibrary extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingLibrary = RelatingLibrary;
            this.type = 3840914261;
        }
    }
    IFC2X32.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;
    class IfcRelAssociatesMaterial extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingMaterial = RelatingMaterial;
            this.type = 2655215786;
        }
    }
    IFC2X32.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;
    class IfcRelAssociatesProfileProperties extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingProfileProperties, ProfileSectionLocation, ProfileOrientation){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingProfileProperties = RelatingProfileProperties;
            this.ProfileSectionLocation = ProfileSectionLocation;
            this.ProfileOrientation = ProfileOrientation;
            this.type = 2851387026;
        }
    }
    IFC2X32.IfcRelAssociatesProfileProperties = IfcRelAssociatesProfileProperties;
    class IfcRelConnects extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 826625072;
        }
    }
    IFC2X32.IfcRelConnects = IfcRelConnects;
    class IfcRelConnectsElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ConnectionGeometry = ConnectionGeometry;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.type = 1204542856;
        }
    }
    IFC2X32.IfcRelConnectsElements = IfcRelConnectsElements;
    class IfcRelConnectsPathElements extends IfcRelConnectsElements {
        constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType){
            super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ConnectionGeometry = ConnectionGeometry;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.RelatingPriorities = RelatingPriorities;
            this.RelatedPriorities = RelatedPriorities;
            this.RelatedConnectionType = RelatedConnectionType;
            this.RelatingConnectionType = RelatingConnectionType;
            this.type = 3945020480;
        }
    }
    IFC2X32.IfcRelConnectsPathElements = IfcRelConnectsPathElements;
    class IfcRelConnectsPortToElement extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingPort = RelatingPort;
            this.RelatedElement = RelatedElement;
            this.type = 4201705270;
        }
    }
    IFC2X32.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;
    class IfcRelConnectsPorts extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingPort = RelatingPort;
            this.RelatedPort = RelatedPort;
            this.RealizingElement = RealizingElement;
            this.type = 3190031847;
        }
    }
    IFC2X32.IfcRelConnectsPorts = IfcRelConnectsPorts;
    class IfcRelConnectsStructuralActivity extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedStructuralActivity = RelatedStructuralActivity;
            this.type = 2127690289;
        }
    }
    IFC2X32.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;
    class IfcRelConnectsStructuralElement extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralMember){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedStructuralMember = RelatedStructuralMember;
            this.type = 3912681535;
        }
    }
    IFC2X32.IfcRelConnectsStructuralElement = IfcRelConnectsStructuralElement;
    class IfcRelConnectsStructuralMember extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingStructuralMember = RelatingStructuralMember;
            this.RelatedStructuralConnection = RelatedStructuralConnection;
            this.AppliedCondition = AppliedCondition;
            this.AdditionalConditions = AdditionalConditions;
            this.SupportedLength = SupportedLength;
            this.ConditionCoordinateSystem = ConditionCoordinateSystem;
            this.type = 1638771189;
        }
    }
    IFC2X32.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;
    class IfcRelConnectsWithEccentricity extends IfcRelConnectsStructuralMember {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint){
            super(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingStructuralMember = RelatingStructuralMember;
            this.RelatedStructuralConnection = RelatedStructuralConnection;
            this.AppliedCondition = AppliedCondition;
            this.AdditionalConditions = AdditionalConditions;
            this.SupportedLength = SupportedLength;
            this.ConditionCoordinateSystem = ConditionCoordinateSystem;
            this.ConnectionConstraint = ConnectionConstraint;
            this.type = 504942748;
        }
    }
    IFC2X32.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;
    class IfcRelConnectsWithRealizingElements extends IfcRelConnectsElements {
        constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType){
            super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ConnectionGeometry = ConnectionGeometry;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.RealizingElements = RealizingElements;
            this.ConnectionType = ConnectionType;
            this.type = 3678494232;
        }
    }
    IFC2X32.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;
    class IfcRelContainedInSpatialStructure extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedElements = RelatedElements;
            this.RelatingStructure = RelatingStructure;
            this.type = 3242617779;
        }
    }
    IFC2X32.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;
    class IfcRelCoversBldgElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingBuildingElement = RelatingBuildingElement;
            this.RelatedCoverings = RelatedCoverings;
            this.type = 886880790;
        }
    }
    IFC2X32.IfcRelCoversBldgElements = IfcRelCoversBldgElements;
    class IfcRelCoversSpaces extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedSpace, RelatedCoverings){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedSpace = RelatedSpace;
            this.RelatedCoverings = RelatedCoverings;
            this.type = 2802773753;
        }
    }
    IFC2X32.IfcRelCoversSpaces = IfcRelCoversSpaces;
    class IfcRelDecomposes extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingObject = RelatingObject;
            this.RelatedObjects = RelatedObjects;
            this.type = 2551354335;
        }
    }
    IFC2X32.IfcRelDecomposes = IfcRelDecomposes;
    class IfcRelDefines extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.type = 693640335;
        }
    }
    IFC2X32.IfcRelDefines = IfcRelDefines;
    class IfcRelDefinesByProperties extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingPropertyDefinition = RelatingPropertyDefinition;
            this.type = 4186316022;
        }
    }
    IFC2X32.IfcRelDefinesByProperties = IfcRelDefinesByProperties;
    class IfcRelDefinesByType extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingType = RelatingType;
            this.type = 781010003;
        }
    }
    IFC2X32.IfcRelDefinesByType = IfcRelDefinesByType;
    class IfcRelFillsElement extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingOpeningElement = RelatingOpeningElement;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.type = 3940055652;
        }
    }
    IFC2X32.IfcRelFillsElement = IfcRelFillsElement;
    class IfcRelFlowControlElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedControlElements = RelatedControlElements;
            this.RelatingFlowElement = RelatingFlowElement;
            this.type = 279856033;
        }
    }
    IFC2X32.IfcRelFlowControlElements = IfcRelFlowControlElements;
    class IfcRelInteractionRequirements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, DailyInteraction, ImportanceRating, LocationOfInteraction, RelatedSpaceProgram, RelatingSpaceProgram){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.DailyInteraction = DailyInteraction;
            this.ImportanceRating = ImportanceRating;
            this.LocationOfInteraction = LocationOfInteraction;
            this.RelatedSpaceProgram = RelatedSpaceProgram;
            this.RelatingSpaceProgram = RelatingSpaceProgram;
            this.type = 4189434867;
        }
    }
    IFC2X32.IfcRelInteractionRequirements = IfcRelInteractionRequirements;
    class IfcRelNests extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingObject = RelatingObject;
            this.RelatedObjects = RelatedObjects;
            this.type = 3268803585;
        }
    }
    IFC2X32.IfcRelNests = IfcRelNests;
    class IfcRelOccupiesSpaces extends IfcRelAssignsToActor {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingActor = RelatingActor;
            this.ActingRole = ActingRole;
            this.type = 2051452291;
        }
    }
    IFC2X32.IfcRelOccupiesSpaces = IfcRelOccupiesSpaces;
    class IfcRelOverridesProperties extends IfcRelDefinesByProperties {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition, OverridingProperties){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingPropertyDefinition = RelatingPropertyDefinition;
            this.OverridingProperties = OverridingProperties;
            this.type = 202636808;
        }
    }
    IFC2X32.IfcRelOverridesProperties = IfcRelOverridesProperties;
    class IfcRelProjectsElement extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedFeatureElement = RelatedFeatureElement;
            this.type = 750771296;
        }
    }
    IFC2X32.IfcRelProjectsElement = IfcRelProjectsElement;
    class IfcRelReferencedInSpatialStructure extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedElements = RelatedElements;
            this.RelatingStructure = RelatingStructure;
            this.type = 1245217292;
        }
    }
    IFC2X32.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;
    class IfcRelSchedulesCostItems extends IfcRelAssignsToControl {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingControl = RelatingControl;
            this.type = 1058617721;
        }
    }
    IFC2X32.IfcRelSchedulesCostItems = IfcRelSchedulesCostItems;
    class IfcRelSequence extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingProcess = RelatingProcess;
            this.RelatedProcess = RelatedProcess;
            this.TimeLag = TimeLag;
            this.SequenceType = SequenceType;
            this.type = 4122056220;
        }
    }
    IFC2X32.IfcRelSequence = IfcRelSequence;
    class IfcRelServicesBuildings extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSystem = RelatingSystem;
            this.RelatedBuildings = RelatedBuildings;
            this.type = 366585022;
        }
    }
    IFC2X32.IfcRelServicesBuildings = IfcRelServicesBuildings;
    class IfcRelSpaceBoundary extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSpace = RelatingSpace;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.ConnectionGeometry = ConnectionGeometry;
            this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
            this.InternalOrExternalBoundary = InternalOrExternalBoundary;
            this.type = 3451746338;
        }
    }
    IFC2X32.IfcRelSpaceBoundary = IfcRelSpaceBoundary;
    class IfcRelVoidsElement extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingBuildingElement = RelatingBuildingElement;
            this.RelatedOpeningElement = RelatedOpeningElement;
            this.type = 1401173127;
        }
    }
    IFC2X32.IfcRelVoidsElement = IfcRelVoidsElement;
    class IfcResource extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 2914609552;
        }
    }
    IFC2X32.IfcResource = IfcResource;
    class IfcRevolvedAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, Axis, Angle){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Axis = Axis;
            this.Angle = Angle;
            this.type = 1856042241;
        }
    }
    IFC2X32.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;
    class IfcRightCircularCone extends IfcCsgPrimitive3D {
        constructor(Position, Height, BottomRadius){
            super(Position);
            this.Position = Position;
            this.Height = Height;
            this.BottomRadius = BottomRadius;
            this.type = 4158566097;
        }
    }
    IFC2X32.IfcRightCircularCone = IfcRightCircularCone;
    class IfcRightCircularCylinder extends IfcCsgPrimitive3D {
        constructor(Position, Height, Radius){
            super(Position);
            this.Position = Position;
            this.Height = Height;
            this.Radius = Radius;
            this.type = 3626867408;
        }
    }
    IFC2X32.IfcRightCircularCylinder = IfcRightCircularCylinder;
    class IfcSpatialStructureElement extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.type = 2706606064;
        }
    }
    IFC2X32.IfcSpatialStructureElement = IfcSpatialStructureElement;
    class IfcSpatialStructureElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3893378262;
        }
    }
    IFC2X32.IfcSpatialStructureElementType = IfcSpatialStructureElementType;
    class IfcSphere extends IfcCsgPrimitive3D {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 451544542;
        }
    }
    IFC2X32.IfcSphere = IfcSphere;
    class IfcStructuralActivity extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 3544373492;
        }
    }
    IFC2X32.IfcStructuralActivity = IfcStructuralActivity;
    class IfcStructuralItem extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 3136571912;
        }
    }
    IFC2X32.IfcStructuralItem = IfcStructuralItem;
    class IfcStructuralMember extends IfcStructuralItem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 530289379;
        }
    }
    IFC2X32.IfcStructuralMember = IfcStructuralMember;
    class IfcStructuralReaction extends IfcStructuralActivity {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 3689010777;
        }
    }
    IFC2X32.IfcStructuralReaction = IfcStructuralReaction;
    class IfcStructuralSurfaceMember extends IfcStructuralMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Thickness = Thickness;
            this.type = 3979015343;
        }
    }
    IFC2X32.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;
    class IfcStructuralSurfaceMemberVarying extends IfcStructuralSurfaceMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness, SubsequentThickness, VaryingThicknessLocation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Thickness = Thickness;
            this.SubsequentThickness = SubsequentThickness;
            this.VaryingThicknessLocation = VaryingThicknessLocation;
            this.type = 2218152070;
        }
    }
    IFC2X32.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;
    class IfcStructuredDimensionCallout extends IfcDraughtingCallout {
        constructor(Contents){
            super(Contents);
            this.Contents = Contents;
            this.type = 4070609034;
        }
    }
    IFC2X32.IfcStructuredDimensionCallout = IfcStructuredDimensionCallout;
    class IfcSurfaceCurveSweptAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Directrix = Directrix;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.ReferenceSurface = ReferenceSurface;
            this.type = 2028607225;
        }
    }
    IFC2X32.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;
    class IfcSurfaceOfLinearExtrusion extends IfcSweptSurface {
        constructor(SweptCurve, Position, ExtrudedDirection, Depth){
            super(SweptCurve, Position);
            this.SweptCurve = SweptCurve;
            this.Position = Position;
            this.ExtrudedDirection = ExtrudedDirection;
            this.Depth = Depth;
            this.type = 2809605785;
        }
    }
    IFC2X32.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;
    class IfcSurfaceOfRevolution extends IfcSweptSurface {
        constructor(SweptCurve, Position, AxisPosition){
            super(SweptCurve, Position);
            this.SweptCurve = SweptCurve;
            this.Position = Position;
            this.AxisPosition = AxisPosition;
            this.type = 4124788165;
        }
    }
    IFC2X32.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;
    class IfcSystemFurnitureElementType extends IfcFurnishingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1580310250;
        }
    }
    IFC2X32.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;
    class IfcTask extends IfcProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TaskId = TaskId;
            this.Status = Status;
            this.WorkMethod = WorkMethod;
            this.IsMilestone = IsMilestone;
            this.Priority = Priority;
            this.type = 3473067441;
        }
    }
    IFC2X32.IfcTask = IfcTask;
    class IfcTransportElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2097647324;
        }
    }
    IFC2X32.IfcTransportElementType = IfcTransportElementType;
    class IfcActor extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TheActor = TheActor;
            this.type = 2296667514;
        }
    }
    IFC2X32.IfcActor = IfcActor;
    class IfcAnnotation extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 1674181508;
        }
    }
    IFC2X32.IfcAnnotation = IfcAnnotation;
    class IfcAsymmetricIShapeProfileDef extends IfcIShapeProfileDef {
        constructor(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, CentreOfGravityInY){
            super(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.OverallWidth = OverallWidth;
            this.OverallDepth = OverallDepth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.TopFlangeWidth = TopFlangeWidth;
            this.TopFlangeThickness = TopFlangeThickness;
            this.TopFlangeFilletRadius = TopFlangeFilletRadius;
            this.CentreOfGravityInY = CentreOfGravityInY;
            this.type = 3207858831;
        }
    }
    IFC2X32.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;
    class IfcBlock extends IfcCsgPrimitive3D {
        constructor(Position, XLength, YLength, ZLength){
            super(Position);
            this.Position = Position;
            this.XLength = XLength;
            this.YLength = YLength;
            this.ZLength = ZLength;
            this.type = 1334484129;
        }
    }
    IFC2X32.IfcBlock = IfcBlock;
    class IfcBooleanClippingResult extends IfcBooleanResult {
        constructor(Operator, FirstOperand, SecondOperand){
            super(Operator, FirstOperand, SecondOperand);
            this.Operator = Operator;
            this.FirstOperand = FirstOperand;
            this.SecondOperand = SecondOperand;
            this.type = 3649129432;
        }
    }
    IFC2X32.IfcBooleanClippingResult = IfcBooleanClippingResult;
    class IfcBoundedCurve extends IfcCurve {
        constructor(){
            super();
            this.type = 1260505505;
        }
    }
    IFC2X32.IfcBoundedCurve = IfcBoundedCurve;
    class IfcBuilding extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.ElevationOfRefHeight = ElevationOfRefHeight;
            this.ElevationOfTerrain = ElevationOfTerrain;
            this.BuildingAddress = BuildingAddress;
            this.type = 4031249490;
        }
    }
    IFC2X32.IfcBuilding = IfcBuilding;
    class IfcBuildingElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1950629157;
        }
    }
    IFC2X32.IfcBuildingElementType = IfcBuildingElementType;
    class IfcBuildingStorey extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.Elevation = Elevation;
            this.type = 3124254112;
        }
    }
    IFC2X32.IfcBuildingStorey = IfcBuildingStorey;
    class IfcCircleHollowProfileDef extends IfcCircleProfileDef {
        constructor(ProfileType, ProfileName, Position, Radius, WallThickness){
            super(ProfileType, ProfileName, Position, Radius);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Radius = Radius;
            this.WallThickness = WallThickness;
            this.type = 2937912522;
        }
    }
    IFC2X32.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;
    class IfcColumnType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 300633059;
        }
    }
    IFC2X32.IfcColumnType = IfcColumnType;
    class IfcCompositeCurve extends IfcBoundedCurve {
        constructor(Segments, SelfIntersect){
            super();
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 3732776249;
        }
    }
    IFC2X32.IfcCompositeCurve = IfcCompositeCurve;
    class IfcConic extends IfcCurve {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2510884976;
        }
    }
    IFC2X32.IfcConic = IfcConic;
    class IfcConstructionResource extends IfcResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ResourceIdentifier = ResourceIdentifier;
            this.ResourceGroup = ResourceGroup;
            this.ResourceConsumption = ResourceConsumption;
            this.BaseQuantity = BaseQuantity;
            this.type = 2559216714;
        }
    }
    IFC2X32.IfcConstructionResource = IfcConstructionResource;
    class IfcControl extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 3293443760;
        }
    }
    IFC2X32.IfcControl = IfcControl;
    class IfcCostItem extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 3895139033;
        }
    }
    IFC2X32.IfcCostItem = IfcCostItem;
    class IfcCostSchedule extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, SubmittedBy, PreparedBy, SubmittedOn, Status, TargetUsers, UpdateDate, ID, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.SubmittedBy = SubmittedBy;
            this.PreparedBy = PreparedBy;
            this.SubmittedOn = SubmittedOn;
            this.Status = Status;
            this.TargetUsers = TargetUsers;
            this.UpdateDate = UpdateDate;
            this.ID = ID;
            this.PredefinedType = PredefinedType;
            this.type = 1419761937;
        }
    }
    IFC2X32.IfcCostSchedule = IfcCostSchedule;
    class IfcCoveringType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1916426348;
        }
    }
    IFC2X32.IfcCoveringType = IfcCoveringType;
    class IfcCrewResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ResourceIdentifier = ResourceIdentifier;
            this.ResourceGroup = ResourceGroup;
            this.ResourceConsumption = ResourceConsumption;
            this.BaseQuantity = BaseQuantity;
            this.type = 3295246426;
        }
    }
    IFC2X32.IfcCrewResource = IfcCrewResource;
    class IfcCurtainWallType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1457835157;
        }
    }
    IFC2X32.IfcCurtainWallType = IfcCurtainWallType;
    class IfcDimensionCurveDirectedCallout extends IfcDraughtingCallout {
        constructor(Contents){
            super(Contents);
            this.Contents = Contents;
            this.type = 681481545;
        }
    }
    IFC2X32.IfcDimensionCurveDirectedCallout = IfcDimensionCurveDirectedCallout;
    class IfcDistributionElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3256556792;
        }
    }
    IFC2X32.IfcDistributionElementType = IfcDistributionElementType;
    class IfcDistributionFlowElementType extends IfcDistributionElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3849074793;
        }
    }
    IFC2X32.IfcDistributionFlowElementType = IfcDistributionFlowElementType;
    class IfcElectricalBaseProperties extends IfcEnergyProperties {
        constructor(GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence, ElectricCurrentType, InputVoltage, InputFrequency, FullLoadCurrent, MinimumCircuitCurrent, MaximumPowerInput, RatedPowerInput, InputPhase){
            super(GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.EnergySequence = EnergySequence;
            this.UserDefinedEnergySequence = UserDefinedEnergySequence;
            this.ElectricCurrentType = ElectricCurrentType;
            this.InputVoltage = InputVoltage;
            this.InputFrequency = InputFrequency;
            this.FullLoadCurrent = FullLoadCurrent;
            this.MinimumCircuitCurrent = MinimumCircuitCurrent;
            this.MaximumPowerInput = MaximumPowerInput;
            this.RatedPowerInput = RatedPowerInput;
            this.InputPhase = InputPhase;
            this.type = 360485395;
        }
    }
    IFC2X32.IfcElectricalBaseProperties = IfcElectricalBaseProperties;
    class IfcElement extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1758889154;
        }
    }
    IFC2X32.IfcElement = IfcElement;
    class IfcElementAssembly extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.AssemblyPlace = AssemblyPlace;
            this.PredefinedType = PredefinedType;
            this.type = 4123344466;
        }
    }
    IFC2X32.IfcElementAssembly = IfcElementAssembly;
    class IfcElementComponent extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1623761950;
        }
    }
    IFC2X32.IfcElementComponent = IfcElementComponent;
    class IfcElementComponentType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2590856083;
        }
    }
    IFC2X32.IfcElementComponentType = IfcElementComponentType;
    class IfcEllipse extends IfcConic {
        constructor(Position, SemiAxis1, SemiAxis2){
            super(Position);
            this.Position = Position;
            this.SemiAxis1 = SemiAxis1;
            this.SemiAxis2 = SemiAxis2;
            this.type = 1704287377;
        }
    }
    IFC2X32.IfcEllipse = IfcEllipse;
    class IfcEnergyConversionDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2107101300;
        }
    }
    IFC2X32.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;
    class IfcEquipmentElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1962604670;
        }
    }
    IFC2X32.IfcEquipmentElement = IfcEquipmentElement;
    class IfcEquipmentStandard extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 3272907226;
        }
    }
    IFC2X32.IfcEquipmentStandard = IfcEquipmentStandard;
    class IfcEvaporativeCoolerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3174744832;
        }
    }
    IFC2X32.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;
    class IfcEvaporatorType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3390157468;
        }
    }
    IFC2X32.IfcEvaporatorType = IfcEvaporatorType;
    class IfcFacetedBrep extends IfcManifoldSolidBrep {
        constructor(Outer){
            super(Outer);
            this.Outer = Outer;
            this.type = 807026263;
        }
    }
    IFC2X32.IfcFacetedBrep = IfcFacetedBrep;
    class IfcFacetedBrepWithVoids extends IfcManifoldSolidBrep {
        constructor(Outer, Voids){
            super(Outer);
            this.Outer = Outer;
            this.Voids = Voids;
            this.type = 3737207727;
        }
    }
    IFC2X32.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;
    class IfcFastener extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 647756555;
        }
    }
    IFC2X32.IfcFastener = IfcFastener;
    class IfcFastenerType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2489546625;
        }
    }
    IFC2X32.IfcFastenerType = IfcFastenerType;
    class IfcFeatureElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2827207264;
        }
    }
    IFC2X32.IfcFeatureElement = IfcFeatureElement;
    class IfcFeatureElementAddition extends IfcFeatureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2143335405;
        }
    }
    IFC2X32.IfcFeatureElementAddition = IfcFeatureElementAddition;
    class IfcFeatureElementSubtraction extends IfcFeatureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1287392070;
        }
    }
    IFC2X32.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;
    class IfcFlowControllerType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3907093117;
        }
    }
    IFC2X32.IfcFlowControllerType = IfcFlowControllerType;
    class IfcFlowFittingType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3198132628;
        }
    }
    IFC2X32.IfcFlowFittingType = IfcFlowFittingType;
    class IfcFlowMeterType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3815607619;
        }
    }
    IFC2X32.IfcFlowMeterType = IfcFlowMeterType;
    class IfcFlowMovingDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1482959167;
        }
    }
    IFC2X32.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;
    class IfcFlowSegmentType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1834744321;
        }
    }
    IFC2X32.IfcFlowSegmentType = IfcFlowSegmentType;
    class IfcFlowStorageDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1339347760;
        }
    }
    IFC2X32.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;
    class IfcFlowTerminalType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2297155007;
        }
    }
    IFC2X32.IfcFlowTerminalType = IfcFlowTerminalType;
    class IfcFlowTreatmentDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3009222698;
        }
    }
    IFC2X32.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;
    class IfcFurnishingElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 263784265;
        }
    }
    IFC2X32.IfcFurnishingElement = IfcFurnishingElement;
    class IfcFurnitureStandard extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 814719939;
        }
    }
    IFC2X32.IfcFurnitureStandard = IfcFurnitureStandard;
    class IfcGasTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 200128114;
        }
    }
    IFC2X32.IfcGasTerminalType = IfcGasTerminalType;
    class IfcGrid extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.UAxes = UAxes;
            this.VAxes = VAxes;
            this.WAxes = WAxes;
            this.type = 3009204131;
        }
    }
    IFC2X32.IfcGrid = IfcGrid;
    class IfcGroup extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 2706460486;
        }
    }
    IFC2X32.IfcGroup = IfcGroup;
    class IfcHeatExchangerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1251058090;
        }
    }
    IFC2X32.IfcHeatExchangerType = IfcHeatExchangerType;
    class IfcHumidifierType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1806887404;
        }
    }
    IFC2X32.IfcHumidifierType = IfcHumidifierType;
    class IfcInventory extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, InventoryType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.InventoryType = InventoryType;
            this.Jurisdiction = Jurisdiction;
            this.ResponsiblePersons = ResponsiblePersons;
            this.LastUpdateDate = LastUpdateDate;
            this.CurrentValue = CurrentValue;
            this.OriginalValue = OriginalValue;
            this.type = 2391368822;
        }
    }
    IFC2X32.IfcInventory = IfcInventory;
    class IfcJunctionBoxType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4288270099;
        }
    }
    IFC2X32.IfcJunctionBoxType = IfcJunctionBoxType;
    class IfcLaborResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, SkillSet){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ResourceIdentifier = ResourceIdentifier;
            this.ResourceGroup = ResourceGroup;
            this.ResourceConsumption = ResourceConsumption;
            this.BaseQuantity = BaseQuantity;
            this.SkillSet = SkillSet;
            this.type = 3827777499;
        }
    }
    IFC2X32.IfcLaborResource = IfcLaborResource;
    class IfcLampType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1051575348;
        }
    }
    IFC2X32.IfcLampType = IfcLampType;
    class IfcLightFixtureType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1161773419;
        }
    }
    IFC2X32.IfcLightFixtureType = IfcLightFixtureType;
    class IfcLinearDimension extends IfcDimensionCurveDirectedCallout {
        constructor(Contents){
            super(Contents);
            this.Contents = Contents;
            this.type = 2506943328;
        }
    }
    IFC2X32.IfcLinearDimension = IfcLinearDimension;
    class IfcMechanicalFastener extends IfcFastener {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.NominalDiameter = NominalDiameter;
            this.NominalLength = NominalLength;
            this.type = 377706215;
        }
    }
    IFC2X32.IfcMechanicalFastener = IfcMechanicalFastener;
    class IfcMechanicalFastenerType extends IfcFastenerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2108223431;
        }
    }
    IFC2X32.IfcMechanicalFastenerType = IfcMechanicalFastenerType;
    class IfcMemberType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3181161470;
        }
    }
    IFC2X32.IfcMemberType = IfcMemberType;
    class IfcMotorConnectionType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 977012517;
        }
    }
    IFC2X32.IfcMotorConnectionType = IfcMotorConnectionType;
    class IfcMove extends IfcTask {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority, MoveFrom, MoveTo, PunchList){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TaskId = TaskId;
            this.Status = Status;
            this.WorkMethod = WorkMethod;
            this.IsMilestone = IsMilestone;
            this.Priority = Priority;
            this.MoveFrom = MoveFrom;
            this.MoveTo = MoveTo;
            this.PunchList = PunchList;
            this.type = 1916936684;
        }
    }
    IFC2X32.IfcMove = IfcMove;
    class IfcOccupant extends IfcActor {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TheActor = TheActor;
            this.PredefinedType = PredefinedType;
            this.type = 4143007308;
        }
    }
    IFC2X32.IfcOccupant = IfcOccupant;
    class IfcOpeningElement extends IfcFeatureElementSubtraction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3588315303;
        }
    }
    IFC2X32.IfcOpeningElement = IfcOpeningElement;
    class IfcOrderAction extends IfcTask {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority, ActionID){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TaskId = TaskId;
            this.Status = Status;
            this.WorkMethod = WorkMethod;
            this.IsMilestone = IsMilestone;
            this.Priority = Priority;
            this.ActionID = ActionID;
            this.type = 3425660407;
        }
    }
    IFC2X32.IfcOrderAction = IfcOrderAction;
    class IfcOutletType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2837617999;
        }
    }
    IFC2X32.IfcOutletType = IfcOutletType;
    class IfcPerformanceHistory extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LifeCyclePhase){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LifeCyclePhase = LifeCyclePhase;
            this.type = 2382730787;
        }
    }
    IFC2X32.IfcPerformanceHistory = IfcPerformanceHistory;
    class IfcPermit extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PermitID){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PermitID = PermitID;
            this.type = 3327091369;
        }
    }
    IFC2X32.IfcPermit = IfcPermit;
    class IfcPipeFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 804291784;
        }
    }
    IFC2X32.IfcPipeFittingType = IfcPipeFittingType;
    class IfcPipeSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4231323485;
        }
    }
    IFC2X32.IfcPipeSegmentType = IfcPipeSegmentType;
    class IfcPlateType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4017108033;
        }
    }
    IFC2X32.IfcPlateType = IfcPlateType;
    class IfcPolyline extends IfcBoundedCurve {
        constructor(Points){
            super();
            this.Points = Points;
            this.type = 3724593414;
        }
    }
    IFC2X32.IfcPolyline = IfcPolyline;
    class IfcPort extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 3740093272;
        }
    }
    IFC2X32.IfcPort = IfcPort;
    class IfcProcedure extends IfcProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ProcedureID, ProcedureType, UserDefinedProcedureType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ProcedureID = ProcedureID;
            this.ProcedureType = ProcedureType;
            this.UserDefinedProcedureType = UserDefinedProcedureType;
            this.type = 2744685151;
        }
    }
    IFC2X32.IfcProcedure = IfcProcedure;
    class IfcProjectOrder extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ID, PredefinedType, Status){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ID = ID;
            this.PredefinedType = PredefinedType;
            this.Status = Status;
            this.type = 2904328755;
        }
    }
    IFC2X32.IfcProjectOrder = IfcProjectOrder;
    class IfcProjectOrderRecord extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Records, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Records = Records;
            this.PredefinedType = PredefinedType;
            this.type = 3642467123;
        }
    }
    IFC2X32.IfcProjectOrderRecord = IfcProjectOrderRecord;
    class IfcProjectionElement extends IfcFeatureElementAddition {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3651124850;
        }
    }
    IFC2X32.IfcProjectionElement = IfcProjectionElement;
    class IfcProtectiveDeviceType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1842657554;
        }
    }
    IFC2X32.IfcProtectiveDeviceType = IfcProtectiveDeviceType;
    class IfcPumpType extends IfcFlowMovingDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2250791053;
        }
    }
    IFC2X32.IfcPumpType = IfcPumpType;
    class IfcRadiusDimension extends IfcDimensionCurveDirectedCallout {
        constructor(Contents){
            super(Contents);
            this.Contents = Contents;
            this.type = 3248260540;
        }
    }
    IFC2X32.IfcRadiusDimension = IfcRadiusDimension;
    class IfcRailingType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2893384427;
        }
    }
    IFC2X32.IfcRailingType = IfcRailingType;
    class IfcRampFlightType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2324767716;
        }
    }
    IFC2X32.IfcRampFlightType = IfcRampFlightType;
    class IfcRelAggregates extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingObject = RelatingObject;
            this.RelatedObjects = RelatedObjects;
            this.type = 160246688;
        }
    }
    IFC2X32.IfcRelAggregates = IfcRelAggregates;
    class IfcRelAssignsTasks extends IfcRelAssignsToControl {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl, TimeForTask){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingControl = RelatingControl;
            this.TimeForTask = TimeForTask;
            this.type = 2863920197;
        }
    }
    IFC2X32.IfcRelAssignsTasks = IfcRelAssignsTasks;
    class IfcSanitaryTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1768891740;
        }
    }
    IFC2X32.IfcSanitaryTerminalType = IfcSanitaryTerminalType;
    class IfcScheduleTimeControl extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ActualStart, EarlyStart, LateStart, ScheduleStart, ActualFinish, EarlyFinish, LateFinish, ScheduleFinish, ScheduleDuration, ActualDuration, RemainingTime, FreeFloat, TotalFloat, IsCritical, StatusTime, StartFloat, FinishFloat, Completion){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ActualStart = ActualStart;
            this.EarlyStart = EarlyStart;
            this.LateStart = LateStart;
            this.ScheduleStart = ScheduleStart;
            this.ActualFinish = ActualFinish;
            this.EarlyFinish = EarlyFinish;
            this.LateFinish = LateFinish;
            this.ScheduleFinish = ScheduleFinish;
            this.ScheduleDuration = ScheduleDuration;
            this.ActualDuration = ActualDuration;
            this.RemainingTime = RemainingTime;
            this.FreeFloat = FreeFloat;
            this.TotalFloat = TotalFloat;
            this.IsCritical = IsCritical;
            this.StatusTime = StatusTime;
            this.StartFloat = StartFloat;
            this.FinishFloat = FinishFloat;
            this.Completion = Completion;
            this.type = 3517283431;
        }
    }
    IFC2X32.IfcScheduleTimeControl = IfcScheduleTimeControl;
    class IfcServiceLife extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ServiceLifeType, ServiceLifeDuration){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ServiceLifeType = ServiceLifeType;
            this.ServiceLifeDuration = ServiceLifeDuration;
            this.type = 4105383287;
        }
    }
    IFC2X32.IfcServiceLife = IfcServiceLife;
    class IfcSite extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.RefLatitude = RefLatitude;
            this.RefLongitude = RefLongitude;
            this.RefElevation = RefElevation;
            this.LandTitleNumber = LandTitleNumber;
            this.SiteAddress = SiteAddress;
            this.type = 4097777520;
        }
    }
    IFC2X32.IfcSite = IfcSite;
    class IfcSlabType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2533589738;
        }
    }
    IFC2X32.IfcSlabType = IfcSlabType;
    class IfcSpace extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, InteriorOrExteriorSpace, ElevationWithFlooring){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.InteriorOrExteriorSpace = InteriorOrExteriorSpace;
            this.ElevationWithFlooring = ElevationWithFlooring;
            this.type = 3856911033;
        }
    }
    IFC2X32.IfcSpace = IfcSpace;
    class IfcSpaceHeaterType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1305183839;
        }
    }
    IFC2X32.IfcSpaceHeaterType = IfcSpaceHeaterType;
    class IfcSpaceProgram extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, SpaceProgramIdentifier, MaxRequiredArea, MinRequiredArea, RequestedLocation, StandardRequiredArea){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.SpaceProgramIdentifier = SpaceProgramIdentifier;
            this.MaxRequiredArea = MaxRequiredArea;
            this.MinRequiredArea = MinRequiredArea;
            this.RequestedLocation = RequestedLocation;
            this.StandardRequiredArea = StandardRequiredArea;
            this.type = 652456506;
        }
    }
    IFC2X32.IfcSpaceProgram = IfcSpaceProgram;
    class IfcSpaceType extends IfcSpatialStructureElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3812236995;
        }
    }
    IFC2X32.IfcSpaceType = IfcSpaceType;
    class IfcStackTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3112655638;
        }
    }
    IFC2X32.IfcStackTerminalType = IfcStackTerminalType;
    class IfcStairFlightType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1039846685;
        }
    }
    IFC2X32.IfcStairFlightType = IfcStairFlightType;
    class IfcStructuralAction extends IfcStructuralActivity {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.CausedBy = CausedBy;
            this.type = 682877961;
        }
    }
    IFC2X32.IfcStructuralAction = IfcStructuralAction;
    class IfcStructuralConnection extends IfcStructuralItem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.type = 1179482911;
        }
    }
    IFC2X32.IfcStructuralConnection = IfcStructuralConnection;
    class IfcStructuralCurveConnection extends IfcStructuralConnection {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.type = 4243806635;
        }
    }
    IFC2X32.IfcStructuralCurveConnection = IfcStructuralCurveConnection;
    class IfcStructuralCurveMember extends IfcStructuralMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.type = 214636428;
        }
    }
    IFC2X32.IfcStructuralCurveMember = IfcStructuralCurveMember;
    class IfcStructuralCurveMemberVarying extends IfcStructuralCurveMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.type = 2445595289;
        }
    }
    IFC2X32.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;
    class IfcStructuralLinearAction extends IfcStructuralAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.CausedBy = CausedBy;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.type = 1807405624;
        }
    }
    IFC2X32.IfcStructuralLinearAction = IfcStructuralLinearAction;
    class IfcStructuralLinearActionVarying extends IfcStructuralLinearAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue, VaryingAppliedLoadLocation, SubsequentAppliedLoads){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.CausedBy = CausedBy;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.VaryingAppliedLoadLocation = VaryingAppliedLoadLocation;
            this.SubsequentAppliedLoads = SubsequentAppliedLoads;
            this.type = 1721250024;
        }
    }
    IFC2X32.IfcStructuralLinearActionVarying = IfcStructuralLinearActionVarying;
    class IfcStructuralLoadGroup extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.ActionType = ActionType;
            this.ActionSource = ActionSource;
            this.Coefficient = Coefficient;
            this.Purpose = Purpose;
            this.type = 1252848954;
        }
    }
    IFC2X32.IfcStructuralLoadGroup = IfcStructuralLoadGroup;
    class IfcStructuralPlanarAction extends IfcStructuralAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.CausedBy = CausedBy;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.type = 1621171031;
        }
    }
    IFC2X32.IfcStructuralPlanarAction = IfcStructuralPlanarAction;
    class IfcStructuralPlanarActionVarying extends IfcStructuralPlanarAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue, VaryingAppliedLoadLocation, SubsequentAppliedLoads){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.CausedBy = CausedBy;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.VaryingAppliedLoadLocation = VaryingAppliedLoadLocation;
            this.SubsequentAppliedLoads = SubsequentAppliedLoads;
            this.type = 3987759626;
        }
    }
    IFC2X32.IfcStructuralPlanarActionVarying = IfcStructuralPlanarActionVarying;
    class IfcStructuralPointAction extends IfcStructuralAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.CausedBy = CausedBy;
            this.type = 2082059205;
        }
    }
    IFC2X32.IfcStructuralPointAction = IfcStructuralPointAction;
    class IfcStructuralPointConnection extends IfcStructuralConnection {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.type = 734778138;
        }
    }
    IFC2X32.IfcStructuralPointConnection = IfcStructuralPointConnection;
    class IfcStructuralPointReaction extends IfcStructuralReaction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 1235345126;
        }
    }
    IFC2X32.IfcStructuralPointReaction = IfcStructuralPointReaction;
    class IfcStructuralResultGroup extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TheoryType = TheoryType;
            this.ResultForLoadGroup = ResultForLoadGroup;
            this.IsLinear = IsLinear;
            this.type = 2986769608;
        }
    }
    IFC2X32.IfcStructuralResultGroup = IfcStructuralResultGroup;
    class IfcStructuralSurfaceConnection extends IfcStructuralConnection {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.type = 1975003073;
        }
    }
    IFC2X32.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;
    class IfcSubContractResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, SubContractor, JobDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ResourceIdentifier = ResourceIdentifier;
            this.ResourceGroup = ResourceGroup;
            this.ResourceConsumption = ResourceConsumption;
            this.BaseQuantity = BaseQuantity;
            this.SubContractor = SubContractor;
            this.JobDescription = JobDescription;
            this.type = 148013059;
        }
    }
    IFC2X32.IfcSubContractResource = IfcSubContractResource;
    class IfcSwitchingDeviceType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2315554128;
        }
    }
    IFC2X32.IfcSwitchingDeviceType = IfcSwitchingDeviceType;
    class IfcSystem extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 2254336722;
        }
    }
    IFC2X32.IfcSystem = IfcSystem;
    class IfcTankType extends IfcFlowStorageDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 5716631;
        }
    }
    IFC2X32.IfcTankType = IfcTankType;
    class IfcTimeSeriesSchedule extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ApplicableDates, TimeSeriesScheduleType, TimeSeries){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ApplicableDates = ApplicableDates;
            this.TimeSeriesScheduleType = TimeSeriesScheduleType;
            this.TimeSeries = TimeSeries;
            this.type = 1637806684;
        }
    }
    IFC2X32.IfcTimeSeriesSchedule = IfcTimeSeriesSchedule;
    class IfcTransformerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1692211062;
        }
    }
    IFC2X32.IfcTransformerType = IfcTransformerType;
    class IfcTransportElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OperationType, CapacityByWeight, CapacityByNumber){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.OperationType = OperationType;
            this.CapacityByWeight = CapacityByWeight;
            this.CapacityByNumber = CapacityByNumber;
            this.type = 1620046519;
        }
    }
    IFC2X32.IfcTransportElement = IfcTransportElement;
    class IfcTrimmedCurve extends IfcBoundedCurve {
        constructor(BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation){
            super();
            this.BasisCurve = BasisCurve;
            this.Trim1 = Trim1;
            this.Trim2 = Trim2;
            this.SenseAgreement = SenseAgreement;
            this.MasterRepresentation = MasterRepresentation;
            this.type = 3593883385;
        }
    }
    IFC2X32.IfcTrimmedCurve = IfcTrimmedCurve;
    class IfcTubeBundleType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1600972822;
        }
    }
    IFC2X32.IfcTubeBundleType = IfcTubeBundleType;
    class IfcUnitaryEquipmentType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1911125066;
        }
    }
    IFC2X32.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;
    class IfcValveType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 728799441;
        }
    }
    IFC2X32.IfcValveType = IfcValveType;
    class IfcVirtualElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2769231204;
        }
    }
    IFC2X32.IfcVirtualElement = IfcVirtualElement;
    class IfcWallType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1898987631;
        }
    }
    IFC2X32.IfcWallType = IfcWallType;
    class IfcWasteTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1133259667;
        }
    }
    IFC2X32.IfcWasteTerminalType = IfcWasteTerminalType;
    class IfcWorkControl extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identifier = Identifier;
            this.CreationDate = CreationDate;
            this.Creators = Creators;
            this.Purpose = Purpose;
            this.Duration = Duration;
            this.TotalFloat = TotalFloat;
            this.StartTime = StartTime;
            this.FinishTime = FinishTime;
            this.WorkControlType = WorkControlType;
            this.UserDefinedControlType = UserDefinedControlType;
            this.type = 1028945134;
        }
    }
    IFC2X32.IfcWorkControl = IfcWorkControl;
    class IfcWorkPlan extends IfcWorkControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identifier = Identifier;
            this.CreationDate = CreationDate;
            this.Creators = Creators;
            this.Purpose = Purpose;
            this.Duration = Duration;
            this.TotalFloat = TotalFloat;
            this.StartTime = StartTime;
            this.FinishTime = FinishTime;
            this.WorkControlType = WorkControlType;
            this.UserDefinedControlType = UserDefinedControlType;
            this.type = 4218914973;
        }
    }
    IFC2X32.IfcWorkPlan = IfcWorkPlan;
    class IfcWorkSchedule extends IfcWorkControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identifier = Identifier;
            this.CreationDate = CreationDate;
            this.Creators = Creators;
            this.Purpose = Purpose;
            this.Duration = Duration;
            this.TotalFloat = TotalFloat;
            this.StartTime = StartTime;
            this.FinishTime = FinishTime;
            this.WorkControlType = WorkControlType;
            this.UserDefinedControlType = UserDefinedControlType;
            this.type = 3342526732;
        }
    }
    IFC2X32.IfcWorkSchedule = IfcWorkSchedule;
    class IfcZone extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 1033361043;
        }
    }
    IFC2X32.IfcZone = IfcZone;
    class Ifc2DCompositeCurve extends IfcCompositeCurve {
        constructor(Segments, SelfIntersect){
            super(Segments, SelfIntersect);
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 1213861670;
        }
    }
    IFC2X32.Ifc2DCompositeCurve = Ifc2DCompositeCurve;
    class IfcActionRequest extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, RequestID){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.RequestID = RequestID;
            this.type = 3821786052;
        }
    }
    IFC2X32.IfcActionRequest = IfcActionRequest;
    class IfcAirTerminalBoxType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1411407467;
        }
    }
    IFC2X32.IfcAirTerminalBoxType = IfcAirTerminalBoxType;
    class IfcAirTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3352864051;
        }
    }
    IFC2X32.IfcAirTerminalType = IfcAirTerminalType;
    class IfcAirToAirHeatRecoveryType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1871374353;
        }
    }
    IFC2X32.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;
    class IfcAngularDimension extends IfcDimensionCurveDirectedCallout {
        constructor(Contents){
            super(Contents);
            this.Contents = Contents;
            this.type = 2470393545;
        }
    }
    IFC2X32.IfcAngularDimension = IfcAngularDimension;
    class IfcAsset extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, AssetID, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.AssetID = AssetID;
            this.OriginalValue = OriginalValue;
            this.CurrentValue = CurrentValue;
            this.TotalReplacementCost = TotalReplacementCost;
            this.Owner = Owner;
            this.User = User;
            this.ResponsiblePerson = ResponsiblePerson;
            this.IncorporationDate = IncorporationDate;
            this.DepreciatedValue = DepreciatedValue;
            this.type = 3460190687;
        }
    }
    IFC2X32.IfcAsset = IfcAsset;
    class IfcBSplineCurve extends IfcBoundedCurve {
        constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect){
            super();
            this.Degree = Degree;
            this.ControlPointsList = ControlPointsList;
            this.CurveForm = CurveForm;
            this.ClosedCurve = ClosedCurve;
            this.SelfIntersect = SelfIntersect;
            this.type = 1967976161;
        }
    }
    IFC2X32.IfcBSplineCurve = IfcBSplineCurve;
    class IfcBeamType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 819618141;
        }
    }
    IFC2X32.IfcBeamType = IfcBeamType;
    class IfcBezierCurve extends IfcBSplineCurve {
        constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect){
            super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
            this.Degree = Degree;
            this.ControlPointsList = ControlPointsList;
            this.CurveForm = CurveForm;
            this.ClosedCurve = ClosedCurve;
            this.SelfIntersect = SelfIntersect;
            this.type = 1916977116;
        }
    }
    IFC2X32.IfcBezierCurve = IfcBezierCurve;
    class IfcBoilerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 231477066;
        }
    }
    IFC2X32.IfcBoilerType = IfcBoilerType;
    class IfcBuildingElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3299480353;
        }
    }
    IFC2X32.IfcBuildingElement = IfcBuildingElement;
    class IfcBuildingElementComponent extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 52481810;
        }
    }
    IFC2X32.IfcBuildingElementComponent = IfcBuildingElementComponent;
    class IfcBuildingElementPart extends IfcBuildingElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2979338954;
        }
    }
    IFC2X32.IfcBuildingElementPart = IfcBuildingElementPart;
    class IfcBuildingElementProxy extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, CompositionType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.CompositionType = CompositionType;
            this.type = 1095909175;
        }
    }
    IFC2X32.IfcBuildingElementProxy = IfcBuildingElementProxy;
    class IfcBuildingElementProxyType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1909888760;
        }
    }
    IFC2X32.IfcBuildingElementProxyType = IfcBuildingElementProxyType;
    class IfcCableCarrierFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 395041908;
        }
    }
    IFC2X32.IfcCableCarrierFittingType = IfcCableCarrierFittingType;
    class IfcCableCarrierSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3293546465;
        }
    }
    IFC2X32.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;
    class IfcCableSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1285652485;
        }
    }
    IFC2X32.IfcCableSegmentType = IfcCableSegmentType;
    class IfcChillerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2951183804;
        }
    }
    IFC2X32.IfcChillerType = IfcChillerType;
    class IfcCircle extends IfcConic {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 2611217952;
        }
    }
    IFC2X32.IfcCircle = IfcCircle;
    class IfcCoilType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2301859152;
        }
    }
    IFC2X32.IfcCoilType = IfcCoilType;
    class IfcColumn extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 843113511;
        }
    }
    IFC2X32.IfcColumn = IfcColumn;
    class IfcCompressorType extends IfcFlowMovingDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3850581409;
        }
    }
    IFC2X32.IfcCompressorType = IfcCompressorType;
    class IfcCondenserType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2816379211;
        }
    }
    IFC2X32.IfcCondenserType = IfcCondenserType;
    class IfcCondition extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 2188551683;
        }
    }
    IFC2X32.IfcCondition = IfcCondition;
    class IfcConditionCriterion extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Criterion, CriterionDateTime){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Criterion = Criterion;
            this.CriterionDateTime = CriterionDateTime;
            this.type = 1163958913;
        }
    }
    IFC2X32.IfcConditionCriterion = IfcConditionCriterion;
    class IfcConstructionEquipmentResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ResourceIdentifier = ResourceIdentifier;
            this.ResourceGroup = ResourceGroup;
            this.ResourceConsumption = ResourceConsumption;
            this.BaseQuantity = BaseQuantity;
            this.type = 3898045240;
        }
    }
    IFC2X32.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;
    class IfcConstructionMaterialResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, Suppliers, UsageRatio){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ResourceIdentifier = ResourceIdentifier;
            this.ResourceGroup = ResourceGroup;
            this.ResourceConsumption = ResourceConsumption;
            this.BaseQuantity = BaseQuantity;
            this.Suppliers = Suppliers;
            this.UsageRatio = UsageRatio;
            this.type = 1060000209;
        }
    }
    IFC2X32.IfcConstructionMaterialResource = IfcConstructionMaterialResource;
    class IfcConstructionProductResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ResourceIdentifier = ResourceIdentifier;
            this.ResourceGroup = ResourceGroup;
            this.ResourceConsumption = ResourceConsumption;
            this.BaseQuantity = BaseQuantity;
            this.type = 488727124;
        }
    }
    IFC2X32.IfcConstructionProductResource = IfcConstructionProductResource;
    class IfcCooledBeamType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 335055490;
        }
    }
    IFC2X32.IfcCooledBeamType = IfcCooledBeamType;
    class IfcCoolingTowerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2954562838;
        }
    }
    IFC2X32.IfcCoolingTowerType = IfcCoolingTowerType;
    class IfcCovering extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1973544240;
        }
    }
    IFC2X32.IfcCovering = IfcCovering;
    class IfcCurtainWall extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3495092785;
        }
    }
    IFC2X32.IfcCurtainWall = IfcCurtainWall;
    class IfcDamperType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3961806047;
        }
    }
    IFC2X32.IfcDamperType = IfcDamperType;
    class IfcDiameterDimension extends IfcDimensionCurveDirectedCallout {
        constructor(Contents){
            super(Contents);
            this.Contents = Contents;
            this.type = 4147604152;
        }
    }
    IFC2X32.IfcDiameterDimension = IfcDiameterDimension;
    class IfcDiscreteAccessory extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1335981549;
        }
    }
    IFC2X32.IfcDiscreteAccessory = IfcDiscreteAccessory;
    class IfcDiscreteAccessoryType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2635815018;
        }
    }
    IFC2X32.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;
    class IfcDistributionChamberElementType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1599208980;
        }
    }
    IFC2X32.IfcDistributionChamberElementType = IfcDistributionChamberElementType;
    class IfcDistributionControlElementType extends IfcDistributionElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2063403501;
        }
    }
    IFC2X32.IfcDistributionControlElementType = IfcDistributionControlElementType;
    class IfcDistributionElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1945004755;
        }
    }
    IFC2X32.IfcDistributionElement = IfcDistributionElement;
    class IfcDistributionFlowElement extends IfcDistributionElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3040386961;
        }
    }
    IFC2X32.IfcDistributionFlowElement = IfcDistributionFlowElement;
    class IfcDistributionPort extends IfcPort {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.FlowDirection = FlowDirection;
            this.type = 3041715199;
        }
    }
    IFC2X32.IfcDistributionPort = IfcDistributionPort;
    class IfcDoor extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.OverallHeight = OverallHeight;
            this.OverallWidth = OverallWidth;
            this.type = 395920057;
        }
    }
    IFC2X32.IfcDoor = IfcDoor;
    class IfcDuctFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 869906466;
        }
    }
    IFC2X32.IfcDuctFittingType = IfcDuctFittingType;
    class IfcDuctSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3760055223;
        }
    }
    IFC2X32.IfcDuctSegmentType = IfcDuctSegmentType;
    class IfcDuctSilencerType extends IfcFlowTreatmentDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2030761528;
        }
    }
    IFC2X32.IfcDuctSilencerType = IfcDuctSilencerType;
    class IfcEdgeFeature extends IfcFeatureElementSubtraction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.FeatureLength = FeatureLength;
            this.type = 855621170;
        }
    }
    IFC2X32.IfcEdgeFeature = IfcEdgeFeature;
    class IfcElectricApplianceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 663422040;
        }
    }
    IFC2X32.IfcElectricApplianceType = IfcElectricApplianceType;
    class IfcElectricFlowStorageDeviceType extends IfcFlowStorageDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3277789161;
        }
    }
    IFC2X32.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;
    class IfcElectricGeneratorType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1534661035;
        }
    }
    IFC2X32.IfcElectricGeneratorType = IfcElectricGeneratorType;
    class IfcElectricHeaterType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1365060375;
        }
    }
    IFC2X32.IfcElectricHeaterType = IfcElectricHeaterType;
    class IfcElectricMotorType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1217240411;
        }
    }
    IFC2X32.IfcElectricMotorType = IfcElectricMotorType;
    class IfcElectricTimeControlType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 712377611;
        }
    }
    IFC2X32.IfcElectricTimeControlType = IfcElectricTimeControlType;
    class IfcElectricalCircuit extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 1634875225;
        }
    }
    IFC2X32.IfcElectricalCircuit = IfcElectricalCircuit;
    class IfcElectricalElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 857184966;
        }
    }
    IFC2X32.IfcElectricalElement = IfcElectricalElement;
    class IfcEnergyConversionDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1658829314;
        }
    }
    IFC2X32.IfcEnergyConversionDevice = IfcEnergyConversionDevice;
    class IfcFanType extends IfcFlowMovingDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 346874300;
        }
    }
    IFC2X32.IfcFanType = IfcFanType;
    class IfcFilterType extends IfcFlowTreatmentDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1810631287;
        }
    }
    IFC2X32.IfcFilterType = IfcFilterType;
    class IfcFireSuppressionTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4222183408;
        }
    }
    IFC2X32.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;
    class IfcFlowController extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2058353004;
        }
    }
    IFC2X32.IfcFlowController = IfcFlowController;
    class IfcFlowFitting extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 4278956645;
        }
    }
    IFC2X32.IfcFlowFitting = IfcFlowFitting;
    class IfcFlowInstrumentType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4037862832;
        }
    }
    IFC2X32.IfcFlowInstrumentType = IfcFlowInstrumentType;
    class IfcFlowMovingDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3132237377;
        }
    }
    IFC2X32.IfcFlowMovingDevice = IfcFlowMovingDevice;
    class IfcFlowSegment extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 987401354;
        }
    }
    IFC2X32.IfcFlowSegment = IfcFlowSegment;
    class IfcFlowStorageDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 707683696;
        }
    }
    IFC2X32.IfcFlowStorageDevice = IfcFlowStorageDevice;
    class IfcFlowTerminal extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2223149337;
        }
    }
    IFC2X32.IfcFlowTerminal = IfcFlowTerminal;
    class IfcFlowTreatmentDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3508470533;
        }
    }
    IFC2X32.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;
    class IfcFooting extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 900683007;
        }
    }
    IFC2X32.IfcFooting = IfcFooting;
    class IfcMember extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1073191201;
        }
    }
    IFC2X32.IfcMember = IfcMember;
    class IfcPile extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.ConstructionType = ConstructionType;
            this.type = 1687234759;
        }
    }
    IFC2X32.IfcPile = IfcPile;
    class IfcPlate extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3171933400;
        }
    }
    IFC2X32.IfcPlate = IfcPlate;
    class IfcRailing extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2262370178;
        }
    }
    IFC2X32.IfcRailing = IfcRailing;
    class IfcRamp extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.ShapeType = ShapeType;
            this.type = 3024970846;
        }
    }
    IFC2X32.IfcRamp = IfcRamp;
    class IfcRampFlight extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3283111854;
        }
    }
    IFC2X32.IfcRampFlight = IfcRampFlight;
    class IfcRationalBezierCurve extends IfcBezierCurve {
        constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, WeightsData){
            super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
            this.Degree = Degree;
            this.ControlPointsList = ControlPointsList;
            this.CurveForm = CurveForm;
            this.ClosedCurve = ClosedCurve;
            this.SelfIntersect = SelfIntersect;
            this.WeightsData = WeightsData;
            this.type = 3055160366;
        }
    }
    IFC2X32.IfcRationalBezierCurve = IfcRationalBezierCurve;
    class IfcReinforcingElement extends IfcBuildingElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.type = 3027567501;
        }
    }
    IFC2X32.IfcReinforcingElement = IfcReinforcingElement;
    class IfcReinforcingMesh extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.MeshLength = MeshLength;
            this.MeshWidth = MeshWidth;
            this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
            this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
            this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
            this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
            this.LongitudinalBarSpacing = LongitudinalBarSpacing;
            this.TransverseBarSpacing = TransverseBarSpacing;
            this.type = 2320036040;
        }
    }
    IFC2X32.IfcReinforcingMesh = IfcReinforcingMesh;
    class IfcRoof extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.ShapeType = ShapeType;
            this.type = 2016517767;
        }
    }
    IFC2X32.IfcRoof = IfcRoof;
    class IfcRoundedEdgeFeature extends IfcEdgeFeature {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength, Radius){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.FeatureLength = FeatureLength;
            this.Radius = Radius;
            this.type = 1376911519;
        }
    }
    IFC2X32.IfcRoundedEdgeFeature = IfcRoundedEdgeFeature;
    class IfcSensorType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1783015770;
        }
    }
    IFC2X32.IfcSensorType = IfcSensorType;
    class IfcSlab extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1529196076;
        }
    }
    IFC2X32.IfcSlab = IfcSlab;
    class IfcStair extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.ShapeType = ShapeType;
            this.type = 331165859;
        }
    }
    IFC2X32.IfcStair = IfcStair;
    class IfcStairFlight extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRiser, NumberOfTreads, RiserHeight, TreadLength){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.NumberOfRiser = NumberOfRiser;
            this.NumberOfTreads = NumberOfTreads;
            this.RiserHeight = RiserHeight;
            this.TreadLength = TreadLength;
            this.type = 4252922144;
        }
    }
    IFC2X32.IfcStairFlight = IfcStairFlight;
    class IfcStructuralAnalysisModel extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.OrientationOf2DPlane = OrientationOf2DPlane;
            this.LoadedBy = LoadedBy;
            this.HasResults = HasResults;
            this.type = 2515109513;
        }
    }
    IFC2X32.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;
    class IfcTendon extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.PredefinedType = PredefinedType;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.TensionForce = TensionForce;
            this.PreStress = PreStress;
            this.FrictionCoefficient = FrictionCoefficient;
            this.AnchorageSlip = AnchorageSlip;
            this.MinCurvatureRadius = MinCurvatureRadius;
            this.type = 3824725483;
        }
    }
    IFC2X32.IfcTendon = IfcTendon;
    class IfcTendonAnchor extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.type = 2347447852;
        }
    }
    IFC2X32.IfcTendonAnchor = IfcTendonAnchor;
    class IfcVibrationIsolatorType extends IfcDiscreteAccessoryType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3313531582;
        }
    }
    IFC2X32.IfcVibrationIsolatorType = IfcVibrationIsolatorType;
    class IfcWall extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2391406946;
        }
    }
    IFC2X32.IfcWall = IfcWall;
    class IfcWallStandardCase extends IfcWall {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3512223829;
        }
    }
    IFC2X32.IfcWallStandardCase = IfcWallStandardCase;
    class IfcWindow extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.OverallHeight = OverallHeight;
            this.OverallWidth = OverallWidth;
            this.type = 3304561284;
        }
    }
    IFC2X32.IfcWindow = IfcWindow;
    class IfcActuatorType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2874132201;
        }
    }
    IFC2X32.IfcActuatorType = IfcActuatorType;
    class IfcAlarmType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3001207471;
        }
    }
    IFC2X32.IfcAlarmType = IfcAlarmType;
    class IfcBeam extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 753842376;
        }
    }
    IFC2X32.IfcBeam = IfcBeam;
    class IfcChamferEdgeFeature extends IfcEdgeFeature {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength, Width, Height){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.FeatureLength = FeatureLength;
            this.Width = Width;
            this.Height = Height;
            this.type = 2454782716;
        }
    }
    IFC2X32.IfcChamferEdgeFeature = IfcChamferEdgeFeature;
    class IfcControllerType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 578613899;
        }
    }
    IFC2X32.IfcControllerType = IfcControllerType;
    class IfcDistributionChamberElement extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1052013943;
        }
    }
    IFC2X32.IfcDistributionChamberElement = IfcDistributionChamberElement;
    class IfcDistributionControlElement extends IfcDistributionElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ControlElementId){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.ControlElementId = ControlElementId;
            this.type = 1062813311;
        }
    }
    IFC2X32.IfcDistributionControlElement = IfcDistributionControlElement;
    class IfcElectricDistributionPoint extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, DistributionPointFunction, UserDefinedFunction){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.DistributionPointFunction = DistributionPointFunction;
            this.UserDefinedFunction = UserDefinedFunction;
            this.type = 3700593921;
        }
    }
    IFC2X32.IfcElectricDistributionPoint = IfcElectricDistributionPoint;
    class IfcReinforcingBar extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, BarRole, BarSurface){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.BarLength = BarLength;
            this.BarRole = BarRole;
            this.BarSurface = BarSurface;
            this.type = 979691226;
        }
    }
    IFC2X32.IfcReinforcingBar = IfcReinforcingBar;
})($3b8da494b8e92f36$export$c9c0ab869345d70a || ($3b8da494b8e92f36$export$c9c0ab869345d70a = {}));
$3b8da494b8e92f36$export$a6870f5c6ab054f9[2] = [
    "IFC4"
];
$3b8da494b8e92f36$export$6c6c405ef9389ced[2] = {
    3630933823: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActorRole(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    618182010: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAddress(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    639542469: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcApplication(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    411424972: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAppliedValue((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    130549933: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcApproval((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    4037036970: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1560379544: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryEdgeCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[6])),
    3367102660: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryFaceCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[3])),
    1387855156: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryNodeCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[6])),
    2069777674: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryNodeConditionWarping((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[7])),
    2859738748: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionGeometry(),
    2614616156: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionPointGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    2732653382: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionSurfaceGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    775493141: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionVolumeGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    1959218052: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstraint(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1785450214: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoordinateOperation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    1466758467: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoordinateReferenceSystem(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    602808272: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCostValue((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1765591967: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDerivedUnit(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1045800335: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDerivedUnitElement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 10)),
    2949456006: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDimensionalExponents(new $3b8da494b8e92f36$export$2e483f5afea275bb((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 10)),
    4294318154: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalInformation(),
    3200245327: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2242383968: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternallyDefinedHatchStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1040185647: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternallyDefinedSurfaceStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3548104201: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternallyDefinedTextFont((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    852622518: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGridAxis((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3020489413: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIrregularTimeSeriesValue(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || []),
    2655187982: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLibraryInformation(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3452421091: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLibraryReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLanguageId((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    4162380809: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightDistributionData(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure(p.value) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLuminousIntensityDistributionMeasure(p.value) : null) || []),
    1566485204: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightIntensityDistribution(v[0], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3057273783: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMapConversion(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1847130766: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialClassificationRelationship(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    760658860: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialDefinition(),
    248100487: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialLayer((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    3303938423: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialLayerSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1847252529: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialLayerWithOffsets((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2199411900: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialList(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2235152071: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfile((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    164193824: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfileSet((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    552965576: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfileWithOffsets((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1507914824: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialUsageDefinition(),
    2597039031: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMeasureWithUnit($3b8da494b8e92f36$var$TypeInitialiser(2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    3368373690: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMetric(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10])),
    2706619895: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMonetaryUnit(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1918398963: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNamedUnit(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]),
    3701648758: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcObjectPlacement(),
    2251480897: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcObjective(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[8], v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    4251960020: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOrganization((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1207048766: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOwnerHistory(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), v[2], v[3], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeStamp((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeStamp((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2077209135: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPerson((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel(p.value) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    101040310: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPersonAndOrganization(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2483315170: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPhysicalQuantity(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2226359599: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPhysicalSimpleQuantity(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    3355820592: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPostalAddress(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    677532197: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationItem(),
    2022622350: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationLayerAssignment(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1304840413: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationLayerWithStyle(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3119450353: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2417041796: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationStyleAssignment(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2095639259: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProductRepresentation((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3958567839: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3843373140: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProjectedCRS(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    986844984: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyAbstraction(),
    3710013099: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyEnumeration(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    2044713172: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityArea(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2093928680: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityCount(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCountMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    931644368: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityLength(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3252649465: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityTime(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2405470396: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityVolume(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVolumeMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    825690147: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityWeight(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMassMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3915482550: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRecurrencePattern(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDayInMonthNumber(p.value) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDayInWeekNumber(p.value) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMonthInYearNumber(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2433181523: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4])),
    1076942058: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3377609919: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRepresentationContext((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3008791417: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRepresentationItem(),
    1660063152: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRepresentationMap(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    2439245199: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResourceLevelRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2341007311: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRoot(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    448429030: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSIUnit(v[0], v[1], v[2]),
    1054537805: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSchedulingTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    867548509: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShapeAspect(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4])),
    3982875396: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShapeModel(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    4240577450: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShapeRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2273995522: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralConnectionCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2162789131: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoad((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3478079324: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadConfiguration((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure(p2.value) : null) || [])),
    609421318: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadOrResult((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2525727697: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadStatic((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3408363356: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadTemperature((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermodynamicTemperatureMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermodynamicTemperatureMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermodynamicTemperatureMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2830218821: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStyleModel(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3958052878: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStyledItem((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3049322572: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStyledRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2934153892: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceReinforcementArea((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure(p.value) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure(p.value) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1300840506: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3303107099: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleLighting(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    1607154358: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleRefraction((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    846575682: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleShading(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1351298697: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleWithTextures(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    626085974: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceTexture(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier(p.value) : null) || []),
    985171141: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTable((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2043862942: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTableColumn((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4])),
    531007025: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTableRow((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1549132990: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTaskTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value), (v[19] ?? void 0) === void 0 || v[19] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[19] ?? void 0) === void 0 || v[19] === "" ? null : v[19].value)),
    2771591690: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTaskTimeRecurring((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value), (v[19] ?? void 0) === void 0 || v[19] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[19] ?? void 0) === void 0 || v[19] === "" ? null : v[19].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[20] ?? void 0) === void 0 || v[20] === "" ? null : v[20].value, 2, v[20])),
    912023232: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTelecomAddress(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel(p.value) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference(p.value) : null) || []),
    1447204868: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2636378356: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextStyleForDefinedFont(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    1640371178: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextStyleTextModel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextAlignment((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextDecoration((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextTransformation((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[6])),
    280115917: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureCoordinate(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1742049831: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureCoordinateGenerator(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal(p.value) : null) || []),
    2552916305: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureMap(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    1210645708: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureVertex(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(p.value) : null) || []),
    3611470254: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureVertexList(v[0]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(p2.value) : null) || [])),
    1199560280: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimePeriod(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTime((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3101149627: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeSeries(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7])),
    581633288: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeSeriesValue(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || []),
    1377556343: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTopologicalRepresentationItem(),
    1735638870: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTopologyRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    180925521: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitAssignment(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2799835756: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVertex(),
    1907098498: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVertexPoint(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    891718957: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVirtualGridIntersection(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure(p.value) : null) || []),
    1236880293: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3869604511: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcApprovalRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3798115385: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcArbitraryClosedProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    1310608509: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcArbitraryOpenProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    2705031697: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcArbitraryProfileDefWithVoids(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    616511568: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBlobTexture(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier(p.value) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBinary((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    3150382593: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCenterLineProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    747523909: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcClassification((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier(p.value) : null) || []),
    647927063: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcClassificationReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3285139300: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColourRgbList(v[0]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure(p2.value) : null) || [])),
    3264961684: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColourSpecification((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1485152156: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompositeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    370225590: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectedFaceSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1981873012: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionCurveGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    45288368: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionPointEccentricity(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3050246964: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcContextDependentUnit(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2889183280: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConversionBasedUnit(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    2713554722: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConversionBasedUnitWithOffset(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    539742890: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurrencyRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    3800577675: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1105321065: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveStyleFont((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2367409068: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveStyleFontAndScaling((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3510044353: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveStyleFontPattern(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3632507154: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDerivedProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1154170062: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDocumentInformation(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), v[15], v[16]),
    770865208: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDocumentInformationRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3732053477: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDocumentReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4])),
    3900360178: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEdge(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    476780140: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEdgeCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    211053100: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEventTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    297599258: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExtendedProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1437805879: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalReferenceRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2556980723: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFace(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1809719519: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFaceBound(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    803316827: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFaceOuterBound(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3008276851: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFaceSurface(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    4219587988: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFailureConnectionCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    738692330: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFillAreaStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3448662350: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricRepresentationContext((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDimensionCount((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    2453401579: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricRepresentationItem(),
    4142052618: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricRepresentationSubContext((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3590301190: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    178086475: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGridPlacement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    812098782: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHalfSpaceSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3905492369: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcImageTexture(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier(p.value) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3570813810: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedColourMap(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveInteger(p.value) : null) || []),
    1437953363: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedTextureMap(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    2133299955: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedTriangleTextureMap(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveInteger(p2.value) : null) || [])),
    3741457305: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIrregularTimeSeries(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1585845231: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLagTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), $3b8da494b8e92f36$var$TypeInitialiser(2, v[3]), v[4]),
    1402838566: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSource((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    125510826: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourceAmbient((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2604431987: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourceDirectional((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4])),
    4266656042: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourceGoniometric((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermodynamicTemperatureMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLuminousFluxMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9])),
    1520743889: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourcePositional((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3422422726: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourceSpot((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositivePlaneAngleMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositivePlaneAngleMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    2624227202: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLocalPlacement((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    1008929658: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLoop(),
    2347385850: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMappedItem(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    1838606355: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterial(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3708119e3: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialConstituent((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2852063980: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialConstituentSet((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2022407955: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialDefinitionRepresentation((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    1303795690: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialLayerSetUsage(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1], v[2], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3079605661: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfileSetUsage(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCardinalPointReference((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3404854881: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfileSetUsageTapering(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCardinalPointReference((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCardinalPointReference((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3265635763: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    853536259: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2998442950: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMirroredProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    219451334: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcObjectDefinition(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2665983363: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOpenShell(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1411181986: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOrganizationRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1029017970: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOrientedEdge(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2529465313: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterizedProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    2519244187: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPath(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3021840470: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPhysicalComplexQuantity(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    597895409: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPixelTexture(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier(p.value) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBinary(p.value) : null) || []),
    2004835150: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlacement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    1663979128: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlanarExtent(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2067069095: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPoint(),
    4022376103: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPointOnCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1423911732: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPointOnSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2924175390: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPolyLoop(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2775532180: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPolygonalBoundedHalfSpace(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    3727388367: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedItem(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3778827333: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedProperties(),
    1775413392: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedTextFont(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    673634403: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProductDefinitionShape((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2802850158: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProfileProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    2598011224: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProperty(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1680319473: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyDefinition(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    148025276: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyDependencyRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3357820518: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertySetDefinition(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1482703590: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyTemplateDefinition(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2090586900: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantitySet(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3615266464: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRectangleProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3413951693: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRegularTimeSeries(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1580146022: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcementBarProperties(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCountMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    478536968: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelationship(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2943643501: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResourceApprovalRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    1608871552: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResourceConstraintRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1042787934: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResourceTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value)),
    2778083089: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRoundedRectangleProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    2042790032: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSectionProperties(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    4165799628: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSectionReinforcementProperties(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1509187699: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSectionedSpine(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    4124623270: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShellBasedSurfaceModel(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3692461612: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSimpleProperty(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2609359061: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlippageConnectionCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    723233188: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSolidModel(),
    1595516126: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadLinearForce((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearMomentMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearMomentMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearMomentMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    2668620305: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadPlanarForce((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlanarForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlanarForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlanarForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2473145415: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadSingleDisplacement((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1973038258: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadSingleDisplacementDistortion((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurvatureMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1597423693: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadSingleForce((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTorqueMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTorqueMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTorqueMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1190533807: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadSingleForceWarping((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTorqueMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTorqueMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTorqueMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWarpingMomentMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2233826070: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSubedge(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    2513912981: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurface(),
    1878645084: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleRendering(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[7]), v[8]),
    2247615214: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    1260650574: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSweptDiskSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1096409881: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSweptDiskSolidPolygonal(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    230924584: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSweptSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    3071757647: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    901063453: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTessellatedItem(),
    4282788508: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextLiteral(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentableText((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), v[2]),
    3124975700: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextLiteralWithExtent(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentableText((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), v[2], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoxAlignment((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1983826977: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextStyleFontModel(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextFontName(p.value) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFontStyle((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFontVariant((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFontWeight((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), $3b8da494b8e92f36$var$TypeInitialiser(2, v[5])),
    2715220739: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTrapeziumProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1628702193: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTypeObject(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3736923433: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTypeProcess(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2347495698: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTypeProduct(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3698973494: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTypeResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    427810014: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    1417489154: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVector(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2759199220: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVertexLoop(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    1299126871: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowStyle(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    2543172580: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcZShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3406155212: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAdvancedFace(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    669184980: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAnnotationFillArea(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3207858831: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAsymmetricIShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value)),
    4261334040: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAxis1Placement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    3125803723: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAxis2Placement2D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    2740243338: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAxis2Placement3D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    2736907675: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBooleanResult(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    4182860854: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundedSurface(),
    2581212453: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundingBox(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2713105998: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoxedHalfSpace(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    2898889636: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1123145078: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianPoint(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure(p.value) : null) || []),
    574549367: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianPointList(),
    1675464909: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianPointList2D(v[0]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure(p2.value) : null) || [])),
    2059837836: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianPointList3D(v[0]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure(p2.value) : null) || [])),
    59481748: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3749851601: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator2D((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3486308946: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator2DnonUniform((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3331915920: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator3D((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4])),
    1416205885: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator3DnonUniform((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1383045692: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCircleProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2205249479: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcClosedShell(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    776857604: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColourRgb((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2542286263: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcComplexProperty(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2485617015: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompositeCurveSegment(v[0], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    2574617495: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionResourceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10])),
    3419103109: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcContext(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    1815067380: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCrewResourceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10]), v[11]),
    2506170314: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCsgPrimitive3D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    2147822146: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCsgSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    2601014836: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurve(),
    2827736869: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveBoundedPlane(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2629017746: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveBoundedSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    32440307: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDirection(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal(p.value) : null) || []),
    526551008: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorStyle(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    1472233963: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEdgeLoop(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1883228015: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementQuantity(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    339256511: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2777663545: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementarySurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    2835456948: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEllipseProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    4024345920: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEventType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], v[10], (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    477187591: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExtrudedAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2804161546: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExtrudedAreaSolidTapered(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4])),
    2047409740: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFaceBasedSurfaceModel(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    374418227: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFillAreaStyleHatching(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    315944413: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFillAreaStyleTiles(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2652556860: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFixedReferenceSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    4238390223: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFurnishingElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1268542332: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFurnitureType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], v[10]),
    4095422895: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeographicElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    987898635: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricCurveSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1484403080: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    178912537: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedPolygonalFace(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveInteger(p.value) : null) || []),
    2294589976: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedPolygonalFaceWithVoids(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveInteger(p.value) : null) || [], v[1]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveInteger(p2.value) : null) || [])),
    572779678: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    428585644: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLaborResourceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10]), v[11]),
    1281925730: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLine(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    1425443689: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcManifoldSolidBrep(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    3888040117: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcObject(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3388369263: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOffsetCurve2D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3505215534: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOffsetCurve3D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    1682466193: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPcurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1])),
    603570806: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlanarBox(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    220341763: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlane(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    759155922: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedColour(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2559016684: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedCurveFont(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3967405729: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedPropertySet(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    569719735: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProcedureType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2945172077: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProcess(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    4208778838: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProduct(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    103090709: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProject(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    653396225: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProjectLibrary(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    871118103: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyBoundedValue(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[5])),
    4166981789: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyEnumeratedValue(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    2752243245: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyListValue(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    941946838: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyReferenceValue(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    1451395588: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertySet(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    492091185: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertySetTemplate(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3650150729: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertySingleValue(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 2, v[3])),
    110355661: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyTableValue(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7]),
    3521284610: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyTemplate(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3219374653: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProxy(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2770003689: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRectangleHollowProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2798486643: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRectangularPyramid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3454111270: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRectangularTrimmedSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    3765753017: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcementDefinitionProperties(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3939117080: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssigns(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[5]),
    1683148259: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToActor(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7])),
    2495723537: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToControl(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    1307041759: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToGroup(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    1027710054: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToGroupByFactor(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRatioMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4278684876: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToProcess(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7])),
    2857406711: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToProduct(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    205026976: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[5], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    1865459582: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociates(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    4095574036: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesApproval(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    919958153: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesClassification(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    2728634034: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesConstraint(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    982818633: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesDocument(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    3840914261: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesLibrary(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    2655215786: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesMaterial(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    826625072: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnects(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1204542856: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsElements(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    3945020480: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsPathElements(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(p.value) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(p.value) : null) || [], v[9], v[10]),
    4201705270: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsPortToElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    3190031847: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsPorts(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    2127690289: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsStructuralActivity(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    1638771189: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsStructuralMember(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9])),
    504942748: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsWithEccentricity(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10])),
    3678494232: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsWithRealizingElements(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3242617779: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelContainedInSpatialStructure(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    886880790: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelCoversBldgElements(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2802773753: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelCoversSpaces(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2565941209: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDeclares(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2551354335: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDecomposes(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    693640335: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefines(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1462361463: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefinesByObject(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    4186316022: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefinesByProperties(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    307848117: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefinesByTemplate(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    781010003: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefinesByType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    3940055652: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelFillsElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    279856033: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelFlowControlElements(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    427948657: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelInterferesElements(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value),
    3268803585: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelNests(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    750771296: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelProjectsElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    1245217292: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelReferencedInSpatialStructure(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    4122056220: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelSequence(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    366585022: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelServicesBuildings(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3451746338: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelSpaceBoundary(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], v[8]),
    3523091289: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelSpaceBoundary1stLevel(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9])),
    1521410863: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelSpaceBoundary2ndLevel(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10])),
    1401173127: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelVoidsElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    816062949: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReparametrisedCompositeCurveSegment(v[0], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2914609552: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1856042241: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRevolvedAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3243963512: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRevolvedAreaSolidTapered(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4])),
    4158566097: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRightCircularCone(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3626867408: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRightCircularCylinder(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3663146110: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSimplePropertyTemplate(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), v[11]),
    1412071761: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    710998568: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2706606064: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialStructureElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3893378262: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialStructureElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    463610769: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialZone(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2481509218: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialZoneType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    451544542: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSphere(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    4015995234: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSphericalSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3544373492: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralActivity(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8]),
    3136571912: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralItem(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    530289379: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralMember(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    3689010777: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralReaction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8]),
    3979015343: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceMember(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2218152070: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceMemberVarying(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    603775116: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceReaction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8], v[9]),
    4095615324: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSubContractResourceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10]), v[11]),
    699246055: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[2]),
    2028607225: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceCurveSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    2809605785: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceOfLinearExtrusion(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    4124788165: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceOfRevolution(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    1580310250: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSystemFurnitureElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3473067441: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTask(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 2, v[11]), v[12]),
    3206491090: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTaskType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    2387106220: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTessellatedFaceSet(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    1935646853: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcToroidalSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2097647324: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTransportElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2916149573: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTriangulatedFaceSet(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(p2.value) : null) || []), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveInteger(p2.value) : null) || []), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveInteger(p.value) : null) || []),
    336235671: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowLiningProperties(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 2, v[12]), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value)),
    512836454: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowPanelProperties(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    2296667514: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActor(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5])),
    1635779807: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAdvancedBrep(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    2603310189: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAdvancedBrepWithVoids(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1674181508: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAnnotation(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    2887950389: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBSplineSurface(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p2.value, 2, p2) : null) || []), v[3], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    167062518: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBSplineSurfaceWithKnots(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p2.value, 2, p2) : null) || []), v[3], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(p.value) : null) || [], v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(p.value) : null) || [], v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(p.value) : null) || [], v[10]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(p.value) : null) || [], v[11]),
    1334484129: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBlock(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3649129432: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBooleanClippingResult(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2])),
    1260505505: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundedCurve(),
    4031249490: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuilding(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 2, v[11])),
    1950629157: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3124254112: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingStorey(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    2197970202: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcChimneyType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2937912522: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCircleHollowProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 2, v[2]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3893394355: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCivilElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    300633059: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColumnType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3875453745: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcComplexPropertyTemplate(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3732776249: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompositeCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    15328376: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompositeCurveOnSurface(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2510884976: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConic(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    2185764099: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionEquipmentResourceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10]), v[11]),
    4105962743: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionMaterialResourceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10]), v[11]),
    1525564444: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionProductResourceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10]), v[11]),
    2559216714: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9])),
    3293443760: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcControl(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3895139033: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCostItem(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    1419761937: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCostSchedule(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    1916426348: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoveringType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3295246426: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCrewResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), v[10]),
    1457835157: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurtainWallType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1213902940: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCylindricalSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3256556792: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3849074793: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionFlowElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2963535650: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorLiningProperties(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value, 2, v[14]), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value)),
    1714330368: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorPanelProperties(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    2323601079: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], v[10], (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    445594917: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDraughtingPreDefinedColour(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    4006246654: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDraughtingPreDefinedCurveFont(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1758889154: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4123344466: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementAssembly(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    2397081782: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementAssemblyType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1623761950: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementComponent(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2590856083: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementComponentType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1704287377: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEllipse(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2107101300: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEnergyConversionDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    132023988: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEngineType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3174744832: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvaporativeCoolerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3390157468: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvaporatorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4148101412: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvent(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10])),
    2853485674: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalSpatialStructureElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    807026263: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFacetedBrep(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0])),
    3737207727: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFacetedBrepWithVoids(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    647756555: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFastener(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2489546625: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFastenerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2827207264: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFeatureElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2143335405: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFeatureElementAddition(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1287392070: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFeatureElementSubtraction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3907093117: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowControllerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3198132628: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowFittingType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3815607619: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowMeterType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1482959167: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowMovingDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1834744321: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowSegmentType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1339347760: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowStorageDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2297155007: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowTerminalType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3009222698: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowTreatmentDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1893162501: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFootingType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    263784265: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFurnishingElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1509553395: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFurniture(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3493046030: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeographicElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3009204131: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGrid(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[10]),
    2706460486: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGroup(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1251058090: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHeatExchangerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1806887404: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHumidifierType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2571569899: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedPolyCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3946677679: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInterceptorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3113134337: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIntersectionCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[2]),
    2391368822: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInventory(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10])),
    4288270099: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcJunctionBoxType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3827777499: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLaborResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), v[10]),
    1051575348: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLampType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1161773419: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightFixtureType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    377706215: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMechanicalFastener(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10]),
    2108223431: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMechanicalFastenerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    1114901282: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMedicalDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3181161470: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMemberType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    977012517: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMotorConnectionType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4143007308: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOccupant(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), v[6]),
    3588315303: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOpeningElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3079942009: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOpeningStandardCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2837617999: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOutletType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2382730787: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPerformanceHistory(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]),
    3566463478: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPermeableCoveringProperties(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    3327091369: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPermit(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1158309216: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPileType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    804291784: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPipeFittingType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4231323485: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPipeSegmentType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4017108033: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlateType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2839578677: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPolygonalFaceSet(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveInteger(p.value) : null) || []),
    3724593414: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPolyline(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    3740093272: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPort(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6])),
    2744685151: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProcedure(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]),
    2904328755: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProjectOrder(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3651124850: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProjectionElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1842657554: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProtectiveDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2250791053: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPumpType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2893384427: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRailingType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2324767716: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRampFlightType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1469900589: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRampType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    683857671: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRationalBSplineSurfaceWithKnots(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p2.value, 2, p2) : null) || []), v[3], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(p.value) : null) || [], v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(p.value) : null) || [], v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(p.value) : null) || [], v[10]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(p.value) : null) || [], v[11], v[12]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal(p2.value) : null) || [])),
    3027567501: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    964333572: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2320036040: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingMesh(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), v[17]),
    2310774935: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingMeshType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value), (v[19] ?? void 0) === void 0 || v[19] === "" ? null : v[19]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || []),
    160246688: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAggregates(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 2, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || []),
    2781568857: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRoofType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1768891740: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSanitaryTerminalType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2157484638: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSeamCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[2]),
    4074543187: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShadingDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4097777520: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSite(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompoundPlaneAngleMeasure(v[9].map((x)=>x.value)), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompoundPlaneAngleMeasure(v[10].map((x)=>x.value)), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value, 2, v[13])),
    2533589738: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlabType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1072016465: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSolarDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3856911033: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpace(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    1305183839: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpaceHeaterType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3812236995: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpaceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    3112655638: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStackTerminalType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1039846685: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStairFlightType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    338393293: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStairType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    682877961: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralAction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    1179482911: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralConnection(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7])),
    1004757350: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveAction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11]),
    4243806635: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveConnection(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    214636428: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveMember(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    2445595289: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveMemberVarying(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    2757150158: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveReaction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8], v[9]),
    1807405624: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLinearAction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11]),
    1252848954: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadGroup(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], v[6], v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    2082059205: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralPointAction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    734778138: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralPointConnection(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8])),
    1235345126: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralPointReaction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8]),
    2986769608: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralResultGroup(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3657597509: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceAction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11]),
    1975003073: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceConnection(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7])),
    148013059: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSubContractResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), v[10]),
    3101698114: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceFeature(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2315554128: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSwitchingDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2254336722: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSystem(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    413509423: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSystemFurnitureElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    5716631: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTankType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3824725483: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTendon(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPressureMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value)),
    2347447852: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTendonAnchor(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3081323446: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTendonAnchorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2415094496: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTendonType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    1692211062: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTransformerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1620046519: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTransportElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3593883385: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTrimmedCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]),
    1600972822: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTubeBundleType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1911125066: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitaryEquipmentType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    728799441: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcValveType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2391383451: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVibrationIsolator(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3313531582: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVibrationIsolatorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2769231204: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVirtualElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    926996030: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVoidingFeature(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1898987631: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWallType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1133259667: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWasteTerminalType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4009809668: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], v[10], (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    4088093105: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkCalendar(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[8]),
    1028945134: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkControl(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    4218914973: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkPlan(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), v[13]),
    3342526732: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkSchedule(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), v[13]),
    1033361043: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcZone(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3821786052: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActionRequest(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1411407467: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirTerminalBoxType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3352864051: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirTerminalType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1871374353: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirToAirHeatRecoveryType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3460190687: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAsset(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 2, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 2, v[10]), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 2, v[11]), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value, 2, v[13])),
    1532957894: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAudioVisualApplianceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1967976161: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBSplineCurve(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[2], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2461110595: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBSplineCurveWithKnots(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[2], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(p.value) : null) || [], v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(p.value) : null) || [], v[7]),
    819618141: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBeamType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    231477066: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoilerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1136057603: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3299480353: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2979338954: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementPart(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    39481116: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementPartType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1095909175: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementProxy(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1909888760: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementProxyType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1177604601: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingSystem(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    2188180465: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBurnerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    395041908: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableCarrierFittingType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3293546465: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableCarrierSegmentType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2674252688: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableFittingType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1285652485: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableSegmentType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2951183804: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcChillerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3296154744: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcChimney(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2611217952: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCircle(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 2, v[0]), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1677625105: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCivilElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2301859152: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoilType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    843113511: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColumn(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    905975707: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColumnStandardCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    400855858: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCommunicationsApplianceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3850581409: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompressorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2816379211: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCondenserType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3898045240: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionEquipmentResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), v[10]),
    1060000209: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionMaterialResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), v[10]),
    488727124: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionProductResource(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9]), v[10]),
    335055490: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCooledBeamType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2954562838: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoolingTowerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1973544240: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCovering(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3495092785: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurtainWall(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3961806047: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDamperType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1335981549: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDiscreteAccessory(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2635815018: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDiscreteAccessoryType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1599208980: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionChamberElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2063403501: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionControlElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1945004755: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3040386961: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionFlowElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3041715199: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionPort(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), v[7], v[8], v[9]),
    3205830791: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionSystem(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6]),
    395920057: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoor(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11], (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    3242481149: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorStandardCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11], (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    869906466: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctFittingType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3760055223: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctSegmentType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2030761528: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctSilencerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    663422040: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricApplianceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2417008758: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricDistributionBoardType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3277789161: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricFlowStorageDeviceType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1534661035: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricGeneratorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1217240411: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricMotorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    712377611: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricTimeControlType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1658829314: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEnergyConversionDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2814081492: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEngine(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3747195512: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvaporativeCooler(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    484807127: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvaporator(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1209101575: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalSpatialElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    346874300: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFanType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1810631287: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFilterType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4222183408: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFireSuppressionTerminalType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2058353004: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowController(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4278956645: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowFitting(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4037862832: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowInstrumentType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2188021234: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowMeter(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3132237377: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowMovingDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    987401354: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowSegment(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    707683696: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowStorageDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2223149337: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowTerminal(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3508470533: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowTreatmentDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    900683007: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFooting(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3319311131: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHeatExchanger(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2068733104: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHumidifier(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4175244083: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInterceptor(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2176052936: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcJunctionBox(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    76236018: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLamp(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    629592764: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightFixture(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1437502449: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMedicalDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1073191201: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMember(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1911478936: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMemberStandardCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2474470126: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMotorConnection(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    144952367: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOuterBoundaryCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3694346114: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOutlet(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1687234759: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPile(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    310824031: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPipeFitting(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3612865200: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPipeSegment(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3171933400: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlate(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1156407060: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlateStandardCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    738039164: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProtectiveDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    655969474: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProtectiveDeviceTrippingUnitType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    90941305: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPump(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2262370178: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRailing(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3024970846: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRamp(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3283111854: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRampFlight(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1232101972: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRationalBSplineCurveWithKnots(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], v[2], new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(p.value) : null) || [], v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(p.value) : null) || [], v[7], v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal(p.value) : null) || []),
    979691226: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingBar(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), v[12], v[13]),
    2572171363: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingBarType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), v[13], (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(2, p) : null) || []),
    2016517767: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRoof(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3053780830: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSanitaryTerminal(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1783015770: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSensorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1329646415: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShadingDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1529196076: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlab(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3127900445: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlabElementedCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3027962421: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlabStandardCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3420628829: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSolarDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1999602285: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpaceHeater(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1404847402: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStackTerminal(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    331165859: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStair(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4252922144: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStairFlight(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), v[12]),
    2515109513: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralAnalysisModel(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 2, v[9])),
    385403989: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], v[6], v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRatioMeasure(p.value) : null) || []),
    1621171031: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralPlanarAction(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 2, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11]),
    1162798199: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSwitchingDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    812556717: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTank(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3825984169: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTransformer(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3026737570: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTubeBundle(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3179687236: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitaryControlElementType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4292641817: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitaryEquipment(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4207607924: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcValve(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2391406946: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWall(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4156078855: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWallElementedCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3512223829: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWallStandardCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4237592921: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWasteTerminal(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3304561284: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindow(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11], (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    486154966: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowStandardCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11], (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    2874132201: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActuatorType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1634111441: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirTerminal(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    177149247: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirTerminalBox(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2056796094: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirToAirHeatRecovery(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3001207471: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAlarmType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    277319702: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAudioVisualAppliance(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    753842376: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBeam(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2906023776: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBeamStandardCase(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    32344328: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoiler(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2938176219: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBurner(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    635142910: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableCarrierFitting(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3758799889: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableCarrierSegment(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1051757585: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableFitting(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4217484030: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableSegment(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3902619387: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcChiller(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    639361253: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoil(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3221913625: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCommunicationsAppliance(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3571504051: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompressor(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2272882330: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCondenser(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    578613899: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcControllerType(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 2, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4136498852: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCooledBeam(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3640358203: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoolingTower(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4074379575: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDamper(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1052013943: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionChamberElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    562808652: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionCircuit(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6]),
    1062813311: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionControlElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    342316401: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctFitting(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3518393246: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctSegment(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1360408905: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctSilencer(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1904799276: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricAppliance(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    862014818: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricDistributionBoard(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3310460725: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricFlowStorageDevice(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    264262732: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricGenerator(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    402227799: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricMotor(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1003880860: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricTimeControl(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3415622556: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFan(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    819412036: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFilter(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1426591983: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFireSuppressionTerminal(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    182646315: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowInstrument(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2295281155: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProtectiveDeviceTrippingUnit(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4086658281: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSensor(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    630975310: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitaryControlElement(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4288193352: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActuator(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3087945054: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAlarm(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    25142252: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcController(new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 2, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 2, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 2, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8])
};
$3b8da494b8e92f36$export$6fc5084ea038b400[2] = {
    618182010: [
        $3b8da494b8e92f36$export$1d51c48a0d338c7d,
        $3b8da494b8e92f36$export$852f8a6b6383ece8
    ],
    411424972: [
        $3b8da494b8e92f36$export$61dc578b5cbce35b
    ],
    4037036970: [
        $3b8da494b8e92f36$export$cfb27e5500a39320,
        $3b8da494b8e92f36$export$229e73e933804e50,
        $3b8da494b8e92f36$export$a34702b337593132,
        $3b8da494b8e92f36$export$a08930e72563c535
    ],
    1387855156: [
        $3b8da494b8e92f36$export$cfb27e5500a39320
    ],
    2859738748: [
        $3b8da494b8e92f36$export$6ef8b10b979d6ed7,
        $3b8da494b8e92f36$export$7630445096f3e0e,
        $3b8da494b8e92f36$export$dc861dfbf2baaa1a,
        $3b8da494b8e92f36$export$415e991945a654ac,
        $3b8da494b8e92f36$export$a8e470c98a867218
    ],
    2614616156: [
        $3b8da494b8e92f36$export$415e991945a654ac
    ],
    1959218052: [
        $3b8da494b8e92f36$export$fd56761a594c90b1,
        $3b8da494b8e92f36$export$6bb698fabb80bc4f
    ],
    1785450214: [
        $3b8da494b8e92f36$export$9c8e8646198c2dbd
    ],
    1466758467: [
        $3b8da494b8e92f36$export$3ba9c26e1e245f60
    ],
    4294318154: [
        $3b8da494b8e92f36$export$18cb417b645b7410,
        $3b8da494b8e92f36$export$4414ee8d28b3907a,
        $3b8da494b8e92f36$export$87ba372ae8130125
    ],
    3200245327: [
        $3b8da494b8e92f36$export$5dc53366ca618592,
        $3b8da494b8e92f36$export$72ed75e7fb4d773c,
        $3b8da494b8e92f36$export$96fe74a17c6cc802,
        $3b8da494b8e92f36$export$5ea64628e783fcd7,
        $3b8da494b8e92f36$export$599e2cc9684286ad,
        $3b8da494b8e92f36$export$133f46f5e03827d2
    ],
    760658860: [
        $3b8da494b8e92f36$export$b1bef060ce5931d8,
        $3b8da494b8e92f36$export$bf1ff376c816a889,
        $3b8da494b8e92f36$export$f73761c75017e522,
        $3b8da494b8e92f36$export$ce700270dbd3f574,
        $3b8da494b8e92f36$export$cb4089fd00927e5e,
        $3b8da494b8e92f36$export$90624260d4eb2c6c,
        $3b8da494b8e92f36$export$271c16e7766bc70a,
        $3b8da494b8e92f36$export$36935a2a2087e3a2,
        $3b8da494b8e92f36$export$dc9e27d0030a4e65
    ],
    248100487: [
        $3b8da494b8e92f36$export$36935a2a2087e3a2
    ],
    2235152071: [
        $3b8da494b8e92f36$export$cb4089fd00927e5e
    ],
    1507914824: [
        $3b8da494b8e92f36$export$ac428444f42ac73b,
        $3b8da494b8e92f36$export$9da0ae2bdea157b5,
        $3b8da494b8e92f36$export$33d702d835661133
    ],
    1918398963: [
        $3b8da494b8e92f36$export$c792ec963053411b,
        $3b8da494b8e92f36$export$bc84a57a2afc707f,
        $3b8da494b8e92f36$export$4d644d65c6f10de9,
        $3b8da494b8e92f36$export$342dff6367faf07
    ],
    3701648758: [
        $3b8da494b8e92f36$export$34302876ddf37791,
        $3b8da494b8e92f36$export$af00f3f0f2c6d769
    ],
    2483315170: [
        $3b8da494b8e92f36$export$8334e069ea620bb8,
        $3b8da494b8e92f36$export$b383f456d1eb5728,
        $3b8da494b8e92f36$export$e5dbe5700ecba735,
        $3b8da494b8e92f36$export$ccca2dba73dadeee,
        $3b8da494b8e92f36$export$678778899caae9fb,
        $3b8da494b8e92f36$export$d48394905ba00253,
        $3b8da494b8e92f36$export$c69ac01f7bf51b3,
        $3b8da494b8e92f36$export$21edf23fe590ab33
    ],
    2226359599: [
        $3b8da494b8e92f36$export$b383f456d1eb5728,
        $3b8da494b8e92f36$export$e5dbe5700ecba735,
        $3b8da494b8e92f36$export$ccca2dba73dadeee,
        $3b8da494b8e92f36$export$678778899caae9fb,
        $3b8da494b8e92f36$export$d48394905ba00253,
        $3b8da494b8e92f36$export$c69ac01f7bf51b3
    ],
    677532197: [
        $3b8da494b8e92f36$export$2c91bae7185bb7c5,
        $3b8da494b8e92f36$export$42292ad7a949ca7e,
        $3b8da494b8e92f36$export$2a79ce8e6dde1605,
        $3b8da494b8e92f36$export$d18f4beaf4701e94,
        $3b8da494b8e92f36$export$56d725cc20359b33,
        $3b8da494b8e92f36$export$e24694355c430317,
        $3b8da494b8e92f36$export$5cd60fa6a78c0173,
        $3b8da494b8e92f36$export$5c5bfbea1f9750f0,
        $3b8da494b8e92f36$export$a111f4db685f7a59,
        $3b8da494b8e92f36$export$3ed3034f18cddaaf,
        $3b8da494b8e92f36$export$f9ded52c4b70f4f5,
        $3b8da494b8e92f36$export$856784adecc150fd,
        $3b8da494b8e92f36$export$6ce0be1835c9ab1b,
        $3b8da494b8e92f36$export$447b3f598cf8325d,
        $3b8da494b8e92f36$export$eb38190c7ccf4599,
        $3b8da494b8e92f36$export$616208c6ed2a0bc3,
        $3b8da494b8e92f36$export$12c8486b22f747b4,
        $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
        $3b8da494b8e92f36$export$925b578047892bce,
        $3b8da494b8e92f36$export$cc681b8347ae2d28,
        $3b8da494b8e92f36$export$f9f8eae306150574,
        $3b8da494b8e92f36$export$d8e08722b3a63093,
        $3b8da494b8e92f36$export$a22358e886367f19,
        $3b8da494b8e92f36$export$d3d6625d33fe749f,
        $3b8da494b8e92f36$export$28f95f3a6633e96f,
        $3b8da494b8e92f36$export$cdda591705a51882,
        $3b8da494b8e92f36$export$b54830ac8ad9727a,
        $3b8da494b8e92f36$export$a208be2840956e7f,
        $3b8da494b8e92f36$export$102bd971c14ba988,
        $3b8da494b8e92f36$export$c548b4b271e262e6,
        $3b8da494b8e92f36$export$9b0f4a78b27610b2,
        $3b8da494b8e92f36$export$a47851a048855495
    ],
    2022622350: [
        $3b8da494b8e92f36$export$c9ca953ef790beab
    ],
    3119450353: [
        $3b8da494b8e92f36$export$868aba9d7912640,
        $3b8da494b8e92f36$export$4c036fdbe809739e,
        $3b8da494b8e92f36$export$6f91f48d17dc7f0c,
        $3b8da494b8e92f36$export$922b2a5ffa4eee3e
    ],
    2095639259: [
        $3b8da494b8e92f36$export$6d55f5b363d70c84,
        $3b8da494b8e92f36$export$95d5078ec273e20a
    ],
    3958567839: [
        $3b8da494b8e92f36$export$78c21ee34d1c97a2,
        $3b8da494b8e92f36$export$4f772a6ff028612d,
        $3b8da494b8e92f36$export$6cce02eb19410fd6,
        $3b8da494b8e92f36$export$9bf9b7d525eb98c7,
        $3b8da494b8e92f36$export$509dfb8dfad057e9,
        $3b8da494b8e92f36$export$6659a6bebb9ff076,
        $3b8da494b8e92f36$export$9f98ad7f69b4,
        $3b8da494b8e92f36$export$3e010693b51db065,
        $3b8da494b8e92f36$export$5046f8ea20f33c53,
        $3b8da494b8e92f36$export$6a6339501d69dda6,
        $3b8da494b8e92f36$export$24e4f709acf9819a,
        $3b8da494b8e92f36$export$2c0c343d0211b12a,
        $3b8da494b8e92f36$export$bb7bafb36fa737d0,
        $3b8da494b8e92f36$export$9d1f507a1764cea9,
        $3b8da494b8e92f36$export$81a199afe8025f54,
        $3b8da494b8e92f36$export$6ff606ccfc58f5bb,
        $3b8da494b8e92f36$export$1a193eff9b81238c,
        $3b8da494b8e92f36$export$a749204998f5a3c,
        $3b8da494b8e92f36$export$3c5dfd8f9406db1,
        $3b8da494b8e92f36$export$40359089e4e5f50d,
        $3b8da494b8e92f36$export$7d329955417ee03b,
        $3b8da494b8e92f36$export$17c544e73ae3a145
    ],
    986844984: [
        $3b8da494b8e92f36$export$ea419368a3085d41,
        $3b8da494b8e92f36$export$18fc149087e3c79f,
        $3b8da494b8e92f36$export$9f8310d680636df4,
        $3b8da494b8e92f36$export$2d97768d0015dccc,
        $3b8da494b8e92f36$export$b40b280750874c4,
        $3b8da494b8e92f36$export$421fb9d9a3f56509,
        $3b8da494b8e92f36$export$2ee49241e76b8d88,
        $3b8da494b8e92f36$export$15997dea423f274a,
        $3b8da494b8e92f36$export$58f9c0981808b34a,
        $3b8da494b8e92f36$export$8ada78967ce0de43,
        $3b8da494b8e92f36$export$2f757802d81974e2,
        $3b8da494b8e92f36$export$f4438fbaac045e16,
        $3b8da494b8e92f36$export$c262d6aa9cc45c1e,
        $3b8da494b8e92f36$export$925767a3ae3a4925,
        $3b8da494b8e92f36$export$d8f086a59e04ee25,
        $3b8da494b8e92f36$export$971eec9c9d45cdbc,
        $3b8da494b8e92f36$export$a1c63a5e92dd2589
    ],
    1076942058: [
        $3b8da494b8e92f36$export$e8d16de4476cf00b,
        $3b8da494b8e92f36$export$feba35570752eed7,
        $3b8da494b8e92f36$export$5f0eb5061797e589,
        $3b8da494b8e92f36$export$982f17a83654a1a9,
        $3b8da494b8e92f36$export$2e35095825dbcf3c
    ],
    3377609919: [
        $3b8da494b8e92f36$export$c78a940a5c4e916a,
        $3b8da494b8e92f36$export$b1afc9e5bea6b0b5
    ],
    3008791417: [
        $3b8da494b8e92f36$export$f6578324c1ae7b2d,
        $3b8da494b8e92f36$export$9aea5e4278bdf41,
        $3b8da494b8e92f36$export$521bada8515ab976,
        $3b8da494b8e92f36$export$5549d05fc93b536b,
        $3b8da494b8e92f36$export$ef6ede6699415aa4,
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f,
        $3b8da494b8e92f36$export$ec4770aab56c805f,
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$569b2f842286694a,
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f,
        $3b8da494b8e92f36$export$7952e91536a239e7,
        $3b8da494b8e92f36$export$cddab537799fe2fd,
        $3b8da494b8e92f36$export$922fa769a539de57,
        $3b8da494b8e92f36$export$85f2457f407ffd38,
        $3b8da494b8e92f36$export$c71362c4ed185b32,
        $3b8da494b8e92f36$export$3a90cd7486e7bfc7,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43,
        $3b8da494b8e92f36$export$6c79cacc663fc254,
        $3b8da494b8e92f36$export$5f769669c17cd7be,
        $3b8da494b8e92f36$export$aba424e86850f717,
        $3b8da494b8e92f36$export$2a2b17b32d1a9938,
        $3b8da494b8e92f36$export$f1de0c39f08c8646,
        $3b8da494b8e92f36$export$36783435db2b01a1,
        $3b8da494b8e92f36$export$d414ecd4014891b0,
        $3b8da494b8e92f36$export$5655bbb83559ae0a,
        $3b8da494b8e92f36$export$5478cb2985eabb5a,
        $3b8da494b8e92f36$export$d919945f72bbea0b,
        $3b8da494b8e92f36$export$64fbfc27b4cec02a,
        $3b8da494b8e92f36$export$843f1ace19c7b757,
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252,
        $3b8da494b8e92f36$export$88babb7bc763dabe,
        $3b8da494b8e92f36$export$86be59b19ba0bac8,
        $3b8da494b8e92f36$export$e5527fc80680ccac,
        $3b8da494b8e92f36$export$d0a6287d5fe2b0d0,
        $3b8da494b8e92f36$export$24551edc0d1c7c9e,
        $3b8da494b8e92f36$export$36a18b804a497897,
        $3b8da494b8e92f36$export$a340b94c3a9627f5,
        $3b8da494b8e92f36$export$a93e600de3d261bf,
        $3b8da494b8e92f36$export$6b50b93a9a443e09,
        $3b8da494b8e92f36$export$aa7ed498f6d760b8,
        $3b8da494b8e92f36$export$fd5f089562b081f9,
        $3b8da494b8e92f36$export$baa116807524c06e,
        $3b8da494b8e92f36$export$cf616a1a67553ce5,
        $3b8da494b8e92f36$export$2ecfbeca9fa8edbd,
        $3b8da494b8e92f36$export$be55db5658261c24,
        $3b8da494b8e92f36$export$e759ffb34c88cdbb,
        $3b8da494b8e92f36$export$a15ad7bc84af942e,
        $3b8da494b8e92f36$export$70128586019a4a85,
        $3b8da494b8e92f36$export$a633a7857c4afb8b,
        $3b8da494b8e92f36$export$8bcad0fd81ccef4e,
        $3b8da494b8e92f36$export$7c3b7ecc8dd17171,
        $3b8da494b8e92f36$export$32b9b3ebd4722148,
        $3b8da494b8e92f36$export$60c94e2d2eb3ae2d,
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d,
        $3b8da494b8e92f36$export$14920f38b00f3073,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$4bb861b4bba551ce,
        $3b8da494b8e92f36$export$7a8fab203344ee59,
        $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b,
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a,
        $3b8da494b8e92f36$export$e7d69479b3ed50b5,
        $3b8da494b8e92f36$export$aea7582eed012cfd,
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f,
        $3b8da494b8e92f36$export$45f4c4bef325c6de,
        $3b8da494b8e92f36$export$212932c39cad14c1,
        $3b8da494b8e92f36$export$a7c9a308bd61791e,
        $3b8da494b8e92f36$export$9462ca86e16364d3,
        $3b8da494b8e92f36$export$2ef492eaafc1544a,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$fe015439a6fa96b6,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$cc878395e6134df2,
        $3b8da494b8e92f36$export$f03ac9a18a5a000,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$db3cb7c28fcdcb12,
        $3b8da494b8e92f36$export$1fe9373d30daf09d,
        $3b8da494b8e92f36$export$f0268edfa147e5dc,
        $3b8da494b8e92f36$export$9de8356191dd818,
        $3b8da494b8e92f36$export$929165ba65228ecd,
        $3b8da494b8e92f36$export$8923f08b310dd8eb,
        $3b8da494b8e92f36$export$f9263ceb04bc6af7,
        $3b8da494b8e92f36$export$f181705801de6aa3,
        $3b8da494b8e92f36$export$a8dfee375f66477,
        $3b8da494b8e92f36$export$53e8d872a4770e53,
        $3b8da494b8e92f36$export$51d4dba1ae2d8f1b,
        $3b8da494b8e92f36$export$307e928f69359e15,
        $3b8da494b8e92f36$export$ad8e83777baa8a31,
        $3b8da494b8e92f36$export$48039412bed87667,
        $3b8da494b8e92f36$export$f91087a08c2974c5,
        $3b8da494b8e92f36$export$a205ad382a675d9,
        $3b8da494b8e92f36$export$7d2f047f3374cd6d,
        $3b8da494b8e92f36$export$91b809c3774b52ca,
        $3b8da494b8e92f36$export$8799bf99f01d0b68,
        $3b8da494b8e92f36$export$117debe45e2ae49d,
        $3b8da494b8e92f36$export$ebd3184cd8b065fd,
        $3b8da494b8e92f36$export$e569b2ccaf52a8fd,
        $3b8da494b8e92f36$export$fc934d2c514a6d85,
        $3b8da494b8e92f36$export$20db6cfb2db45f44,
        $3b8da494b8e92f36$export$70c90f142bc37811,
        $3b8da494b8e92f36$export$a321d78f5cb9ca4f,
        $3b8da494b8e92f36$export$52eaa2d341700ec1,
        $3b8da494b8e92f36$export$804200e8992a9b20,
        $3b8da494b8e92f36$export$e209a4a7e118ebd5,
        $3b8da494b8e92f36$export$1dcd1852764e4fb7,
        $3b8da494b8e92f36$export$c75f1a12de9d86b8,
        $3b8da494b8e92f36$export$720f149ff6c3542a,
        $3b8da494b8e92f36$export$3534ea9b1da643f3,
        $3b8da494b8e92f36$export$55b4788f85a51e1a,
        $3b8da494b8e92f36$export$5a54e2173db7aff1,
        $3b8da494b8e92f36$export$6c1d729adeeaed4a,
        $3b8da494b8e92f36$export$a88a630c8a34962c,
        $3b8da494b8e92f36$export$3d22c077bdb90a75,
        $3b8da494b8e92f36$export$7beb7cab9d3e2b14,
        $3b8da494b8e92f36$export$4b2fd6d0e55ecfa0,
        $3b8da494b8e92f36$export$8176d17ddc845867,
        $3b8da494b8e92f36$export$dd210e591847e415,
        $3b8da494b8e92f36$export$873d7c14f646e598,
        $3b8da494b8e92f36$export$5993765fc33cd311,
        $3b8da494b8e92f36$export$c780a52ecdcabf01,
        $3b8da494b8e92f36$export$d82e092cbe83635,
        $3b8da494b8e92f36$export$b718d0ddc70e8826
    ],
    2439245199: [
        $3b8da494b8e92f36$export$acffd400493c189c,
        $3b8da494b8e92f36$export$13de02c11c361011,
        $3b8da494b8e92f36$export$7fc4348977f8efbe,
        $3b8da494b8e92f36$export$f7ea933b5cc28fe9,
        $3b8da494b8e92f36$export$e2f0b7f5e626526f,
        $3b8da494b8e92f36$export$dc995d42867b8d56,
        $3b8da494b8e92f36$export$623f6287e006c7a4,
        $3b8da494b8e92f36$export$fba1c7dc4402a4b3,
        $3b8da494b8e92f36$export$cea9d94742f0d4d6
    ],
    2341007311: [
        $3b8da494b8e92f36$export$813f9cf6a2209fec,
        $3b8da494b8e92f36$export$dfec9be971c6e8a5,
        $3b8da494b8e92f36$export$bc9bd707c4403985,
        $3b8da494b8e92f36$export$f650b9b610878411,
        $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
        $3b8da494b8e92f36$export$cff3fa05b2018b59,
        $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
        $3b8da494b8e92f36$export$d35785e0f77dbe69,
        $3b8da494b8e92f36$export$b1832f175144bc77,
        $3b8da494b8e92f36$export$2e330e8e36019063,
        $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
        $3b8da494b8e92f36$export$96504c3b59e8a728,
        $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
        $3b8da494b8e92f36$export$a712aed3e137585e,
        $3b8da494b8e92f36$export$c331bec3b085e9a1,
        $3b8da494b8e92f36$export$2bafde249aab99b4,
        $3b8da494b8e92f36$export$8d69d79340327b03,
        $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
        $3b8da494b8e92f36$export$9cb68f339a367600,
        $3b8da494b8e92f36$export$51e6468498cab028,
        $3b8da494b8e92f36$export$20528f2adfe8dc9c,
        $3b8da494b8e92f36$export$9572797f2851b0,
        $3b8da494b8e92f36$export$b933598a67b23044,
        $3b8da494b8e92f36$export$976ca854e309f825,
        $3b8da494b8e92f36$export$1fe9178d23052979,
        $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
        $3b8da494b8e92f36$export$94d1e1fe7b940759,
        $3b8da494b8e92f36$export$2b794d8b645d7087,
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c,
        $3b8da494b8e92f36$export$4a59ec454710396a,
        $3b8da494b8e92f36$export$a636087bbbf1a084,
        $3b8da494b8e92f36$export$90569318bbf3a5cb,
        $3b8da494b8e92f36$export$3fd59b6be292fb81,
        $3b8da494b8e92f36$export$8bef70def9fcccef,
        $3b8da494b8e92f36$export$8f026b620b6b36d2,
        $3b8da494b8e92f36$export$89d3022d89ef3649,
        $3b8da494b8e92f36$export$c7eeffff290e6124,
        $3b8da494b8e92f36$export$87c3ff288d974d02,
        $3b8da494b8e92f36$export$5c698c7bb50b493,
        $3b8da494b8e92f36$export$422809562a8398de,
        $3b8da494b8e92f36$export$a48481dfef95f4a2,
        $3b8da494b8e92f36$export$d68e05a23c1f8359,
        $3b8da494b8e92f36$export$95d386c017712592,
        $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
        $3b8da494b8e92f36$export$d988060319005ccc,
        $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
        $3b8da494b8e92f36$export$6c8179c0d6d08ecd,
        $3b8da494b8e92f36$export$825f7cab9140cf42,
        $3b8da494b8e92f36$export$6dac613d32d3427f,
        $3b8da494b8e92f36$export$23fb84fb575e1cb4,
        $3b8da494b8e92f36$export$67177aa5e10d7edd,
        $3b8da494b8e92f36$export$2abd1abb4fbec99a,
        $3b8da494b8e92f36$export$11ccca7a6068fc2c,
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$b58a07450f76f5f4,
        $3b8da494b8e92f36$export$f27d665fae434b5e,
        $3b8da494b8e92f36$export$ae9001e98ea773dd,
        $3b8da494b8e92f36$export$3eb2ff47f0213310,
        $3b8da494b8e92f36$export$de24c94bb0d02a47,
        $3b8da494b8e92f36$export$c97535012f6ac326,
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$57379c20a5f35b14,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09,
        $3b8da494b8e92f36$export$f43ad39311bcb56,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$8e15250779a21ef,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c,
        $3b8da494b8e92f36$export$573337cb0f58bf7b,
        $3b8da494b8e92f36$export$4690a2f5205975d8,
        $3b8da494b8e92f36$export$d4f0edab93018f7f,
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1,
        $3b8da494b8e92f36$export$5591fe75469fbc36,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$d912e9b49c740c82,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$df5d90a458391b35,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$7f972ab55f8adda0,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$f765133cc69cf269,
        $3b8da494b8e92f36$export$53f51e3ca061719d,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$40058285857aae13,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$540eb1154ef9932a,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$22f423f0e05cb34b,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$1c2f4ad96fea6d36,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$14c6ae98e9d52fcb,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$cc78bfb1fd84dc0c,
        $3b8da494b8e92f36$export$ecd13d53d7a4573e,
        $3b8da494b8e92f36$export$91748340fd72a888,
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$d14ef3fe75da3f4,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6,
        $3b8da494b8e92f36$export$22d84e75fa702951,
        $3b8da494b8e92f36$export$aa818ced04ed1ad6,
        $3b8da494b8e92f36$export$4f9b13f55d01f662,
        $3b8da494b8e92f36$export$7bec46e80091ced6,
        $3b8da494b8e92f36$export$ae975bd6a53dc3da,
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e,
        $3b8da494b8e92f36$export$3d378e730e40374,
        $3b8da494b8e92f36$export$b05d4b54ea7217ba,
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8ab37c04c221437e,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$d1d6e43b67173127,
        $3b8da494b8e92f36$export$e8d5f91a47737ca2,
        $3b8da494b8e92f36$export$fe64d2939a7bcd9f,
        $3b8da494b8e92f36$export$b09c679f1085725a,
        $3b8da494b8e92f36$export$c81d279acf1b12b4,
        $3b8da494b8e92f36$export$599b343cb1d64b49,
        $3b8da494b8e92f36$export$60411d6f391d4743,
        $3b8da494b8e92f36$export$9418e91392f50813,
        $3b8da494b8e92f36$export$933e35db50e6a51e
    ],
    1054537805: [
        $3b8da494b8e92f36$export$995f2435226e1b6a,
        $3b8da494b8e92f36$export$a568399b60500b43,
        $3b8da494b8e92f36$export$1c250d1efa52f027,
        $3b8da494b8e92f36$export$c259b6fe2d03e118,
        $3b8da494b8e92f36$export$25d64be31bf108b,
        $3b8da494b8e92f36$export$cfb1203a57a5f31c
    ],
    3982875396: [
        $3b8da494b8e92f36$export$5f0eb5061797e589,
        $3b8da494b8e92f36$export$982f17a83654a1a9
    ],
    2273995522: [
        $3b8da494b8e92f36$export$7bbc953ffa23813a,
        $3b8da494b8e92f36$export$b4e4bbdecfda501
    ],
    2162789131: [
        $3b8da494b8e92f36$export$ebcd8907887dc222,
        $3b8da494b8e92f36$export$34a05c9e12c53c23,
        $3b8da494b8e92f36$export$a413c76fb80f2f8f,
        $3b8da494b8e92f36$export$3787e1faec59f84d,
        $3b8da494b8e92f36$export$17bdef5f951eb73a,
        $3b8da494b8e92f36$export$ceebe0114638d080,
        $3b8da494b8e92f36$export$1256946afdc9c505,
        $3b8da494b8e92f36$export$6b91369e24532c08,
        $3b8da494b8e92f36$export$2488f86e43e28df,
        $3b8da494b8e92f36$export$aaf8576a4abe9819,
        $3b8da494b8e92f36$export$f8bd1434641262e3
    ],
    609421318: [
        $3b8da494b8e92f36$export$ebcd8907887dc222,
        $3b8da494b8e92f36$export$34a05c9e12c53c23,
        $3b8da494b8e92f36$export$a413c76fb80f2f8f,
        $3b8da494b8e92f36$export$3787e1faec59f84d,
        $3b8da494b8e92f36$export$17bdef5f951eb73a,
        $3b8da494b8e92f36$export$ceebe0114638d080,
        $3b8da494b8e92f36$export$1256946afdc9c505,
        $3b8da494b8e92f36$export$6b91369e24532c08,
        $3b8da494b8e92f36$export$2488f86e43e28df
    ],
    2525727697: [
        $3b8da494b8e92f36$export$34a05c9e12c53c23,
        $3b8da494b8e92f36$export$a413c76fb80f2f8f,
        $3b8da494b8e92f36$export$3787e1faec59f84d,
        $3b8da494b8e92f36$export$17bdef5f951eb73a,
        $3b8da494b8e92f36$export$ceebe0114638d080,
        $3b8da494b8e92f36$export$1256946afdc9c505,
        $3b8da494b8e92f36$export$6b91369e24532c08
    ],
    2830218821: [
        $3b8da494b8e92f36$export$e8d16de4476cf00b
    ],
    846575682: [
        $3b8da494b8e92f36$export$102bd971c14ba988
    ],
    626085974: [
        $3b8da494b8e92f36$export$d3d6625d33fe749f,
        $3b8da494b8e92f36$export$28f95f3a6633e96f,
        $3b8da494b8e92f36$export$cdda591705a51882
    ],
    1549132990: [
        $3b8da494b8e92f36$export$25d64be31bf108b
    ],
    280115917: [
        $3b8da494b8e92f36$export$12c8486b22f747b4,
        $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
        $3b8da494b8e92f36$export$925b578047892bce,
        $3b8da494b8e92f36$export$cc681b8347ae2d28
    ],
    3101149627: [
        $3b8da494b8e92f36$export$3535b249460c70df,
        $3b8da494b8e92f36$export$9fb6085672705774
    ],
    1377556343: [
        $3b8da494b8e92f36$export$52eaa2d341700ec1,
        $3b8da494b8e92f36$export$804200e8992a9b20,
        $3b8da494b8e92f36$export$e209a4a7e118ebd5,
        $3b8da494b8e92f36$export$1dcd1852764e4fb7,
        $3b8da494b8e92f36$export$c75f1a12de9d86b8,
        $3b8da494b8e92f36$export$720f149ff6c3542a,
        $3b8da494b8e92f36$export$3534ea9b1da643f3,
        $3b8da494b8e92f36$export$55b4788f85a51e1a,
        $3b8da494b8e92f36$export$5a54e2173db7aff1,
        $3b8da494b8e92f36$export$6c1d729adeeaed4a,
        $3b8da494b8e92f36$export$a88a630c8a34962c,
        $3b8da494b8e92f36$export$3d22c077bdb90a75,
        $3b8da494b8e92f36$export$7beb7cab9d3e2b14,
        $3b8da494b8e92f36$export$4b2fd6d0e55ecfa0,
        $3b8da494b8e92f36$export$8176d17ddc845867,
        $3b8da494b8e92f36$export$dd210e591847e415,
        $3b8da494b8e92f36$export$873d7c14f646e598,
        $3b8da494b8e92f36$export$5993765fc33cd311,
        $3b8da494b8e92f36$export$c780a52ecdcabf01
    ],
    2799835756: [
        $3b8da494b8e92f36$export$5993765fc33cd311
    ],
    3798115385: [
        $3b8da494b8e92f36$export$7d329955417ee03b
    ],
    1310608509: [
        $3b8da494b8e92f36$export$3c5dfd8f9406db1
    ],
    3264961684: [
        $3b8da494b8e92f36$export$856784adecc150fd
    ],
    370225590: [
        $3b8da494b8e92f36$export$8176d17ddc845867,
        $3b8da494b8e92f36$export$dd210e591847e415
    ],
    2889183280: [
        $3b8da494b8e92f36$export$c792ec963053411b
    ],
    3632507154: [
        $3b8da494b8e92f36$export$6ff606ccfc58f5bb
    ],
    3900360178: [
        $3b8da494b8e92f36$export$a88a630c8a34962c,
        $3b8da494b8e92f36$export$3d22c077bdb90a75,
        $3b8da494b8e92f36$export$7beb7cab9d3e2b14
    ],
    297599258: [
        $3b8da494b8e92f36$export$925767a3ae3a4925,
        $3b8da494b8e92f36$export$d8f086a59e04ee25
    ],
    2556980723: [
        $3b8da494b8e92f36$export$55b4788f85a51e1a,
        $3b8da494b8e92f36$export$5a54e2173db7aff1
    ],
    1809719519: [
        $3b8da494b8e92f36$export$720f149ff6c3542a
    ],
    3008276851: [
        $3b8da494b8e92f36$export$55b4788f85a51e1a
    ],
    3448662350: [
        $3b8da494b8e92f36$export$c78a940a5c4e916a
    ],
    2453401579: [
        $3b8da494b8e92f36$export$9aea5e4278bdf41,
        $3b8da494b8e92f36$export$521bada8515ab976,
        $3b8da494b8e92f36$export$5549d05fc93b536b,
        $3b8da494b8e92f36$export$ef6ede6699415aa4,
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f,
        $3b8da494b8e92f36$export$ec4770aab56c805f,
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$569b2f842286694a,
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f,
        $3b8da494b8e92f36$export$7952e91536a239e7,
        $3b8da494b8e92f36$export$cddab537799fe2fd,
        $3b8da494b8e92f36$export$922fa769a539de57,
        $3b8da494b8e92f36$export$85f2457f407ffd38,
        $3b8da494b8e92f36$export$c71362c4ed185b32,
        $3b8da494b8e92f36$export$3a90cd7486e7bfc7,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43,
        $3b8da494b8e92f36$export$6c79cacc663fc254,
        $3b8da494b8e92f36$export$5f769669c17cd7be,
        $3b8da494b8e92f36$export$aba424e86850f717,
        $3b8da494b8e92f36$export$2a2b17b32d1a9938,
        $3b8da494b8e92f36$export$f1de0c39f08c8646,
        $3b8da494b8e92f36$export$36783435db2b01a1,
        $3b8da494b8e92f36$export$d414ecd4014891b0,
        $3b8da494b8e92f36$export$5655bbb83559ae0a,
        $3b8da494b8e92f36$export$5478cb2985eabb5a,
        $3b8da494b8e92f36$export$d919945f72bbea0b,
        $3b8da494b8e92f36$export$64fbfc27b4cec02a,
        $3b8da494b8e92f36$export$843f1ace19c7b757,
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252,
        $3b8da494b8e92f36$export$88babb7bc763dabe,
        $3b8da494b8e92f36$export$86be59b19ba0bac8,
        $3b8da494b8e92f36$export$e5527fc80680ccac,
        $3b8da494b8e92f36$export$d0a6287d5fe2b0d0,
        $3b8da494b8e92f36$export$24551edc0d1c7c9e,
        $3b8da494b8e92f36$export$36a18b804a497897,
        $3b8da494b8e92f36$export$a340b94c3a9627f5,
        $3b8da494b8e92f36$export$a93e600de3d261bf,
        $3b8da494b8e92f36$export$6b50b93a9a443e09,
        $3b8da494b8e92f36$export$aa7ed498f6d760b8,
        $3b8da494b8e92f36$export$fd5f089562b081f9,
        $3b8da494b8e92f36$export$baa116807524c06e,
        $3b8da494b8e92f36$export$cf616a1a67553ce5,
        $3b8da494b8e92f36$export$2ecfbeca9fa8edbd,
        $3b8da494b8e92f36$export$be55db5658261c24,
        $3b8da494b8e92f36$export$e759ffb34c88cdbb,
        $3b8da494b8e92f36$export$a15ad7bc84af942e,
        $3b8da494b8e92f36$export$70128586019a4a85,
        $3b8da494b8e92f36$export$a633a7857c4afb8b,
        $3b8da494b8e92f36$export$8bcad0fd81ccef4e,
        $3b8da494b8e92f36$export$7c3b7ecc8dd17171,
        $3b8da494b8e92f36$export$32b9b3ebd4722148,
        $3b8da494b8e92f36$export$60c94e2d2eb3ae2d,
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d,
        $3b8da494b8e92f36$export$14920f38b00f3073,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$4bb861b4bba551ce,
        $3b8da494b8e92f36$export$7a8fab203344ee59,
        $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b,
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a,
        $3b8da494b8e92f36$export$e7d69479b3ed50b5,
        $3b8da494b8e92f36$export$aea7582eed012cfd,
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f,
        $3b8da494b8e92f36$export$45f4c4bef325c6de,
        $3b8da494b8e92f36$export$212932c39cad14c1,
        $3b8da494b8e92f36$export$a7c9a308bd61791e,
        $3b8da494b8e92f36$export$9462ca86e16364d3,
        $3b8da494b8e92f36$export$2ef492eaafc1544a,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$fe015439a6fa96b6,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$cc878395e6134df2,
        $3b8da494b8e92f36$export$f03ac9a18a5a000,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$db3cb7c28fcdcb12,
        $3b8da494b8e92f36$export$1fe9373d30daf09d,
        $3b8da494b8e92f36$export$f0268edfa147e5dc,
        $3b8da494b8e92f36$export$9de8356191dd818,
        $3b8da494b8e92f36$export$929165ba65228ecd,
        $3b8da494b8e92f36$export$8923f08b310dd8eb,
        $3b8da494b8e92f36$export$f9263ceb04bc6af7,
        $3b8da494b8e92f36$export$f181705801de6aa3,
        $3b8da494b8e92f36$export$a8dfee375f66477,
        $3b8da494b8e92f36$export$53e8d872a4770e53,
        $3b8da494b8e92f36$export$51d4dba1ae2d8f1b,
        $3b8da494b8e92f36$export$307e928f69359e15,
        $3b8da494b8e92f36$export$ad8e83777baa8a31,
        $3b8da494b8e92f36$export$48039412bed87667,
        $3b8da494b8e92f36$export$f91087a08c2974c5,
        $3b8da494b8e92f36$export$a205ad382a675d9,
        $3b8da494b8e92f36$export$7d2f047f3374cd6d,
        $3b8da494b8e92f36$export$91b809c3774b52ca,
        $3b8da494b8e92f36$export$8799bf99f01d0b68,
        $3b8da494b8e92f36$export$117debe45e2ae49d,
        $3b8da494b8e92f36$export$ebd3184cd8b065fd,
        $3b8da494b8e92f36$export$e569b2ccaf52a8fd,
        $3b8da494b8e92f36$export$fc934d2c514a6d85,
        $3b8da494b8e92f36$export$20db6cfb2db45f44,
        $3b8da494b8e92f36$export$70c90f142bc37811
    ],
    3590301190: [
        $3b8da494b8e92f36$export$20db6cfb2db45f44
    ],
    812098782: [
        $3b8da494b8e92f36$export$ebd3184cd8b065fd,
        $3b8da494b8e92f36$export$e569b2ccaf52a8fd
    ],
    1437953363: [
        $3b8da494b8e92f36$export$12c8486b22f747b4
    ],
    1402838566: [
        $3b8da494b8e92f36$export$f91087a08c2974c5,
        $3b8da494b8e92f36$export$a205ad382a675d9,
        $3b8da494b8e92f36$export$7d2f047f3374cd6d,
        $3b8da494b8e92f36$export$91b809c3774b52ca,
        $3b8da494b8e92f36$export$8799bf99f01d0b68
    ],
    1520743889: [
        $3b8da494b8e92f36$export$f91087a08c2974c5
    ],
    1008929658: [
        $3b8da494b8e92f36$export$804200e8992a9b20,
        $3b8da494b8e92f36$export$e209a4a7e118ebd5,
        $3b8da494b8e92f36$export$1dcd1852764e4fb7
    ],
    3079605661: [
        $3b8da494b8e92f36$export$ac428444f42ac73b
    ],
    219451334: [
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$57379c20a5f35b14,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09,
        $3b8da494b8e92f36$export$f43ad39311bcb56,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$8e15250779a21ef,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c,
        $3b8da494b8e92f36$export$573337cb0f58bf7b,
        $3b8da494b8e92f36$export$4690a2f5205975d8,
        $3b8da494b8e92f36$export$d4f0edab93018f7f,
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1,
        $3b8da494b8e92f36$export$5591fe75469fbc36,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$d912e9b49c740c82,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$df5d90a458391b35,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$7f972ab55f8adda0,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$f765133cc69cf269,
        $3b8da494b8e92f36$export$53f51e3ca061719d,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$40058285857aae13,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$540eb1154ef9932a,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$22f423f0e05cb34b,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$1c2f4ad96fea6d36,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$14c6ae98e9d52fcb,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$cc78bfb1fd84dc0c,
        $3b8da494b8e92f36$export$ecd13d53d7a4573e,
        $3b8da494b8e92f36$export$91748340fd72a888,
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$d14ef3fe75da3f4,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6,
        $3b8da494b8e92f36$export$22d84e75fa702951,
        $3b8da494b8e92f36$export$aa818ced04ed1ad6,
        $3b8da494b8e92f36$export$4f9b13f55d01f662,
        $3b8da494b8e92f36$export$7bec46e80091ced6,
        $3b8da494b8e92f36$export$ae975bd6a53dc3da,
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e,
        $3b8da494b8e92f36$export$3d378e730e40374,
        $3b8da494b8e92f36$export$b05d4b54ea7217ba,
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8ab37c04c221437e,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$d1d6e43b67173127,
        $3b8da494b8e92f36$export$e8d5f91a47737ca2,
        $3b8da494b8e92f36$export$fe64d2939a7bcd9f,
        $3b8da494b8e92f36$export$b09c679f1085725a,
        $3b8da494b8e92f36$export$c81d279acf1b12b4,
        $3b8da494b8e92f36$export$599b343cb1d64b49,
        $3b8da494b8e92f36$export$60411d6f391d4743,
        $3b8da494b8e92f36$export$9418e91392f50813
    ],
    2529465313: [
        $3b8da494b8e92f36$export$78c21ee34d1c97a2,
        $3b8da494b8e92f36$export$4f772a6ff028612d,
        $3b8da494b8e92f36$export$6cce02eb19410fd6,
        $3b8da494b8e92f36$export$9bf9b7d525eb98c7,
        $3b8da494b8e92f36$export$509dfb8dfad057e9,
        $3b8da494b8e92f36$export$6659a6bebb9ff076,
        $3b8da494b8e92f36$export$9f98ad7f69b4,
        $3b8da494b8e92f36$export$3e010693b51db065,
        $3b8da494b8e92f36$export$5046f8ea20f33c53,
        $3b8da494b8e92f36$export$6a6339501d69dda6,
        $3b8da494b8e92f36$export$24e4f709acf9819a,
        $3b8da494b8e92f36$export$2c0c343d0211b12a,
        $3b8da494b8e92f36$export$bb7bafb36fa737d0,
        $3b8da494b8e92f36$export$9d1f507a1764cea9
    ],
    2004835150: [
        $3b8da494b8e92f36$export$51d4dba1ae2d8f1b,
        $3b8da494b8e92f36$export$307e928f69359e15,
        $3b8da494b8e92f36$export$ad8e83777baa8a31
    ],
    1663979128: [
        $3b8da494b8e92f36$export$a8dfee375f66477
    ],
    2067069095: [
        $3b8da494b8e92f36$export$929165ba65228ecd,
        $3b8da494b8e92f36$export$8923f08b310dd8eb,
        $3b8da494b8e92f36$export$f9263ceb04bc6af7
    ],
    3727388367: [
        $3b8da494b8e92f36$export$2c91bae7185bb7c5,
        $3b8da494b8e92f36$export$42292ad7a949ca7e,
        $3b8da494b8e92f36$export$2a79ce8e6dde1605,
        $3b8da494b8e92f36$export$d18f4beaf4701e94,
        $3b8da494b8e92f36$export$56d725cc20359b33,
        $3b8da494b8e92f36$export$e24694355c430317
    ],
    3778827333: [
        $3b8da494b8e92f36$export$8ada78967ce0de43,
        $3b8da494b8e92f36$export$2f757802d81974e2,
        $3b8da494b8e92f36$export$f4438fbaac045e16
    ],
    1775413392: [
        $3b8da494b8e92f36$export$56d725cc20359b33
    ],
    2598011224: [
        $3b8da494b8e92f36$export$ea419368a3085d41,
        $3b8da494b8e92f36$export$18fc149087e3c79f,
        $3b8da494b8e92f36$export$9f8310d680636df4,
        $3b8da494b8e92f36$export$2d97768d0015dccc,
        $3b8da494b8e92f36$export$b40b280750874c4,
        $3b8da494b8e92f36$export$421fb9d9a3f56509,
        $3b8da494b8e92f36$export$2ee49241e76b8d88,
        $3b8da494b8e92f36$export$15997dea423f274a
    ],
    1680319473: [
        $3b8da494b8e92f36$export$825f7cab9140cf42,
        $3b8da494b8e92f36$export$6dac613d32d3427f,
        $3b8da494b8e92f36$export$23fb84fb575e1cb4,
        $3b8da494b8e92f36$export$67177aa5e10d7edd,
        $3b8da494b8e92f36$export$2abd1abb4fbec99a,
        $3b8da494b8e92f36$export$11ccca7a6068fc2c,
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$b58a07450f76f5f4,
        $3b8da494b8e92f36$export$f27d665fae434b5e,
        $3b8da494b8e92f36$export$ae9001e98ea773dd,
        $3b8da494b8e92f36$export$3eb2ff47f0213310,
        $3b8da494b8e92f36$export$de24c94bb0d02a47
    ],
    3357820518: [
        $3b8da494b8e92f36$export$11ccca7a6068fc2c,
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$b58a07450f76f5f4,
        $3b8da494b8e92f36$export$f27d665fae434b5e,
        $3b8da494b8e92f36$export$ae9001e98ea773dd,
        $3b8da494b8e92f36$export$3eb2ff47f0213310
    ],
    1482703590: [
        $3b8da494b8e92f36$export$825f7cab9140cf42,
        $3b8da494b8e92f36$export$6dac613d32d3427f,
        $3b8da494b8e92f36$export$23fb84fb575e1cb4,
        $3b8da494b8e92f36$export$67177aa5e10d7edd
    ],
    2090586900: [
        $3b8da494b8e92f36$export$ae9001e98ea773dd
    ],
    3615266464: [
        $3b8da494b8e92f36$export$2c0c343d0211b12a,
        $3b8da494b8e92f36$export$bb7bafb36fa737d0
    ],
    478536968: [
        $3b8da494b8e92f36$export$813f9cf6a2209fec,
        $3b8da494b8e92f36$export$dfec9be971c6e8a5,
        $3b8da494b8e92f36$export$bc9bd707c4403985,
        $3b8da494b8e92f36$export$f650b9b610878411,
        $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
        $3b8da494b8e92f36$export$cff3fa05b2018b59,
        $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
        $3b8da494b8e92f36$export$d35785e0f77dbe69,
        $3b8da494b8e92f36$export$b1832f175144bc77,
        $3b8da494b8e92f36$export$2e330e8e36019063,
        $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
        $3b8da494b8e92f36$export$96504c3b59e8a728,
        $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
        $3b8da494b8e92f36$export$a712aed3e137585e,
        $3b8da494b8e92f36$export$c331bec3b085e9a1,
        $3b8da494b8e92f36$export$2bafde249aab99b4,
        $3b8da494b8e92f36$export$8d69d79340327b03,
        $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
        $3b8da494b8e92f36$export$9cb68f339a367600,
        $3b8da494b8e92f36$export$51e6468498cab028,
        $3b8da494b8e92f36$export$20528f2adfe8dc9c,
        $3b8da494b8e92f36$export$9572797f2851b0,
        $3b8da494b8e92f36$export$b933598a67b23044,
        $3b8da494b8e92f36$export$976ca854e309f825,
        $3b8da494b8e92f36$export$1fe9178d23052979,
        $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
        $3b8da494b8e92f36$export$94d1e1fe7b940759,
        $3b8da494b8e92f36$export$2b794d8b645d7087,
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c,
        $3b8da494b8e92f36$export$4a59ec454710396a,
        $3b8da494b8e92f36$export$a636087bbbf1a084,
        $3b8da494b8e92f36$export$90569318bbf3a5cb,
        $3b8da494b8e92f36$export$3fd59b6be292fb81,
        $3b8da494b8e92f36$export$8bef70def9fcccef,
        $3b8da494b8e92f36$export$8f026b620b6b36d2,
        $3b8da494b8e92f36$export$89d3022d89ef3649,
        $3b8da494b8e92f36$export$c7eeffff290e6124,
        $3b8da494b8e92f36$export$87c3ff288d974d02,
        $3b8da494b8e92f36$export$5c698c7bb50b493,
        $3b8da494b8e92f36$export$422809562a8398de,
        $3b8da494b8e92f36$export$a48481dfef95f4a2,
        $3b8da494b8e92f36$export$d68e05a23c1f8359,
        $3b8da494b8e92f36$export$95d386c017712592,
        $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
        $3b8da494b8e92f36$export$d988060319005ccc,
        $3b8da494b8e92f36$export$bb5ce9eb5b74ac1
    ],
    3692461612: [
        $3b8da494b8e92f36$export$18fc149087e3c79f,
        $3b8da494b8e92f36$export$9f8310d680636df4,
        $3b8da494b8e92f36$export$2d97768d0015dccc,
        $3b8da494b8e92f36$export$b40b280750874c4,
        $3b8da494b8e92f36$export$421fb9d9a3f56509,
        $3b8da494b8e92f36$export$2ee49241e76b8d88
    ],
    723233188: [
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f,
        $3b8da494b8e92f36$export$45f4c4bef325c6de,
        $3b8da494b8e92f36$export$212932c39cad14c1,
        $3b8da494b8e92f36$export$a7c9a308bd61791e,
        $3b8da494b8e92f36$export$9462ca86e16364d3,
        $3b8da494b8e92f36$export$2ef492eaafc1544a,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$fe015439a6fa96b6,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$cc878395e6134df2,
        $3b8da494b8e92f36$export$f03ac9a18a5a000,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$db3cb7c28fcdcb12
    ],
    2473145415: [
        $3b8da494b8e92f36$export$3787e1faec59f84d
    ],
    1597423693: [
        $3b8da494b8e92f36$export$34a05c9e12c53c23
    ],
    2513912981: [
        $3b8da494b8e92f36$export$a633a7857c4afb8b,
        $3b8da494b8e92f36$export$8bcad0fd81ccef4e,
        $3b8da494b8e92f36$export$7c3b7ecc8dd17171,
        $3b8da494b8e92f36$export$32b9b3ebd4722148,
        $3b8da494b8e92f36$export$60c94e2d2eb3ae2d,
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d,
        $3b8da494b8e92f36$export$14920f38b00f3073,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$4bb861b4bba551ce,
        $3b8da494b8e92f36$export$7a8fab203344ee59,
        $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b,
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a,
        $3b8da494b8e92f36$export$e7d69479b3ed50b5
    ],
    2247615214: [
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$fe015439a6fa96b6,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$cc878395e6134df2,
        $3b8da494b8e92f36$export$f03ac9a18a5a000,
        $3b8da494b8e92f36$export$e537328a93948147
    ],
    1260650574: [
        $3b8da494b8e92f36$export$9462ca86e16364d3
    ],
    230924584: [
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a
    ],
    901063453: [
        $3b8da494b8e92f36$export$cf616a1a67553ce5,
        $3b8da494b8e92f36$export$2ecfbeca9fa8edbd,
        $3b8da494b8e92f36$export$be55db5658261c24,
        $3b8da494b8e92f36$export$e759ffb34c88cdbb,
        $3b8da494b8e92f36$export$a15ad7bc84af942e
    ],
    4282788508: [
        $3b8da494b8e92f36$export$fd5f089562b081f9
    ],
    1628702193: [
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e,
        $3b8da494b8e92f36$export$3d378e730e40374,
        $3b8da494b8e92f36$export$b05d4b54ea7217ba,
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8ab37c04c221437e,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$d1d6e43b67173127,
        $3b8da494b8e92f36$export$e8d5f91a47737ca2,
        $3b8da494b8e92f36$export$fe64d2939a7bcd9f,
        $3b8da494b8e92f36$export$b09c679f1085725a,
        $3b8da494b8e92f36$export$c81d279acf1b12b4,
        $3b8da494b8e92f36$export$599b343cb1d64b49,
        $3b8da494b8e92f36$export$60411d6f391d4743
    ],
    3736923433: [
        $3b8da494b8e92f36$export$b09c679f1085725a,
        $3b8da494b8e92f36$export$c81d279acf1b12b4,
        $3b8da494b8e92f36$export$599b343cb1d64b49
    ],
    2347495698: [
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8ab37c04c221437e,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$d1d6e43b67173127,
        $3b8da494b8e92f36$export$e8d5f91a47737ca2
    ],
    3698973494: [
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e,
        $3b8da494b8e92f36$export$3d378e730e40374
    ],
    2736907675: [
        $3b8da494b8e92f36$export$a340b94c3a9627f5
    ],
    4182860854: [
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d,
        $3b8da494b8e92f36$export$14920f38b00f3073,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$4bb861b4bba551ce,
        $3b8da494b8e92f36$export$7a8fab203344ee59
    ],
    574549367: [
        $3b8da494b8e92f36$export$e5527fc80680ccac,
        $3b8da494b8e92f36$export$d0a6287d5fe2b0d0
    ],
    59481748: [
        $3b8da494b8e92f36$export$64fbfc27b4cec02a,
        $3b8da494b8e92f36$export$843f1ace19c7b757,
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252,
        $3b8da494b8e92f36$export$88babb7bc763dabe
    ],
    3749851601: [
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252
    ],
    3331915920: [
        $3b8da494b8e92f36$export$64fbfc27b4cec02a
    ],
    1383045692: [
        $3b8da494b8e92f36$export$9bf9b7d525eb98c7
    ],
    2485617015: [
        $3b8da494b8e92f36$export$5478cb2985eabb5a
    ],
    2574617495: [
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e
    ],
    3419103109: [
        $3b8da494b8e92f36$export$4f9b13f55d01f662,
        $3b8da494b8e92f36$export$7bec46e80091ced6
    ],
    2506170314: [
        $3b8da494b8e92f36$export$aba424e86850f717,
        $3b8da494b8e92f36$export$2a2b17b32d1a9938,
        $3b8da494b8e92f36$export$f1de0c39f08c8646,
        $3b8da494b8e92f36$export$36783435db2b01a1,
        $3b8da494b8e92f36$export$d414ecd4014891b0
    ],
    2601014836: [
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f,
        $3b8da494b8e92f36$export$ec4770aab56c805f,
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$569b2f842286694a,
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f,
        $3b8da494b8e92f36$export$7952e91536a239e7,
        $3b8da494b8e92f36$export$cddab537799fe2fd,
        $3b8da494b8e92f36$export$922fa769a539de57,
        $3b8da494b8e92f36$export$85f2457f407ffd38,
        $3b8da494b8e92f36$export$c71362c4ed185b32,
        $3b8da494b8e92f36$export$3a90cd7486e7bfc7,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43,
        $3b8da494b8e92f36$export$6c79cacc663fc254
    ],
    339256511: [
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$7bcfd353a35a91d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8
    ],
    2777663545: [
        $3b8da494b8e92f36$export$a633a7857c4afb8b,
        $3b8da494b8e92f36$export$8bcad0fd81ccef4e,
        $3b8da494b8e92f36$export$7c3b7ecc8dd17171,
        $3b8da494b8e92f36$export$32b9b3ebd4722148
    ],
    477187591: [
        $3b8da494b8e92f36$export$f03ac9a18a5a000
    ],
    4238390223: [
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167
    ],
    178912537: [
        $3b8da494b8e92f36$export$e759ffb34c88cdbb
    ],
    1425443689: [
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f,
        $3b8da494b8e92f36$export$45f4c4bef325c6de
    ],
    3888040117: [
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$57379c20a5f35b14,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09,
        $3b8da494b8e92f36$export$f43ad39311bcb56,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$8e15250779a21ef,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c,
        $3b8da494b8e92f36$export$573337cb0f58bf7b,
        $3b8da494b8e92f36$export$4690a2f5205975d8,
        $3b8da494b8e92f36$export$d4f0edab93018f7f,
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1,
        $3b8da494b8e92f36$export$5591fe75469fbc36,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$d912e9b49c740c82,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$df5d90a458391b35,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$7f972ab55f8adda0,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$f765133cc69cf269,
        $3b8da494b8e92f36$export$53f51e3ca061719d,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$40058285857aae13,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$540eb1154ef9932a,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$22f423f0e05cb34b,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$1c2f4ad96fea6d36,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$14c6ae98e9d52fcb,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$cc78bfb1fd84dc0c,
        $3b8da494b8e92f36$export$ecd13d53d7a4573e,
        $3b8da494b8e92f36$export$91748340fd72a888,
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$d14ef3fe75da3f4,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6,
        $3b8da494b8e92f36$export$22d84e75fa702951
    ],
    759155922: [
        $3b8da494b8e92f36$export$2a79ce8e6dde1605
    ],
    2559016684: [
        $3b8da494b8e92f36$export$2c91bae7185bb7c5
    ],
    3967405729: [
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$b58a07450f76f5f4
    ],
    2945172077: [
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$d14ef3fe75da3f4,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6
    ],
    4208778838: [
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$d912e9b49c740c82,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$df5d90a458391b35,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$7f972ab55f8adda0,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$f765133cc69cf269,
        $3b8da494b8e92f36$export$53f51e3ca061719d,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$40058285857aae13,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$540eb1154ef9932a,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$22f423f0e05cb34b,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$1c2f4ad96fea6d36,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$14c6ae98e9d52fcb,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$cc78bfb1fd84dc0c,
        $3b8da494b8e92f36$export$ecd13d53d7a4573e
    ],
    3521284610: [
        $3b8da494b8e92f36$export$825f7cab9140cf42,
        $3b8da494b8e92f36$export$6dac613d32d3427f
    ],
    3939117080: [
        $3b8da494b8e92f36$export$5c698c7bb50b493,
        $3b8da494b8e92f36$export$422809562a8398de,
        $3b8da494b8e92f36$export$a48481dfef95f4a2,
        $3b8da494b8e92f36$export$d68e05a23c1f8359,
        $3b8da494b8e92f36$export$95d386c017712592,
        $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
        $3b8da494b8e92f36$export$d988060319005ccc
    ],
    1307041759: [
        $3b8da494b8e92f36$export$d68e05a23c1f8359
    ],
    1865459582: [
        $3b8da494b8e92f36$export$90569318bbf3a5cb,
        $3b8da494b8e92f36$export$3fd59b6be292fb81,
        $3b8da494b8e92f36$export$8bef70def9fcccef,
        $3b8da494b8e92f36$export$8f026b620b6b36d2,
        $3b8da494b8e92f36$export$89d3022d89ef3649,
        $3b8da494b8e92f36$export$c7eeffff290e6124
    ],
    826625072: [
        $3b8da494b8e92f36$export$96504c3b59e8a728,
        $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
        $3b8da494b8e92f36$export$a712aed3e137585e,
        $3b8da494b8e92f36$export$c331bec3b085e9a1,
        $3b8da494b8e92f36$export$2bafde249aab99b4,
        $3b8da494b8e92f36$export$8d69d79340327b03,
        $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
        $3b8da494b8e92f36$export$9cb68f339a367600,
        $3b8da494b8e92f36$export$51e6468498cab028,
        $3b8da494b8e92f36$export$20528f2adfe8dc9c,
        $3b8da494b8e92f36$export$9572797f2851b0,
        $3b8da494b8e92f36$export$b933598a67b23044,
        $3b8da494b8e92f36$export$976ca854e309f825,
        $3b8da494b8e92f36$export$1fe9178d23052979,
        $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
        $3b8da494b8e92f36$export$94d1e1fe7b940759,
        $3b8da494b8e92f36$export$2b794d8b645d7087,
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c,
        $3b8da494b8e92f36$export$4a59ec454710396a
    ],
    1204542856: [
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c
    ],
    1638771189: [
        $3b8da494b8e92f36$export$976ca854e309f825
    ],
    2551354335: [
        $3b8da494b8e92f36$export$cff3fa05b2018b59,
        $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
        $3b8da494b8e92f36$export$d35785e0f77dbe69,
        $3b8da494b8e92f36$export$b1832f175144bc77
    ],
    693640335: [
        $3b8da494b8e92f36$export$813f9cf6a2209fec,
        $3b8da494b8e92f36$export$dfec9be971c6e8a5,
        $3b8da494b8e92f36$export$bc9bd707c4403985,
        $3b8da494b8e92f36$export$f650b9b610878411
    ],
    3451746338: [
        $3b8da494b8e92f36$export$96504c3b59e8a728,
        $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9
    ],
    3523091289: [
        $3b8da494b8e92f36$export$96504c3b59e8a728
    ],
    2914609552: [
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1
    ],
    1856042241: [
        $3b8da494b8e92f36$export$fe015439a6fa96b6
    ],
    1412071761: [
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$c3dee48e256db302
    ],
    710998568: [
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf
    ],
    2706606064: [
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$70a5078283e32f9
    ],
    3893378262: [
        $3b8da494b8e92f36$export$70869bbe5fdba7cc
    ],
    3544373492: [
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab
    ],
    3136571912: [
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6
    ],
    530289379: [
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a
    ],
    3689010777: [
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2
    ],
    3979015343: [
        $3b8da494b8e92f36$export$76257ab7fe716a7f
    ],
    699246055: [
        $3b8da494b8e92f36$export$922fa769a539de57,
        $3b8da494b8e92f36$export$85f2457f407ffd38
    ],
    2387106220: [
        $3b8da494b8e92f36$export$cf616a1a67553ce5,
        $3b8da494b8e92f36$export$2ecfbeca9fa8edbd
    ],
    2296667514: [
        $3b8da494b8e92f36$export$4690a2f5205975d8
    ],
    1635779807: [
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f
    ],
    2887950389: [
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d
    ],
    167062518: [
        $3b8da494b8e92f36$export$7be85d9a50dbe60c
    ],
    1260505505: [
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$569b2f842286694a,
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f,
        $3b8da494b8e92f36$export$7952e91536a239e7
    ],
    1950629157: [
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2
    ],
    3732776249: [
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f
    ],
    15328376: [
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd
    ],
    2510884976: [
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f
    ],
    2559216714: [
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22
    ],
    3293443760: [
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$8e15250779a21ef,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c
    ],
    3256556792: [
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a
    ],
    3849074793: [
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5
    ],
    1758889154: [
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$d912e9b49c740c82,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$df5d90a458391b35,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$7f972ab55f8adda0,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$f765133cc69cf269,
        $3b8da494b8e92f36$export$53f51e3ca061719d,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$40058285857aae13,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$540eb1154ef9932a,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$22f423f0e05cb34b,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$1c2f4ad96fea6d36,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$a86d393485a380dd,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$14c6ae98e9d52fcb,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a
    ],
    1623761950: [
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$c119463806d89254
    ],
    2590856083: [
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7
    ],
    2107101300: [
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191
    ],
    2853485674: [
        $3b8da494b8e92f36$export$1d58c6b4a0c04096
    ],
    807026263: [
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a
    ],
    2827207264: [
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$14c6ae98e9d52fcb,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f
    ],
    2143335405: [
        $3b8da494b8e92f36$export$fd69280ac5175edc
    ],
    1287392070: [
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$14c6ae98e9d52fcb,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc
    ],
    3907093117: [
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6
    ],
    3198132628: [
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac
    ],
    1482959167: [
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2
    ],
    1834744321: [
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693
    ],
    1339347760: [
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c
    ],
    2297155007: [
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5
    ],
    3009222698: [
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d
    ],
    263784265: [
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007
    ],
    2706460486: [
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$57379c20a5f35b14,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09
    ],
    3588315303: [
        $3b8da494b8e92f36$export$14c6ae98e9d52fcb
    ],
    3740093272: [
        $3b8da494b8e92f36$export$a0685d525ffdd769
    ],
    3027567501: [
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398
    ],
    964333572: [
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89
    ],
    682877961: [
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9
    ],
    1179482911: [
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0
    ],
    1004757350: [
        $3b8da494b8e92f36$export$ee7aa2a71993541a
    ],
    214636428: [
        $3b8da494b8e92f36$export$1c90015ebcc206f4
    ],
    1252848954: [
        $3b8da494b8e92f36$export$57379c20a5f35b14
    ],
    3657597509: [
        $3b8da494b8e92f36$export$512d0c7c106ecc18
    ],
    2254336722: [
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928
    ],
    1028945134: [
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4
    ],
    1967976161: [
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b
    ],
    2461110595: [
        $3b8da494b8e92f36$export$d119e59d83beec72
    ],
    1136057603: [
        $3b8da494b8e92f36$export$3051e38f53a4ea7f
    ],
    3299480353: [
        $3b8da494b8e92f36$export$d912e9b49c740c82,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$df5d90a458391b35,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$7f972ab55f8adda0,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$f765133cc69cf269,
        $3b8da494b8e92f36$export$53f51e3ca061719d,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$40058285857aae13,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$540eb1154ef9932a,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$22f423f0e05cb34b,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$1c2f4ad96fea6d36,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1
    ],
    843113511: [
        $3b8da494b8e92f36$export$1c2f4ad96fea6d36
    ],
    2063403501: [
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21
    ],
    1945004755: [
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf
    ],
    3040386961: [
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098
    ],
    3205830791: [
        $3b8da494b8e92f36$export$78b19c4a252f3d7b
    ],
    395920057: [
        $3b8da494b8e92f36$export$22f423f0e05cb34b
    ],
    1658829314: [
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5
    ],
    2058353004: [
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475
    ],
    4278956645: [
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae
    ],
    3132237377: [
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08
    ],
    987401354: [
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608
    ],
    707683696: [
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88
    ],
    2223149337: [
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d
    ],
    3508470533: [
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e
    ],
    1073191201: [
        $3b8da494b8e92f36$export$540eb1154ef9932a
    ],
    3171933400: [
        $3b8da494b8e92f36$export$40058285857aae13
    ],
    1529196076: [
        $3b8da494b8e92f36$export$f765133cc69cf269,
        $3b8da494b8e92f36$export$53f51e3ca061719d
    ],
    2391406946: [
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$7f972ab55f8adda0
    ],
    3304561284: [
        $3b8da494b8e92f36$export$df5d90a458391b35
    ],
    753842376: [
        $3b8da494b8e92f36$export$d912e9b49c740c82
    ],
    1062813311: [
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3
    ]
};
$3b8da494b8e92f36$export$1ae3922015fd7522[2] = {
    3630933823: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    618182010: [
        [
            "OfPerson",
            $3b8da494b8e92f36$export$ffa0fdddece68333,
            7,
            true
        ],
        [
            "OfOrganization",
            $3b8da494b8e92f36$export$484015ec0cfcf638,
            4,
            true
        ]
    ],
    411424972: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    130549933: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "ApprovedObjects",
            $3b8da494b8e92f36$export$c7eeffff290e6124,
            5,
            true
        ],
        [
            "ApprovedResources",
            $3b8da494b8e92f36$export$13de02c11c361011,
            3,
            true
        ],
        [
            "IsRelatedWith",
            $3b8da494b8e92f36$export$cea9d94742f0d4d6,
            3,
            true
        ],
        [
            "Relates",
            $3b8da494b8e92f36$export$cea9d94742f0d4d6,
            2,
            true
        ]
    ],
    1959218052: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PropertiesForConstraint",
            $3b8da494b8e92f36$export$acffd400493c189c,
            2,
            true
        ]
    ],
    1466758467: [
        [
            "HasCoordinateOperation",
            $3b8da494b8e92f36$export$ecb047565e884e65,
            0,
            true
        ]
    ],
    602808272: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    3200245327: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ]
    ],
    2242383968: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ]
    ],
    1040185647: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ]
    ],
    3548104201: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ]
    ],
    852622518: [
        [
            "PartOfW",
            $3b8da494b8e92f36$export$d112ffc231f4837b,
            9,
            true
        ],
        [
            "PartOfV",
            $3b8da494b8e92f36$export$d112ffc231f4837b,
            8,
            true
        ],
        [
            "PartOfU",
            $3b8da494b8e92f36$export$d112ffc231f4837b,
            7,
            true
        ],
        [
            "HasIntersections",
            $3b8da494b8e92f36$export$39a9378576bb57be,
            0,
            true
        ]
    ],
    2655187982: [
        [
            "LibraryInfoForObjects",
            $3b8da494b8e92f36$export$3fd59b6be292fb81,
            5,
            true
        ],
        [
            "HasLibraryReferences",
            $3b8da494b8e92f36$export$96fe74a17c6cc802,
            5,
            true
        ]
    ],
    3452421091: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ],
        [
            "LibraryRefForObjects",
            $3b8da494b8e92f36$export$3fd59b6be292fb81,
            5,
            true
        ]
    ],
    760658860: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ]
    ],
    248100487: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialLayerSet",
            $3b8da494b8e92f36$export$271c16e7766bc70a,
            0,
            false
        ]
    ],
    3303938423: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ]
    ],
    1847252529: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialLayerSet",
            $3b8da494b8e92f36$export$271c16e7766bc70a,
            0,
            false
        ]
    ],
    2235152071: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialProfileSet",
            $3b8da494b8e92f36$export$ce700270dbd3f574,
            2,
            false
        ]
    ],
    164193824: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ]
    ],
    552965576: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialProfileSet",
            $3b8da494b8e92f36$export$ce700270dbd3f574,
            2,
            false
        ]
    ],
    1507914824: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ]
    ],
    3368373690: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PropertiesForConstraint",
            $3b8da494b8e92f36$export$acffd400493c189c,
            2,
            true
        ]
    ],
    3701648758: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$34302876ddf37791,
            0,
            true
        ]
    ],
    2251480897: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PropertiesForConstraint",
            $3b8da494b8e92f36$export$acffd400493c189c,
            2,
            true
        ]
    ],
    4251960020: [
        [
            "IsRelatedBy",
            $3b8da494b8e92f36$export$f7ea933b5cc28fe9,
            3,
            true
        ],
        [
            "Relates",
            $3b8da494b8e92f36$export$f7ea933b5cc28fe9,
            2,
            true
        ],
        [
            "Engages",
            $3b8da494b8e92f36$export$c819a2c53c7debd3,
            1,
            true
        ]
    ],
    2077209135: [
        [
            "EngagedIn",
            $3b8da494b8e92f36$export$c819a2c53c7debd3,
            0,
            true
        ]
    ],
    2483315170: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2226359599: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    3355820592: [
        [
            "OfPerson",
            $3b8da494b8e92f36$export$ffa0fdddece68333,
            7,
            true
        ],
        [
            "OfOrganization",
            $3b8da494b8e92f36$export$484015ec0cfcf638,
            4,
            true
        ]
    ],
    3958567839: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    3843373140: [
        [
            "HasCoordinateOperation",
            $3b8da494b8e92f36$export$ecb047565e884e65,
            0,
            true
        ]
    ],
    986844984: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    3710013099: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2044713172: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2093928680: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    931644368: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    3252649465: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2405470396: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    825690147: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    1076942058: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ]
    ],
    3377609919: [
        [
            "RepresentationsInContext",
            $3b8da494b8e92f36$export$2ddea3c8ef71f411,
            0,
            true
        ]
    ],
    3008791417: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1660063152: [
        [
            "HasShapeAspects",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            4,
            true
        ],
        [
            "MapUsage",
            $3b8da494b8e92f36$export$f6578324c1ae7b2d,
            0,
            true
        ]
    ],
    3982875396: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ],
        [
            "OfShapeAspect",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            0,
            true
        ]
    ],
    4240577450: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ],
        [
            "OfShapeAspect",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            0,
            true
        ]
    ],
    2830218821: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ]
    ],
    3958052878: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3049322572: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ]
    ],
    626085974: [
        [
            "IsMappedBy",
            $3b8da494b8e92f36$export$f9f8eae306150574,
            0,
            true
        ],
        [
            "UsedInStyles",
            $3b8da494b8e92f36$export$a208be2840956e7f,
            0,
            true
        ]
    ],
    912023232: [
        [
            "OfPerson",
            $3b8da494b8e92f36$export$ffa0fdddece68333,
            7,
            true
        ],
        [
            "OfOrganization",
            $3b8da494b8e92f36$export$484015ec0cfcf638,
            4,
            true
        ]
    ],
    3101149627: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    1377556343: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1735638870: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ],
        [
            "OfShapeAspect",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            0,
            true
        ]
    ],
    2799835756: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1907098498: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3798115385: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1310608509: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2705031697: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    616511568: [
        [
            "IsMappedBy",
            $3b8da494b8e92f36$export$f9f8eae306150574,
            0,
            true
        ],
        [
            "UsedInStyles",
            $3b8da494b8e92f36$export$a208be2840956e7f,
            0,
            true
        ]
    ],
    3150382593: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    747523909: [
        [
            "ClassificationForObjects",
            $3b8da494b8e92f36$export$89d3022d89ef3649,
            5,
            true
        ],
        [
            "HasReferences",
            $3b8da494b8e92f36$export$72ed75e7fb4d773c,
            3,
            true
        ]
    ],
    647927063: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ],
        [
            "ClassificationRefForObjects",
            $3b8da494b8e92f36$export$89d3022d89ef3649,
            5,
            true
        ],
        [
            "HasReferences",
            $3b8da494b8e92f36$export$72ed75e7fb4d773c,
            3,
            true
        ]
    ],
    1485152156: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    370225590: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3050246964: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2889183280: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2713554722: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    3632507154: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1154170062: [
        [
            "DocumentInfoForObjects",
            $3b8da494b8e92f36$export$8bef70def9fcccef,
            5,
            true
        ],
        [
            "HasDocumentReferences",
            $3b8da494b8e92f36$export$5dc53366ca618592,
            4,
            true
        ],
        [
            "IsPointedTo",
            $3b8da494b8e92f36$export$623f6287e006c7a4,
            3,
            true
        ],
        [
            "IsPointer",
            $3b8da494b8e92f36$export$623f6287e006c7a4,
            2,
            true
        ]
    ],
    3732053477: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ],
        [
            "DocumentRefForObjects",
            $3b8da494b8e92f36$export$8bef70def9fcccef,
            5,
            true
        ]
    ],
    3900360178: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    476780140: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    297599258: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2556980723: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasTextureMaps",
            $3b8da494b8e92f36$export$925b578047892bce,
            2,
            true
        ]
    ],
    1809719519: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    803316827: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3008276851: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasTextureMaps",
            $3b8da494b8e92f36$export$925b578047892bce,
            2,
            true
        ]
    ],
    3448662350: [
        [
            "RepresentationsInContext",
            $3b8da494b8e92f36$export$2ddea3c8ef71f411,
            0,
            true
        ],
        [
            "HasSubContexts",
            $3b8da494b8e92f36$export$c78a940a5c4e916a,
            6,
            true
        ],
        [
            "HasCoordinateOperation",
            $3b8da494b8e92f36$export$ecb047565e884e65,
            0,
            true
        ]
    ],
    2453401579: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4142052618: [
        [
            "RepresentationsInContext",
            $3b8da494b8e92f36$export$2ddea3c8ef71f411,
            0,
            true
        ],
        [
            "HasSubContexts",
            $3b8da494b8e92f36$export$c78a940a5c4e916a,
            6,
            true
        ],
        [
            "HasCoordinateOperation",
            $3b8da494b8e92f36$export$ecb047565e884e65,
            0,
            true
        ]
    ],
    3590301190: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    178086475: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$34302876ddf37791,
            0,
            true
        ]
    ],
    812098782: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3905492369: [
        [
            "IsMappedBy",
            $3b8da494b8e92f36$export$f9f8eae306150574,
            0,
            true
        ],
        [
            "UsedInStyles",
            $3b8da494b8e92f36$export$a208be2840956e7f,
            0,
            true
        ]
    ],
    3741457305: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    1402838566: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    125510826: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2604431987: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4266656042: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1520743889: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3422422726: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2624227202: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$34302876ddf37791,
            0,
            true
        ]
    ],
    1008929658: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2347385850: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1838606355: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "HasRepresentation",
            $3b8da494b8e92f36$export$95d5078ec273e20a,
            3,
            true
        ],
        [
            "IsRelatedWith",
            $3b8da494b8e92f36$export$e2f0b7f5e626526f,
            3,
            true
        ],
        [
            "RelatesTo",
            $3b8da494b8e92f36$export$e2f0b7f5e626526f,
            2,
            true
        ]
    ],
    3708119e3: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialConstituentSet",
            $3b8da494b8e92f36$export$b1bef060ce5931d8,
            2,
            false
        ]
    ],
    2852063980: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ]
    ],
    1303795690: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ]
    ],
    3079605661: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ]
    ],
    3404854881: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ]
    ],
    3265635763: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2998442950: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    219451334: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ]
    ],
    2665983363: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1029017970: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2529465313: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2519244187: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3021840470: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    597895409: [
        [
            "IsMappedBy",
            $3b8da494b8e92f36$export$f9f8eae306150574,
            0,
            true
        ],
        [
            "UsedInStyles",
            $3b8da494b8e92f36$export$a208be2840956e7f,
            0,
            true
        ]
    ],
    2004835150: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1663979128: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2067069095: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4022376103: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1423911732: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2924175390: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2775532180: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3778827333: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    673634403: [
        [
            "ShapeOfProduct",
            $3b8da494b8e92f36$export$91748340fd72a888,
            6,
            true
        ],
        [
            "HasShapeAspects",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            4,
            true
        ]
    ],
    2802850158: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2598011224: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    1680319473: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ]
    ],
    3357820518: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    1482703590: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ]
    ],
    2090586900: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    3615266464: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    3413951693: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    1580146022: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2778083089: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2042790032: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    4165799628: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    1509187699: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4124623270: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3692461612: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    723233188: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2233826070: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2513912981: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2247615214: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1260650574: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1096409881: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    230924584: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3071757647: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    901063453: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4282788508: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3124975700: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2715220739: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1628702193: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3736923433: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2347495698: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3698973494: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    427810014: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1417489154: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2759199220: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1299126871: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2543172580: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    3406155212: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasTextureMaps",
            $3b8da494b8e92f36$export$925b578047892bce,
            2,
            true
        ]
    ],
    669184980: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3207858831: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    4261334040: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3125803723: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2740243338: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2736907675: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4182860854: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2581212453: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2713105998: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2898889636: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1123145078: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    574549367: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1675464909: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2059837836: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    59481748: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3749851601: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3486308946: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3331915920: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1416205885: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1383045692: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2205249479: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2542286263: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    2485617015: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "UsingCurves",
            $3b8da494b8e92f36$export$7952e91536a239e7,
            0,
            true
        ]
    ],
    2574617495: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    3419103109: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            4,
            true
        ]
    ],
    1815067380: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    2506170314: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2147822146: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2601014836: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2827736869: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2629017746: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    32440307: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    526551008: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1472233963: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1883228015: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    339256511: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2777663545: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2835456948: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    4024345920: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    477187591: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2804161546: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2047409740: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    374418227: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    315944413: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2652556860: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4238390223: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1268542332: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4095422895: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    987898635: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1484403080: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    178912537: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "ToFaceSet",
            $3b8da494b8e92f36$export$cf616a1a67553ce5,
            2,
            true
        ]
    ],
    2294589976: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "ToFaceSet",
            $3b8da494b8e92f36$export$cf616a1a67553ce5,
            2,
            true
        ]
    ],
    572779678: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    428585644: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1281925730: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1425443689: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3888040117: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ]
    ],
    3388369263: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3505215534: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1682466193: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    603570806: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    220341763: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3967405729: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    569719735: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2945172077: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    4208778838: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    103090709: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            4,
            true
        ]
    ],
    653396225: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            4,
            true
        ]
    ],
    871118103: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    4166981789: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    2752243245: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    941946838: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    1451395588: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    492091185: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Defines",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            5,
            true
        ]
    ],
    3650150729: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    110355661: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    3521284610: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PartOfComplexTemplate",
            $3b8da494b8e92f36$export$825f7cab9140cf42,
            6,
            true
        ],
        [
            "PartOfPsetTemplate",
            $3b8da494b8e92f36$export$67177aa5e10d7edd,
            6,
            true
        ]
    ],
    3219374653: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2770003689: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2798486643: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3454111270: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3765753017: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    3523091289: [
        [
            "InnerBoundaries",
            $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
            9,
            true
        ]
    ],
    1521410863: [
        [
            "InnerBoundaries",
            $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
            9,
            true
        ],
        [
            "Corresponds",
            $3b8da494b8e92f36$export$96504c3b59e8a728,
            10,
            true
        ]
    ],
    816062949: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "UsingCurves",
            $3b8da494b8e92f36$export$7952e91536a239e7,
            0,
            true
        ]
    ],
    2914609552: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1856042241: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3243963512: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4158566097: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3626867408: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3663146110: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PartOfComplexTemplate",
            $3b8da494b8e92f36$export$825f7cab9140cf42,
            6,
            true
        ],
        [
            "PartOfPsetTemplate",
            $3b8da494b8e92f36$export$67177aa5e10d7edd,
            6,
            true
        ]
    ],
    1412071761: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ]
    ],
    710998568: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2706606064: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ]
    ],
    3893378262: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    463610769: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ]
    ],
    2481509218: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    451544542: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4015995234: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3544373492: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    3136571912: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ]
    ],
    530289379: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    3689010777: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    3979015343: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    2218152070: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    603775116: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    4095615324: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    699246055: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2028607225: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2809605785: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4124788165: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1580310250: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3473067441: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    3206491090: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2387106220: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasColours",
            $3b8da494b8e92f36$export$5c5bfbea1f9750f0,
            0,
            true
        ],
        [
            "HasTextures",
            $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
            1,
            true
        ]
    ],
    1935646853: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2097647324: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2916149573: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasColours",
            $3b8da494b8e92f36$export$5c5bfbea1f9750f0,
            0,
            true
        ],
        [
            "HasTextures",
            $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
            1,
            true
        ]
    ],
    336235671: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    512836454: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    2296667514: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsActingUpon",
            $3b8da494b8e92f36$export$d988060319005ccc,
            6,
            true
        ]
    ],
    1635779807: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2603310189: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1674181508: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2887950389: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    167062518: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1334484129: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3649129432: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1260505505: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4031249490: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ]
    ],
    1950629157: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3124254112: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ]
    ],
    2197970202: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2937912522: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    3893394355: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    300633059: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3875453745: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PartOfComplexTemplate",
            $3b8da494b8e92f36$export$825f7cab9140cf42,
            6,
            true
        ],
        [
            "PartOfPsetTemplate",
            $3b8da494b8e92f36$export$67177aa5e10d7edd,
            6,
            true
        ]
    ],
    3732776249: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    15328376: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2510884976: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2185764099: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    4105962743: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1525564444: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    2559216714: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    3293443760: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3895139033: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1419761937: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1916426348: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3295246426: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1457835157: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1213902940: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3256556792: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3849074793: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2963535650: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    1714330368: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    2323601079: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1758889154: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    4123344466: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2397081782: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1623761950: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2590856083: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1704287377: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2107101300: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    132023988: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3174744832: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3390157468: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4148101412: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2853485674: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ]
    ],
    807026263: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3737207727: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    647756555: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2489546625: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2827207264: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2143335405: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "ProjectsElements",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            5,
            false
        ]
    ],
    1287392070: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ]
    ],
    3907093117: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3198132628: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3815607619: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1482959167: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1834744321: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1339347760: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2297155007: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3009222698: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1893162501: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    263784265: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    1509553395: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3493046030: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3009204131: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2706460486: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ]
    ],
    1251058090: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1806887404: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2571569899: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3946677679: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3113134337: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2391368822: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ]
    ],
    4288270099: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3827777499: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1051575348: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1161773419: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    377706215: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2108223431: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1114901282: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3181161470: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    977012517: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4143007308: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsActingUpon",
            $3b8da494b8e92f36$export$d988060319005ccc,
            6,
            true
        ]
    ],
    3588315303: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ],
        [
            "HasFillings",
            $3b8da494b8e92f36$export$51e6468498cab028,
            4,
            true
        ]
    ],
    3079942009: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ],
        [
            "HasFillings",
            $3b8da494b8e92f36$export$51e6468498cab028,
            4,
            true
        ]
    ],
    2837617999: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2382730787: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3566463478: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    3327091369: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1158309216: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    804291784: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4231323485: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4017108033: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2839578677: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasColours",
            $3b8da494b8e92f36$export$5c5bfbea1f9750f0,
            0,
            true
        ],
        [
            "HasTextures",
            $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
            1,
            true
        ]
    ],
    3724593414: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3740093272: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainedIn",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            4,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            4,
            true
        ]
    ],
    2744685151: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2904328755: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3651124850: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "ProjectsElements",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            5,
            false
        ]
    ],
    1842657554: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2250791053: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2893384427: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2324767716: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1469900589: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    683857671: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3027567501: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    964333572: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2320036040: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2310774935: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2781568857: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1768891740: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2157484638: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4074543187: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4097777520: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ]
    ],
    2533589738: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1072016465: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3856911033: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$20528f2adfe8dc9c,
            4,
            true
        ],
        [
            "BoundedBy",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            4,
            true
        ]
    ],
    1305183839: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3812236995: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3112655638: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1039846685: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    338393293: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    682877961: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1179482911: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    1004757350: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    4243806635: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    214636428: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    2445595289: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    2757150158: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1807405624: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1252848954: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "SourceOfResultGroup",
            $3b8da494b8e92f36$export$88c23504cdda26e,
            6,
            true
        ],
        [
            "LoadGroupFor",
            $3b8da494b8e92f36$export$1a86b8c219c2e539,
            7,
            true
        ]
    ],
    2082059205: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    734778138: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    1235345126: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    2986769608: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ResultGroupFor",
            $3b8da494b8e92f36$export$1a86b8c219c2e539,
            8,
            true
        ]
    ],
    3657597509: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1975003073: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    148013059: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    3101698114: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2315554128: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2254336722: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ]
    ],
    413509423: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    5716631: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3824725483: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2347447852: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3081323446: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2415094496: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1692211062: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1620046519: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3593883385: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1600972822: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1911125066: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    728799441: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2391383451: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3313531582: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2769231204: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    926996030: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ]
    ],
    1898987631: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1133259667: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4009809668: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4088093105: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1028945134: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    4218914973: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3342526732: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1033361043: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ]
    ],
    3821786052: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1411407467: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3352864051: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1871374353: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3460190687: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ]
    ],
    1532957894: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1967976161: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2461110595: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    819618141: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    231477066: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1136057603: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3299480353: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2979338954: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    39481116: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1095909175: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    1909888760: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1177604601: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ]
    ],
    2188180465: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    395041908: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3293546465: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2674252688: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1285652485: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2951183804: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3296154744: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2611217952: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1677625105: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2301859152: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    843113511: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    905975707: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    400855858: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3850581409: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2816379211: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3898045240: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1060000209: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    488727124: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    335055490: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2954562838: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1973544240: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "CoversSpaces",
            $3b8da494b8e92f36$export$20528f2adfe8dc9c,
            5,
            true
        ],
        [
            "CoversElements",
            $3b8da494b8e92f36$export$9572797f2851b0,
            5,
            true
        ]
    ],
    3495092785: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3961806047: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1335981549: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2635815018: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1599208980: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2063403501: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1945004755: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ]
    ],
    3040386961: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3041715199: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainedIn",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            4,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            4,
            true
        ]
    ],
    3205830791: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ]
    ],
    395920057: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3242481149: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    869906466: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3760055223: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2030761528: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    663422040: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2417008758: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3277789161: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1534661035: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1217240411: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    712377611: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1658829314: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2814081492: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3747195512: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    484807127: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1209101575: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "BoundedBy",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            4,
            true
        ]
    ],
    346874300: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1810631287: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4222183408: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2058353004: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4278956645: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4037862832: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2188021234: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3132237377: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    987401354: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    707683696: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2223149337: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3508470533: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    900683007: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3319311131: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2068733104: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4175244083: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2176052936: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    76236018: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    629592764: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1437502449: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1073191201: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    1911478936: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2474470126: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    144952367: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3694346114: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1687234759: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    310824031: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3612865200: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3171933400: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    1156407060: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    738039164: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    655969474: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    90941305: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2262370178: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3024970846: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3283111854: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    1232101972: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    979691226: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2572171363: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2016517767: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3053780830: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1783015770: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1329646415: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    1529196076: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3127900445: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3027962421: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3420628829: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1999602285: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1404847402: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    331165859: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    4252922144: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2515109513: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ]
    ],
    385403989: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "SourceOfResultGroup",
            $3b8da494b8e92f36$export$88c23504cdda26e,
            6,
            true
        ],
        [
            "LoadGroupFor",
            $3b8da494b8e92f36$export$1a86b8c219c2e539,
            7,
            true
        ]
    ],
    1621171031: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1162798199: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    812556717: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3825984169: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3026737570: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3179687236: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4292641817: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4207607924: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2391406946: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    4156078855: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    3512223829: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    4237592921: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3304561284: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    486154966: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2874132201: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1634111441: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    177149247: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2056796094: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3001207471: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    277319702: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    753842376: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    2906023776: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ]
    ],
    32344328: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2938176219: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    635142910: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3758799889: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1051757585: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4217484030: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3902619387: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    639361253: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3221913625: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3571504051: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2272882330: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    578613899: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4136498852: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3640358203: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4074379575: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1052013943: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    562808652: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ]
    ],
    1062813311: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    342316401: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3518393246: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1360408905: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1904799276: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    862014818: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3310460725: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    264262732: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    402227799: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1003880860: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3415622556: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    819412036: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1426591983: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    182646315: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    2295281155: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    4086658281: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    630975310: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    4288193352: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    3087945054: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    25142252: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ]
};
$3b8da494b8e92f36$export$cab133dc4b2240f9[2] = {
    3630933823: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActorRole(a[0], a[1], a[2]),
    618182010: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAddress(a[0], a[1], a[2]),
    639542469: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcApplication(a[0], a[1], a[2], a[3]),
    411424972: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAppliedValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    130549933: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcApproval(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4037036970: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryCondition(a[0]),
    1560379544: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryEdgeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3367102660: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryFaceCondition(a[0], a[1], a[2], a[3]),
    1387855156: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryNodeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2069777674: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryNodeConditionWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2859738748: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionGeometry(),
    2614616156: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionPointGeometry(a[0], a[1]),
    2732653382: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionSurfaceGeometry(a[0], a[1]),
    775493141: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionVolumeGeometry(a[0], a[1]),
    1959218052: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1785450214: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoordinateOperation(a[0], a[1]),
    1466758467: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoordinateReferenceSystem(a[0], a[1], a[2], a[3]),
    602808272: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCostValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1765591967: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDerivedUnit(a[0], a[1], a[2]),
    1045800335: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDerivedUnitElement(a[0], a[1]),
    2949456006: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDimensionalExponents(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    4294318154: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalInformation(),
    3200245327: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalReference(a[0], a[1], a[2]),
    2242383968: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternallyDefinedHatchStyle(a[0], a[1], a[2]),
    1040185647: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternallyDefinedSurfaceStyle(a[0], a[1], a[2]),
    3548104201: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternallyDefinedTextFont(a[0], a[1], a[2]),
    852622518: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGridAxis(a[0], a[1], a[2]),
    3020489413: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIrregularTimeSeriesValue(a[0], a[1]),
    2655187982: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLibraryInformation(a[0], a[1], a[2], a[3], a[4], a[5]),
    3452421091: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLibraryReference(a[0], a[1], a[2], a[3], a[4], a[5]),
    4162380809: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightDistributionData(a[0], a[1], a[2]),
    1566485204: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightIntensityDistribution(a[0], a[1]),
    3057273783: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMapConversion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1847130766: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialClassificationRelationship(a[0], a[1]),
    760658860: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialDefinition(),
    248100487: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialLayer(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3303938423: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialLayerSet(a[0], a[1], a[2]),
    1847252529: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialLayerWithOffsets(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2199411900: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialList(a[0]),
    2235152071: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfile(a[0], a[1], a[2], a[3], a[4], a[5]),
    164193824: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfileSet(a[0], a[1], a[2], a[3]),
    552965576: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfileWithOffsets(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1507914824: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialUsageDefinition(),
    2597039031: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMeasureWithUnit(a[0], a[1]),
    3368373690: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMetric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2706619895: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMonetaryUnit(a[0]),
    1918398963: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNamedUnit(a[0], a[1]),
    3701648758: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcObjectPlacement(),
    2251480897: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcObjective(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4251960020: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOrganization(a[0], a[1], a[2], a[3], a[4]),
    1207048766: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOwnerHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2077209135: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPerson(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    101040310: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPersonAndOrganization(a[0], a[1], a[2]),
    2483315170: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPhysicalQuantity(a[0], a[1]),
    2226359599: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPhysicalSimpleQuantity(a[0], a[1], a[2]),
    3355820592: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPostalAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    677532197: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationItem(),
    2022622350: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationLayerAssignment(a[0], a[1], a[2], a[3]),
    1304840413: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationLayerWithStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3119450353: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationStyle(a[0]),
    2417041796: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentationStyleAssignment(a[0]),
    2095639259: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProductRepresentation(a[0], a[1], a[2]),
    3958567839: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProfileDef(a[0], a[1]),
    3843373140: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProjectedCRS(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    986844984: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyAbstraction(),
    3710013099: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyEnumeration(a[0], a[1], a[2]),
    2044713172: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityArea(a[0], a[1], a[2], a[3], a[4]),
    2093928680: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityCount(a[0], a[1], a[2], a[3], a[4]),
    931644368: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityLength(a[0], a[1], a[2], a[3], a[4]),
    3252649465: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityTime(a[0], a[1], a[2], a[3], a[4]),
    2405470396: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityVolume(a[0], a[1], a[2], a[3], a[4]),
    825690147: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantityWeight(a[0], a[1], a[2], a[3], a[4]),
    3915482550: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRecurrencePattern(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2433181523: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReference(a[0], a[1], a[2], a[3], a[4]),
    1076942058: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRepresentation(a[0], a[1], a[2], a[3]),
    3377609919: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRepresentationContext(a[0], a[1]),
    3008791417: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRepresentationItem(),
    1660063152: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRepresentationMap(a[0], a[1]),
    2439245199: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResourceLevelRelationship(a[0], a[1]),
    2341007311: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRoot(a[0], a[1], a[2], a[3]),
    448429030: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSIUnit(a[0], a[1], a[2]),
    1054537805: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSchedulingTime(a[0], a[1], a[2]),
    867548509: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShapeAspect(a[0], a[1], a[2], a[3], a[4]),
    3982875396: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShapeModel(a[0], a[1], a[2], a[3]),
    4240577450: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShapeRepresentation(a[0], a[1], a[2], a[3]),
    2273995522: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralConnectionCondition(a[0]),
    2162789131: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoad(a[0]),
    3478079324: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadConfiguration(a[0], a[1], a[2]),
    609421318: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadOrResult(a[0]),
    2525727697: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadStatic(a[0]),
    3408363356: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadTemperature(a[0], a[1], a[2], a[3]),
    2830218821: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStyleModel(a[0], a[1], a[2], a[3]),
    3958052878: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStyledItem(a[0], a[1], a[2]),
    3049322572: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStyledRepresentation(a[0], a[1], a[2], a[3]),
    2934153892: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceReinforcementArea(a[0], a[1], a[2], a[3]),
    1300840506: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyle(a[0], a[1], a[2]),
    3303107099: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleLighting(a[0], a[1], a[2], a[3]),
    1607154358: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleRefraction(a[0], a[1]),
    846575682: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleShading(a[0], a[1]),
    1351298697: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleWithTextures(a[0]),
    626085974: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceTexture(a[0], a[1], a[2], a[3], a[4]),
    985171141: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTable(a[0], a[1], a[2]),
    2043862942: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTableColumn(a[0], a[1], a[2], a[3], a[4]),
    531007025: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTableRow(a[0], a[1]),
    1549132990: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTaskTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
    2771591690: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTaskTimeRecurring(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20]),
    912023232: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTelecomAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1447204868: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextStyle(a[0], a[1], a[2], a[3], a[4]),
    2636378356: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextStyleForDefinedFont(a[0], a[1]),
    1640371178: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextStyleTextModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    280115917: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureCoordinate(a[0]),
    1742049831: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureCoordinateGenerator(a[0], a[1], a[2]),
    2552916305: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureMap(a[0], a[1], a[2]),
    1210645708: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureVertex(a[0]),
    3611470254: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextureVertexList(a[0]),
    1199560280: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimePeriod(a[0], a[1]),
    3101149627: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    581633288: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeSeriesValue(a[0]),
    1377556343: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTopologicalRepresentationItem(),
    1735638870: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTopologyRepresentation(a[0], a[1], a[2], a[3]),
    180925521: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitAssignment(a[0]),
    2799835756: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVertex(),
    1907098498: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVertexPoint(a[0]),
    891718957: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVirtualGridIntersection(a[0], a[1]),
    1236880293: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkTime(a[0], a[1], a[2], a[3], a[4], a[5]),
    3869604511: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcApprovalRelationship(a[0], a[1], a[2], a[3]),
    3798115385: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcArbitraryClosedProfileDef(a[0], a[1], a[2]),
    1310608509: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcArbitraryOpenProfileDef(a[0], a[1], a[2]),
    2705031697: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcArbitraryProfileDefWithVoids(a[0], a[1], a[2], a[3]),
    616511568: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBlobTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3150382593: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCenterLineProfileDef(a[0], a[1], a[2], a[3]),
    747523909: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcClassification(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    647927063: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcClassificationReference(a[0], a[1], a[2], a[3], a[4], a[5]),
    3285139300: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColourRgbList(a[0]),
    3264961684: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColourSpecification(a[0]),
    1485152156: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompositeProfileDef(a[0], a[1], a[2], a[3]),
    370225590: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectedFaceSet(a[0]),
    1981873012: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionCurveGeometry(a[0], a[1]),
    45288368: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConnectionPointEccentricity(a[0], a[1], a[2], a[3], a[4]),
    3050246964: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcContextDependentUnit(a[0], a[1], a[2]),
    2889183280: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConversionBasedUnit(a[0], a[1], a[2], a[3]),
    2713554722: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConversionBasedUnitWithOffset(a[0], a[1], a[2], a[3], a[4]),
    539742890: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurrencyRelationship(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3800577675: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveStyle(a[0], a[1], a[2], a[3], a[4]),
    1105321065: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveStyleFont(a[0], a[1]),
    2367409068: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveStyleFontAndScaling(a[0], a[1], a[2]),
    3510044353: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveStyleFontPattern(a[0], a[1]),
    3632507154: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDerivedProfileDef(a[0], a[1], a[2], a[3], a[4]),
    1154170062: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDocumentInformation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
    770865208: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDocumentInformationRelationship(a[0], a[1], a[2], a[3], a[4]),
    3732053477: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDocumentReference(a[0], a[1], a[2], a[3], a[4]),
    3900360178: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEdge(a[0], a[1]),
    476780140: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEdgeCurve(a[0], a[1], a[2], a[3]),
    211053100: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEventTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    297599258: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExtendedProperties(a[0], a[1], a[2]),
    1437805879: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalReferenceRelationship(a[0], a[1], a[2], a[3]),
    2556980723: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFace(a[0]),
    1809719519: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFaceBound(a[0], a[1]),
    803316827: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFaceOuterBound(a[0], a[1]),
    3008276851: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFaceSurface(a[0], a[1], a[2]),
    4219587988: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFailureConnectionCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    738692330: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFillAreaStyle(a[0], a[1], a[2]),
    3448662350: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricRepresentationContext(a[0], a[1], a[2], a[3], a[4], a[5]),
    2453401579: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricRepresentationItem(),
    4142052618: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricRepresentationSubContext(a[0], a[1], a[2], a[3], a[4], a[5]),
    3590301190: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricSet(a[0]),
    178086475: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGridPlacement(a[0], a[1]),
    812098782: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHalfSpaceSolid(a[0], a[1]),
    3905492369: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcImageTexture(a[0], a[1], a[2], a[3], a[4], a[5]),
    3570813810: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedColourMap(a[0], a[1], a[2], a[3]),
    1437953363: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedTextureMap(a[0], a[1], a[2]),
    2133299955: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedTriangleTextureMap(a[0], a[1], a[2], a[3]),
    3741457305: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIrregularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1585845231: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLagTime(a[0], a[1], a[2], a[3], a[4]),
    1402838566: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSource(a[0], a[1], a[2], a[3]),
    125510826: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourceAmbient(a[0], a[1], a[2], a[3]),
    2604431987: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourceDirectional(a[0], a[1], a[2], a[3], a[4]),
    4266656042: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourceGoniometric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1520743889: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourcePositional(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3422422726: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightSourceSpot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    2624227202: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLocalPlacement(a[0], a[1]),
    1008929658: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLoop(),
    2347385850: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMappedItem(a[0], a[1]),
    1838606355: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterial(a[0], a[1], a[2]),
    3708119e3: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialConstituent(a[0], a[1], a[2], a[3], a[4]),
    2852063980: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialConstituentSet(a[0], a[1], a[2]),
    2022407955: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialDefinitionRepresentation(a[0], a[1], a[2], a[3]),
    1303795690: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialLayerSetUsage(a[0], a[1], a[2], a[3], a[4]),
    3079605661: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfileSetUsage(a[0], a[1], a[2]),
    3404854881: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProfileSetUsageTapering(a[0], a[1], a[2], a[3], a[4]),
    3265635763: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialProperties(a[0], a[1], a[2], a[3]),
    853536259: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMaterialRelationship(a[0], a[1], a[2], a[3], a[4]),
    2998442950: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMirroredProfileDef(a[0], a[1], a[2], a[3]),
    219451334: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcObjectDefinition(a[0], a[1], a[2], a[3]),
    2665983363: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOpenShell(a[0]),
    1411181986: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOrganizationRelationship(a[0], a[1], a[2], a[3]),
    1029017970: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOrientedEdge(a[0], a[1]),
    2529465313: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterizedProfileDef(a[0], a[1], a[2]),
    2519244187: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPath(a[0]),
    3021840470: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPhysicalComplexQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
    597895409: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPixelTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2004835150: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlacement(a[0]),
    1663979128: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlanarExtent(a[0], a[1]),
    2067069095: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPoint(),
    4022376103: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPointOnCurve(a[0], a[1]),
    1423911732: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPointOnSurface(a[0], a[1], a[2]),
    2924175390: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPolyLoop(a[0]),
    2775532180: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPolygonalBoundedHalfSpace(a[0], a[1], a[2], a[3]),
    3727388367: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedItem(a[0]),
    3778827333: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedProperties(),
    1775413392: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedTextFont(a[0]),
    673634403: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProductDefinitionShape(a[0], a[1], a[2]),
    2802850158: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProfileProperties(a[0], a[1], a[2], a[3]),
    2598011224: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProperty(a[0], a[1]),
    1680319473: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyDefinition(a[0], a[1], a[2], a[3]),
    148025276: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyDependencyRelationship(a[0], a[1], a[2], a[3], a[4]),
    3357820518: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertySetDefinition(a[0], a[1], a[2], a[3]),
    1482703590: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyTemplateDefinition(a[0], a[1], a[2], a[3]),
    2090586900: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcQuantitySet(a[0], a[1], a[2], a[3]),
    3615266464: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRectangleProfileDef(a[0], a[1], a[2], a[3], a[4]),
    3413951693: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRegularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1580146022: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcementBarProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    478536968: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelationship(a[0], a[1], a[2], a[3]),
    2943643501: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResourceApprovalRelationship(a[0], a[1], a[2], a[3]),
    1608871552: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResourceConstraintRelationship(a[0], a[1], a[2], a[3]),
    1042787934: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResourceTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
    2778083089: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRoundedRectangleProfileDef(a[0], a[1], a[2], a[3], a[4], a[5]),
    2042790032: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSectionProperties(a[0], a[1], a[2]),
    4165799628: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSectionReinforcementProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    1509187699: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSectionedSpine(a[0], a[1], a[2]),
    4124623270: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShellBasedSurfaceModel(a[0]),
    3692461612: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSimpleProperty(a[0], a[1]),
    2609359061: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlippageConnectionCondition(a[0], a[1], a[2], a[3]),
    723233188: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSolidModel(),
    1595516126: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadLinearForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2668620305: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadPlanarForce(a[0], a[1], a[2], a[3]),
    2473145415: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadSingleDisplacement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1973038258: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadSingleDisplacementDistortion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1597423693: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadSingleForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1190533807: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadSingleForceWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2233826070: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSubedge(a[0], a[1], a[2]),
    2513912981: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurface(),
    1878645084: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceStyleRendering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2247615214: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSweptAreaSolid(a[0], a[1]),
    1260650574: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSweptDiskSolid(a[0], a[1], a[2], a[3], a[4]),
    1096409881: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSweptDiskSolidPolygonal(a[0], a[1], a[2], a[3], a[4], a[5]),
    230924584: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSweptSurface(a[0], a[1]),
    3071757647: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    901063453: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTessellatedItem(),
    4282788508: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextLiteral(a[0], a[1], a[2]),
    3124975700: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextLiteralWithExtent(a[0], a[1], a[2], a[3], a[4]),
    1983826977: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextStyleFontModel(a[0], a[1], a[2], a[3], a[4], a[5]),
    2715220739: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTrapeziumProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1628702193: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTypeObject(a[0], a[1], a[2], a[3], a[4], a[5]),
    3736923433: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTypeProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2347495698: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTypeProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3698973494: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTypeResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    427810014: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1417489154: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVector(a[0], a[1]),
    2759199220: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVertexLoop(a[0]),
    1299126871: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    2543172580: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcZShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3406155212: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAdvancedFace(a[0], a[1], a[2]),
    669184980: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAnnotationFillArea(a[0], a[1]),
    3207858831: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAsymmetricIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
    4261334040: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAxis1Placement(a[0], a[1]),
    3125803723: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAxis2Placement2D(a[0], a[1]),
    2740243338: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAxis2Placement3D(a[0], a[1], a[2]),
    2736907675: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBooleanResult(a[0], a[1], a[2]),
    4182860854: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundedSurface(),
    2581212453: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundingBox(a[0], a[1], a[2], a[3]),
    2713105998: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoxedHalfSpace(a[0], a[1], a[2]),
    2898889636: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1123145078: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianPoint(a[0]),
    574549367: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianPointList(),
    1675464909: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianPointList2D(a[0]),
    2059837836: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianPointList3D(a[0]),
    59481748: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator(a[0], a[1], a[2], a[3]),
    3749851601: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator2D(a[0], a[1], a[2], a[3]),
    3486308946: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator2DnonUniform(a[0], a[1], a[2], a[3], a[4]),
    3331915920: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator3D(a[0], a[1], a[2], a[3], a[4]),
    1416205885: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCartesianTransformationOperator3DnonUniform(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1383045692: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCircleProfileDef(a[0], a[1], a[2], a[3]),
    2205249479: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcClosedShell(a[0]),
    776857604: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColourRgb(a[0], a[1], a[2], a[3]),
    2542286263: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcComplexProperty(a[0], a[1], a[2], a[3]),
    2485617015: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompositeCurveSegment(a[0], a[1], a[2]),
    2574617495: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3419103109: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcContext(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1815067380: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCrewResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    2506170314: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCsgPrimitive3D(a[0]),
    2147822146: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCsgSolid(a[0]),
    2601014836: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurve(),
    2827736869: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveBoundedPlane(a[0], a[1], a[2]),
    2629017746: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurveBoundedSurface(a[0], a[1], a[2]),
    32440307: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDirection(a[0]),
    526551008: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1472233963: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEdgeLoop(a[0]),
    1883228015: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
    339256511: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2777663545: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementarySurface(a[0]),
    2835456948: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEllipseProfileDef(a[0], a[1], a[2], a[3], a[4]),
    4024345920: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEventType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    477187591: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExtrudedAreaSolid(a[0], a[1], a[2], a[3]),
    2804161546: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExtrudedAreaSolidTapered(a[0], a[1], a[2], a[3], a[4]),
    2047409740: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFaceBasedSurfaceModel(a[0]),
    374418227: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFillAreaStyleHatching(a[0], a[1], a[2], a[3], a[4]),
    315944413: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFillAreaStyleTiles(a[0], a[1], a[2]),
    2652556860: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFixedReferenceSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
    4238390223: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFurnishingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1268542332: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFurnitureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4095422895: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeographicElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    987898635: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeometricCurveSet(a[0]),
    1484403080: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    178912537: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedPolygonalFace(a[0]),
    2294589976: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedPolygonalFaceWithVoids(a[0], a[1]),
    572779678: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    428585644: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLaborResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1281925730: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLine(a[0], a[1]),
    1425443689: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcManifoldSolidBrep(a[0]),
    3888040117: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcObject(a[0], a[1], a[2], a[3], a[4]),
    3388369263: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOffsetCurve2D(a[0], a[1], a[2]),
    3505215534: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOffsetCurve3D(a[0], a[1], a[2], a[3]),
    1682466193: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPcurve(a[0], a[1]),
    603570806: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlanarBox(a[0], a[1], a[2]),
    220341763: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlane(a[0]),
    759155922: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedColour(a[0]),
    2559016684: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedCurveFont(a[0]),
    3967405729: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPreDefinedPropertySet(a[0], a[1], a[2], a[3]),
    569719735: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProcedureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2945172077: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    4208778838: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    103090709: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProject(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    653396225: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProjectLibrary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    871118103: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyBoundedValue(a[0], a[1], a[2], a[3], a[4], a[5]),
    4166981789: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyEnumeratedValue(a[0], a[1], a[2], a[3]),
    2752243245: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyListValue(a[0], a[1], a[2], a[3]),
    941946838: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyReferenceValue(a[0], a[1], a[2], a[3]),
    1451395588: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertySet(a[0], a[1], a[2], a[3], a[4]),
    492091185: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertySetTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3650150729: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertySingleValue(a[0], a[1], a[2], a[3]),
    110355661: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyTableValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3521284610: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertyTemplate(a[0], a[1], a[2], a[3]),
    3219374653: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2770003689: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRectangleHollowProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2798486643: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRectangularPyramid(a[0], a[1], a[2], a[3]),
    3454111270: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRectangularTrimmedSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3765753017: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcementDefinitionProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    3939117080: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssigns(a[0], a[1], a[2], a[3], a[4], a[5]),
    1683148259: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToActor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2495723537: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1307041759: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1027710054: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToGroupByFactor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4278684876: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2857406711: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    205026976: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssignsToResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1865459582: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociates(a[0], a[1], a[2], a[3], a[4]),
    4095574036: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesApproval(a[0], a[1], a[2], a[3], a[4], a[5]),
    919958153: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesClassification(a[0], a[1], a[2], a[3], a[4], a[5]),
    2728634034: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    982818633: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesDocument(a[0], a[1], a[2], a[3], a[4], a[5]),
    3840914261: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesLibrary(a[0], a[1], a[2], a[3], a[4], a[5]),
    2655215786: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAssociatesMaterial(a[0], a[1], a[2], a[3], a[4], a[5]),
    826625072: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnects(a[0], a[1], a[2], a[3]),
    1204542856: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3945020480: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsPathElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4201705270: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsPortToElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    3190031847: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsPorts(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2127690289: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5]),
    1638771189: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    504942748: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsWithEccentricity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3678494232: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelConnectsWithRealizingElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3242617779: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelContainedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
    886880790: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelCoversBldgElements(a[0], a[1], a[2], a[3], a[4], a[5]),
    2802773753: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelCoversSpaces(a[0], a[1], a[2], a[3], a[4], a[5]),
    2565941209: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDeclares(a[0], a[1], a[2], a[3], a[4], a[5]),
    2551354335: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDecomposes(a[0], a[1], a[2], a[3]),
    693640335: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefines(a[0], a[1], a[2], a[3]),
    1462361463: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefinesByObject(a[0], a[1], a[2], a[3], a[4], a[5]),
    4186316022: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefinesByProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    307848117: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefinesByTemplate(a[0], a[1], a[2], a[3], a[4], a[5]),
    781010003: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelDefinesByType(a[0], a[1], a[2], a[3], a[4], a[5]),
    3940055652: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelFillsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    279856033: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelFlowControlElements(a[0], a[1], a[2], a[3], a[4], a[5]),
    427948657: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelInterferesElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3268803585: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelNests(a[0], a[1], a[2], a[3], a[4], a[5]),
    750771296: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelProjectsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    1245217292: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelReferencedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
    4122056220: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelSequence(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    366585022: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelServicesBuildings(a[0], a[1], a[2], a[3], a[4], a[5]),
    3451746338: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelSpaceBoundary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3523091289: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelSpaceBoundary1stLevel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1521410863: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelSpaceBoundary2ndLevel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1401173127: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelVoidsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    816062949: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReparametrisedCompositeCurveSegment(a[0], a[1], a[2], a[3]),
    2914609552: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1856042241: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRevolvedAreaSolid(a[0], a[1], a[2], a[3]),
    3243963512: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRevolvedAreaSolidTapered(a[0], a[1], a[2], a[3], a[4]),
    4158566097: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRightCircularCone(a[0], a[1], a[2]),
    3626867408: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRightCircularCylinder(a[0], a[1], a[2]),
    3663146110: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSimplePropertyTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1412071761: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    710998568: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2706606064: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3893378262: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialStructureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    463610769: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialZone(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2481509218: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpatialZoneType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    451544542: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSphere(a[0], a[1]),
    4015995234: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSphericalSurface(a[0], a[1]),
    3544373492: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3136571912: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    530289379: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3689010777: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3979015343: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2218152070: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    603775116: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4095615324: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSubContractResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    699246055: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceCurve(a[0], a[1], a[2]),
    2028607225: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceCurveSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
    2809605785: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceOfLinearExtrusion(a[0], a[1], a[2], a[3]),
    4124788165: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceOfRevolution(a[0], a[1], a[2]),
    1580310250: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSystemFurnitureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3473067441: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTask(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    3206491090: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTaskType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2387106220: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTessellatedFaceSet(a[0]),
    1935646853: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcToroidalSurface(a[0], a[1], a[2]),
    2097647324: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTransportElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2916149573: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTriangulatedFaceSet(a[0], a[1], a[2], a[3], a[4]),
    336235671: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
    512836454: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2296667514: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActor(a[0], a[1], a[2], a[3], a[4], a[5]),
    1635779807: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAdvancedBrep(a[0]),
    2603310189: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAdvancedBrepWithVoids(a[0], a[1]),
    1674181508: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAnnotation(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2887950389: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBSplineSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    167062518: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBSplineSurfaceWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1334484129: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBlock(a[0], a[1], a[2], a[3]),
    3649129432: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBooleanClippingResult(a[0], a[1], a[2]),
    1260505505: (_)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundedCurve(),
    4031249490: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuilding(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1950629157: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3124254112: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingStorey(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2197970202: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcChimneyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2937912522: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCircleHollowProfileDef(a[0], a[1], a[2], a[3], a[4]),
    3893394355: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCivilElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    300633059: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColumnType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3875453745: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcComplexPropertyTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3732776249: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompositeCurve(a[0], a[1]),
    15328376: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompositeCurveOnSurface(a[0], a[1]),
    2510884976: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConic(a[0]),
    2185764099: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionEquipmentResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    4105962743: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionMaterialResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1525564444: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionProductResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    2559216714: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3293443760: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcControl(a[0], a[1], a[2], a[3], a[4], a[5]),
    3895139033: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCostItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1419761937: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCostSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1916426348: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoveringType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3295246426: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCrewResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1457835157: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurtainWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1213902940: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCylindricalSurface(a[0], a[1]),
    3256556792: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3849074793: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionFlowElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2963535650: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
    1714330368: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2323601079: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    445594917: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDraughtingPreDefinedColour(a[0]),
    4006246654: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDraughtingPreDefinedCurveFont(a[0]),
    1758889154: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4123344466: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementAssembly(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2397081782: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementAssemblyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1623761950: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementComponent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2590856083: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElementComponentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1704287377: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEllipse(a[0], a[1], a[2]),
    2107101300: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEnergyConversionDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    132023988: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEngineType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3174744832: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvaporativeCoolerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3390157468: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvaporatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4148101412: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2853485674: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    807026263: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFacetedBrep(a[0]),
    3737207727: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFacetedBrepWithVoids(a[0], a[1]),
    647756555: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2489546625: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2827207264: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFeatureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2143335405: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFeatureElementAddition(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1287392070: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFeatureElementSubtraction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3907093117: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3198132628: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3815607619: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowMeterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1482959167: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowMovingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1834744321: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1339347760: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2297155007: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3009222698: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowTreatmentDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1893162501: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFootingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    263784265: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFurnishingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1509553395: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFurniture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3493046030: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGeographicElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3009204131: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGrid(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2706460486: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGroup(a[0], a[1], a[2], a[3], a[4]),
    1251058090: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHeatExchangerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1806887404: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHumidifierType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2571569899: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIndexedPolyCurve(a[0], a[1], a[2]),
    3946677679: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInterceptorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3113134337: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIntersectionCurve(a[0], a[1], a[2]),
    2391368822: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInventory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4288270099: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcJunctionBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3827777499: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLaborResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1051575348: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1161773419: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightFixtureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    377706215: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMechanicalFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2108223431: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMechanicalFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1114901282: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMedicalDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3181161470: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMemberType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    977012517: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMotorConnectionType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4143007308: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOccupant(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3588315303: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOpeningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3079942009: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOpeningStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2837617999: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOutletType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2382730787: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPerformanceHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3566463478: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPermeableCoveringProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3327091369: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPermit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1158309216: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPileType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    804291784: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPipeFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4231323485: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPipeSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4017108033: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlateType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2839578677: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPolygonalFaceSet(a[0], a[1], a[2], a[3]),
    3724593414: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPolyline(a[0]),
    3740093272: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2744685151: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProcedure(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2904328755: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProjectOrder(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3651124850: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProjectionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1842657554: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProtectiveDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2250791053: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPumpType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2893384427: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRailingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2324767716: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRampFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1469900589: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    683857671: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRationalBSplineSurfaceWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    3027567501: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    964333572: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2320036040: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingMesh(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
    2310774935: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingMeshType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
    160246688: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRelAggregates(a[0], a[1], a[2], a[3], a[4], a[5]),
    2781568857: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRoofType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1768891740: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSanitaryTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2157484638: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSeamCurve(a[0], a[1], a[2]),
    4074543187: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShadingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4097777520: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSite(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    2533589738: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlabType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1072016465: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSolarDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3856911033: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpace(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1305183839: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpaceHeaterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3812236995: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpaceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3112655638: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStackTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1039846685: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStairFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    338393293: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStairType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    682877961: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1179482911: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1004757350: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    4243806635: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    214636428: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2445595289: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2757150158: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralCurveReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1807405624: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLinearAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1252848954: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2082059205: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralPointAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    734778138: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralPointConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1235345126: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralPointReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2986769608: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralResultGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3657597509: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1975003073: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralSurfaceConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    148013059: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSubContractResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3101698114: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSurfaceFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2315554128: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSwitchingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2254336722: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSystem(a[0], a[1], a[2], a[3], a[4]),
    413509423: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSystemFurnitureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    5716631: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTankType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3824725483: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTendon(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
    2347447852: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTendonAnchor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3081323446: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTendonAnchorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2415094496: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTendonType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    1692211062: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTransformerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1620046519: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTransportElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3593883385: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTrimmedCurve(a[0], a[1], a[2], a[3], a[4]),
    1600972822: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTubeBundleType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1911125066: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitaryEquipmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    728799441: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcValveType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2391383451: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVibrationIsolator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3313531582: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVibrationIsolatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2769231204: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVirtualElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    926996030: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVoidingFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1898987631: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1133259667: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWasteTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4009809668: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    4088093105: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkCalendar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1028945134: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    4218914973: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkPlan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    3342526732: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWorkSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    1033361043: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcZone(a[0], a[1], a[2], a[3], a[4], a[5]),
    3821786052: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActionRequest(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1411407467: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirTerminalBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3352864051: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1871374353: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirToAirHeatRecoveryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3460190687: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAsset(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    1532957894: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAudioVisualApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1967976161: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBSplineCurve(a[0], a[1], a[2], a[3], a[4]),
    2461110595: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBSplineCurveWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    819618141: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    231477066: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoilerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1136057603: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoundaryCurve(a[0], a[1]),
    3299480353: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2979338954: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    39481116: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementPartType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1095909175: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1909888760: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingElementProxyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1177604601: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBuildingSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2188180465: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBurnerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    395041908: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableCarrierFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3293546465: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableCarrierSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2674252688: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1285652485: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2951183804: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcChillerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3296154744: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcChimney(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2611217952: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCircle(a[0], a[1]),
    1677625105: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCivilElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2301859152: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoilType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    843113511: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColumn(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    905975707: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcColumnStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    400855858: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCommunicationsApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3850581409: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompressorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2816379211: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCondenserType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3898045240: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionEquipmentResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1060000209: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionMaterialResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    488727124: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcConstructionProductResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    335055490: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCooledBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2954562838: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoolingTowerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1973544240: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCovering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3495092785: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurtainWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3961806047: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDamperType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1335981549: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDiscreteAccessory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2635815018: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDiscreteAccessoryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1599208980: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionChamberElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2063403501: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1945004755: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3040386961: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionFlowElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3041715199: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3205830791: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    395920057: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    3242481149: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoorStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    869906466: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3760055223: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2030761528: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctSilencerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    663422040: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2417008758: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricDistributionBoardType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3277789161: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1534661035: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricGeneratorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1217240411: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricMotorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    712377611: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricTimeControlType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1658829314: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEnergyConversionDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2814081492: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEngine(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3747195512: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvaporativeCooler(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    484807127: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEvaporator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1209101575: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcExternalSpatialElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    346874300: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFanType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1810631287: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFilterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4222183408: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFireSuppressionTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2058353004: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4278956645: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4037862832: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowInstrumentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2188021234: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowMeter(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3132237377: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowMovingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    987401354: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    707683696: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2223149337: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3508470533: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowTreatmentDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    900683007: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFooting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3319311131: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHeatExchanger(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2068733104: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHumidifier(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4175244083: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInterceptor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2176052936: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcJunctionBox(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    76236018: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    629592764: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLightFixture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1437502449: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMedicalDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1073191201: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1911478936: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMemberStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2474470126: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMotorConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    144952367: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOuterBoundaryCurve(a[0], a[1]),
    3694346114: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcOutlet(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1687234759: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPile(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    310824031: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPipeFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3612865200: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPipeSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3171933400: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1156407060: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlateStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    738039164: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProtectiveDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    655969474: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProtectiveDeviceTrippingUnitType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    90941305: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPump(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2262370178: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRailing(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3024970846: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3283111854: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRampFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1232101972: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRationalBSplineCurveWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    979691226: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingBar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    2572171363: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReinforcingBarType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
    2016517767: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRoof(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3053780830: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSanitaryTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1783015770: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSensorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1329646415: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShadingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1529196076: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlab(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3127900445: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlabElementedCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3027962421: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSlabStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3420628829: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSolarDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1999602285: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpaceHeater(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1404847402: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStackTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    331165859: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStair(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4252922144: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStairFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    2515109513: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralAnalysisModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    385403989: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralLoadCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1621171031: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcStructuralPlanarAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1162798199: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSwitchingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    812556717: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTank(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3825984169: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTransformer(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3026737570: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTubeBundle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3179687236: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitaryControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4292641817: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitaryEquipment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4207607924: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcValve(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2391406946: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4156078855: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWallElementedCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3512223829: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWallStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4237592921: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWasteTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3304561284: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindow(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    486154966: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWindowStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    2874132201: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActuatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1634111441: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    177149247: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirTerminalBox(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2056796094: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAirToAirHeatRecovery(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3001207471: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAlarmType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    277319702: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAudioVisualAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    753842376: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2906023776: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBeamStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    32344328: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoiler(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2938176219: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBurner(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    635142910: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableCarrierFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3758799889: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableCarrierSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1051757585: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4217484030: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCableSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3902619387: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcChiller(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    639361253: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoil(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3221913625: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCommunicationsAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3571504051: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompressor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2272882330: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCondenser(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    578613899: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4136498852: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCooledBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3640358203: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCoolingTower(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4074379575: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDamper(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1052013943: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionChamberElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    562808652: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionCircuit(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1062813311: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDistributionControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    342316401: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3518393246: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1360408905: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuctSilencer(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1904799276: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    862014818: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricDistributionBoard(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3310460725: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    264262732: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricGenerator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    402227799: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricMotor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1003880860: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricTimeControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3415622556: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    819412036: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFilter(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1426591983: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFireSuppressionTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    182646315: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFlowInstrument(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2295281155: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcProtectiveDeviceTrippingUnit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4086658281: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSensor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    630975310: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcUnitaryControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4288193352: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcActuator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3087945054: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAlarm(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    25142252: (a)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8])
};
$3b8da494b8e92f36$export$4085d3c0722bed8d[2] = {
    3630933823: (i)=>[
            i.Role,
            i.UserDefinedRole,
            i.Description
        ],
    618182010: (i)=>[
            i.Purpose,
            i.Description,
            i.UserDefinedPurpose
        ],
    639542469: (i)=>[
            i.ApplicationDeveloper,
            i.Version,
            i.ApplicationFullName,
            i.ApplicationIdentifier
        ],
    411424972: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AppliedValue),
            i.UnitBasis,
            i.ApplicableDate,
            i.FixedUntilDate,
            i.Category,
            i.Condition,
            i.ArithmeticOperator,
            i.Components
        ],
    130549933: (i)=>[
            i.Identifier,
            i.Name,
            i.Description,
            i.TimeOfApproval,
            i.Status,
            i.Level,
            i.Qualifier,
            $3b8da494b8e92f36$var$Labelise(i.RequestingApproval),
            $3b8da494b8e92f36$var$Labelise(i.GivingApproval)
        ],
    4037036970: (i)=>[
            i.Name
        ],
    1560379544: (i)=>[
            i.Name,
            (i.TranslationalStiffnessByLengthX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByLengthX),
            (i.TranslationalStiffnessByLengthY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByLengthY),
            (i.TranslationalStiffnessByLengthZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByLengthZ),
            (i.RotationalStiffnessByLengthX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessByLengthX),
            (i.RotationalStiffnessByLengthY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessByLengthY),
            (i.RotationalStiffnessByLengthZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessByLengthZ)
        ],
    3367102660: (i)=>[
            i.Name,
            (i.TranslationalStiffnessByAreaX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByAreaX),
            (i.TranslationalStiffnessByAreaY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByAreaY),
            (i.TranslationalStiffnessByAreaZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByAreaZ)
        ],
    1387855156: (i)=>[
            i.Name,
            (i.TranslationalStiffnessX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessX),
            (i.TranslationalStiffnessY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessY),
            (i.TranslationalStiffnessZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessZ),
            (i.RotationalStiffnessX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessX),
            (i.RotationalStiffnessY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessY),
            (i.RotationalStiffnessZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessZ)
        ],
    2069777674: (i)=>[
            i.Name,
            (i.TranslationalStiffnessX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessX),
            (i.TranslationalStiffnessY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessY),
            (i.TranslationalStiffnessZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessZ),
            (i.RotationalStiffnessX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessX),
            (i.RotationalStiffnessY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessY),
            (i.RotationalStiffnessZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessZ),
            (i.WarpingStiffness ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.WarpingStiffness)
        ],
    2859738748: (_)=>[],
    2614616156: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatedElement)
        ],
    2732653382: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SurfaceOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.SurfaceOnRelatedElement)
        ],
    775493141: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.VolumeOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.VolumeOnRelatedElement)
        ],
    1959218052: (i)=>[
            i.Name,
            i.Description,
            i.ConstraintGrade,
            i.ConstraintSource,
            $3b8da494b8e92f36$var$Labelise(i.CreatingActor),
            i.CreationTime,
            i.UserDefinedGrade
        ],
    1785450214: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SourceCRS),
            i.TargetCRS
        ],
    1466758467: (i)=>[
            i.Name,
            i.Description,
            i.GeodeticDatum,
            i.VerticalDatum
        ],
    602808272: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AppliedValue),
            i.UnitBasis,
            i.ApplicableDate,
            i.FixedUntilDate,
            i.Category,
            i.Condition,
            i.ArithmeticOperator,
            i.Components
        ],
    1765591967: (i)=>[
            i.Elements,
            i.UnitType,
            i.UserDefinedType
        ],
    1045800335: (i)=>[
            i.Unit,
            i.Exponent
        ],
    2949456006: (i)=>[
            i.LengthExponent,
            i.MassExponent,
            i.TimeExponent,
            i.ElectricCurrentExponent,
            i.ThermodynamicTemperatureExponent,
            i.AmountOfSubstanceExponent,
            i.LuminousIntensityExponent
        ],
    4294318154: (_)=>[],
    3200245327: (i)=>[
            i.Location,
            i.Identification,
            i.Name
        ],
    2242383968: (i)=>[
            i.Location,
            i.Identification,
            i.Name
        ],
    1040185647: (i)=>[
            i.Location,
            i.Identification,
            i.Name
        ],
    3548104201: (i)=>[
            i.Location,
            i.Identification,
            i.Name
        ],
    852622518: (i)=>[
            i.AxisTag,
            i.AxisCurve,
            {
                type: 3,
                value: i.SameSense.value
            }
        ],
    3020489413: (i)=>[
            i.TimeStamp,
            i.ListValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    2655187982: (i)=>[
            i.Name,
            i.Version,
            $3b8da494b8e92f36$var$Labelise(i.Publisher),
            i.VersionDate,
            i.Location,
            i.Description
        ],
    3452421091: (i)=>[
            i.Location,
            i.Identification,
            i.Name,
            i.Description,
            i.Language,
            i.ReferencedLibrary
        ],
    4162380809: (i)=>[
            i.MainPlaneAngle,
            i.SecondaryPlaneAngle,
            i.LuminousIntensity
        ],
    1566485204: (i)=>[
            i.LightDistributionCurve,
            i.DistributionData
        ],
    3057273783: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SourceCRS),
            i.TargetCRS,
            i.Eastings,
            i.Northings,
            i.OrthogonalHeight,
            i.XAxisAbscissa,
            i.XAxisOrdinate,
            i.Scale
        ],
    1847130766: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.MaterialClassifications),
            i.ClassifiedMaterial
        ],
    760658860: (_)=>[],
    248100487: (i)=>[
            i.Material,
            i.LayerThickness,
            i.IsVentilated == null ? null : {
                type: 3,
                value: i.IsVentilated.value
            },
            i.Name,
            i.Description,
            i.Category,
            i.Priority
        ],
    3303938423: (i)=>[
            i.MaterialLayers,
            i.LayerSetName,
            i.Description
        ],
    1847252529: (i)=>[
            i.Material,
            i.LayerThickness,
            i.IsVentilated == null ? null : {
                type: 3,
                value: i.IsVentilated.value
            },
            i.Name,
            i.Description,
            i.Category,
            i.Priority,
            i.OffsetDirection,
            i.OffsetValues
        ],
    2199411900: (i)=>[
            i.Materials
        ],
    2235152071: (i)=>[
            i.Name,
            i.Description,
            i.Material,
            i.Profile,
            i.Priority,
            i.Category
        ],
    164193824: (i)=>[
            i.Name,
            i.Description,
            i.MaterialProfiles,
            i.CompositeProfile
        ],
    552965576: (i)=>[
            i.Name,
            i.Description,
            i.Material,
            i.Profile,
            i.Priority,
            i.Category,
            i.OffsetValues
        ],
    1507914824: (_)=>[],
    2597039031: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.ValueComponent),
            $3b8da494b8e92f36$var$Labelise(i.UnitComponent)
        ],
    3368373690: (i)=>[
            i.Name,
            i.Description,
            i.ConstraintGrade,
            i.ConstraintSource,
            $3b8da494b8e92f36$var$Labelise(i.CreatingActor),
            i.CreationTime,
            i.UserDefinedGrade,
            i.Benchmark,
            i.ValueSource,
            $3b8da494b8e92f36$var$Labelise(i.DataValue),
            i.ReferencePath
        ],
    2706619895: (i)=>[
            i.Currency
        ],
    1918398963: (i)=>[
            i.Dimensions,
            i.UnitType
        ],
    3701648758: (_)=>[],
    2251480897: (i)=>[
            i.Name,
            i.Description,
            i.ConstraintGrade,
            i.ConstraintSource,
            $3b8da494b8e92f36$var$Labelise(i.CreatingActor),
            i.CreationTime,
            i.UserDefinedGrade,
            i.BenchmarkValues,
            i.LogicalAggregator,
            i.ObjectiveQualifier,
            i.UserDefinedQualifier
        ],
    4251960020: (i)=>[
            i.Identification,
            i.Name,
            i.Description,
            i.Roles,
            i.Addresses
        ],
    1207048766: (i)=>[
            i.OwningUser,
            i.OwningApplication,
            i.State,
            i.ChangeAction,
            i.LastModifiedDate,
            i.LastModifyingUser,
            i.LastModifyingApplication,
            i.CreationDate
        ],
    2077209135: (i)=>[
            i.Identification,
            i.FamilyName,
            i.GivenName,
            i.MiddleNames,
            i.PrefixTitles,
            i.SuffixTitles,
            i.Roles,
            i.Addresses
        ],
    101040310: (i)=>[
            i.ThePerson,
            i.TheOrganization,
            i.Roles
        ],
    2483315170: (i)=>[
            i.Name,
            i.Description
        ],
    2226359599: (i)=>[
            i.Name,
            i.Description,
            i.Unit
        ],
    3355820592: (i)=>[
            i.Purpose,
            i.Description,
            i.UserDefinedPurpose,
            i.InternalLocation,
            i.AddressLines,
            i.PostalBox,
            i.Town,
            i.Region,
            i.PostalCode,
            i.Country
        ],
    677532197: (_)=>[],
    2022622350: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AssignedItems),
            i.Identifier
        ],
    1304840413: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AssignedItems),
            i.Identifier,
            {
                type: 3,
                value: i.LayerOn.value
            },
            {
                type: 3,
                value: i.LayerFrozen.value
            },
            {
                type: 3,
                value: i.LayerBlocked.value
            },
            i.LayerStyles
        ],
    3119450353: (i)=>[
            i.Name
        ],
    2417041796: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Styles)
        ],
    2095639259: (i)=>[
            i.Name,
            i.Description,
            i.Representations
        ],
    3958567839: (i)=>[
            i.ProfileType,
            i.ProfileName
        ],
    3843373140: (i)=>[
            i.Name,
            i.Description,
            i.GeodeticDatum,
            i.VerticalDatum,
            i.MapProjection,
            i.MapZone,
            i.MapUnit
        ],
    986844984: (_)=>[],
    3710013099: (i)=>[
            i.Name,
            i.EnumerationValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    2044713172: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.AreaValue,
            i.Formula
        ],
    2093928680: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.CountValue,
            i.Formula
        ],
    931644368: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.LengthValue,
            i.Formula
        ],
    3252649465: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.TimeValue,
            i.Formula
        ],
    2405470396: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.VolumeValue,
            i.Formula
        ],
    825690147: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.WeightValue,
            i.Formula
        ],
    3915482550: (i)=>[
            i.RecurrenceType,
            i.DayComponent,
            i.WeekdayComponent,
            i.MonthComponent,
            i.Position,
            i.Interval,
            i.Occurrences,
            i.TimePeriods
        ],
    2433181523: (i)=>[
            i.TypeIdentifier,
            i.AttributeIdentifier,
            i.InstanceName,
            i.ListPositions,
            i.InnerReference
        ],
    1076942058: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    3377609919: (i)=>[
            i.ContextIdentifier,
            i.ContextType
        ],
    3008791417: (_)=>[],
    1660063152: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.MappingOrigin),
            i.MappedRepresentation
        ],
    2439245199: (i)=>[
            i.Name,
            i.Description
        ],
    2341007311: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    448429030: (i)=>[
            void 0,
            i.UnitType,
            i.Prefix,
            i.Name
        ],
    1054537805: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin
        ],
    867548509: (i)=>[
            i.ShapeRepresentations,
            i.Name,
            i.Description,
            {
                type: 3,
                value: i.ProductDefinitional.value
            },
            $3b8da494b8e92f36$var$Labelise(i.PartOfProductDefinitionShape)
        ],
    3982875396: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    4240577450: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    2273995522: (i)=>[
            i.Name
        ],
    2162789131: (i)=>[
            i.Name
        ],
    3478079324: (i)=>[
            i.Name,
            i.Values,
            i.Locations
        ],
    609421318: (i)=>[
            i.Name
        ],
    2525727697: (i)=>[
            i.Name
        ],
    3408363356: (i)=>[
            i.Name,
            i.DeltaTConstant,
            i.DeltaTY,
            i.DeltaTZ
        ],
    2830218821: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    3958052878: (i)=>[
            i.Item,
            $3b8da494b8e92f36$var$Labelise(i.Styles),
            i.Name
        ],
    3049322572: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    2934153892: (i)=>[
            i.Name,
            i.SurfaceReinforcement1,
            i.SurfaceReinforcement2,
            i.ShearReinforcement
        ],
    1300840506: (i)=>[
            i.Name,
            i.Side,
            $3b8da494b8e92f36$var$Labelise(i.Styles)
        ],
    3303107099: (i)=>[
            i.DiffuseTransmissionColour,
            i.DiffuseReflectionColour,
            i.TransmissionColour,
            i.ReflectanceColour
        ],
    1607154358: (i)=>[
            i.RefractionIndex,
            i.DispersionFactor
        ],
    846575682: (i)=>[
            i.SurfaceColour,
            i.Transparency
        ],
    1351298697: (i)=>[
            i.Textures
        ],
    626085974: (i)=>[
            {
                type: 3,
                value: i.RepeatS.value
            },
            {
                type: 3,
                value: i.RepeatT.value
            },
            i.Mode,
            i.TextureTransform,
            i.Parameter
        ],
    985171141: (i)=>[
            i.Name,
            i.Rows,
            i.Columns
        ],
    2043862942: (i)=>[
            i.Identifier,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            i.ReferencePath
        ],
    531007025: (i)=>[
            (i.RowCells ?? void 0) === void 0 ? null : i.RowCells.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.IsHeading == null ? null : {
                type: 3,
                value: i.IsHeading.value
            }
        ],
    1549132990: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.DurationType,
            i.ScheduleDuration,
            i.ScheduleStart,
            i.ScheduleFinish,
            i.EarlyStart,
            i.EarlyFinish,
            i.LateStart,
            i.LateFinish,
            i.FreeFloat,
            i.TotalFloat,
            i.IsCritical == null ? null : {
                type: 3,
                value: i.IsCritical.value
            },
            i.StatusTime,
            i.ActualDuration,
            i.ActualStart,
            i.ActualFinish,
            i.RemainingTime,
            i.Completion
        ],
    2771591690: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.DurationType,
            i.ScheduleDuration,
            i.ScheduleStart,
            i.ScheduleFinish,
            i.EarlyStart,
            i.EarlyFinish,
            i.LateStart,
            i.LateFinish,
            i.FreeFloat,
            i.TotalFloat,
            i.IsCritical == null ? null : {
                type: 3,
                value: i.IsCritical.value
            },
            i.StatusTime,
            i.ActualDuration,
            i.ActualStart,
            i.ActualFinish,
            i.RemainingTime,
            i.Completion,
            i.Recurrence
        ],
    912023232: (i)=>[
            i.Purpose,
            i.Description,
            i.UserDefinedPurpose,
            i.TelephoneNumbers,
            i.FacsimileNumbers,
            i.PagerNumber,
            i.ElectronicMailAddresses,
            i.WWWHomePageURL,
            i.MessagingIDs
        ],
    1447204868: (i)=>[
            i.Name,
            i.TextCharacterAppearance,
            i.TextStyle,
            $3b8da494b8e92f36$var$Labelise(i.TextFontStyle),
            i.ModelOrDraughting == null ? null : {
                type: 3,
                value: i.ModelOrDraughting.value
            }
        ],
    2636378356: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Colour),
            $3b8da494b8e92f36$var$Labelise(i.BackgroundColour)
        ],
    1640371178: (i)=>[
            (i.TextIndent ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TextIndent),
            i.TextAlign,
            i.TextDecoration,
            (i.LetterSpacing ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LetterSpacing),
            (i.WordSpacing ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.WordSpacing),
            i.TextTransform,
            (i.LineHeight ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LineHeight)
        ],
    280115917: (i)=>[
            i.Maps
        ],
    1742049831: (i)=>[
            i.Maps,
            i.Mode,
            i.Parameter
        ],
    2552916305: (i)=>[
            i.Maps,
            i.Vertices,
            i.MappedTo
        ],
    1210645708: (i)=>[
            i.Coordinates
        ],
    3611470254: (i)=>[
            i.TexCoordsList
        ],
    1199560280: (i)=>[
            i.StartTime,
            i.EndTime
        ],
    3101149627: (i)=>[
            i.Name,
            i.Description,
            i.StartTime,
            i.EndTime,
            i.TimeSeriesDataType,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    581633288: (i)=>[
            i.ListValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    1377556343: (_)=>[],
    1735638870: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    180925521: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Units)
        ],
    2799835756: (_)=>[],
    1907098498: (i)=>[
            i.VertexGeometry
        ],
    891718957: (i)=>[
            i.IntersectingAxes,
            i.OffsetDistances
        ],
    1236880293: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.RecurrencePattern,
            i.Start,
            i.Finish
        ],
    3869604511: (i)=>[
            i.Name,
            i.Description,
            i.RelatingApproval,
            i.RelatedApprovals
        ],
    3798115385: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.OuterCurve
        ],
    1310608509: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Curve
        ],
    2705031697: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.OuterCurve,
            i.InnerCurves
        ],
    616511568: (i)=>[
            {
                type: 3,
                value: i.RepeatS.value
            },
            {
                type: 3,
                value: i.RepeatT.value
            },
            i.Mode,
            i.TextureTransform,
            i.Parameter,
            i.RasterFormat,
            i.RasterCode
        ],
    3150382593: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Curve,
            i.Thickness
        ],
    747523909: (i)=>[
            i.Source,
            i.Edition,
            i.EditionDate,
            i.Name,
            i.Description,
            i.Location,
            i.ReferenceTokens
        ],
    647927063: (i)=>[
            i.Location,
            i.Identification,
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.ReferencedSource),
            i.Description,
            i.Sort
        ],
    3285139300: (i)=>[
            i.ColourList
        ],
    3264961684: (i)=>[
            i.Name
        ],
    1485152156: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Profiles,
            i.Label
        ],
    370225590: (i)=>[
            i.CfsFaces
        ],
    1981873012: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.CurveOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.CurveOnRelatedElement)
        ],
    45288368: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatedElement),
            i.EccentricityInX,
            i.EccentricityInY,
            i.EccentricityInZ
        ],
    3050246964: (i)=>[
            i.Dimensions,
            i.UnitType,
            i.Name
        ],
    2889183280: (i)=>[
            i.Dimensions,
            i.UnitType,
            i.Name,
            i.ConversionFactor
        ],
    2713554722: (i)=>[
            i.Dimensions,
            i.UnitType,
            i.Name,
            i.ConversionFactor,
            i.ConversionOffset
        ],
    539742890: (i)=>[
            i.Name,
            i.Description,
            i.RelatingMonetaryUnit,
            i.RelatedMonetaryUnit,
            i.ExchangeRate,
            i.RateDateTime,
            i.RateSource
        ],
    3800577675: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.CurveFont),
            (i.CurveWidth ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.CurveWidth),
            $3b8da494b8e92f36$var$Labelise(i.CurveColour),
            i.ModelOrDraughting == null ? null : {
                type: 3,
                value: i.ModelOrDraughting.value
            }
        ],
    1105321065: (i)=>[
            i.Name,
            i.PatternList
        ],
    2367409068: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.CurveFont),
            i.CurveFontScaling
        ],
    3510044353: (i)=>[
            i.VisibleSegmentLength,
            i.InvisibleSegmentLength
        ],
    3632507154: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.ParentProfile,
            i.Operator,
            i.Label
        ],
    1154170062: (i)=>[
            i.Identification,
            i.Name,
            i.Description,
            i.Location,
            i.Purpose,
            i.IntendedUse,
            i.Scope,
            i.Revision,
            $3b8da494b8e92f36$var$Labelise(i.DocumentOwner),
            $3b8da494b8e92f36$var$Labelise(i.Editors),
            i.CreationTime,
            i.LastRevisionTime,
            i.ElectronicFormat,
            i.ValidFrom,
            i.ValidUntil,
            i.Confidentiality,
            i.Status
        ],
    770865208: (i)=>[
            i.Name,
            i.Description,
            i.RelatingDocument,
            i.RelatedDocuments,
            i.RelationshipType
        ],
    3732053477: (i)=>[
            i.Location,
            i.Identification,
            i.Name,
            i.Description,
            i.ReferencedDocument
        ],
    3900360178: (i)=>[
            i.EdgeStart,
            i.EdgeEnd
        ],
    476780140: (i)=>[
            i.EdgeStart,
            i.EdgeEnd,
            i.EdgeGeometry,
            {
                type: 3,
                value: i.SameSense.value
            }
        ],
    211053100: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.ActualDate,
            i.EarlyDate,
            i.LateDate,
            i.ScheduleDate
        ],
    297599258: (i)=>[
            i.Name,
            i.Description,
            i.Properties
        ],
    1437805879: (i)=>[
            i.Name,
            i.Description,
            i.RelatingReference,
            $3b8da494b8e92f36$var$Labelise(i.RelatedResourceObjects)
        ],
    2556980723: (i)=>[
            i.Bounds
        ],
    1809719519: (i)=>[
            i.Bound,
            {
                type: 3,
                value: i.Orientation.value
            }
        ],
    803316827: (i)=>[
            i.Bound,
            {
                type: 3,
                value: i.Orientation.value
            }
        ],
    3008276851: (i)=>[
            i.Bounds,
            i.FaceSurface,
            {
                type: 3,
                value: i.SameSense.value
            }
        ],
    4219587988: (i)=>[
            i.Name,
            i.TensionFailureX,
            i.TensionFailureY,
            i.TensionFailureZ,
            i.CompressionFailureX,
            i.CompressionFailureY,
            i.CompressionFailureZ
        ],
    738692330: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.FillStyles),
            i.ModelorDraughting == null ? null : {
                type: 3,
                value: i.ModelorDraughting.value
            }
        ],
    3448662350: (i)=>[
            i.ContextIdentifier,
            i.ContextType,
            i.CoordinateSpaceDimension,
            i.Precision,
            $3b8da494b8e92f36$var$Labelise(i.WorldCoordinateSystem),
            i.TrueNorth
        ],
    2453401579: (_)=>[],
    4142052618: (i)=>[
            i.ContextIdentifier,
            i.ContextType,
            void 0,
            void 0,
            void 0,
            void 0,
            i.ParentContext,
            i.TargetScale,
            i.TargetView,
            i.UserDefinedTargetView
        ],
    3590301190: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Elements)
        ],
    178086475: (i)=>[
            i.PlacementLocation,
            $3b8da494b8e92f36$var$Labelise(i.PlacementRefDirection)
        ],
    812098782: (i)=>[
            i.BaseSurface,
            {
                type: 3,
                value: i.AgreementFlag.value
            }
        ],
    3905492369: (i)=>[
            {
                type: 3,
                value: i.RepeatS.value
            },
            {
                type: 3,
                value: i.RepeatT.value
            },
            i.Mode,
            i.TextureTransform,
            i.Parameter,
            i.URLReference
        ],
    3570813810: (i)=>[
            i.MappedTo,
            i.Opacity,
            i.Colours,
            i.ColourIndex
        ],
    1437953363: (i)=>[
            i.Maps,
            i.MappedTo,
            i.TexCoords
        ],
    2133299955: (i)=>[
            i.Maps,
            i.MappedTo,
            i.TexCoords,
            i.TexCoordIndex
        ],
    3741457305: (i)=>[
            i.Name,
            i.Description,
            i.StartTime,
            i.EndTime,
            i.TimeSeriesDataType,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            i.Values
        ],
    1585845231: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.LagValue),
            i.DurationType
        ],
    1402838566: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity
        ],
    125510826: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity
        ],
    2604431987: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Orientation
        ],
    4266656042: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Position,
            i.ColourAppearance,
            i.ColourTemperature,
            i.LuminousFlux,
            i.LightEmissionSource,
            $3b8da494b8e92f36$var$Labelise(i.LightDistributionDataSource)
        ],
    1520743889: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Position,
            i.Radius,
            i.ConstantAttenuation,
            i.DistanceAttenuation,
            i.QuadricAttenuation
        ],
    3422422726: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Position,
            i.Radius,
            i.ConstantAttenuation,
            i.DistanceAttenuation,
            i.QuadricAttenuation,
            i.Orientation,
            i.ConcentrationExponent,
            i.SpreadAngle,
            i.BeamWidthAngle
        ],
    2624227202: (i)=>[
            i.PlacementRelTo,
            $3b8da494b8e92f36$var$Labelise(i.RelativePlacement)
        ],
    1008929658: (_)=>[],
    2347385850: (i)=>[
            i.MappingSource,
            i.MappingTarget
        ],
    1838606355: (i)=>[
            i.Name,
            i.Description,
            i.Category
        ],
    3708119e3: (i)=>[
            i.Name,
            i.Description,
            i.Material,
            i.Fraction,
            i.Category
        ],
    2852063980: (i)=>[
            i.Name,
            i.Description,
            i.MaterialConstituents
        ],
    2022407955: (i)=>[
            i.Name,
            i.Description,
            i.Representations,
            i.RepresentedMaterial
        ],
    1303795690: (i)=>[
            i.ForLayerSet,
            i.LayerSetDirection,
            i.DirectionSense,
            i.OffsetFromReferenceLine,
            i.ReferenceExtent
        ],
    3079605661: (i)=>[
            i.ForProfileSet,
            i.CardinalPoint,
            i.ReferenceExtent
        ],
    3404854881: (i)=>[
            i.ForProfileSet,
            i.CardinalPoint,
            i.ReferenceExtent,
            i.ForProfileEndSet,
            i.CardinalEndPoint
        ],
    3265635763: (i)=>[
            i.Name,
            i.Description,
            i.Properties,
            i.Material
        ],
    853536259: (i)=>[
            i.Name,
            i.Description,
            i.RelatingMaterial,
            i.RelatedMaterials,
            i.Expression
        ],
    2998442950: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.ParentProfile,
            void 0,
            i.Label
        ],
    219451334: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    2665983363: (i)=>[
            i.CfsFaces
        ],
    1411181986: (i)=>[
            i.Name,
            i.Description,
            i.RelatingOrganization,
            i.RelatedOrganizations
        ],
    1029017970: (i)=>[
            void 0,
            void 0,
            i.EdgeElement,
            {
                type: 3,
                value: i.Orientation.value
            }
        ],
    2529465313: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position
        ],
    2519244187: (i)=>[
            i.EdgeList
        ],
    3021840470: (i)=>[
            i.Name,
            i.Description,
            i.HasQuantities,
            i.Discrimination,
            i.Quality,
            i.Usage
        ],
    597895409: (i)=>[
            {
                type: 3,
                value: i.RepeatS.value
            },
            {
                type: 3,
                value: i.RepeatT.value
            },
            i.Mode,
            i.TextureTransform,
            i.Parameter,
            i.Width,
            i.Height,
            i.ColourComponents,
            i.Pixel
        ],
    2004835150: (i)=>[
            i.Location
        ],
    1663979128: (i)=>[
            i.SizeInX,
            i.SizeInY
        ],
    2067069095: (_)=>[],
    4022376103: (i)=>[
            i.BasisCurve,
            i.PointParameter
        ],
    1423911732: (i)=>[
            i.BasisSurface,
            i.PointParameterU,
            i.PointParameterV
        ],
    2924175390: (i)=>[
            i.Polygon
        ],
    2775532180: (i)=>[
            i.BaseSurface,
            {
                type: 3,
                value: i.AgreementFlag.value
            },
            i.Position,
            i.PolygonalBoundary
        ],
    3727388367: (i)=>[
            i.Name
        ],
    3778827333: (_)=>[],
    1775413392: (i)=>[
            i.Name
        ],
    673634403: (i)=>[
            i.Name,
            i.Description,
            i.Representations
        ],
    2802850158: (i)=>[
            i.Name,
            i.Description,
            i.Properties,
            i.ProfileDefinition
        ],
    2598011224: (i)=>[
            i.Name,
            i.Description
        ],
    1680319473: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    148025276: (i)=>[
            i.Name,
            i.Description,
            i.DependingProperty,
            i.DependantProperty,
            i.Expression
        ],
    3357820518: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    1482703590: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    2090586900: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    3615266464: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.XDim,
            i.YDim
        ],
    3413951693: (i)=>[
            i.Name,
            i.Description,
            i.StartTime,
            i.EndTime,
            i.TimeSeriesDataType,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            i.TimeStep,
            i.Values
        ],
    1580146022: (i)=>[
            i.TotalCrossSectionArea,
            i.SteelGrade,
            i.BarSurface,
            i.EffectiveDepth,
            i.NominalBarDiameter,
            i.BarCount
        ],
    478536968: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    2943643501: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedResourceObjects),
            i.RelatingApproval
        ],
    1608871552: (i)=>[
            i.Name,
            i.Description,
            i.RelatingConstraint,
            $3b8da494b8e92f36$var$Labelise(i.RelatedResourceObjects)
        ],
    1042787934: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.ScheduleWork,
            i.ScheduleUsage,
            i.ScheduleStart,
            i.ScheduleFinish,
            i.ScheduleContour,
            i.LevelingDelay,
            i.IsOverAllocated == null ? null : {
                type: 3,
                value: i.IsOverAllocated.value
            },
            i.StatusTime,
            i.ActualWork,
            i.ActualUsage,
            i.ActualStart,
            i.ActualFinish,
            i.RemainingWork,
            i.RemainingUsage,
            i.Completion
        ],
    2778083089: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.XDim,
            i.YDim,
            i.RoundingRadius
        ],
    2042790032: (i)=>[
            i.SectionType,
            i.StartProfile,
            i.EndProfile
        ],
    4165799628: (i)=>[
            i.LongitudinalStartPosition,
            i.LongitudinalEndPosition,
            i.TransversePosition,
            i.ReinforcementRole,
            i.SectionDefinition,
            i.CrossSectionReinforcementDefinitions
        ],
    1509187699: (i)=>[
            i.SpineCurve,
            i.CrossSections,
            i.CrossSectionPositions
        ],
    4124623270: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SbsmBoundary)
        ],
    3692461612: (i)=>[
            i.Name,
            i.Description
        ],
    2609359061: (i)=>[
            i.Name,
            i.SlippageX,
            i.SlippageY,
            i.SlippageZ
        ],
    723233188: (_)=>[],
    1595516126: (i)=>[
            i.Name,
            i.LinearForceX,
            i.LinearForceY,
            i.LinearForceZ,
            i.LinearMomentX,
            i.LinearMomentY,
            i.LinearMomentZ
        ],
    2668620305: (i)=>[
            i.Name,
            i.PlanarForceX,
            i.PlanarForceY,
            i.PlanarForceZ
        ],
    2473145415: (i)=>[
            i.Name,
            i.DisplacementX,
            i.DisplacementY,
            i.DisplacementZ,
            i.RotationalDisplacementRX,
            i.RotationalDisplacementRY,
            i.RotationalDisplacementRZ
        ],
    1973038258: (i)=>[
            i.Name,
            i.DisplacementX,
            i.DisplacementY,
            i.DisplacementZ,
            i.RotationalDisplacementRX,
            i.RotationalDisplacementRY,
            i.RotationalDisplacementRZ,
            i.Distortion
        ],
    1597423693: (i)=>[
            i.Name,
            i.ForceX,
            i.ForceY,
            i.ForceZ,
            i.MomentX,
            i.MomentY,
            i.MomentZ
        ],
    1190533807: (i)=>[
            i.Name,
            i.ForceX,
            i.ForceY,
            i.ForceZ,
            i.MomentX,
            i.MomentY,
            i.MomentZ,
            i.WarpingMoment
        ],
    2233826070: (i)=>[
            i.EdgeStart,
            i.EdgeEnd,
            i.ParentEdge
        ],
    2513912981: (_)=>[],
    1878645084: (i)=>[
            i.SurfaceColour,
            i.Transparency,
            $3b8da494b8e92f36$var$Labelise(i.DiffuseColour),
            $3b8da494b8e92f36$var$Labelise(i.TransmissionColour),
            $3b8da494b8e92f36$var$Labelise(i.DiffuseTransmissionColour),
            $3b8da494b8e92f36$var$Labelise(i.ReflectionColour),
            $3b8da494b8e92f36$var$Labelise(i.SpecularColour),
            (i.SpecularHighlight ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.SpecularHighlight),
            i.ReflectanceMethod
        ],
    2247615214: (i)=>[
            i.SweptArea,
            i.Position
        ],
    1260650574: (i)=>[
            i.Directrix,
            i.Radius,
            i.InnerRadius,
            i.StartParam,
            i.EndParam
        ],
    1096409881: (i)=>[
            i.Directrix,
            i.Radius,
            i.InnerRadius,
            i.StartParam,
            i.EndParam,
            i.FilletRadius
        ],
    230924584: (i)=>[
            i.SweptCurve,
            i.Position
        ],
    3071757647: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.FlangeWidth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.FlangeEdgeRadius,
            i.WebEdgeRadius,
            i.WebSlope,
            i.FlangeSlope
        ],
    901063453: (_)=>[],
    4282788508: (i)=>[
            i.Literal,
            $3b8da494b8e92f36$var$Labelise(i.Placement),
            i.Path
        ],
    3124975700: (i)=>[
            i.Literal,
            $3b8da494b8e92f36$var$Labelise(i.Placement),
            i.Path,
            i.Extent,
            i.BoxAlignment
        ],
    1983826977: (i)=>[
            i.Name,
            i.FontFamily,
            i.FontStyle,
            i.FontVariant,
            i.FontWeight,
            $3b8da494b8e92f36$var$Labelise(i.FontSize)
        ],
    2715220739: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.BottomXDim,
            i.TopXDim,
            i.YDim,
            i.TopXOffset
        ],
    1628702193: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets
        ],
    3736923433: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ProcessType
        ],
    2347495698: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag
        ],
    3698973494: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType
        ],
    427810014: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.FlangeWidth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.EdgeRadius,
            i.FlangeSlope
        ],
    1417489154: (i)=>[
            i.Orientation,
            i.Magnitude
        ],
    2759199220: (i)=>[
            i.LoopVertex
        ],
    1299126871: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ConstructionType,
            i.OperationType,
            {
                type: 3,
                value: i.ParameterTakesPrecedence.value
            },
            {
                type: 3,
                value: i.Sizeable.value
            }
        ],
    2543172580: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.FlangeWidth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.EdgeRadius
        ],
    3406155212: (i)=>[
            i.Bounds,
            i.FaceSurface,
            {
                type: 3,
                value: i.SameSense.value
            }
        ],
    669184980: (i)=>[
            i.OuterBoundary,
            i.InnerBoundaries
        ],
    3207858831: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.BottomFlangeWidth,
            i.OverallDepth,
            i.WebThickness,
            i.BottomFlangeThickness,
            i.BottomFlangeFilletRadius,
            i.TopFlangeWidth,
            i.TopFlangeThickness,
            i.TopFlangeFilletRadius,
            i.BottomFlangeEdgeRadius,
            i.BottomFlangeSlope,
            i.TopFlangeEdgeRadius,
            i.TopFlangeSlope
        ],
    4261334040: (i)=>[
            i.Location,
            i.Axis
        ],
    3125803723: (i)=>[
            i.Location,
            i.RefDirection
        ],
    2740243338: (i)=>[
            i.Location,
            i.Axis,
            i.RefDirection
        ],
    2736907675: (i)=>[
            i.Operator,
            $3b8da494b8e92f36$var$Labelise(i.FirstOperand),
            $3b8da494b8e92f36$var$Labelise(i.SecondOperand)
        ],
    4182860854: (_)=>[],
    2581212453: (i)=>[
            i.Corner,
            i.XDim,
            i.YDim,
            i.ZDim
        ],
    2713105998: (i)=>[
            i.BaseSurface,
            {
                type: 3,
                value: i.AgreementFlag.value
            },
            i.Enclosure
        ],
    2898889636: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.Width,
            i.WallThickness,
            i.Girth,
            i.InternalFilletRadius
        ],
    1123145078: (i)=>[
            i.Coordinates
        ],
    574549367: (_)=>[],
    1675464909: (i)=>[
            i.CoordList
        ],
    2059837836: (i)=>[
            i.CoordList
        ],
    59481748: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale
        ],
    3749851601: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale
        ],
    3486308946: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale,
            i.Scale2
        ],
    3331915920: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale,
            i.Axis3
        ],
    1416205885: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale,
            i.Axis3,
            i.Scale2,
            i.Scale3
        ],
    1383045692: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Radius
        ],
    2205249479: (i)=>[
            i.CfsFaces
        ],
    776857604: (i)=>[
            i.Name,
            i.Red,
            i.Green,
            i.Blue
        ],
    2542286263: (i)=>[
            i.Name,
            i.Description,
            i.UsageName,
            i.HasProperties
        ],
    2485617015: (i)=>[
            i.Transition,
            {
                type: 3,
                value: i.SameSense.value
            },
            i.ParentCurve
        ],
    2574617495: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity
        ],
    3419103109: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.Phase,
            i.RepresentationContexts,
            i.UnitsInContext
        ],
    1815067380: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    2506170314: (i)=>[
            i.Position
        ],
    2147822146: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.TreeRootExpression)
        ],
    2601014836: (_)=>[],
    2827736869: (i)=>[
            i.BasisSurface,
            i.OuterBoundary,
            i.InnerBoundaries
        ],
    2629017746: (i)=>[
            i.BasisSurface,
            i.Boundaries,
            {
                type: 3,
                value: i.ImplicitOuter.value
            }
        ],
    32440307: (i)=>[
            i.DirectionRatios
        ],
    526551008: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.OperationType,
            i.ConstructionType,
            {
                type: 3,
                value: i.ParameterTakesPrecedence.value
            },
            {
                type: 3,
                value: i.Sizeable.value
            }
        ],
    1472233963: (i)=>[
            i.EdgeList
        ],
    1883228015: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.MethodOfMeasurement,
            i.Quantities
        ],
    339256511: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2777663545: (i)=>[
            i.Position
        ],
    2835456948: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.SemiAxis1,
            i.SemiAxis2
        ],
    4024345920: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ProcessType,
            i.PredefinedType,
            i.EventTriggerType,
            i.UserDefinedEventTriggerType
        ],
    477187591: (i)=>[
            i.SweptArea,
            i.Position,
            i.ExtrudedDirection,
            i.Depth
        ],
    2804161546: (i)=>[
            i.SweptArea,
            i.Position,
            i.ExtrudedDirection,
            i.Depth,
            i.EndSweptArea
        ],
    2047409740: (i)=>[
            i.FbsmFaces
        ],
    374418227: (i)=>[
            i.HatchLineAppearance,
            $3b8da494b8e92f36$var$Labelise(i.StartOfNextHatchLine),
            i.PointOfReferenceHatchLine,
            i.PatternStart,
            i.HatchLineAngle
        ],
    315944413: (i)=>[
            i.TilingPattern,
            i.Tiles,
            i.TilingScale
        ],
    2652556860: (i)=>[
            i.SweptArea,
            i.Position,
            i.Directrix,
            i.StartParam,
            i.EndParam,
            i.FixedReference
        ],
    4238390223: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1268542332: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.AssemblyPlace,
            i.PredefinedType
        ],
    4095422895: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    987898635: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Elements)
        ],
    1484403080: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.OverallWidth,
            i.OverallDepth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.FlangeEdgeRadius,
            i.FlangeSlope
        ],
    178912537: (i)=>[
            i.CoordIndex
        ],
    2294589976: (i)=>[
            i.CoordIndex,
            i.InnerCoordIndices
        ],
    572779678: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.Width,
            i.Thickness,
            i.FilletRadius,
            i.EdgeRadius,
            i.LegSlope
        ],
    428585644: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1281925730: (i)=>[
            i.Pnt,
            i.Dir
        ],
    1425443689: (i)=>[
            i.Outer
        ],
    3888040117: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    3388369263: (i)=>[
            i.BasisCurve,
            i.Distance,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    3505215534: (i)=>[
            i.BasisCurve,
            i.Distance,
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.RefDirection
        ],
    1682466193: (i)=>[
            i.BasisSurface,
            i.ReferenceCurve
        ],
    603570806: (i)=>[
            i.SizeInX,
            i.SizeInY,
            $3b8da494b8e92f36$var$Labelise(i.Placement)
        ],
    220341763: (i)=>[
            i.Position
        ],
    759155922: (i)=>[
            i.Name
        ],
    2559016684: (i)=>[
            i.Name
        ],
    3967405729: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    569719735: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ProcessType,
            i.PredefinedType
        ],
    2945172077: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription
        ],
    4208778838: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    103090709: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.Phase,
            i.RepresentationContexts,
            i.UnitsInContext
        ],
    653396225: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.Phase,
            i.RepresentationContexts,
            i.UnitsInContext
        ],
    871118103: (i)=>[
            i.Name,
            i.Description,
            (i.UpperBoundValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.UpperBoundValue),
            (i.LowerBoundValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LowerBoundValue),
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            (i.SetPointValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.SetPointValue)
        ],
    4166981789: (i)=>[
            i.Name,
            i.Description,
            (i.EnumerationValues ?? void 0) === void 0 ? null : i.EnumerationValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.EnumerationReference
        ],
    2752243245: (i)=>[
            i.Name,
            i.Description,
            (i.ListValues ?? void 0) === void 0 ? null : i.ListValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    941946838: (i)=>[
            i.Name,
            i.Description,
            i.UsageName,
            $3b8da494b8e92f36$var$Labelise(i.PropertyReference)
        ],
    1451395588: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.HasProperties
        ],
    492091185: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.TemplateType,
            i.ApplicableEntity,
            i.HasPropertyTemplates
        ],
    3650150729: (i)=>[
            i.Name,
            i.Description,
            (i.NominalValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.NominalValue),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    110355661: (i)=>[
            i.Name,
            i.Description,
            (i.DefiningValues ?? void 0) === void 0 ? null : i.DefiningValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            (i.DefinedValues ?? void 0) === void 0 ? null : i.DefinedValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.Expression,
            $3b8da494b8e92f36$var$Labelise(i.DefiningUnit),
            $3b8da494b8e92f36$var$Labelise(i.DefinedUnit),
            i.CurveInterpolation
        ],
    3521284610: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    3219374653: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.ProxyType,
            i.Tag
        ],
    2770003689: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.XDim,
            i.YDim,
            i.WallThickness,
            i.InnerFilletRadius,
            i.OuterFilletRadius
        ],
    2798486643: (i)=>[
            i.Position,
            i.XLength,
            i.YLength,
            i.Height
        ],
    3454111270: (i)=>[
            i.BasisSurface,
            i.U1,
            i.V1,
            i.U2,
            i.V2,
            {
                type: 3,
                value: i.Usense.value
            },
            {
                type: 3,
                value: i.Vsense.value
            }
        ],
    3765753017: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.DefinitionType,
            i.ReinforcementSectionDefinitions
        ],
    3939117080: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType
        ],
    1683148259: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingActor,
            i.ActingRole
        ],
    2495723537: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingControl
        ],
    1307041759: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingGroup
        ],
    1027710054: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            i.RelatingGroup,
            i.Factor
        ],
    4278684876: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            $3b8da494b8e92f36$var$Labelise(i.RelatingProcess),
            i.QuantityInProcess
        ],
    2857406711: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            $3b8da494b8e92f36$var$Labelise(i.RelatingProduct)
        ],
    205026976: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType,
            $3b8da494b8e92f36$var$Labelise(i.RelatingResource)
        ],
    1865459582: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects)
        ],
    4095574036: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            i.RelatingApproval
        ],
    919958153: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            $3b8da494b8e92f36$var$Labelise(i.RelatingClassification)
        ],
    2728634034: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            i.Intent,
            i.RelatingConstraint
        ],
    982818633: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            $3b8da494b8e92f36$var$Labelise(i.RelatingDocument)
        ],
    3840914261: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            $3b8da494b8e92f36$var$Labelise(i.RelatingLibrary)
        ],
    2655215786: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            $3b8da494b8e92f36$var$Labelise(i.RelatingMaterial)
        ],
    826625072: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    1204542856: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ConnectionGeometry,
            i.RelatingElement,
            i.RelatedElement
        ],
    3945020480: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ConnectionGeometry,
            i.RelatingElement,
            i.RelatedElement,
            i.RelatingPriorities,
            i.RelatedPriorities,
            i.RelatedConnectionType,
            i.RelatingConnectionType
        ],
    4201705270: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingPort,
            i.RelatedElement
        ],
    3190031847: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingPort,
            i.RelatedPort,
            i.RealizingElement
        ],
    2127690289: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingElement),
            i.RelatedStructuralActivity
        ],
    1638771189: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingStructuralMember,
            i.RelatedStructuralConnection,
            i.AppliedCondition,
            i.AdditionalConditions,
            i.SupportedLength,
            i.ConditionCoordinateSystem
        ],
    504942748: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingStructuralMember,
            i.RelatedStructuralConnection,
            i.AppliedCondition,
            i.AdditionalConditions,
            i.SupportedLength,
            i.ConditionCoordinateSystem,
            i.ConnectionConstraint
        ],
    3678494232: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ConnectionGeometry,
            i.RelatingElement,
            i.RelatedElement,
            i.RealizingElements,
            i.ConnectionType
        ],
    3242617779: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedElements,
            i.RelatingStructure
        ],
    886880790: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingBuildingElement,
            i.RelatedCoverings
        ],
    2802773753: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingSpace,
            i.RelatedCoverings
        ],
    2565941209: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingContext,
            $3b8da494b8e92f36$var$Labelise(i.RelatedDefinitions)
        ],
    2551354335: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    693640335: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    1462361463: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingObject
        ],
    4186316022: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            $3b8da494b8e92f36$var$Labelise(i.RelatingPropertyDefinition)
        ],
    307848117: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedPropertySets,
            i.RelatingTemplate
        ],
    781010003: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingType
        ],
    3940055652: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingOpeningElement,
            i.RelatedBuildingElement
        ],
    279856033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedControlElements,
            i.RelatingFlowElement
        ],
    427948657: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingElement,
            i.RelatedElement,
            i.InterferenceGeometry,
            i.InterferenceType,
            i.ImpliedOrder
        ],
    3268803585: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingObject,
            i.RelatedObjects
        ],
    750771296: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingElement,
            i.RelatedFeatureElement
        ],
    1245217292: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedElements,
            i.RelatingStructure
        ],
    4122056220: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingProcess,
            i.RelatedProcess,
            i.TimeLag,
            i.SequenceType,
            i.UserDefinedSequenceType
        ],
    366585022: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingSystem,
            i.RelatedBuildings
        ],
    3451746338: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingSpace),
            i.RelatedBuildingElement,
            i.ConnectionGeometry,
            i.PhysicalOrVirtualBoundary,
            i.InternalOrExternalBoundary
        ],
    3523091289: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingSpace),
            i.RelatedBuildingElement,
            i.ConnectionGeometry,
            i.PhysicalOrVirtualBoundary,
            i.InternalOrExternalBoundary,
            i.ParentBoundary
        ],
    1521410863: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingSpace),
            i.RelatedBuildingElement,
            i.ConnectionGeometry,
            i.PhysicalOrVirtualBoundary,
            i.InternalOrExternalBoundary,
            i.ParentBoundary,
            i.CorrespondingBoundary
        ],
    1401173127: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingBuildingElement,
            i.RelatedOpeningElement
        ],
    816062949: (i)=>[
            i.Transition,
            {
                type: 3,
                value: i.SameSense.value
            },
            i.ParentCurve,
            i.ParamLength
        ],
    2914609552: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription
        ],
    1856042241: (i)=>[
            i.SweptArea,
            i.Position,
            i.Axis,
            i.Angle
        ],
    3243963512: (i)=>[
            i.SweptArea,
            i.Position,
            i.Axis,
            i.Angle,
            i.EndSweptArea
        ],
    4158566097: (i)=>[
            i.Position,
            i.Height,
            i.BottomRadius
        ],
    3626867408: (i)=>[
            i.Position,
            i.Height,
            i.Radius
        ],
    3663146110: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.TemplateType,
            i.PrimaryMeasureType,
            i.SecondaryMeasureType,
            i.Enumerators,
            $3b8da494b8e92f36$var$Labelise(i.PrimaryUnit),
            $3b8da494b8e92f36$var$Labelise(i.SecondaryUnit),
            i.Expression,
            i.AccessState
        ],
    1412071761: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName
        ],
    710998568: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2706606064: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType
        ],
    3893378262: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    463610769: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.PredefinedType
        ],
    2481509218: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.LongName
        ],
    451544542: (i)=>[
            i.Position,
            i.Radius
        ],
    4015995234: (i)=>[
            i.Position,
            i.Radius
        ],
    3544373492: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal
        ],
    3136571912: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    530289379: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    3689010777: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal
        ],
    3979015343: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Thickness
        ],
    2218152070: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Thickness
        ],
    603775116: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.PredefinedType
        ],
    4095615324: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    699246055: (i)=>[
            i.Curve3D,
            i.AssociatedGeometry,
            i.MasterRepresentation
        ],
    2028607225: (i)=>[
            i.SweptArea,
            i.Position,
            i.Directrix,
            i.StartParam,
            i.EndParam,
            i.ReferenceSurface
        ],
    2809605785: (i)=>[
            i.SweptCurve,
            i.Position,
            i.ExtrudedDirection,
            i.Depth
        ],
    4124788165: (i)=>[
            i.SweptCurve,
            i.Position,
            i.AxisPosition
        ],
    1580310250: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3473067441: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Status,
            i.WorkMethod,
            {
                type: 3,
                value: i.IsMilestone.value
            },
            i.Priority,
            i.TaskTime,
            i.PredefinedType
        ],
    3206491090: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ProcessType,
            i.PredefinedType,
            i.WorkMethod
        ],
    2387106220: (i)=>[
            i.Coordinates
        ],
    1935646853: (i)=>[
            i.Position,
            i.MajorRadius,
            i.MinorRadius
        ],
    2097647324: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2916149573: (i)=>[
            i.Coordinates,
            i.Normals,
            i.Closed == null ? null : {
                type: 3,
                value: i.Closed.value
            },
            i.CoordIndex,
            i.PnIndex
        ],
    336235671: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.LiningDepth,
            i.LiningThickness,
            i.TransomThickness,
            i.MullionThickness,
            i.FirstTransomOffset,
            i.SecondTransomOffset,
            i.FirstMullionOffset,
            i.SecondMullionOffset,
            i.ShapeAspectStyle,
            i.LiningOffset,
            i.LiningToPanelOffsetX,
            i.LiningToPanelOffsetY
        ],
    512836454: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.OperationType,
            i.PanelPosition,
            i.FrameDepth,
            i.FrameThickness,
            i.ShapeAspectStyle
        ],
    2296667514: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.TheActor)
        ],
    1635779807: (i)=>[
            i.Outer
        ],
    2603310189: (i)=>[
            i.Outer,
            i.Voids
        ],
    1674181508: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    2887950389: (i)=>[
            i.UDegree,
            i.VDegree,
            i.ControlPointsList,
            i.SurfaceForm,
            {
                type: 3,
                value: i.UClosed.value
            },
            {
                type: 3,
                value: i.VClosed.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    167062518: (i)=>[
            i.UDegree,
            i.VDegree,
            i.ControlPointsList,
            i.SurfaceForm,
            {
                type: 3,
                value: i.UClosed.value
            },
            {
                type: 3,
                value: i.VClosed.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.UMultiplicities,
            i.VMultiplicities,
            i.UKnots,
            i.VKnots,
            i.KnotSpec
        ],
    1334484129: (i)=>[
            i.Position,
            i.XLength,
            i.YLength,
            i.ZLength
        ],
    3649129432: (i)=>[
            i.Operator,
            $3b8da494b8e92f36$var$Labelise(i.FirstOperand),
            $3b8da494b8e92f36$var$Labelise(i.SecondOperand)
        ],
    1260505505: (_)=>[],
    4031249490: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.ElevationOfRefHeight,
            i.ElevationOfTerrain,
            i.BuildingAddress
        ],
    1950629157: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3124254112: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.Elevation
        ],
    2197970202: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2937912522: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Radius,
            i.WallThickness
        ],
    3893394355: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    300633059: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3875453745: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.UsageName,
            i.TemplateType,
            i.HasPropertyTemplates
        ],
    3732776249: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    15328376: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    2510884976: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position)
        ],
    2185764099: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    4105962743: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1525564444: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    2559216714: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity
        ],
    3293443760: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification
        ],
    3895139033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.CostValues,
            i.CostQuantities
        ],
    1419761937: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.Status,
            i.SubmittedOn,
            i.UpdateDate
        ],
    1916426348: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3295246426: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1457835157: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1213902940: (i)=>[
            i.Position,
            i.Radius
        ],
    3256556792: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3849074793: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2963535650: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.LiningDepth,
            i.LiningThickness,
            i.ThresholdDepth,
            i.ThresholdThickness,
            i.TransomThickness,
            i.TransomOffset,
            i.LiningOffset,
            i.ThresholdOffset,
            i.CasingThickness,
            i.CasingDepth,
            i.ShapeAspectStyle,
            i.LiningToPanelOffsetX,
            i.LiningToPanelOffsetY
        ],
    1714330368: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.PanelDepth,
            i.PanelOperation,
            i.PanelWidth,
            i.PanelPosition,
            i.ShapeAspectStyle
        ],
    2323601079: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.OperationType,
            i.ParameterTakesPrecedence == null ? null : {
                type: 3,
                value: i.ParameterTakesPrecedence.value
            },
            i.UserDefinedOperationType
        ],
    445594917: (i)=>[
            i.Name
        ],
    4006246654: (i)=>[
            i.Name
        ],
    1758889154: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    4123344466: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.AssemblyPlace,
            i.PredefinedType
        ],
    2397081782: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1623761950: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2590856083: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1704287377: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.SemiAxis1,
            i.SemiAxis2
        ],
    2107101300: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    132023988: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3174744832: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3390157468: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4148101412: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.PredefinedType,
            i.EventTriggerType,
            i.UserDefinedEventTriggerType,
            i.EventOccurenceTime
        ],
    2853485674: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName
        ],
    807026263: (i)=>[
            i.Outer
        ],
    3737207727: (i)=>[
            i.Outer,
            i.Voids
        ],
    647756555: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2489546625: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2827207264: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2143335405: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1287392070: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3907093117: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3198132628: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3815607619: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1482959167: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1834744321: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1339347760: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2297155007: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3009222698: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1893162501: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    263784265: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1509553395: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3493046030: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3009204131: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.UAxes,
            i.VAxes,
            i.WAxes,
            i.PredefinedType
        ],
    2706460486: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    1251058090: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1806887404: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2571569899: (i)=>[
            i.Points,
            (i.Segments ?? void 0) === void 0 ? null : i.Segments.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.SelfIntersect == null ? null : {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    3946677679: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3113134337: (i)=>[
            i.Curve3D,
            i.AssociatedGeometry,
            i.MasterRepresentation
        ],
    2391368822: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            $3b8da494b8e92f36$var$Labelise(i.Jurisdiction),
            i.ResponsiblePersons,
            i.LastUpdateDate,
            i.CurrentValue,
            i.OriginalValue
        ],
    4288270099: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3827777499: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1051575348: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1161773419: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    377706215: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.NominalDiameter,
            i.NominalLength,
            i.PredefinedType
        ],
    2108223431: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.NominalDiameter,
            i.NominalLength
        ],
    1114901282: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3181161470: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    977012517: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4143007308: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.TheActor),
            i.PredefinedType
        ],
    3588315303: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3079942009: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2837617999: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2382730787: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LifeCyclePhase,
            i.PredefinedType
        ],
    3566463478: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.OperationType,
            i.PanelPosition,
            i.FrameDepth,
            i.FrameThickness,
            i.ShapeAspectStyle
        ],
    3327091369: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.Status,
            i.LongDescription
        ],
    1158309216: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    804291784: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4231323485: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4017108033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2839578677: (i)=>[
            i.Coordinates,
            i.Closed == null ? null : {
                type: 3,
                value: i.Closed.value
            },
            i.Faces,
            i.PnIndex
        ],
    3724593414: (i)=>[
            i.Points
        ],
    3740093272: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    2744685151: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.PredefinedType
        ],
    2904328755: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.Status,
            i.LongDescription
        ],
    3651124850: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1842657554: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2250791053: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2893384427: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2324767716: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1469900589: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    683857671: (i)=>[
            i.UDegree,
            i.VDegree,
            i.ControlPointsList,
            i.SurfaceForm,
            {
                type: 3,
                value: i.UClosed.value
            },
            {
                type: 3,
                value: i.VClosed.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.UMultiplicities,
            i.VMultiplicities,
            i.UKnots,
            i.VKnots,
            i.KnotSpec,
            i.WeightsData
        ],
    3027567501: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade
        ],
    964333572: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2320036040: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.MeshLength,
            i.MeshWidth,
            i.LongitudinalBarNominalDiameter,
            i.TransverseBarNominalDiameter,
            i.LongitudinalBarCrossSectionArea,
            i.TransverseBarCrossSectionArea,
            i.LongitudinalBarSpacing,
            i.TransverseBarSpacing,
            i.PredefinedType
        ],
    2310774935: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.MeshLength,
            i.MeshWidth,
            i.LongitudinalBarNominalDiameter,
            i.TransverseBarNominalDiameter,
            i.LongitudinalBarCrossSectionArea,
            i.TransverseBarCrossSectionArea,
            i.LongitudinalBarSpacing,
            i.TransverseBarSpacing,
            i.BendingShapeCode,
            (i.BendingParameters ?? void 0) === void 0 ? null : i.BendingParameters.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    160246688: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingObject,
            i.RelatedObjects
        ],
    2781568857: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1768891740: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2157484638: (i)=>[
            i.Curve3D,
            i.AssociatedGeometry,
            i.MasterRepresentation
        ],
    4074543187: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4097777520: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.RefLatitude,
            i.RefLongitude,
            i.RefElevation,
            i.LandTitleNumber,
            i.SiteAddress
        ],
    2533589738: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1072016465: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3856911033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.PredefinedType,
            i.ElevationWithFlooring
        ],
    1305183839: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3812236995: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.LongName
        ],
    3112655638: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1039846685: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    338393293: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    682877961: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            }
        ],
    1179482911: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition
        ],
    1004757350: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            },
            i.ProjectedOrTrue,
            i.PredefinedType
        ],
    4243806635: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition,
            i.Axis
        ],
    214636428: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Axis
        ],
    2445595289: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Axis
        ],
    2757150158: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.PredefinedType
        ],
    1807405624: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            },
            i.ProjectedOrTrue,
            i.PredefinedType
        ],
    1252848954: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.ActionType,
            i.ActionSource,
            i.Coefficient,
            i.Purpose
        ],
    2082059205: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            }
        ],
    734778138: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition,
            i.ConditionCoordinateSystem
        ],
    1235345126: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal
        ],
    2986769608: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.TheoryType,
            i.ResultForLoadGroup,
            {
                type: 3,
                value: i.IsLinear.value
            }
        ],
    3657597509: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            },
            i.ProjectedOrTrue,
            i.PredefinedType
        ],
    1975003073: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition
        ],
    148013059: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    3101698114: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2315554128: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2254336722: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    413509423: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    5716631: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3824725483: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.PredefinedType,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.TensionForce,
            i.PreStress,
            i.FrictionCoefficient,
            i.AnchorageSlip,
            i.MinCurvatureRadius
        ],
    2347447852: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.PredefinedType
        ],
    3081323446: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2415094496: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.SheathDiameter
        ],
    1692211062: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1620046519: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3593883385: (i)=>[
            i.BasisCurve,
            $3b8da494b8e92f36$var$Labelise(i.Trim1),
            $3b8da494b8e92f36$var$Labelise(i.Trim2),
            {
                type: 3,
                value: i.SenseAgreement.value
            },
            i.MasterRepresentation
        ],
    1600972822: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1911125066: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    728799441: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2391383451: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3313531582: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2769231204: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    926996030: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1898987631: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1133259667: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4009809668: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.PartitioningType,
            i.ParameterTakesPrecedence == null ? null : {
                type: 3,
                value: i.ParameterTakesPrecedence.value
            },
            i.UserDefinedPartitioningType
        ],
    4088093105: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.WorkingTimes,
            i.ExceptionTimes,
            i.PredefinedType
        ],
    1028945134: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.CreationDate,
            i.Creators,
            i.Purpose,
            i.Duration,
            i.TotalFloat,
            i.StartTime,
            i.FinishTime
        ],
    4218914973: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.CreationDate,
            i.Creators,
            i.Purpose,
            i.Duration,
            i.TotalFloat,
            i.StartTime,
            i.FinishTime,
            i.PredefinedType
        ],
    3342526732: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.CreationDate,
            i.Creators,
            i.Purpose,
            i.Duration,
            i.TotalFloat,
            i.StartTime,
            i.FinishTime,
            i.PredefinedType
        ],
    1033361043: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName
        ],
    3821786052: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.Status,
            i.LongDescription
        ],
    1411407467: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3352864051: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1871374353: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3460190687: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.OriginalValue,
            i.CurrentValue,
            i.TotalReplacementCost,
            $3b8da494b8e92f36$var$Labelise(i.Owner),
            $3b8da494b8e92f36$var$Labelise(i.User),
            i.ResponsiblePerson,
            i.IncorporationDate,
            i.DepreciatedValue
        ],
    1532957894: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1967976161: (i)=>[
            i.Degree,
            i.ControlPointsList,
            i.CurveForm,
            {
                type: 3,
                value: i.ClosedCurve.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    2461110595: (i)=>[
            i.Degree,
            i.ControlPointsList,
            i.CurveForm,
            {
                type: 3,
                value: i.ClosedCurve.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.KnotMultiplicities,
            i.Knots,
            i.KnotSpec
        ],
    819618141: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    231477066: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1136057603: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    3299480353: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2979338954: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    39481116: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1095909175: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1909888760: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1177604601: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.LongName
        ],
    2188180465: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    395041908: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3293546465: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2674252688: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1285652485: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2951183804: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3296154744: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2611217952: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.Radius
        ],
    1677625105: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2301859152: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    843113511: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    905975707: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    400855858: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3850581409: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2816379211: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3898045240: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1060000209: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    488727124: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    335055490: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2954562838: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1973544240: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3495092785: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3961806047: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1335981549: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2635815018: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1599208980: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2063403501: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1945004755: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3040386961: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3041715199: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.FlowDirection,
            i.PredefinedType,
            i.SystemType
        ],
    3205830791: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.PredefinedType
        ],
    395920057: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.OverallHeight,
            i.OverallWidth,
            i.PredefinedType,
            i.OperationType,
            i.UserDefinedOperationType
        ],
    3242481149: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.OverallHeight,
            i.OverallWidth,
            i.PredefinedType,
            i.OperationType,
            i.UserDefinedOperationType
        ],
    869906466: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3760055223: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2030761528: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    663422040: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2417008758: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3277789161: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1534661035: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1217240411: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    712377611: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1658829314: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2814081492: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3747195512: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    484807127: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1209101575: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.PredefinedType
        ],
    346874300: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1810631287: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4222183408: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2058353004: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    4278956645: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    4037862832: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2188021234: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3132237377: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    987401354: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    707683696: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2223149337: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3508470533: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    900683007: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3319311131: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2068733104: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4175244083: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2176052936: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    76236018: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    629592764: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1437502449: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1073191201: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1911478936: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2474470126: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    144952367: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    3694346114: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1687234759: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType,
            i.ConstructionType
        ],
    310824031: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3612865200: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3171933400: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1156407060: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    738039164: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    655969474: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    90941305: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2262370178: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3024970846: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3283111854: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1232101972: (i)=>[
            i.Degree,
            i.ControlPointsList,
            i.CurveForm,
            {
                type: 3,
                value: i.ClosedCurve.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.KnotMultiplicities,
            i.Knots,
            i.KnotSpec,
            i.WeightsData
        ],
    979691226: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.BarLength,
            i.PredefinedType,
            i.BarSurface
        ],
    2572171363: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.BarLength,
            i.BarSurface,
            i.BendingShapeCode,
            (i.BendingParameters ?? void 0) === void 0 ? null : i.BendingParameters.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    2016517767: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3053780830: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1783015770: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1329646415: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1529196076: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3127900445: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3027962421: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3420628829: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1999602285: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1404847402: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    331165859: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4252922144: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.NumberOfRisers,
            i.NumberOfTreads,
            i.RiserHeight,
            i.TreadLength,
            i.PredefinedType
        ],
    2515109513: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.OrientationOf2DPlane,
            i.LoadedBy,
            i.HasResults,
            i.SharedPlacement
        ],
    385403989: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.ActionType,
            i.ActionSource,
            i.Coefficient,
            i.Purpose,
            i.SelfWeightCoefficients
        ],
    1621171031: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            },
            i.ProjectedOrTrue,
            i.PredefinedType
        ],
    1162798199: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    812556717: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3825984169: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3026737570: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3179687236: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4292641817: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4207607924: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2391406946: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4156078855: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3512223829: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4237592921: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3304561284: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.OverallHeight,
            i.OverallWidth,
            i.PredefinedType,
            i.PartitioningType,
            i.UserDefinedPartitioningType
        ],
    486154966: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.OverallHeight,
            i.OverallWidth,
            i.PredefinedType,
            i.PartitioningType,
            i.UserDefinedPartitioningType
        ],
    2874132201: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1634111441: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    177149247: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2056796094: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3001207471: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    277319702: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    753842376: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2906023776: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    32344328: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2938176219: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    635142910: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3758799889: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1051757585: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4217484030: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3902619387: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    639361253: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3221913625: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3571504051: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2272882330: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    578613899: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4136498852: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3640358203: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4074379575: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1052013943: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    562808652: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.PredefinedType
        ],
    1062813311: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    342316401: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3518393246: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1360408905: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1904799276: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    862014818: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3310460725: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    264262732: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    402227799: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1003880860: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3415622556: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    819412036: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1426591983: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    182646315: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2295281155: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4086658281: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    630975310: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4288193352: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3087945054: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    25142252: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ]
};
$3b8da494b8e92f36$export$9d063d2e6222d3e2[2] = {
    3699917729: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAbsorbedDoseMeasure(v),
    4182062534: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAccelerationMeasure(v),
    360377573: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAmountOfSubstanceMeasure(v),
    632304761: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAngularVelocityMeasure(v),
    3683503648: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcArcIndex(v.map((x)=>x.value)),
    1500781891: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaDensityMeasure(v),
    2650437152: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcAreaMeasure(v),
    2314439260: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBinary(v),
    2735952531: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoolean(v),
    1867003952: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcBoxAlignment(v),
    1683019596: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCardinalPointReference(v),
    2991860651: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcComplexNumber(v.map((x)=>x.value)),
    3812528620: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCompoundPlaneAngleMeasure(v.map((x)=>x.value)),
    3238673880: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcContextDependentMeasure(v),
    1778710042: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCountMeasure(v),
    94842927: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcCurvatureMeasure(v),
    937566702: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDate(v),
    2195413836: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDateTime(v),
    86635668: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDayInMonthNumber(v),
    3701338814: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDayInWeekNumber(v),
    1514641115: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDescriptiveMeasure(v),
    4134073009: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDimensionCount(v),
    524656162: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDoseEquivalentMeasure(v),
    2541165894: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDuration(v),
    69416015: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcDynamicViscosityMeasure(v),
    1827137117: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricCapacitanceMeasure(v),
    3818826038: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricChargeMeasure(v),
    2093906313: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricConductanceMeasure(v),
    3790457270: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricCurrentMeasure(v),
    2951915441: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricResistanceMeasure(v),
    2506197118: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcElectricVoltageMeasure(v),
    2078135608: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcEnergyMeasure(v),
    1102727119: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFontStyle(v),
    2715512545: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFontVariant(v),
    2590844177: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFontWeight(v),
    1361398929: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcForceMeasure(v),
    3044325142: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcFrequencyMeasure(v),
    3064340077: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcGloballyUniqueId(v),
    3113092358: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHeatFluxDensityMeasure(v),
    1158859006: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcHeatingValueMeasure(v),
    983778844: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIdentifier(v),
    3358199106: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIlluminanceMeasure(v),
    2679005408: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInductanceMeasure(v),
    1939436016: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcInteger(v),
    3809634241: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIntegerCountRateMeasure(v),
    3686016028: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIonConcentrationMeasure(v),
    3192672207: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcIsothermalMoistureCapacityMeasure(v),
    2054016361: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcKinematicViscosityMeasure(v),
    3258342251: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLabel(v),
    1275358634: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLanguageId(v),
    1243674935: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLengthMeasure(v),
    1774176899: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLineIndex(v.map((x)=>x.value)),
    191860431: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearForceMeasure(v),
    2128979029: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearMomentMeasure(v),
    1307019551: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearStiffnessMeasure(v),
    3086160713: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLinearVelocityMeasure(v),
    503418787: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLogical(v),
    2095003142: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLuminousFluxMeasure(v),
    2755797622: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLuminousIntensityDistributionMeasure(v),
    151039812: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcLuminousIntensityMeasure(v),
    286949696: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMagneticFluxDensityMeasure(v),
    2486716878: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMagneticFluxMeasure(v),
    1477762836: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMassDensityMeasure(v),
    4017473158: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMassFlowRateMeasure(v),
    3124614049: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMassMeasure(v),
    3531705166: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMassPerLengthMeasure(v),
    3341486342: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcModulusOfElasticityMeasure(v),
    2173214787: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcModulusOfLinearSubgradeReactionMeasure(v),
    1052454078: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcModulusOfRotationalSubgradeReactionMeasure(v),
    1753493141: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcModulusOfSubgradeReactionMeasure(v),
    3177669450: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMoistureDiffusivityMeasure(v),
    1648970520: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMolecularWeightMeasure(v),
    3114022597: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMomentOfInertiaMeasure(v),
    2615040989: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMonetaryMeasure(v),
    765770214: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcMonthInYearNumber(v),
    525895558: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNonNegativeLengthMeasure(v),
    2095195183: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNormalisedRatioMeasure(v),
    2395907400: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcNumericMeasure(v),
    929793134: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPHMeasure(v),
    2260317790: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcParameterValue(v),
    2642773653: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlanarForceMeasure(v),
    4042175685: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPlaneAngleMeasure(v),
    1790229001: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveInteger(v),
    2815919920: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveLengthMeasure(v),
    3054510233: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositivePlaneAngleMeasure(v),
    1245737093: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPositiveRatioMeasure(v),
    1364037233: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPowerMeasure(v),
    2169031380: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPresentableText(v),
    3665567075: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPressureMeasure(v),
    2798247006: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcPropertySetDefinitionSet(v.map((x)=>x.value)),
    3972513137: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRadioActivityMeasure(v),
    96294661: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRatioMeasure(v),
    200335297: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcReal(v),
    2133746277: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRotationalFrequencyMeasure(v),
    1755127002: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRotationalMassMeasure(v),
    3211557302: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcRotationalStiffnessMeasure(v),
    3467162246: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSectionModulusMeasure(v),
    2190458107: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSectionalAreaIntegralMeasure(v),
    408310005: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcShearModulusMeasure(v),
    3471399674: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSolidAngleMeasure(v),
    4157543285: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSoundPowerLevelMeasure(v),
    846465480: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSoundPowerMeasure(v),
    3457685358: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSoundPressureLevelMeasure(v),
    993287707: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSoundPressureMeasure(v),
    3477203348: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpecificHeatCapacityMeasure(v),
    2757832317: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpecularExponent(v),
    361837227: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcSpecularRoughness(v),
    58845555: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTemperatureGradientMeasure(v),
    1209108979: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTemperatureRateOfChangeMeasure(v),
    2801250643: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcText(v),
    1460886941: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextAlignment(v),
    3490877962: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextDecoration(v),
    603696268: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextFontName(v),
    296282323: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTextTransformation(v),
    232962298: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermalAdmittanceMeasure(v),
    2645777649: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermalConductivityMeasure(v),
    2281867870: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermalExpansionCoefficientMeasure(v),
    857959152: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermalResistanceMeasure(v),
    2016195849: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermalTransmittanceMeasure(v),
    743184107: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcThermodynamicTemperatureMeasure(v),
    4075327185: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTime(v),
    2726807636: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeMeasure(v),
    2591213694: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTimeStamp(v),
    1278329552: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcTorqueMeasure(v),
    950732822: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcURIReference(v),
    3345633955: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVaporPermeabilityMeasure(v),
    3458127941: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVolumeMeasure(v),
    2593997549: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcVolumetricFlowRateMeasure(v),
    51269191: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWarpingConstantMeasure(v),
    1718600412: (v)=>new $3b8da494b8e92f36$export$8167db95e5b199ea.IfcWarpingMomentMeasure(v)
};
var $3b8da494b8e92f36$export$8167db95e5b199ea;
((IFC42)=>{
    class IfcAbsorbedDoseMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCABSORBEDDOSEMEASURE";
        }
    }
    IFC42.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;
    class IfcAccelerationMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCACCELERATIONMEASURE";
        }
    }
    IFC42.IfcAccelerationMeasure = IfcAccelerationMeasure;
    class IfcAmountOfSubstanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCAMOUNTOFSUBSTANCEMEASURE";
        }
    }
    IFC42.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;
    class IfcAngularVelocityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCANGULARVELOCITYMEASURE";
        }
    }
    IFC42.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;
    class IfcArcIndex {
        constructor(value){
            this.value = value;
            this.type = 5;
        }
    }
    IFC42.IfcArcIndex = IfcArcIndex;
    class IfcAreaDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCAREADENSITYMEASURE";
        }
    }
    IFC42.IfcAreaDensityMeasure = IfcAreaDensityMeasure;
    class IfcAreaMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCAREAMEASURE";
        }
    }
    IFC42.IfcAreaMeasure = IfcAreaMeasure;
    class IfcBinary extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCBINARY";
        }
    }
    IFC42.IfcBinary = IfcBinary;
    class IfcBoolean {
        constructor(v){
            this.type = 3;
            this.name = "IFCBOOLEAN";
            this.value = v;
        }
    }
    IFC42.IfcBoolean = IfcBoolean;
    class IfcBoxAlignment {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCBOXALIGNMENT";
        }
    }
    IFC42.IfcBoxAlignment = IfcBoxAlignment;
    class IfcCardinalPointReference extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCCARDINALPOINTREFERENCE";
        }
    }
    IFC42.IfcCardinalPointReference = IfcCardinalPointReference;
    class IfcComplexNumber {
        constructor(value){
            this.value = value;
            this.type = 4;
        }
    }
    IFC42.IfcComplexNumber = IfcComplexNumber;
    class IfcCompoundPlaneAngleMeasure {
        constructor(value){
            this.value = value;
            this.type = 10;
        }
    }
    IFC42.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;
    class IfcContextDependentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCCONTEXTDEPENDENTMEASURE";
        }
    }
    IFC42.IfcContextDependentMeasure = IfcContextDependentMeasure;
    class IfcCountMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCCOUNTMEASURE";
        }
    }
    IFC42.IfcCountMeasure = IfcCountMeasure;
    class IfcCurvatureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCCURVATUREMEASURE";
        }
    }
    IFC42.IfcCurvatureMeasure = IfcCurvatureMeasure;
    class IfcDate {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCDATE";
        }
    }
    IFC42.IfcDate = IfcDate;
    class IfcDateTime {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCDATETIME";
        }
    }
    IFC42.IfcDateTime = IfcDateTime;
    class IfcDayInMonthNumber extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCDAYINMONTHNUMBER";
        }
    }
    IFC42.IfcDayInMonthNumber = IfcDayInMonthNumber;
    class IfcDayInWeekNumber extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCDAYINWEEKNUMBER";
        }
    }
    IFC42.IfcDayInWeekNumber = IfcDayInWeekNumber;
    class IfcDescriptiveMeasure {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCDESCRIPTIVEMEASURE";
        }
    }
    IFC42.IfcDescriptiveMeasure = IfcDescriptiveMeasure;
    class IfcDimensionCount extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCDIMENSIONCOUNT";
        }
    }
    IFC42.IfcDimensionCount = IfcDimensionCount;
    class IfcDoseEquivalentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCDOSEEQUIVALENTMEASURE";
        }
    }
    IFC42.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;
    class IfcDuration {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCDURATION";
        }
    }
    IFC42.IfcDuration = IfcDuration;
    class IfcDynamicViscosityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCDYNAMICVISCOSITYMEASURE";
        }
    }
    IFC42.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;
    class IfcElectricCapacitanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCAPACITANCEMEASURE";
        }
    }
    IFC42.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;
    class IfcElectricChargeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCHARGEMEASURE";
        }
    }
    IFC42.IfcElectricChargeMeasure = IfcElectricChargeMeasure;
    class IfcElectricConductanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCONDUCTANCEMEASURE";
        }
    }
    IFC42.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;
    class IfcElectricCurrentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCURRENTMEASURE";
        }
    }
    IFC42.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;
    class IfcElectricResistanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICRESISTANCEMEASURE";
        }
    }
    IFC42.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;
    class IfcElectricVoltageMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICVOLTAGEMEASURE";
        }
    }
    IFC42.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;
    class IfcEnergyMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCENERGYMEASURE";
        }
    }
    IFC42.IfcEnergyMeasure = IfcEnergyMeasure;
    class IfcFontStyle {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCFONTSTYLE";
        }
    }
    IFC42.IfcFontStyle = IfcFontStyle;
    class IfcFontVariant {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCFONTVARIANT";
        }
    }
    IFC42.IfcFontVariant = IfcFontVariant;
    class IfcFontWeight {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCFONTWEIGHT";
        }
    }
    IFC42.IfcFontWeight = IfcFontWeight;
    class IfcForceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCFORCEMEASURE";
        }
    }
    IFC42.IfcForceMeasure = IfcForceMeasure;
    class IfcFrequencyMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCFREQUENCYMEASURE";
        }
    }
    IFC42.IfcFrequencyMeasure = IfcFrequencyMeasure;
    class IfcGloballyUniqueId {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCGLOBALLYUNIQUEID";
        }
    }
    IFC42.IfcGloballyUniqueId = IfcGloballyUniqueId;
    class IfcHeatFluxDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCHEATFLUXDENSITYMEASURE";
        }
    }
    IFC42.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;
    class IfcHeatingValueMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCHEATINGVALUEMEASURE";
        }
    }
    IFC42.IfcHeatingValueMeasure = IfcHeatingValueMeasure;
    class IfcIdentifier {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCIDENTIFIER";
        }
    }
    IFC42.IfcIdentifier = IfcIdentifier;
    class IfcIlluminanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCILLUMINANCEMEASURE";
        }
    }
    IFC42.IfcIlluminanceMeasure = IfcIlluminanceMeasure;
    class IfcInductanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCINDUCTANCEMEASURE";
        }
    }
    IFC42.IfcInductanceMeasure = IfcInductanceMeasure;
    class IfcInteger extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCINTEGER";
        }
    }
    IFC42.IfcInteger = IfcInteger;
    class IfcIntegerCountRateMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCINTEGERCOUNTRATEMEASURE";
        }
    }
    IFC42.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;
    class IfcIonConcentrationMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCIONCONCENTRATIONMEASURE";
        }
    }
    IFC42.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;
    class IfcIsothermalMoistureCapacityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCISOTHERMALMOISTURECAPACITYMEASURE";
        }
    }
    IFC42.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;
    class IfcKinematicViscosityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCKINEMATICVISCOSITYMEASURE";
        }
    }
    IFC42.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;
    class IfcLabel {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCLABEL";
        }
    }
    IFC42.IfcLabel = IfcLabel;
    class IfcLanguageId {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCLANGUAGEID";
        }
    }
    IFC42.IfcLanguageId = IfcLanguageId;
    class IfcLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLENGTHMEASURE";
        }
    }
    IFC42.IfcLengthMeasure = IfcLengthMeasure;
    class IfcLineIndex {
        constructor(value){
            this.value = value;
            this.type = 5;
        }
    }
    IFC42.IfcLineIndex = IfcLineIndex;
    class IfcLinearForceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARFORCEMEASURE";
        }
    }
    IFC42.IfcLinearForceMeasure = IfcLinearForceMeasure;
    class IfcLinearMomentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARMOMENTMEASURE";
        }
    }
    IFC42.IfcLinearMomentMeasure = IfcLinearMomentMeasure;
    class IfcLinearStiffnessMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARSTIFFNESSMEASURE";
        }
    }
    IFC42.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;
    class IfcLinearVelocityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARVELOCITYMEASURE";
        }
    }
    IFC42.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;
    class IfcLogical {
        constructor(v){
            this.type = 3;
            this.name = "IFCLOGICAL";
            this.value = v;
        }
    }
    IFC42.IfcLogical = IfcLogical;
    class IfcLuminousFluxMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLUMINOUSFLUXMEASURE";
        }
    }
    IFC42.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;
    class IfcLuminousIntensityDistributionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE";
        }
    }
    IFC42.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;
    class IfcLuminousIntensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLUMINOUSINTENSITYMEASURE";
        }
    }
    IFC42.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;
    class IfcMagneticFluxDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMAGNETICFLUXDENSITYMEASURE";
        }
    }
    IFC42.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;
    class IfcMagneticFluxMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMAGNETICFLUXMEASURE";
        }
    }
    IFC42.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;
    class IfcMassDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSDENSITYMEASURE";
        }
    }
    IFC42.IfcMassDensityMeasure = IfcMassDensityMeasure;
    class IfcMassFlowRateMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSFLOWRATEMEASURE";
        }
    }
    IFC42.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;
    class IfcMassMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSMEASURE";
        }
    }
    IFC42.IfcMassMeasure = IfcMassMeasure;
    class IfcMassPerLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSPERLENGTHMEASURE";
        }
    }
    IFC42.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;
    class IfcModulusOfElasticityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFELASTICITYMEASURE";
        }
    }
    IFC42.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;
    class IfcModulusOfLinearSubgradeReactionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE";
        }
    }
    IFC42.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;
    class IfcModulusOfRotationalSubgradeReactionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE";
        }
    }
    IFC42.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;
    class IfcModulusOfSubgradeReactionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFSUBGRADEREACTIONMEASURE";
        }
    }
    IFC42.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;
    class IfcMoistureDiffusivityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMOISTUREDIFFUSIVITYMEASURE";
        }
    }
    IFC42.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;
    class IfcMolecularWeightMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMOLECULARWEIGHTMEASURE";
        }
    }
    IFC42.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;
    class IfcMomentOfInertiaMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMOMENTOFINERTIAMEASURE";
        }
    }
    IFC42.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;
    class IfcMonetaryMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMONETARYMEASURE";
        }
    }
    IFC42.IfcMonetaryMeasure = IfcMonetaryMeasure;
    class IfcMonthInYearNumber extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCMONTHINYEARNUMBER";
        }
    }
    IFC42.IfcMonthInYearNumber = IfcMonthInYearNumber;
    class IfcNonNegativeLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCNONNEGATIVELENGTHMEASURE";
        }
    }
    IFC42.IfcNonNegativeLengthMeasure = IfcNonNegativeLengthMeasure;
    class IfcNormalisedRatioMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCNORMALISEDRATIOMEASURE";
        }
    }
    IFC42.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;
    class IfcNumericMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCNUMERICMEASURE";
        }
    }
    IFC42.IfcNumericMeasure = IfcNumericMeasure;
    class IfcPHMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPHMEASURE";
        }
    }
    IFC42.IfcPHMeasure = IfcPHMeasure;
    class IfcParameterValue extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPARAMETERVALUE";
        }
    }
    IFC42.IfcParameterValue = IfcParameterValue;
    class IfcPlanarForceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPLANARFORCEMEASURE";
        }
    }
    IFC42.IfcPlanarForceMeasure = IfcPlanarForceMeasure;
    class IfcPlaneAngleMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPLANEANGLEMEASURE";
        }
    }
    IFC42.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;
    class IfcPositiveInteger extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCPOSITIVEINTEGER";
        }
    }
    IFC42.IfcPositiveInteger = IfcPositiveInteger;
    class IfcPositiveLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOSITIVELENGTHMEASURE";
        }
    }
    IFC42.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;
    class IfcPositivePlaneAngleMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOSITIVEPLANEANGLEMEASURE";
        }
    }
    IFC42.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;
    class IfcPositiveRatioMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOSITIVERATIOMEASURE";
        }
    }
    IFC42.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;
    class IfcPowerMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOWERMEASURE";
        }
    }
    IFC42.IfcPowerMeasure = IfcPowerMeasure;
    class IfcPresentableText {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCPRESENTABLETEXT";
        }
    }
    IFC42.IfcPresentableText = IfcPresentableText;
    class IfcPressureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPRESSUREMEASURE";
        }
    }
    IFC42.IfcPressureMeasure = IfcPressureMeasure;
    class IfcPropertySetDefinitionSet {
        constructor(value){
            this.value = value;
            this.type = 5;
        }
    }
    IFC42.IfcPropertySetDefinitionSet = IfcPropertySetDefinitionSet;
    class IfcRadioActivityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCRADIOACTIVITYMEASURE";
        }
    }
    IFC42.IfcRadioActivityMeasure = IfcRadioActivityMeasure;
    class IfcRatioMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCRATIOMEASURE";
        }
    }
    IFC42.IfcRatioMeasure = IfcRatioMeasure;
    class IfcReal extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCREAL";
        }
    }
    IFC42.IfcReal = IfcReal;
    class IfcRotationalFrequencyMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCROTATIONALFREQUENCYMEASURE";
        }
    }
    IFC42.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;
    class IfcRotationalMassMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCROTATIONALMASSMEASURE";
        }
    }
    IFC42.IfcRotationalMassMeasure = IfcRotationalMassMeasure;
    class IfcRotationalStiffnessMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCROTATIONALSTIFFNESSMEASURE";
        }
    }
    IFC42.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;
    class IfcSectionModulusMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSECTIONMODULUSMEASURE";
        }
    }
    IFC42.IfcSectionModulusMeasure = IfcSectionModulusMeasure;
    class IfcSectionalAreaIntegralMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSECTIONALAREAINTEGRALMEASURE";
        }
    }
    IFC42.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;
    class IfcShearModulusMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSHEARMODULUSMEASURE";
        }
    }
    IFC42.IfcShearModulusMeasure = IfcShearModulusMeasure;
    class IfcSolidAngleMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOLIDANGLEMEASURE";
        }
    }
    IFC42.IfcSolidAngleMeasure = IfcSolidAngleMeasure;
    class IfcSoundPowerLevelMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPOWERLEVELMEASURE";
        }
    }
    IFC42.IfcSoundPowerLevelMeasure = IfcSoundPowerLevelMeasure;
    class IfcSoundPowerMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPOWERMEASURE";
        }
    }
    IFC42.IfcSoundPowerMeasure = IfcSoundPowerMeasure;
    class IfcSoundPressureLevelMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPRESSURELEVELMEASURE";
        }
    }
    IFC42.IfcSoundPressureLevelMeasure = IfcSoundPressureLevelMeasure;
    class IfcSoundPressureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPRESSUREMEASURE";
        }
    }
    IFC42.IfcSoundPressureMeasure = IfcSoundPressureMeasure;
    class IfcSpecificHeatCapacityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSPECIFICHEATCAPACITYMEASURE";
        }
    }
    IFC42.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;
    class IfcSpecularExponent extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSPECULAREXPONENT";
        }
    }
    IFC42.IfcSpecularExponent = IfcSpecularExponent;
    class IfcSpecularRoughness extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSPECULARROUGHNESS";
        }
    }
    IFC42.IfcSpecularRoughness = IfcSpecularRoughness;
    class IfcTemperatureGradientMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTEMPERATUREGRADIENTMEASURE";
        }
    }
    IFC42.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;
    class IfcTemperatureRateOfChangeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTEMPERATURERATEOFCHANGEMEASURE";
        }
    }
    IFC42.IfcTemperatureRateOfChangeMeasure = IfcTemperatureRateOfChangeMeasure;
    class IfcText {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXT";
        }
    }
    IFC42.IfcText = IfcText;
    class IfcTextAlignment {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTALIGNMENT";
        }
    }
    IFC42.IfcTextAlignment = IfcTextAlignment;
    class IfcTextDecoration {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTDECORATION";
        }
    }
    IFC42.IfcTextDecoration = IfcTextDecoration;
    class IfcTextFontName {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTFONTNAME";
        }
    }
    IFC42.IfcTextFontName = IfcTextFontName;
    class IfcTextTransformation {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTTRANSFORMATION";
        }
    }
    IFC42.IfcTextTransformation = IfcTextTransformation;
    class IfcThermalAdmittanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALADMITTANCEMEASURE";
        }
    }
    IFC42.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;
    class IfcThermalConductivityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALCONDUCTIVITYMEASURE";
        }
    }
    IFC42.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;
    class IfcThermalExpansionCoefficientMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE";
        }
    }
    IFC42.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;
    class IfcThermalResistanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALRESISTANCEMEASURE";
        }
    }
    IFC42.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;
    class IfcThermalTransmittanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALTRANSMITTANCEMEASURE";
        }
    }
    IFC42.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;
    class IfcThermodynamicTemperatureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMODYNAMICTEMPERATUREMEASURE";
        }
    }
    IFC42.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;
    class IfcTime {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTIME";
        }
    }
    IFC42.IfcTime = IfcTime;
    class IfcTimeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTIMEMEASURE";
        }
    }
    IFC42.IfcTimeMeasure = IfcTimeMeasure;
    class IfcTimeStamp extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCTIMESTAMP";
        }
    }
    IFC42.IfcTimeStamp = IfcTimeStamp;
    class IfcTorqueMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTORQUEMEASURE";
        }
    }
    IFC42.IfcTorqueMeasure = IfcTorqueMeasure;
    class IfcURIReference {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCURIREFERENCE";
        }
    }
    IFC42.IfcURIReference = IfcURIReference;
    class IfcVaporPermeabilityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCVAPORPERMEABILITYMEASURE";
        }
    }
    IFC42.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;
    class IfcVolumeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCVOLUMEMEASURE";
        }
    }
    IFC42.IfcVolumeMeasure = IfcVolumeMeasure;
    class IfcVolumetricFlowRateMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCVOLUMETRICFLOWRATEMEASURE";
        }
    }
    IFC42.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;
    class IfcWarpingConstantMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCWARPINGCONSTANTMEASURE";
        }
    }
    IFC42.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;
    class IfcWarpingMomentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCWARPINGMOMENTMEASURE";
        }
    }
    IFC42.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;
    class IfcActionRequestTypeEnum {
        static{
            this.EMAIL = {
                type: 3,
                value: "EMAIL"
            };
        }
        static{
            this.FAX = {
                type: 3,
                value: "FAX"
            };
        }
        static{
            this.PHONE = {
                type: 3,
                value: "PHONE"
            };
        }
        static{
            this.POST = {
                type: 3,
                value: "POST"
            };
        }
        static{
            this.VERBAL = {
                type: 3,
                value: "VERBAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcActionRequestTypeEnum = IfcActionRequestTypeEnum;
    class IfcActionSourceTypeEnum {
        static{
            this.DEAD_LOAD_G = {
                type: 3,
                value: "DEAD_LOAD_G"
            };
        }
        static{
            this.COMPLETION_G1 = {
                type: 3,
                value: "COMPLETION_G1"
            };
        }
        static{
            this.LIVE_LOAD_Q = {
                type: 3,
                value: "LIVE_LOAD_Q"
            };
        }
        static{
            this.SNOW_S = {
                type: 3,
                value: "SNOW_S"
            };
        }
        static{
            this.WIND_W = {
                type: 3,
                value: "WIND_W"
            };
        }
        static{
            this.PRESTRESSING_P = {
                type: 3,
                value: "PRESTRESSING_P"
            };
        }
        static{
            this.SETTLEMENT_U = {
                type: 3,
                value: "SETTLEMENT_U"
            };
        }
        static{
            this.TEMPERATURE_T = {
                type: 3,
                value: "TEMPERATURE_T"
            };
        }
        static{
            this.EARTHQUAKE_E = {
                type: 3,
                value: "EARTHQUAKE_E"
            };
        }
        static{
            this.FIRE = {
                type: 3,
                value: "FIRE"
            };
        }
        static{
            this.IMPULSE = {
                type: 3,
                value: "IMPULSE"
            };
        }
        static{
            this.IMPACT = {
                type: 3,
                value: "IMPACT"
            };
        }
        static{
            this.TRANSPORT = {
                type: 3,
                value: "TRANSPORT"
            };
        }
        static{
            this.ERECTION = {
                type: 3,
                value: "ERECTION"
            };
        }
        static{
            this.PROPPING = {
                type: 3,
                value: "PROPPING"
            };
        }
        static{
            this.SYSTEM_IMPERFECTION = {
                type: 3,
                value: "SYSTEM_IMPERFECTION"
            };
        }
        static{
            this.SHRINKAGE = {
                type: 3,
                value: "SHRINKAGE"
            };
        }
        static{
            this.CREEP = {
                type: 3,
                value: "CREEP"
            };
        }
        static{
            this.LACK_OF_FIT = {
                type: 3,
                value: "LACK_OF_FIT"
            };
        }
        static{
            this.BUOYANCY = {
                type: 3,
                value: "BUOYANCY"
            };
        }
        static{
            this.ICE = {
                type: 3,
                value: "ICE"
            };
        }
        static{
            this.CURRENT = {
                type: 3,
                value: "CURRENT"
            };
        }
        static{
            this.WAVE = {
                type: 3,
                value: "WAVE"
            };
        }
        static{
            this.RAIN = {
                type: 3,
                value: "RAIN"
            };
        }
        static{
            this.BRAKES = {
                type: 3,
                value: "BRAKES"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;
    class IfcActionTypeEnum {
        static{
            this.PERMANENT_G = {
                type: 3,
                value: "PERMANENT_G"
            };
        }
        static{
            this.VARIABLE_Q = {
                type: 3,
                value: "VARIABLE_Q"
            };
        }
        static{
            this.EXTRAORDINARY_A = {
                type: 3,
                value: "EXTRAORDINARY_A"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcActionTypeEnum = IfcActionTypeEnum;
    class IfcActuatorTypeEnum {
        static{
            this.ELECTRICACTUATOR = {
                type: 3,
                value: "ELECTRICACTUATOR"
            };
        }
        static{
            this.HANDOPERATEDACTUATOR = {
                type: 3,
                value: "HANDOPERATEDACTUATOR"
            };
        }
        static{
            this.HYDRAULICACTUATOR = {
                type: 3,
                value: "HYDRAULICACTUATOR"
            };
        }
        static{
            this.PNEUMATICACTUATOR = {
                type: 3,
                value: "PNEUMATICACTUATOR"
            };
        }
        static{
            this.THERMOSTATICACTUATOR = {
                type: 3,
                value: "THERMOSTATICACTUATOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcActuatorTypeEnum = IfcActuatorTypeEnum;
    class IfcAddressTypeEnum {
        static{
            this.OFFICE = {
                type: 3,
                value: "OFFICE"
            };
        }
        static{
            this.SITE = {
                type: 3,
                value: "SITE"
            };
        }
        static{
            this.HOME = {
                type: 3,
                value: "HOME"
            };
        }
        static{
            this.DISTRIBUTIONPOINT = {
                type: 3,
                value: "DISTRIBUTIONPOINT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC42.IfcAddressTypeEnum = IfcAddressTypeEnum;
    class IfcAirTerminalBoxTypeEnum {
        static{
            this.CONSTANTFLOW = {
                type: 3,
                value: "CONSTANTFLOW"
            };
        }
        static{
            this.VARIABLEFLOWPRESSUREDEPENDANT = {
                type: 3,
                value: "VARIABLEFLOWPRESSUREDEPENDANT"
            };
        }
        static{
            this.VARIABLEFLOWPRESSUREINDEPENDANT = {
                type: 3,
                value: "VARIABLEFLOWPRESSUREINDEPENDANT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;
    class IfcAirTerminalTypeEnum {
        static{
            this.DIFFUSER = {
                type: 3,
                value: "DIFFUSER"
            };
        }
        static{
            this.GRILLE = {
                type: 3,
                value: "GRILLE"
            };
        }
        static{
            this.LOUVRE = {
                type: 3,
                value: "LOUVRE"
            };
        }
        static{
            this.REGISTER = {
                type: 3,
                value: "REGISTER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;
    class IfcAirToAirHeatRecoveryTypeEnum {
        static{
            this.FIXEDPLATECOUNTERFLOWEXCHANGER = {
                type: 3,
                value: "FIXEDPLATECOUNTERFLOWEXCHANGER"
            };
        }
        static{
            this.FIXEDPLATECROSSFLOWEXCHANGER = {
                type: 3,
                value: "FIXEDPLATECROSSFLOWEXCHANGER"
            };
        }
        static{
            this.FIXEDPLATEPARALLELFLOWEXCHANGER = {
                type: 3,
                value: "FIXEDPLATEPARALLELFLOWEXCHANGER"
            };
        }
        static{
            this.ROTARYWHEEL = {
                type: 3,
                value: "ROTARYWHEEL"
            };
        }
        static{
            this.RUNAROUNDCOILLOOP = {
                type: 3,
                value: "RUNAROUNDCOILLOOP"
            };
        }
        static{
            this.HEATPIPE = {
                type: 3,
                value: "HEATPIPE"
            };
        }
        static{
            this.TWINTOWERENTHALPYRECOVERYLOOPS = {
                type: 3,
                value: "TWINTOWERENTHALPYRECOVERYLOOPS"
            };
        }
        static{
            this.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = {
                type: 3,
                value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS"
            };
        }
        static{
            this.THERMOSIPHONCOILTYPEHEATEXCHANGERS = {
                type: 3,
                value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;
    class IfcAlarmTypeEnum {
        static{
            this.BELL = {
                type: 3,
                value: "BELL"
            };
        }
        static{
            this.BREAKGLASSBUTTON = {
                type: 3,
                value: "BREAKGLASSBUTTON"
            };
        }
        static{
            this.LIGHT = {
                type: 3,
                value: "LIGHT"
            };
        }
        static{
            this.MANUALPULLBOX = {
                type: 3,
                value: "MANUALPULLBOX"
            };
        }
        static{
            this.SIREN = {
                type: 3,
                value: "SIREN"
            };
        }
        static{
            this.WHISTLE = {
                type: 3,
                value: "WHISTLE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcAlarmTypeEnum = IfcAlarmTypeEnum;
    class IfcAnalysisModelTypeEnum {
        static{
            this.IN_PLANE_LOADING_2D = {
                type: 3,
                value: "IN_PLANE_LOADING_2D"
            };
        }
        static{
            this.OUT_PLANE_LOADING_2D = {
                type: 3,
                value: "OUT_PLANE_LOADING_2D"
            };
        }
        static{
            this.LOADING_3D = {
                type: 3,
                value: "LOADING_3D"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;
    class IfcAnalysisTheoryTypeEnum {
        static{
            this.FIRST_ORDER_THEORY = {
                type: 3,
                value: "FIRST_ORDER_THEORY"
            };
        }
        static{
            this.SECOND_ORDER_THEORY = {
                type: 3,
                value: "SECOND_ORDER_THEORY"
            };
        }
        static{
            this.THIRD_ORDER_THEORY = {
                type: 3,
                value: "THIRD_ORDER_THEORY"
            };
        }
        static{
            this.FULL_NONLINEAR_THEORY = {
                type: 3,
                value: "FULL_NONLINEAR_THEORY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;
    class IfcArithmeticOperatorEnum {
        static{
            this.ADD = {
                type: 3,
                value: "ADD"
            };
        }
        static{
            this.DIVIDE = {
                type: 3,
                value: "DIVIDE"
            };
        }
        static{
            this.MULTIPLY = {
                type: 3,
                value: "MULTIPLY"
            };
        }
        static{
            this.SUBTRACT = {
                type: 3,
                value: "SUBTRACT"
            };
        }
    }
    IFC42.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;
    class IfcAssemblyPlaceEnum {
        static{
            this.SITE = {
                type: 3,
                value: "SITE"
            };
        }
        static{
            this.FACTORY = {
                type: 3,
                value: "FACTORY"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;
    class IfcAudioVisualApplianceTypeEnum {
        static{
            this.AMPLIFIER = {
                type: 3,
                value: "AMPLIFIER"
            };
        }
        static{
            this.CAMERA = {
                type: 3,
                value: "CAMERA"
            };
        }
        static{
            this.DISPLAY = {
                type: 3,
                value: "DISPLAY"
            };
        }
        static{
            this.MICROPHONE = {
                type: 3,
                value: "MICROPHONE"
            };
        }
        static{
            this.PLAYER = {
                type: 3,
                value: "PLAYER"
            };
        }
        static{
            this.PROJECTOR = {
                type: 3,
                value: "PROJECTOR"
            };
        }
        static{
            this.RECEIVER = {
                type: 3,
                value: "RECEIVER"
            };
        }
        static{
            this.SPEAKER = {
                type: 3,
                value: "SPEAKER"
            };
        }
        static{
            this.SWITCHER = {
                type: 3,
                value: "SWITCHER"
            };
        }
        static{
            this.TELEPHONE = {
                type: 3,
                value: "TELEPHONE"
            };
        }
        static{
            this.TUNER = {
                type: 3,
                value: "TUNER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcAudioVisualApplianceTypeEnum = IfcAudioVisualApplianceTypeEnum;
    class IfcBSplineCurveForm {
        static{
            this.POLYLINE_FORM = {
                type: 3,
                value: "POLYLINE_FORM"
            };
        }
        static{
            this.CIRCULAR_ARC = {
                type: 3,
                value: "CIRCULAR_ARC"
            };
        }
        static{
            this.ELLIPTIC_ARC = {
                type: 3,
                value: "ELLIPTIC_ARC"
            };
        }
        static{
            this.PARABOLIC_ARC = {
                type: 3,
                value: "PARABOLIC_ARC"
            };
        }
        static{
            this.HYPERBOLIC_ARC = {
                type: 3,
                value: "HYPERBOLIC_ARC"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC42.IfcBSplineCurveForm = IfcBSplineCurveForm;
    class IfcBSplineSurfaceForm {
        static{
            this.PLANE_SURF = {
                type: 3,
                value: "PLANE_SURF"
            };
        }
        static{
            this.CYLINDRICAL_SURF = {
                type: 3,
                value: "CYLINDRICAL_SURF"
            };
        }
        static{
            this.CONICAL_SURF = {
                type: 3,
                value: "CONICAL_SURF"
            };
        }
        static{
            this.SPHERICAL_SURF = {
                type: 3,
                value: "SPHERICAL_SURF"
            };
        }
        static{
            this.TOROIDAL_SURF = {
                type: 3,
                value: "TOROIDAL_SURF"
            };
        }
        static{
            this.SURF_OF_REVOLUTION = {
                type: 3,
                value: "SURF_OF_REVOLUTION"
            };
        }
        static{
            this.RULED_SURF = {
                type: 3,
                value: "RULED_SURF"
            };
        }
        static{
            this.GENERALISED_CONE = {
                type: 3,
                value: "GENERALISED_CONE"
            };
        }
        static{
            this.QUADRIC_SURF = {
                type: 3,
                value: "QUADRIC_SURF"
            };
        }
        static{
            this.SURF_OF_LINEAR_EXTRUSION = {
                type: 3,
                value: "SURF_OF_LINEAR_EXTRUSION"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC42.IfcBSplineSurfaceForm = IfcBSplineSurfaceForm;
    class IfcBeamTypeEnum {
        static{
            this.BEAM = {
                type: 3,
                value: "BEAM"
            };
        }
        static{
            this.JOIST = {
                type: 3,
                value: "JOIST"
            };
        }
        static{
            this.HOLLOWCORE = {
                type: 3,
                value: "HOLLOWCORE"
            };
        }
        static{
            this.LINTEL = {
                type: 3,
                value: "LINTEL"
            };
        }
        static{
            this.SPANDREL = {
                type: 3,
                value: "SPANDREL"
            };
        }
        static{
            this.T_BEAM = {
                type: 3,
                value: "T_BEAM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcBeamTypeEnum = IfcBeamTypeEnum;
    class IfcBenchmarkEnum {
        static{
            this.GREATERTHAN = {
                type: 3,
                value: "GREATERTHAN"
            };
        }
        static{
            this.GREATERTHANOREQUALTO = {
                type: 3,
                value: "GREATERTHANOREQUALTO"
            };
        }
        static{
            this.LESSTHAN = {
                type: 3,
                value: "LESSTHAN"
            };
        }
        static{
            this.LESSTHANOREQUALTO = {
                type: 3,
                value: "LESSTHANOREQUALTO"
            };
        }
        static{
            this.EQUALTO = {
                type: 3,
                value: "EQUALTO"
            };
        }
        static{
            this.NOTEQUALTO = {
                type: 3,
                value: "NOTEQUALTO"
            };
        }
        static{
            this.INCLUDES = {
                type: 3,
                value: "INCLUDES"
            };
        }
        static{
            this.NOTINCLUDES = {
                type: 3,
                value: "NOTINCLUDES"
            };
        }
        static{
            this.INCLUDEDIN = {
                type: 3,
                value: "INCLUDEDIN"
            };
        }
        static{
            this.NOTINCLUDEDIN = {
                type: 3,
                value: "NOTINCLUDEDIN"
            };
        }
    }
    IFC42.IfcBenchmarkEnum = IfcBenchmarkEnum;
    class IfcBoilerTypeEnum {
        static{
            this.WATER = {
                type: 3,
                value: "WATER"
            };
        }
        static{
            this.STEAM = {
                type: 3,
                value: "STEAM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcBoilerTypeEnum = IfcBoilerTypeEnum;
    class IfcBooleanOperator {
        static{
            this.UNION = {
                type: 3,
                value: "UNION"
            };
        }
        static{
            this.INTERSECTION = {
                type: 3,
                value: "INTERSECTION"
            };
        }
        static{
            this.DIFFERENCE = {
                type: 3,
                value: "DIFFERENCE"
            };
        }
    }
    IFC42.IfcBooleanOperator = IfcBooleanOperator;
    class IfcBuildingElementPartTypeEnum {
        static{
            this.INSULATION = {
                type: 3,
                value: "INSULATION"
            };
        }
        static{
            this.PRECASTPANEL = {
                type: 3,
                value: "PRECASTPANEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcBuildingElementPartTypeEnum = IfcBuildingElementPartTypeEnum;
    class IfcBuildingElementProxyTypeEnum {
        static{
            this.COMPLEX = {
                type: 3,
                value: "COMPLEX"
            };
        }
        static{
            this.ELEMENT = {
                type: 3,
                value: "ELEMENT"
            };
        }
        static{
            this.PARTIAL = {
                type: 3,
                value: "PARTIAL"
            };
        }
        static{
            this.PROVISIONFORVOID = {
                type: 3,
                value: "PROVISIONFORVOID"
            };
        }
        static{
            this.PROVISIONFORSPACE = {
                type: 3,
                value: "PROVISIONFORSPACE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;
    class IfcBuildingSystemTypeEnum {
        static{
            this.FENESTRATION = {
                type: 3,
                value: "FENESTRATION"
            };
        }
        static{
            this.FOUNDATION = {
                type: 3,
                value: "FOUNDATION"
            };
        }
        static{
            this.LOADBEARING = {
                type: 3,
                value: "LOADBEARING"
            };
        }
        static{
            this.OUTERSHELL = {
                type: 3,
                value: "OUTERSHELL"
            };
        }
        static{
            this.SHADING = {
                type: 3,
                value: "SHADING"
            };
        }
        static{
            this.TRANSPORT = {
                type: 3,
                value: "TRANSPORT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcBuildingSystemTypeEnum = IfcBuildingSystemTypeEnum;
    class IfcBurnerTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcBurnerTypeEnum = IfcBurnerTypeEnum;
    class IfcCableCarrierFittingTypeEnum {
        static{
            this.BEND = {
                type: 3,
                value: "BEND"
            };
        }
        static{
            this.CROSS = {
                type: 3,
                value: "CROSS"
            };
        }
        static{
            this.REDUCER = {
                type: 3,
                value: "REDUCER"
            };
        }
        static{
            this.TEE = {
                type: 3,
                value: "TEE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;
    class IfcCableCarrierSegmentTypeEnum {
        static{
            this.CABLELADDERSEGMENT = {
                type: 3,
                value: "CABLELADDERSEGMENT"
            };
        }
        static{
            this.CABLETRAYSEGMENT = {
                type: 3,
                value: "CABLETRAYSEGMENT"
            };
        }
        static{
            this.CABLETRUNKINGSEGMENT = {
                type: 3,
                value: "CABLETRUNKINGSEGMENT"
            };
        }
        static{
            this.CONDUITSEGMENT = {
                type: 3,
                value: "CONDUITSEGMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;
    class IfcCableFittingTypeEnum {
        static{
            this.CONNECTOR = {
                type: 3,
                value: "CONNECTOR"
            };
        }
        static{
            this.ENTRY = {
                type: 3,
                value: "ENTRY"
            };
        }
        static{
            this.EXIT = {
                type: 3,
                value: "EXIT"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.TRANSITION = {
                type: 3,
                value: "TRANSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCableFittingTypeEnum = IfcCableFittingTypeEnum;
    class IfcCableSegmentTypeEnum {
        static{
            this.BUSBARSEGMENT = {
                type: 3,
                value: "BUSBARSEGMENT"
            };
        }
        static{
            this.CABLESEGMENT = {
                type: 3,
                value: "CABLESEGMENT"
            };
        }
        static{
            this.CONDUCTORSEGMENT = {
                type: 3,
                value: "CONDUCTORSEGMENT"
            };
        }
        static{
            this.CORESEGMENT = {
                type: 3,
                value: "CORESEGMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;
    class IfcChangeActionEnum {
        static{
            this.NOCHANGE = {
                type: 3,
                value: "NOCHANGE"
            };
        }
        static{
            this.MODIFIED = {
                type: 3,
                value: "MODIFIED"
            };
        }
        static{
            this.ADDED = {
                type: 3,
                value: "ADDED"
            };
        }
        static{
            this.DELETED = {
                type: 3,
                value: "DELETED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcChangeActionEnum = IfcChangeActionEnum;
    class IfcChillerTypeEnum {
        static{
            this.AIRCOOLED = {
                type: 3,
                value: "AIRCOOLED"
            };
        }
        static{
            this.WATERCOOLED = {
                type: 3,
                value: "WATERCOOLED"
            };
        }
        static{
            this.HEATRECOVERY = {
                type: 3,
                value: "HEATRECOVERY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcChillerTypeEnum = IfcChillerTypeEnum;
    class IfcChimneyTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcChimneyTypeEnum = IfcChimneyTypeEnum;
    class IfcCoilTypeEnum {
        static{
            this.DXCOOLINGCOIL = {
                type: 3,
                value: "DXCOOLINGCOIL"
            };
        }
        static{
            this.ELECTRICHEATINGCOIL = {
                type: 3,
                value: "ELECTRICHEATINGCOIL"
            };
        }
        static{
            this.GASHEATINGCOIL = {
                type: 3,
                value: "GASHEATINGCOIL"
            };
        }
        static{
            this.HYDRONICCOIL = {
                type: 3,
                value: "HYDRONICCOIL"
            };
        }
        static{
            this.STEAMHEATINGCOIL = {
                type: 3,
                value: "STEAMHEATINGCOIL"
            };
        }
        static{
            this.WATERCOOLINGCOIL = {
                type: 3,
                value: "WATERCOOLINGCOIL"
            };
        }
        static{
            this.WATERHEATINGCOIL = {
                type: 3,
                value: "WATERHEATINGCOIL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCoilTypeEnum = IfcCoilTypeEnum;
    class IfcColumnTypeEnum {
        static{
            this.COLUMN = {
                type: 3,
                value: "COLUMN"
            };
        }
        static{
            this.PILASTER = {
                type: 3,
                value: "PILASTER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcColumnTypeEnum = IfcColumnTypeEnum;
    class IfcCommunicationsApplianceTypeEnum {
        static{
            this.ANTENNA = {
                type: 3,
                value: "ANTENNA"
            };
        }
        static{
            this.COMPUTER = {
                type: 3,
                value: "COMPUTER"
            };
        }
        static{
            this.FAX = {
                type: 3,
                value: "FAX"
            };
        }
        static{
            this.GATEWAY = {
                type: 3,
                value: "GATEWAY"
            };
        }
        static{
            this.MODEM = {
                type: 3,
                value: "MODEM"
            };
        }
        static{
            this.NETWORKAPPLIANCE = {
                type: 3,
                value: "NETWORKAPPLIANCE"
            };
        }
        static{
            this.NETWORKBRIDGE = {
                type: 3,
                value: "NETWORKBRIDGE"
            };
        }
        static{
            this.NETWORKHUB = {
                type: 3,
                value: "NETWORKHUB"
            };
        }
        static{
            this.PRINTER = {
                type: 3,
                value: "PRINTER"
            };
        }
        static{
            this.REPEATER = {
                type: 3,
                value: "REPEATER"
            };
        }
        static{
            this.ROUTER = {
                type: 3,
                value: "ROUTER"
            };
        }
        static{
            this.SCANNER = {
                type: 3,
                value: "SCANNER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCommunicationsApplianceTypeEnum = IfcCommunicationsApplianceTypeEnum;
    class IfcComplexPropertyTemplateTypeEnum {
        static{
            this.P_COMPLEX = {
                type: 3,
                value: "P_COMPLEX"
            };
        }
        static{
            this.Q_COMPLEX = {
                type: 3,
                value: "Q_COMPLEX"
            };
        }
    }
    IFC42.IfcComplexPropertyTemplateTypeEnum = IfcComplexPropertyTemplateTypeEnum;
    class IfcCompressorTypeEnum {
        static{
            this.DYNAMIC = {
                type: 3,
                value: "DYNAMIC"
            };
        }
        static{
            this.RECIPROCATING = {
                type: 3,
                value: "RECIPROCATING"
            };
        }
        static{
            this.ROTARY = {
                type: 3,
                value: "ROTARY"
            };
        }
        static{
            this.SCROLL = {
                type: 3,
                value: "SCROLL"
            };
        }
        static{
            this.TROCHOIDAL = {
                type: 3,
                value: "TROCHOIDAL"
            };
        }
        static{
            this.SINGLESTAGE = {
                type: 3,
                value: "SINGLESTAGE"
            };
        }
        static{
            this.BOOSTER = {
                type: 3,
                value: "BOOSTER"
            };
        }
        static{
            this.OPENTYPE = {
                type: 3,
                value: "OPENTYPE"
            };
        }
        static{
            this.HERMETIC = {
                type: 3,
                value: "HERMETIC"
            };
        }
        static{
            this.SEMIHERMETIC = {
                type: 3,
                value: "SEMIHERMETIC"
            };
        }
        static{
            this.WELDEDSHELLHERMETIC = {
                type: 3,
                value: "WELDEDSHELLHERMETIC"
            };
        }
        static{
            this.ROLLINGPISTON = {
                type: 3,
                value: "ROLLINGPISTON"
            };
        }
        static{
            this.ROTARYVANE = {
                type: 3,
                value: "ROTARYVANE"
            };
        }
        static{
            this.SINGLESCREW = {
                type: 3,
                value: "SINGLESCREW"
            };
        }
        static{
            this.TWINSCREW = {
                type: 3,
                value: "TWINSCREW"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCompressorTypeEnum = IfcCompressorTypeEnum;
    class IfcCondenserTypeEnum {
        static{
            this.AIRCOOLED = {
                type: 3,
                value: "AIRCOOLED"
            };
        }
        static{
            this.EVAPORATIVECOOLED = {
                type: 3,
                value: "EVAPORATIVECOOLED"
            };
        }
        static{
            this.WATERCOOLED = {
                type: 3,
                value: "WATERCOOLED"
            };
        }
        static{
            this.WATERCOOLEDBRAZEDPLATE = {
                type: 3,
                value: "WATERCOOLEDBRAZEDPLATE"
            };
        }
        static{
            this.WATERCOOLEDSHELLCOIL = {
                type: 3,
                value: "WATERCOOLEDSHELLCOIL"
            };
        }
        static{
            this.WATERCOOLEDSHELLTUBE = {
                type: 3,
                value: "WATERCOOLEDSHELLTUBE"
            };
        }
        static{
            this.WATERCOOLEDTUBEINTUBE = {
                type: 3,
                value: "WATERCOOLEDTUBEINTUBE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCondenserTypeEnum = IfcCondenserTypeEnum;
    class IfcConnectionTypeEnum {
        static{
            this.ATPATH = {
                type: 3,
                value: "ATPATH"
            };
        }
        static{
            this.ATSTART = {
                type: 3,
                value: "ATSTART"
            };
        }
        static{
            this.ATEND = {
                type: 3,
                value: "ATEND"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcConnectionTypeEnum = IfcConnectionTypeEnum;
    class IfcConstraintEnum {
        static{
            this.HARD = {
                type: 3,
                value: "HARD"
            };
        }
        static{
            this.SOFT = {
                type: 3,
                value: "SOFT"
            };
        }
        static{
            this.ADVISORY = {
                type: 3,
                value: "ADVISORY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcConstraintEnum = IfcConstraintEnum;
    class IfcConstructionEquipmentResourceTypeEnum {
        static{
            this.DEMOLISHING = {
                type: 3,
                value: "DEMOLISHING"
            };
        }
        static{
            this.EARTHMOVING = {
                type: 3,
                value: "EARTHMOVING"
            };
        }
        static{
            this.ERECTING = {
                type: 3,
                value: "ERECTING"
            };
        }
        static{
            this.HEATING = {
                type: 3,
                value: "HEATING"
            };
        }
        static{
            this.LIGHTING = {
                type: 3,
                value: "LIGHTING"
            };
        }
        static{
            this.PAVING = {
                type: 3,
                value: "PAVING"
            };
        }
        static{
            this.PUMPING = {
                type: 3,
                value: "PUMPING"
            };
        }
        static{
            this.TRANSPORTING = {
                type: 3,
                value: "TRANSPORTING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcConstructionEquipmentResourceTypeEnum = IfcConstructionEquipmentResourceTypeEnum;
    class IfcConstructionMaterialResourceTypeEnum {
        static{
            this.AGGREGATES = {
                type: 3,
                value: "AGGREGATES"
            };
        }
        static{
            this.CONCRETE = {
                type: 3,
                value: "CONCRETE"
            };
        }
        static{
            this.DRYWALL = {
                type: 3,
                value: "DRYWALL"
            };
        }
        static{
            this.FUEL = {
                type: 3,
                value: "FUEL"
            };
        }
        static{
            this.GYPSUM = {
                type: 3,
                value: "GYPSUM"
            };
        }
        static{
            this.MASONRY = {
                type: 3,
                value: "MASONRY"
            };
        }
        static{
            this.METAL = {
                type: 3,
                value: "METAL"
            };
        }
        static{
            this.PLASTIC = {
                type: 3,
                value: "PLASTIC"
            };
        }
        static{
            this.WOOD = {
                type: 3,
                value: "WOOD"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC42.IfcConstructionMaterialResourceTypeEnum = IfcConstructionMaterialResourceTypeEnum;
    class IfcConstructionProductResourceTypeEnum {
        static{
            this.ASSEMBLY = {
                type: 3,
                value: "ASSEMBLY"
            };
        }
        static{
            this.FORMWORK = {
                type: 3,
                value: "FORMWORK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcConstructionProductResourceTypeEnum = IfcConstructionProductResourceTypeEnum;
    class IfcControllerTypeEnum {
        static{
            this.FLOATING = {
                type: 3,
                value: "FLOATING"
            };
        }
        static{
            this.PROGRAMMABLE = {
                type: 3,
                value: "PROGRAMMABLE"
            };
        }
        static{
            this.PROPORTIONAL = {
                type: 3,
                value: "PROPORTIONAL"
            };
        }
        static{
            this.MULTIPOSITION = {
                type: 3,
                value: "MULTIPOSITION"
            };
        }
        static{
            this.TWOPOSITION = {
                type: 3,
                value: "TWOPOSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcControllerTypeEnum = IfcControllerTypeEnum;
    class IfcCooledBeamTypeEnum {
        static{
            this.ACTIVE = {
                type: 3,
                value: "ACTIVE"
            };
        }
        static{
            this.PASSIVE = {
                type: 3,
                value: "PASSIVE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;
    class IfcCoolingTowerTypeEnum {
        static{
            this.NATURALDRAFT = {
                type: 3,
                value: "NATURALDRAFT"
            };
        }
        static{
            this.MECHANICALINDUCEDDRAFT = {
                type: 3,
                value: "MECHANICALINDUCEDDRAFT"
            };
        }
        static{
            this.MECHANICALFORCEDDRAFT = {
                type: 3,
                value: "MECHANICALFORCEDDRAFT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;
    class IfcCostItemTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCostItemTypeEnum = IfcCostItemTypeEnum;
    class IfcCostScheduleTypeEnum {
        static{
            this.BUDGET = {
                type: 3,
                value: "BUDGET"
            };
        }
        static{
            this.COSTPLAN = {
                type: 3,
                value: "COSTPLAN"
            };
        }
        static{
            this.ESTIMATE = {
                type: 3,
                value: "ESTIMATE"
            };
        }
        static{
            this.TENDER = {
                type: 3,
                value: "TENDER"
            };
        }
        static{
            this.PRICEDBILLOFQUANTITIES = {
                type: 3,
                value: "PRICEDBILLOFQUANTITIES"
            };
        }
        static{
            this.UNPRICEDBILLOFQUANTITIES = {
                type: 3,
                value: "UNPRICEDBILLOFQUANTITIES"
            };
        }
        static{
            this.SCHEDULEOFRATES = {
                type: 3,
                value: "SCHEDULEOFRATES"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;
    class IfcCoveringTypeEnum {
        static{
            this.CEILING = {
                type: 3,
                value: "CEILING"
            };
        }
        static{
            this.FLOORING = {
                type: 3,
                value: "FLOORING"
            };
        }
        static{
            this.CLADDING = {
                type: 3,
                value: "CLADDING"
            };
        }
        static{
            this.ROOFING = {
                type: 3,
                value: "ROOFING"
            };
        }
        static{
            this.MOLDING = {
                type: 3,
                value: "MOLDING"
            };
        }
        static{
            this.SKIRTINGBOARD = {
                type: 3,
                value: "SKIRTINGBOARD"
            };
        }
        static{
            this.INSULATION = {
                type: 3,
                value: "INSULATION"
            };
        }
        static{
            this.MEMBRANE = {
                type: 3,
                value: "MEMBRANE"
            };
        }
        static{
            this.SLEEVING = {
                type: 3,
                value: "SLEEVING"
            };
        }
        static{
            this.WRAPPING = {
                type: 3,
                value: "WRAPPING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCoveringTypeEnum = IfcCoveringTypeEnum;
    class IfcCrewResourceTypeEnum {
        static{
            this.OFFICE = {
                type: 3,
                value: "OFFICE"
            };
        }
        static{
            this.SITE = {
                type: 3,
                value: "SITE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCrewResourceTypeEnum = IfcCrewResourceTypeEnum;
    class IfcCurtainWallTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;
    class IfcCurveInterpolationEnum {
        static{
            this.LINEAR = {
                type: 3,
                value: "LINEAR"
            };
        }
        static{
            this.LOG_LINEAR = {
                type: 3,
                value: "LOG_LINEAR"
            };
        }
        static{
            this.LOG_LOG = {
                type: 3,
                value: "LOG_LOG"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcCurveInterpolationEnum = IfcCurveInterpolationEnum;
    class IfcDamperTypeEnum {
        static{
            this.BACKDRAFTDAMPER = {
                type: 3,
                value: "BACKDRAFTDAMPER"
            };
        }
        static{
            this.BALANCINGDAMPER = {
                type: 3,
                value: "BALANCINGDAMPER"
            };
        }
        static{
            this.BLASTDAMPER = {
                type: 3,
                value: "BLASTDAMPER"
            };
        }
        static{
            this.CONTROLDAMPER = {
                type: 3,
                value: "CONTROLDAMPER"
            };
        }
        static{
            this.FIREDAMPER = {
                type: 3,
                value: "FIREDAMPER"
            };
        }
        static{
            this.FIRESMOKEDAMPER = {
                type: 3,
                value: "FIRESMOKEDAMPER"
            };
        }
        static{
            this.FUMEHOODEXHAUST = {
                type: 3,
                value: "FUMEHOODEXHAUST"
            };
        }
        static{
            this.GRAVITYDAMPER = {
                type: 3,
                value: "GRAVITYDAMPER"
            };
        }
        static{
            this.GRAVITYRELIEFDAMPER = {
                type: 3,
                value: "GRAVITYRELIEFDAMPER"
            };
        }
        static{
            this.RELIEFDAMPER = {
                type: 3,
                value: "RELIEFDAMPER"
            };
        }
        static{
            this.SMOKEDAMPER = {
                type: 3,
                value: "SMOKEDAMPER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDamperTypeEnum = IfcDamperTypeEnum;
    class IfcDataOriginEnum {
        static{
            this.MEASURED = {
                type: 3,
                value: "MEASURED"
            };
        }
        static{
            this.PREDICTED = {
                type: 3,
                value: "PREDICTED"
            };
        }
        static{
            this.SIMULATED = {
                type: 3,
                value: "SIMULATED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDataOriginEnum = IfcDataOriginEnum;
    class IfcDerivedUnitEnum {
        static{
            this.ANGULARVELOCITYUNIT = {
                type: 3,
                value: "ANGULARVELOCITYUNIT"
            };
        }
        static{
            this.AREADENSITYUNIT = {
                type: 3,
                value: "AREADENSITYUNIT"
            };
        }
        static{
            this.COMPOUNDPLANEANGLEUNIT = {
                type: 3,
                value: "COMPOUNDPLANEANGLEUNIT"
            };
        }
        static{
            this.DYNAMICVISCOSITYUNIT = {
                type: 3,
                value: "DYNAMICVISCOSITYUNIT"
            };
        }
        static{
            this.HEATFLUXDENSITYUNIT = {
                type: 3,
                value: "HEATFLUXDENSITYUNIT"
            };
        }
        static{
            this.INTEGERCOUNTRATEUNIT = {
                type: 3,
                value: "INTEGERCOUNTRATEUNIT"
            };
        }
        static{
            this.ISOTHERMALMOISTURECAPACITYUNIT = {
                type: 3,
                value: "ISOTHERMALMOISTURECAPACITYUNIT"
            };
        }
        static{
            this.KINEMATICVISCOSITYUNIT = {
                type: 3,
                value: "KINEMATICVISCOSITYUNIT"
            };
        }
        static{
            this.LINEARVELOCITYUNIT = {
                type: 3,
                value: "LINEARVELOCITYUNIT"
            };
        }
        static{
            this.MASSDENSITYUNIT = {
                type: 3,
                value: "MASSDENSITYUNIT"
            };
        }
        static{
            this.MASSFLOWRATEUNIT = {
                type: 3,
                value: "MASSFLOWRATEUNIT"
            };
        }
        static{
            this.MOISTUREDIFFUSIVITYUNIT = {
                type: 3,
                value: "MOISTUREDIFFUSIVITYUNIT"
            };
        }
        static{
            this.MOLECULARWEIGHTUNIT = {
                type: 3,
                value: "MOLECULARWEIGHTUNIT"
            };
        }
        static{
            this.SPECIFICHEATCAPACITYUNIT = {
                type: 3,
                value: "SPECIFICHEATCAPACITYUNIT"
            };
        }
        static{
            this.THERMALADMITTANCEUNIT = {
                type: 3,
                value: "THERMALADMITTANCEUNIT"
            };
        }
        static{
            this.THERMALCONDUCTANCEUNIT = {
                type: 3,
                value: "THERMALCONDUCTANCEUNIT"
            };
        }
        static{
            this.THERMALRESISTANCEUNIT = {
                type: 3,
                value: "THERMALRESISTANCEUNIT"
            };
        }
        static{
            this.THERMALTRANSMITTANCEUNIT = {
                type: 3,
                value: "THERMALTRANSMITTANCEUNIT"
            };
        }
        static{
            this.VAPORPERMEABILITYUNIT = {
                type: 3,
                value: "VAPORPERMEABILITYUNIT"
            };
        }
        static{
            this.VOLUMETRICFLOWRATEUNIT = {
                type: 3,
                value: "VOLUMETRICFLOWRATEUNIT"
            };
        }
        static{
            this.ROTATIONALFREQUENCYUNIT = {
                type: 3,
                value: "ROTATIONALFREQUENCYUNIT"
            };
        }
        static{
            this.TORQUEUNIT = {
                type: 3,
                value: "TORQUEUNIT"
            };
        }
        static{
            this.MOMENTOFINERTIAUNIT = {
                type: 3,
                value: "MOMENTOFINERTIAUNIT"
            };
        }
        static{
            this.LINEARMOMENTUNIT = {
                type: 3,
                value: "LINEARMOMENTUNIT"
            };
        }
        static{
            this.LINEARFORCEUNIT = {
                type: 3,
                value: "LINEARFORCEUNIT"
            };
        }
        static{
            this.PLANARFORCEUNIT = {
                type: 3,
                value: "PLANARFORCEUNIT"
            };
        }
        static{
            this.MODULUSOFELASTICITYUNIT = {
                type: 3,
                value: "MODULUSOFELASTICITYUNIT"
            };
        }
        static{
            this.SHEARMODULUSUNIT = {
                type: 3,
                value: "SHEARMODULUSUNIT"
            };
        }
        static{
            this.LINEARSTIFFNESSUNIT = {
                type: 3,
                value: "LINEARSTIFFNESSUNIT"
            };
        }
        static{
            this.ROTATIONALSTIFFNESSUNIT = {
                type: 3,
                value: "ROTATIONALSTIFFNESSUNIT"
            };
        }
        static{
            this.MODULUSOFSUBGRADEREACTIONUNIT = {
                type: 3,
                value: "MODULUSOFSUBGRADEREACTIONUNIT"
            };
        }
        static{
            this.ACCELERATIONUNIT = {
                type: 3,
                value: "ACCELERATIONUNIT"
            };
        }
        static{
            this.CURVATUREUNIT = {
                type: 3,
                value: "CURVATUREUNIT"
            };
        }
        static{
            this.HEATINGVALUEUNIT = {
                type: 3,
                value: "HEATINGVALUEUNIT"
            };
        }
        static{
            this.IONCONCENTRATIONUNIT = {
                type: 3,
                value: "IONCONCENTRATIONUNIT"
            };
        }
        static{
            this.LUMINOUSINTENSITYDISTRIBUTIONUNIT = {
                type: 3,
                value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT"
            };
        }
        static{
            this.MASSPERLENGTHUNIT = {
                type: 3,
                value: "MASSPERLENGTHUNIT"
            };
        }
        static{
            this.MODULUSOFLINEARSUBGRADEREACTIONUNIT = {
                type: 3,
                value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT"
            };
        }
        static{
            this.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = {
                type: 3,
                value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT"
            };
        }
        static{
            this.PHUNIT = {
                type: 3,
                value: "PHUNIT"
            };
        }
        static{
            this.ROTATIONALMASSUNIT = {
                type: 3,
                value: "ROTATIONALMASSUNIT"
            };
        }
        static{
            this.SECTIONAREAINTEGRALUNIT = {
                type: 3,
                value: "SECTIONAREAINTEGRALUNIT"
            };
        }
        static{
            this.SECTIONMODULUSUNIT = {
                type: 3,
                value: "SECTIONMODULUSUNIT"
            };
        }
        static{
            this.SOUNDPOWERLEVELUNIT = {
                type: 3,
                value: "SOUNDPOWERLEVELUNIT"
            };
        }
        static{
            this.SOUNDPOWERUNIT = {
                type: 3,
                value: "SOUNDPOWERUNIT"
            };
        }
        static{
            this.SOUNDPRESSURELEVELUNIT = {
                type: 3,
                value: "SOUNDPRESSURELEVELUNIT"
            };
        }
        static{
            this.SOUNDPRESSUREUNIT = {
                type: 3,
                value: "SOUNDPRESSUREUNIT"
            };
        }
        static{
            this.TEMPERATUREGRADIENTUNIT = {
                type: 3,
                value: "TEMPERATUREGRADIENTUNIT"
            };
        }
        static{
            this.TEMPERATURERATEOFCHANGEUNIT = {
                type: 3,
                value: "TEMPERATURERATEOFCHANGEUNIT"
            };
        }
        static{
            this.THERMALEXPANSIONCOEFFICIENTUNIT = {
                type: 3,
                value: "THERMALEXPANSIONCOEFFICIENTUNIT"
            };
        }
        static{
            this.WARPINGCONSTANTUNIT = {
                type: 3,
                value: "WARPINGCONSTANTUNIT"
            };
        }
        static{
            this.WARPINGMOMENTUNIT = {
                type: 3,
                value: "WARPINGMOMENTUNIT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC42.IfcDerivedUnitEnum = IfcDerivedUnitEnum;
    class IfcDirectionSenseEnum {
        static{
            this.POSITIVE = {
                type: 3,
                value: "POSITIVE"
            };
        }
        static{
            this.NEGATIVE = {
                type: 3,
                value: "NEGATIVE"
            };
        }
    }
    IFC42.IfcDirectionSenseEnum = IfcDirectionSenseEnum;
    class IfcDiscreteAccessoryTypeEnum {
        static{
            this.ANCHORPLATE = {
                type: 3,
                value: "ANCHORPLATE"
            };
        }
        static{
            this.BRACKET = {
                type: 3,
                value: "BRACKET"
            };
        }
        static{
            this.SHOE = {
                type: 3,
                value: "SHOE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDiscreteAccessoryTypeEnum = IfcDiscreteAccessoryTypeEnum;
    class IfcDistributionChamberElementTypeEnum {
        static{
            this.FORMEDDUCT = {
                type: 3,
                value: "FORMEDDUCT"
            };
        }
        static{
            this.INSPECTIONCHAMBER = {
                type: 3,
                value: "INSPECTIONCHAMBER"
            };
        }
        static{
            this.INSPECTIONPIT = {
                type: 3,
                value: "INSPECTIONPIT"
            };
        }
        static{
            this.MANHOLE = {
                type: 3,
                value: "MANHOLE"
            };
        }
        static{
            this.METERCHAMBER = {
                type: 3,
                value: "METERCHAMBER"
            };
        }
        static{
            this.SUMP = {
                type: 3,
                value: "SUMP"
            };
        }
        static{
            this.TRENCH = {
                type: 3,
                value: "TRENCH"
            };
        }
        static{
            this.VALVECHAMBER = {
                type: 3,
                value: "VALVECHAMBER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;
    class IfcDistributionPortTypeEnum {
        static{
            this.CABLE = {
                type: 3,
                value: "CABLE"
            };
        }
        static{
            this.CABLECARRIER = {
                type: 3,
                value: "CABLECARRIER"
            };
        }
        static{
            this.DUCT = {
                type: 3,
                value: "DUCT"
            };
        }
        static{
            this.PIPE = {
                type: 3,
                value: "PIPE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDistributionPortTypeEnum = IfcDistributionPortTypeEnum;
    class IfcDistributionSystemEnum {
        static{
            this.AIRCONDITIONING = {
                type: 3,
                value: "AIRCONDITIONING"
            };
        }
        static{
            this.AUDIOVISUAL = {
                type: 3,
                value: "AUDIOVISUAL"
            };
        }
        static{
            this.CHEMICAL = {
                type: 3,
                value: "CHEMICAL"
            };
        }
        static{
            this.CHILLEDWATER = {
                type: 3,
                value: "CHILLEDWATER"
            };
        }
        static{
            this.COMMUNICATION = {
                type: 3,
                value: "COMMUNICATION"
            };
        }
        static{
            this.COMPRESSEDAIR = {
                type: 3,
                value: "COMPRESSEDAIR"
            };
        }
        static{
            this.CONDENSERWATER = {
                type: 3,
                value: "CONDENSERWATER"
            };
        }
        static{
            this.CONTROL = {
                type: 3,
                value: "CONTROL"
            };
        }
        static{
            this.CONVEYING = {
                type: 3,
                value: "CONVEYING"
            };
        }
        static{
            this.DATA = {
                type: 3,
                value: "DATA"
            };
        }
        static{
            this.DISPOSAL = {
                type: 3,
                value: "DISPOSAL"
            };
        }
        static{
            this.DOMESTICCOLDWATER = {
                type: 3,
                value: "DOMESTICCOLDWATER"
            };
        }
        static{
            this.DOMESTICHOTWATER = {
                type: 3,
                value: "DOMESTICHOTWATER"
            };
        }
        static{
            this.DRAINAGE = {
                type: 3,
                value: "DRAINAGE"
            };
        }
        static{
            this.EARTHING = {
                type: 3,
                value: "EARTHING"
            };
        }
        static{
            this.ELECTRICAL = {
                type: 3,
                value: "ELECTRICAL"
            };
        }
        static{
            this.ELECTROACOUSTIC = {
                type: 3,
                value: "ELECTROACOUSTIC"
            };
        }
        static{
            this.EXHAUST = {
                type: 3,
                value: "EXHAUST"
            };
        }
        static{
            this.FIREPROTECTION = {
                type: 3,
                value: "FIREPROTECTION"
            };
        }
        static{
            this.FUEL = {
                type: 3,
                value: "FUEL"
            };
        }
        static{
            this.GAS = {
                type: 3,
                value: "GAS"
            };
        }
        static{
            this.HAZARDOUS = {
                type: 3,
                value: "HAZARDOUS"
            };
        }
        static{
            this.HEATING = {
                type: 3,
                value: "HEATING"
            };
        }
        static{
            this.LIGHTING = {
                type: 3,
                value: "LIGHTING"
            };
        }
        static{
            this.LIGHTNINGPROTECTION = {
                type: 3,
                value: "LIGHTNINGPROTECTION"
            };
        }
        static{
            this.MUNICIPALSOLIDWASTE = {
                type: 3,
                value: "MUNICIPALSOLIDWASTE"
            };
        }
        static{
            this.OIL = {
                type: 3,
                value: "OIL"
            };
        }
        static{
            this.OPERATIONAL = {
                type: 3,
                value: "OPERATIONAL"
            };
        }
        static{
            this.POWERGENERATION = {
                type: 3,
                value: "POWERGENERATION"
            };
        }
        static{
            this.RAINWATER = {
                type: 3,
                value: "RAINWATER"
            };
        }
        static{
            this.REFRIGERATION = {
                type: 3,
                value: "REFRIGERATION"
            };
        }
        static{
            this.SECURITY = {
                type: 3,
                value: "SECURITY"
            };
        }
        static{
            this.SEWAGE = {
                type: 3,
                value: "SEWAGE"
            };
        }
        static{
            this.SIGNAL = {
                type: 3,
                value: "SIGNAL"
            };
        }
        static{
            this.STORMWATER = {
                type: 3,
                value: "STORMWATER"
            };
        }
        static{
            this.TELEPHONE = {
                type: 3,
                value: "TELEPHONE"
            };
        }
        static{
            this.TV = {
                type: 3,
                value: "TV"
            };
        }
        static{
            this.VACUUM = {
                type: 3,
                value: "VACUUM"
            };
        }
        static{
            this.VENT = {
                type: 3,
                value: "VENT"
            };
        }
        static{
            this.VENTILATION = {
                type: 3,
                value: "VENTILATION"
            };
        }
        static{
            this.WASTEWATER = {
                type: 3,
                value: "WASTEWATER"
            };
        }
        static{
            this.WATERSUPPLY = {
                type: 3,
                value: "WATERSUPPLY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDistributionSystemEnum = IfcDistributionSystemEnum;
    class IfcDocumentConfidentialityEnum {
        static{
            this.PUBLIC = {
                type: 3,
                value: "PUBLIC"
            };
        }
        static{
            this.RESTRICTED = {
                type: 3,
                value: "RESTRICTED"
            };
        }
        static{
            this.CONFIDENTIAL = {
                type: 3,
                value: "CONFIDENTIAL"
            };
        }
        static{
            this.PERSONAL = {
                type: 3,
                value: "PERSONAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;
    class IfcDocumentStatusEnum {
        static{
            this.DRAFT = {
                type: 3,
                value: "DRAFT"
            };
        }
        static{
            this.FINALDRAFT = {
                type: 3,
                value: "FINALDRAFT"
            };
        }
        static{
            this.FINAL = {
                type: 3,
                value: "FINAL"
            };
        }
        static{
            this.REVISION = {
                type: 3,
                value: "REVISION"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDocumentStatusEnum = IfcDocumentStatusEnum;
    class IfcDoorPanelOperationEnum {
        static{
            this.SWINGING = {
                type: 3,
                value: "SWINGING"
            };
        }
        static{
            this.DOUBLE_ACTING = {
                type: 3,
                value: "DOUBLE_ACTING"
            };
        }
        static{
            this.SLIDING = {
                type: 3,
                value: "SLIDING"
            };
        }
        static{
            this.FOLDING = {
                type: 3,
                value: "FOLDING"
            };
        }
        static{
            this.REVOLVING = {
                type: 3,
                value: "REVOLVING"
            };
        }
        static{
            this.ROLLINGUP = {
                type: 3,
                value: "ROLLINGUP"
            };
        }
        static{
            this.FIXEDPANEL = {
                type: 3,
                value: "FIXEDPANEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;
    class IfcDoorPanelPositionEnum {
        static{
            this.LEFT = {
                type: 3,
                value: "LEFT"
            };
        }
        static{
            this.MIDDLE = {
                type: 3,
                value: "MIDDLE"
            };
        }
        static{
            this.RIGHT = {
                type: 3,
                value: "RIGHT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;
    class IfcDoorStyleConstructionEnum {
        static{
            this.ALUMINIUM = {
                type: 3,
                value: "ALUMINIUM"
            };
        }
        static{
            this.HIGH_GRADE_STEEL = {
                type: 3,
                value: "HIGH_GRADE_STEEL"
            };
        }
        static{
            this.STEEL = {
                type: 3,
                value: "STEEL"
            };
        }
        static{
            this.WOOD = {
                type: 3,
                value: "WOOD"
            };
        }
        static{
            this.ALUMINIUM_WOOD = {
                type: 3,
                value: "ALUMINIUM_WOOD"
            };
        }
        static{
            this.ALUMINIUM_PLASTIC = {
                type: 3,
                value: "ALUMINIUM_PLASTIC"
            };
        }
        static{
            this.PLASTIC = {
                type: 3,
                value: "PLASTIC"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;
    class IfcDoorStyleOperationEnum {
        static{
            this.SINGLE_SWING_LEFT = {
                type: 3,
                value: "SINGLE_SWING_LEFT"
            };
        }
        static{
            this.SINGLE_SWING_RIGHT = {
                type: 3,
                value: "SINGLE_SWING_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT"
            };
        }
        static{
            this.DOUBLE_SWING_LEFT = {
                type: 3,
                value: "DOUBLE_SWING_LEFT"
            };
        }
        static{
            this.DOUBLE_SWING_RIGHT = {
                type: 3,
                value: "DOUBLE_SWING_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_DOUBLE_SWING = {
                type: 3,
                value: "DOUBLE_DOOR_DOUBLE_SWING"
            };
        }
        static{
            this.SLIDING_TO_LEFT = {
                type: 3,
                value: "SLIDING_TO_LEFT"
            };
        }
        static{
            this.SLIDING_TO_RIGHT = {
                type: 3,
                value: "SLIDING_TO_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_SLIDING = {
                type: 3,
                value: "DOUBLE_DOOR_SLIDING"
            };
        }
        static{
            this.FOLDING_TO_LEFT = {
                type: 3,
                value: "FOLDING_TO_LEFT"
            };
        }
        static{
            this.FOLDING_TO_RIGHT = {
                type: 3,
                value: "FOLDING_TO_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_FOLDING = {
                type: 3,
                value: "DOUBLE_DOOR_FOLDING"
            };
        }
        static{
            this.REVOLVING = {
                type: 3,
                value: "REVOLVING"
            };
        }
        static{
            this.ROLLINGUP = {
                type: 3,
                value: "ROLLINGUP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;
    class IfcDoorTypeEnum {
        static{
            this.DOOR = {
                type: 3,
                value: "DOOR"
            };
        }
        static{
            this.GATE = {
                type: 3,
                value: "GATE"
            };
        }
        static{
            this.TRAPDOOR = {
                type: 3,
                value: "TRAPDOOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDoorTypeEnum = IfcDoorTypeEnum;
    class IfcDoorTypeOperationEnum {
        static{
            this.SINGLE_SWING_LEFT = {
                type: 3,
                value: "SINGLE_SWING_LEFT"
            };
        }
        static{
            this.SINGLE_SWING_RIGHT = {
                type: 3,
                value: "SINGLE_SWING_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT"
            };
        }
        static{
            this.DOUBLE_SWING_LEFT = {
                type: 3,
                value: "DOUBLE_SWING_LEFT"
            };
        }
        static{
            this.DOUBLE_SWING_RIGHT = {
                type: 3,
                value: "DOUBLE_SWING_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_DOUBLE_SWING = {
                type: 3,
                value: "DOUBLE_DOOR_DOUBLE_SWING"
            };
        }
        static{
            this.SLIDING_TO_LEFT = {
                type: 3,
                value: "SLIDING_TO_LEFT"
            };
        }
        static{
            this.SLIDING_TO_RIGHT = {
                type: 3,
                value: "SLIDING_TO_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_SLIDING = {
                type: 3,
                value: "DOUBLE_DOOR_SLIDING"
            };
        }
        static{
            this.FOLDING_TO_LEFT = {
                type: 3,
                value: "FOLDING_TO_LEFT"
            };
        }
        static{
            this.FOLDING_TO_RIGHT = {
                type: 3,
                value: "FOLDING_TO_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_FOLDING = {
                type: 3,
                value: "DOUBLE_DOOR_FOLDING"
            };
        }
        static{
            this.REVOLVING = {
                type: 3,
                value: "REVOLVING"
            };
        }
        static{
            this.ROLLINGUP = {
                type: 3,
                value: "ROLLINGUP"
            };
        }
        static{
            this.SWING_FIXED_LEFT = {
                type: 3,
                value: "SWING_FIXED_LEFT"
            };
        }
        static{
            this.SWING_FIXED_RIGHT = {
                type: 3,
                value: "SWING_FIXED_RIGHT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDoorTypeOperationEnum = IfcDoorTypeOperationEnum;
    class IfcDuctFittingTypeEnum {
        static{
            this.BEND = {
                type: 3,
                value: "BEND"
            };
        }
        static{
            this.CONNECTOR = {
                type: 3,
                value: "CONNECTOR"
            };
        }
        static{
            this.ENTRY = {
                type: 3,
                value: "ENTRY"
            };
        }
        static{
            this.EXIT = {
                type: 3,
                value: "EXIT"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.OBSTRUCTION = {
                type: 3,
                value: "OBSTRUCTION"
            };
        }
        static{
            this.TRANSITION = {
                type: 3,
                value: "TRANSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;
    class IfcDuctSegmentTypeEnum {
        static{
            this.RIGIDSEGMENT = {
                type: 3,
                value: "RIGIDSEGMENT"
            };
        }
        static{
            this.FLEXIBLESEGMENT = {
                type: 3,
                value: "FLEXIBLESEGMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;
    class IfcDuctSilencerTypeEnum {
        static{
            this.FLATOVAL = {
                type: 3,
                value: "FLATOVAL"
            };
        }
        static{
            this.RECTANGULAR = {
                type: 3,
                value: "RECTANGULAR"
            };
        }
        static{
            this.ROUND = {
                type: 3,
                value: "ROUND"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;
    class IfcElectricApplianceTypeEnum {
        static{
            this.DISHWASHER = {
                type: 3,
                value: "DISHWASHER"
            };
        }
        static{
            this.ELECTRICCOOKER = {
                type: 3,
                value: "ELECTRICCOOKER"
            };
        }
        static{
            this.FREESTANDINGELECTRICHEATER = {
                type: 3,
                value: "FREESTANDINGELECTRICHEATER"
            };
        }
        static{
            this.FREESTANDINGFAN = {
                type: 3,
                value: "FREESTANDINGFAN"
            };
        }
        static{
            this.FREESTANDINGWATERHEATER = {
                type: 3,
                value: "FREESTANDINGWATERHEATER"
            };
        }
        static{
            this.FREESTANDINGWATERCOOLER = {
                type: 3,
                value: "FREESTANDINGWATERCOOLER"
            };
        }
        static{
            this.FREEZER = {
                type: 3,
                value: "FREEZER"
            };
        }
        static{
            this.FRIDGE_FREEZER = {
                type: 3,
                value: "FRIDGE_FREEZER"
            };
        }
        static{
            this.HANDDRYER = {
                type: 3,
                value: "HANDDRYER"
            };
        }
        static{
            this.KITCHENMACHINE = {
                type: 3,
                value: "KITCHENMACHINE"
            };
        }
        static{
            this.MICROWAVE = {
                type: 3,
                value: "MICROWAVE"
            };
        }
        static{
            this.PHOTOCOPIER = {
                type: 3,
                value: "PHOTOCOPIER"
            };
        }
        static{
            this.REFRIGERATOR = {
                type: 3,
                value: "REFRIGERATOR"
            };
        }
        static{
            this.TUMBLEDRYER = {
                type: 3,
                value: "TUMBLEDRYER"
            };
        }
        static{
            this.VENDINGMACHINE = {
                type: 3,
                value: "VENDINGMACHINE"
            };
        }
        static{
            this.WASHINGMACHINE = {
                type: 3,
                value: "WASHINGMACHINE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;
    class IfcElectricDistributionBoardTypeEnum {
        static{
            this.CONSUMERUNIT = {
                type: 3,
                value: "CONSUMERUNIT"
            };
        }
        static{
            this.DISTRIBUTIONBOARD = {
                type: 3,
                value: "DISTRIBUTIONBOARD"
            };
        }
        static{
            this.MOTORCONTROLCENTRE = {
                type: 3,
                value: "MOTORCONTROLCENTRE"
            };
        }
        static{
            this.SWITCHBOARD = {
                type: 3,
                value: "SWITCHBOARD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcElectricDistributionBoardTypeEnum = IfcElectricDistributionBoardTypeEnum;
    class IfcElectricFlowStorageDeviceTypeEnum {
        static{
            this.BATTERY = {
                type: 3,
                value: "BATTERY"
            };
        }
        static{
            this.CAPACITORBANK = {
                type: 3,
                value: "CAPACITORBANK"
            };
        }
        static{
            this.HARMONICFILTER = {
                type: 3,
                value: "HARMONICFILTER"
            };
        }
        static{
            this.INDUCTORBANK = {
                type: 3,
                value: "INDUCTORBANK"
            };
        }
        static{
            this.UPS = {
                type: 3,
                value: "UPS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;
    class IfcElectricGeneratorTypeEnum {
        static{
            this.CHP = {
                type: 3,
                value: "CHP"
            };
        }
        static{
            this.ENGINEGENERATOR = {
                type: 3,
                value: "ENGINEGENERATOR"
            };
        }
        static{
            this.STANDALONE = {
                type: 3,
                value: "STANDALONE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;
    class IfcElectricMotorTypeEnum {
        static{
            this.DC = {
                type: 3,
                value: "DC"
            };
        }
        static{
            this.INDUCTION = {
                type: 3,
                value: "INDUCTION"
            };
        }
        static{
            this.POLYPHASE = {
                type: 3,
                value: "POLYPHASE"
            };
        }
        static{
            this.RELUCTANCESYNCHRONOUS = {
                type: 3,
                value: "RELUCTANCESYNCHRONOUS"
            };
        }
        static{
            this.SYNCHRONOUS = {
                type: 3,
                value: "SYNCHRONOUS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;
    class IfcElectricTimeControlTypeEnum {
        static{
            this.TIMECLOCK = {
                type: 3,
                value: "TIMECLOCK"
            };
        }
        static{
            this.TIMEDELAY = {
                type: 3,
                value: "TIMEDELAY"
            };
        }
        static{
            this.RELAY = {
                type: 3,
                value: "RELAY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;
    class IfcElementAssemblyTypeEnum {
        static{
            this.ACCESSORY_ASSEMBLY = {
                type: 3,
                value: "ACCESSORY_ASSEMBLY"
            };
        }
        static{
            this.ARCH = {
                type: 3,
                value: "ARCH"
            };
        }
        static{
            this.BEAM_GRID = {
                type: 3,
                value: "BEAM_GRID"
            };
        }
        static{
            this.BRACED_FRAME = {
                type: 3,
                value: "BRACED_FRAME"
            };
        }
        static{
            this.GIRDER = {
                type: 3,
                value: "GIRDER"
            };
        }
        static{
            this.REINFORCEMENT_UNIT = {
                type: 3,
                value: "REINFORCEMENT_UNIT"
            };
        }
        static{
            this.RIGID_FRAME = {
                type: 3,
                value: "RIGID_FRAME"
            };
        }
        static{
            this.SLAB_FIELD = {
                type: 3,
                value: "SLAB_FIELD"
            };
        }
        static{
            this.TRUSS = {
                type: 3,
                value: "TRUSS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;
    class IfcElementCompositionEnum {
        static{
            this.COMPLEX = {
                type: 3,
                value: "COMPLEX"
            };
        }
        static{
            this.ELEMENT = {
                type: 3,
                value: "ELEMENT"
            };
        }
        static{
            this.PARTIAL = {
                type: 3,
                value: "PARTIAL"
            };
        }
    }
    IFC42.IfcElementCompositionEnum = IfcElementCompositionEnum;
    class IfcEngineTypeEnum {
        static{
            this.EXTERNALCOMBUSTION = {
                type: 3,
                value: "EXTERNALCOMBUSTION"
            };
        }
        static{
            this.INTERNALCOMBUSTION = {
                type: 3,
                value: "INTERNALCOMBUSTION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcEngineTypeEnum = IfcEngineTypeEnum;
    class IfcEvaporativeCoolerTypeEnum {
        static{
            this.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVEAIRWASHER = {
                type: 3,
                value: "DIRECTEVAPORATIVEAIRWASHER"
            };
        }
        static{
            this.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = {
                type: 3,
                value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER"
            };
        }
        static{
            this.INDIRECTEVAPORATIVEWETCOIL = {
                type: 3,
                value: "INDIRECTEVAPORATIVEWETCOIL"
            };
        }
        static{
            this.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = {
                type: 3,
                value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER"
            };
        }
        static{
            this.INDIRECTDIRECTCOMBINATION = {
                type: 3,
                value: "INDIRECTDIRECTCOMBINATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;
    class IfcEvaporatorTypeEnum {
        static{
            this.DIRECTEXPANSION = {
                type: 3,
                value: "DIRECTEXPANSION"
            };
        }
        static{
            this.DIRECTEXPANSIONSHELLANDTUBE = {
                type: 3,
                value: "DIRECTEXPANSIONSHELLANDTUBE"
            };
        }
        static{
            this.DIRECTEXPANSIONTUBEINTUBE = {
                type: 3,
                value: "DIRECTEXPANSIONTUBEINTUBE"
            };
        }
        static{
            this.DIRECTEXPANSIONBRAZEDPLATE = {
                type: 3,
                value: "DIRECTEXPANSIONBRAZEDPLATE"
            };
        }
        static{
            this.FLOODEDSHELLANDTUBE = {
                type: 3,
                value: "FLOODEDSHELLANDTUBE"
            };
        }
        static{
            this.SHELLANDCOIL = {
                type: 3,
                value: "SHELLANDCOIL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;
    class IfcEventTriggerTypeEnum {
        static{
            this.EVENTRULE = {
                type: 3,
                value: "EVENTRULE"
            };
        }
        static{
            this.EVENTMESSAGE = {
                type: 3,
                value: "EVENTMESSAGE"
            };
        }
        static{
            this.EVENTTIME = {
                type: 3,
                value: "EVENTTIME"
            };
        }
        static{
            this.EVENTCOMPLEX = {
                type: 3,
                value: "EVENTCOMPLEX"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcEventTriggerTypeEnum = IfcEventTriggerTypeEnum;
    class IfcEventTypeEnum {
        static{
            this.STARTEVENT = {
                type: 3,
                value: "STARTEVENT"
            };
        }
        static{
            this.ENDEVENT = {
                type: 3,
                value: "ENDEVENT"
            };
        }
        static{
            this.INTERMEDIATEEVENT = {
                type: 3,
                value: "INTERMEDIATEEVENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcEventTypeEnum = IfcEventTypeEnum;
    class IfcExternalSpatialElementTypeEnum {
        static{
            this.EXTERNAL = {
                type: 3,
                value: "EXTERNAL"
            };
        }
        static{
            this.EXTERNAL_EARTH = {
                type: 3,
                value: "EXTERNAL_EARTH"
            };
        }
        static{
            this.EXTERNAL_WATER = {
                type: 3,
                value: "EXTERNAL_WATER"
            };
        }
        static{
            this.EXTERNAL_FIRE = {
                type: 3,
                value: "EXTERNAL_FIRE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcExternalSpatialElementTypeEnum = IfcExternalSpatialElementTypeEnum;
    class IfcFanTypeEnum {
        static{
            this.CENTRIFUGALFORWARDCURVED = {
                type: 3,
                value: "CENTRIFUGALFORWARDCURVED"
            };
        }
        static{
            this.CENTRIFUGALRADIAL = {
                type: 3,
                value: "CENTRIFUGALRADIAL"
            };
        }
        static{
            this.CENTRIFUGALBACKWARDINCLINEDCURVED = {
                type: 3,
                value: "CENTRIFUGALBACKWARDINCLINEDCURVED"
            };
        }
        static{
            this.CENTRIFUGALAIRFOIL = {
                type: 3,
                value: "CENTRIFUGALAIRFOIL"
            };
        }
        static{
            this.TUBEAXIAL = {
                type: 3,
                value: "TUBEAXIAL"
            };
        }
        static{
            this.VANEAXIAL = {
                type: 3,
                value: "VANEAXIAL"
            };
        }
        static{
            this.PROPELLORAXIAL = {
                type: 3,
                value: "PROPELLORAXIAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcFanTypeEnum = IfcFanTypeEnum;
    class IfcFastenerTypeEnum {
        static{
            this.GLUE = {
                type: 3,
                value: "GLUE"
            };
        }
        static{
            this.MORTAR = {
                type: 3,
                value: "MORTAR"
            };
        }
        static{
            this.WELD = {
                type: 3,
                value: "WELD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcFastenerTypeEnum = IfcFastenerTypeEnum;
    class IfcFilterTypeEnum {
        static{
            this.AIRPARTICLEFILTER = {
                type: 3,
                value: "AIRPARTICLEFILTER"
            };
        }
        static{
            this.COMPRESSEDAIRFILTER = {
                type: 3,
                value: "COMPRESSEDAIRFILTER"
            };
        }
        static{
            this.ODORFILTER = {
                type: 3,
                value: "ODORFILTER"
            };
        }
        static{
            this.OILFILTER = {
                type: 3,
                value: "OILFILTER"
            };
        }
        static{
            this.STRAINER = {
                type: 3,
                value: "STRAINER"
            };
        }
        static{
            this.WATERFILTER = {
                type: 3,
                value: "WATERFILTER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcFilterTypeEnum = IfcFilterTypeEnum;
    class IfcFireSuppressionTerminalTypeEnum {
        static{
            this.BREECHINGINLET = {
                type: 3,
                value: "BREECHINGINLET"
            };
        }
        static{
            this.FIREHYDRANT = {
                type: 3,
                value: "FIREHYDRANT"
            };
        }
        static{
            this.HOSEREEL = {
                type: 3,
                value: "HOSEREEL"
            };
        }
        static{
            this.SPRINKLER = {
                type: 3,
                value: "SPRINKLER"
            };
        }
        static{
            this.SPRINKLERDEFLECTOR = {
                type: 3,
                value: "SPRINKLERDEFLECTOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;
    class IfcFlowDirectionEnum {
        static{
            this.SOURCE = {
                type: 3,
                value: "SOURCE"
            };
        }
        static{
            this.SINK = {
                type: 3,
                value: "SINK"
            };
        }
        static{
            this.SOURCEANDSINK = {
                type: 3,
                value: "SOURCEANDSINK"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcFlowDirectionEnum = IfcFlowDirectionEnum;
    class IfcFlowInstrumentTypeEnum {
        static{
            this.PRESSUREGAUGE = {
                type: 3,
                value: "PRESSUREGAUGE"
            };
        }
        static{
            this.THERMOMETER = {
                type: 3,
                value: "THERMOMETER"
            };
        }
        static{
            this.AMMETER = {
                type: 3,
                value: "AMMETER"
            };
        }
        static{
            this.FREQUENCYMETER = {
                type: 3,
                value: "FREQUENCYMETER"
            };
        }
        static{
            this.POWERFACTORMETER = {
                type: 3,
                value: "POWERFACTORMETER"
            };
        }
        static{
            this.PHASEANGLEMETER = {
                type: 3,
                value: "PHASEANGLEMETER"
            };
        }
        static{
            this.VOLTMETER_PEAK = {
                type: 3,
                value: "VOLTMETER_PEAK"
            };
        }
        static{
            this.VOLTMETER_RMS = {
                type: 3,
                value: "VOLTMETER_RMS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;
    class IfcFlowMeterTypeEnum {
        static{
            this.ENERGYMETER = {
                type: 3,
                value: "ENERGYMETER"
            };
        }
        static{
            this.GASMETER = {
                type: 3,
                value: "GASMETER"
            };
        }
        static{
            this.OILMETER = {
                type: 3,
                value: "OILMETER"
            };
        }
        static{
            this.WATERMETER = {
                type: 3,
                value: "WATERMETER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;
    class IfcFootingTypeEnum {
        static{
            this.CAISSON_FOUNDATION = {
                type: 3,
                value: "CAISSON_FOUNDATION"
            };
        }
        static{
            this.FOOTING_BEAM = {
                type: 3,
                value: "FOOTING_BEAM"
            };
        }
        static{
            this.PAD_FOOTING = {
                type: 3,
                value: "PAD_FOOTING"
            };
        }
        static{
            this.PILE_CAP = {
                type: 3,
                value: "PILE_CAP"
            };
        }
        static{
            this.STRIP_FOOTING = {
                type: 3,
                value: "STRIP_FOOTING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcFootingTypeEnum = IfcFootingTypeEnum;
    class IfcFurnitureTypeEnum {
        static{
            this.CHAIR = {
                type: 3,
                value: "CHAIR"
            };
        }
        static{
            this.TABLE = {
                type: 3,
                value: "TABLE"
            };
        }
        static{
            this.DESK = {
                type: 3,
                value: "DESK"
            };
        }
        static{
            this.BED = {
                type: 3,
                value: "BED"
            };
        }
        static{
            this.FILECABINET = {
                type: 3,
                value: "FILECABINET"
            };
        }
        static{
            this.SHELF = {
                type: 3,
                value: "SHELF"
            };
        }
        static{
            this.SOFA = {
                type: 3,
                value: "SOFA"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcFurnitureTypeEnum = IfcFurnitureTypeEnum;
    class IfcGeographicElementTypeEnum {
        static{
            this.TERRAIN = {
                type: 3,
                value: "TERRAIN"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcGeographicElementTypeEnum = IfcGeographicElementTypeEnum;
    class IfcGeometricProjectionEnum {
        static{
            this.GRAPH_VIEW = {
                type: 3,
                value: "GRAPH_VIEW"
            };
        }
        static{
            this.SKETCH_VIEW = {
                type: 3,
                value: "SKETCH_VIEW"
            };
        }
        static{
            this.MODEL_VIEW = {
                type: 3,
                value: "MODEL_VIEW"
            };
        }
        static{
            this.PLAN_VIEW = {
                type: 3,
                value: "PLAN_VIEW"
            };
        }
        static{
            this.REFLECTED_PLAN_VIEW = {
                type: 3,
                value: "REFLECTED_PLAN_VIEW"
            };
        }
        static{
            this.SECTION_VIEW = {
                type: 3,
                value: "SECTION_VIEW"
            };
        }
        static{
            this.ELEVATION_VIEW = {
                type: 3,
                value: "ELEVATION_VIEW"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;
    class IfcGlobalOrLocalEnum {
        static{
            this.GLOBAL_COORDS = {
                type: 3,
                value: "GLOBAL_COORDS"
            };
        }
        static{
            this.LOCAL_COORDS = {
                type: 3,
                value: "LOCAL_COORDS"
            };
        }
    }
    IFC42.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;
    class IfcGridTypeEnum {
        static{
            this.RECTANGULAR = {
                type: 3,
                value: "RECTANGULAR"
            };
        }
        static{
            this.RADIAL = {
                type: 3,
                value: "RADIAL"
            };
        }
        static{
            this.TRIANGULAR = {
                type: 3,
                value: "TRIANGULAR"
            };
        }
        static{
            this.IRREGULAR = {
                type: 3,
                value: "IRREGULAR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcGridTypeEnum = IfcGridTypeEnum;
    class IfcHeatExchangerTypeEnum {
        static{
            this.PLATE = {
                type: 3,
                value: "PLATE"
            };
        }
        static{
            this.SHELLANDTUBE = {
                type: 3,
                value: "SHELLANDTUBE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;
    class IfcHumidifierTypeEnum {
        static{
            this.STEAMINJECTION = {
                type: 3,
                value: "STEAMINJECTION"
            };
        }
        static{
            this.ADIABATICAIRWASHER = {
                type: 3,
                value: "ADIABATICAIRWASHER"
            };
        }
        static{
            this.ADIABATICPAN = {
                type: 3,
                value: "ADIABATICPAN"
            };
        }
        static{
            this.ADIABATICWETTEDELEMENT = {
                type: 3,
                value: "ADIABATICWETTEDELEMENT"
            };
        }
        static{
            this.ADIABATICATOMIZING = {
                type: 3,
                value: "ADIABATICATOMIZING"
            };
        }
        static{
            this.ADIABATICULTRASONIC = {
                type: 3,
                value: "ADIABATICULTRASONIC"
            };
        }
        static{
            this.ADIABATICRIGIDMEDIA = {
                type: 3,
                value: "ADIABATICRIGIDMEDIA"
            };
        }
        static{
            this.ADIABATICCOMPRESSEDAIRNOZZLE = {
                type: 3,
                value: "ADIABATICCOMPRESSEDAIRNOZZLE"
            };
        }
        static{
            this.ASSISTEDELECTRIC = {
                type: 3,
                value: "ASSISTEDELECTRIC"
            };
        }
        static{
            this.ASSISTEDNATURALGAS = {
                type: 3,
                value: "ASSISTEDNATURALGAS"
            };
        }
        static{
            this.ASSISTEDPROPANE = {
                type: 3,
                value: "ASSISTEDPROPANE"
            };
        }
        static{
            this.ASSISTEDBUTANE = {
                type: 3,
                value: "ASSISTEDBUTANE"
            };
        }
        static{
            this.ASSISTEDSTEAM = {
                type: 3,
                value: "ASSISTEDSTEAM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;
    class IfcInterceptorTypeEnum {
        static{
            this.CYCLONIC = {
                type: 3,
                value: "CYCLONIC"
            };
        }
        static{
            this.GREASE = {
                type: 3,
                value: "GREASE"
            };
        }
        static{
            this.OIL = {
                type: 3,
                value: "OIL"
            };
        }
        static{
            this.PETROL = {
                type: 3,
                value: "PETROL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcInterceptorTypeEnum = IfcInterceptorTypeEnum;
    class IfcInternalOrExternalEnum {
        static{
            this.INTERNAL = {
                type: 3,
                value: "INTERNAL"
            };
        }
        static{
            this.EXTERNAL = {
                type: 3,
                value: "EXTERNAL"
            };
        }
        static{
            this.EXTERNAL_EARTH = {
                type: 3,
                value: "EXTERNAL_EARTH"
            };
        }
        static{
            this.EXTERNAL_WATER = {
                type: 3,
                value: "EXTERNAL_WATER"
            };
        }
        static{
            this.EXTERNAL_FIRE = {
                type: 3,
                value: "EXTERNAL_FIRE"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;
    class IfcInventoryTypeEnum {
        static{
            this.ASSETINVENTORY = {
                type: 3,
                value: "ASSETINVENTORY"
            };
        }
        static{
            this.SPACEINVENTORY = {
                type: 3,
                value: "SPACEINVENTORY"
            };
        }
        static{
            this.FURNITUREINVENTORY = {
                type: 3,
                value: "FURNITUREINVENTORY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcInventoryTypeEnum = IfcInventoryTypeEnum;
    class IfcJunctionBoxTypeEnum {
        static{
            this.DATA = {
                type: 3,
                value: "DATA"
            };
        }
        static{
            this.POWER = {
                type: 3,
                value: "POWER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;
    class IfcKnotType {
        static{
            this.UNIFORM_KNOTS = {
                type: 3,
                value: "UNIFORM_KNOTS"
            };
        }
        static{
            this.QUASI_UNIFORM_KNOTS = {
                type: 3,
                value: "QUASI_UNIFORM_KNOTS"
            };
        }
        static{
            this.PIECEWISE_BEZIER_KNOTS = {
                type: 3,
                value: "PIECEWISE_BEZIER_KNOTS"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC42.IfcKnotType = IfcKnotType;
    class IfcLaborResourceTypeEnum {
        static{
            this.ADMINISTRATION = {
                type: 3,
                value: "ADMINISTRATION"
            };
        }
        static{
            this.CARPENTRY = {
                type: 3,
                value: "CARPENTRY"
            };
        }
        static{
            this.CLEANING = {
                type: 3,
                value: "CLEANING"
            };
        }
        static{
            this.CONCRETE = {
                type: 3,
                value: "CONCRETE"
            };
        }
        static{
            this.DRYWALL = {
                type: 3,
                value: "DRYWALL"
            };
        }
        static{
            this.ELECTRIC = {
                type: 3,
                value: "ELECTRIC"
            };
        }
        static{
            this.FINISHING = {
                type: 3,
                value: "FINISHING"
            };
        }
        static{
            this.FLOORING = {
                type: 3,
                value: "FLOORING"
            };
        }
        static{
            this.GENERAL = {
                type: 3,
                value: "GENERAL"
            };
        }
        static{
            this.HVAC = {
                type: 3,
                value: "HVAC"
            };
        }
        static{
            this.LANDSCAPING = {
                type: 3,
                value: "LANDSCAPING"
            };
        }
        static{
            this.MASONRY = {
                type: 3,
                value: "MASONRY"
            };
        }
        static{
            this.PAINTING = {
                type: 3,
                value: "PAINTING"
            };
        }
        static{
            this.PAVING = {
                type: 3,
                value: "PAVING"
            };
        }
        static{
            this.PLUMBING = {
                type: 3,
                value: "PLUMBING"
            };
        }
        static{
            this.ROOFING = {
                type: 3,
                value: "ROOFING"
            };
        }
        static{
            this.SITEGRADING = {
                type: 3,
                value: "SITEGRADING"
            };
        }
        static{
            this.STEELWORK = {
                type: 3,
                value: "STEELWORK"
            };
        }
        static{
            this.SURVEYING = {
                type: 3,
                value: "SURVEYING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcLaborResourceTypeEnum = IfcLaborResourceTypeEnum;
    class IfcLampTypeEnum {
        static{
            this.COMPACTFLUORESCENT = {
                type: 3,
                value: "COMPACTFLUORESCENT"
            };
        }
        static{
            this.FLUORESCENT = {
                type: 3,
                value: "FLUORESCENT"
            };
        }
        static{
            this.HALOGEN = {
                type: 3,
                value: "HALOGEN"
            };
        }
        static{
            this.HIGHPRESSUREMERCURY = {
                type: 3,
                value: "HIGHPRESSUREMERCURY"
            };
        }
        static{
            this.HIGHPRESSURESODIUM = {
                type: 3,
                value: "HIGHPRESSURESODIUM"
            };
        }
        static{
            this.LED = {
                type: 3,
                value: "LED"
            };
        }
        static{
            this.METALHALIDE = {
                type: 3,
                value: "METALHALIDE"
            };
        }
        static{
            this.OLED = {
                type: 3,
                value: "OLED"
            };
        }
        static{
            this.TUNGSTENFILAMENT = {
                type: 3,
                value: "TUNGSTENFILAMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcLampTypeEnum = IfcLampTypeEnum;
    class IfcLayerSetDirectionEnum {
        static{
            this.AXIS1 = {
                type: 3,
                value: "AXIS1"
            };
        }
        static{
            this.AXIS2 = {
                type: 3,
                value: "AXIS2"
            };
        }
        static{
            this.AXIS3 = {
                type: 3,
                value: "AXIS3"
            };
        }
    }
    IFC42.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;
    class IfcLightDistributionCurveEnum {
        static{
            this.TYPE_A = {
                type: 3,
                value: "TYPE_A"
            };
        }
        static{
            this.TYPE_B = {
                type: 3,
                value: "TYPE_B"
            };
        }
        static{
            this.TYPE_C = {
                type: 3,
                value: "TYPE_C"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;
    class IfcLightEmissionSourceEnum {
        static{
            this.COMPACTFLUORESCENT = {
                type: 3,
                value: "COMPACTFLUORESCENT"
            };
        }
        static{
            this.FLUORESCENT = {
                type: 3,
                value: "FLUORESCENT"
            };
        }
        static{
            this.HIGHPRESSUREMERCURY = {
                type: 3,
                value: "HIGHPRESSUREMERCURY"
            };
        }
        static{
            this.HIGHPRESSURESODIUM = {
                type: 3,
                value: "HIGHPRESSURESODIUM"
            };
        }
        static{
            this.LIGHTEMITTINGDIODE = {
                type: 3,
                value: "LIGHTEMITTINGDIODE"
            };
        }
        static{
            this.LOWPRESSURESODIUM = {
                type: 3,
                value: "LOWPRESSURESODIUM"
            };
        }
        static{
            this.LOWVOLTAGEHALOGEN = {
                type: 3,
                value: "LOWVOLTAGEHALOGEN"
            };
        }
        static{
            this.MAINVOLTAGEHALOGEN = {
                type: 3,
                value: "MAINVOLTAGEHALOGEN"
            };
        }
        static{
            this.METALHALIDE = {
                type: 3,
                value: "METALHALIDE"
            };
        }
        static{
            this.TUNGSTENFILAMENT = {
                type: 3,
                value: "TUNGSTENFILAMENT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;
    class IfcLightFixtureTypeEnum {
        static{
            this.POINTSOURCE = {
                type: 3,
                value: "POINTSOURCE"
            };
        }
        static{
            this.DIRECTIONSOURCE = {
                type: 3,
                value: "DIRECTIONSOURCE"
            };
        }
        static{
            this.SECURITYLIGHTING = {
                type: 3,
                value: "SECURITYLIGHTING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;
    class IfcLoadGroupTypeEnum {
        static{
            this.LOAD_GROUP = {
                type: 3,
                value: "LOAD_GROUP"
            };
        }
        static{
            this.LOAD_CASE = {
                type: 3,
                value: "LOAD_CASE"
            };
        }
        static{
            this.LOAD_COMBINATION = {
                type: 3,
                value: "LOAD_COMBINATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;
    class IfcLogicalOperatorEnum {
        static{
            this.LOGICALAND = {
                type: 3,
                value: "LOGICALAND"
            };
        }
        static{
            this.LOGICALOR = {
                type: 3,
                value: "LOGICALOR"
            };
        }
        static{
            this.LOGICALXOR = {
                type: 3,
                value: "LOGICALXOR"
            };
        }
        static{
            this.LOGICALNOTAND = {
                type: 3,
                value: "LOGICALNOTAND"
            };
        }
        static{
            this.LOGICALNOTOR = {
                type: 3,
                value: "LOGICALNOTOR"
            };
        }
    }
    IFC42.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;
    class IfcMechanicalFastenerTypeEnum {
        static{
            this.ANCHORBOLT = {
                type: 3,
                value: "ANCHORBOLT"
            };
        }
        static{
            this.BOLT = {
                type: 3,
                value: "BOLT"
            };
        }
        static{
            this.DOWEL = {
                type: 3,
                value: "DOWEL"
            };
        }
        static{
            this.NAIL = {
                type: 3,
                value: "NAIL"
            };
        }
        static{
            this.NAILPLATE = {
                type: 3,
                value: "NAILPLATE"
            };
        }
        static{
            this.RIVET = {
                type: 3,
                value: "RIVET"
            };
        }
        static{
            this.SCREW = {
                type: 3,
                value: "SCREW"
            };
        }
        static{
            this.SHEARCONNECTOR = {
                type: 3,
                value: "SHEARCONNECTOR"
            };
        }
        static{
            this.STAPLE = {
                type: 3,
                value: "STAPLE"
            };
        }
        static{
            this.STUDSHEARCONNECTOR = {
                type: 3,
                value: "STUDSHEARCONNECTOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcMechanicalFastenerTypeEnum = IfcMechanicalFastenerTypeEnum;
    class IfcMedicalDeviceTypeEnum {
        static{
            this.AIRSTATION = {
                type: 3,
                value: "AIRSTATION"
            };
        }
        static{
            this.FEEDAIRUNIT = {
                type: 3,
                value: "FEEDAIRUNIT"
            };
        }
        static{
            this.OXYGENGENERATOR = {
                type: 3,
                value: "OXYGENGENERATOR"
            };
        }
        static{
            this.OXYGENPLANT = {
                type: 3,
                value: "OXYGENPLANT"
            };
        }
        static{
            this.VACUUMSTATION = {
                type: 3,
                value: "VACUUMSTATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcMedicalDeviceTypeEnum = IfcMedicalDeviceTypeEnum;
    class IfcMemberTypeEnum {
        static{
            this.BRACE = {
                type: 3,
                value: "BRACE"
            };
        }
        static{
            this.CHORD = {
                type: 3,
                value: "CHORD"
            };
        }
        static{
            this.COLLAR = {
                type: 3,
                value: "COLLAR"
            };
        }
        static{
            this.MEMBER = {
                type: 3,
                value: "MEMBER"
            };
        }
        static{
            this.MULLION = {
                type: 3,
                value: "MULLION"
            };
        }
        static{
            this.PLATE = {
                type: 3,
                value: "PLATE"
            };
        }
        static{
            this.POST = {
                type: 3,
                value: "POST"
            };
        }
        static{
            this.PURLIN = {
                type: 3,
                value: "PURLIN"
            };
        }
        static{
            this.RAFTER = {
                type: 3,
                value: "RAFTER"
            };
        }
        static{
            this.STRINGER = {
                type: 3,
                value: "STRINGER"
            };
        }
        static{
            this.STRUT = {
                type: 3,
                value: "STRUT"
            };
        }
        static{
            this.STUD = {
                type: 3,
                value: "STUD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcMemberTypeEnum = IfcMemberTypeEnum;
    class IfcMotorConnectionTypeEnum {
        static{
            this.BELTDRIVE = {
                type: 3,
                value: "BELTDRIVE"
            };
        }
        static{
            this.COUPLING = {
                type: 3,
                value: "COUPLING"
            };
        }
        static{
            this.DIRECTDRIVE = {
                type: 3,
                value: "DIRECTDRIVE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;
    class IfcNullStyle {
        static{
            this.NULL = {
                type: 3,
                value: "NULL"
            };
        }
    }
    IFC42.IfcNullStyle = IfcNullStyle;
    class IfcObjectTypeEnum {
        static{
            this.PRODUCT = {
                type: 3,
                value: "PRODUCT"
            };
        }
        static{
            this.PROCESS = {
                type: 3,
                value: "PROCESS"
            };
        }
        static{
            this.CONTROL = {
                type: 3,
                value: "CONTROL"
            };
        }
        static{
            this.RESOURCE = {
                type: 3,
                value: "RESOURCE"
            };
        }
        static{
            this.ACTOR = {
                type: 3,
                value: "ACTOR"
            };
        }
        static{
            this.GROUP = {
                type: 3,
                value: "GROUP"
            };
        }
        static{
            this.PROJECT = {
                type: 3,
                value: "PROJECT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcObjectTypeEnum = IfcObjectTypeEnum;
    class IfcObjectiveEnum {
        static{
            this.CODECOMPLIANCE = {
                type: 3,
                value: "CODECOMPLIANCE"
            };
        }
        static{
            this.CODEWAIVER = {
                type: 3,
                value: "CODEWAIVER"
            };
        }
        static{
            this.DESIGNINTENT = {
                type: 3,
                value: "DESIGNINTENT"
            };
        }
        static{
            this.EXTERNAL = {
                type: 3,
                value: "EXTERNAL"
            };
        }
        static{
            this.HEALTHANDSAFETY = {
                type: 3,
                value: "HEALTHANDSAFETY"
            };
        }
        static{
            this.MERGECONFLICT = {
                type: 3,
                value: "MERGECONFLICT"
            };
        }
        static{
            this.MODELVIEW = {
                type: 3,
                value: "MODELVIEW"
            };
        }
        static{
            this.PARAMETER = {
                type: 3,
                value: "PARAMETER"
            };
        }
        static{
            this.REQUIREMENT = {
                type: 3,
                value: "REQUIREMENT"
            };
        }
        static{
            this.SPECIFICATION = {
                type: 3,
                value: "SPECIFICATION"
            };
        }
        static{
            this.TRIGGERCONDITION = {
                type: 3,
                value: "TRIGGERCONDITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcObjectiveEnum = IfcObjectiveEnum;
    class IfcOccupantTypeEnum {
        static{
            this.ASSIGNEE = {
                type: 3,
                value: "ASSIGNEE"
            };
        }
        static{
            this.ASSIGNOR = {
                type: 3,
                value: "ASSIGNOR"
            };
        }
        static{
            this.LESSEE = {
                type: 3,
                value: "LESSEE"
            };
        }
        static{
            this.LESSOR = {
                type: 3,
                value: "LESSOR"
            };
        }
        static{
            this.LETTINGAGENT = {
                type: 3,
                value: "LETTINGAGENT"
            };
        }
        static{
            this.OWNER = {
                type: 3,
                value: "OWNER"
            };
        }
        static{
            this.TENANT = {
                type: 3,
                value: "TENANT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcOccupantTypeEnum = IfcOccupantTypeEnum;
    class IfcOpeningElementTypeEnum {
        static{
            this.OPENING = {
                type: 3,
                value: "OPENING"
            };
        }
        static{
            this.RECESS = {
                type: 3,
                value: "RECESS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcOpeningElementTypeEnum = IfcOpeningElementTypeEnum;
    class IfcOutletTypeEnum {
        static{
            this.AUDIOVISUALOUTLET = {
                type: 3,
                value: "AUDIOVISUALOUTLET"
            };
        }
        static{
            this.COMMUNICATIONSOUTLET = {
                type: 3,
                value: "COMMUNICATIONSOUTLET"
            };
        }
        static{
            this.POWEROUTLET = {
                type: 3,
                value: "POWEROUTLET"
            };
        }
        static{
            this.DATAOUTLET = {
                type: 3,
                value: "DATAOUTLET"
            };
        }
        static{
            this.TELEPHONEOUTLET = {
                type: 3,
                value: "TELEPHONEOUTLET"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcOutletTypeEnum = IfcOutletTypeEnum;
    class IfcPerformanceHistoryTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPerformanceHistoryTypeEnum = IfcPerformanceHistoryTypeEnum;
    class IfcPermeableCoveringOperationEnum {
        static{
            this.GRILL = {
                type: 3,
                value: "GRILL"
            };
        }
        static{
            this.LOUVER = {
                type: 3,
                value: "LOUVER"
            };
        }
        static{
            this.SCREEN = {
                type: 3,
                value: "SCREEN"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;
    class IfcPermitTypeEnum {
        static{
            this.ACCESS = {
                type: 3,
                value: "ACCESS"
            };
        }
        static{
            this.BUILDING = {
                type: 3,
                value: "BUILDING"
            };
        }
        static{
            this.WORK = {
                type: 3,
                value: "WORK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPermitTypeEnum = IfcPermitTypeEnum;
    class IfcPhysicalOrVirtualEnum {
        static{
            this.PHYSICAL = {
                type: 3,
                value: "PHYSICAL"
            };
        }
        static{
            this.VIRTUAL = {
                type: 3,
                value: "VIRTUAL"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;
    class IfcPileConstructionEnum {
        static{
            this.CAST_IN_PLACE = {
                type: 3,
                value: "CAST_IN_PLACE"
            };
        }
        static{
            this.COMPOSITE = {
                type: 3,
                value: "COMPOSITE"
            };
        }
        static{
            this.PRECAST_CONCRETE = {
                type: 3,
                value: "PRECAST_CONCRETE"
            };
        }
        static{
            this.PREFAB_STEEL = {
                type: 3,
                value: "PREFAB_STEEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPileConstructionEnum = IfcPileConstructionEnum;
    class IfcPileTypeEnum {
        static{
            this.BORED = {
                type: 3,
                value: "BORED"
            };
        }
        static{
            this.DRIVEN = {
                type: 3,
                value: "DRIVEN"
            };
        }
        static{
            this.JETGROUTING = {
                type: 3,
                value: "JETGROUTING"
            };
        }
        static{
            this.COHESION = {
                type: 3,
                value: "COHESION"
            };
        }
        static{
            this.FRICTION = {
                type: 3,
                value: "FRICTION"
            };
        }
        static{
            this.SUPPORT = {
                type: 3,
                value: "SUPPORT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPileTypeEnum = IfcPileTypeEnum;
    class IfcPipeFittingTypeEnum {
        static{
            this.BEND = {
                type: 3,
                value: "BEND"
            };
        }
        static{
            this.CONNECTOR = {
                type: 3,
                value: "CONNECTOR"
            };
        }
        static{
            this.ENTRY = {
                type: 3,
                value: "ENTRY"
            };
        }
        static{
            this.EXIT = {
                type: 3,
                value: "EXIT"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.OBSTRUCTION = {
                type: 3,
                value: "OBSTRUCTION"
            };
        }
        static{
            this.TRANSITION = {
                type: 3,
                value: "TRANSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;
    class IfcPipeSegmentTypeEnum {
        static{
            this.CULVERT = {
                type: 3,
                value: "CULVERT"
            };
        }
        static{
            this.FLEXIBLESEGMENT = {
                type: 3,
                value: "FLEXIBLESEGMENT"
            };
        }
        static{
            this.RIGIDSEGMENT = {
                type: 3,
                value: "RIGIDSEGMENT"
            };
        }
        static{
            this.GUTTER = {
                type: 3,
                value: "GUTTER"
            };
        }
        static{
            this.SPOOL = {
                type: 3,
                value: "SPOOL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;
    class IfcPlateTypeEnum {
        static{
            this.CURTAIN_PANEL = {
                type: 3,
                value: "CURTAIN_PANEL"
            };
        }
        static{
            this.SHEET = {
                type: 3,
                value: "SHEET"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPlateTypeEnum = IfcPlateTypeEnum;
    class IfcPreferredSurfaceCurveRepresentation {
        static{
            this.CURVE3D = {
                type: 3,
                value: "CURVE3D"
            };
        }
        static{
            this.PCURVE_S1 = {
                type: 3,
                value: "PCURVE_S1"
            };
        }
        static{
            this.PCURVE_S2 = {
                type: 3,
                value: "PCURVE_S2"
            };
        }
    }
    IFC42.IfcPreferredSurfaceCurveRepresentation = IfcPreferredSurfaceCurveRepresentation;
    class IfcProcedureTypeEnum {
        static{
            this.ADVICE_CAUTION = {
                type: 3,
                value: "ADVICE_CAUTION"
            };
        }
        static{
            this.ADVICE_NOTE = {
                type: 3,
                value: "ADVICE_NOTE"
            };
        }
        static{
            this.ADVICE_WARNING = {
                type: 3,
                value: "ADVICE_WARNING"
            };
        }
        static{
            this.CALIBRATION = {
                type: 3,
                value: "CALIBRATION"
            };
        }
        static{
            this.DIAGNOSTIC = {
                type: 3,
                value: "DIAGNOSTIC"
            };
        }
        static{
            this.SHUTDOWN = {
                type: 3,
                value: "SHUTDOWN"
            };
        }
        static{
            this.STARTUP = {
                type: 3,
                value: "STARTUP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcProcedureTypeEnum = IfcProcedureTypeEnum;
    class IfcProfileTypeEnum {
        static{
            this.CURVE = {
                type: 3,
                value: "CURVE"
            };
        }
        static{
            this.AREA = {
                type: 3,
                value: "AREA"
            };
        }
    }
    IFC42.IfcProfileTypeEnum = IfcProfileTypeEnum;
    class IfcProjectOrderTypeEnum {
        static{
            this.CHANGEORDER = {
                type: 3,
                value: "CHANGEORDER"
            };
        }
        static{
            this.MAINTENANCEWORKORDER = {
                type: 3,
                value: "MAINTENANCEWORKORDER"
            };
        }
        static{
            this.MOVEORDER = {
                type: 3,
                value: "MOVEORDER"
            };
        }
        static{
            this.PURCHASEORDER = {
                type: 3,
                value: "PURCHASEORDER"
            };
        }
        static{
            this.WORKORDER = {
                type: 3,
                value: "WORKORDER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;
    class IfcProjectedOrTrueLengthEnum {
        static{
            this.PROJECTED_LENGTH = {
                type: 3,
                value: "PROJECTED_LENGTH"
            };
        }
        static{
            this.TRUE_LENGTH = {
                type: 3,
                value: "TRUE_LENGTH"
            };
        }
    }
    IFC42.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;
    class IfcProjectionElementTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcProjectionElementTypeEnum = IfcProjectionElementTypeEnum;
    class IfcPropertySetTemplateTypeEnum {
        static{
            this.PSET_TYPEDRIVENONLY = {
                type: 3,
                value: "PSET_TYPEDRIVENONLY"
            };
        }
        static{
            this.PSET_TYPEDRIVENOVERRIDE = {
                type: 3,
                value: "PSET_TYPEDRIVENOVERRIDE"
            };
        }
        static{
            this.PSET_OCCURRENCEDRIVEN = {
                type: 3,
                value: "PSET_OCCURRENCEDRIVEN"
            };
        }
        static{
            this.PSET_PERFORMANCEDRIVEN = {
                type: 3,
                value: "PSET_PERFORMANCEDRIVEN"
            };
        }
        static{
            this.QTO_TYPEDRIVENONLY = {
                type: 3,
                value: "QTO_TYPEDRIVENONLY"
            };
        }
        static{
            this.QTO_TYPEDRIVENOVERRIDE = {
                type: 3,
                value: "QTO_TYPEDRIVENOVERRIDE"
            };
        }
        static{
            this.QTO_OCCURRENCEDRIVEN = {
                type: 3,
                value: "QTO_OCCURRENCEDRIVEN"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPropertySetTemplateTypeEnum = IfcPropertySetTemplateTypeEnum;
    class IfcProtectiveDeviceTrippingUnitTypeEnum {
        static{
            this.ELECTRONIC = {
                type: 3,
                value: "ELECTRONIC"
            };
        }
        static{
            this.ELECTROMAGNETIC = {
                type: 3,
                value: "ELECTROMAGNETIC"
            };
        }
        static{
            this.RESIDUALCURRENT = {
                type: 3,
                value: "RESIDUALCURRENT"
            };
        }
        static{
            this.THERMAL = {
                type: 3,
                value: "THERMAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcProtectiveDeviceTrippingUnitTypeEnum = IfcProtectiveDeviceTrippingUnitTypeEnum;
    class IfcProtectiveDeviceTypeEnum {
        static{
            this.CIRCUITBREAKER = {
                type: 3,
                value: "CIRCUITBREAKER"
            };
        }
        static{
            this.EARTHLEAKAGECIRCUITBREAKER = {
                type: 3,
                value: "EARTHLEAKAGECIRCUITBREAKER"
            };
        }
        static{
            this.EARTHINGSWITCH = {
                type: 3,
                value: "EARTHINGSWITCH"
            };
        }
        static{
            this.FUSEDISCONNECTOR = {
                type: 3,
                value: "FUSEDISCONNECTOR"
            };
        }
        static{
            this.RESIDUALCURRENTCIRCUITBREAKER = {
                type: 3,
                value: "RESIDUALCURRENTCIRCUITBREAKER"
            };
        }
        static{
            this.RESIDUALCURRENTSWITCH = {
                type: 3,
                value: "RESIDUALCURRENTSWITCH"
            };
        }
        static{
            this.VARISTOR = {
                type: 3,
                value: "VARISTOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;
    class IfcPumpTypeEnum {
        static{
            this.CIRCULATOR = {
                type: 3,
                value: "CIRCULATOR"
            };
        }
        static{
            this.ENDSUCTION = {
                type: 3,
                value: "ENDSUCTION"
            };
        }
        static{
            this.SPLITCASE = {
                type: 3,
                value: "SPLITCASE"
            };
        }
        static{
            this.SUBMERSIBLEPUMP = {
                type: 3,
                value: "SUBMERSIBLEPUMP"
            };
        }
        static{
            this.SUMPPUMP = {
                type: 3,
                value: "SUMPPUMP"
            };
        }
        static{
            this.VERTICALINLINE = {
                type: 3,
                value: "VERTICALINLINE"
            };
        }
        static{
            this.VERTICALTURBINE = {
                type: 3,
                value: "VERTICALTURBINE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcPumpTypeEnum = IfcPumpTypeEnum;
    class IfcRailingTypeEnum {
        static{
            this.HANDRAIL = {
                type: 3,
                value: "HANDRAIL"
            };
        }
        static{
            this.GUARDRAIL = {
                type: 3,
                value: "GUARDRAIL"
            };
        }
        static{
            this.BALUSTRADE = {
                type: 3,
                value: "BALUSTRADE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcRailingTypeEnum = IfcRailingTypeEnum;
    class IfcRampFlightTypeEnum {
        static{
            this.STRAIGHT = {
                type: 3,
                value: "STRAIGHT"
            };
        }
        static{
            this.SPIRAL = {
                type: 3,
                value: "SPIRAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;
    class IfcRampTypeEnum {
        static{
            this.STRAIGHT_RUN_RAMP = {
                type: 3,
                value: "STRAIGHT_RUN_RAMP"
            };
        }
        static{
            this.TWO_STRAIGHT_RUN_RAMP = {
                type: 3,
                value: "TWO_STRAIGHT_RUN_RAMP"
            };
        }
        static{
            this.QUARTER_TURN_RAMP = {
                type: 3,
                value: "QUARTER_TURN_RAMP"
            };
        }
        static{
            this.TWO_QUARTER_TURN_RAMP = {
                type: 3,
                value: "TWO_QUARTER_TURN_RAMP"
            };
        }
        static{
            this.HALF_TURN_RAMP = {
                type: 3,
                value: "HALF_TURN_RAMP"
            };
        }
        static{
            this.SPIRAL_RAMP = {
                type: 3,
                value: "SPIRAL_RAMP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcRampTypeEnum = IfcRampTypeEnum;
    class IfcRecurrenceTypeEnum {
        static{
            this.DAILY = {
                type: 3,
                value: "DAILY"
            };
        }
        static{
            this.WEEKLY = {
                type: 3,
                value: "WEEKLY"
            };
        }
        static{
            this.MONTHLY_BY_DAY_OF_MONTH = {
                type: 3,
                value: "MONTHLY_BY_DAY_OF_MONTH"
            };
        }
        static{
            this.MONTHLY_BY_POSITION = {
                type: 3,
                value: "MONTHLY_BY_POSITION"
            };
        }
        static{
            this.BY_DAY_COUNT = {
                type: 3,
                value: "BY_DAY_COUNT"
            };
        }
        static{
            this.BY_WEEKDAY_COUNT = {
                type: 3,
                value: "BY_WEEKDAY_COUNT"
            };
        }
        static{
            this.YEARLY_BY_DAY_OF_MONTH = {
                type: 3,
                value: "YEARLY_BY_DAY_OF_MONTH"
            };
        }
        static{
            this.YEARLY_BY_POSITION = {
                type: 3,
                value: "YEARLY_BY_POSITION"
            };
        }
    }
    IFC42.IfcRecurrenceTypeEnum = IfcRecurrenceTypeEnum;
    class IfcReflectanceMethodEnum {
        static{
            this.BLINN = {
                type: 3,
                value: "BLINN"
            };
        }
        static{
            this.FLAT = {
                type: 3,
                value: "FLAT"
            };
        }
        static{
            this.GLASS = {
                type: 3,
                value: "GLASS"
            };
        }
        static{
            this.MATT = {
                type: 3,
                value: "MATT"
            };
        }
        static{
            this.METAL = {
                type: 3,
                value: "METAL"
            };
        }
        static{
            this.MIRROR = {
                type: 3,
                value: "MIRROR"
            };
        }
        static{
            this.PHONG = {
                type: 3,
                value: "PHONG"
            };
        }
        static{
            this.PLASTIC = {
                type: 3,
                value: "PLASTIC"
            };
        }
        static{
            this.STRAUSS = {
                type: 3,
                value: "STRAUSS"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;
    class IfcReinforcingBarRoleEnum {
        static{
            this.MAIN = {
                type: 3,
                value: "MAIN"
            };
        }
        static{
            this.SHEAR = {
                type: 3,
                value: "SHEAR"
            };
        }
        static{
            this.LIGATURE = {
                type: 3,
                value: "LIGATURE"
            };
        }
        static{
            this.STUD = {
                type: 3,
                value: "STUD"
            };
        }
        static{
            this.PUNCHING = {
                type: 3,
                value: "PUNCHING"
            };
        }
        static{
            this.EDGE = {
                type: 3,
                value: "EDGE"
            };
        }
        static{
            this.RING = {
                type: 3,
                value: "RING"
            };
        }
        static{
            this.ANCHORING = {
                type: 3,
                value: "ANCHORING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;
    class IfcReinforcingBarSurfaceEnum {
        static{
            this.PLAIN = {
                type: 3,
                value: "PLAIN"
            };
        }
        static{
            this.TEXTURED = {
                type: 3,
                value: "TEXTURED"
            };
        }
    }
    IFC42.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;
    class IfcReinforcingBarTypeEnum {
        static{
            this.ANCHORING = {
                type: 3,
                value: "ANCHORING"
            };
        }
        static{
            this.EDGE = {
                type: 3,
                value: "EDGE"
            };
        }
        static{
            this.LIGATURE = {
                type: 3,
                value: "LIGATURE"
            };
        }
        static{
            this.MAIN = {
                type: 3,
                value: "MAIN"
            };
        }
        static{
            this.PUNCHING = {
                type: 3,
                value: "PUNCHING"
            };
        }
        static{
            this.RING = {
                type: 3,
                value: "RING"
            };
        }
        static{
            this.SHEAR = {
                type: 3,
                value: "SHEAR"
            };
        }
        static{
            this.STUD = {
                type: 3,
                value: "STUD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcReinforcingBarTypeEnum = IfcReinforcingBarTypeEnum;
    class IfcReinforcingMeshTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcReinforcingMeshTypeEnum = IfcReinforcingMeshTypeEnum;
    class IfcRoleEnum {
        static{
            this.SUPPLIER = {
                type: 3,
                value: "SUPPLIER"
            };
        }
        static{
            this.MANUFACTURER = {
                type: 3,
                value: "MANUFACTURER"
            };
        }
        static{
            this.CONTRACTOR = {
                type: 3,
                value: "CONTRACTOR"
            };
        }
        static{
            this.SUBCONTRACTOR = {
                type: 3,
                value: "SUBCONTRACTOR"
            };
        }
        static{
            this.ARCHITECT = {
                type: 3,
                value: "ARCHITECT"
            };
        }
        static{
            this.STRUCTURALENGINEER = {
                type: 3,
                value: "STRUCTURALENGINEER"
            };
        }
        static{
            this.COSTENGINEER = {
                type: 3,
                value: "COSTENGINEER"
            };
        }
        static{
            this.CLIENT = {
                type: 3,
                value: "CLIENT"
            };
        }
        static{
            this.BUILDINGOWNER = {
                type: 3,
                value: "BUILDINGOWNER"
            };
        }
        static{
            this.BUILDINGOPERATOR = {
                type: 3,
                value: "BUILDINGOPERATOR"
            };
        }
        static{
            this.MECHANICALENGINEER = {
                type: 3,
                value: "MECHANICALENGINEER"
            };
        }
        static{
            this.ELECTRICALENGINEER = {
                type: 3,
                value: "ELECTRICALENGINEER"
            };
        }
        static{
            this.PROJECTMANAGER = {
                type: 3,
                value: "PROJECTMANAGER"
            };
        }
        static{
            this.FACILITIESMANAGER = {
                type: 3,
                value: "FACILITIESMANAGER"
            };
        }
        static{
            this.CIVILENGINEER = {
                type: 3,
                value: "CIVILENGINEER"
            };
        }
        static{
            this.COMMISSIONINGENGINEER = {
                type: 3,
                value: "COMMISSIONINGENGINEER"
            };
        }
        static{
            this.ENGINEER = {
                type: 3,
                value: "ENGINEER"
            };
        }
        static{
            this.OWNER = {
                type: 3,
                value: "OWNER"
            };
        }
        static{
            this.CONSULTANT = {
                type: 3,
                value: "CONSULTANT"
            };
        }
        static{
            this.CONSTRUCTIONMANAGER = {
                type: 3,
                value: "CONSTRUCTIONMANAGER"
            };
        }
        static{
            this.FIELDCONSTRUCTIONMANAGER = {
                type: 3,
                value: "FIELDCONSTRUCTIONMANAGER"
            };
        }
        static{
            this.RESELLER = {
                type: 3,
                value: "RESELLER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC42.IfcRoleEnum = IfcRoleEnum;
    class IfcRoofTypeEnum {
        static{
            this.FLAT_ROOF = {
                type: 3,
                value: "FLAT_ROOF"
            };
        }
        static{
            this.SHED_ROOF = {
                type: 3,
                value: "SHED_ROOF"
            };
        }
        static{
            this.GABLE_ROOF = {
                type: 3,
                value: "GABLE_ROOF"
            };
        }
        static{
            this.HIP_ROOF = {
                type: 3,
                value: "HIP_ROOF"
            };
        }
        static{
            this.HIPPED_GABLE_ROOF = {
                type: 3,
                value: "HIPPED_GABLE_ROOF"
            };
        }
        static{
            this.GAMBREL_ROOF = {
                type: 3,
                value: "GAMBREL_ROOF"
            };
        }
        static{
            this.MANSARD_ROOF = {
                type: 3,
                value: "MANSARD_ROOF"
            };
        }
        static{
            this.BARREL_ROOF = {
                type: 3,
                value: "BARREL_ROOF"
            };
        }
        static{
            this.RAINBOW_ROOF = {
                type: 3,
                value: "RAINBOW_ROOF"
            };
        }
        static{
            this.BUTTERFLY_ROOF = {
                type: 3,
                value: "BUTTERFLY_ROOF"
            };
        }
        static{
            this.PAVILION_ROOF = {
                type: 3,
                value: "PAVILION_ROOF"
            };
        }
        static{
            this.DOME_ROOF = {
                type: 3,
                value: "DOME_ROOF"
            };
        }
        static{
            this.FREEFORM = {
                type: 3,
                value: "FREEFORM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcRoofTypeEnum = IfcRoofTypeEnum;
    class IfcSIPrefix {
        static{
            this.EXA = {
                type: 3,
                value: "EXA"
            };
        }
        static{
            this.PETA = {
                type: 3,
                value: "PETA"
            };
        }
        static{
            this.TERA = {
                type: 3,
                value: "TERA"
            };
        }
        static{
            this.GIGA = {
                type: 3,
                value: "GIGA"
            };
        }
        static{
            this.MEGA = {
                type: 3,
                value: "MEGA"
            };
        }
        static{
            this.KILO = {
                type: 3,
                value: "KILO"
            };
        }
        static{
            this.HECTO = {
                type: 3,
                value: "HECTO"
            };
        }
        static{
            this.DECA = {
                type: 3,
                value: "DECA"
            };
        }
        static{
            this.DECI = {
                type: 3,
                value: "DECI"
            };
        }
        static{
            this.CENTI = {
                type: 3,
                value: "CENTI"
            };
        }
        static{
            this.MILLI = {
                type: 3,
                value: "MILLI"
            };
        }
        static{
            this.MICRO = {
                type: 3,
                value: "MICRO"
            };
        }
        static{
            this.NANO = {
                type: 3,
                value: "NANO"
            };
        }
        static{
            this.PICO = {
                type: 3,
                value: "PICO"
            };
        }
        static{
            this.FEMTO = {
                type: 3,
                value: "FEMTO"
            };
        }
        static{
            this.ATTO = {
                type: 3,
                value: "ATTO"
            };
        }
    }
    IFC42.IfcSIPrefix = IfcSIPrefix;
    class IfcSIUnitName {
        static{
            this.AMPERE = {
                type: 3,
                value: "AMPERE"
            };
        }
        static{
            this.BECQUEREL = {
                type: 3,
                value: "BECQUEREL"
            };
        }
        static{
            this.CANDELA = {
                type: 3,
                value: "CANDELA"
            };
        }
        static{
            this.COULOMB = {
                type: 3,
                value: "COULOMB"
            };
        }
        static{
            this.CUBIC_METRE = {
                type: 3,
                value: "CUBIC_METRE"
            };
        }
        static{
            this.DEGREE_CELSIUS = {
                type: 3,
                value: "DEGREE_CELSIUS"
            };
        }
        static{
            this.FARAD = {
                type: 3,
                value: "FARAD"
            };
        }
        static{
            this.GRAM = {
                type: 3,
                value: "GRAM"
            };
        }
        static{
            this.GRAY = {
                type: 3,
                value: "GRAY"
            };
        }
        static{
            this.HENRY = {
                type: 3,
                value: "HENRY"
            };
        }
        static{
            this.HERTZ = {
                type: 3,
                value: "HERTZ"
            };
        }
        static{
            this.JOULE = {
                type: 3,
                value: "JOULE"
            };
        }
        static{
            this.KELVIN = {
                type: 3,
                value: "KELVIN"
            };
        }
        static{
            this.LUMEN = {
                type: 3,
                value: "LUMEN"
            };
        }
        static{
            this.LUX = {
                type: 3,
                value: "LUX"
            };
        }
        static{
            this.METRE = {
                type: 3,
                value: "METRE"
            };
        }
        static{
            this.MOLE = {
                type: 3,
                value: "MOLE"
            };
        }
        static{
            this.NEWTON = {
                type: 3,
                value: "NEWTON"
            };
        }
        static{
            this.OHM = {
                type: 3,
                value: "OHM"
            };
        }
        static{
            this.PASCAL = {
                type: 3,
                value: "PASCAL"
            };
        }
        static{
            this.RADIAN = {
                type: 3,
                value: "RADIAN"
            };
        }
        static{
            this.SECOND = {
                type: 3,
                value: "SECOND"
            };
        }
        static{
            this.SIEMENS = {
                type: 3,
                value: "SIEMENS"
            };
        }
        static{
            this.SIEVERT = {
                type: 3,
                value: "SIEVERT"
            };
        }
        static{
            this.SQUARE_METRE = {
                type: 3,
                value: "SQUARE_METRE"
            };
        }
        static{
            this.STERADIAN = {
                type: 3,
                value: "STERADIAN"
            };
        }
        static{
            this.TESLA = {
                type: 3,
                value: "TESLA"
            };
        }
        static{
            this.VOLT = {
                type: 3,
                value: "VOLT"
            };
        }
        static{
            this.WATT = {
                type: 3,
                value: "WATT"
            };
        }
        static{
            this.WEBER = {
                type: 3,
                value: "WEBER"
            };
        }
    }
    IFC42.IfcSIUnitName = IfcSIUnitName;
    class IfcSanitaryTerminalTypeEnum {
        static{
            this.BATH = {
                type: 3,
                value: "BATH"
            };
        }
        static{
            this.BIDET = {
                type: 3,
                value: "BIDET"
            };
        }
        static{
            this.CISTERN = {
                type: 3,
                value: "CISTERN"
            };
        }
        static{
            this.SHOWER = {
                type: 3,
                value: "SHOWER"
            };
        }
        static{
            this.SINK = {
                type: 3,
                value: "SINK"
            };
        }
        static{
            this.SANITARYFOUNTAIN = {
                type: 3,
                value: "SANITARYFOUNTAIN"
            };
        }
        static{
            this.TOILETPAN = {
                type: 3,
                value: "TOILETPAN"
            };
        }
        static{
            this.URINAL = {
                type: 3,
                value: "URINAL"
            };
        }
        static{
            this.WASHHANDBASIN = {
                type: 3,
                value: "WASHHANDBASIN"
            };
        }
        static{
            this.WCSEAT = {
                type: 3,
                value: "WCSEAT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;
    class IfcSectionTypeEnum {
        static{
            this.UNIFORM = {
                type: 3,
                value: "UNIFORM"
            };
        }
        static{
            this.TAPERED = {
                type: 3,
                value: "TAPERED"
            };
        }
    }
    IFC42.IfcSectionTypeEnum = IfcSectionTypeEnum;
    class IfcSensorTypeEnum {
        static{
            this.COSENSOR = {
                type: 3,
                value: "COSENSOR"
            };
        }
        static{
            this.CO2SENSOR = {
                type: 3,
                value: "CO2SENSOR"
            };
        }
        static{
            this.CONDUCTANCESENSOR = {
                type: 3,
                value: "CONDUCTANCESENSOR"
            };
        }
        static{
            this.CONTACTSENSOR = {
                type: 3,
                value: "CONTACTSENSOR"
            };
        }
        static{
            this.FIRESENSOR = {
                type: 3,
                value: "FIRESENSOR"
            };
        }
        static{
            this.FLOWSENSOR = {
                type: 3,
                value: "FLOWSENSOR"
            };
        }
        static{
            this.FROSTSENSOR = {
                type: 3,
                value: "FROSTSENSOR"
            };
        }
        static{
            this.GASSENSOR = {
                type: 3,
                value: "GASSENSOR"
            };
        }
        static{
            this.HEATSENSOR = {
                type: 3,
                value: "HEATSENSOR"
            };
        }
        static{
            this.HUMIDITYSENSOR = {
                type: 3,
                value: "HUMIDITYSENSOR"
            };
        }
        static{
            this.IDENTIFIERSENSOR = {
                type: 3,
                value: "IDENTIFIERSENSOR"
            };
        }
        static{
            this.IONCONCENTRATIONSENSOR = {
                type: 3,
                value: "IONCONCENTRATIONSENSOR"
            };
        }
        static{
            this.LEVELSENSOR = {
                type: 3,
                value: "LEVELSENSOR"
            };
        }
        static{
            this.LIGHTSENSOR = {
                type: 3,
                value: "LIGHTSENSOR"
            };
        }
        static{
            this.MOISTURESENSOR = {
                type: 3,
                value: "MOISTURESENSOR"
            };
        }
        static{
            this.MOVEMENTSENSOR = {
                type: 3,
                value: "MOVEMENTSENSOR"
            };
        }
        static{
            this.PHSENSOR = {
                type: 3,
                value: "PHSENSOR"
            };
        }
        static{
            this.PRESSURESENSOR = {
                type: 3,
                value: "PRESSURESENSOR"
            };
        }
        static{
            this.RADIATIONSENSOR = {
                type: 3,
                value: "RADIATIONSENSOR"
            };
        }
        static{
            this.RADIOACTIVITYSENSOR = {
                type: 3,
                value: "RADIOACTIVITYSENSOR"
            };
        }
        static{
            this.SMOKESENSOR = {
                type: 3,
                value: "SMOKESENSOR"
            };
        }
        static{
            this.SOUNDSENSOR = {
                type: 3,
                value: "SOUNDSENSOR"
            };
        }
        static{
            this.TEMPERATURESENSOR = {
                type: 3,
                value: "TEMPERATURESENSOR"
            };
        }
        static{
            this.WINDSENSOR = {
                type: 3,
                value: "WINDSENSOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSensorTypeEnum = IfcSensorTypeEnum;
    class IfcSequenceEnum {
        static{
            this.START_START = {
                type: 3,
                value: "START_START"
            };
        }
        static{
            this.START_FINISH = {
                type: 3,
                value: "START_FINISH"
            };
        }
        static{
            this.FINISH_START = {
                type: 3,
                value: "FINISH_START"
            };
        }
        static{
            this.FINISH_FINISH = {
                type: 3,
                value: "FINISH_FINISH"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSequenceEnum = IfcSequenceEnum;
    class IfcShadingDeviceTypeEnum {
        static{
            this.JALOUSIE = {
                type: 3,
                value: "JALOUSIE"
            };
        }
        static{
            this.SHUTTER = {
                type: 3,
                value: "SHUTTER"
            };
        }
        static{
            this.AWNING = {
                type: 3,
                value: "AWNING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcShadingDeviceTypeEnum = IfcShadingDeviceTypeEnum;
    class IfcSimplePropertyTemplateTypeEnum {
        static{
            this.P_SINGLEVALUE = {
                type: 3,
                value: "P_SINGLEVALUE"
            };
        }
        static{
            this.P_ENUMERATEDVALUE = {
                type: 3,
                value: "P_ENUMERATEDVALUE"
            };
        }
        static{
            this.P_BOUNDEDVALUE = {
                type: 3,
                value: "P_BOUNDEDVALUE"
            };
        }
        static{
            this.P_LISTVALUE = {
                type: 3,
                value: "P_LISTVALUE"
            };
        }
        static{
            this.P_TABLEVALUE = {
                type: 3,
                value: "P_TABLEVALUE"
            };
        }
        static{
            this.P_REFERENCEVALUE = {
                type: 3,
                value: "P_REFERENCEVALUE"
            };
        }
        static{
            this.Q_LENGTH = {
                type: 3,
                value: "Q_LENGTH"
            };
        }
        static{
            this.Q_AREA = {
                type: 3,
                value: "Q_AREA"
            };
        }
        static{
            this.Q_VOLUME = {
                type: 3,
                value: "Q_VOLUME"
            };
        }
        static{
            this.Q_COUNT = {
                type: 3,
                value: "Q_COUNT"
            };
        }
        static{
            this.Q_WEIGHT = {
                type: 3,
                value: "Q_WEIGHT"
            };
        }
        static{
            this.Q_TIME = {
                type: 3,
                value: "Q_TIME"
            };
        }
    }
    IFC42.IfcSimplePropertyTemplateTypeEnum = IfcSimplePropertyTemplateTypeEnum;
    class IfcSlabTypeEnum {
        static{
            this.FLOOR = {
                type: 3,
                value: "FLOOR"
            };
        }
        static{
            this.ROOF = {
                type: 3,
                value: "ROOF"
            };
        }
        static{
            this.LANDING = {
                type: 3,
                value: "LANDING"
            };
        }
        static{
            this.BASESLAB = {
                type: 3,
                value: "BASESLAB"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSlabTypeEnum = IfcSlabTypeEnum;
    class IfcSolarDeviceTypeEnum {
        static{
            this.SOLARCOLLECTOR = {
                type: 3,
                value: "SOLARCOLLECTOR"
            };
        }
        static{
            this.SOLARPANEL = {
                type: 3,
                value: "SOLARPANEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSolarDeviceTypeEnum = IfcSolarDeviceTypeEnum;
    class IfcSpaceHeaterTypeEnum {
        static{
            this.CONVECTOR = {
                type: 3,
                value: "CONVECTOR"
            };
        }
        static{
            this.RADIATOR = {
                type: 3,
                value: "RADIATOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;
    class IfcSpaceTypeEnum {
        static{
            this.SPACE = {
                type: 3,
                value: "SPACE"
            };
        }
        static{
            this.PARKING = {
                type: 3,
                value: "PARKING"
            };
        }
        static{
            this.GFA = {
                type: 3,
                value: "GFA"
            };
        }
        static{
            this.INTERNAL = {
                type: 3,
                value: "INTERNAL"
            };
        }
        static{
            this.EXTERNAL = {
                type: 3,
                value: "EXTERNAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSpaceTypeEnum = IfcSpaceTypeEnum;
    class IfcSpatialZoneTypeEnum {
        static{
            this.CONSTRUCTION = {
                type: 3,
                value: "CONSTRUCTION"
            };
        }
        static{
            this.FIRESAFETY = {
                type: 3,
                value: "FIRESAFETY"
            };
        }
        static{
            this.LIGHTING = {
                type: 3,
                value: "LIGHTING"
            };
        }
        static{
            this.OCCUPANCY = {
                type: 3,
                value: "OCCUPANCY"
            };
        }
        static{
            this.SECURITY = {
                type: 3,
                value: "SECURITY"
            };
        }
        static{
            this.THERMAL = {
                type: 3,
                value: "THERMAL"
            };
        }
        static{
            this.TRANSPORT = {
                type: 3,
                value: "TRANSPORT"
            };
        }
        static{
            this.VENTILATION = {
                type: 3,
                value: "VENTILATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSpatialZoneTypeEnum = IfcSpatialZoneTypeEnum;
    class IfcStackTerminalTypeEnum {
        static{
            this.BIRDCAGE = {
                type: 3,
                value: "BIRDCAGE"
            };
        }
        static{
            this.COWL = {
                type: 3,
                value: "COWL"
            };
        }
        static{
            this.RAINWATERHOPPER = {
                type: 3,
                value: "RAINWATERHOPPER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;
    class IfcStairFlightTypeEnum {
        static{
            this.STRAIGHT = {
                type: 3,
                value: "STRAIGHT"
            };
        }
        static{
            this.WINDER = {
                type: 3,
                value: "WINDER"
            };
        }
        static{
            this.SPIRAL = {
                type: 3,
                value: "SPIRAL"
            };
        }
        static{
            this.CURVED = {
                type: 3,
                value: "CURVED"
            };
        }
        static{
            this.FREEFORM = {
                type: 3,
                value: "FREEFORM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;
    class IfcStairTypeEnum {
        static{
            this.STRAIGHT_RUN_STAIR = {
                type: 3,
                value: "STRAIGHT_RUN_STAIR"
            };
        }
        static{
            this.TWO_STRAIGHT_RUN_STAIR = {
                type: 3,
                value: "TWO_STRAIGHT_RUN_STAIR"
            };
        }
        static{
            this.QUARTER_WINDING_STAIR = {
                type: 3,
                value: "QUARTER_WINDING_STAIR"
            };
        }
        static{
            this.QUARTER_TURN_STAIR = {
                type: 3,
                value: "QUARTER_TURN_STAIR"
            };
        }
        static{
            this.HALF_WINDING_STAIR = {
                type: 3,
                value: "HALF_WINDING_STAIR"
            };
        }
        static{
            this.HALF_TURN_STAIR = {
                type: 3,
                value: "HALF_TURN_STAIR"
            };
        }
        static{
            this.TWO_QUARTER_WINDING_STAIR = {
                type: 3,
                value: "TWO_QUARTER_WINDING_STAIR"
            };
        }
        static{
            this.TWO_QUARTER_TURN_STAIR = {
                type: 3,
                value: "TWO_QUARTER_TURN_STAIR"
            };
        }
        static{
            this.THREE_QUARTER_WINDING_STAIR = {
                type: 3,
                value: "THREE_QUARTER_WINDING_STAIR"
            };
        }
        static{
            this.THREE_QUARTER_TURN_STAIR = {
                type: 3,
                value: "THREE_QUARTER_TURN_STAIR"
            };
        }
        static{
            this.SPIRAL_STAIR = {
                type: 3,
                value: "SPIRAL_STAIR"
            };
        }
        static{
            this.DOUBLE_RETURN_STAIR = {
                type: 3,
                value: "DOUBLE_RETURN_STAIR"
            };
        }
        static{
            this.CURVED_RUN_STAIR = {
                type: 3,
                value: "CURVED_RUN_STAIR"
            };
        }
        static{
            this.TWO_CURVED_RUN_STAIR = {
                type: 3,
                value: "TWO_CURVED_RUN_STAIR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcStairTypeEnum = IfcStairTypeEnum;
    class IfcStateEnum {
        static{
            this.READWRITE = {
                type: 3,
                value: "READWRITE"
            };
        }
        static{
            this.READONLY = {
                type: 3,
                value: "READONLY"
            };
        }
        static{
            this.LOCKED = {
                type: 3,
                value: "LOCKED"
            };
        }
        static{
            this.READWRITELOCKED = {
                type: 3,
                value: "READWRITELOCKED"
            };
        }
        static{
            this.READONLYLOCKED = {
                type: 3,
                value: "READONLYLOCKED"
            };
        }
    }
    IFC42.IfcStateEnum = IfcStateEnum;
    class IfcStructuralCurveActivityTypeEnum {
        static{
            this.CONST = {
                type: 3,
                value: "CONST"
            };
        }
        static{
            this.LINEAR = {
                type: 3,
                value: "LINEAR"
            };
        }
        static{
            this.POLYGONAL = {
                type: 3,
                value: "POLYGONAL"
            };
        }
        static{
            this.EQUIDISTANT = {
                type: 3,
                value: "EQUIDISTANT"
            };
        }
        static{
            this.SINUS = {
                type: 3,
                value: "SINUS"
            };
        }
        static{
            this.PARABOLA = {
                type: 3,
                value: "PARABOLA"
            };
        }
        static{
            this.DISCRETE = {
                type: 3,
                value: "DISCRETE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcStructuralCurveActivityTypeEnum = IfcStructuralCurveActivityTypeEnum;
    class IfcStructuralCurveMemberTypeEnum {
        static{
            this.RIGID_JOINED_MEMBER = {
                type: 3,
                value: "RIGID_JOINED_MEMBER"
            };
        }
        static{
            this.PIN_JOINED_MEMBER = {
                type: 3,
                value: "PIN_JOINED_MEMBER"
            };
        }
        static{
            this.CABLE = {
                type: 3,
                value: "CABLE"
            };
        }
        static{
            this.TENSION_MEMBER = {
                type: 3,
                value: "TENSION_MEMBER"
            };
        }
        static{
            this.COMPRESSION_MEMBER = {
                type: 3,
                value: "COMPRESSION_MEMBER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcStructuralCurveMemberTypeEnum = IfcStructuralCurveMemberTypeEnum;
    class IfcStructuralSurfaceActivityTypeEnum {
        static{
            this.CONST = {
                type: 3,
                value: "CONST"
            };
        }
        static{
            this.BILINEAR = {
                type: 3,
                value: "BILINEAR"
            };
        }
        static{
            this.DISCRETE = {
                type: 3,
                value: "DISCRETE"
            };
        }
        static{
            this.ISOCONTOUR = {
                type: 3,
                value: "ISOCONTOUR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcStructuralSurfaceActivityTypeEnum = IfcStructuralSurfaceActivityTypeEnum;
    class IfcStructuralSurfaceMemberTypeEnum {
        static{
            this.BENDING_ELEMENT = {
                type: 3,
                value: "BENDING_ELEMENT"
            };
        }
        static{
            this.MEMBRANE_ELEMENT = {
                type: 3,
                value: "MEMBRANE_ELEMENT"
            };
        }
        static{
            this.SHELL = {
                type: 3,
                value: "SHELL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcStructuralSurfaceMemberTypeEnum = IfcStructuralSurfaceMemberTypeEnum;
    class IfcSubContractResourceTypeEnum {
        static{
            this.PURCHASE = {
                type: 3,
                value: "PURCHASE"
            };
        }
        static{
            this.WORK = {
                type: 3,
                value: "WORK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSubContractResourceTypeEnum = IfcSubContractResourceTypeEnum;
    class IfcSurfaceFeatureTypeEnum {
        static{
            this.MARK = {
                type: 3,
                value: "MARK"
            };
        }
        static{
            this.TAG = {
                type: 3,
                value: "TAG"
            };
        }
        static{
            this.TREATMENT = {
                type: 3,
                value: "TREATMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSurfaceFeatureTypeEnum = IfcSurfaceFeatureTypeEnum;
    class IfcSurfaceSide {
        static{
            this.POSITIVE = {
                type: 3,
                value: "POSITIVE"
            };
        }
        static{
            this.NEGATIVE = {
                type: 3,
                value: "NEGATIVE"
            };
        }
        static{
            this.BOTH = {
                type: 3,
                value: "BOTH"
            };
        }
    }
    IFC42.IfcSurfaceSide = IfcSurfaceSide;
    class IfcSwitchingDeviceTypeEnum {
        static{
            this.CONTACTOR = {
                type: 3,
                value: "CONTACTOR"
            };
        }
        static{
            this.DIMMERSWITCH = {
                type: 3,
                value: "DIMMERSWITCH"
            };
        }
        static{
            this.EMERGENCYSTOP = {
                type: 3,
                value: "EMERGENCYSTOP"
            };
        }
        static{
            this.KEYPAD = {
                type: 3,
                value: "KEYPAD"
            };
        }
        static{
            this.MOMENTARYSWITCH = {
                type: 3,
                value: "MOMENTARYSWITCH"
            };
        }
        static{
            this.SELECTORSWITCH = {
                type: 3,
                value: "SELECTORSWITCH"
            };
        }
        static{
            this.STARTER = {
                type: 3,
                value: "STARTER"
            };
        }
        static{
            this.SWITCHDISCONNECTOR = {
                type: 3,
                value: "SWITCHDISCONNECTOR"
            };
        }
        static{
            this.TOGGLESWITCH = {
                type: 3,
                value: "TOGGLESWITCH"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;
    class IfcSystemFurnitureElementTypeEnum {
        static{
            this.PANEL = {
                type: 3,
                value: "PANEL"
            };
        }
        static{
            this.WORKSURFACE = {
                type: 3,
                value: "WORKSURFACE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcSystemFurnitureElementTypeEnum = IfcSystemFurnitureElementTypeEnum;
    class IfcTankTypeEnum {
        static{
            this.BASIN = {
                type: 3,
                value: "BASIN"
            };
        }
        static{
            this.BREAKPRESSURE = {
                type: 3,
                value: "BREAKPRESSURE"
            };
        }
        static{
            this.EXPANSION = {
                type: 3,
                value: "EXPANSION"
            };
        }
        static{
            this.FEEDANDEXPANSION = {
                type: 3,
                value: "FEEDANDEXPANSION"
            };
        }
        static{
            this.PRESSUREVESSEL = {
                type: 3,
                value: "PRESSUREVESSEL"
            };
        }
        static{
            this.STORAGE = {
                type: 3,
                value: "STORAGE"
            };
        }
        static{
            this.VESSEL = {
                type: 3,
                value: "VESSEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcTankTypeEnum = IfcTankTypeEnum;
    class IfcTaskDurationEnum {
        static{
            this.ELAPSEDTIME = {
                type: 3,
                value: "ELAPSEDTIME"
            };
        }
        static{
            this.WORKTIME = {
                type: 3,
                value: "WORKTIME"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcTaskDurationEnum = IfcTaskDurationEnum;
    class IfcTaskTypeEnum {
        static{
            this.ATTENDANCE = {
                type: 3,
                value: "ATTENDANCE"
            };
        }
        static{
            this.CONSTRUCTION = {
                type: 3,
                value: "CONSTRUCTION"
            };
        }
        static{
            this.DEMOLITION = {
                type: 3,
                value: "DEMOLITION"
            };
        }
        static{
            this.DISMANTLE = {
                type: 3,
                value: "DISMANTLE"
            };
        }
        static{
            this.DISPOSAL = {
                type: 3,
                value: "DISPOSAL"
            };
        }
        static{
            this.INSTALLATION = {
                type: 3,
                value: "INSTALLATION"
            };
        }
        static{
            this.LOGISTIC = {
                type: 3,
                value: "LOGISTIC"
            };
        }
        static{
            this.MAINTENANCE = {
                type: 3,
                value: "MAINTENANCE"
            };
        }
        static{
            this.MOVE = {
                type: 3,
                value: "MOVE"
            };
        }
        static{
            this.OPERATION = {
                type: 3,
                value: "OPERATION"
            };
        }
        static{
            this.REMOVAL = {
                type: 3,
                value: "REMOVAL"
            };
        }
        static{
            this.RENOVATION = {
                type: 3,
                value: "RENOVATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcTaskTypeEnum = IfcTaskTypeEnum;
    class IfcTendonAnchorTypeEnum {
        static{
            this.COUPLER = {
                type: 3,
                value: "COUPLER"
            };
        }
        static{
            this.FIXED_END = {
                type: 3,
                value: "FIXED_END"
            };
        }
        static{
            this.TENSIONING_END = {
                type: 3,
                value: "TENSIONING_END"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcTendonAnchorTypeEnum = IfcTendonAnchorTypeEnum;
    class IfcTendonTypeEnum {
        static{
            this.BAR = {
                type: 3,
                value: "BAR"
            };
        }
        static{
            this.COATED = {
                type: 3,
                value: "COATED"
            };
        }
        static{
            this.STRAND = {
                type: 3,
                value: "STRAND"
            };
        }
        static{
            this.WIRE = {
                type: 3,
                value: "WIRE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcTendonTypeEnum = IfcTendonTypeEnum;
    class IfcTextPath {
        static{
            this.LEFT = {
                type: 3,
                value: "LEFT"
            };
        }
        static{
            this.RIGHT = {
                type: 3,
                value: "RIGHT"
            };
        }
        static{
            this.UP = {
                type: 3,
                value: "UP"
            };
        }
        static{
            this.DOWN = {
                type: 3,
                value: "DOWN"
            };
        }
    }
    IFC42.IfcTextPath = IfcTextPath;
    class IfcTimeSeriesDataTypeEnum {
        static{
            this.CONTINUOUS = {
                type: 3,
                value: "CONTINUOUS"
            };
        }
        static{
            this.DISCRETE = {
                type: 3,
                value: "DISCRETE"
            };
        }
        static{
            this.DISCRETEBINARY = {
                type: 3,
                value: "DISCRETEBINARY"
            };
        }
        static{
            this.PIECEWISEBINARY = {
                type: 3,
                value: "PIECEWISEBINARY"
            };
        }
        static{
            this.PIECEWISECONSTANT = {
                type: 3,
                value: "PIECEWISECONSTANT"
            };
        }
        static{
            this.PIECEWISECONTINUOUS = {
                type: 3,
                value: "PIECEWISECONTINUOUS"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;
    class IfcTransformerTypeEnum {
        static{
            this.CURRENT = {
                type: 3,
                value: "CURRENT"
            };
        }
        static{
            this.FREQUENCY = {
                type: 3,
                value: "FREQUENCY"
            };
        }
        static{
            this.INVERTER = {
                type: 3,
                value: "INVERTER"
            };
        }
        static{
            this.RECTIFIER = {
                type: 3,
                value: "RECTIFIER"
            };
        }
        static{
            this.VOLTAGE = {
                type: 3,
                value: "VOLTAGE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcTransformerTypeEnum = IfcTransformerTypeEnum;
    class IfcTransitionCode {
        static{
            this.DISCONTINUOUS = {
                type: 3,
                value: "DISCONTINUOUS"
            };
        }
        static{
            this.CONTINUOUS = {
                type: 3,
                value: "CONTINUOUS"
            };
        }
        static{
            this.CONTSAMEGRADIENT = {
                type: 3,
                value: "CONTSAMEGRADIENT"
            };
        }
        static{
            this.CONTSAMEGRADIENTSAMECURVATURE = {
                type: 3,
                value: "CONTSAMEGRADIENTSAMECURVATURE"
            };
        }
    }
    IFC42.IfcTransitionCode = IfcTransitionCode;
    class IfcTransportElementTypeEnum {
        static{
            this.ELEVATOR = {
                type: 3,
                value: "ELEVATOR"
            };
        }
        static{
            this.ESCALATOR = {
                type: 3,
                value: "ESCALATOR"
            };
        }
        static{
            this.MOVINGWALKWAY = {
                type: 3,
                value: "MOVINGWALKWAY"
            };
        }
        static{
            this.CRANEWAY = {
                type: 3,
                value: "CRANEWAY"
            };
        }
        static{
            this.LIFTINGGEAR = {
                type: 3,
                value: "LIFTINGGEAR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;
    class IfcTrimmingPreference {
        static{
            this.CARTESIAN = {
                type: 3,
                value: "CARTESIAN"
            };
        }
        static{
            this.PARAMETER = {
                type: 3,
                value: "PARAMETER"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC42.IfcTrimmingPreference = IfcTrimmingPreference;
    class IfcTubeBundleTypeEnum {
        static{
            this.FINNED = {
                type: 3,
                value: "FINNED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;
    class IfcUnitEnum {
        static{
            this.ABSORBEDDOSEUNIT = {
                type: 3,
                value: "ABSORBEDDOSEUNIT"
            };
        }
        static{
            this.AMOUNTOFSUBSTANCEUNIT = {
                type: 3,
                value: "AMOUNTOFSUBSTANCEUNIT"
            };
        }
        static{
            this.AREAUNIT = {
                type: 3,
                value: "AREAUNIT"
            };
        }
        static{
            this.DOSEEQUIVALENTUNIT = {
                type: 3,
                value: "DOSEEQUIVALENTUNIT"
            };
        }
        static{
            this.ELECTRICCAPACITANCEUNIT = {
                type: 3,
                value: "ELECTRICCAPACITANCEUNIT"
            };
        }
        static{
            this.ELECTRICCHARGEUNIT = {
                type: 3,
                value: "ELECTRICCHARGEUNIT"
            };
        }
        static{
            this.ELECTRICCONDUCTANCEUNIT = {
                type: 3,
                value: "ELECTRICCONDUCTANCEUNIT"
            };
        }
        static{
            this.ELECTRICCURRENTUNIT = {
                type: 3,
                value: "ELECTRICCURRENTUNIT"
            };
        }
        static{
            this.ELECTRICRESISTANCEUNIT = {
                type: 3,
                value: "ELECTRICRESISTANCEUNIT"
            };
        }
        static{
            this.ELECTRICVOLTAGEUNIT = {
                type: 3,
                value: "ELECTRICVOLTAGEUNIT"
            };
        }
        static{
            this.ENERGYUNIT = {
                type: 3,
                value: "ENERGYUNIT"
            };
        }
        static{
            this.FORCEUNIT = {
                type: 3,
                value: "FORCEUNIT"
            };
        }
        static{
            this.FREQUENCYUNIT = {
                type: 3,
                value: "FREQUENCYUNIT"
            };
        }
        static{
            this.ILLUMINANCEUNIT = {
                type: 3,
                value: "ILLUMINANCEUNIT"
            };
        }
        static{
            this.INDUCTANCEUNIT = {
                type: 3,
                value: "INDUCTANCEUNIT"
            };
        }
        static{
            this.LENGTHUNIT = {
                type: 3,
                value: "LENGTHUNIT"
            };
        }
        static{
            this.LUMINOUSFLUXUNIT = {
                type: 3,
                value: "LUMINOUSFLUXUNIT"
            };
        }
        static{
            this.LUMINOUSINTENSITYUNIT = {
                type: 3,
                value: "LUMINOUSINTENSITYUNIT"
            };
        }
        static{
            this.MAGNETICFLUXDENSITYUNIT = {
                type: 3,
                value: "MAGNETICFLUXDENSITYUNIT"
            };
        }
        static{
            this.MAGNETICFLUXUNIT = {
                type: 3,
                value: "MAGNETICFLUXUNIT"
            };
        }
        static{
            this.MASSUNIT = {
                type: 3,
                value: "MASSUNIT"
            };
        }
        static{
            this.PLANEANGLEUNIT = {
                type: 3,
                value: "PLANEANGLEUNIT"
            };
        }
        static{
            this.POWERUNIT = {
                type: 3,
                value: "POWERUNIT"
            };
        }
        static{
            this.PRESSUREUNIT = {
                type: 3,
                value: "PRESSUREUNIT"
            };
        }
        static{
            this.RADIOACTIVITYUNIT = {
                type: 3,
                value: "RADIOACTIVITYUNIT"
            };
        }
        static{
            this.SOLIDANGLEUNIT = {
                type: 3,
                value: "SOLIDANGLEUNIT"
            };
        }
        static{
            this.THERMODYNAMICTEMPERATUREUNIT = {
                type: 3,
                value: "THERMODYNAMICTEMPERATUREUNIT"
            };
        }
        static{
            this.TIMEUNIT = {
                type: 3,
                value: "TIMEUNIT"
            };
        }
        static{
            this.VOLUMEUNIT = {
                type: 3,
                value: "VOLUMEUNIT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC42.IfcUnitEnum = IfcUnitEnum;
    class IfcUnitaryControlElementTypeEnum {
        static{
            this.ALARMPANEL = {
                type: 3,
                value: "ALARMPANEL"
            };
        }
        static{
            this.CONTROLPANEL = {
                type: 3,
                value: "CONTROLPANEL"
            };
        }
        static{
            this.GASDETECTIONPANEL = {
                type: 3,
                value: "GASDETECTIONPANEL"
            };
        }
        static{
            this.INDICATORPANEL = {
                type: 3,
                value: "INDICATORPANEL"
            };
        }
        static{
            this.MIMICPANEL = {
                type: 3,
                value: "MIMICPANEL"
            };
        }
        static{
            this.HUMIDISTAT = {
                type: 3,
                value: "HUMIDISTAT"
            };
        }
        static{
            this.THERMOSTAT = {
                type: 3,
                value: "THERMOSTAT"
            };
        }
        static{
            this.WEATHERSTATION = {
                type: 3,
                value: "WEATHERSTATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcUnitaryControlElementTypeEnum = IfcUnitaryControlElementTypeEnum;
    class IfcUnitaryEquipmentTypeEnum {
        static{
            this.AIRHANDLER = {
                type: 3,
                value: "AIRHANDLER"
            };
        }
        static{
            this.AIRCONDITIONINGUNIT = {
                type: 3,
                value: "AIRCONDITIONINGUNIT"
            };
        }
        static{
            this.DEHUMIDIFIER = {
                type: 3,
                value: "DEHUMIDIFIER"
            };
        }
        static{
            this.SPLITSYSTEM = {
                type: 3,
                value: "SPLITSYSTEM"
            };
        }
        static{
            this.ROOFTOPUNIT = {
                type: 3,
                value: "ROOFTOPUNIT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;
    class IfcValveTypeEnum {
        static{
            this.AIRRELEASE = {
                type: 3,
                value: "AIRRELEASE"
            };
        }
        static{
            this.ANTIVACUUM = {
                type: 3,
                value: "ANTIVACUUM"
            };
        }
        static{
            this.CHANGEOVER = {
                type: 3,
                value: "CHANGEOVER"
            };
        }
        static{
            this.CHECK = {
                type: 3,
                value: "CHECK"
            };
        }
        static{
            this.COMMISSIONING = {
                type: 3,
                value: "COMMISSIONING"
            };
        }
        static{
            this.DIVERTING = {
                type: 3,
                value: "DIVERTING"
            };
        }
        static{
            this.DRAWOFFCOCK = {
                type: 3,
                value: "DRAWOFFCOCK"
            };
        }
        static{
            this.DOUBLECHECK = {
                type: 3,
                value: "DOUBLECHECK"
            };
        }
        static{
            this.DOUBLEREGULATING = {
                type: 3,
                value: "DOUBLEREGULATING"
            };
        }
        static{
            this.FAUCET = {
                type: 3,
                value: "FAUCET"
            };
        }
        static{
            this.FLUSHING = {
                type: 3,
                value: "FLUSHING"
            };
        }
        static{
            this.GASCOCK = {
                type: 3,
                value: "GASCOCK"
            };
        }
        static{
            this.GASTAP = {
                type: 3,
                value: "GASTAP"
            };
        }
        static{
            this.ISOLATING = {
                type: 3,
                value: "ISOLATING"
            };
        }
        static{
            this.MIXING = {
                type: 3,
                value: "MIXING"
            };
        }
        static{
            this.PRESSUREREDUCING = {
                type: 3,
                value: "PRESSUREREDUCING"
            };
        }
        static{
            this.PRESSURERELIEF = {
                type: 3,
                value: "PRESSURERELIEF"
            };
        }
        static{
            this.REGULATING = {
                type: 3,
                value: "REGULATING"
            };
        }
        static{
            this.SAFETYCUTOFF = {
                type: 3,
                value: "SAFETYCUTOFF"
            };
        }
        static{
            this.STEAMTRAP = {
                type: 3,
                value: "STEAMTRAP"
            };
        }
        static{
            this.STOPCOCK = {
                type: 3,
                value: "STOPCOCK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcValveTypeEnum = IfcValveTypeEnum;
    class IfcVibrationIsolatorTypeEnum {
        static{
            this.COMPRESSION = {
                type: 3,
                value: "COMPRESSION"
            };
        }
        static{
            this.SPRING = {
                type: 3,
                value: "SPRING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;
    class IfcVoidingFeatureTypeEnum {
        static{
            this.CUTOUT = {
                type: 3,
                value: "CUTOUT"
            };
        }
        static{
            this.NOTCH = {
                type: 3,
                value: "NOTCH"
            };
        }
        static{
            this.HOLE = {
                type: 3,
                value: "HOLE"
            };
        }
        static{
            this.MITER = {
                type: 3,
                value: "MITER"
            };
        }
        static{
            this.CHAMFER = {
                type: 3,
                value: "CHAMFER"
            };
        }
        static{
            this.EDGE = {
                type: 3,
                value: "EDGE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcVoidingFeatureTypeEnum = IfcVoidingFeatureTypeEnum;
    class IfcWallTypeEnum {
        static{
            this.MOVABLE = {
                type: 3,
                value: "MOVABLE"
            };
        }
        static{
            this.PARAPET = {
                type: 3,
                value: "PARAPET"
            };
        }
        static{
            this.PARTITIONING = {
                type: 3,
                value: "PARTITIONING"
            };
        }
        static{
            this.PLUMBINGWALL = {
                type: 3,
                value: "PLUMBINGWALL"
            };
        }
        static{
            this.SHEAR = {
                type: 3,
                value: "SHEAR"
            };
        }
        static{
            this.SOLIDWALL = {
                type: 3,
                value: "SOLIDWALL"
            };
        }
        static{
            this.STANDARD = {
                type: 3,
                value: "STANDARD"
            };
        }
        static{
            this.POLYGONAL = {
                type: 3,
                value: "POLYGONAL"
            };
        }
        static{
            this.ELEMENTEDWALL = {
                type: 3,
                value: "ELEMENTEDWALL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWallTypeEnum = IfcWallTypeEnum;
    class IfcWasteTerminalTypeEnum {
        static{
            this.FLOORTRAP = {
                type: 3,
                value: "FLOORTRAP"
            };
        }
        static{
            this.FLOORWASTE = {
                type: 3,
                value: "FLOORWASTE"
            };
        }
        static{
            this.GULLYSUMP = {
                type: 3,
                value: "GULLYSUMP"
            };
        }
        static{
            this.GULLYTRAP = {
                type: 3,
                value: "GULLYTRAP"
            };
        }
        static{
            this.ROOFDRAIN = {
                type: 3,
                value: "ROOFDRAIN"
            };
        }
        static{
            this.WASTEDISPOSALUNIT = {
                type: 3,
                value: "WASTEDISPOSALUNIT"
            };
        }
        static{
            this.WASTETRAP = {
                type: 3,
                value: "WASTETRAP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;
    class IfcWindowPanelOperationEnum {
        static{
            this.SIDEHUNGRIGHTHAND = {
                type: 3,
                value: "SIDEHUNGRIGHTHAND"
            };
        }
        static{
            this.SIDEHUNGLEFTHAND = {
                type: 3,
                value: "SIDEHUNGLEFTHAND"
            };
        }
        static{
            this.TILTANDTURNRIGHTHAND = {
                type: 3,
                value: "TILTANDTURNRIGHTHAND"
            };
        }
        static{
            this.TILTANDTURNLEFTHAND = {
                type: 3,
                value: "TILTANDTURNLEFTHAND"
            };
        }
        static{
            this.TOPHUNG = {
                type: 3,
                value: "TOPHUNG"
            };
        }
        static{
            this.BOTTOMHUNG = {
                type: 3,
                value: "BOTTOMHUNG"
            };
        }
        static{
            this.PIVOTHORIZONTAL = {
                type: 3,
                value: "PIVOTHORIZONTAL"
            };
        }
        static{
            this.PIVOTVERTICAL = {
                type: 3,
                value: "PIVOTVERTICAL"
            };
        }
        static{
            this.SLIDINGHORIZONTAL = {
                type: 3,
                value: "SLIDINGHORIZONTAL"
            };
        }
        static{
            this.SLIDINGVERTICAL = {
                type: 3,
                value: "SLIDINGVERTICAL"
            };
        }
        static{
            this.REMOVABLECASEMENT = {
                type: 3,
                value: "REMOVABLECASEMENT"
            };
        }
        static{
            this.FIXEDCASEMENT = {
                type: 3,
                value: "FIXEDCASEMENT"
            };
        }
        static{
            this.OTHEROPERATION = {
                type: 3,
                value: "OTHEROPERATION"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;
    class IfcWindowPanelPositionEnum {
        static{
            this.LEFT = {
                type: 3,
                value: "LEFT"
            };
        }
        static{
            this.MIDDLE = {
                type: 3,
                value: "MIDDLE"
            };
        }
        static{
            this.RIGHT = {
                type: 3,
                value: "RIGHT"
            };
        }
        static{
            this.BOTTOM = {
                type: 3,
                value: "BOTTOM"
            };
        }
        static{
            this.TOP = {
                type: 3,
                value: "TOP"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;
    class IfcWindowStyleConstructionEnum {
        static{
            this.ALUMINIUM = {
                type: 3,
                value: "ALUMINIUM"
            };
        }
        static{
            this.HIGH_GRADE_STEEL = {
                type: 3,
                value: "HIGH_GRADE_STEEL"
            };
        }
        static{
            this.STEEL = {
                type: 3,
                value: "STEEL"
            };
        }
        static{
            this.WOOD = {
                type: 3,
                value: "WOOD"
            };
        }
        static{
            this.ALUMINIUM_WOOD = {
                type: 3,
                value: "ALUMINIUM_WOOD"
            };
        }
        static{
            this.PLASTIC = {
                type: 3,
                value: "PLASTIC"
            };
        }
        static{
            this.OTHER_CONSTRUCTION = {
                type: 3,
                value: "OTHER_CONSTRUCTION"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;
    class IfcWindowStyleOperationEnum {
        static{
            this.SINGLE_PANEL = {
                type: 3,
                value: "SINGLE_PANEL"
            };
        }
        static{
            this.DOUBLE_PANEL_VERTICAL = {
                type: 3,
                value: "DOUBLE_PANEL_VERTICAL"
            };
        }
        static{
            this.DOUBLE_PANEL_HORIZONTAL = {
                type: 3,
                value: "DOUBLE_PANEL_HORIZONTAL"
            };
        }
        static{
            this.TRIPLE_PANEL_VERTICAL = {
                type: 3,
                value: "TRIPLE_PANEL_VERTICAL"
            };
        }
        static{
            this.TRIPLE_PANEL_BOTTOM = {
                type: 3,
                value: "TRIPLE_PANEL_BOTTOM"
            };
        }
        static{
            this.TRIPLE_PANEL_TOP = {
                type: 3,
                value: "TRIPLE_PANEL_TOP"
            };
        }
        static{
            this.TRIPLE_PANEL_LEFT = {
                type: 3,
                value: "TRIPLE_PANEL_LEFT"
            };
        }
        static{
            this.TRIPLE_PANEL_RIGHT = {
                type: 3,
                value: "TRIPLE_PANEL_RIGHT"
            };
        }
        static{
            this.TRIPLE_PANEL_HORIZONTAL = {
                type: 3,
                value: "TRIPLE_PANEL_HORIZONTAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;
    class IfcWindowTypeEnum {
        static{
            this.WINDOW = {
                type: 3,
                value: "WINDOW"
            };
        }
        static{
            this.SKYLIGHT = {
                type: 3,
                value: "SKYLIGHT"
            };
        }
        static{
            this.LIGHTDOME = {
                type: 3,
                value: "LIGHTDOME"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWindowTypeEnum = IfcWindowTypeEnum;
    class IfcWindowTypePartitioningEnum {
        static{
            this.SINGLE_PANEL = {
                type: 3,
                value: "SINGLE_PANEL"
            };
        }
        static{
            this.DOUBLE_PANEL_VERTICAL = {
                type: 3,
                value: "DOUBLE_PANEL_VERTICAL"
            };
        }
        static{
            this.DOUBLE_PANEL_HORIZONTAL = {
                type: 3,
                value: "DOUBLE_PANEL_HORIZONTAL"
            };
        }
        static{
            this.TRIPLE_PANEL_VERTICAL = {
                type: 3,
                value: "TRIPLE_PANEL_VERTICAL"
            };
        }
        static{
            this.TRIPLE_PANEL_BOTTOM = {
                type: 3,
                value: "TRIPLE_PANEL_BOTTOM"
            };
        }
        static{
            this.TRIPLE_PANEL_TOP = {
                type: 3,
                value: "TRIPLE_PANEL_TOP"
            };
        }
        static{
            this.TRIPLE_PANEL_LEFT = {
                type: 3,
                value: "TRIPLE_PANEL_LEFT"
            };
        }
        static{
            this.TRIPLE_PANEL_RIGHT = {
                type: 3,
                value: "TRIPLE_PANEL_RIGHT"
            };
        }
        static{
            this.TRIPLE_PANEL_HORIZONTAL = {
                type: 3,
                value: "TRIPLE_PANEL_HORIZONTAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWindowTypePartitioningEnum = IfcWindowTypePartitioningEnum;
    class IfcWorkCalendarTypeEnum {
        static{
            this.FIRSTSHIFT = {
                type: 3,
                value: "FIRSTSHIFT"
            };
        }
        static{
            this.SECONDSHIFT = {
                type: 3,
                value: "SECONDSHIFT"
            };
        }
        static{
            this.THIRDSHIFT = {
                type: 3,
                value: "THIRDSHIFT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWorkCalendarTypeEnum = IfcWorkCalendarTypeEnum;
    class IfcWorkPlanTypeEnum {
        static{
            this.ACTUAL = {
                type: 3,
                value: "ACTUAL"
            };
        }
        static{
            this.BASELINE = {
                type: 3,
                value: "BASELINE"
            };
        }
        static{
            this.PLANNED = {
                type: 3,
                value: "PLANNED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWorkPlanTypeEnum = IfcWorkPlanTypeEnum;
    class IfcWorkScheduleTypeEnum {
        static{
            this.ACTUAL = {
                type: 3,
                value: "ACTUAL"
            };
        }
        static{
            this.BASELINE = {
                type: 3,
                value: "BASELINE"
            };
        }
        static{
            this.PLANNED = {
                type: 3,
                value: "PLANNED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC42.IfcWorkScheduleTypeEnum = IfcWorkScheduleTypeEnum;
    class IfcActorRole extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Role, UserDefinedRole, Description){
            super();
            this.Role = Role;
            this.UserDefinedRole = UserDefinedRole;
            this.Description = Description;
            this.type = 3630933823;
        }
    }
    IFC42.IfcActorRole = IfcActorRole;
    class IfcAddress extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Purpose, Description, UserDefinedPurpose){
            super();
            this.Purpose = Purpose;
            this.Description = Description;
            this.UserDefinedPurpose = UserDefinedPurpose;
            this.type = 618182010;
        }
    }
    IFC42.IfcAddress = IfcAddress;
    class IfcApplication extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier){
            super();
            this.ApplicationDeveloper = ApplicationDeveloper;
            this.Version = Version;
            this.ApplicationFullName = ApplicationFullName;
            this.ApplicationIdentifier = ApplicationIdentifier;
            this.type = 639542469;
        }
    }
    IFC42.IfcApplication = IfcApplication;
    class IfcAppliedValue extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components){
            super();
            this.Name = Name;
            this.Description = Description;
            this.AppliedValue = AppliedValue;
            this.UnitBasis = UnitBasis;
            this.ApplicableDate = ApplicableDate;
            this.FixedUntilDate = FixedUntilDate;
            this.Category = Category;
            this.Condition = Condition;
            this.ArithmeticOperator = ArithmeticOperator;
            this.Components = Components;
            this.type = 411424972;
        }
    }
    IFC42.IfcAppliedValue = IfcAppliedValue;
    class IfcApproval extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Identifier, Name, Description, TimeOfApproval, Status, Level, Qualifier, RequestingApproval, GivingApproval){
            super();
            this.Identifier = Identifier;
            this.Name = Name;
            this.Description = Description;
            this.TimeOfApproval = TimeOfApproval;
            this.Status = Status;
            this.Level = Level;
            this.Qualifier = Qualifier;
            this.RequestingApproval = RequestingApproval;
            this.GivingApproval = GivingApproval;
            this.type = 130549933;
        }
    }
    IFC42.IfcApproval = IfcApproval;
    class IfcBoundaryCondition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 4037036970;
        }
    }
    IFC42.IfcBoundaryCondition = IfcBoundaryCondition;
    class IfcBoundaryEdgeCondition extends IfcBoundaryCondition {
        constructor(Name, TranslationalStiffnessByLengthX, TranslationalStiffnessByLengthY, TranslationalStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ){
            super(Name);
            this.Name = Name;
            this.TranslationalStiffnessByLengthX = TranslationalStiffnessByLengthX;
            this.TranslationalStiffnessByLengthY = TranslationalStiffnessByLengthY;
            this.TranslationalStiffnessByLengthZ = TranslationalStiffnessByLengthZ;
            this.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
            this.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
            this.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
            this.type = 1560379544;
        }
    }
    IFC42.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;
    class IfcBoundaryFaceCondition extends IfcBoundaryCondition {
        constructor(Name, TranslationalStiffnessByAreaX, TranslationalStiffnessByAreaY, TranslationalStiffnessByAreaZ){
            super(Name);
            this.Name = Name;
            this.TranslationalStiffnessByAreaX = TranslationalStiffnessByAreaX;
            this.TranslationalStiffnessByAreaY = TranslationalStiffnessByAreaY;
            this.TranslationalStiffnessByAreaZ = TranslationalStiffnessByAreaZ;
            this.type = 3367102660;
        }
    }
    IFC42.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;
    class IfcBoundaryNodeCondition extends IfcBoundaryCondition {
        constructor(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ){
            super(Name);
            this.Name = Name;
            this.TranslationalStiffnessX = TranslationalStiffnessX;
            this.TranslationalStiffnessY = TranslationalStiffnessY;
            this.TranslationalStiffnessZ = TranslationalStiffnessZ;
            this.RotationalStiffnessX = RotationalStiffnessX;
            this.RotationalStiffnessY = RotationalStiffnessY;
            this.RotationalStiffnessZ = RotationalStiffnessZ;
            this.type = 1387855156;
        }
    }
    IFC42.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;
    class IfcBoundaryNodeConditionWarping extends IfcBoundaryNodeCondition {
        constructor(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness){
            super(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
            this.Name = Name;
            this.TranslationalStiffnessX = TranslationalStiffnessX;
            this.TranslationalStiffnessY = TranslationalStiffnessY;
            this.TranslationalStiffnessZ = TranslationalStiffnessZ;
            this.RotationalStiffnessX = RotationalStiffnessX;
            this.RotationalStiffnessY = RotationalStiffnessY;
            this.RotationalStiffnessZ = RotationalStiffnessZ;
            this.WarpingStiffness = WarpingStiffness;
            this.type = 2069777674;
        }
    }
    IFC42.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;
    class IfcConnectionGeometry extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 2859738748;
        }
    }
    IFC42.IfcConnectionGeometry = IfcConnectionGeometry;
    class IfcConnectionPointGeometry extends IfcConnectionGeometry {
        constructor(PointOnRelatingElement, PointOnRelatedElement){
            super();
            this.PointOnRelatingElement = PointOnRelatingElement;
            this.PointOnRelatedElement = PointOnRelatedElement;
            this.type = 2614616156;
        }
    }
    IFC42.IfcConnectionPointGeometry = IfcConnectionPointGeometry;
    class IfcConnectionSurfaceGeometry extends IfcConnectionGeometry {
        constructor(SurfaceOnRelatingElement, SurfaceOnRelatedElement){
            super();
            this.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
            this.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
            this.type = 2732653382;
        }
    }
    IFC42.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;
    class IfcConnectionVolumeGeometry extends IfcConnectionGeometry {
        constructor(VolumeOnRelatingElement, VolumeOnRelatedElement){
            super();
            this.VolumeOnRelatingElement = VolumeOnRelatingElement;
            this.VolumeOnRelatedElement = VolumeOnRelatedElement;
            this.type = 775493141;
        }
    }
    IFC42.IfcConnectionVolumeGeometry = IfcConnectionVolumeGeometry;
    class IfcConstraint extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade){
            super();
            this.Name = Name;
            this.Description = Description;
            this.ConstraintGrade = ConstraintGrade;
            this.ConstraintSource = ConstraintSource;
            this.CreatingActor = CreatingActor;
            this.CreationTime = CreationTime;
            this.UserDefinedGrade = UserDefinedGrade;
            this.type = 1959218052;
        }
    }
    IFC42.IfcConstraint = IfcConstraint;
    class IfcCoordinateOperation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(SourceCRS, TargetCRS){
            super();
            this.SourceCRS = SourceCRS;
            this.TargetCRS = TargetCRS;
            this.type = 1785450214;
        }
    }
    IFC42.IfcCoordinateOperation = IfcCoordinateOperation;
    class IfcCoordinateReferenceSystem extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, GeodeticDatum, VerticalDatum){
            super();
            this.Name = Name;
            this.Description = Description;
            this.GeodeticDatum = GeodeticDatum;
            this.VerticalDatum = VerticalDatum;
            this.type = 1466758467;
        }
    }
    IFC42.IfcCoordinateReferenceSystem = IfcCoordinateReferenceSystem;
    class IfcCostValue extends IfcAppliedValue {
        constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components){
            super(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components);
            this.Name = Name;
            this.Description = Description;
            this.AppliedValue = AppliedValue;
            this.UnitBasis = UnitBasis;
            this.ApplicableDate = ApplicableDate;
            this.FixedUntilDate = FixedUntilDate;
            this.Category = Category;
            this.Condition = Condition;
            this.ArithmeticOperator = ArithmeticOperator;
            this.Components = Components;
            this.type = 602808272;
        }
    }
    IFC42.IfcCostValue = IfcCostValue;
    class IfcDerivedUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Elements, UnitType, UserDefinedType){
            super();
            this.Elements = Elements;
            this.UnitType = UnitType;
            this.UserDefinedType = UserDefinedType;
            this.type = 1765591967;
        }
    }
    IFC42.IfcDerivedUnit = IfcDerivedUnit;
    class IfcDerivedUnitElement extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Unit, Exponent){
            super();
            this.Unit = Unit;
            this.Exponent = Exponent;
            this.type = 1045800335;
        }
    }
    IFC42.IfcDerivedUnitElement = IfcDerivedUnitElement;
    class IfcDimensionalExponents extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent){
            super();
            this.LengthExponent = LengthExponent;
            this.MassExponent = MassExponent;
            this.TimeExponent = TimeExponent;
            this.ElectricCurrentExponent = ElectricCurrentExponent;
            this.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
            this.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
            this.LuminousIntensityExponent = LuminousIntensityExponent;
            this.type = 2949456006;
        }
    }
    IFC42.IfcDimensionalExponents = IfcDimensionalExponents;
    class IfcExternalInformation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 4294318154;
        }
    }
    IFC42.IfcExternalInformation = IfcExternalInformation;
    class IfcExternalReference extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Location, Identification, Name){
            super();
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.type = 3200245327;
        }
    }
    IFC42.IfcExternalReference = IfcExternalReference;
    class IfcExternallyDefinedHatchStyle extends IfcExternalReference {
        constructor(Location, Identification, Name){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.type = 2242383968;
        }
    }
    IFC42.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;
    class IfcExternallyDefinedSurfaceStyle extends IfcExternalReference {
        constructor(Location, Identification, Name){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.type = 1040185647;
        }
    }
    IFC42.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;
    class IfcExternallyDefinedTextFont extends IfcExternalReference {
        constructor(Location, Identification, Name){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.type = 3548104201;
        }
    }
    IFC42.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;
    class IfcGridAxis extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(AxisTag, AxisCurve, SameSense){
            super();
            this.AxisTag = AxisTag;
            this.AxisCurve = AxisCurve;
            this.SameSense = SameSense;
            this.type = 852622518;
        }
    }
    IFC42.IfcGridAxis = IfcGridAxis;
    class IfcIrregularTimeSeriesValue extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(TimeStamp, ListValues){
            super();
            this.TimeStamp = TimeStamp;
            this.ListValues = ListValues;
            this.type = 3020489413;
        }
    }
    IFC42.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;
    class IfcLibraryInformation extends IfcExternalInformation {
        constructor(Name, Version, Publisher, VersionDate, Location, Description){
            super();
            this.Name = Name;
            this.Version = Version;
            this.Publisher = Publisher;
            this.VersionDate = VersionDate;
            this.Location = Location;
            this.Description = Description;
            this.type = 2655187982;
        }
    }
    IFC42.IfcLibraryInformation = IfcLibraryInformation;
    class IfcLibraryReference extends IfcExternalReference {
        constructor(Location, Identification, Name, Description, Language, ReferencedLibrary){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.Description = Description;
            this.Language = Language;
            this.ReferencedLibrary = ReferencedLibrary;
            this.type = 3452421091;
        }
    }
    IFC42.IfcLibraryReference = IfcLibraryReference;
    class IfcLightDistributionData extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity){
            super();
            this.MainPlaneAngle = MainPlaneAngle;
            this.SecondaryPlaneAngle = SecondaryPlaneAngle;
            this.LuminousIntensity = LuminousIntensity;
            this.type = 4162380809;
        }
    }
    IFC42.IfcLightDistributionData = IfcLightDistributionData;
    class IfcLightIntensityDistribution extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(LightDistributionCurve, DistributionData){
            super();
            this.LightDistributionCurve = LightDistributionCurve;
            this.DistributionData = DistributionData;
            this.type = 1566485204;
        }
    }
    IFC42.IfcLightIntensityDistribution = IfcLightIntensityDistribution;
    class IfcMapConversion extends IfcCoordinateOperation {
        constructor(SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale){
            super(SourceCRS, TargetCRS);
            this.SourceCRS = SourceCRS;
            this.TargetCRS = TargetCRS;
            this.Eastings = Eastings;
            this.Northings = Northings;
            this.OrthogonalHeight = OrthogonalHeight;
            this.XAxisAbscissa = XAxisAbscissa;
            this.XAxisOrdinate = XAxisOrdinate;
            this.Scale = Scale;
            this.type = 3057273783;
        }
    }
    IFC42.IfcMapConversion = IfcMapConversion;
    class IfcMaterialClassificationRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MaterialClassifications, ClassifiedMaterial){
            super();
            this.MaterialClassifications = MaterialClassifications;
            this.ClassifiedMaterial = ClassifiedMaterial;
            this.type = 1847130766;
        }
    }
    IFC42.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;
    class IfcMaterialDefinition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 760658860;
        }
    }
    IFC42.IfcMaterialDefinition = IfcMaterialDefinition;
    class IfcMaterialLayer extends IfcMaterialDefinition {
        constructor(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority){
            super();
            this.Material = Material;
            this.LayerThickness = LayerThickness;
            this.IsVentilated = IsVentilated;
            this.Name = Name;
            this.Description = Description;
            this.Category = Category;
            this.Priority = Priority;
            this.type = 248100487;
        }
    }
    IFC42.IfcMaterialLayer = IfcMaterialLayer;
    class IfcMaterialLayerSet extends IfcMaterialDefinition {
        constructor(MaterialLayers, LayerSetName, Description){
            super();
            this.MaterialLayers = MaterialLayers;
            this.LayerSetName = LayerSetName;
            this.Description = Description;
            this.type = 3303938423;
        }
    }
    IFC42.IfcMaterialLayerSet = IfcMaterialLayerSet;
    class IfcMaterialLayerWithOffsets extends IfcMaterialLayer {
        constructor(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority, OffsetDirection, OffsetValues){
            super(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority);
            this.Material = Material;
            this.LayerThickness = LayerThickness;
            this.IsVentilated = IsVentilated;
            this.Name = Name;
            this.Description = Description;
            this.Category = Category;
            this.Priority = Priority;
            this.OffsetDirection = OffsetDirection;
            this.OffsetValues = OffsetValues;
            this.type = 1847252529;
        }
    }
    IFC42.IfcMaterialLayerWithOffsets = IfcMaterialLayerWithOffsets;
    class IfcMaterialList extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Materials){
            super();
            this.Materials = Materials;
            this.type = 2199411900;
        }
    }
    IFC42.IfcMaterialList = IfcMaterialList;
    class IfcMaterialProfile extends IfcMaterialDefinition {
        constructor(Name, Description, Material, Profile, Priority, Category){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Material = Material;
            this.Profile = Profile;
            this.Priority = Priority;
            this.Category = Category;
            this.type = 2235152071;
        }
    }
    IFC42.IfcMaterialProfile = IfcMaterialProfile;
    class IfcMaterialProfileSet extends IfcMaterialDefinition {
        constructor(Name, Description, MaterialProfiles, CompositeProfile){
            super();
            this.Name = Name;
            this.Description = Description;
            this.MaterialProfiles = MaterialProfiles;
            this.CompositeProfile = CompositeProfile;
            this.type = 164193824;
        }
    }
    IFC42.IfcMaterialProfileSet = IfcMaterialProfileSet;
    class IfcMaterialProfileWithOffsets extends IfcMaterialProfile {
        constructor(Name, Description, Material, Profile, Priority, Category, OffsetValues){
            super(Name, Description, Material, Profile, Priority, Category);
            this.Name = Name;
            this.Description = Description;
            this.Material = Material;
            this.Profile = Profile;
            this.Priority = Priority;
            this.Category = Category;
            this.OffsetValues = OffsetValues;
            this.type = 552965576;
        }
    }
    IFC42.IfcMaterialProfileWithOffsets = IfcMaterialProfileWithOffsets;
    class IfcMaterialUsageDefinition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 1507914824;
        }
    }
    IFC42.IfcMaterialUsageDefinition = IfcMaterialUsageDefinition;
    class IfcMeasureWithUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ValueComponent, UnitComponent){
            super();
            this.ValueComponent = ValueComponent;
            this.UnitComponent = UnitComponent;
            this.type = 2597039031;
        }
    }
    IFC42.IfcMeasureWithUnit = IfcMeasureWithUnit;
    class IfcMetric extends IfcConstraint {
        constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue, ReferencePath){
            super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
            this.Name = Name;
            this.Description = Description;
            this.ConstraintGrade = ConstraintGrade;
            this.ConstraintSource = ConstraintSource;
            this.CreatingActor = CreatingActor;
            this.CreationTime = CreationTime;
            this.UserDefinedGrade = UserDefinedGrade;
            this.Benchmark = Benchmark;
            this.ValueSource = ValueSource;
            this.DataValue = DataValue;
            this.ReferencePath = ReferencePath;
            this.type = 3368373690;
        }
    }
    IFC42.IfcMetric = IfcMetric;
    class IfcMonetaryUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Currency){
            super();
            this.Currency = Currency;
            this.type = 2706619895;
        }
    }
    IFC42.IfcMonetaryUnit = IfcMonetaryUnit;
    class IfcNamedUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Dimensions, UnitType){
            super();
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.type = 1918398963;
        }
    }
    IFC42.IfcNamedUnit = IfcNamedUnit;
    class IfcObjectPlacement extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 3701648758;
        }
    }
    IFC42.IfcObjectPlacement = IfcObjectPlacement;
    class IfcObjective extends IfcConstraint {
        constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, LogicalAggregator, ObjectiveQualifier, UserDefinedQualifier){
            super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
            this.Name = Name;
            this.Description = Description;
            this.ConstraintGrade = ConstraintGrade;
            this.ConstraintSource = ConstraintSource;
            this.CreatingActor = CreatingActor;
            this.CreationTime = CreationTime;
            this.UserDefinedGrade = UserDefinedGrade;
            this.BenchmarkValues = BenchmarkValues;
            this.LogicalAggregator = LogicalAggregator;
            this.ObjectiveQualifier = ObjectiveQualifier;
            this.UserDefinedQualifier = UserDefinedQualifier;
            this.type = 2251480897;
        }
    }
    IFC42.IfcObjective = IfcObjective;
    class IfcOrganization extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Identification, Name, Description, Roles, Addresses){
            super();
            this.Identification = Identification;
            this.Name = Name;
            this.Description = Description;
            this.Roles = Roles;
            this.Addresses = Addresses;
            this.type = 4251960020;
        }
    }
    IFC42.IfcOrganization = IfcOrganization;
    class IfcOwnerHistory extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate){
            super();
            this.OwningUser = OwningUser;
            this.OwningApplication = OwningApplication;
            this.State = State;
            this.ChangeAction = ChangeAction;
            this.LastModifiedDate = LastModifiedDate;
            this.LastModifyingUser = LastModifyingUser;
            this.LastModifyingApplication = LastModifyingApplication;
            this.CreationDate = CreationDate;
            this.type = 1207048766;
        }
    }
    IFC42.IfcOwnerHistory = IfcOwnerHistory;
    class IfcPerson extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Identification, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses){
            super();
            this.Identification = Identification;
            this.FamilyName = FamilyName;
            this.GivenName = GivenName;
            this.MiddleNames = MiddleNames;
            this.PrefixTitles = PrefixTitles;
            this.SuffixTitles = SuffixTitles;
            this.Roles = Roles;
            this.Addresses = Addresses;
            this.type = 2077209135;
        }
    }
    IFC42.IfcPerson = IfcPerson;
    class IfcPersonAndOrganization extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ThePerson, TheOrganization, Roles){
            super();
            this.ThePerson = ThePerson;
            this.TheOrganization = TheOrganization;
            this.Roles = Roles;
            this.type = 101040310;
        }
    }
    IFC42.IfcPersonAndOrganization = IfcPersonAndOrganization;
    class IfcPhysicalQuantity extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description){
            super();
            this.Name = Name;
            this.Description = Description;
            this.type = 2483315170;
        }
    }
    IFC42.IfcPhysicalQuantity = IfcPhysicalQuantity;
    class IfcPhysicalSimpleQuantity extends IfcPhysicalQuantity {
        constructor(Name, Description, Unit){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.type = 2226359599;
        }
    }
    IFC42.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;
    class IfcPostalAddress extends IfcAddress {
        constructor(Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country){
            super(Purpose, Description, UserDefinedPurpose);
            this.Purpose = Purpose;
            this.Description = Description;
            this.UserDefinedPurpose = UserDefinedPurpose;
            this.InternalLocation = InternalLocation;
            this.AddressLines = AddressLines;
            this.PostalBox = PostalBox;
            this.Town = Town;
            this.Region = Region;
            this.PostalCode = PostalCode;
            this.Country = Country;
            this.type = 3355820592;
        }
    }
    IFC42.IfcPostalAddress = IfcPostalAddress;
    class IfcPresentationItem extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 677532197;
        }
    }
    IFC42.IfcPresentationItem = IfcPresentationItem;
    class IfcPresentationLayerAssignment extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, AssignedItems, Identifier){
            super();
            this.Name = Name;
            this.Description = Description;
            this.AssignedItems = AssignedItems;
            this.Identifier = Identifier;
            this.type = 2022622350;
        }
    }
    IFC42.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;
    class IfcPresentationLayerWithStyle extends IfcPresentationLayerAssignment {
        constructor(Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles){
            super(Name, Description, AssignedItems, Identifier);
            this.Name = Name;
            this.Description = Description;
            this.AssignedItems = AssignedItems;
            this.Identifier = Identifier;
            this.LayerOn = LayerOn;
            this.LayerFrozen = LayerFrozen;
            this.LayerBlocked = LayerBlocked;
            this.LayerStyles = LayerStyles;
            this.type = 1304840413;
        }
    }
    IFC42.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;
    class IfcPresentationStyle extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 3119450353;
        }
    }
    IFC42.IfcPresentationStyle = IfcPresentationStyle;
    class IfcPresentationStyleAssignment extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Styles){
            super();
            this.Styles = Styles;
            this.type = 2417041796;
        }
    }
    IFC42.IfcPresentationStyleAssignment = IfcPresentationStyleAssignment;
    class IfcProductRepresentation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, Representations){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Representations = Representations;
            this.type = 2095639259;
        }
    }
    IFC42.IfcProductRepresentation = IfcProductRepresentation;
    class IfcProfileDef extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ProfileType, ProfileName){
            super();
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.type = 3958567839;
        }
    }
    IFC42.IfcProfileDef = IfcProfileDef;
    class IfcProjectedCRS extends IfcCoordinateReferenceSystem {
        constructor(Name, Description, GeodeticDatum, VerticalDatum, MapProjection, MapZone, MapUnit){
            super(Name, Description, GeodeticDatum, VerticalDatum);
            this.Name = Name;
            this.Description = Description;
            this.GeodeticDatum = GeodeticDatum;
            this.VerticalDatum = VerticalDatum;
            this.MapProjection = MapProjection;
            this.MapZone = MapZone;
            this.MapUnit = MapUnit;
            this.type = 3843373140;
        }
    }
    IFC42.IfcProjectedCRS = IfcProjectedCRS;
    class IfcPropertyAbstraction extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 986844984;
        }
    }
    IFC42.IfcPropertyAbstraction = IfcPropertyAbstraction;
    class IfcPropertyEnumeration extends IfcPropertyAbstraction {
        constructor(Name, EnumerationValues, Unit){
            super();
            this.Name = Name;
            this.EnumerationValues = EnumerationValues;
            this.Unit = Unit;
            this.type = 3710013099;
        }
    }
    IFC42.IfcPropertyEnumeration = IfcPropertyEnumeration;
    class IfcQuantityArea extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, AreaValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.AreaValue = AreaValue;
            this.Formula = Formula;
            this.type = 2044713172;
        }
    }
    IFC42.IfcQuantityArea = IfcQuantityArea;
    class IfcQuantityCount extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, CountValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.CountValue = CountValue;
            this.Formula = Formula;
            this.type = 2093928680;
        }
    }
    IFC42.IfcQuantityCount = IfcQuantityCount;
    class IfcQuantityLength extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, LengthValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.LengthValue = LengthValue;
            this.Formula = Formula;
            this.type = 931644368;
        }
    }
    IFC42.IfcQuantityLength = IfcQuantityLength;
    class IfcQuantityTime extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, TimeValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.TimeValue = TimeValue;
            this.Formula = Formula;
            this.type = 3252649465;
        }
    }
    IFC42.IfcQuantityTime = IfcQuantityTime;
    class IfcQuantityVolume extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, VolumeValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.VolumeValue = VolumeValue;
            this.Formula = Formula;
            this.type = 2405470396;
        }
    }
    IFC42.IfcQuantityVolume = IfcQuantityVolume;
    class IfcQuantityWeight extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, WeightValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.WeightValue = WeightValue;
            this.Formula = Formula;
            this.type = 825690147;
        }
    }
    IFC42.IfcQuantityWeight = IfcQuantityWeight;
    class IfcRecurrencePattern extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RecurrenceType, DayComponent, WeekdayComponent, MonthComponent, Position, Interval, Occurrences, TimePeriods){
            super();
            this.RecurrenceType = RecurrenceType;
            this.DayComponent = DayComponent;
            this.WeekdayComponent = WeekdayComponent;
            this.MonthComponent = MonthComponent;
            this.Position = Position;
            this.Interval = Interval;
            this.Occurrences = Occurrences;
            this.TimePeriods = TimePeriods;
            this.type = 3915482550;
        }
    }
    IFC42.IfcRecurrencePattern = IfcRecurrencePattern;
    class IfcReference extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(TypeIdentifier, AttributeIdentifier, InstanceName, ListPositions, InnerReference){
            super();
            this.TypeIdentifier = TypeIdentifier;
            this.AttributeIdentifier = AttributeIdentifier;
            this.InstanceName = InstanceName;
            this.ListPositions = ListPositions;
            this.InnerReference = InnerReference;
            this.type = 2433181523;
        }
    }
    IFC42.IfcReference = IfcReference;
    class IfcRepresentation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super();
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 1076942058;
        }
    }
    IFC42.IfcRepresentation = IfcRepresentation;
    class IfcRepresentationContext extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ContextIdentifier, ContextType){
            super();
            this.ContextIdentifier = ContextIdentifier;
            this.ContextType = ContextType;
            this.type = 3377609919;
        }
    }
    IFC42.IfcRepresentationContext = IfcRepresentationContext;
    class IfcRepresentationItem extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 3008791417;
        }
    }
    IFC42.IfcRepresentationItem = IfcRepresentationItem;
    class IfcRepresentationMap extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MappingOrigin, MappedRepresentation){
            super();
            this.MappingOrigin = MappingOrigin;
            this.MappedRepresentation = MappedRepresentation;
            this.type = 1660063152;
        }
    }
    IFC42.IfcRepresentationMap = IfcRepresentationMap;
    class IfcResourceLevelRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description){
            super();
            this.Name = Name;
            this.Description = Description;
            this.type = 2439245199;
        }
    }
    IFC42.IfcResourceLevelRelationship = IfcResourceLevelRelationship;
    class IfcRoot extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super();
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 2341007311;
        }
    }
    IFC42.IfcRoot = IfcRoot;
    class IfcSIUnit extends IfcNamedUnit {
        constructor(UnitType, Prefix, Name){
            super(new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), UnitType);
            this.UnitType = UnitType;
            this.Prefix = Prefix;
            this.Name = Name;
            this.type = 448429030;
        }
    }
    IFC42.IfcSIUnit = IfcSIUnit;
    class IfcSchedulingTime extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, DataOrigin, UserDefinedDataOrigin){
            super();
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.type = 1054537805;
        }
    }
    IFC42.IfcSchedulingTime = IfcSchedulingTime;
    class IfcShapeAspect extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape){
            super();
            this.ShapeRepresentations = ShapeRepresentations;
            this.Name = Name;
            this.Description = Description;
            this.ProductDefinitional = ProductDefinitional;
            this.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
            this.type = 867548509;
        }
    }
    IFC42.IfcShapeAspect = IfcShapeAspect;
    class IfcShapeModel extends IfcRepresentation {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 3982875396;
        }
    }
    IFC42.IfcShapeModel = IfcShapeModel;
    class IfcShapeRepresentation extends IfcShapeModel {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 4240577450;
        }
    }
    IFC42.IfcShapeRepresentation = IfcShapeRepresentation;
    class IfcStructuralConnectionCondition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 2273995522;
        }
    }
    IFC42.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;
    class IfcStructuralLoad extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 2162789131;
        }
    }
    IFC42.IfcStructuralLoad = IfcStructuralLoad;
    class IfcStructuralLoadConfiguration extends IfcStructuralLoad {
        constructor(Name, Values, Locations){
            super(Name);
            this.Name = Name;
            this.Values = Values;
            this.Locations = Locations;
            this.type = 3478079324;
        }
    }
    IFC42.IfcStructuralLoadConfiguration = IfcStructuralLoadConfiguration;
    class IfcStructuralLoadOrResult extends IfcStructuralLoad {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 609421318;
        }
    }
    IFC42.IfcStructuralLoadOrResult = IfcStructuralLoadOrResult;
    class IfcStructuralLoadStatic extends IfcStructuralLoadOrResult {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 2525727697;
        }
    }
    IFC42.IfcStructuralLoadStatic = IfcStructuralLoadStatic;
    class IfcStructuralLoadTemperature extends IfcStructuralLoadStatic {
        constructor(Name, DeltaTConstant, DeltaTY, DeltaTZ){
            super(Name);
            this.Name = Name;
            this.DeltaTConstant = DeltaTConstant;
            this.DeltaTY = DeltaTY;
            this.DeltaTZ = DeltaTZ;
            this.type = 3408363356;
        }
    }
    IFC42.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;
    class IfcStyleModel extends IfcRepresentation {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 2830218821;
        }
    }
    IFC42.IfcStyleModel = IfcStyleModel;
    class IfcStyledItem extends IfcRepresentationItem {
        constructor(Item, Styles, Name){
            super();
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 3958052878;
        }
    }
    IFC42.IfcStyledItem = IfcStyledItem;
    class IfcStyledRepresentation extends IfcStyleModel {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 3049322572;
        }
    }
    IFC42.IfcStyledRepresentation = IfcStyledRepresentation;
    class IfcSurfaceReinforcementArea extends IfcStructuralLoadOrResult {
        constructor(Name, SurfaceReinforcement1, SurfaceReinforcement2, ShearReinforcement){
            super(Name);
            this.Name = Name;
            this.SurfaceReinforcement1 = SurfaceReinforcement1;
            this.SurfaceReinforcement2 = SurfaceReinforcement2;
            this.ShearReinforcement = ShearReinforcement;
            this.type = 2934153892;
        }
    }
    IFC42.IfcSurfaceReinforcementArea = IfcSurfaceReinforcementArea;
    class IfcSurfaceStyle extends IfcPresentationStyle {
        constructor(Name, Side, Styles){
            super(Name);
            this.Name = Name;
            this.Side = Side;
            this.Styles = Styles;
            this.type = 1300840506;
        }
    }
    IFC42.IfcSurfaceStyle = IfcSurfaceStyle;
    class IfcSurfaceStyleLighting extends IfcPresentationItem {
        constructor(DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour){
            super();
            this.DiffuseTransmissionColour = DiffuseTransmissionColour;
            this.DiffuseReflectionColour = DiffuseReflectionColour;
            this.TransmissionColour = TransmissionColour;
            this.ReflectanceColour = ReflectanceColour;
            this.type = 3303107099;
        }
    }
    IFC42.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;
    class IfcSurfaceStyleRefraction extends IfcPresentationItem {
        constructor(RefractionIndex, DispersionFactor){
            super();
            this.RefractionIndex = RefractionIndex;
            this.DispersionFactor = DispersionFactor;
            this.type = 1607154358;
        }
    }
    IFC42.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;
    class IfcSurfaceStyleShading extends IfcPresentationItem {
        constructor(SurfaceColour, Transparency){
            super();
            this.SurfaceColour = SurfaceColour;
            this.Transparency = Transparency;
            this.type = 846575682;
        }
    }
    IFC42.IfcSurfaceStyleShading = IfcSurfaceStyleShading;
    class IfcSurfaceStyleWithTextures extends IfcPresentationItem {
        constructor(Textures){
            super();
            this.Textures = Textures;
            this.type = 1351298697;
        }
    }
    IFC42.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;
    class IfcSurfaceTexture extends IfcPresentationItem {
        constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter){
            super();
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.Mode = Mode;
            this.TextureTransform = TextureTransform;
            this.Parameter = Parameter;
            this.type = 626085974;
        }
    }
    IFC42.IfcSurfaceTexture = IfcSurfaceTexture;
    class IfcTable extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Rows, Columns){
            super();
            this.Name = Name;
            this.Rows = Rows;
            this.Columns = Columns;
            this.type = 985171141;
        }
    }
    IFC42.IfcTable = IfcTable;
    class IfcTableColumn extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Identifier, Name, Description, Unit, ReferencePath){
            super();
            this.Identifier = Identifier;
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.ReferencePath = ReferencePath;
            this.type = 2043862942;
        }
    }
    IFC42.IfcTableColumn = IfcTableColumn;
    class IfcTableRow extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RowCells, IsHeading){
            super();
            this.RowCells = RowCells;
            this.IsHeading = IsHeading;
            this.type = 531007025;
        }
    }
    IFC42.IfcTableRow = IfcTableRow;
    class IfcTaskTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.DurationType = DurationType;
            this.ScheduleDuration = ScheduleDuration;
            this.ScheduleStart = ScheduleStart;
            this.ScheduleFinish = ScheduleFinish;
            this.EarlyStart = EarlyStart;
            this.EarlyFinish = EarlyFinish;
            this.LateStart = LateStart;
            this.LateFinish = LateFinish;
            this.FreeFloat = FreeFloat;
            this.TotalFloat = TotalFloat;
            this.IsCritical = IsCritical;
            this.StatusTime = StatusTime;
            this.ActualDuration = ActualDuration;
            this.ActualStart = ActualStart;
            this.ActualFinish = ActualFinish;
            this.RemainingTime = RemainingTime;
            this.Completion = Completion;
            this.type = 1549132990;
        }
    }
    IFC42.IfcTaskTime = IfcTaskTime;
    class IfcTaskTimeRecurring extends IfcTaskTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion, Recurrence){
            super(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.DurationType = DurationType;
            this.ScheduleDuration = ScheduleDuration;
            this.ScheduleStart = ScheduleStart;
            this.ScheduleFinish = ScheduleFinish;
            this.EarlyStart = EarlyStart;
            this.EarlyFinish = EarlyFinish;
            this.LateStart = LateStart;
            this.LateFinish = LateFinish;
            this.FreeFloat = FreeFloat;
            this.TotalFloat = TotalFloat;
            this.IsCritical = IsCritical;
            this.StatusTime = StatusTime;
            this.ActualDuration = ActualDuration;
            this.ActualStart = ActualStart;
            this.ActualFinish = ActualFinish;
            this.RemainingTime = RemainingTime;
            this.Completion = Completion;
            this.Recurrence = Recurrence;
            this.type = 2771591690;
        }
    }
    IFC42.IfcTaskTimeRecurring = IfcTaskTimeRecurring;
    class IfcTelecomAddress extends IfcAddress {
        constructor(Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL, MessagingIDs){
            super(Purpose, Description, UserDefinedPurpose);
            this.Purpose = Purpose;
            this.Description = Description;
            this.UserDefinedPurpose = UserDefinedPurpose;
            this.TelephoneNumbers = TelephoneNumbers;
            this.FacsimileNumbers = FacsimileNumbers;
            this.PagerNumber = PagerNumber;
            this.ElectronicMailAddresses = ElectronicMailAddresses;
            this.WWWHomePageURL = WWWHomePageURL;
            this.MessagingIDs = MessagingIDs;
            this.type = 912023232;
        }
    }
    IFC42.IfcTelecomAddress = IfcTelecomAddress;
    class IfcTextStyle extends IfcPresentationStyle {
        constructor(Name, TextCharacterAppearance, TextStyle, TextFontStyle, ModelOrDraughting){
            super(Name);
            this.Name = Name;
            this.TextCharacterAppearance = TextCharacterAppearance;
            this.TextStyle = TextStyle;
            this.TextFontStyle = TextFontStyle;
            this.ModelOrDraughting = ModelOrDraughting;
            this.type = 1447204868;
        }
    }
    IFC42.IfcTextStyle = IfcTextStyle;
    class IfcTextStyleForDefinedFont extends IfcPresentationItem {
        constructor(Colour, BackgroundColour){
            super();
            this.Colour = Colour;
            this.BackgroundColour = BackgroundColour;
            this.type = 2636378356;
        }
    }
    IFC42.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;
    class IfcTextStyleTextModel extends IfcPresentationItem {
        constructor(TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight){
            super();
            this.TextIndent = TextIndent;
            this.TextAlign = TextAlign;
            this.TextDecoration = TextDecoration;
            this.LetterSpacing = LetterSpacing;
            this.WordSpacing = WordSpacing;
            this.TextTransform = TextTransform;
            this.LineHeight = LineHeight;
            this.type = 1640371178;
        }
    }
    IFC42.IfcTextStyleTextModel = IfcTextStyleTextModel;
    class IfcTextureCoordinate extends IfcPresentationItem {
        constructor(Maps){
            super();
            this.Maps = Maps;
            this.type = 280115917;
        }
    }
    IFC42.IfcTextureCoordinate = IfcTextureCoordinate;
    class IfcTextureCoordinateGenerator extends IfcTextureCoordinate {
        constructor(Maps, Mode, Parameter){
            super(Maps);
            this.Maps = Maps;
            this.Mode = Mode;
            this.Parameter = Parameter;
            this.type = 1742049831;
        }
    }
    IFC42.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;
    class IfcTextureMap extends IfcTextureCoordinate {
        constructor(Maps, Vertices, MappedTo){
            super(Maps);
            this.Maps = Maps;
            this.Vertices = Vertices;
            this.MappedTo = MappedTo;
            this.type = 2552916305;
        }
    }
    IFC42.IfcTextureMap = IfcTextureMap;
    class IfcTextureVertex extends IfcPresentationItem {
        constructor(Coordinates){
            super();
            this.Coordinates = Coordinates;
            this.type = 1210645708;
        }
    }
    IFC42.IfcTextureVertex = IfcTextureVertex;
    class IfcTextureVertexList extends IfcPresentationItem {
        constructor(TexCoordsList){
            super();
            this.TexCoordsList = TexCoordsList;
            this.type = 3611470254;
        }
    }
    IFC42.IfcTextureVertexList = IfcTextureVertexList;
    class IfcTimePeriod extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(StartTime, EndTime){
            super();
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.type = 1199560280;
        }
    }
    IFC42.IfcTimePeriod = IfcTimePeriod;
    class IfcTimeSeries extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit){
            super();
            this.Name = Name;
            this.Description = Description;
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.TimeSeriesDataType = TimeSeriesDataType;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.Unit = Unit;
            this.type = 3101149627;
        }
    }
    IFC42.IfcTimeSeries = IfcTimeSeries;
    class IfcTimeSeriesValue extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ListValues){
            super();
            this.ListValues = ListValues;
            this.type = 581633288;
        }
    }
    IFC42.IfcTimeSeriesValue = IfcTimeSeriesValue;
    class IfcTopologicalRepresentationItem extends IfcRepresentationItem {
        constructor(){
            super();
            this.type = 1377556343;
        }
    }
    IFC42.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;
    class IfcTopologyRepresentation extends IfcShapeModel {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 1735638870;
        }
    }
    IFC42.IfcTopologyRepresentation = IfcTopologyRepresentation;
    class IfcUnitAssignment extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Units){
            super();
            this.Units = Units;
            this.type = 180925521;
        }
    }
    IFC42.IfcUnitAssignment = IfcUnitAssignment;
    class IfcVertex extends IfcTopologicalRepresentationItem {
        constructor(){
            super();
            this.type = 2799835756;
        }
    }
    IFC42.IfcVertex = IfcVertex;
    class IfcVertexPoint extends IfcVertex {
        constructor(VertexGeometry){
            super();
            this.VertexGeometry = VertexGeometry;
            this.type = 1907098498;
        }
    }
    IFC42.IfcVertexPoint = IfcVertexPoint;
    class IfcVirtualGridIntersection extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(IntersectingAxes, OffsetDistances){
            super();
            this.IntersectingAxes = IntersectingAxes;
            this.OffsetDistances = OffsetDistances;
            this.type = 891718957;
        }
    }
    IFC42.IfcVirtualGridIntersection = IfcVirtualGridIntersection;
    class IfcWorkTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, RecurrencePattern, Start, Finish){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.RecurrencePattern = RecurrencePattern;
            this.Start = Start;
            this.Finish = Finish;
            this.type = 1236880293;
        }
    }
    IFC42.IfcWorkTime = IfcWorkTime;
    class IfcApprovalRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingApproval, RelatedApprovals){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingApproval = RelatingApproval;
            this.RelatedApprovals = RelatedApprovals;
            this.type = 3869604511;
        }
    }
    IFC42.IfcApprovalRelationship = IfcApprovalRelationship;
    class IfcArbitraryClosedProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, OuterCurve){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.OuterCurve = OuterCurve;
            this.type = 3798115385;
        }
    }
    IFC42.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;
    class IfcArbitraryOpenProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, Curve){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Curve = Curve;
            this.type = 1310608509;
        }
    }
    IFC42.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;
    class IfcArbitraryProfileDefWithVoids extends IfcArbitraryClosedProfileDef {
        constructor(ProfileType, ProfileName, OuterCurve, InnerCurves){
            super(ProfileType, ProfileName, OuterCurve);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.OuterCurve = OuterCurve;
            this.InnerCurves = InnerCurves;
            this.type = 2705031697;
        }
    }
    IFC42.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;
    class IfcBlobTexture extends IfcSurfaceTexture {
        constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, RasterFormat, RasterCode){
            super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.Mode = Mode;
            this.TextureTransform = TextureTransform;
            this.Parameter = Parameter;
            this.RasterFormat = RasterFormat;
            this.RasterCode = RasterCode;
            this.type = 616511568;
        }
    }
    IFC42.IfcBlobTexture = IfcBlobTexture;
    class IfcCenterLineProfileDef extends IfcArbitraryOpenProfileDef {
        constructor(ProfileType, ProfileName, Curve, Thickness){
            super(ProfileType, ProfileName, Curve);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Curve = Curve;
            this.Thickness = Thickness;
            this.type = 3150382593;
        }
    }
    IFC42.IfcCenterLineProfileDef = IfcCenterLineProfileDef;
    class IfcClassification extends IfcExternalInformation {
        constructor(Source, Edition, EditionDate, Name, Description, Location, ReferenceTokens){
            super();
            this.Source = Source;
            this.Edition = Edition;
            this.EditionDate = EditionDate;
            this.Name = Name;
            this.Description = Description;
            this.Location = Location;
            this.ReferenceTokens = ReferenceTokens;
            this.type = 747523909;
        }
    }
    IFC42.IfcClassification = IfcClassification;
    class IfcClassificationReference extends IfcExternalReference {
        constructor(Location, Identification, Name, ReferencedSource, Description, Sort){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.ReferencedSource = ReferencedSource;
            this.Description = Description;
            this.Sort = Sort;
            this.type = 647927063;
        }
    }
    IFC42.IfcClassificationReference = IfcClassificationReference;
    class IfcColourRgbList extends IfcPresentationItem {
        constructor(ColourList){
            super();
            this.ColourList = ColourList;
            this.type = 3285139300;
        }
    }
    IFC42.IfcColourRgbList = IfcColourRgbList;
    class IfcColourSpecification extends IfcPresentationItem {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 3264961684;
        }
    }
    IFC42.IfcColourSpecification = IfcColourSpecification;
    class IfcCompositeProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, Profiles, Label){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Profiles = Profiles;
            this.Label = Label;
            this.type = 1485152156;
        }
    }
    IFC42.IfcCompositeProfileDef = IfcCompositeProfileDef;
    class IfcConnectedFaceSet extends IfcTopologicalRepresentationItem {
        constructor(CfsFaces){
            super();
            this.CfsFaces = CfsFaces;
            this.type = 370225590;
        }
    }
    IFC42.IfcConnectedFaceSet = IfcConnectedFaceSet;
    class IfcConnectionCurveGeometry extends IfcConnectionGeometry {
        constructor(CurveOnRelatingElement, CurveOnRelatedElement){
            super();
            this.CurveOnRelatingElement = CurveOnRelatingElement;
            this.CurveOnRelatedElement = CurveOnRelatedElement;
            this.type = 1981873012;
        }
    }
    IFC42.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;
    class IfcConnectionPointEccentricity extends IfcConnectionPointGeometry {
        constructor(PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ){
            super(PointOnRelatingElement, PointOnRelatedElement);
            this.PointOnRelatingElement = PointOnRelatingElement;
            this.PointOnRelatedElement = PointOnRelatedElement;
            this.EccentricityInX = EccentricityInX;
            this.EccentricityInY = EccentricityInY;
            this.EccentricityInZ = EccentricityInZ;
            this.type = 45288368;
        }
    }
    IFC42.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;
    class IfcContextDependentUnit extends IfcNamedUnit {
        constructor(Dimensions, UnitType, Name){
            super(Dimensions, UnitType);
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.Name = Name;
            this.type = 3050246964;
        }
    }
    IFC42.IfcContextDependentUnit = IfcContextDependentUnit;
    class IfcConversionBasedUnit extends IfcNamedUnit {
        constructor(Dimensions, UnitType, Name, ConversionFactor){
            super(Dimensions, UnitType);
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.Name = Name;
            this.ConversionFactor = ConversionFactor;
            this.type = 2889183280;
        }
    }
    IFC42.IfcConversionBasedUnit = IfcConversionBasedUnit;
    class IfcConversionBasedUnitWithOffset extends IfcConversionBasedUnit {
        constructor(Dimensions, UnitType, Name, ConversionFactor, ConversionOffset){
            super(Dimensions, UnitType, Name, ConversionFactor);
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.Name = Name;
            this.ConversionFactor = ConversionFactor;
            this.ConversionOffset = ConversionOffset;
            this.type = 2713554722;
        }
    }
    IFC42.IfcConversionBasedUnitWithOffset = IfcConversionBasedUnitWithOffset;
    class IfcCurrencyRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingMonetaryUnit = RelatingMonetaryUnit;
            this.RelatedMonetaryUnit = RelatedMonetaryUnit;
            this.ExchangeRate = ExchangeRate;
            this.RateDateTime = RateDateTime;
            this.RateSource = RateSource;
            this.type = 539742890;
        }
    }
    IFC42.IfcCurrencyRelationship = IfcCurrencyRelationship;
    class IfcCurveStyle extends IfcPresentationStyle {
        constructor(Name, CurveFont, CurveWidth, CurveColour, ModelOrDraughting){
            super(Name);
            this.Name = Name;
            this.CurveFont = CurveFont;
            this.CurveWidth = CurveWidth;
            this.CurveColour = CurveColour;
            this.ModelOrDraughting = ModelOrDraughting;
            this.type = 3800577675;
        }
    }
    IFC42.IfcCurveStyle = IfcCurveStyle;
    class IfcCurveStyleFont extends IfcPresentationItem {
        constructor(Name, PatternList){
            super();
            this.Name = Name;
            this.PatternList = PatternList;
            this.type = 1105321065;
        }
    }
    IFC42.IfcCurveStyleFont = IfcCurveStyleFont;
    class IfcCurveStyleFontAndScaling extends IfcPresentationItem {
        constructor(Name, CurveFont, CurveFontScaling){
            super();
            this.Name = Name;
            this.CurveFont = CurveFont;
            this.CurveFontScaling = CurveFontScaling;
            this.type = 2367409068;
        }
    }
    IFC42.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;
    class IfcCurveStyleFontPattern extends IfcPresentationItem {
        constructor(VisibleSegmentLength, InvisibleSegmentLength){
            super();
            this.VisibleSegmentLength = VisibleSegmentLength;
            this.InvisibleSegmentLength = InvisibleSegmentLength;
            this.type = 3510044353;
        }
    }
    IFC42.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;
    class IfcDerivedProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, ParentProfile, Operator, Label){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.ParentProfile = ParentProfile;
            this.Operator = Operator;
            this.Label = Label;
            this.type = 3632507154;
        }
    }
    IFC42.IfcDerivedProfileDef = IfcDerivedProfileDef;
    class IfcDocumentInformation extends IfcExternalInformation {
        constructor(Identification, Name, Description, Location, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status){
            super();
            this.Identification = Identification;
            this.Name = Name;
            this.Description = Description;
            this.Location = Location;
            this.Purpose = Purpose;
            this.IntendedUse = IntendedUse;
            this.Scope = Scope;
            this.Revision = Revision;
            this.DocumentOwner = DocumentOwner;
            this.Editors = Editors;
            this.CreationTime = CreationTime;
            this.LastRevisionTime = LastRevisionTime;
            this.ElectronicFormat = ElectronicFormat;
            this.ValidFrom = ValidFrom;
            this.ValidUntil = ValidUntil;
            this.Confidentiality = Confidentiality;
            this.Status = Status;
            this.type = 1154170062;
        }
    }
    IFC42.IfcDocumentInformation = IfcDocumentInformation;
    class IfcDocumentInformationRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingDocument, RelatedDocuments, RelationshipType){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingDocument = RelatingDocument;
            this.RelatedDocuments = RelatedDocuments;
            this.RelationshipType = RelationshipType;
            this.type = 770865208;
        }
    }
    IFC42.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;
    class IfcDocumentReference extends IfcExternalReference {
        constructor(Location, Identification, Name, Description, ReferencedDocument){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.Description = Description;
            this.ReferencedDocument = ReferencedDocument;
            this.type = 3732053477;
        }
    }
    IFC42.IfcDocumentReference = IfcDocumentReference;
    class IfcEdge extends IfcTopologicalRepresentationItem {
        constructor(EdgeStart, EdgeEnd){
            super();
            this.EdgeStart = EdgeStart;
            this.EdgeEnd = EdgeEnd;
            this.type = 3900360178;
        }
    }
    IFC42.IfcEdge = IfcEdge;
    class IfcEdgeCurve extends IfcEdge {
        constructor(EdgeStart, EdgeEnd, EdgeGeometry, SameSense){
            super(EdgeStart, EdgeEnd);
            this.EdgeStart = EdgeStart;
            this.EdgeEnd = EdgeEnd;
            this.EdgeGeometry = EdgeGeometry;
            this.SameSense = SameSense;
            this.type = 476780140;
        }
    }
    IFC42.IfcEdgeCurve = IfcEdgeCurve;
    class IfcEventTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, ActualDate, EarlyDate, LateDate, ScheduleDate){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.ActualDate = ActualDate;
            this.EarlyDate = EarlyDate;
            this.LateDate = LateDate;
            this.ScheduleDate = ScheduleDate;
            this.type = 211053100;
        }
    }
    IFC42.IfcEventTime = IfcEventTime;
    class IfcExtendedProperties extends IfcPropertyAbstraction {
        constructor(Name, Description, Properties2){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Properties = Properties2;
            this.type = 297599258;
        }
    }
    IFC42.IfcExtendedProperties = IfcExtendedProperties;
    class IfcExternalReferenceRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingReference, RelatedResourceObjects){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingReference = RelatingReference;
            this.RelatedResourceObjects = RelatedResourceObjects;
            this.type = 1437805879;
        }
    }
    IFC42.IfcExternalReferenceRelationship = IfcExternalReferenceRelationship;
    class IfcFace extends IfcTopologicalRepresentationItem {
        constructor(Bounds){
            super();
            this.Bounds = Bounds;
            this.type = 2556980723;
        }
    }
    IFC42.IfcFace = IfcFace;
    class IfcFaceBound extends IfcTopologicalRepresentationItem {
        constructor(Bound, Orientation){
            super();
            this.Bound = Bound;
            this.Orientation = Orientation;
            this.type = 1809719519;
        }
    }
    IFC42.IfcFaceBound = IfcFaceBound;
    class IfcFaceOuterBound extends IfcFaceBound {
        constructor(Bound, Orientation){
            super(Bound, Orientation);
            this.Bound = Bound;
            this.Orientation = Orientation;
            this.type = 803316827;
        }
    }
    IFC42.IfcFaceOuterBound = IfcFaceOuterBound;
    class IfcFaceSurface extends IfcFace {
        constructor(Bounds, FaceSurface, SameSense){
            super(Bounds);
            this.Bounds = Bounds;
            this.FaceSurface = FaceSurface;
            this.SameSense = SameSense;
            this.type = 3008276851;
        }
    }
    IFC42.IfcFaceSurface = IfcFaceSurface;
    class IfcFailureConnectionCondition extends IfcStructuralConnectionCondition {
        constructor(Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ){
            super(Name);
            this.Name = Name;
            this.TensionFailureX = TensionFailureX;
            this.TensionFailureY = TensionFailureY;
            this.TensionFailureZ = TensionFailureZ;
            this.CompressionFailureX = CompressionFailureX;
            this.CompressionFailureY = CompressionFailureY;
            this.CompressionFailureZ = CompressionFailureZ;
            this.type = 4219587988;
        }
    }
    IFC42.IfcFailureConnectionCondition = IfcFailureConnectionCondition;
    class IfcFillAreaStyle extends IfcPresentationStyle {
        constructor(Name, FillStyles, ModelorDraughting){
            super(Name);
            this.Name = Name;
            this.FillStyles = FillStyles;
            this.ModelorDraughting = ModelorDraughting;
            this.type = 738692330;
        }
    }
    IFC42.IfcFillAreaStyle = IfcFillAreaStyle;
    class IfcGeometricRepresentationContext extends IfcRepresentationContext {
        constructor(ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth){
            super(ContextIdentifier, ContextType);
            this.ContextIdentifier = ContextIdentifier;
            this.ContextType = ContextType;
            this.CoordinateSpaceDimension = CoordinateSpaceDimension;
            this.Precision = Precision;
            this.WorldCoordinateSystem = WorldCoordinateSystem;
            this.TrueNorth = TrueNorth;
            this.type = 3448662350;
        }
    }
    IFC42.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;
    class IfcGeometricRepresentationItem extends IfcRepresentationItem {
        constructor(){
            super();
            this.type = 2453401579;
        }
    }
    IFC42.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;
    class IfcGeometricRepresentationSubContext extends IfcGeometricRepresentationContext {
        constructor(ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView){
            super(ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), null);
            this.ContextIdentifier = ContextIdentifier;
            this.ContextType = ContextType;
            this.ParentContext = ParentContext;
            this.TargetScale = TargetScale;
            this.TargetView = TargetView;
            this.UserDefinedTargetView = UserDefinedTargetView;
            this.type = 4142052618;
        }
    }
    IFC42.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;
    class IfcGeometricSet extends IfcGeometricRepresentationItem {
        constructor(Elements){
            super();
            this.Elements = Elements;
            this.type = 3590301190;
        }
    }
    IFC42.IfcGeometricSet = IfcGeometricSet;
    class IfcGridPlacement extends IfcObjectPlacement {
        constructor(PlacementLocation, PlacementRefDirection){
            super();
            this.PlacementLocation = PlacementLocation;
            this.PlacementRefDirection = PlacementRefDirection;
            this.type = 178086475;
        }
    }
    IFC42.IfcGridPlacement = IfcGridPlacement;
    class IfcHalfSpaceSolid extends IfcGeometricRepresentationItem {
        constructor(BaseSurface, AgreementFlag){
            super();
            this.BaseSurface = BaseSurface;
            this.AgreementFlag = AgreementFlag;
            this.type = 812098782;
        }
    }
    IFC42.IfcHalfSpaceSolid = IfcHalfSpaceSolid;
    class IfcImageTexture extends IfcSurfaceTexture {
        constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, URLReference){
            super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.Mode = Mode;
            this.TextureTransform = TextureTransform;
            this.Parameter = Parameter;
            this.URLReference = URLReference;
            this.type = 3905492369;
        }
    }
    IFC42.IfcImageTexture = IfcImageTexture;
    class IfcIndexedColourMap extends IfcPresentationItem {
        constructor(MappedTo, Opacity, Colours, ColourIndex){
            super();
            this.MappedTo = MappedTo;
            this.Opacity = Opacity;
            this.Colours = Colours;
            this.ColourIndex = ColourIndex;
            this.type = 3570813810;
        }
    }
    IFC42.IfcIndexedColourMap = IfcIndexedColourMap;
    class IfcIndexedTextureMap extends IfcTextureCoordinate {
        constructor(Maps, MappedTo, TexCoords){
            super(Maps);
            this.Maps = Maps;
            this.MappedTo = MappedTo;
            this.TexCoords = TexCoords;
            this.type = 1437953363;
        }
    }
    IFC42.IfcIndexedTextureMap = IfcIndexedTextureMap;
    class IfcIndexedTriangleTextureMap extends IfcIndexedTextureMap {
        constructor(Maps, MappedTo, TexCoords, TexCoordIndex){
            super(Maps, MappedTo, TexCoords);
            this.Maps = Maps;
            this.MappedTo = MappedTo;
            this.TexCoords = TexCoords;
            this.TexCoordIndex = TexCoordIndex;
            this.type = 2133299955;
        }
    }
    IFC42.IfcIndexedTriangleTextureMap = IfcIndexedTriangleTextureMap;
    class IfcIrregularTimeSeries extends IfcTimeSeries {
        constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values){
            super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
            this.Name = Name;
            this.Description = Description;
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.TimeSeriesDataType = TimeSeriesDataType;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.Unit = Unit;
            this.Values = Values;
            this.type = 3741457305;
        }
    }
    IFC42.IfcIrregularTimeSeries = IfcIrregularTimeSeries;
    class IfcLagTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, LagValue, DurationType){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.LagValue = LagValue;
            this.DurationType = DurationType;
            this.type = 1585845231;
        }
    }
    IFC42.IfcLagTime = IfcLagTime;
    class IfcLightSource extends IfcGeometricRepresentationItem {
        constructor(Name, LightColour, AmbientIntensity, Intensity){
            super();
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.type = 1402838566;
        }
    }
    IFC42.IfcLightSource = IfcLightSource;
    class IfcLightSourceAmbient extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.type = 125510826;
        }
    }
    IFC42.IfcLightSourceAmbient = IfcLightSourceAmbient;
    class IfcLightSourceDirectional extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Orientation){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Orientation = Orientation;
            this.type = 2604431987;
        }
    }
    IFC42.IfcLightSourceDirectional = IfcLightSourceDirectional;
    class IfcLightSourceGoniometric extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Position = Position;
            this.ColourAppearance = ColourAppearance;
            this.ColourTemperature = ColourTemperature;
            this.LuminousFlux = LuminousFlux;
            this.LightEmissionSource = LightEmissionSource;
            this.LightDistributionDataSource = LightDistributionDataSource;
            this.type = 4266656042;
        }
    }
    IFC42.IfcLightSourceGoniometric = IfcLightSourceGoniometric;
    class IfcLightSourcePositional extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Position = Position;
            this.Radius = Radius;
            this.ConstantAttenuation = ConstantAttenuation;
            this.DistanceAttenuation = DistanceAttenuation;
            this.QuadricAttenuation = QuadricAttenuation;
            this.type = 1520743889;
        }
    }
    IFC42.IfcLightSourcePositional = IfcLightSourcePositional;
    class IfcLightSourceSpot extends IfcLightSourcePositional {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle){
            super(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Position = Position;
            this.Radius = Radius;
            this.ConstantAttenuation = ConstantAttenuation;
            this.DistanceAttenuation = DistanceAttenuation;
            this.QuadricAttenuation = QuadricAttenuation;
            this.Orientation = Orientation;
            this.ConcentrationExponent = ConcentrationExponent;
            this.SpreadAngle = SpreadAngle;
            this.BeamWidthAngle = BeamWidthAngle;
            this.type = 3422422726;
        }
    }
    IFC42.IfcLightSourceSpot = IfcLightSourceSpot;
    class IfcLocalPlacement extends IfcObjectPlacement {
        constructor(PlacementRelTo, RelativePlacement){
            super();
            this.PlacementRelTo = PlacementRelTo;
            this.RelativePlacement = RelativePlacement;
            this.type = 2624227202;
        }
    }
    IFC42.IfcLocalPlacement = IfcLocalPlacement;
    class IfcLoop extends IfcTopologicalRepresentationItem {
        constructor(){
            super();
            this.type = 1008929658;
        }
    }
    IFC42.IfcLoop = IfcLoop;
    class IfcMappedItem extends IfcRepresentationItem {
        constructor(MappingSource, MappingTarget){
            super();
            this.MappingSource = MappingSource;
            this.MappingTarget = MappingTarget;
            this.type = 2347385850;
        }
    }
    IFC42.IfcMappedItem = IfcMappedItem;
    class IfcMaterial extends IfcMaterialDefinition {
        constructor(Name, Description, Category){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Category = Category;
            this.type = 1838606355;
        }
    }
    IFC42.IfcMaterial = IfcMaterial;
    class IfcMaterialConstituent extends IfcMaterialDefinition {
        constructor(Name, Description, Material, Fraction, Category){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Material = Material;
            this.Fraction = Fraction;
            this.Category = Category;
            this.type = 3708119e3;
        }
    }
    IFC42.IfcMaterialConstituent = IfcMaterialConstituent;
    class IfcMaterialConstituentSet extends IfcMaterialDefinition {
        constructor(Name, Description, MaterialConstituents){
            super();
            this.Name = Name;
            this.Description = Description;
            this.MaterialConstituents = MaterialConstituents;
            this.type = 2852063980;
        }
    }
    IFC42.IfcMaterialConstituentSet = IfcMaterialConstituentSet;
    class IfcMaterialDefinitionRepresentation extends IfcProductRepresentation {
        constructor(Name, Description, Representations, RepresentedMaterial){
            super(Name, Description, Representations);
            this.Name = Name;
            this.Description = Description;
            this.Representations = Representations;
            this.RepresentedMaterial = RepresentedMaterial;
            this.type = 2022407955;
        }
    }
    IFC42.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;
    class IfcMaterialLayerSetUsage extends IfcMaterialUsageDefinition {
        constructor(ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine, ReferenceExtent){
            super();
            this.ForLayerSet = ForLayerSet;
            this.LayerSetDirection = LayerSetDirection;
            this.DirectionSense = DirectionSense;
            this.OffsetFromReferenceLine = OffsetFromReferenceLine;
            this.ReferenceExtent = ReferenceExtent;
            this.type = 1303795690;
        }
    }
    IFC42.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;
    class IfcMaterialProfileSetUsage extends IfcMaterialUsageDefinition {
        constructor(ForProfileSet, CardinalPoint, ReferenceExtent){
            super();
            this.ForProfileSet = ForProfileSet;
            this.CardinalPoint = CardinalPoint;
            this.ReferenceExtent = ReferenceExtent;
            this.type = 3079605661;
        }
    }
    IFC42.IfcMaterialProfileSetUsage = IfcMaterialProfileSetUsage;
    class IfcMaterialProfileSetUsageTapering extends IfcMaterialProfileSetUsage {
        constructor(ForProfileSet, CardinalPoint, ReferenceExtent, ForProfileEndSet, CardinalEndPoint){
            super(ForProfileSet, CardinalPoint, ReferenceExtent);
            this.ForProfileSet = ForProfileSet;
            this.CardinalPoint = CardinalPoint;
            this.ReferenceExtent = ReferenceExtent;
            this.ForProfileEndSet = ForProfileEndSet;
            this.CardinalEndPoint = CardinalEndPoint;
            this.type = 3404854881;
        }
    }
    IFC42.IfcMaterialProfileSetUsageTapering = IfcMaterialProfileSetUsageTapering;
    class IfcMaterialProperties extends IfcExtendedProperties {
        constructor(Name, Description, Properties2, Material){
            super(Name, Description, Properties2);
            this.Name = Name;
            this.Description = Description;
            this.Properties = Properties2;
            this.Material = Material;
            this.type = 3265635763;
        }
    }
    IFC42.IfcMaterialProperties = IfcMaterialProperties;
    class IfcMaterialRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingMaterial, RelatedMaterials, Expression){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingMaterial = RelatingMaterial;
            this.RelatedMaterials = RelatedMaterials;
            this.Expression = Expression;
            this.type = 853536259;
        }
    }
    IFC42.IfcMaterialRelationship = IfcMaterialRelationship;
    class IfcMirroredProfileDef extends IfcDerivedProfileDef {
        constructor(ProfileType, ProfileName, ParentProfile, Label){
            super(ProfileType, ProfileName, ParentProfile, new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), Label);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.ParentProfile = ParentProfile;
            this.Label = Label;
            this.type = 2998442950;
        }
    }
    IFC42.IfcMirroredProfileDef = IfcMirroredProfileDef;
    class IfcObjectDefinition extends IfcRoot {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 219451334;
        }
    }
    IFC42.IfcObjectDefinition = IfcObjectDefinition;
    class IfcOpenShell extends IfcConnectedFaceSet {
        constructor(CfsFaces){
            super(CfsFaces);
            this.CfsFaces = CfsFaces;
            this.type = 2665983363;
        }
    }
    IFC42.IfcOpenShell = IfcOpenShell;
    class IfcOrganizationRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingOrganization, RelatedOrganizations){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingOrganization = RelatingOrganization;
            this.RelatedOrganizations = RelatedOrganizations;
            this.type = 1411181986;
        }
    }
    IFC42.IfcOrganizationRelationship = IfcOrganizationRelationship;
    class IfcOrientedEdge extends IfcEdge {
        constructor(EdgeElement, Orientation){
            super(new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), new $3b8da494b8e92f36$export$94890c79f4cae6d6(0));
            this.EdgeElement = EdgeElement;
            this.Orientation = Orientation;
            this.type = 1029017970;
        }
    }
    IFC42.IfcOrientedEdge = IfcOrientedEdge;
    class IfcParameterizedProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, Position){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.type = 2529465313;
        }
    }
    IFC42.IfcParameterizedProfileDef = IfcParameterizedProfileDef;
    class IfcPath extends IfcTopologicalRepresentationItem {
        constructor(EdgeList){
            super();
            this.EdgeList = EdgeList;
            this.type = 2519244187;
        }
    }
    IFC42.IfcPath = IfcPath;
    class IfcPhysicalComplexQuantity extends IfcPhysicalQuantity {
        constructor(Name, Description, HasQuantities, Discrimination, Quality, Usage){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.HasQuantities = HasQuantities;
            this.Discrimination = Discrimination;
            this.Quality = Quality;
            this.Usage = Usage;
            this.type = 3021840470;
        }
    }
    IFC42.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;
    class IfcPixelTexture extends IfcSurfaceTexture {
        constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, Width, Height, ColourComponents, Pixel){
            super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.Mode = Mode;
            this.TextureTransform = TextureTransform;
            this.Parameter = Parameter;
            this.Width = Width;
            this.Height = Height;
            this.ColourComponents = ColourComponents;
            this.Pixel = Pixel;
            this.type = 597895409;
        }
    }
    IFC42.IfcPixelTexture = IfcPixelTexture;
    class IfcPlacement extends IfcGeometricRepresentationItem {
        constructor(Location){
            super();
            this.Location = Location;
            this.type = 2004835150;
        }
    }
    IFC42.IfcPlacement = IfcPlacement;
    class IfcPlanarExtent extends IfcGeometricRepresentationItem {
        constructor(SizeInX, SizeInY){
            super();
            this.SizeInX = SizeInX;
            this.SizeInY = SizeInY;
            this.type = 1663979128;
        }
    }
    IFC42.IfcPlanarExtent = IfcPlanarExtent;
    class IfcPoint extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 2067069095;
        }
    }
    IFC42.IfcPoint = IfcPoint;
    class IfcPointOnCurve extends IfcPoint {
        constructor(BasisCurve, PointParameter){
            super();
            this.BasisCurve = BasisCurve;
            this.PointParameter = PointParameter;
            this.type = 4022376103;
        }
    }
    IFC42.IfcPointOnCurve = IfcPointOnCurve;
    class IfcPointOnSurface extends IfcPoint {
        constructor(BasisSurface, PointParameterU, PointParameterV){
            super();
            this.BasisSurface = BasisSurface;
            this.PointParameterU = PointParameterU;
            this.PointParameterV = PointParameterV;
            this.type = 1423911732;
        }
    }
    IFC42.IfcPointOnSurface = IfcPointOnSurface;
    class IfcPolyLoop extends IfcLoop {
        constructor(Polygon){
            super();
            this.Polygon = Polygon;
            this.type = 2924175390;
        }
    }
    IFC42.IfcPolyLoop = IfcPolyLoop;
    class IfcPolygonalBoundedHalfSpace extends IfcHalfSpaceSolid {
        constructor(BaseSurface, AgreementFlag, Position, PolygonalBoundary){
            super(BaseSurface, AgreementFlag);
            this.BaseSurface = BaseSurface;
            this.AgreementFlag = AgreementFlag;
            this.Position = Position;
            this.PolygonalBoundary = PolygonalBoundary;
            this.type = 2775532180;
        }
    }
    IFC42.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;
    class IfcPreDefinedItem extends IfcPresentationItem {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 3727388367;
        }
    }
    IFC42.IfcPreDefinedItem = IfcPreDefinedItem;
    class IfcPreDefinedProperties extends IfcPropertyAbstraction {
        constructor(){
            super();
            this.type = 3778827333;
        }
    }
    IFC42.IfcPreDefinedProperties = IfcPreDefinedProperties;
    class IfcPreDefinedTextFont extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 1775413392;
        }
    }
    IFC42.IfcPreDefinedTextFont = IfcPreDefinedTextFont;
    class IfcProductDefinitionShape extends IfcProductRepresentation {
        constructor(Name, Description, Representations){
            super(Name, Description, Representations);
            this.Name = Name;
            this.Description = Description;
            this.Representations = Representations;
            this.type = 673634403;
        }
    }
    IFC42.IfcProductDefinitionShape = IfcProductDefinitionShape;
    class IfcProfileProperties extends IfcExtendedProperties {
        constructor(Name, Description, Properties2, ProfileDefinition){
            super(Name, Description, Properties2);
            this.Name = Name;
            this.Description = Description;
            this.Properties = Properties2;
            this.ProfileDefinition = ProfileDefinition;
            this.type = 2802850158;
        }
    }
    IFC42.IfcProfileProperties = IfcProfileProperties;
    class IfcProperty extends IfcPropertyAbstraction {
        constructor(Name, Description){
            super();
            this.Name = Name;
            this.Description = Description;
            this.type = 2598011224;
        }
    }
    IFC42.IfcProperty = IfcProperty;
    class IfcPropertyDefinition extends IfcRoot {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 1680319473;
        }
    }
    IFC42.IfcPropertyDefinition = IfcPropertyDefinition;
    class IfcPropertyDependencyRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, DependingProperty, DependantProperty, Expression){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.DependingProperty = DependingProperty;
            this.DependantProperty = DependantProperty;
            this.Expression = Expression;
            this.type = 148025276;
        }
    }
    IFC42.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;
    class IfcPropertySetDefinition extends IfcPropertyDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 3357820518;
        }
    }
    IFC42.IfcPropertySetDefinition = IfcPropertySetDefinition;
    class IfcPropertyTemplateDefinition extends IfcPropertyDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 1482703590;
        }
    }
    IFC42.IfcPropertyTemplateDefinition = IfcPropertyTemplateDefinition;
    class IfcQuantitySet extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 2090586900;
        }
    }
    IFC42.IfcQuantitySet = IfcQuantitySet;
    class IfcRectangleProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, XDim, YDim){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.XDim = XDim;
            this.YDim = YDim;
            this.type = 3615266464;
        }
    }
    IFC42.IfcRectangleProfileDef = IfcRectangleProfileDef;
    class IfcRegularTimeSeries extends IfcTimeSeries {
        constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values){
            super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
            this.Name = Name;
            this.Description = Description;
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.TimeSeriesDataType = TimeSeriesDataType;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.Unit = Unit;
            this.TimeStep = TimeStep;
            this.Values = Values;
            this.type = 3413951693;
        }
    }
    IFC42.IfcRegularTimeSeries = IfcRegularTimeSeries;
    class IfcReinforcementBarProperties extends IfcPreDefinedProperties {
        constructor(TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount){
            super();
            this.TotalCrossSectionArea = TotalCrossSectionArea;
            this.SteelGrade = SteelGrade;
            this.BarSurface = BarSurface;
            this.EffectiveDepth = EffectiveDepth;
            this.NominalBarDiameter = NominalBarDiameter;
            this.BarCount = BarCount;
            this.type = 1580146022;
        }
    }
    IFC42.IfcReinforcementBarProperties = IfcReinforcementBarProperties;
    class IfcRelationship extends IfcRoot {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 478536968;
        }
    }
    IFC42.IfcRelationship = IfcRelationship;
    class IfcResourceApprovalRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatedResourceObjects, RelatingApproval){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatedResourceObjects = RelatedResourceObjects;
            this.RelatingApproval = RelatingApproval;
            this.type = 2943643501;
        }
    }
    IFC42.IfcResourceApprovalRelationship = IfcResourceApprovalRelationship;
    class IfcResourceConstraintRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingConstraint, RelatedResourceObjects){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingConstraint = RelatingConstraint;
            this.RelatedResourceObjects = RelatedResourceObjects;
            this.type = 1608871552;
        }
    }
    IFC42.IfcResourceConstraintRelationship = IfcResourceConstraintRelationship;
    class IfcResourceTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, ScheduleWork, ScheduleUsage, ScheduleStart, ScheduleFinish, ScheduleContour, LevelingDelay, IsOverAllocated, StatusTime, ActualWork, ActualUsage, ActualStart, ActualFinish, RemainingWork, RemainingUsage, Completion){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.ScheduleWork = ScheduleWork;
            this.ScheduleUsage = ScheduleUsage;
            this.ScheduleStart = ScheduleStart;
            this.ScheduleFinish = ScheduleFinish;
            this.ScheduleContour = ScheduleContour;
            this.LevelingDelay = LevelingDelay;
            this.IsOverAllocated = IsOverAllocated;
            this.StatusTime = StatusTime;
            this.ActualWork = ActualWork;
            this.ActualUsage = ActualUsage;
            this.ActualStart = ActualStart;
            this.ActualFinish = ActualFinish;
            this.RemainingWork = RemainingWork;
            this.RemainingUsage = RemainingUsage;
            this.Completion = Completion;
            this.type = 1042787934;
        }
    }
    IFC42.IfcResourceTime = IfcResourceTime;
    class IfcRoundedRectangleProfileDef extends IfcRectangleProfileDef {
        constructor(ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius){
            super(ProfileType, ProfileName, Position, XDim, YDim);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.XDim = XDim;
            this.YDim = YDim;
            this.RoundingRadius = RoundingRadius;
            this.type = 2778083089;
        }
    }
    IFC42.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;
    class IfcSectionProperties extends IfcPreDefinedProperties {
        constructor(SectionType, StartProfile, EndProfile){
            super();
            this.SectionType = SectionType;
            this.StartProfile = StartProfile;
            this.EndProfile = EndProfile;
            this.type = 2042790032;
        }
    }
    IFC42.IfcSectionProperties = IfcSectionProperties;
    class IfcSectionReinforcementProperties extends IfcPreDefinedProperties {
        constructor(LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions){
            super();
            this.LongitudinalStartPosition = LongitudinalStartPosition;
            this.LongitudinalEndPosition = LongitudinalEndPosition;
            this.TransversePosition = TransversePosition;
            this.ReinforcementRole = ReinforcementRole;
            this.SectionDefinition = SectionDefinition;
            this.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
            this.type = 4165799628;
        }
    }
    IFC42.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;
    class IfcSectionedSpine extends IfcGeometricRepresentationItem {
        constructor(SpineCurve, CrossSections, CrossSectionPositions){
            super();
            this.SpineCurve = SpineCurve;
            this.CrossSections = CrossSections;
            this.CrossSectionPositions = CrossSectionPositions;
            this.type = 1509187699;
        }
    }
    IFC42.IfcSectionedSpine = IfcSectionedSpine;
    class IfcShellBasedSurfaceModel extends IfcGeometricRepresentationItem {
        constructor(SbsmBoundary){
            super();
            this.SbsmBoundary = SbsmBoundary;
            this.type = 4124623270;
        }
    }
    IFC42.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;
    class IfcSimpleProperty extends IfcProperty {
        constructor(Name, Description){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.type = 3692461612;
        }
    }
    IFC42.IfcSimpleProperty = IfcSimpleProperty;
    class IfcSlippageConnectionCondition extends IfcStructuralConnectionCondition {
        constructor(Name, SlippageX, SlippageY, SlippageZ){
            super(Name);
            this.Name = Name;
            this.SlippageX = SlippageX;
            this.SlippageY = SlippageY;
            this.SlippageZ = SlippageZ;
            this.type = 2609359061;
        }
    }
    IFC42.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;
    class IfcSolidModel extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 723233188;
        }
    }
    IFC42.IfcSolidModel = IfcSolidModel;
    class IfcStructuralLoadLinearForce extends IfcStructuralLoadStatic {
        constructor(Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ){
            super(Name);
            this.Name = Name;
            this.LinearForceX = LinearForceX;
            this.LinearForceY = LinearForceY;
            this.LinearForceZ = LinearForceZ;
            this.LinearMomentX = LinearMomentX;
            this.LinearMomentY = LinearMomentY;
            this.LinearMomentZ = LinearMomentZ;
            this.type = 1595516126;
        }
    }
    IFC42.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;
    class IfcStructuralLoadPlanarForce extends IfcStructuralLoadStatic {
        constructor(Name, PlanarForceX, PlanarForceY, PlanarForceZ){
            super(Name);
            this.Name = Name;
            this.PlanarForceX = PlanarForceX;
            this.PlanarForceY = PlanarForceY;
            this.PlanarForceZ = PlanarForceZ;
            this.type = 2668620305;
        }
    }
    IFC42.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;
    class IfcStructuralLoadSingleDisplacement extends IfcStructuralLoadStatic {
        constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ){
            super(Name);
            this.Name = Name;
            this.DisplacementX = DisplacementX;
            this.DisplacementY = DisplacementY;
            this.DisplacementZ = DisplacementZ;
            this.RotationalDisplacementRX = RotationalDisplacementRX;
            this.RotationalDisplacementRY = RotationalDisplacementRY;
            this.RotationalDisplacementRZ = RotationalDisplacementRZ;
            this.type = 2473145415;
        }
    }
    IFC42.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;
    class IfcStructuralLoadSingleDisplacementDistortion extends IfcStructuralLoadSingleDisplacement {
        constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion){
            super(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
            this.Name = Name;
            this.DisplacementX = DisplacementX;
            this.DisplacementY = DisplacementY;
            this.DisplacementZ = DisplacementZ;
            this.RotationalDisplacementRX = RotationalDisplacementRX;
            this.RotationalDisplacementRY = RotationalDisplacementRY;
            this.RotationalDisplacementRZ = RotationalDisplacementRZ;
            this.Distortion = Distortion;
            this.type = 1973038258;
        }
    }
    IFC42.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;
    class IfcStructuralLoadSingleForce extends IfcStructuralLoadStatic {
        constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ){
            super(Name);
            this.Name = Name;
            this.ForceX = ForceX;
            this.ForceY = ForceY;
            this.ForceZ = ForceZ;
            this.MomentX = MomentX;
            this.MomentY = MomentY;
            this.MomentZ = MomentZ;
            this.type = 1597423693;
        }
    }
    IFC42.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;
    class IfcStructuralLoadSingleForceWarping extends IfcStructuralLoadSingleForce {
        constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment){
            super(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
            this.Name = Name;
            this.ForceX = ForceX;
            this.ForceY = ForceY;
            this.ForceZ = ForceZ;
            this.MomentX = MomentX;
            this.MomentY = MomentY;
            this.MomentZ = MomentZ;
            this.WarpingMoment = WarpingMoment;
            this.type = 1190533807;
        }
    }
    IFC42.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;
    class IfcSubedge extends IfcEdge {
        constructor(EdgeStart, EdgeEnd, ParentEdge){
            super(EdgeStart, EdgeEnd);
            this.EdgeStart = EdgeStart;
            this.EdgeEnd = EdgeEnd;
            this.ParentEdge = ParentEdge;
            this.type = 2233826070;
        }
    }
    IFC42.IfcSubedge = IfcSubedge;
    class IfcSurface extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 2513912981;
        }
    }
    IFC42.IfcSurface = IfcSurface;
    class IfcSurfaceStyleRendering extends IfcSurfaceStyleShading {
        constructor(SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod){
            super(SurfaceColour, Transparency);
            this.SurfaceColour = SurfaceColour;
            this.Transparency = Transparency;
            this.DiffuseColour = DiffuseColour;
            this.TransmissionColour = TransmissionColour;
            this.DiffuseTransmissionColour = DiffuseTransmissionColour;
            this.ReflectionColour = ReflectionColour;
            this.SpecularColour = SpecularColour;
            this.SpecularHighlight = SpecularHighlight;
            this.ReflectanceMethod = ReflectanceMethod;
            this.type = 1878645084;
        }
    }
    IFC42.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;
    class IfcSweptAreaSolid extends IfcSolidModel {
        constructor(SweptArea, Position){
            super();
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.type = 2247615214;
        }
    }
    IFC42.IfcSweptAreaSolid = IfcSweptAreaSolid;
    class IfcSweptDiskSolid extends IfcSolidModel {
        constructor(Directrix, Radius, InnerRadius, StartParam, EndParam){
            super();
            this.Directrix = Directrix;
            this.Radius = Radius;
            this.InnerRadius = InnerRadius;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.type = 1260650574;
        }
    }
    IFC42.IfcSweptDiskSolid = IfcSweptDiskSolid;
    class IfcSweptDiskSolidPolygonal extends IfcSweptDiskSolid {
        constructor(Directrix, Radius, InnerRadius, StartParam, EndParam, FilletRadius){
            super(Directrix, Radius, InnerRadius, StartParam, EndParam);
            this.Directrix = Directrix;
            this.Radius = Radius;
            this.InnerRadius = InnerRadius;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.FilletRadius = FilletRadius;
            this.type = 1096409881;
        }
    }
    IFC42.IfcSweptDiskSolidPolygonal = IfcSweptDiskSolidPolygonal;
    class IfcSweptSurface extends IfcSurface {
        constructor(SweptCurve, Position){
            super();
            this.SweptCurve = SweptCurve;
            this.Position = Position;
            this.type = 230924584;
        }
    }
    IFC42.IfcSweptSurface = IfcSweptSurface;
    class IfcTShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.FlangeWidth = FlangeWidth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.FlangeEdgeRadius = FlangeEdgeRadius;
            this.WebEdgeRadius = WebEdgeRadius;
            this.WebSlope = WebSlope;
            this.FlangeSlope = FlangeSlope;
            this.type = 3071757647;
        }
    }
    IFC42.IfcTShapeProfileDef = IfcTShapeProfileDef;
    class IfcTessellatedItem extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 901063453;
        }
    }
    IFC42.IfcTessellatedItem = IfcTessellatedItem;
    class IfcTextLiteral extends IfcGeometricRepresentationItem {
        constructor(Literal, Placement, Path){
            super();
            this.Literal = Literal;
            this.Placement = Placement;
            this.Path = Path;
            this.type = 4282788508;
        }
    }
    IFC42.IfcTextLiteral = IfcTextLiteral;
    class IfcTextLiteralWithExtent extends IfcTextLiteral {
        constructor(Literal, Placement, Path, Extent, BoxAlignment){
            super(Literal, Placement, Path);
            this.Literal = Literal;
            this.Placement = Placement;
            this.Path = Path;
            this.Extent = Extent;
            this.BoxAlignment = BoxAlignment;
            this.type = 3124975700;
        }
    }
    IFC42.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;
    class IfcTextStyleFontModel extends IfcPreDefinedTextFont {
        constructor(Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize){
            super(Name);
            this.Name = Name;
            this.FontFamily = FontFamily;
            this.FontStyle = FontStyle;
            this.FontVariant = FontVariant;
            this.FontWeight = FontWeight;
            this.FontSize = FontSize;
            this.type = 1983826977;
        }
    }
    IFC42.IfcTextStyleFontModel = IfcTextStyleFontModel;
    class IfcTrapeziumProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.BottomXDim = BottomXDim;
            this.TopXDim = TopXDim;
            this.YDim = YDim;
            this.TopXOffset = TopXOffset;
            this.type = 2715220739;
        }
    }
    IFC42.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;
    class IfcTypeObject extends IfcObjectDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.type = 1628702193;
        }
    }
    IFC42.IfcTypeObject = IfcTypeObject;
    class IfcTypeProcess extends IfcTypeObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ProcessType = ProcessType;
            this.type = 3736923433;
        }
    }
    IFC42.IfcTypeProcess = IfcTypeProcess;
    class IfcTypeProduct extends IfcTypeObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.type = 2347495698;
        }
    }
    IFC42.IfcTypeProduct = IfcTypeProduct;
    class IfcTypeResource extends IfcTypeObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.type = 3698973494;
        }
    }
    IFC42.IfcTypeResource = IfcTypeResource;
    class IfcUShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.FlangeWidth = FlangeWidth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.EdgeRadius = EdgeRadius;
            this.FlangeSlope = FlangeSlope;
            this.type = 427810014;
        }
    }
    IFC42.IfcUShapeProfileDef = IfcUShapeProfileDef;
    class IfcVector extends IfcGeometricRepresentationItem {
        constructor(Orientation, Magnitude){
            super();
            this.Orientation = Orientation;
            this.Magnitude = Magnitude;
            this.type = 1417489154;
        }
    }
    IFC42.IfcVector = IfcVector;
    class IfcVertexLoop extends IfcLoop {
        constructor(LoopVertex){
            super();
            this.LoopVertex = LoopVertex;
            this.type = 2759199220;
        }
    }
    IFC42.IfcVertexLoop = IfcVertexLoop;
    class IfcWindowStyle extends IfcTypeProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ConstructionType, OperationType, ParameterTakesPrecedence, Sizeable){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ConstructionType = ConstructionType;
            this.OperationType = OperationType;
            this.ParameterTakesPrecedence = ParameterTakesPrecedence;
            this.Sizeable = Sizeable;
            this.type = 1299126871;
        }
    }
    IFC42.IfcWindowStyle = IfcWindowStyle;
    class IfcZShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.FlangeWidth = FlangeWidth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.EdgeRadius = EdgeRadius;
            this.type = 2543172580;
        }
    }
    IFC42.IfcZShapeProfileDef = IfcZShapeProfileDef;
    class IfcAdvancedFace extends IfcFaceSurface {
        constructor(Bounds, FaceSurface, SameSense){
            super(Bounds, FaceSurface, SameSense);
            this.Bounds = Bounds;
            this.FaceSurface = FaceSurface;
            this.SameSense = SameSense;
            this.type = 3406155212;
        }
    }
    IFC42.IfcAdvancedFace = IfcAdvancedFace;
    class IfcAnnotationFillArea extends IfcGeometricRepresentationItem {
        constructor(OuterBoundary, InnerBoundaries){
            super();
            this.OuterBoundary = OuterBoundary;
            this.InnerBoundaries = InnerBoundaries;
            this.type = 669184980;
        }
    }
    IFC42.IfcAnnotationFillArea = IfcAnnotationFillArea;
    class IfcAsymmetricIShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, BottomFlangeWidth, OverallDepth, WebThickness, BottomFlangeThickness, BottomFlangeFilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, BottomFlangeEdgeRadius, BottomFlangeSlope, TopFlangeEdgeRadius, TopFlangeSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.BottomFlangeWidth = BottomFlangeWidth;
            this.OverallDepth = OverallDepth;
            this.WebThickness = WebThickness;
            this.BottomFlangeThickness = BottomFlangeThickness;
            this.BottomFlangeFilletRadius = BottomFlangeFilletRadius;
            this.TopFlangeWidth = TopFlangeWidth;
            this.TopFlangeThickness = TopFlangeThickness;
            this.TopFlangeFilletRadius = TopFlangeFilletRadius;
            this.BottomFlangeEdgeRadius = BottomFlangeEdgeRadius;
            this.BottomFlangeSlope = BottomFlangeSlope;
            this.TopFlangeEdgeRadius = TopFlangeEdgeRadius;
            this.TopFlangeSlope = TopFlangeSlope;
            this.type = 3207858831;
        }
    }
    IFC42.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;
    class IfcAxis1Placement extends IfcPlacement {
        constructor(Location, Axis){
            super(Location);
            this.Location = Location;
            this.Axis = Axis;
            this.type = 4261334040;
        }
    }
    IFC42.IfcAxis1Placement = IfcAxis1Placement;
    class IfcAxis2Placement2D extends IfcPlacement {
        constructor(Location, RefDirection){
            super(Location);
            this.Location = Location;
            this.RefDirection = RefDirection;
            this.type = 3125803723;
        }
    }
    IFC42.IfcAxis2Placement2D = IfcAxis2Placement2D;
    class IfcAxis2Placement3D extends IfcPlacement {
        constructor(Location, Axis, RefDirection){
            super(Location);
            this.Location = Location;
            this.Axis = Axis;
            this.RefDirection = RefDirection;
            this.type = 2740243338;
        }
    }
    IFC42.IfcAxis2Placement3D = IfcAxis2Placement3D;
    class IfcBooleanResult extends IfcGeometricRepresentationItem {
        constructor(Operator, FirstOperand, SecondOperand){
            super();
            this.Operator = Operator;
            this.FirstOperand = FirstOperand;
            this.SecondOperand = SecondOperand;
            this.type = 2736907675;
        }
    }
    IFC42.IfcBooleanResult = IfcBooleanResult;
    class IfcBoundedSurface extends IfcSurface {
        constructor(){
            super();
            this.type = 4182860854;
        }
    }
    IFC42.IfcBoundedSurface = IfcBoundedSurface;
    class IfcBoundingBox extends IfcGeometricRepresentationItem {
        constructor(Corner, XDim, YDim, ZDim){
            super();
            this.Corner = Corner;
            this.XDim = XDim;
            this.YDim = YDim;
            this.ZDim = ZDim;
            this.type = 2581212453;
        }
    }
    IFC42.IfcBoundingBox = IfcBoundingBox;
    class IfcBoxedHalfSpace extends IfcHalfSpaceSolid {
        constructor(BaseSurface, AgreementFlag, Enclosure){
            super(BaseSurface, AgreementFlag);
            this.BaseSurface = BaseSurface;
            this.AgreementFlag = AgreementFlag;
            this.Enclosure = Enclosure;
            this.type = 2713105998;
        }
    }
    IFC42.IfcBoxedHalfSpace = IfcBoxedHalfSpace;
    class IfcCShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.Width = Width;
            this.WallThickness = WallThickness;
            this.Girth = Girth;
            this.InternalFilletRadius = InternalFilletRadius;
            this.type = 2898889636;
        }
    }
    IFC42.IfcCShapeProfileDef = IfcCShapeProfileDef;
    class IfcCartesianPoint extends IfcPoint {
        constructor(Coordinates){
            super();
            this.Coordinates = Coordinates;
            this.type = 1123145078;
        }
    }
    IFC42.IfcCartesianPoint = IfcCartesianPoint;
    class IfcCartesianPointList extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 574549367;
        }
    }
    IFC42.IfcCartesianPointList = IfcCartesianPointList;
    class IfcCartesianPointList2D extends IfcCartesianPointList {
        constructor(CoordList){
            super();
            this.CoordList = CoordList;
            this.type = 1675464909;
        }
    }
    IFC42.IfcCartesianPointList2D = IfcCartesianPointList2D;
    class IfcCartesianPointList3D extends IfcCartesianPointList {
        constructor(CoordList){
            super();
            this.CoordList = CoordList;
            this.type = 2059837836;
        }
    }
    IFC42.IfcCartesianPointList3D = IfcCartesianPointList3D;
    class IfcCartesianTransformationOperator extends IfcGeometricRepresentationItem {
        constructor(Axis1, Axis2, LocalOrigin, Scale){
            super();
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.type = 59481748;
        }
    }
    IFC42.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;
    class IfcCartesianTransformationOperator2D extends IfcCartesianTransformationOperator {
        constructor(Axis1, Axis2, LocalOrigin, Scale){
            super(Axis1, Axis2, LocalOrigin, Scale);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.type = 3749851601;
        }
    }
    IFC42.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;
    class IfcCartesianTransformationOperator2DnonUniform extends IfcCartesianTransformationOperator2D {
        constructor(Axis1, Axis2, LocalOrigin, Scale, Scale2){
            super(Axis1, Axis2, LocalOrigin, Scale);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.Scale2 = Scale2;
            this.type = 3486308946;
        }
    }
    IFC42.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;
    class IfcCartesianTransformationOperator3D extends IfcCartesianTransformationOperator {
        constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3){
            super(Axis1, Axis2, LocalOrigin, Scale);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.Axis3 = Axis3;
            this.type = 3331915920;
        }
    }
    IFC42.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;
    class IfcCartesianTransformationOperator3DnonUniform extends IfcCartesianTransformationOperator3D {
        constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3){
            super(Axis1, Axis2, LocalOrigin, Scale, Axis3);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.Axis3 = Axis3;
            this.Scale2 = Scale2;
            this.Scale3 = Scale3;
            this.type = 1416205885;
        }
    }
    IFC42.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;
    class IfcCircleProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Radius){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Radius = Radius;
            this.type = 1383045692;
        }
    }
    IFC42.IfcCircleProfileDef = IfcCircleProfileDef;
    class IfcClosedShell extends IfcConnectedFaceSet {
        constructor(CfsFaces){
            super(CfsFaces);
            this.CfsFaces = CfsFaces;
            this.type = 2205249479;
        }
    }
    IFC42.IfcClosedShell = IfcClosedShell;
    class IfcColourRgb extends IfcColourSpecification {
        constructor(Name, Red, Green, Blue){
            super(Name);
            this.Name = Name;
            this.Red = Red;
            this.Green = Green;
            this.Blue = Blue;
            this.type = 776857604;
        }
    }
    IFC42.IfcColourRgb = IfcColourRgb;
    class IfcComplexProperty extends IfcProperty {
        constructor(Name, Description, UsageName, HasProperties){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.UsageName = UsageName;
            this.HasProperties = HasProperties;
            this.type = 2542286263;
        }
    }
    IFC42.IfcComplexProperty = IfcComplexProperty;
    class IfcCompositeCurveSegment extends IfcGeometricRepresentationItem {
        constructor(Transition, SameSense, ParentCurve){
            super();
            this.Transition = Transition;
            this.SameSense = SameSense;
            this.ParentCurve = ParentCurve;
            this.type = 2485617015;
        }
    }
    IFC42.IfcCompositeCurveSegment = IfcCompositeCurveSegment;
    class IfcConstructionResourceType extends IfcTypeResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.type = 2574617495;
        }
    }
    IFC42.IfcConstructionResourceType = IfcConstructionResourceType;
    class IfcContext extends IfcObjectDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.Phase = Phase;
            this.RepresentationContexts = RepresentationContexts;
            this.UnitsInContext = UnitsInContext;
            this.type = 3419103109;
        }
    }
    IFC42.IfcContext = IfcContext;
    class IfcCrewResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 1815067380;
        }
    }
    IFC42.IfcCrewResourceType = IfcCrewResourceType;
    class IfcCsgPrimitive3D extends IfcGeometricRepresentationItem {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2506170314;
        }
    }
    IFC42.IfcCsgPrimitive3D = IfcCsgPrimitive3D;
    class IfcCsgSolid extends IfcSolidModel {
        constructor(TreeRootExpression){
            super();
            this.TreeRootExpression = TreeRootExpression;
            this.type = 2147822146;
        }
    }
    IFC42.IfcCsgSolid = IfcCsgSolid;
    class IfcCurve extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 2601014836;
        }
    }
    IFC42.IfcCurve = IfcCurve;
    class IfcCurveBoundedPlane extends IfcBoundedSurface {
        constructor(BasisSurface, OuterBoundary, InnerBoundaries){
            super();
            this.BasisSurface = BasisSurface;
            this.OuterBoundary = OuterBoundary;
            this.InnerBoundaries = InnerBoundaries;
            this.type = 2827736869;
        }
    }
    IFC42.IfcCurveBoundedPlane = IfcCurveBoundedPlane;
    class IfcCurveBoundedSurface extends IfcBoundedSurface {
        constructor(BasisSurface, Boundaries, ImplicitOuter){
            super();
            this.BasisSurface = BasisSurface;
            this.Boundaries = Boundaries;
            this.ImplicitOuter = ImplicitOuter;
            this.type = 2629017746;
        }
    }
    IFC42.IfcCurveBoundedSurface = IfcCurveBoundedSurface;
    class IfcDirection extends IfcGeometricRepresentationItem {
        constructor(DirectionRatios){
            super();
            this.DirectionRatios = DirectionRatios;
            this.type = 32440307;
        }
    }
    IFC42.IfcDirection = IfcDirection;
    class IfcDoorStyle extends IfcTypeProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, OperationType, ConstructionType, ParameterTakesPrecedence, Sizeable){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.OperationType = OperationType;
            this.ConstructionType = ConstructionType;
            this.ParameterTakesPrecedence = ParameterTakesPrecedence;
            this.Sizeable = Sizeable;
            this.type = 526551008;
        }
    }
    IFC42.IfcDoorStyle = IfcDoorStyle;
    class IfcEdgeLoop extends IfcLoop {
        constructor(EdgeList){
            super();
            this.EdgeList = EdgeList;
            this.type = 1472233963;
        }
    }
    IFC42.IfcEdgeLoop = IfcEdgeLoop;
    class IfcElementQuantity extends IfcQuantitySet {
        constructor(GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.MethodOfMeasurement = MethodOfMeasurement;
            this.Quantities = Quantities;
            this.type = 1883228015;
        }
    }
    IFC42.IfcElementQuantity = IfcElementQuantity;
    class IfcElementType extends IfcTypeProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 339256511;
        }
    }
    IFC42.IfcElementType = IfcElementType;
    class IfcElementarySurface extends IfcSurface {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2777663545;
        }
    }
    IFC42.IfcElementarySurface = IfcElementarySurface;
    class IfcEllipseProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.SemiAxis1 = SemiAxis1;
            this.SemiAxis2 = SemiAxis2;
            this.type = 2835456948;
        }
    }
    IFC42.IfcEllipseProfileDef = IfcEllipseProfileDef;
    class IfcEventType extends IfcTypeProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, EventTriggerType, UserDefinedEventTriggerType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ProcessType = ProcessType;
            this.PredefinedType = PredefinedType;
            this.EventTriggerType = EventTriggerType;
            this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
            this.type = 4024345920;
        }
    }
    IFC42.IfcEventType = IfcEventType;
    class IfcExtrudedAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, ExtrudedDirection, Depth){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.ExtrudedDirection = ExtrudedDirection;
            this.Depth = Depth;
            this.type = 477187591;
        }
    }
    IFC42.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;
    class IfcExtrudedAreaSolidTapered extends IfcExtrudedAreaSolid {
        constructor(SweptArea, Position, ExtrudedDirection, Depth, EndSweptArea){
            super(SweptArea, Position, ExtrudedDirection, Depth);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.ExtrudedDirection = ExtrudedDirection;
            this.Depth = Depth;
            this.EndSweptArea = EndSweptArea;
            this.type = 2804161546;
        }
    }
    IFC42.IfcExtrudedAreaSolidTapered = IfcExtrudedAreaSolidTapered;
    class IfcFaceBasedSurfaceModel extends IfcGeometricRepresentationItem {
        constructor(FbsmFaces){
            super();
            this.FbsmFaces = FbsmFaces;
            this.type = 2047409740;
        }
    }
    IFC42.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;
    class IfcFillAreaStyleHatching extends IfcGeometricRepresentationItem {
        constructor(HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle){
            super();
            this.HatchLineAppearance = HatchLineAppearance;
            this.StartOfNextHatchLine = StartOfNextHatchLine;
            this.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
            this.PatternStart = PatternStart;
            this.HatchLineAngle = HatchLineAngle;
            this.type = 374418227;
        }
    }
    IFC42.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;
    class IfcFillAreaStyleTiles extends IfcGeometricRepresentationItem {
        constructor(TilingPattern, Tiles, TilingScale){
            super();
            this.TilingPattern = TilingPattern;
            this.Tiles = Tiles;
            this.TilingScale = TilingScale;
            this.type = 315944413;
        }
    }
    IFC42.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;
    class IfcFixedReferenceSweptAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, Directrix, StartParam, EndParam, FixedReference){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Directrix = Directrix;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.FixedReference = FixedReference;
            this.type = 2652556860;
        }
    }
    IFC42.IfcFixedReferenceSweptAreaSolid = IfcFixedReferenceSweptAreaSolid;
    class IfcFurnishingElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 4238390223;
        }
    }
    IFC42.IfcFurnishingElementType = IfcFurnishingElementType;
    class IfcFurnitureType extends IfcFurnishingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.AssemblyPlace = AssemblyPlace;
            this.PredefinedType = PredefinedType;
            this.type = 1268542332;
        }
    }
    IFC42.IfcFurnitureType = IfcFurnitureType;
    class IfcGeographicElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4095422895;
        }
    }
    IFC42.IfcGeographicElementType = IfcGeographicElementType;
    class IfcGeometricCurveSet extends IfcGeometricSet {
        constructor(Elements){
            super(Elements);
            this.Elements = Elements;
            this.type = 987898635;
        }
    }
    IFC42.IfcGeometricCurveSet = IfcGeometricCurveSet;
    class IfcIShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, FlangeSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.OverallWidth = OverallWidth;
            this.OverallDepth = OverallDepth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.FlangeEdgeRadius = FlangeEdgeRadius;
            this.FlangeSlope = FlangeSlope;
            this.type = 1484403080;
        }
    }
    IFC42.IfcIShapeProfileDef = IfcIShapeProfileDef;
    class IfcIndexedPolygonalFace extends IfcTessellatedItem {
        constructor(CoordIndex){
            super();
            this.CoordIndex = CoordIndex;
            this.type = 178912537;
        }
    }
    IFC42.IfcIndexedPolygonalFace = IfcIndexedPolygonalFace;
    class IfcIndexedPolygonalFaceWithVoids extends IfcIndexedPolygonalFace {
        constructor(CoordIndex, InnerCoordIndices){
            super(CoordIndex);
            this.CoordIndex = CoordIndex;
            this.InnerCoordIndices = InnerCoordIndices;
            this.type = 2294589976;
        }
    }
    IFC42.IfcIndexedPolygonalFaceWithVoids = IfcIndexedPolygonalFaceWithVoids;
    class IfcLShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.Width = Width;
            this.Thickness = Thickness;
            this.FilletRadius = FilletRadius;
            this.EdgeRadius = EdgeRadius;
            this.LegSlope = LegSlope;
            this.type = 572779678;
        }
    }
    IFC42.IfcLShapeProfileDef = IfcLShapeProfileDef;
    class IfcLaborResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 428585644;
        }
    }
    IFC42.IfcLaborResourceType = IfcLaborResourceType;
    class IfcLine extends IfcCurve {
        constructor(Pnt, Dir){
            super();
            this.Pnt = Pnt;
            this.Dir = Dir;
            this.type = 1281925730;
        }
    }
    IFC42.IfcLine = IfcLine;
    class IfcManifoldSolidBrep extends IfcSolidModel {
        constructor(Outer){
            super();
            this.Outer = Outer;
            this.type = 1425443689;
        }
    }
    IFC42.IfcManifoldSolidBrep = IfcManifoldSolidBrep;
    class IfcObject extends IfcObjectDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 3888040117;
        }
    }
    IFC42.IfcObject = IfcObject;
    class IfcOffsetCurve2D extends IfcCurve {
        constructor(BasisCurve, Distance, SelfIntersect){
            super();
            this.BasisCurve = BasisCurve;
            this.Distance = Distance;
            this.SelfIntersect = SelfIntersect;
            this.type = 3388369263;
        }
    }
    IFC42.IfcOffsetCurve2D = IfcOffsetCurve2D;
    class IfcOffsetCurve3D extends IfcCurve {
        constructor(BasisCurve, Distance, SelfIntersect, RefDirection){
            super();
            this.BasisCurve = BasisCurve;
            this.Distance = Distance;
            this.SelfIntersect = SelfIntersect;
            this.RefDirection = RefDirection;
            this.type = 3505215534;
        }
    }
    IFC42.IfcOffsetCurve3D = IfcOffsetCurve3D;
    class IfcPcurve extends IfcCurve {
        constructor(BasisSurface, ReferenceCurve){
            super();
            this.BasisSurface = BasisSurface;
            this.ReferenceCurve = ReferenceCurve;
            this.type = 1682466193;
        }
    }
    IFC42.IfcPcurve = IfcPcurve;
    class IfcPlanarBox extends IfcPlanarExtent {
        constructor(SizeInX, SizeInY, Placement){
            super(SizeInX, SizeInY);
            this.SizeInX = SizeInX;
            this.SizeInY = SizeInY;
            this.Placement = Placement;
            this.type = 603570806;
        }
    }
    IFC42.IfcPlanarBox = IfcPlanarBox;
    class IfcPlane extends IfcElementarySurface {
        constructor(Position){
            super(Position);
            this.Position = Position;
            this.type = 220341763;
        }
    }
    IFC42.IfcPlane = IfcPlane;
    class IfcPreDefinedColour extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 759155922;
        }
    }
    IFC42.IfcPreDefinedColour = IfcPreDefinedColour;
    class IfcPreDefinedCurveFont extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 2559016684;
        }
    }
    IFC42.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;
    class IfcPreDefinedPropertySet extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 3967405729;
        }
    }
    IFC42.IfcPreDefinedPropertySet = IfcPreDefinedPropertySet;
    class IfcProcedureType extends IfcTypeProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ProcessType = ProcessType;
            this.PredefinedType = PredefinedType;
            this.type = 569719735;
        }
    }
    IFC42.IfcProcedureType = IfcProcedureType;
    class IfcProcess extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.type = 2945172077;
        }
    }
    IFC42.IfcProcess = IfcProcess;
    class IfcProduct extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 4208778838;
        }
    }
    IFC42.IfcProduct = IfcProduct;
    class IfcProject extends IfcContext {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.Phase = Phase;
            this.RepresentationContexts = RepresentationContexts;
            this.UnitsInContext = UnitsInContext;
            this.type = 103090709;
        }
    }
    IFC42.IfcProject = IfcProject;
    class IfcProjectLibrary extends IfcContext {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.Phase = Phase;
            this.RepresentationContexts = RepresentationContexts;
            this.UnitsInContext = UnitsInContext;
            this.type = 653396225;
        }
    }
    IFC42.IfcProjectLibrary = IfcProjectLibrary;
    class IfcPropertyBoundedValue extends IfcSimpleProperty {
        constructor(Name, Description, UpperBoundValue, LowerBoundValue, Unit, SetPointValue){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.UpperBoundValue = UpperBoundValue;
            this.LowerBoundValue = LowerBoundValue;
            this.Unit = Unit;
            this.SetPointValue = SetPointValue;
            this.type = 871118103;
        }
    }
    IFC42.IfcPropertyBoundedValue = IfcPropertyBoundedValue;
    class IfcPropertyEnumeratedValue extends IfcSimpleProperty {
        constructor(Name, Description, EnumerationValues, EnumerationReference){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.EnumerationValues = EnumerationValues;
            this.EnumerationReference = EnumerationReference;
            this.type = 4166981789;
        }
    }
    IFC42.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;
    class IfcPropertyListValue extends IfcSimpleProperty {
        constructor(Name, Description, ListValues, Unit){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.ListValues = ListValues;
            this.Unit = Unit;
            this.type = 2752243245;
        }
    }
    IFC42.IfcPropertyListValue = IfcPropertyListValue;
    class IfcPropertyReferenceValue extends IfcSimpleProperty {
        constructor(Name, Description, UsageName, PropertyReference){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.UsageName = UsageName;
            this.PropertyReference = PropertyReference;
            this.type = 941946838;
        }
    }
    IFC42.IfcPropertyReferenceValue = IfcPropertyReferenceValue;
    class IfcPropertySet extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, HasProperties){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.HasProperties = HasProperties;
            this.type = 1451395588;
        }
    }
    IFC42.IfcPropertySet = IfcPropertySet;
    class IfcPropertySetTemplate extends IfcPropertyTemplateDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, TemplateType, ApplicableEntity, HasPropertyTemplates){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.TemplateType = TemplateType;
            this.ApplicableEntity = ApplicableEntity;
            this.HasPropertyTemplates = HasPropertyTemplates;
            this.type = 492091185;
        }
    }
    IFC42.IfcPropertySetTemplate = IfcPropertySetTemplate;
    class IfcPropertySingleValue extends IfcSimpleProperty {
        constructor(Name, Description, NominalValue, Unit){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.NominalValue = NominalValue;
            this.Unit = Unit;
            this.type = 3650150729;
        }
    }
    IFC42.IfcPropertySingleValue = IfcPropertySingleValue;
    class IfcPropertyTableValue extends IfcSimpleProperty {
        constructor(Name, Description, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit, CurveInterpolation){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.DefiningValues = DefiningValues;
            this.DefinedValues = DefinedValues;
            this.Expression = Expression;
            this.DefiningUnit = DefiningUnit;
            this.DefinedUnit = DefinedUnit;
            this.CurveInterpolation = CurveInterpolation;
            this.type = 110355661;
        }
    }
    IFC42.IfcPropertyTableValue = IfcPropertyTableValue;
    class IfcPropertyTemplate extends IfcPropertyTemplateDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 3521284610;
        }
    }
    IFC42.IfcPropertyTemplate = IfcPropertyTemplate;
    class IfcProxy extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, ProxyType, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.ProxyType = ProxyType;
            this.Tag = Tag;
            this.type = 3219374653;
        }
    }
    IFC42.IfcProxy = IfcProxy;
    class IfcRectangleHollowProfileDef extends IfcRectangleProfileDef {
        constructor(ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius){
            super(ProfileType, ProfileName, Position, XDim, YDim);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.XDim = XDim;
            this.YDim = YDim;
            this.WallThickness = WallThickness;
            this.InnerFilletRadius = InnerFilletRadius;
            this.OuterFilletRadius = OuterFilletRadius;
            this.type = 2770003689;
        }
    }
    IFC42.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;
    class IfcRectangularPyramid extends IfcCsgPrimitive3D {
        constructor(Position, XLength, YLength, Height){
            super(Position);
            this.Position = Position;
            this.XLength = XLength;
            this.YLength = YLength;
            this.Height = Height;
            this.type = 2798486643;
        }
    }
    IFC42.IfcRectangularPyramid = IfcRectangularPyramid;
    class IfcRectangularTrimmedSurface extends IfcBoundedSurface {
        constructor(BasisSurface, U1, V1, U2, V2, Usense, Vsense){
            super();
            this.BasisSurface = BasisSurface;
            this.U1 = U1;
            this.V1 = V1;
            this.U2 = U2;
            this.V2 = V2;
            this.Usense = Usense;
            this.Vsense = Vsense;
            this.type = 3454111270;
        }
    }
    IFC42.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;
    class IfcReinforcementDefinitionProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.DefinitionType = DefinitionType;
            this.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
            this.type = 3765753017;
        }
    }
    IFC42.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;
    class IfcRelAssigns extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.type = 3939117080;
        }
    }
    IFC42.IfcRelAssigns = IfcRelAssigns;
    class IfcRelAssignsToActor extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingActor = RelatingActor;
            this.ActingRole = ActingRole;
            this.type = 1683148259;
        }
    }
    IFC42.IfcRelAssignsToActor = IfcRelAssignsToActor;
    class IfcRelAssignsToControl extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingControl = RelatingControl;
            this.type = 2495723537;
        }
    }
    IFC42.IfcRelAssignsToControl = IfcRelAssignsToControl;
    class IfcRelAssignsToGroup extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingGroup = RelatingGroup;
            this.type = 1307041759;
        }
    }
    IFC42.IfcRelAssignsToGroup = IfcRelAssignsToGroup;
    class IfcRelAssignsToGroupByFactor extends IfcRelAssignsToGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup, Factor){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingGroup = RelatingGroup;
            this.Factor = Factor;
            this.type = 1027710054;
        }
    }
    IFC42.IfcRelAssignsToGroupByFactor = IfcRelAssignsToGroupByFactor;
    class IfcRelAssignsToProcess extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingProcess = RelatingProcess;
            this.QuantityInProcess = QuantityInProcess;
            this.type = 4278684876;
        }
    }
    IFC42.IfcRelAssignsToProcess = IfcRelAssignsToProcess;
    class IfcRelAssignsToProduct extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingProduct = RelatingProduct;
            this.type = 2857406711;
        }
    }
    IFC42.IfcRelAssignsToProduct = IfcRelAssignsToProduct;
    class IfcRelAssignsToResource extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingResource = RelatingResource;
            this.type = 205026976;
        }
    }
    IFC42.IfcRelAssignsToResource = IfcRelAssignsToResource;
    class IfcRelAssociates extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.type = 1865459582;
        }
    }
    IFC42.IfcRelAssociates = IfcRelAssociates;
    class IfcRelAssociatesApproval extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingApproval = RelatingApproval;
            this.type = 4095574036;
        }
    }
    IFC42.IfcRelAssociatesApproval = IfcRelAssociatesApproval;
    class IfcRelAssociatesClassification extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingClassification = RelatingClassification;
            this.type = 919958153;
        }
    }
    IFC42.IfcRelAssociatesClassification = IfcRelAssociatesClassification;
    class IfcRelAssociatesConstraint extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.Intent = Intent;
            this.RelatingConstraint = RelatingConstraint;
            this.type = 2728634034;
        }
    }
    IFC42.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;
    class IfcRelAssociatesDocument extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingDocument = RelatingDocument;
            this.type = 982818633;
        }
    }
    IFC42.IfcRelAssociatesDocument = IfcRelAssociatesDocument;
    class IfcRelAssociatesLibrary extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingLibrary = RelatingLibrary;
            this.type = 3840914261;
        }
    }
    IFC42.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;
    class IfcRelAssociatesMaterial extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingMaterial = RelatingMaterial;
            this.type = 2655215786;
        }
    }
    IFC42.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;
    class IfcRelConnects extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 826625072;
        }
    }
    IFC42.IfcRelConnects = IfcRelConnects;
    class IfcRelConnectsElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ConnectionGeometry = ConnectionGeometry;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.type = 1204542856;
        }
    }
    IFC42.IfcRelConnectsElements = IfcRelConnectsElements;
    class IfcRelConnectsPathElements extends IfcRelConnectsElements {
        constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType){
            super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ConnectionGeometry = ConnectionGeometry;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.RelatingPriorities = RelatingPriorities;
            this.RelatedPriorities = RelatedPriorities;
            this.RelatedConnectionType = RelatedConnectionType;
            this.RelatingConnectionType = RelatingConnectionType;
            this.type = 3945020480;
        }
    }
    IFC42.IfcRelConnectsPathElements = IfcRelConnectsPathElements;
    class IfcRelConnectsPortToElement extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingPort = RelatingPort;
            this.RelatedElement = RelatedElement;
            this.type = 4201705270;
        }
    }
    IFC42.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;
    class IfcRelConnectsPorts extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingPort = RelatingPort;
            this.RelatedPort = RelatedPort;
            this.RealizingElement = RealizingElement;
            this.type = 3190031847;
        }
    }
    IFC42.IfcRelConnectsPorts = IfcRelConnectsPorts;
    class IfcRelConnectsStructuralActivity extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedStructuralActivity = RelatedStructuralActivity;
            this.type = 2127690289;
        }
    }
    IFC42.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;
    class IfcRelConnectsStructuralMember extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingStructuralMember = RelatingStructuralMember;
            this.RelatedStructuralConnection = RelatedStructuralConnection;
            this.AppliedCondition = AppliedCondition;
            this.AdditionalConditions = AdditionalConditions;
            this.SupportedLength = SupportedLength;
            this.ConditionCoordinateSystem = ConditionCoordinateSystem;
            this.type = 1638771189;
        }
    }
    IFC42.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;
    class IfcRelConnectsWithEccentricity extends IfcRelConnectsStructuralMember {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint){
            super(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingStructuralMember = RelatingStructuralMember;
            this.RelatedStructuralConnection = RelatedStructuralConnection;
            this.AppliedCondition = AppliedCondition;
            this.AdditionalConditions = AdditionalConditions;
            this.SupportedLength = SupportedLength;
            this.ConditionCoordinateSystem = ConditionCoordinateSystem;
            this.ConnectionConstraint = ConnectionConstraint;
            this.type = 504942748;
        }
    }
    IFC42.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;
    class IfcRelConnectsWithRealizingElements extends IfcRelConnectsElements {
        constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType){
            super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ConnectionGeometry = ConnectionGeometry;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.RealizingElements = RealizingElements;
            this.ConnectionType = ConnectionType;
            this.type = 3678494232;
        }
    }
    IFC42.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;
    class IfcRelContainedInSpatialStructure extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedElements = RelatedElements;
            this.RelatingStructure = RelatingStructure;
            this.type = 3242617779;
        }
    }
    IFC42.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;
    class IfcRelCoversBldgElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingBuildingElement = RelatingBuildingElement;
            this.RelatedCoverings = RelatedCoverings;
            this.type = 886880790;
        }
    }
    IFC42.IfcRelCoversBldgElements = IfcRelCoversBldgElements;
    class IfcRelCoversSpaces extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedCoverings){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSpace = RelatingSpace;
            this.RelatedCoverings = RelatedCoverings;
            this.type = 2802773753;
        }
    }
    IFC42.IfcRelCoversSpaces = IfcRelCoversSpaces;
    class IfcRelDeclares extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingContext, RelatedDefinitions){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingContext = RelatingContext;
            this.RelatedDefinitions = RelatedDefinitions;
            this.type = 2565941209;
        }
    }
    IFC42.IfcRelDeclares = IfcRelDeclares;
    class IfcRelDecomposes extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 2551354335;
        }
    }
    IFC42.IfcRelDecomposes = IfcRelDecomposes;
    class IfcRelDefines extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 693640335;
        }
    }
    IFC42.IfcRelDefines = IfcRelDefines;
    class IfcRelDefinesByObject extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingObject){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingObject = RelatingObject;
            this.type = 1462361463;
        }
    }
    IFC42.IfcRelDefinesByObject = IfcRelDefinesByObject;
    class IfcRelDefinesByProperties extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingPropertyDefinition = RelatingPropertyDefinition;
            this.type = 4186316022;
        }
    }
    IFC42.IfcRelDefinesByProperties = IfcRelDefinesByProperties;
    class IfcRelDefinesByTemplate extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedPropertySets, RelatingTemplate){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedPropertySets = RelatedPropertySets;
            this.RelatingTemplate = RelatingTemplate;
            this.type = 307848117;
        }
    }
    IFC42.IfcRelDefinesByTemplate = IfcRelDefinesByTemplate;
    class IfcRelDefinesByType extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingType = RelatingType;
            this.type = 781010003;
        }
    }
    IFC42.IfcRelDefinesByType = IfcRelDefinesByType;
    class IfcRelFillsElement extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingOpeningElement = RelatingOpeningElement;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.type = 3940055652;
        }
    }
    IFC42.IfcRelFillsElement = IfcRelFillsElement;
    class IfcRelFlowControlElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedControlElements = RelatedControlElements;
            this.RelatingFlowElement = RelatingFlowElement;
            this.type = 279856033;
        }
    }
    IFC42.IfcRelFlowControlElements = IfcRelFlowControlElements;
    class IfcRelInterferesElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedElement, InterferenceGeometry, InterferenceType, ImpliedOrder){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.InterferenceGeometry = InterferenceGeometry;
            this.InterferenceType = InterferenceType;
            this.ImpliedOrder = ImpliedOrder;
            this.type = 427948657;
        }
    }
    IFC42.IfcRelInterferesElements = IfcRelInterferesElements;
    class IfcRelNests extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingObject = RelatingObject;
            this.RelatedObjects = RelatedObjects;
            this.type = 3268803585;
        }
    }
    IFC42.IfcRelNests = IfcRelNests;
    class IfcRelProjectsElement extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedFeatureElement = RelatedFeatureElement;
            this.type = 750771296;
        }
    }
    IFC42.IfcRelProjectsElement = IfcRelProjectsElement;
    class IfcRelReferencedInSpatialStructure extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedElements = RelatedElements;
            this.RelatingStructure = RelatingStructure;
            this.type = 1245217292;
        }
    }
    IFC42.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;
    class IfcRelSequence extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType, UserDefinedSequenceType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingProcess = RelatingProcess;
            this.RelatedProcess = RelatedProcess;
            this.TimeLag = TimeLag;
            this.SequenceType = SequenceType;
            this.UserDefinedSequenceType = UserDefinedSequenceType;
            this.type = 4122056220;
        }
    }
    IFC42.IfcRelSequence = IfcRelSequence;
    class IfcRelServicesBuildings extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSystem = RelatingSystem;
            this.RelatedBuildings = RelatedBuildings;
            this.type = 366585022;
        }
    }
    IFC42.IfcRelServicesBuildings = IfcRelServicesBuildings;
    class IfcRelSpaceBoundary extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSpace = RelatingSpace;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.ConnectionGeometry = ConnectionGeometry;
            this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
            this.InternalOrExternalBoundary = InternalOrExternalBoundary;
            this.type = 3451746338;
        }
    }
    IFC42.IfcRelSpaceBoundary = IfcRelSpaceBoundary;
    class IfcRelSpaceBoundary1stLevel extends IfcRelSpaceBoundary {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary){
            super(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSpace = RelatingSpace;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.ConnectionGeometry = ConnectionGeometry;
            this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
            this.InternalOrExternalBoundary = InternalOrExternalBoundary;
            this.ParentBoundary = ParentBoundary;
            this.type = 3523091289;
        }
    }
    IFC42.IfcRelSpaceBoundary1stLevel = IfcRelSpaceBoundary1stLevel;
    class IfcRelSpaceBoundary2ndLevel extends IfcRelSpaceBoundary1stLevel {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary, CorrespondingBoundary){
            super(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSpace = RelatingSpace;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.ConnectionGeometry = ConnectionGeometry;
            this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
            this.InternalOrExternalBoundary = InternalOrExternalBoundary;
            this.ParentBoundary = ParentBoundary;
            this.CorrespondingBoundary = CorrespondingBoundary;
            this.type = 1521410863;
        }
    }
    IFC42.IfcRelSpaceBoundary2ndLevel = IfcRelSpaceBoundary2ndLevel;
    class IfcRelVoidsElement extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingBuildingElement = RelatingBuildingElement;
            this.RelatedOpeningElement = RelatedOpeningElement;
            this.type = 1401173127;
        }
    }
    IFC42.IfcRelVoidsElement = IfcRelVoidsElement;
    class IfcReparametrisedCompositeCurveSegment extends IfcCompositeCurveSegment {
        constructor(Transition, SameSense, ParentCurve, ParamLength){
            super(Transition, SameSense, ParentCurve);
            this.Transition = Transition;
            this.SameSense = SameSense;
            this.ParentCurve = ParentCurve;
            this.ParamLength = ParamLength;
            this.type = 816062949;
        }
    }
    IFC42.IfcReparametrisedCompositeCurveSegment = IfcReparametrisedCompositeCurveSegment;
    class IfcResource extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.type = 2914609552;
        }
    }
    IFC42.IfcResource = IfcResource;
    class IfcRevolvedAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, Axis, Angle){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Axis = Axis;
            this.Angle = Angle;
            this.type = 1856042241;
        }
    }
    IFC42.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;
    class IfcRevolvedAreaSolidTapered extends IfcRevolvedAreaSolid {
        constructor(SweptArea, Position, Axis, Angle, EndSweptArea){
            super(SweptArea, Position, Axis, Angle);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Axis = Axis;
            this.Angle = Angle;
            this.EndSweptArea = EndSweptArea;
            this.type = 3243963512;
        }
    }
    IFC42.IfcRevolvedAreaSolidTapered = IfcRevolvedAreaSolidTapered;
    class IfcRightCircularCone extends IfcCsgPrimitive3D {
        constructor(Position, Height, BottomRadius){
            super(Position);
            this.Position = Position;
            this.Height = Height;
            this.BottomRadius = BottomRadius;
            this.type = 4158566097;
        }
    }
    IFC42.IfcRightCircularCone = IfcRightCircularCone;
    class IfcRightCircularCylinder extends IfcCsgPrimitive3D {
        constructor(Position, Height, Radius){
            super(Position);
            this.Position = Position;
            this.Height = Height;
            this.Radius = Radius;
            this.type = 3626867408;
        }
    }
    IFC42.IfcRightCircularCylinder = IfcRightCircularCylinder;
    class IfcSimplePropertyTemplate extends IfcPropertyTemplate {
        constructor(GlobalId, OwnerHistory, Name, Description, TemplateType, PrimaryMeasureType, SecondaryMeasureType, Enumerators, PrimaryUnit, SecondaryUnit, Expression, AccessState){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.TemplateType = TemplateType;
            this.PrimaryMeasureType = PrimaryMeasureType;
            this.SecondaryMeasureType = SecondaryMeasureType;
            this.Enumerators = Enumerators;
            this.PrimaryUnit = PrimaryUnit;
            this.SecondaryUnit = SecondaryUnit;
            this.Expression = Expression;
            this.AccessState = AccessState;
            this.type = 3663146110;
        }
    }
    IFC42.IfcSimplePropertyTemplate = IfcSimplePropertyTemplate;
    class IfcSpatialElement extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.type = 1412071761;
        }
    }
    IFC42.IfcSpatialElement = IfcSpatialElement;
    class IfcSpatialElementType extends IfcTypeProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 710998568;
        }
    }
    IFC42.IfcSpatialElementType = IfcSpatialElementType;
    class IfcSpatialStructureElement extends IfcSpatialElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.type = 2706606064;
        }
    }
    IFC42.IfcSpatialStructureElement = IfcSpatialStructureElement;
    class IfcSpatialStructureElementType extends IfcSpatialElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3893378262;
        }
    }
    IFC42.IfcSpatialStructureElementType = IfcSpatialStructureElementType;
    class IfcSpatialZone extends IfcSpatialElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.PredefinedType = PredefinedType;
            this.type = 463610769;
        }
    }
    IFC42.IfcSpatialZone = IfcSpatialZone;
    class IfcSpatialZoneType extends IfcSpatialElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.LongName = LongName;
            this.type = 2481509218;
        }
    }
    IFC42.IfcSpatialZoneType = IfcSpatialZoneType;
    class IfcSphere extends IfcCsgPrimitive3D {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 451544542;
        }
    }
    IFC42.IfcSphere = IfcSphere;
    class IfcSphericalSurface extends IfcElementarySurface {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 4015995234;
        }
    }
    IFC42.IfcSphericalSurface = IfcSphericalSurface;
    class IfcStructuralActivity extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 3544373492;
        }
    }
    IFC42.IfcStructuralActivity = IfcStructuralActivity;
    class IfcStructuralItem extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 3136571912;
        }
    }
    IFC42.IfcStructuralItem = IfcStructuralItem;
    class IfcStructuralMember extends IfcStructuralItem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 530289379;
        }
    }
    IFC42.IfcStructuralMember = IfcStructuralMember;
    class IfcStructuralReaction extends IfcStructuralActivity {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 3689010777;
        }
    }
    IFC42.IfcStructuralReaction = IfcStructuralReaction;
    class IfcStructuralSurfaceMember extends IfcStructuralMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Thickness = Thickness;
            this.type = 3979015343;
        }
    }
    IFC42.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;
    class IfcStructuralSurfaceMemberVarying extends IfcStructuralSurfaceMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Thickness = Thickness;
            this.type = 2218152070;
        }
    }
    IFC42.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;
    class IfcStructuralSurfaceReaction extends IfcStructuralReaction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.PredefinedType = PredefinedType;
            this.type = 603775116;
        }
    }
    IFC42.IfcStructuralSurfaceReaction = IfcStructuralSurfaceReaction;
    class IfcSubContractResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 4095615324;
        }
    }
    IFC42.IfcSubContractResourceType = IfcSubContractResourceType;
    class IfcSurfaceCurve extends IfcCurve {
        constructor(Curve3D, AssociatedGeometry, MasterRepresentation){
            super();
            this.Curve3D = Curve3D;
            this.AssociatedGeometry = AssociatedGeometry;
            this.MasterRepresentation = MasterRepresentation;
            this.type = 699246055;
        }
    }
    IFC42.IfcSurfaceCurve = IfcSurfaceCurve;
    class IfcSurfaceCurveSweptAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Directrix = Directrix;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.ReferenceSurface = ReferenceSurface;
            this.type = 2028607225;
        }
    }
    IFC42.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;
    class IfcSurfaceOfLinearExtrusion extends IfcSweptSurface {
        constructor(SweptCurve, Position, ExtrudedDirection, Depth){
            super(SweptCurve, Position);
            this.SweptCurve = SweptCurve;
            this.Position = Position;
            this.ExtrudedDirection = ExtrudedDirection;
            this.Depth = Depth;
            this.type = 2809605785;
        }
    }
    IFC42.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;
    class IfcSurfaceOfRevolution extends IfcSweptSurface {
        constructor(SweptCurve, Position, AxisPosition){
            super(SweptCurve, Position);
            this.SweptCurve = SweptCurve;
            this.Position = Position;
            this.AxisPosition = AxisPosition;
            this.type = 4124788165;
        }
    }
    IFC42.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;
    class IfcSystemFurnitureElementType extends IfcFurnishingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1580310250;
        }
    }
    IFC42.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;
    class IfcTask extends IfcProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Status, WorkMethod, IsMilestone, Priority, TaskTime, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Status = Status;
            this.WorkMethod = WorkMethod;
            this.IsMilestone = IsMilestone;
            this.Priority = Priority;
            this.TaskTime = TaskTime;
            this.PredefinedType = PredefinedType;
            this.type = 3473067441;
        }
    }
    IFC42.IfcTask = IfcTask;
    class IfcTaskType extends IfcTypeProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, WorkMethod){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ProcessType = ProcessType;
            this.PredefinedType = PredefinedType;
            this.WorkMethod = WorkMethod;
            this.type = 3206491090;
        }
    }
    IFC42.IfcTaskType = IfcTaskType;
    class IfcTessellatedFaceSet extends IfcTessellatedItem {
        constructor(Coordinates){
            super();
            this.Coordinates = Coordinates;
            this.type = 2387106220;
        }
    }
    IFC42.IfcTessellatedFaceSet = IfcTessellatedFaceSet;
    class IfcToroidalSurface extends IfcElementarySurface {
        constructor(Position, MajorRadius, MinorRadius){
            super(Position);
            this.Position = Position;
            this.MajorRadius = MajorRadius;
            this.MinorRadius = MinorRadius;
            this.type = 1935646853;
        }
    }
    IFC42.IfcToroidalSurface = IfcToroidalSurface;
    class IfcTransportElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2097647324;
        }
    }
    IFC42.IfcTransportElementType = IfcTransportElementType;
    class IfcTriangulatedFaceSet extends IfcTessellatedFaceSet {
        constructor(Coordinates, Normals, Closed, CoordIndex, PnIndex){
            super(Coordinates);
            this.Coordinates = Coordinates;
            this.Normals = Normals;
            this.Closed = Closed;
            this.CoordIndex = CoordIndex;
            this.PnIndex = PnIndex;
            this.type = 2916149573;
        }
    }
    IFC42.IfcTriangulatedFaceSet = IfcTriangulatedFaceSet;
    class IfcWindowLiningProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle, LiningOffset, LiningToPanelOffsetX, LiningToPanelOffsetY){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.LiningDepth = LiningDepth;
            this.LiningThickness = LiningThickness;
            this.TransomThickness = TransomThickness;
            this.MullionThickness = MullionThickness;
            this.FirstTransomOffset = FirstTransomOffset;
            this.SecondTransomOffset = SecondTransomOffset;
            this.FirstMullionOffset = FirstMullionOffset;
            this.SecondMullionOffset = SecondMullionOffset;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.LiningOffset = LiningOffset;
            this.LiningToPanelOffsetX = LiningToPanelOffsetX;
            this.LiningToPanelOffsetY = LiningToPanelOffsetY;
            this.type = 336235671;
        }
    }
    IFC42.IfcWindowLiningProperties = IfcWindowLiningProperties;
    class IfcWindowPanelProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.OperationType = OperationType;
            this.PanelPosition = PanelPosition;
            this.FrameDepth = FrameDepth;
            this.FrameThickness = FrameThickness;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 512836454;
        }
    }
    IFC42.IfcWindowPanelProperties = IfcWindowPanelProperties;
    class IfcActor extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TheActor = TheActor;
            this.type = 2296667514;
        }
    }
    IFC42.IfcActor = IfcActor;
    class IfcAdvancedBrep extends IfcManifoldSolidBrep {
        constructor(Outer){
            super(Outer);
            this.Outer = Outer;
            this.type = 1635779807;
        }
    }
    IFC42.IfcAdvancedBrep = IfcAdvancedBrep;
    class IfcAdvancedBrepWithVoids extends IfcAdvancedBrep {
        constructor(Outer, Voids){
            super(Outer);
            this.Outer = Outer;
            this.Voids = Voids;
            this.type = 2603310189;
        }
    }
    IFC42.IfcAdvancedBrepWithVoids = IfcAdvancedBrepWithVoids;
    class IfcAnnotation extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 1674181508;
        }
    }
    IFC42.IfcAnnotation = IfcAnnotation;
    class IfcBSplineSurface extends IfcBoundedSurface {
        constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect){
            super();
            this.UDegree = UDegree;
            this.VDegree = VDegree;
            this.ControlPointsList = ControlPointsList;
            this.SurfaceForm = SurfaceForm;
            this.UClosed = UClosed;
            this.VClosed = VClosed;
            this.SelfIntersect = SelfIntersect;
            this.type = 2887950389;
        }
    }
    IFC42.IfcBSplineSurface = IfcBSplineSurface;
    class IfcBSplineSurfaceWithKnots extends IfcBSplineSurface {
        constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec){
            super(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect);
            this.UDegree = UDegree;
            this.VDegree = VDegree;
            this.ControlPointsList = ControlPointsList;
            this.SurfaceForm = SurfaceForm;
            this.UClosed = UClosed;
            this.VClosed = VClosed;
            this.SelfIntersect = SelfIntersect;
            this.UMultiplicities = UMultiplicities;
            this.VMultiplicities = VMultiplicities;
            this.UKnots = UKnots;
            this.VKnots = VKnots;
            this.KnotSpec = KnotSpec;
            this.type = 167062518;
        }
    }
    IFC42.IfcBSplineSurfaceWithKnots = IfcBSplineSurfaceWithKnots;
    class IfcBlock extends IfcCsgPrimitive3D {
        constructor(Position, XLength, YLength, ZLength){
            super(Position);
            this.Position = Position;
            this.XLength = XLength;
            this.YLength = YLength;
            this.ZLength = ZLength;
            this.type = 1334484129;
        }
    }
    IFC42.IfcBlock = IfcBlock;
    class IfcBooleanClippingResult extends IfcBooleanResult {
        constructor(Operator, FirstOperand, SecondOperand){
            super(Operator, FirstOperand, SecondOperand);
            this.Operator = Operator;
            this.FirstOperand = FirstOperand;
            this.SecondOperand = SecondOperand;
            this.type = 3649129432;
        }
    }
    IFC42.IfcBooleanClippingResult = IfcBooleanClippingResult;
    class IfcBoundedCurve extends IfcCurve {
        constructor(){
            super();
            this.type = 1260505505;
        }
    }
    IFC42.IfcBoundedCurve = IfcBoundedCurve;
    class IfcBuilding extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.ElevationOfRefHeight = ElevationOfRefHeight;
            this.ElevationOfTerrain = ElevationOfTerrain;
            this.BuildingAddress = BuildingAddress;
            this.type = 4031249490;
        }
    }
    IFC42.IfcBuilding = IfcBuilding;
    class IfcBuildingElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1950629157;
        }
    }
    IFC42.IfcBuildingElementType = IfcBuildingElementType;
    class IfcBuildingStorey extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.Elevation = Elevation;
            this.type = 3124254112;
        }
    }
    IFC42.IfcBuildingStorey = IfcBuildingStorey;
    class IfcChimneyType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2197970202;
        }
    }
    IFC42.IfcChimneyType = IfcChimneyType;
    class IfcCircleHollowProfileDef extends IfcCircleProfileDef {
        constructor(ProfileType, ProfileName, Position, Radius, WallThickness){
            super(ProfileType, ProfileName, Position, Radius);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Radius = Radius;
            this.WallThickness = WallThickness;
            this.type = 2937912522;
        }
    }
    IFC42.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;
    class IfcCivilElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3893394355;
        }
    }
    IFC42.IfcCivilElementType = IfcCivilElementType;
    class IfcColumnType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 300633059;
        }
    }
    IFC42.IfcColumnType = IfcColumnType;
    class IfcComplexPropertyTemplate extends IfcPropertyTemplate {
        constructor(GlobalId, OwnerHistory, Name, Description, UsageName, TemplateType, HasPropertyTemplates){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.UsageName = UsageName;
            this.TemplateType = TemplateType;
            this.HasPropertyTemplates = HasPropertyTemplates;
            this.type = 3875453745;
        }
    }
    IFC42.IfcComplexPropertyTemplate = IfcComplexPropertyTemplate;
    class IfcCompositeCurve extends IfcBoundedCurve {
        constructor(Segments, SelfIntersect){
            super();
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 3732776249;
        }
    }
    IFC42.IfcCompositeCurve = IfcCompositeCurve;
    class IfcCompositeCurveOnSurface extends IfcCompositeCurve {
        constructor(Segments, SelfIntersect){
            super(Segments, SelfIntersect);
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 15328376;
        }
    }
    IFC42.IfcCompositeCurveOnSurface = IfcCompositeCurveOnSurface;
    class IfcConic extends IfcCurve {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2510884976;
        }
    }
    IFC42.IfcConic = IfcConic;
    class IfcConstructionEquipmentResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 2185764099;
        }
    }
    IFC42.IfcConstructionEquipmentResourceType = IfcConstructionEquipmentResourceType;
    class IfcConstructionMaterialResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 4105962743;
        }
    }
    IFC42.IfcConstructionMaterialResourceType = IfcConstructionMaterialResourceType;
    class IfcConstructionProductResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 1525564444;
        }
    }
    IFC42.IfcConstructionProductResourceType = IfcConstructionProductResourceType;
    class IfcConstructionResource extends IfcResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.type = 2559216714;
        }
    }
    IFC42.IfcConstructionResource = IfcConstructionResource;
    class IfcControl extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.type = 3293443760;
        }
    }
    IFC42.IfcControl = IfcControl;
    class IfcCostItem extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, CostValues, CostQuantities){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.CostValues = CostValues;
            this.CostQuantities = CostQuantities;
            this.type = 3895139033;
        }
    }
    IFC42.IfcCostItem = IfcCostItem;
    class IfcCostSchedule extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, SubmittedOn, UpdateDate){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.Status = Status;
            this.SubmittedOn = SubmittedOn;
            this.UpdateDate = UpdateDate;
            this.type = 1419761937;
        }
    }
    IFC42.IfcCostSchedule = IfcCostSchedule;
    class IfcCoveringType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1916426348;
        }
    }
    IFC42.IfcCoveringType = IfcCoveringType;
    class IfcCrewResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 3295246426;
        }
    }
    IFC42.IfcCrewResource = IfcCrewResource;
    class IfcCurtainWallType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1457835157;
        }
    }
    IFC42.IfcCurtainWallType = IfcCurtainWallType;
    class IfcCylindricalSurface extends IfcElementarySurface {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 1213902940;
        }
    }
    IFC42.IfcCylindricalSurface = IfcCylindricalSurface;
    class IfcDistributionElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3256556792;
        }
    }
    IFC42.IfcDistributionElementType = IfcDistributionElementType;
    class IfcDistributionFlowElementType extends IfcDistributionElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3849074793;
        }
    }
    IFC42.IfcDistributionFlowElementType = IfcDistributionFlowElementType;
    class IfcDoorLiningProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle, LiningToPanelOffsetX, LiningToPanelOffsetY){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.LiningDepth = LiningDepth;
            this.LiningThickness = LiningThickness;
            this.ThresholdDepth = ThresholdDepth;
            this.ThresholdThickness = ThresholdThickness;
            this.TransomThickness = TransomThickness;
            this.TransomOffset = TransomOffset;
            this.LiningOffset = LiningOffset;
            this.ThresholdOffset = ThresholdOffset;
            this.CasingThickness = CasingThickness;
            this.CasingDepth = CasingDepth;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.LiningToPanelOffsetX = LiningToPanelOffsetX;
            this.LiningToPanelOffsetY = LiningToPanelOffsetY;
            this.type = 2963535650;
        }
    }
    IFC42.IfcDoorLiningProperties = IfcDoorLiningProperties;
    class IfcDoorPanelProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.PanelDepth = PanelDepth;
            this.PanelOperation = PanelOperation;
            this.PanelWidth = PanelWidth;
            this.PanelPosition = PanelPosition;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 1714330368;
        }
    }
    IFC42.IfcDoorPanelProperties = IfcDoorPanelProperties;
    class IfcDoorType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, OperationType, ParameterTakesPrecedence, UserDefinedOperationType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.OperationType = OperationType;
            this.ParameterTakesPrecedence = ParameterTakesPrecedence;
            this.UserDefinedOperationType = UserDefinedOperationType;
            this.type = 2323601079;
        }
    }
    IFC42.IfcDoorType = IfcDoorType;
    class IfcDraughtingPreDefinedColour extends IfcPreDefinedColour {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 445594917;
        }
    }
    IFC42.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;
    class IfcDraughtingPreDefinedCurveFont extends IfcPreDefinedCurveFont {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 4006246654;
        }
    }
    IFC42.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;
    class IfcElement extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1758889154;
        }
    }
    IFC42.IfcElement = IfcElement;
    class IfcElementAssembly extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.AssemblyPlace = AssemblyPlace;
            this.PredefinedType = PredefinedType;
            this.type = 4123344466;
        }
    }
    IFC42.IfcElementAssembly = IfcElementAssembly;
    class IfcElementAssemblyType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2397081782;
        }
    }
    IFC42.IfcElementAssemblyType = IfcElementAssemblyType;
    class IfcElementComponent extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1623761950;
        }
    }
    IFC42.IfcElementComponent = IfcElementComponent;
    class IfcElementComponentType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2590856083;
        }
    }
    IFC42.IfcElementComponentType = IfcElementComponentType;
    class IfcEllipse extends IfcConic {
        constructor(Position, SemiAxis1, SemiAxis2){
            super(Position);
            this.Position = Position;
            this.SemiAxis1 = SemiAxis1;
            this.SemiAxis2 = SemiAxis2;
            this.type = 1704287377;
        }
    }
    IFC42.IfcEllipse = IfcEllipse;
    class IfcEnergyConversionDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2107101300;
        }
    }
    IFC42.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;
    class IfcEngineType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 132023988;
        }
    }
    IFC42.IfcEngineType = IfcEngineType;
    class IfcEvaporativeCoolerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3174744832;
        }
    }
    IFC42.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;
    class IfcEvaporatorType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3390157468;
        }
    }
    IFC42.IfcEvaporatorType = IfcEvaporatorType;
    class IfcEvent extends IfcProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType, EventTriggerType, UserDefinedEventTriggerType, EventOccurenceTime){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.PredefinedType = PredefinedType;
            this.EventTriggerType = EventTriggerType;
            this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
            this.EventOccurenceTime = EventOccurenceTime;
            this.type = 4148101412;
        }
    }
    IFC42.IfcEvent = IfcEvent;
    class IfcExternalSpatialStructureElement extends IfcSpatialElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.type = 2853485674;
        }
    }
    IFC42.IfcExternalSpatialStructureElement = IfcExternalSpatialStructureElement;
    class IfcFacetedBrep extends IfcManifoldSolidBrep {
        constructor(Outer){
            super(Outer);
            this.Outer = Outer;
            this.type = 807026263;
        }
    }
    IFC42.IfcFacetedBrep = IfcFacetedBrep;
    class IfcFacetedBrepWithVoids extends IfcFacetedBrep {
        constructor(Outer, Voids){
            super(Outer);
            this.Outer = Outer;
            this.Voids = Voids;
            this.type = 3737207727;
        }
    }
    IFC42.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;
    class IfcFastener extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 647756555;
        }
    }
    IFC42.IfcFastener = IfcFastener;
    class IfcFastenerType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2489546625;
        }
    }
    IFC42.IfcFastenerType = IfcFastenerType;
    class IfcFeatureElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2827207264;
        }
    }
    IFC42.IfcFeatureElement = IfcFeatureElement;
    class IfcFeatureElementAddition extends IfcFeatureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2143335405;
        }
    }
    IFC42.IfcFeatureElementAddition = IfcFeatureElementAddition;
    class IfcFeatureElementSubtraction extends IfcFeatureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1287392070;
        }
    }
    IFC42.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;
    class IfcFlowControllerType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3907093117;
        }
    }
    IFC42.IfcFlowControllerType = IfcFlowControllerType;
    class IfcFlowFittingType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3198132628;
        }
    }
    IFC42.IfcFlowFittingType = IfcFlowFittingType;
    class IfcFlowMeterType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3815607619;
        }
    }
    IFC42.IfcFlowMeterType = IfcFlowMeterType;
    class IfcFlowMovingDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1482959167;
        }
    }
    IFC42.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;
    class IfcFlowSegmentType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1834744321;
        }
    }
    IFC42.IfcFlowSegmentType = IfcFlowSegmentType;
    class IfcFlowStorageDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1339347760;
        }
    }
    IFC42.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;
    class IfcFlowTerminalType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2297155007;
        }
    }
    IFC42.IfcFlowTerminalType = IfcFlowTerminalType;
    class IfcFlowTreatmentDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3009222698;
        }
    }
    IFC42.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;
    class IfcFootingType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1893162501;
        }
    }
    IFC42.IfcFootingType = IfcFootingType;
    class IfcFurnishingElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 263784265;
        }
    }
    IFC42.IfcFurnishingElement = IfcFurnishingElement;
    class IfcFurniture extends IfcFurnishingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1509553395;
        }
    }
    IFC42.IfcFurniture = IfcFurniture;
    class IfcGeographicElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3493046030;
        }
    }
    IFC42.IfcGeographicElement = IfcGeographicElement;
    class IfcGrid extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.UAxes = UAxes;
            this.VAxes = VAxes;
            this.WAxes = WAxes;
            this.PredefinedType = PredefinedType;
            this.type = 3009204131;
        }
    }
    IFC42.IfcGrid = IfcGrid;
    class IfcGroup extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 2706460486;
        }
    }
    IFC42.IfcGroup = IfcGroup;
    class IfcHeatExchangerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1251058090;
        }
    }
    IFC42.IfcHeatExchangerType = IfcHeatExchangerType;
    class IfcHumidifierType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1806887404;
        }
    }
    IFC42.IfcHumidifierType = IfcHumidifierType;
    class IfcIndexedPolyCurve extends IfcBoundedCurve {
        constructor(Points, Segments, SelfIntersect){
            super();
            this.Points = Points;
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 2571569899;
        }
    }
    IFC42.IfcIndexedPolyCurve = IfcIndexedPolyCurve;
    class IfcInterceptorType extends IfcFlowTreatmentDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3946677679;
        }
    }
    IFC42.IfcInterceptorType = IfcInterceptorType;
    class IfcIntersectionCurve extends IfcSurfaceCurve {
        constructor(Curve3D, AssociatedGeometry, MasterRepresentation){
            super(Curve3D, AssociatedGeometry, MasterRepresentation);
            this.Curve3D = Curve3D;
            this.AssociatedGeometry = AssociatedGeometry;
            this.MasterRepresentation = MasterRepresentation;
            this.type = 3113134337;
        }
    }
    IFC42.IfcIntersectionCurve = IfcIntersectionCurve;
    class IfcInventory extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.Jurisdiction = Jurisdiction;
            this.ResponsiblePersons = ResponsiblePersons;
            this.LastUpdateDate = LastUpdateDate;
            this.CurrentValue = CurrentValue;
            this.OriginalValue = OriginalValue;
            this.type = 2391368822;
        }
    }
    IFC42.IfcInventory = IfcInventory;
    class IfcJunctionBoxType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4288270099;
        }
    }
    IFC42.IfcJunctionBoxType = IfcJunctionBoxType;
    class IfcLaborResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 3827777499;
        }
    }
    IFC42.IfcLaborResource = IfcLaborResource;
    class IfcLampType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1051575348;
        }
    }
    IFC42.IfcLampType = IfcLampType;
    class IfcLightFixtureType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1161773419;
        }
    }
    IFC42.IfcLightFixtureType = IfcLightFixtureType;
    class IfcMechanicalFastener extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.NominalDiameter = NominalDiameter;
            this.NominalLength = NominalLength;
            this.PredefinedType = PredefinedType;
            this.type = 377706215;
        }
    }
    IFC42.IfcMechanicalFastener = IfcMechanicalFastener;
    class IfcMechanicalFastenerType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, NominalLength){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.NominalDiameter = NominalDiameter;
            this.NominalLength = NominalLength;
            this.type = 2108223431;
        }
    }
    IFC42.IfcMechanicalFastenerType = IfcMechanicalFastenerType;
    class IfcMedicalDeviceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1114901282;
        }
    }
    IFC42.IfcMedicalDeviceType = IfcMedicalDeviceType;
    class IfcMemberType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3181161470;
        }
    }
    IFC42.IfcMemberType = IfcMemberType;
    class IfcMotorConnectionType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 977012517;
        }
    }
    IFC42.IfcMotorConnectionType = IfcMotorConnectionType;
    class IfcOccupant extends IfcActor {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TheActor = TheActor;
            this.PredefinedType = PredefinedType;
            this.type = 4143007308;
        }
    }
    IFC42.IfcOccupant = IfcOccupant;
    class IfcOpeningElement extends IfcFeatureElementSubtraction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3588315303;
        }
    }
    IFC42.IfcOpeningElement = IfcOpeningElement;
    class IfcOpeningStandardCase extends IfcOpeningElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3079942009;
        }
    }
    IFC42.IfcOpeningStandardCase = IfcOpeningStandardCase;
    class IfcOutletType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2837617999;
        }
    }
    IFC42.IfcOutletType = IfcOutletType;
    class IfcPerformanceHistory extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LifeCyclePhase, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LifeCyclePhase = LifeCyclePhase;
            this.PredefinedType = PredefinedType;
            this.type = 2382730787;
        }
    }
    IFC42.IfcPerformanceHistory = IfcPerformanceHistory;
    class IfcPermeableCoveringProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.OperationType = OperationType;
            this.PanelPosition = PanelPosition;
            this.FrameDepth = FrameDepth;
            this.FrameThickness = FrameThickness;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 3566463478;
        }
    }
    IFC42.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;
    class IfcPermit extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.Status = Status;
            this.LongDescription = LongDescription;
            this.type = 3327091369;
        }
    }
    IFC42.IfcPermit = IfcPermit;
    class IfcPileType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1158309216;
        }
    }
    IFC42.IfcPileType = IfcPileType;
    class IfcPipeFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 804291784;
        }
    }
    IFC42.IfcPipeFittingType = IfcPipeFittingType;
    class IfcPipeSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4231323485;
        }
    }
    IFC42.IfcPipeSegmentType = IfcPipeSegmentType;
    class IfcPlateType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4017108033;
        }
    }
    IFC42.IfcPlateType = IfcPlateType;
    class IfcPolygonalFaceSet extends IfcTessellatedFaceSet {
        constructor(Coordinates, Closed, Faces, PnIndex){
            super(Coordinates);
            this.Coordinates = Coordinates;
            this.Closed = Closed;
            this.Faces = Faces;
            this.PnIndex = PnIndex;
            this.type = 2839578677;
        }
    }
    IFC42.IfcPolygonalFaceSet = IfcPolygonalFaceSet;
    class IfcPolyline extends IfcBoundedCurve {
        constructor(Points){
            super();
            this.Points = Points;
            this.type = 3724593414;
        }
    }
    IFC42.IfcPolyline = IfcPolyline;
    class IfcPort extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 3740093272;
        }
    }
    IFC42.IfcPort = IfcPort;
    class IfcProcedure extends IfcProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.PredefinedType = PredefinedType;
            this.type = 2744685151;
        }
    }
    IFC42.IfcProcedure = IfcProcedure;
    class IfcProjectOrder extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.Status = Status;
            this.LongDescription = LongDescription;
            this.type = 2904328755;
        }
    }
    IFC42.IfcProjectOrder = IfcProjectOrder;
    class IfcProjectionElement extends IfcFeatureElementAddition {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3651124850;
        }
    }
    IFC42.IfcProjectionElement = IfcProjectionElement;
    class IfcProtectiveDeviceType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1842657554;
        }
    }
    IFC42.IfcProtectiveDeviceType = IfcProtectiveDeviceType;
    class IfcPumpType extends IfcFlowMovingDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2250791053;
        }
    }
    IFC42.IfcPumpType = IfcPumpType;
    class IfcRailingType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2893384427;
        }
    }
    IFC42.IfcRailingType = IfcRailingType;
    class IfcRampFlightType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2324767716;
        }
    }
    IFC42.IfcRampFlightType = IfcRampFlightType;
    class IfcRampType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1469900589;
        }
    }
    IFC42.IfcRampType = IfcRampType;
    class IfcRationalBSplineSurfaceWithKnots extends IfcBSplineSurfaceWithKnots {
        constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec, WeightsData){
            super(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec);
            this.UDegree = UDegree;
            this.VDegree = VDegree;
            this.ControlPointsList = ControlPointsList;
            this.SurfaceForm = SurfaceForm;
            this.UClosed = UClosed;
            this.VClosed = VClosed;
            this.SelfIntersect = SelfIntersect;
            this.UMultiplicities = UMultiplicities;
            this.VMultiplicities = VMultiplicities;
            this.UKnots = UKnots;
            this.VKnots = VKnots;
            this.KnotSpec = KnotSpec;
            this.WeightsData = WeightsData;
            this.type = 683857671;
        }
    }
    IFC42.IfcRationalBSplineSurfaceWithKnots = IfcRationalBSplineSurfaceWithKnots;
    class IfcReinforcingElement extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.type = 3027567501;
        }
    }
    IFC42.IfcReinforcingElement = IfcReinforcingElement;
    class IfcReinforcingElementType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 964333572;
        }
    }
    IFC42.IfcReinforcingElementType = IfcReinforcingElementType;
    class IfcReinforcingMesh extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.MeshLength = MeshLength;
            this.MeshWidth = MeshWidth;
            this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
            this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
            this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
            this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
            this.LongitudinalBarSpacing = LongitudinalBarSpacing;
            this.TransverseBarSpacing = TransverseBarSpacing;
            this.PredefinedType = PredefinedType;
            this.type = 2320036040;
        }
    }
    IFC42.IfcReinforcingMesh = IfcReinforcingMesh;
    class IfcReinforcingMeshType extends IfcReinforcingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, BendingShapeCode, BendingParameters){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.MeshLength = MeshLength;
            this.MeshWidth = MeshWidth;
            this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
            this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
            this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
            this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
            this.LongitudinalBarSpacing = LongitudinalBarSpacing;
            this.TransverseBarSpacing = TransverseBarSpacing;
            this.BendingShapeCode = BendingShapeCode;
            this.BendingParameters = BendingParameters;
            this.type = 2310774935;
        }
    }
    IFC42.IfcReinforcingMeshType = IfcReinforcingMeshType;
    class IfcRelAggregates extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingObject = RelatingObject;
            this.RelatedObjects = RelatedObjects;
            this.type = 160246688;
        }
    }
    IFC42.IfcRelAggregates = IfcRelAggregates;
    class IfcRoofType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2781568857;
        }
    }
    IFC42.IfcRoofType = IfcRoofType;
    class IfcSanitaryTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1768891740;
        }
    }
    IFC42.IfcSanitaryTerminalType = IfcSanitaryTerminalType;
    class IfcSeamCurve extends IfcSurfaceCurve {
        constructor(Curve3D, AssociatedGeometry, MasterRepresentation){
            super(Curve3D, AssociatedGeometry, MasterRepresentation);
            this.Curve3D = Curve3D;
            this.AssociatedGeometry = AssociatedGeometry;
            this.MasterRepresentation = MasterRepresentation;
            this.type = 2157484638;
        }
    }
    IFC42.IfcSeamCurve = IfcSeamCurve;
    class IfcShadingDeviceType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4074543187;
        }
    }
    IFC42.IfcShadingDeviceType = IfcShadingDeviceType;
    class IfcSite extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.RefLatitude = RefLatitude;
            this.RefLongitude = RefLongitude;
            this.RefElevation = RefElevation;
            this.LandTitleNumber = LandTitleNumber;
            this.SiteAddress = SiteAddress;
            this.type = 4097777520;
        }
    }
    IFC42.IfcSite = IfcSite;
    class IfcSlabType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2533589738;
        }
    }
    IFC42.IfcSlabType = IfcSlabType;
    class IfcSolarDeviceType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1072016465;
        }
    }
    IFC42.IfcSolarDeviceType = IfcSolarDeviceType;
    class IfcSpace extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType, ElevationWithFlooring){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.PredefinedType = PredefinedType;
            this.ElevationWithFlooring = ElevationWithFlooring;
            this.type = 3856911033;
        }
    }
    IFC42.IfcSpace = IfcSpace;
    class IfcSpaceHeaterType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1305183839;
        }
    }
    IFC42.IfcSpaceHeaterType = IfcSpaceHeaterType;
    class IfcSpaceType extends IfcSpatialStructureElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.LongName = LongName;
            this.type = 3812236995;
        }
    }
    IFC42.IfcSpaceType = IfcSpaceType;
    class IfcStackTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3112655638;
        }
    }
    IFC42.IfcStackTerminalType = IfcStackTerminalType;
    class IfcStairFlightType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1039846685;
        }
    }
    IFC42.IfcStairFlightType = IfcStairFlightType;
    class IfcStairType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 338393293;
        }
    }
    IFC42.IfcStairType = IfcStairType;
    class IfcStructuralAction extends IfcStructuralActivity {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.type = 682877961;
        }
    }
    IFC42.IfcStructuralAction = IfcStructuralAction;
    class IfcStructuralConnection extends IfcStructuralItem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.type = 1179482911;
        }
    }
    IFC42.IfcStructuralConnection = IfcStructuralConnection;
    class IfcStructuralCurveAction extends IfcStructuralAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.PredefinedType = PredefinedType;
            this.type = 1004757350;
        }
    }
    IFC42.IfcStructuralCurveAction = IfcStructuralCurveAction;
    class IfcStructuralCurveConnection extends IfcStructuralConnection {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, Axis){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.Axis = Axis;
            this.type = 4243806635;
        }
    }
    IFC42.IfcStructuralCurveConnection = IfcStructuralCurveConnection;
    class IfcStructuralCurveMember extends IfcStructuralMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Axis = Axis;
            this.type = 214636428;
        }
    }
    IFC42.IfcStructuralCurveMember = IfcStructuralCurveMember;
    class IfcStructuralCurveMemberVarying extends IfcStructuralCurveMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Axis = Axis;
            this.type = 2445595289;
        }
    }
    IFC42.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;
    class IfcStructuralCurveReaction extends IfcStructuralReaction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.PredefinedType = PredefinedType;
            this.type = 2757150158;
        }
    }
    IFC42.IfcStructuralCurveReaction = IfcStructuralCurveReaction;
    class IfcStructuralLinearAction extends IfcStructuralCurveAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.PredefinedType = PredefinedType;
            this.type = 1807405624;
        }
    }
    IFC42.IfcStructuralLinearAction = IfcStructuralLinearAction;
    class IfcStructuralLoadGroup extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.ActionType = ActionType;
            this.ActionSource = ActionSource;
            this.Coefficient = Coefficient;
            this.Purpose = Purpose;
            this.type = 1252848954;
        }
    }
    IFC42.IfcStructuralLoadGroup = IfcStructuralLoadGroup;
    class IfcStructuralPointAction extends IfcStructuralAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.type = 2082059205;
        }
    }
    IFC42.IfcStructuralPointAction = IfcStructuralPointAction;
    class IfcStructuralPointConnection extends IfcStructuralConnection {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, ConditionCoordinateSystem){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.ConditionCoordinateSystem = ConditionCoordinateSystem;
            this.type = 734778138;
        }
    }
    IFC42.IfcStructuralPointConnection = IfcStructuralPointConnection;
    class IfcStructuralPointReaction extends IfcStructuralReaction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 1235345126;
        }
    }
    IFC42.IfcStructuralPointReaction = IfcStructuralPointReaction;
    class IfcStructuralResultGroup extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TheoryType = TheoryType;
            this.ResultForLoadGroup = ResultForLoadGroup;
            this.IsLinear = IsLinear;
            this.type = 2986769608;
        }
    }
    IFC42.IfcStructuralResultGroup = IfcStructuralResultGroup;
    class IfcStructuralSurfaceAction extends IfcStructuralAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.PredefinedType = PredefinedType;
            this.type = 3657597509;
        }
    }
    IFC42.IfcStructuralSurfaceAction = IfcStructuralSurfaceAction;
    class IfcStructuralSurfaceConnection extends IfcStructuralConnection {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.type = 1975003073;
        }
    }
    IFC42.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;
    class IfcSubContractResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 148013059;
        }
    }
    IFC42.IfcSubContractResource = IfcSubContractResource;
    class IfcSurfaceFeature extends IfcFeatureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3101698114;
        }
    }
    IFC42.IfcSurfaceFeature = IfcSurfaceFeature;
    class IfcSwitchingDeviceType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2315554128;
        }
    }
    IFC42.IfcSwitchingDeviceType = IfcSwitchingDeviceType;
    class IfcSystem extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 2254336722;
        }
    }
    IFC42.IfcSystem = IfcSystem;
    class IfcSystemFurnitureElement extends IfcFurnishingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 413509423;
        }
    }
    IFC42.IfcSystemFurnitureElement = IfcSystemFurnitureElement;
    class IfcTankType extends IfcFlowStorageDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 5716631;
        }
    }
    IFC42.IfcTankType = IfcTankType;
    class IfcTendon extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.PredefinedType = PredefinedType;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.TensionForce = TensionForce;
            this.PreStress = PreStress;
            this.FrictionCoefficient = FrictionCoefficient;
            this.AnchorageSlip = AnchorageSlip;
            this.MinCurvatureRadius = MinCurvatureRadius;
            this.type = 3824725483;
        }
    }
    IFC42.IfcTendon = IfcTendon;
    class IfcTendonAnchor extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.PredefinedType = PredefinedType;
            this.type = 2347447852;
        }
    }
    IFC42.IfcTendonAnchor = IfcTendonAnchor;
    class IfcTendonAnchorType extends IfcReinforcingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3081323446;
        }
    }
    IFC42.IfcTendonAnchorType = IfcTendonAnchorType;
    class IfcTendonType extends IfcReinforcingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, SheathDiameter){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.SheathDiameter = SheathDiameter;
            this.type = 2415094496;
        }
    }
    IFC42.IfcTendonType = IfcTendonType;
    class IfcTransformerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1692211062;
        }
    }
    IFC42.IfcTransformerType = IfcTransformerType;
    class IfcTransportElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1620046519;
        }
    }
    IFC42.IfcTransportElement = IfcTransportElement;
    class IfcTrimmedCurve extends IfcBoundedCurve {
        constructor(BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation){
            super();
            this.BasisCurve = BasisCurve;
            this.Trim1 = Trim1;
            this.Trim2 = Trim2;
            this.SenseAgreement = SenseAgreement;
            this.MasterRepresentation = MasterRepresentation;
            this.type = 3593883385;
        }
    }
    IFC42.IfcTrimmedCurve = IfcTrimmedCurve;
    class IfcTubeBundleType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1600972822;
        }
    }
    IFC42.IfcTubeBundleType = IfcTubeBundleType;
    class IfcUnitaryEquipmentType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1911125066;
        }
    }
    IFC42.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;
    class IfcValveType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 728799441;
        }
    }
    IFC42.IfcValveType = IfcValveType;
    class IfcVibrationIsolator extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2391383451;
        }
    }
    IFC42.IfcVibrationIsolator = IfcVibrationIsolator;
    class IfcVibrationIsolatorType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3313531582;
        }
    }
    IFC42.IfcVibrationIsolatorType = IfcVibrationIsolatorType;
    class IfcVirtualElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2769231204;
        }
    }
    IFC42.IfcVirtualElement = IfcVirtualElement;
    class IfcVoidingFeature extends IfcFeatureElementSubtraction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 926996030;
        }
    }
    IFC42.IfcVoidingFeature = IfcVoidingFeature;
    class IfcWallType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1898987631;
        }
    }
    IFC42.IfcWallType = IfcWallType;
    class IfcWasteTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1133259667;
        }
    }
    IFC42.IfcWasteTerminalType = IfcWasteTerminalType;
    class IfcWindowType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, PartitioningType, ParameterTakesPrecedence, UserDefinedPartitioningType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.PartitioningType = PartitioningType;
            this.ParameterTakesPrecedence = ParameterTakesPrecedence;
            this.UserDefinedPartitioningType = UserDefinedPartitioningType;
            this.type = 4009809668;
        }
    }
    IFC42.IfcWindowType = IfcWindowType;
    class IfcWorkCalendar extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, WorkingTimes, ExceptionTimes, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.WorkingTimes = WorkingTimes;
            this.ExceptionTimes = ExceptionTimes;
            this.PredefinedType = PredefinedType;
            this.type = 4088093105;
        }
    }
    IFC42.IfcWorkCalendar = IfcWorkCalendar;
    class IfcWorkControl extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.CreationDate = CreationDate;
            this.Creators = Creators;
            this.Purpose = Purpose;
            this.Duration = Duration;
            this.TotalFloat = TotalFloat;
            this.StartTime = StartTime;
            this.FinishTime = FinishTime;
            this.type = 1028945134;
        }
    }
    IFC42.IfcWorkControl = IfcWorkControl;
    class IfcWorkPlan extends IfcWorkControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.CreationDate = CreationDate;
            this.Creators = Creators;
            this.Purpose = Purpose;
            this.Duration = Duration;
            this.TotalFloat = TotalFloat;
            this.StartTime = StartTime;
            this.FinishTime = FinishTime;
            this.PredefinedType = PredefinedType;
            this.type = 4218914973;
        }
    }
    IFC42.IfcWorkPlan = IfcWorkPlan;
    class IfcWorkSchedule extends IfcWorkControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.CreationDate = CreationDate;
            this.Creators = Creators;
            this.Purpose = Purpose;
            this.Duration = Duration;
            this.TotalFloat = TotalFloat;
            this.StartTime = StartTime;
            this.FinishTime = FinishTime;
            this.PredefinedType = PredefinedType;
            this.type = 3342526732;
        }
    }
    IFC42.IfcWorkSchedule = IfcWorkSchedule;
    class IfcZone extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.type = 1033361043;
        }
    }
    IFC42.IfcZone = IfcZone;
    class IfcActionRequest extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.Status = Status;
            this.LongDescription = LongDescription;
            this.type = 3821786052;
        }
    }
    IFC42.IfcActionRequest = IfcActionRequest;
    class IfcAirTerminalBoxType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1411407467;
        }
    }
    IFC42.IfcAirTerminalBoxType = IfcAirTerminalBoxType;
    class IfcAirTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3352864051;
        }
    }
    IFC42.IfcAirTerminalType = IfcAirTerminalType;
    class IfcAirToAirHeatRecoveryType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1871374353;
        }
    }
    IFC42.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;
    class IfcAsset extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.OriginalValue = OriginalValue;
            this.CurrentValue = CurrentValue;
            this.TotalReplacementCost = TotalReplacementCost;
            this.Owner = Owner;
            this.User = User;
            this.ResponsiblePerson = ResponsiblePerson;
            this.IncorporationDate = IncorporationDate;
            this.DepreciatedValue = DepreciatedValue;
            this.type = 3460190687;
        }
    }
    IFC42.IfcAsset = IfcAsset;
    class IfcAudioVisualApplianceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1532957894;
        }
    }
    IFC42.IfcAudioVisualApplianceType = IfcAudioVisualApplianceType;
    class IfcBSplineCurve extends IfcBoundedCurve {
        constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect){
            super();
            this.Degree = Degree;
            this.ControlPointsList = ControlPointsList;
            this.CurveForm = CurveForm;
            this.ClosedCurve = ClosedCurve;
            this.SelfIntersect = SelfIntersect;
            this.type = 1967976161;
        }
    }
    IFC42.IfcBSplineCurve = IfcBSplineCurve;
    class IfcBSplineCurveWithKnots extends IfcBSplineCurve {
        constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec){
            super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
            this.Degree = Degree;
            this.ControlPointsList = ControlPointsList;
            this.CurveForm = CurveForm;
            this.ClosedCurve = ClosedCurve;
            this.SelfIntersect = SelfIntersect;
            this.KnotMultiplicities = KnotMultiplicities;
            this.Knots = Knots;
            this.KnotSpec = KnotSpec;
            this.type = 2461110595;
        }
    }
    IFC42.IfcBSplineCurveWithKnots = IfcBSplineCurveWithKnots;
    class IfcBeamType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 819618141;
        }
    }
    IFC42.IfcBeamType = IfcBeamType;
    class IfcBoilerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 231477066;
        }
    }
    IFC42.IfcBoilerType = IfcBoilerType;
    class IfcBoundaryCurve extends IfcCompositeCurveOnSurface {
        constructor(Segments, SelfIntersect){
            super(Segments, SelfIntersect);
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 1136057603;
        }
    }
    IFC42.IfcBoundaryCurve = IfcBoundaryCurve;
    class IfcBuildingElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3299480353;
        }
    }
    IFC42.IfcBuildingElement = IfcBuildingElement;
    class IfcBuildingElementPart extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2979338954;
        }
    }
    IFC42.IfcBuildingElementPart = IfcBuildingElementPart;
    class IfcBuildingElementPartType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 39481116;
        }
    }
    IFC42.IfcBuildingElementPartType = IfcBuildingElementPartType;
    class IfcBuildingElementProxy extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1095909175;
        }
    }
    IFC42.IfcBuildingElementProxy = IfcBuildingElementProxy;
    class IfcBuildingElementProxyType extends IfcBuildingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1909888760;
        }
    }
    IFC42.IfcBuildingElementProxyType = IfcBuildingElementProxyType;
    class IfcBuildingSystem extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.LongName = LongName;
            this.type = 1177604601;
        }
    }
    IFC42.IfcBuildingSystem = IfcBuildingSystem;
    class IfcBurnerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2188180465;
        }
    }
    IFC42.IfcBurnerType = IfcBurnerType;
    class IfcCableCarrierFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 395041908;
        }
    }
    IFC42.IfcCableCarrierFittingType = IfcCableCarrierFittingType;
    class IfcCableCarrierSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3293546465;
        }
    }
    IFC42.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;
    class IfcCableFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2674252688;
        }
    }
    IFC42.IfcCableFittingType = IfcCableFittingType;
    class IfcCableSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1285652485;
        }
    }
    IFC42.IfcCableSegmentType = IfcCableSegmentType;
    class IfcChillerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2951183804;
        }
    }
    IFC42.IfcChillerType = IfcChillerType;
    class IfcChimney extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3296154744;
        }
    }
    IFC42.IfcChimney = IfcChimney;
    class IfcCircle extends IfcConic {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 2611217952;
        }
    }
    IFC42.IfcCircle = IfcCircle;
    class IfcCivilElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1677625105;
        }
    }
    IFC42.IfcCivilElement = IfcCivilElement;
    class IfcCoilType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2301859152;
        }
    }
    IFC42.IfcCoilType = IfcCoilType;
    class IfcColumn extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 843113511;
        }
    }
    IFC42.IfcColumn = IfcColumn;
    class IfcColumnStandardCase extends IfcColumn {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 905975707;
        }
    }
    IFC42.IfcColumnStandardCase = IfcColumnStandardCase;
    class IfcCommunicationsApplianceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 400855858;
        }
    }
    IFC42.IfcCommunicationsApplianceType = IfcCommunicationsApplianceType;
    class IfcCompressorType extends IfcFlowMovingDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3850581409;
        }
    }
    IFC42.IfcCompressorType = IfcCompressorType;
    class IfcCondenserType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2816379211;
        }
    }
    IFC42.IfcCondenserType = IfcCondenserType;
    class IfcConstructionEquipmentResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 3898045240;
        }
    }
    IFC42.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;
    class IfcConstructionMaterialResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 1060000209;
        }
    }
    IFC42.IfcConstructionMaterialResource = IfcConstructionMaterialResource;
    class IfcConstructionProductResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 488727124;
        }
    }
    IFC42.IfcConstructionProductResource = IfcConstructionProductResource;
    class IfcCooledBeamType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 335055490;
        }
    }
    IFC42.IfcCooledBeamType = IfcCooledBeamType;
    class IfcCoolingTowerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2954562838;
        }
    }
    IFC42.IfcCoolingTowerType = IfcCoolingTowerType;
    class IfcCovering extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1973544240;
        }
    }
    IFC42.IfcCovering = IfcCovering;
    class IfcCurtainWall extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3495092785;
        }
    }
    IFC42.IfcCurtainWall = IfcCurtainWall;
    class IfcDamperType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3961806047;
        }
    }
    IFC42.IfcDamperType = IfcDamperType;
    class IfcDiscreteAccessory extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1335981549;
        }
    }
    IFC42.IfcDiscreteAccessory = IfcDiscreteAccessory;
    class IfcDiscreteAccessoryType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2635815018;
        }
    }
    IFC42.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;
    class IfcDistributionChamberElementType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1599208980;
        }
    }
    IFC42.IfcDistributionChamberElementType = IfcDistributionChamberElementType;
    class IfcDistributionControlElementType extends IfcDistributionElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2063403501;
        }
    }
    IFC42.IfcDistributionControlElementType = IfcDistributionControlElementType;
    class IfcDistributionElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1945004755;
        }
    }
    IFC42.IfcDistributionElement = IfcDistributionElement;
    class IfcDistributionFlowElement extends IfcDistributionElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3040386961;
        }
    }
    IFC42.IfcDistributionFlowElement = IfcDistributionFlowElement;
    class IfcDistributionPort extends IfcPort {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection, PredefinedType, SystemType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.FlowDirection = FlowDirection;
            this.PredefinedType = PredefinedType;
            this.SystemType = SystemType;
            this.type = 3041715199;
        }
    }
    IFC42.IfcDistributionPort = IfcDistributionPort;
    class IfcDistributionSystem extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.PredefinedType = PredefinedType;
            this.type = 3205830791;
        }
    }
    IFC42.IfcDistributionSystem = IfcDistributionSystem;
    class IfcDoor extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.OverallHeight = OverallHeight;
            this.OverallWidth = OverallWidth;
            this.PredefinedType = PredefinedType;
            this.OperationType = OperationType;
            this.UserDefinedOperationType = UserDefinedOperationType;
            this.type = 395920057;
        }
    }
    IFC42.IfcDoor = IfcDoor;
    class IfcDoorStandardCase extends IfcDoor {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.OverallHeight = OverallHeight;
            this.OverallWidth = OverallWidth;
            this.PredefinedType = PredefinedType;
            this.OperationType = OperationType;
            this.UserDefinedOperationType = UserDefinedOperationType;
            this.type = 3242481149;
        }
    }
    IFC42.IfcDoorStandardCase = IfcDoorStandardCase;
    class IfcDuctFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 869906466;
        }
    }
    IFC42.IfcDuctFittingType = IfcDuctFittingType;
    class IfcDuctSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3760055223;
        }
    }
    IFC42.IfcDuctSegmentType = IfcDuctSegmentType;
    class IfcDuctSilencerType extends IfcFlowTreatmentDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2030761528;
        }
    }
    IFC42.IfcDuctSilencerType = IfcDuctSilencerType;
    class IfcElectricApplianceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 663422040;
        }
    }
    IFC42.IfcElectricApplianceType = IfcElectricApplianceType;
    class IfcElectricDistributionBoardType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2417008758;
        }
    }
    IFC42.IfcElectricDistributionBoardType = IfcElectricDistributionBoardType;
    class IfcElectricFlowStorageDeviceType extends IfcFlowStorageDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3277789161;
        }
    }
    IFC42.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;
    class IfcElectricGeneratorType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1534661035;
        }
    }
    IFC42.IfcElectricGeneratorType = IfcElectricGeneratorType;
    class IfcElectricMotorType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1217240411;
        }
    }
    IFC42.IfcElectricMotorType = IfcElectricMotorType;
    class IfcElectricTimeControlType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 712377611;
        }
    }
    IFC42.IfcElectricTimeControlType = IfcElectricTimeControlType;
    class IfcEnergyConversionDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1658829314;
        }
    }
    IFC42.IfcEnergyConversionDevice = IfcEnergyConversionDevice;
    class IfcEngine extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2814081492;
        }
    }
    IFC42.IfcEngine = IfcEngine;
    class IfcEvaporativeCooler extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3747195512;
        }
    }
    IFC42.IfcEvaporativeCooler = IfcEvaporativeCooler;
    class IfcEvaporator extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 484807127;
        }
    }
    IFC42.IfcEvaporator = IfcEvaporator;
    class IfcExternalSpatialElement extends IfcExternalSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.PredefinedType = PredefinedType;
            this.type = 1209101575;
        }
    }
    IFC42.IfcExternalSpatialElement = IfcExternalSpatialElement;
    class IfcFanType extends IfcFlowMovingDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 346874300;
        }
    }
    IFC42.IfcFanType = IfcFanType;
    class IfcFilterType extends IfcFlowTreatmentDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1810631287;
        }
    }
    IFC42.IfcFilterType = IfcFilterType;
    class IfcFireSuppressionTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4222183408;
        }
    }
    IFC42.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;
    class IfcFlowController extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2058353004;
        }
    }
    IFC42.IfcFlowController = IfcFlowController;
    class IfcFlowFitting extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 4278956645;
        }
    }
    IFC42.IfcFlowFitting = IfcFlowFitting;
    class IfcFlowInstrumentType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4037862832;
        }
    }
    IFC42.IfcFlowInstrumentType = IfcFlowInstrumentType;
    class IfcFlowMeter extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2188021234;
        }
    }
    IFC42.IfcFlowMeter = IfcFlowMeter;
    class IfcFlowMovingDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3132237377;
        }
    }
    IFC42.IfcFlowMovingDevice = IfcFlowMovingDevice;
    class IfcFlowSegment extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 987401354;
        }
    }
    IFC42.IfcFlowSegment = IfcFlowSegment;
    class IfcFlowStorageDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 707683696;
        }
    }
    IFC42.IfcFlowStorageDevice = IfcFlowStorageDevice;
    class IfcFlowTerminal extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2223149337;
        }
    }
    IFC42.IfcFlowTerminal = IfcFlowTerminal;
    class IfcFlowTreatmentDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3508470533;
        }
    }
    IFC42.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;
    class IfcFooting extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 900683007;
        }
    }
    IFC42.IfcFooting = IfcFooting;
    class IfcHeatExchanger extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3319311131;
        }
    }
    IFC42.IfcHeatExchanger = IfcHeatExchanger;
    class IfcHumidifier extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2068733104;
        }
    }
    IFC42.IfcHumidifier = IfcHumidifier;
    class IfcInterceptor extends IfcFlowTreatmentDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4175244083;
        }
    }
    IFC42.IfcInterceptor = IfcInterceptor;
    class IfcJunctionBox extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2176052936;
        }
    }
    IFC42.IfcJunctionBox = IfcJunctionBox;
    class IfcLamp extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 76236018;
        }
    }
    IFC42.IfcLamp = IfcLamp;
    class IfcLightFixture extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 629592764;
        }
    }
    IFC42.IfcLightFixture = IfcLightFixture;
    class IfcMedicalDevice extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1437502449;
        }
    }
    IFC42.IfcMedicalDevice = IfcMedicalDevice;
    class IfcMember extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1073191201;
        }
    }
    IFC42.IfcMember = IfcMember;
    class IfcMemberStandardCase extends IfcMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1911478936;
        }
    }
    IFC42.IfcMemberStandardCase = IfcMemberStandardCase;
    class IfcMotorConnection extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2474470126;
        }
    }
    IFC42.IfcMotorConnection = IfcMotorConnection;
    class IfcOuterBoundaryCurve extends IfcBoundaryCurve {
        constructor(Segments, SelfIntersect){
            super(Segments, SelfIntersect);
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 144952367;
        }
    }
    IFC42.IfcOuterBoundaryCurve = IfcOuterBoundaryCurve;
    class IfcOutlet extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3694346114;
        }
    }
    IFC42.IfcOutlet = IfcOutlet;
    class IfcPile extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.ConstructionType = ConstructionType;
            this.type = 1687234759;
        }
    }
    IFC42.IfcPile = IfcPile;
    class IfcPipeFitting extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 310824031;
        }
    }
    IFC42.IfcPipeFitting = IfcPipeFitting;
    class IfcPipeSegment extends IfcFlowSegment {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3612865200;
        }
    }
    IFC42.IfcPipeSegment = IfcPipeSegment;
    class IfcPlate extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3171933400;
        }
    }
    IFC42.IfcPlate = IfcPlate;
    class IfcPlateStandardCase extends IfcPlate {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1156407060;
        }
    }
    IFC42.IfcPlateStandardCase = IfcPlateStandardCase;
    class IfcProtectiveDevice extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 738039164;
        }
    }
    IFC42.IfcProtectiveDevice = IfcProtectiveDevice;
    class IfcProtectiveDeviceTrippingUnitType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 655969474;
        }
    }
    IFC42.IfcProtectiveDeviceTrippingUnitType = IfcProtectiveDeviceTrippingUnitType;
    class IfcPump extends IfcFlowMovingDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 90941305;
        }
    }
    IFC42.IfcPump = IfcPump;
    class IfcRailing extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2262370178;
        }
    }
    IFC42.IfcRailing = IfcRailing;
    class IfcRamp extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3024970846;
        }
    }
    IFC42.IfcRamp = IfcRamp;
    class IfcRampFlight extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3283111854;
        }
    }
    IFC42.IfcRampFlight = IfcRampFlight;
    class IfcRationalBSplineCurveWithKnots extends IfcBSplineCurveWithKnots {
        constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec, WeightsData){
            super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec);
            this.Degree = Degree;
            this.ControlPointsList = ControlPointsList;
            this.CurveForm = CurveForm;
            this.ClosedCurve = ClosedCurve;
            this.SelfIntersect = SelfIntersect;
            this.KnotMultiplicities = KnotMultiplicities;
            this.Knots = Knots;
            this.KnotSpec = KnotSpec;
            this.WeightsData = WeightsData;
            this.type = 1232101972;
        }
    }
    IFC42.IfcRationalBSplineCurveWithKnots = IfcRationalBSplineCurveWithKnots;
    class IfcReinforcingBar extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, PredefinedType, BarSurface){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.BarLength = BarLength;
            this.PredefinedType = PredefinedType;
            this.BarSurface = BarSurface;
            this.type = 979691226;
        }
    }
    IFC42.IfcReinforcingBar = IfcReinforcingBar;
    class IfcReinforcingBarType extends IfcReinforcingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, BarLength, BarSurface, BendingShapeCode, BendingParameters){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.BarLength = BarLength;
            this.BarSurface = BarSurface;
            this.BendingShapeCode = BendingShapeCode;
            this.BendingParameters = BendingParameters;
            this.type = 2572171363;
        }
    }
    IFC42.IfcReinforcingBarType = IfcReinforcingBarType;
    class IfcRoof extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2016517767;
        }
    }
    IFC42.IfcRoof = IfcRoof;
    class IfcSanitaryTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3053780830;
        }
    }
    IFC42.IfcSanitaryTerminal = IfcSanitaryTerminal;
    class IfcSensorType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1783015770;
        }
    }
    IFC42.IfcSensorType = IfcSensorType;
    class IfcShadingDevice extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1329646415;
        }
    }
    IFC42.IfcShadingDevice = IfcShadingDevice;
    class IfcSlab extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1529196076;
        }
    }
    IFC42.IfcSlab = IfcSlab;
    class IfcSlabElementedCase extends IfcSlab {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3127900445;
        }
    }
    IFC42.IfcSlabElementedCase = IfcSlabElementedCase;
    class IfcSlabStandardCase extends IfcSlab {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3027962421;
        }
    }
    IFC42.IfcSlabStandardCase = IfcSlabStandardCase;
    class IfcSolarDevice extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3420628829;
        }
    }
    IFC42.IfcSolarDevice = IfcSolarDevice;
    class IfcSpaceHeater extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1999602285;
        }
    }
    IFC42.IfcSpaceHeater = IfcSpaceHeater;
    class IfcStackTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1404847402;
        }
    }
    IFC42.IfcStackTerminal = IfcStackTerminal;
    class IfcStair extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 331165859;
        }
    }
    IFC42.IfcStair = IfcStair;
    class IfcStairFlight extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRisers, NumberOfTreads, RiserHeight, TreadLength, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.NumberOfRisers = NumberOfRisers;
            this.NumberOfTreads = NumberOfTreads;
            this.RiserHeight = RiserHeight;
            this.TreadLength = TreadLength;
            this.PredefinedType = PredefinedType;
            this.type = 4252922144;
        }
    }
    IFC42.IfcStairFlight = IfcStairFlight;
    class IfcStructuralAnalysisModel extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults, SharedPlacement){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.OrientationOf2DPlane = OrientationOf2DPlane;
            this.LoadedBy = LoadedBy;
            this.HasResults = HasResults;
            this.SharedPlacement = SharedPlacement;
            this.type = 2515109513;
        }
    }
    IFC42.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;
    class IfcStructuralLoadCase extends IfcStructuralLoadGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose, SelfWeightCoefficients){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.ActionType = ActionType;
            this.ActionSource = ActionSource;
            this.Coefficient = Coefficient;
            this.Purpose = Purpose;
            this.SelfWeightCoefficients = SelfWeightCoefficients;
            this.type = 385403989;
        }
    }
    IFC42.IfcStructuralLoadCase = IfcStructuralLoadCase;
    class IfcStructuralPlanarAction extends IfcStructuralSurfaceAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.PredefinedType = PredefinedType;
            this.type = 1621171031;
        }
    }
    IFC42.IfcStructuralPlanarAction = IfcStructuralPlanarAction;
    class IfcSwitchingDevice extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1162798199;
        }
    }
    IFC42.IfcSwitchingDevice = IfcSwitchingDevice;
    class IfcTank extends IfcFlowStorageDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 812556717;
        }
    }
    IFC42.IfcTank = IfcTank;
    class IfcTransformer extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3825984169;
        }
    }
    IFC42.IfcTransformer = IfcTransformer;
    class IfcTubeBundle extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3026737570;
        }
    }
    IFC42.IfcTubeBundle = IfcTubeBundle;
    class IfcUnitaryControlElementType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3179687236;
        }
    }
    IFC42.IfcUnitaryControlElementType = IfcUnitaryControlElementType;
    class IfcUnitaryEquipment extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4292641817;
        }
    }
    IFC42.IfcUnitaryEquipment = IfcUnitaryEquipment;
    class IfcValve extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4207607924;
        }
    }
    IFC42.IfcValve = IfcValve;
    class IfcWall extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2391406946;
        }
    }
    IFC42.IfcWall = IfcWall;
    class IfcWallElementedCase extends IfcWall {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4156078855;
        }
    }
    IFC42.IfcWallElementedCase = IfcWallElementedCase;
    class IfcWallStandardCase extends IfcWall {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3512223829;
        }
    }
    IFC42.IfcWallStandardCase = IfcWallStandardCase;
    class IfcWasteTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4237592921;
        }
    }
    IFC42.IfcWasteTerminal = IfcWasteTerminal;
    class IfcWindow extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.OverallHeight = OverallHeight;
            this.OverallWidth = OverallWidth;
            this.PredefinedType = PredefinedType;
            this.PartitioningType = PartitioningType;
            this.UserDefinedPartitioningType = UserDefinedPartitioningType;
            this.type = 3304561284;
        }
    }
    IFC42.IfcWindow = IfcWindow;
    class IfcWindowStandardCase extends IfcWindow {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.OverallHeight = OverallHeight;
            this.OverallWidth = OverallWidth;
            this.PredefinedType = PredefinedType;
            this.PartitioningType = PartitioningType;
            this.UserDefinedPartitioningType = UserDefinedPartitioningType;
            this.type = 486154966;
        }
    }
    IFC42.IfcWindowStandardCase = IfcWindowStandardCase;
    class IfcActuatorType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2874132201;
        }
    }
    IFC42.IfcActuatorType = IfcActuatorType;
    class IfcAirTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1634111441;
        }
    }
    IFC42.IfcAirTerminal = IfcAirTerminal;
    class IfcAirTerminalBox extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 177149247;
        }
    }
    IFC42.IfcAirTerminalBox = IfcAirTerminalBox;
    class IfcAirToAirHeatRecovery extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2056796094;
        }
    }
    IFC42.IfcAirToAirHeatRecovery = IfcAirToAirHeatRecovery;
    class IfcAlarmType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3001207471;
        }
    }
    IFC42.IfcAlarmType = IfcAlarmType;
    class IfcAudioVisualAppliance extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 277319702;
        }
    }
    IFC42.IfcAudioVisualAppliance = IfcAudioVisualAppliance;
    class IfcBeam extends IfcBuildingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 753842376;
        }
    }
    IFC42.IfcBeam = IfcBeam;
    class IfcBeamStandardCase extends IfcBeam {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2906023776;
        }
    }
    IFC42.IfcBeamStandardCase = IfcBeamStandardCase;
    class IfcBoiler extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 32344328;
        }
    }
    IFC42.IfcBoiler = IfcBoiler;
    class IfcBurner extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2938176219;
        }
    }
    IFC42.IfcBurner = IfcBurner;
    class IfcCableCarrierFitting extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 635142910;
        }
    }
    IFC42.IfcCableCarrierFitting = IfcCableCarrierFitting;
    class IfcCableCarrierSegment extends IfcFlowSegment {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3758799889;
        }
    }
    IFC42.IfcCableCarrierSegment = IfcCableCarrierSegment;
    class IfcCableFitting extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1051757585;
        }
    }
    IFC42.IfcCableFitting = IfcCableFitting;
    class IfcCableSegment extends IfcFlowSegment {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4217484030;
        }
    }
    IFC42.IfcCableSegment = IfcCableSegment;
    class IfcChiller extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3902619387;
        }
    }
    IFC42.IfcChiller = IfcChiller;
    class IfcCoil extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 639361253;
        }
    }
    IFC42.IfcCoil = IfcCoil;
    class IfcCommunicationsAppliance extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3221913625;
        }
    }
    IFC42.IfcCommunicationsAppliance = IfcCommunicationsAppliance;
    class IfcCompressor extends IfcFlowMovingDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3571504051;
        }
    }
    IFC42.IfcCompressor = IfcCompressor;
    class IfcCondenser extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2272882330;
        }
    }
    IFC42.IfcCondenser = IfcCondenser;
    class IfcControllerType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 578613899;
        }
    }
    IFC42.IfcControllerType = IfcControllerType;
    class IfcCooledBeam extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4136498852;
        }
    }
    IFC42.IfcCooledBeam = IfcCooledBeam;
    class IfcCoolingTower extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3640358203;
        }
    }
    IFC42.IfcCoolingTower = IfcCoolingTower;
    class IfcDamper extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4074379575;
        }
    }
    IFC42.IfcDamper = IfcDamper;
    class IfcDistributionChamberElement extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1052013943;
        }
    }
    IFC42.IfcDistributionChamberElement = IfcDistributionChamberElement;
    class IfcDistributionCircuit extends IfcDistributionSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.PredefinedType = PredefinedType;
            this.type = 562808652;
        }
    }
    IFC42.IfcDistributionCircuit = IfcDistributionCircuit;
    class IfcDistributionControlElement extends IfcDistributionElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1062813311;
        }
    }
    IFC42.IfcDistributionControlElement = IfcDistributionControlElement;
    class IfcDuctFitting extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 342316401;
        }
    }
    IFC42.IfcDuctFitting = IfcDuctFitting;
    class IfcDuctSegment extends IfcFlowSegment {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3518393246;
        }
    }
    IFC42.IfcDuctSegment = IfcDuctSegment;
    class IfcDuctSilencer extends IfcFlowTreatmentDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1360408905;
        }
    }
    IFC42.IfcDuctSilencer = IfcDuctSilencer;
    class IfcElectricAppliance extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1904799276;
        }
    }
    IFC42.IfcElectricAppliance = IfcElectricAppliance;
    class IfcElectricDistributionBoard extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 862014818;
        }
    }
    IFC42.IfcElectricDistributionBoard = IfcElectricDistributionBoard;
    class IfcElectricFlowStorageDevice extends IfcFlowStorageDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3310460725;
        }
    }
    IFC42.IfcElectricFlowStorageDevice = IfcElectricFlowStorageDevice;
    class IfcElectricGenerator extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 264262732;
        }
    }
    IFC42.IfcElectricGenerator = IfcElectricGenerator;
    class IfcElectricMotor extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 402227799;
        }
    }
    IFC42.IfcElectricMotor = IfcElectricMotor;
    class IfcElectricTimeControl extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1003880860;
        }
    }
    IFC42.IfcElectricTimeControl = IfcElectricTimeControl;
    class IfcFan extends IfcFlowMovingDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3415622556;
        }
    }
    IFC42.IfcFan = IfcFan;
    class IfcFilter extends IfcFlowTreatmentDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 819412036;
        }
    }
    IFC42.IfcFilter = IfcFilter;
    class IfcFireSuppressionTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1426591983;
        }
    }
    IFC42.IfcFireSuppressionTerminal = IfcFireSuppressionTerminal;
    class IfcFlowInstrument extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 182646315;
        }
    }
    IFC42.IfcFlowInstrument = IfcFlowInstrument;
    class IfcProtectiveDeviceTrippingUnit extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2295281155;
        }
    }
    IFC42.IfcProtectiveDeviceTrippingUnit = IfcProtectiveDeviceTrippingUnit;
    class IfcSensor extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4086658281;
        }
    }
    IFC42.IfcSensor = IfcSensor;
    class IfcUnitaryControlElement extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 630975310;
        }
    }
    IFC42.IfcUnitaryControlElement = IfcUnitaryControlElement;
    class IfcActuator extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4288193352;
        }
    }
    IFC42.IfcActuator = IfcActuator;
    class IfcAlarm extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3087945054;
        }
    }
    IFC42.IfcAlarm = IfcAlarm;
    class IfcController extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 25142252;
        }
    }
    IFC42.IfcController = IfcController;
})($3b8da494b8e92f36$export$8167db95e5b199ea || ($3b8da494b8e92f36$export$8167db95e5b199ea = {}));
$3b8da494b8e92f36$export$a6870f5c6ab054f9[3] = [
    "IFC4X3",
    "IFC4X1",
    "IFC4X2",
    "IFC4X3_RC3",
    "IFC4X3_RC4",
    "IFC4X3_RC1",
    "IFC4X3_RC2",
    "IFC4X3_ADD2",
    "IFC4X3_ADD1"
];
$3b8da494b8e92f36$export$6c6c405ef9389ced[3] = {
    3630933823: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActorRole(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    618182010: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAddress(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2879124712: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentParameterSegment((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3633395639: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentVerticalSegment((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRatioMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRatioMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    639542469: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcApplication(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    411424972: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAppliedValue((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    130549933: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcApproval((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    4037036970: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1560379544: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryEdgeCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[6])),
    3367102660: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryFaceCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3])),
    1387855156: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryNodeCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[6])),
    2069777674: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryNodeConditionWarping((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[7])),
    2859738748: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionGeometry(),
    2614616156: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionPointGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    2732653382: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionSurfaceGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    775493141: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionVolumeGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    1959218052: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstraint(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1785450214: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoordinateOperation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    1466758467: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoordinateReferenceSystem((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    602808272: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCostValue((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1765591967: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDerivedUnit(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1045800335: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDerivedUnitElement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 10)),
    2949456006: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDimensionalExponents(new $3b8da494b8e92f36$export$2e483f5afea275bb((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 10), new $3b8da494b8e92f36$export$2e483f5afea275bb((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 10)),
    4294318154: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalInformation(),
    3200245327: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2242383968: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternallyDefinedHatchStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1040185647: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternallyDefinedSurfaceStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3548104201: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternallyDefinedTextFont((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    917726184: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeographicCRS((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    852622518: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGridAxis((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3020489413: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIrregularTimeSeriesValue(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || []),
    2655187982: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLibraryInformation(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3452421091: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLibraryReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLanguageId((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    4162380809: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightDistributionData(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure(p.value) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLuminousIntensityDistributionMeasure(p.value) : null) || []),
    1566485204: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightIntensityDistribution(v[0], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3057273783: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMapConversion(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4105526436: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMapConversionScaled(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    1847130766: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialClassificationRelationship(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    760658860: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialDefinition(),
    248100487: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialLayer((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    3303938423: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialLayerSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1847252529: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialLayerWithOffsets((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2199411900: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialList(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2235152071: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfile((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    164193824: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfileSet((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    552965576: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfileWithOffsets((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1507914824: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialUsageDefinition(),
    2597039031: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMeasureWithUnit($3b8da494b8e92f36$var$TypeInitialiser(3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    3368373690: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMetric(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10])),
    2706619895: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMonetaryUnit(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1918398963: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNamedUnit(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]),
    3701648758: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcObjectPlacement((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    2251480897: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcObjective(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[8], v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    4251960020: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOrganization((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1207048766: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOwnerHistory(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), v[2], v[3], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeStamp((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeStamp((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2077209135: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPerson((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    101040310: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPersonAndOrganization(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2483315170: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPhysicalQuantity(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2226359599: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPhysicalSimpleQuantity(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    3355820592: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPostalAddress(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    677532197: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentationItem(),
    2022622350: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentationLayerAssignment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1304840413: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentationLayerWithStyle(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3119450353: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentationStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2095639259: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProductRepresentation((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3958567839: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3843373140: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProjectedCRS((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    986844984: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyAbstraction(),
    3710013099: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyEnumeration(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    2044713172: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityArea(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2093928680: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityCount(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCountMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    931644368: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityLength(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2691318326: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityNumber(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNumericMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3252649465: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityTime(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2405470396: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityVolume(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVolumeMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    825690147: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityWeight(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMassMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3915482550: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRecurrencePattern(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDayInMonthNumber(p.value) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDayInWeekNumber(p.value) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMonthInYearNumber(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2433181523: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    1076942058: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3377609919: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRepresentationContext((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3008791417: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRepresentationItem(),
    1660063152: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRepresentationMap(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    2439245199: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResourceLevelRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1794013214: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRigidOperation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), $3b8da494b8e92f36$var$TypeInitialiser(3, v[2]), $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2341007311: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoot(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    448429030: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSIUnit(v[0], v[1], v[2]),
    1054537805: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSchedulingTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    867548509: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShapeAspect(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    3982875396: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShapeModel(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    4240577450: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShapeRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2273995522: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralConnectionCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2162789131: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoad((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3478079324: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadConfiguration((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure(p2.value) : null) || [])),
    609421318: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadOrResult((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2525727697: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadStatic((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3408363356: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadTemperature((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermodynamicTemperatureMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermodynamicTemperatureMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermodynamicTemperatureMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2830218821: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStyleModel(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3958052878: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStyledItem((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3049322572: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStyledRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2934153892: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceReinforcementArea((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure(p.value) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure(p.value) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1300840506: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3303107099: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleLighting(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    1607154358: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleRefraction((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    846575682: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleShading(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1351298697: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleWithTextures(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    626085974: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceTexture(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier(p.value) : null) || []),
    985171141: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTable((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2043862942: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTableColumn((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    531007025: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTableRow((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || [], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1549132990: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTaskTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value), (v[19] ?? void 0) === void 0 || v[19] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[19] ?? void 0) === void 0 || v[19] === "" ? null : v[19].value)),
    2771591690: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTaskTimeRecurring((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value), (v[19] ?? void 0) === void 0 || v[19] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[19] ?? void 0) === void 0 || v[19] === "" ? null : v[19].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[20] ?? void 0) === void 0 || v[20] === "" ? null : v[20].value, 3, v[20])),
    912023232: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTelecomAddress(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference(p.value) : null) || []),
    1447204868: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2636378356: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextStyleForDefinedFont(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    1640371178: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextStyleTextModel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextAlignment((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextDecoration((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextTransformation((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[6])),
    280115917: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureCoordinate(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1742049831: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureCoordinateGenerator(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal(p.value) : null) || []),
    222769930: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureCoordinateIndices(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p.value) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    1010789467: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureCoordinateIndicesWithVoids(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p.value) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), v[2]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p2.value) : null) || [])),
    2552916305: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureMap(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    1210645708: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureVertex(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p.value) : null) || []),
    3611470254: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureVertexList(v[0]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p2.value) : null) || [])),
    1199560280: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimePeriod(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTime((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3101149627: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeSeries(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7])),
    581633288: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeSeriesValue(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || []),
    1377556343: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTopologicalRepresentationItem(),
    1735638870: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTopologyRepresentation(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    180925521: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitAssignment(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2799835756: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVertex(),
    1907098498: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVertexPoint(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    891718957: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVirtualGridIntersection(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure(p.value) : null) || []),
    1175146630: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWellKnownText(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWellKnownTextLiteral((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    1236880293: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3752311538: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentCantSegment((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    536804194: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentHorizontalSegment((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3869604511: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcApprovalRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3798115385: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcArbitraryClosedProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    1310608509: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcArbitraryOpenProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    2705031697: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcArbitraryProfileDefWithVoids(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    616511568: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBlobTexture(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier(p.value) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBinary((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    3150382593: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCenterLineProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    747523909: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcClassification((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier(p.value) : null) || []),
    647927063: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcClassificationReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3285139300: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColourRgbList(v[0]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure(p2.value) : null) || [])),
    3264961684: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColourSpecification((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1485152156: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompositeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    370225590: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectedFaceSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1981873012: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionCurveGeometry(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    45288368: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionPointEccentricity(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3050246964: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcContextDependentUnit(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2889183280: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConversionBasedUnit(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    2713554722: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConversionBasedUnitWithOffset(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    539742890: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurrencyRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    3800577675: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1105321065: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveStyleFont((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2367409068: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveStyleFontAndScaling((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3510044353: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveStyleFontPattern(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3632507154: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDerivedProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1154170062: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDocumentInformation(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), v[15], v[16]),
    770865208: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDocumentInformationRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3732053477: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDocumentReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    3900360178: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEdge(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    476780140: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEdgeCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    211053100: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEventTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    297599258: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExtendedProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1437805879: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalReferenceRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2556980723: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFace(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1809719519: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFaceBound(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    803316827: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFaceOuterBound(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3008276851: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFaceSurface(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    4219587988: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFailureConnectionCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    738692330: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFillAreaStyle((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3448662350: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricRepresentationContext((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDimensionCount((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    2453401579: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricRepresentationItem(),
    4142052618: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricRepresentationSubContext((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3590301190: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    178086475: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGridPlacement((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    812098782: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHalfSpaceSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3905492369: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcImageTexture(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier(p.value) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3570813810: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedColourMap(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p.value) : null) || []),
    1437953363: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedTextureMap(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    2133299955: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedTriangleTextureMap(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p2.value) : null) || [])),
    3741457305: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIrregularTimeSeries(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1585845231: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLagTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), v[4]),
    1402838566: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSource((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    125510826: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourceAmbient((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2604431987: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourceDirectional((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    4266656042: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourceGoniometric((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermodynamicTemperatureMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLuminousFluxMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9])),
    1520743889: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourcePositional((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3422422726: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourceSpot((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositivePlaneAngleMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositivePlaneAngleMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    388784114: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearPlacement((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    2624227202: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLocalPlacement((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    1008929658: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLoop(),
    2347385850: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMappedItem(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    1838606355: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterial(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3708119e3: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialConstituent((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2852063980: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialConstituentSet((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2022407955: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialDefinitionRepresentation((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    1303795690: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialLayerSetUsage(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1], v[2], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3079605661: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfileSetUsage(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCardinalPointReference((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3404854881: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfileSetUsageTapering(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCardinalPointReference((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCardinalPointReference((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3265635763: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    853536259: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2998442950: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMirroredProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    219451334: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcObjectDefinition(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    182550632: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOpenCrossProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure(p.value) : null) || [], v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure(p.value) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    2665983363: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOpenShell(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1411181986: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOrganizationRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1029017970: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOrientedEdge(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2529465313: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterizedProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    2519244187: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPath(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3021840470: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPhysicalComplexQuantity(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    597895409: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPixelTexture(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier(p.value) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBinary(p.value) : null) || []),
    2004835150: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlacement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    1663979128: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlanarExtent(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2067069095: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPoint(),
    2165702409: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPointByDistanceExpression($3b8da494b8e92f36$var$TypeInitialiser(3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    4022376103: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPointOnCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1423911732: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPointOnSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2924175390: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolyLoop(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2775532180: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolygonalBoundedHalfSpace(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    3727388367: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedItem(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3778827333: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedProperties(),
    1775413392: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedTextFont(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    673634403: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProductDefinitionShape((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2802850158: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProfileProperties((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    2598011224: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProperty(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1680319473: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyDefinition(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    148025276: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyDependencyRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3357820518: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertySetDefinition(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1482703590: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyTemplateDefinition(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2090586900: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantitySet(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3615266464: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRectangleProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3413951693: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRegularTimeSeries(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1580146022: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcementBarProperties(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCountMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    478536968: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelationship(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2943643501: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResourceApprovalRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    1608871552: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResourceConstraintRelationship((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1042787934: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResourceTime((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value)),
    2778083089: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoundedRectangleProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    2042790032: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionProperties(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    4165799628: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionReinforcementProperties(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1509187699: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionedSpine(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    823603102: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSegment(v[0]),
    4124623270: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShellBasedSurfaceModel(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3692461612: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSimpleProperty(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2609359061: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSlippageConnectionCondition((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    723233188: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSolidModel(),
    1595516126: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadLinearForce((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearMomentMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearMomentMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearMomentMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    2668620305: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadPlanarForce((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlanarForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlanarForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlanarForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2473145415: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadSingleDisplacement((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1973038258: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadSingleDisplacementDistortion((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurvatureMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1597423693: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadSingleForce((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTorqueMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTorqueMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTorqueMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1190533807: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadSingleForceWarping((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTorqueMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTorqueMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTorqueMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWarpingMomentMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2233826070: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSubedge(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    2513912981: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurface(),
    1878645084: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleRendering(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[7]), v[8]),
    2247615214: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    1260650574: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSweptDiskSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1096409881: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSweptDiskSolidPolygonal(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    230924584: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSweptSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    3071757647: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    901063453: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTessellatedItem(),
    4282788508: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextLiteral(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentableText((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), v[2]),
    3124975700: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextLiteralWithExtent(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentableText((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), v[2], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoxAlignment((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1983826977: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextStyleFontModel(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextFontName(p.value) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFontStyle((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFontVariant((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFontWeight((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), $3b8da494b8e92f36$var$TypeInitialiser(3, v[5])),
    2715220739: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTrapeziumProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1628702193: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTypeObject(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3736923433: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTypeProcess(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2347495698: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTypeProduct(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3698973494: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTypeResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    427810014: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    1417489154: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVector(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2759199220: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVertexLoop(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    2543172580: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcZShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3406155212: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAdvancedFace(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    669184980: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAnnotationFillArea(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3207858831: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAsymmetricIShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value)),
    4261334040: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAxis1Placement(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    3125803723: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAxis2Placement2D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    2740243338: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAxis2Placement3D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    3425423356: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAxis2PlacementLinear(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    2736907675: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBooleanResult(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    4182860854: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundedSurface(),
    2581212453: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundingBox(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2713105998: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoxedHalfSpace(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    2898889636: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1123145078: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianPoint(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure(p.value) : null) || []),
    574549367: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianPointList(),
    1675464909: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianPointList2D(v[0]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure(p2.value) : null) || []), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || []),
    2059837836: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianPointList3D(v[0]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure(p2.value) : null) || []), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(p.value) : null) || []),
    59481748: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3749851601: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator2D((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3486308946: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator2DnonUniform((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3331915920: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator3D((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    1416205885: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator3DnonUniform((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1383045692: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCircleProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2205249479: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcClosedShell(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    776857604: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColourRgb((v[0] ?? void 0) === void 0 || v[0] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2542286263: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcComplexProperty(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2485617015: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompositeCurveSegment(v[0], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    2574617495: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionResourceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10])),
    3419103109: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcContext(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    1815067380: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCrewResourceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10]), v[11]),
    2506170314: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCsgPrimitive3D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    2147822146: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCsgSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    2601014836: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurve(),
    2827736869: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveBoundedPlane(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2629017746: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveBoundedSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    4212018352: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveSegment(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), $3b8da494b8e92f36$var$TypeInitialiser(3, v[2]), $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    32440307: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDirection(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal(p.value) : null) || []),
    593015953: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDirectrixCurveSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[4])),
    1472233963: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEdgeLoop(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1883228015: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementQuantity(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    339256511: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2777663545: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementarySurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    2835456948: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEllipseProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    4024345920: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEventType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], v[10], (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    477187591: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExtrudedAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2804161546: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExtrudedAreaSolidTapered(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    2047409740: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFaceBasedSurfaceModel(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    374418227: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFillAreaStyleHatching(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    315944413: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFillAreaStyleTiles(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2652556860: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFixedReferenceSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    4238390223: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFurnishingElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1268542332: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFurnitureType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], v[10]),
    4095422895: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeographicElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    987898635: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricCurveSet(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1484403080: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    178912537: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedPolygonalFace(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p.value) : null) || []),
    2294589976: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedPolygonalFaceWithVoids(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p.value) : null) || [], v[1]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p2.value) : null) || [])),
    3465909080: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedPolygonalTextureMap(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    572779678: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLShapeProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    428585644: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLaborResourceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10]), v[11]),
    1281925730: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLine(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    1425443689: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcManifoldSolidBrep(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    3888040117: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcObject(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    590820931: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOffsetCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    3388369263: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOffsetCurve2D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3505215534: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOffsetCurve3D(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    2485787929: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOffsetCurveByDistances(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1682466193: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPcurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1])),
    603570806: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlanarBox(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    220341763: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlane(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    3381221214: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolynomialCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal(p.value) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal(p.value) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal(p.value) : null) || []),
    759155922: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedColour(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    2559016684: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedCurveFont(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    3967405729: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedPropertySet(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    569719735: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProcedureType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2945172077: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProcess(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    4208778838: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProduct(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    103090709: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProject(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    653396225: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProjectLibrary(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    871118103: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyBoundedValue(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[5])),
    4166981789: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyEnumeratedValue(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    2752243245: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyListValue(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    941946838: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyReferenceValue(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    1451395588: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertySet(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    492091185: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertySetTemplate(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3650150729: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertySingleValue(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    110355661: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyTableValue(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || [], (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7]),
    3521284610: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyTemplate(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2770003689: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRectangleHollowProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2798486643: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRectangularPyramid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3454111270: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRectangularTrimmedSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    3765753017: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcementDefinitionProperties(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3939117080: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssigns(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStrippedOptional((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    1683148259: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToActor(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStrippedOptional((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7])),
    2495723537: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToControl(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStrippedOptional((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    1307041759: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToGroup(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStrippedOptional((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    1027710054: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToGroupByFactor(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStrippedOptional((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRatioMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4278684876: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToProcess(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStrippedOptional((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7])),
    2857406711: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToProduct(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStrippedOptional((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    205026976: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStrippedOptional((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    1865459582: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociates(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    4095574036: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesApproval(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    919958153: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesClassification(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    2728634034: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesConstraint(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    982818633: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesDocument(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    3840914261: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesLibrary(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    2655215786: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesMaterial(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    1033248425: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesProfileDef(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    826625072: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnects(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1204542856: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsElements(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    3945020480: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsPathElements(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || [], v[9], v[10]),
    4201705270: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsPortToElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    3190031847: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsPorts(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    2127690289: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsStructuralActivity(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    1638771189: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsStructuralMember(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9])),
    504942748: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsWithEccentricity(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10])),
    3678494232: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsWithRealizingElements(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3242617779: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelContainedInSpatialStructure(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    886880790: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelCoversBldgElements(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2802773753: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelCoversSpaces(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2565941209: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDeclares(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    2551354335: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDecomposes(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    693640335: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefines(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    1462361463: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefinesByObject(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    4186316022: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefinesByProperties(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    307848117: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefinesByTemplate(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    781010003: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefinesByType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    3940055652: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelFillsElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    279856033: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelFlowControlElements(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    427948657: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelInterferesElements(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9])),
    3268803585: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelNests(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1441486842: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelPositions(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    750771296: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelProjectsElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    1245217292: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelReferencedInSpatialStructure(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    4122056220: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelSequence(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    366585022: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelServicesBuildings(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3451746338: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelSpaceBoundary(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7], v[8]),
    3523091289: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelSpaceBoundary1stLevel(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7], v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9])),
    1521410863: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelSpaceBoundary2ndLevel(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7], v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10])),
    1401173127: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelVoidsElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    816062949: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReparametrisedCompositeCurveSegment(v[0], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    2914609552: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1856042241: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRevolvedAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3243963512: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRevolvedAreaSolidTapered(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4])),
    4158566097: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRightCircularCone(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3626867408: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRightCircularCylinder(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    1862484736: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionedSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1290935644: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionedSolidHorizontal(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1356537516: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionedSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3663146110: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSimplePropertyTemplate(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), v[11]),
    1412071761: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    710998568: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2706606064: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialStructureElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3893378262: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialStructureElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    463610769: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialZone(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2481509218: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialZoneType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    451544542: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSphere(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    4015995234: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSphericalSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2735484536: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpiral(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    3544373492: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralActivity(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8]),
    3136571912: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralItem(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    530289379: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralMember(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    3689010777: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralReaction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8]),
    3979015343: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceMember(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2218152070: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceMemberVarying(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    603775116: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceReaction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8], v[9]),
    4095615324: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSubContractResourceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10]), v[11]),
    699246055: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2]),
    2028607225: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceCurveSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    2809605785: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceOfLinearExtrusion(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    4124788165: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceOfRevolution(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    1580310250: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSystemFurnitureElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3473067441: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTask(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 3, v[11]), v[12]),
    3206491090: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTaskType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    2387106220: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTessellatedFaceSet(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    782932809: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThirdOrderPolynomialSpiral(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1935646853: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcToroidalSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3665877780: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransportationDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2916149573: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTriangulatedFaceSet(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p2.value) : null) || []), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p2.value) : null) || []), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p.value) : null) || []),
    1229763772: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTriangulatedIrregularNetwork(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p2.value) : null) || []), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), v[3]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p2.value) : null) || []), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p.value) : null) || [], v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || []),
    3651464721: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVehicleType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    336235671: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWindowLiningProperties(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value, 3, v[12]), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value)),
    512836454: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWindowPanelProperties(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    2296667514: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActor(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    1635779807: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAdvancedBrep(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    2603310189: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAdvancedBrepWithVoids(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1674181508: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAnnotation(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7]),
    2887950389: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBSplineSurface(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p2.value, 3, p2) : null) || []), v[3], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    167062518: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBSplineSurfaceWithKnots(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p2.value, 3, p2) : null) || []), v[3], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || [], v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || [], v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p.value) : null) || [], v[10]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p.value) : null) || [], v[11]),
    1334484129: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBlock(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    3649129432: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBooleanClippingResult(v[0], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2])),
    1260505505: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundedCurve(),
    3124254112: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingStorey(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    1626504194: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuiltElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2197970202: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcChimneyType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2937912522: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCircleHollowProfileDef(v[0], (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    3893394355: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCivilElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3497074424: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcClothoid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    300633059: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColumnType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3875453745: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcComplexPropertyTemplate(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3732776249: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompositeCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    15328376: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompositeCurveOnSurface(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    2510884976: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConic(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    2185764099: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionEquipmentResourceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10]), v[11]),
    4105962743: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionMaterialResourceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10]), v[11]),
    1525564444: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionProductResourceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10]), v[11]),
    2559216714: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9])),
    3293443760: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcControl(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    2000195564: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCosineSpiral(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3895139033: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCostItem(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    1419761937: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCostSchedule(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    4189326743: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCourseType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1916426348: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoveringType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3295246426: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCrewResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), v[10]),
    1457835157: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurtainWallType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1213902940: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCylindricalSurface(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1306400036: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDeepFoundationType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    4234616927: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDirectrixDerivedReferenceSweptAreaSolid(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[3]), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : $3b8da494b8e92f36$var$TypeInitialiser(3, v[4]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5])),
    3256556792: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3849074793: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionFlowElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2963535650: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDoorLiningProperties(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value, 3, v[14]), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value)),
    1714330368: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDoorPanelProperties(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    2323601079: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDoorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], v[10], (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    445594917: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDraughtingPreDefinedColour(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    4006246654: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDraughtingPreDefinedCurveFont(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value)),
    1758889154: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4123344466: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementAssembly(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    2397081782: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementAssemblyType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1623761950: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementComponent(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2590856083: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementComponentType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1704287377: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEllipse(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    2107101300: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEnergyConversionDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    132023988: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEngineType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3174744832: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvaporativeCoolerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3390157468: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvaporatorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4148101412: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvent(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7], v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10])),
    2853485674: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalSpatialStructureElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    807026263: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacetedBrep(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0])),
    3737207727: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacetedBrepWithVoids(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    24185140: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacility(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1310830890: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacilityPart(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    4228831410: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacilityPartCommon(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], v[10]),
    647756555: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFastener(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2489546625: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFastenerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2827207264: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFeatureElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2143335405: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFeatureElementAddition(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1287392070: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFeatureElementSubtraction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3907093117: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowControllerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3198132628: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowFittingType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3815607619: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowMeterType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1482959167: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowMovingDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1834744321: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowSegmentType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1339347760: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowStorageDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2297155007: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowTerminalType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3009222698: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowTreatmentDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1893162501: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFootingType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    263784265: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFurnishingElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1509553395: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFurniture(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3493046030: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeographicElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4230923436: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeotechnicalElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1594536857: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeotechnicalStratum(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2898700619: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGradientCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    2706460486: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGroup(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    1251058090: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHeatExchangerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1806887404: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHumidifierType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2568555532: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcImpactProtectionDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3948183225: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcImpactProtectionDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2571569899: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedPolyCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || [], (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value)),
    3946677679: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInterceptorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3113134337: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIntersectionCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2]),
    2391368822: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInventory(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10])),
    4288270099: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcJunctionBoxType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    679976338: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcKerbType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3827777499: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLaborResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), v[10]),
    1051575348: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLampType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1161773419: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightFixtureType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2176059722: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    1770583370: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLiquidTerminalType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    525669439: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMarineFacility(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    976884017: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMarinePart(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], v[10]),
    377706215: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMechanicalFastener(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10]),
    2108223431: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMechanicalFastenerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value)),
    1114901282: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMedicalDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3181161470: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMemberType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1950438474: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMobileTelecommunicationsApplianceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    710110818: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMooringDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    977012517: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMotorConnectionType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    506776471: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNavigationElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4143007308: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOccupant(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), v[6]),
    3588315303: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOpeningElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2837617999: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOutletType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    514975943: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPavementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2382730787: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPerformanceHistory(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]),
    3566463478: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPermeableCoveringProperties(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4], v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    3327091369: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPermit(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1158309216: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPileType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    804291784: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPipeFittingType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4231323485: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPipeSegmentType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4017108033: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlateType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2839578677: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolygonalFaceSet(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(p.value) : null) || []),
    3724593414: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolyline(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    3740093272: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPort(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    1946335990: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositioningElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    2744685151: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProcedure(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]),
    2904328755: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProjectOrder(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    3651124850: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProjectionElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1842657554: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProtectiveDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2250791053: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPumpType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1763565496: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2893384427: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailingType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3992365140: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailway(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    1891881377: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailwayPart(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], v[10]),
    2324767716: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRampFlightType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1469900589: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRampType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    683857671: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRationalBSplineSurfaceWithKnots(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), v[2]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p2.value, 3, p2) : null) || []), v[3], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || [], v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || [], v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p.value) : null) || [], v[10]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p.value) : null) || [], v[11], v[12]?.map((p)=>p?.map((p2)=>(p2?.value ?? void 0) !== void 0 && p2?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal(p2.value) : null) || [])),
    4021432810: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReferent(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7]),
    3027567501: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    964333572: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    2320036040: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingMesh(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), v[17]),
    2310774935: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingMeshType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value), (v[17] ?? void 0) === void 0 || v[17] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[17] ?? void 0) === void 0 || v[17] === "" ? null : v[17].value), (v[18] ?? void 0) === void 0 || v[18] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[18] ?? void 0) === void 0 || v[18] === "" ? null : v[18].value), (v[19] ?? void 0) === void 0 || v[19] === "" ? null : v[19]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || []),
    3818125796: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAdheresToElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    160246688: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAggregates(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value, 3, v[4]), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || []),
    146592293: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoad(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    550521510: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoadPart(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], v[10]),
    2781568857: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoofType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1768891740: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSanitaryTerminalType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2157484638: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSeamCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2]),
    3649235739: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSecondOrderPolynomialSpiral(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    544395925: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSegmentedReferenceCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value, 3, v[2]), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value, 3, v[3])),
    1027922057: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSeventhOrderPolynomialSpiral(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    4074543187: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShadingDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    33720170: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSign(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3599934289: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSignType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1894708472: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSignalType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    42703149: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSineSpiral(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value)),
    4097777520: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSite(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompoundPlaneAngleMeasure(v[9].map((x)=>x.value)), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompoundPlaneAngleMeasure(v[10].map((x)=>x.value)), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value, 3, v[13])),
    2533589738: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSlabType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1072016465: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSolarDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3856911033: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpace(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    1305183839: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpaceHeaterType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3812236995: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpaceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value)),
    3112655638: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStackTerminalType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1039846685: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStairFlightType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    338393293: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStairType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    682877961: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralAction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    1179482911: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralConnection(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7])),
    1004757350: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveAction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11]),
    4243806635: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveConnection(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    214636428: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveMember(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    2445595289: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveMemberVarying(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7], new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    2757150158: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveReaction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8], v[9]),
    1807405624: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLinearAction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11]),
    1252848954: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadGroup(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], v[6], v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    2082059205: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralPointAction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value)),
    734778138: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralPointConnection(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8])),
    1235345126: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralPointReaction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8]),
    2986769608: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralResultGroup(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3657597509: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceAction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11]),
    1975003073: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceConnection(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7])),
    148013059: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSubContractResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), v[10]),
    3101698114: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceFeature(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2315554128: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSwitchingDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2254336722: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSystem(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    413509423: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSystemFurnitureElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    5716631: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTankType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3824725483: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendon(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPressureMeasure((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value), (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15].value), (v[16] ?? void 0) === void 0 || v[16] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[16] ?? void 0) === void 0 || v[16] === "" ? null : v[16].value)),
    2347447852: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonAnchor(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3081323446: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonAnchorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3663046924: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonConduit(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2281632017: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonConduitType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2415094496: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    618700268: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTrackElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1692211062: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransformerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2097647324: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransportElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1953115116: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransportationDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3593883385: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTrimmedCurve(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), v[4]),
    1600972822: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTubeBundleType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1911125066: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitaryEquipmentType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    728799441: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcValveType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    840318589: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVehicle(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1530820697: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVibrationDamper(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3956297820: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVibrationDamperType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2391383451: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVibrationIsolator(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3313531582: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVibrationIsolatorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2769231204: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVirtualElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    926996030: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVoidingFeature(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1898987631: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWallType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1133259667: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWasteTerminalType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4009809668: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWindowType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], v[10], (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    4088093105: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkCalendar(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[8]),
    1028945134: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkControl(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    4218914973: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkPlan(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), v[13]),
    3342526732: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkSchedule(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), v[13]),
    1033361043: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcZone(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value)),
    3821786052: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActionRequest(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1411407467: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirTerminalBoxType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3352864051: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirTerminalType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1871374353: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirToAirHeatRecoveryType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4266260250: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentCant(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1545765605: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentHorizontal(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    317615605: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentSegment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7])),
    1662888072: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentVertical(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    3460190687: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAsset(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value, 3, v[8]), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value, 3, v[10]), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 3, v[11]), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), (v[13] ?? void 0) === void 0 || v[13] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[13] ?? void 0) === void 0 || v[13] === "" ? null : v[13].value, 3, v[13])),
    1532957894: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAudioVisualApplianceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1967976161: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBSplineCurve(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value)),
    2461110595: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBSplineCurveWithKnots(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || [], v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p.value) : null) || [], v[7]),
    819618141: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBeamType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3649138523: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBearingType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    231477066: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoilerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1136057603: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    644574406: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBridge(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    963979645: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBridgePart(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9], v[10]),
    4031249490: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuilding(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value, 3, v[11])),
    2979338954: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingElementPart(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    39481116: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingElementPartType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1909888760: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingElementProxyType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1177604601: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingSystem(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    1876633798: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuiltElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3862327254: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuiltSystem(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value)),
    2188180465: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBurnerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    395041908: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableCarrierFittingType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3293546465: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableCarrierSegmentType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2674252688: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableFittingType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1285652485: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableSegmentType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3203706013: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCaissonFoundationType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2951183804: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcChillerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3296154744: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcChimney(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2611217952: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCircle(new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value, 3, v[0]), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    1677625105: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCivilElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2301859152: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoilType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    843113511: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColumn(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    400855858: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCommunicationsApplianceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3850581409: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompressorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2816379211: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCondenserType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3898045240: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionEquipmentResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), v[10]),
    1060000209: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionMaterialResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), v[10]),
    488727124: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionProductResource(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9]), v[10]),
    2940368186: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConveyorSegmentType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    335055490: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCooledBeamType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2954562838: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoolingTowerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1502416096: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCourse(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1973544240: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCovering(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3495092785: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurtainWall(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3961806047: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDamperType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3426335179: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDeepFoundation(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1335981549: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDiscreteAccessory(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2635815018: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDiscreteAccessoryType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    479945903: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionBoardType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1599208980: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionChamberElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2063403501: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionControlElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value)),
    1945004755: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3040386961: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionFlowElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3041715199: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionPort(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7], v[8], v[9]),
    3205830791: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionSystem(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6]),
    395920057: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDoor(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11], (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    869906466: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctFittingType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3760055223: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctSegmentType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2030761528: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctSilencerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3071239417: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEarthworksCut(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1077100507: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEarthworksElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3376911765: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEarthworksFill(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    663422040: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricApplianceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2417008758: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricDistributionBoardType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3277789161: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricFlowStorageDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2142170206: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricFlowTreatmentDeviceType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1534661035: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricGeneratorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1217240411: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricMotorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    712377611: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricTimeControlType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1658829314: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEnergyConversionDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2814081492: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEngine(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3747195512: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvaporativeCooler(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    484807127: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvaporator(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1209101575: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalSpatialElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    346874300: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFanType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1810631287: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFilterType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4222183408: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFireSuppressionTerminalType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2058353004: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowController(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4278956645: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowFitting(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    4037862832: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowInstrumentType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    2188021234: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowMeter(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3132237377: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowMovingDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    987401354: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowSegment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    707683696: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowStorageDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2223149337: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowTerminal(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3508470533: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowTreatmentDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    900683007: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFooting(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2713699986: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeotechnicalAssembly(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    3009204131: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGrid(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[10]),
    3319311131: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHeatExchanger(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2068733104: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHumidifier(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4175244083: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInterceptor(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2176052936: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcJunctionBox(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2696325953: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcKerb(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    76236018: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLamp(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    629592764: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightFixture(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1154579445: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearPositioningElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6])),
    1638804497: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLiquidTerminal(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1437502449: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMedicalDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1073191201: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMember(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2078563270: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMobileTelecommunicationsAppliance(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    234836483: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMooringDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2474470126: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMotorConnection(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2182337498: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNavigationElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    144952367: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOuterBoundaryCurve(v[0]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value)),
    3694346114: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOutlet(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1383356374: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPavement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1687234759: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPile(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8], v[9]),
    310824031: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPipeFitting(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3612865200: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPipeSegment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3171933400: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlate(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    738039164: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProtectiveDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    655969474: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProtectiveDeviceTrippingUnitType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    90941305: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPump(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3290496277: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRail(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2262370178: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailing(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3024970846: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRamp(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3283111854: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRampFlight(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1232101972: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRationalBSplineCurveWithKnots(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), v[1]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], v[2], new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(p.value) : null) || [], v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(p.value) : null) || [], v[7], v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal(p.value) : null) || []),
    3798194928: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcedSoil(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    979691226: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingBar(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), v[12], v[13]),
    2572171363: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingBarType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9], (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value), v[13], (v[14] ?? void 0) === void 0 || v[14] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[14] ?? void 0) === void 0 || v[14] === "" ? null : v[14].value), (v[15] ?? void 0) === void 0 || v[15] === "" ? null : v[15]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? $3b8da494b8e92f36$var$TypeInitialiser(3, p) : null) || []),
    2016517767: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoof(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3053780830: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSanitaryTerminal(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1783015770: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSensorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1329646415: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShadingDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    991950508: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSignal(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1529196076: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSlab(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3420628829: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSolarDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1999602285: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpaceHeater(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1404847402: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStackTerminal(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    331165859: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStair(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4252922144: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStairFlight(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10].value), (v[11] ?? void 0) === void 0 || v[11] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[11] ?? void 0) === void 0 || v[11] === "" ? null : v[11].value), v[12]),
    2515109513: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralAnalysisModel(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value, 3, v[9])),
    385403989: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadCase(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), v[5], v[6], v[7], (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRatioMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), (v[10] ?? void 0) === void 0 || v[10] === "" ? null : v[10]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRatioMeasure(p.value) : null) || []),
    1621171031: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralPlanarAction(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value, 3, v[7]), v[8], (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11]),
    1162798199: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSwitchingDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    812556717: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTank(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3425753595: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTrackElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3825984169: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransformer(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1620046519: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransportElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3026737570: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTubeBundle(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3179687236: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitaryControlElementType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    4292641817: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitaryEquipment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4207607924: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcValve(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2391406946: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWall(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3512223829: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWallStandardCase(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4237592921: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWasteTerminal(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3304561284: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWindow(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), (v[9] ?? void 0) === void 0 || v[9] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure((v[9] ?? void 0) === void 0 || v[9] === "" ? null : v[9].value), v[10], v[11], (v[12] ?? void 0) === void 0 || v[12] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[12] ?? void 0) === void 0 || v[12] === "" ? null : v[12].value)),
    2874132201: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActuatorType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    1634111441: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirTerminal(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    177149247: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirTerminalBox(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2056796094: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirToAirHeatRecovery(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3001207471: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlarmType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    325726236: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), v[7]),
    277319702: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAudioVisualAppliance(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    753842376: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBeam(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4196446775: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBearing(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    32344328: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoiler(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3314249567: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBorehole(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1095909175: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingElementProxy(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2938176219: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBurner(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    635142910: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableCarrierFitting(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3758799889: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableCarrierSegment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1051757585: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableFitting(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4217484030: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableSegment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3999819293: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCaissonFoundation(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3902619387: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcChiller(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    639361253: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoil(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3221913625: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCommunicationsAppliance(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3571504051: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompressor(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2272882330: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCondenser(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    578613899: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcControllerType(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6]?.map((p)=>(p?.value ?? void 0) !== void 0 && p?.value !== "" ? new $3b8da494b8e92f36$export$94890c79f4cae6d6(p.value, 3, p) : null) || [], (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), (v[8] ?? void 0) === void 0 || v[8] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[8] ?? void 0) === void 0 || v[8] === "" ? null : v[8].value), v[9]),
    3460952963: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConveyorSegment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4136498852: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCooledBeam(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3640358203: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoolingTower(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4074379575: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDamper(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3693000487: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionBoard(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1052013943: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionChamberElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    562808652: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionCircuit(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value), v[6]),
    1062813311: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionControlElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    342316401: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctFitting(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3518393246: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctSegment(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1360408905: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctSilencer(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1904799276: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricAppliance(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    862014818: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricDistributionBoard(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3310460725: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricFlowStorageDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    24726584: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricFlowTreatmentDevice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    264262732: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricGenerator(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    402227799: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricMotor(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1003880860: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricTimeControl(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3415622556: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFan(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    819412036: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFilter(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    1426591983: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFireSuppressionTerminal(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    182646315: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowInstrument(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    2680139844: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeomodel(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    1971632696: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeoslice(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value)),
    2295281155: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProtectiveDeviceTrippingUnit(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4086658281: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSensor(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    630975310: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitaryControlElement(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    4288193352: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActuator(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    3087945054: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlarm(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8]),
    25142252: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcController(new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId((v[0] ?? void 0) === void 0 || v[0] === "" ? null : v[0].value), (v[1] ?? void 0) === void 0 || v[1] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[1] ?? void 0) === void 0 || v[1] === "" ? null : v[1].value, 3, v[1]), (v[2] ?? void 0) === void 0 || v[2] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[2] ?? void 0) === void 0 || v[2] === "" ? null : v[2].value), (v[3] ?? void 0) === void 0 || v[3] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText((v[3] ?? void 0) === void 0 || v[3] === "" ? null : v[3].value), (v[4] ?? void 0) === void 0 || v[4] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel((v[4] ?? void 0) === void 0 || v[4] === "" ? null : v[4].value), (v[5] ?? void 0) === void 0 || v[5] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[5] ?? void 0) === void 0 || v[5] === "" ? null : v[5].value, 3, v[5]), (v[6] ?? void 0) === void 0 || v[6] === "" ? null : new $3b8da494b8e92f36$export$94890c79f4cae6d6((v[6] ?? void 0) === void 0 || v[6] === "" ? null : v[6].value, 3, v[6]), (v[7] ?? void 0) === void 0 || v[7] === "" ? null : new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier((v[7] ?? void 0) === void 0 || v[7] === "" ? null : v[7].value), v[8])
};
$3b8da494b8e92f36$export$6fc5084ea038b400[3] = {
    618182010: [
        $3b8da494b8e92f36$export$1d51c48a0d338c7d,
        $3b8da494b8e92f36$export$852f8a6b6383ece8
    ],
    2879124712: [
        $3b8da494b8e92f36$export$e2b249d4f45002ea,
        $3b8da494b8e92f36$export$fa5b448c5eddeb03,
        $3b8da494b8e92f36$export$56da2f0cc849825c
    ],
    411424972: [
        $3b8da494b8e92f36$export$61dc578b5cbce35b
    ],
    4037036970: [
        $3b8da494b8e92f36$export$cfb27e5500a39320,
        $3b8da494b8e92f36$export$229e73e933804e50,
        $3b8da494b8e92f36$export$a34702b337593132,
        $3b8da494b8e92f36$export$a08930e72563c535
    ],
    1387855156: [
        $3b8da494b8e92f36$export$cfb27e5500a39320
    ],
    2859738748: [
        $3b8da494b8e92f36$export$6ef8b10b979d6ed7,
        $3b8da494b8e92f36$export$7630445096f3e0e,
        $3b8da494b8e92f36$export$dc861dfbf2baaa1a,
        $3b8da494b8e92f36$export$415e991945a654ac,
        $3b8da494b8e92f36$export$a8e470c98a867218
    ],
    2614616156: [
        $3b8da494b8e92f36$export$415e991945a654ac
    ],
    1959218052: [
        $3b8da494b8e92f36$export$fd56761a594c90b1,
        $3b8da494b8e92f36$export$6bb698fabb80bc4f
    ],
    1785450214: [
        $3b8da494b8e92f36$export$fd0b1b6c7ac86314,
        $3b8da494b8e92f36$export$6d2edf02bc3e05a2,
        $3b8da494b8e92f36$export$9c8e8646198c2dbd
    ],
    1466758467: [
        $3b8da494b8e92f36$export$3ba9c26e1e245f60,
        $3b8da494b8e92f36$export$c81b40a3be0ef8e7
    ],
    4294318154: [
        $3b8da494b8e92f36$export$18cb417b645b7410,
        $3b8da494b8e92f36$export$4414ee8d28b3907a,
        $3b8da494b8e92f36$export$87ba372ae8130125
    ],
    3200245327: [
        $3b8da494b8e92f36$export$5dc53366ca618592,
        $3b8da494b8e92f36$export$72ed75e7fb4d773c,
        $3b8da494b8e92f36$export$96fe74a17c6cc802,
        $3b8da494b8e92f36$export$5ea64628e783fcd7,
        $3b8da494b8e92f36$export$599e2cc9684286ad,
        $3b8da494b8e92f36$export$133f46f5e03827d2
    ],
    3057273783: [
        $3b8da494b8e92f36$export$6d2edf02bc3e05a2
    ],
    760658860: [
        $3b8da494b8e92f36$export$b1bef060ce5931d8,
        $3b8da494b8e92f36$export$bf1ff376c816a889,
        $3b8da494b8e92f36$export$f73761c75017e522,
        $3b8da494b8e92f36$export$ce700270dbd3f574,
        $3b8da494b8e92f36$export$cb4089fd00927e5e,
        $3b8da494b8e92f36$export$90624260d4eb2c6c,
        $3b8da494b8e92f36$export$271c16e7766bc70a,
        $3b8da494b8e92f36$export$36935a2a2087e3a2,
        $3b8da494b8e92f36$export$dc9e27d0030a4e65
    ],
    248100487: [
        $3b8da494b8e92f36$export$36935a2a2087e3a2
    ],
    2235152071: [
        $3b8da494b8e92f36$export$cb4089fd00927e5e
    ],
    1507914824: [
        $3b8da494b8e92f36$export$ac428444f42ac73b,
        $3b8da494b8e92f36$export$9da0ae2bdea157b5,
        $3b8da494b8e92f36$export$33d702d835661133
    ],
    1918398963: [
        $3b8da494b8e92f36$export$c792ec963053411b,
        $3b8da494b8e92f36$export$bc84a57a2afc707f,
        $3b8da494b8e92f36$export$4d644d65c6f10de9,
        $3b8da494b8e92f36$export$342dff6367faf07
    ],
    3701648758: [
        $3b8da494b8e92f36$export$34302876ddf37791,
        $3b8da494b8e92f36$export$ee5fe2a61985b27e,
        $3b8da494b8e92f36$export$af00f3f0f2c6d769
    ],
    2483315170: [
        $3b8da494b8e92f36$export$8334e069ea620bb8,
        $3b8da494b8e92f36$export$b383f456d1eb5728,
        $3b8da494b8e92f36$export$e5dbe5700ecba735,
        $3b8da494b8e92f36$export$ccca2dba73dadeee,
        $3b8da494b8e92f36$export$f192946650c793a8,
        $3b8da494b8e92f36$export$678778899caae9fb,
        $3b8da494b8e92f36$export$d48394905ba00253,
        $3b8da494b8e92f36$export$c69ac01f7bf51b3,
        $3b8da494b8e92f36$export$21edf23fe590ab33
    ],
    2226359599: [
        $3b8da494b8e92f36$export$b383f456d1eb5728,
        $3b8da494b8e92f36$export$e5dbe5700ecba735,
        $3b8da494b8e92f36$export$ccca2dba73dadeee,
        $3b8da494b8e92f36$export$f192946650c793a8,
        $3b8da494b8e92f36$export$678778899caae9fb,
        $3b8da494b8e92f36$export$d48394905ba00253,
        $3b8da494b8e92f36$export$c69ac01f7bf51b3
    ],
    677532197: [
        $3b8da494b8e92f36$export$2c91bae7185bb7c5,
        $3b8da494b8e92f36$export$42292ad7a949ca7e,
        $3b8da494b8e92f36$export$2a79ce8e6dde1605,
        $3b8da494b8e92f36$export$d18f4beaf4701e94,
        $3b8da494b8e92f36$export$56d725cc20359b33,
        $3b8da494b8e92f36$export$e24694355c430317,
        $3b8da494b8e92f36$export$5cd60fa6a78c0173,
        $3b8da494b8e92f36$export$5c5bfbea1f9750f0,
        $3b8da494b8e92f36$export$a111f4db685f7a59,
        $3b8da494b8e92f36$export$3ed3034f18cddaaf,
        $3b8da494b8e92f36$export$f9ded52c4b70f4f5,
        $3b8da494b8e92f36$export$856784adecc150fd,
        $3b8da494b8e92f36$export$6ce0be1835c9ab1b,
        $3b8da494b8e92f36$export$447b3f598cf8325d,
        $3b8da494b8e92f36$export$eb38190c7ccf4599,
        $3b8da494b8e92f36$export$616208c6ed2a0bc3,
        $3b8da494b8e92f36$export$1e82cbdcd9fe6ab9,
        $3b8da494b8e92f36$export$12c8486b22f747b4,
        $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
        $3b8da494b8e92f36$export$925b578047892bce,
        $3b8da494b8e92f36$export$cc681b8347ae2d28,
        $3b8da494b8e92f36$export$f9f8eae306150574,
        $3b8da494b8e92f36$export$d8e08722b3a63093,
        $3b8da494b8e92f36$export$a22358e886367f19,
        $3b8da494b8e92f36$export$d3d6625d33fe749f,
        $3b8da494b8e92f36$export$28f95f3a6633e96f,
        $3b8da494b8e92f36$export$cdda591705a51882,
        $3b8da494b8e92f36$export$b54830ac8ad9727a,
        $3b8da494b8e92f36$export$a208be2840956e7f,
        $3b8da494b8e92f36$export$102bd971c14ba988,
        $3b8da494b8e92f36$export$c548b4b271e262e6,
        $3b8da494b8e92f36$export$9b0f4a78b27610b2,
        $3b8da494b8e92f36$export$a47851a048855495
    ],
    2022622350: [
        $3b8da494b8e92f36$export$c9ca953ef790beab
    ],
    3119450353: [
        $3b8da494b8e92f36$export$868aba9d7912640,
        $3b8da494b8e92f36$export$4c036fdbe809739e,
        $3b8da494b8e92f36$export$6f91f48d17dc7f0c,
        $3b8da494b8e92f36$export$922b2a5ffa4eee3e
    ],
    2095639259: [
        $3b8da494b8e92f36$export$6d55f5b363d70c84,
        $3b8da494b8e92f36$export$95d5078ec273e20a
    ],
    3958567839: [
        $3b8da494b8e92f36$export$78c21ee34d1c97a2,
        $3b8da494b8e92f36$export$4f772a6ff028612d,
        $3b8da494b8e92f36$export$6cce02eb19410fd6,
        $3b8da494b8e92f36$export$9bf9b7d525eb98c7,
        $3b8da494b8e92f36$export$509dfb8dfad057e9,
        $3b8da494b8e92f36$export$6659a6bebb9ff076,
        $3b8da494b8e92f36$export$9f98ad7f69b4,
        $3b8da494b8e92f36$export$3e010693b51db065,
        $3b8da494b8e92f36$export$5046f8ea20f33c53,
        $3b8da494b8e92f36$export$6a6339501d69dda6,
        $3b8da494b8e92f36$export$24e4f709acf9819a,
        $3b8da494b8e92f36$export$2c0c343d0211b12a,
        $3b8da494b8e92f36$export$bb7bafb36fa737d0,
        $3b8da494b8e92f36$export$9d1f507a1764cea9,
        $3b8da494b8e92f36$export$81a199afe8025f54,
        $3b8da494b8e92f36$export$c2cca572ace0bab5,
        $3b8da494b8e92f36$export$6ff606ccfc58f5bb,
        $3b8da494b8e92f36$export$1a193eff9b81238c,
        $3b8da494b8e92f36$export$a749204998f5a3c,
        $3b8da494b8e92f36$export$3c5dfd8f9406db1,
        $3b8da494b8e92f36$export$40359089e4e5f50d,
        $3b8da494b8e92f36$export$7d329955417ee03b,
        $3b8da494b8e92f36$export$17c544e73ae3a145
    ],
    986844984: [
        $3b8da494b8e92f36$export$ea419368a3085d41,
        $3b8da494b8e92f36$export$18fc149087e3c79f,
        $3b8da494b8e92f36$export$9f8310d680636df4,
        $3b8da494b8e92f36$export$2d97768d0015dccc,
        $3b8da494b8e92f36$export$b40b280750874c4,
        $3b8da494b8e92f36$export$421fb9d9a3f56509,
        $3b8da494b8e92f36$export$2ee49241e76b8d88,
        $3b8da494b8e92f36$export$15997dea423f274a,
        $3b8da494b8e92f36$export$58f9c0981808b34a,
        $3b8da494b8e92f36$export$8ada78967ce0de43,
        $3b8da494b8e92f36$export$2f757802d81974e2,
        $3b8da494b8e92f36$export$f4438fbaac045e16,
        $3b8da494b8e92f36$export$c262d6aa9cc45c1e,
        $3b8da494b8e92f36$export$925767a3ae3a4925,
        $3b8da494b8e92f36$export$d8f086a59e04ee25,
        $3b8da494b8e92f36$export$971eec9c9d45cdbc,
        $3b8da494b8e92f36$export$a1c63a5e92dd2589
    ],
    1076942058: [
        $3b8da494b8e92f36$export$e8d16de4476cf00b,
        $3b8da494b8e92f36$export$feba35570752eed7,
        $3b8da494b8e92f36$export$5f0eb5061797e589,
        $3b8da494b8e92f36$export$982f17a83654a1a9,
        $3b8da494b8e92f36$export$2e35095825dbcf3c
    ],
    3377609919: [
        $3b8da494b8e92f36$export$c78a940a5c4e916a,
        $3b8da494b8e92f36$export$b1afc9e5bea6b0b5
    ],
    3008791417: [
        $3b8da494b8e92f36$export$f6578324c1ae7b2d,
        $3b8da494b8e92f36$export$9aea5e4278bdf41,
        $3b8da494b8e92f36$export$521bada8515ab976,
        $3b8da494b8e92f36$export$5549d05fc93b536b,
        $3b8da494b8e92f36$export$ef6ede6699415aa4,
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f,
        $3b8da494b8e92f36$export$ec4770aab56c805f,
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$569b2f842286694a,
        $3b8da494b8e92f36$export$ae61b17b9a1def4f,
        $3b8da494b8e92f36$export$14f69d2c614ba0a3,
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f,
        $3b8da494b8e92f36$export$7952e91536a239e7,
        $3b8da494b8e92f36$export$cddab537799fe2fd,
        $3b8da494b8e92f36$export$922fa769a539de57,
        $3b8da494b8e92f36$export$85f2457f407ffd38,
        $3b8da494b8e92f36$export$c71362c4ed185b32,
        $3b8da494b8e92f36$export$930ecb71bb54f6b9,
        $3b8da494b8e92f36$export$71a20a295551861d,
        $3b8da494b8e92f36$export$21377908e11164b8,
        $3b8da494b8e92f36$export$fd146d5f53fefc87,
        $3b8da494b8e92f36$export$9c60c9750bd86c93,
        $3b8da494b8e92f36$export$eae2f9556d21859d,
        $3b8da494b8e92f36$export$889cc41214b5970c,
        $3b8da494b8e92f36$export$1721bccc01fce10a,
        $3b8da494b8e92f36$export$3a90cd7486e7bfc7,
        $3b8da494b8e92f36$export$7ff49950c8e89377,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43,
        $3b8da494b8e92f36$export$ff5167510e50ee26,
        $3b8da494b8e92f36$export$6c79cacc663fc254,
        $3b8da494b8e92f36$export$5f769669c17cd7be,
        $3b8da494b8e92f36$export$aba424e86850f717,
        $3b8da494b8e92f36$export$2a2b17b32d1a9938,
        $3b8da494b8e92f36$export$f1de0c39f08c8646,
        $3b8da494b8e92f36$export$36783435db2b01a1,
        $3b8da494b8e92f36$export$d414ecd4014891b0,
        $3b8da494b8e92f36$export$5655bbb83559ae0a,
        $3b8da494b8e92f36$export$64fbfc27b4cec02a,
        $3b8da494b8e92f36$export$843f1ace19c7b757,
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252,
        $3b8da494b8e92f36$export$88babb7bc763dabe,
        $3b8da494b8e92f36$export$86be59b19ba0bac8,
        $3b8da494b8e92f36$export$e5527fc80680ccac,
        $3b8da494b8e92f36$export$d0a6287d5fe2b0d0,
        $3b8da494b8e92f36$export$24551edc0d1c7c9e,
        $3b8da494b8e92f36$export$36a18b804a497897,
        $3b8da494b8e92f36$export$a340b94c3a9627f5,
        $3b8da494b8e92f36$export$a93e600de3d261bf,
        $3b8da494b8e92f36$export$6b50b93a9a443e09,
        $3b8da494b8e92f36$export$aa7ed498f6d760b8,
        $3b8da494b8e92f36$export$fd5f089562b081f9,
        $3b8da494b8e92f36$export$baa116807524c06e,
        $3b8da494b8e92f36$export$cf616a1a67553ce5,
        $3b8da494b8e92f36$export$df1aea6f3c3fdd3,
        $3b8da494b8e92f36$export$2ecfbeca9fa8edbd,
        $3b8da494b8e92f36$export$be55db5658261c24,
        $3b8da494b8e92f36$export$e759ffb34c88cdbb,
        $3b8da494b8e92f36$export$a15ad7bc84af942e,
        $3b8da494b8e92f36$export$70128586019a4a85,
        $3b8da494b8e92f36$export$406ae3ea561cdfed,
        $3b8da494b8e92f36$export$a633a7857c4afb8b,
        $3b8da494b8e92f36$export$8bcad0fd81ccef4e,
        $3b8da494b8e92f36$export$7c3b7ecc8dd17171,
        $3b8da494b8e92f36$export$32b9b3ebd4722148,
        $3b8da494b8e92f36$export$60c94e2d2eb3ae2d,
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d,
        $3b8da494b8e92f36$export$14920f38b00f3073,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$4bb861b4bba551ce,
        $3b8da494b8e92f36$export$7a8fab203344ee59,
        $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b,
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a,
        $3b8da494b8e92f36$export$e7d69479b3ed50b5,
        $3b8da494b8e92f36$export$aea7582eed012cfd,
        $3b8da494b8e92f36$export$25fbf7852b3a8a34,
        $3b8da494b8e92f36$export$e545ccdc4ae42e81,
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f,
        $3b8da494b8e92f36$export$45f4c4bef325c6de,
        $3b8da494b8e92f36$export$212932c39cad14c1,
        $3b8da494b8e92f36$export$a7c9a308bd61791e,
        $3b8da494b8e92f36$export$9462ca86e16364d3,
        $3b8da494b8e92f36$export$2ef492eaafc1544a,
        $3b8da494b8e92f36$export$fe015439a6fa96b6,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$f03ac9a18a5a000,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$7ac92bdfbda997a6,
        $3b8da494b8e92f36$export$cc878395e6134df2,
        $3b8da494b8e92f36$export$6eda1fffe4033879,
        $3b8da494b8e92f36$export$db3cb7c28fcdcb12,
        $3b8da494b8e92f36$export$1fe9373d30daf09d,
        $3b8da494b8e92f36$export$f0268edfa147e5dc,
        $3b8da494b8e92f36$export$702326c0288a963,
        $3b8da494b8e92f36$export$5478cb2985eabb5a,
        $3b8da494b8e92f36$export$d919945f72bbea0b,
        $3b8da494b8e92f36$export$301a7e858fe85036,
        $3b8da494b8e92f36$export$9de8356191dd818,
        $3b8da494b8e92f36$export$929165ba65228ecd,
        $3b8da494b8e92f36$export$8923f08b310dd8eb,
        $3b8da494b8e92f36$export$f9263ceb04bc6af7,
        $3b8da494b8e92f36$export$b2d243272d4e7e07,
        $3b8da494b8e92f36$export$f181705801de6aa3,
        $3b8da494b8e92f36$export$a8dfee375f66477,
        $3b8da494b8e92f36$export$53e8d872a4770e53,
        $3b8da494b8e92f36$export$aa97e6334e80a8ca,
        $3b8da494b8e92f36$export$51d4dba1ae2d8f1b,
        $3b8da494b8e92f36$export$307e928f69359e15,
        $3b8da494b8e92f36$export$ad8e83777baa8a31,
        $3b8da494b8e92f36$export$48039412bed87667,
        $3b8da494b8e92f36$export$f91087a08c2974c5,
        $3b8da494b8e92f36$export$a205ad382a675d9,
        $3b8da494b8e92f36$export$7d2f047f3374cd6d,
        $3b8da494b8e92f36$export$91b809c3774b52ca,
        $3b8da494b8e92f36$export$8799bf99f01d0b68,
        $3b8da494b8e92f36$export$117debe45e2ae49d,
        $3b8da494b8e92f36$export$ebd3184cd8b065fd,
        $3b8da494b8e92f36$export$e569b2ccaf52a8fd,
        $3b8da494b8e92f36$export$fc934d2c514a6d85,
        $3b8da494b8e92f36$export$20db6cfb2db45f44,
        $3b8da494b8e92f36$export$70c90f142bc37811,
        $3b8da494b8e92f36$export$a321d78f5cb9ca4f,
        $3b8da494b8e92f36$export$52eaa2d341700ec1,
        $3b8da494b8e92f36$export$804200e8992a9b20,
        $3b8da494b8e92f36$export$e209a4a7e118ebd5,
        $3b8da494b8e92f36$export$1dcd1852764e4fb7,
        $3b8da494b8e92f36$export$c75f1a12de9d86b8,
        $3b8da494b8e92f36$export$720f149ff6c3542a,
        $3b8da494b8e92f36$export$3534ea9b1da643f3,
        $3b8da494b8e92f36$export$55b4788f85a51e1a,
        $3b8da494b8e92f36$export$5a54e2173db7aff1,
        $3b8da494b8e92f36$export$6c1d729adeeaed4a,
        $3b8da494b8e92f36$export$a88a630c8a34962c,
        $3b8da494b8e92f36$export$3d22c077bdb90a75,
        $3b8da494b8e92f36$export$7beb7cab9d3e2b14,
        $3b8da494b8e92f36$export$4b2fd6d0e55ecfa0,
        $3b8da494b8e92f36$export$8176d17ddc845867,
        $3b8da494b8e92f36$export$dd210e591847e415,
        $3b8da494b8e92f36$export$873d7c14f646e598,
        $3b8da494b8e92f36$export$5993765fc33cd311,
        $3b8da494b8e92f36$export$c780a52ecdcabf01,
        $3b8da494b8e92f36$export$d82e092cbe83635,
        $3b8da494b8e92f36$export$b718d0ddc70e8826
    ],
    2439245199: [
        $3b8da494b8e92f36$export$acffd400493c189c,
        $3b8da494b8e92f36$export$13de02c11c361011,
        $3b8da494b8e92f36$export$7fc4348977f8efbe,
        $3b8da494b8e92f36$export$f7ea933b5cc28fe9,
        $3b8da494b8e92f36$export$e2f0b7f5e626526f,
        $3b8da494b8e92f36$export$dc995d42867b8d56,
        $3b8da494b8e92f36$export$623f6287e006c7a4,
        $3b8da494b8e92f36$export$fba1c7dc4402a4b3,
        $3b8da494b8e92f36$export$cea9d94742f0d4d6
    ],
    2341007311: [
        $3b8da494b8e92f36$export$813f9cf6a2209fec,
        $3b8da494b8e92f36$export$dfec9be971c6e8a5,
        $3b8da494b8e92f36$export$bc9bd707c4403985,
        $3b8da494b8e92f36$export$f650b9b610878411,
        $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
        $3b8da494b8e92f36$export$cff3fa05b2018b59,
        $3b8da494b8e92f36$export$79a1ba43c7a549ce,
        $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
        $3b8da494b8e92f36$export$d35785e0f77dbe69,
        $3b8da494b8e92f36$export$b1832f175144bc77,
        $3b8da494b8e92f36$export$2e330e8e36019063,
        $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
        $3b8da494b8e92f36$export$96504c3b59e8a728,
        $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
        $3b8da494b8e92f36$export$a712aed3e137585e,
        $3b8da494b8e92f36$export$c331bec3b085e9a1,
        $3b8da494b8e92f36$export$2bafde249aab99b4,
        $3b8da494b8e92f36$export$8d69d79340327b03,
        $3b8da494b8e92f36$export$c33f71f232dbf671,
        $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
        $3b8da494b8e92f36$export$9cb68f339a367600,
        $3b8da494b8e92f36$export$51e6468498cab028,
        $3b8da494b8e92f36$export$20528f2adfe8dc9c,
        $3b8da494b8e92f36$export$9572797f2851b0,
        $3b8da494b8e92f36$export$b933598a67b23044,
        $3b8da494b8e92f36$export$976ca854e309f825,
        $3b8da494b8e92f36$export$1fe9178d23052979,
        $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
        $3b8da494b8e92f36$export$94d1e1fe7b940759,
        $3b8da494b8e92f36$export$2b794d8b645d7087,
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c,
        $3b8da494b8e92f36$export$4a59ec454710396a,
        $3b8da494b8e92f36$export$a636087bbbf1a084,
        $3b8da494b8e92f36$export$4f578206c5065f1f,
        $3b8da494b8e92f36$export$90569318bbf3a5cb,
        $3b8da494b8e92f36$export$3fd59b6be292fb81,
        $3b8da494b8e92f36$export$8bef70def9fcccef,
        $3b8da494b8e92f36$export$8f026b620b6b36d2,
        $3b8da494b8e92f36$export$89d3022d89ef3649,
        $3b8da494b8e92f36$export$c7eeffff290e6124,
        $3b8da494b8e92f36$export$87c3ff288d974d02,
        $3b8da494b8e92f36$export$5c698c7bb50b493,
        $3b8da494b8e92f36$export$422809562a8398de,
        $3b8da494b8e92f36$export$a48481dfef95f4a2,
        $3b8da494b8e92f36$export$d68e05a23c1f8359,
        $3b8da494b8e92f36$export$95d386c017712592,
        $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
        $3b8da494b8e92f36$export$d988060319005ccc,
        $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
        $3b8da494b8e92f36$export$6c8179c0d6d08ecd,
        $3b8da494b8e92f36$export$825f7cab9140cf42,
        $3b8da494b8e92f36$export$6dac613d32d3427f,
        $3b8da494b8e92f36$export$23fb84fb575e1cb4,
        $3b8da494b8e92f36$export$67177aa5e10d7edd,
        $3b8da494b8e92f36$export$2abd1abb4fbec99a,
        $3b8da494b8e92f36$export$11ccca7a6068fc2c,
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$b58a07450f76f5f4,
        $3b8da494b8e92f36$export$f27d665fae434b5e,
        $3b8da494b8e92f36$export$ae9001e98ea773dd,
        $3b8da494b8e92f36$export$3eb2ff47f0213310,
        $3b8da494b8e92f36$export$de24c94bb0d02a47,
        $3b8da494b8e92f36$export$c97535012f6ac326,
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$4e0003e3499b7937,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$57379c20a5f35b14,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09,
        $3b8da494b8e92f36$export$f43ad39311bcb56,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$8e15250779a21ef,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c,
        $3b8da494b8e92f36$export$573337cb0f58bf7b,
        $3b8da494b8e92f36$export$4690a2f5205975d8,
        $3b8da494b8e92f36$export$d4f0edab93018f7f,
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1,
        $3b8da494b8e92f36$export$5591fe75469fbc36,
        $3b8da494b8e92f36$export$15d220a8d3840c2b,
        $3b8da494b8e92f36$export$b9eca9ef3b8d6669,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$2594575309e586b5,
        $3b8da494b8e92f36$export$8f9be165ecf1e4df,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$c8107dc828f27d75,
        $3b8da494b8e92f36$export$e09bab7a22edd350,
        $3b8da494b8e92f36$export$b885f77cbc299c4,
        $3b8da494b8e92f36$export$32d390b4d2721141,
        $3b8da494b8e92f36$export$f3c5edda9fcffe08,
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$fc44e3e1a7a655b8,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$882807e675fb9068,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$baebabf49e14381f,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$fd80d94bec4f0a5b,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$85aee7ae7c03d05a,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$8b38478acd341f50,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$621164991f057b60,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$148542c71c2cd1c6,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$58e8ff1cdcf5d006,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$fa079470b767c651,
        $3b8da494b8e92f36$export$bc6fb4287404ee80,
        $3b8da494b8e92f36$export$cf79a786a1f31c67,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$9c2743d05a45981d,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$aea7c0bc4ec470d9,
        $3b8da494b8e92f36$export$510370982f2cd70b,
        $3b8da494b8e92f36$export$d913f9a28f897cb4,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$e3e5acb3f314f36e,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$df9b2345d13dc8f2,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$7758680385d7f5d0,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$3e99d4f5fb74344a,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$5c7124f036f5261b,
        $3b8da494b8e92f36$export$77890d3c0e815d73,
        $3b8da494b8e92f36$export$ba9b533eb93c61e6,
        $3b8da494b8e92f36$export$c6db94a21532bc0,
        $3b8da494b8e92f36$export$c9e95b59bddb461b,
        $3b8da494b8e92f36$export$590a133adb265ce2,
        $3b8da494b8e92f36$export$3120d79bc0036ae8,
        $3b8da494b8e92f36$export$27c232e08a5c1615,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$689c1ff4f7778216,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$63c3891ef0655b46,
        $3b8da494b8e92f36$export$5988cb69223093bd,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$a6d7d4ab29f210d8,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$fc1d66d7d457d0bd,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$13e708936da24a68,
        $3b8da494b8e92f36$export$222e5cfe959e7091,
        $3b8da494b8e92f36$export$6d6a87bbda8f8f8f,
        $3b8da494b8e92f36$export$b27765c1626bd4e5,
        $3b8da494b8e92f36$export$2430d0e5fe5a448e,
        $3b8da494b8e92f36$export$21e17a46032a87f8,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$621ee50854ea2931,
        $3b8da494b8e92f36$export$cbecbfc736c5fee6,
        $3b8da494b8e92f36$export$3d4b06c2ec93a11c,
        $3b8da494b8e92f36$export$9586a13e6aa3297b,
        $3b8da494b8e92f36$export$c8c6cd13ee455751,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$cc78bfb1fd84dc0c,
        $3b8da494b8e92f36$export$91748340fd72a888,
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$d14ef3fe75da3f4,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6,
        $3b8da494b8e92f36$export$22d84e75fa702951,
        $3b8da494b8e92f36$export$aa818ced04ed1ad6,
        $3b8da494b8e92f36$export$4f9b13f55d01f662,
        $3b8da494b8e92f36$export$7bec46e80091ced6,
        $3b8da494b8e92f36$export$ae975bd6a53dc3da,
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e,
        $3b8da494b8e92f36$export$3d378e730e40374,
        $3b8da494b8e92f36$export$b05d4b54ea7217ba,
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8ab37c04c221437e,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$65425f7fe03c67e3,
        $3b8da494b8e92f36$export$bf8da5dfd8f2bbd7,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$36865c33f6b928df,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$20d4cd77bb23839a,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$8ecb1acc5cef3623,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$4aad03902b9ab9b7,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$8ec901ef3dd34dee,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$30c0a743764a442d,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac3368af3a97899c,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$a71ce1f807a99ffa,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$658f97b35e3ab77a,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$a319cba82d87c3cb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$bde4b2f022aa3cc3,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$ae5ea07bb40f05a4,
        $3b8da494b8e92f36$export$d9ea6d65e35c77e6,
        $3b8da494b8e92f36$export$1b9d9b67f9494a,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$bc2d1907fc896c9e,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$1571a6a1a0ef60d5,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$261b3d86b8abacc9,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$6348979270e0ef76,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$a118d3359be4f9d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$a39811f2fb3014d9,
        $3b8da494b8e92f36$export$e925431939456153,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$fe64d2939a7bcd9f,
        $3b8da494b8e92f36$export$b09c679f1085725a,
        $3b8da494b8e92f36$export$c81d279acf1b12b4,
        $3b8da494b8e92f36$export$599b343cb1d64b49,
        $3b8da494b8e92f36$export$60411d6f391d4743,
        $3b8da494b8e92f36$export$9418e91392f50813,
        $3b8da494b8e92f36$export$933e35db50e6a51e
    ],
    1054537805: [
        $3b8da494b8e92f36$export$995f2435226e1b6a,
        $3b8da494b8e92f36$export$a568399b60500b43,
        $3b8da494b8e92f36$export$1c250d1efa52f027,
        $3b8da494b8e92f36$export$c259b6fe2d03e118,
        $3b8da494b8e92f36$export$25d64be31bf108b,
        $3b8da494b8e92f36$export$cfb1203a57a5f31c
    ],
    3982875396: [
        $3b8da494b8e92f36$export$5f0eb5061797e589,
        $3b8da494b8e92f36$export$982f17a83654a1a9
    ],
    2273995522: [
        $3b8da494b8e92f36$export$7bbc953ffa23813a,
        $3b8da494b8e92f36$export$b4e4bbdecfda501
    ],
    2162789131: [
        $3b8da494b8e92f36$export$ebcd8907887dc222,
        $3b8da494b8e92f36$export$34a05c9e12c53c23,
        $3b8da494b8e92f36$export$a413c76fb80f2f8f,
        $3b8da494b8e92f36$export$3787e1faec59f84d,
        $3b8da494b8e92f36$export$17bdef5f951eb73a,
        $3b8da494b8e92f36$export$ceebe0114638d080,
        $3b8da494b8e92f36$export$1256946afdc9c505,
        $3b8da494b8e92f36$export$6b91369e24532c08,
        $3b8da494b8e92f36$export$2488f86e43e28df,
        $3b8da494b8e92f36$export$aaf8576a4abe9819,
        $3b8da494b8e92f36$export$f8bd1434641262e3
    ],
    609421318: [
        $3b8da494b8e92f36$export$ebcd8907887dc222,
        $3b8da494b8e92f36$export$34a05c9e12c53c23,
        $3b8da494b8e92f36$export$a413c76fb80f2f8f,
        $3b8da494b8e92f36$export$3787e1faec59f84d,
        $3b8da494b8e92f36$export$17bdef5f951eb73a,
        $3b8da494b8e92f36$export$ceebe0114638d080,
        $3b8da494b8e92f36$export$1256946afdc9c505,
        $3b8da494b8e92f36$export$6b91369e24532c08,
        $3b8da494b8e92f36$export$2488f86e43e28df
    ],
    2525727697: [
        $3b8da494b8e92f36$export$34a05c9e12c53c23,
        $3b8da494b8e92f36$export$a413c76fb80f2f8f,
        $3b8da494b8e92f36$export$3787e1faec59f84d,
        $3b8da494b8e92f36$export$17bdef5f951eb73a,
        $3b8da494b8e92f36$export$ceebe0114638d080,
        $3b8da494b8e92f36$export$1256946afdc9c505,
        $3b8da494b8e92f36$export$6b91369e24532c08
    ],
    2830218821: [
        $3b8da494b8e92f36$export$e8d16de4476cf00b
    ],
    846575682: [
        $3b8da494b8e92f36$export$102bd971c14ba988
    ],
    626085974: [
        $3b8da494b8e92f36$export$d3d6625d33fe749f,
        $3b8da494b8e92f36$export$28f95f3a6633e96f,
        $3b8da494b8e92f36$export$cdda591705a51882
    ],
    1549132990: [
        $3b8da494b8e92f36$export$25d64be31bf108b
    ],
    280115917: [
        $3b8da494b8e92f36$export$1e82cbdcd9fe6ab9,
        $3b8da494b8e92f36$export$12c8486b22f747b4,
        $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
        $3b8da494b8e92f36$export$925b578047892bce,
        $3b8da494b8e92f36$export$cc681b8347ae2d28
    ],
    222769930: [
        $3b8da494b8e92f36$export$e6abbc136a759ca9
    ],
    3101149627: [
        $3b8da494b8e92f36$export$3535b249460c70df,
        $3b8da494b8e92f36$export$9fb6085672705774
    ],
    1377556343: [
        $3b8da494b8e92f36$export$52eaa2d341700ec1,
        $3b8da494b8e92f36$export$804200e8992a9b20,
        $3b8da494b8e92f36$export$e209a4a7e118ebd5,
        $3b8da494b8e92f36$export$1dcd1852764e4fb7,
        $3b8da494b8e92f36$export$c75f1a12de9d86b8,
        $3b8da494b8e92f36$export$720f149ff6c3542a,
        $3b8da494b8e92f36$export$3534ea9b1da643f3,
        $3b8da494b8e92f36$export$55b4788f85a51e1a,
        $3b8da494b8e92f36$export$5a54e2173db7aff1,
        $3b8da494b8e92f36$export$6c1d729adeeaed4a,
        $3b8da494b8e92f36$export$a88a630c8a34962c,
        $3b8da494b8e92f36$export$3d22c077bdb90a75,
        $3b8da494b8e92f36$export$7beb7cab9d3e2b14,
        $3b8da494b8e92f36$export$4b2fd6d0e55ecfa0,
        $3b8da494b8e92f36$export$8176d17ddc845867,
        $3b8da494b8e92f36$export$dd210e591847e415,
        $3b8da494b8e92f36$export$873d7c14f646e598,
        $3b8da494b8e92f36$export$5993765fc33cd311,
        $3b8da494b8e92f36$export$c780a52ecdcabf01
    ],
    2799835756: [
        $3b8da494b8e92f36$export$5993765fc33cd311
    ],
    3798115385: [
        $3b8da494b8e92f36$export$7d329955417ee03b
    ],
    1310608509: [
        $3b8da494b8e92f36$export$3c5dfd8f9406db1
    ],
    3264961684: [
        $3b8da494b8e92f36$export$856784adecc150fd
    ],
    370225590: [
        $3b8da494b8e92f36$export$8176d17ddc845867,
        $3b8da494b8e92f36$export$dd210e591847e415
    ],
    2889183280: [
        $3b8da494b8e92f36$export$c792ec963053411b
    ],
    3632507154: [
        $3b8da494b8e92f36$export$6ff606ccfc58f5bb
    ],
    3900360178: [
        $3b8da494b8e92f36$export$a88a630c8a34962c,
        $3b8da494b8e92f36$export$3d22c077bdb90a75,
        $3b8da494b8e92f36$export$7beb7cab9d3e2b14
    ],
    297599258: [
        $3b8da494b8e92f36$export$925767a3ae3a4925,
        $3b8da494b8e92f36$export$d8f086a59e04ee25
    ],
    2556980723: [
        $3b8da494b8e92f36$export$55b4788f85a51e1a,
        $3b8da494b8e92f36$export$5a54e2173db7aff1
    ],
    1809719519: [
        $3b8da494b8e92f36$export$720f149ff6c3542a
    ],
    3008276851: [
        $3b8da494b8e92f36$export$55b4788f85a51e1a
    ],
    3448662350: [
        $3b8da494b8e92f36$export$c78a940a5c4e916a
    ],
    2453401579: [
        $3b8da494b8e92f36$export$9aea5e4278bdf41,
        $3b8da494b8e92f36$export$521bada8515ab976,
        $3b8da494b8e92f36$export$5549d05fc93b536b,
        $3b8da494b8e92f36$export$ef6ede6699415aa4,
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f,
        $3b8da494b8e92f36$export$ec4770aab56c805f,
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$569b2f842286694a,
        $3b8da494b8e92f36$export$ae61b17b9a1def4f,
        $3b8da494b8e92f36$export$14f69d2c614ba0a3,
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f,
        $3b8da494b8e92f36$export$7952e91536a239e7,
        $3b8da494b8e92f36$export$cddab537799fe2fd,
        $3b8da494b8e92f36$export$922fa769a539de57,
        $3b8da494b8e92f36$export$85f2457f407ffd38,
        $3b8da494b8e92f36$export$c71362c4ed185b32,
        $3b8da494b8e92f36$export$930ecb71bb54f6b9,
        $3b8da494b8e92f36$export$71a20a295551861d,
        $3b8da494b8e92f36$export$21377908e11164b8,
        $3b8da494b8e92f36$export$fd146d5f53fefc87,
        $3b8da494b8e92f36$export$9c60c9750bd86c93,
        $3b8da494b8e92f36$export$eae2f9556d21859d,
        $3b8da494b8e92f36$export$889cc41214b5970c,
        $3b8da494b8e92f36$export$1721bccc01fce10a,
        $3b8da494b8e92f36$export$3a90cd7486e7bfc7,
        $3b8da494b8e92f36$export$7ff49950c8e89377,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43,
        $3b8da494b8e92f36$export$ff5167510e50ee26,
        $3b8da494b8e92f36$export$6c79cacc663fc254,
        $3b8da494b8e92f36$export$5f769669c17cd7be,
        $3b8da494b8e92f36$export$aba424e86850f717,
        $3b8da494b8e92f36$export$2a2b17b32d1a9938,
        $3b8da494b8e92f36$export$f1de0c39f08c8646,
        $3b8da494b8e92f36$export$36783435db2b01a1,
        $3b8da494b8e92f36$export$d414ecd4014891b0,
        $3b8da494b8e92f36$export$5655bbb83559ae0a,
        $3b8da494b8e92f36$export$64fbfc27b4cec02a,
        $3b8da494b8e92f36$export$843f1ace19c7b757,
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252,
        $3b8da494b8e92f36$export$88babb7bc763dabe,
        $3b8da494b8e92f36$export$86be59b19ba0bac8,
        $3b8da494b8e92f36$export$e5527fc80680ccac,
        $3b8da494b8e92f36$export$d0a6287d5fe2b0d0,
        $3b8da494b8e92f36$export$24551edc0d1c7c9e,
        $3b8da494b8e92f36$export$36a18b804a497897,
        $3b8da494b8e92f36$export$a340b94c3a9627f5,
        $3b8da494b8e92f36$export$a93e600de3d261bf,
        $3b8da494b8e92f36$export$6b50b93a9a443e09,
        $3b8da494b8e92f36$export$aa7ed498f6d760b8,
        $3b8da494b8e92f36$export$fd5f089562b081f9,
        $3b8da494b8e92f36$export$baa116807524c06e,
        $3b8da494b8e92f36$export$cf616a1a67553ce5,
        $3b8da494b8e92f36$export$df1aea6f3c3fdd3,
        $3b8da494b8e92f36$export$2ecfbeca9fa8edbd,
        $3b8da494b8e92f36$export$be55db5658261c24,
        $3b8da494b8e92f36$export$e759ffb34c88cdbb,
        $3b8da494b8e92f36$export$a15ad7bc84af942e,
        $3b8da494b8e92f36$export$70128586019a4a85,
        $3b8da494b8e92f36$export$406ae3ea561cdfed,
        $3b8da494b8e92f36$export$a633a7857c4afb8b,
        $3b8da494b8e92f36$export$8bcad0fd81ccef4e,
        $3b8da494b8e92f36$export$7c3b7ecc8dd17171,
        $3b8da494b8e92f36$export$32b9b3ebd4722148,
        $3b8da494b8e92f36$export$60c94e2d2eb3ae2d,
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d,
        $3b8da494b8e92f36$export$14920f38b00f3073,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$4bb861b4bba551ce,
        $3b8da494b8e92f36$export$7a8fab203344ee59,
        $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b,
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a,
        $3b8da494b8e92f36$export$e7d69479b3ed50b5,
        $3b8da494b8e92f36$export$aea7582eed012cfd,
        $3b8da494b8e92f36$export$25fbf7852b3a8a34,
        $3b8da494b8e92f36$export$e545ccdc4ae42e81,
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f,
        $3b8da494b8e92f36$export$45f4c4bef325c6de,
        $3b8da494b8e92f36$export$212932c39cad14c1,
        $3b8da494b8e92f36$export$a7c9a308bd61791e,
        $3b8da494b8e92f36$export$9462ca86e16364d3,
        $3b8da494b8e92f36$export$2ef492eaafc1544a,
        $3b8da494b8e92f36$export$fe015439a6fa96b6,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$f03ac9a18a5a000,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$7ac92bdfbda997a6,
        $3b8da494b8e92f36$export$cc878395e6134df2,
        $3b8da494b8e92f36$export$6eda1fffe4033879,
        $3b8da494b8e92f36$export$db3cb7c28fcdcb12,
        $3b8da494b8e92f36$export$1fe9373d30daf09d,
        $3b8da494b8e92f36$export$f0268edfa147e5dc,
        $3b8da494b8e92f36$export$702326c0288a963,
        $3b8da494b8e92f36$export$5478cb2985eabb5a,
        $3b8da494b8e92f36$export$d919945f72bbea0b,
        $3b8da494b8e92f36$export$301a7e858fe85036,
        $3b8da494b8e92f36$export$9de8356191dd818,
        $3b8da494b8e92f36$export$929165ba65228ecd,
        $3b8da494b8e92f36$export$8923f08b310dd8eb,
        $3b8da494b8e92f36$export$f9263ceb04bc6af7,
        $3b8da494b8e92f36$export$b2d243272d4e7e07,
        $3b8da494b8e92f36$export$f181705801de6aa3,
        $3b8da494b8e92f36$export$a8dfee375f66477,
        $3b8da494b8e92f36$export$53e8d872a4770e53,
        $3b8da494b8e92f36$export$aa97e6334e80a8ca,
        $3b8da494b8e92f36$export$51d4dba1ae2d8f1b,
        $3b8da494b8e92f36$export$307e928f69359e15,
        $3b8da494b8e92f36$export$ad8e83777baa8a31,
        $3b8da494b8e92f36$export$48039412bed87667,
        $3b8da494b8e92f36$export$f91087a08c2974c5,
        $3b8da494b8e92f36$export$a205ad382a675d9,
        $3b8da494b8e92f36$export$7d2f047f3374cd6d,
        $3b8da494b8e92f36$export$91b809c3774b52ca,
        $3b8da494b8e92f36$export$8799bf99f01d0b68,
        $3b8da494b8e92f36$export$117debe45e2ae49d,
        $3b8da494b8e92f36$export$ebd3184cd8b065fd,
        $3b8da494b8e92f36$export$e569b2ccaf52a8fd,
        $3b8da494b8e92f36$export$fc934d2c514a6d85,
        $3b8da494b8e92f36$export$20db6cfb2db45f44,
        $3b8da494b8e92f36$export$70c90f142bc37811
    ],
    3590301190: [
        $3b8da494b8e92f36$export$20db6cfb2db45f44
    ],
    812098782: [
        $3b8da494b8e92f36$export$ebd3184cd8b065fd,
        $3b8da494b8e92f36$export$e569b2ccaf52a8fd
    ],
    1437953363: [
        $3b8da494b8e92f36$export$1e82cbdcd9fe6ab9,
        $3b8da494b8e92f36$export$12c8486b22f747b4
    ],
    1402838566: [
        $3b8da494b8e92f36$export$f91087a08c2974c5,
        $3b8da494b8e92f36$export$a205ad382a675d9,
        $3b8da494b8e92f36$export$7d2f047f3374cd6d,
        $3b8da494b8e92f36$export$91b809c3774b52ca,
        $3b8da494b8e92f36$export$8799bf99f01d0b68
    ],
    1520743889: [
        $3b8da494b8e92f36$export$f91087a08c2974c5
    ],
    1008929658: [
        $3b8da494b8e92f36$export$804200e8992a9b20,
        $3b8da494b8e92f36$export$e209a4a7e118ebd5,
        $3b8da494b8e92f36$export$1dcd1852764e4fb7
    ],
    3079605661: [
        $3b8da494b8e92f36$export$ac428444f42ac73b
    ],
    219451334: [
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$4e0003e3499b7937,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$57379c20a5f35b14,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09,
        $3b8da494b8e92f36$export$f43ad39311bcb56,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$8e15250779a21ef,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c,
        $3b8da494b8e92f36$export$573337cb0f58bf7b,
        $3b8da494b8e92f36$export$4690a2f5205975d8,
        $3b8da494b8e92f36$export$d4f0edab93018f7f,
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1,
        $3b8da494b8e92f36$export$5591fe75469fbc36,
        $3b8da494b8e92f36$export$15d220a8d3840c2b,
        $3b8da494b8e92f36$export$b9eca9ef3b8d6669,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$2594575309e586b5,
        $3b8da494b8e92f36$export$8f9be165ecf1e4df,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$c8107dc828f27d75,
        $3b8da494b8e92f36$export$e09bab7a22edd350,
        $3b8da494b8e92f36$export$b885f77cbc299c4,
        $3b8da494b8e92f36$export$32d390b4d2721141,
        $3b8da494b8e92f36$export$f3c5edda9fcffe08,
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$fc44e3e1a7a655b8,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$882807e675fb9068,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$baebabf49e14381f,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$fd80d94bec4f0a5b,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$85aee7ae7c03d05a,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$8b38478acd341f50,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$621164991f057b60,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$148542c71c2cd1c6,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$58e8ff1cdcf5d006,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$fa079470b767c651,
        $3b8da494b8e92f36$export$bc6fb4287404ee80,
        $3b8da494b8e92f36$export$cf79a786a1f31c67,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$9c2743d05a45981d,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$aea7c0bc4ec470d9,
        $3b8da494b8e92f36$export$510370982f2cd70b,
        $3b8da494b8e92f36$export$d913f9a28f897cb4,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$e3e5acb3f314f36e,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$df9b2345d13dc8f2,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$7758680385d7f5d0,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$3e99d4f5fb74344a,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$5c7124f036f5261b,
        $3b8da494b8e92f36$export$77890d3c0e815d73,
        $3b8da494b8e92f36$export$ba9b533eb93c61e6,
        $3b8da494b8e92f36$export$c6db94a21532bc0,
        $3b8da494b8e92f36$export$c9e95b59bddb461b,
        $3b8da494b8e92f36$export$590a133adb265ce2,
        $3b8da494b8e92f36$export$3120d79bc0036ae8,
        $3b8da494b8e92f36$export$27c232e08a5c1615,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$689c1ff4f7778216,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$63c3891ef0655b46,
        $3b8da494b8e92f36$export$5988cb69223093bd,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$a6d7d4ab29f210d8,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$fc1d66d7d457d0bd,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$13e708936da24a68,
        $3b8da494b8e92f36$export$222e5cfe959e7091,
        $3b8da494b8e92f36$export$6d6a87bbda8f8f8f,
        $3b8da494b8e92f36$export$b27765c1626bd4e5,
        $3b8da494b8e92f36$export$2430d0e5fe5a448e,
        $3b8da494b8e92f36$export$21e17a46032a87f8,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$621ee50854ea2931,
        $3b8da494b8e92f36$export$cbecbfc736c5fee6,
        $3b8da494b8e92f36$export$3d4b06c2ec93a11c,
        $3b8da494b8e92f36$export$9586a13e6aa3297b,
        $3b8da494b8e92f36$export$c8c6cd13ee455751,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$cc78bfb1fd84dc0c,
        $3b8da494b8e92f36$export$91748340fd72a888,
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$d14ef3fe75da3f4,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6,
        $3b8da494b8e92f36$export$22d84e75fa702951,
        $3b8da494b8e92f36$export$aa818ced04ed1ad6,
        $3b8da494b8e92f36$export$4f9b13f55d01f662,
        $3b8da494b8e92f36$export$7bec46e80091ced6,
        $3b8da494b8e92f36$export$ae975bd6a53dc3da,
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e,
        $3b8da494b8e92f36$export$3d378e730e40374,
        $3b8da494b8e92f36$export$b05d4b54ea7217ba,
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8ab37c04c221437e,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$65425f7fe03c67e3,
        $3b8da494b8e92f36$export$bf8da5dfd8f2bbd7,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$36865c33f6b928df,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$20d4cd77bb23839a,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$8ecb1acc5cef3623,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$4aad03902b9ab9b7,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$8ec901ef3dd34dee,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$30c0a743764a442d,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac3368af3a97899c,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$a71ce1f807a99ffa,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$658f97b35e3ab77a,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$a319cba82d87c3cb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$bde4b2f022aa3cc3,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$ae5ea07bb40f05a4,
        $3b8da494b8e92f36$export$d9ea6d65e35c77e6,
        $3b8da494b8e92f36$export$1b9d9b67f9494a,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$bc2d1907fc896c9e,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$1571a6a1a0ef60d5,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$261b3d86b8abacc9,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$6348979270e0ef76,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$a118d3359be4f9d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$a39811f2fb3014d9,
        $3b8da494b8e92f36$export$e925431939456153,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$fe64d2939a7bcd9f,
        $3b8da494b8e92f36$export$b09c679f1085725a,
        $3b8da494b8e92f36$export$c81d279acf1b12b4,
        $3b8da494b8e92f36$export$599b343cb1d64b49,
        $3b8da494b8e92f36$export$60411d6f391d4743,
        $3b8da494b8e92f36$export$9418e91392f50813
    ],
    2529465313: [
        $3b8da494b8e92f36$export$78c21ee34d1c97a2,
        $3b8da494b8e92f36$export$4f772a6ff028612d,
        $3b8da494b8e92f36$export$6cce02eb19410fd6,
        $3b8da494b8e92f36$export$9bf9b7d525eb98c7,
        $3b8da494b8e92f36$export$509dfb8dfad057e9,
        $3b8da494b8e92f36$export$6659a6bebb9ff076,
        $3b8da494b8e92f36$export$9f98ad7f69b4,
        $3b8da494b8e92f36$export$3e010693b51db065,
        $3b8da494b8e92f36$export$5046f8ea20f33c53,
        $3b8da494b8e92f36$export$6a6339501d69dda6,
        $3b8da494b8e92f36$export$24e4f709acf9819a,
        $3b8da494b8e92f36$export$2c0c343d0211b12a,
        $3b8da494b8e92f36$export$bb7bafb36fa737d0,
        $3b8da494b8e92f36$export$9d1f507a1764cea9
    ],
    2004835150: [
        $3b8da494b8e92f36$export$aa97e6334e80a8ca,
        $3b8da494b8e92f36$export$51d4dba1ae2d8f1b,
        $3b8da494b8e92f36$export$307e928f69359e15,
        $3b8da494b8e92f36$export$ad8e83777baa8a31
    ],
    1663979128: [
        $3b8da494b8e92f36$export$a8dfee375f66477
    ],
    2067069095: [
        $3b8da494b8e92f36$export$929165ba65228ecd,
        $3b8da494b8e92f36$export$8923f08b310dd8eb,
        $3b8da494b8e92f36$export$f9263ceb04bc6af7,
        $3b8da494b8e92f36$export$b2d243272d4e7e07
    ],
    3727388367: [
        $3b8da494b8e92f36$export$2c91bae7185bb7c5,
        $3b8da494b8e92f36$export$42292ad7a949ca7e,
        $3b8da494b8e92f36$export$2a79ce8e6dde1605,
        $3b8da494b8e92f36$export$d18f4beaf4701e94,
        $3b8da494b8e92f36$export$56d725cc20359b33,
        $3b8da494b8e92f36$export$e24694355c430317
    ],
    3778827333: [
        $3b8da494b8e92f36$export$8ada78967ce0de43,
        $3b8da494b8e92f36$export$2f757802d81974e2,
        $3b8da494b8e92f36$export$f4438fbaac045e16
    ],
    1775413392: [
        $3b8da494b8e92f36$export$56d725cc20359b33
    ],
    2598011224: [
        $3b8da494b8e92f36$export$ea419368a3085d41,
        $3b8da494b8e92f36$export$18fc149087e3c79f,
        $3b8da494b8e92f36$export$9f8310d680636df4,
        $3b8da494b8e92f36$export$2d97768d0015dccc,
        $3b8da494b8e92f36$export$b40b280750874c4,
        $3b8da494b8e92f36$export$421fb9d9a3f56509,
        $3b8da494b8e92f36$export$2ee49241e76b8d88,
        $3b8da494b8e92f36$export$15997dea423f274a
    ],
    1680319473: [
        $3b8da494b8e92f36$export$825f7cab9140cf42,
        $3b8da494b8e92f36$export$6dac613d32d3427f,
        $3b8da494b8e92f36$export$23fb84fb575e1cb4,
        $3b8da494b8e92f36$export$67177aa5e10d7edd,
        $3b8da494b8e92f36$export$2abd1abb4fbec99a,
        $3b8da494b8e92f36$export$11ccca7a6068fc2c,
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$b58a07450f76f5f4,
        $3b8da494b8e92f36$export$f27d665fae434b5e,
        $3b8da494b8e92f36$export$ae9001e98ea773dd,
        $3b8da494b8e92f36$export$3eb2ff47f0213310,
        $3b8da494b8e92f36$export$de24c94bb0d02a47
    ],
    3357820518: [
        $3b8da494b8e92f36$export$11ccca7a6068fc2c,
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$b58a07450f76f5f4,
        $3b8da494b8e92f36$export$f27d665fae434b5e,
        $3b8da494b8e92f36$export$ae9001e98ea773dd,
        $3b8da494b8e92f36$export$3eb2ff47f0213310
    ],
    1482703590: [
        $3b8da494b8e92f36$export$825f7cab9140cf42,
        $3b8da494b8e92f36$export$6dac613d32d3427f,
        $3b8da494b8e92f36$export$23fb84fb575e1cb4,
        $3b8da494b8e92f36$export$67177aa5e10d7edd
    ],
    2090586900: [
        $3b8da494b8e92f36$export$ae9001e98ea773dd
    ],
    3615266464: [
        $3b8da494b8e92f36$export$2c0c343d0211b12a,
        $3b8da494b8e92f36$export$bb7bafb36fa737d0
    ],
    478536968: [
        $3b8da494b8e92f36$export$813f9cf6a2209fec,
        $3b8da494b8e92f36$export$dfec9be971c6e8a5,
        $3b8da494b8e92f36$export$bc9bd707c4403985,
        $3b8da494b8e92f36$export$f650b9b610878411,
        $3b8da494b8e92f36$export$d4b22dc6a2f55e73,
        $3b8da494b8e92f36$export$cff3fa05b2018b59,
        $3b8da494b8e92f36$export$79a1ba43c7a549ce,
        $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
        $3b8da494b8e92f36$export$d35785e0f77dbe69,
        $3b8da494b8e92f36$export$b1832f175144bc77,
        $3b8da494b8e92f36$export$2e330e8e36019063,
        $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
        $3b8da494b8e92f36$export$96504c3b59e8a728,
        $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
        $3b8da494b8e92f36$export$a712aed3e137585e,
        $3b8da494b8e92f36$export$c331bec3b085e9a1,
        $3b8da494b8e92f36$export$2bafde249aab99b4,
        $3b8da494b8e92f36$export$8d69d79340327b03,
        $3b8da494b8e92f36$export$c33f71f232dbf671,
        $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
        $3b8da494b8e92f36$export$9cb68f339a367600,
        $3b8da494b8e92f36$export$51e6468498cab028,
        $3b8da494b8e92f36$export$20528f2adfe8dc9c,
        $3b8da494b8e92f36$export$9572797f2851b0,
        $3b8da494b8e92f36$export$b933598a67b23044,
        $3b8da494b8e92f36$export$976ca854e309f825,
        $3b8da494b8e92f36$export$1fe9178d23052979,
        $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
        $3b8da494b8e92f36$export$94d1e1fe7b940759,
        $3b8da494b8e92f36$export$2b794d8b645d7087,
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c,
        $3b8da494b8e92f36$export$4a59ec454710396a,
        $3b8da494b8e92f36$export$a636087bbbf1a084,
        $3b8da494b8e92f36$export$4f578206c5065f1f,
        $3b8da494b8e92f36$export$90569318bbf3a5cb,
        $3b8da494b8e92f36$export$3fd59b6be292fb81,
        $3b8da494b8e92f36$export$8bef70def9fcccef,
        $3b8da494b8e92f36$export$8f026b620b6b36d2,
        $3b8da494b8e92f36$export$89d3022d89ef3649,
        $3b8da494b8e92f36$export$c7eeffff290e6124,
        $3b8da494b8e92f36$export$87c3ff288d974d02,
        $3b8da494b8e92f36$export$5c698c7bb50b493,
        $3b8da494b8e92f36$export$422809562a8398de,
        $3b8da494b8e92f36$export$a48481dfef95f4a2,
        $3b8da494b8e92f36$export$d68e05a23c1f8359,
        $3b8da494b8e92f36$export$95d386c017712592,
        $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
        $3b8da494b8e92f36$export$d988060319005ccc,
        $3b8da494b8e92f36$export$bb5ce9eb5b74ac1
    ],
    823603102: [
        $3b8da494b8e92f36$export$702326c0288a963,
        $3b8da494b8e92f36$export$5478cb2985eabb5a,
        $3b8da494b8e92f36$export$d919945f72bbea0b
    ],
    3692461612: [
        $3b8da494b8e92f36$export$18fc149087e3c79f,
        $3b8da494b8e92f36$export$9f8310d680636df4,
        $3b8da494b8e92f36$export$2d97768d0015dccc,
        $3b8da494b8e92f36$export$b40b280750874c4,
        $3b8da494b8e92f36$export$421fb9d9a3f56509,
        $3b8da494b8e92f36$export$2ee49241e76b8d88
    ],
    723233188: [
        $3b8da494b8e92f36$export$25fbf7852b3a8a34,
        $3b8da494b8e92f36$export$e545ccdc4ae42e81,
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f,
        $3b8da494b8e92f36$export$45f4c4bef325c6de,
        $3b8da494b8e92f36$export$212932c39cad14c1,
        $3b8da494b8e92f36$export$a7c9a308bd61791e,
        $3b8da494b8e92f36$export$9462ca86e16364d3,
        $3b8da494b8e92f36$export$2ef492eaafc1544a,
        $3b8da494b8e92f36$export$fe015439a6fa96b6,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$f03ac9a18a5a000,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$7ac92bdfbda997a6,
        $3b8da494b8e92f36$export$cc878395e6134df2,
        $3b8da494b8e92f36$export$6eda1fffe4033879,
        $3b8da494b8e92f36$export$db3cb7c28fcdcb12
    ],
    2473145415: [
        $3b8da494b8e92f36$export$3787e1faec59f84d
    ],
    1597423693: [
        $3b8da494b8e92f36$export$34a05c9e12c53c23
    ],
    2513912981: [
        $3b8da494b8e92f36$export$406ae3ea561cdfed,
        $3b8da494b8e92f36$export$a633a7857c4afb8b,
        $3b8da494b8e92f36$export$8bcad0fd81ccef4e,
        $3b8da494b8e92f36$export$7c3b7ecc8dd17171,
        $3b8da494b8e92f36$export$32b9b3ebd4722148,
        $3b8da494b8e92f36$export$60c94e2d2eb3ae2d,
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d,
        $3b8da494b8e92f36$export$14920f38b00f3073,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$4bb861b4bba551ce,
        $3b8da494b8e92f36$export$7a8fab203344ee59,
        $3b8da494b8e92f36$export$7a70cb8cfbcb9d2b,
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a,
        $3b8da494b8e92f36$export$e7d69479b3ed50b5
    ],
    2247615214: [
        $3b8da494b8e92f36$export$fe015439a6fa96b6,
        $3b8da494b8e92f36$export$a60bd1ba1e8134ca,
        $3b8da494b8e92f36$export$f03ac9a18a5a000,
        $3b8da494b8e92f36$export$e537328a93948147,
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$7ac92bdfbda997a6,
        $3b8da494b8e92f36$export$cc878395e6134df2,
        $3b8da494b8e92f36$export$6eda1fffe4033879
    ],
    1260650574: [
        $3b8da494b8e92f36$export$9462ca86e16364d3
    ],
    230924584: [
        $3b8da494b8e92f36$export$723dea784c83594a,
        $3b8da494b8e92f36$export$c551472fc9de690a
    ],
    901063453: [
        $3b8da494b8e92f36$export$cf616a1a67553ce5,
        $3b8da494b8e92f36$export$df1aea6f3c3fdd3,
        $3b8da494b8e92f36$export$2ecfbeca9fa8edbd,
        $3b8da494b8e92f36$export$be55db5658261c24,
        $3b8da494b8e92f36$export$e759ffb34c88cdbb,
        $3b8da494b8e92f36$export$a15ad7bc84af942e
    ],
    4282788508: [
        $3b8da494b8e92f36$export$fd5f089562b081f9
    ],
    1628702193: [
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e,
        $3b8da494b8e92f36$export$3d378e730e40374,
        $3b8da494b8e92f36$export$b05d4b54ea7217ba,
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8ab37c04c221437e,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$65425f7fe03c67e3,
        $3b8da494b8e92f36$export$bf8da5dfd8f2bbd7,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$36865c33f6b928df,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$20d4cd77bb23839a,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$8ecb1acc5cef3623,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$4aad03902b9ab9b7,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$8ec901ef3dd34dee,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$30c0a743764a442d,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac3368af3a97899c,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$a71ce1f807a99ffa,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$658f97b35e3ab77a,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$a319cba82d87c3cb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$bde4b2f022aa3cc3,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$ae5ea07bb40f05a4,
        $3b8da494b8e92f36$export$d9ea6d65e35c77e6,
        $3b8da494b8e92f36$export$1b9d9b67f9494a,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$bc2d1907fc896c9e,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$1571a6a1a0ef60d5,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$261b3d86b8abacc9,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$6348979270e0ef76,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$a118d3359be4f9d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$a39811f2fb3014d9,
        $3b8da494b8e92f36$export$e925431939456153,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1,
        $3b8da494b8e92f36$export$fe64d2939a7bcd9f,
        $3b8da494b8e92f36$export$b09c679f1085725a,
        $3b8da494b8e92f36$export$c81d279acf1b12b4,
        $3b8da494b8e92f36$export$599b343cb1d64b49,
        $3b8da494b8e92f36$export$60411d6f391d4743
    ],
    3736923433: [
        $3b8da494b8e92f36$export$b09c679f1085725a,
        $3b8da494b8e92f36$export$c81d279acf1b12b4,
        $3b8da494b8e92f36$export$599b343cb1d64b49
    ],
    2347495698: [
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf,
        $3b8da494b8e92f36$export$8ab37c04c221437e,
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$65425f7fe03c67e3,
        $3b8da494b8e92f36$export$bf8da5dfd8f2bbd7,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$36865c33f6b928df,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$20d4cd77bb23839a,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$8ecb1acc5cef3623,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$4aad03902b9ab9b7,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$8ec901ef3dd34dee,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$30c0a743764a442d,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac3368af3a97899c,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$a71ce1f807a99ffa,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$658f97b35e3ab77a,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$a319cba82d87c3cb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$bde4b2f022aa3cc3,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$ae5ea07bb40f05a4,
        $3b8da494b8e92f36$export$d9ea6d65e35c77e6,
        $3b8da494b8e92f36$export$1b9d9b67f9494a,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$bc2d1907fc896c9e,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$1571a6a1a0ef60d5,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$261b3d86b8abacc9,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$6348979270e0ef76,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$a118d3359be4f9d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$a39811f2fb3014d9,
        $3b8da494b8e92f36$export$e925431939456153,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8,
        $3b8da494b8e92f36$export$f1c306d0c6bd87c1
    ],
    3698973494: [
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e,
        $3b8da494b8e92f36$export$3d378e730e40374
    ],
    2736907675: [
        $3b8da494b8e92f36$export$a340b94c3a9627f5
    ],
    4182860854: [
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d,
        $3b8da494b8e92f36$export$14920f38b00f3073,
        $3b8da494b8e92f36$export$20b2a1f4dec0721b,
        $3b8da494b8e92f36$export$4bb861b4bba551ce,
        $3b8da494b8e92f36$export$7a8fab203344ee59
    ],
    574549367: [
        $3b8da494b8e92f36$export$e5527fc80680ccac,
        $3b8da494b8e92f36$export$d0a6287d5fe2b0d0
    ],
    59481748: [
        $3b8da494b8e92f36$export$64fbfc27b4cec02a,
        $3b8da494b8e92f36$export$843f1ace19c7b757,
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252,
        $3b8da494b8e92f36$export$88babb7bc763dabe
    ],
    3749851601: [
        $3b8da494b8e92f36$export$6b6b5ff5fe5ba252
    ],
    3331915920: [
        $3b8da494b8e92f36$export$64fbfc27b4cec02a
    ],
    1383045692: [
        $3b8da494b8e92f36$export$9bf9b7d525eb98c7
    ],
    2485617015: [
        $3b8da494b8e92f36$export$5478cb2985eabb5a
    ],
    2574617495: [
        $3b8da494b8e92f36$export$b545dd0102a18723,
        $3b8da494b8e92f36$export$140202a799be714a,
        $3b8da494b8e92f36$export$d615d46de51ad773,
        $3b8da494b8e92f36$export$5b70e847d8154d66,
        $3b8da494b8e92f36$export$bbeb77fbb7735b23,
        $3b8da494b8e92f36$export$8c2a8073f4f77e7e
    ],
    3419103109: [
        $3b8da494b8e92f36$export$4f9b13f55d01f662,
        $3b8da494b8e92f36$export$7bec46e80091ced6
    ],
    2506170314: [
        $3b8da494b8e92f36$export$aba424e86850f717,
        $3b8da494b8e92f36$export$2a2b17b32d1a9938,
        $3b8da494b8e92f36$export$f1de0c39f08c8646,
        $3b8da494b8e92f36$export$36783435db2b01a1,
        $3b8da494b8e92f36$export$d414ecd4014891b0
    ],
    2601014836: [
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f,
        $3b8da494b8e92f36$export$ec4770aab56c805f,
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$569b2f842286694a,
        $3b8da494b8e92f36$export$ae61b17b9a1def4f,
        $3b8da494b8e92f36$export$14f69d2c614ba0a3,
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f,
        $3b8da494b8e92f36$export$7952e91536a239e7,
        $3b8da494b8e92f36$export$cddab537799fe2fd,
        $3b8da494b8e92f36$export$922fa769a539de57,
        $3b8da494b8e92f36$export$85f2457f407ffd38,
        $3b8da494b8e92f36$export$c71362c4ed185b32,
        $3b8da494b8e92f36$export$930ecb71bb54f6b9,
        $3b8da494b8e92f36$export$71a20a295551861d,
        $3b8da494b8e92f36$export$21377908e11164b8,
        $3b8da494b8e92f36$export$fd146d5f53fefc87,
        $3b8da494b8e92f36$export$9c60c9750bd86c93,
        $3b8da494b8e92f36$export$eae2f9556d21859d,
        $3b8da494b8e92f36$export$889cc41214b5970c,
        $3b8da494b8e92f36$export$1721bccc01fce10a,
        $3b8da494b8e92f36$export$3a90cd7486e7bfc7,
        $3b8da494b8e92f36$export$7ff49950c8e89377,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43,
        $3b8da494b8e92f36$export$ff5167510e50ee26,
        $3b8da494b8e92f36$export$6c79cacc663fc254
    ],
    593015953: [
        $3b8da494b8e92f36$export$58866381b884e0eb,
        $3b8da494b8e92f36$export$7ac92bdfbda997a6,
        $3b8da494b8e92f36$export$cc878395e6134df2
    ],
    339256511: [
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$65425f7fe03c67e3,
        $3b8da494b8e92f36$export$bf8da5dfd8f2bbd7,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$36865c33f6b928df,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$20d4cd77bb23839a,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7,
        $3b8da494b8e92f36$export$50d67ce214025f0d,
        $3b8da494b8e92f36$export$1388d94b5491cc07,
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$8ecb1acc5cef3623,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$4aad03902b9ab9b7,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$8ec901ef3dd34dee,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$30c0a743764a442d,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac3368af3a97899c,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$a71ce1f807a99ffa,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a,
        $3b8da494b8e92f36$export$a1410ea7301e19b2,
        $3b8da494b8e92f36$export$2b01c18e55370ff,
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$658f97b35e3ab77a,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$a319cba82d87c3cb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$bde4b2f022aa3cc3,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$ae5ea07bb40f05a4,
        $3b8da494b8e92f36$export$d9ea6d65e35c77e6,
        $3b8da494b8e92f36$export$1b9d9b67f9494a,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$bc2d1907fc896c9e,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$1571a6a1a0ef60d5,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$261b3d86b8abacc9,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$6348979270e0ef76,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2,
        $3b8da494b8e92f36$export$a118d3359be4f9d8,
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$a39811f2fb3014d9,
        $3b8da494b8e92f36$export$e925431939456153,
        $3b8da494b8e92f36$export$61d02055f294889e,
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167,
        $3b8da494b8e92f36$export$5c5e42d238f720e8
    ],
    2777663545: [
        $3b8da494b8e92f36$export$a633a7857c4afb8b,
        $3b8da494b8e92f36$export$8bcad0fd81ccef4e,
        $3b8da494b8e92f36$export$7c3b7ecc8dd17171,
        $3b8da494b8e92f36$export$32b9b3ebd4722148
    ],
    477187591: [
        $3b8da494b8e92f36$export$f03ac9a18a5a000
    ],
    2652556860: [
        $3b8da494b8e92f36$export$7ac92bdfbda997a6
    ],
    4238390223: [
        $3b8da494b8e92f36$export$8e2240bc69b3bc6b,
        $3b8da494b8e92f36$export$6f6e43cda6d00167
    ],
    178912537: [
        $3b8da494b8e92f36$export$e759ffb34c88cdbb
    ],
    1425443689: [
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a,
        $3b8da494b8e92f36$export$24a3bc8472005843,
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f,
        $3b8da494b8e92f36$export$45f4c4bef325c6de
    ],
    3888040117: [
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$4e0003e3499b7937,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$57379c20a5f35b14,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09,
        $3b8da494b8e92f36$export$f43ad39311bcb56,
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$8e15250779a21ef,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c,
        $3b8da494b8e92f36$export$573337cb0f58bf7b,
        $3b8da494b8e92f36$export$4690a2f5205975d8,
        $3b8da494b8e92f36$export$d4f0edab93018f7f,
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1,
        $3b8da494b8e92f36$export$5591fe75469fbc36,
        $3b8da494b8e92f36$export$15d220a8d3840c2b,
        $3b8da494b8e92f36$export$b9eca9ef3b8d6669,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$2594575309e586b5,
        $3b8da494b8e92f36$export$8f9be165ecf1e4df,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$c8107dc828f27d75,
        $3b8da494b8e92f36$export$e09bab7a22edd350,
        $3b8da494b8e92f36$export$b885f77cbc299c4,
        $3b8da494b8e92f36$export$32d390b4d2721141,
        $3b8da494b8e92f36$export$f3c5edda9fcffe08,
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$fc44e3e1a7a655b8,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$882807e675fb9068,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$baebabf49e14381f,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$fd80d94bec4f0a5b,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$85aee7ae7c03d05a,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$8b38478acd341f50,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$621164991f057b60,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$148542c71c2cd1c6,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$58e8ff1cdcf5d006,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$fa079470b767c651,
        $3b8da494b8e92f36$export$bc6fb4287404ee80,
        $3b8da494b8e92f36$export$cf79a786a1f31c67,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$9c2743d05a45981d,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$aea7c0bc4ec470d9,
        $3b8da494b8e92f36$export$510370982f2cd70b,
        $3b8da494b8e92f36$export$d913f9a28f897cb4,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$e3e5acb3f314f36e,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$df9b2345d13dc8f2,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$7758680385d7f5d0,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$3e99d4f5fb74344a,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$5c7124f036f5261b,
        $3b8da494b8e92f36$export$77890d3c0e815d73,
        $3b8da494b8e92f36$export$ba9b533eb93c61e6,
        $3b8da494b8e92f36$export$c6db94a21532bc0,
        $3b8da494b8e92f36$export$c9e95b59bddb461b,
        $3b8da494b8e92f36$export$590a133adb265ce2,
        $3b8da494b8e92f36$export$3120d79bc0036ae8,
        $3b8da494b8e92f36$export$27c232e08a5c1615,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$689c1ff4f7778216,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$63c3891ef0655b46,
        $3b8da494b8e92f36$export$5988cb69223093bd,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$a6d7d4ab29f210d8,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$fc1d66d7d457d0bd,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$13e708936da24a68,
        $3b8da494b8e92f36$export$222e5cfe959e7091,
        $3b8da494b8e92f36$export$6d6a87bbda8f8f8f,
        $3b8da494b8e92f36$export$b27765c1626bd4e5,
        $3b8da494b8e92f36$export$2430d0e5fe5a448e,
        $3b8da494b8e92f36$export$21e17a46032a87f8,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$621ee50854ea2931,
        $3b8da494b8e92f36$export$cbecbfc736c5fee6,
        $3b8da494b8e92f36$export$3d4b06c2ec93a11c,
        $3b8da494b8e92f36$export$9586a13e6aa3297b,
        $3b8da494b8e92f36$export$c8c6cd13ee455751,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$cc78bfb1fd84dc0c,
        $3b8da494b8e92f36$export$91748340fd72a888,
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$d14ef3fe75da3f4,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6,
        $3b8da494b8e92f36$export$22d84e75fa702951
    ],
    590820931: [
        $3b8da494b8e92f36$export$7ff49950c8e89377,
        $3b8da494b8e92f36$export$cb9cf4371be8f15d,
        $3b8da494b8e92f36$export$1d01e90a5e4dec43
    ],
    759155922: [
        $3b8da494b8e92f36$export$2a79ce8e6dde1605
    ],
    2559016684: [
        $3b8da494b8e92f36$export$2c91bae7185bb7c5
    ],
    3967405729: [
        $3b8da494b8e92f36$export$f68e11d990d9b413,
        $3b8da494b8e92f36$export$3d28a3f3def06976,
        $3b8da494b8e92f36$export$a6127017c8832457,
        $3b8da494b8e92f36$export$b5f25ff49e2cce09,
        $3b8da494b8e92f36$export$519ba6d3fd8728d1,
        $3b8da494b8e92f36$export$b58a07450f76f5f4
    ],
    2945172077: [
        $3b8da494b8e92f36$export$6e44935b7739e0ff,
        $3b8da494b8e92f36$export$d14ef3fe75da3f4,
        $3b8da494b8e92f36$export$dbe999d9768fb4f6
    ],
    4208778838: [
        $3b8da494b8e92f36$export$15d220a8d3840c2b,
        $3b8da494b8e92f36$export$b9eca9ef3b8d6669,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$2594575309e586b5,
        $3b8da494b8e92f36$export$8f9be165ecf1e4df,
        $3b8da494b8e92f36$export$a0685d525ffdd769,
        $3b8da494b8e92f36$export$a71149a81d77ee49,
        $3b8da494b8e92f36$export$c8107dc828f27d75,
        $3b8da494b8e92f36$export$e09bab7a22edd350,
        $3b8da494b8e92f36$export$b885f77cbc299c4,
        $3b8da494b8e92f36$export$32d390b4d2721141,
        $3b8da494b8e92f36$export$f3c5edda9fcffe08,
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$fc44e3e1a7a655b8,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$882807e675fb9068,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$baebabf49e14381f,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$fd80d94bec4f0a5b,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$85aee7ae7c03d05a,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$8b38478acd341f50,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$621164991f057b60,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$148542c71c2cd1c6,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$58e8ff1cdcf5d006,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$fa079470b767c651,
        $3b8da494b8e92f36$export$bc6fb4287404ee80,
        $3b8da494b8e92f36$export$cf79a786a1f31c67,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$9c2743d05a45981d,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$aea7c0bc4ec470d9,
        $3b8da494b8e92f36$export$510370982f2cd70b,
        $3b8da494b8e92f36$export$d913f9a28f897cb4,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$e3e5acb3f314f36e,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$df9b2345d13dc8f2,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$7758680385d7f5d0,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$3e99d4f5fb74344a,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$5c7124f036f5261b,
        $3b8da494b8e92f36$export$77890d3c0e815d73,
        $3b8da494b8e92f36$export$ba9b533eb93c61e6,
        $3b8da494b8e92f36$export$c6db94a21532bc0,
        $3b8da494b8e92f36$export$c9e95b59bddb461b,
        $3b8da494b8e92f36$export$590a133adb265ce2,
        $3b8da494b8e92f36$export$3120d79bc0036ae8,
        $3b8da494b8e92f36$export$27c232e08a5c1615,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$689c1ff4f7778216,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$63c3891ef0655b46,
        $3b8da494b8e92f36$export$5988cb69223093bd,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$a6d7d4ab29f210d8,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$fc1d66d7d457d0bd,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a,
        $3b8da494b8e92f36$export$eeda05de3055b9ad,
        $3b8da494b8e92f36$export$f8669d468384f20f,
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6,
        $3b8da494b8e92f36$export$3a817c6a27a024f5,
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab,
        $3b8da494b8e92f36$export$f105b5cea245e10f,
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$13e708936da24a68,
        $3b8da494b8e92f36$export$222e5cfe959e7091,
        $3b8da494b8e92f36$export$6d6a87bbda8f8f8f,
        $3b8da494b8e92f36$export$b27765c1626bd4e5,
        $3b8da494b8e92f36$export$2430d0e5fe5a448e,
        $3b8da494b8e92f36$export$21e17a46032a87f8,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$621ee50854ea2931,
        $3b8da494b8e92f36$export$cbecbfc736c5fee6,
        $3b8da494b8e92f36$export$3d4b06c2ec93a11c,
        $3b8da494b8e92f36$export$9586a13e6aa3297b,
        $3b8da494b8e92f36$export$c8c6cd13ee455751,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$c3dee48e256db302,
        $3b8da494b8e92f36$export$cc78bfb1fd84dc0c
    ],
    3521284610: [
        $3b8da494b8e92f36$export$825f7cab9140cf42,
        $3b8da494b8e92f36$export$6dac613d32d3427f
    ],
    3939117080: [
        $3b8da494b8e92f36$export$5c698c7bb50b493,
        $3b8da494b8e92f36$export$422809562a8398de,
        $3b8da494b8e92f36$export$a48481dfef95f4a2,
        $3b8da494b8e92f36$export$d68e05a23c1f8359,
        $3b8da494b8e92f36$export$95d386c017712592,
        $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
        $3b8da494b8e92f36$export$d988060319005ccc
    ],
    1307041759: [
        $3b8da494b8e92f36$export$d68e05a23c1f8359
    ],
    1865459582: [
        $3b8da494b8e92f36$export$4f578206c5065f1f,
        $3b8da494b8e92f36$export$90569318bbf3a5cb,
        $3b8da494b8e92f36$export$3fd59b6be292fb81,
        $3b8da494b8e92f36$export$8bef70def9fcccef,
        $3b8da494b8e92f36$export$8f026b620b6b36d2,
        $3b8da494b8e92f36$export$89d3022d89ef3649,
        $3b8da494b8e92f36$export$c7eeffff290e6124
    ],
    826625072: [
        $3b8da494b8e92f36$export$96504c3b59e8a728,
        $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
        $3b8da494b8e92f36$export$a712aed3e137585e,
        $3b8da494b8e92f36$export$c331bec3b085e9a1,
        $3b8da494b8e92f36$export$2bafde249aab99b4,
        $3b8da494b8e92f36$export$8d69d79340327b03,
        $3b8da494b8e92f36$export$c33f71f232dbf671,
        $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
        $3b8da494b8e92f36$export$9cb68f339a367600,
        $3b8da494b8e92f36$export$51e6468498cab028,
        $3b8da494b8e92f36$export$20528f2adfe8dc9c,
        $3b8da494b8e92f36$export$9572797f2851b0,
        $3b8da494b8e92f36$export$b933598a67b23044,
        $3b8da494b8e92f36$export$976ca854e309f825,
        $3b8da494b8e92f36$export$1fe9178d23052979,
        $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
        $3b8da494b8e92f36$export$94d1e1fe7b940759,
        $3b8da494b8e92f36$export$2b794d8b645d7087,
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c,
        $3b8da494b8e92f36$export$4a59ec454710396a
    ],
    1204542856: [
        $3b8da494b8e92f36$export$edd14ec048dfff5c,
        $3b8da494b8e92f36$export$1804860af295bb6c
    ],
    1638771189: [
        $3b8da494b8e92f36$export$976ca854e309f825
    ],
    2551354335: [
        $3b8da494b8e92f36$export$cff3fa05b2018b59,
        $3b8da494b8e92f36$export$79a1ba43c7a549ce,
        $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
        $3b8da494b8e92f36$export$d35785e0f77dbe69,
        $3b8da494b8e92f36$export$b1832f175144bc77
    ],
    693640335: [
        $3b8da494b8e92f36$export$813f9cf6a2209fec,
        $3b8da494b8e92f36$export$dfec9be971c6e8a5,
        $3b8da494b8e92f36$export$bc9bd707c4403985,
        $3b8da494b8e92f36$export$f650b9b610878411
    ],
    3451746338: [
        $3b8da494b8e92f36$export$96504c3b59e8a728,
        $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9
    ],
    3523091289: [
        $3b8da494b8e92f36$export$96504c3b59e8a728
    ],
    2914609552: [
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22,
        $3b8da494b8e92f36$export$2ba349e11c58c1d1
    ],
    1856042241: [
        $3b8da494b8e92f36$export$fe015439a6fa96b6
    ],
    1862484736: [
        $3b8da494b8e92f36$export$25fbf7852b3a8a34
    ],
    1412071761: [
        $3b8da494b8e92f36$export$1d58c6b4a0c04096,
        $3b8da494b8e92f36$export$6e8c566b0d60ea1b,
        $3b8da494b8e92f36$export$7b95f940068bb1c3,
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$13e708936da24a68,
        $3b8da494b8e92f36$export$222e5cfe959e7091,
        $3b8da494b8e92f36$export$6d6a87bbda8f8f8f,
        $3b8da494b8e92f36$export$b27765c1626bd4e5,
        $3b8da494b8e92f36$export$2430d0e5fe5a448e,
        $3b8da494b8e92f36$export$21e17a46032a87f8,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$621ee50854ea2931,
        $3b8da494b8e92f36$export$cbecbfc736c5fee6,
        $3b8da494b8e92f36$export$3d4b06c2ec93a11c,
        $3b8da494b8e92f36$export$9586a13e6aa3297b,
        $3b8da494b8e92f36$export$c8c6cd13ee455751,
        $3b8da494b8e92f36$export$9c2be460fff60f00,
        $3b8da494b8e92f36$export$c3dee48e256db302
    ],
    710998568: [
        $3b8da494b8e92f36$export$b1ab780de012c3ba,
        $3b8da494b8e92f36$export$70869bbe5fdba7cc,
        $3b8da494b8e92f36$export$32533591b24299cf
    ],
    2706606064: [
        $3b8da494b8e92f36$export$9e9518e51f5a696e,
        $3b8da494b8e92f36$export$f24dfb731091175,
        $3b8da494b8e92f36$export$13e708936da24a68,
        $3b8da494b8e92f36$export$222e5cfe959e7091,
        $3b8da494b8e92f36$export$6d6a87bbda8f8f8f,
        $3b8da494b8e92f36$export$b27765c1626bd4e5,
        $3b8da494b8e92f36$export$2430d0e5fe5a448e,
        $3b8da494b8e92f36$export$21e17a46032a87f8,
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$621ee50854ea2931,
        $3b8da494b8e92f36$export$cbecbfc736c5fee6,
        $3b8da494b8e92f36$export$3d4b06c2ec93a11c,
        $3b8da494b8e92f36$export$9586a13e6aa3297b,
        $3b8da494b8e92f36$export$c8c6cd13ee455751,
        $3b8da494b8e92f36$export$9c2be460fff60f00
    ],
    3893378262: [
        $3b8da494b8e92f36$export$70869bbe5fdba7cc
    ],
    2735484536: [
        $3b8da494b8e92f36$export$930ecb71bb54f6b9,
        $3b8da494b8e92f36$export$71a20a295551861d,
        $3b8da494b8e92f36$export$21377908e11164b8,
        $3b8da494b8e92f36$export$fd146d5f53fefc87,
        $3b8da494b8e92f36$export$9c60c9750bd86c93,
        $3b8da494b8e92f36$export$eae2f9556d21859d
    ],
    3544373492: [
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9,
        $3b8da494b8e92f36$export$708a87c69a745de7,
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2,
        $3b8da494b8e92f36$export$3cb9409cf76f9ab
    ],
    3136571912: [
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0,
        $3b8da494b8e92f36$export$39176bacc0129384,
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a,
        $3b8da494b8e92f36$export$526ec6349313a6f6
    ],
    530289379: [
        $3b8da494b8e92f36$export$1c90015ebcc206f4,
        $3b8da494b8e92f36$export$d63f485dcf694e96,
        $3b8da494b8e92f36$export$76257ab7fe716a7f,
        $3b8da494b8e92f36$export$fa5640b666a3c31a
    ],
    3689010777: [
        $3b8da494b8e92f36$export$b39a8ba0405bb6d5,
        $3b8da494b8e92f36$export$e85d2db4954b8de1,
        $3b8da494b8e92f36$export$c40954ae09567ff2
    ],
    3979015343: [
        $3b8da494b8e92f36$export$76257ab7fe716a7f
    ],
    699246055: [
        $3b8da494b8e92f36$export$922fa769a539de57,
        $3b8da494b8e92f36$export$85f2457f407ffd38
    ],
    2387106220: [
        $3b8da494b8e92f36$export$cf616a1a67553ce5,
        $3b8da494b8e92f36$export$df1aea6f3c3fdd3,
        $3b8da494b8e92f36$export$2ecfbeca9fa8edbd
    ],
    3665877780: [
        $3b8da494b8e92f36$export$8b6f0b216dad9fa1,
        $3b8da494b8e92f36$export$a39811f2fb3014d9
    ],
    2916149573: [
        $3b8da494b8e92f36$export$df1aea6f3c3fdd3
    ],
    2296667514: [
        $3b8da494b8e92f36$export$4690a2f5205975d8
    ],
    1635779807: [
        $3b8da494b8e92f36$export$e7d9f6ef76ebe73f
    ],
    2887950389: [
        $3b8da494b8e92f36$export$7be85d9a50dbe60c,
        $3b8da494b8e92f36$export$c954e3b540b1cc1d
    ],
    167062518: [
        $3b8da494b8e92f36$export$7be85d9a50dbe60c
    ],
    1260505505: [
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b,
        $3b8da494b8e92f36$export$4ff88438ab997405,
        $3b8da494b8e92f36$export$b671f8cba3531a5b,
        $3b8da494b8e92f36$export$c2678de8aed1a067,
        $3b8da494b8e92f36$export$569b2f842286694a,
        $3b8da494b8e92f36$export$ae61b17b9a1def4f,
        $3b8da494b8e92f36$export$14f69d2c614ba0a3,
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f,
        $3b8da494b8e92f36$export$7952e91536a239e7
    ],
    1626504194: [
        $3b8da494b8e92f36$export$87e5f03e9b7321b2,
        $3b8da494b8e92f36$export$658f97b35e3ab77a,
        $3b8da494b8e92f36$export$526a609d02735d86,
        $3b8da494b8e92f36$export$ccb52ac6dd143ac7,
        $3b8da494b8e92f36$export$723497d1e8551beb,
        $3b8da494b8e92f36$export$a319cba82d87c3cb,
        $3b8da494b8e92f36$export$b31d2e8d2292dbf5,
        $3b8da494b8e92f36$export$9ff11c1c025aada8,
        $3b8da494b8e92f36$export$a709f37d4ebaba50,
        $3b8da494b8e92f36$export$d4787b648eef7e28,
        $3b8da494b8e92f36$export$ef31ba14dea6d94d,
        $3b8da494b8e92f36$export$789f22e7812b8923,
        $3b8da494b8e92f36$export$2fef8d3cb4859750,
        $3b8da494b8e92f36$export$ae2d3615237f1a,
        $3b8da494b8e92f36$export$bde4b2f022aa3cc3,
        $3b8da494b8e92f36$export$57538b274174efc0,
        $3b8da494b8e92f36$export$ae5ea07bb40f05a4,
        $3b8da494b8e92f36$export$d9ea6d65e35c77e6,
        $3b8da494b8e92f36$export$1b9d9b67f9494a,
        $3b8da494b8e92f36$export$850457d55019fbac,
        $3b8da494b8e92f36$export$bc2d1907fc896c9e,
        $3b8da494b8e92f36$export$5efb46f971d100c,
        $3b8da494b8e92f36$export$e95d4dc7a2f8cef,
        $3b8da494b8e92f36$export$1571a6a1a0ef60d5,
        $3b8da494b8e92f36$export$45d766a52c6751e8,
        $3b8da494b8e92f36$export$261b3d86b8abacc9,
        $3b8da494b8e92f36$export$91c73aab9ceca7a4,
        $3b8da494b8e92f36$export$cec8b10dd1fabd5d,
        $3b8da494b8e92f36$export$6348979270e0ef76,
        $3b8da494b8e92f36$export$68729a9d4641d5fa,
        $3b8da494b8e92f36$export$afecab087ae8f2
    ],
    3732776249: [
        $3b8da494b8e92f36$export$ae61b17b9a1def4f,
        $3b8da494b8e92f36$export$14f69d2c614ba0a3,
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd,
        $3b8da494b8e92f36$export$c894d0a8a6cbf76f
    ],
    15328376: [
        $3b8da494b8e92f36$export$3051e38f53a4ea7f,
        $3b8da494b8e92f36$export$a8fb7937a6f31dcd
    ],
    2510884976: [
        $3b8da494b8e92f36$export$184537a450d4eb23,
        $3b8da494b8e92f36$export$ada38802d9d4b96f
    ],
    2559216714: [
        $3b8da494b8e92f36$export$75992b31f8a355d1,
        $3b8da494b8e92f36$export$9c528b0c14978ab5,
        $3b8da494b8e92f36$export$94821cd5f6936a22,
        $3b8da494b8e92f36$export$588bb20bb44157c,
        $3b8da494b8e92f36$export$a72c82f60145e8d0,
        $3b8da494b8e92f36$export$8a56abe08ce17f22
    ],
    3293443760: [
        $3b8da494b8e92f36$export$b4911fd9d99601eb,
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4,
        $3b8da494b8e92f36$export$aa19b9c6daf8f2b7,
        $3b8da494b8e92f36$export$8e15250779a21ef,
        $3b8da494b8e92f36$export$c88ac1f006bdeee2,
        $3b8da494b8e92f36$export$7182a3bf21e44226,
        $3b8da494b8e92f36$export$509cf312676aed46,
        $3b8da494b8e92f36$export$86236e7471cd08b7,
        $3b8da494b8e92f36$export$bd39418d01d3093c
    ],
    1306400036: [
        $3b8da494b8e92f36$export$1571a6a1a0ef60d5,
        $3b8da494b8e92f36$export$45d766a52c6751e8
    ],
    3256556792: [
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21,
        $3b8da494b8e92f36$export$77bcfd1ca2caf9f1,
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$8ecb1acc5cef3623,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$4aad03902b9ab9b7,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$8ec901ef3dd34dee,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$30c0a743764a442d,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac3368af3a97899c,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$a71ce1f807a99ffa,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5,
        $3b8da494b8e92f36$export$751ee52b2566888a
    ],
    3849074793: [
        $3b8da494b8e92f36$export$22c217a29e76d93f,
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$8ecb1acc5cef3623,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d,
        $3b8da494b8e92f36$export$2572b77a3589fc3e,
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$4aad03902b9ab9b7,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$8ec901ef3dd34dee,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$30c0a743764a442d,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5,
        $3b8da494b8e92f36$export$ce5af253d449f14,
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c,
        $3b8da494b8e92f36$export$560300bd08cc9a49,
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac3368af3a97899c,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693,
        $3b8da494b8e92f36$export$8f4beacebcde9bad,
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2,
        $3b8da494b8e92f36$export$98508108126f81e2,
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac,
        $3b8da494b8e92f36$export$41fabaf132913619,
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$a71ce1f807a99ffa,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6,
        $3b8da494b8e92f36$export$7e49ca761835aea4,
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191,
        $3b8da494b8e92f36$export$4fb40b28127d10c5
    ],
    1758889154: [
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$fc44e3e1a7a655b8,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$882807e675fb9068,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$baebabf49e14381f,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$fd80d94bec4f0a5b,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$85aee7ae7c03d05a,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$8b38478acd341f50,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf,
        $3b8da494b8e92f36$export$dc7924847d53fe73,
        $3b8da494b8e92f36$export$19789af29bafa1b,
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$621164991f057b60,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$148542c71c2cd1c6,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$58e8ff1cdcf5d006,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$fa079470b767c651,
        $3b8da494b8e92f36$export$bc6fb4287404ee80,
        $3b8da494b8e92f36$export$cf79a786a1f31c67,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$9c2743d05a45981d,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$aea7c0bc4ec470d9,
        $3b8da494b8e92f36$export$510370982f2cd70b,
        $3b8da494b8e92f36$export$d913f9a28f897cb4,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$e3e5acb3f314f36e,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$df9b2345d13dc8f2,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$7758680385d7f5d0,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c,
        $3b8da494b8e92f36$export$3e99d4f5fb74344a,
        $3b8da494b8e92f36$export$4a8581b8026ec1de,
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$5c7124f036f5261b,
        $3b8da494b8e92f36$export$77890d3c0e815d73,
        $3b8da494b8e92f36$export$ba9b533eb93c61e6,
        $3b8da494b8e92f36$export$c6db94a21532bc0,
        $3b8da494b8e92f36$export$c9e95b59bddb461b,
        $3b8da494b8e92f36$export$590a133adb265ce2,
        $3b8da494b8e92f36$export$3120d79bc0036ae8,
        $3b8da494b8e92f36$export$27c232e08a5c1615,
        $3b8da494b8e92f36$export$e640d953799bf92a,
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007,
        $3b8da494b8e92f36$export$694b1dc00358431a,
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$689c1ff4f7778216,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f,
        $3b8da494b8e92f36$export$4a5f0a051095a87e,
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$63c3891ef0655b46,
        $3b8da494b8e92f36$export$5988cb69223093bd,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$a6d7d4ab29f210d8,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$fc1d66d7d457d0bd,
        $3b8da494b8e92f36$export$c119463806d89254,
        $3b8da494b8e92f36$export$724079d67d908529,
        $3b8da494b8e92f36$export$eabd83e99ab5035a
    ],
    1623761950: [
        $3b8da494b8e92f36$export$2f56044b25111c07,
        $3b8da494b8e92f36$export$e889106cbea0f06d,
        $3b8da494b8e92f36$export$fec6e80290b1bed0,
        $3b8da494b8e92f36$export$63c3891ef0655b46,
        $3b8da494b8e92f36$export$5988cb69223093bd,
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$a6d7d4ab29f210d8,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398,
        $3b8da494b8e92f36$export$287844283129ec9a,
        $3b8da494b8e92f36$export$55aca517d8ba50ae,
        $3b8da494b8e92f36$export$fc1d66d7d457d0bd,
        $3b8da494b8e92f36$export$c119463806d89254
    ],
    2590856083: [
        $3b8da494b8e92f36$export$1618f1a56215844f,
        $3b8da494b8e92f36$export$356a8f063280f1fb,
        $3b8da494b8e92f36$export$7f68f805d71a6e66,
        $3b8da494b8e92f36$export$65425f7fe03c67e3,
        $3b8da494b8e92f36$export$bf8da5dfd8f2bbd7,
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$36865c33f6b928df,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89,
        $3b8da494b8e92f36$export$52cd7ae850170c1c,
        $3b8da494b8e92f36$export$fa6e0ae210f3bc46,
        $3b8da494b8e92f36$export$20d4cd77bb23839a,
        $3b8da494b8e92f36$export$f1c98ef26339ddd7
    ],
    2107101300: [
        $3b8da494b8e92f36$export$6d06d206fd28315e,
        $3b8da494b8e92f36$export$62566c9f1588e72d,
        $3b8da494b8e92f36$export$fea663b35a9b2fd5,
        $3b8da494b8e92f36$export$5e23f47185550854,
        $3b8da494b8e92f36$export$2af5a79c3477a52b,
        $3b8da494b8e92f36$export$6a5c99508008e1cf,
        $3b8da494b8e92f36$export$39652294cc94ec4d,
        $3b8da494b8e92f36$export$8ebc99c73ee268ae,
        $3b8da494b8e92f36$export$14196a6ce01ebc90,
        $3b8da494b8e92f36$export$86ca3b73bd675762,
        $3b8da494b8e92f36$export$b06bf88c31950afb,
        $3b8da494b8e92f36$export$5c2a810c48b7d687,
        $3b8da494b8e92f36$export$e3363943d93a5893,
        $3b8da494b8e92f36$export$2c822598b9767f32,
        $3b8da494b8e92f36$export$7d9c8b1bb730aae6,
        $3b8da494b8e92f36$export$38d6e43c3cb2511b,
        $3b8da494b8e92f36$export$c628708806673682,
        $3b8da494b8e92f36$export$4b03dc5d4218e051,
        $3b8da494b8e92f36$export$8f0a8783fda72466,
        $3b8da494b8e92f36$export$1ff9841360300191
    ],
    2853485674: [
        $3b8da494b8e92f36$export$1d58c6b4a0c04096
    ],
    807026263: [
        $3b8da494b8e92f36$export$fbb5bbebdcabe72a
    ],
    24185140: [
        $3b8da494b8e92f36$export$70a5078283e32f9,
        $3b8da494b8e92f36$export$621ee50854ea2931,
        $3b8da494b8e92f36$export$cbecbfc736c5fee6,
        $3b8da494b8e92f36$export$3d4b06c2ec93a11c,
        $3b8da494b8e92f36$export$9586a13e6aa3297b
    ],
    1310830890: [
        $3b8da494b8e92f36$export$13e708936da24a68,
        $3b8da494b8e92f36$export$222e5cfe959e7091,
        $3b8da494b8e92f36$export$6d6a87bbda8f8f8f,
        $3b8da494b8e92f36$export$b27765c1626bd4e5,
        $3b8da494b8e92f36$export$2430d0e5fe5a448e
    ],
    2827207264: [
        $3b8da494b8e92f36$export$dbd31b812d2eaf57,
        $3b8da494b8e92f36$export$689c1ff4f7778216,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc,
        $3b8da494b8e92f36$export$b471058a8e9e1bfd,
        $3b8da494b8e92f36$export$fd69280ac5175edc,
        $3b8da494b8e92f36$export$39f93a81a1d0de6f
    ],
    2143335405: [
        $3b8da494b8e92f36$export$fd69280ac5175edc
    ],
    1287392070: [
        $3b8da494b8e92f36$export$689c1ff4f7778216,
        $3b8da494b8e92f36$export$9322f31e6030ab4a,
        $3b8da494b8e92f36$export$b1c9dabc9c7433dc
    ],
    3907093117: [
        $3b8da494b8e92f36$export$6f58b73dd87cfe79,
        $3b8da494b8e92f36$export$62cf11b69e1e5438,
        $3b8da494b8e92f36$export$a71ce1f807a99ffa,
        $3b8da494b8e92f36$export$56e4e9cc3d4027a8,
        $3b8da494b8e92f36$export$9fdf36e3167f42db,
        $3b8da494b8e92f36$export$c49899a0f28a82a4,
        $3b8da494b8e92f36$export$bcd0a4268fe14e8d,
        $3b8da494b8e92f36$export$5fc87efa73b68291,
        $3b8da494b8e92f36$export$25b07a829bbe1df6
    ],
    3198132628: [
        $3b8da494b8e92f36$export$bf3c7060c2d74dc3,
        $3b8da494b8e92f36$export$20641696240c6d20,
        $3b8da494b8e92f36$export$c3fd351b02fc878e,
        $3b8da494b8e92f36$export$b4ba1bc8e1985ce0,
        $3b8da494b8e92f36$export$54e62b6aab985cac
    ],
    1482959167: [
        $3b8da494b8e92f36$export$d0de9dff026d95f4,
        $3b8da494b8e92f36$export$ac6bae5e4212d704,
        $3b8da494b8e92f36$export$34f76b58e0e9c3d2
    ],
    1834744321: [
        $3b8da494b8e92f36$export$878c9eeddcfc1c9d,
        $3b8da494b8e92f36$export$ac3368af3a97899c,
        $3b8da494b8e92f36$export$ac39f9e9a6506c31,
        $3b8da494b8e92f36$export$632f59f9073fd206,
        $3b8da494b8e92f36$export$19fbfd0ac4f95693
    ],
    1339347760: [
        $3b8da494b8e92f36$export$9aaf0a68d7c0b8e8,
        $3b8da494b8e92f36$export$5c4875c794e07e3c
    ],
    2297155007: [
        $3b8da494b8e92f36$export$8fc952379a94dea3,
        $3b8da494b8e92f36$export$e9c2f02afad5f070,
        $3b8da494b8e92f36$export$b200d13e7dff4623,
        $3b8da494b8e92f36$export$5462a079c779a428,
        $3b8da494b8e92f36$export$3430f4fb0b506a96,
        $3b8da494b8e92f36$export$9166b29db0b1767c,
        $3b8da494b8e92f36$export$61500658d92a6fec,
        $3b8da494b8e92f36$export$7fa46c2d8dc9bd1c,
        $3b8da494b8e92f36$export$4aad03902b9ab9b7,
        $3b8da494b8e92f36$export$cf2424288308e0b2,
        $3b8da494b8e92f36$export$c370851a9414f0eb,
        $3b8da494b8e92f36$export$8ec901ef3dd34dee,
        $3b8da494b8e92f36$export$e31f8d74b6c6a890,
        $3b8da494b8e92f36$export$30c0a743764a442d,
        $3b8da494b8e92f36$export$4653376215ef59b8,
        $3b8da494b8e92f36$export$4a801cfaa3c0d3b5
    ],
    3009222698: [
        $3b8da494b8e92f36$export$c16cb005304b9a6,
        $3b8da494b8e92f36$export$8ecb1acc5cef3623,
        $3b8da494b8e92f36$export$f2f8891345874b6a,
        $3b8da494b8e92f36$export$bcb97b473c8cf78d
    ],
    263784265: [
        $3b8da494b8e92f36$export$a023a3a19ecc9fa8,
        $3b8da494b8e92f36$export$eef1bb90f7dbe007
    ],
    4230923436: [
        $3b8da494b8e92f36$export$ba9b533eb93c61e6,
        $3b8da494b8e92f36$export$c6db94a21532bc0,
        $3b8da494b8e92f36$export$c9e95b59bddb461b,
        $3b8da494b8e92f36$export$590a133adb265ce2,
        $3b8da494b8e92f36$export$3120d79bc0036ae8
    ],
    2706460486: [
        $3b8da494b8e92f36$export$a9dc0bd4f9b9dd2a,
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$4e0003e3499b7937,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928,
        $3b8da494b8e92f36$export$9f161186acea64da,
        $3b8da494b8e92f36$export$88c23504cdda26e,
        $3b8da494b8e92f36$export$57379c20a5f35b14,
        $3b8da494b8e92f36$export$b02d58a89e6b5ff7,
        $3b8da494b8e92f36$export$6738e6f00a5ca09
    ],
    2176059722: [
        $3b8da494b8e92f36$export$c8107dc828f27d75,
        $3b8da494b8e92f36$export$e09bab7a22edd350,
        $3b8da494b8e92f36$export$b885f77cbc299c4,
        $3b8da494b8e92f36$export$32d390b4d2721141
    ],
    3740093272: [
        $3b8da494b8e92f36$export$a0685d525ffdd769
    ],
    1946335990: [
        $3b8da494b8e92f36$export$15d220a8d3840c2b,
        $3b8da494b8e92f36$export$b9eca9ef3b8d6669,
        $3b8da494b8e92f36$export$d112ffc231f4837b,
        $3b8da494b8e92f36$export$2594575309e586b5
    ],
    3027567501: [
        $3b8da494b8e92f36$export$66b56d86c1fdc999,
        $3b8da494b8e92f36$export$a6d7d4ab29f210d8,
        $3b8da494b8e92f36$export$ff63d71e09d6a536,
        $3b8da494b8e92f36$export$2be614ca8afd913d,
        $3b8da494b8e92f36$export$ddf825439bd50398
    ],
    964333572: [
        $3b8da494b8e92f36$export$4adb715104a5828e,
        $3b8da494b8e92f36$export$4c91930f06c612f3,
        $3b8da494b8e92f36$export$36865c33f6b928df,
        $3b8da494b8e92f36$export$292060b67a56230e,
        $3b8da494b8e92f36$export$c746bc8f9f204d89
    ],
    682877961: [
        $3b8da494b8e92f36$export$512d0c7c106ecc18,
        $3b8da494b8e92f36$export$9a501468338c7167,
        $3b8da494b8e92f36$export$42d84e5964307874,
        $3b8da494b8e92f36$export$ee7aa2a71993541a,
        $3b8da494b8e92f36$export$7274fd8538766ba9
    ],
    1179482911: [
        $3b8da494b8e92f36$export$c928377fd4feb321,
        $3b8da494b8e92f36$export$c216fdf93111d89f,
        $3b8da494b8e92f36$export$1b3d019a5ff7e4c0
    ],
    1004757350: [
        $3b8da494b8e92f36$export$ee7aa2a71993541a
    ],
    214636428: [
        $3b8da494b8e92f36$export$1c90015ebcc206f4
    ],
    1252848954: [
        $3b8da494b8e92f36$export$57379c20a5f35b14
    ],
    3657597509: [
        $3b8da494b8e92f36$export$512d0c7c106ecc18
    ],
    2254336722: [
        $3b8da494b8e92f36$export$1a86b8c219c2e539,
        $3b8da494b8e92f36$export$78b19c4a252f3d7b,
        $3b8da494b8e92f36$export$34a6baef290b91cd,
        $3b8da494b8e92f36$export$4e0003e3499b7937,
        $3b8da494b8e92f36$export$2db5c9c97dd86736,
        $3b8da494b8e92f36$export$6ca3bf98d9446928
    ],
    1953115116: [
        $3b8da494b8e92f36$export$89669bf1e21c3a8c,
        $3b8da494b8e92f36$export$5c7124f036f5261b
    ],
    1028945134: [
        $3b8da494b8e92f36$export$a95166503d2b6ffb,
        $3b8da494b8e92f36$export$4cbf3a97f9bc2cc4
    ],
    1967976161: [
        $3b8da494b8e92f36$export$d119e59d83beec72,
        $3b8da494b8e92f36$export$8c7b4fc0454a715b
    ],
    2461110595: [
        $3b8da494b8e92f36$export$d119e59d83beec72
    ],
    1136057603: [
        $3b8da494b8e92f36$export$3051e38f53a4ea7f
    ],
    1876633798: [
        $3b8da494b8e92f36$export$5f91686e3f0ec9c1,
        $3b8da494b8e92f36$export$621164991f057b60,
        $3b8da494b8e92f36$export$4f2487ede48f0d2a,
        $3b8da494b8e92f36$export$d6aa0703d849041b,
        $3b8da494b8e92f36$export$61bc9e508bdccd25,
        $3b8da494b8e92f36$export$dafc07efbc1adbdf,
        $3b8da494b8e92f36$export$148542c71c2cd1c6,
        $3b8da494b8e92f36$export$46f01ebf0887dc1d,
        $3b8da494b8e92f36$export$866ac0b0ad7986cb,
        $3b8da494b8e92f36$export$609a47466db8ab45,
        $3b8da494b8e92f36$export$7c2f4cd7aa58d5cc,
        $3b8da494b8e92f36$export$3607ac6f8790d3a8,
        $3b8da494b8e92f36$export$322ff56c5dcb27d9,
        $3b8da494b8e92f36$export$13db912ddb7b3508,
        $3b8da494b8e92f36$export$805f2f490dd0ca23,
        $3b8da494b8e92f36$export$58e8ff1cdcf5d006,
        $3b8da494b8e92f36$export$91c283c4fd8a20a6,
        $3b8da494b8e92f36$export$fa079470b767c651,
        $3b8da494b8e92f36$export$bc6fb4287404ee80,
        $3b8da494b8e92f36$export$cf79a786a1f31c67,
        $3b8da494b8e92f36$export$be1b4f4b5c27785f,
        $3b8da494b8e92f36$export$9c2743d05a45981d,
        $3b8da494b8e92f36$export$ef3c534479771485,
        $3b8da494b8e92f36$export$aea7c0bc4ec470d9,
        $3b8da494b8e92f36$export$510370982f2cd70b,
        $3b8da494b8e92f36$export$d913f9a28f897cb4,
        $3b8da494b8e92f36$export$9c705f1ac76b11cc,
        $3b8da494b8e92f36$export$e3e5acb3f314f36e,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1,
        $3b8da494b8e92f36$export$df9b2345d13dc8f2,
        $3b8da494b8e92f36$export$661f52213c124a05,
        $3b8da494b8e92f36$export$500d8b4c01275b03,
        $3b8da494b8e92f36$export$7758680385d7f5d0,
        $3b8da494b8e92f36$export$6b2435252ee80cc6,
        $3b8da494b8e92f36$export$ab271d772829021c
    ],
    3426335179: [
        $3b8da494b8e92f36$export$e3e5acb3f314f36e,
        $3b8da494b8e92f36$export$da9bcacbb199e2e1
    ],
    2063403501: [
        $3b8da494b8e92f36$export$1a9d91cc7daf74f7,
        $3b8da494b8e92f36$export$972dd4e9463306ac,
        $3b8da494b8e92f36$export$547e4d098b2f0ae5,
        $3b8da494b8e92f36$export$34d108d80727bc18,
        $3b8da494b8e92f36$export$1bfa1e9b0a33c4cb,
        $3b8da494b8e92f36$export$3feb97dc469b4d81,
        $3b8da494b8e92f36$export$eb2d882d03a89f21
    ],
    1945004755: [
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3,
        $3b8da494b8e92f36$export$c65910fd24111dc1,
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$fc44e3e1a7a655b8,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$882807e675fb9068,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$baebabf49e14381f,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$fd80d94bec4f0a5b,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$85aee7ae7c03d05a,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$8b38478acd341f50,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098,
        $3b8da494b8e92f36$export$8d770ff3102f12cf
    ],
    3040386961: [
        $3b8da494b8e92f36$export$7a104ba75cbe7e45,
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$fc44e3e1a7a655b8,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e,
        $3b8da494b8e92f36$export$f80c44f6cd8e5df8,
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$882807e675fb9068,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$baebabf49e14381f,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$fd80d94bec4f0a5b,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d,
        $3b8da494b8e92f36$export$b227591106b6c07d,
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88,
        $3b8da494b8e92f36$export$91ba6cfefaa29b48,
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$85aee7ae7c03d05a,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608,
        $3b8da494b8e92f36$export$5d7451154b719cfd,
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08,
        $3b8da494b8e92f36$export$22cffa5d6d01d817,
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae,
        $3b8da494b8e92f36$export$f2a6887988b8cf66,
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$8b38478acd341f50,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475,
        $3b8da494b8e92f36$export$eb7f84f0caa28271,
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5,
        $3b8da494b8e92f36$export$52e474d7ed246098
    ],
    3205830791: [
        $3b8da494b8e92f36$export$78b19c4a252f3d7b
    ],
    1077100507: [
        $3b8da494b8e92f36$export$aea7c0bc4ec470d9,
        $3b8da494b8e92f36$export$510370982f2cd70b
    ],
    1658829314: [
        $3b8da494b8e92f36$export$2a7fd01d7f217eea,
        $3b8da494b8e92f36$export$f7b92a5686344918,
        $3b8da494b8e92f36$export$9af0ffdfaf8deb4b,
        $3b8da494b8e92f36$export$c1ab2755a348af2,
        $3b8da494b8e92f36$export$f532c17f39683164,
        $3b8da494b8e92f36$export$8d5af027eaba9fc4,
        $3b8da494b8e92f36$export$8a82842e122232c,
        $3b8da494b8e92f36$export$ab163798e2f775ed,
        $3b8da494b8e92f36$export$306fdfb2e1082660,
        $3b8da494b8e92f36$export$6c7de868663152ee,
        $3b8da494b8e92f36$export$9c3f5e24bcf64017,
        $3b8da494b8e92f36$export$7ddb90dede515c81,
        $3b8da494b8e92f36$export$4f4bf8c551fb73d5,
        $3b8da494b8e92f36$export$1dd798d580992210,
        $3b8da494b8e92f36$export$909c399c43b4565a,
        $3b8da494b8e92f36$export$23b97179eafd208b,
        $3b8da494b8e92f36$export$e74173267223d777,
        $3b8da494b8e92f36$export$4d77b1c4ed455124,
        $3b8da494b8e92f36$export$1590d3bdbcc096f,
        $3b8da494b8e92f36$export$7b69c20feaae0df5
    ],
    2058353004: [
        $3b8da494b8e92f36$export$29c53ca64f3f47eb,
        $3b8da494b8e92f36$export$f8e3926daf5ae150,
        $3b8da494b8e92f36$export$8b38478acd341f50,
        $3b8da494b8e92f36$export$2f2a04037296b593,
        $3b8da494b8e92f36$export$e01e5cce8a3c1b24,
        $3b8da494b8e92f36$export$41a1521485ab6317,
        $3b8da494b8e92f36$export$4c61bb3d56ddc107,
        $3b8da494b8e92f36$export$9e9165f95050e15e,
        $3b8da494b8e92f36$export$aef8a18f5e93c475
    ],
    4278956645: [
        $3b8da494b8e92f36$export$9acab8bc6a12023d,
        $3b8da494b8e92f36$export$cd3804f140d65bc7,
        $3b8da494b8e92f36$export$e44afe3a7829791a,
        $3b8da494b8e92f36$export$4df0321cc3536447,
        $3b8da494b8e92f36$export$f77c50967a5433ae
    ],
    3132237377: [
        $3b8da494b8e92f36$export$60cebc3132db61fc,
        $3b8da494b8e92f36$export$d80c5d49d2a19bfd,
        $3b8da494b8e92f36$export$eb15acbbc0d2cf08
    ],
    987401354: [
        $3b8da494b8e92f36$export$a71590cc0b132e81,
        $3b8da494b8e92f36$export$85aee7ae7c03d05a,
        $3b8da494b8e92f36$export$7cb946b2ac41961c,
        $3b8da494b8e92f36$export$133c65ddb4b70017,
        $3b8da494b8e92f36$export$3b8d48227d708608
    ],
    707683696: [
        $3b8da494b8e92f36$export$17b013543c080bda,
        $3b8da494b8e92f36$export$5229b0f0c9a5bb88
    ],
    2223149337: [
        $3b8da494b8e92f36$export$6f871c8fa333e822,
        $3b8da494b8e92f36$export$965414a7c9f66c8e,
        $3b8da494b8e92f36$export$668639329cae33ad,
        $3b8da494b8e92f36$export$ab6c764fe9bef52d,
        $3b8da494b8e92f36$export$9deafe265cc260c9,
        $3b8da494b8e92f36$export$b6a8842980c23f65,
        $3b8da494b8e92f36$export$39c19636f9173ccb,
        $3b8da494b8e92f36$export$273c14799d1e65d2,
        $3b8da494b8e92f36$export$882807e675fb9068,
        $3b8da494b8e92f36$export$bb3a10186aad9336,
        $3b8da494b8e92f36$export$6618e2639e992b4,
        $3b8da494b8e92f36$export$baebabf49e14381f,
        $3b8da494b8e92f36$export$85feca2a73d2d8f,
        $3b8da494b8e92f36$export$fd80d94bec4f0a5b,
        $3b8da494b8e92f36$export$9b1fd3cec62df66d,
        $3b8da494b8e92f36$export$f570b472a926491d
    ],
    3508470533: [
        $3b8da494b8e92f36$export$97f16789cdafafab,
        $3b8da494b8e92f36$export$fc44e3e1a7a655b8,
        $3b8da494b8e92f36$export$cdadba6e2525ae05,
        $3b8da494b8e92f36$export$30cd12a6f9c4e81e
    ],
    2713699986: [
        $3b8da494b8e92f36$export$ba9b533eb93c61e6,
        $3b8da494b8e92f36$export$c6db94a21532bc0,
        $3b8da494b8e92f36$export$c9e95b59bddb461b
    ],
    1154579445: [
        $3b8da494b8e92f36$export$15d220a8d3840c2b
    ],
    2391406946: [
        $3b8da494b8e92f36$export$61bc9e508bdccd25
    ],
    1062813311: [
        $3b8da494b8e92f36$export$1bed1511641669cd,
        $3b8da494b8e92f36$export$256a7ae6f2f20b7a,
        $3b8da494b8e92f36$export$6228cf2343baa399,
        $3b8da494b8e92f36$export$104c0856e18167ed,
        $3b8da494b8e92f36$export$bd8a03a55659160d,
        $3b8da494b8e92f36$export$4d5258657f2d3858,
        $3b8da494b8e92f36$export$3c336c07a4f995a3
    ]
};
$3b8da494b8e92f36$export$1ae3922015fd7522[3] = {
    3630933823: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    618182010: [
        [
            "OfPerson",
            $3b8da494b8e92f36$export$ffa0fdddece68333,
            7,
            true
        ],
        [
            "OfOrganization",
            $3b8da494b8e92f36$export$484015ec0cfcf638,
            4,
            true
        ]
    ],
    411424972: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    130549933: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "ApprovedObjects",
            $3b8da494b8e92f36$export$c7eeffff290e6124,
            5,
            true
        ],
        [
            "ApprovedResources",
            $3b8da494b8e92f36$export$13de02c11c361011,
            3,
            true
        ],
        [
            "IsRelatedWith",
            $3b8da494b8e92f36$export$cea9d94742f0d4d6,
            3,
            true
        ],
        [
            "Relates",
            $3b8da494b8e92f36$export$cea9d94742f0d4d6,
            2,
            true
        ]
    ],
    1959218052: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PropertiesForConstraint",
            $3b8da494b8e92f36$export$acffd400493c189c,
            2,
            true
        ]
    ],
    1466758467: [
        [
            "HasCoordinateOperation",
            $3b8da494b8e92f36$export$ecb047565e884e65,
            0,
            true
        ],
        [
            "WellKnownText",
            $3b8da494b8e92f36$export$2431f6624361f2ff,
            1,
            true
        ]
    ],
    602808272: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    3200245327: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ]
    ],
    2242383968: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ]
    ],
    1040185647: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ]
    ],
    3548104201: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ]
    ],
    917726184: [
        [
            "HasCoordinateOperation",
            $3b8da494b8e92f36$export$ecb047565e884e65,
            0,
            true
        ],
        [
            "WellKnownText",
            $3b8da494b8e92f36$export$2431f6624361f2ff,
            1,
            true
        ]
    ],
    852622518: [
        [
            "PartOfW",
            $3b8da494b8e92f36$export$d112ffc231f4837b,
            9,
            true
        ],
        [
            "PartOfV",
            $3b8da494b8e92f36$export$d112ffc231f4837b,
            8,
            true
        ],
        [
            "PartOfU",
            $3b8da494b8e92f36$export$d112ffc231f4837b,
            7,
            true
        ],
        [
            "HasIntersections",
            $3b8da494b8e92f36$export$39a9378576bb57be,
            0,
            true
        ]
    ],
    2655187982: [
        [
            "LibraryInfoForObjects",
            $3b8da494b8e92f36$export$3fd59b6be292fb81,
            5,
            true
        ],
        [
            "HasLibraryReferences",
            $3b8da494b8e92f36$export$96fe74a17c6cc802,
            5,
            true
        ]
    ],
    3452421091: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ],
        [
            "LibraryRefForObjects",
            $3b8da494b8e92f36$export$3fd59b6be292fb81,
            5,
            true
        ]
    ],
    760658860: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ]
    ],
    248100487: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialLayerSet",
            $3b8da494b8e92f36$export$271c16e7766bc70a,
            0,
            false
        ]
    ],
    3303938423: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ]
    ],
    1847252529: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialLayerSet",
            $3b8da494b8e92f36$export$271c16e7766bc70a,
            0,
            false
        ]
    ],
    2235152071: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialProfileSet",
            $3b8da494b8e92f36$export$ce700270dbd3f574,
            2,
            false
        ]
    ],
    164193824: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ]
    ],
    552965576: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialProfileSet",
            $3b8da494b8e92f36$export$ce700270dbd3f574,
            2,
            false
        ]
    ],
    1507914824: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ]
    ],
    3368373690: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PropertiesForConstraint",
            $3b8da494b8e92f36$export$acffd400493c189c,
            2,
            true
        ]
    ],
    3701648758: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$16a79191283c73fb,
            0,
            true
        ]
    ],
    2251480897: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PropertiesForConstraint",
            $3b8da494b8e92f36$export$acffd400493c189c,
            2,
            true
        ]
    ],
    4251960020: [
        [
            "IsRelatedBy",
            $3b8da494b8e92f36$export$f7ea933b5cc28fe9,
            3,
            true
        ],
        [
            "Relates",
            $3b8da494b8e92f36$export$f7ea933b5cc28fe9,
            2,
            true
        ],
        [
            "Engages",
            $3b8da494b8e92f36$export$c819a2c53c7debd3,
            1,
            true
        ]
    ],
    2077209135: [
        [
            "EngagedIn",
            $3b8da494b8e92f36$export$c819a2c53c7debd3,
            0,
            true
        ]
    ],
    2483315170: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2226359599: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    3355820592: [
        [
            "OfPerson",
            $3b8da494b8e92f36$export$ffa0fdddece68333,
            7,
            true
        ],
        [
            "OfOrganization",
            $3b8da494b8e92f36$export$484015ec0cfcf638,
            4,
            true
        ]
    ],
    3958567839: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    3843373140: [
        [
            "HasCoordinateOperation",
            $3b8da494b8e92f36$export$ecb047565e884e65,
            0,
            true
        ],
        [
            "WellKnownText",
            $3b8da494b8e92f36$export$2431f6624361f2ff,
            1,
            true
        ]
    ],
    986844984: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    3710013099: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2044713172: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2093928680: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    931644368: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2691318326: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    3252649465: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    2405470396: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    825690147: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    1076942058: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ]
    ],
    3377609919: [
        [
            "RepresentationsInContext",
            $3b8da494b8e92f36$export$2ddea3c8ef71f411,
            0,
            true
        ]
    ],
    3008791417: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1660063152: [
        [
            "HasShapeAspects",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            4,
            true
        ],
        [
            "MapUsage",
            $3b8da494b8e92f36$export$f6578324c1ae7b2d,
            0,
            true
        ]
    ],
    867548509: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    3982875396: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ],
        [
            "OfShapeAspect",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            0,
            true
        ]
    ],
    4240577450: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ],
        [
            "OfShapeAspect",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            0,
            true
        ]
    ],
    2830218821: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ]
    ],
    3958052878: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3049322572: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ]
    ],
    626085974: [
        [
            "IsMappedBy",
            $3b8da494b8e92f36$export$f9f8eae306150574,
            0,
            true
        ],
        [
            "UsedInStyles",
            $3b8da494b8e92f36$export$a208be2840956e7f,
            0,
            true
        ]
    ],
    912023232: [
        [
            "OfPerson",
            $3b8da494b8e92f36$export$ffa0fdddece68333,
            7,
            true
        ],
        [
            "OfOrganization",
            $3b8da494b8e92f36$export$484015ec0cfcf638,
            4,
            true
        ]
    ],
    222769930: [
        [
            "ToTexMap",
            $3b8da494b8e92f36$export$1e82cbdcd9fe6ab9,
            3,
            false
        ]
    ],
    1010789467: [
        [
            "ToTexMap",
            $3b8da494b8e92f36$export$1e82cbdcd9fe6ab9,
            3,
            false
        ]
    ],
    3101149627: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    1377556343: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1735638870: [
        [
            "RepresentationMap",
            $3b8da494b8e92f36$export$fdb8da78dfd217b,
            1,
            true
        ],
        [
            "LayerAssignments",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "OfProductRepresentation",
            $3b8da494b8e92f36$export$d5d8ad3a011628f1,
            2,
            true
        ],
        [
            "OfShapeAspect",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            0,
            true
        ]
    ],
    2799835756: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1907098498: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3798115385: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1310608509: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2705031697: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    616511568: [
        [
            "IsMappedBy",
            $3b8da494b8e92f36$export$f9f8eae306150574,
            0,
            true
        ],
        [
            "UsedInStyles",
            $3b8da494b8e92f36$export$a208be2840956e7f,
            0,
            true
        ]
    ],
    3150382593: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    747523909: [
        [
            "ClassificationForObjects",
            $3b8da494b8e92f36$export$89d3022d89ef3649,
            5,
            true
        ],
        [
            "HasReferences",
            $3b8da494b8e92f36$export$72ed75e7fb4d773c,
            3,
            true
        ]
    ],
    647927063: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ],
        [
            "ClassificationRefForObjects",
            $3b8da494b8e92f36$export$89d3022d89ef3649,
            5,
            true
        ],
        [
            "HasReferences",
            $3b8da494b8e92f36$export$72ed75e7fb4d773c,
            3,
            true
        ]
    ],
    1485152156: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    370225590: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3050246964: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2889183280: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2713554722: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    3632507154: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1154170062: [
        [
            "DocumentInfoForObjects",
            $3b8da494b8e92f36$export$8bef70def9fcccef,
            5,
            true
        ],
        [
            "HasDocumentReferences",
            $3b8da494b8e92f36$export$5dc53366ca618592,
            4,
            true
        ],
        [
            "IsPointedTo",
            $3b8da494b8e92f36$export$623f6287e006c7a4,
            3,
            true
        ],
        [
            "IsPointer",
            $3b8da494b8e92f36$export$623f6287e006c7a4,
            2,
            true
        ]
    ],
    3732053477: [
        [
            "ExternalReferenceForResources",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            2,
            true
        ],
        [
            "DocumentRefForObjects",
            $3b8da494b8e92f36$export$8bef70def9fcccef,
            5,
            true
        ]
    ],
    3900360178: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    476780140: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    297599258: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2556980723: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasTextureMaps",
            $3b8da494b8e92f36$export$925b578047892bce,
            2,
            true
        ]
    ],
    1809719519: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    803316827: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3008276851: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasTextureMaps",
            $3b8da494b8e92f36$export$925b578047892bce,
            2,
            true
        ]
    ],
    3448662350: [
        [
            "RepresentationsInContext",
            $3b8da494b8e92f36$export$2ddea3c8ef71f411,
            0,
            true
        ],
        [
            "HasSubContexts",
            $3b8da494b8e92f36$export$c78a940a5c4e916a,
            6,
            true
        ],
        [
            "HasCoordinateOperation",
            $3b8da494b8e92f36$export$ecb047565e884e65,
            0,
            true
        ]
    ],
    2453401579: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4142052618: [
        [
            "RepresentationsInContext",
            $3b8da494b8e92f36$export$2ddea3c8ef71f411,
            0,
            true
        ],
        [
            "HasSubContexts",
            $3b8da494b8e92f36$export$c78a940a5c4e916a,
            6,
            true
        ],
        [
            "HasCoordinateOperation",
            $3b8da494b8e92f36$export$ecb047565e884e65,
            0,
            true
        ]
    ],
    3590301190: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    178086475: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$16a79191283c73fb,
            0,
            true
        ]
    ],
    812098782: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3905492369: [
        [
            "IsMappedBy",
            $3b8da494b8e92f36$export$f9f8eae306150574,
            0,
            true
        ],
        [
            "UsedInStyles",
            $3b8da494b8e92f36$export$a208be2840956e7f,
            0,
            true
        ]
    ],
    3741457305: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    1402838566: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    125510826: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2604431987: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4266656042: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1520743889: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3422422726: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    388784114: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$16a79191283c73fb,
            0,
            true
        ]
    ],
    2624227202: [
        [
            "PlacesObject",
            $3b8da494b8e92f36$export$91748340fd72a888,
            5,
            true
        ],
        [
            "ReferencedByPlacements",
            $3b8da494b8e92f36$export$16a79191283c73fb,
            0,
            true
        ]
    ],
    1008929658: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2347385850: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1838606355: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "HasRepresentation",
            $3b8da494b8e92f36$export$95d5078ec273e20a,
            3,
            true
        ],
        [
            "IsRelatedWith",
            $3b8da494b8e92f36$export$e2f0b7f5e626526f,
            3,
            true
        ],
        [
            "RelatesTo",
            $3b8da494b8e92f36$export$e2f0b7f5e626526f,
            2,
            true
        ]
    ],
    3708119e3: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ],
        [
            "ToMaterialConstituentSet",
            $3b8da494b8e92f36$export$b1bef060ce5931d8,
            2,
            false
        ]
    ],
    2852063980: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ],
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$d8f086a59e04ee25,
            3,
            true
        ]
    ],
    1303795690: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ]
    ],
    3079605661: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ]
    ],
    3404854881: [
        [
            "AssociatedTo",
            $3b8da494b8e92f36$export$90569318bbf3a5cb,
            5,
            true
        ]
    ],
    3265635763: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2998442950: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    219451334: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ]
    ],
    182550632: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2665983363: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1029017970: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2529465313: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2519244187: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3021840470: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$8334e069ea620bb8,
            2,
            true
        ]
    ],
    597895409: [
        [
            "IsMappedBy",
            $3b8da494b8e92f36$export$f9f8eae306150574,
            0,
            true
        ],
        [
            "UsedInStyles",
            $3b8da494b8e92f36$export$a208be2840956e7f,
            0,
            true
        ]
    ],
    2004835150: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1663979128: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2067069095: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2165702409: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4022376103: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1423911732: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2924175390: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2775532180: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3778827333: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    673634403: [
        [
            "ShapeOfProduct",
            $3b8da494b8e92f36$export$91748340fd72a888,
            6,
            true
        ],
        [
            "HasShapeAspects",
            $3b8da494b8e92f36$export$858f8a041fd3a224,
            4,
            true
        ]
    ],
    2802850158: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2598011224: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    1680319473: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ]
    ],
    3357820518: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    1482703590: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ]
    ],
    2090586900: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    3615266464: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    3413951693: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    1580146022: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    2778083089: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2042790032: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    4165799628: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ]
    ],
    1509187699: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    823603102: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "UsingCurves",
            $3b8da494b8e92f36$export$7952e91536a239e7,
            0,
            true
        ]
    ],
    4124623270: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3692461612: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    723233188: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2233826070: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2513912981: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2247615214: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1260650574: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1096409881: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    230924584: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3071757647: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    901063453: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4282788508: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3124975700: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2715220739: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1628702193: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ]
    ],
    3736923433: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2347495698: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3698973494: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    427810014: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1417489154: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2759199220: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2543172580: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    3406155212: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasTextureMaps",
            $3b8da494b8e92f36$export$925b578047892bce,
            2,
            true
        ]
    ],
    669184980: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3207858831: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    4261334040: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3125803723: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2740243338: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3425423356: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2736907675: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4182860854: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2581212453: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2713105998: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2898889636: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    1123145078: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    574549367: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1675464909: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2059837836: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    59481748: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3749851601: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3486308946: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3331915920: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1416205885: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1383045692: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2205249479: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2542286263: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    2485617015: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "UsingCurves",
            $3b8da494b8e92f36$export$7952e91536a239e7,
            0,
            true
        ]
    ],
    2574617495: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    3419103109: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            4,
            true
        ]
    ],
    1815067380: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    2506170314: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2147822146: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2601014836: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2827736869: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2629017746: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4212018352: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "UsingCurves",
            $3b8da494b8e92f36$export$7952e91536a239e7,
            0,
            true
        ]
    ],
    32440307: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    593015953: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1472233963: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1883228015: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    339256511: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2777663545: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2835456948: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    4024345920: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    477187591: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2804161546: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2047409740: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    374418227: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    315944413: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2652556860: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4238390223: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1268542332: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4095422895: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    987898635: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1484403080: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    178912537: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "ToFaceSet",
            $3b8da494b8e92f36$export$cf616a1a67553ce5,
            2,
            true
        ],
        [
            "HasTexCoords",
            $3b8da494b8e92f36$export$9a0fe36b94f2528a,
            1,
            true
        ]
    ],
    2294589976: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "ToFaceSet",
            $3b8da494b8e92f36$export$cf616a1a67553ce5,
            2,
            true
        ],
        [
            "HasTexCoords",
            $3b8da494b8e92f36$export$9a0fe36b94f2528a,
            1,
            true
        ]
    ],
    572779678: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    428585644: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1281925730: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1425443689: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3888040117: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ]
    ],
    590820931: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3388369263: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3505215534: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2485787929: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1682466193: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    603570806: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    220341763: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3381221214: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3967405729: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    569719735: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2945172077: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    4208778838: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    103090709: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            4,
            true
        ]
    ],
    653396225: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            4,
            true
        ]
    ],
    871118103: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    4166981789: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    2752243245: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    941946838: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    1451395588: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    492091185: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Defines",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            5,
            true
        ]
    ],
    3650150729: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    110355661: [
        [
            "HasExternalReferences",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "PartOfPset",
            $3b8da494b8e92f36$export$11ccca7a6068fc2c,
            4,
            true
        ],
        [
            "PropertyForDependance",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            2,
            true
        ],
        [
            "PropertyDependsOn",
            $3b8da494b8e92f36$export$7fc4348977f8efbe,
            3,
            true
        ],
        [
            "PartOfComplex",
            $3b8da494b8e92f36$export$ea419368a3085d41,
            3,
            true
        ],
        [
            "HasConstraints",
            $3b8da494b8e92f36$export$acffd400493c189c,
            3,
            true
        ],
        [
            "HasApprovals",
            $3b8da494b8e92f36$export$13de02c11c361011,
            2,
            true
        ]
    ],
    3521284610: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PartOfComplexTemplate",
            $3b8da494b8e92f36$export$825f7cab9140cf42,
            6,
            true
        ],
        [
            "PartOfPsetTemplate",
            $3b8da494b8e92f36$export$67177aa5e10d7edd,
            6,
            true
        ]
    ],
    2770003689: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    2798486643: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3454111270: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3765753017: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    3523091289: [
        [
            "InnerBoundaries",
            $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
            9,
            true
        ]
    ],
    1521410863: [
        [
            "InnerBoundaries",
            $3b8da494b8e92f36$export$a6ad5b7c87a4c3a9,
            9,
            true
        ],
        [
            "Corresponds",
            $3b8da494b8e92f36$export$96504c3b59e8a728,
            10,
            true
        ]
    ],
    816062949: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "UsingCurves",
            $3b8da494b8e92f36$export$7952e91536a239e7,
            0,
            true
        ]
    ],
    2914609552: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1856042241: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3243963512: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4158566097: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3626867408: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1862484736: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1290935644: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1356537516: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3663146110: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PartOfComplexTemplate",
            $3b8da494b8e92f36$export$825f7cab9140cf42,
            6,
            true
        ],
        [
            "PartOfPsetTemplate",
            $3b8da494b8e92f36$export$67177aa5e10d7edd,
            6,
            true
        ]
    ],
    1412071761: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    710998568: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2706606064: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    3893378262: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    463610769: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    2481509218: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    451544542: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4015995234: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2735484536: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3544373492: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    3136571912: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ]
    ],
    530289379: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    3689010777: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    3979015343: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    2218152070: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    603775116: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    4095615324: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    699246055: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2028607225: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2809605785: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4124788165: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1580310250: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3473067441: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    3206491090: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2387106220: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasColours",
            $3b8da494b8e92f36$export$5c5bfbea1f9750f0,
            0,
            true
        ],
        [
            "HasTextures",
            $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
            1,
            true
        ]
    ],
    782932809: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1935646853: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3665877780: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2916149573: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasColours",
            $3b8da494b8e92f36$export$5c5bfbea1f9750f0,
            0,
            true
        ],
        [
            "HasTextures",
            $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
            1,
            true
        ]
    ],
    1229763772: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasColours",
            $3b8da494b8e92f36$export$5c5bfbea1f9750f0,
            0,
            true
        ],
        [
            "HasTextures",
            $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
            1,
            true
        ]
    ],
    3651464721: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    336235671: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    512836454: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    2296667514: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsActingUpon",
            $3b8da494b8e92f36$export$d988060319005ccc,
            6,
            true
        ]
    ],
    1635779807: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2603310189: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1674181508: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ]
    ],
    2887950389: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    167062518: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1334484129: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3649129432: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1260505505: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3124254112: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    1626504194: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2197970202: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2937912522: [
        [
            "HasExternalReference",
            $3b8da494b8e92f36$export$dc995d42867b8d56,
            3,
            true
        ],
        [
            "HasProperties",
            $3b8da494b8e92f36$export$925767a3ae3a4925,
            3,
            true
        ]
    ],
    3893394355: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3497074424: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    300633059: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3875453745: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "PartOfComplexTemplate",
            $3b8da494b8e92f36$export$825f7cab9140cf42,
            6,
            true
        ],
        [
            "PartOfPsetTemplate",
            $3b8da494b8e92f36$export$67177aa5e10d7edd,
            6,
            true
        ]
    ],
    3732776249: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    15328376: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2510884976: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2185764099: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    4105962743: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1525564444: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    2559216714: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    3293443760: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    2000195564: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3895139033: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1419761937: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    4189326743: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1916426348: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3295246426: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1457835157: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1213902940: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1306400036: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4234616927: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3256556792: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3849074793: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2963535650: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    1714330368: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    2323601079: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1758889154: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    4123344466: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2397081782: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1623761950: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2590856083: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1704287377: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2107101300: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    132023988: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3174744832: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3390157468: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4148101412: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2853485674: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    807026263: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3737207727: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    24185140: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    1310830890: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    4228831410: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    647756555: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2489546625: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2827207264: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2143335405: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "ProjectsElements",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            5,
            false
        ]
    ],
    1287392070: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ]
    ],
    3907093117: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3198132628: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3815607619: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1482959167: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1834744321: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1339347760: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2297155007: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3009222698: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1893162501: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    263784265: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    1509553395: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3493046030: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    4230923436: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    1594536857: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2898700619: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2706460486: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    1251058090: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1806887404: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2568555532: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3948183225: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2571569899: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3946677679: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3113134337: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2391368822: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    4288270099: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    679976338: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3827777499: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1051575348: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1161773419: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2176059722: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    1770583370: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    525669439: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    976884017: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    377706215: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2108223431: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1114901282: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3181161470: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1950438474: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    710110818: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    977012517: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    506776471: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4143007308: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsActingUpon",
            $3b8da494b8e92f36$export$d988060319005ccc,
            6,
            true
        ]
    ],
    3588315303: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ],
        [
            "HasFillings",
            $3b8da494b8e92f36$export$51e6468498cab028,
            4,
            true
        ]
    ],
    2837617999: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    514975943: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2382730787: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3566463478: [
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "DefinesType",
            $3b8da494b8e92f36$export$9418e91392f50813,
            5,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$dfec9be971c6e8a5,
            4,
            true
        ],
        [
            "DefinesOccurrence",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            5,
            true
        ]
    ],
    3327091369: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1158309216: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    804291784: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4231323485: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4017108033: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2839578677: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ],
        [
            "HasColours",
            $3b8da494b8e92f36$export$5c5bfbea1f9750f0,
            0,
            true
        ],
        [
            "HasTextures",
            $3b8da494b8e92f36$export$7c4f7aaa3a160deb,
            1,
            true
        ]
    ],
    3724593414: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3740093272: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainedIn",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            4,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            4,
            true
        ]
    ],
    1946335990: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "Positions",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            4,
            true
        ]
    ],
    2744685151: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsPredecessorTo",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            4,
            true
        ],
        [
            "IsSuccessorFrom",
            $3b8da494b8e92f36$export$2bafde249aab99b4,
            5,
            true
        ],
        [
            "OperatesOn",
            $3b8da494b8e92f36$export$a48481dfef95f4a2,
            6,
            true
        ]
    ],
    2904328755: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3651124850: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "ProjectsElements",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            5,
            false
        ]
    ],
    1842657554: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2250791053: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1763565496: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2893384427: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3992365140: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    1891881377: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    2324767716: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1469900589: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    683857671: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4021432810: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "Positions",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            4,
            true
        ]
    ],
    3027567501: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    964333572: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2320036040: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2310774935: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    146592293: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    550521510: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    2781568857: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1768891740: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2157484638: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3649235739: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    544395925: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1027922057: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4074543187: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    33720170: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3599934289: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1894708472: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    42703149: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    4097777520: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    2533589738: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1072016465: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3856911033: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$20528f2adfe8dc9c,
            4,
            true
        ],
        [
            "BoundedBy",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            4,
            true
        ]
    ],
    1305183839: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3812236995: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3112655638: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1039846685: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    338393293: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    682877961: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1179482911: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    1004757350: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    4243806635: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    214636428: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    2445595289: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectedBy",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            4,
            true
        ]
    ],
    2757150158: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1807405624: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1252848954: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "SourceOfResultGroup",
            $3b8da494b8e92f36$export$88c23504cdda26e,
            6,
            true
        ],
        [
            "LoadGroupFor",
            $3b8da494b8e92f36$export$1a86b8c219c2e539,
            7,
            true
        ]
    ],
    2082059205: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    734778138: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    1235345126: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    2986769608: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ResultGroupFor",
            $3b8da494b8e92f36$export$1a86b8c219c2e539,
            8,
            true
        ]
    ],
    3657597509: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1975003073: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedStructuralActivity",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            4,
            true
        ],
        [
            "ConnectsStructuralMembers",
            $3b8da494b8e92f36$export$1fe9178d23052979,
            5,
            true
        ]
    ],
    148013059: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    3101698114: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "AdheresToElement",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            5,
            false
        ]
    ],
    2315554128: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2254336722: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ],
        [
            "ServicesFacilities",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    413509423: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    5716631: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3824725483: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2347447852: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3081323446: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3663046924: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2281632017: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2415094496: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    618700268: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1692211062: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2097647324: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1953115116: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3593883385: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1600972822: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1911125066: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    728799441: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    840318589: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    1530820697: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3956297820: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2391383451: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3313531582: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2769231204: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    926996030: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ]
    ],
    1898987631: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1133259667: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4009809668: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4088093105: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1028945134: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    4218914973: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    3342526732: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1033361043: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ],
        [
            "ServicesFacilities",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    3821786052: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "Controls",
            $3b8da494b8e92f36$export$d6a5461e4c9c5de9,
            6,
            true
        ]
    ],
    1411407467: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3352864051: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1871374353: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4266260250: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    1545765605: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    317615605: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    1662888072: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    3460190687: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    1532957894: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1967976161: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    2461110595: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    819618141: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3649138523: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    231477066: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1136057603: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    644574406: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    963979645: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    4031249490: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ]
    ],
    2979338954: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    39481116: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1909888760: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1177604601: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ],
        [
            "ServicesFacilities",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    1876633798: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3862327254: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ],
        [
            "ServicesFacilities",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    2188180465: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    395041908: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3293546465: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2674252688: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1285652485: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3203706013: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2951183804: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3296154744: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2611217952: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    1677625105: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2301859152: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    843113511: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    400855858: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3850581409: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2816379211: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3898045240: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    1060000209: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    488727124: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ResourceOf",
            $3b8da494b8e92f36$export$5c698c7bb50b493,
            6,
            true
        ]
    ],
    2940368186: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    335055490: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2954562838: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1502416096: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    1973544240: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "CoversSpaces",
            $3b8da494b8e92f36$export$20528f2adfe8dc9c,
            5,
            true
        ],
        [
            "CoversElements",
            $3b8da494b8e92f36$export$9572797f2851b0,
            5,
            true
        ]
    ],
    3495092785: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3961806047: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3426335179: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    1335981549: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2635815018: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    479945903: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1599208980: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2063403501: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1945004755: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ]
    ],
    3040386961: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3041715199: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainedIn",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            4,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$94d1e1fe7b940759,
            4,
            true
        ]
    ],
    3205830791: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ],
        [
            "ServicesFacilities",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    395920057: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    869906466: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3760055223: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2030761528: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3071239417: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "VoidsElements",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            5,
            false
        ]
    ],
    1077100507: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3376911765: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    663422040: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2417008758: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3277789161: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2142170206: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1534661035: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1217240411: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    712377611: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1658829314: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2814081492: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3747195512: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    484807127: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1209101575: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainsElements",
            $3b8da494b8e92f36$export$b933598a67b23044,
            5,
            true
        ],
        [
            "ServicedBySystems",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            5,
            true
        ],
        [
            "ReferencesElements",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "BoundedBy",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            4,
            true
        ]
    ],
    346874300: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1810631287: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4222183408: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2058353004: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4278956645: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4037862832: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2188021234: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3132237377: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    987401354: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    707683696: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2223149337: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3508470533: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    900683007: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2713699986: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3009204131: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "Positions",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            4,
            true
        ]
    ],
    3319311131: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2068733104: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4175244083: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2176052936: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2696325953: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    76236018: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    629592764: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1154579445: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "Positions",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            4,
            true
        ]
    ],
    1638804497: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1437502449: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1073191201: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2078563270: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    234836483: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2474470126: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2182337498: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    144952367: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3694346114: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1383356374: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    1687234759: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    310824031: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3612865200: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3171933400: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    738039164: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    655969474: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    90941305: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3290496277: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2262370178: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3024970846: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3283111854: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    1232101972: [
        [
            "LayerAssignment",
            $3b8da494b8e92f36$export$8fee3bf866f8cce8,
            2,
            true
        ],
        [
            "StyledByItem",
            $3b8da494b8e92f36$export$b718d0ddc70e8826,
            0,
            true
        ]
    ],
    3798194928: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    979691226: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2572171363: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    2016517767: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3053780830: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1783015770: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1329646415: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    991950508: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1529196076: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3420628829: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1999602285: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1404847402: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    331165859: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    4252922144: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2515109513: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ],
        [
            "ServicesFacilities",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    385403989: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "SourceOfResultGroup",
            $3b8da494b8e92f36$export$88c23504cdda26e,
            6,
            true
        ],
        [
            "LoadGroupFor",
            $3b8da494b8e92f36$export$1a86b8c219c2e539,
            7,
            true
        ]
    ],
    1621171031: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "AssignedToStructuralItem",
            $3b8da494b8e92f36$export$cf68aeaedc9f5bf1,
            5,
            true
        ]
    ],
    1162798199: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    812556717: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3425753595: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3825984169: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1620046519: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3026737570: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3179687236: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    4292641817: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4207607924: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2391406946: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3512223829: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    4237592921: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3304561284: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2874132201: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    1634111441: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    177149247: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2056796094: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3001207471: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    325726236: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "Positions",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            4,
            true
        ]
    ],
    277319702: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    753842376: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    4196446775: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    32344328: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3314249567: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    1095909175: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2938176219: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    635142910: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3758799889: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1051757585: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4217484030: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3999819293: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    3902619387: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    639361253: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3221913625: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3571504051: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    2272882330: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    578613899: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "Types",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            5,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ]
    ],
    3460952963: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4136498852: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3640358203: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    4074379575: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3693000487: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1052013943: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    562808652: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "IsGroupedBy",
            $3b8da494b8e92f36$export$95d386c017712592,
            6,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "ServicesBuildings",
            $3b8da494b8e92f36$export$c331bec3b085e9a1,
            4,
            true
        ],
        [
            "ServicesFacilities",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ]
    ],
    1062813311: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    342316401: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3518393246: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1360408905: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1904799276: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    862014818: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3310460725: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    24726584: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    264262732: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    402227799: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1003880860: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    3415622556: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    819412036: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    1426591983: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "HasControlElements",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            5,
            true
        ]
    ],
    182646315: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    2680139844: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    1971632696: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ]
    ],
    2295281155: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    4086658281: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    630975310: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    4288193352: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    3087945054: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ],
    25142252: [
        [
            "HasAssignments",
            $3b8da494b8e92f36$export$bb5ce9eb5b74ac1,
            4,
            true
        ],
        [
            "Nests",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            5,
            true
        ],
        [
            "IsNestedBy",
            $3b8da494b8e92f36$export$b1832f175144bc77,
            4,
            true
        ],
        [
            "HasContext",
            $3b8da494b8e92f36$export$4ea4a40a0b69b18b,
            5,
            true
        ],
        [
            "IsDecomposedBy",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            4,
            true
        ],
        [
            "Decomposes",
            $3b8da494b8e92f36$export$cff3fa05b2018b59,
            5,
            true
        ],
        [
            "HasAssociations",
            $3b8da494b8e92f36$export$87c3ff288d974d02,
            4,
            true
        ],
        [
            "IsDeclaredBy",
            $3b8da494b8e92f36$export$f650b9b610878411,
            4,
            true
        ],
        [
            "Declares",
            $3b8da494b8e92f36$export$f650b9b610878411,
            5,
            true
        ],
        [
            "IsTypedBy",
            $3b8da494b8e92f36$export$813f9cf6a2209fec,
            4,
            true
        ],
        [
            "IsDefinedBy",
            $3b8da494b8e92f36$export$bc9bd707c4403985,
            4,
            true
        ],
        [
            "ReferencedBy",
            $3b8da494b8e92f36$export$422809562a8398de,
            6,
            true
        ],
        [
            "PositionedRelativeTo",
            $3b8da494b8e92f36$export$c33f71f232dbf671,
            5,
            true
        ],
        [
            "ReferencedInStructures",
            $3b8da494b8e92f36$export$8d69d79340327b03,
            4,
            true
        ],
        [
            "FillsVoids",
            $3b8da494b8e92f36$export$51e6468498cab028,
            5,
            true
        ],
        [
            "ConnectedTo",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            5,
            true
        ],
        [
            "IsInterferedByElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            5,
            true
        ],
        [
            "InterferesElements",
            $3b8da494b8e92f36$export$bb6d5e50e6dcbd85,
            4,
            true
        ],
        [
            "HasProjections",
            $3b8da494b8e92f36$export$d35785e0f77dbe69,
            4,
            true
        ],
        [
            "HasOpenings",
            $3b8da494b8e92f36$export$27e14a4f50e6a1ce,
            4,
            true
        ],
        [
            "IsConnectionRealization",
            $3b8da494b8e92f36$export$edd14ec048dfff5c,
            7,
            true
        ],
        [
            "ProvidesBoundaries",
            $3b8da494b8e92f36$export$a712aed3e137585e,
            5,
            true
        ],
        [
            "ConnectedFrom",
            $3b8da494b8e92f36$export$4a59ec454710396a,
            6,
            true
        ],
        [
            "ContainedInStructure",
            $3b8da494b8e92f36$export$b933598a67b23044,
            4,
            true
        ],
        [
            "HasCoverings",
            $3b8da494b8e92f36$export$9572797f2851b0,
            4,
            true
        ],
        [
            "HasSurfaceFeatures",
            $3b8da494b8e92f36$export$79a1ba43c7a549ce,
            4,
            true
        ],
        [
            "HasPorts",
            $3b8da494b8e92f36$export$2b794d8b645d7087,
            5,
            true
        ],
        [
            "AssignedToFlowElement",
            $3b8da494b8e92f36$export$9cb68f339a367600,
            4,
            true
        ]
    ]
};
$3b8da494b8e92f36$export$cab133dc4b2240f9[3] = {
    3630933823: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActorRole(a[0], a[1], a[2]),
    618182010: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAddress(a[0], a[1], a[2]),
    2879124712: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentParameterSegment(a[0], a[1]),
    3633395639: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentVerticalSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    639542469: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcApplication(a[0], a[1], a[2], a[3]),
    411424972: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAppliedValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    130549933: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcApproval(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4037036970: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryCondition(a[0]),
    1560379544: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryEdgeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3367102660: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryFaceCondition(a[0], a[1], a[2], a[3]),
    1387855156: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryNodeCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2069777674: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryNodeConditionWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2859738748: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionGeometry(),
    2614616156: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionPointGeometry(a[0], a[1]),
    2732653382: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionSurfaceGeometry(a[0], a[1]),
    775493141: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionVolumeGeometry(a[0], a[1]),
    1959218052: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1785450214: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoordinateOperation(a[0], a[1]),
    1466758467: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoordinateReferenceSystem(a[0], a[1], a[2]),
    602808272: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCostValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1765591967: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDerivedUnit(a[0], a[1], a[2], a[3]),
    1045800335: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDerivedUnitElement(a[0], a[1]),
    2949456006: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDimensionalExponents(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    4294318154: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalInformation(),
    3200245327: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalReference(a[0], a[1], a[2]),
    2242383968: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternallyDefinedHatchStyle(a[0], a[1], a[2]),
    1040185647: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternallyDefinedSurfaceStyle(a[0], a[1], a[2]),
    3548104201: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternallyDefinedTextFont(a[0], a[1], a[2]),
    917726184: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeographicCRS(a[0], a[1], a[2], a[3], a[4], a[5]),
    852622518: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGridAxis(a[0], a[1], a[2]),
    3020489413: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIrregularTimeSeriesValue(a[0], a[1]),
    2655187982: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLibraryInformation(a[0], a[1], a[2], a[3], a[4], a[5]),
    3452421091: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLibraryReference(a[0], a[1], a[2], a[3], a[4], a[5]),
    4162380809: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightDistributionData(a[0], a[1], a[2]),
    1566485204: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightIntensityDistribution(a[0], a[1]),
    3057273783: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMapConversion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4105526436: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMapConversionScaled(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1847130766: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialClassificationRelationship(a[0], a[1]),
    760658860: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialDefinition(),
    248100487: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialLayer(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3303938423: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialLayerSet(a[0], a[1], a[2]),
    1847252529: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialLayerWithOffsets(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2199411900: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialList(a[0]),
    2235152071: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfile(a[0], a[1], a[2], a[3], a[4], a[5]),
    164193824: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfileSet(a[0], a[1], a[2], a[3]),
    552965576: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfileWithOffsets(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1507914824: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialUsageDefinition(),
    2597039031: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMeasureWithUnit(a[0], a[1]),
    3368373690: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMetric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2706619895: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMonetaryUnit(a[0]),
    1918398963: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNamedUnit(a[0], a[1]),
    3701648758: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcObjectPlacement(a[0]),
    2251480897: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcObjective(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4251960020: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOrganization(a[0], a[1], a[2], a[3], a[4]),
    1207048766: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOwnerHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2077209135: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPerson(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    101040310: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPersonAndOrganization(a[0], a[1], a[2]),
    2483315170: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPhysicalQuantity(a[0], a[1]),
    2226359599: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPhysicalSimpleQuantity(a[0], a[1], a[2]),
    3355820592: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPostalAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    677532197: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentationItem(),
    2022622350: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentationLayerAssignment(a[0], a[1], a[2], a[3]),
    1304840413: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentationLayerWithStyle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3119450353: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentationStyle(a[0]),
    2095639259: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProductRepresentation(a[0], a[1], a[2]),
    3958567839: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProfileDef(a[0], a[1]),
    3843373140: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProjectedCRS(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    986844984: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyAbstraction(),
    3710013099: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyEnumeration(a[0], a[1], a[2]),
    2044713172: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityArea(a[0], a[1], a[2], a[3], a[4]),
    2093928680: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityCount(a[0], a[1], a[2], a[3], a[4]),
    931644368: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityLength(a[0], a[1], a[2], a[3], a[4]),
    2691318326: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityNumber(a[0], a[1], a[2], a[3], a[4]),
    3252649465: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityTime(a[0], a[1], a[2], a[3], a[4]),
    2405470396: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityVolume(a[0], a[1], a[2], a[3], a[4]),
    825690147: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantityWeight(a[0], a[1], a[2], a[3], a[4]),
    3915482550: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRecurrencePattern(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2433181523: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReference(a[0], a[1], a[2], a[3], a[4]),
    1076942058: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRepresentation(a[0], a[1], a[2], a[3]),
    3377609919: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRepresentationContext(a[0], a[1]),
    3008791417: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRepresentationItem(),
    1660063152: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRepresentationMap(a[0], a[1]),
    2439245199: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResourceLevelRelationship(a[0], a[1]),
    1794013214: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRigidOperation(a[0], a[1], a[2], a[3], a[4]),
    2341007311: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoot(a[0], a[1], a[2], a[3]),
    448429030: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSIUnit(a[0], a[1], a[2]),
    1054537805: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSchedulingTime(a[0], a[1], a[2]),
    867548509: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShapeAspect(a[0], a[1], a[2], a[3], a[4]),
    3982875396: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShapeModel(a[0], a[1], a[2], a[3]),
    4240577450: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShapeRepresentation(a[0], a[1], a[2], a[3]),
    2273995522: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralConnectionCondition(a[0]),
    2162789131: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoad(a[0]),
    3478079324: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadConfiguration(a[0], a[1], a[2]),
    609421318: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadOrResult(a[0]),
    2525727697: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadStatic(a[0]),
    3408363356: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadTemperature(a[0], a[1], a[2], a[3]),
    2830218821: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStyleModel(a[0], a[1], a[2], a[3]),
    3958052878: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStyledItem(a[0], a[1], a[2]),
    3049322572: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStyledRepresentation(a[0], a[1], a[2], a[3]),
    2934153892: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceReinforcementArea(a[0], a[1], a[2], a[3]),
    1300840506: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyle(a[0], a[1], a[2]),
    3303107099: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleLighting(a[0], a[1], a[2], a[3]),
    1607154358: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleRefraction(a[0], a[1]),
    846575682: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleShading(a[0], a[1]),
    1351298697: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleWithTextures(a[0]),
    626085974: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceTexture(a[0], a[1], a[2], a[3], a[4]),
    985171141: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTable(a[0], a[1], a[2]),
    2043862942: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTableColumn(a[0], a[1], a[2], a[3], a[4]),
    531007025: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTableRow(a[0], a[1]),
    1549132990: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTaskTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
    2771591690: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTaskTimeRecurring(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20]),
    912023232: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTelecomAddress(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1447204868: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextStyle(a[0], a[1], a[2], a[3], a[4]),
    2636378356: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextStyleForDefinedFont(a[0], a[1]),
    1640371178: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextStyleTextModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    280115917: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureCoordinate(a[0]),
    1742049831: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureCoordinateGenerator(a[0], a[1], a[2]),
    222769930: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureCoordinateIndices(a[0], a[1]),
    1010789467: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureCoordinateIndicesWithVoids(a[0], a[1], a[2]),
    2552916305: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureMap(a[0], a[1], a[2]),
    1210645708: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureVertex(a[0]),
    3611470254: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextureVertexList(a[0]),
    1199560280: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimePeriod(a[0], a[1]),
    3101149627: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    581633288: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeSeriesValue(a[0]),
    1377556343: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTopologicalRepresentationItem(),
    1735638870: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTopologyRepresentation(a[0], a[1], a[2], a[3]),
    180925521: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitAssignment(a[0]),
    2799835756: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVertex(),
    1907098498: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVertexPoint(a[0]),
    891718957: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVirtualGridIntersection(a[0], a[1]),
    1175146630: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWellKnownText(a[0], a[1]),
    1236880293: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkTime(a[0], a[1], a[2], a[3], a[4], a[5]),
    3752311538: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentCantSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    536804194: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentHorizontalSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3869604511: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcApprovalRelationship(a[0], a[1], a[2], a[3]),
    3798115385: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcArbitraryClosedProfileDef(a[0], a[1], a[2]),
    1310608509: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcArbitraryOpenProfileDef(a[0], a[1], a[2]),
    2705031697: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcArbitraryProfileDefWithVoids(a[0], a[1], a[2], a[3]),
    616511568: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBlobTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3150382593: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCenterLineProfileDef(a[0], a[1], a[2], a[3]),
    747523909: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcClassification(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    647927063: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcClassificationReference(a[0], a[1], a[2], a[3], a[4], a[5]),
    3285139300: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColourRgbList(a[0]),
    3264961684: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColourSpecification(a[0]),
    1485152156: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompositeProfileDef(a[0], a[1], a[2], a[3]),
    370225590: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectedFaceSet(a[0]),
    1981873012: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionCurveGeometry(a[0], a[1]),
    45288368: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConnectionPointEccentricity(a[0], a[1], a[2], a[3], a[4]),
    3050246964: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcContextDependentUnit(a[0], a[1], a[2]),
    2889183280: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConversionBasedUnit(a[0], a[1], a[2], a[3]),
    2713554722: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConversionBasedUnitWithOffset(a[0], a[1], a[2], a[3], a[4]),
    539742890: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurrencyRelationship(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3800577675: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveStyle(a[0], a[1], a[2], a[3], a[4]),
    1105321065: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveStyleFont(a[0], a[1]),
    2367409068: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveStyleFontAndScaling(a[0], a[1], a[2]),
    3510044353: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveStyleFontPattern(a[0], a[1]),
    3632507154: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDerivedProfileDef(a[0], a[1], a[2], a[3], a[4]),
    1154170062: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDocumentInformation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
    770865208: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDocumentInformationRelationship(a[0], a[1], a[2], a[3], a[4]),
    3732053477: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDocumentReference(a[0], a[1], a[2], a[3], a[4]),
    3900360178: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEdge(a[0], a[1]),
    476780140: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEdgeCurve(a[0], a[1], a[2], a[3]),
    211053100: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEventTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    297599258: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExtendedProperties(a[0], a[1], a[2]),
    1437805879: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalReferenceRelationship(a[0], a[1], a[2], a[3]),
    2556980723: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFace(a[0]),
    1809719519: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFaceBound(a[0], a[1]),
    803316827: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFaceOuterBound(a[0], a[1]),
    3008276851: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFaceSurface(a[0], a[1], a[2]),
    4219587988: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFailureConnectionCondition(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    738692330: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFillAreaStyle(a[0], a[1], a[2]),
    3448662350: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricRepresentationContext(a[0], a[1], a[2], a[3], a[4], a[5]),
    2453401579: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricRepresentationItem(),
    4142052618: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricRepresentationSubContext(a[0], a[1], a[2], a[3], a[4], a[5]),
    3590301190: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricSet(a[0]),
    178086475: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGridPlacement(a[0], a[1], a[2]),
    812098782: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHalfSpaceSolid(a[0], a[1]),
    3905492369: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcImageTexture(a[0], a[1], a[2], a[3], a[4], a[5]),
    3570813810: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedColourMap(a[0], a[1], a[2], a[3]),
    1437953363: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedTextureMap(a[0], a[1], a[2]),
    2133299955: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedTriangleTextureMap(a[0], a[1], a[2], a[3]),
    3741457305: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIrregularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1585845231: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLagTime(a[0], a[1], a[2], a[3], a[4]),
    1402838566: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSource(a[0], a[1], a[2], a[3]),
    125510826: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourceAmbient(a[0], a[1], a[2], a[3]),
    2604431987: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourceDirectional(a[0], a[1], a[2], a[3], a[4]),
    4266656042: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourceGoniometric(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1520743889: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourcePositional(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3422422726: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightSourceSpot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    388784114: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearPlacement(a[0], a[1], a[2]),
    2624227202: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLocalPlacement(a[0], a[1]),
    1008929658: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLoop(),
    2347385850: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMappedItem(a[0], a[1]),
    1838606355: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterial(a[0], a[1], a[2]),
    3708119e3: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialConstituent(a[0], a[1], a[2], a[3], a[4]),
    2852063980: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialConstituentSet(a[0], a[1], a[2]),
    2022407955: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialDefinitionRepresentation(a[0], a[1], a[2], a[3]),
    1303795690: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialLayerSetUsage(a[0], a[1], a[2], a[3], a[4]),
    3079605661: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfileSetUsage(a[0], a[1], a[2]),
    3404854881: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProfileSetUsageTapering(a[0], a[1], a[2], a[3], a[4]),
    3265635763: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialProperties(a[0], a[1], a[2], a[3]),
    853536259: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMaterialRelationship(a[0], a[1], a[2], a[3], a[4]),
    2998442950: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMirroredProfileDef(a[0], a[1], a[2], a[3]),
    219451334: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcObjectDefinition(a[0], a[1], a[2], a[3]),
    182550632: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOpenCrossProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2665983363: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOpenShell(a[0]),
    1411181986: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOrganizationRelationship(a[0], a[1], a[2], a[3]),
    1029017970: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOrientedEdge(a[0], a[1]),
    2529465313: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterizedProfileDef(a[0], a[1], a[2]),
    2519244187: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPath(a[0]),
    3021840470: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPhysicalComplexQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
    597895409: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPixelTexture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2004835150: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlacement(a[0]),
    1663979128: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlanarExtent(a[0], a[1]),
    2067069095: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPoint(),
    2165702409: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPointByDistanceExpression(a[0], a[1], a[2], a[3], a[4]),
    4022376103: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPointOnCurve(a[0], a[1]),
    1423911732: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPointOnSurface(a[0], a[1], a[2]),
    2924175390: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolyLoop(a[0]),
    2775532180: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolygonalBoundedHalfSpace(a[0], a[1], a[2], a[3]),
    3727388367: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedItem(a[0]),
    3778827333: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedProperties(),
    1775413392: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedTextFont(a[0]),
    673634403: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProductDefinitionShape(a[0], a[1], a[2]),
    2802850158: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProfileProperties(a[0], a[1], a[2], a[3]),
    2598011224: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProperty(a[0], a[1]),
    1680319473: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyDefinition(a[0], a[1], a[2], a[3]),
    148025276: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyDependencyRelationship(a[0], a[1], a[2], a[3], a[4]),
    3357820518: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertySetDefinition(a[0], a[1], a[2], a[3]),
    1482703590: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyTemplateDefinition(a[0], a[1], a[2], a[3]),
    2090586900: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcQuantitySet(a[0], a[1], a[2], a[3]),
    3615266464: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRectangleProfileDef(a[0], a[1], a[2], a[3], a[4]),
    3413951693: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRegularTimeSeries(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1580146022: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcementBarProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    478536968: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelationship(a[0], a[1], a[2], a[3]),
    2943643501: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResourceApprovalRelationship(a[0], a[1], a[2], a[3]),
    1608871552: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResourceConstraintRelationship(a[0], a[1], a[2], a[3]),
    1042787934: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResourceTime(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
    2778083089: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoundedRectangleProfileDef(a[0], a[1], a[2], a[3], a[4], a[5]),
    2042790032: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionProperties(a[0], a[1], a[2]),
    4165799628: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionReinforcementProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    1509187699: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionedSpine(a[0], a[1], a[2]),
    823603102: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSegment(a[0]),
    4124623270: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShellBasedSurfaceModel(a[0]),
    3692461612: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSimpleProperty(a[0], a[1]),
    2609359061: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSlippageConnectionCondition(a[0], a[1], a[2], a[3]),
    723233188: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSolidModel(),
    1595516126: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadLinearForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2668620305: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadPlanarForce(a[0], a[1], a[2], a[3]),
    2473145415: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadSingleDisplacement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1973038258: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadSingleDisplacementDistortion(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1597423693: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadSingleForce(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1190533807: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadSingleForceWarping(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2233826070: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSubedge(a[0], a[1], a[2]),
    2513912981: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurface(),
    1878645084: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceStyleRendering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2247615214: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSweptAreaSolid(a[0], a[1]),
    1260650574: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSweptDiskSolid(a[0], a[1], a[2], a[3], a[4]),
    1096409881: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSweptDiskSolidPolygonal(a[0], a[1], a[2], a[3], a[4], a[5]),
    230924584: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSweptSurface(a[0], a[1]),
    3071757647: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    901063453: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTessellatedItem(),
    4282788508: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextLiteral(a[0], a[1], a[2]),
    3124975700: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextLiteralWithExtent(a[0], a[1], a[2], a[3], a[4]),
    1983826977: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextStyleFontModel(a[0], a[1], a[2], a[3], a[4], a[5]),
    2715220739: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTrapeziumProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1628702193: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTypeObject(a[0], a[1], a[2], a[3], a[4], a[5]),
    3736923433: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTypeProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2347495698: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTypeProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3698973494: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTypeResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    427810014: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1417489154: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVector(a[0], a[1]),
    2759199220: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVertexLoop(a[0]),
    2543172580: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcZShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3406155212: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAdvancedFace(a[0], a[1], a[2]),
    669184980: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAnnotationFillArea(a[0], a[1]),
    3207858831: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAsymmetricIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]),
    4261334040: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAxis1Placement(a[0], a[1]),
    3125803723: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAxis2Placement2D(a[0], a[1]),
    2740243338: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAxis2Placement3D(a[0], a[1], a[2]),
    3425423356: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAxis2PlacementLinear(a[0], a[1], a[2]),
    2736907675: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBooleanResult(a[0], a[1], a[2]),
    4182860854: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundedSurface(),
    2581212453: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundingBox(a[0], a[1], a[2], a[3]),
    2713105998: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoxedHalfSpace(a[0], a[1], a[2]),
    2898889636: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1123145078: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianPoint(a[0]),
    574549367: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianPointList(),
    1675464909: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianPointList2D(a[0], a[1]),
    2059837836: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianPointList3D(a[0], a[1]),
    59481748: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator(a[0], a[1], a[2], a[3]),
    3749851601: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator2D(a[0], a[1], a[2], a[3]),
    3486308946: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator2DnonUniform(a[0], a[1], a[2], a[3], a[4]),
    3331915920: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator3D(a[0], a[1], a[2], a[3], a[4]),
    1416205885: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCartesianTransformationOperator3DnonUniform(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1383045692: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCircleProfileDef(a[0], a[1], a[2], a[3]),
    2205249479: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcClosedShell(a[0]),
    776857604: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColourRgb(a[0], a[1], a[2], a[3]),
    2542286263: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcComplexProperty(a[0], a[1], a[2], a[3]),
    2485617015: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompositeCurveSegment(a[0], a[1], a[2]),
    2574617495: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3419103109: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcContext(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1815067380: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCrewResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    2506170314: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCsgPrimitive3D(a[0]),
    2147822146: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCsgSolid(a[0]),
    2601014836: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurve(),
    2827736869: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveBoundedPlane(a[0], a[1], a[2]),
    2629017746: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveBoundedSurface(a[0], a[1], a[2]),
    4212018352: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurveSegment(a[0], a[1], a[2], a[3], a[4]),
    32440307: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDirection(a[0]),
    593015953: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDirectrixCurveSweptAreaSolid(a[0], a[1], a[2], a[3], a[4]),
    1472233963: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEdgeLoop(a[0]),
    1883228015: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementQuantity(a[0], a[1], a[2], a[3], a[4], a[5]),
    339256511: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2777663545: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementarySurface(a[0]),
    2835456948: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEllipseProfileDef(a[0], a[1], a[2], a[3], a[4]),
    4024345920: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEventType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    477187591: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExtrudedAreaSolid(a[0], a[1], a[2], a[3]),
    2804161546: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExtrudedAreaSolidTapered(a[0], a[1], a[2], a[3], a[4]),
    2047409740: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFaceBasedSurfaceModel(a[0]),
    374418227: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFillAreaStyleHatching(a[0], a[1], a[2], a[3], a[4]),
    315944413: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFillAreaStyleTiles(a[0], a[1], a[2]),
    2652556860: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFixedReferenceSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
    4238390223: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFurnishingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1268542332: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFurnitureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4095422895: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeographicElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    987898635: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeometricCurveSet(a[0]),
    1484403080: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    178912537: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedPolygonalFace(a[0]),
    2294589976: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedPolygonalFaceWithVoids(a[0], a[1]),
    3465909080: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedPolygonalTextureMap(a[0], a[1], a[2], a[3]),
    572779678: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLShapeProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    428585644: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLaborResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1281925730: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLine(a[0], a[1]),
    1425443689: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcManifoldSolidBrep(a[0]),
    3888040117: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcObject(a[0], a[1], a[2], a[3], a[4]),
    590820931: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOffsetCurve(a[0]),
    3388369263: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOffsetCurve2D(a[0], a[1], a[2]),
    3505215534: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOffsetCurve3D(a[0], a[1], a[2], a[3]),
    2485787929: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOffsetCurveByDistances(a[0], a[1], a[2]),
    1682466193: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPcurve(a[0], a[1]),
    603570806: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlanarBox(a[0], a[1], a[2]),
    220341763: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlane(a[0]),
    3381221214: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolynomialCurve(a[0], a[1], a[2], a[3]),
    759155922: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedColour(a[0]),
    2559016684: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedCurveFont(a[0]),
    3967405729: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPreDefinedPropertySet(a[0], a[1], a[2], a[3]),
    569719735: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProcedureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2945172077: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    4208778838: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    103090709: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProject(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    653396225: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProjectLibrary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    871118103: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyBoundedValue(a[0], a[1], a[2], a[3], a[4], a[5]),
    4166981789: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyEnumeratedValue(a[0], a[1], a[2], a[3]),
    2752243245: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyListValue(a[0], a[1], a[2], a[3]),
    941946838: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyReferenceValue(a[0], a[1], a[2], a[3]),
    1451395588: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertySet(a[0], a[1], a[2], a[3], a[4]),
    492091185: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertySetTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3650150729: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertySingleValue(a[0], a[1], a[2], a[3]),
    110355661: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyTableValue(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3521284610: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertyTemplate(a[0], a[1], a[2], a[3]),
    2770003689: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRectangleHollowProfileDef(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2798486643: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRectangularPyramid(a[0], a[1], a[2], a[3]),
    3454111270: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRectangularTrimmedSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3765753017: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcementDefinitionProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    3939117080: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssigns(a[0], a[1], a[2], a[3], a[4], a[5]),
    1683148259: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToActor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2495723537: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1307041759: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1027710054: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToGroupByFactor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4278684876: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToProcess(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2857406711: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToProduct(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    205026976: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssignsToResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1865459582: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociates(a[0], a[1], a[2], a[3], a[4]),
    4095574036: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesApproval(a[0], a[1], a[2], a[3], a[4], a[5]),
    919958153: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesClassification(a[0], a[1], a[2], a[3], a[4], a[5]),
    2728634034: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesConstraint(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    982818633: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesDocument(a[0], a[1], a[2], a[3], a[4], a[5]),
    3840914261: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesLibrary(a[0], a[1], a[2], a[3], a[4], a[5]),
    2655215786: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesMaterial(a[0], a[1], a[2], a[3], a[4], a[5]),
    1033248425: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAssociatesProfileDef(a[0], a[1], a[2], a[3], a[4], a[5]),
    826625072: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnects(a[0], a[1], a[2], a[3]),
    1204542856: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3945020480: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsPathElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4201705270: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsPortToElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    3190031847: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsPorts(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2127690289: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5]),
    1638771189: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    504942748: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsWithEccentricity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3678494232: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelConnectsWithRealizingElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3242617779: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelContainedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
    886880790: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelCoversBldgElements(a[0], a[1], a[2], a[3], a[4], a[5]),
    2802773753: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelCoversSpaces(a[0], a[1], a[2], a[3], a[4], a[5]),
    2565941209: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDeclares(a[0], a[1], a[2], a[3], a[4], a[5]),
    2551354335: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDecomposes(a[0], a[1], a[2], a[3]),
    693640335: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefines(a[0], a[1], a[2], a[3]),
    1462361463: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefinesByObject(a[0], a[1], a[2], a[3], a[4], a[5]),
    4186316022: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefinesByProperties(a[0], a[1], a[2], a[3], a[4], a[5]),
    307848117: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefinesByTemplate(a[0], a[1], a[2], a[3], a[4], a[5]),
    781010003: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelDefinesByType(a[0], a[1], a[2], a[3], a[4], a[5]),
    3940055652: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelFillsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    279856033: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelFlowControlElements(a[0], a[1], a[2], a[3], a[4], a[5]),
    427948657: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelInterferesElements(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3268803585: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelNests(a[0], a[1], a[2], a[3], a[4], a[5]),
    1441486842: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelPositions(a[0], a[1], a[2], a[3], a[4], a[5]),
    750771296: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelProjectsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    1245217292: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelReferencedInSpatialStructure(a[0], a[1], a[2], a[3], a[4], a[5]),
    4122056220: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelSequence(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    366585022: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelServicesBuildings(a[0], a[1], a[2], a[3], a[4], a[5]),
    3451746338: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelSpaceBoundary(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3523091289: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelSpaceBoundary1stLevel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1521410863: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelSpaceBoundary2ndLevel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1401173127: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelVoidsElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    816062949: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReparametrisedCompositeCurveSegment(a[0], a[1], a[2], a[3]),
    2914609552: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1856042241: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRevolvedAreaSolid(a[0], a[1], a[2], a[3]),
    3243963512: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRevolvedAreaSolidTapered(a[0], a[1], a[2], a[3], a[4]),
    4158566097: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRightCircularCone(a[0], a[1], a[2]),
    3626867408: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRightCircularCylinder(a[0], a[1], a[2]),
    1862484736: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionedSolid(a[0], a[1]),
    1290935644: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionedSolidHorizontal(a[0], a[1], a[2]),
    1356537516: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionedSurface(a[0], a[1], a[2]),
    3663146110: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSimplePropertyTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1412071761: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    710998568: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2706606064: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3893378262: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialStructureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    463610769: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialZone(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2481509218: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpatialZoneType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    451544542: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSphere(a[0], a[1]),
    4015995234: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSphericalSurface(a[0], a[1]),
    2735484536: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpiral(a[0]),
    3544373492: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralActivity(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3136571912: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    530289379: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3689010777: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3979015343: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2218152070: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    603775116: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4095615324: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSubContractResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    699246055: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceCurve(a[0], a[1], a[2]),
    2028607225: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceCurveSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
    2809605785: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceOfLinearExtrusion(a[0], a[1], a[2], a[3]),
    4124788165: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceOfRevolution(a[0], a[1], a[2]),
    1580310250: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSystemFurnitureElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3473067441: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTask(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    3206491090: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTaskType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2387106220: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTessellatedFaceSet(a[0]),
    782932809: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThirdOrderPolynomialSpiral(a[0], a[1], a[2], a[3], a[4]),
    1935646853: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcToroidalSurface(a[0], a[1], a[2]),
    3665877780: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransportationDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2916149573: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTriangulatedFaceSet(a[0], a[1], a[2], a[3], a[4]),
    1229763772: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTriangulatedIrregularNetwork(a[0], a[1], a[2], a[3], a[4], a[5]),
    3651464721: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVehicleType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    336235671: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWindowLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
    512836454: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWindowPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2296667514: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActor(a[0], a[1], a[2], a[3], a[4], a[5]),
    1635779807: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAdvancedBrep(a[0]),
    2603310189: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAdvancedBrepWithVoids(a[0], a[1]),
    1674181508: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAnnotation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2887950389: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBSplineSurface(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    167062518: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBSplineSurfaceWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1334484129: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBlock(a[0], a[1], a[2], a[3]),
    3649129432: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBooleanClippingResult(a[0], a[1], a[2]),
    1260505505: (_)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundedCurve(),
    3124254112: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingStorey(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1626504194: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuiltElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2197970202: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcChimneyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2937912522: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCircleHollowProfileDef(a[0], a[1], a[2], a[3], a[4]),
    3893394355: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCivilElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3497074424: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcClothoid(a[0], a[1]),
    300633059: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColumnType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3875453745: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcComplexPropertyTemplate(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3732776249: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompositeCurve(a[0], a[1]),
    15328376: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompositeCurveOnSurface(a[0], a[1]),
    2510884976: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConic(a[0]),
    2185764099: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionEquipmentResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    4105962743: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionMaterialResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1525564444: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionProductResourceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    2559216714: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3293443760: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcControl(a[0], a[1], a[2], a[3], a[4], a[5]),
    2000195564: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCosineSpiral(a[0], a[1], a[2]),
    3895139033: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCostItem(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1419761937: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCostSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4189326743: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCourseType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1916426348: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoveringType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3295246426: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCrewResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1457835157: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurtainWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1213902940: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCylindricalSurface(a[0], a[1]),
    1306400036: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDeepFoundationType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4234616927: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDirectrixDerivedReferenceSweptAreaSolid(a[0], a[1], a[2], a[3], a[4], a[5]),
    3256556792: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3849074793: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionFlowElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2963535650: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDoorLiningProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
    1714330368: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDoorPanelProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2323601079: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDoorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    445594917: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDraughtingPreDefinedColour(a[0]),
    4006246654: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDraughtingPreDefinedCurveFont(a[0]),
    1758889154: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4123344466: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementAssembly(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2397081782: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementAssemblyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1623761950: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementComponent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2590856083: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElementComponentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1704287377: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEllipse(a[0], a[1], a[2]),
    2107101300: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEnergyConversionDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    132023988: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEngineType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3174744832: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvaporativeCoolerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3390157468: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvaporatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4148101412: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2853485674: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalSpatialStructureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    807026263: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacetedBrep(a[0]),
    3737207727: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacetedBrepWithVoids(a[0], a[1]),
    24185140: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacility(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1310830890: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacilityPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4228831410: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFacilityPartCommon(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    647756555: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2489546625: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2827207264: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFeatureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2143335405: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFeatureElementAddition(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1287392070: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFeatureElementSubtraction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3907093117: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3198132628: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3815607619: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowMeterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1482959167: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowMovingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1834744321: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1339347760: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2297155007: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3009222698: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowTreatmentDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1893162501: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFootingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    263784265: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFurnishingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1509553395: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFurniture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3493046030: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeographicElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4230923436: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeotechnicalElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1594536857: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeotechnicalStratum(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2898700619: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGradientCurve(a[0], a[1], a[2], a[3]),
    2706460486: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGroup(a[0], a[1], a[2], a[3], a[4]),
    1251058090: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHeatExchangerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1806887404: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHumidifierType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2568555532: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcImpactProtectionDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3948183225: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcImpactProtectionDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2571569899: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIndexedPolyCurve(a[0], a[1], a[2]),
    3946677679: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInterceptorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3113134337: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIntersectionCurve(a[0], a[1], a[2]),
    2391368822: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInventory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4288270099: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcJunctionBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    679976338: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcKerbType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3827777499: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLaborResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1051575348: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1161773419: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightFixtureType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2176059722: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1770583370: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLiquidTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    525669439: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMarineFacility(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    976884017: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMarinePart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    377706215: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMechanicalFastener(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2108223431: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMechanicalFastenerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1114901282: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMedicalDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3181161470: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMemberType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1950438474: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMobileTelecommunicationsApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    710110818: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMooringDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    977012517: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMotorConnectionType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    506776471: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNavigationElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4143007308: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOccupant(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3588315303: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOpeningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2837617999: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOutletType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    514975943: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPavementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2382730787: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPerformanceHistory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3566463478: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPermeableCoveringProperties(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3327091369: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPermit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1158309216: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPileType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    804291784: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPipeFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4231323485: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPipeSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4017108033: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlateType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2839578677: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolygonalFaceSet(a[0], a[1], a[2], a[3]),
    3724593414: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPolyline(a[0]),
    3740093272: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1946335990: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositioningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2744685151: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProcedure(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2904328755: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProjectOrder(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3651124850: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProjectionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1842657554: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProtectiveDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2250791053: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPumpType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1763565496: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2893384427: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3992365140: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailway(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1891881377: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailwayPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2324767716: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRampFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1469900589: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRampType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    683857671: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRationalBSplineSurfaceWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    4021432810: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReferent(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3027567501: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    964333572: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2320036040: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingMesh(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]),
    2310774935: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingMeshType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]),
    3818125796: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAdheresToElement(a[0], a[1], a[2], a[3], a[4], a[5]),
    160246688: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRelAggregates(a[0], a[1], a[2], a[3], a[4], a[5]),
    146592293: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoad(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    550521510: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoadPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2781568857: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoofType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1768891740: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSanitaryTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2157484638: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSeamCurve(a[0], a[1], a[2]),
    3649235739: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSecondOrderPolynomialSpiral(a[0], a[1], a[2], a[3]),
    544395925: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSegmentedReferenceCurve(a[0], a[1], a[2], a[3]),
    1027922057: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSeventhOrderPolynomialSpiral(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4074543187: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShadingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    33720170: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSign(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3599934289: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSignType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1894708472: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSignalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    42703149: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSineSpiral(a[0], a[1], a[2], a[3]),
    4097777520: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSite(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    2533589738: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSlabType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1072016465: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSolarDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3856911033: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpace(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1305183839: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpaceHeaterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3812236995: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpaceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3112655638: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStackTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1039846685: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStairFlightType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    338393293: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStairType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    682877961: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1179482911: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1004757350: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    4243806635: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    214636428: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2445595289: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveMemberVarying(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2757150158: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralCurveReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1807405624: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLinearAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1252848954: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2082059205: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralPointAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    734778138: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralPointConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1235345126: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralPointReaction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2986769608: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralResultGroup(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3657597509: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1975003073: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralSurfaceConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    148013059: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSubContractResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3101698114: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSurfaceFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2315554128: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSwitchingDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2254336722: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSystem(a[0], a[1], a[2], a[3], a[4]),
    413509423: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSystemFurnitureElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    5716631: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTankType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3824725483: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendon(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]),
    2347447852: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonAnchor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3081323446: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonAnchorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3663046924: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonConduit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2281632017: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonConduitType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2415094496: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTendonType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    618700268: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTrackElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1692211062: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransformerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2097647324: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransportElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1953115116: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransportationDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3593883385: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTrimmedCurve(a[0], a[1], a[2], a[3], a[4]),
    1600972822: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTubeBundleType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1911125066: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitaryEquipmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    728799441: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcValveType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    840318589: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVehicle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1530820697: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVibrationDamper(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3956297820: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVibrationDamperType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2391383451: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVibrationIsolator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3313531582: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVibrationIsolatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2769231204: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVirtualElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    926996030: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVoidingFeature(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1898987631: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWallType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1133259667: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWasteTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4009809668: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWindowType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    4088093105: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkCalendar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1028945134: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    4218914973: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkPlan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    3342526732: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWorkSchedule(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    1033361043: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcZone(a[0], a[1], a[2], a[3], a[4], a[5]),
    3821786052: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActionRequest(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1411407467: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirTerminalBoxType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3352864051: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1871374353: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirToAirHeatRecoveryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4266260250: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentCant(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1545765605: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentHorizontal(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    317615605: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1662888072: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignmentVertical(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    3460190687: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAsset(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    1532957894: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAudioVisualApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1967976161: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBSplineCurve(a[0], a[1], a[2], a[3], a[4]),
    2461110595: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBSplineCurveWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    819618141: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3649138523: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBearingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    231477066: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoilerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1136057603: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoundaryCurve(a[0], a[1]),
    644574406: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBridge(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    963979645: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBridgePart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    4031249490: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuilding(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    2979338954: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingElementPart(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    39481116: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingElementPartType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1909888760: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingElementProxyType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1177604601: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1876633798: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuiltElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3862327254: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuiltSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    2188180465: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBurnerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    395041908: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableCarrierFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3293546465: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableCarrierSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2674252688: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1285652485: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3203706013: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCaissonFoundationType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2951183804: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcChillerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3296154744: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcChimney(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2611217952: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCircle(a[0], a[1]),
    1677625105: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCivilElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2301859152: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoilType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    843113511: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcColumn(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    400855858: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCommunicationsApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3850581409: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompressorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2816379211: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCondenserType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3898045240: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionEquipmentResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1060000209: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionMaterialResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    488727124: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConstructionProductResource(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    2940368186: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConveyorSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    335055490: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCooledBeamType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2954562838: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoolingTowerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1502416096: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCourse(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1973544240: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCovering(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3495092785: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurtainWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3961806047: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDamperType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3426335179: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDeepFoundation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1335981549: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDiscreteAccessory(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2635815018: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDiscreteAccessoryType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    479945903: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionBoardType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1599208980: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionChamberElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2063403501: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1945004755: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3040386961: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionFlowElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3041715199: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionPort(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3205830791: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionSystem(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    395920057: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDoor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    869906466: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctFittingType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3760055223: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctSegmentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2030761528: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctSilencerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3071239417: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEarthworksCut(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1077100507: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEarthworksElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3376911765: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEarthworksFill(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    663422040: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricApplianceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2417008758: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricDistributionBoardType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3277789161: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricFlowStorageDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2142170206: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricFlowTreatmentDeviceType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1534661035: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricGeneratorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1217240411: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricMotorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    712377611: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricTimeControlType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1658829314: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEnergyConversionDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2814081492: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEngine(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3747195512: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvaporativeCooler(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    484807127: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEvaporator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1209101575: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcExternalSpatialElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    346874300: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFanType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1810631287: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFilterType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4222183408: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFireSuppressionTerminalType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2058353004: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4278956645: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    4037862832: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowInstrumentType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    2188021234: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowMeter(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3132237377: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowMovingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    987401354: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    707683696: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2223149337: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3508470533: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowTreatmentDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    900683007: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFooting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2713699986: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeotechnicalAssembly(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    3009204131: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGrid(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    3319311131: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHeatExchanger(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2068733104: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHumidifier(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4175244083: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInterceptor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2176052936: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcJunctionBox(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2696325953: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcKerb(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    76236018: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    629592764: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLightFixture(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1154579445: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearPositioningElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1638804497: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLiquidTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1437502449: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMedicalDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1073191201: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMember(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2078563270: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMobileTelecommunicationsAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    234836483: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMooringDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2474470126: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMotorConnection(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2182337498: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNavigationElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    144952367: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOuterBoundaryCurve(a[0], a[1]),
    3694346114: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcOutlet(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1383356374: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPavement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1687234759: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPile(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    310824031: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPipeFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3612865200: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPipeSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3171933400: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlate(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    738039164: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProtectiveDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    655969474: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProtectiveDeviceTrippingUnitType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    90941305: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPump(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3290496277: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRail(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2262370178: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRailing(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3024970846: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRamp(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3283111854: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRampFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1232101972: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRationalBSplineCurveWithKnots(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3798194928: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcedSoil(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    979691226: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingBar(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]),
    2572171363: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReinforcingBarType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]),
    2016517767: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRoof(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3053780830: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSanitaryTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1783015770: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSensorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1329646415: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShadingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    991950508: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSignal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1529196076: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSlab(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3420628829: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSolarDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1999602285: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpaceHeater(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1404847402: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStackTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    331165859: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStair(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4252922144: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStairFlight(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    2515109513: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralAnalysisModel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    385403989: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralLoadCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]),
    1621171031: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStructuralPlanarAction(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]),
    1162798199: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSwitchingDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    812556717: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTank(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3425753595: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTrackElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3825984169: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransformer(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1620046519: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTransportElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3026737570: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTubeBundle(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3179687236: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitaryControlElementType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    4292641817: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitaryEquipment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4207607924: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcValve(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2391406946: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWall(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3512223829: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWallStandardCase(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4237592921: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWasteTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3304561284: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWindow(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]),
    2874132201: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActuatorType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    1634111441: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    177149247: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirTerminalBox(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2056796094: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAirToAirHeatRecovery(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3001207471: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlarmType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    325726236: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlignment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    277319702: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAudioVisualAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    753842376: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4196446775: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBearing(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    32344328: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoiler(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3314249567: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBorehole(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1095909175: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBuildingElementProxy(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2938176219: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBurner(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    635142910: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableCarrierFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3758799889: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableCarrierSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1051757585: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4217484030: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCableSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3999819293: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCaissonFoundation(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3902619387: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcChiller(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    639361253: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoil(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3221913625: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCommunicationsAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3571504051: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompressor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2272882330: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCondenser(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    578613899: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcControllerType(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]),
    3460952963: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcConveyorSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4136498852: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCooledBeam(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3640358203: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCoolingTower(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4074379575: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDamper(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3693000487: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionBoard(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1052013943: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionChamberElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    562808652: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionCircuit(a[0], a[1], a[2], a[3], a[4], a[5], a[6]),
    1062813311: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDistributionControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    342316401: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctFitting(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3518393246: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctSegment(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1360408905: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuctSilencer(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1904799276: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricAppliance(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    862014818: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricDistributionBoard(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3310460725: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricFlowStorageDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    24726584: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricFlowTreatmentDevice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    264262732: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricGenerator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    402227799: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricMotor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1003880860: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricTimeControl(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3415622556: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFan(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    819412036: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFilter(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    1426591983: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFireSuppressionTerminal(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    182646315: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFlowInstrument(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    2680139844: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeomodel(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    1971632696: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGeoslice(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]),
    2295281155: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcProtectiveDeviceTrippingUnit(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4086658281: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSensor(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    630975310: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcUnitaryControlElement(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    4288193352: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcActuator(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    3087945054: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAlarm(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]),
    25142252: (a)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcController(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8])
};
$3b8da494b8e92f36$export$4085d3c0722bed8d[3] = {
    3630933823: (i)=>[
            i.Role,
            i.UserDefinedRole,
            i.Description
        ],
    618182010: (i)=>[
            i.Purpose,
            i.Description,
            i.UserDefinedPurpose
        ],
    2879124712: (i)=>[
            i.StartTag,
            i.EndTag
        ],
    3633395639: (i)=>[
            i.StartTag,
            i.EndTag,
            i.StartDistAlong,
            i.HorizontalLength,
            i.StartHeight,
            i.StartGradient,
            i.EndGradient,
            i.RadiusOfCurvature,
            i.PredefinedType
        ],
    639542469: (i)=>[
            i.ApplicationDeveloper,
            i.Version,
            i.ApplicationFullName,
            i.ApplicationIdentifier
        ],
    411424972: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AppliedValue),
            i.UnitBasis,
            i.ApplicableDate,
            i.FixedUntilDate,
            i.Category,
            i.Condition,
            i.ArithmeticOperator,
            i.Components
        ],
    130549933: (i)=>[
            i.Identifier,
            i.Name,
            i.Description,
            i.TimeOfApproval,
            i.Status,
            i.Level,
            i.Qualifier,
            $3b8da494b8e92f36$var$Labelise(i.RequestingApproval),
            $3b8da494b8e92f36$var$Labelise(i.GivingApproval)
        ],
    4037036970: (i)=>[
            i.Name
        ],
    1560379544: (i)=>[
            i.Name,
            (i.TranslationalStiffnessByLengthX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByLengthX),
            (i.TranslationalStiffnessByLengthY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByLengthY),
            (i.TranslationalStiffnessByLengthZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByLengthZ),
            (i.RotationalStiffnessByLengthX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessByLengthX),
            (i.RotationalStiffnessByLengthY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessByLengthY),
            (i.RotationalStiffnessByLengthZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessByLengthZ)
        ],
    3367102660: (i)=>[
            i.Name,
            (i.TranslationalStiffnessByAreaX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByAreaX),
            (i.TranslationalStiffnessByAreaY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByAreaY),
            (i.TranslationalStiffnessByAreaZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessByAreaZ)
        ],
    1387855156: (i)=>[
            i.Name,
            (i.TranslationalStiffnessX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessX),
            (i.TranslationalStiffnessY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessY),
            (i.TranslationalStiffnessZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessZ),
            (i.RotationalStiffnessX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessX),
            (i.RotationalStiffnessY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessY),
            (i.RotationalStiffnessZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessZ)
        ],
    2069777674: (i)=>[
            i.Name,
            (i.TranslationalStiffnessX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessX),
            (i.TranslationalStiffnessY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessY),
            (i.TranslationalStiffnessZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TranslationalStiffnessZ),
            (i.RotationalStiffnessX ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessX),
            (i.RotationalStiffnessY ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessY),
            (i.RotationalStiffnessZ ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.RotationalStiffnessZ),
            (i.WarpingStiffness ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.WarpingStiffness)
        ],
    2859738748: (_)=>[],
    2614616156: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatedElement)
        ],
    2732653382: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SurfaceOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.SurfaceOnRelatedElement)
        ],
    775493141: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.VolumeOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.VolumeOnRelatedElement)
        ],
    1959218052: (i)=>[
            i.Name,
            i.Description,
            i.ConstraintGrade,
            i.ConstraintSource,
            $3b8da494b8e92f36$var$Labelise(i.CreatingActor),
            i.CreationTime,
            i.UserDefinedGrade
        ],
    1785450214: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SourceCRS),
            i.TargetCRS
        ],
    1466758467: (i)=>[
            i.Name,
            i.Description,
            i.GeodeticDatum
        ],
    602808272: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AppliedValue),
            i.UnitBasis,
            i.ApplicableDate,
            i.FixedUntilDate,
            i.Category,
            i.Condition,
            i.ArithmeticOperator,
            i.Components
        ],
    1765591967: (i)=>[
            i.Elements,
            i.UnitType,
            i.UserDefinedType,
            i.Name
        ],
    1045800335: (i)=>[
            i.Unit,
            i.Exponent
        ],
    2949456006: (i)=>[
            i.LengthExponent,
            i.MassExponent,
            i.TimeExponent,
            i.ElectricCurrentExponent,
            i.ThermodynamicTemperatureExponent,
            i.AmountOfSubstanceExponent,
            i.LuminousIntensityExponent
        ],
    4294318154: (_)=>[],
    3200245327: (i)=>[
            i.Location,
            i.Identification,
            i.Name
        ],
    2242383968: (i)=>[
            i.Location,
            i.Identification,
            i.Name
        ],
    1040185647: (i)=>[
            i.Location,
            i.Identification,
            i.Name
        ],
    3548104201: (i)=>[
            i.Location,
            i.Identification,
            i.Name
        ],
    917726184: (i)=>[
            i.Name,
            i.Description,
            i.GeodeticDatum,
            i.PrimeMeridian,
            i.AngleUnit,
            i.HeightUnit
        ],
    852622518: (i)=>[
            i.AxisTag,
            i.AxisCurve,
            {
                type: 3,
                value: i.SameSense.value
            }
        ],
    3020489413: (i)=>[
            i.TimeStamp,
            i.ListValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    2655187982: (i)=>[
            i.Name,
            i.Version,
            $3b8da494b8e92f36$var$Labelise(i.Publisher),
            i.VersionDate,
            i.Location,
            i.Description
        ],
    3452421091: (i)=>[
            i.Location,
            i.Identification,
            i.Name,
            i.Description,
            i.Language,
            i.ReferencedLibrary
        ],
    4162380809: (i)=>[
            i.MainPlaneAngle,
            i.SecondaryPlaneAngle,
            i.LuminousIntensity
        ],
    1566485204: (i)=>[
            i.LightDistributionCurve,
            i.DistributionData
        ],
    3057273783: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SourceCRS),
            i.TargetCRS,
            i.Eastings,
            i.Northings,
            i.OrthogonalHeight,
            i.XAxisAbscissa,
            i.XAxisOrdinate,
            i.Scale
        ],
    4105526436: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SourceCRS),
            i.TargetCRS,
            i.Eastings,
            i.Northings,
            i.OrthogonalHeight,
            i.XAxisAbscissa,
            i.XAxisOrdinate,
            i.Scale,
            i.FactorX,
            i.FactorY,
            i.FactorZ
        ],
    1847130766: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.MaterialClassifications),
            i.ClassifiedMaterial
        ],
    760658860: (_)=>[],
    248100487: (i)=>[
            i.Material,
            i.LayerThickness,
            i.IsVentilated == null ? null : {
                type: 3,
                value: i.IsVentilated.value
            },
            i.Name,
            i.Description,
            i.Category,
            i.Priority
        ],
    3303938423: (i)=>[
            i.MaterialLayers,
            i.LayerSetName,
            i.Description
        ],
    1847252529: (i)=>[
            i.Material,
            i.LayerThickness,
            i.IsVentilated == null ? null : {
                type: 3,
                value: i.IsVentilated.value
            },
            i.Name,
            i.Description,
            i.Category,
            i.Priority,
            i.OffsetDirection,
            i.OffsetValues
        ],
    2199411900: (i)=>[
            i.Materials
        ],
    2235152071: (i)=>[
            i.Name,
            i.Description,
            i.Material,
            i.Profile,
            i.Priority,
            i.Category
        ],
    164193824: (i)=>[
            i.Name,
            i.Description,
            i.MaterialProfiles,
            i.CompositeProfile
        ],
    552965576: (i)=>[
            i.Name,
            i.Description,
            i.Material,
            i.Profile,
            i.Priority,
            i.Category,
            i.OffsetValues
        ],
    1507914824: (_)=>[],
    2597039031: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.ValueComponent),
            $3b8da494b8e92f36$var$Labelise(i.UnitComponent)
        ],
    3368373690: (i)=>[
            i.Name,
            i.Description,
            i.ConstraintGrade,
            i.ConstraintSource,
            $3b8da494b8e92f36$var$Labelise(i.CreatingActor),
            i.CreationTime,
            i.UserDefinedGrade,
            i.Benchmark,
            i.ValueSource,
            $3b8da494b8e92f36$var$Labelise(i.DataValue),
            i.ReferencePath
        ],
    2706619895: (i)=>[
            i.Currency
        ],
    1918398963: (i)=>[
            i.Dimensions,
            i.UnitType
        ],
    3701648758: (i)=>[
            i.PlacementRelTo
        ],
    2251480897: (i)=>[
            i.Name,
            i.Description,
            i.ConstraintGrade,
            i.ConstraintSource,
            $3b8da494b8e92f36$var$Labelise(i.CreatingActor),
            i.CreationTime,
            i.UserDefinedGrade,
            i.BenchmarkValues,
            i.LogicalAggregator,
            i.ObjectiveQualifier,
            i.UserDefinedQualifier
        ],
    4251960020: (i)=>[
            i.Identification,
            i.Name,
            i.Description,
            i.Roles,
            i.Addresses
        ],
    1207048766: (i)=>[
            i.OwningUser,
            i.OwningApplication,
            i.State,
            i.ChangeAction,
            i.LastModifiedDate,
            i.LastModifyingUser,
            i.LastModifyingApplication,
            i.CreationDate
        ],
    2077209135: (i)=>[
            i.Identification,
            i.FamilyName,
            i.GivenName,
            i.MiddleNames,
            i.PrefixTitles,
            i.SuffixTitles,
            i.Roles,
            i.Addresses
        ],
    101040310: (i)=>[
            i.ThePerson,
            i.TheOrganization,
            i.Roles
        ],
    2483315170: (i)=>[
            i.Name,
            i.Description
        ],
    2226359599: (i)=>[
            i.Name,
            i.Description,
            i.Unit
        ],
    3355820592: (i)=>[
            i.Purpose,
            i.Description,
            i.UserDefinedPurpose,
            i.InternalLocation,
            i.AddressLines,
            i.PostalBox,
            i.Town,
            i.Region,
            i.PostalCode,
            i.Country
        ],
    677532197: (_)=>[],
    2022622350: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AssignedItems),
            i.Identifier
        ],
    1304840413: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.AssignedItems),
            i.Identifier,
            {
                type: 3,
                value: i.LayerOn.value
            },
            {
                type: 3,
                value: i.LayerFrozen.value
            },
            {
                type: 3,
                value: i.LayerBlocked.value
            },
            i.LayerStyles
        ],
    3119450353: (i)=>[
            i.Name
        ],
    2095639259: (i)=>[
            i.Name,
            i.Description,
            i.Representations
        ],
    3958567839: (i)=>[
            i.ProfileType,
            i.ProfileName
        ],
    3843373140: (i)=>[
            i.Name,
            i.Description,
            i.GeodeticDatum,
            i.VerticalDatum,
            i.MapProjection,
            i.MapZone,
            i.MapUnit
        ],
    986844984: (_)=>[],
    3710013099: (i)=>[
            i.Name,
            i.EnumerationValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    2044713172: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.AreaValue,
            i.Formula
        ],
    2093928680: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.CountValue,
            i.Formula
        ],
    931644368: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.LengthValue,
            i.Formula
        ],
    2691318326: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.NumberValue,
            i.Formula
        ],
    3252649465: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.TimeValue,
            i.Formula
        ],
    2405470396: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.VolumeValue,
            i.Formula
        ],
    825690147: (i)=>[
            i.Name,
            i.Description,
            i.Unit,
            i.WeightValue,
            i.Formula
        ],
    3915482550: (i)=>[
            i.RecurrenceType,
            i.DayComponent,
            i.WeekdayComponent,
            i.MonthComponent,
            i.Position,
            i.Interval,
            i.Occurrences,
            i.TimePeriods
        ],
    2433181523: (i)=>[
            i.TypeIdentifier,
            i.AttributeIdentifier,
            i.InstanceName,
            i.ListPositions,
            i.InnerReference
        ],
    1076942058: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    3377609919: (i)=>[
            i.ContextIdentifier,
            i.ContextType
        ],
    3008791417: (_)=>[],
    1660063152: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.MappingOrigin),
            i.MappedRepresentation
        ],
    2439245199: (i)=>[
            i.Name,
            i.Description
        ],
    1794013214: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SourceCRS),
            i.TargetCRS,
            $3b8da494b8e92f36$var$Labelise(i.FirstCoordinate),
            $3b8da494b8e92f36$var$Labelise(i.SecondCoordinate),
            i.Height
        ],
    2341007311: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    448429030: (i)=>[
            void 0,
            i.UnitType,
            i.Prefix,
            i.Name
        ],
    1054537805: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin
        ],
    867548509: (i)=>[
            i.ShapeRepresentations,
            i.Name,
            i.Description,
            {
                type: 3,
                value: i.ProductDefinitional.value
            },
            $3b8da494b8e92f36$var$Labelise(i.PartOfProductDefinitionShape)
        ],
    3982875396: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    4240577450: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    2273995522: (i)=>[
            i.Name
        ],
    2162789131: (i)=>[
            i.Name
        ],
    3478079324: (i)=>[
            i.Name,
            i.Values,
            i.Locations
        ],
    609421318: (i)=>[
            i.Name
        ],
    2525727697: (i)=>[
            i.Name
        ],
    3408363356: (i)=>[
            i.Name,
            i.DeltaTConstant,
            i.DeltaTY,
            i.DeltaTZ
        ],
    2830218821: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    3958052878: (i)=>[
            i.Item,
            i.Styles,
            i.Name
        ],
    3049322572: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    2934153892: (i)=>[
            i.Name,
            i.SurfaceReinforcement1,
            i.SurfaceReinforcement2,
            i.ShearReinforcement
        ],
    1300840506: (i)=>[
            i.Name,
            i.Side,
            $3b8da494b8e92f36$var$Labelise(i.Styles)
        ],
    3303107099: (i)=>[
            i.DiffuseTransmissionColour,
            i.DiffuseReflectionColour,
            i.TransmissionColour,
            i.ReflectanceColour
        ],
    1607154358: (i)=>[
            i.RefractionIndex,
            i.DispersionFactor
        ],
    846575682: (i)=>[
            i.SurfaceColour,
            i.Transparency
        ],
    1351298697: (i)=>[
            i.Textures
        ],
    626085974: (i)=>[
            {
                type: 3,
                value: i.RepeatS.value
            },
            {
                type: 3,
                value: i.RepeatT.value
            },
            i.Mode,
            i.TextureTransform,
            i.Parameter
        ],
    985171141: (i)=>[
            i.Name,
            i.Rows,
            i.Columns
        ],
    2043862942: (i)=>[
            i.Identifier,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            i.ReferencePath
        ],
    531007025: (i)=>[
            (i.RowCells ?? void 0) === void 0 ? null : i.RowCells.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.IsHeading == null ? null : {
                type: 3,
                value: i.IsHeading.value
            }
        ],
    1549132990: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.DurationType,
            i.ScheduleDuration,
            i.ScheduleStart,
            i.ScheduleFinish,
            i.EarlyStart,
            i.EarlyFinish,
            i.LateStart,
            i.LateFinish,
            i.FreeFloat,
            i.TotalFloat,
            i.IsCritical == null ? null : {
                type: 3,
                value: i.IsCritical.value
            },
            i.StatusTime,
            i.ActualDuration,
            i.ActualStart,
            i.ActualFinish,
            i.RemainingTime,
            i.Completion
        ],
    2771591690: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.DurationType,
            i.ScheduleDuration,
            i.ScheduleStart,
            i.ScheduleFinish,
            i.EarlyStart,
            i.EarlyFinish,
            i.LateStart,
            i.LateFinish,
            i.FreeFloat,
            i.TotalFloat,
            i.IsCritical == null ? null : {
                type: 3,
                value: i.IsCritical.value
            },
            i.StatusTime,
            i.ActualDuration,
            i.ActualStart,
            i.ActualFinish,
            i.RemainingTime,
            i.Completion,
            i.Recurrence
        ],
    912023232: (i)=>[
            i.Purpose,
            i.Description,
            i.UserDefinedPurpose,
            i.TelephoneNumbers,
            i.FacsimileNumbers,
            i.PagerNumber,
            i.ElectronicMailAddresses,
            i.WWWHomePageURL,
            i.MessagingIDs
        ],
    1447204868: (i)=>[
            i.Name,
            i.TextCharacterAppearance,
            i.TextStyle,
            $3b8da494b8e92f36$var$Labelise(i.TextFontStyle),
            i.ModelOrDraughting == null ? null : {
                type: 3,
                value: i.ModelOrDraughting.value
            }
        ],
    2636378356: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Colour),
            $3b8da494b8e92f36$var$Labelise(i.BackgroundColour)
        ],
    1640371178: (i)=>[
            (i.TextIndent ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.TextIndent),
            i.TextAlign,
            i.TextDecoration,
            (i.LetterSpacing ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LetterSpacing),
            (i.WordSpacing ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.WordSpacing),
            i.TextTransform,
            (i.LineHeight ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LineHeight)
        ],
    280115917: (i)=>[
            i.Maps
        ],
    1742049831: (i)=>[
            i.Maps,
            i.Mode,
            i.Parameter
        ],
    222769930: (i)=>[
            i.TexCoordIndex,
            i.TexCoordsOf
        ],
    1010789467: (i)=>[
            i.TexCoordIndex,
            i.TexCoordsOf,
            i.InnerTexCoordIndices
        ],
    2552916305: (i)=>[
            i.Maps,
            i.Vertices,
            i.MappedTo
        ],
    1210645708: (i)=>[
            i.Coordinates
        ],
    3611470254: (i)=>[
            i.TexCoordsList
        ],
    1199560280: (i)=>[
            i.StartTime,
            i.EndTime
        ],
    3101149627: (i)=>[
            i.Name,
            i.Description,
            i.StartTime,
            i.EndTime,
            i.TimeSeriesDataType,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    581633288: (i)=>[
            i.ListValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    1377556343: (_)=>[],
    1735638870: (i)=>[
            i.ContextOfItems,
            i.RepresentationIdentifier,
            i.RepresentationType,
            i.Items
        ],
    180925521: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Units)
        ],
    2799835756: (_)=>[],
    1907098498: (i)=>[
            i.VertexGeometry
        ],
    891718957: (i)=>[
            i.IntersectingAxes,
            i.OffsetDistances
        ],
    1175146630: (i)=>[
            i.WellKnownText,
            i.CoordinateReferenceSystem
        ],
    1236880293: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.RecurrencePattern,
            i.StartDate,
            i.FinishDate
        ],
    3752311538: (i)=>[
            i.StartTag,
            i.EndTag,
            i.StartDistAlong,
            i.HorizontalLength,
            i.StartCantLeft,
            i.EndCantLeft,
            i.StartCantRight,
            i.EndCantRight,
            i.PredefinedType
        ],
    536804194: (i)=>[
            i.StartTag,
            i.EndTag,
            i.StartPoint,
            i.StartDirection,
            i.StartRadiusOfCurvature,
            i.EndRadiusOfCurvature,
            i.SegmentLength,
            i.GravityCenterLineHeight,
            i.PredefinedType
        ],
    3869604511: (i)=>[
            i.Name,
            i.Description,
            i.RelatingApproval,
            i.RelatedApprovals
        ],
    3798115385: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.OuterCurve
        ],
    1310608509: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Curve
        ],
    2705031697: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.OuterCurve,
            i.InnerCurves
        ],
    616511568: (i)=>[
            {
                type: 3,
                value: i.RepeatS.value
            },
            {
                type: 3,
                value: i.RepeatT.value
            },
            i.Mode,
            i.TextureTransform,
            i.Parameter,
            i.RasterFormat,
            i.RasterCode
        ],
    3150382593: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Curve,
            i.Thickness
        ],
    747523909: (i)=>[
            i.Source,
            i.Edition,
            i.EditionDate,
            i.Name,
            i.Description,
            i.Specification,
            i.ReferenceTokens
        ],
    647927063: (i)=>[
            i.Location,
            i.Identification,
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.ReferencedSource),
            i.Description,
            i.Sort
        ],
    3285139300: (i)=>[
            i.ColourList
        ],
    3264961684: (i)=>[
            i.Name
        ],
    1485152156: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Profiles,
            i.Label
        ],
    370225590: (i)=>[
            i.CfsFaces
        ],
    1981873012: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.CurveOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.CurveOnRelatedElement)
        ],
    45288368: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.PointOnRelatedElement),
            i.EccentricityInX,
            i.EccentricityInY,
            i.EccentricityInZ
        ],
    3050246964: (i)=>[
            i.Dimensions,
            i.UnitType,
            i.Name
        ],
    2889183280: (i)=>[
            i.Dimensions,
            i.UnitType,
            i.Name,
            i.ConversionFactor
        ],
    2713554722: (i)=>[
            i.Dimensions,
            i.UnitType,
            i.Name,
            i.ConversionFactor,
            i.ConversionOffset
        ],
    539742890: (i)=>[
            i.Name,
            i.Description,
            i.RelatingMonetaryUnit,
            i.RelatedMonetaryUnit,
            i.ExchangeRate,
            i.RateDateTime,
            i.RateSource
        ],
    3800577675: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.CurveFont),
            (i.CurveWidth ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.CurveWidth),
            $3b8da494b8e92f36$var$Labelise(i.CurveColour),
            i.ModelOrDraughting == null ? null : {
                type: 3,
                value: i.ModelOrDraughting.value
            }
        ],
    1105321065: (i)=>[
            i.Name,
            i.PatternList
        ],
    2367409068: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.CurveStyleFont),
            i.CurveFontScaling
        ],
    3510044353: (i)=>[
            i.VisibleSegmentLength,
            i.InvisibleSegmentLength
        ],
    3632507154: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.ParentProfile,
            i.Operator,
            i.Label
        ],
    1154170062: (i)=>[
            i.Identification,
            i.Name,
            i.Description,
            i.Location,
            i.Purpose,
            i.IntendedUse,
            i.Scope,
            i.Revision,
            $3b8da494b8e92f36$var$Labelise(i.DocumentOwner),
            $3b8da494b8e92f36$var$Labelise(i.Editors),
            i.CreationTime,
            i.LastRevisionTime,
            i.ElectronicFormat,
            i.ValidFrom,
            i.ValidUntil,
            i.Confidentiality,
            i.Status
        ],
    770865208: (i)=>[
            i.Name,
            i.Description,
            i.RelatingDocument,
            i.RelatedDocuments,
            i.RelationshipType
        ],
    3732053477: (i)=>[
            i.Location,
            i.Identification,
            i.Name,
            i.Description,
            i.ReferencedDocument
        ],
    3900360178: (i)=>[
            i.EdgeStart,
            i.EdgeEnd
        ],
    476780140: (i)=>[
            i.EdgeStart,
            i.EdgeEnd,
            i.EdgeGeometry,
            {
                type: 3,
                value: i.SameSense.value
            }
        ],
    211053100: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.ActualDate,
            i.EarlyDate,
            i.LateDate,
            i.ScheduleDate
        ],
    297599258: (i)=>[
            i.Name,
            i.Description,
            i.Properties
        ],
    1437805879: (i)=>[
            i.Name,
            i.Description,
            i.RelatingReference,
            $3b8da494b8e92f36$var$Labelise(i.RelatedResourceObjects)
        ],
    2556980723: (i)=>[
            i.Bounds
        ],
    1809719519: (i)=>[
            i.Bound,
            {
                type: 3,
                value: i.Orientation.value
            }
        ],
    803316827: (i)=>[
            i.Bound,
            {
                type: 3,
                value: i.Orientation.value
            }
        ],
    3008276851: (i)=>[
            i.Bounds,
            i.FaceSurface,
            {
                type: 3,
                value: i.SameSense.value
            }
        ],
    4219587988: (i)=>[
            i.Name,
            i.TensionFailureX,
            i.TensionFailureY,
            i.TensionFailureZ,
            i.CompressionFailureX,
            i.CompressionFailureY,
            i.CompressionFailureZ
        ],
    738692330: (i)=>[
            i.Name,
            $3b8da494b8e92f36$var$Labelise(i.FillStyles),
            i.ModelOrDraughting == null ? null : {
                type: 3,
                value: i.ModelOrDraughting.value
            }
        ],
    3448662350: (i)=>[
            i.ContextIdentifier,
            i.ContextType,
            i.CoordinateSpaceDimension,
            i.Precision,
            $3b8da494b8e92f36$var$Labelise(i.WorldCoordinateSystem),
            i.TrueNorth
        ],
    2453401579: (_)=>[],
    4142052618: (i)=>[
            i.ContextIdentifier,
            i.ContextType,
            void 0,
            void 0,
            void 0,
            void 0,
            i.ParentContext,
            i.TargetScale,
            i.TargetView,
            i.UserDefinedTargetView
        ],
    3590301190: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Elements)
        ],
    178086475: (i)=>[
            i.PlacementRelTo,
            i.PlacementLocation,
            $3b8da494b8e92f36$var$Labelise(i.PlacementRefDirection)
        ],
    812098782: (i)=>[
            i.BaseSurface,
            {
                type: 3,
                value: i.AgreementFlag.value
            }
        ],
    3905492369: (i)=>[
            {
                type: 3,
                value: i.RepeatS.value
            },
            {
                type: 3,
                value: i.RepeatT.value
            },
            i.Mode,
            i.TextureTransform,
            i.Parameter,
            i.URLReference
        ],
    3570813810: (i)=>[
            i.MappedTo,
            i.Opacity,
            i.Colours,
            i.ColourIndex
        ],
    1437953363: (i)=>[
            i.Maps,
            i.MappedTo,
            i.TexCoords
        ],
    2133299955: (i)=>[
            i.Maps,
            i.MappedTo,
            i.TexCoords,
            i.TexCoordIndex
        ],
    3741457305: (i)=>[
            i.Name,
            i.Description,
            i.StartTime,
            i.EndTime,
            i.TimeSeriesDataType,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            i.Values
        ],
    1585845231: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.LagValue),
            i.DurationType
        ],
    1402838566: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity
        ],
    125510826: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity
        ],
    2604431987: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Orientation
        ],
    4266656042: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Position,
            i.ColourAppearance,
            i.ColourTemperature,
            i.LuminousFlux,
            i.LightEmissionSource,
            $3b8da494b8e92f36$var$Labelise(i.LightDistributionDataSource)
        ],
    1520743889: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Position,
            i.Radius,
            i.ConstantAttenuation,
            i.DistanceAttenuation,
            i.QuadricAttenuation
        ],
    3422422726: (i)=>[
            i.Name,
            i.LightColour,
            i.AmbientIntensity,
            i.Intensity,
            i.Position,
            i.Radius,
            i.ConstantAttenuation,
            i.DistanceAttenuation,
            i.QuadricAttenuation,
            i.Orientation,
            i.ConcentrationExponent,
            i.SpreadAngle,
            i.BeamWidthAngle
        ],
    388784114: (i)=>[
            i.PlacementRelTo,
            i.RelativePlacement,
            i.CartesianPosition
        ],
    2624227202: (i)=>[
            i.PlacementRelTo,
            $3b8da494b8e92f36$var$Labelise(i.RelativePlacement)
        ],
    1008929658: (_)=>[],
    2347385850: (i)=>[
            i.MappingSource,
            i.MappingTarget
        ],
    1838606355: (i)=>[
            i.Name,
            i.Description,
            i.Category
        ],
    3708119e3: (i)=>[
            i.Name,
            i.Description,
            i.Material,
            i.Fraction,
            i.Category
        ],
    2852063980: (i)=>[
            i.Name,
            i.Description,
            i.MaterialConstituents
        ],
    2022407955: (i)=>[
            i.Name,
            i.Description,
            i.Representations,
            i.RepresentedMaterial
        ],
    1303795690: (i)=>[
            i.ForLayerSet,
            i.LayerSetDirection,
            i.DirectionSense,
            i.OffsetFromReferenceLine,
            i.ReferenceExtent
        ],
    3079605661: (i)=>[
            i.ForProfileSet,
            i.CardinalPoint,
            i.ReferenceExtent
        ],
    3404854881: (i)=>[
            i.ForProfileSet,
            i.CardinalPoint,
            i.ReferenceExtent,
            i.ForProfileEndSet,
            i.CardinalEndPoint
        ],
    3265635763: (i)=>[
            i.Name,
            i.Description,
            i.Properties,
            i.Material
        ],
    853536259: (i)=>[
            i.Name,
            i.Description,
            i.RelatingMaterial,
            i.RelatedMaterials,
            i.MaterialExpression
        ],
    2998442950: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.ParentProfile,
            void 0,
            i.Label
        ],
    219451334: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    182550632: (i)=>[
            i.ProfileType,
            i.ProfileName,
            {
                type: 3,
                value: i.HorizontalWidths.value
            },
            i.Widths,
            i.Slopes,
            i.Tags,
            i.OffsetPoint
        ],
    2665983363: (i)=>[
            i.CfsFaces
        ],
    1411181986: (i)=>[
            i.Name,
            i.Description,
            i.RelatingOrganization,
            i.RelatedOrganizations
        ],
    1029017970: (i)=>[
            void 0,
            void 0,
            i.EdgeElement,
            {
                type: 3,
                value: i.Orientation.value
            }
        ],
    2529465313: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position
        ],
    2519244187: (i)=>[
            i.EdgeList
        ],
    3021840470: (i)=>[
            i.Name,
            i.Description,
            i.HasQuantities,
            i.Discrimination,
            i.Quality,
            i.Usage
        ],
    597895409: (i)=>[
            {
                type: 3,
                value: i.RepeatS.value
            },
            {
                type: 3,
                value: i.RepeatT.value
            },
            i.Mode,
            i.TextureTransform,
            i.Parameter,
            i.Width,
            i.Height,
            i.ColourComponents,
            i.Pixel
        ],
    2004835150: (i)=>[
            i.Location
        ],
    1663979128: (i)=>[
            i.SizeInX,
            i.SizeInY
        ],
    2067069095: (_)=>[],
    2165702409: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.DistanceAlong),
            i.OffsetLateral,
            i.OffsetVertical,
            i.OffsetLongitudinal,
            i.BasisCurve
        ],
    4022376103: (i)=>[
            i.BasisCurve,
            i.PointParameter
        ],
    1423911732: (i)=>[
            i.BasisSurface,
            i.PointParameterU,
            i.PointParameterV
        ],
    2924175390: (i)=>[
            i.Polygon
        ],
    2775532180: (i)=>[
            i.BaseSurface,
            {
                type: 3,
                value: i.AgreementFlag.value
            },
            i.Position,
            i.PolygonalBoundary
        ],
    3727388367: (i)=>[
            i.Name
        ],
    3778827333: (_)=>[],
    1775413392: (i)=>[
            i.Name
        ],
    673634403: (i)=>[
            i.Name,
            i.Description,
            i.Representations
        ],
    2802850158: (i)=>[
            i.Name,
            i.Description,
            i.Properties,
            i.ProfileDefinition
        ],
    2598011224: (i)=>[
            i.Name,
            i.Specification
        ],
    1680319473: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    148025276: (i)=>[
            i.Name,
            i.Description,
            i.DependingProperty,
            i.DependantProperty,
            i.Expression
        ],
    3357820518: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    1482703590: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    2090586900: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    3615266464: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.XDim,
            i.YDim
        ],
    3413951693: (i)=>[
            i.Name,
            i.Description,
            i.StartTime,
            i.EndTime,
            i.TimeSeriesDataType,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            i.TimeStep,
            i.Values
        ],
    1580146022: (i)=>[
            i.TotalCrossSectionArea,
            i.SteelGrade,
            i.BarSurface,
            i.EffectiveDepth,
            i.NominalBarDiameter,
            i.BarCount
        ],
    478536968: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    2943643501: (i)=>[
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedResourceObjects),
            i.RelatingApproval
        ],
    1608871552: (i)=>[
            i.Name,
            i.Description,
            i.RelatingConstraint,
            $3b8da494b8e92f36$var$Labelise(i.RelatedResourceObjects)
        ],
    1042787934: (i)=>[
            i.Name,
            i.DataOrigin,
            i.UserDefinedDataOrigin,
            i.ScheduleWork,
            i.ScheduleUsage,
            i.ScheduleStart,
            i.ScheduleFinish,
            i.ScheduleContour,
            i.LevelingDelay,
            i.IsOverAllocated == null ? null : {
                type: 3,
                value: i.IsOverAllocated.value
            },
            i.StatusTime,
            i.ActualWork,
            i.ActualUsage,
            i.ActualStart,
            i.ActualFinish,
            i.RemainingWork,
            i.RemainingUsage,
            i.Completion
        ],
    2778083089: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.XDim,
            i.YDim,
            i.RoundingRadius
        ],
    2042790032: (i)=>[
            i.SectionType,
            i.StartProfile,
            i.EndProfile
        ],
    4165799628: (i)=>[
            i.LongitudinalStartPosition,
            i.LongitudinalEndPosition,
            i.TransversePosition,
            i.ReinforcementRole,
            i.SectionDefinition,
            i.CrossSectionReinforcementDefinitions
        ],
    1509187699: (i)=>[
            i.SpineCurve,
            i.CrossSections,
            i.CrossSectionPositions
        ],
    823603102: (i)=>[
            i.Transition
        ],
    4124623270: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.SbsmBoundary)
        ],
    3692461612: (i)=>[
            i.Name,
            i.Specification
        ],
    2609359061: (i)=>[
            i.Name,
            i.SlippageX,
            i.SlippageY,
            i.SlippageZ
        ],
    723233188: (_)=>[],
    1595516126: (i)=>[
            i.Name,
            i.LinearForceX,
            i.LinearForceY,
            i.LinearForceZ,
            i.LinearMomentX,
            i.LinearMomentY,
            i.LinearMomentZ
        ],
    2668620305: (i)=>[
            i.Name,
            i.PlanarForceX,
            i.PlanarForceY,
            i.PlanarForceZ
        ],
    2473145415: (i)=>[
            i.Name,
            i.DisplacementX,
            i.DisplacementY,
            i.DisplacementZ,
            i.RotationalDisplacementRX,
            i.RotationalDisplacementRY,
            i.RotationalDisplacementRZ
        ],
    1973038258: (i)=>[
            i.Name,
            i.DisplacementX,
            i.DisplacementY,
            i.DisplacementZ,
            i.RotationalDisplacementRX,
            i.RotationalDisplacementRY,
            i.RotationalDisplacementRZ,
            i.Distortion
        ],
    1597423693: (i)=>[
            i.Name,
            i.ForceX,
            i.ForceY,
            i.ForceZ,
            i.MomentX,
            i.MomentY,
            i.MomentZ
        ],
    1190533807: (i)=>[
            i.Name,
            i.ForceX,
            i.ForceY,
            i.ForceZ,
            i.MomentX,
            i.MomentY,
            i.MomentZ,
            i.WarpingMoment
        ],
    2233826070: (i)=>[
            i.EdgeStart,
            i.EdgeEnd,
            i.ParentEdge
        ],
    2513912981: (_)=>[],
    1878645084: (i)=>[
            i.SurfaceColour,
            i.Transparency,
            $3b8da494b8e92f36$var$Labelise(i.DiffuseColour),
            $3b8da494b8e92f36$var$Labelise(i.TransmissionColour),
            $3b8da494b8e92f36$var$Labelise(i.DiffuseTransmissionColour),
            $3b8da494b8e92f36$var$Labelise(i.ReflectionColour),
            $3b8da494b8e92f36$var$Labelise(i.SpecularColour),
            (i.SpecularHighlight ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.SpecularHighlight),
            i.ReflectanceMethod
        ],
    2247615214: (i)=>[
            i.SweptArea,
            i.Position
        ],
    1260650574: (i)=>[
            i.Directrix,
            i.Radius,
            i.InnerRadius,
            i.StartParam,
            i.EndParam
        ],
    1096409881: (i)=>[
            i.Directrix,
            i.Radius,
            i.InnerRadius,
            i.StartParam,
            i.EndParam,
            i.FilletRadius
        ],
    230924584: (i)=>[
            i.SweptCurve,
            i.Position
        ],
    3071757647: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.FlangeWidth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.FlangeEdgeRadius,
            i.WebEdgeRadius,
            i.WebSlope,
            i.FlangeSlope
        ],
    901063453: (_)=>[],
    4282788508: (i)=>[
            i.Literal,
            $3b8da494b8e92f36$var$Labelise(i.Placement),
            i.Path
        ],
    3124975700: (i)=>[
            i.Literal,
            $3b8da494b8e92f36$var$Labelise(i.Placement),
            i.Path,
            i.Extent,
            i.BoxAlignment
        ],
    1983826977: (i)=>[
            i.Name,
            i.FontFamily,
            i.FontStyle,
            i.FontVariant,
            i.FontWeight,
            $3b8da494b8e92f36$var$Labelise(i.FontSize)
        ],
    2715220739: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.BottomXDim,
            i.TopXDim,
            i.YDim,
            i.TopXOffset
        ],
    1628702193: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets
        ],
    3736923433: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ProcessType
        ],
    2347495698: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag
        ],
    3698973494: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType
        ],
    427810014: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.FlangeWidth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.EdgeRadius,
            i.FlangeSlope
        ],
    1417489154: (i)=>[
            i.Orientation,
            i.Magnitude
        ],
    2759199220: (i)=>[
            i.LoopVertex
        ],
    2543172580: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.FlangeWidth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.EdgeRadius
        ],
    3406155212: (i)=>[
            i.Bounds,
            i.FaceSurface,
            {
                type: 3,
                value: i.SameSense.value
            }
        ],
    669184980: (i)=>[
            i.OuterBoundary,
            i.InnerBoundaries
        ],
    3207858831: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.BottomFlangeWidth,
            i.OverallDepth,
            i.WebThickness,
            i.BottomFlangeThickness,
            i.BottomFlangeFilletRadius,
            i.TopFlangeWidth,
            i.TopFlangeThickness,
            i.TopFlangeFilletRadius,
            i.BottomFlangeEdgeRadius,
            i.BottomFlangeSlope,
            i.TopFlangeEdgeRadius,
            i.TopFlangeSlope
        ],
    4261334040: (i)=>[
            i.Location,
            i.Axis
        ],
    3125803723: (i)=>[
            i.Location,
            i.RefDirection
        ],
    2740243338: (i)=>[
            i.Location,
            i.Axis,
            i.RefDirection
        ],
    3425423356: (i)=>[
            i.Location,
            i.Axis,
            i.RefDirection
        ],
    2736907675: (i)=>[
            i.Operator,
            $3b8da494b8e92f36$var$Labelise(i.FirstOperand),
            $3b8da494b8e92f36$var$Labelise(i.SecondOperand)
        ],
    4182860854: (_)=>[],
    2581212453: (i)=>[
            i.Corner,
            i.XDim,
            i.YDim,
            i.ZDim
        ],
    2713105998: (i)=>[
            i.BaseSurface,
            {
                type: 3,
                value: i.AgreementFlag.value
            },
            i.Enclosure
        ],
    2898889636: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.Width,
            i.WallThickness,
            i.Girth,
            i.InternalFilletRadius
        ],
    1123145078: (i)=>[
            i.Coordinates
        ],
    574549367: (_)=>[],
    1675464909: (i)=>[
            i.CoordList,
            i.TagList
        ],
    2059837836: (i)=>[
            i.CoordList,
            i.TagList
        ],
    59481748: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale
        ],
    3749851601: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale
        ],
    3486308946: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale,
            i.Scale2
        ],
    3331915920: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale,
            i.Axis3
        ],
    1416205885: (i)=>[
            i.Axis1,
            i.Axis2,
            i.LocalOrigin,
            i.Scale,
            i.Axis3,
            i.Scale2,
            i.Scale3
        ],
    1383045692: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Radius
        ],
    2205249479: (i)=>[
            i.CfsFaces
        ],
    776857604: (i)=>[
            i.Name,
            i.Red,
            i.Green,
            i.Blue
        ],
    2542286263: (i)=>[
            i.Name,
            i.Specification,
            i.UsageName,
            i.HasProperties
        ],
    2485617015: (i)=>[
            i.Transition,
            {
                type: 3,
                value: i.SameSense.value
            },
            i.ParentCurve
        ],
    2574617495: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity
        ],
    3419103109: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.Phase,
            i.RepresentationContexts,
            i.UnitsInContext
        ],
    1815067380: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    2506170314: (i)=>[
            i.Position
        ],
    2147822146: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.TreeRootExpression)
        ],
    2601014836: (_)=>[],
    2827736869: (i)=>[
            i.BasisSurface,
            i.OuterBoundary,
            i.InnerBoundaries
        ],
    2629017746: (i)=>[
            i.BasisSurface,
            i.Boundaries,
            {
                type: 3,
                value: i.ImplicitOuter.value
            }
        ],
    4212018352: (i)=>[
            i.Transition,
            i.Placement,
            $3b8da494b8e92f36$var$Labelise(i.SegmentStart),
            $3b8da494b8e92f36$var$Labelise(i.SegmentLength),
            i.ParentCurve
        ],
    32440307: (i)=>[
            i.DirectionRatios
        ],
    593015953: (i)=>[
            i.SweptArea,
            i.Position,
            i.Directrix,
            (i.StartParam ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.StartParam),
            (i.EndParam ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.EndParam)
        ],
    1472233963: (i)=>[
            i.EdgeList
        ],
    1883228015: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.MethodOfMeasurement,
            i.Quantities
        ],
    339256511: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2777663545: (i)=>[
            i.Position
        ],
    2835456948: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.SemiAxis1,
            i.SemiAxis2
        ],
    4024345920: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ProcessType,
            i.PredefinedType,
            i.EventTriggerType,
            i.UserDefinedEventTriggerType
        ],
    477187591: (i)=>[
            i.SweptArea,
            i.Position,
            i.ExtrudedDirection,
            i.Depth
        ],
    2804161546: (i)=>[
            i.SweptArea,
            i.Position,
            i.ExtrudedDirection,
            i.Depth,
            i.EndSweptArea
        ],
    2047409740: (i)=>[
            i.FbsmFaces
        ],
    374418227: (i)=>[
            i.HatchLineAppearance,
            $3b8da494b8e92f36$var$Labelise(i.StartOfNextHatchLine),
            i.PointOfReferenceHatchLine,
            i.PatternStart,
            i.HatchLineAngle
        ],
    315944413: (i)=>[
            i.TilingPattern,
            i.Tiles,
            i.TilingScale
        ],
    2652556860: (i)=>[
            i.SweptArea,
            i.Position,
            i.Directrix,
            (i.StartParam ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.StartParam),
            (i.EndParam ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.EndParam),
            i.FixedReference
        ],
    4238390223: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1268542332: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.AssemblyPlace,
            i.PredefinedType
        ],
    4095422895: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    987898635: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Elements)
        ],
    1484403080: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.OverallWidth,
            i.OverallDepth,
            i.WebThickness,
            i.FlangeThickness,
            i.FilletRadius,
            i.FlangeEdgeRadius,
            i.FlangeSlope
        ],
    178912537: (i)=>[
            i.CoordIndex
        ],
    2294589976: (i)=>[
            i.CoordIndex,
            i.InnerCoordIndices
        ],
    3465909080: (i)=>[
            i.Maps,
            i.MappedTo,
            i.TexCoords,
            i.TexCoordIndices
        ],
    572779678: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Depth,
            i.Width,
            i.Thickness,
            i.FilletRadius,
            i.EdgeRadius,
            i.LegSlope
        ],
    428585644: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1281925730: (i)=>[
            i.Pnt,
            i.Dir
        ],
    1425443689: (i)=>[
            i.Outer
        ],
    3888040117: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    590820931: (i)=>[
            i.BasisCurve
        ],
    3388369263: (i)=>[
            i.BasisCurve,
            i.Distance,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    3505215534: (i)=>[
            i.BasisCurve,
            i.Distance,
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.RefDirection
        ],
    2485787929: (i)=>[
            i.BasisCurve,
            i.OffsetValues,
            i.Tag
        ],
    1682466193: (i)=>[
            i.BasisSurface,
            i.ReferenceCurve
        ],
    603570806: (i)=>[
            i.SizeInX,
            i.SizeInY,
            $3b8da494b8e92f36$var$Labelise(i.Placement)
        ],
    220341763: (i)=>[
            i.Position
        ],
    3381221214: (i)=>[
            i.Position,
            i.CoefficientsX,
            i.CoefficientsY,
            i.CoefficientsZ
        ],
    759155922: (i)=>[
            i.Name
        ],
    2559016684: (i)=>[
            i.Name
        ],
    3967405729: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    569719735: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ProcessType,
            i.PredefinedType
        ],
    2945172077: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription
        ],
    4208778838: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    103090709: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.Phase,
            i.RepresentationContexts,
            i.UnitsInContext
        ],
    653396225: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.Phase,
            i.RepresentationContexts,
            i.UnitsInContext
        ],
    871118103: (i)=>[
            i.Name,
            i.Specification,
            (i.UpperBoundValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.UpperBoundValue),
            (i.LowerBoundValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.LowerBoundValue),
            $3b8da494b8e92f36$var$Labelise(i.Unit),
            (i.SetPointValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.SetPointValue)
        ],
    4166981789: (i)=>[
            i.Name,
            i.Specification,
            (i.EnumerationValues ?? void 0) === void 0 ? null : i.EnumerationValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.EnumerationReference
        ],
    2752243245: (i)=>[
            i.Name,
            i.Specification,
            (i.ListValues ?? void 0) === void 0 ? null : i.ListValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    941946838: (i)=>[
            i.Name,
            i.Specification,
            i.UsageName,
            $3b8da494b8e92f36$var$Labelise(i.PropertyReference)
        ],
    1451395588: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.HasProperties
        ],
    492091185: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.TemplateType,
            i.ApplicableEntity,
            i.HasPropertyTemplates
        ],
    3650150729: (i)=>[
            i.Name,
            i.Specification,
            (i.NominalValue ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.NominalValue),
            $3b8da494b8e92f36$var$Labelise(i.Unit)
        ],
    110355661: (i)=>[
            i.Name,
            i.Specification,
            (i.DefiningValues ?? void 0) === void 0 ? null : i.DefiningValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            (i.DefinedValues ?? void 0) === void 0 ? null : i.DefinedValues.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.Expression,
            $3b8da494b8e92f36$var$Labelise(i.DefiningUnit),
            $3b8da494b8e92f36$var$Labelise(i.DefinedUnit),
            i.CurveInterpolation
        ],
    3521284610: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    2770003689: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.XDim,
            i.YDim,
            i.WallThickness,
            i.InnerFilletRadius,
            i.OuterFilletRadius
        ],
    2798486643: (i)=>[
            i.Position,
            i.XLength,
            i.YLength,
            i.Height
        ],
    3454111270: (i)=>[
            i.BasisSurface,
            i.U1,
            i.V1,
            i.U2,
            i.V2,
            {
                type: 3,
                value: i.Usense.value
            },
            {
                type: 3,
                value: i.Vsense.value
            }
        ],
    3765753017: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.DefinitionType,
            i.ReinforcementSectionDefinitions
        ],
    3939117080: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType == null ? null : {
                type: 3,
                value: i.RelatedObjectsType.value
            }
        ],
    1683148259: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType == null ? null : {
                type: 3,
                value: i.RelatedObjectsType.value
            },
            i.RelatingActor,
            i.ActingRole
        ],
    2495723537: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType == null ? null : {
                type: 3,
                value: i.RelatedObjectsType.value
            },
            i.RelatingControl
        ],
    1307041759: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType == null ? null : {
                type: 3,
                value: i.RelatedObjectsType.value
            },
            i.RelatingGroup
        ],
    1027710054: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType == null ? null : {
                type: 3,
                value: i.RelatedObjectsType.value
            },
            i.RelatingGroup,
            i.Factor
        ],
    4278684876: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType == null ? null : {
                type: 3,
                value: i.RelatedObjectsType.value
            },
            $3b8da494b8e92f36$var$Labelise(i.RelatingProcess),
            i.QuantityInProcess
        ],
    2857406711: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType == null ? null : {
                type: 3,
                value: i.RelatedObjectsType.value
            },
            $3b8da494b8e92f36$var$Labelise(i.RelatingProduct)
        ],
    205026976: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatedObjectsType == null ? null : {
                type: 3,
                value: i.RelatedObjectsType.value
            },
            $3b8da494b8e92f36$var$Labelise(i.RelatingResource)
        ],
    1865459582: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects)
        ],
    4095574036: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            i.RelatingApproval
        ],
    919958153: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            $3b8da494b8e92f36$var$Labelise(i.RelatingClassification)
        ],
    2728634034: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            i.Intent,
            i.RelatingConstraint
        ],
    982818633: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            $3b8da494b8e92f36$var$Labelise(i.RelatingDocument)
        ],
    3840914261: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            $3b8da494b8e92f36$var$Labelise(i.RelatingLibrary)
        ],
    2655215786: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            $3b8da494b8e92f36$var$Labelise(i.RelatingMaterial)
        ],
    1033248425: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedObjects),
            i.RelatingProfileDef
        ],
    826625072: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    1204542856: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ConnectionGeometry,
            i.RelatingElement,
            i.RelatedElement
        ],
    3945020480: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ConnectionGeometry,
            i.RelatingElement,
            i.RelatedElement,
            i.RelatingPriorities,
            i.RelatedPriorities,
            i.RelatedConnectionType,
            i.RelatingConnectionType
        ],
    4201705270: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingPort,
            i.RelatedElement
        ],
    3190031847: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingPort,
            i.RelatedPort,
            i.RealizingElement
        ],
    2127690289: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingElement),
            i.RelatedStructuralActivity
        ],
    1638771189: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingStructuralMember,
            i.RelatedStructuralConnection,
            i.AppliedCondition,
            i.AdditionalConditions,
            i.SupportedLength,
            i.ConditionCoordinateSystem
        ],
    504942748: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingStructuralMember,
            i.RelatedStructuralConnection,
            i.AppliedCondition,
            i.AdditionalConditions,
            i.SupportedLength,
            i.ConditionCoordinateSystem,
            i.ConnectionConstraint
        ],
    3678494232: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ConnectionGeometry,
            i.RelatingElement,
            i.RelatedElement,
            i.RealizingElements,
            i.ConnectionType
        ],
    3242617779: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedElements,
            i.RelatingStructure
        ],
    886880790: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingBuildingElement,
            i.RelatedCoverings
        ],
    2802773753: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingSpace,
            i.RelatedCoverings
        ],
    2565941209: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingContext,
            $3b8da494b8e92f36$var$Labelise(i.RelatedDefinitions)
        ],
    2551354335: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    693640335: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description
        ],
    1462361463: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingObject
        ],
    4186316022: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            $3b8da494b8e92f36$var$Labelise(i.RelatingPropertyDefinition)
        ],
    307848117: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedPropertySets,
            i.RelatingTemplate
        ],
    781010003: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedObjects,
            i.RelatingType
        ],
    3940055652: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingOpeningElement,
            i.RelatedBuildingElement
        ],
    279856033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatedControlElements,
            i.RelatingFlowElement
        ],
    427948657: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingElement),
            $3b8da494b8e92f36$var$Labelise(i.RelatedElement),
            i.InterferenceGeometry,
            i.InterferenceType,
            {
                type: 3,
                value: i.ImpliedOrder.value
            },
            i.InterferenceSpace
        ],
    3268803585: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingObject,
            i.RelatedObjects
        ],
    1441486842: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingPositioningElement,
            i.RelatedProducts
        ],
    750771296: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingElement,
            i.RelatedFeatureElement
        ],
    1245217292: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatedElements),
            i.RelatingStructure
        ],
    4122056220: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingProcess,
            i.RelatedProcess,
            i.TimeLag,
            i.SequenceType,
            i.UserDefinedSequenceType
        ],
    366585022: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingSystem,
            i.RelatedBuildings
        ],
    3451746338: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingSpace),
            i.RelatedBuildingElement,
            i.ConnectionGeometry,
            i.PhysicalOrVirtualBoundary,
            i.InternalOrExternalBoundary
        ],
    3523091289: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingSpace),
            i.RelatedBuildingElement,
            i.ConnectionGeometry,
            i.PhysicalOrVirtualBoundary,
            i.InternalOrExternalBoundary,
            i.ParentBoundary
        ],
    1521410863: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            $3b8da494b8e92f36$var$Labelise(i.RelatingSpace),
            i.RelatedBuildingElement,
            i.ConnectionGeometry,
            i.PhysicalOrVirtualBoundary,
            i.InternalOrExternalBoundary,
            i.ParentBoundary,
            i.CorrespondingBoundary
        ],
    1401173127: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingBuildingElement,
            i.RelatedOpeningElement
        ],
    816062949: (i)=>[
            i.Transition,
            {
                type: 3,
                value: i.SameSense.value
            },
            i.ParentCurve,
            i.ParamLength
        ],
    2914609552: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription
        ],
    1856042241: (i)=>[
            i.SweptArea,
            i.Position,
            i.Axis,
            i.Angle
        ],
    3243963512: (i)=>[
            i.SweptArea,
            i.Position,
            i.Axis,
            i.Angle,
            i.EndSweptArea
        ],
    4158566097: (i)=>[
            i.Position,
            i.Height,
            i.BottomRadius
        ],
    3626867408: (i)=>[
            i.Position,
            i.Height,
            i.Radius
        ],
    1862484736: (i)=>[
            i.Directrix,
            i.CrossSections
        ],
    1290935644: (i)=>[
            i.Directrix,
            i.CrossSections,
            i.CrossSectionPositions
        ],
    1356537516: (i)=>[
            i.Directrix,
            i.CrossSectionPositions,
            i.CrossSections
        ],
    3663146110: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.TemplateType,
            i.PrimaryMeasureType,
            i.SecondaryMeasureType,
            i.Enumerators,
            $3b8da494b8e92f36$var$Labelise(i.PrimaryUnit),
            $3b8da494b8e92f36$var$Labelise(i.SecondaryUnit),
            i.Expression,
            i.AccessState
        ],
    1412071761: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName
        ],
    710998568: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2706606064: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType
        ],
    3893378262: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    463610769: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.PredefinedType
        ],
    2481509218: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.LongName
        ],
    451544542: (i)=>[
            i.Position,
            i.Radius
        ],
    4015995234: (i)=>[
            i.Position,
            i.Radius
        ],
    2735484536: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position)
        ],
    3544373492: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal
        ],
    3136571912: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    530289379: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    3689010777: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal
        ],
    3979015343: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Thickness
        ],
    2218152070: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Thickness
        ],
    603775116: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.PredefinedType
        ],
    4095615324: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    699246055: (i)=>[
            i.Curve3D,
            i.AssociatedGeometry,
            i.MasterRepresentation
        ],
    2028607225: (i)=>[
            i.SweptArea,
            i.Position,
            i.Directrix,
            (i.StartParam ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.StartParam),
            (i.EndParam ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.EndParam),
            i.ReferenceSurface
        ],
    2809605785: (i)=>[
            i.SweptCurve,
            i.Position,
            i.ExtrudedDirection,
            i.Depth
        ],
    4124788165: (i)=>[
            i.SweptCurve,
            i.Position,
            i.AxisPosition
        ],
    1580310250: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3473067441: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Status,
            i.WorkMethod,
            {
                type: 3,
                value: i.IsMilestone.value
            },
            i.Priority,
            i.TaskTime,
            i.PredefinedType
        ],
    3206491090: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ProcessType,
            i.PredefinedType,
            i.WorkMethod
        ],
    2387106220: (i)=>[
            i.Coordinates
        ],
    782932809: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.CubicTerm,
            i.QuadraticTerm,
            i.LinearTerm,
            i.ConstantTerm
        ],
    1935646853: (i)=>[
            i.Position,
            i.MajorRadius,
            i.MinorRadius
        ],
    3665877780: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2916149573: (i)=>[
            i.Coordinates,
            i.Normals,
            i.Closed == null ? null : {
                type: 3,
                value: i.Closed.value
            },
            i.CoordIndex,
            i.PnIndex
        ],
    1229763772: (i)=>[
            i.Coordinates,
            i.Normals,
            i.Closed == null ? null : {
                type: 3,
                value: i.Closed.value
            },
            i.CoordIndex,
            i.PnIndex,
            i.Flags
        ],
    3651464721: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    336235671: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.LiningDepth,
            i.LiningThickness,
            i.TransomThickness,
            i.MullionThickness,
            i.FirstTransomOffset,
            i.SecondTransomOffset,
            i.FirstMullionOffset,
            i.SecondMullionOffset,
            i.ShapeAspectStyle,
            i.LiningOffset,
            i.LiningToPanelOffsetX,
            i.LiningToPanelOffsetY
        ],
    512836454: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.OperationType,
            i.PanelPosition,
            i.FrameDepth,
            i.FrameThickness,
            i.ShapeAspectStyle
        ],
    2296667514: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.TheActor)
        ],
    1635779807: (i)=>[
            i.Outer
        ],
    2603310189: (i)=>[
            i.Outer,
            i.Voids
        ],
    1674181508: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType
        ],
    2887950389: (i)=>[
            i.UDegree,
            i.VDegree,
            i.ControlPointsList,
            i.SurfaceForm,
            {
                type: 3,
                value: i.UClosed.value
            },
            {
                type: 3,
                value: i.VClosed.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    167062518: (i)=>[
            i.UDegree,
            i.VDegree,
            i.ControlPointsList,
            i.SurfaceForm,
            {
                type: 3,
                value: i.UClosed.value
            },
            {
                type: 3,
                value: i.VClosed.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.UMultiplicities,
            i.VMultiplicities,
            i.UKnots,
            i.VKnots,
            i.KnotSpec
        ],
    1334484129: (i)=>[
            i.Position,
            i.XLength,
            i.YLength,
            i.ZLength
        ],
    3649129432: (i)=>[
            i.Operator,
            $3b8da494b8e92f36$var$Labelise(i.FirstOperand),
            $3b8da494b8e92f36$var$Labelise(i.SecondOperand)
        ],
    1260505505: (_)=>[],
    3124254112: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.Elevation
        ],
    1626504194: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2197970202: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2937912522: (i)=>[
            i.ProfileType,
            i.ProfileName,
            i.Position,
            i.Radius,
            i.WallThickness
        ],
    3893394355: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3497074424: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.ClothoidConstant
        ],
    300633059: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3875453745: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.UsageName,
            i.TemplateType,
            i.HasPropertyTemplates
        ],
    3732776249: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    15328376: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    2510884976: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position)
        ],
    2185764099: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    4105962743: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1525564444: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.Identification,
            i.LongDescription,
            i.ResourceType,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    2559216714: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity
        ],
    3293443760: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification
        ],
    2000195564: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.CosineTerm,
            i.ConstantTerm
        ],
    3895139033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.CostValues,
            i.CostQuantities
        ],
    1419761937: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.Status,
            i.SubmittedOn,
            i.UpdateDate
        ],
    4189326743: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1916426348: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3295246426: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1457835157: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1213902940: (i)=>[
            i.Position,
            i.Radius
        ],
    1306400036: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    4234616927: (i)=>[
            i.SweptArea,
            i.Position,
            i.Directrix,
            (i.StartParam ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.StartParam),
            (i.EndParam ?? void 0) === void 0 ? null : $3b8da494b8e92f36$var$Labelise(i.EndParam),
            i.FixedReference
        ],
    3256556792: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3849074793: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2963535650: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.LiningDepth,
            i.LiningThickness,
            i.ThresholdDepth,
            i.ThresholdThickness,
            i.TransomThickness,
            i.TransomOffset,
            i.LiningOffset,
            i.ThresholdOffset,
            i.CasingThickness,
            i.CasingDepth,
            i.ShapeAspectStyle,
            i.LiningToPanelOffsetX,
            i.LiningToPanelOffsetY
        ],
    1714330368: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.PanelDepth,
            i.PanelOperation,
            i.PanelWidth,
            i.PanelPosition,
            i.ShapeAspectStyle
        ],
    2323601079: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.OperationType,
            i.ParameterTakesPrecedence == null ? null : {
                type: 3,
                value: i.ParameterTakesPrecedence.value
            },
            i.UserDefinedOperationType
        ],
    445594917: (i)=>[
            i.Name
        ],
    4006246654: (i)=>[
            i.Name
        ],
    1758889154: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    4123344466: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.AssemblyPlace,
            i.PredefinedType
        ],
    2397081782: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1623761950: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2590856083: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1704287377: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.SemiAxis1,
            i.SemiAxis2
        ],
    2107101300: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    132023988: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3174744832: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3390157468: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4148101412: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.PredefinedType,
            i.EventTriggerType,
            i.UserDefinedEventTriggerType,
            i.EventOccurenceTime
        ],
    2853485674: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName
        ],
    807026263: (i)=>[
            i.Outer
        ],
    3737207727: (i)=>[
            i.Outer,
            i.Voids
        ],
    24185140: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType
        ],
    1310830890: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.UsageType
        ],
    4228831410: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.UsageType,
            i.PredefinedType
        ],
    647756555: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2489546625: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2827207264: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2143335405: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1287392070: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3907093117: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3198132628: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3815607619: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1482959167: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1834744321: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1339347760: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2297155007: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    3009222698: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1893162501: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    263784265: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1509553395: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3493046030: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4230923436: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1594536857: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2898700619: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.BaseCurve,
            i.EndPoint
        ],
    2706460486: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    1251058090: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1806887404: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2568555532: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3948183225: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2571569899: (i)=>[
            i.Points,
            (i.Segments ?? void 0) === void 0 ? null : i.Segments.map((p)=>$3b8da494b8e92f36$var$Labelise(p)),
            i.SelfIntersect == null ? null : {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    3946677679: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3113134337: (i)=>[
            i.Curve3D,
            i.AssociatedGeometry,
            i.MasterRepresentation
        ],
    2391368822: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            $3b8da494b8e92f36$var$Labelise(i.Jurisdiction),
            i.ResponsiblePersons,
            i.LastUpdateDate,
            i.CurrentValue,
            i.OriginalValue
        ],
    4288270099: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    679976338: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3827777499: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1051575348: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1161773419: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2176059722: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    1770583370: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    525669439: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.PredefinedType
        ],
    976884017: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.UsageType,
            i.PredefinedType
        ],
    377706215: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.NominalDiameter,
            i.NominalLength,
            i.PredefinedType
        ],
    2108223431: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.NominalDiameter,
            i.NominalLength
        ],
    1114901282: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3181161470: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1950438474: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    710110818: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    977012517: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    506776471: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4143007308: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            $3b8da494b8e92f36$var$Labelise(i.TheActor),
            i.PredefinedType
        ],
    3588315303: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2837617999: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    514975943: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2382730787: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LifeCyclePhase,
            i.PredefinedType
        ],
    3566463478: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.OperationType,
            i.PanelPosition,
            i.FrameDepth,
            i.FrameThickness,
            i.ShapeAspectStyle
        ],
    3327091369: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.Status,
            i.LongDescription
        ],
    1158309216: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    804291784: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4231323485: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4017108033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2839578677: (i)=>[
            i.Coordinates,
            i.Closed == null ? null : {
                type: 3,
                value: i.Closed.value
            },
            i.Faces,
            i.PnIndex
        ],
    3724593414: (i)=>[
            i.Points
        ],
    3740093272: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    1946335990: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    2744685151: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.PredefinedType
        ],
    2904328755: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.Status,
            i.LongDescription
        ],
    3651124850: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1842657554: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2250791053: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1763565496: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2893384427: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3992365140: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.PredefinedType
        ],
    1891881377: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.UsageType,
            i.PredefinedType
        ],
    2324767716: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1469900589: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    683857671: (i)=>[
            i.UDegree,
            i.VDegree,
            i.ControlPointsList,
            i.SurfaceForm,
            {
                type: 3,
                value: i.UClosed.value
            },
            {
                type: 3,
                value: i.VClosed.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.UMultiplicities,
            i.VMultiplicities,
            i.UKnots,
            i.VKnots,
            i.KnotSpec,
            i.WeightsData
        ],
    4021432810: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType
        ],
    3027567501: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade
        ],
    964333572: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    2320036040: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.MeshLength,
            i.MeshWidth,
            i.LongitudinalBarNominalDiameter,
            i.TransverseBarNominalDiameter,
            i.LongitudinalBarCrossSectionArea,
            i.TransverseBarCrossSectionArea,
            i.LongitudinalBarSpacing,
            i.TransverseBarSpacing,
            i.PredefinedType
        ],
    2310774935: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.MeshLength,
            i.MeshWidth,
            i.LongitudinalBarNominalDiameter,
            i.TransverseBarNominalDiameter,
            i.LongitudinalBarCrossSectionArea,
            i.TransverseBarCrossSectionArea,
            i.LongitudinalBarSpacing,
            i.TransverseBarSpacing,
            i.BendingShapeCode,
            (i.BendingParameters ?? void 0) === void 0 ? null : i.BendingParameters.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    3818125796: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingElement,
            i.RelatedSurfaceFeatures
        ],
    160246688: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.RelatingObject,
            i.RelatedObjects
        ],
    146592293: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.PredefinedType
        ],
    550521510: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.UsageType,
            i.PredefinedType
        ],
    2781568857: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1768891740: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2157484638: (i)=>[
            i.Curve3D,
            i.AssociatedGeometry,
            i.MasterRepresentation
        ],
    3649235739: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.QuadraticTerm,
            i.LinearTerm,
            i.ConstantTerm
        ],
    544395925: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.BaseCurve,
            i.EndPoint
        ],
    1027922057: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.SepticTerm,
            i.SexticTerm,
            i.QuinticTerm,
            i.QuarticTerm,
            i.CubicTerm,
            i.QuadraticTerm,
            i.LinearTerm,
            i.ConstantTerm
        ],
    4074543187: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    33720170: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3599934289: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1894708472: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    42703149: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.SineTerm,
            i.LinearTerm,
            i.ConstantTerm
        ],
    4097777520: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.RefLatitude,
            i.RefLongitude,
            i.RefElevation,
            i.LandTitleNumber,
            i.SiteAddress
        ],
    2533589738: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1072016465: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3856911033: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.PredefinedType,
            i.ElevationWithFlooring
        ],
    1305183839: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3812236995: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.LongName
        ],
    3112655638: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1039846685: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    338393293: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    682877961: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            }
        ],
    1179482911: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition
        ],
    1004757350: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            },
            i.ProjectedOrTrue,
            i.PredefinedType
        ],
    4243806635: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition,
            i.AxisDirection
        ],
    214636428: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Axis
        ],
    2445595289: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType,
            i.Axis
        ],
    2757150158: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.PredefinedType
        ],
    1807405624: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            },
            i.ProjectedOrTrue,
            i.PredefinedType
        ],
    1252848954: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.ActionType,
            i.ActionSource,
            i.Coefficient,
            i.Purpose
        ],
    2082059205: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            }
        ],
    734778138: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition,
            i.ConditionCoordinateSystem
        ],
    1235345126: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal
        ],
    2986769608: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.TheoryType,
            i.ResultForLoadGroup,
            {
                type: 3,
                value: i.IsLinear.value
            }
        ],
    3657597509: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            },
            i.ProjectedOrTrue,
            i.PredefinedType
        ],
    1975003073: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedCondition
        ],
    148013059: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    3101698114: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2315554128: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2254336722: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType
        ],
    413509423: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    5716631: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3824725483: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.PredefinedType,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.TensionForce,
            i.PreStress,
            i.FrictionCoefficient,
            i.AnchorageSlip,
            i.MinCurvatureRadius
        ],
    2347447852: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.PredefinedType
        ],
    3081323446: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3663046924: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.PredefinedType
        ],
    2281632017: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2415094496: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.SheathDiameter
        ],
    618700268: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1692211062: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2097647324: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1953115116: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3593883385: (i)=>[
            i.BasisCurve,
            $3b8da494b8e92f36$var$Labelise(i.Trim1),
            $3b8da494b8e92f36$var$Labelise(i.Trim2),
            {
                type: 3,
                value: i.SenseAgreement.value
            },
            i.MasterRepresentation
        ],
    1600972822: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1911125066: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    728799441: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    840318589: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1530820697: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3956297820: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2391383451: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3313531582: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2769231204: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    926996030: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1898987631: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1133259667: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4009809668: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.PartitioningType,
            i.ParameterTakesPrecedence == null ? null : {
                type: 3,
                value: i.ParameterTakesPrecedence.value
            },
            i.UserDefinedPartitioningType
        ],
    4088093105: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.WorkingTimes,
            i.ExceptionTimes,
            i.PredefinedType
        ],
    1028945134: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.CreationDate,
            i.Creators,
            i.Purpose,
            i.Duration,
            i.TotalFloat,
            i.StartTime,
            i.FinishTime
        ],
    4218914973: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.CreationDate,
            i.Creators,
            i.Purpose,
            i.Duration,
            i.TotalFloat,
            i.StartTime,
            i.FinishTime,
            i.PredefinedType
        ],
    3342526732: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.CreationDate,
            i.Creators,
            i.Purpose,
            i.Duration,
            i.TotalFloat,
            i.StartTime,
            i.FinishTime,
            i.PredefinedType
        ],
    1033361043: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName
        ],
    3821786052: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.PredefinedType,
            i.Status,
            i.LongDescription
        ],
    1411407467: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3352864051: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1871374353: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4266260250: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.RailHeadDistance
        ],
    1545765605: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    317615605: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.DesignParameters
        ],
    1662888072: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    3460190687: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.OriginalValue,
            i.CurrentValue,
            i.TotalReplacementCost,
            $3b8da494b8e92f36$var$Labelise(i.Owner),
            $3b8da494b8e92f36$var$Labelise(i.User),
            i.ResponsiblePerson,
            i.IncorporationDate,
            i.DepreciatedValue
        ],
    1532957894: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1967976161: (i)=>[
            i.Degree,
            i.ControlPointsList,
            i.CurveForm,
            {
                type: 3,
                value: i.ClosedCurve.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    2461110595: (i)=>[
            i.Degree,
            i.ControlPointsList,
            i.CurveForm,
            {
                type: 3,
                value: i.ClosedCurve.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.KnotMultiplicities,
            i.Knots,
            i.KnotSpec
        ],
    819618141: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3649138523: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    231477066: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1136057603: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    644574406: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.PredefinedType
        ],
    963979645: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.UsageType,
            i.PredefinedType
        ],
    4031249490: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.CompositionType,
            i.ElevationOfRefHeight,
            i.ElevationOfTerrain,
            i.BuildingAddress
        ],
    2979338954: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    39481116: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1909888760: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1177604601: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.LongName
        ],
    1876633798: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3862327254: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.LongName
        ],
    2188180465: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    395041908: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3293546465: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2674252688: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1285652485: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3203706013: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2951183804: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3296154744: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2611217952: (i)=>[
            $3b8da494b8e92f36$var$Labelise(i.Position),
            i.Radius
        ],
    1677625105: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2301859152: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    843113511: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    400855858: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3850581409: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2816379211: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3898045240: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    1060000209: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    488727124: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.Identification,
            i.LongDescription,
            i.Usage,
            i.BaseCosts,
            i.BaseQuantity,
            i.PredefinedType
        ],
    2940368186: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    335055490: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2954562838: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1502416096: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1973544240: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3495092785: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3961806047: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3426335179: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1335981549: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2635815018: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    479945903: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1599208980: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2063403501: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType
        ],
    1945004755: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3040386961: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3041715199: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.FlowDirection,
            i.PredefinedType,
            i.SystemType
        ],
    3205830791: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.PredefinedType
        ],
    395920057: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.OverallHeight,
            i.OverallWidth,
            i.PredefinedType,
            i.OperationType,
            i.UserDefinedOperationType
        ],
    869906466: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3760055223: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2030761528: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3071239417: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1077100507: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3376911765: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    663422040: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2417008758: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3277789161: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2142170206: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1534661035: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1217240411: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    712377611: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1658829314: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2814081492: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3747195512: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    484807127: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1209101575: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.LongName,
            i.PredefinedType
        ],
    346874300: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1810631287: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4222183408: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2058353004: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    4278956645: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    4037862832: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    2188021234: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3132237377: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    987401354: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    707683696: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2223149337: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3508470533: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    900683007: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2713699986: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    3009204131: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.UAxes,
            i.VAxes,
            i.WAxes,
            i.PredefinedType
        ],
    3319311131: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2068733104: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4175244083: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2176052936: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2696325953: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    76236018: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    629592764: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1154579445: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation
        ],
    1638804497: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1437502449: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1073191201: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2078563270: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    234836483: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2474470126: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2182337498: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    144952367: (i)=>[
            i.Segments,
            {
                type: 3,
                value: i.SelfIntersect.value
            }
        ],
    3694346114: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1383356374: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1687234759: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType,
            i.ConstructionType
        ],
    310824031: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3612865200: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3171933400: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    738039164: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    655969474: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    90941305: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3290496277: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2262370178: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3024970846: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3283111854: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1232101972: (i)=>[
            i.Degree,
            i.ControlPointsList,
            i.CurveForm,
            {
                type: 3,
                value: i.ClosedCurve.value
            },
            {
                type: 3,
                value: i.SelfIntersect.value
            },
            i.KnotMultiplicities,
            i.Knots,
            i.KnotSpec,
            i.WeightsData
        ],
    3798194928: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    979691226: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.SteelGrade,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.BarLength,
            i.PredefinedType,
            i.BarSurface
        ],
    2572171363: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType,
            i.NominalDiameter,
            i.CrossSectionArea,
            i.BarLength,
            i.BarSurface,
            i.BendingShapeCode,
            (i.BendingParameters ?? void 0) === void 0 ? null : i.BendingParameters.map((p)=>$3b8da494b8e92f36$var$Labelise(p))
        ],
    2016517767: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3053780830: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1783015770: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1329646415: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    991950508: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1529196076: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3420628829: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1999602285: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1404847402: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    331165859: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4252922144: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.NumberOfRisers,
            i.NumberOfTreads,
            i.RiserHeight,
            i.TreadLength,
            i.PredefinedType
        ],
    2515109513: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.OrientationOf2DPlane,
            i.LoadedBy,
            i.HasResults,
            i.SharedPlacement
        ],
    385403989: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.PredefinedType,
            i.ActionType,
            i.ActionSource,
            i.Coefficient,
            i.Purpose,
            i.SelfWeightCoefficients
        ],
    1621171031: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.AppliedLoad,
            i.GlobalOrLocal,
            i.DestabilizingLoad == null ? null : {
                type: 3,
                value: i.DestabilizingLoad.value
            },
            i.ProjectedOrTrue,
            i.PredefinedType
        ],
    1162798199: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    812556717: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3425753595: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3825984169: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1620046519: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3026737570: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3179687236: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    4292641817: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4207607924: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2391406946: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3512223829: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4237592921: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3304561284: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.OverallHeight,
            i.OverallWidth,
            i.PredefinedType,
            i.PartitioningType,
            i.UserDefinedPartitioningType
        ],
    2874132201: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    1634111441: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    177149247: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2056796094: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3001207471: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    325726236: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.PredefinedType
        ],
    277319702: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    753842376: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4196446775: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    32344328: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3314249567: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1095909175: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2938176219: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    635142910: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3758799889: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1051757585: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4217484030: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3999819293: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3902619387: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    639361253: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3221913625: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3571504051: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2272882330: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    578613899: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ApplicableOccurrence,
            i.HasPropertySets,
            i.RepresentationMaps,
            i.Tag,
            i.ElementType,
            i.PredefinedType
        ],
    3460952963: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4136498852: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3640358203: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4074379575: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3693000487: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1052013943: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    562808652: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.LongName,
            i.PredefinedType
        ],
    1062813311: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    342316401: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3518393246: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1360408905: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1904799276: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    862014818: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3310460725: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    24726584: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    264262732: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    402227799: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1003880860: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3415622556: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    819412036: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    1426591983: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    182646315: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    2680139844: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    1971632696: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag
        ],
    2295281155: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4086658281: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    630975310: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    4288193352: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    3087945054: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ],
    25142252: (i)=>[
            i.GlobalId,
            i.OwnerHistory,
            i.Name,
            i.Description,
            i.ObjectType,
            i.ObjectPlacement,
            i.Representation,
            i.Tag,
            i.PredefinedType
        ]
};
$3b8da494b8e92f36$export$9d063d2e6222d3e2[3] = {
    3699917729: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAbsorbedDoseMeasure(v),
    4182062534: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAccelerationMeasure(v),
    360377573: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAmountOfSubstanceMeasure(v),
    632304761: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAngularVelocityMeasure(v),
    3683503648: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcArcIndex(v.map((x)=>x.value)),
    1500781891: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaDensityMeasure(v),
    2650437152: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcAreaMeasure(v),
    2314439260: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBinary(v),
    2735952531: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoolean(v),
    1867003952: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcBoxAlignment(v),
    1683019596: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCardinalPointReference(v),
    2991860651: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcComplexNumber(v.map((x)=>x.value)),
    3812528620: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCompoundPlaneAngleMeasure(v.map((x)=>x.value)),
    3238673880: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcContextDependentMeasure(v),
    1778710042: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCountMeasure(v),
    94842927: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcCurvatureMeasure(v),
    937566702: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDate(v),
    2195413836: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDateTime(v),
    86635668: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDayInMonthNumber(v),
    3701338814: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDayInWeekNumber(v),
    1514641115: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDescriptiveMeasure(v),
    4134073009: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDimensionCount(v),
    524656162: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDoseEquivalentMeasure(v),
    2541165894: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDuration(v),
    69416015: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcDynamicViscosityMeasure(v),
    1827137117: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricCapacitanceMeasure(v),
    3818826038: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricChargeMeasure(v),
    2093906313: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricConductanceMeasure(v),
    3790457270: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricCurrentMeasure(v),
    2951915441: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricResistanceMeasure(v),
    2506197118: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcElectricVoltageMeasure(v),
    2078135608: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcEnergyMeasure(v),
    1102727119: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFontStyle(v),
    2715512545: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFontVariant(v),
    2590844177: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFontWeight(v),
    1361398929: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcForceMeasure(v),
    3044325142: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcFrequencyMeasure(v),
    3064340077: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcGloballyUniqueId(v),
    3113092358: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHeatFluxDensityMeasure(v),
    1158859006: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcHeatingValueMeasure(v),
    983778844: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIdentifier(v),
    3358199106: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIlluminanceMeasure(v),
    2679005408: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInductanceMeasure(v),
    1939436016: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcInteger(v),
    3809634241: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIntegerCountRateMeasure(v),
    3686016028: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIonConcentrationMeasure(v),
    3192672207: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcIsothermalMoistureCapacityMeasure(v),
    2054016361: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcKinematicViscosityMeasure(v),
    3258342251: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLabel(v),
    1275358634: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLanguageId(v),
    1243674935: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLengthMeasure(v),
    1774176899: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLineIndex(v.map((x)=>x.value)),
    191860431: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearForceMeasure(v),
    2128979029: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearMomentMeasure(v),
    1307019551: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearStiffnessMeasure(v),
    3086160713: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLinearVelocityMeasure(v),
    503418787: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLogical(v),
    2095003142: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLuminousFluxMeasure(v),
    2755797622: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLuminousIntensityDistributionMeasure(v),
    151039812: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcLuminousIntensityMeasure(v),
    286949696: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMagneticFluxDensityMeasure(v),
    2486716878: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMagneticFluxMeasure(v),
    1477762836: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMassDensityMeasure(v),
    4017473158: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMassFlowRateMeasure(v),
    3124614049: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMassMeasure(v),
    3531705166: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMassPerLengthMeasure(v),
    3341486342: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcModulusOfElasticityMeasure(v),
    2173214787: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcModulusOfLinearSubgradeReactionMeasure(v),
    1052454078: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcModulusOfRotationalSubgradeReactionMeasure(v),
    1753493141: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcModulusOfSubgradeReactionMeasure(v),
    3177669450: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMoistureDiffusivityMeasure(v),
    1648970520: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMolecularWeightMeasure(v),
    3114022597: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMomentOfInertiaMeasure(v),
    2615040989: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMonetaryMeasure(v),
    765770214: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcMonthInYearNumber(v),
    525895558: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNonNegativeLengthMeasure(v),
    2095195183: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNormalisedRatioMeasure(v),
    2395907400: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcNumericMeasure(v),
    929793134: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPHMeasure(v),
    2260317790: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcParameterValue(v),
    2642773653: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlanarForceMeasure(v),
    4042175685: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPlaneAngleMeasure(v),
    1790229001: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveInteger(v),
    2815919920: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveLengthMeasure(v),
    3054510233: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositivePlaneAngleMeasure(v),
    1245737093: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPositiveRatioMeasure(v),
    1364037233: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPowerMeasure(v),
    2169031380: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPresentableText(v),
    3665567075: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPressureMeasure(v),
    2798247006: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcPropertySetDefinitionSet(v.map((x)=>x.value)),
    3972513137: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRadioActivityMeasure(v),
    96294661: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRatioMeasure(v),
    200335297: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcReal(v),
    2133746277: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRotationalFrequencyMeasure(v),
    1755127002: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRotationalMassMeasure(v),
    3211557302: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcRotationalStiffnessMeasure(v),
    3467162246: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionModulusMeasure(v),
    2190458107: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSectionalAreaIntegralMeasure(v),
    408310005: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcShearModulusMeasure(v),
    3471399674: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSolidAngleMeasure(v),
    4157543285: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSoundPowerLevelMeasure(v),
    846465480: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSoundPowerMeasure(v),
    3457685358: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSoundPressureLevelMeasure(v),
    993287707: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSoundPressureMeasure(v),
    3477203348: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpecificHeatCapacityMeasure(v),
    2757832317: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpecularExponent(v),
    361837227: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcSpecularRoughness(v),
    1805707277: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcStrippedOptional(v),
    58845555: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTemperatureGradientMeasure(v),
    1209108979: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTemperatureRateOfChangeMeasure(v),
    2801250643: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcText(v),
    1460886941: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextAlignment(v),
    3490877962: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextDecoration(v),
    603696268: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextFontName(v),
    296282323: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTextTransformation(v),
    232962298: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermalAdmittanceMeasure(v),
    2645777649: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermalConductivityMeasure(v),
    2281867870: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermalExpansionCoefficientMeasure(v),
    857959152: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermalResistanceMeasure(v),
    2016195849: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermalTransmittanceMeasure(v),
    743184107: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcThermodynamicTemperatureMeasure(v),
    4075327185: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTime(v),
    2726807636: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeMeasure(v),
    2591213694: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTimeStamp(v),
    1278329552: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcTorqueMeasure(v),
    950732822: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcURIReference(v),
    3345633955: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVaporPermeabilityMeasure(v),
    3458127941: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVolumeMeasure(v),
    2593997549: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcVolumetricFlowRateMeasure(v),
    51269191: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWarpingConstantMeasure(v),
    1718600412: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWarpingMomentMeasure(v),
    2149462589: (v)=>new $3b8da494b8e92f36$export$80d8bc28a624d324.IfcWellKnownTextLiteral(v)
};
var $3b8da494b8e92f36$export$80d8bc28a624d324;
((IFC4X32)=>{
    class IfcAbsorbedDoseMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCABSORBEDDOSEMEASURE";
        }
    }
    IFC4X32.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;
    class IfcAccelerationMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCACCELERATIONMEASURE";
        }
    }
    IFC4X32.IfcAccelerationMeasure = IfcAccelerationMeasure;
    class IfcAmountOfSubstanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCAMOUNTOFSUBSTANCEMEASURE";
        }
    }
    IFC4X32.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;
    class IfcAngularVelocityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCANGULARVELOCITYMEASURE";
        }
    }
    IFC4X32.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;
    class IfcArcIndex {
        constructor(value){
            this.value = value;
            this.type = 5;
        }
    }
    IFC4X32.IfcArcIndex = IfcArcIndex;
    class IfcAreaDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCAREADENSITYMEASURE";
        }
    }
    IFC4X32.IfcAreaDensityMeasure = IfcAreaDensityMeasure;
    class IfcAreaMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCAREAMEASURE";
        }
    }
    IFC4X32.IfcAreaMeasure = IfcAreaMeasure;
    class IfcBinary extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCBINARY";
        }
    }
    IFC4X32.IfcBinary = IfcBinary;
    class IfcBoolean {
        constructor(v){
            this.type = 3;
            this.name = "IFCBOOLEAN";
            this.value = v;
        }
    }
    IFC4X32.IfcBoolean = IfcBoolean;
    class IfcBoxAlignment {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCBOXALIGNMENT";
        }
    }
    IFC4X32.IfcBoxAlignment = IfcBoxAlignment;
    class IfcCardinalPointReference extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCCARDINALPOINTREFERENCE";
        }
    }
    IFC4X32.IfcCardinalPointReference = IfcCardinalPointReference;
    class IfcComplexNumber {
        constructor(value){
            this.value = value;
            this.type = 4;
        }
    }
    IFC4X32.IfcComplexNumber = IfcComplexNumber;
    class IfcCompoundPlaneAngleMeasure {
        constructor(value){
            this.value = value;
            this.type = 10;
        }
    }
    IFC4X32.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;
    class IfcContextDependentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCCONTEXTDEPENDENTMEASURE";
        }
    }
    IFC4X32.IfcContextDependentMeasure = IfcContextDependentMeasure;
    class IfcCountMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCCOUNTMEASURE";
        }
    }
    IFC4X32.IfcCountMeasure = IfcCountMeasure;
    class IfcCurvatureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCCURVATUREMEASURE";
        }
    }
    IFC4X32.IfcCurvatureMeasure = IfcCurvatureMeasure;
    class IfcDate {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCDATE";
        }
    }
    IFC4X32.IfcDate = IfcDate;
    class IfcDateTime {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCDATETIME";
        }
    }
    IFC4X32.IfcDateTime = IfcDateTime;
    class IfcDayInMonthNumber extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCDAYINMONTHNUMBER";
        }
    }
    IFC4X32.IfcDayInMonthNumber = IfcDayInMonthNumber;
    class IfcDayInWeekNumber extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCDAYINWEEKNUMBER";
        }
    }
    IFC4X32.IfcDayInWeekNumber = IfcDayInWeekNumber;
    class IfcDescriptiveMeasure {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCDESCRIPTIVEMEASURE";
        }
    }
    IFC4X32.IfcDescriptiveMeasure = IfcDescriptiveMeasure;
    class IfcDimensionCount extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCDIMENSIONCOUNT";
        }
    }
    IFC4X32.IfcDimensionCount = IfcDimensionCount;
    class IfcDoseEquivalentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCDOSEEQUIVALENTMEASURE";
        }
    }
    IFC4X32.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;
    class IfcDuration {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCDURATION";
        }
    }
    IFC4X32.IfcDuration = IfcDuration;
    class IfcDynamicViscosityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCDYNAMICVISCOSITYMEASURE";
        }
    }
    IFC4X32.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;
    class IfcElectricCapacitanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCAPACITANCEMEASURE";
        }
    }
    IFC4X32.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;
    class IfcElectricChargeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCHARGEMEASURE";
        }
    }
    IFC4X32.IfcElectricChargeMeasure = IfcElectricChargeMeasure;
    class IfcElectricConductanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCONDUCTANCEMEASURE";
        }
    }
    IFC4X32.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;
    class IfcElectricCurrentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICCURRENTMEASURE";
        }
    }
    IFC4X32.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;
    class IfcElectricResistanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICRESISTANCEMEASURE";
        }
    }
    IFC4X32.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;
    class IfcElectricVoltageMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCELECTRICVOLTAGEMEASURE";
        }
    }
    IFC4X32.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;
    class IfcEnergyMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCENERGYMEASURE";
        }
    }
    IFC4X32.IfcEnergyMeasure = IfcEnergyMeasure;
    class IfcFontStyle {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCFONTSTYLE";
        }
    }
    IFC4X32.IfcFontStyle = IfcFontStyle;
    class IfcFontVariant {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCFONTVARIANT";
        }
    }
    IFC4X32.IfcFontVariant = IfcFontVariant;
    class IfcFontWeight {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCFONTWEIGHT";
        }
    }
    IFC4X32.IfcFontWeight = IfcFontWeight;
    class IfcForceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCFORCEMEASURE";
        }
    }
    IFC4X32.IfcForceMeasure = IfcForceMeasure;
    class IfcFrequencyMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCFREQUENCYMEASURE";
        }
    }
    IFC4X32.IfcFrequencyMeasure = IfcFrequencyMeasure;
    class IfcGloballyUniqueId {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCGLOBALLYUNIQUEID";
        }
    }
    IFC4X32.IfcGloballyUniqueId = IfcGloballyUniqueId;
    class IfcHeatFluxDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCHEATFLUXDENSITYMEASURE";
        }
    }
    IFC4X32.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;
    class IfcHeatingValueMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCHEATINGVALUEMEASURE";
        }
    }
    IFC4X32.IfcHeatingValueMeasure = IfcHeatingValueMeasure;
    class IfcIdentifier {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCIDENTIFIER";
        }
    }
    IFC4X32.IfcIdentifier = IfcIdentifier;
    class IfcIlluminanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCILLUMINANCEMEASURE";
        }
    }
    IFC4X32.IfcIlluminanceMeasure = IfcIlluminanceMeasure;
    class IfcInductanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCINDUCTANCEMEASURE";
        }
    }
    IFC4X32.IfcInductanceMeasure = IfcInductanceMeasure;
    class IfcInteger extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCINTEGER";
        }
    }
    IFC4X32.IfcInteger = IfcInteger;
    class IfcIntegerCountRateMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCINTEGERCOUNTRATEMEASURE";
        }
    }
    IFC4X32.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;
    class IfcIonConcentrationMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCIONCONCENTRATIONMEASURE";
        }
    }
    IFC4X32.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;
    class IfcIsothermalMoistureCapacityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCISOTHERMALMOISTURECAPACITYMEASURE";
        }
    }
    IFC4X32.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;
    class IfcKinematicViscosityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCKINEMATICVISCOSITYMEASURE";
        }
    }
    IFC4X32.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;
    class IfcLabel {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCLABEL";
        }
    }
    IFC4X32.IfcLabel = IfcLabel;
    class IfcLanguageId {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCLANGUAGEID";
        }
    }
    IFC4X32.IfcLanguageId = IfcLanguageId;
    class IfcLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLENGTHMEASURE";
        }
    }
    IFC4X32.IfcLengthMeasure = IfcLengthMeasure;
    class IfcLineIndex {
        constructor(value){
            this.value = value;
            this.type = 5;
        }
    }
    IFC4X32.IfcLineIndex = IfcLineIndex;
    class IfcLinearForceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARFORCEMEASURE";
        }
    }
    IFC4X32.IfcLinearForceMeasure = IfcLinearForceMeasure;
    class IfcLinearMomentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARMOMENTMEASURE";
        }
    }
    IFC4X32.IfcLinearMomentMeasure = IfcLinearMomentMeasure;
    class IfcLinearStiffnessMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARSTIFFNESSMEASURE";
        }
    }
    IFC4X32.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;
    class IfcLinearVelocityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLINEARVELOCITYMEASURE";
        }
    }
    IFC4X32.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;
    class IfcLogical {
        constructor(v){
            this.type = 3;
            this.name = "IFCLOGICAL";
            this.value = v;
        }
    }
    IFC4X32.IfcLogical = IfcLogical;
    class IfcLuminousFluxMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLUMINOUSFLUXMEASURE";
        }
    }
    IFC4X32.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;
    class IfcLuminousIntensityDistributionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLUMINOUSINTENSITYDISTRIBUTIONMEASURE";
        }
    }
    IFC4X32.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;
    class IfcLuminousIntensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCLUMINOUSINTENSITYMEASURE";
        }
    }
    IFC4X32.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;
    class IfcMagneticFluxDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMAGNETICFLUXDENSITYMEASURE";
        }
    }
    IFC4X32.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;
    class IfcMagneticFluxMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMAGNETICFLUXMEASURE";
        }
    }
    IFC4X32.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;
    class IfcMassDensityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSDENSITYMEASURE";
        }
    }
    IFC4X32.IfcMassDensityMeasure = IfcMassDensityMeasure;
    class IfcMassFlowRateMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSFLOWRATEMEASURE";
        }
    }
    IFC4X32.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;
    class IfcMassMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSMEASURE";
        }
    }
    IFC4X32.IfcMassMeasure = IfcMassMeasure;
    class IfcMassPerLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMASSPERLENGTHMEASURE";
        }
    }
    IFC4X32.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;
    class IfcModulusOfElasticityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFELASTICITYMEASURE";
        }
    }
    IFC4X32.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;
    class IfcModulusOfLinearSubgradeReactionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFLINEARSUBGRADEREACTIONMEASURE";
        }
    }
    IFC4X32.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;
    class IfcModulusOfRotationalSubgradeReactionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFROTATIONALSUBGRADEREACTIONMEASURE";
        }
    }
    IFC4X32.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;
    class IfcModulusOfSubgradeReactionMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMODULUSOFSUBGRADEREACTIONMEASURE";
        }
    }
    IFC4X32.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;
    class IfcMoistureDiffusivityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMOISTUREDIFFUSIVITYMEASURE";
        }
    }
    IFC4X32.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;
    class IfcMolecularWeightMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMOLECULARWEIGHTMEASURE";
        }
    }
    IFC4X32.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;
    class IfcMomentOfInertiaMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMOMENTOFINERTIAMEASURE";
        }
    }
    IFC4X32.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;
    class IfcMonetaryMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCMONETARYMEASURE";
        }
    }
    IFC4X32.IfcMonetaryMeasure = IfcMonetaryMeasure;
    class IfcMonthInYearNumber extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCMONTHINYEARNUMBER";
        }
    }
    IFC4X32.IfcMonthInYearNumber = IfcMonthInYearNumber;
    class IfcNonNegativeLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCNONNEGATIVELENGTHMEASURE";
        }
    }
    IFC4X32.IfcNonNegativeLengthMeasure = IfcNonNegativeLengthMeasure;
    class IfcNormalisedRatioMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCNORMALISEDRATIOMEASURE";
        }
    }
    IFC4X32.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;
    class IfcNumericMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCNUMERICMEASURE";
        }
    }
    IFC4X32.IfcNumericMeasure = IfcNumericMeasure;
    class IfcPHMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPHMEASURE";
        }
    }
    IFC4X32.IfcPHMeasure = IfcPHMeasure;
    class IfcParameterValue extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPARAMETERVALUE";
        }
    }
    IFC4X32.IfcParameterValue = IfcParameterValue;
    class IfcPlanarForceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPLANARFORCEMEASURE";
        }
    }
    IFC4X32.IfcPlanarForceMeasure = IfcPlanarForceMeasure;
    class IfcPlaneAngleMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPLANEANGLEMEASURE";
        }
    }
    IFC4X32.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;
    class IfcPositiveInteger extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCPOSITIVEINTEGER";
        }
    }
    IFC4X32.IfcPositiveInteger = IfcPositiveInteger;
    class IfcPositiveLengthMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOSITIVELENGTHMEASURE";
        }
    }
    IFC4X32.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;
    class IfcPositivePlaneAngleMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOSITIVEPLANEANGLEMEASURE";
        }
    }
    IFC4X32.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;
    class IfcPositiveRatioMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOSITIVERATIOMEASURE";
        }
    }
    IFC4X32.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;
    class IfcPowerMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPOWERMEASURE";
        }
    }
    IFC4X32.IfcPowerMeasure = IfcPowerMeasure;
    class IfcPresentableText {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCPRESENTABLETEXT";
        }
    }
    IFC4X32.IfcPresentableText = IfcPresentableText;
    class IfcPressureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCPRESSUREMEASURE";
        }
    }
    IFC4X32.IfcPressureMeasure = IfcPressureMeasure;
    class IfcPropertySetDefinitionSet {
        constructor(value){
            this.value = value;
            this.type = 5;
        }
    }
    IFC4X32.IfcPropertySetDefinitionSet = IfcPropertySetDefinitionSet;
    class IfcRadioActivityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCRADIOACTIVITYMEASURE";
        }
    }
    IFC4X32.IfcRadioActivityMeasure = IfcRadioActivityMeasure;
    class IfcRatioMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCRATIOMEASURE";
        }
    }
    IFC4X32.IfcRatioMeasure = IfcRatioMeasure;
    class IfcReal extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCREAL";
        }
    }
    IFC4X32.IfcReal = IfcReal;
    class IfcRotationalFrequencyMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCROTATIONALFREQUENCYMEASURE";
        }
    }
    IFC4X32.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;
    class IfcRotationalMassMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCROTATIONALMASSMEASURE";
        }
    }
    IFC4X32.IfcRotationalMassMeasure = IfcRotationalMassMeasure;
    class IfcRotationalStiffnessMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCROTATIONALSTIFFNESSMEASURE";
        }
    }
    IFC4X32.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;
    class IfcSectionModulusMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSECTIONMODULUSMEASURE";
        }
    }
    IFC4X32.IfcSectionModulusMeasure = IfcSectionModulusMeasure;
    class IfcSectionalAreaIntegralMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSECTIONALAREAINTEGRALMEASURE";
        }
    }
    IFC4X32.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;
    class IfcShearModulusMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSHEARMODULUSMEASURE";
        }
    }
    IFC4X32.IfcShearModulusMeasure = IfcShearModulusMeasure;
    class IfcSolidAngleMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOLIDANGLEMEASURE";
        }
    }
    IFC4X32.IfcSolidAngleMeasure = IfcSolidAngleMeasure;
    class IfcSoundPowerLevelMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPOWERLEVELMEASURE";
        }
    }
    IFC4X32.IfcSoundPowerLevelMeasure = IfcSoundPowerLevelMeasure;
    class IfcSoundPowerMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPOWERMEASURE";
        }
    }
    IFC4X32.IfcSoundPowerMeasure = IfcSoundPowerMeasure;
    class IfcSoundPressureLevelMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPRESSURELEVELMEASURE";
        }
    }
    IFC4X32.IfcSoundPressureLevelMeasure = IfcSoundPressureLevelMeasure;
    class IfcSoundPressureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSOUNDPRESSUREMEASURE";
        }
    }
    IFC4X32.IfcSoundPressureMeasure = IfcSoundPressureMeasure;
    class IfcSpecificHeatCapacityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSPECIFICHEATCAPACITYMEASURE";
        }
    }
    IFC4X32.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;
    class IfcSpecularExponent extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSPECULAREXPONENT";
        }
    }
    IFC4X32.IfcSpecularExponent = IfcSpecularExponent;
    class IfcSpecularRoughness extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCSPECULARROUGHNESS";
        }
    }
    IFC4X32.IfcSpecularRoughness = IfcSpecularRoughness;
    class IfcStrippedOptional {
        constructor(v){
            this.type = 3;
            this.name = "IFCSTRIPPEDOPTIONAL";
            this.value = v;
        }
    }
    IFC4X32.IfcStrippedOptional = IfcStrippedOptional;
    class IfcTemperatureGradientMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTEMPERATUREGRADIENTMEASURE";
        }
    }
    IFC4X32.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;
    class IfcTemperatureRateOfChangeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTEMPERATURERATEOFCHANGEMEASURE";
        }
    }
    IFC4X32.IfcTemperatureRateOfChangeMeasure = IfcTemperatureRateOfChangeMeasure;
    class IfcText {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXT";
        }
    }
    IFC4X32.IfcText = IfcText;
    class IfcTextAlignment {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTALIGNMENT";
        }
    }
    IFC4X32.IfcTextAlignment = IfcTextAlignment;
    class IfcTextDecoration {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTDECORATION";
        }
    }
    IFC4X32.IfcTextDecoration = IfcTextDecoration;
    class IfcTextFontName {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTFONTNAME";
        }
    }
    IFC4X32.IfcTextFontName = IfcTextFontName;
    class IfcTextTransformation {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTEXTTRANSFORMATION";
        }
    }
    IFC4X32.IfcTextTransformation = IfcTextTransformation;
    class IfcThermalAdmittanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALADMITTANCEMEASURE";
        }
    }
    IFC4X32.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;
    class IfcThermalConductivityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALCONDUCTIVITYMEASURE";
        }
    }
    IFC4X32.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;
    class IfcThermalExpansionCoefficientMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALEXPANSIONCOEFFICIENTMEASURE";
        }
    }
    IFC4X32.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;
    class IfcThermalResistanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALRESISTANCEMEASURE";
        }
    }
    IFC4X32.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;
    class IfcThermalTransmittanceMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMALTRANSMITTANCEMEASURE";
        }
    }
    IFC4X32.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;
    class IfcThermodynamicTemperatureMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTHERMODYNAMICTEMPERATUREMEASURE";
        }
    }
    IFC4X32.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;
    class IfcTime {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCTIME";
        }
    }
    IFC4X32.IfcTime = IfcTime;
    class IfcTimeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTIMEMEASURE";
        }
    }
    IFC4X32.IfcTimeMeasure = IfcTimeMeasure;
    class IfcTimeStamp extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 10;
            this.name = "IFCTIMESTAMP";
        }
    }
    IFC4X32.IfcTimeStamp = IfcTimeStamp;
    class IfcTorqueMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCTORQUEMEASURE";
        }
    }
    IFC4X32.IfcTorqueMeasure = IfcTorqueMeasure;
    class IfcURIReference {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCURIREFERENCE";
        }
    }
    IFC4X32.IfcURIReference = IfcURIReference;
    class IfcVaporPermeabilityMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCVAPORPERMEABILITYMEASURE";
        }
    }
    IFC4X32.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;
    class IfcVolumeMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCVOLUMEMEASURE";
        }
    }
    IFC4X32.IfcVolumeMeasure = IfcVolumeMeasure;
    class IfcVolumetricFlowRateMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCVOLUMETRICFLOWRATEMEASURE";
        }
    }
    IFC4X32.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;
    class IfcWarpingConstantMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCWARPINGCONSTANTMEASURE";
        }
    }
    IFC4X32.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;
    class IfcWarpingMomentMeasure extends $3b8da494b8e92f36$export$2e483f5afea275bb {
        constructor(){
            super(...arguments);
            this.type = 4;
            this.name = "IFCWARPINGMOMENTMEASURE";
        }
    }
    IFC4X32.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;
    class IfcWellKnownTextLiteral {
        constructor(value){
            this.value = value;
            this.type = 1;
            this.name = "IFCWELLKNOWNTEXTLITERAL";
        }
    }
    IFC4X32.IfcWellKnownTextLiteral = IfcWellKnownTextLiteral;
    class IfcActionRequestTypeEnum {
        static{
            this.EMAIL = {
                type: 3,
                value: "EMAIL"
            };
        }
        static{
            this.FAX = {
                type: 3,
                value: "FAX"
            };
        }
        static{
            this.PHONE = {
                type: 3,
                value: "PHONE"
            };
        }
        static{
            this.POST = {
                type: 3,
                value: "POST"
            };
        }
        static{
            this.VERBAL = {
                type: 3,
                value: "VERBAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcActionRequestTypeEnum = IfcActionRequestTypeEnum;
    class IfcActionSourceTypeEnum {
        static{
            this.BRAKES = {
                type: 3,
                value: "BRAKES"
            };
        }
        static{
            this.BUOYANCY = {
                type: 3,
                value: "BUOYANCY"
            };
        }
        static{
            this.COMPLETION_G1 = {
                type: 3,
                value: "COMPLETION_G1"
            };
        }
        static{
            this.CREEP = {
                type: 3,
                value: "CREEP"
            };
        }
        static{
            this.CURRENT = {
                type: 3,
                value: "CURRENT"
            };
        }
        static{
            this.DEAD_LOAD_G = {
                type: 3,
                value: "DEAD_LOAD_G"
            };
        }
        static{
            this.EARTHQUAKE_E = {
                type: 3,
                value: "EARTHQUAKE_E"
            };
        }
        static{
            this.ERECTION = {
                type: 3,
                value: "ERECTION"
            };
        }
        static{
            this.FIRE = {
                type: 3,
                value: "FIRE"
            };
        }
        static{
            this.ICE = {
                type: 3,
                value: "ICE"
            };
        }
        static{
            this.IMPACT = {
                type: 3,
                value: "IMPACT"
            };
        }
        static{
            this.IMPULSE = {
                type: 3,
                value: "IMPULSE"
            };
        }
        static{
            this.LACK_OF_FIT = {
                type: 3,
                value: "LACK_OF_FIT"
            };
        }
        static{
            this.LIVE_LOAD_Q = {
                type: 3,
                value: "LIVE_LOAD_Q"
            };
        }
        static{
            this.PRESTRESSING_P = {
                type: 3,
                value: "PRESTRESSING_P"
            };
        }
        static{
            this.PROPPING = {
                type: 3,
                value: "PROPPING"
            };
        }
        static{
            this.RAIN = {
                type: 3,
                value: "RAIN"
            };
        }
        static{
            this.SETTLEMENT_U = {
                type: 3,
                value: "SETTLEMENT_U"
            };
        }
        static{
            this.SHRINKAGE = {
                type: 3,
                value: "SHRINKAGE"
            };
        }
        static{
            this.SNOW_S = {
                type: 3,
                value: "SNOW_S"
            };
        }
        static{
            this.SYSTEM_IMPERFECTION = {
                type: 3,
                value: "SYSTEM_IMPERFECTION"
            };
        }
        static{
            this.TEMPERATURE_T = {
                type: 3,
                value: "TEMPERATURE_T"
            };
        }
        static{
            this.TRANSPORT = {
                type: 3,
                value: "TRANSPORT"
            };
        }
        static{
            this.WAVE = {
                type: 3,
                value: "WAVE"
            };
        }
        static{
            this.WIND_W = {
                type: 3,
                value: "WIND_W"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;
    class IfcActionTypeEnum {
        static{
            this.EXTRAORDINARY_A = {
                type: 3,
                value: "EXTRAORDINARY_A"
            };
        }
        static{
            this.PERMANENT_G = {
                type: 3,
                value: "PERMANENT_G"
            };
        }
        static{
            this.VARIABLE_Q = {
                type: 3,
                value: "VARIABLE_Q"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcActionTypeEnum = IfcActionTypeEnum;
    class IfcActuatorTypeEnum {
        static{
            this.ELECTRICACTUATOR = {
                type: 3,
                value: "ELECTRICACTUATOR"
            };
        }
        static{
            this.HANDOPERATEDACTUATOR = {
                type: 3,
                value: "HANDOPERATEDACTUATOR"
            };
        }
        static{
            this.HYDRAULICACTUATOR = {
                type: 3,
                value: "HYDRAULICACTUATOR"
            };
        }
        static{
            this.PNEUMATICACTUATOR = {
                type: 3,
                value: "PNEUMATICACTUATOR"
            };
        }
        static{
            this.THERMOSTATICACTUATOR = {
                type: 3,
                value: "THERMOSTATICACTUATOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcActuatorTypeEnum = IfcActuatorTypeEnum;
    class IfcAddressTypeEnum {
        static{
            this.DISTRIBUTIONPOINT = {
                type: 3,
                value: "DISTRIBUTIONPOINT"
            };
        }
        static{
            this.HOME = {
                type: 3,
                value: "HOME"
            };
        }
        static{
            this.OFFICE = {
                type: 3,
                value: "OFFICE"
            };
        }
        static{
            this.SITE = {
                type: 3,
                value: "SITE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC4X32.IfcAddressTypeEnum = IfcAddressTypeEnum;
    class IfcAirTerminalBoxTypeEnum {
        static{
            this.CONSTANTFLOW = {
                type: 3,
                value: "CONSTANTFLOW"
            };
        }
        static{
            this.VARIABLEFLOWPRESSUREDEPENDANT = {
                type: 3,
                value: "VARIABLEFLOWPRESSUREDEPENDANT"
            };
        }
        static{
            this.VARIABLEFLOWPRESSUREINDEPENDANT = {
                type: 3,
                value: "VARIABLEFLOWPRESSUREINDEPENDANT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;
    class IfcAirTerminalTypeEnum {
        static{
            this.DIFFUSER = {
                type: 3,
                value: "DIFFUSER"
            };
        }
        static{
            this.GRILLE = {
                type: 3,
                value: "GRILLE"
            };
        }
        static{
            this.LOUVRE = {
                type: 3,
                value: "LOUVRE"
            };
        }
        static{
            this.REGISTER = {
                type: 3,
                value: "REGISTER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;
    class IfcAirToAirHeatRecoveryTypeEnum {
        static{
            this.FIXEDPLATECOUNTERFLOWEXCHANGER = {
                type: 3,
                value: "FIXEDPLATECOUNTERFLOWEXCHANGER"
            };
        }
        static{
            this.FIXEDPLATECROSSFLOWEXCHANGER = {
                type: 3,
                value: "FIXEDPLATECROSSFLOWEXCHANGER"
            };
        }
        static{
            this.FIXEDPLATEPARALLELFLOWEXCHANGER = {
                type: 3,
                value: "FIXEDPLATEPARALLELFLOWEXCHANGER"
            };
        }
        static{
            this.HEATPIPE = {
                type: 3,
                value: "HEATPIPE"
            };
        }
        static{
            this.ROTARYWHEEL = {
                type: 3,
                value: "ROTARYWHEEL"
            };
        }
        static{
            this.RUNAROUNDCOILLOOP = {
                type: 3,
                value: "RUNAROUNDCOILLOOP"
            };
        }
        static{
            this.THERMOSIPHONCOILTYPEHEATEXCHANGERS = {
                type: 3,
                value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS"
            };
        }
        static{
            this.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = {
                type: 3,
                value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS"
            };
        }
        static{
            this.TWINTOWERENTHALPYRECOVERYLOOPS = {
                type: 3,
                value: "TWINTOWERENTHALPYRECOVERYLOOPS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;
    class IfcAlarmTypeEnum {
        static{
            this.BELL = {
                type: 3,
                value: "BELL"
            };
        }
        static{
            this.BREAKGLASSBUTTON = {
                type: 3,
                value: "BREAKGLASSBUTTON"
            };
        }
        static{
            this.LIGHT = {
                type: 3,
                value: "LIGHT"
            };
        }
        static{
            this.MANUALPULLBOX = {
                type: 3,
                value: "MANUALPULLBOX"
            };
        }
        static{
            this.RAILWAYCROCODILE = {
                type: 3,
                value: "RAILWAYCROCODILE"
            };
        }
        static{
            this.RAILWAYDETONATOR = {
                type: 3,
                value: "RAILWAYDETONATOR"
            };
        }
        static{
            this.SIREN = {
                type: 3,
                value: "SIREN"
            };
        }
        static{
            this.WHISTLE = {
                type: 3,
                value: "WHISTLE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAlarmTypeEnum = IfcAlarmTypeEnum;
    class IfcAlignmentCantSegmentTypeEnum {
        static{
            this.BLOSSCURVE = {
                type: 3,
                value: "BLOSSCURVE"
            };
        }
        static{
            this.CONSTANTCANT = {
                type: 3,
                value: "CONSTANTCANT"
            };
        }
        static{
            this.COSINECURVE = {
                type: 3,
                value: "COSINECURVE"
            };
        }
        static{
            this.HELMERTCURVE = {
                type: 3,
                value: "HELMERTCURVE"
            };
        }
        static{
            this.LINEARTRANSITION = {
                type: 3,
                value: "LINEARTRANSITION"
            };
        }
        static{
            this.SINECURVE = {
                type: 3,
                value: "SINECURVE"
            };
        }
        static{
            this.VIENNESEBEND = {
                type: 3,
                value: "VIENNESEBEND"
            };
        }
    }
    IFC4X32.IfcAlignmentCantSegmentTypeEnum = IfcAlignmentCantSegmentTypeEnum;
    class IfcAlignmentHorizontalSegmentTypeEnum {
        static{
            this.BLOSSCURVE = {
                type: 3,
                value: "BLOSSCURVE"
            };
        }
        static{
            this.CIRCULARARC = {
                type: 3,
                value: "CIRCULARARC"
            };
        }
        static{
            this.CLOTHOID = {
                type: 3,
                value: "CLOTHOID"
            };
        }
        static{
            this.COSINECURVE = {
                type: 3,
                value: "COSINECURVE"
            };
        }
        static{
            this.CUBIC = {
                type: 3,
                value: "CUBIC"
            };
        }
        static{
            this.HELMERTCURVE = {
                type: 3,
                value: "HELMERTCURVE"
            };
        }
        static{
            this.LINE = {
                type: 3,
                value: "LINE"
            };
        }
        static{
            this.SINECURVE = {
                type: 3,
                value: "SINECURVE"
            };
        }
        static{
            this.VIENNESEBEND = {
                type: 3,
                value: "VIENNESEBEND"
            };
        }
    }
    IFC4X32.IfcAlignmentHorizontalSegmentTypeEnum = IfcAlignmentHorizontalSegmentTypeEnum;
    class IfcAlignmentTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAlignmentTypeEnum = IfcAlignmentTypeEnum;
    class IfcAlignmentVerticalSegmentTypeEnum {
        static{
            this.CIRCULARARC = {
                type: 3,
                value: "CIRCULARARC"
            };
        }
        static{
            this.CLOTHOID = {
                type: 3,
                value: "CLOTHOID"
            };
        }
        static{
            this.CONSTANTGRADIENT = {
                type: 3,
                value: "CONSTANTGRADIENT"
            };
        }
        static{
            this.PARABOLICARC = {
                type: 3,
                value: "PARABOLICARC"
            };
        }
    }
    IFC4X32.IfcAlignmentVerticalSegmentTypeEnum = IfcAlignmentVerticalSegmentTypeEnum;
    class IfcAnalysisModelTypeEnum {
        static{
            this.IN_PLANE_LOADING_2D = {
                type: 3,
                value: "IN_PLANE_LOADING_2D"
            };
        }
        static{
            this.LOADING_3D = {
                type: 3,
                value: "LOADING_3D"
            };
        }
        static{
            this.OUT_PLANE_LOADING_2D = {
                type: 3,
                value: "OUT_PLANE_LOADING_2D"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;
    class IfcAnalysisTheoryTypeEnum {
        static{
            this.FIRST_ORDER_THEORY = {
                type: 3,
                value: "FIRST_ORDER_THEORY"
            };
        }
        static{
            this.FULL_NONLINEAR_THEORY = {
                type: 3,
                value: "FULL_NONLINEAR_THEORY"
            };
        }
        static{
            this.SECOND_ORDER_THEORY = {
                type: 3,
                value: "SECOND_ORDER_THEORY"
            };
        }
        static{
            this.THIRD_ORDER_THEORY = {
                type: 3,
                value: "THIRD_ORDER_THEORY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;
    class IfcAnnotationTypeEnum {
        static{
            this.CONTOURLINE = {
                type: 3,
                value: "CONTOURLINE"
            };
        }
        static{
            this.DIMENSION = {
                type: 3,
                value: "DIMENSION"
            };
        }
        static{
            this.ISOBAR = {
                type: 3,
                value: "ISOBAR"
            };
        }
        static{
            this.ISOLUX = {
                type: 3,
                value: "ISOLUX"
            };
        }
        static{
            this.ISOTHERM = {
                type: 3,
                value: "ISOTHERM"
            };
        }
        static{
            this.LEADER = {
                type: 3,
                value: "LEADER"
            };
        }
        static{
            this.SURVEY = {
                type: 3,
                value: "SURVEY"
            };
        }
        static{
            this.SYMBOL = {
                type: 3,
                value: "SYMBOL"
            };
        }
        static{
            this.TEXT = {
                type: 3,
                value: "TEXT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAnnotationTypeEnum = IfcAnnotationTypeEnum;
    class IfcArithmeticOperatorEnum {
        static{
            this.ADD = {
                type: 3,
                value: "ADD"
            };
        }
        static{
            this.DIVIDE = {
                type: 3,
                value: "DIVIDE"
            };
        }
        static{
            this.MODULO = {
                type: 3,
                value: "MODULO"
            };
        }
        static{
            this.MULTIPLY = {
                type: 3,
                value: "MULTIPLY"
            };
        }
        static{
            this.SUBTRACT = {
                type: 3,
                value: "SUBTRACT"
            };
        }
    }
    IFC4X32.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;
    class IfcAssemblyPlaceEnum {
        static{
            this.FACTORY = {
                type: 3,
                value: "FACTORY"
            };
        }
        static{
            this.SITE = {
                type: 3,
                value: "SITE"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;
    class IfcAudioVisualApplianceTypeEnum {
        static{
            this.AMPLIFIER = {
                type: 3,
                value: "AMPLIFIER"
            };
        }
        static{
            this.CAMERA = {
                type: 3,
                value: "CAMERA"
            };
        }
        static{
            this.COMMUNICATIONTERMINAL = {
                type: 3,
                value: "COMMUNICATIONTERMINAL"
            };
        }
        static{
            this.DISPLAY = {
                type: 3,
                value: "DISPLAY"
            };
        }
        static{
            this.MICROPHONE = {
                type: 3,
                value: "MICROPHONE"
            };
        }
        static{
            this.PLAYER = {
                type: 3,
                value: "PLAYER"
            };
        }
        static{
            this.PROJECTOR = {
                type: 3,
                value: "PROJECTOR"
            };
        }
        static{
            this.RECEIVER = {
                type: 3,
                value: "RECEIVER"
            };
        }
        static{
            this.RECORDINGEQUIPMENT = {
                type: 3,
                value: "RECORDINGEQUIPMENT"
            };
        }
        static{
            this.SPEAKER = {
                type: 3,
                value: "SPEAKER"
            };
        }
        static{
            this.SWITCHER = {
                type: 3,
                value: "SWITCHER"
            };
        }
        static{
            this.TELEPHONE = {
                type: 3,
                value: "TELEPHONE"
            };
        }
        static{
            this.TUNER = {
                type: 3,
                value: "TUNER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcAudioVisualApplianceTypeEnum = IfcAudioVisualApplianceTypeEnum;
    class IfcBSplineCurveForm {
        static{
            this.CIRCULAR_ARC = {
                type: 3,
                value: "CIRCULAR_ARC"
            };
        }
        static{
            this.ELLIPTIC_ARC = {
                type: 3,
                value: "ELLIPTIC_ARC"
            };
        }
        static{
            this.HYPERBOLIC_ARC = {
                type: 3,
                value: "HYPERBOLIC_ARC"
            };
        }
        static{
            this.PARABOLIC_ARC = {
                type: 3,
                value: "PARABOLIC_ARC"
            };
        }
        static{
            this.POLYLINE_FORM = {
                type: 3,
                value: "POLYLINE_FORM"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC4X32.IfcBSplineCurveForm = IfcBSplineCurveForm;
    class IfcBSplineSurfaceForm {
        static{
            this.CONICAL_SURF = {
                type: 3,
                value: "CONICAL_SURF"
            };
        }
        static{
            this.CYLINDRICAL_SURF = {
                type: 3,
                value: "CYLINDRICAL_SURF"
            };
        }
        static{
            this.GENERALISED_CONE = {
                type: 3,
                value: "GENERALISED_CONE"
            };
        }
        static{
            this.PLANE_SURF = {
                type: 3,
                value: "PLANE_SURF"
            };
        }
        static{
            this.QUADRIC_SURF = {
                type: 3,
                value: "QUADRIC_SURF"
            };
        }
        static{
            this.RULED_SURF = {
                type: 3,
                value: "RULED_SURF"
            };
        }
        static{
            this.SPHERICAL_SURF = {
                type: 3,
                value: "SPHERICAL_SURF"
            };
        }
        static{
            this.SURF_OF_LINEAR_EXTRUSION = {
                type: 3,
                value: "SURF_OF_LINEAR_EXTRUSION"
            };
        }
        static{
            this.SURF_OF_REVOLUTION = {
                type: 3,
                value: "SURF_OF_REVOLUTION"
            };
        }
        static{
            this.TOROIDAL_SURF = {
                type: 3,
                value: "TOROIDAL_SURF"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC4X32.IfcBSplineSurfaceForm = IfcBSplineSurfaceForm;
    class IfcBeamTypeEnum {
        static{
            this.BEAM = {
                type: 3,
                value: "BEAM"
            };
        }
        static{
            this.CORNICE = {
                type: 3,
                value: "CORNICE"
            };
        }
        static{
            this.DIAPHRAGM = {
                type: 3,
                value: "DIAPHRAGM"
            };
        }
        static{
            this.EDGEBEAM = {
                type: 3,
                value: "EDGEBEAM"
            };
        }
        static{
            this.GIRDER_SEGMENT = {
                type: 3,
                value: "GIRDER_SEGMENT"
            };
        }
        static{
            this.HATSTONE = {
                type: 3,
                value: "HATSTONE"
            };
        }
        static{
            this.HOLLOWCORE = {
                type: 3,
                value: "HOLLOWCORE"
            };
        }
        static{
            this.JOIST = {
                type: 3,
                value: "JOIST"
            };
        }
        static{
            this.LINTEL = {
                type: 3,
                value: "LINTEL"
            };
        }
        static{
            this.PIERCAP = {
                type: 3,
                value: "PIERCAP"
            };
        }
        static{
            this.SPANDREL = {
                type: 3,
                value: "SPANDREL"
            };
        }
        static{
            this.T_BEAM = {
                type: 3,
                value: "T_BEAM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBeamTypeEnum = IfcBeamTypeEnum;
    class IfcBearingTypeEnum {
        static{
            this.CYLINDRICAL = {
                type: 3,
                value: "CYLINDRICAL"
            };
        }
        static{
            this.DISK = {
                type: 3,
                value: "DISK"
            };
        }
        static{
            this.ELASTOMERIC = {
                type: 3,
                value: "ELASTOMERIC"
            };
        }
        static{
            this.GUIDE = {
                type: 3,
                value: "GUIDE"
            };
        }
        static{
            this.POT = {
                type: 3,
                value: "POT"
            };
        }
        static{
            this.ROCKER = {
                type: 3,
                value: "ROCKER"
            };
        }
        static{
            this.ROLLER = {
                type: 3,
                value: "ROLLER"
            };
        }
        static{
            this.SPHERICAL = {
                type: 3,
                value: "SPHERICAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBearingTypeEnum = IfcBearingTypeEnum;
    class IfcBenchmarkEnum {
        static{
            this.EQUALTO = {
                type: 3,
                value: "EQUALTO"
            };
        }
        static{
            this.GREATERTHAN = {
                type: 3,
                value: "GREATERTHAN"
            };
        }
        static{
            this.GREATERTHANOREQUALTO = {
                type: 3,
                value: "GREATERTHANOREQUALTO"
            };
        }
        static{
            this.INCLUDEDIN = {
                type: 3,
                value: "INCLUDEDIN"
            };
        }
        static{
            this.INCLUDES = {
                type: 3,
                value: "INCLUDES"
            };
        }
        static{
            this.LESSTHAN = {
                type: 3,
                value: "LESSTHAN"
            };
        }
        static{
            this.LESSTHANOREQUALTO = {
                type: 3,
                value: "LESSTHANOREQUALTO"
            };
        }
        static{
            this.NOTEQUALTO = {
                type: 3,
                value: "NOTEQUALTO"
            };
        }
        static{
            this.NOTINCLUDEDIN = {
                type: 3,
                value: "NOTINCLUDEDIN"
            };
        }
        static{
            this.NOTINCLUDES = {
                type: 3,
                value: "NOTINCLUDES"
            };
        }
    }
    IFC4X32.IfcBenchmarkEnum = IfcBenchmarkEnum;
    class IfcBoilerTypeEnum {
        static{
            this.STEAM = {
                type: 3,
                value: "STEAM"
            };
        }
        static{
            this.WATER = {
                type: 3,
                value: "WATER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBoilerTypeEnum = IfcBoilerTypeEnum;
    class IfcBooleanOperator {
        static{
            this.DIFFERENCE = {
                type: 3,
                value: "DIFFERENCE"
            };
        }
        static{
            this.INTERSECTION = {
                type: 3,
                value: "INTERSECTION"
            };
        }
        static{
            this.UNION = {
                type: 3,
                value: "UNION"
            };
        }
    }
    IFC4X32.IfcBooleanOperator = IfcBooleanOperator;
    class IfcBridgePartTypeEnum {
        static{
            this.ABUTMENT = {
                type: 3,
                value: "ABUTMENT"
            };
        }
        static{
            this.DECK = {
                type: 3,
                value: "DECK"
            };
        }
        static{
            this.DECK_SEGMENT = {
                type: 3,
                value: "DECK_SEGMENT"
            };
        }
        static{
            this.FOUNDATION = {
                type: 3,
                value: "FOUNDATION"
            };
        }
        static{
            this.PIER = {
                type: 3,
                value: "PIER"
            };
        }
        static{
            this.PIER_SEGMENT = {
                type: 3,
                value: "PIER_SEGMENT"
            };
        }
        static{
            this.PYLON = {
                type: 3,
                value: "PYLON"
            };
        }
        static{
            this.SUBSTRUCTURE = {
                type: 3,
                value: "SUBSTRUCTURE"
            };
        }
        static{
            this.SUPERSTRUCTURE = {
                type: 3,
                value: "SUPERSTRUCTURE"
            };
        }
        static{
            this.SURFACESTRUCTURE = {
                type: 3,
                value: "SURFACESTRUCTURE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBridgePartTypeEnum = IfcBridgePartTypeEnum;
    class IfcBridgeTypeEnum {
        static{
            this.ARCHED = {
                type: 3,
                value: "ARCHED"
            };
        }
        static{
            this.CABLE_STAYED = {
                type: 3,
                value: "CABLE_STAYED"
            };
        }
        static{
            this.CANTILEVER = {
                type: 3,
                value: "CANTILEVER"
            };
        }
        static{
            this.CULVERT = {
                type: 3,
                value: "CULVERT"
            };
        }
        static{
            this.FRAMEWORK = {
                type: 3,
                value: "FRAMEWORK"
            };
        }
        static{
            this.GIRDER = {
                type: 3,
                value: "GIRDER"
            };
        }
        static{
            this.SUSPENSION = {
                type: 3,
                value: "SUSPENSION"
            };
        }
        static{
            this.TRUSS = {
                type: 3,
                value: "TRUSS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBridgeTypeEnum = IfcBridgeTypeEnum;
    class IfcBuildingElementPartTypeEnum {
        static{
            this.APRON = {
                type: 3,
                value: "APRON"
            };
        }
        static{
            this.ARMOURUNIT = {
                type: 3,
                value: "ARMOURUNIT"
            };
        }
        static{
            this.INSULATION = {
                type: 3,
                value: "INSULATION"
            };
        }
        static{
            this.PRECASTPANEL = {
                type: 3,
                value: "PRECASTPANEL"
            };
        }
        static{
            this.SAFETYCAGE = {
                type: 3,
                value: "SAFETYCAGE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBuildingElementPartTypeEnum = IfcBuildingElementPartTypeEnum;
    class IfcBuildingElementProxyTypeEnum {
        static{
            this.COMPLEX = {
                type: 3,
                value: "COMPLEX"
            };
        }
        static{
            this.ELEMENT = {
                type: 3,
                value: "ELEMENT"
            };
        }
        static{
            this.PARTIAL = {
                type: 3,
                value: "PARTIAL"
            };
        }
        static{
            this.PROVISIONFORSPACE = {
                type: 3,
                value: "PROVISIONFORSPACE"
            };
        }
        static{
            this.PROVISIONFORVOID = {
                type: 3,
                value: "PROVISIONFORVOID"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;
    class IfcBuildingSystemTypeEnum {
        static{
            this.FENESTRATION = {
                type: 3,
                value: "FENESTRATION"
            };
        }
        static{
            this.FOUNDATION = {
                type: 3,
                value: "FOUNDATION"
            };
        }
        static{
            this.LOADBEARING = {
                type: 3,
                value: "LOADBEARING"
            };
        }
        static{
            this.OUTERSHELL = {
                type: 3,
                value: "OUTERSHELL"
            };
        }
        static{
            this.SHADING = {
                type: 3,
                value: "SHADING"
            };
        }
        static{
            this.TRANSPORT = {
                type: 3,
                value: "TRANSPORT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBuildingSystemTypeEnum = IfcBuildingSystemTypeEnum;
    class IfcBuiltSystemTypeEnum {
        static{
            this.EROSIONPREVENTION = {
                type: 3,
                value: "EROSIONPREVENTION"
            };
        }
        static{
            this.FENESTRATION = {
                type: 3,
                value: "FENESTRATION"
            };
        }
        static{
            this.FOUNDATION = {
                type: 3,
                value: "FOUNDATION"
            };
        }
        static{
            this.LOADBEARING = {
                type: 3,
                value: "LOADBEARING"
            };
        }
        static{
            this.MOORING = {
                type: 3,
                value: "MOORING"
            };
        }
        static{
            this.OUTERSHELL = {
                type: 3,
                value: "OUTERSHELL"
            };
        }
        static{
            this.PRESTRESSING = {
                type: 3,
                value: "PRESTRESSING"
            };
        }
        static{
            this.RAILWAYLINE = {
                type: 3,
                value: "RAILWAYLINE"
            };
        }
        static{
            this.RAILWAYTRACK = {
                type: 3,
                value: "RAILWAYTRACK"
            };
        }
        static{
            this.REINFORCING = {
                type: 3,
                value: "REINFORCING"
            };
        }
        static{
            this.SHADING = {
                type: 3,
                value: "SHADING"
            };
        }
        static{
            this.TRACKCIRCUIT = {
                type: 3,
                value: "TRACKCIRCUIT"
            };
        }
        static{
            this.TRANSPORT = {
                type: 3,
                value: "TRANSPORT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBuiltSystemTypeEnum = IfcBuiltSystemTypeEnum;
    class IfcBurnerTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcBurnerTypeEnum = IfcBurnerTypeEnum;
    class IfcCableCarrierFittingTypeEnum {
        static{
            this.BEND = {
                type: 3,
                value: "BEND"
            };
        }
        static{
            this.CONNECTOR = {
                type: 3,
                value: "CONNECTOR"
            };
        }
        static{
            this.CROSS = {
                type: 3,
                value: "CROSS"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.REDUCER = {
                type: 3,
                value: "REDUCER"
            };
        }
        static{
            this.TEE = {
                type: 3,
                value: "TEE"
            };
        }
        static{
            this.TRANSITION = {
                type: 3,
                value: "TRANSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;
    class IfcCableCarrierSegmentTypeEnum {
        static{
            this.CABLEBRACKET = {
                type: 3,
                value: "CABLEBRACKET"
            };
        }
        static{
            this.CABLELADDERSEGMENT = {
                type: 3,
                value: "CABLELADDERSEGMENT"
            };
        }
        static{
            this.CABLETRAYSEGMENT = {
                type: 3,
                value: "CABLETRAYSEGMENT"
            };
        }
        static{
            this.CABLETRUNKINGSEGMENT = {
                type: 3,
                value: "CABLETRUNKINGSEGMENT"
            };
        }
        static{
            this.CATENARYWIRE = {
                type: 3,
                value: "CATENARYWIRE"
            };
        }
        static{
            this.CONDUITSEGMENT = {
                type: 3,
                value: "CONDUITSEGMENT"
            };
        }
        static{
            this.DROPPER = {
                type: 3,
                value: "DROPPER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;
    class IfcCableFittingTypeEnum {
        static{
            this.CONNECTOR = {
                type: 3,
                value: "CONNECTOR"
            };
        }
        static{
            this.ENTRY = {
                type: 3,
                value: "ENTRY"
            };
        }
        static{
            this.EXIT = {
                type: 3,
                value: "EXIT"
            };
        }
        static{
            this.FANOUT = {
                type: 3,
                value: "FANOUT"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.TRANSITION = {
                type: 3,
                value: "TRANSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCableFittingTypeEnum = IfcCableFittingTypeEnum;
    class IfcCableSegmentTypeEnum {
        static{
            this.BUSBARSEGMENT = {
                type: 3,
                value: "BUSBARSEGMENT"
            };
        }
        static{
            this.CABLESEGMENT = {
                type: 3,
                value: "CABLESEGMENT"
            };
        }
        static{
            this.CONDUCTORSEGMENT = {
                type: 3,
                value: "CONDUCTORSEGMENT"
            };
        }
        static{
            this.CONTACTWIRESEGMENT = {
                type: 3,
                value: "CONTACTWIRESEGMENT"
            };
        }
        static{
            this.CORESEGMENT = {
                type: 3,
                value: "CORESEGMENT"
            };
        }
        static{
            this.FIBERSEGMENT = {
                type: 3,
                value: "FIBERSEGMENT"
            };
        }
        static{
            this.FIBERTUBE = {
                type: 3,
                value: "FIBERTUBE"
            };
        }
        static{
            this.OPTICALCABLESEGMENT = {
                type: 3,
                value: "OPTICALCABLESEGMENT"
            };
        }
        static{
            this.STITCHWIRE = {
                type: 3,
                value: "STITCHWIRE"
            };
        }
        static{
            this.WIREPAIRSEGMENT = {
                type: 3,
                value: "WIREPAIRSEGMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;
    class IfcCaissonFoundationTypeEnum {
        static{
            this.CAISSON = {
                type: 3,
                value: "CAISSON"
            };
        }
        static{
            this.WELL = {
                type: 3,
                value: "WELL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCaissonFoundationTypeEnum = IfcCaissonFoundationTypeEnum;
    class IfcChangeActionEnum {
        static{
            this.ADDED = {
                type: 3,
                value: "ADDED"
            };
        }
        static{
            this.DELETED = {
                type: 3,
                value: "DELETED"
            };
        }
        static{
            this.MODIFIED = {
                type: 3,
                value: "MODIFIED"
            };
        }
        static{
            this.NOCHANGE = {
                type: 3,
                value: "NOCHANGE"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcChangeActionEnum = IfcChangeActionEnum;
    class IfcChillerTypeEnum {
        static{
            this.AIRCOOLED = {
                type: 3,
                value: "AIRCOOLED"
            };
        }
        static{
            this.HEATRECOVERY = {
                type: 3,
                value: "HEATRECOVERY"
            };
        }
        static{
            this.WATERCOOLED = {
                type: 3,
                value: "WATERCOOLED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcChillerTypeEnum = IfcChillerTypeEnum;
    class IfcChimneyTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcChimneyTypeEnum = IfcChimneyTypeEnum;
    class IfcCoilTypeEnum {
        static{
            this.DXCOOLINGCOIL = {
                type: 3,
                value: "DXCOOLINGCOIL"
            };
        }
        static{
            this.ELECTRICHEATINGCOIL = {
                type: 3,
                value: "ELECTRICHEATINGCOIL"
            };
        }
        static{
            this.GASHEATINGCOIL = {
                type: 3,
                value: "GASHEATINGCOIL"
            };
        }
        static{
            this.HYDRONICCOIL = {
                type: 3,
                value: "HYDRONICCOIL"
            };
        }
        static{
            this.STEAMHEATINGCOIL = {
                type: 3,
                value: "STEAMHEATINGCOIL"
            };
        }
        static{
            this.WATERCOOLINGCOIL = {
                type: 3,
                value: "WATERCOOLINGCOIL"
            };
        }
        static{
            this.WATERHEATINGCOIL = {
                type: 3,
                value: "WATERHEATINGCOIL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCoilTypeEnum = IfcCoilTypeEnum;
    class IfcColumnTypeEnum {
        static{
            this.COLUMN = {
                type: 3,
                value: "COLUMN"
            };
        }
        static{
            this.PIERSTEM = {
                type: 3,
                value: "PIERSTEM"
            };
        }
        static{
            this.PIERSTEM_SEGMENT = {
                type: 3,
                value: "PIERSTEM_SEGMENT"
            };
        }
        static{
            this.PILASTER = {
                type: 3,
                value: "PILASTER"
            };
        }
        static{
            this.STANDCOLUMN = {
                type: 3,
                value: "STANDCOLUMN"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcColumnTypeEnum = IfcColumnTypeEnum;
    class IfcCommunicationsApplianceTypeEnum {
        static{
            this.ANTENNA = {
                type: 3,
                value: "ANTENNA"
            };
        }
        static{
            this.AUTOMATON = {
                type: 3,
                value: "AUTOMATON"
            };
        }
        static{
            this.COMPUTER = {
                type: 3,
                value: "COMPUTER"
            };
        }
        static{
            this.FAX = {
                type: 3,
                value: "FAX"
            };
        }
        static{
            this.GATEWAY = {
                type: 3,
                value: "GATEWAY"
            };
        }
        static{
            this.INTELLIGENTPERIPHERAL = {
                type: 3,
                value: "INTELLIGENTPERIPHERAL"
            };
        }
        static{
            this.IPNETWORKEQUIPMENT = {
                type: 3,
                value: "IPNETWORKEQUIPMENT"
            };
        }
        static{
            this.LINESIDEELECTRONICUNIT = {
                type: 3,
                value: "LINESIDEELECTRONICUNIT"
            };
        }
        static{
            this.MODEM = {
                type: 3,
                value: "MODEM"
            };
        }
        static{
            this.NETWORKAPPLIANCE = {
                type: 3,
                value: "NETWORKAPPLIANCE"
            };
        }
        static{
            this.NETWORKBRIDGE = {
                type: 3,
                value: "NETWORKBRIDGE"
            };
        }
        static{
            this.NETWORKHUB = {
                type: 3,
                value: "NETWORKHUB"
            };
        }
        static{
            this.OPTICALLINETERMINAL = {
                type: 3,
                value: "OPTICALLINETERMINAL"
            };
        }
        static{
            this.OPTICALNETWORKUNIT = {
                type: 3,
                value: "OPTICALNETWORKUNIT"
            };
        }
        static{
            this.PRINTER = {
                type: 3,
                value: "PRINTER"
            };
        }
        static{
            this.RADIOBLOCKCENTER = {
                type: 3,
                value: "RADIOBLOCKCENTER"
            };
        }
        static{
            this.REPEATER = {
                type: 3,
                value: "REPEATER"
            };
        }
        static{
            this.ROUTER = {
                type: 3,
                value: "ROUTER"
            };
        }
        static{
            this.SCANNER = {
                type: 3,
                value: "SCANNER"
            };
        }
        static{
            this.TELECOMMAND = {
                type: 3,
                value: "TELECOMMAND"
            };
        }
        static{
            this.TELEPHONYEXCHANGE = {
                type: 3,
                value: "TELEPHONYEXCHANGE"
            };
        }
        static{
            this.TRANSITIONCOMPONENT = {
                type: 3,
                value: "TRANSITIONCOMPONENT"
            };
        }
        static{
            this.TRANSPONDER = {
                type: 3,
                value: "TRANSPONDER"
            };
        }
        static{
            this.TRANSPORTEQUIPMENT = {
                type: 3,
                value: "TRANSPORTEQUIPMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCommunicationsApplianceTypeEnum = IfcCommunicationsApplianceTypeEnum;
    class IfcComplexPropertyTemplateTypeEnum {
        static{
            this.P_COMPLEX = {
                type: 3,
                value: "P_COMPLEX"
            };
        }
        static{
            this.Q_COMPLEX = {
                type: 3,
                value: "Q_COMPLEX"
            };
        }
    }
    IFC4X32.IfcComplexPropertyTemplateTypeEnum = IfcComplexPropertyTemplateTypeEnum;
    class IfcCompressorTypeEnum {
        static{
            this.BOOSTER = {
                type: 3,
                value: "BOOSTER"
            };
        }
        static{
            this.DYNAMIC = {
                type: 3,
                value: "DYNAMIC"
            };
        }
        static{
            this.HERMETIC = {
                type: 3,
                value: "HERMETIC"
            };
        }
        static{
            this.OPENTYPE = {
                type: 3,
                value: "OPENTYPE"
            };
        }
        static{
            this.RECIPROCATING = {
                type: 3,
                value: "RECIPROCATING"
            };
        }
        static{
            this.ROLLINGPISTON = {
                type: 3,
                value: "ROLLINGPISTON"
            };
        }
        static{
            this.ROTARY = {
                type: 3,
                value: "ROTARY"
            };
        }
        static{
            this.ROTARYVANE = {
                type: 3,
                value: "ROTARYVANE"
            };
        }
        static{
            this.SCROLL = {
                type: 3,
                value: "SCROLL"
            };
        }
        static{
            this.SEMIHERMETIC = {
                type: 3,
                value: "SEMIHERMETIC"
            };
        }
        static{
            this.SINGLESCREW = {
                type: 3,
                value: "SINGLESCREW"
            };
        }
        static{
            this.SINGLESTAGE = {
                type: 3,
                value: "SINGLESTAGE"
            };
        }
        static{
            this.TROCHOIDAL = {
                type: 3,
                value: "TROCHOIDAL"
            };
        }
        static{
            this.TWINSCREW = {
                type: 3,
                value: "TWINSCREW"
            };
        }
        static{
            this.WELDEDSHELLHERMETIC = {
                type: 3,
                value: "WELDEDSHELLHERMETIC"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCompressorTypeEnum = IfcCompressorTypeEnum;
    class IfcCondenserTypeEnum {
        static{
            this.AIRCOOLED = {
                type: 3,
                value: "AIRCOOLED"
            };
        }
        static{
            this.EVAPORATIVECOOLED = {
                type: 3,
                value: "EVAPORATIVECOOLED"
            };
        }
        static{
            this.WATERCOOLED = {
                type: 3,
                value: "WATERCOOLED"
            };
        }
        static{
            this.WATERCOOLEDBRAZEDPLATE = {
                type: 3,
                value: "WATERCOOLEDBRAZEDPLATE"
            };
        }
        static{
            this.WATERCOOLEDSHELLCOIL = {
                type: 3,
                value: "WATERCOOLEDSHELLCOIL"
            };
        }
        static{
            this.WATERCOOLEDSHELLTUBE = {
                type: 3,
                value: "WATERCOOLEDSHELLTUBE"
            };
        }
        static{
            this.WATERCOOLEDTUBEINTUBE = {
                type: 3,
                value: "WATERCOOLEDTUBEINTUBE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCondenserTypeEnum = IfcCondenserTypeEnum;
    class IfcConnectionTypeEnum {
        static{
            this.ATEND = {
                type: 3,
                value: "ATEND"
            };
        }
        static{
            this.ATPATH = {
                type: 3,
                value: "ATPATH"
            };
        }
        static{
            this.ATSTART = {
                type: 3,
                value: "ATSTART"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcConnectionTypeEnum = IfcConnectionTypeEnum;
    class IfcConstraintEnum {
        static{
            this.ADVISORY = {
                type: 3,
                value: "ADVISORY"
            };
        }
        static{
            this.HARD = {
                type: 3,
                value: "HARD"
            };
        }
        static{
            this.SOFT = {
                type: 3,
                value: "SOFT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcConstraintEnum = IfcConstraintEnum;
    class IfcConstructionEquipmentResourceTypeEnum {
        static{
            this.DEMOLISHING = {
                type: 3,
                value: "DEMOLISHING"
            };
        }
        static{
            this.EARTHMOVING = {
                type: 3,
                value: "EARTHMOVING"
            };
        }
        static{
            this.ERECTING = {
                type: 3,
                value: "ERECTING"
            };
        }
        static{
            this.HEATING = {
                type: 3,
                value: "HEATING"
            };
        }
        static{
            this.LIGHTING = {
                type: 3,
                value: "LIGHTING"
            };
        }
        static{
            this.PAVING = {
                type: 3,
                value: "PAVING"
            };
        }
        static{
            this.PUMPING = {
                type: 3,
                value: "PUMPING"
            };
        }
        static{
            this.TRANSPORTING = {
                type: 3,
                value: "TRANSPORTING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcConstructionEquipmentResourceTypeEnum = IfcConstructionEquipmentResourceTypeEnum;
    class IfcConstructionMaterialResourceTypeEnum {
        static{
            this.AGGREGATES = {
                type: 3,
                value: "AGGREGATES"
            };
        }
        static{
            this.CONCRETE = {
                type: 3,
                value: "CONCRETE"
            };
        }
        static{
            this.DRYWALL = {
                type: 3,
                value: "DRYWALL"
            };
        }
        static{
            this.FUEL = {
                type: 3,
                value: "FUEL"
            };
        }
        static{
            this.GYPSUM = {
                type: 3,
                value: "GYPSUM"
            };
        }
        static{
            this.MASONRY = {
                type: 3,
                value: "MASONRY"
            };
        }
        static{
            this.METAL = {
                type: 3,
                value: "METAL"
            };
        }
        static{
            this.PLASTIC = {
                type: 3,
                value: "PLASTIC"
            };
        }
        static{
            this.WOOD = {
                type: 3,
                value: "WOOD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcConstructionMaterialResourceTypeEnum = IfcConstructionMaterialResourceTypeEnum;
    class IfcConstructionProductResourceTypeEnum {
        static{
            this.ASSEMBLY = {
                type: 3,
                value: "ASSEMBLY"
            };
        }
        static{
            this.FORMWORK = {
                type: 3,
                value: "FORMWORK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcConstructionProductResourceTypeEnum = IfcConstructionProductResourceTypeEnum;
    class IfcControllerTypeEnum {
        static{
            this.FLOATING = {
                type: 3,
                value: "FLOATING"
            };
        }
        static{
            this.MULTIPOSITION = {
                type: 3,
                value: "MULTIPOSITION"
            };
        }
        static{
            this.PROGRAMMABLE = {
                type: 3,
                value: "PROGRAMMABLE"
            };
        }
        static{
            this.PROPORTIONAL = {
                type: 3,
                value: "PROPORTIONAL"
            };
        }
        static{
            this.TWOPOSITION = {
                type: 3,
                value: "TWOPOSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcControllerTypeEnum = IfcControllerTypeEnum;
    class IfcConveyorSegmentTypeEnum {
        static{
            this.BELTCONVEYOR = {
                type: 3,
                value: "BELTCONVEYOR"
            };
        }
        static{
            this.BUCKETCONVEYOR = {
                type: 3,
                value: "BUCKETCONVEYOR"
            };
        }
        static{
            this.CHUTECONVEYOR = {
                type: 3,
                value: "CHUTECONVEYOR"
            };
        }
        static{
            this.SCREWCONVEYOR = {
                type: 3,
                value: "SCREWCONVEYOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcConveyorSegmentTypeEnum = IfcConveyorSegmentTypeEnum;
    class IfcCooledBeamTypeEnum {
        static{
            this.ACTIVE = {
                type: 3,
                value: "ACTIVE"
            };
        }
        static{
            this.PASSIVE = {
                type: 3,
                value: "PASSIVE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;
    class IfcCoolingTowerTypeEnum {
        static{
            this.MECHANICALFORCEDDRAFT = {
                type: 3,
                value: "MECHANICALFORCEDDRAFT"
            };
        }
        static{
            this.MECHANICALINDUCEDDRAFT = {
                type: 3,
                value: "MECHANICALINDUCEDDRAFT"
            };
        }
        static{
            this.NATURALDRAFT = {
                type: 3,
                value: "NATURALDRAFT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;
    class IfcCostItemTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCostItemTypeEnum = IfcCostItemTypeEnum;
    class IfcCostScheduleTypeEnum {
        static{
            this.BUDGET = {
                type: 3,
                value: "BUDGET"
            };
        }
        static{
            this.COSTPLAN = {
                type: 3,
                value: "COSTPLAN"
            };
        }
        static{
            this.ESTIMATE = {
                type: 3,
                value: "ESTIMATE"
            };
        }
        static{
            this.PRICEDBILLOFQUANTITIES = {
                type: 3,
                value: "PRICEDBILLOFQUANTITIES"
            };
        }
        static{
            this.SCHEDULEOFRATES = {
                type: 3,
                value: "SCHEDULEOFRATES"
            };
        }
        static{
            this.TENDER = {
                type: 3,
                value: "TENDER"
            };
        }
        static{
            this.UNPRICEDBILLOFQUANTITIES = {
                type: 3,
                value: "UNPRICEDBILLOFQUANTITIES"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;
    class IfcCourseTypeEnum {
        static{
            this.ARMOUR = {
                type: 3,
                value: "ARMOUR"
            };
        }
        static{
            this.BALLASTBED = {
                type: 3,
                value: "BALLASTBED"
            };
        }
        static{
            this.CORE = {
                type: 3,
                value: "CORE"
            };
        }
        static{
            this.FILTER = {
                type: 3,
                value: "FILTER"
            };
        }
        static{
            this.PAVEMENT = {
                type: 3,
                value: "PAVEMENT"
            };
        }
        static{
            this.PROTECTION = {
                type: 3,
                value: "PROTECTION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCourseTypeEnum = IfcCourseTypeEnum;
    class IfcCoveringTypeEnum {
        static{
            this.CEILING = {
                type: 3,
                value: "CEILING"
            };
        }
        static{
            this.CLADDING = {
                type: 3,
                value: "CLADDING"
            };
        }
        static{
            this.COPING = {
                type: 3,
                value: "COPING"
            };
        }
        static{
            this.FLOORING = {
                type: 3,
                value: "FLOORING"
            };
        }
        static{
            this.INSULATION = {
                type: 3,
                value: "INSULATION"
            };
        }
        static{
            this.MEMBRANE = {
                type: 3,
                value: "MEMBRANE"
            };
        }
        static{
            this.MOLDING = {
                type: 3,
                value: "MOLDING"
            };
        }
        static{
            this.ROOFING = {
                type: 3,
                value: "ROOFING"
            };
        }
        static{
            this.SKIRTINGBOARD = {
                type: 3,
                value: "SKIRTINGBOARD"
            };
        }
        static{
            this.SLEEVING = {
                type: 3,
                value: "SLEEVING"
            };
        }
        static{
            this.TOPPING = {
                type: 3,
                value: "TOPPING"
            };
        }
        static{
            this.WRAPPING = {
                type: 3,
                value: "WRAPPING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCoveringTypeEnum = IfcCoveringTypeEnum;
    class IfcCrewResourceTypeEnum {
        static{
            this.OFFICE = {
                type: 3,
                value: "OFFICE"
            };
        }
        static{
            this.SITE = {
                type: 3,
                value: "SITE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCrewResourceTypeEnum = IfcCrewResourceTypeEnum;
    class IfcCurtainWallTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;
    class IfcCurveInterpolationEnum {
        static{
            this.LINEAR = {
                type: 3,
                value: "LINEAR"
            };
        }
        static{
            this.LOG_LINEAR = {
                type: 3,
                value: "LOG_LINEAR"
            };
        }
        static{
            this.LOG_LOG = {
                type: 3,
                value: "LOG_LOG"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcCurveInterpolationEnum = IfcCurveInterpolationEnum;
    class IfcDamperTypeEnum {
        static{
            this.BACKDRAFTDAMPER = {
                type: 3,
                value: "BACKDRAFTDAMPER"
            };
        }
        static{
            this.BALANCINGDAMPER = {
                type: 3,
                value: "BALANCINGDAMPER"
            };
        }
        static{
            this.BLASTDAMPER = {
                type: 3,
                value: "BLASTDAMPER"
            };
        }
        static{
            this.CONTROLDAMPER = {
                type: 3,
                value: "CONTROLDAMPER"
            };
        }
        static{
            this.FIREDAMPER = {
                type: 3,
                value: "FIREDAMPER"
            };
        }
        static{
            this.FIRESMOKEDAMPER = {
                type: 3,
                value: "FIRESMOKEDAMPER"
            };
        }
        static{
            this.FUMEHOODEXHAUST = {
                type: 3,
                value: "FUMEHOODEXHAUST"
            };
        }
        static{
            this.GRAVITYDAMPER = {
                type: 3,
                value: "GRAVITYDAMPER"
            };
        }
        static{
            this.GRAVITYRELIEFDAMPER = {
                type: 3,
                value: "GRAVITYRELIEFDAMPER"
            };
        }
        static{
            this.RELIEFDAMPER = {
                type: 3,
                value: "RELIEFDAMPER"
            };
        }
        static{
            this.SMOKEDAMPER = {
                type: 3,
                value: "SMOKEDAMPER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDamperTypeEnum = IfcDamperTypeEnum;
    class IfcDataOriginEnum {
        static{
            this.MEASURED = {
                type: 3,
                value: "MEASURED"
            };
        }
        static{
            this.PREDICTED = {
                type: 3,
                value: "PREDICTED"
            };
        }
        static{
            this.SIMULATED = {
                type: 3,
                value: "SIMULATED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDataOriginEnum = IfcDataOriginEnum;
    class IfcDerivedUnitEnum {
        static{
            this.ACCELERATIONUNIT = {
                type: 3,
                value: "ACCELERATIONUNIT"
            };
        }
        static{
            this.ANGULARVELOCITYUNIT = {
                type: 3,
                value: "ANGULARVELOCITYUNIT"
            };
        }
        static{
            this.AREADENSITYUNIT = {
                type: 3,
                value: "AREADENSITYUNIT"
            };
        }
        static{
            this.COMPOUNDPLANEANGLEUNIT = {
                type: 3,
                value: "COMPOUNDPLANEANGLEUNIT"
            };
        }
        static{
            this.CURVATUREUNIT = {
                type: 3,
                value: "CURVATUREUNIT"
            };
        }
        static{
            this.DYNAMICVISCOSITYUNIT = {
                type: 3,
                value: "DYNAMICVISCOSITYUNIT"
            };
        }
        static{
            this.HEATFLUXDENSITYUNIT = {
                type: 3,
                value: "HEATFLUXDENSITYUNIT"
            };
        }
        static{
            this.HEATINGVALUEUNIT = {
                type: 3,
                value: "HEATINGVALUEUNIT"
            };
        }
        static{
            this.INTEGERCOUNTRATEUNIT = {
                type: 3,
                value: "INTEGERCOUNTRATEUNIT"
            };
        }
        static{
            this.IONCONCENTRATIONUNIT = {
                type: 3,
                value: "IONCONCENTRATIONUNIT"
            };
        }
        static{
            this.ISOTHERMALMOISTURECAPACITYUNIT = {
                type: 3,
                value: "ISOTHERMALMOISTURECAPACITYUNIT"
            };
        }
        static{
            this.KINEMATICVISCOSITYUNIT = {
                type: 3,
                value: "KINEMATICVISCOSITYUNIT"
            };
        }
        static{
            this.LINEARFORCEUNIT = {
                type: 3,
                value: "LINEARFORCEUNIT"
            };
        }
        static{
            this.LINEARMOMENTUNIT = {
                type: 3,
                value: "LINEARMOMENTUNIT"
            };
        }
        static{
            this.LINEARSTIFFNESSUNIT = {
                type: 3,
                value: "LINEARSTIFFNESSUNIT"
            };
        }
        static{
            this.LINEARVELOCITYUNIT = {
                type: 3,
                value: "LINEARVELOCITYUNIT"
            };
        }
        static{
            this.LUMINOUSINTENSITYDISTRIBUTIONUNIT = {
                type: 3,
                value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT"
            };
        }
        static{
            this.MASSDENSITYUNIT = {
                type: 3,
                value: "MASSDENSITYUNIT"
            };
        }
        static{
            this.MASSFLOWRATEUNIT = {
                type: 3,
                value: "MASSFLOWRATEUNIT"
            };
        }
        static{
            this.MASSPERLENGTHUNIT = {
                type: 3,
                value: "MASSPERLENGTHUNIT"
            };
        }
        static{
            this.MODULUSOFELASTICITYUNIT = {
                type: 3,
                value: "MODULUSOFELASTICITYUNIT"
            };
        }
        static{
            this.MODULUSOFLINEARSUBGRADEREACTIONUNIT = {
                type: 3,
                value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT"
            };
        }
        static{
            this.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = {
                type: 3,
                value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT"
            };
        }
        static{
            this.MODULUSOFSUBGRADEREACTIONUNIT = {
                type: 3,
                value: "MODULUSOFSUBGRADEREACTIONUNIT"
            };
        }
        static{
            this.MOISTUREDIFFUSIVITYUNIT = {
                type: 3,
                value: "MOISTUREDIFFUSIVITYUNIT"
            };
        }
        static{
            this.MOLECULARWEIGHTUNIT = {
                type: 3,
                value: "MOLECULARWEIGHTUNIT"
            };
        }
        static{
            this.MOMENTOFINERTIAUNIT = {
                type: 3,
                value: "MOMENTOFINERTIAUNIT"
            };
        }
        static{
            this.PHUNIT = {
                type: 3,
                value: "PHUNIT"
            };
        }
        static{
            this.PLANARFORCEUNIT = {
                type: 3,
                value: "PLANARFORCEUNIT"
            };
        }
        static{
            this.ROTATIONALFREQUENCYUNIT = {
                type: 3,
                value: "ROTATIONALFREQUENCYUNIT"
            };
        }
        static{
            this.ROTATIONALMASSUNIT = {
                type: 3,
                value: "ROTATIONALMASSUNIT"
            };
        }
        static{
            this.ROTATIONALSTIFFNESSUNIT = {
                type: 3,
                value: "ROTATIONALSTIFFNESSUNIT"
            };
        }
        static{
            this.SECTIONAREAINTEGRALUNIT = {
                type: 3,
                value: "SECTIONAREAINTEGRALUNIT"
            };
        }
        static{
            this.SECTIONMODULUSUNIT = {
                type: 3,
                value: "SECTIONMODULUSUNIT"
            };
        }
        static{
            this.SHEARMODULUSUNIT = {
                type: 3,
                value: "SHEARMODULUSUNIT"
            };
        }
        static{
            this.SOUNDPOWERLEVELUNIT = {
                type: 3,
                value: "SOUNDPOWERLEVELUNIT"
            };
        }
        static{
            this.SOUNDPOWERUNIT = {
                type: 3,
                value: "SOUNDPOWERUNIT"
            };
        }
        static{
            this.SOUNDPRESSURELEVELUNIT = {
                type: 3,
                value: "SOUNDPRESSURELEVELUNIT"
            };
        }
        static{
            this.SOUNDPRESSUREUNIT = {
                type: 3,
                value: "SOUNDPRESSUREUNIT"
            };
        }
        static{
            this.SPECIFICHEATCAPACITYUNIT = {
                type: 3,
                value: "SPECIFICHEATCAPACITYUNIT"
            };
        }
        static{
            this.TEMPERATUREGRADIENTUNIT = {
                type: 3,
                value: "TEMPERATUREGRADIENTUNIT"
            };
        }
        static{
            this.TEMPERATURERATEOFCHANGEUNIT = {
                type: 3,
                value: "TEMPERATURERATEOFCHANGEUNIT"
            };
        }
        static{
            this.THERMALADMITTANCEUNIT = {
                type: 3,
                value: "THERMALADMITTANCEUNIT"
            };
        }
        static{
            this.THERMALCONDUCTANCEUNIT = {
                type: 3,
                value: "THERMALCONDUCTANCEUNIT"
            };
        }
        static{
            this.THERMALEXPANSIONCOEFFICIENTUNIT = {
                type: 3,
                value: "THERMALEXPANSIONCOEFFICIENTUNIT"
            };
        }
        static{
            this.THERMALRESISTANCEUNIT = {
                type: 3,
                value: "THERMALRESISTANCEUNIT"
            };
        }
        static{
            this.THERMALTRANSMITTANCEUNIT = {
                type: 3,
                value: "THERMALTRANSMITTANCEUNIT"
            };
        }
        static{
            this.TORQUEUNIT = {
                type: 3,
                value: "TORQUEUNIT"
            };
        }
        static{
            this.VAPORPERMEABILITYUNIT = {
                type: 3,
                value: "VAPORPERMEABILITYUNIT"
            };
        }
        static{
            this.VOLUMETRICFLOWRATEUNIT = {
                type: 3,
                value: "VOLUMETRICFLOWRATEUNIT"
            };
        }
        static{
            this.WARPINGCONSTANTUNIT = {
                type: 3,
                value: "WARPINGCONSTANTUNIT"
            };
        }
        static{
            this.WARPINGMOMENTUNIT = {
                type: 3,
                value: "WARPINGMOMENTUNIT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC4X32.IfcDerivedUnitEnum = IfcDerivedUnitEnum;
    class IfcDirectionSenseEnum {
        static{
            this.NEGATIVE = {
                type: 3,
                value: "NEGATIVE"
            };
        }
        static{
            this.POSITIVE = {
                type: 3,
                value: "POSITIVE"
            };
        }
    }
    IFC4X32.IfcDirectionSenseEnum = IfcDirectionSenseEnum;
    class IfcDiscreteAccessoryTypeEnum {
        static{
            this.ANCHORPLATE = {
                type: 3,
                value: "ANCHORPLATE"
            };
        }
        static{
            this.BIRDPROTECTION = {
                type: 3,
                value: "BIRDPROTECTION"
            };
        }
        static{
            this.BRACKET = {
                type: 3,
                value: "BRACKET"
            };
        }
        static{
            this.CABLEARRANGER = {
                type: 3,
                value: "CABLEARRANGER"
            };
        }
        static{
            this.ELASTIC_CUSHION = {
                type: 3,
                value: "ELASTIC_CUSHION"
            };
        }
        static{
            this.EXPANSION_JOINT_DEVICE = {
                type: 3,
                value: "EXPANSION_JOINT_DEVICE"
            };
        }
        static{
            this.FILLER = {
                type: 3,
                value: "FILLER"
            };
        }
        static{
            this.FLASHING = {
                type: 3,
                value: "FLASHING"
            };
        }
        static{
            this.INSULATOR = {
                type: 3,
                value: "INSULATOR"
            };
        }
        static{
            this.LOCK = {
                type: 3,
                value: "LOCK"
            };
        }
        static{
            this.PANEL_STRENGTHENING = {
                type: 3,
                value: "PANEL_STRENGTHENING"
            };
        }
        static{
            this.POINTMACHINEMOUNTINGDEVICE = {
                type: 3,
                value: "POINTMACHINEMOUNTINGDEVICE"
            };
        }
        static{
            this.POINT_MACHINE_LOCKING_DEVICE = {
                type: 3,
                value: "POINT_MACHINE_LOCKING_DEVICE"
            };
        }
        static{
            this.RAILBRACE = {
                type: 3,
                value: "RAILBRACE"
            };
        }
        static{
            this.RAILPAD = {
                type: 3,
                value: "RAILPAD"
            };
        }
        static{
            this.RAIL_LUBRICATION = {
                type: 3,
                value: "RAIL_LUBRICATION"
            };
        }
        static{
            this.RAIL_MECHANICAL_EQUIPMENT = {
                type: 3,
                value: "RAIL_MECHANICAL_EQUIPMENT"
            };
        }
        static{
            this.SHOE = {
                type: 3,
                value: "SHOE"
            };
        }
        static{
            this.SLIDINGCHAIR = {
                type: 3,
                value: "SLIDINGCHAIR"
            };
        }
        static{
            this.SOUNDABSORPTION = {
                type: 3,
                value: "SOUNDABSORPTION"
            };
        }
        static{
            this.TENSIONINGEQUIPMENT = {
                type: 3,
                value: "TENSIONINGEQUIPMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDiscreteAccessoryTypeEnum = IfcDiscreteAccessoryTypeEnum;
    class IfcDistributionBoardTypeEnum {
        static{
            this.CONSUMERUNIT = {
                type: 3,
                value: "CONSUMERUNIT"
            };
        }
        static{
            this.DISPATCHINGBOARD = {
                type: 3,
                value: "DISPATCHINGBOARD"
            };
        }
        static{
            this.DISTRIBUTIONBOARD = {
                type: 3,
                value: "DISTRIBUTIONBOARD"
            };
        }
        static{
            this.DISTRIBUTIONFRAME = {
                type: 3,
                value: "DISTRIBUTIONFRAME"
            };
        }
        static{
            this.MOTORCONTROLCENTRE = {
                type: 3,
                value: "MOTORCONTROLCENTRE"
            };
        }
        static{
            this.SWITCHBOARD = {
                type: 3,
                value: "SWITCHBOARD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDistributionBoardTypeEnum = IfcDistributionBoardTypeEnum;
    class IfcDistributionChamberElementTypeEnum {
        static{
            this.FORMEDDUCT = {
                type: 3,
                value: "FORMEDDUCT"
            };
        }
        static{
            this.INSPECTIONCHAMBER = {
                type: 3,
                value: "INSPECTIONCHAMBER"
            };
        }
        static{
            this.INSPECTIONPIT = {
                type: 3,
                value: "INSPECTIONPIT"
            };
        }
        static{
            this.MANHOLE = {
                type: 3,
                value: "MANHOLE"
            };
        }
        static{
            this.METERCHAMBER = {
                type: 3,
                value: "METERCHAMBER"
            };
        }
        static{
            this.SUMP = {
                type: 3,
                value: "SUMP"
            };
        }
        static{
            this.TRENCH = {
                type: 3,
                value: "TRENCH"
            };
        }
        static{
            this.VALVECHAMBER = {
                type: 3,
                value: "VALVECHAMBER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;
    class IfcDistributionPortTypeEnum {
        static{
            this.CABLE = {
                type: 3,
                value: "CABLE"
            };
        }
        static{
            this.CABLECARRIER = {
                type: 3,
                value: "CABLECARRIER"
            };
        }
        static{
            this.DUCT = {
                type: 3,
                value: "DUCT"
            };
        }
        static{
            this.PIPE = {
                type: 3,
                value: "PIPE"
            };
        }
        static{
            this.WIRELESS = {
                type: 3,
                value: "WIRELESS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDistributionPortTypeEnum = IfcDistributionPortTypeEnum;
    class IfcDistributionSystemEnum {
        static{
            this.AIRCONDITIONING = {
                type: 3,
                value: "AIRCONDITIONING"
            };
        }
        static{
            this.AUDIOVISUAL = {
                type: 3,
                value: "AUDIOVISUAL"
            };
        }
        static{
            this.CATENARY_SYSTEM = {
                type: 3,
                value: "CATENARY_SYSTEM"
            };
        }
        static{
            this.CHEMICAL = {
                type: 3,
                value: "CHEMICAL"
            };
        }
        static{
            this.CHILLEDWATER = {
                type: 3,
                value: "CHILLEDWATER"
            };
        }
        static{
            this.COMMUNICATION = {
                type: 3,
                value: "COMMUNICATION"
            };
        }
        static{
            this.COMPRESSEDAIR = {
                type: 3,
                value: "COMPRESSEDAIR"
            };
        }
        static{
            this.CONDENSERWATER = {
                type: 3,
                value: "CONDENSERWATER"
            };
        }
        static{
            this.CONTROL = {
                type: 3,
                value: "CONTROL"
            };
        }
        static{
            this.CONVEYING = {
                type: 3,
                value: "CONVEYING"
            };
        }
        static{
            this.DATA = {
                type: 3,
                value: "DATA"
            };
        }
        static{
            this.DISPOSAL = {
                type: 3,
                value: "DISPOSAL"
            };
        }
        static{
            this.DOMESTICCOLDWATER = {
                type: 3,
                value: "DOMESTICCOLDWATER"
            };
        }
        static{
            this.DOMESTICHOTWATER = {
                type: 3,
                value: "DOMESTICHOTWATER"
            };
        }
        static{
            this.DRAINAGE = {
                type: 3,
                value: "DRAINAGE"
            };
        }
        static{
            this.EARTHING = {
                type: 3,
                value: "EARTHING"
            };
        }
        static{
            this.ELECTRICAL = {
                type: 3,
                value: "ELECTRICAL"
            };
        }
        static{
            this.ELECTROACOUSTIC = {
                type: 3,
                value: "ELECTROACOUSTIC"
            };
        }
        static{
            this.EXHAUST = {
                type: 3,
                value: "EXHAUST"
            };
        }
        static{
            this.FIREPROTECTION = {
                type: 3,
                value: "FIREPROTECTION"
            };
        }
        static{
            this.FIXEDTRANSMISSIONNETWORK = {
                type: 3,
                value: "FIXEDTRANSMISSIONNETWORK"
            };
        }
        static{
            this.FUEL = {
                type: 3,
                value: "FUEL"
            };
        }
        static{
            this.GAS = {
                type: 3,
                value: "GAS"
            };
        }
        static{
            this.HAZARDOUS = {
                type: 3,
                value: "HAZARDOUS"
            };
        }
        static{
            this.HEATING = {
                type: 3,
                value: "HEATING"
            };
        }
        static{
            this.LIGHTING = {
                type: 3,
                value: "LIGHTING"
            };
        }
        static{
            this.LIGHTNINGPROTECTION = {
                type: 3,
                value: "LIGHTNINGPROTECTION"
            };
        }
        static{
            this.MOBILENETWORK = {
                type: 3,
                value: "MOBILENETWORK"
            };
        }
        static{
            this.MONITORINGSYSTEM = {
                type: 3,
                value: "MONITORINGSYSTEM"
            };
        }
        static{
            this.MUNICIPALSOLIDWASTE = {
                type: 3,
                value: "MUNICIPALSOLIDWASTE"
            };
        }
        static{
            this.OIL = {
                type: 3,
                value: "OIL"
            };
        }
        static{
            this.OPERATIONAL = {
                type: 3,
                value: "OPERATIONAL"
            };
        }
        static{
            this.OPERATIONALTELEPHONYSYSTEM = {
                type: 3,
                value: "OPERATIONALTELEPHONYSYSTEM"
            };
        }
        static{
            this.OVERHEAD_CONTACTLINE_SYSTEM = {
                type: 3,
                value: "OVERHEAD_CONTACTLINE_SYSTEM"
            };
        }
        static{
            this.POWERGENERATION = {
                type: 3,
                value: "POWERGENERATION"
            };
        }
        static{
            this.RAINWATER = {
                type: 3,
                value: "RAINWATER"
            };
        }
        static{
            this.REFRIGERATION = {
                type: 3,
                value: "REFRIGERATION"
            };
        }
        static{
            this.RETURN_CIRCUIT = {
                type: 3,
                value: "RETURN_CIRCUIT"
            };
        }
        static{
            this.SECURITY = {
                type: 3,
                value: "SECURITY"
            };
        }
        static{
            this.SEWAGE = {
                type: 3,
                value: "SEWAGE"
            };
        }
        static{
            this.SIGNAL = {
                type: 3,
                value: "SIGNAL"
            };
        }
        static{
            this.STORMWATER = {
                type: 3,
                value: "STORMWATER"
            };
        }
        static{
            this.TELEPHONE = {
                type: 3,
                value: "TELEPHONE"
            };
        }
        static{
            this.TV = {
                type: 3,
                value: "TV"
            };
        }
        static{
            this.VACUUM = {
                type: 3,
                value: "VACUUM"
            };
        }
        static{
            this.VENT = {
                type: 3,
                value: "VENT"
            };
        }
        static{
            this.VENTILATION = {
                type: 3,
                value: "VENTILATION"
            };
        }
        static{
            this.WASTEWATER = {
                type: 3,
                value: "WASTEWATER"
            };
        }
        static{
            this.WATERSUPPLY = {
                type: 3,
                value: "WATERSUPPLY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDistributionSystemEnum = IfcDistributionSystemEnum;
    class IfcDocumentConfidentialityEnum {
        static{
            this.CONFIDENTIAL = {
                type: 3,
                value: "CONFIDENTIAL"
            };
        }
        static{
            this.PERSONAL = {
                type: 3,
                value: "PERSONAL"
            };
        }
        static{
            this.PUBLIC = {
                type: 3,
                value: "PUBLIC"
            };
        }
        static{
            this.RESTRICTED = {
                type: 3,
                value: "RESTRICTED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;
    class IfcDocumentStatusEnum {
        static{
            this.DRAFT = {
                type: 3,
                value: "DRAFT"
            };
        }
        static{
            this.FINAL = {
                type: 3,
                value: "FINAL"
            };
        }
        static{
            this.FINALDRAFT = {
                type: 3,
                value: "FINALDRAFT"
            };
        }
        static{
            this.REVISION = {
                type: 3,
                value: "REVISION"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDocumentStatusEnum = IfcDocumentStatusEnum;
    class IfcDoorPanelOperationEnum {
        static{
            this.DOUBLE_ACTING = {
                type: 3,
                value: "DOUBLE_ACTING"
            };
        }
        static{
            this.FIXEDPANEL = {
                type: 3,
                value: "FIXEDPANEL"
            };
        }
        static{
            this.FOLDING = {
                type: 3,
                value: "FOLDING"
            };
        }
        static{
            this.REVOLVING = {
                type: 3,
                value: "REVOLVING"
            };
        }
        static{
            this.ROLLINGUP = {
                type: 3,
                value: "ROLLINGUP"
            };
        }
        static{
            this.SLIDING = {
                type: 3,
                value: "SLIDING"
            };
        }
        static{
            this.SWINGING = {
                type: 3,
                value: "SWINGING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;
    class IfcDoorPanelPositionEnum {
        static{
            this.LEFT = {
                type: 3,
                value: "LEFT"
            };
        }
        static{
            this.MIDDLE = {
                type: 3,
                value: "MIDDLE"
            };
        }
        static{
            this.RIGHT = {
                type: 3,
                value: "RIGHT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;
    class IfcDoorTypeEnum {
        static{
            this.BOOM_BARRIER = {
                type: 3,
                value: "BOOM_BARRIER"
            };
        }
        static{
            this.DOOR = {
                type: 3,
                value: "DOOR"
            };
        }
        static{
            this.GATE = {
                type: 3,
                value: "GATE"
            };
        }
        static{
            this.TRAPDOOR = {
                type: 3,
                value: "TRAPDOOR"
            };
        }
        static{
            this.TURNSTILE = {
                type: 3,
                value: "TURNSTILE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDoorTypeEnum = IfcDoorTypeEnum;
    class IfcDoorTypeOperationEnum {
        static{
            this.DOUBLE_DOOR_DOUBLE_SWING = {
                type: 3,
                value: "DOUBLE_DOOR_DOUBLE_SWING"
            };
        }
        static{
            this.DOUBLE_DOOR_FOLDING = {
                type: 3,
                value: "DOUBLE_DOOR_FOLDING"
            };
        }
        static{
            this.DOUBLE_DOOR_LIFTING_VERTICAL = {
                type: 3,
                value: "DOUBLE_DOOR_LIFTING_VERTICAL"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT"
            };
        }
        static{
            this.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = {
                type: 3,
                value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT"
            };
        }
        static{
            this.DOUBLE_DOOR_SLIDING = {
                type: 3,
                value: "DOUBLE_DOOR_SLIDING"
            };
        }
        static{
            this.DOUBLE_SWING_LEFT = {
                type: 3,
                value: "DOUBLE_SWING_LEFT"
            };
        }
        static{
            this.DOUBLE_SWING_RIGHT = {
                type: 3,
                value: "DOUBLE_SWING_RIGHT"
            };
        }
        static{
            this.FOLDING_TO_LEFT = {
                type: 3,
                value: "FOLDING_TO_LEFT"
            };
        }
        static{
            this.FOLDING_TO_RIGHT = {
                type: 3,
                value: "FOLDING_TO_RIGHT"
            };
        }
        static{
            this.LIFTING_HORIZONTAL = {
                type: 3,
                value: "LIFTING_HORIZONTAL"
            };
        }
        static{
            this.LIFTING_VERTICAL_LEFT = {
                type: 3,
                value: "LIFTING_VERTICAL_LEFT"
            };
        }
        static{
            this.LIFTING_VERTICAL_RIGHT = {
                type: 3,
                value: "LIFTING_VERTICAL_RIGHT"
            };
        }
        static{
            this.REVOLVING = {
                type: 3,
                value: "REVOLVING"
            };
        }
        static{
            this.REVOLVING_VERTICAL = {
                type: 3,
                value: "REVOLVING_VERTICAL"
            };
        }
        static{
            this.ROLLINGUP = {
                type: 3,
                value: "ROLLINGUP"
            };
        }
        static{
            this.SINGLE_SWING_LEFT = {
                type: 3,
                value: "SINGLE_SWING_LEFT"
            };
        }
        static{
            this.SINGLE_SWING_RIGHT = {
                type: 3,
                value: "SINGLE_SWING_RIGHT"
            };
        }
        static{
            this.SLIDING_TO_LEFT = {
                type: 3,
                value: "SLIDING_TO_LEFT"
            };
        }
        static{
            this.SLIDING_TO_RIGHT = {
                type: 3,
                value: "SLIDING_TO_RIGHT"
            };
        }
        static{
            this.SWING_FIXED_LEFT = {
                type: 3,
                value: "SWING_FIXED_LEFT"
            };
        }
        static{
            this.SWING_FIXED_RIGHT = {
                type: 3,
                value: "SWING_FIXED_RIGHT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDoorTypeOperationEnum = IfcDoorTypeOperationEnum;
    class IfcDuctFittingTypeEnum {
        static{
            this.BEND = {
                type: 3,
                value: "BEND"
            };
        }
        static{
            this.CONNECTOR = {
                type: 3,
                value: "CONNECTOR"
            };
        }
        static{
            this.ENTRY = {
                type: 3,
                value: "ENTRY"
            };
        }
        static{
            this.EXIT = {
                type: 3,
                value: "EXIT"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.OBSTRUCTION = {
                type: 3,
                value: "OBSTRUCTION"
            };
        }
        static{
            this.TRANSITION = {
                type: 3,
                value: "TRANSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;
    class IfcDuctSegmentTypeEnum {
        static{
            this.FLEXIBLESEGMENT = {
                type: 3,
                value: "FLEXIBLESEGMENT"
            };
        }
        static{
            this.RIGIDSEGMENT = {
                type: 3,
                value: "RIGIDSEGMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;
    class IfcDuctSilencerTypeEnum {
        static{
            this.FLATOVAL = {
                type: 3,
                value: "FLATOVAL"
            };
        }
        static{
            this.RECTANGULAR = {
                type: 3,
                value: "RECTANGULAR"
            };
        }
        static{
            this.ROUND = {
                type: 3,
                value: "ROUND"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;
    class IfcEarthworksCutTypeEnum {
        static{
            this.BASE_EXCAVATION = {
                type: 3,
                value: "BASE_EXCAVATION"
            };
        }
        static{
            this.CUT = {
                type: 3,
                value: "CUT"
            };
        }
        static{
            this.DREDGING = {
                type: 3,
                value: "DREDGING"
            };
        }
        static{
            this.EXCAVATION = {
                type: 3,
                value: "EXCAVATION"
            };
        }
        static{
            this.OVEREXCAVATION = {
                type: 3,
                value: "OVEREXCAVATION"
            };
        }
        static{
            this.PAVEMENTMILLING = {
                type: 3,
                value: "PAVEMENTMILLING"
            };
        }
        static{
            this.STEPEXCAVATION = {
                type: 3,
                value: "STEPEXCAVATION"
            };
        }
        static{
            this.TOPSOILREMOVAL = {
                type: 3,
                value: "TOPSOILREMOVAL"
            };
        }
        static{
            this.TRENCH = {
                type: 3,
                value: "TRENCH"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcEarthworksCutTypeEnum = IfcEarthworksCutTypeEnum;
    class IfcEarthworksFillTypeEnum {
        static{
            this.BACKFILL = {
                type: 3,
                value: "BACKFILL"
            };
        }
        static{
            this.COUNTERWEIGHT = {
                type: 3,
                value: "COUNTERWEIGHT"
            };
        }
        static{
            this.EMBANKMENT = {
                type: 3,
                value: "EMBANKMENT"
            };
        }
        static{
            this.SLOPEFILL = {
                type: 3,
                value: "SLOPEFILL"
            };
        }
        static{
            this.SUBGRADE = {
                type: 3,
                value: "SUBGRADE"
            };
        }
        static{
            this.SUBGRADEBED = {
                type: 3,
                value: "SUBGRADEBED"
            };
        }
        static{
            this.TRANSITIONSECTION = {
                type: 3,
                value: "TRANSITIONSECTION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcEarthworksFillTypeEnum = IfcEarthworksFillTypeEnum;
    class IfcElectricApplianceTypeEnum {
        static{
            this.DISHWASHER = {
                type: 3,
                value: "DISHWASHER"
            };
        }
        static{
            this.ELECTRICCOOKER = {
                type: 3,
                value: "ELECTRICCOOKER"
            };
        }
        static{
            this.FREESTANDINGELECTRICHEATER = {
                type: 3,
                value: "FREESTANDINGELECTRICHEATER"
            };
        }
        static{
            this.FREESTANDINGFAN = {
                type: 3,
                value: "FREESTANDINGFAN"
            };
        }
        static{
            this.FREESTANDINGWATERCOOLER = {
                type: 3,
                value: "FREESTANDINGWATERCOOLER"
            };
        }
        static{
            this.FREESTANDINGWATERHEATER = {
                type: 3,
                value: "FREESTANDINGWATERHEATER"
            };
        }
        static{
            this.FREEZER = {
                type: 3,
                value: "FREEZER"
            };
        }
        static{
            this.FRIDGE_FREEZER = {
                type: 3,
                value: "FRIDGE_FREEZER"
            };
        }
        static{
            this.HANDDRYER = {
                type: 3,
                value: "HANDDRYER"
            };
        }
        static{
            this.KITCHENMACHINE = {
                type: 3,
                value: "KITCHENMACHINE"
            };
        }
        static{
            this.MICROWAVE = {
                type: 3,
                value: "MICROWAVE"
            };
        }
        static{
            this.PHOTOCOPIER = {
                type: 3,
                value: "PHOTOCOPIER"
            };
        }
        static{
            this.REFRIGERATOR = {
                type: 3,
                value: "REFRIGERATOR"
            };
        }
        static{
            this.TUMBLEDRYER = {
                type: 3,
                value: "TUMBLEDRYER"
            };
        }
        static{
            this.VENDINGMACHINE = {
                type: 3,
                value: "VENDINGMACHINE"
            };
        }
        static{
            this.WASHINGMACHINE = {
                type: 3,
                value: "WASHINGMACHINE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;
    class IfcElectricDistributionBoardTypeEnum {
        static{
            this.CONSUMERUNIT = {
                type: 3,
                value: "CONSUMERUNIT"
            };
        }
        static{
            this.DISTRIBUTIONBOARD = {
                type: 3,
                value: "DISTRIBUTIONBOARD"
            };
        }
        static{
            this.MOTORCONTROLCENTRE = {
                type: 3,
                value: "MOTORCONTROLCENTRE"
            };
        }
        static{
            this.SWITCHBOARD = {
                type: 3,
                value: "SWITCHBOARD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcElectricDistributionBoardTypeEnum = IfcElectricDistributionBoardTypeEnum;
    class IfcElectricFlowStorageDeviceTypeEnum {
        static{
            this.BATTERY = {
                type: 3,
                value: "BATTERY"
            };
        }
        static{
            this.CAPACITOR = {
                type: 3,
                value: "CAPACITOR"
            };
        }
        static{
            this.CAPACITORBANK = {
                type: 3,
                value: "CAPACITORBANK"
            };
        }
        static{
            this.COMPENSATOR = {
                type: 3,
                value: "COMPENSATOR"
            };
        }
        static{
            this.HARMONICFILTER = {
                type: 3,
                value: "HARMONICFILTER"
            };
        }
        static{
            this.INDUCTOR = {
                type: 3,
                value: "INDUCTOR"
            };
        }
        static{
            this.INDUCTORBANK = {
                type: 3,
                value: "INDUCTORBANK"
            };
        }
        static{
            this.RECHARGER = {
                type: 3,
                value: "RECHARGER"
            };
        }
        static{
            this.UPS = {
                type: 3,
                value: "UPS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;
    class IfcElectricFlowTreatmentDeviceTypeEnum {
        static{
            this.ELECTRONICFILTER = {
                type: 3,
                value: "ELECTRONICFILTER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcElectricFlowTreatmentDeviceTypeEnum = IfcElectricFlowTreatmentDeviceTypeEnum;
    class IfcElectricGeneratorTypeEnum {
        static{
            this.CHP = {
                type: 3,
                value: "CHP"
            };
        }
        static{
            this.ENGINEGENERATOR = {
                type: 3,
                value: "ENGINEGENERATOR"
            };
        }
        static{
            this.STANDALONE = {
                type: 3,
                value: "STANDALONE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;
    class IfcElectricMotorTypeEnum {
        static{
            this.DC = {
                type: 3,
                value: "DC"
            };
        }
        static{
            this.INDUCTION = {
                type: 3,
                value: "INDUCTION"
            };
        }
        static{
            this.POLYPHASE = {
                type: 3,
                value: "POLYPHASE"
            };
        }
        static{
            this.RELUCTANCESYNCHRONOUS = {
                type: 3,
                value: "RELUCTANCESYNCHRONOUS"
            };
        }
        static{
            this.SYNCHRONOUS = {
                type: 3,
                value: "SYNCHRONOUS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;
    class IfcElectricTimeControlTypeEnum {
        static{
            this.RELAY = {
                type: 3,
                value: "RELAY"
            };
        }
        static{
            this.TIMECLOCK = {
                type: 3,
                value: "TIMECLOCK"
            };
        }
        static{
            this.TIMEDELAY = {
                type: 3,
                value: "TIMEDELAY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;
    class IfcElementAssemblyTypeEnum {
        static{
            this.ABUTMENT = {
                type: 3,
                value: "ABUTMENT"
            };
        }
        static{
            this.ACCESSORY_ASSEMBLY = {
                type: 3,
                value: "ACCESSORY_ASSEMBLY"
            };
        }
        static{
            this.ARCH = {
                type: 3,
                value: "ARCH"
            };
        }
        static{
            this.BEAM_GRID = {
                type: 3,
                value: "BEAM_GRID"
            };
        }
        static{
            this.BRACED_FRAME = {
                type: 3,
                value: "BRACED_FRAME"
            };
        }
        static{
            this.CROSS_BRACING = {
                type: 3,
                value: "CROSS_BRACING"
            };
        }
        static{
            this.DECK = {
                type: 3,
                value: "DECK"
            };
        }
        static{
            this.DILATATIONPANEL = {
                type: 3,
                value: "DILATATIONPANEL"
            };
        }
        static{
            this.ENTRANCEWORKS = {
                type: 3,
                value: "ENTRANCEWORKS"
            };
        }
        static{
            this.GIRDER = {
                type: 3,
                value: "GIRDER"
            };
        }
        static{
            this.GRID = {
                type: 3,
                value: "GRID"
            };
        }
        static{
            this.MAST = {
                type: 3,
                value: "MAST"
            };
        }
        static{
            this.PIER = {
                type: 3,
                value: "PIER"
            };
        }
        static{
            this.PYLON = {
                type: 3,
                value: "PYLON"
            };
        }
        static{
            this.RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY = {
                type: 3,
                value: "RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY"
            };
        }
        static{
            this.REINFORCEMENT_UNIT = {
                type: 3,
                value: "REINFORCEMENT_UNIT"
            };
        }
        static{
            this.RIGID_FRAME = {
                type: 3,
                value: "RIGID_FRAME"
            };
        }
        static{
            this.SHELTER = {
                type: 3,
                value: "SHELTER"
            };
        }
        static{
            this.SIGNALASSEMBLY = {
                type: 3,
                value: "SIGNALASSEMBLY"
            };
        }
        static{
            this.SLAB_FIELD = {
                type: 3,
                value: "SLAB_FIELD"
            };
        }
        static{
            this.SUMPBUSTER = {
                type: 3,
                value: "SUMPBUSTER"
            };
        }
        static{
            this.SUPPORTINGASSEMBLY = {
                type: 3,
                value: "SUPPORTINGASSEMBLY"
            };
        }
        static{
            this.SUSPENSIONASSEMBLY = {
                type: 3,
                value: "SUSPENSIONASSEMBLY"
            };
        }
        static{
            this.TRACKPANEL = {
                type: 3,
                value: "TRACKPANEL"
            };
        }
        static{
            this.TRACTION_SWITCHING_ASSEMBLY = {
                type: 3,
                value: "TRACTION_SWITCHING_ASSEMBLY"
            };
        }
        static{
            this.TRAFFIC_CALMING_DEVICE = {
                type: 3,
                value: "TRAFFIC_CALMING_DEVICE"
            };
        }
        static{
            this.TRUSS = {
                type: 3,
                value: "TRUSS"
            };
        }
        static{
            this.TURNOUTPANEL = {
                type: 3,
                value: "TURNOUTPANEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;
    class IfcElementCompositionEnum {
        static{
            this.COMPLEX = {
                type: 3,
                value: "COMPLEX"
            };
        }
        static{
            this.ELEMENT = {
                type: 3,
                value: "ELEMENT"
            };
        }
        static{
            this.PARTIAL = {
                type: 3,
                value: "PARTIAL"
            };
        }
    }
    IFC4X32.IfcElementCompositionEnum = IfcElementCompositionEnum;
    class IfcEngineTypeEnum {
        static{
            this.EXTERNALCOMBUSTION = {
                type: 3,
                value: "EXTERNALCOMBUSTION"
            };
        }
        static{
            this.INTERNALCOMBUSTION = {
                type: 3,
                value: "INTERNALCOMBUSTION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcEngineTypeEnum = IfcEngineTypeEnum;
    class IfcEvaporativeCoolerTypeEnum {
        static{
            this.DIRECTEVAPORATIVEAIRWASHER = {
                type: 3,
                value: "DIRECTEVAPORATIVEAIRWASHER"
            };
        }
        static{
            this.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER"
            };
        }
        static{
            this.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = {
                type: 3,
                value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER"
            };
        }
        static{
            this.INDIRECTDIRECTCOMBINATION = {
                type: 3,
                value: "INDIRECTDIRECTCOMBINATION"
            };
        }
        static{
            this.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = {
                type: 3,
                value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER"
            };
        }
        static{
            this.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = {
                type: 3,
                value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER"
            };
        }
        static{
            this.INDIRECTEVAPORATIVEWETCOIL = {
                type: 3,
                value: "INDIRECTEVAPORATIVEWETCOIL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;
    class IfcEvaporatorTypeEnum {
        static{
            this.DIRECTEXPANSION = {
                type: 3,
                value: "DIRECTEXPANSION"
            };
        }
        static{
            this.DIRECTEXPANSIONBRAZEDPLATE = {
                type: 3,
                value: "DIRECTEXPANSIONBRAZEDPLATE"
            };
        }
        static{
            this.DIRECTEXPANSIONSHELLANDTUBE = {
                type: 3,
                value: "DIRECTEXPANSIONSHELLANDTUBE"
            };
        }
        static{
            this.DIRECTEXPANSIONTUBEINTUBE = {
                type: 3,
                value: "DIRECTEXPANSIONTUBEINTUBE"
            };
        }
        static{
            this.FLOODEDSHELLANDTUBE = {
                type: 3,
                value: "FLOODEDSHELLANDTUBE"
            };
        }
        static{
            this.SHELLANDCOIL = {
                type: 3,
                value: "SHELLANDCOIL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;
    class IfcEventTriggerTypeEnum {
        static{
            this.EVENTCOMPLEX = {
                type: 3,
                value: "EVENTCOMPLEX"
            };
        }
        static{
            this.EVENTMESSAGE = {
                type: 3,
                value: "EVENTMESSAGE"
            };
        }
        static{
            this.EVENTRULE = {
                type: 3,
                value: "EVENTRULE"
            };
        }
        static{
            this.EVENTTIME = {
                type: 3,
                value: "EVENTTIME"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcEventTriggerTypeEnum = IfcEventTriggerTypeEnum;
    class IfcEventTypeEnum {
        static{
            this.ENDEVENT = {
                type: 3,
                value: "ENDEVENT"
            };
        }
        static{
            this.INTERMEDIATEEVENT = {
                type: 3,
                value: "INTERMEDIATEEVENT"
            };
        }
        static{
            this.STARTEVENT = {
                type: 3,
                value: "STARTEVENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcEventTypeEnum = IfcEventTypeEnum;
    class IfcExternalSpatialElementTypeEnum {
        static{
            this.EXTERNAL = {
                type: 3,
                value: "EXTERNAL"
            };
        }
        static{
            this.EXTERNAL_EARTH = {
                type: 3,
                value: "EXTERNAL_EARTH"
            };
        }
        static{
            this.EXTERNAL_FIRE = {
                type: 3,
                value: "EXTERNAL_FIRE"
            };
        }
        static{
            this.EXTERNAL_WATER = {
                type: 3,
                value: "EXTERNAL_WATER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcExternalSpatialElementTypeEnum = IfcExternalSpatialElementTypeEnum;
    class IfcFacilityPartCommonTypeEnum {
        static{
            this.ABOVEGROUND = {
                type: 3,
                value: "ABOVEGROUND"
            };
        }
        static{
            this.BELOWGROUND = {
                type: 3,
                value: "BELOWGROUND"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.LEVELCROSSING = {
                type: 3,
                value: "LEVELCROSSING"
            };
        }
        static{
            this.SEGMENT = {
                type: 3,
                value: "SEGMENT"
            };
        }
        static{
            this.SUBSTRUCTURE = {
                type: 3,
                value: "SUBSTRUCTURE"
            };
        }
        static{
            this.SUPERSTRUCTURE = {
                type: 3,
                value: "SUPERSTRUCTURE"
            };
        }
        static{
            this.TERMINAL = {
                type: 3,
                value: "TERMINAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFacilityPartCommonTypeEnum = IfcFacilityPartCommonTypeEnum;
    class IfcFacilityUsageEnum {
        static{
            this.LATERAL = {
                type: 3,
                value: "LATERAL"
            };
        }
        static{
            this.LONGITUDINAL = {
                type: 3,
                value: "LONGITUDINAL"
            };
        }
        static{
            this.REGION = {
                type: 3,
                value: "REGION"
            };
        }
        static{
            this.VERTICAL = {
                type: 3,
                value: "VERTICAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFacilityUsageEnum = IfcFacilityUsageEnum;
    class IfcFanTypeEnum {
        static{
            this.CENTRIFUGALAIRFOIL = {
                type: 3,
                value: "CENTRIFUGALAIRFOIL"
            };
        }
        static{
            this.CENTRIFUGALBACKWARDINCLINEDCURVED = {
                type: 3,
                value: "CENTRIFUGALBACKWARDINCLINEDCURVED"
            };
        }
        static{
            this.CENTRIFUGALFORWARDCURVED = {
                type: 3,
                value: "CENTRIFUGALFORWARDCURVED"
            };
        }
        static{
            this.CENTRIFUGALRADIAL = {
                type: 3,
                value: "CENTRIFUGALRADIAL"
            };
        }
        static{
            this.PROPELLORAXIAL = {
                type: 3,
                value: "PROPELLORAXIAL"
            };
        }
        static{
            this.TUBEAXIAL = {
                type: 3,
                value: "TUBEAXIAL"
            };
        }
        static{
            this.VANEAXIAL = {
                type: 3,
                value: "VANEAXIAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFanTypeEnum = IfcFanTypeEnum;
    class IfcFastenerTypeEnum {
        static{
            this.GLUE = {
                type: 3,
                value: "GLUE"
            };
        }
        static{
            this.MORTAR = {
                type: 3,
                value: "MORTAR"
            };
        }
        static{
            this.WELD = {
                type: 3,
                value: "WELD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFastenerTypeEnum = IfcFastenerTypeEnum;
    class IfcFilterTypeEnum {
        static{
            this.AIRPARTICLEFILTER = {
                type: 3,
                value: "AIRPARTICLEFILTER"
            };
        }
        static{
            this.COMPRESSEDAIRFILTER = {
                type: 3,
                value: "COMPRESSEDAIRFILTER"
            };
        }
        static{
            this.ODORFILTER = {
                type: 3,
                value: "ODORFILTER"
            };
        }
        static{
            this.OILFILTER = {
                type: 3,
                value: "OILFILTER"
            };
        }
        static{
            this.STRAINER = {
                type: 3,
                value: "STRAINER"
            };
        }
        static{
            this.WATERFILTER = {
                type: 3,
                value: "WATERFILTER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFilterTypeEnum = IfcFilterTypeEnum;
    class IfcFireSuppressionTerminalTypeEnum {
        static{
            this.BREECHINGINLET = {
                type: 3,
                value: "BREECHINGINLET"
            };
        }
        static{
            this.FIREHYDRANT = {
                type: 3,
                value: "FIREHYDRANT"
            };
        }
        static{
            this.FIREMONITOR = {
                type: 3,
                value: "FIREMONITOR"
            };
        }
        static{
            this.HOSEREEL = {
                type: 3,
                value: "HOSEREEL"
            };
        }
        static{
            this.SPRINKLER = {
                type: 3,
                value: "SPRINKLER"
            };
        }
        static{
            this.SPRINKLERDEFLECTOR = {
                type: 3,
                value: "SPRINKLERDEFLECTOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;
    class IfcFlowDirectionEnum {
        static{
            this.SINK = {
                type: 3,
                value: "SINK"
            };
        }
        static{
            this.SOURCE = {
                type: 3,
                value: "SOURCE"
            };
        }
        static{
            this.SOURCEANDSINK = {
                type: 3,
                value: "SOURCEANDSINK"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFlowDirectionEnum = IfcFlowDirectionEnum;
    class IfcFlowInstrumentTypeEnum {
        static{
            this.AMMETER = {
                type: 3,
                value: "AMMETER"
            };
        }
        static{
            this.COMBINED = {
                type: 3,
                value: "COMBINED"
            };
        }
        static{
            this.FREQUENCYMETER = {
                type: 3,
                value: "FREQUENCYMETER"
            };
        }
        static{
            this.PHASEANGLEMETER = {
                type: 3,
                value: "PHASEANGLEMETER"
            };
        }
        static{
            this.POWERFACTORMETER = {
                type: 3,
                value: "POWERFACTORMETER"
            };
        }
        static{
            this.PRESSUREGAUGE = {
                type: 3,
                value: "PRESSUREGAUGE"
            };
        }
        static{
            this.THERMOMETER = {
                type: 3,
                value: "THERMOMETER"
            };
        }
        static{
            this.VOLTMETER = {
                type: 3,
                value: "VOLTMETER"
            };
        }
        static{
            this.VOLTMETER_PEAK = {
                type: 3,
                value: "VOLTMETER_PEAK"
            };
        }
        static{
            this.VOLTMETER_RMS = {
                type: 3,
                value: "VOLTMETER_RMS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;
    class IfcFlowMeterTypeEnum {
        static{
            this.ENERGYMETER = {
                type: 3,
                value: "ENERGYMETER"
            };
        }
        static{
            this.GASMETER = {
                type: 3,
                value: "GASMETER"
            };
        }
        static{
            this.OILMETER = {
                type: 3,
                value: "OILMETER"
            };
        }
        static{
            this.WATERMETER = {
                type: 3,
                value: "WATERMETER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;
    class IfcFootingTypeEnum {
        static{
            this.CAISSON_FOUNDATION = {
                type: 3,
                value: "CAISSON_FOUNDATION"
            };
        }
        static{
            this.FOOTING_BEAM = {
                type: 3,
                value: "FOOTING_BEAM"
            };
        }
        static{
            this.PAD_FOOTING = {
                type: 3,
                value: "PAD_FOOTING"
            };
        }
        static{
            this.PILE_CAP = {
                type: 3,
                value: "PILE_CAP"
            };
        }
        static{
            this.STRIP_FOOTING = {
                type: 3,
                value: "STRIP_FOOTING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFootingTypeEnum = IfcFootingTypeEnum;
    class IfcFurnitureTypeEnum {
        static{
            this.BED = {
                type: 3,
                value: "BED"
            };
        }
        static{
            this.CHAIR = {
                type: 3,
                value: "CHAIR"
            };
        }
        static{
            this.DESK = {
                type: 3,
                value: "DESK"
            };
        }
        static{
            this.FILECABINET = {
                type: 3,
                value: "FILECABINET"
            };
        }
        static{
            this.SHELF = {
                type: 3,
                value: "SHELF"
            };
        }
        static{
            this.SOFA = {
                type: 3,
                value: "SOFA"
            };
        }
        static{
            this.TABLE = {
                type: 3,
                value: "TABLE"
            };
        }
        static{
            this.TECHNICALCABINET = {
                type: 3,
                value: "TECHNICALCABINET"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcFurnitureTypeEnum = IfcFurnitureTypeEnum;
    class IfcGeographicElementTypeEnum {
        static{
            this.SOIL_BORING_POINT = {
                type: 3,
                value: "SOIL_BORING_POINT"
            };
        }
        static{
            this.TERRAIN = {
                type: 3,
                value: "TERRAIN"
            };
        }
        static{
            this.VEGETATION = {
                type: 3,
                value: "VEGETATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcGeographicElementTypeEnum = IfcGeographicElementTypeEnum;
    class IfcGeometricProjectionEnum {
        static{
            this.ELEVATION_VIEW = {
                type: 3,
                value: "ELEVATION_VIEW"
            };
        }
        static{
            this.GRAPH_VIEW = {
                type: 3,
                value: "GRAPH_VIEW"
            };
        }
        static{
            this.MODEL_VIEW = {
                type: 3,
                value: "MODEL_VIEW"
            };
        }
        static{
            this.PLAN_VIEW = {
                type: 3,
                value: "PLAN_VIEW"
            };
        }
        static{
            this.REFLECTED_PLAN_VIEW = {
                type: 3,
                value: "REFLECTED_PLAN_VIEW"
            };
        }
        static{
            this.SECTION_VIEW = {
                type: 3,
                value: "SECTION_VIEW"
            };
        }
        static{
            this.SKETCH_VIEW = {
                type: 3,
                value: "SKETCH_VIEW"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;
    class IfcGeotechnicalStratumTypeEnum {
        static{
            this.SOLID = {
                type: 3,
                value: "SOLID"
            };
        }
        static{
            this.VOID = {
                type: 3,
                value: "VOID"
            };
        }
        static{
            this.WATER = {
                type: 3,
                value: "WATER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcGeotechnicalStratumTypeEnum = IfcGeotechnicalStratumTypeEnum;
    class IfcGlobalOrLocalEnum {
        static{
            this.GLOBAL_COORDS = {
                type: 3,
                value: "GLOBAL_COORDS"
            };
        }
        static{
            this.LOCAL_COORDS = {
                type: 3,
                value: "LOCAL_COORDS"
            };
        }
    }
    IFC4X32.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;
    class IfcGridTypeEnum {
        static{
            this.IRREGULAR = {
                type: 3,
                value: "IRREGULAR"
            };
        }
        static{
            this.RADIAL = {
                type: 3,
                value: "RADIAL"
            };
        }
        static{
            this.RECTANGULAR = {
                type: 3,
                value: "RECTANGULAR"
            };
        }
        static{
            this.TRIANGULAR = {
                type: 3,
                value: "TRIANGULAR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcGridTypeEnum = IfcGridTypeEnum;
    class IfcHeatExchangerTypeEnum {
        static{
            this.PLATE = {
                type: 3,
                value: "PLATE"
            };
        }
        static{
            this.SHELLANDTUBE = {
                type: 3,
                value: "SHELLANDTUBE"
            };
        }
        static{
            this.TURNOUTHEATING = {
                type: 3,
                value: "TURNOUTHEATING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;
    class IfcHumidifierTypeEnum {
        static{
            this.ADIABATICAIRWASHER = {
                type: 3,
                value: "ADIABATICAIRWASHER"
            };
        }
        static{
            this.ADIABATICATOMIZING = {
                type: 3,
                value: "ADIABATICATOMIZING"
            };
        }
        static{
            this.ADIABATICCOMPRESSEDAIRNOZZLE = {
                type: 3,
                value: "ADIABATICCOMPRESSEDAIRNOZZLE"
            };
        }
        static{
            this.ADIABATICPAN = {
                type: 3,
                value: "ADIABATICPAN"
            };
        }
        static{
            this.ADIABATICRIGIDMEDIA = {
                type: 3,
                value: "ADIABATICRIGIDMEDIA"
            };
        }
        static{
            this.ADIABATICULTRASONIC = {
                type: 3,
                value: "ADIABATICULTRASONIC"
            };
        }
        static{
            this.ADIABATICWETTEDELEMENT = {
                type: 3,
                value: "ADIABATICWETTEDELEMENT"
            };
        }
        static{
            this.ASSISTEDBUTANE = {
                type: 3,
                value: "ASSISTEDBUTANE"
            };
        }
        static{
            this.ASSISTEDELECTRIC = {
                type: 3,
                value: "ASSISTEDELECTRIC"
            };
        }
        static{
            this.ASSISTEDNATURALGAS = {
                type: 3,
                value: "ASSISTEDNATURALGAS"
            };
        }
        static{
            this.ASSISTEDPROPANE = {
                type: 3,
                value: "ASSISTEDPROPANE"
            };
        }
        static{
            this.ASSISTEDSTEAM = {
                type: 3,
                value: "ASSISTEDSTEAM"
            };
        }
        static{
            this.STEAMINJECTION = {
                type: 3,
                value: "STEAMINJECTION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;
    class IfcImpactProtectionDeviceTypeEnum {
        static{
            this.BUMPER = {
                type: 3,
                value: "BUMPER"
            };
        }
        static{
            this.CRASHCUSHION = {
                type: 3,
                value: "CRASHCUSHION"
            };
        }
        static{
            this.DAMPINGSYSTEM = {
                type: 3,
                value: "DAMPINGSYSTEM"
            };
        }
        static{
            this.FENDER = {
                type: 3,
                value: "FENDER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcImpactProtectionDeviceTypeEnum = IfcImpactProtectionDeviceTypeEnum;
    class IfcInterceptorTypeEnum {
        static{
            this.CYCLONIC = {
                type: 3,
                value: "CYCLONIC"
            };
        }
        static{
            this.GREASE = {
                type: 3,
                value: "GREASE"
            };
        }
        static{
            this.OIL = {
                type: 3,
                value: "OIL"
            };
        }
        static{
            this.PETROL = {
                type: 3,
                value: "PETROL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcInterceptorTypeEnum = IfcInterceptorTypeEnum;
    class IfcInternalOrExternalEnum {
        static{
            this.EXTERNAL = {
                type: 3,
                value: "EXTERNAL"
            };
        }
        static{
            this.EXTERNAL_EARTH = {
                type: 3,
                value: "EXTERNAL_EARTH"
            };
        }
        static{
            this.EXTERNAL_FIRE = {
                type: 3,
                value: "EXTERNAL_FIRE"
            };
        }
        static{
            this.EXTERNAL_WATER = {
                type: 3,
                value: "EXTERNAL_WATER"
            };
        }
        static{
            this.INTERNAL = {
                type: 3,
                value: "INTERNAL"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;
    class IfcInventoryTypeEnum {
        static{
            this.ASSETINVENTORY = {
                type: 3,
                value: "ASSETINVENTORY"
            };
        }
        static{
            this.FURNITUREINVENTORY = {
                type: 3,
                value: "FURNITUREINVENTORY"
            };
        }
        static{
            this.SPACEINVENTORY = {
                type: 3,
                value: "SPACEINVENTORY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcInventoryTypeEnum = IfcInventoryTypeEnum;
    class IfcJunctionBoxTypeEnum {
        static{
            this.DATA = {
                type: 3,
                value: "DATA"
            };
        }
        static{
            this.POWER = {
                type: 3,
                value: "POWER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;
    class IfcKerbTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcKerbTypeEnum = IfcKerbTypeEnum;
    class IfcKnotType {
        static{
            this.PIECEWISE_BEZIER_KNOTS = {
                type: 3,
                value: "PIECEWISE_BEZIER_KNOTS"
            };
        }
        static{
            this.QUASI_UNIFORM_KNOTS = {
                type: 3,
                value: "QUASI_UNIFORM_KNOTS"
            };
        }
        static{
            this.UNIFORM_KNOTS = {
                type: 3,
                value: "UNIFORM_KNOTS"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC4X32.IfcKnotType = IfcKnotType;
    class IfcLaborResourceTypeEnum {
        static{
            this.ADMINISTRATION = {
                type: 3,
                value: "ADMINISTRATION"
            };
        }
        static{
            this.CARPENTRY = {
                type: 3,
                value: "CARPENTRY"
            };
        }
        static{
            this.CLEANING = {
                type: 3,
                value: "CLEANING"
            };
        }
        static{
            this.CONCRETE = {
                type: 3,
                value: "CONCRETE"
            };
        }
        static{
            this.DRYWALL = {
                type: 3,
                value: "DRYWALL"
            };
        }
        static{
            this.ELECTRIC = {
                type: 3,
                value: "ELECTRIC"
            };
        }
        static{
            this.FINISHING = {
                type: 3,
                value: "FINISHING"
            };
        }
        static{
            this.FLOORING = {
                type: 3,
                value: "FLOORING"
            };
        }
        static{
            this.GENERAL = {
                type: 3,
                value: "GENERAL"
            };
        }
        static{
            this.HVAC = {
                type: 3,
                value: "HVAC"
            };
        }
        static{
            this.LANDSCAPING = {
                type: 3,
                value: "LANDSCAPING"
            };
        }
        static{
            this.MASONRY = {
                type: 3,
                value: "MASONRY"
            };
        }
        static{
            this.PAINTING = {
                type: 3,
                value: "PAINTING"
            };
        }
        static{
            this.PAVING = {
                type: 3,
                value: "PAVING"
            };
        }
        static{
            this.PLUMBING = {
                type: 3,
                value: "PLUMBING"
            };
        }
        static{
            this.ROOFING = {
                type: 3,
                value: "ROOFING"
            };
        }
        static{
            this.SITEGRADING = {
                type: 3,
                value: "SITEGRADING"
            };
        }
        static{
            this.STEELWORK = {
                type: 3,
                value: "STEELWORK"
            };
        }
        static{
            this.SURVEYING = {
                type: 3,
                value: "SURVEYING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcLaborResourceTypeEnum = IfcLaborResourceTypeEnum;
    class IfcLampTypeEnum {
        static{
            this.COMPACTFLUORESCENT = {
                type: 3,
                value: "COMPACTFLUORESCENT"
            };
        }
        static{
            this.FLUORESCENT = {
                type: 3,
                value: "FLUORESCENT"
            };
        }
        static{
            this.HALOGEN = {
                type: 3,
                value: "HALOGEN"
            };
        }
        static{
            this.HIGHPRESSUREMERCURY = {
                type: 3,
                value: "HIGHPRESSUREMERCURY"
            };
        }
        static{
            this.HIGHPRESSURESODIUM = {
                type: 3,
                value: "HIGHPRESSURESODIUM"
            };
        }
        static{
            this.LED = {
                type: 3,
                value: "LED"
            };
        }
        static{
            this.METALHALIDE = {
                type: 3,
                value: "METALHALIDE"
            };
        }
        static{
            this.OLED = {
                type: 3,
                value: "OLED"
            };
        }
        static{
            this.TUNGSTENFILAMENT = {
                type: 3,
                value: "TUNGSTENFILAMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcLampTypeEnum = IfcLampTypeEnum;
    class IfcLayerSetDirectionEnum {
        static{
            this.AXIS1 = {
                type: 3,
                value: "AXIS1"
            };
        }
        static{
            this.AXIS2 = {
                type: 3,
                value: "AXIS2"
            };
        }
        static{
            this.AXIS3 = {
                type: 3,
                value: "AXIS3"
            };
        }
    }
    IFC4X32.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;
    class IfcLightDistributionCurveEnum {
        static{
            this.TYPE_A = {
                type: 3,
                value: "TYPE_A"
            };
        }
        static{
            this.TYPE_B = {
                type: 3,
                value: "TYPE_B"
            };
        }
        static{
            this.TYPE_C = {
                type: 3,
                value: "TYPE_C"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;
    class IfcLightEmissionSourceEnum {
        static{
            this.COMPACTFLUORESCENT = {
                type: 3,
                value: "COMPACTFLUORESCENT"
            };
        }
        static{
            this.FLUORESCENT = {
                type: 3,
                value: "FLUORESCENT"
            };
        }
        static{
            this.HIGHPRESSUREMERCURY = {
                type: 3,
                value: "HIGHPRESSUREMERCURY"
            };
        }
        static{
            this.HIGHPRESSURESODIUM = {
                type: 3,
                value: "HIGHPRESSURESODIUM"
            };
        }
        static{
            this.LIGHTEMITTINGDIODE = {
                type: 3,
                value: "LIGHTEMITTINGDIODE"
            };
        }
        static{
            this.LOWPRESSURESODIUM = {
                type: 3,
                value: "LOWPRESSURESODIUM"
            };
        }
        static{
            this.LOWVOLTAGEHALOGEN = {
                type: 3,
                value: "LOWVOLTAGEHALOGEN"
            };
        }
        static{
            this.MAINVOLTAGEHALOGEN = {
                type: 3,
                value: "MAINVOLTAGEHALOGEN"
            };
        }
        static{
            this.METALHALIDE = {
                type: 3,
                value: "METALHALIDE"
            };
        }
        static{
            this.TUNGSTENFILAMENT = {
                type: 3,
                value: "TUNGSTENFILAMENT"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;
    class IfcLightFixtureTypeEnum {
        static{
            this.DIRECTIONSOURCE = {
                type: 3,
                value: "DIRECTIONSOURCE"
            };
        }
        static{
            this.POINTSOURCE = {
                type: 3,
                value: "POINTSOURCE"
            };
        }
        static{
            this.SECURITYLIGHTING = {
                type: 3,
                value: "SECURITYLIGHTING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;
    class IfcLiquidTerminalTypeEnum {
        static{
            this.HOSEREEL = {
                type: 3,
                value: "HOSEREEL"
            };
        }
        static{
            this.LOADINGARM = {
                type: 3,
                value: "LOADINGARM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcLiquidTerminalTypeEnum = IfcLiquidTerminalTypeEnum;
    class IfcLoadGroupTypeEnum {
        static{
            this.LOAD_CASE = {
                type: 3,
                value: "LOAD_CASE"
            };
        }
        static{
            this.LOAD_COMBINATION = {
                type: 3,
                value: "LOAD_COMBINATION"
            };
        }
        static{
            this.LOAD_GROUP = {
                type: 3,
                value: "LOAD_GROUP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;
    class IfcLogicalOperatorEnum {
        static{
            this.LOGICALAND = {
                type: 3,
                value: "LOGICALAND"
            };
        }
        static{
            this.LOGICALNOTAND = {
                type: 3,
                value: "LOGICALNOTAND"
            };
        }
        static{
            this.LOGICALNOTOR = {
                type: 3,
                value: "LOGICALNOTOR"
            };
        }
        static{
            this.LOGICALOR = {
                type: 3,
                value: "LOGICALOR"
            };
        }
        static{
            this.LOGICALXOR = {
                type: 3,
                value: "LOGICALXOR"
            };
        }
    }
    IFC4X32.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;
    class IfcMarineFacilityTypeEnum {
        static{
            this.BARRIERBEACH = {
                type: 3,
                value: "BARRIERBEACH"
            };
        }
        static{
            this.BREAKWATER = {
                type: 3,
                value: "BREAKWATER"
            };
        }
        static{
            this.CANAL = {
                type: 3,
                value: "CANAL"
            };
        }
        static{
            this.DRYDOCK = {
                type: 3,
                value: "DRYDOCK"
            };
        }
        static{
            this.FLOATINGDOCK = {
                type: 3,
                value: "FLOATINGDOCK"
            };
        }
        static{
            this.HYDROLIFT = {
                type: 3,
                value: "HYDROLIFT"
            };
        }
        static{
            this.JETTY = {
                type: 3,
                value: "JETTY"
            };
        }
        static{
            this.LAUNCHRECOVERY = {
                type: 3,
                value: "LAUNCHRECOVERY"
            };
        }
        static{
            this.MARINEDEFENCE = {
                type: 3,
                value: "MARINEDEFENCE"
            };
        }
        static{
            this.NAVIGATIONALCHANNEL = {
                type: 3,
                value: "NAVIGATIONALCHANNEL"
            };
        }
        static{
            this.PORT = {
                type: 3,
                value: "PORT"
            };
        }
        static{
            this.QUAY = {
                type: 3,
                value: "QUAY"
            };
        }
        static{
            this.REVETMENT = {
                type: 3,
                value: "REVETMENT"
            };
        }
        static{
            this.SHIPLIFT = {
                type: 3,
                value: "SHIPLIFT"
            };
        }
        static{
            this.SHIPLOCK = {
                type: 3,
                value: "SHIPLOCK"
            };
        }
        static{
            this.SHIPYARD = {
                type: 3,
                value: "SHIPYARD"
            };
        }
        static{
            this.SLIPWAY = {
                type: 3,
                value: "SLIPWAY"
            };
        }
        static{
            this.WATERWAY = {
                type: 3,
                value: "WATERWAY"
            };
        }
        static{
            this.WATERWAYSHIPLIFT = {
                type: 3,
                value: "WATERWAYSHIPLIFT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcMarineFacilityTypeEnum = IfcMarineFacilityTypeEnum;
    class IfcMarinePartTypeEnum {
        static{
            this.ABOVEWATERLINE = {
                type: 3,
                value: "ABOVEWATERLINE"
            };
        }
        static{
            this.ANCHORAGE = {
                type: 3,
                value: "ANCHORAGE"
            };
        }
        static{
            this.APPROACHCHANNEL = {
                type: 3,
                value: "APPROACHCHANNEL"
            };
        }
        static{
            this.BELOWWATERLINE = {
                type: 3,
                value: "BELOWWATERLINE"
            };
        }
        static{
            this.BERTHINGSTRUCTURE = {
                type: 3,
                value: "BERTHINGSTRUCTURE"
            };
        }
        static{
            this.CHAMBER = {
                type: 3,
                value: "CHAMBER"
            };
        }
        static{
            this.CILL_LEVEL = {
                type: 3,
                value: "CILL_LEVEL"
            };
        }
        static{
            this.COPELEVEL = {
                type: 3,
                value: "COPELEVEL"
            };
        }
        static{
            this.CORE = {
                type: 3,
                value: "CORE"
            };
        }
        static{
            this.CREST = {
                type: 3,
                value: "CREST"
            };
        }
        static{
            this.GATEHEAD = {
                type: 3,
                value: "GATEHEAD"
            };
        }
        static{
            this.GUDINGSTRUCTURE = {
                type: 3,
                value: "GUDINGSTRUCTURE"
            };
        }
        static{
            this.HIGHWATERLINE = {
                type: 3,
                value: "HIGHWATERLINE"
            };
        }
        static{
            this.LANDFIELD = {
                type: 3,
                value: "LANDFIELD"
            };
        }
        static{
            this.LEEWARDSIDE = {
                type: 3,
                value: "LEEWARDSIDE"
            };
        }
        static{
            this.LOWWATERLINE = {
                type: 3,
                value: "LOWWATERLINE"
            };
        }
        static{
            this.MANUFACTURING = {
                type: 3,
                value: "MANUFACTURING"
            };
        }
        static{
            this.NAVIGATIONALAREA = {
                type: 3,
                value: "NAVIGATIONALAREA"
            };
        }
        static{
            this.PROTECTION = {
                type: 3,
                value: "PROTECTION"
            };
        }
        static{
            this.SHIPTRANSFER = {
                type: 3,
                value: "SHIPTRANSFER"
            };
        }
        static{
            this.STORAGEAREA = {
                type: 3,
                value: "STORAGEAREA"
            };
        }
        static{
            this.VEHICLESERVICING = {
                type: 3,
                value: "VEHICLESERVICING"
            };
        }
        static{
            this.WATERFIELD = {
                type: 3,
                value: "WATERFIELD"
            };
        }
        static{
            this.WEATHERSIDE = {
                type: 3,
                value: "WEATHERSIDE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcMarinePartTypeEnum = IfcMarinePartTypeEnum;
    class IfcMechanicalFastenerTypeEnum {
        static{
            this.ANCHORBOLT = {
                type: 3,
                value: "ANCHORBOLT"
            };
        }
        static{
            this.BOLT = {
                type: 3,
                value: "BOLT"
            };
        }
        static{
            this.CHAIN = {
                type: 3,
                value: "CHAIN"
            };
        }
        static{
            this.COUPLER = {
                type: 3,
                value: "COUPLER"
            };
        }
        static{
            this.DOWEL = {
                type: 3,
                value: "DOWEL"
            };
        }
        static{
            this.NAIL = {
                type: 3,
                value: "NAIL"
            };
        }
        static{
            this.NAILPLATE = {
                type: 3,
                value: "NAILPLATE"
            };
        }
        static{
            this.RAILFASTENING = {
                type: 3,
                value: "RAILFASTENING"
            };
        }
        static{
            this.RAILJOINT = {
                type: 3,
                value: "RAILJOINT"
            };
        }
        static{
            this.RIVET = {
                type: 3,
                value: "RIVET"
            };
        }
        static{
            this.ROPE = {
                type: 3,
                value: "ROPE"
            };
        }
        static{
            this.SCREW = {
                type: 3,
                value: "SCREW"
            };
        }
        static{
            this.SHEARCONNECTOR = {
                type: 3,
                value: "SHEARCONNECTOR"
            };
        }
        static{
            this.STAPLE = {
                type: 3,
                value: "STAPLE"
            };
        }
        static{
            this.STUDSHEARCONNECTOR = {
                type: 3,
                value: "STUDSHEARCONNECTOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcMechanicalFastenerTypeEnum = IfcMechanicalFastenerTypeEnum;
    class IfcMedicalDeviceTypeEnum {
        static{
            this.AIRSTATION = {
                type: 3,
                value: "AIRSTATION"
            };
        }
        static{
            this.FEEDAIRUNIT = {
                type: 3,
                value: "FEEDAIRUNIT"
            };
        }
        static{
            this.OXYGENGENERATOR = {
                type: 3,
                value: "OXYGENGENERATOR"
            };
        }
        static{
            this.OXYGENPLANT = {
                type: 3,
                value: "OXYGENPLANT"
            };
        }
        static{
            this.VACUUMSTATION = {
                type: 3,
                value: "VACUUMSTATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcMedicalDeviceTypeEnum = IfcMedicalDeviceTypeEnum;
    class IfcMemberTypeEnum {
        static{
            this.ARCH_SEGMENT = {
                type: 3,
                value: "ARCH_SEGMENT"
            };
        }
        static{
            this.BRACE = {
                type: 3,
                value: "BRACE"
            };
        }
        static{
            this.CHORD = {
                type: 3,
                value: "CHORD"
            };
        }
        static{
            this.COLLAR = {
                type: 3,
                value: "COLLAR"
            };
        }
        static{
            this.MEMBER = {
                type: 3,
                value: "MEMBER"
            };
        }
        static{
            this.MULLION = {
                type: 3,
                value: "MULLION"
            };
        }
        static{
            this.PLATE = {
                type: 3,
                value: "PLATE"
            };
        }
        static{
            this.POST = {
                type: 3,
                value: "POST"
            };
        }
        static{
            this.PURLIN = {
                type: 3,
                value: "PURLIN"
            };
        }
        static{
            this.RAFTER = {
                type: 3,
                value: "RAFTER"
            };
        }
        static{
            this.STAY_CABLE = {
                type: 3,
                value: "STAY_CABLE"
            };
        }
        static{
            this.STIFFENING_RIB = {
                type: 3,
                value: "STIFFENING_RIB"
            };
        }
        static{
            this.STRINGER = {
                type: 3,
                value: "STRINGER"
            };
        }
        static{
            this.STRUCTURALCABLE = {
                type: 3,
                value: "STRUCTURALCABLE"
            };
        }
        static{
            this.STRUT = {
                type: 3,
                value: "STRUT"
            };
        }
        static{
            this.STUD = {
                type: 3,
                value: "STUD"
            };
        }
        static{
            this.SUSPENDER = {
                type: 3,
                value: "SUSPENDER"
            };
        }
        static{
            this.SUSPENSION_CABLE = {
                type: 3,
                value: "SUSPENSION_CABLE"
            };
        }
        static{
            this.TIEBAR = {
                type: 3,
                value: "TIEBAR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcMemberTypeEnum = IfcMemberTypeEnum;
    class IfcMobileTelecommunicationsApplianceTypeEnum {
        static{
            this.ACCESSPOINT = {
                type: 3,
                value: "ACCESSPOINT"
            };
        }
        static{
            this.BASEBANDUNIT = {
                type: 3,
                value: "BASEBANDUNIT"
            };
        }
        static{
            this.BASETRANSCEIVERSTATION = {
                type: 3,
                value: "BASETRANSCEIVERSTATION"
            };
        }
        static{
            this.E_UTRAN_NODE_B = {
                type: 3,
                value: "E_UTRAN_NODE_B"
            };
        }
        static{
            this.GATEWAY_GPRS_SUPPORT_NODE = {
                type: 3,
                value: "GATEWAY_GPRS_SUPPORT_NODE"
            };
        }
        static{
            this.MASTERUNIT = {
                type: 3,
                value: "MASTERUNIT"
            };
        }
        static{
            this.MOBILESWITCHINGCENTER = {
                type: 3,
                value: "MOBILESWITCHINGCENTER"
            };
        }
        static{
            this.MSCSERVER = {
                type: 3,
                value: "MSCSERVER"
            };
        }
        static{
            this.PACKETCONTROLUNIT = {
                type: 3,
                value: "PACKETCONTROLUNIT"
            };
        }
        static{
            this.REMOTERADIOUNIT = {
                type: 3,
                value: "REMOTERADIOUNIT"
            };
        }
        static{
            this.REMOTEUNIT = {
                type: 3,
                value: "REMOTEUNIT"
            };
        }
        static{
            this.SERVICE_GPRS_SUPPORT_NODE = {
                type: 3,
                value: "SERVICE_GPRS_SUPPORT_NODE"
            };
        }
        static{
            this.SUBSCRIBERSERVER = {
                type: 3,
                value: "SUBSCRIBERSERVER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcMobileTelecommunicationsApplianceTypeEnum = IfcMobileTelecommunicationsApplianceTypeEnum;
    class IfcMooringDeviceTypeEnum {
        static{
            this.BOLLARD = {
                type: 3,
                value: "BOLLARD"
            };
        }
        static{
            this.LINETENSIONER = {
                type: 3,
                value: "LINETENSIONER"
            };
        }
        static{
            this.MAGNETICDEVICE = {
                type: 3,
                value: "MAGNETICDEVICE"
            };
        }
        static{
            this.MOORINGHOOKS = {
                type: 3,
                value: "MOORINGHOOKS"
            };
        }
        static{
            this.VACUUMDEVICE = {
                type: 3,
                value: "VACUUMDEVICE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcMooringDeviceTypeEnum = IfcMooringDeviceTypeEnum;
    class IfcMotorConnectionTypeEnum {
        static{
            this.BELTDRIVE = {
                type: 3,
                value: "BELTDRIVE"
            };
        }
        static{
            this.COUPLING = {
                type: 3,
                value: "COUPLING"
            };
        }
        static{
            this.DIRECTDRIVE = {
                type: 3,
                value: "DIRECTDRIVE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;
    class IfcNavigationElementTypeEnum {
        static{
            this.BEACON = {
                type: 3,
                value: "BEACON"
            };
        }
        static{
            this.BUOY = {
                type: 3,
                value: "BUOY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcNavigationElementTypeEnum = IfcNavigationElementTypeEnum;
    class IfcObjectiveEnum {
        static{
            this.CODECOMPLIANCE = {
                type: 3,
                value: "CODECOMPLIANCE"
            };
        }
        static{
            this.CODEWAIVER = {
                type: 3,
                value: "CODEWAIVER"
            };
        }
        static{
            this.DESIGNINTENT = {
                type: 3,
                value: "DESIGNINTENT"
            };
        }
        static{
            this.EXTERNAL = {
                type: 3,
                value: "EXTERNAL"
            };
        }
        static{
            this.HEALTHANDSAFETY = {
                type: 3,
                value: "HEALTHANDSAFETY"
            };
        }
        static{
            this.MERGECONFLICT = {
                type: 3,
                value: "MERGECONFLICT"
            };
        }
        static{
            this.MODELVIEW = {
                type: 3,
                value: "MODELVIEW"
            };
        }
        static{
            this.PARAMETER = {
                type: 3,
                value: "PARAMETER"
            };
        }
        static{
            this.REQUIREMENT = {
                type: 3,
                value: "REQUIREMENT"
            };
        }
        static{
            this.SPECIFICATION = {
                type: 3,
                value: "SPECIFICATION"
            };
        }
        static{
            this.TRIGGERCONDITION = {
                type: 3,
                value: "TRIGGERCONDITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcObjectiveEnum = IfcObjectiveEnum;
    class IfcOccupantTypeEnum {
        static{
            this.ASSIGNEE = {
                type: 3,
                value: "ASSIGNEE"
            };
        }
        static{
            this.ASSIGNOR = {
                type: 3,
                value: "ASSIGNOR"
            };
        }
        static{
            this.LESSEE = {
                type: 3,
                value: "LESSEE"
            };
        }
        static{
            this.LESSOR = {
                type: 3,
                value: "LESSOR"
            };
        }
        static{
            this.LETTINGAGENT = {
                type: 3,
                value: "LETTINGAGENT"
            };
        }
        static{
            this.OWNER = {
                type: 3,
                value: "OWNER"
            };
        }
        static{
            this.TENANT = {
                type: 3,
                value: "TENANT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcOccupantTypeEnum = IfcOccupantTypeEnum;
    class IfcOpeningElementTypeEnum {
        static{
            this.OPENING = {
                type: 3,
                value: "OPENING"
            };
        }
        static{
            this.RECESS = {
                type: 3,
                value: "RECESS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcOpeningElementTypeEnum = IfcOpeningElementTypeEnum;
    class IfcOutletTypeEnum {
        static{
            this.AUDIOVISUALOUTLET = {
                type: 3,
                value: "AUDIOVISUALOUTLET"
            };
        }
        static{
            this.COMMUNICATIONSOUTLET = {
                type: 3,
                value: "COMMUNICATIONSOUTLET"
            };
        }
        static{
            this.DATAOUTLET = {
                type: 3,
                value: "DATAOUTLET"
            };
        }
        static{
            this.POWEROUTLET = {
                type: 3,
                value: "POWEROUTLET"
            };
        }
        static{
            this.TELEPHONEOUTLET = {
                type: 3,
                value: "TELEPHONEOUTLET"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcOutletTypeEnum = IfcOutletTypeEnum;
    class IfcPavementTypeEnum {
        static{
            this.FLEXIBLE = {
                type: 3,
                value: "FLEXIBLE"
            };
        }
        static{
            this.RIGID = {
                type: 3,
                value: "RIGID"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPavementTypeEnum = IfcPavementTypeEnum;
    class IfcPerformanceHistoryTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPerformanceHistoryTypeEnum = IfcPerformanceHistoryTypeEnum;
    class IfcPermeableCoveringOperationEnum {
        static{
            this.GRILL = {
                type: 3,
                value: "GRILL"
            };
        }
        static{
            this.LOUVER = {
                type: 3,
                value: "LOUVER"
            };
        }
        static{
            this.SCREEN = {
                type: 3,
                value: "SCREEN"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;
    class IfcPermitTypeEnum {
        static{
            this.ACCESS = {
                type: 3,
                value: "ACCESS"
            };
        }
        static{
            this.BUILDING = {
                type: 3,
                value: "BUILDING"
            };
        }
        static{
            this.WORK = {
                type: 3,
                value: "WORK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPermitTypeEnum = IfcPermitTypeEnum;
    class IfcPhysicalOrVirtualEnum {
        static{
            this.PHYSICAL = {
                type: 3,
                value: "PHYSICAL"
            };
        }
        static{
            this.VIRTUAL = {
                type: 3,
                value: "VIRTUAL"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;
    class IfcPileConstructionEnum {
        static{
            this.CAST_IN_PLACE = {
                type: 3,
                value: "CAST_IN_PLACE"
            };
        }
        static{
            this.COMPOSITE = {
                type: 3,
                value: "COMPOSITE"
            };
        }
        static{
            this.PRECAST_CONCRETE = {
                type: 3,
                value: "PRECAST_CONCRETE"
            };
        }
        static{
            this.PREFAB_STEEL = {
                type: 3,
                value: "PREFAB_STEEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPileConstructionEnum = IfcPileConstructionEnum;
    class IfcPileTypeEnum {
        static{
            this.BORED = {
                type: 3,
                value: "BORED"
            };
        }
        static{
            this.COHESION = {
                type: 3,
                value: "COHESION"
            };
        }
        static{
            this.DRIVEN = {
                type: 3,
                value: "DRIVEN"
            };
        }
        static{
            this.FRICTION = {
                type: 3,
                value: "FRICTION"
            };
        }
        static{
            this.JETGROUTING = {
                type: 3,
                value: "JETGROUTING"
            };
        }
        static{
            this.SUPPORT = {
                type: 3,
                value: "SUPPORT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPileTypeEnum = IfcPileTypeEnum;
    class IfcPipeFittingTypeEnum {
        static{
            this.BEND = {
                type: 3,
                value: "BEND"
            };
        }
        static{
            this.CONNECTOR = {
                type: 3,
                value: "CONNECTOR"
            };
        }
        static{
            this.ENTRY = {
                type: 3,
                value: "ENTRY"
            };
        }
        static{
            this.EXIT = {
                type: 3,
                value: "EXIT"
            };
        }
        static{
            this.JUNCTION = {
                type: 3,
                value: "JUNCTION"
            };
        }
        static{
            this.OBSTRUCTION = {
                type: 3,
                value: "OBSTRUCTION"
            };
        }
        static{
            this.TRANSITION = {
                type: 3,
                value: "TRANSITION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;
    class IfcPipeSegmentTypeEnum {
        static{
            this.CULVERT = {
                type: 3,
                value: "CULVERT"
            };
        }
        static{
            this.FLEXIBLESEGMENT = {
                type: 3,
                value: "FLEXIBLESEGMENT"
            };
        }
        static{
            this.GUTTER = {
                type: 3,
                value: "GUTTER"
            };
        }
        static{
            this.RIGIDSEGMENT = {
                type: 3,
                value: "RIGIDSEGMENT"
            };
        }
        static{
            this.SPOOL = {
                type: 3,
                value: "SPOOL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;
    class IfcPlateTypeEnum {
        static{
            this.BASE_PLATE = {
                type: 3,
                value: "BASE_PLATE"
            };
        }
        static{
            this.COVER_PLATE = {
                type: 3,
                value: "COVER_PLATE"
            };
        }
        static{
            this.CURTAIN_PANEL = {
                type: 3,
                value: "CURTAIN_PANEL"
            };
        }
        static{
            this.FLANGE_PLATE = {
                type: 3,
                value: "FLANGE_PLATE"
            };
        }
        static{
            this.GUSSET_PLATE = {
                type: 3,
                value: "GUSSET_PLATE"
            };
        }
        static{
            this.SHEET = {
                type: 3,
                value: "SHEET"
            };
        }
        static{
            this.SPLICE_PLATE = {
                type: 3,
                value: "SPLICE_PLATE"
            };
        }
        static{
            this.STIFFENER_PLATE = {
                type: 3,
                value: "STIFFENER_PLATE"
            };
        }
        static{
            this.WEB_PLATE = {
                type: 3,
                value: "WEB_PLATE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPlateTypeEnum = IfcPlateTypeEnum;
    class IfcPreferredSurfaceCurveRepresentation {
        static{
            this.CURVE3D = {
                type: 3,
                value: "CURVE3D"
            };
        }
        static{
            this.PCURVE_S1 = {
                type: 3,
                value: "PCURVE_S1"
            };
        }
        static{
            this.PCURVE_S2 = {
                type: 3,
                value: "PCURVE_S2"
            };
        }
    }
    IFC4X32.IfcPreferredSurfaceCurveRepresentation = IfcPreferredSurfaceCurveRepresentation;
    class IfcProcedureTypeEnum {
        static{
            this.ADVICE_CAUTION = {
                type: 3,
                value: "ADVICE_CAUTION"
            };
        }
        static{
            this.ADVICE_NOTE = {
                type: 3,
                value: "ADVICE_NOTE"
            };
        }
        static{
            this.ADVICE_WARNING = {
                type: 3,
                value: "ADVICE_WARNING"
            };
        }
        static{
            this.CALIBRATION = {
                type: 3,
                value: "CALIBRATION"
            };
        }
        static{
            this.DIAGNOSTIC = {
                type: 3,
                value: "DIAGNOSTIC"
            };
        }
        static{
            this.SHUTDOWN = {
                type: 3,
                value: "SHUTDOWN"
            };
        }
        static{
            this.STARTUP = {
                type: 3,
                value: "STARTUP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcProcedureTypeEnum = IfcProcedureTypeEnum;
    class IfcProfileTypeEnum {
        static{
            this.AREA = {
                type: 3,
                value: "AREA"
            };
        }
        static{
            this.CURVE = {
                type: 3,
                value: "CURVE"
            };
        }
    }
    IFC4X32.IfcProfileTypeEnum = IfcProfileTypeEnum;
    class IfcProjectOrderTypeEnum {
        static{
            this.CHANGEORDER = {
                type: 3,
                value: "CHANGEORDER"
            };
        }
        static{
            this.MAINTENANCEWORKORDER = {
                type: 3,
                value: "MAINTENANCEWORKORDER"
            };
        }
        static{
            this.MOVEORDER = {
                type: 3,
                value: "MOVEORDER"
            };
        }
        static{
            this.PURCHASEORDER = {
                type: 3,
                value: "PURCHASEORDER"
            };
        }
        static{
            this.WORKORDER = {
                type: 3,
                value: "WORKORDER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;
    class IfcProjectedOrTrueLengthEnum {
        static{
            this.PROJECTED_LENGTH = {
                type: 3,
                value: "PROJECTED_LENGTH"
            };
        }
        static{
            this.TRUE_LENGTH = {
                type: 3,
                value: "TRUE_LENGTH"
            };
        }
    }
    IFC4X32.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;
    class IfcProjectionElementTypeEnum {
        static{
            this.BLISTER = {
                type: 3,
                value: "BLISTER"
            };
        }
        static{
            this.DEVIATOR = {
                type: 3,
                value: "DEVIATOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcProjectionElementTypeEnum = IfcProjectionElementTypeEnum;
    class IfcPropertySetTemplateTypeEnum {
        static{
            this.PSET_MATERIALDRIVEN = {
                type: 3,
                value: "PSET_MATERIALDRIVEN"
            };
        }
        static{
            this.PSET_OCCURRENCEDRIVEN = {
                type: 3,
                value: "PSET_OCCURRENCEDRIVEN"
            };
        }
        static{
            this.PSET_PERFORMANCEDRIVEN = {
                type: 3,
                value: "PSET_PERFORMANCEDRIVEN"
            };
        }
        static{
            this.PSET_PROFILEDRIVEN = {
                type: 3,
                value: "PSET_PROFILEDRIVEN"
            };
        }
        static{
            this.PSET_TYPEDRIVENONLY = {
                type: 3,
                value: "PSET_TYPEDRIVENONLY"
            };
        }
        static{
            this.PSET_TYPEDRIVENOVERRIDE = {
                type: 3,
                value: "PSET_TYPEDRIVENOVERRIDE"
            };
        }
        static{
            this.QTO_OCCURRENCEDRIVEN = {
                type: 3,
                value: "QTO_OCCURRENCEDRIVEN"
            };
        }
        static{
            this.QTO_TYPEDRIVENONLY = {
                type: 3,
                value: "QTO_TYPEDRIVENONLY"
            };
        }
        static{
            this.QTO_TYPEDRIVENOVERRIDE = {
                type: 3,
                value: "QTO_TYPEDRIVENOVERRIDE"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPropertySetTemplateTypeEnum = IfcPropertySetTemplateTypeEnum;
    class IfcProtectiveDeviceTrippingUnitTypeEnum {
        static{
            this.ELECTROMAGNETIC = {
                type: 3,
                value: "ELECTROMAGNETIC"
            };
        }
        static{
            this.ELECTRONIC = {
                type: 3,
                value: "ELECTRONIC"
            };
        }
        static{
            this.RESIDUALCURRENT = {
                type: 3,
                value: "RESIDUALCURRENT"
            };
        }
        static{
            this.THERMAL = {
                type: 3,
                value: "THERMAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcProtectiveDeviceTrippingUnitTypeEnum = IfcProtectiveDeviceTrippingUnitTypeEnum;
    class IfcProtectiveDeviceTypeEnum {
        static{
            this.ANTI_ARCING_DEVICE = {
                type: 3,
                value: "ANTI_ARCING_DEVICE"
            };
        }
        static{
            this.CIRCUITBREAKER = {
                type: 3,
                value: "CIRCUITBREAKER"
            };
        }
        static{
            this.EARTHINGSWITCH = {
                type: 3,
                value: "EARTHINGSWITCH"
            };
        }
        static{
            this.EARTHLEAKAGECIRCUITBREAKER = {
                type: 3,
                value: "EARTHLEAKAGECIRCUITBREAKER"
            };
        }
        static{
            this.FUSEDISCONNECTOR = {
                type: 3,
                value: "FUSEDISCONNECTOR"
            };
        }
        static{
            this.RESIDUALCURRENTCIRCUITBREAKER = {
                type: 3,
                value: "RESIDUALCURRENTCIRCUITBREAKER"
            };
        }
        static{
            this.RESIDUALCURRENTSWITCH = {
                type: 3,
                value: "RESIDUALCURRENTSWITCH"
            };
        }
        static{
            this.SPARKGAP = {
                type: 3,
                value: "SPARKGAP"
            };
        }
        static{
            this.VARISTOR = {
                type: 3,
                value: "VARISTOR"
            };
        }
        static{
            this.VOLTAGELIMITER = {
                type: 3,
                value: "VOLTAGELIMITER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;
    class IfcPumpTypeEnum {
        static{
            this.CIRCULATOR = {
                type: 3,
                value: "CIRCULATOR"
            };
        }
        static{
            this.ENDSUCTION = {
                type: 3,
                value: "ENDSUCTION"
            };
        }
        static{
            this.SPLITCASE = {
                type: 3,
                value: "SPLITCASE"
            };
        }
        static{
            this.SUBMERSIBLEPUMP = {
                type: 3,
                value: "SUBMERSIBLEPUMP"
            };
        }
        static{
            this.SUMPPUMP = {
                type: 3,
                value: "SUMPPUMP"
            };
        }
        static{
            this.VERTICALINLINE = {
                type: 3,
                value: "VERTICALINLINE"
            };
        }
        static{
            this.VERTICALTURBINE = {
                type: 3,
                value: "VERTICALTURBINE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcPumpTypeEnum = IfcPumpTypeEnum;
    class IfcRailTypeEnum {
        static{
            this.BLADE = {
                type: 3,
                value: "BLADE"
            };
        }
        static{
            this.CHECKRAIL = {
                type: 3,
                value: "CHECKRAIL"
            };
        }
        static{
            this.GUARDRAIL = {
                type: 3,
                value: "GUARDRAIL"
            };
        }
        static{
            this.RACKRAIL = {
                type: 3,
                value: "RACKRAIL"
            };
        }
        static{
            this.RAIL = {
                type: 3,
                value: "RAIL"
            };
        }
        static{
            this.STOCKRAIL = {
                type: 3,
                value: "STOCKRAIL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcRailTypeEnum = IfcRailTypeEnum;
    class IfcRailingTypeEnum {
        static{
            this.BALUSTRADE = {
                type: 3,
                value: "BALUSTRADE"
            };
        }
        static{
            this.FENCE = {
                type: 3,
                value: "FENCE"
            };
        }
        static{
            this.GUARDRAIL = {
                type: 3,
                value: "GUARDRAIL"
            };
        }
        static{
            this.HANDRAIL = {
                type: 3,
                value: "HANDRAIL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcRailingTypeEnum = IfcRailingTypeEnum;
    class IfcRailwayPartTypeEnum {
        static{
            this.ABOVETRACK = {
                type: 3,
                value: "ABOVETRACK"
            };
        }
        static{
            this.DILATIONTRACK = {
                type: 3,
                value: "DILATIONTRACK"
            };
        }
        static{
            this.LINESIDE = {
                type: 3,
                value: "LINESIDE"
            };
        }
        static{
            this.LINESIDEPART = {
                type: 3,
                value: "LINESIDEPART"
            };
        }
        static{
            this.PLAINTRACK = {
                type: 3,
                value: "PLAINTRACK"
            };
        }
        static{
            this.SUBSTRUCTURE = {
                type: 3,
                value: "SUBSTRUCTURE"
            };
        }
        static{
            this.TRACK = {
                type: 3,
                value: "TRACK"
            };
        }
        static{
            this.TRACKPART = {
                type: 3,
                value: "TRACKPART"
            };
        }
        static{
            this.TURNOUTTRACK = {
                type: 3,
                value: "TURNOUTTRACK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcRailwayPartTypeEnum = IfcRailwayPartTypeEnum;
    class IfcRailwayTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcRailwayTypeEnum = IfcRailwayTypeEnum;
    class IfcRampFlightTypeEnum {
        static{
            this.SPIRAL = {
                type: 3,
                value: "SPIRAL"
            };
        }
        static{
            this.STRAIGHT = {
                type: 3,
                value: "STRAIGHT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;
    class IfcRampTypeEnum {
        static{
            this.HALF_TURN_RAMP = {
                type: 3,
                value: "HALF_TURN_RAMP"
            };
        }
        static{
            this.QUARTER_TURN_RAMP = {
                type: 3,
                value: "QUARTER_TURN_RAMP"
            };
        }
        static{
            this.SPIRAL_RAMP = {
                type: 3,
                value: "SPIRAL_RAMP"
            };
        }
        static{
            this.STRAIGHT_RUN_RAMP = {
                type: 3,
                value: "STRAIGHT_RUN_RAMP"
            };
        }
        static{
            this.TWO_QUARTER_TURN_RAMP = {
                type: 3,
                value: "TWO_QUARTER_TURN_RAMP"
            };
        }
        static{
            this.TWO_STRAIGHT_RUN_RAMP = {
                type: 3,
                value: "TWO_STRAIGHT_RUN_RAMP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcRampTypeEnum = IfcRampTypeEnum;
    class IfcRecurrenceTypeEnum {
        static{
            this.BY_DAY_COUNT = {
                type: 3,
                value: "BY_DAY_COUNT"
            };
        }
        static{
            this.BY_WEEKDAY_COUNT = {
                type: 3,
                value: "BY_WEEKDAY_COUNT"
            };
        }
        static{
            this.DAILY = {
                type: 3,
                value: "DAILY"
            };
        }
        static{
            this.MONTHLY_BY_DAY_OF_MONTH = {
                type: 3,
                value: "MONTHLY_BY_DAY_OF_MONTH"
            };
        }
        static{
            this.MONTHLY_BY_POSITION = {
                type: 3,
                value: "MONTHLY_BY_POSITION"
            };
        }
        static{
            this.WEEKLY = {
                type: 3,
                value: "WEEKLY"
            };
        }
        static{
            this.YEARLY_BY_DAY_OF_MONTH = {
                type: 3,
                value: "YEARLY_BY_DAY_OF_MONTH"
            };
        }
        static{
            this.YEARLY_BY_POSITION = {
                type: 3,
                value: "YEARLY_BY_POSITION"
            };
        }
    }
    IFC4X32.IfcRecurrenceTypeEnum = IfcRecurrenceTypeEnum;
    class IfcReferentTypeEnum {
        static{
            this.BOUNDARY = {
                type: 3,
                value: "BOUNDARY"
            };
        }
        static{
            this.INTERSECTION = {
                type: 3,
                value: "INTERSECTION"
            };
        }
        static{
            this.KILOPOINT = {
                type: 3,
                value: "KILOPOINT"
            };
        }
        static{
            this.LANDMARK = {
                type: 3,
                value: "LANDMARK"
            };
        }
        static{
            this.MILEPOINT = {
                type: 3,
                value: "MILEPOINT"
            };
        }
        static{
            this.POSITION = {
                type: 3,
                value: "POSITION"
            };
        }
        static{
            this.REFERENCEMARKER = {
                type: 3,
                value: "REFERENCEMARKER"
            };
        }
        static{
            this.STATION = {
                type: 3,
                value: "STATION"
            };
        }
        static{
            this.SUPERELEVATIONEVENT = {
                type: 3,
                value: "SUPERELEVATIONEVENT"
            };
        }
        static{
            this.WIDTHEVENT = {
                type: 3,
                value: "WIDTHEVENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcReferentTypeEnum = IfcReferentTypeEnum;
    class IfcReflectanceMethodEnum {
        static{
            this.BLINN = {
                type: 3,
                value: "BLINN"
            };
        }
        static{
            this.FLAT = {
                type: 3,
                value: "FLAT"
            };
        }
        static{
            this.GLASS = {
                type: 3,
                value: "GLASS"
            };
        }
        static{
            this.MATT = {
                type: 3,
                value: "MATT"
            };
        }
        static{
            this.METAL = {
                type: 3,
                value: "METAL"
            };
        }
        static{
            this.MIRROR = {
                type: 3,
                value: "MIRROR"
            };
        }
        static{
            this.PHONG = {
                type: 3,
                value: "PHONG"
            };
        }
        static{
            this.PHYSICAL = {
                type: 3,
                value: "PHYSICAL"
            };
        }
        static{
            this.PLASTIC = {
                type: 3,
                value: "PLASTIC"
            };
        }
        static{
            this.STRAUSS = {
                type: 3,
                value: "STRAUSS"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;
    class IfcReinforcedSoilTypeEnum {
        static{
            this.DYNAMICALLYCOMPACTED = {
                type: 3,
                value: "DYNAMICALLYCOMPACTED"
            };
        }
        static{
            this.GROUTED = {
                type: 3,
                value: "GROUTED"
            };
        }
        static{
            this.REPLACED = {
                type: 3,
                value: "REPLACED"
            };
        }
        static{
            this.ROLLERCOMPACTED = {
                type: 3,
                value: "ROLLERCOMPACTED"
            };
        }
        static{
            this.SURCHARGEPRELOADED = {
                type: 3,
                value: "SURCHARGEPRELOADED"
            };
        }
        static{
            this.VERTICALLYDRAINED = {
                type: 3,
                value: "VERTICALLYDRAINED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcReinforcedSoilTypeEnum = IfcReinforcedSoilTypeEnum;
    class IfcReinforcingBarRoleEnum {
        static{
            this.ANCHORING = {
                type: 3,
                value: "ANCHORING"
            };
        }
        static{
            this.EDGE = {
                type: 3,
                value: "EDGE"
            };
        }
        static{
            this.LIGATURE = {
                type: 3,
                value: "LIGATURE"
            };
        }
        static{
            this.MAIN = {
                type: 3,
                value: "MAIN"
            };
        }
        static{
            this.PUNCHING = {
                type: 3,
                value: "PUNCHING"
            };
        }
        static{
            this.RING = {
                type: 3,
                value: "RING"
            };
        }
        static{
            this.SHEAR = {
                type: 3,
                value: "SHEAR"
            };
        }
        static{
            this.STUD = {
                type: 3,
                value: "STUD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;
    class IfcReinforcingBarSurfaceEnum {
        static{
            this.PLAIN = {
                type: 3,
                value: "PLAIN"
            };
        }
        static{
            this.TEXTURED = {
                type: 3,
                value: "TEXTURED"
            };
        }
    }
    IFC4X32.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;
    class IfcReinforcingBarTypeEnum {
        static{
            this.ANCHORING = {
                type: 3,
                value: "ANCHORING"
            };
        }
        static{
            this.EDGE = {
                type: 3,
                value: "EDGE"
            };
        }
        static{
            this.LIGATURE = {
                type: 3,
                value: "LIGATURE"
            };
        }
        static{
            this.MAIN = {
                type: 3,
                value: "MAIN"
            };
        }
        static{
            this.PUNCHING = {
                type: 3,
                value: "PUNCHING"
            };
        }
        static{
            this.RING = {
                type: 3,
                value: "RING"
            };
        }
        static{
            this.SHEAR = {
                type: 3,
                value: "SHEAR"
            };
        }
        static{
            this.SPACEBAR = {
                type: 3,
                value: "SPACEBAR"
            };
        }
        static{
            this.STUD = {
                type: 3,
                value: "STUD"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcReinforcingBarTypeEnum = IfcReinforcingBarTypeEnum;
    class IfcReinforcingMeshTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcReinforcingMeshTypeEnum = IfcReinforcingMeshTypeEnum;
    class IfcRoadPartTypeEnum {
        static{
            this.BICYCLECROSSING = {
                type: 3,
                value: "BICYCLECROSSING"
            };
        }
        static{
            this.BUS_STOP = {
                type: 3,
                value: "BUS_STOP"
            };
        }
        static{
            this.CARRIAGEWAY = {
                type: 3,
                value: "CARRIAGEWAY"
            };
        }
        static{
            this.CENTRALISLAND = {
                type: 3,
                value: "CENTRALISLAND"
            };
        }
        static{
            this.CENTRALRESERVE = {
                type: 3,
                value: "CENTRALRESERVE"
            };
        }
        static{
            this.HARDSHOULDER = {
                type: 3,
                value: "HARDSHOULDER"
            };
        }
        static{
            this.INTERSECTION = {
                type: 3,
                value: "INTERSECTION"
            };
        }
        static{
            this.LAYBY = {
                type: 3,
                value: "LAYBY"
            };
        }
        static{
            this.PARKINGBAY = {
                type: 3,
                value: "PARKINGBAY"
            };
        }
        static{
            this.PASSINGBAY = {
                type: 3,
                value: "PASSINGBAY"
            };
        }
        static{
            this.PEDESTRIAN_CROSSING = {
                type: 3,
                value: "PEDESTRIAN_CROSSING"
            };
        }
        static{
            this.RAILWAYCROSSING = {
                type: 3,
                value: "RAILWAYCROSSING"
            };
        }
        static{
            this.REFUGEISLAND = {
                type: 3,
                value: "REFUGEISLAND"
            };
        }
        static{
            this.ROADSEGMENT = {
                type: 3,
                value: "ROADSEGMENT"
            };
        }
        static{
            this.ROADSIDE = {
                type: 3,
                value: "ROADSIDE"
            };
        }
        static{
            this.ROADSIDEPART = {
                type: 3,
                value: "ROADSIDEPART"
            };
        }
        static{
            this.ROADWAYPLATEAU = {
                type: 3,
                value: "ROADWAYPLATEAU"
            };
        }
        static{
            this.ROUNDABOUT = {
                type: 3,
                value: "ROUNDABOUT"
            };
        }
        static{
            this.SHOULDER = {
                type: 3,
                value: "SHOULDER"
            };
        }
        static{
            this.SIDEWALK = {
                type: 3,
                value: "SIDEWALK"
            };
        }
        static{
            this.SOFTSHOULDER = {
                type: 3,
                value: "SOFTSHOULDER"
            };
        }
        static{
            this.TOLLPLAZA = {
                type: 3,
                value: "TOLLPLAZA"
            };
        }
        static{
            this.TRAFFICISLAND = {
                type: 3,
                value: "TRAFFICISLAND"
            };
        }
        static{
            this.TRAFFICLANE = {
                type: 3,
                value: "TRAFFICLANE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcRoadPartTypeEnum = IfcRoadPartTypeEnum;
    class IfcRoadTypeEnum {
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcRoadTypeEnum = IfcRoadTypeEnum;
    class IfcRoleEnum {
        static{
            this.ARCHITECT = {
                type: 3,
                value: "ARCHITECT"
            };
        }
        static{
            this.BUILDINGOPERATOR = {
                type: 3,
                value: "BUILDINGOPERATOR"
            };
        }
        static{
            this.BUILDINGOWNER = {
                type: 3,
                value: "BUILDINGOWNER"
            };
        }
        static{
            this.CIVILENGINEER = {
                type: 3,
                value: "CIVILENGINEER"
            };
        }
        static{
            this.CLIENT = {
                type: 3,
                value: "CLIENT"
            };
        }
        static{
            this.COMMISSIONINGENGINEER = {
                type: 3,
                value: "COMMISSIONINGENGINEER"
            };
        }
        static{
            this.CONSTRUCTIONMANAGER = {
                type: 3,
                value: "CONSTRUCTIONMANAGER"
            };
        }
        static{
            this.CONSULTANT = {
                type: 3,
                value: "CONSULTANT"
            };
        }
        static{
            this.CONTRACTOR = {
                type: 3,
                value: "CONTRACTOR"
            };
        }
        static{
            this.COSTENGINEER = {
                type: 3,
                value: "COSTENGINEER"
            };
        }
        static{
            this.ELECTRICALENGINEER = {
                type: 3,
                value: "ELECTRICALENGINEER"
            };
        }
        static{
            this.ENGINEER = {
                type: 3,
                value: "ENGINEER"
            };
        }
        static{
            this.FACILITIESMANAGER = {
                type: 3,
                value: "FACILITIESMANAGER"
            };
        }
        static{
            this.FIELDCONSTRUCTIONMANAGER = {
                type: 3,
                value: "FIELDCONSTRUCTIONMANAGER"
            };
        }
        static{
            this.MANUFACTURER = {
                type: 3,
                value: "MANUFACTURER"
            };
        }
        static{
            this.MECHANICALENGINEER = {
                type: 3,
                value: "MECHANICALENGINEER"
            };
        }
        static{
            this.OWNER = {
                type: 3,
                value: "OWNER"
            };
        }
        static{
            this.PROJECTMANAGER = {
                type: 3,
                value: "PROJECTMANAGER"
            };
        }
        static{
            this.RESELLER = {
                type: 3,
                value: "RESELLER"
            };
        }
        static{
            this.STRUCTURALENGINEER = {
                type: 3,
                value: "STRUCTURALENGINEER"
            };
        }
        static{
            this.SUBCONTRACTOR = {
                type: 3,
                value: "SUBCONTRACTOR"
            };
        }
        static{
            this.SUPPLIER = {
                type: 3,
                value: "SUPPLIER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC4X32.IfcRoleEnum = IfcRoleEnum;
    class IfcRoofTypeEnum {
        static{
            this.BARREL_ROOF = {
                type: 3,
                value: "BARREL_ROOF"
            };
        }
        static{
            this.BUTTERFLY_ROOF = {
                type: 3,
                value: "BUTTERFLY_ROOF"
            };
        }
        static{
            this.DOME_ROOF = {
                type: 3,
                value: "DOME_ROOF"
            };
        }
        static{
            this.FLAT_ROOF = {
                type: 3,
                value: "FLAT_ROOF"
            };
        }
        static{
            this.FREEFORM = {
                type: 3,
                value: "FREEFORM"
            };
        }
        static{
            this.GABLE_ROOF = {
                type: 3,
                value: "GABLE_ROOF"
            };
        }
        static{
            this.GAMBREL_ROOF = {
                type: 3,
                value: "GAMBREL_ROOF"
            };
        }
        static{
            this.HIPPED_GABLE_ROOF = {
                type: 3,
                value: "HIPPED_GABLE_ROOF"
            };
        }
        static{
            this.HIP_ROOF = {
                type: 3,
                value: "HIP_ROOF"
            };
        }
        static{
            this.MANSARD_ROOF = {
                type: 3,
                value: "MANSARD_ROOF"
            };
        }
        static{
            this.PAVILION_ROOF = {
                type: 3,
                value: "PAVILION_ROOF"
            };
        }
        static{
            this.RAINBOW_ROOF = {
                type: 3,
                value: "RAINBOW_ROOF"
            };
        }
        static{
            this.SHED_ROOF = {
                type: 3,
                value: "SHED_ROOF"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcRoofTypeEnum = IfcRoofTypeEnum;
    class IfcSIPrefix {
        static{
            this.ATTO = {
                type: 3,
                value: "ATTO"
            };
        }
        static{
            this.CENTI = {
                type: 3,
                value: "CENTI"
            };
        }
        static{
            this.DECA = {
                type: 3,
                value: "DECA"
            };
        }
        static{
            this.DECI = {
                type: 3,
                value: "DECI"
            };
        }
        static{
            this.EXA = {
                type: 3,
                value: "EXA"
            };
        }
        static{
            this.FEMTO = {
                type: 3,
                value: "FEMTO"
            };
        }
        static{
            this.GIGA = {
                type: 3,
                value: "GIGA"
            };
        }
        static{
            this.HECTO = {
                type: 3,
                value: "HECTO"
            };
        }
        static{
            this.KILO = {
                type: 3,
                value: "KILO"
            };
        }
        static{
            this.MEGA = {
                type: 3,
                value: "MEGA"
            };
        }
        static{
            this.MICRO = {
                type: 3,
                value: "MICRO"
            };
        }
        static{
            this.MILLI = {
                type: 3,
                value: "MILLI"
            };
        }
        static{
            this.NANO = {
                type: 3,
                value: "NANO"
            };
        }
        static{
            this.PETA = {
                type: 3,
                value: "PETA"
            };
        }
        static{
            this.PICO = {
                type: 3,
                value: "PICO"
            };
        }
        static{
            this.TERA = {
                type: 3,
                value: "TERA"
            };
        }
    }
    IFC4X32.IfcSIPrefix = IfcSIPrefix;
    class IfcSIUnitName {
        static{
            this.AMPERE = {
                type: 3,
                value: "AMPERE"
            };
        }
        static{
            this.BECQUEREL = {
                type: 3,
                value: "BECQUEREL"
            };
        }
        static{
            this.CANDELA = {
                type: 3,
                value: "CANDELA"
            };
        }
        static{
            this.COULOMB = {
                type: 3,
                value: "COULOMB"
            };
        }
        static{
            this.CUBIC_METRE = {
                type: 3,
                value: "CUBIC_METRE"
            };
        }
        static{
            this.DEGREE_CELSIUS = {
                type: 3,
                value: "DEGREE_CELSIUS"
            };
        }
        static{
            this.FARAD = {
                type: 3,
                value: "FARAD"
            };
        }
        static{
            this.GRAM = {
                type: 3,
                value: "GRAM"
            };
        }
        static{
            this.GRAY = {
                type: 3,
                value: "GRAY"
            };
        }
        static{
            this.HENRY = {
                type: 3,
                value: "HENRY"
            };
        }
        static{
            this.HERTZ = {
                type: 3,
                value: "HERTZ"
            };
        }
        static{
            this.JOULE = {
                type: 3,
                value: "JOULE"
            };
        }
        static{
            this.KELVIN = {
                type: 3,
                value: "KELVIN"
            };
        }
        static{
            this.LUMEN = {
                type: 3,
                value: "LUMEN"
            };
        }
        static{
            this.LUX = {
                type: 3,
                value: "LUX"
            };
        }
        static{
            this.METRE = {
                type: 3,
                value: "METRE"
            };
        }
        static{
            this.MOLE = {
                type: 3,
                value: "MOLE"
            };
        }
        static{
            this.NEWTON = {
                type: 3,
                value: "NEWTON"
            };
        }
        static{
            this.OHM = {
                type: 3,
                value: "OHM"
            };
        }
        static{
            this.PASCAL = {
                type: 3,
                value: "PASCAL"
            };
        }
        static{
            this.RADIAN = {
                type: 3,
                value: "RADIAN"
            };
        }
        static{
            this.SECOND = {
                type: 3,
                value: "SECOND"
            };
        }
        static{
            this.SIEMENS = {
                type: 3,
                value: "SIEMENS"
            };
        }
        static{
            this.SIEVERT = {
                type: 3,
                value: "SIEVERT"
            };
        }
        static{
            this.SQUARE_METRE = {
                type: 3,
                value: "SQUARE_METRE"
            };
        }
        static{
            this.STERADIAN = {
                type: 3,
                value: "STERADIAN"
            };
        }
        static{
            this.TESLA = {
                type: 3,
                value: "TESLA"
            };
        }
        static{
            this.VOLT = {
                type: 3,
                value: "VOLT"
            };
        }
        static{
            this.WATT = {
                type: 3,
                value: "WATT"
            };
        }
        static{
            this.WEBER = {
                type: 3,
                value: "WEBER"
            };
        }
    }
    IFC4X32.IfcSIUnitName = IfcSIUnitName;
    class IfcSanitaryTerminalTypeEnum {
        static{
            this.BATH = {
                type: 3,
                value: "BATH"
            };
        }
        static{
            this.BIDET = {
                type: 3,
                value: "BIDET"
            };
        }
        static{
            this.CISTERN = {
                type: 3,
                value: "CISTERN"
            };
        }
        static{
            this.SANITARYFOUNTAIN = {
                type: 3,
                value: "SANITARYFOUNTAIN"
            };
        }
        static{
            this.SHOWER = {
                type: 3,
                value: "SHOWER"
            };
        }
        static{
            this.SINK = {
                type: 3,
                value: "SINK"
            };
        }
        static{
            this.TOILETPAN = {
                type: 3,
                value: "TOILETPAN"
            };
        }
        static{
            this.URINAL = {
                type: 3,
                value: "URINAL"
            };
        }
        static{
            this.WASHHANDBASIN = {
                type: 3,
                value: "WASHHANDBASIN"
            };
        }
        static{
            this.WCSEAT = {
                type: 3,
                value: "WCSEAT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;
    class IfcSectionTypeEnum {
        static{
            this.TAPERED = {
                type: 3,
                value: "TAPERED"
            };
        }
        static{
            this.UNIFORM = {
                type: 3,
                value: "UNIFORM"
            };
        }
    }
    IFC4X32.IfcSectionTypeEnum = IfcSectionTypeEnum;
    class IfcSensorTypeEnum {
        static{
            this.CO2SENSOR = {
                type: 3,
                value: "CO2SENSOR"
            };
        }
        static{
            this.CONDUCTANCESENSOR = {
                type: 3,
                value: "CONDUCTANCESENSOR"
            };
        }
        static{
            this.CONTACTSENSOR = {
                type: 3,
                value: "CONTACTSENSOR"
            };
        }
        static{
            this.COSENSOR = {
                type: 3,
                value: "COSENSOR"
            };
        }
        static{
            this.EARTHQUAKESENSOR = {
                type: 3,
                value: "EARTHQUAKESENSOR"
            };
        }
        static{
            this.FIRESENSOR = {
                type: 3,
                value: "FIRESENSOR"
            };
        }
        static{
            this.FLOWSENSOR = {
                type: 3,
                value: "FLOWSENSOR"
            };
        }
        static{
            this.FOREIGNOBJECTDETECTIONSENSOR = {
                type: 3,
                value: "FOREIGNOBJECTDETECTIONSENSOR"
            };
        }
        static{
            this.FROSTSENSOR = {
                type: 3,
                value: "FROSTSENSOR"
            };
        }
        static{
            this.GASSENSOR = {
                type: 3,
                value: "GASSENSOR"
            };
        }
        static{
            this.HEATSENSOR = {
                type: 3,
                value: "HEATSENSOR"
            };
        }
        static{
            this.HUMIDITYSENSOR = {
                type: 3,
                value: "HUMIDITYSENSOR"
            };
        }
        static{
            this.IDENTIFIERSENSOR = {
                type: 3,
                value: "IDENTIFIERSENSOR"
            };
        }
        static{
            this.IONCONCENTRATIONSENSOR = {
                type: 3,
                value: "IONCONCENTRATIONSENSOR"
            };
        }
        static{
            this.LEVELSENSOR = {
                type: 3,
                value: "LEVELSENSOR"
            };
        }
        static{
            this.LIGHTSENSOR = {
                type: 3,
                value: "LIGHTSENSOR"
            };
        }
        static{
            this.MOISTURESENSOR = {
                type: 3,
                value: "MOISTURESENSOR"
            };
        }
        static{
            this.MOVEMENTSENSOR = {
                type: 3,
                value: "MOVEMENTSENSOR"
            };
        }
        static{
            this.OBSTACLESENSOR = {
                type: 3,
                value: "OBSTACLESENSOR"
            };
        }
        static{
            this.PHSENSOR = {
                type: 3,
                value: "PHSENSOR"
            };
        }
        static{
            this.PRESSURESENSOR = {
                type: 3,
                value: "PRESSURESENSOR"
            };
        }
        static{
            this.RADIATIONSENSOR = {
                type: 3,
                value: "RADIATIONSENSOR"
            };
        }
        static{
            this.RADIOACTIVITYSENSOR = {
                type: 3,
                value: "RADIOACTIVITYSENSOR"
            };
        }
        static{
            this.RAINSENSOR = {
                type: 3,
                value: "RAINSENSOR"
            };
        }
        static{
            this.SMOKESENSOR = {
                type: 3,
                value: "SMOKESENSOR"
            };
        }
        static{
            this.SNOWDEPTHSENSOR = {
                type: 3,
                value: "SNOWDEPTHSENSOR"
            };
        }
        static{
            this.SOUNDSENSOR = {
                type: 3,
                value: "SOUNDSENSOR"
            };
        }
        static{
            this.TEMPERATURESENSOR = {
                type: 3,
                value: "TEMPERATURESENSOR"
            };
        }
        static{
            this.TRAINSENSOR = {
                type: 3,
                value: "TRAINSENSOR"
            };
        }
        static{
            this.TURNOUTCLOSURESENSOR = {
                type: 3,
                value: "TURNOUTCLOSURESENSOR"
            };
        }
        static{
            this.WHEELSENSOR = {
                type: 3,
                value: "WHEELSENSOR"
            };
        }
        static{
            this.WINDSENSOR = {
                type: 3,
                value: "WINDSENSOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSensorTypeEnum = IfcSensorTypeEnum;
    class IfcSequenceEnum {
        static{
            this.FINISH_FINISH = {
                type: 3,
                value: "FINISH_FINISH"
            };
        }
        static{
            this.FINISH_START = {
                type: 3,
                value: "FINISH_START"
            };
        }
        static{
            this.START_FINISH = {
                type: 3,
                value: "START_FINISH"
            };
        }
        static{
            this.START_START = {
                type: 3,
                value: "START_START"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSequenceEnum = IfcSequenceEnum;
    class IfcShadingDeviceTypeEnum {
        static{
            this.AWNING = {
                type: 3,
                value: "AWNING"
            };
        }
        static{
            this.JALOUSIE = {
                type: 3,
                value: "JALOUSIE"
            };
        }
        static{
            this.SHUTTER = {
                type: 3,
                value: "SHUTTER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcShadingDeviceTypeEnum = IfcShadingDeviceTypeEnum;
    class IfcSignTypeEnum {
        static{
            this.MARKER = {
                type: 3,
                value: "MARKER"
            };
        }
        static{
            this.MIRROR = {
                type: 3,
                value: "MIRROR"
            };
        }
        static{
            this.PICTORAL = {
                type: 3,
                value: "PICTORAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSignTypeEnum = IfcSignTypeEnum;
    class IfcSignalTypeEnum {
        static{
            this.AUDIO = {
                type: 3,
                value: "AUDIO"
            };
        }
        static{
            this.MIXED = {
                type: 3,
                value: "MIXED"
            };
        }
        static{
            this.VISUAL = {
                type: 3,
                value: "VISUAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSignalTypeEnum = IfcSignalTypeEnum;
    class IfcSimplePropertyTemplateTypeEnum {
        static{
            this.P_BOUNDEDVALUE = {
                type: 3,
                value: "P_BOUNDEDVALUE"
            };
        }
        static{
            this.P_ENUMERATEDVALUE = {
                type: 3,
                value: "P_ENUMERATEDVALUE"
            };
        }
        static{
            this.P_LISTVALUE = {
                type: 3,
                value: "P_LISTVALUE"
            };
        }
        static{
            this.P_REFERENCEVALUE = {
                type: 3,
                value: "P_REFERENCEVALUE"
            };
        }
        static{
            this.P_SINGLEVALUE = {
                type: 3,
                value: "P_SINGLEVALUE"
            };
        }
        static{
            this.P_TABLEVALUE = {
                type: 3,
                value: "P_TABLEVALUE"
            };
        }
        static{
            this.Q_AREA = {
                type: 3,
                value: "Q_AREA"
            };
        }
        static{
            this.Q_COUNT = {
                type: 3,
                value: "Q_COUNT"
            };
        }
        static{
            this.Q_LENGTH = {
                type: 3,
                value: "Q_LENGTH"
            };
        }
        static{
            this.Q_NUMBER = {
                type: 3,
                value: "Q_NUMBER"
            };
        }
        static{
            this.Q_TIME = {
                type: 3,
                value: "Q_TIME"
            };
        }
        static{
            this.Q_VOLUME = {
                type: 3,
                value: "Q_VOLUME"
            };
        }
        static{
            this.Q_WEIGHT = {
                type: 3,
                value: "Q_WEIGHT"
            };
        }
    }
    IFC4X32.IfcSimplePropertyTemplateTypeEnum = IfcSimplePropertyTemplateTypeEnum;
    class IfcSlabTypeEnum {
        static{
            this.APPROACH_SLAB = {
                type: 3,
                value: "APPROACH_SLAB"
            };
        }
        static{
            this.BASESLAB = {
                type: 3,
                value: "BASESLAB"
            };
        }
        static{
            this.FLOOR = {
                type: 3,
                value: "FLOOR"
            };
        }
        static{
            this.LANDING = {
                type: 3,
                value: "LANDING"
            };
        }
        static{
            this.PAVING = {
                type: 3,
                value: "PAVING"
            };
        }
        static{
            this.ROOF = {
                type: 3,
                value: "ROOF"
            };
        }
        static{
            this.SIDEWALK = {
                type: 3,
                value: "SIDEWALK"
            };
        }
        static{
            this.TRACKSLAB = {
                type: 3,
                value: "TRACKSLAB"
            };
        }
        static{
            this.WEARING = {
                type: 3,
                value: "WEARING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSlabTypeEnum = IfcSlabTypeEnum;
    class IfcSolarDeviceTypeEnum {
        static{
            this.SOLARCOLLECTOR = {
                type: 3,
                value: "SOLARCOLLECTOR"
            };
        }
        static{
            this.SOLARPANEL = {
                type: 3,
                value: "SOLARPANEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSolarDeviceTypeEnum = IfcSolarDeviceTypeEnum;
    class IfcSpaceHeaterTypeEnum {
        static{
            this.CONVECTOR = {
                type: 3,
                value: "CONVECTOR"
            };
        }
        static{
            this.RADIATOR = {
                type: 3,
                value: "RADIATOR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;
    class IfcSpaceTypeEnum {
        static{
            this.BERTH = {
                type: 3,
                value: "BERTH"
            };
        }
        static{
            this.EXTERNAL = {
                type: 3,
                value: "EXTERNAL"
            };
        }
        static{
            this.GFA = {
                type: 3,
                value: "GFA"
            };
        }
        static{
            this.INTERNAL = {
                type: 3,
                value: "INTERNAL"
            };
        }
        static{
            this.PARKING = {
                type: 3,
                value: "PARKING"
            };
        }
        static{
            this.SPACE = {
                type: 3,
                value: "SPACE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSpaceTypeEnum = IfcSpaceTypeEnum;
    class IfcSpatialZoneTypeEnum {
        static{
            this.CONSTRUCTION = {
                type: 3,
                value: "CONSTRUCTION"
            };
        }
        static{
            this.FIRESAFETY = {
                type: 3,
                value: "FIRESAFETY"
            };
        }
        static{
            this.INTERFERENCE = {
                type: 3,
                value: "INTERFERENCE"
            };
        }
        static{
            this.LIGHTING = {
                type: 3,
                value: "LIGHTING"
            };
        }
        static{
            this.OCCUPANCY = {
                type: 3,
                value: "OCCUPANCY"
            };
        }
        static{
            this.RESERVATION = {
                type: 3,
                value: "RESERVATION"
            };
        }
        static{
            this.SECURITY = {
                type: 3,
                value: "SECURITY"
            };
        }
        static{
            this.THERMAL = {
                type: 3,
                value: "THERMAL"
            };
        }
        static{
            this.TRANSPORT = {
                type: 3,
                value: "TRANSPORT"
            };
        }
        static{
            this.VENTILATION = {
                type: 3,
                value: "VENTILATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSpatialZoneTypeEnum = IfcSpatialZoneTypeEnum;
    class IfcStackTerminalTypeEnum {
        static{
            this.BIRDCAGE = {
                type: 3,
                value: "BIRDCAGE"
            };
        }
        static{
            this.COWL = {
                type: 3,
                value: "COWL"
            };
        }
        static{
            this.RAINWATERHOPPER = {
                type: 3,
                value: "RAINWATERHOPPER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;
    class IfcStairFlightTypeEnum {
        static{
            this.CURVED = {
                type: 3,
                value: "CURVED"
            };
        }
        static{
            this.FREEFORM = {
                type: 3,
                value: "FREEFORM"
            };
        }
        static{
            this.SPIRAL = {
                type: 3,
                value: "SPIRAL"
            };
        }
        static{
            this.STRAIGHT = {
                type: 3,
                value: "STRAIGHT"
            };
        }
        static{
            this.WINDER = {
                type: 3,
                value: "WINDER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;
    class IfcStairTypeEnum {
        static{
            this.CURVED_RUN_STAIR = {
                type: 3,
                value: "CURVED_RUN_STAIR"
            };
        }
        static{
            this.DOUBLE_RETURN_STAIR = {
                type: 3,
                value: "DOUBLE_RETURN_STAIR"
            };
        }
        static{
            this.HALF_TURN_STAIR = {
                type: 3,
                value: "HALF_TURN_STAIR"
            };
        }
        static{
            this.HALF_WINDING_STAIR = {
                type: 3,
                value: "HALF_WINDING_STAIR"
            };
        }
        static{
            this.LADDER = {
                type: 3,
                value: "LADDER"
            };
        }
        static{
            this.QUARTER_TURN_STAIR = {
                type: 3,
                value: "QUARTER_TURN_STAIR"
            };
        }
        static{
            this.QUARTER_WINDING_STAIR = {
                type: 3,
                value: "QUARTER_WINDING_STAIR"
            };
        }
        static{
            this.SPIRAL_STAIR = {
                type: 3,
                value: "SPIRAL_STAIR"
            };
        }
        static{
            this.STRAIGHT_RUN_STAIR = {
                type: 3,
                value: "STRAIGHT_RUN_STAIR"
            };
        }
        static{
            this.THREE_QUARTER_TURN_STAIR = {
                type: 3,
                value: "THREE_QUARTER_TURN_STAIR"
            };
        }
        static{
            this.THREE_QUARTER_WINDING_STAIR = {
                type: 3,
                value: "THREE_QUARTER_WINDING_STAIR"
            };
        }
        static{
            this.TWO_CURVED_RUN_STAIR = {
                type: 3,
                value: "TWO_CURVED_RUN_STAIR"
            };
        }
        static{
            this.TWO_QUARTER_TURN_STAIR = {
                type: 3,
                value: "TWO_QUARTER_TURN_STAIR"
            };
        }
        static{
            this.TWO_QUARTER_WINDING_STAIR = {
                type: 3,
                value: "TWO_QUARTER_WINDING_STAIR"
            };
        }
        static{
            this.TWO_STRAIGHT_RUN_STAIR = {
                type: 3,
                value: "TWO_STRAIGHT_RUN_STAIR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcStairTypeEnum = IfcStairTypeEnum;
    class IfcStateEnum {
        static{
            this.LOCKED = {
                type: 3,
                value: "LOCKED"
            };
        }
        static{
            this.READONLY = {
                type: 3,
                value: "READONLY"
            };
        }
        static{
            this.READONLYLOCKED = {
                type: 3,
                value: "READONLYLOCKED"
            };
        }
        static{
            this.READWRITE = {
                type: 3,
                value: "READWRITE"
            };
        }
        static{
            this.READWRITELOCKED = {
                type: 3,
                value: "READWRITELOCKED"
            };
        }
    }
    IFC4X32.IfcStateEnum = IfcStateEnum;
    class IfcStructuralCurveActivityTypeEnum {
        static{
            this.CONST = {
                type: 3,
                value: "CONST"
            };
        }
        static{
            this.DISCRETE = {
                type: 3,
                value: "DISCRETE"
            };
        }
        static{
            this.EQUIDISTANT = {
                type: 3,
                value: "EQUIDISTANT"
            };
        }
        static{
            this.LINEAR = {
                type: 3,
                value: "LINEAR"
            };
        }
        static{
            this.PARABOLA = {
                type: 3,
                value: "PARABOLA"
            };
        }
        static{
            this.POLYGONAL = {
                type: 3,
                value: "POLYGONAL"
            };
        }
        static{
            this.SINUS = {
                type: 3,
                value: "SINUS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcStructuralCurveActivityTypeEnum = IfcStructuralCurveActivityTypeEnum;
    class IfcStructuralCurveMemberTypeEnum {
        static{
            this.CABLE = {
                type: 3,
                value: "CABLE"
            };
        }
        static{
            this.COMPRESSION_MEMBER = {
                type: 3,
                value: "COMPRESSION_MEMBER"
            };
        }
        static{
            this.PIN_JOINED_MEMBER = {
                type: 3,
                value: "PIN_JOINED_MEMBER"
            };
        }
        static{
            this.RIGID_JOINED_MEMBER = {
                type: 3,
                value: "RIGID_JOINED_MEMBER"
            };
        }
        static{
            this.TENSION_MEMBER = {
                type: 3,
                value: "TENSION_MEMBER"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcStructuralCurveMemberTypeEnum = IfcStructuralCurveMemberTypeEnum;
    class IfcStructuralSurfaceActivityTypeEnum {
        static{
            this.BILINEAR = {
                type: 3,
                value: "BILINEAR"
            };
        }
        static{
            this.CONST = {
                type: 3,
                value: "CONST"
            };
        }
        static{
            this.DISCRETE = {
                type: 3,
                value: "DISCRETE"
            };
        }
        static{
            this.ISOCONTOUR = {
                type: 3,
                value: "ISOCONTOUR"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcStructuralSurfaceActivityTypeEnum = IfcStructuralSurfaceActivityTypeEnum;
    class IfcStructuralSurfaceMemberTypeEnum {
        static{
            this.BENDING_ELEMENT = {
                type: 3,
                value: "BENDING_ELEMENT"
            };
        }
        static{
            this.MEMBRANE_ELEMENT = {
                type: 3,
                value: "MEMBRANE_ELEMENT"
            };
        }
        static{
            this.SHELL = {
                type: 3,
                value: "SHELL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcStructuralSurfaceMemberTypeEnum = IfcStructuralSurfaceMemberTypeEnum;
    class IfcSubContractResourceTypeEnum {
        static{
            this.PURCHASE = {
                type: 3,
                value: "PURCHASE"
            };
        }
        static{
            this.WORK = {
                type: 3,
                value: "WORK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSubContractResourceTypeEnum = IfcSubContractResourceTypeEnum;
    class IfcSurfaceFeatureTypeEnum {
        static{
            this.DEFECT = {
                type: 3,
                value: "DEFECT"
            };
        }
        static{
            this.HATCHMARKING = {
                type: 3,
                value: "HATCHMARKING"
            };
        }
        static{
            this.LINEMARKING = {
                type: 3,
                value: "LINEMARKING"
            };
        }
        static{
            this.MARK = {
                type: 3,
                value: "MARK"
            };
        }
        static{
            this.NONSKIDSURFACING = {
                type: 3,
                value: "NONSKIDSURFACING"
            };
        }
        static{
            this.PAVEMENTSURFACEMARKING = {
                type: 3,
                value: "PAVEMENTSURFACEMARKING"
            };
        }
        static{
            this.RUMBLESTRIP = {
                type: 3,
                value: "RUMBLESTRIP"
            };
        }
        static{
            this.SYMBOLMARKING = {
                type: 3,
                value: "SYMBOLMARKING"
            };
        }
        static{
            this.TAG = {
                type: 3,
                value: "TAG"
            };
        }
        static{
            this.TRANSVERSERUMBLESTRIP = {
                type: 3,
                value: "TRANSVERSERUMBLESTRIP"
            };
        }
        static{
            this.TREATMENT = {
                type: 3,
                value: "TREATMENT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSurfaceFeatureTypeEnum = IfcSurfaceFeatureTypeEnum;
    class IfcSurfaceSide {
        static{
            this.BOTH = {
                type: 3,
                value: "BOTH"
            };
        }
        static{
            this.NEGATIVE = {
                type: 3,
                value: "NEGATIVE"
            };
        }
        static{
            this.POSITIVE = {
                type: 3,
                value: "POSITIVE"
            };
        }
    }
    IFC4X32.IfcSurfaceSide = IfcSurfaceSide;
    class IfcSwitchingDeviceTypeEnum {
        static{
            this.CONTACTOR = {
                type: 3,
                value: "CONTACTOR"
            };
        }
        static{
            this.DIMMERSWITCH = {
                type: 3,
                value: "DIMMERSWITCH"
            };
        }
        static{
            this.EMERGENCYSTOP = {
                type: 3,
                value: "EMERGENCYSTOP"
            };
        }
        static{
            this.KEYPAD = {
                type: 3,
                value: "KEYPAD"
            };
        }
        static{
            this.MOMENTARYSWITCH = {
                type: 3,
                value: "MOMENTARYSWITCH"
            };
        }
        static{
            this.RELAY = {
                type: 3,
                value: "RELAY"
            };
        }
        static{
            this.SELECTORSWITCH = {
                type: 3,
                value: "SELECTORSWITCH"
            };
        }
        static{
            this.STARTER = {
                type: 3,
                value: "STARTER"
            };
        }
        static{
            this.START_AND_STOP_EQUIPMENT = {
                type: 3,
                value: "START_AND_STOP_EQUIPMENT"
            };
        }
        static{
            this.SWITCHDISCONNECTOR = {
                type: 3,
                value: "SWITCHDISCONNECTOR"
            };
        }
        static{
            this.TOGGLESWITCH = {
                type: 3,
                value: "TOGGLESWITCH"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;
    class IfcSystemFurnitureElementTypeEnum {
        static{
            this.PANEL = {
                type: 3,
                value: "PANEL"
            };
        }
        static{
            this.SUBRACK = {
                type: 3,
                value: "SUBRACK"
            };
        }
        static{
            this.WORKSURFACE = {
                type: 3,
                value: "WORKSURFACE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcSystemFurnitureElementTypeEnum = IfcSystemFurnitureElementTypeEnum;
    class IfcTankTypeEnum {
        static{
            this.BASIN = {
                type: 3,
                value: "BASIN"
            };
        }
        static{
            this.BREAKPRESSURE = {
                type: 3,
                value: "BREAKPRESSURE"
            };
        }
        static{
            this.EXPANSION = {
                type: 3,
                value: "EXPANSION"
            };
        }
        static{
            this.FEEDANDEXPANSION = {
                type: 3,
                value: "FEEDANDEXPANSION"
            };
        }
        static{
            this.OILRETENTIONTRAY = {
                type: 3,
                value: "OILRETENTIONTRAY"
            };
        }
        static{
            this.PRESSUREVESSEL = {
                type: 3,
                value: "PRESSUREVESSEL"
            };
        }
        static{
            this.STORAGE = {
                type: 3,
                value: "STORAGE"
            };
        }
        static{
            this.VESSEL = {
                type: 3,
                value: "VESSEL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTankTypeEnum = IfcTankTypeEnum;
    class IfcTaskDurationEnum {
        static{
            this.ELAPSEDTIME = {
                type: 3,
                value: "ELAPSEDTIME"
            };
        }
        static{
            this.WORKTIME = {
                type: 3,
                value: "WORKTIME"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTaskDurationEnum = IfcTaskDurationEnum;
    class IfcTaskTypeEnum {
        static{
            this.ADJUSTMENT = {
                type: 3,
                value: "ADJUSTMENT"
            };
        }
        static{
            this.ATTENDANCE = {
                type: 3,
                value: "ATTENDANCE"
            };
        }
        static{
            this.CALIBRATION = {
                type: 3,
                value: "CALIBRATION"
            };
        }
        static{
            this.CONSTRUCTION = {
                type: 3,
                value: "CONSTRUCTION"
            };
        }
        static{
            this.DEMOLITION = {
                type: 3,
                value: "DEMOLITION"
            };
        }
        static{
            this.DISMANTLE = {
                type: 3,
                value: "DISMANTLE"
            };
        }
        static{
            this.DISPOSAL = {
                type: 3,
                value: "DISPOSAL"
            };
        }
        static{
            this.EMERGENCY = {
                type: 3,
                value: "EMERGENCY"
            };
        }
        static{
            this.INSPECTION = {
                type: 3,
                value: "INSPECTION"
            };
        }
        static{
            this.INSTALLATION = {
                type: 3,
                value: "INSTALLATION"
            };
        }
        static{
            this.LOGISTIC = {
                type: 3,
                value: "LOGISTIC"
            };
        }
        static{
            this.MAINTENANCE = {
                type: 3,
                value: "MAINTENANCE"
            };
        }
        static{
            this.MOVE = {
                type: 3,
                value: "MOVE"
            };
        }
        static{
            this.OPERATION = {
                type: 3,
                value: "OPERATION"
            };
        }
        static{
            this.REMOVAL = {
                type: 3,
                value: "REMOVAL"
            };
        }
        static{
            this.RENOVATION = {
                type: 3,
                value: "RENOVATION"
            };
        }
        static{
            this.SAFETY = {
                type: 3,
                value: "SAFETY"
            };
        }
        static{
            this.SHUTDOWN = {
                type: 3,
                value: "SHUTDOWN"
            };
        }
        static{
            this.STARTUP = {
                type: 3,
                value: "STARTUP"
            };
        }
        static{
            this.TESTING = {
                type: 3,
                value: "TESTING"
            };
        }
        static{
            this.TROUBLESHOOTING = {
                type: 3,
                value: "TROUBLESHOOTING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTaskTypeEnum = IfcTaskTypeEnum;
    class IfcTendonAnchorTypeEnum {
        static{
            this.COUPLER = {
                type: 3,
                value: "COUPLER"
            };
        }
        static{
            this.FIXED_END = {
                type: 3,
                value: "FIXED_END"
            };
        }
        static{
            this.TENSIONING_END = {
                type: 3,
                value: "TENSIONING_END"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTendonAnchorTypeEnum = IfcTendonAnchorTypeEnum;
    class IfcTendonConduitTypeEnum {
        static{
            this.COUPLER = {
                type: 3,
                value: "COUPLER"
            };
        }
        static{
            this.DIABOLO = {
                type: 3,
                value: "DIABOLO"
            };
        }
        static{
            this.DUCT = {
                type: 3,
                value: "DUCT"
            };
        }
        static{
            this.GROUTING_DUCT = {
                type: 3,
                value: "GROUTING_DUCT"
            };
        }
        static{
            this.TRUMPET = {
                type: 3,
                value: "TRUMPET"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTendonConduitTypeEnum = IfcTendonConduitTypeEnum;
    class IfcTendonTypeEnum {
        static{
            this.BAR = {
                type: 3,
                value: "BAR"
            };
        }
        static{
            this.COATED = {
                type: 3,
                value: "COATED"
            };
        }
        static{
            this.STRAND = {
                type: 3,
                value: "STRAND"
            };
        }
        static{
            this.WIRE = {
                type: 3,
                value: "WIRE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTendonTypeEnum = IfcTendonTypeEnum;
    class IfcTextPath {
        static{
            this.DOWN = {
                type: 3,
                value: "DOWN"
            };
        }
        static{
            this.LEFT = {
                type: 3,
                value: "LEFT"
            };
        }
        static{
            this.RIGHT = {
                type: 3,
                value: "RIGHT"
            };
        }
        static{
            this.UP = {
                type: 3,
                value: "UP"
            };
        }
    }
    IFC4X32.IfcTextPath = IfcTextPath;
    class IfcTimeSeriesDataTypeEnum {
        static{
            this.CONTINUOUS = {
                type: 3,
                value: "CONTINUOUS"
            };
        }
        static{
            this.DISCRETE = {
                type: 3,
                value: "DISCRETE"
            };
        }
        static{
            this.DISCRETEBINARY = {
                type: 3,
                value: "DISCRETEBINARY"
            };
        }
        static{
            this.PIECEWISEBINARY = {
                type: 3,
                value: "PIECEWISEBINARY"
            };
        }
        static{
            this.PIECEWISECONSTANT = {
                type: 3,
                value: "PIECEWISECONSTANT"
            };
        }
        static{
            this.PIECEWISECONTINUOUS = {
                type: 3,
                value: "PIECEWISECONTINUOUS"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;
    class IfcTrackElementTypeEnum {
        static{
            this.BLOCKINGDEVICE = {
                type: 3,
                value: "BLOCKINGDEVICE"
            };
        }
        static{
            this.DERAILER = {
                type: 3,
                value: "DERAILER"
            };
        }
        static{
            this.FROG = {
                type: 3,
                value: "FROG"
            };
        }
        static{
            this.HALF_SET_OF_BLADES = {
                type: 3,
                value: "HALF_SET_OF_BLADES"
            };
        }
        static{
            this.SLEEPER = {
                type: 3,
                value: "SLEEPER"
            };
        }
        static{
            this.SPEEDREGULATOR = {
                type: 3,
                value: "SPEEDREGULATOR"
            };
        }
        static{
            this.TRACKENDOFALIGNMENT = {
                type: 3,
                value: "TRACKENDOFALIGNMENT"
            };
        }
        static{
            this.VEHICLESTOP = {
                type: 3,
                value: "VEHICLESTOP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTrackElementTypeEnum = IfcTrackElementTypeEnum;
    class IfcTransformerTypeEnum {
        static{
            this.CHOPPER = {
                type: 3,
                value: "CHOPPER"
            };
        }
        static{
            this.COMBINED = {
                type: 3,
                value: "COMBINED"
            };
        }
        static{
            this.CURRENT = {
                type: 3,
                value: "CURRENT"
            };
        }
        static{
            this.FREQUENCY = {
                type: 3,
                value: "FREQUENCY"
            };
        }
        static{
            this.INVERTER = {
                type: 3,
                value: "INVERTER"
            };
        }
        static{
            this.RECTIFIER = {
                type: 3,
                value: "RECTIFIER"
            };
        }
        static{
            this.VOLTAGE = {
                type: 3,
                value: "VOLTAGE"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTransformerTypeEnum = IfcTransformerTypeEnum;
    class IfcTransitionCode {
        static{
            this.CONTINUOUS = {
                type: 3,
                value: "CONTINUOUS"
            };
        }
        static{
            this.CONTSAMEGRADIENT = {
                type: 3,
                value: "CONTSAMEGRADIENT"
            };
        }
        static{
            this.CONTSAMEGRADIENTSAMECURVATURE = {
                type: 3,
                value: "CONTSAMEGRADIENTSAMECURVATURE"
            };
        }
        static{
            this.DISCONTINUOUS = {
                type: 3,
                value: "DISCONTINUOUS"
            };
        }
    }
    IFC4X32.IfcTransitionCode = IfcTransitionCode;
    class IfcTransportElementTypeEnum {
        static{
            this.CRANEWAY = {
                type: 3,
                value: "CRANEWAY"
            };
        }
        static{
            this.ELEVATOR = {
                type: 3,
                value: "ELEVATOR"
            };
        }
        static{
            this.ESCALATOR = {
                type: 3,
                value: "ESCALATOR"
            };
        }
        static{
            this.HAULINGGEAR = {
                type: 3,
                value: "HAULINGGEAR"
            };
        }
        static{
            this.LIFTINGGEAR = {
                type: 3,
                value: "LIFTINGGEAR"
            };
        }
        static{
            this.MOVINGWALKWAY = {
                type: 3,
                value: "MOVINGWALKWAY"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;
    class IfcTrimmingPreference {
        static{
            this.CARTESIAN = {
                type: 3,
                value: "CARTESIAN"
            };
        }
        static{
            this.PARAMETER = {
                type: 3,
                value: "PARAMETER"
            };
        }
        static{
            this.UNSPECIFIED = {
                type: 3,
                value: "UNSPECIFIED"
            };
        }
    }
    IFC4X32.IfcTrimmingPreference = IfcTrimmingPreference;
    class IfcTubeBundleTypeEnum {
        static{
            this.FINNED = {
                type: 3,
                value: "FINNED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;
    class IfcUnitEnum {
        static{
            this.ABSORBEDDOSEUNIT = {
                type: 3,
                value: "ABSORBEDDOSEUNIT"
            };
        }
        static{
            this.AMOUNTOFSUBSTANCEUNIT = {
                type: 3,
                value: "AMOUNTOFSUBSTANCEUNIT"
            };
        }
        static{
            this.AREAUNIT = {
                type: 3,
                value: "AREAUNIT"
            };
        }
        static{
            this.DOSEEQUIVALENTUNIT = {
                type: 3,
                value: "DOSEEQUIVALENTUNIT"
            };
        }
        static{
            this.ELECTRICCAPACITANCEUNIT = {
                type: 3,
                value: "ELECTRICCAPACITANCEUNIT"
            };
        }
        static{
            this.ELECTRICCHARGEUNIT = {
                type: 3,
                value: "ELECTRICCHARGEUNIT"
            };
        }
        static{
            this.ELECTRICCONDUCTANCEUNIT = {
                type: 3,
                value: "ELECTRICCONDUCTANCEUNIT"
            };
        }
        static{
            this.ELECTRICCURRENTUNIT = {
                type: 3,
                value: "ELECTRICCURRENTUNIT"
            };
        }
        static{
            this.ELECTRICRESISTANCEUNIT = {
                type: 3,
                value: "ELECTRICRESISTANCEUNIT"
            };
        }
        static{
            this.ELECTRICVOLTAGEUNIT = {
                type: 3,
                value: "ELECTRICVOLTAGEUNIT"
            };
        }
        static{
            this.ENERGYUNIT = {
                type: 3,
                value: "ENERGYUNIT"
            };
        }
        static{
            this.FORCEUNIT = {
                type: 3,
                value: "FORCEUNIT"
            };
        }
        static{
            this.FREQUENCYUNIT = {
                type: 3,
                value: "FREQUENCYUNIT"
            };
        }
        static{
            this.ILLUMINANCEUNIT = {
                type: 3,
                value: "ILLUMINANCEUNIT"
            };
        }
        static{
            this.INDUCTANCEUNIT = {
                type: 3,
                value: "INDUCTANCEUNIT"
            };
        }
        static{
            this.LENGTHUNIT = {
                type: 3,
                value: "LENGTHUNIT"
            };
        }
        static{
            this.LUMINOUSFLUXUNIT = {
                type: 3,
                value: "LUMINOUSFLUXUNIT"
            };
        }
        static{
            this.LUMINOUSINTENSITYUNIT = {
                type: 3,
                value: "LUMINOUSINTENSITYUNIT"
            };
        }
        static{
            this.MAGNETICFLUXDENSITYUNIT = {
                type: 3,
                value: "MAGNETICFLUXDENSITYUNIT"
            };
        }
        static{
            this.MAGNETICFLUXUNIT = {
                type: 3,
                value: "MAGNETICFLUXUNIT"
            };
        }
        static{
            this.MASSUNIT = {
                type: 3,
                value: "MASSUNIT"
            };
        }
        static{
            this.PLANEANGLEUNIT = {
                type: 3,
                value: "PLANEANGLEUNIT"
            };
        }
        static{
            this.POWERUNIT = {
                type: 3,
                value: "POWERUNIT"
            };
        }
        static{
            this.PRESSUREUNIT = {
                type: 3,
                value: "PRESSUREUNIT"
            };
        }
        static{
            this.RADIOACTIVITYUNIT = {
                type: 3,
                value: "RADIOACTIVITYUNIT"
            };
        }
        static{
            this.SOLIDANGLEUNIT = {
                type: 3,
                value: "SOLIDANGLEUNIT"
            };
        }
        static{
            this.THERMODYNAMICTEMPERATUREUNIT = {
                type: 3,
                value: "THERMODYNAMICTEMPERATUREUNIT"
            };
        }
        static{
            this.TIMEUNIT = {
                type: 3,
                value: "TIMEUNIT"
            };
        }
        static{
            this.VOLUMEUNIT = {
                type: 3,
                value: "VOLUMEUNIT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
    }
    IFC4X32.IfcUnitEnum = IfcUnitEnum;
    class IfcUnitaryControlElementTypeEnum {
        static{
            this.ALARMPANEL = {
                type: 3,
                value: "ALARMPANEL"
            };
        }
        static{
            this.BASESTATIONCONTROLLER = {
                type: 3,
                value: "BASESTATIONCONTROLLER"
            };
        }
        static{
            this.COMBINED = {
                type: 3,
                value: "COMBINED"
            };
        }
        static{
            this.CONTROLPANEL = {
                type: 3,
                value: "CONTROLPANEL"
            };
        }
        static{
            this.GASDETECTIONPANEL = {
                type: 3,
                value: "GASDETECTIONPANEL"
            };
        }
        static{
            this.HUMIDISTAT = {
                type: 3,
                value: "HUMIDISTAT"
            };
        }
        static{
            this.INDICATORPANEL = {
                type: 3,
                value: "INDICATORPANEL"
            };
        }
        static{
            this.MIMICPANEL = {
                type: 3,
                value: "MIMICPANEL"
            };
        }
        static{
            this.THERMOSTAT = {
                type: 3,
                value: "THERMOSTAT"
            };
        }
        static{
            this.WEATHERSTATION = {
                type: 3,
                value: "WEATHERSTATION"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcUnitaryControlElementTypeEnum = IfcUnitaryControlElementTypeEnum;
    class IfcUnitaryEquipmentTypeEnum {
        static{
            this.AIRCONDITIONINGUNIT = {
                type: 3,
                value: "AIRCONDITIONINGUNIT"
            };
        }
        static{
            this.AIRHANDLER = {
                type: 3,
                value: "AIRHANDLER"
            };
        }
        static{
            this.DEHUMIDIFIER = {
                type: 3,
                value: "DEHUMIDIFIER"
            };
        }
        static{
            this.ROOFTOPUNIT = {
                type: 3,
                value: "ROOFTOPUNIT"
            };
        }
        static{
            this.SPLITSYSTEM = {
                type: 3,
                value: "SPLITSYSTEM"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;
    class IfcValveTypeEnum {
        static{
            this.AIRRELEASE = {
                type: 3,
                value: "AIRRELEASE"
            };
        }
        static{
            this.ANTIVACUUM = {
                type: 3,
                value: "ANTIVACUUM"
            };
        }
        static{
            this.CHANGEOVER = {
                type: 3,
                value: "CHANGEOVER"
            };
        }
        static{
            this.CHECK = {
                type: 3,
                value: "CHECK"
            };
        }
        static{
            this.COMMISSIONING = {
                type: 3,
                value: "COMMISSIONING"
            };
        }
        static{
            this.DIVERTING = {
                type: 3,
                value: "DIVERTING"
            };
        }
        static{
            this.DOUBLECHECK = {
                type: 3,
                value: "DOUBLECHECK"
            };
        }
        static{
            this.DOUBLEREGULATING = {
                type: 3,
                value: "DOUBLEREGULATING"
            };
        }
        static{
            this.DRAWOFFCOCK = {
                type: 3,
                value: "DRAWOFFCOCK"
            };
        }
        static{
            this.FAUCET = {
                type: 3,
                value: "FAUCET"
            };
        }
        static{
            this.FLUSHING = {
                type: 3,
                value: "FLUSHING"
            };
        }
        static{
            this.GASCOCK = {
                type: 3,
                value: "GASCOCK"
            };
        }
        static{
            this.GASTAP = {
                type: 3,
                value: "GASTAP"
            };
        }
        static{
            this.ISOLATING = {
                type: 3,
                value: "ISOLATING"
            };
        }
        static{
            this.MIXING = {
                type: 3,
                value: "MIXING"
            };
        }
        static{
            this.PRESSUREREDUCING = {
                type: 3,
                value: "PRESSUREREDUCING"
            };
        }
        static{
            this.PRESSURERELIEF = {
                type: 3,
                value: "PRESSURERELIEF"
            };
        }
        static{
            this.REGULATING = {
                type: 3,
                value: "REGULATING"
            };
        }
        static{
            this.SAFETYCUTOFF = {
                type: 3,
                value: "SAFETYCUTOFF"
            };
        }
        static{
            this.STEAMTRAP = {
                type: 3,
                value: "STEAMTRAP"
            };
        }
        static{
            this.STOPCOCK = {
                type: 3,
                value: "STOPCOCK"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcValveTypeEnum = IfcValveTypeEnum;
    class IfcVehicleTypeEnum {
        static{
            this.CARGO = {
                type: 3,
                value: "CARGO"
            };
        }
        static{
            this.ROLLINGSTOCK = {
                type: 3,
                value: "ROLLINGSTOCK"
            };
        }
        static{
            this.VEHICLE = {
                type: 3,
                value: "VEHICLE"
            };
        }
        static{
            this.VEHICLEAIR = {
                type: 3,
                value: "VEHICLEAIR"
            };
        }
        static{
            this.VEHICLEMARINE = {
                type: 3,
                value: "VEHICLEMARINE"
            };
        }
        static{
            this.VEHICLETRACKED = {
                type: 3,
                value: "VEHICLETRACKED"
            };
        }
        static{
            this.VEHICLEWHEELED = {
                type: 3,
                value: "VEHICLEWHEELED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcVehicleTypeEnum = IfcVehicleTypeEnum;
    class IfcVibrationDamperTypeEnum {
        static{
            this.AXIAL_YIELD = {
                type: 3,
                value: "AXIAL_YIELD"
            };
        }
        static{
            this.BENDING_YIELD = {
                type: 3,
                value: "BENDING_YIELD"
            };
        }
        static{
            this.FRICTION = {
                type: 3,
                value: "FRICTION"
            };
        }
        static{
            this.RUBBER = {
                type: 3,
                value: "RUBBER"
            };
        }
        static{
            this.SHEAR_YIELD = {
                type: 3,
                value: "SHEAR_YIELD"
            };
        }
        static{
            this.VISCOUS = {
                type: 3,
                value: "VISCOUS"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcVibrationDamperTypeEnum = IfcVibrationDamperTypeEnum;
    class IfcVibrationIsolatorTypeEnum {
        static{
            this.BASE = {
                type: 3,
                value: "BASE"
            };
        }
        static{
            this.COMPRESSION = {
                type: 3,
                value: "COMPRESSION"
            };
        }
        static{
            this.SPRING = {
                type: 3,
                value: "SPRING"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;
    class IfcVirtualElementTypeEnum {
        static{
            this.BOUNDARY = {
                type: 3,
                value: "BOUNDARY"
            };
        }
        static{
            this.CLEARANCE = {
                type: 3,
                value: "CLEARANCE"
            };
        }
        static{
            this.PROVISIONFORVOID = {
                type: 3,
                value: "PROVISIONFORVOID"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcVirtualElementTypeEnum = IfcVirtualElementTypeEnum;
    class IfcVoidingFeatureTypeEnum {
        static{
            this.CHAMFER = {
                type: 3,
                value: "CHAMFER"
            };
        }
        static{
            this.CUTOUT = {
                type: 3,
                value: "CUTOUT"
            };
        }
        static{
            this.EDGE = {
                type: 3,
                value: "EDGE"
            };
        }
        static{
            this.HOLE = {
                type: 3,
                value: "HOLE"
            };
        }
        static{
            this.MITER = {
                type: 3,
                value: "MITER"
            };
        }
        static{
            this.NOTCH = {
                type: 3,
                value: "NOTCH"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcVoidingFeatureTypeEnum = IfcVoidingFeatureTypeEnum;
    class IfcWallTypeEnum {
        static{
            this.ELEMENTEDWALL = {
                type: 3,
                value: "ELEMENTEDWALL"
            };
        }
        static{
            this.MOVABLE = {
                type: 3,
                value: "MOVABLE"
            };
        }
        static{
            this.PARAPET = {
                type: 3,
                value: "PARAPET"
            };
        }
        static{
            this.PARTITIONING = {
                type: 3,
                value: "PARTITIONING"
            };
        }
        static{
            this.PLUMBINGWALL = {
                type: 3,
                value: "PLUMBINGWALL"
            };
        }
        static{
            this.POLYGONAL = {
                type: 3,
                value: "POLYGONAL"
            };
        }
        static{
            this.RETAININGWALL = {
                type: 3,
                value: "RETAININGWALL"
            };
        }
        static{
            this.SHEAR = {
                type: 3,
                value: "SHEAR"
            };
        }
        static{
            this.SOLIDWALL = {
                type: 3,
                value: "SOLIDWALL"
            };
        }
        static{
            this.STANDARD = {
                type: 3,
                value: "STANDARD"
            };
        }
        static{
            this.WAVEWALL = {
                type: 3,
                value: "WAVEWALL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcWallTypeEnum = IfcWallTypeEnum;
    class IfcWasteTerminalTypeEnum {
        static{
            this.FLOORTRAP = {
                type: 3,
                value: "FLOORTRAP"
            };
        }
        static{
            this.FLOORWASTE = {
                type: 3,
                value: "FLOORWASTE"
            };
        }
        static{
            this.GULLYSUMP = {
                type: 3,
                value: "GULLYSUMP"
            };
        }
        static{
            this.GULLYTRAP = {
                type: 3,
                value: "GULLYTRAP"
            };
        }
        static{
            this.ROOFDRAIN = {
                type: 3,
                value: "ROOFDRAIN"
            };
        }
        static{
            this.WASTEDISPOSALUNIT = {
                type: 3,
                value: "WASTEDISPOSALUNIT"
            };
        }
        static{
            this.WASTETRAP = {
                type: 3,
                value: "WASTETRAP"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;
    class IfcWindowPanelOperationEnum {
        static{
            this.BOTTOMHUNG = {
                type: 3,
                value: "BOTTOMHUNG"
            };
        }
        static{
            this.FIXEDCASEMENT = {
                type: 3,
                value: "FIXEDCASEMENT"
            };
        }
        static{
            this.OTHEROPERATION = {
                type: 3,
                value: "OTHEROPERATION"
            };
        }
        static{
            this.PIVOTHORIZONTAL = {
                type: 3,
                value: "PIVOTHORIZONTAL"
            };
        }
        static{
            this.PIVOTVERTICAL = {
                type: 3,
                value: "PIVOTVERTICAL"
            };
        }
        static{
            this.REMOVABLECASEMENT = {
                type: 3,
                value: "REMOVABLECASEMENT"
            };
        }
        static{
            this.SIDEHUNGLEFTHAND = {
                type: 3,
                value: "SIDEHUNGLEFTHAND"
            };
        }
        static{
            this.SIDEHUNGRIGHTHAND = {
                type: 3,
                value: "SIDEHUNGRIGHTHAND"
            };
        }
        static{
            this.SLIDINGHORIZONTAL = {
                type: 3,
                value: "SLIDINGHORIZONTAL"
            };
        }
        static{
            this.SLIDINGVERTICAL = {
                type: 3,
                value: "SLIDINGVERTICAL"
            };
        }
        static{
            this.TILTANDTURNLEFTHAND = {
                type: 3,
                value: "TILTANDTURNLEFTHAND"
            };
        }
        static{
            this.TILTANDTURNRIGHTHAND = {
                type: 3,
                value: "TILTANDTURNRIGHTHAND"
            };
        }
        static{
            this.TOPHUNG = {
                type: 3,
                value: "TOPHUNG"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;
    class IfcWindowPanelPositionEnum {
        static{
            this.BOTTOM = {
                type: 3,
                value: "BOTTOM"
            };
        }
        static{
            this.LEFT = {
                type: 3,
                value: "LEFT"
            };
        }
        static{
            this.MIDDLE = {
                type: 3,
                value: "MIDDLE"
            };
        }
        static{
            this.RIGHT = {
                type: 3,
                value: "RIGHT"
            };
        }
        static{
            this.TOP = {
                type: 3,
                value: "TOP"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;
    class IfcWindowTypeEnum {
        static{
            this.LIGHTDOME = {
                type: 3,
                value: "LIGHTDOME"
            };
        }
        static{
            this.SKYLIGHT = {
                type: 3,
                value: "SKYLIGHT"
            };
        }
        static{
            this.WINDOW = {
                type: 3,
                value: "WINDOW"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcWindowTypeEnum = IfcWindowTypeEnum;
    class IfcWindowTypePartitioningEnum {
        static{
            this.DOUBLE_PANEL_HORIZONTAL = {
                type: 3,
                value: "DOUBLE_PANEL_HORIZONTAL"
            };
        }
        static{
            this.DOUBLE_PANEL_VERTICAL = {
                type: 3,
                value: "DOUBLE_PANEL_VERTICAL"
            };
        }
        static{
            this.SINGLE_PANEL = {
                type: 3,
                value: "SINGLE_PANEL"
            };
        }
        static{
            this.TRIPLE_PANEL_BOTTOM = {
                type: 3,
                value: "TRIPLE_PANEL_BOTTOM"
            };
        }
        static{
            this.TRIPLE_PANEL_HORIZONTAL = {
                type: 3,
                value: "TRIPLE_PANEL_HORIZONTAL"
            };
        }
        static{
            this.TRIPLE_PANEL_LEFT = {
                type: 3,
                value: "TRIPLE_PANEL_LEFT"
            };
        }
        static{
            this.TRIPLE_PANEL_RIGHT = {
                type: 3,
                value: "TRIPLE_PANEL_RIGHT"
            };
        }
        static{
            this.TRIPLE_PANEL_TOP = {
                type: 3,
                value: "TRIPLE_PANEL_TOP"
            };
        }
        static{
            this.TRIPLE_PANEL_VERTICAL = {
                type: 3,
                value: "TRIPLE_PANEL_VERTICAL"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcWindowTypePartitioningEnum = IfcWindowTypePartitioningEnum;
    class IfcWorkCalendarTypeEnum {
        static{
            this.FIRSTSHIFT = {
                type: 3,
                value: "FIRSTSHIFT"
            };
        }
        static{
            this.SECONDSHIFT = {
                type: 3,
                value: "SECONDSHIFT"
            };
        }
        static{
            this.THIRDSHIFT = {
                type: 3,
                value: "THIRDSHIFT"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcWorkCalendarTypeEnum = IfcWorkCalendarTypeEnum;
    class IfcWorkPlanTypeEnum {
        static{
            this.ACTUAL = {
                type: 3,
                value: "ACTUAL"
            };
        }
        static{
            this.BASELINE = {
                type: 3,
                value: "BASELINE"
            };
        }
        static{
            this.PLANNED = {
                type: 3,
                value: "PLANNED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcWorkPlanTypeEnum = IfcWorkPlanTypeEnum;
    class IfcWorkScheduleTypeEnum {
        static{
            this.ACTUAL = {
                type: 3,
                value: "ACTUAL"
            };
        }
        static{
            this.BASELINE = {
                type: 3,
                value: "BASELINE"
            };
        }
        static{
            this.PLANNED = {
                type: 3,
                value: "PLANNED"
            };
        }
        static{
            this.USERDEFINED = {
                type: 3,
                value: "USERDEFINED"
            };
        }
        static{
            this.NOTDEFINED = {
                type: 3,
                value: "NOTDEFINED"
            };
        }
    }
    IFC4X32.IfcWorkScheduleTypeEnum = IfcWorkScheduleTypeEnum;
    class IfcActorRole extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Role, UserDefinedRole, Description){
            super();
            this.Role = Role;
            this.UserDefinedRole = UserDefinedRole;
            this.Description = Description;
            this.type = 3630933823;
        }
    }
    IFC4X32.IfcActorRole = IfcActorRole;
    class IfcAddress extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Purpose, Description, UserDefinedPurpose){
            super();
            this.Purpose = Purpose;
            this.Description = Description;
            this.UserDefinedPurpose = UserDefinedPurpose;
            this.type = 618182010;
        }
    }
    IFC4X32.IfcAddress = IfcAddress;
    class IfcAlignmentParameterSegment extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(StartTag, EndTag){
            super();
            this.StartTag = StartTag;
            this.EndTag = EndTag;
            this.type = 2879124712;
        }
    }
    IFC4X32.IfcAlignmentParameterSegment = IfcAlignmentParameterSegment;
    class IfcAlignmentVerticalSegment extends IfcAlignmentParameterSegment {
        constructor(StartTag, EndTag, StartDistAlong, HorizontalLength, StartHeight, StartGradient, EndGradient, RadiusOfCurvature, PredefinedType){
            super(StartTag, EndTag);
            this.StartTag = StartTag;
            this.EndTag = EndTag;
            this.StartDistAlong = StartDistAlong;
            this.HorizontalLength = HorizontalLength;
            this.StartHeight = StartHeight;
            this.StartGradient = StartGradient;
            this.EndGradient = EndGradient;
            this.RadiusOfCurvature = RadiusOfCurvature;
            this.PredefinedType = PredefinedType;
            this.type = 3633395639;
        }
    }
    IFC4X32.IfcAlignmentVerticalSegment = IfcAlignmentVerticalSegment;
    class IfcApplication extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier){
            super();
            this.ApplicationDeveloper = ApplicationDeveloper;
            this.Version = Version;
            this.ApplicationFullName = ApplicationFullName;
            this.ApplicationIdentifier = ApplicationIdentifier;
            this.type = 639542469;
        }
    }
    IFC4X32.IfcApplication = IfcApplication;
    class IfcAppliedValue extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components){
            super();
            this.Name = Name;
            this.Description = Description;
            this.AppliedValue = AppliedValue;
            this.UnitBasis = UnitBasis;
            this.ApplicableDate = ApplicableDate;
            this.FixedUntilDate = FixedUntilDate;
            this.Category = Category;
            this.Condition = Condition;
            this.ArithmeticOperator = ArithmeticOperator;
            this.Components = Components;
            this.type = 411424972;
        }
    }
    IFC4X32.IfcAppliedValue = IfcAppliedValue;
    class IfcApproval extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Identifier, Name, Description, TimeOfApproval, Status, Level, Qualifier, RequestingApproval, GivingApproval){
            super();
            this.Identifier = Identifier;
            this.Name = Name;
            this.Description = Description;
            this.TimeOfApproval = TimeOfApproval;
            this.Status = Status;
            this.Level = Level;
            this.Qualifier = Qualifier;
            this.RequestingApproval = RequestingApproval;
            this.GivingApproval = GivingApproval;
            this.type = 130549933;
        }
    }
    IFC4X32.IfcApproval = IfcApproval;
    class IfcBoundaryCondition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 4037036970;
        }
    }
    IFC4X32.IfcBoundaryCondition = IfcBoundaryCondition;
    class IfcBoundaryEdgeCondition extends IfcBoundaryCondition {
        constructor(Name, TranslationalStiffnessByLengthX, TranslationalStiffnessByLengthY, TranslationalStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ){
            super(Name);
            this.Name = Name;
            this.TranslationalStiffnessByLengthX = TranslationalStiffnessByLengthX;
            this.TranslationalStiffnessByLengthY = TranslationalStiffnessByLengthY;
            this.TranslationalStiffnessByLengthZ = TranslationalStiffnessByLengthZ;
            this.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
            this.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
            this.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
            this.type = 1560379544;
        }
    }
    IFC4X32.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;
    class IfcBoundaryFaceCondition extends IfcBoundaryCondition {
        constructor(Name, TranslationalStiffnessByAreaX, TranslationalStiffnessByAreaY, TranslationalStiffnessByAreaZ){
            super(Name);
            this.Name = Name;
            this.TranslationalStiffnessByAreaX = TranslationalStiffnessByAreaX;
            this.TranslationalStiffnessByAreaY = TranslationalStiffnessByAreaY;
            this.TranslationalStiffnessByAreaZ = TranslationalStiffnessByAreaZ;
            this.type = 3367102660;
        }
    }
    IFC4X32.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;
    class IfcBoundaryNodeCondition extends IfcBoundaryCondition {
        constructor(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ){
            super(Name);
            this.Name = Name;
            this.TranslationalStiffnessX = TranslationalStiffnessX;
            this.TranslationalStiffnessY = TranslationalStiffnessY;
            this.TranslationalStiffnessZ = TranslationalStiffnessZ;
            this.RotationalStiffnessX = RotationalStiffnessX;
            this.RotationalStiffnessY = RotationalStiffnessY;
            this.RotationalStiffnessZ = RotationalStiffnessZ;
            this.type = 1387855156;
        }
    }
    IFC4X32.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;
    class IfcBoundaryNodeConditionWarping extends IfcBoundaryNodeCondition {
        constructor(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness){
            super(Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
            this.Name = Name;
            this.TranslationalStiffnessX = TranslationalStiffnessX;
            this.TranslationalStiffnessY = TranslationalStiffnessY;
            this.TranslationalStiffnessZ = TranslationalStiffnessZ;
            this.RotationalStiffnessX = RotationalStiffnessX;
            this.RotationalStiffnessY = RotationalStiffnessY;
            this.RotationalStiffnessZ = RotationalStiffnessZ;
            this.WarpingStiffness = WarpingStiffness;
            this.type = 2069777674;
        }
    }
    IFC4X32.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;
    class IfcConnectionGeometry extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 2859738748;
        }
    }
    IFC4X32.IfcConnectionGeometry = IfcConnectionGeometry;
    class IfcConnectionPointGeometry extends IfcConnectionGeometry {
        constructor(PointOnRelatingElement, PointOnRelatedElement){
            super();
            this.PointOnRelatingElement = PointOnRelatingElement;
            this.PointOnRelatedElement = PointOnRelatedElement;
            this.type = 2614616156;
        }
    }
    IFC4X32.IfcConnectionPointGeometry = IfcConnectionPointGeometry;
    class IfcConnectionSurfaceGeometry extends IfcConnectionGeometry {
        constructor(SurfaceOnRelatingElement, SurfaceOnRelatedElement){
            super();
            this.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
            this.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
            this.type = 2732653382;
        }
    }
    IFC4X32.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;
    class IfcConnectionVolumeGeometry extends IfcConnectionGeometry {
        constructor(VolumeOnRelatingElement, VolumeOnRelatedElement){
            super();
            this.VolumeOnRelatingElement = VolumeOnRelatingElement;
            this.VolumeOnRelatedElement = VolumeOnRelatedElement;
            this.type = 775493141;
        }
    }
    IFC4X32.IfcConnectionVolumeGeometry = IfcConnectionVolumeGeometry;
    class IfcConstraint extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade){
            super();
            this.Name = Name;
            this.Description = Description;
            this.ConstraintGrade = ConstraintGrade;
            this.ConstraintSource = ConstraintSource;
            this.CreatingActor = CreatingActor;
            this.CreationTime = CreationTime;
            this.UserDefinedGrade = UserDefinedGrade;
            this.type = 1959218052;
        }
    }
    IFC4X32.IfcConstraint = IfcConstraint;
    class IfcCoordinateOperation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(SourceCRS, TargetCRS){
            super();
            this.SourceCRS = SourceCRS;
            this.TargetCRS = TargetCRS;
            this.type = 1785450214;
        }
    }
    IFC4X32.IfcCoordinateOperation = IfcCoordinateOperation;
    class IfcCoordinateReferenceSystem extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, GeodeticDatum){
            super();
            this.Name = Name;
            this.Description = Description;
            this.GeodeticDatum = GeodeticDatum;
            this.type = 1466758467;
        }
    }
    IFC4X32.IfcCoordinateReferenceSystem = IfcCoordinateReferenceSystem;
    class IfcCostValue extends IfcAppliedValue {
        constructor(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components){
            super(Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components);
            this.Name = Name;
            this.Description = Description;
            this.AppliedValue = AppliedValue;
            this.UnitBasis = UnitBasis;
            this.ApplicableDate = ApplicableDate;
            this.FixedUntilDate = FixedUntilDate;
            this.Category = Category;
            this.Condition = Condition;
            this.ArithmeticOperator = ArithmeticOperator;
            this.Components = Components;
            this.type = 602808272;
        }
    }
    IFC4X32.IfcCostValue = IfcCostValue;
    class IfcDerivedUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Elements, UnitType, UserDefinedType, Name){
            super();
            this.Elements = Elements;
            this.UnitType = UnitType;
            this.UserDefinedType = UserDefinedType;
            this.Name = Name;
            this.type = 1765591967;
        }
    }
    IFC4X32.IfcDerivedUnit = IfcDerivedUnit;
    class IfcDerivedUnitElement extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Unit, Exponent){
            super();
            this.Unit = Unit;
            this.Exponent = Exponent;
            this.type = 1045800335;
        }
    }
    IFC4X32.IfcDerivedUnitElement = IfcDerivedUnitElement;
    class IfcDimensionalExponents extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent){
            super();
            this.LengthExponent = LengthExponent;
            this.MassExponent = MassExponent;
            this.TimeExponent = TimeExponent;
            this.ElectricCurrentExponent = ElectricCurrentExponent;
            this.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
            this.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
            this.LuminousIntensityExponent = LuminousIntensityExponent;
            this.type = 2949456006;
        }
    }
    IFC4X32.IfcDimensionalExponents = IfcDimensionalExponents;
    class IfcExternalInformation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 4294318154;
        }
    }
    IFC4X32.IfcExternalInformation = IfcExternalInformation;
    class IfcExternalReference extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Location, Identification, Name){
            super();
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.type = 3200245327;
        }
    }
    IFC4X32.IfcExternalReference = IfcExternalReference;
    class IfcExternallyDefinedHatchStyle extends IfcExternalReference {
        constructor(Location, Identification, Name){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.type = 2242383968;
        }
    }
    IFC4X32.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;
    class IfcExternallyDefinedSurfaceStyle extends IfcExternalReference {
        constructor(Location, Identification, Name){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.type = 1040185647;
        }
    }
    IFC4X32.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;
    class IfcExternallyDefinedTextFont extends IfcExternalReference {
        constructor(Location, Identification, Name){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.type = 3548104201;
        }
    }
    IFC4X32.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;
    class IfcGeographicCRS extends IfcCoordinateReferenceSystem {
        constructor(Name, Description, GeodeticDatum, PrimeMeridian, AngleUnit, HeightUnit){
            super(Name, Description, GeodeticDatum);
            this.Name = Name;
            this.Description = Description;
            this.GeodeticDatum = GeodeticDatum;
            this.PrimeMeridian = PrimeMeridian;
            this.AngleUnit = AngleUnit;
            this.HeightUnit = HeightUnit;
            this.type = 917726184;
        }
    }
    IFC4X32.IfcGeographicCRS = IfcGeographicCRS;
    class IfcGridAxis extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(AxisTag, AxisCurve, SameSense){
            super();
            this.AxisTag = AxisTag;
            this.AxisCurve = AxisCurve;
            this.SameSense = SameSense;
            this.type = 852622518;
        }
    }
    IFC4X32.IfcGridAxis = IfcGridAxis;
    class IfcIrregularTimeSeriesValue extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(TimeStamp, ListValues){
            super();
            this.TimeStamp = TimeStamp;
            this.ListValues = ListValues;
            this.type = 3020489413;
        }
    }
    IFC4X32.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;
    class IfcLibraryInformation extends IfcExternalInformation {
        constructor(Name, Version, Publisher, VersionDate, Location, Description){
            super();
            this.Name = Name;
            this.Version = Version;
            this.Publisher = Publisher;
            this.VersionDate = VersionDate;
            this.Location = Location;
            this.Description = Description;
            this.type = 2655187982;
        }
    }
    IFC4X32.IfcLibraryInformation = IfcLibraryInformation;
    class IfcLibraryReference extends IfcExternalReference {
        constructor(Location, Identification, Name, Description, Language, ReferencedLibrary){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.Description = Description;
            this.Language = Language;
            this.ReferencedLibrary = ReferencedLibrary;
            this.type = 3452421091;
        }
    }
    IFC4X32.IfcLibraryReference = IfcLibraryReference;
    class IfcLightDistributionData extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity){
            super();
            this.MainPlaneAngle = MainPlaneAngle;
            this.SecondaryPlaneAngle = SecondaryPlaneAngle;
            this.LuminousIntensity = LuminousIntensity;
            this.type = 4162380809;
        }
    }
    IFC4X32.IfcLightDistributionData = IfcLightDistributionData;
    class IfcLightIntensityDistribution extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(LightDistributionCurve, DistributionData){
            super();
            this.LightDistributionCurve = LightDistributionCurve;
            this.DistributionData = DistributionData;
            this.type = 1566485204;
        }
    }
    IFC4X32.IfcLightIntensityDistribution = IfcLightIntensityDistribution;
    class IfcMapConversion extends IfcCoordinateOperation {
        constructor(SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale){
            super(SourceCRS, TargetCRS);
            this.SourceCRS = SourceCRS;
            this.TargetCRS = TargetCRS;
            this.Eastings = Eastings;
            this.Northings = Northings;
            this.OrthogonalHeight = OrthogonalHeight;
            this.XAxisAbscissa = XAxisAbscissa;
            this.XAxisOrdinate = XAxisOrdinate;
            this.Scale = Scale;
            this.type = 3057273783;
        }
    }
    IFC4X32.IfcMapConversion = IfcMapConversion;
    class IfcMapConversionScaled extends IfcMapConversion {
        constructor(SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale, FactorX, FactorY, FactorZ){
            super(SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale);
            this.SourceCRS = SourceCRS;
            this.TargetCRS = TargetCRS;
            this.Eastings = Eastings;
            this.Northings = Northings;
            this.OrthogonalHeight = OrthogonalHeight;
            this.XAxisAbscissa = XAxisAbscissa;
            this.XAxisOrdinate = XAxisOrdinate;
            this.Scale = Scale;
            this.FactorX = FactorX;
            this.FactorY = FactorY;
            this.FactorZ = FactorZ;
            this.type = 4105526436;
        }
    }
    IFC4X32.IfcMapConversionScaled = IfcMapConversionScaled;
    class IfcMaterialClassificationRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MaterialClassifications, ClassifiedMaterial){
            super();
            this.MaterialClassifications = MaterialClassifications;
            this.ClassifiedMaterial = ClassifiedMaterial;
            this.type = 1847130766;
        }
    }
    IFC4X32.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;
    class IfcMaterialDefinition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 760658860;
        }
    }
    IFC4X32.IfcMaterialDefinition = IfcMaterialDefinition;
    class IfcMaterialLayer extends IfcMaterialDefinition {
        constructor(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority){
            super();
            this.Material = Material;
            this.LayerThickness = LayerThickness;
            this.IsVentilated = IsVentilated;
            this.Name = Name;
            this.Description = Description;
            this.Category = Category;
            this.Priority = Priority;
            this.type = 248100487;
        }
    }
    IFC4X32.IfcMaterialLayer = IfcMaterialLayer;
    class IfcMaterialLayerSet extends IfcMaterialDefinition {
        constructor(MaterialLayers, LayerSetName, Description){
            super();
            this.MaterialLayers = MaterialLayers;
            this.LayerSetName = LayerSetName;
            this.Description = Description;
            this.type = 3303938423;
        }
    }
    IFC4X32.IfcMaterialLayerSet = IfcMaterialLayerSet;
    class IfcMaterialLayerWithOffsets extends IfcMaterialLayer {
        constructor(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority, OffsetDirection, OffsetValues){
            super(Material, LayerThickness, IsVentilated, Name, Description, Category, Priority);
            this.Material = Material;
            this.LayerThickness = LayerThickness;
            this.IsVentilated = IsVentilated;
            this.Name = Name;
            this.Description = Description;
            this.Category = Category;
            this.Priority = Priority;
            this.OffsetDirection = OffsetDirection;
            this.OffsetValues = OffsetValues;
            this.type = 1847252529;
        }
    }
    IFC4X32.IfcMaterialLayerWithOffsets = IfcMaterialLayerWithOffsets;
    class IfcMaterialList extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Materials){
            super();
            this.Materials = Materials;
            this.type = 2199411900;
        }
    }
    IFC4X32.IfcMaterialList = IfcMaterialList;
    class IfcMaterialProfile extends IfcMaterialDefinition {
        constructor(Name, Description, Material, Profile, Priority, Category){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Material = Material;
            this.Profile = Profile;
            this.Priority = Priority;
            this.Category = Category;
            this.type = 2235152071;
        }
    }
    IFC4X32.IfcMaterialProfile = IfcMaterialProfile;
    class IfcMaterialProfileSet extends IfcMaterialDefinition {
        constructor(Name, Description, MaterialProfiles, CompositeProfile){
            super();
            this.Name = Name;
            this.Description = Description;
            this.MaterialProfiles = MaterialProfiles;
            this.CompositeProfile = CompositeProfile;
            this.type = 164193824;
        }
    }
    IFC4X32.IfcMaterialProfileSet = IfcMaterialProfileSet;
    class IfcMaterialProfileWithOffsets extends IfcMaterialProfile {
        constructor(Name, Description, Material, Profile, Priority, Category, OffsetValues){
            super(Name, Description, Material, Profile, Priority, Category);
            this.Name = Name;
            this.Description = Description;
            this.Material = Material;
            this.Profile = Profile;
            this.Priority = Priority;
            this.Category = Category;
            this.OffsetValues = OffsetValues;
            this.type = 552965576;
        }
    }
    IFC4X32.IfcMaterialProfileWithOffsets = IfcMaterialProfileWithOffsets;
    class IfcMaterialUsageDefinition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 1507914824;
        }
    }
    IFC4X32.IfcMaterialUsageDefinition = IfcMaterialUsageDefinition;
    class IfcMeasureWithUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ValueComponent, UnitComponent){
            super();
            this.ValueComponent = ValueComponent;
            this.UnitComponent = UnitComponent;
            this.type = 2597039031;
        }
    }
    IFC4X32.IfcMeasureWithUnit = IfcMeasureWithUnit;
    class IfcMetric extends IfcConstraint {
        constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue, ReferencePath){
            super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
            this.Name = Name;
            this.Description = Description;
            this.ConstraintGrade = ConstraintGrade;
            this.ConstraintSource = ConstraintSource;
            this.CreatingActor = CreatingActor;
            this.CreationTime = CreationTime;
            this.UserDefinedGrade = UserDefinedGrade;
            this.Benchmark = Benchmark;
            this.ValueSource = ValueSource;
            this.DataValue = DataValue;
            this.ReferencePath = ReferencePath;
            this.type = 3368373690;
        }
    }
    IFC4X32.IfcMetric = IfcMetric;
    class IfcMonetaryUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Currency){
            super();
            this.Currency = Currency;
            this.type = 2706619895;
        }
    }
    IFC4X32.IfcMonetaryUnit = IfcMonetaryUnit;
    class IfcNamedUnit extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Dimensions, UnitType){
            super();
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.type = 1918398963;
        }
    }
    IFC4X32.IfcNamedUnit = IfcNamedUnit;
    class IfcObjectPlacement extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(PlacementRelTo){
            super();
            this.PlacementRelTo = PlacementRelTo;
            this.type = 3701648758;
        }
    }
    IFC4X32.IfcObjectPlacement = IfcObjectPlacement;
    class IfcObjective extends IfcConstraint {
        constructor(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, LogicalAggregator, ObjectiveQualifier, UserDefinedQualifier){
            super(Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
            this.Name = Name;
            this.Description = Description;
            this.ConstraintGrade = ConstraintGrade;
            this.ConstraintSource = ConstraintSource;
            this.CreatingActor = CreatingActor;
            this.CreationTime = CreationTime;
            this.UserDefinedGrade = UserDefinedGrade;
            this.BenchmarkValues = BenchmarkValues;
            this.LogicalAggregator = LogicalAggregator;
            this.ObjectiveQualifier = ObjectiveQualifier;
            this.UserDefinedQualifier = UserDefinedQualifier;
            this.type = 2251480897;
        }
    }
    IFC4X32.IfcObjective = IfcObjective;
    class IfcOrganization extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Identification, Name, Description, Roles, Addresses){
            super();
            this.Identification = Identification;
            this.Name = Name;
            this.Description = Description;
            this.Roles = Roles;
            this.Addresses = Addresses;
            this.type = 4251960020;
        }
    }
    IFC4X32.IfcOrganization = IfcOrganization;
    class IfcOwnerHistory extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate){
            super();
            this.OwningUser = OwningUser;
            this.OwningApplication = OwningApplication;
            this.State = State;
            this.ChangeAction = ChangeAction;
            this.LastModifiedDate = LastModifiedDate;
            this.LastModifyingUser = LastModifyingUser;
            this.LastModifyingApplication = LastModifyingApplication;
            this.CreationDate = CreationDate;
            this.type = 1207048766;
        }
    }
    IFC4X32.IfcOwnerHistory = IfcOwnerHistory;
    class IfcPerson extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Identification, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses){
            super();
            this.Identification = Identification;
            this.FamilyName = FamilyName;
            this.GivenName = GivenName;
            this.MiddleNames = MiddleNames;
            this.PrefixTitles = PrefixTitles;
            this.SuffixTitles = SuffixTitles;
            this.Roles = Roles;
            this.Addresses = Addresses;
            this.type = 2077209135;
        }
    }
    IFC4X32.IfcPerson = IfcPerson;
    class IfcPersonAndOrganization extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ThePerson, TheOrganization, Roles){
            super();
            this.ThePerson = ThePerson;
            this.TheOrganization = TheOrganization;
            this.Roles = Roles;
            this.type = 101040310;
        }
    }
    IFC4X32.IfcPersonAndOrganization = IfcPersonAndOrganization;
    class IfcPhysicalQuantity extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description){
            super();
            this.Name = Name;
            this.Description = Description;
            this.type = 2483315170;
        }
    }
    IFC4X32.IfcPhysicalQuantity = IfcPhysicalQuantity;
    class IfcPhysicalSimpleQuantity extends IfcPhysicalQuantity {
        constructor(Name, Description, Unit){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.type = 2226359599;
        }
    }
    IFC4X32.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;
    class IfcPostalAddress extends IfcAddress {
        constructor(Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country){
            super(Purpose, Description, UserDefinedPurpose);
            this.Purpose = Purpose;
            this.Description = Description;
            this.UserDefinedPurpose = UserDefinedPurpose;
            this.InternalLocation = InternalLocation;
            this.AddressLines = AddressLines;
            this.PostalBox = PostalBox;
            this.Town = Town;
            this.Region = Region;
            this.PostalCode = PostalCode;
            this.Country = Country;
            this.type = 3355820592;
        }
    }
    IFC4X32.IfcPostalAddress = IfcPostalAddress;
    class IfcPresentationItem extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 677532197;
        }
    }
    IFC4X32.IfcPresentationItem = IfcPresentationItem;
    class IfcPresentationLayerAssignment extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, AssignedItems, Identifier){
            super();
            this.Name = Name;
            this.Description = Description;
            this.AssignedItems = AssignedItems;
            this.Identifier = Identifier;
            this.type = 2022622350;
        }
    }
    IFC4X32.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;
    class IfcPresentationLayerWithStyle extends IfcPresentationLayerAssignment {
        constructor(Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles){
            super(Name, Description, AssignedItems, Identifier);
            this.Name = Name;
            this.Description = Description;
            this.AssignedItems = AssignedItems;
            this.Identifier = Identifier;
            this.LayerOn = LayerOn;
            this.LayerFrozen = LayerFrozen;
            this.LayerBlocked = LayerBlocked;
            this.LayerStyles = LayerStyles;
            this.type = 1304840413;
        }
    }
    IFC4X32.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;
    class IfcPresentationStyle extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 3119450353;
        }
    }
    IFC4X32.IfcPresentationStyle = IfcPresentationStyle;
    class IfcProductRepresentation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, Representations){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Representations = Representations;
            this.type = 2095639259;
        }
    }
    IFC4X32.IfcProductRepresentation = IfcProductRepresentation;
    class IfcProfileDef extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ProfileType, ProfileName){
            super();
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.type = 3958567839;
        }
    }
    IFC4X32.IfcProfileDef = IfcProfileDef;
    class IfcProjectedCRS extends IfcCoordinateReferenceSystem {
        constructor(Name, Description, GeodeticDatum, VerticalDatum, MapProjection, MapZone, MapUnit){
            super(Name, Description, GeodeticDatum);
            this.Name = Name;
            this.Description = Description;
            this.GeodeticDatum = GeodeticDatum;
            this.VerticalDatum = VerticalDatum;
            this.MapProjection = MapProjection;
            this.MapZone = MapZone;
            this.MapUnit = MapUnit;
            this.type = 3843373140;
        }
    }
    IFC4X32.IfcProjectedCRS = IfcProjectedCRS;
    class IfcPropertyAbstraction extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 986844984;
        }
    }
    IFC4X32.IfcPropertyAbstraction = IfcPropertyAbstraction;
    class IfcPropertyEnumeration extends IfcPropertyAbstraction {
        constructor(Name, EnumerationValues, Unit){
            super();
            this.Name = Name;
            this.EnumerationValues = EnumerationValues;
            this.Unit = Unit;
            this.type = 3710013099;
        }
    }
    IFC4X32.IfcPropertyEnumeration = IfcPropertyEnumeration;
    class IfcQuantityArea extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, AreaValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.AreaValue = AreaValue;
            this.Formula = Formula;
            this.type = 2044713172;
        }
    }
    IFC4X32.IfcQuantityArea = IfcQuantityArea;
    class IfcQuantityCount extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, CountValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.CountValue = CountValue;
            this.Formula = Formula;
            this.type = 2093928680;
        }
    }
    IFC4X32.IfcQuantityCount = IfcQuantityCount;
    class IfcQuantityLength extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, LengthValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.LengthValue = LengthValue;
            this.Formula = Formula;
            this.type = 931644368;
        }
    }
    IFC4X32.IfcQuantityLength = IfcQuantityLength;
    class IfcQuantityNumber extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, NumberValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.NumberValue = NumberValue;
            this.Formula = Formula;
            this.type = 2691318326;
        }
    }
    IFC4X32.IfcQuantityNumber = IfcQuantityNumber;
    class IfcQuantityTime extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, TimeValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.TimeValue = TimeValue;
            this.Formula = Formula;
            this.type = 3252649465;
        }
    }
    IFC4X32.IfcQuantityTime = IfcQuantityTime;
    class IfcQuantityVolume extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, VolumeValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.VolumeValue = VolumeValue;
            this.Formula = Formula;
            this.type = 2405470396;
        }
    }
    IFC4X32.IfcQuantityVolume = IfcQuantityVolume;
    class IfcQuantityWeight extends IfcPhysicalSimpleQuantity {
        constructor(Name, Description, Unit, WeightValue, Formula){
            super(Name, Description, Unit);
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.WeightValue = WeightValue;
            this.Formula = Formula;
            this.type = 825690147;
        }
    }
    IFC4X32.IfcQuantityWeight = IfcQuantityWeight;
    class IfcRecurrencePattern extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RecurrenceType, DayComponent, WeekdayComponent, MonthComponent, Position, Interval, Occurrences, TimePeriods){
            super();
            this.RecurrenceType = RecurrenceType;
            this.DayComponent = DayComponent;
            this.WeekdayComponent = WeekdayComponent;
            this.MonthComponent = MonthComponent;
            this.Position = Position;
            this.Interval = Interval;
            this.Occurrences = Occurrences;
            this.TimePeriods = TimePeriods;
            this.type = 3915482550;
        }
    }
    IFC4X32.IfcRecurrencePattern = IfcRecurrencePattern;
    class IfcReference extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(TypeIdentifier, AttributeIdentifier, InstanceName, ListPositions, InnerReference){
            super();
            this.TypeIdentifier = TypeIdentifier;
            this.AttributeIdentifier = AttributeIdentifier;
            this.InstanceName = InstanceName;
            this.ListPositions = ListPositions;
            this.InnerReference = InnerReference;
            this.type = 2433181523;
        }
    }
    IFC4X32.IfcReference = IfcReference;
    class IfcRepresentation extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super();
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 1076942058;
        }
    }
    IFC4X32.IfcRepresentation = IfcRepresentation;
    class IfcRepresentationContext extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ContextIdentifier, ContextType){
            super();
            this.ContextIdentifier = ContextIdentifier;
            this.ContextType = ContextType;
            this.type = 3377609919;
        }
    }
    IFC4X32.IfcRepresentationContext = IfcRepresentationContext;
    class IfcRepresentationItem extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(){
            super();
            this.type = 3008791417;
        }
    }
    IFC4X32.IfcRepresentationItem = IfcRepresentationItem;
    class IfcRepresentationMap extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(MappingOrigin, MappedRepresentation){
            super();
            this.MappingOrigin = MappingOrigin;
            this.MappedRepresentation = MappedRepresentation;
            this.type = 1660063152;
        }
    }
    IFC4X32.IfcRepresentationMap = IfcRepresentationMap;
    class IfcResourceLevelRelationship extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description){
            super();
            this.Name = Name;
            this.Description = Description;
            this.type = 2439245199;
        }
    }
    IFC4X32.IfcResourceLevelRelationship = IfcResourceLevelRelationship;
    class IfcRigidOperation extends IfcCoordinateOperation {
        constructor(SourceCRS, TargetCRS, FirstCoordinate, SecondCoordinate, Height){
            super(SourceCRS, TargetCRS);
            this.SourceCRS = SourceCRS;
            this.TargetCRS = TargetCRS;
            this.FirstCoordinate = FirstCoordinate;
            this.SecondCoordinate = SecondCoordinate;
            this.Height = Height;
            this.type = 1794013214;
        }
    }
    IFC4X32.IfcRigidOperation = IfcRigidOperation;
    class IfcRoot extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super();
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 2341007311;
        }
    }
    IFC4X32.IfcRoot = IfcRoot;
    class IfcSIUnit extends IfcNamedUnit {
        constructor(UnitType, Prefix, Name){
            super(new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), UnitType);
            this.UnitType = UnitType;
            this.Prefix = Prefix;
            this.Name = Name;
            this.type = 448429030;
        }
    }
    IFC4X32.IfcSIUnit = IfcSIUnit;
    class IfcSchedulingTime extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, DataOrigin, UserDefinedDataOrigin){
            super();
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.type = 1054537805;
        }
    }
    IFC4X32.IfcSchedulingTime = IfcSchedulingTime;
    class IfcShapeAspect extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape){
            super();
            this.ShapeRepresentations = ShapeRepresentations;
            this.Name = Name;
            this.Description = Description;
            this.ProductDefinitional = ProductDefinitional;
            this.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
            this.type = 867548509;
        }
    }
    IFC4X32.IfcShapeAspect = IfcShapeAspect;
    class IfcShapeModel extends IfcRepresentation {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 3982875396;
        }
    }
    IFC4X32.IfcShapeModel = IfcShapeModel;
    class IfcShapeRepresentation extends IfcShapeModel {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 4240577450;
        }
    }
    IFC4X32.IfcShapeRepresentation = IfcShapeRepresentation;
    class IfcStructuralConnectionCondition extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 2273995522;
        }
    }
    IFC4X32.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;
    class IfcStructuralLoad extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 2162789131;
        }
    }
    IFC4X32.IfcStructuralLoad = IfcStructuralLoad;
    class IfcStructuralLoadConfiguration extends IfcStructuralLoad {
        constructor(Name, Values, Locations){
            super(Name);
            this.Name = Name;
            this.Values = Values;
            this.Locations = Locations;
            this.type = 3478079324;
        }
    }
    IFC4X32.IfcStructuralLoadConfiguration = IfcStructuralLoadConfiguration;
    class IfcStructuralLoadOrResult extends IfcStructuralLoad {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 609421318;
        }
    }
    IFC4X32.IfcStructuralLoadOrResult = IfcStructuralLoadOrResult;
    class IfcStructuralLoadStatic extends IfcStructuralLoadOrResult {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 2525727697;
        }
    }
    IFC4X32.IfcStructuralLoadStatic = IfcStructuralLoadStatic;
    class IfcStructuralLoadTemperature extends IfcStructuralLoadStatic {
        constructor(Name, DeltaTConstant, DeltaTY, DeltaTZ){
            super(Name);
            this.Name = Name;
            this.DeltaTConstant = DeltaTConstant;
            this.DeltaTY = DeltaTY;
            this.DeltaTZ = DeltaTZ;
            this.type = 3408363356;
        }
    }
    IFC4X32.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;
    class IfcStyleModel extends IfcRepresentation {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 2830218821;
        }
    }
    IFC4X32.IfcStyleModel = IfcStyleModel;
    class IfcStyledItem extends IfcRepresentationItem {
        constructor(Item, Styles, Name){
            super();
            this.Item = Item;
            this.Styles = Styles;
            this.Name = Name;
            this.type = 3958052878;
        }
    }
    IFC4X32.IfcStyledItem = IfcStyledItem;
    class IfcStyledRepresentation extends IfcStyleModel {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 3049322572;
        }
    }
    IFC4X32.IfcStyledRepresentation = IfcStyledRepresentation;
    class IfcSurfaceReinforcementArea extends IfcStructuralLoadOrResult {
        constructor(Name, SurfaceReinforcement1, SurfaceReinforcement2, ShearReinforcement){
            super(Name);
            this.Name = Name;
            this.SurfaceReinforcement1 = SurfaceReinforcement1;
            this.SurfaceReinforcement2 = SurfaceReinforcement2;
            this.ShearReinforcement = ShearReinforcement;
            this.type = 2934153892;
        }
    }
    IFC4X32.IfcSurfaceReinforcementArea = IfcSurfaceReinforcementArea;
    class IfcSurfaceStyle extends IfcPresentationStyle {
        constructor(Name, Side, Styles){
            super(Name);
            this.Name = Name;
            this.Side = Side;
            this.Styles = Styles;
            this.type = 1300840506;
        }
    }
    IFC4X32.IfcSurfaceStyle = IfcSurfaceStyle;
    class IfcSurfaceStyleLighting extends IfcPresentationItem {
        constructor(DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour){
            super();
            this.DiffuseTransmissionColour = DiffuseTransmissionColour;
            this.DiffuseReflectionColour = DiffuseReflectionColour;
            this.TransmissionColour = TransmissionColour;
            this.ReflectanceColour = ReflectanceColour;
            this.type = 3303107099;
        }
    }
    IFC4X32.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;
    class IfcSurfaceStyleRefraction extends IfcPresentationItem {
        constructor(RefractionIndex, DispersionFactor){
            super();
            this.RefractionIndex = RefractionIndex;
            this.DispersionFactor = DispersionFactor;
            this.type = 1607154358;
        }
    }
    IFC4X32.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;
    class IfcSurfaceStyleShading extends IfcPresentationItem {
        constructor(SurfaceColour, Transparency){
            super();
            this.SurfaceColour = SurfaceColour;
            this.Transparency = Transparency;
            this.type = 846575682;
        }
    }
    IFC4X32.IfcSurfaceStyleShading = IfcSurfaceStyleShading;
    class IfcSurfaceStyleWithTextures extends IfcPresentationItem {
        constructor(Textures){
            super();
            this.Textures = Textures;
            this.type = 1351298697;
        }
    }
    IFC4X32.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;
    class IfcSurfaceTexture extends IfcPresentationItem {
        constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter){
            super();
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.Mode = Mode;
            this.TextureTransform = TextureTransform;
            this.Parameter = Parameter;
            this.type = 626085974;
        }
    }
    IFC4X32.IfcSurfaceTexture = IfcSurfaceTexture;
    class IfcTable extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Rows, Columns){
            super();
            this.Name = Name;
            this.Rows = Rows;
            this.Columns = Columns;
            this.type = 985171141;
        }
    }
    IFC4X32.IfcTable = IfcTable;
    class IfcTableColumn extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Identifier, Name, Description, Unit, ReferencePath){
            super();
            this.Identifier = Identifier;
            this.Name = Name;
            this.Description = Description;
            this.Unit = Unit;
            this.ReferencePath = ReferencePath;
            this.type = 2043862942;
        }
    }
    IFC4X32.IfcTableColumn = IfcTableColumn;
    class IfcTableRow extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(RowCells, IsHeading){
            super();
            this.RowCells = RowCells;
            this.IsHeading = IsHeading;
            this.type = 531007025;
        }
    }
    IFC4X32.IfcTableRow = IfcTableRow;
    class IfcTaskTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.DurationType = DurationType;
            this.ScheduleDuration = ScheduleDuration;
            this.ScheduleStart = ScheduleStart;
            this.ScheduleFinish = ScheduleFinish;
            this.EarlyStart = EarlyStart;
            this.EarlyFinish = EarlyFinish;
            this.LateStart = LateStart;
            this.LateFinish = LateFinish;
            this.FreeFloat = FreeFloat;
            this.TotalFloat = TotalFloat;
            this.IsCritical = IsCritical;
            this.StatusTime = StatusTime;
            this.ActualDuration = ActualDuration;
            this.ActualStart = ActualStart;
            this.ActualFinish = ActualFinish;
            this.RemainingTime = RemainingTime;
            this.Completion = Completion;
            this.type = 1549132990;
        }
    }
    IFC4X32.IfcTaskTime = IfcTaskTime;
    class IfcTaskTimeRecurring extends IfcTaskTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion, Recurrence){
            super(Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.DurationType = DurationType;
            this.ScheduleDuration = ScheduleDuration;
            this.ScheduleStart = ScheduleStart;
            this.ScheduleFinish = ScheduleFinish;
            this.EarlyStart = EarlyStart;
            this.EarlyFinish = EarlyFinish;
            this.LateStart = LateStart;
            this.LateFinish = LateFinish;
            this.FreeFloat = FreeFloat;
            this.TotalFloat = TotalFloat;
            this.IsCritical = IsCritical;
            this.StatusTime = StatusTime;
            this.ActualDuration = ActualDuration;
            this.ActualStart = ActualStart;
            this.ActualFinish = ActualFinish;
            this.RemainingTime = RemainingTime;
            this.Completion = Completion;
            this.Recurrence = Recurrence;
            this.type = 2771591690;
        }
    }
    IFC4X32.IfcTaskTimeRecurring = IfcTaskTimeRecurring;
    class IfcTelecomAddress extends IfcAddress {
        constructor(Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL, MessagingIDs){
            super(Purpose, Description, UserDefinedPurpose);
            this.Purpose = Purpose;
            this.Description = Description;
            this.UserDefinedPurpose = UserDefinedPurpose;
            this.TelephoneNumbers = TelephoneNumbers;
            this.FacsimileNumbers = FacsimileNumbers;
            this.PagerNumber = PagerNumber;
            this.ElectronicMailAddresses = ElectronicMailAddresses;
            this.WWWHomePageURL = WWWHomePageURL;
            this.MessagingIDs = MessagingIDs;
            this.type = 912023232;
        }
    }
    IFC4X32.IfcTelecomAddress = IfcTelecomAddress;
    class IfcTextStyle extends IfcPresentationStyle {
        constructor(Name, TextCharacterAppearance, TextStyle, TextFontStyle, ModelOrDraughting){
            super(Name);
            this.Name = Name;
            this.TextCharacterAppearance = TextCharacterAppearance;
            this.TextStyle = TextStyle;
            this.TextFontStyle = TextFontStyle;
            this.ModelOrDraughting = ModelOrDraughting;
            this.type = 1447204868;
        }
    }
    IFC4X32.IfcTextStyle = IfcTextStyle;
    class IfcTextStyleForDefinedFont extends IfcPresentationItem {
        constructor(Colour, BackgroundColour){
            super();
            this.Colour = Colour;
            this.BackgroundColour = BackgroundColour;
            this.type = 2636378356;
        }
    }
    IFC4X32.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;
    class IfcTextStyleTextModel extends IfcPresentationItem {
        constructor(TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight){
            super();
            this.TextIndent = TextIndent;
            this.TextAlign = TextAlign;
            this.TextDecoration = TextDecoration;
            this.LetterSpacing = LetterSpacing;
            this.WordSpacing = WordSpacing;
            this.TextTransform = TextTransform;
            this.LineHeight = LineHeight;
            this.type = 1640371178;
        }
    }
    IFC4X32.IfcTextStyleTextModel = IfcTextStyleTextModel;
    class IfcTextureCoordinate extends IfcPresentationItem {
        constructor(Maps){
            super();
            this.Maps = Maps;
            this.type = 280115917;
        }
    }
    IFC4X32.IfcTextureCoordinate = IfcTextureCoordinate;
    class IfcTextureCoordinateGenerator extends IfcTextureCoordinate {
        constructor(Maps, Mode, Parameter){
            super(Maps);
            this.Maps = Maps;
            this.Mode = Mode;
            this.Parameter = Parameter;
            this.type = 1742049831;
        }
    }
    IFC4X32.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;
    class IfcTextureCoordinateIndices extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(TexCoordIndex, TexCoordsOf){
            super();
            this.TexCoordIndex = TexCoordIndex;
            this.TexCoordsOf = TexCoordsOf;
            this.type = 222769930;
        }
    }
    IFC4X32.IfcTextureCoordinateIndices = IfcTextureCoordinateIndices;
    class IfcTextureCoordinateIndicesWithVoids extends IfcTextureCoordinateIndices {
        constructor(TexCoordIndex, TexCoordsOf, InnerTexCoordIndices){
            super(TexCoordIndex, TexCoordsOf);
            this.TexCoordIndex = TexCoordIndex;
            this.TexCoordsOf = TexCoordsOf;
            this.InnerTexCoordIndices = InnerTexCoordIndices;
            this.type = 1010789467;
        }
    }
    IFC4X32.IfcTextureCoordinateIndicesWithVoids = IfcTextureCoordinateIndicesWithVoids;
    class IfcTextureMap extends IfcTextureCoordinate {
        constructor(Maps, Vertices, MappedTo){
            super(Maps);
            this.Maps = Maps;
            this.Vertices = Vertices;
            this.MappedTo = MappedTo;
            this.type = 2552916305;
        }
    }
    IFC4X32.IfcTextureMap = IfcTextureMap;
    class IfcTextureVertex extends IfcPresentationItem {
        constructor(Coordinates){
            super();
            this.Coordinates = Coordinates;
            this.type = 1210645708;
        }
    }
    IFC4X32.IfcTextureVertex = IfcTextureVertex;
    class IfcTextureVertexList extends IfcPresentationItem {
        constructor(TexCoordsList){
            super();
            this.TexCoordsList = TexCoordsList;
            this.type = 3611470254;
        }
    }
    IFC4X32.IfcTextureVertexList = IfcTextureVertexList;
    class IfcTimePeriod extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(StartTime, EndTime){
            super();
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.type = 1199560280;
        }
    }
    IFC4X32.IfcTimePeriod = IfcTimePeriod;
    class IfcTimeSeries extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit){
            super();
            this.Name = Name;
            this.Description = Description;
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.TimeSeriesDataType = TimeSeriesDataType;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.Unit = Unit;
            this.type = 3101149627;
        }
    }
    IFC4X32.IfcTimeSeries = IfcTimeSeries;
    class IfcTimeSeriesValue extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(ListValues){
            super();
            this.ListValues = ListValues;
            this.type = 581633288;
        }
    }
    IFC4X32.IfcTimeSeriesValue = IfcTimeSeriesValue;
    class IfcTopologicalRepresentationItem extends IfcRepresentationItem {
        constructor(){
            super();
            this.type = 1377556343;
        }
    }
    IFC4X32.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;
    class IfcTopologyRepresentation extends IfcShapeModel {
        constructor(ContextOfItems, RepresentationIdentifier, RepresentationType, Items){
            super(ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
            this.ContextOfItems = ContextOfItems;
            this.RepresentationIdentifier = RepresentationIdentifier;
            this.RepresentationType = RepresentationType;
            this.Items = Items;
            this.type = 1735638870;
        }
    }
    IFC4X32.IfcTopologyRepresentation = IfcTopologyRepresentation;
    class IfcUnitAssignment extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(Units){
            super();
            this.Units = Units;
            this.type = 180925521;
        }
    }
    IFC4X32.IfcUnitAssignment = IfcUnitAssignment;
    class IfcVertex extends IfcTopologicalRepresentationItem {
        constructor(){
            super();
            this.type = 2799835756;
        }
    }
    IFC4X32.IfcVertex = IfcVertex;
    class IfcVertexPoint extends IfcVertex {
        constructor(VertexGeometry){
            super();
            this.VertexGeometry = VertexGeometry;
            this.type = 1907098498;
        }
    }
    IFC4X32.IfcVertexPoint = IfcVertexPoint;
    class IfcVirtualGridIntersection extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(IntersectingAxes, OffsetDistances){
            super();
            this.IntersectingAxes = IntersectingAxes;
            this.OffsetDistances = OffsetDistances;
            this.type = 891718957;
        }
    }
    IFC4X32.IfcVirtualGridIntersection = IfcVirtualGridIntersection;
    class IfcWellKnownText extends $3b8da494b8e92f36$export$1e3b93c2f61ce3f4 {
        constructor(WellKnownText, CoordinateReferenceSystem){
            super();
            this.WellKnownText = WellKnownText;
            this.CoordinateReferenceSystem = CoordinateReferenceSystem;
            this.type = 1175146630;
        }
    }
    IFC4X32.IfcWellKnownText = IfcWellKnownText;
    class IfcWorkTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, RecurrencePattern, StartDate, FinishDate){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.RecurrencePattern = RecurrencePattern;
            this.StartDate = StartDate;
            this.FinishDate = FinishDate;
            this.type = 1236880293;
        }
    }
    IFC4X32.IfcWorkTime = IfcWorkTime;
    class IfcAlignmentCantSegment extends IfcAlignmentParameterSegment {
        constructor(StartTag, EndTag, StartDistAlong, HorizontalLength, StartCantLeft, EndCantLeft, StartCantRight, EndCantRight, PredefinedType){
            super(StartTag, EndTag);
            this.StartTag = StartTag;
            this.EndTag = EndTag;
            this.StartDistAlong = StartDistAlong;
            this.HorizontalLength = HorizontalLength;
            this.StartCantLeft = StartCantLeft;
            this.EndCantLeft = EndCantLeft;
            this.StartCantRight = StartCantRight;
            this.EndCantRight = EndCantRight;
            this.PredefinedType = PredefinedType;
            this.type = 3752311538;
        }
    }
    IFC4X32.IfcAlignmentCantSegment = IfcAlignmentCantSegment;
    class IfcAlignmentHorizontalSegment extends IfcAlignmentParameterSegment {
        constructor(StartTag, EndTag, StartPoint, StartDirection, StartRadiusOfCurvature, EndRadiusOfCurvature, SegmentLength, GravityCenterLineHeight, PredefinedType){
            super(StartTag, EndTag);
            this.StartTag = StartTag;
            this.EndTag = EndTag;
            this.StartPoint = StartPoint;
            this.StartDirection = StartDirection;
            this.StartRadiusOfCurvature = StartRadiusOfCurvature;
            this.EndRadiusOfCurvature = EndRadiusOfCurvature;
            this.SegmentLength = SegmentLength;
            this.GravityCenterLineHeight = GravityCenterLineHeight;
            this.PredefinedType = PredefinedType;
            this.type = 536804194;
        }
    }
    IFC4X32.IfcAlignmentHorizontalSegment = IfcAlignmentHorizontalSegment;
    class IfcApprovalRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingApproval, RelatedApprovals){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingApproval = RelatingApproval;
            this.RelatedApprovals = RelatedApprovals;
            this.type = 3869604511;
        }
    }
    IFC4X32.IfcApprovalRelationship = IfcApprovalRelationship;
    class IfcArbitraryClosedProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, OuterCurve){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.OuterCurve = OuterCurve;
            this.type = 3798115385;
        }
    }
    IFC4X32.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;
    class IfcArbitraryOpenProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, Curve){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Curve = Curve;
            this.type = 1310608509;
        }
    }
    IFC4X32.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;
    class IfcArbitraryProfileDefWithVoids extends IfcArbitraryClosedProfileDef {
        constructor(ProfileType, ProfileName, OuterCurve, InnerCurves){
            super(ProfileType, ProfileName, OuterCurve);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.OuterCurve = OuterCurve;
            this.InnerCurves = InnerCurves;
            this.type = 2705031697;
        }
    }
    IFC4X32.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;
    class IfcBlobTexture extends IfcSurfaceTexture {
        constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, RasterFormat, RasterCode){
            super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.Mode = Mode;
            this.TextureTransform = TextureTransform;
            this.Parameter = Parameter;
            this.RasterFormat = RasterFormat;
            this.RasterCode = RasterCode;
            this.type = 616511568;
        }
    }
    IFC4X32.IfcBlobTexture = IfcBlobTexture;
    class IfcCenterLineProfileDef extends IfcArbitraryOpenProfileDef {
        constructor(ProfileType, ProfileName, Curve, Thickness){
            super(ProfileType, ProfileName, Curve);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Curve = Curve;
            this.Thickness = Thickness;
            this.type = 3150382593;
        }
    }
    IFC4X32.IfcCenterLineProfileDef = IfcCenterLineProfileDef;
    class IfcClassification extends IfcExternalInformation {
        constructor(Source, Edition, EditionDate, Name, Description, Specification, ReferenceTokens){
            super();
            this.Source = Source;
            this.Edition = Edition;
            this.EditionDate = EditionDate;
            this.Name = Name;
            this.Description = Description;
            this.Specification = Specification;
            this.ReferenceTokens = ReferenceTokens;
            this.type = 747523909;
        }
    }
    IFC4X32.IfcClassification = IfcClassification;
    class IfcClassificationReference extends IfcExternalReference {
        constructor(Location, Identification, Name, ReferencedSource, Description, Sort){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.ReferencedSource = ReferencedSource;
            this.Description = Description;
            this.Sort = Sort;
            this.type = 647927063;
        }
    }
    IFC4X32.IfcClassificationReference = IfcClassificationReference;
    class IfcColourRgbList extends IfcPresentationItem {
        constructor(ColourList){
            super();
            this.ColourList = ColourList;
            this.type = 3285139300;
        }
    }
    IFC4X32.IfcColourRgbList = IfcColourRgbList;
    class IfcColourSpecification extends IfcPresentationItem {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 3264961684;
        }
    }
    IFC4X32.IfcColourSpecification = IfcColourSpecification;
    class IfcCompositeProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, Profiles, Label){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Profiles = Profiles;
            this.Label = Label;
            this.type = 1485152156;
        }
    }
    IFC4X32.IfcCompositeProfileDef = IfcCompositeProfileDef;
    class IfcConnectedFaceSet extends IfcTopologicalRepresentationItem {
        constructor(CfsFaces){
            super();
            this.CfsFaces = CfsFaces;
            this.type = 370225590;
        }
    }
    IFC4X32.IfcConnectedFaceSet = IfcConnectedFaceSet;
    class IfcConnectionCurveGeometry extends IfcConnectionGeometry {
        constructor(CurveOnRelatingElement, CurveOnRelatedElement){
            super();
            this.CurveOnRelatingElement = CurveOnRelatingElement;
            this.CurveOnRelatedElement = CurveOnRelatedElement;
            this.type = 1981873012;
        }
    }
    IFC4X32.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;
    class IfcConnectionPointEccentricity extends IfcConnectionPointGeometry {
        constructor(PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ){
            super(PointOnRelatingElement, PointOnRelatedElement);
            this.PointOnRelatingElement = PointOnRelatingElement;
            this.PointOnRelatedElement = PointOnRelatedElement;
            this.EccentricityInX = EccentricityInX;
            this.EccentricityInY = EccentricityInY;
            this.EccentricityInZ = EccentricityInZ;
            this.type = 45288368;
        }
    }
    IFC4X32.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;
    class IfcContextDependentUnit extends IfcNamedUnit {
        constructor(Dimensions, UnitType, Name){
            super(Dimensions, UnitType);
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.Name = Name;
            this.type = 3050246964;
        }
    }
    IFC4X32.IfcContextDependentUnit = IfcContextDependentUnit;
    class IfcConversionBasedUnit extends IfcNamedUnit {
        constructor(Dimensions, UnitType, Name, ConversionFactor){
            super(Dimensions, UnitType);
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.Name = Name;
            this.ConversionFactor = ConversionFactor;
            this.type = 2889183280;
        }
    }
    IFC4X32.IfcConversionBasedUnit = IfcConversionBasedUnit;
    class IfcConversionBasedUnitWithOffset extends IfcConversionBasedUnit {
        constructor(Dimensions, UnitType, Name, ConversionFactor, ConversionOffset){
            super(Dimensions, UnitType, Name, ConversionFactor);
            this.Dimensions = Dimensions;
            this.UnitType = UnitType;
            this.Name = Name;
            this.ConversionFactor = ConversionFactor;
            this.ConversionOffset = ConversionOffset;
            this.type = 2713554722;
        }
    }
    IFC4X32.IfcConversionBasedUnitWithOffset = IfcConversionBasedUnitWithOffset;
    class IfcCurrencyRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingMonetaryUnit = RelatingMonetaryUnit;
            this.RelatedMonetaryUnit = RelatedMonetaryUnit;
            this.ExchangeRate = ExchangeRate;
            this.RateDateTime = RateDateTime;
            this.RateSource = RateSource;
            this.type = 539742890;
        }
    }
    IFC4X32.IfcCurrencyRelationship = IfcCurrencyRelationship;
    class IfcCurveStyle extends IfcPresentationStyle {
        constructor(Name, CurveFont, CurveWidth, CurveColour, ModelOrDraughting){
            super(Name);
            this.Name = Name;
            this.CurveFont = CurveFont;
            this.CurveWidth = CurveWidth;
            this.CurveColour = CurveColour;
            this.ModelOrDraughting = ModelOrDraughting;
            this.type = 3800577675;
        }
    }
    IFC4X32.IfcCurveStyle = IfcCurveStyle;
    class IfcCurveStyleFont extends IfcPresentationItem {
        constructor(Name, PatternList){
            super();
            this.Name = Name;
            this.PatternList = PatternList;
            this.type = 1105321065;
        }
    }
    IFC4X32.IfcCurveStyleFont = IfcCurveStyleFont;
    class IfcCurveStyleFontAndScaling extends IfcPresentationItem {
        constructor(Name, CurveStyleFont, CurveFontScaling){
            super();
            this.Name = Name;
            this.CurveStyleFont = CurveStyleFont;
            this.CurveFontScaling = CurveFontScaling;
            this.type = 2367409068;
        }
    }
    IFC4X32.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;
    class IfcCurveStyleFontPattern extends IfcPresentationItem {
        constructor(VisibleSegmentLength, InvisibleSegmentLength){
            super();
            this.VisibleSegmentLength = VisibleSegmentLength;
            this.InvisibleSegmentLength = InvisibleSegmentLength;
            this.type = 3510044353;
        }
    }
    IFC4X32.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;
    class IfcDerivedProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, ParentProfile, Operator, Label){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.ParentProfile = ParentProfile;
            this.Operator = Operator;
            this.Label = Label;
            this.type = 3632507154;
        }
    }
    IFC4X32.IfcDerivedProfileDef = IfcDerivedProfileDef;
    class IfcDocumentInformation extends IfcExternalInformation {
        constructor(Identification, Name, Description, Location, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status){
            super();
            this.Identification = Identification;
            this.Name = Name;
            this.Description = Description;
            this.Location = Location;
            this.Purpose = Purpose;
            this.IntendedUse = IntendedUse;
            this.Scope = Scope;
            this.Revision = Revision;
            this.DocumentOwner = DocumentOwner;
            this.Editors = Editors;
            this.CreationTime = CreationTime;
            this.LastRevisionTime = LastRevisionTime;
            this.ElectronicFormat = ElectronicFormat;
            this.ValidFrom = ValidFrom;
            this.ValidUntil = ValidUntil;
            this.Confidentiality = Confidentiality;
            this.Status = Status;
            this.type = 1154170062;
        }
    }
    IFC4X32.IfcDocumentInformation = IfcDocumentInformation;
    class IfcDocumentInformationRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingDocument, RelatedDocuments, RelationshipType){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingDocument = RelatingDocument;
            this.RelatedDocuments = RelatedDocuments;
            this.RelationshipType = RelationshipType;
            this.type = 770865208;
        }
    }
    IFC4X32.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;
    class IfcDocumentReference extends IfcExternalReference {
        constructor(Location, Identification, Name, Description, ReferencedDocument){
            super(Location, Identification, Name);
            this.Location = Location;
            this.Identification = Identification;
            this.Name = Name;
            this.Description = Description;
            this.ReferencedDocument = ReferencedDocument;
            this.type = 3732053477;
        }
    }
    IFC4X32.IfcDocumentReference = IfcDocumentReference;
    class IfcEdge extends IfcTopologicalRepresentationItem {
        constructor(EdgeStart, EdgeEnd){
            super();
            this.EdgeStart = EdgeStart;
            this.EdgeEnd = EdgeEnd;
            this.type = 3900360178;
        }
    }
    IFC4X32.IfcEdge = IfcEdge;
    class IfcEdgeCurve extends IfcEdge {
        constructor(EdgeStart, EdgeEnd, EdgeGeometry, SameSense){
            super(EdgeStart, EdgeEnd);
            this.EdgeStart = EdgeStart;
            this.EdgeEnd = EdgeEnd;
            this.EdgeGeometry = EdgeGeometry;
            this.SameSense = SameSense;
            this.type = 476780140;
        }
    }
    IFC4X32.IfcEdgeCurve = IfcEdgeCurve;
    class IfcEventTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, ActualDate, EarlyDate, LateDate, ScheduleDate){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.ActualDate = ActualDate;
            this.EarlyDate = EarlyDate;
            this.LateDate = LateDate;
            this.ScheduleDate = ScheduleDate;
            this.type = 211053100;
        }
    }
    IFC4X32.IfcEventTime = IfcEventTime;
    class IfcExtendedProperties extends IfcPropertyAbstraction {
        constructor(Name, Description, Properties2){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Properties = Properties2;
            this.type = 297599258;
        }
    }
    IFC4X32.IfcExtendedProperties = IfcExtendedProperties;
    class IfcExternalReferenceRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingReference, RelatedResourceObjects){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingReference = RelatingReference;
            this.RelatedResourceObjects = RelatedResourceObjects;
            this.type = 1437805879;
        }
    }
    IFC4X32.IfcExternalReferenceRelationship = IfcExternalReferenceRelationship;
    class IfcFace extends IfcTopologicalRepresentationItem {
        constructor(Bounds){
            super();
            this.Bounds = Bounds;
            this.type = 2556980723;
        }
    }
    IFC4X32.IfcFace = IfcFace;
    class IfcFaceBound extends IfcTopologicalRepresentationItem {
        constructor(Bound, Orientation){
            super();
            this.Bound = Bound;
            this.Orientation = Orientation;
            this.type = 1809719519;
        }
    }
    IFC4X32.IfcFaceBound = IfcFaceBound;
    class IfcFaceOuterBound extends IfcFaceBound {
        constructor(Bound, Orientation){
            super(Bound, Orientation);
            this.Bound = Bound;
            this.Orientation = Orientation;
            this.type = 803316827;
        }
    }
    IFC4X32.IfcFaceOuterBound = IfcFaceOuterBound;
    class IfcFaceSurface extends IfcFace {
        constructor(Bounds, FaceSurface, SameSense){
            super(Bounds);
            this.Bounds = Bounds;
            this.FaceSurface = FaceSurface;
            this.SameSense = SameSense;
            this.type = 3008276851;
        }
    }
    IFC4X32.IfcFaceSurface = IfcFaceSurface;
    class IfcFailureConnectionCondition extends IfcStructuralConnectionCondition {
        constructor(Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ){
            super(Name);
            this.Name = Name;
            this.TensionFailureX = TensionFailureX;
            this.TensionFailureY = TensionFailureY;
            this.TensionFailureZ = TensionFailureZ;
            this.CompressionFailureX = CompressionFailureX;
            this.CompressionFailureY = CompressionFailureY;
            this.CompressionFailureZ = CompressionFailureZ;
            this.type = 4219587988;
        }
    }
    IFC4X32.IfcFailureConnectionCondition = IfcFailureConnectionCondition;
    class IfcFillAreaStyle extends IfcPresentationStyle {
        constructor(Name, FillStyles, ModelOrDraughting){
            super(Name);
            this.Name = Name;
            this.FillStyles = FillStyles;
            this.ModelOrDraughting = ModelOrDraughting;
            this.type = 738692330;
        }
    }
    IFC4X32.IfcFillAreaStyle = IfcFillAreaStyle;
    class IfcGeometricRepresentationContext extends IfcRepresentationContext {
        constructor(ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth){
            super(ContextIdentifier, ContextType);
            this.ContextIdentifier = ContextIdentifier;
            this.ContextType = ContextType;
            this.CoordinateSpaceDimension = CoordinateSpaceDimension;
            this.Precision = Precision;
            this.WorldCoordinateSystem = WorldCoordinateSystem;
            this.TrueNorth = TrueNorth;
            this.type = 3448662350;
        }
    }
    IFC4X32.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;
    class IfcGeometricRepresentationItem extends IfcRepresentationItem {
        constructor(){
            super();
            this.type = 2453401579;
        }
    }
    IFC4X32.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;
    class IfcGeometricRepresentationSubContext extends IfcGeometricRepresentationContext {
        constructor(ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView){
            super(ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), null);
            this.ContextIdentifier = ContextIdentifier;
            this.ContextType = ContextType;
            this.ParentContext = ParentContext;
            this.TargetScale = TargetScale;
            this.TargetView = TargetView;
            this.UserDefinedTargetView = UserDefinedTargetView;
            this.type = 4142052618;
        }
    }
    IFC4X32.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;
    class IfcGeometricSet extends IfcGeometricRepresentationItem {
        constructor(Elements){
            super();
            this.Elements = Elements;
            this.type = 3590301190;
        }
    }
    IFC4X32.IfcGeometricSet = IfcGeometricSet;
    class IfcGridPlacement extends IfcObjectPlacement {
        constructor(PlacementRelTo, PlacementLocation, PlacementRefDirection){
            super(PlacementRelTo);
            this.PlacementRelTo = PlacementRelTo;
            this.PlacementLocation = PlacementLocation;
            this.PlacementRefDirection = PlacementRefDirection;
            this.type = 178086475;
        }
    }
    IFC4X32.IfcGridPlacement = IfcGridPlacement;
    class IfcHalfSpaceSolid extends IfcGeometricRepresentationItem {
        constructor(BaseSurface, AgreementFlag){
            super();
            this.BaseSurface = BaseSurface;
            this.AgreementFlag = AgreementFlag;
            this.type = 812098782;
        }
    }
    IFC4X32.IfcHalfSpaceSolid = IfcHalfSpaceSolid;
    class IfcImageTexture extends IfcSurfaceTexture {
        constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, URLReference){
            super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.Mode = Mode;
            this.TextureTransform = TextureTransform;
            this.Parameter = Parameter;
            this.URLReference = URLReference;
            this.type = 3905492369;
        }
    }
    IFC4X32.IfcImageTexture = IfcImageTexture;
    class IfcIndexedColourMap extends IfcPresentationItem {
        constructor(MappedTo, Opacity, Colours, ColourIndex){
            super();
            this.MappedTo = MappedTo;
            this.Opacity = Opacity;
            this.Colours = Colours;
            this.ColourIndex = ColourIndex;
            this.type = 3570813810;
        }
    }
    IFC4X32.IfcIndexedColourMap = IfcIndexedColourMap;
    class IfcIndexedTextureMap extends IfcTextureCoordinate {
        constructor(Maps, MappedTo, TexCoords){
            super(Maps);
            this.Maps = Maps;
            this.MappedTo = MappedTo;
            this.TexCoords = TexCoords;
            this.type = 1437953363;
        }
    }
    IFC4X32.IfcIndexedTextureMap = IfcIndexedTextureMap;
    class IfcIndexedTriangleTextureMap extends IfcIndexedTextureMap {
        constructor(Maps, MappedTo, TexCoords, TexCoordIndex){
            super(Maps, MappedTo, TexCoords);
            this.Maps = Maps;
            this.MappedTo = MappedTo;
            this.TexCoords = TexCoords;
            this.TexCoordIndex = TexCoordIndex;
            this.type = 2133299955;
        }
    }
    IFC4X32.IfcIndexedTriangleTextureMap = IfcIndexedTriangleTextureMap;
    class IfcIrregularTimeSeries extends IfcTimeSeries {
        constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values){
            super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
            this.Name = Name;
            this.Description = Description;
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.TimeSeriesDataType = TimeSeriesDataType;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.Unit = Unit;
            this.Values = Values;
            this.type = 3741457305;
        }
    }
    IFC4X32.IfcIrregularTimeSeries = IfcIrregularTimeSeries;
    class IfcLagTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, LagValue, DurationType){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.LagValue = LagValue;
            this.DurationType = DurationType;
            this.type = 1585845231;
        }
    }
    IFC4X32.IfcLagTime = IfcLagTime;
    class IfcLightSource extends IfcGeometricRepresentationItem {
        constructor(Name, LightColour, AmbientIntensity, Intensity){
            super();
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.type = 1402838566;
        }
    }
    IFC4X32.IfcLightSource = IfcLightSource;
    class IfcLightSourceAmbient extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.type = 125510826;
        }
    }
    IFC4X32.IfcLightSourceAmbient = IfcLightSourceAmbient;
    class IfcLightSourceDirectional extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Orientation){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Orientation = Orientation;
            this.type = 2604431987;
        }
    }
    IFC4X32.IfcLightSourceDirectional = IfcLightSourceDirectional;
    class IfcLightSourceGoniometric extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Position = Position;
            this.ColourAppearance = ColourAppearance;
            this.ColourTemperature = ColourTemperature;
            this.LuminousFlux = LuminousFlux;
            this.LightEmissionSource = LightEmissionSource;
            this.LightDistributionDataSource = LightDistributionDataSource;
            this.type = 4266656042;
        }
    }
    IFC4X32.IfcLightSourceGoniometric = IfcLightSourceGoniometric;
    class IfcLightSourcePositional extends IfcLightSource {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation){
            super(Name, LightColour, AmbientIntensity, Intensity);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Position = Position;
            this.Radius = Radius;
            this.ConstantAttenuation = ConstantAttenuation;
            this.DistanceAttenuation = DistanceAttenuation;
            this.QuadricAttenuation = QuadricAttenuation;
            this.type = 1520743889;
        }
    }
    IFC4X32.IfcLightSourcePositional = IfcLightSourcePositional;
    class IfcLightSourceSpot extends IfcLightSourcePositional {
        constructor(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle){
            super(Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
            this.Name = Name;
            this.LightColour = LightColour;
            this.AmbientIntensity = AmbientIntensity;
            this.Intensity = Intensity;
            this.Position = Position;
            this.Radius = Radius;
            this.ConstantAttenuation = ConstantAttenuation;
            this.DistanceAttenuation = DistanceAttenuation;
            this.QuadricAttenuation = QuadricAttenuation;
            this.Orientation = Orientation;
            this.ConcentrationExponent = ConcentrationExponent;
            this.SpreadAngle = SpreadAngle;
            this.BeamWidthAngle = BeamWidthAngle;
            this.type = 3422422726;
        }
    }
    IFC4X32.IfcLightSourceSpot = IfcLightSourceSpot;
    class IfcLinearPlacement extends IfcObjectPlacement {
        constructor(PlacementRelTo, RelativePlacement, CartesianPosition){
            super(PlacementRelTo);
            this.PlacementRelTo = PlacementRelTo;
            this.RelativePlacement = RelativePlacement;
            this.CartesianPosition = CartesianPosition;
            this.type = 388784114;
        }
    }
    IFC4X32.IfcLinearPlacement = IfcLinearPlacement;
    class IfcLocalPlacement extends IfcObjectPlacement {
        constructor(PlacementRelTo, RelativePlacement){
            super(PlacementRelTo);
            this.PlacementRelTo = PlacementRelTo;
            this.RelativePlacement = RelativePlacement;
            this.type = 2624227202;
        }
    }
    IFC4X32.IfcLocalPlacement = IfcLocalPlacement;
    class IfcLoop extends IfcTopologicalRepresentationItem {
        constructor(){
            super();
            this.type = 1008929658;
        }
    }
    IFC4X32.IfcLoop = IfcLoop;
    class IfcMappedItem extends IfcRepresentationItem {
        constructor(MappingSource, MappingTarget){
            super();
            this.MappingSource = MappingSource;
            this.MappingTarget = MappingTarget;
            this.type = 2347385850;
        }
    }
    IFC4X32.IfcMappedItem = IfcMappedItem;
    class IfcMaterial extends IfcMaterialDefinition {
        constructor(Name, Description, Category){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Category = Category;
            this.type = 1838606355;
        }
    }
    IFC4X32.IfcMaterial = IfcMaterial;
    class IfcMaterialConstituent extends IfcMaterialDefinition {
        constructor(Name, Description, Material, Fraction, Category){
            super();
            this.Name = Name;
            this.Description = Description;
            this.Material = Material;
            this.Fraction = Fraction;
            this.Category = Category;
            this.type = 3708119e3;
        }
    }
    IFC4X32.IfcMaterialConstituent = IfcMaterialConstituent;
    class IfcMaterialConstituentSet extends IfcMaterialDefinition {
        constructor(Name, Description, MaterialConstituents){
            super();
            this.Name = Name;
            this.Description = Description;
            this.MaterialConstituents = MaterialConstituents;
            this.type = 2852063980;
        }
    }
    IFC4X32.IfcMaterialConstituentSet = IfcMaterialConstituentSet;
    class IfcMaterialDefinitionRepresentation extends IfcProductRepresentation {
        constructor(Name, Description, Representations, RepresentedMaterial){
            super(Name, Description, Representations);
            this.Name = Name;
            this.Description = Description;
            this.Representations = Representations;
            this.RepresentedMaterial = RepresentedMaterial;
            this.type = 2022407955;
        }
    }
    IFC4X32.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;
    class IfcMaterialLayerSetUsage extends IfcMaterialUsageDefinition {
        constructor(ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine, ReferenceExtent){
            super();
            this.ForLayerSet = ForLayerSet;
            this.LayerSetDirection = LayerSetDirection;
            this.DirectionSense = DirectionSense;
            this.OffsetFromReferenceLine = OffsetFromReferenceLine;
            this.ReferenceExtent = ReferenceExtent;
            this.type = 1303795690;
        }
    }
    IFC4X32.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;
    class IfcMaterialProfileSetUsage extends IfcMaterialUsageDefinition {
        constructor(ForProfileSet, CardinalPoint, ReferenceExtent){
            super();
            this.ForProfileSet = ForProfileSet;
            this.CardinalPoint = CardinalPoint;
            this.ReferenceExtent = ReferenceExtent;
            this.type = 3079605661;
        }
    }
    IFC4X32.IfcMaterialProfileSetUsage = IfcMaterialProfileSetUsage;
    class IfcMaterialProfileSetUsageTapering extends IfcMaterialProfileSetUsage {
        constructor(ForProfileSet, CardinalPoint, ReferenceExtent, ForProfileEndSet, CardinalEndPoint){
            super(ForProfileSet, CardinalPoint, ReferenceExtent);
            this.ForProfileSet = ForProfileSet;
            this.CardinalPoint = CardinalPoint;
            this.ReferenceExtent = ReferenceExtent;
            this.ForProfileEndSet = ForProfileEndSet;
            this.CardinalEndPoint = CardinalEndPoint;
            this.type = 3404854881;
        }
    }
    IFC4X32.IfcMaterialProfileSetUsageTapering = IfcMaterialProfileSetUsageTapering;
    class IfcMaterialProperties extends IfcExtendedProperties {
        constructor(Name, Description, Properties2, Material){
            super(Name, Description, Properties2);
            this.Name = Name;
            this.Description = Description;
            this.Properties = Properties2;
            this.Material = Material;
            this.type = 3265635763;
        }
    }
    IFC4X32.IfcMaterialProperties = IfcMaterialProperties;
    class IfcMaterialRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingMaterial, RelatedMaterials, MaterialExpression){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingMaterial = RelatingMaterial;
            this.RelatedMaterials = RelatedMaterials;
            this.MaterialExpression = MaterialExpression;
            this.type = 853536259;
        }
    }
    IFC4X32.IfcMaterialRelationship = IfcMaterialRelationship;
    class IfcMirroredProfileDef extends IfcDerivedProfileDef {
        constructor(ProfileType, ProfileName, ParentProfile, Label){
            super(ProfileType, ProfileName, ParentProfile, new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), Label);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.ParentProfile = ParentProfile;
            this.Label = Label;
            this.type = 2998442950;
        }
    }
    IFC4X32.IfcMirroredProfileDef = IfcMirroredProfileDef;
    class IfcObjectDefinition extends IfcRoot {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 219451334;
        }
    }
    IFC4X32.IfcObjectDefinition = IfcObjectDefinition;
    class IfcOpenCrossProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, HorizontalWidths, Widths, Slopes, Tags, OffsetPoint){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.HorizontalWidths = HorizontalWidths;
            this.Widths = Widths;
            this.Slopes = Slopes;
            this.Tags = Tags;
            this.OffsetPoint = OffsetPoint;
            this.type = 182550632;
        }
    }
    IFC4X32.IfcOpenCrossProfileDef = IfcOpenCrossProfileDef;
    class IfcOpenShell extends IfcConnectedFaceSet {
        constructor(CfsFaces){
            super(CfsFaces);
            this.CfsFaces = CfsFaces;
            this.type = 2665983363;
        }
    }
    IFC4X32.IfcOpenShell = IfcOpenShell;
    class IfcOrganizationRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingOrganization, RelatedOrganizations){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingOrganization = RelatingOrganization;
            this.RelatedOrganizations = RelatedOrganizations;
            this.type = 1411181986;
        }
    }
    IFC4X32.IfcOrganizationRelationship = IfcOrganizationRelationship;
    class IfcOrientedEdge extends IfcEdge {
        constructor(EdgeElement, Orientation){
            super(new $3b8da494b8e92f36$export$94890c79f4cae6d6(0), new $3b8da494b8e92f36$export$94890c79f4cae6d6(0));
            this.EdgeElement = EdgeElement;
            this.Orientation = Orientation;
            this.type = 1029017970;
        }
    }
    IFC4X32.IfcOrientedEdge = IfcOrientedEdge;
    class IfcParameterizedProfileDef extends IfcProfileDef {
        constructor(ProfileType, ProfileName, Position){
            super(ProfileType, ProfileName);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.type = 2529465313;
        }
    }
    IFC4X32.IfcParameterizedProfileDef = IfcParameterizedProfileDef;
    class IfcPath extends IfcTopologicalRepresentationItem {
        constructor(EdgeList){
            super();
            this.EdgeList = EdgeList;
            this.type = 2519244187;
        }
    }
    IFC4X32.IfcPath = IfcPath;
    class IfcPhysicalComplexQuantity extends IfcPhysicalQuantity {
        constructor(Name, Description, HasQuantities, Discrimination, Quality, Usage){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.HasQuantities = HasQuantities;
            this.Discrimination = Discrimination;
            this.Quality = Quality;
            this.Usage = Usage;
            this.type = 3021840470;
        }
    }
    IFC4X32.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;
    class IfcPixelTexture extends IfcSurfaceTexture {
        constructor(RepeatS, RepeatT, Mode, TextureTransform, Parameter, Width, Height, ColourComponents, Pixel){
            super(RepeatS, RepeatT, Mode, TextureTransform, Parameter);
            this.RepeatS = RepeatS;
            this.RepeatT = RepeatT;
            this.Mode = Mode;
            this.TextureTransform = TextureTransform;
            this.Parameter = Parameter;
            this.Width = Width;
            this.Height = Height;
            this.ColourComponents = ColourComponents;
            this.Pixel = Pixel;
            this.type = 597895409;
        }
    }
    IFC4X32.IfcPixelTexture = IfcPixelTexture;
    class IfcPlacement extends IfcGeometricRepresentationItem {
        constructor(Location){
            super();
            this.Location = Location;
            this.type = 2004835150;
        }
    }
    IFC4X32.IfcPlacement = IfcPlacement;
    class IfcPlanarExtent extends IfcGeometricRepresentationItem {
        constructor(SizeInX, SizeInY){
            super();
            this.SizeInX = SizeInX;
            this.SizeInY = SizeInY;
            this.type = 1663979128;
        }
    }
    IFC4X32.IfcPlanarExtent = IfcPlanarExtent;
    class IfcPoint extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 2067069095;
        }
    }
    IFC4X32.IfcPoint = IfcPoint;
    class IfcPointByDistanceExpression extends IfcPoint {
        constructor(DistanceAlong, OffsetLateral, OffsetVertical, OffsetLongitudinal, BasisCurve){
            super();
            this.DistanceAlong = DistanceAlong;
            this.OffsetLateral = OffsetLateral;
            this.OffsetVertical = OffsetVertical;
            this.OffsetLongitudinal = OffsetLongitudinal;
            this.BasisCurve = BasisCurve;
            this.type = 2165702409;
        }
    }
    IFC4X32.IfcPointByDistanceExpression = IfcPointByDistanceExpression;
    class IfcPointOnCurve extends IfcPoint {
        constructor(BasisCurve, PointParameter){
            super();
            this.BasisCurve = BasisCurve;
            this.PointParameter = PointParameter;
            this.type = 4022376103;
        }
    }
    IFC4X32.IfcPointOnCurve = IfcPointOnCurve;
    class IfcPointOnSurface extends IfcPoint {
        constructor(BasisSurface, PointParameterU, PointParameterV){
            super();
            this.BasisSurface = BasisSurface;
            this.PointParameterU = PointParameterU;
            this.PointParameterV = PointParameterV;
            this.type = 1423911732;
        }
    }
    IFC4X32.IfcPointOnSurface = IfcPointOnSurface;
    class IfcPolyLoop extends IfcLoop {
        constructor(Polygon){
            super();
            this.Polygon = Polygon;
            this.type = 2924175390;
        }
    }
    IFC4X32.IfcPolyLoop = IfcPolyLoop;
    class IfcPolygonalBoundedHalfSpace extends IfcHalfSpaceSolid {
        constructor(BaseSurface, AgreementFlag, Position, PolygonalBoundary){
            super(BaseSurface, AgreementFlag);
            this.BaseSurface = BaseSurface;
            this.AgreementFlag = AgreementFlag;
            this.Position = Position;
            this.PolygonalBoundary = PolygonalBoundary;
            this.type = 2775532180;
        }
    }
    IFC4X32.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;
    class IfcPreDefinedItem extends IfcPresentationItem {
        constructor(Name){
            super();
            this.Name = Name;
            this.type = 3727388367;
        }
    }
    IFC4X32.IfcPreDefinedItem = IfcPreDefinedItem;
    class IfcPreDefinedProperties extends IfcPropertyAbstraction {
        constructor(){
            super();
            this.type = 3778827333;
        }
    }
    IFC4X32.IfcPreDefinedProperties = IfcPreDefinedProperties;
    class IfcPreDefinedTextFont extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 1775413392;
        }
    }
    IFC4X32.IfcPreDefinedTextFont = IfcPreDefinedTextFont;
    class IfcProductDefinitionShape extends IfcProductRepresentation {
        constructor(Name, Description, Representations){
            super(Name, Description, Representations);
            this.Name = Name;
            this.Description = Description;
            this.Representations = Representations;
            this.type = 673634403;
        }
    }
    IFC4X32.IfcProductDefinitionShape = IfcProductDefinitionShape;
    class IfcProfileProperties extends IfcExtendedProperties {
        constructor(Name, Description, Properties2, ProfileDefinition){
            super(Name, Description, Properties2);
            this.Name = Name;
            this.Description = Description;
            this.Properties = Properties2;
            this.ProfileDefinition = ProfileDefinition;
            this.type = 2802850158;
        }
    }
    IFC4X32.IfcProfileProperties = IfcProfileProperties;
    class IfcProperty extends IfcPropertyAbstraction {
        constructor(Name, Specification){
            super();
            this.Name = Name;
            this.Specification = Specification;
            this.type = 2598011224;
        }
    }
    IFC4X32.IfcProperty = IfcProperty;
    class IfcPropertyDefinition extends IfcRoot {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 1680319473;
        }
    }
    IFC4X32.IfcPropertyDefinition = IfcPropertyDefinition;
    class IfcPropertyDependencyRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, DependingProperty, DependantProperty, Expression){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.DependingProperty = DependingProperty;
            this.DependantProperty = DependantProperty;
            this.Expression = Expression;
            this.type = 148025276;
        }
    }
    IFC4X32.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;
    class IfcPropertySetDefinition extends IfcPropertyDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 3357820518;
        }
    }
    IFC4X32.IfcPropertySetDefinition = IfcPropertySetDefinition;
    class IfcPropertyTemplateDefinition extends IfcPropertyDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 1482703590;
        }
    }
    IFC4X32.IfcPropertyTemplateDefinition = IfcPropertyTemplateDefinition;
    class IfcQuantitySet extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 2090586900;
        }
    }
    IFC4X32.IfcQuantitySet = IfcQuantitySet;
    class IfcRectangleProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, XDim, YDim){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.XDim = XDim;
            this.YDim = YDim;
            this.type = 3615266464;
        }
    }
    IFC4X32.IfcRectangleProfileDef = IfcRectangleProfileDef;
    class IfcRegularTimeSeries extends IfcTimeSeries {
        constructor(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values){
            super(Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
            this.Name = Name;
            this.Description = Description;
            this.StartTime = StartTime;
            this.EndTime = EndTime;
            this.TimeSeriesDataType = TimeSeriesDataType;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.Unit = Unit;
            this.TimeStep = TimeStep;
            this.Values = Values;
            this.type = 3413951693;
        }
    }
    IFC4X32.IfcRegularTimeSeries = IfcRegularTimeSeries;
    class IfcReinforcementBarProperties extends IfcPreDefinedProperties {
        constructor(TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount){
            super();
            this.TotalCrossSectionArea = TotalCrossSectionArea;
            this.SteelGrade = SteelGrade;
            this.BarSurface = BarSurface;
            this.EffectiveDepth = EffectiveDepth;
            this.NominalBarDiameter = NominalBarDiameter;
            this.BarCount = BarCount;
            this.type = 1580146022;
        }
    }
    IFC4X32.IfcReinforcementBarProperties = IfcReinforcementBarProperties;
    class IfcRelationship extends IfcRoot {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 478536968;
        }
    }
    IFC4X32.IfcRelationship = IfcRelationship;
    class IfcResourceApprovalRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatedResourceObjects, RelatingApproval){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatedResourceObjects = RelatedResourceObjects;
            this.RelatingApproval = RelatingApproval;
            this.type = 2943643501;
        }
    }
    IFC4X32.IfcResourceApprovalRelationship = IfcResourceApprovalRelationship;
    class IfcResourceConstraintRelationship extends IfcResourceLevelRelationship {
        constructor(Name, Description, RelatingConstraint, RelatedResourceObjects){
            super(Name, Description);
            this.Name = Name;
            this.Description = Description;
            this.RelatingConstraint = RelatingConstraint;
            this.RelatedResourceObjects = RelatedResourceObjects;
            this.type = 1608871552;
        }
    }
    IFC4X32.IfcResourceConstraintRelationship = IfcResourceConstraintRelationship;
    class IfcResourceTime extends IfcSchedulingTime {
        constructor(Name, DataOrigin, UserDefinedDataOrigin, ScheduleWork, ScheduleUsage, ScheduleStart, ScheduleFinish, ScheduleContour, LevelingDelay, IsOverAllocated, StatusTime, ActualWork, ActualUsage, ActualStart, ActualFinish, RemainingWork, RemainingUsage, Completion){
            super(Name, DataOrigin, UserDefinedDataOrigin);
            this.Name = Name;
            this.DataOrigin = DataOrigin;
            this.UserDefinedDataOrigin = UserDefinedDataOrigin;
            this.ScheduleWork = ScheduleWork;
            this.ScheduleUsage = ScheduleUsage;
            this.ScheduleStart = ScheduleStart;
            this.ScheduleFinish = ScheduleFinish;
            this.ScheduleContour = ScheduleContour;
            this.LevelingDelay = LevelingDelay;
            this.IsOverAllocated = IsOverAllocated;
            this.StatusTime = StatusTime;
            this.ActualWork = ActualWork;
            this.ActualUsage = ActualUsage;
            this.ActualStart = ActualStart;
            this.ActualFinish = ActualFinish;
            this.RemainingWork = RemainingWork;
            this.RemainingUsage = RemainingUsage;
            this.Completion = Completion;
            this.type = 1042787934;
        }
    }
    IFC4X32.IfcResourceTime = IfcResourceTime;
    class IfcRoundedRectangleProfileDef extends IfcRectangleProfileDef {
        constructor(ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius){
            super(ProfileType, ProfileName, Position, XDim, YDim);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.XDim = XDim;
            this.YDim = YDim;
            this.RoundingRadius = RoundingRadius;
            this.type = 2778083089;
        }
    }
    IFC4X32.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;
    class IfcSectionProperties extends IfcPreDefinedProperties {
        constructor(SectionType, StartProfile, EndProfile){
            super();
            this.SectionType = SectionType;
            this.StartProfile = StartProfile;
            this.EndProfile = EndProfile;
            this.type = 2042790032;
        }
    }
    IFC4X32.IfcSectionProperties = IfcSectionProperties;
    class IfcSectionReinforcementProperties extends IfcPreDefinedProperties {
        constructor(LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions){
            super();
            this.LongitudinalStartPosition = LongitudinalStartPosition;
            this.LongitudinalEndPosition = LongitudinalEndPosition;
            this.TransversePosition = TransversePosition;
            this.ReinforcementRole = ReinforcementRole;
            this.SectionDefinition = SectionDefinition;
            this.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
            this.type = 4165799628;
        }
    }
    IFC4X32.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;
    class IfcSectionedSpine extends IfcGeometricRepresentationItem {
        constructor(SpineCurve, CrossSections, CrossSectionPositions){
            super();
            this.SpineCurve = SpineCurve;
            this.CrossSections = CrossSections;
            this.CrossSectionPositions = CrossSectionPositions;
            this.type = 1509187699;
        }
    }
    IFC4X32.IfcSectionedSpine = IfcSectionedSpine;
    class IfcSegment extends IfcGeometricRepresentationItem {
        constructor(Transition){
            super();
            this.Transition = Transition;
            this.type = 823603102;
        }
    }
    IFC4X32.IfcSegment = IfcSegment;
    class IfcShellBasedSurfaceModel extends IfcGeometricRepresentationItem {
        constructor(SbsmBoundary){
            super();
            this.SbsmBoundary = SbsmBoundary;
            this.type = 4124623270;
        }
    }
    IFC4X32.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;
    class IfcSimpleProperty extends IfcProperty {
        constructor(Name, Specification){
            super(Name, Specification);
            this.Name = Name;
            this.Specification = Specification;
            this.type = 3692461612;
        }
    }
    IFC4X32.IfcSimpleProperty = IfcSimpleProperty;
    class IfcSlippageConnectionCondition extends IfcStructuralConnectionCondition {
        constructor(Name, SlippageX, SlippageY, SlippageZ){
            super(Name);
            this.Name = Name;
            this.SlippageX = SlippageX;
            this.SlippageY = SlippageY;
            this.SlippageZ = SlippageZ;
            this.type = 2609359061;
        }
    }
    IFC4X32.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;
    class IfcSolidModel extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 723233188;
        }
    }
    IFC4X32.IfcSolidModel = IfcSolidModel;
    class IfcStructuralLoadLinearForce extends IfcStructuralLoadStatic {
        constructor(Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ){
            super(Name);
            this.Name = Name;
            this.LinearForceX = LinearForceX;
            this.LinearForceY = LinearForceY;
            this.LinearForceZ = LinearForceZ;
            this.LinearMomentX = LinearMomentX;
            this.LinearMomentY = LinearMomentY;
            this.LinearMomentZ = LinearMomentZ;
            this.type = 1595516126;
        }
    }
    IFC4X32.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;
    class IfcStructuralLoadPlanarForce extends IfcStructuralLoadStatic {
        constructor(Name, PlanarForceX, PlanarForceY, PlanarForceZ){
            super(Name);
            this.Name = Name;
            this.PlanarForceX = PlanarForceX;
            this.PlanarForceY = PlanarForceY;
            this.PlanarForceZ = PlanarForceZ;
            this.type = 2668620305;
        }
    }
    IFC4X32.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;
    class IfcStructuralLoadSingleDisplacement extends IfcStructuralLoadStatic {
        constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ){
            super(Name);
            this.Name = Name;
            this.DisplacementX = DisplacementX;
            this.DisplacementY = DisplacementY;
            this.DisplacementZ = DisplacementZ;
            this.RotationalDisplacementRX = RotationalDisplacementRX;
            this.RotationalDisplacementRY = RotationalDisplacementRY;
            this.RotationalDisplacementRZ = RotationalDisplacementRZ;
            this.type = 2473145415;
        }
    }
    IFC4X32.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;
    class IfcStructuralLoadSingleDisplacementDistortion extends IfcStructuralLoadSingleDisplacement {
        constructor(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion){
            super(Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
            this.Name = Name;
            this.DisplacementX = DisplacementX;
            this.DisplacementY = DisplacementY;
            this.DisplacementZ = DisplacementZ;
            this.RotationalDisplacementRX = RotationalDisplacementRX;
            this.RotationalDisplacementRY = RotationalDisplacementRY;
            this.RotationalDisplacementRZ = RotationalDisplacementRZ;
            this.Distortion = Distortion;
            this.type = 1973038258;
        }
    }
    IFC4X32.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;
    class IfcStructuralLoadSingleForce extends IfcStructuralLoadStatic {
        constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ){
            super(Name);
            this.Name = Name;
            this.ForceX = ForceX;
            this.ForceY = ForceY;
            this.ForceZ = ForceZ;
            this.MomentX = MomentX;
            this.MomentY = MomentY;
            this.MomentZ = MomentZ;
            this.type = 1597423693;
        }
    }
    IFC4X32.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;
    class IfcStructuralLoadSingleForceWarping extends IfcStructuralLoadSingleForce {
        constructor(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment){
            super(Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
            this.Name = Name;
            this.ForceX = ForceX;
            this.ForceY = ForceY;
            this.ForceZ = ForceZ;
            this.MomentX = MomentX;
            this.MomentY = MomentY;
            this.MomentZ = MomentZ;
            this.WarpingMoment = WarpingMoment;
            this.type = 1190533807;
        }
    }
    IFC4X32.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;
    class IfcSubedge extends IfcEdge {
        constructor(EdgeStart, EdgeEnd, ParentEdge){
            super(EdgeStart, EdgeEnd);
            this.EdgeStart = EdgeStart;
            this.EdgeEnd = EdgeEnd;
            this.ParentEdge = ParentEdge;
            this.type = 2233826070;
        }
    }
    IFC4X32.IfcSubedge = IfcSubedge;
    class IfcSurface extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 2513912981;
        }
    }
    IFC4X32.IfcSurface = IfcSurface;
    class IfcSurfaceStyleRendering extends IfcSurfaceStyleShading {
        constructor(SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod){
            super(SurfaceColour, Transparency);
            this.SurfaceColour = SurfaceColour;
            this.Transparency = Transparency;
            this.DiffuseColour = DiffuseColour;
            this.TransmissionColour = TransmissionColour;
            this.DiffuseTransmissionColour = DiffuseTransmissionColour;
            this.ReflectionColour = ReflectionColour;
            this.SpecularColour = SpecularColour;
            this.SpecularHighlight = SpecularHighlight;
            this.ReflectanceMethod = ReflectanceMethod;
            this.type = 1878645084;
        }
    }
    IFC4X32.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;
    class IfcSweptAreaSolid extends IfcSolidModel {
        constructor(SweptArea, Position){
            super();
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.type = 2247615214;
        }
    }
    IFC4X32.IfcSweptAreaSolid = IfcSweptAreaSolid;
    class IfcSweptDiskSolid extends IfcSolidModel {
        constructor(Directrix, Radius, InnerRadius, StartParam, EndParam){
            super();
            this.Directrix = Directrix;
            this.Radius = Radius;
            this.InnerRadius = InnerRadius;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.type = 1260650574;
        }
    }
    IFC4X32.IfcSweptDiskSolid = IfcSweptDiskSolid;
    class IfcSweptDiskSolidPolygonal extends IfcSweptDiskSolid {
        constructor(Directrix, Radius, InnerRadius, StartParam, EndParam, FilletRadius){
            super(Directrix, Radius, InnerRadius, StartParam, EndParam);
            this.Directrix = Directrix;
            this.Radius = Radius;
            this.InnerRadius = InnerRadius;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.FilletRadius = FilletRadius;
            this.type = 1096409881;
        }
    }
    IFC4X32.IfcSweptDiskSolidPolygonal = IfcSweptDiskSolidPolygonal;
    class IfcSweptSurface extends IfcSurface {
        constructor(SweptCurve, Position){
            super();
            this.SweptCurve = SweptCurve;
            this.Position = Position;
            this.type = 230924584;
        }
    }
    IFC4X32.IfcSweptSurface = IfcSweptSurface;
    class IfcTShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.FlangeWidth = FlangeWidth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.FlangeEdgeRadius = FlangeEdgeRadius;
            this.WebEdgeRadius = WebEdgeRadius;
            this.WebSlope = WebSlope;
            this.FlangeSlope = FlangeSlope;
            this.type = 3071757647;
        }
    }
    IFC4X32.IfcTShapeProfileDef = IfcTShapeProfileDef;
    class IfcTessellatedItem extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 901063453;
        }
    }
    IFC4X32.IfcTessellatedItem = IfcTessellatedItem;
    class IfcTextLiteral extends IfcGeometricRepresentationItem {
        constructor(Literal, Placement, Path){
            super();
            this.Literal = Literal;
            this.Placement = Placement;
            this.Path = Path;
            this.type = 4282788508;
        }
    }
    IFC4X32.IfcTextLiteral = IfcTextLiteral;
    class IfcTextLiteralWithExtent extends IfcTextLiteral {
        constructor(Literal, Placement, Path, Extent, BoxAlignment){
            super(Literal, Placement, Path);
            this.Literal = Literal;
            this.Placement = Placement;
            this.Path = Path;
            this.Extent = Extent;
            this.BoxAlignment = BoxAlignment;
            this.type = 3124975700;
        }
    }
    IFC4X32.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;
    class IfcTextStyleFontModel extends IfcPreDefinedTextFont {
        constructor(Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize){
            super(Name);
            this.Name = Name;
            this.FontFamily = FontFamily;
            this.FontStyle = FontStyle;
            this.FontVariant = FontVariant;
            this.FontWeight = FontWeight;
            this.FontSize = FontSize;
            this.type = 1983826977;
        }
    }
    IFC4X32.IfcTextStyleFontModel = IfcTextStyleFontModel;
    class IfcTrapeziumProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.BottomXDim = BottomXDim;
            this.TopXDim = TopXDim;
            this.YDim = YDim;
            this.TopXOffset = TopXOffset;
            this.type = 2715220739;
        }
    }
    IFC4X32.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;
    class IfcTypeObject extends IfcObjectDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.type = 1628702193;
        }
    }
    IFC4X32.IfcTypeObject = IfcTypeObject;
    class IfcTypeProcess extends IfcTypeObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ProcessType = ProcessType;
            this.type = 3736923433;
        }
    }
    IFC4X32.IfcTypeProcess = IfcTypeProcess;
    class IfcTypeProduct extends IfcTypeObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.type = 2347495698;
        }
    }
    IFC4X32.IfcTypeProduct = IfcTypeProduct;
    class IfcTypeResource extends IfcTypeObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.type = 3698973494;
        }
    }
    IFC4X32.IfcTypeResource = IfcTypeResource;
    class IfcUShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.FlangeWidth = FlangeWidth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.EdgeRadius = EdgeRadius;
            this.FlangeSlope = FlangeSlope;
            this.type = 427810014;
        }
    }
    IFC4X32.IfcUShapeProfileDef = IfcUShapeProfileDef;
    class IfcVector extends IfcGeometricRepresentationItem {
        constructor(Orientation, Magnitude){
            super();
            this.Orientation = Orientation;
            this.Magnitude = Magnitude;
            this.type = 1417489154;
        }
    }
    IFC4X32.IfcVector = IfcVector;
    class IfcVertexLoop extends IfcLoop {
        constructor(LoopVertex){
            super();
            this.LoopVertex = LoopVertex;
            this.type = 2759199220;
        }
    }
    IFC4X32.IfcVertexLoop = IfcVertexLoop;
    class IfcZShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.FlangeWidth = FlangeWidth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.EdgeRadius = EdgeRadius;
            this.type = 2543172580;
        }
    }
    IFC4X32.IfcZShapeProfileDef = IfcZShapeProfileDef;
    class IfcAdvancedFace extends IfcFaceSurface {
        constructor(Bounds, FaceSurface, SameSense){
            super(Bounds, FaceSurface, SameSense);
            this.Bounds = Bounds;
            this.FaceSurface = FaceSurface;
            this.SameSense = SameSense;
            this.type = 3406155212;
        }
    }
    IFC4X32.IfcAdvancedFace = IfcAdvancedFace;
    class IfcAnnotationFillArea extends IfcGeometricRepresentationItem {
        constructor(OuterBoundary, InnerBoundaries){
            super();
            this.OuterBoundary = OuterBoundary;
            this.InnerBoundaries = InnerBoundaries;
            this.type = 669184980;
        }
    }
    IFC4X32.IfcAnnotationFillArea = IfcAnnotationFillArea;
    class IfcAsymmetricIShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, BottomFlangeWidth, OverallDepth, WebThickness, BottomFlangeThickness, BottomFlangeFilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, BottomFlangeEdgeRadius, BottomFlangeSlope, TopFlangeEdgeRadius, TopFlangeSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.BottomFlangeWidth = BottomFlangeWidth;
            this.OverallDepth = OverallDepth;
            this.WebThickness = WebThickness;
            this.BottomFlangeThickness = BottomFlangeThickness;
            this.BottomFlangeFilletRadius = BottomFlangeFilletRadius;
            this.TopFlangeWidth = TopFlangeWidth;
            this.TopFlangeThickness = TopFlangeThickness;
            this.TopFlangeFilletRadius = TopFlangeFilletRadius;
            this.BottomFlangeEdgeRadius = BottomFlangeEdgeRadius;
            this.BottomFlangeSlope = BottomFlangeSlope;
            this.TopFlangeEdgeRadius = TopFlangeEdgeRadius;
            this.TopFlangeSlope = TopFlangeSlope;
            this.type = 3207858831;
        }
    }
    IFC4X32.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;
    class IfcAxis1Placement extends IfcPlacement {
        constructor(Location, Axis){
            super(Location);
            this.Location = Location;
            this.Axis = Axis;
            this.type = 4261334040;
        }
    }
    IFC4X32.IfcAxis1Placement = IfcAxis1Placement;
    class IfcAxis2Placement2D extends IfcPlacement {
        constructor(Location, RefDirection){
            super(Location);
            this.Location = Location;
            this.RefDirection = RefDirection;
            this.type = 3125803723;
        }
    }
    IFC4X32.IfcAxis2Placement2D = IfcAxis2Placement2D;
    class IfcAxis2Placement3D extends IfcPlacement {
        constructor(Location, Axis, RefDirection){
            super(Location);
            this.Location = Location;
            this.Axis = Axis;
            this.RefDirection = RefDirection;
            this.type = 2740243338;
        }
    }
    IFC4X32.IfcAxis2Placement3D = IfcAxis2Placement3D;
    class IfcAxis2PlacementLinear extends IfcPlacement {
        constructor(Location, Axis, RefDirection){
            super(Location);
            this.Location = Location;
            this.Axis = Axis;
            this.RefDirection = RefDirection;
            this.type = 3425423356;
        }
    }
    IFC4X32.IfcAxis2PlacementLinear = IfcAxis2PlacementLinear;
    class IfcBooleanResult extends IfcGeometricRepresentationItem {
        constructor(Operator, FirstOperand, SecondOperand){
            super();
            this.Operator = Operator;
            this.FirstOperand = FirstOperand;
            this.SecondOperand = SecondOperand;
            this.type = 2736907675;
        }
    }
    IFC4X32.IfcBooleanResult = IfcBooleanResult;
    class IfcBoundedSurface extends IfcSurface {
        constructor(){
            super();
            this.type = 4182860854;
        }
    }
    IFC4X32.IfcBoundedSurface = IfcBoundedSurface;
    class IfcBoundingBox extends IfcGeometricRepresentationItem {
        constructor(Corner, XDim, YDim, ZDim){
            super();
            this.Corner = Corner;
            this.XDim = XDim;
            this.YDim = YDim;
            this.ZDim = ZDim;
            this.type = 2581212453;
        }
    }
    IFC4X32.IfcBoundingBox = IfcBoundingBox;
    class IfcBoxedHalfSpace extends IfcHalfSpaceSolid {
        constructor(BaseSurface, AgreementFlag, Enclosure){
            super(BaseSurface, AgreementFlag);
            this.BaseSurface = BaseSurface;
            this.AgreementFlag = AgreementFlag;
            this.Enclosure = Enclosure;
            this.type = 2713105998;
        }
    }
    IFC4X32.IfcBoxedHalfSpace = IfcBoxedHalfSpace;
    class IfcCShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.Width = Width;
            this.WallThickness = WallThickness;
            this.Girth = Girth;
            this.InternalFilletRadius = InternalFilletRadius;
            this.type = 2898889636;
        }
    }
    IFC4X32.IfcCShapeProfileDef = IfcCShapeProfileDef;
    class IfcCartesianPoint extends IfcPoint {
        constructor(Coordinates){
            super();
            this.Coordinates = Coordinates;
            this.type = 1123145078;
        }
    }
    IFC4X32.IfcCartesianPoint = IfcCartesianPoint;
    class IfcCartesianPointList extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 574549367;
        }
    }
    IFC4X32.IfcCartesianPointList = IfcCartesianPointList;
    class IfcCartesianPointList2D extends IfcCartesianPointList {
        constructor(CoordList, TagList){
            super();
            this.CoordList = CoordList;
            this.TagList = TagList;
            this.type = 1675464909;
        }
    }
    IFC4X32.IfcCartesianPointList2D = IfcCartesianPointList2D;
    class IfcCartesianPointList3D extends IfcCartesianPointList {
        constructor(CoordList, TagList){
            super();
            this.CoordList = CoordList;
            this.TagList = TagList;
            this.type = 2059837836;
        }
    }
    IFC4X32.IfcCartesianPointList3D = IfcCartesianPointList3D;
    class IfcCartesianTransformationOperator extends IfcGeometricRepresentationItem {
        constructor(Axis1, Axis2, LocalOrigin, Scale){
            super();
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.type = 59481748;
        }
    }
    IFC4X32.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;
    class IfcCartesianTransformationOperator2D extends IfcCartesianTransformationOperator {
        constructor(Axis1, Axis2, LocalOrigin, Scale){
            super(Axis1, Axis2, LocalOrigin, Scale);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.type = 3749851601;
        }
    }
    IFC4X32.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;
    class IfcCartesianTransformationOperator2DnonUniform extends IfcCartesianTransformationOperator2D {
        constructor(Axis1, Axis2, LocalOrigin, Scale, Scale2){
            super(Axis1, Axis2, LocalOrigin, Scale);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.Scale2 = Scale2;
            this.type = 3486308946;
        }
    }
    IFC4X32.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;
    class IfcCartesianTransformationOperator3D extends IfcCartesianTransformationOperator {
        constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3){
            super(Axis1, Axis2, LocalOrigin, Scale);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.Axis3 = Axis3;
            this.type = 3331915920;
        }
    }
    IFC4X32.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;
    class IfcCartesianTransformationOperator3DnonUniform extends IfcCartesianTransformationOperator3D {
        constructor(Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3){
            super(Axis1, Axis2, LocalOrigin, Scale, Axis3);
            this.Axis1 = Axis1;
            this.Axis2 = Axis2;
            this.LocalOrigin = LocalOrigin;
            this.Scale = Scale;
            this.Axis3 = Axis3;
            this.Scale2 = Scale2;
            this.Scale3 = Scale3;
            this.type = 1416205885;
        }
    }
    IFC4X32.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;
    class IfcCircleProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Radius){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Radius = Radius;
            this.type = 1383045692;
        }
    }
    IFC4X32.IfcCircleProfileDef = IfcCircleProfileDef;
    class IfcClosedShell extends IfcConnectedFaceSet {
        constructor(CfsFaces){
            super(CfsFaces);
            this.CfsFaces = CfsFaces;
            this.type = 2205249479;
        }
    }
    IFC4X32.IfcClosedShell = IfcClosedShell;
    class IfcColourRgb extends IfcColourSpecification {
        constructor(Name, Red, Green, Blue){
            super(Name);
            this.Name = Name;
            this.Red = Red;
            this.Green = Green;
            this.Blue = Blue;
            this.type = 776857604;
        }
    }
    IFC4X32.IfcColourRgb = IfcColourRgb;
    class IfcComplexProperty extends IfcProperty {
        constructor(Name, Specification, UsageName, HasProperties){
            super(Name, Specification);
            this.Name = Name;
            this.Specification = Specification;
            this.UsageName = UsageName;
            this.HasProperties = HasProperties;
            this.type = 2542286263;
        }
    }
    IFC4X32.IfcComplexProperty = IfcComplexProperty;
    class IfcCompositeCurveSegment extends IfcSegment {
        constructor(Transition, SameSense, ParentCurve){
            super(Transition);
            this.Transition = Transition;
            this.SameSense = SameSense;
            this.ParentCurve = ParentCurve;
            this.type = 2485617015;
        }
    }
    IFC4X32.IfcCompositeCurveSegment = IfcCompositeCurveSegment;
    class IfcConstructionResourceType extends IfcTypeResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.type = 2574617495;
        }
    }
    IFC4X32.IfcConstructionResourceType = IfcConstructionResourceType;
    class IfcContext extends IfcObjectDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.Phase = Phase;
            this.RepresentationContexts = RepresentationContexts;
            this.UnitsInContext = UnitsInContext;
            this.type = 3419103109;
        }
    }
    IFC4X32.IfcContext = IfcContext;
    class IfcCrewResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 1815067380;
        }
    }
    IFC4X32.IfcCrewResourceType = IfcCrewResourceType;
    class IfcCsgPrimitive3D extends IfcGeometricRepresentationItem {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2506170314;
        }
    }
    IFC4X32.IfcCsgPrimitive3D = IfcCsgPrimitive3D;
    class IfcCsgSolid extends IfcSolidModel {
        constructor(TreeRootExpression){
            super();
            this.TreeRootExpression = TreeRootExpression;
            this.type = 2147822146;
        }
    }
    IFC4X32.IfcCsgSolid = IfcCsgSolid;
    class IfcCurve extends IfcGeometricRepresentationItem {
        constructor(){
            super();
            this.type = 2601014836;
        }
    }
    IFC4X32.IfcCurve = IfcCurve;
    class IfcCurveBoundedPlane extends IfcBoundedSurface {
        constructor(BasisSurface, OuterBoundary, InnerBoundaries){
            super();
            this.BasisSurface = BasisSurface;
            this.OuterBoundary = OuterBoundary;
            this.InnerBoundaries = InnerBoundaries;
            this.type = 2827736869;
        }
    }
    IFC4X32.IfcCurveBoundedPlane = IfcCurveBoundedPlane;
    class IfcCurveBoundedSurface extends IfcBoundedSurface {
        constructor(BasisSurface, Boundaries, ImplicitOuter){
            super();
            this.BasisSurface = BasisSurface;
            this.Boundaries = Boundaries;
            this.ImplicitOuter = ImplicitOuter;
            this.type = 2629017746;
        }
    }
    IFC4X32.IfcCurveBoundedSurface = IfcCurveBoundedSurface;
    class IfcCurveSegment extends IfcSegment {
        constructor(Transition, Placement, SegmentStart, SegmentLength, ParentCurve){
            super(Transition);
            this.Transition = Transition;
            this.Placement = Placement;
            this.SegmentStart = SegmentStart;
            this.SegmentLength = SegmentLength;
            this.ParentCurve = ParentCurve;
            this.type = 4212018352;
        }
    }
    IFC4X32.IfcCurveSegment = IfcCurveSegment;
    class IfcDirection extends IfcGeometricRepresentationItem {
        constructor(DirectionRatios){
            super();
            this.DirectionRatios = DirectionRatios;
            this.type = 32440307;
        }
    }
    IFC4X32.IfcDirection = IfcDirection;
    class IfcDirectrixCurveSweptAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, Directrix, StartParam, EndParam){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Directrix = Directrix;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.type = 593015953;
        }
    }
    IFC4X32.IfcDirectrixCurveSweptAreaSolid = IfcDirectrixCurveSweptAreaSolid;
    class IfcEdgeLoop extends IfcLoop {
        constructor(EdgeList){
            super();
            this.EdgeList = EdgeList;
            this.type = 1472233963;
        }
    }
    IFC4X32.IfcEdgeLoop = IfcEdgeLoop;
    class IfcElementQuantity extends IfcQuantitySet {
        constructor(GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.MethodOfMeasurement = MethodOfMeasurement;
            this.Quantities = Quantities;
            this.type = 1883228015;
        }
    }
    IFC4X32.IfcElementQuantity = IfcElementQuantity;
    class IfcElementType extends IfcTypeProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 339256511;
        }
    }
    IFC4X32.IfcElementType = IfcElementType;
    class IfcElementarySurface extends IfcSurface {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2777663545;
        }
    }
    IFC4X32.IfcElementarySurface = IfcElementarySurface;
    class IfcEllipseProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.SemiAxis1 = SemiAxis1;
            this.SemiAxis2 = SemiAxis2;
            this.type = 2835456948;
        }
    }
    IFC4X32.IfcEllipseProfileDef = IfcEllipseProfileDef;
    class IfcEventType extends IfcTypeProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, EventTriggerType, UserDefinedEventTriggerType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ProcessType = ProcessType;
            this.PredefinedType = PredefinedType;
            this.EventTriggerType = EventTriggerType;
            this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
            this.type = 4024345920;
        }
    }
    IFC4X32.IfcEventType = IfcEventType;
    class IfcExtrudedAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, ExtrudedDirection, Depth){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.ExtrudedDirection = ExtrudedDirection;
            this.Depth = Depth;
            this.type = 477187591;
        }
    }
    IFC4X32.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;
    class IfcExtrudedAreaSolidTapered extends IfcExtrudedAreaSolid {
        constructor(SweptArea, Position, ExtrudedDirection, Depth, EndSweptArea){
            super(SweptArea, Position, ExtrudedDirection, Depth);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.ExtrudedDirection = ExtrudedDirection;
            this.Depth = Depth;
            this.EndSweptArea = EndSweptArea;
            this.type = 2804161546;
        }
    }
    IFC4X32.IfcExtrudedAreaSolidTapered = IfcExtrudedAreaSolidTapered;
    class IfcFaceBasedSurfaceModel extends IfcGeometricRepresentationItem {
        constructor(FbsmFaces){
            super();
            this.FbsmFaces = FbsmFaces;
            this.type = 2047409740;
        }
    }
    IFC4X32.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;
    class IfcFillAreaStyleHatching extends IfcGeometricRepresentationItem {
        constructor(HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle){
            super();
            this.HatchLineAppearance = HatchLineAppearance;
            this.StartOfNextHatchLine = StartOfNextHatchLine;
            this.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
            this.PatternStart = PatternStart;
            this.HatchLineAngle = HatchLineAngle;
            this.type = 374418227;
        }
    }
    IFC4X32.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;
    class IfcFillAreaStyleTiles extends IfcGeometricRepresentationItem {
        constructor(TilingPattern, Tiles, TilingScale){
            super();
            this.TilingPattern = TilingPattern;
            this.Tiles = Tiles;
            this.TilingScale = TilingScale;
            this.type = 315944413;
        }
    }
    IFC4X32.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;
    class IfcFixedReferenceSweptAreaSolid extends IfcDirectrixCurveSweptAreaSolid {
        constructor(SweptArea, Position, Directrix, StartParam, EndParam, FixedReference){
            super(SweptArea, Position, Directrix, StartParam, EndParam);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Directrix = Directrix;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.FixedReference = FixedReference;
            this.type = 2652556860;
        }
    }
    IFC4X32.IfcFixedReferenceSweptAreaSolid = IfcFixedReferenceSweptAreaSolid;
    class IfcFurnishingElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 4238390223;
        }
    }
    IFC4X32.IfcFurnishingElementType = IfcFurnishingElementType;
    class IfcFurnitureType extends IfcFurnishingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.AssemblyPlace = AssemblyPlace;
            this.PredefinedType = PredefinedType;
            this.type = 1268542332;
        }
    }
    IFC4X32.IfcFurnitureType = IfcFurnitureType;
    class IfcGeographicElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4095422895;
        }
    }
    IFC4X32.IfcGeographicElementType = IfcGeographicElementType;
    class IfcGeometricCurveSet extends IfcGeometricSet {
        constructor(Elements){
            super(Elements);
            this.Elements = Elements;
            this.type = 987898635;
        }
    }
    IFC4X32.IfcGeometricCurveSet = IfcGeometricCurveSet;
    class IfcIShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, FlangeSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.OverallWidth = OverallWidth;
            this.OverallDepth = OverallDepth;
            this.WebThickness = WebThickness;
            this.FlangeThickness = FlangeThickness;
            this.FilletRadius = FilletRadius;
            this.FlangeEdgeRadius = FlangeEdgeRadius;
            this.FlangeSlope = FlangeSlope;
            this.type = 1484403080;
        }
    }
    IFC4X32.IfcIShapeProfileDef = IfcIShapeProfileDef;
    class IfcIndexedPolygonalFace extends IfcTessellatedItem {
        constructor(CoordIndex){
            super();
            this.CoordIndex = CoordIndex;
            this.type = 178912537;
        }
    }
    IFC4X32.IfcIndexedPolygonalFace = IfcIndexedPolygonalFace;
    class IfcIndexedPolygonalFaceWithVoids extends IfcIndexedPolygonalFace {
        constructor(CoordIndex, InnerCoordIndices){
            super(CoordIndex);
            this.CoordIndex = CoordIndex;
            this.InnerCoordIndices = InnerCoordIndices;
            this.type = 2294589976;
        }
    }
    IFC4X32.IfcIndexedPolygonalFaceWithVoids = IfcIndexedPolygonalFaceWithVoids;
    class IfcIndexedPolygonalTextureMap extends IfcIndexedTextureMap {
        constructor(Maps, MappedTo, TexCoords, TexCoordIndices){
            super(Maps, MappedTo, TexCoords);
            this.Maps = Maps;
            this.MappedTo = MappedTo;
            this.TexCoords = TexCoords;
            this.TexCoordIndices = TexCoordIndices;
            this.type = 3465909080;
        }
    }
    IFC4X32.IfcIndexedPolygonalTextureMap = IfcIndexedPolygonalTextureMap;
    class IfcLShapeProfileDef extends IfcParameterizedProfileDef {
        constructor(ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope){
            super(ProfileType, ProfileName, Position);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Depth = Depth;
            this.Width = Width;
            this.Thickness = Thickness;
            this.FilletRadius = FilletRadius;
            this.EdgeRadius = EdgeRadius;
            this.LegSlope = LegSlope;
            this.type = 572779678;
        }
    }
    IFC4X32.IfcLShapeProfileDef = IfcLShapeProfileDef;
    class IfcLaborResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 428585644;
        }
    }
    IFC4X32.IfcLaborResourceType = IfcLaborResourceType;
    class IfcLine extends IfcCurve {
        constructor(Pnt, Dir){
            super();
            this.Pnt = Pnt;
            this.Dir = Dir;
            this.type = 1281925730;
        }
    }
    IFC4X32.IfcLine = IfcLine;
    class IfcManifoldSolidBrep extends IfcSolidModel {
        constructor(Outer){
            super();
            this.Outer = Outer;
            this.type = 1425443689;
        }
    }
    IFC4X32.IfcManifoldSolidBrep = IfcManifoldSolidBrep;
    class IfcObject extends IfcObjectDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 3888040117;
        }
    }
    IFC4X32.IfcObject = IfcObject;
    class IfcOffsetCurve extends IfcCurve {
        constructor(BasisCurve){
            super();
            this.BasisCurve = BasisCurve;
            this.type = 590820931;
        }
    }
    IFC4X32.IfcOffsetCurve = IfcOffsetCurve;
    class IfcOffsetCurve2D extends IfcOffsetCurve {
        constructor(BasisCurve, Distance, SelfIntersect){
            super(BasisCurve);
            this.BasisCurve = BasisCurve;
            this.Distance = Distance;
            this.SelfIntersect = SelfIntersect;
            this.type = 3388369263;
        }
    }
    IFC4X32.IfcOffsetCurve2D = IfcOffsetCurve2D;
    class IfcOffsetCurve3D extends IfcOffsetCurve {
        constructor(BasisCurve, Distance, SelfIntersect, RefDirection){
            super(BasisCurve);
            this.BasisCurve = BasisCurve;
            this.Distance = Distance;
            this.SelfIntersect = SelfIntersect;
            this.RefDirection = RefDirection;
            this.type = 3505215534;
        }
    }
    IFC4X32.IfcOffsetCurve3D = IfcOffsetCurve3D;
    class IfcOffsetCurveByDistances extends IfcOffsetCurve {
        constructor(BasisCurve, OffsetValues, Tag){
            super(BasisCurve);
            this.BasisCurve = BasisCurve;
            this.OffsetValues = OffsetValues;
            this.Tag = Tag;
            this.type = 2485787929;
        }
    }
    IFC4X32.IfcOffsetCurveByDistances = IfcOffsetCurveByDistances;
    class IfcPcurve extends IfcCurve {
        constructor(BasisSurface, ReferenceCurve){
            super();
            this.BasisSurface = BasisSurface;
            this.ReferenceCurve = ReferenceCurve;
            this.type = 1682466193;
        }
    }
    IFC4X32.IfcPcurve = IfcPcurve;
    class IfcPlanarBox extends IfcPlanarExtent {
        constructor(SizeInX, SizeInY, Placement){
            super(SizeInX, SizeInY);
            this.SizeInX = SizeInX;
            this.SizeInY = SizeInY;
            this.Placement = Placement;
            this.type = 603570806;
        }
    }
    IFC4X32.IfcPlanarBox = IfcPlanarBox;
    class IfcPlane extends IfcElementarySurface {
        constructor(Position){
            super(Position);
            this.Position = Position;
            this.type = 220341763;
        }
    }
    IFC4X32.IfcPlane = IfcPlane;
    class IfcPolynomialCurve extends IfcCurve {
        constructor(Position, CoefficientsX, CoefficientsY, CoefficientsZ){
            super();
            this.Position = Position;
            this.CoefficientsX = CoefficientsX;
            this.CoefficientsY = CoefficientsY;
            this.CoefficientsZ = CoefficientsZ;
            this.type = 3381221214;
        }
    }
    IFC4X32.IfcPolynomialCurve = IfcPolynomialCurve;
    class IfcPreDefinedColour extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 759155922;
        }
    }
    IFC4X32.IfcPreDefinedColour = IfcPreDefinedColour;
    class IfcPreDefinedCurveFont extends IfcPreDefinedItem {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 2559016684;
        }
    }
    IFC4X32.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;
    class IfcPreDefinedPropertySet extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 3967405729;
        }
    }
    IFC4X32.IfcPreDefinedPropertySet = IfcPreDefinedPropertySet;
    class IfcProcedureType extends IfcTypeProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ProcessType = ProcessType;
            this.PredefinedType = PredefinedType;
            this.type = 569719735;
        }
    }
    IFC4X32.IfcProcedureType = IfcProcedureType;
    class IfcProcess extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.type = 2945172077;
        }
    }
    IFC4X32.IfcProcess = IfcProcess;
    class IfcProduct extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 4208778838;
        }
    }
    IFC4X32.IfcProduct = IfcProduct;
    class IfcProject extends IfcContext {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.Phase = Phase;
            this.RepresentationContexts = RepresentationContexts;
            this.UnitsInContext = UnitsInContext;
            this.type = 103090709;
        }
    }
    IFC4X32.IfcProject = IfcProject;
    class IfcProjectLibrary extends IfcContext {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.Phase = Phase;
            this.RepresentationContexts = RepresentationContexts;
            this.UnitsInContext = UnitsInContext;
            this.type = 653396225;
        }
    }
    IFC4X32.IfcProjectLibrary = IfcProjectLibrary;
    class IfcPropertyBoundedValue extends IfcSimpleProperty {
        constructor(Name, Specification, UpperBoundValue, LowerBoundValue, Unit, SetPointValue){
            super(Name, Specification);
            this.Name = Name;
            this.Specification = Specification;
            this.UpperBoundValue = UpperBoundValue;
            this.LowerBoundValue = LowerBoundValue;
            this.Unit = Unit;
            this.SetPointValue = SetPointValue;
            this.type = 871118103;
        }
    }
    IFC4X32.IfcPropertyBoundedValue = IfcPropertyBoundedValue;
    class IfcPropertyEnumeratedValue extends IfcSimpleProperty {
        constructor(Name, Specification, EnumerationValues, EnumerationReference){
            super(Name, Specification);
            this.Name = Name;
            this.Specification = Specification;
            this.EnumerationValues = EnumerationValues;
            this.EnumerationReference = EnumerationReference;
            this.type = 4166981789;
        }
    }
    IFC4X32.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;
    class IfcPropertyListValue extends IfcSimpleProperty {
        constructor(Name, Specification, ListValues, Unit){
            super(Name, Specification);
            this.Name = Name;
            this.Specification = Specification;
            this.ListValues = ListValues;
            this.Unit = Unit;
            this.type = 2752243245;
        }
    }
    IFC4X32.IfcPropertyListValue = IfcPropertyListValue;
    class IfcPropertyReferenceValue extends IfcSimpleProperty {
        constructor(Name, Specification, UsageName, PropertyReference){
            super(Name, Specification);
            this.Name = Name;
            this.Specification = Specification;
            this.UsageName = UsageName;
            this.PropertyReference = PropertyReference;
            this.type = 941946838;
        }
    }
    IFC4X32.IfcPropertyReferenceValue = IfcPropertyReferenceValue;
    class IfcPropertySet extends IfcPropertySetDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, HasProperties){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.HasProperties = HasProperties;
            this.type = 1451395588;
        }
    }
    IFC4X32.IfcPropertySet = IfcPropertySet;
    class IfcPropertySetTemplate extends IfcPropertyTemplateDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description, TemplateType, ApplicableEntity, HasPropertyTemplates){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.TemplateType = TemplateType;
            this.ApplicableEntity = ApplicableEntity;
            this.HasPropertyTemplates = HasPropertyTemplates;
            this.type = 492091185;
        }
    }
    IFC4X32.IfcPropertySetTemplate = IfcPropertySetTemplate;
    class IfcPropertySingleValue extends IfcSimpleProperty {
        constructor(Name, Specification, NominalValue, Unit){
            super(Name, Specification);
            this.Name = Name;
            this.Specification = Specification;
            this.NominalValue = NominalValue;
            this.Unit = Unit;
            this.type = 3650150729;
        }
    }
    IFC4X32.IfcPropertySingleValue = IfcPropertySingleValue;
    class IfcPropertyTableValue extends IfcSimpleProperty {
        constructor(Name, Specification, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit, CurveInterpolation){
            super(Name, Specification);
            this.Name = Name;
            this.Specification = Specification;
            this.DefiningValues = DefiningValues;
            this.DefinedValues = DefinedValues;
            this.Expression = Expression;
            this.DefiningUnit = DefiningUnit;
            this.DefinedUnit = DefinedUnit;
            this.CurveInterpolation = CurveInterpolation;
            this.type = 110355661;
        }
    }
    IFC4X32.IfcPropertyTableValue = IfcPropertyTableValue;
    class IfcPropertyTemplate extends IfcPropertyTemplateDefinition {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 3521284610;
        }
    }
    IFC4X32.IfcPropertyTemplate = IfcPropertyTemplate;
    class IfcRectangleHollowProfileDef extends IfcRectangleProfileDef {
        constructor(ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius){
            super(ProfileType, ProfileName, Position, XDim, YDim);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.XDim = XDim;
            this.YDim = YDim;
            this.WallThickness = WallThickness;
            this.InnerFilletRadius = InnerFilletRadius;
            this.OuterFilletRadius = OuterFilletRadius;
            this.type = 2770003689;
        }
    }
    IFC4X32.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;
    class IfcRectangularPyramid extends IfcCsgPrimitive3D {
        constructor(Position, XLength, YLength, Height){
            super(Position);
            this.Position = Position;
            this.XLength = XLength;
            this.YLength = YLength;
            this.Height = Height;
            this.type = 2798486643;
        }
    }
    IFC4X32.IfcRectangularPyramid = IfcRectangularPyramid;
    class IfcRectangularTrimmedSurface extends IfcBoundedSurface {
        constructor(BasisSurface, U1, V1, U2, V2, Usense, Vsense){
            super();
            this.BasisSurface = BasisSurface;
            this.U1 = U1;
            this.V1 = V1;
            this.U2 = U2;
            this.V2 = V2;
            this.Usense = Usense;
            this.Vsense = Vsense;
            this.type = 3454111270;
        }
    }
    IFC4X32.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;
    class IfcReinforcementDefinitionProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.DefinitionType = DefinitionType;
            this.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
            this.type = 3765753017;
        }
    }
    IFC4X32.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;
    class IfcRelAssigns extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.type = 3939117080;
        }
    }
    IFC4X32.IfcRelAssigns = IfcRelAssigns;
    class IfcRelAssignsToActor extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingActor = RelatingActor;
            this.ActingRole = ActingRole;
            this.type = 1683148259;
        }
    }
    IFC4X32.IfcRelAssignsToActor = IfcRelAssignsToActor;
    class IfcRelAssignsToControl extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingControl = RelatingControl;
            this.type = 2495723537;
        }
    }
    IFC4X32.IfcRelAssignsToControl = IfcRelAssignsToControl;
    class IfcRelAssignsToGroup extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingGroup = RelatingGroup;
            this.type = 1307041759;
        }
    }
    IFC4X32.IfcRelAssignsToGroup = IfcRelAssignsToGroup;
    class IfcRelAssignsToGroupByFactor extends IfcRelAssignsToGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup, Factor){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingGroup = RelatingGroup;
            this.Factor = Factor;
            this.type = 1027710054;
        }
    }
    IFC4X32.IfcRelAssignsToGroupByFactor = IfcRelAssignsToGroupByFactor;
    class IfcRelAssignsToProcess extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingProcess = RelatingProcess;
            this.QuantityInProcess = QuantityInProcess;
            this.type = 4278684876;
        }
    }
    IFC4X32.IfcRelAssignsToProcess = IfcRelAssignsToProcess;
    class IfcRelAssignsToProduct extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingProduct = RelatingProduct;
            this.type = 2857406711;
        }
    }
    IFC4X32.IfcRelAssignsToProduct = IfcRelAssignsToProduct;
    class IfcRelAssignsToResource extends IfcRelAssigns {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatedObjectsType = RelatedObjectsType;
            this.RelatingResource = RelatingResource;
            this.type = 205026976;
        }
    }
    IFC4X32.IfcRelAssignsToResource = IfcRelAssignsToResource;
    class IfcRelAssociates extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.type = 1865459582;
        }
    }
    IFC4X32.IfcRelAssociates = IfcRelAssociates;
    class IfcRelAssociatesApproval extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingApproval = RelatingApproval;
            this.type = 4095574036;
        }
    }
    IFC4X32.IfcRelAssociatesApproval = IfcRelAssociatesApproval;
    class IfcRelAssociatesClassification extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingClassification = RelatingClassification;
            this.type = 919958153;
        }
    }
    IFC4X32.IfcRelAssociatesClassification = IfcRelAssociatesClassification;
    class IfcRelAssociatesConstraint extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.Intent = Intent;
            this.RelatingConstraint = RelatingConstraint;
            this.type = 2728634034;
        }
    }
    IFC4X32.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;
    class IfcRelAssociatesDocument extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingDocument = RelatingDocument;
            this.type = 982818633;
        }
    }
    IFC4X32.IfcRelAssociatesDocument = IfcRelAssociatesDocument;
    class IfcRelAssociatesLibrary extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingLibrary = RelatingLibrary;
            this.type = 3840914261;
        }
    }
    IFC4X32.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;
    class IfcRelAssociatesMaterial extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingMaterial = RelatingMaterial;
            this.type = 2655215786;
        }
    }
    IFC4X32.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;
    class IfcRelAssociatesProfileDef extends IfcRelAssociates {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingProfileDef){
            super(GlobalId, OwnerHistory, Name, Description, RelatedObjects);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingProfileDef = RelatingProfileDef;
            this.type = 1033248425;
        }
    }
    IFC4X32.IfcRelAssociatesProfileDef = IfcRelAssociatesProfileDef;
    class IfcRelConnects extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 826625072;
        }
    }
    IFC4X32.IfcRelConnects = IfcRelConnects;
    class IfcRelConnectsElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ConnectionGeometry = ConnectionGeometry;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.type = 1204542856;
        }
    }
    IFC4X32.IfcRelConnectsElements = IfcRelConnectsElements;
    class IfcRelConnectsPathElements extends IfcRelConnectsElements {
        constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType){
            super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ConnectionGeometry = ConnectionGeometry;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.RelatingPriorities = RelatingPriorities;
            this.RelatedPriorities = RelatedPriorities;
            this.RelatedConnectionType = RelatedConnectionType;
            this.RelatingConnectionType = RelatingConnectionType;
            this.type = 3945020480;
        }
    }
    IFC4X32.IfcRelConnectsPathElements = IfcRelConnectsPathElements;
    class IfcRelConnectsPortToElement extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingPort = RelatingPort;
            this.RelatedElement = RelatedElement;
            this.type = 4201705270;
        }
    }
    IFC4X32.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;
    class IfcRelConnectsPorts extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingPort = RelatingPort;
            this.RelatedPort = RelatedPort;
            this.RealizingElement = RealizingElement;
            this.type = 3190031847;
        }
    }
    IFC4X32.IfcRelConnectsPorts = IfcRelConnectsPorts;
    class IfcRelConnectsStructuralActivity extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedStructuralActivity = RelatedStructuralActivity;
            this.type = 2127690289;
        }
    }
    IFC4X32.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;
    class IfcRelConnectsStructuralMember extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingStructuralMember = RelatingStructuralMember;
            this.RelatedStructuralConnection = RelatedStructuralConnection;
            this.AppliedCondition = AppliedCondition;
            this.AdditionalConditions = AdditionalConditions;
            this.SupportedLength = SupportedLength;
            this.ConditionCoordinateSystem = ConditionCoordinateSystem;
            this.type = 1638771189;
        }
    }
    IFC4X32.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;
    class IfcRelConnectsWithEccentricity extends IfcRelConnectsStructuralMember {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint){
            super(GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingStructuralMember = RelatingStructuralMember;
            this.RelatedStructuralConnection = RelatedStructuralConnection;
            this.AppliedCondition = AppliedCondition;
            this.AdditionalConditions = AdditionalConditions;
            this.SupportedLength = SupportedLength;
            this.ConditionCoordinateSystem = ConditionCoordinateSystem;
            this.ConnectionConstraint = ConnectionConstraint;
            this.type = 504942748;
        }
    }
    IFC4X32.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;
    class IfcRelConnectsWithRealizingElements extends IfcRelConnectsElements {
        constructor(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType){
            super(GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ConnectionGeometry = ConnectionGeometry;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.RealizingElements = RealizingElements;
            this.ConnectionType = ConnectionType;
            this.type = 3678494232;
        }
    }
    IFC4X32.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;
    class IfcRelContainedInSpatialStructure extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedElements = RelatedElements;
            this.RelatingStructure = RelatingStructure;
            this.type = 3242617779;
        }
    }
    IFC4X32.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;
    class IfcRelCoversBldgElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingBuildingElement = RelatingBuildingElement;
            this.RelatedCoverings = RelatedCoverings;
            this.type = 886880790;
        }
    }
    IFC4X32.IfcRelCoversBldgElements = IfcRelCoversBldgElements;
    class IfcRelCoversSpaces extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedCoverings){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSpace = RelatingSpace;
            this.RelatedCoverings = RelatedCoverings;
            this.type = 2802773753;
        }
    }
    IFC4X32.IfcRelCoversSpaces = IfcRelCoversSpaces;
    class IfcRelDeclares extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingContext, RelatedDefinitions){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingContext = RelatingContext;
            this.RelatedDefinitions = RelatedDefinitions;
            this.type = 2565941209;
        }
    }
    IFC4X32.IfcRelDeclares = IfcRelDeclares;
    class IfcRelDecomposes extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 2551354335;
        }
    }
    IFC4X32.IfcRelDecomposes = IfcRelDecomposes;
    class IfcRelDefines extends IfcRelationship {
        constructor(GlobalId, OwnerHistory, Name, Description){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.type = 693640335;
        }
    }
    IFC4X32.IfcRelDefines = IfcRelDefines;
    class IfcRelDefinesByObject extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingObject){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingObject = RelatingObject;
            this.type = 1462361463;
        }
    }
    IFC4X32.IfcRelDefinesByObject = IfcRelDefinesByObject;
    class IfcRelDefinesByProperties extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingPropertyDefinition = RelatingPropertyDefinition;
            this.type = 4186316022;
        }
    }
    IFC4X32.IfcRelDefinesByProperties = IfcRelDefinesByProperties;
    class IfcRelDefinesByTemplate extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedPropertySets, RelatingTemplate){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedPropertySets = RelatedPropertySets;
            this.RelatingTemplate = RelatingTemplate;
            this.type = 307848117;
        }
    }
    IFC4X32.IfcRelDefinesByTemplate = IfcRelDefinesByTemplate;
    class IfcRelDefinesByType extends IfcRelDefines {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedObjects = RelatedObjects;
            this.RelatingType = RelatingType;
            this.type = 781010003;
        }
    }
    IFC4X32.IfcRelDefinesByType = IfcRelDefinesByType;
    class IfcRelFillsElement extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingOpeningElement = RelatingOpeningElement;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.type = 3940055652;
        }
    }
    IFC4X32.IfcRelFillsElement = IfcRelFillsElement;
    class IfcRelFlowControlElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedControlElements = RelatedControlElements;
            this.RelatingFlowElement = RelatingFlowElement;
            this.type = 279856033;
        }
    }
    IFC4X32.IfcRelFlowControlElements = IfcRelFlowControlElements;
    class IfcRelInterferesElements extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedElement, InterferenceGeometry, InterferenceType, ImpliedOrder, InterferenceSpace){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedElement = RelatedElement;
            this.InterferenceGeometry = InterferenceGeometry;
            this.InterferenceType = InterferenceType;
            this.ImpliedOrder = ImpliedOrder;
            this.InterferenceSpace = InterferenceSpace;
            this.type = 427948657;
        }
    }
    IFC4X32.IfcRelInterferesElements = IfcRelInterferesElements;
    class IfcRelNests extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingObject = RelatingObject;
            this.RelatedObjects = RelatedObjects;
            this.type = 3268803585;
        }
    }
    IFC4X32.IfcRelNests = IfcRelNests;
    class IfcRelPositions extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingPositioningElement, RelatedProducts){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingPositioningElement = RelatingPositioningElement;
            this.RelatedProducts = RelatedProducts;
            this.type = 1441486842;
        }
    }
    IFC4X32.IfcRelPositions = IfcRelPositions;
    class IfcRelProjectsElement extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedFeatureElement = RelatedFeatureElement;
            this.type = 750771296;
        }
    }
    IFC4X32.IfcRelProjectsElement = IfcRelProjectsElement;
    class IfcRelReferencedInSpatialStructure extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatedElements = RelatedElements;
            this.RelatingStructure = RelatingStructure;
            this.type = 1245217292;
        }
    }
    IFC4X32.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;
    class IfcRelSequence extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType, UserDefinedSequenceType){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingProcess = RelatingProcess;
            this.RelatedProcess = RelatedProcess;
            this.TimeLag = TimeLag;
            this.SequenceType = SequenceType;
            this.UserDefinedSequenceType = UserDefinedSequenceType;
            this.type = 4122056220;
        }
    }
    IFC4X32.IfcRelSequence = IfcRelSequence;
    class IfcRelServicesBuildings extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSystem = RelatingSystem;
            this.RelatedBuildings = RelatedBuildings;
            this.type = 366585022;
        }
    }
    IFC4X32.IfcRelServicesBuildings = IfcRelServicesBuildings;
    class IfcRelSpaceBoundary extends IfcRelConnects {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSpace = RelatingSpace;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.ConnectionGeometry = ConnectionGeometry;
            this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
            this.InternalOrExternalBoundary = InternalOrExternalBoundary;
            this.type = 3451746338;
        }
    }
    IFC4X32.IfcRelSpaceBoundary = IfcRelSpaceBoundary;
    class IfcRelSpaceBoundary1stLevel extends IfcRelSpaceBoundary {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary){
            super(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSpace = RelatingSpace;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.ConnectionGeometry = ConnectionGeometry;
            this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
            this.InternalOrExternalBoundary = InternalOrExternalBoundary;
            this.ParentBoundary = ParentBoundary;
            this.type = 3523091289;
        }
    }
    IFC4X32.IfcRelSpaceBoundary1stLevel = IfcRelSpaceBoundary1stLevel;
    class IfcRelSpaceBoundary2ndLevel extends IfcRelSpaceBoundary1stLevel {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary, CorrespondingBoundary){
            super(GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingSpace = RelatingSpace;
            this.RelatedBuildingElement = RelatedBuildingElement;
            this.ConnectionGeometry = ConnectionGeometry;
            this.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
            this.InternalOrExternalBoundary = InternalOrExternalBoundary;
            this.ParentBoundary = ParentBoundary;
            this.CorrespondingBoundary = CorrespondingBoundary;
            this.type = 1521410863;
        }
    }
    IFC4X32.IfcRelSpaceBoundary2ndLevel = IfcRelSpaceBoundary2ndLevel;
    class IfcRelVoidsElement extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingBuildingElement = RelatingBuildingElement;
            this.RelatedOpeningElement = RelatedOpeningElement;
            this.type = 1401173127;
        }
    }
    IFC4X32.IfcRelVoidsElement = IfcRelVoidsElement;
    class IfcReparametrisedCompositeCurveSegment extends IfcCompositeCurveSegment {
        constructor(Transition, SameSense, ParentCurve, ParamLength){
            super(Transition, SameSense, ParentCurve);
            this.Transition = Transition;
            this.SameSense = SameSense;
            this.ParentCurve = ParentCurve;
            this.ParamLength = ParamLength;
            this.type = 816062949;
        }
    }
    IFC4X32.IfcReparametrisedCompositeCurveSegment = IfcReparametrisedCompositeCurveSegment;
    class IfcResource extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.type = 2914609552;
        }
    }
    IFC4X32.IfcResource = IfcResource;
    class IfcRevolvedAreaSolid extends IfcSweptAreaSolid {
        constructor(SweptArea, Position, Axis, Angle){
            super(SweptArea, Position);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Axis = Axis;
            this.Angle = Angle;
            this.type = 1856042241;
        }
    }
    IFC4X32.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;
    class IfcRevolvedAreaSolidTapered extends IfcRevolvedAreaSolid {
        constructor(SweptArea, Position, Axis, Angle, EndSweptArea){
            super(SweptArea, Position, Axis, Angle);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Axis = Axis;
            this.Angle = Angle;
            this.EndSweptArea = EndSweptArea;
            this.type = 3243963512;
        }
    }
    IFC4X32.IfcRevolvedAreaSolidTapered = IfcRevolvedAreaSolidTapered;
    class IfcRightCircularCone extends IfcCsgPrimitive3D {
        constructor(Position, Height, BottomRadius){
            super(Position);
            this.Position = Position;
            this.Height = Height;
            this.BottomRadius = BottomRadius;
            this.type = 4158566097;
        }
    }
    IFC4X32.IfcRightCircularCone = IfcRightCircularCone;
    class IfcRightCircularCylinder extends IfcCsgPrimitive3D {
        constructor(Position, Height, Radius){
            super(Position);
            this.Position = Position;
            this.Height = Height;
            this.Radius = Radius;
            this.type = 3626867408;
        }
    }
    IFC4X32.IfcRightCircularCylinder = IfcRightCircularCylinder;
    class IfcSectionedSolid extends IfcSolidModel {
        constructor(Directrix, CrossSections){
            super();
            this.Directrix = Directrix;
            this.CrossSections = CrossSections;
            this.type = 1862484736;
        }
    }
    IFC4X32.IfcSectionedSolid = IfcSectionedSolid;
    class IfcSectionedSolidHorizontal extends IfcSectionedSolid {
        constructor(Directrix, CrossSections, CrossSectionPositions){
            super(Directrix, CrossSections);
            this.Directrix = Directrix;
            this.CrossSections = CrossSections;
            this.CrossSectionPositions = CrossSectionPositions;
            this.type = 1290935644;
        }
    }
    IFC4X32.IfcSectionedSolidHorizontal = IfcSectionedSolidHorizontal;
    class IfcSectionedSurface extends IfcSurface {
        constructor(Directrix, CrossSectionPositions, CrossSections){
            super();
            this.Directrix = Directrix;
            this.CrossSectionPositions = CrossSectionPositions;
            this.CrossSections = CrossSections;
            this.type = 1356537516;
        }
    }
    IFC4X32.IfcSectionedSurface = IfcSectionedSurface;
    class IfcSimplePropertyTemplate extends IfcPropertyTemplate {
        constructor(GlobalId, OwnerHistory, Name, Description, TemplateType, PrimaryMeasureType, SecondaryMeasureType, Enumerators, PrimaryUnit, SecondaryUnit, Expression, AccessState){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.TemplateType = TemplateType;
            this.PrimaryMeasureType = PrimaryMeasureType;
            this.SecondaryMeasureType = SecondaryMeasureType;
            this.Enumerators = Enumerators;
            this.PrimaryUnit = PrimaryUnit;
            this.SecondaryUnit = SecondaryUnit;
            this.Expression = Expression;
            this.AccessState = AccessState;
            this.type = 3663146110;
        }
    }
    IFC4X32.IfcSimplePropertyTemplate = IfcSimplePropertyTemplate;
    class IfcSpatialElement extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.type = 1412071761;
        }
    }
    IFC4X32.IfcSpatialElement = IfcSpatialElement;
    class IfcSpatialElementType extends IfcTypeProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 710998568;
        }
    }
    IFC4X32.IfcSpatialElementType = IfcSpatialElementType;
    class IfcSpatialStructureElement extends IfcSpatialElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.type = 2706606064;
        }
    }
    IFC4X32.IfcSpatialStructureElement = IfcSpatialStructureElement;
    class IfcSpatialStructureElementType extends IfcSpatialElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3893378262;
        }
    }
    IFC4X32.IfcSpatialStructureElementType = IfcSpatialStructureElementType;
    class IfcSpatialZone extends IfcSpatialElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.PredefinedType = PredefinedType;
            this.type = 463610769;
        }
    }
    IFC4X32.IfcSpatialZone = IfcSpatialZone;
    class IfcSpatialZoneType extends IfcSpatialElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.LongName = LongName;
            this.type = 2481509218;
        }
    }
    IFC4X32.IfcSpatialZoneType = IfcSpatialZoneType;
    class IfcSphere extends IfcCsgPrimitive3D {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 451544542;
        }
    }
    IFC4X32.IfcSphere = IfcSphere;
    class IfcSphericalSurface extends IfcElementarySurface {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 4015995234;
        }
    }
    IFC4X32.IfcSphericalSurface = IfcSphericalSurface;
    class IfcSpiral extends IfcCurve {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2735484536;
        }
    }
    IFC4X32.IfcSpiral = IfcSpiral;
    class IfcStructuralActivity extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 3544373492;
        }
    }
    IFC4X32.IfcStructuralActivity = IfcStructuralActivity;
    class IfcStructuralItem extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 3136571912;
        }
    }
    IFC4X32.IfcStructuralItem = IfcStructuralItem;
    class IfcStructuralMember extends IfcStructuralItem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 530289379;
        }
    }
    IFC4X32.IfcStructuralMember = IfcStructuralMember;
    class IfcStructuralReaction extends IfcStructuralActivity {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 3689010777;
        }
    }
    IFC4X32.IfcStructuralReaction = IfcStructuralReaction;
    class IfcStructuralSurfaceMember extends IfcStructuralMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Thickness = Thickness;
            this.type = 3979015343;
        }
    }
    IFC4X32.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;
    class IfcStructuralSurfaceMemberVarying extends IfcStructuralSurfaceMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Thickness = Thickness;
            this.type = 2218152070;
        }
    }
    IFC4X32.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;
    class IfcStructuralSurfaceReaction extends IfcStructuralReaction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.PredefinedType = PredefinedType;
            this.type = 603775116;
        }
    }
    IFC4X32.IfcStructuralSurfaceReaction = IfcStructuralSurfaceReaction;
    class IfcSubContractResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 4095615324;
        }
    }
    IFC4X32.IfcSubContractResourceType = IfcSubContractResourceType;
    class IfcSurfaceCurve extends IfcCurve {
        constructor(Curve3D, AssociatedGeometry, MasterRepresentation){
            super();
            this.Curve3D = Curve3D;
            this.AssociatedGeometry = AssociatedGeometry;
            this.MasterRepresentation = MasterRepresentation;
            this.type = 699246055;
        }
    }
    IFC4X32.IfcSurfaceCurve = IfcSurfaceCurve;
    class IfcSurfaceCurveSweptAreaSolid extends IfcDirectrixCurveSweptAreaSolid {
        constructor(SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface){
            super(SweptArea, Position, Directrix, StartParam, EndParam);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Directrix = Directrix;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.ReferenceSurface = ReferenceSurface;
            this.type = 2028607225;
        }
    }
    IFC4X32.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;
    class IfcSurfaceOfLinearExtrusion extends IfcSweptSurface {
        constructor(SweptCurve, Position, ExtrudedDirection, Depth){
            super(SweptCurve, Position);
            this.SweptCurve = SweptCurve;
            this.Position = Position;
            this.ExtrudedDirection = ExtrudedDirection;
            this.Depth = Depth;
            this.type = 2809605785;
        }
    }
    IFC4X32.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;
    class IfcSurfaceOfRevolution extends IfcSweptSurface {
        constructor(SweptCurve, Position, AxisPosition){
            super(SweptCurve, Position);
            this.SweptCurve = SweptCurve;
            this.Position = Position;
            this.AxisPosition = AxisPosition;
            this.type = 4124788165;
        }
    }
    IFC4X32.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;
    class IfcSystemFurnitureElementType extends IfcFurnishingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1580310250;
        }
    }
    IFC4X32.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;
    class IfcTask extends IfcProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Status, WorkMethod, IsMilestone, Priority, TaskTime, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Status = Status;
            this.WorkMethod = WorkMethod;
            this.IsMilestone = IsMilestone;
            this.Priority = Priority;
            this.TaskTime = TaskTime;
            this.PredefinedType = PredefinedType;
            this.type = 3473067441;
        }
    }
    IFC4X32.IfcTask = IfcTask;
    class IfcTaskType extends IfcTypeProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, WorkMethod){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ProcessType = ProcessType;
            this.PredefinedType = PredefinedType;
            this.WorkMethod = WorkMethod;
            this.type = 3206491090;
        }
    }
    IFC4X32.IfcTaskType = IfcTaskType;
    class IfcTessellatedFaceSet extends IfcTessellatedItem {
        constructor(Coordinates){
            super();
            this.Coordinates = Coordinates;
            this.type = 2387106220;
        }
    }
    IFC4X32.IfcTessellatedFaceSet = IfcTessellatedFaceSet;
    class IfcThirdOrderPolynomialSpiral extends IfcSpiral {
        constructor(Position, CubicTerm, QuadraticTerm, LinearTerm, ConstantTerm){
            super(Position);
            this.Position = Position;
            this.CubicTerm = CubicTerm;
            this.QuadraticTerm = QuadraticTerm;
            this.LinearTerm = LinearTerm;
            this.ConstantTerm = ConstantTerm;
            this.type = 782932809;
        }
    }
    IFC4X32.IfcThirdOrderPolynomialSpiral = IfcThirdOrderPolynomialSpiral;
    class IfcToroidalSurface extends IfcElementarySurface {
        constructor(Position, MajorRadius, MinorRadius){
            super(Position);
            this.Position = Position;
            this.MajorRadius = MajorRadius;
            this.MinorRadius = MinorRadius;
            this.type = 1935646853;
        }
    }
    IFC4X32.IfcToroidalSurface = IfcToroidalSurface;
    class IfcTransportationDeviceType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3665877780;
        }
    }
    IFC4X32.IfcTransportationDeviceType = IfcTransportationDeviceType;
    class IfcTriangulatedFaceSet extends IfcTessellatedFaceSet {
        constructor(Coordinates, Normals, Closed, CoordIndex, PnIndex){
            super(Coordinates);
            this.Coordinates = Coordinates;
            this.Normals = Normals;
            this.Closed = Closed;
            this.CoordIndex = CoordIndex;
            this.PnIndex = PnIndex;
            this.type = 2916149573;
        }
    }
    IFC4X32.IfcTriangulatedFaceSet = IfcTriangulatedFaceSet;
    class IfcTriangulatedIrregularNetwork extends IfcTriangulatedFaceSet {
        constructor(Coordinates, Normals, Closed, CoordIndex, PnIndex, Flags){
            super(Coordinates, Normals, Closed, CoordIndex, PnIndex);
            this.Coordinates = Coordinates;
            this.Normals = Normals;
            this.Closed = Closed;
            this.CoordIndex = CoordIndex;
            this.PnIndex = PnIndex;
            this.Flags = Flags;
            this.type = 1229763772;
        }
    }
    IFC4X32.IfcTriangulatedIrregularNetwork = IfcTriangulatedIrregularNetwork;
    class IfcVehicleType extends IfcTransportationDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3651464721;
        }
    }
    IFC4X32.IfcVehicleType = IfcVehicleType;
    class IfcWindowLiningProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle, LiningOffset, LiningToPanelOffsetX, LiningToPanelOffsetY){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.LiningDepth = LiningDepth;
            this.LiningThickness = LiningThickness;
            this.TransomThickness = TransomThickness;
            this.MullionThickness = MullionThickness;
            this.FirstTransomOffset = FirstTransomOffset;
            this.SecondTransomOffset = SecondTransomOffset;
            this.FirstMullionOffset = FirstMullionOffset;
            this.SecondMullionOffset = SecondMullionOffset;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.LiningOffset = LiningOffset;
            this.LiningToPanelOffsetX = LiningToPanelOffsetX;
            this.LiningToPanelOffsetY = LiningToPanelOffsetY;
            this.type = 336235671;
        }
    }
    IFC4X32.IfcWindowLiningProperties = IfcWindowLiningProperties;
    class IfcWindowPanelProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.OperationType = OperationType;
            this.PanelPosition = PanelPosition;
            this.FrameDepth = FrameDepth;
            this.FrameThickness = FrameThickness;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 512836454;
        }
    }
    IFC4X32.IfcWindowPanelProperties = IfcWindowPanelProperties;
    class IfcActor extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TheActor = TheActor;
            this.type = 2296667514;
        }
    }
    IFC4X32.IfcActor = IfcActor;
    class IfcAdvancedBrep extends IfcManifoldSolidBrep {
        constructor(Outer){
            super(Outer);
            this.Outer = Outer;
            this.type = 1635779807;
        }
    }
    IFC4X32.IfcAdvancedBrep = IfcAdvancedBrep;
    class IfcAdvancedBrepWithVoids extends IfcAdvancedBrep {
        constructor(Outer, Voids){
            super(Outer);
            this.Outer = Outer;
            this.Voids = Voids;
            this.type = 2603310189;
        }
    }
    IFC4X32.IfcAdvancedBrepWithVoids = IfcAdvancedBrepWithVoids;
    class IfcAnnotation extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.type = 1674181508;
        }
    }
    IFC4X32.IfcAnnotation = IfcAnnotation;
    class IfcBSplineSurface extends IfcBoundedSurface {
        constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect){
            super();
            this.UDegree = UDegree;
            this.VDegree = VDegree;
            this.ControlPointsList = ControlPointsList;
            this.SurfaceForm = SurfaceForm;
            this.UClosed = UClosed;
            this.VClosed = VClosed;
            this.SelfIntersect = SelfIntersect;
            this.type = 2887950389;
        }
    }
    IFC4X32.IfcBSplineSurface = IfcBSplineSurface;
    class IfcBSplineSurfaceWithKnots extends IfcBSplineSurface {
        constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec){
            super(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect);
            this.UDegree = UDegree;
            this.VDegree = VDegree;
            this.ControlPointsList = ControlPointsList;
            this.SurfaceForm = SurfaceForm;
            this.UClosed = UClosed;
            this.VClosed = VClosed;
            this.SelfIntersect = SelfIntersect;
            this.UMultiplicities = UMultiplicities;
            this.VMultiplicities = VMultiplicities;
            this.UKnots = UKnots;
            this.VKnots = VKnots;
            this.KnotSpec = KnotSpec;
            this.type = 167062518;
        }
    }
    IFC4X32.IfcBSplineSurfaceWithKnots = IfcBSplineSurfaceWithKnots;
    class IfcBlock extends IfcCsgPrimitive3D {
        constructor(Position, XLength, YLength, ZLength){
            super(Position);
            this.Position = Position;
            this.XLength = XLength;
            this.YLength = YLength;
            this.ZLength = ZLength;
            this.type = 1334484129;
        }
    }
    IFC4X32.IfcBlock = IfcBlock;
    class IfcBooleanClippingResult extends IfcBooleanResult {
        constructor(Operator, FirstOperand, SecondOperand){
            super(Operator, FirstOperand, SecondOperand);
            this.Operator = Operator;
            this.FirstOperand = FirstOperand;
            this.SecondOperand = SecondOperand;
            this.type = 3649129432;
        }
    }
    IFC4X32.IfcBooleanClippingResult = IfcBooleanClippingResult;
    class IfcBoundedCurve extends IfcCurve {
        constructor(){
            super();
            this.type = 1260505505;
        }
    }
    IFC4X32.IfcBoundedCurve = IfcBoundedCurve;
    class IfcBuildingStorey extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.Elevation = Elevation;
            this.type = 3124254112;
        }
    }
    IFC4X32.IfcBuildingStorey = IfcBuildingStorey;
    class IfcBuiltElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1626504194;
        }
    }
    IFC4X32.IfcBuiltElementType = IfcBuiltElementType;
    class IfcChimneyType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2197970202;
        }
    }
    IFC4X32.IfcChimneyType = IfcChimneyType;
    class IfcCircleHollowProfileDef extends IfcCircleProfileDef {
        constructor(ProfileType, ProfileName, Position, Radius, WallThickness){
            super(ProfileType, ProfileName, Position, Radius);
            this.ProfileType = ProfileType;
            this.ProfileName = ProfileName;
            this.Position = Position;
            this.Radius = Radius;
            this.WallThickness = WallThickness;
            this.type = 2937912522;
        }
    }
    IFC4X32.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;
    class IfcCivilElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3893394355;
        }
    }
    IFC4X32.IfcCivilElementType = IfcCivilElementType;
    class IfcClothoid extends IfcSpiral {
        constructor(Position, ClothoidConstant){
            super(Position);
            this.Position = Position;
            this.ClothoidConstant = ClothoidConstant;
            this.type = 3497074424;
        }
    }
    IFC4X32.IfcClothoid = IfcClothoid;
    class IfcColumnType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 300633059;
        }
    }
    IFC4X32.IfcColumnType = IfcColumnType;
    class IfcComplexPropertyTemplate extends IfcPropertyTemplate {
        constructor(GlobalId, OwnerHistory, Name, Description, UsageName, TemplateType, HasPropertyTemplates){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.UsageName = UsageName;
            this.TemplateType = TemplateType;
            this.HasPropertyTemplates = HasPropertyTemplates;
            this.type = 3875453745;
        }
    }
    IFC4X32.IfcComplexPropertyTemplate = IfcComplexPropertyTemplate;
    class IfcCompositeCurve extends IfcBoundedCurve {
        constructor(Segments, SelfIntersect){
            super();
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 3732776249;
        }
    }
    IFC4X32.IfcCompositeCurve = IfcCompositeCurve;
    class IfcCompositeCurveOnSurface extends IfcCompositeCurve {
        constructor(Segments, SelfIntersect){
            super(Segments, SelfIntersect);
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 15328376;
        }
    }
    IFC4X32.IfcCompositeCurveOnSurface = IfcCompositeCurveOnSurface;
    class IfcConic extends IfcCurve {
        constructor(Position){
            super();
            this.Position = Position;
            this.type = 2510884976;
        }
    }
    IFC4X32.IfcConic = IfcConic;
    class IfcConstructionEquipmentResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 2185764099;
        }
    }
    IFC4X32.IfcConstructionEquipmentResourceType = IfcConstructionEquipmentResourceType;
    class IfcConstructionMaterialResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 4105962743;
        }
    }
    IFC4X32.IfcConstructionMaterialResourceType = IfcConstructionMaterialResourceType;
    class IfcConstructionProductResourceType extends IfcConstructionResourceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.ResourceType = ResourceType;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 1525564444;
        }
    }
    IFC4X32.IfcConstructionProductResourceType = IfcConstructionProductResourceType;
    class IfcConstructionResource extends IfcResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.type = 2559216714;
        }
    }
    IFC4X32.IfcConstructionResource = IfcConstructionResource;
    class IfcControl extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.type = 3293443760;
        }
    }
    IFC4X32.IfcControl = IfcControl;
    class IfcCosineSpiral extends IfcSpiral {
        constructor(Position, CosineTerm, ConstantTerm){
            super(Position);
            this.Position = Position;
            this.CosineTerm = CosineTerm;
            this.ConstantTerm = ConstantTerm;
            this.type = 2000195564;
        }
    }
    IFC4X32.IfcCosineSpiral = IfcCosineSpiral;
    class IfcCostItem extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, CostValues, CostQuantities){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.CostValues = CostValues;
            this.CostQuantities = CostQuantities;
            this.type = 3895139033;
        }
    }
    IFC4X32.IfcCostItem = IfcCostItem;
    class IfcCostSchedule extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, SubmittedOn, UpdateDate){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.Status = Status;
            this.SubmittedOn = SubmittedOn;
            this.UpdateDate = UpdateDate;
            this.type = 1419761937;
        }
    }
    IFC4X32.IfcCostSchedule = IfcCostSchedule;
    class IfcCourseType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4189326743;
        }
    }
    IFC4X32.IfcCourseType = IfcCourseType;
    class IfcCoveringType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1916426348;
        }
    }
    IFC4X32.IfcCoveringType = IfcCoveringType;
    class IfcCrewResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 3295246426;
        }
    }
    IFC4X32.IfcCrewResource = IfcCrewResource;
    class IfcCurtainWallType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1457835157;
        }
    }
    IFC4X32.IfcCurtainWallType = IfcCurtainWallType;
    class IfcCylindricalSurface extends IfcElementarySurface {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 1213902940;
        }
    }
    IFC4X32.IfcCylindricalSurface = IfcCylindricalSurface;
    class IfcDeepFoundationType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1306400036;
        }
    }
    IFC4X32.IfcDeepFoundationType = IfcDeepFoundationType;
    class IfcDirectrixDerivedReferenceSweptAreaSolid extends IfcFixedReferenceSweptAreaSolid {
        constructor(SweptArea, Position, Directrix, StartParam, EndParam, FixedReference){
            super(SweptArea, Position, Directrix, StartParam, EndParam, FixedReference);
            this.SweptArea = SweptArea;
            this.Position = Position;
            this.Directrix = Directrix;
            this.StartParam = StartParam;
            this.EndParam = EndParam;
            this.FixedReference = FixedReference;
            this.type = 4234616927;
        }
    }
    IFC4X32.IfcDirectrixDerivedReferenceSweptAreaSolid = IfcDirectrixDerivedReferenceSweptAreaSolid;
    class IfcDistributionElementType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3256556792;
        }
    }
    IFC4X32.IfcDistributionElementType = IfcDistributionElementType;
    class IfcDistributionFlowElementType extends IfcDistributionElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3849074793;
        }
    }
    IFC4X32.IfcDistributionFlowElementType = IfcDistributionFlowElementType;
    class IfcDoorLiningProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle, LiningToPanelOffsetX, LiningToPanelOffsetY){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.LiningDepth = LiningDepth;
            this.LiningThickness = LiningThickness;
            this.ThresholdDepth = ThresholdDepth;
            this.ThresholdThickness = ThresholdThickness;
            this.TransomThickness = TransomThickness;
            this.TransomOffset = TransomOffset;
            this.LiningOffset = LiningOffset;
            this.ThresholdOffset = ThresholdOffset;
            this.CasingThickness = CasingThickness;
            this.CasingDepth = CasingDepth;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.LiningToPanelOffsetX = LiningToPanelOffsetX;
            this.LiningToPanelOffsetY = LiningToPanelOffsetY;
            this.type = 2963535650;
        }
    }
    IFC4X32.IfcDoorLiningProperties = IfcDoorLiningProperties;
    class IfcDoorPanelProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.PanelDepth = PanelDepth;
            this.PanelOperation = PanelOperation;
            this.PanelWidth = PanelWidth;
            this.PanelPosition = PanelPosition;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 1714330368;
        }
    }
    IFC4X32.IfcDoorPanelProperties = IfcDoorPanelProperties;
    class IfcDoorType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, OperationType, ParameterTakesPrecedence, UserDefinedOperationType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.OperationType = OperationType;
            this.ParameterTakesPrecedence = ParameterTakesPrecedence;
            this.UserDefinedOperationType = UserDefinedOperationType;
            this.type = 2323601079;
        }
    }
    IFC4X32.IfcDoorType = IfcDoorType;
    class IfcDraughtingPreDefinedColour extends IfcPreDefinedColour {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 445594917;
        }
    }
    IFC4X32.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;
    class IfcDraughtingPreDefinedCurveFont extends IfcPreDefinedCurveFont {
        constructor(Name){
            super(Name);
            this.Name = Name;
            this.type = 4006246654;
        }
    }
    IFC4X32.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;
    class IfcElement extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1758889154;
        }
    }
    IFC4X32.IfcElement = IfcElement;
    class IfcElementAssembly extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.AssemblyPlace = AssemblyPlace;
            this.PredefinedType = PredefinedType;
            this.type = 4123344466;
        }
    }
    IFC4X32.IfcElementAssembly = IfcElementAssembly;
    class IfcElementAssemblyType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2397081782;
        }
    }
    IFC4X32.IfcElementAssemblyType = IfcElementAssemblyType;
    class IfcElementComponent extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1623761950;
        }
    }
    IFC4X32.IfcElementComponent = IfcElementComponent;
    class IfcElementComponentType extends IfcElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2590856083;
        }
    }
    IFC4X32.IfcElementComponentType = IfcElementComponentType;
    class IfcEllipse extends IfcConic {
        constructor(Position, SemiAxis1, SemiAxis2){
            super(Position);
            this.Position = Position;
            this.SemiAxis1 = SemiAxis1;
            this.SemiAxis2 = SemiAxis2;
            this.type = 1704287377;
        }
    }
    IFC4X32.IfcEllipse = IfcEllipse;
    class IfcEnergyConversionDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2107101300;
        }
    }
    IFC4X32.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;
    class IfcEngineType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 132023988;
        }
    }
    IFC4X32.IfcEngineType = IfcEngineType;
    class IfcEvaporativeCoolerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3174744832;
        }
    }
    IFC4X32.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;
    class IfcEvaporatorType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3390157468;
        }
    }
    IFC4X32.IfcEvaporatorType = IfcEvaporatorType;
    class IfcEvent extends IfcProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType, EventTriggerType, UserDefinedEventTriggerType, EventOccurenceTime){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.PredefinedType = PredefinedType;
            this.EventTriggerType = EventTriggerType;
            this.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
            this.EventOccurenceTime = EventOccurenceTime;
            this.type = 4148101412;
        }
    }
    IFC4X32.IfcEvent = IfcEvent;
    class IfcExternalSpatialStructureElement extends IfcSpatialElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.type = 2853485674;
        }
    }
    IFC4X32.IfcExternalSpatialStructureElement = IfcExternalSpatialStructureElement;
    class IfcFacetedBrep extends IfcManifoldSolidBrep {
        constructor(Outer){
            super(Outer);
            this.Outer = Outer;
            this.type = 807026263;
        }
    }
    IFC4X32.IfcFacetedBrep = IfcFacetedBrep;
    class IfcFacetedBrepWithVoids extends IfcFacetedBrep {
        constructor(Outer, Voids){
            super(Outer);
            this.Outer = Outer;
            this.Voids = Voids;
            this.type = 3737207727;
        }
    }
    IFC4X32.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;
    class IfcFacility extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.type = 24185140;
        }
    }
    IFC4X32.IfcFacility = IfcFacility;
    class IfcFacilityPart extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.UsageType = UsageType;
            this.type = 1310830890;
        }
    }
    IFC4X32.IfcFacilityPart = IfcFacilityPart;
    class IfcFacilityPartCommon extends IfcFacilityPart {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.UsageType = UsageType;
            this.PredefinedType = PredefinedType;
            this.type = 4228831410;
        }
    }
    IFC4X32.IfcFacilityPartCommon = IfcFacilityPartCommon;
    class IfcFastener extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 647756555;
        }
    }
    IFC4X32.IfcFastener = IfcFastener;
    class IfcFastenerType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2489546625;
        }
    }
    IFC4X32.IfcFastenerType = IfcFastenerType;
    class IfcFeatureElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2827207264;
        }
    }
    IFC4X32.IfcFeatureElement = IfcFeatureElement;
    class IfcFeatureElementAddition extends IfcFeatureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2143335405;
        }
    }
    IFC4X32.IfcFeatureElementAddition = IfcFeatureElementAddition;
    class IfcFeatureElementSubtraction extends IfcFeatureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1287392070;
        }
    }
    IFC4X32.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;
    class IfcFlowControllerType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3907093117;
        }
    }
    IFC4X32.IfcFlowControllerType = IfcFlowControllerType;
    class IfcFlowFittingType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3198132628;
        }
    }
    IFC4X32.IfcFlowFittingType = IfcFlowFittingType;
    class IfcFlowMeterType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3815607619;
        }
    }
    IFC4X32.IfcFlowMeterType = IfcFlowMeterType;
    class IfcFlowMovingDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1482959167;
        }
    }
    IFC4X32.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;
    class IfcFlowSegmentType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1834744321;
        }
    }
    IFC4X32.IfcFlowSegmentType = IfcFlowSegmentType;
    class IfcFlowStorageDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 1339347760;
        }
    }
    IFC4X32.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;
    class IfcFlowTerminalType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2297155007;
        }
    }
    IFC4X32.IfcFlowTerminalType = IfcFlowTerminalType;
    class IfcFlowTreatmentDeviceType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 3009222698;
        }
    }
    IFC4X32.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;
    class IfcFootingType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1893162501;
        }
    }
    IFC4X32.IfcFootingType = IfcFootingType;
    class IfcFurnishingElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 263784265;
        }
    }
    IFC4X32.IfcFurnishingElement = IfcFurnishingElement;
    class IfcFurniture extends IfcFurnishingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1509553395;
        }
    }
    IFC4X32.IfcFurniture = IfcFurniture;
    class IfcGeographicElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3493046030;
        }
    }
    IFC4X32.IfcGeographicElement = IfcGeographicElement;
    class IfcGeotechnicalElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 4230923436;
        }
    }
    IFC4X32.IfcGeotechnicalElement = IfcGeotechnicalElement;
    class IfcGeotechnicalStratum extends IfcGeotechnicalElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1594536857;
        }
    }
    IFC4X32.IfcGeotechnicalStratum = IfcGeotechnicalStratum;
    class IfcGradientCurve extends IfcCompositeCurve {
        constructor(Segments, SelfIntersect, BaseCurve, EndPoint){
            super(Segments, SelfIntersect);
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.BaseCurve = BaseCurve;
            this.EndPoint = EndPoint;
            this.type = 2898700619;
        }
    }
    IFC4X32.IfcGradientCurve = IfcGradientCurve;
    class IfcGroup extends IfcObject {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 2706460486;
        }
    }
    IFC4X32.IfcGroup = IfcGroup;
    class IfcHeatExchangerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1251058090;
        }
    }
    IFC4X32.IfcHeatExchangerType = IfcHeatExchangerType;
    class IfcHumidifierType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1806887404;
        }
    }
    IFC4X32.IfcHumidifierType = IfcHumidifierType;
    class IfcImpactProtectionDevice extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2568555532;
        }
    }
    IFC4X32.IfcImpactProtectionDevice = IfcImpactProtectionDevice;
    class IfcImpactProtectionDeviceType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3948183225;
        }
    }
    IFC4X32.IfcImpactProtectionDeviceType = IfcImpactProtectionDeviceType;
    class IfcIndexedPolyCurve extends IfcBoundedCurve {
        constructor(Points, Segments, SelfIntersect){
            super();
            this.Points = Points;
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 2571569899;
        }
    }
    IFC4X32.IfcIndexedPolyCurve = IfcIndexedPolyCurve;
    class IfcInterceptorType extends IfcFlowTreatmentDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3946677679;
        }
    }
    IFC4X32.IfcInterceptorType = IfcInterceptorType;
    class IfcIntersectionCurve extends IfcSurfaceCurve {
        constructor(Curve3D, AssociatedGeometry, MasterRepresentation){
            super(Curve3D, AssociatedGeometry, MasterRepresentation);
            this.Curve3D = Curve3D;
            this.AssociatedGeometry = AssociatedGeometry;
            this.MasterRepresentation = MasterRepresentation;
            this.type = 3113134337;
        }
    }
    IFC4X32.IfcIntersectionCurve = IfcIntersectionCurve;
    class IfcInventory extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.Jurisdiction = Jurisdiction;
            this.ResponsiblePersons = ResponsiblePersons;
            this.LastUpdateDate = LastUpdateDate;
            this.CurrentValue = CurrentValue;
            this.OriginalValue = OriginalValue;
            this.type = 2391368822;
        }
    }
    IFC4X32.IfcInventory = IfcInventory;
    class IfcJunctionBoxType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4288270099;
        }
    }
    IFC4X32.IfcJunctionBoxType = IfcJunctionBoxType;
    class IfcKerbType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 679976338;
        }
    }
    IFC4X32.IfcKerbType = IfcKerbType;
    class IfcLaborResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 3827777499;
        }
    }
    IFC4X32.IfcLaborResource = IfcLaborResource;
    class IfcLampType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1051575348;
        }
    }
    IFC4X32.IfcLampType = IfcLampType;
    class IfcLightFixtureType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1161773419;
        }
    }
    IFC4X32.IfcLightFixtureType = IfcLightFixtureType;
    class IfcLinearElement extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 2176059722;
        }
    }
    IFC4X32.IfcLinearElement = IfcLinearElement;
    class IfcLiquidTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1770583370;
        }
    }
    IFC4X32.IfcLiquidTerminalType = IfcLiquidTerminalType;
    class IfcMarineFacility extends IfcFacility {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.PredefinedType = PredefinedType;
            this.type = 525669439;
        }
    }
    IFC4X32.IfcMarineFacility = IfcMarineFacility;
    class IfcMarinePart extends IfcFacilityPart {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.UsageType = UsageType;
            this.PredefinedType = PredefinedType;
            this.type = 976884017;
        }
    }
    IFC4X32.IfcMarinePart = IfcMarinePart;
    class IfcMechanicalFastener extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.NominalDiameter = NominalDiameter;
            this.NominalLength = NominalLength;
            this.PredefinedType = PredefinedType;
            this.type = 377706215;
        }
    }
    IFC4X32.IfcMechanicalFastener = IfcMechanicalFastener;
    class IfcMechanicalFastenerType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, NominalLength){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.NominalDiameter = NominalDiameter;
            this.NominalLength = NominalLength;
            this.type = 2108223431;
        }
    }
    IFC4X32.IfcMechanicalFastenerType = IfcMechanicalFastenerType;
    class IfcMedicalDeviceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1114901282;
        }
    }
    IFC4X32.IfcMedicalDeviceType = IfcMedicalDeviceType;
    class IfcMemberType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3181161470;
        }
    }
    IFC4X32.IfcMemberType = IfcMemberType;
    class IfcMobileTelecommunicationsApplianceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1950438474;
        }
    }
    IFC4X32.IfcMobileTelecommunicationsApplianceType = IfcMobileTelecommunicationsApplianceType;
    class IfcMooringDeviceType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 710110818;
        }
    }
    IFC4X32.IfcMooringDeviceType = IfcMooringDeviceType;
    class IfcMotorConnectionType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 977012517;
        }
    }
    IFC4X32.IfcMotorConnectionType = IfcMotorConnectionType;
    class IfcNavigationElementType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 506776471;
        }
    }
    IFC4X32.IfcNavigationElementType = IfcNavigationElementType;
    class IfcOccupant extends IfcActor {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TheActor = TheActor;
            this.PredefinedType = PredefinedType;
            this.type = 4143007308;
        }
    }
    IFC4X32.IfcOccupant = IfcOccupant;
    class IfcOpeningElement extends IfcFeatureElementSubtraction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3588315303;
        }
    }
    IFC4X32.IfcOpeningElement = IfcOpeningElement;
    class IfcOutletType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2837617999;
        }
    }
    IFC4X32.IfcOutletType = IfcOutletType;
    class IfcPavementType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 514975943;
        }
    }
    IFC4X32.IfcPavementType = IfcPavementType;
    class IfcPerformanceHistory extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LifeCyclePhase, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LifeCyclePhase = LifeCyclePhase;
            this.PredefinedType = PredefinedType;
            this.type = 2382730787;
        }
    }
    IFC4X32.IfcPerformanceHistory = IfcPerformanceHistory;
    class IfcPermeableCoveringProperties extends IfcPreDefinedPropertySet {
        constructor(GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.OperationType = OperationType;
            this.PanelPosition = PanelPosition;
            this.FrameDepth = FrameDepth;
            this.FrameThickness = FrameThickness;
            this.ShapeAspectStyle = ShapeAspectStyle;
            this.type = 3566463478;
        }
    }
    IFC4X32.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;
    class IfcPermit extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.Status = Status;
            this.LongDescription = LongDescription;
            this.type = 3327091369;
        }
    }
    IFC4X32.IfcPermit = IfcPermit;
    class IfcPileType extends IfcDeepFoundationType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1158309216;
        }
    }
    IFC4X32.IfcPileType = IfcPileType;
    class IfcPipeFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 804291784;
        }
    }
    IFC4X32.IfcPipeFittingType = IfcPipeFittingType;
    class IfcPipeSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4231323485;
        }
    }
    IFC4X32.IfcPipeSegmentType = IfcPipeSegmentType;
    class IfcPlateType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4017108033;
        }
    }
    IFC4X32.IfcPlateType = IfcPlateType;
    class IfcPolygonalFaceSet extends IfcTessellatedFaceSet {
        constructor(Coordinates, Closed, Faces, PnIndex){
            super(Coordinates);
            this.Coordinates = Coordinates;
            this.Closed = Closed;
            this.Faces = Faces;
            this.PnIndex = PnIndex;
            this.type = 2839578677;
        }
    }
    IFC4X32.IfcPolygonalFaceSet = IfcPolygonalFaceSet;
    class IfcPolyline extends IfcBoundedCurve {
        constructor(Points){
            super();
            this.Points = Points;
            this.type = 3724593414;
        }
    }
    IFC4X32.IfcPolyline = IfcPolyline;
    class IfcPort extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 3740093272;
        }
    }
    IFC4X32.IfcPort = IfcPort;
    class IfcPositioningElement extends IfcProduct {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 1946335990;
        }
    }
    IFC4X32.IfcPositioningElement = IfcPositioningElement;
    class IfcProcedure extends IfcProcess {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.PredefinedType = PredefinedType;
            this.type = 2744685151;
        }
    }
    IFC4X32.IfcProcedure = IfcProcedure;
    class IfcProjectOrder extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.Status = Status;
            this.LongDescription = LongDescription;
            this.type = 2904328755;
        }
    }
    IFC4X32.IfcProjectOrder = IfcProjectOrder;
    class IfcProjectionElement extends IfcFeatureElementAddition {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3651124850;
        }
    }
    IFC4X32.IfcProjectionElement = IfcProjectionElement;
    class IfcProtectiveDeviceType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1842657554;
        }
    }
    IFC4X32.IfcProtectiveDeviceType = IfcProtectiveDeviceType;
    class IfcPumpType extends IfcFlowMovingDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2250791053;
        }
    }
    IFC4X32.IfcPumpType = IfcPumpType;
    class IfcRailType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1763565496;
        }
    }
    IFC4X32.IfcRailType = IfcRailType;
    class IfcRailingType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2893384427;
        }
    }
    IFC4X32.IfcRailingType = IfcRailingType;
    class IfcRailway extends IfcFacility {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.PredefinedType = PredefinedType;
            this.type = 3992365140;
        }
    }
    IFC4X32.IfcRailway = IfcRailway;
    class IfcRailwayPart extends IfcFacilityPart {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.UsageType = UsageType;
            this.PredefinedType = PredefinedType;
            this.type = 1891881377;
        }
    }
    IFC4X32.IfcRailwayPart = IfcRailwayPart;
    class IfcRampFlightType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2324767716;
        }
    }
    IFC4X32.IfcRampFlightType = IfcRampFlightType;
    class IfcRampType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1469900589;
        }
    }
    IFC4X32.IfcRampType = IfcRampType;
    class IfcRationalBSplineSurfaceWithKnots extends IfcBSplineSurfaceWithKnots {
        constructor(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec, WeightsData){
            super(UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec);
            this.UDegree = UDegree;
            this.VDegree = VDegree;
            this.ControlPointsList = ControlPointsList;
            this.SurfaceForm = SurfaceForm;
            this.UClosed = UClosed;
            this.VClosed = VClosed;
            this.SelfIntersect = SelfIntersect;
            this.UMultiplicities = UMultiplicities;
            this.VMultiplicities = VMultiplicities;
            this.UKnots = UKnots;
            this.VKnots = VKnots;
            this.KnotSpec = KnotSpec;
            this.WeightsData = WeightsData;
            this.type = 683857671;
        }
    }
    IFC4X32.IfcRationalBSplineSurfaceWithKnots = IfcRationalBSplineSurfaceWithKnots;
    class IfcReferent extends IfcPositioningElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.type = 4021432810;
        }
    }
    IFC4X32.IfcReferent = IfcReferent;
    class IfcReinforcingElement extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.type = 3027567501;
        }
    }
    IFC4X32.IfcReinforcingElement = IfcReinforcingElement;
    class IfcReinforcingElementType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 964333572;
        }
    }
    IFC4X32.IfcReinforcingElementType = IfcReinforcingElementType;
    class IfcReinforcingMesh extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.MeshLength = MeshLength;
            this.MeshWidth = MeshWidth;
            this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
            this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
            this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
            this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
            this.LongitudinalBarSpacing = LongitudinalBarSpacing;
            this.TransverseBarSpacing = TransverseBarSpacing;
            this.PredefinedType = PredefinedType;
            this.type = 2320036040;
        }
    }
    IFC4X32.IfcReinforcingMesh = IfcReinforcingMesh;
    class IfcReinforcingMeshType extends IfcReinforcingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, BendingShapeCode, BendingParameters){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.MeshLength = MeshLength;
            this.MeshWidth = MeshWidth;
            this.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
            this.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
            this.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
            this.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
            this.LongitudinalBarSpacing = LongitudinalBarSpacing;
            this.TransverseBarSpacing = TransverseBarSpacing;
            this.BendingShapeCode = BendingShapeCode;
            this.BendingParameters = BendingParameters;
            this.type = 2310774935;
        }
    }
    IFC4X32.IfcReinforcingMeshType = IfcReinforcingMeshType;
    class IfcRelAdheresToElement extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedSurfaceFeatures){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingElement = RelatingElement;
            this.RelatedSurfaceFeatures = RelatedSurfaceFeatures;
            this.type = 3818125796;
        }
    }
    IFC4X32.IfcRelAdheresToElement = IfcRelAdheresToElement;
    class IfcRelAggregates extends IfcRelDecomposes {
        constructor(GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects){
            super(GlobalId, OwnerHistory, Name, Description);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.RelatingObject = RelatingObject;
            this.RelatedObjects = RelatedObjects;
            this.type = 160246688;
        }
    }
    IFC4X32.IfcRelAggregates = IfcRelAggregates;
    class IfcRoad extends IfcFacility {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.PredefinedType = PredefinedType;
            this.type = 146592293;
        }
    }
    IFC4X32.IfcRoad = IfcRoad;
    class IfcRoadPart extends IfcFacilityPart {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.UsageType = UsageType;
            this.PredefinedType = PredefinedType;
            this.type = 550521510;
        }
    }
    IFC4X32.IfcRoadPart = IfcRoadPart;
    class IfcRoofType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2781568857;
        }
    }
    IFC4X32.IfcRoofType = IfcRoofType;
    class IfcSanitaryTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1768891740;
        }
    }
    IFC4X32.IfcSanitaryTerminalType = IfcSanitaryTerminalType;
    class IfcSeamCurve extends IfcSurfaceCurve {
        constructor(Curve3D, AssociatedGeometry, MasterRepresentation){
            super(Curve3D, AssociatedGeometry, MasterRepresentation);
            this.Curve3D = Curve3D;
            this.AssociatedGeometry = AssociatedGeometry;
            this.MasterRepresentation = MasterRepresentation;
            this.type = 2157484638;
        }
    }
    IFC4X32.IfcSeamCurve = IfcSeamCurve;
    class IfcSecondOrderPolynomialSpiral extends IfcSpiral {
        constructor(Position, QuadraticTerm, LinearTerm, ConstantTerm){
            super(Position);
            this.Position = Position;
            this.QuadraticTerm = QuadraticTerm;
            this.LinearTerm = LinearTerm;
            this.ConstantTerm = ConstantTerm;
            this.type = 3649235739;
        }
    }
    IFC4X32.IfcSecondOrderPolynomialSpiral = IfcSecondOrderPolynomialSpiral;
    class IfcSegmentedReferenceCurve extends IfcCompositeCurve {
        constructor(Segments, SelfIntersect, BaseCurve, EndPoint){
            super(Segments, SelfIntersect);
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.BaseCurve = BaseCurve;
            this.EndPoint = EndPoint;
            this.type = 544395925;
        }
    }
    IFC4X32.IfcSegmentedReferenceCurve = IfcSegmentedReferenceCurve;
    class IfcSeventhOrderPolynomialSpiral extends IfcSpiral {
        constructor(Position, SepticTerm, SexticTerm, QuinticTerm, QuarticTerm, CubicTerm, QuadraticTerm, LinearTerm, ConstantTerm){
            super(Position);
            this.Position = Position;
            this.SepticTerm = SepticTerm;
            this.SexticTerm = SexticTerm;
            this.QuinticTerm = QuinticTerm;
            this.QuarticTerm = QuarticTerm;
            this.CubicTerm = CubicTerm;
            this.QuadraticTerm = QuadraticTerm;
            this.LinearTerm = LinearTerm;
            this.ConstantTerm = ConstantTerm;
            this.type = 1027922057;
        }
    }
    IFC4X32.IfcSeventhOrderPolynomialSpiral = IfcSeventhOrderPolynomialSpiral;
    class IfcShadingDeviceType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4074543187;
        }
    }
    IFC4X32.IfcShadingDeviceType = IfcShadingDeviceType;
    class IfcSign extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 33720170;
        }
    }
    IFC4X32.IfcSign = IfcSign;
    class IfcSignType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3599934289;
        }
    }
    IFC4X32.IfcSignType = IfcSignType;
    class IfcSignalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1894708472;
        }
    }
    IFC4X32.IfcSignalType = IfcSignalType;
    class IfcSineSpiral extends IfcSpiral {
        constructor(Position, SineTerm, LinearTerm, ConstantTerm){
            super(Position);
            this.Position = Position;
            this.SineTerm = SineTerm;
            this.LinearTerm = LinearTerm;
            this.ConstantTerm = ConstantTerm;
            this.type = 42703149;
        }
    }
    IFC4X32.IfcSineSpiral = IfcSineSpiral;
    class IfcSite extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.RefLatitude = RefLatitude;
            this.RefLongitude = RefLongitude;
            this.RefElevation = RefElevation;
            this.LandTitleNumber = LandTitleNumber;
            this.SiteAddress = SiteAddress;
            this.type = 4097777520;
        }
    }
    IFC4X32.IfcSite = IfcSite;
    class IfcSlabType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2533589738;
        }
    }
    IFC4X32.IfcSlabType = IfcSlabType;
    class IfcSolarDeviceType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1072016465;
        }
    }
    IFC4X32.IfcSolarDeviceType = IfcSolarDeviceType;
    class IfcSpace extends IfcSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType, ElevationWithFlooring){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.PredefinedType = PredefinedType;
            this.ElevationWithFlooring = ElevationWithFlooring;
            this.type = 3856911033;
        }
    }
    IFC4X32.IfcSpace = IfcSpace;
    class IfcSpaceHeaterType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1305183839;
        }
    }
    IFC4X32.IfcSpaceHeaterType = IfcSpaceHeaterType;
    class IfcSpaceType extends IfcSpatialStructureElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.LongName = LongName;
            this.type = 3812236995;
        }
    }
    IFC4X32.IfcSpaceType = IfcSpaceType;
    class IfcStackTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3112655638;
        }
    }
    IFC4X32.IfcStackTerminalType = IfcStackTerminalType;
    class IfcStairFlightType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1039846685;
        }
    }
    IFC4X32.IfcStairFlightType = IfcStairFlightType;
    class IfcStairType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 338393293;
        }
    }
    IFC4X32.IfcStairType = IfcStairType;
    class IfcStructuralAction extends IfcStructuralActivity {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.type = 682877961;
        }
    }
    IFC4X32.IfcStructuralAction = IfcStructuralAction;
    class IfcStructuralConnection extends IfcStructuralItem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.type = 1179482911;
        }
    }
    IFC4X32.IfcStructuralConnection = IfcStructuralConnection;
    class IfcStructuralCurveAction extends IfcStructuralAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.PredefinedType = PredefinedType;
            this.type = 1004757350;
        }
    }
    IFC4X32.IfcStructuralCurveAction = IfcStructuralCurveAction;
    class IfcStructuralCurveConnection extends IfcStructuralConnection {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, AxisDirection){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.AxisDirection = AxisDirection;
            this.type = 4243806635;
        }
    }
    IFC4X32.IfcStructuralCurveConnection = IfcStructuralCurveConnection;
    class IfcStructuralCurveMember extends IfcStructuralMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Axis = Axis;
            this.type = 214636428;
        }
    }
    IFC4X32.IfcStructuralCurveMember = IfcStructuralCurveMember;
    class IfcStructuralCurveMemberVarying extends IfcStructuralCurveMember {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.Axis = Axis;
            this.type = 2445595289;
        }
    }
    IFC4X32.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;
    class IfcStructuralCurveReaction extends IfcStructuralReaction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.PredefinedType = PredefinedType;
            this.type = 2757150158;
        }
    }
    IFC4X32.IfcStructuralCurveReaction = IfcStructuralCurveReaction;
    class IfcStructuralLinearAction extends IfcStructuralCurveAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.PredefinedType = PredefinedType;
            this.type = 1807405624;
        }
    }
    IFC4X32.IfcStructuralLinearAction = IfcStructuralLinearAction;
    class IfcStructuralLoadGroup extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.ActionType = ActionType;
            this.ActionSource = ActionSource;
            this.Coefficient = Coefficient;
            this.Purpose = Purpose;
            this.type = 1252848954;
        }
    }
    IFC4X32.IfcStructuralLoadGroup = IfcStructuralLoadGroup;
    class IfcStructuralPointAction extends IfcStructuralAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.type = 2082059205;
        }
    }
    IFC4X32.IfcStructuralPointAction = IfcStructuralPointAction;
    class IfcStructuralPointConnection extends IfcStructuralConnection {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, ConditionCoordinateSystem){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.ConditionCoordinateSystem = ConditionCoordinateSystem;
            this.type = 734778138;
        }
    }
    IFC4X32.IfcStructuralPointConnection = IfcStructuralPointConnection;
    class IfcStructuralPointReaction extends IfcStructuralReaction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.type = 1235345126;
        }
    }
    IFC4X32.IfcStructuralPointReaction = IfcStructuralPointReaction;
    class IfcStructuralResultGroup extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.TheoryType = TheoryType;
            this.ResultForLoadGroup = ResultForLoadGroup;
            this.IsLinear = IsLinear;
            this.type = 2986769608;
        }
    }
    IFC4X32.IfcStructuralResultGroup = IfcStructuralResultGroup;
    class IfcStructuralSurfaceAction extends IfcStructuralAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.PredefinedType = PredefinedType;
            this.type = 3657597509;
        }
    }
    IFC4X32.IfcStructuralSurfaceAction = IfcStructuralSurfaceAction;
    class IfcStructuralSurfaceConnection extends IfcStructuralConnection {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedCondition = AppliedCondition;
            this.type = 1975003073;
        }
    }
    IFC4X32.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;
    class IfcSubContractResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 148013059;
        }
    }
    IFC4X32.IfcSubContractResource = IfcSubContractResource;
    class IfcSurfaceFeature extends IfcFeatureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3101698114;
        }
    }
    IFC4X32.IfcSurfaceFeature = IfcSurfaceFeature;
    class IfcSwitchingDeviceType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2315554128;
        }
    }
    IFC4X32.IfcSwitchingDeviceType = IfcSwitchingDeviceType;
    class IfcSystem extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.type = 2254336722;
        }
    }
    IFC4X32.IfcSystem = IfcSystem;
    class IfcSystemFurnitureElement extends IfcFurnishingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 413509423;
        }
    }
    IFC4X32.IfcSystemFurnitureElement = IfcSystemFurnitureElement;
    class IfcTankType extends IfcFlowStorageDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 5716631;
        }
    }
    IFC4X32.IfcTankType = IfcTankType;
    class IfcTendon extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.PredefinedType = PredefinedType;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.TensionForce = TensionForce;
            this.PreStress = PreStress;
            this.FrictionCoefficient = FrictionCoefficient;
            this.AnchorageSlip = AnchorageSlip;
            this.MinCurvatureRadius = MinCurvatureRadius;
            this.type = 3824725483;
        }
    }
    IFC4X32.IfcTendon = IfcTendon;
    class IfcTendonAnchor extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.PredefinedType = PredefinedType;
            this.type = 2347447852;
        }
    }
    IFC4X32.IfcTendonAnchor = IfcTendonAnchor;
    class IfcTendonAnchorType extends IfcReinforcingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3081323446;
        }
    }
    IFC4X32.IfcTendonAnchorType = IfcTendonAnchorType;
    class IfcTendonConduit extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.PredefinedType = PredefinedType;
            this.type = 3663046924;
        }
    }
    IFC4X32.IfcTendonConduit = IfcTendonConduit;
    class IfcTendonConduitType extends IfcReinforcingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2281632017;
        }
    }
    IFC4X32.IfcTendonConduitType = IfcTendonConduitType;
    class IfcTendonType extends IfcReinforcingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, SheathDiameter){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.SheathDiameter = SheathDiameter;
            this.type = 2415094496;
        }
    }
    IFC4X32.IfcTendonType = IfcTendonType;
    class IfcTrackElementType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 618700268;
        }
    }
    IFC4X32.IfcTrackElementType = IfcTrackElementType;
    class IfcTransformerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1692211062;
        }
    }
    IFC4X32.IfcTransformerType = IfcTransformerType;
    class IfcTransportElementType extends IfcTransportationDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2097647324;
        }
    }
    IFC4X32.IfcTransportElementType = IfcTransportElementType;
    class IfcTransportationDevice extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1953115116;
        }
    }
    IFC4X32.IfcTransportationDevice = IfcTransportationDevice;
    class IfcTrimmedCurve extends IfcBoundedCurve {
        constructor(BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation){
            super();
            this.BasisCurve = BasisCurve;
            this.Trim1 = Trim1;
            this.Trim2 = Trim2;
            this.SenseAgreement = SenseAgreement;
            this.MasterRepresentation = MasterRepresentation;
            this.type = 3593883385;
        }
    }
    IFC4X32.IfcTrimmedCurve = IfcTrimmedCurve;
    class IfcTubeBundleType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1600972822;
        }
    }
    IFC4X32.IfcTubeBundleType = IfcTubeBundleType;
    class IfcUnitaryEquipmentType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1911125066;
        }
    }
    IFC4X32.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;
    class IfcValveType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 728799441;
        }
    }
    IFC4X32.IfcValveType = IfcValveType;
    class IfcVehicle extends IfcTransportationDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 840318589;
        }
    }
    IFC4X32.IfcVehicle = IfcVehicle;
    class IfcVibrationDamper extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1530820697;
        }
    }
    IFC4X32.IfcVibrationDamper = IfcVibrationDamper;
    class IfcVibrationDamperType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3956297820;
        }
    }
    IFC4X32.IfcVibrationDamperType = IfcVibrationDamperType;
    class IfcVibrationIsolator extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2391383451;
        }
    }
    IFC4X32.IfcVibrationIsolator = IfcVibrationIsolator;
    class IfcVibrationIsolatorType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3313531582;
        }
    }
    IFC4X32.IfcVibrationIsolatorType = IfcVibrationIsolatorType;
    class IfcVirtualElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2769231204;
        }
    }
    IFC4X32.IfcVirtualElement = IfcVirtualElement;
    class IfcVoidingFeature extends IfcFeatureElementSubtraction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 926996030;
        }
    }
    IFC4X32.IfcVoidingFeature = IfcVoidingFeature;
    class IfcWallType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1898987631;
        }
    }
    IFC4X32.IfcWallType = IfcWallType;
    class IfcWasteTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1133259667;
        }
    }
    IFC4X32.IfcWasteTerminalType = IfcWasteTerminalType;
    class IfcWindowType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, PartitioningType, ParameterTakesPrecedence, UserDefinedPartitioningType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.PartitioningType = PartitioningType;
            this.ParameterTakesPrecedence = ParameterTakesPrecedence;
            this.UserDefinedPartitioningType = UserDefinedPartitioningType;
            this.type = 4009809668;
        }
    }
    IFC4X32.IfcWindowType = IfcWindowType;
    class IfcWorkCalendar extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, WorkingTimes, ExceptionTimes, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.WorkingTimes = WorkingTimes;
            this.ExceptionTimes = ExceptionTimes;
            this.PredefinedType = PredefinedType;
            this.type = 4088093105;
        }
    }
    IFC4X32.IfcWorkCalendar = IfcWorkCalendar;
    class IfcWorkControl extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.CreationDate = CreationDate;
            this.Creators = Creators;
            this.Purpose = Purpose;
            this.Duration = Duration;
            this.TotalFloat = TotalFloat;
            this.StartTime = StartTime;
            this.FinishTime = FinishTime;
            this.type = 1028945134;
        }
    }
    IFC4X32.IfcWorkControl = IfcWorkControl;
    class IfcWorkPlan extends IfcWorkControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.CreationDate = CreationDate;
            this.Creators = Creators;
            this.Purpose = Purpose;
            this.Duration = Duration;
            this.TotalFloat = TotalFloat;
            this.StartTime = StartTime;
            this.FinishTime = FinishTime;
            this.PredefinedType = PredefinedType;
            this.type = 4218914973;
        }
    }
    IFC4X32.IfcWorkPlan = IfcWorkPlan;
    class IfcWorkSchedule extends IfcWorkControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.CreationDate = CreationDate;
            this.Creators = Creators;
            this.Purpose = Purpose;
            this.Duration = Duration;
            this.TotalFloat = TotalFloat;
            this.StartTime = StartTime;
            this.FinishTime = FinishTime;
            this.PredefinedType = PredefinedType;
            this.type = 3342526732;
        }
    }
    IFC4X32.IfcWorkSchedule = IfcWorkSchedule;
    class IfcZone extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.type = 1033361043;
        }
    }
    IFC4X32.IfcZone = IfcZone;
    class IfcActionRequest extends IfcControl {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.PredefinedType = PredefinedType;
            this.Status = Status;
            this.LongDescription = LongDescription;
            this.type = 3821786052;
        }
    }
    IFC4X32.IfcActionRequest = IfcActionRequest;
    class IfcAirTerminalBoxType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1411407467;
        }
    }
    IFC4X32.IfcAirTerminalBoxType = IfcAirTerminalBoxType;
    class IfcAirTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3352864051;
        }
    }
    IFC4X32.IfcAirTerminalType = IfcAirTerminalType;
    class IfcAirToAirHeatRecoveryType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1871374353;
        }
    }
    IFC4X32.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;
    class IfcAlignmentCant extends IfcLinearElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, RailHeadDistance){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.RailHeadDistance = RailHeadDistance;
            this.type = 4266260250;
        }
    }
    IFC4X32.IfcAlignmentCant = IfcAlignmentCant;
    class IfcAlignmentHorizontal extends IfcLinearElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 1545765605;
        }
    }
    IFC4X32.IfcAlignmentHorizontal = IfcAlignmentHorizontal;
    class IfcAlignmentSegment extends IfcLinearElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, DesignParameters){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.DesignParameters = DesignParameters;
            this.type = 317615605;
        }
    }
    IFC4X32.IfcAlignmentSegment = IfcAlignmentSegment;
    class IfcAlignmentVertical extends IfcLinearElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 1662888072;
        }
    }
    IFC4X32.IfcAlignmentVertical = IfcAlignmentVertical;
    class IfcAsset extends IfcGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.OriginalValue = OriginalValue;
            this.CurrentValue = CurrentValue;
            this.TotalReplacementCost = TotalReplacementCost;
            this.Owner = Owner;
            this.User = User;
            this.ResponsiblePerson = ResponsiblePerson;
            this.IncorporationDate = IncorporationDate;
            this.DepreciatedValue = DepreciatedValue;
            this.type = 3460190687;
        }
    }
    IFC4X32.IfcAsset = IfcAsset;
    class IfcAudioVisualApplianceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1532957894;
        }
    }
    IFC4X32.IfcAudioVisualApplianceType = IfcAudioVisualApplianceType;
    class IfcBSplineCurve extends IfcBoundedCurve {
        constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect){
            super();
            this.Degree = Degree;
            this.ControlPointsList = ControlPointsList;
            this.CurveForm = CurveForm;
            this.ClosedCurve = ClosedCurve;
            this.SelfIntersect = SelfIntersect;
            this.type = 1967976161;
        }
    }
    IFC4X32.IfcBSplineCurve = IfcBSplineCurve;
    class IfcBSplineCurveWithKnots extends IfcBSplineCurve {
        constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec){
            super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
            this.Degree = Degree;
            this.ControlPointsList = ControlPointsList;
            this.CurveForm = CurveForm;
            this.ClosedCurve = ClosedCurve;
            this.SelfIntersect = SelfIntersect;
            this.KnotMultiplicities = KnotMultiplicities;
            this.Knots = Knots;
            this.KnotSpec = KnotSpec;
            this.type = 2461110595;
        }
    }
    IFC4X32.IfcBSplineCurveWithKnots = IfcBSplineCurveWithKnots;
    class IfcBeamType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 819618141;
        }
    }
    IFC4X32.IfcBeamType = IfcBeamType;
    class IfcBearingType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3649138523;
        }
    }
    IFC4X32.IfcBearingType = IfcBearingType;
    class IfcBoilerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 231477066;
        }
    }
    IFC4X32.IfcBoilerType = IfcBoilerType;
    class IfcBoundaryCurve extends IfcCompositeCurveOnSurface {
        constructor(Segments, SelfIntersect){
            super(Segments, SelfIntersect);
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 1136057603;
        }
    }
    IFC4X32.IfcBoundaryCurve = IfcBoundaryCurve;
    class IfcBridge extends IfcFacility {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.PredefinedType = PredefinedType;
            this.type = 644574406;
        }
    }
    IFC4X32.IfcBridge = IfcBridge;
    class IfcBridgePart extends IfcFacilityPart {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.UsageType = UsageType;
            this.PredefinedType = PredefinedType;
            this.type = 963979645;
        }
    }
    IFC4X32.IfcBridgePart = IfcBridgePart;
    class IfcBuilding extends IfcFacility {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.CompositionType = CompositionType;
            this.ElevationOfRefHeight = ElevationOfRefHeight;
            this.ElevationOfTerrain = ElevationOfTerrain;
            this.BuildingAddress = BuildingAddress;
            this.type = 4031249490;
        }
    }
    IFC4X32.IfcBuilding = IfcBuilding;
    class IfcBuildingElementPart extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2979338954;
        }
    }
    IFC4X32.IfcBuildingElementPart = IfcBuildingElementPart;
    class IfcBuildingElementPartType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 39481116;
        }
    }
    IFC4X32.IfcBuildingElementPartType = IfcBuildingElementPartType;
    class IfcBuildingElementProxyType extends IfcBuiltElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1909888760;
        }
    }
    IFC4X32.IfcBuildingElementProxyType = IfcBuildingElementProxyType;
    class IfcBuildingSystem extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.LongName = LongName;
            this.type = 1177604601;
        }
    }
    IFC4X32.IfcBuildingSystem = IfcBuildingSystem;
    class IfcBuiltElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1876633798;
        }
    }
    IFC4X32.IfcBuiltElement = IfcBuiltElement;
    class IfcBuiltSystem extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.LongName = LongName;
            this.type = 3862327254;
        }
    }
    IFC4X32.IfcBuiltSystem = IfcBuiltSystem;
    class IfcBurnerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2188180465;
        }
    }
    IFC4X32.IfcBurnerType = IfcBurnerType;
    class IfcCableCarrierFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 395041908;
        }
    }
    IFC4X32.IfcCableCarrierFittingType = IfcCableCarrierFittingType;
    class IfcCableCarrierSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3293546465;
        }
    }
    IFC4X32.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;
    class IfcCableFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2674252688;
        }
    }
    IFC4X32.IfcCableFittingType = IfcCableFittingType;
    class IfcCableSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1285652485;
        }
    }
    IFC4X32.IfcCableSegmentType = IfcCableSegmentType;
    class IfcCaissonFoundationType extends IfcDeepFoundationType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3203706013;
        }
    }
    IFC4X32.IfcCaissonFoundationType = IfcCaissonFoundationType;
    class IfcChillerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2951183804;
        }
    }
    IFC4X32.IfcChillerType = IfcChillerType;
    class IfcChimney extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3296154744;
        }
    }
    IFC4X32.IfcChimney = IfcChimney;
    class IfcCircle extends IfcConic {
        constructor(Position, Radius){
            super(Position);
            this.Position = Position;
            this.Radius = Radius;
            this.type = 2611217952;
        }
    }
    IFC4X32.IfcCircle = IfcCircle;
    class IfcCivilElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1677625105;
        }
    }
    IFC4X32.IfcCivilElement = IfcCivilElement;
    class IfcCoilType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2301859152;
        }
    }
    IFC4X32.IfcCoilType = IfcCoilType;
    class IfcColumn extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 843113511;
        }
    }
    IFC4X32.IfcColumn = IfcColumn;
    class IfcCommunicationsApplianceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 400855858;
        }
    }
    IFC4X32.IfcCommunicationsApplianceType = IfcCommunicationsApplianceType;
    class IfcCompressorType extends IfcFlowMovingDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3850581409;
        }
    }
    IFC4X32.IfcCompressorType = IfcCompressorType;
    class IfcCondenserType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2816379211;
        }
    }
    IFC4X32.IfcCondenserType = IfcCondenserType;
    class IfcConstructionEquipmentResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 3898045240;
        }
    }
    IFC4X32.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;
    class IfcConstructionMaterialResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 1060000209;
        }
    }
    IFC4X32.IfcConstructionMaterialResource = IfcConstructionMaterialResource;
    class IfcConstructionProductResource extends IfcConstructionResource {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.Identification = Identification;
            this.LongDescription = LongDescription;
            this.Usage = Usage;
            this.BaseCosts = BaseCosts;
            this.BaseQuantity = BaseQuantity;
            this.PredefinedType = PredefinedType;
            this.type = 488727124;
        }
    }
    IFC4X32.IfcConstructionProductResource = IfcConstructionProductResource;
    class IfcConveyorSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2940368186;
        }
    }
    IFC4X32.IfcConveyorSegmentType = IfcConveyorSegmentType;
    class IfcCooledBeamType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 335055490;
        }
    }
    IFC4X32.IfcCooledBeamType = IfcCooledBeamType;
    class IfcCoolingTowerType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2954562838;
        }
    }
    IFC4X32.IfcCoolingTowerType = IfcCoolingTowerType;
    class IfcCourse extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1502416096;
        }
    }
    IFC4X32.IfcCourse = IfcCourse;
    class IfcCovering extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1973544240;
        }
    }
    IFC4X32.IfcCovering = IfcCovering;
    class IfcCurtainWall extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3495092785;
        }
    }
    IFC4X32.IfcCurtainWall = IfcCurtainWall;
    class IfcDamperType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3961806047;
        }
    }
    IFC4X32.IfcDamperType = IfcDamperType;
    class IfcDeepFoundation extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3426335179;
        }
    }
    IFC4X32.IfcDeepFoundation = IfcDeepFoundation;
    class IfcDiscreteAccessory extends IfcElementComponent {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1335981549;
        }
    }
    IFC4X32.IfcDiscreteAccessory = IfcDiscreteAccessory;
    class IfcDiscreteAccessoryType extends IfcElementComponentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2635815018;
        }
    }
    IFC4X32.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;
    class IfcDistributionBoardType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 479945903;
        }
    }
    IFC4X32.IfcDistributionBoardType = IfcDistributionBoardType;
    class IfcDistributionChamberElementType extends IfcDistributionFlowElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1599208980;
        }
    }
    IFC4X32.IfcDistributionChamberElementType = IfcDistributionChamberElementType;
    class IfcDistributionControlElementType extends IfcDistributionElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.type = 2063403501;
        }
    }
    IFC4X32.IfcDistributionControlElementType = IfcDistributionControlElementType;
    class IfcDistributionElement extends IfcElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1945004755;
        }
    }
    IFC4X32.IfcDistributionElement = IfcDistributionElement;
    class IfcDistributionFlowElement extends IfcDistributionElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3040386961;
        }
    }
    IFC4X32.IfcDistributionFlowElement = IfcDistributionFlowElement;
    class IfcDistributionPort extends IfcPort {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection, PredefinedType, SystemType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.FlowDirection = FlowDirection;
            this.PredefinedType = PredefinedType;
            this.SystemType = SystemType;
            this.type = 3041715199;
        }
    }
    IFC4X32.IfcDistributionPort = IfcDistributionPort;
    class IfcDistributionSystem extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.PredefinedType = PredefinedType;
            this.type = 3205830791;
        }
    }
    IFC4X32.IfcDistributionSystem = IfcDistributionSystem;
    class IfcDoor extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.OverallHeight = OverallHeight;
            this.OverallWidth = OverallWidth;
            this.PredefinedType = PredefinedType;
            this.OperationType = OperationType;
            this.UserDefinedOperationType = UserDefinedOperationType;
            this.type = 395920057;
        }
    }
    IFC4X32.IfcDoor = IfcDoor;
    class IfcDuctFittingType extends IfcFlowFittingType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 869906466;
        }
    }
    IFC4X32.IfcDuctFittingType = IfcDuctFittingType;
    class IfcDuctSegmentType extends IfcFlowSegmentType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3760055223;
        }
    }
    IFC4X32.IfcDuctSegmentType = IfcDuctSegmentType;
    class IfcDuctSilencerType extends IfcFlowTreatmentDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2030761528;
        }
    }
    IFC4X32.IfcDuctSilencerType = IfcDuctSilencerType;
    class IfcEarthworksCut extends IfcFeatureElementSubtraction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3071239417;
        }
    }
    IFC4X32.IfcEarthworksCut = IfcEarthworksCut;
    class IfcEarthworksElement extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1077100507;
        }
    }
    IFC4X32.IfcEarthworksElement = IfcEarthworksElement;
    class IfcEarthworksFill extends IfcEarthworksElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3376911765;
        }
    }
    IFC4X32.IfcEarthworksFill = IfcEarthworksFill;
    class IfcElectricApplianceType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 663422040;
        }
    }
    IFC4X32.IfcElectricApplianceType = IfcElectricApplianceType;
    class IfcElectricDistributionBoardType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2417008758;
        }
    }
    IFC4X32.IfcElectricDistributionBoardType = IfcElectricDistributionBoardType;
    class IfcElectricFlowStorageDeviceType extends IfcFlowStorageDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3277789161;
        }
    }
    IFC4X32.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;
    class IfcElectricFlowTreatmentDeviceType extends IfcFlowTreatmentDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2142170206;
        }
    }
    IFC4X32.IfcElectricFlowTreatmentDeviceType = IfcElectricFlowTreatmentDeviceType;
    class IfcElectricGeneratorType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1534661035;
        }
    }
    IFC4X32.IfcElectricGeneratorType = IfcElectricGeneratorType;
    class IfcElectricMotorType extends IfcEnergyConversionDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1217240411;
        }
    }
    IFC4X32.IfcElectricMotorType = IfcElectricMotorType;
    class IfcElectricTimeControlType extends IfcFlowControllerType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 712377611;
        }
    }
    IFC4X32.IfcElectricTimeControlType = IfcElectricTimeControlType;
    class IfcEnergyConversionDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1658829314;
        }
    }
    IFC4X32.IfcEnergyConversionDevice = IfcEnergyConversionDevice;
    class IfcEngine extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2814081492;
        }
    }
    IFC4X32.IfcEngine = IfcEngine;
    class IfcEvaporativeCooler extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3747195512;
        }
    }
    IFC4X32.IfcEvaporativeCooler = IfcEvaporativeCooler;
    class IfcEvaporator extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 484807127;
        }
    }
    IFC4X32.IfcEvaporator = IfcEvaporator;
    class IfcExternalSpatialElement extends IfcExternalSpatialStructureElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.LongName = LongName;
            this.PredefinedType = PredefinedType;
            this.type = 1209101575;
        }
    }
    IFC4X32.IfcExternalSpatialElement = IfcExternalSpatialElement;
    class IfcFanType extends IfcFlowMovingDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 346874300;
        }
    }
    IFC4X32.IfcFanType = IfcFanType;
    class IfcFilterType extends IfcFlowTreatmentDeviceType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1810631287;
        }
    }
    IFC4X32.IfcFilterType = IfcFilterType;
    class IfcFireSuppressionTerminalType extends IfcFlowTerminalType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4222183408;
        }
    }
    IFC4X32.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;
    class IfcFlowController extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2058353004;
        }
    }
    IFC4X32.IfcFlowController = IfcFlowController;
    class IfcFlowFitting extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 4278956645;
        }
    }
    IFC4X32.IfcFlowFitting = IfcFlowFitting;
    class IfcFlowInstrumentType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 4037862832;
        }
    }
    IFC4X32.IfcFlowInstrumentType = IfcFlowInstrumentType;
    class IfcFlowMeter extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2188021234;
        }
    }
    IFC4X32.IfcFlowMeter = IfcFlowMeter;
    class IfcFlowMovingDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3132237377;
        }
    }
    IFC4X32.IfcFlowMovingDevice = IfcFlowMovingDevice;
    class IfcFlowSegment extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 987401354;
        }
    }
    IFC4X32.IfcFlowSegment = IfcFlowSegment;
    class IfcFlowStorageDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 707683696;
        }
    }
    IFC4X32.IfcFlowStorageDevice = IfcFlowStorageDevice;
    class IfcFlowTerminal extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2223149337;
        }
    }
    IFC4X32.IfcFlowTerminal = IfcFlowTerminal;
    class IfcFlowTreatmentDevice extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3508470533;
        }
    }
    IFC4X32.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;
    class IfcFooting extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 900683007;
        }
    }
    IFC4X32.IfcFooting = IfcFooting;
    class IfcGeotechnicalAssembly extends IfcGeotechnicalElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2713699986;
        }
    }
    IFC4X32.IfcGeotechnicalAssembly = IfcGeotechnicalAssembly;
    class IfcGrid extends IfcPositioningElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.UAxes = UAxes;
            this.VAxes = VAxes;
            this.WAxes = WAxes;
            this.PredefinedType = PredefinedType;
            this.type = 3009204131;
        }
    }
    IFC4X32.IfcGrid = IfcGrid;
    class IfcHeatExchanger extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3319311131;
        }
    }
    IFC4X32.IfcHeatExchanger = IfcHeatExchanger;
    class IfcHumidifier extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2068733104;
        }
    }
    IFC4X32.IfcHumidifier = IfcHumidifier;
    class IfcInterceptor extends IfcFlowTreatmentDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4175244083;
        }
    }
    IFC4X32.IfcInterceptor = IfcInterceptor;
    class IfcJunctionBox extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2176052936;
        }
    }
    IFC4X32.IfcJunctionBox = IfcJunctionBox;
    class IfcKerb extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2696325953;
        }
    }
    IFC4X32.IfcKerb = IfcKerb;
    class IfcLamp extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 76236018;
        }
    }
    IFC4X32.IfcLamp = IfcLamp;
    class IfcLightFixture extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 629592764;
        }
    }
    IFC4X32.IfcLightFixture = IfcLightFixture;
    class IfcLinearPositioningElement extends IfcPositioningElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.type = 1154579445;
        }
    }
    IFC4X32.IfcLinearPositioningElement = IfcLinearPositioningElement;
    class IfcLiquidTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1638804497;
        }
    }
    IFC4X32.IfcLiquidTerminal = IfcLiquidTerminal;
    class IfcMedicalDevice extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1437502449;
        }
    }
    IFC4X32.IfcMedicalDevice = IfcMedicalDevice;
    class IfcMember extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1073191201;
        }
    }
    IFC4X32.IfcMember = IfcMember;
    class IfcMobileTelecommunicationsAppliance extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2078563270;
        }
    }
    IFC4X32.IfcMobileTelecommunicationsAppliance = IfcMobileTelecommunicationsAppliance;
    class IfcMooringDevice extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 234836483;
        }
    }
    IFC4X32.IfcMooringDevice = IfcMooringDevice;
    class IfcMotorConnection extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2474470126;
        }
    }
    IFC4X32.IfcMotorConnection = IfcMotorConnection;
    class IfcNavigationElement extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2182337498;
        }
    }
    IFC4X32.IfcNavigationElement = IfcNavigationElement;
    class IfcOuterBoundaryCurve extends IfcBoundaryCurve {
        constructor(Segments, SelfIntersect){
            super(Segments, SelfIntersect);
            this.Segments = Segments;
            this.SelfIntersect = SelfIntersect;
            this.type = 144952367;
        }
    }
    IFC4X32.IfcOuterBoundaryCurve = IfcOuterBoundaryCurve;
    class IfcOutlet extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3694346114;
        }
    }
    IFC4X32.IfcOutlet = IfcOutlet;
    class IfcPavement extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1383356374;
        }
    }
    IFC4X32.IfcPavement = IfcPavement;
    class IfcPile extends IfcDeepFoundation {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.ConstructionType = ConstructionType;
            this.type = 1687234759;
        }
    }
    IFC4X32.IfcPile = IfcPile;
    class IfcPipeFitting extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 310824031;
        }
    }
    IFC4X32.IfcPipeFitting = IfcPipeFitting;
    class IfcPipeSegment extends IfcFlowSegment {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3612865200;
        }
    }
    IFC4X32.IfcPipeSegment = IfcPipeSegment;
    class IfcPlate extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3171933400;
        }
    }
    IFC4X32.IfcPlate = IfcPlate;
    class IfcProtectiveDevice extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 738039164;
        }
    }
    IFC4X32.IfcProtectiveDevice = IfcProtectiveDevice;
    class IfcProtectiveDeviceTrippingUnitType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 655969474;
        }
    }
    IFC4X32.IfcProtectiveDeviceTrippingUnitType = IfcProtectiveDeviceTrippingUnitType;
    class IfcPump extends IfcFlowMovingDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 90941305;
        }
    }
    IFC4X32.IfcPump = IfcPump;
    class IfcRail extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3290496277;
        }
    }
    IFC4X32.IfcRail = IfcRail;
    class IfcRailing extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2262370178;
        }
    }
    IFC4X32.IfcRailing = IfcRailing;
    class IfcRamp extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3024970846;
        }
    }
    IFC4X32.IfcRamp = IfcRamp;
    class IfcRampFlight extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3283111854;
        }
    }
    IFC4X32.IfcRampFlight = IfcRampFlight;
    class IfcRationalBSplineCurveWithKnots extends IfcBSplineCurveWithKnots {
        constructor(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec, WeightsData){
            super(Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec);
            this.Degree = Degree;
            this.ControlPointsList = ControlPointsList;
            this.CurveForm = CurveForm;
            this.ClosedCurve = ClosedCurve;
            this.SelfIntersect = SelfIntersect;
            this.KnotMultiplicities = KnotMultiplicities;
            this.Knots = Knots;
            this.KnotSpec = KnotSpec;
            this.WeightsData = WeightsData;
            this.type = 1232101972;
        }
    }
    IFC4X32.IfcRationalBSplineCurveWithKnots = IfcRationalBSplineCurveWithKnots;
    class IfcReinforcedSoil extends IfcEarthworksElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3798194928;
        }
    }
    IFC4X32.IfcReinforcedSoil = IfcReinforcedSoil;
    class IfcReinforcingBar extends IfcReinforcingElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, PredefinedType, BarSurface){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.SteelGrade = SteelGrade;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.BarLength = BarLength;
            this.PredefinedType = PredefinedType;
            this.BarSurface = BarSurface;
            this.type = 979691226;
        }
    }
    IFC4X32.IfcReinforcingBar = IfcReinforcingBar;
    class IfcReinforcingBarType extends IfcReinforcingElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, BarLength, BarSurface, BendingShapeCode, BendingParameters){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.NominalDiameter = NominalDiameter;
            this.CrossSectionArea = CrossSectionArea;
            this.BarLength = BarLength;
            this.BarSurface = BarSurface;
            this.BendingShapeCode = BendingShapeCode;
            this.BendingParameters = BendingParameters;
            this.type = 2572171363;
        }
    }
    IFC4X32.IfcReinforcingBarType = IfcReinforcingBarType;
    class IfcRoof extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2016517767;
        }
    }
    IFC4X32.IfcRoof = IfcRoof;
    class IfcSanitaryTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3053780830;
        }
    }
    IFC4X32.IfcSanitaryTerminal = IfcSanitaryTerminal;
    class IfcSensorType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 1783015770;
        }
    }
    IFC4X32.IfcSensorType = IfcSensorType;
    class IfcShadingDevice extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1329646415;
        }
    }
    IFC4X32.IfcShadingDevice = IfcShadingDevice;
    class IfcSignal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 991950508;
        }
    }
    IFC4X32.IfcSignal = IfcSignal;
    class IfcSlab extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1529196076;
        }
    }
    IFC4X32.IfcSlab = IfcSlab;
    class IfcSolarDevice extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3420628829;
        }
    }
    IFC4X32.IfcSolarDevice = IfcSolarDevice;
    class IfcSpaceHeater extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1999602285;
        }
    }
    IFC4X32.IfcSpaceHeater = IfcSpaceHeater;
    class IfcStackTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1404847402;
        }
    }
    IFC4X32.IfcStackTerminal = IfcStackTerminal;
    class IfcStair extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 331165859;
        }
    }
    IFC4X32.IfcStair = IfcStair;
    class IfcStairFlight extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRisers, NumberOfTreads, RiserHeight, TreadLength, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.NumberOfRisers = NumberOfRisers;
            this.NumberOfTreads = NumberOfTreads;
            this.RiserHeight = RiserHeight;
            this.TreadLength = TreadLength;
            this.PredefinedType = PredefinedType;
            this.type = 4252922144;
        }
    }
    IFC4X32.IfcStairFlight = IfcStairFlight;
    class IfcStructuralAnalysisModel extends IfcSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults, SharedPlacement){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.OrientationOf2DPlane = OrientationOf2DPlane;
            this.LoadedBy = LoadedBy;
            this.HasResults = HasResults;
            this.SharedPlacement = SharedPlacement;
            this.type = 2515109513;
        }
    }
    IFC4X32.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;
    class IfcStructuralLoadCase extends IfcStructuralLoadGroup {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose, SelfWeightCoefficients){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.PredefinedType = PredefinedType;
            this.ActionType = ActionType;
            this.ActionSource = ActionSource;
            this.Coefficient = Coefficient;
            this.Purpose = Purpose;
            this.SelfWeightCoefficients = SelfWeightCoefficients;
            this.type = 385403989;
        }
    }
    IFC4X32.IfcStructuralLoadCase = IfcStructuralLoadCase;
    class IfcStructuralPlanarAction extends IfcStructuralSurfaceAction {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.AppliedLoad = AppliedLoad;
            this.GlobalOrLocal = GlobalOrLocal;
            this.DestabilizingLoad = DestabilizingLoad;
            this.ProjectedOrTrue = ProjectedOrTrue;
            this.PredefinedType = PredefinedType;
            this.type = 1621171031;
        }
    }
    IFC4X32.IfcStructuralPlanarAction = IfcStructuralPlanarAction;
    class IfcSwitchingDevice extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1162798199;
        }
    }
    IFC4X32.IfcSwitchingDevice = IfcSwitchingDevice;
    class IfcTank extends IfcFlowStorageDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 812556717;
        }
    }
    IFC4X32.IfcTank = IfcTank;
    class IfcTrackElement extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3425753595;
        }
    }
    IFC4X32.IfcTrackElement = IfcTrackElement;
    class IfcTransformer extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3825984169;
        }
    }
    IFC4X32.IfcTransformer = IfcTransformer;
    class IfcTransportElement extends IfcTransportationDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1620046519;
        }
    }
    IFC4X32.IfcTransportElement = IfcTransportElement;
    class IfcTubeBundle extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3026737570;
        }
    }
    IFC4X32.IfcTubeBundle = IfcTubeBundle;
    class IfcUnitaryControlElementType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3179687236;
        }
    }
    IFC4X32.IfcUnitaryControlElementType = IfcUnitaryControlElementType;
    class IfcUnitaryEquipment extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4292641817;
        }
    }
    IFC4X32.IfcUnitaryEquipment = IfcUnitaryEquipment;
    class IfcValve extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4207607924;
        }
    }
    IFC4X32.IfcValve = IfcValve;
    class IfcWall extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2391406946;
        }
    }
    IFC4X32.IfcWall = IfcWall;
    class IfcWallStandardCase extends IfcWall {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3512223829;
        }
    }
    IFC4X32.IfcWallStandardCase = IfcWallStandardCase;
    class IfcWasteTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4237592921;
        }
    }
    IFC4X32.IfcWasteTerminal = IfcWasteTerminal;
    class IfcWindow extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.OverallHeight = OverallHeight;
            this.OverallWidth = OverallWidth;
            this.PredefinedType = PredefinedType;
            this.PartitioningType = PartitioningType;
            this.UserDefinedPartitioningType = UserDefinedPartitioningType;
            this.type = 3304561284;
        }
    }
    IFC4X32.IfcWindow = IfcWindow;
    class IfcActuatorType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 2874132201;
        }
    }
    IFC4X32.IfcActuatorType = IfcActuatorType;
    class IfcAirTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1634111441;
        }
    }
    IFC4X32.IfcAirTerminal = IfcAirTerminal;
    class IfcAirTerminalBox extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 177149247;
        }
    }
    IFC4X32.IfcAirTerminalBox = IfcAirTerminalBox;
    class IfcAirToAirHeatRecovery extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2056796094;
        }
    }
    IFC4X32.IfcAirToAirHeatRecovery = IfcAirToAirHeatRecovery;
    class IfcAlarmType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 3001207471;
        }
    }
    IFC4X32.IfcAlarmType = IfcAlarmType;
    class IfcAlignment extends IfcLinearPositioningElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.PredefinedType = PredefinedType;
            this.type = 325726236;
        }
    }
    IFC4X32.IfcAlignment = IfcAlignment;
    class IfcAudioVisualAppliance extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 277319702;
        }
    }
    IFC4X32.IfcAudioVisualAppliance = IfcAudioVisualAppliance;
    class IfcBeam extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 753842376;
        }
    }
    IFC4X32.IfcBeam = IfcBeam;
    class IfcBearing extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4196446775;
        }
    }
    IFC4X32.IfcBearing = IfcBearing;
    class IfcBoiler extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 32344328;
        }
    }
    IFC4X32.IfcBoiler = IfcBoiler;
    class IfcBorehole extends IfcGeotechnicalAssembly {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 3314249567;
        }
    }
    IFC4X32.IfcBorehole = IfcBorehole;
    class IfcBuildingElementProxy extends IfcBuiltElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1095909175;
        }
    }
    IFC4X32.IfcBuildingElementProxy = IfcBuildingElementProxy;
    class IfcBurner extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2938176219;
        }
    }
    IFC4X32.IfcBurner = IfcBurner;
    class IfcCableCarrierFitting extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 635142910;
        }
    }
    IFC4X32.IfcCableCarrierFitting = IfcCableCarrierFitting;
    class IfcCableCarrierSegment extends IfcFlowSegment {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3758799889;
        }
    }
    IFC4X32.IfcCableCarrierSegment = IfcCableCarrierSegment;
    class IfcCableFitting extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1051757585;
        }
    }
    IFC4X32.IfcCableFitting = IfcCableFitting;
    class IfcCableSegment extends IfcFlowSegment {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4217484030;
        }
    }
    IFC4X32.IfcCableSegment = IfcCableSegment;
    class IfcCaissonFoundation extends IfcDeepFoundation {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3999819293;
        }
    }
    IFC4X32.IfcCaissonFoundation = IfcCaissonFoundation;
    class IfcChiller extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3902619387;
        }
    }
    IFC4X32.IfcChiller = IfcChiller;
    class IfcCoil extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 639361253;
        }
    }
    IFC4X32.IfcCoil = IfcCoil;
    class IfcCommunicationsAppliance extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3221913625;
        }
    }
    IFC4X32.IfcCommunicationsAppliance = IfcCommunicationsAppliance;
    class IfcCompressor extends IfcFlowMovingDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3571504051;
        }
    }
    IFC4X32.IfcCompressor = IfcCompressor;
    class IfcCondenser extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2272882330;
        }
    }
    IFC4X32.IfcCondenser = IfcCondenser;
    class IfcControllerType extends IfcDistributionControlElementType {
        constructor(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ApplicableOccurrence = ApplicableOccurrence;
            this.HasPropertySets = HasPropertySets;
            this.RepresentationMaps = RepresentationMaps;
            this.Tag = Tag;
            this.ElementType = ElementType;
            this.PredefinedType = PredefinedType;
            this.type = 578613899;
        }
    }
    IFC4X32.IfcControllerType = IfcControllerType;
    class IfcConveyorSegment extends IfcFlowSegment {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3460952963;
        }
    }
    IFC4X32.IfcConveyorSegment = IfcConveyorSegment;
    class IfcCooledBeam extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4136498852;
        }
    }
    IFC4X32.IfcCooledBeam = IfcCooledBeam;
    class IfcCoolingTower extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3640358203;
        }
    }
    IFC4X32.IfcCoolingTower = IfcCoolingTower;
    class IfcDamper extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4074379575;
        }
    }
    IFC4X32.IfcDamper = IfcDamper;
    class IfcDistributionBoard extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3693000487;
        }
    }
    IFC4X32.IfcDistributionBoard = IfcDistributionBoard;
    class IfcDistributionChamberElement extends IfcDistributionFlowElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1052013943;
        }
    }
    IFC4X32.IfcDistributionChamberElement = IfcDistributionChamberElement;
    class IfcDistributionCircuit extends IfcDistributionSystem {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.LongName = LongName;
            this.PredefinedType = PredefinedType;
            this.type = 562808652;
        }
    }
    IFC4X32.IfcDistributionCircuit = IfcDistributionCircuit;
    class IfcDistributionControlElement extends IfcDistributionElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1062813311;
        }
    }
    IFC4X32.IfcDistributionControlElement = IfcDistributionControlElement;
    class IfcDuctFitting extends IfcFlowFitting {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 342316401;
        }
    }
    IFC4X32.IfcDuctFitting = IfcDuctFitting;
    class IfcDuctSegment extends IfcFlowSegment {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3518393246;
        }
    }
    IFC4X32.IfcDuctSegment = IfcDuctSegment;
    class IfcDuctSilencer extends IfcFlowTreatmentDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1360408905;
        }
    }
    IFC4X32.IfcDuctSilencer = IfcDuctSilencer;
    class IfcElectricAppliance extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1904799276;
        }
    }
    IFC4X32.IfcElectricAppliance = IfcElectricAppliance;
    class IfcElectricDistributionBoard extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 862014818;
        }
    }
    IFC4X32.IfcElectricDistributionBoard = IfcElectricDistributionBoard;
    class IfcElectricFlowStorageDevice extends IfcFlowStorageDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3310460725;
        }
    }
    IFC4X32.IfcElectricFlowStorageDevice = IfcElectricFlowStorageDevice;
    class IfcElectricFlowTreatmentDevice extends IfcFlowTreatmentDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 24726584;
        }
    }
    IFC4X32.IfcElectricFlowTreatmentDevice = IfcElectricFlowTreatmentDevice;
    class IfcElectricGenerator extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 264262732;
        }
    }
    IFC4X32.IfcElectricGenerator = IfcElectricGenerator;
    class IfcElectricMotor extends IfcEnergyConversionDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 402227799;
        }
    }
    IFC4X32.IfcElectricMotor = IfcElectricMotor;
    class IfcElectricTimeControl extends IfcFlowController {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1003880860;
        }
    }
    IFC4X32.IfcElectricTimeControl = IfcElectricTimeControl;
    class IfcFan extends IfcFlowMovingDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3415622556;
        }
    }
    IFC4X32.IfcFan = IfcFan;
    class IfcFilter extends IfcFlowTreatmentDevice {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 819412036;
        }
    }
    IFC4X32.IfcFilter = IfcFilter;
    class IfcFireSuppressionTerminal extends IfcFlowTerminal {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 1426591983;
        }
    }
    IFC4X32.IfcFireSuppressionTerminal = IfcFireSuppressionTerminal;
    class IfcFlowInstrument extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 182646315;
        }
    }
    IFC4X32.IfcFlowInstrument = IfcFlowInstrument;
    class IfcGeomodel extends IfcGeotechnicalAssembly {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 2680139844;
        }
    }
    IFC4X32.IfcGeomodel = IfcGeomodel;
    class IfcGeoslice extends IfcGeotechnicalAssembly {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.type = 1971632696;
        }
    }
    IFC4X32.IfcGeoslice = IfcGeoslice;
    class IfcProtectiveDeviceTrippingUnit extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 2295281155;
        }
    }
    IFC4X32.IfcProtectiveDeviceTrippingUnit = IfcProtectiveDeviceTrippingUnit;
    class IfcSensor extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4086658281;
        }
    }
    IFC4X32.IfcSensor = IfcSensor;
    class IfcUnitaryControlElement extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 630975310;
        }
    }
    IFC4X32.IfcUnitaryControlElement = IfcUnitaryControlElement;
    class IfcActuator extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 4288193352;
        }
    }
    IFC4X32.IfcActuator = IfcActuator;
    class IfcAlarm extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 3087945054;
        }
    }
    IFC4X32.IfcAlarm = IfcAlarm;
    class IfcController extends IfcDistributionControlElement {
        constructor(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType){
            super(GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
            this.GlobalId = GlobalId;
            this.OwnerHistory = OwnerHistory;
            this.Name = Name;
            this.Description = Description;
            this.ObjectType = ObjectType;
            this.ObjectPlacement = ObjectPlacement;
            this.Representation = Representation;
            this.Tag = Tag;
            this.PredefinedType = PredefinedType;
            this.type = 25142252;
        }
    }
    IFC4X32.IfcController = IfcController;
})($3b8da494b8e92f36$export$80d8bc28a624d324 || ($3b8da494b8e92f36$export$80d8bc28a624d324 = {}));
// dist/helpers/properties.ts
var $3b8da494b8e92f36$var$PropsNames = {
    aggregates: {
        name: $3b8da494b8e92f36$export$cff3fa05b2018b59,
        relating: "RelatingObject",
        related: "RelatedObjects",
        key: "children"
    },
    spatial: {
        name: $3b8da494b8e92f36$export$b933598a67b23044,
        relating: "RelatingStructure",
        related: "RelatedElements",
        key: "children"
    },
    psets: {
        name: $3b8da494b8e92f36$export$bc9bd707c4403985,
        relating: "RelatingPropertyDefinition",
        related: "RelatedObjects",
        key: "IsDefinedBy"
    },
    materials: {
        name: $3b8da494b8e92f36$export$90569318bbf3a5cb,
        relating: "RelatingMaterial",
        related: "RelatedObjects",
        key: "HasAssociations"
    },
    type: {
        name: $3b8da494b8e92f36$export$813f9cf6a2209fec,
        relating: "RelatingType",
        related: "RelatedObjects",
        key: "IsDefinedBy"
    }
};
var $3b8da494b8e92f36$export$8714badcfa4caafb = class _Properties {
    /** @ignore */ constructor(api){
        this.api = api;
    }
    /**
   * 
   * @param modelID model handle
   * @param id  expressID of IfcElement
   * @param recursive default false, if true get all nested properties recursively
   * @param inverse default false, if true get all inverse properties recursively
   * @returns IfcElement
   */ async getItemProperties(modelID, id, recursive = false, inverse = false) {
        return this.api.GetLine(modelID, id, recursive, inverse);
    }
    /**
   * Get IfcPropertySets of IfcElements
   * @param modelID model handle
   * @param elementID expressID of IfcElement, default 0 (all psets in model)
   * @param recursive default false, if true get all nested properties recursively
   * @returns array of IfcElements inheriting from IfcPropertySetDefinition
   */ async getPropertySets(modelID, elementID = 0, recursive = false, includeTypeProperties = false) {
        if (includeTypeProperties) {
            let types = await this.getTypeProperties(modelID, elementID, false);
            let results = [];
            for (let t of types)results.push(...await this.getPropertySets(modelID, t.expressID, recursive));
            return results;
        } else return await this.getRelatedProperties(modelID, elementID, $3b8da494b8e92f36$var$PropsNames.psets, recursive);
    }
    /**
   * Set IfcRelDefinesByProperties relations of IfcElements and IfcPropertySets
   * @param modelID model handle
   * @param elementID expressID or array of expressIDs of IfcElements
   * @param psetID expressID or array of expressIDs of IfcPropertySets
   * @returns true if success or false if error
   */ async setPropertySets(modelID, elementID, psetID) {
        return this.setItemProperties(modelID, elementID, psetID, $3b8da494b8e92f36$var$PropsNames.psets);
    }
    /**
   * Get TypeObject of IfcElements
   * @param modelID model handle
   * @param elementID expressID of IfcElement, default 0 (all type objects in model)
   * @param recursive default false, if true get all nested properties of the type object recursively
   * @returns array of objects inheriting from IfcTypeObject
   */ async getTypeProperties(modelID, elementID = 0, recursive = false) {
        if (this.api.GetModelSchema(modelID) == "IFC2X3") return await this.getRelatedProperties(modelID, elementID, $3b8da494b8e92f36$var$PropsNames.type, recursive);
        else return await this.getRelatedProperties(modelID, elementID, {
            ...$3b8da494b8e92f36$var$PropsNames.type,
            key: "IsTypedBy"
        }, recursive);
    }
    /**
   * Get materials of IfcElement
   * @param modelID model handle
   * @param elementID expressID of IfcElement, default 0 (all materials in model)
   * @param recursive default false, if true get all nested properties recursively
   * @returns array of IfcElements inheriting from IfcMaterialDefinition
   */ async getMaterialsProperties(modelID, elementID = 0, recursive = false, includeTypeMaterials = false) {
        if (includeTypeMaterials) {
            let types = await this.getTypeProperties(modelID, elementID, false);
            let results = [];
            for (let t of types)results.push(...await this.getMaterialsProperties(modelID, t.expressID, recursive));
            return results;
        } else return await this.getRelatedProperties(modelID, elementID, $3b8da494b8e92f36$var$PropsNames.materials, recursive);
    }
    /**
   * Set IfcRelAssociatesMaterial relations of IfcElements and IfcMaterialDefinitions
   * @param modelID model handle
   * @param elementID expressID or array of expressIDs of IfcElements
   * @param materialID expressID or array of expressIDs of IfcMaterialDefinitions
   * @returns true if success or false if error
   */ async setMaterialsProperties(modelID, elementID, materialID) {
        return this.setItemProperties(modelID, elementID, materialID, $3b8da494b8e92f36$var$PropsNames.materials);
    }
    /**
   * Get Spatial Structure of IfcProject
   * @param modelID model handle
   * @param includeProperties default false
   * @returns IfcProject as Node
   */ async getSpatialStructure(modelID, includeProperties = false) {
        const chunks = await this.getSpatialTreeChunks(modelID);
        const allLines = await this.api.GetLineIDsWithType(modelID, $3b8da494b8e92f36$export$7bec46e80091ced6);
        const projectID = allLines.get(0);
        const project = _Properties.newIfcProject(projectID);
        await this.getSpatialNode(modelID, project, chunks, includeProperties);
        return project;
    }
    async getRelatedProperties(modelID, elementID, propsName, recursive = false) {
        const result = [];
        let rels = null;
        if (elementID !== 0) rels = await this.api.GetLine(modelID, elementID, false, true, propsName.key)[propsName.key];
        else {
            let vec = this.api.GetLineIDsWithType(modelID, propsName.name);
            rels = [];
            for(let i = 0; i < vec.size(); ++i)rels.push({
                value: vec.get(i)
            });
        }
        if (rels == null) return result;
        if (!Array.isArray(rels)) rels = [
            rels
        ];
        for(let i = 0; i < rels.length; i++){
            let propSetIds = await this.api.GetLine(modelID, rels[i].value, false, false)[propsName.relating];
            if (propSetIds == null) continue;
            if (!Array.isArray(propSetIds)) propSetIds = [
                propSetIds
            ];
            for(let x = 0; x < propSetIds.length; x++)result.push(await this.api.GetLine(modelID, propSetIds[x].value, recursive));
        }
        return result;
    }
    async getChunks(modelID, chunks, propNames) {
        const relation = await this.api.GetLineIDsWithType(modelID, propNames.name, true);
        for(let i = 0; i < relation.size(); i++){
            const rel = await this.api.GetLine(modelID, relation.get(i), false);
            this.saveChunk(chunks, propNames, rel);
        }
    }
    static newIfcProject(id) {
        return {
            expressID: id,
            type: "IFCPROJECT",
            children: []
        };
    }
    async getSpatialNode(modelID, node, treeChunks, includeProperties) {
        await this.getChildren(modelID, node, treeChunks, $3b8da494b8e92f36$var$PropsNames.aggregates, includeProperties);
        await this.getChildren(modelID, node, treeChunks, $3b8da494b8e92f36$var$PropsNames.spatial, includeProperties);
    }
    async getChildren(modelID, node, treeChunks, propNames, includeProperties) {
        const children = treeChunks[node.expressID];
        if (children == void 0) return;
        const prop = propNames.key;
        const nodes = [];
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            let node2 = this.newNode(child, this.api.GetLineType(modelID, child));
            if (includeProperties) {
                const properties = await this.getItemProperties(modelID, node2.expressID);
                node2 = {
                    ...properties,
                    ...node2
                };
            }
            await this.getSpatialNode(modelID, node2, treeChunks, includeProperties);
            nodes.push(node2);
        }
        node[prop] = nodes;
    }
    newNode(id, type) {
        return {
            expressID: id,
            type: this.api.GetNameFromTypeCode(type),
            children: []
        };
    }
    async getSpatialTreeChunks(modelID) {
        const treeChunks = {};
        await this.getChunks(modelID, treeChunks, $3b8da494b8e92f36$var$PropsNames.aggregates);
        await this.getChunks(modelID, treeChunks, $3b8da494b8e92f36$var$PropsNames.spatial);
        return treeChunks;
    }
    saveChunk(chunks, propNames, rel) {
        const relating = rel[propNames.relating].value;
        const related = rel[propNames.related].map((r)=>r.value);
        if (chunks[relating] == void 0) chunks[relating] = related;
        else chunks[relating] = chunks[relating].concat(related);
    }
    async setItemProperties(modelID, elementID, propID, propsName) {
        if (!Array.isArray(elementID)) elementID = [
            elementID
        ];
        if (!Array.isArray(propID)) propID = [
            propID
        ];
        let foundRel = 0;
        const rels = [];
        const elements = [];
        for (const elID of elementID){
            const element = await this.api.GetLine(modelID, elID, false, true);
            if (!element[propsName.key]) continue;
            elements.push(element);
        }
        if (elements.length < 1) return false;
        const relations = this.api.GetLineIDsWithType(modelID, propsName.name);
        for(let i = 0; i < relations.size(); ++i){
            const rel = await this.api.GetLine(modelID, relations.get(i));
            if (propID.includes(Number(rel[propsName.relating].value))) {
                rels.push(rel);
                foundRel++;
            }
            if (foundRel == propID.length) break;
        }
        for (const element of elements){
            for (const rel of rels){
                if (!element[propsName.key].some((e)=>e.value === rel.expressID)) element[propsName.key].push({
                    type: 5,
                    value: rel.expressID
                });
                if (!rel[propsName.related].some((e)=>e.value === element.expressID)) {
                    rel[propsName.related].push({
                        type: 5,
                        value: element.expressID
                    });
                    this.api.WriteLine(modelID, rel);
                }
            }
            this.api.WriteLine(modelID, element);
        }
        return true;
    }
};
// dist/helpers/log.ts
var $3b8da494b8e92f36$export$243e62d78d3b544d = /* @__PURE__ */ ((LogLevel2)=>{
    LogLevel2[LogLevel2["LOG_LEVEL_DEBUG"] = 1] = "LOG_LEVEL_DEBUG";
    LogLevel2[LogLevel2["LOG_LEVEL_WARN"] = 3] = "LOG_LEVEL_WARN";
    LogLevel2[LogLevel2["LOG_LEVEL_ERROR"] = 4] = "LOG_LEVEL_ERROR";
    LogLevel2[LogLevel2["LOG_LEVEL_OFF"] = 6] = "LOG_LEVEL_OFF";
    return LogLevel2;
})($3b8da494b8e92f36$export$243e62d78d3b544d || {});
var $3b8da494b8e92f36$var$Log = class {
    static{
        this.logLevel = 4 /* LOG_LEVEL_ERROR */ ;
    }
    static setLogLevel(level) {
        this.logLevel = level;
    }
    static log(msg, ...args) {
        if (this.logLevel <= 4 /* LOG_LEVEL_ERROR */ ) console.log(msg, ...args);
    }
    static debug(msg, ...args) {
        if (this.logLevel <= 1 /* LOG_LEVEL_DEBUG */ ) console.trace("DEBUG: ", msg, ...args);
    }
    static warn(msg, ...args) {
        if (this.logLevel <= 3 /* LOG_LEVEL_WARN */ ) console.warn("WARN: ", msg, ...args);
    }
    static error(msg, ...args) {
        if (this.logLevel <= 4 /* LOG_LEVEL_ERROR */ ) console.error("ERROR: ", msg, ...args);
    }
};
// dist/web-ifc-api.ts
var $3b8da494b8e92f36$var$WebIFCWasm;
var $3b8da494b8e92f36$var$currentScriptPath;
if (typeof document !== "undefined") {
    const currentScriptData = document.currentScript;
    if (currentScriptData?.src !== void 0) $3b8da494b8e92f36$var$currentScriptPath = currentScriptData.src.substring(0, currentScriptData.src.lastIndexOf("/") + 1);
}
var $3b8da494b8e92f36$export$78244dbb77cfa6b6 = 0;
var $3b8da494b8e92f36$export$a0e01ba2ebef17f2 = 1;
var $3b8da494b8e92f36$export$37aee82a3cb1e8f7 = 2;
var $3b8da494b8e92f36$export$e889e62870bf06db = 3;
var $3b8da494b8e92f36$export$d07a4b0e2ecd1ff1 = 4;
var $3b8da494b8e92f36$export$19039a9c5d174551 = 5;
var $3b8da494b8e92f36$export$ccb33e29d92c9a58 = 6;
var $3b8da494b8e92f36$export$aea21e6980d49319 = 7;
var $3b8da494b8e92f36$export$6595d83692042853 = 8;
var $3b8da494b8e92f36$export$7cfe24f49cb43a4a = 9;
var $3b8da494b8e92f36$export$84ed3454f6108675 = 10;
function $3b8da494b8e92f36$export$5dd2165da01bec80() {
    return /* @__PURE__ */ new Date().getTime();
}
var $3b8da494b8e92f36$export$851bf40c76520248 = class {
    constructor(){
        /** @ignore */ this.wasmModule = void 0;
        this.wasmPath = "";
        this.isWasmPathAbsolute = false;
        this.modelSchemaList = [];
        this.modelSchemaNameList = [];
        /** @ignore */ this.ifcGuidMap = /* @__PURE__ */ new Map();
        this.deletedLines = /* @__PURE__ */ new Map();
        /**
     * Contains all the logic and methods regarding properties, psets, qsets, etc.
     */ this.properties = new $3b8da494b8e92f36$export$8714badcfa4caafb(this);
    }
    /**
   * Initializes the WASM module (WebIFCWasm), required before using any other functionality.
   *
   * @param customLocateFileHandler An optional locateFile function that let's
   * you override the path from which the wasm module is loaded.
   */ async Init(customLocateFileHandler, forceSingleThread = false) {
        if (!$3b8da494b8e92f36$var$WebIFCWasm) {
            if (typeof self !== "undefined" && self.crossOriginIsolated && !forceSingleThread) try {
                $3b8da494b8e92f36$var$WebIFCWasm = $3b8da494b8e92f36$var$require_web_ifc_mt();
            } catch (ex) {
                $3b8da494b8e92f36$var$WebIFCWasm = $3b8da494b8e92f36$var$require_web_ifc();
            }
            else $3b8da494b8e92f36$var$WebIFCWasm = $3b8da494b8e92f36$var$require_web_ifc();
        }
        if ($3b8da494b8e92f36$var$WebIFCWasm && this.wasmModule == void 0) {
            let locateFileHandler = (path, prefix)=>{
                if (path.endsWith(".wasm")) {
                    if (this.isWasmPathAbsolute) return this.wasmPath + path;
                    return ($3b8da494b8e92f36$var$currentScriptPath !== void 0 ? $3b8da494b8e92f36$var$currentScriptPath : prefix) + this.wasmPath + path;
                }
                return ($3b8da494b8e92f36$var$currentScriptPath !== void 0 ? $3b8da494b8e92f36$var$currentScriptPath : prefix) + path;
            };
            this.wasmModule = await $3b8da494b8e92f36$var$WebIFCWasm({
                noInitialRun: true,
                locateFile: customLocateFileHandler || locateFileHandler
            });
            this.SetLogLevel(4 /* LOG_LEVEL_ERROR */ );
        } else $3b8da494b8e92f36$var$Log.error(`Could not find wasm module at './web-ifc' from web-ifc-api.ts`);
    }
    /**
   * Opens a set of models and returns model IDs
   * @param dataSets Array of Buffers containing IFC data (bytes)
   * @param settings Settings for loading the model @see LoaderSettings
   * @returns Array of model IDs
   */ OpenModels(dataSets, settings) {
        let s = {
            MEMORY_LIMIT: 2147483648,
            ...settings
        };
        s.MEMORY_LIMIT = s.MEMORY_LIMIT / dataSets.length;
        let modelIDs = [];
        for (let dataSet of dataSets)modelIDs.push(this.OpenModel(dataSet, s));
        return modelIDs;
    }
    CreateSettings(settings) {
        let s = {
            COORDINATE_TO_ORIGIN: false,
            CIRCLE_SEGMENTS: 12,
            TAPE_SIZE: 67108864,
            MEMORY_LIMIT: 2147483648,
            LINEWRITER_BUFFER: 1e4,
            TOLERANCE_PLANE_INTERSECTION: 1e-4,
            TOLERANCE_PLANE_DEVIATION: 1e-4,
            TOLERANCE_BACK_DEVIATION_DISTANCE: 1e-4,
            TOLERANCE_INSIDE_OUTSIDE_PERIMETER: 1e-10,
            TOLERANCE_SCALAR_EQUALITY: 1e-4,
            PLANE_REFIT_ITERATIONS: 1,
            BOOLEAN_UNION_THRESHOLD: 150,
            ...settings
        };
        return s;
    }
    LookupSchemaId(schemaName) {
        for(var i = 0; i < $3b8da494b8e92f36$export$a6870f5c6ab054f9.length; i++){
            if (typeof $3b8da494b8e92f36$export$a6870f5c6ab054f9[i] !== "undefined") for(var j = 0; j < $3b8da494b8e92f36$export$a6870f5c6ab054f9[i].length; j++){
                if ($3b8da494b8e92f36$export$a6870f5c6ab054f9[i][j] == schemaName) return i;
            }
        }
        return -1;
    }
    /**
   * Opens a model and returns a modelID number
   * @param data Buffer containing IFC data (bytes)
   * @param settings Settings for loading the model @see LoaderSettings
   * @returns ModelID or -1 if model fails to open
   */ OpenModel(data, settings) {
        let s = this.CreateSettings(settings);
        let result = this.wasmModule.OpenModel(s, (destPtr, offsetInSrc, destSize)=>{
            let srcSize = Math.min(data.byteLength - offsetInSrc, destSize);
            let dest = this.wasmModule.HEAPU8.subarray(destPtr, destPtr + srcSize);
            let src = data.subarray(offsetInSrc, offsetInSrc + srcSize);
            dest.set(src);
            return srcSize;
        });
        this.deletedLines.set(result, /* @__PURE__ */ new Set());
        var schemaName = this.GetHeaderLine(result, $3b8da494b8e92f36$export$4506ff5c4f61e02a).arguments[0][0].value;
        this.modelSchemaList[result] = this.LookupSchemaId(schemaName);
        this.modelSchemaNameList[result] = schemaName;
        if (this.modelSchemaList[result] == -1) {
            $3b8da494b8e92f36$var$Log.error("Unsupported Schema:" + schemaName);
            this.CloseModel(result);
            return -1;
        }
        $3b8da494b8e92f36$var$Log.debug("Parsing Model using " + schemaName + " Schema");
        return result;
    }
    /**
   * Opens a model and returns a modelID number
   * @param callback a function of signature (offset:number, size: number) => Uint8Array that will retrieve the IFC data
   * @param settings Settings for loading the model @see LoaderSettings
   * @returns ModelID or -1 if model fails to open
   */ OpenModelFromCallback(callback, settings) {
        let s = this.CreateSettings(settings);
        let result = this.wasmModule.OpenModel(s, (destPtr, offsetInSrc, destSize)=>{
            let data = callback(offsetInSrc, destSize);
            let srcSize = Math.min(data.byteLength, destSize);
            let dest = this.wasmModule.HEAPU8.subarray(destPtr, destPtr + srcSize);
            dest.set(data);
            return srcSize;
        });
        this.deletedLines.set(result, /* @__PURE__ */ new Set());
        var schemaName = this.GetHeaderLine(result, $3b8da494b8e92f36$export$4506ff5c4f61e02a).arguments[0][0].value;
        this.modelSchemaList[result] = this.LookupSchemaId(schemaName);
        this.modelSchemaNameList[result] = schemaName;
        if (this.modelSchemaList[result] == -1) {
            $3b8da494b8e92f36$var$Log.error("Unsupported Schema:" + schemaName);
            this.CloseModel(result);
            return -1;
        }
        $3b8da494b8e92f36$var$Log.debug("Parsing Model using " + schemaName + " Schema");
        return result;
    }
    /**
   * Fetches the ifc schema version of a given model
   * @param modelID Model ID
   * @returns IFC Schema version
   */ GetModelSchema(modelID) {
        return this.modelSchemaNameList[modelID];
    }
    /**
   * Creates a new model and returns a modelID number
   * @param schema ifc schema version
   * @returns ModelID
   */ CreateModel(model, settings) {
        let s = this.CreateSettings(settings);
        let result = this.wasmModule.CreateModel(s);
        this.modelSchemaList[result] = this.LookupSchemaId(model.schema);
        this.modelSchemaNameList[result] = model.schema;
        if (this.modelSchemaList[result] == -1) {
            $3b8da494b8e92f36$var$Log.error("Unsupported Schema:" + model.schema);
            this.CloseModel(result);
            return -1;
        }
        this.deletedLines.set(result, /* @__PURE__ */ new Set());
        const modelName = model.name || "web-ifc-model-" + result + ".ifc";
        const timestamp = /* @__PURE__ */ new Date().toISOString().slice(0, 19);
        const description = model.description?.map((d)=>({
                type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                value: d
            })) || [
            {
                type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                value: "ViewDefinition [CoordinationView]"
            }
        ];
        const authors = model.authors?.map((a)=>({
                type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                value: a
            })) || [
            null
        ];
        const orgs = model.organizations?.map((o)=>({
                type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                value: o
            })) || [
            null
        ];
        const auth = model.authorization ? {
            type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
            value: model.authorization
        } : null;
        this.wasmModule.WriteHeaderLine(result, $3b8da494b8e92f36$export$b29a12041c9b9847, [
            description,
            {
                type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                value: "2;1"
            }
        ]);
        this.wasmModule.WriteHeaderLine(result, $3b8da494b8e92f36$export$4b79612785fd8d50, [
            {
                type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                value: modelName
            },
            {
                type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                value: timestamp
            },
            authors,
            orgs,
            {
                type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                value: "thatopen/web-ifc-api"
            },
            {
                type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                value: "thatopen/web-ifc-api"
            },
            auth
        ]);
        this.wasmModule.WriteHeaderLine(result, $3b8da494b8e92f36$export$4506ff5c4f61e02a, [
            [
                {
                    type: $3b8da494b8e92f36$export$a0e01ba2ebef17f2,
                    value: model.schema
                }
            ]
        ]);
        return result;
    }
    /**
   * Saves a model to a Buffer
   * @param modelID Model ID
   * @returns Buffer containing the model data
   */ SaveModel(modelID) {
        let dataBuffer = new Uint8Array(0);
        this.wasmModule.SaveModel(modelID, (srcPtr, srcSize)=>{
            let origSize = dataBuffer.byteLength;
            let src = this.wasmModule.HEAPU8.subarray(srcPtr, srcPtr + srcSize);
            let newBuffer = new Uint8Array(origSize + srcSize);
            newBuffer.set(dataBuffer);
            newBuffer.set(src, origSize);
            dataBuffer = newBuffer;
        });
        return dataBuffer;
    }
    /**
   * Saves a model to a Buffer
   * @param modelID Model ID
   * @returns Buffer containing the model data
   */ SaveModelToCallback(modelID, callback) {
        this.wasmModule.SaveModel(modelID, (srcPtr, srcSize)=>{
            let src = this.wasmModule.HEAPU8.subarray(srcPtr, srcPtr + srcSize);
            let newBuffer = new Uint8Array(srcSize);
            newBuffer.set(src);
            callback(newBuffer);
        });
    }
    /**
   * Retrieves the geometry of an element
   * @param modelID Model handle retrieved by OpenModel
   * @param geometryExpressID express ID of the element
   * @returns Geometry of the element as a list of vertices and indices
   */ GetGeometry(modelID, geometryExpressID) {
        return this.wasmModule.GetGeometry(modelID, geometryExpressID);
    }
    CreateAABB() {
        return this.wasmModule.CreateAABB();
    }
    CreateExtrusion() {
        return this.wasmModule.CreateExtrusion();
    }
    CreateSweep() {
        return this.wasmModule.CreateSweep();
    }
    CreateCircularSweep() {
        return this.wasmModule.CreateCircularSweep();
    }
    CreateRevolution() {
        return this.wasmModule.CreateRevolution();
    }
    CreateCylindricalRevolution() {
        return this.wasmModule.CreateCylindricalRevolution();
    }
    CreateParabola() {
        return this.wasmModule.CreateParabola();
    }
    CreateClothoid() {
        return this.wasmModule.CreateClothoid();
    }
    CreateArc() {
        return this.wasmModule.CreateArc();
    }
    CreateAlignment() {
        return this.wasmModule.CreateAlignment();
    }
    CreateBooleanOperator() {
        return this.wasmModule.CreateBooleanOperator();
    }
    CreateProfile() {
        return this.wasmModule.CreateProfile();
    }
    /**
   * Gets the header information required by the user
   * @param modelID Model handle retrieved by OpenModel
   * @param headerType Type of header data you want to retrieve
   * ifc.FILE_NAME, ifc.FILE_DESCRIPTION or ifc.FILE_SCHEMA
   * @returns An object with parameters ID, type and arguments
   */ GetHeaderLine(modelID, headerType) {
        return this.wasmModule.GetHeaderLine(modelID, headerType);
    }
    /**
   * Gets the list of all ifcTypes contained in the model
   * @param modelID Model handle retrieved by OpenModel
   * @returns Array of objects containing typeID and typeName
   */ GetAllTypesOfModel(modelID) {
        let typesNames = [];
        const elements = Object.keys($3b8da494b8e92f36$export$6c6c405ef9389ced[this.modelSchemaList[modelID]]).map((e)=>parseInt(e));
        for(let i = 0; i < elements.length; i++){
            const lines = this.GetLineIDsWithType(modelID, elements[i]);
            if (lines.size() > 0) typesNames.push({
                typeID: elements[i],
                typeName: this.wasmModule.GetNameFromTypeCode(elements[i])
            });
        }
        return typesNames;
    }
    /**
   * Gets the ifc line data for a given express ID
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID express ID of the line
   * @param flatten recursively flatten the line, default false
   * @param inverse get the inverse properties of the line, default false
   * @param inversePropKey filters out all other properties from a inverse search, for a increase in performance. Default null
   * @returns lineObject
   */ GetLine(modelID, expressID, flatten = false, inverse = false, inversePropKey = null) {
        return this.GetLines(modelID, [
            expressID
        ], flatten, inverse, inversePropKey)[0];
    }
    /**
   * Gets the ifc line data for a given express ID
   * @param modelID Model handle retrieved by OpenModel
   * @param a list of expressID express ID of the line
   * @param flatten recursively flatten the line, default false
   * @param inverse get the inverse properties of the line, default false
   * @param inversePropKey filters out all other properties from a inverse search, for a increase in performance. Default null
   * @returns lineObject
   */ GetLines(modelID, expressIDs, flatten = false, inverse = false, inversePropKey = null) {
        let outputLineData = [];
        let rawLineDatas = this.GetRawLinesData(modelID, expressIDs);
        let i = 0;
        for (const rawLineData of rawLineDatas){
            let lineData;
            try {
                lineData = $3b8da494b8e92f36$export$6c6c405ef9389ced[this.modelSchemaList[modelID]][rawLineData.type](rawLineData.arguments);
                lineData.expressID = rawLineData.ID;
            } catch (e) {
                $3b8da494b8e92f36$var$Log.error("Invalid IFC Line:" + expressIDs[i]);
                if (rawLineData.ID) throw e;
                else continue;
            }
            if (flatten) this.FlattenLine(modelID, lineData);
            let inverseData = $3b8da494b8e92f36$export$1ae3922015fd7522[this.modelSchemaList[modelID]][rawLineData.type];
            if (inverse && inverseData != null) for (let inverseProp of inverseData){
                if (inversePropKey && inverseProp[0] !== inversePropKey) continue;
                if (!inverseProp[3]) lineData[inverseProp[0]] = null;
                else lineData[inverseProp[0]] = [];
                let targetTypes = [
                    inverseProp[1]
                ];
                if (typeof $3b8da494b8e92f36$export$6fc5084ea038b400[this.modelSchemaList[modelID]][inverseProp[1]] != "undefined") targetTypes = targetTypes.concat($3b8da494b8e92f36$export$6fc5084ea038b400[this.modelSchemaList[modelID]][inverseProp[1]]);
                let inverseIDs = this.wasmModule.GetInversePropertyForItem(modelID, rawLineData.ID, targetTypes, inverseProp[2], inverseProp[3]);
                if (!inverseProp[3] && inverseIDs.size() > 0) {
                    if (!flatten) lineData[inverseProp[0]] = {
                        type: 5,
                        value: inverseIDs.get(0)
                    };
                    else lineData[inverseProp[0]] = this.GetLine(modelID, inverseIDs.get(0));
                } else {
                    for(let x = 0; x < inverseIDs.size(); x++)if (!flatten) lineData[inverseProp[0]].push({
                        type: 5,
                        value: inverseIDs.get(x)
                    });
                    else lineData[inverseProp[0]].push(this.GetLine(modelID, inverseIDs.get(x)));
                }
            }
            outputLineData.push(lineData);
            i++;
        }
        return outputLineData;
    }
    /**
   * Gets the next unused expressID
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID Starting expressID value
   * @returns The next unused expressID starting from the value provided
   */ GetNextExpressID(modelID, expressID) {
        return this.wasmModule.GetNextExpressID(modelID, expressID);
    }
    /**
   * Creates a new ifc entity
   * @param modelID Model handle retrieved by OpenModel
   * @param type Type code
   * @param args Arguments required by the entity
   * @returns An object contining the parameters of the new entity
   */ CreateIfcEntity(modelID, type, ...args) {
        return $3b8da494b8e92f36$export$cab133dc4b2240f9[this.modelSchemaList[modelID]][type](args);
    }
    /**
   * Creates a new ifc globally unqiue ID
   * @param modelID Model handle retrieved by OpenModel
   * @returns An randomly generated globally unique ID
   */ CreateIFCGloballyUniqueId(modelID) {
        const guid = this.wasmModule.GenerateGuid(modelID);
        return $3b8da494b8e92f36$export$9d063d2e6222d3e2[this.modelSchemaList[modelID]][$3b8da494b8e92f36$export$4902c5e80eba64d5](guid);
    }
    /**
   * Creates a new ifc type i.e. IfcLabel, IfcReal, ...
   * @param modelID Model handle retrieved by OpenModel
   * @param type Type code
   * @param value Type value
   * @returns An object with the parameters of the type
   */ CreateIfcType(modelID, type, value) {
        return $3b8da494b8e92f36$export$9d063d2e6222d3e2[this.modelSchemaList[modelID]][type](value);
    }
    /**
   * Gets the name from a type code
   * @param type Code
   * @returns Name
   */ GetNameFromTypeCode(type) {
        return this.wasmModule.GetNameFromTypeCode(type);
    }
    /**
   * Gets the type code  from a name code
   * @param name
   * @returns type code
   */ GetTypeCodeFromName(typeName) {
        return this.wasmModule.GetTypeCodeFromName(typeName);
    }
    /**
   * Evaluates if a type is subtype of IfcElement
   * @param type Type code
   * @returns True if subtype of Ifcelement, False if it is not subtype
   */ IsIfcElement(type) {
        return this.wasmModule.IsIfcElement(type);
    }
    /**
   * Returns a list with all entity types that are present in the current schema
   * @param modelID Model handle retrieved by OpenModel
   * @returns Array of type codes
   */ GetIfcEntityList(modelID) {
        return Object.keys($3b8da494b8e92f36$export$6c6c405ef9389ced[this.modelSchemaList[modelID]]).map((x)=>parseInt(x));
    }
    /**
   * Deletes an IFC line from the model
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID express ID of the line to remove
   */ DeleteLine(modelID, expressID) {
        this.wasmModule.RemoveLine(modelID, expressID);
        this.deletedLines.get(modelID).add(expressID);
    }
    /**
   * Writes a line to the model, can be used to write new lines or to update existing lines
   * @param modelID Model handle retrieved by OpenModel
   * @param lineObject array of line object to write
   */ WriteLines(modelID, lineObjects) {
        for (let lineObject of lineObjects)this.WriteLine(modelID, lineObject);
    }
    /**
   * Writes a set of line to the model, can be used to write new lines or to update existing lines
   * @param modelID Model handle retrieved by OpenModel
   * @param lineObject line object to write
   */ WriteLine(modelID, lineObject) {
        if (lineObject.expressID != -1 && this.deletedLines.get(modelID).has(lineObject.expressID)) {
            $3b8da494b8e92f36$var$Log.error(`Cannot re-use deleted express ID`);
            return;
        }
        if (lineObject.expressID != -1 && lineObject.expressID <= this.GetMaxExpressID(modelID) && this.GetLineType(modelID, lineObject.expressID) != lineObject.type && this.GetLineType(modelID, lineObject.expressID) != 0) {
            $3b8da494b8e92f36$var$Log.error(`Cannot change type of existing IFC Line`);
            return;
        }
        let property;
        for(property in lineObject){
            const lineProperty = lineObject[property];
            if (lineProperty && lineProperty.expressID !== void 0) {
                this.WriteLine(modelID, lineProperty);
                lineObject[property] = new $3b8da494b8e92f36$export$94890c79f4cae6d6(lineProperty.expressID);
            } else if (Array.isArray(lineProperty) && lineProperty.length > 0) {
                for(let i = 0; i < lineProperty.length; i++)if (lineProperty[i].expressID !== void 0) {
                    this.WriteLine(modelID, lineProperty[i]);
                    lineObject[property][i] = new $3b8da494b8e92f36$export$94890c79f4cae6d6(lineProperty[i].expressID);
                }
            }
        }
        if (lineObject.expressID === void 0 || lineObject.expressID < 0) lineObject.expressID = this.GetMaxExpressID(modelID) + 1;
        let rawLineData = {
            ID: lineObject.expressID,
            type: lineObject.type,
            arguments: $3b8da494b8e92f36$export$4085d3c0722bed8d[this.modelSchemaList[modelID]][lineObject.type](lineObject)
        };
        this.WriteRawLineData(modelID, rawLineData);
    }
    /** @ignore */ FlattenLine(modelID, line) {
        Object.keys(line).forEach((propertyName)=>{
            let property = line[propertyName];
            if (property && property.type === 5) {
                if (property.value) line[propertyName] = this.GetLine(modelID, property.value, true);
            } else if (Array.isArray(property) && property.length > 0 && property[0] && property[0].type === 5) {
                for(let i = 0; i < property.length; i++)if (property[i].value) line[propertyName][i] = this.GetLine(modelID, property[i].value, true);
            }
        });
    }
    /** @ignore */ GetRawLinesData(modelID, expressIDs) {
        return this.wasmModule.GetLines(modelID, expressIDs);
    }
    /** @ignore */ GetRawLineData(modelID, expressID) {
        return this.GetRawLinesData(modelID, [
            expressID
        ])[0];
    }
    /** @ignore */ WriteRawLineData(modelID, data) {
        this.wasmModule.WriteLine(modelID, data.ID, data.type, data.arguments);
    }
    /** @ignore */ WriteRawLinesData(modelID, data) {
        for (let rawLine of data)this.wasmModule.WriteLine(modelID, rawLine.ID, rawLine.type, rawLine.arguments);
    }
    /**
   * Get all line IDs of a specific ifc type
   * @param modelID model ID
   * @param type ifc type, @see IfcEntities
   * @param includeInherited if true, also returns all inherited types
   * @returns vector of line IDs
   */ GetLineIDsWithType(modelID, type, includeInherited = false) {
        let types = [];
        types.push(type);
        if (includeInherited && typeof $3b8da494b8e92f36$export$6fc5084ea038b400[this.modelSchemaList[modelID]][type] != "undefined") types = types.concat($3b8da494b8e92f36$export$6fc5084ea038b400[this.modelSchemaList[modelID]][type]);
        let lineIds = this.wasmModule.GetLineIDsWithType(modelID, types);
        lineIds[Symbol.iterator] = function*() {
            for(let i = 0; i < lineIds.size(); i++)yield lineIds.get(i);
        };
        return lineIds;
    }
    /**
   * Get all line IDs of a model
   * @param modelID model ID
   * @returns vector of all line IDs
   */ GetAllLines(modelID) {
        let lineIds = this.wasmModule.GetAllLines(modelID);
        lineIds[Symbol.iterator] = function*() {
            for(let i = 0; i < lineIds.size(); i++)yield lineIds.get(i);
        };
        return lineIds;
    }
    /**
   * Returns all crossSections in 2D contained in IFCSECTIONEDSOLID, IFCSECTIONEDSURFACE, IFCSECTIONEDSOLIDHORIZONTAL (IFC4x3 or superior)
   * @param modelID model ID
   * @returns Lists with the cross sections curves as sets of points
   */ GetAllCrossSections2D(modelID) {
        const crossSections = this.wasmModule.GetAllCrossSections(modelID, 2);
        const crossSectionList = [];
        for(let i = 0; i < crossSections.size(); i++){
            const alignment = crossSections.get(i);
            const curveList = [];
            const expressList = [];
            for(let j = 0; j < alignment.curves.size(); j++){
                const curve = alignment.curves.get(j);
                const ptList = [];
                for(let p = 0; p < curve.points.size(); p++){
                    const pt = curve.points.get(p);
                    const newPoint = {
                        x: pt.x,
                        y: pt.y,
                        z: pt.z
                    };
                    ptList.push(newPoint);
                }
                const newCurve = {
                    points: ptList,
                    userData: [],
                    arcSegments: []
                };
                curveList.push(newCurve);
                expressList.push(alignment.expressID.get(j));
            }
            const align = {
                FlatCoordinationMatrix: this.GetCoordinationMatrix(modelID),
                curves: curveList,
                expressID: expressList
            };
            crossSectionList.push(align);
        }
        return crossSectionList;
    }
    /**
   * Returns all crossSections in 3D contained in IFCSECTIONEDSOLID, IFCSECTIONEDSURFACE, IFCSECTIONEDSOLIDHORIZONTAL (IFC4x3 or superior)
   * @param modelID model ID
   * @returns Lists with the cross sections curves as sets of points
   */ GetAllCrossSections3D(modelID) {
        const crossSections = this.wasmModule.GetAllCrossSections(modelID, 3);
        const crossSectionList = [];
        for(let i = 0; i < crossSections.size(); i++){
            const alignment = crossSections.get(i);
            const curveList = [];
            const expressList = [];
            for(let j = 0; j < alignment.curves.size(); j++){
                const curve = alignment.curves.get(j);
                const ptList = [];
                for(let p = 0; p < curve.points.size(); p++){
                    const pt = curve.points.get(p);
                    const newPoint = {
                        x: pt.x,
                        y: pt.y,
                        z: pt.z
                    };
                    ptList.push(newPoint);
                }
                const newCurve = {
                    points: ptList,
                    userData: [],
                    arcSegments: []
                };
                curveList.push(newCurve);
                expressList.push(alignment.expressID.get(j));
            }
            const align = {
                FlatCoordinationMatrix: this.GetCoordinationMatrix(modelID),
                curves: curveList,
                expressID: expressList
            };
            crossSectionList.push(align);
        }
        return crossSectionList;
    }
    /**
   * Returns all alignments contained in the IFC model (IFC4x3 or superior)
   * @param modelID model ID
   * @returns Lists with horizontal and vertical curves as sets of points
   */ GetAllAlignments(modelID) {
        const alignments = this.wasmModule.GetAllAlignments(modelID);
        const alignmentList = [];
        for(let i = 0; i < alignments.size(); i++){
            const alignment = alignments.get(i);
            const horList = [];
            for(let j = 0; j < alignment.Horizontal.curves.size(); j++){
                const curve = alignment.Horizontal.curves.get(j);
                const ptList = [];
                for(let p = 0; p < curve.points.size(); p++){
                    const pt = curve.points.get(p);
                    const newPoint = {
                        x: pt.x,
                        y: pt.y
                    };
                    ptList.push(newPoint);
                }
                const dtList = [];
                for(let p = 0; p < curve.userData.size(); p++){
                    const dt = curve.userData.get(p);
                    dtList.push(dt);
                }
                const newCurve = {
                    points: ptList,
                    data: dtList
                };
                horList.push(newCurve);
            }
            const verList = [];
            for(let j = 0; j < alignment.Vertical.curves.size(); j++){
                const curve = alignment.Vertical.curves.get(j);
                const ptList = [];
                for(let p = 0; p < curve.points.size(); p++){
                    const pt = curve.points.get(p);
                    const newPoint = {
                        x: pt.x,
                        y: pt.y
                    };
                    ptList.push(newPoint);
                }
                const dtList = [];
                for(let p = 0; p < curve.userData.size(); p++){
                    const dt = curve.userData.get(p);
                    dtList.push(dt);
                }
                const newCurve = {
                    points: ptList,
                    data: dtList
                };
                verList.push(newCurve);
            }
            const curve3DList = [];
            for(let j = 0; j < alignment.Absolute.curves.size(); j++){
                const curve = alignment.Absolute.curves.get(j);
                const ptList = [];
                for(let p = 0; p < curve.points.size(); p++){
                    const pt = curve.points.get(p);
                    const newPoint = {
                        x: pt.x,
                        y: pt.y,
                        z: pt.z
                    };
                    ptList.push(newPoint);
                }
                const dtList = [];
                for(let p = 0; p < curve.userData.size(); p++){
                    const dt = curve.userData.get(p);
                    dtList.push(dt);
                }
                const newCurve = {
                    points: ptList,
                    data: dtList
                };
                curve3DList.push(newCurve);
            }
            const align = {
                FlatCoordinationMatrix: this.GetCoordinationMatrix(modelID),
                horizontal: horList,
                vertical: verList,
                curve3D: curve3DList
            };
            alignmentList.push(align);
        }
        return alignmentList;
    }
    /**
   * Set the transformation matrix
   * @param modelID model ID
   * @param transformationMatrix transformation matrix, flat 4x4 matrix as array[16]
   */ SetGeometryTransformation(modelID, transformationMatrix) {
        if (transformationMatrix.length != 16) throw new Error(`invalid matrix size: ${transformationMatrix.length}`);
        this.wasmModule.SetGeometryTransformation(modelID, transformationMatrix);
    }
    /**
   * Get the coordination matrix
   * @param modelID model ID
   * @returns flat 4x4 matrix as array[16]
   */ GetCoordinationMatrix(modelID) {
        return this.wasmModule.GetCoordinationMatrix(modelID);
    }
    GetVertexArray(ptr, size) {
        return this.getSubArray(this.wasmModule.HEAPF32, ptr, size);
    }
    GetIndexArray(ptr, size) {
        return this.getSubArray(this.wasmModule.HEAPU32, ptr, size);
    }
    getSubArray(heap, startPtr, sizeBytes) {
        return heap.subarray(startPtr / 4, startPtr / 4 + sizeBytes).slice(0);
    }
    /**
   * Closes a model and frees all related memory
   * @param modelID Model handle retrieved by OpenModel, model must be closed after use
   */ CloseModel(modelID) {
        this.ifcGuidMap.delete(modelID);
        this.wasmModule.CloseModel(modelID);
    }
    /**
   * Closes all models and frees all related memory. Please note that after calling this you must call Init() again to ensure web-ifc is in a working state.
   */ Dispose() {
        this.ifcGuidMap.clear();
        this.wasmModule.CloseAllModels();
        this.wasmModule = void 0;
    }
    /**
   * Streams meshes of a model with specific express id
   * @param modelID Model handle retrieved by OpenModel
   * @param expressIDs expressIDs of elements to stream
   * @param meshCallback callback function that is called for each mesh
   */ StreamMeshes(modelID, expressIDs, meshCallback) {
        this.wasmModule.StreamMeshes(modelID, expressIDs, meshCallback);
    }
    /**
   * Streams all meshes of a model
   * @param modelID Model handle retrieved by OpenModel
   * @param meshCallback callback function that is called for each mesh
   */ StreamAllMeshes(modelID, meshCallback) {
        this.wasmModule.StreamAllMeshes(modelID, meshCallback);
    }
    /**
   * Streams all meshes of a model with a specific ifc type
   * @param modelID Model handle retrieved by OpenModel
   * @param types types of elements to stream
   * @param meshCallback callback function that is called for each mesh
   */ StreamAllMeshesWithTypes(modelID, types, meshCallback) {
        this.wasmModule.StreamAllMeshesWithTypes(modelID, types, meshCallback);
    }
    /**
   * Checks if a specific model ID is open or closed
   * @param modelID Model handle retrieved by OpenModel
   * @returns true if model is open, false if model is closed
   */ IsModelOpen(modelID) {
        return this.wasmModule.IsModelOpen(modelID);
    }
    /**
   * Load all geometry in a model
   * @param modelID Model handle retrieved by OpenModel
   * @returns Vector of FlatMesh objects
   */ LoadAllGeometry(modelID) {
        let flatMeshes = this.wasmModule.LoadAllGeometry(modelID);
        flatMeshes[Symbol.iterator] = function*() {
            for(let i = 0; i < flatMeshes.size(); i++)yield flatMeshes.get(i);
        };
        return flatMeshes;
    }
    /**
   * Load geometry for a single element
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID ExpressID of the element
   * @returns FlatMesh object
   */ GetFlatMesh(modelID, expressID) {
        return this.wasmModule.GetFlatMesh(modelID, expressID);
    }
    /**
   * Returns the maximum ExpressID value in the IFC file, ex.- #9999999
   * @param modelID Model handle retrieved by OpenModel
   * @returns Express numerical value
   */ GetMaxExpressID(modelID) {
        return this.wasmModule.GetMaxExpressID(modelID);
    }
    /**
   * Returns the type of a given ifc entity in the fiule.
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID Line Number
   * @returns IFC Type Code
   */ GetLineType(modelID, expressID) {
        return this.wasmModule.GetLineType(modelID, expressID);
    }
    /**
   * Returns the version number of web-ifc
   * @returns The current version number as a string
   */ GetVersion() {
        return this.wasmModule.GetVersion();
    }
    /**
   * Looks up an entities express ID from its GlobalID.
   * @param modelID Model handle retrieved by OpenModel
   * @param guid GobalID to be looked up
   * @returns expressID numerical value
   */ GetExpressIdFromGuid(modelID, guid) {
        if (!this.ifcGuidMap.has(modelID)) this.CreateIfcGuidToExpressIdMapping(modelID);
        return this.ifcGuidMap.get(modelID)?.get(guid);
    }
    /**
   * Looks up an entities GlobalID from its ExpressID.
   * @param modelID Model handle retrieved by OpenModel
   * @param expressID express ID to be looked up
   * @returns globalID string value
   */ GetGuidFromExpressId(modelID, expressID) {
        if (!this.ifcGuidMap.has(modelID)) this.CreateIfcGuidToExpressIdMapping(modelID);
        return this.ifcGuidMap.get(modelID)?.get(expressID);
    }
    /** @ignore */ CreateIfcGuidToExpressIdMapping(modelID) {
        const map = /* @__PURE__ */ new Map();
        let entities = this.GetIfcEntityList(modelID);
        for (const typeId of entities){
            if (!this.IsIfcElement(typeId)) continue;
            const lines = this.GetLineIDsWithType(modelID, typeId);
            const size = lines.size();
            for(let y = 0; y < size; y++){
                const expressID = lines.get(y);
                const info = this.GetLine(modelID, expressID);
                try {
                    if ("GlobalId" in info) {
                        const globalID = info.GlobalId.value;
                        map.set(expressID, globalID);
                        map.set(globalID, expressID);
                    }
                } catch (e) {
                    continue;
                }
            }
        }
        this.ifcGuidMap.set(modelID, map);
    }
    /**
   * Sets the path to the wasm file
   * @param path path to the wasm file
   * @param absolute if true, path is absolute, otherwise it is relative to executing script
   */ SetWasmPath(path, absolute = false) {
        this.wasmPath = path;
        this.isWasmPathAbsolute = absolute;
    }
    /**
   * Sets the log level
   * @param level Log level to set
   */ SetLogLevel(level) {
        $3b8da494b8e92f36$var$Log.setLogLevel(level);
        this.wasmModule.SetLogLevel(level);
    }
    /**
   * Encodes test using IFC Encoding
   * @text the text to encode
   * @returns the text encoded
   */ EncodeText(text) {
        return this.wasmModule.EncodeText(text);
    }
    /**
   * Decodes test using IFC Encoding
   * @text the text to decode
   * @returns the text decoded
   */ DecodeText(text) {
        return this.wasmModule.DecodeText(text);
    }
    /**
   * Resets the Cached IFC Data - useful when changing the geometry of a model
   * @param modelID Model handle retrieved by OpenModel
   */ ResetCache(modelID) {
        return this.wasmModule.DecodeText(modelID);
    }
};

});

parcelRegister("ilpIi", function(module, exports) {
$parcel$export(module.exports, "collection", () => (parcelRequire("9HrqM")).collection);
$parcel$export(module.exports, "deleteDoc", () => (parcelRequire("9HrqM")).deleteDoc);
$parcel$export(module.exports, "doc", () => (parcelRequire("9HrqM")).doc);
$parcel$export(module.exports, "documentId", () => (parcelRequire("9HrqM")).documentId);
$parcel$export(module.exports, "getDocs", () => (parcelRequire("9HrqM")).getDocs);
$parcel$export(module.exports, "getFirestore", () => (parcelRequire("9HrqM")).getFirestore);
$parcel$export(module.exports, "onSnapshot", () => (parcelRequire("9HrqM")).onSnapshot);
$parcel$export(module.exports, "query", () => (parcelRequire("9HrqM")).query);
$parcel$export(module.exports, "setDoc", () => (parcelRequire("9HrqM")).setDoc);
$parcel$export(module.exports, "where", () => (parcelRequire("9HrqM")).where);
parcelRequire("9HrqM");

});
parcelRegister("9HrqM", function(module, exports) {

$parcel$export(module.exports, "collection", () => $70fd6868680e912c$export$bf5175b0c24981cd);
$parcel$export(module.exports, "doc", () => $70fd6868680e912c$export$2a111da947c407d2);
$parcel$export(module.exports, "getFirestore", () => $70fd6868680e912c$export$f06a05d14c3a6678);
$parcel$export(module.exports, "documentId", () => $70fd6868680e912c$export$bf6e62266977b8eb);
$parcel$export(module.exports, "query", () => $70fd6868680e912c$export$2fa187e846a241c4);
$parcel$export(module.exports, "where", () => $70fd6868680e912c$export$9c59b80dda569a6e);
$parcel$export(module.exports, "getDocs", () => $70fd6868680e912c$export$81d3477bd73c86ef);
$parcel$export(module.exports, "setDoc", () => $70fd6868680e912c$export$5ff77ddaff3c9e12);
$parcel$export(module.exports, "deleteDoc", () => $70fd6868680e912c$export$a4f20481fae8f78b);
$parcel$export(module.exports, "onSnapshot", () => $70fd6868680e912c$export$d36370812fb26935);

var $7xvHX = parcelRequire("7xvHX");

var $eryG9 = parcelRequire("eryG9");

var $5Z2ef = parcelRequire("5Z2ef");

var $gMVVg = parcelRequire("gMVVg");

var $l0itG = parcelRequire("l0itG");
const $70fd6868680e912c$var$b = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $70fd6868680e912c$var$V {
    constructor(t){
        this.uid = t;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(t) {
        return t.uid === this.uid;
    }
}
/** A user with a null UID. */ $70fd6868680e912c$var$V.UNAUTHENTICATED = new $70fd6868680e912c$var$V(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$70fd6868680e912c$var$V.GOOGLE_CREDENTIALS = new $70fd6868680e912c$var$V("google-credentials-uid"), $70fd6868680e912c$var$V.FIRST_PARTY = new $70fd6868680e912c$var$V("first-party-uid"), $70fd6868680e912c$var$V.MOCK_USER = new $70fd6868680e912c$var$V("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $70fd6868680e912c$var$S = "9.23.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$D = new (0, $5Z2ef.Logger)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $70fd6868680e912c$var$C() {
    return $70fd6868680e912c$var$D.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $70fd6868680e912c$export$c622e99c0ce7b1c9(t) {
    $70fd6868680e912c$var$D.setLogLevel(t);
}
function $70fd6868680e912c$var$N(t, ...e) {
    if ($70fd6868680e912c$var$D.logLevel <= (0, $5Z2ef.LogLevel).DEBUG) {
        const n = e.map($70fd6868680e912c$var$$);
        $70fd6868680e912c$var$D.debug(`Firestore (${$70fd6868680e912c$var$S}): ${t}`, ...n);
    }
}
function $70fd6868680e912c$var$k(t, ...e) {
    if ($70fd6868680e912c$var$D.logLevel <= (0, $5Z2ef.LogLevel).ERROR) {
        const n = e.map($70fd6868680e912c$var$$);
        $70fd6868680e912c$var$D.error(`Firestore (${$70fd6868680e912c$var$S}): ${t}`, ...n);
    }
}
/**
 * @internal
 */ function $70fd6868680e912c$export$86cd73f49cc6e0bb(t, ...e) {
    if ($70fd6868680e912c$var$D.logLevel <= (0, $5Z2ef.LogLevel).WARN) {
        const n = e.map($70fd6868680e912c$var$$);
        $70fd6868680e912c$var$D.warn(`Firestore (${$70fd6868680e912c$var$S}): ${t}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $70fd6868680e912c$var$$(t) {
    if ("string" == typeof t) return t;
    try {
        return e = t, JSON.stringify(e);
    } catch (e) {
        // Converting to JSON failed, just log the object directly
        return t;
    }
    /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ var e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $70fd6868680e912c$var$O(t = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const e = `FIRESTORE (${$70fd6868680e912c$var$S}) INTERNAL ASSERTION FAILED: ` + t;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $70fd6868680e912c$var$k(e), new Error(e);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $70fd6868680e912c$var$F(t, e) {
    t || $70fd6868680e912c$var$O();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $70fd6868680e912c$export$1d2b90eea9bba017(t, e) {
    t || $70fd6868680e912c$var$O();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $70fd6868680e912c$var$L(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$q = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $70fd6868680e912c$export$8fada0bf726bf278 extends (0, $gMVVg.FirebaseError) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ t, /**
     * A custom error description.
     */ e){
        super(t, e), this.code = t, this.message = e, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$K {
    constructor(){
        this.promise = new Promise((t, e)=>{
            this.resolve = t, this.reject = e;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$G {
    constructor(t, e){
        this.user = e, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${t}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(t, e) {
        // Fire with initial user.
        t.enqueueRetryable(()=>e($70fd6868680e912c$var$V.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $70fd6868680e912c$var$j {
    constructor(t){
        this.token = t, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(t, e) {
        this.changeListener = e, // Fire with initial user.
        t.enqueueRetryable(()=>e(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $70fd6868680e912c$var$z {
    constructor(t){
        this.t = t, /** Tracks the current User. */ this.currentUser = $70fd6868680e912c$var$V.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(t, e) {
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const s = (t)=>this.i !== n ? (n = this.i, e(t)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let i = new $70fd6868680e912c$var$K;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), i.resolve(), i = new $70fd6868680e912c$var$K, t.enqueueRetryable(()=>s(this.currentUser));
        };
        const r = ()=>{
            const e = i;
            t.enqueueRetryable(async ()=>{
                await e.promise, await s(this.currentUser);
            });
        }, o = (t)=>{
            $70fd6868680e912c$var$N("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = t, this.auth.addAuthTokenListener(this.o), r();
        };
        this.t.onInit((t)=>o(t)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const t = this.t.getImmediate({
                    optional: !0
                });
                t ? o(t) : // If auth is still not available, proceed with `null` user
                ($70fd6868680e912c$var$N("FirebaseAuthCredentialsProvider", "Auth not yet detected"), i.resolve(), i = new $70fd6868680e912c$var$K);
            }
        }, 0), r();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const t = this.i, e = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(e).then((e)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== t ? ($70fd6868680e912c$var$N("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : e ? ($70fd6868680e912c$var$F("string" == typeof e.accessToken), new $70fd6868680e912c$var$G(e.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.auth.removeAuthTokenListener(this.o);
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const t = this.auth && this.auth.getUid();
        return $70fd6868680e912c$var$F(null === t || "string" == typeof t), new $70fd6868680e912c$var$V(t);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $70fd6868680e912c$var$W {
    constructor(t, e, n){
        this.h = t, this.l = e, this.m = n, this.type = "FirstParty", this.user = $70fd6868680e912c$var$V.FIRST_PARTY, this.g = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ p() {
        return this.m ? this.m() : null;
    }
    get headers() {
        this.g.set("X-Goog-AuthUser", this.h);
        // Use array notation to prevent minification
        const t = this.p();
        return t && this.g.set("Authorization", t), this.l && this.g.set("X-Goog-Iam-Authorization-Token", this.l), this.g;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $70fd6868680e912c$var$H {
    constructor(t, e, n){
        this.h = t, this.l = e, this.m = n;
    }
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$W(this.h, this.l, this.m));
    }
    start(t, e) {
        // Fire with initial uid.
        t.enqueueRetryable(()=>e($70fd6868680e912c$var$V.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $70fd6868680e912c$var$J {
    constructor(t){
        this.value = t, this.type = "AppCheck", this.headers = new Map, t && t.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $70fd6868680e912c$var$Y {
    constructor(t){
        this.I = t, this.forceRefresh = !1, this.appCheck = null, this.T = null;
    }
    start(t, e) {
        const n = (t)=>{
            null != t.error && $70fd6868680e912c$var$N("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${t.error.message}`);
            const n = t.token !== this.T;
            return this.T = t.token, $70fd6868680e912c$var$N("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? e(t.token) : Promise.resolve();
        };
        this.o = (e)=>{
            t.enqueueRetryable(()=>n(e));
        };
        const s = (t)=>{
            $70fd6868680e912c$var$N("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = t, this.appCheck.addTokenListener(this.o);
        };
        this.I.onInit((t)=>s(t)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const t = this.I.getImmediate({
                    optional: !0
                });
                t ? s(t) : // If AppCheck is still not available, proceed without it.
                $70fd6868680e912c$var$N("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        const t = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(t).then((t)=>t ? ($70fd6868680e912c$var$F("string" == typeof t.token), this.T = t.token, new $70fd6868680e912c$var$J(t.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.appCheck.removeTokenListener(this.o);
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$J(""));
    }
    invalidateToken() {}
    start(t, e) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $70fd6868680e912c$var$Z(t) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const e = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(t);
    if (e && "function" == typeof e.getRandomValues) e.getRandomValues(n);
    else // Falls back to Math.random
    for(let e = 0; e < t; e++)n[e] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$tt {
    static A() {
        // Alphanumeric characters
        const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = Math.floor(256 / t.length) * t.length;
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const s = $70fd6868680e912c$var$Z(40);
            for(let i = 0; i < s.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && s[i] < e && (n += t.charAt(s[i] % t.length));
        }
        return n;
    }
}
function $70fd6868680e912c$var$et(t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $70fd6868680e912c$var$nt(t, e, n) {
    return t.length === e.length && t.every((t, s)=>n(t, e[s]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $70fd6868680e912c$var$st(t) {
    // Return the input string, with an additional NUL byte appended.
    return t + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $70fd6868680e912c$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ t, /**
     * The fractions of a second at nanosecond resolution.*
     */ e){
        if (this.seconds = t, this.nanoseconds = e, e < 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (e >= 1e9) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (t < -62135596800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
        // This will break in the year 10,000.
        if (t >= 253402300800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    }
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(t) {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(t.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(t) {
        const e = Math.floor(t / 1e3), n = Math.floor(1e6 * (t - 1e3 * e));
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e, n);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(t) {
        return this.seconds === t.seconds ? $70fd6868680e912c$var$et(this.nanoseconds, t.nanoseconds) : $70fd6868680e912c$var$et(this.seconds, t.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(t) {
        return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexiographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexiographical ordering.
        const t = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $70fd6868680e912c$var$rt {
    constructor(t){
        this.timestamp = t;
    }
    static fromTimestamp(t) {
        return new $70fd6868680e912c$var$rt(t);
    }
    static min() {
        return new $70fd6868680e912c$var$rt(new $70fd6868680e912c$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $70fd6868680e912c$var$rt(new $70fd6868680e912c$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    compareTo(t) {
        return this.timestamp._compareTo(t.timestamp);
    }
    isEqual(t) {
        return this.timestamp.isEqual(t.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ class $70fd6868680e912c$var$ot {
    constructor(t, e, n){
        void 0 === e ? e = 0 : e > t.length && $70fd6868680e912c$var$O(), void 0 === n ? n = t.length - e : n > t.length - e && $70fd6868680e912c$var$O(), this.segments = t, this.offset = e, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(t) {
        return 0 === $70fd6868680e912c$var$ot.comparator(this, t);
    }
    child(t) {
        const e = this.segments.slice(this.offset, this.limit());
        return t instanceof $70fd6868680e912c$var$ot ? t.forEach((t)=>{
            e.push(t);
        }) : e.push(t), this.construct(e);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(t) {
        return t = void 0 === t ? 1 : t, this.construct(this.segments, this.offset + t, this.length - t);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(t) {
        return this.segments[this.offset + t];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(t) {
        if (t.length < this.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    isImmediateParentOf(t) {
        if (this.length + 1 !== t.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    forEach(t) {
        for(let e = this.offset, n = this.limit(); e < n; e++)t(this.segments[e]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(t, e) {
        const n = Math.min(t.length, e.length);
        for(let s = 0; s < n; s++){
            const n = t.get(s), i = e.get(s);
            if (n < i) return -1;
            if (n > i) return 1;
        }
        return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $70fd6868680e912c$var$ut extends $70fd6868680e912c$var$ot {
    construct(t, e, n) {
        return new $70fd6868680e912c$var$ut(t, e, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...t) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const e = [];
        for (const n of t){
            if (n.indexOf("//") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and traling slashed.
            e.push(...n.split("/").filter((t)=>t.length > 0));
        }
        return new $70fd6868680e912c$var$ut(e);
    }
    static emptyPath() {
        return new $70fd6868680e912c$var$ut([]);
    }
}
const $70fd6868680e912c$var$ct = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $70fd6868680e912c$export$b7871852b967eaf1 extends $70fd6868680e912c$var$ot {
    construct(t, e, n) {
        return new $70fd6868680e912c$export$b7871852b967eaf1(t, e, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(t) {
        return $70fd6868680e912c$var$ct.test(t);
    }
    canonicalString() {
        return this.toArray().map((t)=>(t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $70fd6868680e912c$export$b7871852b967eaf1.isValidIdentifier(t) || (t = "`" + t + "`"), t)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([
            "__name__"
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(t) {
        const e = [];
        let n = "", s = 0;
        const i = ()=>{
            if (0 === n.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            e.push(n), n = "";
        };
        let r = !1;
        for(; s < t.length;){
            const e = t[s];
            if ("\\" === e) {
                if (s + 1 === t.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
                const e = t[s + 1];
                if ("\\" !== e && "." !== e && "`" !== e) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
                n += e, s += 2;
            } else "`" === e ? (r = !r, s++) : "." !== e || r ? (n += e, s++) : (i(), s++);
        }
        if (i(), r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
        return new $70fd6868680e912c$export$b7871852b967eaf1(e);
    }
    static emptyPath() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $70fd6868680e912c$export$afc2e57c475b7810 {
    constructor(t){
        this.path = t;
    }
    static fromPath(t) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.fromString(t));
    }
    static fromName(t) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.fromString(t).popFirst(5));
    }
    static empty() {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(t) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(t) {
        return null !== t && 0 === $70fd6868680e912c$var$ut.comparator(this.path, t.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(t, e) {
        return $70fd6868680e912c$var$ut.comparator(t.path, e.path);
    }
    static isDocumentKey(t) {
        return t.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(t) {
        return new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ut(t.slice()));
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $70fd6868680e912c$var$lt {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ t, /** The collection ID this index applies to. */ e, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ s){
        this.indexId = t, this.collectionGroup = e, this.fields = n, this.indexState = s;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $70fd6868680e912c$var$ft(t) {
    return t.fields.find((t)=>2 /* IndexKind.CONTAINS */  === t.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $70fd6868680e912c$var$dt(t) {
    return t.fields.filter((t)=>2 /* IndexKind.CONTAINS */  !== t.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $70fd6868680e912c$var$wt(t, e) {
    let n = $70fd6868680e912c$var$et(t.collectionGroup, e.collectionGroup);
    if (0 !== n) return n;
    for(let s = 0; s < Math.min(t.fields.length, e.fields.length); ++s)if (n = $70fd6868680e912c$var$mt(t.fields[s], e.fields[s]), 0 !== n) return n;
    return $70fd6868680e912c$var$et(t.fields.length, e.fields.length);
}
/** Returns a debug representation of the field index */ $70fd6868680e912c$var$lt.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $70fd6868680e912c$var$_t {
    constructor(/** The field path of the component. */ t, /** The fields sorting order. */ e){
        this.fieldPath = t, this.kind = e;
    }
}
function $70fd6868680e912c$var$mt(t, e) {
    const n = $70fd6868680e912c$export$b7871852b967eaf1.comparator(t.fieldPath, e.fieldPath);
    return 0 !== n ? n : $70fd6868680e912c$var$et(t.kind, e.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $70fd6868680e912c$var$gt {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ t, /** The the latest indexed read time, document and batch id. */ e){
        this.sequenceNumber = t, this.offset = e;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $70fd6868680e912c$var$gt(0, $70fd6868680e912c$var$It.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $70fd6868680e912c$var$yt(t, e) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = t.toTimestamp().seconds, s = t.toTimestamp().nanoseconds + 1, i = $70fd6868680e912c$var$rt.fromTimestamp(1e9 === s ? new $70fd6868680e912c$export$d9bcbd5e1ff81430(n + 1, 0) : new $70fd6868680e912c$export$d9bcbd5e1ff81430(n, s));
    return new $70fd6868680e912c$var$It(i, $70fd6868680e912c$export$afc2e57c475b7810.empty(), e);
}
/** Creates a new offset based on the provided document. */ function $70fd6868680e912c$var$pt(t) {
    return new $70fd6868680e912c$var$It(t.readTime, t.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $70fd6868680e912c$var$It {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ t, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ e, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = t, this.documentKey = e, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $70fd6868680e912c$var$It($70fd6868680e912c$var$rt.min(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $70fd6868680e912c$var$It($70fd6868680e912c$var$rt.max(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), -1);
    }
}
function $70fd6868680e912c$var$Tt(t, e) {
    let n = t.readTime.compareTo(e.readTime);
    return 0 !== n ? n : (n = $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.documentKey, e.documentKey), 0 !== n ? n : $70fd6868680e912c$var$et(t.largestBatchId, e.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Et = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $70fd6868680e912c$var$At {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(t) {
        this.onCommittedListeners.push(t);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((t)=>t());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $70fd6868680e912c$var$vt(t) {
    if (t.code !== $70fd6868680e912c$var$q.FAILED_PRECONDITION || t.message !== $70fd6868680e912c$var$Et) throw t;
    $70fd6868680e912c$var$N("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $70fd6868680e912c$var$Rt {
    constructor(t){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, t((t)=>{
            this.isDone = !0, this.result = t, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(t);
        }, (t)=>{
            this.isDone = !0, this.error = t, this.catchCallback && this.catchCallback(t);
        });
    }
    catch(t) {
        return this.next(void 0, t);
    }
    next(t, e) {
        return this.callbackAttached && $70fd6868680e912c$var$O(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(e, this.error) : this.wrapSuccess(t, this.result) : new $70fd6868680e912c$var$Rt((n, s)=>{
            this.nextCallback = (e)=>{
                this.wrapSuccess(t, e).next(n, s);
            }, this.catchCallback = (t)=>{
                this.wrapFailure(e, t).next(n, s);
            };
        });
    }
    toPromise() {
        return new Promise((t, e)=>{
            this.next(t, e);
        });
    }
    wrapUserFunction(t) {
        try {
            const e = t();
            return e instanceof $70fd6868680e912c$var$Rt ? e : $70fd6868680e912c$var$Rt.resolve(e);
        } catch (t) {
            return $70fd6868680e912c$var$Rt.reject(t);
        }
    }
    wrapSuccess(t, e) {
        return t ? this.wrapUserFunction(()=>t(e)) : $70fd6868680e912c$var$Rt.resolve(e);
    }
    wrapFailure(t, e) {
        return t ? this.wrapUserFunction(()=>t(e)) : $70fd6868680e912c$var$Rt.reject(e);
    }
    static resolve(t) {
        return new $70fd6868680e912c$var$Rt((e, n)=>{
            e(t);
        });
    }
    static reject(t) {
        return new $70fd6868680e912c$var$Rt((e, n)=>{
            n(t);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t) {
        return new $70fd6868680e912c$var$Rt((e, n)=>{
            let s = 0, i = 0, r = !1;
            t.forEach((t)=>{
                ++s, t.next(()=>{
                    ++i, r && i === s && e();
                }, (t)=>n(t));
            }), r = !0, i === s && e();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(t) {
        let e = $70fd6868680e912c$var$Rt.resolve(!1);
        for (const n of t)e = e.next((t)=>t ? $70fd6868680e912c$var$Rt.resolve(t) : n());
        return e;
    }
    static forEach(t, e) {
        const n = [];
        return t.forEach((t, s)=>{
            n.push(e.call(this, t, s));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(t, e) {
        return new $70fd6868680e912c$var$Rt((n, s)=>{
            const i = t.length, r = new Array(i);
            let o = 0;
            for(let u = 0; u < i; u++){
                const c = u;
                e(t[c]).next((t)=>{
                    r[c] = t, ++o, o === i && n(r);
                }, (t)=>s(t));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(t, e) {
        return new $70fd6868680e912c$var$Rt((n, s)=>{
            const i = ()=>{
                !0 === t() ? e().next(()=>{
                    i();
                }, s) : n();
            };
            i();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $70fd6868680e912c$var$Pt {
    constructor(t, e){
        this.action = t, this.transaction = e, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.v = new $70fd6868680e912c$var$K, this.transaction.oncomplete = ()=>{
            this.v.resolve();
        }, this.transaction.onabort = ()=>{
            e.error ? this.v.reject(new $70fd6868680e912c$var$St(t, e.error)) : this.v.resolve();
        }, this.transaction.onerror = (e)=>{
            const n = $70fd6868680e912c$var$kt(e.target.error);
            this.v.reject(new $70fd6868680e912c$var$St(t, n));
        };
    }
    static open(t, e, n, s) {
        try {
            return new $70fd6868680e912c$var$Pt(e, t.transaction(s, n));
        } catch (t) {
            throw new $70fd6868680e912c$var$St(e, t);
        }
    }
    get R() {
        return this.v.promise;
    }
    abort(t) {
        t && this.v.reject(t), this.aborted || ($70fd6868680e912c$var$N("SimpleDb", "Aborting transaction:", t ? t.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    P() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = this.transaction;
        this.aborted || "function" != typeof t.commit || t.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(t) {
        const e = this.transaction.objectStore(t);
        return new $70fd6868680e912c$var$Ct(e);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $70fd6868680e912c$var$bt {
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(t, e, n){
        this.name = t, this.version = e, this.V = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $70fd6868680e912c$var$bt.S((0, $gMVVg.getUA)()) && $70fd6868680e912c$var$k("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /** Deletes the specified database. */ static delete(t) {
        return $70fd6868680e912c$var$N("SimpleDb", "Removing database:", t), $70fd6868680e912c$var$xt(window.indexedDB.deleteDatabase(t)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static D() {
        if (!(0, $gMVVg.isIndexedDBAvailable)()) return !1;
        if ($70fd6868680e912c$var$bt.C()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const t = (0, $gMVVg.getUA)(), e = $70fd6868680e912c$var$bt.S(t), n = 0 < e && e < 10, s = $70fd6868680e912c$var$bt.N(t), i = 0 < s && s < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(t.indexOf("MSIE ") > 0 || t.indexOf("Trident/") > 0 || t.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static C() {
        var t;
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static M(t, e) {
        return t.store(e);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static S(t) {
        const e = t.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = e ? e[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */ static N(t) {
        const e = t.match(/Android ([\d.]+)/i), n = e ? e[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async $(t) {
        return this.db || ($70fd6868680e912c$var$N("SimpleDb", "Opening database:", this.name), this.db = await new Promise((e, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const s = indexedDB.open(this.name, this.version);
            s.onsuccess = (t)=>{
                const n = t.target.result;
                e(n);
            }, s.onblocked = ()=>{
                n(new $70fd6868680e912c$var$St(t, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, s.onerror = (e)=>{
                const s = e.target.error;
                "VersionError" === s.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === s.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + s)) : n(new $70fd6868680e912c$var$St(t, s));
            }, s.onupgradeneeded = (t)=>{
                $70fd6868680e912c$var$N("SimpleDb", 'Database "' + this.name + '" requires upgrade from version:', t.oldVersion);
                const e = t.target.result;
                this.V.O(e, s.transaction, t.oldVersion, this.version).next(()=>{
                    $70fd6868680e912c$var$N("SimpleDb", "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.F && (this.db.onversionchange = (t)=>this.F(t)), this.db;
    }
    B(t) {
        this.F = t, this.db && (this.db.onversionchange = (e)=>t(e));
    }
    async runTransaction(t, e, n, s) {
        const i = "readonly" === e;
        let r = 0;
        for(;;){
            ++r;
            try {
                this.db = await this.$(t);
                const e = $70fd6868680e912c$var$Pt.open(this.db, t, i ? "readonly" : "readwrite", n), r = s(e).next((t)=>(e.P(), t)).catch((t)=>// Abort the transaction if there was an error.
                    (e.abort(t), $70fd6868680e912c$var$Rt.reject(t))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return r.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await e.R, r;
            } catch (t) {
                const e = t, n = "FirebaseError" !== e.name && r < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($70fd6868680e912c$var$N("SimpleDb", "Transaction failed with error:", e.message, "Retrying:", n), this.close(), !n) return Promise.reject(e);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $70fd6868680e912c$var$Vt {
    constructor(t){
        this.L = t, this.q = !1, this.U = null;
    }
    get isDone() {
        return this.q;
    }
    get K() {
        return this.U;
    }
    set cursor(t) {
        this.L = t;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.q = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ G(t) {
        this.U = t;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $70fd6868680e912c$var$xt(this.L.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $70fd6868680e912c$var$St extends $70fd6868680e912c$export$8fada0bf726bf278 {
    constructor(t, e){
        super($70fd6868680e912c$var$q.UNAVAILABLE, `IndexedDB transaction '${t}' failed: ${e}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $70fd6868680e912c$var$Dt(t) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === t.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $70fd6868680e912c$var$Ct {
    constructor(t){
        this.store = t;
    }
    put(t, e) {
        let n;
        return void 0 !== e ? ($70fd6868680e912c$var$N("SimpleDb", "PUT", this.store.name, t, e), n = this.store.put(e, t)) : ($70fd6868680e912c$var$N("SimpleDb", "PUT", this.store.name, "<auto-key>", t), n = this.store.put(t)), $70fd6868680e912c$var$xt(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(t) {
        $70fd6868680e912c$var$N("SimpleDb", "ADD", this.store.name, t, t);
        return $70fd6868680e912c$var$xt(this.store.add(t));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(t) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $70fd6868680e912c$var$xt(this.store.get(t)).next((e)=>// Normalize nonexistence to null.
            (void 0 === e && (e = null), $70fd6868680e912c$var$N("SimpleDb", "GET", this.store.name, t, e), e));
    }
    delete(t) {
        $70fd6868680e912c$var$N("SimpleDb", "DELETE", this.store.name, t);
        return $70fd6868680e912c$var$xt(this.store.delete(t));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $70fd6868680e912c$var$N("SimpleDb", "COUNT", this.store.name);
        return $70fd6868680e912c$var$xt(this.store.count());
    }
    j(t, e) {
        const n = this.options(t, e);
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster. Unfortunately, getAll() does not support custom indices.
        if (n.index || "function" != typeof this.store.getAll) {
            const t = this.cursor(n), e = [];
            return this.W(t, (t, n)=>{
                e.push(n);
            }).next(()=>e);
        }
        {
            const t = this.store.getAll(n.range);
            return new $70fd6868680e912c$var$Rt((e, n)=>{
                t.onerror = (t)=>{
                    n(t.target.error);
                }, t.onsuccess = (t)=>{
                    e(t.target.result);
                };
            });
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ H(t, e) {
        const n = this.store.getAll(t, null === e ? void 0 : e);
        return new $70fd6868680e912c$var$Rt((t, e)=>{
            n.onerror = (t)=>{
                e(t.target.error);
            }, n.onsuccess = (e)=>{
                t(e.target.result);
            };
        });
    }
    J(t, e) {
        $70fd6868680e912c$var$N("SimpleDb", "DELETE ALL", this.store.name);
        const n = this.options(t, e);
        n.Y = !1;
        const s = this.cursor(n);
        return this.W(s, (t, e, n)=>n.delete());
    }
    X(t, e) {
        let n;
        e ? n = t : (n = {}, e = t);
        const s = this.cursor(n);
        return this.W(s, e);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ Z(t) {
        const e = this.cursor({});
        return new $70fd6868680e912c$var$Rt((n, s)=>{
            e.onerror = (t)=>{
                const e = $70fd6868680e912c$var$kt(t.target.error);
                s(e);
            }, e.onsuccess = (e)=>{
                const s = e.target.result;
                s ? t(s.primaryKey, s.value).next((t)=>{
                    t ? s.continue() : n();
                }) : n();
            };
        });
    }
    W(t, e) {
        const n = [];
        return new $70fd6868680e912c$var$Rt((s, i)=>{
            t.onerror = (t)=>{
                i(t.target.error);
            }, t.onsuccess = (t)=>{
                const i = t.target.result;
                if (!i) return void s();
                const r = new $70fd6868680e912c$var$Vt(i), o = e(i.primaryKey, i.value, r);
                if (o instanceof $70fd6868680e912c$var$Rt) {
                    const t = o.catch((t)=>(r.done(), $70fd6868680e912c$var$Rt.reject(t)));
                    n.push(t);
                }
                r.isDone ? s() : null === r.K ? i.continue() : i.continue(r.K);
            };
        }).next(()=>$70fd6868680e912c$var$Rt.waitFor(n));
    }
    options(t, e) {
        let n;
        return void 0 !== t && ("string" == typeof t ? n = t : e = t), {
            index: n,
            range: e
        };
    }
    cursor(t) {
        let e = "next";
        if (t.reverse && (e = "prev"), t.index) {
            const n = this.store.index(t.index);
            return t.Y ? n.openKeyCursor(t.range, e) : n.openCursor(t.range, e);
        }
        return this.store.openCursor(t.range, e);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $70fd6868680e912c$var$xt(t) {
    return new $70fd6868680e912c$var$Rt((e, n)=>{
        t.onsuccess = (t)=>{
            const n = t.target.result;
            e(n);
        }, t.onerror = (t)=>{
            const e = $70fd6868680e912c$var$kt(t.target.error);
            n(e);
        };
    });
}
// Guard so we only report the error once.
let $70fd6868680e912c$var$Nt = !1;
function $70fd6868680e912c$var$kt(t) {
    const e = $70fd6868680e912c$var$bt.S((0, $gMVVg.getUA)());
    if (e >= 12.2 && e < 13) {
        const e = "An internal error was encountered in the Indexed Database server";
        if (t.message.indexOf(e) >= 0) {
            // Wrap error in a more descriptive one.
            const t = new $70fd6868680e912c$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${e}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $70fd6868680e912c$var$Nt || ($70fd6868680e912c$var$Nt = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw t;
            }, 0)), t;
        }
    }
    return t;
}
/** This class is responsible for the scheduling of Index Backfiller. */ class $70fd6868680e912c$var$Mt {
    constructor(t, e){
        this.asyncQueue = t, this.tt = e, this.task = null;
    }
    start() {
        this.et(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    et(t) {
        $70fd6868680e912c$var$N("IndexBackiller", `Scheduled in ${t}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , t, async ()=>{
            this.task = null;
            try {
                $70fd6868680e912c$var$N("IndexBackiller", `Documents written: ${await this.tt.nt()}`);
            } catch (t) {
                $70fd6868680e912c$var$Dt(t) ? $70fd6868680e912c$var$N("IndexBackiller", "Ignoring IndexedDB error during index backfill: ", t) : await $70fd6868680e912c$var$vt(t);
            }
            await this.et(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $70fd6868680e912c$var$$t {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ t, e){
        this.localStore = t, this.persistence = e;
    }
    async nt(t = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (e)=>this.st(e, t));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ st(t, e) {
        const n = new Set;
        let s = e, i = !0;
        return $70fd6868680e912c$var$Rt.doWhile(()=>!0 === i && s > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(t).next((e)=>{
                if (null !== e && !n.has(e)) return $70fd6868680e912c$var$N("IndexBackiller", `Processing collection: ${e}`), this.it(t, e, s).next((t)=>{
                    s -= t, n.add(e);
                });
                i = !1;
            })).next(()=>e - s);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ it(t, e, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(t, e).next((s)=>this.localStore.localDocuments.getNextDocuments(t, e, s, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(t, i).next(()=>this.rt(s, n)).next((n)=>($70fd6868680e912c$var$N("IndexBackiller", `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(t, e, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ rt(t, e) {
        let n = t;
        return e.changes.forEach((t, e)=>{
            const s = $70fd6868680e912c$var$pt(e);
            $70fd6868680e912c$var$Tt(s, n) > 0 && (n = s);
        }), new $70fd6868680e912c$var$It(n.readTime, n.documentKey, Math.max(e.batchId, t.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $70fd6868680e912c$var$Ot {
    constructor(t, e){
        this.previousValue = t, e && (e.sequenceNumberHandler = (t)=>this.ot(t), this.ut = (t)=>e.writeSequenceNumber(t));
    }
    ot(t) {
        return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
    }
    next() {
        const t = ++this.previousValue;
        return this.ut && this.ut(t), t;
    }
}
$70fd6868680e912c$var$Ot.ct = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $70fd6868680e912c$var$Ft(t) {
    return null == t;
}
/** Returns whether the value represents -0. */ function $70fd6868680e912c$var$Bt(t) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === t && 1 / t == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $70fd6868680e912c$var$Lt(t) {
    return "number" == typeof t && Number.isInteger(t) && !$70fd6868680e912c$var$Bt(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $70fd6868680e912c$var$qt(t) {
    let e = "";
    for(let n = 0; n < t.length; n++)e.length > 0 && (e = $70fd6868680e912c$var$Kt(e)), e = $70fd6868680e912c$var$Ut(t.get(n), e);
    return $70fd6868680e912c$var$Kt(e);
}
/** Encodes a single segment of a resource path into the given result */ function $70fd6868680e912c$var$Ut(t, e) {
    let n = e;
    const s = t.length;
    for(let e = 0; e < s; e++){
        const s = t.charAt(e);
        switch(s){
            case "\0":
                n += "";
                break;
            case "":
                n += "";
                break;
            default:
                n += s;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $70fd6868680e912c$var$Kt(t) {
    return t + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $70fd6868680e912c$var$Gt(t) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const e = t.length;
    if ($70fd6868680e912c$var$F(e >= 2), 2 === e) return $70fd6868680e912c$var$F("" === t.charAt(0) && "" === t.charAt(1)), $70fd6868680e912c$var$ut.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = e - 2, n = [];
    let s = "";
    for(let i = 0; i < e;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const e = t.indexOf("", i);
        (e < 0 || e > __PRIVATE_lastReasonableEscapeIndex) && $70fd6868680e912c$var$O();
        switch(t.charAt(e + 1)){
            case "":
                const r = t.substring(i, e);
                let o;
                0 === s.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = r : (s += r, o = s, s = ""), n.push(o);
                break;
            case "":
                s += t.substring(i, e), s += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                s += t.substring(i, e + 1);
                break;
            default:
                $70fd6868680e912c$var$O();
        }
        i = e + 2;
    }
    return new $70fd6868680e912c$var$ut(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Qt = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $70fd6868680e912c$var$jt(t, e) {
    return [
        t,
        $70fd6868680e912c$var$qt(e)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $70fd6868680e912c$var$zt(t, e, n) {
    return [
        t,
        $70fd6868680e912c$var$qt(e),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $70fd6868680e912c$var$Wt = {}, $70fd6868680e912c$var$Ht = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $70fd6868680e912c$var$Jt = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $70fd6868680e912c$var$Yt = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $70fd6868680e912c$var$Xt = [
    "canonicalId",
    "targetId"
], $70fd6868680e912c$var$Zt = [
    "targetId",
    "path"
], $70fd6868680e912c$var$te = [
    "path",
    "targetId"
], $70fd6868680e912c$var$ee = [
    "collectionId",
    "parent"
], $70fd6868680e912c$var$ne = [
    "indexId",
    "uid"
], $70fd6868680e912c$var$se = [
    "uid",
    "sequenceNumber"
], $70fd6868680e912c$var$ie = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $70fd6868680e912c$var$re = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $70fd6868680e912c$var$oe = [
    "userId",
    "collectionPath",
    "documentId"
], $70fd6868680e912c$var$ue = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $70fd6868680e912c$var$ce = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $70fd6868680e912c$var$ae = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], $70fd6868680e912c$var$he = [
    ...$70fd6868680e912c$var$ae,
    "documentOverlays"
], $70fd6868680e912c$var$le = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], $70fd6868680e912c$var$fe = $70fd6868680e912c$var$le, $70fd6868680e912c$var$de = [
    ...$70fd6868680e912c$var$fe,
    "indexConfiguration",
    "indexState",
    "indexEntries"
];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$we extends $70fd6868680e912c$var$At {
    constructor(t, e){
        super(), this.ht = t, this.currentSequenceNumber = e;
    }
}
function $70fd6868680e912c$var$_e(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return $70fd6868680e912c$var$bt.M(n.ht, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$me(t) {
    let e = 0;
    for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && e++;
    return e;
}
function $70fd6868680e912c$var$ge(t, e) {
    for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]);
}
function $70fd6868680e912c$var$ye(t) {
    for(const e in t)if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $70fd6868680e912c$var$pe {
    constructor(t, e){
        this.comparator = t, this.root = e || $70fd6868680e912c$var$Te.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(t, e) {
        return new $70fd6868680e912c$var$pe(this.comparator, this.root.insert(t, e, this.comparator).copy(null, null, $70fd6868680e912c$var$Te.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(t) {
        return new $70fd6868680e912c$var$pe(this.comparator, this.root.remove(t, this.comparator).copy(null, null, $70fd6868680e912c$var$Te.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(t) {
        let e = this.root;
        for(; !e.isEmpty();){
            const n = this.comparator(t, e.key);
            if (0 === n) return e.value;
            n < 0 ? e = e.left : n > 0 && (e = e.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(t) {
        // Number of nodes that were pruned when descending right
        let e = 0, n = this.root;
        for(; !n.isEmpty();){
            const s = this.comparator(t, n.key);
            if (0 === s) return e + n.left.size;
            s < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (e += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.root.inorderTraversal(t);
    }
    forEach(t) {
        this.inorderTraversal((e, n)=>(t(e, n), !1));
    }
    toString() {
        const t = [];
        return this.inorderTraversal((e, n)=>(t.push(`${e}:${n}`), !1)), `{${t.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.root.reverseTraversal(t);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $70fd6868680e912c$var$Ie(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(t) {
        return new $70fd6868680e912c$var$Ie(this.root, t, this.comparator, !1);
    }
    getReverseIterator() {
        return new $70fd6868680e912c$var$Ie(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(t) {
        return new $70fd6868680e912c$var$Ie(this.root, t, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $70fd6868680e912c$var$Ie {
    constructor(t, e, n, s){
        this.isReverse = s, this.nodeStack = [];
        let i = 1;
        for(; !t.isEmpty();)if (i = e ? n(t.key, e) : 1, // flip the comparison if we're going in reverse
        e && s && (i *= -1), i < 0) // This node is less than our start key. ignore it
        t = this.isReverse ? t.left : t.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(t);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(t), t = this.isReverse ? t.right : t.left;
        }
    }
    getNext() {
        let t = this.nodeStack.pop();
        const e = {
            key: t.key,
            value: t.value
        };
        if (this.isReverse) for(t = t.left; !t.isEmpty();)this.nodeStack.push(t), t = t.right;
        else for(t = t.right; !t.isEmpty();)this.nodeStack.push(t), t = t.left;
        return e;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const t = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: t.key,
            value: t.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $70fd6868680e912c$var$Te {
    constructor(t, e, n, s, i){
        this.key = t, this.value = e, this.color = null != n ? n : $70fd6868680e912c$var$Te.RED, this.left = null != s ? s : $70fd6868680e912c$var$Te.EMPTY, this.right = null != i ? i : $70fd6868680e912c$var$Te.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(t, e, n, s, i) {
        return new $70fd6868680e912c$var$Te(null != t ? t : this.key, null != e ? e : this.value, null != n ? n : this.color, null != s ? s : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.left.inorderTraversal(t) || t(this.key, this.value) || this.right.inorderTraversal(t);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.right.reverseTraversal(t) || t(this.key, this.value) || this.left.reverseTraversal(t);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(t, e, n) {
        let s = this;
        const i = n(t, s.key);
        return s = i < 0 ? s.copy(null, null, null, s.left.insert(t, e, n), null) : 0 === i ? s.copy(null, e, null, null, null) : s.copy(null, null, null, null, s.right.insert(t, e, n)), s.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $70fd6868680e912c$var$Te.EMPTY;
        let t = this;
        return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(t, e) {
        let n, s = this;
        if (e(t, s.key) < 0) s.left.isEmpty() || s.left.isRed() || s.left.left.isRed() || (s = s.moveRedLeft()), s = s.copy(null, null, null, s.left.remove(t, e), null);
        else {
            if (s.left.isRed() && (s = s.rotateRight()), s.right.isEmpty() || s.right.isRed() || s.right.left.isRed() || (s = s.moveRedRight()), 0 === e(t, s.key)) {
                if (s.right.isEmpty()) return $70fd6868680e912c$var$Te.EMPTY;
                n = s.right.min(), s = s.copy(n.key, n.value, null, null, s.right.removeMin());
            }
            s = s.copy(null, null, null, null, s.right.remove(t, e));
        }
        return s.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let t = this;
        return t.right.isRed() && !t.left.isRed() && (t = t.rotateLeft()), t.left.isRed() && t.left.left.isRed() && (t = t.rotateRight()), t.left.isRed() && t.right.isRed() && (t = t.colorFlip()), t;
    }
    moveRedLeft() {
        let t = this.colorFlip();
        return t.right.left.isRed() && (t = t.copy(null, null, null, null, t.right.rotateRight()), t = t.rotateLeft(), t = t.colorFlip()), t;
    }
    moveRedRight() {
        let t = this.colorFlip();
        return t.left.left.isRed() && (t = t.rotateRight(), t = t.colorFlip()), t;
    }
    rotateLeft() {
        const t = this.copy(null, null, $70fd6868680e912c$var$Te.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, t, null);
    }
    rotateRight() {
        const t = this.copy(null, null, $70fd6868680e912c$var$Te.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, t);
    }
    colorFlip() {
        const t = this.left.copy(null, null, !this.left.color, null, null), e = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, t, e);
    }
    // For testing.
    checkMaxDepth() {
        const t = this.check();
        return Math.pow(2, t) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $70fd6868680e912c$var$O();
        if (this.right.isRed()) throw $70fd6868680e912c$var$O();
        const t = this.left.check();
        if (t !== this.right.check()) throw $70fd6868680e912c$var$O();
        return t + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$70fd6868680e912c$var$Te.EMPTY = null, $70fd6868680e912c$var$Te.RED = !0, $70fd6868680e912c$var$Te.BLACK = !1;
// end LLRBEmptyNode
$70fd6868680e912c$var$Te.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $70fd6868680e912c$var$O();
    }
    get value() {
        throw $70fd6868680e912c$var$O();
    }
    get color() {
        throw $70fd6868680e912c$var$O();
    }
    get left() {
        throw $70fd6868680e912c$var$O();
    }
    get right() {
        throw $70fd6868680e912c$var$O();
    }
    // Returns a copy of the current node.
    copy(t, e, n, s, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(t, e, n) {
        return new $70fd6868680e912c$var$Te(t, e);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(t, e) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(t) {
        return !1;
    }
    reverseTraversal(t) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $70fd6868680e912c$var$Ee {
    constructor(t){
        this.comparator = t, this.data = new $70fd6868680e912c$var$pe(this.comparator);
    }
    has(t) {
        return null !== this.data.get(t);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(t) {
        return this.data.indexOf(t);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(t) {
        this.data.inorderTraversal((e, n)=>(t(e), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(t, e) {
        const n = this.data.getIteratorFrom(t[0]);
        for(; n.hasNext();){
            const s = n.getNext();
            if (this.comparator(s.key, t[1]) >= 0) return;
            e(s.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(t, e) {
        let n;
        for(n = void 0 !== e ? this.data.getIteratorFrom(e) : this.data.getIterator(); n.hasNext();){
            if (!t(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(t) {
        const e = this.data.getIteratorFrom(t);
        return e.hasNext() ? e.getNext().key : null;
    }
    getIterator() {
        return new $70fd6868680e912c$var$Ae(this.data.getIterator());
    }
    getIteratorFrom(t) {
        return new $70fd6868680e912c$var$Ae(this.data.getIteratorFrom(t));
    }
    /** Inserts or updates an element */ add(t) {
        return this.copy(this.data.remove(t).insert(t, !0));
    }
    /** Deletes an element */ delete(t) {
        return this.has(t) ? this.copy(this.data.remove(t)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(t) {
        let e = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return e.size < t.size && (e = t, t = this), t.forEach((t)=>{
            e = e.add(t);
        }), e;
    }
    isEqual(t) {
        if (!(t instanceof $70fd6868680e912c$var$Ee)) return !1;
        if (this.size !== t.size) return !1;
        const e = this.data.getIterator(), n = t.data.getIterator();
        for(; e.hasNext();){
            const t = e.getNext().key, s = n.getNext().key;
            if (0 !== this.comparator(t, s)) return !1;
        }
        return !0;
    }
    toArray() {
        const t = [];
        return this.forEach((e)=>{
            t.push(e);
        }), t;
    }
    toString() {
        const t = [];
        return this.forEach((e)=>t.push(e)), "SortedSet(" + t.toString() + ")";
    }
    copy(t) {
        const e = new $70fd6868680e912c$var$Ee(this.comparator);
        return e.data = t, e;
    }
}
class $70fd6868680e912c$var$Ae {
    constructor(t){
        this.iter = t;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $70fd6868680e912c$var$ve(t) {
    return t.hasNext() ? t.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $70fd6868680e912c$var$Re {
    constructor(t){
        this.fields = t, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        t.sort($70fd6868680e912c$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $70fd6868680e912c$var$Re([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(t) {
        let e = new $70fd6868680e912c$var$Ee($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (const t of this.fields)e = e.add(t);
        for (const n of t)e = e.add(n);
        return new $70fd6868680e912c$var$Re(e.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(t) {
        for (const e of this.fields)if (e.isPrefixOf(t)) return !0;
        return !1;
    }
    isEqual(t) {
        return $70fd6868680e912c$var$nt(this.fields, t.fields, (t, e)=>t.isEqual(e));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $70fd6868680e912c$var$Pe extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $70fd6868680e912c$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $70fd6868680e912c$var$Ve {
    constructor(t){
        this.binaryString = t;
    }
    static fromBase64String(t) {
        const e = function(t) {
            try {
                return atob(t);
            } catch (t) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && t instanceof DOMException ? new $70fd6868680e912c$var$Pe("Invalid base64 string: " + t) : t;
            }
        }(t);
        return new $70fd6868680e912c$var$Ve(e);
    }
    static fromUint8Array(t) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const e = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function(t) {
            let e = "";
            for(let n = 0; n < t.length; ++n)e += String.fromCharCode(t[n]);
            return e;
        }(t);
        return new $70fd6868680e912c$var$Ve(e);
    }
    [Symbol.iterator]() {
        let t = 0;
        return {
            next: ()=>t < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(t++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        var t;
        return t = this.binaryString, btoa(t);
    }
    toUint8Array() {
        return function(t) {
            const e = new Uint8Array(t.length);
            for(let n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
            return e;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(t) {
        return $70fd6868680e912c$var$et(this.binaryString, t.binaryString);
    }
    isEqual(t) {
        return this.binaryString === t.binaryString;
    }
}
$70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING = new $70fd6868680e912c$var$Ve("");
const $70fd6868680e912c$var$Se = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $70fd6868680e912c$var$De(t) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($70fd6868680e912c$var$F(!!t), "string" == typeof t) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let e = 0;
        const n = $70fd6868680e912c$var$Se.exec(t);
        if ($70fd6868680e912c$var$F(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let t = n[1];
            t = (t + "000000000").substr(0, 9), e = Number(t);
        }
        // Parse the date to get the seconds.
        const s = new Date(t);
        return {
            seconds: Math.floor(s.getTime() / 1e3),
            nanos: e
        };
    }
    return {
        seconds: $70fd6868680e912c$var$Ce(t.seconds),
        nanos: $70fd6868680e912c$var$Ce(t.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $70fd6868680e912c$var$Ce(t) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $70fd6868680e912c$var$xe(t) {
    return "string" == typeof t ? $70fd6868680e912c$var$Ve.fromBase64String(t) : $70fd6868680e912c$var$Ve.fromUint8Array(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $70fd6868680e912c$var$Ne(t) {
    var e, n;
    return "server_timestamp" === (null === (n = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $70fd6868680e912c$var$ke(t) {
    const e = t.mapValue.fields.__previous_value__;
    return $70fd6868680e912c$var$Ne(e) ? $70fd6868680e912c$var$ke(e) : e;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $70fd6868680e912c$var$Me(t) {
    const e = $70fd6868680e912c$var$De(t.mapValue.fields.__local_write_time__.timestampValue);
    return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$$e {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(t, e, n, s, i, r, o, u, c){
        this.databaseId = t, this.appId = e, this.persistenceKey = n, this.host = s, this.ssl = i, this.forceLongPolling = r, this.autoDetectLongPolling = o, this.longPollingOptions = u, this.useFetchStreams = c;
    }
}
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $70fd6868680e912c$export$4c3ccc07620ae30a {
    constructor(t, e){
        this.projectId = t, this.database = e || "(default)";
    }
    static empty() {
        return new $70fd6868680e912c$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$export$4c3ccc07620ae30a && t.projectId === this.projectId && t.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Fe = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, $70fd6868680e912c$var$Be = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $70fd6868680e912c$var$Le(t) {
    return "nullValue" in t ? 0 /* TypeOrder.NullValue */  : "booleanValue" in t ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in t || "doubleValue" in t ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in t ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in t ? 5 /* TypeOrder.StringValue */  : "bytesValue" in t ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in t ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in t ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in t ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in t ? $70fd6868680e912c$var$Ne(t) ? 4 /* TypeOrder.ServerTimestampValue */  : $70fd6868680e912c$var$en(t) ? 9007199254740991 /* TypeOrder.MaxValue */  : 10 /* TypeOrder.ObjectValue */  : $70fd6868680e912c$var$O();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $70fd6868680e912c$var$qe(t, e) {
    if (t === e) return !0;
    const n = $70fd6868680e912c$var$Le(t);
    if (n !== $70fd6868680e912c$var$Le(e)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return t.booleanValue === e.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$Me(t).isEqual($70fd6868680e912c$var$Me(e));
        case 3 /* TypeOrder.TimestampValue */ :
            return function(t, e) {
                if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return t.timestampValue === e.timestampValue;
                const n = $70fd6868680e912c$var$De(t.timestampValue), s = $70fd6868680e912c$var$De(e.timestampValue);
                return n.seconds === s.seconds && n.nanos === s.nanos;
            }(t, e);
        case 5 /* TypeOrder.StringValue */ :
            return t.stringValue === e.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function(t, e) {
                return $70fd6868680e912c$var$xe(t.bytesValue).isEqual($70fd6868680e912c$var$xe(e.bytesValue));
            }(t, e);
        case 7 /* TypeOrder.RefValue */ :
            return t.referenceValue === e.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function(t, e) {
                return $70fd6868680e912c$var$Ce(t.geoPointValue.latitude) === $70fd6868680e912c$var$Ce(e.geoPointValue.latitude) && $70fd6868680e912c$var$Ce(t.geoPointValue.longitude) === $70fd6868680e912c$var$Ce(e.geoPointValue.longitude);
            }(t, e);
        case 2 /* TypeOrder.NumberValue */ :
            return function(t, e) {
                if ("integerValue" in t && "integerValue" in e) return $70fd6868680e912c$var$Ce(t.integerValue) === $70fd6868680e912c$var$Ce(e.integerValue);
                if ("doubleValue" in t && "doubleValue" in e) {
                    const n = $70fd6868680e912c$var$Ce(t.doubleValue), s = $70fd6868680e912c$var$Ce(e.doubleValue);
                    return n === s ? $70fd6868680e912c$var$Bt(n) === $70fd6868680e912c$var$Bt(s) : isNaN(n) && isNaN(s);
                }
                return !1;
            }(t, e);
        case 9 /* TypeOrder.ArrayValue */ :
            return $70fd6868680e912c$var$nt(t.arrayValue.values || [], e.arrayValue.values || [], $70fd6868680e912c$var$qe);
        case 10 /* TypeOrder.ObjectValue */ :
            return function(t, e) {
                const n = t.mapValue.fields || {}, s = e.mapValue.fields || {};
                if ($70fd6868680e912c$var$me(n) !== $70fd6868680e912c$var$me(s)) return !1;
                for(const t in n)if (n.hasOwnProperty(t) && (void 0 === s[t] || !$70fd6868680e912c$var$qe(n[t], s[t]))) return !1;
                return !0;
            }(t, e);
        default:
            return $70fd6868680e912c$var$O();
    }
}
function $70fd6868680e912c$var$Ue(t, e) {
    return void 0 !== (t.values || []).find((t)=>$70fd6868680e912c$var$qe(t, e));
}
function $70fd6868680e912c$var$Ke(t, e) {
    if (t === e) return 0;
    const n = $70fd6868680e912c$var$Le(t), s = $70fd6868680e912c$var$Le(e);
    if (n !== s) return $70fd6868680e912c$var$et(n, s);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $70fd6868680e912c$var$et(t.booleanValue, e.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function(t, e) {
                const n = $70fd6868680e912c$var$Ce(t.integerValue || t.doubleValue), s = $70fd6868680e912c$var$Ce(e.integerValue || e.doubleValue);
                return n < s ? -1 : n > s ? 1 : n === s ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(s) ? 0 : -1 : 1;
            }(t, e);
        case 3 /* TypeOrder.TimestampValue */ :
            return $70fd6868680e912c$var$Ge(t.timestampValue, e.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$Ge($70fd6868680e912c$var$Me(t), $70fd6868680e912c$var$Me(e));
        case 5 /* TypeOrder.StringValue */ :
            return $70fd6868680e912c$var$et(t.stringValue, e.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function(t, e) {
                const n = $70fd6868680e912c$var$xe(t), s = $70fd6868680e912c$var$xe(e);
                return n.compareTo(s);
            }(t.bytesValue, e.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function(t, e) {
                const n = t.split("/"), s = e.split("/");
                for(let t = 0; t < n.length && t < s.length; t++){
                    const e = $70fd6868680e912c$var$et(n[t], s[t]);
                    if (0 !== e) return e;
                }
                return $70fd6868680e912c$var$et(n.length, s.length);
            }(t.referenceValue, e.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function(t, e) {
                const n = $70fd6868680e912c$var$et($70fd6868680e912c$var$Ce(t.latitude), $70fd6868680e912c$var$Ce(e.latitude));
                if (0 !== n) return n;
                return $70fd6868680e912c$var$et($70fd6868680e912c$var$Ce(t.longitude), $70fd6868680e912c$var$Ce(e.longitude));
            }(t.geoPointValue, e.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return function(t, e) {
                const n = t.values || [], s = e.values || [];
                for(let t = 0; t < n.length && t < s.length; ++t){
                    const e = $70fd6868680e912c$var$Ke(n[t], s[t]);
                    if (e) return e;
                }
                return $70fd6868680e912c$var$et(n.length, s.length);
            }(t.arrayValue, e.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function(t, e) {
                if (t === $70fd6868680e912c$var$Fe.mapValue && e === $70fd6868680e912c$var$Fe.mapValue) return 0;
                if (t === $70fd6868680e912c$var$Fe.mapValue) return 1;
                if (e === $70fd6868680e912c$var$Fe.mapValue) return -1;
                const n = t.fields || {}, s = Object.keys(n), i = e.fields || {}, r = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                s.sort(), r.sort();
                for(let t = 0; t < s.length && t < r.length; ++t){
                    const e = $70fd6868680e912c$var$et(s[t], r[t]);
                    if (0 !== e) return e;
                    const o = $70fd6868680e912c$var$Ke(n[s[t]], i[r[t]]);
                    if (0 !== o) return o;
                }
                return $70fd6868680e912c$var$et(s.length, r.length);
            }(t.mapValue, e.mapValue);
        default:
            throw $70fd6868680e912c$var$O();
    }
}
function $70fd6868680e912c$var$Ge(t, e) {
    if ("string" == typeof t && "string" == typeof e && t.length === e.length) return $70fd6868680e912c$var$et(t, e);
    const n = $70fd6868680e912c$var$De(t), s = $70fd6868680e912c$var$De(e), i = $70fd6868680e912c$var$et(n.seconds, s.seconds);
    return 0 !== i ? i : $70fd6868680e912c$var$et(n.nanos, s.nanos);
}
function $70fd6868680e912c$var$Qe(t) {
    return $70fd6868680e912c$var$je(t);
}
function $70fd6868680e912c$var$je(t) {
    var e, n;
    return "nullValue" in t ? "null" : "booleanValue" in t ? "" + t.booleanValue : "integerValue" in t ? "" + t.integerValue : "doubleValue" in t ? "" + t.doubleValue : "timestampValue" in t ? function(t) {
        const e = $70fd6868680e912c$var$De(t);
        return `time(${e.seconds},${e.nanos})`;
    }(t.timestampValue) : "stringValue" in t ? t.stringValue : "bytesValue" in t ? $70fd6868680e912c$var$xe(t.bytesValue).toBase64() : "referenceValue" in t ? (n = t.referenceValue, $70fd6868680e912c$export$afc2e57c475b7810.fromName(n).toString()) : "geoPointValue" in t ? `geo(${(e = t.geoPointValue).latitude},${e.longitude})` : "arrayValue" in t ? function(t) {
        let e = "[", n = !0;
        for (const s of t.values || [])n ? n = !1 : e += ",", e += $70fd6868680e912c$var$je(s);
        return e + "]";
    }(t.arrayValue) : "mapValue" in t ? function(t) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const e = Object.keys(t.fields || {}).sort();
        let n = "{", s = !0;
        for (const i of e)s ? s = !1 : n += ",", n += `${i}:${$70fd6868680e912c$var$je(t.fields[i])}`;
        return n + "}";
    }(t.mapValue) : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$ze(t) {
    switch($70fd6868680e912c$var$Le(t)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const e = $70fd6868680e912c$var$ke(t);
            return e ? 16 + $70fd6868680e912c$var$ze(e) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * t.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $70fd6868680e912c$var$xe(t.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return t.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return (t.arrayValue.values || []).reduce((t, e)=>t + $70fd6868680e912c$var$ze(e), 0);
        case 10 /* TypeOrder.ObjectValue */ :
            return function(t) {
                let e = 0;
                return $70fd6868680e912c$var$ge(t.fields, (t, n)=>{
                    e += t.length + $70fd6868680e912c$var$ze(n);
                }), e;
            }(t.mapValue);
        default:
            throw $70fd6868680e912c$var$O();
    }
}
/** Returns a reference value for the provided database and key. */ function $70fd6868680e912c$var$We(t, e) {
    return {
        referenceValue: `projects/${t.projectId}/databases/${t.database}/documents/${e.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $70fd6868680e912c$var$He(t) {
    return !!t && "integerValue" in t;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $70fd6868680e912c$var$Je(t) {
    return !!t && "arrayValue" in t;
}
/** Returns true if `value` is a NullValue. */ function $70fd6868680e912c$var$Ye(t) {
    return !!t && "nullValue" in t;
}
/** Returns true if `value` is NaN. */ function $70fd6868680e912c$var$Xe(t) {
    return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $70fd6868680e912c$var$Ze(t) {
    return !!t && "mapValue" in t;
}
/** Creates a deep copy of `source`. */ function $70fd6868680e912c$var$tn(t) {
    if (t.geoPointValue) return {
        geoPointValue: Object.assign({}, t.geoPointValue)
    };
    if (t.timestampValue && "object" == typeof t.timestampValue) return {
        timestampValue: Object.assign({}, t.timestampValue)
    };
    if (t.mapValue) {
        const e = {
            mapValue: {
                fields: {}
            }
        };
        return $70fd6868680e912c$var$ge(t.mapValue.fields, (t, n)=>e.mapValue.fields[t] = $70fd6868680e912c$var$tn(n)), e;
    }
    if (t.arrayValue) {
        const e = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (t.arrayValue.values || []).length; ++n)e.arrayValue.values[n] = $70fd6868680e912c$var$tn(t.arrayValue.values[n]);
        return e;
    }
    return Object.assign({}, t);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $70fd6868680e912c$var$en(t) {
    return "__max__" === (((t.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
/** Returns the lowest value for the given value type (inclusive). */ function $70fd6868680e912c$var$nn(t) {
    return "nullValue" in t ? $70fd6868680e912c$var$Be : "booleanValue" in t ? {
        booleanValue: !1
    } : "integerValue" in t || "doubleValue" in t ? {
        doubleValue: NaN
    } : "timestampValue" in t ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in t ? {
        stringValue: ""
    } : "bytesValue" in t ? {
        bytesValue: ""
    } : "referenceValue" in t ? $70fd6868680e912c$var$We($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "geoPointValue" in t ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in t ? {
        arrayValue: {}
    } : "mapValue" in t ? {
        mapValue: {}
    } : $70fd6868680e912c$var$O();
}
/** Returns the largest value for the given value type (exclusive). */ function $70fd6868680e912c$var$sn(t) {
    return "nullValue" in t ? {
        booleanValue: !1
    } : "booleanValue" in t ? {
        doubleValue: NaN
    } : "integerValue" in t || "doubleValue" in t ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in t ? {
        stringValue: ""
    } : "stringValue" in t ? {
        bytesValue: ""
    } : "bytesValue" in t ? $70fd6868680e912c$var$We($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "referenceValue" in t ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in t ? {
        arrayValue: {}
    } : "arrayValue" in t ? {
        mapValue: {}
    } : "mapValue" in t ? $70fd6868680e912c$var$Fe : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$rn(t, e) {
    const n = $70fd6868680e912c$var$Ke(t.value, e.value);
    return 0 !== n ? n : t.inclusive && !e.inclusive ? -1 : !t.inclusive && e.inclusive ? 1 : 0;
}
function $70fd6868680e912c$var$on(t, e) {
    const n = $70fd6868680e912c$var$Ke(t.value, e.value);
    return 0 !== n ? n : t.inclusive && !e.inclusive ? 1 : !t.inclusive && e.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $70fd6868680e912c$var$un {
    constructor(t){
        this.value = t;
    }
    static empty() {
        return new $70fd6868680e912c$var$un({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(t) {
        if (t.isEmpty()) return this.value;
        {
            let e = this.value;
            for(let n = 0; n < t.length - 1; ++n)if (e = (e.mapValue.fields || {})[t.get(n)], !$70fd6868680e912c$var$Ze(e)) return null;
            return e = (e.mapValue.fields || {})[t.lastSegment()], e || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(t, e) {
        this.getFieldsMap(t.popLast())[t.lastSegment()] = $70fd6868680e912c$var$tn(e);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(t) {
        let e = $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(), n = {}, s = [];
        t.forEach((t, i)=>{
            if (!e.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const t = this.getFieldsMap(e);
                this.applyChanges(t, n, s), n = {}, s = [], e = i.popLast();
            }
            t ? n[i.lastSegment()] = $70fd6868680e912c$var$tn(t) : s.push(i.lastSegment());
        });
        const i = this.getFieldsMap(e);
        this.applyChanges(i, n, s);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(t) {
        const e = this.field(t.popLast());
        $70fd6868680e912c$var$Ze(e) && e.mapValue.fields && delete e.mapValue.fields[t.lastSegment()];
    }
    isEqual(t) {
        return $70fd6868680e912c$var$qe(this.value, t.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(t) {
        let e = this.value;
        e.mapValue.fields || (e.mapValue = {
            fields: {}
        });
        for(let n = 0; n < t.length; ++n){
            let s = e.mapValue.fields[t.get(n)];
            $70fd6868680e912c$var$Ze(s) && s.mapValue.fields || (s = {
                mapValue: {
                    fields: {}
                }
            }, e.mapValue.fields[t.get(n)] = s), e = s;
        }
        return e.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(t, e, n) {
        $70fd6868680e912c$var$ge(e, (e, n)=>t[e] = n);
        for (const e of n)delete t[e];
    }
    clone() {
        return new $70fd6868680e912c$var$un($70fd6868680e912c$var$tn(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $70fd6868680e912c$var$cn(t) {
    const e = [];
    return $70fd6868680e912c$var$ge(t.fields, (t, n)=>{
        const s = new $70fd6868680e912c$export$b7871852b967eaf1([
            t
        ]);
        if ($70fd6868680e912c$var$Ze(n)) {
            const t = $70fd6868680e912c$var$cn(n.mapValue).fields;
            if (0 === t.length) // Preserve the empty map by adding it to the FieldMask.
            e.push(s);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of t)e.push(s.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        e.push(s);
    }), new $70fd6868680e912c$var$Re(e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $70fd6868680e912c$var$an {
    constructor(t, e, n, s, i, r, o){
        this.key = t, this.documentType = e, this.version = n, this.readTime = s, this.createTime = i, this.data = r, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(t) {
        return new $70fd6868680e912c$var$an(t, 0 /* DocumentType.INVALID */ , /* version */ $70fd6868680e912c$var$rt.min(), /* readTime */ $70fd6868680e912c$var$rt.min(), /* createTime */ $70fd6868680e912c$var$rt.min(), $70fd6868680e912c$var$un.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(t, e, n, s) {
        return new $70fd6868680e912c$var$an(t, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ e, /* readTime */ $70fd6868680e912c$var$rt.min(), /* createTime */ n, s, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(t, e) {
        return new $70fd6868680e912c$var$an(t, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ e, /* readTime */ $70fd6868680e912c$var$rt.min(), /* createTime */ $70fd6868680e912c$var$rt.min(), $70fd6868680e912c$var$un.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(t, e) {
        return new $70fd6868680e912c$var$an(t, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ e, /* readTime */ $70fd6868680e912c$var$rt.min(), /* createTime */ $70fd6868680e912c$var$rt.min(), $70fd6868680e912c$var$un.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(t, e) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($70fd6868680e912c$var$rt.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = t), this.version = t, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = e, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(t) {
        return this.version = t, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $70fd6868680e912c$var$un.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(t) {
        return this.version = t, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $70fd6868680e912c$var$un.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $70fd6868680e912c$var$rt.min(), this;
    }
    setReadTime(t) {
        return this.readTime = t, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$var$an && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
    }
    mutableCopy() {
        return new $70fd6868680e912c$var$an(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $70fd6868680e912c$var$hn {
    constructor(t, e){
        this.position = t, this.inclusive = e;
    }
}
function $70fd6868680e912c$var$ln(t, e, n) {
    let s = 0;
    for(let i = 0; i < t.position.length; i++){
        const r = e[i], o = t.position[i];
        if (r.field.isKeyField()) s = $70fd6868680e912c$export$afc2e57c475b7810.comparator($70fd6868680e912c$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else s = $70fd6868680e912c$var$Ke(o, n.data.field(r.field));
        if ("desc" /* Direction.DESCENDING */  === r.dir && (s *= -1), 0 !== s) break;
    }
    return s;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $70fd6868680e912c$var$fn(t, e) {
    if (null === t) return null === e;
    if (null === e) return !1;
    if (t.inclusive !== e.inclusive || t.position.length !== e.position.length) return !1;
    for(let n = 0; n < t.position.length; n++){
        if (!$70fd6868680e912c$var$qe(t.position[n], e.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $70fd6868680e912c$var$dn {
    constructor(t, e = "asc" /* Direction.ASCENDING */ ){
        this.field = t, this.dir = e;
    }
}
function $70fd6868680e912c$var$wn(t, e) {
    return t.dir === e.dir && t.field.isEqual(e.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$_n {
}
class $70fd6868680e912c$var$mn extends $70fd6868680e912c$var$_n {
    constructor(t, e, n){
        super(), this.field = t, this.op = e, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(t, e, n) {
        return t.isKeyField() ? "in" /* Operator.IN */  === e || "not-in" /* Operator.NOT_IN */  === e ? this.createKeyFieldInFilter(t, e, n) : new $70fd6868680e912c$var$Pn(t, e, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === e ? new $70fd6868680e912c$var$Dn(t, n) : "in" /* Operator.IN */  === e ? new $70fd6868680e912c$var$Cn(t, n) : "not-in" /* Operator.NOT_IN */  === e ? new $70fd6868680e912c$var$xn(t, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e ? new $70fd6868680e912c$var$Nn(t, n) : new $70fd6868680e912c$var$mn(t, e, n);
    }
    static createKeyFieldInFilter(t, e, n) {
        return "in" /* Operator.IN */  === e ? new $70fd6868680e912c$var$bn(t, n) : new $70fd6868680e912c$var$Vn(t, n);
    }
    matches(t) {
        const e = t.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== e && this.matchesComparison($70fd6868680e912c$var$Ke(e, this.value)) : null !== e && $70fd6868680e912c$var$Le(this.value) === $70fd6868680e912c$var$Le(e) && this.matchesComparison($70fd6868680e912c$var$Ke(e, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(t) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return t < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return t <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === t;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== t;
            case ">" /* Operator.GREATER_THAN */ :
                return t > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return t >= 0;
            default:
                return $70fd6868680e912c$var$O();
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
    getFirstInequalityField() {
        return this.isInequality() ? this.field : null;
    }
}
class $70fd6868680e912c$var$gn extends $70fd6868680e912c$var$_n {
    constructor(t, e){
        super(), this.filters = t, this.op = e, this.lt = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(t, e) {
        return new $70fd6868680e912c$var$gn(t, e);
    }
    matches(t) {
        return $70fd6868680e912c$var$yn(this) ? void 0 === this.filters.find((e)=>!e.matches(t)) : void 0 !== this.filters.find((e)=>e.matches(t));
    }
    getFlattenedFilters() {
        return null !== this.lt || (this.lt = this.filters.reduce((t, e)=>t.concat(e.getFlattenedFilters()), [])), this.lt;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
    getFirstInequalityField() {
        const t = this.ft((t)=>t.isInequality());
        return null !== t ? t.field : null;
    }
    // Performs a depth-first search to find and return the first FieldFilter in the composite filter
    // that satisfies the predicate. Returns `null` if none of the FieldFilters satisfy the
    // predicate.
    ft(t) {
        for (const e of this.getFlattenedFilters())if (t(e)) return e;
        return null;
    }
}
function $70fd6868680e912c$var$yn(t) {
    return "and" /* CompositeOperator.AND */  === t.op;
}
function $70fd6868680e912c$var$pn(t) {
    return "or" /* CompositeOperator.OR */  === t.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $70fd6868680e912c$var$In(t) {
    return $70fd6868680e912c$var$Tn(t) && $70fd6868680e912c$var$yn(t);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $70fd6868680e912c$var$Tn(t) {
    for (const e of t.filters)if (e instanceof $70fd6868680e912c$var$gn) return !1;
    return !0;
}
function $70fd6868680e912c$var$En(t) {
    if (t instanceof $70fd6868680e912c$var$mn) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return t.field.canonicalString() + t.op.toString() + $70fd6868680e912c$var$Qe(t.value);
    if ($70fd6868680e912c$var$In(t)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return t.filters.map((t)=>$70fd6868680e912c$var$En(t)).join(",");
    {
        // filter instanceof CompositeFilter
        const e = t.filters.map((t)=>$70fd6868680e912c$var$En(t)).join(",");
        return `${t.op}(${e})`;
    }
}
function $70fd6868680e912c$var$An(t, e) {
    return t instanceof $70fd6868680e912c$var$mn ? function(t, e) {
        return e instanceof $70fd6868680e912c$var$mn && t.op === e.op && t.field.isEqual(e.field) && $70fd6868680e912c$var$qe(t.value, e.value);
    }(t, e) : t instanceof $70fd6868680e912c$var$gn ? function(t, e) {
        if (e instanceof $70fd6868680e912c$var$gn && t.op === e.op && t.filters.length === e.filters.length) return t.filters.reduce((t, n, s)=>t && $70fd6868680e912c$var$An(n, e.filters[s]), !0);
        return !1;
    }(t, e) : void $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$vn(t, e) {
    const n = t.filters.concat(e);
    return $70fd6868680e912c$var$gn.create(n, t.op);
}
/** Returns a debug description for `filter`. */ function $70fd6868680e912c$var$Rn(t) {
    return t instanceof $70fd6868680e912c$var$mn ? function(t) {
        return `${t.field.canonicalString()} ${t.op} ${$70fd6868680e912c$var$Qe(t.value)}`;
    }(t) : t instanceof $70fd6868680e912c$var$gn ? function(t) {
        return t.op.toString() + " {" + t.getFilters().map($70fd6868680e912c$var$Rn).join(" ,") + "}";
    }(t) : "Filter";
}
class $70fd6868680e912c$var$Pn extends $70fd6868680e912c$var$mn {
    constructor(t, e, n){
        super(t, e, n), this.key = $70fd6868680e912c$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(t) {
        const e = $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, this.key);
        return this.matchesComparison(e);
    }
}
/** Filter that matches on key fields within an array. */ class $70fd6868680e912c$var$bn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "in" /* Operator.IN */ , e), this.keys = $70fd6868680e912c$var$Sn("in" /* Operator.IN */ , e);
    }
    matches(t) {
        return this.keys.some((e)=>e.isEqual(t.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $70fd6868680e912c$var$Vn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "not-in" /* Operator.NOT_IN */ , e), this.keys = $70fd6868680e912c$var$Sn("not-in" /* Operator.NOT_IN */ , e);
    }
    matches(t) {
        return !this.keys.some((e)=>e.isEqual(t.key));
    }
}
function $70fd6868680e912c$var$Sn(t, e) {
    var n;
    return ((null === (n = e.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((t)=>$70fd6868680e912c$export$afc2e57c475b7810.fromName(t.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $70fd6868680e912c$var$Dn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "array-contains" /* Operator.ARRAY_CONTAINS */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return $70fd6868680e912c$var$Je(e) && $70fd6868680e912c$var$Ue(e.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $70fd6868680e912c$var$Cn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "in" /* Operator.IN */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return null !== e && $70fd6868680e912c$var$Ue(this.value.arrayValue, e);
    }
}
/** A Filter that implements the not-in operator. */ class $70fd6868680e912c$var$xn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "not-in" /* Operator.NOT_IN */ , e);
    }
    matches(t) {
        if ($70fd6868680e912c$var$Ue(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const e = t.data.field(this.field);
        return null !== e && !$70fd6868680e912c$var$Ue(this.value.arrayValue, e);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $70fd6868680e912c$var$Nn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return !(!$70fd6868680e912c$var$Je(e) || !e.arrayValue.values) && e.arrayValue.values.some((t)=>$70fd6868680e912c$var$Ue(this.value.arrayValue, t));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $70fd6868680e912c$var$kn {
    constructor(t, e = null, n = [], s = [], i = null, r = null, o = null){
        this.path = t, this.collectionGroup = e, this.orderBy = n, this.filters = s, this.limit = i, this.startAt = r, this.endAt = o, this.dt = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $70fd6868680e912c$var$Mn(t, e = null, n = [], s = [], i = null, r = null, o = null) {
    return new $70fd6868680e912c$var$kn(t, e, n, s, i, r, o);
}
function $70fd6868680e912c$var$$n(t) {
    const e = $70fd6868680e912c$var$L(t);
    if (null === e.dt) {
        let t = e.path.canonicalString();
        null !== e.collectionGroup && (t += "|cg:" + e.collectionGroup), t += "|f:", t += e.filters.map((t)=>$70fd6868680e912c$var$En(t)).join(","), t += "|ob:", t += e.orderBy.map((t)=>(function(t) {
                // TODO(b/29183165): Make this collision robust.
                return t.field.canonicalString() + t.dir;
            })(t)).join(","), $70fd6868680e912c$var$Ft(e.limit) || (t += "|l:", t += e.limit), e.startAt && (t += "|lb:", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((t)=>$70fd6868680e912c$var$Qe(t)).join(",")), e.endAt && (t += "|ub:", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((t)=>$70fd6868680e912c$var$Qe(t)).join(",")), e.dt = t;
    }
    return e.dt;
}
function $70fd6868680e912c$var$On(t, e) {
    if (t.limit !== e.limit) return !1;
    if (t.orderBy.length !== e.orderBy.length) return !1;
    for(let n = 0; n < t.orderBy.length; n++)if (!$70fd6868680e912c$var$wn(t.orderBy[n], e.orderBy[n])) return !1;
    if (t.filters.length !== e.filters.length) return !1;
    for(let n = 0; n < t.filters.length; n++)if (!$70fd6868680e912c$var$An(t.filters[n], e.filters[n])) return !1;
    return t.collectionGroup === e.collectionGroup && !!t.path.isEqual(e.path) && !!$70fd6868680e912c$var$fn(t.startAt, e.startAt) && $70fd6868680e912c$var$fn(t.endAt, e.endAt);
}
function $70fd6868680e912c$var$Fn(t) {
    return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
}
/** Returns the field filters that target the given field path. */ function $70fd6868680e912c$var$Bn(t, e) {
    return t.filters.filter((t)=>t instanceof $70fd6868680e912c$var$mn && t.field.isEqual(e));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $70fd6868680e912c$var$Ln(t, e, n) {
    let s = $70fd6868680e912c$var$Be, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$Bn(t, e)){
        let t = $70fd6868680e912c$var$Be, e = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                t = $70fd6868680e912c$var$nn(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                t = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                t = n.value, e = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                t = $70fd6868680e912c$var$Be;
        }
        $70fd6868680e912c$var$rn({
            value: s,
            inclusive: i
        }, {
            value: t,
            inclusive: e
        }) < 0 && (s = t, i = e);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let r = 0; r < t.orderBy.length; ++r)if (t.orderBy[r].field.isEqual(e)) {
            const t = n.position[r];
            $70fd6868680e912c$var$rn({
                value: s,
                inclusive: i
            }, {
                value: t,
                inclusive: n.inclusive
            }) < 0 && (s = t, i = n.inclusive);
            break;
        }
    }
    return {
        value: s,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $70fd6868680e912c$var$qn(t, e, n) {
    let s = $70fd6868680e912c$var$Fe, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$Bn(t, e)){
        let t = $70fd6868680e912c$var$Fe, e = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                t = $70fd6868680e912c$var$sn(n.value), e = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                t = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                t = n.value, e = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                t = $70fd6868680e912c$var$Fe;
        }
        $70fd6868680e912c$var$on({
            value: s,
            inclusive: i
        }, {
            value: t,
            inclusive: e
        }) > 0 && (s = t, i = e);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let r = 0; r < t.orderBy.length; ++r)if (t.orderBy[r].field.isEqual(e)) {
            const t = n.position[r];
            $70fd6868680e912c$var$on({
                value: s,
                inclusive: i
            }, {
                value: t,
                inclusive: n.inclusive
            }) > 0 && (s = t, i = n.inclusive);
            break;
        }
    }
    return {
        value: s,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $70fd6868680e912c$var$Un {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(t, e = null, n = [], s = [], i = null, r = "F" /* LimitType.First */ , o = null, u = null){
        this.path = t, this.collectionGroup = e, this.explicitOrderBy = n, this.filters = s, this.limit = i, this.limitType = r, this.startAt = o, this.endAt = u, this.wt = null, // The corresponding `Target` of this `Query` instance.
        this._t = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $70fd6868680e912c$var$Kn(t, e, n, s, i, r, o, u) {
    return new $70fd6868680e912c$var$Un(t, e, n, s, i, r, o, u);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $70fd6868680e912c$var$Gn(t) {
    return new $70fd6868680e912c$var$Un(t);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $70fd6868680e912c$var$Qn(t) {
    return 0 === t.filters.length && null === t.limit && null == t.startAt && null == t.endAt && (0 === t.explicitOrderBy.length || 1 === t.explicitOrderBy.length && t.explicitOrderBy[0].field.isKeyField());
}
function $70fd6868680e912c$var$jn(t) {
    return t.explicitOrderBy.length > 0 ? t.explicitOrderBy[0].field : null;
}
function $70fd6868680e912c$var$zn(t) {
    for (const e of t.filters){
        const t = e.getFirstInequalityField();
        if (null !== t) return t;
    }
    return null;
}
/**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */ /**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $70fd6868680e912c$var$Wn(t) {
    return null !== t.collectionGroup;
}
/**
 * Returns the implicit order by constraint that is used to execute the Query,
 * which can be different from the order by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`).
 */ function $70fd6868680e912c$var$Hn(t) {
    const e = $70fd6868680e912c$var$L(t);
    if (null === e.wt) {
        e.wt = [];
        const t = $70fd6868680e912c$var$zn(e), n = $70fd6868680e912c$var$jn(e);
        if (null !== t && null === n) // In order to implicitly add key ordering, we must also add the
        // inequality filter field for it to be a valid query.
        // Note that the default inequality field and key ordering is ascending.
        t.isKeyField() || e.wt.push(new $70fd6868680e912c$var$dn(t)), e.wt.push(new $70fd6868680e912c$var$dn($70fd6868680e912c$export$b7871852b967eaf1.keyField(), "asc" /* Direction.ASCENDING */ ));
        else {
            let t = !1;
            for (const n of e.explicitOrderBy)e.wt.push(n), n.field.isKeyField() && (t = !0);
            if (!t) {
                // The order of the implicit key ordering always matches the last
                // explicit order by
                const t = e.explicitOrderBy.length > 0 ? e.explicitOrderBy[e.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ ;
                e.wt.push(new $70fd6868680e912c$var$dn($70fd6868680e912c$export$b7871852b967eaf1.keyField(), t));
            }
        }
    }
    return e.wt;
}
/**
 * Converts this `Query` instance to it's corresponding `Target` representation.
 */ function $70fd6868680e912c$var$Jn(t) {
    const e = $70fd6868680e912c$var$L(t);
    if (!e._t) {
        if ("F" /* LimitType.First */  === e.limitType) e._t = $70fd6868680e912c$var$Mn(e.path, e.collectionGroup, $70fd6868680e912c$var$Hn(e), e.filters, e.limit, e.startAt, e.endAt);
        else {
            // Flip the orderBy directions since we want the last results
            const t = [];
            for (const n of $70fd6868680e912c$var$Hn(e)){
                const e = "desc" /* Direction.DESCENDING */  === n.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
                t.push(new $70fd6868680e912c$var$dn(n.field, e));
            }
            // We need to swap the cursors to match the now-flipped query ordering.
            const n = e.endAt ? new $70fd6868680e912c$var$hn(e.endAt.position, e.endAt.inclusive) : null, s = e.startAt ? new $70fd6868680e912c$var$hn(e.startAt.position, e.startAt.inclusive) : null;
            // Now return as a LimitType.First query.
            e._t = $70fd6868680e912c$var$Mn(e.path, e.collectionGroup, t, e.filters, e.limit, n, s);
        }
    }
    return e._t;
}
function $70fd6868680e912c$var$Yn(t, e) {
    e.getFirstInequalityField(), $70fd6868680e912c$var$zn(t);
    const n = t.filters.concat([
        e
    ]);
    return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, t.explicitOrderBy.slice(), n, t.limit, t.limitType, t.startAt, t.endAt);
}
function $70fd6868680e912c$var$Xn(t, e, n) {
    return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), e, n, t.startAt, t.endAt);
}
function $70fd6868680e912c$var$Zn(t, e) {
    return $70fd6868680e912c$var$On($70fd6868680e912c$var$Jn(t), $70fd6868680e912c$var$Jn(e)) && t.limitType === e.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $70fd6868680e912c$var$ts(t) {
    return `${$70fd6868680e912c$var$$n($70fd6868680e912c$var$Jn(t))}|lt:${t.limitType}`;
}
function $70fd6868680e912c$var$es(t) {
    return `Query(target=${function(t) {
        let e = t.path.canonicalString();
        return null !== t.collectionGroup && (e += " collectionGroup=" + t.collectionGroup), t.filters.length > 0 && (e += `, filters: [${t.filters.map((t)=>$70fd6868680e912c$var$Rn(t)).join(", ")}]`), $70fd6868680e912c$var$Ft(t.limit) || (e += ", limit: " + t.limit), t.orderBy.length > 0 && (e += `, orderBy: [${t.orderBy.map((t)=>(function(t) {
                return `${t.field.canonicalString()} (${t.dir})`;
            })(t)).join(", ")}]`), t.startAt && (e += ", startAt: ", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((t)=>$70fd6868680e912c$var$Qe(t)).join(",")), t.endAt && (e += ", endAt: ", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((t)=>$70fd6868680e912c$var$Qe(t)).join(",")), `Target(${e})`;
    }($70fd6868680e912c$var$Jn(t))}; limitType=${t.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $70fd6868680e912c$var$ns(t, e) {
    return e.isFoundDocument() && function(t, e) {
        const n = e.key.path;
        return null !== t.collectionGroup ? e.key.hasCollectionId(t.collectionGroup) && t.path.isPrefixOf(n) : $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t.path) ? t.path.isEqual(n) : t.path.isImmediateParentOf(n);
    }(t, e) && function(t, e) {
        // We must use `queryOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $70fd6868680e912c$var$Hn(t))// order by key always matches
        if (!n.field.isKeyField() && null === e.data.field(n.field)) return !1;
        return !0;
    }(t, e) && function(t, e) {
        for (const n of t.filters)if (!n.matches(e)) return !1;
        return !0;
    }(t, e) && function(t, e) {
        if (t.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function(t, e, n) {
            const s = $70fd6868680e912c$var$ln(t, e, n);
            return t.inclusive ? s <= 0 : s < 0;
        }(t.startAt, $70fd6868680e912c$var$Hn(t), e)) return !1;
        if (t.endAt && !function(t, e, n) {
            const s = $70fd6868680e912c$var$ln(t, e, n);
            return t.inclusive ? s >= 0 : s > 0;
        }(t.endAt, $70fd6868680e912c$var$Hn(t), e)) return !1;
        return !0;
    }(t, e);
}
function $70fd6868680e912c$var$ss(t) {
    return t.collectionGroup || (t.path.length % 2 == 1 ? t.path.lastSegment() : t.path.get(t.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $70fd6868680e912c$var$is(t) {
    return (e, n)=>{
        let s = !1;
        for (const i of $70fd6868680e912c$var$Hn(t)){
            const t = $70fd6868680e912c$var$rs(i, e, n);
            if (0 !== t) return t;
            s = s || i.field.isKeyField();
        }
        return 0;
    };
}
function $70fd6868680e912c$var$rs(t, e, n) {
    const s = t.field.isKeyField() ? $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, n.key) : function(t, e, n) {
        const s = e.data.field(t), i = n.data.field(t);
        return null !== s && null !== i ? $70fd6868680e912c$var$Ke(s, i) : $70fd6868680e912c$var$O();
    }(t.field, e, n);
    switch(t.dir){
        case "asc" /* Direction.ASCENDING */ :
            return s;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * s;
        default:
            return $70fd6868680e912c$var$O();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $70fd6868680e912c$var$os {
    constructor(t, e){
        this.mapKeyFn = t, this.equalsFn = e, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(t) {
        const e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 !== n) {
            for (const [e, s] of n)if (this.equalsFn(e, t)) return s;
        }
    }
    has(t) {
        return void 0 !== this.get(t);
    }
    /** Put this key and value in the map. */ set(t, e) {
        const n = this.mapKeyFn(t), s = this.inner[n];
        if (void 0 === s) return this.inner[n] = [
            [
                t,
                e
            ]
        ], void this.innerSize++;
        for(let n = 0; n < s.length; n++)if (this.equalsFn(s[n][0], t)) // This is updating an existing entry and does not increase `innerSize`.
        return void (s[n] = [
            t,
            e
        ]);
        s.push([
            t,
            e
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(t) {
        const e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 === n) return !1;
        for(let s = 0; s < n.length; s++)if (this.equalsFn(n[s][0], t)) return 1 === n.length ? delete this.inner[e] : n.splice(s, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(t) {
        $70fd6868680e912c$var$ge(this.inner, (e, n)=>{
            for (const [e, s] of n)t(e, s);
        });
    }
    isEmpty() {
        return $70fd6868680e912c$var$ye(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$us = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$cs() {
    return $70fd6868680e912c$var$us;
}
const $70fd6868680e912c$var$as = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$hs(...t) {
    let e = $70fd6868680e912c$var$as;
    for (const n of t)e = e.insert(n.key, n);
    return e;
}
function $70fd6868680e912c$var$ls(t) {
    let e = $70fd6868680e912c$var$as;
    return t.forEach((t, n)=>e = e.insert(t, n.overlayedDocument)), e;
}
function $70fd6868680e912c$var$fs() {
    return $70fd6868680e912c$var$ws();
}
function $70fd6868680e912c$var$ds() {
    return $70fd6868680e912c$var$ws();
}
function $70fd6868680e912c$var$ws() {
    return new $70fd6868680e912c$var$os((t)=>t.toString(), (t, e)=>t.isEqual(e));
}
const $70fd6868680e912c$var$_s = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
const $70fd6868680e912c$var$ms = new $70fd6868680e912c$var$Ee($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$gs(...t) {
    let e = $70fd6868680e912c$var$ms;
    for (const n of t)e = e.add(n);
    return e;
}
const $70fd6868680e912c$var$ys = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
function $70fd6868680e912c$var$ps() {
    return $70fd6868680e912c$var$ys;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $70fd6868680e912c$var$Is(t, e) {
    if (t.useProto3Json) {
        if (isNaN(e)) return {
            doubleValue: "NaN"
        };
        if (e === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (e === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $70fd6868680e912c$var$Bt(e) ? "-0" : e
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $70fd6868680e912c$var$Ts(t) {
    return {
        integerValue: "" + t
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $70fd6868680e912c$var$Es(t, e) {
    return $70fd6868680e912c$var$Lt(e) ? $70fd6868680e912c$var$Ts(e) : $70fd6868680e912c$var$Is(t, e);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $70fd6868680e912c$var$As {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $70fd6868680e912c$var$vs(t, e, n) {
    return t instanceof $70fd6868680e912c$var$bs ? function(t, e) {
        const n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: t.seconds,
                        nanos: t.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return e && $70fd6868680e912c$var$Ne(e) && (e = $70fd6868680e912c$var$ke(e)), e && (n.fields.__previous_value__ = e), {
            mapValue: n
        };
    }(n, e) : t instanceof $70fd6868680e912c$var$Vs ? $70fd6868680e912c$var$Ss(t, e) : t instanceof $70fd6868680e912c$var$Ds ? $70fd6868680e912c$var$Cs(t, e) : function(t, e) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $70fd6868680e912c$var$Ps(t, e), s = $70fd6868680e912c$var$Ns(n) + $70fd6868680e912c$var$Ns(t.gt);
        return $70fd6868680e912c$var$He(n) && $70fd6868680e912c$var$He(t.gt) ? $70fd6868680e912c$var$Ts(s) : $70fd6868680e912c$var$Is(t.serializer, s);
    }(t, e);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $70fd6868680e912c$var$Rs(t, e, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return t instanceof $70fd6868680e912c$var$Vs ? $70fd6868680e912c$var$Ss(t, e) : t instanceof $70fd6868680e912c$var$Ds ? $70fd6868680e912c$var$Cs(t, e) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $70fd6868680e912c$var$Ps(t, e) {
    var n;
    return t instanceof $70fd6868680e912c$var$xs ? $70fd6868680e912c$var$He(n = e) || function(t) {
        return !!t && "doubleValue" in t;
    }(n) ? e : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $70fd6868680e912c$var$bs extends $70fd6868680e912c$var$As {
}
/** Transforms an array value via a union operation. */ class $70fd6868680e912c$var$Vs extends $70fd6868680e912c$var$As {
    constructor(t){
        super(), this.elements = t;
    }
}
function $70fd6868680e912c$var$Ss(t, e) {
    const n = $70fd6868680e912c$var$ks(e);
    for (const e of t.elements)n.some((t)=>$70fd6868680e912c$var$qe(t, e)) || n.push(e);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $70fd6868680e912c$var$Ds extends $70fd6868680e912c$var$As {
    constructor(t){
        super(), this.elements = t;
    }
}
function $70fd6868680e912c$var$Cs(t, e) {
    let n = $70fd6868680e912c$var$ks(e);
    for (const e of t.elements)n = n.filter((t)=>!$70fd6868680e912c$var$qe(t, e));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $70fd6868680e912c$var$xs extends $70fd6868680e912c$var$As {
    constructor(t, e){
        super(), this.serializer = t, this.gt = e;
    }
}
function $70fd6868680e912c$var$Ns(t) {
    return $70fd6868680e912c$var$Ce(t.integerValue || t.doubleValue);
}
function $70fd6868680e912c$var$ks(t) {
    return $70fd6868680e912c$var$Je(t) && t.arrayValue.values ? t.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $70fd6868680e912c$var$Ms {
    constructor(t, e){
        this.field = t, this.transform = e;
    }
}
function $70fd6868680e912c$var$$s(t, e) {
    return t.field.isEqual(e.field) && function(t, e) {
        return t instanceof $70fd6868680e912c$var$Vs && e instanceof $70fd6868680e912c$var$Vs || t instanceof $70fd6868680e912c$var$Ds && e instanceof $70fd6868680e912c$var$Ds ? $70fd6868680e912c$var$nt(t.elements, e.elements, $70fd6868680e912c$var$qe) : t instanceof $70fd6868680e912c$var$xs && e instanceof $70fd6868680e912c$var$xs ? $70fd6868680e912c$var$qe(t.gt, e.gt) : t instanceof $70fd6868680e912c$var$bs && e instanceof $70fd6868680e912c$var$bs;
    }(t.transform, e.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $70fd6868680e912c$var$Os {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ t, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ e){
        this.version = t, this.transformResults = e;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $70fd6868680e912c$var$Fs {
    constructor(t, e){
        this.updateTime = t, this.exists = e;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $70fd6868680e912c$var$Fs;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(t) {
        return new $70fd6868680e912c$var$Fs(void 0, t);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(t) {
        return new $70fd6868680e912c$var$Fs(t);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(t) {
        return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $70fd6868680e912c$var$Bs(t, e) {
    return void 0 !== t.updateTime ? e.isFoundDocument() && e.version.isEqual(t.updateTime) : void 0 === t.exists || t.exists === e.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $70fd6868680e912c$var$Ls {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $70fd6868680e912c$var$qs(t, e) {
    if (!t.hasLocalMutations || e && 0 === e.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === e) return t.isNoDocument() ? new $70fd6868680e912c$var$Ys(t.key, $70fd6868680e912c$var$Fs.none()) : new $70fd6868680e912c$var$js(t.key, t.data, $70fd6868680e912c$var$Fs.none());
    {
        const n = t.data, s = $70fd6868680e912c$var$un.empty();
        let i = new $70fd6868680e912c$var$Ee($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (let t of e.fields)if (!i.has(t)) {
            let e = n.field(t);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === e && t.length > 1 && (t = t.popLast(), e = n.field(t)), null === e ? s.delete(t) : s.set(t, e), i = i.add(t);
        }
        return new $70fd6868680e912c$var$zs(t.key, s, new $70fd6868680e912c$var$Re(i.toArray()), $70fd6868680e912c$var$Fs.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $70fd6868680e912c$var$Us(t, e, n) {
    t instanceof $70fd6868680e912c$var$js ? function(t, e, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const s = t.value.clone(), i = $70fd6868680e912c$var$Hs(t.fieldTransforms, e, n.transformResults);
        s.setAll(i), e.convertToFoundDocument(n.version, s).setHasCommittedMutations();
    }(t, e, n) : t instanceof $70fd6868680e912c$var$zs ? function(t, e, n) {
        if (!$70fd6868680e912c$var$Bs(t.precondition, e)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void e.convertToUnknownDocument(n.version);
        const s = $70fd6868680e912c$var$Hs(t.fieldTransforms, e, n.transformResults), i = e.data;
        i.setAll($70fd6868680e912c$var$Ws(t)), i.setAll(s), e.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(t, e, n) : function(t, e, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        e.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, e, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $70fd6868680e912c$var$Ks(t, e, n, s) {
    return t instanceof $70fd6868680e912c$var$js ? function(t, e, n, s) {
        if (!$70fd6868680e912c$var$Bs(t.precondition, e)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = t.value.clone(), r = $70fd6868680e912c$var$Js(t.fieldTransforms, s, e);
        return i.setAll(r), e.convertToFoundDocument(e.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(t, e, n, s) : t instanceof $70fd6868680e912c$var$zs ? function(t, e, n, s) {
        if (!$70fd6868680e912c$var$Bs(t.precondition, e)) return n;
        const i = $70fd6868680e912c$var$Js(t.fieldTransforms, s, e), r = e.data;
        if (r.setAll($70fd6868680e912c$var$Ws(t)), r.setAll(i), e.convertToFoundDocument(e.version, r).setHasLocalMutations(), null === n) return null;
        return n.unionWith(t.fieldMask.fields).unionWith(t.fieldTransforms.map((t)=>t.field));
    }(t, e, n, s) : function(t, e, n) {
        if ($70fd6868680e912c$var$Bs(t.precondition, e)) return e.convertToNoDocument(e.version).setHasLocalMutations(), null;
        return n;
    }(t, e, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $70fd6868680e912c$var$Gs(t, e) {
    let n = null;
    for (const s of t.fieldTransforms){
        const t = e.data.field(s.field), i = $70fd6868680e912c$var$Ps(s.transform, t || null);
        null != i && (null === n && (n = $70fd6868680e912c$var$un.empty()), n.set(s.field, i));
    }
    return n || null;
}
function $70fd6868680e912c$var$Qs(t, e) {
    return t.type === e.type && !!t.key.isEqual(e.key) && !!t.precondition.isEqual(e.precondition) && !!function(t, e) {
        return void 0 === t && void 0 === e || !(!t || !e) && $70fd6868680e912c$var$nt(t, e, (t, e)=>$70fd6868680e912c$var$$s(t, e));
    }(t.fieldTransforms, e.fieldTransforms) && (0 /* MutationType.Set */  === t.type ? t.value.isEqual(e.value) : 1 /* MutationType.Patch */  !== t.type || t.data.isEqual(e.data) && t.fieldMask.isEqual(e.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $70fd6868680e912c$var$js extends $70fd6868680e912c$var$Ls {
    constructor(t, e, n, s = []){
        super(), this.key = t, this.value = e, this.precondition = n, this.fieldTransforms = s, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$zs extends $70fd6868680e912c$var$Ls {
    constructor(t, e, n, s, i = []){
        super(), this.key = t, this.data = e, this.fieldMask = n, this.precondition = s, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $70fd6868680e912c$var$Ws(t) {
    const e = new Map;
    return t.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const s = t.data.field(n);
            e.set(n, s);
        }
    }), e;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$Hs(t, e, n) {
    const s = new Map;
    $70fd6868680e912c$var$F(t.length === n.length);
    for(let i = 0; i < n.length; i++){
        const r = t[i], o = r.transform, u = e.data.field(r.field);
        s.set(r.field, $70fd6868680e912c$var$Rs(o, u, n[i]));
    }
    return s;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$Js(t, e, n) {
    const s = new Map;
    for (const i of t){
        const t = i.transform, r = n.data.field(i.field);
        s.set(i.field, $70fd6868680e912c$var$vs(t, r, e));
    }
    return s;
}
/** A mutation that deletes the document at the given key. */ class $70fd6868680e912c$var$Ys extends $70fd6868680e912c$var$Ls {
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$Xs extends $70fd6868680e912c$var$Ls {
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $70fd6868680e912c$var$Zs {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(t, e, n, s){
        this.batchId = t, this.localWriteTime = e, this.baseMutations = n, this.mutations = s;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(t, e) {
        const n = e.mutationResults;
        for(let e = 0; e < this.mutations.length; e++){
            const s = this.mutations[e];
            if (s.key.isEqual(t.key)) $70fd6868680e912c$var$Us(s, t, n[e]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(t, e) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(t.key) && (e = $70fd6868680e912c$var$Ks(n, t, e, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(t.key) && (e = $70fd6868680e912c$var$Ks(n, t, e, this.localWriteTime));
        return e;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(t, e) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $70fd6868680e912c$var$ds();
        return this.mutations.forEach((s)=>{
            const i = t.get(s.key), r = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(r, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = e.has(s.key) ? null : o;
            const u = $70fd6868680e912c$var$qs(r, o);
            null !== u && n.set(s.key, u), r.isValidDocument() || r.convertToNoDocument($70fd6868680e912c$var$rt.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((t, e)=>t.add(e.key), $70fd6868680e912c$var$gs());
    }
    isEqual(t) {
        return this.batchId === t.batchId && $70fd6868680e912c$var$nt(this.mutations, t.mutations, (t, e)=>$70fd6868680e912c$var$Qs(t, e)) && $70fd6868680e912c$var$nt(this.baseMutations, t.baseMutations, (t, e)=>$70fd6868680e912c$var$Qs(t, e));
    }
}
/** The result of applying a mutation batch to the backend. */ class $70fd6868680e912c$var$ti {
    constructor(t, e, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ s){
        this.batch = t, this.commitVersion = e, this.mutationResults = n, this.docVersions = s;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(t, e, n) {
        $70fd6868680e912c$var$F(t.mutations.length === n.length);
        let s = $70fd6868680e912c$var$_s;
        const i = t.mutations;
        for(let t = 0; t < i.length; t++)s = s.insert(i[t].key, n[t].version);
        return new $70fd6868680e912c$var$ti(t, e, n, s);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $70fd6868680e912c$var$ei {
    constructor(t, e){
        this.largestBatchId = t, this.mutation = e;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(t) {
        return null !== t && this.mutation === t.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $70fd6868680e912c$var$ni {
    constructor(t, e, n){
        this.alias = t, this.yt = e, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$si {
    constructor(t, e){
        this.count = t, this.unchangedNames = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $70fd6868680e912c$var$ii, $70fd6868680e912c$var$ri;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $70fd6868680e912c$var$oi(t) {
    switch(t){
        default:
            return $70fd6868680e912c$var$O();
        case $70fd6868680e912c$var$q.CANCELLED:
        case $70fd6868680e912c$var$q.UNKNOWN:
        case $70fd6868680e912c$var$q.DEADLINE_EXCEEDED:
        case $70fd6868680e912c$var$q.RESOURCE_EXHAUSTED:
        case $70fd6868680e912c$var$q.INTERNAL:
        case $70fd6868680e912c$var$q.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $70fd6868680e912c$var$q.UNAUTHENTICATED:
            return !1;
        case $70fd6868680e912c$var$q.INVALID_ARGUMENT:
        case $70fd6868680e912c$var$q.NOT_FOUND:
        case $70fd6868680e912c$var$q.ALREADY_EXISTS:
        case $70fd6868680e912c$var$q.PERMISSION_DENIED:
        case $70fd6868680e912c$var$q.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $70fd6868680e912c$var$q.ABORTED:
        case $70fd6868680e912c$var$q.OUT_OF_RANGE:
        case $70fd6868680e912c$var$q.UNIMPLEMENTED:
        case $70fd6868680e912c$var$q.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $70fd6868680e912c$var$ui(t) {
    if (void 0 === t) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $70fd6868680e912c$var$k("GRPC error has no .code"), $70fd6868680e912c$var$q.UNKNOWN;
    switch(t){
        case $70fd6868680e912c$var$ii.OK:
            return $70fd6868680e912c$var$q.OK;
        case $70fd6868680e912c$var$ii.CANCELLED:
            return $70fd6868680e912c$var$q.CANCELLED;
        case $70fd6868680e912c$var$ii.UNKNOWN:
            return $70fd6868680e912c$var$q.UNKNOWN;
        case $70fd6868680e912c$var$ii.DEADLINE_EXCEEDED:
            return $70fd6868680e912c$var$q.DEADLINE_EXCEEDED;
        case $70fd6868680e912c$var$ii.RESOURCE_EXHAUSTED:
            return $70fd6868680e912c$var$q.RESOURCE_EXHAUSTED;
        case $70fd6868680e912c$var$ii.INTERNAL:
            return $70fd6868680e912c$var$q.INTERNAL;
        case $70fd6868680e912c$var$ii.UNAVAILABLE:
            return $70fd6868680e912c$var$q.UNAVAILABLE;
        case $70fd6868680e912c$var$ii.UNAUTHENTICATED:
            return $70fd6868680e912c$var$q.UNAUTHENTICATED;
        case $70fd6868680e912c$var$ii.INVALID_ARGUMENT:
            return $70fd6868680e912c$var$q.INVALID_ARGUMENT;
        case $70fd6868680e912c$var$ii.NOT_FOUND:
            return $70fd6868680e912c$var$q.NOT_FOUND;
        case $70fd6868680e912c$var$ii.ALREADY_EXISTS:
            return $70fd6868680e912c$var$q.ALREADY_EXISTS;
        case $70fd6868680e912c$var$ii.PERMISSION_DENIED:
            return $70fd6868680e912c$var$q.PERMISSION_DENIED;
        case $70fd6868680e912c$var$ii.FAILED_PRECONDITION:
            return $70fd6868680e912c$var$q.FAILED_PRECONDITION;
        case $70fd6868680e912c$var$ii.ABORTED:
            return $70fd6868680e912c$var$q.ABORTED;
        case $70fd6868680e912c$var$ii.OUT_OF_RANGE:
            return $70fd6868680e912c$var$q.OUT_OF_RANGE;
        case $70fd6868680e912c$var$ii.UNIMPLEMENTED:
            return $70fd6868680e912c$var$q.UNIMPLEMENTED;
        case $70fd6868680e912c$var$ii.DATA_LOSS:
            return $70fd6868680e912c$var$q.DATA_LOSS;
        default:
            return $70fd6868680e912c$var$O();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($70fd6868680e912c$var$ri = $70fd6868680e912c$var$ii || ($70fd6868680e912c$var$ii = {}))[$70fd6868680e912c$var$ri.OK = 0] = "OK", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.CANCELLED = 1] = "CANCELLED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.UNKNOWN = 2] = "UNKNOWN", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.NOT_FOUND = 5] = "NOT_FOUND", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.ABORTED = 10] = "ABORTED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.INTERNAL = 13] = "INTERNAL", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.UNAVAILABLE = 14] = "UNAVAILABLE", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Manages "testing hooks", hooks into the internals of the SDK to verify
 * internal state and events during integration tests. Do not use this class
 * except for testing purposes.
 *
 * There are two ways to retrieve the global singleton instance of this class:
 * 1. The `instance` property, which returns null if the global singleton
 *      instance has not been created. Use this property if the caller should
 *      "do nothing" if there are no testing hooks registered, such as when
 *      delivering an event to notify registered callbacks.
 * 2. The `getOrCreateInstance()` method, which creates the global singleton
 *      instance if it has not been created. Use this method if the instance is
 *      needed to, for example, register a callback.
 *
 * @internal
 */ class $70fd6868680e912c$export$3ab3ff3652492b82 {
    constructor(){
        this.onExistenceFilterMismatchCallbacks = new Map;
    }
    /**
     * Returns the singleton instance of this class, or null if it has not been
     * initialized.
     */ static get instance() {
        return $70fd6868680e912c$var$ai;
    }
    /**
     * Returns the singleton instance of this class, creating it if is has never
     * been created before.
     */ static getOrCreateInstance() {
        return null === $70fd6868680e912c$var$ai && ($70fd6868680e912c$var$ai = new $70fd6868680e912c$export$3ab3ff3652492b82), $70fd6868680e912c$var$ai;
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ onExistenceFilterMismatch(t) {
        const e = Symbol();
        return this.onExistenceFilterMismatchCallbacks.set(e, t), ()=>this.onExistenceFilterMismatchCallbacks.delete(e);
    }
    /**
     * Invokes all currently-registered `onExistenceFilterMismatch` callbacks.
     * @param info Information about the existence filter mismatch.
     */ notifyOnExistenceFilterMismatch(t) {
        this.onExistenceFilterMismatchCallbacks.forEach((e)=>e(t));
    }
}
/** The global singleton instance of `TestingHooks`. */ let $70fd6868680e912c$var$ai = null;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $70fd6868680e912c$var$hi() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$li = new (0, $l0itG.Integer)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $70fd6868680e912c$var$fi(t) {
    const e = $70fd6868680e912c$var$hi().encode(t), n = new (0, $l0itG.Md5);
    return n.update(e), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $70fd6868680e912c$var$di(t) {
    const e = new DataView(t.buffer), n = e.getUint32(0, /* littleEndian= */ !0), s = e.getUint32(4, /* littleEndian= */ !0), i = e.getUint32(8, /* littleEndian= */ !0), r = e.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $l0itG.Integer)([
            n,
            s
        ], 0),
        new (0, $l0itG.Integer)([
            i,
            r
        ], 0)
    ];
}
class $70fd6868680e912c$var$wi {
    constructor(t, e, n){
        if (this.bitmap = t, this.padding = e, this.hashCount = n, e < 0 || e >= 8) throw new $70fd6868680e912c$var$_i(`Invalid padding: ${e}`);
        if (n < 0) throw new $70fd6868680e912c$var$_i(`Invalid hash count: ${n}`);
        if (t.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $70fd6868680e912c$var$_i(`Invalid hash count: ${n}`);
        if (0 === t.length && 0 !== e) // Empty bloom filter should have 0 padding.
        throw new $70fd6868680e912c$var$_i(`Invalid padding when bitmap length is 0: ${e}`);
        this.It = 8 * t.length - e, // Set the bit count in Integer to avoid repetition in mightContain().
        this.Tt = (0, $l0itG.Integer).fromNumber(this.It);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    Et(t, e, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let s = t.add(e.multiply((0, $l0itG.Integer).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === s.compare($70fd6868680e912c$var$li) && (s = new (0, $l0itG.Integer)([
            s.getBits(0),
            s.getBits(1)
        ], 0)), s.modulo(this.Tt).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    At(t) {
        return 0 != (this.bitmap[Math.floor(t / 8)] & 1 << t % 8);
    }
    vt(t) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.It) return !1;
        const e = $70fd6868680e912c$var$fi(t), [n, s] = $70fd6868680e912c$var$di(e);
        for(let t = 0; t < this.hashCount; t++){
            const e = this.Et(n, s, t);
            if (!this.At(e)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(t, e, n) {
        const s = t % 8 == 0 ? 0 : 8 - t % 8, i = new Uint8Array(Math.ceil(t / 8)), r = new $70fd6868680e912c$var$wi(i, s, e);
        return n.forEach((t)=>r.insert(t)), r;
    }
    insert(t) {
        if (0 === this.It) return;
        const e = $70fd6868680e912c$var$fi(t), [n, s] = $70fd6868680e912c$var$di(e);
        for(let t = 0; t < this.hashCount; t++){
            const e = this.Et(n, s, t);
            this.Rt(e);
        }
    }
    Rt(t) {
        const e = Math.floor(t / 8), n = t % 8;
        this.bitmap[e] |= 1 << n;
    }
}
class $70fd6868680e912c$var$_i extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $70fd6868680e912c$var$mi {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ t, /**
     * A map from target to changes to the target. See TargetChange.
     */ e, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ s, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = t, this.targetChanges = e, this.targetMismatches = n, this.documentUpdates = s, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(t, e, n) {
        const s = new Map;
        return s.set(t, $70fd6868680e912c$var$gi.createSynthesizedTargetChangeForCurrentChange(t, e, n)), new $70fd6868680e912c$var$mi($70fd6868680e912c$var$rt.min(), s, new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), $70fd6868680e912c$var$cs(), $70fd6868680e912c$var$gs());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $70fd6868680e912c$var$gi {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ t, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ e, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ s, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = t, this.current = e, this.addedDocuments = n, this.modifiedDocuments = s, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(t, e, n) {
        return new $70fd6868680e912c$var$gi(n, e, $70fd6868680e912c$var$gs(), $70fd6868680e912c$var$gs(), $70fd6868680e912c$var$gs());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $70fd6868680e912c$var$yi {
    constructor(/** The new document applies to all of these targets. */ t, /** The new document is removed from all of these targets. */ e, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ s){
        this.Pt = t, this.removedTargetIds = e, this.key = n, this.bt = s;
    }
}
class $70fd6868680e912c$var$pi {
    constructor(t, e){
        this.targetId = t, this.Vt = e;
    }
}
class $70fd6868680e912c$var$Ii {
    constructor(/** What kind of change occurred to the watch target. */ t, /** The target IDs that were added/removed/set. */ e, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, s = null){
        this.state = t, this.targetIds = e, this.resumeToken = n, this.cause = s;
    }
}
/** Tracks the internal state of a Watch target. */ class $70fd6868680e912c$var$Ti {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.St = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Dt = $70fd6868680e912c$var$vi(), /** See public getters for explanations of these fields. */ this.Ct = $70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, this.xt = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.Nt = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.xt;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Ct;
    }
    /** Whether this target has pending target adds or target removes. */ get kt() {
        return 0 !== this.St;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Mt() {
        return this.Nt;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ $t(t) {
        t.approximateByteSize() > 0 && (this.Nt = !0, this.Ct = t);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ Ot() {
        let t = $70fd6868680e912c$var$gs(), e = $70fd6868680e912c$var$gs(), n = $70fd6868680e912c$var$gs();
        return this.Dt.forEach((s, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    t = t.add(s);
                    break;
                case 2 /* ChangeType.Modified */ :
                    e = e.add(s);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(s);
                    break;
                default:
                    $70fd6868680e912c$var$O();
            }
        }), new $70fd6868680e912c$var$gi(this.Ct, this.xt, t, e, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Ft() {
        this.Nt = !1, this.Dt = $70fd6868680e912c$var$vi();
    }
    Bt(t, e) {
        this.Nt = !0, this.Dt = this.Dt.insert(t, e);
    }
    Lt(t) {
        this.Nt = !0, this.Dt = this.Dt.remove(t);
    }
    qt() {
        this.St += 1;
    }
    Ut() {
        this.St -= 1;
    }
    Kt() {
        this.Nt = !0, this.xt = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $70fd6868680e912c$var$Ei {
    constructor(t){
        this.Gt = t, /** The internal state of all tracked targets. */ this.Qt = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.jt = $70fd6868680e912c$var$cs(), /** A mapping of document keys to their set of target IDs. */ this.zt = $70fd6868680e912c$var$Ai(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Wt = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Ht(t) {
        for (const e of t.Pt)t.bt && t.bt.isFoundDocument() ? this.Jt(e, t.bt) : this.Yt(e, t.key, t.bt);
        for (const e of t.removedTargetIds)this.Yt(e, t.key, t.bt);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ Xt(t) {
        this.forEachTarget(t, (e)=>{
            const n = this.Zt(e);
            switch(t.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.te(e) && n.$t(t.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ut(), n.kt || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Ft(), n.$t(t.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ut(), n.kt || this.removeTarget(e);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.te(e) && (n.Kt(), n.$t(t.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.te(e) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.ee(e), n.$t(t.resumeToken));
                    break;
                default:
                    $70fd6868680e912c$var$O();
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(t, e) {
        t.targetIds.length > 0 ? t.targetIds.forEach(e) : this.Qt.forEach((t, n)=>{
            this.te(n) && e(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ ne(t) {
        var e;
        const n = t.targetId, s = t.Vt.count, i = this.se(n);
        if (i) {
            const r = i.target;
            if ($70fd6868680e912c$var$Fn(r)) {
                if (0 === s) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const t = new $70fd6868680e912c$export$afc2e57c475b7810(r.path);
                    this.Yt(n, t, $70fd6868680e912c$var$an.newNoDocument(t, $70fd6868680e912c$var$rt.min()));
                } else $70fd6868680e912c$var$F(1 === s);
            } else {
                const i = this.ie(n);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (i !== s) {
                    // Apply bloom filter to identify and mark removed documents.
                    const s = this.re(t, i);
                    if (0 /* BloomFilterApplicationStatus.Success */  !== s) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.ee(n);
                        const t = 2 /* BloomFilterApplicationStatus.FalsePositive */  === s ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Wt = this.Wt.insert(n, t);
                    }
                    null === (e = $70fd6868680e912c$export$3ab3ff3652492b82.instance) || void 0 === e || e.notifyOnExistenceFilterMismatch(function(t, e, n) {
                        var s, i, r, o, u, c;
                        const a = {
                            localCacheCount: e,
                            existenceFilterCount: n.count
                        }, h = n.unchangedNames;
                        h && (a.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === t,
                            hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                            bitmapLength: null !== (o = null === (r = null === (i = null == h ? void 0 : h.bits) || void 0 === i ? void 0 : i.bitmap) || void 0 === r ? void 0 : r.length) && void 0 !== o ? o : 0,
                            padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0
                        });
                        return a;
                    }(s, i, t.Vt));
                }
            }
        }
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ re(t, e) {
        const { unchangedNames: n, count: s } = t.Vt;
        if (!n || !n.bits) return 1 /* BloomFilterApplicationStatus.Skipped */ ;
        const { bits: { bitmap: i = "", padding: r = 0 }, hashCount: o = 0 } = n;
        let u, c;
        try {
            u = $70fd6868680e912c$var$xe(i).toUint8Array();
        } catch (t) {
            if (t instanceof $70fd6868680e912c$var$Pe) return $70fd6868680e912c$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + t.message + "); ignoring the bloom filter and falling back to full re-query."), 1 /* BloomFilterApplicationStatus.Skipped */ ;
            throw t;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            c = new $70fd6868680e912c$var$wi(u, r, o);
        } catch (t) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb(t instanceof $70fd6868680e912c$var$_i ? "BloomFilter error: " : "Applying bloom filter failed: ", t), 1 /* BloomFilterApplicationStatus.Skipped */ ;
        }
        if (0 === c.It) return 1 /* BloomFilterApplicationStatus.Skipped */ ;
        return s !== e - this.oe(t.targetId, c) ? 2 /* BloomFilterApplicationStatus.FalsePositive */  : 0 /* BloomFilterApplicationStatus.Success */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ oe(t, e) {
        const n = this.Gt.getRemoteKeysForTarget(t);
        let s = 0;
        return n.forEach((n)=>{
            const i = this.Gt.ue(), r = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.vt(r) || (this.Yt(t, n, /*updatedDocument=*/ null), s++);
        }), s;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ ce(t) {
        const e = new Map;
        this.Qt.forEach((n, s)=>{
            const i = this.se(s);
            if (i) {
                if (n.current && $70fd6868680e912c$var$Fn(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const e = new $70fd6868680e912c$export$afc2e57c475b7810(i.target.path);
                    null !== this.jt.get(e) || this.ae(s, e) || this.Yt(s, e, $70fd6868680e912c$var$an.newNoDocument(e, t));
                }
                n.Mt && (e.set(s, n.Ot()), n.Ft());
            }
        });
        let n = $70fd6868680e912c$var$gs();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.zt.forEach((t, e)=>{
            let s = !0;
            e.forEachWhile((t)=>{
                const e = this.se(t);
                return !e || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === e.purpose || (s = !1, !1);
            }), s && (n = n.add(t));
        }), this.jt.forEach((e, n)=>n.setReadTime(t));
        const s = new $70fd6868680e912c$var$mi(t, e, this.Wt, this.jt, n);
        return this.jt = $70fd6868680e912c$var$cs(), this.zt = $70fd6868680e912c$var$Ai(), this.Wt = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), s;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Jt(t, e) {
        if (!this.te(t)) return;
        const n = this.ae(t, e.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.Zt(t).Bt(e.key, n), this.jt = this.jt.insert(e.key, e), this.zt = this.zt.insert(e.key, this.he(e.key).add(t));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    Yt(t, e, n) {
        if (!this.te(t)) return;
        const s = this.Zt(t);
        this.ae(t, e) ? s.Bt(e, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        s.Lt(e), this.zt = this.zt.insert(e, this.he(e).delete(t)), n && (this.jt = this.jt.insert(e, n));
    }
    removeTarget(t) {
        this.Qt.delete(t);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ ie(t) {
        const e = this.Zt(t).Ot();
        return this.Gt.getRemoteKeysForTarget(t).size + e.addedDocuments.size - e.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ qt(t) {
        this.Zt(t).qt();
    }
    Zt(t) {
        let e = this.Qt.get(t);
        return e || (e = new $70fd6868680e912c$var$Ti, this.Qt.set(t, e)), e;
    }
    he(t) {
        let e = this.zt.get(t);
        return e || (e = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et), this.zt = this.zt.insert(t, e)), e;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ te(t) {
        const e = null !== this.se(t);
        return e || $70fd6868680e912c$var$N("WatchChangeAggregator", "Detected inactive target", t), e;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ se(t) {
        const e = this.Qt.get(t);
        return e && e.kt ? null : this.Gt.le(t);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ ee(t) {
        this.Qt.set(t, new $70fd6868680e912c$var$Ti);
        this.Gt.getRemoteKeysForTarget(t).forEach((e)=>{
            this.Yt(t, e, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ ae(t, e) {
        return this.Gt.getRemoteKeysForTarget(t).has(e);
    }
}
function $70fd6868680e912c$var$Ai() {
    return new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
function $70fd6868680e912c$var$vi() {
    return new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
const $70fd6868680e912c$var$Ri = (()=>{
    const t = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return t;
})(), $70fd6868680e912c$var$Pi = (()=>{
    const t = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return t;
})(), $70fd6868680e912c$var$bi = (()=>{
    const t = {
        and: "AND",
        or: "OR"
    };
    return t;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $70fd6868680e912c$var$Vi {
    constructor(t, e){
        this.databaseId = t, this.useProto3Json = e;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $70fd6868680e912c$var$Si(t, e) {
    return t.useProto3Json || $70fd6868680e912c$var$Ft(e) ? e : {
        value: e
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $70fd6868680e912c$var$Di(t, e) {
    if (t.useProto3Json) return `${new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + e.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + e.seconds,
        nanos: e.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$Ci(t, e) {
    return t.useProto3Json ? e.toBase64() : e.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $70fd6868680e912c$var$xi(t, e) {
    return $70fd6868680e912c$var$Di(t, e.toTimestamp());
}
function $70fd6868680e912c$var$Ni(t) {
    return $70fd6868680e912c$var$F(!!t), $70fd6868680e912c$var$rt.fromTimestamp(function(t) {
        const e = $70fd6868680e912c$var$De(t);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }(t));
}
function $70fd6868680e912c$var$ki(t, e) {
    return (function(t) {
        return new $70fd6868680e912c$var$ut([
            "projects",
            t.projectId,
            "databases",
            t.database
        ]);
    })(t).child("documents").child(e).canonicalString();
}
function $70fd6868680e912c$var$Mi(t) {
    const e = $70fd6868680e912c$var$ut.fromString(t);
    return $70fd6868680e912c$var$F($70fd6868680e912c$var$ur(e)), e;
}
function $70fd6868680e912c$var$$i(t, e) {
    return $70fd6868680e912c$var$ki(t.databaseId, e.path);
}
function $70fd6868680e912c$var$Oi(t, e) {
    const n = $70fd6868680e912c$var$Mi(e);
    if (n.get(1) !== t.databaseId.projectId) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + t.databaseId.projectId);
    if (n.get(3) !== t.databaseId.database) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + t.databaseId.database);
    return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$qi(n));
}
function $70fd6868680e912c$var$Fi(t, e) {
    return $70fd6868680e912c$var$ki(t.databaseId, e);
}
function $70fd6868680e912c$var$Bi(t) {
    const e = $70fd6868680e912c$var$Mi(t);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === e.length ? $70fd6868680e912c$var$ut.emptyPath() : $70fd6868680e912c$var$qi(e);
}
function $70fd6868680e912c$var$Li(t) {
    return new $70fd6868680e912c$var$ut([
        "projects",
        t.databaseId.projectId,
        "databases",
        t.databaseId.database
    ]).canonicalString();
}
function $70fd6868680e912c$var$qi(t) {
    return $70fd6868680e912c$var$F(t.length > 4 && "documents" === t.get(4)), t.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $70fd6868680e912c$var$Ui(t, e, n) {
    return {
        name: $70fd6868680e912c$var$$i(t, e),
        fields: n.value.mapValue.fields
    };
}
function $70fd6868680e912c$var$Ki(t, e, n) {
    const s = $70fd6868680e912c$var$Oi(t, e.name), i = $70fd6868680e912c$var$Ni(e.updateTime), r = e.createTime ? $70fd6868680e912c$var$Ni(e.createTime) : $70fd6868680e912c$var$rt.min(), o = new $70fd6868680e912c$var$un({
        mapValue: {
            fields: e.fields
        }
    }), u = $70fd6868680e912c$var$an.newFoundDocument(s, i, r, o);
    return n && u.setHasCommittedMutations(), n ? u.setHasCommittedMutations() : u;
}
function $70fd6868680e912c$var$Gi(t, e) {
    return "found" in e ? function(t, e) {
        $70fd6868680e912c$var$F(!!e.found), e.found.name, e.found.updateTime;
        const n = $70fd6868680e912c$var$Oi(t, e.found.name), s = $70fd6868680e912c$var$Ni(e.found.updateTime), i = e.found.createTime ? $70fd6868680e912c$var$Ni(e.found.createTime) : $70fd6868680e912c$var$rt.min(), r = new $70fd6868680e912c$var$un({
            mapValue: {
                fields: e.found.fields
            }
        });
        return $70fd6868680e912c$var$an.newFoundDocument(n, s, i, r);
    }(t, e) : "missing" in e ? function(t, e) {
        $70fd6868680e912c$var$F(!!e.missing), $70fd6868680e912c$var$F(!!e.readTime);
        const n = $70fd6868680e912c$var$Oi(t, e.missing), s = $70fd6868680e912c$var$Ni(e.readTime);
        return $70fd6868680e912c$var$an.newNoDocument(n, s);
    }(t, e) : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$Qi(t, e) {
    let n;
    if ("targetChange" in e) {
        e.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const s = function(t) {
            return "NO_CHANGE" === t ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === t ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === t ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === t ? 3 /* WatchTargetChangeState.Current */  : "RESET" === t ? 4 /* WatchTargetChangeState.Reset */  : $70fd6868680e912c$var$O();
        }(e.targetChange.targetChangeType || "NO_CHANGE"), i = e.targetChange.targetIds || [], r = function(t, e) {
            return t.useProto3Json ? ($70fd6868680e912c$var$F(void 0 === e || "string" == typeof e), $70fd6868680e912c$var$Ve.fromBase64String(e || "")) : ($70fd6868680e912c$var$F(void 0 === e || e instanceof Uint8Array), $70fd6868680e912c$var$Ve.fromUint8Array(e || new Uint8Array));
        }(t, e.targetChange.resumeToken), o = e.targetChange.cause, u = o && function(t) {
            const e = void 0 === t.code ? $70fd6868680e912c$var$q.UNKNOWN : $70fd6868680e912c$var$ui(t.code);
            return new $70fd6868680e912c$export$8fada0bf726bf278(e, t.message || "");
        }(o);
        n = new $70fd6868680e912c$var$Ii(s, i, r, u || null);
    } else if ("documentChange" in e) {
        e.documentChange;
        const s = e.documentChange;
        s.document, s.document.name, s.document.updateTime;
        const i = $70fd6868680e912c$var$Oi(t, s.document.name), r = $70fd6868680e912c$var$Ni(s.document.updateTime), o = s.document.createTime ? $70fd6868680e912c$var$Ni(s.document.createTime) : $70fd6868680e912c$var$rt.min(), u = new $70fd6868680e912c$var$un({
            mapValue: {
                fields: s.document.fields
            }
        }), c = $70fd6868680e912c$var$an.newFoundDocument(i, r, o, u), a = s.targetIds || [], h = s.removedTargetIds || [];
        n = new $70fd6868680e912c$var$yi(a, h, c.key, c);
    } else if ("documentDelete" in e) {
        e.documentDelete;
        const s = e.documentDelete;
        s.document;
        const i = $70fd6868680e912c$var$Oi(t, s.document), r = s.readTime ? $70fd6868680e912c$var$Ni(s.readTime) : $70fd6868680e912c$var$rt.min(), o = $70fd6868680e912c$var$an.newNoDocument(i, r), u = s.removedTargetIds || [];
        n = new $70fd6868680e912c$var$yi([], u, o.key, o);
    } else if ("documentRemove" in e) {
        e.documentRemove;
        const s = e.documentRemove;
        s.document;
        const i = $70fd6868680e912c$var$Oi(t, s.document), r = s.removedTargetIds || [];
        n = new $70fd6868680e912c$var$yi([], r, i, null);
    } else {
        if (!("filter" in e)) return $70fd6868680e912c$var$O();
        {
            e.filter;
            const t = e.filter;
            t.targetId;
            const { count: s = 0, unchangedNames: i } = t, r = new $70fd6868680e912c$var$si(s, i), o = t.targetId;
            n = new $70fd6868680e912c$var$pi(o, r);
        }
    }
    return n;
}
function $70fd6868680e912c$var$ji(t, e) {
    let n;
    if (e instanceof $70fd6868680e912c$var$js) n = {
        update: $70fd6868680e912c$var$Ui(t, e.key, e.value)
    };
    else if (e instanceof $70fd6868680e912c$var$Ys) n = {
        delete: $70fd6868680e912c$var$$i(t, e.key)
    };
    else if (e instanceof $70fd6868680e912c$var$zs) n = {
        update: $70fd6868680e912c$var$Ui(t, e.key, e.data),
        updateMask: $70fd6868680e912c$var$or(e.fieldMask)
    };
    else {
        if (!(e instanceof $70fd6868680e912c$var$Xs)) return $70fd6868680e912c$var$O();
        n = {
            verify: $70fd6868680e912c$var$$i(t, e.key)
        };
    }
    return e.fieldTransforms.length > 0 && (n.updateTransforms = e.fieldTransforms.map((t)=>(function(t, e) {
            const n = e.transform;
            if (n instanceof $70fd6868680e912c$var$bs) return {
                fieldPath: e.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $70fd6868680e912c$var$Vs) return {
                fieldPath: e.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$Ds) return {
                fieldPath: e.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$xs) return {
                fieldPath: e.field.canonicalString(),
                increment: n.gt
            };
            throw $70fd6868680e912c$var$O();
        })(0, t))), e.precondition.isNone || (n.currentDocument = function(t, e) {
        return void 0 !== e.updateTime ? {
            updateTime: $70fd6868680e912c$var$xi(t, e.updateTime)
        } : void 0 !== e.exists ? {
            exists: e.exists
        } : $70fd6868680e912c$var$O();
    }(t, e.precondition)), n;
}
function $70fd6868680e912c$var$zi(t, e) {
    const n = e.currentDocument ? function(t) {
        return void 0 !== t.updateTime ? $70fd6868680e912c$var$Fs.updateTime($70fd6868680e912c$var$Ni(t.updateTime)) : void 0 !== t.exists ? $70fd6868680e912c$var$Fs.exists(t.exists) : $70fd6868680e912c$var$Fs.none();
    }(e.currentDocument) : $70fd6868680e912c$var$Fs.none(), s = e.updateTransforms ? e.updateTransforms.map((e)=>(function(t, e) {
            let n = null;
            if ("setToServerValue" in e) $70fd6868680e912c$var$F("REQUEST_TIME" === e.setToServerValue), n = new $70fd6868680e912c$var$bs;
            else if ("appendMissingElements" in e) {
                const t = e.appendMissingElements.values || [];
                n = new $70fd6868680e912c$var$Vs(t);
            } else if ("removeAllFromArray" in e) {
                const t = e.removeAllFromArray.values || [];
                n = new $70fd6868680e912c$var$Ds(t);
            } else "increment" in e ? n = new $70fd6868680e912c$var$xs(t, e.increment) : $70fd6868680e912c$var$O();
            const s = $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
            return new $70fd6868680e912c$var$Ms(s, n);
        })(t, e)) : [];
    if (e.update) {
        e.update.name;
        const i = $70fd6868680e912c$var$Oi(t, e.update.name), r = new $70fd6868680e912c$var$un({
            mapValue: {
                fields: e.update.fields
            }
        });
        if (e.updateMask) {
            const t = function(t) {
                const e = t.fieldPaths || [];
                return new $70fd6868680e912c$var$Re(e.map((t)=>$70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t)));
            }(e.updateMask);
            return new $70fd6868680e912c$var$zs(i, r, t, n, s);
        }
        return new $70fd6868680e912c$var$js(i, r, n, s);
    }
    if (e.delete) {
        const s = $70fd6868680e912c$var$Oi(t, e.delete);
        return new $70fd6868680e912c$var$Ys(s, n);
    }
    if (e.verify) {
        const s = $70fd6868680e912c$var$Oi(t, e.verify);
        return new $70fd6868680e912c$var$Xs(s, n);
    }
    return $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$Wi(t, e) {
    return t && t.length > 0 ? ($70fd6868680e912c$var$F(void 0 !== e), t.map((t)=>(function(t, e) {
            // NOTE: Deletes don't have an updateTime.
            let n = t.updateTime ? $70fd6868680e912c$var$Ni(t.updateTime) : $70fd6868680e912c$var$Ni(e);
            return n.isEqual($70fd6868680e912c$var$rt.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $70fd6868680e912c$var$Ni(e)), new $70fd6868680e912c$var$Os(n, t.transformResults || []);
        })(t, e))) : [];
}
function $70fd6868680e912c$var$Hi(t, e) {
    return {
        documents: [
            $70fd6868680e912c$var$Fi(t, e.path)
        ]
    };
}
function $70fd6868680e912c$var$Ji(t, e) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, s = e.path;
    null !== e.collectionGroup ? (n.parent = $70fd6868680e912c$var$Fi(t, s), n.structuredQuery.from = [
        {
            collectionId: e.collectionGroup,
            allDescendants: !0
        }
    ]) : (n.parent = $70fd6868680e912c$var$Fi(t, s.popLast()), n.structuredQuery.from = [
        {
            collectionId: s.lastSegment()
        }
    ]);
    const i = function(t) {
        if (0 === t.length) return;
        return $70fd6868680e912c$var$rr($70fd6868680e912c$var$gn.create(t, "and" /* CompositeOperator.AND */ ));
    }(e.filters);
    i && (n.structuredQuery.where = i);
    const r = function(t) {
        if (0 === t.length) return;
        return t.map((t)=>// visible for testing
            (function(t) {
                return {
                    field: $70fd6868680e912c$var$sr(t.field),
                    direction: $70fd6868680e912c$var$tr(t.dir)
                };
            })(t));
    }(e.orderBy);
    r && (n.structuredQuery.orderBy = r);
    const o = $70fd6868680e912c$var$Si(t, e.limit);
    var u;
    return null !== o && (n.structuredQuery.limit = o), e.startAt && (n.structuredQuery.startAt = {
        before: (u = e.startAt).inclusive,
        values: u.position
    }), e.endAt && (n.structuredQuery.endAt = function(t) {
        return {
            before: !t.inclusive,
            values: t.position
        };
    }(e.endAt)), n;
}
function $70fd6868680e912c$var$Yi(t) {
    let e = $70fd6868680e912c$var$Bi(t.parent);
    const n = t.structuredQuery, s = n.from ? n.from.length : 0;
    let i = null;
    if (s > 0) {
        $70fd6868680e912c$var$F(1 === s);
        const t = n.from[0];
        t.allDescendants ? i = t.collectionId : e = e.child(t.collectionId);
    }
    let r = [];
    n.where && (r = function(t) {
        const e = $70fd6868680e912c$var$Zi(t);
        if (e instanceof $70fd6868680e912c$var$gn && $70fd6868680e912c$var$In(e)) return e.getFilters();
        return [
            e
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = n.orderBy.map((t)=>(function(t) {
            return new $70fd6868680e912c$var$dn($70fd6868680e912c$var$ir(t.field), // visible for testing
            function(t) {
                switch(t){
                    case "ASCENDING":
                        return "asc" /* Direction.ASCENDING */ ;
                    case "DESCENDING":
                        return "desc" /* Direction.DESCENDING */ ;
                    default:
                        return;
                }
            }(t.direction));
        })(t)));
    let u = null;
    n.limit && (u = function(t) {
        let e;
        return e = "object" == typeof t ? t.value : t, $70fd6868680e912c$var$Ft(e) ? null : e;
    }(n.limit));
    let c = null;
    n.startAt && (c = function(t) {
        const e = !!t.before, n = t.values || [];
        return new $70fd6868680e912c$var$hn(n, e);
    }(n.startAt));
    let a = null;
    return n.endAt && (a = function(t) {
        const e = !t.before, n = t.values || [];
        return new $70fd6868680e912c$var$hn(n, e);
    }(n.endAt)), $70fd6868680e912c$var$Kn(e, i, o, r, u, "F" /* LimitType.First */ , c, a);
}
function $70fd6868680e912c$var$Xi(t, e) {
    const n = function(t) {
        switch(t){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $70fd6868680e912c$var$O();
        }
    }(e.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $70fd6868680e912c$var$Zi(t) {
    return void 0 !== t.unaryFilter ? function(t) {
        switch(t.unaryFilter.op){
            case "IS_NAN":
                const e = $70fd6868680e912c$var$ir(t.unaryFilter.field);
                return $70fd6868680e912c$var$mn.create(e, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $70fd6868680e912c$var$ir(t.unaryFilter.field);
                return $70fd6868680e912c$var$mn.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const s = $70fd6868680e912c$var$ir(t.unaryFilter.field);
                return $70fd6868680e912c$var$mn.create(s, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $70fd6868680e912c$var$ir(t.unaryFilter.field);
                return $70fd6868680e912c$var$mn.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            default:
                return $70fd6868680e912c$var$O();
        }
    }(t) : void 0 !== t.fieldFilter ? function(t) {
        return $70fd6868680e912c$var$mn.create($70fd6868680e912c$var$ir(t.fieldFilter.field), function(t) {
            switch(t){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                default:
                    return $70fd6868680e912c$var$O();
            }
        }(t.fieldFilter.op), t.fieldFilter.value);
    }(t) : void 0 !== t.compositeFilter ? function(t) {
        return $70fd6868680e912c$var$gn.create(t.compositeFilter.filters.map((t)=>$70fd6868680e912c$var$Zi(t)), function(t) {
            switch(t){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $70fd6868680e912c$var$O();
            }
        }(t.compositeFilter.op));
    }(t) : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$tr(t) {
    return $70fd6868680e912c$var$Ri[t];
}
function $70fd6868680e912c$var$er(t) {
    return $70fd6868680e912c$var$Pi[t];
}
function $70fd6868680e912c$var$nr(t) {
    return $70fd6868680e912c$var$bi[t];
}
function $70fd6868680e912c$var$sr(t) {
    return {
        fieldPath: t.canonicalString()
    };
}
function $70fd6868680e912c$var$ir(t) {
    return $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
}
function $70fd6868680e912c$var$rr(t) {
    return t instanceof $70fd6868680e912c$var$mn ? function(t) {
        if ("==" /* Operator.EQUAL */  === t.op) {
            if ($70fd6868680e912c$var$Xe(t.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$sr(t.field),
                    op: "IS_NAN"
                }
            };
            if ($70fd6868680e912c$var$Ye(t.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$sr(t.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === t.op) {
            if ($70fd6868680e912c$var$Xe(t.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$sr(t.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($70fd6868680e912c$var$Ye(t.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$sr(t.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $70fd6868680e912c$var$sr(t.field),
                op: $70fd6868680e912c$var$er(t.op),
                value: t.value
            }
        };
    }(t) : t instanceof $70fd6868680e912c$var$gn ? function(t) {
        const e = t.getFilters().map((t)=>$70fd6868680e912c$var$rr(t));
        if (1 === e.length) return e[0];
        return {
            compositeFilter: {
                op: $70fd6868680e912c$var$nr(t.op),
                filters: e
            }
        };
    }(t) : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$or(t) {
    const e = [];
    return t.fields.forEach((t)=>e.push(t.canonicalString())), {
        fieldPaths: e
    };
}
function $70fd6868680e912c$var$ur(t) {
    // Resource names have at least 4 components (project ID, database ID)
    return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $70fd6868680e912c$var$cr {
    constructor(/** The target being listened to. */ t, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ e, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ s, /** The latest snapshot version seen for this target. */ i = $70fd6868680e912c$var$rt.min(), r = $70fd6868680e912c$var$rt.min(), o = $70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, u = null){
        this.target = t, this.targetId = e, this.purpose = n, this.sequenceNumber = s, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = r, this.resumeToken = o, this.expectedCount = u;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(t) {
        return new $70fd6868680e912c$var$cr(this.target, this.targetId, this.purpose, t, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(t, e) {
        return new $70fd6868680e912c$var$cr(this.target, this.targetId, this.purpose, this.sequenceNumber, e, this.lastLimboFreeSnapshotVersion, t, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(t) {
        return new $70fd6868680e912c$var$cr(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, t);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(t) {
        return new $70fd6868680e912c$var$cr(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, t, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $70fd6868680e912c$var$ar {
    constructor(t){
        this.fe = t;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $70fd6868680e912c$var$hr(t, e) {
    let n;
    if (e.document) n = $70fd6868680e912c$var$Ki(t.fe, e.document, !!e.hasCommittedMutations);
    else if (e.noDocument) {
        const t = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.noDocument.path), s = $70fd6868680e912c$var$wr(e.noDocument.readTime);
        n = $70fd6868680e912c$var$an.newNoDocument(t, s), e.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!e.unknownDocument) return $70fd6868680e912c$var$O();
        {
            const t = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path), s = $70fd6868680e912c$var$wr(e.unknownDocument.version);
            n = $70fd6868680e912c$var$an.newUnknownDocument(t, s);
        }
    }
    return e.readTime && n.setReadTime(function(t) {
        const e = new $70fd6868680e912c$export$d9bcbd5e1ff81430(t[0], t[1]);
        return $70fd6868680e912c$var$rt.fromTimestamp(e);
    }(e.readTime)), n;
}
/** Encodes a document for storage locally. */ function $70fd6868680e912c$var$lr(t, e) {
    const n = e.key, s = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $70fd6868680e912c$var$fr(e.readTime),
        hasCommittedMutations: e.hasCommittedMutations
    };
    if (e.isFoundDocument()) s.document = function(t, e) {
        return {
            name: $70fd6868680e912c$var$$i(t, e.key),
            fields: e.data.value.mapValue.fields,
            updateTime: $70fd6868680e912c$var$Di(t, e.version.toTimestamp()),
            createTime: $70fd6868680e912c$var$Di(t, e.createTime.toTimestamp())
        };
    }(t.fe, e);
    else if (e.isNoDocument()) s.noDocument = {
        path: n.path.toArray(),
        readTime: $70fd6868680e912c$var$dr(e.version)
    };
    else {
        if (!e.isUnknownDocument()) return $70fd6868680e912c$var$O();
        s.unknownDocument = {
            path: n.path.toArray(),
            version: $70fd6868680e912c$var$dr(e.version)
        };
    }
    return s;
}
function $70fd6868680e912c$var$fr(t) {
    const e = t.toTimestamp();
    return [
        e.seconds,
        e.nanoseconds
    ];
}
function $70fd6868680e912c$var$dr(t) {
    const e = t.toTimestamp();
    return {
        seconds: e.seconds,
        nanoseconds: e.nanoseconds
    };
}
function $70fd6868680e912c$var$wr(t) {
    const e = new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanoseconds);
    return $70fd6868680e912c$var$rt.fromTimestamp(e);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $70fd6868680e912c$var$_r(t, e) {
    const n = (e.baseMutations || []).map((e)=>$70fd6868680e912c$var$zi(t.fe, e));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let t = 0; t < e.mutations.length - 1; ++t){
        const n = e.mutations[t];
        if (t + 1 < e.mutations.length && void 0 !== e.mutations[t + 1].transform) {
            const s = e.mutations[t + 1];
            n.updateTransforms = s.transform.fieldTransforms, e.mutations.splice(t + 1, 1), ++t;
        }
    }
    const s = e.mutations.map((e)=>$70fd6868680e912c$var$zi(t.fe, e)), i = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(e.localWriteTimeMs);
    return new $70fd6868680e912c$var$Zs(e.batchId, i, n, s);
}
/** Decodes a DbTarget into TargetData */ function $70fd6868680e912c$var$mr(t) {
    const e = $70fd6868680e912c$var$wr(t.readTime), n = void 0 !== t.lastLimboFreeSnapshotVersion ? $70fd6868680e912c$var$wr(t.lastLimboFreeSnapshotVersion) : $70fd6868680e912c$var$rt.min();
    let s;
    var i;
    return void 0 !== t.query.documents ? ($70fd6868680e912c$var$F(1 === (i = t.query).documents.length), s = $70fd6868680e912c$var$Jn($70fd6868680e912c$var$Gn($70fd6868680e912c$var$Bi(i.documents[0])))) : s = function(t) {
        return $70fd6868680e912c$var$Jn($70fd6868680e912c$var$Yi(t));
    }(t.query), new $70fd6868680e912c$var$cr(s, t.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , t.lastListenSequenceNumber, e, n, $70fd6868680e912c$var$Ve.fromBase64String(t.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $70fd6868680e912c$var$gr(t, e) {
    const n = $70fd6868680e912c$var$dr(e.snapshotVersion), s = $70fd6868680e912c$var$dr(e.lastLimboFreeSnapshotVersion);
    let i;
    i = $70fd6868680e912c$var$Fn(e.target) ? $70fd6868680e912c$var$Hi(t.fe, e.target) : $70fd6868680e912c$var$Ji(t.fe, e.target);
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const r = e.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: e.targetId,
        canonicalId: $70fd6868680e912c$var$$n(e.target),
        readTime: n,
        resumeToken: r,
        lastListenSequenceNumber: e.sequenceNumber,
        lastLimboFreeSnapshotVersion: s,
        query: i
    };
}
/**
 * A helper function for figuring out what kind of query has been stored.
 */ /**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $70fd6868680e912c$var$yr(t) {
    const e = $70fd6868680e912c$var$Yi({
        parent: t.parent,
        structuredQuery: t.structuredQuery
    });
    return "LAST" === t.limitType ? $70fd6868680e912c$var$Xn(e, e.limit, "L" /* LimitType.Last */ ) : e;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $70fd6868680e912c$var$pr(t, e) {
    return new $70fd6868680e912c$var$ei(e.largestBatchId, $70fd6868680e912c$var$zi(t.fe, e.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $70fd6868680e912c$var$Ir(t, e) {
    const n = e.path.lastSegment();
    return [
        t,
        $70fd6868680e912c$var$qt(e.path.popLast()),
        n
    ];
}
function $70fd6868680e912c$var$Tr(t, e, n, s) {
    return {
        indexId: t,
        uid: e.uid || "",
        sequenceNumber: n,
        readTime: $70fd6868680e912c$var$dr(s.readTime),
        documentKey: $70fd6868680e912c$var$qt(s.documentKey.path),
        largestBatchId: s.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Er {
    getBundleMetadata(t, e) {
        return $70fd6868680e912c$var$Ar(t).get(e).next((t)=>{
            if (t) return {
                id: (e = t).bundleId,
                createTime: $70fd6868680e912c$var$wr(e.createTime),
                version: e.version
            };
            /** Encodes a DbBundle to a BundleMetadata object. */ var e;
        /** Encodes a BundleMetadata to a DbBundle. */ });
    }
    saveBundleMetadata(t, e) {
        var n;
        return $70fd6868680e912c$var$Ar(t).put({
            bundleId: (n = e).id,
            createTime: $70fd6868680e912c$var$dr($70fd6868680e912c$var$Ni(n.createTime)),
            version: n.version
        });
    /** Encodes a DbNamedQuery to a NamedQuery. */ }
    getNamedQuery(t, e) {
        return $70fd6868680e912c$var$vr(t).get(e).next((t)=>{
            if (t) return {
                name: (e = t).name,
                query: $70fd6868680e912c$var$yr(e.bundledQuery),
                readTime: $70fd6868680e912c$var$wr(e.readTime)
            };
            var e;
        /** Encodes a NamedQuery from a bundle proto to a DbNamedQuery. */ });
    }
    saveNamedQuery(t, e) {
        return $70fd6868680e912c$var$vr(t).put(function(t) {
            return {
                name: t.name,
                readTime: $70fd6868680e912c$var$dr($70fd6868680e912c$var$Ni(t.readTime)),
                bundledQuery: t.bundledQuery
            };
        }(e));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $70fd6868680e912c$var$Ar(t) {
    return $70fd6868680e912c$var$_e(t, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $70fd6868680e912c$var$vr(t) {
    return $70fd6868680e912c$var$_e(t, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $70fd6868680e912c$var$Rr {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(t, e){
        this.serializer = t, this.userId = e;
    }
    static de(t, e) {
        const n = e.uid || "";
        return new $70fd6868680e912c$var$Rr(t, n);
    }
    getOverlay(t, e) {
        return $70fd6868680e912c$var$Pr(t).get($70fd6868680e912c$var$Ir(this.userId, e)).next((t)=>t ? $70fd6868680e912c$var$pr(this.serializer, t) : null);
    }
    getOverlays(t, e) {
        const n = $70fd6868680e912c$var$fs();
        return $70fd6868680e912c$var$Rt.forEach(e, (e)=>this.getOverlay(t, e).next((t)=>{
                null !== t && n.set(e, t);
            })).next(()=>n);
    }
    saveOverlays(t, e, n) {
        const s = [];
        return n.forEach((n, i)=>{
            const r = new $70fd6868680e912c$var$ei(e, i);
            s.push(this.we(t, r));
        }), $70fd6868680e912c$var$Rt.waitFor(s);
    }
    removeOverlaysForBatchId(t, e, n) {
        const s = new Set;
        // Get the set of unique collection paths.
        e.forEach((t)=>s.add($70fd6868680e912c$var$qt(t.getCollectionPath())));
        const i = [];
        return s.forEach((e)=>{
            const s = IDBKeyRange.bound([
                this.userId,
                e,
                n
            ], [
                this.userId,
                e,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($70fd6868680e912c$var$Pr(t).J("collectionPathOverlayIndex", s));
        }), $70fd6868680e912c$var$Rt.waitFor(i);
    }
    getOverlaysForCollection(t, e, n) {
        const s = $70fd6868680e912c$var$fs(), i = $70fd6868680e912c$var$qt(e), r = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$Pr(t).j("collectionPathOverlayIndex", r).next((t)=>{
            for (const e of t){
                const t = $70fd6868680e912c$var$pr(this.serializer, e);
                s.set(t.getKey(), t);
            }
            return s;
        });
    }
    getOverlaysForCollectionGroup(t, e, n, s) {
        const i = $70fd6868680e912c$var$fs();
        let r;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            e,
            n
        ], [
            this.userId,
            e,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$Pr(t).X({
            index: "collectionGroupOverlayIndex",
            range: o
        }, (t, e, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $70fd6868680e912c$var$pr(this.serializer, e);
            i.size() < s || o.largestBatchId === r ? (i.set(o.getKey(), o), r = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    we(t, e) {
        return $70fd6868680e912c$var$Pr(t).put(function(t, e, n) {
            const [s, i, r] = $70fd6868680e912c$var$Ir(e, n.mutation.key);
            return {
                userId: e,
                collectionPath: i,
                documentId: r,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $70fd6868680e912c$var$ji(t.fe, n.mutation)
            };
        }(this.serializer, this.userId, e));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $70fd6868680e912c$var$Pr(t) {
    return $70fd6868680e912c$var$_e(t, "documentOverlays");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $70fd6868680e912c$var$br {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ _e(t, e) {
        this.me(t, e), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        e.ge();
    }
    me(t, e) {
        if ("nullValue" in t) this.ye(e, 5);
        else if ("booleanValue" in t) this.ye(e, 10), e.pe(t.booleanValue ? 1 : 0);
        else if ("integerValue" in t) this.ye(e, 15), e.pe($70fd6868680e912c$var$Ce(t.integerValue));
        else if ("doubleValue" in t) {
            const n = $70fd6868680e912c$var$Ce(t.doubleValue);
            isNaN(n) ? this.ye(e, 13) : (this.ye(e, 15), $70fd6868680e912c$var$Bt(n) ? // -0.0, 0 and 0.0 are all considered the same
            e.pe(0) : e.pe(n));
        } else if ("timestampValue" in t) {
            const n = t.timestampValue;
            this.ye(e, 20), "string" == typeof n ? e.Ie(n) : (e.Ie(`${n.seconds || ""}`), e.pe(n.nanos || 0));
        } else if ("stringValue" in t) this.Te(t.stringValue, e), this.Ee(e);
        else if ("bytesValue" in t) this.ye(e, 30), e.Ae($70fd6868680e912c$var$xe(t.bytesValue)), this.Ee(e);
        else if ("referenceValue" in t) this.ve(t.referenceValue, e);
        else if ("geoPointValue" in t) {
            const n = t.geoPointValue;
            this.ye(e, 45), e.pe(n.latitude || 0), e.pe(n.longitude || 0);
        } else "mapValue" in t ? $70fd6868680e912c$var$en(t) ? this.ye(e, Number.MAX_SAFE_INTEGER) : (this.Re(t.mapValue, e), this.Ee(e)) : "arrayValue" in t ? (this.Pe(t.arrayValue, e), this.Ee(e)) : $70fd6868680e912c$var$O();
    }
    Te(t, e) {
        this.ye(e, 25), this.be(t, e);
    }
    be(t, e) {
        e.Ie(t);
    }
    Re(t, e) {
        const n = t.fields || {};
        this.ye(e, 55);
        for (const t of Object.keys(n))this.Te(t, e), this.me(n[t], e);
    }
    Pe(t, e) {
        const n = t.values || [];
        this.ye(e, 50);
        for (const t of n)this.me(t, e);
    }
    ve(t, e) {
        this.ye(e, 37);
        $70fd6868680e912c$export$afc2e57c475b7810.fromName(t).path.forEach((t)=>{
            this.ye(e, 60), this.be(t, e);
        });
    }
    ye(t, e) {
        t.pe(e);
    }
    Ee(t) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        t.pe(2);
    }
}
$70fd6868680e912c$var$br.Ve = new $70fd6868680e912c$var$br;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$Vr(t) {
    if (0 === t) return 8;
    let e = 0;
    return t >> 4 == 0 && // Test if the first four bits are zero.
    (e += 4, t <<= 4), t >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (e += 2, t <<= 2), t >> 7 == 0 && // Test if the remaining bit is zero.
    (e += 1), e;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $70fd6868680e912c$var$Sr(t) {
    // This is just the number of bytes for the unsigned representation of the number.
    const e = 64 - function(t) {
        let e = 0;
        for(let n = 0; n < 8; ++n){
            const s = $70fd6868680e912c$var$Vr(255 & t[n]);
            if (e += s, 8 !== s) break;
        }
        return e;
    }(t);
    return Math.ceil(e / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $70fd6868680e912c$var$Dr {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Se(t) {
        const e = t[Symbol.iterator]();
        let n = e.next();
        for(; !n.done;)this.De(n.value), n = e.next();
        this.Ce();
    }
    xe(t) {
        const e = t[Symbol.iterator]();
        let n = e.next();
        for(; !n.done;)this.Ne(n.value), n = e.next();
        this.ke();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Me(t) {
        for (const e of t){
            const t = e.charCodeAt(0);
            if (t < 128) this.De(t);
            else if (t < 2048) this.De(960 | t >>> 6), this.De(128 | 63 & t);
            else if (e < "\ud800" || "\udbff" < e) this.De(480 | t >>> 12), this.De(128 | 63 & t >>> 6), this.De(128 | 63 & t);
            else {
                const t = e.codePointAt(0);
                this.De(240 | t >>> 18), this.De(128 | 63 & t >>> 12), this.De(128 | 63 & t >>> 6), this.De(128 | 63 & t);
            }
        }
        this.Ce();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ $e(t) {
        for (const e of t){
            const t = e.charCodeAt(0);
            if (t < 128) this.Ne(t);
            else if (t < 2048) this.Ne(960 | t >>> 6), this.Ne(128 | 63 & t);
            else if (e < "\ud800" || "\udbff" < e) this.Ne(480 | t >>> 12), this.Ne(128 | 63 & t >>> 6), this.Ne(128 | 63 & t);
            else {
                const t = e.codePointAt(0);
                this.Ne(240 | t >>> 18), this.Ne(128 | 63 & t >>> 12), this.Ne(128 | 63 & t >>> 6), this.Ne(128 | 63 & t);
            }
        }
        this.ke();
    }
    Oe(t) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const e = this.Fe(t), n = $70fd6868680e912c$var$Sr(e);
        this.Be(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let t = e.length - n; t < e.length; ++t)this.buffer[this.position++] = 255 & e[t];
    }
    Le(t) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const e = this.Fe(t), n = $70fd6868680e912c$var$Sr(e);
        this.Be(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let t = e.length - n; t < e.length; ++t)this.buffer[this.position++] = ~(255 & e[t]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ qe() {
        this.Ue(255), this.Ue(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ Ke() {
        this.Ge(255), this.Ge(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(t) {
        this.Be(t.length), this.buffer.set(t, this.position), this.position += t.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Qe() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Fe(t) {
        const e = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function(t) {
            const e = new DataView(new ArrayBuffer(8));
            return e.setFloat64(0, t, /* littleEndian= */ !1), new Uint8Array(e.buffer);
        }(t), n = 0 != (128 & e[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        e[0] ^= n ? 255 : 128;
        for(let t = 1; t < e.length; ++t)e[t] ^= n ? 255 : 0;
        return e;
    }
    /** Writes a single byte ascending to the buffer. */ De(t) {
        const e = 255 & t;
        0 === e ? (this.Ue(0), this.Ue(255)) : 255 === e ? (this.Ue(255), this.Ue(0)) : this.Ue(e);
    }
    /** Writes a single byte descending to the buffer.  */ Ne(t) {
        const e = 255 & t;
        0 === e ? (this.Ge(0), this.Ge(255)) : 255 === e ? (this.Ge(255), this.Ge(0)) : this.Ge(t);
    }
    Ce() {
        this.Ue(0), this.Ue(1);
    }
    ke() {
        this.Ge(0), this.Ge(1);
    }
    Ue(t) {
        this.Be(1), this.buffer[this.position++] = t;
    }
    Ge(t) {
        this.Be(1), this.buffer[this.position++] = ~t;
    }
    Be(t) {
        const e = t + this.position;
        if (e <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < e && (n = e);
        // Create the new buffer.
        const s = new Uint8Array(n);
        s.set(this.buffer), this.buffer = s;
    }
}
class $70fd6868680e912c$var$Cr {
    constructor(t){
        this.je = t;
    }
    Ae(t) {
        this.je.Se(t);
    }
    Ie(t) {
        this.je.Me(t);
    }
    pe(t) {
        this.je.Oe(t);
    }
    ge() {
        this.je.qe();
    }
}
class $70fd6868680e912c$var$xr {
    constructor(t){
        this.je = t;
    }
    Ae(t) {
        this.je.xe(t);
    }
    Ie(t) {
        this.je.$e(t);
    }
    pe(t) {
        this.je.Le(t);
    }
    ge() {
        this.je.Ke();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $70fd6868680e912c$var$Nr {
    constructor(){
        this.je = new $70fd6868680e912c$var$Dr, this.ze = new $70fd6868680e912c$var$Cr(this.je), this.We = new $70fd6868680e912c$var$xr(this.je);
    }
    seed(t) {
        this.je.seed(t);
    }
    He(t) {
        return 0 /* IndexKind.ASCENDING */  === t ? this.ze : this.We;
    }
    Qe() {
        return this.je.Qe();
    }
    reset() {
        this.je.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $70fd6868680e912c$var$kr {
    constructor(t, e, n, s){
        this.indexId = t, this.documentKey = e, this.arrayValue = n, this.directionalValue = s;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Je() {
        const t = this.directionalValue.length, e = 0 === t || 255 === this.directionalValue[t - 1] ? t + 1 : t, n = new Uint8Array(e);
        return n.set(this.directionalValue, 0), e !== t ? n.set([
            0
        ], this.directionalValue.length) : ++n[n.length - 1], new $70fd6868680e912c$var$kr(this.indexId, this.documentKey, this.arrayValue, n);
    }
}
function $70fd6868680e912c$var$Mr(t, e) {
    let n = t.indexId - e.indexId;
    return 0 !== n ? n : (n = $70fd6868680e912c$var$$r(t.arrayValue, e.arrayValue), 0 !== n ? n : (n = $70fd6868680e912c$var$$r(t.directionalValue, e.directionalValue), 0 !== n ? n : $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.documentKey, e.documentKey)));
}
function $70fd6868680e912c$var$$r(t, e) {
    for(let n = 0; n < t.length && n < e.length; ++n){
        const s = t[n] - e[n];
        if (0 !== s) return s;
    }
    return t.length - e.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class $70fd6868680e912c$var$Or {
    constructor(t){
        this.collectionId = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment(), this.Ye = t.orderBy, this.Xe = [];
        for (const e of t.filters){
            const t = e;
            t.isInequality() ? this.Ze = t : this.Xe.push(t);
        }
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ tn(t) {
        $70fd6868680e912c$var$F(t.collectionGroup === this.collectionId);
        // If there is an array element, find a matching filter.
        const e = $70fd6868680e912c$var$ft(t);
        if (void 0 !== e && !this.en(e)) return !1;
        const n = $70fd6868680e912c$var$dt(t);
        let s = new Set, i = 0, r = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.en(n[i]); ++i)s = s.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (void 0 !== this.Ze) {
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!s.has(this.Ze.field.canonicalString())) {
                const t = n[i];
                if (!this.nn(this.Ze, t) || !this.sn(this.Ye[r++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const t = n[i];
            if (r >= this.Ye.length || !this.sn(this.Ye[r++], t)) return !1;
        }
        return !0;
    }
    en(t) {
        for (const e of this.Xe)if (this.nn(e, t)) return !0;
        return !1;
    }
    nn(t, e) {
        if (void 0 === t || !t.field.isEqual(e.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === t.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t.op;
        return 2 /* IndexKind.CONTAINS */  === e.kind === n;
    }
    sn(t, e) {
        return !!t.field.isEqual(e.fieldPath) && (0 /* IndexKind.ASCENDING */  === e.kind && "asc" /* Direction.ASCENDING */  === t.dir || 1 /* IndexKind.DESCENDING */  === e.kind && "desc" /* Direction.DESCENDING */  === t.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $70fd6868680e912c$var$Fr(t) {
    var e, n;
    if ($70fd6868680e912c$var$F(t instanceof $70fd6868680e912c$var$mn || t instanceof $70fd6868680e912c$var$gn), t instanceof $70fd6868680e912c$var$mn) {
        if (t instanceof $70fd6868680e912c$var$Cn) {
            const s = (null === (n = null === (e = t.value.arrayValue) || void 0 === e ? void 0 : e.values) || void 0 === n ? void 0 : n.map((e)=>$70fd6868680e912c$var$mn.create(t.field, "==" /* Operator.EQUAL */ , e))) || [];
            return $70fd6868680e912c$var$gn.create(s, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return t;
    }
    // We have a composite filter.
    const s = t.filters.map((t)=>$70fd6868680e912c$var$Fr(t));
    return $70fd6868680e912c$var$gn.create(s, t.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $70fd6868680e912c$var$Br(t) {
    if (0 === t.getFilters().length) return [];
    const e = $70fd6868680e912c$var$Kr($70fd6868680e912c$var$Fr(t));
    return $70fd6868680e912c$var$F($70fd6868680e912c$var$Ur(e)), $70fd6868680e912c$var$Lr(e) || $70fd6868680e912c$var$qr(e) ? [
        e
    ] : e.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $70fd6868680e912c$var$Lr(t) {
    return t instanceof $70fd6868680e912c$var$mn;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $70fd6868680e912c$var$qr(t) {
    return t instanceof $70fd6868680e912c$var$gn && $70fd6868680e912c$var$In(t);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $70fd6868680e912c$var$Ur(t) {
    return $70fd6868680e912c$var$Lr(t) || $70fd6868680e912c$var$qr(t) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function(t) {
        if (t instanceof $70fd6868680e912c$var$gn && $70fd6868680e912c$var$pn(t)) {
            for (const e of t.getFilters())if (!$70fd6868680e912c$var$Lr(e) && !$70fd6868680e912c$var$qr(e)) return !1;
            return !0;
        }
        return !1;
    }(t);
}
function $70fd6868680e912c$var$Kr(t) {
    if ($70fd6868680e912c$var$F(t instanceof $70fd6868680e912c$var$mn || t instanceof $70fd6868680e912c$var$gn), t instanceof $70fd6868680e912c$var$mn) return t;
    if (1 === t.filters.length) return $70fd6868680e912c$var$Kr(t.filters[0]);
    // Compute DNF for each of the subfilters first
    const e = t.filters.map((t)=>$70fd6868680e912c$var$Kr(t));
    let n = $70fd6868680e912c$var$gn.create(e, t.op);
    return n = $70fd6868680e912c$var$jr(n), $70fd6868680e912c$var$Ur(n) ? n : ($70fd6868680e912c$var$F(n instanceof $70fd6868680e912c$var$gn), $70fd6868680e912c$var$F($70fd6868680e912c$var$yn(n)), $70fd6868680e912c$var$F(n.filters.length > 1), n.filters.reduce((t, e)=>$70fd6868680e912c$var$Gr(t, e)));
}
function $70fd6868680e912c$var$Gr(t, e) {
    let n;
    return $70fd6868680e912c$var$F(t instanceof $70fd6868680e912c$var$mn || t instanceof $70fd6868680e912c$var$gn), $70fd6868680e912c$var$F(e instanceof $70fd6868680e912c$var$mn || e instanceof $70fd6868680e912c$var$gn), // FieldFilter FieldFilter
    n = t instanceof $70fd6868680e912c$var$mn ? e instanceof $70fd6868680e912c$var$mn ? function(t, e) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $70fd6868680e912c$var$gn.create([
            t,
            e
        ], "and" /* CompositeOperator.AND */ );
    }(t, e) : $70fd6868680e912c$var$Qr(t, e) : e instanceof $70fd6868680e912c$var$mn ? $70fd6868680e912c$var$Qr(e, t) : function(t, e) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($70fd6868680e912c$var$F(t.filters.length > 0 && e.filters.length > 0), $70fd6868680e912c$var$yn(t) && $70fd6868680e912c$var$yn(e)) return $70fd6868680e912c$var$vn(t, e.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $70fd6868680e912c$var$pn(t) ? t : e, s = $70fd6868680e912c$var$pn(t) ? e : t, i = n.filters.map((t)=>$70fd6868680e912c$var$Gr(t, s));
        return $70fd6868680e912c$var$gn.create(i, "or" /* CompositeOperator.OR */ );
    }(t, e), $70fd6868680e912c$var$jr(n);
}
function $70fd6868680e912c$var$Qr(t, e) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($70fd6868680e912c$var$yn(e)) // Case 1
    return $70fd6868680e912c$var$vn(e, t.getFilters());
    {
        // Case 2
        const n = e.filters.map((e)=>$70fd6868680e912c$var$Gr(t, e));
        return $70fd6868680e912c$var$gn.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $70fd6868680e912c$var$jr(t) {
    if ($70fd6868680e912c$var$F(t instanceof $70fd6868680e912c$var$mn || t instanceof $70fd6868680e912c$var$gn), t instanceof $70fd6868680e912c$var$mn) return t;
    const e = t.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === e.length) return $70fd6868680e912c$var$jr(e[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($70fd6868680e912c$var$Tn(t)) return t;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = e.map((t)=>$70fd6868680e912c$var$jr(t)), s = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((e)=>{
        e instanceof $70fd6868680e912c$var$mn ? s.push(e) : e instanceof $70fd6868680e912c$var$gn && (e.op === t.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        s.push(...e.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        s.push(e));
    }), 1 === s.length ? s[0] : $70fd6868680e912c$var$gn.create(s, t.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $70fd6868680e912c$var$zr {
    constructor(){
        this.rn = new $70fd6868680e912c$var$Wr;
    }
    addToCollectionParentIndex(t, e) {
        return this.rn.add(e), $70fd6868680e912c$var$Rt.resolve();
    }
    getCollectionParents(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.rn.getEntries(e));
    }
    addFieldIndex(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve();
    }
    deleteFieldIndex(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve();
    }
    getDocumentsMatchingTarget(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve(null);
    }
    getIndexType(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve([]);
    }
    getNextCollectionGroupToUpdate(t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve(null);
    }
    getMinOffset(t, e) {
        return $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$It.min());
    }
    getMinOffsetFromCollectionGroup(t, e) {
        return $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$It.min());
    }
    updateCollectionGroup(t, e, n) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve();
    }
    updateIndexEntries(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $70fd6868680e912c$var$Wr {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(t) {
        const e = t.lastSegment(), n = t.popLast(), s = this.index[e] || new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$ut.comparator), i = !s.has(n);
        return this.index[e] = s.add(n), i;
    }
    has(t) {
        const e = t.lastSegment(), n = t.popLast(), s = this.index[e];
        return s && s.has(n);
    }
    getEntries(t) {
        return (this.index[t] || new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$ut.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Hr = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $70fd6868680e912c$var$Jr {
    constructor(t, e){
        this.user = t, this.databaseId = e, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.on = new $70fd6868680e912c$var$Wr, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.un = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$$n(t), (t, e)=>$70fd6868680e912c$var$On(t, e)), this.uid = t.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(t, e) {
        if (!this.on.has(e)) {
            const n = e.lastSegment(), s = e.popLast();
            t.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.on.add(e);
            });
            const i = {
                collectionId: n,
                parent: $70fd6868680e912c$var$qt(s)
            };
            return $70fd6868680e912c$var$Yr(t).put(i);
        }
        return $70fd6868680e912c$var$Rt.resolve();
    }
    getCollectionParents(t, e) {
        const n = [], s = IDBKeyRange.bound([
            e,
            ""
        ], [
            $70fd6868680e912c$var$st(e),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $70fd6868680e912c$var$Yr(t).j(s).next((t)=>{
            for (const s of t){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (s.collectionId !== e) break;
                n.push($70fd6868680e912c$var$Gt(s.parent));
            }
            return n;
        });
    }
    addFieldIndex(t, e) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $70fd6868680e912c$var$Zr(t), s = function(t) {
            return {
                indexId: t.indexId,
                collectionGroup: t.collectionGroup,
                fields: t.fields.map((t)=>[
                        t.fieldPath.canonicalString(),
                        t.kind
                    ])
            };
        }(e);
        delete s.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(s);
        if (e.indexState) {
            const n = $70fd6868680e912c$var$to(t);
            return i.next((t)=>{
                n.put($70fd6868680e912c$var$Tr(t, this.user, e.indexState.sequenceNumber, e.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(t, e) {
        const n = $70fd6868680e912c$var$Zr(t), s = $70fd6868680e912c$var$to(t), i = $70fd6868680e912c$var$Xr(t);
        return n.delete(e.indexId).next(()=>s.delete(IDBKeyRange.bound([
                e.indexId
            ], [
                e.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                e.indexId
            ], [
                e.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    getDocumentsMatchingTarget(t, e) {
        const n = $70fd6868680e912c$var$Xr(t);
        let s = !0;
        const i = new Map;
        return $70fd6868680e912c$var$Rt.forEach(this.cn(e), (e)=>this.an(t, e).next((t)=>{
                s && (s = !!t), i.set(e, t);
            })).next(()=>{
            if (s) {
                let t = $70fd6868680e912c$var$gs();
                const s = [];
                return $70fd6868680e912c$var$Rt.forEach(i, (i, r)=>{
                    var o;
                    $70fd6868680e912c$var$N("IndexedDbIndexManager", `Using index ${(o = i, `id=${o.indexId}|cg=${o.collectionGroup}|f=${o.fields.map((t)=>`${t.fieldPath}:${t.kind}`).join(",")}`)} to execute ${$70fd6868680e912c$var$$n(e)}`);
                    const u = function(t, e) {
                        const n = $70fd6868680e912c$var$ft(e);
                        if (void 0 === n) return null;
                        for (const e of $70fd6868680e912c$var$Bn(t, n.fieldPath))switch(e.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return e.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    e.value
                                ];
                        }
                        return null;
                    }(r, i), c = function(t, e) {
                        const n = new Map;
                        for (const s of $70fd6868680e912c$var$dt(e))for (const e of $70fd6868680e912c$var$Bn(t, s.fieldPath))switch(e.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(s.fieldPath.canonicalString(), e.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(s.fieldPath.canonicalString(), e.value), Array.from(n.values());
                        }
                        return null;
                    }(r, i), a = function(t, e) {
                        const n = [];
                        let s = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $70fd6868680e912c$var$dt(e)){
                            const e = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$Ln(t, i.fieldPath, t.startAt) : $70fd6868680e912c$var$qn(t, i.fieldPath, t.startAt);
                            n.push(e.value), s && (s = e.inclusive);
                        }
                        return new $70fd6868680e912c$var$hn(n, s);
                    }(r, i), h = function(t, e) {
                        const n = [];
                        let s = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $70fd6868680e912c$var$dt(e)){
                            const e = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$qn(t, i.fieldPath, t.endAt) : $70fd6868680e912c$var$Ln(t, i.fieldPath, t.endAt);
                            n.push(e.value), s && (s = e.inclusive);
                        }
                        return new $70fd6868680e912c$var$hn(n, s);
                    }(r, i), l = this.hn(i, r, a), f = this.hn(i, r, h), d = this.ln(i, r, c), w = this.fn(i.indexId, u, l, a.inclusive, f, h.inclusive, d);
                    return $70fd6868680e912c$var$Rt.forEach(w, (i)=>n.H(i, e.limit).next((e)=>{
                            e.forEach((e)=>{
                                const n = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.documentKey);
                                t.has(n) || (t = t.add(n), s.push(n));
                            });
                        }));
                }).next(()=>s);
            }
            return $70fd6868680e912c$var$Rt.resolve(null);
        });
    }
    cn(t) {
        let e = this.un.get(t);
        if (e) return e;
        if (0 === t.filters.length) e = [
            t
        ];
        else e = $70fd6868680e912c$var$Br($70fd6868680e912c$var$gn.create(t.filters, "and" /* CompositeOperator.AND */ )).map((e)=>$70fd6868680e912c$var$Mn(t.path, t.collectionGroup, t.orderBy, e.getFilters(), t.limit, t.startAt, t.endAt));
        return this.un.set(t, e), e;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ fn(t, e, n, s, i, r, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const u = (null != e ? e.length : 1) * Math.max(n.length, i.length), c = u / (null != e ? e.length : 1), a = [];
        for(let h = 0; h < u; ++h){
            const u = e ? this.dn(e[h / c]) : $70fd6868680e912c$var$Hr, l = this.wn(t, u, n[h % c], s), f = this._n(t, u, i[h % c], r), d = o.map((e)=>this.wn(t, u, e, /* inclusive= */ !0));
            a.push(...this.createRange(l, f, d));
        }
        return a;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ wn(t, e, n, s) {
        const i = new $70fd6868680e912c$var$kr(t, $70fd6868680e912c$export$afc2e57c475b7810.empty(), e, n);
        return s ? i : i.Je();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ _n(t, e, n, s) {
        const i = new $70fd6868680e912c$var$kr(t, $70fd6868680e912c$export$afc2e57c475b7810.empty(), e, n);
        return s ? i.Je() : i;
    }
    an(t, e) {
        const n = new $70fd6868680e912c$var$Or(e), s = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment();
        return this.getFieldIndexes(t, s).next((t)=>{
            // Return the index with the most number of segments.
            let e = null;
            for (const s of t)n.tn(s) && (!e || s.fields.length > e.fields.length) && (e = s);
            return e;
        });
    }
    getIndexType(t, e) {
        let n = 2 /* IndexType.FULL */ ;
        const s = this.cn(e);
        return $70fd6868680e912c$var$Rt.forEach(s, (e)=>this.an(t, e).next((t)=>{
                t ? 0 /* IndexType.NONE */  !== n && t.fields.length < function(t) {
                    let e = new $70fd6868680e912c$var$Ee($70fd6868680e912c$export$b7871852b967eaf1.comparator), n = !1;
                    for (const s of t.filters)for (const t of s.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    t.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === t.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t.op ? n = !0 : e = e.add(t.field));
                    for (const n of t.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (e = e.add(n.field));
                    return e.size + (n ? 1 : 0);
                }(e) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function(t) {
                return null !== t.limit;
            })(e) && s.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ mn(t, e) {
        const n = new $70fd6868680e912c$var$Nr;
        for (const s of $70fd6868680e912c$var$dt(t)){
            const t = e.data.field(s.fieldPath);
            if (null == t) return null;
            const i = n.He(s.kind);
            $70fd6868680e912c$var$br.Ve._e(t, i);
        }
        return n.Qe();
    }
    /** Encodes a single value to the ascending index format. */ dn(t) {
        const e = new $70fd6868680e912c$var$Nr;
        return $70fd6868680e912c$var$br.Ve._e(t, e.He(0 /* IndexKind.ASCENDING */ )), e.Qe();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ gn(t, e) {
        const n = new $70fd6868680e912c$var$Nr;
        return $70fd6868680e912c$var$br.Ve._e($70fd6868680e912c$var$We(this.databaseId, e), n.He(function(t) {
            const e = $70fd6868680e912c$var$dt(t);
            return 0 === e.length ? 0 /* IndexKind.ASCENDING */  : e[e.length - 1].kind;
        }(t))), n.Qe();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ ln(t, e, n) {
        if (null === n) return [];
        let s = [];
        s.push(new $70fd6868680e912c$var$Nr);
        let i = 0;
        for (const r of $70fd6868680e912c$var$dt(t)){
            const t = n[i++];
            for (const n of s)if (this.yn(e, r.fieldPath) && $70fd6868680e912c$var$Je(t)) s = this.pn(s, r, t);
            else {
                const e = n.He(r.kind);
                $70fd6868680e912c$var$br.Ve._e(t, e);
            }
        }
        return this.In(s);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ hn(t, e, n) {
        return this.ln(t, e, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ In(t) {
        const e = [];
        for(let n = 0; n < t.length; ++n)e[n] = t[n].Qe();
        return e;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ pn(t, e, n) {
        const s = [
            ...t
        ], i = [];
        for (const t of n.arrayValue.values || [])for (const n of s){
            const s = new $70fd6868680e912c$var$Nr;
            s.seed(n.Qe()), $70fd6868680e912c$var$br.Ve._e(t, s.He(e.kind)), i.push(s);
        }
        return i;
    }
    yn(t, e) {
        return !!t.filters.find((t)=>t instanceof $70fd6868680e912c$var$mn && t.field.isEqual(e) && ("in" /* Operator.IN */  === t.op || "not-in" /* Operator.NOT_IN */  === t.op));
    }
    getFieldIndexes(t, e) {
        const n = $70fd6868680e912c$var$Zr(t), s = $70fd6868680e912c$var$to(t);
        return (e ? n.j("collectionGroupIndex", IDBKeyRange.bound(e, e)) : n.j()).next((t)=>{
            const e = [];
            return $70fd6868680e912c$var$Rt.forEach(t, (t)=>s.get([
                    t.indexId,
                    this.uid
                ]).next((n)=>{
                    e.push(function(t, e) {
                        const n = e ? new $70fd6868680e912c$var$gt(e.sequenceNumber, new $70fd6868680e912c$var$It($70fd6868680e912c$var$wr(e.readTime), new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$Gt(e.documentKey)), e.largestBatchId)) : $70fd6868680e912c$var$gt.empty(), s = t.fields.map(([t, e])=>new $70fd6868680e912c$var$_t($70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t), e));
                        return new $70fd6868680e912c$var$lt(t.indexId, t.collectionGroup, s, n);
                    }(t, n));
                })).next(()=>e);
        });
    }
    getNextCollectionGroupToUpdate(t) {
        return this.getFieldIndexes(t).next((t)=>0 === t.length ? null : (t.sort((t, e)=>{
                const n = t.indexState.sequenceNumber - e.indexState.sequenceNumber;
                return 0 !== n ? n : $70fd6868680e912c$var$et(t.collectionGroup, e.collectionGroup);
            }), t[0].collectionGroup));
    }
    updateCollectionGroup(t, e, n) {
        const s = $70fd6868680e912c$var$Zr(t), i = $70fd6868680e912c$var$to(t);
        return this.Tn(t).next((t)=>s.j("collectionGroupIndex", IDBKeyRange.bound(e, e)).next((e)=>$70fd6868680e912c$var$Rt.forEach(e, (e)=>i.put($70fd6868680e912c$var$Tr(e.indexId, this.user, t, n)))));
    }
    updateIndexEntries(t, e) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $70fd6868680e912c$var$Rt.forEach(e, (e, s)=>{
            const i = n.get(e.collectionGroup);
            return (i ? $70fd6868680e912c$var$Rt.resolve(i) : this.getFieldIndexes(t, e.collectionGroup)).next((i)=>(n.set(e.collectionGroup, i), $70fd6868680e912c$var$Rt.forEach(i, (n)=>this.En(t, e, n).next((e)=>{
                        const i = this.An(s, n);
                        return e.isEqual(i) ? $70fd6868680e912c$var$Rt.resolve() : this.vn(t, s, n, e, i);
                    }))));
        });
    }
    Rn(t, e, n, s) {
        return $70fd6868680e912c$var$Xr(t).put({
            indexId: s.indexId,
            uid: this.uid,
            arrayValue: s.arrayValue,
            directionalValue: s.directionalValue,
            orderedDocumentKey: this.gn(n, e.key),
            documentKey: e.key.path.toArray()
        });
    }
    Pn(t, e, n, s) {
        return $70fd6868680e912c$var$Xr(t).delete([
            s.indexId,
            this.uid,
            s.arrayValue,
            s.directionalValue,
            this.gn(n, e.key),
            e.key.path.toArray()
        ]);
    }
    En(t, e, n) {
        const s = $70fd6868680e912c$var$Xr(t);
        let i = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Mr);
        return s.X({
            index: "documentKeyIndex",
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                this.gn(n, e)
            ])
        }, (t, s)=>{
            i = i.add(new $70fd6868680e912c$var$kr(n.indexId, e, s.arrayValue, s.directionalValue));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ An(t, e) {
        let n = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Mr);
        const s = this.mn(e, t);
        if (null == s) return n;
        const i = $70fd6868680e912c$var$ft(e);
        if (null != i) {
            const r = t.data.field(i.fieldPath);
            if ($70fd6868680e912c$var$Je(r)) for (const i of r.arrayValue.values || [])n = n.add(new $70fd6868680e912c$var$kr(e.indexId, t.key, this.dn(i), s));
        } else n = n.add(new $70fd6868680e912c$var$kr(e.indexId, t.key, $70fd6868680e912c$var$Hr, s));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ vn(t, e, n, s, i) {
        $70fd6868680e912c$var$N("IndexedDbIndexManager", "Updating index entries for document '%s'", e.key);
        const r = [];
        return function(t, e, n, s, i) {
            const r = t.getIterator(), o = e.getIterator();
            let u = $70fd6868680e912c$var$ve(r), c = $70fd6868680e912c$var$ve(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; u || c;){
                let t = !1, e = !1;
                if (u && c) {
                    const s = n(u, c);
                    s < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    e = !0 : s > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (t = !0);
                } else null != u ? e = !0 : t = !0;
                t ? (s(c), c = $70fd6868680e912c$var$ve(o)) : e ? (i(u), u = $70fd6868680e912c$var$ve(r)) : (u = $70fd6868680e912c$var$ve(r), c = $70fd6868680e912c$var$ve(o));
            }
        }(s, i, $70fd6868680e912c$var$Mr, /* onAdd= */ (s)=>{
            r.push(this.Rn(t, e, n, s));
        }, /* onRemove= */ (s)=>{
            r.push(this.Pn(t, e, n, s));
        }), $70fd6868680e912c$var$Rt.waitFor(r);
    }
    Tn(t) {
        let e = 1;
        return $70fd6868680e912c$var$to(t).X({
            index: "sequenceNumberIndex",
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (t, n, s)=>{
            s.done(), e = n.sequenceNumber + 1;
        }).next(()=>e);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(t, e, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((t, e)=>$70fd6868680e912c$var$Mr(t, e)).filter((t, e, n)=>!e || 0 !== $70fd6868680e912c$var$Mr(t, n[e - 1]));
        const s = [];
        s.push(t);
        for (const i of n){
            const n = $70fd6868680e912c$var$Mr(i, t), r = $70fd6868680e912c$var$Mr(i, e);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            s[0] = t.Je();
            else if (n > 0 && r < 0) // `notInValue` is in the middle of the range
            s.push(i), s.push(i.Je());
            else if (r > 0) break;
        }
        s.push(e);
        const i = [];
        for(let t = 0; t < s.length; t += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.bn(s[t], s[t + 1])) return [];
            const e = [
                s[t].indexId,
                this.uid,
                s[t].arrayValue,
                s[t].directionalValue,
                $70fd6868680e912c$var$Hr,
                []
            ], n = [
                s[t + 1].indexId,
                this.uid,
                s[t + 1].arrayValue,
                s[t + 1].directionalValue,
                $70fd6868680e912c$var$Hr,
                []
            ];
            i.push(IDBKeyRange.bound(e, n));
        }
        return i;
    }
    bn(t, e) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $70fd6868680e912c$var$Mr(t, e) > 0;
    }
    getMinOffsetFromCollectionGroup(t, e) {
        return this.getFieldIndexes(t, e).next($70fd6868680e912c$var$eo);
    }
    getMinOffset(t, e) {
        return $70fd6868680e912c$var$Rt.mapArray(this.cn(e), (e)=>this.an(t, e).next((t)=>t || $70fd6868680e912c$var$O())).next($70fd6868680e912c$var$eo);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $70fd6868680e912c$var$Yr(t) {
    return $70fd6868680e912c$var$_e(t, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $70fd6868680e912c$var$Xr(t) {
    return $70fd6868680e912c$var$_e(t, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $70fd6868680e912c$var$Zr(t) {
    return $70fd6868680e912c$var$_e(t, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $70fd6868680e912c$var$to(t) {
    return $70fd6868680e912c$var$_e(t, "indexState");
}
function $70fd6868680e912c$var$eo(t) {
    $70fd6868680e912c$var$F(0 !== t.length);
    let e = t[0].indexState.offset, n = e.largestBatchId;
    for(let s = 1; s < t.length; s++){
        const i = t[s].indexState.offset;
        $70fd6868680e912c$var$Tt(i, e) < 0 && (e = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $70fd6868680e912c$var$It(e.readTime, e.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$no = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
class $70fd6868680e912c$var$so {
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    t, // The percentage of sequence numbers that we will attempt to collect
    e, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = t, this.percentileToCollect = e, this.maximumSequenceNumbersToCollect = n;
    }
    static withCacheSize(t) {
        return new $70fd6868680e912c$var$so(t, $70fd6868680e912c$var$so.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$so.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $70fd6868680e912c$var$io(t, e, n) {
    const s = t.store("mutations"), i = t.store("documentMutations"), r = [], o = IDBKeyRange.only(n.batchId);
    let u = 0;
    const c = s.X({
        range: o
    }, (t, e, n)=>(u++, n.delete()));
    r.push(c.next(()=>{
        $70fd6868680e912c$var$F(1 === u);
    }));
    const a = [];
    for (const t of n.mutations){
        const s = $70fd6868680e912c$var$zt(e, t.key.path, n.batchId);
        r.push(i.delete(s)), a.push(t.key);
    }
    return $70fd6868680e912c$var$Rt.waitFor(r).next(()=>a);
}
/**
 * Returns an approximate size for the given document.
 */ function $70fd6868680e912c$var$ro(t) {
    if (!t) return 0;
    let e;
    if (t.document) e = t.document;
    else if (t.unknownDocument) e = t.unknownDocument;
    else {
        if (!t.noDocument) throw $70fd6868680e912c$var$O();
        e = t.noDocument;
    }
    return JSON.stringify(e).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $70fd6868680e912c$var$so.DEFAULT_COLLECTION_PERCENTILE = 10, $70fd6868680e912c$var$so.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $70fd6868680e912c$var$so.DEFAULT = new $70fd6868680e912c$var$so(41943040, $70fd6868680e912c$var$so.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$so.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $70fd6868680e912c$var$so.DISABLED = new $70fd6868680e912c$var$so(-1, 0, 0);
class $70fd6868680e912c$var$oo {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ t, e, n, s){
        this.userId = t, this.serializer = e, this.indexManager = n, this.referenceDelegate = s, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Vn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static de(t, e, n, s) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $70fd6868680e912c$var$F("" !== t.uid);
        const i = t.isAuthenticated() ? t.uid : "";
        return new $70fd6868680e912c$var$oo(i, e, n, s);
    }
    checkEmpty(t) {
        let e = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$co(t).X({
            index: "userMutationsIndex",
            range: n
        }, (t, n, s)=>{
            e = !1, s.done();
        }).next(()=>e);
    }
    addMutationBatch(t, e, n, s) {
        const i = $70fd6868680e912c$var$ao(t), r = $70fd6868680e912c$var$co(t);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return r.add({}).next((o)=>{
            $70fd6868680e912c$var$F("number" == typeof o);
            const u = new $70fd6868680e912c$var$Zs(o, e, n, s), c = function(t, e, n) {
                const s = n.baseMutations.map((e)=>$70fd6868680e912c$var$ji(t.fe, e)), i = n.mutations.map((e)=>$70fd6868680e912c$var$ji(t.fe, e));
                return {
                    userId: e,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: s,
                    mutations: i
                };
            }(this.serializer, this.userId, u), a = [];
            let h = new $70fd6868680e912c$var$Ee((t, e)=>$70fd6868680e912c$var$et(t.canonicalString(), e.canonicalString()));
            for (const t of s){
                const e = $70fd6868680e912c$var$zt(this.userId, t.key.path, o);
                h = h.add(t.key.path.popLast()), a.push(r.put(c)), a.push(i.put(e, $70fd6868680e912c$var$Wt));
            }
            return h.forEach((e)=>{
                a.push(this.indexManager.addToCollectionParentIndex(t, e));
            }), t.addOnCommittedListener(()=>{
                this.Vn[o] = u.keys();
            }), $70fd6868680e912c$var$Rt.waitFor(a).next(()=>u);
        });
    }
    lookupMutationBatch(t, e) {
        return $70fd6868680e912c$var$co(t).get(e).next((t)=>t ? ($70fd6868680e912c$var$F(t.userId === this.userId), $70fd6868680e912c$var$_r(this.serializer, t)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Sn(t, e) {
        return this.Vn[e] ? $70fd6868680e912c$var$Rt.resolve(this.Vn[e]) : this.lookupMutationBatch(t, e).next((t)=>{
            if (t) {
                const n = t.keys();
                return this.Vn[e] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(t, e) {
        const n = e + 1, s = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $70fd6868680e912c$var$co(t).X({
            index: "userMutationsIndex",
            range: s
        }, (t, e, s)=>{
            e.userId === this.userId && ($70fd6868680e912c$var$F(e.batchId >= n), i = $70fd6868680e912c$var$_r(this.serializer, e)), s.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(t) {
        const e = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = -1;
        return $70fd6868680e912c$var$co(t).X({
            index: "userMutationsIndex",
            range: e,
            reverse: !0
        }, (t, e, s)=>{
            n = e.batchId, s.done();
        }).next(()=>n);
    }
    getAllMutationBatches(t) {
        const e = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$co(t).j("userMutationsIndex", e).next((t)=>t.map((t)=>$70fd6868680e912c$var$_r(this.serializer, t)));
    }
    getAllMutationBatchesAffectingDocumentKey(t, e) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $70fd6868680e912c$var$jt(this.userId, e.path), s = IDBKeyRange.lowerBound(n), i = [];
        return $70fd6868680e912c$var$ao(t).X({
            range: s
        }, (n, s, r)=>{
            const [o, u, c] = n, a = $70fd6868680e912c$var$Gt(u);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && e.path.isEqual(a)) // Look up the mutation batch in the store.
            return $70fd6868680e912c$var$co(t).get(c).next((t)=>{
                if (!t) throw $70fd6868680e912c$var$O();
                $70fd6868680e912c$var$F(t.userId === this.userId), i.push($70fd6868680e912c$var$_r(this.serializer, t));
            });
            r.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(t, e) {
        let n = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
        const s = [];
        return e.forEach((e)=>{
            const i = $70fd6868680e912c$var$jt(this.userId, e.path), r = IDBKeyRange.lowerBound(i), o = $70fd6868680e912c$var$ao(t).X({
                range: r
            }, (t, s, i)=>{
                const [r, o, u] = t, c = $70fd6868680e912c$var$Gt(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                r === this.userId && e.path.isEqual(c) ? n = n.add(u) : i.done();
            });
            s.push(o);
        }), $70fd6868680e912c$var$Rt.waitFor(s).next(()=>this.Dn(t, n));
    }
    getAllMutationBatchesAffectingQuery(t, e) {
        const n = e.path, s = n.length + 1, i = $70fd6868680e912c$var$jt(this.userId, n), r = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
        return $70fd6868680e912c$var$ao(t).X({
            range: r
        }, (t, e, i)=>{
            const [r, u, c] = t, a = $70fd6868680e912c$var$Gt(u);
            r === this.userId && n.isPrefixOf(a) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            a.length === s && (o = o.add(c)) : i.done();
        }).next(()=>this.Dn(t, o));
    }
    Dn(t, e) {
        const n = [], s = [];
        // TODO(rockwood): Implement this using iterate.
        return e.forEach((e)=>{
            s.push($70fd6868680e912c$var$co(t).get(e).next((t)=>{
                if (null === t) throw $70fd6868680e912c$var$O();
                $70fd6868680e912c$var$F(t.userId === this.userId), n.push($70fd6868680e912c$var$_r(this.serializer, t));
            }));
        }), $70fd6868680e912c$var$Rt.waitFor(s).next(()=>n);
    }
    removeMutationBatch(t, e) {
        return $70fd6868680e912c$var$io(t.ht, this.userId, e).next((n)=>(t.addOnCommittedListener(()=>{
                this.Cn(e.batchId);
            }), $70fd6868680e912c$var$Rt.forEach(n, (e)=>this.referenceDelegate.markPotentiallyOrphaned(t, e))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    Cn(t) {
        delete this.Vn[t];
    }
    performConsistencyCheck(t) {
        return this.checkEmpty(t).next((e)=>{
            if (!e) return $70fd6868680e912c$var$Rt.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound([
                this.userId
            ]);
            const s = [];
            return $70fd6868680e912c$var$ao(t).X({
                range: n
            }, (t, e, n)=>{
                if (t[0] === this.userId) {
                    const e = $70fd6868680e912c$var$Gt(t[1]);
                    s.push(e);
                } else n.done();
            }).next(()=>{
                $70fd6868680e912c$var$F(0 === s.length);
            });
        });
    }
    containsKey(t, e) {
        return $70fd6868680e912c$var$uo(t, this.userId, e);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ xn(t) {
        return $70fd6868680e912c$var$ho(t).get(this.userId).next((t)=>t || {
                userId: this.userId,
                lastAcknowledgedBatchId: -1,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $70fd6868680e912c$var$uo(t, e, n) {
    const s = $70fd6868680e912c$var$jt(e, n.path), i = s[1], r = IDBKeyRange.lowerBound(s);
    let o = !1;
    return $70fd6868680e912c$var$ao(t).X({
        range: r,
        Y: !0
    }, (t, n, s)=>{
        const [r, u, /*batchID*/ c] = t;
        r === e && u === i && (o = !0), s.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $70fd6868680e912c$var$co(t) {
    return $70fd6868680e912c$var$_e(t, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$ao(t) {
    return $70fd6868680e912c$var$_e(t, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$ho(t) {
    return $70fd6868680e912c$var$_e(t, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $70fd6868680e912c$var$lo {
    constructor(t){
        this.Nn = t;
    }
    next() {
        return this.Nn += 2, this.Nn;
    }
    static kn() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $70fd6868680e912c$var$lo(0);
    }
    static Mn() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $70fd6868680e912c$var$lo(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$fo {
    constructor(t, e){
        this.referenceDelegate = t, this.serializer = e;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(t) {
        return this.$n(t).next((e)=>{
            const n = new $70fd6868680e912c$var$lo(e.highestTargetId);
            return e.highestTargetId = n.next(), this.On(t, e).next(()=>e.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(t) {
        return this.$n(t).next((t)=>$70fd6868680e912c$var$rt.fromTimestamp(new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.lastRemoteSnapshotVersion.seconds, t.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(t) {
        return this.$n(t).next((t)=>t.highestListenSequenceNumber);
    }
    setTargetsMetadata(t, e, n) {
        return this.$n(t).next((s)=>(s.highestListenSequenceNumber = e, n && (s.lastRemoteSnapshotVersion = n.toTimestamp()), e > s.highestListenSequenceNumber && (s.highestListenSequenceNumber = e), this.On(t, s)));
    }
    addTargetData(t, e) {
        return this.Fn(t, e).next(()=>this.$n(t).next((n)=>(n.targetCount += 1, this.Bn(e, n), this.On(t, n))));
    }
    updateTargetData(t, e) {
        return this.Fn(t, e);
    }
    removeTargetData(t, e) {
        return this.removeMatchingKeysForTargetId(t, e.targetId).next(()=>$70fd6868680e912c$var$wo(t).delete(e.targetId)).next(()=>this.$n(t)).next((e)=>($70fd6868680e912c$var$F(e.targetCount > 0), e.targetCount -= 1, this.On(t, e)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(t, e, n) {
        let s = 0;
        const i = [];
        return $70fd6868680e912c$var$wo(t).X((r, o)=>{
            const u = $70fd6868680e912c$var$mr(o);
            u.sequenceNumber <= e && null === n.get(u.targetId) && (s++, i.push(this.removeTargetData(t, u)));
        }).next(()=>$70fd6868680e912c$var$Rt.waitFor(i)).next(()=>s);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(t, e) {
        return $70fd6868680e912c$var$wo(t).X((t, n)=>{
            const s = $70fd6868680e912c$var$mr(n);
            e(s);
        });
    }
    $n(t) {
        return $70fd6868680e912c$var$_o(t).get("targetGlobalKey").next((t)=>($70fd6868680e912c$var$F(null !== t), t));
    }
    On(t, e) {
        return $70fd6868680e912c$var$_o(t).put("targetGlobalKey", e);
    }
    Fn(t, e) {
        return $70fd6868680e912c$var$wo(t).put($70fd6868680e912c$var$gr(this.serializer, e));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Bn(t, e) {
        let n = !1;
        return t.targetId > e.highestTargetId && (e.highestTargetId = t.targetId, n = !0), t.sequenceNumber > e.highestListenSequenceNumber && (e.highestListenSequenceNumber = t.sequenceNumber, n = !0), n;
    }
    getTargetCount(t) {
        return this.$n(t).next((t)=>t.targetCount);
    }
    getTargetData(t, e) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $70fd6868680e912c$var$$n(e), s = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $70fd6868680e912c$var$wo(t).X({
            range: s,
            index: "queryTargetsIndex"
        }, (t, n, s)=>{
            const r = $70fd6868680e912c$var$mr(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $70fd6868680e912c$var$On(e, r.target) && (i = r, s.done());
        }).next(()=>i);
    }
    addMatchingKeys(t, e, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const s = [], i = $70fd6868680e912c$var$mo(t);
        return e.forEach((e)=>{
            const r = $70fd6868680e912c$var$qt(e.path);
            s.push(i.put({
                targetId: n,
                path: r
            })), s.push(this.referenceDelegate.addReference(t, n, e));
        }), $70fd6868680e912c$var$Rt.waitFor(s);
    }
    removeMatchingKeys(t, e, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const s = $70fd6868680e912c$var$mo(t);
        return $70fd6868680e912c$var$Rt.forEach(e, (e)=>{
            const i = $70fd6868680e912c$var$qt(e.path);
            return $70fd6868680e912c$var$Rt.waitFor([
                s.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(t, n, e)
            ]);
        });
    }
    removeMatchingKeysForTargetId(t, e) {
        const n = $70fd6868680e912c$var$mo(t), s = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(s);
    }
    getMatchingKeysForTargetId(t, e) {
        const n = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), s = $70fd6868680e912c$var$mo(t);
        let i = $70fd6868680e912c$var$gs();
        return s.X({
            range: n,
            Y: !0
        }, (t, e, n)=>{
            const s = $70fd6868680e912c$var$Gt(t[1]), r = new $70fd6868680e912c$export$afc2e57c475b7810(s);
            i = i.add(r);
        }).next(()=>i);
    }
    containsKey(t, e) {
        const n = $70fd6868680e912c$var$qt(e.path), s = IDBKeyRange.bound([
            n
        ], [
            $70fd6868680e912c$var$st(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $70fd6868680e912c$var$mo(t).X({
            index: "documentTargetsIndex",
            Y: !0,
            range: s
        }, ([t, e], n, s)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== t && (i++, s.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    le(t, e) {
        return $70fd6868680e912c$var$wo(t).get(e).next((t)=>t ? $70fd6868680e912c$var$mr(t) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $70fd6868680e912c$var$wo(t) {
    return $70fd6868680e912c$var$_e(t, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $70fd6868680e912c$var$_o(t) {
    return $70fd6868680e912c$var$_e(t, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $70fd6868680e912c$var$mo(t) {
    return $70fd6868680e912c$var$_e(t, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$go([t, e], [n, s]) {
    const i = $70fd6868680e912c$var$et(t, n);
    return 0 === i ? $70fd6868680e912c$var$et(e, s) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $70fd6868680e912c$var$yo {
    constructor(t){
        this.Ln = t, this.buffer = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$go), this.qn = 0;
    }
    Un() {
        return ++this.qn;
    }
    Kn(t) {
        const e = [
            t,
            this.Un()
        ];
        if (this.buffer.size < this.Ln) this.buffer = this.buffer.add(e);
        else {
            const t = this.buffer.last();
            $70fd6868680e912c$var$go(e, t) < 0 && (this.buffer = this.buffer.delete(t).add(e));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $70fd6868680e912c$var$po {
    constructor(t, e, n){
        this.garbageCollector = t, this.asyncQueue = e, this.localStore = n, this.Gn = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Qn(6e4);
    }
    stop() {
        this.Gn && (this.Gn.cancel(), this.Gn = null);
    }
    get started() {
        return null !== this.Gn;
    }
    Qn(t) {
        $70fd6868680e912c$var$N("LruGarbageCollector", `Garbage collection scheduled in ${t}ms`), this.Gn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , t, async ()=>{
            this.Gn = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (t) {
                $70fd6868680e912c$var$Dt(t) ? $70fd6868680e912c$var$N("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", t) : await $70fd6868680e912c$var$vt(t);
            }
            await this.Qn(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $70fd6868680e912c$var$Io {
    constructor(t, e){
        this.jn = t, this.params = e;
    }
    calculateTargetCount(t, e) {
        return this.jn.zn(t).next((t)=>Math.floor(e / 100 * t));
    }
    nthSequenceNumber(t, e) {
        if (0 === e) return $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$Ot.ct);
        const n = new $70fd6868680e912c$var$yo(e);
        return this.jn.forEachTarget(t, (t)=>n.Kn(t.sequenceNumber)).next(()=>this.jn.Wn(t, (t)=>n.Kn(t))).next(()=>n.maxValue);
    }
    removeTargets(t, e, n) {
        return this.jn.removeTargets(t, e, n);
    }
    removeOrphanedDocuments(t, e) {
        return this.jn.removeOrphanedDocuments(t, e);
    }
    collect(t, e) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$N("LruGarbageCollector", "Garbage collection skipped; disabled"), $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$no)) : this.getCacheSize(t).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$N("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $70fd6868680e912c$var$no) : this.Hn(t, e));
    }
    getCacheSize(t) {
        return this.jn.getCacheSize(t);
    }
    Hn(t, e) {
        let n, s, i, r, o, c, a;
        const h = Date.now();
        return this.calculateTargetCount(t, this.params.percentileToCollect).next((e)=>// Cap at the configured max
            (e > this.params.maximumSequenceNumbersToCollect ? ($70fd6868680e912c$var$N("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${e}`), s = this.params.maximumSequenceNumbersToCollect) : s = e, r = Date.now(), this.nthSequenceNumber(t, s))).next((s)=>(n = s, o = Date.now(), this.removeTargets(t, n, e))).next((e)=>(i = e, c = Date.now(), this.removeOrphanedDocuments(t, n))).next((t)=>{
            if (a = Date.now(), $70fd6868680e912c$var$C() <= (0, $5Z2ef.LogLevel).DEBUG) $70fd6868680e912c$var$N("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${r - h}ms\n\tDetermined least recently used ${s} in ` + (o - r) + "ms\n" + `\tRemoved ${i} targets in ` + (c - o) + "ms\n" + `\tRemoved ${t} documents in ` + (a - c) + "ms\n" + `Total Duration: ${a - h}ms`);
            return $70fd6868680e912c$var$Rt.resolve({
                didRun: !0,
                sequenceNumbersCollected: s,
                targetsRemoved: i,
                documentsRemoved: t
            });
        });
    }
}
function $70fd6868680e912c$var$To(t, e) {
    return new $70fd6868680e912c$var$Io(t, e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $70fd6868680e912c$var$Eo {
    constructor(t, e){
        this.db = t, this.garbageCollector = $70fd6868680e912c$var$To(this, e);
    }
    zn(t) {
        const e = this.Jn(t);
        return this.db.getTargetCache().getTargetCount(t).next((t)=>e.next((e)=>t + e));
    }
    Jn(t) {
        let e = 0;
        return this.Wn(t, (t)=>{
            e++;
        }).next(()=>e);
    }
    forEachTarget(t, e) {
        return this.db.getTargetCache().forEachTarget(t, e);
    }
    Wn(t, e) {
        return this.Yn(t, (t, n)=>e(n));
    }
    addReference(t, e, n) {
        return $70fd6868680e912c$var$Ao(t, n);
    }
    removeReference(t, e, n) {
        return $70fd6868680e912c$var$Ao(t, n);
    }
    removeTargets(t, e, n) {
        return this.db.getTargetCache().removeTargets(t, e, n);
    }
    markPotentiallyOrphaned(t, e) {
        return $70fd6868680e912c$var$Ao(t, e);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Xn(t, e) {
        return function(t, e) {
            let n = !1;
            return $70fd6868680e912c$var$ho(t).Z((s)=>$70fd6868680e912c$var$uo(t, s, e).next((t)=>(t && (n = !0), $70fd6868680e912c$var$Rt.resolve(!t)))).next(()=>n);
        }(t, e);
    }
    removeOrphanedDocuments(t, e) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), s = [];
        let i = 0;
        return this.Yn(t, (r, o)=>{
            if (o <= e) {
                const e = this.Xn(t, r).next((e)=>{
                    if (!e) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(t, r).next(()=>(n.removeEntry(r, $70fd6868680e912c$var$rt.min()), $70fd6868680e912c$var$mo(t).delete([
                            0,
                            $70fd6868680e912c$var$qt(r.path)
                        ])));
                });
                s.push(e);
            }
        }).next(()=>$70fd6868680e912c$var$Rt.waitFor(s)).next(()=>n.apply(t)).next(()=>i);
    }
    removeTarget(t, e) {
        const n = e.withSequenceNumber(t.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(t, n);
    }
    updateLimboDocument(t, e) {
        return $70fd6868680e912c$var$Ao(t, e);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Yn(t, e) {
        const n = $70fd6868680e912c$var$mo(t);
        let s, i = $70fd6868680e912c$var$Ot.ct;
        return n.X({
            index: "documentTargetsIndex"
        }, ([t, n], { path: r, sequenceNumber: o })=>{
            0 === t ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $70fd6868680e912c$var$Ot.ct && e(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$Gt(s)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, s = r) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $70fd6868680e912c$var$Ot.ct;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $70fd6868680e912c$var$Ot.ct && e(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$Gt(s)), i);
        });
    }
    getCacheSize(t) {
        return this.db.getRemoteDocumentCache().getSize(t);
    }
}
function $70fd6868680e912c$var$Ao(t, e) {
    return $70fd6868680e912c$var$mo(t).put(/**
 * @returns A value suitable for writing a sentinel row in the target-document
 * store.
 */ function(t, e) {
        return {
            targetId: 0,
            path: $70fd6868680e912c$var$qt(t.path),
            sequenceNumber: e
        };
    }(e, t.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $70fd6868680e912c$var$vo {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $70fd6868680e912c$var$os((t)=>t.toString(), (t, e)=>t.isEqual(e)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(t) {
        this.assertNotApplied(), this.changes.set(t.key, t);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(t, e) {
        this.assertNotApplied(), this.changes.set(t, $70fd6868680e912c$var$an.newInvalidDocument(t).setReadTime(e));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(t, e) {
        this.assertNotApplied();
        const n = this.changes.get(e);
        return void 0 !== n ? $70fd6868680e912c$var$Rt.resolve(n) : this.getFromCache(t, e);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(t, e) {
        return this.getAllFromCache(t, e);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(t) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(t);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$Ro {
    constructor(t){
        this.serializer = t;
    }
    setIndexManager(t) {
        this.indexManager = t;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(t, e, n) {
        return $70fd6868680e912c$var$So(t).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(t, e, n) {
        return $70fd6868680e912c$var$So(t).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function(t, e) {
            const n = t.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $70fd6868680e912c$var$fr(e),
                /* document id */ n[n.length - 1]
            ];
        }(e, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(t, e) {
        return this.getMetadata(t).next((n)=>(n.byteSize += e, this.Zn(t, n)));
    }
    getEntry(t, e) {
        let n = $70fd6868680e912c$var$an.newInvalidDocument(e);
        return $70fd6868680e912c$var$So(t).X({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($70fd6868680e912c$var$Do(e))
        }, (t, s)=>{
            n = this.ts(e, s);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ es(t, e) {
        let n = {
            size: 0,
            document: $70fd6868680e912c$var$an.newInvalidDocument(e)
        };
        return $70fd6868680e912c$var$So(t).X({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($70fd6868680e912c$var$Do(e))
        }, (t, s)=>{
            n = {
                document: this.ts(e, s),
                size: $70fd6868680e912c$var$ro(s)
            };
        }).next(()=>n);
    }
    getEntries(t, e) {
        let n = $70fd6868680e912c$var$cs();
        return this.ns(t, e, (t, e)=>{
            const s = this.ts(t, e);
            n = n.insert(t, s);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ ss(t, e) {
        let n = $70fd6868680e912c$var$cs(), s = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        return this.ns(t, e, (t, e)=>{
            const i = this.ts(t, e);
            n = n.insert(t, i), s = s.insert(t, $70fd6868680e912c$var$ro(e));
        }).next(()=>({
                documents: n,
                rs: s
            }));
    }
    ns(t, e, n) {
        if (e.isEmpty()) return $70fd6868680e912c$var$Rt.resolve();
        let s = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$xo);
        e.forEach((t)=>s = s.add(t));
        const i = IDBKeyRange.bound($70fd6868680e912c$var$Do(s.first()), $70fd6868680e912c$var$Do(s.last())), r = s.getIterator();
        let o = r.getNext();
        return $70fd6868680e912c$var$So(t).X({
            index: "documentKeyIndex",
            range: i
        }, (t, e, s)=>{
            const i = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments([
                ...e.prefixPath,
                e.collectionGroup,
                e.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $70fd6868680e912c$var$xo(o, i) < 0;)n(o, null), o = r.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, e), o = r.hasNext() ? r.getNext() : null), // Skip to the next key (if there is one).
            o ? s.G($70fd6868680e912c$var$Do(o)) : s.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = r.hasNext() ? r.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(t, e, n, s) {
        const i = e.path, r = [
            i.popLast().toArray(),
            i.lastSegment(),
            $70fd6868680e912c$var$fr(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], o = [
            i.popLast().toArray(),
            i.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $70fd6868680e912c$var$So(t).j(IDBKeyRange.bound(r, o, !0)).next((t)=>{
            let n = $70fd6868680e912c$var$cs();
            for (const i of t){
                const t = this.ts($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                t.isFoundDocument() && ($70fd6868680e912c$var$ns(e, t) || s.has(t.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(t.key, t));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(t, e, n, s) {
        let i = $70fd6868680e912c$var$cs();
        const r = $70fd6868680e912c$var$Co(e, n), o = $70fd6868680e912c$var$Co(e, $70fd6868680e912c$var$It.max());
        return $70fd6868680e912c$var$So(t).X({
            index: "collectionGroupIndex",
            range: IDBKeyRange.bound(r, o, !0)
        }, (t, e, n)=>{
            const r = this.ts($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.prefixPath.concat(e.collectionGroup, e.documentId)), e);
            i = i.insert(r.key, r), i.size === s && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(t) {
        return new $70fd6868680e912c$var$bo(this, !!t && t.trackRemovals);
    }
    getSize(t) {
        return this.getMetadata(t).next((t)=>t.byteSize);
    }
    getMetadata(t) {
        return $70fd6868680e912c$var$Vo(t).get("remoteDocumentGlobalKey").next((t)=>($70fd6868680e912c$var$F(!!t), t));
    }
    Zn(t, e) {
        return $70fd6868680e912c$var$Vo(t).put("remoteDocumentGlobalKey", e);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ ts(t, e) {
        if (e) {
            const t = $70fd6868680e912c$var$hr(this.serializer, e);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(t.isNoDocument() && t.version.isEqual($70fd6868680e912c$var$rt.min()))) return t;
        }
        return $70fd6868680e912c$var$an.newInvalidDocument(t);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $70fd6868680e912c$var$Po(t) {
    return new $70fd6868680e912c$var$Ro(t);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $70fd6868680e912c$var$bo extends $70fd6868680e912c$var$vo {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(t, e){
        super(), this.os = t, this.trackRemovals = e, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.us = new $70fd6868680e912c$var$os((t)=>t.toString(), (t, e)=>t.isEqual(e));
    }
    applyChanges(t) {
        const e = [];
        let n = 0, s = new $70fd6868680e912c$var$Ee((t, e)=>$70fd6868680e912c$var$et(t.canonicalString(), e.canonicalString()));
        return this.changes.forEach((i, r)=>{
            const o = this.us.get(i);
            if (e.push(this.os.removeEntry(t, i, o.readTime)), r.isValidDocument()) {
                const u = $70fd6868680e912c$var$lr(this.os.serializer, r);
                s = s.add(i.path.popLast());
                const c = $70fd6868680e912c$var$ro(u);
                n += c - o.size, e.push(this.os.addEntry(t, i, u));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $70fd6868680e912c$var$lr(this.os.serializer, r.convertToNoDocument($70fd6868680e912c$var$rt.min()));
                e.push(this.os.addEntry(t, i, n));
            }
        }), s.forEach((n)=>{
            e.push(this.os.indexManager.addToCollectionParentIndex(t, n));
        }), e.push(this.os.updateMetadata(t, n)), $70fd6868680e912c$var$Rt.waitFor(e);
    }
    getFromCache(t, e) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.os.es(t, e).next((t)=>(this.us.set(e, {
                size: t.size,
                readTime: t.document.readTime
            }), t.document));
    }
    getAllFromCache(t, e) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.os.ss(t, e).next(({ documents: t, rs: e })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (e.forEach((e, n)=>{
                this.us.set(e, {
                    size: n,
                    readTime: t.get(e).readTime
                });
            }), t));
    }
}
function $70fd6868680e912c$var$Vo(t) {
    return $70fd6868680e912c$var$_e(t, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $70fd6868680e912c$var$So(t) {
    return $70fd6868680e912c$var$_e(t, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $70fd6868680e912c$var$Do(t) {
    const e = t.path.toArray();
    return [
        /* prefix path */ e.slice(0, e.length - 2),
        /* collection id */ e[e.length - 2],
        /* document id */ e[e.length - 1]
    ];
}
function $70fd6868680e912c$var$Co(t, e) {
    const n = e.documentKey.path.toArray();
    return [
        /* collection id */ t,
        $70fd6868680e912c$var$fr(e.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$xo(t, e) {
    const n = t.path.toArray(), s = e.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let t = 0; t < n.length - 2 && t < s.length - 2; ++t)if (i = $70fd6868680e912c$var$et(n[t], s[t]), i) return i;
    return i = $70fd6868680e912c$var$et(n.length, s.length), i || (i = $70fd6868680e912c$var$et(n[n.length - 2], s[s.length - 2]), i || $70fd6868680e912c$var$et(n[n.length - 1], s[s.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $70fd6868680e912c$var$No {
    constructor(t, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ e){
        this.overlayedDocument = t, this.mutatedFields = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $70fd6868680e912c$var$ko {
    constructor(t, e, n, s){
        this.remoteDocumentCache = t, this.mutationQueue = e, this.documentOverlayCache = n, this.indexManager = s;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(t, e) {
        let n = null;
        return this.documentOverlayCache.getOverlay(t, e).next((s)=>(n = s, this.remoteDocumentCache.getEntry(t, e))).next((t)=>(null !== n && $70fd6868680e912c$var$Ks(n.mutation, t, $70fd6868680e912c$var$Re.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), t));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(t, e) {
        return this.remoteDocumentCache.getEntries(t, e).next((e)=>this.getLocalViewOfDocuments(t, e, $70fd6868680e912c$var$gs()).next(()=>e));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(t, e, n = $70fd6868680e912c$var$gs()) {
        const s = $70fd6868680e912c$var$fs();
        return this.populateOverlays(t, s, e).next(()=>this.computeViews(t, e, s, n).next((t)=>{
                let e = $70fd6868680e912c$var$hs();
                return t.forEach((t, n)=>{
                    e = e.insert(t, n.overlayedDocument);
                }), e;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(t, e) {
        const n = $70fd6868680e912c$var$fs();
        return this.populateOverlays(t, n, e).next(()=>this.computeViews(t, e, n, $70fd6868680e912c$var$gs()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(t, e, n) {
        const s = [];
        return n.forEach((t)=>{
            e.has(t) || s.push(t);
        }), this.documentOverlayCache.getOverlays(t, s).next((t)=>{
            t.forEach((t, n)=>{
                e.set(t, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(t, e, n, s) {
        let i = $70fd6868680e912c$var$cs();
        const r = $70fd6868680e912c$var$ws(), o = $70fd6868680e912c$var$ws();
        return e.forEach((t, e)=>{
            const o = n.get(e.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            s.has(e.key) && (void 0 === o || o.mutation instanceof $70fd6868680e912c$var$zs) ? i = i.insert(e.key, e) : void 0 !== o ? (r.set(e.key, o.mutation.getFieldMask()), $70fd6868680e912c$var$Ks(o.mutation, e, o.mutation.getFieldMask(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            r.set(e.key, $70fd6868680e912c$var$Re.empty());
        }), this.recalculateAndSaveOverlays(t, i).next((t)=>(t.forEach((t, e)=>r.set(t, e)), e.forEach((t, e)=>{
                var n;
                return o.set(t, new $70fd6868680e912c$var$No(e, null !== (n = r.get(t)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(t, e) {
        const n = $70fd6868680e912c$var$ws();
        // A reverse lookup map from batch id to the documents within that batch.
        let s = new $70fd6868680e912c$var$pe((t, e)=>t - e), i = $70fd6868680e912c$var$gs();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(t, e).next((t)=>{
            for (const i of t)i.keys().forEach((t)=>{
                const r = e.get(t);
                if (null === r) return;
                let o = n.get(t) || $70fd6868680e912c$var$Re.empty();
                o = i.applyToLocalView(r, o), n.set(t, o);
                const u = (s.get(i.batchId) || $70fd6868680e912c$var$gs()).add(t);
                s = s.insert(i.batchId, u);
            });
        }).next(()=>{
            const r = [], o = s.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const s = o.getNext(), u = s.key, c = s.value, a = $70fd6868680e912c$var$ds();
                c.forEach((t)=>{
                    if (!i.has(t)) {
                        const s = $70fd6868680e912c$var$qs(e.get(t), n.get(t));
                        null !== s && a.set(t, s), i = i.add(t);
                    }
                }), r.push(this.documentOverlayCache.saveOverlays(t, u, a));
            }
            return $70fd6868680e912c$var$Rt.waitFor(r);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(t, e) {
        return this.remoteDocumentCache.getEntries(t, e).next((e)=>this.recalculateAndSaveOverlays(t, e));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     */ getDocumentsMatchingQuery(t, e, n) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function(t) {
            return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
        }(e) ? this.getDocumentsMatchingDocumentQuery(t, e.path) : $70fd6868680e912c$var$Wn(e) ? this.getDocumentsMatchingCollectionGroupQuery(t, e, n) : this.getDocumentsMatchingCollectionQuery(t, e, n);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(t, e, n, s) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(t, e, n, s).next((i)=>{
            const r = s - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(t, e, n.largestBatchId, s - i.size) : $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$fs());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = -1, u = i;
            return r.next((e)=>$70fd6868680e912c$var$Rt.forEach(e, (e, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(e) ? $70fd6868680e912c$var$Rt.resolve() : this.remoteDocumentCache.getEntry(t, e).next((t)=>{
                        u = u.insert(e, t);
                    }))).next(()=>this.populateOverlays(t, e, i)).next(()=>this.computeViews(t, u, e, $70fd6868680e912c$var$gs())).next((t)=>({
                        batchId: o,
                        changes: $70fd6868680e912c$var$ls(t)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(t, e) {
        // Just do a simple document lookup.
        return this.getDocument(t, new $70fd6868680e912c$export$afc2e57c475b7810(e)).next((t)=>{
            let e = $70fd6868680e912c$var$hs();
            return t.isFoundDocument() && (e = e.insert(t.key, t)), e;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(t, e, n) {
        const s = e.collectionGroup;
        let i = $70fd6868680e912c$var$hs();
        return this.indexManager.getCollectionParents(t, s).next((r)=>$70fd6868680e912c$var$Rt.forEach(r, (r)=>{
                const o = function(t, e) {
                    return new $70fd6868680e912c$var$Un(e, /*collectionGroup=*/ null, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
                }(e, r.child(s));
                return this.getDocumentsMatchingCollectionQuery(t, o, n).next((t)=>{
                    t.forEach((t, e)=>{
                        i = i.insert(t, e);
                    });
                });
            }).next(()=>i));
    }
    getDocumentsMatchingCollectionQuery(t, e, n) {
        // Query the remote documents and overlay mutations.
        let s;
        return this.documentOverlayCache.getOverlaysForCollection(t, e.path, n.largestBatchId).next((i)=>(s = i, this.remoteDocumentCache.getDocumentsMatchingQuery(t, e, n, s))).next((t)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            s.forEach((e, n)=>{
                const s = n.getKey();
                null === t.get(s) && (t = t.insert(s, $70fd6868680e912c$var$an.newInvalidDocument(s)));
            });
            // Apply the overlays and match against the query.
            let n = $70fd6868680e912c$var$hs();
            return t.forEach((t, i)=>{
                const r = s.get(t);
                void 0 !== r && $70fd6868680e912c$var$Ks(r.mutation, i, $70fd6868680e912c$var$Re.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $70fd6868680e912c$var$ns(e, i) && (n = n.insert(t, i));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Mo {
    constructor(t){
        this.serializer = t, this.cs = new Map, this.hs = new Map;
    }
    getBundleMetadata(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.cs.get(e));
    }
    saveBundleMetadata(t, e) {
        /** Decodes a BundleMetadata proto into a BundleMetadata object. */ var n;
        return this.cs.set(e.id, {
            id: (n = e).id,
            version: n.version,
            createTime: $70fd6868680e912c$var$Ni(n.createTime)
        }), $70fd6868680e912c$var$Rt.resolve();
    }
    getNamedQuery(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.hs.get(e));
    }
    saveNamedQuery(t, e) {
        return this.hs.set(e.name, function(t) {
            return {
                name: t.name,
                query: $70fd6868680e912c$var$yr(t.bundledQuery),
                readTime: $70fd6868680e912c$var$Ni(t.readTime)
            };
        }(e)), $70fd6868680e912c$var$Rt.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $70fd6868680e912c$var$$o {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator), this.ls = new Map;
    }
    getOverlay(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.overlays.get(e));
    }
    getOverlays(t, e) {
        const n = $70fd6868680e912c$var$fs();
        return $70fd6868680e912c$var$Rt.forEach(e, (e)=>this.getOverlay(t, e).next((t)=>{
                null !== t && n.set(e, t);
            })).next(()=>n);
    }
    saveOverlays(t, e, n) {
        return n.forEach((n, s)=>{
            this.we(t, e, s);
        }), $70fd6868680e912c$var$Rt.resolve();
    }
    removeOverlaysForBatchId(t, e, n) {
        const s = this.ls.get(n);
        return void 0 !== s && (s.forEach((t)=>this.overlays = this.overlays.remove(t)), this.ls.delete(n)), $70fd6868680e912c$var$Rt.resolve();
    }
    getOverlaysForCollection(t, e, n) {
        const s = $70fd6868680e912c$var$fs(), i = e.length + 1, r = new $70fd6868680e912c$export$afc2e57c475b7810(e.child("")), o = this.overlays.getIteratorFrom(r);
        for(; o.hasNext();){
            const t = o.getNext().value, r = t.getKey();
            if (!e.isPrefixOf(r.path)) break;
            // Documents from sub-collections
            r.path.length === i && t.largestBatchId > n && s.set(t.getKey(), t);
        }
        return $70fd6868680e912c$var$Rt.resolve(s);
    }
    getOverlaysForCollectionGroup(t, e, n, s) {
        let i = new $70fd6868680e912c$var$pe((t, e)=>t - e);
        const r = this.overlays.getIterator();
        for(; r.hasNext();){
            const t = r.getNext().value;
            if (t.getKey().getCollectionGroup() === e && t.largestBatchId > n) {
                let e = i.get(t.largestBatchId);
                null === e && (e = $70fd6868680e912c$var$fs(), i = i.insert(t.largestBatchId, e)), e.set(t.getKey(), t);
            }
        }
        const o = $70fd6868680e912c$var$fs(), u = i.getIterator();
        for(; u.hasNext();){
            if (u.getNext().value.forEach((t, e)=>o.set(t, e)), o.size() >= s) break;
        }
        return $70fd6868680e912c$var$Rt.resolve(o);
    }
    we(t, e, n) {
        // Remove the association of the overlay to its batch id.
        const s = this.overlays.get(n.key);
        if (null !== s) {
            const t = this.ls.get(s.largestBatchId).delete(n.key);
            this.ls.set(s.largestBatchId, t);
        }
        this.overlays = this.overlays.insert(n.key, new $70fd6868680e912c$var$ei(e, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.ls.get(e);
        void 0 === i && (i = $70fd6868680e912c$var$gs(), this.ls.set(e, i)), this.ls.set(e, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $70fd6868680e912c$var$Oo {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.fs = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Fo.ds), // A set of outstanding references to a document sorted by target id.
        this.ws = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Fo._s);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.fs.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(t, e) {
        const n = new $70fd6868680e912c$var$Fo(t, e);
        this.fs = this.fs.add(n), this.ws = this.ws.add(n);
    }
    /** Add references to the given document keys for the given ID. */ gs(t, e) {
        t.forEach((t)=>this.addReference(t, e));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(t, e) {
        this.ys(new $70fd6868680e912c$var$Fo(t, e));
    }
    ps(t, e) {
        t.forEach((t)=>this.removeReference(t, e));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ Is(t) {
        const e = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ut([])), n = new $70fd6868680e912c$var$Fo(e, t), s = new $70fd6868680e912c$var$Fo(e, t + 1), i = [];
        return this.ws.forEachInRange([
            n,
            s
        ], (t)=>{
            this.ys(t), i.push(t.key);
        }), i;
    }
    Ts() {
        this.fs.forEach((t)=>this.ys(t));
    }
    ys(t) {
        this.fs = this.fs.delete(t), this.ws = this.ws.delete(t);
    }
    Es(t) {
        const e = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ut([])), n = new $70fd6868680e912c$var$Fo(e, t), s = new $70fd6868680e912c$var$Fo(e, t + 1);
        let i = $70fd6868680e912c$var$gs();
        return this.ws.forEachInRange([
            n,
            s
        ], (t)=>{
            i = i.add(t.key);
        }), i;
    }
    containsKey(t) {
        const e = new $70fd6868680e912c$var$Fo(t, 0), n = this.fs.firstAfterOrEqual(e);
        return null !== n && t.isEqual(n.key);
    }
}
class $70fd6868680e912c$var$Fo {
    constructor(t, e){
        this.key = t, this.As = e;
    }
    /** Compare by key then by ID */ static ds(t, e) {
        return $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, e.key) || $70fd6868680e912c$var$et(t.As, e.As);
    }
    /** Compare by ID then by key */ static _s(t, e) {
        return $70fd6868680e912c$var$et(t.As, e.As) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, e.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Bo {
    constructor(t, e){
        this.indexManager = t, this.referenceDelegate = e, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.vs = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Rs = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Fo.ds);
    }
    checkEmpty(t) {
        return $70fd6868680e912c$var$Rt.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(t, e, n, s) {
        const i = this.vs;
        this.vs++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const r = new $70fd6868680e912c$var$Zs(i, e, n, s);
        this.mutationQueue.push(r);
        // Track references by document key and index collection parents.
        for (const e of s)this.Rs = this.Rs.add(new $70fd6868680e912c$var$Fo(e.key, i)), this.indexManager.addToCollectionParentIndex(t, e.key.path.popLast());
        return $70fd6868680e912c$var$Rt.resolve(r);
    }
    lookupMutationBatch(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.Ps(e));
    }
    getNextMutationBatchAfterBatchId(t, e) {
        const n = e + 1, s = this.bs(n), i = s < 0 ? 0 : s;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $70fd6868680e912c$var$Rt.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $70fd6868680e912c$var$Rt.resolve(0 === this.mutationQueue.length ? -1 : this.vs - 1);
    }
    getAllMutationBatches(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(t, e) {
        const n = new $70fd6868680e912c$var$Fo(e, 0), s = new $70fd6868680e912c$var$Fo(e, Number.POSITIVE_INFINITY), i = [];
        return this.Rs.forEachInRange([
            n,
            s
        ], (t)=>{
            const e = this.Ps(t.As);
            i.push(e);
        }), $70fd6868680e912c$var$Rt.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(t, e) {
        let n = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
        return e.forEach((t)=>{
            const e = new $70fd6868680e912c$var$Fo(t, 0), s = new $70fd6868680e912c$var$Fo(t, Number.POSITIVE_INFINITY);
            this.Rs.forEachInRange([
                e,
                s
            ], (t)=>{
                n = n.add(t.As);
            });
        }), $70fd6868680e912c$var$Rt.resolve(this.Vs(n));
    }
    getAllMutationBatchesAffectingQuery(t, e) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = e.path, s = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const r = new $70fd6868680e912c$var$Fo(new $70fd6868680e912c$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
        return this.Rs.forEachWhile((t)=>{
            const e = t.key.path;
            return !!n.isPrefixOf(e) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (e.length === s && (o = o.add(t.As)), !0);
        }, r), $70fd6868680e912c$var$Rt.resolve(this.Vs(o));
    }
    Vs(t) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const e = [];
        return t.forEach((t)=>{
            const n = this.Ps(t);
            null !== n && e.push(n);
        }), e;
    }
    removeMutationBatch(t, e) {
        $70fd6868680e912c$var$F(0 === this.Ss(e.batchId, "removed")), this.mutationQueue.shift();
        let n = this.Rs;
        return $70fd6868680e912c$var$Rt.forEach(e.mutations, (s)=>{
            const i = new $70fd6868680e912c$var$Fo(s.key, e.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(t, s.key);
        }).next(()=>{
            this.Rs = n;
        });
    }
    Cn(t) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(t, e) {
        const n = new $70fd6868680e912c$var$Fo(e, 0), s = this.Rs.firstAfterOrEqual(n);
        return $70fd6868680e912c$var$Rt.resolve(e.isEqual(s && s.key));
    }
    performConsistencyCheck(t) {
        return this.mutationQueue.length, $70fd6868680e912c$var$Rt.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ Ss(t, e) {
        return this.bs(t);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ bs(t) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return t - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ Ps(t) {
        const e = this.bs(t);
        if (e < 0 || e >= this.mutationQueue.length) return null;
        return this.mutationQueue[e];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$Lo {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(t){
        this.Ds = t, /** Underlying cache of documents and their read times. */ this.docs = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(t) {
        this.indexManager = t;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(t, e) {
        const n = e.key, s = this.docs.get(n), i = s ? s.size : 0, r = this.Ds(e);
        return this.docs = this.docs.insert(n, {
            document: e.mutableCopy(),
            size: r
        }), this.size += r - i, this.indexManager.addToCollectionParentIndex(t, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(t) {
        const e = this.docs.get(t);
        e && (this.docs = this.docs.remove(t), this.size -= e.size);
    }
    getEntry(t, e) {
        const n = this.docs.get(e);
        return $70fd6868680e912c$var$Rt.resolve(n ? n.document.mutableCopy() : $70fd6868680e912c$var$an.newInvalidDocument(e));
    }
    getEntries(t, e) {
        let n = $70fd6868680e912c$var$cs();
        return e.forEach((t)=>{
            const e = this.docs.get(t);
            n = n.insert(t, e ? e.document.mutableCopy() : $70fd6868680e912c$var$an.newInvalidDocument(t));
        }), $70fd6868680e912c$var$Rt.resolve(n);
    }
    getDocumentsMatchingQuery(t, e, n, s) {
        let i = $70fd6868680e912c$var$cs();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const r = e.path, o = new $70fd6868680e912c$export$afc2e57c475b7810(r.child("")), u = this.docs.getIteratorFrom(o);
        for(; u.hasNext();){
            const { key: t, value: { document: o } } = u.getNext();
            if (!r.isPrefixOf(t.path)) break;
            t.path.length > r.length + 1 || $70fd6868680e912c$var$Tt($70fd6868680e912c$var$pt(o), n) <= 0 || (s.has(o.key) || $70fd6868680e912c$var$ns(e, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $70fd6868680e912c$var$Rt.resolve(i);
    }
    getAllFromCollectionGroup(t, e, n, s) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $70fd6868680e912c$var$O();
    }
    Cs(t, e) {
        return $70fd6868680e912c$var$Rt.forEach(this.docs, (t)=>e(t));
    }
    newChangeBuffer(t) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $70fd6868680e912c$var$qo(this);
    }
    getSize(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $70fd6868680e912c$var$qo extends $70fd6868680e912c$var$vo {
    constructor(t){
        super(), this.os = t;
    }
    applyChanges(t) {
        const e = [];
        return this.changes.forEach((n, s)=>{
            s.isValidDocument() ? e.push(this.os.addEntry(t, s)) : this.os.removeEntry(n);
        }), $70fd6868680e912c$var$Rt.waitFor(e);
    }
    getFromCache(t, e) {
        return this.os.getEntry(t, e);
    }
    getAllFromCache(t, e) {
        return this.os.getEntries(t, e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Uo {
    constructor(t){
        this.persistence = t, /**
         * Maps a target to the data about that target
         */ this.xs = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$$n(t), $70fd6868680e912c$var$On), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $70fd6868680e912c$var$rt.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Ns = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.ks = new $70fd6868680e912c$var$Oo, this.targetCount = 0, this.Ms = $70fd6868680e912c$var$lo.kn();
    }
    forEachTarget(t, e) {
        return this.xs.forEach((t, n)=>e(n)), $70fd6868680e912c$var$Rt.resolve();
    }
    getLastRemoteSnapshotVersion(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.Ns);
    }
    allocateTargetId(t) {
        return this.highestTargetId = this.Ms.next(), $70fd6868680e912c$var$Rt.resolve(this.highestTargetId);
    }
    setTargetsMetadata(t, e, n) {
        return n && (this.lastRemoteSnapshotVersion = n), e > this.Ns && (this.Ns = e), $70fd6868680e912c$var$Rt.resolve();
    }
    Fn(t) {
        this.xs.set(t.target, t);
        const e = t.targetId;
        e > this.highestTargetId && (this.Ms = new $70fd6868680e912c$var$lo(e), this.highestTargetId = e), t.sequenceNumber > this.Ns && (this.Ns = t.sequenceNumber);
    }
    addTargetData(t, e) {
        return this.Fn(e), this.targetCount += 1, $70fd6868680e912c$var$Rt.resolve();
    }
    updateTargetData(t, e) {
        return this.Fn(e), $70fd6868680e912c$var$Rt.resolve();
    }
    removeTargetData(t, e) {
        return this.xs.delete(e.target), this.ks.Is(e.targetId), this.targetCount -= 1, $70fd6868680e912c$var$Rt.resolve();
    }
    removeTargets(t, e, n) {
        let s = 0;
        const i = [];
        return this.xs.forEach((r, o)=>{
            o.sequenceNumber <= e && null === n.get(o.targetId) && (this.xs.delete(r), i.push(this.removeMatchingKeysForTargetId(t, o.targetId)), s++);
        }), $70fd6868680e912c$var$Rt.waitFor(i).next(()=>s);
    }
    getTargetCount(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.targetCount);
    }
    getTargetData(t, e) {
        const n = this.xs.get(e) || null;
        return $70fd6868680e912c$var$Rt.resolve(n);
    }
    addMatchingKeys(t, e, n) {
        return this.ks.gs(e, n), $70fd6868680e912c$var$Rt.resolve();
    }
    removeMatchingKeys(t, e, n) {
        this.ks.ps(e, n);
        const s = this.persistence.referenceDelegate, i = [];
        return s && e.forEach((e)=>{
            i.push(s.markPotentiallyOrphaned(t, e));
        }), $70fd6868680e912c$var$Rt.waitFor(i);
    }
    removeMatchingKeysForTargetId(t, e) {
        return this.ks.Is(e), $70fd6868680e912c$var$Rt.resolve();
    }
    getMatchingKeysForTargetId(t, e) {
        const n = this.ks.Es(e);
        return $70fd6868680e912c$var$Rt.resolve(n);
    }
    containsKey(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.ks.containsKey(e));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $70fd6868680e912c$var$Ko {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(t, e){
        this.$s = {}, this.overlays = {}, this.Os = new $70fd6868680e912c$var$Ot(0), this.Fs = !1, this.Fs = !0, this.referenceDelegate = t(this), this.Bs = new $70fd6868680e912c$var$Uo(this);
        this.indexManager = new $70fd6868680e912c$var$zr, this.remoteDocumentCache = function(t) {
            return new $70fd6868680e912c$var$Lo(t);
        }((t)=>this.referenceDelegate.Ls(t)), this.serializer = new $70fd6868680e912c$var$ar(e), this.qs = new $70fd6868680e912c$var$Mo(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.Fs = !1, Promise.resolve();
    }
    get started() {
        return this.Fs;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(t) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(t) {
        let e = this.overlays[t.toKey()];
        return e || (e = new $70fd6868680e912c$var$$o, this.overlays[t.toKey()] = e), e;
    }
    getMutationQueue(t, e) {
        let n = this.$s[t.toKey()];
        return n || (n = new $70fd6868680e912c$var$Bo(e, this.referenceDelegate), this.$s[t.toKey()] = n), n;
    }
    getTargetCache() {
        return this.Bs;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.qs;
    }
    runTransaction(t, e, n) {
        $70fd6868680e912c$var$N("MemoryPersistence", "Starting transaction:", t);
        const s = new $70fd6868680e912c$var$Go(this.Os.next());
        return this.referenceDelegate.Us(), n(s).next((t)=>this.referenceDelegate.Ks(s).next(()=>t)).toPromise().then((t)=>(s.raiseOnCommittedEvent(), t));
    }
    Gs(t, e) {
        return $70fd6868680e912c$var$Rt.or(Object.values(this.$s).map((n)=>()=>n.containsKey(t, e)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $70fd6868680e912c$var$Go extends $70fd6868680e912c$var$At {
    constructor(t){
        super(), this.currentSequenceNumber = t;
    }
}
class $70fd6868680e912c$var$Qo {
    constructor(t){
        this.persistence = t, /** Tracks all documents that are active in Query views. */ this.Qs = new $70fd6868680e912c$var$Oo, /** The list of documents that are potentially GCed after each transaction. */ this.js = null;
    }
    static zs(t) {
        return new $70fd6868680e912c$var$Qo(t);
    }
    get Ws() {
        if (this.js) return this.js;
        throw $70fd6868680e912c$var$O();
    }
    addReference(t, e, n) {
        return this.Qs.addReference(n, e), this.Ws.delete(n.toString()), $70fd6868680e912c$var$Rt.resolve();
    }
    removeReference(t, e, n) {
        return this.Qs.removeReference(n, e), this.Ws.add(n.toString()), $70fd6868680e912c$var$Rt.resolve();
    }
    markPotentiallyOrphaned(t, e) {
        return this.Ws.add(e.toString()), $70fd6868680e912c$var$Rt.resolve();
    }
    removeTarget(t, e) {
        this.Qs.Is(e.targetId).forEach((t)=>this.Ws.add(t.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(t, e.targetId).next((t)=>{
            t.forEach((t)=>this.Ws.add(t.toString()));
        }).next(()=>n.removeTargetData(t, e));
    }
    Us() {
        this.js = new Set;
    }
    Ks(t) {
        // Remove newly orphaned documents.
        const e = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $70fd6868680e912c$var$Rt.forEach(this.Ws, (n)=>{
            const s = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(n);
            return this.Hs(t, s).next((t)=>{
                t || e.removeEntry(s, $70fd6868680e912c$var$rt.min());
            });
        }).next(()=>(this.js = null, e.apply(t)));
    }
    updateLimboDocument(t, e) {
        return this.Hs(t, e).next((t)=>{
            t ? this.Ws.delete(e.toString()) : this.Ws.add(e.toString());
        });
    }
    Ls(t) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    Hs(t, e) {
        return $70fd6868680e912c$var$Rt.or([
            ()=>$70fd6868680e912c$var$Rt.resolve(this.Qs.containsKey(e)),
            ()=>this.persistence.getTargetCache().containsKey(t, e),
            ()=>this.persistence.Gs(t, e)
        ]);
    }
}
class $70fd6868680e912c$var$jo {
    constructor(t, e){
        this.persistence = t, this.Js = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$qt(t.path), (t, e)=>t.isEqual(e)), this.garbageCollector = $70fd6868680e912c$var$To(this, e);
    }
    static zs(t, e) {
        return new $70fd6868680e912c$var$jo(t, e);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Us() {}
    Ks(t) {
        return $70fd6868680e912c$var$Rt.resolve();
    }
    forEachTarget(t, e) {
        return this.persistence.getTargetCache().forEachTarget(t, e);
    }
    zn(t) {
        const e = this.Jn(t);
        return this.persistence.getTargetCache().getTargetCount(t).next((t)=>e.next((e)=>t + e));
    }
    Jn(t) {
        let e = 0;
        return this.Wn(t, (t)=>{
            e++;
        }).next(()=>e);
    }
    Wn(t, e) {
        return $70fd6868680e912c$var$Rt.forEach(this.Js, (n, s)=>this.Xn(t, n, s).next((t)=>t ? $70fd6868680e912c$var$Rt.resolve() : e(s)));
    }
    removeTargets(t, e, n) {
        return this.persistence.getTargetCache().removeTargets(t, e, n);
    }
    removeOrphanedDocuments(t, e) {
        let n = 0;
        const s = this.persistence.getRemoteDocumentCache(), i = s.newChangeBuffer();
        return s.Cs(t, (s)=>this.Xn(t, s, e).next((t)=>{
                t || (n++, i.removeEntry(s, $70fd6868680e912c$var$rt.min()));
            })).next(()=>i.apply(t)).next(()=>n);
    }
    markPotentiallyOrphaned(t, e) {
        return this.Js.set(e, t.currentSequenceNumber), $70fd6868680e912c$var$Rt.resolve();
    }
    removeTarget(t, e) {
        const n = e.withSequenceNumber(t.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(t, n);
    }
    addReference(t, e, n) {
        return this.Js.set(n, t.currentSequenceNumber), $70fd6868680e912c$var$Rt.resolve();
    }
    removeReference(t, e, n) {
        return this.Js.set(n, t.currentSequenceNumber), $70fd6868680e912c$var$Rt.resolve();
    }
    updateLimboDocument(t, e) {
        return this.Js.set(e, t.currentSequenceNumber), $70fd6868680e912c$var$Rt.resolve();
    }
    Ls(t) {
        let e = t.key.toString().length;
        return t.isFoundDocument() && (e += $70fd6868680e912c$var$ze(t.data.value)), e;
    }
    Xn(t, e, n) {
        return $70fd6868680e912c$var$Rt.or([
            ()=>this.persistence.Gs(t, e),
            ()=>this.persistence.getTargetCache().containsKey(t, e),
            ()=>{
                const t = this.Js.get(e);
                return $70fd6868680e912c$var$Rt.resolve(void 0 !== t && t > n);
            }
        ]);
    }
    getCacheSize(t) {
        return this.persistence.getRemoteDocumentCache().getSize(t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $70fd6868680e912c$var$zo {
    constructor(t){
        this.serializer = t;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ O(t, e, n, s) {
        const i = new $70fd6868680e912c$var$Pt("createOrUpgrade", e);
        n < 1 && s >= 1 && (function(t) {
            t.createObjectStore("owner");
        }(t), function(t) {
            t.createObjectStore("mutationQueues", {
                keyPath: "userId"
            });
            t.createObjectStore("mutations", {
                keyPath: "batchId",
                autoIncrement: !0
            }).createIndex("userMutationsIndex", $70fd6868680e912c$var$Qt, {
                unique: !0
            }), t.createObjectStore("documentMutations");
        }(t), $70fd6868680e912c$var$Wo(t), function(t) {
            t.createObjectStore("remoteDocuments");
        }(t));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let r = $70fd6868680e912c$var$Rt.resolve();
        return n < 3 && s >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function(t) {
            t.deleteObjectStore("targetDocuments"), t.deleteObjectStore("targets"), t.deleteObjectStore("targetGlobal");
        }(t), $70fd6868680e912c$var$Wo(t)), r = r.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function(t) {
                const e = t.store("targetGlobal"), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $70fd6868680e912c$var$rt.min().toTimestamp(),
                    targetCount: 0
                };
                return e.put("targetGlobalKey", n);
            })(i))), n < 4 && s >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (r = r.next(()=>(function(t, e) {
                return e.store("mutations").j().next((n)=>{
                    t.deleteObjectStore("mutations");
                    t.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", $70fd6868680e912c$var$Qt, {
                        unique: !0
                    });
                    const s = e.store("mutations"), i = n.map((t)=>s.put(t));
                    return $70fd6868680e912c$var$Rt.waitFor(i);
                });
            })(t, i))), r = r.next(()=>{
            !function(t) {
                t.createObjectStore("clientMetadata", {
                    keyPath: "clientId"
                });
            }(t);
        })), n < 5 && s >= 5 && (r = r.next(()=>this.Ys(i))), n < 6 && s >= 6 && (r = r.next(()=>((function(t) {
                t.createObjectStore("remoteDocumentGlobal");
            })(t), this.Xs(i)))), n < 7 && s >= 7 && (r = r.next(()=>this.Zs(i))), n < 8 && s >= 8 && (r = r.next(()=>this.ti(t, i))), n < 9 && s >= 9 && (r = r.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function(t) {
                t.objectStoreNames.contains("remoteDocumentChanges") && t.deleteObjectStore("remoteDocumentChanges");
            }(t);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && s >= 10 && (r = r.next(()=>this.ei(i))), n < 11 && s >= 11 && (r = r.next(()=>{
            !function(t) {
                t.createObjectStore("bundles", {
                    keyPath: "bundleId"
                });
            }(t), function(t) {
                t.createObjectStore("namedQueries", {
                    keyPath: "name"
                });
            }(t);
        })), n < 12 && s >= 12 && (r = r.next(()=>{
            !function(t) {
                const e = t.createObjectStore("documentOverlays", {
                    keyPath: $70fd6868680e912c$var$oe
                });
                e.createIndex("collectionPathOverlayIndex", $70fd6868680e912c$var$ue, {
                    unique: !1
                }), e.createIndex("collectionGroupOverlayIndex", $70fd6868680e912c$var$ce, {
                    unique: !1
                });
            }(t);
        })), n < 13 && s >= 13 && (r = r.next(()=>(function(t) {
                const e = t.createObjectStore("remoteDocumentsV14", {
                    keyPath: $70fd6868680e912c$var$Ht
                });
                e.createIndex("documentKeyIndex", $70fd6868680e912c$var$Jt), e.createIndex("collectionGroupIndex", $70fd6868680e912c$var$Yt);
            })(t)).next(()=>this.ni(t, i)).next(()=>t.deleteObjectStore("remoteDocuments"))), n < 14 && s >= 14 && (r = r.next(()=>this.si(t, i))), n < 15 && s >= 15 && (r = r.next(()=>(function(t) {
                t.createObjectStore("indexConfiguration", {
                    keyPath: "indexId",
                    autoIncrement: !0
                }).createIndex("collectionGroupIndex", "collectionGroup", {
                    unique: !1
                });
                t.createObjectStore("indexState", {
                    keyPath: $70fd6868680e912c$var$ne
                }).createIndex("sequenceNumberIndex", $70fd6868680e912c$var$se, {
                    unique: !1
                });
                t.createObjectStore("indexEntries", {
                    keyPath: $70fd6868680e912c$var$ie
                }).createIndex("documentKeyIndex", $70fd6868680e912c$var$re, {
                    unique: !1
                });
            })(t))), r;
    }
    Xs(t) {
        let e = 0;
        return t.store("remoteDocuments").X((t, n)=>{
            e += $70fd6868680e912c$var$ro(n);
        }).next(()=>{
            const n = {
                byteSize: e
            };
            return t.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
        });
    }
    Ys(t) {
        const e = t.store("mutationQueues"), n = t.store("mutations");
        return e.j().next((e)=>$70fd6868680e912c$var$Rt.forEach(e, (e)=>{
                const s = IDBKeyRange.bound([
                    e.userId,
                    -1
                ], [
                    e.userId,
                    e.lastAcknowledgedBatchId
                ]);
                return n.j("userMutationsIndex", s).next((n)=>$70fd6868680e912c$var$Rt.forEach(n, (n)=>{
                        $70fd6868680e912c$var$F(n.userId === e.userId);
                        const s = $70fd6868680e912c$var$_r(this.serializer, n);
                        return $70fd6868680e912c$var$io(t, e.userId, s).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ Zs(t) {
        const e = t.store("targetDocuments"), n = t.store("remoteDocuments");
        return t.store("targetGlobal").get("targetGlobalKey").next((t)=>{
            const s = [];
            return n.X((n, i)=>{
                const r = new $70fd6868680e912c$var$ut(n), o = function(t) {
                    return [
                        0,
                        $70fd6868680e912c$var$qt(t)
                    ];
                }(r);
                s.push(e.get(o).next((n)=>n ? $70fd6868680e912c$var$Rt.resolve() : ((n)=>e.put({
                            targetId: 0,
                            path: $70fd6868680e912c$var$qt(n),
                            sequenceNumber: t.highestListenSequenceNumber
                        }))(r)));
            }).next(()=>$70fd6868680e912c$var$Rt.waitFor(s));
        });
    }
    ti(t, e) {
        // Create the index.
        t.createObjectStore("collectionParents", {
            keyPath: $70fd6868680e912c$var$ee
        });
        const n = e.store("collectionParents"), s = new $70fd6868680e912c$var$Wr, i = (t)=>{
            if (s.add(t)) {
                const e = t.lastSegment(), s = t.popLast();
                return n.put({
                    collectionId: e,
                    parent: $70fd6868680e912c$var$qt(s)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return e.store("remoteDocuments").X({
            Y: !0
        }, (t, e)=>{
            const n = new $70fd6868680e912c$var$ut(t);
            return i(n.popLast());
        }).next(()=>e.store("documentMutations").X({
                Y: !0
            }, ([t, e, n], s)=>{
                const r = $70fd6868680e912c$var$Gt(e);
                return i(r.popLast());
            }));
    }
    ei(t) {
        const e = t.store("targets");
        return e.X((t, n)=>{
            const s = $70fd6868680e912c$var$mr(n), i = $70fd6868680e912c$var$gr(this.serializer, s);
            return e.put(i);
        });
    }
    ni(t, e) {
        const n = e.store("remoteDocuments"), s = [];
        return n.X((t, n)=>{
            const i = e.store("remoteDocumentsV14"), r = (o = n, o.document ? new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.fromString(o.document.name).popFirst(5)) : o.noDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(o.noDocument.path) : o.unknownDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(o.unknownDocument.path) : $70fd6868680e912c$var$O()).path.toArray();
            var o;
            /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const u = {
                prefixPath: r.slice(0, r.length - 2),
                collectionGroup: r[r.length - 2],
                documentId: r[r.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            s.push(i.put(u));
        }).next(()=>$70fd6868680e912c$var$Rt.waitFor(s));
    }
    si(t, e) {
        const n = e.store("mutations"), s = $70fd6868680e912c$var$Po(this.serializer), i = new $70fd6868680e912c$var$Ko($70fd6868680e912c$var$Qo.zs, this.serializer.fe);
        return n.j().next((t)=>{
            const n = new Map;
            return t.forEach((t)=>{
                var e;
                let s = null !== (e = n.get(t.userId)) && void 0 !== e ? e : $70fd6868680e912c$var$gs();
                $70fd6868680e912c$var$_r(this.serializer, t).keys().forEach((t)=>s = s.add(t)), n.set(t.userId, s);
            }), $70fd6868680e912c$var$Rt.forEach(n, (t, n)=>{
                const r = new $70fd6868680e912c$var$V(n), o = $70fd6868680e912c$var$Rr.de(this.serializer, r), u = i.getIndexManager(r), c = $70fd6868680e912c$var$oo.de(r, this.serializer, u, i.referenceDelegate);
                return new $70fd6868680e912c$var$ko(s, c, o, u).recalculateAndSaveOverlaysForDocumentKeys(new $70fd6868680e912c$var$we(e, $70fd6868680e912c$var$Ot.ct), t).next();
            });
        });
    }
}
function $70fd6868680e912c$var$Wo(t) {
    t.createObjectStore("targetDocuments", {
        keyPath: $70fd6868680e912c$var$Zt
    }).createIndex("documentTargetsIndex", $70fd6868680e912c$var$te, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    t.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", $70fd6868680e912c$var$Xt, {
        unique: !0
    }), t.createObjectStore("targetGlobal");
}
const $70fd6868680e912c$var$Ho = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $70fd6868680e912c$var$Jo {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ t, e, n, s, i, r, o, u, c, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ a, h = 15){
        if (this.allowTabSynchronization = t, this.persistenceKey = e, this.clientId = n, this.ii = i, this.window = r, this.document = o, this.ri = c, this.oi = a, this.ui = h, this.Os = null, this.Fs = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.ci = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.ai = null, /** The client metadata refresh task. */ this.hi = null, /** The last time we garbage collected the client metadata object store. */ this.li = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.fi = (t)=>Promise.resolve(), !$70fd6868680e912c$var$Jo.D()) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $70fd6868680e912c$var$Eo(this, s), this.di = e + "main", this.serializer = new $70fd6868680e912c$var$ar(u), this.wi = new $70fd6868680e912c$var$bt(this.di, this.ui, new $70fd6868680e912c$var$zo(this.serializer)), this.Bs = new $70fd6868680e912c$var$fo(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $70fd6868680e912c$var$Po(this.serializer), this.qs = new $70fd6868680e912c$var$Er, this.window && this.window.localStorage ? this._i = this.window.localStorage : (this._i = null, !1 === a && $70fd6868680e912c$var$k("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.mi().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, $70fd6868680e912c$var$Ho);
            return this.gi(), this.yi(), this.pi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (t)=>this.Bs.getHighestSequenceNumber(t));
        }).then((t)=>{
            this.Os = new $70fd6868680e912c$var$Ot(t, this.ri);
        }).then(()=>{
            this.Fs = !0;
        }).catch((t)=>(this.wi && this.wi.close(), Promise.reject(t)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ii(t) {
        return this.fi = async (e)=>{
            if (this.started) return t(e);
        }, t(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(t) {
        this.wi.B(async (e)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === e.newVersion && await t();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(t) {
        this.networkEnabled !== t && (this.networkEnabled = t, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.ii.enqueueAndForget(async ()=>{
            this.started && await this.mi();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ mi() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (t)=>$70fd6868680e912c$var$Xo(t).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.Ti(t).next((t)=>{
                    t || (this.isPrimary = !1, this.ii.enqueueRetryable(()=>this.fi(!1)));
                });
            }).next(()=>this.Ei(t)).next((e)=>this.isPrimary && !e ? this.Ai(t).next(()=>!1) : !!e && this.vi(t).next(()=>!0))).catch((t)=>{
            if ($70fd6868680e912c$var$Dt(t)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $70fd6868680e912c$var$N("IndexedDbPersistence", "Failed to extend owner lease: ", t), this.isPrimary;
            if (!this.allowTabSynchronization) throw t;
            return $70fd6868680e912c$var$N("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", t), /* isPrimary= */ !1;
        }).then((t)=>{
            this.isPrimary !== t && this.ii.enqueueRetryable(()=>this.fi(t)), this.isPrimary = t;
        });
    }
    Ti(t) {
        return $70fd6868680e912c$var$Yo(t).get("owner").next((t)=>$70fd6868680e912c$var$Rt.resolve(this.Ri(t)));
    }
    Pi(t) {
        return $70fd6868680e912c$var$Xo(t).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async bi() {
        if (this.isPrimary && !this.Vi(this.li, 18e5)) {
            this.li = Date.now();
            const t = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (t)=>{
                const e = $70fd6868680e912c$var$_e(t, "clientMetadata");
                return e.j().next((t)=>{
                    const n = this.Si(t, 18e5), s = t.filter((t)=>-1 === n.indexOf(t));
                    // Delete metadata for clients that are no longer considered active.
                    return $70fd6868680e912c$var$Rt.forEach(s, (t)=>e.delete(t.clientId)).next(()=>s);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this._i) for (const e of t)this._i.removeItem(this.Di(e.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ pi() {
        this.hi = this.ii.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.mi().then(()=>this.bi()).then(()=>this.pi()));
    }
    /** Checks whether `client` is the local client. */ Ri(t) {
        return !!t && t.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Ei(t) {
        if (this.oi) return $70fd6868680e912c$var$Rt.resolve(!0);
        return $70fd6868680e912c$var$Yo(t).get("owner").next((e)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== e && this.Vi(e.leaseTimestampMs, 5e3) && !this.Ci(e.ownerId)) {
                if (this.Ri(e) && this.networkEnabled) return !0;
                if (!this.Ri(e)) {
                    if (!e.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, $70fd6868680e912c$var$Ho);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $70fd6868680e912c$var$Xo(t).j().next((t)=>void 0 === this.Si(t, 5e3).find((t)=>{
                    if (this.clientId !== t.clientId) {
                        const e = !this.networkEnabled && t.networkEnabled, n = !this.inForeground && t.inForeground, s = this.networkEnabled === t.networkEnabled;
                        if (e || n && s) return !0;
                    }
                    return !1;
                }));
        }).next((t)=>(this.isPrimary !== t && $70fd6868680e912c$var$N("IndexedDbPersistence", `Client ${t ? "is" : "is not"} eligible for a primary lease.`), t));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.Fs = !1, this.xi(), this.hi && (this.hi.cancel(), this.hi = null), this.Ni(), this.ki(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.wi.runTransaction("shutdown", "readwrite", [
            "owner",
            "clientMetadata"
        ], (t)=>{
            const e = new $70fd6868680e912c$var$we(t, $70fd6868680e912c$var$Ot.ct);
            return this.Ai(e).next(()=>this.Pi(e));
        }), this.wi.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Mi();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ Si(t, e) {
        return t.filter((t)=>this.Vi(t.updateTimeMs, e) && !this.Ci(t.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ $i() {
        return this.runTransaction("getActiveClients", "readonly", (t)=>$70fd6868680e912c$var$Xo(t).j().next((t)=>this.Si(t, 18e5).map((t)=>t.clientId)));
    }
    get started() {
        return this.Fs;
    }
    getMutationQueue(t, e) {
        return $70fd6868680e912c$var$oo.de(t, this.serializer, e, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Bs;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(t) {
        return new $70fd6868680e912c$var$Jr(t, this.serializer.fe.databaseId);
    }
    getDocumentOverlayCache(t) {
        return $70fd6868680e912c$var$Rr.de(this.serializer, t);
    }
    getBundleCache() {
        return this.qs;
    }
    runTransaction(t, e, n) {
        $70fd6868680e912c$var$N("IndexedDbPersistence", "Starting transaction:", t);
        const s = "readonly" === e ? "readonly" : "readwrite", i = 15 === (r = this.ui) ? $70fd6868680e912c$var$de : 14 === r ? $70fd6868680e912c$var$fe : 13 === r ? $70fd6868680e912c$var$le : 12 === r ? $70fd6868680e912c$var$he : 11 === r ? $70fd6868680e912c$var$ae : void $70fd6868680e912c$var$O();
        /** Returns the object stores for the provided schema. */ var r;
        let o;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.wi.runTransaction(t, s, i, (s)=>(o = new $70fd6868680e912c$var$we(s, this.Os ? this.Os.next() : $70fd6868680e912c$var$Ot.ct), "readwrite-primary" === e ? this.Ti(o).next((t)=>!!t || this.Ei(o)).next((e)=>{
                if (!e) throw $70fd6868680e912c$var$k(`Failed to obtain primary lease for action '${t}'.`), this.isPrimary = !1, this.ii.enqueueRetryable(()=>this.fi(!1)), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, $70fd6868680e912c$var$Et);
                return n(o);
            }).next((t)=>this.vi(o).next(()=>t)) : this.Oi(o).next(()=>n(o)))).then((t)=>(o.raiseOnCommittedEvent(), t));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Oi(t) {
        return $70fd6868680e912c$var$Yo(t).get("owner").next((t)=>{
            if (null !== t && this.Vi(t.leaseTimestampMs, 5e3) && !this.Ci(t.ownerId) && !this.Ri(t) && !(this.oi || this.allowTabSynchronization && t.allowTabSynchronization)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, $70fd6868680e912c$var$Ho);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ vi(t) {
        const e = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $70fd6868680e912c$var$Yo(t).put("owner", e);
    }
    static D() {
        return $70fd6868680e912c$var$bt.D();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ Ai(t) {
        const e = $70fd6868680e912c$var$Yo(t);
        return e.get("owner").next((t)=>this.Ri(t) ? ($70fd6868680e912c$var$N("IndexedDbPersistence", "Releasing primary lease."), e.delete("owner")) : $70fd6868680e912c$var$Rt.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ Vi(t, e) {
        const n = Date.now();
        return !(t < n - e) && (!(t > n) || ($70fd6868680e912c$var$k(`Detected an update time that is in the future: ${t} > ${n}`), !1));
    }
    gi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.ai = ()=>{
            this.ii.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.mi()));
        }, this.document.addEventListener("visibilitychange", this.ai), this.inForeground = "visible" === this.document.visibilityState);
    }
    Ni() {
        this.ai && (this.document.removeEventListener("visibilitychange", this.ai), this.ai = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ yi() {
        var t;
        "function" == typeof (null === (t = this.window) || void 0 === t ? void 0 : t.addEventListener) && (this.ci = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.xi();
            const t = /(?:Version|Mobile)\/1[456]/;
            (0, $gMVVg.isSafari)() && (navigator.appVersion.match(t) || navigator.userAgent.match(t)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.ii.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.ii.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.ci));
    }
    ki() {
        this.ci && (this.window.removeEventListener("pagehide", this.ci), this.ci = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ Ci(t) {
        var e;
        try {
            const n = null !== (null === (e = this._i) || void 0 === e ? void 0 : e.getItem(this.Di(t)));
            return $70fd6868680e912c$var$N("IndexedDbPersistence", `Client '${t}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (t) {
            // Gracefully handle if LocalStorage isn't working.
            return $70fd6868680e912c$var$k("IndexedDbPersistence", "Failed to get zombied client id.", t), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ xi() {
        if (this._i) try {
            this._i.setItem(this.Di(this.clientId), String(Date.now()));
        } catch (t) {
            // Gracefully handle if LocalStorage isn't available / working.
            $70fd6868680e912c$var$k("Failed to set zombie client id.", t);
        }
    }
    /** Removes the zombied client entry if it exists. */ Mi() {
        if (this._i) try {
            this._i.removeItem(this.Di(this.clientId));
        } catch (t) {
        // Ignore
        }
    }
    Di(t) {
        return `firestore_zombie_${this.persistenceKey}_${t}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $70fd6868680e912c$var$Yo(t) {
    return $70fd6868680e912c$var$_e(t, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $70fd6868680e912c$var$Xo(t) {
    return $70fd6868680e912c$var$_e(t, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $70fd6868680e912c$var$Zo(t, e) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = t.projectId;
    return t.isDefaultDatabase || (n += "." + t.database), "firestore/" + e + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $70fd6868680e912c$var$tu {
    constructor(t, e, n, s){
        this.targetId = t, this.fromCache = e, this.Fi = n, this.Bi = s;
    }
    static Li(t, e) {
        let n = $70fd6868680e912c$var$gs(), s = $70fd6868680e912c$var$gs();
        for (const t of e.docChanges)switch(t.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(t.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                s = s.add(t.doc.key);
        }
        return new $70fd6868680e912c$var$tu(t, e.fromCache, n, s);
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $70fd6868680e912c$var$eu {
    constructor(){
        this.qi = !1;
    }
    /** Sets the document view to query against. */ initialize(t, e) {
        this.Ui = t, this.indexManager = e, this.qi = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(t, e, n, s) {
        return this.Ki(t, e).next((i)=>i || this.Gi(t, e, s, n)).next((n)=>n || this.Qi(t, e));
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ Ki(t, e) {
        if ($70fd6868680e912c$var$Qn(e)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $70fd6868680e912c$var$Rt.resolve(null);
        let n = $70fd6868680e912c$var$Jn(e);
        return this.indexManager.getIndexType(t, n).next((s)=>0 /* IndexType.NONE */  === s ? null : (null !== e.limit && 1 /* IndexType.PARTIAL */  === s && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (e = $70fd6868680e912c$var$Xn(e, null, "F" /* LimitType.First */ ), n = $70fd6868680e912c$var$Jn(e)), this.indexManager.getDocumentsMatchingTarget(t, n).next((s)=>{
                const i = $70fd6868680e912c$var$gs(...s);
                return this.Ui.getDocuments(t, i).next((s)=>this.indexManager.getMinOffset(t, n).next((n)=>{
                        const r = this.ji(e, s);
                        return this.zi(e, r, i, n.readTime) ? this.Ki(t, $70fd6868680e912c$var$Xn(e, null, "F" /* LimitType.First */ )) : this.Wi(t, r, e, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ Gi(t, e, n, s) {
        return $70fd6868680e912c$var$Qn(e) || s.isEqual($70fd6868680e912c$var$rt.min()) ? this.Qi(t, e) : this.Ui.getDocuments(t, n).next((i)=>{
            const r = this.ji(e, i);
            return this.zi(e, r, n, s) ? this.Qi(t, e) : ($70fd6868680e912c$var$C() <= (0, $5Z2ef.LogLevel).DEBUG && $70fd6868680e912c$var$N("QueryEngine", "Re-using previous result from %s to execute query: %s", s.toString(), $70fd6868680e912c$var$es(e)), this.Wi(t, r, e, $70fd6868680e912c$var$yt(s, -1)));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ ji(t, e) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$is(t));
        return e.forEach((e, s)=>{
            $70fd6868680e912c$var$ns(t, s) && (n = n.add(s));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ zi(t, e, n, s) {
        if (null === t.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== e.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === t.limitType ? e.last() : e.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(s) > 0);
    }
    Qi(t, e) {
        return $70fd6868680e912c$var$C() <= (0, $5Z2ef.LogLevel).DEBUG && $70fd6868680e912c$var$N("QueryEngine", "Using full collection scan to execute query:", $70fd6868680e912c$var$es(e)), this.Ui.getDocumentsMatchingQuery(t, e, $70fd6868680e912c$var$It.min());
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ Wi(t, e, n, s) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Ui.getDocumentsMatchingQuery(t, n, s).next((t)=>// Merge with existing results
            (e.forEach((e)=>{
                t = t.insert(e.key, e);
            }), t));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$nu {
    constructor(/** Manages our in-memory or durable persistence. */ t, e, n, s){
        this.persistence = t, this.Hi = e, this.serializer = s, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.Ji = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Yi = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$$n(t), $70fd6868680e912c$var$On), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Xi = new Map, this.Zi = t.getRemoteDocumentCache(), this.Bs = t.getTargetCache(), this.qs = t.getBundleCache(), this.tr(n);
    }
    tr(t) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(t), this.indexManager = this.persistence.getIndexManager(t), this.mutationQueue = this.persistence.getMutationQueue(t, this.indexManager), this.localDocuments = new $70fd6868680e912c$var$ko(this.Zi, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Zi.setIndexManager(this.indexManager), this.Hi.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(t) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (e)=>t.collect(e, this.Ji));
    }
}
function $70fd6868680e912c$var$su(/** Manages our in-memory or durable persistence. */ t, e, n, s) {
    return new $70fd6868680e912c$var$nu(t, e, n, s);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $70fd6868680e912c$var$iu(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return await n.persistence.runTransaction("Handle user change", "readonly", (t)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let s;
        return n.mutationQueue.getAllMutationBatches(t).next((i)=>(s = i, n.tr(e), n.mutationQueue.getAllMutationBatches(t))).next((e)=>{
            const i = [], r = [];
            // Union the old/new changed keys.
            let o = $70fd6868680e912c$var$gs();
            for (const t of s){
                i.push(t.batchId);
                for (const e of t.mutations)o = o.add(e.key);
            }
            for (const t of e){
                r.push(t.batchId);
                for (const e of t.mutations)o = o.add(e.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(t, o).next((t)=>({
                    er: t,
                    removedBatchIds: i,
                    addedBatchIds: r
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $70fd6868680e912c$var$ru(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (t)=>{
        const s = e.batch.keys(), i = n.Zi.newChangeBuffer({
            trackRemovals: !0
        });
        return (function(t, e, n, s) {
            const i = n.batch, r = i.keys();
            let o = $70fd6868680e912c$var$Rt.resolve();
            return r.forEach((t)=>{
                o = o.next(()=>s.getEntry(e, t)).next((e)=>{
                    const r = n.docVersions.get(t);
                    $70fd6868680e912c$var$F(null !== r), e.version.compareTo(r) < 0 && (i.applyToRemoteDocument(e, n), e.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (e.setReadTime(n.commitVersion), s.addEntry(e)));
                });
            }), o.next(()=>t.mutationQueue.removeMutationBatch(e, i));
        })(n, t, e, i).next(()=>i.apply(t)).next(()=>n.mutationQueue.performConsistencyCheck(t)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(t, s, e.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, function(t) {
                let e = $70fd6868680e912c$var$gs();
                for(let n = 0; n < t.mutationResults.length; ++n)t.mutationResults[n].transformResults.length > 0 && (e = e.add(t.batch.mutations[n].key));
                return e;
            }(e))).next(()=>n.localDocuments.getDocuments(t, s));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $70fd6868680e912c$var$ou(t) {
    const e = $70fd6868680e912c$var$L(t);
    return e.persistence.runTransaction("Get last remote snapshot version", "readonly", (t)=>e.Bs.getLastRemoteSnapshotVersion(t));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $70fd6868680e912c$var$uu(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = e.snapshotVersion;
    let i = n.Ji;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (t)=>{
        const r = n.Zi.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.Ji;
        const o = [];
        e.targetChanges.forEach((r, u)=>{
            const c = i.get(u);
            if (!c) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Bs.removeMatchingKeys(t, r.removedDocuments, u).next(()=>n.Bs.addMatchingKeys(t, r.addedDocuments, u)));
            let a = c.withSequenceNumber(t.currentSequenceNumber);
            null !== e.targetMismatches.get(u) ? a = a.withResumeToken($70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, $70fd6868680e912c$var$rt.min()).withLastLimboFreeSnapshotVersion($70fd6868680e912c$var$rt.min()) : r.resumeToken.approximateByteSize() > 0 && (a = a.withResumeToken(r.resumeToken, s)), i = i.insert(u, a), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function(t, e, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === t.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (e.snapshotVersion.toMicroseconds() - t.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(c, a, r) && o.push(n.Bs.updateTargetData(t, a));
        });
        let u = $70fd6868680e912c$var$cs(), c = $70fd6868680e912c$var$gs();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (e.documentUpdates.forEach((s)=>{
            e.resolvedLimboDocuments.has(s) && o.push(n.persistence.referenceDelegate.updateLimboDocument(t, s));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($70fd6868680e912c$var$cu(t, r, e.documentUpdates).next((t)=>{
            u = t.nr, c = t.sr;
        })), !s.isEqual($70fd6868680e912c$var$rt.min())) {
            const e = n.Bs.getLastRemoteSnapshotVersion(t).next((e)=>n.Bs.setTargetsMetadata(t, t.currentSequenceNumber, s));
            o.push(e);
        }
        return $70fd6868680e912c$var$Rt.waitFor(o).next(()=>r.apply(t)).next(()=>n.localDocuments.getLocalViewOfDocuments(t, u, c)).next(()=>u);
    }).then((t)=>(n.Ji = i, t));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $70fd6868680e912c$var$cu(t, e, n) {
    let s = $70fd6868680e912c$var$gs(), i = $70fd6868680e912c$var$gs();
    return n.forEach((t)=>s = s.add(t)), e.getEntries(t, s).next((t)=>{
        let s = $70fd6868680e912c$var$cs();
        return n.forEach((n, r)=>{
            const o = t.get(n);
            // Check if see if there is a existence state change for this document.
            r.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            r.isNoDocument() && r.version.isEqual($70fd6868680e912c$var$rt.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (e.removeEntry(n, r.readTime), s = s.insert(n, r)) : !o.isValidDocument() || r.version.compareTo(o.version) > 0 || 0 === r.version.compareTo(o.version) && o.hasPendingWrites ? (e.addEntry(r), s = s.insert(n, r)) : $70fd6868680e912c$var$N("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", r.version);
        }), {
            nr: s,
            sr: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $70fd6868680e912c$var$au(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (t)=>(void 0 === e && (e = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(t, e)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $70fd6868680e912c$var$hu(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return n.persistence.runTransaction("Allocate target", "readwrite", (t)=>{
        let s;
        return n.Bs.getTargetData(t, e).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (s = i, $70fd6868680e912c$var$Rt.resolve(s)) : n.Bs.allocateTargetId(t).next((i)=>(s = new $70fd6868680e912c$var$cr(e, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , t.currentSequenceNumber), n.Bs.addTargetData(t, s).next(()=>s))));
    }).then((t)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const s = n.Ji.get(t.targetId);
        return (null === s || t.snapshotVersion.compareTo(s.snapshotVersion) > 0) && (n.Ji = n.Ji.insert(t.targetId, t), n.Yi.set(e, t.targetId)), t;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $70fd6868680e912c$var$lu(t, e, n) {
    const s = $70fd6868680e912c$var$L(t), i = s.Ji.get(e), r = n ? "readwrite" : "readwrite-primary";
    try {
        n || await s.persistence.runTransaction("Release target", r, (t)=>s.persistence.referenceDelegate.removeTarget(t, i));
    } catch (t) {
        if (!$70fd6868680e912c$var$Dt(t)) throw t;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $70fd6868680e912c$var$N("LocalStore", `Failed to update sequence numbers for target ${e}: ${t}`);
    }
    s.Ji = s.Ji.remove(e), s.Yi.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $70fd6868680e912c$var$fu(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    let i = $70fd6868680e912c$var$rt.min(), r = $70fd6868680e912c$var$gs();
    return s.persistence.runTransaction("Execute query", "readonly", (t)=>(function(t, e, n) {
            const s = $70fd6868680e912c$var$L(t), i = s.Yi.get(n);
            return void 0 !== i ? $70fd6868680e912c$var$Rt.resolve(s.Ji.get(i)) : s.Bs.getTargetData(e, n);
        })(s, t, $70fd6868680e912c$var$Jn(e)).next((e)=>{
            if (e) return i = e.lastLimboFreeSnapshotVersion, s.Bs.getMatchingKeysForTargetId(t, e.targetId).next((t)=>{
                r = t;
            });
        }).next(()=>s.Hi.getDocumentsMatchingQuery(t, e, n ? i : $70fd6868680e912c$var$rt.min(), n ? r : $70fd6868680e912c$var$gs())).next((t)=>($70fd6868680e912c$var$_u(s, $70fd6868680e912c$var$ss(e), t), {
                documents: t,
                ir: r
            })));
}
// PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$du(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$L(n.Bs), i = n.Ji.get(e);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (t)=>s.le(t, e).next((t)=>t ? t.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$wu(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = n.Xi.get(e) || $70fd6868680e912c$var$rt.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (t)=>n.Zi.getAllFromCollectionGroup(t, e, $70fd6868680e912c$var$yt(s, -1), /* limit= */ Number.MAX_SAFE_INTEGER)).then((t)=>($70fd6868680e912c$var$_u(n, e, t), t));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$_u(t, e, n) {
    let s = t.Xi.get(e) || $70fd6868680e912c$var$rt.min();
    n.forEach((t, e)=>{
        e.readTime.compareTo(s) > 0 && (s = e.readTime);
    }), t.Xi.set(e, s);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $70fd6868680e912c$var$mu(t, e, n, s) {
    const i = $70fd6868680e912c$var$L(t);
    let r = $70fd6868680e912c$var$gs(), o = $70fd6868680e912c$var$cs();
    for (const t of n){
        const n = e.rr(t.metadata.name);
        t.document && (r = r.add(n));
        const s = e.ur(t);
        s.setReadTime(e.cr(t.metadata.readTime)), o = o.insert(n, s);
    }
    const u = i.Zi.newChangeBuffer({
        trackRemovals: !0
    }), c = await $70fd6868680e912c$var$hu(i, function(t) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $70fd6868680e912c$var$Jn($70fd6868680e912c$var$Gn($70fd6868680e912c$var$ut.fromString(`__bundle__/docs/${t}`)));
    }(s));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (t)=>$70fd6868680e912c$var$cu(t, u, o).next((e)=>(u.apply(t), e)).next((e)=>i.Bs.removeMatchingKeysForTargetId(t, c.targetId).next(()=>i.Bs.addMatchingKeys(t, r, c.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(t, e.nr, e.sr)).next(()=>e.nr)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $70fd6868680e912c$var$gu(t, e, n = $70fd6868680e912c$var$gs()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const s = await $70fd6868680e912c$var$hu(t, $70fd6868680e912c$var$Jn($70fd6868680e912c$var$yr(e.bundledQuery))), i = $70fd6868680e912c$var$L(t);
    return i.persistence.runTransaction("Save named query", "readwrite", (t)=>{
        const r = $70fd6868680e912c$var$Ni(e.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (s.snapshotVersion.compareTo(r) >= 0) return i.qs.saveNamedQuery(t, e);
        // Update existing target data because the query from the bundle is newer.
        const o = s.withResumeToken($70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, r);
        return i.Ji = i.Ji.insert(o.targetId, o), i.Bs.updateTargetData(t, o).next(()=>i.Bs.removeMatchingKeysForTargetId(t, s.targetId)).next(()=>i.Bs.addMatchingKeys(t, n, s.targetId)).next(()=>i.qs.saveNamedQuery(t, e));
    });
}
/** Assembles the key for a client state in WebStorage */ function $70fd6868680e912c$var$yu(t, e) {
    return `firestore_clients_${t}_${e}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $70fd6868680e912c$var$pu(t, e, n) {
    let s = `firestore_mutations_${t}_${n}`;
    return e.isAuthenticated() && (s += `_${e.uid}`), s;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $70fd6868680e912c$var$Iu(t, e) {
    return `firestore_targets_${t}_${e}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$Tu {
    constructor(t, e, n, s){
        this.user = t, this.batchId = e, this.state = n, this.error = s;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ar(t, e, n) {
        const s = JSON.parse(n);
        let i, r = "object" == typeof s && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(s.state) && (void 0 === s.error || "object" == typeof s.error);
        return r && s.error && (r = "string" == typeof s.error.message && "string" == typeof s.error.code, r && (i = new $70fd6868680e912c$export$8fada0bf726bf278(s.error.code, s.error.message))), r ? new $70fd6868680e912c$var$Tu(t, e, s.state, i) : ($70fd6868680e912c$var$k("SharedClientState", `Failed to parse mutation state for ID '${e}': ${n}`), null);
    }
    hr() {
        const t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$Eu {
    constructor(t, e, n){
        this.targetId = t, this.state = e, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ar(t, e) {
        const n = JSON.parse(e);
        let s, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (s = new $70fd6868680e912c$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $70fd6868680e912c$var$Eu(t, n.state, s) : ($70fd6868680e912c$var$k("SharedClientState", `Failed to parse target state for ID '${t}': ${e}`), null);
    }
    hr() {
        const t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $70fd6868680e912c$var$Au {
    constructor(t, e){
        this.clientId = t, this.activeTargetIds = e;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ar(t, e) {
        const n = JSON.parse(e);
        let s = "object" == typeof n && n.activeTargetIds instanceof Array, i = $70fd6868680e912c$var$ps();
        for(let t = 0; s && t < n.activeTargetIds.length; ++t)s = $70fd6868680e912c$var$Lt(n.activeTargetIds[t]), i = i.add(n.activeTargetIds[t]);
        return s ? new $70fd6868680e912c$var$Au(t, i) : ($70fd6868680e912c$var$k("SharedClientState", `Failed to parse client data for instance '${t}': ${e}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $70fd6868680e912c$var$vu {
    constructor(t, e){
        this.clientId = t, this.onlineState = e;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ar(t) {
        const e = JSON.parse(t);
        return "object" == typeof e && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(e.onlineState) && "string" == typeof e.clientId ? new $70fd6868680e912c$var$vu(e.clientId, e.onlineState) : ($70fd6868680e912c$var$k("SharedClientState", `Failed to parse online state: ${t}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $70fd6868680e912c$var$Ru {
    constructor(){
        this.activeTargetIds = $70fd6868680e912c$var$ps();
    }
    lr(t) {
        this.activeTargetIds = this.activeTargetIds.add(t);
    }
    dr(t) {
        this.activeTargetIds = this.activeTargetIds.delete(t);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ hr() {
        const t = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(t);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $70fd6868680e912c$var$Pu {
    constructor(t, e, n, s, i){
        this.window = t, this.ii = e, this.persistenceKey = n, this.wr = s, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this._r = this.mr.bind(this), this.gr = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.yr = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const r = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.pr = $70fd6868680e912c$var$yu(this.persistenceKey, this.wr), this.Ir = /** Assembles the key for the current sequence number. */ function(t) {
            return `firestore_sequence_number_${t}`;
        }(this.persistenceKey), this.gr = this.gr.insert(this.wr, new $70fd6868680e912c$var$Ru), this.Tr = new RegExp(`^firestore_clients_${r}_([^_]*)$`), this.Er = new RegExp(`^firestore_mutations_${r}_(\\d+)(?:_(.*))?$`), this.Ar = new RegExp(`^firestore_targets_${r}_(\\d+)$`), this.vr = /** Assembles the key for the online state of the primary tab. */ function(t) {
            return `firestore_online_state_${t}`;
        }(this.persistenceKey), this.Rr = function(t) {
            return `firestore_bundle_loaded_v2_${t}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this._r);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static D(t) {
        return !(!t || !t.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const t = await this.syncEngine.$i();
        for (const e of t){
            if (e === this.wr) continue;
            const t = this.getItem($70fd6868680e912c$var$yu(this.persistenceKey, e));
            if (t) {
                const n = $70fd6868680e912c$var$Au.ar(e, t);
                n && (this.gr = this.gr.insert(n.clientId, n));
            }
        }
        this.Pr();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const e = this.storage.getItem(this.vr);
        if (e) {
            const t = this.br(e);
            t && this.Vr(t);
        }
        for (const t of this.yr)this.mr(t);
        this.yr = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(t) {
        this.setItem(this.Ir, JSON.stringify(t));
    }
    getAllActiveQueryTargets() {
        return this.Sr(this.gr);
    }
    isActiveQueryTarget(t) {
        let e = !1;
        return this.gr.forEach((n, s)=>{
            s.activeTargetIds.has(t) && (e = !0);
        }), e;
    }
    addPendingMutation(t) {
        this.Dr(t, "pending");
    }
    updateMutationState(t, e, n) {
        this.Dr(t, e, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.Cr(t);
    }
    addLocalQueryTarget(t) {
        let e = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(t)) {
            const n = this.storage.getItem($70fd6868680e912c$var$Iu(this.persistenceKey, t));
            if (n) {
                const s = $70fd6868680e912c$var$Eu.ar(t, n);
                s && (e = s.state);
            }
        }
        return this.Nr.lr(t), this.Pr(), e;
    }
    removeLocalQueryTarget(t) {
        this.Nr.dr(t), this.Pr();
    }
    isLocalQueryTarget(t) {
        return this.Nr.activeTargetIds.has(t);
    }
    clearQueryState(t) {
        this.removeItem($70fd6868680e912c$var$Iu(this.persistenceKey, t));
    }
    updateQueryState(t, e, n) {
        this.kr(t, e, n);
    }
    handleUserChange(t, e, n) {
        e.forEach((t)=>{
            this.Cr(t);
        }), this.currentUser = t, n.forEach((t)=>{
            this.addPendingMutation(t);
        });
    }
    setOnlineState(t) {
        this.Mr(t);
    }
    notifyBundleLoaded(t) {
        this.$r(t);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this._r), this.removeItem(this.pr), this.started = !1);
    }
    getItem(t) {
        const e = this.storage.getItem(t);
        return $70fd6868680e912c$var$N("SharedClientState", "READ", t, e), e;
    }
    setItem(t, e) {
        $70fd6868680e912c$var$N("SharedClientState", "SET", t, e), this.storage.setItem(t, e);
    }
    removeItem(t) {
        $70fd6868680e912c$var$N("SharedClientState", "REMOVE", t), this.storage.removeItem(t);
    }
    mr(t) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const e = t;
        if (e.storageArea === this.storage) {
            if ($70fd6868680e912c$var$N("SharedClientState", "EVENT", e.key, e.newValue), e.key === this.pr) return void $70fd6868680e912c$var$k("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.ii.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== e.key) {
                        if (this.Tr.test(e.key)) {
                            if (null == e.newValue) {
                                const t = this.Or(e.key);
                                return this.Fr(t, null);
                            }
                            {
                                const t = this.Br(e.key, e.newValue);
                                if (t) return this.Fr(t.clientId, t);
                            }
                        } else if (this.Er.test(e.key)) {
                            if (null !== e.newValue) {
                                const t = this.Lr(e.key, e.newValue);
                                if (t) return this.qr(t);
                            }
                        } else if (this.Ar.test(e.key)) {
                            if (null !== e.newValue) {
                                const t = this.Ur(e.key, e.newValue);
                                if (t) return this.Kr(t);
                            }
                        } else if (e.key === this.vr) {
                            if (null !== e.newValue) {
                                const t = this.br(e.newValue);
                                if (t) return this.Vr(t);
                            }
                        } else if (e.key === this.Ir) {
                            const t = function(t) {
                                let e = $70fd6868680e912c$var$Ot.ct;
                                if (null != t) try {
                                    const n = JSON.parse(t);
                                    $70fd6868680e912c$var$F("number" == typeof n), e = n;
                                } catch (t) {
                                    $70fd6868680e912c$var$k("SharedClientState", "Failed to read sequence number from WebStorage", t);
                                }
                                return e;
                            }(e.newValue);
                            t !== $70fd6868680e912c$var$Ot.ct && this.sequenceNumberHandler(t);
                        } else if (e.key === this.Rr) {
                            const t = this.Gr(e.newValue);
                            await Promise.all(t.map((t)=>this.syncEngine.Qr(t)));
                        }
                    }
                } else this.yr.push(e);
            });
        }
    }
    get Nr() {
        return this.gr.get(this.wr);
    }
    Pr() {
        this.setItem(this.pr, this.Nr.hr());
    }
    Dr(t, e, n) {
        const s = new $70fd6868680e912c$var$Tu(this.currentUser, t, e, n), i = $70fd6868680e912c$var$pu(this.persistenceKey, this.currentUser, t);
        this.setItem(i, s.hr());
    }
    Cr(t) {
        const e = $70fd6868680e912c$var$pu(this.persistenceKey, this.currentUser, t);
        this.removeItem(e);
    }
    Mr(t) {
        const e = {
            clientId: this.wr,
            onlineState: t
        };
        this.storage.setItem(this.vr, JSON.stringify(e));
    }
    kr(t, e, n) {
        const s = $70fd6868680e912c$var$Iu(this.persistenceKey, t), i = new $70fd6868680e912c$var$Eu(t, e, n);
        this.setItem(s, i.hr());
    }
    $r(t) {
        const e = JSON.stringify(Array.from(t));
        this.setItem(this.Rr, e);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Or(t) {
        const e = this.Tr.exec(t);
        return e ? e[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Br(t, e) {
        const n = this.Or(t);
        return $70fd6868680e912c$var$Au.ar(n, e);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Lr(t, e) {
        const n = this.Er.exec(t), s = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $70fd6868680e912c$var$Tu.ar(new $70fd6868680e912c$var$V(i), s, e);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Ur(t, e) {
        const n = this.Ar.exec(t), s = Number(n[1]);
        return $70fd6868680e912c$var$Eu.ar(s, e);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ br(t) {
        return $70fd6868680e912c$var$vu.ar(t);
    }
    Gr(t) {
        return JSON.parse(t);
    }
    async qr(t) {
        if (t.user.uid === this.currentUser.uid) return this.syncEngine.jr(t.batchId, t.state, t.error);
        $70fd6868680e912c$var$N("SharedClientState", `Ignoring mutation for non-active user ${t.user.uid}`);
    }
    Kr(t) {
        return this.syncEngine.zr(t.targetId, t.state, t.error);
    }
    Fr(t, e) {
        const n = e ? this.gr.insert(t, e) : this.gr.remove(t), s = this.Sr(this.gr), i = this.Sr(n), r = [], o = [];
        return i.forEach((t)=>{
            s.has(t) || r.push(t);
        }), s.forEach((t)=>{
            i.has(t) || o.push(t);
        }), this.syncEngine.Wr(r, o).then(()=>{
            this.gr = n;
        });
    }
    Vr(t) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.gr.get(t.clientId) && this.onlineStateHandler(t.onlineState);
    }
    Sr(t) {
        let e = $70fd6868680e912c$var$ps();
        return t.forEach((t, n)=>{
            e = e.unionWith(n.activeTargetIds);
        }), e;
    }
}
class $70fd6868680e912c$var$bu {
    constructor(){
        this.Hr = new $70fd6868680e912c$var$Ru, this.Jr = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(t) {
    // No op.
    }
    updateMutationState(t, e, n) {
    // No op.
    }
    addLocalQueryTarget(t) {
        return this.Hr.lr(t), this.Jr[t] || "not-current";
    }
    updateQueryState(t, e, n) {
        this.Jr[t] = e;
    }
    removeLocalQueryTarget(t) {
        this.Hr.dr(t);
    }
    isLocalQueryTarget(t) {
        return this.Hr.activeTargetIds.has(t);
    }
    clearQueryState(t) {
        delete this.Jr[t];
    }
    getAllActiveQueryTargets() {
        return this.Hr.activeTargetIds;
    }
    isActiveQueryTarget(t) {
        return this.Hr.activeTargetIds.has(t);
    }
    start() {
        return this.Hr = new $70fd6868680e912c$var$Ru, Promise.resolve();
    }
    handleUserChange(t, e, n) {
    // No op.
    }
    setOnlineState(t) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(t) {}
    notifyBundleLoaded(t) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Vu {
    Yr(t) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ class $70fd6868680e912c$var$Su {
    constructor(){
        this.Xr = ()=>this.Zr(), this.eo = ()=>this.no(), this.so = [], this.io();
    }
    Yr(t) {
        this.so.push(t);
    }
    shutdown() {
        window.removeEventListener("online", this.Xr), window.removeEventListener("offline", this.eo);
    }
    io() {
        window.addEventListener("online", this.Xr), window.addEventListener("offline", this.eo);
    }
    Zr() {
        $70fd6868680e912c$var$N("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for (const t of this.so)t(0 /* NetworkStatus.AVAILABLE */ );
    }
    no() {
        $70fd6868680e912c$var$N("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for (const t of this.so)t(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static D() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $70fd6868680e912c$var$Du = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $70fd6868680e912c$var$Cu() {
    return null === $70fd6868680e912c$var$Du ? $70fd6868680e912c$var$Du = 268435456 + Math.round(2147483648 * Math.random()) : $70fd6868680e912c$var$Du++, "0x" + $70fd6868680e912c$var$Du.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$xu = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $70fd6868680e912c$var$Nu {
    constructor(t){
        this.ro = t.ro, this.oo = t.oo;
    }
    uo(t) {
        this.co = t;
    }
    ao(t) {
        this.ho = t;
    }
    onMessage(t) {
        this.lo = t;
    }
    close() {
        this.oo();
    }
    send(t) {
        this.ro(t);
    }
    fo() {
        this.co();
    }
    wo(t) {
        this.ho(t);
    }
    _o(t) {
        this.lo(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$ku = "WebChannelConnection";
class $70fd6868680e912c$var$Mu extends /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class {
    constructor(t){
        this.databaseInfo = t, this.databaseId = t.databaseId;
        const e = t.ssl ? "https" : "http";
        this.mo = e + "://" + t.host, this.yo = "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database + "/documents";
    }
    get po() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    Io(t, e, n, s, i) {
        const r = $70fd6868680e912c$var$Cu(), o = this.To(t, e);
        $70fd6868680e912c$var$N("RestConnection", `Sending RPC '${t}' ${r}:`, o, n);
        const u = {};
        return this.Eo(u, s, i), this.Ao(t, o, u, n).then((e)=>($70fd6868680e912c$var$N("RestConnection", `Received RPC '${t}' ${r}: `, e), e), (e)=>{
            throw $70fd6868680e912c$export$86cd73f49cc6e0bb("RestConnection", `RPC '${t}' ${r} failed with error: `, e, "url: ", o, "request:", n), e;
        });
    }
    vo(t, e, n, s, i, r) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Io(t, e, n, s, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ Eo(t, e, n) {
        t["X-Goog-Api-Client"] = "gl-js/ fire/" + $70fd6868680e912c$var$S, // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        t["Content-Type"] = "text/plain", this.databaseInfo.appId && (t["X-Firebase-GMPID"] = this.databaseInfo.appId), e && e.headers.forEach((e, n)=>t[n] = e), n && n.headers.forEach((e, n)=>t[n] = e);
    }
    To(t, e) {
        const n = $70fd6868680e912c$var$xu[t];
        return `${this.mo}/v1/${e}:${n}`;
    }
} {
    constructor(t){
        super(t), this.forceLongPolling = t.forceLongPolling, this.autoDetectLongPolling = t.autoDetectLongPolling, this.useFetchStreams = t.useFetchStreams, this.longPollingOptions = t.longPollingOptions;
    }
    Ao(t, e, n, s) {
        const i = $70fd6868680e912c$var$Cu();
        return new Promise((r, o)=>{
            const u = new (0, $l0itG.XhrIo);
            u.setWithCredentials(!0), u.listenOnce((0, $l0itG.EventType).COMPLETE, ()=>{
                try {
                    switch(u.getLastErrorCode()){
                        case (0, $l0itG.ErrorCode).NO_ERROR:
                            const e = u.getResponseJson();
                            $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `XHR for RPC '${t}' ${i} received:`, JSON.stringify(e)), r(e);
                            break;
                        case (0, $l0itG.ErrorCode).TIMEOUT:
                            $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' ${i} timed out`), o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $l0itG.ErrorCode).HTTP_ERROR:
                            const n = u.getStatus();
                            if ($70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' ${i} failed with status:`, n, "response text:", u.getResponseText()), n > 0) {
                                let t = u.getResponseJson();
                                Array.isArray(t) && (t = t[0]);
                                const e = null == t ? void 0 : t.error;
                                if (e && e.status && e.message) {
                                    const t = function(t) {
                                        const e = t.toLowerCase().replace(/_/g, "-");
                                        return Object.values($70fd6868680e912c$var$q).indexOf(e) >= 0 ? e : $70fd6868680e912c$var$q.UNKNOWN;
                                    }(e.status);
                                    o(new $70fd6868680e912c$export$8fada0bf726bf278(t, e.message));
                                } else o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNKNOWN, "Server responded with status " + u.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $70fd6868680e912c$var$O();
                    }
                } finally{
                    $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' ${i} completed.`);
                }
            });
            const c = JSON.stringify(s);
            $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' ${i} sending request:`, s), u.send(e, "POST", c, n, 15);
        });
    }
    Ro(t, e, n) {
        const s = $70fd6868680e912c$var$Cu(), i = [
            this.mo,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            t,
            "/channel"
        ], r = (0, $l0itG.createWebChannelTransport)(), o = (0, $l0itG.getStatEventTarget)(), u = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, c = this.longPollingOptions.timeoutSeconds;
        void 0 !== c && (u.longPollingTimeout = Math.round(1e3 * c)), this.useFetchStreams && (u.xmlHttpFactory = new (0, $l0itG.FetchXmlHttpFactory)({})), this.Eo(u.initMessageHeaders, e, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        u.encodeInitMessageHeaders = !0;
        const a = i.join("");
        $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `Creating RPC '${t}' stream ${s}: ${a}`, u);
        const h = r.createWebChannel(a, u);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, f = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const d = new $70fd6868680e912c$var$Nu({
            ro: (e)=>{
                f ? $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `Not sending because RPC '${t}' stream ${s} is closed:`, e) : (l || ($70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `Opening RPC '${t}' stream ${s} transport.`), h.open(), l = !0), $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} sending:`, e), h.send(e));
            },
            oo: ()=>h.close()
        }), w = (t, e, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            t.listen(e, (t)=>{
                try {
                    n(t);
                } catch (t) {
                    setTimeout(()=>{
                        throw t;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return w(h, (0, $l0itG.WebChannel).EventType.OPEN, ()=>{
            f || $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} transport opened.`);
        }), w(h, (0, $l0itG.WebChannel).EventType.CLOSE, ()=>{
            f || (f = !0, $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} transport closed`), d.wo());
        }), w(h, (0, $l0itG.WebChannel).EventType.ERROR, (e)=>{
            f || (f = !0, $70fd6868680e912c$export$86cd73f49cc6e0bb($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} transport errored:`, e), d.wo(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, "The operation could not be completed")));
        }), w(h, (0, $l0itG.WebChannel).EventType.MESSAGE, (e)=>{
            var n;
            if (!f) {
                const i = e.data[0];
                $70fd6868680e912c$var$F(!!i);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const r = i, o = r.error || (null === (n = r[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const e = o.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function(t) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const e = $70fd6868680e912c$var$ii[t];
                        if (void 0 !== e) return $70fd6868680e912c$var$ui(e);
                    }(e), i = o.message;
                    void 0 === n && (n = $70fd6868680e912c$var$q.INTERNAL, i = "Unknown error status: " + e + " with message " + o.message), // Mark closed so no further events are propagated
                    f = !0, d.wo(new $70fd6868680e912c$export$8fada0bf726bf278(n, i)), h.close();
                } else $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} received:`, i), d._o(i);
            }
        }), w(o, (0, $l0itG.Event).STAT_EVENT, (e)=>{
            e.stat === (0, $l0itG.Stat).PROXY ? $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} detected buffering proxy`) : e.stat === (0, $l0itG.Stat).NOPROXY && $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            d.fo();
        }, 0), d;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $70fd6868680e912c$var$$u() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $70fd6868680e912c$var$Ou() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$Fu(t) {
    return new $70fd6868680e912c$var$Vi(t, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $70fd6868680e912c$var$Bu {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ t, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ e, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, s = 1.5, i = 6e4){
        this.ii = t, this.timerId = e, this.Po = n, this.bo = s, this.Vo = i, this.So = 0, this.Do = null, /** The last backoff attempt, as epoch milliseconds. */ this.Co = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.So = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ xo() {
        this.So = this.Vo;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ No(t) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const e = Math.floor(this.So + this.ko()), n = Math.max(0, Date.now() - this.Co), s = Math.max(0, e - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        s > 0 && $70fd6868680e912c$var$N("ExponentialBackoff", `Backing off for ${s} ms (base delay: ${this.So} ms, delay with jitter: ${e} ms, last attempt: ${n} ms ago)`), this.Do = this.ii.enqueueAfterDelay(this.timerId, s, ()=>(this.Co = Date.now(), t())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.So *= this.bo, this.So < this.Po && (this.So = this.Po), this.So > this.Vo && (this.So = this.Vo);
    }
    Mo() {
        null !== this.Do && (this.Do.skipDelay(), this.Do = null);
    }
    cancel() {
        null !== this.Do && (this.Do.cancel(), this.Do = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ ko() {
        return (Math.random() - .5) * this.So;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $70fd6868680e912c$var$Lu {
    constructor(t, e, n, s, i, r, o, u){
        this.ii = t, this.$o = n, this.Oo = s, this.connection = i, this.authCredentialsProvider = r, this.appCheckCredentialsProvider = o, this.listener = u, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.Fo = 0, this.Bo = null, this.Lo = null, this.stream = null, this.qo = new $70fd6868680e912c$var$Bu(t, e);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ Uo() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Ko();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ Ko() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.Go();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.Uo() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ Qo() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.qo.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ jo() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Ko() && null === this.Bo && (this.Bo = this.ii.enqueueAfterDelay(this.$o, 6e4, ()=>this.zo()));
    }
    /** Sends a message to the underlying stream. */ Wo(t) {
        this.Ho(), this.stream.send(t);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async zo() {
        if (this.Ko()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ Ho() {
        this.Bo && (this.Bo.cancel(), this.Bo = null);
    }
    /** Cancels the health check delayed operation. */ Jo() {
        this.Lo && (this.Lo.cancel(), this.Lo = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(t, e) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.Ho(), this.Jo(), this.qo.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.Fo++, 4 /* PersistentStreamState.Error */  !== t ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.qo.reset() : e && e.code === $70fd6868680e912c$var$q.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($70fd6868680e912c$var$k(e.toString()), $70fd6868680e912c$var$k("Using maximum backoff delay to prevent overloading the backend."), this.qo.xo()) : e && e.code === $70fd6868680e912c$var$q.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.Yo(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = t, // Notify the listener that the stream closed.
        await this.listener.ao(e);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ Yo() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const t = this.Xo(this.Fo), e = this.Fo;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([t, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.Fo === e && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.Zo(t, n);
        }, (e)=>{
            t(()=>{
                const t = new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNKNOWN, "Fetching auth token failed: " + e.message);
                return this.tu(t);
            });
        });
    }
    Zo(t, e) {
        const n = this.Xo(this.Fo);
        this.stream = this.eu(t, e), this.stream.uo(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.Lo = this.ii.enqueueAfterDelay(this.Oo, 1e4, ()=>(this.Ko() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.uo()));
        }), this.stream.ao((t)=>{
            n(()=>this.tu(t));
        }), this.stream.onMessage((t)=>{
            n(()=>this.onMessage(t));
        });
    }
    Go() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.qo.No(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    tu(t) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $70fd6868680e912c$var$N("PersistentStream", `close with error: ${t}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , t);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ Xo(t) {
        return (e)=>{
            this.ii.enqueueAndForget(()=>this.Fo === t ? e() : ($70fd6868680e912c$var$N("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $70fd6868680e912c$var$qu extends $70fd6868680e912c$var$Lu {
    constructor(t, e, n, s, i, r){
        super(t, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , e, n, s, r), this.serializer = i;
    }
    eu(t, e) {
        return this.connection.Ro("Listen", t, e);
    }
    onMessage(t) {
        // A successful response means the stream is healthy
        this.qo.reset();
        const e = $70fd6868680e912c$var$Qi(this.serializer, t), n = function(t) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in t)) return $70fd6868680e912c$var$rt.min();
            const e = t.targetChange;
            return e.targetIds && e.targetIds.length ? $70fd6868680e912c$var$rt.min() : e.readTime ? $70fd6868680e912c$var$Ni(e.readTime) : $70fd6868680e912c$var$rt.min();
        }(t);
        return this.listener.nu(e, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ su(t) {
        const e = {};
        e.database = $70fd6868680e912c$var$Li(this.serializer), e.addTarget = function(t, e) {
            let n;
            const s = e.target;
            if (n = $70fd6868680e912c$var$Fn(s) ? {
                documents: $70fd6868680e912c$var$Hi(t, s)
            } : {
                query: $70fd6868680e912c$var$Ji(t, s)
            }, n.targetId = e.targetId, e.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $70fd6868680e912c$var$Ci(t, e.resumeToken);
                const s = $70fd6868680e912c$var$Si(t, e.expectedCount);
                null !== s && (n.expectedCount = s);
            } else if (e.snapshotVersion.compareTo($70fd6868680e912c$var$rt.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $70fd6868680e912c$var$Di(t, e.snapshotVersion.toTimestamp());
                const s = $70fd6868680e912c$var$Si(t, e.expectedCount);
                null !== s && (n.expectedCount = s);
            }
            return n;
        }(this.serializer, t);
        const n = $70fd6868680e912c$var$Xi(this.serializer, t);
        n && (e.labels = n), this.Wo(e);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ iu(t) {
        const e = {};
        e.database = $70fd6868680e912c$var$Li(this.serializer), e.removeTarget = t, this.Wo(e);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $70fd6868680e912c$var$Uu extends $70fd6868680e912c$var$Lu {
    constructor(t, e, n, s, i, r){
        super(t, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , e, n, s, r), this.serializer = i, this.ru = !1;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get ou() {
        return this.ru;
    }
    // Override of PersistentStream.start
    start() {
        this.ru = !1, this.lastStreamToken = void 0, super.start();
    }
    Yo() {
        this.ru && this.uu([]);
    }
    eu(t, e) {
        return this.connection.Ro("Write", t, e);
    }
    onMessage(t) {
        if (// Always capture the last stream token.
        $70fd6868680e912c$var$F(!!t.streamToken), this.lastStreamToken = t.streamToken, this.ru) {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.qo.reset();
            const e = $70fd6868680e912c$var$Wi(t.writeResults, t.commitTime), n = $70fd6868680e912c$var$Ni(t.commitTime);
            return this.listener.cu(n, e);
        }
        // The first response is always the handshake response
        return $70fd6868680e912c$var$F(!t.writeResults || 0 === t.writeResults.length), this.ru = !0, this.listener.au();
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ hu() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const t = {};
        t.database = $70fd6868680e912c$var$Li(this.serializer), this.Wo(t);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ uu(t) {
        const e = {
            streamToken: this.lastStreamToken,
            writes: t.map((t)=>$70fd6868680e912c$var$ji(this.serializer, t))
        };
        this.Wo(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $70fd6868680e912c$var$Ku extends class {
} {
    constructor(t, e, n, s){
        super(), this.authCredentials = t, this.appCheckCredentials = e, this.connection = n, this.serializer = s, this.lu = !1;
    }
    fu() {
        if (this.lu) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Io(t, e, n) {
        return this.fu(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, i])=>this.connection.Io(t, e, n, s, i)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $70fd6868680e912c$var$q.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNKNOWN, t.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ vo(t, e, n, s) {
        return this.fu(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, r])=>this.connection.vo(t, e, n, i, r, s)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $70fd6868680e912c$var$q.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNKNOWN, t.toString());
        });
    }
    terminate() {
        this.lu = !0;
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
async function $70fd6868680e912c$var$Gu(t, e, n) {
    var s;
    const i = $70fd6868680e912c$var$L(t), { request: r, du: o } = function(t, e, n) {
        const s = $70fd6868680e912c$var$Ji(t, e), i = {}, r = [];
        let o = 0;
        return n.forEach((t)=>{
            // Map all client-side aliases to a unique short-form
            // alias. This avoids issues with client-side aliases that
            // exceed the 1500-byte string size limit.
            const e = "aggregate_" + o++;
            i[e] = t.alias, "count" === t.yt ? r.push({
                alias: e,
                count: {}
            }) : "avg" === t.yt ? r.push({
                alias: e,
                avg: {
                    field: $70fd6868680e912c$var$sr(t.fieldPath)
                }
            }) : "sum" === t.yt && r.push({
                alias: e,
                sum: {
                    field: $70fd6868680e912c$var$sr(t.fieldPath)
                }
            });
        }), {
            request: {
                structuredAggregationQuery: {
                    aggregations: r,
                    structuredQuery: s.structuredQuery
                },
                parent: s.parent
            },
            du: i
        };
    }(i.serializer, $70fd6868680e912c$var$Jn(e), n), u = r.parent;
    i.connection.po || delete r.parent;
    const c = (await i.vo("RunAggregationQuery", u, r, /*expectedResponseCount=*/ 1)).filter((t)=>!!t.result);
    // Omit RunAggregationQueryResponse that only contain readTimes.
    $70fd6868680e912c$var$F(1 === c.length);
    // Remap the short-form aliases that were sent to the server
    // to the client-side aliases. Users will access the results
    // using the client-side alias.
    const a = null === (s = c[0].result) || void 0 === s ? void 0 : s.aggregateFields;
    return Object.keys(a).reduce((t, e)=>(t[o[e]] = a[e], t), {});
}
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $70fd6868680e912c$var$Qu {
    constructor(t, e){
        this.asyncQueue = t, this.onlineStateHandler = e, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.wu = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this._u = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.mu = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ gu() {
        0 === this.wu && (this.yu("Unknown" /* OnlineState.Unknown */ ), this._u = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this._u = null, this.pu("Backend didn't respond within 10 seconds."), this.yu("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ Iu(t) {
        "Online" /* OnlineState.Online */  === this.state ? this.yu("Unknown" /* OnlineState.Unknown */ ) : (this.wu++, this.wu >= 1 && (this.Tu(), this.pu(`Connection failed 1 times. Most recent error: ${t.toString()}`), this.yu("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(t) {
        this.Tu(), this.wu = 0, "Online" /* OnlineState.Online */  === t && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.mu = !1), this.yu(t);
    }
    yu(t) {
        t !== this.state && (this.state = t, this.onlineStateHandler(t));
    }
    pu(t) {
        const e = `Could not reach Cloud Firestore backend. ${t}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.mu ? ($70fd6868680e912c$var$k(e), this.mu = !1) : $70fd6868680e912c$var$N("OnlineStateTracker", e);
    }
    Tu() {
        null !== this._u && (this._u.cancel(), this._u = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$ju {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ t, /** The client-side proxy for interacting with the backend. */ e, n, s, i){
        this.localStore = t, this.datastore = e, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Eu = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Au = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.vu = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.Ru = [], this.Pu = i, this.Pu.Yr((t)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $70fd6868680e912c$var$ec(this) && ($70fd6868680e912c$var$N("RemoteStore", "Restarting streams for network reachability change."), await async function(t) {
                    const e = $70fd6868680e912c$var$L(t);
                    e.vu.add(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$Wu(e), e.bu.set("Unknown" /* OnlineState.Unknown */ ), e.vu.delete(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$zu(e);
                }(this));
            });
        }), this.bu = new $70fd6868680e912c$var$Qu(n, s);
    }
}
async function $70fd6868680e912c$var$zu(t) {
    if ($70fd6868680e912c$var$ec(t)) for (const e of t.Ru)await e(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $70fd6868680e912c$var$Wu(t) {
    for (const e of t.Ru)await e(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $70fd6868680e912c$var$Hu(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    n.Au.has(e.targetId) || // Mark this as something the client is currently listening for.
    (n.Au.set(e.targetId, e), $70fd6868680e912c$var$tc(n) ? // The listen will be sent in onWatchStreamOpen
    $70fd6868680e912c$var$Zu(n) : $70fd6868680e912c$var$pc(n).Ko() && $70fd6868680e912c$var$Yu(n, e));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $70fd6868680e912c$var$Ju(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$pc(n);
    n.Au.delete(e), s.Ko() && $70fd6868680e912c$var$Xu(n, e), 0 === n.Au.size && (s.Ko() ? s.jo() : $70fd6868680e912c$var$ec(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.bu.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $70fd6868680e912c$var$Yu(t, e) {
    if (t.Vu.qt(e.targetId), e.resumeToken.approximateByteSize() > 0 || e.snapshotVersion.compareTo($70fd6868680e912c$var$rt.min()) > 0) {
        const n = t.remoteSyncer.getRemoteKeysForTarget(e.targetId).size;
        e = e.withExpectedCount(n);
    }
    $70fd6868680e912c$var$pc(t).su(e);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $70fd6868680e912c$var$Xu(t, e) {
    t.Vu.qt(e), $70fd6868680e912c$var$pc(t).iu(e);
}
function $70fd6868680e912c$var$Zu(t) {
    t.Vu = new $70fd6868680e912c$var$Ei({
        getRemoteKeysForTarget: (e)=>t.remoteSyncer.getRemoteKeysForTarget(e),
        le: (e)=>t.Au.get(e) || null,
        ue: ()=>t.datastore.serializer.databaseId
    }), $70fd6868680e912c$var$pc(t).start(), t.bu.gu();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $70fd6868680e912c$var$tc(t) {
    return $70fd6868680e912c$var$ec(t) && !$70fd6868680e912c$var$pc(t).Uo() && t.Au.size > 0;
}
function $70fd6868680e912c$var$ec(t) {
    return 0 === $70fd6868680e912c$var$L(t).vu.size;
}
function $70fd6868680e912c$var$nc(t) {
    t.Vu = void 0;
}
async function $70fd6868680e912c$var$sc(t) {
    t.Au.forEach((e, n)=>{
        $70fd6868680e912c$var$Yu(t, e);
    });
}
async function $70fd6868680e912c$var$ic(t, e) {
    $70fd6868680e912c$var$nc(t), // If we still need the watch stream, retry the connection.
    $70fd6868680e912c$var$tc(t) ? (t.bu.Iu(e), $70fd6868680e912c$var$Zu(t)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    t.bu.set("Unknown" /* OnlineState.Unknown */ );
}
async function $70fd6868680e912c$var$rc(t, e, n) {
    if (// Mark the client as online since we got a message from the server
    t.bu.set("Online" /* OnlineState.Online */ ), e instanceof $70fd6868680e912c$var$Ii && 2 /* WatchTargetChangeState.Removed */  === e.state && e.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        await /** Handles an error on a target */ async function(t, e) {
            const n = e.cause;
            for (const s of e.targetIds)// A watched target might have been removed already.
            t.Au.has(s) && (await t.remoteSyncer.rejectListen(s, n), t.Au.delete(s), t.Vu.removeTarget(s));
        }(t, e);
    } catch (n) {
        $70fd6868680e912c$var$N("RemoteStore", "Failed to remove targets %s: %s ", e.targetIds.join(","), n), await $70fd6868680e912c$var$oc(t, n);
    }
    else if (e instanceof $70fd6868680e912c$var$yi ? t.Vu.Ht(e) : e instanceof $70fd6868680e912c$var$pi ? t.Vu.ne(e) : t.Vu.Xt(e), !n.isEqual($70fd6868680e912c$var$rt.min())) try {
        const e = await $70fd6868680e912c$var$ou(t.localStore);
        n.compareTo(e) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        await /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function(t, e) {
            const n = t.Vu.ce(e);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, s)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = t.Au.get(s);
                    // A watched target might have been removed already.
                    i && t.Au.set(s, i.withResumeToken(n.resumeToken, e));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((e, n)=>{
                const s = t.Au.get(e);
                if (!s) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                t.Au.set(e, s.withResumeToken($70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, s.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $70fd6868680e912c$var$Xu(t, e);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $70fd6868680e912c$var$cr(s.target, e, n, s.sequenceNumber);
                $70fd6868680e912c$var$Yu(t, i);
            }), t.remoteSyncer.applyRemoteEvent(n);
        }(t, n);
    } catch (e) {
        $70fd6868680e912c$var$N("RemoteStore", "Failed to raise snapshot:", e), await $70fd6868680e912c$var$oc(t, e);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $70fd6868680e912c$var$oc(t, e, n) {
    if (!$70fd6868680e912c$var$Dt(e)) throw e;
    t.vu.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $70fd6868680e912c$var$Wu(t), t.bu.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$70fd6868680e912c$var$ou(t.localStore)), // Probe IndexedDB periodically and re-enable network
    t.asyncQueue.enqueueRetryable(async ()=>{
        $70fd6868680e912c$var$N("RemoteStore", "Retrying IndexedDB access"), await n(), t.vu.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $70fd6868680e912c$var$zu(t);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $70fd6868680e912c$var$uc(t, e) {
    return e().catch((n)=>$70fd6868680e912c$var$oc(t, n, e));
}
async function $70fd6868680e912c$var$cc(t) {
    const e = $70fd6868680e912c$var$L(t), n = $70fd6868680e912c$var$Ic(e);
    let s = e.Eu.length > 0 ? e.Eu[e.Eu.length - 1].batchId : -1;
    for(; $70fd6868680e912c$var$ac(e);)try {
        const t = await $70fd6868680e912c$var$au(e.localStore, s);
        if (null === t) {
            0 === e.Eu.length && n.jo();
            break;
        }
        s = t.batchId, $70fd6868680e912c$var$hc(e, t);
    } catch (t) {
        await $70fd6868680e912c$var$oc(e, t);
    }
    $70fd6868680e912c$var$lc(e) && $70fd6868680e912c$var$fc(e);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $70fd6868680e912c$var$ac(t) {
    return $70fd6868680e912c$var$ec(t) && t.Eu.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $70fd6868680e912c$var$hc(t, e) {
    t.Eu.push(e);
    const n = $70fd6868680e912c$var$Ic(t);
    n.Ko() && n.ou && n.uu(e.mutations);
}
function $70fd6868680e912c$var$lc(t) {
    return $70fd6868680e912c$var$ec(t) && !$70fd6868680e912c$var$Ic(t).Uo() && t.Eu.length > 0;
}
function $70fd6868680e912c$var$fc(t) {
    $70fd6868680e912c$var$Ic(t).start();
}
async function $70fd6868680e912c$var$dc(t) {
    $70fd6868680e912c$var$Ic(t).hu();
}
async function $70fd6868680e912c$var$wc(t) {
    const e = $70fd6868680e912c$var$Ic(t);
    // Send the write pipeline now that the stream is established.
    for (const n of t.Eu)e.uu(n.mutations);
}
async function $70fd6868680e912c$var$_c(t, e, n) {
    const s = t.Eu.shift(), i = $70fd6868680e912c$var$ti.from(s, e, n);
    await $70fd6868680e912c$var$uc(t, ()=>t.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $70fd6868680e912c$var$cc(t);
}
async function $70fd6868680e912c$var$mc(t, e) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    e && $70fd6868680e912c$var$Ic(t).ou && // This error affects the actual write.
    await async function(t, e) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (n = e.code, $70fd6868680e912c$var$oi(n) && n !== $70fd6868680e912c$var$q.ABORTED) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = t.Eu.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $70fd6868680e912c$var$Ic(t).Qo(), await $70fd6868680e912c$var$uc(t, ()=>t.remoteSyncer.rejectFailedWrite(n.batchId, e)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $70fd6868680e912c$var$cc(t);
        }
        var n;
    }(t, e), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $70fd6868680e912c$var$lc(t) && $70fd6868680e912c$var$fc(t);
}
async function $70fd6868680e912c$var$gc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    n.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$N("RemoteStore", "RemoteStore received new credentials");
    const s = $70fd6868680e912c$var$ec(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.vu.add(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$Wu(n), s && // Don't set the network status to Unknown if we are offline.
    n.bu.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(e), n.vu.delete(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$zu(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $70fd6868680e912c$var$yc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    e ? (n.vu.delete(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$zu(n)) : e || (n.vu.add(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$Wu(n), n.bu.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$pc(t) {
    return t.Su || // Create stream (but note that it is not started yet).
    (t.Su = function(t, e, n) {
        const s = $70fd6868680e912c$var$L(t);
        return s.fu(), new $70fd6868680e912c$var$qu(e, s.connection, s.authCredentials, s.appCheckCredentials, s.serializer, n);
    }(t.datastore, t.asyncQueue, {
        uo: $70fd6868680e912c$var$sc.bind(null, t),
        ao: $70fd6868680e912c$var$ic.bind(null, t),
        nu: $70fd6868680e912c$var$rc.bind(null, t)
    }), t.Ru.push(async (e)=>{
        e ? (t.Su.Qo(), $70fd6868680e912c$var$tc(t) ? $70fd6868680e912c$var$Zu(t) : t.bu.set("Unknown" /* OnlineState.Unknown */ )) : (await t.Su.stop(), $70fd6868680e912c$var$nc(t));
    })), t.Su;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$Ic(t) {
    return t.Du || // Create stream (but note that it is not started yet).
    (t.Du = function(t, e, n) {
        const s = $70fd6868680e912c$var$L(t);
        return s.fu(), new $70fd6868680e912c$var$Uu(e, s.connection, s.authCredentials, s.appCheckCredentials, s.serializer, n);
    }(t.datastore, t.asyncQueue, {
        uo: $70fd6868680e912c$var$dc.bind(null, t),
        ao: $70fd6868680e912c$var$mc.bind(null, t),
        au: $70fd6868680e912c$var$wc.bind(null, t),
        cu: $70fd6868680e912c$var$_c.bind(null, t)
    }), t.Ru.push(async (e)=>{
        e ? (t.Du.Qo(), // This will start the write stream if necessary.
        await $70fd6868680e912c$var$cc(t)) : (await t.Du.stop(), t.Eu.length > 0 && ($70fd6868680e912c$var$N("RemoteStore", `Stopping write stream with ${t.Eu.length} pending writes`), t.Eu = []));
    })), t.Du;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $70fd6868680e912c$var$Tc {
    constructor(t, e, n, s, i){
        this.asyncQueue = t, this.timerId = e, this.targetTimeMs = n, this.op = s, this.removalCallback = i, this.deferred = new $70fd6868680e912c$var$K, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((t)=>{});
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(t, e, n, s, i) {
        const r = Date.now() + n, o = new $70fd6868680e912c$var$Tc(t, e, r, s, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(t) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), t);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(t) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((t)=>this.deferred.resolve(t))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $70fd6868680e912c$var$Ec(t, e) {
    if ($70fd6868680e912c$var$k("AsyncQueue", `${e}: ${t}`), $70fd6868680e912c$var$Dt(t)) return new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, `${e}: ${t}`);
    throw t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $70fd6868680e912c$var$Ac {
    /** The default ordering is by key if the comparator is omitted */ constructor(t){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = t ? (e, n)=>t(e, n) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, n.key) : (t, e)=>$70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, e.key), this.keyedMap = $70fd6868680e912c$var$hs(), this.sortedSet = new $70fd6868680e912c$var$pe(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(t) {
        return new $70fd6868680e912c$var$Ac(t.comparator);
    }
    has(t) {
        return null != this.keyedMap.get(t);
    }
    get(t) {
        return this.keyedMap.get(t);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(t) {
        const e = this.keyedMap.get(t);
        return e ? this.sortedSet.indexOf(e) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(t) {
        this.sortedSet.inorderTraversal((e, n)=>(t(e), !1));
    }
    /** Inserts or updates a document with the same key */ add(t) {
        // First remove the element if we have it.
        const e = this.delete(t.key);
        return e.copy(e.keyedMap.insert(t.key, t), e.sortedSet.insert(t, null));
    }
    /** Deletes a document with a given key */ delete(t) {
        const e = this.get(t);
        return e ? this.copy(this.keyedMap.remove(t), this.sortedSet.remove(e)) : this;
    }
    isEqual(t) {
        if (!(t instanceof $70fd6868680e912c$var$Ac)) return !1;
        if (this.size !== t.size) return !1;
        const e = this.sortedSet.getIterator(), n = t.sortedSet.getIterator();
        for(; e.hasNext();){
            const t = e.getNext().key, s = n.getNext().key;
            if (!t.isEqual(s)) return !1;
        }
        return !0;
    }
    toString() {
        const t = [];
        return this.forEach((e)=>{
            t.push(e.toString());
        }), 0 === t.length ? "DocumentSet ()" : "DocumentSet (\n  " + t.join("  \n") + "\n)";
    }
    copy(t, e) {
        const n = new $70fd6868680e912c$var$Ac;
        return n.comparator = this.comparator, n.keyedMap = t, n.sortedSet = e, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $70fd6868680e912c$var$vc {
    constructor(){
        this.Cu = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
    }
    track(t) {
        const e = t.doc.key, n = this.Cu.get(e);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== t.type && 3 /* ChangeType.Metadata */  === n.type ? this.Cu = this.Cu.insert(e, t) : 3 /* ChangeType.Metadata */  === t.type && 1 /* ChangeType.Removed */  !== n.type ? this.Cu = this.Cu.insert(e, {
            type: n.type,
            doc: t.doc
        }) : 2 /* ChangeType.Modified */  === t.type && 2 /* ChangeType.Modified */  === n.type ? this.Cu = this.Cu.insert(e, {
            type: 2 /* ChangeType.Modified */ ,
            doc: t.doc
        }) : 2 /* ChangeType.Modified */  === t.type && 0 /* ChangeType.Added */  === n.type ? this.Cu = this.Cu.insert(e, {
            type: 0 /* ChangeType.Added */ ,
            doc: t.doc
        }) : 1 /* ChangeType.Removed */  === t.type && 0 /* ChangeType.Added */  === n.type ? this.Cu = this.Cu.remove(e) : 1 /* ChangeType.Removed */  === t.type && 2 /* ChangeType.Modified */  === n.type ? this.Cu = this.Cu.insert(e, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === t.type && 1 /* ChangeType.Removed */  === n.type ? this.Cu = this.Cu.insert(e, {
            type: 2 /* ChangeType.Modified */ ,
            doc: t.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $70fd6868680e912c$var$O() : this.Cu = this.Cu.insert(e, t);
    }
    xu() {
        const t = [];
        return this.Cu.inorderTraversal((e, n)=>{
            t.push(n);
        }), t;
    }
}
class $70fd6868680e912c$var$Rc {
    constructor(t, e, n, s, i, r, o, u, c){
        this.query = t, this.docs = e, this.oldDocs = n, this.docChanges = s, this.mutatedKeys = i, this.fromCache = r, this.syncStateChanged = o, this.excludesMetadataChanges = u, this.hasCachedResults = c;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(t, e, n, s, i) {
        const r = [];
        return e.forEach((t)=>{
            r.push({
                type: 0 /* ChangeType.Added */ ,
                doc: t
            });
        }), new $70fd6868680e912c$var$Rc(t, e, $70fd6868680e912c$var$Ac.emptySet(e), r, n, s, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(t) {
        if (!(this.fromCache === t.fromCache && this.hasCachedResults === t.hasCachedResults && this.syncStateChanged === t.syncStateChanged && this.mutatedKeys.isEqual(t.mutatedKeys) && $70fd6868680e912c$var$Zn(this.query, t.query) && this.docs.isEqual(t.docs) && this.oldDocs.isEqual(t.oldDocs))) return !1;
        const e = this.docChanges, n = t.docChanges;
        if (e.length !== n.length) return !1;
        for(let t = 0; t < e.length; t++)if (e[t].type !== n[t].type || !e[t].doc.isEqual(n[t].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $70fd6868680e912c$var$Pc {
    constructor(){
        this.Nu = void 0, this.listeners = [];
    }
}
class $70fd6868680e912c$var$bc {
    constructor(){
        this.queries = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$ts(t), $70fd6868680e912c$var$Zn), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.ku = new Set;
    }
}
async function $70fd6868680e912c$var$Vc(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = e.query;
    let i = !1, r = n.queries.get(s);
    if (r || (i = !0, r = new $70fd6868680e912c$var$Pc), i) try {
        r.Nu = await n.onListen(s);
    } catch (t) {
        const n = $70fd6868680e912c$var$Ec(t, `Initialization of query '${$70fd6868680e912c$var$es(e.query)}' failed`);
        return void e.onError(n);
    }
    if (n.queries.set(s, r), r.listeners.push(e), // Run global snapshot listeners if a consistent snapshot has been emitted.
    e.Mu(n.onlineState), r.Nu) e.$u(r.Nu) && $70fd6868680e912c$var$xc(n);
}
async function $70fd6868680e912c$var$Sc(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = e.query;
    let i = !1;
    const r = n.queries.get(s);
    if (r) {
        const t = r.listeners.indexOf(e);
        t >= 0 && (r.listeners.splice(t, 1), i = 0 === r.listeners.length);
    }
    if (i) return n.queries.delete(s), n.onUnlisten(s);
}
function $70fd6868680e912c$var$Dc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    let s = !1;
    for (const t of e){
        const e = t.query, i = n.queries.get(e);
        if (i) {
            for (const e of i.listeners)e.$u(t) && (s = !0);
            i.Nu = t;
        }
    }
    s && $70fd6868680e912c$var$xc(n);
}
function $70fd6868680e912c$var$Cc(t, e, n) {
    const s = $70fd6868680e912c$var$L(t), i = s.queries.get(e);
    if (i) for (const t of i.listeners)t.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    s.queries.delete(e);
}
// Call all global snapshot listeners that have been set.
function $70fd6868680e912c$var$xc(t) {
    t.ku.forEach((t)=>{
        t.next();
    });
}
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $70fd6868680e912c$var$Nc {
    constructor(t, e, n){
        this.query = t, this.Ou = e, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Fu = !1, this.Bu = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ $u(t) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const e = [];
            for (const n of t.docChanges)3 /* ChangeType.Metadata */  !== n.type && e.push(n);
            t = new $70fd6868680e912c$var$Rc(t.query, t.docs, t.oldDocs, e, t.mutatedKeys, t.fromCache, t.syncStateChanged, /* excludesMetadataChanges= */ !0, t.hasCachedResults);
        }
        let e = !1;
        return this.Fu ? this.Lu(t) && (this.Ou.next(t), e = !0) : this.qu(t, this.onlineState) && (this.Uu(t), e = !0), this.Bu = t, e;
    }
    onError(t) {
        this.Ou.error(t);
    }
    /** Returns whether a snapshot was raised. */ Mu(t) {
        this.onlineState = t;
        let e = !1;
        return this.Bu && !this.Fu && this.qu(this.Bu, t) && (this.Uu(this.Bu), e = !0), e;
    }
    qu(t, e) {
        // Always raise the first event when we're synced
        if (!t.fromCache) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== e;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.Ku || !n) && (!t.docs.isEmpty() || t.hasCachedResults || "Offline" /* OnlineState.Offline */  === e);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    Lu(t) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (t.docChanges.length > 0) return !0;
        const e = this.Bu && this.Bu.hasPendingWrites !== t.hasPendingWrites;
        return !(!t.syncStateChanged && !e) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    Uu(t) {
        t = $70fd6868680e912c$var$Rc.fromInitialDocuments(t.query, t.docs, t.mutatedKeys, t.fromCache, t.hasCachedResults), this.Fu = !0, this.Ou.next(t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $70fd6868680e912c$var$kc {
    constructor(t, // How many bytes this element takes to store in the bundle.
    e){
        this.Gu = t, this.byteLength = e;
    }
    Qu() {
        return "metadata" in this.Gu;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $70fd6868680e912c$var$Mc {
    constructor(t){
        this.serializer = t;
    }
    rr(t) {
        return $70fd6868680e912c$var$Oi(this.serializer, t);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ ur(t) {
        return t.metadata.exists ? $70fd6868680e912c$var$Ki(this.serializer, t.document, !1) : $70fd6868680e912c$var$an.newNoDocument(this.rr(t.metadata.name), this.cr(t.metadata.readTime));
    }
    cr(t) {
        return $70fd6868680e912c$var$Ni(t);
    }
}
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class $70fd6868680e912c$var$$c {
    constructor(t, e, n){
        this.ju = t, this.localStore = e, this.serializer = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $70fd6868680e912c$var$Oc(t);
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ zu(t) {
        this.progress.bytesLoaded += t.byteLength;
        let e = this.progress.documentsLoaded;
        if (t.Gu.namedQuery) this.queries.push(t.Gu.namedQuery);
        else if (t.Gu.documentMetadata) {
            this.documents.push({
                metadata: t.Gu.documentMetadata
            }), t.Gu.documentMetadata.exists || ++e;
            const n = $70fd6868680e912c$var$ut.fromString(t.Gu.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else t.Gu.document && (this.documents[this.documents.length - 1].document = t.Gu.document, ++e);
        return e !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = e, Object.assign({}, this.progress)) : null;
    }
    Wu(t) {
        const e = new Map, n = new $70fd6868680e912c$var$Mc(this.serializer);
        for (const s of t)if (s.metadata.queries) {
            const t = n.rr(s.metadata.name);
            for (const n of s.metadata.queries){
                const s = (e.get(n) || $70fd6868680e912c$var$gs()).add(t);
                e.set(n, s);
            }
        }
        return e;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async complete() {
        const t = await $70fd6868680e912c$var$mu(this.localStore, new $70fd6868680e912c$var$Mc(this.serializer), this.documents, this.ju.id), e = this.Wu(this.documents);
        for (const t of this.queries)await $70fd6868680e912c$var$gu(this.localStore, t, e.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Hu: this.collectionGroups,
            Ju: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $70fd6868680e912c$var$Oc(t) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: t.totalDocuments,
        totalBytes: t.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Fc {
    constructor(t){
        this.key = t;
    }
}
class $70fd6868680e912c$var$Bc {
    constructor(t){
        this.key = t;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $70fd6868680e912c$var$Lc {
    constructor(t, /** Documents included in the remote target */ e){
        this.query = t, this.Yu = e, this.Xu = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Zu = $70fd6868680e912c$var$gs(), /** Document Keys that have local changes */ this.mutatedKeys = $70fd6868680e912c$var$gs(), this.tc = $70fd6868680e912c$var$is(t), this.ec = new $70fd6868680e912c$var$Ac(this.tc);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get nc() {
        return this.Yu;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ sc(t, e) {
        const n = e ? e.ic : new $70fd6868680e912c$var$vc, s = e ? e.ec : this.ec;
        let i = e ? e.mutatedKeys : this.mutatedKeys, r = s, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const u = "F" /* LimitType.First */  === this.query.limitType && s.size === this.query.limit ? s.last() : null, c = "L" /* LimitType.Last */  === this.query.limitType && s.size === this.query.limit ? s.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (t.inorderTraversal((t, e)=>{
            const a = s.get(t), h = $70fd6868680e912c$var$ns(this.query, e) ? e : null, l = !!a && this.mutatedKeys.has(a.key), f = !!h && (h.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(h.key) && h.hasCommittedMutations);
            let d = !1;
            // Calculate change
            if (a && h) a.data.isEqual(h.data) ? l !== f && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: h
            }), d = !0) : this.rc(a, h) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: h
            }), d = !0, (u && this.tc(h, u) > 0 || c && this.tc(h, c) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !a && h ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: h
            }), d = !0) : a && !h && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: a
            }), d = !0, (u || c) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            d && (h ? (r = r.add(h), i = f ? i.add(t) : i.delete(t)) : (r = r.delete(t), i = i.delete(t)));
        }), null !== this.query.limit) for(; r.size > this.query.limit;){
            const t = "F" /* LimitType.First */  === this.query.limitType ? r.last() : r.first();
            r = r.delete(t.key), i = i.delete(t.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: t
            });
        }
        return {
            ec: r,
            ic: n,
            zi: o,
            mutatedKeys: i
        };
    }
    rc(t, e) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return t.hasLocalMutations && e.hasCommittedMutations && !e.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param updateLimboDocuments - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(t, e, n) {
        const s = this.ec;
        this.ec = t.ec, this.mutatedKeys = t.mutatedKeys;
        // Sort changes based on type and query comparator
        const i = t.ic.xu();
        i.sort((t, e)=>(function(t, e) {
                const n = (t)=>{
                    switch(t){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $70fd6868680e912c$var$O();
                    }
                };
                return n(t) - n(e);
            })(t.type, e.type) || this.tc(t.doc, e.doc)), this.oc(n);
        const r = e ? this.uc() : [], o = 0 === this.Zu.size && this.current ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , u = o !== this.Xu;
        if (this.Xu = o, 0 !== i.length || u) return {
            snapshot: new $70fd6868680e912c$var$Rc(this.query, t.ec, s, i, t.mutatedKeys, 0 /* SyncState.Local */  === o, u, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            cc: r
        };
        // no changes
        return {
            cc: r
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ Mu(t) {
        return this.current && "Offline" /* OnlineState.Offline */  === t ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            ec: this.ec,
            ic: new $70fd6868680e912c$var$vc,
            mutatedKeys: this.mutatedKeys,
            zi: !1
        }, /* updateLimboDocuments= */ !1)) : {
            cc: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ ac(t) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Yu.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.ec.has(t) && !this.ec.get(t).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ oc(t) {
        t && (t.addedDocuments.forEach((t)=>this.Yu = this.Yu.add(t)), t.modifiedDocuments.forEach((t)=>{}), t.removedDocuments.forEach((t)=>this.Yu = this.Yu.delete(t)), this.current = t.current);
    }
    uc() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const t = this.Zu;
        this.Zu = $70fd6868680e912c$var$gs(), this.ec.forEach((t)=>{
            this.ac(t.key) && (this.Zu = this.Zu.add(t.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const e = [];
        return t.forEach((t)=>{
            this.Zu.has(t) || e.push(new $70fd6868680e912c$var$Bc(t));
        }), this.Zu.forEach((n)=>{
            t.has(n) || e.push(new $70fd6868680e912c$var$Fc(n));
        }), e;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    hc(t) {
        this.Yu = t.ir, this.Zu = $70fd6868680e912c$var$gs();
        const e = this.sc(t.documents);
        return this.applyChanges(e, /*updateLimboDocuments=*/ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    lc() {
        return $70fd6868680e912c$var$Rc.fromInitialDocuments(this.query, this.ec, this.mutatedKeys, 0 /* SyncState.Local */  === this.Xu, this.hasCachedResults);
    }
}
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $70fd6868680e912c$var$qc {
    constructor(/**
     * The query itself.
     */ t, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ e, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = t, this.targetId = e, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $70fd6868680e912c$var$Uc {
    constructor(t){
        this.key = t, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.fc = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$Kc {
    constructor(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    s, i, r){
        this.localStore = t, this.remoteStore = e, this.eventManager = n, this.sharedClientState = s, this.currentUser = i, this.maxConcurrentLimboResolutions = r, this.dc = {}, this.wc = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$ts(t), $70fd6868680e912c$var$Zn), this._c = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.mc = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.gc = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.yc = new Map, this.Ic = new $70fd6868680e912c$var$Oo, /** Stores user completion handlers, indexed by User and BatchId. */ this.Tc = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Ec = new Map, this.Ac = $70fd6868680e912c$var$lo.Mn(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.vc = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.vc;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $70fd6868680e912c$var$Gc(t, e) {
    const n = $70fd6868680e912c$var$pa(t);
    let s, i;
    const r = n.wc.get(e);
    if (r) // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    s = r.targetId, n.sharedClientState.addLocalQueryTarget(s), i = r.view.lc();
    else {
        const t = await $70fd6868680e912c$var$hu(n.localStore, $70fd6868680e912c$var$Jn(e)), r = n.sharedClientState.addLocalQueryTarget(t.targetId);
        s = t.targetId, i = await $70fd6868680e912c$var$Qc(n, e, s, "current" === r, t.resumeToken), n.isPrimaryClient && $70fd6868680e912c$var$Hu(n.remoteStore, t);
    }
    return i;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $70fd6868680e912c$var$Qc(t, e, n, s, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    t.Rc = (e, n, s)=>(async function(t, e, n, s) {
            let i = e.view.sc(n);
            i.zi && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $70fd6868680e912c$var$fu(t.localStore, e.query, /* usePreviousResults= */ !1).then(({ documents: t })=>e.view.sc(t, i)));
            const r = s && s.targetChanges.get(e.targetId), o = e.view.applyChanges(i, /* updateLimboDocuments= */ t.isPrimaryClient, r);
            return $70fd6868680e912c$var$ia(t, e.targetId, o.cc), o.snapshot;
        })(t, e, n, s);
    const r = await $70fd6868680e912c$var$fu(t.localStore, e, /* usePreviousResults= */ !0), o = new $70fd6868680e912c$var$Lc(e, r.ir), u = o.sc(r.documents), c = $70fd6868680e912c$var$gi.createSynthesizedTargetChangeForCurrentChange(n, s && "Offline" /* OnlineState.Offline */  !== t.onlineState, i), a = o.applyChanges(u, /* updateLimboDocuments= */ t.isPrimaryClient, c);
    $70fd6868680e912c$var$ia(t, n, a.cc);
    const h = new $70fd6868680e912c$var$qc(e, n, o);
    return t.wc.set(e, h), t._c.has(n) ? t._c.get(n).push(e) : t._c.set(n, [
        e
    ]), a.snapshot;
}
/** Stops listening to the query. */ async function $70fd6868680e912c$var$jc(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = n.wc.get(e), i = n._c.get(s.targetId);
    if (i.length > 1) return n._c.set(s.targetId, i.filter((t)=>!$70fd6868680e912c$var$Zn(t, e))), void n.wc.delete(e);
    // No other queries are mapped to the target, clean up the query and the target.
    if (n.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        n.sharedClientState.removeLocalQueryTarget(s.targetId);
        n.sharedClientState.isActiveQueryTarget(s.targetId) || await $70fd6868680e912c$var$lu(n.localStore, s.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            n.sharedClientState.clearQueryState(s.targetId), $70fd6868680e912c$var$Ju(n.remoteStore, s.targetId), $70fd6868680e912c$var$na(n, s.targetId);
        }).catch($70fd6868680e912c$var$vt);
    } else $70fd6868680e912c$var$na(n, s.targetId), await $70fd6868680e912c$var$lu(n.localStore, s.targetId, /*keepPersistedTargetData=*/ !0);
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $70fd6868680e912c$var$zc(t, e, n) {
    const s = $70fd6868680e912c$var$Ia(t);
    try {
        const t = await function(t, e) {
            const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$export$d9bcbd5e1ff81430.now(), i = e.reduce((t, e)=>t.add(e.key), $70fd6868680e912c$var$gs());
            let r, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (t)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let u = $70fd6868680e912c$var$cs(), c = $70fd6868680e912c$var$gs();
                return n.Zi.getEntries(t, i).next((t)=>{
                    u = t, u.forEach((t, e)=>{
                        e.isValidDocument() || (c = c.add(t));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(t, u)).next((i)=>{
                    r = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const t of e){
                        const e = $70fd6868680e912c$var$Gs(t, r.get(t.key).overlayedDocument);
                        null != e && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $70fd6868680e912c$var$zs(t.key, e, $70fd6868680e912c$var$cn(e.value.mapValue), $70fd6868680e912c$var$Fs.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(t, s, o, e);
                }).next((e)=>{
                    o = e;
                    const s = e.applyToLocalDocumentSet(r, c);
                    return n.documentOverlayCache.saveOverlays(t, e.batchId, s);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $70fd6868680e912c$var$ls(r)
                }));
        }(s.localStore, e);
        s.sharedClientState.addPendingMutation(t.batchId), function(t, e, n) {
            let s = t.Tc[t.currentUser.toKey()];
            s || (s = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et));
            s = s.insert(e, n), t.Tc[t.currentUser.toKey()] = s;
        }(s, t.batchId, n), await $70fd6868680e912c$var$ua(s, t.changes), await $70fd6868680e912c$var$cc(s.remoteStore);
    } catch (t) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const e = $70fd6868680e912c$var$Ec(t, "Failed to persist write");
        n.reject(e);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $70fd6868680e912c$var$Wc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    try {
        const t = await $70fd6868680e912c$var$uu(n.localStore, e);
        // Update `receivedDocument` as appropriate for any limbo targets.
        e.targetChanges.forEach((t, e)=>{
            const s = n.yc.get(e);
            s && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($70fd6868680e912c$var$F(t.addedDocuments.size + t.modifiedDocuments.size + t.removedDocuments.size <= 1), t.addedDocuments.size > 0 ? s.fc = !0 : t.modifiedDocuments.size > 0 ? $70fd6868680e912c$var$F(s.fc) : t.removedDocuments.size > 0 && ($70fd6868680e912c$var$F(s.fc), s.fc = !1));
        }), await $70fd6868680e912c$var$ua(n, t, e);
    } catch (t) {
        await $70fd6868680e912c$var$vt(t);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $70fd6868680e912c$var$Hc(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (s.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !s.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const t = [];
        s.wc.forEach((n, s)=>{
            const i = s.view.Mu(e);
            i.snapshot && t.push(i.snapshot);
        }), function(t, e) {
            const n = $70fd6868680e912c$var$L(t);
            n.onlineState = e;
            let s = !1;
            n.queries.forEach((t, n)=>{
                for (const t of n.listeners)// Run global snapshot listeners if a consistent snapshot has been emitted.
                t.Mu(e) && (s = !0);
            }), s && $70fd6868680e912c$var$xc(n);
        }(s.eventManager, e), t.length && s.dc.nu(t), s.onlineState = e, s.isPrimaryClient && s.sharedClientState.setOnlineState(e);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $70fd6868680e912c$var$Jc(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    // PORTING NOTE: Multi-tab only.
    s.sharedClientState.updateQueryState(e, "rejected", n);
    const i = s.yc.get(e), r = i && i.key;
    if (r) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let t = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        t = t.insert(r, $70fd6868680e912c$var$an.newNoDocument(r, $70fd6868680e912c$var$rt.min()));
        const n = $70fd6868680e912c$var$gs().add(r), i = new $70fd6868680e912c$var$mi($70fd6868680e912c$var$rt.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), t, n);
        await $70fd6868680e912c$var$Wc(s, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        s.gc = s.gc.remove(r), s.yc.delete(e), $70fd6868680e912c$var$oa(s);
    } else await $70fd6868680e912c$var$lu(s.localStore, e, /* keepPersistedTargetData */ !1).then(()=>$70fd6868680e912c$var$na(s, e, n)).catch($70fd6868680e912c$var$vt);
}
async function $70fd6868680e912c$var$Yc(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = e.batch.batchId;
    try {
        const t = await $70fd6868680e912c$var$ru(n.localStore, e);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $70fd6868680e912c$var$ea(n, s, /*error=*/ null), $70fd6868680e912c$var$ta(n, s), n.sharedClientState.updateMutationState(s, "acknowledged"), await $70fd6868680e912c$var$ua(n, t);
    } catch (t) {
        await $70fd6868680e912c$var$vt(t);
    }
}
async function $70fd6868680e912c$var$Xc(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    try {
        const t = await function(t, e) {
            const n = $70fd6868680e912c$var$L(t);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (t)=>{
                let s;
                return n.mutationQueue.lookupMutationBatch(t, e).next((e)=>($70fd6868680e912c$var$F(null !== e), s = e.keys(), n.mutationQueue.removeMutationBatch(t, e))).next(()=>n.mutationQueue.performConsistencyCheck(t)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(t, s, e)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, s)).next(()=>n.localDocuments.getDocuments(t, s));
            });
        }(s.localStore, e);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $70fd6868680e912c$var$ea(s, e, n), $70fd6868680e912c$var$ta(s, e), s.sharedClientState.updateMutationState(e, "rejected", n), await $70fd6868680e912c$var$ua(s, t);
    } catch (n) {
        await $70fd6868680e912c$var$vt(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $70fd6868680e912c$var$Zc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    $70fd6868680e912c$var$ec(n.remoteStore) || $70fd6868680e912c$var$N("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const t = await function(t) {
            const e = $70fd6868680e912c$var$L(t);
            return e.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (t)=>e.mutationQueue.getHighestUnacknowledgedBatchId(t));
        }(n.localStore);
        if (-1 === t) // Trigger the callback right away if there is no pending writes at the moment.
        return void e.resolve();
        const s = n.Ec.get(t) || [];
        s.push(e), n.Ec.set(t, s);
    } catch (t) {
        const n = $70fd6868680e912c$var$Ec(t, "Initialization of waitForPendingWrites() operation failed");
        e.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $70fd6868680e912c$var$ta(t, e) {
    (t.Ec.get(e) || []).forEach((t)=>{
        t.resolve();
    }), t.Ec.delete(e);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $70fd6868680e912c$var$ea(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    let i = s.Tc[s.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const t = i.get(e);
        t && (n ? t.reject(n) : t.resolve(), i = i.remove(e)), s.Tc[s.currentUser.toKey()] = i;
    }
}
function $70fd6868680e912c$var$na(t, e, n = null) {
    t.sharedClientState.removeLocalQueryTarget(e);
    for (const s of t._c.get(e))t.wc.delete(s), n && t.dc.Pc(s, n);
    if (t._c.delete(e), t.isPrimaryClient) t.Ic.Is(e).forEach((e)=>{
        t.Ic.containsKey(e) || // We removed the last reference for this key
        $70fd6868680e912c$var$sa(t, e);
    });
}
function $70fd6868680e912c$var$sa(t, e) {
    t.mc.delete(e.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = t.gc.get(e);
    null !== n && ($70fd6868680e912c$var$Ju(t.remoteStore, n), t.gc = t.gc.remove(e), t.yc.delete(n), $70fd6868680e912c$var$oa(t));
}
function $70fd6868680e912c$var$ia(t, e, n) {
    for (const s of n)if (s instanceof $70fd6868680e912c$var$Fc) t.Ic.addReference(s.key, e), $70fd6868680e912c$var$ra(t, s);
    else if (s instanceof $70fd6868680e912c$var$Bc) {
        $70fd6868680e912c$var$N("SyncEngine", "Document no longer in limbo: " + s.key), t.Ic.removeReference(s.key, e);
        t.Ic.containsKey(s.key) || // We removed the last reference for this key
        $70fd6868680e912c$var$sa(t, s.key);
    } else $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$ra(t, e) {
    const n = e.key, s = n.path.canonicalString();
    t.gc.get(n) || t.mc.has(s) || ($70fd6868680e912c$var$N("SyncEngine", "New document in limbo: " + n), t.mc.add(s), $70fd6868680e912c$var$oa(t));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $70fd6868680e912c$var$oa(t) {
    for(; t.mc.size > 0 && t.gc.size < t.maxConcurrentLimboResolutions;){
        const e = t.mc.values().next().value;
        t.mc.delete(e);
        const n = new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.fromString(e)), s = t.Ac.next();
        t.yc.set(s, new $70fd6868680e912c$var$Uc(n)), t.gc = t.gc.insert(n, s), $70fd6868680e912c$var$Hu(t.remoteStore, new $70fd6868680e912c$var$cr($70fd6868680e912c$var$Jn($70fd6868680e912c$var$Gn(n.path)), s, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $70fd6868680e912c$var$Ot.ct));
    }
}
async function $70fd6868680e912c$var$ua(t, e, n) {
    const s = $70fd6868680e912c$var$L(t), i = [], r = [], o = [];
    s.wc.isEmpty() || (s.wc.forEach((t, u)=>{
        o.push(s.Rc(u, e, n).then((t)=>{
            // Update views if there are actual changes.
            if (// If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            (t || n) && s.isPrimaryClient && s.sharedClientState.updateQueryState(u.targetId, (null == t ? void 0 : t.fromCache) ? "not-current" : "current"), t) {
                i.push(t);
                const e = $70fd6868680e912c$var$tu.Li(u.targetId, t);
                r.push(e);
            }
        }));
    }), await Promise.all(o), s.dc.nu(i), await async function(t, e) {
        const n = $70fd6868680e912c$var$L(t);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (t)=>$70fd6868680e912c$var$Rt.forEach(e, (e)=>$70fd6868680e912c$var$Rt.forEach(e.Fi, (s)=>n.persistence.referenceDelegate.addReference(t, e.targetId, s)).next(()=>$70fd6868680e912c$var$Rt.forEach(e.Bi, (s)=>n.persistence.referenceDelegate.removeReference(t, e.targetId, s)))));
        } catch (t) {
            if (!$70fd6868680e912c$var$Dt(t)) throw t;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $70fd6868680e912c$var$N("LocalStore", "Failed to update sequence numbers: " + t);
        }
        for (const t of e){
            const e = t.targetId;
            if (!t.fromCache) {
                const t = n.Ji.get(e), s = t.snapshotVersion, i = t.withLastLimboFreeSnapshotVersion(s);
                // Advance the last limbo free snapshot version
                n.Ji = n.Ji.insert(e, i);
            }
        }
    }(s.localStore, r));
}
async function $70fd6868680e912c$var$ca(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    if (!n.currentUser.isEqual(e)) {
        $70fd6868680e912c$var$N("SyncEngine", "User change. New user:", e.toKey());
        const t = await $70fd6868680e912c$var$iu(n.localStore, e);
        n.currentUser = e, // Fails tasks waiting for pending writes requested by previous user.
        function(t, e) {
            t.Ec.forEach((t)=>{
                t.forEach((t)=>{
                    t.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.CANCELLED, e));
                });
            }), t.Ec.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(e, t.removedBatchIds, t.addedBatchIds), await $70fd6868680e912c$var$ua(n, t.er);
    }
}
function $70fd6868680e912c$var$aa(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = n.yc.get(e);
    if (s && s.fc) return $70fd6868680e912c$var$gs().add(s.key);
    {
        let t = $70fd6868680e912c$var$gs();
        const s = n._c.get(e);
        if (!s) return t;
        for (const e of s){
            const s = n.wc.get(e);
            t = t.unionWith(s.view.nc);
        }
        return t;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $70fd6868680e912c$var$ha(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = await $70fd6868680e912c$var$fu(n.localStore, e.query, /* usePreviousResults= */ !0), i = e.view.hc(s);
    return n.isPrimaryClient && $70fd6868680e912c$var$ia(n, e.targetId, i.cc), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$la(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return $70fd6868680e912c$var$wu(n.localStore, e).then((t)=>$70fd6868680e912c$var$ua(n, t));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$fa(t, e, n, s) {
    const i = $70fd6868680e912c$var$L(t), r = await function(t, e) {
        const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$L(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (t)=>s.Sn(t, e).next((e)=>e ? n.localDocuments.getDocuments(t, e) : $70fd6868680e912c$var$Rt.resolve(null)));
    }(i.localStore, e);
    null !== r ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $70fd6868680e912c$var$cc(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($70fd6868680e912c$var$ea(i, e, s || null), $70fd6868680e912c$var$ta(i, e), function(t, e) {
        $70fd6868680e912c$var$L($70fd6868680e912c$var$L(t).mutationQueue).Cn(e);
    }(i.localStore, e)) : $70fd6868680e912c$var$O(), await $70fd6868680e912c$var$ua(i, r)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $70fd6868680e912c$var$N("SyncEngine", "Cannot apply mutation batch with id: " + e);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$da(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    if ($70fd6868680e912c$var$pa(n), $70fd6868680e912c$var$Ia(n), !0 === e && !0 !== n.vc) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const t = n.sharedClientState.getAllActiveQueryTargets(), e = await $70fd6868680e912c$var$wa(n, t.toArray());
        n.vc = !0, await $70fd6868680e912c$var$yc(n.remoteStore, !0);
        for (const t of e)$70fd6868680e912c$var$Hu(n.remoteStore, t);
    } else if (!1 === e && !1 !== n.vc) {
        const t = [];
        let e = Promise.resolve();
        n._c.forEach((s, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? t.push(i) : e = e.then(()=>($70fd6868680e912c$var$na(n, i), $70fd6868680e912c$var$lu(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $70fd6868680e912c$var$Ju(n.remoteStore, i);
        }), await e, await $70fd6868680e912c$var$wa(n, t), // PORTING NOTE: Multi-Tab only.
        function(t) {
            const e = $70fd6868680e912c$var$L(t);
            e.yc.forEach((t, n)=>{
                $70fd6868680e912c$var$Ju(e.remoteStore, n);
            }), e.Ic.Ts(), e.yc = new Map, e.gc = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        }(n), n.vc = !1, await $70fd6868680e912c$var$yc(n.remoteStore, !1);
    }
}
async function $70fd6868680e912c$var$wa(t, e, n) {
    const s = $70fd6868680e912c$var$L(t), i = [], r = [];
    for (const t of e){
        let e;
        const n = s._c.get(t);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            e = await $70fd6868680e912c$var$hu(s.localStore, $70fd6868680e912c$var$Jn(n[0]));
            for (const t of n){
                const e = s.wc.get(t), n = await $70fd6868680e912c$var$ha(s, e);
                n.snapshot && r.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $70fd6868680e912c$var$du(s.localStore, t);
            e = await $70fd6868680e912c$var$hu(s.localStore, n), await $70fd6868680e912c$var$Qc(s, $70fd6868680e912c$var$_a(n), t, /*current=*/ !1, e.resumeToken);
        }
        i.push(e);
    }
    return s.dc.nu(r), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$_a(t) {
    return $70fd6868680e912c$var$Kn(t.path, t.collectionGroup, t.orderBy, t.filters, t.limit, "F" /* LimitType.First */ , t.startAt, t.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$ma(t) {
    const e = $70fd6868680e912c$var$L(t);
    return $70fd6868680e912c$var$L($70fd6868680e912c$var$L(e.localStore).persistence).$i();
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$ga(t, e, n, s) {
    const i = $70fd6868680e912c$var$L(t);
    if (i.vc) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $70fd6868680e912c$var$N("SyncEngine", "Ignoring unexpected query state notification.");
    const r = i._c.get(e);
    if (r && r.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const t = await $70fd6868680e912c$var$wu(i.localStore, $70fd6868680e912c$var$ss(r[0])), s = $70fd6868680e912c$var$mi.createSynthesizedRemoteEventForCurrentChange(e, "current" === n, $70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING);
                await $70fd6868680e912c$var$ua(i, t, s);
                break;
            }
        case "rejected":
            await $70fd6868680e912c$var$lu(i.localStore, e, /* keepPersistedTargetData */ !0), $70fd6868680e912c$var$na(i, e, s);
            break;
        default:
            $70fd6868680e912c$var$O();
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $70fd6868680e912c$var$ya(t, e, n) {
    const s = $70fd6868680e912c$var$pa(t);
    if (s.vc) {
        for (const t of e){
            if (s._c.has(t)) {
                // A target might have been added in a previous attempt
                $70fd6868680e912c$var$N("SyncEngine", "Adding an already active target " + t);
                continue;
            }
            const e = await $70fd6868680e912c$var$du(s.localStore, t), n = await $70fd6868680e912c$var$hu(s.localStore, e);
            await $70fd6868680e912c$var$Qc(s, $70fd6868680e912c$var$_a(e), n.targetId, /*current=*/ !1, n.resumeToken), $70fd6868680e912c$var$Hu(s.remoteStore, n);
        }
        for (const t of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        s._c.has(t) && // Release queries that are still active.
        await $70fd6868680e912c$var$lu(s.localStore, t, /* keepPersistedTargetData */ !1).then(()=>{
            $70fd6868680e912c$var$Ju(s.remoteStore, t), $70fd6868680e912c$var$na(s, t);
        }).catch($70fd6868680e912c$var$vt);
    }
}
function $70fd6868680e912c$var$pa(t) {
    const e = $70fd6868680e912c$var$L(t);
    return e.remoteStore.remoteSyncer.applyRemoteEvent = $70fd6868680e912c$var$Wc.bind(null, e), e.remoteStore.remoteSyncer.getRemoteKeysForTarget = $70fd6868680e912c$var$aa.bind(null, e), e.remoteStore.remoteSyncer.rejectListen = $70fd6868680e912c$var$Jc.bind(null, e), e.dc.nu = $70fd6868680e912c$var$Dc.bind(null, e.eventManager), e.dc.Pc = $70fd6868680e912c$var$Cc.bind(null, e.eventManager), e;
}
function $70fd6868680e912c$var$Ia(t) {
    const e = $70fd6868680e912c$var$L(t);
    return e.remoteStore.remoteSyncer.applySuccessfulWrite = $70fd6868680e912c$var$Yc.bind(null, e), e.remoteStore.remoteSyncer.rejectFailedWrite = $70fd6868680e912c$var$Xc.bind(null, e), e;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $70fd6868680e912c$var$Ta(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function(t, e, n) {
        try {
            const s = await e.getMetadata();
            if (await function(t, e) {
                const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$Ni(e.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (t)=>n.qs.getBundleMetadata(t, e.id)).then((t)=>!!t && t.createTime.compareTo(s) >= 0);
            }(t.localStore, s)) return await e.close(), n._completeWith(function(t) {
                return {
                    taskState: "Success",
                    documentsLoaded: t.totalDocuments,
                    bytesLoaded: t.totalBytes,
                    totalDocuments: t.totalDocuments,
                    totalBytes: t.totalBytes
                };
            }(s)), Promise.resolve(new Set);
            n._updateProgress($70fd6868680e912c$var$Oc(s));
            const i = new $70fd6868680e912c$var$$c(s, t.localStore, e.serializer);
            let r = await e.bc();
            for(; r;){
                const t = await i.zu(r);
                t && n._updateProgress(t), r = await e.bc();
            }
            const o = await i.complete();
            return await $70fd6868680e912c$var$ua(t, o.Ju, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function(t, e) {
                const n = $70fd6868680e912c$var$L(t);
                return n.persistence.runTransaction("Save bundle", "readwrite", (t)=>n.qs.saveBundleMetadata(t, e));
            }(t.localStore, s), n._completeWith(o.progress), Promise.resolve(o.Hu);
        } catch (t) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb("SyncEngine", `Loading bundle failed with ${t}`), n._failWith(t), Promise.resolve(new Set);
        }
    })(s, e, n).then((t)=>{
        s.sharedClientState.notifyBundleLoaded(t);
    });
}
class $70fd6868680e912c$var$Ea {
    constructor(){
        this.synchronizeTabs = !1;
    }
    async initialize(t) {
        this.serializer = $70fd6868680e912c$var$Fu(t.databaseInfo.databaseId), this.sharedClientState = this.createSharedClientState(t), this.persistence = this.createPersistence(t), await this.persistence.start(), this.localStore = this.createLocalStore(t), this.gcScheduler = this.createGarbageCollectionScheduler(t, this.localStore), this.indexBackfillerScheduler = this.createIndexBackfillerScheduler(t, this.localStore);
    }
    createGarbageCollectionScheduler(t, e) {
        return null;
    }
    createIndexBackfillerScheduler(t, e) {
        return null;
    }
    createLocalStore(t) {
        return $70fd6868680e912c$var$su(this.persistence, new $70fd6868680e912c$var$eu, t.initialUser, this.serializer);
    }
    createPersistence(t) {
        return new $70fd6868680e912c$var$Ko($70fd6868680e912c$var$Qo.zs, this.serializer);
    }
    createSharedClientState(t) {
        return new $70fd6868680e912c$var$bu;
    }
    async terminate() {
        this.gcScheduler && this.gcScheduler.stop(), await this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
class $70fd6868680e912c$var$Aa extends $70fd6868680e912c$var$Ea {
    constructor(t){
        super(), this.cacheSizeBytes = t;
    }
    createGarbageCollectionScheduler(t, e) {
        $70fd6868680e912c$var$F(this.persistence.referenceDelegate instanceof $70fd6868680e912c$var$jo);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$po(n, t.asyncQueue, e);
    }
    createPersistence(t) {
        const e = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$so.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$so.DEFAULT;
        return new $70fd6868680e912c$var$Ko((t)=>$70fd6868680e912c$var$jo.zs(t, e), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $70fd6868680e912c$var$va extends $70fd6868680e912c$var$Ea {
    constructor(t, e, n){
        super(), this.Vc = t, this.cacheSizeBytes = e, this.forceOwnership = n, this.synchronizeTabs = !1;
    }
    async initialize(t) {
        await super.initialize(t), await this.Vc.initialize(this, t), // Enqueue writes from a previous session
        await $70fd6868680e912c$var$Ia(this.Vc.syncEngine), await $70fd6868680e912c$var$cc(this.Vc.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Ii(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    createLocalStore(t) {
        return $70fd6868680e912c$var$su(this.persistence, new $70fd6868680e912c$var$eu, t.initialUser, this.serializer);
    }
    createGarbageCollectionScheduler(t, e) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$po(n, t.asyncQueue, e);
    }
    createIndexBackfillerScheduler(t, e) {
        const n = new $70fd6868680e912c$var$$t(e, this.persistence);
        return new $70fd6868680e912c$var$Mt(t.asyncQueue, n);
    }
    createPersistence(t) {
        const e = $70fd6868680e912c$var$Zo(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$so.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$so.DEFAULT;
        return new $70fd6868680e912c$var$Jo(this.synchronizeTabs, e, t.clientId, n, t.asyncQueue, $70fd6868680e912c$var$$u(), $70fd6868680e912c$var$Ou(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    createSharedClientState(t) {
        return new $70fd6868680e912c$var$bu;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $70fd6868680e912c$var$Ra extends $70fd6868680e912c$var$va {
    constructor(t, e){
        super(t, e, /* forceOwnership= */ !1), this.Vc = t, this.cacheSizeBytes = e, this.synchronizeTabs = !0;
    }
    async initialize(t) {
        await super.initialize(t);
        const e = this.Vc.syncEngine;
        this.sharedClientState instanceof $70fd6868680e912c$var$Pu && (this.sharedClientState.syncEngine = {
            jr: $70fd6868680e912c$var$fa.bind(null, e),
            zr: $70fd6868680e912c$var$ga.bind(null, e),
            Wr: $70fd6868680e912c$var$ya.bind(null, e),
            $i: $70fd6868680e912c$var$ma.bind(null, e),
            Qr: $70fd6868680e912c$var$la.bind(null, e)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Ii(async (t)=>{
            await $70fd6868680e912c$var$da(this.Vc.syncEngine, t), this.gcScheduler && (t && !this.gcScheduler.started ? this.gcScheduler.start() : t || this.gcScheduler.stop()), this.indexBackfillerScheduler && (t && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : t || this.indexBackfillerScheduler.stop());
        });
    }
    createSharedClientState(t) {
        const e = $70fd6868680e912c$var$$u();
        if (!$70fd6868680e912c$var$Pu.D(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $70fd6868680e912c$var$Zo(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey);
        return new $70fd6868680e912c$var$Pu(e, t.asyncQueue, n, t.clientId, t.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $70fd6868680e912c$var$Pa {
    async initialize(t, e) {
        this.localStore || (this.localStore = t.localStore, this.sharedClientState = t.sharedClientState, this.datastore = this.createDatastore(e), this.remoteStore = this.createRemoteStore(e), this.eventManager = this.createEventManager(e), this.syncEngine = this.createSyncEngine(e, /* startAsPrimary=*/ !t.synchronizeTabs), this.sharedClientState.onlineStateHandler = (t)=>$70fd6868680e912c$var$Hc(this.syncEngine, t, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $70fd6868680e912c$var$ca.bind(null, this.syncEngine), await $70fd6868680e912c$var$yc(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(t) {
        return new $70fd6868680e912c$var$bc;
    }
    createDatastore(t) {
        const e = $70fd6868680e912c$var$Fu(t.databaseInfo.databaseId), n = (s = t.databaseInfo, new $70fd6868680e912c$var$Mu(s));
        var s;
        /** Return the Platform-specific connectivity monitor. */ return function(t, e, n, s) {
            return new $70fd6868680e912c$var$Ku(t, e, n, s);
        }(t.authCredentials, t.appCheckCredentials, n, e);
    }
    createRemoteStore(t) {
        var e, n, s, i, r;
        return e = this.localStore, n = this.datastore, s = t.asyncQueue, i = (t)=>$70fd6868680e912c$var$Hc(this.syncEngine, t, 0 /* OnlineStateSource.RemoteStore */ ), r = $70fd6868680e912c$var$Su.D() ? new $70fd6868680e912c$var$Su : new $70fd6868680e912c$var$Vu, new $70fd6868680e912c$var$ju(e, n, s, i, r);
    /** Re-enables the network. Idempotent. */ }
    createSyncEngine(t, e) {
        return function(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        s, i, r, o) {
            const u = new $70fd6868680e912c$var$Kc(t, e, n, s, i, r);
            return o && (u.vc = !0), u;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, t.initialUser, t.maxConcurrentLimboResolutions, e);
    }
    terminate() {
        return async function(t) {
            const e = $70fd6868680e912c$var$L(t);
            $70fd6868680e912c$var$N("RemoteStore", "RemoteStore shutting down."), e.vu.add(5 /* OfflineCause.Shutdown */ ), await $70fd6868680e912c$var$Wu(e), e.Pu.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            e.bu.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $70fd6868680e912c$var$ba(t, e = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < t.byteLength) {
                const s = {
                    value: t.slice(n, n + e),
                    done: !1
                };
                return n += e, s;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $70fd6868680e912c$var$Va {
    constructor(t){
        this.observer = t, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(t) {
        this.observer.next && this.Sc(this.observer.next, t);
    }
    error(t) {
        this.observer.error ? this.Sc(this.observer.error, t) : $70fd6868680e912c$var$k("Uncaught Error in snapshot listener:", t.toString());
    }
    Dc() {
        this.muted = !0;
    }
    Sc(t, e) {
        this.muted || setTimeout(()=>{
            this.muted || t(e);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $70fd6868680e912c$var$Sa {
    constructor(/** The reader to read from underlying binary bundle data source. */ t, e){
        this.Cc = t, this.serializer = e, /** Cached bundle metadata. */ this.metadata = new $70fd6868680e912c$var$K, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.xc = new TextDecoder("utf-8"), // Read the metadata (which is the first element).
        this.Nc().then((t)=>{
            t && t.Qu() ? this.metadata.resolve(t.Gu.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == t ? void 0 : t.Gu)}`));
        }, (t)=>this.metadata.reject(t));
    }
    close() {
        return this.Cc.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async bc() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.Nc();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async Nc() {
        const t = await this.kc();
        if (null === t) return null;
        const e = this.xc.decode(t), n = Number(e);
        isNaN(n) && this.Mc(`length string (${e}) is not valid number`);
        const s = await this.$c(n);
        return new $70fd6868680e912c$var$kc(JSON.parse(s), t.length + n);
    }
    /** First index of '{' from the underlying buffer. */ Oc() {
        return this.buffer.findIndex((t)=>t === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async kc() {
        for(; this.Oc() < 0;){
            if (await this.Fc()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const t = this.Oc();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        t < 0 && this.Mc("Reached the end of bundle when a length string is expected.");
        const e = this.buffer.slice(0, t);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(t), e;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async $c(t) {
        for(; this.buffer.length < t;)await this.Fc() && this.Mc("Reached the end of bundle when more is expected.");
        const e = this.xc.decode(this.buffer.slice(0, t));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(t), e;
    }
    Mc(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Cc.cancel(), new Error(`Invalid bundle format: ${t}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Fc() {
        const t = await this.Cc.read();
        if (!t.done) {
            const e = new Uint8Array(this.buffer.length + t.value.length);
            e.set(this.buffer), e.set(t.value, this.buffer.length), this.buffer = e;
        }
        return t.done;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $70fd6868680e912c$var$Da {
    constructor(t){
        this.datastore = t, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastWriteError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(t) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
        const e = await async function(t, e) {
            const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$Li(n.serializer) + "/documents", i = {
                documents: e.map((t)=>$70fd6868680e912c$var$$i(n.serializer, t))
            }, r = await n.vo("BatchGetDocuments", s, i, e.length), o = new Map;
            r.forEach((t)=>{
                const e = $70fd6868680e912c$var$Gi(n.serializer, t);
                o.set(e.key.toString(), e);
            });
            const u = [];
            return e.forEach((t)=>{
                const e = o.get(t.toString());
                $70fd6868680e912c$var$F(!!e), u.push(e);
            }), u;
        }(this.datastore, t);
        return e.forEach((t)=>this.recordVersion(t)), e;
    }
    set(t, e) {
        this.write(e.toMutation(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    update(t, e) {
        try {
            this.write(e.toMutation(t, this.preconditionForUpdate(t)));
        } catch (t) {
            this.lastWriteError = t;
        }
        this.writtenDocs.add(t.toString());
    }
    delete(t) {
        this.write(new $70fd6868680e912c$var$Ys(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastWriteError) throw this.lastWriteError;
        const t = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((e)=>{
            t.delete(e.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        t.forEach((t, e)=>{
            const n = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(e);
            this.mutations.push(new $70fd6868680e912c$var$Xs(n, this.precondition(n)));
        }), await async function(t, e) {
            const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$Li(n.serializer) + "/documents", i = {
                writes: e.map((t)=>$70fd6868680e912c$var$ji(n.serializer, t))
            };
            await n.Io("Commit", s, i);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(t) {
        let e;
        if (t.isFoundDocument()) e = t.version;
        else {
            if (!t.isNoDocument()) throw $70fd6868680e912c$var$O();
            // Represent a deleted doc using SnapshotVersion.min().
            e = $70fd6868680e912c$var$rt.min();
        }
        const n = this.readVersions.get(t.key.toString());
        if (n) {
            if (!e.isEqual(n)) // This transaction will fail no matter what.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(t.key.toString(), e);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(t) {
        const e = this.readVersions.get(t.toString());
        return !this.writtenDocs.has(t.toString()) && e ? e.isEqual($70fd6868680e912c$var$rt.min()) ? $70fd6868680e912c$var$Fs.exists(!1) : $70fd6868680e912c$var$Fs.updateTime(e) : $70fd6868680e912c$var$Fs.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(t) {
        const e = this.readVersions.get(t.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(t.toString()) && e) {
            if (e.isEqual($70fd6868680e912c$var$rt.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $70fd6868680e912c$var$Fs.updateTime(e);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $70fd6868680e912c$var$Fs.exists(!0);
    }
    write(t) {
        this.ensureCommitNotCalled(), this.mutations.push(t);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $70fd6868680e912c$var$Ca {
    constructor(t, e, n, s, i){
        this.asyncQueue = t, this.datastore = e, this.options = n, this.updateFunction = s, this.deferred = i, this.Bc = n.maxAttempts, this.qo = new $70fd6868680e912c$var$Bu(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ run() {
        this.Bc -= 1, this.Lc();
    }
    Lc() {
        this.qo.No(async ()=>{
            const t = new $70fd6868680e912c$var$Da(this.datastore), e = this.qc(t);
            e && e.then((e)=>{
                this.asyncQueue.enqueueAndForget(()=>t.commit().then(()=>{
                        this.deferred.resolve(e);
                    }).catch((t)=>{
                        this.Uc(t);
                    }));
            }).catch((t)=>{
                this.Uc(t);
            });
        });
    }
    qc(t) {
        try {
            const e = this.updateFunction(t);
            return !$70fd6868680e912c$var$Ft(e) && e.catch && e.then ? e : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (t) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(t), null;
        }
    }
    Uc(t) {
        this.Bc > 0 && this.Kc(t) ? (this.Bc -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Lc(), Promise.resolve()))) : this.deferred.reject(t);
    }
    Kc(t) {
        if ("FirebaseError" === t.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const e = t.code;
            return "aborted" === e || "failed-precondition" === e || "already-exists" === e || !$70fd6868680e912c$var$oi(e);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $70fd6868680e912c$var$xa {
    constructor(t, e, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, s){
        this.authCredentials = t, this.appCheckCredentials = e, this.asyncQueue = n, this.databaseInfo = s, this.user = $70fd6868680e912c$var$V.UNAUTHENTICATED, this.clientId = $70fd6868680e912c$var$tt.A(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this.authCredentials.start(n, async (t)=>{
            $70fd6868680e912c$var$N("FirestoreClient", "Received user=", t.uid), await this.authCredentialListener(t), this.user = t;
        }), this.appCheckCredentials.start(n, (t)=>($70fd6868680e912c$var$N("FirestoreClient", "Received new app check token=", t), this.appCheckCredentialListener(t, this.user)));
    }
    async getConfiguration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(t) {
        this.authCredentialListener = t;
    }
    setAppCheckTokenChangeListener(t) {
        this.appCheckCredentialListener = t;
    }
    /**
     * Checks that the client has not been terminated. Ensures that other methods on //
     * this class cannot be called after the client is terminated. //
     */ verifyNotTerminated() {
        if (this.asyncQueue.isShuttingDown) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const t = new $70fd6868680e912c$var$K;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), t.resolve();
            } catch (e) {
                const n = $70fd6868680e912c$var$Ec(e, "Failed to shutdown persistence");
                t.reject(n);
            }
        }), t.promise;
    }
}
async function $70fd6868680e912c$var$Na(t, e) {
    t.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$N("FirestoreClient", "Initializing OfflineComponentProvider");
    const n = await t.getConfiguration();
    await e.initialize(n);
    let s = n.initialUser;
    t.setCredentialChangeListener(async (t)=>{
        s.isEqual(t) || (await $70fd6868680e912c$var$iu(e.localStore, t), s = t);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    e.persistence.setDatabaseDeletedListener(()=>t.terminate()), t._offlineComponents = e;
}
async function $70fd6868680e912c$var$ka(t, e) {
    t.asyncQueue.verifyOperationInProgress();
    const n = await $70fd6868680e912c$var$$a(t);
    $70fd6868680e912c$var$N("FirestoreClient", "Initializing OnlineComponentProvider");
    const s = await t.getConfiguration();
    await e.initialize(n, s), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    t.setCredentialChangeListener((t)=>$70fd6868680e912c$var$gc(e.remoteStore, t)), t.setAppCheckTokenChangeListener((t, n)=>$70fd6868680e912c$var$gc(e.remoteStore, n)), t._onlineComponents = e;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ function $70fd6868680e912c$var$Ma(t) {
    return "FirebaseError" === t.name ? t.code === $70fd6868680e912c$var$q.FAILED_PRECONDITION || t.code === $70fd6868680e912c$var$q.UNIMPLEMENTED : !("undefined" != typeof DOMException && t instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
    // or an aborted error depending on whether the error happened during
    // schema migration.
    22 === t.code || 20 === t.code || // Firefox Private Browsing mode disables IndexedDb and returns
    // INVALID_STATE for any usage.
    11 === t.code;
}
async function $70fd6868680e912c$var$$a(t) {
    if (!t._offlineComponents) {
        if (t._uninitializedComponentsProvider) {
            $70fd6868680e912c$var$N("FirestoreClient", "Using user provided OfflineComponentProvider");
            try {
                await $70fd6868680e912c$var$Na(t, t._uninitializedComponentsProvider._offline);
            } catch (e) {
                const n = e;
                if (!$70fd6868680e912c$var$Ma(n)) throw n;
                $70fd6868680e912c$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $70fd6868680e912c$var$Na(t, new $70fd6868680e912c$var$Ea);
            }
        } else $70fd6868680e912c$var$N("FirestoreClient", "Using default OfflineComponentProvider"), await $70fd6868680e912c$var$Na(t, new $70fd6868680e912c$var$Ea);
    }
    return t._offlineComponents;
}
async function $70fd6868680e912c$var$Oa(t) {
    return t._onlineComponents || (t._uninitializedComponentsProvider ? ($70fd6868680e912c$var$N("FirestoreClient", "Using user provided OnlineComponentProvider"), await $70fd6868680e912c$var$ka(t, t._uninitializedComponentsProvider._online)) : ($70fd6868680e912c$var$N("FirestoreClient", "Using default OnlineComponentProvider"), await $70fd6868680e912c$var$ka(t, new $70fd6868680e912c$var$Pa))), t._onlineComponents;
}
function $70fd6868680e912c$var$Fa(t) {
    return $70fd6868680e912c$var$$a(t).then((t)=>t.persistence);
}
function $70fd6868680e912c$var$Ba(t) {
    return $70fd6868680e912c$var$$a(t).then((t)=>t.localStore);
}
function $70fd6868680e912c$var$La(t) {
    return $70fd6868680e912c$var$Oa(t).then((t)=>t.remoteStore);
}
function $70fd6868680e912c$var$qa(t) {
    return $70fd6868680e912c$var$Oa(t).then((t)=>t.syncEngine);
}
function $70fd6868680e912c$var$Ua(t) {
    return $70fd6868680e912c$var$Oa(t).then((t)=>t.datastore);
}
async function $70fd6868680e912c$var$Ka(t) {
    const e = await $70fd6868680e912c$var$Oa(t), n = e.eventManager;
    return n.onListen = $70fd6868680e912c$var$Gc.bind(null, e.syncEngine), n.onUnlisten = $70fd6868680e912c$var$jc.bind(null, e.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $70fd6868680e912c$var$Ga(t) {
    return t.asyncQueue.enqueue(async ()=>{
        const e = await $70fd6868680e912c$var$Fa(t), n = await $70fd6868680e912c$var$La(t);
        return e.setNetworkEnabled(!0), function(t) {
            const e = $70fd6868680e912c$var$L(t);
            return e.vu.delete(0 /* OfflineCause.UserDisabled */ ), $70fd6868680e912c$var$zu(e);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $70fd6868680e912c$var$Qa(t) {
    return t.asyncQueue.enqueue(async ()=>{
        const e = await $70fd6868680e912c$var$Fa(t), n = await $70fd6868680e912c$var$La(t);
        return e.setNetworkEnabled(!1), async function(t) {
            const e = $70fd6868680e912c$var$L(t);
            e.vu.add(0 /* OfflineCause.UserDisabled */ ), await $70fd6868680e912c$var$Wu(e), // Set the OnlineState to Offline so get()s return from cache, etc.
            e.bu.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $70fd6868680e912c$var$ja(t, e) {
    const n = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueueAndForget(async ()=>(async function(t, e, n) {
            try {
                const s = await function(t, e) {
                    const n = $70fd6868680e912c$var$L(t);
                    return n.persistence.runTransaction("read document", "readonly", (t)=>n.localDocuments.getDocument(t, e));
                }(t, e);
                s.isFoundDocument() ? n.resolve(s) : s.isNoDocument() ? n.resolve(null) : n.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (t) {
                const s = $70fd6868680e912c$var$Ec(t, `Failed to get document '${e} from cache`);
                n.reject(s);
            }
        })(await $70fd6868680e912c$var$Ba(t), e, n)), n.promise;
}
function $70fd6868680e912c$var$za(t, e, n = {}) {
    const s = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e, n, s, i) {
            const r = new $70fd6868680e912c$var$Va({
                next: (r)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    e.enqueueAndForget(()=>$70fd6868680e912c$var$Sc(t, o));
                    const u = r.docs.has(n);
                    !u && r.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, "Failed to get document because the client is offline.")) : u && r.fromCache && s && "server" === s.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(r);
                },
                error: (t)=>i.reject(t)
            }), o = new $70fd6868680e912c$var$Nc($70fd6868680e912c$var$Gn(n.path), r, {
                includeMetadataChanges: !0,
                Ku: !0
            });
            return $70fd6868680e912c$var$Vc(t, o);
        })(await $70fd6868680e912c$var$Ka(t), t.asyncQueue, e, n, s)), s.promise;
}
function $70fd6868680e912c$var$Wa(t, e) {
    const n = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueueAndForget(async ()=>(async function(t, e, n) {
            try {
                const s = await $70fd6868680e912c$var$fu(t, e, /* usePreviousResults= */ !0), i = new $70fd6868680e912c$var$Lc(e, s.ir), r = i.sc(s.documents), o = i.applyChanges(r, /* updateLimboDocuments= */ !1);
                n.resolve(o.snapshot);
            } catch (t) {
                const s = $70fd6868680e912c$var$Ec(t, `Failed to execute query '${e} against cache`);
                n.reject(s);
            }
        })(await $70fd6868680e912c$var$Ba(t), e, n)), n.promise;
}
function $70fd6868680e912c$var$Ha(t, e, n = {}) {
    const s = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e, n, s, i) {
            const r = new $70fd6868680e912c$var$Va({
                next: (n)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    e.enqueueAndForget(()=>$70fd6868680e912c$var$Sc(t, o)), n.fromCache && "server" === s.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (t)=>i.reject(t)
            }), o = new $70fd6868680e912c$var$Nc(n, r, {
                includeMetadataChanges: !0,
                Ku: !0
            });
            return $70fd6868680e912c$var$Vc(t, o);
        })(await $70fd6868680e912c$var$Ka(t), t.asyncQueue, e, n, s)), s.promise;
}
function $70fd6868680e912c$var$Ja(t, e) {
    const n = new $70fd6868680e912c$var$Va(e);
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e) {
            $70fd6868680e912c$var$L(t).ku.add(e), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            e.next();
        })(await $70fd6868680e912c$var$Ka(t), n)), ()=>{
        n.Dc(), t.asyncQueue.enqueueAndForget(async ()=>(function(t, e) {
                $70fd6868680e912c$var$L(t).ku.delete(e);
            })(await $70fd6868680e912c$var$Ka(t), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $70fd6868680e912c$var$Ya(t, e, n, s) {
    const i = function(t, e) {
        let n;
        n = "string" == typeof t ? $70fd6868680e912c$var$hi().encode(t) : t;
        return function(t, e) {
            return new $70fd6868680e912c$var$Sa(t, e);
        }(function(t, e) {
            if (t instanceof Uint8Array) return $70fd6868680e912c$var$ba(t, e);
            if (t instanceof ArrayBuffer) return $70fd6868680e912c$var$ba(new Uint8Array(t), e);
            if (t instanceof ReadableStream) return t.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), e);
    }(n, $70fd6868680e912c$var$Fu(e));
    t.asyncQueue.enqueueAndForget(async ()=>{
        $70fd6868680e912c$var$Ta(await $70fd6868680e912c$var$qa(t), i, s);
    });
}
function $70fd6868680e912c$var$Xa(t, e) {
    return t.asyncQueue.enqueue(async ()=>(function(t, e) {
            const n = $70fd6868680e912c$var$L(t);
            return n.persistence.runTransaction("Get named query", "readonly", (t)=>n.qs.getNamedQuery(t, e));
        })(await $70fd6868680e912c$var$Ba(t), e));
}
function $70fd6868680e912c$var$Za(t, e) {
    return t.asyncQueue.enqueue(async ()=>(async function(t, e) {
            const n = $70fd6868680e912c$var$L(t), s = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (t)=>s.getFieldIndexes(t).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function(t, e, n, s, i) {
                        t = [
                            ...t
                        ], e = [
                            ...e
                        ], t.sort(n), e.sort(n);
                        const r = t.length, o = e.length;
                        let u = 0, c = 0;
                        for(; u < o && c < r;){
                            const r = n(t[c], e[u]);
                            r < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(t[c++]) : r > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            s(e[u++]) : (u++, c++);
                        }
                        for(; u < o;)s(e[u++]);
                        for(; c < r;)i(t[c++]);
                    })(n, e, $70fd6868680e912c$var$wt, (e)=>{
                        i.push(s.addFieldIndex(t, e));
                    }, (e)=>{
                        i.push(s.deleteFieldIndex(t, e));
                    })).next(()=>$70fd6868680e912c$var$Rt.waitFor(i)));
        })(await $70fd6868680e912c$var$Ba(t), e));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $70fd6868680e912c$var$th(t) {
    const e = {};
    return void 0 !== t.timeoutSeconds && (e.timeoutSeconds = t.timeoutSeconds), e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$eh = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$nh(t, e, n) {
    if (!n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Function ${t}() cannot be called with an empty ${e}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $70fd6868680e912c$export$8731e8d1617cddb1(t, e, n, s) {
    if (!0 === e && !0 === s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `${t} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $70fd6868680e912c$var$ih(t) {
    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${t} has ${t.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $70fd6868680e912c$var$rh(t) {
    if ($70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${t} has ${t.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $70fd6868680e912c$var$oh(t) {
    if (void 0 === t) return "undefined";
    if (null === t) return "null";
    if ("string" == typeof t) return t.length > 20 && (t = `${t.substring(0, 20)}...`), JSON.stringify(t);
    if ("number" == typeof t || "boolean" == typeof t) return "" + t;
    if ("object" == typeof t) {
        if (t instanceof Array) return "an array";
        {
            const e = /** try to get the constructor name for an object. */ function(t) {
                if (t.constructor) return t.constructor.name;
                return null;
            }(t);
            return e ? `a custom ${e} object` : "an object";
        }
    }
    return "function" == typeof t ? "a function" : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$export$572106fb5803752c(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    if ("_delegate" in t && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (t = t._delegate), !(t instanceof e)) {
        if (e.name === t.constructor.name) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $70fd6868680e912c$var$oh(t);
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Expected type '${e.name}', but it was: ${n}`);
        }
    }
    return t;
}
function $70fd6868680e912c$var$ch(t, e) {
    if (e <= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Function ${t}() requires a positive number, but it was: ${e}.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $70fd6868680e912c$var$ah {
    constructor(t){
        var e, n;
        if (void 0 === t.host) {
            if (void 0 !== t.ssl) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = t.host, this.ssl = null === (e = t.ssl) || void 0 === e || e;
        if (this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, this.cache = t.localCache, void 0 === t.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = t.cacheSizeBytes;
        }
        $70fd6868680e912c$export$8731e8d1617cddb1("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === t.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $70fd6868680e912c$var$th(null !== (n = t.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function(t) {
            if (void 0 !== t.timeoutSeconds) {
                if (isNaN(t.timeoutSeconds)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `invalid long polling timeout: ${t.timeoutSeconds} (must not be NaN)`);
                if (t.timeoutSeconds < 5) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `invalid long polling timeout: ${t.timeoutSeconds} (minimum allowed value is 5)`);
                if (t.timeoutSeconds > 30) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `invalid long polling timeout: ${t.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!t.useFetchStreams;
    }
    isEqual(t) {
        var e, n;
        return this.host === t.host && this.ssl === t.ssl && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && (e = this.experimentalLongPollingOptions, n = t.experimentalLongPollingOptions, e.timeoutSeconds === n.timeoutSeconds) && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties && this.useFetchStreams === t.useFetchStreams;
    }
}
class $70fd6868680e912c$var$hh {
    /** @hideconstructor */ constructor(t, e, n, s){
        this._authCredentials = t, this._appCheckCredentials = e, this._databaseId = n, this._app = s, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $70fd6868680e912c$var$ah({}), this._settingsFrozen = !1;
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return void 0 !== this._terminateTask;
    }
    _setSettings(t) {
        if (this._settingsFrozen) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $70fd6868680e912c$var$ah(t), void 0 !== t.credentials && (this._authCredentials = function(t) {
            if (!t) return new $70fd6868680e912c$export$65ffa50b6039c992;
            switch(t.type){
                case "firstParty":
                    return new $70fd6868680e912c$var$H(t.sessionIndex || "0", t.iamToken || null, t.authTokenFactory || null);
                case "provider":
                    return t.client;
                default:
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(t.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function(t) {
            const e = $70fd6868680e912c$var$eh.get(t);
            e && ($70fd6868680e912c$var$N("ComponentProvider", "Removing Datastore"), $70fd6868680e912c$var$eh.delete(t), e.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $70fd6868680e912c$export$966a03d25297d115(t, e, n, s = {}) {
    var i;
    const r = (t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$var$hh))._getSettings(), o = `${e}:${n}`;
    if ("firestore.googleapis.com" !== r.host && r.host !== o && $70fd6868680e912c$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), t._setSettings(Object.assign(Object.assign({}, r), {
        host: o,
        ssl: !1
    })), s.mockUserToken) {
        let e, n;
        if ("string" == typeof s.mockUserToken) e = s.mockUserToken, n = $70fd6868680e912c$var$V.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            e = (0, $gMVVg.createMockUserToken)(s.mockUserToken, null === (i = t._app) || void 0 === i ? void 0 : i.options.projectId);
            const r = s.mockUserToken.sub || s.mockUserToken.user_id;
            if (!r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $70fd6868680e912c$var$V(r);
        }
        t._authCredentials = new $70fd6868680e912c$var$j(new $70fd6868680e912c$var$G(e, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $70fd6868680e912c$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n){
        this.converter = e, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = t;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(t) {
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, t, this._key);
    }
}
/**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $70fd6868680e912c$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n){
        this.converter = e, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = t;
    }
    withConverter(t) {
        return new $70fd6868680e912c$export$62297b13309008b2(this.firestore, t, this._query);
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $70fd6868680e912c$export$ab5a1a47940a200e extends $70fd6868680e912c$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(t, e, n){
        super(t, e, $70fd6868680e912c$var$Gn(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const t = this._path.popLast();
        return t.isEmpty() ? null : new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(t));
    }
    withConverter(t) {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, t, this._path);
    }
}
function $70fd6868680e912c$export$bf5175b0c24981cd(t, e, ...n) {
    if (t = (0, $gMVVg.getModularInstance)(t), $70fd6868680e912c$var$nh("collection", "path", e), t instanceof $70fd6868680e912c$var$hh) {
        const s = $70fd6868680e912c$var$ut.fromString(e, ...n);
        return $70fd6868680e912c$var$rh(s), new $70fd6868680e912c$export$ab5a1a47940a200e(t, /* converter= */ null, s);
    }
    {
        if (!(t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const s = t._path.child($70fd6868680e912c$var$ut.fromString(e, ...n));
        return $70fd6868680e912c$var$rh(s), new $70fd6868680e912c$export$ab5a1a47940a200e(t.firestore, /* converter= */ null, s);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $70fd6868680e912c$export$473d82a73f88c107(t, e) {
    if (t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$var$hh), $70fd6868680e912c$var$nh("collectionGroup", "collection id", e), e.indexOf("/") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid collection ID '${e}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $70fd6868680e912c$export$62297b13309008b2(t, /* converter= */ null, function(t) {
        return new $70fd6868680e912c$var$Un($70fd6868680e912c$var$ut.emptyPath(), t);
    }(e));
}
function $70fd6868680e912c$export$2a111da947c407d2(t, e, ...n) {
    if (t = (0, $gMVVg.getModularInstance)(t), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (e = $70fd6868680e912c$var$tt.A()), $70fd6868680e912c$var$nh("doc", "path", e), t instanceof $70fd6868680e912c$var$hh) {
        const s = $70fd6868680e912c$var$ut.fromString(e, ...n);
        return $70fd6868680e912c$var$ih(s), new $70fd6868680e912c$export$6be62b059fb12175(t, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(s));
    }
    {
        if (!(t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const s = t._path.child($70fd6868680e912c$var$ut.fromString(e, ...n));
        return $70fd6868680e912c$var$ih(s), new $70fd6868680e912c$export$6be62b059fb12175(t.firestore, t instanceof $70fd6868680e912c$export$ab5a1a47940a200e ? t.converter : null, new $70fd6868680e912c$export$afc2e57c475b7810(s));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$62a32f2da6187d11(t, e) {
    return t = (0, $gMVVg.getModularInstance)(t), e = (0, $gMVVg.getModularInstance)(e), (t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && (e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && t.firestore === e.firestore && t.path === e.path && t.converter === e.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$49b1d0de6ba30f41(t, e) {
    return t = (0, $gMVVg.getModularInstance)(t), e = (0, $gMVVg.getModularInstance)(e), t instanceof $70fd6868680e912c$export$62297b13309008b2 && e instanceof $70fd6868680e912c$export$62297b13309008b2 && t.firestore === e.firestore && $70fd6868680e912c$var$Zn(t._query, e._query) && t.converter === e.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Ih {
    constructor(){
        // The last promise in the queue.
        this.Gc = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Qc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.jc = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.zc = [], // visible for testing
        this.Wc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Hc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Jc = !1, // List of TimerIds to fast-forward delays for.
        this.Yc = [], // Backoff timer used to schedule retries for retryable operations
        this.qo = new $70fd6868680e912c$var$Bu(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Xc = ()=>{
            const t = $70fd6868680e912c$var$Ou();
            t && $70fd6868680e912c$var$N("AsyncQueue", "Visibility state changed to " + t.visibilityState), this.qo.Mo();
        };
        const t = $70fd6868680e912c$var$Ou();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.Xc);
    }
    get isShuttingDown() {
        return this.jc;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(t);
    }
    enqueueAndForgetEvenWhileRestricted(t) {
        this.Zc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.ta(t);
    }
    enterRestrictedMode(t) {
        if (!this.jc) {
            this.jc = !0, this.Jc = t || !1;
            const e = $70fd6868680e912c$var$Ou();
            e && "function" == typeof e.removeEventListener && e.removeEventListener("visibilitychange", this.Xc);
        }
    }
    enqueue(t) {
        if (this.Zc(), this.jc) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const e = new $70fd6868680e912c$var$K;
        return this.ta(()=>this.jc && this.Jc ? Promise.resolve() : (t().then(e.resolve, e.reject), e.promise)).then(()=>e.promise);
    }
    enqueueRetryable(t) {
        this.enqueueAndForget(()=>(this.Qc.push(t), this.ea()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async ea() {
        if (0 !== this.Qc.length) {
            try {
                await this.Qc[0](), this.Qc.shift(), this.qo.reset();
            } catch (t) {
                if (!$70fd6868680e912c$var$Dt(t)) throw t;
                // Failure will be handled by AsyncQueue
                $70fd6868680e912c$var$N("AsyncQueue", "Operation failed with retryable error: " + t);
            }
            this.Qc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.qo.No(()=>this.ea());
        }
    }
    ta(t) {
        const e = this.Gc.then(()=>(this.Hc = !0, t().catch((t)=>{
                this.Wc = t, this.Hc = !1;
                const e = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function(t) {
                    let e = t.message || "";
                    t.stack && (e = t.stack.includes(t.message) ? t.stack : t.message + "\n" + t.stack);
                    return e;
                }(t);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $70fd6868680e912c$var$k("INTERNAL UNHANDLED ERROR: ", e), t;
            }).then((t)=>(this.Hc = !1, t))));
        return this.Gc = e, e;
    }
    enqueueAfterDelay(t, e, n) {
        this.Zc(), // Fast-forward delays for timerIds that have been overriden.
        this.Yc.indexOf(t) > -1 && (e = 0);
        const s = $70fd6868680e912c$var$Tc.createAndSchedule(this, t, e, n, (t)=>this.na(t));
        return this.zc.push(s), s;
    }
    Zc() {
        this.Wc && $70fd6868680e912c$var$O();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async sa() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let t;
        do t = this.Gc, await t;
        while (t !== this.Gc);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ ia(t) {
        for (const e of this.zc)if (e.timerId === t) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ ra(t) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.sa().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            this.zc.sort((t, e)=>t.targetTimeMs - e.targetTimeMs);
            for (const e of this.zc)if (e.skipDelay(), "all" /* TimerId.All */  !== t && e.timerId === t) break;
            return this.sa();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ oa(t) {
        this.Yc.push(t);
    }
    /** Called once a DelayedOperation is run or canceled. */ na(t) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const e = this.zc.indexOf(t);
        this.zc.splice(e, 1);
    }
}
function $70fd6868680e912c$var$Th(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function(t, e) {
        if ("object" != typeof t || null === t) return !1;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return !0;
        return !1;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
class $70fd6868680e912c$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $70fd6868680e912c$var$K, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(t, e, n) {
        this._progressObserver = {
            next: t,
            error: e,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(t) {
        return this._taskCompletionResolver.promise.catch(t);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(t, e) {
        return this._taskCompletionResolver.promise.then(t, e);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(t) {
        this._updateProgress(t), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(t);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(t) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(t), this._taskCompletionResolver.reject(t);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(t) {
        this._lastProgress = t, this._progressObserver.next && this._progressObserver.next(t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $70fd6868680e912c$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $70fd6868680e912c$export$d0e2b3272814ce82 extends $70fd6868680e912c$var$hh {
    /** @hideconstructor */ constructor(t, e, n, s){
        super(t, e, n, s), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $70fd6868680e912c$var$Ih, this._persistenceKey = (null == s ? void 0 : s.name) || "[DEFAULT]";
    }
    _terminate() {
        return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
        // usage throws an exception.
        $70fd6868680e912c$var$Vh(this), this._firestoreClient.terminate();
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $70fd6868680e912c$export$9061557f3e3b42f9(t, e, n) {
    n || (n = "(default)");
    const s = (0, $7xvHX._getProvider)(t, "firestore");
    if (s.isInitialized(n)) {
        const t = s.getImmediate({
            identifier: n
        }), i = s.getOptions(n);
        if ((0, $gMVVg.deepEqual)(i, e)) return t;
        throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== e.cacheSizeBytes && void 0 !== e.localCache) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== e.cacheSizeBytes && -1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return s.initialize({
        options: e,
        instanceIdentifier: n
    });
}
function $70fd6868680e912c$export$f06a05d14c3a6678(e, n) {
    const s = "object" == typeof e ? e : (0, $7xvHX.getApp)(), i = "string" == typeof e ? e : n || "(default)", r = (0, $7xvHX._getProvider)(s, "firestore").getImmediate({
        identifier: i
    });
    if (!r._initialized) {
        const t = (0, $gMVVg.getDefaultEmulatorHostnameAndPort)("firestore");
        t && $70fd6868680e912c$export$966a03d25297d115(r, ...t);
    }
    return r;
}
/**
 * @internal
 */ function $70fd6868680e912c$export$8da5fbea04405656(t) {
    return t._firestoreClient || $70fd6868680e912c$var$Vh(t), t._firestoreClient.verifyNotTerminated(), t._firestoreClient;
}
function $70fd6868680e912c$var$Vh(t) {
    var e, n, s;
    const i = t._freezeSettings(), r = function(t, e, n, s) {
        return new $70fd6868680e912c$var$$e(t, e, n, s.host, s.ssl, s.experimentalForceLongPolling, s.experimentalAutoDetectLongPolling, $70fd6868680e912c$var$th(s.experimentalLongPollingOptions), s.useFetchStreams);
    }(t._databaseId, (null === (e = t._app) || void 0 === e ? void 0 : e.options.appId) || "", t._persistenceKey, i);
    t._firestoreClient = new $70fd6868680e912c$var$xa(t._authCredentials, t._appCheckCredentials, t._queue, r), (null === (n = i.cache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (s = i.cache) || void 0 === s ? void 0 : s._onlineComponentProvider) && (t._firestoreClient._uninitializedComponentsProvider = {
        _offlineKind: i.cache.kind,
        _offline: i.cache._offlineComponentProvider,
        _online: i.cache._onlineComponentProvider
    });
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * Must be called before any other functions (other than
 * {@link initializeFirestore}, {@link (getFirestore:1)} or
 * {@link clearIndexedDbPersistence}.
 *
 * If this fails, `enableIndexedDbPersistence()` will reject the promise it
 * returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * Persistence cannot be used in a Node.js environment.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.cache` to an instance of `IndexedDbLocalCache` to
 * turn on IndexedDb cache. Calling this function when `FirestoreSettings.cache`
 * is already specified will throw an exception.
 */ function $70fd6868680e912c$export$cebe3b626a79c5f3(t, e) {
    $70fd6868680e912c$var$Bh(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82));
    const n = $70fd6868680e912c$export$8da5fbea04405656(t);
    if (n._uninitializedComponentsProvider) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "SDK cache is already specified.");
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const s = t._freezeSettings(), i = new $70fd6868680e912c$var$Pa;
    return $70fd6868680e912c$var$Ch(n, i, new $70fd6868680e912c$var$va(i, s.cacheSizeBytes, null == e ? void 0 : e.forceOwnership));
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * If this fails, `enableMultiTabIndexedDbPersistence()` will reject the promise
 * it returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.cache` to an instance of `IndexedDbLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.cache`
 * is already specified will throw an exception.
 */ function $70fd6868680e912c$export$6d4c055e91302ab9(t) {
    $70fd6868680e912c$var$Bh(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82));
    const e = $70fd6868680e912c$export$8da5fbea04405656(t);
    if (e._uninitializedComponentsProvider) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "SDK cache is already specified.");
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = t._freezeSettings(), s = new $70fd6868680e912c$var$Pa;
    return $70fd6868680e912c$var$Ch(e, s, new $70fd6868680e912c$var$Ra(s, n.cacheSizeBytes));
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $70fd6868680e912c$var$Ch(t, e, n) {
    const s = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueue(async ()=>{
        try {
            await $70fd6868680e912c$var$Na(t, n), await $70fd6868680e912c$var$ka(t, e), s.resolve();
        } catch (t) {
            const e = t;
            if (!$70fd6868680e912c$var$Ma(e)) throw e;
            $70fd6868680e912c$export$86cd73f49cc6e0bb("Error enabling indexeddb cache. Falling back to memory cache: " + e), s.reject(e);
        }
    }).then(()=>s.promise);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $70fd6868680e912c$export$b4f5899b4e28cf7b(t) {
    if (t._initialized && !t._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const e = new $70fd6868680e912c$var$K;
    return t._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function(t) {
                if (!$70fd6868680e912c$var$bt.D()) return Promise.resolve();
                const e = t + "main";
                await $70fd6868680e912c$var$bt.delete(e);
            }($70fd6868680e912c$var$Zo(t._databaseId, t._persistenceKey)), e.resolve();
        } catch (t) {
            e.reject(t);
        }
    }), e.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $70fd6868680e912c$export$50b5113fd6653025(t) {
    return function(t) {
        const e = new $70fd6868680e912c$var$K;
        return t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$Zc(await $70fd6868680e912c$var$qa(t), e)), e.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $70fd6868680e912c$export$ee6bdee8287ecc5f(t) {
    return $70fd6868680e912c$var$Ga($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $70fd6868680e912c$export$f35b708ad73d52eb(t) {
    return $70fd6868680e912c$var$Qa($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $70fd6868680e912c$export$9aff22d1ec357a14(t) {
    return (0, $7xvHX._removeServiceInstance)(t.app, "firestore", t._databaseId.database), t._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $70fd6868680e912c$export$4b8b93c690c9810b(t, e) {
    const n = $70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), s = new $70fd6868680e912c$export$6cac12425252ec14;
    return $70fd6868680e912c$var$Ya(n, t._databaseId, e, s), s;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $70fd6868680e912c$export$169d2c6fe0f7f4ea(t, e) {
    return $70fd6868680e912c$var$Xa($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), e).then((e)=>e ? new $70fd6868680e912c$export$62297b13309008b2(t, null, e.query) : null);
}
function $70fd6868680e912c$var$Bh(t) {
    if (t._initialized || t._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $70fd6868680e912c$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param _aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(// TODO (sum/avg) make aggregateType public when the feature is supported
    t = "count", e){
        this._aggregateType = t, this._internalFieldPath = e, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField";
    }
}
/**
 * The results of executing an aggregation query.
 */ class $70fd6868680e912c$export$40257fef64be808b {
    /** @hideconstructor */ constructor(t, e, n){
        this._userDataWriter = e, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = t;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $70fd6868680e912c$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(t){
        this._byteString = t;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(t) {
        try {
            return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$var$Ve.fromBase64String(t));
        } catch (t) {
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + t);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(t) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$var$Ve.fromUint8Array(t));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(t) {
        return this._byteString.isEqual(t._byteString);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $70fd6868680e912c$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...t){
        for(let e = 0; e < t.length; ++e)if (0 === t[e].length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $70fd6868680e912c$export$b7871852b967eaf1(t);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(t) {
        return this._internalPath.isEqual(t._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $70fd6868680e912c$export$bf6e62266977b8eb() {
    return new $70fd6868680e912c$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $70fd6868680e912c$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(t){
        this._methodName = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $70fd6868680e912c$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(t, e){
        if (!isFinite(t) || t < -90 || t > 90) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
        if (!isFinite(e) || e < -180 || e > 180) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e);
        this._lat = t, this._long = e;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(t) {
        return this._lat === t._lat && this._long === t._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(t) {
        return $70fd6868680e912c$var$et(this._lat, t._lat) || $70fd6868680e912c$var$et(this._long, t._long);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$zh = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $70fd6868680e912c$var$Wh {
    constructor(t, e, n){
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
    toMutation(t, e) {
        return null !== this.fieldMask ? new $70fd6868680e912c$var$zs(t, this.data, this.fieldMask, e, this.fieldTransforms) : new $70fd6868680e912c$var$js(t, this.data, e, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $70fd6868680e912c$var$Hh {
    constructor(t, // The fieldMask does not include document transforms.
    e, n){
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
    toMutation(t, e) {
        return new $70fd6868680e912c$var$zs(t, this.data, this.fieldMask, e, this.fieldTransforms);
    }
}
function $70fd6868680e912c$var$Jh(t) {
    switch(t){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $70fd6868680e912c$var$O();
    }
}
/** A "context" object passed around while parsing user data. */ class $70fd6868680e912c$var$Yh {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(t, e, n, s, i, r){
        this.settings = t, this.databaseId = e, this.serializer = n, this.ignoreUndefinedProperties = s, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.ua(), this.fieldTransforms = i || [], this.fieldMask = r || [];
    }
    get path() {
        return this.settings.path;
    }
    get ca() {
        return this.settings.ca;
    }
    /** Returns a new context with the specified settings overwritten. */ aa(t) {
        return new $70fd6868680e912c$var$Yh(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    ha(t) {
        var e;
        const n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), s = this.aa({
            path: n,
            la: !1
        });
        return s.fa(t), s;
    }
    da(t) {
        var e;
        const n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), s = this.aa({
            path: n,
            la: !1
        });
        return s.ua(), s;
    }
    wa(t) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.aa({
            path: void 0,
            la: !0
        });
    }
    _a(t) {
        return $70fd6868680e912c$var$gl(t, this.settings.methodName, this.settings.ma || !1, this.path, this.settings.ga);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(t) {
        return void 0 !== this.fieldMask.find((e)=>t.isPrefixOf(e)) || void 0 !== this.fieldTransforms.find((e)=>t.isPrefixOf(e.field));
    }
    ua() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let t = 0; t < this.path.length; t++)this.fa(this.path.get(t));
    }
    fa(t) {
        if (0 === t.length) throw this._a("Document fields must not be empty");
        if ($70fd6868680e912c$var$Jh(this.ca) && $70fd6868680e912c$var$zh.test(t)) throw this._a('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $70fd6868680e912c$var$Xh {
    constructor(t, e, n){
        this.databaseId = t, this.ignoreUndefinedProperties = e, this.serializer = n || $70fd6868680e912c$var$Fu(t);
    }
    /** Creates a new top-level parse context. */ ya(t, e, n, s = !1) {
        return new $70fd6868680e912c$var$Yh({
            ca: t,
            methodName: e,
            ga: n,
            path: $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(),
            la: !1,
            ma: s
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $70fd6868680e912c$var$Zh(t) {
    const e = t._freezeSettings(), n = $70fd6868680e912c$var$Fu(t._databaseId);
    return new $70fd6868680e912c$var$Xh(t._databaseId, !!e.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $70fd6868680e912c$var$tl(t, e, n, s, i, r = {}) {
    const o = t.ya(r.merge || r.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , e, n, i);
    $70fd6868680e912c$var$dl("Data must be an object, but it was:", o, s);
    const u = $70fd6868680e912c$var$ll(s, o);
    let c, a;
    if (r.merge) c = new $70fd6868680e912c$var$Re(o.fieldMask), a = o.fieldTransforms;
    else if (r.mergeFields) {
        const t = [];
        for (const s of r.mergeFields){
            const i = $70fd6868680e912c$var$wl(e, s, n);
            if (!o.contains(i)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $70fd6868680e912c$var$yl(t, i) || t.push(i);
        }
        c = new $70fd6868680e912c$var$Re(t), a = o.fieldTransforms.filter((t)=>c.covers(t.field));
    } else c = null, a = o.fieldTransforms;
    return new $70fd6868680e912c$var$Wh(new $70fd6868680e912c$var$un(u), c, a);
}
class $70fd6868680e912c$var$el extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        if (2 /* UserDataSource.MergeSet */  !== t.ca) throw 1 /* UserDataSource.Update */  === t.ca ? t._a(`${this._methodName}() can only appear at the top level of your update data`) : t._a(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return t.fieldMask.push(t.path), null;
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$var$el;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $70fd6868680e912c$var$nl(t, e, n) {
    return new $70fd6868680e912c$var$Yh({
        ca: 3 /* UserDataSource.Argument */ ,
        ga: e.settings.ga,
        methodName: t._methodName,
        la: n
    }, e.databaseId, e.serializer, e.ignoreUndefinedProperties);
}
class $70fd6868680e912c$var$sl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        return new $70fd6868680e912c$var$Ms(t.path, new $70fd6868680e912c$var$bs);
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$var$sl;
    }
}
class $70fd6868680e912c$var$il extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.pa = e;
    }
    _toFieldTransform(t) {
        const e = $70fd6868680e912c$var$nl(this, t, /*array=*/ !0), n = this.pa.map((t)=>$70fd6868680e912c$var$hl(t, e)), s = new $70fd6868680e912c$var$Vs(n);
        return new $70fd6868680e912c$var$Ms(t.path, s);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
}
class $70fd6868680e912c$var$rl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.pa = e;
    }
    _toFieldTransform(t) {
        const e = $70fd6868680e912c$var$nl(this, t, /*array=*/ !0), n = this.pa.map((t)=>$70fd6868680e912c$var$hl(t, e)), s = new $70fd6868680e912c$var$Ds(n);
        return new $70fd6868680e912c$var$Ms(t.path, s);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
}
class $70fd6868680e912c$var$ol extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.Ia = e;
    }
    _toFieldTransform(t) {
        const e = new $70fd6868680e912c$var$xs(t.serializer, $70fd6868680e912c$var$Es(t.serializer, this.Ia));
        return new $70fd6868680e912c$var$Ms(t.path, e);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
}
/** Parse update data from an update() call. */ function $70fd6868680e912c$var$ul(t, e, n, s) {
    const i = t.ya(1 /* UserDataSource.Update */ , e, n);
    $70fd6868680e912c$var$dl("Data must be an object, but it was:", i, s);
    const r = [], o = $70fd6868680e912c$var$un.empty();
    $70fd6868680e912c$var$ge(s, (t, s)=>{
        const u = $70fd6868680e912c$var$ml(e, t, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        s = (0, $gMVVg.getModularInstance)(s);
        const c = i.da(u);
        if (s instanceof $70fd6868680e912c$var$el) // Add it to the field mask, but don't add anything to updateData.
        r.push(u);
        else {
            const t = $70fd6868680e912c$var$hl(s, c);
            null != t && (r.push(u), o.set(u, t));
        }
    });
    const u = new $70fd6868680e912c$var$Re(r);
    return new $70fd6868680e912c$var$Hh(o, u, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $70fd6868680e912c$var$cl(t, e, n, s, i, r) {
    const o = t.ya(1 /* UserDataSource.Update */ , e, n), u = [
        $70fd6868680e912c$var$wl(e, s, n)
    ], c = [
        i
    ];
    if (r.length % 2 != 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Function ${e}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let t = 0; t < r.length; t += 2)u.push($70fd6868680e912c$var$wl(e, r[t])), c.push(r[t + 1]);
    const a = [], h = $70fd6868680e912c$var$un.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let t = u.length - 1; t >= 0; --t)if (!$70fd6868680e912c$var$yl(a, u[t])) {
        const e = u[t];
        let n = c[t];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $gMVVg.getModularInstance)(n);
        const s = o.da(e);
        if (n instanceof $70fd6868680e912c$var$el) // Add it to the field mask, but don't add anything to updateData.
        a.push(e);
        else {
            const t = $70fd6868680e912c$var$hl(n, s);
            null != t && (a.push(e), h.set(e, t));
        }
    }
    const l = new $70fd6868680e912c$var$Re(a);
    return new $70fd6868680e912c$var$Hh(h, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $70fd6868680e912c$var$al(t, e, n, s = !1) {
    return $70fd6868680e912c$var$hl(n, t.ya(s ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , e));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $70fd6868680e912c$var$hl(t, e) {
    if ($70fd6868680e912c$var$fl(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    t = (0, $gMVVg.getModularInstance)(t))) return $70fd6868680e912c$var$dl("Unsupported field value:", e, t), $70fd6868680e912c$var$ll(t, e);
    if (t instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function(t, e) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$70fd6868680e912c$var$Jh(e.ca)) throw e._a(`${t._methodName}() can only be used with update() and set()`);
        if (!e.path) throw e._a(`${t._methodName}() is not currently supported inside arrays`);
        const n = t._toFieldTransform(e);
        n && e.fieldTransforms.push(n);
    }(t, e), null;
    if (void 0 === t && e.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    e.path && e.fieldMask.push(e.path), t instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (e.settings.la && 4 /* UserDataSource.ArrayArgument */  !== e.ca) throw e._a("Nested arrays are not supported");
        return function(t, e) {
            const n = [];
            let s = 0;
            for (const i of t){
                let t = $70fd6868680e912c$var$hl(i, e.wa(s));
                null == t && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (t = {
                    nullValue: "NULL_VALUE"
                }), n.push(t), s++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(t, e);
    }
    return function(t, e) {
        if (null === (t = (0, $gMVVg.getModularInstance)(t))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof t) return $70fd6868680e912c$var$Es(e.serializer, t);
        if ("boolean" == typeof t) return {
            booleanValue: t
        };
        if ("string" == typeof t) return {
            stringValue: t
        };
        if (t instanceof Date) {
            const n = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromDate(t);
            return {
                timestampValue: $70fd6868680e912c$var$Di(e.serializer, n)
            };
        }
        if (t instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
            return {
                timestampValue: $70fd6868680e912c$var$Di(e.serializer, n)
            };
        }
        if (t instanceof $70fd6868680e912c$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: t.latitude,
                longitude: t.longitude
            }
        };
        if (t instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $70fd6868680e912c$var$Ci(e.serializer, t._byteString)
        };
        if (t instanceof $70fd6868680e912c$export$6be62b059fb12175) {
            const n = e.databaseId, s = t.firestore._databaseId;
            if (!s.isEqual(n)) throw e._a(`Document reference is for database ${s.projectId}/${s.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $70fd6868680e912c$var$ki(t.firestore._databaseId || e.databaseId, t._key.path)
            };
        }
        throw e._a(`Unsupported field value: ${$70fd6868680e912c$var$oh(t)}`);
    }(t, e);
}
function $70fd6868680e912c$var$ll(t, e) {
    const n = {};
    return $70fd6868680e912c$var$ye(t) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    e.path && e.path.length > 0 && e.fieldMask.push(e.path) : $70fd6868680e912c$var$ge(t, (t, s)=>{
        const i = $70fd6868680e912c$var$hl(s, e.ha(t));
        null != i && (n[t] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $70fd6868680e912c$var$fl(t) {
    return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430 || t instanceof $70fd6868680e912c$export$f9f719d1b6419c4 || t instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1 || t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d);
}
function $70fd6868680e912c$var$dl(t, e, n) {
    if (!$70fd6868680e912c$var$fl(n) || !function(t) {
        return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
    }(n)) {
        const s = $70fd6868680e912c$var$oh(n);
        throw "an object" === s ? e._a(t + " a custom object") : e._a(t + " " + s);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $70fd6868680e912c$var$wl(t, e, n) {
    if (// If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (e = (0, $gMVVg.getModularInstance)(e)) instanceof $70fd6868680e912c$export$a1a8fea822d17659) return e._internalPath;
    if ("string" == typeof e) return $70fd6868680e912c$var$ml(t, e);
    throw $70fd6868680e912c$var$gl("Field path arguments must be of type string or ", t, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $70fd6868680e912c$var$_l = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $70fd6868680e912c$var$ml(t, e, n) {
    if (e.search($70fd6868680e912c$var$_l) >= 0) throw $70fd6868680e912c$var$gl(`Invalid field path (${e}). Paths must not contain '~', '*', '/', '[', or ']'`, t, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $70fd6868680e912c$export$a1a8fea822d17659(...e.split("."))._internalPath;
    } catch (s) {
        throw $70fd6868680e912c$var$gl(`Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, t, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $70fd6868680e912c$var$gl(t, e, n, s, i) {
    const r = s && !s.isEmpty(), o = void 0 !== i;
    let u = `Function ${e}() called with invalid data`;
    n && (u += " (via `toFirestore()`)"), u += ". ";
    let c = "";
    return (r || o) && (c += " (found", r && (c += ` in field ${s}`), o && (c += ` in document ${i}`), c += ")"), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, u + t + c);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $70fd6868680e912c$var$yl(t, e) {
    return t.some((t)=>t.isEqual(e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$var$pl {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, s, i){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = s, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $70fd6868680e912c$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $70fd6868680e912c$var$Il(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field($70fd6868680e912c$var$Tl("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$var$Il extends $70fd6868680e912c$var$pl {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $70fd6868680e912c$var$Tl(t, e) {
    return "string" == typeof e ? $70fd6868680e912c$var$ml(t, e) : e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? e._internalPath : e._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$El(t) {
    if ("L" /* LimitType.Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $70fd6868680e912c$var$Al {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $70fd6868680e912c$export$b0e86f2c7431df4e extends $70fd6868680e912c$var$Al {
}
function $70fd6868680e912c$export$2fa187e846a241c4(t, e, ...n) {
    let s = [];
    e instanceof $70fd6868680e912c$var$Al && s.push(e), s = s.concat(n), function(t) {
        const e = t.filter((t)=>t instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2).length, n = t.filter((t)=>t instanceof $70fd6868680e912c$export$f765fc5789dfd439).length;
        if (e > 1 || e > 0 && n > 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(s);
    for (const e of s)t = e._apply(t);
    return t;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $70fd6868680e912c$export$f765fc5789dfd439 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e, n){
        super(), this._field = t, this._op = e, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(t, e, n) {
        return new $70fd6868680e912c$export$f765fc5789dfd439(t, e, n);
    }
    _apply(t) {
        const e = this._parse(t);
        return $70fd6868680e912c$var$Ql(t._query, e), new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, $70fd6868680e912c$var$Yn(t._query, e));
    }
    _parse(t) {
        const e = $70fd6868680e912c$var$Zh(t.firestore), n = function(t, e, n, s, i, r, o) {
            let u;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === r || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid Query. You can't perform '${r}' queries on documentId().`);
                if ("in" /* Operator.IN */  === r || "not-in" /* Operator.NOT_IN */  === r) {
                    $70fd6868680e912c$var$Gl(o, r);
                    const e = [];
                    for (const n of o)e.push($70fd6868680e912c$var$Kl(s, t, n));
                    u = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else u = $70fd6868680e912c$var$Kl(s, t, o);
            } else "in" /* Operator.IN */  !== r && "not-in" /* Operator.NOT_IN */  !== r && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== r || $70fd6868680e912c$var$Gl(o, r), u = $70fd6868680e912c$var$al(n, e, o, /* allowArrays= */ "in" /* Operator.IN */  === r || "not-in" /* Operator.NOT_IN */  === r);
            return $70fd6868680e912c$var$mn.create(i, r, u);
        }(t._query, "where", e, t.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $70fd6868680e912c$export$9c59b80dda569a6e(t, e, n) {
    const s = e, i = $70fd6868680e912c$var$Tl("where", t);
    return $70fd6868680e912c$export$f765fc5789dfd439._create(i, s, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $70fd6868680e912c$export$6bbc7aef0717f3d2 extends $70fd6868680e912c$var$Al {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e){
        super(), this.type = t, this._queryConstraints = e;
    }
    static _create(t, e) {
        return new $70fd6868680e912c$export$6bbc7aef0717f3d2(t, e);
    }
    _parse(t) {
        const e = this._queryConstraints.map((e)=>e._parse(t)).filter((t)=>t.getFilters().length > 0);
        return 1 === e.length ? e[0] : $70fd6868680e912c$var$gn.create(e, this._getOperator());
    }
    _apply(t) {
        const e = this._parse(t);
        return 0 === e.getFilters().length ? t : (function(t, e) {
            let n = t;
            const s = e.getFlattenedFilters();
            for (const t of s)$70fd6868680e912c$var$Ql(n, t), n = $70fd6868680e912c$var$Yn(n, t);
        }(t._query, e), new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, $70fd6868680e912c$var$Yn(t._query, e)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$252bb8b3bbdf6749(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$70fd6868680e912c$var$zl("or", t)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , t);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$21c0ac7fe1cef1b8(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$70fd6868680e912c$var$zl("and", t)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , t);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $70fd6868680e912c$export$65a9ba8bbd6ed9e3 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e){
        super(), this._field = t, this._direction = e, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(t, e) {
        return new $70fd6868680e912c$export$65a9ba8bbd6ed9e3(t, e);
    }
    _apply(t) {
        const e = function(t, e, n) {
            if (null !== t.startAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const s = new $70fd6868680e912c$var$dn(e, n);
            return function(t, e) {
                if (null === $70fd6868680e912c$var$jn(t)) {
                    // This is the first order by. It must match any inequality.
                    const n = $70fd6868680e912c$var$zn(t);
                    null !== n && $70fd6868680e912c$var$jl(t, n, e.field);
                }
            }(t, s), s;
        }(t._query, this._field, this._direction);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = t.explicitOrderBy.concat([
                e
            ]);
            return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, n, t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
        }(t._query, e));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $70fd6868680e912c$export$f18af21d6f4dafd8(t, e = "asc") {
    const n = e, s = $70fd6868680e912c$var$Tl("orderBy", t);
    return $70fd6868680e912c$export$65a9ba8bbd6ed9e3._create(s, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $70fd6868680e912c$export$49bb5356ca788047 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._limit = e, this._limitType = n;
    }
    static _create(t, e, n) {
        return new $70fd6868680e912c$export$49bb5356ca788047(t, e, n);
    }
    _apply(t) {
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, $70fd6868680e912c$var$Xn(t._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$ee37e834aaad6f7e(t) {
    return $70fd6868680e912c$var$ch("limit", t), $70fd6868680e912c$export$49bb5356ca788047._create("limit", t, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$f823b3589f69d3b8(t) {
    return $70fd6868680e912c$var$ch("limitToLast", t), $70fd6868680e912c$export$49bb5356ca788047._create("limitToLast", t, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $70fd6868680e912c$export$d92e2830aca1d816 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $70fd6868680e912c$export$d92e2830aca1d816(t, e, n);
    }
    _apply(t) {
        const e = $70fd6868680e912c$var$Ul(t, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, e, t.endAt);
        }(t._query, e));
    }
}
function $70fd6868680e912c$export$859941c5fc8eba6b(...t) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAt", t, /*inclusive=*/ !0);
}
function $70fd6868680e912c$export$dd8dee5f7b804673(...t) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAfter", t, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $70fd6868680e912c$export$fd1782fd870d1e06 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $70fd6868680e912c$export$fd1782fd870d1e06(t, e, n);
    }
    _apply(t) {
        const e = $70fd6868680e912c$var$Ul(t, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, e);
        }(t._query, e));
    }
}
function $70fd6868680e912c$export$57203950645b8b11(...t) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endBefore", t, /*inclusive=*/ !1);
}
function $70fd6868680e912c$export$28ec54a8428bdb3f(...t) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $70fd6868680e912c$var$Ul(t, e, n, s) {
    if (n[0] = (0, $gMVVg.getModularInstance)(n[0]), n[0] instanceof $70fd6868680e912c$var$pl) return function(t, e, n, s, i) {
        if (!s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const r = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $70fd6868680e912c$var$Hn(t))if (n.field.isKeyField()) r.push($70fd6868680e912c$var$We(e, s.key));
        else {
            const t = s.data.field(n.field);
            if ($70fd6868680e912c$var$Ne(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            r.push(t);
        }
        return new $70fd6868680e912c$var$hn(r, i);
    }(t._query, t.firestore._databaseId, e, n[0]._document, s);
    {
        const i = $70fd6868680e912c$var$Zh(t.firestore);
        return function(t, e, n, s, i, r) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (i.length > o.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Too many arguments provided to ${s}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const u = [];
            for(let r = 0; r < i.length; r++){
                const c = i[r];
                if (o[r].field.isKeyField()) {
                    if ("string" != typeof c) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${s}(), but got a ${typeof c}`);
                    if (!$70fd6868680e912c$var$Wn(t) && -1 !== c.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${s}() must be a plain document ID, but '${c}' contains a slash.`);
                    const n = t.path.child($70fd6868680e912c$var$ut.fromString(c));
                    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(n)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${s}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $70fd6868680e912c$export$afc2e57c475b7810(n);
                    u.push($70fd6868680e912c$var$We(e, i));
                } else {
                    const t = $70fd6868680e912c$var$al(n, s, c);
                    u.push(t);
                }
            }
            return new $70fd6868680e912c$var$hn(u, r);
        }(t._query, t.firestore._databaseId, i, e, n, s);
    }
}
function $70fd6868680e912c$var$Kl(t, e, n) {
    if ("string" == typeof (n = (0, $gMVVg.getModularInstance)(n))) {
        if ("" === n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$70fd6868680e912c$var$Wn(e) && -1 !== n.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const s = e.path.child($70fd6868680e912c$var$ut.fromString(n));
        if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(s)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${s}' is not because it has an odd number of segments (${s.length}).`);
        return $70fd6868680e912c$var$We(t, new $70fd6868680e912c$export$afc2e57c475b7810(s));
    }
    if (n instanceof $70fd6868680e912c$export$6be62b059fb12175) return $70fd6868680e912c$var$We(t, n._key);
    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$70fd6868680e912c$var$oh(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $70fd6868680e912c$var$Gl(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $70fd6868680e912c$var$Ql(t, e) {
    if (e.isInequality()) {
        const n = $70fd6868680e912c$var$zn(t), s = e.field;
        if (null !== n && !n.isEqual(s)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. All where filters with an inequality (<, <=, !=, not-in, >, or >=) must be on the same field. But you have inequality filters on '${n.toString()}' and '${s.toString()}'`);
        const i = $70fd6868680e912c$var$jn(t);
        null !== i && $70fd6868680e912c$var$jl(t, s, i);
    }
    const n = function(t, e) {
        for (const n of t)for (const t of n.getFlattenedFilters())if (e.indexOf(t.op) >= 0) return t.op;
        return null;
    }(t.filters, function(t) {
        switch(t){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(e.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === e.op ? new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $70fd6868680e912c$var$jl(t, e, n) {
    if (!n.isEqual(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. You have a where filter with an inequality (<, <=, !=, not-in, >, or >=) on field '${e.toString()}' and so you must also use '${e.toString()}' as your first argument to orderBy(), but your first orderBy() is on field '${n.toString()}' instead.`);
}
function $70fd6868680e912c$var$zl(t, e) {
    if (!(e instanceof $70fd6868680e912c$export$f765fc5789dfd439 || e instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Function ${t}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    convertValue(t, e = "none") {
        switch($70fd6868680e912c$var$Le(t)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return t.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $70fd6868680e912c$var$Ce(t.integerValue || t.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(t.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(t, e);
            case 5 /* TypeOrder.StringValue */ :
                return t.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($70fd6868680e912c$var$xe(t.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(t.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(t.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(t.arrayValue, e);
            case 10 /* TypeOrder.ObjectValue */ :
                return this.convertObject(t.mapValue, e);
            default:
                throw $70fd6868680e912c$var$O();
        }
    }
    convertObject(t, e) {
        return this.convertObjectMap(t.fields, e);
    }
    /**
     * @internal
     */ convertObjectMap(t, e = "none") {
        const n = {};
        return $70fd6868680e912c$var$ge(t, (t, s)=>{
            n[t] = this.convertValue(s, e);
        }), n;
    }
    convertGeoPoint(t) {
        return new $70fd6868680e912c$export$f9f719d1b6419c4($70fd6868680e912c$var$Ce(t.latitude), $70fd6868680e912c$var$Ce(t.longitude));
    }
    convertArray(t, e) {
        return (t.values || []).map((t)=>this.convertValue(t, e));
    }
    convertServerTimestamp(t, e) {
        switch(e){
            case "previous":
                const n = $70fd6868680e912c$var$ke(t);
                return null == n ? null : this.convertValue(n, e);
            case "estimate":
                return this.convertTimestamp($70fd6868680e912c$var$Me(t));
            default:
                return null;
        }
    }
    convertTimestamp(t) {
        const e = $70fd6868680e912c$var$De(t);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }
    convertDocumentKey(t, e) {
        const n = $70fd6868680e912c$var$ut.fromString(t);
        $70fd6868680e912c$var$F($70fd6868680e912c$var$ur(n));
        const s = new $70fd6868680e912c$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $70fd6868680e912c$export$afc2e57c475b7810(n.popFirst(5));
        return s.isEqual(e) || // TODO(b/64130202): Somehow support foreign references.
        $70fd6868680e912c$var$k(`Document ${i} contains a document reference within a different database (${s.projectId}/${s.database}) which is not supported. It will be treated as a reference in the current database (${e.projectId}/${e.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $70fd6868680e912c$var$Hl(t, e, n) {
    let s;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return s = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, s;
}
class $70fd6868680e912c$var$Jl extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, e);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$8a63f25cc62965f1(t) {
    return new $70fd6868680e912c$export$fada2345be8928cf("sum", $70fd6868680e912c$var$wl("sum", t));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$cc6710ee5f037d57(t) {
    return new $70fd6868680e912c$export$fada2345be8928cf("avg", $70fd6868680e912c$var$wl("average", t));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$85b9a36db797e02b() {
    return new $70fd6868680e912c$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$31fa8ec66e0239ad(t, e) {
    var n, s;
    return t instanceof $70fd6868680e912c$export$fada2345be8928cf && e instanceof $70fd6868680e912c$export$fada2345be8928cf && t._aggregateType === e._aggregateType && (null === (n = t._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (s = e._internalFieldPath) || void 0 === s ? void 0 : s.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $70fd6868680e912c$export$104f59389a332076(t, e) {
    return $70fd6868680e912c$export$49b1d0de6ba30f41(t.query, e.query) && (0, $gMVVg.deepEqual)(t.data(), e.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $70fd6868680e912c$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$export$acab0e6ef25eb301 extends $70fd6868680e912c$var$pl {
    /** @hideconstructor protected */ constructor(t, e, n, s, i, r){
        super(t, e, n, s, r), this._firestore = t, this._firestoreImpl = t, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field($70fd6868680e912c$var$Tl("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$export$6d4d04e42af6b03c extends $70fd6868680e912c$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $70fd6868680e912c$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(t, e, n, s){
        this._firestore = t, this._userDataWriter = e, this._snapshot = s, this.metadata = new $70fd6868680e912c$export$99d61448206ab5cd(s.hasPendingWrites, s.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $70fd6868680e912c$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>{
                    const s = new $70fd6868680e912c$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, n.doc.key, n.doc, new $70fd6868680e912c$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: s,
                        oldIndex: -1,
                        newIndex: e++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* ChangeType.Metadata */  !== t.type).map((e)=>{
                    const s = new $70fd6868680e912c$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $70fd6868680e912c$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let i = -1, r = -1;
                    return 0 /* ChangeType.Added */  !== e.type && (i = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* ChangeType.Removed */  !== e.type && (n = n.add(e.doc), r = n.indexOf(e.doc.key)), {
                        type: $70fd6868680e912c$var$uf(e.type),
                        doc: s,
                        oldIndex: i,
                        newIndex: r
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
}
function $70fd6868680e912c$var$uf(t) {
    switch(t){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $70fd6868680e912c$var$O();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $70fd6868680e912c$export$f243a5d948512846(t, e) {
    return t instanceof $70fd6868680e912c$export$acab0e6ef25eb301 && e instanceof $70fd6868680e912c$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $70fd6868680e912c$export$8f21149d8133945c && e instanceof $70fd6868680e912c$export$8f21149d8133945c && t._firestore === e._firestore && $70fd6868680e912c$export$49b1d0de6ba30f41(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$11eb3b5ef9574821(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$za($70fd6868680e912c$export$8da5fbea04405656(e), t._key).then((n)=>$70fd6868680e912c$var$Af(e, t, n));
}
class $70fd6868680e912c$var$hf extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, e);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$a58bd92642f7fb58(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$hf(e);
    return $70fd6868680e912c$var$ja(n, t._key).then((n)=>new $70fd6868680e912c$export$acab0e6ef25eb301(e, s, t._key, n, new $70fd6868680e912c$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$35dd759aed9686b4(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$za($70fd6868680e912c$export$8da5fbea04405656(e), t._key, {
        source: "server"
    }).then((n)=>$70fd6868680e912c$var$Af(e, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$81d3477bd73c86ef(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$hf(e);
    return $70fd6868680e912c$var$El(t._query), $70fd6868680e912c$var$Ha(n, t._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(e, s, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$3fd010f18eac1dd(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$hf(e);
    return $70fd6868680e912c$var$Wa(n, t._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(e, s, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$ec7d9e44f349c77b(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$hf(e);
    return $70fd6868680e912c$var$Ha(n, t._query, {
        source: "server"
    }).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(e, s, t, n));
}
function $70fd6868680e912c$export$5ff77ddaff3c9e12(t, e, n) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const s = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), i = $70fd6868680e912c$var$Hl(t.converter, e, n);
    return $70fd6868680e912c$export$1945f8fec9dda613(s, [
        $70fd6868680e912c$var$tl($70fd6868680e912c$var$Zh(s), "setDoc", t._key, i, null !== t.converter, n).toMutation(t._key, $70fd6868680e912c$var$Fs.none())
    ]);
}
function $70fd6868680e912c$export$22d1fdd1e73faff2(t, e, n, ...s) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const i = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), r = $70fd6868680e912c$var$Zh(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, $gMVVg.getModularInstance)(e)) || e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$cl(r, "updateDoc", t._key, e, n, s) : $70fd6868680e912c$var$ul(r, "updateDoc", t._key, e);
    return $70fd6868680e912c$export$1945f8fec9dda613(i, [
        o.toMutation(t._key, $70fd6868680e912c$var$Fs.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a4f20481fae8f78b(t) {
    return $70fd6868680e912c$export$1945f8fec9dda613($70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), [
        new $70fd6868680e912c$var$Ys(t._key, $70fd6868680e912c$var$Fs.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a13890143fb1c2dd(t, e) {
    const n = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), s = $70fd6868680e912c$export$2a111da947c407d2(t), i = $70fd6868680e912c$var$Hl(t.converter, e);
    return $70fd6868680e912c$export$1945f8fec9dda613(n, [
        $70fd6868680e912c$var$tl($70fd6868680e912c$var$Zh(t.firestore), "addDoc", s._key, i, null !== t.converter, {}).toMutation(s._key, $70fd6868680e912c$var$Fs.exists(!1))
    ]).then(()=>s);
}
function $70fd6868680e912c$export$d36370812fb26935(t, ...e) {
    var n, s, i;
    t = (0, $gMVVg.getModularInstance)(t);
    let r = {
        includeMetadataChanges: !1
    }, o = 0;
    "object" != typeof e[o] || $70fd6868680e912c$var$Th(e[o]) || (r = e[o], o++);
    const u = {
        includeMetadataChanges: r.includeMetadataChanges
    };
    if ($70fd6868680e912c$var$Th(e[o])) {
        const t = e[o];
        e[o] = null === (n = t.next) || void 0 === n ? void 0 : n.bind(t), e[o + 1] = null === (s = t.error) || void 0 === s ? void 0 : s.bind(t), e[o + 2] = null === (i = t.complete) || void 0 === i ? void 0 : i.bind(t);
    }
    let c, a, h;
    if (t instanceof $70fd6868680e912c$export$6be62b059fb12175) a = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), h = $70fd6868680e912c$var$Gn(t._key.path), c = {
        next: (n)=>{
            e[o] && e[o]($70fd6868680e912c$var$Af(a, t, n));
        },
        error: e[o + 1],
        complete: e[o + 2]
    };
    else {
        const n = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
        a = $70fd6868680e912c$export$572106fb5803752c(n.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), h = n._query;
        const s = new $70fd6868680e912c$var$hf(a);
        c = {
            next: (t)=>{
                e[o] && e[o](new $70fd6868680e912c$export$8f21149d8133945c(a, s, n, t));
            },
            error: e[o + 1],
            complete: e[o + 2]
        }, $70fd6868680e912c$var$El(t._query);
    }
    return function(t, e, n, s) {
        const i = new $70fd6868680e912c$var$Va(s), r = new $70fd6868680e912c$var$Nc(e, i, n);
        return t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$Vc(await $70fd6868680e912c$var$Ka(t), r)), ()=>{
            i.Dc(), t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$Sc(await $70fd6868680e912c$var$Ka(t), r));
        };
    }($70fd6868680e912c$export$8da5fbea04405656(a), h, u, c);
}
function $70fd6868680e912c$export$9dff4f5aba83e348(t, e) {
    return $70fd6868680e912c$var$Ja($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), $70fd6868680e912c$var$Th(e) ? e : {
        next: e
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $70fd6868680e912c$export$1945f8fec9dda613(t, e) {
    return function(t, e) {
        const n = new $70fd6868680e912c$var$K;
        return t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$zc(await $70fd6868680e912c$var$qa(t), e, n)), n.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(t), e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $70fd6868680e912c$var$Af(t, e, n) {
    const s = n.docs.get(e._key), i = new $70fd6868680e912c$var$hf(t);
    return new $70fd6868680e912c$export$acab0e6ef25eb301(t, i, e._key, s, new $70fd6868680e912c$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), e.converter);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query,
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can even
 * count the documents if the result set would be prohibitively large to
 * download entirely (e.g. thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used: every request using this source necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size to calculate.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $70fd6868680e912c$export$b1de1b12889d0afb(t) {
    return $70fd6868680e912c$export$a51511de2fae49b3(t, {
        count: $70fd6868680e912c$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query, without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, is downloaded. This
 * function can even perform aggregations of the documents if the result set
 * would be prohibitively large to download entirely (e.g. thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used: every request using this source necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set to aggregate over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$a51511de2fae49b3(t, e) {
    const n = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), s = $70fd6868680e912c$export$8da5fbea04405656(n), i = function(t, e) {
        const n = [];
        for(const s in t)Object.prototype.hasOwnProperty.call(t, s) && n.push(e(t[s], s, t));
        return n;
    }(e, (t, e)=>new $70fd6868680e912c$var$ni(e, t._aggregateType, t._internalFieldPath));
    // Run the aggregation and convert the results
    return (function(t, e, n) {
        const s = new $70fd6868680e912c$var$K;
        return t.asyncQueue.enqueueAndForget(async ()=>{
            // TODO (sum/avg) should we update this to use the event manager?
            // Implement and call executeAggregateQueryViaSnapshotListener, similar
            // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
            // above
            try {
                // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
                const i = await $70fd6868680e912c$var$Ua(t);
                s.resolve($70fd6868680e912c$var$Gu(i, e, n));
            } catch (t) {
                s.reject(t);
            }
        }), s.promise;
    })(s, t._query, i).then((e)=>/**
 * Converts the core aggregration result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function(t, e, n) {
            const s = new $70fd6868680e912c$var$hf(t);
            return new $70fd6868680e912c$export$40257fef64be808b(e, s, n);
        })(n, t, e));
}
class $70fd6868680e912c$var$Pf {
    constructor(t){
        this.kind = "memory", this._onlineComponentProvider = new $70fd6868680e912c$var$Pa, (null == t ? void 0 : t.garbageCollector) ? this._offlineComponentProvider = t.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = new $70fd6868680e912c$var$Ea;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$bf {
    constructor(t){
        let e;
        this.kind = "persistent", (null == t ? void 0 : t.tabManager) ? (t.tabManager._initialize(t), e = t.tabManager) : (e = $70fd6868680e912c$export$d5f96a3c009e86ac(void 0), e._initialize(t)), this._onlineComponentProvider = e._onlineComponentProvider, this._offlineComponentProvider = e._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$Vf {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = new $70fd6868680e912c$var$Ea;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$Sf {
    constructor(t){
        this.kind = "memoryLru", this._offlineComponentProvider = new $70fd6868680e912c$var$Aa(t);
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $70fd6868680e912c$export$574728f3be606189() {
    return new $70fd6868680e912c$var$Vf;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $70fd6868680e912c$export$2340f88905cc0c23(t) {
    return new $70fd6868680e912c$var$Sf(null == t ? void 0 : t.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $70fd6868680e912c$export$72ef71adb739a32c(t) {
    return new $70fd6868680e912c$var$Pf(t);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $70fd6868680e912c$export$51b321e43d5331d5(t) {
    return new $70fd6868680e912c$var$bf(t);
}
class $70fd6868680e912c$var$kf {
    constructor(t){
        this.forceOwnership = t, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = new $70fd6868680e912c$var$Pa, this._offlineComponentProvider = new $70fd6868680e912c$var$va(this._onlineComponentProvider, null == t ? void 0 : t.cacheSizeBytes, this.forceOwnership);
    }
}
class $70fd6868680e912c$var$Mf {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = new $70fd6868680e912c$var$Pa, this._offlineComponentProvider = new $70fd6868680e912c$var$Ra(this._onlineComponentProvider, null == t ? void 0 : t.cacheSizeBytes);
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $70fd6868680e912c$export$d5f96a3c009e86ac(t) {
    return new $70fd6868680e912c$var$kf(null == t ? void 0 : t.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $70fd6868680e912c$export$57e9d290b0b4dc04() {
    return new $70fd6868680e912c$var$Mf;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Ff = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $70fd6868680e912c$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = $70fd6868680e912c$var$Zh(t);
    }
    set(t, e, n) {
        this._verifyNotCommitted();
        const s = $70fd6868680e912c$var$Lf(t, this._firestore), i = $70fd6868680e912c$var$Hl(s.converter, e, n), r = $70fd6868680e912c$var$tl(this._dataReader, "WriteBatch.set", s._key, i, null !== s.converter, n);
        return this._mutations.push(r.toMutation(s._key, $70fd6868680e912c$var$Fs.none())), this;
    }
    update(t, e, n, ...s) {
        this._verifyNotCommitted();
        const i = $70fd6868680e912c$var$Lf(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let r;
        return r = "string" == typeof (e = (0, $gMVVg.getModularInstance)(e)) || e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$cl(this._dataReader, "WriteBatch.update", i._key, e, n, s) : $70fd6868680e912c$var$ul(this._dataReader, "WriteBatch.update", i._key, e), this._mutations.push(r.toMutation(i._key, $70fd6868680e912c$var$Fs.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $70fd6868680e912c$var$Lf(t, this._firestore);
        return this._mutations = this._mutations.concat(new $70fd6868680e912c$var$Ys(e._key, $70fd6868680e912c$var$Fs.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $70fd6868680e912c$var$Lf(t, e) {
    if ((t = (0, $gMVVg.getModularInstance)(t)).firestore !== e) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $70fd6868680e912c$export$febc5573c75cefb0 extends class {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = $70fd6868680e912c$var$Zh(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $70fd6868680e912c$var$Lf(t, this._firestore), n = new $70fd6868680e912c$var$Jl(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return $70fd6868680e912c$var$O();
            const s = t[0];
            if (s.isFoundDocument()) return new $70fd6868680e912c$var$pl(this._firestore, n, s.key, s, e.converter);
            if (s.isNoDocument()) return new $70fd6868680e912c$var$pl(this._firestore, n, e._key, null, e.converter);
            throw $70fd6868680e912c$var$O();
        });
    }
    set(t, e, n) {
        const s = $70fd6868680e912c$var$Lf(t, this._firestore), i = $70fd6868680e912c$var$Hl(s.converter, e, n), r = $70fd6868680e912c$var$tl(this._dataReader, "Transaction.set", s._key, i, null !== s.converter, n);
        return this._transaction.set(s._key, r), this;
    }
    update(t, e, n, ...s) {
        const i = $70fd6868680e912c$var$Lf(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let r;
        return r = "string" == typeof (e = (0, $gMVVg.getModularInstance)(e)) || e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$cl(this._dataReader, "Transaction.update", i._key, e, n, s) : $70fd6868680e912c$var$ul(this._dataReader, "Transaction.update", i._key, e), this._transaction.update(i._key, r), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $70fd6868680e912c$var$Lf(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
} {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $70fd6868680e912c$var$Lf(t, this._firestore), n = new $70fd6868680e912c$var$hf(this._firestore);
        return super.get(t).then((t)=>new $70fd6868680e912c$export$acab0e6ef25eb301(this._firestore, n, e._key, t._document, new $70fd6868680e912c$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), e.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $70fd6868680e912c$export$3c54e006bf9c93b7(t, e, n) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82);
    const s = Object.assign(Object.assign({}, $70fd6868680e912c$var$Ff), n);
    !function(t) {
        if (t.maxAttempts < 1) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(s);
    return function(t, e, n) {
        const s = new $70fd6868680e912c$var$K;
        return t.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $70fd6868680e912c$var$Ua(t);
            new $70fd6868680e912c$var$Ca(t.asyncQueue, i, n, e, s).run();
        }), s.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(t), (n)=>e(new $70fd6868680e912c$export$febc5573c75cefb0(t, n)), s);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $70fd6868680e912c$export$2bbad96c62fdba3e() {
    return new $70fd6868680e912c$var$el("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $70fd6868680e912c$export$3ff8e7e00c3264b7() {
    return new $70fd6868680e912c$var$sl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $70fd6868680e912c$export$f62af892fd92610c(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$il("arrayUnion", t);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$30a014203d0d7e4f(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$rl("arrayRemove", t);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$a2647aa13413c947(t) {
    return new $70fd6868680e912c$var$ol("increment", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $70fd6868680e912c$export$44cd1c9d57edd9b1(t) {
    return $70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), new $70fd6868680e912c$export$d94ed661b1cfd435(t, (e)=>$70fd6868680e912c$export$1945f8fec9dda613(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$export$ff1663c0c1304f1a(t, e) {
    var n;
    const s = $70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82));
    if (!s._uninitializedComponentsProvider || "memory" === (null === (n = s._uninitializedComponentsProvider) || void 0 === n ? void 0 : n._offlineKind)) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $70fd6868680e912c$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const i = function(t) {
        const e = "string" == typeof t ? function(t) {
            try {
                return JSON.parse(t);
            } catch (t) {
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == t ? void 0 : t.message));
            }
        }(t) : t, n = [];
        if (Array.isArray(e.indexes)) for (const t of e.indexes){
            const e = $70fd6868680e912c$var$Jf(t, "collectionGroup"), s = [];
            if (Array.isArray(t.fields)) for (const e of t.fields){
                const t = $70fd6868680e912c$var$ml("setIndexConfiguration", $70fd6868680e912c$var$Jf(e, "fieldPath"));
                "CONTAINS" === e.arrayConfig ? s.push(new $70fd6868680e912c$var$_t(t, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === e.order ? s.push(new $70fd6868680e912c$var$_t(t, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === e.order && s.push(new $70fd6868680e912c$var$_t(t, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $70fd6868680e912c$var$lt($70fd6868680e912c$var$lt.UNKNOWN_ID, e, s, $70fd6868680e912c$var$gt.empty()));
        }
        return n;
    }(e);
    return $70fd6868680e912c$var$Za(s, i);
}
function $70fd6868680e912c$var$Jf(t, e) {
    if ("string" != typeof t[e]) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function(t, e = !0) {
    !function(t) {
        $70fd6868680e912c$var$S = t;
    }((0, $7xvHX.SDK_VERSION)), (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)("firestore", (t, { instanceIdentifier: n, options: s })=>{
        const i = t.getProvider("app").getImmediate(), r = new $70fd6868680e912c$export$d0e2b3272814ce82(new $70fd6868680e912c$var$z(t.getProvider("auth-internal")), new $70fd6868680e912c$var$Y(t.getProvider("app-check-internal")), function(t, e) {
            if (!Object.prototype.hasOwnProperty.apply(t.options, [
                "projectId"
            ])) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $70fd6868680e912c$export$4c3ccc07620ae30a(t.options.projectId, e);
        }(i, n), i);
        return s = Object.assign({
            useFetchStreams: e
        }, s), r._setSettings(s), r;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $7xvHX.registerVersion)($70fd6868680e912c$var$b, "3.13.0", t), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $7xvHX.registerVersion)($70fd6868680e912c$var$b, "3.13.0", "esm2017");
}();

});
parcelRegister("7xvHX", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", () => $57d436074e210fb5$export$c930050e7bb63965);
$parcel$export(module.exports, "_getProvider", () => $57d436074e210fb5$export$fa0d6da0f5838f50);
$parcel$export(module.exports, "_removeServiceInstance", () => $57d436074e210fb5$export$48d18de2ff1c45a5);
$parcel$export(module.exports, "SDK_VERSION", () => $57d436074e210fb5$export$31499a9cd224b78c);
$parcel$export(module.exports, "initializeApp", () => $57d436074e210fb5$export$c55cfd413944906d);
$parcel$export(module.exports, "getApp", () => $57d436074e210fb5$export$f9962582c9e66d99);
$parcel$export(module.exports, "registerVersion", () => $57d436074e210fb5$export$d29d5299a7137abc);

var $eryG9 = parcelRequire("eryG9");

var $5Z2ef = parcelRequire("5Z2ef");

var $gMVVg = parcelRequire("gMVVg");

var $iItpQ = parcelRequire("iItpQ");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($57d436074e210fb5$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $57d436074e210fb5$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $57d436074e210fb5$var$name$o = "@firebase/app";
const $57d436074e210fb5$var$version$1 = "0.9.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$logger = new (0, $5Z2ef.Logger)('@firebase/app');
const $57d436074e210fb5$var$name$n = "@firebase/app-compat";
const $57d436074e210fb5$var$name$m = "@firebase/analytics-compat";
const $57d436074e210fb5$var$name$l = "@firebase/analytics";
const $57d436074e210fb5$var$name$k = "@firebase/app-check-compat";
const $57d436074e210fb5$var$name$j = "@firebase/app-check";
const $57d436074e210fb5$var$name$i = "@firebase/auth";
const $57d436074e210fb5$var$name$h = "@firebase/auth-compat";
const $57d436074e210fb5$var$name$g = "@firebase/database";
const $57d436074e210fb5$var$name$f = "@firebase/database-compat";
const $57d436074e210fb5$var$name$e = "@firebase/functions";
const $57d436074e210fb5$var$name$d = "@firebase/functions-compat";
const $57d436074e210fb5$var$name$c = "@firebase/installations";
const $57d436074e210fb5$var$name$b = "@firebase/installations-compat";
const $57d436074e210fb5$var$name$a = "@firebase/messaging";
const $57d436074e210fb5$var$name$9 = "@firebase/messaging-compat";
const $57d436074e210fb5$var$name$8 = "@firebase/performance";
const $57d436074e210fb5$var$name$7 = "@firebase/performance-compat";
const $57d436074e210fb5$var$name$6 = "@firebase/remote-config";
const $57d436074e210fb5$var$name$5 = "@firebase/remote-config-compat";
const $57d436074e210fb5$var$name$4 = "@firebase/storage";
const $57d436074e210fb5$var$name$3 = "@firebase/storage-compat";
const $57d436074e210fb5$var$name$2 = "@firebase/firestore";
const $57d436074e210fb5$var$name$1 = "@firebase/firestore-compat";
const $57d436074e210fb5$var$name = "firebase";
const $57d436074e210fb5$var$version = "9.23.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $57d436074e210fb5$export$9f30fa0c10967f7f = '[DEFAULT]';
const $57d436074e210fb5$var$PLATFORM_LOG_STRING = {
    [$57d436074e210fb5$var$name$o]: 'fire-core',
    [$57d436074e210fb5$var$name$n]: 'fire-core-compat',
    [$57d436074e210fb5$var$name$l]: 'fire-analytics',
    [$57d436074e210fb5$var$name$m]: 'fire-analytics-compat',
    [$57d436074e210fb5$var$name$j]: 'fire-app-check',
    [$57d436074e210fb5$var$name$k]: 'fire-app-check-compat',
    [$57d436074e210fb5$var$name$i]: 'fire-auth',
    [$57d436074e210fb5$var$name$h]: 'fire-auth-compat',
    [$57d436074e210fb5$var$name$g]: 'fire-rtdb',
    [$57d436074e210fb5$var$name$f]: 'fire-rtdb-compat',
    [$57d436074e210fb5$var$name$e]: 'fire-fn',
    [$57d436074e210fb5$var$name$d]: 'fire-fn-compat',
    [$57d436074e210fb5$var$name$c]: 'fire-iid',
    [$57d436074e210fb5$var$name$b]: 'fire-iid-compat',
    [$57d436074e210fb5$var$name$a]: 'fire-fcm',
    [$57d436074e210fb5$var$name$9]: 'fire-fcm-compat',
    [$57d436074e210fb5$var$name$8]: 'fire-perf',
    [$57d436074e210fb5$var$name$7]: 'fire-perf-compat',
    [$57d436074e210fb5$var$name$6]: 'fire-rc',
    [$57d436074e210fb5$var$name$5]: 'fire-rc-compat',
    [$57d436074e210fb5$var$name$4]: 'fire-gcs',
    [$57d436074e210fb5$var$name$3]: 'fire-gcs-compat',
    [$57d436074e210fb5$var$name$2]: 'fire-fst',
    [$57d436074e210fb5$var$name$1]: 'fire-fst-compat',
    'fire-js': 'fire-js',
    [$57d436074e210fb5$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $57d436074e210fb5$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57d436074e210fb5$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $57d436074e210fb5$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $57d436074e210fb5$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $57d436074e210fb5$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $57d436074e210fb5$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($57d436074e210fb5$export$9566bce3835c0f28.has(componentName)) {
        $57d436074e210fb5$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $57d436074e210fb5$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $57d436074e210fb5$export$b4e3c36c855b14b5.values())$57d436074e210fb5$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $57d436074e210fb5$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $57d436074e210fb5$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    $57d436074e210fb5$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $57d436074e210fb5$export$3685d89b9c3cdfaf() {
    $57d436074e210fb5$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.'
};
const $57d436074e210fb5$var$ERROR_FACTORY = new (0, $gMVVg.ErrorFactory)('app', 'Firebase', $57d436074e210fb5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $eryG9.Component)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $57d436074e210fb5$export$31499a9cd224b78c = $57d436074e210fb5$var$version;
function $57d436074e210fb5$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $57d436074e210fb5$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $57d436074e210fb5$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $gMVVg.getDefaultAppConfig)());
    if (!options) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $gMVVg.deepEqual)(options, existingApp.options) && (0, $gMVVg.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $57d436074e210fb5$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $eryG9.ComponentContainer)(name);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseAppImpl(options, config, container);
    $57d436074e210fb5$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $57d436074e210fb5$export$f9962582c9e66d99(name = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    const app = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $57d436074e210fb5$export$9f30fa0c10967f7f && (0, $gMVVg.getDefaultAppConfig)()) return $57d436074e210fb5$export$c55cfd413944906d();
    if (!app) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $57d436074e210fb5$export$68ddedf7d44b3bdf() {
    return Array.from($57d436074e210fb5$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $57d436074e210fb5$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($57d436074e210fb5$export$b4e3c36c855b14b5.has(name)) {
        $57d436074e210fb5$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $57d436074e210fb5$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $57d436074e210fb5$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $57d436074e210fb5$var$logger.warn(warning.join(' '));
        return;
    }
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $eryG9.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $57d436074e210fb5$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $5Z2ef.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $57d436074e210fb5$export$c622e99c0ce7b1c9(logLevel) {
    (0, $5Z2ef.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$DB_NAME = 'firebase-heartbeat-database';
const $57d436074e210fb5$var$DB_VERSION = 1;
const $57d436074e210fb5$var$STORE_NAME = 'firebase-heartbeat-store';
let $57d436074e210fb5$var$dbPromise = null;
function $57d436074e210fb5$var$getDbPromise() {
    if (!$57d436074e210fb5$var$dbPromise) $57d436074e210fb5$var$dbPromise = (0, $iItpQ.openDB)($57d436074e210fb5$var$DB_NAME, $57d436074e210fb5$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($57d436074e210fb5$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $57d436074e210fb5$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $57d436074e210fb5$var$dbPromise;
}
async function $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const result = await db.transaction($57d436074e210fb5$var$STORE_NAME).objectStore($57d436074e210fb5$var$STORE_NAME).get($57d436074e210fb5$var$computeKey(app));
        return result;
    } catch (e) {
        if (e instanceof (0, $gMVVg.FirebaseError)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
async function $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($57d436074e210fb5$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $57d436074e210fb5$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $gMVVg.FirebaseError)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
function $57d436074e210fb5$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $57d436074e210fb5$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $57d436074e210fb5$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        const platformLogger = this.container.getProvider('platform-logger').getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $57d436074e210fb5$var$getUTCDateString();
        if (this._heartbeatsCache === null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return '';
        const date = $57d436074e210fb5$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $57d436074e210fb5$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $gMVVg.base64urlEncodeWithoutPadding)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $57d436074e210fb5$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $57d436074e210fb5$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $57d436074e210fb5$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $57d436074e210fb5$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $gMVVg.isIndexedDBAvailable)()) return false;
        else return (0, $gMVVg.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $57d436074e210fb5$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $gMVVg.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d436074e210fb5$var$registerCoreComponents(variant) {
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $eryG9.Component)('platform-logger', (container)=>new $57d436074e210fb5$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $eryG9.Component)('heartbeat', (container)=>new $57d436074e210fb5$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $57d436074e210fb5$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $57d436074e210fb5$var$registerCoreComponents('');

});
parcelRegister("eryG9", function(module, exports) {

$parcel$export(module.exports, "Component", () => $a83e7ccd68ca8d4e$export$16fa2f45be04daa8);
$parcel$export(module.exports, "ComponentContainer", () => $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5);

var $gMVVg = parcelRequire("gMVVg");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $a83e7ccd68ca8d4e$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $gMVVg.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($a83e7ccd68ca8d4e$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $a83e7ccd68ca8d4e$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $a83e7ccd68ca8d4e$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

});
parcelRegister("gMVVg", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", () => $c38e0f42709c826a$export$4b5284a3025a455);
$parcel$export(module.exports, "getDefaultEmulatorHostnameAndPort", () => $c38e0f42709c826a$export$a3febcf1f14a3a0c);
$parcel$export(module.exports, "getDefaultAppConfig", () => $c38e0f42709c826a$export$3dfb6827a9f89756);
$parcel$export(module.exports, "Deferred", () => $c38e0f42709c826a$export$85f6557964517f1a);
$parcel$export(module.exports, "createMockUserToken", () => $c38e0f42709c826a$export$367bf224123348f1);
$parcel$export(module.exports, "getUA", () => $c38e0f42709c826a$export$c36915b22ce77c19);
$parcel$export(module.exports, "isBrowserExtension", () => $c38e0f42709c826a$export$caa8774a9107a58e);
$parcel$export(module.exports, "isSafari", () => $c38e0f42709c826a$export$95df08bae54cb4df);
$parcel$export(module.exports, "isIndexedDBAvailable", () => $c38e0f42709c826a$export$3865db50535c2055);
$parcel$export(module.exports, "validateIndexedDBOpenable", () => $c38e0f42709c826a$export$a8a3018f3d187a4d);
$parcel$export(module.exports, "areCookiesEnabled", () => $c38e0f42709c826a$export$f172b7eb6cf60599);
$parcel$export(module.exports, "FirebaseError", () => $c38e0f42709c826a$export$dd24e9cd51226c56);
$parcel$export(module.exports, "ErrorFactory", () => $c38e0f42709c826a$export$3fa6e1b18a3b2d40);
$parcel$export(module.exports, "deepEqual", () => $c38e0f42709c826a$export$9cb4719e2e525b7a);
$parcel$export(module.exports, "calculateBackoffMillis", () => $c38e0f42709c826a$export$4d810c0ca64ed8e9);
$parcel$export(module.exports, "getModularInstance", () => $c38e0f42709c826a$export$4befe9b5fa509a1b);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $c38e0f42709c826a$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $c38e0f42709c826a$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $c38e0f42709c826a$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $c38e0f42709c826a$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $c38e0f42709c826a$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $c38e0f42709c826a$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $c38e0f42709c826a$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c38e0f42709c826a$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c38e0f42709c826a$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $c38e0f42709c826a$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $c38e0f42709c826a$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $c38e0f42709c826a$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $c38e0f42709c826a$var$stringToByteArray$1(str);
    return $c38e0f42709c826a$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $c38e0f42709c826a$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c38e0f42709c826a$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $c38e0f42709c826a$export$c62426fdd000a97e = function(str) {
    try {
        return $c38e0f42709c826a$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c38e0f42709c826a$export$6c40052bed430212(value) {
    return $c38e0f42709c826a$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c38e0f42709c826a$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c38e0f42709c826a$var$isValidKey(prop)) continue;
        target[prop] = $c38e0f42709c826a$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c38e0f42709c826a$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $c38e0f42709c826a$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$getDefaultsFromGlobal = ()=>$c38e0f42709c826a$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $c38e0f42709c826a$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $c38e0f42709c826a$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $c38e0f42709c826a$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $c38e0f42709c826a$export$212bb2fc580a90a8 = ()=>{
    try {
        return $c38e0f42709c826a$var$getDefaultsFromGlobal() || $c38e0f42709c826a$var$getDefaultsFromEnvVariable() || $c38e0f42709c826a$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $c38e0f42709c826a$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $c38e0f42709c826a$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $c38e0f42709c826a$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $c38e0f42709c826a$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $c38e0f42709c826a$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c38e0f42709c826a$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(header)),
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c38e0f42709c826a$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c38e0f42709c826a$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c38e0f42709c826a$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c38e0f42709c826a$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $c38e0f42709c826a$export$4e09c449d6c407f7() {
    return typeof self === 'object' && self.self === self;
}
function $c38e0f42709c826a$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c38e0f42709c826a$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $c38e0f42709c826a$export$f2f6a8999f8ebd30() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $c38e0f42709c826a$export$7e7b1a9668aaed8() {
    const ua = $c38e0f42709c826a$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c38e0f42709c826a$export$202944b2d2824246() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c38e0f42709c826a$export$5d1d834fbbf8bab7() {
    return $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c38e0f42709c826a$export$95df08bae54cb4df() {
    return !$c38e0f42709c826a$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c38e0f42709c826a$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c38e0f42709c826a$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c38e0f42709c826a$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $c38e0f42709c826a$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $c38e0f42709c826a$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $c38e0f42709c826a$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c38e0f42709c826a$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c38e0f42709c826a$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $c38e0f42709c826a$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $c38e0f42709c826a$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $c38e0f42709c826a$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $c38e0f42709c826a$var$replaceTemplate(template, data) {
    return template.replace($c38e0f42709c826a$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $c38e0f42709c826a$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c38e0f42709c826a$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c38e0f42709c826a$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[0]) || '');
        claims = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$5f870fcca7ae6a88 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$701c661ec91095f2 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $c38e0f42709c826a$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$fc970ed23da99565 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c38e0f42709c826a$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c38e0f42709c826a$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c38e0f42709c826a$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c38e0f42709c826a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($c38e0f42709c826a$var$isObject(aProp) && $c38e0f42709c826a$var$isObject(bProp)) {
            if (!$c38e0f42709c826a$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $c38e0f42709c826a$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $c38e0f42709c826a$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $c38e0f42709c826a$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c38e0f42709c826a$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c38e0f42709c826a$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c38e0f42709c826a$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $c38e0f42709c826a$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c38e0f42709c826a$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $c38e0f42709c826a$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $c38e0f42709c826a$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($c38e0f42709c826a$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $c38e0f42709c826a$var$noop;
        if (observer.error === undefined) observer.error = $c38e0f42709c826a$var$noop;
        if (observer.complete === undefined) observer.complete = $c38e0f42709c826a$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c38e0f42709c826a$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c38e0f42709c826a$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $c38e0f42709c826a$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $c38e0f42709c826a$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c38e0f42709c826a$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c38e0f42709c826a$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $c38e0f42709c826a$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $c38e0f42709c826a$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $c38e0f42709c826a$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $c38e0f42709c826a$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $c38e0f42709c826a$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $c38e0f42709c826a$export$abe4376e1bf796d6 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c38e0f42709c826a$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c38e0f42709c826a$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c38e0f42709c826a$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c38e0f42709c826a$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $c38e0f42709c826a$var$indicator(i);
}
function $c38e0f42709c826a$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});


parcelRegister("5Z2ef", function(module, exports) {

$parcel$export(module.exports, "LogLevel", () => $45b460d9de9b230f$export$243e62d78d3b544d);
$parcel$export(module.exports, "Logger", () => $45b460d9de9b230f$export$efa9a398d6368992);
$parcel$export(module.exports, "setLogLevel", () => $45b460d9de9b230f$export$c622e99c0ce7b1c9);
$parcel$export(module.exports, "setUserLogHandler", () => $45b460d9de9b230f$export$29577d29c84db5f6);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $45b460d9de9b230f$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $45b460d9de9b230f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($45b460d9de9b230f$export$243e62d78d3b544d || ($45b460d9de9b230f$export$243e62d78d3b544d = {}));
const $45b460d9de9b230f$var$levelStringToEnum = {
    'debug': $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG,
    'verbose': $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE,
    'info': $45b460d9de9b230f$export$243e62d78d3b544d.INFO,
    'warn': $45b460d9de9b230f$export$243e62d78d3b544d.WARN,
    'error': $45b460d9de9b230f$export$243e62d78d3b544d.ERROR,
    'silent': $45b460d9de9b230f$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $45b460d9de9b230f$var$defaultLogLevel = $45b460d9de9b230f$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $45b460d9de9b230f$var$ConsoleMethod = {
    [$45b460d9de9b230f$export$243e62d78d3b544d.DEBUG]: 'log',
    [$45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$45b460d9de9b230f$export$243e62d78d3b544d.INFO]: 'info',
    [$45b460d9de9b230f$export$243e62d78d3b544d.WARN]: 'warn',
    [$45b460d9de9b230f$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $45b460d9de9b230f$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $45b460d9de9b230f$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $45b460d9de9b230f$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $45b460d9de9b230f$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $45b460d9de9b230f$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $45b460d9de9b230f$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $45b460d9de9b230f$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $45b460d9de9b230f$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $45b460d9de9b230f$export$c622e99c0ce7b1c9(level) {
    $45b460d9de9b230f$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $45b460d9de9b230f$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $45b460d9de9b230f$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $45b460d9de9b230f$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $45b460d9de9b230f$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("iItpQ", function(module, exports) {

$parcel$export(module.exports, "openDB", () => $da032767b57a4aa4$export$ca0ed41b1a2af7e);

var $jMRra = parcelRequire("jMRra");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $jMRra.w)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $jMRra.w)(request.result), event.oldVersion, event.newVersion, (0, $jMRra.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $jMRra.w)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $da032767b57a4aa4$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $jMRra.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRegister("jMRra", function(module, exports) {

$parcel$export(module.exports, "w", () => $e67bf383372d72f4$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "r", () => $e67bf383372d72f4$export$43caf9889c228507);
const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);

});



parcelRegister("l0itG", function(module, exports) {

$parcel$export(module.exports, "createWebChannelTransport", () => $f4a7ee607ae1ef78$export$66869136fc133c3a);
$parcel$export(module.exports, "getStatEventTarget", () => $f4a7ee607ae1ef78$export$888d0d9ab79d08fc);
$parcel$export(module.exports, "ErrorCode", () => $f4a7ee607ae1ef78$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "EventType", () => $f4a7ee607ae1ef78$export$3d7865934588d77e);
$parcel$export(module.exports, "Event", () => $f4a7ee607ae1ef78$export$d61e24a684f9e51);
$parcel$export(module.exports, "Stat", () => $f4a7ee607ae1ef78$export$cbbc350c1dfc80cb);
$parcel$export(module.exports, "FetchXmlHttpFactory", () => $f4a7ee607ae1ef78$export$ddb1030448106742);
$parcel$export(module.exports, "WebChannel", () => $f4a7ee607ae1ef78$export$aa726fb96ad3e039);
$parcel$export(module.exports, "XhrIo", () => $f4a7ee607ae1ef78$export$26404658cda3ee02);
$parcel$export(module.exports, "Md5", () => $f4a7ee607ae1ef78$export$9f5a3dfc7a9f5dd);
$parcel$export(module.exports, "Integer", () => $f4a7ee607ae1ef78$export$70ffa26850098d01);
var $f4a7ee607ae1ef78$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $f4a7ee607ae1ef78$export$2e2bcd8739ae039 = {};
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $f4a7ee607ae1ef78$var$k, $f4a7ee607ae1ef78$var$goog = $f4a7ee607ae1ef78$var$goog || {}, $f4a7ee607ae1ef78$var$l = $f4a7ee607ae1ef78$var$commonjsGlobal || self;
function $f4a7ee607ae1ef78$var$aa(a) {
    var b = typeof a;
    b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
    return "array" == b || "object" == b && "number" == typeof a.length;
}
function $f4a7ee607ae1ef78$var$p(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
function $f4a7ee607ae1ef78$var$ba(a) {
    return Object.prototype.hasOwnProperty.call(a, $f4a7ee607ae1ef78$var$ca) && a[$f4a7ee607ae1ef78$var$ca] || (a[$f4a7ee607ae1ef78$var$ca] = ++$f4a7ee607ae1ef78$var$da);
}
var $f4a7ee607ae1ef78$var$ca = "closure_uid_" + (1E9 * Math.random() >>> 0), $f4a7ee607ae1ef78$var$da = 0;
function $f4a7ee607ae1ef78$var$ea(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $f4a7ee607ae1ef78$var$fa(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var e = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(e, d);
            return a.apply(b, e);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $f4a7ee607ae1ef78$var$q(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $f4a7ee607ae1ef78$var$q = $f4a7ee607ae1ef78$var$ea : $f4a7ee607ae1ef78$var$q = $f4a7ee607ae1ef78$var$fa;
    return $f4a7ee607ae1ef78$var$q.apply(null, arguments);
}
function $f4a7ee607ae1ef78$var$ha(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
    };
}
function $f4a7ee607ae1ef78$var$r(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.$ = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
    a.ac = function(d, e, f) {
        for(var h = Array(arguments.length - 2), n = 2; n < arguments.length; n++)h[n - 2] = arguments[n];
        return b.prototype[e].apply(d, h);
    };
}
function $f4a7ee607ae1ef78$var$v() {
    this.s = this.s;
    this.o = this.o;
}
var $f4a7ee607ae1ef78$var$ia = 0;
$f4a7ee607ae1ef78$var$v.prototype.s = !1;
$f4a7ee607ae1ef78$var$v.prototype.sa = function() {
    if (!this.s && (this.s = !0, this.N(), 0 != $f4a7ee607ae1ef78$var$ia)) $f4a7ee607ae1ef78$var$ba(this);
};
$f4a7ee607ae1ef78$var$v.prototype.N = function() {
    if (this.o) for(; this.o.length;)this.o.shift()();
};
const $f4a7ee607ae1ef78$var$ka = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(let c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
};
function $f4a7ee607ae1ef78$var$ma(a) {
    const b = a.length;
    if (0 < b) {
        const c = Array(b);
        for(let d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
}
function $f4a7ee607ae1ef78$var$na(a, b) {
    for(let c = 1; c < arguments.length; c++){
        const d = arguments[c];
        if ($f4a7ee607ae1ef78$var$aa(d)) {
            const e = a.length || 0, f = d.length || 0;
            a.length = e + f;
            for(let h = 0; h < f; h++)a[e + h] = d[h];
        } else a.push(d);
    }
}
function $f4a7ee607ae1ef78$var$w(a, b) {
    this.type = a;
    this.g = this.target = b;
    this.defaultPrevented = !1;
}
$f4a7ee607ae1ef78$var$w.prototype.h = function() {
    this.defaultPrevented = !0;
};
var $f4a7ee607ae1ef78$var$oa = function() {
    if (!$f4a7ee607ae1ef78$var$l.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        $f4a7ee607ae1ef78$var$l.addEventListener("test", ()=>{}, b), $f4a7ee607ae1ef78$var$l.removeEventListener("test", ()=>{}, b);
    } catch (c) {}
    return a;
}();
function $f4a7ee607ae1ef78$var$x(a) {
    return /^[\s\xa0]*$/.test(a);
}
function $f4a7ee607ae1ef78$var$pa() {
    var a = $f4a7ee607ae1ef78$var$l.navigator;
    return a && (a = a.userAgent) ? a : "";
}
function $f4a7ee607ae1ef78$var$y(a) {
    return -1 != $f4a7ee607ae1ef78$var$pa().indexOf(a);
}
function $f4a7ee607ae1ef78$var$qa(a) {
    $f4a7ee607ae1ef78$var$qa[" "](a);
    return a;
}
$f4a7ee607ae1ef78$var$qa[" "] = function() {};
function $f4a7ee607ae1ef78$var$ra(a, b) {
    var c = $f4a7ee607ae1ef78$var$sa;
    return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
}
var $f4a7ee607ae1ef78$var$ta = $f4a7ee607ae1ef78$var$y("Opera"), $f4a7ee607ae1ef78$var$z = $f4a7ee607ae1ef78$var$y("Trident") || $f4a7ee607ae1ef78$var$y("MSIE"), $f4a7ee607ae1ef78$var$ua = $f4a7ee607ae1ef78$var$y("Edge"), $f4a7ee607ae1ef78$var$va = $f4a7ee607ae1ef78$var$ua || $f4a7ee607ae1ef78$var$z, $f4a7ee607ae1ef78$var$wa = $f4a7ee607ae1ef78$var$y("Gecko") && !(-1 != $f4a7ee607ae1ef78$var$pa().toLowerCase().indexOf("webkit") && !$f4a7ee607ae1ef78$var$y("Edge")) && !($f4a7ee607ae1ef78$var$y("Trident") || $f4a7ee607ae1ef78$var$y("MSIE")) && !$f4a7ee607ae1ef78$var$y("Edge"), $f4a7ee607ae1ef78$var$xa = -1 != $f4a7ee607ae1ef78$var$pa().toLowerCase().indexOf("webkit") && !$f4a7ee607ae1ef78$var$y("Edge");
function $f4a7ee607ae1ef78$var$ya() {
    var a = $f4a7ee607ae1ef78$var$l.document;
    return a ? a.documentMode : void 0;
}
var $f4a7ee607ae1ef78$var$za;
a: {
    var $f4a7ee607ae1ef78$var$Aa = "", $f4a7ee607ae1ef78$var$Ba = function() {
        var a = $f4a7ee607ae1ef78$var$pa();
        if ($f4a7ee607ae1ef78$var$wa) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($f4a7ee607ae1ef78$var$ua) return /Edge\/([\d\.]+)/.exec(a);
        if ($f4a7ee607ae1ef78$var$z) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($f4a7ee607ae1ef78$var$xa) return /WebKit\/(\S+)/.exec(a);
        if ($f4a7ee607ae1ef78$var$ta) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $f4a7ee607ae1ef78$var$Ba && ($f4a7ee607ae1ef78$var$Aa = $f4a7ee607ae1ef78$var$Ba ? $f4a7ee607ae1ef78$var$Ba[1] : "");
    if ($f4a7ee607ae1ef78$var$z) {
        var $f4a7ee607ae1ef78$var$Ca = $f4a7ee607ae1ef78$var$ya();
        if (null != $f4a7ee607ae1ef78$var$Ca && $f4a7ee607ae1ef78$var$Ca > parseFloat($f4a7ee607ae1ef78$var$Aa)) {
            $f4a7ee607ae1ef78$var$za = String($f4a7ee607ae1ef78$var$Ca);
            break a;
        }
    }
    $f4a7ee607ae1ef78$var$za = $f4a7ee607ae1ef78$var$Aa;
}
var $f4a7ee607ae1ef78$var$Da;
if ($f4a7ee607ae1ef78$var$l.document && $f4a7ee607ae1ef78$var$z) {
    var $f4a7ee607ae1ef78$var$Ea = $f4a7ee607ae1ef78$var$ya();
    $f4a7ee607ae1ef78$var$Da = $f4a7ee607ae1ef78$var$Ea ? $f4a7ee607ae1ef78$var$Ea : parseInt($f4a7ee607ae1ef78$var$za, 10) || void 0;
} else $f4a7ee607ae1ef78$var$Da = void 0;
var $f4a7ee607ae1ef78$var$Fa = $f4a7ee607ae1ef78$var$Da;
function $f4a7ee607ae1ef78$var$A(a, b) {
    $f4a7ee607ae1ef78$var$w.call(this, a ? a.type : "");
    this.relatedTarget = this.g = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.state = null;
    this.pointerId = 0;
    this.pointerType = "";
    this.i = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        if (b = a.relatedTarget) {
            if ($f4a7ee607ae1ef78$var$wa) {
                a: {
                    try {
                        $f4a7ee607ae1ef78$var$qa(b.nodeName);
                        var e = !0;
                        break a;
                    } catch (f) {}
                    e = !1;
                }
                e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $f4a7ee607ae1ef78$var$Ga[a.pointerType] || "";
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && $f4a7ee607ae1ef78$var$A.$.h.call(this);
    }
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$A, $f4a7ee607ae1ef78$var$w);
var $f4a7ee607ae1ef78$var$Ga = {
    2: "touch",
    3: "pen",
    4: "mouse"
};
$f4a7ee607ae1ef78$var$A.prototype.h = function() {
    $f4a7ee607ae1ef78$var$A.$.h.call(this);
    var a = this.i;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var $f4a7ee607ae1ef78$var$Ha = "closure_listenable_" + (1E6 * Math.random() | 0);
var $f4a7ee607ae1ef78$var$Ia = 0;
function $f4a7ee607ae1ef78$var$Ja(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.la = e;
    this.key = ++$f4a7ee607ae1ef78$var$Ia;
    this.fa = this.ia = !1;
}
function $f4a7ee607ae1ef78$var$Ka(a) {
    a.fa = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.la = null;
}
function $f4a7ee607ae1ef78$var$Na(a, b, c) {
    for(const d in a)b.call(c, a[d], d, a);
}
function $f4a7ee607ae1ef78$var$Oa(a, b) {
    for(const c in a)b.call(void 0, a[c], c, a);
}
function $f4a7ee607ae1ef78$var$Pa(a) {
    const b = {};
    for(const c in a)b[c] = a[c];
    return b;
}
const $f4a7ee607ae1ef78$var$Qa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $f4a7ee607ae1ef78$var$Ra(a, b) {
    let c, d;
    for(let e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(let f = 0; f < $f4a7ee607ae1ef78$var$Qa.length; f++)c = $f4a7ee607ae1ef78$var$Qa[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $f4a7ee607ae1ef78$var$Sa(a) {
    this.src = a;
    this.g = {};
    this.h = 0;
}
$f4a7ee607ae1ef78$var$Sa.prototype.add = function(a, b, c, d, e) {
    var f = a.toString();
    a = this.g[f];
    a || (a = this.g[f] = [], this.h++);
    var h = $f4a7ee607ae1ef78$var$Ta(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.ia = !1)) : (b = new $f4a7ee607ae1ef78$var$Ja(b, this.src, f, !!d, e), b.ia = c, a.push(b));
    return b;
};
function $f4a7ee607ae1ef78$var$Ua(a, b) {
    var c = b.type;
    if (c in a.g) {
        var d = a.g[c], e = $f4a7ee607ae1ef78$var$ka(d, b), f;
        (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
        f && ($f4a7ee607ae1ef78$var$Ka(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
    }
}
function $f4a7ee607ae1ef78$var$Ta(a, b, c, d) {
    for(var e = 0; e < a.length; ++e){
        var f = a[e];
        if (!f.fa && f.listener == b && f.capture == !!c && f.la == d) return e;
    }
    return -1;
}
var $f4a7ee607ae1ef78$var$Va = "closure_lm_" + (1E6 * Math.random() | 0), $f4a7ee607ae1ef78$var$Wa = {};
function $f4a7ee607ae1ef78$var$Ya(a, b, c, d, e) {
    if (d && d.once) return $f4a7ee607ae1ef78$var$Za(a, b, c, d, e);
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$f4a7ee607ae1ef78$var$Ya(a, b[f], c, d, e);
        return null;
    }
    c = $f4a7ee607ae1ef78$var$$a(c);
    return a && a[$f4a7ee607ae1ef78$var$Ha] ? a.O(b, c, $f4a7ee607ae1ef78$var$p(d) ? !!d.capture : !!d, e) : $f4a7ee607ae1ef78$var$ab(a, b, c, !1, d, e);
}
function $f4a7ee607ae1ef78$var$ab(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = $f4a7ee607ae1ef78$var$p(e) ? !!e.capture : !!e, n = $f4a7ee607ae1ef78$var$bb(a);
    n || (a[$f4a7ee607ae1ef78$var$Va] = n = new $f4a7ee607ae1ef78$var$Sa(a));
    c = n.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = $f4a7ee607ae1ef78$var$cb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) $f4a7ee607ae1ef78$var$oa || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
    else if (a.attachEvent) a.attachEvent($f4a7ee607ae1ef78$var$db(b.toString()), d);
    else if (a.addListener && a.removeListener) a.addListener(d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
}
function $f4a7ee607ae1ef78$var$cb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    const b = $f4a7ee607ae1ef78$var$eb;
    return a;
}
function $f4a7ee607ae1ef78$var$Za(a, b, c, d, e) {
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$f4a7ee607ae1ef78$var$Za(a, b[f], c, d, e);
        return null;
    }
    c = $f4a7ee607ae1ef78$var$$a(c);
    return a && a[$f4a7ee607ae1ef78$var$Ha] ? a.P(b, c, $f4a7ee607ae1ef78$var$p(d) ? !!d.capture : !!d, e) : $f4a7ee607ae1ef78$var$ab(a, b, c, !0, d, e);
}
function $f4a7ee607ae1ef78$var$fb(a, b, c, d, e) {
    if (Array.isArray(b)) for(var f = 0; f < b.length; f++)$f4a7ee607ae1ef78$var$fb(a, b[f], c, d, e);
    else (d = $f4a7ee607ae1ef78$var$p(d) ? !!d.capture : !!d, c = $f4a7ee607ae1ef78$var$$a(c), a && a[$f4a7ee607ae1ef78$var$Ha]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = $f4a7ee607ae1ef78$var$Ta(f, c, d, e), -1 < c && ($f4a7ee607ae1ef78$var$Ka(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = $f4a7ee607ae1ef78$var$bb(a)) && (b = a.g[b.toString()], a = -1, b && (a = $f4a7ee607ae1ef78$var$Ta(b, c, d, e)), (c = -1 < a ? b[a] : null) && $f4a7ee607ae1ef78$var$gb(c));
}
function $f4a7ee607ae1ef78$var$gb(a) {
    if ("number" !== typeof a && a && !a.fa) {
        var b = a.src;
        if (b && b[$f4a7ee607ae1ef78$var$Ha]) $f4a7ee607ae1ef78$var$Ua(b.i, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($f4a7ee607ae1ef78$var$db(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            (c = $f4a7ee607ae1ef78$var$bb(b)) ? ($f4a7ee607ae1ef78$var$Ua(c, a), 0 == c.h && (c.src = null, b[$f4a7ee607ae1ef78$var$Va] = null)) : $f4a7ee607ae1ef78$var$Ka(a);
        }
    }
}
function $f4a7ee607ae1ef78$var$db(a) {
    return a in $f4a7ee607ae1ef78$var$Wa ? $f4a7ee607ae1ef78$var$Wa[a] : $f4a7ee607ae1ef78$var$Wa[a] = "on" + a;
}
function $f4a7ee607ae1ef78$var$eb(a, b) {
    if (a.fa) a = !0;
    else {
        b = new $f4a7ee607ae1ef78$var$A(b, this);
        var c = a.listener, d = a.la || a.src;
        a.ia && $f4a7ee607ae1ef78$var$gb(a);
        a = c.call(d, b);
    }
    return a;
}
function $f4a7ee607ae1ef78$var$bb(a) {
    a = a[$f4a7ee607ae1ef78$var$Va];
    return a instanceof $f4a7ee607ae1ef78$var$Sa ? a : null;
}
var $f4a7ee607ae1ef78$var$hb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $f4a7ee607ae1ef78$var$$a(a) {
    if ("function" === typeof a) return a;
    a[$f4a7ee607ae1ef78$var$hb] || (a[$f4a7ee607ae1ef78$var$hb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$f4a7ee607ae1ef78$var$hb];
}
function $f4a7ee607ae1ef78$var$B() {
    $f4a7ee607ae1ef78$var$v.call(this);
    this.i = new $f4a7ee607ae1ef78$var$Sa(this);
    this.S = this;
    this.J = null;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$B, $f4a7ee607ae1ef78$var$v);
$f4a7ee607ae1ef78$var$B.prototype[$f4a7ee607ae1ef78$var$Ha] = !0;
$f4a7ee607ae1ef78$var$B.prototype.removeEventListener = function(a, b, c, d) {
    $f4a7ee607ae1ef78$var$fb(this, a, b, c, d);
};
function $f4a7ee607ae1ef78$var$C(a, b) {
    var c, d = a.J;
    if (d) for(c = []; d; d = d.J)c.push(d);
    a = a.S;
    d = b.type || b;
    if ("string" === typeof b) b = new $f4a7ee607ae1ef78$var$w(b, a);
    else if (b instanceof $f4a7ee607ae1ef78$var$w) b.target = b.target || a;
    else {
        var e = b;
        b = new $f4a7ee607ae1ef78$var$w(d, a);
        $f4a7ee607ae1ef78$var$Ra(b, e);
    }
    e = !0;
    if (c) for(var f = c.length - 1; 0 <= f; f--){
        var h = b.g = c[f];
        e = $f4a7ee607ae1ef78$var$ib(h, d, !0, b) && e;
    }
    h = b.g = a;
    e = $f4a7ee607ae1ef78$var$ib(h, d, !0, b) && e;
    e = $f4a7ee607ae1ef78$var$ib(h, d, !1, b) && e;
    if (c) for(f = 0; f < c.length; f++)h = b.g = c[f], e = $f4a7ee607ae1ef78$var$ib(h, d, !1, b) && e;
}
$f4a7ee607ae1ef78$var$B.prototype.N = function() {
    $f4a7ee607ae1ef78$var$B.$.N.call(this);
    if (this.i) {
        var a = this.i, c;
        for(c in a.g){
            for(var d = a.g[c], e = 0; e < d.length; e++)$f4a7ee607ae1ef78$var$Ka(d[e]);
            delete a.g[c];
            a.h--;
        }
    }
    this.J = null;
};
$f4a7ee607ae1ef78$var$B.prototype.O = function(a, b, c, d) {
    return this.i.add(String(a), b, !1, c, d);
};
$f4a7ee607ae1ef78$var$B.prototype.P = function(a, b, c, d) {
    return this.i.add(String(a), b, !0, c, d);
};
function $f4a7ee607ae1ef78$var$ib(a, b, c, d) {
    b = a.i.g[String(b)];
    if (!b) return !0;
    b = b.concat();
    for(var e = !0, f = 0; f < b.length; ++f){
        var h = b[f];
        if (h && !h.fa && h.capture == c) {
            var n = h.listener, t = h.la || h.src;
            h.ia && $f4a7ee607ae1ef78$var$Ua(a.i, h);
            e = !1 !== n.call(t, d) && e;
        }
    }
    return e && !d.defaultPrevented;
}
var $f4a7ee607ae1ef78$var$jb = $f4a7ee607ae1ef78$var$l.JSON.stringify;
class $f4a7ee607ae1ef78$var$kb {
    constructor(a, b){
        this.i = a;
        this.j = b;
        this.h = 0;
        this.g = null;
    }
    get() {
        let a;
        0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
        return a;
    }
}
function $f4a7ee607ae1ef78$var$lb() {
    var a = $f4a7ee607ae1ef78$var$mb;
    let b = null;
    a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
    return b;
}
class $f4a7ee607ae1ef78$var$nb {
    constructor(){
        this.h = this.g = null;
    }
    add(a, b) {
        const c = $f4a7ee607ae1ef78$var$ob.get();
        c.set(a, b);
        this.h ? this.h.next = c : this.g = c;
        this.h = c;
    }
}
var $f4a7ee607ae1ef78$var$ob = new $f4a7ee607ae1ef78$var$kb(()=>new $f4a7ee607ae1ef78$var$pb, (a)=>a.reset());
class $f4a7ee607ae1ef78$var$pb {
    constructor(){
        this.next = this.g = this.h = null;
    }
    set(a, b) {
        this.h = a;
        this.g = b;
        this.next = null;
    }
    reset() {
        this.next = this.g = this.h = null;
    }
}
function $f4a7ee607ae1ef78$var$qb(a) {
    var b = 1;
    a = a.split(":");
    const c = [];
    for(; 0 < b && a.length;)c.push(a.shift()), b--;
    a.length && c.push(a.join(":"));
    return c;
}
function $f4a7ee607ae1ef78$var$rb(a) {
    $f4a7ee607ae1ef78$var$l.setTimeout(()=>{
        throw a;
    }, 0);
}
let $f4a7ee607ae1ef78$var$sb, $f4a7ee607ae1ef78$var$tb = !1, $f4a7ee607ae1ef78$var$mb = new $f4a7ee607ae1ef78$var$nb, $f4a7ee607ae1ef78$var$vb = ()=>{
    const a = $f4a7ee607ae1ef78$var$l.Promise.resolve(void 0);
    $f4a7ee607ae1ef78$var$sb = ()=>{
        a.then($f4a7ee607ae1ef78$var$ub);
    };
};
var $f4a7ee607ae1ef78$var$ub = ()=>{
    for(var a; a = $f4a7ee607ae1ef78$var$lb();){
        try {
            a.h.call(a.g);
        } catch (c) {
            $f4a7ee607ae1ef78$var$rb(c);
        }
        var b = $f4a7ee607ae1ef78$var$ob;
        b.j(a);
        100 > b.h && (b.h++, a.next = b.g, b.g = a);
    }
    $f4a7ee607ae1ef78$var$tb = !1;
};
function $f4a7ee607ae1ef78$var$wb(a, b) {
    $f4a7ee607ae1ef78$var$B.call(this);
    this.h = a || 1;
    this.g = b || $f4a7ee607ae1ef78$var$l;
    this.j = $f4a7ee607ae1ef78$var$q(this.qb, this);
    this.l = Date.now();
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$wb, $f4a7ee607ae1ef78$var$B);
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$wb.prototype;
$f4a7ee607ae1ef78$var$k.ga = !1;
$f4a7ee607ae1ef78$var$k.T = null;
$f4a7ee607ae1ef78$var$k.qb = function() {
    if (this.ga) {
        var a = Date.now() - this.l;
        0 < a && a < .8 * this.h ? this.T = this.g.setTimeout(this.j, this.h - a) : (this.T && (this.g.clearTimeout(this.T), this.T = null), $f4a7ee607ae1ef78$var$C(this, "tick"), this.ga && ($f4a7ee607ae1ef78$var$xb(this), this.start()));
    }
};
$f4a7ee607ae1ef78$var$k.start = function() {
    this.ga = !0;
    this.T || (this.T = this.g.setTimeout(this.j, this.h), this.l = Date.now());
};
function $f4a7ee607ae1ef78$var$xb(a) {
    a.ga = !1;
    a.T && (a.g.clearTimeout(a.T), a.T = null);
}
$f4a7ee607ae1ef78$var$k.N = function() {
    $f4a7ee607ae1ef78$var$wb.$.N.call(this);
    $f4a7ee607ae1ef78$var$xb(this);
    delete this.g;
};
function $f4a7ee607ae1ef78$var$yb(a, b, c) {
    if ("function" === typeof a) c && (a = $f4a7ee607ae1ef78$var$q(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $f4a7ee607ae1ef78$var$q(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $f4a7ee607ae1ef78$var$l.setTimeout(a, b || 0);
}
function $f4a7ee607ae1ef78$var$zb(a) {
    a.g = $f4a7ee607ae1ef78$var$yb(()=>{
        a.g = null;
        a.i && (a.i = !1, $f4a7ee607ae1ef78$var$zb(a));
    }, a.j);
    const b = a.h;
    a.h = null;
    a.m.apply(null, b);
}
class $f4a7ee607ae1ef78$var$Ab extends $f4a7ee607ae1ef78$var$v {
    constructor(a, b){
        super();
        this.m = a;
        this.j = b;
        this.h = null;
        this.i = !1;
        this.g = null;
    }
    l(a) {
        this.h = arguments;
        this.g ? this.i = !0 : $f4a7ee607ae1ef78$var$zb(this);
    }
    N() {
        super.N();
        this.g && ($f4a7ee607ae1ef78$var$l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
    }
}
function $f4a7ee607ae1ef78$var$Bb(a) {
    $f4a7ee607ae1ef78$var$v.call(this);
    this.h = a;
    this.g = {};
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Bb, $f4a7ee607ae1ef78$var$v);
var $f4a7ee607ae1ef78$var$Cb = [];
function $f4a7ee607ae1ef78$var$Db(a, b, c, d) {
    Array.isArray(c) || (c && ($f4a7ee607ae1ef78$var$Cb[0] = c.toString()), c = $f4a7ee607ae1ef78$var$Cb);
    for(var e = 0; e < c.length; e++){
        var f = $f4a7ee607ae1ef78$var$Ya(b, c[e], d || a.handleEvent, !1, a.h || a);
        if (!f) break;
        a.g[f.key] = f;
    }
}
function $f4a7ee607ae1ef78$var$Fb(a) {
    $f4a7ee607ae1ef78$var$Na(a.g, function(b, c) {
        this.g.hasOwnProperty(c) && $f4a7ee607ae1ef78$var$gb(b);
    }, a);
    a.g = {};
}
$f4a7ee607ae1ef78$var$Bb.prototype.N = function() {
    $f4a7ee607ae1ef78$var$Bb.$.N.call(this);
    $f4a7ee607ae1ef78$var$Fb(this);
};
$f4a7ee607ae1ef78$var$Bb.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
};
function $f4a7ee607ae1ef78$var$Gb() {
    this.g = !0;
}
$f4a7ee607ae1ef78$var$Gb.prototype.Ea = function() {
    this.g = !1;
};
function $f4a7ee607ae1ef78$var$Hb(a, b, c, d, e, f) {
    a.info(function() {
        if (a.g) {
            if (f) {
                var h = "";
                for(var n = f.split("&"), t = 0; t < n.length; t++){
                    var m = n[t].split("=");
                    if (1 < m.length) {
                        var u = m[0];
                        m = m[1];
                        var L = u.split("_");
                        h = 2 <= L.length && "type" == L[1] ? h + (u + "=" + m + "&") : h + (u + "=redacted&");
                    }
                }
            } else h = null;
        } else h = f;
        return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
}
function $f4a7ee607ae1ef78$var$Ib(a, b, c, d, e, f, h) {
    a.info(function() {
        return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
}
function $f4a7ee607ae1ef78$var$D(a, b, c, d) {
    a.info(function() {
        return "XMLHTTP TEXT (" + b + "): " + $f4a7ee607ae1ef78$var$Jb(a, c) + (d ? " " + d : "");
    });
}
function $f4a7ee607ae1ef78$var$Kb(a, b) {
    a.info(function() {
        return "TIMEOUT: " + b;
    });
}
$f4a7ee607ae1ef78$var$Gb.prototype.info = function() {};
function $f4a7ee607ae1ef78$var$Jb(a, b) {
    if (!a.g) return b;
    if (!b) return null;
    try {
        var c = JSON.parse(b);
        if (c) {
            for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                var d = c[a];
                if (!(2 > d.length)) {
                    var e = d[1];
                    if (Array.isArray(e) && !(1 > e.length)) {
                        var f = e[0];
                        if ("noop" != f && "stop" != f && "close" != f) for(var h = 1; h < e.length; h++)e[h] = "";
                    }
                }
            }
        }
        return $f4a7ee607ae1ef78$var$jb(c);
    } catch (n) {
        return b;
    }
}
var $f4a7ee607ae1ef78$var$E = {}, $f4a7ee607ae1ef78$var$Lb = null;
function $f4a7ee607ae1ef78$var$Mb() {
    return $f4a7ee607ae1ef78$var$Lb = $f4a7ee607ae1ef78$var$Lb || new $f4a7ee607ae1ef78$var$B;
}
$f4a7ee607ae1ef78$var$E.Ta = "serverreachability";
function $f4a7ee607ae1ef78$var$Nb(a) {
    $f4a7ee607ae1ef78$var$w.call(this, $f4a7ee607ae1ef78$var$E.Ta, a);
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Nb, $f4a7ee607ae1ef78$var$w);
function $f4a7ee607ae1ef78$var$Ob(a) {
    const b = $f4a7ee607ae1ef78$var$Mb();
    $f4a7ee607ae1ef78$var$C(b, new $f4a7ee607ae1ef78$var$Nb(b));
}
$f4a7ee607ae1ef78$var$E.STAT_EVENT = "statevent";
function $f4a7ee607ae1ef78$var$Pb(a, b) {
    $f4a7ee607ae1ef78$var$w.call(this, $f4a7ee607ae1ef78$var$E.STAT_EVENT, a);
    this.stat = b;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Pb, $f4a7ee607ae1ef78$var$w);
function $f4a7ee607ae1ef78$var$F(a) {
    const b = $f4a7ee607ae1ef78$var$Mb();
    $f4a7ee607ae1ef78$var$C(b, new $f4a7ee607ae1ef78$var$Pb(b, a));
}
$f4a7ee607ae1ef78$var$E.Ua = "timingevent";
function $f4a7ee607ae1ef78$var$Qb(a, b) {
    $f4a7ee607ae1ef78$var$w.call(this, $f4a7ee607ae1ef78$var$E.Ua, a);
    this.size = b;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Qb, $f4a7ee607ae1ef78$var$w);
function $f4a7ee607ae1ef78$var$Rb(a, b) {
    if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
    return $f4a7ee607ae1ef78$var$l.setTimeout(function() {
        a();
    }, b);
}
var $f4a7ee607ae1ef78$var$Sb = {
    NO_ERROR: 0,
    rb: 1,
    Eb: 2,
    Db: 3,
    yb: 4,
    Cb: 5,
    Fb: 6,
    Qa: 7,
    TIMEOUT: 8,
    Ib: 9
};
var $f4a7ee607ae1ef78$var$Tb = {
    wb: "complete",
    Sb: "success",
    Ra: "error",
    Qa: "abort",
    Kb: "ready",
    Lb: "readystatechange",
    TIMEOUT: "timeout",
    Gb: "incrementaldata",
    Jb: "progress",
    zb: "downloadprogress",
    $b: "uploadprogress"
};
function $f4a7ee607ae1ef78$var$Ub() {}
$f4a7ee607ae1ef78$var$Ub.prototype.h = null;
function $f4a7ee607ae1ef78$var$Vb(a) {
    return a.h || (a.h = a.i());
}
function $f4a7ee607ae1ef78$var$Wb() {}
var $f4a7ee607ae1ef78$var$Xb = {
    OPEN: "a",
    vb: "b",
    Ra: "c",
    Hb: "d"
};
function $f4a7ee607ae1ef78$var$Yb() {
    $f4a7ee607ae1ef78$var$w.call(this, "d");
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Yb, $f4a7ee607ae1ef78$var$w);
function $f4a7ee607ae1ef78$var$Zb() {
    $f4a7ee607ae1ef78$var$w.call(this, "c");
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Zb, $f4a7ee607ae1ef78$var$w);
var $f4a7ee607ae1ef78$var$$b;
function $f4a7ee607ae1ef78$var$ac() {}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$ac, $f4a7ee607ae1ef78$var$Ub);
$f4a7ee607ae1ef78$var$ac.prototype.g = function() {
    return new XMLHttpRequest;
};
$f4a7ee607ae1ef78$var$ac.prototype.i = function() {
    return {};
};
$f4a7ee607ae1ef78$var$$b = new $f4a7ee607ae1ef78$var$ac;
function $f4a7ee607ae1ef78$var$bc(a, b, c, d) {
    this.l = a;
    this.j = b;
    this.m = c;
    this.W = d || 1;
    this.U = new $f4a7ee607ae1ef78$var$Bb(this);
    this.P = $f4a7ee607ae1ef78$var$cc;
    a = $f4a7ee607ae1ef78$var$va ? 125 : void 0;
    this.V = new $f4a7ee607ae1ef78$var$wb(a);
    this.I = null;
    this.i = !1;
    this.s = this.A = this.v = this.L = this.G = this.Y = this.B = null;
    this.F = [];
    this.g = null;
    this.C = 0;
    this.o = this.u = null;
    this.ca = -1;
    this.J = !1;
    this.O = 0;
    this.M = null;
    this.ba = this.K = this.aa = this.S = !1;
    this.h = new $f4a7ee607ae1ef78$var$dc;
}
function $f4a7ee607ae1ef78$var$dc() {
    this.i = null;
    this.g = "";
    this.h = !1;
}
var $f4a7ee607ae1ef78$var$cc = 45E3, $f4a7ee607ae1ef78$var$ec = {}, $f4a7ee607ae1ef78$var$fc = {};
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$bc.prototype;
$f4a7ee607ae1ef78$var$k.setTimeout = function(a) {
    this.P = a;
};
function $f4a7ee607ae1ef78$var$gc(a, b, c) {
    a.L = 1;
    a.v = $f4a7ee607ae1ef78$var$hc($f4a7ee607ae1ef78$var$G(b));
    a.s = c;
    a.S = !0;
    $f4a7ee607ae1ef78$var$ic(a, null);
}
function $f4a7ee607ae1ef78$var$ic(a, b) {
    a.G = Date.now();
    $f4a7ee607ae1ef78$var$jc(a);
    a.A = $f4a7ee607ae1ef78$var$G(a.v);
    var c = a.A, d = a.W;
    Array.isArray(d) || (d = [
        String(d)
    ]);
    $f4a7ee607ae1ef78$var$kc(c.i, "t", d);
    a.C = 0;
    c = a.l.J;
    a.h = new $f4a7ee607ae1ef78$var$dc;
    a.g = $f4a7ee607ae1ef78$var$lc(a.l, c ? b : null, !a.s);
    0 < a.O && (a.M = new $f4a7ee607ae1ef78$var$Ab($f4a7ee607ae1ef78$var$q(a.Pa, a, a.g), a.O));
    $f4a7ee607ae1ef78$var$Db(a.U, a.g, "readystatechange", a.nb);
    b = a.I ? $f4a7ee607ae1ef78$var$Pa(a.I) : {};
    a.s ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ha(a.A, a.u, a.s, b)) : (a.u = "GET", a.g.ha(a.A, a.u, null, b));
    $f4a7ee607ae1ef78$var$Ob();
    $f4a7ee607ae1ef78$var$Hb(a.j, a.u, a.A, a.m, a.W, a.s);
}
$f4a7ee607ae1ef78$var$k.nb = function(a) {
    a = a.target;
    const b = this.M;
    b && 3 == $f4a7ee607ae1ef78$var$H(a) ? b.l() : this.Pa(a);
};
$f4a7ee607ae1ef78$var$k.Pa = function(a) {
    try {
        if (a == this.g) a: {
            const u = $f4a7ee607ae1ef78$var$H(this.g);
            var b = this.g.Ia();
            const L = this.g.da();
            if (!(3 > u) && (3 != u || $f4a7ee607ae1ef78$var$va || this.g && (this.h.h || this.g.ja() || $f4a7ee607ae1ef78$var$mc(this.g)))) {
                this.J || 4 != u || 7 == b || (8 == b || 0 >= L ? $f4a7ee607ae1ef78$var$Ob(3) : $f4a7ee607ae1ef78$var$Ob(2));
                $f4a7ee607ae1ef78$var$nc(this);
                var c = this.g.da();
                this.ca = c;
                b: if ($f4a7ee607ae1ef78$var$oc(this)) {
                    var d = $f4a7ee607ae1ef78$var$mc(this.g);
                    a = "";
                    var e = d.length, f = 4 == $f4a7ee607ae1ef78$var$H(this.g);
                    if (!this.h.i) {
                        if ("undefined" === typeof TextDecoder) {
                            $f4a7ee607ae1ef78$var$I(this);
                            $f4a7ee607ae1ef78$var$pc(this);
                            var h = "";
                            break b;
                        }
                        this.h.i = new $f4a7ee607ae1ef78$var$l.TextDecoder;
                    }
                    for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                        stream: f && b == e - 1
                    });
                    d.splice(0, e);
                    this.h.g += a;
                    this.C = 0;
                    h = this.h.g;
                } else h = this.g.ja();
                this.i = 200 == c;
                $f4a7ee607ae1ef78$var$Ib(this.j, this.u, this.A, this.m, this.W, u, c);
                if (this.i) {
                    if (this.aa && !this.K) {
                        b: {
                            if (this.g) {
                                var n, t = this.g;
                                if ((n = t.g ? t.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !$f4a7ee607ae1ef78$var$x(n)) {
                                    var m = n;
                                    break b;
                                }
                            }
                            m = null;
                        }
                        if (c = m) $f4a7ee607ae1ef78$var$D(this.j, this.m, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, $f4a7ee607ae1ef78$var$qc(this, c);
                        else {
                            this.i = !1;
                            this.o = 3;
                            $f4a7ee607ae1ef78$var$F(12);
                            $f4a7ee607ae1ef78$var$I(this);
                            $f4a7ee607ae1ef78$var$pc(this);
                            break a;
                        }
                    }
                    this.S ? ($f4a7ee607ae1ef78$var$rc(this, u, h), $f4a7ee607ae1ef78$var$va && this.i && 3 == u && ($f4a7ee607ae1ef78$var$Db(this.U, this.V, "tick", this.mb), this.V.start())) : ($f4a7ee607ae1ef78$var$D(this.j, this.m, h, null), $f4a7ee607ae1ef78$var$qc(this, h));
                    4 == u && $f4a7ee607ae1ef78$var$I(this);
                    this.i && !this.J && (4 == u ? $f4a7ee607ae1ef78$var$sc(this.l, this) : (this.i = !1, $f4a7ee607ae1ef78$var$jc(this)));
                } else $f4a7ee607ae1ef78$var$tc(this.g), 400 == c && 0 < h.indexOf("Unknown SID") ? (this.o = 3, $f4a7ee607ae1ef78$var$F(12)) : (this.o = 0, $f4a7ee607ae1ef78$var$F(13)), $f4a7ee607ae1ef78$var$I(this), $f4a7ee607ae1ef78$var$pc(this);
            }
        }
    } catch (u) {} finally{}
};
function $f4a7ee607ae1ef78$var$oc(a) {
    return a.g ? "GET" == a.u && 2 != a.L && a.l.Ha : !1;
}
function $f4a7ee607ae1ef78$var$rc(a, b, c) {
    let d = !0, e;
    for(; !a.J && a.C < c.length;)if (e = $f4a7ee607ae1ef78$var$uc(a, c), e == $f4a7ee607ae1ef78$var$fc) {
        4 == b && (a.o = 4, $f4a7ee607ae1ef78$var$F(14), d = !1);
        $f4a7ee607ae1ef78$var$D(a.j, a.m, null, "[Incomplete Response]");
        break;
    } else if (e == $f4a7ee607ae1ef78$var$ec) {
        a.o = 4;
        $f4a7ee607ae1ef78$var$F(15);
        $f4a7ee607ae1ef78$var$D(a.j, a.m, c, "[Invalid Chunk]");
        d = !1;
        break;
    } else $f4a7ee607ae1ef78$var$D(a.j, a.m, e, null), $f4a7ee607ae1ef78$var$qc(a, e);
    $f4a7ee607ae1ef78$var$oc(a) && e != $f4a7ee607ae1ef78$var$fc && e != $f4a7ee607ae1ef78$var$ec && (a.h.g = "", a.C = 0);
    4 != b || 0 != c.length || a.h.h || (a.o = 1, $f4a7ee607ae1ef78$var$F(16), d = !1);
    a.i = a.i && d;
    d ? 0 < c.length && !a.ba && (a.ba = !0, b = a.l, b.g == a && b.ca && !b.M && (b.l.info("Great, no buffering proxy detected. Bytes received: " + c.length), $f4a7ee607ae1ef78$var$vc(b), b.M = !0, $f4a7ee607ae1ef78$var$F(11))) : ($f4a7ee607ae1ef78$var$D(a.j, a.m, c, "[Invalid Chunked Response]"), $f4a7ee607ae1ef78$var$I(a), $f4a7ee607ae1ef78$var$pc(a));
}
$f4a7ee607ae1ef78$var$k.mb = function() {
    if (this.g) {
        var a = $f4a7ee607ae1ef78$var$H(this.g), b = this.g.ja();
        this.C < b.length && ($f4a7ee607ae1ef78$var$nc(this), $f4a7ee607ae1ef78$var$rc(this, a, b), this.i && 4 != a && $f4a7ee607ae1ef78$var$jc(this));
    }
};
function $f4a7ee607ae1ef78$var$uc(a, b) {
    var c = a.C, d = b.indexOf("\n", c);
    if (-1 == d) return $f4a7ee607ae1ef78$var$fc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return $f4a7ee607ae1ef78$var$ec;
    d += 1;
    if (d + c > b.length) return $f4a7ee607ae1ef78$var$fc;
    b = b.slice(d, d + c);
    a.C = d + c;
    return b;
}
$f4a7ee607ae1ef78$var$k.cancel = function() {
    this.J = !0;
    $f4a7ee607ae1ef78$var$I(this);
};
function $f4a7ee607ae1ef78$var$jc(a) {
    a.Y = Date.now() + a.P;
    $f4a7ee607ae1ef78$var$wc(a, a.P);
}
function $f4a7ee607ae1ef78$var$wc(a, b) {
    if (null != a.B) throw Error("WatchDog timer not null");
    a.B = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(a.lb, a), b);
}
function $f4a7ee607ae1ef78$var$nc(a) {
    a.B && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.B), a.B = null);
}
$f4a7ee607ae1ef78$var$k.lb = function() {
    this.B = null;
    const a = Date.now();
    0 <= a - this.Y ? ($f4a7ee607ae1ef78$var$Kb(this.j, this.A), 2 != this.L && ($f4a7ee607ae1ef78$var$Ob(), $f4a7ee607ae1ef78$var$F(17)), $f4a7ee607ae1ef78$var$I(this), this.o = 2, $f4a7ee607ae1ef78$var$pc(this)) : $f4a7ee607ae1ef78$var$wc(this, this.Y - a);
};
function $f4a7ee607ae1ef78$var$pc(a) {
    0 == a.l.H || a.J || $f4a7ee607ae1ef78$var$sc(a.l, a);
}
function $f4a7ee607ae1ef78$var$I(a) {
    $f4a7ee607ae1ef78$var$nc(a);
    var b = a.M;
    b && "function" == typeof b.sa && b.sa();
    a.M = null;
    $f4a7ee607ae1ef78$var$xb(a.V);
    $f4a7ee607ae1ef78$var$Fb(a.U);
    a.g && (b = a.g, a.g = null, b.abort(), b.sa());
}
function $f4a7ee607ae1ef78$var$qc(a, b) {
    try {
        var c = a.l;
        if (0 != c.H && (c.g == a || $f4a7ee607ae1ef78$var$xc(c.i, a))) {
            if (!a.K && $f4a7ee607ae1ef78$var$xc(c.i, a) && 3 == c.H) {
                try {
                    var d = c.Ja.g.parse(b);
                } catch (m) {
                    d = null;
                }
                if (Array.isArray(d) && 3 == d.length) {
                    var e = d;
                    if (0 == e[0]) {
                        a: if (!c.u) {
                            if (c.g) {
                                if (c.g.G + 3E3 < a.G) $f4a7ee607ae1ef78$var$yc(c), $f4a7ee607ae1ef78$var$zc(c);
                                else break a;
                            }
                            $f4a7ee607ae1ef78$var$Ac(c);
                            $f4a7ee607ae1ef78$var$F(18);
                        }
                    } else c.Fa = e[1], 0 < c.Fa - c.V && 37500 > e[2] && c.G && 0 == c.A && !c.v && (c.v = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(c.ib, c), 6E3));
                    if (1 >= $f4a7ee607ae1ef78$var$Bc(c.i) && c.oa) {
                        try {
                            c.oa();
                        } catch (m) {}
                        c.oa = void 0;
                    }
                } else $f4a7ee607ae1ef78$var$J(c, 11);
            } else if ((a.K || c.g == a) && $f4a7ee607ae1ef78$var$yc(c), !$f4a7ee607ae1ef78$var$x(b)) for(e = c.Ja.g.parse(b), b = 0; b < e.length; b++){
                let m = e[b];
                c.V = m[0];
                m = m[1];
                if (2 == c.H) {
                    if ("c" == m[0]) {
                        c.K = m[1];
                        c.pa = m[2];
                        const u = m[3];
                        null != u && (c.ra = u, c.l.info("VER=" + c.ra));
                        const L = m[4];
                        null != L && (c.Ga = L, c.l.info("SVER=" + c.Ga));
                        const La = m[5];
                        null != La && "number" === typeof La && 0 < La && (d = 1.5 * La, c.L = d, c.l.info("backChannelRequestTimeoutMs_=" + d));
                        d = c;
                        const la = a.g;
                        if (la) {
                            const Ma = la.g ? la.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                            if (Ma) {
                                var f = d.i;
                                f.g || -1 == Ma.indexOf("spdy") && -1 == Ma.indexOf("quic") && -1 == Ma.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && ($f4a7ee607ae1ef78$var$Cc(f, f.h), f.h = null));
                            }
                            if (d.F) {
                                const Eb = la.g ? la.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                Eb && (d.Da = Eb, $f4a7ee607ae1ef78$var$K(d.I, d.F, Eb));
                            }
                        }
                        c.H = 3;
                        c.h && c.h.Ba();
                        c.ca && (c.S = Date.now() - a.G, c.l.info("Handshake RTT: " + c.S + "ms"));
                        d = c;
                        var h = a;
                        d.wa = $f4a7ee607ae1ef78$var$Dc(d, d.J ? d.pa : null, d.Y);
                        if (h.K) {
                            $f4a7ee607ae1ef78$var$Ec(d.i, h);
                            var n = h, t = d.L;
                            t && n.setTimeout(t);
                            n.B && ($f4a7ee607ae1ef78$var$nc(n), $f4a7ee607ae1ef78$var$jc(n));
                            d.g = h;
                        } else $f4a7ee607ae1ef78$var$Fc(d);
                        0 < c.j.length && $f4a7ee607ae1ef78$var$Gc(c);
                    } else "stop" != m[0] && "close" != m[0] || $f4a7ee607ae1ef78$var$J(c, 7);
                } else 3 == c.H && ("stop" == m[0] || "close" == m[0] ? "stop" == m[0] ? $f4a7ee607ae1ef78$var$J(c, 7) : $f4a7ee607ae1ef78$var$Hc(c) : "noop" != m[0] && c.h && c.h.Aa(m), c.A = 0);
            }
        }
        $f4a7ee607ae1ef78$var$Ob(4);
    } catch (m) {}
}
function $f4a7ee607ae1ef78$var$Ic(a) {
    if (a.Z && "function" == typeof a.Z) return a.Z();
    if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
    if ("string" === typeof a) return a.split("");
    if ($f4a7ee607ae1ef78$var$aa(a)) {
        for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
        return b;
    }
    b = [];
    c = 0;
    for(d in a)b[c++] = a[d];
    return b;
}
function $f4a7ee607ae1ef78$var$Jc(a) {
    if (a.ta && "function" == typeof a.ta) return a.ta();
    if (!a.Z || "function" != typeof a.Z) {
        if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
        if (!("undefined" !== typeof Set && a instanceof Set)) {
            if ($f4a7ee607ae1ef78$var$aa(a) || "string" === typeof a) {
                var b = [];
                a = a.length;
                for(var c = 0; c < a; c++)b.push(c);
                return b;
            }
            b = [];
            c = 0;
            for(const d in a)b[c++] = d;
            return b;
        }
    }
}
function $f4a7ee607ae1ef78$var$Kc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
    else if ($f4a7ee607ae1ef78$var$aa(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
    else for(var c = $f4a7ee607ae1ef78$var$Jc(a), d = $f4a7ee607ae1ef78$var$Ic(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
}
var $f4a7ee607ae1ef78$var$Lc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
function $f4a7ee607ae1ef78$var$Mc(a, b) {
    if (a) {
        a = a.split("&");
        for(var c = 0; c < a.length; c++){
            var d = a[c].indexOf("="), e = null;
            if (0 <= d) {
                var f = a[c].substring(0, d);
                e = a[c].substring(d + 1);
            } else f = a[c];
            b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
    }
}
function $f4a7ee607ae1ef78$var$M(a) {
    this.g = this.s = this.j = "";
    this.m = null;
    this.o = this.l = "";
    this.h = !1;
    if (a instanceof $f4a7ee607ae1ef78$var$M) {
        this.h = a.h;
        $f4a7ee607ae1ef78$var$Nc(this, a.j);
        this.s = a.s;
        this.g = a.g;
        $f4a7ee607ae1ef78$var$Oc(this, a.m);
        this.l = a.l;
        var b = a.i;
        var c = new $f4a7ee607ae1ef78$var$Pc;
        c.i = b.i;
        b.g && (c.g = new Map(b.g), c.h = b.h);
        $f4a7ee607ae1ef78$var$Qc(this, c);
        this.o = a.o;
    } else a && (b = String(a).match($f4a7ee607ae1ef78$var$Lc)) ? (this.h = !1, $f4a7ee607ae1ef78$var$Nc(this, b[1] || "", !0), this.s = $f4a7ee607ae1ef78$var$Rc(b[2] || ""), this.g = $f4a7ee607ae1ef78$var$Rc(b[3] || "", !0), $f4a7ee607ae1ef78$var$Oc(this, b[4]), this.l = $f4a7ee607ae1ef78$var$Rc(b[5] || "", !0), $f4a7ee607ae1ef78$var$Qc(this, b[6] || "", !0), this.o = $f4a7ee607ae1ef78$var$Rc(b[7] || "")) : (this.h = !1, this.i = new $f4a7ee607ae1ef78$var$Pc(null, this.h));
}
$f4a7ee607ae1ef78$var$M.prototype.toString = function() {
    var a = [], b = this.j;
    b && a.push($f4a7ee607ae1ef78$var$Sc(b, $f4a7ee607ae1ef78$var$Tc, !0), ":");
    var c = this.g;
    if (c || "file" == b) a.push("//"), (b = this.s) && a.push($f4a7ee607ae1ef78$var$Sc(b, $f4a7ee607ae1ef78$var$Tc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.m, null != c && a.push(":", String(c));
    if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push($f4a7ee607ae1ef78$var$Sc(c, "/" == c.charAt(0) ? $f4a7ee607ae1ef78$var$Uc : $f4a7ee607ae1ef78$var$Vc, !0));
    (c = this.i.toString()) && a.push("?", c);
    (c = this.o) && a.push("#", $f4a7ee607ae1ef78$var$Sc(c, $f4a7ee607ae1ef78$var$Wc));
    return a.join("");
};
function $f4a7ee607ae1ef78$var$G(a) {
    return new $f4a7ee607ae1ef78$var$M(a);
}
function $f4a7ee607ae1ef78$var$Nc(a, b, c) {
    a.j = c ? $f4a7ee607ae1ef78$var$Rc(b, !0) : b;
    a.j && (a.j = a.j.replace(/:$/, ""));
}
function $f4a7ee607ae1ef78$var$Oc(a, b) {
    if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.m = b;
    } else a.m = null;
}
function $f4a7ee607ae1ef78$var$Qc(a, b, c) {
    b instanceof $f4a7ee607ae1ef78$var$Pc ? (a.i = b, $f4a7ee607ae1ef78$var$Xc(a.i, a.h)) : (c || (b = $f4a7ee607ae1ef78$var$Sc(b, $f4a7ee607ae1ef78$var$Yc)), a.i = new $f4a7ee607ae1ef78$var$Pc(b, a.h));
}
function $f4a7ee607ae1ef78$var$K(a, b, c) {
    a.i.set(b, c);
}
function $f4a7ee607ae1ef78$var$hc(a) {
    $f4a7ee607ae1ef78$var$K(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
    return a;
}
function $f4a7ee607ae1ef78$var$Rc(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function $f4a7ee607ae1ef78$var$Sc(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, $f4a7ee607ae1ef78$var$Zc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}
function $f4a7ee607ae1ef78$var$Zc(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}
var $f4a7ee607ae1ef78$var$Tc = /[#\/\?@]/g, $f4a7ee607ae1ef78$var$Vc = /[#\?:]/g, $f4a7ee607ae1ef78$var$Uc = /[#\?]/g, $f4a7ee607ae1ef78$var$Yc = /[#\?@]/g, $f4a7ee607ae1ef78$var$Wc = /#/g;
function $f4a7ee607ae1ef78$var$Pc(a, b) {
    this.h = this.g = null;
    this.i = a || null;
    this.j = !!b;
}
function $f4a7ee607ae1ef78$var$N(a) {
    a.g || (a.g = new Map, a.h = 0, a.i && $f4a7ee607ae1ef78$var$Mc(a.i, function(b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
}
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$Pc.prototype;
$f4a7ee607ae1ef78$var$k.add = function(a, b) {
    $f4a7ee607ae1ef78$var$N(this);
    this.i = null;
    a = $f4a7ee607ae1ef78$var$O(this, a);
    var c = this.g.get(a);
    c || this.g.set(a, c = []);
    c.push(b);
    this.h += 1;
    return this;
};
function $f4a7ee607ae1ef78$var$$c(a, b) {
    $f4a7ee607ae1ef78$var$N(a);
    b = $f4a7ee607ae1ef78$var$O(a, b);
    a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
}
function $f4a7ee607ae1ef78$var$ad(a, b) {
    $f4a7ee607ae1ef78$var$N(a);
    b = $f4a7ee607ae1ef78$var$O(a, b);
    return a.g.has(b);
}
$f4a7ee607ae1ef78$var$k.forEach = function(a, b) {
    $f4a7ee607ae1ef78$var$N(this);
    this.g.forEach(function(c, d) {
        c.forEach(function(e) {
            a.call(b, e, d, this);
        }, this);
    }, this);
};
$f4a7ee607ae1ef78$var$k.ta = function() {
    $f4a7ee607ae1ef78$var$N(this);
    const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
    for(let d = 0; d < b.length; d++){
        const e = a[d];
        for(let f = 0; f < e.length; f++)c.push(b[d]);
    }
    return c;
};
$f4a7ee607ae1ef78$var$k.Z = function(a) {
    $f4a7ee607ae1ef78$var$N(this);
    let b = [];
    if ("string" === typeof a) $f4a7ee607ae1ef78$var$ad(this, a) && (b = b.concat(this.g.get($f4a7ee607ae1ef78$var$O(this, a))));
    else {
        a = Array.from(this.g.values());
        for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
    }
    return b;
};
$f4a7ee607ae1ef78$var$k.set = function(a, b) {
    $f4a7ee607ae1ef78$var$N(this);
    this.i = null;
    a = $f4a7ee607ae1ef78$var$O(this, a);
    $f4a7ee607ae1ef78$var$ad(this, a) && (this.h -= this.g.get(a).length);
    this.g.set(a, [
        b
    ]);
    this.h += 1;
    return this;
};
$f4a7ee607ae1ef78$var$k.get = function(a, b) {
    if (!a) return b;
    a = this.Z(a);
    return 0 < a.length ? String(a[0]) : b;
};
function $f4a7ee607ae1ef78$var$kc(a, b, c) {
    $f4a7ee607ae1ef78$var$$c(a, b);
    0 < c.length && (a.i = null, a.g.set($f4a7ee607ae1ef78$var$O(a, b), $f4a7ee607ae1ef78$var$ma(c)), a.h += c.length);
}
$f4a7ee607ae1ef78$var$k.toString = function() {
    if (this.i) return this.i;
    if (!this.g) return "";
    const a = [], b = Array.from(this.g.keys());
    for(var c = 0; c < b.length; c++){
        var d = b[c];
        const f = encodeURIComponent(String(d)), h = this.Z(d);
        for(d = 0; d < h.length; d++){
            var e = f;
            "" !== h[d] && (e += "=" + encodeURIComponent(String(h[d])));
            a.push(e);
        }
    }
    return this.i = a.join("&");
};
function $f4a7ee607ae1ef78$var$O(a, b) {
    b = String(b);
    a.j && (b = b.toLowerCase());
    return b;
}
function $f4a7ee607ae1ef78$var$Xc(a, b) {
    b && !a.j && ($f4a7ee607ae1ef78$var$N(a), a.i = null, a.g.forEach(function(c, d) {
        var e = d.toLowerCase();
        d != e && ($f4a7ee607ae1ef78$var$$c(this, d), $f4a7ee607ae1ef78$var$kc(this, e, c));
    }, a));
    a.j = b;
}
var $f4a7ee607ae1ef78$var$bd = class {
    constructor(a, b){
        this.g = a;
        this.map = b;
    }
};
function $f4a7ee607ae1ef78$var$cd(a) {
    this.l = a || $f4a7ee607ae1ef78$var$dd;
    $f4a7ee607ae1ef78$var$l.PerformanceNavigationTiming ? (a = $f4a7ee607ae1ef78$var$l.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!($f4a7ee607ae1ef78$var$l.g && $f4a7ee607ae1ef78$var$l.g.Ka && $f4a7ee607ae1ef78$var$l.g.Ka() && $f4a7ee607ae1ef78$var$l.g.Ka().ec);
    this.j = a ? this.l : 1;
    this.g = null;
    1 < this.j && (this.g = new Set);
    this.h = null;
    this.i = [];
}
var $f4a7ee607ae1ef78$var$dd = 10;
function $f4a7ee607ae1ef78$var$ed(a) {
    return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
}
function $f4a7ee607ae1ef78$var$Bc(a) {
    return a.h ? 1 : a.g ? a.g.size : 0;
}
function $f4a7ee607ae1ef78$var$xc(a, b) {
    return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
}
function $f4a7ee607ae1ef78$var$Cc(a, b) {
    a.g ? a.g.add(b) : a.h = b;
}
function $f4a7ee607ae1ef78$var$Ec(a, b) {
    a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
}
$f4a7ee607ae1ef78$var$cd.prototype.cancel = function() {
    this.i = $f4a7ee607ae1ef78$var$fd(this);
    if (this.h) this.h.cancel(), this.h = null;
    else if (this.g && 0 !== this.g.size) {
        for (const a of this.g.values())a.cancel();
        this.g.clear();
    }
};
function $f4a7ee607ae1ef78$var$fd(a) {
    if (null != a.h) return a.i.concat(a.h.F);
    if (null != a.g && 0 !== a.g.size) {
        let b = a.i;
        for (const c of a.g.values())b = b.concat(c.F);
        return b;
    }
    return $f4a7ee607ae1ef78$var$ma(a.i);
}
var $f4a7ee607ae1ef78$var$gd = class {
    stringify(a) {
        return $f4a7ee607ae1ef78$var$l.JSON.stringify(a, void 0);
    }
    parse(a) {
        return $f4a7ee607ae1ef78$var$l.JSON.parse(a, void 0);
    }
};
function $f4a7ee607ae1ef78$var$hd() {
    this.g = new $f4a7ee607ae1ef78$var$gd;
}
function $f4a7ee607ae1ef78$var$id(a, b, c) {
    const d = c || "";
    try {
        $f4a7ee607ae1ef78$var$Kc(a, function(e, f) {
            let h = e;
            $f4a7ee607ae1ef78$var$p(e) && (h = $f4a7ee607ae1ef78$var$jb(e));
            b.push(d + f + "=" + encodeURIComponent(h));
        });
    } catch (e) {
        throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
}
function $f4a7ee607ae1ef78$var$jd(a, b) {
    const c = new $f4a7ee607ae1ef78$var$Gb;
    if ($f4a7ee607ae1ef78$var$l.Image) {
        const d = new Image;
        d.onload = $f4a7ee607ae1ef78$var$ha($f4a7ee607ae1ef78$var$kd, c, d, "TestLoadImage: loaded", !0, b);
        d.onerror = $f4a7ee607ae1ef78$var$ha($f4a7ee607ae1ef78$var$kd, c, d, "TestLoadImage: error", !1, b);
        d.onabort = $f4a7ee607ae1ef78$var$ha($f4a7ee607ae1ef78$var$kd, c, d, "TestLoadImage: abort", !1, b);
        d.ontimeout = $f4a7ee607ae1ef78$var$ha($f4a7ee607ae1ef78$var$kd, c, d, "TestLoadImage: timeout", !1, b);
        $f4a7ee607ae1ef78$var$l.setTimeout(function() {
            if (d.ontimeout) d.ontimeout();
        }, 1E4);
        d.src = a;
    } else b(!1);
}
function $f4a7ee607ae1ef78$var$kd(a, b, c, d, e) {
    try {
        b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {}
}
function $f4a7ee607ae1ef78$var$ld(a) {
    this.l = a.fc || null;
    this.j = a.ob || !1;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$ld, $f4a7ee607ae1ef78$var$Ub);
$f4a7ee607ae1ef78$var$ld.prototype.g = function() {
    return new $f4a7ee607ae1ef78$var$md(this.l, this.j);
};
$f4a7ee607ae1ef78$var$ld.prototype.i = function(a) {
    return function() {
        return a;
    };
}({});
function $f4a7ee607ae1ef78$var$md(a, b) {
    $f4a7ee607ae1ef78$var$B.call(this);
    this.F = a;
    this.u = b;
    this.m = void 0;
    this.readyState = $f4a7ee607ae1ef78$var$nd;
    this.status = 0;
    this.responseType = this.responseText = this.response = this.statusText = "";
    this.onreadystatechange = null;
    this.v = new Headers;
    this.h = null;
    this.C = "GET";
    this.B = "";
    this.g = !1;
    this.A = this.j = this.l = null;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$md, $f4a7ee607ae1ef78$var$B);
var $f4a7ee607ae1ef78$var$nd = 0;
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$md.prototype;
$f4a7ee607ae1ef78$var$k.open = function(a, b) {
    if (this.readyState != $f4a7ee607ae1ef78$var$nd) throw this.abort(), Error("Error reopening a connection");
    this.C = a;
    this.B = b;
    this.readyState = 1;
    $f4a7ee607ae1ef78$var$od(this);
};
$f4a7ee607ae1ef78$var$k.send = function(a) {
    if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    const b = {
        headers: this.v,
        method: this.C,
        credentials: this.m,
        cache: void 0
    };
    a && (b.body = a);
    (this.F || $f4a7ee607ae1ef78$var$l).fetch(new Request(this.B, b)).then(this.$a.bind(this), this.ka.bind(this));
};
$f4a7ee607ae1ef78$var$k.abort = function() {
    this.response = this.responseText = "";
    this.v = new Headers;
    this.status = 0;
    this.j && this.j.cancel("Request was aborted.").catch(()=>{});
    1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, $f4a7ee607ae1ef78$var$pd(this));
    this.readyState = $f4a7ee607ae1ef78$var$nd;
};
$f4a7ee607ae1ef78$var$k.$a = function(a) {
    if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, $f4a7ee607ae1ef78$var$od(this)), this.g && (this.readyState = 3, $f4a7ee607ae1ef78$var$od(this), this.g))) {
        if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Ya.bind(this), this.ka.bind(this));
        else if ("undefined" !== typeof $f4a7ee607ae1ef78$var$l.ReadableStream && "body" in a) {
            this.j = a.body.getReader();
            if (this.u) {
                if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                this.response = [];
            } else this.response = this.responseText = "", this.A = new TextDecoder;
            $f4a7ee607ae1ef78$var$qd(this);
        } else a.text().then(this.Za.bind(this), this.ka.bind(this));
    }
};
function $f4a7ee607ae1ef78$var$qd(a) {
    a.j.read().then(a.Xa.bind(a)).catch(a.ka.bind(a));
}
$f4a7ee607ae1ef78$var$k.Xa = function(a) {
    if (this.g) {
        if (this.u && a.value) this.response.push(a.value);
        else if (!this.u) {
            var b = a.value ? a.value : new Uint8Array(0);
            if (b = this.A.decode(b, {
                stream: !a.done
            })) this.response = this.responseText += b;
        }
        a.done ? $f4a7ee607ae1ef78$var$pd(this) : $f4a7ee607ae1ef78$var$od(this);
        3 == this.readyState && $f4a7ee607ae1ef78$var$qd(this);
    }
};
$f4a7ee607ae1ef78$var$k.Za = function(a) {
    this.g && (this.response = this.responseText = a, $f4a7ee607ae1ef78$var$pd(this));
};
$f4a7ee607ae1ef78$var$k.Ya = function(a) {
    this.g && (this.response = a, $f4a7ee607ae1ef78$var$pd(this));
};
$f4a7ee607ae1ef78$var$k.ka = function() {
    this.g && $f4a7ee607ae1ef78$var$pd(this);
};
function $f4a7ee607ae1ef78$var$pd(a) {
    a.readyState = 4;
    a.l = null;
    a.j = null;
    a.A = null;
    $f4a7ee607ae1ef78$var$od(a);
}
$f4a7ee607ae1ef78$var$k.setRequestHeader = function(a, b) {
    this.v.append(a, b);
};
$f4a7ee607ae1ef78$var$k.getResponseHeader = function(a) {
    return this.h ? this.h.get(a.toLowerCase()) || "" : "";
};
$f4a7ee607ae1ef78$var$k.getAllResponseHeaders = function() {
    if (!this.h) return "";
    const a = [], b = this.h.entries();
    for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
    return a.join("\r\n");
};
function $f4a7ee607ae1ef78$var$od(a) {
    a.onreadystatechange && a.onreadystatechange.call(a);
}
Object.defineProperty($f4a7ee607ae1ef78$var$md.prototype, "withCredentials", {
    get: function() {
        return "include" === this.m;
    },
    set: function(a) {
        this.m = a ? "include" : "same-origin";
    }
});
var $f4a7ee607ae1ef78$var$rd = $f4a7ee607ae1ef78$var$l.JSON.parse;
function $f4a7ee607ae1ef78$var$P(a) {
    $f4a7ee607ae1ef78$var$B.call(this);
    this.headers = new Map;
    this.u = a || null;
    this.h = !1;
    this.C = this.g = null;
    this.I = "";
    this.m = 0;
    this.j = "";
    this.l = this.G = this.v = this.F = !1;
    this.B = 0;
    this.A = null;
    this.K = $f4a7ee607ae1ef78$var$sd;
    this.L = this.M = !1;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$P, $f4a7ee607ae1ef78$var$B);
var $f4a7ee607ae1ef78$var$sd = "", $f4a7ee607ae1ef78$var$td = /^https?$/i, $f4a7ee607ae1ef78$var$ud = [
    "POST",
    "PUT"
];
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$P.prototype;
$f4a7ee607ae1ef78$var$k.Oa = function(a) {
    this.M = a;
};
$f4a7ee607ae1ef78$var$k.ha = function(a, b, c, d) {
    if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.I + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.I = a;
    this.j = "";
    this.m = 0;
    this.F = !1;
    this.h = !0;
    this.g = this.u ? this.u.g() : $f4a7ee607ae1ef78$var$$b.g();
    this.C = this.u ? $f4a7ee607ae1ef78$var$Vb(this.u) : $f4a7ee607ae1ef78$var$Vb($f4a7ee607ae1ef78$var$$b);
    this.g.onreadystatechange = $f4a7ee607ae1ef78$var$q(this.La, this);
    try {
        this.G = !0, this.g.open(b, String(a), !0), this.G = !1;
    } catch (f) {
        $f4a7ee607ae1ef78$var$vd(this, f);
        return;
    }
    a = c || "";
    c = new Map(this.headers);
    if (d) {
        if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
        else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
        else throw Error("Unknown input type for opt_headers: " + String(d));
    }
    d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
    e = $f4a7ee607ae1ef78$var$l.FormData && a instanceof $f4a7ee607ae1ef78$var$l.FormData;
    !(0 <= $f4a7ee607ae1ef78$var$ka($f4a7ee607ae1ef78$var$ud, b)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    for (const [f, h] of c)this.g.setRequestHeader(f, h);
    this.K && (this.g.responseType = this.K);
    "withCredentials" in this.g && this.g.withCredentials !== this.M && (this.g.withCredentials = this.M);
    try {
        $f4a7ee607ae1ef78$var$wd(this), 0 < this.B && ((this.L = $f4a7ee607ae1ef78$var$xd(this.g)) ? (this.g.timeout = this.B, this.g.ontimeout = $f4a7ee607ae1ef78$var$q(this.ua, this)) : this.A = $f4a7ee607ae1ef78$var$yb(this.ua, this.B, this)), this.v = !0, this.g.send(a), this.v = !1;
    } catch (f) {
        $f4a7ee607ae1ef78$var$vd(this, f);
    }
};
function $f4a7ee607ae1ef78$var$xd(a) {
    return $f4a7ee607ae1ef78$var$z && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
$f4a7ee607ae1ef78$var$k.ua = function() {
    "undefined" != typeof $f4a7ee607ae1ef78$var$goog && this.g && (this.j = "Timed out after " + this.B + "ms, aborting", this.m = 8, $f4a7ee607ae1ef78$var$C(this, "timeout"), this.abort(8));
};
function $f4a7ee607ae1ef78$var$vd(a, b) {
    a.h = !1;
    a.g && (a.l = !0, a.g.abort(), a.l = !1);
    a.j = b;
    a.m = 5;
    $f4a7ee607ae1ef78$var$yd(a);
    $f4a7ee607ae1ef78$var$zd(a);
}
function $f4a7ee607ae1ef78$var$yd(a) {
    a.F || (a.F = !0, $f4a7ee607ae1ef78$var$C(a, "complete"), $f4a7ee607ae1ef78$var$C(a, "error"));
}
$f4a7ee607ae1ef78$var$k.abort = function(a) {
    this.g && this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1, this.m = a || 7, $f4a7ee607ae1ef78$var$C(this, "complete"), $f4a7ee607ae1ef78$var$C(this, "abort"), $f4a7ee607ae1ef78$var$zd(this));
};
$f4a7ee607ae1ef78$var$k.N = function() {
    this.g && (this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1), $f4a7ee607ae1ef78$var$zd(this, !0));
    $f4a7ee607ae1ef78$var$P.$.N.call(this);
};
$f4a7ee607ae1ef78$var$k.La = function() {
    this.s || (this.G || this.v || this.l ? $f4a7ee607ae1ef78$var$Ad(this) : this.kb());
};
$f4a7ee607ae1ef78$var$k.kb = function() {
    $f4a7ee607ae1ef78$var$Ad(this);
};
function $f4a7ee607ae1ef78$var$Ad(a) {
    if (a.h && "undefined" != typeof $f4a7ee607ae1ef78$var$goog && (!a.C[1] || 4 != $f4a7ee607ae1ef78$var$H(a) || 2 != a.da())) {
        if (a.v && 4 == $f4a7ee607ae1ef78$var$H(a)) $f4a7ee607ae1ef78$var$yb(a.La, 0, a);
        else if ($f4a7ee607ae1ef78$var$C(a, "readystatechange"), 4 == $f4a7ee607ae1ef78$var$H(a)) {
            a.h = !1;
            try {
                const h = a.da();
                a: switch(h){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var b = !0;
                        break a;
                    default:
                        b = !1;
                }
                var c;
                if (!(c = b)) {
                    var d;
                    if (d = 0 === h) {
                        var e = String(a.I).match($f4a7ee607ae1ef78$var$Lc)[1] || null;
                        !e && $f4a7ee607ae1ef78$var$l.self && $f4a7ee607ae1ef78$var$l.self.location && (e = $f4a7ee607ae1ef78$var$l.self.location.protocol.slice(0, -1));
                        d = !$f4a7ee607ae1ef78$var$td.test(e ? e.toLowerCase() : "");
                    }
                    c = d;
                }
                if (c) $f4a7ee607ae1ef78$var$C(a, "complete"), $f4a7ee607ae1ef78$var$C(a, "success");
                else {
                    a.m = 6;
                    try {
                        var f = 2 < $f4a7ee607ae1ef78$var$H(a) ? a.g.statusText : "";
                    } catch (n) {
                        f = "";
                    }
                    a.j = f + " [" + a.da() + "]";
                    $f4a7ee607ae1ef78$var$yd(a);
                }
            } finally{
                $f4a7ee607ae1ef78$var$zd(a);
            }
        }
    }
}
function $f4a7ee607ae1ef78$var$zd(a, b) {
    if (a.g) {
        $f4a7ee607ae1ef78$var$wd(a);
        const c = a.g, d = a.C[0] ? ()=>{} : null;
        a.g = null;
        a.C = null;
        b || $f4a7ee607ae1ef78$var$C(a, "ready");
        try {
            c.onreadystatechange = d;
        } catch (e) {}
    }
}
function $f4a7ee607ae1ef78$var$wd(a) {
    a.g && a.L && (a.g.ontimeout = null);
    a.A && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.A), a.A = null);
}
$f4a7ee607ae1ef78$var$k.isActive = function() {
    return !!this.g;
};
function $f4a7ee607ae1ef78$var$H(a) {
    return a.g ? a.g.readyState : 0;
}
$f4a7ee607ae1ef78$var$k.da = function() {
    try {
        return 2 < $f4a7ee607ae1ef78$var$H(this) ? this.g.status : -1;
    } catch (a) {
        return -1;
    }
};
$f4a7ee607ae1ef78$var$k.ja = function() {
    try {
        return this.g ? this.g.responseText : "";
    } catch (a) {
        return "";
    }
};
$f4a7ee607ae1ef78$var$k.Wa = function(a) {
    if (this.g) {
        var b = this.g.responseText;
        a && 0 == b.indexOf(a) && (b = b.substring(a.length));
        return $f4a7ee607ae1ef78$var$rd(b);
    }
};
function $f4a7ee607ae1ef78$var$mc(a) {
    try {
        if (!a.g) return null;
        if ("response" in a.g) return a.g.response;
        switch(a.K){
            case $f4a7ee607ae1ef78$var$sd:
            case "text":
                return a.g.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
        }
        return null;
    } catch (b) {
        return null;
    }
}
function $f4a7ee607ae1ef78$var$tc(a) {
    const b = {};
    a = (a.g && 2 <= $f4a7ee607ae1ef78$var$H(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
    for(let d = 0; d < a.length; d++){
        if ($f4a7ee607ae1ef78$var$x(a[d])) continue;
        var c = $f4a7ee607ae1ef78$var$qb(a[d]);
        const e = c[0];
        c = c[1];
        if ("string" !== typeof c) continue;
        c = c.trim();
        const f = b[e] || [];
        b[e] = f;
        f.push(c);
    }
    $f4a7ee607ae1ef78$var$Oa(b, function(d) {
        return d.join(", ");
    });
}
$f4a7ee607ae1ef78$var$k.Ia = function() {
    return this.m;
};
$f4a7ee607ae1ef78$var$k.Sa = function() {
    return "string" === typeof this.j ? this.j : String(this.j);
};
function $f4a7ee607ae1ef78$var$Bd(a) {
    let b = "";
    $f4a7ee607ae1ef78$var$Na(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $f4a7ee607ae1ef78$var$Cd(a, b, c) {
    a: {
        for(d in c){
            var d = !1;
            break a;
        }
        d = !0;
    }
    d || (c = $f4a7ee607ae1ef78$var$Bd(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : $f4a7ee607ae1ef78$var$K(a, b, c));
}
function $f4a7ee607ae1ef78$var$Dd(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
}
function $f4a7ee607ae1ef78$var$Ed(a) {
    this.Ga = 0;
    this.j = [];
    this.l = new $f4a7ee607ae1ef78$var$Gb;
    this.pa = this.wa = this.I = this.Y = this.g = this.Da = this.F = this.na = this.o = this.U = this.s = null;
    this.fb = this.W = 0;
    this.cb = $f4a7ee607ae1ef78$var$Dd("failFast", !1, a);
    this.G = this.v = this.u = this.m = this.h = null;
    this.aa = !0;
    this.Fa = this.V = -1;
    this.ba = this.A = this.C = 0;
    this.ab = $f4a7ee607ae1ef78$var$Dd("baseRetryDelayMs", 5E3, a);
    this.hb = $f4a7ee607ae1ef78$var$Dd("retryDelaySeedMs", 1E4, a);
    this.eb = $f4a7ee607ae1ef78$var$Dd("forwardChannelMaxRetries", 2, a);
    this.xa = $f4a7ee607ae1ef78$var$Dd("forwardChannelRequestTimeoutMs", 2E4, a);
    this.va = a && a.xmlHttpFactory || void 0;
    this.Ha = a && a.dc || !1;
    this.L = void 0;
    this.J = a && a.supportsCrossDomainXhr || !1;
    this.K = "";
    this.i = new $f4a7ee607ae1ef78$var$cd(a && a.concurrentRequestLimit);
    this.Ja = new $f4a7ee607ae1ef78$var$hd;
    this.P = a && a.fastHandshake || !1;
    this.O = a && a.encodeInitMessageHeaders || !1;
    this.P && this.O && (this.O = !1);
    this.bb = a && a.bc || !1;
    a && a.Ea && this.l.Ea();
    a && a.forceLongPolling && (this.aa = !1);
    this.ca = !this.P && this.aa && a && a.detectBufferingProxy || !1;
    this.qa = void 0;
    a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.qa = a.longPollingTimeout);
    this.oa = void 0;
    this.S = 0;
    this.M = !1;
    this.ma = this.B = null;
}
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$Ed.prototype;
$f4a7ee607ae1ef78$var$k.ra = 8;
$f4a7ee607ae1ef78$var$k.H = 1;
function $f4a7ee607ae1ef78$var$Hc(a) {
    $f4a7ee607ae1ef78$var$Fd(a);
    if (3 == a.H) {
        var b = a.W++, c = $f4a7ee607ae1ef78$var$G(a.I);
        $f4a7ee607ae1ef78$var$K(c, "SID", a.K);
        $f4a7ee607ae1ef78$var$K(c, "RID", b);
        $f4a7ee607ae1ef78$var$K(c, "TYPE", "terminate");
        $f4a7ee607ae1ef78$var$Gd(a, c);
        b = new $f4a7ee607ae1ef78$var$bc(a, a.l, b);
        b.L = 2;
        b.v = $f4a7ee607ae1ef78$var$hc($f4a7ee607ae1ef78$var$G(c));
        c = !1;
        if ($f4a7ee607ae1ef78$var$l.navigator && $f4a7ee607ae1ef78$var$l.navigator.sendBeacon) try {
            c = $f4a7ee607ae1ef78$var$l.navigator.sendBeacon(b.v.toString(), "");
        } catch (d) {}
        !c && $f4a7ee607ae1ef78$var$l.Image && ((new Image).src = b.v, c = !0);
        c || (b.g = $f4a7ee607ae1ef78$var$lc(b.l, null), b.g.ha(b.v));
        b.G = Date.now();
        $f4a7ee607ae1ef78$var$jc(b);
    }
    $f4a7ee607ae1ef78$var$Hd(a);
}
function $f4a7ee607ae1ef78$var$zc(a) {
    a.g && ($f4a7ee607ae1ef78$var$vc(a), a.g.cancel(), a.g = null);
}
function $f4a7ee607ae1ef78$var$Fd(a) {
    $f4a7ee607ae1ef78$var$zc(a);
    a.u && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.u), a.u = null);
    $f4a7ee607ae1ef78$var$yc(a);
    a.i.cancel();
    a.m && ("number" === typeof a.m && $f4a7ee607ae1ef78$var$l.clearTimeout(a.m), a.m = null);
}
function $f4a7ee607ae1ef78$var$Gc(a) {
    if (!$f4a7ee607ae1ef78$var$ed(a.i) && !a.m) {
        a.m = !0;
        var b = a.Na;
        $f4a7ee607ae1ef78$var$sb || $f4a7ee607ae1ef78$var$vb();
        $f4a7ee607ae1ef78$var$tb || ($f4a7ee607ae1ef78$var$sb(), $f4a7ee607ae1ef78$var$tb = !0);
        $f4a7ee607ae1ef78$var$mb.add(b, a);
        a.C = 0;
    }
}
function $f4a7ee607ae1ef78$var$Id(a, b) {
    if ($f4a7ee607ae1ef78$var$Bc(a.i) >= a.i.j - (a.m ? 1 : 0)) return !1;
    if (a.m) return a.j = b.F.concat(a.j), !0;
    if (1 == a.H || 2 == a.H || a.C >= (a.cb ? 0 : a.eb)) return !1;
    a.m = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(a.Na, a, b), $f4a7ee607ae1ef78$var$Jd(a, a.C));
    a.C++;
    return !0;
}
$f4a7ee607ae1ef78$var$k.Na = function(a) {
    if (this.m) {
        if (this.m = null, 1 == this.H) {
            if (!a) {
                this.W = Math.floor(1E5 * Math.random());
                a = this.W++;
                const e = new $f4a7ee607ae1ef78$var$bc(this, this.l, a);
                let f = this.s;
                this.U && (f ? (f = $f4a7ee607ae1ef78$var$Pa(f), $f4a7ee607ae1ef78$var$Ra(f, this.U)) : f = this.U);
                null !== this.o || this.O || (e.I = f, f = null);
                if (this.P) a: {
                    var b = 0;
                    for(var c = 0; c < this.j.length; c++){
                        b: {
                            var d = this.j[c];
                            if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                d = d.length;
                                break b;
                            }
                            d = void 0;
                        }
                        if (void 0 === d) break;
                        b += d;
                        if (4096 < b) {
                            b = c;
                            break a;
                        }
                        if (4096 === b || c === this.j.length - 1) {
                            b = c + 1;
                            break a;
                        }
                    }
                    b = 1E3;
                }
                else b = 1E3;
                b = $f4a7ee607ae1ef78$var$Kd(this, e, b);
                c = $f4a7ee607ae1ef78$var$G(this.I);
                $f4a7ee607ae1ef78$var$K(c, "RID", a);
                $f4a7ee607ae1ef78$var$K(c, "CVER", 22);
                this.F && $f4a7ee607ae1ef78$var$K(c, "X-HTTP-Session-Id", this.F);
                $f4a7ee607ae1ef78$var$Gd(this, c);
                f && (this.O ? b = "headers=" + encodeURIComponent(String($f4a7ee607ae1ef78$var$Bd(f))) + "&" + b : this.o && $f4a7ee607ae1ef78$var$Cd(c, this.o, f));
                $f4a7ee607ae1ef78$var$Cc(this.i, e);
                this.bb && $f4a7ee607ae1ef78$var$K(c, "TYPE", "init");
                this.P ? ($f4a7ee607ae1ef78$var$K(c, "$req", b), $f4a7ee607ae1ef78$var$K(c, "SID", "null"), e.aa = !0, $f4a7ee607ae1ef78$var$gc(e, c, null)) : $f4a7ee607ae1ef78$var$gc(e, c, b);
                this.H = 2;
            }
        } else 3 == this.H && (a ? $f4a7ee607ae1ef78$var$Ld(this, a) : 0 == this.j.length || $f4a7ee607ae1ef78$var$ed(this.i) || $f4a7ee607ae1ef78$var$Ld(this));
    }
};
function $f4a7ee607ae1ef78$var$Ld(a, b) {
    var c;
    b ? c = b.m : c = a.W++;
    const d = $f4a7ee607ae1ef78$var$G(a.I);
    $f4a7ee607ae1ef78$var$K(d, "SID", a.K);
    $f4a7ee607ae1ef78$var$K(d, "RID", c);
    $f4a7ee607ae1ef78$var$K(d, "AID", a.V);
    $f4a7ee607ae1ef78$var$Gd(a, d);
    a.o && a.s && $f4a7ee607ae1ef78$var$Cd(d, a.o, a.s);
    c = new $f4a7ee607ae1ef78$var$bc(a, a.l, c, a.C + 1);
    null === a.o && (c.I = a.s);
    b && (a.j = b.F.concat(a.j));
    b = $f4a7ee607ae1ef78$var$Kd(a, c, 1E3);
    c.setTimeout(Math.round(.5 * a.xa) + Math.round(.5 * a.xa * Math.random()));
    $f4a7ee607ae1ef78$var$Cc(a.i, c);
    $f4a7ee607ae1ef78$var$gc(c, d, b);
}
function $f4a7ee607ae1ef78$var$Gd(a, b) {
    a.na && $f4a7ee607ae1ef78$var$Na(a.na, function(c, d) {
        $f4a7ee607ae1ef78$var$K(b, d, c);
    });
    a.h && $f4a7ee607ae1ef78$var$Kc({}, function(c, d) {
        $f4a7ee607ae1ef78$var$K(b, d, c);
    });
}
function $f4a7ee607ae1ef78$var$Kd(a, b, c) {
    c = Math.min(a.j.length, c);
    var d = a.h ? $f4a7ee607ae1ef78$var$q(a.h.Va, a.h, a) : null;
    a: {
        var e = a.j;
        let f = -1;
        for(;;){
            const h = [
                "count=" + c
            ];
            -1 == f ? 0 < c ? (f = e[0].g, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
            let n = !0;
            for(let t = 0; t < c; t++){
                let m = e[t].g;
                const u = e[t].map;
                m -= f;
                if (0 > m) f = Math.max(0, e[t].g - 100), n = !1;
                else try {
                    $f4a7ee607ae1ef78$var$id(u, h, "req" + m + "_");
                } catch (L) {
                    d && d(u);
                }
            }
            if (n) {
                d = h.join("&");
                break a;
            }
        }
    }
    a = a.j.splice(0, c);
    b.F = a;
    return d;
}
function $f4a7ee607ae1ef78$var$Fc(a) {
    if (!a.g && !a.u) {
        a.ba = 1;
        var b = a.Ma;
        $f4a7ee607ae1ef78$var$sb || $f4a7ee607ae1ef78$var$vb();
        $f4a7ee607ae1ef78$var$tb || ($f4a7ee607ae1ef78$var$sb(), $f4a7ee607ae1ef78$var$tb = !0);
        $f4a7ee607ae1ef78$var$mb.add(b, a);
        a.A = 0;
    }
}
function $f4a7ee607ae1ef78$var$Ac(a) {
    if (a.g || a.u || 3 <= a.A) return !1;
    a.ba++;
    a.u = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(a.Ma, a), $f4a7ee607ae1ef78$var$Jd(a, a.A));
    a.A++;
    return !0;
}
$f4a7ee607ae1ef78$var$k.Ma = function() {
    this.u = null;
    $f4a7ee607ae1ef78$var$Md(this);
    if (this.ca && !(this.M || null == this.g || 0 >= this.S)) {
        var a = 2 * this.S;
        this.l.info("BP detection timer enabled: " + a);
        this.B = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(this.jb, this), a);
    }
};
$f4a7ee607ae1ef78$var$k.jb = function() {
    this.B && (this.B = null, this.l.info("BP detection timeout reached."), this.l.info("Buffering proxy detected and switch to long-polling!"), this.G = !1, this.M = !0, $f4a7ee607ae1ef78$var$F(10), $f4a7ee607ae1ef78$var$zc(this), $f4a7ee607ae1ef78$var$Md(this));
};
function $f4a7ee607ae1ef78$var$vc(a) {
    null != a.B && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.B), a.B = null);
}
function $f4a7ee607ae1ef78$var$Md(a) {
    a.g = new $f4a7ee607ae1ef78$var$bc(a, a.l, "rpc", a.ba);
    null === a.o && (a.g.I = a.s);
    a.g.O = 0;
    var b = $f4a7ee607ae1ef78$var$G(a.wa);
    $f4a7ee607ae1ef78$var$K(b, "RID", "rpc");
    $f4a7ee607ae1ef78$var$K(b, "SID", a.K);
    $f4a7ee607ae1ef78$var$K(b, "AID", a.V);
    $f4a7ee607ae1ef78$var$K(b, "CI", a.G ? "0" : "1");
    !a.G && a.qa && $f4a7ee607ae1ef78$var$K(b, "TO", a.qa);
    $f4a7ee607ae1ef78$var$K(b, "TYPE", "xmlhttp");
    $f4a7ee607ae1ef78$var$Gd(a, b);
    a.o && a.s && $f4a7ee607ae1ef78$var$Cd(b, a.o, a.s);
    a.L && a.g.setTimeout(a.L);
    var c = a.g;
    a = a.pa;
    c.L = 1;
    c.v = $f4a7ee607ae1ef78$var$hc($f4a7ee607ae1ef78$var$G(b));
    c.s = null;
    c.S = !0;
    $f4a7ee607ae1ef78$var$ic(c, a);
}
$f4a7ee607ae1ef78$var$k.ib = function() {
    null != this.v && (this.v = null, $f4a7ee607ae1ef78$var$zc(this), $f4a7ee607ae1ef78$var$Ac(this), $f4a7ee607ae1ef78$var$F(19));
};
function $f4a7ee607ae1ef78$var$yc(a) {
    null != a.v && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.v), a.v = null);
}
function $f4a7ee607ae1ef78$var$sc(a, b) {
    var c = null;
    if (a.g == b) {
        $f4a7ee607ae1ef78$var$yc(a);
        $f4a7ee607ae1ef78$var$vc(a);
        a.g = null;
        var d = 2;
    } else if ($f4a7ee607ae1ef78$var$xc(a.i, b)) c = b.F, $f4a7ee607ae1ef78$var$Ec(a.i, b), d = 1;
    else return;
    if (0 != a.H) {
        if (b.i) {
            if (1 == d) {
                c = b.s ? b.s.length : 0;
                b = Date.now() - b.G;
                var e = a.C;
                d = $f4a7ee607ae1ef78$var$Mb();
                $f4a7ee607ae1ef78$var$C(d, new $f4a7ee607ae1ef78$var$Qb(d, c));
                $f4a7ee607ae1ef78$var$Gc(a);
            } else $f4a7ee607ae1ef78$var$Fc(a);
        } else if (e = b.o, 3 == e || 0 == e && 0 < b.ca || !(1 == d && $f4a7ee607ae1ef78$var$Id(a, b) || 2 == d && $f4a7ee607ae1ef78$var$Ac(a))) switch(c && 0 < c.length && (b = a.i, b.i = b.i.concat(c)), e){
            case 1:
                $f4a7ee607ae1ef78$var$J(a, 5);
                break;
            case 4:
                $f4a7ee607ae1ef78$var$J(a, 10);
                break;
            case 3:
                $f4a7ee607ae1ef78$var$J(a, 6);
                break;
            default:
                $f4a7ee607ae1ef78$var$J(a, 2);
        }
    }
}
function $f4a7ee607ae1ef78$var$Jd(a, b) {
    let c = a.ab + Math.floor(Math.random() * a.hb);
    a.isActive() || (c *= 2);
    return c * b;
}
function $f4a7ee607ae1ef78$var$J(a, b) {
    a.l.info("Error code " + b);
    if (2 == b) {
        var c = null;
        a.h && (c = null);
        var d = $f4a7ee607ae1ef78$var$q(a.pb, a);
        c || (c = new $f4a7ee607ae1ef78$var$M("//www.google.com/images/cleardot.gif"), $f4a7ee607ae1ef78$var$l.location && "http" == $f4a7ee607ae1ef78$var$l.location.protocol || $f4a7ee607ae1ef78$var$Nc(c, "https"), $f4a7ee607ae1ef78$var$hc(c));
        $f4a7ee607ae1ef78$var$jd(c.toString(), d);
    } else $f4a7ee607ae1ef78$var$F(2);
    a.H = 0;
    a.h && a.h.za(b);
    $f4a7ee607ae1ef78$var$Hd(a);
    $f4a7ee607ae1ef78$var$Fd(a);
}
$f4a7ee607ae1ef78$var$k.pb = function(a) {
    a ? (this.l.info("Successfully pinged google.com"), $f4a7ee607ae1ef78$var$F(2)) : (this.l.info("Failed to ping google.com"), $f4a7ee607ae1ef78$var$F(1));
};
function $f4a7ee607ae1ef78$var$Hd(a) {
    a.H = 0;
    a.ma = [];
    if (a.h) {
        const b = $f4a7ee607ae1ef78$var$fd(a.i);
        if (0 != b.length || 0 != a.j.length) $f4a7ee607ae1ef78$var$na(a.ma, b), $f4a7ee607ae1ef78$var$na(a.ma, a.j), a.i.i.length = 0, $f4a7ee607ae1ef78$var$ma(a.j), a.j.length = 0;
        a.h.ya();
    }
}
function $f4a7ee607ae1ef78$var$Dc(a, b, c) {
    var d = c instanceof $f4a7ee607ae1ef78$var$M ? $f4a7ee607ae1ef78$var$G(c) : new $f4a7ee607ae1ef78$var$M(c);
    if ("" != d.g) b && (d.g = b + "." + d.g), $f4a7ee607ae1ef78$var$Oc(d, d.m);
    else {
        var e = $f4a7ee607ae1ef78$var$l.location;
        d = e.protocol;
        b = b ? b + "." + e.hostname : e.hostname;
        e = +e.port;
        var f = new $f4a7ee607ae1ef78$var$M(null);
        d && $f4a7ee607ae1ef78$var$Nc(f, d);
        b && (f.g = b);
        e && $f4a7ee607ae1ef78$var$Oc(f, e);
        c && (f.l = c);
        d = f;
    }
    c = a.F;
    b = a.Da;
    c && b && $f4a7ee607ae1ef78$var$K(d, c, b);
    $f4a7ee607ae1ef78$var$K(d, "VER", a.ra);
    $f4a7ee607ae1ef78$var$Gd(a, d);
    return d;
}
function $f4a7ee607ae1ef78$var$lc(a, b, c) {
    if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
    b = c && a.Ha && !a.va ? new $f4a7ee607ae1ef78$var$P(new $f4a7ee607ae1ef78$var$ld({
        ob: !0
    })) : new $f4a7ee607ae1ef78$var$P(a.va);
    b.Oa(a.J);
    return b;
}
$f4a7ee607ae1ef78$var$k.isActive = function() {
    return !!this.h && this.h.isActive(this);
};
function $f4a7ee607ae1ef78$var$Nd() {}
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$Nd.prototype;
$f4a7ee607ae1ef78$var$k.Ba = function() {};
$f4a7ee607ae1ef78$var$k.Aa = function() {};
$f4a7ee607ae1ef78$var$k.za = function() {};
$f4a7ee607ae1ef78$var$k.ya = function() {};
$f4a7ee607ae1ef78$var$k.isActive = function() {
    return !0;
};
$f4a7ee607ae1ef78$var$k.Va = function() {};
function $f4a7ee607ae1ef78$var$Od() {
    if ($f4a7ee607ae1ef78$var$z && !(10 <= Number($f4a7ee607ae1ef78$var$Fa))) throw Error("Environmental error: no available transport.");
}
$f4a7ee607ae1ef78$var$Od.prototype.g = function(a, b) {
    return new $f4a7ee607ae1ef78$var$Q(a, b);
};
function $f4a7ee607ae1ef78$var$Q(a, b) {
    $f4a7ee607ae1ef78$var$B.call(this);
    this.g = new $f4a7ee607ae1ef78$var$Ed(b);
    this.l = a;
    this.h = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
        "X-Client-Protocol": "webchannel"
    });
    this.g.s = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
        "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.Ca && (a ? a["X-WebChannel-Client-Profile"] = b.Ca : a = {
        "X-WebChannel-Client-Profile": b.Ca
    });
    this.g.U = a;
    (a = b && b.cc) && !$f4a7ee607ae1ef78$var$x(a) && (this.g.o = a);
    this.A = b && b.supportsCrossDomainXhr || !1;
    this.v = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !$f4a7ee607ae1ef78$var$x(b) && (this.g.F = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
    this.j = new $f4a7ee607ae1ef78$var$R(this);
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Q, $f4a7ee607ae1ef78$var$B);
$f4a7ee607ae1ef78$var$Q.prototype.m = function() {
    this.g.h = this.j;
    this.A && (this.g.J = !0);
    var a = this.g, b = this.l, c = this.h || void 0;
    $f4a7ee607ae1ef78$var$F(0);
    a.Y = b;
    a.na = c || {};
    a.G = a.aa;
    a.I = $f4a7ee607ae1ef78$var$Dc(a, null, a.Y);
    $f4a7ee607ae1ef78$var$Gc(a);
};
$f4a7ee607ae1ef78$var$Q.prototype.close = function() {
    $f4a7ee607ae1ef78$var$Hc(this.g);
};
$f4a7ee607ae1ef78$var$Q.prototype.u = function(a) {
    var b = this.g;
    if ("string" === typeof a) {
        var c = {};
        c.__data__ = a;
        a = c;
    } else this.v && (c = {}, c.__data__ = $f4a7ee607ae1ef78$var$jb(a), a = c);
    b.j.push(new $f4a7ee607ae1ef78$var$bd(b.fb++, a));
    3 == b.H && $f4a7ee607ae1ef78$var$Gc(b);
};
$f4a7ee607ae1ef78$var$Q.prototype.N = function() {
    this.g.h = null;
    delete this.j;
    $f4a7ee607ae1ef78$var$Hc(this.g);
    delete this.g;
    $f4a7ee607ae1ef78$var$Q.$.N.call(this);
};
function $f4a7ee607ae1ef78$var$Pd(a) {
    $f4a7ee607ae1ef78$var$Yb.call(this);
    a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
    var b = a.__sm__;
    if (b) {
        a: {
            for(const c in b){
                a = c;
                break a;
            }
            a = void 0;
        }
        if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
        this.data = b;
    } else this.data = a;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Pd, $f4a7ee607ae1ef78$var$Yb);
function $f4a7ee607ae1ef78$var$Qd() {
    $f4a7ee607ae1ef78$var$Zb.call(this);
    this.status = 1;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Qd, $f4a7ee607ae1ef78$var$Zb);
function $f4a7ee607ae1ef78$var$R(a) {
    this.g = a;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$R, $f4a7ee607ae1ef78$var$Nd);
$f4a7ee607ae1ef78$var$R.prototype.Ba = function() {
    $f4a7ee607ae1ef78$var$C(this.g, "a");
};
$f4a7ee607ae1ef78$var$R.prototype.Aa = function(a) {
    $f4a7ee607ae1ef78$var$C(this.g, new $f4a7ee607ae1ef78$var$Pd(a));
};
$f4a7ee607ae1ef78$var$R.prototype.za = function(a) {
    $f4a7ee607ae1ef78$var$C(this.g, new $f4a7ee607ae1ef78$var$Qd());
};
$f4a7ee607ae1ef78$var$R.prototype.ya = function() {
    $f4a7ee607ae1ef78$var$C(this.g, "b");
};
function $f4a7ee607ae1ef78$var$Rd() {
    this.blockSize = -1;
}
function $f4a7ee607ae1ef78$var$S() {
    this.blockSize = -1;
    this.blockSize = 64;
    this.g = Array(4);
    this.m = Array(this.blockSize);
    this.i = this.h = 0;
    this.reset();
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$S, $f4a7ee607ae1ef78$var$Rd);
$f4a7ee607ae1ef78$var$S.prototype.reset = function() {
    this.g[0] = 1732584193;
    this.g[1] = 4023233417;
    this.g[2] = 2562383102;
    this.g[3] = 271733878;
    this.i = this.h = 0;
};
function $f4a7ee607ae1ef78$var$Sd(a, b, c) {
    c || (c = 0);
    var d = Array(16);
    if ("string" === typeof b) for(var e = 0; 16 > e; ++e)d[e] = b.charCodeAt(c++) | b.charCodeAt(c++) << 8 | b.charCodeAt(c++) << 16 | b.charCodeAt(c++) << 24;
    else for(e = 0; 16 > e; ++e)d[e] = b[c++] | b[c++] << 8 | b[c++] << 16 | b[c++] << 24;
    b = a.g[0];
    c = a.g[1];
    e = a.g[2];
    var f = a.g[3];
    var h = b + (f ^ c & (e ^ f)) + d[0] + 3614090360 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[1] + 3905402710 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[2] + 606105819 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[3] + 3250441966 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[4] + 4118548399 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[5] + 1200080426 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[6] + 2821735955 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[7] + 4249261313 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[8] + 1770035416 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[9] + 2336552879 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[10] + 4294925233 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[11] + 2304563134 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[12] + 1804603682 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[13] + 4254626195 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[14] + 2792965006 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[15] + 1236535329 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (e ^ f & (c ^ e)) + d[1] + 4129170786 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[6] + 3225465664 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[11] + 643717713 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[0] + 3921069994 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[5] + 3593408605 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[10] + 38016083 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[15] + 3634488961 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[4] + 3889429448 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[9] + 568446438 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[14] + 3275163606 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[3] + 4107603335 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[8] + 1163531501 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[13] + 2850285829 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[2] + 4243563512 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[7] + 1735328473 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[12] + 2368359562 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (c ^ e ^ f) + d[5] + 4294588738 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[8] + 2272392833 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[11] + 1839030562 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[14] + 4259657740 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[1] + 2763975236 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[4] + 1272893353 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[7] + 4139469664 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[10] + 3200236656 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[13] + 681279174 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[0] + 3936430074 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[3] + 3572445317 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[6] + 76029189 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[9] + 3654602809 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[12] + 3873151461 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[15] + 530742520 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[2] + 3299628645 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (e ^ (c | ~f)) + d[0] + 4096336452 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[7] + 1126891415 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[14] + 2878612391 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[5] + 4237533241 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[12] + 1700485571 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[3] + 2399980690 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[10] + 4293915773 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[1] + 2240044497 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[8] + 1873313359 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[15] + 4264355552 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[6] + 2734768916 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[13] + 1309151649 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[4] + 4149444226 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[11] + 3174756917 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[2] + 718787259 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[9] + 3951481745 & 4294967295;
    a.g[0] = a.g[0] + b & 4294967295;
    a.g[1] = a.g[1] + (e + (h << 21 & 4294967295 | h >>> 11)) & 4294967295;
    a.g[2] = a.g[2] + e & 4294967295;
    a.g[3] = a.g[3] + f & 4294967295;
}
$f4a7ee607ae1ef78$var$S.prototype.j = function(a, b) {
    void 0 === b && (b = a.length);
    for(var c = b - this.blockSize, d = this.m, e = this.h, f = 0; f < b;){
        if (0 == e) for(; f <= c;)$f4a7ee607ae1ef78$var$Sd(this, a, f), f += this.blockSize;
        if ("string" === typeof a) {
            for(; f < b;)if (d[e++] = a.charCodeAt(f++), e == this.blockSize) {
                $f4a7ee607ae1ef78$var$Sd(this, d);
                e = 0;
                break;
            }
        } else for(; f < b;)if (d[e++] = a[f++], e == this.blockSize) {
            $f4a7ee607ae1ef78$var$Sd(this, d);
            e = 0;
            break;
        }
    }
    this.h = e;
    this.i += b;
};
$f4a7ee607ae1ef78$var$S.prototype.l = function() {
    var a = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
    a[0] = 128;
    for(var b = 1; b < a.length - 8; ++b)a[b] = 0;
    var c = 8 * this.i;
    for(b = a.length - 8; b < a.length; ++b)a[b] = c & 255, c /= 256;
    this.j(a);
    a = Array(16);
    for(b = c = 0; 4 > b; ++b)for(var d = 0; 32 > d; d += 8)a[c++] = this.g[b] >>> d & 255;
    return a;
};
function $f4a7ee607ae1ef78$var$T(a, b) {
    this.h = b;
    for(var c = [], d = !0, e = a.length - 1; 0 <= e; e--){
        var f = a[e] | 0;
        d && f == b || (c[e] = f, d = !1);
    }
    this.g = c;
}
var $f4a7ee607ae1ef78$var$sa = {};
function $f4a7ee607ae1ef78$var$Td(a) {
    return -128 <= a && 128 > a ? $f4a7ee607ae1ef78$var$ra(a, function(b) {
        return new $f4a7ee607ae1ef78$var$T([
            b | 0
        ], 0 > b ? -1 : 0);
    }) : new $f4a7ee607ae1ef78$var$T([
        a | 0
    ], 0 > a ? -1 : 0);
}
function $f4a7ee607ae1ef78$var$U(a) {
    if (isNaN(a) || !isFinite(a)) return $f4a7ee607ae1ef78$var$V;
    if (0 > a) return $f4a7ee607ae1ef78$var$W($f4a7ee607ae1ef78$var$U(-a));
    for(var b = [], c = 1, d = 0; a >= c; d++)b[d] = a / c | 0, c *= $f4a7ee607ae1ef78$var$Ud;
    return new $f4a7ee607ae1ef78$var$T(b, 0);
}
function $f4a7ee607ae1ef78$var$Vd(a, b) {
    if (0 == a.length) throw Error("number format error: empty string");
    b = b || 10;
    if (2 > b || 36 < b) throw Error("radix out of range: " + b);
    if ("-" == a.charAt(0)) return $f4a7ee607ae1ef78$var$W($f4a7ee607ae1ef78$var$Vd(a.substring(1), b));
    if (0 <= a.indexOf("-")) throw Error('number format error: interior "-" character');
    for(var c = $f4a7ee607ae1ef78$var$U(Math.pow(b, 8)), d = $f4a7ee607ae1ef78$var$V, e = 0; e < a.length; e += 8){
        var f = Math.min(8, a.length - e), h = parseInt(a.substring(e, e + f), b);
        8 > f ? (f = $f4a7ee607ae1ef78$var$U(Math.pow(b, f)), d = d.R(f).add($f4a7ee607ae1ef78$var$U(h))) : (d = d.R(c), d = d.add($f4a7ee607ae1ef78$var$U(h)));
    }
    return d;
}
var $f4a7ee607ae1ef78$var$Ud = 4294967296, $f4a7ee607ae1ef78$var$V = $f4a7ee607ae1ef78$var$Td(0), $f4a7ee607ae1ef78$var$Wd = $f4a7ee607ae1ef78$var$Td(1), $f4a7ee607ae1ef78$var$Xd = $f4a7ee607ae1ef78$var$Td(16777216);
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$T.prototype;
$f4a7ee607ae1ef78$var$k.ea = function() {
    if ($f4a7ee607ae1ef78$var$X(this)) return -$f4a7ee607ae1ef78$var$W(this).ea();
    for(var a = 0, b = 1, c = 0; c < this.g.length; c++){
        var d = this.D(c);
        a += (0 <= d ? d : $f4a7ee607ae1ef78$var$Ud + d) * b;
        b *= $f4a7ee607ae1ef78$var$Ud;
    }
    return a;
};
$f4a7ee607ae1ef78$var$k.toString = function(a) {
    a = a || 10;
    if (2 > a || 36 < a) throw Error("radix out of range: " + a);
    if ($f4a7ee607ae1ef78$var$Y(this)) return "0";
    if ($f4a7ee607ae1ef78$var$X(this)) return "-" + $f4a7ee607ae1ef78$var$W(this).toString(a);
    for(var b = $f4a7ee607ae1ef78$var$U(Math.pow(a, 6)), c = this, d = "";;){
        var e = $f4a7ee607ae1ef78$var$Yd(c, b).g;
        c = $f4a7ee607ae1ef78$var$Zd(c, e.R(b));
        var f = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(a);
        c = e;
        if ($f4a7ee607ae1ef78$var$Y(c)) return f + d;
        for(; 6 > f.length;)f = "0" + f;
        d = f + d;
    }
};
$f4a7ee607ae1ef78$var$k.D = function(a) {
    return 0 > a ? 0 : a < this.g.length ? this.g[a] : this.h;
};
function $f4a7ee607ae1ef78$var$Y(a) {
    if (0 != a.h) return !1;
    for(var b = 0; b < a.g.length; b++)if (0 != a.g[b]) return !1;
    return !0;
}
function $f4a7ee607ae1ef78$var$X(a) {
    return -1 == a.h;
}
$f4a7ee607ae1ef78$var$k.X = function(a) {
    a = $f4a7ee607ae1ef78$var$Zd(this, a);
    return $f4a7ee607ae1ef78$var$X(a) ? -1 : $f4a7ee607ae1ef78$var$Y(a) ? 0 : 1;
};
function $f4a7ee607ae1ef78$var$W(a) {
    for(var b = a.g.length, c = [], d = 0; d < b; d++)c[d] = ~a.g[d];
    return new $f4a7ee607ae1ef78$var$T(c, ~a.h).add($f4a7ee607ae1ef78$var$Wd);
}
$f4a7ee607ae1ef78$var$k.abs = function() {
    return $f4a7ee607ae1ef78$var$X(this) ? $f4a7ee607ae1ef78$var$W(this) : this;
};
$f4a7ee607ae1ef78$var$k.add = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0, e = 0; e <= b; e++){
        var f = d + (this.D(e) & 65535) + (a.D(e) & 65535), h = (f >>> 16) + (this.D(e) >>> 16) + (a.D(e) >>> 16);
        d = h >>> 16;
        f &= 65535;
        h &= 65535;
        c[e] = h << 16 | f;
    }
    return new $f4a7ee607ae1ef78$var$T(c, c[c.length - 1] & -2147483648 ? -1 : 0);
};
function $f4a7ee607ae1ef78$var$Zd(a, b) {
    return a.add($f4a7ee607ae1ef78$var$W(b));
}
$f4a7ee607ae1ef78$var$k.R = function(a) {
    if ($f4a7ee607ae1ef78$var$Y(this) || $f4a7ee607ae1ef78$var$Y(a)) return $f4a7ee607ae1ef78$var$V;
    if ($f4a7ee607ae1ef78$var$X(this)) return $f4a7ee607ae1ef78$var$X(a) ? $f4a7ee607ae1ef78$var$W(this).R($f4a7ee607ae1ef78$var$W(a)) : $f4a7ee607ae1ef78$var$W($f4a7ee607ae1ef78$var$W(this).R(a));
    if ($f4a7ee607ae1ef78$var$X(a)) return $f4a7ee607ae1ef78$var$W(this.R($f4a7ee607ae1ef78$var$W(a)));
    if (0 > this.X($f4a7ee607ae1ef78$var$Xd) && 0 > a.X($f4a7ee607ae1ef78$var$Xd)) return $f4a7ee607ae1ef78$var$U(this.ea() * a.ea());
    for(var b = this.g.length + a.g.length, c = [], d = 0; d < 2 * b; d++)c[d] = 0;
    for(d = 0; d < this.g.length; d++)for(var e = 0; e < a.g.length; e++){
        var f = this.D(d) >>> 16, h = this.D(d) & 65535, n = a.D(e) >>> 16, t = a.D(e) & 65535;
        c[2 * d + 2 * e] += h * t;
        $f4a7ee607ae1ef78$var$$d(c, 2 * d + 2 * e);
        c[2 * d + 2 * e + 1] += f * t;
        $f4a7ee607ae1ef78$var$$d(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 1] += h * n;
        $f4a7ee607ae1ef78$var$$d(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 2] += f * n;
        $f4a7ee607ae1ef78$var$$d(c, 2 * d + 2 * e + 2);
    }
    for(d = 0; d < b; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
    for(d = b; d < 2 * b; d++)c[d] = 0;
    return new $f4a7ee607ae1ef78$var$T(c, 0);
};
function $f4a7ee607ae1ef78$var$$d(a, b) {
    for(; (a[b] & 65535) != a[b];)a[b + 1] += a[b] >>> 16, a[b] &= 65535, b++;
}
function $f4a7ee607ae1ef78$var$ae(a, b) {
    this.g = a;
    this.h = b;
}
function $f4a7ee607ae1ef78$var$Yd(a, b) {
    if ($f4a7ee607ae1ef78$var$Y(b)) throw Error("division by zero");
    if ($f4a7ee607ae1ef78$var$Y(a)) return new $f4a7ee607ae1ef78$var$ae($f4a7ee607ae1ef78$var$V, $f4a7ee607ae1ef78$var$V);
    if ($f4a7ee607ae1ef78$var$X(a)) return b = $f4a7ee607ae1ef78$var$Yd($f4a7ee607ae1ef78$var$W(a), b), new $f4a7ee607ae1ef78$var$ae($f4a7ee607ae1ef78$var$W(b.g), $f4a7ee607ae1ef78$var$W(b.h));
    if ($f4a7ee607ae1ef78$var$X(b)) return b = $f4a7ee607ae1ef78$var$Yd(a, $f4a7ee607ae1ef78$var$W(b)), new $f4a7ee607ae1ef78$var$ae($f4a7ee607ae1ef78$var$W(b.g), b.h);
    if (30 < a.g.length) {
        if ($f4a7ee607ae1ef78$var$X(a) || $f4a7ee607ae1ef78$var$X(b)) throw Error("slowDivide_ only works with positive integers.");
        for(var c = $f4a7ee607ae1ef78$var$Wd, d = b; 0 >= d.X(a);)c = $f4a7ee607ae1ef78$var$be(c), d = $f4a7ee607ae1ef78$var$be(d);
        var e = $f4a7ee607ae1ef78$var$Z(c, 1), f = $f4a7ee607ae1ef78$var$Z(d, 1);
        d = $f4a7ee607ae1ef78$var$Z(d, 2);
        for(c = $f4a7ee607ae1ef78$var$Z(c, 2); !$f4a7ee607ae1ef78$var$Y(d);){
            var h = f.add(d);
            0 >= h.X(a) && (e = e.add(c), f = h);
            d = $f4a7ee607ae1ef78$var$Z(d, 1);
            c = $f4a7ee607ae1ef78$var$Z(c, 1);
        }
        b = $f4a7ee607ae1ef78$var$Zd(a, e.R(b));
        return new $f4a7ee607ae1ef78$var$ae(e, b);
    }
    for(e = $f4a7ee607ae1ef78$var$V; 0 <= a.X(b);){
        c = Math.max(1, Math.floor(a.ea() / b.ea()));
        d = Math.ceil(Math.log(c) / Math.LN2);
        d = 48 >= d ? 1 : Math.pow(2, d - 48);
        f = $f4a7ee607ae1ef78$var$U(c);
        for(h = f.R(b); $f4a7ee607ae1ef78$var$X(h) || 0 < h.X(a);)c -= d, f = $f4a7ee607ae1ef78$var$U(c), h = f.R(b);
        $f4a7ee607ae1ef78$var$Y(f) && (f = $f4a7ee607ae1ef78$var$Wd);
        e = e.add(f);
        a = $f4a7ee607ae1ef78$var$Zd(a, h);
    }
    return new $f4a7ee607ae1ef78$var$ae(e, a);
}
$f4a7ee607ae1ef78$var$k.gb = function(a) {
    return $f4a7ee607ae1ef78$var$Yd(this, a).h;
};
$f4a7ee607ae1ef78$var$k.and = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) & a.D(d);
    return new $f4a7ee607ae1ef78$var$T(c, this.h & a.h);
};
$f4a7ee607ae1ef78$var$k.or = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) | a.D(d);
    return new $f4a7ee607ae1ef78$var$T(c, this.h | a.h);
};
$f4a7ee607ae1ef78$var$k.xor = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) ^ a.D(d);
    return new $f4a7ee607ae1ef78$var$T(c, this.h ^ a.h);
};
function $f4a7ee607ae1ef78$var$be(a) {
    for(var b = a.g.length + 1, c = [], d = 0; d < b; d++)c[d] = a.D(d) << 1 | a.D(d - 1) >>> 31;
    return new $f4a7ee607ae1ef78$var$T(c, a.h);
}
function $f4a7ee607ae1ef78$var$Z(a, b) {
    var c = b >> 5;
    b %= 32;
    for(var d = a.g.length - c, e = [], f = 0; f < d; f++)e[f] = 0 < b ? a.D(f + c) >>> b | a.D(f + c + 1) << 32 - b : a.D(f + c);
    return new $f4a7ee607ae1ef78$var$T(e, a.h);
}
$f4a7ee607ae1ef78$var$Od.prototype.createWebChannel = $f4a7ee607ae1ef78$var$Od.prototype.g;
$f4a7ee607ae1ef78$var$Q.prototype.send = $f4a7ee607ae1ef78$var$Q.prototype.u;
$f4a7ee607ae1ef78$var$Q.prototype.open = $f4a7ee607ae1ef78$var$Q.prototype.m;
$f4a7ee607ae1ef78$var$Q.prototype.close = $f4a7ee607ae1ef78$var$Q.prototype.close;
$f4a7ee607ae1ef78$var$Sb.NO_ERROR = 0;
$f4a7ee607ae1ef78$var$Sb.TIMEOUT = 8;
$f4a7ee607ae1ef78$var$Sb.HTTP_ERROR = 6;
$f4a7ee607ae1ef78$var$Tb.COMPLETE = "complete";
$f4a7ee607ae1ef78$var$Wb.EventType = $f4a7ee607ae1ef78$var$Xb;
$f4a7ee607ae1ef78$var$Xb.OPEN = "a";
$f4a7ee607ae1ef78$var$Xb.CLOSE = "b";
$f4a7ee607ae1ef78$var$Xb.ERROR = "c";
$f4a7ee607ae1ef78$var$Xb.MESSAGE = "d";
$f4a7ee607ae1ef78$var$B.prototype.listen = $f4a7ee607ae1ef78$var$B.prototype.O;
$f4a7ee607ae1ef78$var$P.prototype.listenOnce = $f4a7ee607ae1ef78$var$P.prototype.P;
$f4a7ee607ae1ef78$var$P.prototype.getLastError = $f4a7ee607ae1ef78$var$P.prototype.Sa;
$f4a7ee607ae1ef78$var$P.prototype.getLastErrorCode = $f4a7ee607ae1ef78$var$P.prototype.Ia;
$f4a7ee607ae1ef78$var$P.prototype.getStatus = $f4a7ee607ae1ef78$var$P.prototype.da;
$f4a7ee607ae1ef78$var$P.prototype.getResponseJson = $f4a7ee607ae1ef78$var$P.prototype.Wa;
$f4a7ee607ae1ef78$var$P.prototype.getResponseText = $f4a7ee607ae1ef78$var$P.prototype.ja;
$f4a7ee607ae1ef78$var$P.prototype.send = $f4a7ee607ae1ef78$var$P.prototype.ha;
$f4a7ee607ae1ef78$var$P.prototype.setWithCredentials = $f4a7ee607ae1ef78$var$P.prototype.Oa;
$f4a7ee607ae1ef78$var$S.prototype.digest = $f4a7ee607ae1ef78$var$S.prototype.l;
$f4a7ee607ae1ef78$var$S.prototype.reset = $f4a7ee607ae1ef78$var$S.prototype.reset;
$f4a7ee607ae1ef78$var$S.prototype.update = $f4a7ee607ae1ef78$var$S.prototype.j;
$f4a7ee607ae1ef78$var$T.prototype.add = $f4a7ee607ae1ef78$var$T.prototype.add;
$f4a7ee607ae1ef78$var$T.prototype.multiply = $f4a7ee607ae1ef78$var$T.prototype.R;
$f4a7ee607ae1ef78$var$T.prototype.modulo = $f4a7ee607ae1ef78$var$T.prototype.gb;
$f4a7ee607ae1ef78$var$T.prototype.compare = $f4a7ee607ae1ef78$var$T.prototype.X;
$f4a7ee607ae1ef78$var$T.prototype.toNumber = $f4a7ee607ae1ef78$var$T.prototype.ea;
$f4a7ee607ae1ef78$var$T.prototype.toString = $f4a7ee607ae1ef78$var$T.prototype.toString;
$f4a7ee607ae1ef78$var$T.prototype.getBits = $f4a7ee607ae1ef78$var$T.prototype.D;
$f4a7ee607ae1ef78$var$T.fromNumber = $f4a7ee607ae1ef78$var$U;
$f4a7ee607ae1ef78$var$T.fromString = $f4a7ee607ae1ef78$var$Vd;
var $f4a7ee607ae1ef78$export$66869136fc133c3a = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.createWebChannelTransport = function() {
    return new $f4a7ee607ae1ef78$var$Od;
};
var $f4a7ee607ae1ef78$export$888d0d9ab79d08fc = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.getStatEventTarget = function() {
    return $f4a7ee607ae1ef78$var$Mb();
};
var $f4a7ee607ae1ef78$export$d4e71bc0b80dc0fb = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.ErrorCode = $f4a7ee607ae1ef78$var$Sb;
var $f4a7ee607ae1ef78$export$3d7865934588d77e = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.EventType = $f4a7ee607ae1ef78$var$Tb;
var $f4a7ee607ae1ef78$export$d61e24a684f9e51 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.Event = $f4a7ee607ae1ef78$var$E;
var $f4a7ee607ae1ef78$export$cbbc350c1dfc80cb = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.Stat = {
    xb: 0,
    Ab: 1,
    Bb: 2,
    Ub: 3,
    Zb: 4,
    Wb: 5,
    Xb: 6,
    Vb: 7,
    Tb: 8,
    Yb: 9,
    PROXY: 10,
    NOPROXY: 11,
    Rb: 12,
    Nb: 13,
    Ob: 14,
    Mb: 15,
    Pb: 16,
    Qb: 17,
    tb: 18,
    sb: 19,
    ub: 20
};
var $f4a7ee607ae1ef78$export$ddb1030448106742 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.FetchXmlHttpFactory = $f4a7ee607ae1ef78$var$ld;
var $f4a7ee607ae1ef78$export$aa726fb96ad3e039 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.WebChannel = $f4a7ee607ae1ef78$var$Wb;
var $f4a7ee607ae1ef78$export$26404658cda3ee02 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.XhrIo = $f4a7ee607ae1ef78$var$P;
var $f4a7ee607ae1ef78$export$9f5a3dfc7a9f5dd = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.Md5 = $f4a7ee607ae1ef78$var$S;
var $f4a7ee607ae1ef78$export$70ffa26850098d01 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.Integer = $f4a7ee607ae1ef78$var$T;

});



parcelRegister("kp7Te", function(module, exports) {

$parcel$export(module.exports, "MeshoptDecoder", () => $edac432dada49dd7$export$1111800106ba519a);
// This file is part of meshoptimizer library and is distributed under the terms of MIT License.
// Copyright (C) 2016-2020, by Arseny Kapoulkine (arseny.kapoulkine@gmail.com)
var $edac432dada49dd7$export$1111800106ba519a = function() {
    "use strict";
    // Built with clang version 11.0.0 (https://github.com/llvm/llvm-project.git 0160ad802e899c2922bc9b29564080c22eb0908c)
    // Built from meshoptimizer 0.14
    var wasm_base = "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";
    var wasm_simd = "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";
    // Uses bulk-memory and simd extensions
    var detector = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        3,
        2,
        0,
        0,
        5,
        3,
        1,
        0,
        1,
        12,
        1,
        0,
        10,
        22,
        2,
        12,
        0,
        65,
        0,
        65,
        0,
        65,
        0,
        252,
        10,
        0,
        0,
        11,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    // Used to unpack wasm
    var wasmpack = new Uint8Array([
        32,
        0,
        65,
        253,
        3,
        1,
        2,
        34,
        4,
        106,
        6,
        5,
        11,
        8,
        7,
        20,
        13,
        33,
        12,
        16,
        128,
        9,
        116,
        64,
        19,
        113,
        127,
        15,
        10,
        21,
        22,
        14,
        255,
        66,
        24,
        54,
        136,
        107,
        18,
        23,
        192,
        26,
        114,
        118,
        132,
        17,
        77,
        101,
        130,
        144,
        27,
        87,
        131,
        44,
        45,
        74,
        156,
        154,
        70,
        167
    ]);
    if (typeof WebAssembly !== 'object') // This module requires WebAssembly to function
    return {
        supported: false
    };
    var wasm = wasm_base;
    if (WebAssembly.validate(detector)) {
        wasm = wasm_simd;
        console.log("Warning: meshopt_decoder is using experimental SIMD support");
    }
    var instance;
    var promise = WebAssembly.instantiate(unpack(wasm), {}).then(function(result) {
        instance = result.instance;
        instance.exports.__wasm_call_ctors();
    });
    function unpack(data) {
        var result = new Uint8Array(data.length);
        for(var i = 0; i < data.length; ++i){
            var ch = data.charCodeAt(i);
            result[i] = ch > 96 ? ch - 71 : ch > 64 ? ch - 65 : ch > 47 ? ch + 4 : ch > 46 ? 63 : 62;
        }
        var write = 0;
        for(var i = 0; i < data.length; ++i)result[write++] = result[i] < 60 ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
        return result.buffer.slice(0, write);
    }
    function decode(fun, target, count, size, source, filter) {
        var sbrk = instance.exports.sbrk;
        var count4 = count + 3 & -4; // pad for SIMD filter
        var tp = sbrk(count4 * size);
        var sp = sbrk(source.length);
        var heap = new Uint8Array(instance.exports.memory.buffer);
        heap.set(source, sp);
        var res = fun(tp, count, size, sp, source.length);
        if (res == 0 && filter) filter(tp, count4, size);
        target.set(heap.subarray(tp, tp + count * size));
        sbrk(tp - sbrk(0));
        if (res != 0) throw new Error("Malformed buffer data: " + res);
    }
    var filters = {
        // legacy index-based enums for glTF
        0: "",
        1: "meshopt_decodeFilterOct",
        2: "meshopt_decodeFilterQuat",
        3: "meshopt_decodeFilterExp",
        // string-based enums for glTF
        NONE: "",
        OCTAHEDRAL: "meshopt_decodeFilterOct",
        QUATERNION: "meshopt_decodeFilterQuat",
        EXPONENTIAL: "meshopt_decodeFilterExp"
    };
    var decoders = {
        // legacy index-based enums for glTF
        0: "meshopt_decodeVertexBuffer",
        1: "meshopt_decodeIndexBuffer",
        2: "meshopt_decodeIndexSequence",
        // string-based enums for glTF
        ATTRIBUTES: "meshopt_decodeVertexBuffer",
        TRIANGLES: "meshopt_decodeIndexBuffer",
        INDICES: "meshopt_decodeIndexSequence"
    };
    return {
        ready: promise,
        supported: true,
        decodeVertexBuffer: function(target, count, size, source, filter) {
            decode(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
        },
        decodeIndexBuffer: function(target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
        },
        decodeIndexSequence: function(target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
        },
        decodeGltfBuffer: function(target, count, size, source, mode, filter) {
            decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
        }
    };
}();

});

parcelRegister("dBwuy", function(module, exports) {

$parcel$export(module.exports, "db", () => $9e77ef45f1e42b78$export$f932f06c7eb6abeb);
parcelRequire("fhN3L");
var $7xvHX = parcelRequire("7xvHX");
parcelRequire("ilpIi");
var $9HrqM = parcelRequire("9HrqM");
parcelRequire("7FrCY");
var $17EBg = parcelRequire("17EBg");
const $9e77ef45f1e42b78$var$firebaseConfig = {
    apiKey: 'AIzaSyDU2I_7IOU4iv2m9pkOyiEPRGV3AxXELsY',
    authDomain: 'scanattest.firebaseapp.com',
    projectId: 'scanattest',
    storageBucket: 'scanattest.appspot.com',
    messagingSenderId: '481437421657',
    appId: '1:481437421657:web:694b91d4530e6cc7432148',
    measurementId: 'G-RRSYK0N2ML'
};
const $9e77ef45f1e42b78$var$prodFirebaseConfig = {
    apiKey: 'AIzaSyCyL1zcVcb6yPCGmrW1ssd3ZhMiytwVEsI',
    authDomain: 'scanat.firebaseapp.com',
    projectId: 'scanat',
    storageBucket: 'scanat.appspot.com',
    messagingSenderId: '499135754420',
    appId: '1:499135754420:web:8feb0c1a90bf9a2c72e7e1',
    measurementId: 'G-6HD8WM2L7F'
};
const $9e77ef45f1e42b78$var$isProd = true;
const $9e77ef45f1e42b78$export$729c8b7179294ba = (0, $7xvHX.initializeApp)($9e77ef45f1e42b78$var$isProd ? $9e77ef45f1e42b78$var$prodFirebaseConfig : $9e77ef45f1e42b78$var$firebaseConfig);
const $9e77ef45f1e42b78$export$f932f06c7eb6abeb = $9e77ef45f1e42b78$var$isProd ? (0, $9HrqM.getFirestore)($9e77ef45f1e42b78$export$729c8b7179294ba, 'scanat') : (0, $9HrqM.getFirestore)($9e77ef45f1e42b78$export$729c8b7179294ba);
if ($9e77ef45f1e42b78$var$isProd) {
    const analytics = (0, $17EBg.getAnalytics)($9e77ef45f1e42b78$export$729c8b7179294ba);
    const clickClasses = [
        'nav-home',
        'nav-intro',
        'nav-case',
        'nav-news',
        'nav-fee',
        'faq-tabs',
        'fee-pay-a',
        'fee-pay-b',
        'fee-pay-c',
        'fee-pay-consult',
        'home-login',
        'home-register',
        'view-report'
    ];
    const hoverClasses = [
        'fee-card-a',
        'fee-card-b',
        'fee-card-c',
        'fee-card-d'
    ];
    window.addEventListener('load', ()=>{
        (0, $17EBg.logEvent)(analytics, 'lp_view_page');
        clickClasses.forEach((clickClass)=>{
            document.querySelector(`.${clickClass}`)?.addEventListener('click', ()=>{
                (0, $17EBg.logEvent)(analytics, `lp_${clickClass}`);
            });
        });
        const throttle = (fn, wait)=>{
            let pre = 0;
            return ()=>{
                const now = +new Date();
                if (now - pre > wait) {
                    fn();
                    pre = now;
                }
            };
        };
        // Hover events, mouseover need be throttled
        hoverClasses.forEach((hoverClass)=>{
            document.querySelector(`.${hoverClass}`)?.addEventListener('mouseover', throttle(()=>{
                (0, $17EBg.logEvent)(analytics, `lp_${hoverClass}`);
            }, 2000));
        });
    });
}

});
parcelRegister("fhN3L", function(module, exports) {
$parcel$export(module.exports, "initializeApp", () => (parcelRequire("7xvHX")).initializeApp);
$parcel$export(module.exports, "registerVersion", () => (parcelRequire("7xvHX")).registerVersion);

var $7xvHX = parcelRequire("7xvHX");
var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "9.23.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $7xvHX.registerVersion)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, 'app');

});

parcelRegister("7FrCY", function(module, exports) {
$parcel$export(module.exports, "getAnalytics", () => (parcelRequire("17EBg")).getAnalytics);
$parcel$export(module.exports, "logEvent", () => (parcelRequire("17EBg")).logEvent);
parcelRequire("17EBg");

});
parcelRegister("17EBg", function(module, exports) {

$parcel$export(module.exports, "getAnalytics", () => $0d15f034d14801d0$export$b0297573c90085aa);
$parcel$export(module.exports, "logEvent", () => $0d15f034d14801d0$export$5e9eec8001665ac5);

var $7xvHX = parcelRequire("7xvHX");

var $5Z2ef = parcelRequire("5Z2ef");

var $gMVVg = parcelRequire("gMVVg");

var $eryG9 = parcelRequire("eryG9");
parcelRequire("2Ey2D");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $0d15f034d14801d0$var$ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const $0d15f034d14801d0$var$GA_FID_KEY = 'firebase_id';
const $0d15f034d14801d0$var$ORIGIN_KEY = 'origin';
const $0d15f034d14801d0$var$FETCH_TIMEOUT_MILLIS = 60000;
const $0d15f034d14801d0$var$DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const $0d15f034d14801d0$var$GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0d15f034d14801d0$var$logger = new (0, $5Z2ef.Logger)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0d15f034d14801d0$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-intialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const $0d15f034d14801d0$var$ERROR_FACTORY = new (0, $gMVVg.ErrorFactory)('analytics', 'Analytics', $0d15f034d14801d0$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $0d15f034d14801d0$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($0d15f034d14801d0$var$GTAG_URL)) {
        const err = $0d15f034d14801d0$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $0d15f034d14801d0$var$logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $0d15f034d14801d0$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $0d15f034d14801d0$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $0d15f034d14801d0$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $0d15f034d14801d0$var$createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: $0d15f034d14801d0$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$0d15f034d14801d0$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy === null || trustedTypesPolicy === void 0 ? void 0 : trustedTypesPolicy.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $0d15f034d14801d0$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $0d15f034d14801d0$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $0d15f034d14801d0$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $0d15f034d14801d0$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $0d15f034d14801d0$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $0d15f034d14801d0$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $0d15f034d14801d0$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $0d15f034d14801d0$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $0d15f034d14801d0$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $0d15f034d14801d0$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [gtagParams] = args;
                gtagCore("consent" /* GtagCommand.CONSENT */ , 'update', gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $0d15f034d14801d0$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $0d15f034d14801d0$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $0d15f034d14801d0$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $0d15f034d14801d0$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($0d15f034d14801d0$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $0d15f034d14801d0$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $0d15f034d14801d0$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $0d15f034d14801d0$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $0d15f034d14801d0$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $0d15f034d14801d0$var$defaultRetryData = new $0d15f034d14801d0$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $0d15f034d14801d0$var$getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $0d15f034d14801d0$var$fetchDynamicConfig(appFields) {
    var _a;
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: $0d15f034d14801d0$var$getHeaders(apiKey)
    };
    const appUrl = $0d15f034d14801d0$var$DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $0d15f034d14801d0$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $0d15f034d14801d0$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $0d15f034d14801d0$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $0d15f034d14801d0$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $0d15f034d14801d0$var$FETCH_TIMEOUT_MILLIS);
    return $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $0d15f034d14801d0$var$defaultRetryData // for testing
) {
    var _a;
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $0d15f034d14801d0$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $0d15f034d14801d0$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e === null || e === void 0 ? void 0 : e.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $0d15f034d14801d0$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$0d15f034d14801d0$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $0d15f034d14801d0$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error === null || error === void 0 ? void 0 : error.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number((_a = error === null || error === void 0 ? void 0 : error.customData) === null || _a === void 0 ? void 0 : _a.httpStatus) === 503 ? (0, $gMVVg.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, $0d15f034d14801d0$var$LONG_RETRY_FACTOR) : (0, $gMVVg.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $0d15f034d14801d0$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $0d15f034d14801d0$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $0d15f034d14801d0$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($0d15f034d14801d0$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $0d15f034d14801d0$var$isRetriableError(e) {
    if (!(e instanceof (0, $gMVVg.FirebaseError)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $0d15f034d14801d0$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $0d15f034d14801d0$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $0d15f034d14801d0$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = Object.assign(Object.assign({}, eventParams), {
            'send_to': measurementId
        });
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $0d15f034d14801d0$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $0d15f034d14801d0$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $0d15f034d14801d0$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $0d15f034d14801d0$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject($0d15f034d14801d0$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $0d15f034d14801d0$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $0d15f034d14801d0$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $0d15f034d14801d0$var$_setConsentDefaultForInit(consentSettings) {
    $0d15f034d14801d0$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $0d15f034d14801d0$var$_setDefaultEventParametersForInit(customParams) {
    $0d15f034d14801d0$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0d15f034d14801d0$var$validateIndexedDB() {
    if (!(0, $gMVVg.isIndexedDBAvailable)()) {
        $0d15f034d14801d0$var$logger.warn($0d15f034d14801d0$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, $gMVVg.validateIndexedDBOpenable)();
    } catch (e) {
        $0d15f034d14801d0$var$logger.warn($0d15f034d14801d0$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e === null || e === void 0 ? void 0 : e.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $0d15f034d14801d0$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    var _a;
    const dynamicConfigPromise = $0d15f034d14801d0$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $0d15f034d14801d0$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $0d15f034d14801d0$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$0d15f034d14801d0$var$findGtagScriptOnPage(dataLayerName)) $0d15f034d14801d0$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($0d15f034d14801d0$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', $0d15f034d14801d0$var$defaultConsentSettingsForInit);
        $0d15f034d14801d0$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$0d15f034d14801d0$var$ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[$0d15f034d14801d0$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($0d15f034d14801d0$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $0d15f034d14801d0$var$defaultEventParametersForInit);
        $0d15f034d14801d0$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $0d15f034d14801d0$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $0d15f034d14801d0$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $0d15f034d14801d0$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $0d15f034d14801d0$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $0d15f034d14801d0$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $0d15f034d14801d0$var$dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $0d15f034d14801d0$var$gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $0d15f034d14801d0$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $0d15f034d14801d0$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $0d15f034d14801d0$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $0d15f034d14801d0$export$a5a6e0b888b2c992(options) {
    if ($0d15f034d14801d0$var$globalInitDone) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $0d15f034d14801d0$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $0d15f034d14801d0$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $0d15f034d14801d0$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $gMVVg.isBrowserExtension)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, $gMVVg.areCookiesEnabled)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = $0d15f034d14801d0$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $0d15f034d14801d0$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $0d15f034d14801d0$var$factory(app, installations, options) {
    $0d15f034d14801d0$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $0d15f034d14801d0$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $0d15f034d14801d0$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($0d15f034d14801d0$var$initializationPromisesMap[appId] != null) throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$0d15f034d14801d0$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $0d15f034d14801d0$var$getOrCreateDataLayer($0d15f034d14801d0$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $0d15f034d14801d0$var$wrapOrCreateGtag($0d15f034d14801d0$var$initializationPromisesMap, $0d15f034d14801d0$var$dynamicConfigPromisesList, $0d15f034d14801d0$var$measurementIdToAppId, $0d15f034d14801d0$var$dataLayerName, $0d15f034d14801d0$var$gtagName);
        $0d15f034d14801d0$var$wrappedGtagFunction = wrappedGtag;
        $0d15f034d14801d0$var$gtagCoreFunction = gtagCore;
        $0d15f034d14801d0$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $0d15f034d14801d0$var$initializationPromisesMap[appId] = $0d15f034d14801d0$var$_initializeAnalytics(app, $0d15f034d14801d0$var$dynamicConfigPromisesList, $0d15f034d14801d0$var$measurementIdToAppId, installations, $0d15f034d14801d0$var$gtagCoreFunction, $0d15f034d14801d0$var$dataLayerName, options);
    const analyticsInstance = new $0d15f034d14801d0$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $0d15f034d14801d0$export$b0297573c90085aa(app = (0, $7xvHX.getApp)()) {
    app = (0, $gMVVg.getModularInstance)(app);
    // Dependencies
    const analyticsProvider = (0, $7xvHX._getProvider)(app, $0d15f034d14801d0$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $0d15f034d14801d0$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $0d15f034d14801d0$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $7xvHX._getProvider)(app, $0d15f034d14801d0$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $gMVVg.deepEqual)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $0d15f034d14801d0$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $0d15f034d14801d0$export$48c17662a6902497() {
    if ((0, $gMVVg.isBrowserExtension)()) return false;
    if (!(0, $gMVVg.areCookiesEnabled)()) return false;
    if (!(0, $gMVVg.isIndexedDBAvailable)()) return false;
    try {
        const isDBOpenable = await (0, $gMVVg.validateIndexedDBOpenable)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $0d15f034d14801d0$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$setCurrentScreen$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $0d15f034d14801d0$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    return $0d15f034d14801d0$var$internalGetGoogleAnalyticsClientId($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $0d15f034d14801d0$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$setUserId$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $0d15f034d14801d0$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$setUserProperties$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $0d15f034d14801d0$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$setAnalyticsCollectionEnabled$1($0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $0d15f034d14801d0$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($0d15f034d14801d0$var$wrappedGtagFunction) $0d15f034d14801d0$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $0d15f034d14801d0$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $0d15f034d14801d0$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $gMVVg.getModularInstance)(analyticsInstance);
    $0d15f034d14801d0$var$logEvent$1($0d15f034d14801d0$var$wrappedGtagFunction, $0d15f034d14801d0$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$0d15f034d14801d0$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $0d15f034d14801d0$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($0d15f034d14801d0$var$wrappedGtagFunction) $0d15f034d14801d0$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else $0d15f034d14801d0$var$_setConsentDefaultForInit(consentSettings);
}
const $0d15f034d14801d0$var$name = "@firebase/analytics";
const $0d15f034d14801d0$var$version = "0.10.0";
/**
 * Firebase Analytics
 *
 * @packageDocumentation
 */ function $0d15f034d14801d0$var$registerAnalytics() {
    (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)($0d15f034d14801d0$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return $0d15f034d14801d0$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $7xvHX.registerVersion)($0d15f034d14801d0$var$name, $0d15f034d14801d0$var$version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $7xvHX.registerVersion)($0d15f034d14801d0$var$name, $0d15f034d14801d0$var$version, 'esm2017');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($0d15f034d14801d0$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$0d15f034d14801d0$export$5e9eec8001665ac5(analytics, eventName, eventParams, options)
            };
        } catch (e) {
            throw $0d15f034d14801d0$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$0d15f034d14801d0$var$registerAnalytics();

});
parcelRegister("2Ey2D", function(module, exports) {

var $7xvHX = parcelRequire("7xvHX");

var $eryG9 = parcelRequire("eryG9");

var $gMVVg = parcelRequire("gMVVg");

var $aXk5D = parcelRequire("aXk5D");
const $1ee9b91e988771f9$var$name = "@firebase/installations";
const $1ee9b91e988771f9$var$version = "0.6.4";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS = 10000;
const $1ee9b91e988771f9$var$PACKAGE_VERSION = `w:${$1ee9b91e988771f9$var$version}`;
const $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $1ee9b91e988771f9$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $1ee9b91e988771f9$var$SERVICE = 'installations';
const $1ee9b91e988771f9$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $1ee9b91e988771f9$var$ERROR_FACTORY = new (0, $gMVVg.ErrorFactory)($1ee9b91e988771f9$var$SERVICE, $1ee9b91e988771f9$var$SERVICE_NAME, $1ee9b91e988771f9$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $1ee9b91e988771f9$var$isServerError(error) {
    return error instanceof (0, $gMVVg.FirebaseError) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$1ee9b91e988771f9$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $1ee9b91e988771f9$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $1ee9b91e988771f9$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    headers.append('Authorization', $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $1ee9b91e988771f9$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $1ee9b91e988771f9$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $1ee9b91e988771f9$var$getAuthorizationHeader(refreshToken) {
    return `${$1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig);
    const headers = $1ee9b91e988771f9$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $1ee9b91e988771f9$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $1ee9b91e988771f9$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $1ee9b91e988771f9$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $1ee9b91e988771f9$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $1ee9b91e988771f9$var$encode(fidByteArray);
        return $1ee9b91e988771f9$var$VALID_FID_PATTERN.test(fid) ? fid : $1ee9b91e988771f9$var$INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return $1ee9b91e988771f9$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $1ee9b91e988771f9$var$encode(fidByteArray) {
    const b64String = $1ee9b91e988771f9$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $1ee9b91e988771f9$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $1ee9b91e988771f9$var$fidChanged(appConfig, fid) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid);
    $1ee9b91e988771f9$var$broadcastFidChange(key, fid);
}
function $1ee9b91e988771f9$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $1ee9b91e988771f9$var$getBroadcastChannel();
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    let callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $1ee9b91e988771f9$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $1ee9b91e988771f9$var$removeCallback(appConfig, callback) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const callbackSet = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $1ee9b91e988771f9$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
function $1ee9b91e988771f9$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $1ee9b91e988771f9$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $1ee9b91e988771f9$var$broadcastFidChange(key, fid) {
    const channel = $1ee9b91e988771f9$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $1ee9b91e988771f9$var$closeBroadcastChannel();
}
let $1ee9b91e988771f9$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $1ee9b91e988771f9$var$getBroadcastChannel() {
    if (!$1ee9b91e988771f9$var$broadcastChannel && 'BroadcastChannel' in self) {
        $1ee9b91e988771f9$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $1ee9b91e988771f9$var$broadcastChannel.onmessage = (e)=>{
            $1ee9b91e988771f9$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $1ee9b91e988771f9$var$broadcastChannel;
}
function $1ee9b91e988771f9$var$closeBroadcastChannel() {
    if ($1ee9b91e988771f9$var$fidChangeCallbacks.size === 0 && $1ee9b91e988771f9$var$broadcastChannel) {
        $1ee9b91e988771f9$var$broadcastChannel.close();
        $1ee9b91e988771f9$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$DATABASE_NAME = 'firebase-installations-database';
const $1ee9b91e988771f9$var$DATABASE_VERSION = 1;
const $1ee9b91e988771f9$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $1ee9b91e988771f9$var$dbPromise = null;
function $1ee9b91e988771f9$var$getDbPromise() {
    if (!$1ee9b91e988771f9$var$dbPromise) $1ee9b91e988771f9$var$dbPromise = (0, $aXk5D.openDB)($1ee9b91e988771f9$var$DATABASE_NAME, $1ee9b91e988771f9$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $1ee9b91e988771f9$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $1ee9b91e988771f9$var$set(appConfig, value) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $1ee9b91e988771f9$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $1ee9b91e988771f9$var$remove(appConfig) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $1ee9b91e988771f9$var$update(appConfig, updateFn) {
    const key = $1ee9b91e988771f9$var$getKey(appConfig);
    const db = await $1ee9b91e988771f9$var$getDbPromise();
    const tx = db.transaction($1ee9b91e988771f9$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($1ee9b91e988771f9$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $1ee9b91e988771f9$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $1ee9b91e988771f9$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $1ee9b91e988771f9$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $1ee9b91e988771f9$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $1ee9b91e988771f9$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $1ee9b91e988771f9$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $1ee9b91e988771f9$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $1ee9b91e988771f9$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $1ee9b91e988771f9$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $1ee9b91e988771f9$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $1ee9b91e988771f9$var$createInstallationRequest(installations, installationEntry);
        return $1ee9b91e988771f9$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID can not be used" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $1ee9b91e988771f9$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $1ee9b91e988771f9$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateInstallationRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $1ee9b91e988771f9$var$clearTimedOutRequest(oldEntry);
    });
}
function $1ee9b91e988771f9$var$clearTimedOutRequest(entry) {
    if ($1ee9b91e988771f9$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $1ee9b91e988771f9$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $1ee9b91e988771f9$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $1ee9b91e988771f9$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $1ee9b91e988771f9$var$getErrorFromResponse('Generate Auth Token', response);
}
function $1ee9b91e988771f9$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $1ee9b91e988771f9$var$update(installations.appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $1ee9b91e988771f9$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $1ee9b91e988771f9$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $1ee9b91e988771f9$var$sleep(100);
        entry = await $1ee9b91e988771f9$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $1ee9b91e988771f9$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $1ee9b91e988771f9$var$updateAuthTokenRequest(appConfig) {
    return $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (!$1ee9b91e988771f9$var$isEntryRegistered(oldEntry)) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return Object.assign(Object.assign({}, oldEntry), {
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        });
        return oldEntry;
    });
}
async function $1ee9b91e988771f9$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $1ee9b91e988771f9$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
            authToken: authToken
        });
        await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($1ee9b91e988771f9$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $1ee9b91e988771f9$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), {
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            });
            await $1ee9b91e988771f9$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $1ee9b91e988771f9$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $1ee9b91e988771f9$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$1ee9b91e988771f9$var$isAuthTokenExpired(authToken);
}
function $1ee9b91e988771f9$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $1ee9b91e988771f9$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $1ee9b91e988771f9$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), {
        authToken: inProgressAuthToken
    });
}
function $1ee9b91e988771f9$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $1ee9b91e988771f9$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $1ee9b91e988771f9$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $1ee9b91e988771f9$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $1ee9b91e988771f9$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $1ee9b91e988771f9$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $1ee9b91e988771f9$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $1ee9b91e988771f9$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $1ee9b91e988771f9$var$getErrorFromResponse('Delete Installation', response);
}
function $1ee9b91e988771f9$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$1ee9b91e988771f9$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $1ee9b91e988771f9$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $1ee9b91e988771f9$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $1ee9b91e988771f9$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $1ee9b91e988771f9$var$deleteInstallationRequest(appConfig, entry);
                await $1ee9b91e988771f9$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $1ee9b91e988771f9$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $1ee9b91e988771f9$var$addCallback(appConfig, callback);
    return ()=>{
        $1ee9b91e988771f9$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $1ee9b91e988771f9$export$9bfc115e43431ff5(app = (0, $7xvHX.getApp)()) {
    const installationsImpl = (0, $7xvHX._getProvider)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1ee9b91e988771f9$var$extractAppConfig(app) {
    if (!app || !app.options) throw $1ee9b91e988771f9$var$getMissingValueError('App Configuration');
    if (!app.name) throw $1ee9b91e988771f9$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $1ee9b91e988771f9$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $1ee9b91e988771f9$var$getMissingValueError(valueName) {
    return $1ee9b91e988771f9$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1ee9b91e988771f9$var$INSTALLATIONS_NAME = 'installations';
const $1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $1ee9b91e988771f9$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $1ee9b91e988771f9$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $7xvHX._getProvider)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $1ee9b91e988771f9$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $7xvHX._getProvider)(app, $1ee9b91e988771f9$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$1ee9b91e988771f9$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$1ee9b91e988771f9$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $1ee9b91e988771f9$var$registerInstallations() {
    (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)($1ee9b91e988771f9$var$INSTALLATIONS_NAME, $1ee9b91e988771f9$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $7xvHX._registerComponent)(new (0, $eryG9.Component)($1ee9b91e988771f9$var$INSTALLATIONS_NAME_INTERNAL, $1ee9b91e988771f9$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * Firebase Installations
 *
 * @packageDocumentation
 */ $1ee9b91e988771f9$var$registerInstallations();
(0, $7xvHX.registerVersion)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, $7xvHX.registerVersion)($1ee9b91e988771f9$var$name, $1ee9b91e988771f9$var$version, 'esm2017');

});
parcelRegister("aXk5D", function(module, exports) {

$parcel$export(module.exports, "openDB", () => $7f9eff7de122d39a$export$ca0ed41b1a2af7e);

var $8qwAD = parcelRequire("8qwAD");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $7f9eff7de122d39a$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $8qwAD.w)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $8qwAD.w)(request.result), event.oldVersion, event.newVersion, (0, $8qwAD.w)(request.transaction));
    });
    if (blocked) request.addEventListener('blocked', ()=>blocked());
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', ()=>blocking());
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $7f9eff7de122d39a$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', ()=>blocked());
    return (0, $8qwAD.w)(request).then(()=>undefined);
}
const $7f9eff7de122d39a$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $7f9eff7de122d39a$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $7f9eff7de122d39a$var$cachedMethods = new Map();
function $7f9eff7de122d39a$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($7f9eff7de122d39a$var$cachedMethods.get(prop)) return $7f9eff7de122d39a$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $7f9eff7de122d39a$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $7f9eff7de122d39a$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $7f9eff7de122d39a$var$cachedMethods.set(prop, method);
    return method;
}
(0, $8qwAD.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$7f9eff7de122d39a$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$7f9eff7de122d39a$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRegister("8qwAD", function(module, exports) {

$parcel$export(module.exports, "w", () => $622a081c3b3bf47b$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "r", () => $622a081c3b3bf47b$export$43caf9889c228507);
const $622a081c3b3bf47b$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $622a081c3b3bf47b$var$idbProxyableTypes;
let $622a081c3b3bf47b$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $622a081c3b3bf47b$var$getIdbProxyableTypes() {
    return $622a081c3b3bf47b$var$idbProxyableTypes || ($622a081c3b3bf47b$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $622a081c3b3bf47b$var$getCursorAdvanceMethods() {
    return $622a081c3b3bf47b$var$cursorAdvanceMethods || ($622a081c3b3bf47b$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $622a081c3b3bf47b$var$cursorRequestMap = new WeakMap();
const $622a081c3b3bf47b$var$transactionDoneMap = new WeakMap();
const $622a081c3b3bf47b$var$transactionStoreNamesMap = new WeakMap();
const $622a081c3b3bf47b$var$transformCache = new WeakMap();
const $622a081c3b3bf47b$export$407448d2b89b1813 = new WeakMap();
function $622a081c3b3bf47b$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($622a081c3b3bf47b$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $622a081c3b3bf47b$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $622a081c3b3bf47b$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $622a081c3b3bf47b$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($622a081c3b3bf47b$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $622a081c3b3bf47b$var$transactionDoneMap.set(tx, done);
}
let $622a081c3b3bf47b$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $622a081c3b3bf47b$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $622a081c3b3bf47b$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $622a081c3b3bf47b$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $622a081c3b3bf47b$export$43caf9889c228507(callback) {
    $622a081c3b3bf47b$var$idbProxyTraps = callback($622a081c3b3bf47b$var$idbProxyTraps);
}
function $622a081c3b3bf47b$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($622a081c3b3bf47b$export$3b14a55fb2447963(this), storeNames, ...args);
        $622a081c3b3bf47b$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $622a081c3b3bf47b$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($622a081c3b3bf47b$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($622a081c3b3bf47b$export$3b14a55fb2447963(this), args);
        return $622a081c3b3bf47b$export$efccba1c4a2ef57b($622a081c3b3bf47b$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $622a081c3b3bf47b$export$efccba1c4a2ef57b(func.apply($622a081c3b3bf47b$export$3b14a55fb2447963(this), args));
    };
}
function $622a081c3b3bf47b$var$transformCachableValue(value) {
    if (typeof value === 'function') return $622a081c3b3bf47b$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $622a081c3b3bf47b$var$cacheDonePromiseForTransaction(value);
    if ($622a081c3b3bf47b$export$23f2a1d2818174ef(value, $622a081c3b3bf47b$var$getIdbProxyableTypes())) return new Proxy(value, $622a081c3b3bf47b$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $622a081c3b3bf47b$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $622a081c3b3bf47b$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($622a081c3b3bf47b$var$transformCache.has(value)) return $622a081c3b3bf47b$var$transformCache.get(value);
    const newValue = $622a081c3b3bf47b$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $622a081c3b3bf47b$var$transformCache.set(value, newValue);
        $622a081c3b3bf47b$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $622a081c3b3bf47b$export$3b14a55fb2447963 = (value)=>$622a081c3b3bf47b$export$407448d2b89b1813.get(value);

});






parcelRegister("ebHgd", function(module, exports) {

$parcel$export(module.exports, "MTLLoader", () => $a543a6666dda10e2$export$2a0ca4746a43f1f8);

var $ilwiq = parcelRequire("ilwiq");

var $5WBRZ = parcelRequire("5WBRZ");
/**
 * Loads a Wavefront .mtl file specifying materials
 */ class $a543a6666dda10e2$export$2a0ca4746a43f1f8 extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
    }
    /**
   * Loads and parses a MTL asset from a URL.
   *
   * @param {String} url - URL to the MTL file.
   * @param {Function} [onLoad] - Callback invoked with the loaded object.
   * @param {Function} [onProgress] - Callback for download progress.
   * @param {Function} [onError] - Callback for download errors.
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to load.
   */ load(url, onLoad, onProgress, onError, jpgMap) {
        const scope = this;
        this.jpgMap = jpgMap || {};
        const path = this.path === '' ? (0, $ilwiq.LoaderUtils).extractUrlBase(url) : this.path;
        const loader = new (0, $ilwiq.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(text, path));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    setMaterialOptions(value) {
        this.materialOptions = value;
        return this;
    }
    /**
   * Parses a MTL file.
   *
   * @param {String} text - Content of MTL file
   * @return {MaterialCreator}
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to parse.
   */ parse(text, path) {
        const lines = text.split('\n');
        let info = {};
        const delimiter_pattern = /\s+/;
        const materialsInfo = {};
        for(let i = 0; i < lines.length; i++){
            let line = lines[i];
            line = line.trim();
            if (line.length === 0 || line.charAt(0) === '#') continue;
            const pos = line.indexOf(' ');
            let key = pos >= 0 ? line.substring(0, pos) : line;
            key = key.toLowerCase();
            let value = pos >= 0 ? line.substring(pos + 1) : '';
            value = value.trim();
            if (key === 'newmtl') {
                // New material
                info = {
                    name: value
                };
                materialsInfo[value] = info;
            } else if (key === 'ka' || key === 'kd' || key === 'ks' || key === 'ke') {
                const ss = value.split(delimiter_pattern, 3);
                info[key] = [
                    parseFloat(ss[0]),
                    parseFloat(ss[1]),
                    parseFloat(ss[2])
                ];
            } else info[key] = value;
        }
        const materialCreator = new $a543a6666dda10e2$var$MaterialCreator(this.resourcePath || path, {
            jpgMap: this.jpgMap,
            ...this.materialOptions
        });
        materialCreator.setCrossOrigin(this.crossOrigin);
        materialCreator.setManager(this.manager);
        materialCreator.setMaterials(materialsInfo);
        return materialCreator;
    }
}
/**
 * Create a new MTLLoader.MaterialCreator
 * @param baseUrl - Url relative to which textures are loaded
 * @param options - Set of options on how to construct the materials
 *                  side: Which side to apply the material
 *                        FrontSide (default), THREE.BackSide, THREE.DoubleSide
 *                  wrap: What type of wrapping to apply for textures
 *                        RepeatWrapping (default), THREE.ClampToEdgeWrapping, THREE.MirroredRepeatWrapping
 *                  normalizeRGB: RGBs need to be normalized to 0-1 from 0-255
 *                                Default: false, assumed to be already normalized
 *                  ignoreZeroRGBs: Ignore values of RGBs (Ka,Kd,Ks) that are all 0's
 *                                  Default: false
 * @constructor
 */ class $a543a6666dda10e2$var$MaterialCreator {
    constructor(baseUrl = '', options = {}){
        this.baseUrl = baseUrl;
        this.options = options;
        this.materialsInfo = {};
        this.materials = {};
        this.materialsArray = [];
        this.nameLookup = {};
        this.crossOrigin = 'anonymous';
        this.side = this.options.side !== undefined ? this.options.side : (0, $ilwiq.FrontSide);
        this.wrap = this.options.wrap !== undefined ? this.options.wrap : (0, $ilwiq.RepeatWrapping);
    }
    setCrossOrigin(value) {
        this.crossOrigin = value;
        return this;
    }
    setManager(value) {
        this.manager = value;
    }
    setMaterials(materialsInfo) {
        this.materialsInfo = this.convert(materialsInfo);
        this.materials = {};
        this.materialsArray = [];
        this.nameLookup = {};
    }
    convert(materialsInfo) {
        if (!this.options) return materialsInfo;
        const converted = {};
        for(const mn in materialsInfo){
            // Convert materials info into normalized form based on options
            const mat = materialsInfo[mn];
            const covmat = {};
            converted[mn] = covmat;
            for(const prop in mat){
                let save = true;
                let value = mat[prop];
                const lprop = prop.toLowerCase();
                switch(lprop){
                    case 'kd':
                    case 'ka':
                    case 'ks':
                        // Diffuse color (color under white light) using RGB values
                        if (this.options && this.options.normalizeRGB) value = [
                            value[0] / 255,
                            value[1] / 255,
                            value[2] / 255
                        ];
                        if (this.options && this.options.ignoreZeroRGBs) {
                            if (value[0] === 0 && value[1] === 0 && value[2] === 0) // ignore
                            save = false;
                        }
                        break;
                    default:
                        break;
                }
                if (save) covmat[lprop] = value;
            }
        }
        return converted;
    }
    preload() {
        return Promise.all(Object.keys(this.materialsInfo).map(async (mn)=>{
            await this.create(mn);
        }));
    }
    getIndex(materialName) {
        return this.nameLookup[materialName];
    }
    async getAsArray() {
        let index = 0;
        for(const mn in this.materialsInfo){
            this.materialsArray[index] = await this.create(mn);
            this.nameLookup[mn] = index;
            index++;
        }
        return this.materialsArray;
    }
    async create(materialName) {
        if (this.materials[materialName] === undefined) await this.createMaterial_(materialName);
        return this.materials[materialName];
    }
    async createMaterial_(materialName) {
        // Create material
        const scope = this;
        const mat = this.materialsInfo[materialName];
        const params = {
            name: materialName,
            side: this.side
        };
        function resolveURL(baseUrl, url) {
            if (typeof url !== 'string' || url === '') return '';
            // Absolute URL
            if (/^https?:\/\//i.test(url)) return url;
            return baseUrl + url;
        }
        async function setMapForType(mapType, value) {
            if (params[mapType]) return; // Keep the first encountered texture
            const texParams = scope.getTextureParams(value, params);
            const map = await scope.loadTexture(resolveURL(scope.baseUrl, texParams.url));
            map.repeat.copy(texParams.scale);
            map.offset.copy(texParams.offset);
            map.wrapS = scope.wrap;
            map.wrapT = scope.wrap;
            if (mapType === 'map' || mapType === 'emissiveMap') map.colorSpace = (0, $ilwiq.SRGBColorSpace);
            params[mapType] = map;
        }
        for(const prop in mat){
            const value = mat[prop];
            let n;
            if (value === '') continue;
            switch(prop.toLowerCase()){
                // Ns is material specular exponent
                case 'kd':
                    // Diffuse color (color under white light) using RGB values
                    params.color = new (0, $ilwiq.Color)().fromArray(value).convertSRGBToLinear();
                    break;
                case 'ks':
                    // Specular color (color when light is reflected from shiny surface) using RGB values
                    params.specular = new (0, $ilwiq.Color)().fromArray(value).convertSRGBToLinear();
                    break;
                case 'ke':
                    // Emissive using RGB values
                    params.emissive = new (0, $ilwiq.Color)().fromArray(value).convertSRGBToLinear();
                    break;
                case 'map_kd':
                    // Diffuse texture map
                    await setMapForType('map', value);
                    break;
                case 'map_ks':
                    // Specular map
                    await setMapForType('specularMap', value);
                    break;
                case 'map_ke':
                    // Emissive map
                    await setMapForType('emissiveMap', value);
                    break;
                case 'norm':
                    await setMapForType('normalMap', value);
                    break;
                case 'map_bump':
                case 'bump':
                    // Bump texture map
                    await setMapForType('bumpMap', value);
                    break;
                case 'map_d':
                    // Alpha map
                    await setMapForType('alphaMap', value);
                    params.transparent = true;
                    break;
                case 'ns':
                    // The specular exponent (defines the focus of the specular highlight)
                    // A high exponent results in a tight, concentrated highlight. Ns values normally range from 0 to 1000.
                    params.shininess = parseFloat(value);
                    break;
                case 'd':
                    n = parseFloat(value);
                    if (n < 1) {
                        params.opacity = n;
                        params.transparent = true;
                    }
                    break;
                case 'tr':
                    n = parseFloat(value);
                    if (this.options && this.options.invertTrProperty) n = 1 - n;
                    if (n > 0) {
                        params.opacity = 1 - n;
                        params.transparent = true;
                    }
                    break;
                case 'illum':
                    n = parseFloat(value);
                    if (n === 2) params.opacity = 1;
                    break;
                default:
                    break;
            }
        }
        let matNew = new (0, $ilwiq.MeshBasicMaterial)(params);
        matNew.params = params;
        if (matNew.map) {
            matNew.map.minFilter = (0, $ilwiq.NearestFilter);
            matNew.map.magFilter = (0, $ilwiq.NearestFilter);
        }
        this.materials[materialName] = matNew;
        return this.materials[materialName];
    }
    getTextureParams(value, matParams) {
        const texParams = {
            scale: new (0, $ilwiq.Vector2)(1, 1),
            offset: new (0, $ilwiq.Vector2)(0, 0)
        };
        const items = value.split(/\s+/);
        let pos;
        pos = items.indexOf('-bm');
        if (pos >= 0) {
            matParams.bumpScale = parseFloat(items[pos + 1]);
            items.splice(pos, 2);
        }
        pos = items.indexOf('-s');
        if (pos >= 0) {
            texParams.scale.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
            items.splice(pos, 4) // we expect 3 parameters here!
            ;
        }
        pos = items.indexOf('-o');
        if (pos >= 0) {
            texParams.offset.set(parseFloat(items[pos + 1]), parseFloat(items[pos + 2]));
            items.splice(pos, 4) // we expect 3 parameters here!
            ;
        }
        texParams.url = items.join(' ').trim();
        const url = (0, $5WBRZ.getJPGKey)(texParams.url, this.options.jpgMap)?.split('/')?.pop?.();
        if (url) texParams.url = url;
        return texParams;
    }
    loadTexture(url, mapping, onLoad, onProgress, onError) {
        const manager = this.manager !== undefined ? this.manager : (0, $ilwiq.DefaultLoadingManager);
        let loader = manager.getHandler(url);
        if (loader === null) loader = new (0, $ilwiq.TextureLoader)(manager);
        if (loader.setCrossOrigin) loader.setCrossOrigin(this.crossOrigin);
        return new Promise((resolve, reject)=>{
            loader.load(url, (texture)=>{
                onLoad?.(texture);
                if (mapping !== undefined) texture.mapping = mapping;
                resolve(texture);
            }, onProgress, (err)=>{
                onError?.(err);
                reject(err);
            });
        });
    }
}

});
parcelRegister("ilwiq", function(module, exports) {

$parcel$export(module.exports, "FrontSide", () => $d5b33d7c30034067$export$2ede184fc2998901);
$parcel$export(module.exports, "DoubleSide", () => $d5b33d7c30034067$export$3b296b6f144d5b03);
$parcel$export(module.exports, "EquirectangularReflectionMapping", () => $d5b33d7c30034067$export$d64030b316d3b087);
$parcel$export(module.exports, "RepeatWrapping", () => $d5b33d7c30034067$export$533346c8e8dac0f5);
$parcel$export(module.exports, "ClampToEdgeWrapping", () => $d5b33d7c30034067$export$9d9334239a5a5e06);
$parcel$export(module.exports, "MirroredRepeatWrapping", () => $d5b33d7c30034067$export$c7e7c00b14f51a4f);
$parcel$export(module.exports, "NearestFilter", () => $d5b33d7c30034067$export$727aa5ec3fe39bf0);
$parcel$export(module.exports, "NearestMipmapNearestFilter", () => $d5b33d7c30034067$export$d129e38cf6feaa8c);
$parcel$export(module.exports, "NearestMipmapLinearFilter", () => $d5b33d7c30034067$export$d2327c1afe5bfdf2);
$parcel$export(module.exports, "LinearFilter", () => $d5b33d7c30034067$export$8a72f490b25c56c8);
$parcel$export(module.exports, "LinearMipmapNearestFilter", () => $d5b33d7c30034067$export$19a719f377145a13);
$parcel$export(module.exports, "LinearMipmapLinearFilter", () => $d5b33d7c30034067$export$5d8599b6a933fb1b);
$parcel$export(module.exports, "FloatType", () => $d5b33d7c30034067$export$f6d331659b644596);
$parcel$export(module.exports, "HalfFloatType", () => $d5b33d7c30034067$export$2697304443f382bc);
$parcel$export(module.exports, "RGBAFormat", () => $d5b33d7c30034067$export$3f8bb04b555a363c);
$parcel$export(module.exports, "RedFormat", () => $d5b33d7c30034067$export$4e041a7967d15c4b);
$parcel$export(module.exports, "InterpolateDiscrete", () => $d5b33d7c30034067$export$995b32462a65e855);
$parcel$export(module.exports, "InterpolateLinear", () => $d5b33d7c30034067$export$30fac1aace31cf4d);
$parcel$export(module.exports, "TrianglesDrawMode", () => $d5b33d7c30034067$export$4c28c87c2dc84758);
$parcel$export(module.exports, "TriangleStripDrawMode", () => $d5b33d7c30034067$export$b23a071aa286eb29);
$parcel$export(module.exports, "TriangleFanDrawMode", () => $d5b33d7c30034067$export$f0d8293634f88842);
$parcel$export(module.exports, "LinearEncoding", () => $d5b33d7c30034067$export$7207336e4151a112);
$parcel$export(module.exports, "sRGBEncoding", () => $d5b33d7c30034067$export$f32388edbb32674);
$parcel$export(module.exports, "SRGBColorSpace", () => $d5b33d7c30034067$export$561f394b24edfcaa);
$parcel$export(module.exports, "LinearSRGBColorSpace", () => $d5b33d7c30034067$export$42429b3acfb233a4);
$parcel$export(module.exports, "MathUtils", () => $d5b33d7c30034067$export$6a7ef315a0d1ef07);
$parcel$export(module.exports, "Vector2", () => $d5b33d7c30034067$export$c977b3e384af9ae1);
$parcel$export(module.exports, "Matrix3", () => $d5b33d7c30034067$export$8ff26dafa08918);
$parcel$export(module.exports, "ColorManagement", () => $d5b33d7c30034067$export$5e6fd513f44698c);
$parcel$export(module.exports, "Color", () => $d5b33d7c30034067$export$892596cec99bc70e);
$parcel$export(module.exports, "Source", () => $d5b33d7c30034067$export$1d2df86270c81ecb);
$parcel$export(module.exports, "Texture", () => $d5b33d7c30034067$export$5431306cf43de24a);
$parcel$export(module.exports, "Vector4", () => $d5b33d7c30034067$export$fa7daccca11cdbe3);
$parcel$export(module.exports, "Quaternion", () => $d5b33d7c30034067$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "Vector3", () => $d5b33d7c30034067$export$64b5c384219d3699);
$parcel$export(module.exports, "Box3", () => $d5b33d7c30034067$export$6f7d5a9418ab2aa3);
$parcel$export(module.exports, "Sphere", () => $d5b33d7c30034067$export$805e8b72413ccaba);
$parcel$export(module.exports, "Matrix4", () => $d5b33d7c30034067$export$2ae72fc923e5eb5);
$parcel$export(module.exports, "Euler", () => $d5b33d7c30034067$export$d93cc409a0768c5f);
$parcel$export(module.exports, "Object3D", () => $d5b33d7c30034067$export$e4dd07dff30cc924);
$parcel$export(module.exports, "Material", () => $d5b33d7c30034067$export$a2d8b23205c25948);
$parcel$export(module.exports, "MeshBasicMaterial", () => $d5b33d7c30034067$export$55cbcc9b622fe1f5);
$parcel$export(module.exports, "BufferAttribute", () => $d5b33d7c30034067$export$8dea267bd6bde117);
$parcel$export(module.exports, "Uint16BufferAttribute", () => $d5b33d7c30034067$export$640a853f68025f2e);
$parcel$export(module.exports, "Float32BufferAttribute", () => $d5b33d7c30034067$export$cbe7a62641830ebd);
$parcel$export(module.exports, "BufferGeometry", () => $d5b33d7c30034067$export$b7be63a67df8959);
$parcel$export(module.exports, "Mesh", () => $d5b33d7c30034067$export$e176487c05830cc5);
$parcel$export(module.exports, "PerspectiveCamera", () => $d5b33d7c30034067$export$74e4ae24825f68d7);
$parcel$export(module.exports, "OrthographicCamera", () => $d5b33d7c30034067$export$9ebf355ee4ed261b);
$parcel$export(module.exports, "Group", () => $d5b33d7c30034067$export$eb2fcfdbd7ba97d4);
$parcel$export(module.exports, "Scene", () => $d5b33d7c30034067$export$38af1803e3442a7f);
$parcel$export(module.exports, "InterleavedBuffer", () => $d5b33d7c30034067$export$3d5cd879f108f53f);
$parcel$export(module.exports, "InterleavedBufferAttribute", () => $d5b33d7c30034067$export$920b6d07334599c7);
$parcel$export(module.exports, "SpriteMaterial", () => $d5b33d7c30034067$export$5ec7dd1c6994bf8e);
$parcel$export(module.exports, "Sprite", () => $d5b33d7c30034067$export$3075603db8e6204c);
$parcel$export(module.exports, "SkinnedMesh", () => $d5b33d7c30034067$export$b303577035157ecf);
$parcel$export(module.exports, "Bone", () => $d5b33d7c30034067$export$b127726e56765aa4);
$parcel$export(module.exports, "Skeleton", () => $d5b33d7c30034067$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "InstancedBufferAttribute", () => $d5b33d7c30034067$export$32ea87a8b54d744a);
$parcel$export(module.exports, "InstancedMesh", () => $d5b33d7c30034067$export$f3c979c331175ad7);
$parcel$export(module.exports, "LineBasicMaterial", () => $d5b33d7c30034067$export$fbaaa33907730a0c);
$parcel$export(module.exports, "Line", () => $d5b33d7c30034067$export$17d680238e50603e);
$parcel$export(module.exports, "LineSegments", () => $d5b33d7c30034067$export$ff1ed10fedfdd604);
$parcel$export(module.exports, "LineLoop", () => $d5b33d7c30034067$export$f85a24d745e4f17d);
$parcel$export(module.exports, "PointsMaterial", () => $d5b33d7c30034067$export$a178c45366ce5d6b);
$parcel$export(module.exports, "Points", () => $d5b33d7c30034067$export$1c787534cb11aa3e);
$parcel$export(module.exports, "CanvasTexture", () => $d5b33d7c30034067$export$f7189e49152d1c13);
$parcel$export(module.exports, "Curve", () => $d5b33d7c30034067$export$b0e83c3ef8d2db1);
$parcel$export(module.exports, "MeshStandardMaterial", () => $d5b33d7c30034067$export$f2980790215acccd);
$parcel$export(module.exports, "MeshPhysicalMaterial", () => $d5b33d7c30034067$export$28d04986c4269c9f);
$parcel$export(module.exports, "MeshPhongMaterial", () => $d5b33d7c30034067$export$24c72f71cbaf0678);
$parcel$export(module.exports, "MeshLambertMaterial", () => $d5b33d7c30034067$export$5023a9a8114806b8);
$parcel$export(module.exports, "Interpolant", () => $d5b33d7c30034067$export$b558baee9c0f72d3);
$parcel$export(module.exports, "NumberKeyframeTrack", () => $d5b33d7c30034067$export$d45f0d1a4d9a9314);
$parcel$export(module.exports, "QuaternionKeyframeTrack", () => $d5b33d7c30034067$export$b8043f12b5aafbd7);
$parcel$export(module.exports, "VectorKeyframeTrack", () => $d5b33d7c30034067$export$5ce2dcb4cc9f2bff);
$parcel$export(module.exports, "AnimationClip", () => $d5b33d7c30034067$export$d942c706bf23829c);
$parcel$export(module.exports, "DefaultLoadingManager", () => $d5b33d7c30034067$export$b033c3f9a95c6a16);
$parcel$export(module.exports, "Loader", () => $d5b33d7c30034067$export$3b0d6d7590275603);
$parcel$export(module.exports, "FileLoader", () => $d5b33d7c30034067$export$98435a25b5cf7b2b);
$parcel$export(module.exports, "DataTextureLoader", () => $d5b33d7c30034067$export$792d8a18f2c55855);
$parcel$export(module.exports, "TextureLoader", () => $d5b33d7c30034067$export$fd1bfc71f64c538c);
$parcel$export(module.exports, "SpotLight", () => $d5b33d7c30034067$export$81495cbb73897362);
$parcel$export(module.exports, "PointLight", () => $d5b33d7c30034067$export$4c9c1cb3f0b6f455);
$parcel$export(module.exports, "DirectionalLight", () => $d5b33d7c30034067$export$3fea33cc9972c868);
$parcel$export(module.exports, "AmbientLight", () => $d5b33d7c30034067$export$af279bfef9ec2c96);
$parcel$export(module.exports, "RectAreaLight", () => $d5b33d7c30034067$export$61db2d908bbd2429);
$parcel$export(module.exports, "LoaderUtils", () => $d5b33d7c30034067$export$b5d2dc08d867e41a);
$parcel$export(module.exports, "BufferGeometryLoader", () => $d5b33d7c30034067$export$dc275bb96327833a);
$parcel$export(module.exports, "ImageBitmapLoader", () => $d5b33d7c30034067$export$52286b55c4a9b51f);
$parcel$export(module.exports, "PropertyBinding", () => $d5b33d7c30034067$export$7bf70fcf9f891893);
$parcel$export(module.exports, "DataUtils", () => $d5b33d7c30034067$export$11ce8b759162cc80);
/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $d5b33d7c30034067$export$3545e07a80636437 = '143';
const $d5b33d7c30034067$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $d5b33d7c30034067$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $d5b33d7c30034067$export$3237e1f2c1ea1f44 = 0;
const $d5b33d7c30034067$export$b9a7b4fc5cb15f9b = 1;
const $d5b33d7c30034067$export$b8058bcc7037d3f3 = 2;
const $d5b33d7c30034067$export$f24be24dcddeac0d = 3;
const $d5b33d7c30034067$export$346307dbae2b7447 = 0;
const $d5b33d7c30034067$export$5813f879eee7cd88 = 1;
const $d5b33d7c30034067$export$a47c4b43a1be34f0 = 2;
const $d5b33d7c30034067$export$896ae1ade6c829c4 = 3;
const $d5b33d7c30034067$export$2ede184fc2998901 = 0;
const $d5b33d7c30034067$export$d9f0486e75b5ace = 1;
const $d5b33d7c30034067$export$3b296b6f144d5b03 = 2;
const $d5b33d7c30034067$export$a62047d29c96d8ff = 1;
const $d5b33d7c30034067$export$fadb74c06a7f490 = 2;
const $d5b33d7c30034067$export$63b8d6b580fc65ba = 0;
const $d5b33d7c30034067$export$5b29a26d96ee6af0 = 1;
const $d5b33d7c30034067$export$777d8f9551c2216b = 2;
const $d5b33d7c30034067$export$cdfa06f868e2e467 = 3;
const $d5b33d7c30034067$export$4138e1c684b46a20 = 4;
const $d5b33d7c30034067$export$eda4864c68df1fa2 = 5;
const $d5b33d7c30034067$export$20183a0484ce21a0 = 100;
const $d5b33d7c30034067$export$73e0df5177988548 = 101;
const $d5b33d7c30034067$export$28e582859cbec660 = 102;
const $d5b33d7c30034067$export$c8c1508da8d0600c = 103;
const $d5b33d7c30034067$export$99948c02fb51055f = 104;
const $d5b33d7c30034067$export$2110f05edf778d3d = 200;
const $d5b33d7c30034067$export$8805bad65e24940e = 201;
const $d5b33d7c30034067$export$7fbe15b28d28cf52 = 202;
const $d5b33d7c30034067$export$947829af9f2c17f6 = 203;
const $d5b33d7c30034067$export$d5773124e86cf28c = 204;
const $d5b33d7c30034067$export$11d468cc7f19e971 = 205;
const $d5b33d7c30034067$export$a78aed1ca2a87192 = 206;
const $d5b33d7c30034067$export$5d0fe17fd8773bac = 207;
const $d5b33d7c30034067$export$ef5f2dd8ffac5574 = 208;
const $d5b33d7c30034067$export$56b85b2686ab16 = 209;
const $d5b33d7c30034067$export$c05e2a1fc8609506 = 210;
const $d5b33d7c30034067$export$69025ce147cee220 = 0;
const $d5b33d7c30034067$export$7182eb52ea3b3f04 = 1;
const $d5b33d7c30034067$export$eedccec66ab7ebe = 2;
const $d5b33d7c30034067$export$296f78a0b892f81a = 3;
const $d5b33d7c30034067$export$a60d398fc7b7590e = 4;
const $d5b33d7c30034067$export$7d7234c1240a1fc4 = 5;
const $d5b33d7c30034067$export$c5e2c52991f30937 = 6;
const $d5b33d7c30034067$export$2f843afa843d8916 = 7;
const $d5b33d7c30034067$export$e50ac29801f1774d = 0;
const $d5b33d7c30034067$export$9f9d94f963c85479 = 1;
const $d5b33d7c30034067$export$e641dc52bc3494aa = 2;
const $d5b33d7c30034067$export$9fcb6b4294603b2 = 0;
const $d5b33d7c30034067$export$98f52c2a46c598ca = 1;
const $d5b33d7c30034067$export$74b25e54b3bcd548 = 2;
const $d5b33d7c30034067$export$932b3dd283d4a366 = 3;
const $d5b33d7c30034067$export$a0d98fe6d7e4af64 = 4;
const $d5b33d7c30034067$export$2c7b09c1e9abfb5e = 5;
const $d5b33d7c30034067$export$1beec6768cbb3d2d = 300;
const $d5b33d7c30034067$export$8759762a6477f2c4 = 301;
const $d5b33d7c30034067$export$dc59f8aed047f61d = 302;
const $d5b33d7c30034067$export$d64030b316d3b087 = 303;
const $d5b33d7c30034067$export$ee99d97d46898098 = 304;
const $d5b33d7c30034067$export$dbf3e70ff37af79 = 306;
const $d5b33d7c30034067$export$533346c8e8dac0f5 = 1000;
const $d5b33d7c30034067$export$9d9334239a5a5e06 = 1001;
const $d5b33d7c30034067$export$c7e7c00b14f51a4f = 1002;
const $d5b33d7c30034067$export$727aa5ec3fe39bf0 = 1003;
const $d5b33d7c30034067$export$d129e38cf6feaa8c = 1004;
const $d5b33d7c30034067$export$14a4936464a36496 = 1004;
const $d5b33d7c30034067$export$d2327c1afe5bfdf2 = 1005;
const $d5b33d7c30034067$export$cbc5b7f5647595d8 = 1005;
const $d5b33d7c30034067$export$8a72f490b25c56c8 = 1006;
const $d5b33d7c30034067$export$19a719f377145a13 = 1007;
const $d5b33d7c30034067$export$dbe96bee3fe9dbf0 = 1007;
const $d5b33d7c30034067$export$5d8599b6a933fb1b = 1008;
const $d5b33d7c30034067$export$90d80f1e3506775f = 1008;
const $d5b33d7c30034067$export$2e8ce08d3f6f5e10 = 1009;
const $d5b33d7c30034067$export$545fce0311a9796a = 1010;
const $d5b33d7c30034067$export$88572337f312435f = 1011;
const $d5b33d7c30034067$export$c63dc51868b06a9d = 1012;
const $d5b33d7c30034067$export$5c612977753abe2 = 1013;
const $d5b33d7c30034067$export$c3c7fc4518ebba96 = 1014;
const $d5b33d7c30034067$export$f6d331659b644596 = 1015;
const $d5b33d7c30034067$export$2697304443f382bc = 1016;
const $d5b33d7c30034067$export$b3969b01faf587f2 = 1017;
const $d5b33d7c30034067$export$18886f8ae33e90de = 1018;
const $d5b33d7c30034067$export$6c8ea339bfab1301 = 1020;
const $d5b33d7c30034067$export$988473390501ed4b = 1021;
const $d5b33d7c30034067$export$7c67423a5ee6f5eb = 1022;
const $d5b33d7c30034067$export$3f8bb04b555a363c = 1023;
const $d5b33d7c30034067$export$cc09ccbf6d1ed449 = 1024;
const $d5b33d7c30034067$export$9053a81c4a69c289 = 1025;
const $d5b33d7c30034067$export$c1b6b5136be58045 = 1026;
const $d5b33d7c30034067$export$1e113ac2d0905829 = 1027;
const $d5b33d7c30034067$export$4e041a7967d15c4b = 1028;
const $d5b33d7c30034067$export$aa92e870a709d190 = 1029;
const $d5b33d7c30034067$export$6cdf0b461c7ce8a0 = 1030;
const $d5b33d7c30034067$export$1ba1c45f9f77d4d7 = 1031;
const $d5b33d7c30034067$export$c200e7d26f592f21 = 1033;
const $d5b33d7c30034067$export$21d1799c6d552fc0 = 33776;
const $d5b33d7c30034067$export$afa304c3e981b668 = 33777;
const $d5b33d7c30034067$export$d2a1a68024a3e56c = 33778;
const $d5b33d7c30034067$export$9a79c424327dacf9 = 33779;
const $d5b33d7c30034067$export$19ada9bbb1af3573 = 35840;
const $d5b33d7c30034067$export$d0f0355bb3d948e4 = 35841;
const $d5b33d7c30034067$export$b82296714358084c = 35842;
const $d5b33d7c30034067$export$b71692456c47b6c3 = 35843;
const $d5b33d7c30034067$export$6ab91af2d757aee7 = 36196;
const $d5b33d7c30034067$export$7800993ef8106a6a = 37492;
const $d5b33d7c30034067$export$23ed8300a860e7d8 = 37496;
const $d5b33d7c30034067$export$dc5570b4a2b92d48 = 37808;
const $d5b33d7c30034067$export$68880cd325f8b2fb = 37809;
const $d5b33d7c30034067$export$7d2c0be323373d95 = 37810;
const $d5b33d7c30034067$export$22b52da301fc3a3e = 37811;
const $d5b33d7c30034067$export$c009e2cb4a66485e = 37812;
const $d5b33d7c30034067$export$118fff5afa255b63 = 37813;
const $d5b33d7c30034067$export$120713c829ae0667 = 37814;
const $d5b33d7c30034067$export$c79eeabbf53313e9 = 37815;
const $d5b33d7c30034067$export$443cf6567cdd6424 = 37816;
const $d5b33d7c30034067$export$6573984fc9840780 = 37817;
const $d5b33d7c30034067$export$e7aee563f30091de = 37818;
const $d5b33d7c30034067$export$2eb8634622ddeab7 = 37819;
const $d5b33d7c30034067$export$202b1ce7b5d25742 = 37820;
const $d5b33d7c30034067$export$18ab77abd087e467 = 37821;
const $d5b33d7c30034067$export$ce40b115e188bc81 = 36492;
const $d5b33d7c30034067$export$d62fdc9d1b1cccad = 2200;
const $d5b33d7c30034067$export$dfaf4422ce096e29 = 2201;
const $d5b33d7c30034067$export$f8f6f2041b78e210 = 2202;
const $d5b33d7c30034067$export$995b32462a65e855 = 2300;
const $d5b33d7c30034067$export$30fac1aace31cf4d = 2301;
const $d5b33d7c30034067$export$198b11ff4c72bb30 = 2302;
const $d5b33d7c30034067$export$7f795934b84ab523 = 2400;
const $d5b33d7c30034067$export$24a4ccb5099273b5 = 2401;
const $d5b33d7c30034067$export$8e8c3ecdcd8e1fee = 2402;
const $d5b33d7c30034067$export$bcfbbdcf8de7f8cd = 2500;
const $d5b33d7c30034067$export$d875e029ef558d3 = 2501;
const $d5b33d7c30034067$export$4c28c87c2dc84758 = 0;
const $d5b33d7c30034067$export$b23a071aa286eb29 = 1;
const $d5b33d7c30034067$export$f0d8293634f88842 = 2;
const $d5b33d7c30034067$export$7207336e4151a112 = 3000;
const $d5b33d7c30034067$export$f32388edbb32674 = 3001;
const $d5b33d7c30034067$export$deeb383078690b50 = 3200;
const $d5b33d7c30034067$export$8f910f4c4f73df11 = 3201;
const $d5b33d7c30034067$export$2852a58ebdac27b8 = 0;
const $d5b33d7c30034067$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $d5b33d7c30034067$export$bfcb490c2dd3db51 = '';
const $d5b33d7c30034067$export$561f394b24edfcaa = 'srgb';
const $d5b33d7c30034067$export$42429b3acfb233a4 = 'srgb-linear';
const $d5b33d7c30034067$export$69433f11f42d5527 = 0;
const $d5b33d7c30034067$export$9f542ae4b5baca34 = 7680;
const $d5b33d7c30034067$export$8a4f28336ef203d3 = 7681;
const $d5b33d7c30034067$export$2928c0231297c036 = 7682;
const $d5b33d7c30034067$export$c0e9611c8a15f9a8 = 7683;
const $d5b33d7c30034067$export$9c2c08927385dcc4 = 34055;
const $d5b33d7c30034067$export$7c74ea00fa1315e6 = 34056;
const $d5b33d7c30034067$export$22e2e5726612443 = 5386;
const $d5b33d7c30034067$export$1343870698229224 = 512;
const $d5b33d7c30034067$export$8e1d8ed281997fa6 = 513;
const $d5b33d7c30034067$export$55648a1cde8329a7 = 514;
const $d5b33d7c30034067$export$2dff107857e6aca2 = 515;
const $d5b33d7c30034067$export$6f93765ab2f451a2 = 516;
const $d5b33d7c30034067$export$6f3fb2d2440f2b76 = 517;
const $d5b33d7c30034067$export$4119cf7b4c98fd5a = 518;
const $d5b33d7c30034067$export$14cf96713ddd97a8 = 519;
const $d5b33d7c30034067$export$763e8360f4d7f77d = 35044;
const $d5b33d7c30034067$export$8505d14ac8546ca = 35048;
const $d5b33d7c30034067$export$721e63549e51d81e = 35040;
const $d5b33d7c30034067$export$415731dc4f48e299 = 35045;
const $d5b33d7c30034067$export$9e809946455f13bc = 35049;
const $d5b33d7c30034067$export$2ed9499a35b5f832 = 35041;
const $d5b33d7c30034067$export$32ab2503ea19469a = 35046;
const $d5b33d7c30034067$export$ab4022c2c3f86315 = 35050;
const $d5b33d7c30034067$export$ba7f1db36a76a970 = 35042;
const $d5b33d7c30034067$export$43600cc67fabd9f = '100';
const $d5b33d7c30034067$export$f63012db5506e7dd = '300 es';
const $d5b33d7c30034067$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $d5b33d7c30034067$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $d5b33d7c30034067$var$_seed = 1234567;
const $d5b33d7c30034067$var$DEG2RAD = Math.PI / 180;
const $d5b33d7c30034067$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $d5b33d7c30034067$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $d5b33d7c30034067$var$_lut[d0 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d0 >> 24 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d1 & 0xff] + $d5b33d7c30034067$var$_lut[d1 >> 8 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d1 >> 16 & 0x0f | 0x40] + $d5b33d7c30034067$var$_lut[d1 >> 24 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d2 & 0x3f | 0x80] + $d5b33d7c30034067$var$_lut[d2 >> 8 & 0xff] + '-' + $d5b33d7c30034067$var$_lut[d2 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d2 >> 24 & 0xff] + $d5b33d7c30034067$var$_lut[d3 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 8 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 16 & 0xff] + $d5b33d7c30034067$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $d5b33d7c30034067$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $d5b33d7c30034067$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $d5b33d7c30034067$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $d5b33d7c30034067$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $d5b33d7c30034067$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $d5b33d7c30034067$var$damp(x, y, lambda, dt) {
    return $d5b33d7c30034067$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $d5b33d7c30034067$var$pingpong(x, length = 1) {
    return length - Math.abs($d5b33d7c30034067$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $d5b33d7c30034067$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $d5b33d7c30034067$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $d5b33d7c30034067$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $d5b33d7c30034067$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $d5b33d7c30034067$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $d5b33d7c30034067$var$seededRandom(s) {
    if (s !== undefined) $d5b33d7c30034067$var$_seed = s;
    // Mulberry32 generator
    let t = $d5b33d7c30034067$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $d5b33d7c30034067$var$degToRad(degrees) {
    return degrees * $d5b33d7c30034067$var$DEG2RAD;
}
function $d5b33d7c30034067$var$radToDeg(radians) {
    return radians * $d5b33d7c30034067$var$RAD2DEG;
}
function $d5b33d7c30034067$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $d5b33d7c30034067$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $d5b33d7c30034067$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $d5b33d7c30034067$var$denormalize$1(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $d5b33d7c30034067$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
var $d5b33d7c30034067$export$6a7ef315a0d1ef07 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEG2RAD: $d5b33d7c30034067$var$DEG2RAD,
    RAD2DEG: $d5b33d7c30034067$var$RAD2DEG,
    generateUUID: $d5b33d7c30034067$var$generateUUID,
    clamp: $d5b33d7c30034067$var$clamp,
    euclideanModulo: $d5b33d7c30034067$var$euclideanModulo,
    mapLinear: $d5b33d7c30034067$var$mapLinear,
    inverseLerp: $d5b33d7c30034067$var$inverseLerp,
    lerp: $d5b33d7c30034067$var$lerp,
    damp: $d5b33d7c30034067$var$damp,
    pingpong: $d5b33d7c30034067$var$pingpong,
    smoothstep: $d5b33d7c30034067$var$smoothstep,
    smootherstep: $d5b33d7c30034067$var$smootherstep,
    randInt: $d5b33d7c30034067$var$randInt,
    randFloat: $d5b33d7c30034067$var$randFloat,
    randFloatSpread: $d5b33d7c30034067$var$randFloatSpread,
    seededRandom: $d5b33d7c30034067$var$seededRandom,
    degToRad: $d5b33d7c30034067$var$degToRad,
    radToDeg: $d5b33d7c30034067$var$radToDeg,
    isPowerOfTwo: $d5b33d7c30034067$var$isPowerOfTwo,
    ceilPowerOfTwo: $d5b33d7c30034067$var$ceilPowerOfTwo,
    floorPowerOfTwo: $d5b33d7c30034067$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $d5b33d7c30034067$var$setQuaternionFromProperEuler,
    normalize: $d5b33d7c30034067$var$normalize,
    denormalize: $d5b33d7c30034067$var$denormalize$1
});
class $d5b33d7c30034067$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $d5b33d7c30034067$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $d5b33d7c30034067$export$8ff26dafa08918 {
    constructor(){
        $d5b33d7c30034067$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    scale(sx, sy) {
        const te = this.elements;
        te[0] *= sx;
        te[3] *= sx;
        te[6] *= sx;
        te[1] *= sy;
        te[4] *= sy;
        te[7] *= sy;
        return this;
    }
    rotate(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        const te = this.elements;
        const a11 = te[0], a12 = te[3], a13 = te[6];
        const a21 = te[1], a22 = te[4], a23 = te[7];
        te[0] = c * a11 + s * a21;
        te[3] = c * a12 + s * a22;
        te[6] = c * a13 + s * a23;
        te[1] = -s * a11 + c * a21;
        te[4] = -s * a12 + c * a22;
        te[7] = -s * a13 + c * a23;
        return this;
    }
    translate(tx, ty) {
        const te = this.elements;
        te[0] += tx * te[2];
        te[3] += tx * te[5];
        te[6] += tx * te[8];
        te[1] += ty * te[2];
        te[4] += ty * te[5];
        te[7] += ty * te[8];
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
function $d5b33d7c30034067$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] > 65535) return true;
    }
    return false;
}
const $d5b33d7c30034067$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $d5b33d7c30034067$var$getTypedArray(type, buffer) {
    return new $d5b33d7c30034067$var$TYPED_ARRAYS[type](buffer);
}
function $d5b33d7c30034067$var$createElementNS(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $d5b33d7c30034067$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $d5b33d7c30034067$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
// JavaScript RGB-to-RGB transforms, defined as
// FN[InputColorSpace][OutputColorSpace] callback functions.
const $d5b33d7c30034067$var$FN = {
    [$d5b33d7c30034067$export$561f394b24edfcaa]: {
        [$d5b33d7c30034067$export$42429b3acfb233a4]: $d5b33d7c30034067$var$SRGBToLinear
    },
    [$d5b33d7c30034067$export$42429b3acfb233a4]: {
        [$d5b33d7c30034067$export$561f394b24edfcaa]: $d5b33d7c30034067$var$LinearToSRGB
    }
};
const $d5b33d7c30034067$export$5e6fd513f44698c = {
    legacyMode: true,
    get workingColorSpace () {
        return $d5b33d7c30034067$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn('THREE.ColorManagement: .workingColorSpace is readonly.');
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.legacyMode || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        if ($d5b33d7c30034067$var$FN[sourceColorSpace] && $d5b33d7c30034067$var$FN[sourceColorSpace][targetColorSpace] !== undefined) {
            const fn = $d5b33d7c30034067$var$FN[sourceColorSpace][targetColorSpace];
            color.r = fn(color.r);
            color.g = fn(color.g);
            color.b = fn(color.b);
            return color;
        }
        throw new Error('Unsupported color space conversion.');
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
const $d5b33d7c30034067$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $d5b33d7c30034067$var$_rgb = {
    r: 0,
    g: 0,
    b: 0
};
const $d5b33d7c30034067$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $d5b33d7c30034067$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $d5b33d7c30034067$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function $d5b33d7c30034067$var$toComponents(source, target) {
    target.r = source.r;
    target.g = source.g;
    target.b = source.b;
    return target;
}
class $d5b33d7c30034067$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === 'number') this.setHex(value);
        else if (typeof value === 'string') this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $d5b33d7c30034067$export$42429b3acfb233a4) {
        this.r = r;
        this.g = g;
        this.b = b;
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $d5b33d7c30034067$export$42429b3acfb233a4) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $d5b33d7c30034067$var$euclideanModulo(h, 1);
        s = $d5b33d7c30034067$var$clamp(s, 0, 1);
        l = $d5b33d7c30034067$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $d5b33d7c30034067$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $d5b33d7c30034067$var$hue2rgb(q, p, h);
            this.b = $d5b33d7c30034067$var$hue2rgb(q, p, h - 1 / 3);
        }
        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseInt(color[2], 10) / 100;
                        const l = parseInt(color[3], 10) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l, colorSpace1);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                $d5b33d7c30034067$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        // color keywords
        const hex = $d5b33d7c30034067$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $d5b33d7c30034067$var$SRGBToLinear(color.r);
        this.g = $d5b33d7c30034067$var$SRGBToLinear(color.g);
        this.b = $d5b33d7c30034067$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $d5b33d7c30034067$var$LinearToSRGB(color.r);
        this.g = $d5b33d7c30034067$var$LinearToSRGB(color.g);
        this.b = $d5b33d7c30034067$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$toComponents(this, $d5b33d7c30034067$var$_rgb), colorSpace1);
        return $d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_rgb.r * 255, 0, 255) << 16 ^ $d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_rgb.g * 255, 0, 255) << 8 ^ $d5b33d7c30034067$var$clamp($d5b33d7c30034067$var$_rgb.b * 255, 0, 255) << 0;
    }
    getHexString(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $d5b33d7c30034067$export$42429b3acfb233a4) {
        // h,s,l ranges are in 0.0 - 1.0
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$toComponents(this, $d5b33d7c30034067$var$_rgb), colorSpace1);
        const r = $d5b33d7c30034067$var$_rgb.r, g = $d5b33d7c30034067$var$_rgb.g, b = $d5b33d7c30034067$var$_rgb.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $d5b33d7c30034067$export$42429b3acfb233a4) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$toComponents(this, $d5b33d7c30034067$var$_rgb), colorSpace1);
        target.r = $d5b33d7c30034067$var$_rgb.r;
        target.g = $d5b33d7c30034067$var$_rgb.g;
        target.b = $d5b33d7c30034067$var$_rgb.b;
        return target;
    }
    getStyle(colorSpace1 = $d5b33d7c30034067$export$561f394b24edfcaa) {
        $d5b33d7c30034067$export$5e6fd513f44698c.fromWorkingColorSpace($d5b33d7c30034067$var$toComponents(this, $d5b33d7c30034067$var$_rgb), colorSpace1);
        if (colorSpace1 !== $d5b33d7c30034067$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${$d5b33d7c30034067$var$_rgb.r} ${$d5b33d7c30034067$var$_rgb.g} ${$d5b33d7c30034067$var$_rgb.b})`;
        return `rgb(${$d5b33d7c30034067$var$_rgb.r * 255 | 0},${$d5b33d7c30034067$var$_rgb.g * 255 | 0},${$d5b33d7c30034067$var$_rgb.b * 255 | 0})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        $d5b33d7c30034067$var$_hslA.h += h;
        $d5b33d7c30034067$var$_hslA.s += s;
        $d5b33d7c30034067$var$_hslA.l += l;
        this.setHSL($d5b33d7c30034067$var$_hslA.h, $d5b33d7c30034067$var$_hslA.s, $d5b33d7c30034067$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($d5b33d7c30034067$var$_hslA);
        color.getHSL($d5b33d7c30034067$var$_hslB);
        const h = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.h, $d5b33d7c30034067$var$_hslB.h, alpha);
        const s = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.s, $d5b33d7c30034067$var$_hslB.s, alpha);
        const l = $d5b33d7c30034067$var$lerp($d5b33d7c30034067$var$_hslA.l, $d5b33d7c30034067$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        if (attribute.normalized === true) {
            // assuming Uint8Array
            this.r /= 255;
            this.g /= 255;
            this.b /= 255;
        }
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
$d5b33d7c30034067$export$892596cec99bc70e.NAMES = $d5b33d7c30034067$var$_colorKeywords;
let $d5b33d7c30034067$var$_canvas;
class $d5b33d7c30034067$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement == 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($d5b33d7c30034067$var$_canvas === undefined) $d5b33d7c30034067$var$_canvas = $d5b33d7c30034067$var$createElementNS('canvas');
            $d5b33d7c30034067$var$_canvas.width = image.width;
            $d5b33d7c30034067$var$_canvas.height = image.height;
            const context = $d5b33d7c30034067$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $d5b33d7c30034067$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $d5b33d7c30034067$var$createElementNS('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($d5b33d7c30034067$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $d5b33d7c30034067$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
class $d5b33d7c30034067$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($d5b33d7c30034067$var$serializeImage(data[i].image));
                else url.push($d5b33d7c30034067$var$serializeImage(data[i]));
            } else // texture
            url = $d5b33d7c30034067$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $d5b33d7c30034067$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $d5b33d7c30034067$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $d5b33d7c30034067$var$textureId = 0;
class $d5b33d7c30034067$export$5431306cf43de24a extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(image = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $d5b33d7c30034067$export$9d9334239a5a5e06, wrapT = $d5b33d7c30034067$export$9d9334239a5a5e06, magFilter = $d5b33d7c30034067$export$8a72f490b25c56c8, minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b, format = $d5b33d7c30034067$export$3f8bb04b555a363c, type = $d5b33d7c30034067$export$2e8ce08d3f6f5e10, anisotropy = 1, encoding = $d5b33d7c30034067$export$7207336e4151a112){
        super();
        this.isTexture = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$textureId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $d5b33d7c30034067$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
        //
        // Also changing the encoding after already used by a Material will not automatically make the Material
        // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
        this.encoding = encoding;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (JSON.stringify(this.userData) !== '{}') output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== $d5b33d7c30034067$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $d5b33d7c30034067$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $d5b33d7c30034067$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $d5b33d7c30034067$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
}
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$d5b33d7c30034067$export$5431306cf43de24a.DEFAULT_MAPPING = $d5b33d7c30034067$export$1beec6768cbb3d2d;
class $d5b33d7c30034067$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $d5b33d7c30034067$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $d5b33d7c30034067$export$3c052beb2e51e23f extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(width, height, options = {}){
        super();
        this.isWebGLRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        this.texture = new $d5b33d7c30034067$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $d5b33d7c30034067$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $d5b33d7c30034067$export$dfac6c8e811406a3 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$c77a02c11ed180c7 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width, height, depth){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$d7a3086320f856db extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.wrapR = $d5b33d7c30034067$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $d5b33d7c30034067$export$7ee06591009639df extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width, height, depth){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $d5b33d7c30034067$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $d5b33d7c30034067$export$bd934554fb721730 extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width, height, count, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.set(0, 0, this.width, this.height);
        this.scissor.set(0, 0, this.width, this.height);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $d5b33d7c30034067$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        if (!(euler && euler.isEuler)) throw new Error('THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.');
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($d5b33d7c30034067$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $d5b33d7c30034067$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $d5b33d7c30034067$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($d5b33d7c30034067$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $d5b33d7c30034067$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($d5b33d7c30034067$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($d5b33d7c30034067$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($d5b33d7c30034067$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $d5b33d7c30034067$var$_vector$c = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$6f7d5a9418ab2aa3 {
    constructor(min = new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromBufferAttribute(attribute) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = attribute.count; i < l; i++){
            const x = attribute.getX(i);
            const y = attribute.getY(i);
            const z = attribute.getZ(i);
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            if (precise && geometry.attributes != undefined && geometry.attributes.position !== undefined) {
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count; i < l; i++){
                    $d5b33d7c30034067$var$_vector$b.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                    this.expandByPoint($d5b33d7c30034067$var$_vector$b);
                }
            } else {
                if (geometry.boundingBox === null) geometry.computeBoundingBox();
                $d5b33d7c30034067$var$_box$3.copy(geometry.boundingBox);
                $d5b33d7c30034067$var$_box$3.applyMatrix4(object.matrixWorld);
                this.union($d5b33d7c30034067$var$_box$3);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $d5b33d7c30034067$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $d5b33d7c30034067$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_extents.subVectors(this.max, $d5b33d7c30034067$var$_center);
        // translate triangle to aabb origin
        $d5b33d7c30034067$var$_v0$2.subVectors(triangle.a, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v1$7.subVectors(triangle.b, $d5b33d7c30034067$var$_center);
        $d5b33d7c30034067$var$_v2$3.subVectors(triangle.c, $d5b33d7c30034067$var$_center);
        // compute edge vectors for triangle
        $d5b33d7c30034067$var$_f0.subVectors($d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v0$2);
        $d5b33d7c30034067$var$_f1.subVectors($d5b33d7c30034067$var$_v2$3, $d5b33d7c30034067$var$_v1$7);
        $d5b33d7c30034067$var$_f2.subVectors($d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v2$3);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$d5b33d7c30034067$var$_f0.z,
            $d5b33d7c30034067$var$_f0.y,
            0,
            -$d5b33d7c30034067$var$_f1.z,
            $d5b33d7c30034067$var$_f1.y,
            0,
            -$d5b33d7c30034067$var$_f2.z,
            $d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f0.z,
            0,
            -$d5b33d7c30034067$var$_f0.x,
            $d5b33d7c30034067$var$_f1.z,
            0,
            -$d5b33d7c30034067$var$_f1.x,
            $d5b33d7c30034067$var$_f2.z,
            0,
            -$d5b33d7c30034067$var$_f2.x,
            -$d5b33d7c30034067$var$_f0.y,
            $d5b33d7c30034067$var$_f0.x,
            0,
            -$d5b33d7c30034067$var$_f1.y,
            $d5b33d7c30034067$var$_f1.x,
            0,
            -$d5b33d7c30034067$var$_f2.y,
            $d5b33d7c30034067$var$_f2.x,
            0
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$3, $d5b33d7c30034067$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$3, $d5b33d7c30034067$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $d5b33d7c30034067$var$_triangleNormal.crossVectors($d5b33d7c30034067$var$_f0, $d5b33d7c30034067$var$_f1);
        axes = [
            $d5b33d7c30034067$var$_triangleNormal.x,
            $d5b33d7c30034067$var$_triangleNormal.y,
            $d5b33d7c30034067$var$_triangleNormal.z
        ];
        return $d5b33d7c30034067$var$satForAxes(axes, $d5b33d7c30034067$var$_v0$2, $d5b33d7c30034067$var$_v1$7, $d5b33d7c30034067$var$_v2$3, $d5b33d7c30034067$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $d5b33d7c30034067$var$_vector$b.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        this.getCenter(target.center);
        target.radius = this.getSize($d5b33d7c30034067$var$_vector$b).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $d5b33d7c30034067$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $d5b33d7c30034067$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $d5b33d7c30034067$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $d5b33d7c30034067$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $d5b33d7c30034067$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $d5b33d7c30034067$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $d5b33d7c30034067$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $d5b33d7c30034067$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($d5b33d7c30034067$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_points = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
];
const $d5b33d7c30034067$var$_vector$b = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $d5b33d7c30034067$var$_v0$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
// triangle edge vectors
const $d5b33d7c30034067$var$_f0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_f2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_center = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_extents = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangleNormal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_testAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
function $d5b33d7c30034067$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $d5b33d7c30034067$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($d5b33d7c30034067$var$_testAxis.x) + extents.y * Math.abs($d5b33d7c30034067$var$_testAxis.y) + extents.z * Math.abs($d5b33d7c30034067$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($d5b33d7c30034067$var$_testAxis);
        const p1 = v1.dot($d5b33d7c30034067$var$_testAxis);
        const p2 = v2.dot($d5b33d7c30034067$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $d5b33d7c30034067$var$_box$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_v1$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_toFarthestPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_toPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$805e8b72413ccaba {
    constructor(center = new $d5b33d7c30034067$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $d5b33d7c30034067$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
        $d5b33d7c30034067$var$_toPoint.subVectors(point, this.center);
        const lengthSq = $d5b33d7c30034067$var$_toPoint.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            const length = Math.sqrt(lengthSq);
            const missingRadiusHalf = (length - this.radius) * 0.5;
            // Nudge this sphere towards the target point. Add half the missing distance to radius,
            // and the other half to position. This gives a tighter enclosure, instead of if
            // the whole missing distance were just added to radius.
            this.center.add($d5b33d7c30034067$var$_toPoint.multiplyScalar(missingRadiusHalf / length));
            this.radius += missingRadiusHalf;
        }
        return this;
    }
    union(sphere) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
        // To enclose another sphere into this sphere, we only need to enclose two points:
        // 1) Enclose the farthest point on the other sphere into this sphere.
        // 2) Enclose the opposite point of the farthest point into this sphere.
        if (this.center.equals(sphere.center) === true) $d5b33d7c30034067$var$_toFarthestPoint.set(0, 0, 1).multiplyScalar(sphere.radius);
        else $d5b33d7c30034067$var$_toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
        this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).add($d5b33d7c30034067$var$_toFarthestPoint));
        this.expandByPoint($d5b33d7c30034067$var$_v1$6.copy(sphere.center).sub($d5b33d7c30034067$var$_toFarthestPoint));
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$a = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segCenter = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_segDir = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_diff = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_edge2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$a186db52eed6d40e {
    constructor(origin = new $d5b33d7c30034067$export$64b5c384219d3699(), direction = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $d5b33d7c30034067$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $d5b33d7c30034067$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $d5b33d7c30034067$var$_vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return $d5b33d7c30034067$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $d5b33d7c30034067$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $d5b33d7c30034067$var$_segDir.copy(v1).sub(v0).normalize();
        $d5b33d7c30034067$var$_diff.copy(this.origin).sub($d5b33d7c30034067$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($d5b33d7c30034067$var$_segDir);
        const b0 = $d5b33d7c30034067$var$_diff.dot(this.direction);
        const b1 = -$d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_segDir);
        const c = $d5b33d7c30034067$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($d5b33d7c30034067$var$_segDir).multiplyScalar(s1).add($d5b33d7c30034067$var$_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $d5b33d7c30034067$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $d5b33d7c30034067$var$_vector$a.dot(this.direction);
        const d2 = $d5b33d7c30034067$var$_vector$a.dot($d5b33d7c30034067$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $d5b33d7c30034067$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $d5b33d7c30034067$var$_edge1.subVectors(b, a);
        $d5b33d7c30034067$var$_edge2.subVectors(c, a);
        $d5b33d7c30034067$var$_normal$1.crossVectors($d5b33d7c30034067$var$_edge1, $d5b33d7c30034067$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($d5b33d7c30034067$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $d5b33d7c30034067$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($d5b33d7c30034067$var$_edge2.crossVectors($d5b33d7c30034067$var$_diff, $d5b33d7c30034067$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($d5b33d7c30034067$var$_edge1.cross($d5b33d7c30034067$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $d5b33d7c30034067$var$_diff.dot($d5b33d7c30034067$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$2ae72fc923e5eb5 {
    constructor(){
        $d5b33d7c30034067$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $d5b33d7c30034067$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($d5b33d7c30034067$var$_zero, q, $d5b33d7c30034067$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $d5b33d7c30034067$var$_z.subVectors(eye, target);
        if ($d5b33d7c30034067$var$_z.lengthSq() === 0) // eye and target are in the same position
        $d5b33d7c30034067$var$_z.z = 1;
        $d5b33d7c30034067$var$_z.normalize();
        $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        if ($d5b33d7c30034067$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $d5b33d7c30034067$var$_z.x += 0.0001;
            else $d5b33d7c30034067$var$_z.z += 0.0001;
            $d5b33d7c30034067$var$_z.normalize();
            $d5b33d7c30034067$var$_x.crossVectors(up, $d5b33d7c30034067$var$_z);
        }
        $d5b33d7c30034067$var$_x.normalize();
        $d5b33d7c30034067$var$_y.crossVectors($d5b33d7c30034067$var$_z, $d5b33d7c30034067$var$_x);
        te[0] = $d5b33d7c30034067$var$_x.x;
        te[4] = $d5b33d7c30034067$var$_y.x;
        te[8] = $d5b33d7c30034067$var$_z.x;
        te[1] = $d5b33d7c30034067$var$_x.y;
        te[5] = $d5b33d7c30034067$var$_y.y;
        te[9] = $d5b33d7c30034067$var$_z.y;
        te[2] = $d5b33d7c30034067$var$_x.z;
        te[6] = $d5b33d7c30034067$var$_y.z;
        te[10] = $d5b33d7c30034067$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $d5b33d7c30034067$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $d5b33d7c30034067$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $d5b33d7c30034067$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $d5b33d7c30034067$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $d5b33d7c30034067$var$_m1$2.elements[0] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[1] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[2] *= invSX;
        $d5b33d7c30034067$var$_m1$2.elements[4] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[5] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[6] *= invSY;
        $d5b33d7c30034067$var$_m1$2.elements[8] *= invSZ;
        $d5b33d7c30034067$var$_m1$2.elements[9] *= invSZ;
        $d5b33d7c30034067$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $d5b33d7c30034067$var$_v1$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_m1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_zero = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0);
const $d5b33d7c30034067$var$_one = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
const $d5b33d7c30034067$var$_x = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_y = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_z = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_quaternion$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
class $d5b33d7c30034067$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $d5b33d7c30034067$export$d93cc409a0768c5f.DefaultOrder){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($d5b33d7c30034067$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$d5b33d7c30034067$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($d5b33d7c30034067$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$d5b33d7c30034067$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($d5b33d7c30034067$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$d5b33d7c30034067$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $d5b33d7c30034067$var$_matrix$1.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($d5b33d7c30034067$var$_matrix$1, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $d5b33d7c30034067$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($d5b33d7c30034067$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
    // @deprecated since r138, 02cf0df1cb4575d5842fef9c85bb5a89fe020d53
    toVector3() {
        console.error('THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead');
    }
}
$d5b33d7c30034067$export$d93cc409a0768c5f.DefaultOrder = 'XYZ';
$d5b33d7c30034067$export$d93cc409a0768c5f.RotationOrders = [
    'XYZ',
    'YZX',
    'ZXY',
    'XZY',
    'YXZ',
    'ZYX'
];
class $d5b33d7c30034067$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $d5b33d7c30034067$var$_object3DId = 0;
const $d5b33d7c30034067$var$_v1$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_q1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_m1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_target = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_position$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_scale$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_xAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0);
const $d5b33d7c30034067$var$_yAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
const $d5b33d7c30034067$var$_zAxis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1);
const $d5b33d7c30034067$var$_addedEvent = {
    type: 'added'
};
const $d5b33d7c30034067$var$_removedEvent = {
    type: 'removed'
};
class $d5b33d7c30034067$export$e4dd07dff30cc924 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_object3DId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $d5b33d7c30034067$export$e4dd07dff30cc924.DefaultUp.clone();
        const position = new $d5b33d7c30034067$export$64b5c384219d3699();
        const rotation = new $d5b33d7c30034067$export$d93cc409a0768c5f();
        const quaternion = new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
        const scale = new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $d5b33d7c30034067$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $d5b33d7c30034067$export$8ff26dafa08918()
            }
        });
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixWorld = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $d5b33d7c30034067$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate;
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $d5b33d7c30034067$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($d5b33d7c30034067$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($d5b33d7c30034067$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $d5b33d7c30034067$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($d5b33d7c30034067$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($d5b33d7c30034067$var$_zAxis, distance);
    }
    localToWorld(vector) {
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        return vector.applyMatrix4($d5b33d7c30034067$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $d5b33d7c30034067$var$_target.copy(x);
        else $d5b33d7c30034067$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $d5b33d7c30034067$var$_m1$1.lookAt($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_target, this.up);
        else $d5b33d7c30034067$var$_m1$1.lookAt($d5b33d7c30034067$var$_target, $d5b33d7c30034067$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($d5b33d7c30034067$var$_m1$1);
        if (parent) {
            $d5b33d7c30034067$var$_m1$1.extractRotation(parent.matrixWorld);
            $d5b33d7c30034067$var$_q1.setFromRotationMatrix($d5b33d7c30034067$var$_m1$1);
            this.quaternion.premultiply($d5b33d7c30034067$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($d5b33d7c30034067$var$_addedEvent);
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($d5b33d7c30034067$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($d5b33d7c30034067$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $d5b33d7c30034067$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $d5b33d7c30034067$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($d5b33d7c30034067$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, target, $d5b33d7c30034067$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$3, $d5b33d7c30034067$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(force);
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateWorldMatrix(false, true);
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.5,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (JSON.stringify(this.userData) !== '{}') object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$d5b33d7c30034067$export$e4dd07dff30cc924.DefaultUp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
$d5b33d7c30034067$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate = true;
const $d5b33d7c30034067$var$_v0$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vab = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vac = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbc = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vap = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vbp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vcp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$5a465592bfe74b48 {
    constructor(a = new $d5b33d7c30034067$export$64b5c384219d3699(), b = new $d5b33d7c30034067$export$64b5c384219d3699(), c = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $d5b33d7c30034067$var$_v0$1.subVectors(a, b);
        target.cross($d5b33d7c30034067$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $d5b33d7c30034067$var$_v0$1.subVectors(c, a);
        $d5b33d7c30034067$var$_v1$3.subVectors(b, a);
        $d5b33d7c30034067$var$_v2$2.subVectors(point, a);
        const dot00 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v0$1);
        const dot01 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v1$3);
        const dot02 = $d5b33d7c30034067$var$_v0$1.dot($d5b33d7c30034067$var$_v2$2);
        const dot11 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v1$3);
        const dot12 = $d5b33d7c30034067$var$_v1$3.dot($d5b33d7c30034067$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $d5b33d7c30034067$var$_v3$1);
        return $d5b33d7c30034067$var$_v3$1.x >= 0 && $d5b33d7c30034067$var$_v3$1.y >= 0 && $d5b33d7c30034067$var$_v3$1.x + $d5b33d7c30034067$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, $d5b33d7c30034067$var$_v3$1);
        target.set(0, 0);
        target.addScaledVector(uv1, $d5b33d7c30034067$var$_v3$1.x);
        target.addScaledVector(uv2, $d5b33d7c30034067$var$_v3$1.y);
        target.addScaledVector(uv3, $d5b33d7c30034067$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $d5b33d7c30034067$var$_v0$1.subVectors(c, b);
        $d5b33d7c30034067$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $d5b33d7c30034067$var$_v0$1.cross($d5b33d7c30034067$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $d5b33d7c30034067$var$_v0$1.subVectors(this.c, this.b);
        $d5b33d7c30034067$var$_v1$3.subVectors(this.a, this.b);
        return $d5b33d7c30034067$var$_v0$1.cross($d5b33d7c30034067$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $d5b33d7c30034067$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $d5b33d7c30034067$var$_vab.subVectors(b, a);
        $d5b33d7c30034067$var$_vac.subVectors(c, a);
        $d5b33d7c30034067$var$_vap.subVectors(p, a);
        const d1 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vap);
        const d2 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $d5b33d7c30034067$var$_vbp.subVectors(p, b);
        const d3 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vbp);
        const d4 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v);
        }
        $d5b33d7c30034067$var$_vcp.subVectors(p, c);
        const d5 = $d5b33d7c30034067$var$_vab.dot($d5b33d7c30034067$var$_vcp);
        const d6 = $d5b33d7c30034067$var$_vac.dot($d5b33d7c30034067$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $d5b33d7c30034067$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($d5b33d7c30034067$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($d5b33d7c30034067$var$_vab, v).addScaledVector($d5b33d7c30034067$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $d5b33d7c30034067$var$materialId = 0;
class $d5b33d7c30034067$export$a2d8b23205c25948 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$materialId++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'Material';
        this.blending = $d5b33d7c30034067$export$5b29a26d96ee6af0;
        this.side = $d5b33d7c30034067$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $d5b33d7c30034067$export$d5773124e86cf28c;
        this.blendDst = $d5b33d7c30034067$export$11d468cc7f19e971;
        this.blendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $d5b33d7c30034067$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $d5b33d7c30034067$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZFail = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilZPass = $d5b33d7c30034067$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn('THREE.Material: \'' + key + '\' parameter is undefined.');
                continue;
            }
            // for backward compatibility if shading is set in the constructor
            if (key === 'shading') {
                console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
                this.flatShading = newValue === $d5b33d7c30034067$export$a62047d29c96d8ff ? true : false;
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn('THREE.' + this.type + ': \'' + key + '\' is not a property of this material.');
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $d5b33d7c30034067$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $d5b33d7c30034067$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (JSON.stringify(this.userData) !== '{}') data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
class $d5b33d7c30034067$export$55cbcc9b622fe1f5 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_vector$9 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized === true;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    copyColorsArray(colors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = colors.length; i < l; i++){
            let color = colors[i];
            if (color === undefined) {
                console.warn('THREE.BufferAttribute.copyColorsArray(): color is undefined', i);
                color = new $d5b33d7c30034067$export$892596cec99bc70e();
            }
            array[offset++] = color.r;
            array[offset++] = color.g;
            array[offset++] = color.b;
        }
        return this;
    }
    copyVector2sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i);
                vector = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
        }
        return this;
    }
    copyVector3sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i);
                vector = new $d5b33d7c30034067$export$64b5c384219d3699();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
        }
        return this;
    }
    copyVector4sArray(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i);
                vector = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
            array[offset++] = vector.w;
        }
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector2$1.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $d5b33d7c30034067$var$_vector2$1.x, $d5b33d7c30034067$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$9.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$9.x, $d5b33d7c30034067$var$_vector$9.y, $d5b33d7c30034067$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        return this.array[index * this.itemSize];
    }
    setX(index, x) {
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        return this.array[index * this.itemSize + 1];
    }
    setY(index, y) {
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        return this.array[index * this.itemSize + 2];
    }
    setZ(index, z) {
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        return this.array[index * this.itemSize + 3];
    }
    setW(index, w) {
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $d5b33d7c30034067$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
}
//
class $d5b33d7c30034067$export$f9ff2d6a20248cbf extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$cacc90cf35d11cdd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$baaa85a1a812c157 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$2b755a102ccdcefe extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$640a853f68025f2e extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$46b369aed2968a0a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$dbd3698c64958d69 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
}
class $d5b33d7c30034067$export$cbe7a62641830ebd extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $d5b33d7c30034067$export$9e0ade74842adbb8 extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $d5b33d7c30034067$var$_id$1 = 0;
const $d5b33d7c30034067$var$_m1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_obj = /*@__PURE__*/ new $d5b33d7c30034067$export$e4dd07dff30cc924();
const $d5b33d7c30034067$var$_offset = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_box$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_boxMorphTargets = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
const $d5b33d7c30034067$var$_vector$8 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$b7be63a67df8959 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$_id$1++
        });
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($d5b33d7c30034067$var$arrayNeedsUint32(index) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $d5b33d7c30034067$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $d5b33d7c30034067$var$_m1.makeRotationX(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $d5b33d7c30034067$var$_m1.makeRotationY(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $d5b33d7c30034067$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $d5b33d7c30034067$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $d5b33d7c30034067$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($d5b33d7c30034067$var$_m1);
        return this;
    }
    lookAt(vector) {
        $d5b33d7c30034067$var$_obj.lookAt(vector);
        $d5b33d7c30034067$var$_obj.updateMatrix();
        this.applyMatrix4($d5b33d7c30034067$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($d5b33d7c30034067$var$_offset).negate();
        this.translate($d5b33d7c30034067$var$_offset.x, $d5b33d7c30034067$var$_offset.y, $d5b33d7c30034067$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $d5b33d7c30034067$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $d5b33d7c30034067$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$8.addVectors(this.boundingBox.min, $d5b33d7c30034067$var$_box$1.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$8);
                    $d5b33d7c30034067$var$_vector$8.addVectors(this.boundingBox.max, $d5b33d7c30034067$var$_box$1.max);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$1.min);
                    this.boundingBox.expandByPoint($d5b33d7c30034067$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $d5b33d7c30034067$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $d5b33d7c30034067$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $d5b33d7c30034067$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $d5b33d7c30034067$var$_vector$8.addVectors($d5b33d7c30034067$var$_box$1.min, $d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_vector$8);
                    $d5b33d7c30034067$var$_vector$8.addVectors($d5b33d7c30034067$var$_box$1.max, $d5b33d7c30034067$var$_boxMorphTargets.max);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_vector$8);
                } else {
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.min);
                    $d5b33d7c30034067$var$_box$1.expandByPoint($d5b33d7c30034067$var$_boxMorphTargets.max);
                }
            }
            $d5b33d7c30034067$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $d5b33d7c30034067$var$_offset.fromBufferAttribute(position, j);
                        $d5b33d7c30034067$var$_vector$8.add($d5b33d7c30034067$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($d5b33d7c30034067$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute('tangent').array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
            tan2[i] = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        const vA = new $d5b33d7c30034067$export$64b5c384219d3699(), vB = new $d5b33d7c30034067$export$64b5c384219d3699(), vC = new $d5b33d7c30034067$export$64b5c384219d3699(), uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1(), uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1(), sdir = new $d5b33d7c30034067$export$64b5c384219d3699(), tdir = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $d5b33d7c30034067$export$64b5c384219d3699(), tmp2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const n = new $d5b33d7c30034067$export$64b5c384219d3699(), n2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $d5b33d7c30034067$export$64b5c384219d3699(), pB = new $d5b33d7c30034067$export$64b5c384219d3699(), pC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const nA = new $d5b33d7c30034067$export$64b5c384219d3699(), nB = new $d5b33d7c30034067$export$64b5c384219d3699(), nC = new $d5b33d7c30034067$export$64b5c384219d3699();
            const cb = new $d5b33d7c30034067$export$64b5c384219d3699(), ab = new $d5b33d7c30034067$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    merge(geometry, offset) {
        if (!(geometry && geometry.isBufferGeometry)) {
            console.error('THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry);
            return;
        }
        if (offset === undefined) {
            offset = 0;
            console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.");
        }
        const attributes = this.attributes;
        for(const key in attributes){
            if (geometry.attributes[key] === undefined) continue;
            const attribute1 = attributes[key];
            const attributeArray1 = attribute1.array;
            const attribute2 = geometry.attributes[key];
            const attributeArray2 = attribute2.array;
            const attributeOffset = attribute2.itemSize * offset;
            const length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
            for(let i = 0, j = attributeOffset; i < length; i++, j++)attributeArray1[j] = attributeArray2[i];
        }
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $d5b33d7c30034067$var$_vector$8.fromBufferAttribute(normals, i);
            $d5b33d7c30034067$var$_vector$8.normalize();
            normals.setXYZ(i, $d5b33d7c30034067$var$_vector$8.x, $d5b33d7c30034067$var$_vector$8.y, $d5b33d7c30034067$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        // geometry generator parameters
        if (source.parameters !== undefined) this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $d5b33d7c30034067$var$_inverseMatrix$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_vA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_tempA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_tempB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_tempC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_morphA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_morphB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_morphC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_intersectionPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_intersectionPointWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e176487c05830cc5 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$3.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$3) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$2.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$2);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if ($d5b33d7c30034067$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        const uv = geometry.attributes.uv;
        const uv2 = geometry.attributes.uv2;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $d5b33d7c30034067$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $d5b33d7c30034067$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $d5b33d7c30034067$var$checkBufferGeometryIntersection(this, material, raycaster, $d5b33d7c30034067$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $d5b33d7c30034067$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $d5b33d7c30034067$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $d5b33d7c30034067$var$checkBufferGeometryIntersection(this, material, raycaster, $d5b33d7c30034067$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== $d5b33d7c30034067$export$3b296b6f144d5b03, point);
    if (intersect === null) return null;
    $d5b33d7c30034067$var$_intersectionPointWorld.copy(point);
    $d5b33d7c30034067$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $d5b33d7c30034067$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $d5b33d7c30034067$var$checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    $d5b33d7c30034067$var$_vA$1.fromBufferAttribute(position, a);
    $d5b33d7c30034067$var$_vB$1.fromBufferAttribute(position, b);
    $d5b33d7c30034067$var$_vC$1.fromBufferAttribute(position, c);
    const morphInfluences = object.morphTargetInfluences;
    if (morphPosition && morphInfluences) {
        $d5b33d7c30034067$var$_morphA.set(0, 0, 0);
        $d5b33d7c30034067$var$_morphB.set(0, 0, 0);
        $d5b33d7c30034067$var$_morphC.set(0, 0, 0);
        for(let i = 0, il = morphPosition.length; i < il; i++){
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            $d5b33d7c30034067$var$_tempA.fromBufferAttribute(morphAttribute, a);
            $d5b33d7c30034067$var$_tempB.fromBufferAttribute(morphAttribute, b);
            $d5b33d7c30034067$var$_tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA, influence);
                $d5b33d7c30034067$var$_morphB.addScaledVector($d5b33d7c30034067$var$_tempB, influence);
                $d5b33d7c30034067$var$_morphC.addScaledVector($d5b33d7c30034067$var$_tempC, influence);
            } else {
                $d5b33d7c30034067$var$_morphA.addScaledVector($d5b33d7c30034067$var$_tempA.sub($d5b33d7c30034067$var$_vA$1), influence);
                $d5b33d7c30034067$var$_morphB.addScaledVector($d5b33d7c30034067$var$_tempB.sub($d5b33d7c30034067$var$_vB$1), influence);
                $d5b33d7c30034067$var$_morphC.addScaledVector($d5b33d7c30034067$var$_tempC.sub($d5b33d7c30034067$var$_vC$1), influence);
            }
        }
        $d5b33d7c30034067$var$_vA$1.add($d5b33d7c30034067$var$_morphA);
        $d5b33d7c30034067$var$_vB$1.add($d5b33d7c30034067$var$_morphB);
        $d5b33d7c30034067$var$_vC$1.add($d5b33d7c30034067$var$_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, $d5b33d7c30034067$var$_vA$1);
        object.boneTransform(b, $d5b33d7c30034067$var$_vB$1);
        object.boneTransform(c, $d5b33d7c30034067$var$_vC$1);
    }
    const intersection = $d5b33d7c30034067$var$checkIntersection(object, material, raycaster, ray, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $d5b33d7c30034067$export$5a465592bfe74b48.getUV($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
        }
        if (uv2) {
            $d5b33d7c30034067$var$_uvA$1.fromBufferAttribute(uv2, a);
            $d5b33d7c30034067$var$_uvB$1.fromBufferAttribute(uv2, b);
            $d5b33d7c30034067$var$_uvC$1.fromBufferAttribute(uv2, c);
            intersection.uv2 = $d5b33d7c30034067$export$5a465592bfe74b48.getUV($d5b33d7c30034067$var$_intersectionPoint, $d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, $d5b33d7c30034067$var$_uvA$1, $d5b33d7c30034067$var$_uvB$1, $d5b33d7c30034067$var$_uvC$1, new $d5b33d7c30034067$export$c977b3e384af9ae1());
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $d5b33d7c30034067$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $d5b33d7c30034067$export$5a465592bfe74b48.getNormal($d5b33d7c30034067$var$_vA$1, $d5b33d7c30034067$var$_vB$1, $d5b33d7c30034067$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $d5b33d7c30034067$export$ab3456a079aa7d80 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $d5b33d7c30034067$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$ab3456a079aa7d80(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $d5b33d7c30034067$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $d5b33d7c30034067$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $d5b33d7c30034067$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $d5b33d7c30034067$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
// Legacy
const $d5b33d7c30034067$export$d8ecdf8615bfea69 = {
    clone: $d5b33d7c30034067$var$cloneUniforms,
    merge: $d5b33d7c30034067$var$mergeUniforms
};
var $d5b33d7c30034067$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $d5b33d7c30034067$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $d5b33d7c30034067$export$83c7d75d550a8b0d extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $d5b33d7c30034067$var$default_vertex;
        this.fragmentShader = $d5b33d7c30034067$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv2': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) {
            if (parameters.attributes !== undefined) console.error('THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.');
            this.setValues(parameters);
        }
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $d5b33d7c30034067$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $d5b33d7c30034067$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $d5b33d7c30034067$export$79f141de891a5fed extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = 'Camera';
        this.matrixWorldInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$74e4ae24825f68d7 extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $d5b33d7c30034067$var$RAD2DEG * 2 * Math.atan(Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($d5b33d7c30034067$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $d5b33d7c30034067$var$fov = 90, $d5b33d7c30034067$var$aspect = 1;
class $d5b33d7c30034067$export$d0cdd0bd804995de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        if (renderTarget.isWebGLCubeRenderTarget !== true) {
            console.error('THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.');
            return;
        }
        this.renderTarget = renderTarget;
        const cameraPX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPX.layers = this.layers;
        cameraPX.up.set(0, -1, 0);
        cameraPX.lookAt(new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0));
        this.add(cameraPX);
        const cameraNX = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNX.layers = this.layers;
        cameraNX.up.set(0, -1, 0);
        cameraNX.lookAt(new $d5b33d7c30034067$export$64b5c384219d3699(-1, 0, 0));
        this.add(cameraNX);
        const cameraPY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPY.layers = this.layers;
        cameraPY.up.set(0, 0, 1);
        cameraPY.lookAt(new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0));
        this.add(cameraPY);
        const cameraNY = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNY.layers = this.layers;
        cameraNY.up.set(0, 0, -1);
        cameraNY.lookAt(new $d5b33d7c30034067$export$64b5c384219d3699(0, -1, 0));
        this.add(cameraNY);
        const cameraPZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        cameraPZ.up.set(0, -1, 0);
        cameraPZ.lookAt(new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1));
        this.add(cameraPZ);
        const cameraNZ = new $d5b33d7c30034067$export$74e4ae24825f68d7($d5b33d7c30034067$var$fov, $d5b33d7c30034067$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        cameraNZ.up.set(0, -1, 0);
        cameraNZ.lookAt(new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1));
        this.add(cameraNZ);
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentToneMapping = renderer.toneMapping;
        const currentXrEnabled = renderer.xr.enabled;
        renderer.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.toneMapping = currentToneMapping;
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $d5b33d7c30034067$export$ee2e5a18258a4049 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $d5b33d7c30034067$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $d5b33d7c30034067$export$ac386671d651941e extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(size, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $d5b33d7c30034067$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.encoding = texture.encoding;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $d5b33d7c30034067$export$ab3456a079aa7d80(5, 5, 5);
        const material = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $d5b33d7c30034067$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            blending: $d5b33d7c30034067$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $d5b33d7c30034067$export$5d8599b6a933fb1b) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
        const camera = new $d5b33d7c30034067$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $d5b33d7c30034067$var$_vector1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vector2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918();
class $d5b33d7c30034067$export$7ff5ac152ef991b0 {
    constructor(normal = new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $d5b33d7c30034067$var$_vector1.subVectors(c, b).cross($d5b33d7c30034067$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        const direction = line.delta($d5b33d7c30034067$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $d5b33d7c30034067$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($d5b33d7c30034067$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_sphere$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_vector$7 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$35efe6f4c85463d2 {
    constructor(p0 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p1 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p2 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p3 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p4 = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), p5 = new $d5b33d7c30034067$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$2);
    }
    intersectsSprite(sprite) {
        $d5b33d7c30034067$var$_sphere$2.center.set(0, 0, 0);
        $d5b33d7c30034067$var$_sphere$2.radius = 0.7071067811865476;
        $d5b33d7c30034067$var$_sphere$2.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($d5b33d7c30034067$var$_sphere$2);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $d5b33d7c30034067$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $d5b33d7c30034067$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $d5b33d7c30034067$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($d5b33d7c30034067$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $d5b33d7c30034067$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $d5b33d7c30034067$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else throw new Error('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        else if (array instanceof Uint8ClampedArray) type = 5121;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $d5b33d7c30034067$export$e789a11a194ca4e0 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$e789a11a194ca4e0(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $d5b33d7c30034067$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var $d5b33d7c30034067$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $d5b33d7c30034067$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $d5b33d7c30034067$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $d5b33d7c30034067$var$begin_vertex = "vec3 transformed = vec3( position );";
var $d5b33d7c30034067$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $d5b33d7c30034067$var$bsdfs = "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\n#ifdef USE_IRIDESCENCE\n\tvec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = mix( F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif";
var $d5b33d7c30034067$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\t return vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat R21 = R12;\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $d5b33d7c30034067$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos.xyz );\n\t\tvec3 vSigmaY = dFdy( surf_pos.xyz );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $d5b33d7c30034067$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $d5b33d7c30034067$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $d5b33d7c30034067$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $d5b33d7c30034067$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $d5b33d7c30034067$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var $d5b33d7c30034067$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}";
var $d5b33d7c30034067$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $d5b33d7c30034067$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $d5b33d7c30034067$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var $d5b33d7c30034067$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $d5b33d7c30034067$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $d5b33d7c30034067$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $d5b33d7c30034067$var$encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $d5b33d7c30034067$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $d5b33d7c30034067$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $d5b33d7c30034067$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $d5b33d7c30034067$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $d5b33d7c30034067$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}";
var $d5b33d7c30034067$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $d5b33d7c30034067$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $d5b33d7c30034067$var$lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointLightInfo( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotLightInfo( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $d5b33d7c30034067$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#else\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $d5b33d7c30034067$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $d5b33d7c30034067$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)";
var $d5b33d7c30034067$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $d5b33d7c30034067$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)";
var $d5b33d7c30034067$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\t#ifdef SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULARINTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n\t\t#endif\n\t\t#ifdef USE_SPECULARCOLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\treflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );\n\t#else\n\t\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $d5b33d7c30034067$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometry.viewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $d5b33d7c30034067$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var $d5b33d7c30034067$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $d5b33d7c30034067$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $d5b33d7c30034067$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $d5b33d7c30034067$var$map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $d5b33d7c30034067$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $d5b33d7c30034067$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";
var $d5b33d7c30034067$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
var $d5b33d7c30034067$var$normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $d5b33d7c30034067$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
var $d5b33d7c30034067$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif";
var $d5b33d7c30034067$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif";
var $d5b33d7c30034067$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $d5b33d7c30034067$var$output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $d5b33d7c30034067$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var $d5b33d7c30034067$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $d5b33d7c30034067$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $d5b33d7c30034067$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $d5b33d7c30034067$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $d5b33d7c30034067$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var $d5b33d7c30034067$var$shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $d5b33d7c30034067$var$shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif";
var $d5b33d7c30034067$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $d5b33d7c30034067$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $d5b33d7c30034067$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif";
var $d5b33d7c30034067$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $d5b33d7c30034067$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $d5b33d7c30034067$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $d5b33d7c30034067$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $d5b33d7c30034067$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $d5b33d7c30034067$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $d5b33d7c30034067$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tfloat transmissionAlpha = 1.0;\n\tfloat transmissionFactor = transmission;\n\tfloat thicknessFactor = thickness;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttransmissionFactor *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationColor, attenuationDistance );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n\ttransmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );\n#endif";
var $d5b33d7c30034067$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\t#ifdef texture2DLodEXT\n\t\t\treturn texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#else\n\t\t\treturn texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#endif\n\t}\n\tvec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( attenuationDistance == 0.0 ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif";
var $d5b33d7c30034067$var$uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif";
var $d5b33d7c30034067$var$uv_pars_vertex = "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif";
var $d5b33d7c30034067$var$uv_vertex = "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var $d5b33d7c30034067$var$uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
var $d5b33d7c30034067$var$uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif";
var $d5b33d7c30034067$var$uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var $d5b33d7c30034067$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $d5b33d7c30034067$var$vertex$g = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment$g = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tgl_FragColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tgl_FragColor = vec4( mix( pow( gl_FragColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), gl_FragColor.rgb * 0.0773993808, vec3( lessThanEqual( gl_FragColor.rgb, vec3( 0.04045 ) ) ) ), gl_FragColor.w );\n\t#endif\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
const $d5b33d7c30034067$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $d5b33d7c30034067$var$fragment$f = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
const $d5b33d7c30034067$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $d5b33d7c30034067$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $d5b33d7c30034067$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $d5b33d7c30034067$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
const $d5b33d7c30034067$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$9 = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$9 = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $d5b33d7c30034067$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $d5b33d7c30034067$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $d5b33d7c30034067$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARCOLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $d5b33d7c30034067$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $d5b33d7c30034067$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $d5b33d7c30034067$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
const $d5b33d7c30034067$export$955f9f2e84c43c8b = {
    alphamap_fragment: $d5b33d7c30034067$var$alphamap_fragment,
    alphamap_pars_fragment: $d5b33d7c30034067$var$alphamap_pars_fragment,
    alphatest_fragment: $d5b33d7c30034067$var$alphatest_fragment,
    alphatest_pars_fragment: $d5b33d7c30034067$var$alphatest_pars_fragment,
    aomap_fragment: $d5b33d7c30034067$var$aomap_fragment,
    aomap_pars_fragment: $d5b33d7c30034067$var$aomap_pars_fragment,
    begin_vertex: $d5b33d7c30034067$var$begin_vertex,
    beginnormal_vertex: $d5b33d7c30034067$var$beginnormal_vertex,
    bsdfs: $d5b33d7c30034067$var$bsdfs,
    iridescence_fragment: $d5b33d7c30034067$var$iridescence_fragment,
    bumpmap_pars_fragment: $d5b33d7c30034067$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $d5b33d7c30034067$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $d5b33d7c30034067$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $d5b33d7c30034067$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $d5b33d7c30034067$var$clipping_planes_vertex,
    color_fragment: $d5b33d7c30034067$var$color_fragment,
    color_pars_fragment: $d5b33d7c30034067$var$color_pars_fragment,
    color_pars_vertex: $d5b33d7c30034067$var$color_pars_vertex,
    color_vertex: $d5b33d7c30034067$var$color_vertex,
    common: $d5b33d7c30034067$var$common,
    cube_uv_reflection_fragment: $d5b33d7c30034067$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $d5b33d7c30034067$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $d5b33d7c30034067$var$displacementmap_pars_vertex,
    displacementmap_vertex: $d5b33d7c30034067$var$displacementmap_vertex,
    emissivemap_fragment: $d5b33d7c30034067$var$emissivemap_fragment,
    emissivemap_pars_fragment: $d5b33d7c30034067$var$emissivemap_pars_fragment,
    encodings_fragment: $d5b33d7c30034067$var$encodings_fragment,
    encodings_pars_fragment: $d5b33d7c30034067$var$encodings_pars_fragment,
    envmap_fragment: $d5b33d7c30034067$var$envmap_fragment,
    envmap_common_pars_fragment: $d5b33d7c30034067$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $d5b33d7c30034067$var$envmap_pars_fragment,
    envmap_pars_vertex: $d5b33d7c30034067$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $d5b33d7c30034067$var$envmap_physical_pars_fragment,
    envmap_vertex: $d5b33d7c30034067$var$envmap_vertex,
    fog_vertex: $d5b33d7c30034067$var$fog_vertex,
    fog_pars_vertex: $d5b33d7c30034067$var$fog_pars_vertex,
    fog_fragment: $d5b33d7c30034067$var$fog_fragment,
    fog_pars_fragment: $d5b33d7c30034067$var$fog_pars_fragment,
    gradientmap_pars_fragment: $d5b33d7c30034067$var$gradientmap_pars_fragment,
    lightmap_fragment: $d5b33d7c30034067$var$lightmap_fragment,
    lightmap_pars_fragment: $d5b33d7c30034067$var$lightmap_pars_fragment,
    lights_lambert_vertex: $d5b33d7c30034067$var$lights_lambert_vertex,
    lights_pars_begin: $d5b33d7c30034067$var$lights_pars_begin,
    lights_toon_fragment: $d5b33d7c30034067$var$lights_toon_fragment,
    lights_toon_pars_fragment: $d5b33d7c30034067$var$lights_toon_pars_fragment,
    lights_phong_fragment: $d5b33d7c30034067$var$lights_phong_fragment,
    lights_phong_pars_fragment: $d5b33d7c30034067$var$lights_phong_pars_fragment,
    lights_physical_fragment: $d5b33d7c30034067$var$lights_physical_fragment,
    lights_physical_pars_fragment: $d5b33d7c30034067$var$lights_physical_pars_fragment,
    lights_fragment_begin: $d5b33d7c30034067$var$lights_fragment_begin,
    lights_fragment_maps: $d5b33d7c30034067$var$lights_fragment_maps,
    lights_fragment_end: $d5b33d7c30034067$var$lights_fragment_end,
    logdepthbuf_fragment: $d5b33d7c30034067$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $d5b33d7c30034067$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $d5b33d7c30034067$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $d5b33d7c30034067$var$logdepthbuf_vertex,
    map_fragment: $d5b33d7c30034067$var$map_fragment,
    map_pars_fragment: $d5b33d7c30034067$var$map_pars_fragment,
    map_particle_fragment: $d5b33d7c30034067$var$map_particle_fragment,
    map_particle_pars_fragment: $d5b33d7c30034067$var$map_particle_pars_fragment,
    metalnessmap_fragment: $d5b33d7c30034067$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $d5b33d7c30034067$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $d5b33d7c30034067$var$morphcolor_vertex,
    morphnormal_vertex: $d5b33d7c30034067$var$morphnormal_vertex,
    morphtarget_pars_vertex: $d5b33d7c30034067$var$morphtarget_pars_vertex,
    morphtarget_vertex: $d5b33d7c30034067$var$morphtarget_vertex,
    normal_fragment_begin: $d5b33d7c30034067$var$normal_fragment_begin,
    normal_fragment_maps: $d5b33d7c30034067$var$normal_fragment_maps,
    normal_pars_fragment: $d5b33d7c30034067$var$normal_pars_fragment,
    normal_pars_vertex: $d5b33d7c30034067$var$normal_pars_vertex,
    normal_vertex: $d5b33d7c30034067$var$normal_vertex,
    normalmap_pars_fragment: $d5b33d7c30034067$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $d5b33d7c30034067$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $d5b33d7c30034067$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $d5b33d7c30034067$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $d5b33d7c30034067$var$iridescence_pars_fragment,
    output_fragment: $d5b33d7c30034067$var$output_fragment,
    packing: $d5b33d7c30034067$var$packing,
    premultiplied_alpha_fragment: $d5b33d7c30034067$var$premultiplied_alpha_fragment,
    project_vertex: $d5b33d7c30034067$var$project_vertex,
    dithering_fragment: $d5b33d7c30034067$var$dithering_fragment,
    dithering_pars_fragment: $d5b33d7c30034067$var$dithering_pars_fragment,
    roughnessmap_fragment: $d5b33d7c30034067$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $d5b33d7c30034067$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $d5b33d7c30034067$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $d5b33d7c30034067$var$shadowmap_pars_vertex,
    shadowmap_vertex: $d5b33d7c30034067$var$shadowmap_vertex,
    shadowmask_pars_fragment: $d5b33d7c30034067$var$shadowmask_pars_fragment,
    skinbase_vertex: $d5b33d7c30034067$var$skinbase_vertex,
    skinning_pars_vertex: $d5b33d7c30034067$var$skinning_pars_vertex,
    skinning_vertex: $d5b33d7c30034067$var$skinning_vertex,
    skinnormal_vertex: $d5b33d7c30034067$var$skinnormal_vertex,
    specularmap_fragment: $d5b33d7c30034067$var$specularmap_fragment,
    specularmap_pars_fragment: $d5b33d7c30034067$var$specularmap_pars_fragment,
    tonemapping_fragment: $d5b33d7c30034067$var$tonemapping_fragment,
    tonemapping_pars_fragment: $d5b33d7c30034067$var$tonemapping_pars_fragment,
    transmission_fragment: $d5b33d7c30034067$var$transmission_fragment,
    transmission_pars_fragment: $d5b33d7c30034067$var$transmission_pars_fragment,
    uv_pars_fragment: $d5b33d7c30034067$var$uv_pars_fragment,
    uv_pars_vertex: $d5b33d7c30034067$var$uv_pars_vertex,
    uv_vertex: $d5b33d7c30034067$var$uv_vertex,
    uv2_pars_fragment: $d5b33d7c30034067$var$uv2_pars_fragment,
    uv2_pars_vertex: $d5b33d7c30034067$var$uv2_pars_vertex,
    uv2_vertex: $d5b33d7c30034067$var$uv2_vertex,
    worldpos_vertex: $d5b33d7c30034067$var$worldpos_vertex,
    background_vert: $d5b33d7c30034067$var$vertex$g,
    background_frag: $d5b33d7c30034067$var$fragment$g,
    cube_vert: $d5b33d7c30034067$var$vertex$f,
    cube_frag: $d5b33d7c30034067$var$fragment$f,
    depth_vert: $d5b33d7c30034067$var$vertex$e,
    depth_frag: $d5b33d7c30034067$var$fragment$e,
    distanceRGBA_vert: $d5b33d7c30034067$var$vertex$d,
    distanceRGBA_frag: $d5b33d7c30034067$var$fragment$d,
    equirect_vert: $d5b33d7c30034067$var$vertex$c,
    equirect_frag: $d5b33d7c30034067$var$fragment$c,
    linedashed_vert: $d5b33d7c30034067$var$vertex$b,
    linedashed_frag: $d5b33d7c30034067$var$fragment$b,
    meshbasic_vert: $d5b33d7c30034067$var$vertex$a,
    meshbasic_frag: $d5b33d7c30034067$var$fragment$a,
    meshlambert_vert: $d5b33d7c30034067$var$vertex$9,
    meshlambert_frag: $d5b33d7c30034067$var$fragment$9,
    meshmatcap_vert: $d5b33d7c30034067$var$vertex$8,
    meshmatcap_frag: $d5b33d7c30034067$var$fragment$8,
    meshnormal_vert: $d5b33d7c30034067$var$vertex$7,
    meshnormal_frag: $d5b33d7c30034067$var$fragment$7,
    meshphong_vert: $d5b33d7c30034067$var$vertex$6,
    meshphong_frag: $d5b33d7c30034067$var$fragment$6,
    meshphysical_vert: $d5b33d7c30034067$var$vertex$5,
    meshphysical_frag: $d5b33d7c30034067$var$fragment$5,
    meshtoon_vert: $d5b33d7c30034067$var$vertex$4,
    meshtoon_frag: $d5b33d7c30034067$var$fragment$4,
    points_vert: $d5b33d7c30034067$var$vertex$3,
    points_frag: $d5b33d7c30034067$var$fragment$3,
    shadow_vert: $d5b33d7c30034067$var$vertex$2,
    shadow_frag: $d5b33d7c30034067$var$fragment$2,
    sprite_vert: $d5b33d7c30034067$var$vertex$1,
    sprite_frag: $d5b33d7c30034067$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $d5b33d7c30034067$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        uv2Transform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        } // basic, lambert, phong
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
        }
    }
};
const $d5b33d7c30034067$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.specularmap,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.roughnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.metalnessmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.aomap,
            $d5b33d7c30034067$export$6643083551874bf5.lightmap,
            $d5b33d7c30034067$export$6643083551874bf5.emissivemap,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.gradientmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.points,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.bumpmap,
            $d5b33d7c30034067$export$6643083551874bf5.normalmap,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.sprite,
            $d5b33d7c30034067$export$6643083551874bf5.fog
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.background_frag
    },
    cube: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.common,
            $d5b33d7c30034067$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
            $d5b33d7c30034067$export$6643083551874bf5.lights,
            $d5b33d7c30034067$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.shadow_frag
    }
};
$d5b33d7c30034067$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $d5b33d7c30034067$var$mergeUniforms([
        $d5b33d7c30034067$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(0x000000)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $d5b33d7c30034067$export$955f9f2e84c43c8b.meshphysical_frag
};
function $d5b33d7c30034067$var$WebGLBackground(renderer, cubemaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === 'additive') background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$ab3456a079aa7d80(1, 1, 1), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: 'BackgroundCubeMaterial',
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.cube.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.cube.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.cube.fragmentShader,
                    side: $d5b33d7c30034067$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // enable code injection for non-built-in material
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$e789a11a194ca4e0(2, 2), new $d5b33d7c30034067$export$83c7d75d550a8b0d({
                    name: 'BackgroundMaterial',
                    uniforms: $d5b33d7c30034067$var$cloneUniforms($d5b33d7c30034067$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $d5b33d7c30034067$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $d5b33d7c30034067$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // enable code injection for non-built-in material
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $d5b33d7c30034067$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
            extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get('ANGLE_instanced_arrays') === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $d5b33d7c30034067$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawArraysInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawArraysInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $d5b33d7c30034067$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== 'undefined' && gl instanceof WebGL2ComputeRenderingContext;
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $d5b33d7c30034067$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $d5b33d7c30034067$export$7ff5ac152ef991b0(), viewNormalMatrix = new $d5b33d7c30034067$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $d5b33d7c30034067$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $d5b33d7c30034067$export$d64030b316d3b087) texture.mapping = $d5b33d7c30034067$export$8759762a6477f2c4;
        else if (mapping === $d5b33d7c30034067$export$ee99d97d46898098) texture.mapping = $d5b33d7c30034067$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $d5b33d7c30034067$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$9ebf355ee4ed261b extends $d5b33d7c30034067$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $d5b33d7c30034067$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $d5b33d7c30034067$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $d5b33d7c30034067$var$MAX_SAMPLES = 20;
const $d5b33d7c30034067$var$_flatCamera = /*@__PURE__*/ new $d5b33d7c30034067$export$9ebf355ee4ed261b();
const $d5b33d7c30034067$var$_clearColor = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
let $d5b33d7c30034067$var$_oldTarget = null;
// Golden Ratio
const $d5b33d7c30034067$var$PHI = (1 + Math.sqrt(5)) / 2;
const $d5b33d7c30034067$var$INV_PHI = 1 / $d5b33d7c30034067$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $d5b33d7c30034067$var$_axisDirections = [
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(0, $d5b33d7c30034067$var$PHI, -$d5b33d7c30034067$var$INV_PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$INV_PHI, 0, $d5b33d7c30034067$var$PHI),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699($d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0),
    /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699(-$d5b33d7c30034067$var$PHI, $d5b33d7c30034067$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $d5b33d7c30034067$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($d5b33d7c30034067$var$_oldTarget);
        outputTarget.scissorTest = false;
        $d5b33d7c30034067$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $d5b33d7c30034067$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            minFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $d5b33d7c30034067$export$2697304443f382bc,
            format: $d5b33d7c30034067$export$3f8bb04b555a363c,
            encoding: $d5b33d7c30034067$export$7207336e4151a112,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $d5b33d7c30034067$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $d5b33d7c30034067$var$_createPlanes(_lodMax));
            this._blurMaterial = $d5b33d7c30034067$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $d5b33d7c30034067$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($d5b33d7c30034067$var$_clearColor);
        renderer.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            name: 'PMREM.Background',
            side: $d5b33d7c30034067$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $d5b33d7c30034067$export$e176487c05830cc5(new $d5b33d7c30034067$export$ab3456a079aa7d80(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($d5b33d7c30034067$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || texture.mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $d5b33d7c30034067$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $d5b33d7c30034067$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $d5b33d7c30034067$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $d5b33d7c30034067$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $d5b33d7c30034067$var$_axisDirections[(i - 1) % $d5b33d7c30034067$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $d5b33d7c30034067$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $d5b33d7c30034067$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $d5b33d7c30034067$var$MAX_SAMPLES;
        if (samples > $d5b33d7c30034067$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$d5b33d7c30034067$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $d5b33d7c30034067$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $d5b33d7c30034067$var$LOD_MIN ? lodOut - _lodMax + $d5b33d7c30034067$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $d5b33d7c30034067$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $d5b33d7c30034067$var$_flatCamera);
    }
}
function $d5b33d7c30034067$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $d5b33d7c30034067$var$LOD_MIN + 1 + $d5b33d7c30034067$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $d5b33d7c30034067$var$LOD_MIN) sigma = $d5b33d7c30034067$var$EXTRA_LOD_SIGMA[i - lodMax + $d5b33d7c30034067$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $d5b33d7c30034067$export$b7be63a67df8959();
        planes.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute('uv', new $d5b33d7c30034067$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute('faceIndex', new $d5b33d7c30034067$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $d5b33d7c30034067$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $d5b33d7c30034067$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $d5b33d7c30034067$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $d5b33d7c30034067$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $d5b33d7c30034067$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($d5b33d7c30034067$var$MAX_SAMPLES);
    const poleAxis = new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $d5b33d7c30034067$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $d5b33d7c30034067$var$_getEquirectMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCubemapMaterial() {
    return new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $d5b33d7c30034067$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $d5b33d7c30034067$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $d5b33d7c30034067$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $d5b33d7c30034067$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $d5b33d7c30034067$export$d64030b316d3b087 || mapping === $d5b33d7c30034067$export$ee99d97d46898098;
            const isCubeMap = mapping === $d5b33d7c30034067$export$8759762a6477f2c4 || mapping === $d5b33d7c30034067$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $d5b33d7c30034067$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension('EXT_color_buffer_float');
            else {
                getExtension('WEBGL_depth_texture');
                getExtension('OES_texture_float');
                getExtension('OES_texture_half_float');
                getExtension('OES_texture_half_float_linear');
                getExtension('OES_standard_derivatives');
                getExtension('OES_element_index_uint');
                getExtension('OES_vertex_array_object');
                getExtension('ANGLE_instanced_arrays');
            }
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $d5b33d7c30034067$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($d5b33d7c30034067$var$arrayNeedsUint32(indices) ? $d5b33d7c30034067$export$7eb8c9fa25cd5bd6 : $d5b33d7c30034067$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawElementsInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawElementsInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $d5b33d7c30034067$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $d5b33d7c30034067$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $d5b33d7c30034067$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $d5b33d7c30034067$var$denormalize(morph, attribute) {
    let denominator = 1;
    const array = attribute.isInterleavedBufferAttribute ? attribute.data.array : attribute.array;
    if (array instanceof Int8Array) denominator = 127;
    else if (array instanceof Uint8Array) denominator = 255;
    else if (array instanceof Uint16Array) denominator = 65535;
    else if (array instanceof Int16Array) denominator = 32767;
    else if (array instanceof Int32Array) denominator = 2147483647;
    else console.error('THREE.WebGLMorphtargets: Unsupported morph attribute data type: ', array);
    morph.divideScalar(denominator);
}
function $d5b33d7c30034067$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $d5b33d7c30034067$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $d5b33d7c30034067$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            if (morphTarget.normalized === true) $d5b33d7c30034067$var$denormalize(morph, morphTarget);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            if (morphNormal.normalized === true) $d5b33d7c30034067$var$denormalize(morph, morphNormal);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            if (morphColor.normalized === true) $d5b33d7c30034067$var$denormalize(morph, morphColor);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $d5b33d7c30034067$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener('dispose', disposeTexture);
                }
                geometry.addEventListener('dispose', disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
            program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
            program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($d5b33d7c30034067$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($d5b33d7c30034067$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute('morphTarget' + i) !== morphTargets[index]) geometry.setAttribute('morphTarget' + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute('morphNormal' + i) !== morphNormals[index]) geometry.setAttribute('morphNormal' + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute('morphTarget' + i) === true) geometry.deleteAttribute('morphTarget' + i);
                    if (morphNormals && geometry.hasAttribute('morphNormal' + i) === true) geometry.deleteAttribute('morphNormal' + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $d5b33d7c30034067$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $d5b33d7c30034067$var$emptyTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$5431306cf43de24a();
const $d5b33d7c30034067$var$emptyArrayTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$dfac6c8e811406a3();
const $d5b33d7c30034067$var$empty3dTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$d7a3086320f856db();
const $d5b33d7c30034067$var$emptyCubeTexture = /*@__PURE__*/ new $d5b33d7c30034067$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $d5b33d7c30034067$var$arrayCacheF32 = [];
const $d5b33d7c30034067$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $d5b33d7c30034067$var$mat4array = new Float32Array(16);
const $d5b33d7c30034067$var$mat3array = new Float32Array(9);
const $d5b33d7c30034067$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $d5b33d7c30034067$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $d5b33d7c30034067$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $d5b33d7c30034067$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $d5b33d7c30034067$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d5b33d7c30034067$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $d5b33d7c30034067$var$allocTexUnits(textures, n) {
    let r = $d5b33d7c30034067$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $d5b33d7c30034067$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $d5b33d7c30034067$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
function $d5b33d7c30034067$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $d5b33d7c30034067$var$mat2array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $d5b33d7c30034067$var$mat3array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
function $d5b33d7c30034067$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $d5b33d7c30034067$var$copyArray(cache, v);
    } else {
        if ($d5b33d7c30034067$var$arraysEqual(cache, elements)) return;
        $d5b33d7c30034067$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $d5b33d7c30034067$var$mat4array);
        $d5b33d7c30034067$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $d5b33d7c30034067$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array)
function $d5b33d7c30034067$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    $d5b33d7c30034067$var$copyArray(cache, v);
}
function $d5b33d7c30034067$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    $d5b33d7c30034067$var$copyArray(cache, v);
}
function $d5b33d7c30034067$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    $d5b33d7c30034067$var$copyArray(cache, v);
}
// Single unsigned integer
function $d5b33d7c30034067$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array)
function $d5b33d7c30034067$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    $d5b33d7c30034067$var$copyArray(cache, v);
}
function $d5b33d7c30034067$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    $d5b33d7c30034067$var$copyArray(cache, v);
}
function $d5b33d7c30034067$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if ($d5b33d7c30034067$var$arraysEqual(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    $d5b33d7c30034067$var$copyArray(cache, v);
}
// Single texture (2D / Cube)
function $d5b33d7c30034067$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $d5b33d7c30034067$var$emptyTexture, unit);
}
function $d5b33d7c30034067$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $d5b33d7c30034067$var$empty3dTexture, unit);
}
function $d5b33d7c30034067$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $d5b33d7c30034067$var$emptyCubeTexture, unit);
}
function $d5b33d7c30034067$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $d5b33d7c30034067$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $d5b33d7c30034067$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4i; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArray1;
    }
}
// Array of scalars
function $d5b33d7c30034067$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $d5b33d7c30034067$var$setValueV2fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV3fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $d5b33d7c30034067$var$setValueV4fArray(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $d5b33d7c30034067$var$setValueM2Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM3Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $d5b33d7c30034067$var$setValueM4Array(gl, v) {
    const data = $d5b33d7c30034067$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $d5b33d7c30034067$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $d5b33d7c30034067$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $d5b33d7c30034067$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $d5b33d7c30034067$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $d5b33d7c30034067$var$setValueT1Array(gl, v, textures) {
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $d5b33d7c30034067$var$emptyTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT3DArray(gl, v, textures) {
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $d5b33d7c30034067$var$empty3dTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT6Array(gl, v, textures) {
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $d5b33d7c30034067$var$emptyCubeTexture, units[i]);
}
function $d5b33d7c30034067$var$setValueT2DArrayArray(gl, v, textures) {
    const n = v.length;
    const units = $d5b33d7c30034067$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $d5b33d7c30034067$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $d5b33d7c30034067$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $d5b33d7c30034067$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $d5b33d7c30034067$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $d5b33d7c30034067$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $d5b33d7c30034067$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $d5b33d7c30034067$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $d5b33d7c30034067$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $d5b33d7c30034067$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $d5b33d7c30034067$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $d5b33d7c30034067$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $d5b33d7c30034067$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $d5b33d7c30034067$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $d5b33d7c30034067$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $d5b33d7c30034067$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $d5b33d7c30034067$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $d5b33d7c30034067$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $d5b33d7c30034067$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $d5b33d7c30034067$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $d5b33d7c30034067$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $d5b33d7c30034067$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $d5b33d7c30034067$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $d5b33d7c30034067$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $d5b33d7c30034067$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $d5b33d7c30034067$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $d5b33d7c30034067$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $d5b33d7c30034067$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $d5b33d7c30034067$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $d5b33d7c30034067$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $d5b33d7c30034067$var$RePathPart.exec(path), matchEnd = $d5b33d7c30034067$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $d5b33d7c30034067$var$addUniform(container, subscript === undefined ? new $d5b33d7c30034067$var$SingleUniform(id, activeInfo, addr) : new $d5b33d7c30034067$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $d5b33d7c30034067$var$StructuredUniform(id);
                $d5b33d7c30034067$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $d5b33d7c30034067$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, 35718);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $d5b33d7c30034067$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $d5b33d7c30034067$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $d5b33d7c30034067$var$programIdCount = 0;
function $d5b33d7c30034067$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
function $d5b33d7c30034067$var$getEncodingComponents(encoding) {
    switch(encoding){
        case $d5b33d7c30034067$export$7207336e4151a112:
            return [
                'Linear',
                '( value )'
            ];
        case $d5b33d7c30034067$export$f32388edbb32674:
            return [
                'sRGB',
                '( value )'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported encoding:', encoding);
            return [
                'Linear',
                '( value )'
            ];
    }
}
function $d5b33d7c30034067$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $d5b33d7c30034067$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $d5b33d7c30034067$var$getTexelEncodingFunction(functionName, encoding) {
    const components = $d5b33d7c30034067$var$getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
}
function $d5b33d7c30034067$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $d5b33d7c30034067$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case $d5b33d7c30034067$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case $d5b33d7c30034067$export$932b3dd283d4a366:
            toneMappingName = 'OptimizedCineon';
            break;
        case $d5b33d7c30034067$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case $d5b33d7c30034067$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
function $d5b33d7c30034067$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '',
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '',
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '',
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''
    ];
    return chunks.filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
}
function $d5b33d7c30034067$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $d5b33d7c30034067$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === 35674) locationSize = 2;
        if (info.type === 35675) locationSize = 3;
        if (info.type === 35676) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $d5b33d7c30034067$var$filterEmptyLine(string) {
    return string !== '';
}
function $d5b33d7c30034067$var$replaceLightNums(string, parameters) {
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $d5b33d7c30034067$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $d5b33d7c30034067$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $d5b33d7c30034067$var$resolveIncludes(string) {
    return string.replace($d5b33d7c30034067$var$includePattern, $d5b33d7c30034067$var$includeReplacer);
}
function $d5b33d7c30034067$var$includeReplacer(match, include) {
    const string = $d5b33d7c30034067$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error('Can not resolve #include <' + include + '>');
    return $d5b33d7c30034067$var$resolveIncludes(string);
}
// Unroll Loops
const $d5b33d7c30034067$var$deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const $d5b33d7c30034067$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $d5b33d7c30034067$var$unrollLoops(string) {
    return string.replace($d5b33d7c30034067$var$unrollLoopPattern, $d5b33d7c30034067$var$loopReplacer).replace($d5b33d7c30034067$var$deprecatedUnrollLoopPattern, $d5b33d7c30034067$var$deprecatedLoopReplacer);
}
function $d5b33d7c30034067$var$deprecatedLoopReplacer(match, start, end, snippet) {
    console.warn('WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.');
    return $d5b33d7c30034067$var$loopReplacer(match, start, end, snippet);
}
function $d5b33d7c30034067$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $d5b33d7c30034067$var$generatePrecision(parameters) {
    let precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === $d5b33d7c30034067$export$5813f879eee7cd88) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$a47c4b43a1be34f0) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === $d5b33d7c30034067$export$896ae1ade6c829c4) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$8759762a6477f2c4:
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case $d5b33d7c30034067$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $d5b33d7c30034067$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case $d5b33d7c30034067$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case $d5b33d7c30034067$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case $d5b33d7c30034067$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $d5b33d7c30034067$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $d5b33d7c30034067$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $d5b33d7c30034067$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $d5b33d7c30034067$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $d5b33d7c30034067$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $d5b33d7c30034067$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? '' : $d5b33d7c30034067$var$generateExtensions(parameters);
    const customDefines = $d5b33d7c30034067$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULARINTENSITYMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULARCOLORMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEENCOLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEENROUGHNESSMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors && parameters.isWebGL2 ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )',
            '	attribute vec3 morphTarget0;',
            '	attribute vec3 morphTarget1;',
            '	attribute vec3 morphTarget2;',
            '	attribute vec3 morphTarget3;',
            '	#ifdef USE_MORPHNORMALS',
            '		attribute vec3 morphNormal0;',
            '		attribute vec3 morphNormal1;',
            '		attribute vec3 morphNormal2;',
            '		attribute vec3 morphNormal3;',
            '	#else',
            '		attribute vec3 morphTarget4;',
            '		attribute vec3 morphTarget5;',
            '		attribute vec3 morphTarget6;',
            '		attribute vec3 morphTarget7;',
            '	#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
        prefixFragment = [
            customExtensions,
            $d5b33d7c30034067$var$generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULARINTENSITYMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULARCOLORMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEENCOLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEENROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== $d5b33d7c30034067$export$9fcb6b4294603b2 ? $d5b33d7c30034067$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $d5b33d7c30034067$export$955f9f2e84c43c8b['encodings_pars_fragment'],
            $d5b33d7c30034067$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputEncoding),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($d5b33d7c30034067$var$filterEmptyLine).join('\n');
    }
    vertexShader = $d5b33d7c30034067$var$resolveIncludes(vertexShader);
    vertexShader = $d5b33d7c30034067$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$resolveIncludes(fragmentShader);
    fragmentShader = $d5b33d7c30034067$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $d5b33d7c30034067$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $d5b33d7c30034067$var$unrollLoops(vertexShader);
    fragmentShader = $d5b33d7c30034067$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            'precision mediump sampler2DArray;',
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === $d5b33d7c30034067$export$f63012db5506e7dd ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $d5b33d7c30034067$var$WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = $d5b33d7c30034067$var$WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            const vertexErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glVertexShader, 'vertex');
            const fragmentErrors = $d5b33d7c30034067$var$getShaderErrors(gl, glFragmentShader, 'fragment');
            console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, 35715) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
        } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
        else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $d5b33d7c30034067$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $d5b33d7c30034067$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $d5b33d7c30034067$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $d5b33d7c30034067$var$_id = 0;
class $d5b33d7c30034067$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        if (cache.has(material) === false) cache.set(material, new Set());
        return cache.get(material);
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        if (cache.has(code) === false) {
            const stage = new $d5b33d7c30034067$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return cache.get(code);
    }
}
class $d5b33d7c30034067$var$WebGLShaderStage {
    constructor(code){
        this.id = $d5b33d7c30034067$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $d5b33d7c30034067$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $d5b33d7c30034067$export$89312ce47c0ca777();
    const _customShaders = new $d5b33d7c30034067$var$WebGLShaderCache();
    const programs = [];
    const isWebGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const vertexTextures = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $d5b33d7c30034067$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const useAlphaTest = material.alphaTest > 0;
        const useClearcoat = material.clearcoat > 0;
        const useIridescence = material.iridescence > 0;
        const parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : $d5b33d7c30034067$export$7207336e4151a112,
            map: !!material.map,
            matcap: !!material.matcap,
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            lightMap: !!material.lightMap,
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === $d5b33d7c30034067$export$9990ad26f9db5b2c,
            tangentSpaceNormalMap: material.normalMapType === $d5b33d7c30034067$export$2852a58ebdac27b8,
            decodeVideoTexture: !!material.map && material.map.isVideoTexture === true && material.map.encoding === $d5b33d7c30034067$export$f32388edbb32674,
            clearcoat: useClearcoat,
            clearcoatMap: useClearcoat && !!material.clearcoatMap,
            clearcoatRoughnessMap: useClearcoat && !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: useClearcoat && !!material.clearcoatNormalMap,
            iridescence: useIridescence,
            iridescenceMap: useIridescence && !!material.iridescenceMap,
            iridescenceThicknessMap: useIridescence && !!material.iridescenceThicknessMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            specularIntensityMap: !!material.specularIntensityMap,
            specularColorMap: !!material.specularColorMap,
            opaque: material.transparent === false && material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0,
            alphaMap: !!material.alphaMap,
            alphaTest: useAlphaTest,
            gradientMap: !!material.gradientMap,
            sheen: material.sheen > 0,
            sheenColorMap: !!material.sheenColorMap,
            sheenRoughnessMap: !!material.sheenRoughnessMap,
            transmission: material.transmission > 0,
            transmissionMap: !!material.transmissionMap,
            thicknessMap: !!material.thicknessMap,
            combine: material.combine,
            vertexTangents: !!material.normalMap && !!geometry.attributes.tangent,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.iridescenceMap || !!material.iridescenceThicknessMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || !!material.sheenColorMap || !!material.sheenRoughnessMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.iridescenceMap || !!material.iridescenceThicknessMap || material.transmission > 0 || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || material.sheen > 0 || !!material.sheenColorMap || !!material.sheenRoughnessMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: !!material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $d5b33d7c30034067$export$9fcb6b4294603b2,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $d5b33d7c30034067$export$3b296b6f144d5b03,
            flipSided: material.side === $d5b33d7c30034067$export$d9f0486e75b5ace,
            useDepthPacking: !!material.depthPacking,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has('EXT_shader_texture_lod'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputEncoding);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputEncoding);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.combine);
        array.push(parameters.vertexUvs);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.map) _programLayers.enable(4);
        if (parameters.matcap) _programLayers.enable(5);
        if (parameters.envMap) _programLayers.enable(6);
        if (parameters.lightMap) _programLayers.enable(7);
        if (parameters.aoMap) _programLayers.enable(8);
        if (parameters.emissiveMap) _programLayers.enable(9);
        if (parameters.bumpMap) _programLayers.enable(10);
        if (parameters.normalMap) _programLayers.enable(11);
        if (parameters.objectSpaceNormalMap) _programLayers.enable(12);
        if (parameters.tangentSpaceNormalMap) _programLayers.enable(13);
        if (parameters.clearcoat) _programLayers.enable(14);
        if (parameters.clearcoatMap) _programLayers.enable(15);
        if (parameters.clearcoatRoughnessMap) _programLayers.enable(16);
        if (parameters.clearcoatNormalMap) _programLayers.enable(17);
        if (parameters.iridescence) _programLayers.enable(18);
        if (parameters.iridescenceMap) _programLayers.enable(19);
        if (parameters.iridescenceThicknessMap) _programLayers.enable(20);
        if (parameters.displacementMap) _programLayers.enable(21);
        if (parameters.specularMap) _programLayers.enable(22);
        if (parameters.roughnessMap) _programLayers.enable(23);
        if (parameters.metalnessMap) _programLayers.enable(24);
        if (parameters.gradientMap) _programLayers.enable(25);
        if (parameters.alphaMap) _programLayers.enable(26);
        if (parameters.alphaTest) _programLayers.enable(27);
        if (parameters.vertexColors) _programLayers.enable(28);
        if (parameters.vertexAlphas) _programLayers.enable(29);
        if (parameters.vertexUvs) _programLayers.enable(30);
        if (parameters.vertexTangents) _programLayers.enable(31);
        if (parameters.uvsVertexOnly) _programLayers.enable(32);
        if (parameters.fog) _programLayers.enable(33);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.useFog) _programLayers.enable(0);
        if (parameters.flatShading) _programLayers.enable(1);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(2);
        if (parameters.skinning) _programLayers.enable(3);
        if (parameters.morphTargets) _programLayers.enable(4);
        if (parameters.morphNormals) _programLayers.enable(5);
        if (parameters.morphColors) _programLayers.enable(6);
        if (parameters.premultipliedAlpha) _programLayers.enable(7);
        if (parameters.shadowMapEnabled) _programLayers.enable(8);
        if (parameters.physicallyCorrectLights) _programLayers.enable(9);
        if (parameters.doubleSided) _programLayers.enable(10);
        if (parameters.flipSided) _programLayers.enable(11);
        if (parameters.useDepthPacking) _programLayers.enable(12);
        if (parameters.dithering) _programLayers.enable(13);
        if (parameters.specularIntensityMap) _programLayers.enable(14);
        if (parameters.specularColorMap) _programLayers.enable(15);
        if (parameters.transmission) _programLayers.enable(16);
        if (parameters.transmissionMap) _programLayers.enable(17);
        if (parameters.thicknessMap) _programLayers.enable(18);
        if (parameters.sheen) _programLayers.enable(19);
        if (parameters.sheenColorMap) _programLayers.enable(20);
        if (parameters.sheenRoughnessMap) _programLayers.enable(21);
        if (parameters.decodeVideoTexture) _programLayers.enable(22);
        if (parameters.opaque) _programLayers.enable(23);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $d5b33d7c30034067$export$bee4a7d47f8f5014[shaderID];
            uniforms = $d5b33d7c30034067$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $d5b33d7c30034067$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $d5b33d7c30034067$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $d5b33d7c30034067$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $d5b33d7c30034067$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $d5b33d7c30034067$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        let list;
        if (lists.has(scene) === false) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= lists.get(scene).length) {
            list = new $d5b33d7c30034067$var$WebGLRenderList();
            lists.get(scene).push(list);
        } else list = lists.get(scene)[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        skyColor: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        groundColor: new $d5b33d7c30034067$export$892596cec99bc70e()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new $d5b33d7c30034067$export$892596cec99bc70e(),
                        position: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfWidth: new $d5b33d7c30034067$export$64b5c384219d3699(),
                        halfHeight: new $d5b33d7c30034067$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $d5b33d7c30034067$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $d5b33d7c30034067$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $d5b33d7c30034067$var$nextVersion = 0;
function $d5b33d7c30034067$var$shadowCastingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function $d5b33d7c30034067$var$WebGLLights(extensions, capabilities) {
    const cache = new $d5b33d7c30034067$var$UniformsCache();
    const shadowCache = $d5b33d7c30034067$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    const vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
    const matrix4 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    const matrix42 = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    function setup(lights, physicallyCorrectLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        lights.sort($d5b33d7c30034067$var$shadowCastingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = physicallyCorrectLights !== true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    state.spotShadowMatrix[spotLength] = light.shadow.matrix;
                    numSpotShadows++;
                }
                state.spot[spotLength] = uniforms;
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $d5b33d7c30034067$export$6643083551874bf5.LTC_HALF_2;
                } else console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotShadowMatrix.length = numSpotShadows;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            state.version = $d5b33d7c30034067$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $d5b33d7c30034067$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(physicallyCorrectLights) {
        lights.setup(lightsArray, physicallyCorrectLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $d5b33d7c30034067$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        let renderState;
        if (renderStates.has(scene) === false) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStates.get(scene).length) {
            renderState = new $d5b33d7c30034067$var$WebGLRenderState(extensions, capabilities);
            renderStates.get(scene).push(renderState);
        } else renderState = renderStates.get(scene)[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $d5b33d7c30034067$export$2698c22ec13825db extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        this.depthPacking = $d5b33d7c30034067$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $d5b33d7c30034067$export$33e187ed002f2a19 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        this.referencePosition = new $d5b33d7c30034067$export$64b5c384219d3699();
        this.nearDistance = 1;
        this.farDistance = 1000;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.referencePosition.copy(source.referencePosition);
        this.nearDistance = source.nearDistance;
        this.farDistance = source.farDistance;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $d5b33d7c30034067$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $d5b33d7c30034067$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $d5b33d7c30034067$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
    const _shadowMapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewportSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(), _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(), _depthMaterial = new $d5b33d7c30034067$export$2698c22ec13825db({
        depthPacking: $d5b33d7c30034067$export$8f910f4c4f73df11
    }), _distanceMaterial = new $d5b33d7c30034067$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        0: $d5b33d7c30034067$export$d9f0486e75b5ace,
        1: $d5b33d7c30034067$export$2ede184fc2998901,
        2: $d5b33d7c30034067$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $d5b33d7c30034067$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $d5b33d7c30034067$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $d5b33d7c30034067$var$vertex,
        fragmentShader: $d5b33d7c30034067$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $d5b33d7c30034067$export$b7be63a67df8959();
    fullScreenTri.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $d5b33d7c30034067$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $d5b33d7c30034067$export$5813f879eee7cd88;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null) {
                const pars = this.type !== $d5b33d7c30034067$export$896ae1ade6c829c4 ? {
                    minFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
                    magFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0
                } : {};
                shadow.map = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $d5b33d7c30034067$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $d5b33d7c30034067$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, shadowCameraNear, shadowCameraFar, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            const keyA = result.uuid, keyB = material.uuid;
            let materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            let cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $d5b33d7c30034067$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $d5b33d7c30034067$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $d5b33d7c30034067$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case $d5b33d7c30034067$export$69025ce147cee220:
                            gl.depthFunc(512);
                            break;
                        case $d5b33d7c30034067$export$7182eb52ea3b3f04:
                            gl.depthFunc(519);
                            break;
                        case $d5b33d7c30034067$export$eedccec66ab7ebe:
                            gl.depthFunc(513);
                            break;
                        case $d5b33d7c30034067$export$296f78a0b892f81a:
                            gl.depthFunc(515);
                            break;
                        case $d5b33d7c30034067$export$a60d398fc7b7590e:
                            gl.depthFunc(514);
                            break;
                        case $d5b33d7c30034067$export$7d7234c1240a1fc4:
                            gl.depthFunc(518);
                            break;
                        case $d5b33d7c30034067$export$c5e2c52991f30937:
                            gl.depthFunc(516);
                            break;
                        case $d5b33d7c30034067$export$2f843afa843d8916:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgamMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(3088);
    const viewportParam = gl.getParameter(2978);
    const currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc($d5b33d7c30034067$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($d5b33d7c30034067$export$b9a7b4fc5cb15f9b);
    enable(2884);
    setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // 36009 is equivalent to 36160
                if (target === 36009) currentBoundFramebuffers[36160] = framebuffer;
                if (target === 36160) currentBoundFramebuffers[36009] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== 36064) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = 36064 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== 36064) {
                drawBuffers[0] = 36064;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== 1029) {
            drawBuffers[0] = 1029;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$d5b33d7c30034067$export$20183a0484ce21a0]: 32774,
        [$d5b33d7c30034067$export$73e0df5177988548]: 32778,
        [$d5b33d7c30034067$export$28e582859cbec660]: 32779
    };
    if (isWebGL2) {
        equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = 32775;
        equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = 32776;
    } else {
        const extension = extensions.get('EXT_blend_minmax');
        if (extension !== null) {
            equationToGL[$d5b33d7c30034067$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$d5b33d7c30034067$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$d5b33d7c30034067$export$2110f05edf778d3d]: 0,
        [$d5b33d7c30034067$export$8805bad65e24940e]: 1,
        [$d5b33d7c30034067$export$7fbe15b28d28cf52]: 768,
        [$d5b33d7c30034067$export$d5773124e86cf28c]: 770,
        [$d5b33d7c30034067$export$c05e2a1fc8609506]: 776,
        [$d5b33d7c30034067$export$ef5f2dd8ffac5574]: 774,
        [$d5b33d7c30034067$export$a78aed1ca2a87192]: 772,
        [$d5b33d7c30034067$export$947829af9f2c17f6]: 769,
        [$d5b33d7c30034067$export$11d468cc7f19e971]: 771,
        [$d5b33d7c30034067$export$56b85b2686ab16]: 775,
        [$d5b33d7c30034067$export$5d0fe17fd8773bac]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $d5b33d7c30034067$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== $d5b33d7c30034067$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $d5b33d7c30034067$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $d5b33d7c30034067$export$20183a0484ce21a0) {
                    gl.blendEquation(32774);
                    currentBlendEquation = $d5b33d7c30034067$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $d5b33d7c30034067$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(1, 1);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case $d5b33d7c30034067$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case $d5b33d7c30034067$export$777d8f9551c2216b:
                        gl.blendFunc(770, 1);
                        break;
                    case $d5b33d7c30034067$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $d5b33d7c30034067$export$4138e1c684b46a20:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $d5b33d7c30034067$export$3b296b6f144d5b03 ? disable(2884) : enable(2884);
        let flipSided = material.side === $d5b33d7c30034067$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $d5b33d7c30034067$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($d5b33d7c30034067$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(32926) : disable(32926);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $d5b33d7c30034067$export$3237e1f2c1ea1f44) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === $d5b33d7c30034067$export$b9a7b4fc5cb15f9b) gl.cullFace(1029);
                else if (cullFace === $d5b33d7c30034067$export$b8058bcc7037d3f3) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        let boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgamMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgamMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgamMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(uniformsGroup) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(uniformsGroup, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(3042);
        gl.disable(2884);
        gl.disable(2929);
        gl.disable(32823);
        gl.disable(3089);
        gl.disable(2960);
        gl.disable(32926);
        gl.blendEquation(32774);
        gl.blendFunc(1, 0);
        gl.blendFuncSeparate(1, 0, 1, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(513);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(519, 0, 0xffffffff);
        gl.stencilOp(7680, 7680, 7680);
        gl.clearStencil(0);
        gl.cullFace(1029);
        gl.frontFace(2305);
        gl.polygonOffset(0, 0);
        gl.activeTexture(33984);
        gl.bindFramebuffer(36160, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(36009, null);
            gl.bindFramebuffer(36008, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $d5b33d7c30034067$var$createElementNS('canvas');
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $d5b33d7c30034067$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $d5b33d7c30034067$var$isPowerOfTwo(image.width) && $d5b33d7c30034067$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.wrapT !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, encoding, isVideoTexture = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 33319) {
            if (glType === 5126) internalFormat = 33328;
            if (glType === 5131) internalFormat = 33327;
            if (glType === 5121) internalFormat = 33323;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = encoding === $d5b33d7c30034067$export$f32388edbb32674 && isVideoTexture === false ? 35907 : 32856;
            if (glType === 32819) internalFormat = 32854;
            if (glType === 32820) internalFormat = 32855;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $d5b33d7c30034067$export$727aa5ec3fe39bf0 || f === $d5b33d7c30034067$export$d129e38cf6feaa8c || f === $d5b33d7c30034067$export$d2327c1afe5bfdf2) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.encoding);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    const wrappingToGL = {
        [$d5b33d7c30034067$export$533346c8e8dac0f5]: 10497,
        [$d5b33d7c30034067$export$9d9334239a5a5e06]: 33071,
        [$d5b33d7c30034067$export$c7e7c00b14f51a4f]: 33648
    };
    const filterToGL = {
        [$d5b33d7c30034067$export$727aa5ec3fe39bf0]: 9728,
        [$d5b33d7c30034067$export$d129e38cf6feaa8c]: 9984,
        [$d5b33d7c30034067$export$d2327c1afe5bfdf2]: 9986,
        [$d5b33d7c30034067$export$8a72f490b25c56c8]: 9729,
        [$d5b33d7c30034067$export$19a719f377145a13]: 9985,
        [$d5b33d7c30034067$export$5d8599b6a933fb1b]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== $d5b33d7c30034067$export$9d9334239a5a5e06 || texture.wrapT !== $d5b33d7c30034067$export$9d9334239a5a5e06) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== $d5b33d7c30034067$export$727aa5ec3fe39bf0 && texture.minFilter !== $d5b33d7c30034067$export$8a72f490b25c56c8) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            if (texture.type === $d5b33d7c30034067$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $d5b33d7c30034067$export$2697304443f382bc && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataArrayTexture) textureType = 35866;
        if (texture.isData3DTexture) textureType = 32879;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        if (source.version !== source.__currentVersion || forceUpload === true) {
            _gl.pixelStorei(37440, texture.flipY);
            _gl.pixelStorei(37441, texture.premultiplyAlpha);
            _gl.pixelStorei(3317, texture.unpackAlignment);
            _gl.pixelStorei(37443, 0);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = source.__currentVersion === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = 6402;
                if (isWebGL2) {
                    if (texture.type === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (texture.type === $d5b33d7c30034067$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                    else if (texture.type === $d5b33d7c30034067$export$6c8ea339bfab1301) glInternalFormat = 35056;
                    else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $d5b33d7c30034067$export$f6d331659b644596) console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
                // validation checks for WebGL 1
                if (texture.format === $d5b33d7c30034067$export$c1b6b5136be58045 && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $d5b33d7c30034067$export$c63dc51868b06a9d && texture.type !== $d5b33d7c30034067$export$c3c7fc4518ebba96) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                        texture.type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $d5b33d7c30034067$export$1e113ac2d0905829 && glInternalFormat === 6402) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = 34041;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $d5b33d7c30034067$export$6c8ea339bfab1301) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                        texture.type = $d5b33d7c30034067$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                        if (glFormat !== null) {
                            if (useTexStorage) state.compressedTexSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                            else state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                    } else if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                    else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(3553, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            source.__currentVersion = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        if (source.version !== source.__currentVersion || forceUpload === true) {
            _gl.pixelStorei(37440, texture.flipY);
            _gl.pixelStorei(37441, texture.premultiplyAlpha);
            _gl.pixelStorei(3317, texture.unpackAlignment);
            _gl.pixelStorei(37443, 0);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = source.__currentVersion === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(34067, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $d5b33d7c30034067$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else if (useTexStorage) state.texSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(34067);
            source.__currentVersion = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format, texture.encoding);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            if (textureTarget === 32879 || textureTarget === 35866) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(36160, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $d5b33d7c30034067$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (depthTexture.type === $d5b33d7c30034067$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.encoding);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $d5b33d7c30034067$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(36160, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.encoding);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(36161, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(36160, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(34067);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(3553, attachmentProperties.__webglTexture);
                setTextureParameters(3553, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i, 3553);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(3553);
            }
            state.unbindTexture();
        } else {
            let glTextureType = 3553;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? 32879 : 35866;
                else console.error('THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.');
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = 16384;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, null);
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(36009, 36064 + i, 3553, null, 0);
            }
            state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(36064 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= 256;
                    if (renderTarget.stencilBuffer) mask |= 1024;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(36008, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(36008, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(36009, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(36009, 36064, 3553, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(36008, invalidationArray);
            }
            state.bindFramebuffer(36008, null);
            state.bindFramebuffer(36009, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(36009, 36064 + i, 3553, webglTexture, 0);
            }
            state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const encoding = texture.encoding;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === $d5b33d7c30034067$export$ca1dce8b5e1de74d) return image;
        if (encoding !== $d5b33d7c30034067$export$7207336e4151a112) {
            // sRGB
            if (encoding === $d5b33d7c30034067$export$f32388edbb32674) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has('EXT_sRGB') === true && format === $d5b33d7c30034067$export$3f8bb04b555a363c) {
                        texture.format = $d5b33d7c30034067$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $d5b33d7c30034067$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $d5b33d7c30034067$export$3f8bb04b555a363c || type !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture encoding:', encoding);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $d5b33d7c30034067$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, encoding = null) {
        let extension;
        if (p === $d5b33d7c30034067$export$2e8ce08d3f6f5e10) return 5121;
        if (p === $d5b33d7c30034067$export$b3969b01faf587f2) return 32819;
        if (p === $d5b33d7c30034067$export$18886f8ae33e90de) return 32820;
        if (p === $d5b33d7c30034067$export$545fce0311a9796a) return 5120;
        if (p === $d5b33d7c30034067$export$88572337f312435f) return 5122;
        if (p === $d5b33d7c30034067$export$c63dc51868b06a9d) return 5123;
        if (p === $d5b33d7c30034067$export$5c612977753abe2) return 5124;
        if (p === $d5b33d7c30034067$export$c3c7fc4518ebba96) return 5125;
        if (p === $d5b33d7c30034067$export$f6d331659b644596) return 5126;
        if (p === $d5b33d7c30034067$export$2697304443f382bc) {
            if (isWebGL2) return 5131;
            extension = extensions.get('OES_texture_half_float');
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $d5b33d7c30034067$export$988473390501ed4b) return 6406;
        if (p === $d5b33d7c30034067$export$3f8bb04b555a363c) return 6408;
        if (p === $d5b33d7c30034067$export$cc09ccbf6d1ed449) return 6409;
        if (p === $d5b33d7c30034067$export$9053a81c4a69c289) return 6410;
        if (p === $d5b33d7c30034067$export$c1b6b5136be58045) return 6402;
        if (p === $d5b33d7c30034067$export$1e113ac2d0905829) return 34041;
        if (p === $d5b33d7c30034067$export$4e041a7967d15c4b) return 6403;
        if (p === $d5b33d7c30034067$export$7c67423a5ee6f5eb) {
            console.warn('THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228');
            return 6408;
        }
        // WebGL 1 sRGB fallback
        if (p === $d5b33d7c30034067$export$ca1dce8b5e1de74d) {
            extension = extensions.get('EXT_sRGB');
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $d5b33d7c30034067$export$aa92e870a709d190) return 36244;
        if (p === $d5b33d7c30034067$export$6cdf0b461c7ce8a0) return 33319;
        if (p === $d5b33d7c30034067$export$1ba1c45f9f77d4d7) return 33320;
        if (p === $d5b33d7c30034067$export$c200e7d26f592f21) return 36249;
        // S3TC
        if (p === $d5b33d7c30034067$export$21d1799c6d552fc0 || p === $d5b33d7c30034067$export$afa304c3e981b668 || p === $d5b33d7c30034067$export$d2a1a68024a3e56c || p === $d5b33d7c30034067$export$9a79c424327dacf9) {
            if (encoding === $d5b33d7c30034067$export$f32388edbb32674) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === $d5b33d7c30034067$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $d5b33d7c30034067$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $d5b33d7c30034067$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $d5b33d7c30034067$export$19ada9bbb1af3573 || p === $d5b33d7c30034067$export$d0f0355bb3d948e4 || p === $d5b33d7c30034067$export$b82296714358084c || p === $d5b33d7c30034067$export$b71692456c47b6c3) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $d5b33d7c30034067$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $d5b33d7c30034067$export$6ab91af2d757aee7) {
            extension = extensions.get('WEBGL_compressed_texture_etc1');
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $d5b33d7c30034067$export$7800993ef8106a6a || p === $d5b33d7c30034067$export$23ed8300a860e7d8) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$7800993ef8106a6a) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $d5b33d7c30034067$export$23ed8300a860e7d8) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48 || p === $d5b33d7c30034067$export$68880cd325f8b2fb || p === $d5b33d7c30034067$export$7d2c0be323373d95 || p === $d5b33d7c30034067$export$22b52da301fc3a3e || p === $d5b33d7c30034067$export$c009e2cb4a66485e || p === $d5b33d7c30034067$export$118fff5afa255b63 || p === $d5b33d7c30034067$export$120713c829ae0667 || p === $d5b33d7c30034067$export$c79eeabbf53313e9 || p === $d5b33d7c30034067$export$443cf6567cdd6424 || p === $d5b33d7c30034067$export$6573984fc9840780 || p === $d5b33d7c30034067$export$e7aee563f30091de || p === $d5b33d7c30034067$export$2eb8634622ddeab7 || p === $d5b33d7c30034067$export$202b1ce7b5d25742 || p === $d5b33d7c30034067$export$18ab77abd087e467) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$dc5570b4a2b92d48) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $d5b33d7c30034067$export$68880cd325f8b2fb) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $d5b33d7c30034067$export$7d2c0be323373d95) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $d5b33d7c30034067$export$22b52da301fc3a3e) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $d5b33d7c30034067$export$c009e2cb4a66485e) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $d5b33d7c30034067$export$118fff5afa255b63) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $d5b33d7c30034067$export$120713c829ae0667) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $d5b33d7c30034067$export$c79eeabbf53313e9) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $d5b33d7c30034067$export$443cf6567cdd6424) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $d5b33d7c30034067$export$6573984fc9840780) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $d5b33d7c30034067$export$e7aee563f30091de) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $d5b33d7c30034067$export$2eb8634622ddeab7) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $d5b33d7c30034067$export$202b1ce7b5d25742) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $d5b33d7c30034067$export$18ab77abd087e467) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $d5b33d7c30034067$export$ce40b115e188bc81) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === $d5b33d7c30034067$export$ce40b115e188bc81) return encoding === $d5b33d7c30034067$export$f32388edbb32674 ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        //
        if (p === $d5b33d7c30034067$export$6c8ea339bfab1301) {
            if (isWebGL2) return 34042;
            extension = extensions.get('WEBGL_depth_texture');
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $d5b33d7c30034067$export$56b937d9e5581166 extends $d5b33d7c30034067$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $d5b33d7c30034067$export$eb2fcfdbd7ba97d4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = 'Group';
    }
}
const $d5b33d7c30034067$var$_moveEvent = {
    type: 'move'
};
class $d5b33d7c30034067$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $d5b33d7c30034067$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    if (hand.joints[inputjoint.jointName] === undefined) {
                        // The transform of this joint will be updated with the joint pose on each frame
                        const joint = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
                        joint.matrixAutoUpdate = false;
                        joint.visible = false;
                        hand.joints[inputjoint.jointName] = joint;
                        // ??
                        hand.add(joint);
                    }
                    const joint = hand.joints[inputjoint.jointName];
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($d5b33d7c30034067$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
}
class $d5b33d7c30034067$export$fc830aa069cc8c2f extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $d5b33d7c30034067$export$c1b6b5136be58045;
        if (format !== $d5b33d7c30034067$export$c1b6b5136be58045 && format !== $d5b33d7c30034067$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $d5b33d7c30034067$export$c1b6b5136be58045) type = $d5b33d7c30034067$export$c3c7fc4518ebba96;
        if (type === undefined && format === $d5b33d7c30034067$export$1e113ac2d0905829) type = $d5b33d7c30034067$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
    }
}
class $d5b33d7c30034067$var$WebXRManager extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        const cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraVR = new $d5b33d7c30034067$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $d5b33d7c30034067$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) controller.dispatchEvent({
                type: event.type,
                data: event.inputSource
            });
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: attributes.alpha,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        encoding: renderer.outputEncoding
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? 35056 : 33190;
                        depthFormat = attributes.stencil ? $d5b33d7c30034067$export$1e113ac2d0905829 : $d5b33d7c30034067$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $d5b33d7c30034067$export$6c8ea339bfab1301 : $d5b33d7c30034067$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: 32856,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $d5b33d7c30034067$export$3f8bb04b555a363c,
                        type: $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
                        depthTexture: new $d5b33d7c30034067$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        encoding: renderer.outputEncoding,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                // Set foveation to maximum.
                this.setFoveation(1.0);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].dispatchEvent({
                        type: 'disconnected',
                        data: inputSource
                    });
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.dispatchEvent({
                    type: 'connected',
                    data: inputSource
                });
            }
        }
        //
        const cameraLPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        const cameraRPos = new $d5b33d7c30034067$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            const parent = camera.parent;
            const cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
            // update user camera and its children
            camera.position.copy(cameraVR.position);
            camera.quaternion.copy(cameraVR.quaternion);
            camera.scale.copy(cameraVR.scale);
            camera.matrix.copy(cameraVR.matrix);
            camera.matrixWorld.copy(cameraVR.matrixWorld);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        };
        this.getCamera = function() {
            return cameraVR;
        };
        this.getFoveation = function() {
            if (glProjLayer !== null) return glProjLayer.fixedFoveation;
            if (glBaseLayer !== null) return glBaseLayer.fixedFoveation;
            return undefined;
        };
        this.setFoveation = function(foveation) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            if (glProjLayer !== null) glProjLayer.fixedFoveation = foveation;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = foveation;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $d5b33d7c30034067$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) cameraVR.matrix.copy(camera.matrix);
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            xrFrame = null;
        }
        const animation = new $d5b33d7c30034067$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $d5b33d7c30034067$var$WebGLMaterials(renderer, properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer.physicallyCorrectLights !== true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        // 13. iridescence map
        // 14. iridescence thickness map
        // 15. specular intensity map
        // 16. specular tint map
        // 17. transmission map
        // 18. thickness map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        else if (material.iridescenceMap) uvScaleMap = material.iridescenceMap;
        else if (material.iridescenceThicknessMap) uvScaleMap = material.iridescenceThicknessMap;
        else if (material.specularIntensityMap) uvScaleMap = material.specularIntensityMap;
        else if (material.specularColorMap) uvScaleMap = material.specularColorMap;
        else if (material.transmissionMap) uvScaleMap = material.transmissionMap;
        else if (material.thicknessMap) uvScaleMap = material.thicknessMap;
        else if (material.sheenColorMap) uvScaleMap = material.sheenColorMap;
        else if (material.sheenRoughnessMap) uvScaleMap = material.sheenRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        let uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) uniforms.sheenColorMap.value = material.sheenColorMap;
            if (material.sheenRoughnessMap) uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
            if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                if (material.side === $d5b33d7c30034067$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) uniforms.iridescenceMap.value = material.iridescenceMap;
            if (material.iridescenceThicknessMap) uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) uniforms.thicknessMap.value = material.thicknessMap;
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularIntensityMap) uniforms.specularIntensityMap.value = material.specularIntensityMap;
        if (material.specularColorMap) uniforms.specularColorMap.value = material.specularColorMap;
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $d5b33d7c30034067$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(35375) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(35345, buffer);
        gl.bufferData(35345, size, usage);
        gl.bindBuffer(35345, null);
        gl.bindBufferBase(35345, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(35345, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const value = uniform.value;
                const offset = uniform.__offset;
                if (typeof value === 'number') {
                    uniform.__data[0] = value;
                    gl.bufferSubData(35345, offset, uniform.__data);
                } else {
                    if (uniform.value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = uniform.value.elements[0];
                        uniform.__data[1] = uniform.value.elements[1];
                        uniform.__data[2] = uniform.value.elements[2];
                        uniform.__data[3] = uniform.value.elements[0];
                        uniform.__data[4] = uniform.value.elements[3];
                        uniform.__data[5] = uniform.value.elements[4];
                        uniform.__data[6] = uniform.value.elements[5];
                        uniform.__data[7] = uniform.value.elements[0];
                        uniform.__data[8] = uniform.value.elements[6];
                        uniform.__data[9] = uniform.value.elements[7];
                        uniform.__data[10] = uniform.value.elements[8];
                        uniform.__data[11] = uniform.value.elements[0];
                    } else value.toArray(uniform.__data);
                    gl.bufferSubData(35345, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(35345, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number') cache[index] = value;
            else cache[index] = value.clone();
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === 'number') {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObject = cache[index];
                if (cachedObject.equals(value) === false) {
                    cachedObject.copy(value);
                    return true;
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const info = getUniformSize(uniform);
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - info.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += info.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(uniform) {
        const value = uniform.value;
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number') {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
function $d5b33d7c30034067$var$createCanvasElement() {
    const canvas = $d5b33d7c30034067$var$createElementNS('canvas');
    canvas.style.display = 'block';
    return canvas;
}
function $d5b33d7c30034067$export$f6cc00ef28d7cf97(parameters = {}) {
    this.isWebGLRenderer = true;
    const _canvas = parameters.canvas !== undefined ? parameters.canvas : $d5b33d7c30034067$var$createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default', _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    let _alpha;
    if (_context !== null) _alpha = _context.getContextAttributes().alpha;
    else _alpha = parameters.alpha !== undefined ? parameters.alpha : false;
    let currentRenderList = null;
    let currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its list and state isolated from the parent render call.
    const renderListStack = [];
    const renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.outputEncoding = $d5b33d7c30034067$export$7207336e4151a112;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
    this.toneMappingExposure = 1.0;
    //
    Object.defineProperties(this, {
        // @deprecated since r136, 0e21088102b4de7e0a0a33140620b7a3424b9e6d
        gammaFactor: {
            get: function() {
                console.warn('THREE.WebGLRenderer: .gammaFactor has been removed.');
                return 2;
            },
            set: function() {
                console.warn('THREE.WebGLRenderer: .gammaFactor has been removed.');
            }
        }
    });
    // internal properties
    const _this = this;
    let _isContextLost = false;
    // internal state cache
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
    const _currentScissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
    let _currentScissorTest = null;
    //
    let _width = _canvas.width;
    let _height = _canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
    const _scissor = new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, _width, _height);
    let _scissorTest = false;
    // frustum
    const _frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
    // clipping
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    // transmission
    let _transmissionRenderTarget = null;
    // camera matrices cache
    const _projScreenMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    const _vector2 = new $d5b33d7c30034067$export$c977b3e384af9ae1();
    const _vector3 = new $d5b33d7c30034067$export$64b5c384219d3699();
    const _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    let _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(let i = 0; i < contextNames.length; i++){
            const contextName = contextNames[i];
            const context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        const contextAttributes = {
            alpha: true,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // OffscreenCanvas does not have setAttribute, see #22811
        if ('setAttribute' in _canvas) _canvas.setAttribute('data-engine', `three.js r${$d5b33d7c30034067$export$3545e07a80636437}`);
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener('webglcontextlost', onContextLost, false);
        _canvas.addEventListener('webglcontextrestored', onContextRestore, false);
        _canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
        if (_gl === null) {
            const contextNames = [
                'webgl2',
                'webgl',
                'experimental-webgl'
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error('Error creating WebGL context with your selected attributes.');
                else throw new Error('Error creating WebGL context.');
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                'rangeMin': 1,
                'rangeMax': 1,
                'precision': 1
            };
        };
    } catch (error) {
        console.error('THREE.WebGLRenderer: ' + error.message);
        throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping, shadowMap;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates, uniformsGroups;
    function initGLContext() {
        extensions = new $d5b33d7c30034067$var$WebGLExtensions(_gl);
        capabilities = new $d5b33d7c30034067$var$WebGLCapabilities(_gl, extensions, parameters);
        extensions.init(capabilities);
        utils = new $d5b33d7c30034067$export$ddaebcad857649a8(_gl, extensions, capabilities);
        state = new $d5b33d7c30034067$var$WebGLState(_gl, extensions, capabilities);
        info = new $d5b33d7c30034067$var$WebGLInfo();
        properties = new $d5b33d7c30034067$var$WebGLProperties();
        textures = new $d5b33d7c30034067$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new $d5b33d7c30034067$var$WebGLCubeMaps(_this);
        cubeuvmaps = new $d5b33d7c30034067$var$WebGLCubeUVMaps(_this);
        attributes = new $d5b33d7c30034067$var$WebGLAttributes(_gl, capabilities);
        bindingStates = new $d5b33d7c30034067$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new $d5b33d7c30034067$var$WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new $d5b33d7c30034067$var$WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new $d5b33d7c30034067$var$WebGLMorphtargets(_gl, capabilities, textures);
        clipping = new $d5b33d7c30034067$var$WebGLClipping(properties);
        programCache = new $d5b33d7c30034067$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
        materials = new $d5b33d7c30034067$var$WebGLMaterials(_this, properties);
        renderLists = new $d5b33d7c30034067$var$WebGLRenderLists();
        renderStates = new $d5b33d7c30034067$var$WebGLRenderStates(extensions, capabilities);
        background = new $d5b33d7c30034067$var$WebGLBackground(_this, cubemaps, state, objects, _alpha, _premultipliedAlpha);
        shadowMap = new $d5b33d7c30034067$var$WebGLShadowMap(_this, objects, capabilities);
        uniformsGroups = new $d5b33d7c30034067$var$WebGLUniformsGroups(_gl, info, capabilities, state);
        bufferRenderer = new $d5b33d7c30034067$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new $d5b33d7c30034067$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.shadowMap = shadowMap;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    const xr = new $d5b33d7c30034067$var$WebXRManager(_this, _gl);
    this.xr = xr;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + 'px';
            _canvas.style.height = height + 'px';
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color = true, depth = true, stencil = true) {
        let bits = 0;
        if (color) bits |= 16384;
        if (depth) bits |= 256;
        if (stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener('webglcontextlost', onContextLost, false);
        _canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
        _canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        cubeuvmaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        uniformsGroups.dispose();
        programCache.dispose();
        xr.dispose();
        xr.removeEventListener('sessionstart', onXRSessionStart);
        xr.removeEventListener('sessionend', onXRSessionEnd);
        if (_transmissionRenderTarget) {
            _transmissionRenderTarget.dispose();
            _transmissionRenderTarget = null;
        }
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log('THREE.WebGLRenderer: Context Lost.');
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log('THREE.WebGLRenderer: Context Restored.');
        _isContextLost = false;
        const infoAutoReset = info.autoReset;
        const shadowMapEnabled = shadowMap.enabled;
        const shadowMapAutoUpdate = shadowMap.autoUpdate;
        const shadowMapNeedsUpdate = shadowMap.needsUpdate;
        const shadowMapType = shadowMap.type;
        initGLContext();
        info.autoReset = infoAutoReset;
        shadowMap.enabled = shadowMapEnabled;
        shadowMap.autoUpdate = shadowMapAutoUpdate;
        shadowMap.needsUpdate = shadowMapNeedsUpdate;
        shadowMap.type = shadowMapType;
    }
    function onContextCreationError(event) {
        console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReferences(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
        const programs = properties.get(material).programs;
        if (programs !== undefined) {
            programs.forEach(function(program) {
                programCache.releaseProgram(program);
            });
            if (material.isShaderMaterial) programCache.releaseShaderCache(material);
        }
    }
    // Buffer rendering
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, geometry, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        let index = geometry.index;
        const position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        let rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        const dataCount = index !== null ? index.count : position.count;
        const rangeStart = geometry.drawRange.start * rangeFactor;
        const rangeCount = geometry.drawRange.count * rangeFactor;
        const groupStart = group !== null ? group.start * rangeFactor : 0;
        const groupCount = group !== null ? group.count * rangeFactor : Infinity;
        const drawStart = Math.max(rangeStart, groupStart);
        const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        const drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        scene.traverse(function(object) {
            const material = object.material;
            if (material) {
                if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                    const material2 = material[i];
                    getProgram(material2, scene, object);
                }
                else getProgram(material, scene, object);
            }
        });
        renderStateStack.pop();
        currentRenderState = null;
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    function onXRSessionStart() {
        animation.stop();
    }
    function onXRSessionEnd() {
        animation.start();
    }
    const animation = new $d5b33d7c30034067$var$WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof self !== 'undefined') animation.setContext(self);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener('sessionstart', onXRSessionStart);
    xr.addEventListener('sessionend', onXRSessionEnd);
    // Rendering
    this.render = function(scene, camera) {
        if (camera !== undefined && camera.isCamera !== true) {
            console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
            return;
        }
        if (_isContextLost === true) return;
        // update scene graph
        if (scene.autoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, renderListStack.length);
        currentRenderList.init();
        renderListStack.push(currentRenderList);
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        //
        background.render(currentRenderList, scene);
        // render scene
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        if (camera.isArrayCamera) {
            const cameras = camera.cameras;
            for(let i = 0, l = cameras.length; i < l; i++){
                const camera2 = cameras[i];
                renderScene(currentRenderList, scene, camera2, camera2.viewport);
            }
        } else renderScene(currentRenderList, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
        }
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        // _gl.finish();
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        renderListStack.pop();
        if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
        else currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
    }
    function renderScene(currentRenderList, scene, camera, viewport) {
        const opaqueObjects = currentRenderList.opaque;
        const transmissiveObjects = currentRenderList.transmissive;
        const transparentObjects = currentRenderList.transparent;
        currentRenderState.setupLightsView(camera);
        if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, scene, camera);
        if (viewport) state.viewport(_currentViewport.copy(viewport));
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
    }
    function renderTransmissionPass(opaqueObjects, scene, camera) {
        const isWebGL2 = capabilities.isWebGL2;
        if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $d5b33d7c30034067$export$3c052beb2e51e23f(1, 1, {
            generateMipmaps: true,
            type: extensions.has('EXT_color_buffer_half_float') ? $d5b33d7c30034067$export$2697304443f382bc : $d5b33d7c30034067$export$2e8ce08d3f6f5e10,
            minFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b,
            samples: isWebGL2 && _antialias === true ? 4 : 0
        });
        _this.getDrawingBufferSize(_vector2);
        if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
        else _transmissionRenderTarget.setSize($d5b33d7c30034067$var$floorPowerOfTwo(_vector2.x), $d5b33d7c30034067$var$floorPowerOfTwo(_vector2.y));
        //
        const currentRenderTarget = _this.getRenderTarget();
        _this.setRenderTarget(_transmissionRenderTarget);
        _this.clear();
        // Turn off the features which can affect the frag color for opaque objects pass.
        // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
        const currentToneMapping = _this.toneMapping;
        _this.toneMapping = $d5b33d7c30034067$export$9fcb6b4294603b2;
        renderObjects(opaqueObjects, scene, camera);
        _this.toneMapping = currentToneMapping;
        textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
        textures.updateRenderTargetMipmap(_transmissionRenderTarget);
        _this.setRenderTarget(currentRenderTarget);
    }
    function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(let i = 0, l = renderList.length; i < l; i++){
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            const group = renderItem.group;
            if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        material.onBeforeRender(_this, scene, camera, geometry, object, group);
        if (material.transparent === true && material.side === $d5b33d7c30034067$export$3b296b6f144d5b03) {
            material.side = $d5b33d7c30034067$export$d9f0486e75b5ace;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $d5b33d7c30034067$export$2ede184fc2998901;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $d5b33d7c30034067$export$3b296b6f144d5b03;
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters);
        let programs = materialProperties.programs;
        // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
        if (programs === undefined) {
            // new material
            material.addEventListener('dispose', onMaterialDispose);
            programs = new Map();
            materialProperties.programs = programs;
        }
        let program = programs.get(programCacheKey);
        if (program !== undefined) // early out if program and light state is identical
        {
            if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                updateCommonMaterialProperties(material, parameters);
                return program;
            }
        } else {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBuild(object, parameters, _this);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            programs.set(programCacheKey, program);
            materialProperties.uniforms = parameters.uniforms;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
        updateCommonMaterialProperties(material, parameters);
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        const progUniforms = program.getUniforms();
        const uniformsList = $d5b33d7c30034067$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.currentProgram = program;
        materialProperties.uniformsList = uniformsList;
        return program;
    }
    function updateCommonMaterialProperties(material, parameters) {
        const materialProperties = properties.get(material);
        materialProperties.outputEncoding = parameters.outputEncoding;
        materialProperties.instancing = parameters.instancing;
        materialProperties.skinning = parameters.skinning;
        materialProperties.morphTargets = parameters.morphTargets;
        materialProperties.morphNormals = parameters.morphNormals;
        materialProperties.morphColors = parameters.morphColors;
        materialProperties.morphTargetsCount = parameters.morphTargetsCount;
        materialProperties.numClippingPlanes = parameters.numClippingPlanes;
        materialProperties.numIntersection = parameters.numClipIntersection;
        materialProperties.vertexAlphas = parameters.vertexAlphas;
        materialProperties.vertexTangents = parameters.vertexTangents;
        materialProperties.toneMapping = parameters.toneMapping;
    }
    function setProgram(camera, scene, geometry, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : $d5b33d7c30034067$export$7207336e4151a112;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
        const vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
        const morphTargets = !!geometry.morphAttributes.position;
        const morphNormals = !!geometry.morphAttributes.normal;
        const morphColors = !!geometry.morphAttributes.color;
        const toneMapping = material.toneMapped ? _this.toneMapping : $d5b33d7c30034067$export$9fcb6b4294603b2;
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        //
        let needsProgramChange = false;
        if (material.version === materialProperties.__version) {
            if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
            else if (materialProperties.outputEncoding !== encoding) needsProgramChange = true;
            else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
            else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
            else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
            else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
            else if (materialProperties.envMap !== envMap) needsProgramChange = true;
            else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
            else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
            else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
            else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
            else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
            else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
            else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
            else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
        } else {
            needsProgramChange = true;
            materialProperties.__version = material.version;
        }
        //
        let program = materialProperties.currentProgram;
        if (needsProgramChange === true) program = getProgram(material, scene, object);
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
        }
        // skinning and morph target uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone and morph texture must go before other textures
        // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
        if (object.isSkinnedMesh) {
            p_uniforms.setOptional(_gl, object, 'bindMatrix');
            p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
            const skeleton = object.skeleton;
            if (skeleton) {
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                } else console.warn('THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.');
            }
        }
        const morphAttributes = geometry.morphAttributes;
        if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, material, program);
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
            $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            $d5b33d7c30034067$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
        // common matrices
        p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
        p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
        p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
        // UBOs
        if (material.isShaderMaterial || material.isRawShaderMaterial) {
            const groups = material.uniformsGroups;
            for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                const group = groups[i];
                uniformsGroups.update(group, program);
                uniformsGroups.bind(group, program);
            } else console.warn('THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.');
        }
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
        properties.get(renderTarget.texture).__webglTexture = colorTexture;
        properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__hasExternalTextures = true;
        if (renderTargetProperties.__hasExternalTextures) {
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                    console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        }
    };
    this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
        renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        let useDefaultFramebuffer = true;
        if (renderTarget) {
            const renderTargetProperties = properties.get(renderTarget);
            if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                // We need to make sure to rebind the framebuffer.
                state.bindFramebuffer(36160, null);
                useDefaultFramebuffer = false;
            } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
            else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
            textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
        }
        let framebuffer = null;
        let isCube = false;
        let isRenderTarget3D = false;
        if (renderTarget) {
            const texture = renderTarget.texture;
            if (texture.isData3DTexture || texture.isDataArrayTexture) isRenderTarget3D = true;
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        const framebufferBound = state.bindFramebuffer(36160, framebuffer);
        if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        } else if (isRenderTarget3D) {
            const textureProperties = properties.get(renderTarget.texture);
            const layer = activeCubeFace || 0;
            _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
        }
        _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            state.bindFramebuffer(36160, framebuffer);
            try {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (textureFormat !== $d5b33d7c30034067$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                    return;
                }
                const halfFloatSupportedByExt = textureType === $d5b33d7c30034067$export$2697304443f382bc && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));
                if (textureType !== $d5b33d7c30034067$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
                !(textureType === $d5b33d7c30034067$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
                !halfFloatSupportedByExt) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                    return;
                }
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
            } finally{
                // restore framebuffer of current render target if necessary
                const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                state.bindFramebuffer(36160, framebuffer);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture, level = 0) {
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        textures.setTexture2D(texture, 0);
        _gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
        const width = srcTexture.image.width;
        const height = srcTexture.image.height;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
        if (_this.isWebGL1Renderer) {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
            return;
        }
        const width = sourceBox.max.x - sourceBox.min.x + 1;
        const height = sourceBox.max.y - sourceBox.min.y + 1;
        const depth = sourceBox.max.z - sourceBox.min.z + 1;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        let glTarget;
        if (dstTexture.isData3DTexture) {
            textures.setTexture3D(dstTexture, 0);
            glTarget = 32879;
        } else if (dstTexture.isDataArrayTexture) {
            textures.setTexture2DArray(dstTexture, 0);
            glTarget = 35866;
        } else {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
            return;
        }
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        const unpackRowLen = _gl.getParameter(3314);
        const unpackImageHeight = _gl.getParameter(32878);
        const unpackSkipPixels = _gl.getParameter(3316);
        const unpackSkipRows = _gl.getParameter(3315);
        const unpackSkipImages = _gl.getParameter(32877);
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
        _gl.pixelStorei(3314, image.width);
        _gl.pixelStorei(32878, image.height);
        _gl.pixelStorei(3316, sourceBox.min.x);
        _gl.pixelStorei(3315, sourceBox.min.y);
        _gl.pixelStorei(32877, sourceBox.min.z);
        if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
        else if (srcTexture.isCompressedTexture) {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.');
            _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
        } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
        _gl.pixelStorei(3314, unpackRowLen);
        _gl.pixelStorei(32878, unpackImageHeight);
        _gl.pixelStorei(3316, unpackSkipPixels);
        _gl.pixelStorei(3315, unpackSkipRows);
        _gl.pixelStorei(32877, unpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
        else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
        else if (texture.isDataArrayTexture) textures.setTexture2DArray(texture, 0);
        else textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        _currentActiveCubeFace = 0;
        _currentActiveMipmapLevel = 0;
        _currentRenderTarget = null;
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
        detail: this
    }));
}
class $d5b33d7c30034067$export$a2f65229194348f9 extends $d5b33d7c30034067$export$f6cc00ef28d7cf97 {
}
$d5b33d7c30034067$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $d5b33d7c30034067$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = '';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $d5b33d7c30034067$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $d5b33d7c30034067$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = '';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $d5b33d7c30034067$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $d5b33d7c30034067$export$38af1803e3442a7f extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.overrideMaterial = null;
        this.autoUpdate = true; // checked by the renderer
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.autoUpdate = source.autoUpdate;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        return data;
    }
}
class $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $d5b33d7c30034067$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $d5b33d7c30034067$var$_vector$6 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized === true;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$6.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$6.x, $d5b33d7c30034067$var$_vector$6.y, $d5b33d7c30034067$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$6.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$6.x, $d5b33d7c30034067$var$_vector$6.y, $d5b33d7c30034067$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $d5b33d7c30034067$var$_vector$6.fromBufferAttribute(this, i);
            $d5b33d7c30034067$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $d5b33d7c30034067$var$_vector$6.x, $d5b33d7c30034067$var$_vector$6.y, $d5b33d7c30034067$var$_vector$6.z);
        }
        return this;
    }
    setX(index, x) {
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        return this.data.array[index * this.data.stride + this.offset];
    }
    getY(index) {
        return this.data.array[index * this.data.stride + this.offset + 1];
    }
    getZ(index) {
        return this.data.array[index * this.data.stride + this.offset + 2];
    }
    getW(index) {
        return this.data.array[index * this.data.stride + this.offset + 3];
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $d5b33d7c30034067$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $d5b33d7c30034067$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // deinterleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribtue
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $d5b33d7c30034067$export$5ec7dd1c6994bf8e extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $d5b33d7c30034067$var$_geometry;
const $d5b33d7c30034067$var$_intersectPoint = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_worldScale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_mvPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_alignedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_rotatedPosition = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_viewWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_vA = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vB = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_vC = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_uvA = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvB = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
const $d5b33d7c30034067$var$_uvC = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$3075603db8e6204c extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.isSprite = true;
        this.type = 'Sprite';
        if ($d5b33d7c30034067$var$_geometry === undefined) {
            $d5b33d7c30034067$var$_geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $d5b33d7c30034067$export$3d5cd879f108f53f(float32Array, 5);
            $d5b33d7c30034067$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $d5b33d7c30034067$var$_geometry.setAttribute('position', new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $d5b33d7c30034067$var$_geometry.setAttribute('uv', new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $d5b33d7c30034067$var$_geometry;
        this.material = material !== undefined ? material : new $d5b33d7c30034067$export$5ec7dd1c6994bf8e();
        this.center = new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $d5b33d7c30034067$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $d5b33d7c30034067$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $d5b33d7c30034067$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $d5b33d7c30034067$var$_worldScale.multiplyScalar(-$d5b33d7c30034067$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vA.set(-0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(0.5, -0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vC.set(0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
        $d5b33d7c30034067$var$_uvA.set(0, 0);
        $d5b33d7c30034067$var$_uvB.set(1, 0);
        $d5b33d7c30034067$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, false, $d5b33d7c30034067$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $d5b33d7c30034067$var$transformVertex($d5b33d7c30034067$var$_vB.set(-0.5, 0.5, 0), $d5b33d7c30034067$var$_mvPosition, center, $d5b33d7c30034067$var$_worldScale, sin, cos);
            $d5b33d7c30034067$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_vB, false, $d5b33d7c30034067$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $d5b33d7c30034067$var$_intersectPoint.clone(),
            uv: $d5b33d7c30034067$export$5a465592bfe74b48.getUV($d5b33d7c30034067$var$_intersectPoint, $d5b33d7c30034067$var$_vA, $d5b33d7c30034067$var$_vB, $d5b33d7c30034067$var$_vC, $d5b33d7c30034067$var$_uvA, $d5b33d7c30034067$var$_uvB, $d5b33d7c30034067$var$_uvC, new $d5b33d7c30034067$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $d5b33d7c30034067$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $d5b33d7c30034067$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $d5b33d7c30034067$var$_rotatedPosition.x = cos * $d5b33d7c30034067$var$_alignedPosition.x - sin * $d5b33d7c30034067$var$_alignedPosition.y;
        $d5b33d7c30034067$var$_rotatedPosition.y = sin * $d5b33d7c30034067$var$_alignedPosition.x + cos * $d5b33d7c30034067$var$_alignedPosition.y;
    } else $d5b33d7c30034067$var$_rotatedPosition.copy($d5b33d7c30034067$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $d5b33d7c30034067$var$_rotatedPosition.x;
    vertexPosition.y += $d5b33d7c30034067$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($d5b33d7c30034067$var$_viewWorldMatrix);
}
const $d5b33d7c30034067$var$_v1$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$112e7237be0c5f30 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance < levels[i].distance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($d5b33d7c30034067$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $d5b33d7c30034067$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $d5b33d7c30034067$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $d5b33d7c30034067$var$_v1$2.distanceTo($d5b33d7c30034067$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance >= levels[i].distance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance
            });
        }
        return data;
    }
}
const $d5b33d7c30034067$var$_basePosition = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_skinIndex = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_skinWeight = /*@__PURE__*/ new $d5b33d7c30034067$export$fa7daccca11cdbe3();
const $d5b33d7c30034067$var$_vector$5 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_matrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$b303577035157ecf extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        this.bindMode = 'attached';
        this.bindMatrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $d5b33d7c30034067$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === 'attached') this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === 'detached') this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    boneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $d5b33d7c30034067$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $d5b33d7c30034067$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $d5b33d7c30034067$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $d5b33d7c30034067$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $d5b33d7c30034067$var$_skinIndex.getComponent(i);
                $d5b33d7c30034067$var$_matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($d5b33d7c30034067$var$_vector$5.copy($d5b33d7c30034067$var$_basePosition).applyMatrix4($d5b33d7c30034067$var$_matrix), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
class $d5b33d7c30034067$export$b127726e56765aa4 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = 'Bone';
    }
}
class $d5b33d7c30034067$export$b691f601014eabe1 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $d5b33d7c30034067$var$_offsetMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_identityMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $d5b33d7c30034067$var$_identityMatrix;
            $d5b33d7c30034067$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $d5b33d7c30034067$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $d5b33d7c30034067$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $d5b33d7c30034067$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $d5b33d7c30034067$export$b691f601014eabe1(boneMatrices, size, size, $d5b33d7c30034067$export$3f8bb04b555a363c, $d5b33d7c30034067$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $d5b33d7c30034067$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $d5b33d7c30034067$export$32ea87a8b54d744a extends $d5b33d7c30034067$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        if (typeof normalized === 'number') {
            meshPerAttribute = normalized;
            normalized = false;
            console.error('THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.');
        }
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $d5b33d7c30034067$var$_instanceLocalMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceWorldMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_instanceIntersects = [];
const $d5b33d7c30034067$var$_mesh = /*@__PURE__*/ new $d5b33d7c30034067$export$e176487c05830cc5();
class $d5b33d7c30034067$export$f3c979c331175ad7 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.frustumCulled = false;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $d5b33d7c30034067$var$_mesh.geometry = this.geometry;
        $d5b33d7c30034067$var$_mesh.material = this.material;
        if ($d5b33d7c30034067$var$_mesh.material === undefined) return;
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $d5b33d7c30034067$var$_instanceLocalMatrix);
            $d5b33d7c30034067$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $d5b33d7c30034067$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $d5b33d7c30034067$var$_mesh.matrixWorld = $d5b33d7c30034067$var$_instanceWorldMatrix;
            $d5b33d7c30034067$var$_mesh.raycast(raycaster, $d5b33d7c30034067$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $d5b33d7c30034067$var$_instanceIntersects.length; i < l; i++){
                const intersect = $d5b33d7c30034067$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $d5b33d7c30034067$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $d5b33d7c30034067$export$fbaaa33907730a0c extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_start$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_inverseMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
class $d5b33d7c30034067$export$17d680238e50603e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = 'Line';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $d5b33d7c30034067$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $d5b33d7c30034067$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $d5b33d7c30034067$var$_start$1.distanceTo($d5b33d7c30034067$var$_end$1);
            }
            geometry.setAttribute('lineDistance', new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere$1.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere$1.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere$1) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray$1.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vEnd = new $d5b33d7c30034067$export$64b5c384219d3699();
        const interSegment = new $d5b33d7c30034067$export$64b5c384219d3699();
        const interRay = new $d5b33d7c30034067$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $d5b33d7c30034067$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $d5b33d7c30034067$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $d5b33d7c30034067$var$_start = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_end = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$ff1ed10fedfdd604 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $d5b33d7c30034067$var$_start.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $d5b33d7c30034067$var$_start.distanceTo($d5b33d7c30034067$var$_end);
            }
            geometry.setAttribute('lineDistance', new $d5b33d7c30034067$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
class $d5b33d7c30034067$export$f85a24d745e4f17d extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
class $d5b33d7c30034067$export$a178c45366ce5d6b extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $d5b33d7c30034067$var$_inverseMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_ray = /*@__PURE__*/ new $d5b33d7c30034067$export$a186db52eed6d40e();
const $d5b33d7c30034067$var$_sphere = /*@__PURE__*/ new $d5b33d7c30034067$export$805e8b72413ccaba();
const $d5b33d7c30034067$var$_position$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$1c787534cb11aa3e extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(geometry = new $d5b33d7c30034067$export$b7be63a67df8959(), material = new $d5b33d7c30034067$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = 'Points';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $d5b33d7c30034067$var$_sphere.copy(geometry.boundingSphere);
        $d5b33d7c30034067$var$_sphere.applyMatrix4(matrixWorld);
        $d5b33d7c30034067$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($d5b33d7c30034067$var$_sphere) === false) return;
        //
        $d5b33d7c30034067$var$_inverseMatrix.copy(matrixWorld).invert();
        $d5b33d7c30034067$var$_ray.copy(raycaster.ray).applyMatrix4($d5b33d7c30034067$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $d5b33d7c30034067$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $d5b33d7c30034067$var$testPoint($d5b33d7c30034067$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $d5b33d7c30034067$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $d5b33d7c30034067$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $d5b33d7c30034067$export$64b5c384219d3699();
        $d5b33d7c30034067$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $d5b33d7c30034067$export$6e09d1edf8d5a25c extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$9270d786f73ce6fe extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(width, height, format){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.format = format;
        this.magFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.minFilter = $d5b33d7c30034067$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $d5b33d7c30034067$export$3466bac9141a5cc4 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $d5b33d7c30034067$export$f7189e49152d1c13 extends $d5b33d7c30034067$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $d5b33d7c30034067$export$c977b3e384af9ae1() : new $d5b33d7c30034067$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $d5b33d7c30034067$export$64b5c384219d3699();
        const mat = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $d5b33d7c30034067$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        binormals[0] = new $d5b33d7c30034067$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($d5b33d7c30034067$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($d5b33d7c30034067$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $d5b33d7c30034067$export$3f87a931616cde04 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $d5b33d7c30034067$export$b1eedc9aab6300e8 extends $d5b33d7c30034067$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $d5b33d7c30034067$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $d5b33d7c30034067$var$tmp = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$px = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$py = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
const $d5b33d7c30034067$var$pz = /*@__PURE__*/ new $d5b33d7c30034067$var$CubicPoly();
class $d5b33d7c30034067$export$b9146b27c24b744c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $d5b33d7c30034067$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $d5b33d7c30034067$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $d5b33d7c30034067$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $d5b33d7c30034067$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $d5b33d7c30034067$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $d5b33d7c30034067$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $d5b33d7c30034067$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $d5b33d7c30034067$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $d5b33d7c30034067$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $d5b33d7c30034067$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($d5b33d7c30034067$var$px.calc(weight), $d5b33d7c30034067$var$py.calc(weight), $d5b33d7c30034067$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $d5b33d7c30034067$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $d5b33d7c30034067$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $d5b33d7c30034067$var$QuadraticBezier(t, p0, p1, p2) {
    return $d5b33d7c30034067$var$QuadraticBezierP0(t, p0) + $d5b33d7c30034067$var$QuadraticBezierP1(t, p1) + $d5b33d7c30034067$var$QuadraticBezierP2(t, p2);
}
//
function $d5b33d7c30034067$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $d5b33d7c30034067$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $d5b33d7c30034067$var$CubicBezier(t, p0, p1, p2, p3) {
    return $d5b33d7c30034067$var$CubicBezierP0(t, p0) + $d5b33d7c30034067$var$CubicBezierP1(t, p1) + $d5b33d7c30034067$var$CubicBezierP2(t, p2) + $d5b33d7c30034067$var$CubicBezierP3(t, p3);
}
class $d5b33d7c30034067$export$e36650d36468bb39 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v3 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$13d5f1c9525f246c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699(), v3 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($d5b33d7c30034067$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $d5b33d7c30034067$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $d5b33d7c30034067$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $d5b33d7c30034067$export$ab2e07e76531a47e extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = 'LineCurve';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget) {
        const tangent = optionalTarget || new $d5b33d7c30034067$export$c977b3e384af9ae1();
        tangent.copy(this.v2).sub(this.v1).normalize();
        return tangent;
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$1fdfd9d9cf487600 extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$5938c4ee491a43ad extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v1 = new $d5b33d7c30034067$export$c977b3e384af9ae1(), v2 = new $d5b33d7c30034067$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$bf3f4c7e459f90fc extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $d5b33d7c30034067$export$64b5c384219d3699(), v1 = new $d5b33d7c30034067$export$64b5c384219d3699(), v2 = new $d5b33d7c30034067$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($d5b33d7c30034067$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $d5b33d7c30034067$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $d5b33d7c30034067$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $d5b33d7c30034067$export$d3bdd77da77afc1b extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = 'SplineCurve';
        this.points = points;
    }
    getPoint(t, optionalTarget = new $d5b33d7c30034067$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($d5b33d7c30034067$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $d5b33d7c30034067$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $d5b33d7c30034067$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $d5b33d7c30034067$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $d5b33d7c30034067$export$b9146b27c24b744c,
    CubicBezierCurve: $d5b33d7c30034067$export$e36650d36468bb39,
    CubicBezierCurve3: $d5b33d7c30034067$export$13d5f1c9525f246c,
    EllipseCurve: $d5b33d7c30034067$export$3f87a931616cde04,
    LineCurve: $d5b33d7c30034067$export$ab2e07e76531a47e,
    LineCurve3: $d5b33d7c30034067$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $d5b33d7c30034067$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $d5b33d7c30034067$export$bf3f4c7e459f90fc,
    SplineCurve: $d5b33d7c30034067$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $d5b33d7c30034067$export$4aaf9b66af1bbf2c extends $d5b33d7c30034067$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = 'CurvePath';
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $d5b33d7c30034067$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $d5b33d7c30034067$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $d5b33d7c30034067$export$4b2950bdac9b6ee9 extends $d5b33d7c30034067$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = 'Path';
        this.currentPoint = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $d5b33d7c30034067$export$ab2e07e76531a47e(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $d5b33d7c30034067$export$5938c4ee491a43ad(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCPx, aCPy), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $d5b33d7c30034067$export$e36650d36468bb39(this.currentPoint.clone(), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP1x, aCP1y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aCP2x, aCP2y), new $d5b33d7c30034067$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $d5b33d7c30034067$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $d5b33d7c30034067$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $d5b33d7c30034067$export$dc3e1273c1dd9240 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(points = [
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $d5b33d7c30034067$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const curNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const prevNormal = new $d5b33d7c30034067$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$dc3e1273c1dd9240(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $d5b33d7c30034067$export$f036d76f832848a extends $d5b33d7c30034067$export$dc3e1273c1dd9240 {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        this.parameters = {
            radius: radius,
            height: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$f036d76f832848a(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $d5b33d7c30034067$export$3f74fe60decf7462 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$3f74fe60decf7462(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$d4345c83207d7c68 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$d4345c83207d7c68(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$59d971120dc8b6e7 extends $d5b33d7c30034067$export$d4345c83207d7c68 {
    constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$59d971120dc8b6e7(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$38789b531813345c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivison with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $d5b33d7c30034067$export$64b5c384219d3699();
            const b = new $d5b33d7c30034067$export$64b5c384219d3699();
            const c = new $d5b33d7c30034067$export$64b5c384219d3699();
            const centroid = new $d5b33d7c30034067$export$64b5c384219d3699();
            const uvA = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvB = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            const uvC = new $d5b33d7c30034067$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$38789b531813345c(data.vertices, data.indices, data.radius, data.details);
    }
}
class $d5b33d7c30034067$export$37cd4e52cce48c4c extends $d5b33d7c30034067$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$37cd4e52cce48c4c(data.radius, data.detail);
    }
}
const $d5b33d7c30034067$var$_v0 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v1$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_normal = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_triangle = /*@__PURE__*/ new $d5b33d7c30034067$export$5a465592bfe74b48();
class $d5b33d7c30034067$export$4730b1542707547f extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($d5b33d7c30034067$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $d5b33d7c30034067$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $d5b33d7c30034067$var$_triangle.getNormal($d5b33d7c30034067$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $d5b33d7c30034067$var$_triangle[vertKeys[j]];
                    const v1 = $d5b33d7c30034067$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($d5b33d7c30034067$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $d5b33d7c30034067$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $d5b33d7c30034067$var$_v0.fromBufferAttribute(positionAttr, index0);
                $d5b33d7c30034067$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($d5b33d7c30034067$var$_v0.x, $d5b33d7c30034067$var$_v0.y, $d5b33d7c30034067$var$_v0.z);
                vertices.push($d5b33d7c30034067$var$_v1$1.x, $d5b33d7c30034067$var$_v1$1.y, $d5b33d7c30034067$var$_v1$1.z);
            }
            this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
class $d5b33d7c30034067$export$6428a7f2611ef1fa extends $d5b33d7c30034067$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        this.type = 'Shape';
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $d5b33d7c30034067$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ const $d5b33d7c30034067$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $d5b33d7c30034067$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        $d5b33d7c30034067$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $d5b33d7c30034067$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $d5b33d7c30034067$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $d5b33d7c30034067$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $d5b33d7c30034067$var$equals(last, last.next)) {
        $d5b33d7c30034067$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $d5b33d7c30034067$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($d5b33d7c30034067$var$equals(p, p.next) || $d5b33d7c30034067$var$area(p.prev, p, p.next) === 0)) {
            $d5b33d7c30034067$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $d5b33d7c30034067$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) : $d5b33d7c30034067$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $d5b33d7c30034067$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $d5b33d7c30034067$var$earcutLinked($d5b33d7c30034067$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $d5b33d7c30034067$var$cureLocalIntersections($d5b33d7c30034067$var$filterPoints(ear), triangles, dim);
                $d5b33d7c30034067$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $d5b33d7c30034067$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $d5b33d7c30034067$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    let p = ear.next.next;
    while(p !== ear.prev){
        if ($d5b33d7c30034067$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $d5b33d7c30034067$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($d5b33d7c30034067$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    const minZ = $d5b33d7c30034067$var$zOrder(minTX, minTY, minX, minY, invSize), maxZ = $d5b33d7c30034067$var$zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $d5b33d7c30034067$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && $d5b33d7c30034067$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $d5b33d7c30034067$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $d5b33d7c30034067$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && $d5b33d7c30034067$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $d5b33d7c30034067$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $d5b33d7c30034067$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$intersects(a, p, p.next, b) && $d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            $d5b33d7c30034067$var$removeNode(p);
            $d5b33d7c30034067$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $d5b33d7c30034067$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $d5b33d7c30034067$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $d5b33d7c30034067$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $d5b33d7c30034067$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $d5b33d7c30034067$var$filterPoints(a, a.next);
                c = $d5b33d7c30034067$var$filterPoints(c, c.next);
                // run earcut on each half
                $d5b33d7c30034067$var$earcutLinked(a, triangles, dim, minX, minY, invSize);
                $d5b33d7c30034067$var$earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $d5b33d7c30034067$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $d5b33d7c30034067$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($d5b33d7c30034067$var$getLeftmost(list));
    }
    queue.sort($d5b33d7c30034067$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        $d5b33d7c30034067$var$eliminateHole(queue[i], outerNode);
        outerNode = $d5b33d7c30034067$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $d5b33d7c30034067$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $d5b33d7c30034067$var$eliminateHole(hole, outerNode) {
    outerNode = $d5b33d7c30034067$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = $d5b33d7c30034067$var$splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        $d5b33d7c30034067$var$filterPoints(outerNode, outerNode.next);
        $d5b33d7c30034067$var$filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $d5b33d7c30034067$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $d5b33d7c30034067$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($d5b33d7c30034067$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $d5b33d7c30034067$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $d5b33d7c30034067$var$sectorContainsSector(m, p) {
    return $d5b33d7c30034067$var$area(m.prev, m, p.prev) < 0 && $d5b33d7c30034067$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $d5b33d7c30034067$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = $d5b33d7c30034067$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $d5b33d7c30034067$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $d5b33d7c30034067$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $d5b33d7c30034067$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $d5b33d7c30034067$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $d5b33d7c30034067$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $d5b33d7c30034067$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$d5b33d7c30034067$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($d5b33d7c30034067$var$locallyInside(a, b) && $d5b33d7c30034067$var$locallyInside(b, a) && $d5b33d7c30034067$var$middleInside(a, b) && // locally visible
    ($d5b33d7c30034067$var$area(a.prev, a, b.prev) || $d5b33d7c30034067$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $d5b33d7c30034067$var$equals(a, b) && $d5b33d7c30034067$var$area(a.prev, a, a.next) > 0 && $d5b33d7c30034067$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $d5b33d7c30034067$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $d5b33d7c30034067$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $d5b33d7c30034067$var$intersects(p1, q1, p2, q2) {
    const o1 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, p2));
    const o2 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p1, q1, q2));
    const o3 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, p1));
    const o4 = $d5b33d7c30034067$var$sign($d5b33d7c30034067$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $d5b33d7c30034067$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $d5b33d7c30034067$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $d5b33d7c30034067$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $d5b33d7c30034067$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $d5b33d7c30034067$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $d5b33d7c30034067$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $d5b33d7c30034067$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $d5b33d7c30034067$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $d5b33d7c30034067$var$locallyInside(a, b) {
    return $d5b33d7c30034067$var$area(a.prev, a, a.next) < 0 ? $d5b33d7c30034067$var$area(a, b, a.next) >= 0 && $d5b33d7c30034067$var$area(a, a.prev, b) >= 0 : $d5b33d7c30034067$var$area(a, b, a.prev) < 0 || $d5b33d7c30034067$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $d5b33d7c30034067$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $d5b33d7c30034067$var$splitPolygon(a, b) {
    const a2 = new $d5b33d7c30034067$var$Node(a.i, a.x, a.y), b2 = new $d5b33d7c30034067$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $d5b33d7c30034067$var$insertNode(i, x, y, last) {
    const p = new $d5b33d7c30034067$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $d5b33d7c30034067$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $d5b33d7c30034067$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $d5b33d7c30034067$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $d5b33d7c30034067$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $d5b33d7c30034067$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $d5b33d7c30034067$var$removeDupEndPts(contour);
        $d5b33d7c30034067$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($d5b33d7c30034067$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $d5b33d7c30034067$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $d5b33d7c30034067$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $d5b33d7c30034067$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $d5b33d7c30034067$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $d5b33d7c30034067$export$91836d01b9f75a58 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $d5b33d7c30034067$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $d5b33d7c30034067$export$64b5c384219d3699();
                normal = new $d5b33d7c30034067$export$64b5c384219d3699();
                position2 = new $d5b33d7c30034067$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return vec.clone().multiplyScalar(size).add(pt);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $d5b33d7c30034067$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $d5b33d7c30034067$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $d5b33d7c30034067$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $d5b33d7c30034067$export$91836d01b9f75a58(geometryShapes, data.options);
    }
}
const $d5b33d7c30034067$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, a_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, b_y),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $d5b33d7c30034067$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $d5b33d7c30034067$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $d5b33d7c30034067$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $d5b33d7c30034067$export$731fd4feef063ea2 extends $d5b33d7c30034067$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$731fd4feef063ea2(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$8e05fc91596f4752 extends $d5b33d7c30034067$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$8e05fc91596f4752(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$ee8b85b34b7d9cad extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$ee8b85b34b7d9cad(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$233afc324766bed8 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(shapes = new $d5b33d7c30034067$export$6428a7f2611ef1fa([
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0, 0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(-0.5, -0.5),
        new $d5b33d7c30034067$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $d5b33d7c30034067$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $d5b33d7c30034067$export$233afc324766bed8(geometryShapes, data.curveSegments);
    }
}
function $d5b33d7c30034067$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $d5b33d7c30034067$export$d5d06a966fec4192 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$d5d06a966fec4192(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $d5b33d7c30034067$export$369e08f62a796c65 extends $d5b33d7c30034067$export$38789b531813345c {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$369e08f62a796c65(data.radius, data.detail);
    }
}
class $d5b33d7c30034067$export$19d55f905fa4f2cb extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $d5b33d7c30034067$export$64b5c384219d3699();
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$19d55f905fa4f2cb(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $d5b33d7c30034067$export$2b32466f4274fe5c extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P1 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const P2 = new $d5b33d7c30034067$export$64b5c384219d3699();
        const B = new $d5b33d7c30034067$export$64b5c384219d3699();
        const T = new $d5b33d7c30034067$export$64b5c384219d3699();
        const N = new $d5b33d7c30034067$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    static fromJSON(data) {
        return new $d5b33d7c30034067$export$2b32466f4274fe5c(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $d5b33d7c30034067$export$d97a193ce44e691b extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(path = new $d5b33d7c30034067$export$bf3f4c7e459f90fc(new $d5b33d7c30034067$export$64b5c384219d3699(-1, -1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(-1, 1, 0), new $d5b33d7c30034067$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $d5b33d7c30034067$export$64b5c384219d3699();
        const normal = new $d5b33d7c30034067$export$64b5c384219d3699();
        const uv = new $d5b33d7c30034067$export$c977b3e384af9ae1();
        let P = new $d5b33d7c30034067$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $d5b33d7c30034067$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $d5b33d7c30034067$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $d5b33d7c30034067$export$d97a193ce44e691b(new $d5b33d7c30034067$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $d5b33d7c30034067$export$4b739da06d24892b extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $d5b33d7c30034067$export$64b5c384219d3699();
            const end = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($d5b33d7c30034067$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
function $d5b33d7c30034067$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $d5b33d7c30034067$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $d5b33d7c30034067$export$ab3456a079aa7d80,
    BoxBufferGeometry: $d5b33d7c30034067$export$ab3456a079aa7d80,
    CapsuleGeometry: $d5b33d7c30034067$export$f036d76f832848a,
    CapsuleBufferGeometry: $d5b33d7c30034067$export$f036d76f832848a,
    CircleGeometry: $d5b33d7c30034067$export$3f74fe60decf7462,
    CircleBufferGeometry: $d5b33d7c30034067$export$3f74fe60decf7462,
    ConeGeometry: $d5b33d7c30034067$export$59d971120dc8b6e7,
    ConeBufferGeometry: $d5b33d7c30034067$export$59d971120dc8b6e7,
    CylinderGeometry: $d5b33d7c30034067$export$d4345c83207d7c68,
    CylinderBufferGeometry: $d5b33d7c30034067$export$d4345c83207d7c68,
    DodecahedronGeometry: $d5b33d7c30034067$export$37cd4e52cce48c4c,
    DodecahedronBufferGeometry: $d5b33d7c30034067$export$37cd4e52cce48c4c,
    EdgesGeometry: $d5b33d7c30034067$export$4730b1542707547f,
    ExtrudeGeometry: $d5b33d7c30034067$export$91836d01b9f75a58,
    ExtrudeBufferGeometry: $d5b33d7c30034067$export$91836d01b9f75a58,
    IcosahedronGeometry: $d5b33d7c30034067$export$731fd4feef063ea2,
    IcosahedronBufferGeometry: $d5b33d7c30034067$export$731fd4feef063ea2,
    LatheGeometry: $d5b33d7c30034067$export$dc3e1273c1dd9240,
    LatheBufferGeometry: $d5b33d7c30034067$export$dc3e1273c1dd9240,
    OctahedronGeometry: $d5b33d7c30034067$export$8e05fc91596f4752,
    OctahedronBufferGeometry: $d5b33d7c30034067$export$8e05fc91596f4752,
    PlaneGeometry: $d5b33d7c30034067$export$e789a11a194ca4e0,
    PlaneBufferGeometry: $d5b33d7c30034067$export$e789a11a194ca4e0,
    PolyhedronGeometry: $d5b33d7c30034067$export$38789b531813345c,
    PolyhedronBufferGeometry: $d5b33d7c30034067$export$38789b531813345c,
    RingGeometry: $d5b33d7c30034067$export$ee8b85b34b7d9cad,
    RingBufferGeometry: $d5b33d7c30034067$export$ee8b85b34b7d9cad,
    ShapeGeometry: $d5b33d7c30034067$export$233afc324766bed8,
    ShapeBufferGeometry: $d5b33d7c30034067$export$233afc324766bed8,
    SphereGeometry: $d5b33d7c30034067$export$d5d06a966fec4192,
    SphereBufferGeometry: $d5b33d7c30034067$export$d5d06a966fec4192,
    TetrahedronGeometry: $d5b33d7c30034067$export$369e08f62a796c65,
    TetrahedronBufferGeometry: $d5b33d7c30034067$export$369e08f62a796c65,
    TorusGeometry: $d5b33d7c30034067$export$19d55f905fa4f2cb,
    TorusBufferGeometry: $d5b33d7c30034067$export$19d55f905fa4f2cb,
    TorusKnotGeometry: $d5b33d7c30034067$export$2b32466f4274fe5c,
    TorusKnotBufferGeometry: $d5b33d7c30034067$export$2b32466f4274fe5c,
    TubeGeometry: $d5b33d7c30034067$export$d97a193ce44e691b,
    TubeBufferGeometry: $d5b33d7c30034067$export$d97a193ce44e691b,
    WireframeGeometry: $d5b33d7c30034067$export$4b739da06d24892b
});
class $d5b33d7c30034067$export$e8564da406055a3 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$21c421a2e1df9d22 extends $d5b33d7c30034067$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
class $d5b33d7c30034067$export$f2980790215acccd extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            'STANDARD': ''
        };
        this.type = 'MeshStandardMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$28d04986c4269c9f extends $d5b33d7c30034067$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $d5b33d7c30034067$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = 0.0;
        this.attenuationColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $d5b33d7c30034067$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._sheen = 0.0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $d5b33d7c30034067$export$24c72f71cbaf0678 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $d5b33d7c30034067$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$df893cf97e765622 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$bfe8c0a091f41ae7 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $d5b33d7c30034067$export$5023a9a8114806b8 extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $d5b33d7c30034067$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $d5b33d7c30034067$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$6f5fef6235ec12ee extends $d5b33d7c30034067$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $d5b33d7c30034067$export$2852a58ebdac27b8;
        this.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $d5b33d7c30034067$export$327886a3efaeaebe extends $d5b33d7c30034067$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// same as Array.prototype.slice, but also works on typed arrays
function $d5b33d7c30034067$var$arraySlice(array, from, to) {
    if ($d5b33d7c30034067$var$isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
    // but array.subarray(from) or array.subarray(from, len) is correct
    return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
    return array.slice(from, to);
}
// converts an array to a specific type
function $d5b33d7c30034067$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $d5b33d7c30034067$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $d5b33d7c30034067$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $d5b33d7c30034067$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $d5b33d7c30034067$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $d5b33d7c30034067$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $d5b33d7c30034067$var$convertArray(times, track.times.constructor);
        track.values = $d5b33d7c30034067$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $d5b33d7c30034067$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = $d5b33d7c30034067$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = $d5b33d7c30034067$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = $d5b33d7c30034067$var$arraySlice(interpolant.resultBuffer, startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $d5b33d7c30034067$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $d5b33d7c30034067$export$d875e029ef558d3;
    return targetClip;
}
var $d5b33d7c30034067$export$7ee8caa573e71ad1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    arraySlice: $d5b33d7c30034067$var$arraySlice,
    convertArray: $d5b33d7c30034067$var$convertArray,
    isTypedArray: $d5b33d7c30034067$var$isTypedArray,
    getKeyframeOrder: $d5b33d7c30034067$var$getKeyframeOrder,
    sortedArray: $d5b33d7c30034067$var$sortedArray,
    flattenJSON: $d5b33d7c30034067$var$flattenJSON,
    subclip: $d5b33d7c30034067$var$subclip,
    makeClipAdditive: $d5b33d7c30034067$var$makeClipAdditive
});
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $d5b33d7c30034067$export$3646682e7a3959 extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $d5b33d7c30034067$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $d5b33d7c30034067$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $d5b33d7c30034067$export$a8e6009059f51e1a extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $d5b33d7c30034067$export$fb9758ef7ef8d5cc extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $d5b33d7c30034067$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $d5b33d7c30034067$var$convertArray(times, this.TimeBufferType);
        this.values = $d5b33d7c30034067$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $d5b33d7c30034067$var$convertArray(track.times, Array),
                'values': $d5b33d7c30034067$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $d5b33d7c30034067$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $d5b33d7c30034067$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $d5b33d7c30034067$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $d5b33d7c30034067$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $d5b33d7c30034067$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $d5b33d7c30034067$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $d5b33d7c30034067$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $d5b33d7c30034067$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $d5b33d7c30034067$var$arraySlice(times, from, to);
            this.values = $d5b33d7c30034067$var$arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($d5b33d7c30034067$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $d5b33d7c30034067$var$arraySlice(this.times), values = $d5b33d7c30034067$var$arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $d5b33d7c30034067$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $d5b33d7c30034067$var$arraySlice(times, 0, writeIndex);
            this.values = $d5b33d7c30034067$var$arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $d5b33d7c30034067$var$arraySlice(this.times, 0);
        const values = $d5b33d7c30034067$var$arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$d5b33d7c30034067$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $d5b33d7c30034067$export$d3a344b98cf0b775 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $d5b33d7c30034067$export$83444c5d885347d8 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $d5b33d7c30034067$export$d45f0d1a4d9a9314 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ class $d5b33d7c30034067$export$2db1cfb7923d931e extends $d5b33d7c30034067$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $d5b33d7c30034067$export$b8043f12b5aafbd7 extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $d5b33d7c30034067$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $d5b33d7c30034067$export$30fac1aace31cf4d;
$d5b33d7c30034067$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $d5b33d7c30034067$export$6ce41d4f3a8df9cd extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $d5b33d7c30034067$export$995b32462a65e855;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$d5b33d7c30034067$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $d5b33d7c30034067$export$5ce2dcb4cc9f2bff extends $d5b33d7c30034067$export$b0e479f45b7006d6 {
}
$d5b33d7c30034067$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $d5b33d7c30034067$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($d5b33d7c30034067$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $d5b33d7c30034067$var$getKeyframeOrder(times);
            times = $d5b33d7c30034067$var$sortedArray(times, 1, order);
            values = $d5b33d7c30034067$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $d5b33d7c30034067$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $d5b33d7c30034067$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($d5b33d7c30034067$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($d5b33d7c30034067$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $d5b33d7c30034067$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $d5b33d7c30034067$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $d5b33d7c30034067$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $d5b33d7c30034067$export$83444c5d885347d8;
        case 'quaternion':
            return $d5b33d7c30034067$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $d5b33d7c30034067$export$d3a344b98cf0b775;
        case 'string':
            return $d5b33d7c30034067$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $d5b33d7c30034067$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $d5b33d7c30034067$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $d5b33d7c30034067$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $d5b33d7c30034067$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $d5b33d7c30034067$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $d5b33d7c30034067$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $d5b33d7c30034067$export$99cc795e99919eed();
class $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $d5b33d7c30034067$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $d5b33d7c30034067$var$loading = {};
class $d5b33d7c30034067$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $d5b33d7c30034067$export$98435a25b5cf7b2b extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($d5b33d7c30034067$var$loading[url] !== undefined) {
            $d5b33d7c30034067$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $d5b33d7c30034067$var$loading[url] = [];
        $d5b33d7c30034067$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $d5b33d7c30034067$var$loading[url];
                const reader = response.body.getReader();
                const contentLength = response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $d5b33d7c30034067$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, data);
            const callbacks = $d5b33d7c30034067$var$loading[url];
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $d5b33d7c30034067$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $d5b33d7c30034067$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $d5b33d7c30034067$export$29711c7e14f61db extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$bd73ce947a280350 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $d5b33d7c30034067$export$3466bac9141a5cc4();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$8905ce1c7a2464a1 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $d5b33d7c30034067$var$createElementNS('img');
        function onImageLoad() {
            removeEventListeners();
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $d5b33d7c30034067$export$2ec114afc2cf6308 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $d5b33d7c30034067$export$792d8a18f2c55855 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $d5b33d7c30034067$export$b691f601014eabe1();
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $d5b33d7c30034067$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $d5b33d7c30034067$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $d5b33d7c30034067$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $d5b33d7c30034067$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$fd1bfc71f64c538c extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $d5b33d7c30034067$export$5431306cf43de24a();
        const loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $d5b33d7c30034067$export$6ecadb6ed240d696 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = 'Light';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $d5b33d7c30034067$export$8d474f55edbb9624 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.groundColor = new $d5b33d7c30034067$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $d5b33d7c30034067$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $d5b33d7c30034067$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $d5b33d7c30034067$export$35efe6f4c85463d2();
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $d5b33d7c30034067$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($d5b33d7c30034067$var$_lightPositionWorld$1);
        $d5b33d7c30034067$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($d5b33d7c30034067$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $d5b33d7c30034067$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(shadowCamera.projectionMatrix);
        shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $d5b33d7c30034067$var$SpotLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $d5b33d7c30034067$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $d5b33d7c30034067$export$81495cbb73897362 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 1){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $d5b33d7c30034067$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $d5b33d7c30034067$var$_projScreenMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_lightPositionWorld = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_lookTarget = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$var$PointLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $d5b33d7c30034067$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $d5b33d7c30034067$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $d5b33d7c30034067$export$64b5c384219d3699(1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(-1, 0, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 1, 0),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1),
            new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $d5b33d7c30034067$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($d5b33d7c30034067$var$_lightPositionWorld);
        $d5b33d7c30034067$var$_lookTarget.copy(camera.position);
        $d5b33d7c30034067$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($d5b33d7c30034067$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$d5b33d7c30034067$var$_lightPositionWorld.x, -$d5b33d7c30034067$var$_lightPositionWorld.y, -$d5b33d7c30034067$var$_lightPositionWorld.z);
        $d5b33d7c30034067$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($d5b33d7c30034067$var$_projScreenMatrix);
    }
}
class $d5b33d7c30034067$export$4c9c1cb3f0b6f455 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 1){
        super(color, intensity);
        this.isPointLight = true;
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $d5b33d7c30034067$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$var$DirectionalLightShadow extends $d5b33d7c30034067$var$LightShadow {
    constructor(){
        super(new $d5b33d7c30034067$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $d5b33d7c30034067$export$3fea33cc9972c868 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($d5b33d7c30034067$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        this.shadow = new $d5b33d7c30034067$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $d5b33d7c30034067$export$af279bfef9ec2c96 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
class $d5b33d7c30034067$export$61db2d908bbd2429 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $d5b33d7c30034067$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $d5b33d7c30034067$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $d5b33d7c30034067$export$e7ef036e309b38d2 extends $d5b33d7c30034067$export$6ecadb6ed240d696 {
    constructor(sh = new $d5b33d7c30034067$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $d5b33d7c30034067$export$3bd6d323353dcf96 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = $d5b33d7c30034067$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $d5b33d7c30034067$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // Deprecated
        if (json.shading !== undefined) material.flatShading = json.shading === 1; // THREE.FlatShading
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $d5b33d7c30034067$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $d5b33d7c30034067$export$e8564da406055a3,
            SpriteMaterial: $d5b33d7c30034067$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $d5b33d7c30034067$export$21c421a2e1df9d22,
            ShaderMaterial: $d5b33d7c30034067$export$83c7d75d550a8b0d,
            PointsMaterial: $d5b33d7c30034067$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $d5b33d7c30034067$export$28d04986c4269c9f,
            MeshStandardMaterial: $d5b33d7c30034067$export$f2980790215acccd,
            MeshPhongMaterial: $d5b33d7c30034067$export$24c72f71cbaf0678,
            MeshToonMaterial: $d5b33d7c30034067$export$df893cf97e765622,
            MeshNormalMaterial: $d5b33d7c30034067$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $d5b33d7c30034067$export$5023a9a8114806b8,
            MeshDepthMaterial: $d5b33d7c30034067$export$2698c22ec13825db,
            MeshDistanceMaterial: $d5b33d7c30034067$export$33e187ed002f2a19,
            MeshBasicMaterial: $d5b33d7c30034067$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $d5b33d7c30034067$export$6f5fef6235ec12ee,
            LineDashedMaterial: $d5b33d7c30034067$export$327886a3efaeaebe,
            LineBasicMaterial: $d5b33d7c30034067$export$fbaaa33907730a0c,
            Material: $d5b33d7c30034067$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $d5b33d7c30034067$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $d5b33d7c30034067$export$231f009cbe414146 extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const data = super.toJSON(this);
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $d5b33d7c30034067$export$dc275bb96327833a extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $d5b33d7c30034067$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $d5b33d7c30034067$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $d5b33d7c30034067$export$231f009cbe414146() : new $d5b33d7c30034067$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $d5b33d7c30034067$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $d5b33d7c30034067$export$32ea87a8b54d744a : $d5b33d7c30034067$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $d5b33d7c30034067$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $d5b33d7c30034067$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $d5b33d7c30034067$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $d5b33d7c30034067$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $d5b33d7c30034067$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $d5b33d7c30034067$export$40110c8505c5ad19 extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $d5b33d7c30034067$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $d5b33d7c30034067$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $d5b33d7c30034067$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $d5b33d7c30034067$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    case 'Geometry':
                        console.error('THREE.ObjectLoader: The legacy Geometry type is no longer supported.');
                        break;
                    default:
                        if (data.type in $d5b33d7c30034067$var$Geometries) geometry = $d5b33d7c30034067$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $d5b33d7c30034067$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (data.type === 'MultiMaterial') {
                    // Deprecated
                    const array = [];
                    for(let j = 0; j < data.materials.length; j++){
                        const material = data.materials[j];
                        if (cache[material.uuid] === undefined) cache[material.uuid] = loader.parse(material);
                        array.push(cache[material.uuid]);
                    }
                    materials[data.uuid] = array;
                } else {
                    if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                    materials[data.uuid] = cache[data.uuid];
                }
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $d5b33d7c30034067$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $d5b33d7c30034067$export$99cc795e99919eed(onLoad);
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $d5b33d7c30034067$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $d5b33d7c30034067$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $d5b33d7c30034067$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $d5b33d7c30034067$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $d5b33d7c30034067$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $d5b33d7c30034067$export$b691f601014eabe1();
                else texture = new $d5b33d7c30034067$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $d5b33d7c30034067$var$TEXTURE_MAPPING);
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $d5b33d7c30034067$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $d5b33d7c30034067$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $d5b33d7c30034067$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $d5b33d7c30034067$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $d5b33d7c30034067$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $d5b33d7c30034067$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                break;
            case 'PerspectiveCamera':
                object = new $d5b33d7c30034067$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $d5b33d7c30034067$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $d5b33d7c30034067$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $d5b33d7c30034067$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case 'PointLight':
                object = new $d5b33d7c30034067$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $d5b33d7c30034067$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $d5b33d7c30034067$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case 'HemisphereLight':
                object = new $d5b33d7c30034067$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $d5b33d7c30034067$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $d5b33d7c30034067$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $d5b33d7c30034067$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $d5b33d7c30034067$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'LOD':
                object = new $d5b33d7c30034067$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $d5b33d7c30034067$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $d5b33d7c30034067$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $d5b33d7c30034067$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $d5b33d7c30034067$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $d5b33d7c30034067$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $d5b33d7c30034067$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $d5b33d7c30034067$export$b127726e56765aa4();
                break;
            default:
                object = new $d5b33d7c30034067$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $d5b33d7c30034067$var$TEXTURE_MAPPING = {
    UVMapping: $d5b33d7c30034067$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $d5b33d7c30034067$export$8759762a6477f2c4,
    CubeRefractionMapping: $d5b33d7c30034067$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $d5b33d7c30034067$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $d5b33d7c30034067$export$ee99d97d46898098,
    CubeUVReflectionMapping: $d5b33d7c30034067$export$dbf3e70ff37af79
};
const $d5b33d7c30034067$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $d5b33d7c30034067$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $d5b33d7c30034067$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $d5b33d7c30034067$export$c7e7c00b14f51a4f
};
const $d5b33d7c30034067$var$TEXTURE_FILTER = {
    NearestFilter: $d5b33d7c30034067$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $d5b33d7c30034067$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $d5b33d7c30034067$export$d2327c1afe5bfdf2,
    LinearFilter: $d5b33d7c30034067$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $d5b33d7c30034067$export$19a719f377145a13,
    LinearMipmapLinearFilter: $d5b33d7c30034067$export$5d8599b6a933fb1b
};
class $d5b33d7c30034067$export$52286b55c4a9b51f extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $d5b33d7c30034067$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $d5b33d7c30034067$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $d5b33d7c30034067$var$_context;
const $d5b33d7c30034067$export$fcbc63750ec2a81f = {
    getContext: function() {
        if ($d5b33d7c30034067$var$_context === undefined) $d5b33d7c30034067$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $d5b33d7c30034067$var$_context;
    },
    setContext: function(value) {
        $d5b33d7c30034067$var$_context = value;
    }
};
class $d5b33d7c30034067$export$d8d5fccfbf47714e extends $d5b33d7c30034067$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $d5b33d7c30034067$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
}
class $d5b33d7c30034067$export$2f22dadc8bc42820 extends $d5b33d7c30034067$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e().set(skyColor);
        const color2 = new $d5b33d7c30034067$export$892596cec99bc70e().set(groundColor);
        const sky = new $d5b33d7c30034067$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $d5b33d7c30034067$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $d5b33d7c30034067$export$afe310a21c86023d extends $d5b33d7c30034067$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $d5b33d7c30034067$var$_eyeRight = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_eyeLeft = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_projectionMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$bc7f73a1065bee0c {
    constructor(){
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $d5b33d7c30034067$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $d5b33d7c30034067$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($d5b33d7c30034067$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $d5b33d7c30034067$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $d5b33d7c30034067$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $d5b33d7c30034067$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $d5b33d7c30034067$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($d5b33d7c30034067$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($d5b33d7c30034067$var$_eyeRight);
    }
}
class $d5b33d7c30034067$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $d5b33d7c30034067$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $d5b33d7c30034067$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $d5b33d7c30034067$var$now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
const $d5b33d7c30034067$var$_position$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$8a1b810c6fde8951 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = $d5b33d7c30034067$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $d5b33d7c30034067$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position$1, $d5b33d7c30034067$var$_quaternion$1, $d5b33d7c30034067$var$_scale$1);
        $d5b33d7c30034067$var$_orientation$1.set(0, 0, -1).applyQuaternion($d5b33d7c30034067$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($d5b33d7c30034067$var$_position$1.x, $d5b33d7c30034067$var$_position$1.y, $d5b33d7c30034067$var$_position$1.z);
            listener.setOrientation($d5b33d7c30034067$var$_orientation$1.x, $d5b33d7c30034067$var$_orientation$1.y, $d5b33d7c30034067$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $d5b33d7c30034067$export$153755f98d9861de extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        this.source.stop();
        this.source.onended = null;
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $d5b33d7c30034067$var$_position = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_quaternion = /*@__PURE__*/ new $d5b33d7c30034067$export$23d6a54f0bbc85a3();
const $d5b33d7c30034067$var$_scale = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_orientation = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b3e397ef1832507 extends $d5b33d7c30034067$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($d5b33d7c30034067$var$_position, $d5b33d7c30034067$var$_quaternion, $d5b33d7c30034067$var$_scale);
        $d5b33d7c30034067$var$_orientation.set(0, 0, 1).applyQuaternion($d5b33d7c30034067$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($d5b33d7c30034067$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($d5b33d7c30034067$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($d5b33d7c30034067$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($d5b33d7c30034067$var$_orientation.z, endTime);
        } else {
            panner.setPosition($d5b33d7c30034067$var$_position.x, $d5b33d7c30034067$var$_position.y, $d5b33d7c30034067$var$_position.z);
            panner.setOrientation($d5b33d7c30034067$var$_orientation.x, $d5b33d7c30034067$var$_orientation.y, $d5b33d7c30034067$var$_orientation.z);
        }
    }
}
class $d5b33d7c30034067$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $d5b33d7c30034067$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $d5b33d7c30034067$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $d5b33d7c30034067$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $d5b33d7c30034067$var$_reservedRe = new RegExp('[' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $d5b33d7c30034067$var$_wordChar = '[^' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE + ']';
const $d5b33d7c30034067$var$_wordCharOrDot = '[^' + $d5b33d7c30034067$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $d5b33d7c30034067$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $d5b33d7c30034067$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $d5b33d7c30034067$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $d5b33d7c30034067$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $d5b33d7c30034067$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $d5b33d7c30034067$var$_wordChar);
const $d5b33d7c30034067$var$_trackRe = new RegExp("^" + $d5b33d7c30034067$var$_directoryRe + $d5b33d7c30034067$var$_nodeRe + $d5b33d7c30034067$var$_objectRe + $d5b33d7c30034067$var$_propertyRe + '$');
const $d5b33d7c30034067$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones'
];
class $d5b33d7c30034067$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $d5b33d7c30034067$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $d5b33d7c30034067$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $d5b33d7c30034067$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $d5b33d7c30034067$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($d5b33d7c30034067$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $d5b33d7c30034067$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($d5b33d7c30034067$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $d5b33d7c30034067$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error('THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$d5b33d7c30034067$export$7bf70fcf9f891893.Composite = $d5b33d7c30034067$var$Composite;
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_direct,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_array,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$d5b33d7c30034067$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $d5b33d7c30034067$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $d5b33d7c30034067$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $d5b33d7c30034067$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $d5b33d7c30034067$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $d5b33d7c30034067$var$AnimationAction {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $d5b33d7c30034067$export$7f795934b84ab523,
            endingEnd: $d5b33d7c30034067$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $d5b33d7c30034067$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) return; // yet to come / don't decide when delta = 0
            // start
            this._startTime = null; // unschedule
            deltaTime = timeDirection * timeRunning;
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $d5b33d7c30034067$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $d5b33d7c30034067$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $d5b33d7c30034067$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $d5b33d7c30034067$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $d5b33d7c30034067$export$24a4ccb5099273b5;
            settings.endingEnd = $d5b33d7c30034067$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingStart = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $d5b33d7c30034067$export$24a4ccb5099273b5 : $d5b33d7c30034067$export$7f795934b84ab523;
            else settings.endingEnd = $d5b33d7c30034067$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $d5b33d7c30034067$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $d5b33d7c30034067$export$fbd77e5aefaa0102 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $d5b33d7c30034067$export$dfe0af1ca1acb78a($d5b33d7c30034067$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $d5b33d7c30034067$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $d5b33d7c30034067$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $d5b33d7c30034067$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $d5b33d7c30034067$var$AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $d5b33d7c30034067$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $d5b33d7c30034067$export$2947cebfe91c02f8 {
    constructor(value){
        if (typeof value === 'string') {
            console.warn('THREE.Uniform: Type parameter is no longer needed.');
            value = arguments[1];
        }
        this.value = value;
    }
    clone() {
        return new $d5b33d7c30034067$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $d5b33d7c30034067$var$id = 0;
class $d5b33d7c30034067$export$c412d5ffe1f79209 extends $d5b33d7c30034067$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, 'id', {
            value: $d5b33d7c30034067$var$id++
        });
        this.name = '';
        this.usage = $d5b33d7c30034067$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $d5b33d7c30034067$export$25ec0e1af1389358 extends $d5b33d7c30034067$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $d5b33d7c30034067$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $d5b33d7c30034067$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $d5b33d7c30034067$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $d5b33d7c30034067$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $d5b33d7c30034067$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$d5b33d7c30034067$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($d5b33d7c30034067$var$ascSort);
        return intersects;
    }
}
function $d5b33d7c30034067$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $d5b33d7c30034067$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$d5b33d7c30034067$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $d5b33d7c30034067$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($d5b33d7c30034067$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $d5b33d7c30034067$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$4 = /*@__PURE__*/ new $d5b33d7c30034067$export$c977b3e384af9ae1();
class $d5b33d7c30034067$export$60f553fa130f08b0 {
    constructor(min = new $d5b33d7c30034067$export$c977b3e384af9ae1(Infinity, Infinity), max = new $d5b33d7c30034067$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $d5b33d7c30034067$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $d5b33d7c30034067$var$_vector$4.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $d5b33d7c30034067$var$_startP = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_startEnd = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$e0ba6359f1954fd3 {
    constructor(start = new $d5b33d7c30034067$export$64b5c384219d3699(), end = new $d5b33d7c30034067$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $d5b33d7c30034067$var$_startP.subVectors(point, this.start);
        $d5b33d7c30034067$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startEnd);
        const startEnd_startP = $d5b33d7c30034067$var$_startEnd.dot($d5b33d7c30034067$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $d5b33d7c30034067$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $d5b33d7c30034067$var$_vector$3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$4b14638ffdd81e68 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $d5b33d7c30034067$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateMatrixWorld();
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $d5b33d7c30034067$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($d5b33d7c30034067$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $d5b33d7c30034067$var$_vector$2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_boneMatrix = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
const $d5b33d7c30034067$var$_matrixWorldInv = /*@__PURE__*/ new $d5b33d7c30034067$export$2ae72fc923e5eb5();
class $d5b33d7c30034067$export$5277df3c9e732259 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $d5b33d7c30034067$var$getBoneList(object);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $d5b33d7c30034067$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $d5b33d7c30034067$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                $d5b33d7c30034067$var$_boneMatrix.multiplyMatrices($d5b33d7c30034067$var$_matrixWorldInv, bone.parent.matrixWorld);
                $d5b33d7c30034067$var$_vector$2.setFromMatrixPosition($d5b33d7c30034067$var$_boneMatrix);
                position.setXYZ(j + 1, $d5b33d7c30034067$var$_vector$2.x, $d5b33d7c30034067$var$_vector$2.y, $d5b33d7c30034067$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
}
function $d5b33d7c30034067$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $d5b33d7c30034067$var$getBoneList(object.children[i]));
    return boneList;
}
class $d5b33d7c30034067$export$9a9291685b9e4023 extends $d5b33d7c30034067$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $d5b33d7c30034067$export$d5d06a966fec4192(sphereSize, 4, 2);
        const material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.light.updateMatrixWorld();
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $d5b33d7c30034067$var$_vector$1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_color1 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
const $d5b33d7c30034067$var$_color2 = /*@__PURE__*/ new $d5b33d7c30034067$export$892596cec99bc70e();
class $d5b33d7c30034067$export$8dca15f13f4f8172 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $d5b33d7c30034067$export$8e05fc91596f4752(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $d5b33d7c30034067$export$8dea267bd6bde117(colors, 3));
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $d5b33d7c30034067$var$_color1.copy(this.light.color);
            $d5b33d7c30034067$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $d5b33d7c30034067$var$_color1 : $d5b33d7c30034067$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        mesh.lookAt($d5b33d7c30034067$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $d5b33d7c30034067$export$3875d39926561055 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
}
class $d5b33d7c30034067$export$361430a10f533cd3 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(radius = 10, radials = 16, circles = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $d5b33d7c30034067$export$892596cec99bc70e(color1);
        color2 = new $d5b33d7c30034067$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the radials
        for(let i = 0; i <= radials; i++){
            const v = i / radials * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the circles
        for(let i = 0; i <= circles; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / circles * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
}
const $d5b33d7c30034067$var$_v1 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v2 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_v3 = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
class $d5b33d7c30034067$export$f8e434dc14203e7d extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        if (size === undefined) size = 1;
        let geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $d5b33d7c30034067$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        $d5b33d7c30034067$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $d5b33d7c30034067$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $d5b33d7c30034067$var$_v3.subVectors($d5b33d7c30034067$var$_v2, $d5b33d7c30034067$var$_v1);
        this.lightPlane.lookAt($d5b33d7c30034067$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($d5b33d7c30034067$var$_v2);
        this.targetLine.scale.z = $d5b33d7c30034067$var$_v3.length();
    }
}
const $d5b33d7c30034067$var$_vector = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
const $d5b33d7c30034067$var$_camera = /*@__PURE__*/ new $d5b33d7c30034067$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $d5b33d7c30034067$export$ed8e93f853cd795 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $d5b33d7c30034067$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $d5b33d7c30034067$export$892596cec99bc70e(0xff0000);
        const colorUp = new $d5b33d7c30034067$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $d5b33d7c30034067$export$892596cec99bc70e(0xffffff);
        const colorCross = new $d5b33d7c30034067$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $d5b33d7c30034067$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $d5b33d7c30034067$var$setPoint('c', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, -1);
        $d5b33d7c30034067$var$setPoint('t', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, 0, 1);
        // near
        $d5b33d7c30034067$var$setPoint('n1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, -1);
        $d5b33d7c30034067$var$setPoint('n2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, -1);
        $d5b33d7c30034067$var$setPoint('n3', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, -1);
        $d5b33d7c30034067$var$setPoint('n4', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, -1);
        // far
        $d5b33d7c30034067$var$setPoint('f1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, -h, 1);
        $d5b33d7c30034067$var$setPoint('f2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, -h, 1);
        $d5b33d7c30034067$var$setPoint('f3', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, h, 1);
        $d5b33d7c30034067$var$setPoint('f4', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, h, 1);
        // up
        $d5b33d7c30034067$var$setPoint('u1', pointMap, geometry, $d5b33d7c30034067$var$_camera, w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint('u2', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w * 0.7, h * 1.1, -1);
        $d5b33d7c30034067$var$setPoint('u3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h * 2, -1);
        // cross
        $d5b33d7c30034067$var$setPoint('cf1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, 1);
        $d5b33d7c30034067$var$setPoint('cf2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, 1);
        $d5b33d7c30034067$var$setPoint('cf3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, 1);
        $d5b33d7c30034067$var$setPoint('cf4', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, 1);
        $d5b33d7c30034067$var$setPoint('cn1', pointMap, geometry, $d5b33d7c30034067$var$_camera, -w, 0, -1);
        $d5b33d7c30034067$var$setPoint('cn2', pointMap, geometry, $d5b33d7c30034067$var$_camera, w, 0, -1);
        $d5b33d7c30034067$var$setPoint('cn3', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, -h, -1);
        $d5b33d7c30034067$var$setPoint('cn4', pointMap, geometry, $d5b33d7c30034067$var$_camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $d5b33d7c30034067$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $d5b33d7c30034067$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $d5b33d7c30034067$var$_vector.x, $d5b33d7c30034067$var$_vector.y, $d5b33d7c30034067$var$_vector.z);
    }
}
const $d5b33d7c30034067$var$_box = /*@__PURE__*/ new $d5b33d7c30034067$export$6f7d5a9418ab2aa3();
class $d5b33d7c30034067$export$38a664cc862a6a9d extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $d5b33d7c30034067$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) $d5b33d7c30034067$var$_box.setFromObject(this.object);
        if ($d5b33d7c30034067$var$_box.isEmpty()) return;
        const min = $d5b33d7c30034067$var$_box.min;
        const max = $d5b33d7c30034067$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
}
class $d5b33d7c30034067$export$ce39f4bb96c9a290 extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setIndex(new $d5b33d7c30034067$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
}
class $d5b33d7c30034067$export$a34fe8156c66e5d7 extends $d5b33d7c30034067$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $d5b33d7c30034067$export$e176487c05830cc5(geometry2, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
}
const $d5b33d7c30034067$var$_axis = /*@__PURE__*/ new $d5b33d7c30034067$export$64b5c384219d3699();
let $d5b33d7c30034067$var$_lineGeometry, $d5b33d7c30034067$var$_coneGeometry;
class $d5b33d7c30034067$export$a3008e7bd8d2cbe7 extends $d5b33d7c30034067$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 1), origin = new $d5b33d7c30034067$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($d5b33d7c30034067$var$_lineGeometry === undefined) {
            $d5b33d7c30034067$var$_lineGeometry = new $d5b33d7c30034067$export$b7be63a67df8959();
            $d5b33d7c30034067$var$_lineGeometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $d5b33d7c30034067$var$_coneGeometry = new $d5b33d7c30034067$export$d4345c83207d7c68(0, 0.5, 1, 5, 1);
            $d5b33d7c30034067$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $d5b33d7c30034067$export$17d680238e50603e($d5b33d7c30034067$var$_lineGeometry, new $d5b33d7c30034067$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $d5b33d7c30034067$export$e176487c05830cc5($d5b33d7c30034067$var$_coneGeometry, new $d5b33d7c30034067$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $d5b33d7c30034067$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($d5b33d7c30034067$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
}
class $d5b33d7c30034067$export$6c8303f35b8578fd extends $d5b33d7c30034067$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $d5b33d7c30034067$export$b7be63a67df8959();
        geometry.setAttribute('position', new $d5b33d7c30034067$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $d5b33d7c30034067$export$cbe7a62641830ebd(colors, 3));
        const material = new $d5b33d7c30034067$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $d5b33d7c30034067$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $d5b33d7c30034067$export$148534a3c727230b {
    constructor(){
        this.type = 'ShapePath';
        this.color = new $d5b33d7c30034067$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $d5b33d7c30034067$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW, noHoles) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $d5b33d7c30034067$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        if (noHoles === true) return toShapesNoHoles(subPaths);
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $d5b33d7c30034067$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $d5b33d7c30034067$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $d5b33d7c30034067$var$_tables = /*@__PURE__*/ $d5b33d7c30034067$var$_generateTables();
function $d5b33d7c30034067$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $d5b33d7c30034067$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $d5b33d7c30034067$var$clamp(val, -65504, 65504);
    $d5b33d7c30034067$var$_tables.floatView[0] = val;
    const f = $d5b33d7c30034067$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $d5b33d7c30034067$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $d5b33d7c30034067$var$_tables.shiftTable[e]);
}
// float16 to float32
function $d5b33d7c30034067$var$fromHalfFloat(val) {
    const m = val >> 10;
    $d5b33d7c30034067$var$_tables.uint32View[0] = $d5b33d7c30034067$var$_tables.mantissaTable[$d5b33d7c30034067$var$_tables.offsetTable[m] + (val & 0x3ff)] + $d5b33d7c30034067$var$_tables.exponentTable[m];
    return $d5b33d7c30034067$var$_tables.floatView[0];
}
var $d5b33d7c30034067$export$11ce8b759162cc80 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    toHalfFloat: $d5b33d7c30034067$var$toHalfFloat,
    fromHalfFloat: $d5b33d7c30034067$var$fromHalfFloat
});
// r133, c5bb5434555a3c3ddd784944a0a124f996fc721b
class $d5b33d7c30034067$export$8f6f2b4b16d33f extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(){
        console.error('THREE.ParametricGeometry has been moved to /examples/jsm/geometries/ParametricGeometry.js');
        super();
    }
}
// r133, eb58ff153119090d3bbb24474ea0ffc40c70dc92
class $d5b33d7c30034067$export$684b774b4473ba5f extends $d5b33d7c30034067$export$b7be63a67df8959 {
    constructor(){
        console.error('THREE.TextGeometry has been moved to /examples/jsm/geometries/TextGeometry.js');
        super();
    }
}
// r133, eb58ff153119090d3bbb24474ea0ffc40c70dc92
function $d5b33d7c30034067$export$812303d6cad736b3() {
    console.error('THREE.FontLoader has been moved to /examples/jsm/loaders/FontLoader.js');
}
// r133, eb58ff153119090d3bbb24474ea0ffc40c70dc92
function $d5b33d7c30034067$export$89abf52a030e56ee() {
    console.error('THREE.Font has been moved to /examples/jsm/loaders/FontLoader.js');
}
// r134, d65e0af06644fe5a84a6fc0e372f4318f95a04c0
function $d5b33d7c30034067$export$960665a8431ecff6() {
    console.error('THREE.ImmediateRenderObject has been removed.');
}
// r138, 48b05d3500acc084df50be9b4c90781ad9b8cb17
class $d5b33d7c30034067$export$cb2022643d3c928d extends $d5b33d7c30034067$export$3c052beb2e51e23f {
    constructor(width, height, options){
        console.error('THREE.WebGLMultisampleRenderTarget has been removed. Use a normal render target and set the "samples" property to greater 0 to enable multisampling.');
        super(width, height, options);
        this.samples = 4;
    }
}
// r138, f9cd9cab03b7b64244e304900a3a2eeaa3a588ce
class $d5b33d7c30034067$export$e38bf4541665bbbd extends $d5b33d7c30034067$export$dfac6c8e811406a3 {
    constructor(data, width, height, depth){
        console.warn('THREE.DataTexture2DArray has been renamed to DataArrayTexture.');
        super(data, width, height, depth);
    }
}
// r138, f9cd9cab03b7b64244e304900a3a2eeaa3a588ce
class $d5b33d7c30034067$export$ef03cdc98340bab4 extends $d5b33d7c30034067$export$d7a3086320f856db {
    constructor(data, width, height, depth){
        console.warn('THREE.DataTexture3D has been renamed to Data3DTexture.');
        super(data, width, height, depth);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $d5b33d7c30034067$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $d5b33d7c30034067$export$3545e07a80636437;
}

});

parcelRegister("5WBRZ", function(module, exports) {

$parcel$export(module.exports, "getJPGKey", () => $453fbeb572128273$export$1a20d13283972cc9);
const $453fbeb572128273$export$1a20d13283972cc9 = (value = '', jpgMap = {})=>{
    const k = jpgMap[value];
    if (k) return k;
    const key = Object.keys(jpgMap)?.find((k = '')=>k.endsWith(value));
    if (key) return jpgMap[key];
    return value;
};

});


parcelRegister("3Jkin", function(module, exports) {

$parcel$export(module.exports, "OBJLoader", () => $2b755151a565a9d0$export$7ae31604ad04b4a7);

var $ilwiq = parcelRequire("ilwiq");

var $jeyyu = parcelRequire("jeyyu");
// o object_name | g group_name
const $2b755151a565a9d0$var$_object_pattern = /^[og]\s*(.+)?/;
// mtllib file_reference
const $2b755151a565a9d0$var$_material_library_pattern = /^mtllib /;
// usemtl material_name
const $2b755151a565a9d0$var$_material_use_pattern = /^usemtl /;
// usemap map_name
const $2b755151a565a9d0$var$_map_use_pattern = /^usemap /;
const $2b755151a565a9d0$var$_face_vertex_data_separator_pattern = /\s+/;
const $2b755151a565a9d0$var$_vA = new (0, $ilwiq.Vector3)();
const $2b755151a565a9d0$var$_vB = new (0, $ilwiq.Vector3)();
const $2b755151a565a9d0$var$_vC = new (0, $ilwiq.Vector3)();
const $2b755151a565a9d0$var$_ab = new (0, $ilwiq.Vector3)();
const $2b755151a565a9d0$var$_cb = new (0, $ilwiq.Vector3)();
const $2b755151a565a9d0$var$_color = new (0, $ilwiq.Color)();
function $2b755151a565a9d0$var$ParserState() {
    const state = {
        objects: [],
        object: {},
        vertices: [],
        normals: [],
        colors: [],
        uvs: [],
        materials: {},
        materialLibraries: [],
        startObject: function(name, fromDeclaration) {
            // If the current object (initial from reset) is not from a g/o declaration in the parsed
            // file. We need to use it for the first parsed g/o to keep things in sync.
            if (this.object && this.object.fromDeclaration === false) {
                this.object.name = name;
                this.object.fromDeclaration = fromDeclaration !== false;
                return;
            }
            const previousMaterial = this.object && typeof this.object.currentMaterial === 'function' ? this.object.currentMaterial() : undefined;
            if (this.object && typeof this.object._finalize === 'function') this.object._finalize(true);
            this.object = {
                name: name || '',
                fromDeclaration: fromDeclaration !== false,
                geometry: {
                    vertices: [],
                    normals: [],
                    colors: [],
                    uvs: [],
                    hasUVIndices: false
                },
                materials: [],
                smooth: true,
                startMaterial: function(name, libraries) {
                    const previous = this._finalize(false);
                    // New usemtl declaration overwrites an inherited material, except if faces were declared
                    // after the material, then it must be preserved for proper MultiMaterial continuation.
                    if (previous && (previous.inherited || previous.groupCount <= 0)) this.materials.splice(previous.index, 1);
                    const material = {
                        index: this.materials.length,
                        name: name || '',
                        mtllib: Array.isArray(libraries) && libraries.length > 0 ? libraries[libraries.length - 1] : '',
                        smooth: previous !== undefined ? previous.smooth : this.smooth,
                        groupStart: previous !== undefined ? previous.groupEnd : 0,
                        groupEnd: -1,
                        groupCount: -1,
                        inherited: false,
                        clone: function(index) {
                            const cloned = {
                                index: typeof index === 'number' ? index : this.index,
                                name: this.name,
                                mtllib: this.mtllib,
                                smooth: this.smooth,
                                groupStart: 0,
                                groupEnd: -1,
                                groupCount: -1,
                                inherited: false
                            };
                            cloned.clone = this.clone.bind(cloned);
                            return cloned;
                        }
                    };
                    this.materials.push(material);
                    return material;
                },
                currentMaterial: function() {
                    if (this.materials.length > 0) return this.materials[this.materials.length - 1];
                    return undefined;
                },
                _finalize: function(end) {
                    const lastMultiMaterial = this.currentMaterial();
                    if (lastMultiMaterial && lastMultiMaterial.groupEnd === -1) {
                        lastMultiMaterial.groupEnd = this.geometry.vertices.length / 3;
                        lastMultiMaterial.groupCount = lastMultiMaterial.groupEnd - lastMultiMaterial.groupStart;
                        lastMultiMaterial.inherited = false;
                    }
                    // Ignore objects tail materials if no face declarations followed them before a new o/g started.
                    if (end && this.materials.length > 1) {
                        for(let mi = this.materials.length - 1; mi >= 0; mi--)if (this.materials[mi].groupCount <= 0) this.materials.splice(mi, 1);
                    }
                    // Guarantee at least one empty material, this makes the creation later more straight forward.
                    if (end && this.materials.length === 0) this.materials.push({
                        name: '',
                        smooth: this.smooth
                    });
                    return lastMultiMaterial;
                }
            };
            // Inherit previous objects material.
            // Spec tells us that a declared material must be set to all objects until a new material is declared.
            // If a usemtl declaration is encountered while this new object is being parsed, it will
            // overwrite the inherited material. Exception being that there was already face declarations
            // to the inherited material, then it will be preserved for proper MultiMaterial continuation.
            if (previousMaterial && previousMaterial.name && typeof previousMaterial.clone === 'function') {
                const declared = previousMaterial.clone(0);
                declared.inherited = true;
                this.object.materials.push(declared);
            }
            this.objects.push(this.object);
        },
        finalize: function() {
            if (this.object && typeof this.object._finalize === 'function') this.object._finalize(true);
        },
        parseVertexIndex: function(value, len) {
            const index = parseInt(value, 10);
            return (index >= 0 ? index - 1 : index + len / 3) * 3;
        },
        parseNormalIndex: function(value, len) {
            const index = parseInt(value, 10);
            return (index >= 0 ? index - 1 : index + len / 3) * 3;
        },
        parseUVIndex: function(value, len) {
            const index = parseInt(value, 10);
            return (index >= 0 ? index - 1 : index + len / 2) * 2;
        },
        addVertex: function(a, b, c) {
            const src = this.vertices;
            const dst = this.object.geometry.vertices;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
            dst.push(src[b + 0], src[b + 1], src[b + 2]);
            dst.push(src[c + 0], src[c + 1], src[c + 2]);
        },
        addVertexPoint: function(a) {
            const src = this.vertices;
            const dst = this.object.geometry.vertices;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
        },
        addVertexLine: function(a) {
            const src = this.vertices;
            const dst = this.object.geometry.vertices;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
        },
        addNormal: function(a, b, c) {
            const src = this.normals;
            const dst = this.object.geometry.normals;
            dst.push(src[a + 0], src[a + 1], src[a + 2]);
            dst.push(src[b + 0], src[b + 1], src[b + 2]);
            dst.push(src[c + 0], src[c + 1], src[c + 2]);
        },
        addFaceNormal: function(a, b, c) {
            const src = this.vertices;
            const dst = this.object.geometry.normals;
            $2b755151a565a9d0$var$_vA.fromArray(src, a);
            $2b755151a565a9d0$var$_vB.fromArray(src, b);
            $2b755151a565a9d0$var$_vC.fromArray(src, c);
            $2b755151a565a9d0$var$_cb.subVectors($2b755151a565a9d0$var$_vC, $2b755151a565a9d0$var$_vB);
            $2b755151a565a9d0$var$_ab.subVectors($2b755151a565a9d0$var$_vA, $2b755151a565a9d0$var$_vB);
            $2b755151a565a9d0$var$_cb.cross($2b755151a565a9d0$var$_ab);
            $2b755151a565a9d0$var$_cb.normalize();
            dst.push($2b755151a565a9d0$var$_cb.x, $2b755151a565a9d0$var$_cb.y, $2b755151a565a9d0$var$_cb.z);
            dst.push($2b755151a565a9d0$var$_cb.x, $2b755151a565a9d0$var$_cb.y, $2b755151a565a9d0$var$_cb.z);
            dst.push($2b755151a565a9d0$var$_cb.x, $2b755151a565a9d0$var$_cb.y, $2b755151a565a9d0$var$_cb.z);
        },
        addColor: function(a, b, c) {
            const src = this.colors;
            const dst = this.object.geometry.colors;
            if (src[a] !== undefined) dst.push(src[a + 0], src[a + 1], src[a + 2]);
            if (src[b] !== undefined) dst.push(src[b + 0], src[b + 1], src[b + 2]);
            if (src[c] !== undefined) dst.push(src[c + 0], src[c + 1], src[c + 2]);
        },
        addUV: function(a, b, c) {
            const src = this.uvs;
            const dst = this.object.geometry.uvs;
            dst.push(src[a + 0], src[a + 1]);
            dst.push(src[b + 0], src[b + 1]);
            dst.push(src[c + 0], src[c + 1]);
        },
        addDefaultUV: function() {
            const dst = this.object.geometry.uvs;
            dst.push(0, 0);
            dst.push(0, 0);
            dst.push(0, 0);
        },
        addUVLine: function(a) {
            const src = this.uvs;
            const dst = this.object.geometry.uvs;
            dst.push(src[a + 0], src[a + 1]);
        },
        addFace: function(a, b, c, ua, ub, uc, na, nb, nc) {
            const vLen = this.vertices.length;
            let ia = this.parseVertexIndex(a, vLen);
            let ib = this.parseVertexIndex(b, vLen);
            let ic = this.parseVertexIndex(c, vLen);
            this.addVertex(ia, ib, ic);
            this.addColor(ia, ib, ic);
            // normals
            if (na !== undefined && na !== '') {
                const nLen = this.normals.length;
                ia = this.parseNormalIndex(na, nLen);
                ib = this.parseNormalIndex(nb, nLen);
                ic = this.parseNormalIndex(nc, nLen);
                this.addNormal(ia, ib, ic);
            } else this.addFaceNormal(ia, ib, ic);
            // uvs
            if (ua !== undefined && ua !== '') {
                const uvLen = this.uvs.length;
                ia = this.parseUVIndex(ua, uvLen);
                ib = this.parseUVIndex(ub, uvLen);
                ic = this.parseUVIndex(uc, uvLen);
                this.addUV(ia, ib, ic);
                this.object.geometry.hasUVIndices = true;
            } else // add placeholder values (for inconsistent face definitions)
            this.addDefaultUV();
        },
        addPointGeometry: function(vertices) {
            this.object.geometry.type = 'Points';
            const vLen = this.vertices.length;
            for(let vi = 0, l = vertices.length; vi < l; vi++){
                const index = this.parseVertexIndex(vertices[vi], vLen);
                this.addVertexPoint(index);
                this.addColor(index);
            }
        },
        addLineGeometry: function(vertices, uvs) {
            this.object.geometry.type = 'Line';
            const vLen = this.vertices.length;
            const uvLen = this.uvs.length;
            for(let vi = 0, l = vertices.length; vi < l; vi++)this.addVertexLine(this.parseVertexIndex(vertices[vi], vLen));
            for(let uvi = 0, l = uvs.length; uvi < l; uvi++)this.addUVLine(this.parseUVIndex(uvs[uvi], uvLen));
        }
    };
    state.startObject('', false);
    return state;
}
const $2b755151a565a9d0$var$_lineTextDecoder = new TextDecoder('utf-8');
class $2b755151a565a9d0$export$7ae31604ad04b4a7 extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
        this.materials = null;
    }
    load(url, onLoad, onProgress, onError, jpgMap) {
        const scope = this;
        this.jpgMap = jpgMap || {};
        const loader = new (0, $jeyyu.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.setResponseType('arraybuffer');
        loader.load(url, async function(data) {
            try {
                onLoad(await scope.parse(data));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    setMaterials(materials) {
        this.materials = materials;
        return this;
    }
    async parse(text) {
        if (text instanceof ArrayBuffer) {
            const state = $2b755151a565a9d0$var$parseOBJFromArrayBuffer(text);
            return $2b755151a565a9d0$var$buildOBJContainer(state, this);
        }
        const state = new $2b755151a565a9d0$var$ParserState();
        if (text.indexOf('\r\n') !== -1) // This is faster than String.split with regex that splits on both
        text = text.replace(/\r\n/g, '\n');
        if (text.indexOf('\\\n') !== -1) // join lines separated by a line continuation character (\)
        text = text.replace(/\\\n/g, '');
        const lines = text.split('\n');
        for(let i = 0, l = lines.length; i < l; i++)$2b755151a565a9d0$var$processOBJLine(lines[i].trimStart(), state);
        state.finalize();
        return $2b755151a565a9d0$var$buildOBJContainer(state, this);
    }
}
function $2b755151a565a9d0$var$decodeObjLineBytes(u8, start, end) {
    for(let i = start; i < end; i++){
        if (u8[i] >= 0x80) return $2b755151a565a9d0$var$_lineTextDecoder.decode(u8.subarray(start, end));
    }
    if (end - start <= 65535) return String.fromCharCode.apply(null, u8.subarray(start, end));
    let s = '';
    const step = 16384;
    for(let i = start; i < end; i += step){
        const lim = Math.min(i + step, end);
        s += String.fromCharCode.apply(null, u8.subarray(i, lim));
    }
    return s;
}
function $2b755151a565a9d0$var$processOBJLine(line, state) {
    if (line.length === 0) return;
    const lineFirstChar = line.charAt(0);
    if (lineFirstChar === '#') return;
    let regResult;
    if (lineFirstChar === 'v') {
        const data = line.split($2b755151a565a9d0$var$_face_vertex_data_separator_pattern);
        switch(data[0]){
            case 'v':
                state.vertices.push(parseFloat(data[1]), parseFloat(data[2]), parseFloat(data[3]));
                if (data.length >= 7) {
                    $2b755151a565a9d0$var$_color.setRGB(parseFloat(data[4]), parseFloat(data[5]), parseFloat(data[6])).convertSRGBToLinear();
                    state.colors.push($2b755151a565a9d0$var$_color.r, $2b755151a565a9d0$var$_color.g, $2b755151a565a9d0$var$_color.b);
                } else state.colors.push(undefined, undefined, undefined);
                break;
            case 'vn':
                state.normals.push(parseFloat(data[1]), parseFloat(data[2]), parseFloat(data[3]));
                break;
            case 'vt':
                state.uvs.push(parseFloat(data[1]), parseFloat(data[2]));
                break;
        }
    } else if (lineFirstChar === 'f') {
        const lineData = line.slice(1).trim();
        const vertexData = lineData.split($2b755151a565a9d0$var$_face_vertex_data_separator_pattern);
        const faceVertices = [];
        for(let j = 0, jl = vertexData.length; j < jl; j++){
            const vertex = vertexData[j];
            if (vertex.length > 0) {
                const vertexParts = vertex.split('/');
                faceVertices.push(vertexParts);
            }
        }
        const v1 = faceVertices[0];
        for(let j = 1, jl = faceVertices.length - 1; j < jl; j++){
            const v2 = faceVertices[j];
            const v3 = faceVertices[j + 1];
            state.addFace(v1[0], v2[0], v3[0], v1[1], v2[1], v3[1], v1[2], v2[2], v3[2]);
        }
    } else if (lineFirstChar === 'l') {
        const lineParts = line.substring(1).trim().split(' ');
        let lineVertices = [];
        const lineUVs = [];
        if (line.indexOf('/') === -1) lineVertices = lineParts;
        else for(let li = 0, llen = lineParts.length; li < llen; li++){
            const parts = lineParts[li].split('/');
            if (parts[0] !== '') lineVertices.push(parts[0]);
            if (parts[1] !== '') lineUVs.push(parts[1]);
        }
        state.addLineGeometry(lineVertices, lineUVs);
    } else if (lineFirstChar === 'p') {
        const lineData = line.slice(1).trim();
        const pointData = lineData.split(' ');
        state.addPointGeometry(pointData);
    } else if ((regResult = $2b755151a565a9d0$var$_object_pattern.exec(line)) !== null) {
        const name = (' ' + regResult[0].slice(1).trim()).slice(1);
        state.startObject(name);
    } else if ($2b755151a565a9d0$var$_material_use_pattern.test(line)) state.object.startMaterial(line.substring(7).trim(), state.materialLibraries);
    else if ($2b755151a565a9d0$var$_material_library_pattern.test(line)) state.materialLibraries.push(line.substring(7).trim());
    else if ($2b755151a565a9d0$var$_map_use_pattern.test(line)) console.warn('THREE.OBJLoader: Rendering identifier "usemap" not supported. Textures must be defined in MTL files.');
    else if (lineFirstChar === 's') {
        regResult = line.split(' ');
        if (regResult.length > 1) {
            const value = regResult[1].trim().toLowerCase();
            state.object.smooth = value !== '0' && value !== 'off';
        } else state.object.smooth = true;
        const material = state.object.currentMaterial();
        if (material) material.smooth = state.object.smooth;
    } else {
        if (line === '\0') return;
        console.warn('THREE.OBJLoader: Unexpected line: "' + line + '"');
    }
}
function $2b755151a565a9d0$var$parseOBJFromArrayBuffer(arrayBuffer) {
    const state = new $2b755151a565a9d0$var$ParserState();
    const u8 = new Uint8Array(arrayBuffer);
    let lineStart = 0;
    let carry = '';
    const flushPhysicalLine = (lineEndExclusive, stripCr)=>{
        let end = lineEndExclusive;
        if (stripCr && end > lineStart && u8[end - 1] === 13) end--;
        const lineStr = $2b755151a565a9d0$var$decodeObjLineBytes(u8, lineStart, end);
        lineStart = lineEndExclusive + 1;
        let combined = carry + lineStr;
        const trimmedForCont = combined.replace(/\r$/, '').trimEnd();
        if (trimmedForCont.length > 0 && trimmedForCont.endsWith('\\')) {
            carry = trimmedForCont.slice(0, -1);
            return;
        }
        carry = '';
        $2b755151a565a9d0$var$processOBJLine(combined.trimStart(), state);
    };
    for(let i = 0; i < u8.length; i++)if (u8[i] === 10) flushPhysicalLine(i, true);
    if (lineStart < u8.length) {
        let end = u8.length;
        if (end > lineStart && u8[end - 1] === 13) end--;
        const lineStr = $2b755151a565a9d0$var$decodeObjLineBytes(u8, lineStart, end);
        let combined = carry + lineStr;
        const trimmedForCont = combined.replace(/\r$/, '').trimEnd();
        if (trimmedForCont.length > 0 && trimmedForCont.endsWith('\\')) combined = trimmedForCont.slice(0, -1);
        carry = '';
        $2b755151a565a9d0$var$processOBJLine(combined.trimStart(), state);
    } else if (carry.length > 0) $2b755151a565a9d0$var$processOBJLine(carry.trimStart(), state);
    state.finalize();
    return state;
}
async function $2b755151a565a9d0$var$buildOBJContainer(state, loader) {
    const container = new (0, $ilwiq.Group)();
    container.materialLibraries = [].concat(state.materialLibraries);
    const hasPrimitives = !(state.objects.length === 1 && state.objects[0].geometry.vertices.length === 0);
    if (hasPrimitives === true) for(let i = 0, l = state.objects.length; i < l; i++){
        const object = state.objects[i];
        const geometry = object.geometry;
        const materials = object.materials;
        const isLine = geometry.type === 'Line';
        const isPoints = geometry.type === 'Points';
        let hasVertexColors = false;
        // Skip o/g line declarations that did not follow with any faces
        if (geometry.vertices.length === 0) continue;
        const buffergeometry = new (0, $ilwiq.BufferGeometry)();
        buffergeometry.setAttribute('position', new (0, $ilwiq.Float32BufferAttribute)(geometry.vertices, 3));
        if (geometry.normals.length > 0) buffergeometry.setAttribute('normal', new (0, $ilwiq.Float32BufferAttribute)(geometry.normals, 3));
        if (geometry.colors.length > 0) {
            hasVertexColors = true;
            buffergeometry.setAttribute('color', new (0, $ilwiq.Float32BufferAttribute)(geometry.colors, 3));
        }
        if (geometry.hasUVIndices === true) buffergeometry.setAttribute('uv', new (0, $ilwiq.Float32BufferAttribute)(geometry.uvs, 2));
        // Create materials
        const createdMaterials = [];
        for(let mi = 0, miLen = materials.length; mi < miLen; mi++){
            const sourceMaterial = materials[mi];
            const materialHash = sourceMaterial.name + '_' + sourceMaterial.smooth + '_' + hasVertexColors;
            let material = state.materials[materialHash];
            if (loader.materials !== null) {
                const keys = loader.jpgMap ? Object.keys(loader.jpgMap) : [];
                material = await loader.materials.create(keys.length > 0 ? loader.jpgMap[sourceMaterial.name]?.split('/').pop() || sourceMaterial.name : sourceMaterial.name);
                // mtl etc. loaders probably can't create line materials correctly, copy properties to a line material.
                if (isLine && material && !(material instanceof (0, $ilwiq.LineBasicMaterial))) {
                    const materialLine = new (0, $ilwiq.LineBasicMaterial)();
                    (0, $ilwiq.Material).prototype.copy.call(materialLine, material);
                    materialLine.color.copy(material.color);
                    material = materialLine;
                } else if (isPoints && material && !(material instanceof (0, $ilwiq.PointsMaterial))) {
                    const materialPoints = new (0, $ilwiq.PointsMaterial)({
                        size: 10,
                        sizeAttenuation: false
                    });
                    (0, $ilwiq.Material).prototype.copy.call(materialPoints, material);
                    materialPoints.color.copy(material.color);
                    materialPoints.map = material.map;
                    material = materialPoints;
                }
            }
            if (material === undefined) {
                if (isLine) material = new (0, $ilwiq.LineBasicMaterial)();
                else if (isPoints) material = new (0, $ilwiq.PointsMaterial)({
                    size: 1,
                    sizeAttenuation: false
                });
                else material = new (0, $ilwiq.MeshPhongMaterial)();
                material.name = sourceMaterial.name;
                material.flatShading = sourceMaterial.smooth ? false : true;
                material.vertexColors = hasVertexColors;
                state.materials[materialHash] = material;
            }
            createdMaterials.push(material);
        }
        // Create mesh
        let mesh;
        if (createdMaterials.length > 1) {
            for(let mi = 0, miLen = materials.length; mi < miLen; mi++){
                const sourceMaterial = materials[mi];
                buffergeometry.addGroup(sourceMaterial.groupStart, sourceMaterial.groupCount, mi);
            }
            if (isLine) mesh = new (0, $ilwiq.LineSegments)(buffergeometry, createdMaterials);
            else if (isPoints) mesh = new (0, $ilwiq.Points)(buffergeometry, createdMaterials);
            else mesh = new (0, $ilwiq.Mesh)(buffergeometry, createdMaterials);
        } else {
            if (isLine) mesh = new (0, $ilwiq.LineSegments)(buffergeometry, createdMaterials[0]);
            else if (isPoints) mesh = new (0, $ilwiq.Points)(buffergeometry, createdMaterials[0]);
            else mesh = new (0, $ilwiq.Mesh)(buffergeometry, createdMaterials[0]);
        }
        mesh.name = object.name;
        container.add(mesh);
    }
    else // if there is only the default parser state object with no geometry data, interpret data as point cloud
    if (state.vertices.length > 0) {
        const material = new (0, $ilwiq.PointsMaterial)({
            size: 1,
            sizeAttenuation: false
        });
        const buffergeometry = new (0, $ilwiq.BufferGeometry)();
        buffergeometry.setAttribute('position', new (0, $ilwiq.Float32BufferAttribute)(state.vertices, 3));
        if (state.colors.length > 0 && state.colors[0] !== undefined) {
            buffergeometry.setAttribute('color', new (0, $ilwiq.Float32BufferAttribute)(state.colors, 3));
            material.vertexColors = true;
        }
        const points = new (0, $ilwiq.Points)(buffergeometry, material);
        container.add(points);
    }
    return container;
}

});
parcelRegister("jeyyu", function(module, exports) {

$parcel$export(module.exports, "FileLoader", () => $e00a211103e290c5$export$98435a25b5cf7b2b);

var $ilwiq = parcelRequire("ilwiq");

var $ddI8l = parcelRequire("ddI8l");

var $h8sKa = parcelRequire("h8sKa");
const $e00a211103e290c5$var$loading = {};
class $e00a211103e290c5$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $e00a211103e290c5$export$98435a25b5cf7b2b extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = (0, $ddI8l.Cache).get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($e00a211103e290c5$var$loading[url] !== undefined) {
            $e00a211103e290c5$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $e00a211103e290c5$var$loading[url] = [];
        $e00a211103e290c5$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $e00a211103e290c5$var$loading[url];
                const reader = response.body.getReader();
                const contentLength = response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(async ({ done: done, value: value })=>{
                                if (done) {
                                    await (0, $h8sKa.sleep)(100);
                                    controller.close();
                                } else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $e00a211103e290c5$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then(async (response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            (0, $ddI8l.Cache).add(url, data);
            const callbacks = $e00a211103e290c5$var$loading[url];
            delete $e00a211103e290c5$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $e00a211103e290c5$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $e00a211103e290c5$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}

});
parcelRegister("ddI8l", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $99feb9485f611fde$export$94affb487e701bf2);
const $99feb9485f611fde$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};

});



parcelRegister("f55LV", function(module, exports) {

$parcel$export(module.exports, "GLTFLoader", () => $afabccd2e82af430$export$aa93f11e7884f0f4);

var $ilwiq = parcelRequire("ilwiq");

var $7ePFa = parcelRequire("7ePFa");

var $5WBRZ = parcelRequire("5WBRZ");

var $jeyyu = parcelRequire("jeyyu");
class $afabccd2e82af430$export$aa93f11e7884f0f4 extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new $afabccd2e82af430$var$GLTFMeshGpuInstancing(parser);
        });
    }
    load(url, onLoad, onProgress, onError, jpgMap) {
        const scope = this;
        this.jpgMap = jpgMap || {};
        let resourcePath;
        if (this.resourcePath !== '') resourcePath = this.resourcePath;
        else if (this.path !== '') resourcePath = this.path;
        else resourcePath = (0, $ilwiq.LoaderUtils).extractUrlBase(url);
        // Tells the LoadingManager to track an extra item, which resolves after
        // the model is fully loaded. This means the count of items loaded will
        // be incorrect, but ensures manager.onLoad() does not fire early.
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, $jeyyu.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        const textDecoder = new TextDecoder();
        if (typeof data === 'string') json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = textDecoder.decode(new Uint8Array(data, 0, 4));
            if (magic === $afabccd2e82af430$var$BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_BINARY_GLTF] = new $afabccd2e82af430$var$GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse(textDecoder.decode(data));
        } else json = data;
        if (json.asset === undefined || json.asset.version[0] < 2) {
            if (onError) onError(new Error('THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.'));
            return;
        }
        const parser = new $afabccd2e82af430$var$GLTFParser(json, {
            path: path || this.resourcePath || '',
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder,
            jpgMap: this.jpgMap
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            plugins[plugin.name] = plugin;
            // Workaround to avoid determining as unknown extension
            // in addUnknownExtensionsToUserData().
            // Remove this workaround if we move all the existing
            // extension handlers to plugin system
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new $afabccd2e82af430$var$GLTFMaterialsUnlitExtension();
                    break;
                case $afabccd2e82af430$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new $afabccd2e82af430$var$GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case $afabccd2e82af430$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new $afabccd2e82af430$var$GLTFTextureTransformExtension();
                    break;
                case $afabccd2e82af430$var$EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new $afabccd2e82af430$var$GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === undefined) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
/* GLTFREGISTRY */ function $afabccd2e82af430$var$GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
/*********************************/ /********** EXTENSIONS ***********/ /*********************************/ const $afabccd2e82af430$var$EXTENSIONS = {
    KHR_BINARY_GLTF: 'KHR_binary_glTF',
    KHR_DRACO_MESH_COMPRESSION: 'KHR_draco_mesh_compression',
    KHR_LIGHTS_PUNCTUAL: 'KHR_lights_punctual',
    KHR_MATERIALS_CLEARCOAT: 'KHR_materials_clearcoat',
    KHR_MATERIALS_IOR: 'KHR_materials_ior',
    KHR_MATERIALS_SHEEN: 'KHR_materials_sheen',
    KHR_MATERIALS_SPECULAR: 'KHR_materials_specular',
    KHR_MATERIALS_TRANSMISSION: 'KHR_materials_transmission',
    KHR_MATERIALS_IRIDESCENCE: 'KHR_materials_iridescence',
    KHR_MATERIALS_ANISOTROPY: 'KHR_materials_anisotropy',
    KHR_MATERIALS_UNLIT: 'KHR_materials_unlit',
    KHR_MATERIALS_VOLUME: 'KHR_materials_volume',
    KHR_TEXTURE_BASISU: 'KHR_texture_basisu',
    KHR_TEXTURE_TRANSFORM: 'KHR_texture_transform',
    KHR_MESH_QUANTIZATION: 'KHR_mesh_quantization',
    KHR_MATERIALS_EMISSIVE_STRENGTH: 'KHR_materials_emissive_strength',
    EXT_TEXTURE_WEBP: 'EXT_texture_webp',
    EXT_TEXTURE_AVIF: 'EXT_texture_avif',
    EXT_MESHOPT_COMPRESSION: 'EXT_meshopt_compression',
    EXT_MESH_GPU_INSTANCING: 'EXT_mesh_gpu_instancing'
};
/**
 * Punctual Lights Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_lights_punctual
 */ class $afabccd2e82af430$var$GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        // Object3D instance caches
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== undefined) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = 'light:' + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, $ilwiq.Color)(0xffffff);
        if (lightDef.color !== undefined) color.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], (0, $ilwiq.LinearSRGBColorSpace));
        const range = lightDef.range !== undefined ? lightDef.range : 0;
        switch(lightDef.type){
            case 'directional':
                lightNode = new (0, $ilwiq.DirectionalLight)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case 'point':
                lightNode = new (0, $ilwiq.PointLight)(color);
                lightNode.distance = range;
                break;
            case 'spot':
                lightNode = new (0, $ilwiq.SpotLight)(color);
                lightNode.distance = range;
                // Handle spotlight properties.
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== undefined ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== undefined ? lightDef.spot.outerConeAngle : Math.PI / 4.0;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1.0 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error('THREE.GLTFLoader: Unexpected light type: ' + lightDef.type);
        }
        // Some lights (e.g. spot) default to a position other than the origin. Reset the position
        // here, because node-level parsing will only override position if explicitly specified.
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        $afabccd2e82af430$var$assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== undefined) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || 'light_' + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== 'light') return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self1 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === undefined) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self1.cache, lightIndex, light);
        });
    }
}
/**
 * Unlit Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_unlit
 */ class $afabccd2e82af430$var$GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, $ilwiq.MeshBasicMaterial;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, $ilwiq.Color)(1.0, 1.0, 1.0);
        materialParams.opacity = 1.0;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], (0, $ilwiq.LinearSRGBColorSpace));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, (0, $ilwiq.SRGBColorSpace)));
        }
        return Promise.all(pending);
    }
}
/**
 * Materials Emissive Strength Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/blob/5768b3ce0ef32bc39cdf1bef10b948586635ead3/extensions/2.0/Khronos/KHR_materials_emissive_strength/README.md
 */ class $afabccd2e82af430$var$GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== undefined) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
/**
 * Clearcoat Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_clearcoat
 */ class $afabccd2e82af430$var$GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== undefined) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'clearcoatMap', extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== undefined) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'clearcoatRoughnessMap', extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== undefined) {
            pending.push(parser.assignTexture(materialParams, 'clearcoatNormalMap', extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== undefined) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, $ilwiq.Vector2)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
/**
 * Iridescence Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_iridescence
 */ class $afabccd2e82af430$var$GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== undefined) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'iridescenceMap', extension.iridescenceTexture));
        if (extension.iridescenceIor !== undefined) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === undefined) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== undefined) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== undefined) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'iridescenceThicknessMap', extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
/**
 * Sheen Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/main/extensions/2.0/Khronos/KHR_materials_sheen
 */ class $afabccd2e82af430$var$GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, $ilwiq.Color)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== undefined) {
            const colorFactor = extension.sheenColorFactor;
            materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], (0, $ilwiq.LinearSRGBColorSpace));
        }
        if (extension.sheenRoughnessFactor !== undefined) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'sheenColorMap', extension.sheenColorTexture, (0, $ilwiq.SRGBColorSpace)));
        if (extension.sheenRoughnessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'sheenRoughnessMap', extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
/**
 * Transmission Materials Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_transmission
 * Draft: https://github.com/KhronosGroup/glTF/pull/1698
 */ class $afabccd2e82af430$var$GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== undefined) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'transmissionMap', extension.transmissionTexture));
        return Promise.all(pending);
    }
}
/**
 * Materials Volume Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_volume
 */ class $afabccd2e82af430$var$GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== undefined ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'thicknessMap', extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, $ilwiq.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], (0, $ilwiq.LinearSRGBColorSpace));
        return Promise.all(pending);
    }
}
/**
 * Materials ior Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_ior
 */ class $afabccd2e82af430$var$GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== undefined ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
/**
 * Materials specular Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_specular
 */ class $afabccd2e82af430$var$GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== undefined ? extension.specularFactor : 1.0;
        if (extension.specularTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'specularIntensityMap', extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, $ilwiq.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], (0, $ilwiq.LinearSRGBColorSpace));
        if (extension.specularColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'specularColorMap', extension.specularColorTexture, (0, $ilwiq.SRGBColorSpace)));
        return Promise.all(pending);
    }
}
/**
 * Materials anisotropy Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_materials_anisotropy
 */ class $afabccd2e82af430$var$GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, $ilwiq.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== undefined) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== undefined) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'anisotropyMap', extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
/**
 * BasisU Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_basisu
 */ class $afabccd2e82af430$var$GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error('THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures');
            else // Assumes that the extension is optional and that a fallback texture is present
            return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
/**
 * WebP Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_webp
 */ class $afabccd2e82af430$var$GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const uri = (0, $5WBRZ.getJPGKey)(source.uri, parser.options.jpgMap);
            const handler = parser.options.manager.getHandler(uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error('THREE.GLTFLoader: WebP required by asset but unsupported.');
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image. Support for lossy images doesn't guarantee support for all
            // WebP images, unfortunately.
            image.src = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA';
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * AVIF Texture Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_texture_avif
 */ class $afabccd2e82af430$var$GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = $afabccd2e82af430$var$EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const uri = (0, $5WBRZ.getJPGKey)(source.uri, parser.options.jpgMap);
            const handler = parser.options.manager.getHandler(uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error('THREE.GLTFLoader: AVIF required by asset but unsupported.');
            // Fall back to PNG or JPEG.
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            // Lossy test image.
            image.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=';
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
/**
 * meshopt BufferView Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_meshopt_compression
 */ class $afabccd2e82af430$var$GLTFMeshoptCompression {
    constructor(parser){
        this.name = $afabccd2e82af430$var$EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency('buffer', extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error('THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files');
                else // Assumes that the extension is optional and that fallback buffer data is present
                return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res) {
                    return res.buffer;
                });
                else // Support for MeshoptDecoder 0.18 or earlier, without decodeGltfBufferAsync
                return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
/**
 * GPU Instancing Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Vendor/EXT_mesh_gpu_instancing
 *
 */ class $afabccd2e82af430$var$GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = $afabccd2e82af430$var$EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === undefined) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        // No Points or Lines + Instancing support yet
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== $afabccd2e82af430$var$WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== $afabccd2e82af430$var$WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== $afabccd2e82af430$var$WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== undefined) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        // @TODO: Can we support InstancedMesh + SkinnedMesh?
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency('accessor', attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count // All attribute counts should be same
            ;
            const instancedMeshes = [];
            for (const mesh of meshes){
                // Temporal variables
                const m = new (0, $ilwiq.Matrix4)();
                const p = new (0, $ilwiq.Vector3)();
                const q = new (0, $ilwiq.Quaternion)();
                const s = new (0, $ilwiq.Vector3)(1, 1, 1);
                const instancedMesh = new (0, $ilwiq.InstancedMesh)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                // Add instance attributes to the geometry, excluding TRS.
                for(const attributeName in attributes)if (attributeName !== 'TRANSLATION' && attributeName !== 'ROTATION' && attributeName !== 'SCALE') mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                // Just in case
                (0, $ilwiq.Object3D).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
/* BINARY EXTENSION */ const $afabccd2e82af430$var$BINARY_EXTENSION_HEADER_MAGIC = 'glTF';
const $afabccd2e82af430$var$BINARY_EXTENSION_HEADER_LENGTH = 12;
const $afabccd2e82af430$var$BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 0x4e4f534a,
    BIN: 0x004e4942
};
class $afabccd2e82af430$var$GLTFBinaryExtension {
    constructor(data){
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, $afabccd2e82af430$var$BINARY_EXTENSION_HEADER_LENGTH);
        const textDecoder = new TextDecoder();
        this.header = {
            magic: textDecoder.decode(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== $afabccd2e82af430$var$BINARY_EXTENSION_HEADER_MAGIC) throw new Error('THREE.GLTFLoader: Unsupported glTF-Binary header.');
        else if (this.header.version < 2.0) throw new Error('THREE.GLTFLoader: Legacy binary file detected.');
        const chunkContentsLength = this.header.length - $afabccd2e82af430$var$BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, $afabccd2e82af430$var$BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === $afabccd2e82af430$var$BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, $afabccd2e82af430$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = textDecoder.decode(contentArray);
            } else if (chunkType === $afabccd2e82af430$var$BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = $afabccd2e82af430$var$BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            // Clients must ignore chunks with unknown types.
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error('THREE.GLTFLoader: JSON content not found.');
    }
}
/**
 * DRACO Mesh Compression Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_draco_mesh_compression
 */ class $afabccd2e82af430$var$GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error('THREE.GLTFLoader: No DRACOLoader instance provided.');
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = $afabccd2e82af430$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = $afabccd2e82af430$var$ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== undefined) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = $afabccd2e82af430$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency('bufferView', bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== undefined) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap);
            });
        });
    }
}
/**
 * Texture Transform Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_texture_transform
 */ class $afabccd2e82af430$var$GLTFTextureTransformExtension {
    constructor(){
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === undefined || transform.texCoord === texture.channel) && transform.offset === undefined && transform.rotation === undefined && transform.scale === undefined) // See https://github.com/mrdoob/three.js/issues/21819.
        return texture;
        texture = texture.clone();
        if (transform.texCoord !== undefined) texture.channel = transform.texCoord;
        if (transform.offset !== undefined) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== undefined) texture.rotation = transform.rotation;
        if (transform.scale !== undefined) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
/**
 * Mesh Quantization Extension
 *
 * Specification: https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization
 */ class $afabccd2e82af430$var$GLTFMeshQuantizationExtension {
    constructor(){
        this.name = $afabccd2e82af430$var$EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
/*********************************/ /********** INTERPOLATION ********/ /*********************************/ // Spline Interpolation
// Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#appendix-c-spline-interpolation
class $afabccd2e82af430$var$GLTFCubicSplineInterpolant extends (0, $ilwiq.Interpolant) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        // Copies a sample value to the result buffer. See description of glTF
        // CUBICSPLINE values layout in interpolate_() function below.
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        // Layout of keyframe output values for CUBICSPLINE animations:
        //   [ inTangent_1, splineVertex_1, outTangent_1, inTangent_2, splineVertex_2, ... ]
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride] // splineVertex_k
            ;
            const m0 = values[offset0 + i + stride2] * td // outTangent_k * (t_k+1 - t_k)
            ;
            const p1 = values[offset1 + i + stride] // splineVertex_k+1
            ;
            const m1 = values[offset1 + i] * td // inTangent_k+1 * (t_k+1 - t_k)
            ;
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const $afabccd2e82af430$var$_q = new (0, $ilwiq.Quaternion)();
class $afabccd2e82af430$var$GLTFCubicSplineQuaternionInterpolant extends $afabccd2e82af430$var$GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        $afabccd2e82af430$var$_q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
/*********************************/ /********** INTERNALS ************/ /*********************************/ /* CONSTANTS */ const $afabccd2e82af430$var$WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const $afabccd2e82af430$var$WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const $afabccd2e82af430$var$WEBGL_FILTERS = {
    9728: (0, $ilwiq.NearestFilter),
    9729: (0, $ilwiq.LinearFilter),
    9984: (0, $ilwiq.NearestMipmapNearestFilter),
    9985: (0, $ilwiq.LinearMipmapNearestFilter),
    9986: (0, $ilwiq.NearestMipmapLinearFilter),
    9987: (0, $ilwiq.LinearMipmapLinearFilter)
};
const $afabccd2e82af430$var$WEBGL_WRAPPINGS = {
    33071: (0, $ilwiq.ClampToEdgeWrapping),
    33648: (0, $ilwiq.MirroredRepeatWrapping),
    10497: (0, $ilwiq.RepeatWrapping)
};
const $afabccd2e82af430$var$WEBGL_TYPE_SIZES = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
};
const $afabccd2e82af430$var$ATTRIBUTES = {
    POSITION: 'position',
    NORMAL: 'normal',
    TANGENT: 'tangent',
    TEXCOORD_0: 'uv',
    TEXCOORD_1: 'uv1',
    TEXCOORD_2: 'uv2',
    TEXCOORD_3: 'uv3',
    COLOR_0: 'color',
    WEIGHTS_0: 'skinWeight',
    JOINTS_0: 'skinIndex'
};
const $afabccd2e82af430$var$PATH_PROPERTIES = {
    scale: 'scale',
    translation: 'position',
    rotation: 'quaternion',
    weights: 'morphTargetInfluences'
};
const $afabccd2e82af430$var$INTERPOLATION = {
    CUBICSPLINE: undefined,
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, $ilwiq.InterpolateLinear),
    STEP: (0, $ilwiq.InterpolateDiscrete)
};
const $afabccd2e82af430$var$ALPHA_MODES = {
    OPAQUE: 'OPAQUE',
    MASK: 'MASK',
    BLEND: 'BLEND'
};
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#default-material
 */ function $afabccd2e82af430$var$createDefaultMaterial(cache) {
    if (cache['DefaultMaterial'] === undefined) cache['DefaultMaterial'] = new (0, $ilwiq.MeshStandardMaterial)({
        color: 0xffffff,
        emissive: 0x000000,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, $ilwiq.FrontSide)
    });
    return cache['DefaultMaterial'];
}
function $afabccd2e82af430$var$addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    // Add unknown glTF extensions to an object's userData.
    for(const name in objectDef.extensions)if (knownExtensions[name] === undefined) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
/**
 * @param {Object3D|Material|BufferGeometry} object
 * @param {GLTF.definition} gltfDef
 */ function $afabccd2e82af430$var$assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== undefined) {
        if (typeof gltfDef.extras === 'object') Object.assign(object.userData, gltfDef.extras);
        else console.warn('THREE.GLTFLoader: Ignoring primitive type .extras, ' + gltfDef.extras);
    }
}
/**
 * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#morph-targets
 *
 * @param {BufferGeometry} geometry
 * @param {Array<GLTF.Target>} targets
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $afabccd2e82af430$var$addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== undefined) hasMorphPosition = true;
        if (target.NORMAL !== undefined) hasMorphNormal = true;
        if (target.COLOR_0 !== undefined) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== undefined ? parser.getDependency('accessor', target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== undefined ? parser.getDependency('accessor', target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== undefined ? parser.getDependency('accessor', target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
/**
 * @param {Mesh} mesh
 * @param {GLTF.Mesh} meshDef
 */ function $afabccd2e82af430$var$updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== undefined) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    // .extras has user-defined data, so check that .extras.targetNames is an array.
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn('THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.');
    }
}
function $afabccd2e82af430$var$createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = 'draco:' + dracoExtension.bufferView + ':' + dracoExtension.indices + ':' + $afabccd2e82af430$var$createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ':' + $afabccd2e82af430$var$createAttributesKey(primitiveDef.attributes) + ':' + primitiveDef.mode;
    if (primitiveDef.targets !== undefined) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ':' + $afabccd2e82af430$var$createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function $afabccd2e82af430$var$createAttributesKey(attributes) {
    let attributesKey = '';
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ':' + attributes[keys[i]] + ';';
    return attributesKey;
}
function $afabccd2e82af430$var$getNormalizedComponentScale(constructor) {
    // Reference:
    // https://github.com/KhronosGroup/glTF/tree/master/extensions/2.0/Khronos/KHR_mesh_quantization#encoding-quantized-data
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error('THREE.GLTFLoader: Unsupported normalized accessor component type.');
    }
}
function $afabccd2e82af430$var$getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return 'image/jpeg';
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return 'image/webp';
    return 'image/png';
}
const $afabccd2e82af430$var$_identityMatrix = new (0, $ilwiq.Matrix4)();
/* GLTF PARSER */ class $afabccd2e82af430$var$GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        // loader object cache
        this.cache = new $afabccd2e82af430$var$GLTFRegistry();
        // associations between Three.js objects and glTF elements
        this.associations = new Map();
        // BufferGeometry caching
        this.primitiveCache = {};
        // Node cache
        this.nodeCache = {};
        // Object3D instance caches
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        // Track node names, to ensure no duplicates
        this.nodeNamesUsed = {};
        // Use an ImageBitmapLoader if imageBitmaps are supported. Moves much of the
        // expensive work of uploading a texture to the GPU off the main thread.
        let isSafari = false;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== 'undefined') {
            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
            isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
            firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === 'undefined' || isSafari || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, $ilwiq.TextureLoader)(this.options.manager);
        else this.textureLoader = new (0, $ilwiq.ImageBitmapLoader)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, $jeyyu.FileLoader)(this.options.manager);
        this.fileLoader.setResponseType('arraybuffer');
        if (this.options.crossOrigin === 'use-credentials') this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        // Clear the loader cache
        this.cache.removeAll();
        this.nodeCache = {};
        // Mark the special nodes/meshes in json for efficient parse
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies('scene'),
                parser.getDependencies('animation'),
                parser.getDependencies('camera')
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser: parser,
                userData: {}
            };
            $afabccd2e82af430$var$addUnknownExtensionsToUserData(extensions, result, json);
            $afabccd2e82af430$var$assignExtrasToUserData(result, json);
            return Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
   * Marks the special nodes/meshes in json for efficient parse.
   */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        // Nothing in the node definition indicates whether it is a Bone or an
        // Object3D. Use the skins' joint references to mark bones.
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        // Iterate over all nodes, marking references to shared resources,
        // as well as skeleton joints.
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== undefined) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                // Nothing in the mesh definition indicates whether it is
                // a SkinnedMesh or Mesh. Use the node's mesh reference
                // to mark SkinnedMesh if node has skin.
                if (nodeDef.skin !== undefined) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== undefined) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */ _addNodeRef(cache, index) {
        if (index === undefined) return;
        if (cache.refs[index] === undefined) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        // Propagates mappings to the cloned object, prevents mappings on the
        // original object from being lost.
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += '_instance_' + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */ getDependency(type, index) {
        const cacheKey = type + ':' + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case 'scene':
                    dependency = this.loadScene(index);
                    break;
                case 'node':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case 'mesh':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case 'accessor':
                    dependency = this.loadAccessor(index);
                    break;
                case 'bufferView':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case 'buffer':
                    dependency = this.loadBuffer(index);
                    break;
                case 'material':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case 'texture':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case 'skin':
                    dependency = this.loadSkin(index);
                    break;
                case 'animation':
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case 'camera':
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error('Unknown type: ' + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === 'mesh' ? 'es' : 's')] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== 'arraybuffer') throw new Error('THREE.GLTFLoader: ' + bufferDef.type + ' buffer type is not supported.');
        // If present, GLB container is required to be the first buffer.
        if (bufferDef.uri === undefined && bufferIndex === 0) return Promise.resolve(this.extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            const uri = (0, $5WBRZ.getJPGKey)(bufferDef.uri, options.jpgMap);
            loader.load((0, $ilwiq.LoaderUtils).resolveURL(uri, options.path), resolve, undefined, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency('buffer', bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === undefined && accessorDef.sparse === undefined) {
            const itemSize = $afabccd2e82af430$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $afabccd2e82af430$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, $ilwiq.BufferAttribute)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== undefined) pendingBufferViews.push(this.getDependency('bufferView', accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== undefined) {
            pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency('bufferView', accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = $afabccd2e82af430$var$WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = $afabccd2e82af430$var$WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            // For VEC3: itemSize is 3, elementBytes is 4, itemBytes is 12.
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== undefined ? json.bufferViews[accessorDef.bufferView].byteStride : undefined;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            // The buffer is not interleaved if the stride is the item size in bytes.
            if (byteStride && byteStride !== itemBytes) {
                // Each "slice" of the buffer, as defined by 'count' elements of 'byteStride' bytes, gets its own InterleavedBuffer
                // This makes sure that IBA.count reflects accessor.count properly
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = 'InterleavedBuffer:' + accessorDef.bufferView + ':' + accessorDef.componentType + ':' + ibSlice + ':' + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    // Integer parameters to IB/IBA are in array elements, not bytes.
                    ib = new (0, $ilwiq.InterleavedBuffer)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, $ilwiq.InterleavedBufferAttribute)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, $ilwiq.BufferAttribute)(array, itemSize, normalized);
            }
            // https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#sparse-accessors
            if (accessorDef.sparse !== undefined) {
                const itemSizeIndices = $afabccd2e82af430$var$WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = $afabccd2e82af430$var$WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                bufferAttribute = new (0, $ilwiq.BufferAttribute)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error('THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.');
                }
            }
            return bufferAttribute;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const uri = (0, $5WBRZ.getJPGKey)(sourceDef.uri, options.jpgMap);
            const handler = options.manager.getHandler(uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ':' + textureDef.sampler;
        if (this.textureCache[cacheKey]) // See https://github.com/mrdoob/three.js/issues/21559.
        return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || '';
            if (texture.name === '' && typeof sourceDef.uri === 'string' && sourceDef.uri.startsWith('data:image/') === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = $afabccd2e82af430$var$WEBGL_FILTERS[sampler.magFilter] || (0, $ilwiq.LinearFilter);
            texture.minFilter = $afabccd2e82af430$var$WEBGL_FILTERS[sampler.minFilter] || (0, $ilwiq.LinearMipmapLinearFilter);
            texture.wrapS = $afabccd2e82af430$var$WEBGL_WRAPPINGS[sampler.wrapS] || (0, $ilwiq.RepeatWrapping);
            texture.wrapT = $afabccd2e82af430$var$WEBGL_WRAPPINGS[sampler.wrapT] || (0, $ilwiq.RepeatWrapping);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== undefined) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || '';
        let isObjectURL = false;
        if (sourceDef.bufferView !== undefined) // Load binary image data from bufferView, if provided.
        sourceURI = parser.getDependency('bufferView', sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === undefined) throw new Error('THREE.GLTFLoader: Image ' + sourceIndex + ' is missing URI and bufferView');
        sourceURI = (0, $5WBRZ.getJPGKey)(sourceURI, options.jpgMap);
        const promise = Promise.resolve(sourceURI).then(function(sourceURI) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, $ilwiq.Texture)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, $ilwiq.LoaderUtils).resolveURL(sourceURI, options.path), onLoad, undefined, reject);
            });
        }).then(function(texture) {
            // Clean up resources and configure Texture.
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            texture.userData.mimeType = sourceDef.mimeType || $afabccd2e82af430$var$getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency('texture', mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== undefined && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== undefined ? mapDef.extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM] : undefined;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (texture) {
                if (colorSpace !== undefined) texture.colorSpace = colorSpace;
            }
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === undefined;
        const useVertexColors = geometry.attributes.color !== undefined;
        const useFlatShading = geometry.attributes.normal === undefined;
        if (mesh.isPoints) {
            const cacheKey = 'PointsMaterial:' + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, $ilwiq.PointsMaterial)();
                (0, $ilwiq.Material).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false // glTF spec says points should be 1px
                ;
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = 'LineBasicMaterial:' + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, $ilwiq.LineBasicMaterial)();
                (0, $ilwiq.Material).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        // Clone the material if it will be modified
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = 'ClonedMaterial:' + material.uuid + ':';
            if (useDerivativeTangents) cacheKey += 'derivative-tangents:';
            if (useVertexColors) cacheKey += 'vertex-colors:';
            if (useFlatShading) cacheKey += 'flat-shading:';
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    // https://github.com/mrdoob/three.js/issues/11438#issuecomment-507003995
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, $ilwiq.MeshStandardMaterial;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[$afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            // Specification:
            // https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#metallic-roughness-material
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, $ilwiq.Color)(1.0, 1.0, 1.0);
            materialParams.opacity = 1.0;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], (0, $ilwiq.LinearSRGBColorSpace));
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== undefined) pending.push(parser.assignTexture(materialParams, 'map', metallicRoughness.baseColorTexture, (0, $ilwiq.SRGBColorSpace)));
            materialParams.metalness = metallicRoughness.metallicFactor !== undefined ? metallicRoughness.metallicFactor : 1.0;
            materialParams.roughness = metallicRoughness.roughnessFactor !== undefined ? metallicRoughness.roughnessFactor : 1.0;
            if (metallicRoughness.metallicRoughnessTexture !== undefined) {
                pending.push(parser.assignTexture(materialParams, 'metalnessMap', metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, 'roughnessMap', metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, $ilwiq.DoubleSide);
        const alphaMode = materialDef.alphaMode || $afabccd2e82af430$var$ALPHA_MODES.OPAQUE;
        if (alphaMode === $afabccd2e82af430$var$ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            // See: https://github.com/mrdoob/three.js/issues/17706
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === $afabccd2e82af430$var$ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== undefined ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== undefined && materialType !== (0, $ilwiq.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, 'normalMap', materialDef.normalTexture));
            materialParams.normalScale = new (0, $ilwiq.Vector2)(1, 1);
            if (materialDef.normalTexture.scale !== undefined) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== undefined && materialType !== (0, $ilwiq.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, 'aoMap', materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== undefined) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== undefined && materialType !== (0, $ilwiq.MeshBasicMaterial)) {
            const emissiveFactor = materialDef.emissiveFactor;
            materialParams.emissive = new (0, $ilwiq.Color)().setRGB(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], (0, $ilwiq.LinearSRGBColorSpace));
        }
        if (materialDef.emissiveTexture !== undefined && materialType !== (0, $ilwiq.MeshBasicMaterial)) pending.push(parser.assignTexture(materialParams, 'emissiveMap', materialDef.emissiveTexture, (0, $ilwiq.SRGBColorSpace)));
        return Promise.all(pending).then(function() {
            const material = new (0, $ilwiq.MeshBasicMaterial)(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            $afabccd2e82af430$var$assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) $afabccd2e82af430$var$addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, $ilwiq.PropertyBinding).sanitizeNodeName(originalName || '');
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + '_' + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return $afabccd2e82af430$var$addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = $afabccd2e82af430$var$createPrimitiveKey(primitive);
            // See if we've already created this geometry
            const cached = cache[cacheKey];
            if (cached) // Use the cached geometry if it exists
            pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[$afabccd2e82af430$var$EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) // Use DRACO geometry if available
                geometryPromise = createDracoPrimitive(primitive);
                else // Otherwise create a new geometry
                geometryPromise = $afabccd2e82af430$var$addPrimitiveAttributes(new (0, $ilwiq.BufferGeometry)(), primitive, parser);
                // Cache this geometry
                cache[cacheKey] = {
                    primitive: primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === undefined ? $afabccd2e82af430$var$createDefaultMaterial(this.cache) : this.getDependency('material', primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                // 1. create Mesh
                let mesh;
                const material = materials[i];
                if (primitive.mode === $afabccd2e82af430$var$WEBGL_CONSTANTS.TRIANGLES || primitive.mode === $afabccd2e82af430$var$WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === $afabccd2e82af430$var$WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === undefined) {
                    // .isSkinnedMesh isn't in glTF spec. See ._markDefs()
                    mesh = meshDef.isSkinnedMesh === true ? new (0, $ilwiq.SkinnedMesh)(geometry, material) : new (0, $ilwiq.Mesh)(geometry, material);
                    if (mesh.isSkinnedMesh === true) // normalize skin weights to fix malformed assets (see #15319)
                    mesh.normalizeSkinWeights();
                    if (primitive.mode === $afabccd2e82af430$var$WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, $7ePFa.toTrianglesDrawMode)(mesh.geometry, (0, $ilwiq.TriangleStripDrawMode));
                    else if (primitive.mode === $afabccd2e82af430$var$WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, $7ePFa.toTrianglesDrawMode)(mesh.geometry, (0, $ilwiq.TriangleFanDrawMode));
                } else if (primitive.mode === $afabccd2e82af430$var$WEBGL_CONSTANTS.LINES) mesh = new (0, $ilwiq.LineSegments)(geometry, material);
                else if (primitive.mode === $afabccd2e82af430$var$WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, $ilwiq.Line)(geometry, material);
                else if (primitive.mode === $afabccd2e82af430$var$WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, $ilwiq.LineLoop)(geometry, material);
                else if (primitive.mode === $afabccd2e82af430$var$WEBGL_CONSTANTS.POINTS) mesh = new (0, $ilwiq.Points)(geometry, material);
                else throw new Error('THREE.GLTFLoader: Primitive mode unsupported: ' + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) $afabccd2e82af430$var$updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || 'mesh_' + meshIndex);
                $afabccd2e82af430$var$assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) $afabccd2e82af430$var$addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) $afabccd2e82af430$var$addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, $ilwiq.Group)();
            if (meshDef.extensions) $afabccd2e82af430$var$addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn('THREE.GLTFLoader: Missing camera parameters.');
            return;
        }
        if (cameraDef.type === 'perspective') camera = new (0, $ilwiq.PerspectiveCamera)((0, $ilwiq.MathUtils).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === 'orthographic') camera = new (0, $ilwiq.OrthographicCamera)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        $afabccd2e82af430$var$assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== undefined) pending.push(this.getDependency('accessor', skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            // Note that bones (joint nodes) may or may not be in the
            // scene graph at this time.
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, $ilwiq.Matrix4)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, $ilwiq.Skeleton)(bones, boneInverses);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */ loadAnimation(animationIndex) {
        const json = this.json;
        const parser = this;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : 'animation_' + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== undefined ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== undefined ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === undefined) continue;
            pendingNodes.push(this.getDependency('node', name));
            pendingInputAccessors.push(this.getDependency('accessor', input));
            pendingOutputAccessors.push(this.getDependency('accessor', output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === undefined) continue;
                if (node.updateMatrix) node.updateMatrix();
                const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
                if (createdTracks) for(let k = 0; k < createdTracks.length; k++)tracks.push(createdTracks[k]);
            }
            return new (0, $ilwiq.AnimationClip)(animationName, undefined, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === undefined) return null;
        return parser.getDependency('mesh', nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            // if weights are provided on the node, override weights on the mesh.
            if (nodeDef.weights !== undefined) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency('node', childrenDef[i]));
        const skeletonPending = nodeDef.skin === undefined ? Promise.resolve(null) : parser.getDependency('skin', nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) // This full traverse should be fine because
            // child glTF nodes have not been added to this node yet.
            node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, $afabccd2e82af430$var$_identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        // This method is called from .loadNode() and .loadSkin().
        // Cache a node to avoid duplication.
        if (this.nodeCache[nodeIndex] !== undefined) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        // reserve node's name before its dependencies, so the root has the intended name.
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : '';
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== undefined) pending.push(parser.getDependency('camera', nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            // .isBone isn't in glTF spec. See ._markDefs
            if (nodeDef.isBone === true) node = new (0, $ilwiq.Bone)();
            else if (objects.length > 1) node = new (0, $ilwiq.Group)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, $ilwiq.Object3D)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            $afabccd2e82af430$var$assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) $afabccd2e82af430$var$addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== undefined) {
                const matrix = new (0, $ilwiq.Matrix4)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== undefined) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== undefined) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== undefined) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        // Loader returns Group, not Scene.
        // See: https://github.com/mrdoob/three.js/issues/18342#issuecomment-578981172
        const scene = new (0, $ilwiq.Group)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        $afabccd2e82af430$var$assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) $afabccd2e82af430$var$addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency('node', nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            // Removes dangling associations, associations that reference a node that
            // didn't make it into the scene.
            const reduceAssociations = (node)=>{
                const reducedAssociations = new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, $ilwiq.Material) || key instanceof (0, $ilwiq.Texture)) reducedAssociations.set(key, value);
                node.traverse((node)=>{
                    const mappings = parser.associations.get(node);
                    if (mappings != null) reducedAssociations.set(node, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
        const tracks = [];
        const targetName = node.name ? node.name : node.uuid;
        const targetNames = [];
        if ($afabccd2e82af430$var$PATH_PROPERTIES[target.path] === $afabccd2e82af430$var$PATH_PROPERTIES.weights) node.traverse(function(object) {
            if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
        });
        else targetNames.push(targetName);
        let TypedKeyframeTrack;
        switch($afabccd2e82af430$var$PATH_PROPERTIES[target.path]){
            case $afabccd2e82af430$var$PATH_PROPERTIES.weights:
                TypedKeyframeTrack = (0, $ilwiq.NumberKeyframeTrack);
                break;
            case $afabccd2e82af430$var$PATH_PROPERTIES.rotation:
                TypedKeyframeTrack = (0, $ilwiq.QuaternionKeyframeTrack);
                break;
            case $afabccd2e82af430$var$PATH_PROPERTIES.position:
            case $afabccd2e82af430$var$PATH_PROPERTIES.scale:
                TypedKeyframeTrack = (0, $ilwiq.VectorKeyframeTrack);
                break;
            default:
                switch(outputAccessor.itemSize){
                    case 1:
                        TypedKeyframeTrack = (0, $ilwiq.NumberKeyframeTrack);
                        break;
                    case 2:
                    case 3:
                    default:
                        TypedKeyframeTrack = (0, $ilwiq.VectorKeyframeTrack);
                        break;
                }
                break;
        }
        const interpolation = sampler.interpolation !== undefined ? $afabccd2e82af430$var$INTERPOLATION[sampler.interpolation] : (0, $ilwiq.InterpolateLinear);
        const outputArray = this._getArrayFromAccessor(outputAccessor);
        for(let j = 0, jl = targetNames.length; j < jl; j++){
            const track = new TypedKeyframeTrack(targetNames[j] + '.' + $afabccd2e82af430$var$PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
            // Override interpolation with custom factory method.
            if (sampler.interpolation === 'CUBICSPLINE') this._createCubicSplineTrackInterpolant(track);
            tracks.push(track);
        }
        return tracks;
    }
    _getArrayFromAccessor(accessor) {
        let outputArray = accessor.array;
        if (accessor.normalized) {
            const scale = $afabccd2e82af430$var$getNormalizedComponentScale(outputArray.constructor);
            const scaled = new Float32Array(outputArray.length);
            for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
            outputArray = scaled;
        }
        return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
            // A CUBICSPLINE keyframe in glTF has three output values for each input value,
            // representing inTangent, splineVertex, and outTangent. As a result, track.getValueSize()
            // must be divided by three to get the interpolant's sampleSize argument.
            const interpolantType = this instanceof (0, $ilwiq.QuaternionKeyframeTrack) ? $afabccd2e82af430$var$GLTFCubicSplineQuaternionInterpolant : $afabccd2e82af430$var$GLTFCubicSplineInterpolant;
            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
        };
        // Mark as CUBICSPLINE. `track.getInterpolation()` doesn't support custom interpolants.
        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 */ function $afabccd2e82af430$var$computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, $ilwiq.Box3)();
    if (attributes.POSITION !== undefined) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
        if (min !== undefined && max !== undefined) {
            box.set(new (0, $ilwiq.Vector3)(min[0], min[1], min[2]), new (0, $ilwiq.Vector3)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = $afabccd2e82af430$var$getNormalizedComponentScale($afabccd2e82af430$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== undefined) {
        const maxDisplacement = new (0, $ilwiq.Vector3)();
        const vector = new (0, $ilwiq.Vector3)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== undefined) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                // glTF requires 'min' and 'max', but VRM (which extends glTF) currently ignores that requirement.
                if (min !== undefined && max !== undefined) {
                    // we need to get max of absolute components because target weight is [-1,1]
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = $afabccd2e82af430$var$getNormalizedComponentScale($afabccd2e82af430$var$WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    // Note: this assumes that the sum of all weights is at most 1. This isn't quite correct - it's more conservative
                    // to assume that each target can have a max weight of 1. However, for some use cases - notably, when morph targets
                    // are used to implement key-frame animations and as such only two are active at a time - this results in very large
                    // boxes. So for now we make a box that's sometimes a touch too small but is hopefully mostly of reasonable size.
                    maxDisplacement.max(vector);
                } else console.warn('THREE.GLTFLoader: Missing min/max properties for accessor POSITION.');
            }
        }
        // As per comment above this box isn't conservative, but has a reasonable size for a very large number of morph targets.
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, $ilwiq.Sphere)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
/**
 * @param {BufferGeometry} geometry
 * @param {GLTF.Primitive} primitiveDef
 * @param {GLTFParser} parser
 * @return {Promise<BufferGeometry>}
 */ function $afabccd2e82af430$var$addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency('accessor', accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = $afabccd2e82af430$var$ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        // Skip attributes already provided by e.g. Draco extension.
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== undefined && !geometry.index) {
        const accessor = parser.getDependency('accessor', primitiveDef.indices).then(function(accessor) {
            geometry.setIndex(accessor);
        });
        pending.push(accessor);
    }
    if ((0, $ilwiq.ColorManagement).workingColorSpace !== (0, $ilwiq.LinearSRGBColorSpace) && 'COLOR_0' in attributes) console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${(0, $ilwiq.ColorManagement).workingColorSpace}" not supported.`);
    $afabccd2e82af430$var$assignExtrasToUserData(geometry, primitiveDef);
    $afabccd2e82af430$var$computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== undefined ? $afabccd2e82af430$var$addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}

});
parcelRegister("7ePFa", function(module, exports) {

$parcel$export(module.exports, "toTrianglesDrawMode", () => $5451ea62abbe5f68$export$5492ca6e5c0c7aa0);

var $ilwiq = parcelRequire("ilwiq");
function $5451ea62abbe5f68$export$15356c20484a5e31() {
    throw new Error('BufferGeometryUtils: computeTangents renamed to computeMikkTSpaceTangents.');
}
function $5451ea62abbe5f68$export$676e3e70c930f774(geometry, MikkTSpace, negateSign = true) {
    if (!MikkTSpace || !MikkTSpace.isReady) throw new Error('BufferGeometryUtils: Initialized MikkTSpace library required.');
    if (!geometry.hasAttribute('position') || !geometry.hasAttribute('normal') || !geometry.hasAttribute('uv')) throw new Error('BufferGeometryUtils: Tangents require "position", "normal", and "uv" attributes.');
    function getAttributeArray(attribute) {
        if (attribute.normalized || attribute.isInterleavedBufferAttribute) {
            const srcArray = attribute.isInterleavedBufferAttribute ? attribute.data.array : attribute.array;
            const dstArray = new Float32Array(attribute.getCount() * attribute.itemSize);
            for(let i = 0, j = 0; i < attribute.getCount(); i++){
                dstArray[j++] = (0, $ilwiq.MathUtils).denormalize(attribute.getX(i), srcArray);
                dstArray[j++] = (0, $ilwiq.MathUtils).denormalize(attribute.getY(i), srcArray);
                if (attribute.itemSize > 2) dstArray[j++] = (0, $ilwiq.MathUtils).denormalize(attribute.getZ(i), srcArray);
            }
            return dstArray;
        }
        if (attribute.array instanceof Float32Array) return attribute.array;
        return new Float32Array(attribute.array);
    }
    // MikkTSpace algorithm requires non-indexed input.
    const _geometry = geometry.index ? geometry.toNonIndexed() : geometry;
    // Compute vertex tangents.
    const tangents = MikkTSpace.generateTangents(getAttributeArray(_geometry.attributes.position), getAttributeArray(_geometry.attributes.normal), getAttributeArray(_geometry.attributes.uv));
    // Texture coordinate convention of glTF differs from the apparent
    // default of the MikkTSpace library; .w component must be flipped.
    if (negateSign) for(let i = 3; i < tangents.length; i += 4)tangents[i] *= -1;
    //
    _geometry.setAttribute('tangent', new (0, $ilwiq.BufferAttribute)(tangents, 4));
    if (geometry !== _geometry) geometry.copy(_geometry);
    return geometry;
}
/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */ function $5451ea62abbe5f68$export$728c051ccdf8a702(geometries, useGroups = false) {
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, $ilwiq.BufferGeometry)();
    let offset = 0;
    for(let i = 0; i < geometries.length; ++i){
        const geometry = geometries[i];
        let attributesCount = 0;
        // ensure that all geometries are indexed, or none
        if (isIndexed !== (geometry.index !== null)) {
            console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.');
            return null;
        }
        // gather attributes, exit early if they're different
        for(const name in geometry.attributes){
            if (!attributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === undefined) attributes[name] = [];
            attributes[name].push(geometry.attributes[name]);
            attributesCount++;
        }
        // ensure geometries have the same number of attributes
        if (attributesCount !== attributesUsed.size) {
            console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. Make sure all geometries have the same number of attributes.');
            return null;
        }
        // gather morph attributes, exit early if they're different
        if (morphTargetsRelative !== geometry.morphTargetsRelative) {
            console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. .morphTargetsRelative must be consistent throughout all geometries.');
            return null;
        }
        for(const name in geometry.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '.  .morphAttributes must be consistent throughout all geometries.');
                return null;
            }
            if (morphAttributes[name] === undefined) morphAttributes[name] = [];
            morphAttributes[name].push(geometry.morphAttributes[name]);
        }
        // gather .userData
        mergedGeometry.userData.mergedUserData = mergedGeometry.userData.mergedUserData || [];
        mergedGeometry.userData.mergedUserData.push(geometry.userData);
        if (useGroups) {
            let count;
            if (isIndexed) count = geometry.index.count;
            else if (geometry.attributes.position !== undefined) count = geometry.attributes.position.count;
            else {
                console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + i + '. The geometry must have either an index or a position attribute');
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    }
    // merge indices
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        for(let i = 0; i < geometries.length; ++i){
            const index = geometries[i].index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geometries[i].attributes.position.count;
        }
        mergedGeometry.setIndex(mergedIndex);
    }
    // merge attributes
    for(const name in attributes){
        const mergedAttribute = $5451ea62abbe5f68$export$c4eef4c1c9d34ea9(attributes[name]);
        if (!mergedAttribute) {
            console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the ' + name + ' attribute.');
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    // merge morph attributes
    for(const name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = $5451ea62abbe5f68$export$c4eef4c1c9d34ea9(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the ' + name + ' morphAttribute.');
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */ function $5451ea62abbe5f68$export$c4eef4c1c9d34ea9(attributes) {
    let TypedArray;
    let itemSize;
    let normalized;
    let arrayLength = 0;
    for(let i = 0; i < attributes.length; ++i){
        const attribute = attributes[i];
        if (attribute.isInterleavedBufferAttribute) {
            console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported.');
            return null;
        }
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.');
            return null;
        }
        if (itemSize === undefined) itemSize = attribute.itemSize;
        if (itemSize !== attribute.itemSize) {
            console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.');
            return null;
        }
        if (normalized === undefined) normalized = attribute.normalized;
        if (normalized !== attribute.normalized) {
            console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.');
            return null;
        }
        arrayLength += attribute.array.length;
    }
    const array = new TypedArray(arrayLength);
    let offset = 0;
    for(let i = 0; i < attributes.length; ++i){
        array.set(attributes[i].array, offset);
        offset += attributes[i].array.length;
    }
    return new (0, $ilwiq.BufferAttribute)(array, itemSize, normalized);
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {Array<InterleavedBufferAttribute>}
 */ function $5451ea62abbe5f68$export$308f9509e428a845(attributes) {
    // Interleaves the provided attributes into an InterleavedBuffer and returns
    // a set of InterleavedBufferAttributes for each attribute
    let TypedArray;
    let arrayLength = 0;
    let stride = 0;
    // calculate the the length and type of the interleavedBuffer
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === undefined) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error('AttributeBuffers of different types cannot be interleaved');
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    // Create the set of buffer attributes
    const interleavedBuffer = new (0, $ilwiq.InterleavedBuffer)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    const setters = [
        'setX',
        'setY',
        'setZ',
        'setW'
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, $ilwiq.InterleavedBufferAttribute)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        // Move the data for each attribute into the new interleavedBuffer
        // at the appropriate offset
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++)iba[setters[k]](c, attribute[getters[k]](c));
    }
    return res;
}
function $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attribute) {
    const cons = attribute.data.array.constructor;
    const count = attribute.count;
    const itemSize = attribute.itemSize;
    const normalized = attribute.normalized;
    const array = new cons(count * itemSize);
    let newAttribute;
    if (attribute.isInstancedInterleavedBufferAttribute) newAttribute = new (0, $ilwiq.InstancedBufferAttribute)(array, itemSize, normalized, attribute.meshPerAttribute);
    else newAttribute = new (0, $ilwiq.BufferAttribute)(array, itemSize, normalized);
    for(let i = 0; i < count; i++){
        newAttribute.setX(i, attribute.getX(i));
        if (itemSize >= 2) newAttribute.setY(i, attribute.getY(i));
        if (itemSize >= 3) newAttribute.setZ(i, attribute.getZ(i));
        if (itemSize >= 4) newAttribute.setW(i, attribute.getW(i));
    }
    return newAttribute;
}
function $5451ea62abbe5f68$export$e7413b17bfaaa80b(geometry) {
    const attributes = geometry.attributes;
    const morphTargets = geometry.morphTargets;
    const attrMap = new Map();
    for(const key in attributes){
        const attr = attributes[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attr));
            attributes[key] = attrMap.get(attr);
        }
    }
    for(const key in morphTargets){
        const attr = morphTargets[key];
        if (attr.isInterleavedBufferAttribute) {
            if (!attrMap.has(attr)) attrMap.set(attr, $5451ea62abbe5f68$export$4b7aa2f2134b7e19(attr));
            morphTargets[key] = attrMap.get(attr);
        }
    }
}
/**
 * @param {Array<BufferGeometry>} geometry
 * @return {number}
 */ function $5451ea62abbe5f68$export$35bee7999e19754d(geometry) {
    // Return the estimated memory used by this geometry in bytes
    // Calculate using itemSize, count, and BYTES_PER_ELEMENT to account
    // for InterleavedBufferAttributes.
    let mem = 0;
    for(const name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} tolerance
 * @return {BufferGeometry>}
 */ function $5451ea62abbe5f68$export$e36bb98c4c944f9(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    // Generate an index buffer if the geometry doesn't have one, or optimize it
    // if it's already available.
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute('position');
    const vertexCount = indices ? indices.count : positions.count;
    // next value for triangle indices
    let nextIndex = 0;
    // attributes and new attribute arrays
    const attributeNames = Object.keys(geometry.attributes);
    const attrArrays = {};
    const morphAttrsArrays = {};
    const newIndices = [];
    const getters = [
        'getX',
        'getY',
        'getZ',
        'getW'
    ];
    // initialize the arrays
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        attrArrays[name] = [];
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) morphAttrsArrays[name] = new Array(morphAttr.length).fill().map(()=>[]);
    }
    // convert the error tolerance to an amount of decimal places to truncate to
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        // Generate a hash for the vertex attributes at the current index 'i'
        let hash = '';
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)// double tilde truncates the decimal value
            hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        // Add another reference to the vertex if it's already
        // used by another index
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            // copy data to the new index in the attribute arrays
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = attrArrays[name];
                const newMorphArrays = morphAttrsArrays[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    newarray.push(attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m].push(morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    // Generate typed arrays from new attribute arrays and update
    // the attributeBuffers
    const result = geometry.clone();
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const oldAttribute = geometry.getAttribute(name);
        const buffer = new oldAttribute.array.constructor(attrArrays[name]);
        const attribute = new (0, $ilwiq.BufferAttribute)(buffer, oldAttribute.itemSize, oldAttribute.normalized);
        result.setAttribute(name, attribute);
        // Update the attribute arrays
        if (name in morphAttrsArrays) for(let j = 0; j < morphAttrsArrays[name].length; j++){
            const oldMorphAttribute = geometry.morphAttributes[name][j];
            const buffer = new oldMorphAttribute.array.constructor(morphAttrsArrays[name][j]);
            const morphAttribute = new (0, $ilwiq.BufferAttribute)(buffer, oldMorphAttribute.itemSize, oldMorphAttribute.normalized);
            result.morphAttributes[name][j] = morphAttribute;
        }
    }
    // indices
    result.setIndex(newIndices);
    return result;
}
/**
 * @param {BufferGeometry} geometry
 * @param {number} drawMode
 * @return {BufferGeometry>}
 */ function $5451ea62abbe5f68$export$5492ca6e5c0c7aa0(geometry, drawMode) {
    if (drawMode === (0, $ilwiq.TrianglesDrawMode)) {
        console.warn('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.');
        return geometry;
    }
    if (drawMode === (0, $ilwiq.TriangleFanDrawMode) || drawMode === (0, $ilwiq.TriangleStripDrawMode)) {
        let index = geometry.getIndex();
        // generate index if not present
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute('position');
            if (position !== undefined) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.');
                return geometry;
            }
        }
        //
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (drawMode === (0, $ilwiq.TriangleFanDrawMode)) // gl.TRIANGLE_FAN
        for(let i = 1; i <= numberOfTriangles; i++){
            newIndices.push(index.getX(0));
            newIndices.push(index.getX(i));
            newIndices.push(index.getX(i + 1));
        }
        else {
            // gl.TRIANGLE_STRIP
            for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i + 2));
            } else {
                newIndices.push(index.getX(i + 2));
                newIndices.push(index.getX(i + 1));
                newIndices.push(index.getX(i));
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.');
        // build final geometry
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error('THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:', drawMode);
        return geometry;
    }
}
/**
 * Calculates the morphed attributes of a morphed/skinned BufferGeometry.
 * Helpful for Raytracing or Decals.
 * @param {Mesh | Line | Points} object An instance of Mesh, Line or Points.
 * @return {Object} An Object with original position/normal attributes and morphed ones.
 */ function $5451ea62abbe5f68$export$29e54e2e4ab904e7(object) {
    if (object.geometry.isBufferGeometry !== true) {
        console.error('THREE.BufferGeometryUtils: Geometry is not of type BufferGeometry.');
        return null;
    }
    const _vA = new (0, $ilwiq.Vector3)();
    const _vB = new (0, $ilwiq.Vector3)();
    const _vC = new (0, $ilwiq.Vector3)();
    const _tempA = new (0, $ilwiq.Vector3)();
    const _tempB = new (0, $ilwiq.Vector3)();
    const _tempC = new (0, $ilwiq.Vector3)();
    const _morphA = new (0, $ilwiq.Vector3)();
    const _morphB = new (0, $ilwiq.Vector3)();
    const _morphC = new (0, $ilwiq.Vector3)();
    function _calculateMorphedAttributeData(object, attribute, morphAttribute, morphTargetsRelative, a, b, c, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a);
        _vB.fromBufferAttribute(attribute, b);
        _vC.fromBufferAttribute(attribute, c);
        const morphInfluences = object.morphTargetInfluences;
        if (morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const influence = morphInfluences[i];
                const morph = morphAttribute[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a);
                _tempB.fromBufferAttribute(morph, b);
                _tempC.fromBufferAttribute(morph, c);
                if (morphTargetsRelative) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object.isSkinnedMesh) {
            object.boneTransform(a, _vA);
            object.boneTransform(b, _vB);
            object.boneTransform(c, _vC);
        }
        modifiedAttributeArray[a * 3 + 0] = _vA.x;
        modifiedAttributeArray[a * 3 + 1] = _vA.y;
        modifiedAttributeArray[a * 3 + 2] = _vA.z;
        modifiedAttributeArray[b * 3 + 0] = _vB.x;
        modifiedAttributeArray[b * 3 + 1] = _vB.y;
        modifiedAttributeArray[b * 3 + 2] = _vB.z;
        modifiedAttributeArray[c * 3 + 0] = _vC.x;
        modifiedAttributeArray[c * 3 + 1] = _vC.y;
        modifiedAttributeArray[c * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        // indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else {
        // non-indexed buffer geometry
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, $ilwiq.Float32BufferAttribute)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, $ilwiq.Float32BufferAttribute)(modifiedNormal, 3);
    return {
        positionAttribute: positionAttribute,
        normalAttribute: normalAttribute,
        morphedPositionAttribute: morphedPositionAttribute,
        morphedNormalAttribute: morphedNormalAttribute
    };
}
function $5451ea62abbe5f68$export$8babbf41197098b1(geometry) {
    if (geometry.groups.length === 0) {
        console.warn('THREE.BufferGeometryUtils.mergeGroups(): No groups are defined. Nothing to merge.');
        return geometry;
    }
    let groups = geometry.groups;
    // sort groups by material index
    groups = groups.sort((a, b)=>{
        if (a.materialIndex !== b.materialIndex) return a.materialIndex - b.materialIndex;
        return a.start - b.start;
    });
    // create index for non-indexed geometries
    if (geometry.getIndex() === null) {
        const positionAttribute = geometry.getAttribute('position');
        const indices = [];
        for(let i = 0; i < positionAttribute.count; i += 3)indices.push(i, i + 1, i + 2);
        geometry.setIndex(indices);
    }
    // sort index
    const index = geometry.getIndex();
    const newIndices = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        const groupStart = group.start;
        const groupLength = groupStart + group.count;
        for(let j = groupStart; j < groupLength; j++)newIndices.push(index.getX(j));
    }
    geometry.dispose(); // Required to force buffer recreation
    geometry.setIndex(newIndices);
    // update groups indices
    let start = 0;
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        group.start = start;
        start += group.count;
    }
    // merge groups
    let currentGroup = groups[0];
    geometry.groups = [
        currentGroup
    ];
    for(let i = 1; i < groups.length; i++){
        const group = groups[i];
        if (currentGroup.materialIndex === group.materialIndex) currentGroup.count += group.count;
        else {
            currentGroup = group;
            geometry.groups.push(currentGroup);
        }
    }
    return geometry;
}

});


parcelRegister("4xroJ", function(module, exports) {

$parcel$export(module.exports, "FBXLoader", () => $34df7f268a78e6c9$export$60c52e42bb04b96);

var $ilwiq = parcelRequire("ilwiq");

var $79Zxq = parcelRequire("79Zxq");

var $cLt9Z = parcelRequire("cLt9Z");

var $5WBRZ = parcelRequire("5WBRZ");

var $jeyyu = parcelRequire("jeyyu");
/**
 * Loader loads FBX file and generates Group representing FBX scene.
 * Requires FBX file to be >= 7.0 and in ASCII or >= 6400 in Binary format
 * Versions lower than this may load but will probably have errors
 *
 * Needs Support:
 *  Morph normals / blend shape normals
 *
 * FBX format references:
 * 	https://help.autodesk.com/view/FBX/2017/ENU/?guid=__cpp_ref_index_html (C++ SDK reference)
 *
 * Binary format specification:
 *	https://code.blender.org/2013/08/fbx-binary-file-format-specification/
 */ let $34df7f268a78e6c9$var$fbxTree;
let $34df7f268a78e6c9$var$connections;
let $34df7f268a78e6c9$var$sceneGraph;
class $34df7f268a78e6c9$export$60c52e42bb04b96 extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError, jpgMap) {
        const scope = this;
        this.jpgMap = jpgMap || {};
        const path = scope.path === '' ? (0, $ilwiq.LoaderUtils).extractUrlBase(url) : scope.path;
        const loader = new (0, $jeyyu.FileLoader)(this.manager);
        loader.setPath(scope.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            scope.parse(buffer, path).then(onLoad).catch((e)=>{
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            });
        }, onProgress, onError);
    }
    async parse(FBXBuffer, path) {
        if ($34df7f268a78e6c9$var$isFbxFormatBinary(FBXBuffer)) $34df7f268a78e6c9$var$fbxTree = new $34df7f268a78e6c9$var$BinaryParser().parse(FBXBuffer);
        else {
            const FBXText = $34df7f268a78e6c9$var$convertArrayBufferToString(FBXBuffer);
            if (!$34df7f268a78e6c9$var$isFbxFormatASCII(FBXText)) throw new Error('THREE.FBXLoader: Unknown format.');
            if ($34df7f268a78e6c9$var$getFbxVersion(FBXText) < 7000) throw new Error('THREE.FBXLoader: FBX version not supported, FileVersion: ' + $34df7f268a78e6c9$var$getFbxVersion(FBXText));
            $34df7f268a78e6c9$var$fbxTree = new $34df7f268a78e6c9$var$TextParser().parse(FBXText);
        }
        // console.log( fbxTree );
        const textureLoader = new (0, $ilwiq.TextureLoader)(this.manager).setPath(this.resourcePath || path).setCrossOrigin(this.crossOrigin);
        return new $34df7f268a78e6c9$var$FBXTreeParser(textureLoader, this.manager, this.jpgMap).parse($34df7f268a78e6c9$var$fbxTree);
    }
}
// Parse the FBXTree object returned by the BinaryParser or TextParser and return a Group
class $34df7f268a78e6c9$var$FBXTreeParser {
    constructor(textureLoader, manager, jpgMap){
        this.textureLoader = textureLoader;
        this.manager = manager;
        this.jpgMap = jpgMap || {};
    }
    async parse() {
        $34df7f268a78e6c9$var$connections = this.parseConnections();
        const images = this.parseImages();
        const textures = await this.parseTextures(images);
        const materials = this.parseMaterials(textures);
        const deformers = this.parseDeformers();
        const geometryMap = new $34df7f268a78e6c9$var$GeometryParser().parse(deformers);
        this.parseScene(deformers, geometryMap, materials);
        return $34df7f268a78e6c9$var$sceneGraph;
    }
    // Parses FBXTree.Connections which holds parent-child connections between objects (e.g. material -> texture, model->geometry )
    // and details the connection type
    parseConnections() {
        const connectionMap = new Map();
        if ('Connections' in $34df7f268a78e6c9$var$fbxTree) {
            const rawConnections = $34df7f268a78e6c9$var$fbxTree.Connections.connections;
            rawConnections.forEach(function(rawConnection) {
                const fromID = rawConnection[0];
                const toID = rawConnection[1];
                const relationship = rawConnection[2];
                if (!connectionMap.has(fromID)) connectionMap.set(fromID, {
                    parents: [],
                    children: []
                });
                const parentRelationship = {
                    ID: toID,
                    relationship: relationship
                };
                connectionMap.get(fromID).parents.push(parentRelationship);
                if (!connectionMap.has(toID)) connectionMap.set(toID, {
                    parents: [],
                    children: []
                });
                const childRelationship = {
                    ID: fromID,
                    relationship: relationship
                };
                connectionMap.get(toID).children.push(childRelationship);
            });
        }
        return connectionMap;
    }
    // Parse FBXTree.Objects.Video for embedded image data
    // These images are connected to textures in FBXTree.Objects.Textures
    // via FBXTree.Connections.
    parseImages() {
        const images = {};
        const blobs = {};
        if ('Video' in $34df7f268a78e6c9$var$fbxTree.Objects) {
            const videoNodes = $34df7f268a78e6c9$var$fbxTree.Objects.Video;
            for(const nodeID in videoNodes){
                const videoNode = videoNodes[nodeID];
                const id = parseInt(nodeID);
                images[id] = videoNode.RelativeFilename || videoNode.Filename;
                // raw image data is in videoNode.Content
                if ('Content' in videoNode) {
                    const arrayBufferContent = videoNode.Content instanceof ArrayBuffer && videoNode.Content.byteLength > 0;
                    const base64Content = typeof videoNode.Content === 'string' && videoNode.Content !== '';
                    if (arrayBufferContent || base64Content) {
                        const image = this.parseImage(videoNodes[nodeID]);
                        blobs[videoNode.RelativeFilename || videoNode.Filename] = image;
                    }
                }
            }
        }
        for(const id in images){
            const filename = images[id];
            if (blobs[filename] !== undefined) images[id] = blobs[filename];
            else images[id] = images[id].split('\\').pop();
        }
        return images;
    }
    // Parse embedded image data in FBXTree.Video.Content
    parseImage(videoNode) {
        const content = videoNode.Content;
        const fileName = videoNode.RelativeFilename || videoNode.Filename;
        const extension = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();
        let type;
        switch(extension){
            case 'bmp':
                type = 'image/bmp';
                break;
            case 'jpg':
            case 'jpeg':
                type = 'image/jpeg';
                break;
            case 'png':
                type = 'image/png';
                break;
            case 'tif':
                type = 'image/tiff';
                break;
            case 'tga':
                if (this.manager.getHandler('.tga') === null) console.warn('FBXLoader: TGA loader not found, skipping ', fileName);
                type = 'image/tga';
                break;
            default:
                console.warn('FBXLoader: Image type "' + extension + '" is not supported.');
                return;
        }
        if (typeof content === 'string') // ASCII format
        return 'data:' + type + ';base64,' + content;
        else {
            // Binary Format
            const array = new Uint8Array(content);
            return window.URL.createObjectURL(new Blob([
                array
            ], {
                type: type
            }));
        }
    }
    // Parse nodes in FBXTree.Objects.Texture
    // These contain details such as UV scaling, cropping, rotation etc and are connected
    // to images in FBXTree.Objects.Video
    async parseTextures(images) {
        const textureMap = new Map();
        if ('Texture' in $34df7f268a78e6c9$var$fbxTree.Objects) {
            const textureNodes = $34df7f268a78e6c9$var$fbxTree.Objects.Texture;
            for(const nodeID in textureNodes){
                const texture = await this.parseTexture(textureNodes[nodeID], images);
                textureMap.set(parseInt(nodeID), texture);
            }
        }
        return textureMap;
    }
    // Parse individual node in FBXTree.Objects.Texture
    async parseTexture(textureNode, images) {
        const texture = await this.loadTexture(textureNode, images);
        texture.ID = textureNode.id;
        texture.name = textureNode.attrName;
        const wrapModeU = textureNode.WrapModeU;
        const wrapModeV = textureNode.WrapModeV;
        const valueU = wrapModeU !== undefined ? wrapModeU.value : 0;
        const valueV = wrapModeV !== undefined ? wrapModeV.value : 0;
        // http://download.autodesk.com/us/fbx/SDKdocs/FBX_SDK_Help/files/fbxsdkref/class_k_fbx_texture.html#889640e63e2e681259ea81061b85143a
        // 0: repeat(default), 1: clamp
        texture.wrapS = valueU === 0 ? (0, $ilwiq.RepeatWrapping) : (0, $ilwiq.ClampToEdgeWrapping);
        texture.wrapT = valueV === 0 ? (0, $ilwiq.RepeatWrapping) : (0, $ilwiq.ClampToEdgeWrapping);
        if ('Scaling' in textureNode) {
            const values = textureNode.Scaling.value;
            texture.repeat.x = values[0];
            texture.repeat.y = values[1];
        }
        if ('Translation' in textureNode) {
            const values = textureNode.Translation.value;
            texture.offset.x = values[0];
            texture.offset.y = values[1];
        }
        return texture;
    }
    // load a texture specified as a blob or data URI, or via an external URL using TextureLoader
    loadTexture(textureNode, images) {
        return new Promise((resolve, reject)=>{
            let fileName;
            const currentPath = this.textureLoader.path;
            const children = $34df7f268a78e6c9$var$connections.get(textureNode.id).children;
            if (children !== undefined && children.length > 0 && images[children[0].ID] !== undefined) {
                fileName = images[children[0].ID];
                if (this.jpgMap) fileName = (0, $5WBRZ.getJPGKey)(fileName, this.jpgMap);
                if (fileName.indexOf('blob:') === 0 || fileName.indexOf('data:') === 0) this.textureLoader.setPath(undefined);
            }
            const extension = textureNode.FileName.slice(-3).toLowerCase();
            if (extension === 'tga') {
                const loader = this.manager.getHandler('.tga');
                if (loader === null) {
                    console.warn('FBXLoader: TGA loader not found, creating placeholder texture for', textureNode.RelativeFilename);
                    this.textureLoader.setPath(currentPath);
                    resolve(new (0, $ilwiq.Texture)());
                } else {
                    loader.setPath(this.textureLoader.path);
                    const texture = loader.load(fileName);
                    this.textureLoader.setPath(currentPath);
                    resolve(texture);
                }
            } else if (extension === 'psd') {
                console.warn('FBXLoader: PSD textures are not supported, creating placeholder texture for', textureNode.RelativeFilename);
                this.textureLoader.setPath(currentPath);
                resolve(new (0, $ilwiq.Texture)());
            } else this.textureLoader.load(fileName, (texture)=>{
                this.textureLoader.setPath(currentPath);
                resolve(texture);
            }, undefined, reject);
        });
    }
    // Parse nodes in FBXTree.Objects.Material
    parseMaterials(textureMap) {
        const materialMap = new Map();
        if ('Material' in $34df7f268a78e6c9$var$fbxTree.Objects) {
            const materialNodes = $34df7f268a78e6c9$var$fbxTree.Objects.Material;
            for(const nodeID in materialNodes){
                const material = this.parseMaterial(materialNodes[nodeID], textureMap);
                if (material !== null) materialMap.set(parseInt(nodeID), material);
            }
        }
        return materialMap;
    }
    // Parse single node in FBXTree.Objects.Material
    // Materials are connected to texture maps in FBXTree.Objects.Textures
    // FBX format currently only supports Lambert and Phong shading models
    parseMaterial(materialNode, textureMap) {
        const ID = materialNode.id;
        const name = materialNode.attrName;
        let type = materialNode.ShadingModel;
        // Case where FBX wraps shading model in property object.
        if (typeof type === 'object') type = type.value;
        // Ignore unused materials which don't have any connections.
        if (!$34df7f268a78e6c9$var$connections.has(ID)) return null;
        const parameters = this.parseParameters(materialNode, textureMap, ID);
        let material;
        switch(type.toLowerCase()){
            case 'phong':
                material = new (0, $ilwiq.MeshPhongMaterial)();
                break;
            case 'lambert':
                material = new (0, $ilwiq.MeshLambertMaterial)();
                break;
            default:
                console.warn('THREE.FBXLoader: unknown material type "%s". Defaulting to MeshPhongMaterial.', type);
                material = new (0, $ilwiq.MeshPhongMaterial)();
                break;
        }
        material.setValues(parameters);
        material.name = name;
        return material;
    }
    // Parse FBX material and return parameters suitable for a three.js material
    // Also parse the texture map and return any textures associated with the material
    parseParameters(materialNode, textureMap, ID) {
        const parameters = {};
        if (materialNode.BumpFactor) parameters.bumpScale = materialNode.BumpFactor.value;
        if (materialNode.Diffuse) parameters.color = new (0, $ilwiq.Color)().fromArray(materialNode.Diffuse.value);
        else if (materialNode.DiffuseColor && (materialNode.DiffuseColor.type === 'Color' || materialNode.DiffuseColor.type === 'ColorRGB')) // The blender exporter exports diffuse here instead of in materialNode.Diffuse
        parameters.color = new (0, $ilwiq.Color)().fromArray(materialNode.DiffuseColor.value);
        if (materialNode.DisplacementFactor) parameters.displacementScale = materialNode.DisplacementFactor.value;
        if (materialNode.Emissive) parameters.emissive = new (0, $ilwiq.Color)().fromArray(materialNode.Emissive.value);
        else if (materialNode.EmissiveColor && (materialNode.EmissiveColor.type === 'Color' || materialNode.EmissiveColor.type === 'ColorRGB')) // The blender exporter exports emissive color here instead of in materialNode.Emissive
        parameters.emissive = new (0, $ilwiq.Color)().fromArray(materialNode.EmissiveColor.value);
        if (materialNode.EmissiveFactor) parameters.emissiveIntensity = parseFloat(materialNode.EmissiveFactor.value);
        if (materialNode.Opacity) parameters.opacity = parseFloat(materialNode.Opacity.value);
        if (parameters.opacity < 1.0) parameters.transparent = true;
        if (materialNode.ReflectionFactor) parameters.reflectivity = materialNode.ReflectionFactor.value;
        if (materialNode.Shininess) parameters.shininess = materialNode.Shininess.value;
        if (materialNode.Specular) parameters.specular = new (0, $ilwiq.Color)().fromArray(materialNode.Specular.value);
        else if (materialNode.SpecularColor && materialNode.SpecularColor.type === 'Color') // The blender exporter exports specular color here instead of in materialNode.Specular
        parameters.specular = new (0, $ilwiq.Color)().fromArray(materialNode.SpecularColor.value);
        const scope = this;
        $34df7f268a78e6c9$var$connections.get(ID).children.forEach(function(child) {
            const type = child.relationship;
            switch(type){
                case 'Bump':
                    parameters.bumpMap = scope.getTexture(textureMap, child.ID);
                    break;
                case 'Maya|TEX_ao_map':
                    parameters.aoMap = scope.getTexture(textureMap, child.ID);
                    break;
                case 'DiffuseColor':
                case 'Maya|TEX_color_map':
                    parameters.map = scope.getTexture(textureMap, child.ID);
                    if (parameters.map !== undefined) parameters.map.encoding = (0, $ilwiq.sRGBEncoding);
                    break;
                case 'DisplacementColor':
                    parameters.displacementMap = scope.getTexture(textureMap, child.ID);
                    break;
                case 'EmissiveColor':
                    parameters.emissiveMap = scope.getTexture(textureMap, child.ID);
                    if (parameters.emissiveMap !== undefined) parameters.emissiveMap.encoding = (0, $ilwiq.sRGBEncoding);
                    break;
                case 'NormalMap':
                case 'Maya|TEX_normal_map':
                    parameters.normalMap = scope.getTexture(textureMap, child.ID);
                    break;
                case 'ReflectionColor':
                    parameters.envMap = scope.getTexture(textureMap, child.ID);
                    if (parameters.envMap !== undefined) {
                        parameters.envMap.mapping = (0, $ilwiq.EquirectangularReflectionMapping);
                        parameters.envMap.encoding = (0, $ilwiq.sRGBEncoding);
                    }
                    break;
                case 'SpecularColor':
                    parameters.specularMap = scope.getTexture(textureMap, child.ID);
                    if (parameters.specularMap !== undefined) parameters.specularMap.encoding = (0, $ilwiq.sRGBEncoding);
                    break;
                case 'TransparentColor':
                case 'TransparencyFactor':
                    parameters.alphaMap = scope.getTexture(textureMap, child.ID);
                    parameters.transparent = true;
                    break;
                case 'AmbientColor':
                case 'ShininessExponent':
                case 'SpecularFactor':
                case 'VectorDisplacementColor':
                default:
                    console.warn('THREE.FBXLoader: %s map is not supported in three.js, skipping texture.', type);
                    break;
            }
        });
        return parameters;
    }
    // get a texture from the textureMap for use by a material.
    getTexture(textureMap, id) {
        // if the texture is a layered texture, just use the first layer and issue a warning
        if ('LayeredTexture' in $34df7f268a78e6c9$var$fbxTree.Objects && id in $34df7f268a78e6c9$var$fbxTree.Objects.LayeredTexture) {
            console.warn('THREE.FBXLoader: layered textures are not supported in three.js. Discarding all but first layer.');
            id = $34df7f268a78e6c9$var$connections.get(id).children[0].ID;
        }
        return textureMap.get(id);
    }
    // Parse nodes in FBXTree.Objects.Deformer
    // Deformer node can contain skinning or Vertex Cache animation data, however only skinning is supported here
    // Generates map of Skeleton-like objects for use later when generating and binding skeletons.
    parseDeformers() {
        const skeletons = {};
        const morphTargets = {};
        if ('Deformer' in $34df7f268a78e6c9$var$fbxTree.Objects) {
            const DeformerNodes = $34df7f268a78e6c9$var$fbxTree.Objects.Deformer;
            for(const nodeID in DeformerNodes){
                const deformerNode = DeformerNodes[nodeID];
                const relationships = $34df7f268a78e6c9$var$connections.get(parseInt(nodeID));
                if (deformerNode.attrType === 'Skin') {
                    const skeleton = this.parseSkeleton(relationships, DeformerNodes);
                    skeleton.ID = nodeID;
                    if (relationships.parents.length > 1) console.warn('THREE.FBXLoader: skeleton attached to more than one geometry is not supported.');
                    skeleton.geometryID = relationships.parents[0].ID;
                    skeletons[nodeID] = skeleton;
                } else if (deformerNode.attrType === 'BlendShape') {
                    const morphTarget = {
                        id: nodeID
                    };
                    morphTarget.rawTargets = this.parseMorphTargets(relationships, DeformerNodes);
                    morphTarget.id = nodeID;
                    if (relationships.parents.length > 1) console.warn('THREE.FBXLoader: morph target attached to more than one geometry is not supported.');
                    morphTargets[nodeID] = morphTarget;
                }
            }
        }
        return {
            skeletons: skeletons,
            morphTargets: morphTargets
        };
    }
    // Parse single nodes in FBXTree.Objects.Deformer
    // The top level skeleton node has type 'Skin' and sub nodes have type 'Cluster'
    // Each skin node represents a skeleton and each cluster node represents a bone
    parseSkeleton(relationships, deformerNodes) {
        const rawBones = [];
        relationships.children.forEach(function(child) {
            const boneNode = deformerNodes[child.ID];
            if (boneNode.attrType !== 'Cluster') return;
            const rawBone = {
                ID: child.ID,
                indices: [],
                weights: [],
                transformLink: new (0, $ilwiq.Matrix4)().fromArray(boneNode.TransformLink.a)
            };
            if ('Indexes' in boneNode) {
                rawBone.indices = boneNode.Indexes.a;
                rawBone.weights = boneNode.Weights.a;
            }
            rawBones.push(rawBone);
        });
        return {
            rawBones: rawBones,
            bones: []
        };
    }
    // The top level morph deformer node has type "BlendShape" and sub nodes have type "BlendShapeChannel"
    parseMorphTargets(relationships, deformerNodes) {
        const rawMorphTargets = [];
        for(let i = 0; i < relationships.children.length; i++){
            const child = relationships.children[i];
            const morphTargetNode = deformerNodes[child.ID];
            const rawMorphTarget = {
                name: morphTargetNode.attrName,
                initialWeight: morphTargetNode.DeformPercent,
                id: morphTargetNode.id,
                fullWeights: morphTargetNode.FullWeights.a
            };
            if (morphTargetNode.attrType !== 'BlendShapeChannel') return;
            rawMorphTarget.geoID = $34df7f268a78e6c9$var$connections.get(parseInt(child.ID)).children.filter(function(child) {
                return child.relationship === undefined;
            })[0].ID;
            rawMorphTargets.push(rawMorphTarget);
        }
        return rawMorphTargets;
    }
    // create the main Group() to be returned by the loader
    parseScene(deformers, geometryMap, materialMap) {
        $34df7f268a78e6c9$var$sceneGraph = new (0, $ilwiq.Group)();
        const modelMap = this.parseModels(deformers.skeletons, geometryMap, materialMap);
        const modelNodes = $34df7f268a78e6c9$var$fbxTree.Objects.Model;
        const scope = this;
        modelMap.forEach(function(model) {
            const modelNode = modelNodes[model.ID];
            scope.setLookAtProperties(model, modelNode);
            const parentConnections = $34df7f268a78e6c9$var$connections.get(model.ID).parents;
            parentConnections.forEach(function(connection) {
                const parent = modelMap.get(connection.ID);
                if (parent !== undefined) parent.add(model);
            });
            if (model.parent === null) $34df7f268a78e6c9$var$sceneGraph.add(model);
        });
        this.bindSkeleton(deformers.skeletons, geometryMap, modelMap);
        this.createAmbientLight();
        $34df7f268a78e6c9$var$sceneGraph.traverse(function(node) {
            if (node.userData.transformData) {
                if (node.parent) {
                    node.userData.transformData.parentMatrix = node.parent.matrix;
                    node.userData.transformData.parentMatrixWorld = node.parent.matrixWorld;
                }
                const transform = $34df7f268a78e6c9$var$generateTransform(node.userData.transformData);
                node.applyMatrix4(transform);
                node.updateWorldMatrix();
            }
        });
        const animations = new $34df7f268a78e6c9$var$AnimationParser().parse();
        // if all the models where already combined in a single group, just return that
        if ($34df7f268a78e6c9$var$sceneGraph.children.length === 1 && $34df7f268a78e6c9$var$sceneGraph.children[0].isGroup) {
            $34df7f268a78e6c9$var$sceneGraph.children[0].animations = animations;
            $34df7f268a78e6c9$var$sceneGraph = $34df7f268a78e6c9$var$sceneGraph.children[0];
        }
        $34df7f268a78e6c9$var$sceneGraph.animations = animations;
    }
    // parse nodes in FBXTree.Objects.Model
    parseModels(skeletons, geometryMap, materialMap) {
        const modelMap = new Map();
        const modelNodes = $34df7f268a78e6c9$var$fbxTree.Objects.Model;
        for(const nodeID in modelNodes){
            const id = parseInt(nodeID);
            const node = modelNodes[nodeID];
            const relationships = $34df7f268a78e6c9$var$connections.get(id);
            let model = this.buildSkeleton(relationships, skeletons, id, node.attrName);
            if (!model) {
                switch(node.attrType){
                    case 'Camera':
                        model = this.createCamera(relationships);
                        break;
                    case 'Light':
                        model = this.createLight(relationships);
                        break;
                    case 'Mesh':
                        model = this.createMesh(relationships, geometryMap, materialMap);
                        break;
                    case 'NurbsCurve':
                        model = this.createCurve(relationships, geometryMap);
                        break;
                    case 'LimbNode':
                    case 'Root':
                        model = new (0, $ilwiq.Bone)();
                        break;
                    case 'Null':
                    default:
                        model = new (0, $ilwiq.Group)();
                        break;
                }
                model.name = node.attrName ? (0, $ilwiq.PropertyBinding).sanitizeNodeName(node.attrName) : '';
                model.ID = id;
            }
            this.getTransformData(model, node);
            modelMap.set(id, model);
        }
        return modelMap;
    }
    buildSkeleton(relationships, skeletons, id, name) {
        let bone = null;
        relationships.parents.forEach(function(parent) {
            for(const ID in skeletons){
                const skeleton = skeletons[ID];
                skeleton.rawBones.forEach(function(rawBone, i) {
                    if (rawBone.ID === parent.ID) {
                        const subBone = bone;
                        bone = new (0, $ilwiq.Bone)();
                        bone.matrixWorld.copy(rawBone.transformLink);
                        // set name and id here - otherwise in cases where "subBone" is created it will not have a name / id
                        bone.name = name ? (0, $ilwiq.PropertyBinding).sanitizeNodeName(name) : '';
                        bone.ID = id;
                        skeleton.bones[i] = bone;
                        // In cases where a bone is shared between multiple meshes
                        // duplicate the bone here and and it as a child of the first bone
                        if (subBone !== null) bone.add(subBone);
                    }
                });
            }
        });
        return bone;
    }
    // create a PerspectiveCamera or OrthographicCamera
    createCamera(relationships) {
        let model;
        let cameraAttribute;
        relationships.children.forEach(function(child) {
            const attr = $34df7f268a78e6c9$var$fbxTree.Objects.NodeAttribute[child.ID];
            if (attr !== undefined) cameraAttribute = attr;
        });
        if (cameraAttribute === undefined) model = new (0, $ilwiq.Object3D)();
        else {
            let type = 0;
            if (cameraAttribute.CameraProjectionType !== undefined && cameraAttribute.CameraProjectionType.value === 1) type = 1;
            let nearClippingPlane = 1;
            if (cameraAttribute.NearPlane !== undefined) nearClippingPlane = cameraAttribute.NearPlane.value / 1000;
            let farClippingPlane = 1000;
            if (cameraAttribute.FarPlane !== undefined) farClippingPlane = cameraAttribute.FarPlane.value / 1000;
            let width = window.innerWidth;
            let height = window.innerHeight;
            if (cameraAttribute.AspectWidth !== undefined && cameraAttribute.AspectHeight !== undefined) {
                width = cameraAttribute.AspectWidth.value;
                height = cameraAttribute.AspectHeight.value;
            }
            const aspect = width / height;
            let fov = 45;
            if (cameraAttribute.FieldOfView !== undefined) fov = cameraAttribute.FieldOfView.value;
            const focalLength = cameraAttribute.FocalLength ? cameraAttribute.FocalLength.value : null;
            switch(type){
                case 0:
                    model = new (0, $ilwiq.PerspectiveCamera)(fov, aspect, nearClippingPlane, farClippingPlane);
                    if (focalLength !== null) model.setFocalLength(focalLength);
                    break;
                case 1:
                    model = new (0, $ilwiq.OrthographicCamera)(-width / 2, width / 2, height / 2, -height / 2, nearClippingPlane, farClippingPlane);
                    break;
                default:
                    console.warn('THREE.FBXLoader: Unknown camera type ' + type + '.');
                    model = new (0, $ilwiq.Object3D)();
                    break;
            }
        }
        return model;
    }
    // Create a DirectionalLight, PointLight or SpotLight
    createLight(relationships) {
        let model;
        let lightAttribute;
        relationships.children.forEach(function(child) {
            const attr = $34df7f268a78e6c9$var$fbxTree.Objects.NodeAttribute[child.ID];
            if (attr !== undefined) lightAttribute = attr;
        });
        if (lightAttribute === undefined) model = new (0, $ilwiq.Object3D)();
        else {
            let type;
            // LightType can be undefined for Point lights
            if (lightAttribute.LightType === undefined) type = 0;
            else type = lightAttribute.LightType.value;
            let color = 0xffffff;
            if (lightAttribute.Color !== undefined) color = new (0, $ilwiq.Color)().fromArray(lightAttribute.Color.value);
            let intensity = lightAttribute.Intensity === undefined ? 1 : lightAttribute.Intensity.value / 100;
            // light disabled
            if (lightAttribute.CastLightOnObject !== undefined && lightAttribute.CastLightOnObject.value === 0) intensity = 0;
            let distance = 0;
            if (lightAttribute.FarAttenuationEnd !== undefined) {
                if (lightAttribute.EnableFarAttenuation !== undefined && lightAttribute.EnableFarAttenuation.value === 0) distance = 0;
                else distance = lightAttribute.FarAttenuationEnd.value;
            }
            // TODO: could this be calculated linearly from FarAttenuationStart to FarAttenuationEnd?
            const decay = 1;
            switch(type){
                case 0:
                    model = new (0, $ilwiq.PointLight)(color, intensity, distance, decay);
                    break;
                case 1:
                    model = new (0, $ilwiq.DirectionalLight)(color, intensity);
                    break;
                case 2:
                    let angle = Math.PI / 3;
                    if (lightAttribute.InnerAngle !== undefined) angle = (0, $ilwiq.MathUtils).degToRad(lightAttribute.InnerAngle.value);
                    let penumbra = 0;
                    if (lightAttribute.OuterAngle !== undefined) {
                        // TODO: this is not correct - FBX calculates outer and inner angle in degrees
                        // with OuterAngle > InnerAngle && OuterAngle <= Math.PI
                        // while three.js uses a penumbra between (0, 1) to attenuate the inner angle
                        penumbra = (0, $ilwiq.MathUtils).degToRad(lightAttribute.OuterAngle.value);
                        penumbra = Math.max(penumbra, 1);
                    }
                    model = new (0, $ilwiq.SpotLight)(color, intensity, distance, angle, penumbra, decay);
                    break;
                default:
                    console.warn('THREE.FBXLoader: Unknown light type ' + lightAttribute.LightType.value + ', defaulting to a PointLight.');
                    model = new (0, $ilwiq.PointLight)(color, intensity);
                    break;
            }
            if (lightAttribute.CastShadows !== undefined && lightAttribute.CastShadows.value === 1) model.castShadow = true;
        }
        return model;
    }
    createMesh(relationships, geometryMap, materialMap) {
        let model;
        let geometry = null;
        let material = null;
        const materials = [];
        // get geometry and materials(s) from connections
        relationships.children.forEach(function(child) {
            if (geometryMap.has(child.ID)) geometry = geometryMap.get(child.ID);
            if (materialMap.has(child.ID)) materials.push(materialMap.get(child.ID));
        });
        if (materials.length > 1) material = materials;
        else if (materials.length > 0) material = materials[0];
        else {
            material = new (0, $ilwiq.MeshPhongMaterial)({
                color: 0xcccccc
            });
            materials.push(material);
        }
        if ('color' in geometry.attributes) materials.forEach(function(material) {
            material.vertexColors = true;
        });
        if (geometry.FBX_Deformer) {
            model = new (0, $ilwiq.SkinnedMesh)(geometry, material);
            model.normalizeSkinWeights();
        } else model = new (0, $ilwiq.Mesh)(geometry, material);
        return model;
    }
    createCurve(relationships, geometryMap) {
        const geometry = relationships.children.reduce(function(geo, child) {
            if (geometryMap.has(child.ID)) geo = geometryMap.get(child.ID);
            return geo;
        }, null);
        // FBX does not list materials for Nurbs lines, so we'll just put our own in here.
        const material = new (0, $ilwiq.LineBasicMaterial)({
            color: 0x3300ff,
            linewidth: 1
        });
        return new (0, $ilwiq.Line)(geometry, material);
    }
    // parse the model node for transform data
    getTransformData(model, modelNode) {
        const transformData = {};
        if ('InheritType' in modelNode) transformData.inheritType = parseInt(modelNode.InheritType.value);
        if ('RotationOrder' in modelNode) transformData.eulerOrder = $34df7f268a78e6c9$var$getEulerOrder(modelNode.RotationOrder.value);
        else transformData.eulerOrder = 'ZYX';
        if ('Lcl_Translation' in modelNode) transformData.translation = modelNode.Lcl_Translation.value;
        if ('PreRotation' in modelNode) transformData.preRotation = modelNode.PreRotation.value;
        if ('Lcl_Rotation' in modelNode) transformData.rotation = modelNode.Lcl_Rotation.value;
        if ('PostRotation' in modelNode) transformData.postRotation = modelNode.PostRotation.value;
        if ('Lcl_Scaling' in modelNode) transformData.scale = modelNode.Lcl_Scaling.value;
        if ('ScalingOffset' in modelNode) transformData.scalingOffset = modelNode.ScalingOffset.value;
        if ('ScalingPivot' in modelNode) transformData.scalingPivot = modelNode.ScalingPivot.value;
        if ('RotationOffset' in modelNode) transformData.rotationOffset = modelNode.RotationOffset.value;
        if ('RotationPivot' in modelNode) transformData.rotationPivot = modelNode.RotationPivot.value;
        model.userData.transformData = transformData;
    }
    setLookAtProperties(model, modelNode) {
        if ('LookAtProperty' in modelNode) {
            const children = $34df7f268a78e6c9$var$connections.get(model.ID).children;
            children.forEach(function(child) {
                if (child.relationship === 'LookAtProperty') {
                    const lookAtTarget = $34df7f268a78e6c9$var$fbxTree.Objects.Model[child.ID];
                    if ('Lcl_Translation' in lookAtTarget) {
                        const pos = lookAtTarget.Lcl_Translation.value;
                        // DirectionalLight, SpotLight
                        if (model.target !== undefined) {
                            model.target.position.fromArray(pos);
                            $34df7f268a78e6c9$var$sceneGraph.add(model.target);
                        } else // Cameras and other Object3Ds
                        model.lookAt(new (0, $ilwiq.Vector3)().fromArray(pos));
                    }
                }
            });
        }
    }
    bindSkeleton(skeletons, geometryMap, modelMap) {
        const bindMatrices = this.parsePoseNodes();
        for(const ID in skeletons){
            const skeleton = skeletons[ID];
            const parents = $34df7f268a78e6c9$var$connections.get(parseInt(skeleton.ID)).parents;
            parents.forEach(function(parent) {
                if (geometryMap.has(parent.ID)) {
                    const geoID = parent.ID;
                    const geoRelationships = $34df7f268a78e6c9$var$connections.get(geoID);
                    geoRelationships.parents.forEach(function(geoConnParent) {
                        if (modelMap.has(geoConnParent.ID)) {
                            const model = modelMap.get(geoConnParent.ID);
                            model.bind(new (0, $ilwiq.Skeleton)(skeleton.bones), bindMatrices[geoConnParent.ID]);
                        }
                    });
                }
            });
        }
    }
    parsePoseNodes() {
        const bindMatrices = {};
        if ('Pose' in $34df7f268a78e6c9$var$fbxTree.Objects) {
            const BindPoseNode = $34df7f268a78e6c9$var$fbxTree.Objects.Pose;
            for(const nodeID in BindPoseNode)if (BindPoseNode[nodeID].attrType === 'BindPose' && BindPoseNode[nodeID].NbPoseNodes > 0) {
                const poseNodes = BindPoseNode[nodeID].PoseNode;
                if (Array.isArray(poseNodes)) poseNodes.forEach(function(poseNode) {
                    bindMatrices[poseNode.Node] = new (0, $ilwiq.Matrix4)().fromArray(poseNode.Matrix.a);
                });
                else bindMatrices[poseNodes.Node] = new (0, $ilwiq.Matrix4)().fromArray(poseNodes.Matrix.a);
            }
        }
        return bindMatrices;
    }
    // Parse ambient color in FBXTree.GlobalSettings - if it's not set to black (default), create an ambient light
    createAmbientLight() {
        if ('GlobalSettings' in $34df7f268a78e6c9$var$fbxTree && 'AmbientColor' in $34df7f268a78e6c9$var$fbxTree.GlobalSettings) {
            const ambientColor = $34df7f268a78e6c9$var$fbxTree.GlobalSettings.AmbientColor.value;
            const r = ambientColor[0];
            const g = ambientColor[1];
            const b = ambientColor[2];
            if (r !== 0 || g !== 0 || b !== 0) {
                const color = new (0, $ilwiq.Color)(r, g, b);
                $34df7f268a78e6c9$var$sceneGraph.add(new (0, $ilwiq.AmbientLight)(color, 1));
            }
        }
    }
}
// parse Geometry data from FBXTree and return map of BufferGeometries
class $34df7f268a78e6c9$var$GeometryParser {
    // Parse nodes in FBXTree.Objects.Geometry
    parse(deformers) {
        const geometryMap = new Map();
        if ('Geometry' in $34df7f268a78e6c9$var$fbxTree.Objects) {
            const geoNodes = $34df7f268a78e6c9$var$fbxTree.Objects.Geometry;
            for(const nodeID in geoNodes){
                const relationships = $34df7f268a78e6c9$var$connections.get(parseInt(nodeID));
                const geo = this.parseGeometry(relationships, geoNodes[nodeID], deformers);
                geometryMap.set(parseInt(nodeID), geo);
            }
        }
        return geometryMap;
    }
    // Parse single node in FBXTree.Objects.Geometry
    parseGeometry(relationships, geoNode, deformers) {
        switch(geoNode.attrType){
            case 'Mesh':
                return this.parseMeshGeometry(relationships, geoNode, deformers);
            case 'NurbsCurve':
                return this.parseNurbsGeometry(geoNode);
        }
    }
    // Parse single node mesh geometry in FBXTree.Objects.Geometry
    parseMeshGeometry(relationships, geoNode, deformers) {
        const skeletons = deformers.skeletons;
        const morphTargets = [];
        const modelNodes = relationships.parents.map(function(parent) {
            return $34df7f268a78e6c9$var$fbxTree.Objects.Model[parent.ID];
        });
        // don't create geometry if it is not associated with any models
        if (modelNodes.length === 0) return;
        const skeleton = relationships.children.reduce(function(skeleton, child) {
            if (skeletons[child.ID] !== undefined) skeleton = skeletons[child.ID];
            return skeleton;
        }, null);
        relationships.children.forEach(function(child) {
            if (deformers.morphTargets[child.ID] !== undefined) morphTargets.push(deformers.morphTargets[child.ID]);
        });
        // Assume one model and get the preRotation from that
        // if there is more than one model associated with the geometry this may cause problems
        const modelNode = modelNodes[0];
        const transformData = {};
        if ('RotationOrder' in modelNode) transformData.eulerOrder = $34df7f268a78e6c9$var$getEulerOrder(modelNode.RotationOrder.value);
        if ('InheritType' in modelNode) transformData.inheritType = parseInt(modelNode.InheritType.value);
        if ('GeometricTranslation' in modelNode) transformData.translation = modelNode.GeometricTranslation.value;
        if ('GeometricRotation' in modelNode) transformData.rotation = modelNode.GeometricRotation.value;
        if ('GeometricScaling' in modelNode) transformData.scale = modelNode.GeometricScaling.value;
        const transform = $34df7f268a78e6c9$var$generateTransform(transformData);
        return this.genGeometry(geoNode, skeleton, morphTargets, transform);
    }
    // Generate a BufferGeometry from a node in FBXTree.Objects.Geometry
    genGeometry(geoNode, skeleton, morphTargets, preTransform) {
        const geo = new (0, $ilwiq.BufferGeometry)();
        if (geoNode.attrName) geo.name = geoNode.attrName;
        const geoInfo = this.parseGeoNode(geoNode, skeleton);
        const buffers = this.genBuffers(geoInfo);
        const positionAttribute = new (0, $ilwiq.Float32BufferAttribute)(buffers.vertex, 3);
        positionAttribute.applyMatrix4(preTransform);
        geo.setAttribute('position', positionAttribute);
        if (buffers.colors.length > 0) geo.setAttribute('color', new (0, $ilwiq.Float32BufferAttribute)(buffers.colors, 3));
        if (skeleton) {
            geo.setAttribute('skinIndex', new (0, $ilwiq.Uint16BufferAttribute)(buffers.weightsIndices, 4));
            geo.setAttribute('skinWeight', new (0, $ilwiq.Float32BufferAttribute)(buffers.vertexWeights, 4));
            // used later to bind the skeleton to the model
            geo.FBX_Deformer = skeleton;
        }
        if (buffers.normal.length > 0) {
            const normalMatrix = new (0, $ilwiq.Matrix3)().getNormalMatrix(preTransform);
            const normalAttribute = new (0, $ilwiq.Float32BufferAttribute)(buffers.normal, 3);
            normalAttribute.applyNormalMatrix(normalMatrix);
            geo.setAttribute('normal', normalAttribute);
        }
        buffers.uvs.forEach(function(uvBuffer, i) {
            // subsequent uv buffers are called 'uv1', 'uv2', ...
            let name = 'uv' + (i + 1).toString();
            // the first uv buffer is just called 'uv'
            if (i === 0) name = 'uv';
            geo.setAttribute(name, new (0, $ilwiq.Float32BufferAttribute)(buffers.uvs[i], 2));
        });
        if (geoInfo.material && geoInfo.material.mappingType !== 'AllSame') {
            // Convert the material indices of each vertex into rendering groups on the geometry.
            let prevMaterialIndex = buffers.materialIndex[0];
            let startIndex = 0;
            buffers.materialIndex.forEach(function(currentIndex, i) {
                if (currentIndex !== prevMaterialIndex) {
                    geo.addGroup(startIndex, i - startIndex, prevMaterialIndex);
                    prevMaterialIndex = currentIndex;
                    startIndex = i;
                }
            });
            // the loop above doesn't add the last group, do that here.
            if (geo.groups.length > 0) {
                const lastGroup = geo.groups[geo.groups.length - 1];
                const lastIndex = lastGroup.start + lastGroup.count;
                if (lastIndex !== buffers.materialIndex.length) geo.addGroup(lastIndex, buffers.materialIndex.length - lastIndex, prevMaterialIndex);
            }
            // case where there are multiple materials but the whole geometry is only
            // using one of them
            if (geo.groups.length === 0) geo.addGroup(0, buffers.materialIndex.length, buffers.materialIndex[0]);
        }
        this.addMorphTargets(geo, geoNode, morphTargets, preTransform);
        return geo;
    }
    parseGeoNode(geoNode, skeleton) {
        const geoInfo = {};
        geoInfo.vertexPositions = geoNode.Vertices !== undefined ? geoNode.Vertices.a : [];
        geoInfo.vertexIndices = geoNode.PolygonVertexIndex !== undefined ? geoNode.PolygonVertexIndex.a : [];
        if (geoNode.LayerElementColor) geoInfo.color = this.parseVertexColors(geoNode.LayerElementColor[0]);
        if (geoNode.LayerElementMaterial) geoInfo.material = this.parseMaterialIndices(geoNode.LayerElementMaterial[0]);
        if (geoNode.LayerElementNormal) geoInfo.normal = this.parseNormals(geoNode.LayerElementNormal[0]);
        if (geoNode.LayerElementUV) {
            geoInfo.uv = [];
            let i = 0;
            while(geoNode.LayerElementUV[i]){
                if (geoNode.LayerElementUV[i].UV) geoInfo.uv.push(this.parseUVs(geoNode.LayerElementUV[i]));
                i++;
            }
        }
        geoInfo.weightTable = {};
        if (skeleton !== null) {
            geoInfo.skeleton = skeleton;
            skeleton.rawBones.forEach(function(rawBone, i) {
                // loop over the bone's vertex indices and weights
                rawBone.indices.forEach(function(index, j) {
                    if (geoInfo.weightTable[index] === undefined) geoInfo.weightTable[index] = [];
                    geoInfo.weightTable[index].push({
                        id: i,
                        weight: rawBone.weights[j]
                    });
                });
            });
        }
        return geoInfo;
    }
    genBuffers(geoInfo) {
        const buffers = {
            vertex: [],
            normal: [],
            colors: [],
            uvs: [],
            materialIndex: [],
            vertexWeights: [],
            weightsIndices: []
        };
        let polygonIndex = 0;
        let faceLength = 0;
        let displayedWeightsWarning = false;
        // these will hold data for a single face
        let facePositionIndexes = [];
        let faceNormals = [];
        let faceColors = [];
        let faceUVs = [];
        let faceWeights = [];
        let faceWeightIndices = [];
        const scope = this;
        geoInfo.vertexIndices.forEach(function(vertexIndex, polygonVertexIndex) {
            let materialIndex;
            let endOfFace = false;
            // Face index and vertex index arrays are combined in a single array
            // A cube with quad faces looks like this:
            // PolygonVertexIndex: *24 {
            //  a: 0, 1, 3, -3, 2, 3, 5, -5, 4, 5, 7, -7, 6, 7, 1, -1, 1, 7, 5, -4, 6, 0, 2, -5
            //  }
            // Negative numbers mark the end of a face - first face here is 0, 1, 3, -3
            // to find index of last vertex bit shift the index: ^ - 1
            if (vertexIndex < 0) {
                vertexIndex = vertexIndex ^ -1 // equivalent to ( x * -1 ) - 1
                ;
                endOfFace = true;
            }
            let weightIndices = [];
            let weights = [];
            facePositionIndexes.push(vertexIndex * 3, vertexIndex * 3 + 1, vertexIndex * 3 + 2);
            if (geoInfo.color) {
                const data = $34df7f268a78e6c9$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.color);
                faceColors.push(data[0], data[1], data[2]);
            }
            if (geoInfo.skeleton) {
                if (geoInfo.weightTable[vertexIndex] !== undefined) geoInfo.weightTable[vertexIndex].forEach(function(wt) {
                    weights.push(wt.weight);
                    weightIndices.push(wt.id);
                });
                if (weights.length > 4) {
                    if (!displayedWeightsWarning) {
                        console.warn('THREE.FBXLoader: Vertex has more than 4 skinning weights assigned to vertex. Deleting additional weights.');
                        displayedWeightsWarning = true;
                    }
                    const wIndex = [
                        0,
                        0,
                        0,
                        0
                    ];
                    const Weight = [
                        0,
                        0,
                        0,
                        0
                    ];
                    weights.forEach(function(weight, weightIndex) {
                        let currentWeight = weight;
                        let currentIndex = weightIndices[weightIndex];
                        Weight.forEach(function(comparedWeight, comparedWeightIndex, comparedWeightArray) {
                            if (currentWeight > comparedWeight) {
                                comparedWeightArray[comparedWeightIndex] = currentWeight;
                                currentWeight = comparedWeight;
                                const tmp = wIndex[comparedWeightIndex];
                                wIndex[comparedWeightIndex] = currentIndex;
                                currentIndex = tmp;
                            }
                        });
                    });
                    weightIndices = wIndex;
                    weights = Weight;
                }
                // if the weight array is shorter than 4 pad with 0s
                while(weights.length < 4){
                    weights.push(0);
                    weightIndices.push(0);
                }
                for(let i = 0; i < 4; ++i){
                    faceWeights.push(weights[i]);
                    faceWeightIndices.push(weightIndices[i]);
                }
            }
            if (geoInfo.normal) {
                const data = $34df7f268a78e6c9$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.normal);
                faceNormals.push(data[0], data[1], data[2]);
            }
            if (geoInfo.material && geoInfo.material.mappingType !== 'AllSame') materialIndex = $34df7f268a78e6c9$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, geoInfo.material)[0];
            if (geoInfo.uv) geoInfo.uv.forEach(function(uv, i) {
                const data = $34df7f268a78e6c9$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, uv);
                if (faceUVs[i] === undefined) faceUVs[i] = [];
                faceUVs[i].push(data[0]);
                faceUVs[i].push(data[1]);
            });
            faceLength++;
            if (endOfFace) {
                scope.genFace(buffers, geoInfo, facePositionIndexes, materialIndex, faceNormals, faceColors, faceUVs, faceWeights, faceWeightIndices, faceLength);
                polygonIndex++;
                faceLength = 0;
                // reset arrays for the next face
                facePositionIndexes = [];
                faceNormals = [];
                faceColors = [];
                faceUVs = [];
                faceWeights = [];
                faceWeightIndices = [];
            }
        });
        return buffers;
    }
    // Generate data for a single face in a geometry. If the face is a quad then split it into 2 tris
    genFace(buffers, geoInfo, facePositionIndexes, materialIndex, faceNormals, faceColors, faceUVs, faceWeights, faceWeightIndices, faceLength) {
        for(let i = 2; i < faceLength; i++){
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[0]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[1]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[2]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[(i - 1) * 3]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[(i - 1) * 3 + 1]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[(i - 1) * 3 + 2]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i * 3]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i * 3 + 1]]);
            buffers.vertex.push(geoInfo.vertexPositions[facePositionIndexes[i * 3 + 2]]);
            if (geoInfo.skeleton) {
                buffers.vertexWeights.push(faceWeights[0]);
                buffers.vertexWeights.push(faceWeights[1]);
                buffers.vertexWeights.push(faceWeights[2]);
                buffers.vertexWeights.push(faceWeights[3]);
                buffers.vertexWeights.push(faceWeights[(i - 1) * 4]);
                buffers.vertexWeights.push(faceWeights[(i - 1) * 4 + 1]);
                buffers.vertexWeights.push(faceWeights[(i - 1) * 4 + 2]);
                buffers.vertexWeights.push(faceWeights[(i - 1) * 4 + 3]);
                buffers.vertexWeights.push(faceWeights[i * 4]);
                buffers.vertexWeights.push(faceWeights[i * 4 + 1]);
                buffers.vertexWeights.push(faceWeights[i * 4 + 2]);
                buffers.vertexWeights.push(faceWeights[i * 4 + 3]);
                buffers.weightsIndices.push(faceWeightIndices[0]);
                buffers.weightsIndices.push(faceWeightIndices[1]);
                buffers.weightsIndices.push(faceWeightIndices[2]);
                buffers.weightsIndices.push(faceWeightIndices[3]);
                buffers.weightsIndices.push(faceWeightIndices[(i - 1) * 4]);
                buffers.weightsIndices.push(faceWeightIndices[(i - 1) * 4 + 1]);
                buffers.weightsIndices.push(faceWeightIndices[(i - 1) * 4 + 2]);
                buffers.weightsIndices.push(faceWeightIndices[(i - 1) * 4 + 3]);
                buffers.weightsIndices.push(faceWeightIndices[i * 4]);
                buffers.weightsIndices.push(faceWeightIndices[i * 4 + 1]);
                buffers.weightsIndices.push(faceWeightIndices[i * 4 + 2]);
                buffers.weightsIndices.push(faceWeightIndices[i * 4 + 3]);
            }
            if (geoInfo.color) {
                buffers.colors.push(faceColors[0]);
                buffers.colors.push(faceColors[1]);
                buffers.colors.push(faceColors[2]);
                buffers.colors.push(faceColors[(i - 1) * 3]);
                buffers.colors.push(faceColors[(i - 1) * 3 + 1]);
                buffers.colors.push(faceColors[(i - 1) * 3 + 2]);
                buffers.colors.push(faceColors[i * 3]);
                buffers.colors.push(faceColors[i * 3 + 1]);
                buffers.colors.push(faceColors[i * 3 + 2]);
            }
            if (geoInfo.material && geoInfo.material.mappingType !== 'AllSame') {
                buffers.materialIndex.push(materialIndex);
                buffers.materialIndex.push(materialIndex);
                buffers.materialIndex.push(materialIndex);
            }
            if (geoInfo.normal) {
                buffers.normal.push(faceNormals[0]);
                buffers.normal.push(faceNormals[1]);
                buffers.normal.push(faceNormals[2]);
                buffers.normal.push(faceNormals[(i - 1) * 3]);
                buffers.normal.push(faceNormals[(i - 1) * 3 + 1]);
                buffers.normal.push(faceNormals[(i - 1) * 3 + 2]);
                buffers.normal.push(faceNormals[i * 3]);
                buffers.normal.push(faceNormals[i * 3 + 1]);
                buffers.normal.push(faceNormals[i * 3 + 2]);
            }
            if (geoInfo.uv) geoInfo.uv.forEach(function(uv, j) {
                if (buffers.uvs[j] === undefined) buffers.uvs[j] = [];
                buffers.uvs[j].push(faceUVs[j][0]);
                buffers.uvs[j].push(faceUVs[j][1]);
                buffers.uvs[j].push(faceUVs[j][(i - 1) * 2]);
                buffers.uvs[j].push(faceUVs[j][(i - 1) * 2 + 1]);
                buffers.uvs[j].push(faceUVs[j][i * 2]);
                buffers.uvs[j].push(faceUVs[j][i * 2 + 1]);
            });
        }
    }
    addMorphTargets(parentGeo, parentGeoNode, morphTargets, preTransform) {
        if (morphTargets.length === 0) return;
        parentGeo.morphTargetsRelative = true;
        parentGeo.morphAttributes.position = [];
        // parentGeo.morphAttributes.normal = []; // not implemented
        const scope = this;
        morphTargets.forEach(function(morphTarget) {
            morphTarget.rawTargets.forEach(function(rawTarget) {
                const morphGeoNode = $34df7f268a78e6c9$var$fbxTree.Objects.Geometry[rawTarget.geoID];
                if (morphGeoNode !== undefined) scope.genMorphGeometry(parentGeo, parentGeoNode, morphGeoNode, preTransform, rawTarget.name);
            });
        });
    }
    // a morph geometry node is similar to a standard  node, and the node is also contained
    // in FBXTree.Objects.Geometry, however it can only have attributes for position, normal
    // and a special attribute Index defining which vertices of the original geometry are affected
    // Normal and position attributes only have data for the vertices that are affected by the morph
    genMorphGeometry(parentGeo, parentGeoNode, morphGeoNode, preTransform, name) {
        const vertexIndices = parentGeoNode.PolygonVertexIndex !== undefined ? parentGeoNode.PolygonVertexIndex.a : [];
        const morphPositionsSparse = morphGeoNode.Vertices !== undefined ? morphGeoNode.Vertices.a : [];
        const indices = morphGeoNode.Indexes !== undefined ? morphGeoNode.Indexes.a : [];
        const length = parentGeo.attributes.position.count * 3;
        const morphPositions = new Float32Array(length);
        for(let i = 0; i < indices.length; i++){
            const morphIndex = indices[i] * 3;
            morphPositions[morphIndex] = morphPositionsSparse[i * 3];
            morphPositions[morphIndex + 1] = morphPositionsSparse[i * 3 + 1];
            morphPositions[morphIndex + 2] = morphPositionsSparse[i * 3 + 2];
        }
        // TODO: add morph normal support
        const morphGeoInfo = {
            vertexIndices: vertexIndices,
            vertexPositions: morphPositions
        };
        const morphBuffers = this.genBuffers(morphGeoInfo);
        const positionAttribute = new (0, $ilwiq.Float32BufferAttribute)(morphBuffers.vertex, 3);
        positionAttribute.name = name || morphGeoNode.attrName;
        positionAttribute.applyMatrix4(preTransform);
        parentGeo.morphAttributes.position.push(positionAttribute);
    }
    // Parse normal from FBXTree.Objects.Geometry.LayerElementNormal if it exists
    parseNormals(NormalNode) {
        const mappingType = NormalNode.MappingInformationType;
        const referenceType = NormalNode.ReferenceInformationType;
        const buffer = NormalNode.Normals.a;
        let indexBuffer = [];
        if (referenceType === 'IndexToDirect') {
            if ('NormalIndex' in NormalNode) indexBuffer = NormalNode.NormalIndex.a;
            else if ('NormalsIndex' in NormalNode) indexBuffer = NormalNode.NormalsIndex.a;
        }
        return {
            dataSize: 3,
            buffer: buffer,
            indices: indexBuffer,
            mappingType: mappingType,
            referenceType: referenceType
        };
    }
    // Parse UVs from FBXTree.Objects.Geometry.LayerElementUV if it exists
    parseUVs(UVNode) {
        const mappingType = UVNode.MappingInformationType;
        const referenceType = UVNode.ReferenceInformationType;
        const buffer = UVNode.UV.a;
        let indexBuffer = [];
        if (referenceType === 'IndexToDirect') indexBuffer = UVNode.UVIndex.a;
        return {
            dataSize: 2,
            buffer: buffer,
            indices: indexBuffer,
            mappingType: mappingType,
            referenceType: referenceType
        };
    }
    // Parse Vertex Colors from FBXTree.Objects.Geometry.LayerElementColor if it exists
    parseVertexColors(ColorNode) {
        const mappingType = ColorNode.MappingInformationType;
        const referenceType = ColorNode.ReferenceInformationType;
        const buffer = ColorNode.Colors.a;
        let indexBuffer = [];
        if (referenceType === 'IndexToDirect') indexBuffer = ColorNode.ColorIndex.a;
        return {
            dataSize: 4,
            buffer: buffer,
            indices: indexBuffer,
            mappingType: mappingType,
            referenceType: referenceType
        };
    }
    // Parse mapping and material data in FBXTree.Objects.Geometry.LayerElementMaterial if it exists
    parseMaterialIndices(MaterialNode) {
        const mappingType = MaterialNode.MappingInformationType;
        const referenceType = MaterialNode.ReferenceInformationType;
        if (mappingType === 'NoMappingInformation') return {
            dataSize: 1,
            buffer: [
                0
            ],
            indices: [
                0
            ],
            mappingType: 'AllSame',
            referenceType: referenceType
        };
        const materialIndexBuffer = MaterialNode.Materials.a;
        // Since materials are stored as indices, there's a bit of a mismatch between FBX and what
        // we expect.So we create an intermediate buffer that points to the index in the buffer,
        // for conforming with the other functions we've written for other data.
        const materialIndices = [];
        for(let i = 0; i < materialIndexBuffer.length; ++i)materialIndices.push(i);
        return {
            dataSize: 1,
            buffer: materialIndexBuffer,
            indices: materialIndices,
            mappingType: mappingType,
            referenceType: referenceType
        };
    }
    // Generate a NurbGeometry from a node in FBXTree.Objects.Geometry
    parseNurbsGeometry(geoNode) {
        if ((0, $cLt9Z.NURBSCurve) === undefined) {
            console.error('THREE.FBXLoader: The loader relies on NURBSCurve for any nurbs present in the model. Nurbs will show up as empty geometry.');
            return new (0, $ilwiq.BufferGeometry)();
        }
        const order = parseInt(geoNode.Order);
        if (isNaN(order)) {
            console.error('THREE.FBXLoader: Invalid Order %s given for geometry ID: %s', geoNode.Order, geoNode.id);
            return new (0, $ilwiq.BufferGeometry)();
        }
        const degree = order - 1;
        const knots = geoNode.KnotVector.a;
        const controlPoints = [];
        const pointsValues = geoNode.Points.a;
        for(let i = 0, l = pointsValues.length; i < l; i += 4)controlPoints.push(new (0, $ilwiq.Vector4)().fromArray(pointsValues, i));
        let startKnot, endKnot;
        if (geoNode.Form === 'Closed') controlPoints.push(controlPoints[0]);
        else if (geoNode.Form === 'Periodic') {
            startKnot = degree;
            endKnot = knots.length - 1 - startKnot;
            for(let i = 0; i < degree; ++i)controlPoints.push(controlPoints[i]);
        }
        const curve = new (0, $cLt9Z.NURBSCurve)(degree, knots, controlPoints, startKnot, endKnot);
        const points = curve.getPoints(controlPoints.length * 12);
        return new (0, $ilwiq.BufferGeometry)().setFromPoints(points);
    }
}
// parse animation data from FBXTree
class $34df7f268a78e6c9$var$AnimationParser {
    // take raw animation clips and turn them into three.js animation clips
    parse() {
        const animationClips = [];
        const rawClips = this.parseClips();
        if (rawClips !== undefined) for(const key in rawClips){
            const rawClip = rawClips[key];
            const clip = this.addClip(rawClip);
            animationClips.push(clip);
        }
        return animationClips;
    }
    parseClips() {
        // since the actual transformation data is stored in FBXTree.Objects.AnimationCurve,
        // if this is undefined we can safely assume there are no animations
        if ($34df7f268a78e6c9$var$fbxTree.Objects.AnimationCurve === undefined) return undefined;
        const curveNodesMap = this.parseAnimationCurveNodes();
        this.parseAnimationCurves(curveNodesMap);
        const layersMap = this.parseAnimationLayers(curveNodesMap);
        const rawClips = this.parseAnimStacks(layersMap);
        return rawClips;
    }
    // parse nodes in FBXTree.Objects.AnimationCurveNode
    // each AnimationCurveNode holds data for an animation transform for a model (e.g. left arm rotation )
    // and is referenced by an AnimationLayer
    parseAnimationCurveNodes() {
        const rawCurveNodes = $34df7f268a78e6c9$var$fbxTree.Objects.AnimationCurveNode;
        const curveNodesMap = new Map();
        for(const nodeID in rawCurveNodes){
            const rawCurveNode = rawCurveNodes[nodeID];
            if (rawCurveNode.attrName.match(/S|R|T|DeformPercent/) !== null) {
                const curveNode = {
                    id: rawCurveNode.id,
                    attr: rawCurveNode.attrName,
                    curves: {}
                };
                curveNodesMap.set(curveNode.id, curveNode);
            }
        }
        return curveNodesMap;
    }
    // parse nodes in FBXTree.Objects.AnimationCurve and connect them up to
    // previously parsed AnimationCurveNodes. Each AnimationCurve holds data for a single animated
    // axis ( e.g. times and values of x rotation)
    parseAnimationCurves(curveNodesMap) {
        const rawCurves = $34df7f268a78e6c9$var$fbxTree.Objects.AnimationCurve;
        // TODO: Many values are identical up to roundoff error, but won't be optimised
        // e.g. position times: [0, 0.4, 0. 8]
        // position values: [7.23538335023477e-7, 93.67518615722656, -0.9982695579528809, 7.23538335023477e-7, 93.67518615722656, -0.9982695579528809, 7.235384487103147e-7, 93.67520904541016, -0.9982695579528809]
        // clearly, this should be optimised to
        // times: [0], positions [7.23538335023477e-7, 93.67518615722656, -0.9982695579528809]
        // this shows up in nearly every FBX file, and generally time array is length > 100
        for(const nodeID in rawCurves){
            const animationCurve = {
                id: rawCurves[nodeID].id,
                times: rawCurves[nodeID].KeyTime.a.map($34df7f268a78e6c9$var$convertFBXTimeToSeconds),
                values: rawCurves[nodeID].KeyValueFloat.a
            };
            const relationships = $34df7f268a78e6c9$var$connections.get(animationCurve.id);
            if (relationships !== undefined) {
                const animationCurveID = relationships.parents[0].ID;
                const animationCurveRelationship = relationships.parents[0].relationship;
                if (animationCurveRelationship.match(/X/)) curveNodesMap.get(animationCurveID).curves['x'] = animationCurve;
                else if (animationCurveRelationship.match(/Y/)) curveNodesMap.get(animationCurveID).curves['y'] = animationCurve;
                else if (animationCurveRelationship.match(/Z/)) curveNodesMap.get(animationCurveID).curves['z'] = animationCurve;
                else if (animationCurveRelationship.match(/d|DeformPercent/) && curveNodesMap.has(animationCurveID)) curveNodesMap.get(animationCurveID).curves['morph'] = animationCurve;
            }
        }
    }
    // parse nodes in FBXTree.Objects.AnimationLayer. Each layers holds references
    // to various AnimationCurveNodes and is referenced by an AnimationStack node
    // note: theoretically a stack can have multiple layers, however in practice there always seems to be one per stack
    parseAnimationLayers(curveNodesMap) {
        const rawLayers = $34df7f268a78e6c9$var$fbxTree.Objects.AnimationLayer;
        const layersMap = new Map();
        for(const nodeID in rawLayers){
            const layerCurveNodes = [];
            const connection = $34df7f268a78e6c9$var$connections.get(parseInt(nodeID));
            if (connection !== undefined) {
                // all the animationCurveNodes used in the layer
                const children = connection.children;
                children.forEach(function(child, i) {
                    if (curveNodesMap.has(child.ID)) {
                        const curveNode = curveNodesMap.get(child.ID);
                        // check that the curves are defined for at least one axis, otherwise ignore the curveNode
                        if (curveNode.curves.x !== undefined || curveNode.curves.y !== undefined || curveNode.curves.z !== undefined) {
                            if (layerCurveNodes[i] === undefined) {
                                const modelID = $34df7f268a78e6c9$var$connections.get(child.ID).parents.filter(function(parent) {
                                    return parent.relationship !== undefined;
                                })[0].ID;
                                if (modelID !== undefined) {
                                    const rawModel = $34df7f268a78e6c9$var$fbxTree.Objects.Model[modelID.toString()];
                                    if (rawModel === undefined) {
                                        console.warn('THREE.FBXLoader: Encountered a unused curve.', child);
                                        return;
                                    }
                                    const node = {
                                        modelName: rawModel.attrName ? (0, $ilwiq.PropertyBinding).sanitizeNodeName(rawModel.attrName) : '',
                                        ID: rawModel.id,
                                        initialPosition: [
                                            0,
                                            0,
                                            0
                                        ],
                                        initialRotation: [
                                            0,
                                            0,
                                            0
                                        ],
                                        initialScale: [
                                            1,
                                            1,
                                            1
                                        ]
                                    };
                                    $34df7f268a78e6c9$var$sceneGraph.traverse(function(child) {
                                        if (child.ID === rawModel.id) {
                                            node.transform = child.matrix;
                                            if (child.userData.transformData) node.eulerOrder = child.userData.transformData.eulerOrder;
                                        }
                                    });
                                    if (!node.transform) node.transform = new (0, $ilwiq.Matrix4)();
                                    // if the animated model is pre rotated, we'll have to apply the pre rotations to every
                                    // animation value as well
                                    if ('PreRotation' in rawModel) node.preRotation = rawModel.PreRotation.value;
                                    if ('PostRotation' in rawModel) node.postRotation = rawModel.PostRotation.value;
                                    layerCurveNodes[i] = node;
                                }
                            }
                            if (layerCurveNodes[i]) layerCurveNodes[i][curveNode.attr] = curveNode;
                        } else if (curveNode.curves.morph !== undefined) {
                            if (layerCurveNodes[i] === undefined) {
                                const deformerID = $34df7f268a78e6c9$var$connections.get(child.ID).parents.filter(function(parent) {
                                    return parent.relationship !== undefined;
                                })[0].ID;
                                const morpherID = $34df7f268a78e6c9$var$connections.get(deformerID).parents[0].ID;
                                const geoID = $34df7f268a78e6c9$var$connections.get(morpherID).parents[0].ID;
                                // assuming geometry is not used in more than one model
                                const modelID = $34df7f268a78e6c9$var$connections.get(geoID).parents[0].ID;
                                const rawModel = $34df7f268a78e6c9$var$fbxTree.Objects.Model[modelID];
                                const node = {
                                    modelName: rawModel.attrName ? (0, $ilwiq.PropertyBinding).sanitizeNodeName(rawModel.attrName) : '',
                                    morphName: $34df7f268a78e6c9$var$fbxTree.Objects.Deformer[deformerID].attrName
                                };
                                layerCurveNodes[i] = node;
                            }
                            layerCurveNodes[i][curveNode.attr] = curveNode;
                        }
                    }
                });
                layersMap.set(parseInt(nodeID), layerCurveNodes);
            }
        }
        return layersMap;
    }
    // parse nodes in FBXTree.Objects.AnimationStack. These are the top level node in the animation
    // hierarchy. Each Stack node will be used to create a AnimationClip
    parseAnimStacks(layersMap) {
        const rawStacks = $34df7f268a78e6c9$var$fbxTree.Objects.AnimationStack;
        // connect the stacks (clips) up to the layers
        const rawClips = {};
        for(const nodeID in rawStacks){
            const children = $34df7f268a78e6c9$var$connections.get(parseInt(nodeID)).children;
            if (children.length > 1) // it seems like stacks will always be associated with a single layer. But just in case there are files
            // where there are multiple layers per stack, we'll display a warning
            console.warn('THREE.FBXLoader: Encountered an animation stack with multiple layers, this is currently not supported. Ignoring subsequent layers.');
            const layer = layersMap.get(children[0].ID);
            rawClips[nodeID] = {
                name: rawStacks[nodeID].attrName,
                layer: layer
            };
        }
        return rawClips;
    }
    addClip(rawClip) {
        let tracks = [];
        const scope = this;
        rawClip.layer.forEach(function(rawTracks) {
            tracks = tracks.concat(scope.generateTracks(rawTracks));
        });
        return new (0, $ilwiq.AnimationClip)(rawClip.name, -1, tracks);
    }
    generateTracks(rawTracks) {
        const tracks = [];
        let initialPosition = new (0, $ilwiq.Vector3)();
        let initialRotation = new (0, $ilwiq.Quaternion)();
        let initialScale = new (0, $ilwiq.Vector3)();
        if (rawTracks.transform) rawTracks.transform.decompose(initialPosition, initialRotation, initialScale);
        initialPosition = initialPosition.toArray();
        initialRotation = new (0, $ilwiq.Euler)().setFromQuaternion(initialRotation, rawTracks.eulerOrder).toArray();
        initialScale = initialScale.toArray();
        if (rawTracks.T !== undefined && Object.keys(rawTracks.T.curves).length > 0) {
            const positionTrack = this.generateVectorTrack(rawTracks.modelName, rawTracks.T.curves, initialPosition, 'position');
            if (positionTrack !== undefined) tracks.push(positionTrack);
        }
        if (rawTracks.R !== undefined && Object.keys(rawTracks.R.curves).length > 0) {
            const rotationTrack = this.generateRotationTrack(rawTracks.modelName, rawTracks.R.curves, initialRotation, rawTracks.preRotation, rawTracks.postRotation, rawTracks.eulerOrder);
            if (rotationTrack !== undefined) tracks.push(rotationTrack);
        }
        if (rawTracks.S !== undefined && Object.keys(rawTracks.S.curves).length > 0) {
            const scaleTrack = this.generateVectorTrack(rawTracks.modelName, rawTracks.S.curves, initialScale, 'scale');
            if (scaleTrack !== undefined) tracks.push(scaleTrack);
        }
        if (rawTracks.DeformPercent !== undefined) {
            const morphTrack = this.generateMorphTrack(rawTracks);
            if (morphTrack !== undefined) tracks.push(morphTrack);
        }
        return tracks;
    }
    generateVectorTrack(modelName, curves, initialValue, type) {
        const times = this.getTimesForAllAxes(curves);
        const values = this.getKeyframeTrackValues(times, curves, initialValue);
        return new (0, $ilwiq.VectorKeyframeTrack)(modelName + '.' + type, times, values);
    }
    generateRotationTrack(modelName, curves, initialValue, preRotation, postRotation, eulerOrder) {
        if (curves.x !== undefined) {
            this.interpolateRotations(curves.x);
            curves.x.values = curves.x.values.map((0, $ilwiq.MathUtils).degToRad);
        }
        if (curves.y !== undefined) {
            this.interpolateRotations(curves.y);
            curves.y.values = curves.y.values.map((0, $ilwiq.MathUtils).degToRad);
        }
        if (curves.z !== undefined) {
            this.interpolateRotations(curves.z);
            curves.z.values = curves.z.values.map((0, $ilwiq.MathUtils).degToRad);
        }
        const times = this.getTimesForAllAxes(curves);
        const values = this.getKeyframeTrackValues(times, curves, initialValue);
        if (preRotation !== undefined) {
            preRotation = preRotation.map((0, $ilwiq.MathUtils).degToRad);
            preRotation.push(eulerOrder);
            preRotation = new (0, $ilwiq.Euler)().fromArray(preRotation);
            preRotation = new (0, $ilwiq.Quaternion)().setFromEuler(preRotation);
        }
        if (postRotation !== undefined) {
            postRotation = postRotation.map((0, $ilwiq.MathUtils).degToRad);
            postRotation.push(eulerOrder);
            postRotation = new (0, $ilwiq.Euler)().fromArray(postRotation);
            postRotation = new (0, $ilwiq.Quaternion)().setFromEuler(postRotation).invert();
        }
        const quaternion = new (0, $ilwiq.Quaternion)();
        const euler = new (0, $ilwiq.Euler)();
        const quaternionValues = [];
        for(let i = 0; i < values.length; i += 3){
            euler.set(values[i], values[i + 1], values[i + 2], eulerOrder);
            quaternion.setFromEuler(euler);
            if (preRotation !== undefined) quaternion.premultiply(preRotation);
            if (postRotation !== undefined) quaternion.multiply(postRotation);
            quaternion.toArray(quaternionValues, i / 3 * 4);
        }
        return new (0, $ilwiq.QuaternionKeyframeTrack)(modelName + '.quaternion', times, quaternionValues);
    }
    generateMorphTrack(rawTracks) {
        const curves = rawTracks.DeformPercent.curves.morph;
        const values = curves.values.map(function(val) {
            return val / 100;
        });
        const morphNum = $34df7f268a78e6c9$var$sceneGraph.getObjectByName(rawTracks.modelName).morphTargetDictionary[rawTracks.morphName];
        return new (0, $ilwiq.NumberKeyframeTrack)(rawTracks.modelName + '.morphTargetInfluences[' + morphNum + ']', curves.times, values);
    }
    // For all animated objects, times are defined separately for each axis
    // Here we'll combine the times into one sorted array without duplicates
    getTimesForAllAxes(curves) {
        let times = [];
        // first join together the times for each axis, if defined
        if (curves.x !== undefined) times = times.concat(curves.x.times);
        if (curves.y !== undefined) times = times.concat(curves.y.times);
        if (curves.z !== undefined) times = times.concat(curves.z.times);
        // then sort them
        times = times.sort(function(a, b) {
            return a - b;
        });
        // and remove duplicates
        if (times.length > 1) {
            let targetIndex = 1;
            let lastValue = times[0];
            for(let i = 1; i < times.length; i++){
                const currentValue = times[i];
                if (currentValue !== lastValue) {
                    times[targetIndex] = currentValue;
                    lastValue = currentValue;
                    targetIndex++;
                }
            }
            times = times.slice(0, targetIndex);
        }
        return times;
    }
    getKeyframeTrackValues(times, curves, initialValue) {
        const prevValue = initialValue;
        const values = [];
        let xIndex = -1;
        let yIndex = -1;
        let zIndex = -1;
        times.forEach(function(time) {
            if (curves.x) xIndex = curves.x.times.indexOf(time);
            if (curves.y) yIndex = curves.y.times.indexOf(time);
            if (curves.z) zIndex = curves.z.times.indexOf(time);
            // if there is an x value defined for this frame, use that
            if (xIndex !== -1) {
                const xValue = curves.x.values[xIndex];
                values.push(xValue);
                prevValue[0] = xValue;
            } else // otherwise use the x value from the previous frame
            values.push(prevValue[0]);
            if (yIndex !== -1) {
                const yValue = curves.y.values[yIndex];
                values.push(yValue);
                prevValue[1] = yValue;
            } else values.push(prevValue[1]);
            if (zIndex !== -1) {
                const zValue = curves.z.values[zIndex];
                values.push(zValue);
                prevValue[2] = zValue;
            } else values.push(prevValue[2]);
        });
        return values;
    }
    // Rotations are defined as Euler angles which can have values  of any size
    // These will be converted to quaternions which don't support values greater than
    // PI, so we'll interpolate large rotations
    interpolateRotations(curve) {
        for(let i = 1; i < curve.values.length; i++){
            const initialValue = curve.values[i - 1];
            const valuesSpan = curve.values[i] - initialValue;
            const absoluteSpan = Math.abs(valuesSpan);
            if (absoluteSpan >= 180) {
                const numSubIntervals = absoluteSpan / 180;
                const step = valuesSpan / numSubIntervals;
                let nextValue = initialValue + step;
                const initialTime = curve.times[i - 1];
                const timeSpan = curve.times[i] - initialTime;
                const interval = timeSpan / numSubIntervals;
                let nextTime = initialTime + interval;
                const interpolatedTimes = [];
                const interpolatedValues = [];
                while(nextTime < curve.times[i]){
                    interpolatedTimes.push(nextTime);
                    nextTime += interval;
                    interpolatedValues.push(nextValue);
                    nextValue += step;
                }
                curve.times = $34df7f268a78e6c9$var$inject(curve.times, i, interpolatedTimes);
                curve.values = $34df7f268a78e6c9$var$inject(curve.values, i, interpolatedValues);
            }
        }
    }
}
// parse an FBX file in ASCII format
class $34df7f268a78e6c9$var$TextParser {
    getPrevNode() {
        return this.nodeStack[this.currentIndent - 2];
    }
    getCurrentNode() {
        return this.nodeStack[this.currentIndent - 1];
    }
    getCurrentProp() {
        return this.currentProp;
    }
    pushStack(node) {
        this.nodeStack.push(node);
        this.currentIndent += 1;
    }
    popStack() {
        this.nodeStack.pop();
        this.currentIndent -= 1;
    }
    setCurrentProp(val, name) {
        this.currentProp = val;
        this.currentPropName = name;
    }
    parse(text) {
        this.currentIndent = 0;
        this.allNodes = new $34df7f268a78e6c9$var$FBXTree();
        this.nodeStack = [];
        this.currentProp = [];
        this.currentPropName = '';
        const scope = this;
        const split = text.split(/[\r\n]+/);
        split.forEach(function(line, i) {
            const matchComment = line.match(/^[\s\t]*;/);
            const matchEmpty = line.match(/^[\s\t]*$/);
            if (matchComment || matchEmpty) return;
            const matchBeginning = line.match('^\\t{' + scope.currentIndent + '}(\\w+):(.*){', '');
            const matchProperty = line.match('^\\t{' + scope.currentIndent + '}(\\w+):[\\s\\t\\r\\n](.*)');
            const matchEnd = line.match('^\\t{' + (scope.currentIndent - 1) + '}}');
            if (matchBeginning) scope.parseNodeBegin(line, matchBeginning);
            else if (matchProperty) scope.parseNodeProperty(line, matchProperty, split[++i]);
            else if (matchEnd) scope.popStack();
            else if (line.match(/^[^\s\t}]/)) // large arrays are split over multiple lines terminated with a ',' character
            // if this is encountered the line needs to be joined to the previous line
            scope.parseNodePropertyContinued(line);
        });
        return this.allNodes;
    }
    parseNodeBegin(line, property) {
        const nodeName = property[1].trim().replace(/^"/, '').replace(/"$/, '');
        const nodeAttrs = property[2].split(',').map(function(attr) {
            return attr.trim().replace(/^"/, '').replace(/"$/, '');
        });
        const node = {
            name: nodeName
        };
        const attrs = this.parseNodeAttr(nodeAttrs);
        const currentNode = this.getCurrentNode();
        // a top node
        if (this.currentIndent === 0) this.allNodes.add(nodeName, node);
        else {
            // a subnode
            // if the subnode already exists, append it
            if (nodeName in currentNode) {
                // special case Pose needs PoseNodes as an array
                if (nodeName === 'PoseNode') currentNode.PoseNode.push(node);
                else if (currentNode[nodeName].id !== undefined) {
                    currentNode[nodeName] = {};
                    currentNode[nodeName][currentNode[nodeName].id] = currentNode[nodeName];
                }
                if (attrs.id !== '') currentNode[nodeName][attrs.id] = node;
            } else if (typeof attrs.id === 'number') {
                currentNode[nodeName] = {};
                currentNode[nodeName][attrs.id] = node;
            } else if (nodeName !== 'Properties70') {
                if (nodeName === 'PoseNode') currentNode[nodeName] = [
                    node
                ];
                else currentNode[nodeName] = node;
            }
        }
        if (typeof attrs.id === 'number') node.id = attrs.id;
        if (attrs.name !== '') node.attrName = attrs.name;
        if (attrs.type !== '') node.attrType = attrs.type;
        this.pushStack(node);
    }
    parseNodeAttr(attrs) {
        let id = attrs[0];
        if (attrs[0] !== '') {
            id = parseInt(attrs[0]);
            if (isNaN(id)) id = attrs[0];
        }
        let name = '', type = '';
        if (attrs.length > 1) {
            name = attrs[1].replace(/^(\w+)::/, '');
            type = attrs[2];
        }
        return {
            id: id,
            name: name,
            type: type
        };
    }
    parseNodeProperty(line, property, contentLine) {
        let propName = property[1].replace(/^"/, '').replace(/"$/, '').trim();
        let propValue = property[2].replace(/^"/, '').replace(/"$/, '').trim();
        // for special case: base64 image data follows "Content: ," line
        //	Content: ,
        //	 "/9j/4RDaRXhpZgAATU0A..."
        if (propName === 'Content' && propValue === ',') propValue = contentLine.replace(/"/g, '').replace(/,$/, '').trim();
        const currentNode = this.getCurrentNode();
        const parentName = currentNode.name;
        if (parentName === 'Properties70') {
            this.parseNodeSpecialProperty(line, propName, propValue);
            return;
        }
        // Connections
        if (propName === 'C') {
            const connProps = propValue.split(',').slice(1);
            const from = parseInt(connProps[0]);
            const to = parseInt(connProps[1]);
            let rest = propValue.split(',').slice(3);
            rest = rest.map(function(elem) {
                return elem.trim().replace(/^"/, '');
            });
            propName = 'connections';
            propValue = [
                from,
                to
            ];
            $34df7f268a78e6c9$var$append(propValue, rest);
            if (currentNode[propName] === undefined) currentNode[propName] = [];
        }
        // Node
        if (propName === 'Node') currentNode.id = propValue;
        // connections
        if (propName in currentNode && Array.isArray(currentNode[propName])) currentNode[propName].push(propValue);
        else if (propName !== 'a') currentNode[propName] = propValue;
        else currentNode.a = propValue;
        this.setCurrentProp(currentNode, propName);
        // convert string to array, unless it ends in ',' in which case more will be added to it
        if (propName === 'a' && propValue.slice(-1) !== ',') currentNode.a = $34df7f268a78e6c9$var$parseNumberArray(propValue);
    }
    parseNodePropertyContinued(line) {
        const currentNode = this.getCurrentNode();
        currentNode.a += line;
        // if the line doesn't end in ',' we have reached the end of the property value
        // so convert the string to an array
        if (line.slice(-1) !== ',') currentNode.a = $34df7f268a78e6c9$var$parseNumberArray(currentNode.a);
    }
    // parse "Property70"
    parseNodeSpecialProperty(line, propName, propValue) {
        // split this
        // P: "Lcl Scaling", "Lcl Scaling", "", "A",1,1,1
        // into array like below
        // ["Lcl Scaling", "Lcl Scaling", "", "A", "1,1,1" ]
        const props = propValue.split('",').map(function(prop) {
            return prop.trim().replace(/^\"/, '').replace(/\s/, '_');
        });
        const innerPropName = props[0];
        const innerPropType1 = props[1];
        const innerPropType2 = props[2];
        const innerPropFlag = props[3];
        let innerPropValue = props[4];
        // cast values where needed, otherwise leave as strings
        switch(innerPropType1){
            case 'int':
            case 'enum':
            case 'bool':
            case 'ULongLong':
            case 'double':
            case 'Number':
            case 'FieldOfView':
                innerPropValue = parseFloat(innerPropValue);
                break;
            case 'Color':
            case 'ColorRGB':
            case 'Vector3D':
            case 'Lcl_Translation':
            case 'Lcl_Rotation':
            case 'Lcl_Scaling':
                innerPropValue = $34df7f268a78e6c9$var$parseNumberArray(innerPropValue);
                break;
        }
        // CAUTION: these props must append to parent's parent
        this.getPrevNode()[innerPropName] = {
            type: innerPropType1,
            type2: innerPropType2,
            flag: innerPropFlag,
            value: innerPropValue
        };
        this.setCurrentProp(this.getPrevNode(), innerPropName);
    }
}
// Parse an FBX file in Binary format
class $34df7f268a78e6c9$var$BinaryParser {
    parse(buffer) {
        const reader = new $34df7f268a78e6c9$var$BinaryReader(buffer);
        reader.skip(23) // skip magic 23 bytes
        ;
        const version = reader.getUint32();
        if (version < 6400) throw new Error('THREE.FBXLoader: FBX version not supported, FileVersion: ' + version);
        const allNodes = new $34df7f268a78e6c9$var$FBXTree();
        while(!this.endOfContent(reader)){
            const node = this.parseNode(reader, version);
            if (node !== null) allNodes.add(node.name, node);
        }
        return allNodes;
    }
    // Check if reader has reached the end of content.
    endOfContent(reader) {
        // footer size: 160bytes + 16-byte alignment padding
        // - 16bytes: magic
        // - padding til 16-byte alignment (at least 1byte?)
        //	(seems like some exporters embed fixed 15 or 16bytes?)
        // - 4bytes: magic
        // - 4bytes: version
        // - 120bytes: zero
        // - 16bytes: magic
        if (reader.size() % 16 === 0) return (reader.getOffset() + 160 + 16 & -16) >= reader.size();
        else return reader.getOffset() + 160 + 16 >= reader.size();
    }
    // recursively parse nodes until the end of the file is reached
    parseNode(reader, version) {
        const node = {};
        // The first three data sizes depends on version.
        const endOffset = version >= 7500 ? reader.getUint64() : reader.getUint32();
        const numProperties = version >= 7500 ? reader.getUint64() : reader.getUint32();
        version >= 7500 ? reader.getUint64() : reader.getUint32() // the returned propertyListLen is not used
        ;
        const nameLen = reader.getUint8();
        const name = reader.getString(nameLen);
        // Regards this node as NULL-record if endOffset is zero
        if (endOffset === 0) return null;
        const propertyList = [];
        for(let i = 0; i < numProperties; i++)propertyList.push(this.parseProperty(reader));
        // Regards the first three elements in propertyList as id, attrName, and attrType
        const id = propertyList.length > 0 ? propertyList[0] : '';
        const attrName = propertyList.length > 1 ? propertyList[1] : '';
        const attrType = propertyList.length > 2 ? propertyList[2] : '';
        // check if this node represents just a single property
        // like (name, 0) set or (name2, [0, 1, 2]) set of {name: 0, name2: [0, 1, 2]}
        node.singleProperty = numProperties === 1 && reader.getOffset() === endOffset ? true : false;
        while(endOffset > reader.getOffset()){
            const subNode = this.parseNode(reader, version);
            if (subNode !== null) this.parseSubNode(name, node, subNode);
        }
        node.propertyList = propertyList // raw property list used by parent
        ;
        if (typeof id === 'number') node.id = id;
        if (attrName !== '') node.attrName = attrName;
        if (attrType !== '') node.attrType = attrType;
        if (name !== '') node.name = name;
        return node;
    }
    parseSubNode(name, node, subNode) {
        // special case: child node is single property
        if (subNode.singleProperty === true) {
            const value = subNode.propertyList[0];
            if (Array.isArray(value)) {
                node[subNode.name] = subNode;
                subNode.a = value;
            } else node[subNode.name] = value;
        } else if (name === 'Connections' && subNode.name === 'C') {
            const array = [];
            subNode.propertyList.forEach(function(property, i) {
                // first Connection is FBX type (OO, OP, etc.). We'll discard these
                if (i !== 0) array.push(property);
            });
            if (node.connections === undefined) node.connections = [];
            node.connections.push(array);
        } else if (subNode.name === 'Properties70') {
            const keys = Object.keys(subNode);
            keys.forEach(function(key) {
                node[key] = subNode[key];
            });
        } else if (name === 'Properties70' && subNode.name === 'P') {
            let innerPropName = subNode.propertyList[0];
            let innerPropType1 = subNode.propertyList[1];
            const innerPropType2 = subNode.propertyList[2];
            const innerPropFlag = subNode.propertyList[3];
            let innerPropValue;
            if (innerPropName.indexOf('Lcl ') === 0) innerPropName = innerPropName.replace('Lcl ', 'Lcl_');
            if (innerPropType1.indexOf('Lcl ') === 0) innerPropType1 = innerPropType1.replace('Lcl ', 'Lcl_');
            if (innerPropType1 === 'Color' || innerPropType1 === 'ColorRGB' || innerPropType1 === 'Vector' || innerPropType1 === 'Vector3D' || innerPropType1.indexOf('Lcl_') === 0) innerPropValue = [
                subNode.propertyList[4],
                subNode.propertyList[5],
                subNode.propertyList[6]
            ];
            else innerPropValue = subNode.propertyList[4];
            // this will be copied to parent, see above
            node[innerPropName] = {
                type: innerPropType1,
                type2: innerPropType2,
                flag: innerPropFlag,
                value: innerPropValue
            };
        } else if (node[subNode.name] === undefined) {
            if (typeof subNode.id === 'number') {
                node[subNode.name] = {};
                node[subNode.name][subNode.id] = subNode;
            } else node[subNode.name] = subNode;
        } else {
            if (subNode.name === 'PoseNode') {
                if (!Array.isArray(node[subNode.name])) node[subNode.name] = [
                    node[subNode.name]
                ];
                node[subNode.name].push(subNode);
            } else if (node[subNode.name][subNode.id] === undefined) node[subNode.name][subNode.id] = subNode;
        }
    }
    parseProperty(reader) {
        const type = reader.getString(1);
        let length;
        switch(type){
            case 'C':
                return reader.getBoolean();
            case 'D':
                return reader.getFloat64();
            case 'F':
                return reader.getFloat32();
            case 'I':
                return reader.getInt32();
            case 'L':
                return reader.getInt64();
            case 'R':
                length = reader.getUint32();
                return reader.getArrayBuffer(length);
            case 'S':
                length = reader.getUint32();
                return reader.getString(length);
            case 'Y':
                return reader.getInt16();
            case 'b':
            case 'c':
            case 'd':
            case 'f':
            case 'i':
            case 'l':
                const arrayLength = reader.getUint32();
                const encoding = reader.getUint32() // 0: non-compressed, 1: compressed
                ;
                const compressedLength = reader.getUint32();
                if (encoding === 0) switch(type){
                    case 'b':
                    case 'c':
                        return reader.getBooleanArray(arrayLength);
                    case 'd':
                        return reader.getFloat64Array(arrayLength);
                    case 'f':
                        return reader.getFloat32Array(arrayLength);
                    case 'i':
                        return reader.getInt32Array(arrayLength);
                    case 'l':
                        return reader.getInt64Array(arrayLength);
                }
                if (typeof $79Zxq === 'undefined') console.error('THREE.FBXLoader: External library fflate.min.js required.');
                const data = $79Zxq.unzlibSync(new Uint8Array(reader.getArrayBuffer(compressedLength))) // eslint-disable-line no-undef
                ;
                const reader2 = new $34df7f268a78e6c9$var$BinaryReader(data.buffer);
                switch(type){
                    case 'b':
                    case 'c':
                        return reader2.getBooleanArray(arrayLength);
                    case 'd':
                        return reader2.getFloat64Array(arrayLength);
                    case 'f':
                        return reader2.getFloat32Array(arrayLength);
                    case 'i':
                        return reader2.getInt32Array(arrayLength);
                    case 'l':
                        return reader2.getInt64Array(arrayLength);
                }
                break; // cannot happen but is required by the DeepScan
            default:
                throw new Error('THREE.FBXLoader: Unknown property type ' + type);
        }
    }
}
class $34df7f268a78e6c9$var$BinaryReader {
    constructor(buffer, littleEndian){
        this.dv = new DataView(buffer);
        this.offset = 0;
        this.littleEndian = littleEndian !== undefined ? littleEndian : true;
    }
    getOffset() {
        return this.offset;
    }
    size() {
        return this.dv.buffer.byteLength;
    }
    skip(length) {
        this.offset += length;
    }
    // seems like true/false representation depends on exporter.
    // true: 1 or 'Y'(=0x59), false: 0 or 'T'(=0x54)
    // then sees LSB.
    getBoolean() {
        return (this.getUint8() & 1) === 1;
    }
    getBooleanArray(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getBoolean());
        return a;
    }
    getUint8() {
        const value = this.dv.getUint8(this.offset);
        this.offset += 1;
        return value;
    }
    getInt16() {
        const value = this.dv.getInt16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    getInt32() {
        const value = this.dv.getInt32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    getInt32Array(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getInt32());
        return a;
    }
    getUint32() {
        const value = this.dv.getUint32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    // JavaScript doesn't support 64-bit integer so calculate this here
    // 1 << 32 will return 1 so using multiply operation instead here.
    // There's a possibility that this method returns wrong value if the value
    // is out of the range between Number.MAX_SAFE_INTEGER and Number.MIN_SAFE_INTEGER.
    // TODO: safely handle 64-bit integer
    getInt64() {
        let low, high;
        if (this.littleEndian) {
            low = this.getUint32();
            high = this.getUint32();
        } else {
            high = this.getUint32();
            low = this.getUint32();
        }
        // calculate negative value
        if (high & 0x80000000) {
            high = ~high & 0xffffffff;
            low = ~low & 0xffffffff;
            if (low === 0xffffffff) high = high + 1 & 0xffffffff;
            low = low + 1 & 0xffffffff;
            return -(high * 0x100000000 + low);
        }
        return high * 0x100000000 + low;
    }
    getInt64Array(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getInt64());
        return a;
    }
    // Note: see getInt64() comment
    getUint64() {
        let low, high;
        if (this.littleEndian) {
            low = this.getUint32();
            high = this.getUint32();
        } else {
            high = this.getUint32();
            low = this.getUint32();
        }
        return high * 0x100000000 + low;
    }
    getFloat32() {
        const value = this.dv.getFloat32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    getFloat32Array(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getFloat32());
        return a;
    }
    getFloat64() {
        const value = this.dv.getFloat64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    getFloat64Array(size) {
        const a = [];
        for(let i = 0; i < size; i++)a.push(this.getFloat64());
        return a;
    }
    getArrayBuffer(size) {
        const value = this.dv.buffer.slice(this.offset, this.offset + size);
        this.offset += size;
        return value;
    }
    getString(size) {
        // note: safari 9 doesn't support Uint8Array.indexOf; create intermediate array instead
        let a = [];
        for(let i = 0; i < size; i++)a[i] = this.getUint8();
        const nullByte = a.indexOf(0);
        if (nullByte >= 0) a = a.slice(0, nullByte);
        return (0, $ilwiq.LoaderUtils).decodeText(new Uint8Array(a));
    }
}
// FBXTree holds a representation of the FBX data, returned by the TextParser ( FBX ASCII format)
// and BinaryParser( FBX Binary format)
class $34df7f268a78e6c9$var$FBXTree {
    add(key, val) {
        this[key] = val;
    }
}
// ************** UTILITY FUNCTIONS **************
function $34df7f268a78e6c9$var$isFbxFormatBinary(buffer) {
    const CORRECT = 'Kaydara\u0020FBX\u0020Binary\u0020\u0020\0';
    return buffer.byteLength >= CORRECT.length && CORRECT === $34df7f268a78e6c9$var$convertArrayBufferToString(buffer, 0, CORRECT.length);
}
function $34df7f268a78e6c9$var$isFbxFormatASCII(text) {
    const CORRECT = [
        'K',
        'a',
        'y',
        'd',
        'a',
        'r',
        'a',
        '\\',
        'F',
        'B',
        'X',
        '\\',
        'B',
        'i',
        'n',
        'a',
        'r',
        'y',
        '\\',
        '\\'
    ];
    let cursor = 0;
    function read(offset) {
        const result = text[offset - 1];
        text = text.slice(cursor + offset);
        cursor++;
        return result;
    }
    for(let i = 0; i < CORRECT.length; ++i){
        const num = read(1);
        if (num === CORRECT[i]) return false;
    }
    return true;
}
function $34df7f268a78e6c9$var$getFbxVersion(text) {
    const versionRegExp = /FBXVersion: (\d+)/;
    const match = text.match(versionRegExp);
    if (match) {
        const version = parseInt(match[1]);
        return version;
    }
    throw new Error('THREE.FBXLoader: Cannot find the version number for the file given.');
}
// Converts FBX ticks into real time seconds.
function $34df7f268a78e6c9$var$convertFBXTimeToSeconds(time) {
    return time / 46186158000;
}
const $34df7f268a78e6c9$var$dataArray = [];
// extracts the data from the correct position in the FBX array based on indexing type
function $34df7f268a78e6c9$var$getData(polygonVertexIndex, polygonIndex, vertexIndex, infoObject) {
    let index;
    switch(infoObject.mappingType){
        case 'ByPolygonVertex':
            index = polygonVertexIndex;
            break;
        case 'ByPolygon':
            index = polygonIndex;
            break;
        case 'ByVertice':
            index = vertexIndex;
            break;
        case 'AllSame':
            index = infoObject.indices[0];
            break;
        default:
            console.warn('THREE.FBXLoader: unknown attribute mapping type ' + infoObject.mappingType);
    }
    if (infoObject.referenceType === 'IndexToDirect') index = infoObject.indices[index];
    const from = index * infoObject.dataSize;
    const to = from + infoObject.dataSize;
    return $34df7f268a78e6c9$var$slice($34df7f268a78e6c9$var$dataArray, infoObject.buffer, from, to);
}
const $34df7f268a78e6c9$var$tempEuler = new (0, $ilwiq.Euler)();
const $34df7f268a78e6c9$var$tempVec = new (0, $ilwiq.Vector3)();
// generate transformation from FBX transform data
// ref: https://help.autodesk.com/view/FBX/2017/ENU/?guid=__files_GUID_10CDD63C_79C1_4F2D_BB28_AD2BE65A02ED_htm
// ref: http://docs.autodesk.com/FBX/2014/ENU/FBX-SDK-Documentation/index.html?url=cpp_ref/_transformations_2main_8cxx-example.html,topicNumber=cpp_ref__transformations_2main_8cxx_example_htmlfc10a1e1-b18d-4e72-9dc0-70d0f1959f5e
function $34df7f268a78e6c9$var$generateTransform(transformData) {
    const lTranslationM = new (0, $ilwiq.Matrix4)();
    const lPreRotationM = new (0, $ilwiq.Matrix4)();
    const lRotationM = new (0, $ilwiq.Matrix4)();
    const lPostRotationM = new (0, $ilwiq.Matrix4)();
    const lScalingM = new (0, $ilwiq.Matrix4)();
    const lScalingPivotM = new (0, $ilwiq.Matrix4)();
    const lScalingOffsetM = new (0, $ilwiq.Matrix4)();
    const lRotationOffsetM = new (0, $ilwiq.Matrix4)();
    const lRotationPivotM = new (0, $ilwiq.Matrix4)();
    const lParentGX = new (0, $ilwiq.Matrix4)();
    const lParentLX = new (0, $ilwiq.Matrix4)();
    const lGlobalT = new (0, $ilwiq.Matrix4)();
    const inheritType = transformData.inheritType ? transformData.inheritType : 0;
    if (transformData.translation) lTranslationM.setPosition($34df7f268a78e6c9$var$tempVec.fromArray(transformData.translation));
    if (transformData.preRotation) {
        const array = transformData.preRotation.map((0, $ilwiq.MathUtils).degToRad);
        array.push(transformData.eulerOrder);
        lPreRotationM.makeRotationFromEuler($34df7f268a78e6c9$var$tempEuler.fromArray(array));
    }
    if (transformData.rotation) {
        const array = transformData.rotation.map((0, $ilwiq.MathUtils).degToRad);
        array.push(transformData.eulerOrder);
        lRotationM.makeRotationFromEuler($34df7f268a78e6c9$var$tempEuler.fromArray(array));
    }
    if (transformData.postRotation) {
        const array = transformData.postRotation.map((0, $ilwiq.MathUtils).degToRad);
        array.push(transformData.eulerOrder);
        lPostRotationM.makeRotationFromEuler($34df7f268a78e6c9$var$tempEuler.fromArray(array));
        lPostRotationM.invert();
    }
    if (transformData.scale) lScalingM.scale($34df7f268a78e6c9$var$tempVec.fromArray(transformData.scale));
    // Pivots and offsets
    if (transformData.scalingOffset) lScalingOffsetM.setPosition($34df7f268a78e6c9$var$tempVec.fromArray(transformData.scalingOffset));
    if (transformData.scalingPivot) lScalingPivotM.setPosition($34df7f268a78e6c9$var$tempVec.fromArray(transformData.scalingPivot));
    if (transformData.rotationOffset) lRotationOffsetM.setPosition($34df7f268a78e6c9$var$tempVec.fromArray(transformData.rotationOffset));
    if (transformData.rotationPivot) lRotationPivotM.setPosition($34df7f268a78e6c9$var$tempVec.fromArray(transformData.rotationPivot));
    // parent transform
    if (transformData.parentMatrixWorld) {
        lParentLX.copy(transformData.parentMatrix);
        lParentGX.copy(transformData.parentMatrixWorld);
    }
    const lLRM = lPreRotationM.clone().multiply(lRotationM).multiply(lPostRotationM);
    // Global Rotation
    const lParentGRM = new (0, $ilwiq.Matrix4)();
    lParentGRM.extractRotation(lParentGX);
    // Global Shear*Scaling
    const lParentTM = new (0, $ilwiq.Matrix4)();
    lParentTM.copyPosition(lParentGX);
    const lParentGRSM = lParentTM.clone().invert().multiply(lParentGX);
    const lParentGSM = lParentGRM.clone().invert().multiply(lParentGRSM);
    const lLSM = lScalingM;
    const lGlobalRS = new (0, $ilwiq.Matrix4)();
    if (inheritType === 0) lGlobalRS.copy(lParentGRM).multiply(lLRM).multiply(lParentGSM).multiply(lLSM);
    else if (inheritType === 1) lGlobalRS.copy(lParentGRM).multiply(lParentGSM).multiply(lLRM).multiply(lLSM);
    else {
        const lParentLSM = new (0, $ilwiq.Matrix4)().scale(new (0, $ilwiq.Vector3)().setFromMatrixScale(lParentLX));
        const lParentLSM_inv = lParentLSM.clone().invert();
        const lParentGSM_noLocal = lParentGSM.clone().multiply(lParentLSM_inv);
        lGlobalRS.copy(lParentGRM).multiply(lLRM).multiply(lParentGSM_noLocal).multiply(lLSM);
    }
    const lRotationPivotM_inv = lRotationPivotM.clone().invert();
    const lScalingPivotM_inv = lScalingPivotM.clone().invert();
    // Calculate the local transform matrix
    let lTransform = lTranslationM.clone().multiply(lRotationOffsetM).multiply(lRotationPivotM).multiply(lPreRotationM).multiply(lRotationM).multiply(lPostRotationM).multiply(lRotationPivotM_inv).multiply(lScalingOffsetM).multiply(lScalingPivotM).multiply(lScalingM).multiply(lScalingPivotM_inv);
    const lLocalTWithAllPivotAndOffsetInfo = new (0, $ilwiq.Matrix4)().copyPosition(lTransform);
    const lGlobalTranslation = lParentGX.clone().multiply(lLocalTWithAllPivotAndOffsetInfo);
    lGlobalT.copyPosition(lGlobalTranslation);
    lTransform = lGlobalT.clone().multiply(lGlobalRS);
    // from global to local
    lTransform.premultiply(lParentGX.invert());
    return lTransform;
}
// Returns the three.js intrinsic Euler order corresponding to FBX extrinsic Euler order
// ref: http://help.autodesk.com/view/FBX/2017/ENU/?guid=__cpp_ref_class_fbx_euler_html
function $34df7f268a78e6c9$var$getEulerOrder(order) {
    order = order || 0;
    const enums = [
        'ZYX',
        'YZX',
        'XZY',
        'ZXY',
        'YXZ',
        'XYZ' // -> ZYX extrinsic
    ];
    if (order === 6) {
        console.warn('THREE.FBXLoader: unsupported Euler Order: Spherical XYZ. Animations and rotations may be incorrect.');
        return enums[0];
    }
    return enums[order];
}
// Parses comma separated list of numbers and returns them an array.
// Used internally by the TextParser
function $34df7f268a78e6c9$var$parseNumberArray(value) {
    const array = value.split(',').map(function(val) {
        return parseFloat(val);
    });
    return array;
}
function $34df7f268a78e6c9$var$convertArrayBufferToString(buffer, from, to) {
    if (from === undefined) from = 0;
    if (to === undefined) to = buffer.byteLength;
    return (0, $ilwiq.LoaderUtils).decodeText(new Uint8Array(buffer, from, to));
}
function $34df7f268a78e6c9$var$append(a, b) {
    for(let i = 0, j = a.length, l = b.length; i < l; i++, j++)a[j] = b[i];
}
function $34df7f268a78e6c9$var$slice(a, b, from, to) {
    for(let i = from, j = 0; i < to; i++, j++)a[j] = b[i];
    return a;
}
// inject array a2 into array a1 at index
function $34df7f268a78e6c9$var$inject(a1, index, a2) {
    return a1.slice(0, index).concat(a2).concat(a1.slice(index));
}

});
parcelRegister("79Zxq", function(module, exports) {

$parcel$export(module.exports, "inflateSync", () => $53691bda533d12d0$export$90366d8b308ba94a);
$parcel$export(module.exports, "deflateSync", () => $53691bda533d12d0$export$21533ff51b8a0b4a);
$parcel$export(module.exports, "Deflate", () => $53691bda533d12d0$export$ae157b6234afe138);
$parcel$export(module.exports, "AsyncDeflate", () => $53691bda533d12d0$export$84e526fabcba03e3);
$parcel$export(module.exports, "deflate", () => $53691bda533d12d0$export$2316623ecd1285ab);
$parcel$export(module.exports, "Inflate", () => $53691bda533d12d0$export$d1de70a877d6e43c);
$parcel$export(module.exports, "AsyncInflate", () => $53691bda533d12d0$export$fff8358d6dbaa9cc);
$parcel$export(module.exports, "inflate", () => $53691bda533d12d0$export$cae1ce83fe4a1782);
$parcel$export(module.exports, "Gzip", () => $53691bda533d12d0$export$8e4b66d280bf8342);
$parcel$export(module.exports, "AsyncGzip", () => $53691bda533d12d0$export$b4c75ae96cdf708b);
$parcel$export(module.exports, "gzip", () => $53691bda533d12d0$export$69f0ea7cf3a331a8);
$parcel$export(module.exports, "gzipSync", () => $53691bda533d12d0$export$3d616c3fb3e15483);
$parcel$export(module.exports, "Gunzip", () => $53691bda533d12d0$export$4cb607de6db70415);
$parcel$export(module.exports, "AsyncGunzip", () => $53691bda533d12d0$export$d5adcdd968132151);
$parcel$export(module.exports, "gunzip", () => $53691bda533d12d0$export$b6df3e950734d697);
$parcel$export(module.exports, "gunzipSync", () => $53691bda533d12d0$export$c80456f7aaba691c);
$parcel$export(module.exports, "Zlib", () => $53691bda533d12d0$export$4187ccf2467013b9);
$parcel$export(module.exports, "AsyncZlib", () => $53691bda533d12d0$export$bedbe3a2c2136490);
$parcel$export(module.exports, "zlib", () => $53691bda533d12d0$export$925212de7058410b);
$parcel$export(module.exports, "zlibSync", () => $53691bda533d12d0$export$f87121a6d50aff25);
$parcel$export(module.exports, "Unzlib", () => $53691bda533d12d0$export$af2424f875ff1b17);
$parcel$export(module.exports, "AsyncUnzlib", () => $53691bda533d12d0$export$cf6668790220dcad);
$parcel$export(module.exports, "unzlib", () => $53691bda533d12d0$export$ca7cbb494e731274);
$parcel$export(module.exports, "unzlibSync", () => $53691bda533d12d0$export$9ec8134f0f1b9fc6);
$parcel$export(module.exports, "compress", () => $53691bda533d12d0$export$69f0ea7cf3a331a8);
$parcel$export(module.exports, "AsyncCompress", () => $53691bda533d12d0$export$b4c75ae96cdf708b);
$parcel$export(module.exports, "compressSync", () => $53691bda533d12d0$export$3d616c3fb3e15483);
$parcel$export(module.exports, "Compress", () => $53691bda533d12d0$export$8e4b66d280bf8342);
$parcel$export(module.exports, "Decompress", () => $53691bda533d12d0$export$578fe199ef655b76);
$parcel$export(module.exports, "AsyncDecompress", () => $53691bda533d12d0$export$ae2c1d81988d4b43);
$parcel$export(module.exports, "decompress", () => $53691bda533d12d0$export$678d868aab8fb3c7);
$parcel$export(module.exports, "decompressSync", () => $53691bda533d12d0$export$c4bdbbbc9a4faabe);
$parcel$export(module.exports, "DecodeUTF8", () => $53691bda533d12d0$export$ba46860a31c72e94);
$parcel$export(module.exports, "EncodeUTF8", () => $53691bda533d12d0$export$283f13d12b1b210e);
$parcel$export(module.exports, "strToU8", () => $53691bda533d12d0$export$366b39a6daa8ed7a);
$parcel$export(module.exports, "strFromU8", () => $53691bda533d12d0$export$adb211f8cb999894);
$parcel$export(module.exports, "ZipPassThrough", () => $53691bda533d12d0$export$2b25194e1767ea06);
$parcel$export(module.exports, "ZipDeflate", () => $53691bda533d12d0$export$f7e481ca646388b6);
$parcel$export(module.exports, "AsyncZipDeflate", () => $53691bda533d12d0$export$ffb5e59e179924b2);
$parcel$export(module.exports, "Zip", () => $53691bda533d12d0$export$9a4d4a7c32a75d2f);
$parcel$export(module.exports, "zip", () => $53691bda533d12d0$export$8901015135f2fb22);
$parcel$export(module.exports, "zipSync", () => $53691bda533d12d0$export$eb1654f146d54eb3);
$parcel$export(module.exports, "UnzipPassThrough", () => $53691bda533d12d0$export$93f81d5bbbb7c6bf);
$parcel$export(module.exports, "UnzipInflate", () => $53691bda533d12d0$export$eb188945cc39e642);
$parcel$export(module.exports, "AsyncUnzipInflate", () => $53691bda533d12d0$export$6235d84645dad4f9);
$parcel$export(module.exports, "Unzip", () => $53691bda533d12d0$export$9b7485f84cbaaa56);
$parcel$export(module.exports, "unzip", () => $53691bda533d12d0$export$23c8d3f8757cab88);
$parcel$export(module.exports, "unzipSync", () => $53691bda533d12d0$export$c757709326bb5901);
/*!
fflate - fast JavaScript compression/decompression
<https://101arrowz.github.io/fflate>
Licensed under MIT. https://github.com/101arrowz/fflate/blob/master/LICENSE
version 0.6.9
*/ // DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $53691bda533d12d0$var$ch2 = {};
var $53691bda533d12d0$var$durl = function(c) {
    return URL.createObjectURL(new Blob([
        c
    ], {
        type: 'text/javascript'
    }));
};
var $53691bda533d12d0$var$cwk = function(u) {
    return new Worker(u);
};
try {
    URL.revokeObjectURL($53691bda533d12d0$var$durl(''));
} catch (e) {
    // We're in Deno or a very old browser
    $53691bda533d12d0$var$durl = function(c) {
        return 'data:application/javascript;charset=UTF-8,' + encodeURI(c);
    };
    // If Deno, this is necessary; if not, this changes nothing
    $53691bda533d12d0$var$cwk = function(u) {
        return new Worker(u, {
            type: 'module'
        });
    };
}
var $53691bda533d12d0$var$wk = function(c, id, msg, transfer, cb) {
    var w = $53691bda533d12d0$var$cwk($53691bda533d12d0$var$ch2[id] || ($53691bda533d12d0$var$ch2[id] = $53691bda533d12d0$var$durl(c)));
    w.onerror = function(e) {
        return cb(e.error, null);
    };
    w.onmessage = function(e) {
        return cb(null, e.data);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $53691bda533d12d0$var$u8 = Uint8Array, $53691bda533d12d0$var$u16 = Uint16Array, $53691bda533d12d0$var$u32 = Uint32Array;
// fixed length extra bits
var $53691bda533d12d0$var$fleb = new $53691bda533d12d0$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var $53691bda533d12d0$var$fdeb = new $53691bda533d12d0$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $53691bda533d12d0$var$clim = new $53691bda533d12d0$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $53691bda533d12d0$var$freb = function(eb, start) {
    var b = new $53691bda533d12d0$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $53691bda533d12d0$var$u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var $53691bda533d12d0$var$_a = $53691bda533d12d0$var$freb($53691bda533d12d0$var$fleb, 2), $53691bda533d12d0$var$fl = $53691bda533d12d0$var$_a[0], $53691bda533d12d0$var$revfl = $53691bda533d12d0$var$_a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$53691bda533d12d0$var$fl[28] = 258, $53691bda533d12d0$var$revfl[258] = 28;
var $53691bda533d12d0$var$_b = $53691bda533d12d0$var$freb($53691bda533d12d0$var$fdeb, 0), $53691bda533d12d0$var$fd = $53691bda533d12d0$var$_b[0], $53691bda533d12d0$var$revfd = $53691bda533d12d0$var$_b[1];
// map of value to reverse (assuming 16 bits)
var $53691bda533d12d0$var$rev = new $53691bda533d12d0$var$u16(32768);
for(var $53691bda533d12d0$var$i = 0; $53691bda533d12d0$var$i < 32768; ++$53691bda533d12d0$var$i){
    // reverse table algorithm from SO
    var $53691bda533d12d0$var$x = ($53691bda533d12d0$var$i & 0xAAAA) >>> 1 | ($53691bda533d12d0$var$i & 0x5555) << 1;
    $53691bda533d12d0$var$x = ($53691bda533d12d0$var$x & 0xCCCC) >>> 2 | ($53691bda533d12d0$var$x & 0x3333) << 2;
    $53691bda533d12d0$var$x = ($53691bda533d12d0$var$x & 0xF0F0) >>> 4 | ($53691bda533d12d0$var$x & 0x0F0F) << 4;
    $53691bda533d12d0$var$rev[$53691bda533d12d0$var$i] = (($53691bda533d12d0$var$x & 0xFF00) >>> 8 | ($53691bda533d12d0$var$x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $53691bda533d12d0$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $53691bda533d12d0$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $53691bda533d12d0$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $53691bda533d12d0$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$53691bda533d12d0$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $53691bda533d12d0$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $53691bda533d12d0$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $53691bda533d12d0$var$flt = new $53691bda533d12d0$var$u8(288);
for(var $53691bda533d12d0$var$i = 0; $53691bda533d12d0$var$i < 144; ++$53691bda533d12d0$var$i)$53691bda533d12d0$var$flt[$53691bda533d12d0$var$i] = 8;
for(var $53691bda533d12d0$var$i = 144; $53691bda533d12d0$var$i < 256; ++$53691bda533d12d0$var$i)$53691bda533d12d0$var$flt[$53691bda533d12d0$var$i] = 9;
for(var $53691bda533d12d0$var$i = 256; $53691bda533d12d0$var$i < 280; ++$53691bda533d12d0$var$i)$53691bda533d12d0$var$flt[$53691bda533d12d0$var$i] = 7;
for(var $53691bda533d12d0$var$i = 280; $53691bda533d12d0$var$i < 288; ++$53691bda533d12d0$var$i)$53691bda533d12d0$var$flt[$53691bda533d12d0$var$i] = 8;
// fixed distance tree
var $53691bda533d12d0$var$fdt = new $53691bda533d12d0$var$u8(32);
for(var $53691bda533d12d0$var$i = 0; $53691bda533d12d0$var$i < 32; ++$53691bda533d12d0$var$i)$53691bda533d12d0$var$fdt[$53691bda533d12d0$var$i] = 5;
// fixed length map
var $53691bda533d12d0$var$flm = /*#__PURE__*/ $53691bda533d12d0$var$hMap($53691bda533d12d0$var$flt, 9, 0), $53691bda533d12d0$var$flrm = /*#__PURE__*/ $53691bda533d12d0$var$hMap($53691bda533d12d0$var$flt, 9, 1);
// fixed distance map
var $53691bda533d12d0$var$fdm = /*#__PURE__*/ $53691bda533d12d0$var$hMap($53691bda533d12d0$var$fdt, 5, 0), $53691bda533d12d0$var$fdrm = /*#__PURE__*/ $53691bda533d12d0$var$hMap($53691bda533d12d0$var$fdt, 5, 1);
// find max of array
var $53691bda533d12d0$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $53691bda533d12d0$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $53691bda533d12d0$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $53691bda533d12d0$var$shft = function(p) {
    return (p / 8 | 0) + (p & 7 && 1);
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $53691bda533d12d0$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof $53691bda533d12d0$var$u16 ? $53691bda533d12d0$var$u16 : v instanceof $53691bda533d12d0$var$u32 ? $53691bda533d12d0$var$u32 : $53691bda533d12d0$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var $53691bda533d12d0$var$inflt = function(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && !st.l && sl < 5) return buf || new $53691bda533d12d0$var$u8(0);
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new $53691bda533d12d0$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $53691bda533d12d0$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = $53691bda533d12d0$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $53691bda533d12d0$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $53691bda533d12d0$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            } else if (type == 1) lm = $53691bda533d12d0$var$flrm, dm = $53691bda533d12d0$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $53691bda533d12d0$var$bits(dat, pos, 31) + 257, hcLen = $53691bda533d12d0$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $53691bda533d12d0$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $53691bda533d12d0$var$u8(tl);
                // code length tree
                var clt = new $53691bda533d12d0$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$53691bda533d12d0$var$clim[i]] = $53691bda533d12d0$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $53691bda533d12d0$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $53691bda533d12d0$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$53691bda533d12d0$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $53691bda533d12d0$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $53691bda533d12d0$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $53691bda533d12d0$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $53691bda533d12d0$var$max(lt);
                // max dist bits
                dbt = $53691bda533d12d0$var$max(dt);
                lm = $53691bda533d12d0$var$hMap(lt, lbt, 1);
                dm = $53691bda533d12d0$var$hMap(dt, dbt, 1);
            } else throw 'invalid block type';
            if (pos > tbts) {
                if (noSt) throw 'unexpected EOF';
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$53691bda533d12d0$var$bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) throw 'unexpected EOF';
                break;
            }
            if (!c) throw 'invalid length/literal';
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $53691bda533d12d0$var$fleb[i];
                    add = $53691bda533d12d0$var$bits(dat, pos, (1 << b) - 1) + $53691bda533d12d0$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$53691bda533d12d0$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) throw 'invalid distance';
                pos += d & 15;
                var dt = $53691bda533d12d0$var$fd[dsym];
                if (dsym > 3) {
                    var b = $53691bda533d12d0$var$fdeb[dsym];
                    dt += $53691bda533d12d0$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) throw 'unexpected EOF';
                    break;
                }
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = lpos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $53691bda533d12d0$var$slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $53691bda533d12d0$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $53691bda533d12d0$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var $53691bda533d12d0$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        $53691bda533d12d0$var$et,
        0
    ];
    if (s == 1) {
        var v = new $53691bda533d12d0$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $53691bda533d12d0$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $53691bda533d12d0$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new $53691bda533d12d0$var$u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var $53691bda533d12d0$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($53691bda533d12d0$var$ln(n.l, l, d + 1), $53691bda533d12d0$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $53691bda533d12d0$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $53691bda533d12d0$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var $53691bda533d12d0$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $53691bda533d12d0$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $53691bda533d12d0$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $53691bda533d12d0$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $53691bda533d12d0$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $53691bda533d12d0$var$hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = $53691bda533d12d0$var$hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = $53691bda533d12d0$var$lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = $53691bda533d12d0$var$lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new $53691bda533d12d0$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = $53691bda533d12d0$var$hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$53691bda533d12d0$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $53691bda533d12d0$var$clen(lf, $53691bda533d12d0$var$flt) + $53691bda533d12d0$var$clen(df, $53691bda533d12d0$var$fdt) + eb;
    var dtlen = $53691bda533d12d0$var$clen(lf, dlt) + $53691bda533d12d0$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $53691bda533d12d0$var$clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return $53691bda533d12d0$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $53691bda533d12d0$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $53691bda533d12d0$var$hMap(dlt, mlb, 0), ll = dlt, dm = $53691bda533d12d0$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $53691bda533d12d0$var$hMap(lct, mlcb, 0);
        $53691bda533d12d0$var$wbits(out, p, nlc - 257);
        $53691bda533d12d0$var$wbits(out, p + 5, ndc - 1);
        $53691bda533d12d0$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$53691bda533d12d0$var$wbits(out, p + 3 * i, lct[$53691bda533d12d0$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $53691bda533d12d0$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $53691bda533d12d0$var$wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = $53691bda533d12d0$var$flm, ll = $53691bda533d12d0$var$flt, dm = $53691bda533d12d0$var$fdm, dl = $53691bda533d12d0$var$fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        $53691bda533d12d0$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) $53691bda533d12d0$var$wbits(out, p, syms[i] >>> 23 & 31), p += $53691bda533d12d0$var$fleb[len];
        var dst = syms[i] & 31;
        $53691bda533d12d0$var$wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) $53691bda533d12d0$var$wbits16(out, p, syms[i] >>> 5 & 8191), p += $53691bda533d12d0$var$fdeb[dst];
    } else $53691bda533d12d0$var$wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    $53691bda533d12d0$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $53691bda533d12d0$var$deo = /*#__PURE__*/ new $53691bda533d12d0$var$u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $53691bda533d12d0$var$et = /*#__PURE__*/ new $53691bda533d12d0$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $53691bda533d12d0$var$dflt = function(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new $53691bda533d12d0$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e < s) // write full block
        pos = $53691bda533d12d0$var$wfblk(w, pos, dat.subarray(i, e));
        else {
            // write final block
            w[i] = lst;
            pos = $53691bda533d12d0$var$wfblk(w, pos, dat.subarray(i, s));
        }
    }
    else {
        var opt = $53691bda533d12d0$var$deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new $53691bda533d12d0$var$u16(32768), head = new $53691bda533d12d0$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $53691bda533d12d0$var$u32(25000);
        // length/literal freq   distance freq
        var lf = new $53691bda533d12d0$var$u16(288), df = new $53691bda533d12d0$var$u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            // deopt when i > s - 3 - at end, deopt acceptable
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = $53691bda533d12d0$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $53691bda533d12d0$var$revfl[l] << 18 | $53691bda533d12d0$var$revfd[d];
                    var lin = $53691bda533d12d0$var$revfl[l] & 31, din = $53691bda533d12d0$var$revfd[d] & 31;
                    eb += $53691bda533d12d0$var$fleb[lin] + $53691bda533d12d0$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = $53691bda533d12d0$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst && pos & 7) pos = $53691bda533d12d0$var$wfblk(w, pos + 1, $53691bda533d12d0$var$et);
    }
    return $53691bda533d12d0$var$slc(o, 0, pre + $53691bda533d12d0$var$shft(pos) + post);
};
// CRC32 table
var $53691bda533d12d0$var$crct = /*#__PURE__*/ function() {
    var t = new $53691bda533d12d0$var$u32(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && 0xEDB88320) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $53691bda533d12d0$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $53691bda533d12d0$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Alder32
var $53691bda533d12d0$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | a >>> 8 << 16 | (b & 255) << 8 | b >>> 8;
        }
    };
};
// deflate with opts
var $53691bda533d12d0$var$dopt = function(dat, opt, pre, post, st) {
    return $53691bda533d12d0$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var $53691bda533d12d0$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $53691bda533d12d0$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/ /g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var $53691bda533d12d0$var$ch = [];
// clone bufs
var $53691bda533d12d0$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k] instanceof $53691bda533d12d0$var$u8 || v[k] instanceof $53691bda533d12d0$var$u16 || v[k] instanceof $53691bda533d12d0$var$u32) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $53691bda533d12d0$var$wrkr = function(fns, init, id, cb) {
    var _a;
    if (!$53691bda533d12d0$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = $53691bda533d12d0$var$wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        $53691bda533d12d0$var$ch[id] = $53691bda533d12d0$var$wcln(fns[m], fnStr, td_1);
    }
    var td = $53691bda533d12d0$var$mrg({}, $53691bda533d12d0$var$ch[id][1]);
    return $53691bda533d12d0$var$wk($53691bda533d12d0$var$ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $53691bda533d12d0$var$cbfs(td), cb);
};
// base async inflate fn
var $53691bda533d12d0$var$bInflt = function() {
    return [
        $53691bda533d12d0$var$u8,
        $53691bda533d12d0$var$u16,
        $53691bda533d12d0$var$u32,
        $53691bda533d12d0$var$fleb,
        $53691bda533d12d0$var$fdeb,
        $53691bda533d12d0$var$clim,
        $53691bda533d12d0$var$fl,
        $53691bda533d12d0$var$fd,
        $53691bda533d12d0$var$flrm,
        $53691bda533d12d0$var$fdrm,
        $53691bda533d12d0$var$rev,
        $53691bda533d12d0$var$hMap,
        $53691bda533d12d0$var$max,
        $53691bda533d12d0$var$bits,
        $53691bda533d12d0$var$bits16,
        $53691bda533d12d0$var$shft,
        $53691bda533d12d0$var$slc,
        $53691bda533d12d0$var$inflt,
        $53691bda533d12d0$export$90366d8b308ba94a,
        $53691bda533d12d0$var$pbf,
        $53691bda533d12d0$var$gu8
    ];
};
var $53691bda533d12d0$var$bDflt = function() {
    return [
        $53691bda533d12d0$var$u8,
        $53691bda533d12d0$var$u16,
        $53691bda533d12d0$var$u32,
        $53691bda533d12d0$var$fleb,
        $53691bda533d12d0$var$fdeb,
        $53691bda533d12d0$var$clim,
        $53691bda533d12d0$var$revfl,
        $53691bda533d12d0$var$revfd,
        $53691bda533d12d0$var$flm,
        $53691bda533d12d0$var$flt,
        $53691bda533d12d0$var$fdm,
        $53691bda533d12d0$var$fdt,
        $53691bda533d12d0$var$rev,
        $53691bda533d12d0$var$deo,
        $53691bda533d12d0$var$et,
        $53691bda533d12d0$var$hMap,
        $53691bda533d12d0$var$wbits,
        $53691bda533d12d0$var$wbits16,
        $53691bda533d12d0$var$hTree,
        $53691bda533d12d0$var$ln,
        $53691bda533d12d0$var$lc,
        $53691bda533d12d0$var$clen,
        $53691bda533d12d0$var$wfblk,
        $53691bda533d12d0$var$wblk,
        $53691bda533d12d0$var$shft,
        $53691bda533d12d0$var$slc,
        $53691bda533d12d0$var$dflt,
        $53691bda533d12d0$var$dopt,
        $53691bda533d12d0$export$21533ff51b8a0b4a,
        $53691bda533d12d0$var$pbf
    ];
};
// gzip extra
var $53691bda533d12d0$var$gze = function() {
    return [
        $53691bda533d12d0$var$gzh,
        $53691bda533d12d0$var$gzhl,
        $53691bda533d12d0$var$wbytes,
        $53691bda533d12d0$var$crc,
        $53691bda533d12d0$var$crct
    ];
};
// gunzip extra
var $53691bda533d12d0$var$guze = function() {
    return [
        $53691bda533d12d0$var$gzs,
        $53691bda533d12d0$var$gzl
    ];
};
// zlib extra
var $53691bda533d12d0$var$zle = function() {
    return [
        $53691bda533d12d0$var$zlh,
        $53691bda533d12d0$var$wbytes,
        $53691bda533d12d0$var$adler
    ];
};
// unzlib extra
var $53691bda533d12d0$var$zule = function() {
    return [
        $53691bda533d12d0$var$zlv
    ];
};
// post buf
var $53691bda533d12d0$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var $53691bda533d12d0$var$gu8 = function(o) {
    return o && o.size && new $53691bda533d12d0$var$u8(o.size);
};
// async helper
var $53691bda533d12d0$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $53691bda533d12d0$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $53691bda533d12d0$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var $53691bda533d12d0$var$astrmify = function(fns, strm, opts, init, id) {
    var t;
    var w = $53691bda533d12d0$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (t) throw 'stream finished';
        if (!strm.ondata) throw 'no stream handler';
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var $53691bda533d12d0$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $53691bda533d12d0$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $53691bda533d12d0$var$b8 = function(d, b) {
    return $53691bda533d12d0$var$b4(d, b) + $53691bda533d12d0$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $53691bda533d12d0$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $53691bda533d12d0$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $53691bda533d12d0$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $53691bda533d12d0$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) throw 'invalid gzip data';
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $53691bda533d12d0$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $53691bda533d12d0$var$gzhl = function(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var $53691bda533d12d0$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var $53691bda533d12d0$var$zlv = function(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw 'invalid zlib data';
    if (d[1] & 32) throw 'invalid zlib data: preset dictionaries not supported';
};
function $53691bda533d12d0$var$AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var $53691bda533d12d0$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($53691bda533d12d0$var$dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $53691bda533d12d0$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $53691bda533d12d0$var$astrmify([
            $53691bda533d12d0$var$bDflt,
            function() {
                return [
                    $53691bda533d12d0$var$astrm,
                    $53691bda533d12d0$export$ae157b6234afe138
                ];
            }
        ], this, $53691bda533d12d0$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $53691bda533d12d0$export$ae157b6234afe138(ev.data);
            onmessage = $53691bda533d12d0$var$astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}();
function $53691bda533d12d0$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $53691bda533d12d0$var$cbify(data, opts, [
        $53691bda533d12d0$var$bDflt
    ], function(ev) {
        return $53691bda533d12d0$var$pbf($53691bda533d12d0$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $53691bda533d12d0$export$21533ff51b8a0b4a(data, opts) {
    return $53691bda533d12d0$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $53691bda533d12d0$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new $53691bda533d12d0$var$u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function(c) {
        if (this.d) throw 'stream finished';
        if (!this.ondata) throw 'no stream handler';
        var l = this.p.length;
        var n = new $53691bda533d12d0$var$u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = $53691bda533d12d0$var$inflt(this.p, this.o, this.s);
        this.ondata($53691bda533d12d0$var$slc(dt, bts, this.s.b), this.d);
        this.o = $53691bda533d12d0$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $53691bda533d12d0$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $53691bda533d12d0$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        $53691bda533d12d0$var$astrmify([
            $53691bda533d12d0$var$bInflt,
            function() {
                return [
                    $53691bda533d12d0$var$astrm,
                    $53691bda533d12d0$export$d1de70a877d6e43c
                ];
            }
        ], this, 0, function() {
            var strm = new $53691bda533d12d0$export$d1de70a877d6e43c();
            onmessage = $53691bda533d12d0$var$astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}();
function $53691bda533d12d0$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $53691bda533d12d0$var$cbify(data, opts, [
        $53691bda533d12d0$var$bInflt
    ], function(ev) {
        return $53691bda533d12d0$var$pbf($53691bda533d12d0$export$90366d8b308ba94a(ev.data[0], $53691bda533d12d0$var$gu8(ev.data[1])));
    }, 1, cb);
}
function $53691bda533d12d0$export$90366d8b308ba94a(data, out) {
    return $53691bda533d12d0$var$inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $53691bda533d12d0$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $53691bda533d12d0$var$crc();
        this.l = 0;
        this.v = 1;
        $53691bda533d12d0$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        $53691bda533d12d0$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = $53691bda533d12d0$var$dopt(c, this.o, this.v && $53691bda533d12d0$var$gzhl(this.o), f && 8, !f);
        if (this.v) $53691bda533d12d0$var$gzh(raw, this.o), this.v = 0;
        if (f) $53691bda533d12d0$var$wbytes(raw, raw.length - 8, this.c.d()), $53691bda533d12d0$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $53691bda533d12d0$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $53691bda533d12d0$var$astrmify([
            $53691bda533d12d0$var$bDflt,
            $53691bda533d12d0$var$gze,
            function() {
                return [
                    $53691bda533d12d0$var$astrm,
                    $53691bda533d12d0$export$ae157b6234afe138,
                    $53691bda533d12d0$export$8e4b66d280bf8342
                ];
            }
        ], this, $53691bda533d12d0$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $53691bda533d12d0$export$8e4b66d280bf8342(ev.data);
            onmessage = $53691bda533d12d0$var$astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}();
function $53691bda533d12d0$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $53691bda533d12d0$var$cbify(data, opts, [
        $53691bda533d12d0$var$bDflt,
        $53691bda533d12d0$var$gze,
        function() {
            return [
                $53691bda533d12d0$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $53691bda533d12d0$var$pbf($53691bda533d12d0$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $53691bda533d12d0$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $53691bda533d12d0$var$crc(), l = data.length;
    c.p(data);
    var d = $53691bda533d12d0$var$dopt(data, opts, $53691bda533d12d0$var$gzhl(opts), 8), s = d.length;
    return $53691bda533d12d0$var$gzh(d, opts), $53691bda533d12d0$var$wbytes(d, s - 8, c.d()), $53691bda533d12d0$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var $53691bda533d12d0$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        $53691bda533d12d0$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $53691bda533d12d0$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            var s = this.p.length > 3 ? $53691bda533d12d0$var$gzs(this.p) : 4;
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) throw 'invalid gzip stream';
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $53691bda533d12d0$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var $53691bda533d12d0$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        $53691bda533d12d0$var$astrmify([
            $53691bda533d12d0$var$bInflt,
            $53691bda533d12d0$var$guze,
            function() {
                return [
                    $53691bda533d12d0$var$astrm,
                    $53691bda533d12d0$export$d1de70a877d6e43c,
                    $53691bda533d12d0$export$4cb607de6db70415
                ];
            }
        ], this, 0, function() {
            var strm = new $53691bda533d12d0$export$4cb607de6db70415();
            onmessage = $53691bda533d12d0$var$astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}();
function $53691bda533d12d0$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $53691bda533d12d0$var$cbify(data, opts, [
        $53691bda533d12d0$var$bInflt,
        $53691bda533d12d0$var$guze,
        function() {
            return [
                $53691bda533d12d0$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $53691bda533d12d0$var$pbf($53691bda533d12d0$export$c80456f7aaba691c(ev.data[0]));
    }, 3, cb);
}
function $53691bda533d12d0$export$c80456f7aaba691c(data, out) {
    return $53691bda533d12d0$var$inflt(data.subarray($53691bda533d12d0$var$gzs(data), -8), out || new $53691bda533d12d0$var$u8($53691bda533d12d0$var$gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var $53691bda533d12d0$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $53691bda533d12d0$var$adler();
        this.v = 1;
        $53691bda533d12d0$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        $53691bda533d12d0$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = $53691bda533d12d0$var$dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) $53691bda533d12d0$var$zlh(raw, this.o), this.v = 0;
        if (f) $53691bda533d12d0$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $53691bda533d12d0$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $53691bda533d12d0$var$astrmify([
            $53691bda533d12d0$var$bDflt,
            $53691bda533d12d0$var$zle,
            function() {
                return [
                    $53691bda533d12d0$var$astrm,
                    $53691bda533d12d0$export$ae157b6234afe138,
                    $53691bda533d12d0$export$4187ccf2467013b9
                ];
            }
        ], this, $53691bda533d12d0$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $53691bda533d12d0$export$4187ccf2467013b9(ev.data);
            onmessage = $53691bda533d12d0$var$astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}();
function $53691bda533d12d0$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $53691bda533d12d0$var$cbify(data, opts, [
        $53691bda533d12d0$var$bDflt,
        $53691bda533d12d0$var$zle,
        function() {
            return [
                $53691bda533d12d0$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $53691bda533d12d0$var$pbf($53691bda533d12d0$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $53691bda533d12d0$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $53691bda533d12d0$var$adler();
    a.p(data);
    var d = $53691bda533d12d0$var$dopt(data, opts, 2, 4);
    return $53691bda533d12d0$var$zlh(d, opts), $53691bda533d12d0$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $53691bda533d12d0$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        $53691bda533d12d0$export$d1de70a877d6e43c.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $53691bda533d12d0$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) throw 'invalid zlib stream';
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $53691bda533d12d0$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $53691bda533d12d0$export$cf6668790220dcad = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        $53691bda533d12d0$var$astrmify([
            $53691bda533d12d0$var$bInflt,
            $53691bda533d12d0$var$zule,
            function() {
                return [
                    $53691bda533d12d0$var$astrm,
                    $53691bda533d12d0$export$d1de70a877d6e43c,
                    $53691bda533d12d0$export$af2424f875ff1b17
                ];
            }
        ], this, 0, function() {
            var strm = new $53691bda533d12d0$export$af2424f875ff1b17();
            onmessage = $53691bda533d12d0$var$astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}();
function $53691bda533d12d0$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return $53691bda533d12d0$var$cbify(data, opts, [
        $53691bda533d12d0$var$bInflt,
        $53691bda533d12d0$var$zule,
        function() {
            return [
                $53691bda533d12d0$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $53691bda533d12d0$var$pbf($53691bda533d12d0$export$9ec8134f0f1b9fc6(ev.data[0], $53691bda533d12d0$var$gu8(ev.data[1])));
    }, 5, cb);
}
function $53691bda533d12d0$export$9ec8134f0f1b9fc6(data, out) {
    return $53691bda533d12d0$var$inflt(($53691bda533d12d0$var$zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $53691bda533d12d0$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = $53691bda533d12d0$export$4cb607de6db70415;
        this.I = $53691bda533d12d0$export$d1de70a877d6e43c;
        this.Z = $53691bda533d12d0$export$af2424f875ff1b17;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no stream handler';
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $53691bda533d12d0$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $53691bda533d12d0$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = $53691bda533d12d0$export$d5adcdd968132151;
        this.I = $53691bda533d12d0$export$fff8358d6dbaa9cc;
        this.Z = $53691bda533d12d0$export$cf6668790220dcad;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        $53691bda533d12d0$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $53691bda533d12d0$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $53691bda533d12d0$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $53691bda533d12d0$export$cae1ce83fe4a1782(data, opts, cb) : $53691bda533d12d0$export$ca7cbb494e731274(data, opts, cb);
}
function $53691bda533d12d0$export$c4bdbbbc9a4faabe(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $53691bda533d12d0$export$c80456f7aaba691c(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $53691bda533d12d0$export$90366d8b308ba94a(data, out) : $53691bda533d12d0$export$9ec8134f0f1b9fc6(data, out);
}
// flatten a directory structure
var $53691bda533d12d0$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k;
        if (val instanceof $53691bda533d12d0$var$u8) t[n] = [
            val,
            o
        ];
        else if (Array.isArray(val)) t[n] = [
            val[0],
            $53691bda533d12d0$var$mrg(o, val[1])
        ];
        else $53691bda533d12d0$var$fltn(val, n + '/', t, o);
    }
};
// text encoder
var $53691bda533d12d0$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $53691bda533d12d0$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $53691bda533d12d0$var$tds = 0;
try {
    $53691bda533d12d0$var$td.decode($53691bda533d12d0$var$et, {
        stream: true
    });
    $53691bda533d12d0$var$tds = 1;
} catch (e) {}
// decode UTF8
var $53691bda533d12d0$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return [
            r,
            $53691bda533d12d0$var$slc(d, i - 1)
        ];
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $53691bda533d12d0$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($53691bda533d12d0$var$tds) this.t = new TextDecoder();
        else this.p = $53691bda533d12d0$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no callback';
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) throw 'invalid utf-8 data';
                this.t = null;
            }
            return;
        }
        if (!this.p) throw 'stream finished';
        var dat = new $53691bda533d12d0$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $53691bda533d12d0$var$dutf8(dat), ch = _a[0], np = _a[1];
        if (final) {
            if (np.length) throw 'invalid utf-8 data';
            this.p = null;
        } else this.p = np;
        this.ondata(ch, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $53691bda533d12d0$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no callback';
        if (this.d) throw 'stream finished';
        this.ondata($53691bda533d12d0$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $53691bda533d12d0$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $53691bda533d12d0$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($53691bda533d12d0$var$te) return $53691bda533d12d0$var$te.encode(str);
    var l = str.length;
    var ar = new $53691bda533d12d0$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $53691bda533d12d0$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $53691bda533d12d0$var$slc(ar, 0, ai);
}
function $53691bda533d12d0$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($53691bda533d12d0$var$td) return $53691bda533d12d0$var$td.decode(dat);
    else {
        var _a = $53691bda533d12d0$var$dutf8(dat), out = _a[0], ext = _a[1];
        if (ext.length) throw 'invalid utf-8 data';
        return out;
    }
}
// deflate bit flag
var $53691bda533d12d0$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $53691bda533d12d0$var$slzh = function(d, b) {
    return b + 30 + $53691bda533d12d0$var$b2(d, b + 26) + $53691bda533d12d0$var$b2(d, b + 28);
};
// read zip header
var $53691bda533d12d0$var$zh = function(d, b, z) {
    var fnl = $53691bda533d12d0$var$b2(d, b + 28), fn = $53691bda533d12d0$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($53691bda533d12d0$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $53691bda533d12d0$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $53691bda533d12d0$var$z64e(d, es) : [
        bs,
        $53691bda533d12d0$var$b4(d, b + 24),
        $53691bda533d12d0$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $53691bda533d12d0$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $53691bda533d12d0$var$b2(d, b + 30) + $53691bda533d12d0$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $53691bda533d12d0$var$z64e = function(d, b) {
    for(; $53691bda533d12d0$var$b2(d, b) != 1; b += 4 + $53691bda533d12d0$var$b2(d, b + 2));
    return [
        $53691bda533d12d0$var$b8(d, b + 12),
        $53691bda533d12d0$var$b8(d, b + 4),
        $53691bda533d12d0$var$b8(d, b + 20)
    ];
};
// extra field length
var $53691bda533d12d0$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) throw 'extra field too long';
        le += l + 4;
    }
    return le;
};
// write zip header
var $53691bda533d12d0$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $53691bda533d12d0$var$exfl(ex);
    $53691bda533d12d0$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c == null && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) throw 'date not in range 1980-2099';
    $53691bda533d12d0$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1), b += 4;
    if (c != null) {
        $53691bda533d12d0$var$wbytes(d, b, f.crc);
        $53691bda533d12d0$var$wbytes(d, b + 4, c);
        $53691bda533d12d0$var$wbytes(d, b + 8, f.size);
    }
    $53691bda533d12d0$var$wbytes(d, b + 12, fl);
    $53691bda533d12d0$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $53691bda533d12d0$var$wbytes(d, b, col);
        $53691bda533d12d0$var$wbytes(d, b + 6, f.attrs);
        $53691bda533d12d0$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $53691bda533d12d0$var$wbytes(d, b, +k);
        $53691bda533d12d0$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $53691bda533d12d0$var$wzf = function(o, b, c, d, e) {
    $53691bda533d12d0$var$wbytes(o, b, 0x6054B50); // skip disk
    $53691bda533d12d0$var$wbytes(o, b + 8, c);
    $53691bda533d12d0$var$wbytes(o, b + 10, c);
    $53691bda533d12d0$var$wbytes(o, b + 12, d);
    $53691bda533d12d0$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $53691bda533d12d0$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $53691bda533d12d0$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) throw 'no callback - add to ZIP archive before pushing';
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $53691bda533d12d0$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $53691bda533d12d0$export$2b25194e1767ea06.call(this, filename);
        this.d = new $53691bda533d12d0$export$ae157b6234afe138(opts, function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $53691bda533d12d0$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $53691bda533d12d0$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $53691bda533d12d0$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this_1 = this;
        if (!opts) opts = {};
        $53691bda533d12d0$export$2b25194e1767ea06.call(this, filename);
        this.d = new $53691bda533d12d0$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this_1.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $53691bda533d12d0$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $53691bda533d12d0$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $53691bda533d12d0$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this_1 = this;
        if (this.d & 2) throw 'stream finished';
        var f = $53691bda533d12d0$export$366b39a6daa8ed7a(file.filename), fl = f.length;
        var com = file.comment, o = com && $53691bda533d12d0$export$366b39a6daa8ed7a(com);
        var u = fl != file.filename.length || o && com.length != o.length;
        var hl = fl + $53691bda533d12d0$var$exfl(file.extra) + 30;
        if (fl > 65535) throw 'filename too long';
        var header = new $53691bda533d12d0$var$u8(hl);
        $53691bda533d12d0$var$wzh(header, 0, file, f, u);
        var chks = [
            header
        ];
        var pAll = function() {
            for(var _i = 0, chks_1 = chks; _i < chks_1.length; _i++){
                var chk = chks_1[_i];
                _this_1.ondata(null, chk, false);
            }
            chks = [];
        };
        var tr = this.d;
        this.d = 0;
        var ind = this.u.length;
        var uf = $53691bda533d12d0$var$mrg(file, {
            f: f,
            u: u,
            o: o,
            t: function() {
                if (file.terminate) file.terminate();
            },
            r: function() {
                pAll();
                if (tr) {
                    var nxt = _this_1.u[ind + 1];
                    if (nxt) nxt.r();
                    else _this_1.d = 1;
                }
                tr = 1;
            }
        });
        var cl = 0;
        file.ondata = function(err, dat, final) {
            if (err) {
                _this_1.ondata(err, dat, final);
                _this_1.terminate();
            } else {
                cl += dat.length;
                chks.push(dat);
                if (final) {
                    var dd = new $53691bda533d12d0$var$u8(16);
                    $53691bda533d12d0$var$wbytes(dd, 0, 0x8074B50);
                    $53691bda533d12d0$var$wbytes(dd, 4, file.crc);
                    $53691bda533d12d0$var$wbytes(dd, 8, cl);
                    $53691bda533d12d0$var$wbytes(dd, 12, file.size);
                    chks.push(dd);
                    uf.c = cl, uf.b = hl + cl + 16, uf.crc = file.crc, uf.size = file.size;
                    if (tr) uf.r();
                    tr = 1;
                } else if (tr) pAll();
            }
        };
        this.u.push(uf);
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this_1 = this;
        if (this.d & 2) {
            if (this.d & 1) throw 'stream finishing';
            throw 'stream finished';
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this_1.d & 1)) return;
                _this_1.u.splice(-1, 1);
                _this_1.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $53691bda533d12d0$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $53691bda533d12d0$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $53691bda533d12d0$var$wzh(out, bt, f, f.f, f.u, f.c, l, f.o);
            bt += 46 + f.f.length + $53691bda533d12d0$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $53691bda533d12d0$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $53691bda533d12d0$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') throw 'no callback';
    var r = {};
    $53691bda533d12d0$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbf = function() {
        var out = new $53691bda533d12d0$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $53691bda533d12d0$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $53691bda533d12d0$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $53691bda533d12d0$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cb(e, null);
            }
        }
        $53691bda533d12d0$var$wzf(out, o, files.length, cdl, oe);
        cb(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $53691bda533d12d0$var$crc(), size = file.length;
        c.p(file);
        var f = $53691bda533d12d0$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $53691bda533d12d0$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $53691bda533d12d0$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                var l = d.length;
                files[i] = $53691bda533d12d0$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl('filename too long', null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $53691bda533d12d0$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($53691bda533d12d0$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $53691bda533d12d0$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $53691bda533d12d0$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $53691bda533d12d0$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $53691bda533d12d0$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $53691bda533d12d0$var$exfl(p.extra);
        if (s > 65535) throw 'filename too long';
        var d = compression ? $53691bda533d12d0$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $53691bda533d12d0$var$crc();
        c.p(file);
        files.push($53691bda533d12d0$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $53691bda533d12d0$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $53691bda533d12d0$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $53691bda533d12d0$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $53691bda533d12d0$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $53691bda533d12d0$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $53691bda533d12d0$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $53691bda533d12d0$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this_1 = this;
        this.i = new $53691bda533d12d0$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, data, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $53691bda533d12d0$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this_1 = this;
        if (sz < 320000) this.i = new $53691bda533d12d0$export$d1de70a877d6e43c(function(dat, final) {
            _this_1.ondata(null, dat, final);
        });
        else {
            this.i = new $53691bda533d12d0$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this_1.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $53691bda533d12d0$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $53691bda533d12d0$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $53691bda533d12d0$export$93f81d5bbbb7c6bf
        };
        this.p = $53691bda533d12d0$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this_1 = this;
        if (!this.onfile) throw 'no callback';
        if (!this.p) throw 'stream finished';
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $53691bda533d12d0$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $53691bda533d12d0$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $53691bda533d12d0$var$b2(buf, i + 6), cmp_1 = $53691bda533d12d0$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $53691bda533d12d0$var$b2(buf, i + 26), es = $53691bda533d12d0$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_2 = [];
                        this_1.k.unshift(chks_2);
                        f = 2;
                        var sc_1 = $53691bda533d12d0$var$b4(buf, i + 18), su_1 = $53691bda533d12d0$var$b4(buf, i + 22);
                        var fn_1 = $53691bda533d12d0$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $53691bda533d12d0$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) throw 'no callback';
                                if (!sc_1) file_1.ondata(null, $53691bda533d12d0$var$et, true);
                                else {
                                    var ctr = _this_1.o[cmp_1];
                                    if (!ctr) throw 'unknown compression type ' + cmp_1;
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_3 = chks_2; _i < chks_3.length; _i++){
                                        var dat = chks_3[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this_1.k[0] == chks_2 && _this_1.c) _this_1.d = d_1;
                                    else d_1.push($53691bda533d12d0$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $53691bda533d12d0$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($53691bda533d12d0$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) throw 'invalid zip file';
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
function $53691bda533d12d0$export$23c8d3f8757cab88(data, cb) {
    if (typeof cb != 'function') throw 'no callback';
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var e = data.length - 22;
    for(; $53691bda533d12d0$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cb('invalid zip file', null);
        return;
    }
    var lft = $53691bda533d12d0$var$b2(data, e + 8);
    if (!lft) cb(null, {});
    var c = lft;
    var o = $53691bda533d12d0$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $53691bda533d12d0$var$b4(data, e - 12);
        if ($53691bda533d12d0$var$b4(data, e) != 0x6064B50) {
            cb('invalid zip file', null);
            return;
        }
        c = lft = $53691bda533d12d0$var$b4(data, e + 32);
        o = $53691bda533d12d0$var$b4(data, e + 48);
    }
    var _loop_3 = function(i) {
        var _a = $53691bda533d12d0$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $53691bda533d12d0$var$slzh(data, off);
        o = no;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                files[fn] = d;
                if (!--lft) cb(null, files);
            }
        };
        if (!c_1) cbl(null, $53691bda533d12d0$var$slc(data, b, b + sc));
        else if (c_1 == 8) {
            var infl = data.subarray(b, b + sc);
            if (sc < 320000) try {
                cbl(null, $53691bda533d12d0$export$90366d8b308ba94a(infl, new $53691bda533d12d0$var$u8(su)));
            } catch (e) {
                cbl(e, null);
            }
            else term.push($53691bda533d12d0$export$cae1ce83fe4a1782(infl, {
                size: su
            }, cbl));
        } else cbl('unknown compression type ' + c_1, null);
    };
    for(var i = 0; i < c; ++i)_loop_3(i);
    return tAll;
}
function $53691bda533d12d0$export$c757709326bb5901(data) {
    var files = {};
    var e = data.length - 22;
    for(; $53691bda533d12d0$var$b4(data, e) != 0x6054B50; --e){
        if (!e || data.length - e > 65558) throw 'invalid zip file';
    }
    var c = $53691bda533d12d0$var$b2(data, e + 8);
    if (!c) return {};
    var o = $53691bda533d12d0$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $53691bda533d12d0$var$b4(data, e - 12);
        if ($53691bda533d12d0$var$b4(data, e) != 0x6064B50) throw 'invalid zip file';
        c = $53691bda533d12d0$var$b4(data, e + 32);
        o = $53691bda533d12d0$var$b4(data, e + 48);
    }
    for(var i = 0; i < c; ++i){
        var _a = $53691bda533d12d0$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $53691bda533d12d0$var$slzh(data, off);
        o = no;
        if (!c_2) files[fn] = $53691bda533d12d0$var$slc(data, b, b + sc);
        else if (c_2 == 8) files[fn] = $53691bda533d12d0$export$90366d8b308ba94a(data.subarray(b, b + sc), new $53691bda533d12d0$var$u8(su));
        else throw 'unknown compression type ' + c_2;
    }
    return files;
}

});

parcelRegister("cLt9Z", function(module, exports) {

$parcel$export(module.exports, "NURBSCurve", () => $94b07e67f83726ad$export$12efb26d7429b049);

var $ilwiq = parcelRequire("ilwiq");

var $5joV2 = parcelRequire("5joV2");
/**
 * NURBS curve object
 *
 * Derives from Curve, overriding getPoint and getTangent.
 *
 * Implementation is based on (x, y [, z=0 [, w=1]]) control points with w=weight.
 *
 **/ class $94b07e67f83726ad$export$12efb26d7429b049 extends (0, $ilwiq.Curve) {
    constructor(degree, knots /* array of reals */ , controlPoints /* array of Vector(2|3|4) */ , startKnot /* index in knots */ , endKnot /* index in knots */ ){
        super();
        this.degree = degree;
        this.knots = knots;
        this.controlPoints = [];
        // Used by periodic NURBS to remove hidden spans
        this.startKnot = startKnot || 0;
        this.endKnot = endKnot || this.knots.length - 1;
        for(let i = 0; i < controlPoints.length; ++i){
            // ensure Vector4 for control points
            const point = controlPoints[i];
            this.controlPoints[i] = new (0, $ilwiq.Vector4)(point.x, point.y, point.z, point.w);
        }
    }
    getPoint(t, optionalTarget = new (0, $ilwiq.Vector3)()) {
        const point = optionalTarget;
        const u = this.knots[this.startKnot] + t * (this.knots[this.endKnot] - this.knots[this.startKnot]); // linear mapping t->u
        // following results in (wx, wy, wz, w) homogeneous point
        const hpoint = $5joV2.calcBSplinePoint(this.degree, this.knots, this.controlPoints, u);
        if (hpoint.w !== 1.0) // project to 3D space: (wx, wy, wz, w) -> (x, y, z, 1)
        hpoint.divideScalar(hpoint.w);
        return point.set(hpoint.x, hpoint.y, hpoint.z);
    }
    getTangent(t, optionalTarget = new (0, $ilwiq.Vector3)()) {
        const tangent = optionalTarget;
        const u = this.knots[0] + t * (this.knots[this.knots.length - 1] - this.knots[0]);
        const ders = $5joV2.calcNURBSDerivatives(this.degree, this.knots, this.controlPoints, u, 1);
        tangent.copy(ders[1]).normalize();
        return tangent;
    }
}

});
parcelRegister("5joV2", function(module, exports) {

$parcel$export(module.exports, "calcBSplinePoint", () => $3de20e7c02944e1d$export$3672a5d5ca534534);
$parcel$export(module.exports, "calcNURBSDerivatives", () => $3de20e7c02944e1d$export$692f68f163c8f6b);

var $ilwiq = parcelRequire("ilwiq");
/**
 * NURBS utils
 *
 * See NURBSCurve and NURBSSurface.
 **/ /**************************************************************
 *	NURBS Utils
 **************************************************************/ /*
Finds knot vector span.

p : degree
u : parametric value
U : knot vector

returns the span
*/ function $3de20e7c02944e1d$export$5d44f085c0641ab4(p, u, U) {
    const n = U.length - p - 1;
    if (u >= U[n]) return n - 1;
    if (u <= U[p]) return p;
    let low = p;
    let high = n;
    let mid = Math.floor((low + high) / 2);
    while(u < U[mid] || u >= U[mid + 1]){
        if (u < U[mid]) high = mid;
        else low = mid;
        mid = Math.floor((low + high) / 2);
    }
    return mid;
}
/*
Calculate basis functions. See The NURBS Book, page 70, algorithm A2.2

span : span in which u lies
u    : parametric point
p    : degree
U    : knot vector

returns array[p+1] with basis functions values.
*/ function $3de20e7c02944e1d$export$bbebd61f407f7f41(span, u, p, U) {
    const N = [];
    const left = [];
    const right = [];
    N[0] = 1.0;
    for(let j = 1; j <= p; ++j){
        left[j] = u - U[span + 1 - j];
        right[j] = U[span + j] - u;
        let saved = 0.0;
        for(let r = 0; r < j; ++r){
            const rv = right[r + 1];
            const lv = left[j - r];
            const temp = N[r] / (rv + lv);
            N[r] = saved + rv * temp;
            saved = lv * temp;
        }
        N[j] = saved;
    }
    return N;
}
/*
Calculate B-Spline curve points. See The NURBS Book, page 82, algorithm A3.1.

p : degree of B-Spline
U : knot vector
P : control points (x, y, z, w)
u : parametric point

returns point for given u
*/ function $3de20e7c02944e1d$export$3672a5d5ca534534(p, U, P, u) {
    const span = $3de20e7c02944e1d$export$5d44f085c0641ab4(p, u, U);
    const N = $3de20e7c02944e1d$export$bbebd61f407f7f41(span, u, p, U);
    const C = new (0, $ilwiq.Vector4)(0, 0, 0, 0);
    for(let j = 0; j <= p; ++j){
        const point = P[span - p + j];
        const Nj = N[j];
        const wNj = point.w * Nj;
        C.x += point.x * wNj;
        C.y += point.y * wNj;
        C.z += point.z * wNj;
        C.w += point.w * Nj;
    }
    return C;
}
/*
Calculate basis functions derivatives. See The NURBS Book, page 72, algorithm A2.3.

span : span in which u lies
u    : parametric point
p    : degree
n    : number of derivatives to calculate
U    : knot vector

returns array[n+1][p+1] with basis functions derivatives
*/ function $3de20e7c02944e1d$export$70bfab2ede47286(span, u, p, n, U) {
    const zeroArr = [];
    for(let i = 0; i <= p; ++i)zeroArr[i] = 0.0;
    const ders = [];
    for(let i = 0; i <= n; ++i)ders[i] = zeroArr.slice(0);
    const ndu = [];
    for(let i = 0; i <= p; ++i)ndu[i] = zeroArr.slice(0);
    ndu[0][0] = 1.0;
    const left = zeroArr.slice(0);
    const right = zeroArr.slice(0);
    for(let j = 1; j <= p; ++j){
        left[j] = u - U[span + 1 - j];
        right[j] = U[span + j] - u;
        let saved = 0.0;
        for(let r = 0; r < j; ++r){
            const rv = right[r + 1];
            const lv = left[j - r];
            ndu[j][r] = rv + lv;
            const temp = ndu[r][j - 1] / ndu[j][r];
            ndu[r][j] = saved + rv * temp;
            saved = lv * temp;
        }
        ndu[j][j] = saved;
    }
    for(let j = 0; j <= p; ++j)ders[0][j] = ndu[j][p];
    for(let r = 0; r <= p; ++r){
        let s1 = 0;
        let s2 = 1;
        const a = [];
        for(let i = 0; i <= p; ++i)a[i] = zeroArr.slice(0);
        a[0][0] = 1.0;
        for(let k = 1; k <= n; ++k){
            let d = 0.0;
            const rk = r - k;
            const pk = p - k;
            if (r >= k) {
                a[s2][0] = a[s1][0] / ndu[pk + 1][rk];
                d = a[s2][0] * ndu[rk][pk];
            }
            const j1 = rk >= -1 ? 1 : -rk;
            const j2 = r - 1 <= pk ? k - 1 : p - r;
            for(let j = j1; j <= j2; ++j){
                a[s2][j] = (a[s1][j] - a[s1][j - 1]) / ndu[pk + 1][rk + j];
                d += a[s2][j] * ndu[rk + j][pk];
            }
            if (r <= pk) {
                a[s2][k] = -a[s1][k - 1] / ndu[pk + 1][r];
                d += a[s2][k] * ndu[r][pk];
            }
            ders[k][r] = d;
            const j = s1;
            s1 = s2;
            s2 = j;
        }
    }
    let r = p;
    for(let k = 1; k <= n; ++k){
        for(let j = 0; j <= p; ++j)ders[k][j] *= r;
        r *= p - k;
    }
    return ders;
}
/*
	Calculate derivatives of a B-Spline. See The NURBS Book, page 93, algorithm A3.2.

	p  : degree
	U  : knot vector
	P  : control points
	u  : Parametric points
	nd : number of derivatives

	returns array[d+1] with derivatives
	*/ function $3de20e7c02944e1d$export$ae5bff7435823e13(p, U, P, u, nd) {
    const du = nd < p ? nd : p;
    const CK = [];
    const span = $3de20e7c02944e1d$export$5d44f085c0641ab4(p, u, U);
    const nders = $3de20e7c02944e1d$export$70bfab2ede47286(span, u, p, du, U);
    const Pw = [];
    for(let i = 0; i < P.length; ++i){
        const point = P[i].clone();
        const w = point.w;
        point.x *= w;
        point.y *= w;
        point.z *= w;
        Pw[i] = point;
    }
    for(let k = 0; k <= du; ++k){
        const point = Pw[span - p].clone().multiplyScalar(nders[k][0]);
        for(let j = 1; j <= p; ++j)point.add(Pw[span - p + j].clone().multiplyScalar(nders[k][j]));
        CK[k] = point;
    }
    for(let k = du + 1; k <= nd + 1; ++k)CK[k] = new (0, $ilwiq.Vector4)(0, 0, 0);
    return CK;
}
/*
Calculate "K over I"

returns k!/(i!(k-i)!)
*/ function $3de20e7c02944e1d$export$3c88b91ac9312187(k, i) {
    let nom = 1;
    for(let j = 2; j <= k; ++j)nom *= j;
    let denom = 1;
    for(let j = 2; j <= i; ++j)denom *= j;
    for(let j = 2; j <= k - i; ++j)denom *= j;
    return nom / denom;
}
/*
Calculate derivatives (0-nd) of rational curve. See The NURBS Book, page 127, algorithm A4.2.

Pders : result of function calcBSplineDerivatives

returns array with derivatives for rational curve.
*/ function $3de20e7c02944e1d$export$66805edec2c1a55d(Pders) {
    const nd = Pders.length;
    const Aders = [];
    const wders = [];
    for(let i = 0; i < nd; ++i){
        const point = Pders[i];
        Aders[i] = new (0, $ilwiq.Vector3)(point.x, point.y, point.z);
        wders[i] = point.w;
    }
    const CK = [];
    for(let k = 0; k < nd; ++k){
        const v = Aders[k].clone();
        for(let i = 1; i <= k; ++i)v.sub(CK[k - i].clone().multiplyScalar($3de20e7c02944e1d$export$3c88b91ac9312187(k, i) * wders[i]));
        CK[k] = v.divideScalar(wders[0]);
    }
    return CK;
}
/*
Calculate NURBS curve derivatives. See The NURBS Book, page 127, algorithm A4.2.

p  : degree
U  : knot vector
P  : control points in homogeneous space
u  : parametric points
nd : number of derivatives

returns array with derivatives.
*/ function $3de20e7c02944e1d$export$692f68f163c8f6b(p, U, P, u, nd) {
    const Pders = $3de20e7c02944e1d$export$ae5bff7435823e13(p, U, P, u, nd);
    return $3de20e7c02944e1d$export$66805edec2c1a55d(Pders);
}
/*
Calculate rational B-Spline surface point. See The NURBS Book, page 134, algorithm A4.3.

p1, p2 : degrees of B-Spline surface
U1, U2 : knot vectors
P      : control points (x, y, z, w)
u, v   : parametric values

returns point for given (u, v)
*/ function $3de20e7c02944e1d$export$6574b03464941be7(p, q, U, V, P, u, v, target) {
    const uspan = $3de20e7c02944e1d$export$5d44f085c0641ab4(p, u, U);
    const vspan = $3de20e7c02944e1d$export$5d44f085c0641ab4(q, v, V);
    const Nu = $3de20e7c02944e1d$export$bbebd61f407f7f41(uspan, u, p, U);
    const Nv = $3de20e7c02944e1d$export$bbebd61f407f7f41(vspan, v, q, V);
    const temp = [];
    for(let l = 0; l <= q; ++l){
        temp[l] = new (0, $ilwiq.Vector4)(0, 0, 0, 0);
        for(let k = 0; k <= p; ++k){
            const point = P[uspan - p + k][vspan - q + l].clone();
            const w = point.w;
            point.x *= w;
            point.y *= w;
            point.z *= w;
            temp[l].add(point.multiplyScalar(Nu[k]));
        }
    }
    const Sw = new (0, $ilwiq.Vector4)(0, 0, 0, 0);
    for(let l = 0; l <= q; ++l)Sw.add(temp[l].multiplyScalar(Nv[l]));
    Sw.divideScalar(Sw.w);
    target.set(Sw.x, Sw.y, Sw.z);
}

});



parcelRegister("hYjPp", function(module, exports) {

$parcel$export(module.exports, "STLLoader", () => $d1576bbc709673e2$export$78deb5981b3aff86);

var $ilwiq = parcelRequire("ilwiq");

var $jeyyu = parcelRequire("jeyyu");
/**
 * Description: A THREE loader for STL ASCII files, as created by Solidworks and other CAD programs.
 *
 * Supports both binary and ASCII encoded files, with automatic detection of type.
 *
 * The loader returns a non-indexed buffer geometry.
 *
 * Limitations:
 *  Binary decoding supports "Magics" color format (http://en.wikipedia.org/wiki/STL_(file_format)#Color_in_binary_STL).
 *  There is perhaps some question as to how valid it is to always assume little-endian-ness.
 *  ASCII decoding assumes file is UTF-8.
 *
 * Usage:
 *  const loader = new STLLoader();
 *  loader.load( './models/stl/slotted_disk.stl', function ( geometry ) {
 *    scene.add( new THREE.Mesh( geometry ) );
 *  });
 *
 * For binary STLs geometry might contain colors for vertices. To use it:
 *  // use the same code to load STL as above
 *  if (geometry.hasColors) {
 *    material = new THREE.MeshPhongMaterial({ opacity: geometry.alpha, vertexColors: true });
 *  } else { .... }
 *  const mesh = new THREE.Mesh( geometry, material );
 *
 * For ASCII STLs containing multiple solids, each solid is assigned to a different group.
 * Groups can be used to assign a different color by defining an array of materials with the same length of
 * geometry.groups and passing it to the Mesh constructor:
 *
 * const mesh = new THREE.Mesh( geometry, material );
 *
 * For example:
 *
 *  const materials = [];
 *  const nGeometryGroups = geometry.groups.length;
 *
 *  const colorMap = ...; // Some logic to index colors.
 *
 *  for (let i = 0; i < nGeometryGroups; i++) {
 *
 *		const material = new THREE.MeshPhongMaterial({
 *			color: colorMap[i],
 *			wireframe: false
 *		});
 *
 *  }
 *
 *  materials.push(material);
 *  const mesh = new THREE.Mesh(geometry, materials);
 */ class $d1576bbc709673e2$export$78deb5981b3aff86 extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new (0, $jeyyu.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(text));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(data) {
        function isBinary(data) {
            const reader = new DataView(data);
            const face_size = 50;
            const n_faces = reader.getUint32(80, true);
            const expect = 84 + n_faces * face_size;
            if (expect === reader.byteLength) return true;
            // An ASCII STL data must begin with 'solid ' as the first six bytes.
            // However, ASCII STLs lacking the SPACE after the 'd' are known to be
            // plentiful.  So, check the first 5 bytes for 'solid'.
            // Several encodings, such as UTF-8, precede the text with up to 5 bytes:
            // https://en.wikipedia.org/wiki/Byte_order_mark#Byte_order_marks_by_encoding
            // Search for "solid" to start anywhere after those prefixes.
            // US-ASCII ordinal values for 's', 'o', 'l', 'i', 'd'
            const solid = [
                115,
                111,
                108,
                105,
                100
            ];
            for(let off = 0; off < 5; off++){
                // If "solid" text is matched to the current offset, declare it to be an ASCII STL.
                if (matchDataViewAt(solid, reader, off)) return false;
            }
            // Couldn't find "solid" text at the beginning; it is binary STL.
            return true;
        }
        function matchDataViewAt(query, reader, offset) {
            // Check if each byte in query matches the corresponding byte from the current offset
            for(let i = 0, il = query.length; i < il; i++){
                if (query[i] !== reader.getUint8(offset + i)) return false;
            }
            return true;
        }
        function parseBinary(data) {
            const reader = new DataView(data);
            const faces = reader.getUint32(80, true);
            let r, g, b, hasColors = false, colors;
            let defaultR, defaultG, defaultB, alpha;
            // process STL header
            // check for default color in header ("COLOR=rgba" sequence).
            for(let index = 0; index < 70; index++)if (reader.getUint32(index, false) == 0x434f4c4f /*COLO*/  && reader.getUint8(index + 4) == 0x52 /*'R'*/  && reader.getUint8(index + 5) == 0x3d /*'='*/ ) {
                hasColors = true;
                colors = new Float32Array(faces * 9);
                defaultR = reader.getUint8(index + 6) / 255;
                defaultG = reader.getUint8(index + 7) / 255;
                defaultB = reader.getUint8(index + 8) / 255;
                alpha = reader.getUint8(index + 9) / 255;
            }
            const dataOffset = 84;
            const faceLength = 50;
            const geometry = new (0, $ilwiq.BufferGeometry)();
            const vertices = new Float32Array(faces * 9);
            const normals = new Float32Array(faces * 9);
            const color = new (0, $ilwiq.Color)();
            for(let face = 0; face < faces; face++){
                const start = dataOffset + face * faceLength;
                const normalX = reader.getFloat32(start, true);
                const normalY = reader.getFloat32(start + 4, true);
                const normalZ = reader.getFloat32(start + 8, true);
                if (hasColors) {
                    const packedColor = reader.getUint16(start + 48, true);
                    if ((packedColor & 0x8000) === 0) {
                        // facet has its own unique color
                        r = (packedColor & 0x1f) / 31;
                        g = (packedColor >> 5 & 0x1f) / 31;
                        b = (packedColor >> 10 & 0x1f) / 31;
                    } else {
                        r = defaultR;
                        g = defaultG;
                        b = defaultB;
                    }
                }
                for(let i = 1; i <= 3; i++){
                    const vertexstart = start + i * 12;
                    const componentIdx = face * 9 + (i - 1) * 3;
                    vertices[componentIdx] = reader.getFloat32(vertexstart, true);
                    vertices[componentIdx + 1] = reader.getFloat32(vertexstart + 4, true);
                    vertices[componentIdx + 2] = reader.getFloat32(vertexstart + 8, true);
                    normals[componentIdx] = normalX;
                    normals[componentIdx + 1] = normalY;
                    normals[componentIdx + 2] = normalZ;
                    if (hasColors) {
                        color.set(r, g, b).convertSRGBToLinear();
                        colors[componentIdx] = color.r;
                        colors[componentIdx + 1] = color.g;
                        colors[componentIdx + 2] = color.b;
                    }
                }
            }
            geometry.setAttribute('position', new (0, $ilwiq.BufferAttribute)(vertices, 3));
            geometry.setAttribute('normal', new (0, $ilwiq.BufferAttribute)(normals, 3));
            if (hasColors) {
                geometry.setAttribute('color', new (0, $ilwiq.BufferAttribute)(colors, 3));
                geometry.hasColors = true;
                geometry.alpha = alpha;
            }
            return geometry;
        }
        function parseASCII(data) {
            const geometry = new (0, $ilwiq.BufferGeometry)();
            const patternSolid = /solid([\s\S]*?)endsolid/g;
            const patternFace = /facet([\s\S]*?)endfacet/g;
            const patternName = /solid\s(.+)/;
            let faceCounter = 0;
            const patternFloat = /[\s]+([+-]?(?:\d*)(?:\.\d*)?(?:[eE][+-]?\d+)?)/.source;
            const patternVertex = new RegExp('vertex' + patternFloat + patternFloat + patternFloat, 'g');
            const patternNormal = new RegExp('normal' + patternFloat + patternFloat + patternFloat, 'g');
            const vertices = [];
            const normals = [];
            const groupNames = [];
            const normal = new (0, $ilwiq.Vector3)();
            let result;
            let groupCount = 0;
            let startVertex = 0;
            let endVertex = 0;
            while((result = patternSolid.exec(data)) !== null){
                startVertex = endVertex;
                const solid = result[0];
                const name = (result = patternName.exec(solid)) !== null ? result[1] : '';
                groupNames.push(name);
                while((result = patternFace.exec(solid)) !== null){
                    let vertexCountPerFace = 0;
                    let normalCountPerFace = 0;
                    const text = result[0];
                    while((result = patternNormal.exec(text)) !== null){
                        normal.x = parseFloat(result[1]);
                        normal.y = parseFloat(result[2]);
                        normal.z = parseFloat(result[3]);
                        normalCountPerFace++;
                    }
                    while((result = patternVertex.exec(text)) !== null){
                        vertices.push(parseFloat(result[1]), parseFloat(result[2]), parseFloat(result[3]));
                        normals.push(normal.x, normal.y, normal.z);
                        vertexCountPerFace++;
                        endVertex++;
                    }
                    // every face have to own ONE valid normal
                    if (normalCountPerFace !== 1) console.error("THREE.STLLoader: Something isn't right with the normal of face number " + faceCounter);
                    // each face have to own THREE valid vertices
                    if (vertexCountPerFace !== 3) console.error("THREE.STLLoader: Something isn't right with the vertices of face number " + faceCounter);
                    faceCounter++;
                }
                const start = startVertex;
                const count = endVertex - startVertex;
                geometry.userData.groupNames = groupNames;
                geometry.addGroup(start, count, groupCount);
                groupCount++;
            }
            geometry.setAttribute('position', new (0, $ilwiq.Float32BufferAttribute)(vertices, 3));
            geometry.setAttribute('normal', new (0, $ilwiq.Float32BufferAttribute)(normals, 3));
            return geometry;
        }
        function ensureString(buffer) {
            if (typeof buffer !== 'string') return new TextDecoder().decode(buffer);
            return buffer;
        }
        function ensureBinary(buffer) {
            if (typeof buffer === 'string') {
                const array_buffer = new Uint8Array(buffer.length);
                for(let i = 0; i < buffer.length; i++)array_buffer[i] = buffer.charCodeAt(i) & 0xff // implicitly assumes little-endian
                ;
                return array_buffer.buffer || array_buffer;
            } else return buffer;
        }
        // start
        const binData = ensureBinary(data);
        return isBinary(binData) ? parseBinary(binData) : parseASCII(ensureString(data));
    }
}

});

parcelRegister("90G9q", function(module, exports) {

$parcel$export(module.exports, "Rhino3dmLoader", () => $68f4cf6f464da6da$export$5f28558e2afe33ab);

var $ilwiq = parcelRequire("ilwiq");

var $jeyyu = parcelRequire("jeyyu");

var $4U9Bx = parcelRequire("4U9Bx");
const $68f4cf6f464da6da$var$_taskCache = new WeakMap();
/**
 * A loader for Rhinoceros 3D files and objects.
 *
 * Rhinoceros is a 3D modeler used to create, edit, analyze, document, render,
 * animate, and translate NURBS curves, surfaces, breps, extrusions, point clouds,
 * as well as polygon meshes and SubD objects. `rhino3dm.js` is compiled to WebAssembly
 * from the open source geometry library `openNURBS`. The loader currently uses
 * `rhino3dm.js 8.4.0`.
 *
 * ```js
 * const loader = new Rhino3dmLoader();
 * loader.setLibraryPath( 'https://cdn.jsdelivr.net/npm/rhino3dm@8.0.1' );
 *
 * const object = await loader.loadAsync( 'models/3dm/Rhino_Logo.3dm' );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class $68f4cf6f464da6da$export$5f28558e2afe33ab extends (0, $ilwiq.Loader) {
    /**
   * Constructs a new Rhino 3DM loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */ constructor(manager){
        super(manager);
        // internals
        this.libraryPath = '';
        this.libraryPending = null;
        this.libraryBinary = null;
        this.libraryConfig = {};
        this.url = '';
        this.workerLimit = 4;
        this.workerPool = [];
        this.workerNextTaskID = 1;
        this.workerSourceURL = '';
        this.workerConfig = {};
        this.materials = [];
        this.warnings = [];
        this.jpgMap = {};
    }
    /**
   * Path to a folder containing the JS and WASM libraries.
   *
   * @param {string} path - The library path to set.
   * @return {Rhino3dmLoader} A reference to this loader.
   */ setLibraryPath(path) {
        this.libraryPath = path;
        return this;
    }
    /**
   * Sets the maximum number of Web Workers to be used during decoding.
   * A lower limit may be preferable if workers are also for other
   * tasks in the application.
   *
   * @param {number} workerLimit - The worker limit.
   * @return {Rhino3dmLoader} A reference to this loader.
   */ setWorkerLimit(workerLimit) {
        this.workerLimit = workerLimit;
        return this;
    }
    /**
   * Starts loading from the given URL and passes the loaded 3DM asset
   * to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */ load(url, onLoad, onProgress, onError, jpgMap = {}) {
        const loader = new (0, $jeyyu.FileLoader)(this.manager);
        this.jpgMap = jpgMap || {};
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        this.url = url;
        loader.load(url, (buffer)=>{
            // Check for an existing task using this buffer. A transferred buffer cannot be transferred
            // again from this thread.
            if ($68f4cf6f464da6da$var$_taskCache.has(buffer)) {
                const cachedTask = $68f4cf6f464da6da$var$_taskCache.get(buffer);
                return cachedTask.promise.then(onLoad).catch(onError);
            }
            this.decodeObjects(buffer, url).then((result)=>{
                result.userData.warnings = this.warnings;
                onLoad(result);
            }).catch((e)=>onError(e));
        }, onProgress, onError);
    }
    /**
   * Prints debug messages to the browser console.
   */ debug() {
        console.log('Task load: ', this.workerPool.map((worker)=>worker._taskLoad));
    }
    /**
   * Decodes the 3DM asset data with a Web Worker.
   *
   * @param {ArrayBuffer} buffer - The raw 3DM asset data as an array buffer.
   * @param {string} url - The asset URL.
   * @return {Promise<Object3D>} A Promise that resolved with the decoded 3D object.
   */ decodeObjects(buffer, url) {
        let worker;
        let taskID;
        const taskCost = buffer.byteLength;
        const objectPending = this._getWorker(taskCost).then((_worker)=>{
            worker = _worker;
            taskID = this.workerNextTaskID++;
            return new Promise((resolve, reject)=>{
                worker._callbacks[taskID] = {
                    resolve: resolve,
                    reject: reject
                };
                worker.postMessage({
                    type: 'decode',
                    id: taskID,
                    buffer: buffer
                }, [
                    buffer
                ]);
            // this.debug();
            });
        }).then((message)=>this._createGeometry(message.data)).catch((e)=>{
            throw e;
        });
        // Remove task from the task list.
        // Note: replaced '.finally()' with '.catch().then()' block - iOS 11 support (#19416)
        objectPending.catch(()=>true).then(()=>{
            if (worker && taskID) this._releaseTask(worker, taskID);
        });
        // Cache the task result.
        $68f4cf6f464da6da$var$_taskCache.set(buffer, {
            url: url,
            promise: objectPending
        });
        return objectPending;
    }
    /**
   * Parses the given 3DM data and passes the loaded 3DM asset
   * to the `onLoad()` callback.
   *
   * @param {ArrayBuffer} data - The raw 3DM asset data as an array buffer.
   * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */ parse(data, onLoad, onError) {
        this.decodeObjects(data, '').then((result)=>{
            result.userData.warnings = this.warnings;
            onLoad(result);
        }).catch((e)=>onError(e));
    }
    _compareMaterials(material) {
        const mat = {};
        mat.name = material.name;
        mat.color = {};
        mat.color.r = material.color.r;
        mat.color.g = material.color.g;
        mat.color.b = material.color.b;
        mat.type = material.type;
        mat.vertexColors = material.vertexColors;
        const json = JSON.stringify(mat);
        for(let i = 0; i < this.materials.length; i++){
            const m = this.materials[i];
            const _mat = {};
            _mat.name = m.name;
            _mat.color = {};
            _mat.color.r = m.color.r;
            _mat.color.g = m.color.g;
            _mat.color.b = m.color.b;
            _mat.type = m.type;
            _mat.vertexColors = m.vertexColors;
            if (JSON.stringify(_mat) === json) return m;
        }
        this.materials.push(material);
        return material;
    }
    _createMaterial(material, renderEnvironment) {
        if (material === undefined) return new (0, $ilwiq.MeshStandardMaterial)({
            color: new (0, $ilwiq.Color)(1, 1, 1),
            metalness: 0.8,
            name: (0, $ilwiq.Loader).DEFAULT_MATERIAL_NAME,
            side: (0, $ilwiq.DoubleSide)
        });
        //console.log(material)
        const mat = new (0, $ilwiq.MeshPhysicalMaterial)({
            color: new (0, $ilwiq.Color)(material.diffuseColor.r / 255.0, material.diffuseColor.g / 255.0, material.diffuseColor.b / 255.0),
            emissive: new (0, $ilwiq.Color)(material.emissionColor.r, material.emissionColor.g, material.emissionColor.b),
            flatShading: material.disableLighting,
            ior: material.indexOfRefraction,
            name: material.name,
            reflectivity: material.reflectivity,
            opacity: 1.0 - material.transparency,
            side: (0, $ilwiq.DoubleSide),
            specularColor: material.specularColor,
            transparent: material.transparency > 0 ? true : false
        });
        mat.userData.id = material.id;
        if (material.pbrSupported) {
            const pbr = material.pbr;
            mat.anisotropy = pbr.anisotropic;
            mat.anisotropyRotation = pbr.anisotropicRotation;
            mat.color = new (0, $ilwiq.Color)(pbr.baseColor.r, pbr.baseColor.g, pbr.baseColor.b);
            mat.clearcoat = pbr.clearcoat;
            mat.clearcoatRoughness = pbr.clearcoatRoughness;
            mat.metalness = pbr.metallic;
            mat.transmission = 1 - pbr.opacity;
            mat.roughness = pbr.roughness;
            mat.sheen = pbr.sheen;
            mat.specularIntensity = pbr.specular;
            mat.thickness = pbr.subsurface;
        }
        if (material.pbrSupported && material.pbr.opacity === 0 && material.transparency === 1) {
            //some compromises
            mat.opacity = 0.2;
            mat.transmission = 1.0;
        }
        const textureLoader = new (0, $ilwiq.TextureLoader)();
        for(let i = 0; i < material.textures.length; i++){
            const texture = material.textures[i];
            if (texture.image !== null) {
                const map = textureLoader.load(texture.image);
                //console.log(texture.type )
                switch(texture.type){
                    case 'Bump':
                        mat.bumpMap = map;
                        break;
                    case 'Diffuse':
                        mat.map = map;
                        break;
                    case 'Emap':
                        mat.envMap = map;
                        break;
                    case 'Opacity':
                        mat.transmissionMap = map;
                        break;
                    case 'Transparency':
                        mat.alphaMap = map;
                        mat.transparent = true;
                        break;
                    case 'PBR_Alpha':
                        mat.alphaMap = map;
                        mat.transparent = true;
                        break;
                    case 'PBR_AmbientOcclusion':
                        mat.aoMap = map;
                        break;
                    case 'PBR_Anisotropic':
                        mat.anisotropyMap = map;
                        break;
                    case 'PBR_BaseColor':
                        mat.map = map;
                        break;
                    case 'PBR_Clearcoat':
                        mat.clearcoatMap = map;
                        break;
                    case 'PBR_ClearcoatBump':
                        mat.clearcoatNormalMap = map;
                        break;
                    case 'PBR_ClearcoatRoughness':
                        mat.clearcoatRoughnessMap = map;
                        break;
                    case 'PBR_Displacement':
                        mat.displacementMap = map;
                        break;
                    case 'PBR_Emission':
                        mat.emissiveMap = map;
                        break;
                    case 'PBR_Metallic':
                        mat.metalnessMap = map;
                        break;
                    case 'PBR_Roughness':
                        mat.roughnessMap = map;
                        break;
                    case 'PBR_Sheen':
                        mat.sheenColorMap = map;
                        break;
                    case 'PBR_Specular':
                        mat.specularColorMap = map;
                        break;
                    case 'PBR_Subsurface':
                        mat.thicknessMap = map;
                        break;
                    default:
                        this.warnings.push({
                            message: `THREE.3DMLoader: No conversion exists for 3dm ${texture.type}.`,
                            type: 'no conversion'
                        });
                        break;
                }
                map.wrapS = texture.wrapU === 0 ? (0, $ilwiq.RepeatWrapping) : (0, $ilwiq.ClampToEdgeWrapping);
                map.wrapT = texture.wrapV === 0 ? (0, $ilwiq.RepeatWrapping) : (0, $ilwiq.ClampToEdgeWrapping);
                if (texture.repeat) map.repeat.set(texture.repeat[0], texture.repeat[1]);
            }
        }
        if (renderEnvironment) new (0, $4U9Bx.EXRLoader)().load(renderEnvironment.image, function(texture) {
            texture.mapping = THREE.EquirectangularReflectionMapping;
            mat.envMap = texture;
        });
        return mat;
    }
    _createGeometry(data) {
        const object = new (0, $ilwiq.Object3D)();
        const instanceDefinitionObjects = [];
        const instanceDefinitions = [];
        const instanceReferences = [];
        object.userData['layers'] = data.layers;
        object.userData['groups'] = data.groups;
        object.userData['settings'] = data.settings;
        object.userData.settings['renderSettings'] = data.renderSettings;
        object.userData['objectType'] = 'File3dm';
        object.userData['materials'] = null;
        object.name = this.url;
        let objects = data.objects;
        const materials = data.materials;
        for(let i = 0; i < objects.length; i++){
            const obj = objects[i];
            const attributes = obj.attributes;
            switch(obj.objectType){
                case 'InstanceDefinition':
                    instanceDefinitions.push(obj);
                    break;
                case 'InstanceReference':
                    instanceReferences.push(obj);
                    break;
                default:
                    let matId = null;
                    switch(attributes.materialSource.name){
                        case 'ObjectMaterialSource_MaterialFromLayer':
                            //check layer index
                            if (attributes.layerIndex >= 0) matId = data.layers[attributes.layerIndex].renderMaterialIndex;
                            break;
                        case 'ObjectMaterialSource_MaterialFromObject':
                            if (attributes.materialIndex >= 0) matId = attributes.materialIndex;
                            break;
                    }
                    let material = null;
                    if (matId >= 0) {
                        const rMaterial = materials[matId];
                        material = this._createMaterial(rMaterial, data.renderEnvironment);
                    }
                    const _object = this._createObject(obj, material);
                    if (_object === undefined) continue;
                    const layer = data.layers[attributes.layerIndex];
                    _object.visible = layer ? data.layers[attributes.layerIndex].visible : true;
                    if (attributes.isInstanceDefinitionObject) instanceDefinitionObjects.push(_object);
                    else object.add(_object);
                    break;
            }
        }
        for(let i = 0; i < instanceDefinitions.length; i++){
            const iDef = instanceDefinitions[i];
            objects = [];
            for(let j = 0; j < iDef.attributes.objectIds.length; j++){
                const objId = iDef.attributes.objectIds[j];
                for(let p = 0; p < instanceDefinitionObjects.length; p++){
                    const idoId = instanceDefinitionObjects[p].userData.attributes.id;
                    if (objId === idoId) objects.push(instanceDefinitionObjects[p]);
                }
            }
            // Currently clones geometry and does not take advantage of instancing
            for(let j = 0; j < instanceReferences.length; j++){
                const iRef = instanceReferences[j];
                if (iRef.geometry.parentIdefId === iDef.attributes.id) {
                    const iRefObject = new (0, $ilwiq.Object3D)();
                    const xf = iRef.geometry.xform.array;
                    const matrix = new (0, $ilwiq.Matrix4)();
                    matrix.set(...xf);
                    iRefObject.applyMatrix4(matrix);
                    for(let p = 0; p < objects.length; p++)iRefObject.add(objects[p].clone(true));
                    object.add(iRefObject);
                }
            }
        }
        object.userData['materials'] = this.materials;
        object.name = '';
        return object;
    }
    _createObject(obj, mat) {
        const loader = new (0, $ilwiq.BufferGeometryLoader)();
        const attributes = obj.attributes;
        let geometry, material, _color, color;
        switch(obj.objectType){
            case 'Point':
            case 'PointSet':
                geometry = loader.parse(obj.geometry);
                if (geometry.attributes.hasOwnProperty('color')) material = new (0, $ilwiq.PointsMaterial)({
                    vertexColors: true,
                    sizeAttenuation: false,
                    size: 2
                });
                else {
                    _color = attributes.drawColor;
                    color = new (0, $ilwiq.Color)(_color.r / 255.0, _color.g / 255.0, _color.b / 255.0);
                    material = new (0, $ilwiq.PointsMaterial)({
                        color: color,
                        sizeAttenuation: false,
                        size: 2
                    });
                }
                material = this._compareMaterials(material);
                const points = new (0, $ilwiq.Points)(geometry, material);
                points.userData['attributes'] = attributes;
                points.userData['objectType'] = obj.objectType;
                if (attributes.name) points.name = attributes.name;
                return points;
            case 'Mesh':
            case 'Extrusion':
            case 'SubD':
            case 'Brep':
                if (obj.geometry === null) return;
                geometry = loader.parse(obj.geometry);
                if (mat === null) mat = this._createMaterial();
                if (geometry.attributes.hasOwnProperty('color')) mat.vertexColors = true;
                mat = this._compareMaterials(mat);
                const mesh = new (0, $ilwiq.Mesh)(geometry, mat);
                mesh.castShadow = attributes.castsShadows;
                mesh.receiveShadow = attributes.receivesShadows;
                mesh.userData['attributes'] = attributes;
                mesh.userData['objectType'] = obj.objectType;
                if (attributes.name) mesh.name = attributes.name;
                return mesh;
            case 'Curve':
                geometry = loader.parse(obj.geometry);
                _color = attributes.drawColor;
                color = new (0, $ilwiq.Color)(_color.r / 255.0, _color.g / 255.0, _color.b / 255.0);
                material = new (0, $ilwiq.LineBasicMaterial)({
                    color: color
                });
                material = this._compareMaterials(material);
                const lines = new (0, $ilwiq.Line)(geometry, material);
                lines.userData['attributes'] = attributes;
                lines.userData['objectType'] = obj.objectType;
                if (attributes.name) lines.name = attributes.name;
                return lines;
            case 'TextDot':
                geometry = obj.geometry;
                const ctx = document.createElement('canvas').getContext('2d');
                const font = `${geometry.fontHeight}px ${geometry.fontFace}`;
                ctx.font = font;
                const width = ctx.measureText(geometry.text).width + 10;
                const height = geometry.fontHeight + 10;
                const r = window.devicePixelRatio;
                ctx.canvas.width = width * r;
                ctx.canvas.height = height * r;
                ctx.canvas.style.width = width + 'px';
                ctx.canvas.style.height = height + 'px';
                ctx.setTransform(r, 0, 0, r, 0, 0);
                ctx.font = font;
                ctx.textBaseline = 'middle';
                ctx.textAlign = 'center';
                color = attributes.drawColor;
                ctx.fillStyle = `rgba(${color.r},${color.g},${color.b},${color.a})`;
                ctx.fillRect(0, 0, width, height);
                ctx.fillStyle = 'white';
                ctx.fillText(geometry.text, width / 2, height / 2);
                const texture = new (0, $ilwiq.CanvasTexture)(ctx.canvas);
                texture.minFilter = (0, $ilwiq.LinearFilter);
                texture.generateMipmaps = false;
                texture.wrapS = (0, $ilwiq.ClampToEdgeWrapping);
                texture.wrapT = (0, $ilwiq.ClampToEdgeWrapping);
                material = new (0, $ilwiq.SpriteMaterial)({
                    map: texture,
                    depthTest: false
                });
                const sprite = new (0, $ilwiq.Sprite)(material);
                sprite.position.set(geometry.point[0], geometry.point[1], geometry.point[2]);
                sprite.scale.set(width / 10, height / 10, 1.0);
                sprite.userData['attributes'] = attributes;
                sprite.userData['objectType'] = obj.objectType;
                if (attributes.name) sprite.name = attributes.name;
                return sprite;
            case 'Light':
                geometry = obj.geometry;
                let light;
                switch(geometry.lightStyle.name){
                    case 'LightStyle_WorldPoint':
                        light = new (0, $ilwiq.PointLight)();
                        light.castShadow = attributes.castsShadows;
                        light.position.set(geometry.location[0], geometry.location[1], geometry.location[2]);
                        light.shadow.normalBias = 0.1;
                        break;
                    case 'LightStyle_WorldSpot':
                        light = new (0, $ilwiq.SpotLight)();
                        light.castShadow = attributes.castsShadows;
                        light.position.set(geometry.location[0], geometry.location[1], geometry.location[2]);
                        light.target.position.set(geometry.direction[0], geometry.direction[1], geometry.direction[2]);
                        light.angle = geometry.spotAngleRadians;
                        light.shadow.normalBias = 0.1;
                        break;
                    case 'LightStyle_WorldRectangular':
                        light = new (0, $ilwiq.RectAreaLight)();
                        const width1 = Math.abs(geometry.width[2]);
                        const height1 = Math.abs(geometry.length[0]);
                        light.position.set(geometry.location[0] - height1 / 2, geometry.location[1], geometry.location[2] - width1 / 2);
                        light.height = height1;
                        light.width = width1;
                        light.lookAt(geometry.direction[0], geometry.direction[1], geometry.direction[2]);
                        break;
                    case 'LightStyle_WorldDirectional':
                        light = new (0, $ilwiq.DirectionalLight)();
                        light.castShadow = attributes.castsShadows;
                        light.position.set(geometry.location[0], geometry.location[1], geometry.location[2]);
                        light.target.position.set(geometry.direction[0], geometry.direction[1], geometry.direction[2]);
                        light.shadow.normalBias = 0.1;
                        break;
                    case 'LightStyle_WorldLinear':
                        break;
                    default:
                        break;
                }
                if (light) {
                    light.intensity = geometry.intensity;
                    _color = geometry.diffuse;
                    color = new (0, $ilwiq.Color)(_color.r / 255.0, _color.g / 255.0, _color.b / 255.0);
                    light.color = color;
                    light.userData['attributes'] = attributes;
                    light.userData['objectType'] = obj.objectType;
                }
                return light;
        }
    }
    _initLibrary() {
        if (!this.libraryPending) {
            // Load rhino3dm wrapper.
            const jsLoader = new (0, $jeyyu.FileLoader)(this.manager);
            jsLoader.setPath(this.libraryPath);
            const jsContent = new Promise((resolve, reject)=>{
                jsLoader.load('rhino3dm.js', resolve, undefined, reject);
            });
            // Load rhino3dm WASM binary.
            const binaryLoader = new (0, $jeyyu.FileLoader)(this.manager);
            binaryLoader.setPath(this.libraryPath);
            binaryLoader.setResponseType('arraybuffer');
            const binaryContent = new Promise((resolve, reject)=>{
                binaryLoader.load('rhino3dm.wasm', resolve, undefined, reject);
            });
            this.libraryPending = Promise.all([
                jsContent,
                binaryContent
            ]).then(([jsContent, binaryContent])=>{
                //this.libraryBinary = binaryContent;
                this.libraryConfig.wasmBinary = binaryContent;
                const fn = $68f4cf6f464da6da$var$Rhino3dmWorker.toString();
                const body = [
                    '/* rhino3dm.js */',
                    jsContent,
                    '/* worker */',
                    fn.substring(fn.indexOf('{') + 1, fn.lastIndexOf('}'))
                ].join('\n');
                this.workerSourceURL = URL.createObjectURL(new Blob([
                    body
                ]));
            });
        }
        return this.libraryPending;
    }
    _getWorker(taskCost) {
        return this._initLibrary().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const worker = new Worker(this.workerSourceURL);
                worker._callbacks = {};
                worker._taskCosts = {};
                worker._taskLoad = 0;
                worker.postMessage({
                    type: 'init',
                    libraryConfig: this.libraryConfig,
                    jpgMap: this.jpgMap
                });
                worker.onmessage = (e)=>{
                    const message = e.data;
                    switch(message.type){
                        case 'warning':
                            this.warnings.push(message.data);
                            console.warn(message.data);
                            break;
                        case 'decode':
                            worker._callbacks[message.id].resolve(message);
                            break;
                        case 'error':
                            worker._callbacks[message.id].reject(message);
                            break;
                        default:
                            console.error('THREE.Rhino3dmLoader: Unexpected message, "' + message.type + '"');
                    }
                };
                this.workerPool.push(worker);
            } else this.workerPool.sort(function(a, b) {
                return a._taskLoad > b._taskLoad ? -1 : 1;
            });
            const worker = this.workerPool[this.workerPool.length - 1];
            worker._taskLoad += taskCost;
            return worker;
        });
    }
    _releaseTask(worker, taskID) {
        worker._taskLoad -= worker._taskCosts[taskID];
        delete worker._callbacks[taskID];
        delete worker._taskCosts[taskID];
    }
    /**
   * Frees internal resources. This method should be called
   * when the loader is no longer required.
   */ dispose() {
        for(let i = 0; i < this.workerPool.length; ++i)this.workerPool[i].terminate();
        this.workerPool.length = 0;
    }
}
/* WEB WORKER */ function $68f4cf6f464da6da$var$Rhino3dmWorker() {
    let libraryPending;
    let libraryConfig;
    let rhino;
    let taskID;
    let jpgMap = {};
    onmessage = function(e) {
        const message = e.data;
        switch(message.type){
            case 'init':
                libraryConfig = message.libraryConfig;
                jpgMap = message.jpgMap;
                const wasmBinary = libraryConfig.wasmBinary;
                let RhinoModule;
                libraryPending = new Promise(function(resolve) {
                    /* Like Basis Loader */ RhinoModule = {
                        wasmBinary: wasmBinary,
                        onRuntimeInitialized: resolve
                    };
                    rhino3dm(RhinoModule) // eslint-disable-line no-undef
                    ;
                }).then(()=>{
                    rhino = RhinoModule;
                });
                break;
            case 'decode':
                taskID = message.id;
                const buffer = message.buffer;
                libraryPending.then(()=>{
                    try {
                        const data = decodeObjects(rhino, buffer);
                        self.postMessage({
                            type: 'decode',
                            id: message.id,
                            data: data
                        });
                    } catch (error) {
                        self.postMessage({
                            type: 'error',
                            id: message.id,
                            error: error
                        });
                    }
                });
                break;
        }
    };
    function decodeObjects(rhino, buffer) {
        const arr = new Uint8Array(buffer);
        const doc = rhino.File3dm.fromByteArray(arr);
        const objects = [];
        const materials = [];
        const layers = [];
        const views = [];
        const namedViews = [];
        const groups = [];
        const strings = [];
        //Handle objects
        const objs = doc.objects();
        const cnt = objs.count;
        for(let i = 0; i < cnt; i++){
            const _object = objs.get(i);
            const object = extractObjectData(_object, doc);
            _object.delete();
            if (object) objects.push(object);
        }
        // Handle instance definitions
        // console.log( `Instance Definitions Count: ${doc.instanceDefinitions().count()}` );
        for(let i = 0; i < doc.instanceDefinitions().count; i++){
            const idef = doc.instanceDefinitions().get(i);
            const idefAttributes = extractProperties(idef);
            idefAttributes.objectIds = idef.getObjectIds();
            objects.push({
                geometry: null,
                attributes: idefAttributes,
                objectType: 'InstanceDefinition'
            });
        }
        // Handle materials
        const textureTypes = [
            // rhino.TextureType.Bitmap,
            rhino.TextureType.Diffuse,
            rhino.TextureType.Bump,
            rhino.TextureType.Transparency,
            rhino.TextureType.Opacity,
            rhino.TextureType.Emap
        ];
        const pbrTextureTypes = [
            rhino.TextureType.PBR_BaseColor,
            rhino.TextureType.PBR_Subsurface,
            rhino.TextureType.PBR_SubsurfaceScattering,
            rhino.TextureType.PBR_SubsurfaceScatteringRadius,
            rhino.TextureType.PBR_Metallic,
            rhino.TextureType.PBR_Specular,
            rhino.TextureType.PBR_SpecularTint,
            rhino.TextureType.PBR_Roughness,
            rhino.TextureType.PBR_Anisotropic,
            rhino.TextureType.PBR_Anisotropic_Rotation,
            rhino.TextureType.PBR_Sheen,
            rhino.TextureType.PBR_SheenTint,
            rhino.TextureType.PBR_Clearcoat,
            rhino.TextureType.PBR_ClearcoatBump,
            rhino.TextureType.PBR_ClearcoatRoughness,
            rhino.TextureType.PBR_OpacityIor,
            rhino.TextureType.PBR_OpacityRoughness,
            rhino.TextureType.PBR_Emission,
            rhino.TextureType.PBR_AmbientOcclusion,
            rhino.TextureType.PBR_Displacement
        ];
        for(let i = 0; i < doc.materials().count; i++){
            const _material = doc.materials().get(i);
            const material = extractProperties(_material);
            const textures = [];
            textures.push(...extractTextures(_material, textureTypes, doc));
            material.pbrSupported = _material.physicallyBased().supported;
            if (material.pbrSupported) {
                textures.push(...extractTextures(_material, pbrTextureTypes, doc));
                material.pbr = extractProperties(_material.physicallyBased());
            }
            material.textures = textures;
            materials.push(material);
            _material.delete();
        }
        // Handle layers
        for(let i = 0; i < doc.layers().count; i++){
            const _layer = doc.layers().get(i);
            const layer = extractProperties(_layer);
            layers.push(layer);
            _layer.delete();
        }
        // Handle views
        for(let i = 0; i < doc.views().count; i++){
            const _view = doc.views().get(i);
            const view = extractProperties(_view);
            views.push(view);
            _view.delete();
        }
        // Handle named views
        for(let i = 0; i < doc.namedViews().count; i++){
            const _namedView = doc.namedViews().get(i);
            const namedView = extractProperties(_namedView);
            namedViews.push(namedView);
            _namedView.delete();
        }
        // Handle groups
        for(let i = 0; i < doc.groups().count; i++){
            const _group = doc.groups().get(i);
            const group = extractProperties(_group);
            groups.push(group);
            _group.delete();
        }
        // Handle settings
        const settings = extractProperties(doc.settings());
        //TODO: Handle other document stuff like dimstyles, instance definitions, bitmaps etc.
        // Handle dimstyles
        // console.log( `Dimstyle Count: ${doc.dimstyles().count()}` );
        // Handle bitmaps
        // console.log( `Bitmap Count: ${doc.bitmaps().count()}` );
        // Handle strings
        // console.log( `Document Strings Count: ${doc.strings().count()}` );
        // Note: doc.strings().documentUserTextCount() counts any doc.strings defined in a section
        // console.log( `Document User Text Count: ${doc.strings().documentUserTextCount()}` );
        const strings_count = doc.strings().count;
        for(let i = 0; i < strings_count; i++)strings.push(doc.strings().get(i));
        // Handle Render Environments for Material Environment
        // get the id of the active render environment skylight, which we'll use for environment texture
        const reflectionId = doc.settings().renderSettings().renderEnvironments.reflectionId;
        const rc = doc.renderContent();
        let renderEnvironment = null;
        for(let i = 0; i < rc.count; i++){
            const content = rc.get(i);
            switch(content.kind){
                case 'environment':
                    const id = content.id;
                    // there could be multiple render environments in a 3dm file
                    if (id !== reflectionId) break;
                    const renderTexture = content.findChild('texture');
                    const fileName = renderTexture.fileName;
                    for(let j = 0; j < doc.embeddedFiles().count; j++){
                        const _fileName = doc.embeddedFiles().get(j).fileName;
                        if (fileName === _fileName) {
                            const background = doc.getEmbeddedFileAsBase64(fileName);
                            const backgroundJpg = jpgMap[fileName] || jpgMap[Object.keys(jpgMap).find((key)=>!!fileName?.endsWith(key) || !!key?.endsWith(fileName))];
                            const backgroundImage = background ? 'data:image/png;base64,' + background : backgroundJpg;
                            renderEnvironment = {
                                type: 'renderEnvironment',
                                image: backgroundImage,
                                name: fileName
                            };
                        }
                    }
                    break;
            }
        }
        // Handle Render Settings
        const renderSettings = {
            ambientLight: doc.settings().renderSettings().ambientLight,
            backgroundColorTop: doc.settings().renderSettings().backgroundColorTop,
            backgroundColorBottom: doc.settings().renderSettings().backgroundColorBottom,
            useHiddenLights: doc.settings().renderSettings().useHiddenLights,
            depthCue: doc.settings().renderSettings().depthCue,
            flatShade: doc.settings().renderSettings().flatShade,
            renderBackFaces: doc.settings().renderSettings().renderBackFaces,
            renderPoints: doc.settings().renderSettings().renderPoints,
            renderCurves: doc.settings().renderSettings().renderCurves,
            renderIsoParams: doc.settings().renderSettings().renderIsoParams,
            renderMeshEdges: doc.settings().renderSettings().renderMeshEdges,
            renderAnnotations: doc.settings().renderSettings().renderAnnotations,
            useViewportSize: doc.settings().renderSettings().useViewportSize,
            scaleBackgroundToFit: doc.settings().renderSettings().scaleBackgroundToFit,
            transparentBackground: doc.settings().renderSettings().transparentBackground,
            imageDpi: doc.settings().renderSettings().imageDpi,
            shadowMapLevel: doc.settings().renderSettings().shadowMapLevel,
            namedView: doc.settings().renderSettings().namedView,
            snapShot: doc.settings().renderSettings().snapShot,
            specificViewport: doc.settings().renderSettings().specificViewport,
            groundPlane: extractProperties(doc.settings().renderSettings().groundPlane),
            safeFrame: extractProperties(doc.settings().renderSettings().safeFrame),
            dithering: extractProperties(doc.settings().renderSettings().dithering),
            skylight: extractProperties(doc.settings().renderSettings().skylight),
            linearWorkflow: extractProperties(doc.settings().renderSettings().linearWorkflow),
            renderChannels: extractProperties(doc.settings().renderSettings().renderChannels),
            sun: extractProperties(doc.settings().renderSettings().sun),
            renderEnvironments: extractProperties(doc.settings().renderSettings().renderEnvironments),
            postEffects: extractProperties(doc.settings().renderSettings().postEffects)
        };
        doc.delete();
        return {
            objects: objects,
            materials: materials,
            layers: layers,
            views: views,
            namedViews: namedViews,
            groups: groups,
            strings: strings,
            settings: settings,
            renderSettings: renderSettings,
            renderEnvironment: renderEnvironment
        };
    }
    function extractTextures(m, tTypes, d) {
        const textures = [];
        for(let i = 0; i < tTypes.length; i++){
            const _texture = m.getTexture(tTypes[i]);
            if (_texture) {
                let textureType = tTypes[i].constructor.name;
                textureType = textureType.substring(12, textureType.length);
                const texture = extractTextureData(_texture, textureType, d);
                textures.push(texture);
                _texture.delete();
            }
        }
        return textures;
    }
    function extractTextureData(t, tType, d) {
        const texture = {
            type: tType
        };
        const image = d.getEmbeddedFileAsBase64(t.fileName);
        const jpg = jpgMap[t.fileName] || jpgMap[Object.keys(jpgMap).find((key)=>!!t.fileName?.endsWith(key) || !!key?.endsWith(t.fileName))];
        texture.wrapU = t.wrapU;
        texture.wrapV = t.wrapV;
        texture.wrapW = t.wrapW;
        const uvw = t.uvwTransform.toFloatArray(true);
        texture.repeat = [
            uvw[0],
            uvw[5]
        ];
        if (image) texture.image = 'data:image/png;base64,' + image;
        else if (jpg) texture.image = jpg;
        else {
            self.postMessage({
                type: 'warning',
                id: taskID,
                data: {
                    message: `THREE.3DMLoader: Image for ${tType} texture not embedded in file.`,
                    type: 'missing resource'
                }
            });
            texture.image = null;
        }
        return texture;
    }
    function extractObjectData(object, doc) {
        const _geometry = object.geometry();
        const _attributes = object.attributes();
        let objectType = _geometry.objectType;
        let geometry, attributes, position, data, mesh;
        // skip instance definition objects
        //if( _attributes.isInstanceDefinitionObject ) { continue; }
        // TODO: handle other geometry types
        switch(objectType){
            case rhino.ObjectType.Curve:
                const pts = curveToPoints(_geometry, 100);
                position = {};
                attributes = {};
                data = {};
                position.itemSize = 3;
                position.type = 'Float32Array';
                position.array = [];
                for(let j = 0; j < pts.length; j++){
                    position.array.push(pts[j][0]);
                    position.array.push(pts[j][1]);
                    position.array.push(pts[j][2]);
                }
                attributes.position = position;
                data.attributes = attributes;
                geometry = {
                    data: data
                };
                break;
            case rhino.ObjectType.Point:
                const pt = _geometry.location;
                position = {};
                const color = {};
                attributes = {};
                data = {};
                position.itemSize = 3;
                position.type = 'Float32Array';
                position.array = [
                    pt[0],
                    pt[1],
                    pt[2]
                ];
                const _color = _attributes.drawColor(doc);
                color.itemSize = 3;
                color.type = 'Float32Array';
                color.array = [
                    _color.r / 255.0,
                    _color.g / 255.0,
                    _color.b / 255.0
                ];
                attributes.position = position;
                attributes.color = color;
                data.attributes = attributes;
                geometry = {
                    data: data
                };
                break;
            case rhino.ObjectType.PointSet:
            case rhino.ObjectType.Mesh:
                geometry = _geometry.toThreejsJSON();
                break;
            case rhino.ObjectType.Brep:
                const faces = _geometry.faces();
                mesh = new rhino.Mesh();
                for(let faceIndex = 0; faceIndex < faces.count; faceIndex++){
                    const face = faces.get(faceIndex);
                    const _mesh = face.getMesh(rhino.MeshType.Any);
                    if (_mesh) {
                        mesh.append(_mesh);
                        _mesh.delete();
                    }
                    face.delete();
                }
                if (mesh.faces().count > 0) {
                    mesh.compact();
                    geometry = mesh.toThreejsJSON();
                    faces.delete();
                }
                mesh.delete();
                break;
            case rhino.ObjectType.Extrusion:
                mesh = _geometry.getMesh(rhino.MeshType.Any);
                if (mesh) {
                    geometry = mesh.toThreejsJSON();
                    mesh.delete();
                }
                break;
            case rhino.ObjectType.TextDot:
                geometry = extractProperties(_geometry);
                break;
            case rhino.ObjectType.Light:
                geometry = extractProperties(_geometry);
                if (geometry.lightStyle.name === 'LightStyle_WorldLinear') self.postMessage({
                    type: 'warning',
                    id: taskID,
                    data: {
                        message: `THREE.3DMLoader: No conversion exists for ${objectType.constructor.name} ${geometry.lightStyle.name}`,
                        type: 'no conversion',
                        guid: _attributes.id
                    }
                });
                break;
            case rhino.ObjectType.InstanceReference:
                geometry = extractProperties(_geometry);
                geometry.xform = extractProperties(_geometry.xform);
                geometry.xform.array = _geometry.xform.toFloatArray(true);
                break;
            case rhino.ObjectType.SubD:
                // TODO: precalculate resulting vertices and faces and warn on excessive results
                _geometry.subdivide(3);
                mesh = rhino.Mesh.createFromSubDControlNet(_geometry, false);
                if (mesh) {
                    geometry = mesh.toThreejsJSON();
                    mesh.delete();
                }
                break;
            /*
				case rhino.ObjectType.Annotation:
				case rhino.ObjectType.Hatch:
				case rhino.ObjectType.ClipPlane:
				*/ default:
                self.postMessage({
                    type: 'warning',
                    id: taskID,
                    data: {
                        message: `THREE.3DMLoader: Conversion not implemented for ${objectType.constructor.name}`,
                        type: 'not implemented',
                        guid: _attributes.id
                    }
                });
                break;
        }
        if (geometry) {
            attributes = extractProperties(_attributes);
            attributes.geometry = extractProperties(_geometry);
            if (_attributes.groupCount > 0) attributes.groupIds = _attributes.getGroupList();
            if (_attributes.userStringCount > 0) attributes.userStrings = _attributes.getUserStrings();
            if (_geometry.userStringCount > 0) attributes.geometry.userStrings = _geometry.getUserStrings();
            if (_attributes.decals().count > 0) self.postMessage({
                type: 'warning',
                id: taskID,
                data: {
                    message: 'THREE.3DMLoader: No conversion exists for the decals associated with this object.',
                    type: 'no conversion',
                    guid: _attributes.id
                }
            });
            attributes.drawColor = _attributes.drawColor(doc);
            objectType = objectType.constructor.name;
            objectType = objectType.substring(11, objectType.length);
            return {
                geometry: geometry,
                attributes: attributes,
                objectType: objectType
            };
        } else self.postMessage({
            type: 'warning',
            id: taskID,
            data: {
                message: `THREE.3DMLoader: ${objectType.constructor.name} has no associated mesh geometry.`,
                type: 'missing mesh',
                guid: _attributes.id
            }
        });
    }
    function extractProperties(object) {
        const result = {};
        for(const property in object){
            const value = object[property];
            if (typeof value !== 'function') {
                if (typeof value === 'object' && value !== null && value.hasOwnProperty('constructor')) result[property] = {
                    name: value.constructor.name,
                    value: value.value
                };
                else if (typeof value === 'object' && value !== null) result[property] = extractProperties(value);
                else result[property] = value;
            }
        }
        return result;
    }
    function curveToPoints(curve, pointLimit) {
        let pointCount = pointLimit;
        let rc = [];
        const ts = [];
        if (curve instanceof rhino.LineCurve) return [
            curve.pointAtStart,
            curve.pointAtEnd
        ];
        if (curve instanceof rhino.PolylineCurve) {
            pointCount = curve.pointCount;
            for(let i = 0; i < pointCount; i++)rc.push(curve.point(i));
            return rc;
        }
        if (curve instanceof rhino.PolyCurve) {
            const segmentCount = curve.segmentCount;
            for(let i = 0; i < segmentCount; i++){
                const segment = curve.segmentCurve(i);
                const segmentArray = curveToPoints(segment, pointCount);
                rc = rc.concat(segmentArray);
                segment.delete();
            }
            return rc;
        }
        if (curve instanceof rhino.ArcCurve) {
            pointCount = Math.floor(curve.angleDegrees / 5);
            pointCount = pointCount < 2 ? 2 : pointCount;
        // alternative to this hardcoded version: https://stackoverflow.com/a/18499923/2179399
        }
        if (curve instanceof rhino.NurbsCurve && curve.degree === 1) {
            const pLine = curve.tryGetPolyline();
            for(let i = 0; i < pLine.count; i++)rc.push(pLine.get(i));
            pLine.delete();
            return rc;
        }
        const domain = curve.domain;
        const divisions = pointCount - 1.0;
        for(let j = 0; j < pointCount; j++){
            const t = domain[0] + j / divisions * (domain[1] - domain[0]);
            if (t === domain[0] || t === domain[1]) {
                ts.push(t);
                continue;
            }
            const tan = curve.tangentAt(t);
            const prevTan = curve.tangentAt(ts.slice(-1)[0]);
            // Duplicated from THREE.Vector3
            // How to pass imports to worker?
            const tS = tan[0] * tan[0] + tan[1] * tan[1] + tan[2] * tan[2];
            const ptS = prevTan[0] * prevTan[0] + prevTan[1] * prevTan[1] + prevTan[2] * prevTan[2];
            const denominator = Math.sqrt(tS * ptS);
            let angle;
            if (denominator === 0) angle = Math.PI / 2;
            else {
                const theta = (tan.x * prevTan.x + tan.y * prevTan.y + tan.z * prevTan.z) / denominator;
                angle = Math.acos(Math.max(-1, Math.min(1, theta)));
            }
            if (angle < 0.1) continue;
            ts.push(t);
        }
        rc = ts.map((t)=>curve.pointAt(t));
        return rc;
    }
}

});
parcelRegister("4U9Bx", function(module, exports) {

$parcel$export(module.exports, "EXRLoader", () => $3923d7a15cdf4f4f$export$ccf20607163eaf96);

var $ilwiq = parcelRequire("ilwiq");

var $79Zxq = parcelRequire("79Zxq");
/**
 * OpenEXR loader currently supports uncompressed, ZIP(S), RLE, PIZ and DWA/B compression.
 * Supports reading as UnsignedByte, HalfFloat and Float type data texture.
 *
 * Referred to the original Industrial Light & Magic OpenEXR implementation and the TinyEXR / Syoyo Fujita
 * implementation, so I have preserved their copyright notices.
 */ // /*
// Copyright (c) 2014 - 2017, Syoyo Fujita
// All rights reserved.
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//     * Redistributions of source code must retain the above copyright
//       notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//     * Neither the name of the Syoyo Fujita nor the
//       names of its contributors may be used to endorse or promote products
//       derived from this software without specific prior written permission.
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
// ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
// WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
// DISCLAIMED. IN NO EVENT SHALL <COPYRIGHT HOLDER> BE LIABLE FOR ANY
// DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
// (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
// LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
// ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
// SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
// */
// // TinyEXR contains some OpenEXR code, which is licensed under ------------
// ///////////////////////////////////////////////////////////////////////////
// //
// // Copyright (c) 2002, Industrial Light & Magic, a division of Lucas
// // Digital Ltd. LLC
// //
// // All rights reserved.
// //
// // Redistribution and use in source and binary forms, with or without
// // modification, are permitted provided that the following conditions are
// // met:
// // *       Redistributions of source code must retain the above copyright
// // notice, this list of conditions and the following disclaimer.
// // *       Redistributions in binary form must reproduce the above
// // copyright notice, this list of conditions and the following disclaimer
// // in the documentation and/or other materials provided with the
// // distribution.
// // *       Neither the name of Industrial Light & Magic nor the names of
// // its contributors may be used to endorse or promote products derived
// // from this software without specific prior written permission.
// //
// // THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// // "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// // LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// // A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// // OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// // SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// // LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// // DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// // THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// // (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// // OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
// //
// ///////////////////////////////////////////////////////////////////////////
// // End of OpenEXR license -------------------------------------------------
class $3923d7a15cdf4f4f$export$ccf20607163eaf96 extends (0, $ilwiq.DataTextureLoader) {
    constructor(manager){
        super(manager);
        this.type = (0, $ilwiq.HalfFloatType);
    }
    parse(buffer) {
        const USHORT_RANGE = 65536;
        const BITMAP_SIZE = USHORT_RANGE >> 3;
        const HUF_ENCBITS = 16; // literal (value) bit length
        const HUF_DECBITS = 14; // decoding bit size (>= 8)
        const HUF_ENCSIZE = (1 << HUF_ENCBITS) + 1; // encoding table size
        const HUF_DECSIZE = 1 << HUF_DECBITS; // decoding table size
        const HUF_DECMASK = HUF_DECSIZE - 1;
        const NBITS = 16;
        const A_OFFSET = 1 << NBITS - 1;
        const MOD_MASK = (1 << NBITS) - 1;
        const SHORT_ZEROCODE_RUN = 59;
        const LONG_ZEROCODE_RUN = 63;
        const SHORTEST_LONG_RUN = 2 + LONG_ZEROCODE_RUN - SHORT_ZEROCODE_RUN;
        const ULONG_SIZE = 8;
        const FLOAT32_SIZE = 4;
        const INT32_SIZE = 4;
        const INT16_SIZE = 2;
        const INT8_SIZE = 1;
        const STATIC_HUFFMAN = 0;
        const DEFLATE = 1;
        const UNKNOWN = 0;
        const LOSSY_DCT = 1;
        const RLE = 2;
        const logBase = Math.pow(2.7182818, 2.2);
        function reverseLutFromBitmap(bitmap, lut) {
            let k = 0;
            for(let i = 0; i < USHORT_RANGE; ++i)if (i == 0 || bitmap[i >> 3] & 1 << (i & 7)) lut[k++] = i;
            const n = k - 1;
            while(k < USHORT_RANGE)lut[k++] = 0;
            return n;
        }
        function hufClearDecTable(hdec) {
            for(let i = 0; i < HUF_DECSIZE; i++){
                hdec[i] = {};
                hdec[i].len = 0;
                hdec[i].lit = 0;
                hdec[i].p = null;
            }
        }
        const getBitsReturn = {
            l: 0,
            c: 0,
            lc: 0
        };
        function getBits(nBits, c, lc, uInt8Array, inOffset) {
            while(lc < nBits){
                c = c << 8 | parseUint8Array(uInt8Array, inOffset);
                lc += 8;
            }
            lc -= nBits;
            getBitsReturn.l = c >> lc & (1 << nBits) - 1;
            getBitsReturn.c = c;
            getBitsReturn.lc = lc;
        }
        const hufTableBuffer = new Array(59);
        function hufCanonicalCodeTable(hcode) {
            for(let i = 0; i <= 58; ++i)hufTableBuffer[i] = 0;
            for(let i = 0; i < HUF_ENCSIZE; ++i)hufTableBuffer[hcode[i]] += 1;
            let c = 0;
            for(let i = 58; i > 0; --i){
                const nc = c + hufTableBuffer[i] >> 1;
                hufTableBuffer[i] = c;
                c = nc;
            }
            for(let i = 0; i < HUF_ENCSIZE; ++i){
                const l = hcode[i];
                if (l > 0) hcode[i] = l | hufTableBuffer[l]++ << 6;
            }
        }
        function hufUnpackEncTable(uInt8Array, inOffset, ni, im, iM, hcode) {
            const p = inOffset;
            let c = 0;
            let lc = 0;
            for(; im <= iM; im++){
                if (p.value - inOffset.value > ni) return false;
                getBits(6, c, lc, uInt8Array, p);
                const l = getBitsReturn.l;
                c = getBitsReturn.c;
                lc = getBitsReturn.lc;
                hcode[im] = l;
                if (l == LONG_ZEROCODE_RUN) {
                    if (p.value - inOffset.value > ni) throw new Error('Something wrong with hufUnpackEncTable');
                    getBits(8, c, lc, uInt8Array, p);
                    let zerun = getBitsReturn.l + SHORTEST_LONG_RUN;
                    c = getBitsReturn.c;
                    lc = getBitsReturn.lc;
                    if (im + zerun > iM + 1) throw new Error('Something wrong with hufUnpackEncTable');
                    while(zerun--)hcode[im++] = 0;
                    im--;
                } else if (l >= SHORT_ZEROCODE_RUN) {
                    let zerun = l - SHORT_ZEROCODE_RUN + 2;
                    if (im + zerun > iM + 1) throw new Error('Something wrong with hufUnpackEncTable');
                    while(zerun--)hcode[im++] = 0;
                    im--;
                }
            }
            hufCanonicalCodeTable(hcode);
        }
        function hufLength(code) {
            return code & 63;
        }
        function hufCode(code) {
            return code >> 6;
        }
        function hufBuildDecTable(hcode, im, iM, hdecod) {
            for(; im <= iM; im++){
                const c = hufCode(hcode[im]);
                const l = hufLength(hcode[im]);
                if (c >> l) throw new Error('Invalid table entry');
                if (l > HUF_DECBITS) {
                    const pl = hdecod[c >> l - HUF_DECBITS];
                    if (pl.len) throw new Error('Invalid table entry');
                    pl.lit++;
                    if (pl.p) {
                        const p = pl.p;
                        pl.p = new Array(pl.lit);
                        for(let i = 0; i < pl.lit - 1; ++i)pl.p[i] = p[i];
                    } else pl.p = new Array(1);
                    pl.p[pl.lit - 1] = im;
                } else if (l) {
                    let plOffset = 0;
                    for(let i = 1 << HUF_DECBITS - l; i > 0; i--){
                        const pl = hdecod[(c << HUF_DECBITS - l) + plOffset];
                        if (pl.len || pl.p) throw new Error('Invalid table entry');
                        pl.len = l;
                        pl.lit = im;
                        plOffset++;
                    }
                }
            }
            return true;
        }
        const getCharReturn = {
            c: 0,
            lc: 0
        };
        function getChar(c, lc, uInt8Array, inOffset) {
            c = c << 8 | parseUint8Array(uInt8Array, inOffset);
            lc += 8;
            getCharReturn.c = c;
            getCharReturn.lc = lc;
        }
        const getCodeReturn = {
            c: 0,
            lc: 0
        };
        function getCode(po, rlc, c, lc, uInt8Array, inOffset, outBuffer, outBufferOffset, outBufferEndOffset) {
            if (po == rlc) {
                if (lc < 8) {
                    getChar(c, lc, uInt8Array, inOffset);
                    c = getCharReturn.c;
                    lc = getCharReturn.lc;
                }
                lc -= 8;
                let cs = c >> lc;
                cs = new Uint8Array([
                    cs
                ])[0];
                if (outBufferOffset.value + cs > outBufferEndOffset) return false;
                const s = outBuffer[outBufferOffset.value - 1];
                while(cs-- > 0)outBuffer[outBufferOffset.value++] = s;
            } else if (outBufferOffset.value < outBufferEndOffset) outBuffer[outBufferOffset.value++] = po;
            else return false;
            getCodeReturn.c = c;
            getCodeReturn.lc = lc;
        }
        function UInt16(value) {
            return value & 0xFFFF;
        }
        function Int16(value) {
            const ref = UInt16(value);
            return ref > 0x7FFF ? ref - 0x10000 : ref;
        }
        const wdec14Return = {
            a: 0,
            b: 0
        };
        function wdec14(l, h) {
            const ls = Int16(l);
            const hs = Int16(h);
            const hi = hs;
            const ai = ls + (hi & 1) + (hi >> 1);
            const as = ai;
            const bs = ai - hi;
            wdec14Return.a = as;
            wdec14Return.b = bs;
        }
        function wdec16(l, h) {
            const m = UInt16(l);
            const d = UInt16(h);
            const bb = m - (d >> 1) & MOD_MASK;
            const aa = d + bb - A_OFFSET & MOD_MASK;
            wdec14Return.a = aa;
            wdec14Return.b = bb;
        }
        function wav2Decode(buffer, j, nx, ox, ny, oy, mx) {
            const w14 = mx < 16384;
            const n = nx > ny ? ny : nx;
            let p = 1;
            let p2;
            let py;
            while(p <= n)p <<= 1;
            p >>= 1;
            p2 = p;
            p >>= 1;
            while(p >= 1){
                py = 0;
                const ey = py + oy * (ny - p2);
                const oy1 = oy * p;
                const oy2 = oy * p2;
                const ox1 = ox * p;
                const ox2 = ox * p2;
                let i00, i01, i10, i11;
                for(; py <= ey; py += oy2){
                    let px = py;
                    const ex = py + ox * (nx - p2);
                    for(; px <= ex; px += ox2){
                        const p01 = px + ox1;
                        const p10 = px + oy1;
                        const p11 = p10 + ox1;
                        if (w14) {
                            wdec14(buffer[px + j], buffer[p10 + j]);
                            i00 = wdec14Return.a;
                            i10 = wdec14Return.b;
                            wdec14(buffer[p01 + j], buffer[p11 + j]);
                            i01 = wdec14Return.a;
                            i11 = wdec14Return.b;
                            wdec14(i00, i01);
                            buffer[px + j] = wdec14Return.a;
                            buffer[p01 + j] = wdec14Return.b;
                            wdec14(i10, i11);
                            buffer[p10 + j] = wdec14Return.a;
                            buffer[p11 + j] = wdec14Return.b;
                        } else {
                            wdec16(buffer[px + j], buffer[p10 + j]);
                            i00 = wdec14Return.a;
                            i10 = wdec14Return.b;
                            wdec16(buffer[p01 + j], buffer[p11 + j]);
                            i01 = wdec14Return.a;
                            i11 = wdec14Return.b;
                            wdec16(i00, i01);
                            buffer[px + j] = wdec14Return.a;
                            buffer[p01 + j] = wdec14Return.b;
                            wdec16(i10, i11);
                            buffer[p10 + j] = wdec14Return.a;
                            buffer[p11 + j] = wdec14Return.b;
                        }
                    }
                    if (nx & p) {
                        const p10 = px + oy1;
                        if (w14) wdec14(buffer[px + j], buffer[p10 + j]);
                        else wdec16(buffer[px + j], buffer[p10 + j]);
                        i00 = wdec14Return.a;
                        buffer[p10 + j] = wdec14Return.b;
                        buffer[px + j] = i00;
                    }
                }
                if (ny & p) {
                    let px = py;
                    const ex = py + ox * (nx - p2);
                    for(; px <= ex; px += ox2){
                        const p01 = px + ox1;
                        if (w14) wdec14(buffer[px + j], buffer[p01 + j]);
                        else wdec16(buffer[px + j], buffer[p01 + j]);
                        i00 = wdec14Return.a;
                        buffer[p01 + j] = wdec14Return.b;
                        buffer[px + j] = i00;
                    }
                }
                p2 = p;
                p >>= 1;
            }
            return py;
        }
        function hufDecode(encodingTable, decodingTable, uInt8Array, inOffset, ni, rlc, no, outBuffer, outOffset) {
            let c = 0;
            let lc = 0;
            const outBufferEndOffset = no;
            const inOffsetEnd = Math.trunc(inOffset.value + (ni + 7) / 8);
            while(inOffset.value < inOffsetEnd){
                getChar(c, lc, uInt8Array, inOffset);
                c = getCharReturn.c;
                lc = getCharReturn.lc;
                while(lc >= HUF_DECBITS){
                    const index = c >> lc - HUF_DECBITS & HUF_DECMASK;
                    const pl = decodingTable[index];
                    if (pl.len) {
                        lc -= pl.len;
                        getCode(pl.lit, rlc, c, lc, uInt8Array, inOffset, outBuffer, outOffset, outBufferEndOffset);
                        c = getCodeReturn.c;
                        lc = getCodeReturn.lc;
                    } else {
                        if (!pl.p) throw new Error('hufDecode issues');
                        let j;
                        for(j = 0; j < pl.lit; j++){
                            const l = hufLength(encodingTable[pl.p[j]]);
                            while(lc < l && inOffset.value < inOffsetEnd){
                                getChar(c, lc, uInt8Array, inOffset);
                                c = getCharReturn.c;
                                lc = getCharReturn.lc;
                            }
                            if (lc >= l) {
                                if (hufCode(encodingTable[pl.p[j]]) == (c >> lc - l & (1 << l) - 1)) {
                                    lc -= l;
                                    getCode(pl.p[j], rlc, c, lc, uInt8Array, inOffset, outBuffer, outOffset, outBufferEndOffset);
                                    c = getCodeReturn.c;
                                    lc = getCodeReturn.lc;
                                    break;
                                }
                            }
                        }
                        if (j == pl.lit) throw new Error('hufDecode issues');
                    }
                }
            }
            const i = 8 - ni & 7;
            c >>= i;
            lc -= i;
            while(lc > 0){
                const pl = decodingTable[c << HUF_DECBITS - lc & HUF_DECMASK];
                if (pl.len) {
                    lc -= pl.len;
                    getCode(pl.lit, rlc, c, lc, uInt8Array, inOffset, outBuffer, outOffset, outBufferEndOffset);
                    c = getCodeReturn.c;
                    lc = getCodeReturn.lc;
                } else throw new Error('hufDecode issues');
            }
            return true;
        }
        function hufUncompress(uInt8Array, inDataView, inOffset, nCompressed, outBuffer, nRaw) {
            const outOffset = {
                value: 0
            };
            const initialInOffset = inOffset.value;
            const im = parseUint32(inDataView, inOffset);
            const iM = parseUint32(inDataView, inOffset);
            inOffset.value += 4;
            const nBits = parseUint32(inDataView, inOffset);
            inOffset.value += 4;
            if (im < 0 || im >= HUF_ENCSIZE || iM < 0 || iM >= HUF_ENCSIZE) throw new Error('Something wrong with HUF_ENCSIZE');
            const freq = new Array(HUF_ENCSIZE);
            const hdec = new Array(HUF_DECSIZE);
            hufClearDecTable(hdec);
            const ni = nCompressed - (inOffset.value - initialInOffset);
            hufUnpackEncTable(uInt8Array, inOffset, ni, im, iM, freq);
            if (nBits > 8 * (nCompressed - (inOffset.value - initialInOffset))) throw new Error('Something wrong with hufUncompress');
            hufBuildDecTable(freq, im, iM, hdec);
            hufDecode(freq, hdec, uInt8Array, inOffset, nBits, iM, nRaw, outBuffer, outOffset);
        }
        function applyLut(lut, data, nData) {
            for(let i = 0; i < nData; ++i)data[i] = lut[data[i]];
        }
        function predictor(source) {
            for(let t = 1; t < source.length; t++){
                const d = source[t - 1] + source[t] - 128;
                source[t] = d;
            }
        }
        function interleaveScalar(source, out) {
            let t1 = 0;
            let t2 = Math.floor((source.length + 1) / 2);
            let s = 0;
            const stop = source.length - 1;
            while(true){
                if (s > stop) break;
                out[s++] = source[t1++];
                if (s > stop) break;
                out[s++] = source[t2++];
            }
        }
        function decodeRunLength(source) {
            let size = source.byteLength;
            const out = new Array();
            let p = 0;
            const reader = new DataView(source);
            while(size > 0){
                const l = reader.getInt8(p++);
                if (l < 0) {
                    const count = -l;
                    size -= count + 1;
                    for(let i = 0; i < count; i++)out.push(reader.getUint8(p++));
                } else {
                    const count = l;
                    size -= 2;
                    const value = reader.getUint8(p++);
                    for(let i = 0; i < count + 1; i++)out.push(value);
                }
            }
            return out;
        }
        function lossyDctDecode(cscSet, rowPtrs, channelData, acBuffer, dcBuffer, outBuffer) {
            let dataView = new DataView(outBuffer.buffer);
            const width = channelData[cscSet.idx[0]].width;
            const height = channelData[cscSet.idx[0]].height;
            const numComp = 3;
            const numFullBlocksX = Math.floor(width / 8.0);
            const numBlocksX = Math.ceil(width / 8.0);
            const numBlocksY = Math.ceil(height / 8.0);
            const leftoverX = width - (numBlocksX - 1) * 8;
            const leftoverY = height - (numBlocksY - 1) * 8;
            const currAcComp = {
                value: 0
            };
            const currDcComp = new Array(numComp);
            const dctData = new Array(numComp);
            const halfZigBlock = new Array(numComp);
            const rowBlock = new Array(numComp);
            const rowOffsets = new Array(numComp);
            for(let comp = 0; comp < numComp; ++comp){
                rowOffsets[comp] = rowPtrs[cscSet.idx[comp]];
                currDcComp[comp] = comp < 1 ? 0 : currDcComp[comp - 1] + numBlocksX * numBlocksY;
                dctData[comp] = new Float32Array(64);
                halfZigBlock[comp] = new Uint16Array(64);
                rowBlock[comp] = new Uint16Array(numBlocksX * 64);
            }
            for(let blocky = 0; blocky < numBlocksY; ++blocky){
                let maxY = 8;
                if (blocky == numBlocksY - 1) maxY = leftoverY;
                let maxX = 8;
                for(let blockx = 0; blockx < numBlocksX; ++blockx){
                    if (blockx == numBlocksX - 1) maxX = leftoverX;
                    for(let comp = 0; comp < numComp; ++comp){
                        halfZigBlock[comp].fill(0);
                        // set block DC component
                        halfZigBlock[comp][0] = dcBuffer[currDcComp[comp]++];
                        // set block AC components
                        unRleAC(currAcComp, acBuffer, halfZigBlock[comp]);
                        // UnZigZag block to float
                        unZigZag(halfZigBlock[comp], dctData[comp]);
                        // decode float dct
                        dctInverse(dctData[comp]);
                    }
                    if (numComp == 3) csc709Inverse(dctData);
                    for(let comp = 0; comp < numComp; ++comp)convertToHalf(dctData[comp], rowBlock[comp], blockx * 64);
                } // blockx
                let offset = 0;
                for(let comp = 0; comp < numComp; ++comp){
                    const type = channelData[cscSet.idx[comp]].type;
                    for(let y = 8 * blocky; y < 8 * blocky + maxY; ++y){
                        offset = rowOffsets[comp][y];
                        for(let blockx = 0; blockx < numFullBlocksX; ++blockx){
                            const src = blockx * 64 + (y & 0x7) * 8;
                            dataView.setUint16(offset + 0 * INT16_SIZE * type, rowBlock[comp][src + 0], true);
                            dataView.setUint16(offset + 1 * INT16_SIZE * type, rowBlock[comp][src + 1], true);
                            dataView.setUint16(offset + 2 * INT16_SIZE * type, rowBlock[comp][src + 2], true);
                            dataView.setUint16(offset + 3 * INT16_SIZE * type, rowBlock[comp][src + 3], true);
                            dataView.setUint16(offset + 4 * INT16_SIZE * type, rowBlock[comp][src + 4], true);
                            dataView.setUint16(offset + 5 * INT16_SIZE * type, rowBlock[comp][src + 5], true);
                            dataView.setUint16(offset + 6 * INT16_SIZE * type, rowBlock[comp][src + 6], true);
                            dataView.setUint16(offset + 7 * INT16_SIZE * type, rowBlock[comp][src + 7], true);
                            offset += 8 * INT16_SIZE * type;
                        }
                    }
                    // handle partial X blocks
                    if (numFullBlocksX != numBlocksX) for(let y = 8 * blocky; y < 8 * blocky + maxY; ++y){
                        const offset = rowOffsets[comp][y] + 8 * numFullBlocksX * INT16_SIZE * type;
                        const src = numFullBlocksX * 64 + (y & 0x7) * 8;
                        for(let x = 0; x < maxX; ++x)dataView.setUint16(offset + x * INT16_SIZE * type, rowBlock[comp][src + x], true);
                    }
                } // comp
            } // blocky
            const halfRow = new Uint16Array(width);
            dataView = new DataView(outBuffer.buffer);
            // convert channels back to float, if needed
            for(let comp = 0; comp < numComp; ++comp){
                channelData[cscSet.idx[comp]].decoded = true;
                const type = channelData[cscSet.idx[comp]].type;
                if (channelData[comp].type != 2) continue;
                for(let y = 0; y < height; ++y){
                    const offset = rowOffsets[comp][y];
                    for(let x = 0; x < width; ++x)halfRow[x] = dataView.getUint16(offset + x * INT16_SIZE * type, true);
                    for(let x = 0; x < width; ++x)dataView.setFloat32(offset + x * INT16_SIZE * type, decodeFloat16(halfRow[x]), true);
                }
            }
        }
        function unRleAC(currAcComp, acBuffer, halfZigBlock) {
            let acValue;
            let dctComp = 1;
            while(dctComp < 64){
                acValue = acBuffer[currAcComp.value];
                if (acValue == 0xff00) dctComp = 64;
                else if (acValue >> 8 == 0xff) dctComp += acValue & 0xff;
                else {
                    halfZigBlock[dctComp] = acValue;
                    dctComp++;
                }
                currAcComp.value++;
            }
        }
        function unZigZag(src, dst) {
            dst[0] = decodeFloat16(src[0]);
            dst[1] = decodeFloat16(src[1]);
            dst[2] = decodeFloat16(src[5]);
            dst[3] = decodeFloat16(src[6]);
            dst[4] = decodeFloat16(src[14]);
            dst[5] = decodeFloat16(src[15]);
            dst[6] = decodeFloat16(src[27]);
            dst[7] = decodeFloat16(src[28]);
            dst[8] = decodeFloat16(src[2]);
            dst[9] = decodeFloat16(src[4]);
            dst[10] = decodeFloat16(src[7]);
            dst[11] = decodeFloat16(src[13]);
            dst[12] = decodeFloat16(src[16]);
            dst[13] = decodeFloat16(src[26]);
            dst[14] = decodeFloat16(src[29]);
            dst[15] = decodeFloat16(src[42]);
            dst[16] = decodeFloat16(src[3]);
            dst[17] = decodeFloat16(src[8]);
            dst[18] = decodeFloat16(src[12]);
            dst[19] = decodeFloat16(src[17]);
            dst[20] = decodeFloat16(src[25]);
            dst[21] = decodeFloat16(src[30]);
            dst[22] = decodeFloat16(src[41]);
            dst[23] = decodeFloat16(src[43]);
            dst[24] = decodeFloat16(src[9]);
            dst[25] = decodeFloat16(src[11]);
            dst[26] = decodeFloat16(src[18]);
            dst[27] = decodeFloat16(src[24]);
            dst[28] = decodeFloat16(src[31]);
            dst[29] = decodeFloat16(src[40]);
            dst[30] = decodeFloat16(src[44]);
            dst[31] = decodeFloat16(src[53]);
            dst[32] = decodeFloat16(src[10]);
            dst[33] = decodeFloat16(src[19]);
            dst[34] = decodeFloat16(src[23]);
            dst[35] = decodeFloat16(src[32]);
            dst[36] = decodeFloat16(src[39]);
            dst[37] = decodeFloat16(src[45]);
            dst[38] = decodeFloat16(src[52]);
            dst[39] = decodeFloat16(src[54]);
            dst[40] = decodeFloat16(src[20]);
            dst[41] = decodeFloat16(src[22]);
            dst[42] = decodeFloat16(src[33]);
            dst[43] = decodeFloat16(src[38]);
            dst[44] = decodeFloat16(src[46]);
            dst[45] = decodeFloat16(src[51]);
            dst[46] = decodeFloat16(src[55]);
            dst[47] = decodeFloat16(src[60]);
            dst[48] = decodeFloat16(src[21]);
            dst[49] = decodeFloat16(src[34]);
            dst[50] = decodeFloat16(src[37]);
            dst[51] = decodeFloat16(src[47]);
            dst[52] = decodeFloat16(src[50]);
            dst[53] = decodeFloat16(src[56]);
            dst[54] = decodeFloat16(src[59]);
            dst[55] = decodeFloat16(src[61]);
            dst[56] = decodeFloat16(src[35]);
            dst[57] = decodeFloat16(src[36]);
            dst[58] = decodeFloat16(src[48]);
            dst[59] = decodeFloat16(src[49]);
            dst[60] = decodeFloat16(src[57]);
            dst[61] = decodeFloat16(src[58]);
            dst[62] = decodeFloat16(src[62]);
            dst[63] = decodeFloat16(src[63]);
        }
        function dctInverse(data) {
            const a = 0.5 * Math.cos(0.7853975);
            const b = 0.5 * Math.cos(0.196349375);
            const c = 0.5 * Math.cos(0.39269875);
            const d = 0.5 * Math.cos(3.0 * 3.14159 / 16.0);
            const e = 0.5 * Math.cos(0.981746875);
            const f = 0.5 * Math.cos(3.0 * 3.14159 / 8.0);
            const g = 0.5 * Math.cos(1.374445625);
            const alpha = new Array(4);
            const beta = new Array(4);
            const theta = new Array(4);
            const gamma = new Array(4);
            for(let row = 0; row < 8; ++row){
                const rowPtr = row * 8;
                alpha[0] = c * data[rowPtr + 2];
                alpha[1] = f * data[rowPtr + 2];
                alpha[2] = c * data[rowPtr + 6];
                alpha[3] = f * data[rowPtr + 6];
                beta[0] = b * data[rowPtr + 1] + d * data[rowPtr + 3] + e * data[rowPtr + 5] + g * data[rowPtr + 7];
                beta[1] = d * data[rowPtr + 1] - g * data[rowPtr + 3] - b * data[rowPtr + 5] - e * data[rowPtr + 7];
                beta[2] = e * data[rowPtr + 1] - b * data[rowPtr + 3] + g * data[rowPtr + 5] + d * data[rowPtr + 7];
                beta[3] = g * data[rowPtr + 1] - e * data[rowPtr + 3] + d * data[rowPtr + 5] - b * data[rowPtr + 7];
                theta[0] = a * (data[rowPtr + 0] + data[rowPtr + 4]);
                theta[3] = a * (data[rowPtr + 0] - data[rowPtr + 4]);
                theta[1] = alpha[0] + alpha[3];
                theta[2] = alpha[1] - alpha[2];
                gamma[0] = theta[0] + theta[1];
                gamma[1] = theta[3] + theta[2];
                gamma[2] = theta[3] - theta[2];
                gamma[3] = theta[0] - theta[1];
                data[rowPtr + 0] = gamma[0] + beta[0];
                data[rowPtr + 1] = gamma[1] + beta[1];
                data[rowPtr + 2] = gamma[2] + beta[2];
                data[rowPtr + 3] = gamma[3] + beta[3];
                data[rowPtr + 4] = gamma[3] - beta[3];
                data[rowPtr + 5] = gamma[2] - beta[2];
                data[rowPtr + 6] = gamma[1] - beta[1];
                data[rowPtr + 7] = gamma[0] - beta[0];
            }
            for(let column = 0; column < 8; ++column){
                alpha[0] = c * data[16 + column];
                alpha[1] = f * data[16 + column];
                alpha[2] = c * data[48 + column];
                alpha[3] = f * data[48 + column];
                beta[0] = b * data[8 + column] + d * data[24 + column] + e * data[40 + column] + g * data[56 + column];
                beta[1] = d * data[8 + column] - g * data[24 + column] - b * data[40 + column] - e * data[56 + column];
                beta[2] = e * data[8 + column] - b * data[24 + column] + g * data[40 + column] + d * data[56 + column];
                beta[3] = g * data[8 + column] - e * data[24 + column] + d * data[40 + column] - b * data[56 + column];
                theta[0] = a * (data[column] + data[32 + column]);
                theta[3] = a * (data[column] - data[32 + column]);
                theta[1] = alpha[0] + alpha[3];
                theta[2] = alpha[1] - alpha[2];
                gamma[0] = theta[0] + theta[1];
                gamma[1] = theta[3] + theta[2];
                gamma[2] = theta[3] - theta[2];
                gamma[3] = theta[0] - theta[1];
                data[0 + column] = gamma[0] + beta[0];
                data[8 + column] = gamma[1] + beta[1];
                data[16 + column] = gamma[2] + beta[2];
                data[24 + column] = gamma[3] + beta[3];
                data[32 + column] = gamma[3] - beta[3];
                data[40 + column] = gamma[2] - beta[2];
                data[48 + column] = gamma[1] - beta[1];
                data[56 + column] = gamma[0] - beta[0];
            }
        }
        function csc709Inverse(data) {
            for(let i = 0; i < 64; ++i){
                const y = data[0][i];
                const cb = data[1][i];
                const cr = data[2][i];
                data[0][i] = y + 1.5747 * cr;
                data[1][i] = y - 0.1873 * cb - 0.4682 * cr;
                data[2][i] = y + 1.8556 * cb;
            }
        }
        function convertToHalf(src, dst, idx) {
            for(let i = 0; i < 64; ++i)dst[idx + i] = (0, $ilwiq.DataUtils).toHalfFloat(toLinear(src[i]));
        }
        function toLinear(float) {
            if (float <= 1) return Math.sign(float) * Math.pow(Math.abs(float), 2.2);
            else return Math.sign(float) * Math.pow(logBase, Math.abs(float) - 1.0);
        }
        function uncompressRAW(info) {
            return new DataView(info.array.buffer, info.offset.value, info.size);
        }
        function uncompressRLE(info) {
            const compressed = info.viewer.buffer.slice(info.offset.value, info.offset.value + info.size);
            const rawBuffer = new Uint8Array(decodeRunLength(compressed));
            const tmpBuffer = new Uint8Array(rawBuffer.length);
            predictor(rawBuffer); // revert predictor
            interleaveScalar(rawBuffer, tmpBuffer); // interleave pixels
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressZIP(info) {
            const compressed = info.array.slice(info.offset.value, info.offset.value + info.size);
            if (typeof $79Zxq === 'undefined') console.error('THREE.EXRLoader: External library fflate.min.js required.');
            const rawBuffer = $79Zxq.unzlibSync(compressed); // eslint-disable-line no-undef
            const tmpBuffer = new Uint8Array(rawBuffer.length);
            predictor(rawBuffer); // revert predictor
            interleaveScalar(rawBuffer, tmpBuffer); // interleave pixels
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressPIZ(info) {
            const inDataView = info.viewer;
            const inOffset = {
                value: info.offset.value
            };
            const outBuffer = new Uint16Array(info.width * info.scanlineBlockSize * (info.channels * info.type));
            const bitmap = new Uint8Array(BITMAP_SIZE);
            // Setup channel info
            let outBufferEnd = 0;
            const pizChannelData = new Array(info.channels);
            for(let i = 0; i < info.channels; i++){
                pizChannelData[i] = {};
                pizChannelData[i]['start'] = outBufferEnd;
                pizChannelData[i]['end'] = pizChannelData[i]['start'];
                pizChannelData[i]['nx'] = info.width;
                pizChannelData[i]['ny'] = info.lines;
                pizChannelData[i]['size'] = info.type;
                outBufferEnd += pizChannelData[i].nx * pizChannelData[i].ny * pizChannelData[i].size;
            }
            // Read range compression data
            const minNonZero = parseUint16(inDataView, inOffset);
            const maxNonZero = parseUint16(inDataView, inOffset);
            if (maxNonZero >= BITMAP_SIZE) throw new Error('Something is wrong with PIZ_COMPRESSION BITMAP_SIZE');
            if (minNonZero <= maxNonZero) for(let i = 0; i < maxNonZero - minNonZero + 1; i++)bitmap[i + minNonZero] = parseUint8(inDataView, inOffset);
            // Reverse LUT
            const lut = new Uint16Array(USHORT_RANGE);
            const maxValue = reverseLutFromBitmap(bitmap, lut);
            const length = parseUint32(inDataView, inOffset);
            // Huffman decoding
            hufUncompress(info.array, inDataView, inOffset, length, outBuffer, outBufferEnd);
            // Wavelet decoding
            for(let i = 0; i < info.channels; ++i){
                const cd = pizChannelData[i];
                for(let j = 0; j < pizChannelData[i].size; ++j)wav2Decode(outBuffer, cd.start + j, cd.nx, cd.size, cd.ny, cd.nx * cd.size, maxValue);
            }
            // Expand the pixel data to their original range
            applyLut(lut, outBuffer, outBufferEnd);
            // Rearrange the pixel data into the format expected by the caller.
            let tmpOffset = 0;
            const tmpBuffer = new Uint8Array(outBuffer.buffer.byteLength);
            for(let y = 0; y < info.lines; y++)for(let c = 0; c < info.channels; c++){
                const cd = pizChannelData[c];
                const n = cd.nx * cd.size;
                const cp = new Uint8Array(outBuffer.buffer, cd.end * INT16_SIZE, n * INT16_SIZE);
                tmpBuffer.set(cp, tmpOffset);
                tmpOffset += n * INT16_SIZE;
                cd.end += n;
            }
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressPXR(info) {
            const compressed = info.array.slice(info.offset.value, info.offset.value + info.size);
            if (typeof $79Zxq === 'undefined') console.error('THREE.EXRLoader: External library fflate.min.js required.');
            const rawBuffer = $79Zxq.unzlibSync(compressed); // eslint-disable-line no-undef
            const sz = info.lines * info.channels * info.width;
            const tmpBuffer = info.type == 1 ? new Uint16Array(sz) : new Uint32Array(sz);
            let tmpBufferEnd = 0;
            let writePtr = 0;
            const ptr = new Array(4);
            for(let y = 0; y < info.lines; y++)for(let c = 0; c < info.channels; c++){
                let pixel = 0;
                switch(info.type){
                    case 1:
                        ptr[0] = tmpBufferEnd;
                        ptr[1] = ptr[0] + info.width;
                        tmpBufferEnd = ptr[1] + info.width;
                        for(let j = 0; j < info.width; ++j){
                            const diff = rawBuffer[ptr[0]++] << 8 | rawBuffer[ptr[1]++];
                            pixel += diff;
                            tmpBuffer[writePtr] = pixel;
                            writePtr++;
                        }
                        break;
                    case 2:
                        ptr[0] = tmpBufferEnd;
                        ptr[1] = ptr[0] + info.width;
                        ptr[2] = ptr[1] + info.width;
                        tmpBufferEnd = ptr[2] + info.width;
                        for(let j = 0; j < info.width; ++j){
                            const diff = rawBuffer[ptr[0]++] << 24 | rawBuffer[ptr[1]++] << 16 | rawBuffer[ptr[2]++] << 8;
                            pixel += diff;
                            tmpBuffer[writePtr] = pixel;
                            writePtr++;
                        }
                        break;
                }
            }
            return new DataView(tmpBuffer.buffer);
        }
        function uncompressDWA(info) {
            const inDataView = info.viewer;
            const inOffset = {
                value: info.offset.value
            };
            const outBuffer = new Uint8Array(info.width * info.lines * (info.channels * info.type * INT16_SIZE));
            // Read compression header information
            const dwaHeader = {
                version: parseInt64(inDataView, inOffset),
                unknownUncompressedSize: parseInt64(inDataView, inOffset),
                unknownCompressedSize: parseInt64(inDataView, inOffset),
                acCompressedSize: parseInt64(inDataView, inOffset),
                dcCompressedSize: parseInt64(inDataView, inOffset),
                rleCompressedSize: parseInt64(inDataView, inOffset),
                rleUncompressedSize: parseInt64(inDataView, inOffset),
                rleRawSize: parseInt64(inDataView, inOffset),
                totalAcUncompressedCount: parseInt64(inDataView, inOffset),
                totalDcUncompressedCount: parseInt64(inDataView, inOffset),
                acCompression: parseInt64(inDataView, inOffset)
            };
            if (dwaHeader.version < 2) throw new Error('EXRLoader.parse: ' + EXRHeader.compression + ' version ' + dwaHeader.version + ' is unsupported');
            // Read channel ruleset information
            const channelRules = new Array();
            let ruleSize = parseUint16(inDataView, inOffset) - INT16_SIZE;
            while(ruleSize > 0){
                const name = parseNullTerminatedString(inDataView.buffer, inOffset);
                const value = parseUint8(inDataView, inOffset);
                const compression = value >> 2 & 3;
                const csc = (value >> 4) - 1;
                const index = new Int8Array([
                    csc
                ])[0];
                const type = parseUint8(inDataView, inOffset);
                channelRules.push({
                    name: name,
                    index: index,
                    type: type,
                    compression: compression
                });
                ruleSize -= name.length + 3;
            }
            // Classify channels
            const channels = EXRHeader.channels;
            const channelData = new Array(info.channels);
            for(let i = 0; i < info.channels; ++i){
                const cd = channelData[i] = {};
                const channel = channels[i];
                cd.name = channel.name;
                cd.compression = UNKNOWN;
                cd.decoded = false;
                cd.type = channel.pixelType;
                cd.pLinear = channel.pLinear;
                cd.width = info.width;
                cd.height = info.lines;
            }
            const cscSet = {
                idx: new Array(3)
            };
            for(let offset = 0; offset < info.channels; ++offset){
                const cd = channelData[offset];
                for(let i = 0; i < channelRules.length; ++i){
                    const rule = channelRules[i];
                    if (cd.name == rule.name) {
                        cd.compression = rule.compression;
                        if (rule.index >= 0) cscSet.idx[rule.index] = offset;
                        cd.offset = offset;
                    }
                }
            }
            let acBuffer, dcBuffer, rleBuffer;
            // Read DCT - AC component data
            if (dwaHeader.acCompressedSize > 0) switch(dwaHeader.acCompression){
                case STATIC_HUFFMAN:
                    acBuffer = new Uint16Array(dwaHeader.totalAcUncompressedCount);
                    hufUncompress(info.array, inDataView, inOffset, dwaHeader.acCompressedSize, acBuffer, dwaHeader.totalAcUncompressedCount);
                    break;
                case DEFLATE:
                    const compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.totalAcUncompressedCount);
                    const data = $79Zxq.unzlibSync(compressed); // eslint-disable-line no-undef
                    acBuffer = new Uint16Array(data.buffer);
                    inOffset.value += dwaHeader.totalAcUncompressedCount;
                    break;
            }
            // Read DCT - DC component data
            if (dwaHeader.dcCompressedSize > 0) {
                const zlibInfo = {
                    array: info.array,
                    offset: inOffset,
                    size: dwaHeader.dcCompressedSize
                };
                dcBuffer = new Uint16Array(uncompressZIP(zlibInfo).buffer);
                inOffset.value += dwaHeader.dcCompressedSize;
            }
            // Read RLE compressed data
            if (dwaHeader.rleRawSize > 0) {
                const compressed = info.array.slice(inOffset.value, inOffset.value + dwaHeader.rleCompressedSize);
                const data = $79Zxq.unzlibSync(compressed); // eslint-disable-line no-undef
                rleBuffer = decodeRunLength(data.buffer);
                inOffset.value += dwaHeader.rleCompressedSize;
            }
            // Prepare outbuffer data offset
            let outBufferEnd = 0;
            const rowOffsets = new Array(channelData.length);
            for(let i = 0; i < rowOffsets.length; ++i)rowOffsets[i] = new Array();
            for(let y = 0; y < info.lines; ++y)for(let chan = 0; chan < channelData.length; ++chan){
                rowOffsets[chan].push(outBufferEnd);
                outBufferEnd += channelData[chan].width * info.type * INT16_SIZE;
            }
            // Lossy DCT decode RGB channels
            lossyDctDecode(cscSet, rowOffsets, channelData, acBuffer, dcBuffer, outBuffer);
            // Decode other channels
            for(let i = 0; i < channelData.length; ++i){
                const cd = channelData[i];
                if (cd.decoded) continue;
                switch(cd.compression){
                    case RLE:
                        let row = 0;
                        let rleOffset = 0;
                        for(let y = 0; y < info.lines; ++y){
                            let rowOffsetBytes = rowOffsets[i][row];
                            for(let x = 0; x < cd.width; ++x){
                                for(let byte = 0; byte < INT16_SIZE * cd.type; ++byte)outBuffer[rowOffsetBytes++] = rleBuffer[rleOffset + byte * cd.width * cd.height];
                                rleOffset++;
                            }
                            row++;
                        }
                        break;
                    case LOSSY_DCT:
                    default:
                        throw new Error('EXRLoader.parse: unsupported channel compression');
                }
            }
            return new DataView(outBuffer.buffer);
        }
        function parseNullTerminatedString(buffer, offset) {
            const uintBuffer = new Uint8Array(buffer);
            let endOffset = 0;
            while(uintBuffer[offset.value + endOffset] != 0)endOffset += 1;
            const stringValue = new TextDecoder().decode(uintBuffer.slice(offset.value, offset.value + endOffset));
            offset.value = offset.value + endOffset + 1;
            return stringValue;
        }
        function parseFixedLengthString(buffer, offset, size) {
            const stringValue = new TextDecoder().decode(new Uint8Array(buffer).slice(offset.value, offset.value + size));
            offset.value = offset.value + size;
            return stringValue;
        }
        function parseRational(dataView, offset) {
            const x = parseInt32(dataView, offset);
            const y = parseUint32(dataView, offset);
            return [
                x,
                y
            ];
        }
        function parseTimecode(dataView, offset) {
            const x = parseUint32(dataView, offset);
            const y = parseUint32(dataView, offset);
            return [
                x,
                y
            ];
        }
        function parseInt32(dataView, offset) {
            const Int32 = dataView.getInt32(offset.value, true);
            offset.value = offset.value + INT32_SIZE;
            return Int32;
        }
        function parseUint32(dataView, offset) {
            const Uint32 = dataView.getUint32(offset.value, true);
            offset.value = offset.value + INT32_SIZE;
            return Uint32;
        }
        function parseUint8Array(uInt8Array, offset) {
            const Uint8 = uInt8Array[offset.value];
            offset.value = offset.value + INT8_SIZE;
            return Uint8;
        }
        function parseUint8(dataView, offset) {
            const Uint8 = dataView.getUint8(offset.value);
            offset.value = offset.value + INT8_SIZE;
            return Uint8;
        }
        const parseInt64 = function(dataView, offset) {
            const Int64 = Number(dataView.getBigInt64(offset.value, true));
            offset.value += ULONG_SIZE;
            return Int64;
        };
        function parseFloat32(dataView, offset) {
            const float = dataView.getFloat32(offset.value, true);
            offset.value += FLOAT32_SIZE;
            return float;
        }
        function decodeFloat32(dataView, offset) {
            return (0, $ilwiq.DataUtils).toHalfFloat(parseFloat32(dataView, offset));
        }
        // https://stackoverflow.com/questions/5678432/decompressing-half-precision-floats-in-javascript
        function decodeFloat16(binary) {
            const exponent = (binary & 0x7C00) >> 10, fraction = binary & 0x03FF;
            return (binary >> 15 ? -1 : 1) * (exponent ? exponent === 0x1F ? fraction ? NaN : Infinity : Math.pow(2, exponent - 15) * (1 + fraction / 0x400) : 6.103515625e-5 * (fraction / 0x400));
        }
        function parseUint16(dataView, offset) {
            const Uint16 = dataView.getUint16(offset.value, true);
            offset.value += INT16_SIZE;
            return Uint16;
        }
        function parseFloat16(buffer, offset) {
            return decodeFloat16(parseUint16(buffer, offset));
        }
        function parseChlist(dataView, buffer, offset, size) {
            const startOffset = offset.value;
            const channels = [];
            while(offset.value < startOffset + size - 1){
                const name = parseNullTerminatedString(buffer, offset);
                const pixelType = parseInt32(dataView, offset);
                const pLinear = parseUint8(dataView, offset);
                offset.value += 3; // reserved, three chars
                const xSampling = parseInt32(dataView, offset);
                const ySampling = parseInt32(dataView, offset);
                channels.push({
                    name: name,
                    pixelType: pixelType,
                    pLinear: pLinear,
                    xSampling: xSampling,
                    ySampling: ySampling
                });
            }
            offset.value += 1;
            return channels;
        }
        function parseChromaticities(dataView, offset) {
            const redX = parseFloat32(dataView, offset);
            const redY = parseFloat32(dataView, offset);
            const greenX = parseFloat32(dataView, offset);
            const greenY = parseFloat32(dataView, offset);
            const blueX = parseFloat32(dataView, offset);
            const blueY = parseFloat32(dataView, offset);
            const whiteX = parseFloat32(dataView, offset);
            const whiteY = parseFloat32(dataView, offset);
            return {
                redX: redX,
                redY: redY,
                greenX: greenX,
                greenY: greenY,
                blueX: blueX,
                blueY: blueY,
                whiteX: whiteX,
                whiteY: whiteY
            };
        }
        function parseCompression(dataView, offset) {
            const compressionCodes = [
                'NO_COMPRESSION',
                'RLE_COMPRESSION',
                'ZIPS_COMPRESSION',
                'ZIP_COMPRESSION',
                'PIZ_COMPRESSION',
                'PXR24_COMPRESSION',
                'B44_COMPRESSION',
                'B44A_COMPRESSION',
                'DWAA_COMPRESSION',
                'DWAB_COMPRESSION'
            ];
            const compression = parseUint8(dataView, offset);
            return compressionCodes[compression];
        }
        function parseBox2i(dataView, offset) {
            const xMin = parseUint32(dataView, offset);
            const yMin = parseUint32(dataView, offset);
            const xMax = parseUint32(dataView, offset);
            const yMax = parseUint32(dataView, offset);
            return {
                xMin: xMin,
                yMin: yMin,
                xMax: xMax,
                yMax: yMax
            };
        }
        function parseLineOrder(dataView, offset) {
            const lineOrders = [
                'INCREASING_Y'
            ];
            const lineOrder = parseUint8(dataView, offset);
            return lineOrders[lineOrder];
        }
        function parseV2f(dataView, offset) {
            const x = parseFloat32(dataView, offset);
            const y = parseFloat32(dataView, offset);
            return [
                x,
                y
            ];
        }
        function parseV3f(dataView, offset) {
            const x = parseFloat32(dataView, offset);
            const y = parseFloat32(dataView, offset);
            const z = parseFloat32(dataView, offset);
            return [
                x,
                y,
                z
            ];
        }
        function parseValue(dataView, buffer, offset, type, size) {
            if (type === 'string' || type === 'stringvector' || type === 'iccProfile') return parseFixedLengthString(buffer, offset, size);
            else if (type === 'chlist') return parseChlist(dataView, buffer, offset, size);
            else if (type === 'chromaticities') return parseChromaticities(dataView, offset);
            else if (type === 'compression') return parseCompression(dataView, offset);
            else if (type === 'box2i') return parseBox2i(dataView, offset);
            else if (type === 'lineOrder') return parseLineOrder(dataView, offset);
            else if (type === 'float') return parseFloat32(dataView, offset);
            else if (type === 'v2f') return parseV2f(dataView, offset);
            else if (type === 'v3f') return parseV3f(dataView, offset);
            else if (type === 'int') return parseInt32(dataView, offset);
            else if (type === 'rational') return parseRational(dataView, offset);
            else if (type === 'timecode') return parseTimecode(dataView, offset);
            else if (type === 'preview') {
                offset.value += size;
                return 'skipped';
            } else {
                offset.value += size;
                return undefined;
            }
        }
        function parseHeader(dataView, buffer, offset) {
            const EXRHeader = {};
            if (dataView.getUint32(0, true) != 20000630) throw new Error('THREE.EXRLoader: provided file doesn\'t appear to be in OpenEXR format.');
            EXRHeader.version = dataView.getUint8(4);
            const spec = dataView.getUint8(5); // fullMask
            EXRHeader.spec = {
                singleTile: !!(spec & 2),
                longName: !!(spec & 4),
                deepFormat: !!(spec & 8),
                multiPart: !!(spec & 16)
            };
            // start of header
            offset.value = 8; // start at 8 - after pre-amble
            let keepReading = true;
            while(keepReading){
                const attributeName = parseNullTerminatedString(buffer, offset);
                if (attributeName == 0) keepReading = false;
                else {
                    const attributeType = parseNullTerminatedString(buffer, offset);
                    const attributeSize = parseUint32(dataView, offset);
                    const attributeValue = parseValue(dataView, buffer, offset, attributeType, attributeSize);
                    if (attributeValue === undefined) console.warn(`EXRLoader.parse: skipped unknown header attribute type \'${attributeType}\'.`);
                    else EXRHeader[attributeName] = attributeValue;
                }
            }
            if ((spec & -5) != 0) {
                console.error('EXRHeader:', EXRHeader);
                throw new Error('THREE.EXRLoader: provided file is currently unsupported.');
            }
            return EXRHeader;
        }
        function setupDecoder(EXRHeader, dataView, uInt8Array, offset, outputType) {
            const EXRDecoder = {
                size: 0,
                viewer: dataView,
                array: uInt8Array,
                offset: offset,
                width: EXRHeader.dataWindow.xMax - EXRHeader.dataWindow.xMin + 1,
                height: EXRHeader.dataWindow.yMax - EXRHeader.dataWindow.yMin + 1,
                channels: EXRHeader.channels.length,
                bytesPerLine: null,
                lines: null,
                inputSize: null,
                type: EXRHeader.channels[0].pixelType,
                uncompress: null,
                getter: null,
                format: null,
                encoding: null
            };
            switch(EXRHeader.compression){
                case 'NO_COMPRESSION':
                    EXRDecoder.lines = 1;
                    EXRDecoder.uncompress = uncompressRAW;
                    break;
                case 'RLE_COMPRESSION':
                    EXRDecoder.lines = 1;
                    EXRDecoder.uncompress = uncompressRLE;
                    break;
                case 'ZIPS_COMPRESSION':
                    EXRDecoder.lines = 1;
                    EXRDecoder.uncompress = uncompressZIP;
                    break;
                case 'ZIP_COMPRESSION':
                    EXRDecoder.lines = 16;
                    EXRDecoder.uncompress = uncompressZIP;
                    break;
                case 'PIZ_COMPRESSION':
                    EXRDecoder.lines = 32;
                    EXRDecoder.uncompress = uncompressPIZ;
                    break;
                case 'PXR24_COMPRESSION':
                    EXRDecoder.lines = 16;
                    EXRDecoder.uncompress = uncompressPXR;
                    break;
                case 'DWAA_COMPRESSION':
                    EXRDecoder.lines = 32;
                    EXRDecoder.uncompress = uncompressDWA;
                    break;
                case 'DWAB_COMPRESSION':
                    EXRDecoder.lines = 256;
                    EXRDecoder.uncompress = uncompressDWA;
                    break;
                default:
                    throw new Error('EXRLoader.parse: ' + EXRHeader.compression + ' is unsupported');
            }
            EXRDecoder.scanlineBlockSize = EXRDecoder.lines;
            if (EXRDecoder.type == 1) // half
            switch(outputType){
                case 0, $ilwiq.FloatType:
                    EXRDecoder.getter = parseFloat16;
                    EXRDecoder.inputSize = INT16_SIZE;
                    break;
                case 0, $ilwiq.HalfFloatType:
                    EXRDecoder.getter = parseUint16;
                    EXRDecoder.inputSize = INT16_SIZE;
                    break;
            }
            else if (EXRDecoder.type == 2) // float
            switch(outputType){
                case 0, $ilwiq.FloatType:
                    EXRDecoder.getter = parseFloat32;
                    EXRDecoder.inputSize = FLOAT32_SIZE;
                    break;
                case 0, $ilwiq.HalfFloatType:
                    EXRDecoder.getter = decodeFloat32;
                    EXRDecoder.inputSize = FLOAT32_SIZE;
            }
            else throw new Error('EXRLoader.parse: unsupported pixelType ' + EXRDecoder.type + ' for ' + EXRHeader.compression + '.');
            EXRDecoder.blockCount = (EXRHeader.dataWindow.yMax + 1) / EXRDecoder.scanlineBlockSize;
            for(let i = 0; i < EXRDecoder.blockCount; i++)parseInt64(dataView, offset); // scanlineOffset
            // we should be passed the scanline offset table, ready to start reading pixel data.
            // RGB images will be converted to RGBA format, preventing software emulation in select devices.
            EXRDecoder.outputChannels = EXRDecoder.channels == 3 ? 4 : EXRDecoder.channels;
            const size = EXRDecoder.width * EXRDecoder.height * EXRDecoder.outputChannels;
            switch(outputType){
                case 0, $ilwiq.FloatType:
                    EXRDecoder.byteArray = new Float32Array(size);
                    // Fill initially with 1s for the alpha value if the texture is not RGBA, RGB values will be overwritten
                    if (EXRDecoder.channels < EXRDecoder.outputChannels) EXRDecoder.byteArray.fill(1, 0, size);
                    break;
                case 0, $ilwiq.HalfFloatType:
                    EXRDecoder.byteArray = new Uint16Array(size);
                    if (EXRDecoder.channels < EXRDecoder.outputChannels) EXRDecoder.byteArray.fill(0x3C00, 0, size); // Uint16Array holds half float data, 0x3C00 is 1
                    break;
                default:
                    console.error('THREE.EXRLoader: unsupported type: ', outputType);
                    break;
            }
            EXRDecoder.bytesPerLine = EXRDecoder.width * EXRDecoder.inputSize * EXRDecoder.channels;
            if (EXRDecoder.outputChannels == 4) {
                EXRDecoder.format = (0, $ilwiq.RGBAFormat);
                EXRDecoder.encoding = (0, $ilwiq.LinearEncoding);
            } else {
                EXRDecoder.format = (0, $ilwiq.RedFormat);
                EXRDecoder.encoding = (0, $ilwiq.LinearEncoding);
            }
            return EXRDecoder;
        }
        // start parsing file [START]
        const bufferDataView = new DataView(buffer);
        const uInt8Array = new Uint8Array(buffer);
        const offset = {
            value: 0
        };
        // get header information and validate format.
        const EXRHeader = parseHeader(bufferDataView, buffer, offset);
        // get input compression information and prepare decoding.
        const EXRDecoder = setupDecoder(EXRHeader, bufferDataView, uInt8Array, offset, this.type);
        const tmpOffset = {
            value: 0
        };
        const channelOffsets = {
            R: 0,
            G: 1,
            B: 2,
            A: 3,
            Y: 0
        };
        for(let scanlineBlockIdx = 0; scanlineBlockIdx < EXRDecoder.height / EXRDecoder.scanlineBlockSize; scanlineBlockIdx++){
            const line = parseUint32(bufferDataView, offset); // line_no
            EXRDecoder.size = parseUint32(bufferDataView, offset); // data_len
            EXRDecoder.lines = line + EXRDecoder.scanlineBlockSize > EXRDecoder.height ? EXRDecoder.height - line : EXRDecoder.scanlineBlockSize;
            const isCompressed = EXRDecoder.size < EXRDecoder.lines * EXRDecoder.bytesPerLine;
            const viewer = isCompressed ? EXRDecoder.uncompress(EXRDecoder) : uncompressRAW(EXRDecoder);
            offset.value += EXRDecoder.size;
            for(let line_y = 0; line_y < EXRDecoder.scanlineBlockSize; line_y++){
                const true_y = line_y + scanlineBlockIdx * EXRDecoder.scanlineBlockSize;
                if (true_y >= EXRDecoder.height) break;
                for(let channelID = 0; channelID < EXRDecoder.channels; channelID++){
                    const cOff = channelOffsets[EXRHeader.channels[channelID].name];
                    for(let x = 0; x < EXRDecoder.width; x++){
                        tmpOffset.value = (line_y * (EXRDecoder.channels * EXRDecoder.width) + channelID * EXRDecoder.width + x) * EXRDecoder.inputSize;
                        const outIndex = (EXRDecoder.height - 1 - true_y) * (EXRDecoder.width * EXRDecoder.outputChannels) + x * EXRDecoder.outputChannels + cOff;
                        EXRDecoder.byteArray[outIndex] = EXRDecoder.getter(viewer, tmpOffset);
                    }
                }
            }
        }
        return {
            header: EXRHeader,
            width: EXRDecoder.width,
            height: EXRDecoder.height,
            data: EXRDecoder.byteArray,
            format: EXRDecoder.format,
            encoding: EXRDecoder.encoding,
            type: this.type
        };
    }
    setDataType(value) {
        this.type = value;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        function onLoadCallback(texture, texData) {
            texture.encoding = texData.encoding;
            texture.minFilter = (0, $ilwiq.LinearFilter);
            texture.magFilter = (0, $ilwiq.LinearFilter);
            texture.generateMipmaps = false;
            texture.flipY = false;
            if (onLoad) onLoad(texture, texData);
        }
        return super.load(url, onLoadCallback, onProgress, onError);
    }
}

});


parcelRegister("fmRoT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("7we3r")).default);

var $7we3r = parcelRequire("7we3r");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a, create: $b302555736d21bd7$export$185802fd694ee1f5 } = (0, $7we3r.default);

});
parcelRegister("7we3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $57966c7e0affc4cb$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $blSvA = parcelRequire("blSvA");

var $8cmY2 = parcelRequire("8cmY2");

var $dIGMp = parcelRequire("dIGMp");

var $lAKPy = parcelRequire("lAKPy");

var $7L4QX = parcelRequire("7L4QX");

var $35BUy = parcelRequire("35BUy");

var $jOwpo = parcelRequire("jOwpo");

var $6HVMZ = parcelRequire("6HVMZ");

var $JEeti = parcelRequire("JEeti");

var $dxy9O = parcelRequire("dxy9O");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");

var $lnWCo = parcelRequire("lnWCo");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $ewFRw.default)(defaultConfig);
    const instance = (0, $jJbMR.default)((0, $ewFRw.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $gKvUL.default).extend(instance, (0, $ewFRw.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $gKvUL.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $lk5EI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $blSvA.default));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $ewFRw.default);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $dIGMp.default);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $lAKPy.default);
$57966c7e0affc4cb$var$axios.isCancel = (0, $7L4QX.default);
$57966c7e0affc4cb$var$axios.VERSION = (0, $35BUy.VERSION);
$57966c7e0affc4cb$var$axios.toFormData = (0, $jOwpo.default);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $6HVMZ.default);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $JEeti.default);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $dxy9O.default);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $lk5EI.default);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $bxxyx.default);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $8cmY2.default)((0, $gKvUL.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $jZ6wW.default).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $lnWCo.default);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c319b2c832c2914a$export$2e2bcd8739ae039);

var $jJbMR = parcelRequire("jJbMR");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const { iterator: $c319b2c832c2914a$var$iterator, toStringTag: $c319b2c832c2914a$var$toStringTag } = Symbol;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== 'object') return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !($c319b2c832c2914a$var$toStringTag in val) && !($c319b2c832c2914a$var$iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c319b2c832c2914a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c319b2c832c2914a$var$isObject(val) || $c319b2c832c2914a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c319b2c832c2914a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c319b2c832c2914a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $c319b2c832c2914a$var$G = $c319b2c832c2914a$var$getGlobal();
const $c319b2c832c2914a$var$FormDataCtor = typeof $c319b2c832c2914a$var$G.FormData !== 'undefined' ? $c319b2c832c2914a$var$G.FormData : undefined;
const $c319b2c832c2914a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c319b2c832c2914a$var$FormDataCtor && thing instanceof $c319b2c832c2914a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c319b2c832c2914a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c319b2c832c2914a$var$isFunction(thing.append)) return false;
    const kind = $c319b2c832c2914a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest('URLSearchParams');
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c319b2c832c2914a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c319b2c832c2914a$var$findKey(obj, key) {
    if ($c319b2c832c2914a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $c319b2c832c2914a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c319b2c832c2914a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c319b2c832c2914a$var$isPlainObject(existing) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(existing, val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c319b2c832c2914a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c319b2c832c2914a$var$isBuffer(source)) continue;
        $c319b2c832c2914a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $c319b2c832c2914a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c319b2c832c2914a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $jJbMR.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c319b2c832c2914a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest('HTMLFormElement');
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const { propertyIsEnumerable: $c319b2c832c2914a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest('RegExp');
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[$c319b2c832c2914a$var$toStringTag] === 'FormData' && thing[$c319b2c832c2914a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c319b2c832c2914a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : $c319b2c832c2914a$var$_setImmediate;
// *********************
const $c319b2c832c2914a$var$isIterable = (thing)=>thing != null && $c319b2c832c2914a$var$isFunction(thing[$c319b2c832c2914a$var$iterator]);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isEmptyObject: $c319b2c832c2914a$var$isEmptyObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isReactNativeBlob: $c319b2c832c2914a$var$isReactNativeBlob,
    isReactNative: $c319b2c832c2914a$var$isReactNative,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap,
    isIterable: $c319b2c832c2914a$var$isIterable
};

});
parcelRegister("jJbMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cb5cefd6507f7e$export$2e2bcd8739ae039);
'use strict';
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("ewFRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93486d2307f31c3$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");

var $7GD7a = parcelRequire("7GD7a");

var $bv3QM = parcelRequire("bv3QM");

var $bxxyx = parcelRequire("bxxyx");

var $6YCMk = parcelRequire("6YCMk");
'use strict';
const $a93486d2307f31c3$var$validators = (0, $bv3QM.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $83RYu.default)(),
            response: new (0, $83RYu.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $lk5EI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $bv3QM.default).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            legacyInterceptorReqResOrdering: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            advertiseZstdAcceptEncoding: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $gKvUL.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $bv3QM.default).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $bv3QM.default).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling('baseURL'),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $gKvUL.default).merge(headers.common, headers[config.method]);
        headers && (0, $gKvUL.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $bxxyx.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $6YCMk.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dlZEJ.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $dlZEJ.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $lk5EI.default)(this.defaults, config);
        const fullPath = (0, $7GD7a.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $cbIsf.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $lk5EI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $gKvUL.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $lk5EI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $a93486d2307f31c3$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8df8fedf1c1e4428$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $l9LQd = parcelRequire("l9LQd");
'use strict';
function $8df8fedf1c1e4428$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$export$c564cdbbe6da493;
    const _options = (0, $gKvUL.default).isFunction(options) ? {
        serialize: options
    } : options;
    const serializeFn = _options && _options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $gKvUL.default).isURLSearchParams(params) ? params.toString() : new (0, $l9LQd.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("l9LQd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f66f8c7b4f247caf$export$2e2bcd8739ae039);

var $jOwpo = parcelRequire("jOwpo");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $jOwpo.default)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;

});
parcelRegister("jOwpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cbd383b18c9625$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $5vpyF = parcelRequire("5vpyF");

var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $gKvUL.default).isPlainObject(thing) || (0, $gKvUL.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $gKvUL.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $gKvUL.default).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $gKvUL.default).toFlatObject((0, $gKvUL.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5vpyF.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $gKvUL.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $gKvUL.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
    const useBlob = _Blob && (0, $gKvUL.default).isSpecCompliantForm(formData);
    if (!(0, $gKvUL.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $gKvUL.default).isDate(value)) return value.toISOString();
        if ((0, $gKvUL.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $gKvUL.default).isBlob(value)) throw new (0, $6HVMZ.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $gKvUL.default).isArrayBuffer(value) || (0, $gKvUL.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $gKvUL.default).isReactNative(formData) && (0, $gKvUL.default).isReactNativeBlob(value)) {
            formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $gKvUL.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $gKvUL.default).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $gKvUL.default).isFileList(value) || (0, $gKvUL.default).endsWith(key, '[]')) && (arr = (0, $gKvUL.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $gKvUL.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $gKvUL.default).isUndefined(value)) return;
        if (depth > maxDepth) throw new (0, $6HVMZ.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $6HVMZ.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $gKvUL.default).forEach(value, function each(el, key) {
            const result = !((0, $gKvUL.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $gKvUL.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $gKvUL.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;

});
parcelRegister("6HVMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2395edb77acf3a$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $4e2395edb77acf3a$var$REDACTED = '[REDACTED ****]';
function $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $gKvUL.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $gKvUL.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $4e2395edb77acf3a$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $gKvUL.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $bxxyx.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $gKvUL.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $gKvUL.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $gKvUL.default).isPlainObject(source) && $4e2395edb77acf3a$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $4e2395edb77acf3a$var$REDACTED : visit(value);
                if (!(0, $gKvUL.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $4e2395edb77acf3a$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $4e2395edb77acf3a$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $gKvUL.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $gKvUL.default).isArray(redactKeys) && redactKeys.length > 0 ? $4e2395edb77acf3a$var$redactConfig(config, redactKeys) : (0, $gKvUL.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$4e2395edb77acf3a$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$4e2395edb77acf3a$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$4e2395edb77acf3a$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$4e2395edb77acf3a$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$4e2395edb77acf3a$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$4e2395edb77acf3a$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$4e2395edb77acf3a$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$4e2395edb77acf3a$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$4e2395edb77acf3a$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$4e2395edb77acf3a$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$4e2395edb77acf3a$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;

});
parcelRegister("bxxyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $866cce54f6bdfb0c$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $lDriZ = parcelRequire("lDriZ");

var $lnc0M = parcelRequire("lnc0M");
'use strict';
const $866cce54f6bdfb0c$var$$internals = Symbol('internals');
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $gKvUL.default).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : (0, $lnc0M.sanitizeHeaderValue)(String(value));
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $gKvUL.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $gKvUL.default).isString(value)) return;
    if ((0, $gKvUL.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $gKvUL.default).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $gKvUL.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $gKvUL.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $gKvUL.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $gKvUL.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $gKvUL.default).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $lDriZ.default)(header), valueOrRewrite);
        else if ((0, $gKvUL.default).isObject(header) && (0, $gKvUL.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, $gKvUL.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, $gKvUL.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $gKvUL.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $gKvUL.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $gKvUL.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $gKvUL.default).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $gKvUL.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            const key = (0, $gKvUL.default).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $gKvUL.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $gKvUL.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $gKvUL.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $gKvUL.default).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $gKvUL.default).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;

});
parcelRegister("lDriZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc026bbf9ee156f1$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $gKvUL.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("lnc0M", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", () => $f8f5102fdfcbfec9$export$9e344cffce061a22);
$parcel$export(module.exports, "toByteStringHeaderObject", () => $f8f5102fdfcbfec9$export$c30c72bb7e677d54);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $f8f5102fdfcbfec9$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f8f5102fdfcbfec9$var$sanitizeValue(value, invalidChars) {
    if ((0, $gKvUL.default).isArray(value)) return value.map((item)=>$f8f5102fdfcbfec9$var$sanitizeValue(item, invalidChars));
    return $f8f5102fdfcbfec9$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f8f5102fdfcbfec9$export$9e344cffce061a22 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f8f5102fdfcbfec9$export$59dd66c2a12d8f62 = (value)=>$f8f5102fdfcbfec9$var$sanitizeValue(value, $f8f5102fdfcbfec9$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f8f5102fdfcbfec9$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $gKvUL.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f8f5102fdfcbfec9$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("5vpyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4023ac50ad132196$export$2e2bcd8739ae039);
// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;

});




parcelRegister("83RYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de878cd737ef277$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $gKvUL.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8d10189805ccc0$export$2e2bcd8739ae039);

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $blSvA = parcelRequire("blSvA");

var $dIGMp = parcelRequire("dIGMp");

var $bxxyx = parcelRequire("bxxyx");

var $jZ6wW = parcelRequire("jZ6wW");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $dIGMp.default)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $bxxyx.default).from(config.headers);
    // Transform request data
    config.data = (0, $7YJ0v.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $jZ6wW.default).getAdapter(config.adapter || (0, $blSvA.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $7YJ0v.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $bxxyx.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $7L4QX.default)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $7YJ0v.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $bxxyx.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("7YJ0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf10c777cce5f4f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $blSvA = parcelRequire("blSvA");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $blSvA.default);
    const context = response || config;
    const headers = (0, $bxxyx.default).from(context.headers);
    let data = context.data;
    (0, $gKvUL.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("blSvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $843bf0209bc94df8$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $6YCMk = parcelRequire("6YCMk");

var $jOwpo = parcelRequire("jOwpo");

var $lcuqa = parcelRequire("lcuqa");

var $g65xr = parcelRequire("g65xr");

var $8cmY2 = parcelRequire("8cmY2");
'use strict';
const $843bf0209bc94df8$var$own = (obj, key)=>obj != null && (0, $gKvUL.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $gKvUL.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $gKvUL.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $6YCMk.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $gKvUL.default).isObject(data);
            if (isObjectPayload && (0, $gKvUL.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $gKvUL.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $8cmY2.default)(data)) : data;
            if ((0, $gKvUL.default).isArrayBuffer(data) || (0, $gKvUL.default).isBuffer(data) || (0, $gKvUL.default).isStream(data) || (0, $gKvUL.default).isFile(data) || (0, $gKvUL.default).isBlob(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if ((0, $gKvUL.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $gKvUL.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $843bf0209bc94df8$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $lcuqa.default)(data, formSerializer).toString();
                if ((isFileList = (0, $gKvUL.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $843bf0209bc94df8$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $jOwpo.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $843bf0209bc94df8$var$own(this, 'transitional') || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $843bf0209bc94df8$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $gKvUL.default).isResponse(data) || (0, $gKvUL.default).isReadableStream(data)) return data;
            if (data && (0, $gKvUL.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $843bf0209bc94df8$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $6HVMZ.default).from(e, (0, $6HVMZ.default).ERR_BAD_RESPONSE, this, null, $843bf0209bc94df8$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $g65xr.default).classes.FormData,
        Blob: (0, $g65xr.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $gKvUL.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;

});
parcelRegister("6YCMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $51466d41a76e5b4b$export$2e2bcd8739ae039);
'use strict';
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false
};

});

parcelRegister("lcuqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f250f62cadb740$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $jOwpo = parcelRequire("jOwpo");

var $g65xr = parcelRequire("g65xr");
'use strict';
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $jOwpo.default)(data, new (0, $g65xr.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $g65xr.default).isNode && (0, $gKvUL.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("g65xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb8180acb278e187$export$2e2bcd8739ae039);

var $44xkq = parcelRequire("44xkq");

var $7pJXT = parcelRequire("7pJXT");
var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$7pJXT,
    ...(0, $44xkq.default)
};

});
parcelRegister("44xkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f71637df772b183$export$2e2bcd8739ae039);

var $9ww2p = parcelRequire("9ww2p");

var $bzEBu = parcelRequire("bzEBu");

var $7HTwA = parcelRequire("7HTwA");
var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9ww2p.default,
        FormData: $bzEBu.default,
        Blob: $7HTwA.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("9ww2p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eeff4490c995137$export$2e2bcd8739ae039);

var $l9LQd = parcelRequire("l9LQd");
'use strict';
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $l9LQd.default);

});

parcelRegister("bzEBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d275a264afb13f$export$2e2bcd8739ae039);
'use strict';
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("7HTwA", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c79e94740631e4$export$2e2bcd8739ae039);
'use strict';
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("7pJXT", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export(module.exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export(module.exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export(module.exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("8cmY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8142930b3b943f$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $gKvUL.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $gKvUL.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $gKvUL.default).hasOwnProp(target, name)) target[name] = (0, $gKvUL.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $gKvUL.default).hasOwnProp(target, name) || !(0, $gKvUL.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $gKvUL.default).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $gKvUL.default).isFormData(formData) && (0, $gKvUL.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $gKvUL.default).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;

});



parcelRegister("7L4QX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a60afef8b0dd173$export$2e2bcd8739ae039);
'use strict';
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("dIGMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fd0919e266b4fda$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
class $9fd0919e266b4fda$var$CanceledError extends (0, $6HVMZ.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $6HVMZ.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;

});

parcelRegister("jZ6wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c8c7960873e9ee$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $5vpyF = parcelRequire("5vpyF");

var $at5cb = parcelRequire("at5cb");

var $jFSbX = parcelRequire("jFSbX");

var $6HVMZ = parcelRequire("6HVMZ");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $5vpyF.default),
    xhr: (0, $at5cb.default),
    fetch: {
        get: $jFSbX.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $gKvUL.default).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $gKvUL.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $e8c8c7960873e9ee$var$getAdapter(adapters, config) {
    adapters = (0, $gKvUL.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $6HVMZ.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $gKvUL.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($e8c8c7960873e9ee$var$renderReason).join('\n') : ' ' + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $6HVMZ.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $e8c8c7960873e9ee$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $e8c8c7960873e9ee$var$knownAdapters
};

});
parcelRegister("at5cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f0a48d5eb7919b$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $6YCMk = parcelRequire("6YCMk");

var $6HVMZ = parcelRequire("6HVMZ");

var $dIGMp = parcelRequire("dIGMp");

var $32jg5 = parcelRequire("32jg5");

var $g65xr = parcelRequire("g65xr");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $lnc0M = parcelRequire("lnc0M");
const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $eHGD2.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $bxxyx.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $bxxyx.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $kk0E9.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6HVMZ.default)('Request aborted', (0, $6HVMZ.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $6HVMZ.default)(msg, (0, $6HVMZ.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $6YCMk.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $6HVMZ.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6HVMZ.default).ETIMEDOUT : (0, $6HVMZ.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $gKvUL.default).forEach((0, $lnc0M.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $gKvUL.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $2gEvX.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $2gEvX.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $dIGMp.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $32jg5.default)(_config.url);
        if (protocol && !(0, $g65xr.default).protocols.includes(protocol)) {
            reject(new (0, $6HVMZ.default)('Unsupported protocol ' + protocol + ':', (0, $6HVMZ.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb62d5372993dcf$export$2e2bcd8739ae039);

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6HVMZ.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $6HVMZ.default).ERR_BAD_REQUEST : (0, $6HVMZ.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("32jg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $23607f53e4fda918$export$2e2bcd8739ae039);
'use strict';
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("2gEvX", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", () => $1a6c80b567b74091$export$c1b28109d46c3592);
$parcel$export(module.exports, "progressEventDecorator", () => $1a6c80b567b74091$export$d9fadd12586c18d6);
$parcel$export(module.exports, "asyncDecorator", () => $1a6c80b567b74091$export$5d35863c355a22a9);

var $6paAk = parcelRequire("6paAk");

var $dkklI = parcelRequire("dkklI");

var $gKvUL = parcelRequire("gKvUL");
const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $6paAk.default)(50, 250);
    return (0, $dkklI.default)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $gKvUL.default).asap(()=>fn(...args));

});
parcelRegister("6paAk", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9d49cd0e6b8acc$export$2e2bcd8739ae039);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;

});

parcelRegister("dkklI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b3ced92bc7bdc99$export$2e2bcd8739ae039);
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;

});


parcelRegister("eHGD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4625fac3104691$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $889er = parcelRequire("889er");

var $8JRzs = parcelRequire("8JRzs");

var $7GD7a = parcelRequire("7GD7a");

var $lk5EI = parcelRequire("lk5EI");

var $bxxyx = parcelRequire("bxxyx");

var $cbIsf = parcelRequire("cbIsf");
const $ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $ab4625fac3104691$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($ab4625fac3104691$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $ab4625fac3104691$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $ab4625fac3104691$var$resolveConfig(config) {
    const newConfig = (0, $lk5EI.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $gKvUL.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $bxxyx.default).from(headers);
    newConfig.url = (0, $cbIsf.default)((0, $7GD7a.default)(baseURL, url, allowAbsoluteUrls), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? $ab4625fac3104691$var$encodeUTF8(auth.password) : '')));
    if ((0, $gKvUL.default).isFormData(data)) {
        if ((0, $g65xr.default).hasStandardBrowserEnv || (0, $g65xr.default).hasStandardBrowserWebWorkerEnv || (0, $gKvUL.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $gKvUL.default).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $ab4625fac3104691$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $g65xr.default).hasStandardBrowserEnv) {
        if ((0, $gKvUL.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $889er.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8JRzs.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $ab4625fac3104691$export$2e2bcd8739ae039 = $ab4625fac3104691$var$resolveConfig;

});
parcelRegister("889er", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb63b558e1fb85a$export$2e2bcd8739ae039);

var $g65xr = parcelRequire("g65xr");
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $g65xr.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $g65xr.default).origin), (0, $g65xr.default).navigator && /(msie|trident)/i.test((0, $g65xr.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("8JRzs", function(module, exports) {

$parcel$export(module.exports, "default", () => $65cc14c0704b5541$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $g65xr = parcelRequire("g65xr");
var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $g65xr.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $gKvUL.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $gKvUL.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $gKvUL.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $gKvUL.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7GD7a", function(module, exports) {

$parcel$export(module.exports, "default", () => $598acbfafd2c63c5$export$2e2bcd8739ae039);

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
'use strict';
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $ckHwb.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) return (0, $fE4ul.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("ckHwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa91c1a59edb5d9$export$2e2bcd8739ae039);
'use strict';
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("fE4ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63e12c1e0b9e0be$export$2e2bcd8739ae039);
'use strict';
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

});


parcelRegister("lk5EI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85fda54cd977b19$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");

var $bxxyx = parcelRequire("bxxyx");
'use strict';
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $bxxyx.default) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $gKvUL.default).isPlainObject(target) && (0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $gKvUL.default).isPlainObject(source)) return (0, $gKvUL.default).merge({}, source);
        else if ((0, $gKvUL.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $gKvUL.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $gKvUL.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $gKvUL.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $gKvUL.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $gKvUL.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $gKvUL.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $gKvUL.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $gKvUL.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $gKvUL.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("jFSbX", function(module, exports) {

$parcel$export(module.exports, "getFetch", () => $e52be20a9fc15e96$export$3105c6651375d4fa);

var $g65xr = parcelRequire("g65xr");

var $gKvUL = parcelRequire("gKvUL");

var $6HVMZ = parcelRequire("6HVMZ");

var $dLozx = parcelRequire("dLozx");

var $hhnAb = parcelRequire("hhnAb");

var $bxxyx = parcelRequire("bxxyx");

var $2gEvX = parcelRequire("2gEvX");

var $eHGD2 = parcelRequire("eHGD2");

var $kk0E9 = parcelRequire("kk0E9");

var $iKBwL = parcelRequire("iKBwL");

var $35BUy = parcelRequire("35BUy");

var $lnc0M = parcelRequire("lnc0M");
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $e52be20a9fc15e96$var$isFunction } = (0, $gKvUL.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $e52be20a9fc15e96$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $e52be20a9fc15e96$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $gKvUL.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $e52be20a9fc15e96$var$factory = (env)=>{
    const globalObject = (0, $gKvUL.default).global !== undefined && (0, $gKvUL.default).global !== null ? (0, $gKvUL.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $gKvUL.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $e52be20a9fc15e96$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $e52be20a9fc15e96$var$isFunction(Request);
    const isResponseSupported = $e52be20a9fc15e96$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $e52be20a9fc15e96$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $g65xr.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $gKvUL.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $6HVMZ.default)(`Response type '${type}' is not supported`, (0, $6HVMZ.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $gKvUL.default).isBlob(body)) return body.size;
        if ((0, $gKvUL.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $g65xr.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $gKvUL.default).isArrayBufferView(body) || (0, $gKvUL.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $gKvUL.default).isURLSearchParams(body)) body = body + '';
        if ((0, $gKvUL.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $gKvUL.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $eHGD2.default)(config);
        const hasMaxContentLength = (0, $gKvUL.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $gKvUL.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $gKvUL.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $dLozx.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = configAuth.username || '';
                const password = configAuth.password || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($e52be20a9fc15e96$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $g65xr.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $e52be20a9fc15e96$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($e52be20a9fc15e96$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $iKBwL.default)(url);
                if (estimated > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against the outbound request body before dispatch.
            // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
            // maxBodyLength limit'). Skip when the body length cannot be determined
            // (e.g. a live ReadableStream supplied by the caller).
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await resolveBodyLength(headers, data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength) && outboundLength > maxBodyLength) throw new (0, $6HVMZ.default)('Request body larger than maxBodyLength limit', (0, $6HVMZ.default).ERR_BAD_REQUEST, config, request);
            }
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: 'half'
                });
                let contentTypeHeader;
                if ((0, $gKvUL.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, $2gEvX.progressEventDecorator)(requestContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onUploadProgress)));
                    data = (0, $hhnAb.trackStream)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, $gKvUL.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $gKvUL.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $35BUy.VERSION), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $lnc0M.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $gKvUL.default).toFiniteNumber(response.headers.get('content-length'));
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $gKvUL.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, $2gEvX.progressEventDecorator)(responseContentLength, (0, $2gEvX.progressEventReducer)((0, $2gEvX.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $hhnAb.trackStream)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $gKvUL.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $6HVMZ.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $6HVMZ.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $kk0E9.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $bxxyx.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $6HVMZ.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $6HVMZ.default)('Network Error', (0, $6HVMZ.default).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $6HVMZ.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $e52be20a9fc15e96$var$seedCache = new Map();
const $e52be20a9fc15e96$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $e52be20a9fc15e96$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $e52be20a9fc15e96$var$factory(env));
        map = target;
    }
    return target;
};
const $e52be20a9fc15e96$var$adapter = $e52be20a9fc15e96$export$3105c6651375d4fa();
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$adapter;

});
parcelRegister("dLozx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a052b9a6636aacdc$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");

var $6HVMZ = parcelRequire("6HVMZ");

var $gKvUL = parcelRequire("gKvUL");
const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $6HVMZ.default) ? err : new (0, $dIGMp.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $6HVMZ.default)(`timeout of ${timeout}ms exceeded`, (0, $6HVMZ.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $gKvUL.default).asap(unsubscribe);
    return signal;
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;

});

parcelRegister("hhnAb", function(module, exports) {

$parcel$export(module.exports, "trackStream", () => $c9465135abb26626$export$b0119225647bd83);
const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("iKBwL", function(module, exports) {

$parcel$export(module.exports, "default", () => $da69a2069c6136ea$export$2e2bcd8739ae039);
/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $da69a2069c6136ea$require$Buffer = $6ZWSX.Buffer;
function $da69a2069c6136ea$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = (a >= 48 && a <= 57 || a >= 65 && a <= 70 || a >= 97 && a <= 102) && (b >= 48 && b <= 57 || b >= 65 && b <= 70 || b >= 97 && b <= 102);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    if (typeof $da69a2069c6136ea$require$Buffer !== 'undefined' && typeof $da69a2069c6136ea$require$Buffer.byteLength === 'function') return $da69a2069c6136ea$require$Buffer.byteLength(body, 'utf8');
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
    // but 3 UTF-8 bytes).
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}

});

parcelRegister("35BUy", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $23ff3f1a5c7912d5$export$a4ad2735b021c132);
const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.17.0";

});




parcelRegister("bv3QM", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f59389941e7907$export$2e2bcd8739ae039);

var $35BUy = parcelRequire("35BUy");

var $6HVMZ = parcelRequire("6HVMZ");
'use strict';
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $35BUy.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6HVMZ.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $6HVMZ.default).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $6HVMZ.default)('options must be an object', (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6HVMZ.default)('option ' + opt + ' must be ' + result, (0, $6HVMZ.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6HVMZ.default)('Unknown option ' + opt, (0, $6HVMZ.default).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};

});


parcelRegister("lAKPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb81495929d8a282$export$2e2bcd8739ae039);

var $dIGMp = parcelRequire("dIGMp");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $dIGMp.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {

$parcel$export(module.exports, "default", () => $089369673aa7c1c3$export$2e2bcd8739ae039);
'use strict';
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("dxy9O", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db8da59db12cd94$export$2e2bcd8739ae039);

var $gKvUL = parcelRequire("gKvUL");
'use strict';
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $gKvUL.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("lnWCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f919374d785e9fb8$export$2e2bcd8739ae039);
const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;

});



parcelRegister("boMKk", function(module, exports) {
module.exports = import.meta.resolve("AwhRU");

});

parcelRegister("hBtug", function(module, exports) {

var $7ryUf = parcelRequire("7ryUf");
let $cd0cc3ea8f79b90a$var$url = new URL(import.meta.resolve("aVRNT"));
module.exports = $7ryUf($cd0cc3ea8f79b90a$var$url.toString(), $cd0cc3ea8f79b90a$var$url.origin, true);

});
parcelRegister("7ryUf", function(module, exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};

});







//# sourceMappingURL=Dashboard.02d5a840.js.map
